var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as React from "react";
import React__default, { useEffect, forwardRef, useContext, createContext, useMemo, useState, createElement, useReducer, useCallback, Component, Children, cloneElement, useRef, isValidElement, useImperativeHandle, useLayoutEffect, PureComponent, Fragment } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default, { unstable_batchedUpdates } from "react-dom";
import { LocalizationProvider, DatePicker as DatePicker$1 } from "@mui/x-date-pickers";
import { createTheme, ThemeProvider as ThemeProvider$2 } from "@mui/material";
import DOMPurify from "dompurify";
import { withRouter } from "react-router";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x3) {
  return x3 && x3.__esModule && Object.prototype.hasOwnProperty.call(x3, "default") ? x3["default"] : x3;
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f = n.default;
  if (typeof f == "function") {
    var a4 = function a5() {
      if (this instanceof a5) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a4.prototype = f.prototype;
  } else
    a4 = {};
  Object.defineProperty(a4, "__esModule", { value: true });
  Object.keys(n).forEach(function(k3) {
    var d3 = Object.getOwnPropertyDescriptor(n, k3);
    Object.defineProperty(a4, k3, d3.get ? d3 : {
      enumerable: true,
      get: function() {
        return n[k3];
      }
    });
  });
  return a4;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign;
var hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign)
    return objectAssign;
  hasRequiredObjectAssign = 1;
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty2 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  function toObject2(val) {
    if (val === null || val === void 0) {
      throw new TypeError("Object.assign cannot be called with null or undefined");
    }
    return Object(val);
  }
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
      var test1 = new String("abc");
      test1[5] = "de";
      if (Object.getOwnPropertyNames(test1)[0] === "5") {
        return false;
      }
      var test2 = {};
      for (var i2 = 0; i2 < 10; i2++) {
        test2["_" + String.fromCharCode(i2)] = i2;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
        return test2[n];
      });
      if (order2.join("") !== "0123456789") {
        return false;
      }
      var test3 = {};
      "abcdefghijklmnopqrst".split("").forEach(function(letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
        return false;
      }
      return true;
    } catch (err) {
      return false;
    }
  }
  objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
    var from2;
    var to2 = toObject2(target);
    var symbols;
    for (var s4 = 1; s4 < arguments.length; s4++) {
      from2 = Object(arguments[s4]);
      for (var key in from2) {
        if (hasOwnProperty2.call(from2, key)) {
          to2[key] = from2[key];
        }
      }
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from2);
        for (var i2 = 0; i2 < symbols.length; i2++) {
          if (propIsEnumerable.call(from2, symbols[i2])) {
            to2[symbols[i2]] = from2[symbols[i2]];
          }
        }
      }
    }
    return to2;
  };
  return objectAssign;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  requireObjectAssign();
  var f = React__default, g2 = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;
  if ("function" === typeof Symbol && Symbol.for) {
    var h3 = Symbol.for;
    g2 = h3("react.element");
    reactJsxRuntime_production_min.Fragment = h3("react.fragment");
  }
  var m3 = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
  function q2(c7, a4, k3) {
    var b10, d3 = {}, e3 = null, l = null;
    void 0 !== k3 && (e3 = "" + k3);
    void 0 !== a4.key && (e3 = "" + a4.key);
    void 0 !== a4.ref && (l = a4.ref);
    for (b10 in a4)
      n.call(a4, b10) && !p.hasOwnProperty(b10) && (d3[b10] = a4[b10]);
    if (c7 && c7.defaultProps)
      for (b10 in a4 = c7.defaultProps, a4)
        void 0 === d3[b10] && (d3[b10] = a4[b10]);
    return { $$typeof: g2, type: c7, key: e3, ref: l, props: d3, _owner: m3.current };
  }
  reactJsxRuntime_production_min.jsx = q2;
  reactJsxRuntime_production_min.jsxs = q2;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  (function(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var React2 = React__default;
        var _assign2 = requireObjectAssign();
        var REACT_ELEMENT_TYPE2 = 60103;
        var REACT_PORTAL_TYPE = 60106;
        exports2.Fragment = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE2 = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          exports2.Fragment = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          symbolFor("react.scope");
          symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function error2(format2) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
        function printWarning(level, format2, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack2 = ReactDebugCurrentFrame2.getStackAddendum();
            if (stack2 !== "") {
              format2 += "%s";
              args = args.concat([stack2]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format2);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        var enableScopeAPI = false;
        function isValidElementType(type2) {
          if (typeof type2 === "string" || typeof type2 === "function") {
            return true;
          }
          if (type2 === exports2.Fragment || type2 === REACT_PROFILER_TYPE || type2 === REACT_DEBUG_TRACING_MODE_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || type2 === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type2 === "object" && type2 !== null) {
            if (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_BLOCK_TYPE || type2[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getContextName(type2) {
          return type2.displayName || "Context";
        }
        function getComponentName(type2) {
          if (type2 == null) {
            return null;
          }
          {
            if (typeof type2.tag === "number") {
              error2("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type2 === "function") {
            return type2.displayName || type2.name || null;
          }
          if (typeof type2 === "string") {
            return type2;
          }
          switch (type2) {
            case exports2.Fragment:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type2 === "object") {
            switch (type2.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type2;
                return getContextName(context) + ".Consumer";
              case REACT_PROVIDER_TYPE:
                var provider = type2;
                return getContextName(provider._context) + ".Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type2, type2.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type2.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type2._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type2;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  return getComponentName(init2(payload));
                } catch (x3) {
                  return null;
                }
              }
            }
          }
          return null;
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
          {
            if (disabledDepth === 0) {
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd;
              var props2 = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              };
              Object.defineProperties(console, {
                info: props2,
                log: props2,
                warn: props2,
                error: props2,
                group: props2,
                groupCollapsed: props2,
                groupEnd: props2
              });
            }
            disabledDepth++;
          }
        }
        function reenableLogs() {
          {
            disabledDepth--;
            if (disabledDepth === 0) {
              var props2 = {
                configurable: true,
                enumerable: true,
                writable: true
              };
              Object.defineProperties(console, {
                log: _assign2({}, props2, {
                  value: prevLog
                }),
                info: _assign2({}, props2, {
                  value: prevInfo
                }),
                warn: _assign2({}, props2, {
                  value: prevWarn
                }),
                error: _assign2({}, props2, {
                  value: prevError
                }),
                group: _assign2({}, props2, {
                  value: prevGroup
                }),
                groupCollapsed: _assign2({}, props2, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign2({}, props2, {
                  value: prevGroupEnd
                })
              });
            }
            if (disabledDepth < 0) {
              error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
        }
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix2;
        function describeBuiltInComponentFrame(name2, source, ownerFn) {
          {
            if (prefix2 === void 0) {
              try {
                throw Error();
              } catch (x3) {
                var match2 = x3.stack.trim().match(/\n( *(at )?)/);
                prefix2 = match2 && match2[1] || "";
              }
            }
            return "\n" + prefix2 + name2;
          }
        }
        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn2, construct) {
          if (!fn2 || reentry) {
            return "";
          }
          {
            var frame2 = componentFrameCache.get(fn2);
            if (frame2 !== void 0) {
              return frame2;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = null;
            disableLogs();
          }
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if (typeof Reflect === "object" && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x3) {
                  control = x3;
                }
                Reflect.construct(fn2, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x3) {
                  control = x3;
                }
                fn2.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x3) {
                control = x3;
              }
              fn2();
            }
          } catch (sample) {
            if (sample && control && typeof sample.stack === "string") {
              var sampleLines = sample.stack.split("\n");
              var controlLines = control.stack.split("\n");
              var s4 = sampleLines.length - 1;
              var c7 = controlLines.length - 1;
              while (s4 >= 1 && c7 >= 0 && sampleLines[s4] !== controlLines[c7]) {
                c7--;
              }
              for (; s4 >= 1 && c7 >= 0; s4--, c7--) {
                if (sampleLines[s4] !== controlLines[c7]) {
                  if (s4 !== 1 || c7 !== 1) {
                    do {
                      s4--;
                      c7--;
                      if (c7 < 0 || sampleLines[s4] !== controlLines[c7]) {
                        var _frame = "\n" + sampleLines[s4].replace(" at new ", " at ");
                        {
                          if (typeof fn2 === "function") {
                            componentFrameCache.set(fn2, _frame);
                          }
                        }
                        return _frame;
                      }
                    } while (s4 >= 1 && c7 >= 0);
                  }
                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          }
          var name2 = fn2 ? fn2.displayName || fn2.name : "";
          var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
          {
            if (typeof fn2 === "function") {
              componentFrameCache.set(fn2, syntheticFrame);
            }
          }
          return syntheticFrame;
        }
        function describeFunctionComponentFrame(fn2, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn2, false);
          }
        }
        function shouldConstruct(Component2) {
          var prototype2 = Component2.prototype;
          return !!(prototype2 && prototype2.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type2, source, ownerFn) {
          if (type2 == null) {
            return "";
          }
          if (typeof type2 === "function") {
            {
              return describeNativeComponentFrame(type2, shouldConstruct(type2));
            }
          }
          if (typeof type2 === "string") {
            return describeBuiltInComponentFrame(type2);
          }
          switch (type2) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame("SuspenseList");
          }
          if (typeof type2 === "object") {
            switch (type2.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type2.render);
              case REACT_MEMO_TYPE:
                return describeUnknownElementTypeFrameInDEV(type2.type, source, ownerFn);
              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type2._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type2;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  return describeUnknownElementTypeFrameInDEV(init2(payload), source, ownerFn);
                } catch (x3) {
                }
              }
            }
          }
          return "";
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack2 = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame.setExtraStackFrame(stack2);
            } else {
              ReactDebugCurrentFrame.setExtraStackFrame(null);
            }
          }
        }
        function checkPropTypes(typeSpecs, values6, location, componentName, element) {
          {
            var has7 = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has7(typeSpecs, typeSpecName)) {
                var error$12 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$12 = typeSpecs[typeSpecName](values6, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$12 = ex;
                }
                if (error$12 && !(error$12 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$12);
                  setCurrentlyValidatingElement(null);
                }
                if (error$12 instanceof Error && !(error$12.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$12.message] = true;
                  setCurrentlyValidatingElement(element);
                  error2("Failed %s type: %s", location, error$12.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        var hasOwnProperty2 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS2 = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown;
        var specialPropRefWarningShown;
        var didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }
        function hasValidRef(config2) {
          {
            if (hasOwnProperty2.call(config2, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config2, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config2.ref !== void 0;
        }
        function hasValidKey(config2) {
          {
            if (hasOwnProperty2.call(config2, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config2.key !== void 0;
        }
        function warnIfStringRefCannotBeAutoConverted(config2, self2) {
          {
            if (typeof config2.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);
              if (!didWarnAboutStringRefs[componentName]) {
                error2('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config2.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        function defineKeyPropWarningGetter(props2, displayName) {
          {
            var warnAboutAccessingKey = function() {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingKey.isReactWarning = true;
            Object.defineProperty(props2, "key", {
              get: warnAboutAccessingKey,
              configurable: true
            });
          }
        }
        function defineRefPropWarningGetter(props2, displayName) {
          {
            var warnAboutAccessingRef = function() {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingRef.isReactWarning = true;
            Object.defineProperty(props2, "ref", {
              get: warnAboutAccessingRef,
              configurable: true
            });
          }
        }
        var ReactElement2 = function(type2, key, ref2, self2, source, owner, props2) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE2,
            // Built-in properties that belong on the element
            type: type2,
            key,
            ref: ref2,
            props: props2,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function jsxDEV(type2, config2, maybeKey, source, self2) {
          {
            var propName;
            var props2 = {};
            var key = null;
            var ref2 = null;
            if (maybeKey !== void 0) {
              key = "" + maybeKey;
            }
            if (hasValidKey(config2)) {
              key = "" + config2.key;
            }
            if (hasValidRef(config2)) {
              ref2 = config2.ref;
              warnIfStringRefCannotBeAutoConverted(config2, self2);
            }
            for (propName in config2) {
              if (hasOwnProperty2.call(config2, propName) && !RESERVED_PROPS2.hasOwnProperty(propName)) {
                props2[propName] = config2[propName];
              }
            }
            if (type2 && type2.defaultProps) {
              var defaultProps2 = type2.defaultProps;
              for (propName in defaultProps2) {
                if (props2[propName] === void 0) {
                  props2[propName] = defaultProps2[propName];
                }
              }
            }
            if (key || ref2) {
              var displayName = typeof type2 === "function" ? type2.displayName || type2.name || "Unknown" : type2;
              if (key) {
                defineKeyPropWarningGetter(props2, displayName);
              }
              if (ref2) {
                defineRefPropWarningGetter(props2, displayName);
              }
            }
            return ReactElement2(type2, key, ref2, self2, source, ReactCurrentOwner.current, props2);
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement$1(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack2 = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame$1.setExtraStackFrame(stack2);
            } else {
              ReactDebugCurrentFrame$1.setExtraStackFrame(null);
            }
          }
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function isValidElement2(object2) {
          {
            return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE2;
          }
        }
        function getDeclarationErrorAddendum() {
          {
            if (ReactCurrentOwner$1.current) {
              var name2 = getComponentName(ReactCurrentOwner$1.current.type);
              if (name2) {
                return "\n\nCheck the render method of `" + name2 + "`.";
              }
            }
            return "";
          }
        }
        function getSourceInfoErrorAddendum(source) {
          {
            if (source !== void 0) {
              var fileName = source.fileName.replace(/^.*[\\\/]/, "");
              var lineNumber = source.lineNumber;
              return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
            }
            return "";
          }
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          {
            var info = getDeclarationErrorAddendum();
            if (!info) {
              var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
              if (parentName) {
                info = "\n\nCheck the top-level render call using <" + parentName + ">.";
              }
            }
            return info;
          }
        }
        function validateExplicitKey(element, parentType) {
          {
            if (!element._store || element._store.validated || element.key != null) {
              return;
            }
            element._store.validated = true;
            var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            var childOwner = "";
            if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
              childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
            }
            setCurrentlyValidatingElement$1(element);
            error2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        function validateChildKeys(node2, parentType) {
          {
            if (typeof node2 !== "object") {
              return;
            }
            if (Array.isArray(node2)) {
              for (var i2 = 0; i2 < node2.length; i2++) {
                var child = node2[i2];
                if (isValidElement2(child)) {
                  validateExplicitKey(child, parentType);
                }
              }
            } else if (isValidElement2(node2)) {
              if (node2._store) {
                node2._store.validated = true;
              }
            } else if (node2) {
              var iteratorFn = getIteratorFn(node2);
              if (typeof iteratorFn === "function") {
                if (iteratorFn !== node2.entries) {
                  var iterator = iteratorFn.call(node2);
                  var step2;
                  while (!(step2 = iterator.next()).done) {
                    if (isValidElement2(step2.value)) {
                      validateExplicitKey(step2.value, parentType);
                    }
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type2 = element.type;
            if (type2 === null || type2 === void 0 || typeof type2 === "string") {
              return;
            }
            var propTypes2;
            if (typeof type2 === "function") {
              propTypes2 = type2.propTypes;
            } else if (typeof type2 === "object" && (type2.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type2.$$typeof === REACT_MEMO_TYPE)) {
              propTypes2 = type2.propTypes;
            } else {
              return;
            }
            if (propTypes2) {
              var name2 = getComponentName(type2);
              checkPropTypes(propTypes2, element.props, "prop", name2, element);
            } else if (type2.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              var _name = getComponentName(type2);
              error2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
            }
            if (typeof type2.getDefaultProps === "function" && !type2.getDefaultProps.isReactClassApproved) {
              error2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            var keys8 = Object.keys(fragment.props);
            for (var i2 = 0; i2 < keys8.length; i2++) {
              var key = keys8[i2];
              if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }
            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error2("Invalid attribute `ref` supplied to `React.Fragment`.");
              setCurrentlyValidatingElement$1(null);
            }
          }
        }
        function jsxWithValidation(type2, props2, key, isStaticChildren, source, self2) {
          {
            var validType = isValidElementType(type2);
            if (!validType) {
              var info = "";
              if (type2 === void 0 || typeof type2 === "object" && type2 !== null && Object.keys(type2).length === 0) {
                info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
              }
              var sourceInfo = getSourceInfoErrorAddendum(source);
              if (sourceInfo) {
                info += sourceInfo;
              } else {
                info += getDeclarationErrorAddendum();
              }
              var typeString;
              if (type2 === null) {
                typeString = "null";
              } else if (Array.isArray(type2)) {
                typeString = "array";
              } else if (type2 !== void 0 && type2.$$typeof === REACT_ELEMENT_TYPE2) {
                typeString = "<" + (getComponentName(type2.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
              } else {
                typeString = typeof type2;
              }
              error2("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
            var element = jsxDEV(type2, props2, key, source, self2);
            if (element == null) {
              return element;
            }
            if (validType) {
              var children2 = props2.children;
              if (children2 !== void 0) {
                if (isStaticChildren) {
                  if (Array.isArray(children2)) {
                    for (var i2 = 0; i2 < children2.length; i2++) {
                      validateChildKeys(children2[i2], type2);
                    }
                    if (Object.freeze) {
                      Object.freeze(children2);
                    }
                  } else {
                    error2("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                  }
                } else {
                  validateChildKeys(children2, type2);
                }
              }
            }
            if (type2 === exports2.Fragment) {
              validateFragmentProps(element);
            } else {
              validatePropTypes(element);
            }
            return element;
          }
        }
        function jsxWithValidationStatic(type2, props2, key) {
          {
            return jsxWithValidation(type2, props2, key, true);
          }
        }
        function jsxWithValidationDynamic(type2, props2, key) {
          {
            return jsxWithValidation(type2, props2, key, false);
          }
        }
        var jsx3 = jsxWithValidationDynamic;
        var jsxs2 = jsxWithValidationStatic;
        exports2.jsx = jsx3;
        exports2.jsxs = jsxs2;
      })();
    }
  })(reactJsxRuntime_development);
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
var freeGlobal$2 = typeof global == "object" && global && global.Object === Object && global;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$b = freeGlobal$2 || freeSelf$1 || Function("return this")();
var Symbol$a = root$b.Symbol;
var objectProto$A = Object.prototype;
var hasOwnProperty$w = objectProto$A.hasOwnProperty;
var nativeObjectToString$3 = objectProto$A.toString;
var symToStringTag$3 = Symbol$a ? Symbol$a.toStringTag : void 0;
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$w.call(value, symToStringTag$3), tag2 = value[symToStringTag$3];
  try {
    value[symToStringTag$3] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag2;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}
var objectProto$z = Object.prototype;
var nativeObjectToString$2 = objectProto$z.toString;
function objectToString$3(value) {
  return nativeObjectToString$2.call(value);
}
var nullTag$1 = "[object Null]", undefinedTag$1 = "[object Undefined]";
var symToStringTag$2 = Symbol$a ? Symbol$a.toStringTag : void 0;
function baseGetTag$9(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag$1 : nullTag$1;
  }
  return symToStringTag$2 && symToStringTag$2 in Object(value) ? getRawTag$2(value) : objectToString$3(value);
}
function isObjectLike$9(value) {
  return value != null && typeof value == "object";
}
var symbolTag$5 = "[object Symbol]";
function isSymbol$9(value) {
  return typeof value == "symbol" || isObjectLike$9(value) && baseGetTag$9(value) == symbolTag$5;
}
function arrayMap$4(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
var isArray$j = Array.isArray;
var INFINITY$5 = 1 / 0;
var symbolProto$4 = Symbol$a ? Symbol$a.prototype : void 0, symbolToString$2 = symbolProto$4 ? symbolProto$4.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$j(value)) {
    return arrayMap$4(value, baseToString$2) + "";
  }
  if (isSymbol$9(value)) {
    return symbolToString$2 ? symbolToString$2.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$5 ? "-0" : result;
}
var reWhitespace$1 = /\s/;
function trimmedEndIndex$2(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace$1.test(string2.charAt(index2))) {
  }
  return index2;
}
var reTrimStart$1 = /^\s+/;
function baseTrim$2(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex$2(string2) + 1).replace(reTrimStart$1, "") : string2;
}
function isObject$e(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var NAN$1 = 0 / 0;
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary$1 = /^0b[01]+$/i;
var reIsOctal$1 = /^0o[0-7]+$/i;
var freeParseInt$1 = parseInt;
function toNumber$3(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$9(value)) {
    return NAN$1;
  }
  if (isObject$e(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$e(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim$2(value);
  var isBinary = reIsBinary$1.test(value);
  return isBinary || reIsOctal$1.test(value) ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8) : reIsBadHex$1.test(value) ? NAN$1 : +value;
}
function identity$b(value) {
  return value;
}
var asyncTag$1 = "[object AsyncFunction]", funcTag$4 = "[object Function]", genTag$2 = "[object GeneratorFunction]", proxyTag$1 = "[object Proxy]";
function isFunction$9(value) {
  if (!isObject$e(value)) {
    return false;
  }
  var tag2 = baseGetTag$9(value);
  return tag2 == funcTag$4 || tag2 == genTag$2 || tag2 == asyncTag$1 || tag2 == proxyTag$1;
}
var coreJsData$2 = root$b["__core-js_shared__"];
var maskSrcKey$1 = function() {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$2(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}
var funcProto$5 = Function.prototype;
var funcToString$5 = funcProto$5.toString;
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$5.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
var funcProto$4 = Function.prototype, objectProto$y = Object.prototype;
var funcToString$4 = funcProto$4.toString;
var hasOwnProperty$v = objectProto$y.hasOwnProperty;
var reIsNative$1 = RegExp(
  "^" + funcToString$4.call(hasOwnProperty$v).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$2(value) {
  if (!isObject$e(value) || isMasked$2(value)) {
    return false;
  }
  var pattern = isFunction$9(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$3(value));
}
function getValue$4(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
function getNative$8(object2, key) {
  var value = getValue$4(object2, key);
  return baseIsNative$2(value) ? value : void 0;
}
var WeakMap$3 = getNative$8(root$b, "WeakMap");
var metaMap = WeakMap$3 && new WeakMap$3();
var objectCreate = Object.create;
var baseCreate = /* @__PURE__ */ function() {
  function object2() {
  }
  return function(proto) {
    if (!isObject$e(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object2.prototype = proto;
    var result = new object2();
    object2.prototype = void 0;
    return result;
  };
}();
function apply$2(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
function baseLodash() {
}
var MAX_ARRAY_LENGTH = 4294967295;
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;
function noop$7() {
}
var getData$1 = !metaMap ? noop$7 : function(func) {
  return metaMap.get(func);
};
var realNames = {};
var objectProto$x = Object.prototype;
var hasOwnProperty$u = objectProto$x.hasOwnProperty;
function getFuncName(func) {
  var result = func.name + "", array2 = realNames[result], length2 = hasOwnProperty$u.call(realNames, result) ? array2.length : 0;
  while (length2--) {
    var data = array2[length2], otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = void 0;
}
LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;
function copyArray(source, array2) {
  var index2 = -1, length2 = source.length;
  array2 || (array2 = Array(length2));
  while (++index2 < length2) {
    array2[index2] = source[index2];
  }
  return array2;
}
function wrapperClone(wrapper2) {
  if (wrapper2 instanceof LazyWrapper) {
    return wrapper2.clone();
  }
  var result = new LodashWrapper(wrapper2.__wrapped__, wrapper2.__chain__);
  result.__actions__ = copyArray(wrapper2.__actions__);
  result.__index__ = wrapper2.__index__;
  result.__values__ = wrapper2.__values__;
  return result;
}
var objectProto$w = Object.prototype;
var hasOwnProperty$t = objectProto$w.hasOwnProperty;
function lodash(value) {
  if (isObjectLike$9(value) && !isArray$j(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty$t.call(value, "__wrapped__")) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;
function isLaziable(func) {
  var funcName = getFuncName(func), other = lodash[funcName];
  if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData$1(other);
  return !!data && func === data[0];
}
var HOT_COUNT$1 = 800, HOT_SPAN$1 = 16;
var nativeNow$1 = Date.now;
function shortOut$2(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow$1(), remaining = HOT_SPAN$1 - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT$1) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
function constant$4(value) {
  return function() {
    return value;
  };
}
var defineProperty$5 = function() {
  try {
    var func = getNative$8(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e3) {
  }
}();
var baseSetToString$2 = !defineProperty$5 ? identity$b : function(func, string2) {
  return defineProperty$5(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant$4(string2),
    "writable": true
  });
};
const baseSetToString$3 = baseSetToString$2;
var setToString$3 = shortOut$2(baseSetToString$3);
function arrayEach(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (iteratee(array2[index2], index2, array2) === false) {
      break;
    }
  }
  return array2;
}
var MAX_SAFE_INTEGER$3 = 9007199254740991;
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;
function isIndex$5(value, length2) {
  var type2 = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER$3 : length2;
  return !!length2 && (type2 == "number" || type2 != "symbol" && reIsUint$1.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
function baseAssignValue$2(object2, key, value) {
  if (key == "__proto__" && defineProperty$5) {
    defineProperty$5(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
function eq$7(value, other) {
  return value === other || value !== value && other !== other;
}
var objectProto$v = Object.prototype;
var hasOwnProperty$s = objectProto$v.hasOwnProperty;
function assignValue$2(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$s.call(object2, key) && eq$7(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue$2(object2, key, value);
  }
}
function copyObject(source, props2, object2, customizer) {
  var isNew = !object2;
  object2 || (object2 = {});
  var index2 = -1, length2 = props2.length;
  while (++index2 < length2) {
    var key = props2[index2];
    var newValue = customizer ? customizer(object2[key], source[key], key, object2, source) : void 0;
    if (newValue === void 0) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$2(object2, key, newValue);
    } else {
      assignValue$2(object2, key, newValue);
    }
  }
  return object2;
}
var nativeMax$3 = Math.max;
function overRest$3(func, start2, transform) {
  start2 = nativeMax$3(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$3(args.length - start2, 0), array2 = Array(length2);
    while (++index2 < length2) {
      array2[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform(array2);
    return apply$2(func, this, otherArgs);
  };
}
function baseRest$2(func, start2) {
  return setToString$3(overRest$3(func, start2, identity$b), func + "");
}
var MAX_SAFE_INTEGER$2 = 9007199254740991;
function isLength$4(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}
function isArrayLike$7(value) {
  return value != null && isLength$4(value.length) && !isFunction$9(value);
}
function isIterateeCall$2(value, index2, object2) {
  if (!isObject$e(object2)) {
    return false;
  }
  var type2 = typeof index2;
  if (type2 == "number" ? isArrayLike$7(object2) && isIndex$5(index2, object2.length) : type2 == "string" && index2 in object2) {
    return eq$7(object2[index2], value);
  }
  return false;
}
function createAssigner(assigner) {
  return baseRest$2(function(object2, sources) {
    var index2 = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : void 0, guard = length2 > 2 ? sources[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
    if (guard && isIterateeCall$2(sources[0], sources[1], guard)) {
      customizer = length2 < 3 ? void 0 : customizer;
      length2 = 1;
    }
    object2 = Object(object2);
    while (++index2 < length2) {
      var source = sources[index2];
      if (source) {
        assigner(object2, source, index2, customizer);
      }
    }
    return object2;
  });
}
var objectProto$u = Object.prototype;
function isPrototype$4(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$u;
  return value === proto;
}
function baseTimes$2(n, iteratee) {
  var index2 = -1, result = Array(n);
  while (++index2 < n) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var argsTag$6 = "[object Arguments]";
function baseIsArguments$2(value) {
  return isObjectLike$9(value) && baseGetTag$9(value) == argsTag$6;
}
var objectProto$t = Object.prototype;
var hasOwnProperty$r = objectProto$t.hasOwnProperty;
var propertyIsEnumerable$3 = objectProto$t.propertyIsEnumerable;
var isArguments$9 = baseIsArguments$2(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments$2 : function(value) {
  return isObjectLike$9(value) && hasOwnProperty$r.call(value, "callee") && !propertyIsEnumerable$3.call(value, "callee");
};
const isArguments$a = isArguments$9;
function stubFalse$1() {
  return false;
}
var freeExports$2 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$2 = freeExports$2 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;
var Buffer$2 = moduleExports$2 ? root$b.Buffer : void 0;
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : void 0;
var isBuffer$6 = nativeIsBuffer || stubFalse$1;
const isBuffer$7 = isBuffer$6;
var argsTag$5 = "[object Arguments]", arrayTag$4 = "[object Array]", boolTag$5 = "[object Boolean]", dateTag$6 = "[object Date]", errorTag$4 = "[object Error]", funcTag$3 = "[object Function]", mapTag$a = "[object Map]", numberTag$5 = "[object Number]", objectTag$8 = "[object Object]", regexpTag$6 = "[object RegExp]", setTag$a = "[object Set]", stringTag$5 = "[object String]", weakMapTag$4 = "[object WeakMap]";
var arrayBufferTag$5 = "[object ArrayBuffer]", dataViewTag$7 = "[object DataView]", float32Tag$3 = "[object Float32Array]", float64Tag$3 = "[object Float64Array]", int8Tag$3 = "[object Int8Array]", int16Tag$3 = "[object Int16Array]", int32Tag$3 = "[object Int32Array]", uint8Tag$3 = "[object Uint8Array]", uint8ClampedTag$3 = "[object Uint8ClampedArray]", uint16Tag$3 = "[object Uint16Array]", uint32Tag$3 = "[object Uint32Array]";
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] = typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] = typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] = typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] = typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] = typedArrayTags$1[arrayBufferTag$5] = typedArrayTags$1[boolTag$5] = typedArrayTags$1[dataViewTag$7] = typedArrayTags$1[dateTag$6] = typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$3] = typedArrayTags$1[mapTag$a] = typedArrayTags$1[numberTag$5] = typedArrayTags$1[objectTag$8] = typedArrayTags$1[regexpTag$6] = typedArrayTags$1[setTag$a] = typedArrayTags$1[stringTag$5] = typedArrayTags$1[weakMapTag$4] = false;
function baseIsTypedArray$2(value) {
  return isObjectLike$9(value) && isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$9(value)];
}
function baseUnary$5(func) {
  return function(value) {
    return func(value);
  };
}
var freeExports$1 = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule$1 = freeExports$1 && typeof module == "object" && module && !module.nodeType && module;
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;
var freeProcess = moduleExports$1 && freeGlobal$2.process;
var nodeUtil$3 = function() {
  try {
    var types2 = freeModule$1 && freeModule$1.require && freeModule$1.require("util").types;
    if (types2) {
      return types2;
    }
    return freeProcess && freeProcess.binding && freeProcess.binding("util");
  } catch (e3) {
  }
}();
var nodeIsTypedArray$1 = nodeUtil$3 && nodeUtil$3.isTypedArray;
var isTypedArray$5 = nodeIsTypedArray$1 ? baseUnary$5(nodeIsTypedArray$1) : baseIsTypedArray$2;
const isTypedArray$6 = isTypedArray$5;
var objectProto$s = Object.prototype;
var hasOwnProperty$q = objectProto$s.hasOwnProperty;
function arrayLikeKeys$3(value, inherited) {
  var isArr = isArray$j(value), isArg = !isArr && isArguments$a(value), isBuff = !isArr && !isArg && isBuffer$7(value), isType = !isArr && !isArg && !isBuff && isTypedArray$6(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes$2(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$q.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$5(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
function overArg$3(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var nativeKeys$2 = overArg$3(Object.keys, Object);
var objectProto$r = Object.prototype;
var hasOwnProperty$p = objectProto$r.hasOwnProperty;
function baseKeys$3(object2) {
  if (!isPrototype$4(object2)) {
    return nativeKeys$2(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$p.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
function keys$7(object2) {
  return isArrayLike$7(object2) ? arrayLikeKeys$3(object2) : baseKeys$3(object2);
}
var objectProto$q = Object.prototype;
var hasOwnProperty$o = objectProto$q.hasOwnProperty;
var assign$8 = createAssigner(function(object2, source) {
  if (isPrototype$4(source) || isArrayLike$7(source)) {
    copyObject(source, keys$7(source), object2);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty$o.call(source, key)) {
      assignValue$2(object2, key, source[key]);
    }
  }
});
const _assign = assign$8;
function nativeKeysIn$2(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var objectProto$p = Object.prototype;
var hasOwnProperty$n = objectProto$p.hasOwnProperty;
function baseKeysIn$2(object2) {
  if (!isObject$e(object2)) {
    return nativeKeysIn$2(object2);
  }
  var isProto = isPrototype$4(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$n.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
function keysIn$3(object2) {
  return isArrayLike$7(object2) ? arrayLikeKeys$3(object2, true) : baseKeysIn$2(object2);
}
var reIsDeepProp$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp$1 = /^\w*$/;
function isKey$4(value, object2) {
  if (isArray$j(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$9(value)) {
    return true;
  }
  return reIsPlainProp$1.test(value) || !reIsDeepProp$1.test(value) || object2 != null && value in Object(object2);
}
var nativeCreate$5 = getNative$8(Object, "create");
function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}
function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var HASH_UNDEFINED$5 = "__lodash_hash_undefined__";
var objectProto$o = Object.prototype;
var hasOwnProperty$m = objectProto$o.hasOwnProperty;
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$5) {
    var result = data[key];
    return result === HASH_UNDEFINED$5 ? void 0 : result;
  }
  return hasOwnProperty$m.call(data, key) ? data[key] : void 0;
}
var objectProto$n = Object.prototype;
var hasOwnProperty$l = objectProto$n.hasOwnProperty;
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$5 ? data[key] !== void 0 : hasOwnProperty$l.call(data, key);
}
var HASH_UNDEFINED$4 = "__lodash_hash_undefined__";
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate$5 && value === void 0 ? HASH_UNDEFINED$4 : value;
  return this;
}
function Hash$2(entries6) {
  var index2 = -1, length2 = entries6 == null ? 0 : entries6.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries6[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$2.prototype.clear = hashClear$2;
Hash$2.prototype["delete"] = hashDelete$2;
Hash$2.prototype.get = hashGet$2;
Hash$2.prototype.has = hashHas$2;
Hash$2.prototype.set = hashSet$2;
function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}
function assocIndexOf$5(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq$7(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var arrayProto$1 = Array.prototype;
var splice$1 = arrayProto$1.splice;
function listCacheDelete$2(key) {
  var data = this.__data__, index2 = assocIndexOf$5(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index2, 1);
  }
  --this.size;
  return true;
}
function listCacheGet$2(key) {
  var data = this.__data__, index2 = assocIndexOf$5(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas$2(key) {
  return assocIndexOf$5(this.__data__, key) > -1;
}
function listCacheSet$2(key, value) {
  var data = this.__data__, index2 = assocIndexOf$5(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
function ListCache$5(entries6) {
  var index2 = -1, length2 = entries6 == null ? 0 : entries6.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries6[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$5.prototype.clear = listCacheClear$2;
ListCache$5.prototype["delete"] = listCacheDelete$2;
ListCache$5.prototype.get = listCacheGet$2;
ListCache$5.prototype.has = listCacheHas$2;
ListCache$5.prototype.set = listCacheSet$2;
var Map$5 = getNative$8(root$b, "Map");
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash$2(),
    "map": new (Map$5 || ListCache$5)(),
    "string": new Hash$2()
  };
}
function isKeyable$2(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
function getMapData$5(map2, key) {
  var data = map2.__data__;
  return isKeyable$2(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
function mapCacheDelete$2(key) {
  var result = getMapData$5(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
function mapCacheGet$2(key) {
  return getMapData$5(this, key).get(key);
}
function mapCacheHas$2(key) {
  return getMapData$5(this, key).has(key);
}
function mapCacheSet$2(key, value) {
  var data = getMapData$5(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
function MapCache$4(entries6) {
  var index2 = -1, length2 = entries6 == null ? 0 : entries6.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries6[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$4.prototype.clear = mapCacheClear$2;
MapCache$4.prototype["delete"] = mapCacheDelete$2;
MapCache$4.prototype.get = mapCacheGet$2;
MapCache$4.prototype.has = mapCacheHas$2;
MapCache$4.prototype.set = mapCacheSet$2;
var FUNC_ERROR_TEXT$7 = "Expected a function";
function memoize$5(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$7);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$5.Cache || MapCache$4)();
  return memoized;
}
memoize$5.Cache = MapCache$4;
var MAX_MEMOIZE_SIZE$1 = 500;
function memoizeCapped$2(func) {
  var result = memoize$5(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE$1) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var rePropName$2 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$2 = /\\(\\)?/g;
var stringToPath$3 = memoizeCapped$2(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName$2, function(match2, number2, quote2, subString) {
    result.push(quote2 ? subString.replace(reEscapeChar$2, "$1") : number2 || match2);
  });
  return result;
});
function toString$7(value) {
  return value == null ? "" : baseToString$2(value);
}
function castPath$5(value, object2) {
  if (isArray$j(value)) {
    return value;
  }
  return isKey$4(value, object2) ? [value] : stringToPath$3(toString$7(value));
}
var INFINITY$4 = 1 / 0;
function toKey$6(value) {
  if (typeof value == "string" || isSymbol$9(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$4 ? "-0" : result;
}
function baseGet$5(object2, path2) {
  path2 = castPath$5(path2, object2);
  var index2 = 0, length2 = path2.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey$6(path2[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
function arrayPush$4(array2, values6) {
  var index2 = -1, length2 = values6.length, offset2 = array2.length;
  while (++index2 < length2) {
    array2[offset2 + index2] = values6[index2];
  }
  return array2;
}
var spreadableSymbol$1 = Symbol$a ? Symbol$a.isConcatSpreadable : void 0;
function isFlattenable$2(value) {
  return isArray$j(value) || isArguments$a(value) || !!(spreadableSymbol$1 && value && value[spreadableSymbol$1]);
}
function baseFlatten$2(array2, depth, predicate, isStrict, result) {
  var index2 = -1, length2 = array2.length;
  predicate || (predicate = isFlattenable$2);
  result || (result = []);
  while (++index2 < length2) {
    var value = array2[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$4(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
function flatten$3(array2) {
  var length2 = array2 == null ? 0 : array2.length;
  return length2 ? baseFlatten$2(array2, 1) : [];
}
function flatRest$2(func) {
  return setToString$3(overRest$3(func, void 0, flatten$3), func + "");
}
var getPrototype$3 = overArg$3(Object.getPrototypeOf, Object);
var objectTag$7 = "[object Object]";
var funcProto$3 = Function.prototype, objectProto$m = Object.prototype;
var funcToString$3 = funcProto$3.toString;
var hasOwnProperty$k = objectProto$m.hasOwnProperty;
var objectCtorString$1 = funcToString$3.call(Object);
function isPlainObject$2(value) {
  if (!isObjectLike$9(value) || baseGetTag$9(value) != objectTag$7) {
    return false;
  }
  var proto = getPrototype$3(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$k.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString$3.call(Ctor) == objectCtorString$1;
}
function baseSlice(array2, start2, end2) {
  var index2 = -1, length2 = array2.length;
  if (start2 < 0) {
    start2 = -start2 > length2 ? 0 : length2 + start2;
  }
  end2 = end2 > length2 ? length2 : end2;
  if (end2 < 0) {
    end2 += length2;
  }
  length2 = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length2);
  while (++index2 < length2) {
    result[index2] = array2[index2 + start2];
  }
  return result;
}
function stackClear$2() {
  this.__data__ = new ListCache$5();
  this.size = 0;
}
function stackDelete$2(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
function stackGet$2(key) {
  return this.__data__.get(key);
}
function stackHas$2(key) {
  return this.__data__.has(key);
}
var LARGE_ARRAY_SIZE$2 = 200;
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$5) {
    var pairs = data.__data__;
    if (!Map$5 || pairs.length < LARGE_ARRAY_SIZE$2 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$4(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
function Stack$4(entries6) {
  var data = this.__data__ = new ListCache$5(entries6);
  this.size = data.size;
}
Stack$4.prototype.clear = stackClear$2;
Stack$4.prototype["delete"] = stackDelete$2;
Stack$4.prototype.get = stackGet$2;
Stack$4.prototype.has = stackHas$2;
Stack$4.prototype.set = stackSet$2;
function baseAssign(object2, source) {
  return object2 && copyObject(source, keys$7(source), object2);
}
function baseAssignIn(object2, source) {
  return object2 && copyObject(source, keysIn$3(source), object2);
}
var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
var moduleExports = freeModule && freeModule.exports === freeExports;
var Buffer$1 = moduleExports ? root$b.Buffer : void 0, allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : void 0;
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length2 = buffer.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
  buffer.copy(result);
  return result;
}
function arrayFilter$2(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
function stubArray$3() {
  return [];
}
var objectProto$l = Object.prototype;
var propertyIsEnumerable$2 = objectProto$l.propertyIsEnumerable;
var nativeGetSymbols$3 = Object.getOwnPropertySymbols;
var getSymbols$3 = !nativeGetSymbols$3 ? stubArray$3 : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter$2(nativeGetSymbols$3(object2), function(symbol) {
    return propertyIsEnumerable$2.call(object2, symbol);
  });
};
function copySymbols(source, object2) {
  return copyObject(source, getSymbols$3(source), object2);
}
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;
var getSymbolsIn$2 = !nativeGetSymbols$2 ? stubArray$3 : function(object2) {
  var result = [];
  while (object2) {
    arrayPush$4(result, getSymbols$3(object2));
    object2 = getPrototype$3(object2);
  }
  return result;
};
const getSymbolsIn$3 = getSymbolsIn$2;
function copySymbolsIn(source, object2) {
  return copyObject(source, getSymbolsIn$3(source), object2);
}
function baseGetAllKeys$3(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$j(object2) ? result : arrayPush$4(result, symbolsFunc(object2));
}
function getAllKeys$2(object2) {
  return baseGetAllKeys$3(object2, keys$7, getSymbols$3);
}
function getAllKeysIn$2(object2) {
  return baseGetAllKeys$3(object2, keysIn$3, getSymbolsIn$3);
}
var DataView$3 = getNative$8(root$b, "DataView");
var Promise$3 = getNative$8(root$b, "Promise");
var Set$4 = getNative$8(root$b, "Set");
var mapTag$9 = "[object Map]", objectTag$6 = "[object Object]", promiseTag$1 = "[object Promise]", setTag$9 = "[object Set]", weakMapTag$3 = "[object WeakMap]";
var dataViewTag$6 = "[object DataView]";
var dataViewCtorString$1 = toSource$3(DataView$3), mapCtorString$1 = toSource$3(Map$5), promiseCtorString$1 = toSource$3(Promise$3), setCtorString$1 = toSource$3(Set$4), weakMapCtorString$1 = toSource$3(WeakMap$3);
var getTag$3 = baseGetTag$9;
if (DataView$3 && getTag$3(new DataView$3(new ArrayBuffer(1))) != dataViewTag$6 || Map$5 && getTag$3(new Map$5()) != mapTag$9 || Promise$3 && getTag$3(Promise$3.resolve()) != promiseTag$1 || Set$4 && getTag$3(new Set$4()) != setTag$9 || WeakMap$3 && getTag$3(new WeakMap$3()) != weakMapTag$3) {
  getTag$3 = function(value) {
    var result = baseGetTag$9(value), Ctor = result == objectTag$6 ? value.constructor : void 0, ctorString = Ctor ? toSource$3(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1:
          return dataViewTag$6;
        case mapCtorString$1:
          return mapTag$9;
        case promiseCtorString$1:
          return promiseTag$1;
        case setCtorString$1:
          return setTag$9;
        case weakMapCtorString$1:
          return weakMapTag$3;
      }
    }
    return result;
  };
}
const getTag$4 = getTag$3;
var objectProto$k = Object.prototype;
var hasOwnProperty$j = objectProto$k.hasOwnProperty;
function initCloneArray(array2) {
  var length2 = array2.length, result = new array2.constructor(length2);
  if (length2 && typeof array2[0] == "string" && hasOwnProperty$j.call(array2, "index")) {
    result.index = array2.index;
    result.input = array2.input;
  }
  return result;
}
var Uint8Array$3 = root$b.Uint8Array;
const Uint8Array$4 = Uint8Array$3;
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$4(result).set(new Uint8Array$4(arrayBuffer));
  return result;
}
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var reFlags = /\w*$/;
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var symbolProto$3 = Symbol$a ? Symbol$a.prototype : void 0, symbolValueOf$2 = symbolProto$3 ? symbolProto$3.valueOf : void 0;
function cloneSymbol(symbol) {
  return symbolValueOf$2 ? Object(symbolValueOf$2.call(symbol)) : {};
}
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var boolTag$4 = "[object Boolean]", dateTag$5 = "[object Date]", mapTag$8 = "[object Map]", numberTag$4 = "[object Number]", regexpTag$5 = "[object RegExp]", setTag$8 = "[object Set]", stringTag$4 = "[object String]", symbolTag$4 = "[object Symbol]";
var arrayBufferTag$4 = "[object ArrayBuffer]", dataViewTag$5 = "[object DataView]", float32Tag$2 = "[object Float32Array]", float64Tag$2 = "[object Float64Array]", int8Tag$2 = "[object Int8Array]", int16Tag$2 = "[object Int16Array]", int32Tag$2 = "[object Int32Array]", uint8Tag$2 = "[object Uint8Array]", uint8ClampedTag$2 = "[object Uint8ClampedArray]", uint16Tag$2 = "[object Uint16Array]", uint32Tag$2 = "[object Uint32Array]";
function initCloneByTag(object2, tag2, isDeep) {
  var Ctor = object2.constructor;
  switch (tag2) {
    case arrayBufferTag$4:
      return cloneArrayBuffer(object2);
    case boolTag$4:
    case dateTag$5:
      return new Ctor(+object2);
    case dataViewTag$5:
      return cloneDataView(object2, isDeep);
    case float32Tag$2:
    case float64Tag$2:
    case int8Tag$2:
    case int16Tag$2:
    case int32Tag$2:
    case uint8Tag$2:
    case uint8ClampedTag$2:
    case uint16Tag$2:
    case uint32Tag$2:
      return cloneTypedArray(object2, isDeep);
    case mapTag$8:
      return new Ctor();
    case numberTag$4:
    case stringTag$4:
      return new Ctor(object2);
    case regexpTag$5:
      return cloneRegExp(object2);
    case setTag$8:
      return new Ctor();
    case symbolTag$4:
      return cloneSymbol(object2);
  }
}
function initCloneObject(object2) {
  return typeof object2.constructor == "function" && !isPrototype$4(object2) ? baseCreate(getPrototype$3(object2)) : {};
}
var mapTag$7 = "[object Map]";
function baseIsMap(value) {
  return isObjectLike$9(value) && getTag$4(value) == mapTag$7;
}
var nodeIsMap = nodeUtil$3 && nodeUtil$3.isMap;
var isMap$4 = nodeIsMap ? baseUnary$5(nodeIsMap) : baseIsMap;
var setTag$7 = "[object Set]";
function baseIsSet(value) {
  return isObjectLike$9(value) && getTag$4(value) == setTag$7;
}
var nodeIsSet = nodeUtil$3 && nodeUtil$3.isSet;
var isSet$4 = nodeIsSet ? baseUnary$5(nodeIsSet) : baseIsSet;
var CLONE_DEEP_FLAG$2 = 1, CLONE_FLAT_FLAG$1 = 2, CLONE_SYMBOLS_FLAG$3 = 4;
var argsTag$4 = "[object Arguments]", arrayTag$3 = "[object Array]", boolTag$3 = "[object Boolean]", dateTag$4 = "[object Date]", errorTag$3 = "[object Error]", funcTag$2 = "[object Function]", genTag$1 = "[object GeneratorFunction]", mapTag$6 = "[object Map]", numberTag$3 = "[object Number]", objectTag$5 = "[object Object]", regexpTag$4 = "[object RegExp]", setTag$6 = "[object Set]", stringTag$3 = "[object String]", symbolTag$3 = "[object Symbol]", weakMapTag$2 = "[object WeakMap]";
var arrayBufferTag$3 = "[object ArrayBuffer]", dataViewTag$4 = "[object DataView]", float32Tag$1 = "[object Float32Array]", float64Tag$1 = "[object Float64Array]", int8Tag$1 = "[object Int8Array]", int16Tag$1 = "[object Int16Array]", int32Tag$1 = "[object Int32Array]", uint8Tag$1 = "[object Uint8Array]", uint8ClampedTag$1 = "[object Uint8ClampedArray]", uint16Tag$1 = "[object Uint16Array]", uint32Tag$1 = "[object Uint32Array]";
var cloneableTags = {};
cloneableTags[argsTag$4] = cloneableTags[arrayTag$3] = cloneableTags[arrayBufferTag$3] = cloneableTags[dataViewTag$4] = cloneableTags[boolTag$3] = cloneableTags[dateTag$4] = cloneableTags[float32Tag$1] = cloneableTags[float64Tag$1] = cloneableTags[int8Tag$1] = cloneableTags[int16Tag$1] = cloneableTags[int32Tag$1] = cloneableTags[mapTag$6] = cloneableTags[numberTag$3] = cloneableTags[objectTag$5] = cloneableTags[regexpTag$4] = cloneableTags[setTag$6] = cloneableTags[stringTag$3] = cloneableTags[symbolTag$3] = cloneableTags[uint8Tag$1] = cloneableTags[uint8ClampedTag$1] = cloneableTags[uint16Tag$1] = cloneableTags[uint32Tag$1] = true;
cloneableTags[errorTag$3] = cloneableTags[funcTag$2] = cloneableTags[weakMapTag$2] = false;
function baseClone(value, bitmask, customizer, key, object2, stack2) {
  var result, isDeep = bitmask & CLONE_DEEP_FLAG$2, isFlat = bitmask & CLONE_FLAT_FLAG$1, isFull = bitmask & CLONE_SYMBOLS_FLAG$3;
  if (customizer) {
    result = object2 ? customizer(value, key, object2, stack2) : customizer(value);
  }
  if (result !== void 0) {
    return result;
  }
  if (!isObject$e(value)) {
    return value;
  }
  var isArr = isArray$j(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag2 = getTag$4(value), isFunc = tag2 == funcTag$2 || tag2 == genTag$1;
    if (isBuffer$7(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag2 == objectTag$5 || tag2 == argsTag$4 || isFunc && !object2) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag2]) {
        return object2 ? value : {};
      }
      result = initCloneByTag(value, tag2, isDeep);
    }
  }
  stack2 || (stack2 = new Stack$4());
  var stacked = stack2.get(value);
  if (stacked) {
    return stacked;
  }
  stack2.set(value, result);
  if (isSet$4(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack2));
    });
  } else if (isMap$4(value)) {
    value.forEach(function(subValue, key2) {
      result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack2));
    });
  }
  var keysFunc = isFull ? isFlat ? getAllKeysIn$2 : getAllKeys$2 : isFlat ? keysIn$3 : keys$7;
  var props2 = isArr ? void 0 : keysFunc(value);
  arrayEach(props2 || value, function(subValue, key2) {
    if (props2) {
      key2 = subValue;
      subValue = value[key2];
    }
    assignValue$2(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack2));
  });
  return result;
}
var CLONE_SYMBOLS_FLAG$2 = 4;
function clone$1(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG$2);
}
var CLONE_DEEP_FLAG$1 = 1, CLONE_SYMBOLS_FLAG$1 = 4;
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}
var HASH_UNDEFINED$3 = "__lodash_hash_undefined__";
function setCacheAdd$2(value) {
  this.__data__.set(value, HASH_UNDEFINED$3);
  return this;
}
function setCacheHas$2(value) {
  return this.__data__.has(value);
}
function SetCache$3(values6) {
  var index2 = -1, length2 = values6 == null ? 0 : values6.length;
  this.__data__ = new MapCache$4();
  while (++index2 < length2) {
    this.add(values6[index2]);
  }
}
SetCache$3.prototype.add = SetCache$3.prototype.push = setCacheAdd$2;
SetCache$3.prototype.has = setCacheHas$2;
function arraySome$2(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
function cacheHas$3(cache2, key) {
  return cache2.has(key);
}
var COMPARE_PARTIAL_FLAG$9 = 1, COMPARE_UNORDERED_FLAG$5 = 2;
function equalArrays$3(array2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$9, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack2.get(array2);
  var othStacked = stack2.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$5 ? new SetCache$3() : void 0;
  stack2.set(array2, other);
  stack2.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack2) : customizer(arrValue, othValue, index2, array2, other, stack2);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome$2(other, function(othValue2, othIndex) {
        if (!cacheHas$3(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
      result = false;
      break;
    }
  }
  stack2["delete"](array2);
  stack2["delete"](other);
  return result;
}
function mapToArray$2(map2) {
  var index2 = -1, result = Array(map2.size);
  map2.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
function setToArray$4(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var COMPARE_PARTIAL_FLAG$8 = 1, COMPARE_UNORDERED_FLAG$4 = 2;
var boolTag$2 = "[object Boolean]", dateTag$3 = "[object Date]", errorTag$2 = "[object Error]", mapTag$5 = "[object Map]", numberTag$2 = "[object Number]", regexpTag$3 = "[object RegExp]", setTag$5 = "[object Set]", stringTag$2 = "[object String]", symbolTag$2 = "[object Symbol]";
var arrayBufferTag$2 = "[object ArrayBuffer]", dataViewTag$3 = "[object DataView]";
var symbolProto$2 = Symbol$a ? Symbol$a.prototype : void 0, symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : void 0;
function equalByTag$2(object2, other, tag2, bitmask, customizer, equalFunc, stack2) {
  switch (tag2) {
    case dataViewTag$3:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$2:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$4(object2), new Uint8Array$4(other))) {
        return false;
      }
      return true;
    case boolTag$2:
    case dateTag$3:
    case numberTag$2:
      return eq$7(+object2, +other);
    case errorTag$2:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$3:
    case stringTag$2:
      return object2 == other + "";
    case mapTag$5:
      var convert = mapToArray$2;
    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$8;
      convert || (convert = setToArray$4);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack2.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$4;
      stack2.set(object2, other);
      var result = equalArrays$3(convert(object2), convert(other), bitmask, customizer, equalFunc, stack2);
      stack2["delete"](object2);
      return result;
    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object2) == symbolValueOf$1.call(other);
      }
  }
  return false;
}
var COMPARE_PARTIAL_FLAG$7 = 1;
var objectProto$j = Object.prototype;
var hasOwnProperty$i = objectProto$j.hasOwnProperty;
function equalObjects$2(object2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$7, objProps = getAllKeys$2(object2), objLength = objProps.length, othProps = getAllKeys$2(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$i.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack2.get(object2);
  var othStacked = stack2.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack2.set(object2, other);
  stack2.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack2) : customizer(objValue, othValue, key, object2, other, stack2);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack2["delete"](object2);
  stack2["delete"](other);
  return result;
}
var COMPARE_PARTIAL_FLAG$6 = 1;
var argsTag$3 = "[object Arguments]", arrayTag$2 = "[object Array]", objectTag$4 = "[object Object]";
var objectProto$i = Object.prototype;
var hasOwnProperty$h = objectProto$i.hasOwnProperty;
function baseIsEqualDeep$2(object2, other, bitmask, customizer, equalFunc, stack2) {
  var objIsArr = isArray$j(object2), othIsArr = isArray$j(other), objTag = objIsArr ? arrayTag$2 : getTag$4(object2), othTag = othIsArr ? arrayTag$2 : getTag$4(other);
  objTag = objTag == argsTag$3 ? objectTag$4 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$4 : othTag;
  var objIsObj = objTag == objectTag$4, othIsObj = othTag == objectTag$4, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$7(object2)) {
    if (!isBuffer$7(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack2 || (stack2 = new Stack$4());
    return objIsArr || isTypedArray$6(object2) ? equalArrays$3(object2, other, bitmask, customizer, equalFunc, stack2) : equalByTag$2(object2, other, objTag, bitmask, customizer, equalFunc, stack2);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$6)) {
    var objIsWrapped = objIsObj && hasOwnProperty$h.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$h.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack2 || (stack2 = new Stack$4());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack2 || (stack2 = new Stack$4());
  return equalObjects$2(object2, other, bitmask, customizer, equalFunc, stack2);
}
function baseIsEqual$4(value, other, bitmask, customizer, stack2) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$9(value) && !isObjectLike$9(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep$2(value, other, bitmask, customizer, baseIsEqual$4, stack2);
}
function baseHasIn$2(object2, key) {
  return object2 != null && key in Object(object2);
}
function hasPath$2(object2, path2, hasFunc) {
  path2 = castPath$5(path2, object2);
  var index2 = -1, length2 = path2.length, result = false;
  while (++index2 < length2) {
    var key = toKey$6(path2[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength$4(length2) && isIndex$5(key, length2) && (isArray$j(object2) || isArguments$a(object2));
}
function hasIn$3(object2, path2) {
  return object2 != null && hasPath$2(object2, path2, baseHasIn$2);
}
function createBaseFor$2(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props2 = keysFunc(object2), length2 = props2.length;
    while (length2--) {
      var key = props2[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var baseFor$2 = createBaseFor$2();
var now$3 = function() {
  return root$b.Date.now();
};
var FUNC_ERROR_TEXT$6 = "Expected a function";
var nativeMax$2 = Math.max, nativeMin$1 = Math.min;
function debounce$3(func, wait, options2) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$6);
  }
  wait = toNumber$3(wait) || 0;
  if (isObject$e(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax$2(toNumber$3(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin$1(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now$3();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel2() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush2() {
    return timerId === void 0 ? result : trailingEdge(now$3());
  }
  function debounced() {
    var time2 = now$3(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel2;
  debounced.flush = flush2;
  return debounced;
}
function assignMergeValue(object2, key, value) {
  if (value !== void 0 && !eq$7(object2[key], value) || value === void 0 && !(key in object2)) {
    baseAssignValue$2(object2, key, value);
  }
}
function isArrayLikeObject(value) {
  return isObjectLike$9(value) && isArrayLike$7(value);
}
function safeGet(object2, key) {
  if (key === "constructor" && typeof object2[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object2[key];
}
function toPlainObject(value) {
  return copyObject(value, keysIn$3(value));
}
function baseMergeDeep(object2, source, key, srcIndex, mergeFunc, customizer, stack2) {
  var objValue = safeGet(object2, key), srcValue = safeGet(source, key), stacked = stack2.get(srcValue);
  if (stacked) {
    assignMergeValue(object2, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object2, source, stack2) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$j(srcValue), isBuff = !isArr && isBuffer$7(srcValue), isTyped = !isArr && !isBuff && isTypedArray$6(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$j(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$2(srcValue) || isArguments$a(srcValue)) {
      newValue = objValue;
      if (isArguments$a(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$e(objValue) || isFunction$9(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack2.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack2);
    stack2["delete"](srcValue);
  }
  assignMergeValue(object2, key, newValue);
}
function baseMerge(object2, source, srcIndex, customizer, stack2) {
  if (object2 === source) {
    return;
  }
  baseFor$2(source, function(srcValue, key) {
    stack2 || (stack2 = new Stack$4());
    if (isObject$e(srcValue)) {
      baseMergeDeep(object2, source, key, srcIndex, baseMerge, customizer, stack2);
    } else {
      var newValue = customizer ? customizer(safeGet(object2, key), srcValue, key + "", object2, source, stack2) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object2, key, newValue);
    }
  }, keysIn$3);
}
var mergeWith = createAssigner(function(object2, source, srcIndex, customizer) {
  baseMerge(object2, source, srcIndex, customizer);
});
function last(array2) {
  var length2 = array2 == null ? 0 : array2.length;
  return length2 ? array2[length2 - 1] : void 0;
}
var INFINITY$3 = 1 / 0;
function flattenDeep(array2) {
  var length2 = array2 == null ? 0 : array2.length;
  return length2 ? baseFlatten$2(array2, INFINITY$3) : [];
}
var FUNC_ERROR_TEXT$5 = "Expected a function";
var WRAP_CURRY_FLAG = 8, WRAP_PARTIAL_FLAG = 32, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256;
function createFlow(fromRight) {
  return flatRest$2(function(funcs) {
    var length2 = funcs.length, index2 = length2, prereq = LodashWrapper.prototype.thru;
    if (fromRight) {
      funcs.reverse();
    }
    while (index2--) {
      var func = funcs[index2];
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT$5);
      }
      if (prereq && !wrapper2 && getFuncName(func) == "wrapper") {
        var wrapper2 = new LodashWrapper([], true);
      }
    }
    index2 = wrapper2 ? index2 : length2;
    while (++index2 < length2) {
      func = funcs[index2];
      var funcName = getFuncName(func), data = funcName == "wrapper" ? getData$1(func) : void 0;
      if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
        wrapper2 = wrapper2[getFuncName(data[0])].apply(wrapper2, data[3]);
      } else {
        wrapper2 = func.length == 1 && isLaziable(func) ? wrapper2[funcName]() : wrapper2.thru(func);
      }
    }
    return function() {
      var args = arguments, value = args[0];
      if (wrapper2 && args.length == 1 && isArray$j(value)) {
        return wrapper2.plant(value).value();
      }
      var index3 = 0, result = length2 ? funcs[index3].apply(this, args) : value;
      while (++index3 < length2) {
        result = funcs[index3].call(this, result);
      }
      return result;
    };
  });
}
var flow = createFlow();
function parent(object2, path2) {
  return path2.length < 2 ? object2 : baseGet$5(object2, baseSlice(path2, 0, -1));
}
var mapTag$4 = "[object Map]", setTag$4 = "[object Set]";
var objectProto$h = Object.prototype;
var hasOwnProperty$g = objectProto$h.hasOwnProperty;
function isEmpty$1(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$7(value) && (isArray$j(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$7(value) || isTypedArray$6(value) || isArguments$a(value))) {
    return !value.length;
  }
  var tag2 = getTag$4(value);
  if (tag2 == mapTag$4 || tag2 == setTag$4) {
    return !value.size;
  }
  if (isPrototype$4(value)) {
    return !baseKeys$3(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$g.call(value, key)) {
      return false;
    }
  }
  return true;
}
function isEqual$a(value, other) {
  return baseIsEqual$4(value, other);
}
var merge$4 = createAssigner(function(object2, source, srcIndex) {
  baseMerge(object2, source, srcIndex);
});
function baseUnset(object2, path2) {
  path2 = castPath$5(path2, object2);
  object2 = parent(object2, path2);
  return object2 == null || delete object2[toKey$6(last(path2))];
}
function customOmitClone(value) {
  return isPlainObject$2(value) ? void 0 : value;
}
var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
var omit$1 = flatRest$2(function(object2, paths) {
  var result = {};
  if (object2 == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$4(paths, function(path2) {
    path2 = castPath$5(path2, object2);
    isDeep || (isDeep = path2.length > 1);
    return path2;
  });
  copyObject(object2, getAllKeysIn$2(object2), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length2 = paths.length;
  while (length2--) {
    baseUnset(result, paths[length2]);
  }
  return result;
});
function baseSet$2(object2, path2, value, customizer) {
  if (!isObject$e(object2)) {
    return object2;
  }
  path2 = castPath$5(path2, object2);
  var index2 = -1, length2 = path2.length, lastIndex = length2 - 1, nested = object2;
  while (nested != null && ++index2 < length2) {
    var key = toKey$6(path2[index2]), newValue = value;
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return object2;
    }
    if (index2 != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject$e(objValue) ? objValue : isIndex$5(path2[index2 + 1]) ? [] : {};
      }
    }
    assignValue$2(nested, key, newValue);
    nested = nested[key];
  }
  return object2;
}
function basePickBy$3(object2, paths, predicate) {
  var index2 = -1, length2 = paths.length, result = {};
  while (++index2 < length2) {
    var path2 = paths[index2], value = baseGet$5(object2, path2);
    if (predicate(value, path2)) {
      baseSet$2(result, castPath$5(path2, object2), value);
    }
  }
  return result;
}
function basePick$2(object2, paths) {
  return basePickBy$3(object2, paths, function(value, path2) {
    return hasIn$3(object2, path2);
  });
}
var pick$2 = flatRest$2(function(object2, paths) {
  return object2 == null ? {} : basePick$2(object2, paths);
});
var FUNC_ERROR_TEXT$4 = "Expected a function";
function throttle$1(func, wait, options2) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$4);
  }
  if (isObject$e(options2)) {
    leading = "leading" in options2 ? !!options2.leading : leading;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  return debounce$3(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
function toPath(value) {
  if (isArray$j(value)) {
    return arrayMap$4(value, toKey$6);
  }
  return isSymbol$9(value) ? [value] : copyArray(stringToPath$3(toString$7(value)));
}
var idCounter$1 = 0;
function uniqueId$1(prefix2) {
  var id = ++idCounter$1;
  return toString$7(prefix2) + id;
}
function useEventListener(type2, listener, options2 = false, dependencies2) {
  useEffect(() => {
    window.addEventListener(type2, listener, options2);
    return () => {
      window.removeEventListener(type2, listener, options2);
    };
  }, dependencies2);
}
function sheetForTag(tag2) {
  if (tag2.sheet) {
    return tag2.sheet;
  }
  for (var i2 = 0; i2 < document.styleSheets.length; i2++) {
    if (document.styleSheets[i2].ownerNode === tag2) {
      return document.styleSheets[i2];
    }
  }
}
function createStyleElement(options2) {
  var tag2 = document.createElement("style");
  tag2.setAttribute("data-emotion", options2.key);
  if (options2.nonce !== void 0) {
    tag2.setAttribute("nonce", options2.nonce);
  }
  tag2.appendChild(document.createTextNode(""));
  tag2.setAttribute("data-s", "");
  return tag2;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options2) {
    var _this = this;
    this._insertTag = function(tag2) {
      var before;
      if (_this.tags.length === 0) {
        if (_this.insertionPoint) {
          before = _this.insertionPoint.nextSibling;
        } else if (_this.prepend) {
          before = _this.container.firstChild;
        } else {
          before = _this.before;
        }
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }
      _this.container.insertBefore(tag2, before);
      _this.tags.push(tag2);
    };
    this.isSpeedy = options2.speedy === void 0 ? process.env.NODE_ENV === "production" : options2.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options2.nonce;
    this.key = options2.key;
    this.container = options2.container;
    this.prepend = options2.prepend;
    this.insertionPoint = options2.insertionPoint;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };
  _proto.insert = function insert(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }
    var tag2 = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var isImportRule3 = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
      if (isImportRule3 && this._alreadyInsertedOrderInsensitiveRule) {
        console.error("You're attempting to insert the following rule:\n" + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.");
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule3;
    }
    if (this.isSpeedy) {
      var sheet2 = sheetForTag(tag2);
      try {
        sheet2.insertRule(rule, sheet2.cssRules.length);
      } catch (e3) {
        if (process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule)) {
          console.error('There was a problem inserting the following rule: "' + rule + '"', e3);
        }
      }
    } else {
      tag2.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush2() {
    this.tags.forEach(function(tag2) {
      return tag2.parentNode && tag2.parentNode.removeChild(tag2);
    });
    this.tags = [];
    this.ctr = 0;
    if (process.env.NODE_ENV !== "production") {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };
  return StyleSheet2;
}();
var MS = "-ms-";
var MOZ = "-moz-";
var WEBKIT = "-webkit-";
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs$1 = Math.abs;
var from = String.fromCharCode;
var assign$7 = Object.assign;
function hash$2(value, length2) {
  return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim$1(value) {
  return value.trim();
}
function match$2(value, pattern) {
  return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
  return value.replace(pattern, replacement);
}
function indexof(value, search) {
  return value.indexOf(search);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end2) {
  return value.slice(begin, end2);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append$1(value, array2) {
  return array2.push(value), value;
}
function combine(array2, callback) {
  return array2.map(callback).join("");
}
var line$1 = 1;
var column = 1;
var length = 0;
var position$1 = 0;
var character = 0;
var characters = "";
function node(value, root2, parent2, type2, props2, children2, length2) {
  return { value, root: root2, parent: parent2, type: type2, props: props2, children: children2, line: line$1, column, length: length2, return: "" };
}
function copy$2(root2, props2) {
  return assign$7(node("", null, null, "", null, null, 0), root2, { length: -root2.length }, props2);
}
function char() {
  return character;
}
function prev() {
  character = position$1 > 0 ? charat(characters, --position$1) : 0;
  if (column--, character === 10)
    column = 1, line$1--;
  return character;
}
function next() {
  character = position$1 < length ? charat(characters, position$1++) : 0;
  if (column++, character === 10)
    column = 1, line$1++;
  return character;
}
function peek() {
  return charat(characters, position$1);
}
function caret() {
  return position$1;
}
function slice$2(begin, end2) {
  return substr(characters, begin, end2);
}
function token(type2) {
  switch (type2) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line$1 = column = 1, length = strlen(characters = value), position$1 = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type2) {
  return trim$1(slice$2(position$1 - 1, delimiter(type2 === 91 ? type2 + 2 : type2 === 40 ? type2 + 1 : type2)));
}
function whitespace(type2) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type2) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice$2(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type2) {
  while (next())
    switch (character) {
      case type2:
        return position$1;
      case 34:
      case 39:
        if (type2 !== 34 && type2 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type2 === 41)
          delimiter(type2);
        break;
      case 92:
        next();
        break;
    }
  return position$1;
}
function commenter(type2, index2) {
  while (next())
    if (type2 + character === 47 + 10)
      break;
    else if (type2 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice$2(index2, position$1 - 1) + "*" + from(type2 === 47 ? type2 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice$2(index2, position$1);
}
function compile(value) {
  return dealloc(parse$3("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse$3(value, root2, parent2, rule, rules, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property2 = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type2 = "";
  var props2 = rules;
  var children2 = rulesets;
  var reference2 = rule;
  var characters2 = type2;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append$1(comment(commenter(next(), caret()), root2, parent2), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (ampersand == -1)
              characters2 = replace(characters2, /\f/g, "");
            if (property2 > 0 && strlen(characters2) - length2)
              append$1(property2 > 32 ? declaration(characters2 + ";", rule, parent2, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent2, length2 - 2), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append$1(reference2 = ruleset(characters2, root2, parent2, index2, offset2, rules, points, type2, props2 = [], children2 = [], length2), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse$3(characters2, root2, reference2, reference2, props2, rulesets, length2, points, children2);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse$3(value, reference2, reference2, rule && append$1(ruleset(value, reference2, reference2, 0, 0, rules, points, type2, rules, props2 = [], length2), children2), rules, children2, length2, points, rule ? props2 : children2);
                    break;
                  default:
                    parse$3(characters2, reference2, reference2, reference2, [""], children2, 0, points, children2);
                }
        }
        index2 = offset2 = property2 = 0, variable = ampersand = 1, type2 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property2 = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type2 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root2, parent2, index2, offset2, rules, points, type2, props2, children2, length2) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules : [""];
  var size = sizeof(rule);
  for (var i2 = 0, j = 0, k3 = 0; i2 < index2; ++i2)
    for (var x3 = 0, y4 = substr(value, post + 1, post = abs$1(j = points[i2])), z2 = value; x3 < size; ++x3)
      if (z2 = trim$1(j > 0 ? rule[x3] + " " + y4 : replace(y4, /&\f/g, rule[x3])))
        props2[k3++] = z2;
  return node(value, root2, parent2, offset2 === 0 ? RULESET : type2, props2, children2, length2);
}
function comment(value, root2, parent2) {
  return node(value, root2, parent2, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root2, parent2, length2) {
  return node(value, root2, parent2, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize$7(children2, callback) {
  var output = "";
  var length2 = sizeof(children2);
  for (var i2 = 0; i2 < length2; i2++)
    output += callback(children2[i2], i2, children2, callback) || "";
  return output;
}
function stringify$2(element, index2, children2, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize$7(element.children, callback) + "}";
    case RULESET:
      element.value = element.props.join(",");
  }
  return strlen(children2 = serialize$7(element.children, callback)) ? element.return = element.value + "{" + children2 + "}" : "";
}
function middleware(collection) {
  var length2 = sizeof(collection);
  return function(element, index2, children2, callback) {
    var output = "";
    for (var i2 = 0; i2 < length2; i2++)
      output += collection[i2](element, index2, children2, callback) || "";
    return output;
  };
}
function rulesheet(callback) {
  return function(element) {
    if (!element.root) {
      if (element = element.return)
        callback(element);
    }
  };
}
function memoize$4(fn2) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
var identifierWithPointTracking = function identifierWithPointTracking2(begin, points, index2) {
  var previous = 0;
  var character2 = 0;
  while (true) {
    previous = character2;
    character2 = peek();
    if (previous === 38 && character2 === 12) {
      points[index2] = 1;
    }
    if (token(character2)) {
      break;
    }
    next();
  }
  return slice$2(begin, position$1);
};
var toRules = function toRules2(parsed, points) {
  var index2 = -1;
  var character2 = 44;
  do {
    switch (token(character2)) {
      case 0:
        if (character2 === 38 && peek() === 12) {
          points[index2] = 1;
        }
        parsed[index2] += identifierWithPointTracking(position$1 - 1, points, index2);
        break;
      case 2:
        parsed[index2] += delimit(character2);
        break;
      case 4:
        if (character2 === 44) {
          parsed[++index2] = peek() === 58 ? "&\f" : "";
          points[index2] = parsed[index2].length;
          break;
        }
      default:
        parsed[index2] += from(character2);
    }
  } while (character2 = next());
  return parsed;
};
var getRules = function getRules2(value, points) {
  return dealloc(toRules(alloc(value), points));
};
var fixedElements = /* @__PURE__ */ new WeakMap();
var compat = function compat2(element) {
  if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  element.length < 1) {
    return;
  }
  var value = element.value, parent2 = element.parent;
  var isImplicitRule = element.column === parent2.column && element.line === parent2.line;
  while (parent2.type !== "rule") {
    parent2 = parent2.parent;
    if (!parent2)
      return;
  }
  if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent2)) {
    return;
  }
  if (isImplicitRule) {
    return;
  }
  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent2.props;
  for (var i2 = 0, k3 = 0; i2 < rules.length; i2++) {
    for (var j = 0; j < parentRules.length; j++, k3++) {
      element.props[k3] = points[i2] ? rules[i2].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i2];
    }
  }
};
var removeLabel = function removeLabel2(element) {
  if (element.type === "decl") {
    var value = element.value;
    if (
      // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98
    ) {
      element["return"] = "";
      element.value = "";
    }
  }
};
var ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var isIgnoringComment = function isIgnoringComment2(element) {
  return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
};
var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm2(cache2) {
  return function(element, index2, children2) {
    if (element.type !== "rule" || cache2.compat)
      return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
    if (unsafePseudoClasses) {
      var isNested = !!element.parent;
      var commentContainer = isNested ? element.parent.children : (
        // global rule at the root level
        children2
      );
      for (var i2 = commentContainer.length - 1; i2 >= 0; i2--) {
        var node2 = commentContainer[i2];
        if (node2.line < element.line) {
          break;
        }
        if (node2.column < element.column) {
          if (isIgnoringComment(node2)) {
            return;
          }
          break;
        }
      }
      unsafePseudoClasses.forEach(function(unsafePseudoClass) {
        console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
      });
    }
  };
};
var isImportRule = function isImportRule2(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var isPrependedWithRegularRules = function isPrependedWithRegularRules2(index2, children2) {
  for (var i2 = index2 - 1; i2 >= 0; i2--) {
    if (!isImportRule(children2[i2])) {
      return true;
    }
  }
  return false;
};
var nullifyElement = function nullifyElement2(element) {
  element.type = "";
  element.value = "";
  element["return"] = "";
  element.children = "";
  element.props = "";
};
var incorrectImportAlarm = function incorrectImportAlarm2(element, index2, children2) {
  if (!isImportRule(element)) {
    return;
  }
  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index2, children2)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};
function prefix$1(value, length2) {
  switch (hash$2(value, length2)) {
    case 5103:
      return WEBKIT + "print-" + value + value;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + value + value;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + value + MOZ + value + MS + value + value;
    case 6828:
    case 4268:
      return WEBKIT + value + MS + value + value;
    case 6165:
      return WEBKIT + value + MS + "flex-" + value + value;
    case 5187:
      return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
    case 5443:
      return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
    case 4675:
      return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
    case 5548:
      return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
    case 5292:
      return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
    case 6060:
      return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
    case 4554:
      return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
    case 6187:
      return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
    case 5495:
    case 3959:
      return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(value) - 1 - length2 > 6)
        switch (charat(value, length2 + 1)) {
          case 109:
            if (charat(value, length2 + 4) !== 45)
              break;
          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
          case 115:
            return ~indexof(value, "stretch") ? prefix$1(replace(value, "stretch", "fill-available"), length2) + value : value;
        }
      break;
    case 4949:
      if (charat(value, length2 + 1) !== 115)
        break;
    case 6444:
      switch (charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))) {
        case 107:
          return replace(value, ":", ":" + WEBKIT) + value;
        case 101:
          return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
      }
      break;
    case 5936:
      switch (charat(value, length2 + 11)) {
        case 114:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
        case 108:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
        case 45:
          return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
      }
      return WEBKIT + value + MS + value + value;
  }
  return value;
}
var prefixer = function prefixer2(element, index2, children2, callback) {
  if (element.length > -1) {
    if (!element["return"])
      switch (element.type) {
        case DECLARATION:
          element["return"] = prefix$1(element.value, element.length);
          break;
        case KEYFRAMES:
          return serialize$7([copy$2(element, {
            value: replace(element.value, "@", "@" + WEBKIT)
          })], callback);
        case RULESET:
          if (element.length)
            return combine(element.props, function(value) {
              switch (match$2(value, /(::plac\w+|:read-\w+)/)) {
                case ":read-only":
                case ":read-write":
                  return serialize$7([copy$2(element, {
                    props: [replace(value, /:(read-\w+)/, ":" + MOZ + "$1")]
                  })], callback);
                case "::placeholder":
                  return serialize$7([copy$2(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
                  }), copy$2(element, {
                    props: [replace(value, /:(plac\w+)/, ":" + MOZ + "$1")]
                  }), copy$2(element, {
                    props: [replace(value, /:(plac\w+)/, MS + "input-$1")]
                  })], callback);
              }
              return "";
            });
      }
  }
};
var defaultStylisPlugins = [prefixer];
var createCache = function createCache2(options2) {
  var key = options2.key;
  if (process.env.NODE_ENV !== "production" && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
  }
  if (key === "css") {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(ssrStyles, function(node2) {
      var dataEmotionAttribute = node2.getAttribute("data-emotion");
      if (dataEmotionAttribute.indexOf(" ") === -1) {
        return;
      }
      document.head.appendChild(node2);
      node2.setAttribute("data-s", "");
    });
  }
  var stylisPlugins = options2.stylisPlugins || defaultStylisPlugins;
  if (process.env.NODE_ENV !== "production") {
    if (/[^a-z-]/.test(key)) {
      throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    }
  }
  var inserted = {};
  var container2;
  var nodesToHydrate = [];
  {
    container2 = options2.container || document.head;
    Array.prototype.forEach.call(
      // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll('style[data-emotion^="' + key + ' "]'),
      function(node2) {
        var attrib = node2.getAttribute("data-emotion").split(" ");
        for (var i2 = 1; i2 < attrib.length; i2++) {
          inserted[attrib[i2]] = true;
        }
        nodesToHydrate.push(node2);
      }
    );
  }
  var _insert;
  var omnipresentPlugins = [compat, removeLabel];
  if (process.env.NODE_ENV !== "production") {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache2.compat;
      }
    }), incorrectImportAlarm);
  }
  {
    var currentSheet;
    var finalizingPlugins = [stringify$2, process.env.NODE_ENV !== "production" ? function(element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== COMMENT) {
          currentSheet.insert(element.value + "{}");
        }
      }
    } : rulesheet(function(rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis2(styles2) {
      return serialize$7(compile(styles2), serializer);
    };
    _insert = function insert(selector, serialized, sheet2, shouldCache) {
      currentSheet = sheet2;
      if (process.env.NODE_ENV !== "production" && serialized.map !== void 0) {
        currentSheet = {
          insert: function insert2(rule) {
            sheet2.insert(rule + serialized.map);
          }
        };
      }
      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      if (shouldCache) {
        cache2.inserted[serialized.name] = true;
      }
    };
  }
  var cache2 = {
    key,
    sheet: new StyleSheet({
      key,
      container: container2,
      nonce: options2.nonce,
      speedy: options2.speedy,
      prepend: options2.prepend,
      insertionPoint: options2.insertionPoint
    }),
    nonce: options2.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  cache2.sheet.hydrate(nodesToHydrate);
  return cache2;
};
function _extends$9() {
  _extends$9 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$9.apply(this, arguments);
}
var reactIs$3 = { exports: {} };
var reactIs_production_min$2 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$2;
function requireReactIs_production_min$2() {
  if (hasRequiredReactIs_production_min$2)
    return reactIs_production_min$2;
  hasRequiredReactIs_production_min$2 = 1;
  var b10 = "function" === typeof Symbol && Symbol.for, c7 = b10 ? Symbol.for("react.element") : 60103, d3 = b10 ? Symbol.for("react.portal") : 60106, e3 = b10 ? Symbol.for("react.fragment") : 60107, f = b10 ? Symbol.for("react.strict_mode") : 60108, g2 = b10 ? Symbol.for("react.profiler") : 60114, h3 = b10 ? Symbol.for("react.provider") : 60109, k3 = b10 ? Symbol.for("react.context") : 60110, l = b10 ? Symbol.for("react.async_mode") : 60111, m3 = b10 ? Symbol.for("react.concurrent_mode") : 60111, n = b10 ? Symbol.for("react.forward_ref") : 60112, p = b10 ? Symbol.for("react.suspense") : 60113, q2 = b10 ? Symbol.for("react.suspense_list") : 60120, r = b10 ? Symbol.for("react.memo") : 60115, t2 = b10 ? Symbol.for("react.lazy") : 60116, v = b10 ? Symbol.for("react.block") : 60121, w2 = b10 ? Symbol.for("react.fundamental") : 60117, x3 = b10 ? Symbol.for("react.responder") : 60118, y4 = b10 ? Symbol.for("react.scope") : 60119;
  function z2(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var u2 = a4.$$typeof;
      switch (u2) {
        case c7:
          switch (a4 = a4.type, a4) {
            case l:
            case m3:
            case e3:
            case g2:
            case f:
            case p:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case n:
                case t2:
                case r:
                case h3:
                  return a4;
                default:
                  return u2;
              }
          }
        case d3:
          return u2;
      }
    }
  }
  function A(a4) {
    return z2(a4) === m3;
  }
  reactIs_production_min$2.AsyncMode = l;
  reactIs_production_min$2.ConcurrentMode = m3;
  reactIs_production_min$2.ContextConsumer = k3;
  reactIs_production_min$2.ContextProvider = h3;
  reactIs_production_min$2.Element = c7;
  reactIs_production_min$2.ForwardRef = n;
  reactIs_production_min$2.Fragment = e3;
  reactIs_production_min$2.Lazy = t2;
  reactIs_production_min$2.Memo = r;
  reactIs_production_min$2.Portal = d3;
  reactIs_production_min$2.Profiler = g2;
  reactIs_production_min$2.StrictMode = f;
  reactIs_production_min$2.Suspense = p;
  reactIs_production_min$2.isAsyncMode = function(a4) {
    return A(a4) || z2(a4) === l;
  };
  reactIs_production_min$2.isConcurrentMode = A;
  reactIs_production_min$2.isContextConsumer = function(a4) {
    return z2(a4) === k3;
  };
  reactIs_production_min$2.isContextProvider = function(a4) {
    return z2(a4) === h3;
  };
  reactIs_production_min$2.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === c7;
  };
  reactIs_production_min$2.isForwardRef = function(a4) {
    return z2(a4) === n;
  };
  reactIs_production_min$2.isFragment = function(a4) {
    return z2(a4) === e3;
  };
  reactIs_production_min$2.isLazy = function(a4) {
    return z2(a4) === t2;
  };
  reactIs_production_min$2.isMemo = function(a4) {
    return z2(a4) === r;
  };
  reactIs_production_min$2.isPortal = function(a4) {
    return z2(a4) === d3;
  };
  reactIs_production_min$2.isProfiler = function(a4) {
    return z2(a4) === g2;
  };
  reactIs_production_min$2.isStrictMode = function(a4) {
    return z2(a4) === f;
  };
  reactIs_production_min$2.isSuspense = function(a4) {
    return z2(a4) === p;
  };
  reactIs_production_min$2.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === e3 || a4 === m3 || a4 === g2 || a4 === f || a4 === p || a4 === q2 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t2 || a4.$$typeof === r || a4.$$typeof === h3 || a4.$$typeof === k3 || a4.$$typeof === n || a4.$$typeof === w2 || a4.$$typeof === x3 || a4.$$typeof === y4 || a4.$$typeof === v);
  };
  reactIs_production_min$2.typeOf = z2;
  return reactIs_production_min$2;
}
var reactIs_development$2 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  if (hasRequiredReactIs_development$2)
    return reactIs_development$2;
  hasRequiredReactIs_development$2 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE2 = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE2:
              var type2 = object2.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE2;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE2;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$2.AsyncMode = AsyncMode;
      reactIs_development$2.ConcurrentMode = ConcurrentMode;
      reactIs_development$2.ContextConsumer = ContextConsumer;
      reactIs_development$2.ContextProvider = ContextProvider;
      reactIs_development$2.Element = Element2;
      reactIs_development$2.ForwardRef = ForwardRef;
      reactIs_development$2.Fragment = Fragment2;
      reactIs_development$2.Lazy = Lazy;
      reactIs_development$2.Memo = Memo;
      reactIs_development$2.Portal = Portal2;
      reactIs_development$2.Profiler = Profiler;
      reactIs_development$2.StrictMode = StrictMode;
      reactIs_development$2.Suspense = Suspense;
      reactIs_development$2.isAsyncMode = isAsyncMode;
      reactIs_development$2.isConcurrentMode = isConcurrentMode;
      reactIs_development$2.isContextConsumer = isContextConsumer;
      reactIs_development$2.isContextProvider = isContextProvider;
      reactIs_development$2.isElement = isElement2;
      reactIs_development$2.isForwardRef = isForwardRef;
      reactIs_development$2.isFragment = isFragment;
      reactIs_development$2.isLazy = isLazy;
      reactIs_development$2.isMemo = isMemo;
      reactIs_development$2.isPortal = isPortal;
      reactIs_development$2.isProfiler = isProfiler;
      reactIs_development$2.isStrictMode = isStrictMode;
      reactIs_development$2.isSuspense = isSuspense;
      reactIs_development$2.isValidElementType = isValidElementType;
      reactIs_development$2.typeOf = typeOf;
    })();
  }
  return reactIs_development$2;
}
if (process.env.NODE_ENV === "production") {
  reactIs$3.exports = requireReactIs_production_min$2();
} else {
  reactIs$3.exports = requireReactIs_development$2();
}
var reactIsExports$1 = reactIs$3.exports;
var reactIs$2 = reactIsExports$1;
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;
var isBrowser$2 = true;
function getRegisteredStyles(registered, registeredStyles, classNames2) {
  var rawClassName = "";
  classNames2.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var registerStyles = function registerStyles2(cache2, serialized, isStringTag) {
  var className = cache2.key + "-" + serialized.name;
  if (
    // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$2 === false) && cache2.registered[className] === void 0
  ) {
    cache2.registered[className] = serialized.styles;
  }
};
var insertStyles = function insertStyles2(cache2, serialized, isStringTag) {
  registerStyles(cache2, serialized, isStringTag);
  var className = cache2.key + "-" + serialized.name;
  if (cache2.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache2.insert(serialized === current ? "." + className : "", current, cache2.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h3 = 0;
  var k3, i2 = 0, len = str.length;
  for (; len >= 4; ++i2, len -= 4) {
    k3 = str.charCodeAt(i2) & 255 | (str.charCodeAt(++i2) & 255) << 8 | (str.charCodeAt(++i2) & 255) << 16 | (str.charCodeAt(++i2) & 255) << 24;
    k3 = /* Math.imul(k, m): */
    (k3 & 65535) * 1540483477 + ((k3 >>> 16) * 59797 << 16);
    k3 ^= /* k >>> r: */
    k3 >>> 24;
    h3 = /* Math.imul(k, m): */
    (k3 & 65535) * 1540483477 + ((k3 >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h3 & 65535) * 1540483477 + ((h3 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h3 ^= (str.charCodeAt(i2 + 2) & 255) << 16;
    case 2:
      h3 ^= (str.charCodeAt(i2 + 1) & 255) << 8;
    case 1:
      h3 ^= str.charCodeAt(i2) & 255;
      h3 = /* Math.imul(h, m): */
      (h3 & 65535) * 1540483477 + ((h3 >>> 16) * 59797 << 16);
  }
  h3 ^= h3 >>> 13;
  h3 = /* Math.imul(h, m): */
  (h3 & 65535) * 1540483477 + ((h3 >>> 16) * 59797 << 16);
  return ((h3 ^ h3 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR$1 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property2) {
  return property2.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = /* @__PURE__ */ memoize$4(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key, value) {
  switch (key) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match2, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
if (process.env.NODE_ENV !== "production") {
  var contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ["normal", "none", "initial", "inherit", "unset"];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};
  processStyleValue = function processStyleValue3(key, value) {
    if (key === "content") {
      if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }
    var processed = oldProcessStyleValue(key, value);
    if (processed !== "" && !isCustomProperty(key) && key.indexOf("-") !== -1 && hyphenatedCache[key] === void 0) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }
    return processed;
  };
}
var noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && interpolation.toString() === "NO_COMPONENT_SELECTOR") {
      throw new Error(noComponentSelectorMessage);
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next2 = interpolation.next;
        if (next2 !== void 0) {
          while (next2 !== void 0) {
            cursor = {
              name: next2.name,
              styles: next2.styles,
              next: cursor
            };
            next2 = next2.next;
          }
        }
        var styles2 = interpolation.styles + ";";
        if (process.env.NODE_ENV !== "production" && interpolation.map !== void 0) {
          styles2 += interpolation.map;
        }
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result);
      } else if (process.env.NODE_ENV !== "production") {
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      }
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function(match2, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, ["`" + replaced + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
        }
      }
      break;
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string2 = "";
  if (Array.isArray(obj)) {
    for (var i2 = 0; i2 < obj.length; i2++) {
      string2 += handleInterpolation(mergedProps, registered, obj[i2]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string2 += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string2 += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production") {
          throw new Error(noComponentSelectorMessage);
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string2 += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);
          switch (_key) {
            case "animation":
            case "animationName": {
              string2 += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              if (process.env.NODE_ENV !== "production" && _key === "undefined") {
                console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
              }
              string2 += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string2;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;
if (process.env.NODE_ENV !== "production") {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
}
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings);
  } else {
    if (process.env.NODE_ENV !== "production" && strings[0] === void 0) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
    }
    styles2 += strings[0];
  }
  for (var i2 = 1; i2 < args.length; i2++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i2]);
    if (stringMode) {
      if (process.env.NODE_ENV !== "production" && strings[i2] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR$1);
      }
      styles2 += strings[i2];
    }
  }
  var sourceMap;
  if (process.env.NODE_ENV !== "production") {
    styles2 = styles2.replace(sourceMapPattern, function(match3) {
      sourceMap = match3;
      return "";
    });
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match2;
  while ((match2 = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + // $FlowFixMe we know it's not null
    match2[1];
  }
  var name2 = murmur2(styles2) + identifierName;
  if (process.env.NODE_ENV !== "production") {
    return {
      name: name2,
      styles: styles2,
      map: sourceMap,
      next: cursor,
      toString: function toString3() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }
  return {
    name: name2,
    styles: styles2,
    next: cursor
  };
};
var syncFallback = function syncFallback2(create2) {
  return create2();
};
var useInsertionEffect = React["useInsertion" + "Effect"] ? React["useInsertion" + "Effect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || React.useLayoutEffect;
var hasOwn$3 = {}.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ React.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== "undefined" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
if (process.env.NODE_ENV !== "production") {
  EmotionCacheContext.displayName = "EmotionCacheContext";
}
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  return /* @__PURE__ */ forwardRef(function(props2, ref2) {
    var cache2 = useContext(EmotionCacheContext);
    return func(props2, cache2, ref2);
  });
};
var ThemeContext = /* @__PURE__ */ React.createContext({});
if (process.env.NODE_ENV !== "production") {
  ThemeContext.displayName = "EmotionThemeContext";
}
var getLastPart = function getLastPart2(functionName) {
  var parts = functionName.split(".");
  return parts[parts.length - 1];
};
var getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine2(line2) {
  var match2 = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line2);
  if (match2)
    return getLastPart(match2[1]);
  match2 = /^([A-Za-z0-9$.]+)@/.exec(line2);
  if (match2)
    return getLastPart(match2[1]);
  return void 0;
};
var internalReactFunctionNames = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]);
var sanitizeIdentifier = function sanitizeIdentifier2(identifier2) {
  return identifier2.replace(/\$/g, "-");
};
var getLabelFromStackTrace = function getLabelFromStackTrace2(stackTrace) {
  if (!stackTrace)
    return void 0;
  var lines = stackTrace.split("\n");
  for (var i2 = 0; i2 < lines.length; i2++) {
    var functionName = getFunctionNameFromStackTraceLine(lines[i2]);
    if (!functionName)
      continue;
    if (internalReactFunctionNames.has(functionName))
      break;
    if (/^[A-Z]/.test(functionName))
      return sanitizeIdentifier(functionName);
  }
  return void 0;
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type2, props2) {
  if (process.env.NODE_ENV !== "production" && typeof props2.css === "string" && // check if there is a css declaration
  props2.css.indexOf(":") !== -1) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props2.css + "`");
  }
  var newProps = {};
  for (var key in props2) {
    if (hasOwn$3.call(props2, key)) {
      newProps[key] = props2[key];
    }
  }
  newProps[typePropName] = type2;
  if (process.env.NODE_ENV !== "production" && !!props2.css && (typeof props2.css !== "object" || typeof props2.css.name !== "string" || props2.css.name.indexOf("-") === -1)) {
    var label2 = getLabelFromStackTrace(new Error().stack);
    if (label2)
      newProps[labelPropName] = label2;
  }
  return newProps;
};
var Insertion$2 = function Insertion(_ref2) {
  var cache2 = _ref2.cache, serialized = _ref2.serialized, isStringTag = _ref2.isStringTag;
  registerStyles(cache2, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag);
  });
  return null;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props2, cache2, ref2) {
  var cssProp = props2.css;
  if (typeof cssProp === "string" && cache2.registered[cssProp] !== void 0) {
    cssProp = cache2.registered[cssProp];
  }
  var WrappedComponent = props2[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props2.className === "string") {
    className = getRegisteredStyles(cache2.registered, registeredStyles, props2.className);
  } else if (props2.className != null) {
    className = props2.className + " ";
  }
  var serialized = serializeStyles(registeredStyles, void 0, React.useContext(ThemeContext));
  if (process.env.NODE_ENV !== "production" && serialized.name.indexOf("-") === -1) {
    var labelFromStack = props2[labelPropName];
    if (labelFromStack) {
      serialized = serializeStyles([serialized, "label:" + labelFromStack + ";"]);
    }
  }
  className += cache2.key + "-" + serialized.name;
  var newProps = {};
  for (var key in props2) {
    if (hasOwn$3.call(props2, key) && key !== "css" && key !== typePropName && (process.env.NODE_ENV === "production" || key !== labelPropName)) {
      newProps[key] = props2[key];
    }
  }
  newProps.ref = ref2;
  newProps.className = className;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$2, {
    cache: cache2,
    serialized,
    isStringTag: typeof WrappedComponent === "string"
  }), /* @__PURE__ */ React.createElement(WrappedComponent, newProps));
});
if (process.env.NODE_ENV !== "production") {
  Emotion.displayName = "EmotionCssPropInternal";
}
var Emotion$1 = Emotion;
var pkg = {
  name: "@emotion/react",
  version: "11.11.4",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        "default": "./dist/emotion-react.esm.js"
      },
      "import": "./dist/emotion-react.cjs.mjs",
      "default": "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
      "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
      "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
      "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": {
      types: {
        "import": "./macro.d.mts",
        "default": "./macro.d.ts"
      },
      "default": "./macro.js"
    }
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.*"
  ],
  sideEffects: false,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.11.0",
    "@emotion/cache": "^11.11.0",
    "@emotion/serialize": "^1.1.3",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
    "@emotion/utils": "^1.2.1",
    "@emotion/weak-memoize": "^0.3.1",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: true
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.11.2",
    "@emotion/css-prettifier": "1.1.3",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
          types: {
            "import": "./macro.d.mts",
            "default": "./macro.d.ts"
          },
          "default": "./macro.js"
        }
      }
    }
  }
};
var jsx$3 = function jsx(type2, props2) {
  var args = arguments;
  if (props2 == null || !hasOwn$3.call(props2, "css")) {
    return React.createElement.apply(void 0, args);
  }
  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion$1;
  createElementArgArray[1] = createEmotionProps(type2, props2);
  for (var i2 = 2; i2 < argsLength; i2++) {
    createElementArgArray[i2] = args[i2];
  }
  return React.createElement.apply(null, createElementArgArray);
};
var warnedAboutCssPropForGlobal = false;
var Global = /* @__PURE__ */ withEmotionCache(function(props2, cache2) {
  if (process.env.NODE_ENV !== "production" && !warnedAboutCssPropForGlobal && // check for className as well since the user is
  // probably using the custom createElement which
  // means it will be turned into a className prop
  // $FlowFixMe I don't really want to add it to the type since it shouldn't be used
  (props2.className || props2.css)) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }
  var styles2 = props2.styles;
  var serialized = serializeStyles([styles2], void 0, React.useContext(ThemeContext));
  var sheetRef = React.useRef();
  useInsertionEffectWithLayoutFallback(function() {
    var key = cache2.key + "-global";
    var sheet2 = new cache2.sheet.constructor({
      key,
      nonce: cache2.sheet.nonce,
      container: cache2.sheet.container,
      speedy: cache2.sheet.isSpeedy
    });
    var rehydrating = false;
    var node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
    if (cache2.sheet.tags.length) {
      sheet2.before = cache2.sheet.tags[0];
    }
    if (node2 !== null) {
      rehydrating = true;
      node2.setAttribute("data-emotion", key);
      sheet2.hydrate([node2]);
    }
    sheetRef.current = [sheet2, rehydrating];
    return function() {
      sheet2.flush();
    };
  }, [cache2]);
  useInsertionEffectWithLayoutFallback(function() {
    var sheetRefCurrent = sheetRef.current;
    var sheet2 = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }
    if (serialized.next !== void 0) {
      insertStyles(cache2, serialized.next, true);
    }
    if (sheet2.tags.length) {
      var element = sheet2.tags[sheet2.tags.length - 1].nextElementSibling;
      sheet2.before = element;
      sheet2.flush();
    }
    cache2.insert("", serialized, sheet2, false);
  }, [cache2, serialized.name]);
  return null;
});
if (process.env.NODE_ENV !== "production") {
  Global.displayName = "EmotionGlobal";
}
function css$2() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return serializeStyles(args);
}
var keyframes$1 = function keyframes() {
  var insertable = css$2.apply(void 0, arguments);
  var name2 = "animation-" + insertable.name;
  return {
    name: name2,
    styles: "@keyframes " + name2 + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString3() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};
var classnames$1 = function classnames(args) {
  var len = args.length;
  var i2 = 0;
  var cls = "";
  for (; i2 < len; i2++) {
    var arg = args[i2];
    if (arg == null)
      continue;
    var toAdd = void 0;
    switch (typeof arg) {
      case "boolean":
        break;
      case "object": {
        if (Array.isArray(arg)) {
          toAdd = classnames(arg);
        } else {
          if (process.env.NODE_ENV !== "production" && arg.styles !== void 0 && arg.name !== void 0) {
            console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component.");
          }
          toAdd = "";
          for (var k3 in arg) {
            if (arg[k3] && k3) {
              toAdd && (toAdd += " ");
              toAdd += k3;
            }
          }
        }
        break;
      }
      default: {
        toAdd = arg;
      }
    }
    if (toAdd) {
      cls && (cls += " ");
      cls += toAdd;
    }
  }
  return cls;
};
function merge$3(registered, css3, className) {
  var registeredStyles = [];
  var rawClassName = getRegisteredStyles(registered, registeredStyles, className);
  if (registeredStyles.length < 2) {
    return className;
  }
  return rawClassName + css3(registeredStyles);
}
var Insertion$1 = function Insertion2(_ref2) {
  var cache2 = _ref2.cache, serializedArr = _ref2.serializedArr;
  useInsertionEffectAlwaysWithSyncFallback(function() {
    for (var i2 = 0; i2 < serializedArr.length; i2++) {
      insertStyles(cache2, serializedArr[i2], false);
    }
  });
  return null;
};
var ClassNames = /* @__PURE__ */ withEmotionCache(function(props2, cache2) {
  var hasRendered = false;
  var serializedArr = [];
  var css3 = function css4() {
    if (hasRendered && process.env.NODE_ENV !== "production") {
      throw new Error("css can only be used during render");
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var serialized = serializeStyles(args, cache2.registered);
    serializedArr.push(serialized);
    registerStyles(cache2, serialized, false);
    return cache2.key + "-" + serialized.name;
  };
  var cx = function cx2() {
    if (hasRendered && process.env.NODE_ENV !== "production") {
      throw new Error("cx can only be used during render");
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return merge$3(cache2.registered, css3, classnames$1(args));
  };
  var content2 = {
    css: css3,
    cx,
    theme: React.useContext(ThemeContext)
  };
  var ele = props2.children(content2);
  hasRendered = true;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion$1, {
    cache: cache2,
    serializedArr
  }), ele);
});
if (process.env.NODE_ENV !== "production") {
  ClassNames.displayName = "EmotionClassNames";
}
if (process.env.NODE_ENV !== "production") {
  var isBrowser$1 = true;
  var isTestEnv = typeof jest !== "undefined" || typeof vi !== "undefined";
  if (isBrowser$1 && !isTestEnv) {
    var globalContext = (
      // $FlowIgnore
      typeof globalThis !== "undefined" ? globalThis : isBrowser$1 ? window : global
    );
    var globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__";
    if (globalContext[globalKey]) {
      console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used.");
    }
    globalContext[globalKey] = true;
  }
}
var isMergeableObject$1 = function isMergeableObject(value) {
  return isNonNullObject$1(value) && !isSpecial$1(value);
};
function isNonNullObject$1(value) {
  return !!value && typeof value === "object";
}
function isSpecial$1(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement$2(value);
}
var canUseSymbol$2 = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE$1 = canUseSymbol$2 ? Symbol.for("react.element") : 60103;
function isReactElement$2(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE$1;
}
function emptyTarget$1(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified$1(value, options2) {
  return options2.clone !== false && options2.isMergeableObject(value) ? deepmerge$1(emptyTarget$1(value), value, options2) : value;
}
function defaultArrayMerge$1(target, source, options2) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified$1(element, options2);
  });
}
function getMergeFunction(key, options2) {
  if (!options2.customMerge) {
    return deepmerge$1;
  }
  var customMerge = options2.customMerge(key);
  return typeof customMerge === "function" ? customMerge : deepmerge$1;
}
function getEnumerableOwnPropertySymbols(target) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
    return Object.propertyIsEnumerable.call(target, symbol);
  }) : [];
}
function getKeys$1(target) {
  return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object2, property2) {
  try {
    return property2 in object2;
  } catch (_) {
    return false;
  }
}
function propertyIsUnsafe(target, key) {
  return propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}
function mergeObject$1(target, source, options2) {
  var destination = {};
  if (options2.isMergeableObject(target)) {
    getKeys$1(target).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified$1(target[key], options2);
    });
  }
  getKeys$1(source).forEach(function(key) {
    if (propertyIsUnsafe(target, key)) {
      return;
    }
    if (propertyIsOnObject(target, key) && options2.isMergeableObject(source[key])) {
      destination[key] = getMergeFunction(key, options2)(target[key], source[key], options2);
    } else {
      destination[key] = cloneUnlessOtherwiseSpecified$1(source[key], options2);
    }
  });
  return destination;
}
function deepmerge$1(target, source, options2) {
  options2 = options2 || {};
  options2.arrayMerge = options2.arrayMerge || defaultArrayMerge$1;
  options2.isMergeableObject = options2.isMergeableObject || isMergeableObject$1;
  options2.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified$1;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified$1(source, options2);
  } else if (sourceIsArray) {
    return options2.arrayMerge(target, source, options2);
  } else {
    return mergeObject$1(target, source, options2);
  }
}
deepmerge$1.all = function deepmergeAll(array2, options2) {
  if (!Array.isArray(array2)) {
    throw new Error("first argument should be an array");
  }
  return array2.reduce(function(prev2, next2) {
    return deepmerge$1(prev2, next2, options2);
  }, {});
};
var deepmerge_1$1 = deepmerge$1;
var cjs = deepmerge_1$1;
const deepmerge$2 = /* @__PURE__ */ getDefaultExportFromCjs(cjs);
const name = "@emotion/react";
const version = "11.11.4";
const main$2 = "dist/emotion-react.cjs.js";
const module$1 = "dist/emotion-react.esm.js";
const browser$1 = {
  "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
};
const exports$1 = {
  ".": {
    module: {
      worker: "./dist/emotion-react.worker.esm.js",
      browser: "./dist/emotion-react.browser.esm.js",
      "default": "./dist/emotion-react.esm.js"
    },
    "import": "./dist/emotion-react.cjs.mjs",
    "default": "./dist/emotion-react.cjs.js"
  },
  "./jsx-runtime": {
    module: {
      worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
      browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
      "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
    },
    "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
    "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
  },
  "./_isolated-hnrs": {
    module: {
      worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
      browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
      "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
    },
    "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
    "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
  },
  "./jsx-dev-runtime": {
    module: {
      worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
      browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
      "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
    },
    "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
    "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
  },
  "./package.json": "./package.json",
  "./types/css-prop": "./types/css-prop.d.ts",
  "./macro": {
    types: {
      "import": "./macro.d.mts",
      "default": "./macro.d.ts"
    },
    "default": "./macro.js"
  }
};
const types = "types/index.d.ts";
const files = [
  "src",
  "dist",
  "jsx-runtime",
  "jsx-dev-runtime",
  "_isolated-hnrs",
  "types/*.d.ts",
  "macro.*"
];
const sideEffects = false;
const author = "Emotion Contributors";
const license = "MIT";
const scripts = {
  "test:typescript": "dtslint types"
};
const dependencies = {
  "@babel/runtime": "^7.18.3",
  "@emotion/babel-plugin": "^11.11.0",
  "@emotion/cache": "^11.11.0",
  "@emotion/serialize": "^1.1.3",
  "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
  "@emotion/utils": "^1.2.1",
  "@emotion/weak-memoize": "^0.3.1",
  "hoist-non-react-statics": "^3.3.1"
};
const peerDependencies = {
  react: ">=16.8.0"
};
const peerDependenciesMeta = {
  "@types/react": {
    optional: true
  }
};
const devDependencies = {
  "@definitelytyped/dtslint": "0.0.112",
  "@emotion/css": "11.11.2",
  "@emotion/css-prettifier": "1.1.3",
  "@emotion/server": "11.11.0",
  "@emotion/styled": "11.11.0",
  "html-tag-names": "^1.1.2",
  react: "16.14.0",
  "svg-tag-names": "^1.1.1",
  typescript: "^4.5.5"
};
const repository = "https://github.com/emotion-js/emotion/tree/main/packages/react";
const publishConfig = {
  access: "public"
};
const preconstruct = {
  entrypoints: [
    "./index.js",
    "./jsx-runtime.js",
    "./jsx-dev-runtime.js",
    "./_isolated-hnrs.js"
  ],
  umdName: "emotionReact",
  exports: {
    envConditions: [
      "browser",
      "worker"
    ],
    extra: {
      "./types/css-prop": "./types/css-prop.d.ts",
      "./macro": {
        types: {
          "import": "./macro.d.mts",
          "default": "./macro.d.ts"
        },
        "default": "./macro.js"
      }
    }
  }
};
const packageInfo = {
  name,
  version,
  main: main$2,
  module: module$1,
  browser: browser$1,
  exports: exports$1,
  types,
  files,
  sideEffects,
  author,
  license,
  scripts,
  dependencies,
  peerDependencies,
  peerDependenciesMeta,
  devDependencies,
  repository,
  publishConfig,
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct
};
const THEME_UI_DEFAULT_KEY = "__default";
const hasDefault = (x3) => {
  return typeof x3 === "object" && x3 !== null && THEME_UI_DEFAULT_KEY in x3;
};
function get$4(obj, path2, fallback, p, undef) {
  const pathArray = path2 && typeof path2 === "string" ? path2.split(".") : [path2];
  for (p = 0; p < pathArray.length; p++) {
    obj = obj ? obj[pathArray[p]] : undef;
  }
  if (obj === undef)
    return fallback;
  return hasDefault(obj) ? obj[THEME_UI_DEFAULT_KEY] : obj;
}
const getObjectWithVariants = (obj, theme2) => {
  if (obj && obj["variant"]) {
    let result = {};
    for (const key in obj) {
      const x3 = obj[key];
      if (key === "variant") {
        const val = typeof x3 === "function" ? x3(theme2) : x3;
        const variant3 = getObjectWithVariants(get$4(theme2, val), theme2);
        result = {
          ...result,
          ...variant3
        };
      } else {
        result[key] = x3;
      }
    }
    return result;
  }
  return obj;
};
const defaultBreakpoints$1 = [40, 52, 64].map((n) => n + "em");
const defaultTheme$1 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
const aliases$2 = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
const multiples$1 = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  scrollMarginX: ["scrollMarginLeft", "scrollMarginRight"],
  scrollMarginY: ["scrollMarginTop", "scrollMarginBottom"],
  scrollPaddingX: ["scrollPaddingLeft", "scrollPaddingRight"],
  scrollPaddingY: ["scrollPaddingTop", "scrollPaddingBottom"],
  size: ["width", "height"]
};
const scales$1 = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  caretColor: "colors",
  columnRuleColor: "colors",
  textDecorationColor: "colors",
  opacity: "opacities",
  transition: "transitions",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  marginBlock: "space",
  marginBlockEnd: "space",
  marginBlockStart: "space",
  marginInline: "space",
  marginInlineEnd: "space",
  marginInlineStart: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  paddingBlock: "space",
  paddingBlockEnd: "space",
  paddingBlockStart: "space",
  paddingInline: "space",
  paddingInlineEnd: "space",
  paddingInlineStart: "space",
  scrollMargin: "space",
  scrollMarginTop: "space",
  scrollMarginRight: "space",
  scrollMarginBottom: "space",
  scrollMarginLeft: "space",
  scrollMarginX: "space",
  scrollMarginY: "space",
  scrollPadding: "space",
  scrollPaddingTop: "space",
  scrollPaddingRight: "space",
  scrollPaddingBottom: "space",
  scrollPaddingLeft: "space",
  scrollPaddingX: "space",
  scrollPaddingY: "space",
  inset: "space",
  insetBlock: "space",
  insetBlockEnd: "space",
  insetBlockStart: "space",
  insetInline: "space",
  insetInlineEnd: "space",
  insetInlineStart: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  borderBlock: "borders",
  borderBlockColor: "colors",
  borderBlockEnd: "borders",
  borderBlockEndColor: "colors",
  borderBlockEndStyle: "borderStyles",
  borderBlockEndWidth: "borderWidths",
  borderBlockStart: "borders",
  borderBlockStartColor: "colors",
  borderBlockStartStyle: "borderStyles",
  borderBlockStartWidth: "borderWidths",
  borderBlockStyle: "borderStyles",
  borderBlockWidth: "borderWidths",
  borderEndEndRadius: "radii",
  borderEndStartRadius: "radii",
  borderInline: "borders",
  borderInlineColor: "colors",
  borderInlineEnd: "borders",
  borderInlineEndColor: "colors",
  borderInlineEndStyle: "borderStyles",
  borderInlineEndWidth: "borderWidths",
  borderInlineStart: "borders",
  borderInlineStartColor: "colors",
  borderInlineStartStyle: "borderStyles",
  borderInlineStartWidth: "borderWidths",
  borderInlineStyle: "borderStyles",
  borderInlineWidth: "borderWidths",
  borderStartEndRadius: "radii",
  borderStartStartRadius: "radii",
  columnRuleWidth: "borderWidths",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  blockSize: "sizes",
  inlineSize: "sizes",
  maxBlockSize: "sizes",
  maxInlineSize: "sizes",
  minBlockSize: "sizes",
  minInlineSize: "sizes",
  columnWidth: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};
const positiveOrNegative$1 = (scale, value) => {
  if (typeof value !== "number" || value >= 0) {
    if (typeof value === "string" && value.startsWith("-")) {
      const valueWithoutMinus = value.substring(1);
      const n2 = get$4(scale, valueWithoutMinus, valueWithoutMinus);
      if (typeof n2 === "number") {
        return n2 * -1;
      }
      return `-${n2}`;
    }
    return get$4(scale, value, value);
  }
  const absolute = Math.abs(value);
  const n = get$4(scale, absolute, absolute);
  if (typeof n === "string")
    return "-" + n;
  return Number(n) * -1;
};
const transforms$1 = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginBlock", "marginBlockEnd", "marginBlockStart", "marginInline", "marginInlineEnd", "marginInlineStart", "top", "bottom", "left", "right"].reduce((acc, curr) => ({
  ...acc,
  [curr]: positiveOrNegative$1
}), {});
const responsive$1 = (styles2) => (theme2) => {
  const next2 = {};
  const breakpoints2 = theme2 && theme2.breakpoints || defaultBreakpoints$1;
  const mediaQueries2 = [null, ...breakpoints2.map((n) => n.includes("@media") ? n : `@media screen and (min-width: ${n})`)];
  for (const k3 in styles2) {
    const key = k3;
    let value = styles2[key];
    if (typeof value === "function") {
      value = value(theme2 || {});
    }
    if (value === false || value == null) {
      continue;
    }
    if (!Array.isArray(value)) {
      next2[key] = value;
      continue;
    }
    for (let i2 = 0; i2 < value.slice(0, mediaQueries2.length).length; i2++) {
      const media = mediaQueries2[i2];
      if (!media) {
        next2[key] = value[i2];
        continue;
      }
      next2[media] = next2[media] || {};
      if (value[i2] == null)
        continue;
      next2[media][key] = value[i2];
    }
  }
  return next2;
};
const css$1 = (args = {}) => (props2 = {}) => {
  const theme2 = {
    ...defaultTheme$1,
    ..."theme" in props2 ? props2.theme : props2
  };
  const obj = getObjectWithVariants(typeof args === "function" ? args(theme2) : args, theme2);
  const styles2 = responsive$1(obj)(theme2);
  let result = {};
  for (const key in styles2) {
    const x3 = styles2[key];
    const val = typeof x3 === "function" ? x3(theme2) : x3;
    if (val && typeof val === "object") {
      if (hasDefault(val)) {
        result[key] = val[THEME_UI_DEFAULT_KEY];
        continue;
      }
      result[key] = css$1(val)(theme2);
      continue;
    }
    const prop = key in aliases$2 ? aliases$2[key] : key;
    const scaleName = prop in scales$1 ? scales$1[prop] : void 0;
    const scale = scaleName ? theme2 == null ? void 0 : theme2[scaleName] : get$4(theme2, prop, {});
    const transform = get$4(transforms$1, prop, get$4);
    const value = transform(scale, val, val);
    if (prop in multiples$1) {
      const dirs = multiples$1[prop];
      for (let i2 = 0; i2 < dirs.length; i2++) {
        result[dirs[i2]] = value;
      }
    } else {
      result[prop] = value;
    }
  }
  return result;
};
const getCSS = (props2) => (theme2) => {
  const styles2 = css$1(props2.sx)(theme2);
  const raw = typeof props2.css === "function" ? props2.css(theme2) : props2.css;
  return [styles2, raw];
};
const parseProps = (props2) => {
  if (!props2 || !props2.sx && !props2.css)
    return props2;
  const next2 = {};
  for (let key in props2) {
    if (key === "sx")
      continue;
    next2[key] = props2[key];
  }
  next2.css = getCSS(props2);
  return next2;
};
const __EMOTION_VERSION__ = packageInfo.version;
const jsx$2 = (type2, props2, ...children2) => jsx$3(type2, parseProps(props2), ...children2);
const __ThemeUIContext = /* @__PURE__ */ createContext({
  __EMOTION_VERSION__,
  theme: {}
});
const useThemeUI = () => useContext(__ThemeUIContext);
const canUseSymbol$1 = typeof Symbol === "function" && Symbol.for;
const REACT_ELEMENT = canUseSymbol$1 ? Symbol.for("react.element") : 60103;
const FORWARD_REF = canUseSymbol$1 ? Symbol.for("react.forward_ref") : 60103;
const deepmergeOptions = {
  isMergeableObject: (n) => {
    return !!n && typeof n === "object" && n.$$typeof !== REACT_ELEMENT && n.$$typeof !== FORWARD_REF;
  },
  arrayMerge: (_leftArray, rightArray) => rightArray
};
const merge$2 = (a4, b10) => deepmerge$2(a4, b10, deepmergeOptions);
function mergeAll(...args) {
  return deepmerge$2.all(args, deepmergeOptions);
}
merge$2.all = mergeAll;
const __ThemeUIInternalBaseThemeProvider = ({
  context,
  children: children2
}) => jsx$2(ThemeContext.Provider, {
  value: context.theme
}, jsx$2(__ThemeUIContext.Provider, {
  value: context,
  children: children2
}));
function ThemeProvider$1({
  theme: theme2,
  children: children2
}) {
  const outer = useThemeUI();
  if (process.env.NODE_ENV !== "production") {
    if (outer.__EMOTION_VERSION__ !== __EMOTION_VERSION__) {
      console.warn("Multiple versions of Emotion detected,", "and theming might not work as expected.", "Please ensure there is only one copy of @emotion/react installed in your application.");
    }
  }
  const context = typeof theme2 === "function" ? {
    ...outer,
    theme: theme2(outer.theme)
  } : merge$2.all({}, outer, {
    theme: theme2
  });
  return jsx$2(__ThemeUIInternalBaseThemeProvider, {
    context
  }, children2);
}
const toVarName = (key) => `--theme-ui-${key.replace("-__default", "")}`;
const toVarValue = (key) => `var(${toVarName(key)})`;
const join$1 = (...args) => args.filter(Boolean).join("-");
const reservedKeys = {
  useCustomProperties: true,
  initialColorModeName: true,
  printColorModeName: true,
  initialColorMode: true,
  useLocalStorage: true
};
const toCustomProperties = (obj, parent2, themeKey) => {
  const next2 = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    const value = obj[key];
    const name2 = join$1(parent2, key);
    if (value && typeof value === "object") {
      next2[key] = toCustomProperties(value, name2);
      continue;
    }
    if (reservedKeys[key]) {
      next2[key] = value;
      continue;
    }
    next2[key] = toVarValue(name2);
  }
  return next2;
};
const objectToVars = (parent2, obj) => {
  let vars = {};
  for (let key in obj) {
    if (key === "modes")
      continue;
    const name2 = join$1(parent2, key);
    const value = obj[key];
    if (value && typeof value === "object") {
      vars = {
        ...vars,
        ...objectToVars(name2, value)
      };
    } else {
      vars[toVarName(name2)] = value;
    }
  }
  return vars;
};
const createColorStyles = (theme2 = {}) => {
  const {
    useCustomProperties,
    initialColorModeName,
    printColorModeName,
    useRootStyles
  } = theme2.config || theme2 || {};
  const colors3 = theme2.rawColors || theme2.colors;
  if (!colors3 || useRootStyles === false)
    return {};
  if (useCustomProperties === false) {
    return css$1({
      html: {
        color: "text",
        bg: "background"
      }
    })(theme2);
  }
  const modes = colors3.modes || {};
  const styles2 = objectToVars("colors", colors3);
  Object.keys(modes).forEach((mode) => {
    const key = `&.theme-ui-${mode}`;
    styles2[key] = objectToVars("colors", modes[mode]);
  });
  if (printColorModeName) {
    const mode = printColorModeName === "initial" || printColorModeName === initialColorModeName ? colors3 : modes[printColorModeName];
    styles2["@media print"] = objectToVars("colors", mode);
  }
  const colorToVarValue = (color2) => toVarValue(`colors-${color2}`);
  return css$1({
    html: {
      ...styles2,
      color: colorToVarValue("text"),
      bg: colorToVarValue("background")
    }
  })(theme2);
};
const STORAGE_KEY = "theme-ui-color-mode";
const storage = {
  get: () => {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e3) {
      console.warn("localStorage is disabled and color mode might not work as expected.", "Please check your Site Settings.", e3);
    }
  },
  set: (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e3) {
      console.warn("localStorage is disabled and color mode might not work as expected.", "Please check your Site Settings.", e3);
    }
  }
};
const getPreferredColorScheme = () => {
  if (typeof window !== "undefined" && window.matchMedia) {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      return "dark";
    }
    if (window.matchMedia("(prefers-color-scheme: light)").matches) {
      return "light";
    }
  }
  return null;
};
const getModeFromClass = () => {
  let mode;
  if (typeof document !== "undefined") {
    document.documentElement.classList.forEach((className) => {
      if (className.startsWith("theme-ui-")) {
        mode = className.replace("theme-ui-", "");
      }
    });
  }
  return mode;
};
const useColorModeState = (theme2 = {}) => {
  const {
    initialColorModeName,
    useColorSchemeMediaQuery,
    useLocalStorage
  } = theme2.config || theme2;
  let [mode, setMode] = useState(() => {
    const modeFromClass = getModeFromClass();
    if (modeFromClass) {
      return modeFromClass;
    }
    const preferredMode = useColorSchemeMediaQuery !== false && getPreferredColorScheme();
    return preferredMode || initialColorModeName;
  });
  useEffect(() => {
    const stored = useLocalStorage !== false && storage.get();
    if (typeof document !== "undefined") {
      document.documentElement.classList.remove("theme-ui-" + stored);
      document.body.classList.remove("theme-ui-" + stored);
    }
    if (stored && stored !== mode) {
      mode = stored;
      setMode(stored);
    }
  }, []);
  React__default.useEffect(() => {
    if (mode && useLocalStorage !== false) {
      storage.set(mode);
    }
  }, [mode, useLocalStorage]);
  if (process.env.NODE_ENV !== "production") {
    var _theme$colors;
    if ((_theme$colors = theme2.colors) != null && _theme$colors.modes && initialColorModeName && Object.keys(theme2.colors.modes).indexOf(initialColorModeName) > -1) {
      console.warn("[theme-ui] The `initialColorModeName` value should be a unique name and cannot reference a key in `theme.colors.modes`.");
    }
  }
  return [mode, setMode];
};
const omitModes = (colors3) => {
  const res = {
    ...colors3
  };
  delete res.modes;
  return res;
};
function copyRawColors(colors3, outerThemeRawColors) {
  for (const [key, value] of Object.entries(colors3)) {
    if (typeof value === "string" && !value.startsWith("var(")) {
      outerThemeRawColors[key] = value;
    }
    if (typeof value === "object") {
      outerThemeRawColors[key] = {
        ...outerThemeRawColors[key],
        ...copyRawColors(value, {})
      };
    }
  }
  return outerThemeRawColors;
}
const ColorModeProvider = ({
  children: children2
}) => {
  const outer = useThemeUI();
  const outerTheme = outer.theme;
  const [colorMode, setColorMode] = useColorModeState(outerTheme);
  const theme2 = useMemo(() => {
    const res = {
      ...outerTheme
    };
    const modes = get$4(res, "colors.modes", {});
    const currentColorMode = get$4(modes, colorMode, {});
    if (colorMode) {
      res.colors = {
        ...res.colors,
        ...currentColorMode
      };
    }
    const {
      useCustomProperties,
      initialColorModeName = "__default"
    } = outerTheme.config || outerTheme;
    let outerThemeRawColors = outerTheme.rawColors || outerTheme.colors || {};
    if (useCustomProperties !== false) {
      const alreadyHasRawColors = res.rawColors != null;
      const colors3 = res.colors || {};
      if (alreadyHasRawColors) {
        outerThemeRawColors = {
          ...outerThemeRawColors
        };
        copyRawColors(colors3, outerThemeRawColors);
        if ("modes" in outerThemeRawColors) {
          var _res$rawColors;
          res.rawColors = {
            ...outerThemeRawColors,
            modes: {
              ...(_res$rawColors = res.rawColors) == null ? void 0 : _res$rawColors.modes,
              [initialColorModeName]: omitModes(outerThemeRawColors)
            }
          };
        } else {
          res.rawColors = outerThemeRawColors;
        }
      } else {
        if (!("modes" in outerThemeRawColors)) {
          res.rawColors = colors3;
        } else {
          const modes2 = {
            [initialColorModeName]: omitModes(outerThemeRawColors),
            ...outerThemeRawColors.modes
          };
          res.rawColors = {
            ...colors3,
            modes: modes2
          };
        }
      }
      res.colors = toCustomProperties(omitModes(outerThemeRawColors), "colors");
    }
    return res;
  }, [colorMode, outerTheme]);
  const context = {
    ...outer,
    theme: theme2,
    colorMode,
    setColorMode
  };
  const isTopLevelColorModeProvider = outer.setColorMode === void 0;
  return jsx$2(__ThemeUIInternalBaseThemeProvider, {
    context
  }, isTopLevelColorModeProvider ? jsx$2(Global, {
    styles: () => {
      return createColorStyles(theme2);
    }
  }) : jsx$2("div", {
    className: "theme-ui__nested-color-mode-provider",
    style: createColorStyles(theme2)["html"]
  }), children2);
};
var reactPropsRegex$1 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var isPropValid = /* @__PURE__ */ memoize$4(
  function(prop) {
    return reactPropsRegex$1.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var testOmitPropsOnStringTag = isPropValid;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
  return key !== "theme";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag2) {
  return typeof tag2 === "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag2.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps2(tag2, options2, isReal) {
  var shouldForwardProp2;
  if (options2) {
    var optionsShouldForwardProp = options2.shouldForwardProp;
    shouldForwardProp2 = tag2.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
      return tag2.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }
  if (typeof shouldForwardProp2 !== "function" && isReal) {
    shouldForwardProp2 = tag2.__emotion_forwardProp;
  }
  return shouldForwardProp2;
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`;
var Insertion3 = function Insertion4(_ref2) {
  var cache2 = _ref2.cache, serialized = _ref2.serialized, isStringTag = _ref2.isStringTag;
  registerStyles(cache2, serialized, isStringTag);
  useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(cache2, serialized, isStringTag);
  });
  return null;
};
var createStyled = function createStyled2(tag2, options2) {
  if (process.env.NODE_ENV !== "production") {
    if (tag2 === void 0) {
      throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
    }
  }
  var isReal = tag2.__emotion_real === tag2;
  var baseTag = isReal && tag2.__emotion_base || tag2;
  var identifierName;
  var targetClassName;
  if (options2 !== void 0) {
    identifierName = options2.label;
    targetClassName = options2.target;
  }
  var shouldForwardProp2 = composeShouldForwardProps(tag2, options2, isReal);
  var defaultShouldForwardProp = shouldForwardProp2 || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag2.__emotion_styles !== void 0 ? tag2.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      if (process.env.NODE_ENV !== "production" && args[0][0] === void 0) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }
      styles2.push(args[0][0]);
      var len = args.length;
      var i2 = 1;
      for (; i2 < len; i2++) {
        if (process.env.NODE_ENV !== "production" && args[0][i2] === void 0) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }
        styles2.push(args[i2], args[0][i2]);
      }
    }
    var Styled2 = withEmotionCache(function(props2, cache2, ref2) {
      var FinalTag = shouldUseAs && props2.as || baseTag;
      var className = "";
      var classInterpolations = [];
      var mergedProps = props2;
      if (props2.theme == null) {
        mergedProps = {};
        for (var key in props2) {
          mergedProps[key] = props2[key];
        }
        mergedProps.theme = React.useContext(ThemeContext);
      }
      if (typeof props2.className === "string") {
        className = getRegisteredStyles(cache2.registered, classInterpolations, props2.className);
      } else if (props2.className != null) {
        className = props2.className + " ";
      }
      var serialized = serializeStyles(styles2.concat(classInterpolations), cache2.registered, mergedProps);
      className += cache2.key + "-" + serialized.name;
      if (targetClassName !== void 0) {
        className += " " + targetClassName;
      }
      var finalShouldForwardProp = shouldUseAs && shouldForwardProp2 === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
      var newProps = {};
      for (var _key in props2) {
        if (shouldUseAs && _key === "as")
          continue;
        if (
          // $FlowFixMe
          finalShouldForwardProp(_key)
        ) {
          newProps[_key] = props2[_key];
        }
      }
      newProps.className = className;
      newProps.ref = ref2;
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Insertion3, {
        cache: cache2,
        serialized,
        isStringTag: typeof FinalTag === "string"
      }), /* @__PURE__ */ React.createElement(FinalTag, newProps));
    });
    Styled2.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled2.defaultProps = tag2.defaultProps;
    Styled2.__emotion_real = Styled2;
    Styled2.__emotion_base = baseTag;
    Styled2.__emotion_styles = styles2;
    Styled2.__emotion_forwardProp = shouldForwardProp2;
    Object.defineProperty(Styled2, "toString", {
      value: function value() {
        if (targetClassName === void 0 && process.env.NODE_ENV !== "production") {
          return "NO_COMPONENT_SELECTOR";
        }
        return "." + targetClassName;
      }
    });
    Styled2.withComponent = function(nextTag, nextOptions) {
      return createStyled2(nextTag, _extends$9({}, options2, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled2, nextOptions, true)
      })).apply(void 0, styles2);
    };
    return Styled2;
  };
};
var tags$1 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
var newStyled = createStyled.bind();
tags$1.forEach(function(tagName) {
  newStyled[tagName] = newStyled(tagName);
});
function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys$2(object2, enumerableOnly) {
  var keys8 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys8.push.apply(keys8, symbols);
  }
  return keys8;
}
function _objectSpread2$1(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys$2(Object(source), true).forEach(function(key) {
        _defineProperty$6(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var isFunction$8 = function isFunction(obj) {
  return typeof obj === "function";
};
var MDXContext = /* @__PURE__ */ React__default.createContext({});
var useMDXComponents = function useMDXComponents2(components2) {
  var contextComponents = React__default.useContext(MDXContext);
  var allComponents = contextComponents;
  if (components2) {
    allComponents = isFunction$8(components2) ? components2(contextComponents) : _objectSpread2$1(_objectSpread2$1({}, contextComponents), components2);
  }
  return allComponents;
};
var MDXProvider$1 = function MDXProvider(props2) {
  var allComponents = useMDXComponents(props2.components);
  return /* @__PURE__ */ React__default.createElement(MDXContext.Provider, {
    value: allComponents
  }, props2.children);
};
var DEFAULTS = {
  inlineCode: "code",
  wrapper: function wrapper(_ref2) {
    var children2 = _ref2.children;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, {}, children2);
  }
};
var MDXCreateElement = /* @__PURE__ */ React__default.forwardRef(function(props2, ref2) {
  var propComponents = props2.components, mdxType = props2.mdxType, originalType = props2.originalType, parentName = props2.parentName, etc = _objectWithoutProperties$1(props2, ["components", "mdxType", "originalType", "parentName"]);
  var components2 = useMDXComponents(propComponents);
  var type2 = mdxType;
  var Component2 = components2["".concat(parentName, ".").concat(type2)] || components2[type2] || DEFAULTS[type2] || originalType;
  if (propComponents) {
    return /* @__PURE__ */ React__default.createElement(Component2, _objectSpread2$1(_objectSpread2$1({
      ref: ref2
    }, etc), {}, {
      components: propComponents
    }));
  }
  return /* @__PURE__ */ React__default.createElement(Component2, _objectSpread2$1({
    ref: ref2
  }, etc));
});
MDXCreateElement.displayName = "MDXCreateElement";
const tags = [
  "p",
  "b",
  "i",
  "a",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "img",
  "pre",
  "code",
  "ol",
  "ul",
  "li",
  "blockquote",
  "hr",
  "em",
  "table",
  "tr",
  "th",
  "td",
  "em",
  "strong",
  "del",
  // mdx
  "inlineCode",
  "thematicBreak",
  // other
  "div",
  // theme-ui
  "root"
];
const aliases$1 = {
  inlineCode: "code",
  thematicBreak: "hr",
  root: "div"
};
const isAlias = (x3) => x3 in aliases$1;
const alias = (n) => isAlias(n) ? aliases$1[n] : n;
const propOverrides = {
  th: {
    align: "textAlign"
  },
  td: {
    align: "textAlign"
  }
};
const themed = (key) => ({
  theme: theme2,
  ...rest
}) => {
  const propsStyle = propOverrides[key];
  const extraStyles = propsStyle ? Object.keys(rest).filter((prop) => propsStyle[prop] !== void 0).reduce((acc, prop) => ({
    ...acc,
    [propsStyle[prop]]: rest[prop]
  }), {}) : void 0;
  return css$1({
    ...get$4(theme2, `styles.${key}`),
    ...extraStyles
  })(theme2);
};
const Themed = newStyled("div")(themed("div"));
const Styled = newStyled("div")(themed("div"));
const warnStyled = (tag2) => (props2) => {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      console.warn('[theme-ui] The Styled component from "@theme-ui/mdx" is deprecated and will be removed in a future version. It has been renamed to Themed with the same API.');
    }
  }, []);
  return /* @__PURE__ */ createElement(alias(tag2), props2);
};
const components$3 = {};
tags.forEach((tag2) => {
  components$3[tag2] = newStyled(alias(tag2))(themed(tag2));
  Themed[tag2] = components$3[tag2];
  Styled[tag2] = newStyled(warnStyled(tag2))(themed(tag2));
});
const createComponents = (comps) => {
  const next2 = {
    ...components$3
  };
  const componentKeys = Object.keys(comps);
  componentKeys.forEach((key) => {
    next2[key] = newStyled(comps[key])(themed(key));
  });
  return next2;
};
const MDXProvider2 = ({
  components: components2,
  children: children2
}) => {
  const outer = useMDXComponents();
  return jsx$2(MDXProvider$1, {
    components: createComponents({
      ...outer,
      ...components2
    }),
    children: children2
  });
};
const RootStyles = () => jsx$2(Global, {
  styles: (emotionTheme) => {
    var _theme$config;
    const theme2 = emotionTheme;
    const {
      useRootStyles
    } = theme2.config || theme2;
    if (useRootStyles === false || theme2.styles && !theme2.styles.root) {
      return null;
    }
    const boxSizing = ((_theme$config = theme2.config) == null ? void 0 : _theme$config.useBorderBox) === false ? void 0 : "border-box";
    return css$1({
      "*": {
        boxSizing
      },
      html: {
        variant: "styles.root"
      },
      body: {
        margin: 0
      }
    })(theme2);
  }
});
const ThemeProvider = ({
  theme: theme2,
  components: components2,
  children: children2
}) => {
  const outer = useThemeUI();
  if (typeof outer.setColorMode === "function") {
    return jsx$2(ThemeProvider$1, {
      theme: theme2
    }, jsx$2(MDXProvider2, {
      components: components2,
      children: children2
    }));
  }
  return jsx$2(ThemeProvider$1, {
    theme: theme2
  }, jsx$2(ColorModeProvider, null, jsx$2(RootStyles), jsx$2(MDXProvider2, {
    components: components2,
    children: children2
  })));
};
function memoize$3(fn2) {
  var cache2 = /* @__PURE__ */ Object.create(null);
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
function memoize$2(fn2) {
  var cache2 = {};
  return function(arg) {
    if (cache2[arg] === void 0)
      cache2[arg] = fn2(arg);
    return cache2[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var index$1 = memoize$2(
  function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
);
var objectAssignExports = requireObjectAssign();
const assign$6 = /* @__PURE__ */ getDefaultExportFromCjs(objectAssignExports);
var merge$1 = function merge(a4, b10) {
  var result = assign$6({}, a4, b10);
  for (var key in a4) {
    var _assign2;
    if (!a4[key] || typeof b10[key] !== "object")
      continue;
    assign$6(result, (_assign2 = {}, _assign2[key] = assign$6(a4[key], b10[key]), _assign2));
  }
  return result;
};
var sort = function sort2(obj) {
  var next2 = {};
  Object.keys(obj).sort(function(a4, b10) {
    return a4.localeCompare(b10, void 0, {
      numeric: true,
      sensitivity: "base"
    });
  }).forEach(function(key) {
    next2[key] = obj[key];
  });
  return next2;
};
var defaults$8 = {
  breakpoints: [40, 52, 64].map(function(n) {
    return n + "em";
  })
};
var createMediaQuery = function createMediaQuery2(n) {
  return "@media screen and (min-width: " + n + ")";
};
var getValue$3 = function getValue(n, scale) {
  return get$3(scale, n, n);
};
var get$3 = function get(obj, key, def, p, undef) {
  key = key && key.split ? key.split(".") : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};
var createParser = function createParser2(config2) {
  var cache2 = {};
  var parse2 = function parse3(props2) {
    var styles2 = {};
    var shouldSort = false;
    var isCacheDisabled = props2.theme && props2.theme.disableStyledSystemCache;
    for (var key in props2) {
      if (!config2[key])
        continue;
      var sx2 = config2[key];
      var raw = props2[key];
      var scale = get$3(props2.theme, sx2.scale, sx2.defaults);
      if (typeof raw === "object") {
        cache2.breakpoints = !isCacheDisabled && cache2.breakpoints || get$3(props2.theme, "breakpoints", defaults$8.breakpoints);
        if (Array.isArray(raw)) {
          cache2.media = !isCacheDisabled && cache2.media || [null].concat(cache2.breakpoints.map(createMediaQuery));
          styles2 = merge$1(styles2, parseResponsiveStyle(cache2.media, sx2, scale, raw, props2));
          continue;
        }
        if (raw !== null) {
          styles2 = merge$1(styles2, parseResponsiveObject(cache2.breakpoints, sx2, scale, raw, props2));
          shouldSort = true;
        }
        continue;
      }
      assign$6(styles2, sx2(raw, scale, props2));
    }
    if (shouldSort) {
      styles2 = sort(styles2);
    }
    return styles2;
  };
  parse2.config = config2;
  parse2.propNames = Object.keys(config2);
  parse2.cache = cache2;
  var keys8 = Object.keys(config2).filter(function(k3) {
    return k3 !== "config";
  });
  if (keys8.length > 1) {
    keys8.forEach(function(key) {
      var _createParser;
      parse2[key] = createParser2((_createParser = {}, _createParser[key] = config2[key], _createParser));
    });
  }
  return parse2;
};
var parseResponsiveStyle = function parseResponsiveStyle2(mediaQueries2, sx2, scale, raw, _props) {
  var styles2 = {};
  raw.slice(0, mediaQueries2.length).forEach(function(value, i2) {
    var media = mediaQueries2[i2];
    var style2 = sx2(value, scale, _props);
    if (!media) {
      assign$6(styles2, style2);
    } else {
      var _assign2;
      assign$6(styles2, (_assign2 = {}, _assign2[media] = assign$6({}, styles2[media], style2), _assign2));
    }
  });
  return styles2;
};
var parseResponsiveObject = function parseResponsiveObject2(breakpoints2, sx2, scale, raw, _props) {
  var styles2 = {};
  for (var key in raw) {
    var breakpoint = breakpoints2[key];
    var value = raw[key];
    var style2 = sx2(value, scale, _props);
    if (!breakpoint) {
      assign$6(styles2, style2);
    } else {
      var _assign3;
      var media = createMediaQuery(breakpoint);
      assign$6(styles2, (_assign3 = {}, _assign3[media] = assign$6({}, styles2[media], style2), _assign3));
    }
  }
  return styles2;
};
var createStyleFunction = function createStyleFunction2(_ref2) {
  var properties2 = _ref2.properties, property2 = _ref2.property, scale = _ref2.scale, _ref$transform = _ref2.transform, transform = _ref$transform === void 0 ? getValue$3 : _ref$transform, defaultScale = _ref2.defaultScale;
  properties2 = properties2 || [property2];
  var sx2 = function sx3(value, scale2, _props) {
    var result = {};
    var n = transform(value, scale2, _props);
    if (n === null)
      return;
    properties2.forEach(function(prop) {
      result[prop] = n;
    });
    return result;
  };
  sx2.scale = scale;
  sx2.defaults = defaultScale;
  return sx2;
};
var system = function system2(args) {
  if (args === void 0) {
    args = {};
  }
  var config2 = {};
  Object.keys(args).forEach(function(key) {
    var conf = args[key];
    if (conf === true) {
      config2[key] = createStyleFunction({
        property: key,
        scale: key
      });
      return;
    }
    if (typeof conf === "function") {
      config2[key] = conf;
      return;
    }
    config2[key] = createStyleFunction(conf);
  });
  var parser = createParser(config2);
  return parser;
};
var compose = function compose2() {
  var config2 = {};
  for (var _len = arguments.length, parsers2 = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers2[_key] = arguments[_key];
  }
  parsers2.forEach(function(parser2) {
    if (!parser2 || !parser2.config)
      return;
    assign$6(config2, parser2.config);
  });
  var parser = createParser(config2);
  return parser;
};
var isNumber$5 = function isNumber(n) {
  return typeof n === "number" && !isNaN(n);
};
var getWidth$1 = function getWidth(n, scale) {
  return get$3(scale, n, !isNumber$5(n) || n > 1 ? n : n * 100 + "%");
};
var config$a = {
  width: {
    property: "width",
    scale: "sizes",
    transform: getWidth$1
  },
  height: {
    property: "height",
    scale: "sizes"
  },
  minWidth: {
    property: "minWidth",
    scale: "sizes"
  },
  minHeight: {
    property: "minHeight",
    scale: "sizes"
  },
  maxWidth: {
    property: "maxWidth",
    scale: "sizes"
  },
  maxHeight: {
    property: "maxHeight",
    scale: "sizes"
  },
  size: {
    properties: ["width", "height"],
    scale: "sizes"
  },
  overflow: true,
  overflowX: true,
  overflowY: true,
  display: true,
  verticalAlign: true
};
var layout = system(config$a);
var config$9 = {
  color: {
    property: "color",
    scale: "colors"
  },
  backgroundColor: {
    property: "backgroundColor",
    scale: "colors"
  },
  opacity: true
};
config$9.bg = config$9.backgroundColor;
var color$1 = system(config$9);
var defaults$7 = {
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var config$8 = {
  fontFamily: {
    property: "fontFamily",
    scale: "fonts"
  },
  fontSize: {
    property: "fontSize",
    scale: "fontSizes",
    defaultScale: defaults$7.fontSizes
  },
  fontWeight: {
    property: "fontWeight",
    scale: "fontWeights"
  },
  lineHeight: {
    property: "lineHeight",
    scale: "lineHeights"
  },
  letterSpacing: {
    property: "letterSpacing",
    scale: "letterSpacings"
  },
  textAlign: true,
  fontStyle: true
};
var typography$1 = system(config$8);
var config$7 = {
  alignItems: true,
  alignContent: true,
  justifyItems: true,
  justifyContent: true,
  flexWrap: true,
  flexDirection: true,
  // item
  flex: true,
  flexGrow: true,
  flexShrink: true,
  flexBasis: true,
  justifySelf: true,
  alignSelf: true,
  order: true
};
var flexbox = system(config$7);
var defaults$6 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$6 = {
  gridGap: {
    property: "gridGap",
    scale: "space",
    defaultScale: defaults$6.space
  },
  gridColumnGap: {
    property: "gridColumnGap",
    scale: "space",
    defaultScale: defaults$6.space
  },
  gridRowGap: {
    property: "gridRowGap",
    scale: "space",
    defaultScale: defaults$6.space
  },
  gridColumn: true,
  gridRow: true,
  gridAutoFlow: true,
  gridAutoColumns: true,
  gridAutoRows: true,
  gridTemplateColumns: true,
  gridTemplateRows: true,
  gridTemplateAreas: true,
  gridArea: true
};
var grid$1 = system(config$6);
var config$5 = {
  border: {
    property: "border",
    scale: "borders"
  },
  borderWidth: {
    property: "borderWidth",
    scale: "borderWidths"
  },
  borderStyle: {
    property: "borderStyle",
    scale: "borderStyles"
  },
  borderColor: {
    property: "borderColor",
    scale: "colors"
  },
  borderRadius: {
    property: "borderRadius",
    scale: "radii"
  },
  borderTop: {
    property: "borderTop",
    scale: "borders"
  },
  borderTopLeftRadius: {
    property: "borderTopLeftRadius",
    scale: "radii"
  },
  borderTopRightRadius: {
    property: "borderTopRightRadius",
    scale: "radii"
  },
  borderRight: {
    property: "borderRight",
    scale: "borders"
  },
  borderBottom: {
    property: "borderBottom",
    scale: "borders"
  },
  borderBottomLeftRadius: {
    property: "borderBottomLeftRadius",
    scale: "radii"
  },
  borderBottomRightRadius: {
    property: "borderBottomRightRadius",
    scale: "radii"
  },
  borderLeft: {
    property: "borderLeft",
    scale: "borders"
  },
  borderX: {
    properties: ["borderLeft", "borderRight"],
    scale: "borders"
  },
  borderY: {
    properties: ["borderTop", "borderBottom"],
    scale: "borders"
  }
};
config$5.borderTopWidth = {
  property: "borderTopWidth",
  scale: "borderWidths"
};
config$5.borderTopColor = {
  property: "borderTopColor",
  scale: "colors"
};
config$5.borderTopStyle = {
  property: "borderTopStyle",
  scale: "borderStyles"
};
config$5.borderTopLeftRadius = {
  property: "borderTopLeftRadius",
  scale: "radii"
};
config$5.borderTopRightRadius = {
  property: "borderTopRightRadius",
  scale: "radii"
};
config$5.borderBottomWidth = {
  property: "borderBottomWidth",
  scale: "borderWidths"
};
config$5.borderBottomColor = {
  property: "borderBottomColor",
  scale: "colors"
};
config$5.borderBottomStyle = {
  property: "borderBottomStyle",
  scale: "borderStyles"
};
config$5.borderBottomLeftRadius = {
  property: "borderBottomLeftRadius",
  scale: "radii"
};
config$5.borderBottomRightRadius = {
  property: "borderBottomRightRadius",
  scale: "radii"
};
config$5.borderLeftWidth = {
  property: "borderLeftWidth",
  scale: "borderWidths"
};
config$5.borderLeftColor = {
  property: "borderLeftColor",
  scale: "colors"
};
config$5.borderLeftStyle = {
  property: "borderLeftStyle",
  scale: "borderStyles"
};
config$5.borderRightWidth = {
  property: "borderRightWidth",
  scale: "borderWidths"
};
config$5.borderRightColor = {
  property: "borderRightColor",
  scale: "colors"
};
config$5.borderRightStyle = {
  property: "borderRightStyle",
  scale: "borderStyles"
};
var border$2 = system(config$5);
var config$4 = {
  background: true,
  backgroundImage: true,
  backgroundSize: true,
  backgroundPosition: true,
  backgroundRepeat: true
};
config$4.bgImage = config$4.backgroundImage;
config$4.bgSize = config$4.backgroundSize;
config$4.bgPosition = config$4.backgroundPosition;
config$4.bgRepeat = config$4.backgroundRepeat;
var background$1 = system(config$4);
var defaults$5 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var config$3 = {
  position: true,
  zIndex: {
    property: "zIndex",
    scale: "zIndices"
  },
  top: {
    property: "top",
    scale: "space",
    defaultScale: defaults$5.space
  },
  right: {
    property: "right",
    scale: "space",
    defaultScale: defaults$5.space
  },
  bottom: {
    property: "bottom",
    scale: "space",
    defaultScale: defaults$5.space
  },
  left: {
    property: "left",
    scale: "space",
    defaultScale: defaults$5.space
  }
};
var position = system(config$3);
var defaults$4 = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512]
};
var isNumber$4 = function isNumber2(n) {
  return typeof n === "number" && !isNaN(n);
};
var getMargin$1 = function getMargin(n, scale) {
  if (!isNumber$4(n)) {
    return get$3(scale, n, n);
  }
  var isNegative = n < 0;
  var absolute = Math.abs(n);
  var value = get$3(scale, absolute, absolute);
  if (!isNumber$4(value)) {
    return isNegative ? "-" + value : value;
  }
  return value * (isNegative ? -1 : 1);
};
var configs = {};
configs.margin = {
  margin: {
    property: "margin",
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  },
  marginTop: {
    property: "marginTop",
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  },
  marginRight: {
    property: "marginRight",
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  },
  marginBottom: {
    property: "marginBottom",
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  },
  marginLeft: {
    property: "marginLeft",
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  },
  marginX: {
    properties: ["marginLeft", "marginRight"],
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  },
  marginY: {
    properties: ["marginTop", "marginBottom"],
    scale: "space",
    transform: getMargin$1,
    defaultScale: defaults$4.space
  }
};
configs.margin.m = configs.margin.margin;
configs.margin.mt = configs.margin.marginTop;
configs.margin.mr = configs.margin.marginRight;
configs.margin.mb = configs.margin.marginBottom;
configs.margin.ml = configs.margin.marginLeft;
configs.margin.mx = configs.margin.marginX;
configs.margin.my = configs.margin.marginY;
configs.padding = {
  padding: {
    property: "padding",
    scale: "space",
    defaultScale: defaults$4.space
  },
  paddingTop: {
    property: "paddingTop",
    scale: "space",
    defaultScale: defaults$4.space
  },
  paddingRight: {
    property: "paddingRight",
    scale: "space",
    defaultScale: defaults$4.space
  },
  paddingBottom: {
    property: "paddingBottom",
    scale: "space",
    defaultScale: defaults$4.space
  },
  paddingLeft: {
    property: "paddingLeft",
    scale: "space",
    defaultScale: defaults$4.space
  },
  paddingX: {
    properties: ["paddingLeft", "paddingRight"],
    scale: "space",
    defaultScale: defaults$4.space
  },
  paddingY: {
    properties: ["paddingTop", "paddingBottom"],
    scale: "space",
    defaultScale: defaults$4.space
  }
};
configs.padding.p = configs.padding.padding;
configs.padding.pt = configs.padding.paddingTop;
configs.padding.pr = configs.padding.paddingRight;
configs.padding.pb = configs.padding.paddingBottom;
configs.padding.pl = configs.padding.paddingLeft;
configs.padding.px = configs.padding.paddingX;
configs.padding.py = configs.padding.paddingY;
var margin = system(configs.margin);
var padding$1 = system(configs.padding);
var space$1 = compose(margin, padding$1);
var shadow = system({
  boxShadow: {
    property: "boxShadow",
    scale: "shadows"
  },
  textShadow: {
    property: "textShadow",
    scale: "shadows"
  }
});
function _extends$8() {
  _extends$8 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$8.apply(this, arguments);
}
var get$2 = function get2(obj, key, def, p, undef) {
  key = key && key.split ? key.split(".") : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};
var defaultBreakpoints = [40, 52, 64].map(function(n) {
  return n + "em";
});
var defaultTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 32, 48, 64, 72]
};
var aliases = {
  bg: "backgroundColor",
  m: "margin",
  mt: "marginTop",
  mr: "marginRight",
  mb: "marginBottom",
  ml: "marginLeft",
  mx: "marginX",
  my: "marginY",
  p: "padding",
  pt: "paddingTop",
  pr: "paddingRight",
  pb: "paddingBottom",
  pl: "paddingLeft",
  px: "paddingX",
  py: "paddingY"
};
var multiples = {
  marginX: ["marginLeft", "marginRight"],
  marginY: ["marginTop", "marginBottom"],
  paddingX: ["paddingLeft", "paddingRight"],
  paddingY: ["paddingTop", "paddingBottom"],
  size: ["width", "height"]
};
var scales = {
  color: "colors",
  backgroundColor: "colors",
  borderColor: "colors",
  margin: "space",
  marginTop: "space",
  marginRight: "space",
  marginBottom: "space",
  marginLeft: "space",
  marginX: "space",
  marginY: "space",
  padding: "space",
  paddingTop: "space",
  paddingRight: "space",
  paddingBottom: "space",
  paddingLeft: "space",
  paddingX: "space",
  paddingY: "space",
  top: "space",
  right: "space",
  bottom: "space",
  left: "space",
  gridGap: "space",
  gridColumnGap: "space",
  gridRowGap: "space",
  gap: "space",
  columnGap: "space",
  rowGap: "space",
  fontFamily: "fonts",
  fontSize: "fontSizes",
  fontWeight: "fontWeights",
  lineHeight: "lineHeights",
  letterSpacing: "letterSpacings",
  border: "borders",
  borderTop: "borders",
  borderRight: "borders",
  borderBottom: "borders",
  borderLeft: "borders",
  borderWidth: "borderWidths",
  borderStyle: "borderStyles",
  borderRadius: "radii",
  borderTopRightRadius: "radii",
  borderTopLeftRadius: "radii",
  borderBottomRightRadius: "radii",
  borderBottomLeftRadius: "radii",
  borderTopWidth: "borderWidths",
  borderTopColor: "colors",
  borderTopStyle: "borderStyles",
  borderBottomWidth: "borderWidths",
  borderBottomColor: "colors",
  borderBottomStyle: "borderStyles",
  borderLeftWidth: "borderWidths",
  borderLeftColor: "colors",
  borderLeftStyle: "borderStyles",
  borderRightWidth: "borderWidths",
  borderRightColor: "colors",
  borderRightStyle: "borderStyles",
  outlineColor: "colors",
  boxShadow: "shadows",
  textShadow: "shadows",
  zIndex: "zIndices",
  width: "sizes",
  minWidth: "sizes",
  maxWidth: "sizes",
  height: "sizes",
  minHeight: "sizes",
  maxHeight: "sizes",
  flexBasis: "sizes",
  size: "sizes",
  // svg
  fill: "colors",
  stroke: "colors"
};
var positiveOrNegative = function positiveOrNegative2(scale, value) {
  if (typeof value !== "number" || value >= 0) {
    return get$2(scale, value, value);
  }
  var absolute = Math.abs(value);
  var n = get$2(scale, absolute, absolute);
  if (typeof n === "string")
    return "-" + n;
  return n * -1;
};
var transforms = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "top", "bottom", "left", "right"].reduce(function(acc, curr) {
  var _extends2;
  return _extends$8({}, acc, (_extends2 = {}, _extends2[curr] = positiveOrNegative, _extends2));
}, {});
var responsive = function responsive2(styles2) {
  return function(theme2) {
    var next2 = {};
    var breakpoints2 = get$2(theme2, "breakpoints", defaultBreakpoints);
    var mediaQueries2 = [null].concat(breakpoints2.map(function(n) {
      return "@media screen and (min-width: " + n + ")";
    }));
    for (var key in styles2) {
      var value = typeof styles2[key] === "function" ? styles2[key](theme2) : styles2[key];
      if (value == null)
        continue;
      if (!Array.isArray(value)) {
        next2[key] = value;
        continue;
      }
      for (var i2 = 0; i2 < value.slice(0, mediaQueries2.length).length; i2++) {
        var media = mediaQueries2[i2];
        if (!media) {
          next2[key] = value[i2];
          continue;
        }
        next2[media] = next2[media] || {};
        if (value[i2] == null)
          continue;
        next2[media][key] = value[i2];
      }
    }
    return next2;
  };
};
var css = function css2(args) {
  return function(props2) {
    if (props2 === void 0) {
      props2 = {};
    }
    var theme2 = _extends$8({}, defaultTheme, {}, props2.theme || props2);
    var result = {};
    var obj = typeof args === "function" ? args(theme2) : args;
    var styles2 = responsive(obj)(theme2);
    for (var key in styles2) {
      var x3 = styles2[key];
      var val = typeof x3 === "function" ? x3(theme2) : x3;
      if (key === "variant") {
        var variant3 = css2(get$2(theme2, val))(theme2);
        result = _extends$8({}, result, {}, variant3);
        continue;
      }
      if (val && typeof val === "object") {
        result[key] = css2(val)(theme2);
        continue;
      }
      var prop = get$2(aliases, key, key);
      var scaleName = get$2(scales, prop);
      var scale = get$2(theme2, scaleName, get$2(theme2, prop, {}));
      var transform = get$2(transforms, prop, get$2);
      var value = transform(scale, val, val);
      if (multiples[prop]) {
        var dirs = multiples[prop];
        for (var i2 = 0; i2 < dirs.length; i2++) {
          result[dirs[i2]] = value;
        }
      } else {
        result[prop] = value;
      }
    }
    return result;
  };
};
var variant$1 = function variant(_ref2) {
  var _config;
  var scale = _ref2.scale, _ref$prop = _ref2.prop, prop = _ref$prop === void 0 ? "variant" : _ref$prop, _ref$variants = _ref2.variants, variants2 = _ref$variants === void 0 ? {} : _ref$variants, key = _ref2.key;
  var sx2;
  if (Object.keys(variants2).length) {
    sx2 = function sx3(value, scale2, props2) {
      return css(get$3(scale2, value, null))(props2.theme);
    };
  } else {
    sx2 = function sx3(value, scale2) {
      return get$3(scale2, value, null);
    };
  }
  sx2.scale = scale || key;
  sx2.defaults = variants2;
  var config2 = (_config = {}, _config[prop] = sx2, _config);
  var parser = createParser(config2);
  return parser;
};
var buttonStyle = variant$1({
  key: "buttons"
});
var textStyle = variant$1({
  key: "textStyles",
  prop: "textStyle"
});
var colorStyle = variant$1({
  key: "colorStyles",
  prop: "colors"
});
layout.width;
layout.height;
layout.minWidth;
layout.minHeight;
layout.maxWidth;
layout.maxHeight;
layout.size;
layout.verticalAlign;
layout.display;
layout.overflow;
layout.overflowX;
layout.overflowY;
color$1.opacity;
typography$1.fontSize;
typography$1.fontFamily;
typography$1.fontWeight;
typography$1.lineHeight;
typography$1.textAlign;
typography$1.fontStyle;
typography$1.letterSpacing;
flexbox.alignItems;
flexbox.alignContent;
flexbox.justifyItems;
flexbox.justifyContent;
flexbox.flexWrap;
flexbox.flexDirection;
flexbox.flex;
flexbox.flexGrow;
flexbox.flexShrink;
flexbox.flexBasis;
flexbox.justifySelf;
flexbox.alignSelf;
flexbox.order;
grid$1.gridGap;
grid$1.gridColumnGap;
grid$1.gridRowGap;
grid$1.gridColumn;
grid$1.gridRow;
grid$1.gridAutoFlow;
grid$1.gridAutoColumns;
grid$1.gridAutoRows;
grid$1.gridTemplateColumns;
grid$1.gridTemplateRows;
grid$1.gridTemplateAreas;
grid$1.gridArea;
border$2.borderWidth;
border$2.borderStyle;
border$2.borderColor;
border$2.borderTop;
border$2.borderRight;
border$2.borderBottom;
border$2.borderLeft;
border$2.borderRadius;
background$1.backgroundImage;
background$1.backgroundSize;
background$1.backgroundPosition;
background$1.backgroundRepeat;
position.zIndex;
position.top;
position.right;
position.bottom;
position.left;
var all$1 = compose(space$1, typography$1, color$1, layout, flexbox, border$2, background$1, position, grid$1, shadow, buttonStyle, textStyle, colorStyle);
var props = all$1.propNames;
var createShouldForwardProp = function createShouldForwardProp2(props2) {
  var regex2 = new RegExp("^(" + props2.join("|") + ")$");
  return memoize$3(function(prop) {
    return index$1(prop) && !regex2.test(prop);
  });
};
createShouldForwardProp(props);
const boxSystemProps = [...space$1.propNames, ...color$1.propNames];
const shouldForwardProp = createShouldForwardProp(boxSystemProps);
const sx = (props2) => css$1(props2.sx)(props2.theme);
const base$f = (props2) => css$1(props2.__css)(props2.theme);
const variant2 = ({
  theme: theme2,
  variant: variant3,
  __themeKey = "variants"
}) => css$1(get$4(theme2, __themeKey + "." + variant3, get$4(theme2, variant3)));
const Box$1 = newStyled("div", {
  shouldForwardProp
})({
  boxSizing: "border-box",
  margin: 0,
  minWidth: 0
}, base$f, variant2, space$1, color$1, sx, (props2) => props2.css);
Box$1.displayName = "Box";
const Flex$1 = newStyled(Box$1)({
  display: "flex"
});
Flex$1.displayName = "Flex";
function _extends$7() {
  _extends$7 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$7.apply(this, arguments);
}
const Button$1 = /* @__PURE__ */ React__default.forwardRef(function Button(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "button",
    variant: "primary"
  }, props2, {
    __themeKey: "buttons",
    __css: {
      appearance: "none",
      display: props2.hidden ? void 0 : "inline-block",
      textAlign: "center",
      lineHeight: "inherit",
      textDecoration: "none",
      fontSize: "inherit",
      px: 3,
      py: 2,
      color: "white",
      bg: "primary",
      border: 0,
      borderRadius: 4
    }
  }));
});
const Link$2 = /* @__PURE__ */ React__default.forwardRef(function Link(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "a",
    variant: "styles.a"
  }, props2, {
    __themeKey: "links"
  }));
});
const Paragraph$1 = /* @__PURE__ */ React__default.forwardRef(function Paragraph(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "p",
    variant: "paragraph",
    __themeKey: "text",
    __css: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    }
  }, props2));
});
const Text$2 = /* @__PURE__ */ React__default.forwardRef(function Text(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    as: "span",
    ref: ref2,
    variant: "default"
  }, props2, {
    __themeKey: "text"
  }));
});
const Card$1 = /* @__PURE__ */ React__default.forwardRef(function Card(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    variant: "primary"
  }, props2, {
    __themeKey: "cards"
  }));
});
const Label$1 = /* @__PURE__ */ React__default.forwardRef(function Label(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "label",
    variant: "label"
  }, props2, {
    __themeKey: "forms",
    __css: {
      width: "100%",
      display: "flex"
    }
  }));
});
const Input$1 = /* @__PURE__ */ React__default.forwardRef(function Input(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "input",
    variant: "input"
  }, props2, {
    __themeKey: "forms",
    __css: {
      display: "block",
      width: "100%",
      p: 2,
      appearance: "none",
      fontSize: "inherit",
      lineHeight: "inherit",
      border: "1px solid",
      borderRadius: 4,
      color: "inherit",
      bg: "transparent"
    }
  }));
});
const SVG = ({
  size = 24,
  ...props2
}) => /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
  as: "svg",
  xmlns: "http://www.w3.org/2000/svg",
  width: size + "",
  height: size + "",
  viewBox: "0 0 24 24",
  fill: "currentcolor"
}, props2));
SVG.displayName = "SVG";
const getProps$1 = (test2) => (props2) => {
  const next2 = {};
  for (const key in props2) {
    if (test2(key || ""))
      next2[key] = props2[key];
  }
  return next2;
};
const MRE = /^m[trblxy]?$/;
const getMargin2 = getProps$1((k3) => MRE.test(k3));
const omitMargin = getProps$1((k3) => !MRE.test(k3));
const DownArrow = (props2) => /* @__PURE__ */ React__default.createElement(SVG, props2, /* @__PURE__ */ React__default.createElement("path", {
  d: "M7 10l5 5 5-5z"
}));
const Select$2 = /* @__PURE__ */ React__default.forwardRef(function Select({
  arrow: arrow2,
  ...props2
}, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({}, getMargin2(props2), {
    sx: {
      display: "flex"
    }
  }), /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "select",
    variant: "select"
  }, omitMargin(props2), {
    __themeKey: "forms",
    __css: {
      display: "block",
      width: "100%",
      p: 2,
      appearance: "none",
      fontSize: "inherit",
      lineHeight: "inherit",
      border: "1px solid",
      borderRadius: 4,
      color: "inherit",
      backgroundColor: (theme2) => get$4(theme2, "colors.background", null)
    }
  })), arrow2 || /* @__PURE__ */ React__default.createElement(DownArrow, {
    sx: {
      ml: -28,
      alignSelf: "center",
      pointerEvents: "none"
    }
  }));
});
const Textarea$1 = /* @__PURE__ */ React__default.forwardRef(function Textarea(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "textarea",
    variant: "textarea"
  }, props2, {
    __themeKey: "forms",
    __css: {
      display: "block",
      width: "100%",
      p: 2,
      appearance: "none",
      fontSize: "inherit",
      lineHeight: "inherit",
      border: "1px solid",
      borderRadius: 4,
      color: "inherit",
      bg: "transparent"
    }
  }));
});
const thumb = {
  appearance: "none",
  width: 16,
  height: 16,
  bg: "currentcolor",
  border: 0,
  borderRadius: 9999,
  variant: "forms.slider.thumb"
};
const Slider$1 = /* @__PURE__ */ React__default.forwardRef(function Slider(props2, ref2) {
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "input",
    type: "range",
    variant: "slider"
  }, props2, {
    __themeKey: "forms",
    __css: {
      display: "block",
      width: "100%",
      height: 4,
      my: 2,
      cursor: "pointer",
      appearance: "none",
      borderRadius: 9999,
      color: "inherit",
      bg: "gray",
      ":focus": {
        outline: "none",
        color: "primary"
      },
      "&::-webkit-slider-thumb": thumb,
      "&::-moz-range-thumb": thumb,
      "&::-ms-thumb": thumb
    }
  }));
});
const spin = keyframes$1({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
});
const Spinner$1 = /* @__PURE__ */ React__default.forwardRef(function Spinner({
  size = 48,
  strokeWidth = 4,
  max: max2 = 1,
  title = "Loading...",
  duration = 500,
  ...props2
}, ref2) {
  const r = 16 - strokeWidth;
  const C = 2 * r * Math.PI;
  const offset2 = C - 1 / 4 * C;
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "svg",
    viewBox: "0 0 32 32",
    width: size,
    height: size,
    strokeWidth,
    fill: "none",
    stroke: "currentcolor",
    role: "img"
  }, props2, {
    __css: {
      color: "primary",
      overflow: "visible"
    }
  }), /* @__PURE__ */ React__default.createElement("title", null, title), /* @__PURE__ */ React__default.createElement("circle", {
    cx: 16,
    cy: 16,
    r,
    opacity: 1 / 8
  }), /* @__PURE__ */ React__default.createElement(Box$1, {
    as: "circle",
    cx: 16,
    cy: 16,
    r,
    strokeDasharray: C,
    strokeDashoffset: offset2,
    __css: {
      transformOrigin: "50% 50%",
      animationName: spin.toString(),
      animationTimingFunction: "linear",
      animationDuration: duration + "ms",
      animationIterationCount: "infinite"
    }
  }));
});
const IconButton$1 = /* @__PURE__ */ React__default.forwardRef(function IconButton({
  size = 32,
  ...props2
}, ref2) {
  var _props$__css;
  return /* @__PURE__ */ React__default.createElement(Box$1, _extends$7({
    ref: ref2,
    as: "button",
    variant: "icon"
  }, props2, {
    __themeKey: "buttons",
    __css: {
      label: ((_props$__css = props2.__css) == null ? void 0 : _props$__css.label) || "IconButton",
      appearance: "none",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 1,
      width: size,
      height: size,
      color: "inherit",
      bg: "transparent",
      border: "none",
      borderRadius: 4
    }
  }));
});
const useTheme = useThemeUI;
var Throttle = /* @__PURE__ */ ((Throttle2) => {
  Throttle2[Throttle2["none"] = 0] = "none";
  Throttle2[Throttle2["movement"] = 16] = "movement";
  Throttle2[Throttle2["loading"] = 100] = "loading";
  Throttle2[Throttle2["forms"] = 200] = "forms";
  Throttle2[Throttle2["charts"] = 300] = "charts";
  Throttle2[Throttle2["request"] = 500] = "request";
  return Throttle2;
})(Throttle || {});
const isTestEnvironment = () => {
  if (typeof process === "undefined")
    return false;
  return process.env.NODE_ENV === "test";
};
const isDevEnvironment = () => {
  if (typeof process === "undefined")
    return false;
  return process.env.NODE_ENV === "development";
};
const isVitestEnvironment = () => {
  if (typeof process === "undefined")
    return false;
  return process.env.JEST_TEST_ENV === "true";
};
const Context$c = React__default.createContext(void 0);
const MatchMediaProvider = ({
  children: children2 = null
}) => {
  const {
    theme: { mediaQueries: mediaQueries2 }
  } = useTheme();
  const [matchMediaQuery, setMatchMediaQuery] = useState(
    () => getCurrentMatchMediaQueries(mediaQueries2)
  );
  const debouncedMatchMediaQuery = useMemo(
    () => debounce$3(() => {
      setMatchMediaQuery(getCurrentMatchMediaQueries(mediaQueries2));
    }, Throttle.movement),
    [mediaQueries2]
  );
  useEffect(() => {
    if (!isTestEnvironment() && !isVitestEnvironment()) {
      debouncedMatchMediaQuery();
    }
    return () => {
      debouncedMatchMediaQuery.cancel();
    };
  }, [debouncedMatchMediaQuery]);
  useEventListener("resize", debouncedMatchMediaQuery);
  const memoizedContext = useMemo(
    () => ({ matchMediaQuery }),
    [matchMediaQuery]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$c.Provider, { value: memoizedContext, children: children2 });
};
const useMatchMedia = () => {
  const context = useContext(Context$c);
  if (context === void 0) {
    throw new Error("useMatchMedia must be used within a MatchMedia Provider");
  }
  return context;
};
function getCurrentMatchMediaQueries(themeMediaQueries) {
  if (typeof window === "undefined")
    return {};
  if (!(window == null ? void 0 : window.matchMedia) || !themeMediaQueries)
    return {};
  return Object.entries(themeMediaQueries).reduce(
    (queryResults, [key, mediaQuery]) => {
      queryResults[key] = window.matchMedia(mediaQuery).matches;
      return queryResults;
    },
    {}
  );
}
const MatchMediaProviderDecorator = (Story) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMediaProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Story, {}) });
};
var StepperActions = /* @__PURE__ */ ((StepperActions2) => {
  StepperActions2["initialize"] = "initialize";
  StepperActions2["jumpToStep"] = "jumpToStep";
  StepperActions2["moveBackward"] = "moveBackward";
  StepperActions2["moveForward"] = "moveForward";
  return StepperActions2;
})(StepperActions || {});
var StepState = /* @__PURE__ */ ((StepState2) => {
  StepState2["inProgress"] = "inProgress";
  StepState2["complete"] = "complete";
  StepState2["incomplete"] = "incomplete";
  StepState2["locked"] = "locked";
  return StepState2;
})(StepState || {});
const reducer = (state, action2) => {
  switch (action2.type) {
    case StepperActions.initialize:
      return {
        ...state,
        ...action2.payload
      };
    case StepperActions.jumpToStep: {
      const { step: step2, subStep } = action2.payload;
      if (isStepValid$1(state, step2, subStep) === false) {
        return state;
      }
      return {
        ...state,
        currentStep: step2,
        currentSubStep: subStep
      };
    }
    case StepperActions.moveBackward: {
      const previousStep = determinePreviousStep$1(state);
      if (previousStep !== null) {
        const { step: step2, subStep } = previousStep;
        return {
          ...state,
          currentStep: step2,
          currentSubStep: subStep
        };
      }
      return state;
    }
    case StepperActions.moveForward: {
      const nextStep = determineNextStep$1(state);
      if (nextStep !== null) {
        const { step: step2, subStep } = nextStep;
        return {
          ...state,
          currentStep: step2,
          currentSubStep: subStep
        };
      }
      return state;
    }
    default:
      return state;
  }
};
const isInvalidStep$1 = (steps2, step2, stepSize) => {
  var _a2;
  return step2 < 0 || step2 >= stepSize || ((_a2 = steps2 == null ? void 0 : steps2[step2]) == null ? void 0 : _a2.state) === StepState.locked;
};
const isStepValid$1 = (state, step2 = null, subStep = null) => {
  var _a2;
  if (step2 === null || isInvalidStep$1(state.steps, step2, state.size)) {
    return false;
  }
  const currentStep = (_a2 = state.steps) == null ? void 0 : _a2[step2];
  if (subStep !== null && subStep !== 0 && isInvalidStep$1(currentStep.subSteps, subStep, currentStep.subStepSize)) {
    return false;
  }
  return true;
};
const determineNextStep$1 = (state) => {
  const { currentStep, currentSubStep } = state;
  if (currentStep === null) {
    return null;
  }
  const { subStepSize } = state.steps[currentStep];
  if (subStepSize > 0) {
    let targetSubStep = currentSubStep;
    if (targetSubStep === void 0 || targetSubStep === null) {
      targetSubStep = 0;
    } else {
      targetSubStep += 1;
    }
    if (isStepValid$1(state, currentStep, targetSubStep)) {
      return {
        step: currentStep,
        subStep: targetSubStep
      };
    }
  }
  const targetStep = currentStep + 1;
  if (isStepValid$1(state, targetStep)) {
    return {
      step: targetStep,
      subStep: null
    };
  }
  return null;
};
const determinePreviousStep$1 = (state) => {
  const { currentStep, currentSubStep } = state;
  if (currentStep === null) {
    return null;
  }
  const { subStepSize } = state.steps[currentStep];
  if (currentSubStep !== null && subStepSize > 0) {
    let targetSubStep = currentSubStep - 1;
    if (targetSubStep < 0) {
      targetSubStep = null;
    }
    if (isStepValid$1(state, currentStep, targetSubStep)) {
      return {
        step: currentStep,
        subStep: targetSubStep
      };
    }
  }
  const targetStep = currentStep - 1;
  if (isStepValid$1(state, targetStep, 0)) {
    const targetStepSubStepSize = state.steps[targetStep].subStepSize;
    if (targetStepSubStepSize > 0) {
      return {
        step: targetStep,
        subStep: targetStepSubStepSize - 1
      };
    }
    return {
      step: targetStep,
      subStep: null
    };
  }
  return null;
};
const Box = React__default.forwardRef(
  ({ as = "div", children: children2 = void 0, sx: sx2 = {}, ...restOfProps }, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { as, ref: ref2, sx: sx2, ...restOfProps, children: children2 })
);
const Context$b = React__default.createContext(
  void 0
);
const useStepper = () => {
  const context = useContext(Context$b);
  if (context === void 0) {
    throw new Error("useStepper must be used within a Stepper Provider");
  }
  return context;
};
const Debug$1 = () => {
  const { stepperState } = useStepper();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { "data-test-id": "stepper-debug", children: /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { children: JSON.stringify(
    stepperState,
    (_key, val) => {
      if (typeof val === "function") {
        return "function";
      }
      return val;
    },
    2
  ) }) });
};
const determineStepState = (targetSteps, currentSteps) => {
  const { step: step2, subStep } = targetSteps;
  const { step: currentStep, subStep: currentSubStep } = currentSteps;
  if (step2 === null) {
    return StepState.incomplete;
  }
  if (currentStep === step2 && (subStep === null || currentSubStep === subStep)) {
    return StepState.inProgress;
  }
  if (currentStep > step2 || currentStep === step2 && subStep !== null && currentSubStep > subStep) {
    return StepState.complete;
  }
  return StepState.incomplete;
};
const buildState = (stateProps, setState) => {
  const { steps: steps2, initialStep, initialSubStep } = stateProps;
  const size = (steps2 == null ? void 0 : steps2.length) || 0;
  const currentStep = validInitialStep(initialStep, size);
  const stepperInitialState = {
    currentStep,
    currentSubStep: null,
    size,
    steps: []
  };
  if (!size)
    return setState(stepperInitialState);
  steps2.forEach((step2, index2) => {
    var _a2;
    const subStepSize = ((_a2 = step2 == null ? void 0 : step2.subSteps) == null ? void 0 : _a2.length) || 0;
    if (index2 === currentStep) {
      stepperInitialState.currentSubStep = validInitialSubStep(
        initialSubStep,
        subStepSize
      );
    }
    stepperInitialState.steps.push({
      ...step2,
      subStepSize
    });
  });
  setState(stepperInitialState);
};
const validInitialStep = (step2, size) => {
  if (step2 === null) {
    return null;
  }
  if (step2 < 0 || size <= 0) {
    return 0;
  }
  if (step2 >= size) {
    return size - 1;
  }
  return step2;
};
const validInitialSubStep = (step2, size) => {
  if (size <= 0) {
    return null;
  }
  if (step2 !== null) {
    return validInitialStep(step2, size);
  }
  return step2;
};
const StepperProvider = ({
  children: children2
}) => {
  const [stepperState, dispatch] = useReducer(
    reducer,
    {}
  );
  const jumpToStep = useCallback(
    (step2 = null, subStep = null) => {
      dispatch({
        type: StepperActions.jumpToStep,
        payload: { step: step2, subStep }
      });
    },
    [dispatch]
  );
  const nextStep = useCallback(() => {
    dispatch({ type: StepperActions.moveForward });
  }, [dispatch]);
  const previousStep = useCallback(() => {
    dispatch({ type: StepperActions.moveBackward });
  }, [dispatch]);
  const getStepState = useCallback(
    (step2 = null, subStep = null) => {
      const { currentStep, currentSubStep } = stepperState;
      return determineStepState(
        { step: step2, subStep },
        { step: currentStep, subStep: currentSubStep }
      );
    },
    [stepperState]
  );
  const getCurrentStep = useCallback(() => {
    if (!stepperState || !stepperState.size)
      return null;
    const { currentStep } = stepperState;
    return stepperState.steps[currentStep];
  }, [stepperState]);
  const getCurrentStepIndex = useCallback(() => {
    if (!stepperState || !stepperState.currentStep)
      return 0;
    return stepperState.currentStep;
  }, [stepperState]);
  const setStepperState = useCallback(
    (state) => dispatch({ type: StepperActions.initialize, payload: state }),
    [dispatch]
  );
  const setStepperNonLinear = useCallback(
    (nonLinear) => dispatch({ type: StepperActions.initialize, payload: { nonLinear } }),
    [dispatch]
  );
  const buildStepperState = useCallback(
    (steps2, initialStep = 0, initialSubStep = null) => {
      buildState({ steps: steps2, initialStep, initialSubStep }, setStepperState);
    },
    [setStepperState]
  );
  const memoizedContext = useMemo(
    () => ({
      buildStepperState,
      getStepState,
      getCurrentStep,
      getCurrentStepIndex,
      jumpToStep,
      nextStep,
      previousStep,
      setStepperState,
      setStepperNonLinear,
      stepperState
    }),
    [
      buildStepperState,
      getStepState,
      getCurrentStep,
      getCurrentStepIndex,
      jumpToStep,
      nextStep,
      previousStep,
      setStepperState,
      setStepperNonLinear,
      stepperState
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$b.Provider, { value: memoizedContext, children: children2 });
};
StepperProvider.Debug = Debug$1;
const StepperDecorator = (Story) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepperProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Story, {}) });
};
const useFinalSpacing = (spacing) => {
  const { theme: theme2 } = useTheme();
  const finalSpacing = useMemo(() => {
    var _a2;
    if (!spacing) {
      return void 0;
    }
    if (typeof spacing === "string") {
      return spacing;
    }
    const themeSpacing = (_a2 = theme2.space) == null ? void 0 : _a2[spacing];
    return themeSpacing || `${spacing}rem`;
  }, [theme2, spacing]);
  return finalSpacing;
};
const Flex = React__default.forwardRef(
  ({
    "aria-labelledby": ariaLabelledBy,
    as = "div",
    children: children2,
    className,
    spacing,
    sx: sx2,
    tabIndex,
    "data-test-id": dataTestId,
    flexDirection,
    flexWrap,
    alignItems,
    justifyContent: justifyContent2,
    flex,
    flexGrow,
    flexShrink,
    flexBasis,
    justifySelf,
    alignSelf,
    order: order2,
    ...restOfProps
  }, ref2) => {
    const finalSpacing = useFinalSpacing(spacing);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex$1,
      {
        "aria-labelledby": ariaLabelledBy,
        as,
        className,
        "data-test-id": dataTestId,
        ref: ref2,
        sx: {
          gap: finalSpacing,
          flexDirection,
          flexWrap,
          alignItems,
          justifyContent: justifyContent2,
          flex,
          flexGrow,
          flexShrink,
          flexBasis,
          justifySelf,
          alignSelf,
          order: order2,
          ...sx2
        },
        ...tabIndex != void 0 && { tabIndex },
        ...restOfProps,
        children: children2
      }
    );
  }
);
const ScaffoldingContainer = ({
  children: children2,
  sx: sx2 = {}
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Flex,
  {
    alignItems: "center",
    justifyContent: "center",
    sx: {
      height: "100%",
      width: "100%",
      backgroundColor: "fog-20",
      borderRadius: 4,
      border: "2px dashed",
      borderColor: "border",
      ...sx2
    },
    children: children2
  }
);
const SvgArrowDown$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 6L6 10L10 6M5.99744 10L5.99744 2", stroke: "current", strokeWidth: 2 }));
const SvgArrowLeft$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 2L2 6L6 10M2 5.99744H10", stroke: "current", strokeWidth: 2 }));
const SvgArrowRight$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 10L10 6L6 2M10 6.00256L2 6.00256", stroke: "current", strokeWidth: 2 }));
const SvgArrowUp$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10 6L6 2L2 6M6.00256 2V10", stroke: "current", strokeWidth: 2 }));
const SvgCaretDown = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.10552 4.76728L5.5564 7.78038C5.79414 8.07321 6.20586 8.07321 6.4436 7.78038L8.89448 4.76728C9.14871 4.45445 8.91472 4 8.5 4H3.5C3.08527 4 2.85129 4.45445 3.10552 4.76728Z", fill: "current" }));
const SvgCaretLeft = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.23252 3.10516L4.21972 5.55616C3.92692 5.79391 3.92692 6.20566 4.21972 6.44341L7.23252 8.89441C7.54532 9.14866 7.99972 8.91466 7.99972 8.49991L7.99972 3.49966C7.99972 3.08491 7.54532 2.85091 7.23252 3.10516Z", fill: "current" }));
const SvgCaretRight = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.76728 8.89448L7.78038 6.4436C8.07321 6.20586 8.07321 5.79414 7.78038 5.5564L4.76728 3.10552C4.45445 2.85129 4 3.08527 4 3.5V8.5C4 8.91472 4.45445 9.14871 4.76728 8.89448Z", fill: "current" }));
const SvgCaretUp = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.89454 7.2324L6.44354 4.2196C6.20579 3.9268 5.79404 3.9268 5.55629 4.2196L3.10529 7.2324C2.85104 7.5452 3.08504 7.9996 3.49979 7.9996H8.50004C8.91479 7.9996 9.14879 7.5452 8.89454 7.2324Z", fill: "current" }));
const SvgCheck$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...props2 }, /* @__PURE__ */ React.createElement("path", { stroke: "current", strokeWidth: 2, d: "M11 1.5l-6.5 8-3.5-3" }));
const SvgChevronDown$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 4L6 8L10 4", stroke: "current", strokeWidth: 2 }));
const SvgChevronLeft$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 2L4 6L8 10", stroke: "current", strokeWidth: 2 }));
const SvgChevronRight$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 10L8 6L4 2", stroke: "current", strokeWidth: 2 }));
const SvgChevronUp$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10 8L6 4L2 8", stroke: "current", strokeWidth: 2 }));
const SvgMinus$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...props2 }, /* @__PURE__ */ React.createElement("path", { stroke: "current", strokeWidth: 2, d: "M1 6h10" }));
const SvgStar = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M5.45334 1.36469C5.65558 0.878436 6.34441 0.878436 6.54666 1.36469L7.69652 4.12928L10.6811 4.36856C11.2061 4.41064 11.4189 5.06576 11.019 5.40837L8.74502 7.35626L9.43976 10.2687C9.56195 10.781 9.00467 11.1859 8.55524 10.9114L6 9.35063L3.44476 10.9114C2.99532 11.1859 2.43805 10.781 2.56024 10.2687L3.25497 7.35626L0.981014 5.40837C0.581056 5.06576 0.793917 4.41064 1.31887 4.36856L4.30348 4.12928L5.45334 1.36469Z", fill: "current" }));
const SvgX$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 12 12", ...props2 }, /* @__PURE__ */ React.createElement("path", { stroke: "current", strokeWidth: 2, d: "M10 2l-8 8M2 2l8 8" }));
const icons12 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrowDown: SvgArrowDown$2,
  arrowLeft: SvgArrowLeft$2,
  arrowRight: SvgArrowRight$2,
  arrowUp: SvgArrowUp$2,
  caretDown: SvgCaretDown,
  caretLeft: SvgCaretLeft,
  caretRight: SvgCaretRight,
  caretUp: SvgCaretUp,
  check: SvgCheck$2,
  chevronDown: SvgChevronDown$2,
  chevronLeft: SvgChevronLeft$2,
  chevronRight: SvgChevronRight$2,
  chevronUp: SvgChevronUp$2,
  minus: SvgMinus$2,
  star: SvgStar,
  x: SvgX$2
}, Symbol.toStringTag, { value: "Module" }));
const SvgArrowDown$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 8L8 13L13 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 13L8 2", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowLeft$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M7 13L2 8M2 8L7 3M2 8H13", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowLeftRight$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 12L13 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 15L2 12L5 9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 4L3 4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11 7L14 4L11 1", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowRight$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 13L13 8L8 3", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 8L2 8", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowUp$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M13 8L8 3L3 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 3L8 14", stroke: "current", strokeWidth: 1.5 }));
const SvgBank$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 3.37715C1 3.15391 1.14799 2.95772 1.36264 2.89639L7.86264 1.03925C7.95242 1.0136 8.04758 1.0136 8.13736 1.03925L14.6374 2.89639C14.852 2.95772 15 3.15391 15 3.37715V5.5C15 5.77614 14.7761 6 14.5 6H1.5C1.22386 6 1 5.77614 1 5.5V3.37715Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14 14V6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 14V6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M-1.19209e-07 14L16 14", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 14V6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 14V6", stroke: "current", strokeWidth: 1.5 }));
const SvgBell$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 1C10.5933 1 12 2.59609 12 5.4V8.7L14.2397 11.1637C14.5317 11.4849 14.3038 12 13.8697 12H8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 1C5.40666 1 4 2.59609 4 5.4V8.7L1.76031 11.1637C1.46832 11.4849 1.6962 12 2.13028 12H8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 12V13C10 14.1046 9.10457 15 8 15C6.89543 15 6 14.1046 6 13V12", stroke: "current", strokeWidth: 1.5 }));
const SvgBookClosed = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9 10H9.7058C9.88738 10 10.0547 9.90155 10.1429 9.74282L14.5873 1.74282C14.7725 1.40956 14.5315 1 14.1502 1H8.17681C7.45047 1 6.78123 1.39378 6.42849 2.02871L2 10H3.5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15 8L11.4078 14.7353C11.3209 14.8982 11.1513 15 10.9667 15H3C1.71107 15 1 14 1 12.5C1 11 1.71107 10 3 10H9.5", stroke: "current", strokeWidth: 1.5 }));
const SvgBookOpen$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 13.7914C8 13.8753 8.0998 13.9255 8.1697 13.879C8.56985 13.6128 9.64982 13 11.1111 13C12.9778 13 13.1333 14 15 14V3C13.1333 3 12.9778 2 11.1111 2C9.24444 2 8 3 8 3V13.7914Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 13.7914C8 13.8753 7.9002 13.9255 7.8303 13.879C7.43015 13.6128 6.35018 13 4.88889 13C3.02222 13 2.86667 14 1 14V3C2.86667 3 3.02222 2 4.88889 2C6.75556 2 8 3 8 3V13.7914Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round" }));
const SvgBriefcase$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 6C1 4.89543 1.89543 4 3 4H13C14.1046 4 15 4.89543 15 6V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V6Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 7L3.27297 7.97413C6.29155 9.26781 9.70845 9.26781 12.727 7.97413L15 7", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10.6666 3.66667V1.5C10.6666 1.22386 10.4427 1 10.1666 1H5.83325C5.55711 1 5.33325 1.22386 5.33325 1.5V3.66667", stroke: "current", strokeWidth: 1.5 }));
const SvgBuilding$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 1.5C6 1.22386 6.22386 1 6.5 1H14.5C14.7761 1 15 1.22386 15 1.5V15H6V1.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 8.5C1 8.22386 1.22386 8 1.5 8H6V15H1V8.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 9L12 9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 5L12 5", stroke: "current", strokeWidth: 1.5 }));
const SvgCalendar$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 4C1 2.89543 1.89543 2 3 2H13C14.1046 2 15 2.89543 15 4V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V4Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 7H15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4 4L4 -2.98023e-08", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 4L8 -2.98023e-08", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 4V-2.98023e-08", stroke: "current", strokeWidth: 1.5 }));
const SvgCaretLeftDouble = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 2L8 8L14 14", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 2L2 8L8 14", stroke: "current", strokeWidth: 1.5 }));
const SvgCaretRightDouble$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 14L8 8L2 2", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 14L14 8L8 2", stroke: "current", strokeWidth: 1.5 }));
const SvgChartBar$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 10.5C2 10.2239 2.22386 10 2.5 10H5.5C5.77614 10 6 10.2239 6 10.5V14H2V10.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 7.5C6 7.22386 6.22386 7 6.5 7H10V14H6V7.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 2.5C10 2.22386 10.2239 2 10.5 2H13.5C13.7761 2 14 2.22386 14 2.5V14H10V2.5Z", stroke: "current", strokeWidth: 1.5 }));
const SvgChartLine$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { stroke: "current", fill: "none", d: "M2 11L3.96299 8.88602C4.75425 8.03389 6.10289 8.03389 6.89416 8.88602L7.02052 9.0221C7.79029 9.85108 9.09382 9.87714 9.89612 9.0796L14 5", strokeWidth: 1.5 }));
const SvgChartPie$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12.5 9C12.7761 9 13.0022 9.22426 12.9792 9.49944C12.8948 10.51 12.5552 11.4857 11.9888 12.3334C11.3295 13.3201 10.3925 14.0891 9.2961 14.5433C8.19974 14.9974 6.99335 15.1162 5.82946 14.8847C4.66557 14.6532 3.59648 14.0818 2.75736 13.2426C1.91825 12.4035 1.3468 11.3344 1.11529 10.1705C0.88378 9.00665 1.0026 7.80025 1.45673 6.7039C1.91085 5.60754 2.67989 4.67047 3.66658 4.01118C4.5143 3.44476 5.48997 3.10523 6.50056 3.02082C6.77574 2.99783 7 3.22386 7 3.5V8.5C7 8.77614 7.22386 9 7.5 9H12.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14.5 9C14.7761 9 15.0016 8.77592 14.9844 8.50032C14.9293 7.62065 14.7292 6.75494 14.391 5.93853C13.989 4.96793 13.3997 4.08601 12.6569 3.34315C11.914 2.60028 11.0321 2.011 10.0615 1.60896C9.24506 1.2708 8.37935 1.07067 7.49968 1.01562C7.22408 0.998372 7 1.22386 7 1.5L7 8.5C7 8.77614 7.22386 9 7.5 9H14.5Z", stroke: "current", strokeWidth: 1.5 }));
const SvgChat$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 12L4.94883 14.8465C4.97234 14.917 5.06185 14.9382 5.11441 14.8856L8 12H13C14.1046 12 15 11.1046 15 10V4C15 2.89543 14.1046 2 13 2H3C1.89543 2 1 2.89543 1 4V10C1 11.1046 1.89543 12 3 12H4Z", stroke: "current", strokeWidth: 1.5 }));
const SvgChatPerson$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 12L4.94883 14.8465C4.97234 14.917 5.06185 14.9382 5.11441 14.8856L8 12H13C14.1046 12 15 11.1046 15 10V3C15 1.89543 14.1046 1 13 1H3C1.89543 1 1 1.89543 1 3V10C1 11.1046 1.89543 12 3 12H4Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 6, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11 10C11 8.89543 9.65685 8 8 8C6.34315 8 5 8.89543 5 10", stroke: "current", strokeWidth: 1.5 }));
const SvgCheck$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 2.5L5.5 14L1.5 10", stroke: "current", strokeWidth: 1.5 }));
const SvgCheckBold = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 2L5.69231 13L1 9", stroke: "current", strokeWidth: 2.5 }));
const SvgCheckCircle$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8 0a8 8 0 110 16A8 8 0 018 0zm-.793 11.707l6-6-1.414-1.414L6.5 9.586 4.207 7.293 2.793 8.707l3 3 .707.707.707-.707z", clipRule: "evenodd" }));
const SvgCheckCircleOutline$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8 .25a7.75 7.75 0 100 15.5A7.75 7.75 0 008 .25zM1.75 8a6.25 6.25 0 1112.5 0 6.25 6.25 0 01-12.5 0zm5.305 3.504l5-5.5-1.11-1.008-4.47 4.917L4.53 7.97 3.47 9.03l2.5 2.5a.75.75 0 001.085-.026z", clipRule: "evenodd" }));
const SvgChevronDown$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 5L8 11L14 5", stroke: "current", strokeWidth: 1.5 }));
const SvgChevronLeft$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M11 14L5 8L11 2", stroke: "current", strokeWidth: 1.5 }));
const SvgChevronRight$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M5 14L11 8L5 2", stroke: "current", strokeWidth: 1.5 }));
const SvgChevronUp$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 11L8 5L2 11", stroke: "current", strokeWidth: 1.5 }));
const SvgClock = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8.00005 4L7.9999 8L12 9", stroke: "current", strokeWidth: 1.5 }));
const SvgClockArrow$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 7.25648 1.11592 6.54004 1.33067 5.86776C1.56735 5.12685 2.00556 4.47283 2.45931 3.8411L4.5 1", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 4V7.73241C8 7.89958 8.08355 8.0557 8.22265 8.14843L11 10", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 5V1H1", stroke: "current", strokeWidth: 1.5 }));
const SvgCopy$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 1.75, y: 5.75, width: 8.5, height: 8.5, rx: 1.25, stroke: "current", strokeWidth: 1.5, fill: "transparent" }), /* @__PURE__ */ React.createElement("path", { d: "M7 2.5H13C13.2761 2.5 13.5 2.72386 13.5 3V9C13.5 9.27614 13.2761 9.5 13 9.5V11C14.1046 11 15 10.1046 15 9V3C15 1.89543 14.1046 1 13 1H7C5.89543 1 5 1.89543 5 3H6.5C6.5 2.72386 6.72386 2.5 7 2.5Z", stroke: "transparent", strokeWidth: 0.01, fill: "current" }));
const SvgDelete$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 4H13L12.1654 13.1811C12.0717 14.2112 11.208 15 10.1736 15H5.82643C4.79202 15 3.92829 14.2112 3.83464 13.1811L3 4Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 3.5C6 3.77614 6.22386 4 6.5 4H9.5C9.77614 4 10 3.77614 10 3.5V1.5C10 1.22386 9.77614 1 9.5 1H6.5C6.22386 1 6 1.22386 6 1.5V3.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 4H15", stroke: "current", strokeWidth: 1.5 }));
const SvgDocument$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 7V13C14 14.1046 13.1046 15 12 15H4C2.89543 15 2 14.1046 2 13V3C2 1.89543 2.89543 1 4 1H8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 1L14 7H8.5C8.22386 7 8 6.77614 8 6.5V1Z", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgDollar$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M11 6C11 6 11 4 7.9988 4C6.1292 4 5 4.99945 5 6C5 7.44695 6.4052 7.79989 7.9988 8", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 12L8 15", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 1L8 4", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 10C5 10 5 12 8.0012 12C9.8708 12 11 11.0005 11 10C11 8.54535 9.5948 8.20011 8.0012 8", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgDollarCircle$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10.3334 6.44447C10.3334 6.44447 10.3334 4.88892 7.99915 4.88892C6.54501 4.88892 5.66675 5.66627 5.66675 6.44447C5.66675 7.56988 6.75968 7.84439 7.99915 8.00003", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.99805 3.33337V4.48313", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.66675 9.55556C5.66675 9.55556 5.66675 11.1111 8.00101 11.1111C9.45515 11.1111 10.3334 10.3338 10.3334 9.55556C10.3334 8.42416 9.24048 8.15564 8.00101 8", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 12.6666L8 11.1111", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, stroke: "current", strokeWidth: 1.5 }));
const SvgDot = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.5, fill: "#5532FA", strokeWidth: 1, stroke: "#5532FA" }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 2, fill: "white", strokeWidth: 1, stroke: "white" }));
const SvgDotEmpty = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.5, fill: "white", strokeWidth: 1, stroke: "#C3C2C1" }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 2, fill: "white", strokeWidth: 1, stroke: "white" }));
const SvgDotFilled = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7.5, fill: "current", strokeWidth: 1, stroke: "#C3C2C1" }));
const SvgDownload$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 11L8 1", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 8L8 11L11 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 12V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V12", stroke: "current", strokeWidth: 1.5 }));
const SvgEdit$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12.8774 1.41421L13.5858 2.12263C14.3668 2.90368 14.3668 4.17001 13.5858 4.95105L4.68329 13.8536C4.58952 13.9473 4.46234 14 4.32974 14H1V10.6703C1 10.5377 1.05268 10.4105 1.14645 10.3167L10.0489 1.41421C10.83 0.633165 12.0963 0.633166 12.8774 1.41421Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 3L12 7", stroke: "current", strokeWidth: 1.5 }));
const SvgEllipsis$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 2, cy: 8, r: 1.5, fill: "current" }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 1.5, fill: "current" }), /* @__PURE__ */ React.createElement("circle", { cx: 14, cy: 8, r: 1.5, fill: "current" }));
const SvgError$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM7 8V3h2v5H7zm1 5a1.5 1.5 0 10.001-2.999A1.5 1.5 0 008 13z", clipRule: "evenodd" }));
const SvgErrorOutline$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8.75 4v4.5h-1.5V4h1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8 1.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zM.25 8a7.75 7.75 0 1115.5 0A7.75 7.75 0 01.25 8z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M7 11a1 1 0 112 0 1 1 0 01-2 0z", clipRule: "evenodd" }));
const SvgEyeClosed$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { stroke: "current", fill: "none", strokeWidth: 1.5, d: "M1 15L15 1" }), /* @__PURE__ */ React.createElement("path", { stroke: "current", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M8 2.501c-2.51-.055-5.103 2.24-6.734 4.59-.355.516-.355 1.299 0 1.814C2.861 11.206 5.448 13.555 8 13.5c2.551.055 5.138-2.293 6.735-4.594.355-.515.355-1.298 0-1.813C13.1 4.74 10.507 2.446 7.999 2.5z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { stroke: "none", fill: "current", fillRule: "evenodd", d: "M10 8a2 2 0 11-4 0 2 2 0 014 0z", clipRule: "evenodd" }));
const SvgEyeOpen$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { stroke: "current", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M8 2.501c-2.51-.055-5.103 2.24-6.734 4.59-.355.516-.355 1.299 0 1.814C2.861 11.206 5.448 13.555 8 13.5c2.551.055 5.138-2.293 6.735-4.594.355-.515.355-1.298 0-1.813C13.1 4.74 10.507 2.446 7.999 2.5z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { stroke: "none", fill: "current", fillRule: "evenodd", d: "M10 8a2 2 0 11-4 0 2 2 0 014 0z", clipRule: "evenodd" }));
const SvgFilter$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9.27639 14.6382L6.27639 13.1382C6.107 13.0535 6 12.8804 6 12.691V8.18103C6 8.06406 5.95899 7.95079 5.88411 7.86093L1.68341 2.82009C1.41202 2.49443 1.6436 2 2.06752 2H13.9325C14.3564 2 14.588 2.49443 14.3166 2.82009L10.1159 7.86093C10.041 7.95079 10 8.06406 10 8.18103V14.191C10 14.5627 9.60884 14.8044 9.27639 14.6382Z", stroke: "current", strokeWidth: 1.5 }));
const SvgFolder$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 14H3C1.89543 14 1 13.1046 1 12V2.5C1 2.22386 1.22386 2 1.5 2H11.5C11.7761 2 12 2.22357 12 2.49971C12 4.03226 12 6 12 6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4.90532 6.37873L3.15532 13.3787C3.07642 13.6943 3.3151 14 3.64039 14H12.6096C12.839 14 13.039 13.8439 13.0947 13.6213L14.8447 6.62127C14.9236 6.30569 14.6849 6 14.3596 6H5.39039C5.16095 6 4.96096 6.15615 4.90532 6.37873Z", stroke: "current", strokeWidth: 1.5 }));
const SvgHelp$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM7.975 5c-.804 0-1.377.514-1.499 1.062l-1.952-.435C4.872 4.068 6.337 3 7.975 3 9.835 3 11.5 4.399 11.5 6.308c0 .786-.22 1.408-.635 1.893-.361.421-.822.67-1.115.829l-.036.02c-.347.187-.493.278-.591.39-.055.063-.148.19-.148.56h-2c0-.781.223-1.398.642-1.876.356-.408.81-.652 1.098-.808l.046-.025c.34-.185.488-.278.585-.391.058-.068.154-.206.154-.592C9.5 5.668 8.904 5 7.975 5zM8 11.5a1.25 1.25 0 10-.002 2.499A1.25 1.25 0 008 11.5z", clipRule: "evenodd" }));
const SvgHelpOutline$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8 1.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zM.25 8a7.75 7.75 0 1115.5 0A7.75 7.75 0 01.25 8z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M7 11.5a1 1 0 112 0 1 1 0 01-2 0zM6.79 5.498c-.207.139-.385.37-.62.837l-1.34-.67c.265-.532.586-1.052 1.125-1.413.544-.365 1.208-.502 2.025-.502 1.495 0 2.77 1.163 2.77 2.673 0 .631-.168 1.125-.486 1.512-.281.342-.642.545-.878.678l-.027.015c-.275.155-.402.235-.489.339-.058.069-.14.2-.14.533h-1.5c0-.626.17-1.115.491-1.497.277-.33.633-.53.865-.661l.035-.02c.27-.152.397-.234.484-.34.06-.073.145-.213.145-.559 0-.613-.534-1.173-1.27-1.173-.663 0-.99.113-1.19.248z", clipRule: "evenodd" }));
const SvgHome$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 5.30902C2 5.11963 2.107 4.9465 2.27639 4.8618L7.77639 2.1118C7.91716 2.04142 8.08284 2.04142 8.22361 2.1118L13.7236 4.8618C13.893 4.9465 14 5.11963 14 5.30902V13.5C14 13.7761 13.7761 14 13.5 14H2.5C2.22386 14 2 13.7761 2 13.5V5.30902Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 11C6 9.89543 6.89543 9 8 9V9C9.10457 9 10 9.89543 10 11V13.5C10 13.7761 9.77614 14 9.5 14H6.5C6.22386 14 6 13.7761 6 13.5V11Z", stroke: "current", strokeWidth: 1.5 }));
const SvgInfo$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM9 8v5H7V8h2zM8 3a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 008 3z", clipRule: "evenodd" }));
const SvgInfoOutline$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M9 5a1 1 0 11-1.999.001A1 1 0 019 5zM8.75 7.5V12h-1.5V7.5h1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8 1.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zM.25 8a7.75 7.75 0 1115.5 0A7.75 7.75 0 01.25 8z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M7 5a1 1 0 111.999-.001A1 1 0 017 5z", clipRule: "evenodd" }));
const SvgLink$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9 5H12C13.6569 5 15 6.34315 15 8V8C15 9.65685 13.6569 11 12 11H9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 5H4C2.34315 5 1 6.34315 1 8V8C1 9.65685 2.34315 11 4 11H7", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 8H11", stroke: "current", strokeWidth: 1.5 }));
const SvgLinkExternal$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10 1H15V6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15 1L7 9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5.71429 4H3C1.89543 4 1 4.89543 1 6V13C1 14.1046 1.89543 15 3 15H10C11.1046 15 12 14.1046 12 13V10.2857", stroke: "current", strokeWidth: 1.5 }));
const SvgList$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 4, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 12, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 4H16", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 12H16", stroke: "current", strokeWidth: 1.5 }));
const SvgLockClosed$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M4.25 6.25H3.5c-.69 0-1.25.56-1.25 1.25V13A2.75 2.75 0 005 15.75h6A2.75 2.75 0 0013.75 13V7.5c0-.69-.56-1.25-1.25-1.25h-.75V3.857A3.607 3.607 0 008.143.25H8A3.75 3.75 0 004.25 4v2.25zm1.5 0h4.5V3.857A2.107 2.107 0 008.143 1.75H8A2.25 2.25 0 005.75 4v2.25zm-2 6.75V7.75h8.5V13c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", d: "M9 11a1 1 0 11-2 0 1 1 0 012 0z" }));
const SvgLockOpen$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M4.25 6.25H3.5c-.69 0-1.25.56-1.25 1.25V13A2.75 2.75 0 005 15.75h6A2.75 2.75 0 0013.75 13V7.5c0-.69-.56-1.25-1.25-1.25H5.75V4A2.25 2.25 0 018 1.75h.143c1.164 0 2.107.943 2.107 2.107h1.5A3.607 3.607 0 008.143.25H8A3.75 3.75 0 004.25 4v2.25zM3.75 13V7.75h8.5V13c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", d: "M9 11a1 1 0 11-2 0 1 1 0 012 0z" }));
const SvgLogin$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M5 12V13C5 14.1046 5.89543 15 7 15H13C14.1046 15 15 14.1046 15 13V3C15 1.89543 14.1046 1 13 1H7C5.89543 1 5 1.89543 5 3V4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 8L0 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 11L11 8L8 5", stroke: "current", strokeWidth: 1.5 }));
const SvgLogout$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 4L8 3C8 1.89543 7.10457 1 6 1L3 1C1.89543 1 0.999999 1.89543 0.999999 3L0.999998 13C0.999998 14.1046 1.89543 15 3 15L6 15C7.10457 15 8 14.1046 8 13L8 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14 8L5 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11 11L14 8L11 5", stroke: "current", strokeWidth: 1.5 }));
const SvgHardshipWithdrawal = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3.49995 0.969673L3.49995 12C3.49995 13.1046 4.39538 14 5.49995 14L10.5 14C11.6045 14 12.5 13.1046 12.5 12L12.5 10M12.5 0.969673L12.5 10M3.49995 10L3.03027 10C1.9257 10 1.03027 9.10457 1.03027 8L1.03027 4.96967L1.03028 2.96967C1.03028 1.8651 1.92571 0.969671 3.03028 0.969672L13.0303 0.969673C14.1348 0.969673 15.0303 1.8651 15.0303 2.96967L15.0303 4.96967L15.0303 8C15.0303 9.10457 14.1348 10 13.0303 10L12.5 10", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10.4166 5.85181C10.4166 5.85181 10.4166 4.31476 8.11007 4.31476C6.67324 4.31476 5.80542 5.08286 5.80542 5.85181C5.80542 6.96382 6.88535 7.23507 8.11007 7.38885", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.10913 2.77771V3.91378", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.80542 8.9259C5.80542 8.9259 5.80542 10.463 8.11191 10.463C9.54875 10.463 10.4166 9.69485 10.4166 8.9259C10.4166 7.80797 9.33663 7.54264 8.11191 7.38885", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.11108 12L8.11108 10.463", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgMail$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 1, y: 2, width: 14, height: 12, rx: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15 5L9.16252 9.16966C8.46713 9.66637 7.53297 9.66637 6.83757 9.16966L1 5", stroke: "current", strokeWidth: 1.5 }));
const SvgMenu$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 13L15 13", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 3L15 3", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 8L15 8", stroke: "current", strokeWidth: 1.5 }));
const SvgMerge$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M11 11L14 8L11 5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 8L6 8L1 3", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M1 13L6 8", stroke: "current", strokeWidth: 1.5 }));
const SvgMinus$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 8L14 8", stroke: "current", strokeWidth: 1.5 }));
const SvgMinusBold = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "current", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 8L14 8", stroke: "current", strokeWidth: 2.5 }));
const SvgMinusCircle$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 8L12 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, stroke: "current", strokeWidth: 1.5 }));
const SvgMobilePhone$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9.5 3.5H6.5M5.28571 15H10.7143C11.5144 15 11.9144 15 12.22 14.8474C12.4888 14.7132 12.7073 14.499 12.8443 14.2356C13 13.9361 13 13.5441 13 12.76V3.24C13 2.45593 13 2.06389 12.8443 1.76441C12.7073 1.50099 12.4888 1.28681 12.22 1.15259C11.9144 1 11.5144 1 10.7143 1H9.42857H6.57143H5.28571C4.48564 1 4.0856 1 3.78001 1.15259C3.51121 1.28681 3.29267 1.50099 3.1557 1.76441C3 2.06389 3 2.45593 3 3.24V12.76C3 13.5441 3 13.9361 3.1557 14.2356C3.29267 14.499 3.51121 14.7132 3.78001 14.8474C4.0856 15 4.48564 15 5.28571 15Z", stroke: "#191817", strokeOpacity: 0.75, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgMoneyMovement = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.76738 4.25658C10.6628 4.39391 11.2552 4.77991 11.6187 5.26431C11.834 5.55129 11.942 5.83869 11.9964 6.05626C12.0238 6.16546 12.0382 6.25947 12.0458 6.33092C12.0497 6.36677 12.0519 6.39734 12.0531 6.42175C12.0537 6.43397 12.0541 6.44469 12.0543 6.45381L12.0545 6.46629L12.0546 6.47162L12.0546 6.47405L12.0546 6.47521C12.0546 6.47577 12.0546 6.47633 11.3046 6.47633C10.5546 6.47633 10.5546 6.47687 10.5546 6.47741L10.5546 6.47847L10.5546 6.48048L10.5546 6.48416L10.5547 6.49011L10.555 6.49669L10.555 6.49726L10.5544 6.49079C10.5531 6.4789 10.5497 6.45386 10.5413 6.4202C10.5242 6.35207 10.4894 6.25852 10.4188 6.16454C10.3038 6.01118 9.97839 5.70252 9.01795 5.70252C8.43573 5.70252 8.02605 5.85815 7.78225 6.0353C7.53416 6.21556 7.48315 6.39015 7.48315 6.47633C7.48315 6.62414 7.51689 6.70135 7.54724 6.74779C7.58107 6.79955 7.64481 6.86413 7.77367 6.93297C8.05789 7.08482 8.50234 7.1795 9.1114 7.25598L8.92451 8.7443C8.31939 8.66831 7.62145 8.55231 7.06681 8.25598C6.77624 8.10073 6.49644 7.88184 6.29158 7.56836C6.08325 7.24956 5.98315 6.87974 5.98315 6.47633C5.98315 5.80019 6.36232 5.21287 6.90052 4.82181C7.27453 4.55005 7.73897 4.35865 8.26738 4.26597V3.42871H9.76738V4.25658ZM11.7464 8.42988C11.9549 8.74934 12.0546 9.11988 12.0546 9.52395C12.0546 10.2001 11.6754 10.7874 11.1372 11.1785C10.7629 11.4505 10.2979 11.642 9.76887 11.7346V12.5716H8.26887V11.7435C7.37425 11.6059 6.78231 11.2201 6.41907 10.736C6.20375 10.449 6.09571 10.1616 6.04129 9.94401C6.01398 9.83482 5.99955 9.74081 5.99189 9.66936C5.98805 9.63351 5.98587 9.60294 5.98465 9.57853C5.98404 9.56631 5.98366 9.55559 5.98344 9.54647L5.98322 9.53399L5.98317 9.52866L5.98316 9.52623L5.98315 9.52507C5.98315 9.52451 5.98315 9.52395 6.73315 9.52395C7.48315 9.52395 7.48315 9.5234 7.48315 9.52287L7.48315 9.52181L7.48314 9.5198L7.48311 9.51612L7.483 9.51017L7.48278 9.50359C7.48275 9.50305 7.48273 9.50279 7.48273 9.50282L7.48335 9.50949C7.48462 9.52138 7.48805 9.54641 7.49647 9.58007C7.51351 9.64821 7.54839 9.74176 7.6189 9.83574C7.73396 9.9891 8.05935 10.2978 9.01978 10.2978C9.602 10.2978 10.0117 10.1421 10.2555 9.96498C10.5036 9.78471 10.5546 9.61013 10.5546 9.52395C10.5546 9.37387 10.5205 9.29592 10.4902 9.24958C10.4566 9.19809 10.3934 9.13396 10.265 9.06559C9.98096 8.91435 9.5371 8.82099 8.92634 8.7443L9.11323 7.25598C9.71664 7.33175 10.4152 7.44615 10.97 7.74162C11.2611 7.8966 11.5413 8.11557 11.7464 8.42988Z", fill: "current" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.43764 3.96057C5.55779 2.69145 7.19426 1.89282 9.0182 1.89282C12.3911 1.89282 15.1253 4.62708 15.1253 7.99997C15.1253 11.3728 12.3911 14.1071 9.0182 14.1071C5.90273 14.1071 3.33213 11.7743 2.9579 8.76013L3.51781 9.20806L4.23175 8.31564L2.32699 6.79183L1.88078 6.43486L1.52381 6.88107L0 8.78583L0.892422 9.49977L1.45258 8.79957C1.85218 12.625 5.08694 15.6071 9.0182 15.6071C13.2195 15.6071 16.6253 12.2013 16.6253 7.99997C16.6253 3.79866 13.2195 0.392822 9.0182 0.392822C6.74604 0.392822 4.70584 1.38993 3.31304 2.96797C2.79404 3.55599 2.36427 4.22526 2.04531 4.95466L3.41965 5.55565C3.67539 4.97083 4.02036 4.43334 4.43764 3.96057Z", fill: "current" }));
const SvgNotebook$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 2, y: 1, width: 12, height: 14, rx: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 5H9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 8H11", stroke: "current", strokeWidth: 1.5 }));
const SvgPercent$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 13L13 3", stroke: "current", strokeWidth: 1.5, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 4, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 12, r: 2, stroke: "current", strokeWidth: 1.5 }));
const SvgPhone$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6947 11.5676L13.2448 10.1177C12.8381 9.71112 12.1783 9.71112 11.7717 10.1177L11.0364 10.853C10.6297 11.2596 9.96989 11.2596 9.56328 10.853L7.35488 8.64472L5.14648 6.43644C4.73986 6.02984 4.73986 5.37125 5.14648 4.96465L5.88302 4.22816C6.28964 3.82156 6.28964 3.16297 5.88302 2.75637L4.43185 1.30529C4.01063 0.884082 3.31426 0.899907 2.9186 1.34546C0.517853 4.04068 -0.277122 6.90147 4.41116 11.5895C9.09944 16.2775 11.9592 15.4814 14.6545 13.082C15.1001 12.6851 15.1159 11.9888 14.6947 11.5676Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 5C15 2.79093 13.2091 1 11 1", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgPlus$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 14V2", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 8L14 8", stroke: "current", strokeWidth: 1.5 }));
const SvgPlusBold = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 14V2", stroke: "current", strokeWidth: 2.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 8L14 8", stroke: "current", strokeWidth: 2.5 }));
const SvgPlusCircle$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 12V4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4 8L12 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, stroke: "current", strokeWidth: 1.5 }));
const SvgPopoverTailDown = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 5L8 11L14 5", stroke: "current", strokeWidth: 0.01 }));
const SvgPopoverTailLeft = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M11 14L5 8L11 2", stroke: "current", strokeWidth: 0.01 }));
const SvgPopoverTailRight = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M5 14L11 8L5 2", stroke: "current", strokeWidth: 0.01 }));
const SvgPopoverTailUp = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 11L8 5L2 11", stroke: "current", strokeWidth: 0.01 }));
const SvgQuote$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M13 3H11.5C10.3954 3 9.5 3.89543 9.5 5V7.6C9.5 8.70457 10.3954 9.6 11.5 9.6H11.9C11.9552 9.6 12 9.64477 12 9.7V12.3901C12 12.7056 12.2917 12.9443 12.588 12.8358C14.6702 12.0735 14.9718 9.85316 14.9979 9.61989C14.9996 9.6054 15 9.5927 15 9.57811V5C15 3.89543 14.1046 3 13 3Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4.5 3H3C1.89543 3 1 3.89543 1 5V7.6C1 8.70457 1.89543 9.6 3 9.6H3.4C3.45523 9.6 3.5 9.64477 3.5 9.7V12.3901C3.5 12.7056 3.79171 12.9443 4.08801 12.8358C6.17021 12.0735 6.47181 9.85316 6.49794 9.61989C6.49956 9.6054 6.5 9.5927 6.5 9.57811V5C6.5 3.89543 5.60457 3 4.5 3Z", stroke: "current", strokeWidth: 1.5 }));
const SvgQuestionCircle = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 7, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 6.034C6.18794 5.15652 7.00343 4.49707 7.98024 4.49707C9.09579 4.49707 10 5.35842 10 6.42015C10 8.3747 7.98024 7.5786 7.98024 9.49707", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 11.5, r: 0.5, strokeWidth: 1, stroke: "current" }));
const SvgSearch$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 7.5, cy: 7.5, r: 5.5, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11 11L15 15", stroke: "current", strokeWidth: 1.5 }));
const SvgSend$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14.6718 2.70985L9.15283 14.6451C8.95146 15.0806 8.31189 15.01 8.21033 14.5411L6.84554 8.23993C6.82608 8.15009 6.78224 8.06736 6.71883 8.00082L1.80524 2.84495C1.50191 2.52666 1.72752 2 2.1672 2H14.2179C14.583 2 14.825 2.37851 14.6718 2.70985Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 7.5L14 2.5", stroke: "current", strokeWidth: 1.5 }));
const SvgSettings$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 8, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14.9607 6.03597L13.2581 3.01439C13.1579 2.81295 12.8575 2.71223 12.6572 2.81295L10.9545 3.82014C10.6541 4.02158 10.2535 3.82014 10.2535 3.41727V1.40288C10.2535 1.20144 10.0532 1 9.85285 1H6.2473C6.047 1 5.84669 1.20144 5.84669 1.40288V3.41727C5.84669 3.71942 5.44607 3.92086 5.14561 3.82014L3.44299 2.81295C3.24268 2.71223 2.94222 2.81295 2.84206 3.01439L1.13944 6.03597C0.939137 6.23741 1.03929 6.43885 1.2396 6.64029L2.94222 7.64748C3.24268 7.7482 3.24268 8.2518 2.94222 8.35252L1.2396 9.35971C1.03929 9.56115 0.939137 9.76259 1.03929 9.96403L2.74191 12.9856C2.94222 13.2878 3.14253 13.2878 3.44299 13.1871L5.14561 12.1799C5.44607 11.9784 5.84669 12.1799 5.84669 12.5827V14.5971C5.84669 14.7986 6.047 15 6.2473 15H9.7527C9.953 15 10.1533 14.7986 10.1533 14.5971V12.5827C10.1533 12.2806 10.5539 12.0791 10.8544 12.1799L12.557 13.1871C12.7573 13.2878 13.0578 13.1871 13.1579 12.9856L14.9607 9.96403C15.0609 9.76259 14.9607 9.46043 14.7604 9.35971L13.0578 8.35252C12.7573 8.15108 12.7573 7.7482 13.0578 7.54676L14.7604 6.53957C14.9607 6.43885 15.0609 6.23741 14.9607 6.03597Z", stroke: "current", strokeWidth: 1.5, strokeMiterlimit: 10 }));
const SvgSettingsSlider$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M0 12L8 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 12, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 12L16 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M0 4L3 4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 4L16 4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 4, r: 2, stroke: "current", strokeWidth: 1.5 }));
const SvgShare$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 11, cy: 13, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 3, cy: 8, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 13, cy: 3, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11.5 4L5 7", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9.5 12L4.5 9", stroke: "current", strokeWidth: 1.5 }));
const SvgShieldCheck$2 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 8.77777V2.99998C2 1.89541 2.89544 0.999978 4.00001 0.999982L12 1.00002C13.1046 1.00002 14 1.89545 14 3.00002V8.77782C14 10.5926 12.8 13.1333 8 15C3.2 13.1333 2 10.5926 2 8.77777Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4.5 8L7.00005 10L11.5 4.5", stroke: "current", strokeWidth: 1.5 }));
const SvgShieldDollar$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 8.77777V2.99998C2 1.89541 2.89544 0.999978 4.00001 0.999982L12 1.00002C13.1046 1.00002 14 1.89545 14 3.00002V8.77782C14 10.5926 12.8 13.1333 8 15C3.2 13.1333 2 10.5926 2 8.77777Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10.4166 5.85181C10.4166 5.85181 10.4166 4.31476 8.11007 4.31476C6.67324 4.31476 5.80542 5.08286 5.80542 5.85181C5.80542 6.96382 6.88535 7.23507 8.11007 7.38885", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.10913 2.77771V3.91378", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.80542 8.9259C5.80542 8.9259 5.80542 10.463 8.11191 10.463C9.54875 10.463 10.4166 9.69485 10.4166 8.9259C10.4166 7.80797 9.33663 7.54264 8.11191 7.38885", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.11108 12L8.11108 10.463", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgSignal$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M13.25 8c0-2.527-1.057-4.814-2.77-6.46L11.52.46c1.99 1.912 3.23 4.583 3.23 7.54s-1.24 5.628-3.23 7.54l-1.04-1.08c1.713-1.646 2.77-3.933 2.77-6.46z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M9.25 8c0-1.302-.636-2.516-1.729-3.423l.958-1.154C9.858 4.567 10.749 6.18 10.749 8c0 1.82-.891 3.433-2.27 4.577l-.958-1.154C8.614 10.516 9.25 9.303 9.25 8z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 8, r: 2, fill: "current" }));
const SvgSparkle$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6.44398 14.5716C6.22629 15.1428 5.39419 15.1428 5.17649 14.5716L4.27547 12.2075C4.20702 12.0279 4.06119 11.8864 3.87623 11.8199L1.44123 10.9451C0.852921 10.7338 0.852921 9.92589 1.44123 9.71453L3.87623 8.83974C4.06119 8.77329 4.20702 8.6317 4.27547 8.45212L5.17649 6.08803C5.39419 5.51685 6.22629 5.51685 6.44398 6.08803L7.34501 8.45212C7.41346 8.6317 7.55929 8.77329 7.74425 8.83974L10.1792 9.71453C10.7676 9.92589 10.7676 10.7338 10.1792 10.9451L7.74425 11.8199C7.55929 11.8864 7.41346 12.0279 7.34501 12.2075L6.44398 14.5716Z" }), /* @__PURE__ */ React.createElement("path", { d: "M11.8981 7.42418C11.7893 7.70977 11.3732 7.70977 11.2644 7.42418L10.5401 5.52383C10.5059 5.43404 10.433 5.36325 10.3405 5.33003L8.38315 4.62683C8.089 4.52115 8.089 4.11722 8.38315 4.01154L10.3405 3.30835C10.433 3.27512 10.5059 3.20433 10.5401 3.11454L11.2644 1.21419C11.3732 0.928602 11.7893 0.928602 11.8981 1.21419L12.6224 3.11454C12.6566 3.20433 12.7296 3.27512 12.822 3.30835L14.7794 4.01154C15.0735 4.11722 15.0735 4.52115 14.7794 4.62683L12.822 5.33003C12.7296 5.36325 12.6566 5.43404 12.6224 5.52383L11.8981 7.42418Z" }));
const SvgSpinner$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 2.34164C5.18107 2.63045 4.4123 3.10235 3.75729 3.75736C1.41414 6.10051 1.41414 9.89949 3.75729 12.2426C6.10043 14.5858 9.89942 14.5858 12.2426 12.2426C14.5857 9.89949 14.5857 6.10051 12.2426 3.75736C11.5876 3.10235 10.8188 2.63045 9.99986 2.34164", stroke: "current", strokeWidth: 1.5 }));
const SvgSync$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 8V9.84203C11.9988 11.4273 11.3387 12.9909 10.0936 14.0005C8.19684 15.5385 5.59827 15.2595 4 13.4526", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 11L12 8L15 11", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4 8L4 6.15797C4.00117 4.57269 4.66131 3.00911 5.90644 1.99947C7.80316 0.461468 10.4017 0.740487 12 2.54748", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 5L4 8L1 5", stroke: "current", strokeWidth: 1.5 }));
const SvgThumbsUp$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 7.5C1 7.22386 1.22386 7 1.5 7H5V14H1.5C1.22386 14 1 13.7761 1 13.5V7.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 14H12.2654C13.2607 14 14.1046 13.2681 14.2453 12.2828L14.6739 9.28282C14.846 8.07795 13.9111 6.99998 12.694 6.99998H11C11 6.99998 12 5.5 12 4C12 2 9 2 9 2L7.85714 4.11858C7.85714 4.11858 6.42857 6.99998 5 6.99998", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgUpload$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 12V13C1 14.1046 1.89543 15 3 15H13C14.1046 15 15 14.1046 15 13V12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 2L8 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11 5L8 2L5 5", stroke: "current", strokeWidth: 1.5 }));
const SvgUserOne$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 5C11 6.65675 9.65675 8 8 8C6.34325 8 5 6.65675 5 5C5 3.34325 6.34325 2 8 2C9.65675 2 11 3.34325 11 5Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 13C13 10 13 8 8 8C3 8 3 10 2 13H14Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgUserTwo$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 8, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 11C7.44948 11 5.345 12.5277 5.03841 14.5018C4.99603 14.7746 5.22386 15 5.5 15H14.5C14.7761 15 15.004 14.7746 14.9616 14.5018C14.655 12.5277 12.5505 11 10 11Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 3C7 1.89543 6.10457 1 5 1C3.89543 1 3 1.89543 3 3C3 4.10457 3.89543 5 5 5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3.85734 9H1.5C1.22386 9 0.996722 8.77502 1.03082 8.50099C1.27643 6.52736 2.95985 5 5 5", stroke: "current", strokeWidth: 1.5 }));
const SvgWarning$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M14.284 16H1.716C.422 16-.404 14.64.204 13.514l6.284-11.62c.645-1.192 2.379-1.192 3.024 0l6.284 11.62C16.405 14.64 15.578 16 14.284 16zM9 5v5H7V5h2zm-1 6.75a1.25 1.25 0 10-.002 2.499A1.25 1.25 0 008 11.75z", clipRule: "evenodd" }));
const SvgWarningOutline$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M6.911 1.422a1.25 1.25 0 012.186 0l6.65 11.97a1.25 1.25 0 01-1.093 1.858h-13.3A1.25 1.25 0 01.26 13.393l6.65-11.97zm1.093 1.122L1.778 13.75H14.23L8.004 2.544z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8.75 6v3.5h-1.5V6h1.5zM7 11.75a1 1 0 112 0 1 1 0 01-2 0z", clipRule: "evenodd" }));
const SvgX$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 14L14 2", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 2L14 14", stroke: "current", strokeWidth: 1.5 }));
const SvgXCircle$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M16 8A8 8 0 100 8a8 8 0 0016 0zM6.586 8L3.793 5.207l1.414-1.414L8 6.586l2.793-2.793 1.414 1.414L9.414 8l2.793 2.793-1.414 1.414L8 9.414l-2.793 2.793-1.414-1.414L6.586 8z", clipRule: "evenodd" }));
const SvgXCircleOutline$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M.25 8a7.75 7.75 0 1115.5 0A7.75 7.75 0 01.25 8zM8 1.75a6.25 6.25 0 100 12.5 6.25 6.25 0 000-12.5zm0 7.31l-2.47 2.47-1.06-1.06L6.94 8 4.47 5.53l1.06-1.06L8 6.94l2.47-2.47 1.06 1.06L9.06 8l2.47 2.47-1.06 1.06L8 9.06z", clipRule: "evenodd" }));
const icons16 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrowDown: SvgArrowDown$1,
  arrowLeft: SvgArrowLeft$1,
  arrowLeftRight: SvgArrowLeftRight$1,
  arrowRight: SvgArrowRight$1,
  arrowUp: SvgArrowUp$1,
  bank: SvgBank$2,
  bell: SvgBell$2,
  bookClosed: SvgBookClosed,
  bookOpen: SvgBookOpen$1,
  briefcase: SvgBriefcase$2,
  building: SvgBuilding$2,
  calendar: SvgCalendar$2,
  caretLeftDouble: SvgCaretLeftDouble,
  caretRightDouble: SvgCaretRightDouble$1,
  chartBar: SvgChartBar$1,
  chartLine: SvgChartLine$1,
  chartPie: SvgChartPie$1,
  chat: SvgChat$2,
  chatPerson: SvgChatPerson$1,
  check: SvgCheck$1,
  checkBold: SvgCheckBold,
  checkCircle: SvgCheckCircle$1,
  checkCircleOutline: SvgCheckCircleOutline$1,
  chevronDown: SvgChevronDown$1,
  chevronLeft: SvgChevronLeft$1,
  chevronRight: SvgChevronRight$1,
  chevronUp: SvgChevronUp$1,
  clock: SvgClock,
  clockArrow: SvgClockArrow$1,
  copy: SvgCopy$1,
  delete: SvgDelete$1,
  document: SvgDocument$1,
  dollar: SvgDollar$1,
  dollarCircle: SvgDollarCircle$1,
  dot: SvgDot,
  dotEmpty: SvgDotEmpty,
  dotFilled: SvgDotFilled,
  download: SvgDownload$1,
  edit: SvgEdit$1,
  ellipsis: SvgEllipsis$1,
  error: SvgError$1,
  errorOutline: SvgErrorOutline$1,
  eyeClosed: SvgEyeClosed$1,
  eyeOpen: SvgEyeOpen$1,
  filter: SvgFilter$1,
  folder: SvgFolder$2,
  hardshipWithdrawal: SvgHardshipWithdrawal,
  help: SvgHelp$1,
  helpOutline: SvgHelpOutline$1,
  home: SvgHome$1,
  info: SvgInfo$1,
  infoOutline: SvgInfoOutline$1,
  link: SvgLink$1,
  linkExternal: SvgLinkExternal$1,
  list: SvgList$1,
  lockClosed: SvgLockClosed$1,
  lockOpen: SvgLockOpen$1,
  login: SvgLogin$1,
  logout: SvgLogout$1,
  mail: SvgMail$1,
  menu: SvgMenu$1,
  merge: SvgMerge$1,
  minus: SvgMinus$1,
  minusBold: SvgMinusBold,
  minusCircle: SvgMinusCircle$1,
  mobilePhone: SvgMobilePhone$1,
  moneyMovement: SvgMoneyMovement,
  notebook: SvgNotebook$1,
  percent: SvgPercent$1,
  phone: SvgPhone$1,
  plus: SvgPlus$1,
  plusBold: SvgPlusBold,
  plusCircle: SvgPlusCircle$1,
  popoverTailDown: SvgPopoverTailDown,
  popoverTailLeft: SvgPopoverTailLeft,
  popoverTailRight: SvgPopoverTailRight,
  popoverTailUp: SvgPopoverTailUp,
  questionCircle: SvgQuestionCircle,
  quote: SvgQuote$1,
  search: SvgSearch$1,
  send: SvgSend$1,
  settings: SvgSettings$1,
  settingsSlider: SvgSettingsSlider$1,
  share: SvgShare$1,
  shieldCheck: SvgShieldCheck$2,
  shieldDollar: SvgShieldDollar$1,
  signal: SvgSignal$1,
  sparkle: SvgSparkle$1,
  spinner: SvgSpinner$1,
  sync: SvgSync$1,
  thumbsUp: SvgThumbsUp$1,
  upload: SvgUpload$1,
  userOne: SvgUserOne$1,
  userTwo: SvgUserTwo$1,
  warning: SvgWarning$1,
  warningOutline: SvgWarningOutline$1,
  x: SvgX$1,
  xCircle: SvgXCircle$1,
  xCircleOutline: SvgXCircleOutline$1
}, Symbol.toStringTag, { value: "Module" }));
const SvgCheckedCheckbox = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 4, fill: "none" }), /* @__PURE__ */ React.createElement("path", { d: "M14.5 6L8.5 13.5L5 10.5", fill: "transparent", stroke: "current", strokeWidth: 2 }));
const SvgIndeterminateCheckbox = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { width: 20, height: 20, rx: 4, fill: "none" }), /* @__PURE__ */ React.createElement("path", { d: "M5 10H15", stroke: "current", strokeWidth: 2 }));
const SvgUncheckedCheckbox = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 19, height: 19, rx: 3.5, fill: "white", stroke: "current" }));
const icons20 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  checkedCheckbox: SvgCheckedCheckbox,
  indeterminateCheckbox: SvgIndeterminateCheckbox,
  uncheckedCheckbox: SvgUncheckedCheckbox
}, Symbol.toStringTag, { value: "Module" }));
const SvgArrowDown = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 12L12 20L4 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 20L12 3", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowLeft = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 20L4 12L12 4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4 12L21 12", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowLeftRight = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 17L19 17", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 21L3 17L7 13", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M21 7L5 7", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17 11L21 7L17 3", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowRight = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 20L20 12L12 4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M20 12L3 12", stroke: "current", strokeWidth: 1.5 }));
const SvgArrowUp = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 12L12 4L20 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 4L12 21", stroke: "current", strokeWidth: 1.5 }));
const SvgBank$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 19C3 17.8954 3.89543 17 5 17H19C20.1046 17 21 17.8954 21 19V20.5C21 20.7761 20.7761 21 20.5 21H3.5C3.22386 21 3 20.7761 3 20.5V19Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 5.78414C3 5.55761 3.15229 5.35939 3.37117 5.30102L11.8712 3.03436C11.9556 3.01184 12.0444 3.01184 12.1288 3.03436L20.6288 5.30102C20.8477 5.35939 21 5.55761 21 5.78414V8.5C21 8.77614 20.7761 9 20.5 9H3.5C3.22386 9 3 8.77614 3 8.5V5.78414Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M18 17V9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 17V9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14 17V9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 17V9", stroke: "current", strokeWidth: 1.5 }));
const SvgBell$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 4C15.3137 4 18 6.68629 18 10V13.5C18 13.5 19.7733 13.9433 19.9803 16.4997C20.0026 16.775 19.7761 17 19.5 17H15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15.5 17H4.5C4.22386 17 3.99736 16.775 4.01966 16.4997C4.22671 13.9433 6 13.5 6 13.5V10C6 6.68629 8.68629 4 12 4V2", stroke: "current", strokeWidth: 1.5 }));
const SvgBookOpen = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 19.7865C12 19.8713 12.1011 19.9211 12.1703 19.8721C12.6419 19.5384 14.0594 18.6667 16 18.6667C18.4 18.6667 18.6 20 21 20V5.33333C18.6 5.33333 18.4 4 16 4C13.6 4 12 5.33333 12 5.33333V19.7865Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 19.7865C12 19.8713 11.8989 19.9211 11.8297 19.8721C11.3581 19.5384 9.94058 18.6667 8 18.6667C5.6 18.6667 5.4 20 3 20V5.33333C5.4 5.33333 5.6 4 8 4C10.4 4 12 5.33333 12 5.33333V19.7865Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 21V18", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M18 9H15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M18 14H15", stroke: "current", strokeWidth: 1.5 }));
const SvgBriefcase$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 9C3 7.89543 3.89543 7 5 7H19C20.1046 7 21 7.89543 21 9V17C21 18.1046 20.1046 19 19 19H5C3.89543 19 3 18.1046 3 17V9Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 10L7.12634 11.8339C10.2291 13.2129 13.7709 13.2129 16.8737 11.8339L21 10", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M16 7V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V7", stroke: "current", strokeWidth: 1.5 }));
const SvgBuilding$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9 3.5C9 3.22386 9.22386 3 9.5 3H20.5C20.7761 3 21 3.22386 21 3.5V21H9V3.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 12.5C3 12.2239 3.22386 12 3.5 12H8.5C8.77614 12 9 12.2239 9 12.5V21H3V12.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 11L18 11", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 7L18 7", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 18C13 16.8954 13.8954 16 15 16V16C16.1046 16 17 16.8954 17 18V21H13V18Z", stroke: "current", strokeWidth: 1.5 }));
const SvgCalendar$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 7C3 5.89543 3.89543 5 5 5H19C20.1046 5 21 5.89543 21 7V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V7Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 11H21", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7 8L7 2", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 8L12 2", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17 8V2", stroke: "current", strokeWidth: 1.5 }));
const SvgCaretRightDouble = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 21L12 12L3 3", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 21L21 12L12 3", stroke: "current", strokeWidth: 1.5 }));
const SvgChartBar = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 21L22 21", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 11.5C3 11.2239 3.22386 11 3.5 11H8.5C8.77614 11 9 11.2239 9 11.5V16H3V11.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 7.5C9 7.22386 9.22386 7 9.5 7H15V16H9V7.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15 3.5C15 3.22386 15.2239 3 15.5 3H20.5C20.7761 3 21 3.22386 21 3.5V16H15V3.5Z", stroke: "current", strokeWidth: 1.5 }));
const SvgChartLine = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M21.53 7.53l-7.585 7.586a2.75 2.75 0 01-3.89 0l-1.171-1.171a1.25 1.25 0 00-1.768 0L3.53 17.53l-1.06-1.06 3.586-3.586a2.75 2.75 0 013.889 0l1.171 1.171a1.25 1.25 0 001.768 0L20.47 6.47l1.06 1.06z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M2.25 6A2.75 2.75 0 015 3.25h14A2.75 2.75 0 0121.75 6v12A2.75 2.75 0 0119 20.75H5A2.75 2.75 0 012.25 18V6zM5 4.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25H5z", clipRule: "evenodd" }));
const SvgChartPie = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M18.5 13C18.7761 13 19.0016 13.2241 18.9844 13.4997C18.8964 14.9063 18.438 16.2679 17.6518 17.4446C16.7727 18.7602 15.5233 19.7855 14.0615 20.391C12.5997 20.9965 10.9911 21.155 9.43928 20.8463C7.88743 20.5376 6.46197 19.7757 5.34315 18.6569C4.22433 17.538 3.4624 16.1126 3.15372 14.5607C2.84504 13.0089 3.00347 11.4003 3.60897 9.93853C4.21447 8.47672 5.23985 7.22729 6.55544 6.34824C7.73215 5.56199 9.09375 5.10363 10.5003 5.01562C10.7759 4.99837 11 5.22386 11 5.5V12.5C11 12.7761 11.2239 13 11.5 13H18.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M20.5 13C20.7761 13 21.0013 12.776 20.9875 12.5002C20.9303 11.3577 20.6775 10.2323 20.2388 9.17317C19.7362 7.95991 18.9997 6.85752 18.0711 5.92893C17.1425 5.00035 16.0401 4.26375 14.8268 3.7612C13.7677 3.32251 12.6423 3.06967 11.4998 3.0125C11.224 2.9987 11 3.22386 11 3.5L11 12.5C11 12.7761 11.2239 13 11.5 13H20.5Z", stroke: "current", strokeWidth: 1.5 }));
const SvgChat$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 18V22.7586C6 22.8477 6.10771 22.8923 6.17071 22.8293L11 18H19C20.1046 18 21 17.1046 21 16V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V16C3 17.1046 3.89543 18 5 18H6Z", stroke: "current", strokeWidth: 1.5 }));
const SvgChatPerson = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 18V22.7586C6 22.8477 6.10771 22.8923 6.17071 22.8293L11 18H19C20.1046 18 21 17.1046 21 16V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V16C3 17.1046 3.89543 18 5 18H6Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 10, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17 15C17 13.8954 14.7614 13 12 13C9.23858 13 7 13.8954 7 15", stroke: "current", strokeWidth: 1.5 }));
const SvgCheck = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 5L9 19L4 14.5", stroke: "current", strokeWidth: 1.5 }));
const SvgCheckCircle = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm3.72 5.375l-5.355 6.693-2.714-2.327-1.302 1.518 3.5 3 .786.674.646-.808 6-7.5-1.562-1.25z", clipRule: "evenodd" }));
const SvgCheckCircleOutline = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M17.086 8.469l-6.524 8.154L6.47 12.53l1.06-1.06 2.908 2.907 5.476-6.846 1.172.938z", clipRule: "evenodd" }));
const SvgChevronDown = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 8L12 16L20 8", stroke: "current", strokeWidth: 1.5 }));
const SvgChevronLeft = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M16 20L8 12L16 4", stroke: "current", strokeWidth: 1.5 }));
const SvgChevronRight = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 20L16 12L8 4", stroke: "current", strokeWidth: 1.5 }));
const SvgChevronUp = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 16L12 8L4 16", stroke: "current", strokeWidth: 1.5 }));
const SvgClockArrow = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 10.9266 3.18791 9.8971 3.53263 8.94258C3.79683 8.21103 4.22778 7.55567 4.68153 6.92395L7.5 3", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M12 7V12.2229C12 12.3953 12.0888 12.5555 12.235 12.6469L16 15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 9V3H2", stroke: "current", strokeWidth: 1.5 }));
const SvgCopy = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 9, width: 12, height: 12, rx: 2, stroke: "current", strokeWidth: 1.5, fill: "transparent" }), /* @__PURE__ */ React.createElement("path", { d: "M11 2.25C9.48122 2.25 8.25 3.48122 8.25 5V6H9.75V5C9.75 4.30964 10.3096 3.75 11 3.75H19C19.6904 3.75 20.25 4.30964 20.25 5V13C20.25 13.6904 19.6904 14.25 19 14.25H18V15.75H19C20.5188 15.75 21.75 14.5188 21.75 13V5C21.75 3.48122 20.5188 2.25 19 2.25H11Z", stroke: "transparent", strokeWidth: 0.01, fill: "current" }));
const SvgDelete = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M5 6H19V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V6Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 5.5C9 5.77614 9.22386 6 9.5 6H14.5C14.7761 6 15 5.77614 15 5.5V3.5C15 3.22386 14.7761 3 14.5 3H9.5C9.22386 3 9 3.22386 9 3.5V5.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 6H21", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14 17V10", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 17V10", stroke: "current", strokeWidth: 1.5 }));
const SvgDocument = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 13H12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 17H16", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M19 9V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H13", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 3L19 9H13.5C13.2239 9 13 8.77614 13 8.5V3Z", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgDollar = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M17 9C17 9 17 6 11.998 6C8.882 6 7 7.49918 7 9C7 11.1704 9.342 11.6998 11.998 12", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 3L12 21", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7 15C7 15 7 18 12.002 18C15.118 18 17 16.5008 17 15C17 12.818 14.658 12.3002 12.002 12", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgDollarCircle = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M15 10C15 10 15 8 11.9988 8C10.1292 8 9 8.99945 9 10C9 11.4469 10.4052 11.7999 11.9988 12", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.9976 6V7.47825", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 14C9 14 9 16 12.0012 16C13.8708 16 15 15.0005 15 14C15 12.5454 13.5948 12.2001 12.0012 12", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 18L12 16", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "current", strokeWidth: 1.5 }));
const SvgDownload = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 16L12 2", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 12L12 16L16 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 18V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V18", stroke: "current", strokeWidth: 1.5 }));
const SvgEdit = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M18.6142 3.41421L20.5858 5.38579C21.3668 6.16684 21.3668 7.43316 20.5858 8.21421L7.94645 20.8536C7.85268 20.9473 7.7255 21 7.59289 21H3V16.4071C3 16.2745 3.05268 16.1473 3.14645 16.0536L15.7858 3.41421C16.5668 2.63317 17.8332 2.63317 18.6142 3.41421Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14 5.5L18.5 10", stroke: "current", strokeWidth: 1.5 }));
const SvgEllipsis = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 20, cy: 12, r: 2, fill: "current" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 2, fill: "current" }), /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 12, r: 2, fill: "current" }));
const SvgError = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zm-11.5 4.5a1.5 1.5 0 112.999-.001 1.5 1.5 0 01-2.999.001zM13 13V6h-2v7h2z", clipRule: "evenodd" }));
const SvgErrorOutline = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12.75 6v7h-1.5V6h1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M10.75 16.5a1.25 1.25 0 112.499-.001 1.25 1.25 0 01-2.499.001z", clipRule: "evenodd" }));
const SvgEyeClosed = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M2 22L22 2", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9991 5.00122C8.41534 4.93174 4.71068 7.85196 2.38016 10.8437C1.87328 11.4996 1.87328 12.4963 2.38016 13.1521C4.65913 16.0806 8.3549 19.0693 11.9991 18.9988C15.6433 19.0693 19.3391 16.0806 21.6198 13.1521C22.1267 12.4963 22.1267 11.4996 21.6198 10.8437C19.2875 7.85196 15.5811 4.93174 11.9991 5.00122Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 12C15 13.6569 13.6569 15 12 15M9 12C9 10.3431 10.3431 9 12 9", stroke: "current", strokeWidth: 1.5 }));
const SvgEyeOpen = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 12C15 13.2134 14.269 14.3073 13.1479 14.7716C12.0268 15.2359 10.7364 14.9791 9.87847 14.121C9.02055 13.2628 8.76409 11.9723 9.22868 10.8514C9.69326 9.73039 10.7874 8.99968 12.0008 9C13.6574 9.00044 15 10.3434 15 12Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.9991 5.00122C8.41534 4.93174 4.71068 7.85196 2.38016 10.8437C1.87328 11.4996 1.87328 12.4963 2.38016 13.1521C4.65913 16.0806 8.3549 19.0693 11.9991 18.9988C15.6433 19.0693 19.3391 16.0806 21.6198 13.1521C22.1267 12.4963 22.1267 11.4996 21.6198 10.8437C19.2875 7.85196 15.5811 4.93174 11.9991 5.00122Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgFilter = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M13.2 21.4L10.2 19.15C10.0741 19.0556 10 18.9074 10 18.75V11.2071C10 11.0745 9.94732 10.9473 9.85355 10.8536L2.85355 3.85355C2.53857 3.53857 2.76165 3 3.20711 3H20.7929C21.2383 3 21.4614 3.53857 21.1464 3.85355L14.1464 10.8536C14.0527 10.9473 14 11.0745 14 11.2071V21C14 21.412 13.5296 21.6472 13.2 21.4Z", stroke: "current", strokeWidth: 1.5 }));
const SvgFolder$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 20H5C3.89543 20 3 19.1046 3 18V5.5C3 5.22386 3.22386 5 3.5 5H8.7591C8.91133 5 9.05526 5.06935 9.15013 5.1884L10.3499 6.69395C10.4447 6.813 10.5887 6.88235 10.7409 6.88235H17.5C17.7761 6.88235 18 7.10621 18 7.38235V11", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7.88604 11.3419L5.21937 19.3419C5.11145 19.6657 5.35243 20 5.69371 20H17.6396C17.8548 20 18.0459 19.8623 18.114 19.6581L20.7806 11.6581C20.8886 11.3343 20.6476 11 20.3063 11H8.36038C8.14516 11 7.9541 11.1377 7.88604 11.3419Z", stroke: "current", strokeWidth: 1.5 }));
const SvgHelp = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-.03 6c-1.068 0-1.833.666-1.995 1.375l-1.95-.447C8.426 7.181 10.11 6 11.97 6 14.082 6 16 7.546 16 9.692c0 .892-.256 1.581-.723 2.111-.41.465-.934.74-1.286.926l-.04.02c-.41.217-.62.338-.764.498-.097.109-.217.294-.217.753h-2c0-.884.26-1.567.73-2.09.404-.449.92-.72 1.267-.902l.052-.028c.405-.213.614-.337.757-.5.101-.113.224-.311.224-.788C14 8.866 13.206 8 11.97 8zm-1.22 9a1.25 1.25 0 112.499-.001A1.25 1.25 0 0110.75 17z", clipRule: "evenodd" }));
const SvgHelpOutline = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M10.75 17a1.25 1.25 0 112.499-.001A1.25 1.25 0 0110.75 17zM11.97 7.75c-1.168 0-2.046.73-2.239 1.57l-1.462-.336C8.64 7.366 10.208 6.25 11.97 6.25c2.002 0 3.78 1.461 3.78 3.442 0 .84-.24 1.468-.66 1.946-.38.43-.867.686-1.224.874l-.031.017c-.403.212-.655.352-.833.551-.145.16-.282.408-.282.92h-1.5c0-.831.242-1.451.666-1.923.373-.415.852-.667 1.204-.851.015-.008.03-.017.046-.024.398-.21.65-.354.828-.556.147-.166.286-.425.286-.954 0-.991-.935-1.942-2.28-1.942z", clipRule: "evenodd" }));
const SvgHome = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 9.25C4 9.09262 4.0741 8.94443 4.2 8.85L11.7 3.225C11.8778 3.09167 12.1222 3.09167 12.3 3.225L19.8 8.85C19.9259 8.94443 20 9.09262 20 9.25V19C20 20.1046 19.1046 21 18 21H6C4.89543 21 4 20.1046 4 19V9.25Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 9, y: 14, width: 6, height: 7, rx: 0.5, stroke: "current", strokeWidth: 1.5 }));
const SvgInfo = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm-1.5 5.5a1.5 1.5 0 112.999-.001A1.5 1.5 0 0110.5 7.5zM13 11v7h-2v-7h2z", clipRule: "evenodd" }));
const SvgInfoOutline = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12.75 11v7h-1.5v-7h1.5z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M10.75 7.5a1.25 1.25 0 112.499-.001 1.25 1.25 0 01-2.499.001z", clipRule: "evenodd" }));
const SvgLink = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3.40183 14.0808C1.53272 15.8962 1.53272 18.8396 3.40183 20.655C5.27094 22.4704 8.26736 22.4371 10.1365 20.6217L12 19M3.36827 14.1136L7.23135 10.3615C9.10046 8.54615 12.1309 8.54615 14 10.3615L15 11.3615", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M20.5982 10.9192C22.4673 9.10377 22.4673 6.16043 20.5982 4.34503C18.7291 2.52963 15.7326 2.56289 13.8635 4.37829L12 6M20.6317 10.8864L16.7687 14.6385C14.8995 16.4538 11.8691 16.4538 10 14.6384L8.86155 13.5", stroke: "current", strokeWidth: 1.5 }));
const SvgLinkExternal = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 3H21V10", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M21 3L10 14", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 7H5C3.89543 7 3 7.89543 3 9V19C3 20.1046 3.89543 21 5 21H15C16.1046 21 17 20.1046 17 19V15", stroke: "current", strokeWidth: 1.5 }));
const SvgList = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 4, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 12, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 20, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 4H22", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 12H22", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 20H22", stroke: "current", strokeWidth: 1.5 }));
const SvgLockClosed = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M7 9H5.25C4.56 9 4 9.56 4 10.25v8.5a2.75 2.75 0 002.75 2.75h10a2.75 2.75 0 002.75-2.75v-8.5c0-.69-.56-1.25-1.25-1.25H16.5V7.75a4.75 4.75 0 10-9.5 0V9zm1.5 0H15V7.75a3.25 3.25 0 00-6.5 0V9zm-3 9.75V10.5H18v8.25c0 .69-.56 1.25-1.25 1.25h-10c-.69 0-1.25-.56-1.25-1.25z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", d: "M13.5 15.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }));
const SvgLockOpen = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M7.25 9.25H5.5c-.69 0-1.25.56-1.25 1.25V19A2.75 2.75 0 007 21.75h10A2.75 2.75 0 0019.75 19v-8.5c0-.69-.56-1.25-1.25-1.25H8.75V7a3.25 3.25 0 016.5 0h1.5a4.75 4.75 0 10-9.5 0v2.25zM5.75 19v-8.25h12.5V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", d: "M13.5 15.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" }));
const SvgLogin = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M7 15V18C7 19.1046 7.89543 20 9 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4H9C7.89543 4 7 4.89543 7 6V9", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17 12L2 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 16L17 12L13 8", stroke: "current", strokeWidth: 1.5 }));
const SvgLogout = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 9L12 6C12 4.89543 11.1046 4 10 4L5 4C3.89543 4 3 4.89543 3 6L3 18C3 19.1046 3.89543 20 5 20L10 20C11.1046 20 12 19.1046 12 18L12 15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M21 12L6 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17 16L21 12L17 8", stroke: "current", strokeWidth: 1.5 }));
const SvgMail = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 3, y: 5, width: 18, height: 14, rx: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M21 8L13.1095 13.2604C12.4377 13.7083 11.5625 13.7083 10.8907 13.2604L3 8", stroke: "current", strokeWidth: 1.5 }));
const SvgMenu = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 19L21 19", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 5L21 5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 12L21 12", stroke: "current", strokeWidth: 1.5 }));
const SvgMerge = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M17 16L21 12L17 8", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 5H5.10192C5.73838 5 6.33685 5.30293 6.71368 5.81585L11.2571 12H20", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 19H5.0543C5.68956 19 6.28704 18.6982 6.66403 18.1869L11.2258 12H20", stroke: "current", strokeWidth: 1.5 }));
const SvgMinus = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 12L20 12", stroke: "current", strokeWidth: 1.5 }));
const SvgMinusCircle = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 12L18 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "current", strokeWidth: 1.5 }));
const SvgMobilePhone = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 5H10M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H14H10H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22Z", stroke: "#191817", strokeOpacity: 0.75, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgNotebook = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 5, y: 3, width: 15, height: 18, rx: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("rect", { x: 9, y: 7, width: 7, height: 5, rx: 0.5, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 12H5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 17H5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 7H5", stroke: "current", strokeWidth: 1.5 }));
const SvgPercent = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 19.5L19.5 4.5", stroke: "current", strokeWidth: 1.5, strokeLinecap: "square", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 7.5, cy: 6, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 16.5, cy: 18, r: 3, stroke: "current", strokeWidth: 1.5 }));
const SvgPhone = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.6511 17.0772L16.994 15.4202C16.5293 14.9556 15.7752 14.9556 15.3105 15.4202L14.4701 16.2606C14.0054 16.7253 13.2513 16.7253 12.7866 16.2606L7.73883 11.2131C7.27413 10.7484 7.27413 9.99572 7.73883 9.53103L8.58059 8.68932C9.0453 8.22464 9.0453 7.47197 8.58059 7.00728L6.92212 5.3489C6.44072 4.86752 5.64487 4.88561 5.19269 5.39481C2.44897 8.47507 1.54043 11.7445 6.89847 17.1023C12.2565 22.46 15.5248 21.5502 18.6052 18.808C19.1144 18.3544 19.1325 17.5586 18.6511 17.0772Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 12C21 7.02944 16.9706 3 12 3", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M17 12C17 9.23858 14.7614 7 12 7", stroke: "current", strokeWidth: 1.5 }));
const SvgPlus = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 20V4", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4 12L20 12", stroke: "current", strokeWidth: 1.5 }));
const SvgPlusCircle = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 18V6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 12L18 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "current", strokeWidth: 1.5 }));
const SvgQuote = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 6H16C14.8954 6 14 6.89543 14 8V12C14 13.1046 14.8954 14 16 14H17V18.2615C17 18.6152 17.3597 18.8554 17.6786 18.7024C22 16.6293 22 13 22 13V8C22 6.89543 21.1046 6 20 6Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 6H4C2.89543 6 2 6.89543 2 8V12C2 13.1046 2.89543 14 4 14H5V18.2615C5 18.6152 5.35971 18.8554 5.67864 18.7024C10 16.6293 10 13 10 13V8C10 6.89543 9.10457 6 8 6Z", stroke: "current", strokeWidth: 1.5 }));
const SvgSearch = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 10.5, cy: 10.5, r: 7.5, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M16 16L21 21", stroke: "current", strokeWidth: 1.5 }));
const SvgSend = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20.6875 4.70307L13.611 20.6252C13.4157 21.0647 12.7732 21.0019 12.6666 20.5329L10.5379 11.1666C10.5133 11.0586 10.4536 10.9618 10.3681 10.8914L3.07581 4.88597C2.71371 4.58776 2.92457 4 3.39367 4H20.2306C20.5924 4 20.8345 4.37243 20.6875 4.70307Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10.5 11L20 4.5", stroke: "current", strokeWidth: 1.5 }));
const SvgSettings = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8351 4.34816C11.1324 4.67735 11.5551 4.86523 11.9986 4.86523C12.4421 4.86523 12.8649 4.67735 13.1621 4.34816L13.9142 3.51432C14.3592 3.02426 15.0639 2.86649 15.6753 3.12006C16.2867 3.37364 16.6729 3.98392 16.6405 4.64504L16.5828 5.76536C16.5606 6.20838 16.7268 6.64013 17.0405 6.95378C17.3541 7.26744 17.7858 7.4337 18.2288 7.41143L19.3491 7.35381C20.0124 7.31851 20.6259 7.70511 20.8804 8.31871C21.1348 8.93231 20.9749 9.63968 20.4813 10.0842L19.6475 10.8364C19.3184 11.1336 19.1305 11.5564 19.1305 11.9999C19.1305 12.4435 19.3184 12.8662 19.6475 13.1635L20.4813 13.9157C20.974 14.3601 21.1335 15.0666 20.8796 15.6796C20.6256 16.2926 20.0133 16.6794 19.3507 16.6452L18.2304 16.5876C17.7874 16.5651 17.3555 16.7313 17.0418 17.045C16.7281 17.3587 16.5619 17.7906 16.5844 18.2337L16.6421 19.354C16.6743 20.0155 16.2874 20.6258 15.6755 20.8789C15.0636 21.132 14.3586 20.9733 13.9142 20.4823L13.1621 19.6485C12.8649 19.3193 12.4421 19.1314 11.9986 19.1314C11.5551 19.1314 11.1324 19.3193 10.8351 19.6485L10.083 20.4823C9.63855 20.975 8.9321 21.1345 8.31912 20.8806C7.70614 20.6266 7.31941 20.0143 7.35356 19.3516L7.41117 18.2313C7.43349 17.7886 7.26728 17.3572 6.95373 17.0439C6.64018 16.7307 6.20863 16.5649 5.766 16.5876L4.64575 16.6452C3.98358 16.6783 3.37223 16.2912 3.11896 15.6784C2.86568 15.0657 3.02526 14.3598 3.51749 13.9157L4.35048 13.1635C4.67965 12.8662 4.86752 12.4435 4.86752 11.9999C4.86752 11.5564 4.67965 11.1336 4.35048 10.8364L3.51749 10.0842C3.02882 9.63958 2.87133 8.93629 3.12372 8.32572C3.37611 7.71515 3.98419 7.32836 4.64415 7.35861L5.7644 7.41623C6.20833 7.43909 6.64111 7.27248 6.95512 6.95784C7.26914 6.64319 7.43489 6.21007 7.41117 5.76616L7.35356 4.64584C7.32052 3.98364 7.70763 3.37225 8.32033 3.11896C8.93304 2.86568 9.63883 3.02526 10.083 3.51752L10.8351 4.34816Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgSettingsSlider = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 18, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 18H5", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 18L22 18", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 17, cy: 12, r: 2, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 12L15 12", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M19 12H22", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 6L5 6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M9 6L22 6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 7, cy: 6, r: 2, stroke: "current", strokeWidth: 1.5 }));
const SvgShare = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 18, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 12, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 18, cy: 6, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M16 7L8 11", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13.5 16.5L8.5 13.5", stroke: "current", strokeWidth: 1.5 }));
const SvgShieldCheck$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 13V4.99997C4 3.8954 4.89544 2.99997 6.00001 2.99997L18 3.00003C19.1046 3.00003 20 3.89546 20 5.00003V13C20 15.3334 18.4 18.6 12 21C5.6 18.6 4 15.3333 4 13Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M7.5 11.5L10.6667 14L16.5 7", stroke: "current", strokeWidth: 1.5 }));
const SvgShieldDollar = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 13V5.00004C4 3.89546 4.89544 3.00003 6.00001 3.00004L18 3.00009C19.1046 3.00009 20 3.89552 20 5.00009V13.0001C20 15.3334 18.4 18.6 12 21C5.6 18.6 4 15.3334 4 13Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M15 9C15 9 15 7 11.9988 7C10.1292 7 9 7.99945 9 9C9 10.4469 10.4052 10.7999 11.9988 11", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.9976 5V6.47825", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 13C9 13 9 15 12.0012 15C13.8708 15 15 14.0005 15 13C15 11.5454 13.5948 11.2001 12.0012 11", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 17L12 15", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgSignal = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M5.525 5.394A9.22 9.22 0 002.75 12a9.22 9.22 0 002.775 6.606l-1.05 1.071A10.72 10.72 0 011.25 12a10.72 10.72 0 013.225-7.677l1.05 1.071zM21.25 12a9.22 9.22 0 00-2.775-6.606l1.05-1.071A10.72 10.72 0 0122.75 12a10.72 10.72 0 01-3.225 7.677l-1.05-1.071A9.22 9.22 0 0021.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M8.277 8.298A5.231 5.231 0 006.75 12a5.23 5.23 0 001.527 3.702l-1.063 1.057A6.731 6.731 0 015.25 12c0-1.857.75-3.54 1.964-4.76l1.063 1.058zM17.25 12a5.231 5.231 0 00-1.527-3.702l1.063-1.057A6.731 6.731 0 0118.75 12c0 1.857-.75 3.54-1.963 4.76l-1.064-1.058A5.23 5.23 0 0017.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 2, fill: "current" }));
const SvgSparkle = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z", stroke: "#191817", strokeOpacity: 0.75, strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgSpinner = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 3.22308C18.0078 4.13264 21 7.71716 21 12C21 16.9703 16.9703 21 12 21C7.02975 21 3 16.9703 3 12C3 7.71716 5.99221 4.13264 10 3.22308", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgStopwatch = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10 7.00337C11.0786 6.36523 12.3309 6 13.6667 6C17.7168 6 21 9.35786 21 13.5C21 17.6421 17.7168 21 13.6667 21C12.3309 21 11.0786 20.6348 10 19.9966", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 3L13 6", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M11 3H15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M4 14L9 14", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M6 18L9 18", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M2 10L9 10", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M13 14L17 10", stroke: "current", strokeWidth: 1.5 }));
const SvgSync = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M18.0004 11.5V14C17.9987 16.1515 17.0084 18.2736 15.1406 19.6439C12.2955 21.7313 8.39748 21.3526 6 18.9002", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M14 15L18 11L22 15", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5.99951 12.5004L5.99951 10.0004C6.00126 7.84885 6.99151 5.72676 8.85928 4.35648C11.7045 2.2691 15.6025 2.64779 18 5.10024", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 9L6 13L2 9", stroke: "current", strokeWidth: 1.5 }));
const SvgThumbsUp = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3 10.5C3 10.2239 3.22386 10 3.5 10H8V21H3.5C3.22386 21 3 20.7761 3 20.5V10.5Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M8 21H17.5119C18.3952 21 19.1738 20.4207 19.4276 19.5747L21.2276 13.5748C21.6126 12.2915 20.6517 11.0001 19.3119 11.0001L15 11.0001C15 11.0001 17 8.70006 17 6.00006C17 2.62506 15 3 14 3C13 3 12.8944 4.98754 12 7C11 9.25 10 10 8 10", stroke: "current", strokeWidth: 1.5, strokeLinejoin: "round" }));
const SvgUpload = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 3L12 17", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M16 7L12 3L8 7", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M3 18V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V18", stroke: "current", strokeWidth: 1.5 }));
const SvgUserOne = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 11C15 12.6568 13.6568 14 12 14C10.3432 14 9 12.6568 9 11C9 9.34325 10.3432 8 12 8C13.6568 8 15 9.34325 15 11Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.8808 18.8042C17.3264 16.0636 14.904 14 12 14C9.09591 14 6.67348 16.0636 6.11914 18.8042", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 12C21 16.9703 16.9703 21 12 21C7.02975 21 3 16.9703 3 12C3 7.02975 7.02975 3 12 3C16.9703 3 21 7.02975 21 12Z", stroke: "current", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgUserTwo = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 13, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M16 16C12.8546 16 10.2745 18.4203 10.0205 21.5002C9.99783 21.7754 10.2239 22 10.5 22H21.5C21.7761 22 22.0022 21.7754 21.9795 21.5002C21.7255 18.4203 19.1454 16 16 16Z", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("circle", { cx: 8, cy: 5, r: 3, stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M10 14H2.5C2.22386 14 1.99783 13.7754 2.02052 13.5002C2.27453 10.4203 4.85462 8 8 8C9.09286 8 10.1175 8.29218 11 8.80269", stroke: "current", strokeWidth: 1.5 }));
const SvgWarning = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M22.854 19.416c.414.703-.102 1.584-.927 1.584H2.073c-.825 0-1.34-.88-.927-1.584l9.927-16.89a1.08 1.08 0 011.854 0l9.927 16.89zM13 8v6h-2V8h2zm-1 8a1.5 1.5 0 10-.001 2.999A1.5 1.5 0 0012 16z", clipRule: "evenodd" }));
const SvgWarningOutline = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M10.918 2.372a1.25 1.25 0 012.164 0l10.132 17.502a1.25 1.25 0 01-1.081 1.876H1.867a1.25 1.25 0 01-1.082-1.876L10.918 2.372zM12 3.497L2.3 20.25H21.7l-9.7-16.753z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12.75 8.5v6h-1.5v-6h1.5zM10.75 17A1.25 1.25 0 1113.249 17 1.25 1.25 0 0110.75 17z", clipRule: "evenodd" }));
const SvgX = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M19 5L5 19", stroke: "current", strokeWidth: 1.5 }), /* @__PURE__ */ React.createElement("path", { d: "M5 5L19 19", stroke: "current", strokeWidth: 1.5 }));
const SvgXCircle = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM7.293 15.293L10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293-1.414-1.414z", clipRule: "evenodd" }));
const SvgXCircleOutline = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M12 2.75a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { fill: "current", fillRule: "evenodd", d: "M10.94 12l-3.47 3.47 1.06 1.06L12 13.06l3.47 3.47 1.06-1.06L13.06 12l3.47-3.47-1.06-1.06L12 10.94 8.53 7.47 7.47 8.53 10.94 12z", clipRule: "evenodd" }));
const icons24 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrowDown: SvgArrowDown,
  arrowLeft: SvgArrowLeft,
  arrowLeftRight: SvgArrowLeftRight,
  arrowRight: SvgArrowRight,
  arrowUp: SvgArrowUp,
  bank: SvgBank$1,
  bell: SvgBell$1,
  bookOpen: SvgBookOpen,
  briefcase: SvgBriefcase$1,
  building: SvgBuilding$1,
  calendar: SvgCalendar$1,
  caretRightDouble: SvgCaretRightDouble,
  chartBar: SvgChartBar,
  chartLine: SvgChartLine,
  chartPie: SvgChartPie,
  chat: SvgChat$1,
  chatPerson: SvgChatPerson,
  check: SvgCheck,
  checkCircle: SvgCheckCircle,
  checkCircleOutline: SvgCheckCircleOutline,
  chevronDown: SvgChevronDown,
  chevronLeft: SvgChevronLeft,
  chevronRight: SvgChevronRight,
  chevronUp: SvgChevronUp,
  clockArrow: SvgClockArrow,
  copy: SvgCopy,
  delete: SvgDelete,
  document: SvgDocument,
  dollar: SvgDollar,
  dollarCircle: SvgDollarCircle,
  download: SvgDownload,
  edit: SvgEdit,
  ellipsis: SvgEllipsis,
  error: SvgError,
  errorOutline: SvgErrorOutline,
  eyeClosed: SvgEyeClosed,
  eyeOpen: SvgEyeOpen,
  filter: SvgFilter,
  folder: SvgFolder$1,
  help: SvgHelp,
  helpOutline: SvgHelpOutline,
  home: SvgHome,
  info: SvgInfo,
  infoOutline: SvgInfoOutline,
  link: SvgLink,
  linkExternal: SvgLinkExternal,
  list: SvgList,
  lockClosed: SvgLockClosed,
  lockOpen: SvgLockOpen,
  login: SvgLogin,
  logout: SvgLogout,
  mail: SvgMail,
  menu: SvgMenu,
  merge: SvgMerge,
  minus: SvgMinus,
  minusCircle: SvgMinusCircle,
  mobilePhone: SvgMobilePhone,
  notebook: SvgNotebook,
  percent: SvgPercent,
  phone: SvgPhone,
  plus: SvgPlus,
  plusCircle: SvgPlusCircle,
  quote: SvgQuote,
  search: SvgSearch,
  send: SvgSend,
  settings: SvgSettings,
  settingsSlider: SvgSettingsSlider,
  share: SvgShare,
  shieldCheck: SvgShieldCheck$1,
  shieldDollar: SvgShieldDollar,
  signal: SvgSignal,
  sparkle: SvgSparkle,
  spinner: SvgSpinner,
  stopwatch: SvgStopwatch,
  sync: SvgSync,
  thumbsUp: SvgThumbsUp,
  upload: SvgUpload,
  userOne: SvgUserOne,
  userTwo: SvgUserTwo,
  warning: SvgWarning,
  warningOutline: SvgWarningOutline,
  x: SvgX,
  xCircle: SvgXCircle,
  xCircleOutline: SvgXCircleOutline
}, Symbol.toStringTag, { value: "Module" }));
var IconSizes = /* @__PURE__ */ ((IconSizes2) => {
  IconSizes2["Icon12"] = "12";
  IconSizes2["Icon16"] = "16";
  IconSizes2["Icon20"] = "20";
  IconSizes2["Icon24"] = "24";
  IconSizes2["Icon40"] = "40";
  return IconSizes2;
})(IconSizes || {});
var IconAlignment = /* @__PURE__ */ ((IconAlignment2) => {
  IconAlignment2["leading"] = "leading";
  IconAlignment2["trailing"] = "trailing";
  return IconAlignment2;
})(IconAlignment || {});
function getIconByKey(key, size) {
  switch (size) {
    case "12":
      return icons12[key];
    case "16":
      return icons16[key];
    case "20":
      return icons20[key];
    case "24":
      return icons24[key];
    default:
      return void 0;
  }
}
const fillOnlyIcons = [
  "caretDown",
  "caretLeft",
  "caretRight",
  "caretUp",
  "chartLine",
  "checkedCheckbox",
  "checkCircle",
  "checkCircleOutline",
  "ellipsis",
  "error",
  "errorOutline",
  "help",
  "helpOutline",
  "indeterminateCheckbox",
  "info",
  "infoOutline",
  "lockClosed",
  "lockOpen",
  "moneyMovement",
  "signal",
  "sparkle",
  "star",
  "warning",
  "warningOutline",
  "xCircle",
  "xCircleOutline"
];
const fillOnlyIcon = (key) => {
  return fillOnlyIcons.includes(key);
};
const colorIcon = (key, size, color2, strokeOverride, fillOverride) => {
  let fillColor = "none";
  let strokeColor = "none";
  if (color2) {
    if (fillOnlyIcon(key)) {
      fillColor = color2;
    } else {
      strokeColor = color2;
    }
    if (size === "16" && key === "chartLine") {
      strokeColor = color2;
    }
    if (size === "16" && (key === "eyeClosed" || key === "eyeOpen")) {
      fillColor = color2;
      strokeColor = color2;
    }
    if (key === "copy") {
      fillColor = color2;
      strokeColor = color2;
    }
  }
  return {
    stroke: strokeOverride || strokeColor,
    fill: fillOverride || fillColor
  };
};
const icon12Keys = Object.keys(icons12);
const icon16Keys = Object.keys(icons16);
const icon20Keys = Object.keys(icons20);
const icon24Keys = Object.keys(icons24);
const SvgAdjust = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M38 20L15 20", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30 39L25 34L30 29", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M33 15L38 20L33 25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M25 34L39.9998 34.0142", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27 2H2C1.44772 2 1 2.44772 1 3V9C1 9.55228 1.44771 10 2 10H27C27.5523 10 28 9.55228 28 9V3C28 2.44772 27.5523 2 27 2Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18 30H2C1.44772 30 1 30.4477 1 31V37C1 37.5523 1.44772 38 2 38H18C18.5523 38 19 37.5523 19 37V31C19 30.4477 18.5523 30 18 30Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 16H2C1.44772 16 1 16.4477 1 17V23C1 23.5523 1.44772 24 2 24H9C9.55228 24 10 23.5523 10 23V17C10 16.4477 9.55228 16 9 16Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgAward = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 29C27.732 29 34 22.732 34 15C34 7.26801 27.732 1 20 1C12.268 1 6 7.26801 6 15C6 22.732 12.268 29 20 29Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31 23.1L35.2 34.3L27.8 33.5L22.7 39L20 31.9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.9998 23L4.7998 34.3L12.1998 33.5L17.2998 39L21.1998 28.7", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 8L22.2055 12.2086L27 12.9568L23.5479 16.2302L24.3151 21L20 18.7554L15.6849 21L16.4521 16.2302L13 12.9568L17.7945 12.2086L20 8Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }));
const SvgBank = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M31 33V17H36V33", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M37 11H30V17H37V11Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 33V17H9V33", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 11H3V17H10V11Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38 11V7.68421L20 2L2 7.68421V11H38Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 38H1V35C1 33.9 1.9 33 3 33H37C38.1 33 39 33.9 39 35V38Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24 18.5739C24 18.5739 22.8732 17.1042 20.2817 17.0062C17.6901 16.9082 16.4507 17.986 16.4507 19.2597C16.4507 20.5334 17.5775 21.2193 20.169 21.8071C22.7606 22.395 23.8873 23.0809 23.8873 24.5505C23.7746 26.1182 22.3099 27 20.0563 27C17.3521 27 16 25.4323 16 25.4323", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 27V30", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 14V17.1974", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgBell = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M29.1714 10.1578L37.7861 7.55284", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29.372 14.276L35.3158 16.6575", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27.0562 6.61845L30.6844 1.34245", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M36 27.0638C36 27.0638 35.1968 25.4525 32.6874 23.9272C30.0776 22.3001 27.0662 20.8765 26.5644 18.741C26.0625 16.6055 25.3598 13.6566 25.2595 13.4532C23.9546 8.16534 18.8354 4.91129 13.7162 6.33494C8.59698 7.75859 5.48534 13.1481 6.79024 18.4359C6.89061 18.6393 7.59324 21.69 8.09512 23.7238C8.597 25.8593 6.58948 28.7066 5.08383 31.3505C4.18586 32.9277 4 36 4 36", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 17C20.775 15.9576 20.4 14.5945 20.4 14.5144C19.8 12.0287 17.4 10.5053 15 11.1467", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.3078 8C9.76889 7.45426 9.33772 6.79939 9.12216 6.03535C8.58325 3.8524 9.87665 1.66945 12.0323 1.12371C14.1879 0.577968 16.3436 1.88772 16.8825 4.07068C17.0981 4.83471 16.9903 5.59875 16.7747 6.36278", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.3846 36.3125L9.62372 36.7335C6.31533 37.1891 4.20996 37.0752 4.00945 36.2779C3.70868 34.797 10.6262 31.3796 19.4486 28.7597C28.271 26.1397 35.6898 25.2284 35.9906 26.7093C36.2746 28.1081 30.1185 31.2346 22 33.7849", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.1609 31.7758C10.9464 32.7751 10.9464 33.8854 11.1609 34.8847C12.0189 37.8825 15.1291 39.659 18.0248 38.7708C20.9206 37.8825 22.6366 34.6626 21.7786 31.6647C21.4568 30.5544 20.9206 29.6662 20.1698 29", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgBook = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M4 7L7 12", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19 6L17 10", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11 2L12 10", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 35V38L17.0192 35C17.6923 36.68 18.8462 37.4 20 37.4C21.1538 37.4 22.3077 36.68 22.9808 35L35 38V35", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 15.4873C18.2 12.7479 12.8 11.9652 9.5 14.7046C8.9 15.1938 8.3 15.683 7.7 15.9765C5.4 17.444 3 18.031 3 18.031L1 33C1 33 6.7 32.3151 10.4 29.5757C14.1 26.8363 18 29.0865 20 31.826C22 29.0865 25.8 26.9341 29.6 29.5757C33.4 32.2173 39 33 39 33L37 18.031C37 18.031 34.9 17.5419 32.3 15.8786", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 24C6.97087 23.5259 8.13592 22.8621 9.30097 22.0087C11.2427 20.5863 13.5 19.0964 16 20.6812", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 31C20 26.8301 23.4803 23.4015 26.5512 22.7529C32.4882 21.5483 33 19.973 33 19.973L31.6693 7C31.6693 7 30.8504 8.76062 25.6299 9.59459C22.7638 10.0579 21.2283 11.7259 20 15.4324V31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgBriefcase = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M27 14L35 14", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38 27.4V32C38 33.6569 36.6569 35 35 35H4C2.34315 35 1 33.6569 1 32V12C1 10.3431 2.34315 9 4 9H36C37.6569 9 39 10.3431 39 12V21C39 22.6569 37.6569 24 36 24H28.1", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 22H20V26H28V22Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 35V27", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 24H7.93827V14.9298C7.93827 13.8684 7.04938 13 5.96296 13H4", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0002 9H13.7002V6C13.7002 4.9 14.6002 4 15.7002 4H27.0002C28.1002 4 29.0002 4.9 29.0002 6V9Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgBuilding = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 24H22", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 29L22 29", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 1H38V39H32", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M25 7L33 7", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M25 12L33 12", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 15V1L14 7.30534V15", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 36V19M8 19L2 24V39H15V37C15 35.3431 16.3431 34 18 34V34C19.6569 34 21 35.3431 21 37V39H28V19H8Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgBusiness = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M17 22H10C9.44772 22 9 22.4477 9 23V31C9 31.5523 9.44772 32 10 32H17C17.5523 32 18 31.5523 18 31V23C18 22.4477 17.5523 22 17 22Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 15V34C4 35.6569 5.34315 37 7 37H33C34.6569 37 36 35.6569 36 34V15", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31.3 4H8.7L1 11H39L31.3 4Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31 37V30C31 27.7909 29.2091 26 27 26V26C24.7909 26 23 27.7909 23 30V37", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 11C10 13.7083 8.01053 16 5.45263 16C2.89474 16 1 13.7083 1 11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 11C20 13.7083 18.0312 16 15.5 16C12.9688 16 11 13.8125 11 11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29 11C29 13.7083 27.0105 16 24.4526 16C21.8947 16 20 13.7083 20 11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 11C39 13.7083 37.0313 16 34.5 16C31.9688 16 30 13.8125 30 11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgCake = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M28 39H25L23 34H35C37.0952 34 39 31.0588 39 29H1C1 31.1569 3 34 5 34H17L15 39H12", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M35 15V28.9396", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 15V28.9396", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 24H19.8571", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 9.43718V6", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 9.43718V6", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30 9.43718V6", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 4.39999C22 3.49999 21.1111 1 20 1C18.8889 1 18 3.49999 18 4.39999C18 5.29999 18.8889 6 20 6C21.1111 5.9 22 5.19999 22 4.39999Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 4.39999C12 3.49999 11.1111 1 10 1C8.88888 1 8 3.49999 8 4.39999C8 5.29999 8.88888 6 10 6C11.1111 5.9 12 5.19999 12 4.39999Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 4.39999C32 3.49999 31.1111 1 30 1C28.8889 1 28 3.49999 28 4.39999C28 5.29999 28.8889 6 30 6C31.1111 5.9 32 5.19999 32 4.39999Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17 34L23 34", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 39L26 39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M35.7591 14.8C33.1606 14.8 33.1606 18 30.4659 18C27.7712 18 27.8674 14.8 25.1727 14.8C22.5743 14.8 22.5743 18 19.8796 18C17.2811 18 17.2811 14.8 14.5864 14.8C11.9879 14.8 11.9879 18 9.29318 18C6.69471 18 6.69471 14.8 4 14.8V10H36V14.7491L35.7591 14.8Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgCalendar = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 16H8C7.44772 16 7 16.4477 7 17V21C7 21.5523 7.44772 22 8 22H12C12.5523 22 13 21.5523 13 21V17C13 16.4477 12.5523 16 12 16Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 16H18C17.4477 16 17 16.4477 17 17V21C17 21.5523 17.4477 22 18 22H22C22.5523 22 23 21.5523 23 21V17C23 16.4477 22.5523 16 22 16Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 27H18C17.4477 27 17 27.4477 17 28V32C17 32.5523 17.4477 33 18 33H22C22.5523 33 23 32.5523 23 32V28C23 27.4477 22.5523 27 22 27Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 27H8C7.44772 27 7 27.4477 7 28V32C7 32.5523 7.44772 33 8 33H12C12.5523 33 13 32.5523 13 32V28C13 27.4477 12.5523 27 12 27Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 16H28C27.4477 16 27 16.4477 27 17V21C27 21.5523 27.4477 22 28 22H32C32.5523 22 33 21.5523 33 21V17C33 16.4477 32.5523 16 32 16Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32.2778 9H34C35.6569 9 37 10.3431 37 12V28.7574C37 29.553 36.6839 30.3161 36.1213 30.8787L29.8787 37.1213C29.3161 37.6839 28.553 38 27.7574 38H6C4.34315 38 3 36.6569 3 35V12C3 10.3431 4.34315 9 6 9H7.72222M28.5 9H21.8889M18.1111 9H11.5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M37 30H29.5C29.2239 30 29 30.2239 29 30.5V38", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 7C28 5.89543 28.8954 5 30 5V5C31.1046 5 32 5.89543 32 7V10C32 11.1046 31.1046 12 30 12V12C28.8954 12 28 11.1046 28 10V7Z", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M18 7C18 5.89543 18.8954 5 20 5V5C21.1046 5 22 5.89543 22 7V10C22 11.1046 21.1046 12 20 12V12C18.8954 12 18 11.1046 18 10V7Z", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M8 7C8 5.89543 8.89543 5 10 5V5C11.1046 5 12 5.89543 12 7V10C12 11.1046 11.1046 12 10 12V12C8.89543 12 8 11.1046 8 10V7Z", stroke: "#292827", strokeWidth: 2 }));
const SvgCare = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 12C22.7614 12 25 9.76142 25 7C25 4.23858 22.7614 2 20 2C17.2386 2 15 4.23858 15 7C15 9.76142 17.2386 12 20 12Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24.6278 21L25.992 13.9397C26.097 12.931 25.1525 12 23.9982 12H16.0231C14.7638 12 13.8194 12.931 14.0293 13.9397L15.3935 21H24.6278Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31.7471 31.0656C31.7471 31.0656 33.3911 28.5498 34.1647 25.7437C34.8417 23.7117 33.9713 21.97 33.2944 20.9056C33.0043 20.4218 32.3273 20.4218 31.9405 20.9056L25.0745 30.2915C23.8173 31.6461 24.0107 33.4846 24.0107 35.4198V39H26.3316C28.9427 39 31.5537 38.1292 33.5845 36.4842C33.6812 36.3874 33.7779 36.3874 33.7779 36.2907C36.4857 33.9684 39 30.5818 39 27.0016V13.2615C39 11.1327 37.9362 10.7457 36.7758 11.1327C36.0988 11.3263 34.5516 12.8745 34.4549 14.6162L33.6812 21.4862", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.30251 31.0656C8.30251 31.0656 6.66905 28.5498 5.90037 25.7437C5.22777 23.7117 6.09254 21.97 6.76514 20.9056C7.0534 20.4218 7.72599 20.4218 8.11034 20.9056L14.9324 30.3882C16.1815 31.7429 15.9894 33.5814 15.9894 35.5166V39H13.6833C11.089 39 8.49468 38.1292 6.47688 36.4842C6.3808 36.3874 6.28471 36.3874 6.28471 36.2907C3.49823 34.0652 1 30.5818 1 27.0016V13.2615C1 11.1327 2.05694 10.7457 3.20997 11.1327C3.88257 11.3263 5.41994 12.8745 5.51603 14.6162L6.28471 21.4862", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgCaution = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 31C21.1046 31 22 30.1045 22 29C22 27.8954 21.1046 27 20 27C18.8954 27 18 27.8954 18 29C18 30.1045 18.8954 31 20 31Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 24C21.1046 24 22 17.1045 22 16C22 14.8954 21.1046 14 20 14C18.8954 14 18 14.8954 18 16C18 17.1045 18.8954 24 20 24Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.87961 35H36.1071C37.6237 35 38.4768 33.304 37.7185 32.007L21.6048 3.97272C20.8465 2.67576 19.0455 2.67576 18.382 3.97272L2.26824 32.007C1.50994 33.4037 2.45781 35 3.87961 35Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgCelebrate = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M29.0032 26.6015C29.0032 26.6015 30.7041 25.3059 33.0793 25.7709C35.4546 26.236 38.0069 25.1949 38.8677 24.4054", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16 7C16 7 18.8203 4.29412 17.7627 1", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.8148 29.7342C25.5392 28.0655 23.6395 23.5217 19.5719 19.5852C15.5042 15.6488 10.8089 13.8104 9.08458 15.4792C7.36025 17.1479 9.25988 21.6917 13.3275 25.6282C17.3952 29.5646 22.0905 31.4029 23.8148 29.7342Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.5 30L2.00095 38.5996C1.60571 38.7577 1.2063 38.3811 1.34091 37.9773L8.66667 16", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M20 25C24.05 22 29 21 29 21", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24.7294 14.2432C31.028 8.2046 38.1509 6.6848 38.1509 6.6848", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19 14L24.2964 5.65217C24.2964 5.65217 25.9989 3.35652 24.1073 2", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11 12V9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M35.5 21C36.3284 21 37 20.3284 37 19.5C37 18.6716 36.3284 18 35.5 18C34.6716 18 34 18.6716 34 19.5C34 20.3284 34.6716 21 35.5 21Z", fill: "#292827" }), /* @__PURE__ */ React.createElement("path", { d: "M31.5 6C32.3284 6 33 5.32843 33 4.5C33 3.67157 32.3284 3 31.5 3C30.6716 3 30 3.67157 30 4.5C30 5.32843 30.6716 6 31.5 6Z", fill: "#292827" }), /* @__PURE__ */ React.createElement("path", { d: "M33.7947 14.2907L29.7173 16.1015", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22.4046 16.7834L19.1341 19.7557", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.5 25.5C5.5 27.6667 7.1 32.4 13.5 34", stroke: "#292827", strokeWidth: 2 }));
const SvgCharts = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M31 4.5L22 9", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M36 9L22 16", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38 15L24 21", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38 21L28 26", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.48319 24.7833C6.53137 22.7315 6 20.4443 6 18.0327C6 9.17807 13.1634 2 22 2C30.8366 2 38 9.17807 38 18.0327C38 26.396 31.6095 33.2636 23.4545 34", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 2V17.8038L30 31", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 39V34C8 33.4477 7.55228 33 7 33H3C2.44772 33 2 33.4477 2 34V39", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M20 39V24C20 23.4477 19.5523 23 19 23H15C14.4477 23 14 23.4477 14 24V39", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M14 39V29C14 28.4477 13.5523 28 13 28H9C8.44772 28 8 28.4477 8 29V39", stroke: "#292827", strokeWidth: 2 }));
const SvgChat = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M25 17.5327C25 19.1896 23.6569 20.5327 22 20.5327H4.8L1 23V4C1 2.34315 2.34315 1 4 1H22C23.6569 1 25 2.34315 25 4V17.5327Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 25V33.6449C15 35.3017 16.3431 36.6449 18 36.6449H35.0039C35.0959 36.6449 35.1861 36.6702 35.2646 36.7182L39 39V21C39 19.3431 37.6569 18 36 18H30", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 27.9157L24.3391 31L33 23", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M7 13C7.82843 13 8.5 12.3284 8.5 11.5C8.5 10.6716 7.82843 10 7 10C6.17157 10 5.5 10.6716 5.5 11.5C5.5 12.3284 6.17157 13 7 13Z", fill: "#292827" }), /* @__PURE__ */ React.createElement("path", { d: "M13 13C13.8284 13 14.5 12.3284 14.5 11.5C14.5 10.6716 13.8284 10 13 10C12.1716 10 11.5 10.6716 11.5 11.5C11.5 12.3284 12.1716 13 13 13Z", fill: "#292827" }), /* @__PURE__ */ React.createElement("path", { d: "M19 13C19.8284 13 20.5 12.3284 20.5 11.5C20.5 10.6716 19.8284 10 19 10C18.1716 10 17.5 10.6716 17.5 11.5C17.5 12.3284 18.1716 13 19 13Z", fill: "#292827" }));
const SvgChecklist = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M25.25 24.75H19.75C19.1977 24.75 18.75 25.1977 18.75 25.75V31.25C18.75 31.8023 19.1977 32.25 19.75 32.25H25.25C25.8023 32.25 26.25 31.8023 26.25 31.25V25.75C26.25 25.1977 25.8023 24.75 25.25 24.75Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.5 13.3333L21.25 17.5L28.75 7.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M10 4V36C10 37.6569 11.3431 39 13 39H32C33.6569 39 35 37.6569 35 36V3C35 1.9 34.1411 1 33.1869 1H7", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 4C10 2 8.66667 1 7 1C5.33333 1 4 2 4 4V16H10", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgContributionHand = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M34 0V12", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 7L34 13L29 7", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16.8495 26C16.8495 26 7.59202 18.98 6.3384 17.9C5.85624 17.45 3.54186 11.96 3.54186 11.96C1.70964 10.7 0.0702945 9.89 1.61321 6.92C4.21689 1.88 7.01342 3.14 7.01342 3.14L21.7676 8.72C23.1176 9.26 24.1784 10.16 24.8534 11.33L29 18.71L28.4214 24.11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20.811 24C18.0472 25.2162 16 27.9527 16 31.1959C16 35.4527 19.4803 39 23.8819 39H29", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M26.8442 24.1961C27.3312 24.098 27.9156 24 28.5 24C32.5909 24 36 27.3333 36 31.549C36 35.7647 32.5909 39 28.5 39C24.4091 39 21 35.6667 21 31.451C21 29.6863 21.5844 28.0196 22.6558 26.7451", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21.2376 14.6782L27.5 25.906C27.5 25.906 27.5 27.9644 25.1516 27.403C22.4118 26.748 19.8677 23.2862 18.5957 20.947C18.1064 19.9178 17.0301 19.2629 15.8558 19.0758C13.5248 18.8369 10.4853 16.8371 10.0522 12.5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgContribution = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1 23V31.8205L20 39L39 31.8205V23", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10.5 20L1 23.4579L20 30L39 23.4579L29.5 20", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 11L22.0674 17L16 11", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M22 16V6", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 1H17.8389C11.906 1 7 5.86316 7 12C7 18.0211 11.7919 23 17.8389 23H22", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M22 23C28.0751 23 33 18.0751 33 12C33 5.92487 28.0751 1 22 1C15.9249 1 11 5.92487 11 12C11 18.0751 15.9249 23 22 23Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M20 38V29", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgDocumentUser = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20.5 19C23.5376 19 26 16.5376 26 13.5C26 10.4624 23.5376 8 20.5 8C17.4624 8 15 10.4624 15 13.5C15 16.5376 17.4624 19 20.5 19Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27 25V22C27 20.3431 25.6569 19 24 19H17C15.3431 19 14 20.3431 14 22V25", stroke: "#5532FA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M9 4V36.3305C9 37.8136 10.218 39 11.7406 39M11.7406 39C13.2632 39 14.4812 37.8136 14.4812 36.3305V32.5734H36V36.3305C36 37.8136 34.782 39 33.2594 39H11.7406Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 1H29.2032C30.757 1 32 2.17722 32 3.64873V32", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 4C9 2 7.88889 1 6.5 1C5.11111 1 4 2.20863 4 3.71942V15H9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgDocuments = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M7.84 9H7C5.34315 9 4 10.3431 4 12V36C4 37.6569 5.34315 39 7 39H25C26.6569 39 28 37.6569 28 36V35.25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 1H15C13.3431 1 12 2.34315 12 4V28C12 29.6569 13.3431 31 15 31H33C34.6569 31 36 29.6569 36 28V9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16 13H24", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16 18L32 18", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 23H16", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 1V8.5C28 8.77614 28.2239 9 28.5 9H36L28 1Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgDownloadDoc = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M30 19L24.0472 25L18 19", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M24 24.5V12", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.84 9H7C5.34315 9 4 10.3431 4 12V36C4 37.6569 5.34315 39 7 39H25C26.6569 39 28 37.6569 28 36V35.25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 1H15C13.3431 1 12 2.34315 12 4V28C12 29.6569 13.3431 31 15 31H33C34.6569 31 36 29.6569 36 28V9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 1V8.5C28 8.77614 28.2239 9 28.5 9H36L28 1Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgEducation = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M28.6154 38.9853C26.4615 39.083 24 38.6923 24 37.8133V33.9067C24 31.758 25.7436 30 28 30C30.1538 30 32 31.758 32 33.9067V37.8133", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32.9545 27.5C33.5227 26.8438 33.75 26.0937 33.75 25.3437L32.5 16.25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.17791 16.25L6.25 25.1595C6.25 29.8439 14.9233 31.893 21.25 31.25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21.5082 1.87712C20.5758 1.33489 19.4242 1.33489 18.4918 1.87712L2.49313 11.1814C1.8286 11.5679 1.83049 12.5284 2.49653 12.9123L18.502 22.1367C19.4292 22.671 20.5708 22.671 21.498 22.1367L37.5035 12.9123C38.1695 12.5284 38.1714 11.5679 37.5069 11.1814L21.5082 1.87712Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 12L28 17V29.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgEmail = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9 17L0 17", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 22H4", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M37 10H15C13.8954 10 13 10.8954 13 12V28C13 29.1046 13.8954 30 15 30H37C38.1046 30 39 29.1046 39 28V12C39 10.8954 38.1046 10 37 10Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 12L24.8616 20.2119C25.5465 20.686 26.4535 20.686 27.1384 20.2119L39 12", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 28L20 20", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M39 28L32 20", stroke: "#292827", strokeWidth: 2 }));
const SvgEmployee = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M25 23C27.2091 23 29 21.2091 29 19C29 16.7909 27.2091 15 25 15C22.7909 15 21 16.7909 21 19C21 21.2091 22.7909 23 25 23Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.88859 35L2 34.1026L7.08696 1L17 2.25926", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 32.5H36.25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 9H28V3.28571C28 2.02857 26.65 1 25 1C23.35 1 22 2.02857 22 3.28571V9Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22.7699 6H13V39H37V6H27.0177", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31 27V26C31 24.3431 29.6569 23 28 23H22C20.3431 23 19 24.3431 19 26V27", stroke: "#5532FA", strokeWidth: 2 }));
const SvgFolder = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M9 7H19", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 12H28", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 17H28", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 18.4V8", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M25 1H5V39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M25 8H32L25 1V8Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 25L32 25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24.5 23.0884L25.4 21H37L32.2 39H5L8.5 24.2818C8.8 23.4862 9.5 23.0884 10.3 23.0884H24.5Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgGears = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12.4087 20.3886L11.399 18C10.6923 18 9.98558 18.0995 9.27885 18.2986C8.57212 18.4976 7.86538 18.6967 7.25962 18.9953L7.46154 21.5829C6.55288 22.1801 5.74519 22.8768 5.03846 23.7725L2.41346 23.3744C1.60577 24.6682 1.10096 26.0616 1 27.455L3.32212 28.6493C3.32212 29.1469 3.42308 29.7441 3.52404 30.2417C3.625 30.7393 3.82692 31.3365 4.02885 31.8341L2.41346 33.9242C3.22115 35.218 4.12981 36.2133 5.34135 37.109L7.5625 35.6161C8.47115 36.1137 9.58173 36.5118 10.6923 36.6114L11.7019 39C12.4087 39 13.1154 38.9005 13.8221 38.7014C14.5288 38.5024 15.2356 38.3033 15.8413 38.0047L15.6394 35.4171C16.5481 34.8199 17.3558 34.1232 18.0625 33.2275L20.6875 33.6256C21.3942 32.3318 21.7981 30.9384 22 29.545L19.6779 28.3507C19.6779 27.8531 19.5769 27.2559 19.476 26.7583M12.3077 31.6351C10.4904 32.0332 8.77404 30.9384 8.37019 29.1469C7.96635 27.3555 9.07692 25.6635 10.8942 25.2654C12.7115 24.8673 14.4279 25.9621 14.8317 27.7536C15.2356 29.545 14.125 31.237 12.3077 31.6351Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M37.2149 14.561C37.4132 13.4878 37.3141 12.3171 37.1157 11.2439L39 10.1707C38.7025 8.80488 38.1074 7.53659 37.314 6.46341L35.2314 6.95122C34.5372 6.07317 33.7438 5.29268 32.8512 4.60976L33.3471 2.46341C32.7521 2.07317 32.157 1.78049 31.4628 1.58537C30.7686 1.29268 30.1736 1.09756 29.4793 1L28.3884 2.85366C27.3967 2.85366 26.2066 2.85366 25.2149 3.04878L24.124 1.19512C22.7355 1.4878 21.4463 2.07317 20.2562 2.85366L20.8512 4.90244C19.9587 5.58537 19.1653 6.36585 18.5702 7.2439L16.4876 6.7561C16.0909 7.34146 15.7934 7.92683 15.595 8.60976C15.2975 9.29268 15.0992 9.87805 15 10.561L16.8843 11.6341C16.686 12.7073 16.7851 13.878 16.9835 14.9512L15.0992 16.0244C15.3967 17.3902 15.9917 18.6585 16.7851 19.7317L18.8678 19.1463C19.562 20.0244 20.3554 20.8049 21.2479 21.4878L20.6529 23.5366C21.2479 23.9268 21.843 24.2195 22.5372 24.4146C23.2314 24.7073 23.8264 24.9024 24.5207 25L25.6116 23.1463C26.7025 23.3415 27.8926 23.2439 28.9835 23.0488L30.0744 24.9024C31.4628 24.6098 32.6529 24.0244 33.843 23.2439L33.1488 21.1951C34.0413 20.5122 34.8347 19.7317 35.4298 18.8537L37.5124 19.3415C37.9091 18.7561 38.2066 18.1707 38.405 17.4878C38.7025 16.8049 38.9008 16.2195 39 15.5366L37.2149 14.561ZM31.3636 14.7561C30.3719 17.1951 27.6942 18.3659 25.2149 17.3902C22.8347 16.4146 21.6446 13.7805 22.5372 11.3415C23.5289 8.90244 26.2066 7.73171 28.686 8.70732C31.1653 9.68293 32.3554 12.4146 31.3636 14.7561Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgGroupHeart = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M31 7.32768C31 3.82486 28.3684 1 25.1053 1C22.8947 1 21 2.35593 19.9474 4.27684C19 2.35593 17.1053 1 14.8947 1C11.6316 1 9 3.82486 9 7.32768C9 8.45763 9.31579 9.47458 9.73684 10.3785C9.73684 10.3785 12.5789 15.9153 19.9474 21C27.4211 15.9153 30.1579 10.3785 30.1579 10.3785C30.6842 9.47458 31 8.34463 31 7.32768Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 36C22.2091 36 24 34.2091 24 32C24 29.7909 22.2091 28 20 28C17.7909 28 16 29.7909 16 32C16 34.2091 17.7909 36 20 36Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34 31C36.2091 31 38 29.2091 38 27C38 24.7909 36.2091 23 34 23C31.7909 23 30 24.7909 30 27C30 29.2091 31.7909 31 34 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 31C8.20914 31 10 29.2091 10 27C10 24.7909 8.20914 23 6 23C3.79086 23 2 24.7909 2 27C2 29.2091 3.79086 31 6 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34.375 11.875L38.75 14.375", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.625 11.875L1.25 14.375", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34.375 3.75L38.75 2.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.625 3.75L1.25 2.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 36V34C39 32.3431 37.6569 31 36 31H32C30.3431 31 29 32.3431 29 34V34", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M11 34V34C11 32.3431 9.65685 31 8 31H4C2.34315 31 1 32.3431 1 34V36", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M26 40V39C26 37.3431 24.6569 36 23 36H17C15.3431 36 14 37.3431 14 39V40", stroke: "#292827", strokeWidth: 2 }));
const SvgGroupSavings = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 23C26.0751 23 31 18.0751 31 12C31 5.92487 26.0751 1 20 1C13.9249 1 9 5.92487 9 12C9 18.0751 13.9249 23 20 23Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.8491 8.35703C23.8491 8.35703 22.6415 7 20.0755 7C17.5094 7 16.3019 8.1103 16.3019 9.34397C16.3019 10.5776 17.5094 11.1945 20.2264 11.8113C22.9434 12.3048 24 12.9216 24 14.402C24 15.8824 22.4906 16.8693 20.2264 16.9927C17.5094 17.1161 16 15.6357 16 15.6357", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 17V20", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 4V7", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 36C22.2091 36 24 34.2091 24 32C24 29.7909 22.2091 28 20 28C17.7909 28 16 29.7909 16 32C16 34.2091 17.7909 36 20 36Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34 31C36.2091 31 38 29.2091 38 27C38 24.7909 36.2091 23 34 23C31.7909 23 30 24.7909 30 27C30 29.2091 31.7909 31 34 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 31C8.20914 31 10 29.2091 10 27C10 24.7909 8.20914 23 6 23C3.79086 23 2 24.7909 2 27C2 29.2091 3.79086 31 6 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 36V34C39 32.3431 37.6569 31 36 31H32C30.3431 31 29 32.3431 29 34V34", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M11 34V34C11 32.3431 9.65685 31 8 31H4C2.34315 31 1 32.3431 1 34V36", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M26 40V39C26 37.3431 24.6569 36 23 36H17C15.3431 36 14 37.3431 14 39V40", stroke: "#292827", strokeWidth: 2 }));
const SvgHandshake = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M15 2.5L17.5 6.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.75 1.25L22.5 6.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 34.9218L22.3286 35.7619C22.3286 35.7619 24.3658 36.812 24.9858 34.5018C24.9858 34.5018 27.8202 35.8669 27.9974 32.1915C27.9974 32.1915 31.0089 33.6617 31.0975 30.0913C31.0975 30.0913 32.8121 31.083 34 30", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 10.5623C20.3301 10.1313 19.1818 9.80808 17.1722 10.1313C12.866 10.8855 9.03828 11.532 5.689 10.3468L1 23.1684L3.87081 25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M35.8 10.2139C35.8 10.2139 32.3 11.3716 28.2 10.3192C22.4 8.95105 18.6 12.424 18.6 12.424L14 20.0013C14 20.0013 17.3 23.79 22.8 17.8965C24.5 21.1589 28.3 23.6847 32.7 26L39 25.0528L35.8 10.2139Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M26.5 22C26.5 22 30.6307 23.1673 33 20", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13.75 27.5C13.75 26.1364 12.7579 25 11.6667 25C11.1706 25 10.7738 25.2273 10.377 25.5682L10.2778 25.6818C10.1786 25.7955 8.19444 28.1818 8.19444 28.1818C7.79762 28.6364 7.5 29.3182 7.5 30C7.5 31.3636 8.49206 32.5 9.58333 32.5C10.1786 32.5 10.6746 32.2727 10.9722 31.8182L12.8571 29.5455C13.3532 28.9773 13.75 28.2955 13.75 27.5Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 25C10 23.6364 9.00794 22.5 7.91667 22.5C7.42063 22.5 7.02381 22.7273 6.62698 23.0682L6.52778 23.1818C6.42857 23.2955 4.44444 25.6818 4.44444 25.6818C4.04762 26.1364 3.75 26.8182 3.75 27.5C3.75 28.8636 4.74206 30 5.83333 30C6.42857 30 6.9246 29.7727 7.22222 29.3182L9.10714 27.0455C9.60317 26.4773 10 25.7955 10 25Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.5 30C17.5 28.6364 16.5079 27.5 15.4167 27.5C14.9206 27.5 14.5238 27.7273 14.127 28.0682L14.0278 28.1818C13.9286 28.2955 11.9444 30.6818 11.9444 30.6818C11.5476 31.1364 11.25 31.8182 11.25 32.5C11.25 33.8636 12.2421 35 13.3333 35C13.9286 35 14.4246 34.7727 14.7222 34.3182L16.6071 32.0455C17.1032 31.4773 17.5 30.7955 17.5 30Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21.2376 32.1215C21.0958 30.8159 19.9483 29.865 18.816 30.0157C18.3013 30.0842 17.9132 30.3567 17.5369 30.7379L17.4458 30.8604C17.3547 30.9829 15.544 33.5418 15.544 33.5418C15.1795 34.0318 14.9416 34.7257 15.0125 35.3785C15.1543 36.6841 16.3018 37.635 17.4341 37.4843C18.0517 37.4021 18.5427 37.1159 18.8043 36.6396L20.5238 34.2032C20.9794 33.5907 21.3203 32.8831 21.2376 32.1215Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgInstitution = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M31 33V17H36V33", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M37 11H30V17H37V11Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17 33V17H22V33", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23 11H16V17H23V11Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 33V17H9V33", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 11H3V17H10V11Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38 11V7.68421L20 2L2 7.68421V11H38Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 38H1V35C1 33.9 1.9 33 3 33H37C38.1 33 39 33.9 39 35V38Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgInterface = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M39 17.3V3H1V29H25.0667", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 9H7V23H15V9Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34 9L21 9L21 24", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.25 38H28.75", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M39 28.5L35.6522 24.5L39 22L28 17L28.9567 30L32.7827 27L36.1305 31L39 28.5Z", stroke: "#292827", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17 29H23L24 38H16L17 29Z", stroke: "#292827", strokeWidth: 2 }));
const SvgIrs = (props2) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 37.6 41.6", ...props2 }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#324063;}.cls-1,.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.6px;}.cls-2,.cls-3{fill:none;}.cls-3{stroke:#7878f5;}")), /* @__PURE__ */ React.createElement("title", null, "icon_IRS"), /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "Layer_1-2", "data-name": "Layer 1" }, /* @__PURE__ */ React.createElement("path", { className: "cls-1", d: "M36.8,32.8v6a2,2,0,0,1-2,2H2.8a2,2,0,0,1-2-2V2.8a2,2,0,0,1,2-2h32a2,2,0,0,1,2,2V4.7" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M7,26.67s0-3.18-1.89-4" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M12.18,29.56c0,.73,6.35.73,6.35,0l-3.17-4.92Z" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M18.53,29.56c0,.73,6.36.73,6.36,0l-3.18-4.92Z" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M13.72,19.12a2.88,2.88,0,0,1,2.8-1.41h4.23v-3.6H16S11.2,14.25,13.72,19.12Z" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M32.29,18.37s0,6.53-1.77,11.11" }), /* @__PURE__ */ React.createElement("line", { className: "cls-2", x1: 18.53, y1: 17.71, x2: 18.53, y2: 23.82 }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M7,26.67V17a11,11,0,0,1,4.21-5.54A12.6,12.6,0,0,1,16,9.51s3.82-.58,3.82-4" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M10.63,11.86a6.42,6.42,0,0,0,1.61-5.57" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M7,16.62s.07-4.17-1.58-5.12" }), /* @__PURE__ */ React.createElement("path", { className: "cls-2", d: "M21.24,10.76h0a3.37,3.37,0,0,1,3.5,2.63l2.07,9.29L29,14.52,26.1,7.26c.89-1.2,7.61.53,8.94,1.9s2.32,12.9.46,18.39" }), /* @__PURE__ */ React.createElement("line", { className: "cls-3", x1: 8.27, y1: 35.58, x2: 29.33, y2: 35.58 }))));
const SvgLetterDollar = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M23.9233 12.3365C23.9233 12.3365 22.7162 10.6154 20.1511 10.6154C17.586 10.6154 16.3789 11.9062 16.3789 13.3405C16.3789 14.7749 17.586 15.6354 20.1511 16.2092C22.7162 16.9263 23.9233 17.5001 23.9233 19.3647C23.9233 21.2293 22.5653 22.3767 20.1511 22.3767C17.4351 22.5201 16.0771 20.6555 16.0771 20.6555", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 22.3846V25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 8V10.6154", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1 18V34C1 35.6569 2.34315 37 4 37H36C37.6569 37 39 35.6569 39 34V18", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24 29.5L39 18.9259V17.5288L32.75 12", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.42857 12L1 17.6154V19.0513L28 37", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33 23V9M7 23V3H27M33 9H27V3M33 9L27 3", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgLetter = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 9H20", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 14L28 14", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 19H12", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1 18V34C1 35.6569 2.34315 37 4 37H36C37.6569 37 39 35.6569 39 34V18", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24 29.5L39 18.9259V17.5288L32.75 12", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.42857 12L1 17.6154V19.0513L28 37", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33 23V9M7 23V3H27M33 9H27V3M33 9L27 3", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgLightbulb = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M38.75 26.25L32.5 23.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38.75 11.25L32.5 13.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28.75 1.25L26.25 7.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.25 1.25L13.75 7.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.25 26.25L7.5 23.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.25 11.25L7.5 13.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 21L17.5 19L20 21L22.5 19L25 21", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M15 31H25M15 31C15 31 15 29.5 12 25.9245C11.8095 25.7315 10 23.2222 10 19.9408C10 14.4396 14.4762 10 20 10C25.5238 10 30 14.4396 30 19.9408C30 23.5117 28.1905 25.635 28 25.9245C25 29.5 25 31 25 31M15 31V36.2347C15 37.1192 15.6011 37.8907 16.4588 38.107V38.107C18.7832 38.6932 21.2168 38.6932 23.5412 38.107V38.107C24.3989 37.8907 25 37.1192 25 36.2347V31", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgLightning = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M16.8462 21.7882L11 21.4529L12.4615 1H28.5385L21.6875 15.8647H30L13.375 39L16.8462 21.7882Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31.25 10L38.75 6.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.5 10L1.25 6.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 26.25L2.5 30", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30 26.25L37.5 30", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgLocation = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M22.7766 30C26.4149 30.6429 29 32.3571 29 34.3928C29 36.9643 24.9787 39 20 39C15.0213 39 11 36.9643 11 34.3928C11 32.3571 13.5851 30.6429 17.2234 30", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30.0165 20.2085C31.2066 18.2568 32 15.8942 32 13.429C32 6.54681 26.6446 1 20 1C13.3554 1 8 6.54681 8 13.429C8 15.997 8.69421 18.2568 9.98347 20.2085C10.0826 20.4139 10.1818 20.5166 10.281 20.722L20 35L29.719 20.722C29.8182 20.5166 29.9174 20.4139 30.0165 20.2085Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 19C22.7614 19 25 16.7614 25 14C25 11.2386 22.7614 9 20 9C17.2386 9 15 11.2386 15 14C15 16.7614 17.2386 19 20 19Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 2V9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 19V34", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgLock = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M8 18V12.858C8 6.24691 13.3812 1 19.9462 1C26.5112 1 32 6.24691 32 12.7531V17.8951", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 18V13.1818C14 9.81818 16.6866 7 20 7C23.3134 7 26 9.72727 26 13.1818V18", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 25L13 25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 33H13", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 18V36.4739C9 37.8341 9.92308 39 11 39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33 25H36.75", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33 33H36.75", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 23, cy: 26, r: 3, stroke: "#5532FA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M23 34V29", stroke: "#5532FA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("rect", { x: 3, y: 18, width: 34, height: 21, rx: 3, stroke: "#292827", strokeWidth: 2 }));
const SvgMagnifyCheck = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M24 28.3636L33.515 37.8787C34.6866 39.0503 36.5861 39.0503 37.7577 37.8787L37.8787 37.7577C39.0503 36.5861 39.0503 34.6866 37.8787 33.515L28.3636 24", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32.25 36L36 32.25", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M28 32.25L31.75 28.5", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 16.5357L13.3478 21L23 11", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }));
const SvgMagnifyUser = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M24.4363 32L24.9802 27.08C25.1615 24.92 24.0737 23 22.6233 23H13.3767C11.9263 23 10.8385 24.92 11.0198 27.08L11.5637 32", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27 30.5294L34.4599 37.4027C35.4005 38.2693 36.8766 38.1656 37.6867 37.1758V37.1758C38.4264 36.2722 38.3409 34.9504 37.491 34.1496L29.9032 27", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18 33C26.2843 33 33 26.2843 33 18C33 9.71571 26.2843 3 18 3C9.71571 3 3 9.71571 3 18C3 26.2843 9.71571 33 18 33Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29 18C29 11.9 24.1 7 18 7", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgMeter = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M32.3867 21.6677L19.3494 25.7785C17.8378 26.2456 16.7986 27.5536 16.7041 29.0484C16.5152 30.8234 17.6488 32.5051 19.3494 33.0656C20.8609 33.5328 22.467 33.0656 23.4117 31.9445L32.3867 21.6677Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8.95703 25.685C8.95703 23.7231 9.4294 21.8546 10.3741 20.173", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30.8752 22.1349C29.3636 17.7439 25.1123 14.474 20.1997 14.474", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33.2368 18.2111C30.5915 13.7267 25.7734 10.7371 20.1995 10.7371H20.105C18.1211 10.7371 16.1371 11.1108 14.4366 11.8582C11.5079 13.0727 8.95717 15.2215 7.35112 17.9308C5.93403 20.173 5.17822 22.8824 5.17822 25.6851C5.17822 27.9274 5.74507 30.1696 6.6898 32.1315", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30.2138 30.6366L37.0158 34C38.3385 31.3841 38.9998 28.4879 38.9998 25.4982C38.9053 15.3149 30.4972 7 20.1996 7H20.1051C9.71308 7.09343 1.39941 15.5017 1.39941 25.6851C1.39941 28.5813 2.06073 31.2906 3.38336 33.8131L10.1854 30.4498C9.42966 28.955 9.05175 27.3668 9.05175 25.5917C9.05175 23.6298 9.52412 21.7612 10.4689 20.0796", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20.1996 7H20.1051C9.71308 7.09343 1.39941 15.5017 1.39941 25.6851C1.39941 28.5813 2.06073 31.2906 3.38336 33.8131", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M37.0159 34C38.3386 31.3841 38.9999 28.4879 38.9999 25.4982C38.9054 15.3149 30.4973 7 20.1997 7", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgMoneyHand = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 41 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M24.8491 8.04508C24.2454 7.64831 23.1586 7.15233 21.7095 7.05314C18.8114 6.75556 17.3623 7.7475 17.2415 9.03702C17.1208 10.2274 18.3283 11.0209 21.1057 11.8145C24.0039 12.608 25.2115 13.3024 24.9699 14.7903C24.7284 16.2782 23.0378 17.171 20.3812 16.9726C18.8113 16.8734 17.7245 16.4766 17 15.9806", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 17V20", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 4V7", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 1H16.8389C10.906 1 6 5.86316 6 12C6 18.0211 10.7919 23 16.8389 23H21", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M21 23C27.0751 23 32 18.0751 32 12C32 5.92487 27.0751 1 21 1C14.9249 1 10 5.92487 10 12C10 18.0751 14.9249 23 21 23Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M35.4839 30.1575L37.5165 28.5091C38.3723 27.7334 38.0514 26.4728 36.8746 26.1819C35.3769 25.7941 33.2374 25.891 30.4559 27.8304L25 31.9999", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7533 28.997C29.184 27.994 29.184 25.9999 27.6503 25.9999C26.5996 25.9999 24.195 25.7872 22.5 28L20.5 31.5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1 28.628C3.66415 28.628 6.6243 25.5098 11.9526 26.0666L19.057 27.0689C20.7345 27.5143 20.7345 28.5007 20.7345 29.853C20.7345 31.2053 20.3549 32.7227 17 32.5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.3079 32.1946L19.4242 32.6071C20.7889 32.7102 22.0562 32.6071 23.4209 32.2977L34.3389 30.1324C36.6785 29.7199 37.9457 30.3386 38.6281 31.0604C39.3105 31.7822 39.0181 33.0195 38.0432 33.432L24.1195 37.2358C23.5897 37.3806 23.0489 37.4814 22.5025 37.5374L9.63119 38.8549C8.69095 38.9511 7.74353 38.9122 6.81106 38.7579C5.1494 38.483 2.42716 38.072 1 38.072", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgNestegg = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M30 36C30 36 30 34.9787 30 32", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.2794 10.2353C23.2794 10.2353 22.3986 8.82349 19.8888 8.82349C17.379 8.82349 16.2206 10.0141 16.2206 11.2047C16.2206 12.4868 17.379 13.2195 19.9853 13.7691C22.5916 14.3186 23.75 14.9597 23.75 16.5166C23.75 18.0735 22.302 19.081 19.9853 19.1725C16.6912 19.1725 15.75 17.2941 15.75 17.2941", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19.9854 19.1765V22", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19.9854 6V8.82353", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 26H20.0071C13.156 26 8.5 26 7.5 23", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27.9926 25C30.5926 24.4194 32.3259 23.6451 32.7111 22.6774C33 21.8064 33 20.5484 33 19.4839C33 11.5484 27.2222 1 20 1C12.7778 1 7 11.5484 7 19.4839C7 20.6451 7 21.5 7.5 23", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M36 27C36 27 35.1529 39 20 39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18 35C16.7143 35.6774 15.6429 36.7419 15 38", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 34C12.2727 34.72 11.4545 35.68 11 37", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 28C5.04762 31.4878 8.38094 39 20 39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.28804 17.2239C6.06797 17.5597 4.75406 17.4478 3.62785 17C3.62785 17 3.62783 20.9179 1 22.3732C3.06473 24.612 2.40777 28.194 2.40777 28.194C7.94499 27.8582 12.9191 31.7761 12.9191 31.7761C12.9191 31.7761 16.11 29.7612 19.9579 29.7612C22.0227 29.7612 24.3689 30.5448 25.8706 32C25.8706 32 26.9029 27.9702 30 28.306", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33.4688 28C33.4688 28 35.625 26.0283 38.1563 27.3773C38.1563 27.3773 36.0937 22.8113 39 20.7359C37.6875 19.9057 37.125 18.6604 36.8438 17C34.875 18.1415 33 17.4151 33 17.4151", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgNoFees = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M28 14.6249C28 14.6249 26.4615 12.4999 23.2564 12.4999C20.0513 12.4999 18.5128 14.1249 18.5128 15.9999C18.5128 17.8749 19.9231 18.8749 23.2564 19.6249C26.5897 20.375 28 21.25 28 23.5C28 25.75 26.2051 27.25 23.2564 27.25C19.7949 27.375 18 25.125 18 25.125", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.1284 27.75V31", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23.1284 9V12.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 4L7 36", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23 35C31.2843 35 38 28.2843 38 20C38 17.0057 37.1227 14.2164 35.611 11.875M33.5882 9.375C30.8752 6.67135 27.1328 5 23 5C14.7157 5 8 11.7157 8 20C8 23.8418 9.44427 27.3462 11.8195 30", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M23 35H18C16.1061 35 14.2942 34.649 12.6258 34.0085M23 5H18C9.71573 5 3 11.7157 3 20C3 25.1385 5.5838 29.6735 9.52307 32.3768", stroke: "#292827", strokeWidth: 2 }));
const SvgPig = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M3.14629 35C7.43886 32.6844 6.51902 24.1937 2.83967 25.0621C1.71543 25.3515 1 26.2199 1 27.4742C1 29.2109 2.53306 31.1406 4.98596 30.4652L5.59918 30.2722", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14 39H11.7137C11.4889 39 11.2918 38.8501 11.2318 38.6335L10 34.1867C7.33333 32.3817 6 29.0405 6 25.4625C6 23.4624 6.61908 21.5926 7.76097 20", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M26.2727 14.8182C26.9158 12.9463 28.0569 11.2895 31.6352 11.0341C32.186 10.9947 32.6364 11.4477 32.6364 12L32.6364 16.0909L34.8889 18.3435C35.0765 18.531 35.3308 18.6364 35.596 18.6364L38 18.6364C38.5523 18.6364 39 19.0841 39 19.6364L39 27.8182C39 28.3705 38.5523 28.8182 38 28.8182L34.6575 28.8182C33.7539 31.4004 32.0252 32.7616 30.0909 33.9091L28.9129 38.6213C28.8572 38.8438 28.6572 39 28.4278 39L24.0877 39C23.8724 39 23.6814 38.8623 23.6133 38.6581L22.5685 35.5237C22.5005 35.3195 22.3094 35.1818 22.0942 35.1818L18.9967 35.1818C18.7815 35.1818 18.5905 35.3195 18.5224 35.5237L17.4776 38.6581C17.4095 38.8623 17.2185 39 17.0033 39L12 39", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("circle", { cx: 28.125, cy: 21.875, r: 1.875, fill: "#292827" }), /* @__PURE__ */ React.createElement("circle", { cx: 15, cy: 8.75, r: 7.5, stroke: "#5532FA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M15 1.25H10C5.85786 1.25 2.5 4.60786 2.5 8.75C2.5 12.8921 5.85786 16.25 10 16.25H15", stroke: "#5532FA", strokeWidth: 2 }));
const SvgQuick = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M7.64453 5.13989L14 11", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18 0V9", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27.5929 13.6087C29.3748 11.7174 31.4575 13.6087 31.4575 13.6087C32.8308 14.7221 32.0758 16.7609 32.0758 16.7609C32.0758 16.7609 33.3124 16.1304 34.8044 16.8203C36.2758 18.1361 35.7856 19.913 35.7856 19.913C35.7856 19.913 36.3739 18.9458 38.1396 20.5652C40.0033 22.2859 38.2588 24.3261 38.2588 24.3261L35.2948 28.1563C35.2948 28.1563 33.1368 31.1928 31.0768 29.4721C28.7225 27.4478 30.8392 25.587 30.8392 25.587C30.8392 25.587 29.213 27.4478 27.0549 25.9296C25.1911 24.5126 27.1294 22.4348 27.1294 22.4348C27.1294 22.4348 25.3873 24.6138 23.033 22.792C20.6788 20.9701 22.7388 18.9458 22.7388 18.9458C28.0359 13.0754 28.0359 13.0754 35.1967 5.68671C35.1967 5.68671 37.0605 3.25756 35.3929 1.73934C33.5291 0.0186989 31.7634 1.84056 31.7634 1.84056L16 16.7609", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32.5 16.5L26 23.5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M36 20L30.5 26", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 29.7922C32 29.7922 29.7508 32.1474 26.6215 35.2877C26.6215 35.2877 19.6782 42.5497 12.1483 36.7598C7.84543 33.4232 7.45426 26.9462 7.45426 26.9462L5.00946 20.0768L1 16.7402C1 16.7402 1.29338 11.539 6.18297 13.4036C12.6372 15.857 11.9527 21.5488 11.9527 21.5488C11.9527 21.5488 20.0694 21.4507 20.0694 30.381", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgReport = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M28 21L23 26.0467L28 31", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M23 33C26.866 33 30 29.866 30 26C30 22.134 26.866 19 23 19C19.134 19 16 22.134 16 26C16 29.866 19.134 33 23 33Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 36C5.8 36 4 34.2105 4 32C4 29.7895 5.8 28 8 28C10.2 28 12 29.7895 12 32", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 12C5.8 12 4 10.2338 4 8.05195C4 5.87013 5.8 4 8 4C10.2 4 12 5.76623 12 7.94805", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M8 24C5.8 24 4 22.2105 4 20C4 17.7895 5.8 16 8 16C10.2 16 12 17.7895 12 20", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 14L31 14", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 9L24 9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34 1H10C8.89543 1 8 1.89543 8 3V37C8 38.1046 8.89543 39 10 39H34C35.1046 39 36 38.1046 36 37V3C36 1.89543 35.1046 1 34 1Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgRocket = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M13.75 35L10 38.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.25 33.75L1.25 38.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 27.5L1.25 31.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M16 24L9 31", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19 31V39L30 28V20C36.8571 13.1966 38.0359 9.8232 39.0002 1C30.1073 1.95673 26.7502 4.19657 20.0002 11H12.0002L1 22H9C9 22 9.35714 28.4487 19 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30 2.5C30 2.5 31.7411 8.125 37.5 10", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M19 31L30 20", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 22L20 11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27.5 14C28.3284 14 29 13.3284 29 12.5C29 11.6716 28.3284 11 27.5 11C26.6716 11 26 11.6716 26 12.5C26 13.3284 26.6716 14 27.5 14Z", fill: "#292827" }), /* @__PURE__ */ React.createElement("path", { d: "M22.5 19C23.3284 19 24 18.3284 24 17.5C24 16.6716 23.3284 16 22.5 16C21.6716 16 21 16.6716 21 17.5C21 18.3284 21.6716 19 22.5 19Z", fill: "#292827" }));
const SvgSafeHarbor = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M32 26C29 26 29 29 26 29C23 29 23 26 20 26C17 26 17 29 14 29C11 29 11 26 8 26", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30 6H37V23.3892C37 24.2784 36.4688 32.7754 20 39C3.2125 32.6766 3 23.5868 3 23.3892V6H15", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29.1739 23.6L31 19L10 22.16V24", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29 19.6154C29 11.5 26.3996 6.10199 21.2727 1C20.4182 6.64103 16.0476 17 12 22", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgSalesMaterials = (props2) => /* @__PURE__ */ React.createElement("svg", { width: "40px", height: "40px", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props2 }, /* @__PURE__ */ React.createElement("title", null, "sales-materials 2"), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("polygon", { id: "path-1", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-3", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-5", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-7", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-9", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-11", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-13", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-15", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-17", points: "0 40 40 40 40 0 0 0" }), /* @__PURE__ */ React.createElement("polygon", { id: "path-19", points: "0 40 40 40 40 0 0 0" })), /* @__PURE__ */ React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "sales-materials-2" }, /* @__PURE__ */ React.createElement("path", { d: "M34.3297143,31.2668276 L35.9175714,29.7654483 C36.6247143,29.0971724 36.3532857,27.924069 35.4168571,27.6344138 C34.2347143,27.2682069 32.4661429,27.3268276 30.2432857,29.182 L25.844,32.9902759", id: "Fill-1", fill: "#C9C9FF", fillRule: "nonzero" }), /* @__PURE__ */ React.createElement("path", { d: "M29.8257143,27.8893103 C29.8257143,27.8893103 30.5271429,28.9362069 29.435,29.8824138 C28.3421429,30.827931 26.4035714,32.5058621 26.4035714,32.5058621 L24.5392857,33.0982759 L22.585,32.99 L22.3521429,32.2237931 L24.8714286,29.1741379 C24.8714286,29.1741379 26.6764286,27.4562069 28.2507143,27.4562069 C29.8257143,27.4562069 29.8257143,27.8893103 29.8257143,27.8893103", id: "Fill-3", fill: "#C9C9FF", fillRule: "nonzero" }), /* @__PURE__ */ React.createElement("path", { d: "M5.41792857,37.8893103 L12.2500714,38.79 L25.4900714,37.4658621 L38.4543571,34.0251724 C39.3072143,33.7017241 39.5636429,32.6348276 38.9422143,31.9755172 C38.3236429,31.3196552 37.2015,30.787931 35.1736429,31.1637931 L23.8229286,33.4010345 L19.1443571,32.8610345 C19.1443571,32.8610345 23.1907857,33.59 23.1907857,30.9672414 C23.1907857,28.3437931 20.0665,29.0651724 14.6543571,28.2858621 C9.2415,27.5065517 7.9115,29.9782759 7.34221429,30.2775862 C6.77292857,30.5762069 5.30721429,30.5741379 5.30721429,32.1141379 C5.30721429,33.6541379 5.41792857,37.8893103 5.41792857,37.8893103", id: "Fill-5", fill: "#FFFFFF", fillRule: "nonzero" }), /* @__PURE__ */ React.createElement("path", { d: "M14.9272143,32.8610345 L23.8229286,33.4010345 L35.1736429,31.1637931 C37.2015,30.787931 38.3236429,31.3196552 38.9422143,31.9755172 C39.5636429,32.6348276 39.3072143,33.7017241 38.4543571,34.0251724 L25.4900714,37.4658621 L12.2500714,38.79 L5.41792857,37.8893103", id: "Stroke-7", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.54835714,30.7017931 C6.59621429,30.7452414 7.62335714,30.4066207 8.4305,29.750069 C10.3755,28.1693793 12.9126429,28.1073103 15.4119286,28.4645517 L21.6047857,29.2321379 C23.0869286,29.5611034 23.6555,30.5645517 23.0562143,31.4245517 C22.3169286,32.485931 21.3526429,33.2507586 18.4012143,33.0721379", id: "Stroke-9", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34.3297143,31.2668276 L35.9175714,29.7654483 C36.6247143,29.0971724 36.3532857,27.924069 35.4168571,27.6344138 C34.2347143,27.2682069 32.4661429,27.3268276 30.2432857,29.182 L25.844,32.9902759", id: "Stroke-11", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29.9453571,29.4288966 C30.4775,28.6192414 29.9389286,27.5392414 28.9603571,27.4668276 C27.7239286,27.3764828 26.0217857,27.5654483 24.2910714,29.8702759 L23.0560714,31.4247586", id: "Stroke-13", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("g", { id: "Fill-15-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-2", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-1" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("polygon", { id: "Fill-15", fill: "#FFFFFF", fillRule: "nonzero", mask: "url(#mask-2)", points: "0.714285714 39.3103448 5.30714286 39.3103448 5.30714286 29.1744828 0.714285714 29.1744828" })), /* @__PURE__ */ React.createElement("g", { id: "Fill-17-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-4", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-3" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("polygon", { id: "Fill-17", fill: "#C9C9FF", fillRule: "nonzero", mask: "url(#mask-4)", points: "0.714285714 39.3103448 5.30714286 39.3103448 5.30714286 34.4262069 0.714285714 34.4262069" })), /* @__PURE__ */ React.createElement("g", { id: "Stroke-18-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-6", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-5" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("polygon", { id: "Stroke-18", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round", mask: "url(#mask-6)", points: "0.714285714 39.3103448 5.30714286 39.3103448 5.30714286 29.1744828 0.714285714 29.1744828" })), /* @__PURE__ */ React.createElement("g", { id: "Fill-19-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-8", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-7" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("path", { d: "M21.1900714,1.28572414 C21.0407857,1.28641379 20.8915,1.28848276 20.7415,1.28848276 C16.3679286,1.28848276 12.0879286,1.08986207 7.82292857,0.689862069 C7.57221429,5.52986207 12.2336429,10.1243448 18.1079286,11.2326207 L19.0893571,11.3643448 L18.9422143,12.314 C18.9422143,12.314 17.6879286,21.9836552 26.5050714,24.7429655 C28.1543571,20.7974483 29.5900714,16.7464138 30.8022143,12.6036552 C32.0143571,8.71951724 32.9393571,4.68296552 33.6150714,0.689862069 C29.4300714,1.08641379 25.3122143,1.27262069 21.1900714,1.28572414", id: "Fill-19", fill: "#FFFFFF", fillRule: "nonzero", mask: "url(#mask-8)" })), /* @__PURE__ */ React.createElement("g", { id: "Fill-20-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-10", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-9" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("path", { d: "M27.5970714,22.0245517 C27.5942143,22.0197241 27.5935,22.0176552 27.5906429,22.0128276 C21.8720714,20.6686897 21.3749286,15.1342069 21.5913571,11.9307586 C21.6763571,10.665931 20.8056429,9.51834483 19.5213571,9.23696552 C11.2606429,7.42662069 10.5399286,1.28593103 10.5399286,1.28593103 L7.8235,0.773517241 C7.63064286,5.58248276 12.2677857,10.1314483 18.1077857,11.2328276 L19.0892143,11.3645517 L18.9420714,12.3142069 C18.9420714,12.3142069 17.6877857,21.9831724 26.5049286,24.7424828 C26.8813571,23.8431724 27.2427857,22.9355862 27.5970714,22.0245517", id: "Fill-20", fill: "#C9C9FF", fillRule: "nonzero", mask: "url(#mask-10)" })), /* @__PURE__ */ React.createElement("g", { id: "Stroke-21-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-12", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-11" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("path", { d: "M20.7412143,1.28841379 C16.3676429,1.28841379 12.0876429,1.0897931 7.82335714,0.689793103 C7.57192857,5.5297931 12.2333571,10.1249655 18.1076429,11.2325517 L19.0890714,11.3642759 C19.3755,9.56427586 20.7047857,2.85737931 21.1897857,1.28565517 C21.0405,1.28634483 20.8912143,1.28841379 20.7412143,1.28841379 Z", id: "Stroke-21", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round", mask: "url(#mask-12)" })), /* @__PURE__ */ React.createElement("g", { id: "Stroke-22-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-14", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-13" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("path", { d: "M21.1900714,1.28572414 C21.1900714,1.28572414 28.1279286,6.12986207 30.8022143,12.6036552 C32.0143571,8.71951724 32.9393571,4.68296552 33.6150714,0.689862069 C29.4300714,1.08641379 25.3122143,1.27262069 21.1900714,1.28572414 Z", id: "Stroke-22", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round", mask: "url(#mask-14)" })), /* @__PURE__ */ React.createElement("g", { id: "Stroke-23-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-16", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-15" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("path", { d: "M19.0894286,11.3644828 L18.9422857,12.3141379 C18.9422857,12.3141379 17.688,21.9831034 26.5051429,24.7424138 C28.1537143,20.7975862 29.5901429,16.7465517 30.8022857,12.6037931 C25.5322857,12.2210345 19.0901429,11.3644828 19.0894286,11.3644828 Z", id: "Stroke-23", stroke: "#324063", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round", mask: "url(#mask-16)" })), /* @__PURE__ */ React.createElement("g", { id: "Stroke-24-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-18", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-17" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("line", { x1: 12.5052857, y1: 13.556069, x2: 8.40885714, y2: 16.6071034, id: "Stroke-24", stroke: "#7878F5", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round", mask: "url(#mask-18)" })), /* @__PURE__ */ React.createElement("g", { id: "Stroke-25-Clipped" }, /* @__PURE__ */ React.createElement("mask", { id: "mask-20", fill: "white" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#path-19" })), /* @__PURE__ */ React.createElement("g", { id: "path-1" }), /* @__PURE__ */ React.createElement("line", { x1: 14.5532857, y1: 16.3927586, x2: 6.84114286, y2: 22.1368966, id: "Stroke-25", stroke: "#7878F5", strokeWidth: 1.39372822, strokeLinecap: "round", strokeLinejoin: "round", mask: "url(#mask-20)" })))));
const SvgShieldCheck = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 19.9412L17.4105 23L26 15", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 39C4.2 32.6 4 23.4 4 23.2V5.60001C9.7 4.70001 15.1 3.2 20 1C25.4 3.2 30.7 4.80001 36 5.60001V23.2C36 24.1 35.5 32.7 20 39Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 29C25.5228 29 30 24.5228 30 19C30 13.4772 25.5228 9 20 9C14.4772 9 10 13.4772 10 19C10 24.5228 14.4772 29 20 29Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 1V9.10001", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 39V29", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgShield = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 30L26.25 36.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 21.25L31.25 32.5", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M26.5 19L34.5 27", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 3.75L20 11.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5 5L18.75 18.75", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 13L10 19", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 39C4.2 32.6 4 21.4 4 21.2V5.6C9.7 4.7 15.1 3.2 20 1C25.4 3.2 30.7 4.8 36 5.6V21.2C36 22.1 35.5 32.7 20 39Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 1.25V38.75", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M36.25 20C25.3828 18.3333 14.6172 18.3333 3.75 20", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgSpecialist = (props2) => /* @__PURE__ */ React.createElement("svg", { width: "40px", height: "40px", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props2 }, /* @__PURE__ */ React.createElement("g", { id: "Page-1", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "Group" }, /* @__PURE__ */ React.createElement("polyline", { id: "Fill-1", fill: "#FFFFFF", fillRule: "nonzero", points: "27.4686329 32.9231735 25.7136589 39.1881773 31.4882828 39.1881773 33.0187214 34.1731094" }), /* @__PURE__ */ React.createElement("g", { id: "Group-46", transform: "translate(0.677763, 0.557748)" }, /* @__PURE__ */ React.createElement("path", { d: "M36.2215565,18.9117582 C36.2215565,18.9117582 37.049739,15.5150774 36.0396629,15.2339085 C34.8203757,14.8954397 34.3753026,15.3951475 34.3753026,15.3951475 C34.4545896,14.4603607 32.849528,13.6948083 32.0726488,14.706217 C31.8207961,15.0340253 30.644817,19.9438215 30.644817,19.9438215 L30.1684288,16.7103786 C30.1684288,16.7103786 29.9898665,15.0333591 29.6200827,14.8507991 C29.2642907,14.6755682 27.7505091,14.6109394 27.7505091,16.2319916 L28.3494922,24.5071536 C28.3494922,24.5071536 26.3826422,23.2212387 24.0266862,23.7842429 C23.4157101,23.9308239 23.4730099,25.4339451 24.0586675,25.7963998 C24.6443251,26.1588546 27.7731625,27.8438694 27.7731625,27.8438694 L27.5879375,29.1970783 C27.5879375,29.1970783 26.7251086,28.7979783 26.4932442,29.7034489 C26.262046,30.6095858 26.0688256,31.362479 26.0688256,31.362479 C26.0688256,31.362479 25.8969261,31.8968332 26.6344949,32.057406 C26.6977912,32.0713978 26.8070607,32.0973826 26.9343196,32.1280314 L25.8915959,35.6999431 L25.7563417,35.2648641 C25.7563417,35.2648641 25.127376,32.1760033 22.6235066,30.4150329 C20.3135238,28.789983 18.6584914,28.6920402 16.2185845,28.6920402 C13.7780114,28.6920402 12.6173566,28.9312337 12.6173566,28.0017771 L12.6173566,24.8223027 C12.6173566,24.8223027 12.2015997,24.2686264 13.767351,24.3545761 C15.3331022,24.4411921 19.8917704,24.6037638 20.1816009,20.9958731 C20.4700989,17.3886487 20.3135238,8.60911497 20.3135238,8.60911497 C20.3135238,8.60911497 21.8812739,6.90078041 22.0145293,5.16046455 C22.148451,3.42081496 22.0431792,3.66933633 20.6373345,3.3615163 C19.232156,3.05302998 17.2040084,2.22884517 15.1532074,0.857646841 C13.1017401,-0.512218939 8.44246415,-0.0624818763 6.59287883,0.960253519 C4.74329352,1.98232264 3.72921973,3.6586759 3.55998533,5.14380762 C3.55998533,5.14380762 2.06152807,5.31370829 2.33936563,8.58779411 C2.61653692,11.8618799 3.275485,13.6828153 3.75253943,14.22783 C4.22959385,14.7728447 4.54607549,15.2152527 4.30621572,15.677649 C4.06635595,16.1413779 3.69990353,18.0615886 6.2384194,18.9477372 L6.2384194,28.1237058 C6.2384194,28.1237058 6.21709853,28.7040332 5.00847182,28.6980367 C3.80117766,28.6920402 3.46604026,28.232309 2.30671805,29.0458334 C1.14739585,29.860024 0.361855109,30.7894806 0.228599683,32.8682653 C0.0960105345,34.9463837 0.216606695,38.6308962 0.216606695,38.6308962 L26.7997316,38.6308962 L30.81072,38.6308962 L32.4324385,33.5265471 C32.6609716,33.5845132 32.8055537,33.622491 32.8055537,33.622491 C32.8055537,33.622491 33.2512931,33.8356997 33.4225263,33.2620351 C33.5937595,32.6883705 33.9115737,31.350486 33.9115737,31.350486 C33.9115737,31.350486 33.8942505,30.9407255 33.532462,30.7681598 L34.0501594,28.8146352 C34.0501594,28.8146352 35.2281373,28.5821045 38.1490963,20.3169367 C38.8173722,18.4247097 36.9891078,17.3813197 36.2215565,18.9117582", id: "Fill-2", fill: "#FFFFFF", fillRule: "nonzero" }), /* @__PURE__ */ React.createElement("path", { d: "M5.00873833,28.6918404 L5.44848123,30.00374 C5.44848123,30.00374 8.20820111,33.9880773 11.6488562,34.7276449 L13.7849407,32.7354763 L16.6872439,32.999322 L15.192118,28.6905078 C15.192118,28.6905078 19.834737,28.6052243 21.5117566,29.905131 C23.1881098,31.2043714 25.6086946,34.5057746 25.6086946,34.5057746 L26.9645686,31.9386088 L32.3280995,33.6949153 C31.1108112,37.6945769 31.05018,38.6007138 29.990133,38.6306963 C28.9307524,38.6606788 0.216873206,38.6306963 0.216873206,38.6306963 L0.216873206,32.8687317 C0.216873206,32.8687317 -0.685266028,28.6918404 5.00873833,28.6918404", id: "Fill-4", fill: "#C9C9FF", fillRule: "nonzero" }), /* @__PURE__ */ React.createElement("path", { d: "M22.148451,3.42081496 C22.148451,3.42081496 19.9837166,6.64492999 13.6674094,6.72821464 C7.35243476,6.81149928 6.81141773,9.81107892 6.61886364,10.3507634 C6.61886364,10.3507634 8.5077593,9.8057487 12.5953695,10.8871165 C15.9927166,11.7859243 20.3135238,10.8458073 20.3135238,10.8458073 L20.3135238,9.01487775 L21.172355,7.44512883 C21.172355,7.44512883 22.148451,6.06127123 22.148451,3.42081496", id: "Fill-6", fill: "#C9C9FF", fillRule: "nonzero" }), /* @__PURE__ */ React.createElement("polygon", { id: "Fill-8", fill: "#C9C9FF", fillRule: "nonzero", points: "21.5114234 34.9862937 24.5656378 38.6308296 21.0843398 38.2104087" }), /* @__PURE__ */ React.createElement("path", { d: "M30.8106533,38.6306963 L-4.43829726e-16,38.6306963 L-4.43829726e-16,32.667516 C-4.43829726e-16,30.4714666 1.75830535,28.6918404 3.92770368,28.6918404 L5.00840519,28.6918404", id: "Stroke-10", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.9540572,28.6918404 L16.3645659,28.6918404 C22.1485176,28.6918404 24.0300842,31.8293394 26.0049296,35.172718", id: "Stroke-12", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9.66421652,22.9295426 C10.6449765,23.6151418 12.4286003,24.4413254 15.3335686,24.4413254 C20.3133239,24.4413254 20.3133239,20.0625521 20.3133239,20.0625521 L20.3133239,8.27877477 C16.8753339,9.65263822 12.353311,9.32816125 9.40103705,8.87975674 C7.79530917,8.63589931 6.3521529,9.88250383 6.3521529,11.5188805 L6.3521529,14.2126389 C6.3521529,14.2126389 4.19541383,14.2126389 4.19541383,16.4866427 C4.19541383,18.7613129 6.23821952,18.9472042 6.23821952,18.9472042 L6.23821952,27.3169775", id: "Stroke-14", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("line", { x1: 4.22986036, y1: 38.6306963, x2: 4.22986036, y2: 34.9861604, id: "Stroke-16", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("line", { x1: 21.0846063, y1: 38.6306963, x2: 21.0846063, y2: 34.9861604, id: "Stroke-18", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20.3135904,8.27864152 C20.3135904,8.27864152 22.1485176,7.44512883 22.1485176,3.42081496 C22.1485176,3.42081496 19.4301069,3.70065136 16.9102468,1.91836003 C15.1132974,0.647769545 13.8593638,0.118079226 11.0190244,0.118079226 C3.57537634,0.118079226 3.55938569,5.14380762 3.55938569,5.14380762 C3.55938569,5.14380762 2.06359353,5.30904435 2.33943226,8.58779411 C2.78783677,13.9286716 4.22966048,14.7728447 4.22966048,14.7728447", id: "Stroke-20", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.42191212,13.0974242 C6.42191212,13.0974242 8.69924735,18.7201369 13.3045549,19.2464959", id: "Stroke-22", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11.648723,18.8160808 C12.1624226,19.027957 12.7147664,19.1792019 13.3044216,19.2464959", id: "Stroke-24", stroke: "#324063", strokeWidth: 2.71186441, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.42131247,7.35991198 C6.66583618,5.24381582 7.77252249,0.207426989 12.764937,0.207426989", id: "Stroke-26", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32.8056203,33.6225576 C33.0774614,33.6918504 33.3533001,33.5312777 33.4225929,33.2621017 L33.9116404,31.3498863 C33.9809332,31.0813767 33.8163627,30.8055379 33.5445217,30.7355788 L27.1749123,29.0898743 C26.9037375,29.0205815 26.6272325,29.1811543 26.5586059,29.4503302 L26.0688923,31.3625456 C25.9995994,31.6317216 26.1641699,31.906894 26.4353447,31.9761868 L26.8291145,32.1027795", id: "Stroke-28", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27.5879375,29.1967452 L27.7758276,27.8462014 C27.7758276,27.8462014 25.3632381,26.5263064 24.3811457,25.828048 C23.3977206,25.1297896 23.3910578,23.9871243 24.5443836,23.7366041 C26.625167,23.2835356 28.3494922,24.5074867 28.3494922,24.5074867", id: "Stroke-30", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M30.5875171,20.4557222 L30.0884756,15.997662 C30.0884756,15.997662 29.8399542,14.3706132 28.7252725,14.5131965 C27.3893869,14.6837635 27.6099246,16.2095381 27.6099246,16.2095381 L28.3494922,24.5073535 C28.3494922,24.5073535 30.3263365,23.7271429 31.4896564,25.1949515", id: "Stroke-32", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34.0502926,28.8147685 C35.2615844,29.0739503 37.8400769,22.2999107 38.4950274,20.6675317 C39.2425903,18.8059534 36.9805794,17.7845506 36.2123619,19.3149892 L35.0017364,22.656369 L36.7400534,17.8605062 C37.0532037,16.8337731 37.3423679,15.6591265 36.1670551,15.2786823 C34.9630923,14.8882439 34.4060846,16.4733172 34.0982646,17.5800035 L32.8982995,21.466398 L34.0982646,17.5800035 C34.0982646,17.5800035 34.4593868,16.222797 34.5779841,15.6811137 C35.0350502,13.5923349 32.4818763,13.0639771 32.0727821,14.705684 L30.5876504,20.4556556", id: "Stroke-34", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("line", { x1: 33.5447882, y1: 30.7355788, x2: 34.0504925, y2: 28.8147019, id: "Stroke-36", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24.2526874,13.9445956 C24.2526874,13.9445956 23.7110041,15.6089559 24.032816,17.583135", id: "Stroke-38", stroke: "#7878F5", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("polyline", { id: "Stroke-40", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round", points: "25.0360294 38.6306963 30.8106533 38.6306963 32.3410919 33.6156283 30.1417111 32.968007" }), /* @__PURE__ */ React.createElement("line", { x1: 26.8293143, y1: 32.1025796, x2: 25.7326222, y2: 36.1455492, id: "Stroke-42", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.6175565,24.4982921 L12.6175565,28.6918404 C13.2505198,29.6825944 13.4357448,30.8359202 13.3044882,32.102513 C10.4021851,31.1863819 7.99892346,29.6499469 6.23861928,27.3166444 L5.0086717,28.6978368 C5.9701096,31.3316303 8.83576754,33.7568791 11.6487896,34.7276449 C12.1704846,33.7308943 12.8640791,33.035301 13.7848741,32.7354763 C14.69834,32.4303213 15.6784337,32.6068848 16.6871772,32.999322 C16.8497489,31.5295146 16.1328347,30.0930212 14.9541904,28.6918404 L12.6175565,27.707749", id: "Stroke-44", stroke: "#324063", strokeWidth: 1.3559322, strokeLinecap: "round", strokeLinejoin: "round" })))));
const SvgStop = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M17 17.7328V10.7862C17 9.79388 16.1111 9 15 9C13.8889 9 13 9.79388 13 10.7862L13 19.5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 20V9.86792C21 8.83018 20.1111 8 19 8C17.8889 8 17 8.83018 17 9.86792V19.9906", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M25 21V10.8409C25 9.81817 24.1111 9 23 9C21.8889 9 21 9.81817 21 10.8409", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24.9999 13.7705C24.9999 12.7869 26.0139 12 26.9999 12C27.986 12 28.9999 12.7869 28.9999 13.7705V24.5246C28.9999 24.5246 27.9999 32 19.9143 32C13.0119 32 10 24 10 24C10 24 8.00024 19 11.0002 19C14.0002 19 15 24 15 24C15 24 18.3179 21.6066 22.0001 26", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M29.5 3H10.5L1 20L10.5 37H29.5L39 20L29.5 3Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgSyncEmployee = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M33 11L38 6L33 1", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M20 23C22.7614 23 25 20.7614 25 18C25 15.2386 22.7614 13 20 13C17.2386 13 15 15.2386 15 18C15 20.7614 17.2386 23 20 23Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M38 6H8C5.79086 6 4 7.79086 4 10V18", stroke: "#5532FA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M7 29L2 34L7 39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M2 34L32 34C34.2091 34 36 32.2091 36 30L36 22", stroke: "#292827", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M26 28V25C26 23.8954 25.1046 23 24 23H16C14.8954 23 14 23.8954 14 25V28", stroke: "#292827", strokeWidth: 2 }));
const SvgSyncMoney = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12 25.1042C17.3581 22.0011 22.6419 28.2073 28 25.1042C28 21.6744 28 18.2447 28 14.8149C22.6419 17.9997 17.3581 11.7934 12 14.8966C12 18.3263 12 21.7561 12 25.1042Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z", fill: "#292827" }), /* @__PURE__ */ React.createElement("path", { d: "M33 11L38 6L33 1", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M38 6H8C5.79086 6 4 7.79086 4 10V18", stroke: "#5532FA", strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M7 29L2 34L7 39", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M2 34L32 34C34.2091 34 36 32.2091 36 30L36 22", stroke: "#292827", strokeWidth: 2 }));
const SvgTime = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M24 9V20L31 25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M24 35C32.2843 35 39 28.2843 39 20C39 11.7157 32.2843 5 24 5C15.7157 5 9 11.7157 9 20C9 28.2843 15.7157 35 24 35Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0 8L15 8", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0 20H7", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0 26H3.75", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 32L15 32", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 14L14 14", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6 26L15 26", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgTransfer = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10 28L10 35C10 36.6569 11.3431 38 13 38H34C35.6569 38 37 36.6569 37 35V12", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27 2H13C11.3431 2 10 3.34315 10 5V20", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27 2V12H37L27 2Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M21 18L27 24L21 30", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M26 24L0 24", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgTrash = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M14 32V17", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 32V17", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M26 32V17", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22 1H18C15.7909 1 14 2.79086 14 5V6H26V5C26 2.79086 24.2091 1 22 1Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M33 11L31.2654 35.285C31.1158 37.3782 29.3741 39 27.2755 39H12.7245C10.6259 39 8.88416 37.3782 8.73464 35.285L7 11", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M4 10C4 7.79086 5.79086 6 8 6H32C34.2091 6 36 7.79086 36 10V11H4V10Z", stroke: "#292827", strokeWidth: 2 }));
const SvgUmbrella = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M6 11C2.85185 14.3191 1 18.6596 1 23", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 23C39 13.4541 30.8148 4 20.7037 4C18.0074 4 15.4074 4.7343 13 5.92754", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M27 24C25.9733 23.1852 23.1733 22 20 22C16.7333 22 14.0267 23.1852 13 24", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 23.4074C38.0526 22.5926 35.7368 22 33 22C30.2632 22 27.8421 23.1852 27 24", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M13 24C12.0526 23.1852 9.73684 22 7 22C4.26316 22 1.84211 22.5926 1 23.4074", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 19C26.8267 17.2632 23.6267 16 20 16C16.2667 16 13.1733 17.2632 12 19", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 19C29 18 31.9561 17.7037 34.1754 18.283C36.9737 19.1105 38.1316 21.0139 39 23", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 4C20 4 12.4267 4 12 19", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 4C20 4 27.5733 4 28 19", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M20 16V35.1345C20 37.2605 21.8 39 24 39C26.2 39 28 37.2605 28 35.1345V33.2983", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3 1V7.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M9 4V10.25", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 9.25V3", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M34 5V0", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12 19.0088C11.0833 18.011 8.04386 17.7153 5.82456 18.2933C3.02632 19.1191 1.86842 21.0182 1 23", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }));
const SvgUploadDoc = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M18 19L23.9528 13L30 19", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M24 26.5V14", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.84 9H7C5.34315 9 4 10.3431 4 12V36C4 37.6569 5.34315 39 7 39H25C26.6569 39 28 37.6569 28 36V35.25", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 1H15C13.3431 1 12 2.34315 12 4V28C12 29.6569 13.3431 31 15 31H33C34.6569 31 36 29.6569 36 28V9", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M28 1V8.5C28 8.77614 28.2239 9 28.5 9H36L28 1Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgUserMan = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M23 29.5V26C25.4375 26 27.5 24.1545 27.5 22.4545V16.1V12.2727C22.25 14.3727 20.375 11.5 16.5313 11V16.1H14.9375C12.4063 16.1 12.4063 20.7 14.9375 20.7V30.3L6.21875 34C5.46875 34.3 5 35 5 35.9V39H35V35.9C35 35.1 34.5313 34.4 33.875 34.1L23 29.5Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23 26L19 26", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 31.25C14.1981 33.5577 16.934 35 20.0472 35C23.066 35 25.8019 33.5577 27.5 31.3461", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M14.3776 25C11.3901 25 9 22.6296 9 19.6667V9.49383C9 7.61729 10.4938 6.1358 12.3859 6.1358C12.3859 6.1358 12.8838 1 20.7511 1C28.6183 1 28.0207 8.50618 33 8.50618C33 8.50618 33 17.0988 26.8257 17.0988", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgUserWoman = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M23 29.5V26C25.4375 26 27.5 24.1545 27.5 22.4545V16.1V12.2727C22.25 14.3727 20.375 11.5 16.5313 11V16.1H14.9375C12.4063 16.1 12.4063 20.7 14.9375 20.7V30.3L6.21875 34C5.46875 34.3 5 35 5 35.9V39H35V35.9C35 35.1 34.5313 34.4 33.875 34.1L23 29.5Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M11 6.00001C12.8333 3.23406 16.0175 1 20.3596 1C27.693 1 31.6491 6.6383 31.6491 13.0213C31.6491 15.0426 31.8421 16.4255 33 17.8085C32.2281 19.8298 29.5263 21 27.307 21", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M23 26L19 26", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 4C7.32772 4.09063 5.10081 6.26562 5.01174 8.98438C4.83359 11.7031 6.70418 13.9688 9.19831 14.5125V33", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.5 31.25C14.1981 33.5577 16.934 35 20.0472 35C23.066 35 25.8019 33.5577 27.5 31.3461", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgVideo = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20 31C24.9706 31 29 26.9706 29 22C29 17.0294 24.9706 13 20 13C15.0294 13 11 17.0294 11 22C11 26.9706 15.0294 31 20 31Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M18 26V18L24 22L18 26Z", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M36 4H4C2.34315 4 1 5.34315 1 7V33C1 34.6569 2.34315 36 4 36H36C37.6569 36 39 34.6569 39 33V7C39 5.34315 37.6569 4 36 4Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M39 9H1", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgWand = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 41, viewBox: "0 0 40 41", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M18.7002 0.0699463V5.93994", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 0.5L13.9803 7.63", stroke: "#5532FA", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M0 15.8199H8.34", stroke: "#5532FA", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M3.76953 24.4399L8.33953 21.7999", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.7695 27.37L8.76953 34.29", stroke: "#5532FA", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M31.9502 15.8199H40.0002", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M7.83039 37.58C8.8963 37.58 9.76039 36.7159 9.76039 35.65C9.76039 34.5841 8.8963 33.72 7.83039 33.72C6.76448 33.72 5.90039 34.5841 5.90039 35.65C5.90039 36.7159 6.76448 37.58 7.83039 37.58Z", stroke: "#5532FA", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.41047 10.83C7.47638 10.83 8.34047 9.96589 8.34047 8.89998C8.34047 7.83407 7.47638 6.96997 6.41047 6.96997C5.34456 6.96997 4.48047 7.83407 4.48047 8.89998C4.48047 9.96589 5.34456 10.83 6.41047 10.83Z", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22.6299 22.61L32.5 39.5", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32.5 1C31.16 2.24 27.6702 4.99999 28.3202 8.60999C28.9702 12.22 32.6702 10.85 32.2402 8.13998C31.7702 5.23998 28.8602 4.61999 24.7002 7.64999", stroke: "#5532FA", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M17.6602 21.6299L12.4502 20.2199L16.7402 16.9399L16.4702 11.5399L20.9102 14.6099L25.9602 12.6799L24.4202 17.8599L27.8102 22.0599L22.4102 22.1999L19.4602 26.7199L17.6602 21.6299Z", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }));
const SvgWave = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M37 6C37 6 40.125 9.65432 38.5625 14", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M1.37493 10C1.37493 10 -0.462723 14.8684 4 18", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M12.7129 22.2667L8.50703 8.83468C8.22664 7.58289 9.06781 6.24168 10.3763 6.06285C11.6848 5.79461 12.9933 6.59934 13.2737 7.94054L17.7599 20.4585L14.4887 5.88402C14.2083 4.63223 15.0495 3.38044 16.358 3.1122C17.6665 2.84396 18.975 3.64868 19.1619 4.98989L22.7135 19.2961L21.405 5.61578C21.2181 4.36399 22.1527 3.20161 23.4612 3.02279C24.7697 2.84396 25.8913 3.7381 26.0782 4.98989L27.854 18.9384L28.5083 10.1759C28.5083 8.92409 29.5364 7.94054 30.7514 7.94054C31.9664 7.94054 33.088 8.92409 32.9945 10.1759V26.0915C32.9011 33.6917 28.5083 37 23.0874 37C16.1711 37 12.7129 31.9928 12.7129 31.9928L5.70312 29.7575C5.70312 29.7575 1.8711 28.3269 5.70312 25.7339C7.75932 24.3033 12.9933 26.628 12.9933 26.628C12.9933 26.628 20.7508 21.442 24.7697 28.5057", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const SvgWrench = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M1.03998 36.7643L16.28 21.5243C20.2 23.2243 24.92 22.4843 28.12 19.2843C30.32 17.0843 31.36 14.1543 31.24 11.2643C31.19 10.1143 30.96 8.97428 30.55 7.89428L28.8 9.64428L24.22 14.2243C22.51 15.9343 19.74 15.9343 18.03 14.2243C16.32 12.5143 16.32 9.74426 18.03 8.03426L24.36 1.70427C20.54 0.244275 16.05 1.05427 12.97 4.13427C9.76997 7.33427 9.02998 12.0543 10.73 15.9743L1 25.7043", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M6.60986 25.6742L12.9899 19.2842", stroke: "#292827", strokeWidth: 2, strokeLinejoin: "round" }));
const SvgWrite = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10 5V36.3305C10 37.8135 11.1729 39 12.6391 39M12.6391 39C14.1053 39 15.2782 37.8135 15.2782 36.3305V36C15.2782 35.4477 15.7259 35 16.2782 35H35C35.5523 35 36 35.4477 36 36V36.3305C36 37.8135 34.8271 39 33.3609 39H12.6391Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 7V3.05882C32 1.92647 31.1266 1 30.1561 1H7", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M32 35L32 21", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M10 15H5C4.44772 15 4 14.5523 4 14V3.71942C4 2.20863 5.33333 1 7 1C8.66667 1 10 2.20863 10 3.71942V5", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M22.4861 30C22.6177 30 22.744 29.9481 22.8376 29.8556L35.0575 17.7771C36.1285 16.7186 36.1335 14.9907 35.0687 13.9259V13.9259C34.0061 12.8632 32.2823 12.8658 31.2228 13.9317L19.1454 26.0828C19.0523 26.1765 19 26.3032 19 26.4353V30H22.4861Z", stroke: "#292827", strokeWidth: 2, strokeMiterlimit: 10 }), /* @__PURE__ */ React.createElement("path", { d: "M15 7H27", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 12H27", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M15 17H21", stroke: "#5532FA", strokeWidth: 2, strokeMiterlimit: 10, strokeLinejoin: "round" }));
const illustrations = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  adjust: SvgAdjust,
  award: SvgAward,
  bank: SvgBank,
  bell: SvgBell,
  book: SvgBook,
  briefcase: SvgBriefcase,
  building: SvgBuilding,
  business: SvgBusiness,
  cake: SvgCake,
  calendar: SvgCalendar,
  care: SvgCare,
  caution: SvgCaution,
  celebrate: SvgCelebrate,
  charts: SvgCharts,
  chat: SvgChat,
  checklist: SvgChecklist,
  contribution: SvgContribution,
  contributionHand: SvgContributionHand,
  documentUser: SvgDocumentUser,
  documents: SvgDocuments,
  downloadDoc: SvgDownloadDoc,
  education: SvgEducation,
  email: SvgEmail,
  employee: SvgEmployee,
  folder: SvgFolder,
  gears: SvgGears,
  groupHeart: SvgGroupHeart,
  groupSavings: SvgGroupSavings,
  handshake: SvgHandshake,
  institution: SvgInstitution,
  interface: SvgInterface,
  irs: SvgIrs,
  letter: SvgLetter,
  letterDollar: SvgLetterDollar,
  lightbulb: SvgLightbulb,
  lightning: SvgLightning,
  location: SvgLocation,
  lock: SvgLock,
  magnifyCheck: SvgMagnifyCheck,
  magnifyUser: SvgMagnifyUser,
  meter: SvgMeter,
  moneyHand: SvgMoneyHand,
  nestegg: SvgNestegg,
  noFees: SvgNoFees,
  pig: SvgPig,
  quick: SvgQuick,
  report: SvgReport,
  rocket: SvgRocket,
  safeHarbor: SvgSafeHarbor,
  salesMaterials: SvgSalesMaterials,
  shield: SvgShield,
  shieldCheck: SvgShieldCheck,
  specialist: SvgSpecialist,
  stop: SvgStop,
  syncEmployee: SvgSyncEmployee,
  syncMoney: SvgSyncMoney,
  time: SvgTime,
  transfer: SvgTransfer,
  trash: SvgTrash,
  umbrella: SvgUmbrella,
  uploadDoc: SvgUploadDoc,
  userMan: SvgUserMan,
  userWoman: SvgUserWoman,
  video: SvgVideo,
  wand: SvgWand,
  wave: SvgWave,
  wrench: SvgWrench,
  write: SvgWrite
}, Symbol.toStringTag, { value: "Module" }));
const illustrationKeyMap = {
  interface: "interfaceSvg"
  // can't export SVG as "interface" since it is a protected word
};
const invertedIllustrationKeyMap = Object.keys(illustrationKeyMap).reduce(
  (obj, key) => {
    obj[illustrationKeyMap[key]] = key;
    return obj;
  },
  {}
);
function mapToValidKey(key, keymap = illustrationKeyMap) {
  const mappedKey = keymap[key] || key;
  return mappedKey;
}
function getIllustrationByKey(key) {
  const mappedKey = mapToValidKey(key);
  return illustrations[mappedKey];
}
const illustrationKeys = Object.keys(illustrations).map(
  (key) => mapToValidKey(key, invertedIllustrationKeyMap)
);
const alpha = (hexValue, alphaValue) => {
  if (alphaValue > 1) {
    alphaValue = 1;
  } else if (alphaValue < 0) {
    alphaValue = 0;
  }
  alphaValue = Math.round(alphaValue * 255);
  const alphaHex = alphaValue.toString(16).padStart(2, "0");
  return `${hexValue}${alphaHex}`;
};
const colorMatcher = (colorSet, color2) => {
  if (!color2)
    return void 0;
  const colorPath = color2.split(".");
  const matchedColor = colorPath.reduce(
    (colorObj, path2) => {
      return colorObj[path2];
    },
    colorSet
  );
  if (typeof matchedColor === "string") {
    return matchedColor;
  }
  if (matchedColor == null ? void 0 : matchedColor.__default) {
    return matchedColor.__default;
  }
  return color2;
};
const xSmallMax$2 = 575;
const smallMin$2 = xSmallMax$2 + 1;
const smallMax$4 = 767;
const mediumMin$4 = smallMax$4 + 1;
const mediumMax$4 = 1023;
const largeMin$4 = mediumMax$4 + 1;
const largeMax$4 = 1279;
const xLargeMin$3 = largeMax$4 + 1;
const screenSizes$1 = {
  xSmallMax: xSmallMax$2,
  smallMin: smallMin$2,
  smallMax: smallMax$4,
  mediumMin: mediumMin$4,
  mediumMax: mediumMax$4,
  largeMin: largeMin$4,
  largeMax: largeMax$4,
  xLargeMin: xLargeMin$3
};
const breakpoints$2 = {
  smallMin: smallMin$2,
  mediumMin: mediumMin$4,
  largeMin: largeMin$4,
  xLargeMin: xLargeMin$3
};
var MatchMediaQuery = /* @__PURE__ */ ((MatchMediaQuery2) => {
  MatchMediaQuery2["xs"] = "xs";
  MatchMediaQuery2["sm"] = "sm";
  MatchMediaQuery2["smUp"] = "smUp";
  MatchMediaQuery2["smDown"] = "smDown";
  MatchMediaQuery2["md"] = "md";
  MatchMediaQuery2["mdUp"] = "mdUp";
  MatchMediaQuery2["mdDown"] = "mdDown";
  MatchMediaQuery2["lg"] = "lg";
  MatchMediaQuery2["lgUp"] = "lgUp";
  MatchMediaQuery2["lgDown"] = "lgDown";
  MatchMediaQuery2["xl"] = "xl";
  MatchMediaQuery2["print"] = "print";
  return MatchMediaQuery2;
})(MatchMediaQuery || {});
const mediaQueries$3 = {
  /** Viewport is printable */
  [
    "print"
    /* print */
  ]: "print",
  /** Viewport is Extra Small - width < 576px */
  [
    "xs"
    /* xs */
  ]: `all and (max-width: ${xSmallMax$2}px)`,
  /** Viewport is Small - 576px ≥ width < 767px */
  [
    "sm"
    /* sm */
  ]: `all and (min-width: ${smallMin$2}px) and (max-width: ${smallMax$4}px)`,
  /** Viewport is Small or larger- width ≥ 576px */
  [
    "smUp"
    /* smUp */
  ]: `all and (min-width: ${smallMin$2}px)`,
  /** Viewport is Small or smaller - width < 767px */
  [
    "smDown"
    /* smDown */
  ]: `all and (max-width: ${smallMax$4}px)`,
  /** Viewport is Medium or smaller - width < 1023 */
  [
    "mdDown"
    /* mdDown */
  ]: `all and (max-width: ${mediumMax$4}px)`,
  /** Viewport is Medium - 768px ≥ width < 1023px */
  [
    "md"
    /* md */
  ]: `all and (min-width: ${mediumMin$4}px) and (max-width: ${mediumMax$4}px)`,
  /** Viewport is Medium or bigger - width ≥ 768 */
  [
    "mdUp"
    /* mdUp */
  ]: `all and (min-width: ${mediumMin$4}px)`,
  /** Viewport is Large or smaller - width < 1280px */
  [
    "lgDown"
    /* lgDown */
  ]: `all and (max-width: ${largeMax$4}px)`,
  /** Viewport is Large - 1024px ≥ width < 1280px */
  [
    "lg"
    /* lg */
  ]: `all and (min-width: ${largeMin$4}px) and (max-width: ${largeMax$4}px)`,
  /** Viewport is Large or bigger - width ≥ 1024px */
  [
    "lgUp"
    /* lgUp */
  ]: `all and (min-width: ${largeMin$4}px)`,
  /** Viewport is X-Large: width ≥ 1280px */
  [
    "xl"
    /* xl */
  ]: `all and (min-width: ${xLargeMin$3}px)`
};
const mediaQueryKeys = Object.keys(mediaQueries$3).map(
  (key) => key
);
const breakpointNames = [
  MatchMediaQuery.xs,
  MatchMediaQuery.sm,
  MatchMediaQuery.md,
  MatchMediaQuery.lg,
  MatchMediaQuery.xl
];
const buildResponsiveValues = (values6) => {
  const result = Array.from(
    Array(breakpointNames.length)
  );
  let value;
  if (!values6)
    return result;
  for (value in values6) {
    if (Object.values(MatchMediaQuery).includes(value)) {
      const [size, direction] = [value.slice(0, 2), value.slice(2)];
      let currentIndex = breakpointNames.findIndex((v) => v === size);
      result[currentIndex] = values6[value];
      if (direction) {
        const increment = direction === "Down" ? -1 : 1;
        while (currentIndex > 0 && currentIndex < breakpointNames.length - 1) {
          currentIndex += increment;
          result[currentIndex] = values6[value];
        }
      }
    }
  }
  return result;
};
const useStyle = (sx2 = {}, themeProps = {}) => {
  const { theme: theme2 } = useTheme();
  const { bottomSpace, leftSpace, rightSpace, topSpace } = themeProps;
  const style2 = (componentStyles) => {
    const themeStyles = {
      mb: bottomSpace && theme2.space[bottomSpace],
      ml: leftSpace && theme2.space[leftSpace],
      mr: rightSpace && theme2.space[rightSpace],
      mt: topSpace && theme2.space[topSpace]
    };
    const baseStyles2 = typeof componentStyles === "function" ? componentStyles(theme2) : componentStyles;
    const overrideStyles = typeof sx2 === "function" ? sx2(theme2) : sx2;
    return {
      ...themeStyles,
      ...baseStyles2,
      ...overrideStyles
    };
  };
  return {
    colorMatcher: (color2) => colorMatcher(theme2.colors, color2),
    style: style2,
    theme: theme2
  };
};
var invariant = function(condition, format2, a4, b10, c7, d3, e3, f) {
  if (process.env.NODE_ENV !== "production") {
    if (format2 === void 0) {
      throw new Error("invariant requires an error message argument");
    }
  }
  if (!condition) {
    var error2;
    if (format2 === void 0) {
      error2 = new Error(
        "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
      );
    } else {
      var args = [a4, b10, c7, d3, e3, f];
      var argIndex = 0;
      error2 = new Error(
        format2.replace(/%s/g, function() {
          return args[argIndex++];
        })
      );
      error2.name = "Invariant Violation";
    }
    error2.framesToPop = 1;
    throw error2;
  }
};
var browser = invariant;
const invariant$1 = /* @__PURE__ */ getDefaultExportFromCjs(browser);
const IconButton2 = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(IconButton$1, { type: "button", ...props2 });
const Svg = ({
  className,
  /** Color applied to SVG. Valid color palette theme key value, hex value */
  color: color2 = "icon",
  /** Override for fill of the SVG. Valid color palette theme key value, hex value, or `none` */
  fill = "",
  /** Function to lookup SVG asset by name */
  getSvgByKey,
  /** Name of the illustration - camelCased */
  name: name2,
  /** Function to call when clicked - supply renders an IconButton */
  onClick = void 0,
  /** One of predefined sizes for icons or illustrations */
  size = void 0,
  /** Override for stroke of the SVG. Valid color palette theme key value, hex value, or `none` */
  stroke = "",
  /** Styling override */
  sx: sx2 = {},
  ...restOfProps
}) => {
  const { colorMatcher: colorMatcher2, style: style2, theme: theme2 } = useStyle(sx2);
  const SvgIcon = getSvgByKey(name2, size);
  if (SvgIcon === void 0) {
    if (isDevEnvironment()) {
      invariant$1(SvgIcon, `No SVG with name - ${name2} for size - ${size}`);
    }
    return null;
  }
  const iconColors = colorIcon(
    name2,
    size,
    colorMatcher2(color2),
    colorMatcher2(stroke),
    colorMatcher2(fill)
  );
  const iconSizes = size ? {
    height: theme2.sizes.icon[size],
    width: theme2.sizes.icon[size]
  } : {};
  const icon2 = /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, { "data-icon": name2, ...iconSizes, ...iconColors });
  return onClick ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    IconButton2,
    {
      className,
      onClick,
      size: "button.small",
      sx: style2({
        p: 0,
        "&.focus-visible": {
          outline: "solid transparent",
          boxShadow: "two-pixel-soft-minimize-inner-border"
        },
        "&:focus:not(&.focus-visible)": {
          outline: "solid transparent"
        }
      }),
      ...restOfProps,
      children: icon2
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { className, flexShrink: 0, sx: style2(), ...restOfProps, children: icon2 });
};
const Icon = ({
  className = void 0,
  color: color2 = "icon",
  disabled = false,
  fill = "",
  name: name2,
  onClick = void 0,
  size = IconSizes.Icon12,
  stroke = "",
  sx: sx2 = {},
  ...rest
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Svg,
    {
      ...rest,
      className,
      color: disabled ? "icon.subdued" : color2,
      fill,
      getSvgByKey: getIconByKey,
      name: name2,
      onClick,
      size,
      stroke,
      sx: sx2
    }
  );
};
const Illustration = ({
  name: name2,
  onClick = void 0,
  sx: sx2 = {},
  ...restOfProps
}) => {
  return (
    // TODO: maybe use this inline as an image component
    // TODO: change naming here to be more generic throughout this chain
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Svg,
      {
        getSvgByKey: getIllustrationByKey,
        name: name2,
        onClick,
        size: IconSizes.Icon40,
        sx: sx2,
        ...restOfProps
      }
    )
  );
};
const focus = {
  focusVisible: {
    outline: "solid transparent",
    // not set to "none", so will show up in high contrast mode
    boxShadow: "two-pixel-soft",
    // boxShadow instead of outline since Safari does not respect border radius when using outline  },
    border: "focusedComponents.focusVisible"
  },
  focus: {
    border: "focusedComponents.focus"
  }
};
const logo = {
  "&.focus-visible": {
    ...focus.focusVisible,
    borderRadius: "logo.container"
  },
  "&:focus": {
    ...focus.focus
  },
  "&:active": {
    opacity: "initial"
  }
};
const cobranded = {
  height: "2rem",
  svg: {
    width: "100%",
    height: "100%"
  },
  div: {
    height: "2rem"
  }
};
const SvgGuidelineAccountants = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 143, height: 30, viewBox: "0 0 143 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M20.3449 29.1094C20.2982 29.1017 20.2561 29.0765 20.2274 29.0389C20.1987 29.0012 20.1854 28.954 20.1905 28.9069V1.09857C20.1832 1.07447 20.1817 1.04894 20.186 1.02414C20.1903 0.999349 20.2004 0.975956 20.2154 0.95575C20.2304 0.935545 20.25 0.919115 20.2725 0.907807C20.295 0.896499 20.3198 0.890625 20.3449 0.890625C20.3701 0.890625 20.3949 0.896499 20.4174 0.907807C20.4399 0.919115 20.4595 0.935545 20.4745 0.95575C20.4895 0.975956 20.4995 0.999349 20.5039 1.02414C20.5082 1.04894 20.5067 1.07447 20.4994 1.09857V28.9069C20.5044 28.954 20.4912 29.0012 20.4625 29.0389C20.4338 29.0765 20.3917 29.1017 20.3449 29.1094Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M7.649 5.53073L7.49451 6.96232C7.18896 6.1315 6.27233 5.30418 4.58667 5.30418C3.75688 5.28722 2.93809 5.49608 2.2178 5.90841C0.765593 6.81132 0 8.46948 0 10.5019C0 12.6888 0.841122 14.2783 2.2178 15.0988C2.9182 15.4925 3.70766 15.7005 4.51113 15.703C6.11783 15.703 6.80788 14.9478 7.03446 14.347V15.8542C7.02202 16.3749 6.80777 16.8704 6.43689 17.2361C6.06602 17.6019 5.56755 17.8093 5.04669 17.8145C3.90003 17.89 3.05892 17.4368 2.90443 16.4412L0.611106 17.5741C1.14667 19.1568 2.75338 20.0597 5.12223 20.0597C8.03008 20.0597 10.0934 18.4771 10.0934 15.6894V5.51699L7.649 5.53073ZM6.42338 12.7643C6.05374 13.0576 5.59576 13.2172 5.12393 13.2172C4.65209 13.2172 4.19414 13.0576 3.8245 12.7643C3.28893 12.3112 2.98338 11.6348 2.98338 10.5019C2.98338 9.36896 3.28893 8.69604 3.8245 8.24287C4.19414 7.94962 4.65209 7.79001 5.12393 7.79001C5.59576 7.79001 6.05374 7.94962 6.42338 8.24287C6.95894 8.69604 7.2645 9.37239 7.2645 10.5019C7.26566 11.3327 6.967 12.1361 6.42338 12.7643Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M10.0934 21.0623V24.4954H0V22.5488H8.15023V21.0623H10.0934Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M34.9598 5.52051H37.4523L43.2886 20.0736H40.8854L39.4332 16.3314H32.9823L31.5301 20.0736H29.127L34.9598 5.52051ZM38.5955 14.2543L36.2266 8.267H36.1854L33.8166 14.2543H38.5955Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M52.9176 18.2023C52.4401 18.8186 51.836 19.3255 51.1462 19.6888C50.3816 20.0961 49.5267 20.3039 48.6606 20.2931C47.7386 20.3016 46.8309 20.0647 46.0308 19.6064C45.2452 19.1608 44.5951 18.5107 44.1495 17.7251C43.6993 16.9217 43.4629 16.0163 43.4629 15.0954C43.4629 14.1744 43.6993 13.2689 44.1495 12.4655C44.5951 11.68 45.2452 11.0298 46.0308 10.5842C46.8047 10.1538 47.6719 9.91856 48.5573 9.89882C49.4426 9.87907 50.3195 10.0754 51.1118 10.4709C51.7811 10.8043 52.3675 11.2828 52.8284 11.8716L51.3727 13.2242C51.0617 12.8336 50.6767 12.5081 50.2398 12.2664C49.7541 12.0039 49.21 11.8682 48.6579 11.8718C48.1058 11.8754 47.5636 12.0182 47.0813 12.287C46.6082 12.561 46.2197 12.9601 45.9587 13.4406C45.6925 13.9509 45.5534 14.518 45.5534 15.0936C45.5534 15.6692 45.6925 16.2363 45.9587 16.7466C46.2178 17.2284 46.6067 17.6281 47.0813 17.9002C47.5676 18.1758 48.1171 18.3207 48.676 18.3207C49.235 18.3207 49.7844 18.1758 50.2707 17.9002C50.7347 17.6373 51.1438 17.2877 51.4757 16.8702L52.9176 18.2023Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M63.1672 18.2023C62.687 18.8161 62.0805 19.3196 61.3888 19.6786C60.6257 20.0862 59.7718 20.2941 58.9067 20.2828C57.9847 20.2914 57.077 20.0544 56.2769 19.5962C55.4913 19.1505 54.8412 18.5004 54.3956 17.7148C53.9454 16.9115 53.709 16.006 53.709 15.0851C53.709 14.1642 53.9454 13.2586 54.3956 12.4553C54.8412 11.6697 55.4913 11.0196 56.2769 10.5739C57.0509 10.1435 57.918 9.9083 58.8034 9.88856C59.6887 9.86882 60.5656 10.0652 61.3579 10.4607C62.0272 10.7941 62.6136 11.2726 63.0745 11.8613L61.6188 13.214C61.3078 12.8234 60.9228 12.498 60.4859 12.2562C60.0002 11.9937 59.4561 11.8579 58.904 11.8615C58.3519 11.8651 57.8097 12.0079 57.3274 12.2767C56.8527 12.5487 56.4638 12.9484 56.2048 13.4303C55.9366 13.94 55.7964 14.5073 55.7964 15.0833C55.7964 15.6593 55.9366 16.2266 56.2048 16.7364C56.4618 17.2197 56.8512 17.6199 57.3274 17.8899C57.8137 18.1656 58.3632 18.3104 58.9221 18.3104C59.4811 18.3104 60.0305 18.1656 60.5168 17.8899C60.9802 17.6262 61.3891 17.2766 61.7218 16.86L63.1672 18.2023Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M69.3246 20.2829C68.4026 20.2915 67.495 20.0545 66.6949 19.5962C65.9093 19.1506 65.2592 18.5005 64.8135 17.7149C64.3633 16.9115 64.127 16.0061 64.127 15.0852C64.127 14.1643 64.3633 13.2587 64.8135 12.4553C65.2592 11.6698 65.9093 11.0196 66.6949 10.574C67.4983 10.1238 68.4037 9.88745 69.3246 9.88745C70.2455 9.88745 71.151 10.1238 71.9544 10.574C72.74 11.0196 73.3901 11.6698 73.8358 12.4553C74.2859 13.2587 74.5223 14.1643 74.5223 15.0852C74.5223 16.0061 74.2859 16.9115 73.8358 17.7149C73.3901 18.5005 72.74 19.1506 71.9544 19.5962C71.1542 20.0542 70.2466 20.2911 69.3246 20.2829ZM69.3246 18.3054C69.8823 18.3129 70.4315 18.1694 70.9142 17.89C71.3888 17.6179 71.7777 17.2182 72.0368 16.7364C72.3031 16.2261 72.4421 15.659 72.4421 15.0834C72.4421 14.5078 72.3031 13.9407 72.0368 13.4304C71.7758 12.95 71.3873 12.5508 70.9142 12.2768C70.4287 12.0043 69.8813 11.8612 69.3246 11.8612C68.7679 11.8612 68.2206 12.0043 67.7351 12.2768C67.2604 12.5488 66.8715 12.9484 66.6125 13.4304C66.3462 13.9407 66.2072 14.5078 66.2072 15.0834C66.2072 15.659 66.3462 16.2261 66.6125 16.7364C66.8695 17.2198 67.2589 17.62 67.7351 17.89C68.2167 18.173 68.7661 18.3201 69.3246 18.3157V18.3054Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M79.9646 20.2828C79.249 20.2945 78.5439 20.1105 77.9253 19.7507C77.3232 19.3889 76.8371 18.8624 76.5246 18.2333C76.1699 17.5133 75.9944 16.7183 76.0131 15.9159V10.0796H78.0935V15.9159C78.0827 16.356 78.183 16.7917 78.3854 17.1827C78.5687 17.5335 78.8503 17.8234 79.1956 18.0169C79.559 18.2133 79.967 18.3126 80.38 18.3053C80.8601 18.3145 81.334 18.196 81.7533 17.962C82.1624 17.7279 82.4969 17.3828 82.718 16.9665C82.9549 16.5185 83.073 16.0174 83.0613 15.5108V10.1071H85.1417V20.0837H83.0613V18.659H83.0407C82.7035 19.1352 82.2635 19.5294 81.7533 19.8125C81.209 20.1244 80.5919 20.2867 79.9646 20.2828Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M92.0996 11.8613C91.6197 11.8538 91.1463 11.9722 90.7264 12.2047C90.3178 12.441 89.9836 12.7872 89.7617 13.2037C89.5243 13.6515 89.4061 14.1528 89.4184 14.6594V20.0631H87.3379V10.0864H89.4184V11.4974H89.439C89.7772 11.0221 90.217 10.6281 90.7264 10.3439C91.277 10.0297 91.9017 9.86843 92.5356 9.87699C93.2496 9.86537 93.9534 10.0481 94.5715 10.4057C95.1747 10.7673 95.6619 11.2937 95.9756 11.9231C96.3292 12.6446 96.5035 13.4407 96.4837 14.2439V20.0631H94.4239V14.2439C94.4335 13.8028 94.3332 13.3663 94.132 12.9737C93.9472 12.6248 93.6659 12.3364 93.3218 12.1429C92.9465 11.9425 92.5248 11.8453 92.0996 11.8613Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M97.8516 12.0707V10.0967H98.9948C99.1254 10.1068 99.2567 10.0877 99.379 10.0408C99.5013 9.99388 99.6117 9.92034 99.702 9.82546C99.8762 9.56966 99.9574 9.26186 99.932 8.95344V6.77002H101.8V10.0967H104.086V12.0707H101.8V16.7466C101.769 17.1684 101.903 17.5856 102.174 17.9105C102.316 18.0505 102.486 18.159 102.673 18.2288C102.86 18.2986 103.06 18.3282 103.259 18.3156C103.66 18.3124 104.054 18.2048 104.402 18.0032V19.9807C103.912 20.1977 103.379 20.3044 102.843 20.293C102.42 20.3195 101.997 20.2571 101.599 20.1099C101.202 19.9627 100.84 19.7339 100.536 19.4382C99.9984 18.8729 99.7283 18.0489 99.7261 16.9664V12.081L97.8516 12.0707Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M110.079 9.8874C110.833 9.87222 111.579 10.0432 112.252 10.3852C112.859 10.697 113.367 11.1727 113.718 11.7584C114.066 12.3539 114.245 13.0328 114.236 13.7223V20.0632H112.176V18.659H112.152C111.788 19.1665 111.308 19.5789 110.751 19.8616C110.194 20.1442 109.577 20.2887 108.953 20.2829C108.357 20.2915 107.768 20.1561 107.236 19.8881C106.753 19.6432 106.344 19.2733 106.052 18.817C105.775 18.3857 105.627 17.8842 105.626 17.3716C105.606 16.6094 105.886 15.8696 106.405 15.3118C106.978 14.7314 107.729 14.3592 108.537 14.2543L112.176 13.6296V13.5883C112.178 13.2628 112.083 12.9442 111.905 12.6717C111.72 12.3916 111.466 12.1635 111.167 12.009C110.837 11.837 110.468 11.7508 110.096 11.7584C109.584 11.7576 109.082 11.894 108.64 12.1533C108.204 12.4004 107.817 12.725 107.497 13.1112L106.148 11.7584C106.596 11.2026 107.155 10.7466 107.789 10.4196C108.498 10.0592 109.284 9.87657 110.079 9.8874ZM109.351 18.5149C109.849 18.5199 110.339 18.3867 110.765 18.1303C111.195 17.8772 111.551 17.5148 111.795 17.0798C112.046 16.6285 112.175 16.1198 112.17 15.6036V15.2911L109.258 15.813C108.835 15.8749 108.436 16.0505 108.105 16.3211C107.98 16.4232 107.879 16.5515 107.809 16.6968C107.739 16.8421 107.702 17.0009 107.7 17.1622C107.694 17.4055 107.762 17.6448 107.895 17.8488C108.043 18.0539 108.244 18.2153 108.476 18.3157C108.748 18.4489 109.048 18.5171 109.351 18.5149Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M121.025 11.8613C120.545 11.8538 120.072 11.9722 119.652 12.2046C119.242 12.4408 118.907 12.7869 118.684 13.2037C118.446 13.6515 118.328 14.1527 118.34 14.6593V20.0631H116.26V10.0864H118.34V11.4974H118.361C118.7 11.022 119.141 10.6281 119.652 10.3439C120.201 10.0296 120.825 9.86833 121.458 9.87695C122.173 9.86574 122.877 10.0485 123.497 10.4057C124.098 10.7683 124.584 11.2946 124.897 11.9231C125.252 12.6443 125.428 13.4404 125.409 14.2439V20.0631H123.329V14.2439C123.339 13.8031 123.24 13.3666 123.04 12.9736C122.854 12.6243 122.572 12.3359 122.227 12.1428C121.857 11.946 121.443 11.8489 121.025 11.8613Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M126.607 12.0707V10.0967H127.751C127.881 10.1068 128.011 10.0876 128.133 10.0407C128.255 9.99378 128.365 9.92027 128.454 9.82546C128.63 9.57038 128.712 9.26201 128.684 8.95344V6.77002H130.556V10.0967H132.842V12.0707H130.556V16.7466C130.524 17.1685 130.658 17.5863 130.93 17.9105C131.072 18.0484 131.242 18.1548 131.428 18.2229C131.615 18.2909 131.813 18.3189 132.011 18.3053C132.413 18.3021 132.807 18.1945 133.154 17.9929V19.9704C132.664 20.1871 132.132 20.2937 131.596 20.2827C131.173 20.3098 130.749 20.2478 130.351 20.1005C129.954 19.9533 129.592 19.7241 129.289 19.4279C128.746 18.8626 128.475 18.0386 128.475 16.9561V12.0707H126.607Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M135.685 17.0482C136.005 17.4352 136.394 17.7598 136.831 18.0059C137.272 18.2636 137.773 18.3999 138.284 18.4008C138.744 18.4239 139.198 18.2921 139.574 18.0266C139.718 17.929 139.836 17.7988 139.919 17.6465C140.002 17.4943 140.047 17.3244 140.052 17.1511C140.053 17.0482 140.031 16.9464 139.988 16.8531C139.944 16.7598 139.881 16.6775 139.801 16.6122C139.623 16.4525 139.415 16.329 139.19 16.2482C138.946 16.159 138.596 16.0422 138.139 15.9049C137.546 15.7383 136.966 15.5295 136.402 15.2801C135.949 15.0704 135.55 14.7577 135.238 14.3669C134.896 13.9138 134.723 13.3549 134.751 12.7876C134.747 12.2697 134.899 11.7626 135.187 11.332C135.503 10.8682 135.942 10.5011 136.454 10.2712C137.062 9.99656 137.723 9.8616 138.39 9.87633C139.105 9.8643 139.816 9.9987 140.477 10.2712C141.021 10.4858 141.513 10.812 141.923 11.229L140.57 12.5782C140.294 12.3259 139.974 12.1258 139.626 11.9878C139.234 11.8249 138.814 11.7431 138.39 11.7474C137.985 11.7231 137.583 11.8329 137.247 12.0598C137.123 12.1379 137.021 12.2451 136.948 12.372C136.876 12.4989 136.836 12.6416 136.831 12.7876C136.831 12.89 136.853 12.9911 136.896 13.0842C136.939 13.1772 137.001 13.2599 137.079 13.3266C137.257 13.4875 137.466 13.6112 137.693 13.6906C137.933 13.7798 138.284 13.8966 138.744 14.0339C139.33 14.2018 139.903 14.4105 140.46 14.6586C140.914 14.8683 141.312 15.181 141.624 15.5719C141.967 16.0248 142.141 16.5835 142.115 17.1511C142.116 17.7025 141.952 18.2416 141.645 18.6994C141.313 19.197 140.849 19.5928 140.306 19.8427C139.668 20.14 138.97 20.2868 138.266 20.2718C137.468 20.2823 136.679 20.096 135.97 19.7294C135.332 19.4079 134.769 18.9551 134.318 18.4008L135.685 17.0482Z", fill: "#150A45" }));
const SvgGuidelineAdvisors = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 105, height: 28, viewBox: "0 0 105 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_20825_145836)" }, /* @__PURE__ */ React.createElement("path", { d: "M20.1698 27.9773C20.1234 27.9697 20.0817 27.9447 20.0533 27.9074C20.0248 27.87 20.0117 27.8232 20.0167 27.7765V0.212926C20.0167 0.10063 20.0847 0.012207 20.1698 0.012207C20.2161 0.0197704 20.2578 0.0447396 20.2863 0.0820764C20.3148 0.119413 20.3279 0.166231 20.3229 0.212926V27.7765C20.3279 27.8232 20.3148 27.87 20.2863 27.9074C20.2578 27.9447 20.2161 27.9697 20.1698 27.9773Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M7.5817 4.6064L7.43197 6.02539C7.12571 5.20188 6.21714 4.38175 4.54971 4.38175C3.72665 4.3655 2.9144 4.57121 2.19829 4.97726C0.758857 5.87563 0 7.51928 0 9.53381C0 11.7015 0.833721 13.277 2.19829 14.0903C2.89387 14.4802 3.67741 14.6864 4.47484 14.6892C6.0674 14.6892 6.74797 13.9406 6.97597 13.345V14.8389C6.96277 15.3544 6.75001 15.8448 6.38249 16.2066C6.01498 16.5684 5.52139 16.7735 5.00569 16.7786C3.86912 16.8535 3.032 16.4077 2.88228 15.4175L0.609134 16.5369C1.13999 18.1057 2.72915 19.0041 5.08056 19.0041C7.96283 19.0041 10.008 17.4353 10.008 14.6722V4.58937L7.5817 4.6064ZM6.37026 11.7763C6.00234 12.0649 5.54821 12.2218 5.08056 12.2218C4.61292 12.2218 4.15877 12.0649 3.79085 11.7763C3.25999 11.3271 2.95713 10.6534 2.95713 9.53381C2.95713 8.41425 3.25999 7.74045 3.79085 7.29466C4.15777 7.00372 4.61229 6.84537 5.08056 6.84537C5.54883 6.84537 6.00334 7.00372 6.37026 7.29466C6.90111 7.74045 7.20398 8.41425 7.20398 9.53381C7.20121 10.3566 6.90566 11.1515 6.37026 11.7763Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M10.008 20.0146V23.3937H0V21.4643H8.09213V20.0146H10.008Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M34.6507 4.58252H37.1246L42.8925 19.0074H40.5105L39.0677 15.2983H32.694L31.2512 19.0074H28.8691L34.6507 4.58252ZM38.2578 13.2361L35.9098 7.30485H35.8655L33.5175 13.2361H38.2578Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M47.735 8.92464C48.4333 8.91064 49.1242 9.06966 49.7461 9.38747C50.2808 9.66025 50.7463 10.0512 51.1073 10.5308H51.1277V4.58252H53.1899V19.0074H51.1277V17.6055H51.1073C50.7463 18.085 50.2808 18.476 49.7461 18.7488C49.0703 19.0852 48.3196 19.243 47.5655 19.2073C46.8115 19.1716 46.0791 18.9435 45.4381 18.5447C44.7218 18.0863 44.1358 17.4511 43.7366 16.7003C43.318 15.8836 43.0996 14.979 43.0996 14.0613C43.0996 13.1436 43.318 12.2391 43.7366 11.4224C44.1349 10.6719 44.7212 10.0375 45.4381 9.58138C46.1241 9.14486 46.9219 8.91674 47.735 8.92464ZM45.159 14.0766C45.152 14.6474 45.2902 15.2107 45.5606 15.7134C45.8138 16.1836 46.1872 16.5781 46.6427 16.8568C47.0981 17.1263 47.6176 17.2684 48.1468 17.2684C48.676 17.2684 49.1954 17.1263 49.6509 16.8568C50.1064 16.5781 50.4798 16.1836 50.733 15.7134C50.9969 15.2076 51.1347 14.6455 51.1347 14.0749C51.1347 13.5044 50.9969 12.9423 50.733 12.4365C50.4798 11.9663 50.1064 11.5717 49.6509 11.2931C49.1954 11.0236 48.676 10.8814 48.1468 10.8814C47.6176 10.8814 47.0981 11.0236 46.6427 11.2931C46.1872 11.5717 45.8138 11.9663 45.5606 12.4365C45.2898 12.9403 45.1516 13.5047 45.159 14.0766Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M54.5352 9.12891H56.8015L59.5647 16.4043H59.6055L62.3653 9.12891H64.6316L60.7183 19.0211H58.4553L54.5352 9.12891Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M65.7637 6.03891C65.7619 5.87449 65.7949 5.71154 65.8606 5.5608C65.9263 5.41005 66.0232 5.27492 66.1449 5.16434C66.256 5.05158 66.3884 4.96202 66.5345 4.9009C66.6805 4.83978 66.8373 4.80835 66.9956 4.80835C67.1539 4.80835 67.3107 4.83978 67.4567 4.9009C67.6028 4.96202 67.7352 5.05158 67.8463 5.16434C67.9665 5.27612 68.0623 5.41149 68.1279 5.56196C68.1934 5.71243 68.2272 5.87479 68.2272 6.03891C68.2272 6.20303 68.1934 6.3654 68.1279 6.51587C68.0623 6.66634 67.9665 6.8017 67.8463 6.91349C67.7352 7.02625 67.6028 7.11573 67.4567 7.17685C67.3107 7.23797 67.1539 7.26948 66.9956 7.26948C66.8373 7.26948 66.6805 7.23797 66.5345 7.17685C66.3884 7.11573 66.256 7.02625 66.1449 6.91349C66.0232 6.80291 65.9263 6.66778 65.8606 6.51703C65.7949 6.36629 65.7619 6.20334 65.7637 6.03891ZM68.0301 9.12878V19.021H65.9884V9.12878H68.0301Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M71.017 16.0332C71.3331 16.4158 71.7173 16.7366 72.1502 16.9793C72.5877 17.2358 73.0858 17.371 73.593 17.3706C74.0493 17.3957 74.5004 17.2649 74.8725 16.9997C75.0142 16.9033 75.1309 16.7748 75.2131 16.6245C75.2953 16.4742 75.3407 16.3066 75.3455 16.1353C75.3468 16.0334 75.3251 15.9325 75.2821 15.84C75.2391 15.7475 75.1759 15.6658 75.0971 15.6011C74.9213 15.4416 74.7153 15.3191 74.4914 15.2404C74.2498 15.1519 73.9027 15.0362 73.4501 14.9001C72.8621 14.735 72.2867 14.528 71.7282 14.2808C71.2785 14.073 70.8835 13.7631 70.5747 13.3756C70.2357 12.9263 70.0647 12.3725 70.0914 11.8103C70.0879 11.2969 70.2384 10.7943 70.5236 10.3674C70.8371 9.90778 71.2717 9.54382 71.7793 9.31589C72.3807 9.04418 73.0353 8.9105 73.6951 8.92459C74.4053 8.91268 75.1105 9.04581 75.7675 9.31589C76.306 9.52752 76.794 9.84981 77.2001 10.2619L75.8594 11.6026C75.5857 11.3513 75.2686 11.1518 74.9236 11.0139C74.5337 10.8549 74.1161 10.7751 73.6951 10.7792C73.2937 10.7561 72.8958 10.8649 72.562 11.0889C72.4401 11.1669 72.339 11.2732 72.2673 11.3988C72.1956 11.5245 72.1554 11.6657 72.1502 11.8103C72.1508 11.9119 72.1733 12.0122 72.2162 12.1044C72.259 12.1966 72.3213 12.2785 72.3986 12.3445C72.5761 12.5035 72.7831 12.626 73.0077 12.7053C73.2459 12.7937 73.593 12.9094 74.0456 13.0456C74.6335 13.2097 75.2089 13.4155 75.7675 13.6614C76.2167 13.8717 76.6114 14.1826 76.9211 14.5701C77.2606 15.0191 77.4316 15.5731 77.4043 16.1353C77.4063 16.6816 77.2452 17.216 76.9415 17.6701C76.6115 18.1624 76.1524 18.5545 75.6144 18.8033C74.9818 19.0967 74.2902 19.2411 73.593 19.2252C72.8018 19.2366 72.02 19.0531 71.3165 18.6909C70.6832 18.3722 70.1252 17.9221 69.6797 17.3706L71.017 16.0332Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M83.691 19.2151C82.7772 19.2234 81.8775 18.9885 81.0844 18.5345C80.3065 18.0918 79.6623 17.4476 79.2196 16.6697C78.7734 15.8734 78.5391 14.9759 78.5391 14.0631C78.5391 13.1503 78.7734 12.2527 79.2196 11.4564C79.6613 10.6778 80.3057 10.0333 81.0844 9.59163C81.8807 9.14543 82.7782 8.91113 83.691 8.91113C84.6038 8.91113 85.5013 9.14543 86.2977 9.59163C87.0763 10.0333 87.7207 10.6778 88.1624 11.4564C88.6086 12.2527 88.843 13.1503 88.843 14.0631C88.843 14.9759 88.6086 15.8734 88.1624 16.6697C87.7198 17.4476 87.0756 18.0918 86.2977 18.5345C85.5046 18.9888 84.6049 19.2237 83.691 19.2151ZM83.691 17.2584C84.2437 17.2658 84.7882 17.1236 85.2666 16.8467C85.7371 16.5771 86.1226 16.1809 86.3793 15.7032C86.6432 15.1974 86.781 14.6353 86.781 14.0648C86.781 13.4942 86.6432 12.9321 86.3793 12.4263C86.1226 11.9486 85.7371 11.5524 85.2666 11.2829C84.7854 11.0128 84.2428 10.871 83.691 10.871C83.1392 10.871 82.5967 11.0128 82.1155 11.2829C81.6465 11.5544 81.2615 11.9501 81.0027 12.4263C80.7388 12.9321 80.601 13.4942 80.601 14.0648C80.601 14.6353 80.7388 15.1974 81.0027 15.7032C81.2615 16.1794 81.6465 16.5751 82.1155 16.8467C82.5929 17.1272 83.1373 17.273 83.691 17.2686V17.2584Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M95.022 10.9832C94.5493 10.9824 94.0859 11.1145 93.6847 11.3643C93.267 11.6263 92.9282 11.9968 92.7046 12.4363C92.4603 12.9105 92.3364 13.4376 92.3439 13.971V19.0209H90.2852V9.12868H92.3439V10.4285H92.3848C92.709 9.98392 93.1288 9.61767 93.6132 9.35665C94.1334 9.06774 94.7197 8.91882 95.3147 8.92447H95.8285V11.0888C95.706 11.0615 95.5767 11.0342 95.4372 11.0138C95.2997 10.9937 95.161 10.9835 95.022 10.9832Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M97.827 16.0333C98.1436 16.4167 98.5291 16.7376 98.9636 16.9793C99.3997 17.2363 99.8968 17.3715 100.403 17.3707C100.859 17.3958 101.31 17.2649 101.683 16.9998C101.825 16.904 101.942 16.7756 102.024 16.6252C102.107 16.4748 102.152 16.3068 102.156 16.1354C102.157 16.0334 102.135 15.9325 102.092 15.8401C102.049 15.7476 101.986 15.6659 101.907 15.6011C101.731 15.4417 101.525 15.3191 101.301 15.2405C101.06 15.152 100.713 15.0363 100.26 14.9002C99.6723 14.7345 99.0969 14.5275 98.5382 14.2808C98.0885 14.073 97.6934 13.7631 97.3846 13.3757C97.0457 12.9264 96.8747 12.3725 96.9014 11.8103C96.8979 11.297 97.0484 10.7944 97.3336 10.3675C97.6471 9.90785 98.0817 9.54389 98.5893 9.31597C99.1917 9.04375 99.8476 8.91006 100.509 8.92466C101.218 8.91274 101.922 9.04587 102.577 9.31597C103.116 9.52759 103.604 9.84988 104.01 10.262L102.669 11.6027C102.396 11.3513 102.079 11.1519 101.734 11.014C101.345 10.8553 100.928 10.7755 100.509 10.7792C100.107 10.7552 99.7088 10.8641 99.3753 11.089C99.2529 11.1663 99.1513 11.2725 99.0795 11.3983C99.0078 11.524 98.9679 11.6656 98.9636 11.8103C98.9636 11.9118 98.9854 12.0121 99.0277 12.1043C99.07 12.1965 99.1317 12.2784 99.2086 12.3446C99.3866 12.5028 99.5934 12.6253 99.8177 12.7053C100.056 12.7938 100.403 12.9095 100.859 13.0456C101.44 13.2111 102.008 13.4168 102.56 13.6615C103.01 13.8717 103.404 14.1827 103.714 14.5701C104.055 15.0189 104.227 15.5728 104.201 16.1354C104.201 16.682 104.039 17.2164 103.734 17.6701C103.404 18.1625 102.945 18.5546 102.407 18.8033C101.775 19.0968 101.083 19.2412 100.386 19.2253C99.5948 19.2367 98.813 19.0532 98.1095 18.691C97.4762 18.3723 96.9182 17.9222 96.4727 17.3707L97.827 16.0333Z", fill: "#150A45" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_20825_145836" }, /* @__PURE__ */ React.createElement("rect", { width: 104.5, height: 27.9549, fill: "white", transform: "translate(0 0.0224609)" }))));
const SvgGuidelineBlack = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 104, height: 33, viewBox: "0 0 104 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10.1523 8.73477C9.31155 7.33721 7.95028 6.53943 5.95413 6.53943C2.2135 6.56272 0 9.53837 0 13.6612C0 17.784 2.2135 20.7597 5.95413 20.7597C6.64128 20.797 7.32796 20.6779 7.96418 20.411C8.60039 20.144 9.17011 19.736 9.63185 19.2165V21.2022C9.63185 22.5532 8.9169 24.1546 6.65193 24.1546C4.93604 24.1546 4.08953 23.1937 3.79211 22.163L0.754991 23.6305C1.5157 25.5812 3.33454 27.2176 6.86355 27.2176C12.097 27.2176 13.4411 23.6887 13.4411 20.5966V6.73742H10.2381L10.1523 8.73477ZM6.77204 17.522C4.90172 17.522 3.79783 16.0021 3.79783 13.6321C3.79783 11.262 4.90172 9.74218 6.77204 9.74218C8.64236 9.74218 9.72337 11.262 9.72337 13.6321C9.72337 16.0021 8.64236 17.522 6.77204 17.522Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M84.742 6.51614C84.0107 6.51373 83.2882 6.67954 82.6286 7.0012C81.969 7.32285 81.3893 7.79204 80.9328 8.37374L80.6868 6.73742H77.3065V20.5384H81.2531V12.7469C81.2531 10.5924 82.0538 9.74801 83.6381 9.74801C84.742 9.74801 85.6572 10.2372 85.6572 12.3393V20.5384H89.6037V11.5357C89.6037 8.61831 87.7963 6.51614 84.742 6.51614Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M23.5992 14.523C23.5992 16.4156 22.7984 17.522 21.2198 17.522C20.1159 17.522 19.1951 17.0328 19.1951 14.9306V6.73743H15.2485V15.7226C15.2485 18.6342 17.0559 20.748 20.1102 20.748C20.8429 20.7498 21.5664 20.5831 22.227 20.2604C22.8876 19.9378 23.4681 19.4675 23.9252 18.8846L24.1712 20.5267H27.5457V6.73743H23.5992V14.523Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M33.5685 6.73743H29.6219V20.5384H33.5685V6.73743Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M44.5216 7.75065C43.5668 6.92854 42.3381 6.51157 41.0898 6.58601C37.332 6.58601 35.1128 9.56166 35.1128 13.6845C35.1128 17.8073 37.332 20.7829 41.0898 20.7829C41.89 20.8348 42.6895 20.6716 43.4082 20.3098C44.1269 19.948 44.7397 19.4003 45.1851 18.7215L45.2823 20.5384H48.4853V0.331909H44.5387L44.5216 7.75065ZM41.9535 17.522C40.0831 17.522 38.9793 16.0021 38.9793 13.6321C38.9793 11.262 40.0831 9.74218 41.9535 9.74218C43.8238 9.74218 44.9277 11.262 44.9277 13.6321C44.9277 16.0021 43.8238 17.522 41.9535 17.522Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M31.5952 0C31.1597 0 30.7339 0.131487 30.3718 0.377833C30.0097 0.624179 29.7274 0.97432 29.5607 1.38398C29.3941 1.79364 29.3505 2.24441 29.4354 2.67931C29.5204 3.1142 29.7301 3.51367 30.0381 3.82721C30.3461 4.14075 30.7384 4.35427 31.1656 4.44078C31.5927 4.52728 32.0355 4.48288 32.4379 4.3132C32.8402 4.14351 33.1842 3.85616 33.4261 3.48747C33.6681 3.11879 33.7972 2.68534 33.7972 2.24193C33.7972 1.64733 33.5652 1.07709 33.1523 0.656645C32.7393 0.236202 32.1792 0 31.5952 0Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M75.2188 6.73743H71.2723V20.5384H75.2188V6.73743Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M73.2455 0C72.81 0 72.3842 0.131487 72.0221 0.377833C71.66 0.624179 71.3778 0.97432 71.2111 1.38398C71.0444 1.79364 71.0008 2.24441 71.0858 2.67931C71.1707 3.1142 71.3805 3.51367 71.6884 3.82721C71.9964 4.14075 72.3888 4.35427 72.8159 4.44078C73.2431 4.52728 73.6858 4.48288 74.0882 4.3132C74.4906 4.14351 74.8345 3.85616 75.0765 3.48747C75.3184 3.11879 75.4476 2.68534 75.4476 2.24193C75.4476 1.64733 75.2156 1.07709 74.8026 0.656645C74.3896 0.236202 73.8295 0 73.2455 0Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M103.989 14.0805C103.989 13.9407 103.989 13.801 103.989 13.6612C103.989 9.39864 101.586 6.56274 97.6226 6.56274C93.6589 6.56274 90.9935 9.39864 90.9935 13.6612C90.9935 17.9238 93.6646 20.7597 97.6226 20.7597C100.362 20.7597 102.404 19.432 103.371 17.1901L100.511 15.81C100.324 16.4071 99.9494 16.9252 99.4452 17.2849C98.9411 17.6446 98.335 17.8261 97.7198 17.8015C96.9903 17.8221 96.2808 17.5579 95.7363 17.0632C95.1919 16.5685 94.8538 15.8805 94.7914 15.1403H94.82L103.989 14.0805ZM94.6941 12.6887C94.6941 10.6856 95.8667 9.37534 97.6111 9.37534C98.3297 9.36279 99.0258 9.63003 99.5574 10.1225C100.089 10.6149 100.416 11.2954 100.471 12.0249L94.6941 12.6887Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M56.5042 6.56274C52.5405 6.56274 49.8694 9.39864 49.8694 13.6612C49.8694 17.9238 52.5405 20.7597 56.5042 20.7597C59.2381 20.7597 61.28 19.432 62.2238 17.1901L59.364 15.81C59.18 16.3987 58.8136 16.911 58.3197 17.27C57.8258 17.629 57.231 17.8155 56.6243 17.8015C55.888 17.8327 55.1683 17.5734 54.6153 17.0776C54.0622 16.5818 53.7185 15.8878 53.6558 15.1403L62.8072 14.0688C62.8072 13.9291 62.8072 13.7893 62.8072 13.6496C62.8644 9.39864 60.4621 6.56274 56.5042 6.56274ZM53.5585 12.6887C53.5585 10.6856 54.7025 9.37534 56.4813 9.37534C57.1998 9.36279 57.896 9.63003 58.4275 10.1225C58.959 10.6149 59.2858 11.2954 59.3411 12.0249L53.5585 12.6887Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M68.1551 16.3806V0.331909H64.2086V16.7882C64.2086 18.6982 64.5861 20.6956 67.9263 20.6956C68.5591 20.7294 69.1916 20.6221 69.7795 20.3811V17.3007C69.7795 17.3007 68.1551 17.7199 68.1551 16.3806Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M104 24.1663H15.729H15.7119V30.2224H0.114441V33H18.4344V26.9381H104V24.1663Z", fill: "#282828" }));
const SvgGuidelineDefault = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 104, height: 33, viewBox: "0 0 104 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10.1523 8.73477C9.31155 7.33721 7.95028 6.53943 5.95413 6.53943C2.2135 6.56272 0 9.53837 0 13.6612C0 17.784 2.2135 20.7597 5.95413 20.7597C6.64128 20.797 7.32796 20.6779 7.96418 20.411C8.60039 20.144 9.17011 19.736 9.63185 19.2165V21.2022C9.63185 22.5532 8.9169 24.1546 6.65193 24.1546C4.93604 24.1546 4.08953 23.1937 3.79211 22.163L0.754991 23.6305C1.5157 25.5812 3.33454 27.2176 6.86355 27.2176C12.097 27.2176 13.4411 23.6887 13.4411 20.5966V6.73742H10.2381L10.1523 8.73477ZM6.77204 17.522C4.90172 17.522 3.79783 16.0021 3.79783 13.6321C3.79783 11.262 4.90172 9.74218 6.77204 9.74218C8.64236 9.74218 9.72337 11.262 9.72337 13.6321C9.72337 16.0021 8.64236 17.522 6.77204 17.522Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M84.742 6.51614C84.0107 6.51373 83.2882 6.67954 82.6286 7.0012C81.969 7.32285 81.3893 7.79204 80.9328 8.37374L80.6868 6.73742H77.3065V20.5384H81.2531V12.7469C81.2531 10.5924 82.0538 9.74801 83.6381 9.74801C84.742 9.74801 85.6572 10.2372 85.6572 12.3393V20.5384H89.6037V11.5357C89.6037 8.61831 87.7963 6.51614 84.742 6.51614Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M23.5992 14.523C23.5992 16.4156 22.7984 17.522 21.2198 17.522C20.1159 17.522 19.1951 17.0328 19.1951 14.9306V6.73743H15.2485V15.7226C15.2485 18.6342 17.0559 20.748 20.1102 20.748C20.8429 20.7498 21.5664 20.5831 22.227 20.2604C22.8876 19.9378 23.4681 19.4675 23.9252 18.8846L24.1712 20.5267H27.5457V6.73743H23.5992V14.523Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M33.5685 6.73743H29.6219V20.5384H33.5685V6.73743Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M44.5216 7.75065C43.5668 6.92854 42.3381 6.51157 41.0898 6.58601C37.332 6.58601 35.1128 9.56166 35.1128 13.6845C35.1128 17.8073 37.332 20.7829 41.0898 20.7829C41.89 20.8348 42.6895 20.6716 43.4082 20.3098C44.1269 19.948 44.7397 19.4003 45.1851 18.7215L45.2823 20.5384H48.4853V0.331909H44.5387L44.5216 7.75065ZM41.9535 17.522C40.0831 17.522 38.9793 16.0021 38.9793 13.6321C38.9793 11.262 40.0831 9.74218 41.9535 9.74218C43.8238 9.74218 44.9277 11.262 44.9277 13.6321C44.9277 16.0021 43.8238 17.522 41.9535 17.522Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M31.5952 0C31.1597 0 30.7339 0.131487 30.3718 0.377833C30.0097 0.624179 29.7274 0.97432 29.5607 1.38398C29.3941 1.79364 29.3505 2.24441 29.4354 2.67931C29.5204 3.1142 29.7301 3.51367 30.0381 3.82721C30.3461 4.14075 30.7384 4.35427 31.1656 4.44078C31.5927 4.52728 32.0355 4.48288 32.4379 4.3132C32.8402 4.14351 33.1842 3.85616 33.4261 3.48747C33.6681 3.11879 33.7972 2.68534 33.7972 2.24193C33.7972 1.64733 33.5652 1.07709 33.1523 0.656645C32.7393 0.236202 32.1792 0 31.5952 0Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M75.2188 6.73743H71.2723V20.5384H75.2188V6.73743Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M73.2455 0C72.81 0 72.3842 0.131487 72.0221 0.377833C71.66 0.624179 71.3778 0.97432 71.2111 1.38398C71.0444 1.79364 71.0008 2.24441 71.0858 2.67931C71.1707 3.1142 71.3805 3.51367 71.6884 3.82721C71.9964 4.14075 72.3888 4.35427 72.8159 4.44078C73.2431 4.52728 73.6858 4.48288 74.0882 4.3132C74.4906 4.14351 74.8345 3.85616 75.0765 3.48747C75.3184 3.11879 75.4476 2.68534 75.4476 2.24193C75.4476 1.64733 75.2156 1.07709 74.8026 0.656645C74.3896 0.236202 73.8295 0 73.2455 0Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M103.989 14.0805C103.989 13.9407 103.989 13.801 103.989 13.6612C103.989 9.39864 101.586 6.56274 97.6226 6.56274C93.6589 6.56274 90.9935 9.39864 90.9935 13.6612C90.9935 17.9238 93.6646 20.7597 97.6226 20.7597C100.362 20.7597 102.404 19.432 103.371 17.1901L100.511 15.81C100.324 16.4071 99.9494 16.9252 99.4452 17.2849C98.9411 17.6446 98.335 17.8261 97.7198 17.8015C96.9903 17.8221 96.2808 17.5579 95.7363 17.0632C95.1919 16.5685 94.8538 15.8805 94.7914 15.1403H94.82L103.989 14.0805ZM94.6941 12.6887C94.6941 10.6856 95.8667 9.37534 97.6111 9.37534C98.3297 9.36279 99.0258 9.63003 99.5574 10.1225C100.089 10.6149 100.416 11.2954 100.471 12.0249L94.6941 12.6887Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M56.5042 6.56274C52.5405 6.56274 49.8694 9.39864 49.8694 13.6612C49.8694 17.9238 52.5405 20.7597 56.5042 20.7597C59.2381 20.7597 61.28 19.432 62.2238 17.1901L59.364 15.81C59.18 16.3987 58.8136 16.911 58.3197 17.27C57.8258 17.629 57.231 17.8155 56.6243 17.8015C55.888 17.8327 55.1683 17.5734 54.6153 17.0776C54.0622 16.5818 53.7185 15.8878 53.6558 15.1403L62.8072 14.0688C62.8072 13.9291 62.8072 13.7893 62.8072 13.6496C62.8644 9.39864 60.4621 6.56274 56.5042 6.56274ZM53.5585 12.6887C53.5585 10.6856 54.7025 9.37534 56.4813 9.37534C57.1998 9.36279 57.896 9.63003 58.4275 10.1225C58.959 10.6149 59.2858 11.2954 59.3411 12.0249L53.5585 12.6887Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M68.1551 16.3806V0.331909H64.2086V16.7882C64.2086 18.6982 64.5861 20.6956 67.9263 20.6956C68.5591 20.7294 69.1916 20.6221 69.7795 20.3811V17.3007C69.7795 17.3007 68.1551 17.7199 68.1551 16.3806Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M104 24.1663H15.729H15.7119V30.2224H0.114441V33H18.4344V26.9381H104V24.1663Z", fill: "#5532FA" }));
const SvgGuidelineIra = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 62, height: 28, viewBox: "0 0 62 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M19.9553 27.8351C19.8711 27.8351 19.8038 27.7476 19.8038 27.6365V0.363722C19.7988 0.31752 19.8118 0.271196 19.84 0.234253C19.8682 0.197311 19.9094 0.172523 19.9553 0.165039C20.0011 0.172523 20.0424 0.197311 20.0706 0.234253C20.0987 0.271196 20.1117 0.31752 20.1068 0.363722V27.6365C20.1117 27.6827 20.0987 27.729 20.0706 27.766C20.0424 27.8029 20.0011 27.8277 19.9553 27.8351Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M7.50171 4.69706L7.35356 6.10108C7.05053 5.28963 6.15152 4.47483 4.50169 4.47483C3.68681 4.45809 2.88268 4.66291 2.1751 5.06742C0.75085 5.95295 0 7.57922 0 9.57585C0 11.7173 0.824925 13.2796 2.1751 14.0843C2.86426 14.4674 3.63912 14.6701 4.42763 14.6735C6.00339 14.6735 6.67678 13.9361 6.90237 13.3267V14.8048C6.89017 15.3155 6.68004 15.8015 6.31631 16.1602C5.95258 16.5189 5.46371 16.7223 4.95288 16.7274C3.82493 16.8015 3.00002 16.357 2.85187 15.3806L0.602708 16.4883C1.12459 18.0405 2.70034 18.926 5.02694 18.926C7.87543 18.926 9.90239 17.3739 9.90239 14.6398V4.6634L7.50171 4.69706ZM6.30305 11.7913C5.94 12.0792 5.49027 12.2359 5.02694 12.2359C4.56361 12.2359 4.1139 12.0792 3.75085 11.7913C3.2256 11.3469 2.92593 10.6836 2.92593 9.57585C2.92593 8.46811 3.2256 7.80145 3.75085 7.35701C4.1149 7.07139 4.56423 6.91615 5.02694 6.91615C5.48966 6.91615 5.93901 7.07139 6.30305 7.35701C6.82831 7.80145 7.12797 8.46474 7.12797 9.57585C7.12591 10.3891 6.83335 11.1748 6.30305 11.7913Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M9.90239 19.9429V23.2863H0V21.3772H7.99328V19.9429H9.90239Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M32.6565 4.69043V18.9598H30.4141V4.69043H32.6565Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M41.42 4.69064C42.263 4.67647 43.0955 4.87938 43.8375 5.27986C44.5348 5.65441 45.1169 6.21202 45.521 6.89267C45.9244 7.58505 46.1316 8.37422 46.1203 9.17547C46.1529 10.1032 45.873 11.015 45.3257 11.7647C44.8313 12.4312 44.1608 12.9466 43.3896 13.2529L46.6321 18.9768H44.0833L41.127 13.6772H37.76V18.9768H35.5176V4.70749L41.42 4.69064ZM41.42 11.6199C41.8622 11.6288 42.2989 11.5208 42.686 11.3068C43.0475 11.1006 43.3465 10.8004 43.5513 10.4381C43.7582 10.0488 43.8664 9.61467 43.8664 9.17379C43.8664 8.73291 43.7582 8.29877 43.5513 7.90948C43.3464 7.54807 43.0474 7.24903 42.686 7.04417C42.2992 6.82913 41.8625 6.71997 41.42 6.72769H37.7533V11.6199H41.42Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M53.0448 4.69043H55.4892L61.2131 18.9598H58.8562L57.432 15.2898H51.1088L49.6811 18.9598H47.3242L53.0448 4.69043ZM56.6104 13.2527L54.2872 7.38067H54.2468L51.9236 13.2527H56.6104Z", fill: "#150A45" }));
const SvgGuidelineMarkBlack = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 32, viewBox: "0 0 17 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12.8788 0.377134L12.6212 2.76565C12.1061 1.38283 10.5606 0 7.72727 0C6.05303 0 4.89394 0.377134 3.73485 1.00569C1.28788 2.51423 0 5.27988 0 8.67409C0 12.3197 1.41667 14.9597 3.73485 16.3425C4.89394 16.971 6.18182 17.3482 7.59848 17.3482C10.303 17.3482 11.4621 16.0911 11.8485 15.0854V15.5882V17.5996C11.8485 19.3596 10.4318 20.7424 8.5 20.8681C6.56818 20.9938 5.15151 20.2395 4.89394 18.6053L1.0303 20.491C1.93182 23.1309 4.63636 24.6394 8.62879 24.6394C13.5227 24.6394 17 21.9995 17 17.3482V15.0854V13.3254V0.377134H12.8788ZM10.8182 12.4454C10.1742 12.9483 9.40151 13.1997 8.62879 13.1997C7.85606 13.1997 7.08333 12.9483 6.43939 12.4454C5.53788 11.6912 5.02273 10.5598 5.02273 8.67409C5.02273 6.78842 5.53788 5.65702 6.43939 4.90275C7.08333 4.3999 7.85606 4.14848 8.62879 4.14848C9.40151 4.14848 10.1742 4.3999 10.8182 4.90275C11.7197 5.65702 12.2348 6.78842 12.2348 8.67409C12.1061 10.5598 11.5909 11.5655 10.8182 12.4454Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M17 26.3127V32L0 32V28.7501H13.7229V26.3127H17Z", fill: "#282828" }));
const SvgGuidelineMarkWhite = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 32, viewBox: "0 0 17 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M12.8788 0.377134L12.6212 2.76565C12.1061 1.38283 10.5606 0 7.72727 0C6.05303 0 4.89394 0.377134 3.73485 1.00569C1.28788 2.51423 0 5.27988 0 8.67409C0 12.3197 1.41667 14.9597 3.73485 16.3425C4.89394 16.971 6.18182 17.3482 7.59848 17.3482C10.303 17.3482 11.4621 16.0911 11.8485 15.0854V15.5882V17.5996C11.8485 19.3596 10.4318 20.7424 8.5 20.8681C6.56818 20.9938 5.15151 20.2395 4.89394 18.6053L1.0303 20.491C1.93182 23.1309 4.63636 24.6394 8.62879 24.6394C13.5227 24.6394 17 21.9995 17 17.3482V15.0854V13.3254V0.377134H12.8788ZM10.8182 12.4454C10.1742 12.9483 9.40151 13.1997 8.62879 13.1997C7.85606 13.1997 7.08333 12.9483 6.43939 12.4454C5.53788 11.6912 5.02273 10.5598 5.02273 8.67409C5.02273 6.78842 5.53788 5.65702 6.43939 4.90275C7.08333 4.3999 7.85606 4.14848 8.62879 4.14848C9.40151 4.14848 10.1742 4.3999 10.8182 4.90275C11.7197 5.65702 12.2348 6.78842 12.2348 8.67409C12.1061 10.5598 11.5909 11.5655 10.8182 12.4454Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M17 26.3127V32L0 32V28.7501H13.7229V26.3127H17Z", fill: "white" }));
const SvgGuidelineMark = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 32, viewBox: "0 0 18 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M13.1496 2.7C12.1496 1 10.4496 0 8.04961 0C3.54961 0 0.849609 3.6 0.849609 8.6C0.849609 13.6 3.54961 17.2 8.04961 17.2C8.84961 17.2 9.74961 17.1 10.4496 16.8C11.2496 16.5 11.9496 16 12.4496 15.4V17.8C12.4496 19.4 11.5496 21.4 8.84961 21.4C6.74961 21.4 5.74961 20.2 5.34961 19L1.64961 20.8C2.64961 23 4.84961 25 9.14961 25C15.4496 25 17.1496 20.7 17.1496 17V0.2H13.2496L13.1496 2.7ZM9.04961 13.3C6.74961 13.3 5.44961 11.5 5.44961 8.6C5.44961 5.7 6.74961 3.9 9.04961 3.9C11.3496 3.9 12.6496 5.7 12.6496 8.6C12.6496 11.4 11.3496 13.3 9.04961 13.3Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M17.1492 26.3V32H0.949219V28.6H13.8492V26.3H17.1492Z", fill: "#5532FA" }));
const SvgGuidelineSepIra = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 99, height: 28, viewBox: "0 0 99 28", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M19.7732 27.7081C19.6898 27.7081 19.623 27.6214 19.623 27.5113V0.489094C19.623 0.379004 19.6898 0.292236 19.7732 0.292236C19.8186 0.299651 19.8595 0.324171 19.8874 0.360774C19.9153 0.397377 19.9282 0.443317 19.9233 0.489094V27.5113C19.9282 27.557 19.9153 27.6029 19.8874 27.6396C19.8595 27.6762 19.8186 27.7007 19.7732 27.7081Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M7.43278 4.80585L7.28599 6.19701C6.98574 5.39301 6.095 4.58566 4.46033 4.58566C3.65293 4.56908 2.8562 4.77202 2.15511 5.17281C0.743951 6.0502 0 7.66152 0 9.63981C0 11.7616 0.817345 13.3095 2.15511 14.1068C2.83734 14.488 3.60547 14.6889 4.38694 14.6906C5.94822 14.6906 6.61543 13.96 6.83895 13.3729V14.8141C6.82686 15.3201 6.61866 15.8016 6.25827 16.157C5.89788 16.5124 5.4135 16.7139 4.90737 16.7189C3.78978 16.7923 2.97245 16.352 2.82566 15.3845L0.59717 16.4821C1.11426 18.02 2.67553 18.8974 4.98075 18.8974C7.80307 18.8974 9.8114 17.3628 9.8114 14.6506V4.80585H7.43278ZM6.24514 11.8116C5.88542 12.0968 5.43982 12.2521 4.98075 12.2521C4.52168 12.2521 4.0761 12.0968 3.71639 11.8116C3.19596 11.3746 2.89905 10.714 2.89905 9.61648C2.89905 8.51891 3.19596 7.85834 3.71639 7.41798C4.07709 7.13499 4.52229 6.98118 4.98075 6.98118C5.43922 6.98118 5.88444 7.13499 6.24514 7.41798C6.76556 7.85834 7.06248 8.51891 7.06248 9.61648C7.06044 10.4222 6.77056 11.2007 6.24514 11.8116Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M9.8114 19.9048V23.2175H0V21.3226H7.91983V19.9048H9.8114Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M30.2403 15.4812C30.6322 15.9588 31.1211 16.3478 31.6748 16.6221C32.3262 16.9492 33.0477 17.1118 33.7765 17.0958C34.2962 17.1075 34.8125 17.0085 35.2911 16.8056C35.6814 16.64 36.0193 16.3713 36.2685 16.0283C36.4862 15.7212 36.6028 15.3539 36.6021 14.9774C36.6101 14.7849 36.5794 14.5926 36.5118 14.4121C36.4442 14.2316 36.341 14.0665 36.2085 13.9266C35.9241 13.6428 35.5831 13.4223 35.2077 13.2794C34.669 13.0727 34.1188 12.8978 33.5596 12.7556C32.7747 12.5343 32.0057 12.2601 31.2577 11.9349C30.6613 11.6614 30.1437 11.2413 29.7532 10.7139C29.3456 10.0969 29.1241 9.37569 29.1152 8.63626C29.1064 7.89683 29.3105 7.17044 29.7031 6.54384C30.1215 5.91926 30.7046 5.42277 31.3879 5.10935C32.1941 4.73614 33.0751 4.55242 33.9633 4.57225C34.8563 4.55965 35.7415 4.7394 36.5588 5.09934C37.258 5.39637 37.8875 5.83611 38.4069 6.39039L36.8924 7.90498C36.5506 7.51829 36.1356 7.20307 35.6714 6.97755C35.1407 6.7156 34.5551 6.58406 33.9633 6.59389C33.4753 6.58122 32.99 6.67102 32.5388 6.85745C32.181 7.00091 31.8703 7.24118 31.6414 7.55134C31.4416 7.83165 31.3353 8.16789 31.3378 8.51213C31.3298 8.70472 31.3605 8.89695 31.4282 9.07746C31.4958 9.25796 31.5989 9.42307 31.7315 9.563C32.0167 9.84565 32.3575 10.066 32.7323 10.2102C33.2697 10.4169 33.8189 10.5918 34.377 10.734C35.1622 10.9565 35.9322 11.2295 36.6822 11.5513C37.2776 11.8281 37.7947 12.2489 38.1868 12.7756C38.638 13.4182 38.8611 14.1933 38.8206 14.9774C38.8241 15.7092 38.6105 16.4255 38.2068 17.0358C37.7678 17.6935 37.156 18.2175 36.4387 18.5504C35.6046 18.9425 34.6913 19.1366 33.7698 19.1175C32.7355 19.1383 31.7096 18.9274 30.7674 18.5003C29.9797 18.1549 29.2772 17.6414 28.709 16.9958L30.2403 15.4812Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M50.5119 4.80591V6.92764H42.7355V10.564H48.8972V12.6824H42.7355V16.8158H50.7154V18.9342H40.5137V4.80591H50.5119Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M58.4939 4.80611C59.3403 4.79461 60.175 5.00386 60.9159 5.41326C61.624 5.79865 62.2152 6.36787 62.627 7.06094C63.0389 7.754 63.2563 8.5453 63.2563 9.35151C63.2563 10.1577 63.0389 10.949 62.627 11.6421C62.2152 12.3352 61.624 12.9044 60.9159 13.2898C60.1744 13.6976 59.3401 13.9067 58.4939 13.8969H55.0578V18.9444H52.8359V4.80611H58.4939ZM58.4939 11.8752C58.9397 11.8788 59.3784 11.7636 59.7649 11.5416C60.1501 11.326 60.4687 11.0086 60.6857 10.6242C60.9043 10.2356 61.0192 9.79735 61.0192 9.35151C61.0192 8.90568 60.9043 8.46738 60.6857 8.07882C60.4679 7.69412 60.1496 7.37585 59.7649 7.15806C59.3778 6.93753 58.9395 6.82249 58.4939 6.82445H55.0578V11.8752H58.4939Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.505 4.80591V18.9442H68.2832V4.80591H70.505Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M79.246 4.80558C80.0802 4.79197 80.9039 4.99301 81.638 5.38939C82.3288 5.76064 82.9055 6.31309 83.306 6.98738C83.7057 7.6734 83.911 8.45531 83.8998 9.24921C83.9336 10.1686 83.6562 11.0725 83.1125 11.8147C82.6227 12.475 81.9584 12.9857 81.1943 13.2892L84.4069 18.9439H81.8815L78.9524 13.6929H75.6164V18.9439H73.3945V4.80558H79.246ZM79.246 11.6745C79.6833 11.6818 80.1148 11.5736 80.497 11.361C80.8552 11.1567 81.1515 10.8592 81.3544 10.5002C81.5589 10.1149 81.6658 9.6854 81.6658 9.24921C81.6658 8.81302 81.5589 8.38348 81.3544 7.99818C81.1515 7.63918 80.8552 7.34178 80.497 7.13749C80.1148 6.92484 79.6833 6.8167 79.246 6.82392H75.6097V11.6745H79.246Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M90.759 4.80591H93.1843L98.8556 18.9442H96.5204L95.1059 15.3112H88.8474L87.4329 18.9442H85.0977L90.759 4.80591ZM94.2952 13.2896L91.99 7.47143H91.9499L89.6481 13.2896H94.2952Z", fill: "#150A45" }));
const SvgGuidelineWhite = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 104, height: 33, viewBox: "0 0 104 33", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M10.1523 8.73477C9.31155 7.33721 7.95028 6.53943 5.95413 6.53943C2.2135 6.56272 0 9.53837 0 13.6612C0 17.784 2.2135 20.7597 5.95413 20.7597C6.64128 20.797 7.32796 20.6779 7.96418 20.411C8.60039 20.144 9.17011 19.736 9.63185 19.2165V21.2022C9.63185 22.5532 8.9169 24.1546 6.65193 24.1546C4.93604 24.1546 4.08953 23.1937 3.79211 22.163L0.754991 23.6305C1.5157 25.5812 3.33454 27.2176 6.86355 27.2176C12.097 27.2176 13.4411 23.6887 13.4411 20.5966V6.73742H10.2381L10.1523 8.73477ZM6.77204 17.522C4.90172 17.522 3.79783 16.0021 3.79783 13.6321C3.79783 11.262 4.90172 9.74218 6.77204 9.74218C8.64236 9.74218 9.72337 11.262 9.72337 13.6321C9.72337 16.0021 8.64236 17.522 6.77204 17.522Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M84.742 6.51614C84.0107 6.51373 83.2882 6.67954 82.6286 7.0012C81.969 7.32285 81.3893 7.79204 80.9328 8.37374L80.6868 6.73742H77.3065V20.5384H81.2531V12.7469C81.2531 10.5924 82.0538 9.74801 83.6381 9.74801C84.742 9.74801 85.6572 10.2372 85.6572 12.3393V20.5384H89.6037V11.5357C89.6037 8.61831 87.7963 6.51614 84.742 6.51614Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M23.5992 14.523C23.5992 16.4156 22.7984 17.522 21.2198 17.522C20.1159 17.522 19.1951 17.0328 19.1951 14.9306V6.73743H15.2485V15.7226C15.2485 18.6342 17.0559 20.748 20.1102 20.748C20.8429 20.7498 21.5664 20.5831 22.227 20.2604C22.8876 19.9378 23.4681 19.4675 23.9252 18.8846L24.1712 20.5267H27.5457V6.73743H23.5992V14.523Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M33.5685 6.73743H29.6219V20.5384H33.5685V6.73743Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M44.5216 7.75065C43.5668 6.92854 42.3381 6.51157 41.0898 6.58601C37.332 6.58601 35.1128 9.56166 35.1128 13.6845C35.1128 17.8073 37.332 20.7829 41.0898 20.7829C41.89 20.8348 42.6895 20.6716 43.4082 20.3098C44.1269 19.948 44.7397 19.4003 45.1851 18.7215L45.2823 20.5384H48.4853V0.331909H44.5387L44.5216 7.75065ZM41.9535 17.522C40.0831 17.522 38.9793 16.0021 38.9793 13.6321C38.9793 11.262 40.0831 9.74218 41.9535 9.74218C43.8238 9.74218 44.9277 11.262 44.9277 13.6321C44.9277 16.0021 43.8238 17.522 41.9535 17.522Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M31.5951 0C31.1596 0 30.7339 0.131487 30.3717 0.377833C30.0096 0.624179 29.7274 0.97432 29.5607 1.38398C29.394 1.79364 29.3504 2.24441 29.4354 2.67931C29.5203 3.1142 29.7301 3.51367 30.038 3.82721C30.346 4.14075 30.7384 4.35427 31.1655 4.44078C31.5927 4.52728 32.0354 4.48288 32.4378 4.3132C32.8402 4.14351 33.1841 3.85616 33.4261 3.48747C33.668 3.11879 33.7972 2.68534 33.7972 2.24193C33.7972 1.64733 33.5652 1.07709 33.1522 0.656645C32.7392 0.236202 32.1791 0 31.5951 0Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M75.2188 6.73743H71.2722V20.5384H75.2188V6.73743Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M73.2455 0C72.81 0 72.3842 0.131487 72.0221 0.377833C71.66 0.624179 71.3778 0.97432 71.2111 1.38398C71.0444 1.79364 71.0008 2.24441 71.0858 2.67931C71.1707 3.1142 71.3805 3.51367 71.6884 3.82721C71.9964 4.14075 72.3888 4.35427 72.8159 4.44078C73.2431 4.52728 73.6858 4.48288 74.0882 4.3132C74.4906 4.14351 74.8345 3.85616 75.0765 3.48747C75.3184 3.11879 75.4476 2.68534 75.4476 2.24193C75.4476 1.64733 75.2156 1.07709 74.8026 0.656645C74.3896 0.236202 73.8295 0 73.2455 0Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M103.989 14.0805C103.989 13.9407 103.989 13.801 103.989 13.6612C103.989 9.39864 101.586 6.56274 97.6226 6.56274C93.6589 6.56274 90.9935 9.39864 90.9935 13.6612C90.9935 17.9238 93.6646 20.7597 97.6226 20.7597C100.362 20.7597 102.404 19.432 103.371 17.1901L100.511 15.81C100.324 16.4071 99.9494 16.9252 99.4452 17.2849C98.9411 17.6446 98.335 17.8261 97.7198 17.8015C96.9903 17.8221 96.2808 17.5579 95.7363 17.0632C95.1919 16.5685 94.8538 15.8805 94.7914 15.1403H94.82L103.989 14.0805ZM94.6941 12.6887C94.6941 10.6856 95.8667 9.37534 97.6111 9.37534C98.3297 9.36279 99.0258 9.63003 99.5574 10.1225C100.089 10.6149 100.416 11.2954 100.471 12.0249L94.6941 12.6887Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M56.5042 6.56274C52.5405 6.56274 49.8694 9.39864 49.8694 13.6612C49.8694 17.9238 52.5405 20.7597 56.5042 20.7597C59.2381 20.7597 61.28 19.432 62.2238 17.1901L59.364 15.81C59.18 16.3987 58.8136 16.911 58.3197 17.27C57.8258 17.629 57.231 17.8155 56.6243 17.8015C55.888 17.8327 55.1683 17.5734 54.6153 17.0776C54.0622 16.5818 53.7185 15.8878 53.6558 15.1403L62.8072 14.0688C62.8072 13.9291 62.8072 13.7893 62.8072 13.6496C62.8644 9.39864 60.4621 6.56274 56.5042 6.56274ZM53.5585 12.6887C53.5585 10.6856 54.7025 9.37534 56.4813 9.37534C57.1998 9.36279 57.896 9.63003 58.4275 10.1225C58.959 10.6149 59.2858 11.2954 59.3411 12.0249L53.5585 12.6887Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M68.155 16.3806V0.331909H64.2085V16.7882C64.2085 18.6982 64.586 20.6956 67.9262 20.6956C68.5591 20.7294 69.1915 20.6221 69.7794 20.3811V17.3007C69.7794 17.3007 68.155 17.7199 68.155 16.3806Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M104 24.1663H15.7291H15.7119V30.2224H0.114502V33H18.4345V26.9381H104V24.1663Z", fill: "white" }));
const logos = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GuidelineAccountants: SvgGuidelineAccountants,
  GuidelineAdvisors: SvgGuidelineAdvisors,
  GuidelineBlack: SvgGuidelineBlack,
  GuidelineDefault: SvgGuidelineDefault,
  GuidelineIra: SvgGuidelineIra,
  GuidelineMark: SvgGuidelineMark,
  GuidelineMarkBlack: SvgGuidelineMarkBlack,
  GuidelineMarkWhite: SvgGuidelineMarkWhite,
  GuidelineSepIra: SvgGuidelineSepIra,
  GuidelineWhite: SvgGuidelineWhite
}, Symbol.toStringTag, { value: "Module" }));
const SvgAmex$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 287, height: 82, viewBox: "0 0 287 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 17.84C20.0351 14.9 17.1751 13.22 12.9751 13.22C5.11508 13.27 0.455078 19.52 0.455078 28.19C0.455078 36.86 5.10508 43.11 12.9751 43.11C14.4151 43.19 15.8651 42.94 17.2051 42.38C18.5451 41.82 19.7451 40.96 20.7151 39.87V44.04C20.7151 46.88 19.2151 50.25 14.4551 50.25C10.8451 50.25 9.06508 48.23 8.44508 46.06L2.06508 49.15C3.66508 53.25 7.48508 56.69 14.9051 56.69C25.9051 56.69 28.7351 49.27 28.7351 42.77V13.64H22.0051L21.8251 17.84H21.8051ZM14.6951 36.31C10.7651 36.31 8.44508 33.11 8.44508 28.13C8.44508 23.15 10.7651 19.95 14.6951 19.95C18.6251 19.95 20.8951 23.15 20.8951 28.13C20.8951 33.11 18.6251 36.31 14.6951 36.31Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 58.96V68.85H0.705078V63.01H22.9951V58.96H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M279.235 53.23H273.465C272.185 53.23 271.385 52.43 271.385 51.31C271.385 50.19 272.345 49.55 273.465 49.55H283.885L286.295 44.26H273.465C268.175 44.26 265.125 47.47 265.125 51.64C265.125 56.13 268.015 58.7 272.665 58.7H278.435C279.715 58.7 280.515 59.5 280.515 60.62C280.515 61.74 279.715 62.54 278.435 62.54H265.925V67.83H278.435C283.725 67.83 286.775 64.78 286.775 60.29C286.775 55.8 284.045 53.23 279.235 53.23Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M256.305 53.23H250.535C249.255 53.23 248.455 52.43 248.455 51.31C248.455 50.19 249.415 49.55 250.535 49.55H260.955L263.365 44.26H250.535C245.245 44.26 242.195 47.47 242.195 51.64C242.195 56.13 245.085 58.7 249.735 58.7H255.505C256.785 58.7 257.585 59.5 257.585 60.62C257.585 61.74 256.785 62.54 255.505 62.54H242.995V67.83H255.505C260.795 67.83 263.845 64.78 263.845 60.29C263.845 55.8 261.115 53.23 256.305 53.23Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M219.735 67.66H239.465V62.37H225.995V58.52H239.145V53.23H225.995V49.54H239.465V44.25H219.735V67.66Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M216.535 51.78C216.535 47.29 213.325 44.24 208.195 44.24H194.725V67.65H200.975V59.47H203.225L210.285 67.65H217.985L210.285 59.15C214.135 58.35 216.535 55.46 216.535 51.77V51.78ZM207.395 54.19H200.815V49.54H207.395C209.315 49.54 210.285 50.66 210.285 51.95C210.125 53.23 209.165 54.2 207.395 54.2V54.19Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M183.495 44.25H169.865V67.66H176.115V59.96H183.335C188.625 59.96 191.835 56.59 191.835 52.1C191.835 47.61 188.625 44.24 183.495 44.24V44.25ZM182.855 54.67H176.115V49.54H182.855C184.775 49.54 185.745 50.66 185.745 52.11C185.585 53.55 184.625 54.68 182.855 54.68V54.67Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M168.745 44.25H160.725L154.625 51.3L148.535 44.25H140.355L150.615 55.79L140.195 67.66H148.215L154.465 60.28L160.885 67.66H169.065L158.475 55.63L168.745 44.25Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M119.505 67.66H139.235V62.37H125.765V58.52H138.915V53.23H125.765V49.54H139.235V44.25H119.505V67.66Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M276.865 28.17L267.175 13.8H259.265V37.38H265.565V22.36L275.415 37.38H283.005V13.8H276.865V28.17Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M239.565 13.8L229.235 37.37H236.175L238.115 32.53H249.095L251.195 37.37H258.295L247.635 13.8H239.565ZM240.215 27.36L243.445 19.45L246.675 27.36H240.215Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M218.895 25.75V25.27C218.895 21.72 220.835 19.3 224.865 19.3H231.965V13.81H224.375C216.625 13.81 212.585 18.82 212.585 25.27V25.75C212.585 33.02 217.105 37.21 224.045 37.21H226.145L228.725 31.88H225.015C221.305 32.04 218.875 29.94 218.875 25.74L218.895 25.75Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M209.375 13.8H203.075V37.37H209.375V13.8Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M199.685 21.39C199.685 16.87 196.455 13.8 191.285 13.8H177.725V37.37H184.025V29.14H186.285L193.385 37.37H201.295L193.545 28.81C197.425 28 199.685 25.1 199.685 21.38V21.39ZM190.485 23.81H183.865V19.13H190.485C192.425 19.13 193.395 20.26 193.395 21.55C193.395 22.84 192.425 23.81 190.485 23.81Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M153.665 37.38H173.525V32.05H159.965V28.17H173.205V22.85H159.965V19.13H173.525V13.8H153.665V37.38Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M133.645 28.66L128.315 13.8H118.465V37.38H124.605V20.42L130.735 37.38H136.385L142.685 20.42V37.38H148.825V13.8H138.975L133.645 28.66Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M98.6049 13.8L88.2749 37.37H95.2149L97.1549 32.53H108.135L110.235 37.37H117.335L106.835 13.8H98.6049ZM99.4149 27.36L102.645 19.45L105.875 27.36H99.4149Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M58.9951 0H57.9951V81.36H58.9951V0Z", fill: "#777675" }));
const SvgBoxGroup$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 267, height: 83, viewBox: "0 0 267 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.5775C20.0351 15.6375 17.1751 13.9575 12.9751 13.9575C5.11508 14.0075 0.455078 20.2575 0.455078 28.9275C0.455078 37.5975 5.10508 43.8475 12.9751 43.8475C14.4151 43.9275 15.8651 43.6775 17.2051 43.1175C18.5451 42.5575 19.7451 41.6975 20.7151 40.6075V44.7775C20.7151 47.6175 19.2151 50.9875 14.4551 50.9875C10.8451 50.9875 9.06508 48.9675 8.44508 46.7975L2.06508 49.8875C3.66508 53.9875 7.48508 57.4275 14.9051 57.4275C25.9051 57.4275 28.7351 50.0075 28.7351 43.5075V14.3675H22.0051L21.8251 18.5675L21.8051 18.5775ZM14.6951 37.0475C10.7651 37.0475 8.44508 33.8475 8.44508 28.8675C8.44508 23.8875 10.7651 20.6875 14.6951 20.6875C18.6251 20.6875 20.8951 23.8875 20.8951 28.8675C20.8951 33.8475 18.6251 37.0475 14.6951 37.0475Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.6975V69.5875H0.705078V63.7475H22.9951V59.6975H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.9951 0.737488H57.9951V82.0975H58.9951V0.737488Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M121.515 6.8075H88.2749V40.0475H121.515V6.8075Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M157.655 6.8075H124.415V40.0475H157.655V6.8075Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M193.795 6.8075H160.555V40.0475H193.795V6.8075Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M121.515 42.9475H88.2749V76.1875H121.515V42.9475Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M157.655 42.9475H124.415V76.1875H157.655V42.9475Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M193.795 42.9475H160.555V76.1875H193.795V42.9475Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M229.935 42.9475H196.695V76.1875H229.935V42.9475Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M266.075 42.9475H232.835V76.1875H266.075V42.9475Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M108.515 23.0775C108.455 23.0575 108.445 22.9775 108.505 22.9575C109.635 22.4475 110.835 21.3775 110.835 19.1375C110.835 14.8975 105.315 14.9575 105.315 14.9575H98.2847V32.0175H105.535C108.545 32.0175 111.555 30.6775 111.555 27.1075C111.555 24.0775 109.215 23.2575 108.515 23.0775ZM102.215 18.1975H105.325C105.325 18.1975 107.005 18.2575 107.005 19.9575C107.005 21.6575 105.165 21.7175 105.165 21.7175H102.215V18.1875V18.1975ZM105.415 28.5975H102.215V24.7575H105.595C105.595 24.7575 107.425 24.8275 107.425 26.6775C107.425 28.5275 105.415 28.5975 105.415 28.5975Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M141.255 14.4475C135.745 14.4475 131.805 18.1975 131.805 23.4975C131.805 28.7975 135.735 32.5475 141.255 32.5475C146.775 32.5475 150.705 28.7975 150.705 23.4975C150.705 18.1975 146.775 14.4475 141.255 14.4475ZM141.255 28.7175C138.415 28.7175 136.395 26.5475 136.395 23.4975C136.395 20.4475 138.415 18.2775 141.255 18.2775C144.095 18.2775 146.115 20.4475 146.115 23.4975C146.115 26.5475 144.095 28.7175 141.255 28.7175Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M177.175 50.2675C171.665 50.2675 167.725 54.0175 167.725 59.3175C167.725 64.6175 171.655 68.3675 177.175 68.3675C182.695 68.3675 186.625 64.6175 186.625 59.3175C186.625 54.0175 182.695 50.2675 177.175 50.2675ZM177.175 64.5375C174.335 64.5375 172.315 62.3675 172.315 59.3175C172.315 56.2675 174.335 54.0975 177.175 54.0975C180.015 54.0975 182.035 56.2675 182.035 59.3175C182.035 62.3675 180.015 64.5375 177.175 64.5375Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M179.635 23.1175L185.085 14.9575H180.195L176.915 19.8675L173.645 14.9575H168.755L174.205 23.1175L167.985 32.0175H173.255L176.855 25.9475L176.915 25.8875L176.985 25.9475L180.585 32.0175H185.855L179.635 23.1175Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M138.305 64.6775V61.0975H139.685L143.475 68.1075H148.355L143.865 60.7175C143.865 60.7175 147.265 60.2975 147.265 56.0475C147.265 51.0375 142.165 51.0375 142.165 51.0375H134.365V68.0975H138.305V64.6775ZM138.305 54.2775H141.415C141.415 54.2775 143.095 54.3375 143.095 56.0375C143.095 57.7375 141.255 57.7975 141.255 57.7975H138.305V54.2675V54.2775Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M251.735 60.9675C251.735 60.9675 255.135 60.2975 255.135 56.0475C255.135 51.0375 250.035 51.0375 250.035 51.0375H242.235V68.0975H246.175V61.3475C250.635 61.3475 251.735 60.9575 251.735 60.9575V60.9675ZM246.175 54.2775H249.285C249.285 54.2775 251.155 54.2775 251.155 56.3275C251.155 58.0275 249.125 58.3375 249.125 58.3375H246.175V54.2675V54.2775Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M110.795 55.7475L113.405 52.7175C113.405 52.7175 111.175 50.3175 106.865 50.3175C102.555 50.3175 97.4648 53.2875 97.4648 59.4175C97.4648 64.9375 101.325 68.3875 106.895 68.3875C110.135 68.3875 112.195 67.5975 113.455 66.9375V58.0175H106.515V61.0675H109.685V64.2375C109.685 64.2375 108.615 64.8875 107.185 64.8875C105.395 64.8875 101.755 63.9675 101.755 59.4575C101.755 59.4575 101.785 54.1475 106.915 53.9975C106.915 53.9975 108.925 53.9275 110.795 55.7275V55.7475Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M216.685 51.0375V61.7875C216.685 61.7875 216.585 64.8275 213.405 64.8275C210.225 64.8275 210.125 61.7875 210.125 61.7875V51.0375H206.145V61.8575C206.145 68.3375 213.405 68.3575 213.405 68.3575C213.405 68.3575 220.665 68.3275 220.665 61.8575V51.0375H216.685Z", fill: "white" }));
const SvgFelicis$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 323, height: 82, viewBox: "0 0 323 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.0049 0.474976H58.0049V81.835H59.0049V0.474976Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M248.065 19.225C248.055 18.775 248.135 18.325 248.295 17.915C248.455 17.495 248.695 17.115 249.005 16.795C249.315 16.475 249.685 16.215 250.085 16.045C250.495 15.865 250.925 15.775 251.375 15.775C251.825 15.755 252.285 15.835 252.705 16.005C253.125 16.175 253.515 16.425 253.845 16.745C254.175 17.065 254.435 17.445 254.605 17.875C254.785 18.295 254.875 18.755 254.875 19.215C254.875 19.675 254.785 20.135 254.605 20.555C254.425 20.975 254.165 21.365 253.845 21.685C253.515 22.005 253.135 22.255 252.705 22.425C252.285 22.595 251.825 22.665 251.375 22.655C250.935 22.655 250.505 22.565 250.095 22.395C249.695 22.225 249.325 21.975 249.015 21.655C248.705 21.335 248.465 20.965 248.305 20.545C248.145 20.135 248.065 19.695 248.065 19.245V19.225Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M170.225 15.845C170.225 14.815 170.715 14.255 171.395 14.255H199.315C199.475 14.255 199.625 14.285 199.765 14.345C199.905 14.405 200.035 14.495 200.145 14.605C200.255 14.715 200.345 14.855 200.395 14.995C200.455 15.145 200.485 15.295 200.485 15.455V18.975C200.485 19.295 200.365 19.595 200.145 19.815C199.925 20.035 199.625 20.165 199.315 20.165H176.595V34.685H192.015C192.325 34.685 192.615 34.825 192.835 35.045C193.055 35.265 193.175 35.565 193.185 35.875V39.325C193.185 39.635 193.045 39.935 192.835 40.155C192.615 40.375 192.325 40.505 192.015 40.515H176.595V55.045C176.585 55.355 176.455 55.655 176.235 55.875C176.015 56.095 175.725 56.225 175.415 56.235H171.395C171.145 56.235 170.895 56.165 170.685 56.025C170.475 55.885 170.315 55.675 170.225 55.435V15.815V15.845Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M211.815 26.025C219.235 26.025 224.865 31.615 224.865 39.345C224.865 39.845 224.805 40.855 224.735 41.355C224.715 41.695 224.565 42.005 224.325 42.235C224.085 42.465 223.765 42.595 223.435 42.605H203.715C203.775 46.495 207.235 50.525 212.245 50.525C215.525 50.525 217.505 49.335 219.235 48.075C219.855 47.635 220.405 47.445 220.905 48.195L222.575 50.835C223.065 51.465 223.315 52.025 222.445 52.775C220.405 54.615 216.635 56.375 211.865 56.375C203.195 56.375 197.565 49.465 197.565 41.175C197.585 32.995 203.205 26.015 211.805 26.015L211.815 26.025ZM218.745 37.955C218.615 34.435 215.895 31.355 211.695 31.355C207.185 31.355 204.455 34.305 204.025 37.955H218.745Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M248.265 28.045C248.275 27.685 248.425 27.345 248.675 27.085C248.925 26.825 249.265 26.675 249.615 26.665H253.085C253.435 26.685 253.765 26.845 254.015 27.095C254.265 27.345 254.415 27.685 254.445 28.045V54.295C254.435 54.655 254.285 55.005 254.035 55.255C253.785 55.515 253.445 55.665 253.085 55.675H249.615C249.255 55.675 248.915 55.525 248.655 55.265C248.395 55.005 248.255 54.655 248.255 54.295V28.045H248.265Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M274.735 26.025C279.185 26.025 282.465 27.725 285.135 31.055C285.255 31.205 285.345 31.375 285.405 31.565C285.455 31.755 285.475 31.945 285.455 32.145C285.435 32.335 285.375 32.525 285.275 32.695C285.175 32.865 285.045 33.015 284.895 33.125L282.655 35.205C281.845 35.955 281.295 35.395 280.805 34.895C279.505 33.455 277.215 32.005 274.935 32.005C270.045 32.005 266.265 36.025 266.265 41.175C266.265 46.325 269.975 50.415 274.735 50.415C278.445 50.415 279.935 48.285 281.475 46.835C281.585 46.695 281.725 46.575 281.885 46.495C282.045 46.415 282.225 46.365 282.405 46.345C282.585 46.335 282.765 46.355 282.935 46.425C283.105 46.485 283.255 46.585 283.385 46.715L285.295 48.285C285.975 48.915 286.285 49.605 285.795 50.355C284.595 52.235 282.945 53.775 280.995 54.825C279.055 55.885 276.875 56.415 274.665 56.385C266.685 56.385 260.075 49.975 260.075 41.245C260.075 32.515 266.815 26.025 274.725 26.025H274.735Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M291.055 28.045C291.065 27.685 291.215 27.335 291.465 27.085C291.715 26.825 292.055 26.675 292.415 26.665H295.885C296.235 26.685 296.575 26.845 296.815 27.095C297.065 27.345 297.215 27.685 297.245 28.045V54.295C297.235 54.655 297.085 55.005 296.835 55.255C296.585 55.515 296.245 55.665 295.885 55.675H292.415C292.055 55.675 291.715 55.525 291.455 55.265C291.205 55.005 291.055 54.655 291.055 54.295V28.045Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M302.705 53.415C302.455 53.275 302.265 53.035 302.175 52.755C302.085 52.475 302.095 52.175 302.215 51.905L303.515 49.205C303.825 48.575 304.625 48.385 305.365 48.825C307.035 49.765 309.075 50.955 312.475 50.955C314.885 50.955 316.245 49.765 316.245 48.125C316.245 46.185 314.085 44.925 310.125 43.095C305.735 41.085 302.395 38.695 302.395 33.925C302.395 30.285 304.925 26.005 311.855 26.005C315.815 26.005 318.785 27.205 320.205 28.145C320.545 28.365 320.795 28.705 320.905 29.095C321.015 29.485 320.985 29.905 320.825 30.275L319.835 32.285C319.755 32.445 319.635 32.595 319.495 32.715C319.355 32.835 319.195 32.925 319.025 32.975C318.855 33.025 318.675 33.045 318.495 33.025C318.315 33.005 318.145 32.945 317.985 32.855C316.065 31.935 313.985 31.445 311.865 31.415C309.395 31.415 308.215 32.665 308.215 33.985C308.215 35.865 310.255 36.995 313.095 38.255C318.355 40.515 322.315 42.465 322.315 47.865C322.315 52.405 318.475 56.365 312.115 56.365C308.755 56.365 305.475 55.325 302.715 53.395L302.705 53.415Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M290.795 19.225C290.785 18.775 290.865 18.325 291.025 17.915C291.185 17.495 291.425 17.115 291.735 16.795C292.045 16.475 292.415 16.215 292.815 16.045C293.225 15.865 293.655 15.775 294.105 15.775C294.555 15.755 295.015 15.835 295.435 16.005C295.855 16.175 296.245 16.425 296.575 16.745C296.905 17.065 297.165 17.445 297.335 17.875C297.515 18.295 297.605 18.755 297.605 19.215C297.605 19.675 297.515 20.135 297.335 20.555C297.155 20.975 296.895 21.365 296.575 21.685C296.245 22.005 295.865 22.255 295.435 22.425C295.015 22.595 294.555 22.665 294.105 22.655C293.665 22.655 293.235 22.565 292.825 22.395C292.425 22.225 292.055 21.975 291.745 21.655C291.435 21.335 291.195 20.965 291.035 20.545C290.875 20.135 290.795 19.695 290.795 19.245V19.225Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M242.385 54.955C242.385 55.155 242.345 55.345 242.265 55.525C242.185 55.705 242.075 55.865 241.935 55.995C241.795 56.125 241.625 56.225 241.445 56.295C241.265 56.355 241.065 56.385 240.875 56.365C237.105 56.025 234.255 54.345 232.315 51.325C230.975 49.195 230.305 46.125 230.305 42.115V18.655C230.305 18.475 230.345 18.285 230.415 18.115C230.485 17.945 230.585 17.785 230.715 17.655C230.845 17.525 230.995 17.425 231.165 17.345C231.335 17.275 231.515 17.235 231.695 17.235H235.085C235.265 17.235 235.445 17.275 235.615 17.345C235.785 17.415 235.935 17.515 236.065 17.655C236.195 17.785 236.295 17.945 236.365 18.115C236.435 18.285 236.475 18.465 236.475 18.655V42.115C236.475 44.845 236.845 46.805 237.585 47.995C238.315 49.245 239.515 49.975 241.165 50.195C241.495 50.235 241.805 50.405 242.035 50.655C242.255 50.915 242.385 51.245 242.385 51.585V54.955Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M145.405 39.415C141.815 40.925 136.905 40.475 121.805 34.135C128.065 18.795 131.215 14.955 134.805 13.455C138.385 11.955 143.035 13.245 145.065 18.225C145.635 19.515 146.015 20.875 146.175 22.285C146.205 22.785 146.315 23.285 146.505 23.745C146.695 24.205 146.965 24.635 147.285 25.015C148.145 26.125 148.845 27.355 149.335 28.675C151.365 33.665 148.985 37.915 145.405 39.425V39.415Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M103.555 57.015C107.145 55.505 110.305 51.665 116.555 36.335C101.455 29.985 96.5453 29.545 92.9553 31.035C89.3653 32.525 86.9853 36.795 89.0153 41.775C89.5153 43.095 90.2153 44.335 91.0853 45.435C91.4153 45.815 91.6753 46.245 91.8753 46.705C92.0553 47.175 92.1653 47.665 92.2053 48.165C92.3653 49.575 92.7353 50.945 93.3053 52.245C95.3153 57.225 99.9553 58.525 103.555 57.015Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M125.625 65.855C126.925 65.345 128.145 64.635 129.235 63.755C129.605 63.425 130.025 63.155 130.485 62.955C130.945 62.775 131.435 62.655 131.925 62.625C133.315 62.465 134.665 62.095 135.935 61.525C140.835 59.465 142.115 54.745 140.635 51.105C139.145 47.455 135.365 44.255 120.275 37.905C114.015 53.245 113.575 58.225 115.075 61.875C116.575 65.515 120.735 67.925 125.635 65.875L125.625 65.855Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M97.7255 19.355C99.2155 22.995 102.996 26.205 118.086 32.555C124.356 17.225 124.796 12.235 123.306 8.59498C121.816 4.95498 117.626 2.53498 112.726 4.59498C111.426 5.10498 110.206 5.81499 109.116 6.69499C108.736 7.02499 108.316 7.29498 107.866 7.49498C107.406 7.68498 106.926 7.79499 106.426 7.82499C105.036 7.98499 103.686 8.35498 102.406 8.93498C97.5155 10.995 96.2355 15.715 97.7155 19.355H97.7255Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.3049C20.0351 15.3649 17.1751 13.6849 12.9751 13.6849C5.11508 13.7349 0.455078 19.9849 0.455078 28.6549C0.455078 37.3249 5.10508 43.575 12.9751 43.575C14.4151 43.655 15.8651 43.4049 17.2051 42.8449C18.5451 42.2849 19.7451 41.4249 20.7151 40.3349V44.5049C20.7151 47.3449 19.2151 50.7149 14.4551 50.7149C10.8451 50.7149 9.06508 48.6949 8.44508 46.5249L2.06508 49.6149C3.66508 53.7149 7.48508 57.1549 14.9051 57.1549C25.9051 57.1549 28.7351 49.735 28.7351 43.235V14.0949H22.0051L21.8251 18.295L21.8051 18.3049ZM14.6951 36.7749C10.7651 36.7749 8.44508 33.5749 8.44508 28.5949C8.44508 23.6149 10.7651 20.4149 14.6951 20.4149C18.6251 20.4149 20.8951 23.6149 20.8951 28.5949C20.8951 33.5749 18.6251 36.7749 14.6951 36.7749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.4349V69.325H0.705078V63.485H22.9951V59.4349H28.7151H28.7251Z", fill: "#5532FA" }));
const SvgGeneralAtlantic$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 316, height: 82, viewBox: "0 0 316 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.0524C20.0351 15.1124 17.1751 13.4324 12.9751 13.4324C5.11508 13.4824 0.455078 19.7325 0.455078 28.4025C0.455078 37.0725 5.10508 43.3224 12.9751 43.3224C14.4151 43.4024 15.8651 43.1525 17.2051 42.5925C18.5451 42.0325 19.7451 41.1725 20.7151 40.0825V44.2524C20.7151 47.0924 19.2151 50.4625 14.4551 50.4625C10.8451 50.4625 9.06508 48.4425 8.44508 46.2725L2.06508 49.3624C3.66508 53.4624 7.48508 56.9025 14.9051 56.9025C25.9051 56.9025 28.7351 49.4825 28.7351 42.9825V13.8425H22.0051L21.8251 18.0425L21.8051 18.0524ZM14.6951 36.5225C10.7651 36.5225 8.44508 33.3225 8.44508 28.3425C8.44508 23.3625 10.7651 20.1625 14.6951 20.1625C18.6251 20.1625 20.8951 23.3625 20.8951 28.3425C20.8951 33.3225 18.6251 36.5225 14.6951 36.5225Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.1824V69.0724H0.705078V63.2324H22.9951V59.1824H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.9951 0.212463H57.9951V81.5724H58.9951V0.212463Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M167.469 36.5274C162.929 36.7074 159.099 33.1674 158.919 28.6274C158.919 28.3774 158.919 28.1374 158.919 27.8874C158.769 23.2074 162.449 19.2974 167.129 19.1474C167.219 19.1474 167.309 19.1474 167.399 19.1474C169.679 19.0374 171.909 19.8074 173.639 21.3074L172.409 22.7574C171.019 21.4574 169.169 20.7674 167.269 20.8274C163.629 20.9074 160.749 23.9174 160.829 27.5474C160.829 27.6174 160.829 27.6874 160.829 27.7574C160.569 31.3874 163.309 34.5374 166.939 34.7874C167.139 34.7974 167.339 34.8074 167.529 34.7974C169.309 34.8174 171.049 34.2374 172.469 33.1474V28.9374H167.269V27.2874H174.249V34.0074C172.379 35.6674 169.969 36.5874 167.469 36.5874", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M197.12 21.1074H186.8V26.8674H196.03V28.5975H186.8V34.5074H197.24V36.2374H184.89V19.3774H197.12V21.1074Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M219.39 19.3774H221.25V36.2374H219.74L208.81 22.4075V36.2374H206.95V19.3774H208.74L219.39 32.8975V19.3774Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M244.56 21.1074H234.24V26.8674H243.48V28.5975H234.24V34.5074H244.68V36.2374H232.33V19.3774H244.56V21.1074Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M266.03 36.2374L261.09 29.6575H256.25V36.2374H254.41V19.3674H261.69C265.41 19.3674 267.8 21.3775 267.8 24.4075C267.8 27.0075 265.8 29.1675 263.21 29.3475L268.41 36.2474H266.04L266.03 36.2374ZM261.52 21.1274H256.3V27.9774H261.5C264.04 27.9774 265.85 26.6774 265.85 24.4874C265.85 22.2974 264.2 21.1974 261.52 21.1974", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M294.28 36.2374H292.27L290.29 31.7775H281.09L279.1 36.2374H277.14L284.84 19.2474H286.63L294.27 36.2374H294.28ZM285.69 21.4675L281.82 30.0574H289.52L285.68 21.4675H285.69Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M303.609 19.3774H305.519V34.4774H315.049V36.2374H303.609V19.3774Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M175.39 62.4575H173.28L171.29 57.9975H162.09L160.08 62.4575H158.12L165.84 45.4175H167.62L175.39 62.4575ZM166.76 47.6375L162.89 56.2275H170.61L166.76 47.6375Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M187.41 62.4075H185.47V47.2974H179.79V45.5375H193.09V47.2974H187.41V62.4075Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M201.189 45.5375H203.099V60.6475H212.609V62.4075H201.189V45.5375Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M237.19 62.4575H235.13L233.14 57.9975H223.94L221.93 62.4575H219.97L227.69 45.4675H229.47L237.19 62.4575ZM228.56 47.6375L224.77 56.2275H232.47L228.55 47.6375H228.56Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M257.619 45.5375H259.479V62.4075H257.949L247.029 48.5775V62.4075H245.169V45.5375H246.949L257.619 59.0474V45.5375Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M275.18 62.4075H273.26V47.2974H267.58V45.5375H280.86V47.2974H275.18V62.4075Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M308.37 62.6875C303.72 62.7175 299.92 58.9675 299.89 54.3175C299.89 54.2075 299.89 54.1075 299.89 53.9975C299.75 49.3075 303.44 45.3975 308.13 45.2575C308.24 45.2575 308.34 45.2575 308.45 45.2575C310.92 45.1775 313.31 46.1475 315.03 47.9275L313.66 49.2975C312.28 47.8275 310.36 46.9875 308.34 46.9775C304.7 46.9775 301.75 49.9175 301.75 53.5475C301.75 53.6675 301.75 53.7975 301.75 53.9175C301.52 57.5475 304.28 60.6775 307.91 60.8975C308.05 60.8975 308.19 60.9075 308.33 60.9075C310.41 60.9075 312.4 60.0175 313.8 58.4675L315.05 59.6875C313.34 61.6275 310.87 62.7075 308.28 62.6475", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M114.38 14.7175C99.9196 14.7575 88.2396 26.4975 88.2696 40.9575C88.3096 55.4175 100.05 67.0974 114.51 67.0674C128.94 67.0274 140.62 55.3275 140.62 40.8975C140.6 26.4275 128.85 14.7074 114.38 14.7274M94.6296 46.5975L106.25 35.2075C109.48 32.0575 114.63 32.0575 117.86 35.2075L106.34 46.5775C103.12 49.6675 98.0396 49.6675 94.8196 46.5775M122.8 46.5775C119.58 49.6675 114.49 49.6675 111.28 46.5775L122.8 35.2075C126 32.0675 131.12 32.0675 134.32 35.2075L122.8 46.5775Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M291.455 45.6725H289.525V62.5425H291.455V45.6725Z", fill: "#172E57" }));
const SvgGenerationIm$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 448, height: 83, viewBox: "0 0 448 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.7902C20.0351 15.8502 17.1751 14.1702 12.9751 14.1702C5.11508 14.2202 0.455078 20.4701 0.455078 29.1401C0.455078 37.8101 5.10508 44.0601 12.9751 44.0601C14.4151 44.1401 15.8651 43.8901 17.2051 43.3301C18.5451 42.7701 19.7451 41.9101 20.7151 40.8201V44.9901C20.7151 47.8301 19.2151 51.2001 14.4551 51.2001C10.8451 51.2001 9.06508 49.1801 8.44508 47.0101L2.06508 50.1002C3.66508 54.2002 7.48508 57.6401 14.9051 57.6401C25.9051 57.6401 28.7351 50.2202 28.7351 43.7202V14.5801H22.0051L21.8251 18.7802L21.8051 18.7902ZM14.6951 37.2601C10.7651 37.2601 8.44508 34.0601 8.44508 29.0801C8.44508 24.1001 10.7651 20.9001 14.6951 20.9001C18.6251 20.9001 20.8951 24.1001 20.8951 29.0801C20.8951 34.0601 18.6251 37.2601 14.6951 37.2601Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.9102V69.8002H0.705078V63.9601H22.9951V59.9102H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.0049 0.950073H58.0049V82.3101H59.0049V0.950073Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M306.975 54.17V27.42C304.825 27.42 302.695 27.49 300.555 27.57C298.425 27.64 296.305 27.72 294.185 27.72V29.44H299.285V54.18H294.185V56.16H312.365V54.18H306.975V54.17Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M302.695 21.74C304.965 21.74 306.975 20.02 306.975 17.75C306.975 15.48 304.965 13.5 302.695 13.5C300.715 13.5 298.735 15.48 298.735 17.75C298.735 20.02 300.715 21.74 302.695 21.74Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M282.935 17.7C280.405 17.99 277.835 18.2499 275.305 18.2499V27.83H270.765V29.52H275.305V50.9299C275.305 54.8599 276.445 56.84 282.935 56.84C287.185 56.84 290.045 55.15 291.735 51.22L290.305 50.3799C289.465 52.3299 288.065 54.3099 285.795 54.3099C283.235 54.3099 282.935 52.6199 282.935 50.3799V29.52H289.755V27.83H282.935V17.7Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.545 51.8401C107.035 51.8401 107.505 51.8301 107.955 51.8201C110.645 51.7501 112.735 51.7001 114.415 54.1501C115.555 55.5801 115.815 57.5601 115.815 59.2801C115.815 68.6601 108.245 72.9501 99.8252 72.9501C95.0452 72.9501 88.2852 70.6701 88.2852 64.6701C88.2852 61.8401 90.5252 59.5401 92.7652 58.4101C89.9752 57.5701 88.2852 55.3001 88.2852 51.8601C88.2852 47.6101 90.8152 45.8901 94.7452 44.7501C91.9152 43.0301 89.9652 40.4701 89.9652 37.0601C89.9652 30.8001 94.7452 27.1001 100.625 27.1001C104.005 27.1001 106.245 28.2401 108.775 30.5101L108.895 30.3401C110.235 28.4301 111.385 26.8101 113.845 26.8101C115.535 26.8101 116.935 27.9501 116.935 29.6701C116.935 31.6501 116.095 32.5301 114.405 32.5301C113.335 32.5301 112.715 31.4901 112.265 30.7401C112.005 30.3101 111.805 29.9701 111.605 29.9701C111.075 29.9701 110.655 30.4101 110.275 30.8101C110.045 31.0501 109.835 31.2701 109.625 31.3701C110.765 32.8001 111.315 34.8101 111.315 36.7901C111.315 39.9401 109.625 43.3501 106.835 45.0701C104.555 46.4301 101.755 46.3401 99.1352 46.2501C98.5052 46.2301 97.8852 46.2101 97.2852 46.2101C95.3052 46.2101 90.5252 46.5001 90.5252 49.6201C90.5252 51.3401 91.6652 51.8901 93.3552 51.8901H106.545V51.8401ZM95.5852 58.6901C93.3452 58.6901 92.7552 62.1001 92.7552 64.1101C92.7552 68.6501 95.8452 70.9601 100.355 70.9601C105.975 70.9601 111.315 69.2401 112.995 62.9801C114.395 58.9901 111.305 58.7001 107.655 58.7001H95.5752L95.5852 58.6901ZM96.6952 41.5901C96.6952 44.1501 97.8352 45.0301 100.625 45.0301C103.415 45.0301 104.585 44.4501 104.585 41.5901V31.6301C104.585 29.0701 103.155 28.5101 100.915 28.5101C97.8252 28.5101 96.6952 29.9401 96.6952 31.6301V41.5901Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M125.365 40.15V45.8C125.365 50.9 125.625 55.41 131.505 55.41C136.835 55.41 140.475 51.74 141.905 46.93H143.855C141.905 54.01 137.125 56.83 130.105 56.83C122.525 56.83 116.935 49.46 116.935 42.12C116.935 34.2 123.375 27.12 130.945 27.12C137.675 27.12 143.555 31.63 143.555 38.71C143.555 40.2 143.145 40.18 142.315 40.15C142.185 40.15 142.045 40.14 141.895 40.14H125.355L125.365 40.15ZM135.775 36.52C135.905 32.36 136.015 28.56 130.695 28.56C125.375 28.56 125.315 33.08 125.355 37.33C125.355 37.71 125.355 38.09 125.355 38.46H135.715C135.715 37.81 135.735 37.16 135.755 36.51L135.775 36.52Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M157.995 33.95H157.705V27.42C155.475 27.42 153.165 27.5 150.995 27.58C149.055 27.65 147.215 27.71 145.615 27.71V29.4H150.395V54.17H145.615V56.15H162.225V54.17H157.715V44.76C157.715 41.35 157.715 38.23 158.855 35.67C159.965 33.11 162.495 29.7 165.615 29.7C169.905 29.7 169.865 33.6 169.815 39.34C169.815 39.99 169.805 40.66 169.805 41.35V54.17H165.325V56.15H181.635V54.17H177.125V41.06C177.125 40.51 177.125 39.96 177.125 39.42C177.185 32.94 177.235 27.14 168.695 27.14C163.335 27.14 160.255 29.7 158.005 33.96L157.995 33.95Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M191.175 40.15V45.8C191.175 50.9 191.465 55.41 197.735 55.41C202.835 55.41 206.825 51.74 208.225 46.93H209.945C208.225 54.01 203.125 56.83 196.315 56.83C188.365 56.83 182.685 49.46 182.685 42.12C182.685 34.2 189.215 27.12 196.875 27.12C203.695 27.12 209.955 31.63 209.955 38.71C209.955 40.2 209.315 40.18 208.405 40.15C208.265 40.15 208.125 40.15 207.975 40.15H191.195H191.175ZM201.695 38.46C201.695 37.81 201.715 37.15 201.735 36.5C201.865 32.35 201.985 28.56 196.595 28.56C191.205 28.56 191.125 33.12 191.165 37.39C191.165 37.75 191.165 38.11 191.165 38.46H201.685H201.695Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M223.995 34.55C223.825 34.83 223.645 35.1 223.475 35.38V27.43C221.295 27.43 219.095 27.51 216.985 27.58C215.015 27.65 213.105 27.72 211.335 27.72V29.41H215.845V54.18H211.625V56.16H229.975V54.18H223.485V47.62C223.485 38.24 225.175 34.25 227.995 31.68C228.835 30.54 229.685 29.99 231.115 29.99C231.665 29.99 231.665 30.25 231.375 31.39V32.56C231.375 34.25 233.095 35.97 234.785 35.97C237.315 35.97 239.295 34.54 239.295 31.98C239.295 28.57 236.465 27.14 233.645 27.14C228.655 27.14 226.345 30.83 224.005 34.56L223.995 34.55Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M258.405 31.1C258.405 29.41 255.025 28.57 253.895 28.57C251.105 28.57 247.715 29.97 248.855 31.4C249.115 31.95 249.695 33.38 249.695 34.78C249.695 36.5 248.005 37.9 246.315 37.9C244.335 37.9 242.675 36.76 242.675 34.52C242.675 29.13 249.695 27.15 253.895 27.15C256.985 27.15 260.355 27.7 263.185 29.13C265.135 30.27 265.685 31.4 265.685 33.38V52.34C265.685 53.45 266.525 53.74 267.375 53.74C268.225 53.74 269.355 52.9 269.905 52.05L270.745 53.19C268.765 55.43 267.105 56.86 264.015 56.86C260.925 56.86 258.945 55.17 258.395 51.76C255.865 55.17 252.195 56.86 247.995 56.86C243.795 56.86 240.685 54.59 240.685 50.07C240.685 41.56 252.195 39.87 258.395 40.17V31.11L258.405 31.1ZM258.405 41.56C254.185 41.56 248.275 42.14 248.275 48.09C248.275 51.21 249.415 53.45 252.785 53.45C255.315 53.45 256.975 51.47 257.825 49.23C258.405 48.09 258.405 46.96 258.405 45.53V41.57V41.56Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M329.745 27.13C337.955 27.13 344.775 34.21 344.775 42.13C344.775 50.05 337.955 56.84 329.745 56.84C321.535 56.84 314.715 50.35 314.715 42.13C314.715 33.91 321.795 27.13 329.745 27.13ZM329.745 28.56C323.195 28.56 323.205 33.77 323.215 41.2C323.215 41.51 323.215 41.82 323.215 42.14C323.215 51.46 323.505 55.42 329.745 55.42C335.985 55.42 336.275 51.46 336.275 42.14C336.275 41.59 336.275 41.06 336.275 40.53C336.305 33.46 336.335 28.56 329.745 28.56Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M369.585 27.13C364.485 27.13 361.075 29.69 358.805 33.95V27.42C356.415 27.42 354.105 27.5 351.915 27.58C349.935 27.65 348.055 27.71 346.305 27.71V29.4H351.145V54.17H346.305V56.15H363.345V54.17H358.805V44.76C358.805 41.35 358.805 38.23 359.645 35.67C360.785 33.11 363.635 29.7 366.465 29.7C370.815 29.7 370.785 33.61 370.725 39.36C370.725 40.01 370.715 40.67 370.715 41.35V54.17H366.175V56.15H382.665V54.17H378.415V41.06C378.415 40.68 378.415 40.31 378.415 39.93C378.445 33.24 378.465 27.13 369.585 27.13Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M389.325 54.17H447.295V56.15H389.325V54.17Z", fill: "black" }));
const SvgLererHippeau$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 464, height: 83, viewBox: "0 0 464 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.0049 0.687622H58.0049V82.0477H59.0049V0.687622Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M96.5649 26.9877H88.2749V48.3577V55.3276H96.5649H111.625V48.3577H96.5649V26.9877Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M125.455 44.0276H134.795V37.5477H125.455V33.9576H141.195V26.9877H125.455H117.455V33.9576V37.5477V44.0276V48.3577V55.3276H125.455H142.865V48.3577H125.455V44.0276Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M189.275 44.0276H198.615V37.5477H189.275V33.9576H205.015V26.9877H189.275H181.275V33.9576V37.5477V44.0276V48.3577V55.3276H189.275H206.685V48.3577H189.275V44.0276Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M379.775 44.0276H389.105V37.5477H379.775V33.9576H395.505V26.9877H379.775H371.775V33.9576V37.5477V44.0276V48.3577V55.3276H379.775H397.185V48.3577H379.775V44.0276Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M175.725 36.1175C175.725 26.8875 165.935 26.9876 165.935 26.9876H148.055V55.3176H156.055V45.7176H162.545L167.915 55.3176H176.855L170.865 44.7576C173.215 43.5076 175.725 41.0276 175.725 36.1076V36.1175ZM156.055 33.9476H165.095C165.095 33.9476 167.445 34.0376 167.445 36.2076C167.445 38.3776 165.285 38.4676 165.285 38.4676H156.065V33.9476H156.055Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M275.975 37.9077H263.925V26.9877H255.925V55.3276H263.925V44.7776H275.975V55.3276H283.975V26.9877H275.975V37.9077Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M298.935 26.9877H290.935V55.3176H298.935V26.9877Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M239.635 36.1175C239.635 26.8875 229.845 26.9876 229.845 26.9876H211.965V55.3176H219.965V45.7176H226.455L231.825 55.3176H240.765L234.775 44.7576C237.125 43.5076 239.635 41.0276 239.635 36.1076V36.1175ZM219.965 33.9476H229.005C229.005 33.9476 231.355 34.0376 231.355 36.2076C231.355 38.3776 229.195 38.4676 229.195 38.4676H219.975V33.9476H219.965Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M323.695 26.9877H305.715V55.3176H313.715V46.3776H323.885C323.885 46.3776 333.585 46.3777 333.585 36.6777C333.585 26.9777 323.705 26.9777 323.705 26.9777L323.695 26.9877ZM322.565 39.1276H313.715V34.2277H322.565C322.565 34.2277 325.295 34.6076 325.295 36.8676C325.295 39.1276 322.565 39.1276 322.565 39.1276Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M356.825 26.9877H338.845V55.3176H346.845V46.3776H357.015C357.015 46.3776 366.715 46.3777 366.715 36.6777C366.715 26.9777 356.835 26.9777 356.835 26.9777L356.825 26.9877ZM355.695 39.1276H346.845V34.2277H355.695C355.695 34.2277 358.425 34.6076 358.425 36.8676C358.425 39.1276 355.695 39.1276 355.695 39.1276Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M411.635 26.9877L399.955 55.3176H408.125L409.795 51.3477H422.135L423.805 55.3176H432.875L420.785 26.9877H411.635ZM412.505 44.8976L415.955 36.6876L419.405 44.8976H412.495H412.505Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M455.655 26.9877V44.1577C455.655 44.1577 455.495 48.8176 449.525 48.8176C443.555 48.8176 443.805 44.1577 443.805 44.1577V26.9877H435.805V44.1577C435.805 44.1577 435.315 55.9976 449.525 55.9976C463.735 55.9976 463.655 45.8677 463.655 44.1577V26.9877H455.655Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.5277C20.0351 15.5877 17.1751 13.9077 12.9751 13.9077C5.11508 13.9577 0.455078 20.2077 0.455078 28.8777C0.455078 37.5477 5.10508 43.7977 12.9751 43.7977C14.4151 43.8777 15.8651 43.6277 17.2051 43.0677C18.5451 42.5077 19.7451 41.6477 20.7151 40.5577V44.7277C20.7151 47.5677 19.2151 50.9377 14.4551 50.9377C10.8451 50.9377 9.06508 48.9177 8.44508 46.7477L2.06508 49.8377C3.66508 53.9377 7.48508 57.3777 14.9051 57.3777C25.9051 57.3777 28.7351 49.9577 28.7351 43.4577V14.3177H22.0051L21.8251 18.5177L21.8051 18.5277ZM14.6951 36.9977C10.7651 36.9977 8.44508 33.7977 8.44508 28.8177C8.44508 23.8377 10.7651 20.6377 14.6951 20.6377C18.6251 20.6377 20.8951 23.8377 20.8951 28.8177C20.8951 33.7977 18.6251 36.9977 14.6951 36.9977Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.6477V69.5377H0.705078V63.6977H22.9951V59.6477H28.7151H28.7251Z", fill: "#5532FA" }));
const SvgPropel$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 303, height: 83, viewBox: "0 0 303 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.7402C20.0351 15.8002 17.1751 14.1202 12.9751 14.1202C5.11508 14.1702 0.455078 20.4203 0.455078 29.0903C0.455078 37.7603 5.10508 44.0103 12.9751 44.0103C14.4151 44.0903 15.8651 43.8403 17.2051 43.2803C18.5451 42.7203 19.7451 41.8603 20.7151 40.7703V44.9403C20.7151 47.7803 19.2151 51.1503 14.4551 51.1503C10.8451 51.1503 9.06508 49.1303 8.44508 46.9603L2.06508 50.0503C3.66508 54.1503 7.48508 57.5903 14.9051 57.5903C25.9051 57.5903 28.7351 50.1703 28.7351 43.6703V14.5303H22.0051L21.8251 18.7302L21.8051 18.7402ZM14.6951 37.2103C10.7651 37.2103 8.44508 34.0103 8.44508 29.0303C8.44508 24.0503 10.7651 20.8503 14.6951 20.8503C18.6251 20.8503 20.8951 24.0503 20.8951 29.0303C20.8951 34.0103 18.6251 37.2103 14.6951 37.2103Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.8702V69.7603H0.705078V63.9203H22.9951V59.8702H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.0049 0.900269H58.0049V82.2603H59.0049V0.900269Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M129.595 44.9003L121.395 36.5503H132.965V30.1102H121.395L129.595 21.9003L125.055 17.2103L116.705 25.5603V13.8403H110.255V25.5603L102.055 17.2103L97.5049 21.9003L125.055 49.4503L129.595 44.9003Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M92.8249 26.4403L88.2749 30.9802L129.595 72.4503L134.285 67.9103L92.8249 26.4403Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M171.655 25.7103C170.775 24.8303 169.755 24.1003 168.725 23.6603C167.405 23.0703 165.945 22.7803 164.475 22.7803H152.025V54.4303H158.035V42.4103H164.485C165.955 42.4103 167.415 42.1203 168.735 41.5303C169.905 41.0903 170.935 40.3603 171.665 39.3303C172.395 38.4503 173.135 37.4302 173.425 36.2502C173.865 35.0802 174.015 33.9102 174.015 32.7302V31.7003C174.015 30.5303 173.865 29.3603 173.425 28.3303C173.135 27.4503 172.545 26.4303 171.665 25.6903L171.655 25.7103ZM168.135 32.8903C168.135 33.9203 167.695 34.9403 166.965 35.6703C166.085 36.4003 164.915 36.8403 163.885 36.7003H158.025V28.3503H163.885C165.055 28.3503 166.225 28.6402 166.965 29.3802C167.705 30.1202 168.135 31.1403 168.135 32.1603V32.8903Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M193.635 31.4203C192.315 31.4203 191.145 31.7103 189.975 32.4503C188.945 33.1803 188.215 34.2102 187.775 35.3802H186.895V32.1603H177.375V37.5803H181.475V49.1603H176.935V54.5803H192.325V49.1603H187.195V41.9802C187.045 40.6602 187.485 39.3403 188.225 38.1703C188.955 37.2903 190.125 36.8503 191.155 36.8503C192.185 36.7003 193.205 37.1402 193.935 38.0202C194.665 38.9002 194.965 39.9203 194.815 40.9503V41.5403L200.675 40.9503V39.9203C200.675 36.9903 199.945 34.9403 198.625 33.4703C197.595 32.0003 195.545 31.2703 193.645 31.4203H193.635Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M223.235 34.3504C222.205 33.3204 220.895 32.5903 219.575 32.1503C216.795 31.1203 213.565 31.1203 210.785 32.1503C209.465 32.5903 208.145 33.4704 207.125 34.3504C205.955 35.3804 205.225 36.5503 204.485 38.0103C203.895 39.6203 203.455 41.2304 203.605 42.8504V43.4403C203.605 45.2003 203.895 46.8103 204.485 48.4203C205.075 49.7403 205.955 51.0604 207.125 52.0804C208.155 53.1104 209.465 53.8403 210.785 54.2803C213.565 55.3103 216.795 55.3103 219.575 54.2803C220.895 53.8403 222.215 52.9604 223.235 52.0804C224.405 51.0504 225.285 49.8803 225.875 48.4203C226.465 46.8103 226.905 45.2003 226.755 43.4403V42.8504C226.755 41.2404 226.465 39.4803 225.875 38.0103C225.285 36.6903 224.405 35.3704 223.235 34.3504ZM221.035 43.5804C221.035 44.4604 220.885 45.3404 220.595 46.0704C220.005 47.5404 218.835 48.5603 217.375 49.1503C216.645 49.4403 215.905 49.5904 215.035 49.5904C214.305 49.5904 213.425 49.4403 212.695 49.1503C211.225 48.5603 210.055 47.5404 209.475 46.0704C209.325 45.3404 209.185 44.4604 209.185 43.5804V42.7004C209.185 41.8204 209.335 40.9404 209.625 40.2104C210.215 38.7404 211.385 37.7203 212.845 37.1303C214.315 36.5403 215.925 36.5403 217.385 37.1303C218.855 37.7203 220.025 38.7404 220.605 40.2104C220.895 40.9404 221.045 41.8204 221.045 42.7004V43.5804H221.035Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M250.335 34.3503C249.455 33.3203 248.435 32.5903 247.255 32.1503C246.085 31.7103 244.765 31.4203 243.445 31.4203C241.975 31.4203 240.365 31.7103 239.045 32.4503C237.875 33.1803 236.995 34.0602 236.405 35.3802H235.525V32.1603H229.815V63.6603H235.525V51.3503H236.405C236.695 51.9403 236.995 52.3803 237.435 52.8203C237.875 53.2603 238.315 53.7002 238.905 53.9902C239.495 54.4302 240.225 54.7202 240.805 54.8702C243.005 55.4602 245.205 55.3103 247.255 54.4303C248.425 53.9903 249.455 53.1102 250.335 52.2302C251.215 51.2002 251.945 49.8903 252.385 48.5703C252.975 46.9603 253.115 45.3502 253.115 43.7302V42.8503C253.115 41.2403 252.825 39.6303 252.235 38.0103C251.945 36.5403 251.205 35.3703 250.335 34.3503ZM247.555 43.4303C247.705 45.0403 247.115 46.6503 245.945 47.9703C244.775 49.1403 243.305 49.7303 241.695 49.5803C240.085 49.7303 238.475 48.9903 237.445 47.9703C236.275 46.8003 235.685 45.1903 235.835 43.5703V42.9802C235.685 41.3702 236.275 39.7603 237.445 38.5803C238.615 37.4103 240.085 36.8203 241.695 36.8203C243.305 36.6703 244.915 37.4103 245.945 38.4303C247.115 39.6003 247.705 41.2103 247.555 42.9703V43.4103V43.4303Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M276.275 34.9403C275.245 33.9103 274.075 33.0403 272.905 32.3003C271.295 31.5703 269.685 31.2703 267.925 31.2703C266.455 31.2703 264.995 31.5603 263.525 32.1503C262.205 32.7403 261.035 33.4702 260.005 34.4902C258.975 35.5202 258.105 36.6903 257.515 38.1503C256.925 39.6203 256.635 41.2303 256.635 42.8403V43.1302C256.635 44.8902 256.925 46.5002 257.515 48.1102C257.955 49.5802 258.835 50.7503 259.855 51.9203C260.885 52.9503 262.055 53.6803 263.375 54.2603C264.845 54.8503 266.455 55.1403 267.915 55.1403C269.235 55.1403 270.555 54.9903 271.725 54.7003C272.755 54.4103 273.625 53.9702 274.505 53.3802C275.235 52.9402 275.825 52.3502 276.405 51.6202C276.845 51.0302 277.285 50.4502 277.575 49.8602L272.735 47.2203C272.295 47.9503 271.855 48.5402 271.125 48.9802C270.095 49.5702 269.075 49.8603 267.905 49.7103C267.175 49.7103 266.585 49.5603 265.855 49.4203C265.265 49.2703 264.685 48.8303 264.095 48.5403C263.655 48.1003 263.215 47.6603 262.925 47.0703C262.635 46.4803 262.485 45.9003 262.485 45.3103H278.895V42.2302C278.895 41.0602 278.605 39.7403 278.305 38.5703C277.715 37.1003 277.135 35.9303 276.255 34.9103L276.275 34.9403ZM262.505 40.2203C262.795 39.1903 263.385 38.3202 264.265 37.7302C265.295 37.0002 266.465 36.5603 267.785 36.5603C269.105 36.5603 270.275 36.8503 271.305 37.5903C272.185 38.1803 272.775 39.2002 273.065 40.2302H262.515L262.505 40.2203Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M294.885 49.0103V22.7803H281.695V28.2003H289.165V49.0103H281.405V54.4303H302.205V49.0103H294.885Z", fill: "#110041" }));
const SvgTigerGlobal$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 383, height: 82, viewBox: "0 0 383 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.2652C20.0351 15.3252 17.1751 13.6453 12.9751 13.6453C5.11508 13.6953 0.455078 19.9453 0.455078 28.6153C0.455078 37.2853 5.10508 43.5352 12.9751 43.5352C14.4151 43.6152 15.8651 43.3652 17.2051 42.8052C18.5451 42.2452 19.7451 41.3852 20.7151 40.2952V44.4653C20.7151 47.3053 19.2151 50.6752 14.4551 50.6752C10.8451 50.6752 9.06508 48.6553 8.44508 46.4853L2.06508 49.5753C3.66508 53.6753 7.48508 57.1153 14.9051 57.1153C25.9051 57.1153 28.7351 49.6953 28.7351 43.1953V14.0552H22.0051L21.8251 18.2553L21.8051 18.2652ZM14.6951 36.7353C10.7651 36.7353 8.44508 33.5352 8.44508 28.5552C8.44508 23.5752 10.7651 20.3753 14.6951 20.3753C18.6251 20.3753 20.8951 23.5752 20.8951 28.5552C20.8951 33.5352 18.6251 36.7353 14.6951 36.7353Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.3953V69.2853H0.705078V63.4453H22.9951V59.3953H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.0049 0.425171H58.0049V81.7852H59.0049V0.425171Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M104.175 32.2152V47.5752C104.035 49.2652 104.385 50.9652 105.175 52.4652C106.035 53.5152 107.335 54.1152 108.695 54.0652C109.185 54.1052 109.435 54.3552 109.435 54.7952C109.435 55.1152 109.225 55.2651 108.795 55.2651C108.705 55.2651 108.525 55.2652 108.285 55.2452L106.755 55.1852L104.205 55.0151C104.005 55.0051 103.725 54.9952 103.385 54.9952C102.595 54.9952 101.885 55.0152 101.265 55.0552L96.7653 55.3252C96.2853 55.3852 95.9553 55.4052 95.7853 55.4052C95.3653 55.4052 95.1552 55.2252 95.1652 54.8652C95.1452 54.6452 95.2153 54.4351 95.3653 54.2751C95.6153 54.1551 95.8853 54.0952 96.1553 54.0952C97.1053 54.0852 97.9953 53.6652 98.6153 52.9452C99.2353 52.1252 99.5353 51.1052 99.4753 50.0752L99.4553 49.1152V31.0052C99.4553 29.9352 98.8753 29.3951 97.7253 29.3951C95.8453 29.2851 93.9653 29.4952 92.1553 29.9852C91.5853 30.1752 91.0853 30.5252 90.7153 30.9952C90.2853 31.8852 89.9653 32.8252 89.7453 33.7852L89.5753 34.3552C89.4253 34.9152 89.1953 35.1952 88.8853 35.1952C88.4353 35.1952 88.2253 34.9852 88.2553 34.5652C88.2853 34.0352 88.3553 33.5052 88.4553 32.9752L88.6553 31.2052L88.9053 29.3951L89.0552 28.1451C89.0452 27.7151 89.3853 27.3552 89.8153 27.3452C89.8453 27.3452 89.8753 27.3452 89.9053 27.3452C90.0453 27.3452 90.2753 27.3553 90.5953 27.3853C91.1253 27.4253 91.8853 27.4452 92.8653 27.4452L97.0253 27.4852L101.985 27.5452C105.185 27.5452 108.565 27.4551 112.145 27.2751C112.855 27.2451 113.315 27.2352 113.515 27.2352C114.265 27.2352 114.655 27.5552 114.695 28.1752L114.795 29.6451C114.805 29.8751 114.875 30.4352 114.995 31.2952C115.075 31.8752 115.125 32.4552 115.145 33.0352C115.145 33.4852 114.955 33.7052 114.585 33.7052C114.285 33.7052 114.065 33.4452 113.935 32.9252C113.765 31.8352 113.175 30.8452 112.295 30.1752C111.235 29.5452 110.005 29.2552 108.775 29.3352C107.465 29.2252 106.145 29.3852 104.905 29.8152C104.395 30.1252 104.145 30.9152 104.145 32.1852L104.175 32.2152Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M124.815 48.8452L124.975 50.8853C125.075 51.8053 125.495 52.6552 126.165 53.2852C126.855 53.8652 127.745 54.1652 128.645 54.1252C129.315 54.1252 129.645 54.3352 129.645 54.7552C129.645 55.1452 129.205 55.3552 128.315 55.3552C127.935 55.3552 127.395 55.3152 126.685 55.2452C125.255 55.0652 123.825 54.9652 122.385 54.9452C121.305 54.9252 120.225 54.9952 119.155 55.1652C118.675 55.2652 118.185 55.3352 117.685 55.3552C117.415 55.3752 117.165 55.1852 117.115 54.9152L117.075 54.7452L117.665 54.2651C118.435 54.0551 119.125 53.6052 119.615 52.9752C119.995 52.1852 120.155 51.3152 120.095 50.4352L120.115 48.6252V32.3951C120.195 31.4551 119.965 30.5252 119.465 29.7252C118.825 29.0952 117.975 28.7152 117.075 28.6652C116.615 28.6152 116.165 28.5152 115.735 28.3452C115.535 28.2452 115.425 28.0352 115.435 27.8152C115.435 27.4252 115.605 27.2452 115.925 27.2552C116.295 27.2852 116.665 27.3452 117.025 27.4152C117.835 27.5552 118.665 27.6052 119.495 27.5852C120.255 27.5852 121.205 27.5452 122.325 27.4552L123.815 27.3452C125.215 27.2452 126.285 27.1852 127.035 27.1852C127.485 27.1852 127.715 27.3552 127.715 27.6852C127.735 27.8552 127.695 28.0352 127.615 28.1852C127.465 28.3052 127.285 28.3652 127.105 28.3652C126.395 28.4052 125.725 28.6952 125.225 29.1852C124.875 29.9052 124.735 30.7052 124.805 31.5052V48.8452H124.815Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M145.335 26.7852C148.095 26.9052 150.815 27.5751 153.305 28.7651C153.775 28.9951 154.275 29.1652 154.795 29.2552C154.985 29.2552 155.165 29.1852 155.305 29.0552L155.535 28.8452C155.665 28.7152 155.845 28.6352 156.025 28.6252C156.425 28.6052 156.635 28.8552 156.635 29.3552L156.615 30.7852L156.535 33.5852L156.595 35.0552C156.625 35.4152 156.665 35.8152 156.715 36.2352C156.725 36.3952 156.735 36.5252 156.735 36.5952C156.735 37.0352 156.525 37.2452 156.095 37.2152C155.815 37.2052 155.625 36.9152 155.525 36.3652C155.155 34.5552 154.255 32.8852 152.935 31.5852C151.055 29.4552 148.335 28.2552 145.495 28.2852C142.875 28.2152 140.385 29.4352 138.845 31.5552C137.065 34.0952 136.195 37.1652 136.355 40.2552C136.235 43.7052 137.135 47.1152 138.925 50.0652C140.645 52.7252 142.755 54.0452 145.265 54.0452C146.235 54.0052 147.195 53.8352 148.115 53.5452C149.035 53.3152 149.925 52.9452 150.735 52.4652C151.285 52.1052 151.685 51.5552 151.865 50.9152C152.115 49.8852 152.225 48.8251 152.185 47.7651C152.305 46.5651 151.995 45.3653 151.305 44.3853C150.385 43.6353 149.205 43.2552 148.015 43.3152C147.595 43.2852 147.385 43.0852 147.385 42.7152C147.385 42.3452 147.635 42.1451 148.125 42.1451C148.275 42.1451 148.515 42.1652 148.835 42.1852C150.175 42.2952 151.685 42.3652 153.375 42.3652C154.655 42.3852 155.935 42.3352 157.215 42.2252C157.725 42.1452 158.235 42.1052 158.755 42.1052C159.245 42.1052 159.485 42.2851 159.485 42.6451C159.485 42.9751 159.245 43.1952 158.755 43.2852C158.035 43.4052 157.415 43.8752 157.125 44.5552C156.765 45.6652 156.615 46.8352 156.675 47.9952C156.675 48.4452 156.695 48.8952 156.735 49.3352C156.795 50.0152 156.815 50.4852 156.815 50.7552C156.845 51.0852 156.755 51.4152 156.555 51.6852C156.265 51.9552 155.905 52.1551 155.525 52.2651C155.205 52.3751 154.125 52.8353 152.285 53.6353C149.615 54.8953 146.725 55.6052 143.785 55.7352C140.385 55.8452 137.105 54.4852 134.775 52.0052C132.385 49.3752 131.135 45.9052 131.285 42.3552C131.165 38.2852 132.605 34.3151 135.315 31.2751C137.825 28.3751 141.485 26.7352 145.315 26.7952L145.335 26.7852Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M170.215 31.9852V36.4052C170.145 37.2152 170.245 38.0352 170.495 38.8152C170.675 39.1552 171.115 39.3252 171.825 39.3252L172.445 39.3052L173.335 39.2852H175.065C176.465 39.2552 177.705 38.3652 178.185 37.0552L178.655 36.0552C178.765 35.8252 179.005 35.6752 179.265 35.6652C179.565 35.6552 179.715 35.8352 179.715 36.2252C179.715 36.3252 179.695 36.6352 179.655 37.1252C179.625 37.4752 179.615 37.7851 179.615 38.0251C179.615 38.4651 179.675 39.4752 179.795 41.0952C179.875 42.1452 179.915 43.0552 179.915 43.8352L179.945 44.8752C179.955 45.0052 179.935 45.1351 179.875 45.2651C179.795 45.3651 179.675 45.4152 179.555 45.4152C179.215 45.4452 179.005 45.1853 178.915 44.6353C178.815 43.6453 178.385 42.7152 177.695 42.0052C177.335 41.6752 176.885 41.4552 176.395 41.3652C175.445 41.2452 174.485 41.2052 173.525 41.2252H172.135C171.665 41.1752 171.195 41.2851 170.795 41.5251C170.505 41.8551 170.335 42.2752 170.315 42.7152C170.215 43.7852 170.175 44.8652 170.195 45.9352V47.7651C170.135 49.1551 170.285 50.5551 170.645 51.8951C170.855 52.9451 171.855 53.6352 172.915 53.4652C178.435 53.4652 182.045 51.7852 183.745 48.4352C183.835 48.2752 183.925 48.1852 183.985 48.1752C184.125 48.1452 184.275 48.2052 184.365 48.3052C184.475 48.4252 184.545 48.5752 184.535 48.7452C184.535 50.1152 184.155 51.4552 183.455 52.6252C182.955 53.5952 182.175 54.3852 181.215 54.9052C180.095 55.4052 178.875 55.6452 177.645 55.5952C176.675 55.5952 175.705 55.5352 174.745 55.4252L172.375 55.2052C171.505 55.1252 170.335 55.0852 168.845 55.0852C167.855 55.0852 166.345 55.1451 164.315 55.2651C163.755 55.3051 163.355 55.3252 163.115 55.3252C162.865 55.3652 162.625 55.1852 162.585 54.9352C162.585 54.9152 162.585 54.8952 162.585 54.8752C162.585 54.6252 162.725 54.4352 163.035 54.3052C163.625 54.1152 164.165 53.7952 164.615 53.3552C164.975 52.8252 165.195 52.2152 165.275 51.5752C165.445 50.6052 165.525 49.6253 165.505 48.6353V32.4952C165.625 31.4052 165.355 30.3152 164.755 29.4052C163.875 28.7052 162.795 28.3051 161.665 28.2651C161.355 28.2651 161.105 27.9952 161.115 27.6852V27.6652C161.115 27.3452 161.345 27.1852 161.785 27.1852C161.885 27.1852 162.085 27.2052 162.405 27.2252C162.645 27.2452 162.985 27.2452 163.405 27.2452L165.465 27.3352L173.195 27.4152C177.645 27.4152 180.385 27.3552 181.415 27.2352C181.515 27.2252 181.615 27.2152 181.695 27.2152C182.095 27.2152 182.285 27.4353 182.285 27.8853C182.285 28.2053 182.325 28.7652 182.405 29.5652C182.505 30.7452 182.565 31.6052 182.565 32.1152C182.565 33.1452 182.295 33.6752 181.775 33.7052C181.515 33.7252 181.395 33.4152 181.395 32.8052C181.485 31.6252 180.915 30.4952 179.915 29.8552C178.425 29.1452 176.785 28.8352 175.135 28.9452H172.645L171.255 29.1052C170.555 29.3152 170.205 30.0152 170.205 31.1652V32.0052L170.215 31.9852Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M194.815 47.2353C194.685 49.0153 194.935 50.7953 195.535 52.4753C196.125 53.4653 197.195 54.0652 198.355 54.0552C198.925 54.1152 199.205 54.3353 199.205 54.7253C199.205 55.1153 198.975 55.3052 198.515 55.3052C198.365 55.3052 198.085 55.2853 197.675 55.2453C196.505 55.1553 195.375 55.1053 194.285 55.1053C193.375 55.1053 192.565 55.1352 191.855 55.1852L190.145 55.3453L188.775 55.4553C188.395 55.4953 188.125 55.5152 187.985 55.5152C187.495 55.5152 187.255 55.3253 187.255 54.9553C187.225 54.6853 187.405 54.4353 187.665 54.3753C188.405 54.2053 189.085 53.8053 189.585 53.2253C189.985 52.5653 190.175 51.7952 190.115 51.0152V49.0853L190.145 48.2952V33.5652C190.255 32.4352 190.035 31.3052 189.525 30.2952C188.715 29.3052 187.535 28.7152 186.265 28.6552C185.705 28.5752 185.425 28.3352 185.425 27.9452C185.385 27.6652 185.575 27.4053 185.855 27.3653C185.905 27.3653 185.955 27.3653 185.995 27.3653C186.245 27.3653 186.485 27.3852 186.725 27.4252C187.865 27.5452 189.015 27.5953 190.175 27.5953C191.545 27.5953 193.215 27.5153 195.175 27.3653C197.475 27.1853 199.065 27.0953 199.925 27.0953C202.255 27.0053 204.525 27.7553 206.345 29.2053C207.985 30.4753 208.925 32.4452 208.895 34.5152C208.905 35.8252 208.515 37.1152 207.765 38.1852C206.995 39.3052 205.915 40.1752 204.655 40.6952C204.385 40.8052 204.255 40.9453 204.275 41.1053C204.305 41.2853 204.375 41.4553 204.475 41.5953C204.595 41.7853 204.775 42.1052 205.025 42.5552L206.835 45.7752L208.935 49.5053C209.435 50.4753 210.085 51.3553 210.865 52.1253C211.415 52.6153 212.125 52.8753 212.855 52.8553C213.145 52.8553 213.435 52.8352 213.725 52.7752C213.875 52.7352 214.025 52.7153 214.175 52.7153C214.425 52.7153 214.545 52.8752 214.545 53.1852C214.545 53.5752 213.985 54.0252 212.885 54.5252C211.955 54.9852 210.945 55.2352 209.915 55.2752C208.385 55.2052 206.965 54.4553 206.055 53.2153C204.245 50.7953 202.695 48.1852 201.455 45.4252C201.025 44.3752 200.415 43.4052 199.645 42.5652C198.965 42.1052 198.145 41.8853 197.315 41.9653H196.055L195.135 42.1253C194.935 42.2353 194.825 42.5653 194.825 43.1053V47.2353H194.815ZM194.815 31.3152V38.3753C194.745 38.9453 194.865 39.5252 195.155 40.0252C195.635 40.3252 196.195 40.4453 196.755 40.3753C198.255 40.4053 199.765 40.3753 201.265 40.2453C201.875 40.1453 202.445 39.8552 202.895 39.4152C203.915 38.4552 204.465 37.1053 204.385 35.7053C204.505 31.9053 201.525 28.7253 197.725 28.6053C197.565 28.6053 197.415 28.6053 197.255 28.6053C196.565 28.5253 195.875 28.7352 195.345 29.1852C194.925 29.8052 194.735 30.5552 194.815 31.3052V31.3152Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M230.745 26.7852C233.505 26.9052 236.225 27.5751 238.725 28.7651C239.195 28.9951 239.695 29.1652 240.215 29.2552C240.405 29.2552 240.585 29.1852 240.725 29.0552L240.955 28.8452C241.085 28.7152 241.255 28.6352 241.445 28.6252C241.855 28.6052 242.055 28.8552 242.055 29.3552L242.035 30.7852L241.955 33.5852L242.015 35.0552C242.045 35.4152 242.085 35.8152 242.125 36.2352C242.135 36.3952 242.145 36.5252 242.145 36.5952C242.145 37.0352 241.935 37.2452 241.515 37.2152C241.225 37.2052 241.035 36.9152 240.935 36.3652C240.565 34.5552 239.665 32.8852 238.355 31.5852C236.475 29.4552 233.755 28.2552 230.915 28.2852C228.295 28.2152 225.805 29.4352 224.265 31.5552C222.495 34.1052 221.615 37.1652 221.775 40.2552C221.655 43.7052 222.555 47.1152 224.345 50.0652C226.065 52.7252 228.175 54.0452 230.685 54.0452C231.655 54.0052 232.615 53.8352 233.535 53.5452C234.455 53.3152 235.345 52.9452 236.165 52.4652C236.715 52.1052 237.115 51.5552 237.285 50.9152C237.535 49.8852 237.645 48.8251 237.605 47.7651C237.725 46.5651 237.415 45.3653 236.735 44.3853C235.815 43.6353 234.635 43.2552 233.445 43.3152C233.025 43.2852 232.815 43.0852 232.815 42.7152C232.815 42.3452 233.055 42.1451 233.545 42.1451C233.695 42.1451 233.935 42.1652 234.255 42.1852C235.585 42.2952 237.105 42.3652 238.785 42.3652C240.065 42.3852 241.345 42.3352 242.625 42.2252C243.135 42.1452 243.645 42.1052 244.155 42.1052C244.655 42.1052 244.895 42.2851 244.895 42.6451C244.895 42.9751 244.645 43.1952 244.165 43.2852C243.445 43.4052 242.825 43.8752 242.525 44.5552C242.165 45.6652 242.005 46.8352 242.075 47.9952C242.075 48.4452 242.095 48.8952 242.135 49.3352C242.185 50.0152 242.215 50.4852 242.215 50.7552C242.245 51.0852 242.155 51.4152 241.965 51.6852C241.675 51.9552 241.315 52.1551 240.925 52.2651C240.615 52.3751 239.535 52.8353 237.685 53.6353C235.015 54.8953 232.125 55.6052 229.175 55.7352C225.775 55.8452 222.495 54.4852 220.175 52.0052C217.785 49.3752 216.525 45.9052 216.675 42.3552C216.555 38.2852 218.005 34.3151 220.715 31.2751C223.225 28.3651 226.905 26.7252 230.745 26.7952V26.7852Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M255.645 48.8052C255.645 51.3452 255.955 52.7752 256.565 53.0752C257.205 53.2952 257.885 53.3952 258.555 53.3452C263.165 53.3452 266.435 51.9952 268.355 49.2852C268.945 48.4552 269.315 48.0352 269.465 48.0352C269.725 48.0352 269.845 48.3152 269.845 48.8752C269.855 50.5752 269.255 52.2152 268.155 53.5052C267.155 54.7052 265.655 55.3752 264.095 55.3052C263.745 55.3052 263.095 55.2752 262.155 55.2052L259.705 55.0552L257.485 54.9552C256.735 54.9152 255.885 54.8951 254.935 54.8951C253.235 54.8951 251.525 55.0052 249.835 55.2052C249.275 55.2652 248.905 55.2952 248.715 55.2952C248.315 55.2952 248.125 55.1151 248.125 54.7651C248.125 54.5051 248.305 54.3352 248.645 54.2352C249.425 54.0652 250.095 53.5452 250.455 52.8252C250.855 51.7252 251.025 50.5651 250.955 49.3951V32.3853C250.955 30.2153 250.055 28.9852 248.245 28.6952L247.015 28.4952C246.505 28.4152 246.235 28.2052 246.235 27.8752C246.195 27.5752 246.395 27.2952 246.695 27.2552C246.745 27.2552 246.795 27.2552 246.845 27.2552C247.045 27.2552 247.245 27.2852 247.435 27.3152C247.625 27.3252 247.885 27.3551 248.225 27.3951L249.105 27.4552C249.935 27.5352 250.555 27.5752 250.965 27.5752C252.005 27.5452 253.055 27.4652 254.085 27.3352C255.165 27.2252 256.245 27.1652 257.335 27.1652C258.155 27.1652 258.565 27.3652 258.565 27.7452C258.565 28.0752 258.265 28.2652 257.685 28.2852C256.305 28.3752 255.625 29.3252 255.625 31.1152V48.7852L255.645 48.8052Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M286.505 26.7452C290.285 26.5752 293.985 27.9052 296.785 30.4552C299.425 32.9852 300.845 36.5252 300.705 40.1852C300.815 44.2652 299.365 48.2351 296.665 51.2951C294.045 54.2651 290.425 55.7452 285.815 55.7452C281.915 55.9352 278.105 54.5452 275.245 51.8852C272.545 49.1452 271.105 45.3951 271.285 41.5451C271.285 39.6551 271.635 37.7951 272.285 36.0251C273.545 32.3351 276.375 29.3952 280.025 28.0052C282.085 27.1752 284.285 26.7551 286.495 26.7651L286.505 26.7452ZM285.035 28.2751C282.535 28.1651 280.135 29.3052 278.635 31.3152C277.095 33.3452 276.325 36.1651 276.325 39.7851C276.155 43.4751 277.175 47.1252 279.225 50.1952C280.885 52.7252 283.725 54.2352 286.745 54.2052C289.385 54.2752 291.895 53.0352 293.435 50.8852C295.225 48.2852 296.105 45.1751 295.945 42.0251C295.945 39.8851 295.545 37.7651 294.785 35.7751C294.135 33.9451 293.075 32.2851 291.685 30.9251C289.905 29.2051 287.525 28.2451 285.045 28.2751H285.035Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M307.185 33.1852C307.185 30.4452 306.065 28.9452 303.835 28.6852L302.895 28.5652C302.595 28.5352 302.445 28.3353 302.445 27.9853C302.445 27.5753 302.635 27.3753 303.015 27.3753L303.525 27.3952L305.055 27.4853C306.325 27.5453 307.125 27.5652 307.485 27.5652C308.465 27.5652 310.255 27.4452 312.845 27.2152C314.445 27.0652 315.805 26.9853 316.905 26.9853C319.365 26.8653 321.805 27.5153 323.875 28.8553C325.545 29.9553 326.535 31.8352 326.495 33.8352C326.615 36.0352 325.295 38.0552 323.235 38.8252C322.735 39.0452 322.475 39.2353 322.455 39.3753C322.445 39.6153 322.705 39.7853 323.245 39.8653C324.815 40.0953 326.245 40.8852 327.275 42.0952C328.285 43.3452 328.805 44.9152 328.745 46.5252C328.855 48.9552 327.865 51.3052 326.045 52.9152C323.975 54.5652 321.375 55.4052 318.735 55.2652L314.595 55.1452L311.415 55.0852C309.645 55.0752 307.875 55.1552 306.115 55.3252C305.685 55.3752 305.245 55.4052 304.815 55.4052C304.405 55.4052 304.205 55.2253 304.205 54.8653C304.205 54.5653 304.385 54.3752 304.755 54.2952C306.375 54.0252 307.185 52.6252 307.185 50.0852V33.1852ZM311.885 31.4152V37.2752C311.815 37.8952 312.025 38.5052 312.455 38.9552C313.055 39.3352 313.755 39.4952 314.455 39.4352L317.275 39.4953L318.545 39.4352C320.875 39.1452 322.035 37.7553 322.035 35.2553C322.115 33.4253 321.405 31.6353 320.095 30.3553C318.715 29.0753 316.875 28.4053 314.995 28.4853C314.125 28.3853 313.245 28.5952 312.525 29.0852C312.025 29.7552 311.795 30.5952 311.895 31.4252L311.885 31.4152ZM311.885 44.9953V48.3753L311.945 49.1452L312.085 50.8753C312.255 52.8353 313.805 53.8052 316.745 53.8052C319.645 53.8052 321.625 53.1052 322.695 51.7052C323.585 50.4852 324.035 49.0152 324.005 47.5152C324.005 44.3252 322.585 42.3553 319.735 41.6253C317.905 41.1853 316.025 40.9753 314.135 40.9953C313.155 40.9953 312.535 41.2252 312.275 41.6952C311.935 42.7652 311.805 43.8853 311.885 44.9953Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M345.956 29.5852L355.236 50.8853C355.596 51.7953 356.146 52.6252 356.866 53.2852C357.566 53.8452 358.406 54.2152 359.296 54.3452C359.536 54.3852 359.656 54.5752 359.656 54.9252C359.656 55.2952 359.496 55.4752 359.186 55.4652C358.926 55.4452 358.666 55.4052 358.406 55.3452C356.736 55.0652 355.036 54.9452 353.336 54.9952C351.736 54.9352 350.136 55.0452 348.556 55.3152C348.386 55.3652 348.206 55.3952 348.026 55.4052C347.746 55.4452 347.496 55.2452 347.456 54.9652C347.456 54.9152 347.456 54.8752 347.456 54.8252C347.456 54.6352 347.606 54.4853 347.906 54.3853C348.536 54.2053 349.096 53.8552 349.526 53.3652C349.926 52.9452 350.156 52.3952 350.166 51.8152C349.846 50.0652 349.246 48.3652 348.406 46.7952C348.036 46.0052 347.636 45.5552 347.196 45.4452C345.636 45.2652 344.076 45.2051 342.506 45.2651H339.736L337.906 45.5952C337.396 45.8252 336.836 46.7152 336.196 48.2852L335.566 49.8552C335.376 50.2852 335.286 50.7452 335.276 51.2152C335.276 52.9252 336.476 53.9152 338.866 54.1852C339.376 54.2552 339.636 54.4552 339.616 54.7852C339.586 55.1452 339.346 55.3252 338.886 55.3252C338.536 55.3152 338.186 55.2752 337.836 55.2052C337.046 55.0352 336.236 54.9452 335.426 54.9352C334.786 54.9352 333.746 55.0051 332.316 55.1451C331.256 55.2551 330.596 55.3052 330.336 55.3052C329.956 55.3052 329.766 55.1352 329.766 54.8052C329.766 54.5252 329.956 54.3252 330.336 54.1852C331.046 53.9652 331.666 53.5252 332.096 52.9152C332.856 51.6752 333.516 50.3651 334.066 49.0151L339.636 36.1852C340.086 35.1652 340.396 34.4652 340.576 34.0852L342.466 30.1952L343.446 28.2751V28.3352C343.886 27.3052 344.176 26.7852 344.326 26.7852C344.546 26.7852 344.916 27.3552 345.446 28.4952L345.916 29.5852H345.956ZM346.716 42.3352L344.056 36.1052C343.416 34.6152 342.966 33.8752 342.696 33.8752C342.536 33.8752 342.246 34.3552 341.806 35.3152L341.416 36.1652L339.036 41.5952L338.806 42.0952C338.716 42.2552 338.666 42.4352 338.656 42.6252C338.656 43.0752 339.146 43.3152 340.116 43.3152H346.136C346.646 43.3152 346.916 43.1753 346.916 42.8853C346.896 42.7653 346.866 42.6552 346.816 42.5452L346.716 42.3152V42.3352Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M368.775 48.8052C368.775 51.3452 369.075 52.7752 369.695 53.0752C370.335 53.3052 371.005 53.3952 371.685 53.3452C376.295 53.3452 379.565 51.9952 381.485 49.2852C382.075 48.4552 382.455 48.0352 382.605 48.0352C382.855 48.0352 382.975 48.3152 382.975 48.8752C382.985 50.5752 382.385 52.2152 381.285 53.5052C380.285 54.7052 378.785 55.3652 377.225 55.3052C376.865 55.3052 376.225 55.2752 375.285 55.2052L372.835 55.0552L370.615 54.9552C369.875 54.9152 369.015 54.8951 368.065 54.8951C366.365 54.8951 364.655 55.0052 362.965 55.2052C362.405 55.2652 362.035 55.2952 361.835 55.2952C361.445 55.2952 361.245 55.1151 361.245 54.7651C361.245 54.5051 361.425 54.3352 361.775 54.2352C362.555 54.0552 363.225 53.5452 363.585 52.8252C363.985 51.7252 364.145 50.5651 364.075 49.3951V32.3853C364.075 30.2153 363.175 28.9852 361.365 28.6952L360.145 28.4952C359.625 28.4152 359.365 28.2052 359.365 27.8752C359.325 27.5752 359.525 27.2952 359.825 27.2552C359.875 27.2552 359.925 27.2552 359.985 27.2552C360.185 27.2552 360.375 27.2852 360.575 27.3152C360.765 27.3252 361.035 27.3551 361.365 27.3951L362.245 27.4552C363.075 27.5352 363.695 27.5852 364.105 27.5752C364.755 27.5752 365.805 27.4952 367.235 27.3352C368.315 27.2252 369.395 27.1652 370.475 27.1652C371.295 27.1652 371.705 27.3652 371.705 27.7452C371.705 28.0752 371.405 28.2652 370.825 28.2852C369.455 28.3752 368.765 29.3252 368.765 31.1152V48.7852L368.775 48.8052Z", fill: "#545456" }));
const SvgXfund$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 158, height: 82, viewBox: "0 0 158 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.8051 18.0027C20.0351 15.0627 17.1751 13.3827 12.9751 13.3827C5.11508 13.4327 0.455078 19.6827 0.455078 28.3527C0.455078 37.0227 5.10508 43.2727 12.9751 43.2727C14.4151 43.3527 15.8651 43.1027 17.2051 42.5427C18.5451 41.9827 19.7451 41.1227 20.7151 40.0327V44.2028C20.7151 47.0428 19.2151 50.4127 14.4551 50.4127C10.8451 50.4127 9.06508 48.3928 8.44508 46.2228L2.06508 49.3127C3.66508 53.4127 7.48508 56.8527 14.9051 56.8527C25.9051 56.8527 28.7351 49.4327 28.7351 42.9327V13.7927H22.0051L21.8251 17.9927L21.8051 18.0027ZM14.6951 36.4728C10.7651 36.4728 8.44508 33.2727 8.44508 28.2927C8.44508 23.3127 10.7651 20.1127 14.6951 20.1127C18.6251 20.1127 20.8951 23.3127 20.8951 28.2927C20.8951 33.2727 18.6251 36.4728 14.6951 36.4728Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.7251 59.1327V69.0227H0.705078V63.1827H22.9951V59.1327H28.7151H28.7251Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.9951 0.16272H57.9951V81.5227H58.9951V0.16272Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M88.2749 5.95276V75.3328H157.655V5.95276H88.2749ZM152.655 70.3328H93.2849V10.9628H152.655V70.3328Z", fill: "#CF0024" }), /* @__PURE__ */ React.createElement("path", { d: "M110.465 58.6427L116.715 48.6927L122.965 58.6427H132.825L121.675 40.7927L132.825 23.0527H122.805L116.715 32.8328L110.615 23.0527H100.605L111.745 40.7927L100.605 58.6427H110.465Z", fill: "#CF0024" }), /* @__PURE__ */ React.createElement("path", { d: "M141.935 58.6427L141.605 41.1427H145.235V33.9927H141.695L141.675 32.4528C141.675 32.4528 141.445 29.8827 144.385 29.8827H144.835V22.5427C144.835 22.5427 132.965 21.2628 132.965 32.5728V33.7527L133.285 58.6427H141.935Z", fill: "#CF0024" }));
const SvgAmex = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 477, height: 82, viewBox: "0 0 477 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M469.17 53.23H463.4C462.12 53.23 461.32 52.43 461.32 51.31C461.32 50.19 462.28 49.55 463.4 49.55H473.82L476.23 44.26H463.4C458.11 44.26 455.06 47.47 455.06 51.64C455.06 56.13 457.95 58.7 462.6 58.7H468.37C469.65 58.7 470.45 59.5 470.45 60.62C470.45 61.74 469.65 62.54 468.37 62.54H455.86V67.83H468.37C473.66 67.83 476.71 64.78 476.71 60.29C476.71 55.8 473.98 53.23 469.17 53.23Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M446.24 53.23H440.47C439.19 53.23 438.39 52.43 438.39 51.31C438.39 50.19 439.35 49.55 440.47 49.55H450.89L453.3 44.26H440.47C435.18 44.26 432.13 47.47 432.13 51.64C432.13 56.13 435.02 58.7 439.67 58.7H445.44C446.72 58.7 447.52 59.5 447.52 60.62C447.52 61.74 446.72 62.54 445.44 62.54H432.93V67.83H445.44C450.73 67.83 453.78 64.78 453.78 60.29C453.78 55.8 451.05 53.23 446.24 53.23Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M409.68 67.66H429.4V62.37H415.93V58.52H429.08V53.23H415.93V49.54H429.4V44.25H409.68V67.66Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M406.47 51.78C406.47 47.29 403.26 44.24 398.13 44.24H384.66V67.65H390.91V59.47H393.16L400.22 67.65H407.92L400.22 59.15C404.07 58.35 406.47 55.46 406.47 51.77V51.78ZM397.33 54.19H390.75V49.54H397.33C399.25 49.54 400.22 50.66 400.22 51.95C400.06 53.23 399.1 54.2 397.33 54.2V54.19Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M373.43 44.25H359.8V67.66H366.05V59.96H373.27C378.56 59.96 381.77 56.59 381.77 52.1C381.77 47.61 378.56 44.24 373.43 44.24V44.25ZM372.79 54.67H366.05V49.54H372.79C374.71 49.54 375.68 50.66 375.68 52.11C375.52 53.55 374.56 54.68 372.79 54.68V54.67Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M358.68 44.25H350.66L344.57 51.3L338.47 44.25H330.29L340.56 55.79L330.13 67.66H338.15L344.41 60.28L350.82 67.66H359L348.41 55.63L358.68 44.25Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M309.45 67.66H329.17V62.37H315.7V58.52H328.85V53.23H315.7V49.54H329.17V44.25H309.45V67.66Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M466.8 28.17L457.11 13.8H449.2V37.38H455.5V22.36L465.35 37.38H472.94V13.8H466.8V28.17Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M429.5 13.8L419.17 37.37H426.11L428.05 32.53H439.03L441.13 37.37H448.23L437.57 13.8H429.5ZM430.15 27.36L433.38 19.45L436.61 27.36H430.15Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M408.84 25.75V25.27C408.84 21.72 410.78 19.3 414.81 19.3H421.91V13.81H414.32C406.57 13.81 402.53 18.82 402.53 25.27V25.75C402.53 33.02 407.05 37.21 413.99 37.21H416.09L418.67 31.88H414.96C411.25 32.04 408.82 29.94 408.82 25.74L408.84 25.75Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M399.31 13.8H393.01V37.37H399.31V13.8Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M389.62 21.39C389.62 16.87 386.39 13.8 381.22 13.8H367.66V37.37H373.96V29.14H376.22L383.32 37.37H391.23L383.48 28.81C387.36 28 389.62 25.1 389.62 21.38V21.39ZM380.42 23.81H373.8V19.13H380.42C382.36 19.13 383.33 20.26 383.33 21.55C383.33 22.84 382.36 23.81 380.42 23.81Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M343.6 37.38H363.46V32.05H349.9V28.17H363.14V22.85H349.9V19.13H363.46V13.8H343.6V37.38Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M323.58 28.66L318.25 13.8H308.4V37.38H314.54V20.42L320.68 37.38H326.33L332.62 20.42V37.38H338.76V13.8H328.91L323.58 28.66Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M288.54 13.8L278.21 37.37H285.15L287.09 32.53H298.07L300.17 37.37H307.27L296.77 13.8H288.54ZM289.35 27.36L292.58 19.45L295.81 27.36H289.35Z", fill: "#006ED6" }), /* @__PURE__ */ React.createElement("path", { d: "M248.93 0H247.93V81.36H248.93V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.4C19.58 27.46 16.72 25.78 12.52 25.78C4.66 25.83 0 32.08 0 40.75C0 49.42 4.65 55.67 12.52 55.67C13.96 55.75 15.41 55.5 16.75 54.94C18.09 54.38 19.29 53.52 20.26 52.43V56.6C20.26 59.44 18.76 62.81 14 62.81C10.39 62.81 8.61 60.79 7.99 58.62L1.6 61.71C3.2 65.81 7.02 69.25 14.44 69.25C25.44 69.25 28.27 61.83 28.27 55.33V26.2H21.54L21.36 30.4H21.35ZM14.24 48.87C10.31 48.87 7.99 45.67 7.99 40.69C7.99 35.71 10.31 32.51 14.24 32.51C18.17 32.51 20.44 35.71 20.44 40.69C20.44 45.67 18.17 48.87 14.24 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.73C176.63 25.73 175.11 26.07 173.73 26.75C172.34 27.43 171.12 28.41 170.16 29.64L169.64 26.2H162.53V55.22H170.83V38.84C170.83 34.31 172.51 32.54 175.84 32.54C178.16 32.54 180.08 33.57 180.08 37.99V55.23H188.38V36.3C188.38 30.17 184.58 25.75 178.16 25.75L178.17 25.73Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.57C49.6201 46.55 47.9401 48.88 44.6201 48.88C42.3001 48.88 40.3601 47.85 40.3601 43.43V26.2H32.0601V45.09C32.0601 51.21 35.8601 55.66 42.2801 55.66C43.8201 55.66 45.3401 55.31 46.7301 54.63C48.1201 53.95 49.3401 52.96 50.3001 51.74L50.8201 55.19H57.9101V26.2H49.6101V42.57H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.2H62.2798V55.22H70.5798V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6098 28.33C91.5998 26.6 89.0198 25.72 86.3898 25.88C78.4898 25.88 73.8198 32.14 73.8198 40.8C73.8198 49.46 78.4898 55.72 86.3898 55.72C88.0698 55.83 89.7498 55.49 91.2598 54.73C92.7698 53.97 94.0598 52.82 94.9998 51.39L95.1998 55.21H101.93V12.73H93.6298L93.5898 28.33H93.6098ZM88.2098 48.87C84.2798 48.87 81.9598 45.67 81.9598 40.69C81.9598 35.71 84.2798 32.51 88.2098 32.51C92.1398 32.51 94.4598 35.71 94.4598 40.69C94.4598 45.67 92.1398 48.87 88.2098 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4399 12.03C65.5199 12.03 64.6299 12.31 63.8699 12.82C63.1099 13.34 62.5199 14.07 62.1599 14.94C61.8099 15.8 61.7199 16.75 61.8999 17.66C62.0799 18.57 62.5199 19.41 63.1699 20.07C63.8199 20.73 64.6399 21.18 65.5399 21.36C66.4399 21.54 67.3699 21.45 68.2099 21.09C69.0599 20.73 69.7799 20.13 70.2899 19.35C70.7999 18.57 71.0699 17.66 71.0699 16.73C71.0699 15.48 70.5799 14.28 69.7099 13.4C68.8399 12.52 67.6599 12.02 66.4399 12.02V12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.15 26.2H149.85V55.22H158.15V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.03C153.08 12.03 152.19 12.31 151.43 12.82C150.67 13.34 150.08 14.07 149.72 14.94C149.37 15.8 149.28 16.75 149.46 17.66C149.64 18.57 150.08 19.41 150.73 20.07C151.38 20.73 152.2 21.18 153.1 21.36C154 21.54 154.93 21.45 155.77 21.09C156.62 20.73 157.34 20.13 157.85 19.35C158.36 18.57 158.63 17.66 158.63 16.73C158.63 15.48 158.14 14.28 157.27 13.4C156.4 12.52 155.22 12.02 154 12.02V12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 41.63V40.75C218.64 31.79 213.59 25.83 205.26 25.83C196.93 25.83 191.32 31.79 191.32 40.75C191.32 49.71 196.94 55.67 205.26 55.67C211.02 55.67 215.31 52.88 217.35 48.17L211.34 45.27C210.95 46.53 210.16 47.61 209.1 48.37C208.04 49.13 206.77 49.51 205.47 49.46C203.94 49.5 202.44 48.95 201.3 47.91C200.16 46.87 199.44 45.42 199.31 43.87H199.37L218.65 41.64L218.64 41.63ZM199.1 38.7C199.1 34.49 201.57 31.73 205.23 31.73C206.74 31.7 208.2 32.27 209.32 33.3C210.44 34.34 211.12 35.77 211.24 37.3L199.1 38.7Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.83C110.47 25.83 104.85 31.79 104.85 40.75C104.85 49.71 110.47 55.67 118.8 55.67C124.55 55.67 128.84 52.88 130.82 48.17L124.81 45.27C124.42 46.51 123.65 47.58 122.61 48.34C121.57 49.09 120.32 49.49 119.05 49.46C117.5 49.53 115.99 48.98 114.83 47.94C113.67 46.9 112.94 45.44 112.81 43.87L132.05 41.62V40.74C132.17 31.8 127.12 25.84 118.8 25.84V25.83ZM112.61 38.71C112.61 34.5 115.02 31.74 118.75 31.74C120.26 31.71 121.72 32.28 122.84 33.31C123.96 34.35 124.64 35.78 124.76 37.31L112.6 38.71H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.3 46.47V12.73H135V47.33C135 51.35 135.79 55.54 142.82 55.54C144.15 55.61 145.48 55.39 146.72 54.88V48.4C146.72 48.4 143.3 49.28 143.3 46.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.66 62.84H33.04V75.57H0.25V81.41H38.77V68.67H218.66V62.84Z", fill: "#5532FA" }));
const SvgBoxGroup = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 457, height: 83, viewBox: "0 0 457 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.609985H248.185V81.97H249.185V0.609985Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 31C19.8349 28.06 16.9749 26.38 12.7749 26.38C4.91488 26.43 0.254883 32.68 0.254883 41.35C0.254883 50.02 4.90488 56.27 12.7749 56.27C14.2149 56.35 15.6649 56.1 17.0049 55.54C18.3449 54.98 19.5449 54.12 20.5149 53.03V57.2C20.5149 60.04 19.0149 63.41 14.2549 63.41C10.6449 63.41 8.86488 61.39 8.24488 59.22L1.85488 62.31C3.45488 66.41 7.27488 69.85 14.6949 69.85C25.6949 69.85 28.5249 62.43 28.5249 55.93V26.79H21.7949L21.6149 30.99L21.6049 31ZM14.4949 49.47C10.5649 49.47 8.24488 46.27 8.24488 41.29C8.24488 36.31 10.5649 33.11 14.4949 33.11C18.4249 33.11 20.6949 36.31 20.6949 41.29C20.6949 46.27 18.4249 49.47 14.4949 49.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 26.34C176.885 26.34 175.365 26.68 173.985 27.36C172.595 28.04 171.375 29.02 170.415 30.25L169.895 26.81H162.785V55.83H171.085V39.45C171.085 34.92 172.765 33.15 176.095 33.15C178.415 33.15 180.335 34.18 180.335 38.6V55.84H188.635V36.91C188.635 30.78 184.835 26.36 178.415 26.36L178.425 26.34Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 43.17C49.8749 47.15 48.1949 49.48 44.8749 49.48C42.5549 49.48 40.6149 48.45 40.6149 44.03V26.8H32.3149V45.69C32.3149 51.81 36.1149 56.26 42.5349 56.26C44.0749 56.26 45.5949 55.91 46.9849 55.23C48.3749 54.55 49.5949 53.56 50.5549 52.34L51.0749 55.79H58.1649V26.8H49.8649V43.17H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 26.8H62.5347V55.82H70.8347V26.8Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.8647 28.93C91.8547 27.2 89.2747 26.32 86.6447 26.48C78.7447 26.48 74.0747 32.74 74.0747 41.4C74.0747 50.06 78.7447 56.32 86.6447 56.32C88.3247 56.43 90.0047 56.09 91.5147 55.33C93.0247 54.57 94.3147 53.42 95.2547 51.99L95.4547 55.81H102.185V13.33H93.8847L93.8447 28.93H93.8647ZM88.4647 49.47C84.5347 49.47 82.2147 46.27 82.2147 41.29C82.2147 36.31 84.5347 33.11 88.4647 33.11C92.3947 33.11 94.7147 36.31 94.7147 41.29C94.7147 46.27 92.3947 49.47 88.4647 49.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6948 12.64C65.7748 12.64 64.8848 12.92 64.1248 13.43C63.3648 13.95 62.7748 14.68 62.4148 15.55C62.0648 16.41 61.9748 17.36 62.1548 18.27C62.3348 19.18 62.7748 20.02 63.4248 20.68C64.0748 21.34 64.8948 21.79 65.7948 21.97C66.6948 22.15 67.6248 22.06 68.4648 21.7C69.3148 21.34 70.0348 20.74 70.5448 19.96C71.0548 19.18 71.3248 18.27 71.3248 17.34C71.3248 16.09 70.8348 14.89 69.9648 14.01C69.0948 13.13 67.9148 12.63 66.6948 12.63V12.64Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.405 26.8H150.105V55.82H158.405V26.8Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.64C153.335 12.64 152.445 12.92 151.685 13.43C150.925 13.95 150.335 14.68 149.975 15.55C149.625 16.41 149.535 17.36 149.715 18.27C149.895 19.18 150.335 20.02 150.985 20.68C151.635 21.34 152.455 21.79 153.355 21.97C154.255 22.15 155.185 22.06 156.025 21.7C156.875 21.34 157.595 20.74 158.105 19.96C158.615 19.18 158.885 18.27 158.885 17.34C158.885 16.09 158.395 14.89 157.525 14.01C156.655 13.13 155.475 12.63 154.255 12.63V12.64Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.895 42.24V41.36C218.895 32.4 213.845 26.44 205.515 26.44C197.185 26.44 191.575 32.4 191.575 41.36C191.575 50.32 197.195 56.28 205.515 56.28C211.275 56.28 215.565 53.49 217.605 48.78L211.595 45.88C211.205 47.14 210.415 48.22 209.355 48.98C208.295 49.74 207.025 50.12 205.725 50.07C204.195 50.11 202.695 49.56 201.555 48.52C200.415 47.48 199.695 46.03 199.565 44.48H199.625L218.905 42.25L218.895 42.24ZM199.355 39.31C199.355 35.1 201.825 32.34 205.485 32.34C206.995 32.31 208.455 32.88 209.575 33.91C210.695 34.95 211.375 36.38 211.495 37.91L199.355 39.31Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 26.44C110.725 26.44 105.105 32.4 105.105 41.36C105.105 50.32 110.725 56.28 119.055 56.28C124.805 56.28 129.095 53.49 131.075 48.78L125.065 45.88C124.675 47.12 123.905 48.19 122.865 48.95C121.825 49.7 120.575 50.1 119.305 50.07C117.755 50.14 116.245 49.59 115.085 48.55C113.925 47.51 113.195 46.05 113.065 44.48L132.305 42.23V41.35C132.425 32.41 127.375 26.45 119.055 26.45V26.44ZM112.865 39.32C112.865 35.11 115.275 32.35 119.005 32.35C120.515 32.32 121.975 32.89 123.095 33.92C124.215 34.96 124.895 36.39 125.015 37.92L112.855 39.32H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.555 47.08V13.34H135.255V47.94C135.255 51.96 136.045 56.15 143.075 56.15C144.405 56.22 145.735 56 146.975 55.49V49.01C146.975 49.01 143.555 49.89 143.555 47.08Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.915 63.45H33.2949V76.18H0.504883V82.02H39.0249V69.28H218.915V63.45Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M311.705 6.67999H278.465V39.92H311.705V6.67999Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M347.845 6.67999H314.605V39.92H347.845V6.67999Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M383.985 6.67999H350.745V39.92H383.985V6.67999Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M311.705 42.82H278.465V76.06H311.705V42.82Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M347.845 42.82H314.605V76.06H347.845V42.82Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M383.985 42.82H350.745V76.06H383.985V42.82Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M420.125 42.82H386.885V76.06H420.125V42.82Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M456.265 42.82H423.025V76.06H456.265V42.82Z", fill: "#3454CE" }), /* @__PURE__ */ React.createElement("path", { d: "M298.715 22.95C298.655 22.93 298.645 22.85 298.705 22.83C299.835 22.32 301.035 21.25 301.035 19.01C301.035 14.77 295.515 14.83 295.515 14.83H288.485V31.89H295.735C298.745 31.89 301.755 30.55 301.755 26.98C301.755 23.95 299.415 23.13 298.715 22.95ZM292.415 18.07H295.525C295.525 18.07 297.205 18.13 297.205 19.83C297.205 21.53 295.365 21.59 295.365 21.59H292.415V18.06V18.07ZM295.615 28.47H292.415V24.63H295.795C295.795 24.63 297.625 24.7 297.625 26.55C297.625 28.4 295.615 28.47 295.615 28.47Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M331.455 14.32C325.945 14.32 322.005 18.07 322.005 23.37C322.005 28.67 325.935 32.42 331.455 32.42C336.975 32.42 340.905 28.67 340.905 23.37C340.905 18.07 336.975 14.32 331.455 14.32ZM331.455 28.59C328.615 28.59 326.595 26.42 326.595 23.37C326.595 20.32 328.615 18.15 331.455 18.15C334.295 18.15 336.315 20.32 336.315 23.37C336.315 26.42 334.295 28.59 331.455 28.59Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M367.365 50.14C361.855 50.14 357.915 53.89 357.915 59.19C357.915 64.49 361.845 68.24 367.365 68.24C372.885 68.24 376.815 64.49 376.815 59.19C376.815 53.89 372.885 50.14 367.365 50.14ZM367.365 64.41C364.525 64.41 362.505 62.24 362.505 59.19C362.505 56.14 364.525 53.97 367.365 53.97C370.205 53.97 372.225 56.14 372.225 59.19C372.225 62.24 370.205 64.41 367.365 64.41Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M369.825 22.99L375.275 14.83H370.395L367.115 19.74L363.835 14.83H358.945L364.405 22.99L358.175 31.89H363.445L367.045 25.82L367.115 25.76L367.175 25.82L370.775 31.89H376.045L369.825 22.99Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M328.495 64.55V60.97H329.875L333.665 67.98H338.545L334.055 60.59C334.055 60.59 337.455 60.17 337.455 55.92C337.455 50.91 332.355 50.91 332.355 50.91H324.555V67.97H328.495V64.55ZM328.495 54.15H331.605C331.605 54.15 333.285 54.21 333.285 55.91C333.285 57.61 331.445 57.67 331.445 57.67H328.495V54.14V54.15Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M441.935 60.84C441.935 60.84 445.335 60.17 445.335 55.92C445.335 50.91 440.235 50.91 440.235 50.91H432.435V67.97H436.375V61.22C440.835 61.22 441.935 60.83 441.935 60.83V60.84ZM436.375 54.15H439.485C439.485 54.15 441.355 54.15 441.355 56.2C441.355 57.9 439.325 58.21 439.325 58.21H436.375V54.14V54.15Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M300.985 55.62L303.595 52.59C303.595 52.59 301.365 50.19 297.055 50.19C292.745 50.19 287.655 53.16 287.655 59.29C287.655 64.81 291.515 68.26 297.085 68.26C300.325 68.26 302.385 67.47 303.645 66.81V57.89H296.705V60.94H299.875V64.11C299.875 64.11 298.805 64.76 297.375 64.76C295.585 64.76 291.945 63.84 291.945 59.33C291.945 59.33 291.975 54.02 297.105 53.87C297.105 53.87 299.115 53.8 300.985 55.6V55.62Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M406.885 50.91V61.66C406.885 61.66 406.785 64.7 403.605 64.7C400.425 64.7 400.325 61.66 400.325 61.66V50.91H396.345V61.73C396.345 68.21 403.605 68.23 403.605 68.23C403.605 68.23 410.865 68.2 410.865 61.73V50.91H406.885Z", fill: "white" }));
const SvgFelicis = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 513, height: 82, viewBox: "0 0 513 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.219971H248.185V81.58H249.185V0.219971Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M438.255 18.97C438.245 18.52 438.325 18.07 438.485 17.66C438.645 17.24 438.885 16.86 439.195 16.54C439.505 16.22 439.875 15.96 440.275 15.79C440.685 15.61 441.115 15.52 441.565 15.52C442.015 15.5 442.475 15.58 442.895 15.75C443.315 15.92 443.705 16.17 444.035 16.49C444.365 16.81 444.625 17.19 444.795 17.62C444.975 18.04 445.065 18.5 445.065 18.96C445.065 19.42 444.975 19.88 444.795 20.3C444.615 20.72 444.355 21.11 444.035 21.43C443.705 21.75 443.325 22 442.895 22.17C442.475 22.34 442.015 22.41 441.565 22.4C441.125 22.4 440.695 22.31 440.285 22.14C439.885 21.97 439.515 21.72 439.205 21.4C438.895 21.08 438.655 20.71 438.495 20.29C438.335 19.88 438.255 19.44 438.255 18.99V18.97Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M360.415 15.59C360.415 14.56 360.905 14 361.585 14H389.505C389.665 14 389.815 14.03 389.955 14.09C390.095 14.15 390.225 14.24 390.335 14.35C390.445 14.46 390.535 14.6 390.585 14.74C390.645 14.89 390.675 15.04 390.675 15.2V18.72C390.675 19.04 390.555 19.34 390.335 19.56C390.115 19.78 389.815 19.91 389.505 19.91H366.785V34.43H382.205C382.515 34.43 382.805 34.57 383.025 34.79C383.245 35.01 383.365 35.31 383.375 35.62V39.07C383.375 39.38 383.235 39.68 383.025 39.9C382.805 40.12 382.515 40.25 382.205 40.26H366.785V54.79C366.775 55.1 366.645 55.4 366.425 55.62C366.205 55.84 365.915 55.97 365.605 55.98H361.585C361.335 55.98 361.085 55.91 360.875 55.77C360.665 55.63 360.505 55.42 360.415 55.18V15.56V15.59Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M401.995 25.77C409.415 25.77 415.045 31.36 415.045 39.09C415.045 39.59 414.985 40.6 414.915 41.1C414.895 41.44 414.745 41.75 414.505 41.98C414.265 42.21 413.945 42.34 413.615 42.35H393.895C393.955 46.24 397.415 50.27 402.425 50.27C405.705 50.27 407.685 49.08 409.415 47.82C410.035 47.38 410.585 47.19 411.085 47.94L412.755 50.58C413.245 51.21 413.495 51.77 412.625 52.52C410.585 54.36 406.815 56.12 402.045 56.12C393.375 56.12 387.745 49.21 387.745 40.92C387.765 32.74 393.385 25.76 401.985 25.76L401.995 25.77ZM408.925 37.7C408.795 34.18 406.075 31.1 401.875 31.1C397.365 31.1 394.635 34.05 394.205 37.7H408.925Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M438.455 27.79C438.465 27.43 438.615 27.09 438.865 26.83C439.115 26.57 439.455 26.42 439.805 26.41H443.275C443.625 26.43 443.955 26.59 444.205 26.84C444.455 27.09 444.605 27.43 444.635 27.79V54.04C444.625 54.4 444.475 54.75 444.225 55C443.975 55.26 443.635 55.41 443.275 55.42H439.805C439.445 55.42 439.105 55.27 438.845 55.01C438.585 54.75 438.445 54.4 438.445 54.04V27.79H438.455Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M464.915 25.77C469.365 25.77 472.645 27.47 475.315 30.8C475.435 30.95 475.525 31.12 475.585 31.31C475.635 31.5 475.655 31.69 475.635 31.89C475.615 32.08 475.555 32.27 475.455 32.44C475.355 32.61 475.225 32.76 475.075 32.87L472.835 34.95C472.025 35.7 471.475 35.14 470.985 34.64C469.685 33.2 467.395 31.75 465.115 31.75C460.225 31.75 456.445 35.77 456.445 40.92C456.445 46.07 460.155 50.16 464.915 50.16C468.625 50.16 470.115 48.03 471.655 46.58C471.765 46.44 471.905 46.32 472.065 46.24C472.225 46.16 472.405 46.11 472.585 46.09C472.765 46.08 472.945 46.1 473.115 46.17C473.285 46.23 473.435 46.33 473.565 46.46L475.475 48.03C476.155 48.66 476.465 49.35 475.975 50.1C474.775 51.98 473.125 53.52 471.175 54.57C469.235 55.63 467.055 56.16 464.845 56.13C456.865 56.13 450.255 49.72 450.255 40.99C450.255 32.26 456.995 25.77 464.905 25.77H464.915Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M481.245 27.79C481.255 27.43 481.405 27.08 481.655 26.83C481.905 26.57 482.245 26.42 482.605 26.41H486.075C486.425 26.43 486.765 26.59 487.005 26.84C487.255 27.09 487.405 27.43 487.435 27.79V54.04C487.425 54.4 487.275 54.75 487.025 55C486.775 55.26 486.435 55.41 486.075 55.42H482.605C482.245 55.42 481.905 55.27 481.645 55.01C481.395 54.75 481.245 54.4 481.245 54.04V27.79Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M492.895 53.16C492.645 53.02 492.455 52.78 492.365 52.5C492.275 52.22 492.285 51.92 492.405 51.65L493.705 48.95C494.015 48.32 494.815 48.13 495.555 48.57C497.225 49.51 499.265 50.7 502.665 50.7C505.075 50.7 506.435 49.51 506.435 47.87C506.435 45.93 504.275 44.67 500.315 42.84C495.925 40.83 492.585 38.44 492.585 33.67C492.585 30.03 495.115 25.75 502.045 25.75C506.005 25.75 508.975 26.95 510.395 27.89C510.735 28.11 510.985 28.45 511.095 28.84C511.205 29.23 511.175 29.65 511.015 30.02L510.025 32.03C509.945 32.19 509.825 32.34 509.685 32.46C509.545 32.58 509.385 32.67 509.215 32.72C509.045 32.77 508.865 32.79 508.685 32.77C508.505 32.75 508.335 32.69 508.175 32.6C506.255 31.68 504.175 31.19 502.055 31.16C499.585 31.16 498.405 32.41 498.405 33.73C498.405 35.61 500.445 36.74 503.285 38C508.545 40.26 512.505 42.21 512.505 47.61C512.505 52.15 508.665 56.11 502.305 56.11C498.945 56.11 495.665 55.07 492.905 53.14L492.895 53.16Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M480.975 18.97C480.965 18.52 481.045 18.07 481.205 17.66C481.365 17.24 481.605 16.86 481.915 16.54C482.225 16.22 482.595 15.96 482.995 15.79C483.405 15.61 483.835 15.52 484.285 15.52C484.735 15.5 485.195 15.58 485.615 15.75C486.035 15.92 486.425 16.17 486.755 16.49C487.085 16.81 487.345 17.19 487.515 17.62C487.695 18.04 487.785 18.5 487.785 18.96C487.785 19.42 487.695 19.88 487.515 20.3C487.335 20.72 487.075 21.11 486.755 21.43C486.425 21.75 486.045 22 485.615 22.17C485.195 22.34 484.735 22.41 484.285 22.4C483.845 22.4 483.415 22.31 483.005 22.14C482.605 21.97 482.235 21.72 481.925 21.4C481.615 21.08 481.375 20.71 481.215 20.29C481.055 19.88 480.975 19.44 480.975 18.99V18.97Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M432.575 54.7C432.575 54.9 432.535 55.09 432.455 55.27C432.375 55.45 432.265 55.61 432.125 55.74C431.985 55.87 431.815 55.97 431.635 56.04C431.455 56.1 431.255 56.13 431.065 56.11C427.295 55.77 424.445 54.09 422.505 51.07C421.165 48.94 420.495 45.87 420.495 41.86V18.4C420.495 18.22 420.535 18.03 420.605 17.86C420.675 17.69 420.775 17.53 420.905 17.4C421.035 17.27 421.185 17.17 421.355 17.09C421.525 17.02 421.705 16.98 421.885 16.98H425.275C425.455 16.98 425.635 17.02 425.805 17.09C425.975 17.16 426.125 17.26 426.255 17.4C426.385 17.53 426.485 17.69 426.555 17.86C426.625 18.03 426.665 18.21 426.665 18.4V41.86C426.665 44.59 427.035 46.55 427.775 47.74C428.505 48.99 429.705 49.72 431.355 49.94C431.685 49.98 431.995 50.15 432.225 50.4C432.445 50.66 432.575 50.99 432.575 51.33V54.7Z", fill: "#968B83" }), /* @__PURE__ */ React.createElement("path", { d: "M335.585 39.16C331.995 40.67 327.085 40.22 311.985 33.88C318.245 18.54 321.395 14.7 324.985 13.2C328.565 11.7 333.215 12.99 335.245 17.97C335.815 19.26 336.195 20.62 336.355 22.03C336.385 22.53 336.495 23.03 336.685 23.49C336.875 23.95 337.145 24.38 337.465 24.76C338.325 25.87 339.025 27.1 339.515 28.42C341.545 33.41 339.165 37.66 335.585 39.17V39.16Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M293.745 56.76C297.335 55.25 300.495 51.41 306.745 36.08C291.645 29.73 286.735 29.29 283.145 30.78C279.555 32.27 277.175 36.54 279.205 41.52C279.705 42.84 280.405 44.08 281.275 45.18C281.605 45.56 281.865 45.99 282.065 46.45C282.245 46.92 282.355 47.41 282.395 47.91C282.555 49.32 282.925 50.69 283.495 51.99C285.505 56.97 290.145 58.27 293.745 56.76Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M315.815 65.6C317.115 65.09 318.335 64.38 319.425 63.5C319.795 63.17 320.215 62.9 320.675 62.7C321.135 62.52 321.625 62.4 322.115 62.37C323.505 62.21 324.855 61.84 326.125 61.27C331.025 59.21 332.305 54.49 330.825 50.85C329.335 47.2 325.555 44 310.465 37.65C304.205 52.99 303.765 57.97 305.265 61.62C306.765 65.26 310.925 67.67 315.825 65.62L315.815 65.6Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M287.905 19.1C289.395 22.74 293.175 25.95 308.265 32.3C314.535 16.97 314.975 11.98 313.485 8.33998C311.995 4.69998 307.805 2.27998 302.905 4.33998C301.605 4.84998 300.385 5.55998 299.295 6.43998C298.915 6.76998 298.495 7.03997 298.045 7.23997C297.585 7.42997 297.105 7.53999 296.605 7.56999C295.215 7.72999 293.865 8.09997 292.585 8.67997C287.695 10.74 286.415 15.46 287.895 19.1H287.905Z", fill: "#FF7E00" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 30.61C19.8349 27.67 16.9749 25.99 12.7749 25.99C4.91488 26.04 0.254883 32.29 0.254883 40.96C0.254883 49.63 4.90488 55.88 12.7749 55.88C14.2149 55.96 15.6649 55.71 17.0049 55.15C18.3449 54.59 19.5449 53.73 20.5149 52.64V56.81C20.5149 59.65 19.0149 63.02 14.2549 63.02C10.6449 63.02 8.86488 61 8.24488 58.83L1.85488 61.92C3.45488 66.02 7.27488 69.46 14.6949 69.46C25.6949 69.46 28.5249 62.04 28.5249 55.54V26.4H21.7949L21.6149 30.6L21.6049 30.61ZM14.4949 49.08C10.5649 49.08 8.24488 45.88 8.24488 40.9C8.24488 35.92 10.5649 32.72 14.4949 32.72C18.4249 32.72 20.6949 35.92 20.6949 40.9C20.6949 45.88 18.4249 49.08 14.4949 49.08Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 25.95C176.885 25.95 175.365 26.29 173.985 26.97C172.595 27.65 171.375 28.63 170.415 29.86L169.895 26.42H162.785V55.43H171.085V39.05C171.085 34.52 172.765 32.75 176.095 32.75C178.415 32.75 180.335 33.78 180.335 38.2V55.44H188.635V36.51C188.635 30.38 184.835 25.96 178.415 25.96L178.425 25.95Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 42.78C49.8749 46.76 48.1949 49.08 44.8749 49.08C42.5549 49.08 40.6149 48.05 40.6149 43.63V26.41H32.3149V45.3C32.3149 51.42 36.1149 55.87 42.5349 55.87C44.0749 55.87 45.5949 55.52 46.9849 54.84C48.3749 54.16 49.5949 53.17 50.5549 51.95L51.0749 55.4H58.1649V26.41H49.8649V42.78H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 26.41H62.5347V55.42H70.8347V26.41Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.865 28.54C91.855 26.81 89.275 25.94 86.655 26.09C78.755 26.09 74.085 32.35 74.085 41.01C74.085 49.67 78.755 55.93 86.655 55.93C88.335 56.04 90.015 55.7 91.525 54.94C93.035 54.18 94.325 53.03 95.265 51.6L95.465 55.42H102.195V12.94H93.895L93.855 28.54H93.865ZM88.465 49.08C84.535 49.08 82.215 45.88 82.215 40.9C82.215 35.92 84.535 32.72 88.465 32.72C92.395 32.72 94.715 35.92 94.715 40.9C94.715 45.88 92.395 49.08 88.465 49.08Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6848 12.25C65.7648 12.25 64.8748 12.53 64.1148 13.04C63.3548 13.56 62.7648 14.29 62.4148 15.16C62.0648 16.02 61.9748 16.97 62.1548 17.88C62.3348 18.79 62.7748 19.63 63.4248 20.29C64.0748 20.95 64.8948 21.4 65.7948 21.58C66.6948 21.76 67.6248 21.67 68.4648 21.31C69.3148 20.95 70.0348 20.35 70.5448 19.57C71.0548 18.79 71.3248 17.88 71.3248 16.95C71.3248 15.7 70.8348 14.5 69.9648 13.62C69.0948 12.74 67.9148 12.24 66.6948 12.24L66.6848 12.25Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.395 26.41H150.095V55.42H158.395V26.41Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.25C153.335 12.25 152.445 12.53 151.685 13.04C150.925 13.56 150.335 14.29 149.975 15.16C149.625 16.02 149.535 16.97 149.715 17.88C149.895 18.79 150.335 19.63 150.985 20.29C151.635 20.95 152.455 21.4 153.355 21.58C154.255 21.76 155.185 21.67 156.025 21.31C156.875 20.95 157.595 20.35 158.105 19.57C158.615 18.79 158.885 17.88 158.885 16.95C158.885 15.7 158.395 14.5 157.525 13.62C156.655 12.74 155.475 12.24 154.255 12.24V12.25Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.885 41.85V40.97C218.885 32.01 213.835 26.05 205.505 26.05C197.175 26.05 191.565 32.01 191.565 40.97C191.565 49.93 197.185 55.89 205.505 55.89C211.265 55.89 215.555 53.1 217.585 48.39L211.575 45.49C211.185 46.75 210.395 47.83 209.335 48.59C208.275 49.35 207.005 49.73 205.705 49.68C204.175 49.72 202.675 49.17 201.535 48.13C200.395 47.09 199.675 45.64 199.545 44.09H199.605L218.885 41.86V41.85ZM199.345 38.92C199.345 34.71 201.805 31.95 205.475 31.95C206.985 31.92 208.445 32.49 209.565 33.52C210.685 34.56 211.365 35.99 211.485 37.52L199.345 38.92Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 26.05C110.725 26.05 105.105 32.01 105.105 40.97C105.105 49.93 110.725 55.89 119.055 55.89C124.805 55.89 129.095 53.1 131.075 48.39L125.065 45.49C124.675 46.73 123.905 47.8 122.865 48.56C121.825 49.31 120.575 49.71 119.305 49.68C117.755 49.75 116.245 49.2 115.085 48.16C113.925 47.12 113.195 45.66 113.065 44.09L132.305 41.84V40.96C132.425 32.02 127.375 26.06 119.055 26.06V26.05ZM112.865 38.93C112.865 34.72 115.275 31.96 119.005 31.96C120.515 31.93 121.975 32.5 123.095 33.53C124.215 34.57 124.895 36 125.015 37.53L112.855 38.93H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.545 46.69V12.95H135.245V47.55C135.245 51.57 136.035 55.76 143.065 55.76C144.395 55.83 145.725 55.61 146.965 55.1V48.62C146.965 48.62 143.545 49.5 143.545 46.69Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.905 63.06H33.2949V75.79H0.504883V81.63H39.0249V68.89H218.905V63.06Z", fill: "#5532FA" }));
const SvgGeneralAtlantic = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 506, height: 83, viewBox: "0 0 506 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.820068H248.185V82.1801H249.185V0.820068Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 31.22C19.8349 28.28 16.9749 26.6 12.7749 26.6C4.91488 26.65 0.254883 32.9001 0.254883 41.5701C0.254883 50.2401 4.90488 56.4901 12.7749 56.4901C14.2149 56.5701 15.6649 56.3201 17.0049 55.7601C18.3449 55.2001 19.5449 54.3401 20.5149 53.2501V57.42C20.5149 60.26 19.0149 63.6301 14.2549 63.6301C10.6449 63.6301 8.86488 61.6101 8.24488 59.4401L1.85488 62.5301C3.45488 66.6301 7.27488 70.0701 14.6949 70.0701C25.6949 70.0701 28.5249 62.6501 28.5249 56.1501V27.0101H21.7949L21.6149 31.2101L21.6049 31.22ZM14.4949 49.6901C10.5649 49.6901 8.24488 46.4901 8.24488 41.5101C8.24488 36.5301 10.5649 33.3301 14.4949 33.3301C18.4249 33.3301 20.6949 36.5301 20.6949 41.5101C20.6949 46.4901 18.4249 49.6901 14.4949 49.6901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 26.55C176.885 26.55 175.365 26.8901 173.985 27.5701C172.595 28.2501 171.375 29.2301 170.415 30.4601L169.895 27.0201H162.785V56.04H171.085V39.66C171.085 35.13 172.765 33.36 176.095 33.36C178.415 33.36 180.335 34.3901 180.335 38.8101V56.05H188.635V37.1201C188.635 30.9901 184.835 26.5701 178.415 26.5701L178.425 26.55Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 43.3901C49.8749 47.3701 48.1949 49.7001 44.8749 49.7001C42.5549 49.7001 40.6149 48.6701 40.6149 44.2501V27.0201H32.3149V45.91C32.3149 52.03 36.1149 56.48 42.5349 56.48C44.0749 56.48 45.5949 56.1301 46.9849 55.4501C48.3749 54.7701 49.5949 53.7801 50.5549 52.5601L51.0749 56.0101H58.1649V27.0201H49.8649V43.3901H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 27.0201H62.5347V56.04H70.8347V27.0201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.8647 29.1501C91.8547 27.4201 89.2747 26.5401 86.6447 26.7001C78.7447 26.7001 74.0747 32.9601 74.0747 41.6201C74.0747 50.2801 78.7447 56.54 86.6447 56.54C88.3247 56.65 90.0047 56.31 91.5147 55.55C93.0247 54.7901 94.3147 53.6401 95.2547 52.2101L95.4547 56.0301H102.185V13.55H93.8847L93.8447 29.1501H93.8647ZM88.4647 49.6901C84.5347 49.6901 82.2147 46.4901 82.2147 41.5101C82.2147 36.5301 84.5347 33.3301 88.4647 33.3301C92.3947 33.3301 94.7147 36.5301 94.7147 41.5101C94.7147 46.4901 92.3947 49.6901 88.4647 49.6901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6948 12.86C65.7748 12.86 64.8848 13.1401 64.1248 13.6501C63.3648 14.1701 62.7748 14.9001 62.4148 15.7701C62.0648 16.6301 61.9748 17.5801 62.1548 18.4901C62.3348 19.4001 62.7748 20.2401 63.4248 20.9001C64.0748 21.5601 64.8948 22.0101 65.7948 22.1901C66.6948 22.3701 67.6248 22.28 68.4648 21.92C69.3148 21.56 70.0348 20.9601 70.5448 20.1801C71.0548 19.4001 71.3248 18.4901 71.3248 17.5601C71.3248 16.3101 70.8348 15.11 69.9648 14.23C69.0948 13.35 67.9148 12.85 66.6948 12.85V12.86Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.405 27.0201H150.105V56.04H158.405V27.0201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.86C153.335 12.86 152.445 13.1401 151.685 13.6501C150.925 14.1701 150.335 14.9001 149.975 15.7701C149.625 16.6301 149.535 17.5801 149.715 18.4901C149.895 19.4001 150.335 20.2401 150.985 20.9001C151.635 21.5601 152.455 22.0101 153.355 22.1901C154.255 22.3701 155.185 22.28 156.025 21.92C156.875 21.56 157.595 20.9601 158.105 20.1801C158.615 19.4001 158.885 18.4901 158.885 17.5601C158.885 16.3101 158.395 15.11 157.525 14.23C156.655 13.35 155.475 12.85 154.255 12.85V12.86Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.895 42.4601V41.5801C218.895 32.6201 213.845 26.66 205.515 26.66C197.185 26.66 191.575 32.6201 191.575 41.5801C191.575 50.5401 197.195 56.5001 205.515 56.5001C211.275 56.5001 215.565 53.7101 217.605 49.0001L211.595 46.1C211.205 47.36 210.415 48.4401 209.355 49.2001C208.295 49.9601 207.025 50.34 205.725 50.29C204.195 50.33 202.695 49.7801 201.555 48.7401C200.415 47.7001 199.695 46.2501 199.565 44.7001H199.625L218.905 42.47L218.895 42.4601ZM199.355 39.5301C199.355 35.3201 201.825 32.5601 205.485 32.5601C206.995 32.5301 208.455 33.1001 209.575 34.1301C210.695 35.1701 211.375 36.6001 211.495 38.1301L199.355 39.5301Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 26.6501C110.725 26.6501 105.105 32.6101 105.105 41.5701C105.105 50.5301 110.725 56.4901 119.055 56.4901C124.805 56.4901 129.095 53.7001 131.075 48.9901L125.065 46.0901C124.675 47.3301 123.905 48.4 122.865 49.16C121.825 49.91 120.575 50.3101 119.305 50.2801C117.755 50.3501 116.245 49.8001 115.085 48.7601C113.925 47.7201 113.195 46.2601 113.065 44.6901L132.305 42.4401V41.5601C132.425 32.6201 127.375 26.66 119.055 26.66V26.6501ZM112.865 39.5301C112.865 35.3201 115.275 32.5601 119.005 32.5601C120.515 32.5301 121.975 33.1001 123.095 34.1301C124.215 35.1701 124.895 36.6001 125.015 38.1301L112.855 39.5301H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.555 47.29V13.55H135.255V48.1501C135.255 52.1701 136.045 56.36 143.075 56.36C144.405 56.43 145.735 56.2101 146.975 55.7001V49.22C146.975 49.22 143.555 50.1 143.555 47.29Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.915 63.66H33.2949V76.3901H0.504883V82.23H39.0249V69.4901H218.915V63.66Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M357.665 37.2701C353.125 37.4501 349.295 33.91 349.115 29.37C349.115 29.12 349.115 28.88 349.115 28.63C348.965 23.95 352.645 20.04 357.325 19.89C357.415 19.89 357.505 19.89 357.595 19.89C359.875 19.78 362.105 20.55 363.835 22.05L362.605 23.5C361.215 22.2 359.365 21.51 357.465 21.57C353.825 21.65 350.945 24.66 351.025 28.29C351.025 28.36 351.025 28.43 351.025 28.5C350.765 32.13 353.505 35.2801 357.135 35.5301C357.335 35.5401 357.535 35.55 357.725 35.54C359.505 35.56 361.245 34.98 362.665 33.89V29.68H357.465V28.0301H364.445V34.75C362.575 36.41 360.165 37.3301 357.665 37.3301", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M387.305 21.85H376.985V27.61H386.225V29.3401H376.985V35.2501H387.425V36.98H375.075V20.1201H387.305V21.85Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M409.585 20.1201H411.445V36.98H409.925L398.995 23.1501V36.98H397.135V20.1201H398.935L409.585 33.6401V20.1201Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M434.755 21.85H424.425V27.61H433.665V29.3401H424.425V35.2501H434.865V36.98H422.525V20.1201H434.755V21.85Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M456.215 36.98L451.275 30.4001H446.435V36.98H444.595V20.11H451.875C455.595 20.11 457.985 22.1201 457.985 25.1501C457.985 27.7501 455.985 29.9101 453.395 30.0901L458.595 36.9901H456.225L456.215 36.98ZM451.705 21.8701H446.485V28.72H451.685C454.225 28.72 456.035 27.42 456.035 25.23C456.035 23.04 454.385 21.9401 451.705 21.9401", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M484.465 36.98H482.455L480.475 32.5201H471.275L469.285 36.98H467.325L475.025 19.9901H476.815L484.455 36.98H484.465ZM475.875 22.2101L472.005 30.8H479.705L475.865 22.2101H475.875Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M493.795 20.1201H495.705V35.22H505.235V36.98H493.795V20.1201Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M365.575 63.2001H363.465L361.475 58.7401H352.275L350.265 63.2001H348.305L356.025 46.16H357.805L365.575 63.2001ZM356.945 48.3801L353.075 56.97H360.795L356.945 48.3801Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M377.595 63.15H375.655V48.04H369.975V46.28H383.275V48.04H377.595V63.15Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M391.375 46.28H393.285V61.39H402.795V63.15H391.375V46.28Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M427.375 63.2001H425.315L423.325 58.7401H414.125L412.115 63.2001H410.155L417.875 46.2101H419.655L427.375 63.2001ZM418.745 48.3801L414.955 56.97H422.655L418.735 48.3801H418.745Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M447.805 46.28H449.665V63.15H448.135L437.225 49.32V63.15H435.365V46.28H437.135L447.805 59.79V46.28Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M465.365 63.15H463.445V48.04H457.765V46.28H471.045V48.04H465.365V63.15Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M498.555 63.4301C493.905 63.4601 490.105 59.7101 490.075 55.0601C490.075 54.9501 490.075 54.8501 490.075 54.7401C489.935 50.0501 493.625 46.1401 498.315 46.0001C498.425 46.0001 498.525 46.0001 498.635 46.0001C501.105 45.9201 503.495 46.8901 505.215 48.6701L503.845 50.04C502.465 48.57 500.545 47.73 498.525 47.72C494.885 47.72 491.935 50.66 491.935 54.29C491.935 54.41 491.935 54.54 491.935 54.66C491.705 58.29 494.465 61.4201 498.095 61.6401C498.235 61.6401 498.375 61.6501 498.515 61.6501C500.595 61.6501 502.585 60.7601 503.985 59.2101L505.235 60.4301C503.525 62.3701 501.055 63.4501 498.465 63.3901", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M304.575 15.4601C290.115 15.5001 278.435 27.2401 278.465 41.7001C278.505 56.1601 290.245 67.8401 304.705 67.8101C319.135 67.7701 330.815 56.0701 330.815 41.6401C330.795 27.1701 319.045 15.45 304.575 15.47V15.4601ZM284.825 47.3401L296.445 35.9501C299.675 32.8001 304.825 32.8001 308.055 35.9501L296.535 47.3201C293.315 50.4101 288.235 50.4101 285.015 47.3201L284.825 47.3401ZM312.995 47.3201C309.775 50.4101 304.685 50.4101 301.475 47.3201L312.995 35.9501C316.195 32.8101 321.315 32.8101 324.515 35.9501L312.995 47.3201Z", fill: "#172E57" }), /* @__PURE__ */ React.createElement("path", { d: "M481.655 46.2778H479.725V63.1478H481.655V46.2778Z", fill: "#172E57" }));
const SvgGenerationIm = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 638, height: 82, viewBox: "0 0 638 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.429932H248.185V81.7899H249.185V0.429932Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 30.83C19.8349 27.89 16.9749 26.21 12.7749 26.21C4.91488 26.26 0.254883 32.5099 0.254883 41.1799C0.254883 49.8499 4.90488 56.0999 12.7749 56.0999C14.2149 56.1799 15.6649 55.9299 17.0049 55.3699C18.3449 54.8099 19.5449 53.9499 20.5149 52.8599V57.03C20.5149 59.87 19.0149 63.2399 14.2549 63.2399C10.6449 63.2399 8.86488 61.2199 8.24488 59.0499L1.85488 62.14C3.45488 66.24 7.27488 69.6799 14.6949 69.6799C25.6949 69.6799 28.5249 62.2599 28.5249 55.7599V26.6199H21.7949L21.6149 30.8199L21.6049 30.83ZM14.4949 49.2999C10.5649 49.2999 8.24488 46.0999 8.24488 41.1199C8.24488 36.1399 10.5649 32.9399 14.4949 32.9399C18.4249 32.9399 20.6949 36.1399 20.6949 41.1199C20.6949 46.0999 18.4249 49.2999 14.4949 49.2999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 26.1599C176.885 26.1599 175.365 26.4999 173.985 27.1799C172.595 27.8599 171.375 28.8399 170.415 30.0699L169.895 26.6299H162.785V55.64H171.085V39.2599C171.085 34.7299 172.765 32.96 176.095 32.96C178.415 32.96 180.335 33.9899 180.335 38.4099V55.65H188.635V36.7199C188.635 30.5899 184.835 26.1699 178.415 26.1699L178.425 26.1599Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 42.9999C49.8749 46.9799 48.1949 49.2999 44.8749 49.2999C42.5549 49.2999 40.6149 48.2699 40.6149 43.8499V26.6299H32.3149V45.5199C32.3149 51.6399 36.1149 56.0899 42.5349 56.0899C44.0749 56.0899 45.5949 55.7399 46.9849 55.0599C48.3749 54.3799 49.5949 53.3899 50.5549 52.1699L51.0749 55.6199H58.1649V26.6299H49.8649V42.9999H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 26.6299H62.5347V55.6399H70.8347V26.6299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.865 28.7599C91.855 27.0299 89.275 26.1599 86.655 26.3099C78.755 26.3099 74.085 32.5699 74.085 41.2299C74.085 49.8899 78.755 56.15 86.655 56.15C88.335 56.26 90.015 55.9199 91.525 55.1599C93.035 54.3999 94.325 53.2499 95.265 51.8199L95.465 55.64H102.195V13.1599H93.895L93.855 28.7599H93.865ZM88.465 49.2999C84.535 49.2999 82.215 46.0999 82.215 41.1199C82.215 36.1399 84.535 32.9399 88.465 32.9399C92.395 32.9399 94.715 36.1399 94.715 41.1199C94.715 46.0999 92.395 49.2999 88.465 49.2999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6848 12.4699C65.7648 12.4699 64.8748 12.7499 64.1148 13.2599C63.3548 13.7799 62.7648 14.5099 62.4148 15.3799C62.0648 16.2399 61.9748 17.1899 62.1548 18.0999C62.3348 19.0099 62.7748 19.8499 63.4248 20.5099C64.0748 21.1699 64.8948 21.6199 65.7948 21.7999C66.6948 21.9799 67.6248 21.89 68.4648 21.53C69.3148 21.17 70.0348 20.5699 70.5448 19.7899C71.0548 19.0099 71.3248 18.0999 71.3248 17.1699C71.3248 15.9199 70.8348 14.72 69.9648 13.84C69.0948 12.96 67.9148 12.46 66.6948 12.46L66.6848 12.4699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.395 26.6299H150.095V55.6399H158.395V26.6299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.4699C153.335 12.4699 152.445 12.7499 151.685 13.2599C150.925 13.7799 150.335 14.5099 149.975 15.3799C149.625 16.2399 149.535 17.1899 149.715 18.0999C149.895 19.0099 150.335 19.8499 150.985 20.5099C151.635 21.1699 152.455 21.6199 153.355 21.7999C154.255 21.9799 155.185 21.89 156.025 21.53C156.875 21.17 157.595 20.5699 158.105 19.7899C158.615 19.0099 158.885 18.0999 158.885 17.1699C158.885 15.9199 158.395 14.72 157.525 13.84C156.655 12.96 155.475 12.46 154.255 12.46V12.4699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.885 42.07V41.19C218.885 32.23 213.835 26.27 205.505 26.27C197.175 26.27 191.565 32.23 191.565 41.19C191.565 50.15 197.185 56.11 205.505 56.11C211.265 56.11 215.555 53.32 217.585 48.61L211.575 45.71C211.185 46.97 210.395 48.05 209.335 48.81C208.275 49.57 207.005 49.95 205.705 49.9C204.175 49.94 202.675 49.39 201.535 48.35C200.395 47.31 199.675 45.86 199.545 44.31H199.605L218.885 42.08V42.07ZM199.345 39.14C199.345 34.93 201.805 32.17 205.475 32.17C206.985 32.14 208.445 32.71 209.565 33.74C210.685 34.78 211.365 36.21 211.485 37.74L199.345 39.14Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 26.26C110.725 26.26 105.105 32.22 105.105 41.18C105.105 50.14 110.725 56.1 119.055 56.1C124.805 56.1 129.095 53.31 131.075 48.6L125.065 45.7C124.675 46.94 123.905 48.01 122.865 48.77C121.825 49.52 120.575 49.92 119.305 49.89C117.755 49.96 116.245 49.41 115.085 48.37C113.925 47.33 113.195 45.87 113.065 44.3L132.305 42.05V41.17C132.425 32.23 127.375 26.27 119.055 26.27V26.26ZM112.865 39.14C112.865 34.93 115.275 32.17 119.005 32.17C120.515 32.14 121.975 32.71 123.095 33.74C124.215 34.78 124.895 36.21 125.015 37.74L112.855 39.14H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.545 46.9V13.1599H135.245V47.7599C135.245 51.7799 136.035 55.9699 143.065 55.9699C144.395 56.0399 145.725 55.8199 146.965 55.3099V48.83C146.965 48.83 143.545 49.71 143.545 46.9Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.905 63.27H33.2949V76H0.504883V81.84H39.0249V69.1H218.905V63.27Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M497.165 53.65V26.9C495.015 26.9 492.885 26.97 490.745 27.05C488.615 27.12 486.495 27.2 484.375 27.2V28.92H489.475V53.66H484.375V55.64H502.555V53.66H497.165V53.65Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M492.875 21.22C495.145 21.22 497.155 19.5 497.155 17.23C497.155 14.96 495.145 12.98 492.875 12.98C490.895 12.98 488.915 14.96 488.915 17.23C488.915 19.5 490.895 21.22 492.875 21.22Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M473.125 17.1799C470.595 17.4699 468.025 17.7299 465.495 17.7299V27.3099H460.955V28.9999H465.495V50.4099C465.495 54.3399 466.635 56.3199 473.125 56.3199C477.375 56.3199 480.235 54.63 481.925 50.7L480.495 49.8599C479.655 51.8099 478.255 53.7899 475.985 53.7899C473.425 53.7899 473.125 52.0999 473.125 49.8599V28.9999H479.945V27.3099H473.125V17.1799Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M296.725 51.3201C297.215 51.3201 297.685 51.31 298.135 51.3C300.825 51.23 302.915 51.1801 304.595 53.6301C305.735 55.0601 305.995 57.0401 305.995 58.7601C305.995 68.1401 298.425 72.4301 290.005 72.4301C285.225 72.4301 278.465 70.1501 278.465 64.1501C278.465 61.3201 280.705 59.0201 282.945 57.8901C280.155 57.0501 278.465 54.7801 278.465 51.3401C278.465 47.0901 280.995 45.37 284.925 44.23C282.095 42.51 280.145 39.95 280.145 36.54C280.145 30.28 284.925 26.5801 290.805 26.5801C294.185 26.5801 296.425 27.7201 298.955 29.9901L299.075 29.8201C300.415 27.9101 301.565 26.29 304.025 26.29C305.715 26.29 307.115 27.4301 307.115 29.1501C307.115 31.1301 306.275 32.0101 304.585 32.0101C303.515 32.0101 302.895 30.97 302.445 30.22C302.185 29.79 301.985 29.4501 301.785 29.4501C301.255 29.4501 300.835 29.89 300.455 30.29C300.225 30.53 300.015 30.75 299.805 30.85C300.945 32.28 301.495 34.2901 301.495 36.2701C301.495 39.4201 299.805 42.83 297.015 44.55C294.735 45.91 291.935 45.82 289.315 45.73C288.685 45.71 288.065 45.6901 287.465 45.6901C285.485 45.6901 280.705 45.98 280.705 49.1C280.705 50.82 281.845 51.3701 283.535 51.3701H296.725V51.3201ZM285.765 58.17C283.525 58.17 282.935 61.5801 282.935 63.5901C282.935 68.1301 286.025 70.4401 290.535 70.4401C296.155 70.4401 301.495 68.7201 303.175 62.4601C304.575 58.4701 301.485 58.1801 297.835 58.1801H285.755L285.765 58.17ZM286.875 41.0701C286.875 43.6301 288.015 44.5101 290.805 44.5101C293.595 44.5101 294.765 43.9301 294.765 41.0701V31.11C294.765 28.55 293.335 27.9901 291.095 27.9901C288.005 27.9901 286.875 29.42 286.875 31.11V41.0701Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M315.555 39.63V45.28C315.555 50.38 315.815 54.89 321.695 54.89C327.025 54.89 330.665 51.22 332.095 46.41H334.045C332.095 53.49 327.315 56.31 320.295 56.31C312.715 56.31 307.125 48.94 307.125 41.6C307.125 33.68 313.565 26.6 321.135 26.6C327.865 26.6 333.745 31.11 333.745 38.19C333.745 39.68 333.335 39.66 332.505 39.63C332.375 39.63 332.235 39.62 332.085 39.62H315.545L315.555 39.63ZM325.965 36C326.095 31.84 326.205 28.04 320.885 28.04C315.565 28.04 315.505 32.56 315.545 36.81C315.545 37.19 315.545 37.57 315.545 37.94H325.905C325.905 37.29 325.925 36.64 325.945 35.99L325.965 36Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M348.175 33.43H347.885V26.9C345.655 26.9 343.345 26.98 341.175 27.06C339.235 27.13 337.395 27.19 335.795 27.19V28.88H340.575V53.65H335.795V55.63H352.405V53.65H347.895V44.24C347.895 40.83 347.895 37.71 349.035 35.15C350.145 32.59 352.675 29.18 355.795 29.18C360.085 29.18 360.045 33.08 359.995 38.82C359.995 39.47 359.985 40.14 359.985 40.83V53.65H355.505V55.63H371.815V53.65H367.305V40.54C367.305 39.99 367.305 39.44 367.305 38.9C367.365 32.42 367.415 26.62 358.875 26.62C353.515 26.62 350.435 29.18 348.185 33.44L348.175 33.43Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M381.355 39.63V45.28C381.355 50.38 381.645 54.89 387.915 54.89C393.015 54.89 397.005 51.22 398.405 46.41H400.125C398.405 53.49 393.305 56.31 386.495 56.31C378.545 56.31 372.865 48.94 372.865 41.6C372.865 33.68 379.395 26.6 387.055 26.6C393.875 26.6 400.135 31.11 400.135 38.19C400.135 39.68 399.495 39.66 398.585 39.63C398.445 39.63 398.305 39.63 398.155 39.63H381.375H381.355ZM391.875 37.94C391.875 37.29 391.895 36.63 391.915 35.98C392.045 31.83 392.165 28.04 386.775 28.04C381.385 28.04 381.305 32.6 381.345 36.87C381.345 37.23 381.345 37.59 381.345 37.94H391.865H391.875Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M414.185 34.03C414.015 34.31 413.835 34.58 413.665 34.86V26.91C411.485 26.91 409.285 26.99 407.175 27.06C405.205 27.13 403.295 27.2 401.525 27.2V28.89H406.035V53.66H401.815V55.64H420.165V53.66H413.675V47.1C413.675 37.72 415.365 33.73 418.185 31.16C419.025 30.02 419.875 29.47 421.305 29.47C421.855 29.47 421.855 29.73 421.565 30.87V32.04C421.565 33.73 423.285 35.45 424.975 35.45C427.505 35.45 429.485 34.02 429.485 31.46C429.485 28.05 426.655 26.62 423.835 26.62C418.845 26.62 416.535 30.31 414.195 34.04L414.185 34.03Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M448.595 30.58C448.595 28.89 445.215 28.05 444.085 28.05C441.295 28.05 437.905 29.45 439.045 30.88C439.305 31.43 439.885 32.86 439.885 34.26C439.885 35.98 438.195 37.38 436.505 37.38C434.525 37.38 432.865 36.24 432.865 34C432.865 28.61 439.885 26.63 444.085 26.63C447.175 26.63 450.545 27.18 453.375 28.61C455.325 29.75 455.875 30.88 455.875 32.86V51.82C455.875 52.93 456.715 53.22 457.565 53.22C458.415 53.22 459.545 52.38 460.095 51.53L460.935 52.67C458.955 54.91 457.295 56.34 454.205 56.34C451.115 56.34 449.135 54.65 448.585 51.24C446.055 54.65 442.385 56.34 438.185 56.34C433.985 56.34 430.875 54.07 430.875 49.55C430.875 41.04 442.385 39.35 448.585 39.65V30.59L448.595 30.58ZM448.595 41.04C444.375 41.04 438.465 41.62 438.465 47.57C438.465 50.69 439.605 52.93 442.975 52.93C445.505 52.93 447.165 50.95 448.015 48.71C448.595 47.57 448.595 46.44 448.595 45.01V41.05V41.04Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M519.935 26.61C528.145 26.61 534.965 33.69 534.965 41.61C534.965 49.53 528.145 56.32 519.935 56.32C511.725 56.32 504.905 49.83 504.905 41.61C504.905 33.39 511.985 26.61 519.935 26.61ZM519.935 28.04C513.385 28.04 513.395 33.25 513.405 40.68C513.405 40.99 513.405 41.3 513.405 41.62C513.405 50.94 513.695 54.9 519.935 54.9C526.175 54.9 526.465 50.94 526.465 41.62C526.465 41.07 526.465 40.54 526.465 40.01C526.495 32.94 526.525 28.04 519.935 28.04Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M559.765 26.61C554.665 26.61 551.255 29.17 548.985 33.43V26.9C546.595 26.9 544.285 26.98 542.095 27.06C540.115 27.13 538.235 27.19 536.485 27.19V28.88H541.325V53.65H536.485V55.63H553.525V53.65H548.985V44.24C548.985 40.83 548.985 37.71 549.825 35.15C550.965 32.59 553.815 29.18 556.645 29.18C560.995 29.18 560.965 33.09 560.905 38.84C560.905 39.49 560.895 40.15 560.895 40.83V53.65H556.355V55.63H572.845V53.65H568.595V40.54C568.595 40.16 568.595 39.79 568.595 39.41C568.625 32.72 568.645 26.61 559.765 26.61Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M579.515 53.65H637.485V55.63H579.515V53.65Z", fill: "black" }));
const SvgLererHippeau = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 654, height: 82, viewBox: "0 0 654 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.0400391H248.185V81.4001H249.185V0.0400391Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 30.4401C19.8349 27.5001 16.9749 25.8201 12.7749 25.8201C4.91488 25.8701 0.254883 32.12 0.254883 40.79C0.254883 49.46 4.90488 55.7101 12.7749 55.7101C14.2149 55.7901 15.6649 55.54 17.0049 54.98C18.3449 54.42 19.5449 53.56 20.5149 52.47V56.6401C20.5149 59.4801 19.0149 62.85 14.2549 62.85C10.6449 62.85 8.86488 60.83 8.24488 58.66L1.85488 61.7501C3.45488 65.8501 7.27488 69.29 14.6949 69.29C25.6949 69.29 28.5249 61.8701 28.5249 55.3701V26.23H21.7949L21.6149 30.4301L21.6049 30.4401ZM14.4949 48.91C10.5649 48.91 8.24488 45.71 8.24488 40.73C8.24488 35.75 10.5649 32.55 14.4949 32.55C18.4249 32.55 20.6949 35.75 20.6949 40.73C20.6949 45.71 18.4249 48.91 14.4949 48.91Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 25.77C176.885 25.77 175.365 26.11 173.985 26.79C172.595 27.47 171.375 28.45 170.415 29.68L169.895 26.24H162.785V55.25H171.085V38.87C171.085 34.34 172.765 32.57 176.095 32.57C178.415 32.57 180.335 33.6 180.335 38.02V55.26H188.635V36.33C188.635 30.2 184.835 25.78 178.415 25.78L178.425 25.77Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 42.61C49.8749 46.59 48.1949 48.91 44.8749 48.91C42.5549 48.91 40.6149 47.88 40.6149 43.46V26.24H32.3149V45.13C32.3149 51.25 36.1149 55.7 42.5349 55.7C44.0749 55.7 45.5949 55.35 46.9849 54.67C48.3749 53.99 49.5949 53 50.5549 51.78L51.0749 55.23H58.1649V26.24H49.8649V42.61H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 26.24H62.5347V55.25H70.8347V26.24Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.865 28.37C91.855 26.64 89.275 25.77 86.655 25.92C78.755 25.92 74.085 32.18 74.085 40.84C74.085 49.5 78.755 55.76 86.655 55.76C88.335 55.87 90.015 55.53 91.525 54.77C93.035 54.01 94.325 52.86 95.265 51.43L95.465 55.25H102.195V12.77H93.895L93.855 28.37H93.865ZM88.465 48.91C84.535 48.91 82.215 45.71 82.215 40.73C82.215 35.75 84.535 32.55 88.465 32.55C92.395 32.55 94.715 35.75 94.715 40.73C94.715 45.71 92.395 48.91 88.465 48.91Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6848 12.0701C65.7648 12.0701 64.8748 12.35 64.1148 12.86C63.3548 13.38 62.7648 14.11 62.4148 14.98C62.0648 15.84 61.9748 16.7901 62.1548 17.7001C62.3348 18.6101 62.7748 19.45 63.4248 20.11C64.0748 20.77 64.8948 21.2201 65.7948 21.4001C66.6948 21.5801 67.6248 21.4901 68.4648 21.1301C69.3148 20.7701 70.0348 20.1701 70.5448 19.3901C71.0548 18.6101 71.3248 17.7001 71.3248 16.7701C71.3248 15.5201 70.8348 14.3201 69.9648 13.4401C69.0948 12.5601 67.9148 12.0601 66.6948 12.0601L66.6848 12.0701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.395 26.24H150.095V55.25H158.395V26.24Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.0701C153.335 12.0701 152.445 12.35 151.685 12.86C150.925 13.38 150.335 14.11 149.975 14.98C149.625 15.84 149.535 16.7901 149.715 17.7001C149.895 18.6101 150.335 19.45 150.985 20.11C151.635 20.77 152.455 21.2201 153.355 21.4001C154.255 21.5801 155.185 21.4901 156.025 21.1301C156.875 20.7701 157.595 20.1701 158.105 19.3901C158.615 18.6101 158.885 17.7001 158.885 16.7701C158.885 15.5201 158.395 14.3201 157.525 13.4401C156.655 12.5601 155.475 12.0601 154.255 12.0601V12.0701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.885 41.6801V40.8001C218.885 31.8401 213.835 25.8801 205.505 25.8801C197.175 25.8801 191.565 31.8401 191.565 40.8001C191.565 49.7601 197.185 55.7201 205.505 55.7201C211.265 55.7201 215.555 52.9301 217.585 48.2201L211.575 45.3201C211.185 46.5801 210.395 47.6601 209.335 48.4201C208.275 49.1801 207.005 49.5601 205.705 49.5101C204.175 49.5501 202.675 49.0001 201.535 47.9601C200.395 46.9201 199.675 45.4701 199.545 43.9201H199.605L218.885 41.6901V41.6801ZM199.345 38.7501C199.345 34.5401 201.805 31.7802 205.475 31.7802C206.985 31.7502 208.445 32.3201 209.565 33.3501C210.685 34.3901 211.365 35.8201 211.485 37.3501L199.345 38.7501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 25.8701C110.725 25.8701 105.105 31.8301 105.105 40.7901C105.105 49.7501 110.725 55.7101 119.055 55.7101C124.805 55.7101 129.095 52.9201 131.075 48.2101L125.065 45.3101C124.675 46.5501 123.905 47.6201 122.865 48.3801C121.825 49.1301 120.575 49.5301 119.305 49.5001C117.755 49.5701 116.245 49.0201 115.085 47.9801C113.925 46.9401 113.195 45.4801 113.065 43.9101L132.305 41.6601V40.7802C132.425 31.8402 127.375 25.8801 119.055 25.8801V25.8701ZM112.865 38.7501C112.865 34.5401 115.275 31.7802 119.005 31.7802C120.515 31.7502 121.975 32.3201 123.095 33.3501C124.215 34.3901 124.895 35.8201 125.015 37.3501L112.855 38.7501H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.545 46.51V12.77H135.245V47.37C135.245 51.39 136.035 55.58 143.065 55.58C144.395 55.65 145.725 55.43 146.965 54.92V48.44C146.965 48.44 143.545 49.32 143.545 46.51Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.905 62.8801H33.2949V75.6101H0.504883V81.4501H39.0249V68.7101H218.905V62.8801Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M286.745 26.3401H278.465V47.7101V54.6801H286.745H301.805V47.7101H286.745V26.3401Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M315.645 43.3801H324.975V36.9001H315.645V33.3101H331.375V26.3401H315.645H307.645V33.3101V36.9001V43.3801V47.7101V54.6801H315.645H333.055V47.7101H315.645V43.3801Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M379.465 43.3801H388.795V36.9001H379.465V33.3101H395.195V26.3401H379.465H371.465V33.3101V36.9001V43.3801V47.7101V54.6801H379.465H396.875V47.7101H379.465V43.3801Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M569.955 43.3801H579.295V36.9001H569.955V33.3101H585.695V26.3401H569.955H561.955V33.3101V36.9001V43.3801V47.7101V54.6801H569.955H587.365V47.7101H569.955V43.3801Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M365.915 35.4701C365.915 26.2401 356.125 26.3401 356.125 26.3401H338.245V54.6701H346.245V45.0701H352.735L358.105 54.6701H367.045L361.055 44.1101C363.405 42.8601 365.915 40.3801 365.915 35.4601V35.4701ZM346.245 33.3001H355.285C355.285 33.3001 357.635 33.3901 357.635 35.5601C357.635 37.7301 355.475 37.8201 355.475 37.8201H346.255V33.3001H346.245Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M466.155 37.2601H454.105V26.3401H446.105V54.6801H454.105V44.1301H466.155V54.6801H474.155V26.3401H466.155V37.2601Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M489.125 26.3401H481.125V54.67H489.125V26.3401Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M429.825 35.4701C429.825 26.2401 420.035 26.3401 420.035 26.3401H402.155V54.6701H410.155V45.0701H416.645L422.015 54.6701H430.955L424.965 44.1101C427.315 42.8601 429.825 40.3801 429.825 35.4601V35.4701ZM410.155 33.3001H419.195C419.195 33.3001 421.545 33.3901 421.545 35.5601C421.545 37.7301 419.385 37.8201 419.385 37.8201H410.165V33.3001H410.155Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M513.885 26.3401H495.905V54.67H503.905V45.73H514.075C514.075 45.73 523.775 45.7301 523.775 36.0301C523.775 26.3301 513.895 26.3301 513.895 26.3301L513.885 26.3401ZM512.755 38.48H503.905V33.5801H512.755C512.755 33.5801 515.485 33.96 515.485 36.22C515.485 38.48 512.755 38.48 512.755 38.48Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M547.015 26.3401H529.035V54.67H537.035V45.73H547.205C547.205 45.73 556.905 45.7301 556.905 36.0301C556.905 26.3301 547.025 26.3301 547.025 26.3301L547.015 26.3401ZM545.885 38.48H537.035V33.5801H545.885C545.885 33.5801 548.615 33.96 548.615 36.22C548.615 38.48 545.885 38.48 545.885 38.48Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M601.815 26.3401L590.135 54.67H598.305L599.975 50.7001H612.315L613.985 54.67H623.055L610.965 26.3401H601.815ZM602.685 44.2501L606.135 36.04L609.585 44.2501H602.675H602.685Z", fill: "#282828" }), /* @__PURE__ */ React.createElement("path", { d: "M645.835 26.3401V43.5101C645.835 43.5101 645.675 48.17 639.705 48.17C633.735 48.17 633.985 43.5101 633.985 43.5101V26.3401H625.985V43.5101C625.985 43.5101 625.495 55.35 639.705 55.35C653.915 55.35 653.835 45.2201 653.835 43.5101V26.3401H645.835Z", fill: "#282828" }));
const SvgPropel = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 493, height: 83, viewBox: "0 0 493 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8643_21216)" }, /* @__PURE__ */ React.createElement("path", { d: "M249.425 0.900024H248.425V82.26H249.425V0.900024Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.8451 31.3001C20.0751 28.3601 17.2151 26.6801 13.0151 26.6801C5.15512 26.7301 0.495117 32.9801 0.495117 41.6501C0.495117 50.3201 5.14512 56.5701 13.0151 56.5701C14.4551 56.6501 15.9051 56.4001 17.2451 55.8401C18.5851 55.2801 19.7851 54.4201 20.7551 53.3301V57.5001C20.7551 60.34 19.2551 63.7101 14.4951 63.7101C10.8851 63.7101 9.10512 61.69 8.48512 59.5201L2.09512 62.6101C3.69512 66.7101 7.51512 70.1501 14.9351 70.1501C25.9351 70.1501 28.7651 62.7301 28.7651 56.2301V27.1001H22.0351L21.8551 31.3001H21.8451ZM14.7351 49.7701C10.8051 49.7701 8.48512 46.5701 8.48512 41.5901C8.48512 36.6101 10.8051 33.4101 14.7351 33.4101C18.6651 33.4101 20.9351 36.6101 20.9351 41.5901C20.9351 46.5701 18.6651 49.7701 14.7351 49.7701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.665 26.63C177.125 26.63 175.605 26.97 174.225 27.65C172.835 28.33 171.615 29.31 170.655 30.54L170.135 27.1H163.025V56.11H171.325V39.73C171.325 35.2 173.005 33.43 176.335 33.43C178.655 33.43 180.575 34.46 180.575 38.88V56.12H188.875V37.19C188.875 31.06 185.075 26.64 178.655 26.64L178.665 26.63Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M50.1152 43.4701C50.1152 47.4501 48.4352 49.7701 45.1152 49.7701C42.7952 49.7701 40.8552 48.7401 40.8552 44.3201V27.1001H32.5552V45.9901C32.5552 52.1101 36.3552 56.5601 42.7752 56.5601C44.3152 56.5601 45.8352 56.2101 47.2252 55.5301C48.6152 54.8501 49.8352 53.8601 50.7952 52.6401L51.3152 56.0901H58.4052V27.1001H50.1052V43.4701H50.1152Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M71.0749 27.1001H62.7749V56.1101H71.0749V27.1001Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M94.1052 29.23C92.0952 27.5 89.5152 26.63 86.8952 26.78C78.9952 26.78 74.3252 33.04 74.3252 41.7C74.3252 50.36 78.9952 56.62 86.8952 56.62C88.5752 56.73 90.2552 56.39 91.7652 55.63C93.2752 54.87 94.5652 53.72 95.5052 52.29L95.7052 56.11H102.435V13.63H94.1352L94.0952 29.23H94.1052ZM88.7052 49.77C84.7752 49.77 82.4552 46.57 82.4552 41.59C82.4552 36.61 84.7752 33.41 88.7052 33.41C92.6352 33.41 94.9552 36.61 94.9552 41.59C94.9552 46.57 92.6352 49.77 88.7052 49.77Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.9251 12.93C66.0051 12.93 65.1151 13.21 64.3551 13.72C63.5951 14.24 63.0051 14.97 62.6551 15.84C62.3051 16.7 62.2151 17.65 62.3951 18.56C62.5751 19.47 63.0151 20.31 63.6651 20.97C64.3151 21.63 65.1351 22.08 66.0351 22.26C66.9351 22.44 67.8651 22.35 68.7051 21.99C69.5551 21.63 70.2751 21.03 70.7851 20.25C71.2951 19.47 71.5651 18.56 71.5651 17.63C71.5651 16.38 71.0751 15.18 70.2051 14.3C69.3351 13.42 68.1551 12.92 66.9351 12.92L66.9251 12.93Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.635 27.1001H150.335V56.1101H158.635V27.1001Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.495 12.93C153.575 12.93 152.685 13.21 151.925 13.72C151.165 14.24 150.575 14.97 150.215 15.84C149.865 16.7 149.775 17.65 149.955 18.56C150.135 19.47 150.575 20.31 151.225 20.97C151.875 21.63 152.695 22.08 153.595 22.26C154.495 22.44 155.425 22.35 156.265 21.99C157.115 21.63 157.835 21.03 158.345 20.25C158.855 19.47 159.125 18.56 159.125 17.63C159.125 16.38 158.635 15.18 157.765 14.3C156.895 13.42 155.715 12.92 154.495 12.92V12.93Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M219.125 42.54V41.66C219.125 32.7 214.075 26.74 205.745 26.74C197.415 26.74 191.805 32.7 191.805 41.66C191.805 50.62 197.425 56.58 205.745 56.58C211.505 56.58 215.795 53.79 217.825 49.08L211.815 46.18C211.425 47.44 210.635 48.52 209.575 49.28C208.515 50.04 207.245 50.42 205.945 50.37C204.415 50.41 202.915 49.86 201.775 48.82C200.635 47.78 199.915 46.33 199.785 44.78H199.845L219.125 42.55V42.54ZM199.585 39.61C199.585 35.4 202.045 32.64 205.715 32.64C207.225 32.61 208.685 33.18 209.805 34.21C210.925 35.25 211.605 36.68 211.725 38.21L199.585 39.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.295 26.7301C110.965 26.7301 105.345 32.6901 105.345 41.6501C105.345 50.6101 110.965 56.5701 119.295 56.5701C125.045 56.5701 129.335 53.7801 131.315 49.0701L125.305 46.1701C124.915 47.4101 124.145 48.4801 123.105 49.2401C122.065 49.9901 120.815 50.3901 119.545 50.3601C117.995 50.4301 116.485 49.8801 115.325 48.8401C114.165 47.8001 113.435 46.3401 113.305 44.7701L132.545 42.5201V41.6401C132.665 32.7001 127.615 26.7401 119.295 26.7401V26.7301ZM113.105 39.6101C113.105 35.4001 115.515 32.6401 119.245 32.6401C120.755 32.6101 122.215 33.1801 123.335 34.2101C124.455 35.2501 125.135 36.6801 125.255 38.2101L113.095 39.6101H113.105Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.785 47.37V13.63H135.485V48.23C135.485 52.25 136.275 56.44 143.305 56.44C144.635 56.51 145.965 56.29 147.205 55.78V49.3C147.205 49.3 143.785 50.18 143.785 47.37Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M219.145 63.74H33.5351V76.47H0.745117V82.31H39.2651V69.57H219.145V63.74Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M320.025 44.9L311.815 36.55H323.395V30.1H311.815L320.025 21.9L315.485 17.21L307.135 25.56V13.84H300.685V25.56L292.475 17.21L287.935 21.9L315.485 49.44L320.025 44.9Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M283.245 26.4399L278.705 30.9799L320.025 72.4499L324.715 67.9099L283.245 26.4399Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M362.075 25.7099C361.195 24.8299 360.175 24.0999 359.145 23.6599C357.825 23.0699 356.365 22.7799 354.895 22.7799H342.445V54.4299H348.455V42.4099H354.905C356.375 42.4099 357.835 42.1199 359.155 41.5299C360.325 41.0899 361.355 40.3599 362.085 39.3299C362.815 38.4499 363.555 37.4299 363.845 36.2499C364.285 35.0799 364.435 33.9099 364.435 32.7299V31.6999C364.435 30.5299 364.285 29.3599 363.845 28.3299C363.555 27.4499 362.965 26.4299 362.085 25.6899L362.075 25.7099ZM358.555 32.8899C358.555 33.9199 358.115 34.9399 357.385 35.6699C356.505 36.3999 355.335 36.8399 354.305 36.6999H348.445V28.3499H354.305C355.475 28.3499 356.645 28.6399 357.385 29.3799C358.125 30.1199 358.555 31.1399 358.555 32.1599V32.8899Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M384.055 31.42C382.735 31.42 381.565 31.71 380.395 32.45C379.365 33.18 378.635 34.21 378.195 35.38H377.315V32.16H367.795V37.58H371.895V49.16H367.355V54.58H382.745V49.16H377.615V41.98C377.465 40.66 377.905 39.34 378.645 38.17C379.375 37.29 380.545 36.85 381.575 36.85C382.605 36.7 383.625 37.14 384.355 38.02C385.085 38.9 385.385 39.92 385.235 40.95V41.54L391.095 40.95V39.92C391.095 36.99 390.365 34.94 389.045 33.47C388.015 32 385.965 31.27 384.065 31.42H384.055Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M413.655 34.3499C412.625 33.3199 411.315 32.5899 409.995 32.1499C407.215 31.1199 403.985 31.1199 401.205 32.1499C399.885 32.5899 398.565 33.4699 397.545 34.3499C396.375 35.3799 395.645 36.5499 394.905 38.0099C394.315 39.6199 393.875 41.2299 394.025 42.8499V43.4399C394.025 45.1999 394.315 46.8099 394.905 48.4199C395.495 49.7399 396.375 51.0599 397.545 52.0799C398.575 53.1099 399.885 53.8399 401.205 54.2799C403.985 55.3099 407.215 55.3099 409.995 54.2799C411.315 53.8399 412.635 52.9599 413.655 52.0799C414.825 51.0499 415.705 49.8799 416.295 48.4199C416.885 46.8099 417.325 45.1999 417.175 43.4399V42.8499C417.175 41.2399 416.885 39.4799 416.295 38.0099C415.705 36.6899 414.825 35.3699 413.655 34.3499ZM411.455 43.5799C411.455 44.4599 411.305 45.3399 411.015 46.0699C410.425 47.5399 409.255 48.5599 407.795 49.1499C407.065 49.4399 406.325 49.5899 405.455 49.5899C404.725 49.5899 403.845 49.4399 403.115 49.1499C401.645 48.5599 400.475 47.5399 399.895 46.0699C399.745 45.3399 399.605 44.4599 399.605 43.5799V42.6999C399.605 41.8199 399.755 40.9399 400.045 40.2099C400.635 38.7399 401.805 37.7199 403.265 37.1299C404.735 36.5399 406.345 36.5399 407.805 37.1299C409.275 37.7199 410.445 38.7399 411.025 40.2099C411.315 40.9399 411.465 41.8199 411.465 42.6999V43.5799H411.455Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M440.765 34.3499C439.885 33.3199 438.865 32.5899 437.685 32.1499C436.515 31.7099 435.195 31.4199 433.875 31.4199C432.405 31.4199 430.795 31.7099 429.475 32.4499C428.305 33.1799 427.425 34.0599 426.835 35.3799H425.955V32.1599H420.245V63.6599H425.955V51.3499H426.835C427.125 51.9399 427.425 52.3799 427.865 52.8199C428.305 53.2599 428.745 53.6999 429.335 53.9899C429.925 54.4299 430.655 54.7199 431.235 54.8699C433.435 55.4599 435.635 55.3099 437.685 54.4299C438.855 53.9899 439.885 53.1099 440.765 52.2299C441.645 51.1999 442.375 49.8899 442.815 48.5699C443.405 46.9599 443.545 45.3499 443.545 43.7299V42.8499C443.545 41.2399 443.255 39.6299 442.665 38.0099C442.375 36.5399 441.635 35.3699 440.765 34.3499ZM437.985 43.4299C438.135 45.0399 437.545 46.6499 436.375 47.9699C435.205 49.1399 433.735 49.7299 432.125 49.5799C430.515 49.7299 428.905 48.9899 427.875 47.9699C426.705 46.7999 426.115 45.1899 426.265 43.5699V42.9799C426.115 41.3699 426.705 39.7599 427.875 38.5799C429.045 37.4099 430.515 36.8199 432.125 36.8199C433.735 36.6699 435.345 37.4099 436.375 38.4299C437.545 39.5999 438.135 41.2099 437.985 42.9699V43.4099V43.4299Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M466.695 34.94C465.665 33.91 464.495 33.04 463.325 32.3C461.715 31.57 460.105 31.27 458.345 31.27C456.875 31.27 455.415 31.56 453.945 32.15C452.625 32.74 451.455 33.47 450.425 34.49C449.395 35.52 448.525 36.69 447.935 38.15C447.345 39.62 447.055 41.23 447.055 42.84V43.13C447.055 44.89 447.345 46.5 447.935 48.11C448.375 49.58 449.255 50.75 450.275 51.92C451.305 52.95 452.475 53.68 453.795 54.26C455.265 54.85 456.875 55.14 458.335 55.14C459.655 55.14 460.975 54.99 462.145 54.7C463.175 54.41 464.045 53.97 464.925 53.38C465.655 52.94 466.245 52.35 466.825 51.62C467.265 51.03 467.705 50.45 467.995 49.86L463.155 47.22C462.715 47.95 462.275 48.54 461.545 48.98C460.515 49.57 459.495 49.86 458.325 49.71C457.595 49.71 457.005 49.56 456.275 49.42C455.685 49.27 455.105 48.83 454.515 48.54C454.075 48.1 453.635 47.66 453.345 47.07C453.055 46.48 452.905 45.9 452.905 45.31H469.315V42.23C469.315 41.06 469.025 39.74 468.725 38.57C468.135 37.1 467.555 35.93 466.675 34.91L466.695 34.94ZM452.925 40.22C453.215 39.19 453.805 38.32 454.685 37.73C455.715 37 456.885 36.56 458.205 36.56C459.525 36.56 460.695 36.85 461.725 37.59C462.605 38.18 463.195 39.2 463.485 40.23H452.935L452.925 40.22Z", fill: "#110041" }), /* @__PURE__ */ React.createElement("path", { d: "M485.305 48.9999V22.7799H472.125V28.1999H479.595V48.9999H471.825V54.4299H492.635V48.9999H485.305Z", fill: "#110041" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8643_21216" }, /* @__PURE__ */ React.createElement("rect", { width: 492.13, height: 81.41, fill: "white", transform: "translate(0.504883 0.900024)" }))));
const SvgTigerGlobal = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 574, height: 82, viewBox: "0 0 574 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.599976H248.185V81.96H249.185V0.599976Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 31C19.8349 28.06 16.9749 26.38 12.7749 26.38C4.91488 26.43 0.254883 32.68 0.254883 41.35C0.254883 50.02 4.90488 56.27 12.7749 56.27C14.2149 56.35 15.6649 56.1 17.0049 55.54C18.3449 54.98 19.5449 54.12 20.5149 53.03V57.2C20.5149 60.04 19.0149 63.41 14.2549 63.41C10.6449 63.41 8.86488 61.39 8.24488 59.22L1.85488 62.3101C3.45488 66.4101 7.27488 69.85 14.6949 69.85C25.6949 69.85 28.5249 62.4301 28.5249 55.9301V26.79H21.7949L21.6149 30.99L21.6049 31ZM14.4949 49.47C10.5649 49.47 8.24488 46.27 8.24488 41.29C8.24488 36.31 10.5649 33.11 14.4949 33.11C18.4249 33.11 20.6949 36.31 20.6949 41.29C20.6949 46.27 18.4249 49.47 14.4949 49.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 26.34C176.885 26.34 175.365 26.68 173.985 27.36C172.595 28.04 171.375 29.02 170.415 30.25L169.895 26.8101H162.785V55.8199H171.085V39.4399C171.085 34.9099 172.765 33.14 176.095 33.14C178.415 33.14 180.335 34.17 180.335 38.59V55.83H188.635V36.9C188.635 30.77 184.835 26.35 178.415 26.35L178.425 26.34Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 43.17C49.8749 47.15 48.1949 49.47 44.8749 49.47C42.5549 49.47 40.6149 48.44 40.6149 44.02V26.8H32.3149V45.6899C32.3149 51.8099 36.1149 56.26 42.5349 56.26C44.0749 56.26 45.5949 55.91 46.9849 55.23C48.3749 54.55 49.5949 53.56 50.5549 52.34L51.0749 55.79H58.1649V26.8H49.8649V43.17H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 26.8H62.5347V55.8101H70.8347V26.8Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.865 28.9301C91.855 27.2001 89.275 26.33 86.655 26.48C78.755 26.48 74.085 32.7401 74.085 41.4001C74.085 50.0601 78.755 56.32 86.655 56.32C88.335 56.43 90.015 56.09 91.525 55.33C93.035 54.57 94.325 53.4201 95.265 51.9901L95.465 55.8101H102.195V13.3301H93.895L93.855 28.9301H93.865ZM88.465 49.47C84.535 49.47 82.215 46.2701 82.215 41.2901C82.215 36.3101 84.535 33.11 88.465 33.11C92.395 33.11 94.715 36.3101 94.715 41.2901C94.715 46.2701 92.395 49.47 88.465 49.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6848 12.64C65.7648 12.64 64.8748 12.92 64.1148 13.43C63.3548 13.95 62.7648 14.68 62.4148 15.55C62.0648 16.41 61.9748 17.36 62.1548 18.27C62.3348 19.18 62.7748 20.0201 63.4248 20.6801C64.0748 21.3401 64.8948 21.79 65.7948 21.97C66.6948 22.15 67.6248 22.06 68.4648 21.7C69.3148 21.34 70.0348 20.74 70.5448 19.96C71.0548 19.18 71.3248 18.27 71.3248 17.34C71.3248 16.09 70.8348 14.89 69.9648 14.01C69.0948 13.13 67.9148 12.63 66.6948 12.63L66.6848 12.64Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.395 26.8H150.095V55.8101H158.395V26.8Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.64C153.335 12.64 152.445 12.92 151.685 13.43C150.925 13.95 150.335 14.68 149.975 15.55C149.625 16.41 149.535 17.36 149.715 18.27C149.895 19.18 150.335 20.0201 150.985 20.6801C151.635 21.3401 152.455 21.79 153.355 21.97C154.255 22.15 155.185 22.06 156.025 21.7C156.875 21.34 157.595 20.74 158.105 19.96C158.615 19.18 158.885 18.27 158.885 17.34C158.885 16.09 158.395 14.89 157.525 14.01C156.655 13.13 155.475 12.63 154.255 12.63V12.64Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.885 42.24V41.36C218.885 32.4 213.835 26.4399 205.505 26.4399C197.175 26.4399 191.565 32.4 191.565 41.36C191.565 50.32 197.185 56.28 205.505 56.28C211.265 56.28 215.555 53.49 217.585 48.78L211.575 45.88C211.185 47.14 210.395 48.22 209.335 48.98C208.275 49.74 207.005 50.1199 205.705 50.0699C204.175 50.1099 202.675 49.56 201.535 48.52C200.395 47.48 199.675 46.03 199.545 44.48H199.605L218.885 42.25V42.24ZM199.345 39.3101C199.345 35.1001 201.805 32.34 205.475 32.34C206.985 32.31 208.445 32.88 209.565 33.91C210.685 34.95 211.365 36.38 211.485 37.91L199.345 39.3101Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 26.4301C110.725 26.4301 105.105 32.39 105.105 41.35C105.105 50.31 110.725 56.27 119.055 56.27C124.805 56.27 129.095 53.48 131.075 48.77L125.065 45.87C124.675 47.11 123.905 48.1799 122.865 48.9399C121.825 49.6899 120.575 50.0901 119.305 50.0601C117.755 50.1301 116.245 49.58 115.085 48.54C113.925 47.5 113.195 46.04 113.065 44.47L132.305 42.22V41.34C132.425 32.4 127.375 26.4399 119.055 26.4399V26.4301ZM112.865 39.3101C112.865 35.1001 115.275 32.34 119.005 32.34C120.515 32.31 121.975 32.88 123.095 33.91C124.215 34.95 124.895 36.38 125.015 37.91L112.855 39.3101H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.545 47.07V13.3301H135.245V47.9301C135.245 51.9501 136.035 56.1401 143.065 56.1401C144.395 56.2101 145.725 55.99 146.965 55.48V49.0001C146.965 49.0001 143.545 49.88 143.545 47.07Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.905 63.4399H33.2949V76.17H0.504883V82.01H39.0249V69.27H218.905V63.4399Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M294.355 32.39V47.75C294.215 49.44 294.565 51.14 295.355 52.64C296.215 53.69 297.515 54.29 298.875 54.24C299.365 54.28 299.615 54.53 299.615 54.97C299.615 55.29 299.405 55.4399 298.975 55.4399C298.885 55.4399 298.705 55.44 298.465 55.42L296.935 55.36L294.385 55.1899C294.185 55.1799 293.905 55.17 293.565 55.17C292.775 55.17 292.065 55.19 291.445 55.23L286.945 55.5C286.465 55.56 286.135 55.58 285.965 55.58C285.545 55.58 285.335 55.4 285.345 55.04C285.325 54.82 285.395 54.61 285.545 54.45C285.795 54.33 286.065 54.27 286.335 54.27C287.285 54.26 288.175 53.84 288.795 53.12C289.415 52.3 289.715 51.28 289.655 50.25L289.635 49.29V31.1801C289.635 30.1101 289.055 29.5699 287.905 29.5699C286.025 29.4599 284.145 29.67 282.335 30.16C281.765 30.35 281.265 30.7 280.895 31.17C280.465 32.06 280.145 33 279.925 33.96L279.755 34.53C279.605 35.09 279.375 35.37 279.065 35.37C278.615 35.37 278.405 35.16 278.435 34.74C278.465 34.21 278.535 33.68 278.635 33.15L278.835 31.38L279.085 29.5699L279.235 28.3199C279.225 27.8899 279.565 27.53 279.995 27.52C280.025 27.52 280.055 27.52 280.085 27.52C280.225 27.52 280.455 27.5301 280.775 27.5601C281.305 27.6001 282.065 27.62 283.045 27.62L287.205 27.66L292.165 27.72C295.365 27.72 298.745 27.63 302.325 27.45C303.035 27.42 303.495 27.41 303.695 27.41C304.445 27.41 304.835 27.73 304.875 28.35L304.975 29.8199C304.985 30.0499 305.055 30.61 305.175 31.47C305.255 32.05 305.305 32.63 305.325 33.21C305.325 33.66 305.135 33.88 304.765 33.88C304.465 33.88 304.245 33.62 304.115 33.1C303.945 32.01 303.355 31.02 302.475 30.35C301.415 29.72 300.185 29.43 298.955 29.51C297.645 29.4 296.325 29.56 295.085 29.99C294.575 30.3 294.325 31.09 294.325 32.36L294.355 32.39Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M315.005 49.02L315.165 51.0601C315.265 51.9801 315.685 52.83 316.355 53.46C317.045 54.04 317.935 54.34 318.835 54.3C319.505 54.3 319.835 54.5101 319.835 54.9301C319.835 55.3201 319.395 55.53 318.505 55.53C318.125 55.53 317.585 55.49 316.875 55.42C315.445 55.24 314.015 55.14 312.575 55.12C311.495 55.1 310.415 55.17 309.345 55.34C308.865 55.44 308.375 55.51 307.875 55.53C307.605 55.55 307.355 55.36 307.305 55.09L307.265 54.92L307.855 54.4399C308.625 54.2299 309.315 53.78 309.805 53.15C310.185 52.36 310.345 51.49 310.285 50.61L310.305 48.8V32.5699C310.385 31.6299 310.155 30.7 309.655 29.9C309.015 29.27 308.165 28.89 307.265 28.84C306.805 28.79 306.355 28.69 305.925 28.52C305.725 28.42 305.615 28.21 305.625 27.99C305.625 27.6 305.795 27.4201 306.115 27.4301C306.485 27.4601 306.855 27.52 307.215 27.59C308.025 27.73 308.855 27.78 309.685 27.76C310.445 27.76 311.395 27.72 312.515 27.63L314.005 27.52C315.405 27.42 316.475 27.36 317.225 27.36C317.675 27.36 317.905 27.53 317.905 27.86C317.925 28.03 317.885 28.21 317.805 28.36C317.655 28.48 317.475 28.54 317.295 28.54C316.585 28.58 315.915 28.87 315.415 29.36C315.065 30.08 314.925 30.8801 314.995 31.6801V49.02H315.005Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M335.515 26.96C338.275 27.08 340.995 27.7499 343.485 28.9399C343.955 29.1699 344.455 29.3401 344.975 29.4301C345.165 29.4301 345.345 29.36 345.485 29.23L345.715 29.02C345.845 28.89 346.025 28.81 346.205 28.8C346.605 28.78 346.815 29.03 346.815 29.53L346.795 30.96L346.715 33.76L346.775 35.23C346.805 35.59 346.845 35.99 346.895 36.41C346.905 36.57 346.915 36.7 346.915 36.77C346.915 37.21 346.705 37.42 346.275 37.39C345.995 37.38 345.805 37.09 345.705 36.54C345.335 34.73 344.435 33.06 343.115 31.76C341.235 29.63 338.515 28.43 335.675 28.46C333.055 28.39 330.565 29.61 329.025 31.73C327.245 34.27 326.375 37.3401 326.535 40.4301C326.415 43.8801 327.315 47.29 329.105 50.24C330.825 52.9 332.935 54.22 335.445 54.22C336.415 54.18 337.375 54.01 338.295 53.72C339.215 53.49 340.105 53.12 340.915 52.64C341.465 52.28 341.865 51.73 342.045 51.09C342.295 50.06 342.405 48.9999 342.365 47.9399C342.485 46.7399 342.175 45.5401 341.485 44.5601C340.565 43.8101 339.385 43.43 338.195 43.49C337.775 43.46 337.565 43.26 337.565 42.89C337.565 42.52 337.815 42.3199 338.305 42.3199C338.455 42.3199 338.695 42.34 339.015 42.36C340.355 42.47 341.865 42.54 343.555 42.54C344.835 42.56 346.115 42.51 347.395 42.4C347.905 42.32 348.415 42.28 348.935 42.28C349.425 42.28 349.665 42.4599 349.665 42.8199C349.665 43.1499 349.425 43.37 348.935 43.46C348.215 43.58 347.595 44.05 347.305 44.73C346.945 45.84 346.795 47.01 346.855 48.17C346.855 48.62 346.875 49.07 346.915 49.51C346.975 50.19 346.995 50.6601 346.995 50.9301C347.025 51.2601 346.935 51.59 346.735 51.86C346.445 52.13 346.085 52.3299 345.705 52.4399C345.385 52.5499 344.305 53.0101 342.465 53.8101C339.795 55.0701 336.905 55.78 333.965 55.91C330.565 56.02 327.285 54.6601 324.955 52.1801C322.565 49.5501 321.315 46.08 321.465 42.53C321.345 38.46 322.785 34.49 325.495 31.45C328.005 28.55 331.665 26.91 335.495 26.97L335.515 26.96Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M360.395 32.16V36.58C360.325 37.39 360.425 38.21 360.675 38.99C360.855 39.33 361.295 39.5 362.005 39.5L362.625 39.48L363.515 39.46H365.245C366.645 39.43 367.885 38.54 368.365 37.23L368.835 36.23C368.945 36 369.185 35.85 369.445 35.84C369.745 35.83 369.895 36.01 369.895 36.4C369.895 36.5 369.875 36.81 369.835 37.3C369.805 37.65 369.795 37.96 369.795 38.2C369.795 38.64 369.855 39.65 369.975 41.27C370.055 42.32 370.095 43.23 370.095 44.01L370.125 45.05C370.135 45.18 370.115 45.3099 370.055 45.4399C369.975 45.5399 369.855 45.59 369.735 45.59C369.395 45.62 369.185 45.3601 369.095 44.8101C368.995 43.8201 368.565 42.8901 367.875 42.1801C367.515 41.8501 367.065 41.63 366.575 41.54C365.625 41.42 364.665 41.38 363.705 41.4H362.315C361.845 41.35 361.375 41.46 360.975 41.7C360.685 42.03 360.515 42.45 360.495 42.89C360.395 43.96 360.355 45.04 360.375 46.11V47.9399C360.315 49.3299 360.465 50.7299 360.825 52.0699C361.035 53.1199 362.035 53.81 363.095 53.64C368.615 53.64 372.225 51.96 373.925 48.61C374.015 48.45 374.105 48.36 374.165 48.35C374.305 48.32 374.455 48.38 374.545 48.48C374.655 48.6 374.725 48.75 374.715 48.92C374.715 50.29 374.335 51.63 373.635 52.8C373.135 53.77 372.355 54.56 371.395 55.08C370.275 55.58 369.055 55.82 367.825 55.77C366.855 55.77 365.885 55.71 364.925 55.6L362.555 55.38C361.685 55.3 360.515 55.26 359.025 55.26C358.035 55.26 356.525 55.3199 354.495 55.4399C353.935 55.4799 353.535 55.5 353.295 55.5C353.045 55.54 352.805 55.36 352.765 55.11C352.765 55.09 352.765 55.07 352.765 55.05C352.765 54.8 352.905 54.61 353.215 54.48C353.805 54.29 354.345 53.97 354.795 53.53C355.155 53 355.375 52.39 355.455 51.75C355.625 50.78 355.705 49.8001 355.685 48.8101V32.67C355.805 31.58 355.535 30.49 354.935 29.58C354.055 28.88 352.975 28.4799 351.845 28.4399C351.535 28.4399 351.285 28.17 351.295 27.86V27.84C351.295 27.52 351.525 27.36 351.965 27.36C352.065 27.36 352.265 27.38 352.585 27.4C352.825 27.42 353.165 27.42 353.585 27.42L355.645 27.51L363.375 27.59C367.825 27.59 370.565 27.53 371.595 27.41C371.695 27.4 371.795 27.39 371.875 27.39C372.275 27.39 372.465 27.6101 372.465 28.0601C372.465 28.3801 372.505 28.94 372.585 29.74C372.685 30.92 372.745 31.78 372.745 32.29C372.745 33.32 372.475 33.85 371.955 33.88C371.695 33.9 371.575 33.59 371.575 32.98C371.665 31.8 371.095 30.67 370.095 30.03C368.605 29.32 366.965 29.01 365.315 29.12H362.825L361.435 29.28C360.735 29.49 360.385 30.19 360.385 31.34V32.1801L360.395 32.16Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M384.995 47.4101C384.865 49.1901 385.115 50.9701 385.715 52.6501C386.305 53.6401 387.375 54.24 388.535 54.23C389.105 54.29 389.385 54.5101 389.385 54.9001C389.385 55.2901 389.155 55.48 388.695 55.48C388.545 55.48 388.265 55.4601 387.855 55.4201C386.685 55.3301 385.555 55.2801 384.465 55.2801C383.555 55.2801 382.745 55.31 382.035 55.36L380.325 55.5201L378.955 55.6301C378.575 55.6701 378.305 55.69 378.165 55.69C377.675 55.69 377.435 55.5001 377.435 55.1301C377.405 54.8601 377.585 54.6101 377.845 54.5501C378.585 54.3801 379.265 53.9801 379.765 53.4001C380.165 52.7401 380.355 51.97 380.295 51.19V49.2601L380.325 48.47V33.74C380.435 32.61 380.215 31.48 379.705 30.47C378.895 29.48 377.715 28.89 376.445 28.83C375.885 28.75 375.605 28.51 375.605 28.12C375.565 27.84 375.755 27.5801 376.035 27.5401C376.085 27.5401 376.135 27.5401 376.175 27.5401C376.425 27.5401 376.665 27.56 376.905 27.6C378.045 27.72 379.195 27.7701 380.355 27.7701C381.725 27.7701 383.395 27.6901 385.355 27.5401C387.655 27.3601 389.245 27.2701 390.105 27.2701C392.435 27.1801 394.705 27.9301 396.525 29.3801C398.165 30.6501 399.105 32.62 399.075 34.69C399.085 36 398.695 37.29 397.945 38.36C397.175 39.48 396.095 40.35 394.835 40.87C394.565 40.98 394.435 41.1201 394.455 41.2801C394.485 41.4601 394.555 41.6301 394.655 41.7701C394.775 41.9601 394.955 42.28 395.205 42.73L397.015 45.95L399.115 49.6801C399.615 50.6501 400.265 51.5301 401.045 52.3001C401.595 52.7901 402.305 53.0501 403.035 53.0301C403.325 53.0301 403.615 53.01 403.905 52.95C404.055 52.91 404.205 52.8901 404.355 52.8901C404.605 52.8901 404.725 53.05 404.725 53.36C404.725 53.75 404.165 54.2 403.065 54.7C402.135 55.16 401.125 55.41 400.095 55.45C398.565 55.38 397.145 54.6301 396.235 53.3901C394.425 50.9701 392.875 48.36 391.635 45.6C391.205 44.55 390.595 43.58 389.825 42.74C389.145 42.28 388.325 42.0601 387.495 42.1401H386.235L385.315 42.3001C385.115 42.4101 385.005 42.7401 385.005 43.2801V47.4101H384.995ZM384.995 31.49V38.5501C384.925 39.1201 385.045 39.7 385.335 40.2C385.815 40.5 386.375 40.6201 386.935 40.5501C388.435 40.5801 389.945 40.5501 391.445 40.4201C392.055 40.3201 392.625 40.03 393.075 39.59C394.095 38.63 394.645 37.2801 394.565 35.8801C394.685 32.0801 391.705 28.9001 387.905 28.7801C387.745 28.7801 387.595 28.7801 387.435 28.7801C386.745 28.7001 386.055 28.91 385.525 29.36C385.105 29.98 384.915 30.73 384.995 31.48V31.49Z", fill: "#E67B26" }), /* @__PURE__ */ React.createElement("path", { d: "M420.925 26.96C423.685 27.08 426.405 27.7499 428.905 28.9399C429.375 29.1699 429.875 29.3401 430.395 29.4301C430.585 29.4301 430.765 29.36 430.905 29.23L431.135 29.02C431.265 28.89 431.435 28.81 431.625 28.8C432.035 28.78 432.235 29.03 432.235 29.53L432.215 30.96L432.135 33.76L432.195 35.23C432.225 35.59 432.265 35.99 432.305 36.41C432.315 36.57 432.325 36.7 432.325 36.77C432.325 37.21 432.115 37.42 431.695 37.39C431.405 37.38 431.215 37.09 431.115 36.54C430.745 34.73 429.845 33.06 428.535 31.76C426.655 29.63 423.935 28.43 421.095 28.46C418.475 28.39 415.985 29.61 414.445 31.73C412.675 34.28 411.795 37.3401 411.955 40.4301C411.835 43.8801 412.735 47.29 414.525 50.24C416.245 52.9 418.355 54.22 420.865 54.22C421.835 54.18 422.795 54.01 423.715 53.72C424.635 53.49 425.525 53.12 426.345 52.64C426.895 52.28 427.295 51.73 427.465 51.09C427.715 50.06 427.825 48.9999 427.785 47.9399C427.905 46.7399 427.595 45.5401 426.915 44.5601C425.995 43.8101 424.815 43.43 423.625 43.49C423.205 43.46 422.995 43.26 422.995 42.89C422.995 42.52 423.235 42.3199 423.725 42.3199C423.875 42.3199 424.115 42.34 424.435 42.36C425.765 42.47 427.285 42.54 428.965 42.54C430.245 42.56 431.525 42.51 432.805 42.4C433.315 42.32 433.825 42.28 434.335 42.28C434.835 42.28 435.075 42.4599 435.075 42.8199C435.075 43.1499 434.825 43.37 434.345 43.46C433.625 43.58 433.005 44.05 432.705 44.73C432.345 45.84 432.185 47.01 432.255 48.17C432.255 48.62 432.275 49.07 432.315 49.51C432.365 50.19 432.395 50.6601 432.395 50.9301C432.425 51.2601 432.335 51.59 432.145 51.86C431.855 52.13 431.495 52.3299 431.105 52.4399C430.795 52.5499 429.715 53.0101 427.865 53.8101C425.195 55.0701 422.305 55.78 419.355 55.91C415.955 56.02 412.675 54.6601 410.355 52.1801C407.965 49.5501 406.705 46.08 406.855 42.53C406.735 38.46 408.185 34.49 410.895 31.45C413.405 28.54 417.085 26.9 420.925 26.97V26.96Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M445.825 48.98C445.825 51.52 446.135 52.95 446.745 53.25C447.385 53.47 448.065 53.57 448.735 53.52C453.345 53.52 456.615 52.17 458.535 49.46C459.125 48.63 459.495 48.21 459.645 48.21C459.905 48.21 460.025 48.49 460.025 49.05C460.035 50.75 459.435 52.3901 458.335 53.6801C457.335 54.8801 455.835 55.55 454.275 55.48C453.925 55.48 453.275 55.45 452.335 55.38L449.885 55.23L447.665 55.13C446.915 55.09 446.065 55.0699 445.115 55.0699C443.415 55.0699 441.705 55.18 440.015 55.38C439.455 55.44 439.085 55.47 438.895 55.47C438.495 55.47 438.305 55.2899 438.305 54.9399C438.305 54.6799 438.485 54.51 438.825 54.41C439.605 54.24 440.275 53.72 440.635 53C441.035 51.9 441.205 50.7399 441.135 49.5699V32.5601C441.135 30.3901 440.235 29.16 438.425 28.87L437.195 28.67C436.685 28.59 436.415 28.38 436.415 28.05C436.375 27.75 436.575 27.4701 436.875 27.4301C436.925 27.4301 436.975 27.4301 437.025 27.4301C437.225 27.4301 437.425 27.46 437.615 27.49C437.805 27.5 438.065 27.5299 438.405 27.5699L439.285 27.63C440.115 27.71 440.735 27.75 441.145 27.75C442.185 27.72 443.235 27.64 444.265 27.51C445.345 27.4 446.425 27.34 447.515 27.34C448.335 27.34 448.745 27.54 448.745 27.92C448.745 28.25 448.445 28.44 447.865 28.46C446.485 28.55 445.805 29.5 445.805 31.29V48.96L445.825 48.98Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M476.685 26.92C480.465 26.75 484.165 28.08 486.965 30.63C489.605 33.16 491.025 36.7 490.885 40.36C490.995 44.44 489.545 48.4099 486.845 51.4699C484.225 54.4399 480.605 55.92 475.995 55.92C472.095 56.11 468.285 54.72 465.425 52.06C462.725 49.32 461.285 45.5699 461.465 41.7199C461.465 39.8299 461.815 37.9699 462.465 36.1999C463.725 32.5099 466.555 29.57 470.205 28.18C472.265 27.35 474.465 26.9299 476.675 26.9399L476.685 26.92ZM475.215 28.4499C472.715 28.3399 470.315 29.48 468.815 31.49C467.275 33.52 466.505 36.3399 466.505 39.9599C466.335 43.6499 467.355 47.3 469.405 50.37C471.065 52.9 473.905 54.41 476.925 54.38C479.565 54.45 482.075 53.21 483.615 51.06C485.405 48.46 486.285 45.3499 486.125 42.1999C486.125 40.0599 485.725 37.9399 484.965 35.9499C484.315 34.1199 483.255 32.46 481.865 31.1C480.085 29.38 477.705 28.4199 475.225 28.4499H475.215Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M497.375 33.36C497.375 30.62 496.255 29.12 494.025 28.86L493.085 28.74C492.785 28.71 492.635 28.5101 492.635 28.1601C492.635 27.7501 492.825 27.5501 493.205 27.5501L493.715 27.57L495.245 27.6601C496.515 27.7201 497.315 27.74 497.675 27.74C498.655 27.74 500.445 27.62 503.035 27.39C504.635 27.24 505.995 27.1601 507.095 27.1601C509.555 27.0401 511.995 27.6901 514.065 29.0301C515.735 30.1301 516.725 32.01 516.685 34.01C516.805 36.21 515.485 38.23 513.425 39C512.925 39.22 512.665 39.4101 512.645 39.5501C512.635 39.7901 512.895 39.9601 513.435 40.0401C515.005 40.2701 516.435 41.06 517.465 42.27C518.475 43.52 518.995 45.09 518.935 46.7C519.045 49.13 518.055 51.48 516.235 53.09C514.165 54.74 511.565 55.58 508.925 55.44L504.785 55.32L501.605 55.26C499.835 55.25 498.065 55.33 496.305 55.5C495.875 55.55 495.435 55.58 495.005 55.58C494.595 55.58 494.395 55.4001 494.395 55.0401C494.395 54.7401 494.575 54.55 494.945 54.47C496.565 54.2 497.375 52.8 497.375 50.26V33.36ZM502.075 31.59V37.45C502.005 38.07 502.215 38.68 502.645 39.13C503.245 39.51 503.945 39.67 504.645 39.61L507.465 39.6701L508.735 39.61C511.065 39.32 512.225 37.9301 512.225 35.4301C512.305 33.6001 511.595 31.8101 510.285 30.5301C508.905 29.2501 507.065 28.5801 505.185 28.6601C504.315 28.5601 503.435 28.77 502.715 29.26C502.215 29.93 501.985 30.77 502.085 31.6L502.075 31.59ZM502.075 45.1701V48.5501L502.135 49.32L502.275 51.0501C502.445 53.0101 503.995 53.98 506.935 53.98C509.835 53.98 511.815 53.28 512.885 51.88C513.775 50.66 514.225 49.19 514.195 47.69C514.195 44.5 512.775 42.5301 509.925 41.8001C508.095 41.3601 506.215 41.1501 504.325 41.1701C503.345 41.1701 502.725 41.4 502.465 41.87C502.125 42.94 501.995 44.0601 502.075 45.1701Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M536.145 29.76L545.425 51.0601C545.785 51.9701 546.335 52.8 547.055 53.46C547.755 54.02 548.595 54.39 549.485 54.52C549.725 54.56 549.845 54.75 549.845 55.1C549.845 55.47 549.685 55.65 549.375 55.64C549.115 55.62 548.855 55.58 548.595 55.52C546.925 55.24 545.225 55.12 543.525 55.17C541.925 55.11 540.325 55.22 538.745 55.49C538.575 55.54 538.395 55.57 538.215 55.58C537.935 55.62 537.685 55.42 537.645 55.14C537.645 55.09 537.645 55.05 537.645 55C537.645 54.81 537.795 54.6601 538.095 54.5601C538.725 54.3801 539.285 54.03 539.715 53.54C540.115 53.12 540.345 52.57 540.355 51.99C540.035 50.24 539.435 48.54 538.595 46.97C538.225 46.18 537.825 45.73 537.385 45.62C535.825 45.44 534.265 45.3799 532.695 45.4399H529.925L528.095 45.77C527.585 46 527.025 46.89 526.385 48.46L525.755 50.03C525.565 50.46 525.475 50.92 525.465 51.39C525.465 53.1 526.665 54.09 529.055 54.36C529.565 54.43 529.825 54.63 529.805 54.96C529.775 55.32 529.535 55.5 529.075 55.5C528.725 55.49 528.375 55.45 528.025 55.38C527.235 55.21 526.425 55.12 525.615 55.11C524.975 55.11 523.935 55.1799 522.505 55.3199C521.445 55.4299 520.785 55.48 520.525 55.48C520.145 55.48 519.955 55.31 519.955 54.98C519.955 54.7 520.145 54.5 520.525 54.36C521.235 54.14 521.855 53.7 522.285 53.09C523.045 51.85 523.705 50.5399 524.255 49.1899L529.825 36.36C530.275 35.34 530.585 34.64 530.765 34.26L532.655 30.37L533.635 28.45V28.51C534.075 27.48 534.365 26.96 534.515 26.96C534.735 26.96 535.105 27.53 535.635 28.67L536.105 29.76H536.145ZM536.905 42.51L534.245 36.28C533.605 34.79 533.155 34.05 532.885 34.05C532.725 34.05 532.435 34.53 531.995 35.49L531.605 36.34L529.225 41.77L528.995 42.27C528.905 42.43 528.855 42.61 528.845 42.8C528.845 43.25 529.335 43.49 530.305 43.49H536.325C536.835 43.49 537.105 43.3501 537.105 43.0601C537.085 42.9401 537.055 42.83 537.005 42.72L536.905 42.49V42.51Z", fill: "#545456" }), /* @__PURE__ */ React.createElement("path", { d: "M558.965 48.98C558.965 51.52 559.265 52.95 559.885 53.25C560.525 53.48 561.195 53.57 561.875 53.52C566.485 53.52 569.755 52.17 571.675 49.46C572.265 48.63 572.645 48.21 572.795 48.21C573.045 48.21 573.165 48.49 573.165 49.05C573.175 50.75 572.575 52.3901 571.475 53.6801C570.475 54.8801 568.975 55.54 567.415 55.48C567.055 55.48 566.415 55.45 565.475 55.38L563.025 55.23L560.805 55.13C560.065 55.09 559.205 55.0699 558.255 55.0699C556.555 55.0699 554.845 55.18 553.155 55.38C552.595 55.44 552.225 55.47 552.025 55.47C551.635 55.47 551.435 55.2899 551.435 54.9399C551.435 54.6799 551.615 54.51 551.965 54.41C552.745 54.23 553.415 53.72 553.775 53C554.175 51.9 554.335 50.7399 554.265 49.5699V32.5601C554.265 30.3901 553.365 29.16 551.555 28.87L550.335 28.67C549.815 28.59 549.555 28.38 549.555 28.05C549.515 27.75 549.715 27.4701 550.015 27.4301C550.065 27.4301 550.115 27.4301 550.175 27.4301C550.375 27.4301 550.565 27.46 550.765 27.49C550.955 27.5 551.225 27.5299 551.555 27.5699L552.435 27.63C553.265 27.71 553.885 27.76 554.295 27.75C554.945 27.75 555.995 27.67 557.425 27.51C558.505 27.4 559.585 27.34 560.665 27.34C561.485 27.34 561.895 27.54 561.895 27.92C561.895 28.25 561.595 28.44 561.015 28.46C559.645 28.55 558.955 29.5 558.955 31.29V48.96L558.965 48.98Z", fill: "#545456" }));
const SvgXfund = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 348, height: 82, viewBox: "0 0 348 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M249.185 0.25H248.185V81.61H249.185V0.25Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6049 30.65C19.8349 27.71 16.9749 26.03 12.7749 26.03C4.91488 26.08 0.254883 32.33 0.254883 41C0.254883 49.67 4.90488 55.92 12.7749 55.92C14.2149 56 15.6649 55.7499 17.0049 55.1899C18.3449 54.6299 19.5449 53.7701 20.5149 52.6801V56.85C20.5149 59.69 19.0149 63.0601 14.2549 63.0601C10.6449 63.0601 8.86488 61.04 8.24488 58.87L1.85488 61.96C3.45488 66.06 7.27488 69.5 14.6949 69.5C25.6949 69.5 28.5249 62.08 28.5249 55.58V26.4399H21.7949L21.6149 30.64L21.6049 30.65ZM14.4949 49.12C10.5649 49.12 8.24488 45.9199 8.24488 40.9399C8.24488 35.9599 10.5649 32.76 14.4949 32.76C18.4249 32.76 20.6949 35.9599 20.6949 40.9399C20.6949 45.9199 18.4249 49.12 14.4949 49.12Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.425 25.99C176.885 25.99 175.365 26.33 173.985 27.01C172.595 27.69 171.375 28.67 170.415 29.9L169.895 26.46H162.785V55.48H171.085V39.1C171.085 34.57 172.765 32.8 176.095 32.8C178.415 32.8 180.335 33.83 180.335 38.25V55.49H188.635V36.5601C188.635 30.4301 184.835 26.01 178.415 26.01L178.425 25.99Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.8749 42.8199C49.8749 46.7999 48.1949 49.13 44.8749 49.13C42.5549 49.13 40.6149 48.1001 40.6149 43.6801V26.45H32.3149V45.34C32.3149 51.46 36.1149 55.91 42.5349 55.91C44.0749 55.91 45.5949 55.56 46.9849 54.88C48.3749 54.2 49.5949 53.21 50.5549 51.99L51.0749 55.4399H58.1649V26.45H49.8649V42.8199H49.8749Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.8347 26.45H62.5347V55.47H70.8347V26.45Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.8647 28.58C91.8547 26.85 89.2747 25.97 86.6447 26.13C78.7447 26.13 74.0747 32.39 74.0747 41.05C74.0747 49.71 78.7447 55.97 86.6447 55.97C88.3247 56.08 90.0047 55.74 91.5147 54.98C93.0247 54.22 94.3147 53.07 95.2547 51.64L95.4547 55.46H102.185V12.98H93.8847L93.8447 28.58H93.8647ZM88.4647 49.12C84.5347 49.12 82.2147 45.9199 82.2147 40.9399C82.2147 35.9599 84.5347 32.76 88.4647 32.76C92.3947 32.76 94.7147 35.9599 94.7147 40.9399C94.7147 45.9199 92.3947 49.12 88.4647 49.12Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.6948 12.29C65.7748 12.29 64.8848 12.57 64.1248 13.08C63.3648 13.6 62.7748 14.33 62.4148 15.2C62.0648 16.06 61.9748 17.01 62.1548 17.92C62.3348 18.83 62.7748 19.67 63.4248 20.33C64.0748 20.99 64.8948 21.44 65.7948 21.62C66.6948 21.8 67.6248 21.71 68.4648 21.35C69.3148 20.99 70.0348 20.39 70.5448 19.61C71.0548 18.83 71.3248 17.92 71.3248 16.99C71.3248 15.74 70.8348 14.54 69.9648 13.66C69.0948 12.78 67.9148 12.28 66.6948 12.28V12.29Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.405 26.45H150.105V55.47H158.405V26.45Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154.255 12.29C153.335 12.29 152.445 12.57 151.685 13.08C150.925 13.6 150.335 14.33 149.975 15.2C149.625 16.06 149.535 17.01 149.715 17.92C149.895 18.83 150.335 19.67 150.985 20.33C151.635 20.99 152.455 21.44 153.355 21.62C154.255 21.8 155.185 21.71 156.025 21.35C156.875 20.99 157.595 20.39 158.105 19.61C158.615 18.83 158.885 17.92 158.885 16.99C158.885 15.74 158.395 14.54 157.525 13.66C156.655 12.78 155.475 12.28 154.255 12.28V12.29Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.895 41.89V41.01C218.895 32.05 213.845 26.09 205.515 26.09C197.185 26.09 191.575 32.05 191.575 41.01C191.575 49.97 197.195 55.9301 205.515 55.9301C211.275 55.9301 215.565 53.1401 217.605 48.4301L211.595 45.53C211.205 46.79 210.415 47.87 209.355 48.63C208.295 49.39 207.025 49.77 205.725 49.72C204.195 49.76 202.695 49.21 201.555 48.17C200.415 47.13 199.695 45.68 199.565 44.13H199.625L218.905 41.9L218.895 41.89ZM199.355 38.96C199.355 34.75 201.825 31.99 205.485 31.99C206.995 31.96 208.455 32.5301 209.575 33.5601C210.695 34.6001 211.375 36.0301 211.495 37.5601L199.355 38.96Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M119.055 26.08C110.725 26.08 105.105 32.04 105.105 41C105.105 49.96 110.725 55.92 119.055 55.92C124.805 55.92 129.095 53.13 131.075 48.42L125.065 45.52C124.675 46.76 123.905 47.83 122.865 48.59C121.825 49.34 120.575 49.74 119.305 49.71C117.755 49.78 116.245 49.2299 115.085 48.1899C113.925 47.1499 113.195 45.69 113.065 44.12L132.305 41.87V40.99C132.425 32.05 127.375 26.09 119.055 26.09V26.08ZM112.865 38.96C112.865 34.75 115.275 31.99 119.005 31.99C120.515 31.96 121.975 32.5301 123.095 33.5601C124.215 34.6001 124.895 36.0301 125.015 37.5601L112.855 38.96H112.865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.555 46.73V12.99H135.255V47.59C135.255 51.61 136.045 55.8 143.075 55.8C144.405 55.87 145.735 55.65 146.975 55.14V48.66C146.975 48.66 143.555 49.54 143.555 46.73Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.915 63.09H33.2949V75.8199H0.504883V81.66H39.0249V68.92H218.915V63.09Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M278.465 6.04004V75.42H347.845V6.04004H278.465ZM342.845 70.42H283.475V11.05H342.845V70.42Z", fill: "#CF0024" }), /* @__PURE__ */ React.createElement("path", { d: "M300.655 58.73L306.905 48.78L313.155 58.73H323.015L311.875 40.88L323.015 23.14H313.005L306.905 32.92L300.805 23.14H290.795L301.935 40.88L290.795 58.73H300.655Z", fill: "#CF0024" }), /* @__PURE__ */ React.createElement("path", { d: "M332.125 58.73L331.795 41.23H335.425V34.08H331.885L331.865 32.5401C331.865 32.5401 331.635 29.97 334.575 29.97H335.025V22.63C335.025 22.63 323.155 21.3501 323.155 32.6601V33.84L323.475 58.73H332.125Z", fill: "#CF0024" }));
const SvgBennie$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 246, height: 82, viewBox: "0 0 246 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M245.03 39.9939C245.03 34.2239 240.92 26.6439 231.62 26.6439C223.51 26.6439 217.84 33.1939 217.84 41.1539V41.2539C217.84 49.7839 224.03 55.6539 232.4 55.6539C236.45 55.6539 239.63 54.3539 242.07 52.2739C242.64 51.7539 243.11 50.9739 243.11 49.9339C243.11 48.1639 241.81 46.8139 240.04 46.8139C239.21 46.8139 238.69 47.0239 238.11 47.4339C236.5 48.6339 234.68 49.3039 232.49 49.3039C228.96 49.3039 226.46 47.4339 225.68 43.8439H241.16C243.16 43.8439 245.02 42.1539 245.02 39.9839L245.03 39.9939ZM225.45 37.9739C226.35 34.8139 228.49 32.8239 231.62 32.8239C234.75 32.8239 236.89 34.8639 237.67 37.9739H225.45Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M211.98 24.7639C214.343 24.7639 216.26 22.8477 216.26 20.4839C216.26 18.1201 214.343 16.2039 211.98 16.2039C209.616 16.2039 207.7 18.1201 207.7 20.4839C207.7 22.8477 209.616 24.7639 211.98 24.7639Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M211.98 26.8539C209.8 26.8539 208.03 28.6239 208.03 30.8039V44.9939H208.01V45.2539C208.01 45.2539 208.01 47.8039 205.73 47.8039C203.71 47.8039 203.71 45.2839 203.71 45.2339C203.71 45.2339 203.71 45.1139 203.71 45.0339C203.71 45.0239 203.71 45.0139 203.71 44.9939V36.9839C203.71 30.5839 200.23 26.6339 194.25 26.6339C190.25 26.6339 187.9 28.7639 186.09 31.1039V30.7939C186.09 28.6139 184.32 26.8439 182.14 26.8439C179.96 26.8439 178.19 28.6139 178.19 30.7939V45.2539C178.19 45.2539 178.19 47.8039 175.91 47.8039C173.89 47.8039 173.89 45.2839 173.89 45.2339C173.89 45.2339 173.88 45.0739 173.88 44.9939V36.9839C173.88 30.5839 170.4 26.6339 164.42 26.6339C160.42 26.6339 158.07 28.7639 156.26 31.1039V30.7939C156.26 28.6139 154.49 26.8439 152.31 26.8439C150.13 26.8439 148.36 28.6139 148.36 30.7939V51.3839C148.36 53.5639 150.13 55.3339 152.31 55.3339C154.49 55.3339 156.26 53.5639 156.26 51.3839V39.4739C156.26 35.7339 158.19 33.8039 161.2 33.8039C164.21 33.8039 165.98 35.7339 165.98 39.4739V45.1239C165.98 45.6039 165.98 49.8939 168.94 52.9139C170.16 54.1639 172.36 55.6539 175.87 55.6539C175.89 55.6539 175.91 55.6539 175.93 55.6539C175.93 55.6539 175.95 55.6539 175.96 55.6539C179.58 55.6239 181.84 54.1139 183.1 52.8339C186.07 49.8139 186.11 45.6239 186.1 45.1539V39.4839C186.1 35.7439 188.02 33.8139 191.04 33.8139C194.06 33.8139 195.82 35.7439 195.82 39.4839V44.9939C195.82 44.9939 195.83 45.0839 195.83 45.1239C195.83 45.6039 195.83 49.8939 198.78 52.9139C200 54.1539 202.17 55.6239 205.62 55.6439C205.62 55.6439 205.64 55.6439 205.65 55.6439C205.67 55.6439 205.69 55.6439 205.71 55.6439H205.76C209.41 55.6239 211.68 54.1039 212.95 52.8239C215.92 49.8039 215.96 45.6139 215.95 45.1439C215.95 45.0839 215.96 45.0339 215.96 44.9839V30.7939C215.96 28.6139 214.19 26.8439 212.01 26.8439L211.98 26.8539Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M132.85 26.6439C124.74 26.6439 119.07 33.1939 119.07 41.1539V41.2539C119.07 49.7839 125.26 55.6539 133.63 55.6539C137.68 55.6539 140.86 54.3539 143.3 52.2739C143.87 51.7539 144.34 50.9739 144.34 49.9339C144.34 48.1639 143.04 46.8139 141.27 46.8139C140.44 46.8139 139.92 47.0239 139.34 47.4339C137.73 48.6339 135.91 49.3039 133.72 49.3039C130.19 49.3039 127.69 47.4339 126.91 43.8439H142.39C144.39 43.8439 146.24 42.1539 146.24 39.9839C146.24 34.2139 142.13 26.6339 132.83 26.6339L132.85 26.6439ZM126.69 37.9739C127.59 34.8139 129.73 32.8239 132.86 32.8239C135.99 32.8239 138.13 34.8639 138.91 37.9739H126.69Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M113.26 34.994C114.64 33.064 115.45 30.694 115.45 28.144C115.45 21.614 110.12 16.304 103.58 16.304H92.1096C89.9196 16.304 88.1396 18.084 88.1396 20.274V51.784C88.1396 52.834 88.5597 53.844 89.2997 54.584C90.0397 55.324 91.0496 55.744 92.0996 55.744H105.45C112 55.744 117.32 50.4339 117.32 43.9039C117.32 40.3539 115.75 37.164 113.25 34.994H113.26ZM96.0696 24.244H103.58C105.76 24.244 107.53 25.9939 107.53 28.1539C107.53 30.3139 105.76 32.0639 103.58 32.0639H96.0696V24.254V24.244ZM105.45 47.8139H96.0696V40.004H105.45C107.63 40.004 109.4 41.754 109.4 43.914C109.4 46.074 107.63 47.8239 105.45 47.8239V47.8139Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.533936H57.8696V81.8939H58.8696V0.533936Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 19.1239C19.8998 16.1839 17.0398 14.5039 12.8398 14.5039C4.97982 14.5539 0.319824 20.8039 0.319824 29.4739C0.319824 38.1439 4.96982 44.3939 12.8398 44.3939C14.2798 44.4739 15.7298 44.2239 17.0698 43.6639C18.4098 43.1039 19.6098 42.2439 20.5798 41.1539V45.3239C20.5798 48.1639 19.0798 51.5339 14.3198 51.5339C10.7098 51.5339 8.92982 49.5139 8.30982 47.3439L1.92982 50.4339C3.52982 54.5339 7.34982 57.9739 14.7698 57.9739C25.7698 57.9739 28.5998 50.5539 28.5998 44.0539V14.9139H21.8698L21.6898 19.1139L21.6698 19.1239ZM14.5598 37.5939C10.6298 37.5939 8.30982 34.3939 8.30982 29.4139C8.30982 24.4339 10.6298 21.2339 14.5598 21.2339C18.4898 21.2339 20.7598 24.4339 20.7598 29.4139C20.7598 34.3939 18.4898 37.5939 14.5598 37.5939Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 60.2439V70.1339H0.569824V64.2939H22.8598V60.2439H28.5798H28.5898Z", fill: "#5532FA" }));
const SvgBrex$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 268, height: 82, viewBox: "0 0 268 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0H57.8696V81.36H58.8696V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M209.47 25.65C206.29 25.65 203.84 26.78 201.56 29.15V26.2H195.31V55.21H202.03V38.38C202.03 34.53 204.32 32.09 207.8 32.09C208.43 32.09 208.99 32.17 209.38 32.25L214.05 26.12C212.23 25.81 210.65 25.65 209.46 25.65H209.47Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M267.44 26.2H259.69L252.53 35.67L245.38 26.2H237.63L248.56 40.82L237.63 55.22H245.54L252.49 46.04L259.45 55.22H267.44L256.43 40.84L267.44 26.2Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M126.27 19.68C123.98 22.75 123.42 23.77 121.21 23.77H88.1499V63.08H101.12C104.05 63.08 106.89 61.66 108.71 59.31C111.08 56.17 111.4 55.22 113.69 55.22H146.83V15.9H133.78C130.85 15.9 128.01 17.32 126.27 19.67V19.68ZM136.55 45.08H122.71C119.7 45.08 116.94 46.34 115.12 48.77C112.75 51.92 112.27 52.86 110.06 52.86H98.3499V33.99H112.19C115.19 33.99 117.96 32.57 119.78 30.22C122.15 27.15 122.79 26.21 124.92 26.21H136.55V45.08Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M186.22 35.4C189.15 33.75 191.2 30.84 191.2 26.99C191.2 21.33 186.85 15.9 180.52 15.9H161.54V55.22H180.52C187.4 55.22 192.15 50.34 192.15 44.21C192.15 40.59 190.49 37.45 186.22 35.4ZM168.27 22.03H179.98C182.91 22.03 184.65 24.78 184.65 27.22C184.65 30.21 182.04 32.25 179.59 32.25H168.28V22.03H168.27ZM179.58 49.08H168.27V38.39H179.98C182.99 38.39 185.44 40.98 185.44 43.66C185.44 46.65 182.36 49.09 179.59 49.09L179.58 49.08Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M230.9 46.88C229.79 48.61 227.66 49.63 225.28 49.63C221.57 49.63 218.48 47.11 218.48 43.26H238.57C238.89 42.08 238.97 41.53 238.97 40.51C238.97 31.7 233.51 25.65 225.29 25.65C217.07 25.65 211.53 31.39 211.53 40.75C211.53 50.11 216.99 55.77 225.45 55.77C231.38 55.77 236.6 52.86 238.1 46.89H230.9V46.88ZM225.28 31.78C229 31.78 231.85 34.14 231.77 37.68H218.56C218.56 34.22 221.57 31.78 225.28 31.78Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.59C19.8998 15.65 17.0398 13.97 12.8398 13.97C4.97982 14.02 0.319824 20.27 0.319824 28.94C0.319824 37.61 4.96982 43.86 12.8398 43.86C14.2798 43.94 15.7298 43.69 17.0698 43.13C18.4098 42.57 19.6098 41.71 20.5798 40.62V44.79C20.5798 47.63 19.0798 51 14.3198 51C10.7098 51 8.92982 48.98 8.30982 46.81L1.92982 49.9C3.52982 54 7.34982 57.44 14.7698 57.44C25.7698 57.44 28.5998 50.02 28.5998 43.52V14.39H21.8698L21.6898 18.59H21.6698ZM14.5598 37.06C10.6298 37.06 8.30982 33.86 8.30982 28.88C8.30982 23.9 10.6298 20.7 14.5598 20.7C18.4898 20.7 20.7598 23.9 20.7598 28.88C20.7598 33.86 18.4898 37.06 14.5598 37.06Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.71V69.6H0.569824V63.76H22.8598V59.71H28.5798H28.5898Z", fill: "#5532FA" }));
const SvgCapitalOneBusinessDeals$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 525, height: 85, viewBox: "0 0 525 85", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9116_21288)" }, /* @__PURE__ */ React.createElement("path", { d: "M21.6605 21.7267C19.8905 18.7867 17.0305 17.1067 12.8305 17.1067C4.97055 17.1567 0.310547 23.4067 0.310547 32.0767C0.310547 40.7467 4.96055 46.9967 12.8305 46.9967C14.2705 47.0767 15.7205 46.8267 17.0605 46.2667C18.4005 45.7067 19.6005 44.8467 20.5705 43.7567V47.9267C20.5705 50.7667 19.0705 54.1367 14.3105 54.1367C10.7005 54.1367 8.92055 52.1167 8.30055 49.9467L1.92055 53.0367C3.52055 57.1367 7.34055 60.5767 14.7605 60.5767C25.7605 60.5767 28.5905 53.1567 28.5905 46.6567V17.5267H21.8605L21.6805 21.7267H21.6605ZM14.5505 40.1967C10.6205 40.1967 8.30055 36.9967 8.30055 32.0167C8.30055 27.0367 10.6205 23.8367 14.5505 23.8367C18.4805 23.8367 20.7505 27.0367 20.7505 32.0167C20.7505 36.9967 18.4805 40.1967 14.5505 40.1967Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5805 62.8467V72.7367H0.560547V66.8967H22.8505V62.8467H28.5705H28.5805Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8604 3.57666H57.8604V84.9367H58.8604V3.57666Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M223.801 52.1166C223.801 52.1166 223.781 52.1266 223.771 52.1366C215.261 58.1666 205.181 64.4966 194.331 71.1366L193.901 71.3866C193.761 71.4866 193.721 71.6866 193.821 71.8366C193.921 71.9866 194.121 72.0166 194.271 71.9166L194.631 71.7266C203.831 66.9266 214.401 61.2266 225.031 55.3766C225.091 55.3466 225.141 55.3166 225.201 55.2866C224.621 54.3266 224.141 53.2766 223.791 52.1266L223.801 52.1166ZM279.671 6.89664C266.251 -7.90336 179.921 5.40664 143.211 13.4266L142.351 13.6066C142.171 13.6366 142.061 13.8066 142.091 13.9866C142.121 14.1666 142.291 14.2766 142.471 14.2466L143.321 14.0766C173.741 8.65664 236.991 1.15664 250.601 14.6466C254.751 18.7666 253.761 24.0666 248.951 30.3266C251.551 31.9966 253.391 34.6166 254.231 37.8966C273.031 25.3866 285.661 13.4766 279.681 6.87664L279.671 6.89664Z", fill: "#CC2427" }), /* @__PURE__ */ React.createElement("path", { d: "M229.231 48.2366C229.401 53.4466 232.701 57.7066 236.991 57.7066C245.321 57.7066 248.861 47.4866 248.611 40.6466C248.431 35.4266 245.051 31.1766 240.761 31.1766C233.601 31.1766 228.971 41.3566 229.221 48.2366H229.231ZM224.831 47.9566C224.521 39.0666 231.481 29.9866 241.601 29.9866C248.361 29.9866 252.791 34.4966 253.041 41.3966C253.361 50.7666 246.861 59.3766 236.271 59.3766C229.501 59.3766 225.081 54.8766 224.831 47.9666V47.9566Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M129.031 45.6067C128.671 45.7467 128.201 45.8767 127.621 45.9967C127.041 46.1267 125.991 46.3167 124.461 46.5567C123.411 46.7267 122.671 46.9467 122.261 47.2367C121.861 47.5367 121.631 47.8867 121.561 48.3167C121.481 48.7767 121.631 49.1467 122.021 49.4267C122.421 49.7067 123.101 49.8567 124.061 49.8567C124.781 49.8567 125.481 49.7367 126.161 49.5267C126.851 49.2967 127.431 48.9967 127.881 48.6167C128.211 48.3367 128.441 47.9767 128.621 47.5367C128.721 47.2567 128.871 46.6167 129.041 45.6067H129.031ZM137.821 40.1367C137.781 40.9567 137.641 41.6667 137.421 42.9167L135.931 51.2667C135.801 52.0067 136.081 52.5867 136.771 52.9867L136.721 53.3167H128.201L128.121 51.1867C126.881 51.9367 125.381 52.5667 124.031 52.9367C122.681 53.2867 121.591 53.4367 119.951 53.4367C117.201 53.4367 115.621 53.1467 114.541 52.1967C113.431 51.2167 112.901 50.5567 112.951 49.2067C112.991 48.4267 113.401 47.4267 113.981 46.7267C114.571 46.0167 115.371 45.5567 116.251 45.1467C117.131 44.7267 118.161 44.4267 119.671 44.1867C121.181 43.9367 123.271 43.6967 126.081 43.4667C127.561 43.3467 128.461 42.9967 128.881 42.8367C129.471 42.6067 129.701 42.3567 129.781 41.8767C129.941 41.0167 129.661 40.5267 128.521 40.3067C125.451 39.7067 119.701 40.6967 116.741 41.4367L118.351 37.0967C122.261 36.5267 125.921 36.1567 129.781 36.1567C135.911 36.1567 137.871 37.9067 137.811 40.1467L137.821 40.1367Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M162.511 53.3166L165.471 36.6366H173.621L170.661 53.3166H162.511ZM165.921 32.7766C166.161 31.4066 168.331 30.2966 170.751 30.2966C173.171 30.2966 174.941 31.4066 174.711 32.7766C174.451 34.1466 172.291 35.2566 169.871 35.2566C167.451 35.2566 165.681 34.1466 165.931 32.7766H165.921Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M202.571 45.6468C202.201 45.7668 201.731 45.9068 201.161 46.0368C200.591 46.1768 199.531 46.3368 197.991 46.5968C196.941 46.7668 196.201 46.9868 195.791 47.2868C195.401 47.5768 195.171 47.9268 195.081 48.3568C194.991 48.8168 195.161 49.1868 195.551 49.4668C195.961 49.7468 196.641 49.8868 197.601 49.8868C198.311 49.8868 199.011 49.7768 199.691 49.5668C200.391 49.3368 200.961 49.0368 201.411 48.6568C201.721 48.3768 201.961 48.0068 202.141 47.5768C202.241 47.2968 202.391 46.6568 202.571 45.6568V45.6468ZM211.361 40.1668C211.331 40.9868 211.181 41.7068 210.961 42.9468L209.481 51.3068C209.351 52.0468 209.621 52.6268 210.311 53.0368L210.261 53.3268L201.751 53.3468L201.681 51.2168C200.441 51.9668 198.931 52.5968 197.591 52.9668C196.231 53.3268 195.141 53.4668 193.491 53.4668C190.741 53.4668 189.181 53.1868 188.091 52.2268C186.981 51.2368 186.441 50.5968 186.501 49.2468C186.531 48.4668 186.941 47.4568 187.531 46.7668C188.121 46.0468 188.921 45.5968 189.801 45.1768C190.681 44.7668 191.721 44.4568 193.201 44.2068C194.711 43.9768 196.821 43.7168 199.631 43.4868C201.091 43.3668 201.991 43.0268 202.411 42.8668C203.001 42.6368 203.241 42.3768 203.331 41.8968C203.481 41.0568 203.211 40.5568 202.081 40.3268C199.001 39.7168 193.261 40.7168 190.301 41.4568L191.901 37.1168C195.821 36.5468 199.471 36.1768 203.331 36.1768C209.461 36.1768 211.411 37.9368 211.361 40.1768V40.1668Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M111.851 47.3167C109.201 47.8467 107.701 48.0467 105.081 48.0467C101.181 48.0467 98.0908 46.1167 98.2608 42.5667C98.3808 40.2067 101.181 35.2267 108.281 35.2267C110.521 35.2267 112.271 35.6267 114.621 36.9667L115.651 31.1767C112.451 29.9667 110.331 29.7867 107.591 29.8167C98.2808 29.9167 89.3308 34.1567 88.2208 42.7667C87.0908 51.5167 97.7808 53.7167 102.521 53.6967C105.261 53.6967 108.111 53.5767 110.771 53.2967L111.851 47.3267V47.3167Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M178.111 36.5366L178.701 33.1366L187.231 31.2766L186.321 36.5266H190.501L189.711 39.8866H185.661L183.201 53.2866C183.201 53.2866 174.991 53.2366 174.961 53.2866L177.411 39.9066H174.311L174.941 36.5266H178.121L178.111 36.5366Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M219.641 53.3066L211.341 53.3166L215.511 30.0466L223.601 30.2766L219.641 53.3066Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M151.721 40.5468C150.651 40.5468 149.681 40.8668 148.821 41.5168C147.971 42.1668 147.431 43.1168 147.211 44.3768C146.951 45.8368 147.101 46.8768 147.681 47.5268C148.261 48.1668 149.101 48.4868 150.201 48.4868C150.941 48.4868 151.711 48.3568 152.281 48.0768C152.981 47.7068 153.461 47.3168 153.881 46.7068C154.331 46.0568 154.621 45.3368 154.781 44.5068C155.011 43.1868 154.821 42.2068 154.211 41.5568C153.621 40.8868 152.801 40.5568 151.731 40.5568L151.721 40.5468ZM136.871 59.0768L140.841 36.7168H148.001L147.451 39.5668C148.071 38.7168 149.061 38.0168 150.431 37.4468C151.811 36.8768 153.371 36.4668 155.061 36.4668C156.931 36.4668 158.081 36.5668 159.481 37.2968C160.871 38.0268 161.841 39.0868 162.371 40.4668C162.911 41.8268 163.021 43.3468 162.731 45.0068C162.251 47.7568 160.901 49.9368 158.701 51.5268C156.511 53.1268 154.551 53.5368 151.741 53.5568C150.751 53.5568 149.911 53.4568 149.221 53.2868C148.541 53.1068 148.011 52.8968 147.601 52.6368C147.211 52.3768 146.791 52.0068 146.261 51.4268L144.931 59.0868H136.891L136.871 59.0768Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M284.911 42.5967C284.861 41.2467 284.191 40.3467 282.801 40.3467C279.461 40.3467 275.901 46.8967 275.291 49.5367C280.781 49.5367 285.051 46.2667 284.911 42.5967ZM285.631 52.8667L286.281 53.3067C284.651 56.6267 281.321 59.3067 277.421 59.3067C274.231 59.3067 271.611 57.1867 271.471 53.1967C271.211 46.0467 277.911 39.4067 283.401 39.4067C285.751 39.4067 287.931 40.4367 288.031 42.9667C288.231 48.6567 280.251 50.3867 274.991 50.5067C274.821 51.0967 274.761 51.6967 274.791 52.6067C274.881 54.9667 276.301 56.9467 279.251 56.9467C281.801 56.9467 284.351 54.8967 285.631 52.8767V52.8667Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M252.911 42.4067C253.481 42.3267 254.391 42.2367 254.781 42.2367C255.381 42.2367 255.941 42.3467 255.971 42.9467C255.981 43.2967 255.341 45.8267 255.211 46.4167L253.941 52.0267C253.431 54.3167 252.871 56.7267 252.381 58.6267H255.651L257.491 49.7467C263.091 43.9067 265.251 42.0067 266.571 42.0067C267.161 42.0067 267.581 42.3167 267.601 43.0267C267.631 44.0567 267.001 46.3867 266.771 47.0567L264.901 53.5367C264.471 54.9967 264.161 56.3067 264.191 57.2467C264.251 58.6667 265.111 59.2967 266.381 59.2967C268.771 59.2967 270.501 56.8067 272.021 54.3667L271.581 53.5667C270.971 54.5467 269.551 56.6967 268.431 56.6967C268.081 56.6967 267.741 56.4567 267.731 55.8667C267.701 55.1067 268.021 53.9767 268.241 53.2267L270.321 45.6367C270.881 43.5467 271.151 42.1967 271.131 41.4867C271.081 40.0667 270.251 39.4067 268.981 39.4067C266.831 39.4067 263.971 40.9767 257.931 47.9367H257.841L258.601 44.5467C259.011 42.6867 259.421 40.7567 259.811 39.4167C257.721 40.1667 254.721 41.0167 252.871 41.3667L252.901 42.4267L252.911 42.4067Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M301.281 58.6967L306.241 33.1467C307.061 32.9267 308.151 32.7267 309.501 32.5667C310.851 32.4067 312.081 32.3267 313.171 32.3267C315.811 32.3267 317.821 32.8567 319.211 33.9167C320.601 34.9767 321.301 36.4967 321.301 38.4867C321.301 40.1067 320.831 41.4867 319.881 42.6267C318.931 43.7667 317.591 44.5867 315.851 45.0867C316.821 45.3367 317.651 45.7167 318.331 46.2467C319.011 46.7667 319.531 47.3967 319.881 48.1267C320.231 48.8567 320.401 49.6767 320.401 50.5667C320.401 53.1567 319.521 55.1567 317.771 56.5767C316.021 57.9967 313.561 58.7067 310.401 58.7067H301.261L301.281 58.6967ZM310.421 55.9767C312.431 55.9767 314.011 55.4967 315.141 54.5367C316.271 53.5767 316.841 52.2567 316.841 50.5667C316.841 49.2967 316.441 48.3267 315.631 47.6367C314.821 46.9567 313.681 46.6067 312.221 46.6067H307.071L305.241 55.9667H310.421V55.9767ZM313.031 34.9767C311.511 34.9767 310.261 35.0967 309.261 35.3467L307.541 43.9967H311.901C313.691 43.9967 315.131 43.5267 316.211 42.5967C317.291 41.6667 317.831 40.4267 317.831 38.8867C317.831 36.2767 316.231 34.9667 313.021 34.9667L313.031 34.9767Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M329.291 39.7466L326.871 52.2066C326.771 52.8066 326.721 53.3166 326.721 53.7366C326.721 54.6366 327.001 55.3266 327.561 55.8266C328.121 56.3266 328.911 56.5766 329.931 56.5766C330.651 56.5766 331.421 56.4566 332.241 56.2266C333.061 55.9866 333.811 55.6766 334.481 55.2766L337.501 39.7566H340.891L337.231 58.4766L334.431 58.7766V57.5066C332.391 58.6766 330.461 59.2566 328.651 59.2566C326.981 59.2566 325.671 58.8166 324.701 57.9366C323.731 57.0566 323.251 55.8266 323.251 54.2666C323.251 53.6166 323.311 53.0066 323.441 52.4366L325.901 39.7566H329.291V39.7466Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M341.301 54.9265C342.201 55.4465 343.151 55.8565 344.171 56.1565C345.191 56.4565 346.171 56.6065 347.121 56.6065C348.511 56.6065 349.611 56.3065 350.401 55.7065C351.201 55.1065 351.591 54.2865 351.591 53.2465C351.591 52.5965 351.431 52.0765 351.101 51.6565C350.771 51.2365 350.241 50.8765 349.501 50.5565L346.961 49.4765C345.691 48.9265 344.771 48.3065 344.201 47.6165C343.631 46.9165 343.341 46.0765 343.341 45.0765C343.341 43.3565 344.011 41.9465 345.351 40.8465C346.691 39.7365 348.411 39.1865 350.501 39.1865C351.491 39.1865 352.501 39.3165 353.501 39.5765C354.511 39.8365 355.431 40.2165 356.281 40.7165L355.791 43.2565C353.971 42.3165 352.281 41.8365 350.721 41.8365C349.481 41.8365 348.501 42.0965 347.791 42.5965C347.081 43.1065 346.731 43.8065 346.731 44.7065C346.731 45.2265 346.891 45.6565 347.201 45.9965C347.511 46.3365 348.061 46.6765 348.861 47.0265L351.401 48.1065C352.621 48.6265 353.521 49.2765 354.101 50.0665C354.681 50.8465 354.981 51.8165 354.981 52.9565C354.981 54.8465 354.281 56.3665 352.871 57.5265C351.461 58.6865 349.621 59.2565 347.331 59.2565C346.191 59.2565 345.091 59.1265 344.031 58.8665C342.971 58.6065 342.061 58.2465 341.291 57.8065V54.9365L341.301 54.9265Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M357.111 58.6966L360.731 40.0866L364.201 39.6766L360.511 58.6966H357.121H357.111ZM363.381 35.8666C362.761 35.8666 362.271 35.7066 361.911 35.3966C361.551 35.0866 361.371 34.6566 361.371 34.1066C361.371 33.3066 361.601 32.6866 362.061 32.2266C362.521 31.7666 363.151 31.5366 363.941 31.5366C364.561 31.5366 365.051 31.6966 365.411 32.0066C365.771 32.3166 365.951 32.7466 365.951 33.2966C365.951 34.0966 365.721 34.7166 365.261 35.1766C364.801 35.6366 364.171 35.8666 363.381 35.8666Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M376.581 58.6965L379.001 46.2365C379.101 45.6365 379.151 45.1265 379.151 44.7065C379.151 43.7865 378.861 43.0865 378.291 42.5965C377.721 42.1165 376.881 41.8665 375.791 41.8665C375.071 41.8665 374.301 41.9865 373.481 42.2165C372.661 42.4565 371.911 42.7665 371.241 43.1665L368.221 58.6865H364.831L368.491 39.9665L371.291 39.6665V40.9365C373.331 39.7665 375.261 39.1865 377.071 39.1865C378.881 39.1865 380.201 39.6265 381.171 40.5065C382.141 41.3865 382.621 42.6165 382.621 44.1765C382.621 44.8265 382.561 45.4365 382.431 46.0065L379.971 58.6865H376.581V58.6965Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M398.291 57.9865C397.491 58.3865 396.591 58.6965 395.571 58.9165C394.551 59.1365 393.561 59.2565 392.591 59.2565C390.101 59.2565 388.191 58.5865 386.861 57.2565C385.531 55.9265 384.861 54.0165 384.861 51.5265C384.861 49.0365 385.311 46.9665 386.201 45.0765C387.101 43.1865 388.281 41.7365 389.761 40.7165C391.241 39.6965 392.871 39.1865 394.661 39.1865C396.701 39.1865 398.301 39.7365 399.451 40.8265C400.611 41.9165 401.181 43.4265 401.181 45.3365C401.181 46.6765 400.931 48.2065 400.431 49.9265H388.311C388.291 50.2265 388.261 50.5265 388.241 50.8365C388.211 51.1465 388.201 51.4565 388.201 51.7465C388.201 54.9565 389.841 56.5565 393.121 56.5565C394.111 56.5565 395.121 56.4465 396.121 56.2365C397.131 56.0265 398.021 55.7465 398.791 55.3965L398.271 57.9665L398.291 57.9865ZM394.491 41.6865C393.151 41.6865 391.981 42.1965 391.001 43.2165C390.021 44.2365 389.291 45.6665 388.821 47.5065H397.811C397.961 46.7865 398.031 46.0765 398.031 45.3765C398.031 44.1565 397.731 43.2365 397.131 42.6165C396.531 41.9965 395.651 41.6865 394.481 41.6865H394.491Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M402.061 54.9265C402.961 55.4465 403.911 55.8565 404.931 56.1565C405.951 56.4565 406.931 56.6065 407.881 56.6065C409.271 56.6065 410.371 56.3065 411.161 55.7065C411.961 55.1065 412.351 54.2865 412.351 53.2465C412.351 52.5965 412.191 52.0765 411.861 51.6565C411.531 51.2365 411.001 50.8765 410.261 50.5565L407.721 49.4765C406.451 48.9265 405.531 48.3065 404.961 47.6165C404.391 46.9165 404.101 46.0765 404.101 45.0765C404.101 43.3565 404.771 41.9465 406.111 40.8465C407.451 39.7365 409.171 39.1865 411.261 39.1865C412.251 39.1865 413.261 39.3165 414.261 39.5765C415.271 39.8365 416.191 40.2165 417.041 40.7165L416.551 43.2565C414.731 42.3165 413.041 41.8365 411.481 41.8365C410.241 41.8365 409.261 42.0965 408.551 42.5965C407.841 43.1065 407.491 43.8065 407.491 44.7065C407.491 45.2265 407.651 45.6565 407.961 45.9965C408.271 46.3365 408.821 46.6765 409.621 47.0265L412.161 48.1065C413.381 48.6265 414.281 49.2765 414.861 50.0665C415.441 50.8465 415.741 51.8165 415.741 52.9565C415.741 54.8465 415.041 56.3665 413.631 57.5265C412.221 58.6865 410.381 59.2565 408.091 59.2565C406.951 59.2565 405.851 59.1265 404.791 58.8665C403.731 58.6065 402.821 58.2465 402.051 57.8065V54.9365L402.061 54.9265Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M417.731 54.9265C418.631 55.4465 419.581 55.8565 420.601 56.1565C421.621 56.4565 422.601 56.6065 423.551 56.6065C424.941 56.6065 426.041 56.3065 426.831 55.7065C427.631 55.1065 428.021 54.2865 428.021 53.2465C428.021 52.5965 427.861 52.0765 427.531 51.6565C427.201 51.2365 426.671 50.8765 425.931 50.5565L423.391 49.4765C422.121 48.9265 421.201 48.3065 420.631 47.6165C420.061 46.9165 419.771 46.0765 419.771 45.0765C419.771 43.3565 420.441 41.9465 421.781 40.8465C423.121 39.7365 424.841 39.1865 426.931 39.1865C427.921 39.1865 428.931 39.3165 429.931 39.5765C430.941 39.8365 431.861 40.2165 432.711 40.7165L432.221 43.2565C430.401 42.3165 428.711 41.8365 427.151 41.8365C425.911 41.8365 424.931 42.0965 424.221 42.5965C423.511 43.1065 423.161 43.8065 423.161 44.7065C423.161 45.2265 423.321 45.6565 423.631 45.9965C423.941 46.3365 424.491 46.6765 425.291 47.0265L427.831 48.1065C429.051 48.6265 429.951 49.2765 430.531 50.0665C431.111 50.8465 431.411 51.8165 431.411 52.9565C431.411 54.8465 430.711 56.3665 429.301 57.5265C427.891 58.6865 426.051 59.2565 423.761 59.2565C422.621 59.2565 421.521 59.1265 420.461 58.8665C419.401 58.6065 418.491 58.2465 417.721 57.8065V54.9365L417.731 54.9265Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M442.641 58.6967L447.601 33.1867C448.571 32.9367 449.711 32.7367 451.031 32.5667C452.351 32.4067 453.571 32.3267 454.691 32.3267C458.051 32.3267 460.601 33.2567 462.341 35.1067C464.081 36.9567 464.951 39.6467 464.951 43.1867C464.951 46.3967 464.331 49.1667 463.091 51.5067C461.851 53.8467 460.101 55.6267 457.851 56.8567C455.601 58.0867 452.991 58.7067 450.041 58.7067H442.651L442.641 58.6967ZM450.591 55.7867C452.731 55.7867 454.601 55.2567 456.201 54.1867C457.801 53.1167 459.041 51.6367 459.891 49.7267C460.741 47.8167 461.181 45.6467 461.181 43.1767C461.181 40.4667 460.631 38.4667 459.521 37.1667C458.411 35.8767 456.681 35.2267 454.321 35.2267C452.981 35.2267 451.781 35.3667 450.741 35.6367L446.821 55.7767H450.591V55.7867Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M479.791 57.9865C478.991 58.3865 478.091 58.6965 477.071 58.9165C476.051 59.1365 475.061 59.2565 474.091 59.2565C471.601 59.2565 469.691 58.5865 468.361 57.2565C467.031 55.9265 466.361 54.0165 466.361 51.5265C466.361 49.0365 466.811 46.9665 467.701 45.0765C468.601 43.1865 469.781 41.7365 471.261 40.7165C472.741 39.6965 474.371 39.1865 476.161 39.1865C478.201 39.1865 479.801 39.7365 480.951 40.8265C482.111 41.9165 482.681 43.4265 482.681 45.3365C482.681 46.6765 482.431 48.2065 481.931 49.9265H469.811C469.791 50.2265 469.761 50.5265 469.741 50.8365C469.711 51.1465 469.701 51.4565 469.701 51.7465C469.701 54.9565 471.341 56.5565 474.621 56.5565C475.611 56.5565 476.621 56.4465 477.621 56.2365C478.631 56.0265 479.521 55.7465 480.291 55.3965L479.771 57.9665L479.791 57.9865ZM475.991 41.6865C474.651 41.6865 473.481 42.1965 472.501 43.2165C471.521 44.2365 470.791 45.6665 470.321 47.5065H479.311C479.461 46.7865 479.531 46.0765 479.531 45.3765C479.531 44.1565 479.231 43.2365 478.631 42.6165C478.031 41.9965 477.151 41.6865 475.981 41.6865H475.991Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M495.011 58.7665V57.4965C492.971 58.6665 491.041 59.2465 489.231 59.2465C487.511 59.2465 486.151 58.7765 485.151 57.8265C484.141 56.8865 483.641 55.5965 483.641 53.9865C483.641 52.6965 483.981 51.5565 484.671 50.5765C485.351 49.5965 486.281 48.8365 487.451 48.2965C488.621 47.7665 489.921 47.4965 491.371 47.4965C493.011 47.4965 494.731 47.7165 496.521 48.1665L496.891 46.2265C496.961 45.7765 497.001 45.3765 497.001 45.0365C497.001 43.9965 496.631 43.2065 495.901 42.6665C495.171 42.1365 494.101 41.8665 492.711 41.8665C490.521 41.8665 488.531 42.2265 486.741 42.9465L487.231 40.4065C489.171 39.5865 491.231 39.1765 493.421 39.1765C495.611 39.1765 497.341 39.6465 498.551 40.5965C499.761 41.5465 500.361 42.8765 500.361 44.5865C500.361 45.2565 500.301 45.8765 500.171 46.4465L497.821 58.4565L495.021 58.7565L495.011 58.7665ZM490.501 56.6065C491.271 56.6065 492.071 56.4865 492.891 56.2565C493.711 56.0165 494.461 55.6865 495.131 55.2665L496.061 50.3765C494.741 50.0565 493.371 49.8965 491.961 49.8965C490.421 49.8965 489.231 50.2265 488.401 50.8865C487.571 51.5465 487.151 52.4965 487.151 53.7365C487.151 55.6565 488.271 56.6065 490.511 56.6065H490.501Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M502.021 58.6966L507.47 30.6866L510.94 30.2766L505.421 58.6966H502.03H502.021Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M509.861 54.9265C510.761 55.4465 511.711 55.8565 512.731 56.1565C513.751 56.4565 514.731 56.6065 515.681 56.6065C517.071 56.6065 518.171 56.3065 518.961 55.7065C519.761 55.1065 520.151 54.2865 520.151 53.2465C520.151 52.5965 519.991 52.0765 519.661 51.6565C519.331 51.2365 518.801 50.8765 518.061 50.5565L515.521 49.4765C514.251 48.9265 513.331 48.3065 512.761 47.6165C512.191 46.9165 511.901 46.0765 511.901 45.0765C511.901 43.3565 512.571 41.9465 513.911 40.8465C515.251 39.7365 516.971 39.1865 519.061 39.1865C520.051 39.1865 521.061 39.3165 522.061 39.5765C523.071 39.8365 523.991 40.2165 524.841 40.7165L524.351 43.2565C522.531 42.3165 520.841 41.8365 519.281 41.8365C518.041 41.8365 517.061 42.0965 516.351 42.5965C515.641 43.1065 515.291 43.8065 515.291 44.7065C515.291 45.2265 515.451 45.6565 515.761 45.9965C516.071 46.3365 516.621 46.6765 517.421 47.0265L519.961 48.1065C521.181 48.6265 522.081 49.2765 522.661 50.0665C523.241 50.8465 523.541 51.8165 523.541 52.9565C523.541 54.8465 522.841 56.3665 521.431 57.5265C520.021 58.6865 518.181 59.2565 515.891 59.2565C514.751 59.2565 513.651 59.1265 512.591 58.8665C511.531 58.6065 510.621 58.2465 509.851 57.8065V54.9365L509.861 54.9265Z", fill: "#013D5B" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9116_21288" }, /* @__PURE__ */ React.createElement("rect", { width: 524.53, height: 84.71, fill: "white", transform: "translate(0.320312 0.226562)" }))));
const SvgCapitalOneSpring$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 236, height: 98, viewBox: "0 0 236 98", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.5498 15.9067H57.5498V97.2667H58.5498V15.9067Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 34.0568C19.58 31.1168 16.72 29.4368 12.52 29.4368C4.66 29.4868 0 35.7368 0 44.4068C0 53.0768 4.65 59.3268 12.52 59.3268C13.96 59.4068 15.41 59.1568 16.75 58.5968C18.09 58.0368 19.29 57.1768 20.26 56.0868V60.2568C20.26 63.0968 18.76 66.4668 14 66.4668C10.39 66.4668 8.61 64.4468 7.99 62.2768L1.61 65.3668C3.21 69.4668 7.03 72.9068 14.45 72.9068C25.45 72.9068 28.28 65.4868 28.28 58.9868V29.8568H21.55L21.37 34.0568H21.35ZM14.24 52.5268C10.31 52.5268 7.99 49.3268 7.99 44.3468C7.99 39.3668 10.31 36.1668 14.24 36.1668C18.17 36.1668 20.44 39.3668 20.44 44.3468C20.44 49.3268 18.17 52.5268 14.24 52.5268Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.27 75.1768V85.0668H0.25V79.2268H22.54V75.1768H28.26H28.27Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M154.39 41.3767C151.72 41.3767 149.16 42.3067 146.79 44.1267L146.54 41.8967L143.02 42.2467V71.1367H147.09V47.5667C149.36 45.7867 151.76 44.8867 154.23 44.8867C154.93 44.8867 155.76 44.9967 156.69 45.2167L157.15 45.3267V41.8167L156.9 41.7267C156.27 41.4867 155.45 41.3667 154.4 41.3667L154.39 41.3767ZM215.34 41.2067C210.83 41.2067 207.32 42.5967 204.92 45.3367C202.53 48.0667 201.31 52.0167 201.31 57.0767C201.31 61.5467 202.38 65.0967 204.5 67.6367C206.63 70.1967 209.59 71.4867 213.3 71.4867C214.58 71.4867 215.98 71.2567 217.47 70.7967C218.75 70.3967 220.03 69.8667 221.27 69.2067V72.4567C221.27 78.0767 218.37 80.8067 212.42 80.8067C209.75 80.8067 206.91 80.1767 203.94 78.9167L203.32 78.6567L203.89 82.3967L204.07 82.4867C206.4 83.6767 209.26 84.2767 212.58 84.2767C216.64 84.2767 219.81 83.2167 222.01 81.1367C224.22 79.0467 225.33 76.0367 225.33 72.1867V43.1367L225.09 43.0467C222 41.8367 218.71 41.2167 215.33 41.2167L215.34 41.2067ZM221.26 65.8667C220.1 66.5067 218.85 67.0267 217.55 67.4167C216.19 67.8167 214.91 68.0267 213.73 68.0267C211.03 68.0267 209.03 67.1267 207.64 65.2767C206.24 63.4167 205.54 60.6467 205.54 57.0367C205.54 52.8367 206.37 49.6867 208.02 47.6767C209.65 45.6967 212.21 44.6867 215.61 44.6867C217.56 44.6867 219.46 44.9567 221.26 45.4867V65.8767V65.8667ZM125.76 41.2067C123.23 41.2067 120.44 42.0367 117.45 43.6867L117.25 41.9067L113.73 42.2567V83.7567L117.8 83.2067V71.2167C119.61 71.7267 121.61 71.9867 123.72 71.9867C128.23 71.9867 131.74 70.5967 134.14 67.8567C136.53 65.1267 137.75 61.1767 137.75 56.1167C137.75 51.5067 136.68 47.8267 134.57 45.2067C132.44 42.5567 129.48 41.2067 125.77 41.2067H125.76ZM131.03 65.5367C129.4 67.5167 126.84 68.5267 123.44 68.5267C121.48 68.5267 119.58 68.2567 117.79 67.7267V46.8267C118.95 46.1867 120.2 45.6567 121.5 45.2767C122.86 44.8767 124.15 44.6667 125.32 44.6667C128.02 44.6667 130.01 45.6067 131.4 47.5467C132.8 49.4967 133.51 52.3967 133.51 56.1667C133.51 60.3767 132.67 63.5267 131.03 65.5267V65.5367ZM101.51 54.8567L97.1398 53.3967C95.4298 52.8167 94.2398 52.2067 93.5998 51.5967C92.9898 51.0067 92.6998 50.2467 92.6998 49.2567C92.6998 47.8367 93.2498 46.7567 94.3898 45.9367C95.5498 45.1067 97.1998 44.6767 99.2898 44.6767C101.63 44.6767 104.03 45.1567 106.45 46.1167L106.96 46.3167V42.8567L106.73 42.7567C104.34 41.7267 101.77 41.2067 99.1198 41.2067C95.9598 41.2067 93.3998 41.9467 91.5198 43.3967C89.6098 44.8767 88.6298 46.8767 88.6298 49.3667C88.6298 51.2267 89.2098 52.7767 90.3398 53.9967C91.4398 55.1867 93.2298 56.1767 95.6298 56.9367L99.8298 58.2867C101.42 58.7867 102.56 59.4167 103.23 60.1467C103.89 60.8667 104.21 61.7967 104.21 62.9867C104.21 66.7067 101.89 68.5167 97.1198 68.5167C94.2398 68.5167 91.4098 67.9067 88.6998 66.6867L88.0698 66.4067L88.6598 70.1167L88.8398 70.2067C91.3498 71.3867 94.2098 71.9867 97.3398 71.9867C100.76 71.9867 103.47 71.1967 105.37 69.6467C107.3 68.0767 108.27 65.8167 108.27 62.9267C108.27 60.9267 107.71 59.2467 106.6 57.9467C105.52 56.6667 103.8 55.6267 101.5 54.8467L101.51 54.8567ZM185.46 36.0267C187.93 36.0467 191.22 35.3667 192.69 35.6167C194.44 35.9167 195.23 36.7567 195.92 37.3867C196.01 37.4667 196.16 37.3867 196.16 37.2667V25.0467C196.16 18.9967 191.5 13.8767 185.56 13.7067C179.4 13.5367 174.35 18.5867 174.36 24.8267C174.36 30.9867 179.42 35.9867 185.46 36.0367V36.0267ZM163.18 71.1467H167.25V41.8267L163.18 42.3767V71.1467ZM186.73 41.2067C183.78 41.2067 180.73 42.0367 177.64 43.6867L177.44 41.9067L173.92 42.2567V71.1467H177.99V46.8367C179.3 46.1867 180.64 45.6567 182 45.2767C183.41 44.8767 184.73 44.6667 185.91 44.6667C190.31 44.6667 192.45 46.8067 192.45 51.2167V71.1467H196.52V50.6567C196.52 47.6667 195.65 45.3167 193.94 43.6767C192.23 42.0367 189.81 41.2067 186.75 41.2067H186.73ZM206.45 34.5967C208.78 34.1967 213.96 35.2767 217.87 35.2467C227.4 35.1867 235.38 27.2767 235.4 17.5567C235.42 7.69667 227.45 -0.263328 217.73 0.00667158C208.35 0.256672 200.99 8.33667 200.99 17.8967V37.1867C200.99 37.3867 201.22 37.5167 201.37 37.3767C202.46 36.3967 203.69 35.0667 206.46 34.5867L206.45 34.5967ZM165.19 33.2667C163.75 33.2667 162.58 34.4567 162.58 35.9267C162.58 37.3967 163.75 38.5867 165.19 38.5867C166.63 38.5867 167.8 37.3967 167.8 35.9267C167.8 34.4667 166.63 33.2667 165.19 33.2667Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M204.09 17.8966V31.9266C204.65 31.7466 205.26 31.5866 205.93 31.4666C206.48 31.3766 207.08 31.3366 207.74 31.3366C209.12 31.3366 210.72 31.5066 212.48 31.6866C214.33 31.8866 216.25 32.0866 217.83 32.0666C225.78 32.0166 232.25 25.4966 232.26 17.5466C232.26 13.6366 230.76 9.9666 228.01 7.2366C225.26 4.5066 221.64 3.0766 217.78 3.1666C210.22 3.3766 204.08 9.9766 204.08 17.8866L204.09 17.8966Z", fill: "#00C0E5" }), /* @__PURE__ */ React.createElement("path", { d: "M185.51 15.7068C183.07 15.6368 180.75 16.5668 179.02 18.2868C177.28 20.0168 176.32 22.3368 176.32 24.8168C176.32 29.8568 180.43 33.9868 185.47 34.0168H185.64C186.55 34.0168 187.61 33.9068 188.63 33.7968L188.87 33.7668C190.43 33.6068 192.03 33.4568 193.07 33.6368L194.19 33.7968V25.0268C194.19 20.0068 190.29 15.8268 185.51 15.6968V15.7068Z", fill: "#CC2427" }));
const SvgDeel$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 208, height: 83, viewBox: "0 0 208 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.743652H57.8696V82.1036H58.8696V0.743652Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M185.85 55.8036C185.67 55.8036 185.53 55.6637 185.53 55.4837V17.2936C185.53 17.1436 185.64 17.0137 185.78 16.9837L192.45 15.6037C192.65 15.5637 192.83 15.7136 192.83 15.9136V55.4837C192.83 55.6637 192.69 55.8036 192.51 55.8036H185.84H185.85Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M102.07 56.6137C99.4099 56.6137 97.0299 55.9636 94.9399 54.6736C92.8499 53.3836 91.1899 51.6137 89.9799 49.3637C88.7599 47.1237 88.1499 44.5736 88.1499 41.7136C88.1499 38.8536 88.7599 36.3337 89.9799 34.1237C91.1999 31.8837 92.8499 30.1337 94.9399 28.8737C97.0299 27.5837 99.4099 26.9336 102.07 26.9336C104.2 26.9336 106.06 27.3337 107.66 28.1337C108.94 28.7737 110.03 29.6236 110.92 30.6836C111.12 30.9236 111.54 30.7837 111.54 30.4737V16.6037C111.54 16.4537 111.65 16.3236 111.79 16.2936L118.46 14.9136C118.66 14.8736 118.84 15.0237 118.84 15.2237V55.6037C118.84 55.7837 118.7 55.9236 118.52 55.9236H112.59C112.44 55.9236 112.31 55.8136 112.28 55.6636L111.67 52.5836C111.62 52.3136 111.26 52.2336 111.08 52.4436C110.23 53.4636 109.16 54.3736 107.87 55.1836C106.39 56.1336 104.45 56.6137 102.05 56.6137H102.07ZM103.61 50.2237C105.97 50.2237 107.89 49.4437 109.37 47.8837C110.89 46.2837 111.65 44.2537 111.65 41.7737C111.65 39.2937 110.89 37.2836 109.37 35.7236C107.89 34.1236 105.96 33.3236 103.61 33.3236C101.26 33.3236 99.3699 34.1036 97.8499 35.6636C96.3299 37.2236 95.5699 39.2436 95.5699 41.7136C95.5699 44.1836 96.3299 46.2236 97.8499 47.8236C99.3699 49.4236 101.29 50.2237 103.61 50.2237Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M136.66 56.6136C133.81 56.6136 131.28 56.0036 129.07 54.7836C126.86 53.5636 125.13 51.8537 123.88 49.6437C122.62 47.4337 122 44.8837 122 41.9937C122 39.1037 122.61 36.4536 123.83 34.1736C125.09 31.8936 126.8 30.1236 128.97 28.8636C131.18 27.5736 133.76 26.9236 136.73 26.9236C139.51 26.9236 141.96 27.5337 144.09 28.7537C146.22 29.9737 147.88 31.6437 149.05 33.7737C150.27 35.8637 150.88 38.2036 150.88 40.7936C150.88 41.2136 150.86 41.6536 150.82 42.1036C150.82 42.4736 150.81 42.8436 150.78 43.2336C150.77 43.4036 150.63 43.5237 150.47 43.5237H129.59C129.41 43.5237 129.26 43.6836 129.28 43.8636C129.48 45.9136 130.24 47.5236 131.53 48.7136C132.94 49.9736 134.63 50.5936 136.61 50.5936C138.09 50.5936 139.33 50.2737 140.32 49.6237C141.29 48.9737 142.02 48.1636 142.51 47.1836C142.57 47.0736 142.68 47.0037 142.8 47.0037H149.59C149.8 47.0037 149.95 47.2036 149.89 47.4136C149.35 49.0436 148.5 50.5436 147.34 51.9136C146.12 53.3636 144.6 54.5036 142.77 55.3336C140.98 56.1736 138.95 56.5936 136.66 56.5936V56.6136ZM136.72 32.8737C134.93 32.8737 133.35 33.3836 131.98 34.4136C130.69 35.3436 129.85 36.7436 129.43 38.6036C129.39 38.7936 129.54 38.9736 129.74 38.9736H143.12C143.3 38.9736 143.45 38.8237 143.43 38.6337C143.26 36.9237 142.58 35.5537 141.4 34.5137C140.14 33.4137 138.58 32.8636 136.72 32.8636V32.8737Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M168.43 56.6136C165.58 56.6136 163.05 56.0036 160.84 54.7836C158.63 53.5636 156.9 51.8537 155.65 49.6437C154.39 47.4337 153.77 44.8837 153.77 41.9937C153.77 39.1037 154.38 36.4536 155.6 34.1736C156.86 31.8936 158.57 30.1236 160.74 28.8636C162.95 27.5736 165.53 26.9236 168.5 26.9236C171.28 26.9236 173.73 27.5337 175.86 28.7537C177.99 29.9737 179.65 31.6437 180.82 33.7737C182.04 35.8637 182.65 38.2036 182.65 40.7936C182.65 41.2136 182.63 41.6536 182.59 42.1036C182.59 42.4736 182.58 42.8436 182.55 43.2336C182.54 43.4036 182.4 43.5237 182.24 43.5237H161.36C161.18 43.5237 161.03 43.6836 161.05 43.8636C161.25 45.9136 162.01 47.5236 163.3 48.7136C164.71 49.9736 166.4 50.5936 168.38 50.5936C169.86 50.5936 171.1 50.2737 172.09 49.6237C173.06 48.9737 173.79 48.1636 174.28 47.1836C174.34 47.0736 174.45 47.0037 174.57 47.0037H181.36C181.57 47.0037 181.72 47.2036 181.66 47.4136C181.12 49.0436 180.27 50.5436 179.11 51.9136C177.89 53.3636 176.37 54.5036 174.54 55.3336C172.75 56.1736 170.72 56.5936 168.43 56.5936V56.6136ZM168.49 32.8737C166.7 32.8737 165.12 33.3836 163.75 34.4136C162.46 35.3436 161.62 36.7436 161.2 38.6036C161.16 38.7936 161.31 38.9736 161.51 38.9736H174.89C175.07 38.9736 175.22 38.8237 175.2 38.6337C175.03 36.9237 174.35 35.5537 173.17 34.5137C171.91 33.4137 170.35 32.8636 168.49 32.8636V32.8737Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M202.41 55.8136C205.127 55.8136 207.33 53.6109 207.33 50.8937C207.33 48.1764 205.127 45.9736 202.41 45.9736C199.693 45.9736 197.49 48.1764 197.49 50.8937C197.49 53.6109 199.693 55.8136 202.41 55.8136Z", fill: "#2C71F0" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 19.3236C19.8998 16.3836 17.0398 14.7036 12.8398 14.7036C4.97982 14.7536 0.319824 21.0036 0.319824 29.6736C0.319824 38.3436 4.96982 44.5936 12.8398 44.5936C14.2798 44.6736 15.7298 44.4236 17.0698 43.8636C18.4098 43.3036 19.6098 42.4436 20.5798 41.3536V45.5237C20.5798 48.3637 19.0798 51.7336 14.3198 51.7336C10.7098 51.7336 8.92982 49.7136 8.30982 47.5436L1.92982 50.6337C3.52982 54.7337 7.34982 58.1736 14.7698 58.1736C25.7698 58.1736 28.5998 50.7537 28.5998 44.2537V15.1136H21.8698L21.6898 19.3136L21.6698 19.3236ZM14.5598 37.7936C10.6298 37.7936 8.30982 34.5936 8.30982 29.6136C8.30982 24.6336 10.6298 21.4336 14.5598 21.4336C18.4898 21.4336 20.7598 24.6336 20.7598 29.6136C20.7598 34.5936 18.4898 37.7936 14.5598 37.7936Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 60.4536V70.3436H0.569824V64.5037H22.8598V60.4536H28.5798H28.5898Z", fill: "#5532FA" }));
const SvgExpensify$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 327, height: 82, viewBox: "0 0 327 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.6698 19.1918C19.8998 16.2518 17.0398 14.5718 12.8398 14.5718C4.97982 14.6218 0.319824 20.8718 0.319824 29.5418C0.319824 38.2118 4.96982 44.4618 12.8398 44.4618C14.2798 44.5418 15.7298 44.2918 17.0698 43.7318C18.4098 43.1718 19.6098 42.3118 20.5798 41.2218V45.3918C20.5798 48.2318 19.0798 51.6018 14.3198 51.6018C10.7098 51.6018 8.92982 49.5818 8.30982 47.4118L1.92982 50.5018C3.52982 54.6018 7.34982 58.0418 14.7698 58.0418C25.7698 58.0418 28.5998 50.6218 28.5998 44.1218V14.9818H21.8698L21.6898 19.1818L21.6698 19.1918ZM14.5598 37.6618C10.6298 37.6618 8.30982 34.4618 8.30982 29.4818C8.30982 24.5018 10.6298 21.3018 14.5598 21.3018C18.4898 21.3018 20.7598 24.5018 20.7598 29.4818C20.7598 34.4618 18.4898 37.6618 14.5598 37.6618Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 60.3218V70.2118H0.569824V64.3718H22.8598V60.3218H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.601807H57.8696V81.9618H58.8696V0.601807Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M88.1396 55.8218H114.1V47.9918H97.6796V40.7418H111.61V32.7218H97.6796V25.8518H114.1V18.0218H88.1396V55.8118V55.8218Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M165.45 25.8518C161.44 25.8518 158.77 27.0018 156.48 30.2418H156.29L155.14 26.6118H148.27V65.9318H157.24V53.5218H157.43C159.15 55.4318 161.63 56.3818 165.07 56.3818C173.09 56.3818 178.81 49.7018 178.81 41.4918V40.3418C178.81 31.3718 172.13 25.8318 165.45 25.8318V25.8518ZM163.16 49.1418C158.96 49.1418 157.05 45.7018 157.05 41.1218C157.05 36.5418 158.96 33.2918 163.16 33.2918C167.36 33.2918 169.27 36.9218 169.27 41.3118C169.27 45.7018 167.17 49.1418 163.16 49.1418Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M209.54 40.3618C209.54 30.6318 202.67 25.8518 195.22 25.8518C186.82 25.8518 180.33 31.7718 180.33 40.9318V41.8818C180.33 51.2318 187.39 56.7718 195.6 56.7718C202.28 56.7718 208.2 53.5318 209.53 46.8418H200.94C199.99 49.1318 198.08 49.8918 195.79 49.8918C191.97 49.8918 189.87 47.2218 189.49 43.5918H209.34C209.34 42.8318 209.53 41.4918 209.53 40.3518L209.54 40.3618ZM189.69 37.6918C190.07 34.6418 191.98 32.3518 195.42 32.3518C198.47 32.3518 200.57 34.4518 200.57 37.6918H189.69Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M228.44 25.8518C224.81 25.8518 221.95 27.1918 219.85 30.4318H219.66L218.51 26.6118H211.45V55.6218H220.61V38.8218C220.61 35.1918 222.33 33.2818 225.38 33.2818C227.86 33.2818 229.77 34.8118 229.77 38.8218V55.6218H238.93V36.1518C238.93 30.6118 235.69 25.8418 228.43 25.8418L228.44 25.8518Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M252.68 37.1118C251.15 36.7318 250.01 36.1618 250.01 34.4418C250.01 33.1018 250.96 32.1518 253.06 32.1518C255.35 32.1518 256.5 33.3018 256.5 35.2018H264.71V34.6318C264.71 28.5218 259.17 26.0418 252.88 26.0418C247.34 26.0418 241.05 28.3318 241.05 35.2018V35.5818C241.05 37.6818 241.81 39.5918 243.15 40.9218C246.01 43.7818 250.4 44.1618 253.46 44.9318C255.94 45.5018 256.51 46.6518 256.51 47.9818C256.51 49.7018 255.17 50.6518 253.07 50.6518C250.59 50.6518 249.06 49.3118 248.87 46.4518H240.66V47.0218C241.04 54.0818 246.39 56.7518 253.07 56.7518C258.99 56.7518 265.48 54.0818 265.48 47.2118V46.4518C265.48 44.3518 264.72 42.4418 263.57 41.1118C260.9 38.0618 256.32 37.6718 252.69 37.1018L252.68 37.1118Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M276.54 26.8118H267.38V55.8218H276.54V26.8118Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M146.36 26.8118H136.24L131.47 34.0618L126.51 26.8118H116.2L125.93 40.3618L114.86 55.8218H124.98L131.09 47.0418L137.2 55.8218H147.7L136.44 40.1718L146.37 26.8118H146.36Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M271.959 12.6818C268.909 12.6818 266.419 15.1618 266.419 18.2218C266.419 21.2818 268.899 23.7618 271.959 23.7618C275.019 23.7618 277.489 21.2818 277.489 18.2218C277.489 15.1618 275.009 12.6818 271.959 12.6818Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M292.95 26.8118V25.8618C292.95 23.3818 294.67 20.9018 297.34 20.9018H300.01V12.8818H296.77C288.94 13.0718 283.79 18.9918 283.79 26.4318V26.8118H278.45V33.6818H283.79V55.6318H292.95V33.6818H298.87L306.51 53.7218L301.17 66.1318H310.71L326.93 26.8118H317.39L311.09 44.1818L305.36 26.8118H292.95Z", fill: "#0C1B33" }));
const SvgGosite$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 283, height: 82, viewBox: "0 0 283 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.9355C19.8998 15.9955 17.0398 14.3154 12.8398 14.3154C4.97982 14.3654 0.319824 20.6155 0.319824 29.2855C0.319824 37.9555 4.96982 44.2054 12.8398 44.2054C14.2798 44.2854 15.7298 44.0355 17.0698 43.4755C18.4098 42.9155 19.6098 42.0555 20.5798 40.9655V45.1355C20.5798 47.9755 19.0798 51.3455 14.3198 51.3455C10.7098 51.3455 8.92982 49.3255 8.30982 47.1555L1.92982 50.2455C3.52982 54.3455 7.34982 57.7855 14.7698 57.7855C25.7698 57.7855 28.5998 50.3655 28.5998 43.8655V14.7255H21.8698L21.6898 18.9255L21.6698 18.9355ZM14.5598 37.4055C10.6298 37.4055 8.30982 34.2055 8.30982 29.2255C8.30982 24.2455 10.6298 21.0455 14.5598 21.0455C18.4898 21.0455 20.7598 24.2455 20.7598 29.2255C20.7598 34.2055 18.4898 37.4055 14.5598 37.4055Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 60.0557V69.9456H0.569824V64.1056H22.8598V60.0557H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8599 0.345459H57.8599V81.7054H58.8599V0.345459Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M90.6298 46.9055L113.65 23.7555L136.68 46.9055C141.22 37.3655 139.55 25.6154 131.7 17.7154C121.73 7.69544 105.59 7.69544 95.6198 17.7154C87.7598 25.6154 86.0998 37.3655 90.6398 46.9055H90.6298Z", fill: "#0058FF" }), /* @__PURE__ */ React.createElement("path", { d: "M113.64 23.7555L90.6196 46.9055C91.8296 49.4555 93.4896 51.8655 95.5996 53.9855L100.1 58.5255L113.63 44.9255L127.16 58.5255L131.66 53.9955C133.77 51.8755 135.43 49.4855 136.64 46.9155L113.62 23.7455L113.64 23.7555Z", fill: "#08B2FA" }), /* @__PURE__ */ React.createElement("path", { d: "M113.64 44.9155L100.11 58.5155L113.64 72.1155L127.17 58.5155L113.64 44.9155Z", fill: "#86EAFA" }), /* @__PURE__ */ React.createElement("path", { d: "M178.68 30.5854V51.3254C178.68 53.3854 178.42 55.2455 177.93 56.8955C177.42 58.5455 176.65 59.9655 175.6 61.1155C174.55 62.2755 173.22 63.1755 171.61 63.7955C170.01 64.4255 168.1 64.7455 165.89 64.7455C163.68 64.7455 161.79 64.4754 159.9 63.9454C158.02 63.3954 156.26 62.4155 154.66 61.0055L158.06 56.3455C159.19 57.3855 160.38 58.1955 161.61 58.7655C162.84 59.3255 164.26 59.6155 165.86 59.6155C167.22 59.6155 168.35 59.4255 169.28 59.0555C170.21 58.6655 170.94 58.1555 171.5 57.4855C172.04 56.8255 172.44 56.0255 172.68 55.0955C172.92 54.1655 173.03 53.1255 173.03 51.9855V50.3354H172.93C172.12 51.4454 171.03 52.2754 169.67 52.8254C168.31 53.3754 166.94 53.6555 165.52 53.6555C163.83 53.6555 162.28 53.3455 160.89 52.7255C159.5 52.1155 158.32 51.2855 157.33 50.2355C156.34 49.1955 155.57 47.9555 155.05 46.5255C154.51 45.0955 154.25 43.5855 154.25 41.9655C154.25 40.3455 154.51 38.7255 155 37.2655C155.5 35.8055 156.25 34.5555 157.22 33.4755C158.19 32.3955 159.38 31.5455 160.73 30.9355C162.1 30.3255 163.67 30.0055 165.43 30.0055C167.04 30.0055 168.53 30.3254 169.92 30.9554C171.31 31.5854 172.41 32.5955 173.23 33.9855H173.33V30.5854H178.7H178.68ZM166.59 35.1455C165.58 35.1455 164.67 35.3055 163.86 35.6455C163.05 35.9855 162.34 36.4355 161.75 37.0255C161.18 37.6055 160.71 38.3255 160.38 39.1655C160.04 39.9955 159.88 40.9354 159.88 41.9454C159.88 42.8654 160.04 43.7155 160.38 44.5155C160.72 45.3055 161.18 46.0055 161.77 46.6055C162.36 47.1955 163.08 47.6855 163.89 48.0355C164.7 48.3855 165.58 48.5654 166.54 48.5654C167.58 48.5654 168.52 48.3855 169.35 48.0355C170.18 47.6855 170.9 47.2155 171.47 46.6355C172.05 46.0555 172.51 45.3555 172.81 44.5155C173.13 43.6955 173.29 42.8155 173.29 41.8455C173.29 39.8555 172.7 38.2355 171.5 37.0155C170.3 35.7655 168.66 35.1555 166.58 35.1555L166.59 35.1455Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M182.98 41.9755C182.98 40.1755 183.3 38.5354 183.95 37.0654C184.59 35.5854 185.47 34.3355 186.57 33.2955C187.67 32.2555 188.98 31.4455 190.48 30.8755C192 30.3155 193.59 30.0255 195.29 30.0255C196.99 30.0255 198.6 30.3155 200.11 30.8755C201.63 31.4355 202.92 32.2555 204.02 33.2955C205.12 34.3355 206 35.5954 206.64 37.0654C207.28 38.5454 207.61 40.1755 207.61 41.9755C207.61 43.7755 207.29 45.4155 206.64 46.8855C206 48.3655 205.12 49.6155 204.02 50.6555C202.92 51.6955 201.61 52.5054 200.11 53.0754C198.59 53.6354 197 53.9255 195.29 53.9255C193.58 53.9255 191.98 53.6354 190.48 53.0754C188.96 52.5154 187.67 51.6955 186.57 50.6555C185.47 49.6155 184.59 48.3555 183.95 46.8855C183.3 45.4255 182.98 43.7855 182.98 41.9755ZM188.65 41.9755C188.65 42.8555 188.79 43.7055 189.1 44.5455C189.4 45.3655 189.83 46.1055 190.43 46.7255C191 47.3555 191.71 47.8655 192.54 48.2555C193.37 48.6455 194.28 48.8154 195.32 48.8154C196.36 48.8154 197.28 48.6255 198.1 48.2555C198.91 47.8655 199.62 47.3755 200.21 46.7255C200.78 46.0955 201.23 45.3655 201.54 44.5455C201.84 43.7255 201.99 42.8755 201.99 41.9755C201.99 41.0755 201.85 40.2455 201.54 39.4055C201.24 38.5855 200.81 37.8455 200.21 37.2255C199.63 36.5955 198.93 36.0854 198.1 35.6954C197.29 35.3054 196.36 35.1355 195.32 35.1355C194.28 35.1355 193.36 35.3254 192.54 35.6954C191.73 36.0854 191.02 36.5755 190.43 37.2255C189.85 37.8555 189.41 38.5855 189.1 39.4055C188.8 40.2355 188.65 41.0955 188.65 41.9755Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M224.01 36.9055C222.91 35.3455 221.42 34.5754 219.57 34.5754C218.82 34.5754 218.07 34.7655 217.35 35.1355C216.63 35.5255 216.26 36.1355 216.26 36.9855C216.26 37.6755 216.56 38.1855 217.15 38.5155C217.74 38.8355 218.51 39.0954 219.42 39.3154C220.33 39.5354 221.32 39.7655 222.37 40.0055C223.42 40.2455 224.41 40.5955 225.32 41.0955C226.23 41.5955 226.98 42.2555 227.59 43.1155C228.18 43.9655 228.48 45.1355 228.48 46.6355C228.48 47.9955 228.19 49.1354 227.6 50.0754C227.03 51.0054 226.26 51.7654 225.33 52.3254C224.4 52.8854 223.35 53.3054 222.18 53.5654C221.01 53.8254 219.85 53.9554 218.68 53.9554C216.92 53.9554 215.29 53.6954 213.82 53.2054C212.33 52.6954 211.02 51.7754 209.86 50.4554L213.63 46.8955C214.35 47.7155 215.13 48.3855 215.96 48.9155C216.79 49.4255 217.81 49.7054 219.01 49.7054C219.43 49.7054 219.84 49.6554 220.29 49.5654C220.74 49.4654 221.14 49.3054 221.52 49.0854C221.9 48.8654 222.21 48.5855 222.45 48.2555C222.69 47.9155 222.8 47.5355 222.8 47.0955C222.8 46.3055 222.5 45.7155 221.91 45.3455C221.32 44.9555 220.55 44.6555 219.64 44.4155C218.73 44.1755 217.74 43.9455 216.69 43.7555C215.64 43.5455 214.65 43.2255 213.74 42.7555C212.83 42.2855 212.08 41.6654 211.47 40.8254C210.88 40.0054 210.58 38.8655 210.58 37.4055C210.58 36.1355 210.84 35.0455 211.36 34.1155C211.89 33.1855 212.56 32.4154 213.42 31.8154C214.27 31.2254 215.24 30.7755 216.34 30.4855C217.44 30.1955 218.56 30.0555 219.69 30.0555C221.21 30.0555 222.69 30.3155 224.18 30.8455C225.67 31.3555 226.85 32.2555 227.77 33.5255L223.98 36.9255L224.01 36.9055Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M231.18 22.8555C231.18 21.9355 231.51 21.1355 232.2 20.4655C232.87 19.7955 233.73 19.4355 234.77 19.4355C235.81 19.4355 236.69 19.7555 237.39 20.4155C238.09 21.0555 238.46 21.8755 238.46 22.8555C238.46 23.8355 238.11 24.6555 237.39 25.2955C236.69 25.9355 235.81 26.2755 234.77 26.2755C233.73 26.2755 232.87 25.9355 232.2 25.2455C231.51 24.5755 231.18 23.7655 231.18 22.8555ZM231.98 30.5955H237.65V53.3755H231.98V30.5955Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M240.52 35.4255V30.5955H245.2V23.9955H250.87V30.5955H257.1V35.4255H250.87V45.3955C250.87 46.5355 251.08 47.4355 251.51 48.0955C251.94 48.7555 252.77 49.0955 254.03 49.0955C254.54 49.0955 255.08 49.0455 255.68 48.9355C256.27 48.8255 256.75 48.6455 257.1 48.3855V53.1855C256.51 53.4755 255.77 53.6655 254.91 53.7755C254.05 53.8855 253.28 53.9355 252.63 53.9355C251.11 53.9355 249.88 53.7755 248.92 53.4355C247.96 53.0955 247.21 52.6055 246.65 51.9055C246.11 51.2355 245.72 50.3755 245.52 49.3655C245.31 48.3555 245.22 47.1855 245.22 45.8455V35.4055H240.52V35.4255Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M265.07 43.9655C265.26 45.6655 265.92 46.9954 267.05 47.9454C268.18 48.8954 269.56 49.3755 271.15 49.3755C272.57 49.3755 273.75 49.0855 274.71 48.4955C275.67 47.9155 276.51 47.1755 277.23 46.2955L281.29 49.3755C279.96 51.0155 278.49 52.1855 276.85 52.8955C275.22 53.5855 273.49 53.9355 271.71 53.9355C270.02 53.9355 268.4 53.6454 266.89 53.0854C265.37 52.5054 264.08 51.7055 262.98 50.6655C261.88 49.6255 261 48.3655 260.36 46.8955C259.72 45.4155 259.39 43.7855 259.39 41.9855C259.39 40.1855 259.71 38.5454 260.36 37.0754C261 35.5954 261.88 34.3455 262.98 33.3055C264.08 32.2655 265.39 31.4555 266.89 30.8855C268.41 30.3255 270 30.0355 271.71 30.0355C273.28 30.0355 274.73 30.3055 276.02 30.8755C277.33 31.4255 278.45 32.2255 279.37 33.2655C280.3 34.3055 281.02 35.5955 281.54 37.1355C282.07 38.6755 282.32 40.4255 282.32 42.4355V44.0055H265.05V43.9855L265.07 43.9655ZM276.68 39.6954C276.65 38.0254 276.12 36.6955 275.11 35.7255C274.1 34.7655 272.7 34.2855 270.91 34.2855C269.22 34.2855 267.86 34.7855 266.87 35.7655C265.88 36.7455 265.27 38.0654 265.05 39.6954H276.68Z", fill: "#082344" }));
const SvgHeard$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 242, height: 83, viewBox: "0 0 242 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9109_21263)" }, /* @__PURE__ */ React.createElement("path", { d: "M58.8604 0.866455H57.8604V82.2265H58.8604V0.866455Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6605 19.0165C19.8905 16.0765 17.0305 14.3965 12.8305 14.3965C4.97055 14.4465 0.310547 20.6965 0.310547 29.3665C0.310547 38.0365 4.96055 44.2865 12.8305 44.2865C14.2705 44.3665 15.7205 44.1165 17.0605 43.5565C18.4005 42.9965 19.6005 42.1365 20.5705 41.0465V45.2165C20.5705 48.0565 19.0705 51.4265 14.3105 51.4265C10.7005 51.4265 8.92055 49.4065 8.30055 47.2365L1.92055 50.3265C3.52055 54.4265 7.34055 57.8665 14.7605 57.8665C25.7605 57.8665 28.5905 50.4465 28.5905 43.9465V14.8165H21.8605L21.6805 19.0165H21.6605ZM14.5505 37.4865C10.6205 37.4865 8.30055 34.2865 8.30055 29.3065C8.30055 24.3265 10.6205 21.1265 14.5505 21.1265C18.4805 21.1265 20.7505 24.3265 20.7505 29.3065C20.7505 34.2865 18.4805 37.4865 14.5505 37.4865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5805 60.1365V70.0265H0.560547V64.1865H22.8505V60.1365H28.5705H28.5805Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M114.3 15.7166V33.5766H95.3704V15.7166H88.1304V56.0366H95.3704V37.5866H114.3V56.0366H121.54V15.7166H114.3Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M186.78 49.0465V37.3965C186.78 35.0465 186.25 30.7065 181.15 28.2865C176.05 25.8665 167.66 24.5765 160.94 31.9665L163.53 34.1565C163.53 34.1565 169.13 28.7565 175.76 31.5665C177.79 32.4365 179.22 34.8265 179.44 36.3765C179.63 37.7065 179.44 40.1465 179.44 40.1465C177.51 38.9665 174.56 37.7265 170.59 37.7265C163 37.7265 158.63 41.7965 158.63 47.4065C158.63 53.0165 163 56.6865 170.59 56.6865C174.78 56.6865 177.85 54.6965 179.76 52.9065C179.92 53.8865 180.13 54.8165 180.43 55.8565H187.62C186.84 53.7765 186.79 49.8465 186.79 49.0565L186.78 49.0465ZM172.66 52.9065C165.63 52.9065 166.03 47.4065 166.03 47.4065C166.03 47.4065 165.63 41.5065 172.66 41.5065C175.59 41.5065 177.88 42.6065 179.42 43.6365V49.0765C177.87 51.0565 175.63 52.9065 172.66 52.9065Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M141.3 26.3866C129.82 26.8966 125.88 35.2366 125.88 41.2366C125.88 52.1366 134.86 56.6766 141.3 56.6766C147.74 56.6766 151.72 55.0266 154.94 50.3866L152.32 48.4666C152.32 48.4666 149.73 52.3366 144 52.3366C137.31 52.3366 133.69 47.3366 133.69 43.2566H156.42C157.75 35.0366 151.65 25.9266 141.3 26.3866ZM133.7 39.2466C133.7 39.2466 134.49 30.4666 141.09 30.1966C148.44 30.1966 148.91 39.2466 148.91 39.2466H133.7Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M201.04 29.2664C200.15 30.1964 199.47 31.2564 198.81 32.3664V27.0764H191.09C191.48 28.1364 191.69 29.7864 191.78 31.0964V55.8564H199.04V40.4064C199.05 39.5164 199.14 38.6164 199.3 37.7364C200.01 33.9964 202.75 31.6664 206.57 31.5264H209.28V26.3964C206.24 26.1864 203.17 27.0064 201.02 29.2564L201.04 29.2664Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M241.32 56.0565C240.93 55.0065 240.72 53.3665 240.63 52.0465V15.6665H233.25V31.1565C231.16 28.2065 227.9 26.3165 223.38 26.3165C216.35 26.3165 209.71 32.7665 209.71 41.3265C209.71 51.0265 216.36 56.6665 223.38 56.6665C228.12 56.6665 231.34 55.1065 233.35 52.0565C233.37 52.3065 233.41 52.7265 233.46 53.1165C233.62 54.0965 233.83 55.0265 234.13 56.0665H241.32C241.32 56.0665 241.32 56.0565 241.32 56.0465V56.0565ZM225.68 51.7465C221.31 51.7465 217.11 47.9165 217.11 41.5065C217.11 35.5665 221.3 31.7365 225.68 31.7365C228.83 31.7365 231.82 33.7965 233.25 37.1765V46.3665C231.82 49.8265 228.83 51.7365 225.68 51.7365V51.7465Z", fill: "#226752" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9109_21263" }, /* @__PURE__ */ React.createElement("rect", { width: 241, height: 81.36, fill: "white", transform: "translate(0.320312 0.866455)" }))));
const SvgLoot$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 170, height: 82, viewBox: "0 0 170 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.6396C19.8998 15.6996 17.0398 14.0198 12.8398 14.0198C4.97982 14.0698 0.319824 20.3197 0.319824 28.9897C0.319824 37.6597 4.96982 43.9097 12.8398 43.9097C14.2798 43.9897 15.7298 43.7397 17.0698 43.1797C18.4098 42.6197 19.6098 41.7597 20.5798 40.6697V44.8396C20.5798 47.6796 19.0798 51.0498 14.3198 51.0498C10.7098 51.0498 8.92982 49.0296 8.30982 46.8596L1.92982 49.9497C3.52982 54.0497 7.34982 57.4897 14.7698 57.4897C25.7698 57.4897 28.5998 50.0698 28.5998 43.5698V14.4297H21.8698L21.6898 18.6296L21.6698 18.6396ZM14.5598 37.1096C10.6298 37.1096 8.30982 33.9097 8.30982 28.9297C8.30982 23.9497 10.6298 20.7498 14.5598 20.7498C18.4898 20.7498 20.7598 23.9497 20.7598 28.9297C20.7598 33.9097 18.4898 37.1096 14.5598 37.1096Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.7598V69.6497H0.569824V63.8098H22.8598V59.7598H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.239746H57.8696V81.5996H58.8696V0.239746Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M95.3597 41.8596V15.9998H88.4297V41.8596C88.4297 49.4596 94.6197 55.6497 102.23 55.6497V48.6697C98.4797 48.6697 95.3597 45.6096 95.3597 41.8596Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M162.2 39.3997V29.2097H168.74V21.3296H162.2V16.5896H154.31V39.3997C154.31 47.9797 161.3 54.9697 169.9 54.9697V47.0896C165.66 47.0896 162.2 43.6297 162.2 39.3997Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M116.6 33.1196V26.1697C108.48 26.1697 101.88 32.7098 101.88 40.7598H108.89C108.89 36.5398 112.35 33.1096 116.61 33.1096L116.6 33.1196Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M124.32 40.7698C124.32 37.1698 125.63 33.8598 127.79 31.2998C125.09 28.1798 121.08 26.1797 116.6 26.1797V33.1296C120.86 33.1296 124.32 36.5598 124.32 40.7798V40.7698Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M146.74 40.7698C146.74 45.0198 143.29 48.4797 139.02 48.4797C134.75 48.4797 131.31 45.0198 131.31 40.7698C131.31 44.3798 129.97 47.6897 127.78 50.2397C130.48 53.4397 134.52 55.6196 139.02 55.6196C147.14 55.6196 153.76 48.8798 153.76 40.7698H146.74Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M139.04 26.0598C134.54 26.0598 130.49 28.0998 127.79 31.2898C125.62 33.8498 124.32 37.1598 124.32 40.7598C124.32 44.9798 120.87 48.4097 116.6 48.4097C112.33 48.4097 108.88 44.9898 108.88 40.7598H101.87C101.87 48.8098 108.47 55.3496 116.59 55.3496C121.07 55.3496 125.08 53.3597 127.78 50.2297C129.99 47.6797 131.31 44.3698 131.31 40.7598C131.31 36.5098 134.76 33.0498 139.03 33.0498C143.3 33.0498 146.75 36.4998 146.75 40.7598H153.76C153.76 32.6498 147.14 26.0598 139.04 26.0598Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M131.479 40.1997C131.169 43.7897 130.069 48.0997 127.689 50.4697C130.109 53.8197 133.439 55.5996 139.069 55.5996V48.5098C134.829 48.1398 131.109 44.3997 131.479 40.1997Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M120.61 41.5896L128.38 33.7898L136.15 41.5896L128.38 49.3896L120.61 41.5896Z", fill: "#BFF0D4", stroke: "white", strokeWidth: 1.99, strokeMiterlimit: 10 }));
const SvgOwnerActions$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 260, height: 83, viewBox: "0 0 260 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.6698 19.4696C19.8998 16.5296 17.0398 14.8496 12.8398 14.8496C4.97982 14.8996 0.319824 21.1496 0.319824 29.8196C0.319824 38.4896 4.96982 44.7395 12.8398 44.7395C14.2798 44.8195 15.7298 44.5695 17.0698 44.0095C18.4098 43.4495 19.6098 42.5895 20.5798 41.4995V45.6696C20.5798 48.5096 19.0798 51.8795 14.3198 51.8795C10.7098 51.8795 8.92982 49.8596 8.30982 47.6896L1.92982 50.7795C3.52982 54.8795 7.34982 58.3196 14.7698 58.3196C25.7698 58.3196 28.5998 50.8995 28.5998 44.3995V15.2595H21.8698L21.6898 19.4596L21.6698 19.4696ZM14.5598 37.9396C10.6298 37.9396 8.30982 34.7395 8.30982 29.7595C8.30982 24.7795 10.6298 21.5796 14.5598 21.5796C18.4898 21.5796 20.7598 24.7795 20.7598 29.7595C20.7598 34.7395 18.4898 37.9396 14.5598 37.9396Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 60.5896V70.4796H0.569824V64.6395H22.8598V60.5896H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M137.56 28.8198L112.63 53.7498L96.6199 37.6998L101.79 32.4897L112.63 43.3298L133.06 22.9298C128.28 18.2198 121.76 15.2998 114.52 15.2998C99.9399 15.2998 88.1299 27.0998 88.1299 41.6898C88.1299 56.2798 99.9299 68.0798 114.52 68.0798C129.11 68.0798 140.91 56.2798 140.91 41.6898C140.87 37.0198 139.66 32.6298 137.56 28.8198Z", fill: "url(#paint0_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M163.2 28.9198V26.5999C162.59 21.6399 158.14 18.2598 152.61 18.2598C146.58 18.2598 141.84 22.1498 141.84 27.7498C141.84 33.3498 146.15 37.1998 152.61 37.1998C158.35 37.2398 162.63 33.8098 163.2 28.9298V28.9198ZM152.57 31.9498C150.07 31.9498 148.4 30.1998 148.4 27.7798C148.4 25.3598 150.25 23.5698 152.57 23.5698C154.89 23.5698 156.71 25.3198 156.71 27.7798C156.75 30.1998 155 31.9498 152.57 31.9498Z", fill: "url(#paint1_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M187.48 28.4598L183.2 18.8298H178.96L174.68 28.4598L170.33 18.8298H163.27V18.9698L172.79 36.6998H176.96L181.07 27.4598L185.2 36.6998H189.37L198.93 18.8298H191.83L187.48 28.4598Z", fill: "url(#paint2_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M211.7 18.2998C209.74 18.2998 207.99 19.2998 206.57 20.6898H206.5V18.7998H200.33V36.6698H206.5V26.6099C206.5 24.8299 208.32 23.1198 210.17 23.1198C212.17 23.1198 213.38 24.8299 213.38 26.6099V36.6998H219.55V24.9298C219.51 19.9398 214.99 18.2998 211.7 18.2998Z", fill: "url(#paint3_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M241.15 32.5598L236.69 30.3098C235.19 31.9098 234.34 32.3098 232.34 32.3098C230.77 32.3098 228.49 31.3799 228.49 28.5999H241.43C241.47 28.3899 241.47 28.0298 241.47 27.7798C241.47 21.4998 237.33 18.2898 231.88 18.2898C226.43 18.2898 222.07 22.5298 222.07 27.7798C222.07 33.0298 226.49 37.2299 231.88 37.2299C235.87 37.2299 239.15 35.9098 241.15 32.5598ZM232.06 22.2898C233.88 22.2898 235.16 23.2898 235.45 25.1798H228.67C228.78 23.5798 229.95 22.2898 232.06 22.2898Z", fill: "url(#paint4_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M249.96 21.3998H249.89V18.8298H243.72V36.6998H249.89V27.2898C249.89 26.8298 250.35 23.6498 253.56 23.6498C255.63 23.6498 256.77 24.6099 256.77 24.6099L259.34 19.3698C259.34 19.3698 257.74 18.2598 255.45 18.2598C251.92 18.2998 249.96 21.3998 249.96 21.3998Z", fill: "url(#paint5_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M156.6 48.4297C155.14 46.9997 153.14 46.1797 150.75 46.1797C145.51 46.1797 141.87 50.4197 141.87 55.6697C141.87 60.9197 145.51 65.0796 150.75 65.1196H150.79C153.21 65.1196 155.32 64.0497 156.64 62.5897H156.71V64.6196H162.81V46.7496H156.61V48.4297H156.6ZM152.57 59.8397C150.07 59.8397 148.4 58.0897 148.4 55.6697C148.4 53.2497 150.25 51.4597 152.57 51.4597C154.89 51.4597 156.71 53.2097 156.71 55.6697C156.75 58.0897 155 59.8397 152.57 59.8397Z", fill: "url(#paint6_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M177.39 59.1997C177.39 59.1997 176.25 60.0197 174.39 60.0197C172.07 60.0197 170.15 58.0597 170.15 55.5997C170.15 53.1397 172.08 51.2097 174.39 51.2097C176.24 51.2097 177.39 52.0297 177.39 52.0297L179.49 47.8197C179.49 47.8197 177.46 46.1396 173.5 46.1396C168.29 46.1396 163.62 50.3797 163.62 55.6597C163.62 60.9397 168.36 65.0697 173.5 65.0697C177.46 65.0697 179.49 63.4697 179.49 63.4697L177.39 59.1897V59.1997Z", fill: "url(#paint7_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M191.55 59.0198C191.55 59.0198 190.8 59.5898 190.02 59.5898C189.06 59.5898 188.63 58.8098 188.63 57.1298V51.4598H192.37V46.7498H188.63V40.0798H182.46V46.7498H179.89V51.4598H182.46V58.3098C182.46 61.4798 183.64 65.1198 188.52 65.1198H188.59C191.12 65.1198 193.08 64.0098 193.08 64.0098L191.55 59.0198Z", fill: "url(#paint8_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M197.29 37.9497C195.26 37.9497 193.62 39.5896 193.62 41.6196C193.62 43.6496 195.26 45.2897 197.29 45.2897C199.32 45.2897 200.96 43.6496 200.96 41.6196C200.92 39.5496 199.28 37.9497 197.29 37.9497Z", fill: "url(#paint9_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M200.29 46.7197H194.12V64.5897H200.29V46.7197Z", fill: "url(#paint10_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M212.23 46.1797C206.2 46.1797 201.46 50.0697 201.46 55.6697C201.46 61.2697 205.77 65.0796 212.19 65.1196H212.23C218.36 65.1196 222.86 61.1997 222.86 55.7097V55.6697C222.9 50.0697 218.15 46.1797 212.23 46.1797ZM212.19 59.8397C209.69 59.8397 208.02 58.0897 208.02 55.6697C208.02 53.2497 209.87 51.4597 212.19 51.4597C214.51 51.4597 216.33 53.2097 216.33 55.6697C216.37 58.0897 214.62 59.8397 212.19 59.8397Z", fill: "url(#paint11_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M234.91 46.1797H234.84C232.91 46.1797 231.13 47.1797 229.74 48.5697H229.67V46.6797H223.5V64.5497H229.67V54.4597C229.67 52.6797 231.49 50.9697 233.34 50.9697C235.34 50.9697 236.55 52.6797 236.55 54.4597V64.5497H242.72V52.7496C242.68 47.8296 238.16 46.2197 234.91 46.1897V46.1797Z", fill: "url(#paint12_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M253.53 53.2799C252 52.7799 250.75 52.5299 250.75 51.5699C250.75 50.7499 251.32 50.4999 252.68 50.4999C254.57 50.4999 256.64 51.61 256.64 51.61L258.67 47.58C258.67 47.58 256.14 46.1899 252.71 46.1899H252.64C247.97 46.1899 244.87 48.2899 244.87 51.9299C244.87 54.5999 246.69 55.8499 248.51 56.8199C250.54 57.8499 252.47 57.9599 252.47 59.2399C252.47 60.4199 251.44 60.5199 250.54 60.5199C248.54 60.5199 246.12 58.45 246.12 58.45L243.62 62.6599C243.62 62.6599 246.19 65.0499 250.5 65.0499C254.17 65.0499 258.95 64.23 258.95 58.95C258.95 55.35 255.88 54.0299 253.53 53.2799Z", fill: "url(#paint13_linear_8660_22033)" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8599 0.879639H57.8599V82.2396H58.8599V0.879639Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_8660_22033", x1: 137.309, y1: 59.7172, x2: 99.624, y2: 22.0324, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint1_linear_8660_22033", x1: 163.545, y1: 11.5324, x2: 163.545, y2: 78.4459, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint2_linear_8660_22033", x1: 193.23, y1: 11.5325, x2: 193.23, y2: 78.4457, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint3_linear_8660_22033", x1: 220.328, y1: 11.5325, x2: 220.328, y2: 78.4458, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint4_linear_8660_22033", x1: 242.545, y1: 11.5325, x2: 242.545, y2: 78.4459, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint5_linear_8660_22033", x1: 262.61, y1: 11.5324, x2: 262.61, y2: 78.4459, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint6_linear_8660_22033", x1: 146.475, y1: 38.5982, x2: 146.475, y2: 60.1126, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint7_linear_8660_22033", x1: 165.407, y1: 38.5981, x2: 165.407, y2: 60.1127, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint8_linear_8660_22033", x1: 180.199, y1: 38.5983, x2: 180.199, y2: 60.1128, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint9_linear_8660_22033", x1: 190.849, y1: 38.5982, x2: 190.849, y2: 60.1126, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint10_linear_8660_22033", x1: 190.849, y1: 38.5982, x2: 190.849, y2: 60.1127, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint11_linear_8660_22033", x1: 206.097, y1: 38.5982, x2: 206.097, y2: 60.1126, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint12_linear_8660_22033", x1: 226.736, y1: 38.5982, x2: 226.736, y2: 60.1127, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint13_linear_8660_22033", x1: 245.127, y1: 38.5984, x2: 245.127, y2: 60.1129, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" }))));
const SvgPrimePay$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 344, height: 82, viewBox: "0 0 344 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.8677C19.8998 15.9277 17.0398 14.2477 12.8398 14.2477C4.97982 14.2977 0.319824 20.5477 0.319824 29.2177C0.319824 37.8877 4.96982 44.1376 12.8398 44.1376C14.2798 44.2176 15.7298 43.9676 17.0698 43.4076C18.4098 42.8476 19.6098 41.9876 20.5798 40.8976V45.0676C20.5798 47.9076 19.0798 51.2776 14.3198 51.2776C10.7098 51.2776 8.92982 49.2576 8.30982 47.0876L1.92982 50.1776C3.52982 54.2776 7.34982 57.7177 14.7698 57.7177C25.7698 57.7177 28.5998 50.2976 28.5998 43.7976V14.6576H21.8698L21.6898 18.8577L21.6698 18.8677ZM14.5598 37.3376C10.6298 37.3376 8.30982 34.1376 8.30982 29.1576C8.30982 24.1776 10.6298 20.9777 14.5598 20.9777C18.4898 20.9777 20.7598 24.1776 20.7598 29.1576C20.7598 34.1376 18.4898 37.3376 14.5598 37.3376Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.9877V69.8777H0.569824V64.0376H22.8598V59.9877H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.277588H57.8696V81.6376H58.8696V0.277588Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M340.67 59.1876C340.67 59.1876 340.86 59.2876 340.96 59.2876C341.06 59.2876 341.15 59.2877 341.25 59.2377C341.39 59.1377 341.49 58.9476 341.49 58.6676C341.49 58.2376 341.25 57.9977 340.87 57.9977C340.77 57.9977 340.73 57.9976 340.68 58.0476V59.1976L340.67 59.1876ZM340.67 59.4777V59.7676C340.67 60.3876 340.72 60.4377 340.72 60.4877C340.77 60.5377 340.82 60.5376 340.96 60.5376C340.96 60.5376 340.977 60.5543 341.01 60.5876C341.01 60.5876 340.96 60.6376 340.91 60.6376H339.76C339.76 60.6376 339.71 60.6376 339.71 60.5876C339.71 60.5376 339.76 60.5376 339.81 60.5376C340.05 60.5376 340.1 60.5377 340.1 60.3477V58.0476C340.1 57.9076 340 57.8577 339.76 57.8577C339.76 57.8577 339.743 57.841 339.71 57.8076C339.71 57.8076 339.76 57.7576 339.81 57.7576H340.86C341.39 57.7576 341.58 57.8576 341.67 57.8976C341.81 57.9976 341.91 58.1376 341.91 58.4276C341.91 58.6676 341.81 58.9076 341.38 59.2876C341.76 59.7176 342 60.0576 342.24 60.2976C342.38 60.4376 342.48 60.5376 342.53 60.5376C342.58 60.5376 342.58 60.5876 342.58 60.5876C342.58 60.5876 342.547 60.6042 342.48 60.6376H342.34C342.2 60.6376 342 60.6376 341.86 60.5376C341.72 60.4376 341.57 60.2477 341.33 59.9677C341.19 59.7777 341.04 59.5376 340.95 59.3976H340.66V59.4977L340.67 59.4777ZM341.01 61.5376C342.3 61.5376 343.21 60.5277 343.21 59.2377C343.21 57.9477 342.25 56.9376 341.01 56.9376C339.77 56.9376 338.81 57.9477 338.81 59.2377C338.81 60.5277 339.82 61.5376 341.01 61.5376ZM338.38 59.2377C338.38 57.7977 339.53 56.6077 341.01 56.6077C342.49 56.6077 343.64 57.7077 343.64 59.2377C343.64 60.6777 342.49 61.8276 341.01 61.8276C339.53 61.8276 338.38 60.7277 338.38 59.2377Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M325.15 55.2676C325.15 55.8376 325.15 57.3776 325.01 58.9076C324.91 59.9576 324.63 60.6776 323.86 60.8276C323.52 60.9276 323.05 60.9677 322.52 60.9677C322.09 60.9677 319.65 61.1577 319.65 61.3477C319.65 61.6377 322.24 61.7277 322.71 61.7277C324.1 61.7277 326.64 61.5876 327.59 61.5876C328.6 61.5876 331.13 61.7277 333.48 61.7277C334.01 61.7277 334.29 61.5877 334.29 61.3477C334.29 61.1577 334.05 60.9677 333.67 60.9677C333.14 60.9677 332.33 60.9176 331.8 60.8276C330.7 60.6376 330.36 59.9676 330.27 58.9076C330.17 57.3776 330.17 55.8876 330.17 55.2676V52.3477C330.17 51.1477 330.07 50.0476 330.65 48.7076C331.32 47.1776 336.73 38.5576 337.93 37.0676C338.74 36.1076 339.08 35.7277 339.89 35.3477C340.46 35.1077 341.14 34.9176 341.52 34.9176C341.95 34.9176 342.24 34.7277 342.24 34.4877C342.24 34.2977 342 34.1976 341.57 34.1976C340.85 34.1976 338.36 34.2976 337.55 34.2976C336.45 34.2976 335.11 34.1976 333.86 34.1976C333.43 34.1976 333.24 34.2976 333.24 34.5376C333.24 34.8276 333.58 34.8777 333.91 34.9677C334.53 35.1077 334.72 35.4476 334.72 35.7776C334.72 36.2576 334.53 36.8776 334.15 37.6976C333.58 38.7976 329.03 46.6076 328.55 47.4176C327.93 46.4076 322.99 37.8876 322.32 36.7876C322.03 36.2576 321.84 35.8276 321.84 35.5376C321.84 35.2476 322.08 35.0577 322.37 34.9677C322.94 34.7777 323.23 34.7777 323.23 34.4877C323.23 34.2477 323.04 34.1476 322.66 34.1476C320.94 34.1476 319.21 34.2477 318.4 34.2477C317.15 34.2477 314.33 34.1476 313.71 34.1476C313.23 34.1476 312.99 34.2477 312.99 34.4877C312.99 34.7277 313.23 34.8677 313.56 34.8677C314.04 34.8677 314.66 35.0577 315.14 35.3477C315.86 35.7277 316.62 36.5976 317.58 37.9376C318.92 39.8576 324.05 47.8476 324.28 48.4276C324.81 49.4776 325.14 50.2476 325.14 52.2076V55.2676H325.15Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M320.98 60.8677C320.55 60.8677 320.12 60.8177 319.59 60.7277C318.92 60.5877 317.82 60.1577 316.38 56.8477C313.99 51.3377 307.71 36.4977 306.8 34.4877C306.42 33.6777 306.23 33.3376 305.7 33.3376C305.32 33.3376 305.03 33.7676 304.6 34.7776L294.78 57.6177C294.01 59.4377 293.39 60.5376 291.67 60.8276C291.33 60.8276 290.9 60.8777 290.57 60.8777C290.28 60.8777 290.14 61.0676 290.14 61.2576C290.14 61.5476 290.33 61.6376 290.81 61.6376C292.77 61.6376 294.78 61.4977 295.17 61.4977C296.37 61.4977 298.14 61.6376 299.34 61.6376C299.72 61.6376 299.91 61.5376 299.91 61.2576C299.91 61.0176 299.81 60.8777 299.34 60.8777H298.81C297.66 60.8777 297.33 60.4977 297.33 59.8677C297.33 59.4377 297.52 58.5276 297.9 57.6676L299.91 52.7876C300.01 52.5976 300.05 52.5476 300.25 52.5476H309.06C309.25 52.5476 309.35 52.5976 309.44 52.7876L312.36 60.0676C312.55 60.4976 312.26 60.8377 312.02 60.8777C311.64 60.9277 311.54 61.0676 311.54 61.2576C311.54 61.4976 311.97 61.4976 312.64 61.5476C315.8 61.6476 318.53 61.6476 319.87 61.6476C321.21 61.6476 323.75 61.5476 323.75 61.2676C323.75 61.0276 321.31 60.8876 320.97 60.8876L320.98 60.8677ZM308.19 50.5276H300.96C300.82 50.5276 300.77 50.4276 300.82 50.2876L304.46 41.0977C304.51 40.9577 304.56 40.7576 304.65 40.7576C304.74 40.7576 304.79 40.9977 304.84 41.0977L308.38 50.3376C308.43 50.4776 308.38 50.5276 308.19 50.5276Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M275.78 48.5176C275.78 52.6876 275.78 56.3277 275.54 58.2377C275.35 59.5777 275.11 60.5377 274.2 60.7277C273.77 60.8277 273.24 60.9176 272.57 60.9176C272.04 60.9176 271.85 61.0576 271.85 61.2976C271.85 61.6376 272.19 61.7277 272.76 61.7277C274.58 61.7277 277.45 61.5876 278.51 61.5876C279.71 61.5876 282.58 61.7277 285.55 61.7277C286.03 61.7277 286.41 61.5876 286.41 61.2976C286.41 61.0576 286.17 60.9176 285.69 60.9176C285.02 60.9176 284.01 60.8177 283.39 60.7277C282 60.5377 281.76 59.5276 281.62 58.2876C281.38 56.3276 281.38 52.7276 281.38 48.5176V30.2676C281.38 29.7376 281.52 29.4976 281.76 29.4076C282.19 29.2676 282.86 29.2177 283.53 29.2177C284.58 29.2177 286.45 29.5077 288.08 30.9877C290.62 33.2877 290.76 36.3076 290.76 37.8376C290.76 42.4876 287.22 45.3577 284.68 45.3577C283.72 45.3577 283.39 45.4976 283.39 45.8376C283.39 46.1776 283.73 46.2176 283.92 46.2676C284.16 46.3176 284.64 46.3176 284.88 46.3176C291.35 46.3176 296.09 41.7676 296.09 35.3076C296.09 32.9176 294.8 30.8576 293.79 29.8976C293.07 29.2276 291.01 27.3076 285.31 27.3076C283.2 27.3076 280.57 27.4476 278.7 27.4476C277.41 27.4476 274.53 27.3076 272.14 27.3076C271.47 27.3076 271.13 27.4077 271.13 27.7377C271.13 28.0677 271.42 28.1676 271.9 28.1676C272.52 28.1676 273.34 28.2176 273.67 28.3076C275.15 28.6476 275.54 29.3576 275.63 30.8976C275.73 32.3376 275.73 33.6276 275.73 40.5676V48.5176H275.78Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M253.269 51.1476C253.269 54.4976 253.269 57.3277 253.079 58.8577C252.939 59.9077 252.739 60.6276 251.979 60.7776C251.639 60.8776 251.209 60.9176 250.639 60.9176C250.159 60.9176 250.019 61.1076 250.019 61.2976C250.019 61.5376 250.259 61.6776 250.739 61.6776C251.509 61.6776 252.459 61.6276 253.329 61.5776C254.239 61.5776 255.049 61.5276 255.489 61.5276C256.589 61.5276 258.029 61.5777 259.849 61.6277C261.669 61.7277 263.969 61.7676 266.749 61.7676C268.139 61.7676 268.519 61.7676 268.759 60.8076C268.949 60.0876 269.289 57.5976 269.289 56.7876C269.289 56.4076 269.239 55.9276 268.949 55.9276C268.709 55.9276 268.609 56.1177 268.519 56.4977C268.279 57.9777 267.849 58.7476 266.889 59.1776C265.929 59.6076 264.299 59.6576 263.349 59.6576C259.519 59.6576 258.369 59.0876 258.269 56.6376C258.219 55.5876 258.269 52.5176 258.269 51.2776V48.3577C258.269 48.1177 258.319 47.9777 258.459 47.9777C259.419 47.9777 263.679 48.0776 264.349 48.1676C265.739 48.3076 266.219 48.8376 266.459 49.5576C266.559 50.0376 266.559 50.5176 266.599 50.8976C266.599 51.0876 266.699 51.1876 266.939 51.1876C267.279 51.1876 267.319 50.6577 267.319 50.3777C267.319 50.1377 267.419 48.6576 267.509 47.9376C267.699 46.1176 267.799 45.4976 267.799 45.3076C267.799 45.1176 267.659 44.9276 267.509 44.9276C267.319 44.9276 267.219 45.1176 266.889 45.4076C266.549 45.7876 265.979 45.8877 265.119 45.9777C264.259 46.0777 259.419 46.0776 258.559 46.0776C258.369 46.0776 258.319 45.8876 258.319 45.6976V36.6976C258.319 36.5076 258.419 36.3577 258.559 36.3577C259.329 36.3577 263.829 36.4576 264.449 36.5476C266.319 36.7376 266.649 37.2176 266.939 37.8876C267.179 38.3176 267.179 38.9377 267.179 39.2277C267.179 39.5177 267.229 39.7076 267.469 39.7076C267.759 39.7076 267.849 39.2776 267.899 39.1376C267.999 38.7076 268.089 37.1277 268.089 36.7477C268.189 35.0677 268.379 34.6376 268.379 34.3976C268.379 34.2076 268.329 34.0576 268.139 34.0576C267.949 34.0576 267.759 34.1977 267.519 34.2477C267.229 34.2977 266.609 34.4377 265.939 34.4877C265.219 34.5377 256.889 34.4877 255.689 34.4877C254.639 34.4877 252.239 34.3876 250.279 34.3876C249.709 34.3876 249.419 34.4877 249.419 34.7277C249.419 34.9677 249.659 35.1077 250.039 35.1077C250.609 35.1077 251.239 35.1577 251.519 35.2477C252.719 35.5877 253.049 35.9676 253.149 37.2076C253.199 38.3576 253.199 39.3677 253.199 44.8677V51.1376H253.299L253.269 51.1476Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M215.39 58.0476C215.2 59.2476 214.86 60.6776 213.86 60.8276C213.29 60.9276 213 60.9276 212.71 60.9276C212.33 60.9276 209.84 61.1176 209.84 61.2676C209.84 61.6076 212.43 61.6976 212.81 61.6976C214.01 61.6976 215.78 61.5576 216.55 61.5576C217.22 61.5576 218.94 61.6976 220.52 61.6976C221.09 61.6976 221.43 61.5976 221.43 61.2676C221.43 61.0776 221.19 60.9276 220.86 60.9276C220.53 60.9276 220.19 60.8777 219.52 60.7377C218.85 60.5977 218.37 60.3576 218.37 59.6876C218.37 59.1176 218.42 58.6377 218.51 57.9677L220.28 43.7876H220.42C221.67 46.3276 223.87 50.8776 224.2 51.5476C224.63 52.5576 227.6 58.1076 228.51 59.7876C229.08 60.8876 229.52 61.6077 229.99 61.6077C230.42 61.6077 230.61 61.2676 231.47 59.5476L239.56 43.3176H239.7L241.81 59.0276C241.95 60.0376 241.86 60.4676 241.62 60.5576C241.38 60.6476 241.19 60.7476 241.19 60.9376C241.19 61.1276 241.38 61.3177 242.29 61.3677C243.77 61.4677 249.14 61.6077 250.05 61.6077C250.62 61.6077 251.06 61.4676 251.06 61.1776C251.06 60.9376 250.82 60.8376 250.49 60.8376C250.01 60.8376 249.44 60.7877 248.33 60.4977C247.18 60.1577 246.85 59.1576 246.51 56.9076L242.97 34.5876C242.83 33.8176 242.4 33.4376 242.11 33.4376C241.77 33.4376 241.44 33.7277 241.1 34.3477L231.04 54.8477L220.98 34.5876C220.45 33.5776 220.21 33.4376 219.83 33.4376C219.54 33.4376 219.21 33.7776 219.11 34.3976L215.37 58.0576L215.39 58.0476Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M202.649 51.1476C202.649 54.6476 202.649 57.5676 202.459 59.0476C202.319 60.0976 202.119 60.6276 201.359 60.8176C201.019 60.9176 200.589 60.9576 200.019 60.9576C199.539 60.9576 199.449 61.1476 199.449 61.3376C199.449 61.5776 199.689 61.7177 200.169 61.7177C201.649 61.7177 204.239 61.5776 205.099 61.5776C206.109 61.5776 208.689 61.7177 211.179 61.7177C211.609 61.7177 214.199 61.5776 214.199 61.3376C214.199 61.1476 211.759 60.9576 211.329 60.9576C210.759 60.9576 209.939 60.9076 209.409 60.8176C208.309 60.6276 208.019 60.0977 207.929 59.0977C207.789 57.5677 207.789 54.6476 207.789 51.1476V44.7277C207.789 39.2177 207.789 38.2176 207.889 37.0676C207.989 35.7776 208.269 35.2477 209.279 35.1077C209.709 35.0077 209.999 34.9677 210.379 34.9677C210.759 34.9677 210.949 34.8676 210.949 34.5376C210.949 34.3476 210.659 34.2477 210.179 34.2477C208.739 34.2477 206.299 34.3477 205.339 34.3477C204.289 34.3477 201.699 34.2477 200.309 34.2477C199.689 34.2477 199.399 34.3476 199.399 34.5376C199.399 34.8776 199.589 34.9677 199.969 34.9677C200.449 34.9677 200.929 35.0176 201.359 35.1576C202.169 35.3976 202.559 35.8276 202.649 37.0776C202.699 38.2276 202.699 39.2377 202.699 44.7377V51.1576H202.649V51.1476Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M200.59 60.9176C200.3 60.9176 200.06 60.9176 199.68 60.8176C199.11 60.6776 197.76 60.5276 195.66 58.4276C193.41 56.1776 190.73 52.8676 187.42 48.7976C191.11 45.8276 192.64 43.4377 192.64 40.7477C192.64 38.3077 191.06 36.4876 190.01 35.7676C188 34.4276 185.27 34.2377 182.87 34.2377C181.72 34.2377 178.32 34.3376 177.03 34.3376C176.26 34.3376 173.87 34.2377 171.91 34.2377C171.34 34.2377 171.05 34.3376 171.05 34.5776C171.05 34.8176 171.29 34.9576 171.67 34.9576C172.24 34.9576 172.87 35.0077 173.15 35.0977C174.35 35.4377 174.68 35.8176 174.78 37.0576C174.83 38.2076 174.83 39.2177 174.83 44.7177V51.1376H174.88C174.88 54.4876 174.88 57.3177 174.69 58.8477C174.55 59.8977 174.35 60.6176 173.59 60.7676C173.25 60.8676 172.82 60.9076 172.25 60.9076C171.77 60.9076 171.68 61.0976 171.68 61.2876C171.68 61.5276 171.92 61.6676 172.4 61.6676C173.88 61.6676 176.28 61.5276 177 61.5276C177.57 61.5276 180.69 61.6676 182.84 61.6676C183.32 61.6676 183.61 61.5276 183.61 61.2876C183.61 61.0976 183.42 60.9076 183.13 60.9076C182.65 60.9076 181.84 60.8576 181.31 60.7676C180.16 60.5776 179.97 59.9077 179.87 58.8477C179.68 57.3177 179.68 54.4876 179.68 51.1376V50.6077C179.68 50.3677 179.82 50.3176 179.97 50.3176L183.32 50.4176C183.56 50.4176 183.8 50.4676 183.99 50.6576C184.47 51.2276 186.05 53.6276 187.53 55.5876C189.64 58.4176 191.03 60.1376 192.65 60.9476C193.61 61.4776 194.66 61.6676 196.77 61.6676H200.36C200.84 61.6676 201.08 61.5676 201.08 61.2876C201.08 61.0976 200.89 60.9076 200.6 60.9076L200.59 60.9176ZM185.41 47.8876C184.79 48.3676 184.26 48.5076 182.78 48.5076C181.82 48.5076 180.72 48.4076 179.91 48.1676C179.67 48.0276 179.57 47.9276 179.57 47.5476V36.7277H179.62C179.62 36.4377 179.72 36.2976 179.96 36.1976C180.34 36.0976 181.25 36.0576 182.16 36.0576C184.36 36.0576 187.86 37.3976 187.86 42.5276C187.86 45.4976 186.57 47.0776 185.42 47.8876H185.41Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M148.44 48.5176C148.44 52.6876 148.44 56.3277 148.2 58.2377C148.01 59.5777 147.77 60.5377 146.86 60.7277C146.43 60.8277 145.9 60.9176 145.23 60.9176C144.7 60.9176 144.51 61.0576 144.51 61.2976C144.51 61.6376 144.85 61.7277 145.42 61.7277C147.24 61.7277 150.11 61.5876 151.17 61.5876C152.37 61.5876 155.24 61.7277 158.26 61.7277C158.74 61.7277 159.12 61.5876 159.12 61.2976C159.12 61.0576 158.88 60.9176 158.4 60.9176C157.73 60.9176 156.72 60.8177 156.1 60.7277C154.71 60.5377 154.47 59.5276 154.33 58.2876C154.09 56.3276 154.09 52.7276 154.09 48.5176V30.2676C154.09 29.7376 154.23 29.4976 154.47 29.4076C154.9 29.2676 155.57 29.2177 156.24 29.2177C157.29 29.2177 159.16 29.5077 160.79 30.9877C163.33 33.2877 163.47 36.3076 163.47 37.8376C163.47 42.4876 159.93 45.3577 157.39 45.3577C156.43 45.3577 156.1 45.4976 156.1 45.8376C156.1 46.1776 156.44 46.2176 156.63 46.2676C156.87 46.3176 157.35 46.3176 157.59 46.3176C164.06 46.3176 168.8 41.7676 168.8 35.3076C168.8 32.9176 167.51 30.8576 166.5 29.8976C165.78 29.2276 163.72 27.3076 158.02 27.3076C155.91 27.3076 153.28 27.4476 151.41 27.4476C150.12 27.4476 147.24 27.3076 144.85 27.3076C144.18 27.3076 143.84 27.4077 143.84 27.7377C143.84 28.0677 144.13 28.1676 144.61 28.1676C145.23 28.1676 146 28.2176 146.38 28.3076C147.86 28.6476 148.25 29.3576 148.34 30.8976C148.44 32.3376 148.44 33.6276 148.44 40.5676V48.5176Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M122.669 20.0676V53.7377L130.619 61.6876V27.6776L122.669 20.0676Z", fill: "#FEE656" }), /* @__PURE__ */ React.createElement("path", { d: "M88.1396 20.0676V54.1177L96.1396 61.6876V28.0676L88.1396 20.0676Z", fill: "#F2B826" }), /* @__PURE__ */ React.createElement("path", { d: "M115.01 34.9576H103.76V46.3577H115.01V34.9576Z", fill: "#F2B826" }), /* @__PURE__ */ React.createElement("path", { d: "M115.01 28.0676V20.0676H88.1396L96.1396 28.0676H115.01Z", fill: "#FEE656" }), /* @__PURE__ */ React.createElement("path", { d: "M122.67 53.7377H103.76V61.6876H130.62L122.67 53.7377Z", fill: "#F2B826" }));
const SvgProliant$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 320 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.135742H57.8696V81.4957H58.8696V0.135742Z", fill: "#777675", transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.7257C19.8998 15.7857 17.0398 14.1057 12.8398 14.1057C4.97982 14.1557 0.319824 20.4057 0.319824 29.0757C0.319824 37.7457 4.96982 43.9957 12.8398 43.9957C14.2798 44.0757 15.7298 43.8257 17.0698 43.2657C18.4098 42.7057 19.6098 41.8457 20.5798 40.7557V44.9257C20.5798 47.7657 19.0798 51.1357 14.3198 51.1357C10.7098 51.1357 8.92982 49.1157 8.30982 46.9457L1.92982 50.0357C3.52982 54.1357 7.34982 57.5757 14.7698 57.5757C25.7698 57.5757 28.5998 50.1557 28.5998 43.6557V14.5157H21.8698L21.6898 18.7157L21.6698 18.7257ZM14.5598 37.1957C10.6298 37.1957 8.30982 33.9957 8.30982 29.0157C8.30982 24.0357 10.6298 20.8357 14.5598 20.8357C18.4898 20.8357 20.7598 24.0357 20.7598 29.0157C20.7598 33.9957 18.4898 37.1957 14.5598 37.1957Z", fill: "#150A45", transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.8457V69.7357H0.569824V63.8957H22.8598V59.8457H28.5798H28.5898Z", fill: "#5532FA", transform: "matrix(1, 0, 0, 1, 5.684341886080802e-14, 0)" }), /* @__PURE__ */ React.createElement("g", { transform: "matrix(0.013375001028180122, 0, 0, -0.013375001028180122, 81.45214080810553, 66.97123718261722)", fill: "#000000", stroke: "none" }, /* @__PURE__ */ React.createElement("path", { d: "M468 3934 c-3 -5 -9 -43 -12 -84 -4 -41 -9 -91 -12 -111 -5 -34 -4 -36 35 -48 57 -17 153 -108 182 -173 21 -47 24 -67 23 -173 -1 -107 -26 -269 -242 -1553 -199 -1182 -239 -1438 -230 -1463 20 -59 21 -59 531 -59 l465 0 7 77 c4 48 3 79 -3 81 -39 13 -104 67 -127 106 -47 80 -45 115 34 596 45 275 79 451 91 477 14 30 31 48 59 63 38 19 58 20 424 20 637 0 952 44 1149 161 199 117 377 323 470 543 60 139 80 244 85 436 4 148 2 190 -15 270 -67 323 -255 571 -539 711 -135 66 -260 97 -443 109 -196 14 -1925 26 -1932 14z m1851 -664 c80 -17 121 -41 183 -109 75 -81 99 -144 106 -280 8 -170 -32 -290 -134 -401 -64 -69 -131 -105 -224 -120 -90 -14 -544 -33 -713 -28 l-139 3 -29 33 c-16 18 -29 42 -29 55 0 12 29 195 64 407 l64 385 42 39 42 38 356 -5 c209 -3 380 -10 411 -17z" }), /* @__PURE__ */ React.createElement("path", { d: "M7976 3888 c-3 -29 -8 -82 -11 -118 l-6 -65 48 -19 c67 -28 145 -108 171 -177 45 -121 54 -50 -212 -1646 -135 -810 -246 -1487 -246 -1504 0 -20 10 -40 29 -60 l29 -29 437 0 c340 0 436 3 439 13 3 6 7 42 10 78 l6 66 -40 18 c-52 23 -92 69 -116 131 l-19 49 268 1605 c148 883 268 1613 268 1623 -2 32 -32 66 -70 77 -22 6 -220 10 -507 10 l-472 0 -6 -52z" }), /* @__PURE__ */ React.createElement("path", { d: "M9615 3925 c-44 -15 -82 -53 -90 -88 -12 -57 -95 -557 -95 -576 0 -13 13 -36 29 -52 l29 -29 293 0 c273 0 294 1 324 20 17 11 39 34 48 52 9 18 37 160 63 314 51 304 51 321 1 354 -33 22 -544 26 -602 5z" }), /* @__PURE__ */ React.createElement("path", { d: "M16380 3764 c-107 -8 -211 -18 -230 -24 -20 -5 -50 -25 -68 -43 -30 -31 -36 -50 -93 -303 -33 -148 -67 -279 -75 -292 -8 -13 -29 -32 -47 -42 -30 -19 -52 -20 -313 -20 -316 0 -294 6 -294 -77 0 -42 5 -50 66 -116 80 -84 143 -209 170 -334 l17 -83 104 0 c102 0 105 -1 134 -29 16 -16 29 -40 29 -52 0 -13 -40 -259 -90 -548 -114 -673 -134 -810 -134 -951 -1 -142 24 -228 96 -337 63 -94 133 -155 233 -203 117 -56 188 -71 361 -77 146 -5 413 16 470 37 27 11 36 46 79 297 37 221 42 282 25 299 -7 7 -39 6 -103 -3 -180 -28 -355 1 -411 68 -53 62 -52 66 79 852 61 360 100 568 110 583 9 14 30 34 48 44 29 18 52 20 227 20 221 0 264 11 295 69 8 17 31 124 50 238 30 183 32 210 20 238 -7 18 -19 36 -26 41 -8 5 -109 11 -225 14 -194 5 -214 7 -234 25 -43 38 -42 52 5 335 25 148 45 284 45 302 -1 37 -14 59 -47 76 -25 14 -13 14 -273 -4z" }), /* @__PURE__ */ React.createElement("path", { d: "M4974 3099 c-153 -19 -400 -165 -609 -361 -62 -57 -88 -70 -98 -45 -2 6 4 64 14 127 22 130 19 161 -18 190 -24 19 -40 20 -277 20 -231 0 -254 -2 -283 -20 -18 -10 -39 -30 -48 -43 -10 -16 -91 -474 -230 -1308 -118 -706 -215 -1294 -215 -1307 0 -13 13 -37 29 -53 l29 -29 272 0 c302 0 322 4 359 64 13 22 43 175 105 548 109 651 180 946 262 1085 94 161 276 296 462 344 56 14 110 19 209 19 l133 0 11 28 c15 37 79 580 79 665 0 45 -4 69 -12 71 -31 10 -118 12 -174 5z" }), /* @__PURE__ */ React.createElement("path", { d: "M11465 3098 c-275 -23 -590 -182 -918 -466 -102 -87 -230 -228 -224 -246 2 -5 14 -18 28 -28 33 -24 524 -178 569 -178 33 0 42 7 88 64 117 143 288 255 437 286 105 22 250 -1 355 -55 18 -9 55 -37 81 -62 63 -58 89 -126 89 -227 0 -70 -2 -76 -30 -100 -40 -33 -53 -34 -330 -40 -718 -13 -1174 -192 -1410 -552 -95 -145 -135 -307 -128 -509 5 -111 10 -144 37 -225 109 -324 387 -531 748 -556 283 -19 548 78 760 278 40 37 76 68 80 68 26 0 33 -29 33 -130 0 -76 4 -112 14 -126 14 -18 29 -19 339 -19 239 0 328 3 339 12 12 10 13 26 5 95 -17 145 11 365 132 1033 67 372 107 629 116 755 12 156 -28 343 -102 470 -79 135 -235 271 -397 345 -189 88 -475 133 -711 113z m370 -1523 c14 -13 25 -31 25 -40 0 -26 -68 -201 -121 -314 -60 -127 -120 -212 -193 -275 -129 -110 -243 -156 -385 -156 -120 0 -177 19 -244 80 -82 75 -109 161 -87 280 15 85 49 148 110 208 111 109 256 153 765 230 94 15 104 14 130 -13z" }), /* @__PURE__ */ React.createElement("path", { d: "M14400 3099 c-216 -19 -392 -107 -546 -275 -48 -52 -90 -94 -95 -94 -15 0 -16 29 -3 100 20 115 18 137 -15 171 l-29 29 -259 0 c-234 0 -261 -2 -286 -19 -15 -10 -35 -28 -43 -40 -16 -22 -444 -2541 -444 -2609 0 -24 9 -42 29 -63 l29 -29 274 0 c253 0 275 2 305 20 18 10 40 31 49 45 11 18 47 205 110 578 51 304 105 604 119 667 37 160 137 457 189 565 108 222 291 357 481 357 99 0 153 -20 200 -74 49 -58 65 -114 65 -229 0 -124 -12 -206 -165 -1101 -74 -433 -123 -748 -119 -763 3 -14 18 -34 31 -45 24 -19 42 -20 297 -20 246 0 275 2 306 19 19 10 43 31 52 47 11 19 63 303 152 839 168 1011 161 960 160 1145 -1 138 -3 164 -27 243 -48 157 -119 267 -234 362 -159 132 -363 193 -583 174z" }), /* @__PURE__ */ React.createElement("path", { d: "M6275 3089 c-440 -68 -781 -334 -1005 -784 -78 -156 -120 -280 -150 -434 -115 -592 37 -1151 383 -1414 345 -263 899 -322 1292 -138 176 83 331 211 461 383 190 253 310 531 360 834 25 149 24 440 0 579 -62 346 -221 619 -461 791 -89 63 -236 130 -350 160 -87 23 -124 27 -285 30 -102 1 -212 -1 -245 -7z m286 -603 c87 -19 136 -44 191 -100 53 -54 91 -128 120 -234 18 -66 22 -105 22 -272 1 -209 -7 -273 -54 -455 -111 -422 -279 -605 -557 -606 -227 -1 -388 124 -449 346 -22 81 -29 288 -15 416 25 218 101 483 184 643 113 217 317 313 558 262z" }), /* @__PURE__ */ React.createElement("path", { d: "M9409 2992 c-21 -21 -40 -49 -43 -63 -16 -70 -426 -2544 -426 -2570 0 -20 10 -40 29 -60 l29 -29 290 0 c284 0 290 0 323 23 19 12 41 38 50 57 10 20 108 583 230 1315 192 1151 212 1283 201 1311 -8 17 -25 36 -38 43 -17 7 -121 11 -316 11 l-290 0 -39 -38z" }), /* @__PURE__ */ React.createElement("path", { d: "M17353 856 c-82 -27 -165 -107 -192 -185 -16 -48 -14 -161 4 -211 22 -61 74 -121 136 -155 49 -27 63 -30 144 -30 82 0 95 3 145 31 61 34 121 105 139 164 19 66 14 169 -13 225 -29 61 -84 117 -144 146 -55 27 -160 34 -219 15z m163 -51 c58 -17 127 -80 155 -140 38 -81 16 -199 -49 -269 -15 -16 -49 -39 -77 -52 -160 -76 -344 45 -345 227 0 104 73 203 173 235 56 17 84 17 143 -1z" }), /* @__PURE__ */ React.createElement("path", { d: "M17310 565 l0 -165 45 0 45 0 0 60 c0 59 0 60 28 60 44 0 63 -21 69 -73 l6 -47 41 0 42 0 -6 56 c-5 44 -12 62 -32 79 l-25 21 29 17 c23 13 28 23 28 56 0 85 -27 101 -170 101 l-100 0 0 -165z m178 93 c32 -27 -3 -78 -55 -78 -32 0 -33 1 -33 43 0 24 3 47 7 51 9 8 63 -3 81 -16z" })));
const SvgRubyMoney$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 441, height: 83, viewBox: "0 0 441 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.6698 19.4015C19.8998 16.4615 17.0398 14.7815 12.8398 14.7815C4.97982 14.8315 0.319824 21.0816 0.319824 29.7516C0.319824 38.4216 4.96982 44.6715 12.8398 44.6715C14.2798 44.7515 15.7298 44.5015 17.0698 43.9415C18.4098 43.3815 19.6098 42.5215 20.5798 41.4315V45.6016C20.5798 48.4416 19.0798 51.8115 14.3198 51.8115C10.7098 51.8115 8.92982 49.7916 8.30982 47.6216L1.92982 50.7115C3.52982 54.8115 7.34982 58.2516 14.7698 58.2516C25.7698 58.2516 28.5998 50.8315 28.5998 44.3315V15.1915H21.8698L21.6898 19.3915L21.6698 19.4015ZM14.5598 37.8716C10.6298 37.8716 8.30982 34.6715 8.30982 29.6915C8.30982 24.7115 10.6298 21.5116 14.5598 21.5116C18.4898 21.5116 20.7598 24.7115 20.7598 29.6915C20.7598 34.6715 18.4898 37.8716 14.5598 37.8716Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 60.5215V70.4115H0.569824V64.5715H22.8598V60.5215H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.811523H57.8696V82.1715H58.8696V0.811523Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M197.28 46.9816C196.83 45.7616 196.21 44.8516 195.43 44.2516C194.92 43.8516 194.35 43.5915 193.74 43.4615C194.95 43.0715 195.98 42.4916 196.85 41.7216C198.59 40.1416 199.45 38.0716 199.45 35.4816C199.45 32.7616 198.61 30.6715 196.92 29.2015C195.24 27.7115 192.75 26.9615 189.46 26.9615H176.95V55.9816H183.03V44.2815H187.01C187.83 44.2815 188.55 44.4316 189.18 44.7316C189.81 45.0016 190.27 45.5315 190.56 46.3215L194.15 55.9816H200.66L197.27 46.9716L197.28 46.9816ZM188.56 39.4415H183V31.8616H188.56C190.35 31.8616 191.64 32.1715 192.43 32.8015C193.25 33.4015 193.65 34.3515 193.65 35.6515C193.65 36.9515 193.24 37.8816 192.43 38.5016C191.61 39.1316 190.33 39.4415 188.56 39.4415Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M221.63 26.9716V44.2915C221.63 46.6015 221.12 48.3716 220.09 49.5916C219.06 50.8116 217.59 51.4215 215.67 51.4215C213.75 51.4215 212.16 50.8116 211.13 49.5916C210.1 48.3716 209.59 46.6015 209.59 44.2915V26.9716H203.59V44.0116C203.59 48.0616 204.6 51.1316 206.63 53.2216C208.68 55.3116 211.69 56.3616 215.66 56.3616C219.63 56.3616 222.54 55.3116 224.62 53.2216C226.7 51.1016 227.74 48.0316 227.74 44.0116V26.9716H221.62H221.63Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M253.63 43.3616C252.75 42.2316 251.5 41.4416 249.92 40.9816C251.24 40.5016 252.3 39.7515 253.08 38.7115C253.95 37.5115 254.38 36.1116 254.38 34.5116C254.38 32.1716 253.53 30.3416 251.82 29.0116C250.11 27.6516 247.81 26.9716 244.92 26.9716H231.98V55.9916H245.32C248.37 55.9916 250.76 55.2816 252.5 53.8716C254.26 52.4316 255.14 50.4915 255.14 48.0415C255.14 46.1715 254.64 44.6016 253.64 43.3516L253.63 43.3616ZM238.01 31.8716H243.89C245.47 31.8716 246.64 32.1616 247.4 32.7316C248.16 33.2716 248.54 34.1416 248.54 35.3416C248.54 36.5416 248.16 37.3815 247.4 37.9515C246.66 38.5215 245.49 38.8115 243.89 38.8115H238.01V31.8816V31.8716ZM248.19 50.2516C247.45 50.8216 246.26 51.1116 244.6 51.1116H238.01V43.6915H244.6C246.26 43.6915 247.45 44.0016 248.19 44.6316C248.95 45.2316 249.33 46.1715 249.33 47.4415C249.33 48.7115 248.95 49.6816 248.19 50.2516Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M284.42 26.9716H277.4L269.67 39.3716L262.01 26.9716H255.03L266.59 44.6316V55.9916H272.79V44.7516L284.42 26.9716Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M319.69 26.9716L310.67 48.3315L301.62 26.9716H296.73V55.9916H302.13V40.3516L308.64 55.9916H312.63L319.07 40.2115L319.1 55.9916H324.54V26.9716H319.69Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M354.32 33.5715C353.22 31.3415 351.64 29.6315 349.59 28.4315C347.56 27.2115 345.14 26.6016 342.33 26.6016C339.52 26.6016 337.08 27.2115 335.03 28.4315C332.98 29.6315 331.39 31.3415 330.26 33.5715C329.16 35.8015 328.6 38.4215 328.6 41.4415C328.6 44.4615 329.15 47.1216 330.26 49.3516C331.39 51.5816 332.98 53.3015 335.03 54.5315C337.08 55.7515 339.52 56.3616 342.33 56.3616C345.14 56.3616 347.56 55.7515 349.59 54.5315C351.64 53.3115 353.22 51.5816 354.32 49.3516C355.42 47.1216 355.98 44.4915 355.98 41.4415C355.98 38.3915 355.43 35.8015 354.32 33.5715ZM347.81 48.8915C346.47 50.5715 344.64 51.4215 342.32 51.4215C340 51.4215 338.14 50.5815 336.8 48.8915C335.46 47.2115 334.79 44.7215 334.79 41.4315C334.79 38.1415 335.46 35.7115 336.8 34.0515C338.14 32.3715 339.98 31.5215 342.32 31.5215C344.66 31.5215 346.46 32.3615 347.81 34.0515C349.18 35.7115 349.86 38.1715 349.86 41.4315C349.86 44.6915 349.18 47.1815 347.81 48.8915Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M378.54 26.9716V45.4415L364.53 26.9716H359.99V55.9916H365.75V37.5116L379.76 55.9916H384.34V26.9716H378.54Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M408.55 31.9015V26.9716H389.18V55.9916H408.55V51.0615H395.22V43.7216H407.72V38.7516H395.22V31.9015H408.55Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M440.89 26.9716H433.87L426.14 39.3716L418.48 26.9716H411.5L423.06 44.6316V55.9916H429.25V44.7516L440.89 26.9716Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M136.63 17.5116C135.31 15.2216 132.95 13.8616 130.32 13.8616H100.45C97.8198 13.8616 95.4598 15.2216 94.1398 17.5116C92.7998 19.8216 92.7998 22.5815 94.1198 24.8915L109.06 50.9415C110.38 53.2415 112.75 54.6216 115.39 54.6216C118.03 54.6216 120.4 53.2415 121.72 50.9415L136.66 24.8915C137.99 22.5815 137.98 19.8216 136.64 17.5116H136.63ZM133.48 23.0615L118.54 49.1116C117.88 50.2616 116.7 50.9515 115.38 50.9515C114.06 50.9515 112.88 50.2616 112.22 49.1116L97.2798 23.0615C96.6098 21.9015 96.6198 20.5116 97.2798 19.3516C97.9398 18.2116 99.1198 17.5215 100.43 17.5215H130.3C131.61 17.5215 132.79 18.2016 133.45 19.3516C134.12 20.5116 134.12 21.8915 133.45 23.0515L133.48 23.0615Z", fill: "#7EC4CF" }), /* @__PURE__ */ React.createElement("path", { d: "M141.61 23.3015C140.29 21.0115 137.93 19.6515 135.3 19.6515H95.4699C92.8399 19.6515 90.4799 21.0115 89.1599 23.3015C87.8199 25.6115 87.8199 28.3715 89.1399 30.6815L109.06 65.4215C110.38 67.7215 112.75 69.1016 115.39 69.1016C118.03 69.1016 120.4 67.7215 121.72 65.4215L141.64 30.6815C142.97 28.3715 142.96 25.6115 141.62 23.3015H141.61ZM138.46 28.8516L118.54 63.5916C117.88 64.7416 116.7 65.4315 115.38 65.4315C114.06 65.4315 112.88 64.7416 112.22 63.5916L92.2999 28.8516C91.6299 27.6916 91.6399 26.3015 92.2999 25.1415C92.9599 24.0015 94.1399 23.3115 95.4499 23.3115H135.28C136.59 23.3115 137.77 23.9915 138.43 25.1415C139.1 26.3015 139.1 27.6816 138.43 28.8516H138.46Z", fill: "#FF3E3E" }));
const SvgSvb$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 209, height: 82, viewBox: "0 0 209 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.0678711H57.8696V81.4279H58.8696V0.0678711Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M103.52 37.5779C99.7197 36.9479 96.4797 36.4178 96.4797 33.8178C96.4797 31.6778 98.4396 30.4078 101.71 30.4078C105.16 30.4078 107.11 32.1378 107.11 35.2078H114.39C114.39 29.1978 109.64 25.6678 101.68 25.6678C93.7196 25.6678 88.8896 28.9678 88.8896 34.4478C88.8896 41.0978 95.0697 42.0778 100.23 42.8878C104.15 43.5178 107.65 44.0978 107.65 47.1678C107.65 49.5978 105.45 50.9578 101.65 50.9578C97.8497 50.9578 95.4196 49.0578 95.4196 45.8078H88.1396C88.1396 52.1378 93.1396 55.8378 101.68 55.8378C110.22 55.8378 115.22 52.2579 115.22 46.2979C115.22 39.4779 108.81 38.4378 103.55 37.5678", fill: "#003149" }), /* @__PURE__ */ React.createElement("path", { d: "M130.52 52.4979H130.43L123.62 26.2579H115.22L123.9 55.2679H137.05L145.73 26.2579H137.32L130.51 52.4979H130.52Z", fill: "#003149" }), /* @__PURE__ */ React.createElement("path", { d: "M163.079 49.8779C159.539 49.8779 157.079 47.8679 156.059 44.5879C155.699 43.3779 155.519 42.1279 155.539 40.8679C155.539 39.6379 155.709 38.4179 156.059 37.2379C156.999 34.1779 159.249 31.7879 163.079 31.7879C168.789 31.7879 170.619 36.2779 170.619 40.8679C170.619 46.1979 168.109 49.8779 163.079 49.8779ZM165.569 25.7479C163.549 25.6779 161.549 26.2279 159.859 27.3079C158.169 28.3879 156.859 29.9579 156.119 31.7879H156.029V10.7579H148.189V55.2679H153.179L156.079 50.1779H156.169C157.029 51.9079 158.369 53.3579 160.049 54.3779C161.719 55.3979 163.649 55.9279 165.629 55.9279C173.579 56.0379 178.689 49.7279 178.689 40.8479C178.689 31.9679 173.949 25.7579 165.629 25.7579", fill: "#003149" }), /* @__PURE__ */ React.createElement("path", { d: "M188.41 16.7479L182.229 20.4779L193.939 40.7479L182.229 61.0179L188.41 64.7479L208.32 40.7379L188.41 16.7279V16.7479Z", fill: "#00C0FF" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.6478C19.8998 15.7078 17.0398 14.0278 12.8398 14.0278C4.97982 14.0778 0.319824 20.3278 0.319824 28.9978C0.319824 37.6678 4.96982 43.9178 12.8398 43.9178C14.2798 43.9978 15.7298 43.7478 17.0698 43.1878C18.4098 42.6278 19.6098 41.7678 20.5798 40.6778V44.8478C20.5798 47.6878 19.0798 51.0578 14.3198 51.0578C10.7098 51.0578 8.92982 49.0378 8.30982 46.8678L1.92982 49.9578C3.52982 54.0578 7.34982 57.4978 14.7698 57.4978C25.7698 57.4978 28.5998 50.0779 28.5998 43.5779V14.4378H21.8698L21.6898 18.6378L21.6698 18.6478ZM14.5598 37.1178C10.6298 37.1178 8.30982 33.9178 8.30982 28.9378C8.30982 23.9578 10.6298 20.7578 14.5598 20.7578C18.4898 20.7578 20.7598 23.9578 20.7598 28.9378C20.7598 33.9178 18.4898 37.1178 14.5598 37.1178Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.7778V69.6678H0.569824V63.8279H22.8598V59.7778H28.5798H28.5898Z", fill: "#5532FA" }));
const SvgStartupGrind$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 426, height: 82, viewBox: "0 0 426 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.209961H57.8696V81.57H58.8696V0.209961Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.7999C19.8998 15.8599 17.0398 14.1799 12.8398 14.1799C4.97982 14.2299 0.319824 20.4799 0.319824 29.1499C0.319824 37.8199 4.96982 44.0699 12.8398 44.0699C14.2798 44.1499 15.7298 43.8999 17.0698 43.3399C18.4098 42.7799 19.6098 41.9199 20.5798 40.8299V44.9999C20.5798 47.8399 19.0798 51.2099 14.3198 51.2099C10.7098 51.2099 8.92982 49.1899 8.30982 47.0199L1.92982 50.1099C3.52982 54.2099 7.34982 57.6499 14.7698 57.6499C25.7698 57.6499 28.5998 50.2299 28.5998 43.7299V14.5899H21.8698L21.6898 18.7899L21.6698 18.7999ZM14.5598 37.2699C10.6298 37.2699 8.30982 34.0699 8.30982 29.0899C8.30982 24.1099 10.6298 20.9099 14.5598 20.9099C18.4898 20.9099 20.7598 24.1099 20.7598 29.0899C20.7598 34.0699 18.4898 37.2699 14.5598 37.2699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.9199V69.8099H0.569824V63.9699H22.8598V59.9199H28.5798H28.5898Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M289.339 39.01V39.02L289.329 39.03L289.339 39.01Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M284.28 44.1601C284.22 44.1401 284.16 44.1101 284.1 44.0801L284.2 43.9601C284.2 43.9601 284.28 44.0401 284.32 44.0801C284.32 44.0901 284.28 44.1601 284.28 44.1601ZM284.45 39.9301L284.4 39.8101C284.4 39.8101 284.47 39.8101 284.5 39.8101C284.52 39.8101 284.52 39.8601 284.53 39.8801L284.45 39.9301ZM288.48 50.6901C288.48 50.6901 288.42 50.6301 288.4 50.6001C288.43 50.5801 288.46 50.5501 288.49 50.5501C288.55 50.5501 288.61 50.5701 288.67 50.5801C288.61 50.6201 288.55 50.6501 288.49 50.6801L288.48 50.6901ZM288.58 39.0901C288.62 39.1701 288.64 39.2701 288.65 39.3601C288.63 39.4501 288.6 39.5401 288.55 39.6301C288.47 39.5301 288.79 38.9901 288.78 38.8901C288.78 38.8201 288.49 39.1801 288.58 39.1001V39.0901ZM287.08 38.3601L286.95 38.5501L286.85 38.4501L287.08 38.3601ZM289.35 51.1901C289.35 51.1901 289.27 51.0801 289.28 51.0501C289.3 51.0001 289.37 50.9701 289.42 50.9301L289.5 51.0901L289.34 51.1901H289.35ZM288.21 43.9501H288.12C288.12 43.9501 288.18 43.8601 288.21 43.8301C288.21 43.8301 288.26 43.8601 288.29 43.8801L288.22 43.9501H288.21ZM288.88 46.4301C288.88 46.4301 288.97 46.3401 289.02 46.3001C289.07 46.3801 289.12 46.4701 289.16 46.5601C289.18 46.6201 289.19 46.6801 289.2 46.7401C289.14 46.7401 289.08 46.7101 289.02 46.6801C288.95 46.6101 288.9 46.5301 288.88 46.4301ZM289.25 47.0001L289.28 47.1601C289.28 47.1601 289.22 47.0901 289.2 47.0601C289.2 47.0601 289.22 47.0301 289.25 47.0001ZM289.35 47.5901C289.35 47.4601 289.35 47.3301 289.35 47.2001C289.54 47.3301 289.52 47.4601 289.35 47.5901ZM290.38 45.8401C289.65 45.5401 289.65 45.5301 290.22 45.0001C290.27 45.2801 290.33 45.5601 290.38 45.8401ZM292.23 49.3601L292.41 49.5101L292.3 49.6001C292.27 49.5201 292.25 49.4401 292.22 49.3601H292.23ZM292.52 50.3001C292.52 50.3001 292.45 50.2601 292.45 50.2401C292.45 50.1801 292.47 50.1301 292.49 50.0701L292.57 50.1301C292.55 50.1901 292.54 50.2401 292.52 50.3001ZM295.64 49.2901C295.64 49.2901 295.58 49.2901 295.54 49.2901C295.54 49.2601 295.54 49.2201 295.56 49.2201C295.59 49.2201 295.62 49.2201 295.66 49.2201C295.66 49.2501 295.66 49.2901 295.64 49.2901ZM298.51 53.7101L298.46 53.6101C298.46 53.6101 298.52 53.6101 298.55 53.6101C298.57 53.6101 298.57 53.6501 298.58 53.6701L298.51 53.7201V53.7101ZM299.34 52.6501C299.34 52.6501 299.29 52.6201 299.27 52.6001C299.32 52.5701 299.37 52.5401 299.43 52.5101C299.45 52.5101 299.48 52.5401 299.5 52.5601C299.45 52.5901 299.4 52.6201 299.34 52.6501ZM299.74 49.2101C299.68 49.1701 299.62 49.1201 299.57 49.0701C299.66 48.9201 299.76 48.7801 299.86 48.6401C299.9 48.6901 299.99 48.7601 299.98 48.7801C299.91 48.9301 299.83 49.0701 299.74 49.2201V49.2101ZM299.08 48.0701C298.68 47.9901 298.17 47.9701 298.51 48.6801C298.54 48.7401 298.37 48.9001 298.29 49.0101C298.22 48.9101 298.07 48.8001 298.09 48.7301C298.23 48.2001 297.81 48.2301 297.51 48.1301C297.24 47.9901 296.91 48.0801 296.74 48.3401C296.29 48.9301 296.27 48.9101 295.59 48.4901C294.97 48.1101 294.78 48.1401 294.36 48.7001C294.17 48.9201 294 49.1601 293.84 49.4101C293.68 49.7101 293.71 50.1501 293.23 50.2001C293.34 49.9101 293.43 49.6001 293.56 49.3201C293.72 48.7501 294.11 48.2701 294.64 48.0101C294.71 47.9901 294.72 47.8201 294.76 47.7201C294.64 47.7001 294.5 47.6201 294.42 47.6701C294.06 47.8501 293.94 47.7801 294.01 47.3701C294.02 47.3001 293.93 47.2001 293.88 47.1201C293.82 47.2001 293.72 47.2801 293.69 47.3701C293.67 47.5501 293.64 47.7301 293.6 47.9001C293.55 48.0101 293.39 48.0701 293.27 48.1501C293.27 48.0301 293.22 47.8801 293.27 47.7801C293.52 47.2901 293.32 47.0201 292.88 46.8201C292.43 46.6101 292.18 46.7001 292.05 47.1601C292 47.3301 292.05 47.5301 292 47.7001C291.9 48.0101 291.61 48.0201 291.31 47.7501C291.26 47.7001 291.18 47.6401 291.13 47.6501C290.51 47.7201 290.76 47.5001 291.05 47.3701C291.48 47.1701 291.48 47.1201 291 47.0601C290.64 47.0101 290.69 46.8401 290.94 46.6501C291.01 46.6001 291.01 46.4701 291.04 46.3801C290.94 46.3601 290.81 46.3001 290.73 46.3301C289.97 46.6701 290.39 46.1201 290.38 45.8901C291.24 45.6201 290.72 44.8101 290.97 44.3101C290.88 44.2401 290.78 44.1701 290.67 44.1101C290.43 43.9701 290.18 43.8301 289.94 43.6901H289.96C289.65 43.6201 289.39 44.1601 289 43.7001C288.53 43.1401 288.92 43.6101 289.45 42.7401L289.15 42.6901L289.41 42.5301C289.36 42.4701 289.32 42.4101 289.28 42.3501C288.79 41.4301 288.34 41.4401 289.27 40.8801C289.42 40.7801 289.56 40.6801 289.69 40.5701C289.44 39.9601 289.73 39.8701 288.9 39.9001C288.93 39.6701 288.51 39.9001 288.54 39.6701L289.32 39.0601L284.77 34.6201C284.54 35.2301 284.44 35.8801 284.45 36.5301C284.45 36.6301 284.29 36.7601 284.19 36.8601C283.66 37.3901 283.66 37.4401 284.16 37.9801C284.27 38.0801 284.35 38.2201 284.39 38.3601C284.42 38.6801 284.43 39.0001 284.41 39.3201C284.4 39.6801 284.11 38.4001 283.92 38.6301C283.29 39.4001 283.22 40.5101 282.35 41.1301C282.01 41.3701 282.16 41.6601 282.48 41.8101C282.65 41.8601 282.82 41.8901 283 41.8901C282.98 42.0201 282.94 42.1601 282.9 42.2801C282.83 42.4501 282.73 42.6201 282.65 42.7801C282.87 42.8101 283.1 42.8201 283.33 42.8101C283.47 42.7901 283.58 42.6401 283.7 42.5401C283.73 42.7101 283.74 42.8801 283.7 43.0501C283.56 43.4201 283.37 43.7601 283.2 44.1101C283.12 44.2701 283.03 44.4101 282.94 44.5701C283.12 44.6501 283.31 44.7301 283.49 44.8101C283.53 44.8101 283.56 44.8101 283.6 44.8101C284.11 44.6001 284.07 45.1401 284.28 45.3401C284.31 45.3701 284.09 45.6501 284 45.8201C283.84 46.1001 283.7 46.3901 283.6 46.6901C283.57 46.8001 283.77 46.9901 283.9 47.0901C283.96 47.1401 284.15 47.0901 284.24 47.0101C284.39 46.8801 284.52 46.7401 284.65 46.5801C284.7 46.8001 284.72 47.0301 284.72 47.2501C284.7 47.4701 284.62 47.6901 284.49 47.8601C284.22 48.1801 284.4 48.2801 284.66 48.4101C285.24 48.7101 285.8 49.0501 286.38 49.3501C286.65 49.4901 286.67 49.5801 286.58 49.9101C286.46 50.3901 287.29 51.1501 287.8 51.3801C288.75 51.8101 289.92 52.0401 290.09 53.3901C290.11 53.5201 290.26 53.6201 290.35 53.7401C290.56 54.0301 290.78 54.2101 290.97 53.7401C291.19 53.2101 291.62 53.3601 292 53.3801C292.06 53.3801 292.18 53.6001 292.15 53.6801C292.07 53.9601 292.19 54.1401 292.5 54.1601C292.76 54.1401 293.01 54.1601 293.26 54.2201C293.71 54.4001 293.94 54.3201 294.04 53.8301C294.05 53.7601 294.18 53.7201 294.26 53.6601C294.26 53.7601 294.29 53.8701 294.32 53.9601C294.38 54.0701 294.49 54.2401 294.55 54.2301C295.01 54.1301 295.2 54.5101 295.48 54.7301C296.03 55.1701 296.34 55.1001 296.74 54.5301C296.94 54.2801 297.18 54.0601 297.45 53.8801C297.71 53.6801 297.93 53.7501 298.03 54.0801C298.06 54.2301 298.11 54.3701 298.17 54.5001C298.28 54.6401 298.4 54.7601 298.53 54.8801C298.64 54.7601 298.74 54.6201 298.84 54.4901C299.09 54.0701 299.15 53.4501 299.9 53.6401C299.97 53.6601 300.11 53.4201 300.21 53.3001C300.27 53.2201 300.32 53.1401 300.37 53.0501C300.4 53.1401 300.42 53.2401 300.43 53.3301C300.43 53.6101 300.5 53.7301 300.82 53.6401C301.3 53.5001 301.79 53.2301 302.3 53.5301C302.7 53.7601 302.84 53.6001 302.87 53.2101", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.729 40.52L289.709 40.53L289.719 40.54L289.729 40.52Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M90.6593 47.16C90.7893 46.95 90.9993 46.8001 91.2493 46.7601C91.4893 46.7201 91.7493 46.7801 91.9393 46.9301C94.6293 48.9401 97.8693 50.1001 101.229 50.2601C104.539 50.2601 106.099 49.1201 106.099 47.3101C106.099 45.2701 103.569 44.5501 100.269 43.8801C95.2793 42.9201 88.8493 41.7201 88.8493 34.8001C88.8493 29.9301 93.1193 25.66 100.749 25.66C104.729 25.61 108.609 26.83 111.839 29.15C112.199 29.42 112.299 29.9201 112.069 30.3001L109.959 33.9C109.829 34.12 109.599 34.2801 109.339 34.3201C109.079 34.3601 108.819 34.2901 108.619 34.1201C106.379 32.4001 103.629 31.4701 100.809 31.4801C98.0393 31.4801 96.2393 32.5001 96.2393 34.1901C96.2393 35.9901 98.5193 36.6501 101.769 37.3201C106.759 38.2801 113.429 39.6001 113.429 46.8201C113.429 52.1101 108.919 56.14 100.869 56.14C96.3993 56.23 92.0293 54.8201 88.4593 52.1301C88.1293 51.8501 88.0493 51.3601 88.2893 50.9901L90.6593 47.15V47.16Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M120.279 48.22V33.96C120.279 33.47 119.88 33.08 119.4 33.08H116.359C116.129 33.08 115.9 32.99 115.74 32.82C115.57 32.65 115.479 32.43 115.479 32.2V27.29C115.479 27.06 115.57 26.83 115.74 26.67C115.91 26.5 116.129 26.41 116.359 26.41H119.4C119.89 26.41 120.279 26.01 120.279 25.53V19.36C120.279 18.87 120.679 18.48 121.159 18.48H127.09C127.58 18.48 127.969 18.88 127.969 19.36V25.53C127.969 26.02 128.369 26.41 128.849 26.41H132.969C133.459 26.41 133.849 26.81 133.849 27.29V32.2C133.849 32.69 133.449 33.08 132.969 33.08H128.849C128.359 33.08 127.969 33.48 127.969 33.96V46.18C127.969 47.98 128.929 49.37 130.609 49.37C131.219 49.37 131.83 49.25 132.4 49.04C132.63 48.95 132.889 48.96 133.109 49.07C133.329 49.18 133.499 49.38 133.559 49.62L134.71 53.73C134.81 54.1 134.669 54.49 134.359 54.7C132.599 55.77 130.559 56.27 128.499 56.16C123.149 56.16 120.27 53.39 120.27 48.23L120.279 48.22Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M156.229 54.46C156.229 54.12 156.029 53.81 155.729 53.67C155.419 53.52 155.059 53.56 154.799 53.78C152.529 55.38 149.809 56.22 147.039 56.16C142.409 56.16 136.939 53.03 136.939 46.54C136.939 40.05 142.409 37.28 147.039 37.28C149.789 37.18 152.509 37.95 154.799 39.48C155.069 39.69 155.429 39.73 155.729 39.58C156.029 39.43 156.229 39.13 156.229 38.79V36.8C156.229 33.85 153.699 31.93 149.859 31.93C147.049 31.93 144.319 32.9 142.159 34.69C141.959 34.85 141.699 34.91 141.449 34.85C141.199 34.79 140.989 34.64 140.859 34.42L138.869 30.89C138.659 30.52 138.739 30.05 139.069 29.77C142.519 27.06 146.799 25.62 151.189 25.68C157.799 25.68 163.869 28.32 163.869 36.68V54.55C163.869 55.04 163.469 55.43 162.989 55.43H157.119C156.629 55.43 156.239 55.03 156.239 54.55V54.47L156.229 54.46ZM156.229 45.17C156.229 44.96 156.159 44.76 156.029 44.6C154.459 43.04 152.309 42.21 150.099 42.33C147.099 42.33 144.629 43.89 144.629 46.72C144.629 49.55 147.089 50.99 150.099 50.99C152.309 51.1 154.459 50.28 156.029 48.72C156.159 48.56 156.229 48.36 156.229 48.15V45.19V45.17Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M172.009 26.4001H177.879C178.369 26.4001 178.759 26.8001 178.759 27.2801V28.1701C178.759 28.5201 178.969 28.8401 179.289 28.9801C179.609 29.1201 179.979 29.0602 180.239 28.8202C182.139 27.1402 184.509 26.0901 187.029 25.7801C187.279 25.7501 187.529 25.8301 187.719 26.0001C187.909 26.1701 188.019 26.4101 188.019 26.6601V32.1301C188.019 32.3801 187.909 32.6201 187.719 32.7901C187.529 32.9601 187.279 33.0401 187.029 33.0001C186.659 32.9501 186.289 32.9301 185.919 32.9301C183.499 32.9301 180.319 34.2501 178.939 36.0001C178.819 36.1601 178.759 36.3501 178.759 36.5401V54.5301C178.759 55.0201 178.359 55.4101 177.879 55.4101H172.009C171.519 55.4101 171.129 55.0101 171.129 54.5301V27.2701C171.129 27.0401 171.219 26.8101 171.389 26.6501C171.559 26.4901 171.779 26.3901 172.009 26.3901V26.4001Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M193.969 48.22V33.96C193.969 33.73 193.88 33.5 193.71 33.34C193.54 33.17 193.32 33.08 193.09 33.08H191.109C190.619 33.08 190.229 32.68 190.229 32.2V27.29C190.229 26.8 190.629 26.41 191.109 26.41H193.09C193.32 26.41 193.55 26.32 193.71 26.15C193.88 25.98 193.969 25.76 193.969 25.53V19.36C193.969 18.87 194.369 18.48 194.849 18.48H200.779C201.269 18.48 201.659 18.88 201.659 19.36V25.53C201.659 25.76 201.749 25.99 201.919 26.15C202.089 26.32 202.309 26.41 202.539 26.41H206.659C207.149 26.41 207.539 26.81 207.539 27.29V32.2C207.539 32.69 207.139 33.08 206.659 33.08H202.539C202.049 33.08 201.659 33.48 201.659 33.96V46.18C201.659 47.98 202.619 49.37 204.299 49.37C204.909 49.37 205.52 49.25 206.09 49.04C206.32 48.95 206.58 48.96 206.799 49.07C207.019 49.18 207.189 49.38 207.249 49.62L208.4 53.73C208.5 54.1 208.359 54.49 208.049 54.7C206.289 55.77 204.249 56.27 202.189 56.16C196.839 56.16 193.96 53.4 193.96 48.23L193.969 48.22Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M232.079 53.8201C232.079 53.4801 231.879 53.17 231.569 53.02C231.259 52.87 230.889 52.92 230.629 53.15C228.139 55.13 225.049 56.19 221.869 56.16C215.499 56.16 212.489 52.67 212.489 47.02V27.29C212.489 27.06 212.579 26.83 212.749 26.67C212.919 26.51 213.139 26.41 213.369 26.41H219.239C219.469 26.41 219.699 26.5 219.859 26.67C220.019 26.84 220.119 27.06 220.119 27.29V44.02C220.119 48.05 222.219 49.3701 225.469 49.3701C227.949 49.3301 230.289 48.2201 231.879 46.3101C232.009 46.1501 232.079 45.9501 232.079 45.7401V27.29C232.079 26.8 232.479 26.41 232.959 26.41H238.829C239.319 26.41 239.709 26.81 239.709 27.29V54.55C239.709 55.04 239.309 55.4301 238.829 55.4301H232.959C232.469 55.4301 232.079 55.03 232.079 54.55V53.8201Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M246.979 65.61V27.29C246.979 27.06 247.069 26.83 247.239 26.67C247.409 26.51 247.629 26.41 247.859 26.41H253.729C254.219 26.41 254.609 26.81 254.609 27.29V27.86C254.609 28.21 254.809 28.52 255.129 28.66C255.449 28.8 255.819 28.74 256.069 28.51C258.129 26.67 260.799 25.66 263.559 25.68C271.009 25.68 276.419 31.2099 276.419 40.8899C276.419 50.5699 271.009 56.16 263.559 56.16C260.789 56.19 258.109 55.16 256.069 53.29C255.809 53.06 255.439 52.9999 255.119 53.1399C254.799 53.2799 254.599 53.6 254.599 53.94V65.61C254.599 66.1 254.199 66.49 253.719 66.49H247.849C247.359 66.49 246.969 66.09 246.969 65.61H246.979ZM261.159 32.47C258.689 32.54 256.369 33.65 254.779 35.54C254.669 35.69 254.609 35.88 254.609 36.07V45.75C254.609 45.95 254.669 46.14 254.789 46.3C256.389 48.16 258.699 49.27 261.159 49.36C265.549 49.36 268.489 45.93 268.489 40.88C268.489 35.89 265.549 32.47 261.159 32.47Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M298.639 53.3301C298.709 53.1501 298.869 53.0301 299.049 53.0001C299.139 53.0001 299.099 53.1801 299.269 53.4401C299.379 53.6101 299.729 53.6101 299.849 53.7801C299.969 53.9501 299.999 54.0501 300.119 54.2101C300.159 54.0401 300.129 53.9701 300.169 53.8001C300.169 53.6201 300.199 53.4401 300.239 53.2601C300.299 53.1201 300.639 53.1301 300.729 53.0001C300.819 52.8701 300.709 52.7501 300.799 52.6301C300.869 52.8701 301.139 52.9601 301.199 53.2001C301.239 53.3401 301.039 53.5401 301.059 53.6801C301.079 53.8101 301.219 53.8801 301.229 54.0101C301.349 53.9501 301.459 53.8601 301.549 53.7601C301.669 53.6301 302.019 53.6901 302.129 53.5501C302.239 53.4101 302.329 53.2601 302.439 53.1301C302.529 52.9801 302.619 52.8401 302.719 52.7001C302.839 52.5801 302.789 52.2201 302.939 52.1201C303.079 52.0301 303.199 52.1401 303.369 52.0901C303.309 51.9001 303.309 51.9401 303.239 51.7501C303.369 51.6701 303.519 51.6201 303.669 51.6101C303.899 51.5901 304.059 51.3601 304.239 51.3301C304.449 51.2901 304.729 51.5101 304.909 51.4301C305.079 51.3601 305.079 50.9501 305.259 50.8201C305.399 50.7201 305.679 50.7701 305.859 50.6301C305.919 50.5801 305.939 50.5701 305.969 50.6101C306.149 50.8501 306.489 50.9101 306.749 50.7601C306.839 50.7401 306.929 50.7401 307.019 50.7601C306.949 50.8301 306.869 50.9001 306.779 50.9501C306.659 51.0501 306.709 51.3401 306.599 51.5201C306.509 51.6701 306.429 51.8301 306.369 52.0001C306.299 52.1901 305.939 52.3201 305.939 52.4901C305.929 52.7501 306.019 52.9201 305.869 53.0001C305.729 53.0801 305.609 52.9501 305.369 52.8401C305.259 52.7901 305.049 52.9801 305.019 53.0401C304.959 53.1401 304.769 53.4701 304.829 53.5201C304.959 53.6201 305.319 53.3801 305.459 53.4701C305.599 53.5601 305.569 53.9001 305.709 53.9801C305.849 54.0701 305.979 54.1201 306.109 54.2101C306.109 54.3201 306.139 54.3901 306.089 54.4401C305.939 54.5601 305.809 54.6901 305.679 54.8301C305.529 54.9901 305.569 55.1801 305.529 55.3601C305.499 55.5001 305.559 55.6701 305.549 55.9001C305.549 56.0401 305.699 56.1101 305.769 56.2501C305.819 56.4701 305.719 56.7001 305.519 56.8201C305.519 56.8201 305.469 57.1401 305.559 57.1701C305.819 57.2701 305.779 57.3001 305.809 57.4601C305.839 57.6401 305.979 57.8301 305.949 58.0301C305.769 57.8901 305.489 57.8901 305.299 57.7701C305.179 57.7001 305.099 57.3801 304.989 57.4201C304.909 57.4401 304.889 57.7201 304.899 57.8401C304.959 58.0601 304.999 58.2701 305.029 58.4901C305.049 58.7401 304.979 58.9901 304.839 59.1901C304.809 59.2201 304.399 59.5201 304.499 59.6901C304.559 59.8001 304.849 59.6701 305.129 59.5801C305.099 59.7001 305.079 59.8101 305.069 59.9301C305.069 59.9701 305.189 60.0101 305.139 60.0101C304.959 60.0301 304.769 60.0401 304.589 60.0301C304.439 59.9901 304.329 59.8401 304.189 59.7801C304.439 59.9601 304.389 60.0401 304.649 60.2001C304.909 60.3601 304.969 60.2601 305.239 60.4201C305.499 60.5801 305.559 60.4801 305.819 60.6401C306.079 60.8001 305.959 61.0001 306.229 61.1601C306.489 61.3201 306.439 61.4101 306.699 61.5701C306.959 61.7301 307.119 61.4701 307.389 61.6301C307.649 61.7901 307.529 62.0201 307.809 62.1501C307.679 62.0001 307.539 61.8801 307.869 61.8301C307.989 61.8301 308.109 61.7601 308.179 61.6601C308.249 61.5601 308.279 61.4301 308.249 61.3101C308.209 61.0301 308.199 60.7401 308.219 60.4601C308.389 60.3401 308.519 60.1901 308.619 60.0101C308.699 59.8201 308.809 59.6501 308.929 59.4801C309.069 59.3201 309.269 59.2101 309.489 59.1801C309.549 59.1801 309.759 58.9801 309.729 58.9301C309.559 58.6601 309.429 58.4501 309.559 58.2701C309.689 58.0801 309.829 57.9701 309.859 57.7401C309.859 57.7401 310.099 57.7601 310.089 57.7601C310.149 57.4501 309.919 57.2601 309.869 57.1101C309.799 56.9001 309.799 56.9501 309.469 57.0301C309.279 57.0601 309.089 57.0301 308.919 56.9601C308.829 56.8801 308.999 56.6001 308.959 56.4601C309.119 56.4301 309.269 56.5701 309.429 56.5401C309.669 56.5001 309.899 56.3101 310.139 56.2601C310.179 56.2601 310.389 56.0401 310.379 55.9801C310.239 55.8801 310.089 55.7901 309.939 55.7301C309.779 55.8601 309.709 56.1901 309.589 56.1501C309.459 56.1001 309.389 55.7901 309.269 55.7101C309.539 55.6301 309.829 55.5401 310.099 55.4701C310.109 55.4701 310.099 55.4901 310.109 55.5201C310.149 55.4401 310.369 55.6201 310.579 55.5901C310.649 55.5901 310.699 55.1601 310.679 55.0501C310.639 54.9001 310.629 54.7501 310.639 54.6001C310.689 54.4101 310.389 54.2101 310.379 54.0401C310.379 53.8601 310.639 53.6501 310.599 53.4801C310.559 53.3101 310.449 53.1501 310.389 52.9701C310.339 52.8001 310.109 52.6701 310.069 52.4901C310.009 52.2301 310.069 52.0901 309.959 52.0701C309.809 52.0301 309.419 52.2201 309.289 52.1601C309.359 52.0201 309.669 51.8801 309.739 51.7401C309.919 51.7401 310.139 51.9001 310.299 51.8601C310.469 51.8201 310.519 51.5001 310.539 51.2501C310.559 51.0601 310.389 50.9201 310.329 50.7301C310.279 50.5501 310.329 50.3201 310.279 50.1401C310.279 50.1101 310.189 50.2801 310.109 50.3101C309.969 50.3601 309.789 50.2801 309.649 50.3101C309.479 50.3301 309.309 50.3301 309.139 50.3101C309.209 50.2401 309.339 49.9401 309.409 49.8701C309.509 49.7801 309.919 49.9901 310.049 49.9001C310.229 49.7701 310.049 49.5301 310.029 49.4501C309.979 49.2701 310.229 49.0601 310.279 48.9101C310.339 48.7501 310.299 48.5601 310.349 48.4001C310.409 48.2401 310.659 48.0801 310.609 47.9101C310.569 47.7801 310.449 47.7001 310.439 47.5601C310.319 47.6701 310.159 47.6401 310.029 47.7201C309.879 47.8001 309.729 48.0101 309.569 48.0701C309.579 47.9001 309.479 47.5201 309.569 47.4301C309.699 47.3101 309.849 47.2001 310.009 47.1101C310.179 47.0101 310.309 47.0101 310.359 46.8801C310.409 46.7301 310.589 46.5401 310.519 46.3501C310.459 46.1901 310.049 46.0901 310.029 45.9301C310.029 45.6801 310.099 45.4301 310.229 45.2101C310.349 45.0201 310.449 44.9401 310.469 44.7501C310.489 44.5701 310.679 44.3501 310.599 44.1501C310.519 43.9901 310.469 43.8201 310.429 43.6501C310.409 43.4701 310.129 43.2301 310.099 43.0501C310.209 42.9601 310.489 42.9301 310.479 42.8601C310.449 42.6501 310.449 42.4401 310.409 42.2301C310.369 42.0201 310.559 41.7901 310.539 41.5801C310.519 41.3701 310.339 41.1801 310.329 40.9701C310.319 40.7601 310.329 40.5501 310.329 40.3401C310.379 40.1401 310.449 39.9301 310.529 39.7401C310.589 39.5201 310.419 39.2601 310.449 39.0401C310.479 38.8101 310.609 38.5601 310.639 38.3301C310.799 38.3001 311.159 38.4801 311.259 38.4001C311.339 38.3401 311.089 38.2101 310.959 37.9401C310.889 37.8101 311.209 37.5401 311.189 37.3901C311.169 37.2601 311.179 37.1301 311.209 37.0001C311.249 36.8401 310.849 36.7201 311.049 36.6001C310.889 36.4501 311.259 36.3101 311.139 36.1301C311.069 36.0201 311.189 35.8501 311.169 35.7001C311.169 35.6901 311.129 35.7301 311.129 35.7101C311.089 35.5501 310.969 35.3901 310.999 35.2501C311.039 35.0901 311.239 34.9901 311.299 34.8401C311.359 34.6901 310.859 34.5201 310.899 34.3701C310.949 34.2001 311.319 33.9901 311.299 33.8301C311.279 33.6301 311.229 33.4201 311.199 33.2101C311.169 33.0001 311.089 32.8101 311.039 32.6101C310.979 32.4201 310.899 32.2301 310.819 32.0401C310.739 31.8401 310.819 31.5801 310.699 31.4101C310.559 31.2501 310.449 31.0701 310.369 30.8701C310.329 30.6601 310.609 30.4801 310.649 30.2801C310.679 30.0801 310.679 29.9001 310.709 29.6901C310.709 29.6501 310.699 29.6101 310.679 29.5701C310.579 29.4801 310.319 29.4701 310.219 29.3801C310.319 29.3101 310.599 29.3901 310.699 29.3201C310.719 29.3101 310.439 29.2801 310.429 29.2601C310.379 29.0901 310.639 28.7801 310.589 28.6101C310.529 28.4301 310.429 28.3501 310.459 28.1801C310.519 28.0001 310.629 27.8401 310.779 27.7301C310.679 27.5201 310.409 27.2801 310.409 27.0801C310.409 26.8701 310.589 26.6901 310.639 26.4801C310.689 26.2801 310.549 26.0201 310.599 25.8101C310.619 25.7401 310.599 25.7601 310.549 25.6801C310.489 25.7801 310.379 25.7801 310.349 25.8901C310.279 26.2101 310.119 26.3601 309.899 26.0501C309.809 25.9301 309.979 25.6101 309.889 25.5001C309.789 25.3801 309.489 25.4801 309.369 25.4101C309.169 25.3001 308.659 25.1401 308.589 25.2501C308.349 25.6101 308.909 25.5201 308.999 25.6701C309.029 25.7201 309.189 25.8201 309.169 25.8801C309.139 26.0001 308.909 26.1301 308.739 26.2701C308.609 26.3701 308.389 26.3501 308.229 26.4301C308.089 26.5301 307.939 26.6101 307.789 26.6901C307.549 26.7601 307.329 26.8301 307.279 26.7201C307.179 26.5101 306.989 26.4901 306.809 26.4101C306.619 26.3201 306.369 26.1801 306.319 25.9301C306.299 25.8501 305.859 25.5401 305.779 25.6201C305.419 25.9201 305.989 26.0601 306.099 26.1801C306.379 26.5001 306.349 26.4901 305.839 26.5901C305.809 26.5901 305.749 26.6501 305.719 26.6501C305.769 26.8001 305.759 26.9701 305.679 27.1101C305.629 27.2401 305.449 27.4401 305.709 27.5201C305.639 27.6701 305.699 27.8301 305.549 27.9101C305.399 27.9901 305.009 27.7301 304.889 27.8301C304.769 28.0101 304.709 28.2301 304.729 28.4501C304.749 28.9401 304.639 28.7801 304.479 28.6101C304.349 28.4501 304.199 28.3201 304.019 28.2101C303.809 28.1401 303.589 28.1301 303.379 28.1801C303.219 28.2201 303.189 28.5901 303.029 28.7001C302.949 28.7801 302.929 28.8501 302.849 28.9301C302.849 28.9401 302.739 28.8001 302.739 28.8101C302.739 28.9501 302.739 29.0301 302.739 29.1701C302.539 29.0001 302.549 28.8301 302.469 28.7101C302.369 28.5501 302.059 28.4501 302.129 28.2001C302.169 28.0601 302.549 27.9201 302.639 27.6901C302.539 27.6201 302.419 27.5401 302.409 27.4701C302.389 27.2301 302.099 27.2101 302.039 27.1801C301.989 27.1501 302.079 27.1401 301.929 27.4301C301.869 27.5401 301.489 27.3901 301.379 27.4801C301.309 27.5401 301.449 27.6601 301.399 27.7301C301.689 27.8301 301.549 28.0301 301.539 28.1701C301.529 28.3201 301.749 28.6001 301.669 28.7701C301.579 28.9801 301.249 29.2701 301.759 29.2501C302.059 29.2401 301.999 29.2201 301.959 29.3801C301.919 29.5701 301.969 29.7601 302.099 29.9001C301.919 29.9801 301.599 30.0901 301.429 30.1701C301.269 29.8101 301.149 29.8601 300.929 30.0701C300.789 30.1401 300.649 30.1801 300.499 30.2001C300.539 30.0401 300.609 29.8901 300.709 29.7601C300.949 29.5301 300.899 29.4701 300.839 29.4101C300.779 29.3401 300.679 29.4301 300.439 29.4201C300.309 29.4201 300.319 28.9001 300.189 28.7301L300.219 28.8801C300.279 28.6901 300.119 28.4201 300.189 28.2301C300.249 28.0401 300.249 27.9201 300.319 27.7301C300.149 27.6401 300.249 27.3601 300.189 27.1701C300.169 27.0701 300.119 26.9801 300.039 26.9201C299.959 26.8601 299.859 26.8401 299.759 26.8601C299.599 26.8801 299.449 26.9601 299.289 26.9801C299.129 26.9901 298.959 26.8701 298.799 26.8801C298.579 26.9001 298.369 26.9701 298.179 27.0901C297.969 27.1801 297.829 27.3801 297.799 27.6101C297.759 28.0101 297.769 27.7101 297.639 27.6001C297.479 27.4601 297.299 27.3401 297.139 27.2001C296.979 27.0601 296.799 26.9501 296.639 26.8101C296.479 26.6701 296.299 26.5501 296.139 26.4101C295.989 26.3301 295.819 26.2901 295.649 26.2901C295.529 26.5401 295.439 26.7101 295.209 26.7501C295.009 26.7701 294.829 26.8801 294.729 27.0501C294.579 27.2401 294.279 27.2901 294.099 27.3801C293.919 27.5201 293.709 27.6301 293.489 27.7001C293.279 27.7401 293.019 27.4101 292.799 27.4201C292.569 27.4401 292.339 27.4601 292.109 27.4801C291.879 27.4801 291.649 27.5801 291.489 27.7501C291.399 27.8701 291.269 27.9701 291.119 28.0201C290.989 28.0901 290.839 28.1101 290.689 28.0801C290.659 28.0801 290.659 28.3301 290.689 28.4501C290.719 28.6001 290.669 28.7401 290.769 28.8701C290.619 28.8201 290.499 28.8101 290.349 28.7601C290.199 28.7101 290.079 28.5001 289.929 28.4801C289.659 28.4401 289.679 28.4601 289.459 28.5901C289.339 28.6601 289.509 29.1701 289.489 29.4101C289.459 29.5601 289.439 29.8101 289.409 30.0701C289.379 30.3301 289.369 30.5901 289.339 30.7401C289.309 30.9001 289.259 31.0501 289.209 31.2001C289.149 31.0701 289.079 30.9601 288.989 30.8501C288.859 30.7501 289.149 30.5301 289.009 30.4401C288.949 30.6401 289.029 31.0501 288.879 31.1701C288.699 31.3001 288.499 31.4101 288.289 31.4701C288.109 31.5301 287.849 31.3501 287.649 31.3601C287.459 31.4101 287.259 31.4401 287.059 31.4601C286.559 31.3901 286.589 31.5501 286.719 31.8101C286.779 31.9301 287.039 31.9201 287.119 32.0301L287.069 32.0901C287.069 32.3001 286.889 32.0301 286.639 31.9801C286.489 31.9501 286.289 32.1101 286.109 32.2201C285.939 32.3201 285.619 32.3001 285.469 32.4401C285.329 32.6301 285.239 32.8401 285.199 33.0701C285.139 33.2301 285.259 33.5301 285.149 33.6801C285.029 33.8301 284.899 33.9701 284.749 34.0901C284.619 34.2101 284.279 34.0901 284.129 34.1901C283.979 34.3001 283.959 34.6001 283.819 34.6901C283.749 34.7401 283.759 34.7501 283.729 34.8801C283.879 34.8801 283.949 34.9501 283.999 34.8801C284.129 34.7201 284.319 34.6301 284.529 34.6401C284.729 34.6301 284.939 34.6801 285.109 34.8001C285.169 34.8601 285.019 34.9701 285.109 34.9901C284.929 35.2901 285.039 35.4101 284.479 35.2801C284.419 35.2501 284.349 35.2801 284.319 35.3401C284.259 35.5301 284.259 35.7401 284.339 35.9201C284.449 36.2901 284.729 36.3901 284.169 36.3301C283.919 36.3001 283.949 36.4501 283.899 36.5801C283.859 36.7001 283.749 36.7901 283.929 36.9501C284.309 37.3001 284.029 37.2501 283.699 37.4301C283.559 37.5101 283.519 38.0201 283.529 38.0301C283.809 38.1101 283.739 38.3601 284.019 38.4401C284.299 38.5201 284.399 38.1701 284.689 38.2501C284.969 38.3301 284.949 38.4101 285.229 38.4901C285.509 38.5701 285.449 38.7801 285.729 38.8601C286.009 38.9401 286.109 38.5801 286.399 38.6601C286.679 38.7401 286.629 38.9301 286.909 39.0101C287.189 39.0901 287.239 38.9201 287.519 39.0101C287.799 39.0901 287.709 39.4301 287.989 39.5201C288.269 39.6001 288.339 39.7501 288.629 39.6801C288.509 39.5001 288.469 39.2901 288.509 39.0801C288.529 38.9801 288.589 39.0001 288.909 38.9601C289.099 38.8501 289.249 38.6901 289.339 38.4901C289.149 38.6101 289.079 38.5701 288.999 38.2901C288.939 38.0801 288.639 37.9501 288.539 37.7601C288.469 37.6101 288.399 37.4501 288.349 37.3001C288.299 37.2101 288.309 37.0901 288.359 37.0101C288.409 36.9301 288.509 36.8701 288.619 36.8701C288.739 36.8701 288.819 36.8701 289.029 36.8701C289.069 36.6901 289.139 36.6201 289.179 36.4301C289.219 36.2401 289.449 36.1201 289.499 35.9401C289.549 35.7201 289.719 35.5501 289.939 35.4901C290.169 35.4301 290.419 35.4501 290.649 35.5201C290.869 35.6001 290.949 35.4601 291.049 35.3801C291.159 35.3001 291.079 35.2401 291.099 35.0401C291.109 34.8901 291.479 34.7401 291.459 34.5601C291.449 34.3701 291.079 34.2001 291.059 34.0001C291.009 33.7801 291.089 33.5601 291.279 33.4301C291.099 33.4001 291.129 33.3501 290.949 33.3201C290.849 33.1301 290.579 33.1001 290.549 32.9801C290.499 32.7901 290.679 32.6201 290.819 32.4901C290.949 32.3901 291.089 32.3001 291.239 32.2301C291.289 32.1901 291.379 32.2101 291.429 32.1701C291.559 32.0501 291.739 31.9901 291.909 32.0101C292.089 31.9701 292.269 32.0101 292.419 32.1201C292.529 32.2201 292.609 32.4201 292.799 32.5301C292.829 32.5501 292.869 32.6501 292.909 32.6601L293.019 32.4201C293.199 32.5801 293.329 32.7901 293.549 32.7801C293.759 32.7701 293.909 32.5901 294.089 32.4201C294.239 32.2701 294.269 32.9001 294.419 32.7401C294.539 32.6001 294.789 32.6401 294.929 32.6101C295.069 32.5801 295.209 32.3401 295.369 32.4701C295.389 32.3401 295.589 32.3801 295.629 32.1501C295.659 31.9801 295.389 31.7301 295.429 31.5301C295.469 31.3501 295.429 31.1301 295.479 30.9401C295.529 30.7501 295.659 30.5701 295.709 30.3901C295.769 30.1901 296.039 30.0701 296.099 29.9101C296.189 29.6801 296.199 29.4701 296.289 29.3701C296.389 29.2801 296.509 29.2101 296.629 29.1601C296.649 29.2501 296.449 29.5401 296.489 29.6201C296.569 29.7901 296.779 29.9001 296.849 30.0901C296.919 30.2701 296.989 30.4501 297.049 30.6301C297.109 30.8201 297.299 30.9701 297.349 31.1401C297.409 31.3401 297.469 31.5301 297.509 31.6901C297.579 31.9601 297.489 32.2001 297.529 32.2801C297.539 32.3101 297.599 31.8401 297.629 31.8501C297.819 31.8801 298.019 32.0601 298.239 32.0501C298.439 32.0501 298.639 31.8401 298.849 31.8201C299.059 31.8001 299.269 31.8601 299.479 31.8401C299.689 31.8201 299.899 32.0001 300.099 31.9901C300.319 31.9901 300.539 31.5601 300.729 31.5801C300.829 31.5901 300.859 31.2701 301.059 31.7001C301.129 31.8701 301.239 32.0201 301.369 32.1401C301.509 32.2701 301.589 32.5201 301.759 32.5901C301.929 32.6701 302.189 32.5301 302.359 32.5801C302.549 32.6301 302.679 32.7701 302.819 32.8001C303.009 32.8401 303.319 32.6701 303.429 32.7701C303.549 32.9401 303.629 33.1301 303.659 33.3401C303.699 33.5601 303.719 33.7701 303.749 33.9701C303.799 34.2001 303.669 34.4701 303.769 34.6201C303.909 34.8101 304.139 34.9201 304.379 34.9201C304.299 34.8101 304.319 34.6601 304.249 34.5501C304.339 34.5201 304.299 34.6501 304.389 34.6501C304.619 34.6501 304.839 34.6001 305.059 34.6101C305.289 34.6101 305.469 34.6001 305.689 34.6001C305.689 34.6601 305.779 34.5601 305.809 34.6001C305.869 34.7601 305.919 34.9301 305.949 35.1001C306.039 35.3201 306.009 35.3101 305.779 35.3701C305.659 35.4001 305.649 35.6801 305.429 35.7101C305.419 35.8601 305.229 35.8201 305.219 35.9701C305.079 36.1201 304.949 36.2801 304.809 36.4301C304.909 36.4501 304.859 36.4801 304.959 36.4901C304.859 36.6201 305.089 36.7401 304.989 36.8701C305.089 37.0301 304.949 37.2401 305.019 37.4201C305.089 37.6001 305.279 37.7101 305.409 37.8501C305.519 37.9801 305.679 38.0701 305.859 38.0901C305.909 38.0901 305.909 38.4301 305.929 38.5501C305.689 38.5801 305.439 38.6501 305.359 38.8201C305.279 38.9901 305.499 39.3001 305.419 39.4701C305.299 39.6601 305.109 39.7901 304.889 39.8201C304.879 39.8201 304.709 40.2701 304.799 40.3801C304.929 40.5301 305.039 40.5801 305.089 40.7501C305.139 40.9201 305.479 41.0501 305.489 41.2301C305.499 41.4101 305.179 41.6201 305.209 41.8001C305.249 41.9901 305.309 42.1701 305.409 42.3301C305.499 42.5001 305.289 42.4601 305.189 42.6001C305.119 42.7001 305.239 42.9001 305.379 43.1001C305.439 43.1901 305.459 43.3001 305.419 43.4001C305.389 43.5001 305.309 43.5801 305.219 43.6201C305.069 43.6801 304.739 43.4301 304.619 43.4901C304.529 43.5401 304.459 43.9301 304.489 44.0401C304.549 44.2201 304.589 44.4101 304.609 44.6101C304.599 44.8001 304.559 44.9901 304.499 45.1701C304.439 45.3501 304.359 45.5201 304.249 45.6801C304.149 45.8401 304.229 46.1801 304.079 46.3201C303.939 46.4501 303.689 46.4801 303.519 46.5901C303.369 46.7201 303.199 46.8401 303.029 46.9501C302.749 47.0801 302.749 47.0101 302.739 47.3201C302.739 47.6101 302.299 47.6001 302.099 47.6801C301.899 47.7701 301.839 48.0101 301.729 48.2101C301.599 48.2301 301.459 48.2101 301.329 48.1801C301.049 47.9501 301.009 47.7301 300.809 48.0201C300.659 48.0501 300.319 48.1101 300.299 48.1801C300.229 48.4201 300.429 48.7101 300.299 48.8601C300.229 48.9301 300.199 49.0201 300.199 49.1101C300.199 49.2001 300.249 49.2901 300.319 49.3501C300.379 49.4401 300.479 49.3901 300.719 49.3901C300.829 49.3901 300.889 49.5601 300.999 49.5701C300.909 49.6501 300.689 49.6001 300.609 49.7001C300.489 49.8601 300.439 49.9501 300.279 50.0101C300.129 50.0801 300.009 50.2401 299.809 50.1801C299.749 50.0401 299.529 49.9001 299.469 49.7301C299.369 49.4801 299.449 49.2301 299.389 49.2301C299.189 49.3001 298.989 49.3801 298.799 49.4701C298.599 49.5301 298.359 49.4701 298.159 49.5301C297.959 49.6001 297.959 49.7601 297.749 49.8301C297.789 50.1101 297.749 50.3001 297.219 50.2401L298.639 53.3301ZM305.959 53.9301C305.879 53.7701 305.569 53.7001 305.899 53.4401C306.039 53.3301 306.169 53.4801 306.369 53.4501C306.379 53.6501 306.649 53.7601 306.589 53.9401C306.559 54.0401 306.269 54.1901 306.139 54.2701C306.109 54.1801 305.999 54.0201 305.949 53.9301H305.959ZM305.659 55.7601C305.729 55.7101 305.919 55.6101 305.959 55.6301C306.089 55.6801 306.039 55.7601 306.209 55.8801C306.049 55.9401 306.069 56.1101 306.009 56.0901C305.889 56.0401 305.749 55.8501 305.649 55.7601H305.659ZM307.109 26.9101C307.109 26.9101 307.109 27.1001 307.129 27.1601C307.069 27.1801 307.109 27.0901 307.069 27.0701C307.019 27.0401 306.809 27.0701 306.779 27.0101C306.849 26.9901 307.049 26.8901 307.109 26.9101ZM306.749 28.7601C306.839 28.7801 306.859 28.9501 306.939 28.9901C306.889 29.0701 306.859 28.9701 306.769 29.1201C306.679 28.9901 306.519 29.1101 306.499 29.0301C306.499 28.9801 306.709 28.7501 306.739 28.7601H306.749ZM306.189 31.1001C306.189 31.1001 306.169 31.2901 306.149 31.3501C306.139 31.3901 306.149 31.2701 306.049 31.3101C306.049 31.2101 305.859 31.2101 305.849 31.1201C305.909 31.1201 306.149 31.0801 306.179 31.1001H306.189ZM306.069 31.7801C306.269 31.8401 306.419 32.0501 306.609 32.1301C306.609 32.2001 306.509 32.1101 306.499 32.1801C306.389 32.2101 306.289 32.5201 306.219 32.4801C306.019 32.3201 305.829 32.1501 305.659 31.9701C305.749 31.9501 305.989 31.7601 306.069 31.7801ZM305.989 34.0301C305.939 34.1401 305.829 34.2401 305.779 34.3501C305.719 34.1901 305.859 34.2101 305.869 34.0401C305.929 34.0401 305.919 34.0401 305.979 34.0401L305.989 34.0301ZM304.929 33.4101C304.929 33.4101 305.019 33.5601 305.059 33.6001C304.959 33.6601 304.959 33.5301 304.839 33.5301C304.879 33.4701 304.889 33.4801 304.929 33.4101ZM303.939 30.3101C303.959 30.3901 303.959 30.4701 303.939 30.5401C303.899 30.5901 303.909 30.4701 303.849 30.5101C303.829 30.4501 303.619 30.4801 303.639 30.4401C303.659 30.3901 303.879 30.3401 303.949 30.3101H303.939ZM303.709 31.8001C303.559 31.8801 303.279 32.0101 303.189 31.9601C302.969 31.8501 302.939 31.7301 302.749 31.5701C302.969 31.6001 303.049 31.4901 303.259 31.5401C303.389 31.5701 303.579 31.7501 303.699 31.8001H303.709ZM302.549 29.6601C302.639 29.7201 302.659 29.8901 302.749 29.9601C302.889 30.0101 302.879 30.0901 303.019 30.1501C302.929 30.2401 302.969 30.3701 302.879 30.4601C302.829 30.3201 302.719 30.1601 302.669 30.0201C302.559 29.9801 302.499 29.9101 302.399 29.8701C302.419 29.8501 302.539 29.6701 302.549 29.6701V29.6601ZM301.729 30.6001C301.789 30.3101 302.039 30.5401 302.219 30.5801C302.459 30.6201 302.429 30.7601 302.489 30.9101C302.549 31.0701 302.789 31.2301 302.759 31.4201C302.719 31.6301 302.539 31.9201 302.529 32.0501C302.319 31.9201 302.049 32.1801 301.869 32.0101C301.759 31.7901 301.699 31.5501 301.699 31.3101C301.699 31.0701 301.699 30.8401 301.739 30.6101L301.729 30.6001ZM301.089 30.6001C301.029 30.8201 300.989 31.0501 300.969 31.2901C300.969 31.4401 300.959 31.5901 300.939 31.7301C300.849 31.6101 300.809 31.4601 300.799 31.3101C300.779 31.0401 300.769 30.7001 300.739 30.6501C300.799 30.6401 301.019 30.6101 301.079 30.6001H301.089ZM298.519 27.2401C298.579 27.2901 298.619 27.3601 298.649 27.4301C298.649 27.4901 298.579 27.3901 298.549 27.4601C298.509 27.4201 298.389 27.5601 298.379 27.5201C298.379 27.4601 298.489 27.3001 298.519 27.2401ZM298.739 28.8601C298.849 29.0001 298.889 29.1701 298.959 29.2601C298.819 29.3501 298.689 29.3201 298.539 29.3501C298.419 29.3701 298.309 29.3401 298.209 29.2701C298.329 29.1701 298.559 29.0001 298.739 28.8601ZM299.169 30.4601C299.059 30.5901 298.919 30.6801 298.849 30.7601C298.709 30.6201 298.689 30.4101 298.559 30.2601C298.549 30.2201 298.549 30.1701 298.559 30.1301C298.739 30.2101 298.959 30.3601 299.179 30.4601H299.169ZM295.769 26.8501C295.849 26.8401 295.949 27.0601 296.039 27.1301C295.899 27.1901 295.779 27.1001 295.629 27.1701C295.489 27.1101 295.279 27.1801 295.169 27.1301C295.359 27.0201 295.559 26.9301 295.769 26.8601V26.8501ZM295.639 29.0801C295.579 29.0801 295.439 29.0701 295.379 29.0701C295.379 28.9501 295.349 29.0201 295.349 28.9001C295.419 29.0201 295.579 28.9701 295.639 29.0801ZM293.279 31.3501C293.429 31.3101 293.619 31.4201 293.779 31.3901C293.939 31.3701 294.109 31.4901 294.269 31.4701C294.319 31.4801 294.349 31.5201 294.369 31.5601C294.179 31.6101 294.009 31.7101 293.879 31.8501C293.709 32.0301 293.639 32.1901 293.529 32.3201C293.339 32.4901 293.089 32.5701 292.829 32.5601C292.939 32.3401 293.299 32.0901 293.399 31.8601C293.449 31.7401 293.239 31.3501 293.289 31.3401L293.279 31.3501ZM292.989 29.8701C293.009 30.1301 292.869 30.1401 292.869 30.4101C292.869 30.6701 292.769 30.6601 292.749 30.9301C292.689 30.9701 292.779 31.1201 292.719 31.1601C292.709 31.1001 292.599 30.8701 292.619 30.8201C292.679 30.6701 292.719 30.5201 292.739 30.3601C292.769 30.1801 292.859 30.0101 292.989 29.8701ZM292.509 29.1401C292.529 29.2201 292.509 29.3001 292.489 29.3801C292.469 29.4201 292.479 29.3001 292.419 29.3201C292.399 29.2601 292.189 29.3001 292.209 29.2601C292.229 29.2201 292.449 29.1601 292.499 29.1401H292.509ZM290.479 29.9501C290.699 29.9301 290.929 30.0501 291.149 30.0401C291.109 30.1001 291.109 30.0201 291.079 30.0201C290.879 29.9901 290.629 30.2101 290.429 30.1601C290.439 30.1601 290.469 29.9501 290.479 29.9501ZM289.899 29.8501C290.029 29.8501 290.239 29.8701 290.369 29.8701C290.369 29.8001 290.369 29.9301 290.369 29.8701C290.239 29.8101 290.019 29.9201 289.889 29.8601L289.899 29.8501ZM290.359 32.3601C290.309 32.4301 290.239 32.5001 290.159 32.5401C290.119 32.5601 290.179 32.4801 290.159 32.4401C290.139 32.3901 289.999 32.2801 290.029 32.2101C290.089 32.2401 290.289 32.3301 290.349 32.3601H290.359ZM289.969 29.1701C289.979 29.2901 289.979 29.4201 289.969 29.5401C289.969 29.6301 289.999 29.5601 289.969 29.6501C289.909 29.5501 289.699 29.6201 289.689 29.5101C289.689 29.4401 289.919 29.2501 289.979 29.1701H289.969ZM288.389 37.7801C288.489 37.7601 288.599 37.9401 288.749 37.9801C288.659 38.1501 288.669 38.1401 288.649 38.1401C288.489 38.0901 288.189 38.2101 288.039 38.1401C288.129 38.0601 288.289 37.8001 288.389 37.7801ZM286.299 34.5401C286.379 34.5601 286.379 34.7801 286.439 34.8701C286.349 34.9201 286.289 34.8301 286.199 34.8401C286.049 34.8401 285.909 35.1301 285.759 35.1301C285.609 35.1301 285.349 35.0501 285.189 35.0501C285.379 34.6301 285.849 34.4201 286.289 34.5401H286.299ZM285.649 33.5001C285.649 33.5001 285.649 33.3201 285.619 33.2601C285.679 33.2401 285.649 33.3401 285.689 33.3601C285.739 33.3801 285.939 33.3601 285.969 33.4101C285.899 33.4301 285.699 33.5201 285.639 33.5001H285.649ZM297.739 51.9401C297.739 52.1301 297.779 52.3101 297.849 52.4901C297.909 52.6101 297.959 52.8501 298.119 52.9401C298.239 52.9901 298.309 53.1201 298.279 53.2501C298.249 53.3801 298.139 53.4701 298.009 53.4701C297.849 53.2401 297.939 53.1601 297.889 52.8901C297.839 52.6201 297.889 52.6101 297.849 52.3301C297.799 52.0601 297.729 52.0701 297.679 51.8001C297.629 51.5301 297.929 51.4701 297.879 51.2001C297.829 50.9301 297.759 50.9501 297.739 50.6701C297.789 50.6801 297.859 50.8401 297.849 50.8801C297.809 50.9701 297.599 50.9401 297.519 50.9701L297.739 51.9401ZM299.199 51.2901C298.989 51.4001 298.669 51.4701 298.459 51.5901C298.249 51.7001 298.209 51.7601 297.999 51.8801C298.099 51.6901 298.129 51.4701 298.099 51.2601C298.119 51.0201 298.199 50.7801 298.339 50.5901C298.499 50.4301 298.679 50.2801 298.859 50.1601C298.859 50.1601 298.949 50.0701 298.959 50.0701C299.179 50.1501 299.209 50.4501 299.429 50.5301C299.389 50.7101 299.229 50.5801 299.069 50.7001C298.929 50.8001 299.019 51.0401 299.189 51.3101L299.199 51.2901ZM300.899 48.1501C301.059 48.2501 301.279 48.4401 301.449 48.5201C301.649 48.6201 301.709 48.6901 301.909 48.7701C301.749 48.9501 301.759 49.2001 301.609 49.3701C301.509 49.1901 301.299 48.9701 301.199 48.7901C301.099 48.6101 301.009 48.3201 300.909 48.1401L300.899 48.1501ZM301.559 52.1801C301.539 52.1001 301.529 52.0101 301.529 51.9201C301.529 51.9001 301.499 52.0101 301.519 52.0101C301.569 52.0201 301.759 51.8901 301.809 51.9101C301.759 51.9701 301.609 52.1201 301.559 52.1701V52.1801ZM302.519 52.4401C302.449 52.5201 302.279 52.4801 302.199 52.5501C302.169 52.5001 302.249 52.5501 302.259 52.5401C302.309 52.4601 302.189 52.1901 302.269 52.1401C302.379 52.1201 302.489 52.1201 302.599 52.1401C302.579 52.2401 302.559 52.3501 302.519 52.4401ZM303.409 50.9501C303.199 51.0501 302.969 51.1301 302.749 51.2101C302.549 51.3001 302.459 51.2501 302.199 51.1601C302.119 50.9301 301.789 50.8401 301.749 50.6001C301.699 50.2301 301.489 50.4601 301.319 50.4701C301.349 50.2901 301.409 50.0301 301.449 49.8601C301.479 49.6801 301.539 49.3901 301.569 49.2101C301.699 49.3501 301.739 49.6901 301.829 49.8601C301.919 50.0301 302.039 50.2101 302.139 50.3701C302.249 50.5501 302.519 50.5101 302.709 50.5601C302.859 50.6001 303.049 50.8101 303.299 50.7101C303.339 50.6901 303.449 50.6301 303.479 50.6801C303.489 50.7801 303.469 50.8801 303.419 50.9601L303.409 50.9501ZM303.269 50.3201C303.249 50.2301 303.249 50.1401 303.269 50.0501C303.289 50.0101 303.299 50.1401 303.359 50.1201C303.379 50.1701 303.569 50.1701 303.549 50.1901C303.509 50.2401 303.319 50.2901 303.249 50.3201H303.269ZM305.359 50.6501C305.319 50.7101 305.179 50.6501 305.119 50.6901C305.109 50.6301 305.199 50.6601 305.229 50.6201C305.259 50.5701 305.229 50.3701 305.299 50.3301C305.299 50.3901 305.389 50.6201 305.359 50.6501ZM305.529 39.2101C305.529 39.2101 305.719 39.2301 305.779 39.2101C305.819 39.2401 305.749 39.1201 305.789 39.1501C305.689 39.2501 305.839 39.4701 305.719 39.5201C305.699 39.4601 305.519 39.2601 305.529 39.2201V39.2101ZM305.829 49.2901C305.829 49.2901 305.799 49.1101 305.779 49.0501C305.989 49.0001 306.209 49.0801 306.409 49.0501C306.409 49.0501 306.479 49.0801 306.519 49.1901C306.299 49.2201 306.029 49.2801 305.819 49.3001L305.829 49.2901ZM306.569 50.1801C306.479 50.0801 306.409 49.8801 306.319 49.7701C306.409 49.7501 306.329 49.8301 306.419 49.8001C306.419 49.9301 306.569 50.0501 306.569 50.1701V50.1801ZM307.249 61.1401C307.179 61.0401 307.129 60.9301 307.089 60.8101C307.069 60.7701 307.119 60.8201 307.159 60.8201C307.239 60.8201 307.409 60.6901 307.519 60.7301C307.439 60.8601 307.299 61.0601 307.249 61.1401ZM307.249 54.1801C307.089 53.9901 307.029 53.7901 306.939 53.6901C307.079 53.6001 307.259 53.6401 307.409 53.5701C307.439 53.5601 307.629 53.6001 307.619 53.6401C307.509 53.8301 307.389 54.0101 307.249 54.1801ZM307.249 49.9801C306.909 49.9801 306.889 49.8601 306.609 49.6601C306.639 49.4001 306.829 49.3401 306.969 49.1901C307.119 49.0401 307.229 48.7301 307.489 48.6801C307.679 48.8701 307.739 49.1501 307.629 49.4001C307.519 49.5801 307.249 49.7801 307.249 49.9801ZM307.429 48.8501C307.299 48.6601 307.199 48.4601 307.109 48.2501C307.069 48.1501 307.109 48.0401 307.189 47.9801C307.299 47.8801 307.239 47.5801 307.369 47.4901C307.499 47.4001 307.619 47.3201 307.749 47.2401C307.849 47.3001 307.929 47.3801 307.999 47.4601C308.099 47.7101 308.099 47.9901 307.999 48.2401C307.859 48.4801 307.669 48.6901 307.439 48.8501H307.429ZM307.779 59.0001C307.779 58.8701 307.829 58.6701 307.829 58.5401C307.939 58.5701 307.859 58.5901 307.969 58.6201C307.859 58.7201 307.889 58.9001 307.789 59.0001H307.779ZM308.429 36.8301C308.349 36.7801 308.279 36.7101 308.229 36.6301C308.209 36.5401 308.289 36.6001 308.289 36.4801C308.389 36.5301 308.519 36.4101 308.519 36.4401C308.499 36.5701 308.469 36.7001 308.419 36.8301H308.429ZM308.909 48.1101C308.939 48.2101 308.949 48.3001 308.939 48.4001C308.909 48.5501 308.959 48.5301 308.899 48.7201C308.669 48.4301 308.469 48.4801 308.429 48.4201C308.559 48.3301 308.769 48.2001 308.899 48.1101H308.909ZM309.119 50.7701C309.039 50.8901 308.799 50.8601 308.669 50.9501C308.619 50.8501 308.669 50.8301 308.689 50.7701C308.719 50.5401 308.799 50.3201 308.919 50.1201C308.989 50.3901 309.159 50.7001 309.109 50.7701H309.119ZM309.999 53.0001C310.079 53.0401 310.059 53.1901 310.149 53.2501C310.079 53.3001 310.159 53.2501 310.159 53.2501C310.099 53.1801 309.819 53.2501 309.769 53.1701C309.839 53.1101 309.919 53.0601 309.999 53.0101V53.0001ZM309.389 53.5901C309.469 53.5901 309.519 53.7801 309.629 53.8501C309.509 53.9601 309.559 53.8801 309.479 53.9501C309.339 53.8701 309.149 54.0501 309.079 53.9001C309.149 53.8401 309.309 53.5901 309.379 53.5901H309.389ZM310.449 38.6801C310.369 38.7201 310.259 38.6201 310.169 38.6401C310.219 38.5301 310.259 38.5101 310.329 38.5001C310.459 38.4701 310.679 38.3301 310.829 38.3601C310.729 38.4301 310.569 38.6301 310.459 38.6801H310.449Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M303.38 34.87C303.27 34.68 303.23 34.45 303.28 34.23C303.29 34.17 303.29 34.12 303.29 34.06C303.27 33.95 303.26 33.84 303.24 33.73C303.23 33.63 303.21 33.53 303.2 33.43C303.19 33.36 303.17 33.3 303.15 33.24C303.01 33.28 302.85 33.2801 302.71 33.2601C302.59 33.2301 302.47 33.18 302.37 33.1C302.33 33.07 302.29 33.05 302.24 33.03C302.23 33.03 302.19 33.04 302.15 33.05C301.96 33.1 301.75 33.09 301.56 33.02C301.38 32.93 301.23 32.78 301.13 32.6C301.11 32.56 301.08 32.53 301.05 32.49C300.95 32.4 300.86 32.3001 300.79 32.1901C300.75 32.1801 300.72 32.16 300.69 32.14C300.54 32.32 300.33 32.43 300.1 32.46C299.94 32.46 299.78 32.42 299.63 32.36C299.59 32.34 299.54 32.33 299.49 32.31C299.36 32.31 299.23 32.31 299.11 32.3C299.03 32.3 298.96 32.29 298.88 32.29C298.83 32.31 298.79 32.33 298.75 32.36C298.6 32.46 298.42 32.51 298.25 32.53C298.14 32.53 298.04 32.52 297.93 32.48C297.88 32.63 297.74 32.7401 297.58 32.7601C297.39 32.7901 297.2 32.6901 297.11 32.5101C297.05 32.3801 297.04 32.24 297.07 32.1C297.08 32.01 297.08 31.93 297.07 31.84C297.05 31.76 297.02 31.67 296.99 31.58C296.96 31.49 296.93 31.39 296.9 31.29C296.9 31.28 296.85 31.22 296.83 31.18C296.73 31.06 296.66 30.93 296.61 30.79C296.57 30.65 296.51 30.51 296.46 30.37L296.42 30.27C296.36 30.34 296.29 30.41 296.22 30.48C296.19 30.51 296.15 30.5401 296.12 30.5701C296.09 30.6801 296.04 30.78 295.99 30.87C295.96 30.93 295.93 31 295.9 31.06C295.89 31.13 295.88 31.2 295.88 31.28C295.88 31.38 295.88 31.48 295.86 31.58C295.87 31.61 295.89 31.65 295.91 31.67C296.02 31.84 296.07 32.05 296.05 32.25C296.02 32.45 295.9 32.63 295.72 32.74C295.67 32.82 295.6 32.87 295.51 32.91C295.44 32.94 295.35 32.9501 295.27 32.9401C295.19 33.0001 295.1 33.0401 295 33.0701C294.93 33.0901 294.85 33.1 294.77 33.1C294.74 33.1 294.7 33.1 294.67 33.1C294.55 33.2 294.4 33.24 294.25 33.22C294.15 33.2 294.06 33.16 293.99 33.09C293.86 33.18 293.7 33.24 293.53 33.25C293.35 33.25 293.18 33.21 293.03 33.1C292.95 33.13 292.86 33.14 292.78 33.12C292.64 33.09 292.52 33.0001 292.45 32.8801C292.33 32.7901 292.23 32.68 292.15 32.55C292.13 32.52 292.11 32.5 292.09 32.47C292.05 32.47 292.01 32.46 291.97 32.47H291.89C291.75 32.47 291.74 32.47 291.68 32.53C291.6 32.6 291.5 32.64 291.39 32.66C291.33 32.7 291.27 32.7301 291.22 32.7601C291.18 32.7801 291.14 32.8 291.1 32.83L291.07 32.86C291.07 32.86 291.14 32.9201 291.18 32.9501C291.22 32.9701 291.26 32.98 291.3 33C291.49 33.03 291.64 33.17 291.68 33.35C291.72 33.53 291.65 33.72 291.5 33.83C291.49 33.83 291.48 33.86 291.48 33.9C291.5 33.92 291.53 33.95 291.55 33.97C291.73 34.11 291.85 34.32 291.89 34.55C291.89 34.81 291.75 35.0501 291.54 35.1901C291.58 35.4201 291.48 35.64 291.29 35.77C291.08 35.99 290.76 36.07 290.48 35.96C290.34 35.91 290.19 35.9101 290.05 35.9401C290.02 35.9401 289.96 35.96 289.93 36.09C289.88 36.24 289.79 36.38 289.68 36.49C289.65 36.52 289.63 36.55 289.61 36.58C289.59 36.67 289.56 36.76 289.52 36.85C289.5 36.89 289.48 36.94 289.47 36.98C289.43 37.19 289.24 37.34 289.02 37.34C288.94 37.34 288.88 37.34 288.83 37.34C288.86 37.42 288.9 37.5 288.94 37.58C288.98 37.62 289.01 37.6501 289.05 37.6901C289.19 37.8001 289.3 37.93 289.39 38.09C289.54 38.11 289.66 38.2 289.73 38.33C289.8 38.46 289.8 38.62 289.73 38.75C289.61 39.01 289.41 39.22 289.17 39.37C289.12 39.41 289.05 39.4301 288.99 39.4501V39.47C289.09 39.59 289.1 39.75 289.05 39.89C288.99 40.03 288.87 40.13 288.73 40.16C288.49 40.22 288.24 40.18 288.03 40.06C287.98 40.03 287.92 40.01 287.87 39.99C287.63 39.92 287.43 39.73 287.35 39.49H287.33C287.15 39.55 286.96 39.55 286.78 39.49C286.6 39.44 286.43 39.33 286.31 39.18C286.11 39.35 285.85 39.41 285.6 39.34C285.4 39.29 285.23 39.16 285.11 39C284.97 38.95 284.83 38.88 284.71 38.8C284.68 38.78 284.65 38.76 284.61 38.75H284.6C284.4 38.93 284.14 38.99 283.88 38.92C283.67 38.86 283.49 38.72 283.38 38.53C283.34 38.51 283.31 38.49 283.27 38.46C283.13 38.37 283.05 38.21 283.06 38.04C283.04 37.69 283.18 37.35 283.43 37.11C283.34 36.92 283.34 36.7001 283.45 36.5101L283.47 36.4501C283.5 36.2301 283.65 36.05 283.86 35.97C283.81 35.79 283.8 35.6 283.83 35.41C283.8 35.41 283.78 35.41 283.75 35.4C283.73 35.4 283.71 35.4 283.69 35.4C283.56 35.4 283.44 35.33 283.36 35.23C283.28 35.13 283.25 34.99 283.27 34.87C283.28 34.69 283.37 34.53 283.51 34.42C283.52 34.4 283.53 34.37 283.54 34.35C283.6 34.17 283.71 34.01 283.85 33.9C284.02 33.79 284.22 33.75 284.42 33.77C284.44 33.77 284.47 33.77 284.49 33.77C284.57 33.69 284.65 33.61 284.73 33.53C284.73 33.5 284.73 33.4701 284.73 33.4401C284.71 33.2901 284.72 33.14 284.76 32.99C284.77 32.95 284.78 32.91 284.8 32.87C284.85 32.61 284.97 32.38 285.15 32.18C285.32 32.04 285.52 31.95 285.74 31.93C285.79 31.93 285.84 31.91 285.88 31.9L285.96 31.85C286.03 31.81 286.1 31.76 286.19 31.71C286.17 31.57 286.21 31.43 286.29 31.31C286.5 31.09 286.82 31 287.12 31.08C287.14 31.08 287.22 31.06 287.27 31.04C287.38 31.01 287.5 30.99 287.62 30.97C287.78 30.97 287.93 30.99 288.08 31.05C288.11 31.06 288.16 31.08 288.19 31.09C288.3 31.05 288.41 31.0001 288.51 30.9401C288.5 30.8501 288.51 30.76 288.53 30.67C288.53 30.57 288.55 30.47 288.57 30.37C288.62 30.19 288.78 30.07 288.96 30.05V30.0101C288.99 29.7901 289.01 29.57 289.04 29.42C289.04 29.33 289.02 29.25 289.01 29.16C288.96 28.84 288.9 28.45 289.23 28.25L289.29 28.21C289.49 28.06 289.75 28.01 289.99 28.08C290.07 28.09 290.15 28.12 290.22 28.16C290.22 28.03 290.28 27.9101 290.36 27.8201C290.47 27.7101 290.62 27.6601 290.77 27.6901C290.82 27.7001 290.87 27.69 290.91 27.67L290.98 27.64C290.98 27.64 291.06 27.6001 291.1 27.5701C291.34 27.2801 291.69 27.11 292.07 27.09C292.18 27.09 292.3 27.07 292.41 27.06C292.53 27.05 292.64 27.04 292.76 27.03C292.98 27.03 293.2 27.11 293.37 27.24C293.39 27.26 293.43 27.28 293.45 27.29C293.52 27.25 293.58 27.22 293.64 27.17C293.72 27.12 293.79 27.07 293.87 27.03C293.95 26.99 294.04 26.95 294.13 26.92C294.21 26.9 294.29 26.8601 294.36 26.8201C294.53 26.5601 294.81 26.39 295.12 26.35C295.12 26.34 295.19 26.2201 295.23 26.1301C295.29 26.0101 295.41 25.92 295.55 25.89C295.85 25.87 296.15 25.95 296.41 26.11C296.48 26.17 296.55 26.22 296.62 26.27C296.72 26.35 296.82 26.4301 296.92 26.5101C296.99 26.5701 297.06 26.62 297.14 26.68C297.24 26.75 297.34 26.83 297.43 26.91C297.48 26.96 297.54 27 297.59 27.04C297.7 26.92 297.82 26.82 297.96 26.75C298.21 26.59 298.49 26.5 298.78 26.48C298.92 26.48 299.05 26.51 299.18 26.55C299.21 26.56 299.24 26.57 299.27 26.58C299.27 26.58 299.33 26.56 299.38 26.54C299.49 26.5 299.6 26.47 299.71 26.46C300.13 26.4 300.52 26.67 300.61 27.08C300.65 27.2 300.66 27.33 300.66 27.46V27.49C300.76 27.61 300.79 27.78 300.74 27.92C300.72 27.98 300.7 28.05 300.69 28.11C300.67 28.21 300.64 28.32 300.61 28.42C300.61 28.4 300.63 28.4601 300.64 28.5101C300.66 28.6001 300.68 28.7 300.68 28.79C300.7 28.85 300.71 28.91 300.73 28.98C300.84 28.98 300.95 29 301.05 29.05C301.08 28.93 301.14 28.82 301.21 28.72L301.23 28.7001C301.23 28.7001 301.21 28.6501 301.2 28.6301C301.13 28.4901 301.09 28.33 301.1 28.18C301.1 28.16 301.1 28.13 301.11 28.1C301.05 28.05 301.01 27.98 300.99 27.91C300.99 27.88 300.97 27.84 300.97 27.81C300.87 27.6 300.92 27.3401 301.1 27.1901C301.25 27.0801 301.43 27.03 301.61 27.06C301.66 26.93 301.76 26.84 301.89 26.8C302.02 26.76 302.16 26.78 302.27 26.85C302.54 26.9 302.75 27.09 302.84 27.34L302.87 27.36C303.05 27.48 303.13 27.71 303.07 27.92C303.13 27.87 303.21 27.83 303.29 27.81C303.59 27.74 303.91 27.75 304.2 27.85C304.26 27.87 304.32 27.9001 304.37 27.9401C304.41 27.7901 304.49 27.65 304.61 27.54C304.76 27.42 304.95 27.38 305.13 27.42C305.13 27.28 305.18 27.15 305.25 27.03C305.28 26.98 305.3 26.92 305.31 26.85C305.24 26.73 305.24 26.58 305.31 26.46C305.34 26.4 305.39 26.35 305.45 26.31C305.32 26.2 305.24 26.05 305.22 25.89C305.2 25.66 305.31 25.44 305.49 25.31C305.65 25.18 305.86 25.16 306.04 25.24C306.04 25.24 306.68 25.5 306.76 25.89C306.76 25.89 306.79 25.96 306.99 26.04C307.02 26.05 307.05 26.07 307.08 26.08C307.24 26.13 307.39 26.22 307.52 26.34C307.56 26.33 307.6 26.32 307.63 26.31C307.69 26.29 307.74 26.26 307.79 26.22C307.86 26.17 307.94 26.12 308.02 26.08C308.14 26.02 308.26 25.98 308.39 25.97H308.41C308.28 25.9 308.18 25.79 308.12 25.66C308.05 25.45 308.09 25.23 308.22 25.06C308.53 24.6 309.32 24.94 309.54 25.05C309.56 25.05 309.58 25.05 309.6 25.05C309.84 25.02 310.08 25.11 310.25 25.28C310.27 25.31 310.29 25.34 310.31 25.36C310.38 25.31 310.46 25.28 310.55 25.28C310.71 25.28 310.86 25.35 310.95 25.49C311.06 25.62 311.1 25.8 311.05 25.97C311.05 25.98 311.07 26.06 311.08 26.11C311.13 26.28 311.13 26.47 311.1 26.64C311.06 26.77 311.01 26.89 310.95 27C310.92 27.05 310.9 27.09 310.88 27.14C310.88 27.11 310.96 27.22 311 27.28C311.08 27.38 311.14 27.48 311.2 27.59C311.29 27.77 311.25 27.98 311.1 28.12C311.03 28.18 310.96 28.25 310.91 28.33C310.96 28.39 311 28.46 311.02 28.54C311.07 28.7 311.06 28.88 310.99 29.04C311.07 29.1 311.12 29.19 311.14 29.29C311.16 29.37 311.15 29.46 311.13 29.53C311.16 29.62 311.17 29.7201 311.16 29.8201C311.15 29.9101 311.14 29.99 311.13 30.08C311.13 30.19 311.11 30.3 311.09 30.42C311.05 30.58 310.98 30.74 310.87 30.87L310.84 30.91C310.87 30.96 310.93 31.04 310.97 31.09L311.07 31.22C311.18 31.39 311.24 31.59 311.23 31.8C311.23 31.85 311.23 31.9001 311.24 31.9401C311.26 31.9901 311.29 32.04 311.31 32.1C311.37 32.24 310.83 32.3901 310.88 32.5701C310.9 32.6401 310.92 32.71 310.94 32.78C310.99 32.92 311.02 33.07 311.05 33.21L311.09 33.42C311.12 33.56 311.14 33.71 311.16 33.85C311.16 33.83 311.18 33.85 311.2 33.89C311.35 34.08 311.41 34.34 311.35 34.58C311.31 34.7 311.26 34.81 311.2 34.92C311.17 34.97 311.14 35.03 311.12 35.08C311.06 35.21 310.98 35.32 310.88 35.42V35.4401H310.89C310.96 35.5201 311.01 35.62 311.02 35.72C311.02 35.83 311.02 35.93 310.99 36.03C311.03 36.07 311.09 36.11 311.14 36.15C311.22 36.21 311.3 36.28 311.37 36.34C311.47 36.44 311.52 36.58 311.51 36.72C311.5 36.86 311.41 36.98 311.29 37.06C311.2 37.11 311.12 37.16 311.04 37.22C311.03 37.28 311.03 37.35 311.04 37.41C311.05 37.61 310.99 37.8001 310.86 37.9501L310.91 38C311.05 38.12 311.13 38.3 311.13 38.48C311.12 38.61 311.65 38.75 311.55 38.83C311.38 38.94 311.17 38.98 310.98 38.92C310.95 39 310.93 39.09 310.91 39.17C310.91 39.22 310.93 39.27 310.95 39.33C311.02 39.53 311.03 39.7401 310.98 39.9501C310.95 40.0501 310.92 40.14 310.88 40.23C310.84 40.31 310.82 40.39 310.8 40.47C310.79 40.61 310.78 40.75 310.8 40.89V41.04C310.8 41.04 310.84 41.13 310.86 41.17C310.93 41.3 310.98 41.45 311 41.6C311.01 41.78 310.98 41.95 310.91 42.11C310.89 42.15 310.88 42.2 310.87 42.25C310.89 42.34 310.9 42.4501 310.91 42.5701C310.91 42.6601 310.92 42.76 310.94 42.85C310.97 43.03 310.9 43.2 310.75 43.3C310.82 43.4 310.86 43.52 310.88 43.64C310.9 43.74 310.93 43.83 310.97 43.92L311.02 44.04C311.1 44.28 311.08 44.55 310.95 44.77C310.94 44.8 310.92 44.83 310.91 44.86C310.89 45.06 310.81 45.25 310.68 45.4L310.61 45.5101C310.56 45.6101 310.52 45.71 310.5 45.81C310.7 45.9 310.85 46.05 310.95 46.24C311.03 46.5 310.98 46.78 310.83 47C310.82 47.02 310.8 47.0501 310.79 47.0701C310.77 47.1201 310.75 47.17 310.72 47.22C310.83 47.3 310.9 47.4301 310.9 47.5701C310.97 47.6401 311.02 47.7301 311.05 47.8201C311.12 48.0901 311.03 48.37 310.83 48.56C310.81 48.58 310.79 48.6101 310.77 48.6301C310.77 48.6601 310.77 48.69 310.77 48.72C310.77 48.85 310.75 48.98 310.71 49.1C310.67 49.2 310.61 49.3 310.54 49.39C310.53 49.41 310.51 49.4301 310.5 49.4501C310.55 49.5701 310.58 49.71 310.57 49.85C310.64 49.91 310.69 49.9801 310.71 50.0701C310.74 50.2101 310.76 50.35 310.75 50.49C310.75 50.54 310.75 50.6 310.75 50.65C310.77 50.69 310.79 50.73 310.81 50.77C310.93 50.94 310.98 51.14 310.98 51.34C310.96 51.59 310.91 52.16 310.48 52.33C310.48 52.37 310.48 52.41 310.5 52.46C310.5 52.46 310.53 52.4801 310.56 52.5101C310.67 52.6201 310.76 52.76 310.81 52.9C310.83 52.96 310.86 53.0201 310.88 53.0701C310.94 53.1901 310.98 53.31 311.02 53.43C311.06 53.66 311 53.8901 310.86 54.0701C311.04 54.2601 311.11 54.53 311.06 54.78C311.07 54.81 311.08 54.83 311.08 54.86C311.09 54.92 311.1 54.99 311.11 55.06C311.11 55.06 311.17 55.79 310.81 56.03C310.76 56.36 310.54 56.6401 310.23 56.7601C310.21 56.7601 310.18 56.77 310.16 56.78C310.21 56.86 310.25 56.94 310.28 57.03C310.28 57.03 310.3 57.0601 310.31 57.0701C310.48 57.3101 310.56 57.6 310.51 57.9C310.47 58.08 310.33 58.2201 310.15 58.25C310.1 58.3301 310.05 58.4 309.99 58.47L309.96 58.5101C309.99 58.5701 310.04 58.66 310.08 58.72C310.16 58.87 310.17 59.05 310.11 59.21C309.98 59.44 309.77 59.6 309.52 59.67C309.41 59.69 309.32 59.75 309.25 59.83C309.2 59.9 309.15 59.9801 309.11 60.0701C309.07 60.1401 309.04 60.21 309 60.28C308.91 60.45 308.79 60.6 308.65 60.73C308.65 60.91 308.66 61.09 308.68 61.27C308.75 61.66 308.56 62.04 308.22 62.22C308.22 62.3 308.19 62.3701 308.14 62.4401C308.06 62.5601 307.92 62.63 307.77 62.64C307.71 62.64 307.66 62.63 307.6 62.6C307.38 62.51 307.22 62.32 307.14 62.1C306.9 62.15 306.65 62.1101 306.44 62C306.3 61.92 306.19 61.8201 306.09 61.6901C306.06 61.6501 306.02 61.61 305.97 61.58C305.79 61.47 305.65 61.3 305.58 61.1C305.5 61.02 305.48 61.0201 305.42 61.0101C305.26 60.9801 305.11 60.93 304.97 60.84C304.93 60.81 304.88 60.8 304.83 60.79C304.67 60.77 304.52 60.71 304.38 60.62C304.24 60.54 304.12 60.43 304.02 60.3C303.99 60.25 303.94 60.21 303.89 60.18C303.74 60.08 303.67 59.89 303.71 59.72C303.75 59.54 303.89 59.41 304.07 59.37C304.17 59.19 304.31 59.04 304.47 58.92C304.53 58.79 304.55 58.6501 304.54 58.5101C304.54 58.4301 304.52 58.35 304.49 58.28C304.45 58.16 304.43 58.04 304.41 57.91C304.41 57.83 304.35 57.1501 304.81 57.0101C304.87 56.9901 304.94 56.98 305.01 56.99C304.99 56.79 305.07 56.59 305.23 56.47C305.25 56.46 305.27 56.44 305.28 56.42C305.14 56.29 305.06 56.1 305.06 55.9C305.06 55.83 305.06 55.75 305.05 55.68C305.03 55.55 305.03 55.42 305.05 55.29C305.05 55.25 305.06 55.22 305.06 55.18C305.06 54.94 305.15 54.72 305.31 54.54C305.35 54.5 305.4 54.45 305.45 54.4H305.43C305.29 54.29 305.19 54.14 305.14 53.98C304.94 54.05 304.71 54.02 304.53 53.91C304.11 53.6 304.46 53.06 304.6 52.83C304.78 52.54 305.12 52.38 305.46 52.43C305.51 52.22 305.65 52.03 305.83 51.91C305.87 51.88 305.9 51.8501 305.94 51.8201C306 51.6401 306.08 51.47 306.18 51.31V51.28C306.06 51.26 305.94 51.21 305.84 51.14C305.75 51.17 305.66 51.1901 305.56 51.2001H305.51C305.51 51.2001 305.49 51.27 305.48 51.3C305.43 51.53 305.28 51.73 305.07 51.85C304.85 51.93 304.61 51.9201 304.4 51.8201C304.37 51.8201 304.33 51.8 304.3 51.79C304.28 51.8 304.26 51.82 304.24 51.83C304.11 51.93 303.96 52.01 303.8 52.05C303.82 52.26 303.69 52.46 303.5 52.52C303.42 52.55 303.33 52.57 303.24 52.56C303.22 52.73 303.15 52.89 303.03 53.02C303 53.06 302.97 53.11 302.95 53.15C302.9 53.24 302.85 53.33 302.79 53.41C302.73 53.48 302.68 53.5601 302.63 53.6301C302.58 53.7001 302.54 53.76 302.49 53.83C302.34 54 302.13 54.1 301.91 54.11C301.89 54.11 301.86 54.11 301.84 54.12C301.73 54.24 301.59 54.34 301.45 54.42C301.33 54.49 301.18 54.49 301.06 54.4401C300.93 54.3901 300.84 54.28 300.8 54.14C300.72 54.04 300.66 53.93 300.63 53.8C300.63 53.83 300.63 53.87 300.62 53.9C300.62 53.95 300.61 53.99 300.61 54.04C300.61 54.14 300.6 54.2301 300.58 54.3201C300.54 54.4901 300.41 54.63 300.23 54.66C300.06 54.7 299.88 54.63 299.77 54.49C299.71 54.41 299.66 54.32 299.61 54.23C299.58 54.17 299.55 54.11 299.51 54.06C299.53 54.09 299.47 54.06 299.43 54.06C299.23 54 299.05 53.88 298.92 53.72C298.86 53.63 298.81 53.53 298.77 53.42L298.73 53.4V53.43C298.64 53.74 298.35 53.9601 298.02 53.9501C297.87 53.9501 297.74 53.88 297.66 53.75C297.53 53.58 297.47 53.37 297.48 53.15C297.48 53.1 297.48 53.04 297.47 52.99C297.45 52.88 297.44 52.77 297.44 52.66C297.38 52.5 297.34 52.34 297.33 52.17C297.3 52.09 297.27 52 297.26 51.91C297.22 51.68 297.29 51.4401 297.44 51.2601C297.44 51.2601 297.42 51.19 297.4 51.15C297.34 51.02 297.31 50.88 297.3 50.74C297.3 50.74 297.23 50.73 297.19 50.72L297.29 49.83H297.32C297.34 49.65 297.46 49.5 297.63 49.4401C297.73 49.3001 297.87 49.2 298.03 49.14C298.25 49.1 298.47 49.0701 298.69 49.0701C298.75 49.0501 298.81 49.02 298.87 48.99C299.01 48.91 299.17 48.8501 299.33 48.8201C299.46 48.8001 299.6 48.84 299.7 48.92C299.72 48.94 299.74 48.96 299.76 48.98C299.78 48.87 299.82 48.76 299.89 48.67V48.62C299.83 48.44 299.83 48.2501 299.87 48.0701C299.95 47.7801 300.23 47.6901 300.57 47.6301C300.67 47.5301 300.8 47.4701 300.94 47.4501C301.15 47.4501 301.36 47.54 301.48 47.72C301.57 47.53 301.73 47.38 301.92 47.29C302.01 47.25 302.1 47.23 302.2 47.21C302.23 47.21 302.26 47.2001 302.29 47.1901C302.29 46.92 302.47 46.69 302.72 46.61L302.83 46.56C302.9 46.52 302.96 46.47 303.02 46.42C303.1 46.35 303.18 46.29 303.26 46.23C303.37 46.17 303.48 46.1101 303.6 46.0701C303.63 46.0601 303.68 46.04 303.71 46.03C303.71 46 303.71 45.9701 303.71 45.9501C303.71 45.7801 303.76 45.61 303.84 45.46C303.92 45.34 303.99 45.2101 304.04 45.0701C304.09 44.9301 304.12 44.78 304.13 44.62C304.13 44.55 304.11 44.48 304.08 44.42C304.05 44.33 304.03 44.24 304.01 44.15C303.99 44.06 303.98 43.33 304.38 43.12C304.51 43.06 304.65 43.0401 304.79 43.0701C304.66 42.8501 304.66 42.58 304.79 42.37C304.81 42.35 304.83 42.32 304.85 42.3C304.79 42.17 304.76 42.03 304.73 41.89C304.71 41.68 304.78 41.47 304.92 41.31C304.78 41.21 304.68 41.07 304.62 40.9C304.61 40.89 304.59 40.87 304.56 40.85C304.52 40.81 304.47 40.7601 304.42 40.7001C304.25 40.5101 304.24 40.2301 304.38 39.8201C304.42 39.6201 304.56 39.46 304.76 39.41C304.82 39.4 304.88 39.38 304.94 39.34C304.94 39.32 304.94 39.31 304.93 39.29C304.85 39.09 304.85 38.86 304.93 38.65C304.99 38.52 305.09 38.4 305.22 38.33C305.16 38.28 305.1 38.23 305.05 38.17C305.02 38.14 304.98 38.1 304.95 38.08C304.79 37.96 304.66 37.79 304.58 37.6C304.53 37.44 304.52 37.28 304.55 37.11V37.0701C304.53 37.0001 304.51 36.91 304.52 36.83V36.8C304.41 36.72 304.35 36.6 304.34 36.48C304.33 36.36 304.38 36.23 304.46 36.14C304.53 36.07 304.59 36 304.65 35.93C304.7 35.87 304.75 35.8201 304.8 35.7601C304.85 35.6601 304.92 35.5701 305.02 35.5101C305.07 35.4201 305.15 35.35 305.25 35.31C305.3 35.21 305.37 35.13 305.45 35.06H305.38C305.27 35.06 305.16 35.07 305.04 35.06C304.96 35.06 304.87 35.0601 304.78 35.0701C304.78 35.0801 304.77 35.1 304.76 35.11C304.69 35.26 304.54 35.36 304.37 35.37L303.38 34.87ZM307.78 61.39C307.78 61.39 307.79 61.4 307.78 61.36C307.78 61.28 307.77 61.2 307.76 61.12C307.74 61.15 307.71 61.19 307.69 61.22L307.64 61.29C307.64 61.29 307.72 61.35 307.76 61.39H307.77H307.78ZM305.57 60.09H305.59C305.75 60.12 305.9 60.1701 306.03 60.2601C306.21 60.3701 306.35 60.54 306.42 60.74C306.5 60.8 306.57 60.86 306.64 60.92C306.59 60.78 306.62 60.62 306.71 60.5C306.81 60.3801 306.95 60.32 307.11 60.34C307.29 60.25 307.49 60.24 307.67 60.31C307.73 60.39 307.84 60.4 307.92 60.35C308 60.3 308.02 60.19 307.97 60.11C308.08 60.03 308.17 59.93 308.23 59.81C308.26 59.76 308.28 59.71 308.31 59.65C308.38 59.49 308.48 59.3301 308.6 59.2001C308.75 59.0301 308.94 58.91 309.15 58.83C309.02 58.58 309.03 58.28 309.19 58.04C309.23 57.99 309.27 57.94 309.3 57.89C309.38 57.79 309.4 57.75 309.41 57.72C309.41 57.69 309.41 57.67 309.43 57.64C309.44 57.6 309.46 57.56 309.48 57.52C309.18 57.57 308.87 57.5 308.62 57.33C308.45 57.14 308.4 56.8601 308.5 56.6301C308.5 56.6101 308.51 56.58 308.52 56.56C308.49 56.33 308.65 56.1201 308.87 56.0701C308.89 56.0701 308.92 56.07 308.94 56.06C308.83 55.95 308.79 55.7801 308.83 55.6301C308.87 55.4801 308.99 55.3601 309.14 55.3201C309.26 55.2901 309.38 55.25 309.5 55.21C309.66 55.16 309.82 55.1201 309.97 55.0701C310.05 55.0501 310.14 55.0501 310.22 55.0701C310.22 55.0501 310.22 55.02 310.21 55C310.18 54.88 310.17 54.7501 310.18 54.6301C310.17 54.6101 310.16 54.6 310.15 54.58C310.04 54.45 309.97 54.3 309.94 54.14C309.94 54.15 309.92 54.16 309.91 54.17C309.85 54.23 309.78 54.28 309.71 54.31C309.6 54.38 309.48 54.4 309.35 54.37C309.08 54.47 308.78 54.34 308.66 54.09C308.57 53.9 308.61 53.68 308.77 53.55C308.77 53.55 308.79 53.52 308.81 53.49C308.92 53.31 309.09 53.1901 309.29 53.1301C309.29 53.1001 309.29 53.08 309.29 53.05C309.32 52.93 309.39 52.8201 309.5 52.7601C309.54 52.7301 309.59 52.69 309.63 52.66C309.63 52.64 309.62 52.62 309.62 52.61C309.46 52.65 309.28 52.65 309.12 52.6C309 52.55 308.91 52.46 308.86 52.35C308.81 52.24 308.82 52.1 308.87 51.99C308.96 51.83 309.08 51.7 309.24 51.61C309.28 51.58 309.32 51.55 309.36 51.52C309.43 51.37 309.59 51.29 309.75 51.31C309.86 51.31 309.97 51.3401 310.07 51.3801C310.07 51.3401 310.08 51.29 310.09 51.23C310.09 51.24 310.06 51.22 310.04 51.18C309.98 51.08 309.93 50.98 309.89 50.87C309.89 50.84 309.87 50.81 309.87 50.78C309.85 50.78 309.82 50.78 309.8 50.78C309.77 50.78 309.76 50.78 309.72 50.78C309.66 50.79 309.59 50.8 309.53 50.8C309.53 50.88 309.5 50.96 309.45 51.02C309.32 51.19 309.13 51.3001 308.92 51.3201C308.89 51.3201 308.87 51.33 308.84 51.34C308.74 51.41 308.61 51.43 308.49 51.39C308.37 51.35 308.27 51.26 308.22 51.15C308.12 50.97 308.13 50.76 308.23 50.58C308.23 50.58 308.23 50.5401 308.24 50.5101C308.27 50.2601 308.37 50.03 308.52 49.84C308.63 49.71 308.8 49.65 308.96 49.6901H308.98C308.98 49.6901 309.05 49.6 309.09 49.56C309.22 49.45 309.39 49.4 309.56 49.43C309.57 49.22 309.65 49.02 309.79 48.86C309.81 48.83 309.83 48.8 309.85 48.77C309.85 48.77 309.85 48.7 309.85 48.65C309.85 48.57 309.86 48.5 309.87 48.42C309.81 48.46 309.75 48.4901 309.69 48.5101C309.57 48.5501 309.43 48.54 309.32 48.47V48.49C309.32 48.61 309.31 48.73 309.27 48.85C309.22 49.01 309.09 49.13 308.93 49.17C308.77 49.2 308.6 49.1401 308.49 49.0101C308.46 48.9501 308.4 48.91 308.33 48.9C308.24 48.88 308.16 48.84 308.09 48.79C308.07 48.82 308.04 48.84 308.02 48.87C308.1 49.13 308.07 49.41 307.94 49.65C307.88 49.74 307.81 49.83 307.74 49.91C307.7 49.96 307.66 50 307.62 50.05C307.6 50.25 307.44 50.41 307.24 50.4401C307.42 50.59 307.46 50.85 307.32 51.05C307.25 51.14 307.16 51.22 307.06 51.29V51.33C307.04 51.49 306.99 51.65 306.92 51.79C306.84 51.91 306.78 52.05 306.73 52.18C306.65 52.36 306.52 52.5201 306.36 52.6301L306.32 52.66V52.72C306.34 52.83 306.34 52.94 306.32 53.05C306.42 53.05 306.51 53.1 306.59 53.16C306.64 53.2 306.68 53.25 306.71 53.3C306.82 53.25 306.95 53.2101 307.07 53.2001C307.1 53.2001 307.13 53.2001 307.16 53.1901C307.39 53.1101 307.65 53.1601 307.84 53.3201C307.97 53.4501 308.03 53.6401 307.97 53.8201C307.91 53.9701 307.82 54.11 307.72 54.24C307.66 54.31 307.61 54.38 307.56 54.46C307.49 54.58 307.35 54.67 307.21 54.68C307.07 54.69 306.92 54.63 306.83 54.52C306.81 54.49 306.79 54.4701 306.77 54.4401C306.67 54.5201 306.56 54.59 306.45 54.65C306.42 54.73 306.37 54.79 306.3 54.85C306.17 54.96 306.05 55.07 305.93 55.1901C305.93 55.2101 305.93 55.23 305.93 55.25C305.98 55.25 306.02 55.26 306.06 55.28C306.2 55.33 306.32 55.4301 306.4 55.5701C306.53 55.6601 306.6 55.8001 306.6 55.9501C306.6 56.1001 306.53 56.25 306.4 56.33C306.35 56.44 306.26 56.5201 306.15 56.5701C306.12 56.7201 306.06 56.86 305.97 56.99C306.09 57.1 306.16 57.25 306.17 57.41C306.17 57.47 306.2 57.52 306.22 57.58C306.3 57.76 306.34 57.96 306.32 58.16C306.3 58.32 306.19 58.46 306.04 58.52C305.89 58.58 305.72 58.56 305.59 58.46C305.53 58.43 305.47 58.41 305.41 58.4H305.39C305.39 58.46 305.4 58.52 305.4 58.59C305.4 58.83 305.36 59.06 305.28 59.29C305.31 59.31 305.33 59.32 305.36 59.35C305.5 59.48 305.55 59.69 305.48 59.87V59.91C305.51 59.99 305.53 60.09 305.52 60.18L305.57 60.09ZM301.21 52.48V52.5C301.21 52.5 301.27 52.56 301.3 52.59C301.45 52.72 301.56 52.89 301.62 53.08C301.63 53.13 301.64 53.18 301.64 53.23C301.68 53.23 301.72 53.22 301.75 53.21C301.77 53.21 301.79 53.21 301.81 53.21L301.88 53.11C301.92 53.06 301.95 53.01 301.99 52.96C301.91 52.92 301.85 52.87 301.8 52.8C301.76 52.74 301.74 52.67 301.73 52.6C301.55 52.69 301.34 52.6501 301.21 52.5101V52.48ZM299.61 53.15C299.61 53.15 299.68 53.18 299.71 53.1901L299.77 53.21C299.77 53.21 299.79 53.12 299.81 53.08C299.9 52.88 300.09 52.7301 300.31 52.6901C300.31 52.57 300.36 52.46 300.42 52.37C300.5 52.26 300.62 52.19 300.75 52.17C300.88 52.16 301.02 52.21 301.11 52.31C301.09 52.26 301.08 52.21 301.08 52.16C301.05 52.09 301.04 52.01 301.04 51.9401C301.04 51.6901 301.23 51.48 301.48 51.47C301.53 51.47 301.58 51.47 301.63 51.49C301.71 51.47 301.79 51.46 301.87 51.48C301.82 51.43 301.78 51.37 301.75 51.3C301.75 51.3 301.7 51.27 301.67 51.24C301.55 51.15 301.45 51.04 301.37 50.91C301.35 50.91 301.32 50.91 301.3 50.91C301.17 50.91 301.04 50.85 300.96 50.75C300.87 50.65 300.84 50.5201 300.86 50.3801C300.88 50.2901 300.9 50.1801 300.92 50.0701H300.88C300.77 50.2301 300.62 50.36 300.45 50.43C300.43 50.44 300.41 50.45 300.39 50.47C300.24 50.59 300.05 50.65 299.85 50.65C299.81 50.81 299.69 50.95 299.54 51.02L299.56 51.06C299.62 51.17 299.64 51.29 299.61 51.41C299.58 51.53 299.5 51.6301 299.39 51.6901C299.25 51.76 299.1 51.82 298.95 51.87C298.85 51.9 298.75 51.94 298.65 51.99C298.58 52.03 298.52 52.06 298.46 52.11C298.4 52.15 298.34 52.19 298.26 52.24V52.27C298.28 52.33 298.29 52.4 298.29 52.47C298.31 52.52 298.33 52.56 298.35 52.61C298.42 52.65 298.49 52.7 298.54 52.77C298.67 52.66 298.83 52.6 299 52.58C299.27 52.56 299.51 52.76 299.54 53.02C299.55 53.07 299.57 53.13 299.6 53.17L299.61 53.15ZM302.64 51.68C302.64 51.68 302.69 51.6901 302.71 51.7001C302.73 51.6901 302.75 51.68 302.77 51.67V51.65C302.77 51.65 302.69 51.67 302.64 51.68ZM302.09 51.59C302.09 51.59 302.14 51.65 302.16 51.68C302.21 51.67 302.26 51.66 302.31 51.66C302.24 51.64 302.16 51.62 302.09 51.59ZM303.29 50.75L303.43 51.09H303.46L303.37 50.9401L303.46 51.08C303.46 51.08 303.49 51.0801 303.5 51.0701L303.29 50.75H303.28H303.29ZM297.4 50.71C297.37 50.8 297.36 50.88 297.38 50.97C297.41 51.02 297.46 51.06 297.52 51.08L297.4 50.71ZM303.86 50.5C303.91 50.66 303.9 50.83 303.86 50.98C303.94 50.93 304.04 50.89 304.13 50.87C304.3 50.85 304.48 50.87 304.65 50.93C304.65 50.9 304.67 50.88 304.68 50.85C304.67 50.82 304.66 50.8 304.65 50.77C304.63 50.64 304.65 50.51 304.73 50.4C304.75 50.38 304.77 50.35 304.79 50.33C304.81 50.15 304.92 50 305.08 49.92C305.2 49.86 305.33 49.86 305.45 49.91C305.57 49.96 305.66 50.06 305.7 50.18C305.79 50.14 305.89 50.12 305.98 50.14H306C306 50.14 305.97 50.08 305.95 50.05C305.88 49.96 305.84 49.85 305.85 49.73C305.71 49.74 305.41 49.72 305.34 49.24V49.16C305.27 48.92 305.41 48.67 305.65 48.6C305.81 48.57 305.97 48.56 306.12 48.58C306.18 48.58 306.24 48.58 306.3 48.58C306.45 48.56 306.6 48.6001 306.71 48.7001L306.76 48.6301C306.76 48.6301 306.73 48.57 306.72 48.55L306.66 48.42C306.54 48.17 306.58 47.88 306.78 47.68V47.64C306.8 47.42 306.9 47.22 307.08 47.08L307.16 47.03C307.26 46.96 307.36 46.89 307.46 46.83C307.57 46.76 307.7 46.74 307.83 46.77C308.05 46.87 308.24 47.03 308.36 47.23C308.44 47.41 308.48 47.6 308.48 47.8L308.63 47.7001C308.75 47.6201 308.9 47.6 309.04 47.65C309.06 47.65 309.09 47.67 309.11 47.68C309.07 47.46 309.13 47.2401 309.28 47.0701C309.44 46.9201 309.61 46.8001 309.8 46.6901C309.86 46.66 309.92 46.63 309.98 46.6C310 46.57 310.01 46.53 310.03 46.5C309.8 46.4 309.64 46.2 309.59 45.96C309.58 45.6 309.67 45.24 309.86 44.9401C309.89 44.8901 309.93 44.84 309.96 44.8C310.02 44.71 310.03 44.7 310.03 44.68C310.05 44.56 310.08 44.44 310.14 44.33C310.15 44.3 310.17 44.27 310.18 44.24L310.16 44.18C310.09 44.02 310.03 43.85 310.01 43.68C310.01 43.69 309.96 43.62 309.93 43.58C309.81 43.44 309.73 43.28 309.69 43.1C309.66 42.94 309.72 42.79 309.84 42.68C309.9 42.63 309.96 42.59 310.03 42.56C310.03 42.46 310.02 42.36 310 42.27C309.98 42.08 310 41.89 310.08 41.72C310.1 41.68 310.11 41.63 310.12 41.59C310.12 41.59 310.08 41.51 310.06 41.46C309.97 41.3 309.92 41.1301 309.91 40.9501V40.81C309.9 40.63 309.91 40.4401 309.92 40.2601C309.94 40.0901 309.99 39.93 310.06 39.78C310.09 39.72 310.11 39.65 310.13 39.59C310.13 39.59 310.11 39.51 310.09 39.46C310.05 39.32 310.02 39.18 310.02 39.03C309.89 39 309.79 38.91 309.73 38.79C309.67 38.67 309.67 38.53 309.73 38.41C309.81 38.2 309.99 38.0501 310.2 38.0101C310.22 38.0101 310.25 37.99 310.28 37.97C310.32 37.95 310.37 37.93 310.42 37.91C310.45 37.89 310.48 37.88 310.51 37.87C310.52 37.69 310.59 37.51 310.71 37.37C310.72 37.35 310.74 37.33 310.75 37.31C310.74 37.16 310.75 37 310.79 36.85C310.82 36.73 310.88 36.63 310.95 36.54C310.89 36.48 310.83 36.41 310.78 36.34C310.68 36.17 310.65 35.97 310.71 35.78C310.71 35.77 310.71 35.75 310.71 35.74C310.7 35.72 310.69 35.7 310.68 35.68C310.58 35.5 310.55 35.3 310.59 35.1C310.64 34.94 310.73 34.79 310.85 34.68C310.87 34.66 310.89 34.64 310.91 34.61C310.93 34.55 310.97 34.47 311.01 34.4C311.03 34.36 311.05 34.32 311.07 34.28L311.05 34.24C310.97 34.12 310.91 33.98 310.89 33.84C310.87 33.71 310.85 33.59 310.83 33.46L310.79 33.24C310.77 33.13 310.74 33.03 310.71 32.93C310.68 32.85 310.66 32.76 310.64 32.68C310.61 32.57 310.57 32.46 310.52 32.36C310.49 32.3 310.46 32.23 310.44 32.17C310.39 32.03 310.36 31.88 310.36 31.74C310.36 31.7 310.36 31.65 310.35 31.61L310.28 31.52C310.13 31.35 310.03 31.15 309.97 30.93C309.93 30.68 310.02 30.42 310.19 30.23C310.21 30.2 310.24 30.17 310.25 30.14C310.25 30.09 310.26 30 310.27 29.92C310.27 29.9 310.27 29.88 310.27 29.86C310.15 29.83 310.04 29.7701 309.94 29.6901C309.84 29.6001 309.79 29.46 309.8 29.33C309.81 29.2 309.88 29.07 309.99 28.99C310.01 28.98 310.02 28.97 310.04 28.96C310.06 28.89 310.09 28.81 310.12 28.74C310.13 28.71 310.14 28.69 310.15 28.66V28.6301C310.04 28.4601 310.01 28.2601 310.04 28.0701C310.07 27.9201 310.14 27.78 310.23 27.66C310.09 27.49 310 27.28 309.98 27.06C309.98 26.91 310.01 26.77 310.08 26.64C309.87 26.6 309.68 26.48 309.56 26.29C309.54 26.26 309.52 26.2301 309.5 26.1901C309.4 26.3101 309.28 26.42 309.15 26.5C309.11 26.53 309.06 26.56 309.03 26.59C308.89 26.69 308.73 26.75 308.56 26.77C308.52 26.77 308.48 26.78 308.44 26.8C308.39 26.83 308.35 26.86 308.3 26.89C308.18 26.98 308.05 27.05 307.92 27.09C307.8 27.13 307.69 27.16 307.57 27.18C307.57 27.23 307.55 27.2801 307.53 27.3201C307.48 27.4401 307.38 27.5301 307.25 27.5701C307.11 27.6101 306.96 27.5901 306.84 27.5101C306.82 27.5001 306.81 27.48 306.79 27.47C306.63 27.46 306.48 27.37 306.39 27.23C306.33 27.14 306.31 27.02 306.33 26.91C306.29 26.92 306.24 26.9401 306.19 26.9501C306.17 27.0501 306.14 27.16 306.1 27.25C306.1 27.25 306.12 27.29 306.13 27.31C306.18 27.43 306.18 27.56 306.13 27.68C306.13 27.93 305.98 28.15 305.77 28.27C305.59 28.35 305.38 28.36 305.2 28.29C305.2 28.32 305.2 28.36 305.2 28.39C305.21 28.6 305.23 29 304.88 29.15C304.62 29.23 304.34 29.13 304.19 28.91L304.45 28.53L304.12 28.84C304.04 28.75 303.96 28.67 303.86 28.59C303.78 28.57 303.7 28.56 303.63 28.56C303.57 28.73 303.48 28.87 303.35 28.99C303.34 29 303.33 29.02 303.32 29.03C303.28 29.09 303.24 29.1501 303.19 29.2001C303.17 29.3201 303.11 29.42 303.01 29.49C303.02 29.52 303.04 29.5401 303.05 29.5701C303.1 29.6001 303.15 29.6501 303.2 29.6901C303.33 29.7401 303.42 29.84 303.46 29.97C303.55 29.93 303.64 29.89 303.73 29.87C303.85 29.82 303.98 29.82 304.1 29.87C304.22 29.91 304.31 30 304.36 30.12C304.43 30.34 304.41 30.57 304.3 30.77C304.2 30.9 304.05 30.97 303.89 30.96C303.81 30.96 303.73 30.92 303.66 30.87H303.64C303.49 30.85 303.35 30.78 303.26 30.65C303.24 30.67 303.22 30.7 303.2 30.72C303.15 30.77 303.08 30.82 303.01 30.84C303.06 30.9 303.1 30.97 303.14 31.04C303.21 31.04 303.29 31.04 303.36 31.06C303.51 31.1 303.65 31.17 303.77 31.27C303.8 31.3 303.84 31.32 303.88 31.34C304.04 31.4 304.16 31.56 304.16 31.73C304.16 31.91 304.07 32.07 303.92 32.15C303.82 32.21 303.71 32.26 303.6 32.3C303.64 32.32 303.69 32.3501 303.72 32.3801C303.92 32.6101 304.04 32.8901 304.09 33.1901C304.11 33.3101 304.13 33.43 304.14 33.55C304.15 33.64 304.16 33.7401 304.18 33.8201C304.19 33.8901 304.2 33.96 304.2 34.03C304.33 34.01 304.46 34.04 304.56 34.12C304.59 34.12 304.62 34.12 304.66 34.12C304.79 34.1 304.93 34.1 305.06 34.1C305.16 34.1 305.25 34.1 305.34 34.1C305.36 34.03 305.4 33.96 305.44 33.89C305.46 33.8 305.51 33.71 305.59 33.65C305.68 33.58 305.79 33.54 305.9 33.54C305.95 33.54 306 33.54 306.04 33.54C306.18 33.56 306.31 33.6401 306.38 33.7601C306.45 33.8801 306.46 34.04 306.4 34.17C306.36 34.26 306.3 34.34 306.24 34.42C306.29 34.55 306.33 34.6801 306.34 34.8201C306.34 34.8401 306.34 34.87 306.35 34.89C306.44 35.06 306.45 35.26 306.37 35.43C306.3 35.57 306.16 35.67 306.01 35.71C305.94 35.83 305.85 35.9301 305.73 36.0101C305.69 36.0601 305.64 36.1 305.59 36.14C305.57 36.17 305.55 36.2 305.52 36.23C305.47 36.28 305.42 36.33 305.38 36.39C305.38 36.43 305.38 36.4701 305.38 36.5101C305.42 36.6101 305.44 36.7101 305.43 36.8201C305.45 36.9401 305.45 37.06 305.43 37.18C305.43 37.21 305.43 37.2301 305.43 37.2601C305.43 37.2401 305.49 37.29 305.53 37.33C305.6 37.39 305.66 37.45 305.72 37.52C305.76 37.57 305.77 37.58 305.91 37.61C306.27 37.68 306.3 38.04 306.32 38.28C306.32 38.33 306.32 38.39 306.33 38.42C306.35 38.54 306.33 38.67 306.25 38.77C306.22 38.81 306.19 38.84 306.15 38.87C306.18 38.92 306.19 38.98 306.2 39.04C306.2 39.07 306.2 39.09 306.2 39.12C306.2 39.17 306.2 39.23 306.18 39.28C306.22 39.53 306.08 39.78 305.84 39.87C305.76 39.9 305.68 39.91 305.6 39.89C305.48 40 305.35 40.09 305.2 40.14C305.32 40.24 305.41 40.37 305.47 40.52C305.49 40.54 305.51 40.56 305.54 40.58C305.74 40.71 305.87 40.92 305.91 41.15C305.91 41.37 305.82 41.58 305.67 41.74L305.64 41.78C305.67 41.88 305.72 41.98 305.77 42.08C305.85 42.21 305.87 42.37 305.82 42.52C305.79 42.61 305.74 42.68 305.68 42.74L305.72 42.79C305.86 42.99 305.9 43.24 305.83 43.47C305.76 43.71 305.58 43.9 305.35 43.99C305.21 44.04 305.05 44.04 304.91 43.99C304.91 44.02 304.93 44.06 304.94 44.09C304.99 44.24 305.02 44.4 305.02 44.56C305.02 44.77 304.97 44.99 304.91 45.1901C304.84 45.43 304.74 45.66 304.6 45.86C304.6 45.86 304.6 45.9001 304.6 45.9501C304.6 46.1901 304.52 46.41 304.36 46.59C304.22 46.71 304.07 46.79 303.89 46.84C303.83 46.86 303.78 46.88 303.72 46.91C303.67 46.94 303.62 46.98 303.58 47.02C303.46 47.13 303.33 47.22 303.18 47.29H303.15C303.11 47.83 302.57 47.95 302.37 48C302.33 48 302.29 48.02 302.25 48.03C302.25 48.03 302.21 48.1301 302.18 48.1901C302.16 48.24 302.14 48.29 302.11 48.33C302.22 48.4 302.3 48.52 302.32 48.65C302.34 48.78 302.3 48.9101 302.21 49.0101C302.18 49.0601 302.16 49.11 302.15 49.16C302.14 49.2 302.12 49.23 302.11 49.27C302.12 49.31 302.13 49.35 302.15 49.39C302.16 49.45 302.18 49.51 302.21 49.56C302.26 49.66 302.32 49.75 302.38 49.84C302.41 49.89 302.44 49.94 302.47 49.99C302.5 49.99 302.53 49.99 302.56 50C302.64 50 302.72 50.02 302.8 50.04C302.8 49.95 302.83 49.87 302.86 49.79C302.93 49.63 303.09 49.52 303.27 49.52C303.39 49.52 303.51 49.57 303.6 49.66C303.76 49.7 303.9 49.8001 303.98 49.9501C304.04 50.1001 304.01 50.28 303.9 50.4L303.87 50.43L303.86 50.5ZM298.18 50.08C298.23 50.04 298.29 50 298.34 49.96C298.32 49.96 298.3 49.96 298.28 49.96C298.25 50 298.22 50.0301 298.19 50.0701L298.18 50.08ZM299.84 49.5C299.84 49.5 299.84 49.56 299.86 49.58C299.86 49.59 299.91 49.64 299.95 49.67H299.97C299.97 49.67 299.94 49.63 299.93 49.61C299.9 49.57 299.87 49.54 299.85 49.5H299.84ZM287.36 38.54C287.45 38.54 287.54 38.55 287.63 38.58C287.82 38.63 287.98 38.76 288.07 38.93C288.11 38.79 288.21 38.67 288.35 38.61C288.17 38.64 287.99 38.63 287.83 38.56C287.69 38.5 287.6 38.37 287.57 38.22C287.55 38.07 287.61 37.9201 287.72 37.8201C287.73 37.8101 287.76 37.77 287.78 37.74C287.83 37.67 287.88 37.61 287.94 37.55L287.92 37.48C287.82 37.24 287.84 36.96 287.97 36.74C288.11 36.54 288.33 36.42 288.57 36.41C288.62 36.41 288.66 36.41 288.7 36.41C288.7 36.39 288.71 36.37 288.72 36.34C288.76 36.16 288.86 36 288.99 35.87C289.02 35.84 289.04 35.81 289.06 35.78C289.16 35.42 289.44 35.14 289.8 35.05C290.07 34.98 290.35 34.98 290.62 35.05V35C290.65 34.83 290.74 34.67 290.88 34.56C290.73 34.43 290.63 34.26 290.59 34.06C290.57 33.92 290.57 33.78 290.6 33.64C290.57 33.61 290.54 33.57 290.52 33.53C290.53 33.56 290.49 33.53 290.46 33.52C290.28 33.44 290.14 33.29 290.08 33.11C290.08 33.08 290.06 33.0401 290.06 33.0101C289.97 33.0001 289.89 32.96 289.83 32.9C289.75 32.82 289.69 32.71 289.69 32.59C289.57 32.44 289.54 32.24 289.6 32.06C289.64 31.95 289.73 31.86 289.84 31.81C289.95 31.76 290.08 31.76 290.19 31.81L290.52 31.96C290.52 31.96 290.6 32 290.64 32.04C290.69 32.01 290.74 31.9801 290.78 31.9501C290.83 31.9201 290.89 31.89 290.95 31.85C291.02 31.81 291.1 31.7801 291.18 31.7601C291.36 31.6201 291.59 31.55 291.82 31.56H291.91C292.19 31.52 292.46 31.6 292.68 31.78C292.72 31.82 292.76 31.86 292.8 31.91C292.84 31.87 292.88 31.83 292.92 31.79C292.91 31.76 292.9 31.7301 292.89 31.7001C292.88 31.6701 292.87 31.64 292.86 31.61C292.74 31.65 292.61 31.6301 292.5 31.5701C292.39 31.5101 292.31 31.4 292.29 31.27L292.27 31.23C292.16 31.05 292.15 30.8301 292.23 30.6301C292.26 30.5301 292.29 30.4201 292.3 30.3201C292.33 30.1501 292.38 30 292.47 29.85H292.44C292.35 29.84 292.27 29.8 292.2 29.74C292.05 29.73 291.91 29.6401 291.83 29.5101C291.75 29.3801 291.75 29.2101 291.82 29.0701C291.93 28.9001 292.09 28.79 292.29 28.75C292.41 28.7 292.55 28.69 292.67 28.75C292.79 28.8 292.89 28.8901 292.94 29.0101C292.98 29.1501 292.99 29.3001 292.95 29.4501C293.04 29.4501 293.13 29.46 293.2 29.5C293.33 29.57 293.42 29.71 293.44 29.86C293.46 30.04 293.42 30.21 293.34 30.37C293.34 30.55 293.3 30.73 293.23 30.89C293.23 30.91 293.22 30.92 293.21 30.93C293.35 30.91 293.5 30.92 293.64 30.96C293.67 30.96 293.7 30.97 293.73 30.98C293.87 30.97 294.02 30.98 294.15 31.04C294.18 31.05 294.21 31.06 294.24 31.06C294.49 31.06 294.71 31.2201 294.79 31.4501C294.83 31.5601 294.82 31.69 294.77 31.8C294.72 31.91 294.62 31.99 294.5 32.03C294.47 32.04 294.44 32.05 294.41 32.06C294.46 32.1 294.51 32.15 294.54 32.21C294.6 32.21 294.67 32.2001 294.72 32.1901H294.77C294.87 32.1201 294.97 32.06 295.09 32.03C294.98 31.86 294.94 31.6501 294.98 31.4501C294.98 31.3901 294.99 31.3201 294.99 31.2601C294.99 31.1201 295 30.99 295.03 30.86C295.07 30.72 295.12 30.59 295.19 30.47C295.22 30.42 295.25 30.36 295.27 30.3C295.34 30.11 295.45 29.9401 295.61 29.8201C295.64 29.8001 295.66 29.77 295.69 29.74C295.69 29.71 295.71 29.6401 295.73 29.5701C295.7 29.5701 295.67 29.5701 295.64 29.5701C295.6 29.5701 295.54 29.5701 295.49 29.5701C295.46 29.5701 295.43 29.5701 295.4 29.5701C295.17 29.5701 294.98 29.4 294.95 29.18C294.92 29.11 294.91 29.04 294.91 28.96C294.91 28.78 295.01 28.61 295.18 28.54C295.34 28.47 295.54 28.5 295.67 28.62C295.83 28.66 295.97 28.77 296.05 28.91C296.06 28.93 296.07 28.96 296.08 28.99C296.21 28.89 296.35 28.8201 296.49 28.7601C296.61 28.7201 296.74 28.74 296.84 28.8C296.95 28.86 297.03 28.96 297.06 29.08C297.09 29.24 297.06 29.41 296.98 29.55C297.1 29.66 297.2 29.8 297.27 29.96L297.31 30.06C297.37 30.21 297.43 30.37 297.47 30.52C297.49 30.57 297.52 30.61 297.56 30.65C297.66 30.77 297.73 30.9 297.78 31.05C297.81 31.14 297.83 31.2301 297.86 31.3201C297.88 31.3801 297.9 31.44 297.91 31.5C297.97 31.52 298.02 31.5501 298.07 31.5701C298.12 31.6001 298.17 31.62 298.23 31.64C298.26 31.62 298.29 31.6 298.33 31.58C298.48 31.49 298.64 31.43 298.81 31.41C298.94 31.41 299.07 31.41 299.2 31.42C299.28 31.43 299.35 31.43 299.43 31.43C299.61 31.43 299.8 31.46 299.97 31.53C299.99 31.53 300.01 31.55 300.04 31.56C300.07 31.54 300.09 31.51 300.12 31.49C300.2 31.41 300.28 31.34 300.37 31.28C300.37 31.22 300.37 31.16 300.36 31.1C300.36 30.99 300.35 30.89 300.34 30.83C300.32 30.77 300.32 30.71 300.33 30.64C300.15 30.55 300.05 30.36 300.08 30.16C300.1 30.04 300.14 29.93 300.19 29.83C300.02 29.67 299.92 29.46 299.9 29.23V29.1901C299.85 29.1101 299.81 29.0301 299.8 28.9401C299.75 28.8401 299.75 28.72 299.78 28.62C299.74 28.46 299.75 28.29 299.79 28.14C299.81 28.08 299.83 28.0101 299.84 27.9401C299.84 27.9201 299.84 27.9001 299.85 27.8801C299.8 27.7501 299.78 27.6 299.78 27.46C299.78 27.43 299.78 27.4 299.78 27.37C299.75 27.37 299.71 27.39 299.68 27.4C299.57 27.44 299.45 27.47 299.34 27.48C299.27 27.48 299.19 27.48 299.12 27.47C299.12 27.63 299.06 27.7801 298.93 27.8801C298.86 27.9301 298.77 27.96 298.69 27.96H298.66C298.53 28.05 298.36 28.06 298.22 28C298.18 28.17 298.03 28.29 297.86 28.31C297.64 28.31 297.44 28.19 297.35 27.99C297.29 27.93 297.22 27.8701 297.15 27.8201C297.05 27.7501 296.96 27.67 296.87 27.59C296.8 27.53 296.72 27.47 296.64 27.41C296.6 27.38 296.56 27.3501 296.51 27.3201C296.46 27.4401 296.37 27.54 296.25 27.59C296.12 27.65 295.97 27.66 295.82 27.64C295.71 27.69 295.58 27.68 295.47 27.62C295.48 27.62 295.45 27.63 295.42 27.64C295.28 27.66 295.14 27.64 295 27.59C294.97 27.58 294.94 27.56 294.91 27.54C294.77 27.64 294.62 27.71 294.46 27.77C294.41 27.79 294.36 27.81 294.31 27.83C294.26 27.86 294.21 27.89 294.16 27.93C293.99 28.06 293.79 28.1501 293.58 28.2001C293.34 28.2301 293.1 28.15 292.91 28C292.88 27.98 292.83 27.95 292.8 27.93C292.71 27.93 292.61 27.95 292.52 27.96C292.4 27.97 292.28 27.98 292.16 27.99C292.05 27.99 291.95 28.03 291.86 28.09C291.75 28.26 291.58 28.39 291.39 28.46C291.32 28.5 291.24 28.53 291.17 28.55C291.17 28.59 291.17 28.63 291.17 28.66C291.28 28.82 291.28 29.0401 291.16 29.1901C291.04 29.3501 290.84 29.41 290.65 29.36C290.6 29.34 290.54 29.3301 290.48 29.3201H290.45C290.45 29.3201 290.45 29.41 290.45 29.47C290.54 29.48 290.62 29.52 290.69 29.58C290.78 29.59 290.86 29.6101 290.94 29.6301H290.99C291.05 29.6301 291.11 29.63 291.17 29.65C291.2 29.65 291.23 29.66 291.26 29.68C291.4 29.71 291.52 29.8 291.58 29.93C291.64 30.06 291.63 30.21 291.56 30.34C291.47 30.49 291.32 30.58 291.15 30.59C291.1 30.59 291.04 30.59 291 30.56C290.98 30.56 290.96 30.58 290.95 30.58C290.76 30.67 290.55 30.7 290.35 30.67C290.2 30.64 290.09 30.53 290.03 30.39C289.97 30.39 289.91 30.39 289.85 30.37V30.46C289.83 30.61 289.81 30.76 289.79 30.91C289.75 31.09 289.7 31.2701 289.63 31.4501C289.56 31.6101 289.41 31.71 289.24 31.72C289.18 31.72 289.11 31.7201 289.05 31.6901C288.86 31.8201 288.65 31.91 288.44 31.99C288.23 32.04 288.01 32.0201 287.81 31.9401C287.77 31.9201 287.72 31.91 287.68 31.9C287.63 31.9 287.59 31.92 287.54 31.93C287.61 32.08 287.59 32.26 287.49 32.39C287.45 32.5 287.37 32.59 287.28 32.64C287.09 32.74 286.85 32.7101 286.68 32.5701C286.66 32.5601 286.63 32.54 286.6 32.52C286.56 32.54 286.5 32.58 286.46 32.61L286.34 32.68C286.21 32.75 286.06 32.8001 285.91 32.8201C285.85 32.8201 285.8 32.84 285.75 32.86V32.8801C285.75 32.8801 285.84 32.91 285.88 32.93C285.91 32.95 285.93 32.96 285.95 32.98C286.11 32.99 286.26 33.08 286.35 33.21C286.43 33.33 286.45 33.48 286.39 33.62C286.34 33.76 286.22 33.86 286.08 33.89C285.91 33.98 285.71 34.01 285.52 33.98C285.52 33.99 285.5 34.01 285.49 34.02C285.39 34.15 285.28 34.2701 285.16 34.3801C285.17 34.3801 285.19 34.39 285.2 34.4C285.3 34.32 285.41 34.25 285.53 34.21C285.81 34.11 286.12 34.09 286.41 34.17C286.63 34.25 286.78 34.44 286.81 34.66C286.81 34.68 286.81 34.69 286.81 34.68C286.88 34.79 286.9 34.92 286.87 35.04C286.84 35.16 286.76 35.2701 286.65 35.3201C286.54 35.3801 286.41 35.4001 286.28 35.3801C286.15 35.5301 285.96 35.6201 285.77 35.6301C285.65 35.6301 285.53 35.61 285.41 35.58H285.36C285.23 35.76 285.01 35.86 284.79 35.84C284.81 35.91 284.84 35.97 284.87 36.02C285 36.2 285.01 36.4401 284.9 36.6301C284.79 36.7801 284.61 36.87 284.43 36.85C284.55 36.98 284.61 37.17 284.58 37.35C284.52 37.57 284.34 37.75 284.11 37.8C284.09 37.8 284.06 37.82 284.04 37.83V37.85C284.04 37.85 284.12 37.95 284.16 38C284.35 37.85 284.61 37.8 284.84 37.86C284.98 37.9 285.11 37.95 285.22 38.03C285.27 38.06 285.32 38.09 285.38 38.1C285.57 38.15 285.73 38.27 285.85 38.42C286.04 38.26 286.31 38.2 286.55 38.27C286.74 38.32 286.9 38.43 287.02 38.58L287.08 38.62C287.19 38.59 287.29 38.5701 287.4 38.5701L287.36 38.54ZM302.11 31.22C302.11 31.22 302.11 31.28 302.11 31.3C302.11 31.4 302.13 31.5 302.15 31.59H302.19C302.21 31.53 302.24 31.47 302.26 31.42L302.23 31.39C302.18 31.34 302.14 31.28 302.1 31.22H302.11ZM301.71 30.62L302.15 30.71L301.71 30.62ZM303.55 30.29C303.55 30.29 303.49 30.3901 303.48 30.4501L303.62 30.41V30.36L303.55 30.29ZM290.29 29.31C290.29 29.31 290.34 29.38 290.35 29.41C290.35 29.41 290.31 29.34 290.28 29.31H290.29ZM302.68 28.31C302.68 28.31 302.72 28.35 302.74 28.37C302.76 28.34 302.77 28.31 302.78 28.27C302.78 28.25 302.8 28.2301 302.81 28.2001C302.77 28.2401 302.72 28.28 302.68 28.31ZM301.01 27.48C300.96 27.55 300.93 27.64 300.94 27.73C300.94 27.64 300.96 27.55 301.01 27.48ZM307.73 59.43C307.49 59.43 307.29 59.24 307.28 58.99C307.28 58.89 307.28 58.78 307.31 58.68C307.31 58.63 307.33 58.58 307.33 58.52C307.33 58.38 307.39 58.24 307.51 58.15C307.63 58.06 307.78 58.04 307.91 58.08C307.99 58.1 308.07 58.1401 308.13 58.2001C308.24 58.2701 308.32 58.3801 308.35 58.5101C308.38 58.6401 308.35 58.7701 308.26 58.8801C308.23 59.0401 308.15 59.2 308.03 59.31C307.95 59.38 307.84 59.42 307.73 59.42V59.43ZM308.38 37.2601C308.3 37.2601 308.22 37.2401 308.15 37.1901C307.97 37.0801 307.83 36.92 307.75 36.72C307.7 36.56 307.74 36.39 307.84 36.27C307.88 36.19 307.95 36.1101 308.03 36.0701C308.18 35.9301 308.4 35.89 308.59 35.97C308.78 36.04 308.91 36.22 308.93 36.42C308.93 36.55 308.9 36.69 308.85 36.81C308.84 36.84 308.83 36.87 308.82 36.9C308.79 37.04 308.69 37.16 308.56 37.22C308.5 37.24 308.44 37.2601 308.38 37.2601ZM304.98 34.09C304.87 34.09 304.76 34.05 304.67 33.98C304.54 33.94 304.44 33.84 304.4 33.71C304.36 33.58 304.37 33.44 304.43 33.33C304.46 33.28 304.49 33.2301 304.53 33.1901C304.6 33.0701 304.72 32.99 304.86 32.98C305 32.97 305.14 33.0301 305.23 33.1301C305.27 33.1801 305.31 33.24 305.35 33.3C305.44 33.4 305.49 33.54 305.47 33.68C305.45 33.82 305.37 33.9401 305.25 34.0101C305.17 34.0601 305.07 34.08 304.98 34.08V34.09ZM306.22 32.96C306.12 32.96 306.03 32.9301 305.95 32.8801C305.78 32.7501 305.62 32.61 305.47 32.46L305.33 32.33C305.21 32.22 305.16 32.0401 305.21 31.8801C305.26 31.7201 305.39 31.6 305.55 31.56C305.52 31.56 305.55 31.55 305.58 31.53C305.47 31.44 305.4 31.31 305.4 31.17C305.4 31.05 305.43 30.93 305.52 30.84C305.6 30.75 305.72 30.7001 305.84 30.6901C306.11 30.6601 306.33 30.63 306.5 30.81C306.66 31 306.69 31.26 306.58 31.48C306.57 31.51 306.56 31.5401 306.54 31.5701C306.57 31.6001 306.6 31.62 306.63 31.65C306.67 31.69 306.71 31.72 306.76 31.75C306.95 31.82 307.07 32.02 307.04 32.22C307.02 32.35 306.96 32.47 306.85 32.55C306.81 32.58 306.76 32.61 306.71 32.62V32.64C306.62 32.8 306.48 32.92 306.31 32.97C306.28 32.97 306.25 32.98 306.22 32.98V32.96ZM305.74 31.27C305.74 31.27 305.78 31.36 305.81 31.4H305.84V31.3L305.74 31.27ZM298.83 31.23C298.71 31.23 298.59 31.19 298.5 31.11C298.39 31 298.31 30.86 298.25 30.72C298.23 30.68 298.21 30.63 298.19 30.59C298.04 30.39 298.03 30.11 298.16 29.9C298.18 29.87 298.21 29.8401 298.23 29.8201C298.1 29.7901 297.98 29.73 297.88 29.64C297.78 29.55 297.73 29.42 297.73 29.29C297.73 29.16 297.8 29.0301 297.9 28.9501L298.43 28.54C298.62 28.39 298.91 28.42 299.06 28.61C299.14 28.71 299.2 28.8301 299.25 28.9501C299.26 28.9801 299.27 29 299.28 29.02C299.36 29.12 299.39 29.24 299.37 29.37C299.35 29.49 299.27 29.6 299.16 29.67C299.05 29.74 298.93 29.78 298.8 29.8C298.88 29.84 298.97 29.8901 299.06 29.9401C299.15 29.9901 299.24 30.04 299.33 30.09C299.45 30.15 299.54 30.26 299.57 30.4C299.6 30.53 299.57 30.67 299.48 30.78C299.4 30.87 299.31 30.96 299.22 31.03C299.2 31.05 299.17 31.07 299.16 31.08C299.07 31.17 298.96 31.22 298.83 31.23ZM306.75 29.6C306.45 29.56 306.19 29.4 306.03 29.14C306.02 28.91 306.12 28.69 306.3 28.55C306.42 28.4 306.61 28.33 306.8 28.35C306.98 28.39 307.14 28.5201 307.21 28.6901C307.37 28.8401 307.4 29.07 307.29 29.25C307.24 29.34 307.15 29.42 307.06 29.46C306.98 29.54 306.87 29.59 306.75 29.59V29.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.089 46.74C308.089 46.79 308.109 46.9 308.099 46.96C308.079 46.92 308.159 46.81 308.149 46.77C308.149 46.76 308.059 46.76 308.089 46.74Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.099 47.41C307.919 47.41 307.749 47.3 307.679 47.13C307.649 47.06 307.639 46.99 307.649 46.92C307.649 46.89 307.649 46.86 307.649 46.84C307.619 46.65 307.699 46.47 307.849 46.37C307.989 46.28 308.169 46.28 308.319 46.37L308.349 46.3899C308.479 46.4599 308.569 46.57 308.599 46.71C308.619 46.82 308.599 46.93 308.549 47.03C308.519 47.23 308.369 47.38 308.179 47.41C308.159 47.41 308.129 47.41 308.109 47.41H308.099ZM308.199 46.92L308.329 47.12L308.199 46.92Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.999 27.3401C305.999 27.3401 305.929 27.2901 305.899 27.3101C305.899 27.2901 305.959 27.4001 305.969 27.3901C305.979 27.3801 305.969 27.3501 305.999 27.3501V27.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.969 27.8301H305.949C305.809 27.8101 305.679 27.7401 305.589 27.6301C305.459 27.5101 305.419 27.3201 305.479 27.1501C305.539 26.9901 305.679 26.8801 305.849 26.8601C305.899 26.8601 305.949 26.8601 305.999 26.8701C306.039 26.8701 306.079 26.8901 306.109 26.9001C306.259 26.9601 306.369 27.0801 306.409 27.2301C306.449 27.3801 306.409 27.5401 306.319 27.6601C306.229 27.7601 306.109 27.8201 305.969 27.8201V27.8301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.709 33.71C304.709 33.71 304.939 33.82 304.949 33.82C304.929 33.84 304.769 33.84 304.749 33.86C304.749 33.84 304.699 33.72 304.709 33.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.739 34.3001C304.519 34.3001 304.339 34.1401 304.299 33.9301C304.199 33.7301 304.259 33.48 304.439 33.34C304.619 33.23 304.849 33.2301 305.019 33.3601L305.079 33.39C305.209 33.44 305.319 33.5401 305.359 33.6801C305.399 33.8101 305.379 33.96 305.299 34.08C305.199 34.21 305.039 34.29 304.879 34.29C304.899 34.29 304.909 34.28 304.919 34.27C304.859 34.3 304.799 34.3101 304.739 34.3101V34.3001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M301.5 31.7001C301.52 31.8001 301.04 31.74 301.03 31.85C301.01 31.76 301.56 31.8 301.55 31.71C301.55 31.66 301.03 32.15 301.02 32.1C301.06 32.14 301.49 31.66 301.5 31.71V31.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M301.01 32.54C300.91 32.54 300.82 32.5001 300.75 32.4401C300.6 32.3201 300.53 32.1201 300.6 31.9401C300.6 31.9001 300.59 31.8501 300.6 31.8001C300.6 31.7001 300.65 31.6 300.72 31.52C300.81 31.43 300.92 31.37 301.04 31.35C301.11 31.33 301.18 31.3201 301.25 31.3201H301.26C301.34 31.2601 301.44 31.2301 301.54 31.2401C301.6 31.2401 301.65 31.25 301.71 31.27C301.86 31.33 301.97 31.4601 302 31.6201C302.02 31.7501 301.99 31.8801 301.91 31.9901C301.85 32.0701 301.76 32.13 301.67 32.16C301.64 32.19 301.61 32.2101 301.57 32.2401C301.44 32.3801 301.27 32.49 301.08 32.54C301.06 32.54 301.04 32.54 301.01 32.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.829 29.3101C295.829 29.3101 295.879 29.2801 295.869 29.3101C295.789 29.2701 295.589 29.1001 295.509 29.0601C295.599 29.0601 295.739 29.3001 295.839 29.3101H295.829Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.869 29.77H295.839C295.759 29.77 295.669 29.75 295.599 29.71C295.509 29.66 295.419 29.5901 295.349 29.5101V29.4901C295.349 29.4901 295.309 29.47 295.299 29.47C295.109 29.38 295.009 29.16 295.059 28.96C295.119 28.75 295.309 28.6101 295.529 28.6301C295.679 28.6401 295.809 28.7101 295.909 28.8101L295.949 28.84C295.949 28.84 296.009 28.88 296.029 28.9C296.079 28.92 296.119 28.95 296.159 28.98C296.299 29.11 296.349 29.3201 296.269 29.5001C296.219 29.6101 296.129 29.7001 296.019 29.7401C295.969 29.7601 295.909 29.77 295.859 29.77H295.869Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.259 28.6399C295.259 28.6399 295.339 28.5299 295.319 28.5299C295.309 28.5199 295.189 28.7 295.179 28.68C295.199 28.71 295.239 28.6199 295.249 28.6399H295.259Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.179 29.1301C295.179 29.1301 295.149 29.1301 295.139 29.1301C294.959 29.1101 294.809 28.9901 294.759 28.8201C294.699 28.6501 294.759 28.47 294.879 28.35C294.959 28.21 295.099 28.11 295.259 28.08C295.449 28.06 295.629 28.1501 295.709 28.3201C295.799 28.4901 295.769 28.69 295.649 28.83C295.629 28.87 295.599 28.9201 295.569 28.9501C295.529 28.9901 295.479 29.0201 295.429 29.0501C295.409 29.0601 295.389 29.08 295.359 29.09C295.309 29.12 295.259 29.1301 295.199 29.1301C295.189 29.1301 295.179 29.1301 295.159 29.1301H295.179Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.319 29.1601C295.319 29.1601 295.329 29.3301 295.319 29.3701C295.289 29.3401 295.129 29.1401 295.099 29.1101C295.139 29.0601 295.249 29.1601 295.319 29.1601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.319 29.8201C295.209 29.8201 295.099 29.7801 295.019 29.7001C294.999 29.6801 294.929 29.6 294.859 29.52C294.829 29.48 294.799 29.4401 294.779 29.4201C294.629 29.2601 294.619 29.02 294.749 28.84C294.909 28.63 295.199 28.5801 295.419 28.7201C295.649 28.7701 295.809 28.9801 295.779 29.2201C295.789 29.3201 295.779 29.42 295.759 29.52C295.699 29.7 295.529 29.83 295.329 29.83L295.319 29.8201ZM295.329 29.3601V29.4901C295.379 29.4601 295.419 29.4301 295.459 29.3801L295.369 29.3201L295.329 29.3601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M285.589 36.5701C285.589 36.5701 285.589 36.55 285.559 36.58C285.499 36.51 285.429 36.5201 285.369 36.4501C285.449 36.4901 285.499 36.5301 285.589 36.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M285.57 37.03C285.46 37.03 285.35 36.99 285.27 36.91C285.19 36.87 285.11 36.82 285.05 36.75C284.91 36.59 284.9 36.35 285.03 36.18C285.16 36.01 285.39 35.95 285.58 36.05C285.63 36.08 285.67 36.1 285.72 36.13C285.74 36.14 285.77 36.16 285.8 36.17C285.93 36.23 286.02 36.35 286.05 36.49C286.08 36.63 286.03 36.78 285.94 36.88C285.87 36.95 285.78 37 285.68 37.02C285.65 37.02 285.61 37.03 285.58 37.03H285.57Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.129 49.98C299.189 49.95 299.069 50.0301 299.129 50.0001C299.129 50.0001 299.179 50.06 299.209 50.08C299.129 50.09 299.209 49.96 299.129 49.97V49.98Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.209 50.5401C299.099 50.5401 298.989 50.5001 298.899 50.4301C298.869 50.4101 298.849 50.3801 298.829 50.3501C298.799 50.3301 298.779 50.3001 298.759 50.2801C298.619 50.0501 298.679 49.7501 298.899 49.6101C299.099 49.4901 299.359 49.5301 299.509 49.7101C299.529 49.7301 299.539 49.7501 299.549 49.7801C299.549 49.8001 299.569 49.8101 299.569 49.8301C299.659 49.9401 299.689 50.1001 299.639 50.2401C299.589 50.4001 299.449 50.5201 299.289 50.5501C299.259 50.5501 299.239 50.5501 299.209 50.5501V50.5401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M301.119 50.5801C301.119 50.5801 301.069 50.5301 301.049 50.5001C301.139 50.4701 301.329 50.3701 301.419 50.3401C301.349 50.3901 301.189 50.5301 301.119 50.5801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M301.119 51.03H301.089C300.939 51.01 300.809 50.93 300.729 50.81C300.639 50.69 300.609 50.54 300.639 50.39C300.679 50.24 300.789 50.1201 300.929 50.0701C300.959 50.0601 301.009 50.0401 301.059 50.0101C301.139 49.9701 301.219 49.94 301.309 49.91C301.519 49.85 301.739 49.9401 301.829 50.1301C301.919 50.3201 301.879 50.55 301.709 50.69C301.599 50.78 301.449 50.89 301.389 50.94C301.309 50.99 301.219 51.02 301.129 51.02L301.119 51.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.06 51.4301C302.06 51.4301 302.07 51.4401 302.09 51.4301L302.19 51.17C302.23 51.22 302.08 51.4001 302.06 51.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.089 51.8801C301.979 51.8801 301.869 51.84 301.789 51.77C301.649 51.66 301.589 51.4901 301.629 51.3201C301.649 51.2601 301.679 51.19 301.719 51.14C301.749 50.99 301.839 50.86 301.959 50.78C302.149 50.67 302.389 50.7101 302.529 50.8801C302.679 51.0801 302.669 51.37 302.509 51.56C302.479 51.64 302.429 51.72 302.359 51.77C302.279 51.84 302.179 51.87 302.069 51.87L302.089 51.8801ZM301.769 51.28C301.779 51.34 301.809 51.4001 301.849 51.4501L301.949 51.36L301.759 51.28H301.769Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.189 47.0901C308.169 47.0401 308.219 47.1701 308.199 47.1101C308.249 47.1301 308.099 47.0801 308.139 47.1101C308.109 47.1401 308.209 47.0601 308.179 47.0901H308.189Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.219 47.57C308.219 47.57 308.12 47.57 308.08 47.55H308.07C307.97 47.54 307.87 47.49 307.8 47.41C307.7 47.28 307.66 47.11 307.71 46.95C307.74 46.86 307.81 46.79 307.89 46.74C308.02 46.62 308.219 46.59 308.379 46.68C308.439 46.7 308.49 46.74 308.54 46.79C308.65 46.93 308.68 47.1 308.64 47.27C308.62 47.31 308.6 47.35 308.57 47.39C308.52 47.46 308.44 47.52 308.36 47.55C308.32 47.56 308.269 47.57 308.219 47.57Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.419 46.15C308.419 46.15 308.329 46.1201 308.339 46.0701C308.369 46.0901 308.309 46.15 308.339 46.17C308.299 46.19 308.459 46.13 308.419 46.15Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.38 46.6001C308.27 46.6001 308.17 46.5701 308.07 46.5201C308.07 46.5201 308.02 46.4901 308.01 46.4701C307.97 46.4401 307.94 46.3901 307.92 46.3501C307.89 46.2701 307.88 46.1901 307.9 46.1101V46.0801C307.9 46.0801 307.9 46.0001 307.91 45.9701C307.95 45.8201 308.06 45.7101 308.2 45.6601C308.34 45.6101 308.5 45.6401 308.62 45.7301C308.64 45.7501 308.66 45.7701 308.68 45.7901C308.7 45.8101 308.72 45.8301 308.74 45.8501C308.79 45.8901 308.82 45.9401 308.84 45.9901C308.93 46.2201 308.81 46.4801 308.58 46.5701C308.56 46.5701 308.53 46.5901 308.51 46.5901C308.51 46.5901 308.47 46.5901 308.45 46.5901C308.42 46.5901 308.4 46.5901 308.37 46.5901L308.38 46.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.589 51.6399C309.589 51.6399 309.799 51.71 309.809 51.76C309.759 51.74 309.509 51.63 309.469 51.62C309.499 51.59 309.559 51.68 309.589 51.65V51.6399Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.82 52.2099C309.82 52.2099 309.72 52.21 309.68 52.19C309.65 52.19 309.56 52.1399 309.47 52.0999C309.41 52.0699 309.35 52.0499 309.33 52.0399C309.19 51.9899 309.08 51.8599 309.05 51.7199C309.02 51.5699 309.05 51.42 309.16 51.31C309.3 51.19 309.49 51.1499 309.67 51.2099H309.7C309.76 51.2299 309.82 51.2499 309.87 51.2899C310.04 51.3299 310.19 51.46 310.26 51.63C310.31 51.77 310.29 51.9199 310.2 52.0399C310.11 52.1599 309.98 52.23 309.83 52.23L309.82 52.2099Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.539 52.0601C309.519 52.1401 309.589 52.45 309.569 52.53C309.539 52.51 309.219 52.3 309.189 52.28C309.239 52.23 309.489 52.1101 309.529 52.0601H309.539Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.569 52.9801C309.469 52.9801 309.359 52.9401 309.279 52.8801C309.279 52.8801 309.199 52.83 309.129 52.78C309.029 52.71 308.929 52.6501 308.909 52.6301C308.809 52.5501 308.749 52.4401 308.739 52.3201C308.729 52.2001 308.769 52.0801 308.849 51.9801C308.929 51.9001 309.029 51.83 309.139 51.78C309.169 51.76 309.209 51.7401 309.229 51.7301C309.369 51.6001 309.569 51.58 309.739 51.66C309.909 51.75 309.999 51.9201 309.979 52.1101C309.979 52.1401 309.979 52.1901 309.999 52.2301C310.029 52.3701 310.029 52.51 309.999 52.64C309.959 52.79 309.849 52.9001 309.699 52.9501C309.659 52.9601 309.609 52.97 309.559 52.97L309.569 52.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.729 28.27C299.729 28.27 299.799 28.38 299.819 28.4C299.839 28.42 299.719 28.28 299.719 28.28C299.699 28.3 299.759 28.4801 299.739 28.5001C299.749 28.4701 299.729 28.3 299.739 28.27H299.729Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.739 28.9501C299.619 28.9501 299.499 28.9001 299.419 28.8101C299.339 28.7201 299.289 28.6 299.289 28.48C299.229 28.3 299.269 28.11 299.389 27.96C299.409 27.94 299.439 27.91 299.469 27.89C299.569 27.82 299.709 27.7901 299.829 27.8201C299.989 27.8601 300.129 27.98 300.189 28.14C300.329 28.32 300.299 28.57 300.129 28.72C300.109 28.75 300.089 28.7801 300.069 28.8101C299.989 28.9001 299.869 28.9501 299.749 28.9501H299.739Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.64 51.3501C308.64 51.3501 308.64 51.5101 308.61 51.4901C308.64 51.5001 308.59 51.4001 308.61 51.4101C308.63 51.4301 308.51 51.3301 308.54 51.3501C308.51 51.3501 308.67 51.3501 308.64 51.3501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.609 51.9401C308.559 51.9401 308.509 51.9401 308.459 51.9101H308.439C308.219 51.7701 308.089 51.5301 308.089 51.2701C308.089 51.2501 308.089 51.2301 308.109 51.2101C308.129 51.1601 308.149 51.1101 308.189 51.0701C308.279 50.9601 308.419 50.8901 308.559 50.9001H308.579C308.719 50.8801 308.859 50.9301 308.959 51.0401C309.059 51.1401 309.099 51.2901 309.079 51.4301C309.079 51.4501 309.069 51.4701 309.059 51.5001V51.5201C309.049 51.7001 308.939 51.8501 308.769 51.9201C308.719 51.9401 308.659 51.9501 308.609 51.9501V51.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M298.159 50.11C298.159 50.11 298.019 50.01 297.999 49.99C297.979 49.97 298.009 50.01 298.029 49.99C298.069 49.95 298.199 49.75 298.239 49.71C298.209 49.76 298.189 50.07 298.159 50.12V50.11Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M298.16 50.56C297.97 50.54 297.79 50.44 297.68 50.29C297.59 50.19 297.54 50.06 297.56 49.92C297.58 49.78 297.65 49.67 297.77 49.59L297.79 49.5701C297.85 49.4901 297.91 49.42 297.93 49.39C298.08 49.23 298.31 49.2001 298.49 49.3201C298.67 49.4301 298.75 49.66 298.68 49.86C298.68 49.89 298.67 49.93 298.66 49.97C298.66 50.1 298.62 50.23 298.56 50.34C298.48 50.48 298.33 50.56 298.17 50.56H298.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.879 49.88C307.819 49.94 307.939 50.08 307.879 50.14C307.899 50.16 307.759 50.11 307.789 50.14C307.819 50.05 307.839 49.96 307.869 49.87C307.879 49.85 307.899 49.87 307.909 49.85C307.919 49.82 307.889 49.86 307.879 49.89V49.88Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.84 50.59C307.84 50.59 307.8 50.59 307.78 50.59C307.66 50.59 307.55 50.54 307.47 50.46C307.33 50.33 307.3 50.1201 307.38 49.9501L307.4 49.89C307.41 49.84 307.43 49.7801 307.45 49.7301C307.46 49.7001 307.47 49.67 307.49 49.64C307.56 49.53 307.67 49.4601 307.79 49.4301C307.9 49.3901 308.03 49.4001 308.13 49.4501C308.32 49.5601 308.41 49.7901 308.34 50.0001C308.36 50.1101 308.34 50.23 308.3 50.33C308.3 50.34 308.29 50.3601 308.28 50.3701C308.18 50.5101 308.02 50.6 307.85 50.59H307.84Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.819 58.9501C308.819 58.9501 308.469 58.9501 308.439 58.9501C308.459 59.0001 308.609 59.1401 308.629 59.1901C308.629 59.2101 308.709 59.17 308.739 59.17C308.729 59.11 308.829 59.0001 308.819 58.9401V58.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.65 59.65C308.48 59.65 308.329 59.56 308.249 59.41H308.23C308.14 59.31 308.07 59.21 308.02 59.09C307.98 58.95 308 58.81 308.08 58.69C308.16 58.57 308.299 58.51 308.439 58.5H308.82C309.03 58.5 309.21 58.64 309.26 58.85C309.29 58.99 309.26 59.14 309.18 59.27C309.14 59.46 308.99 59.6 308.8 59.63C308.75 59.64 308.7 59.65 308.65 59.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.909 52.3601C307.909 52.3601 308.009 52.4901 307.989 52.5001C307.929 52.5101 307.729 52.3501 307.679 52.3701C307.739 52.4001 307.799 52.4301 307.859 52.4401C307.919 52.4301 307.859 52.3901 307.909 52.3601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.979 52.9501C307.869 52.9501 307.759 52.91 307.659 52.85C307.559 52.82 307.459 52.77 307.379 52.71C307.259 52.61 307.199 52.45 307.229 52.3C307.259 52.14 307.359 52.01 307.509 51.96C307.599 51.92 307.699 51.9201 307.789 51.9401C307.989 51.8801 308.209 51.98 308.309 52.16C308.439 52.3 308.469 52.5 308.409 52.68C308.349 52.82 308.229 52.9201 308.079 52.9501C308.049 52.9501 308.019 52.9501 307.979 52.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.609 51.66C307.609 51.66 307.299 51.6801 307.269 51.6301C307.329 51.5901 307.389 51.56 307.449 51.52C307.469 51.57 307.249 51.8 307.269 51.85C307.289 51.83 307.589 51.68 307.609 51.66Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.27 52.3001C307.07 52.2301 306.91 52.0701 306.85 51.8701C306.79 51.6701 306.85 51.4401 306.98 51.2801C307 51.2601 307.02 51.2501 307.04 51.2401C307.19 51.1001 307.4 51.0401 307.59 51.1001C307.67 51.1301 307.75 51.1901 307.8 51.2601C307.89 51.3101 307.97 51.3801 308.01 51.4801C308.09 51.6501 308.05 51.8601 307.91 51.9901C307.83 52.0601 307.74 52.1101 307.65 52.1501C307.6 52.1801 307.55 52.2001 307.52 52.2201C307.44 52.2701 307.35 52.3001 307.26 52.3001H307.27Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.439 52.5701C299.389 52.5901 299.199 52.4201 299.149 52.4501C299.219 52.5401 299.289 52.63 299.369 52.71C299.429 52.7 299.409 52.5301 299.459 52.5101C299.439 52.4901 299.459 52.6 299.439 52.58V52.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.359 53.1601C299.139 53.1601 299.009 53.0001 298.859 52.8101L298.809 52.7501C298.699 52.6501 298.659 52.5001 298.689 52.3601C298.719 52.2101 298.829 52.0901 298.969 52.0401C299.109 51.9801 299.269 51.9901 299.399 52.0601C299.539 52.0401 299.679 52.0901 299.779 52.1901C299.889 52.2901 299.939 52.4501 299.909 52.5901V52.6201C299.859 52.8601 299.699 53.0601 299.469 53.1501C299.429 53.1501 299.399 53.1601 299.359 53.1601ZM299.259 52.7101L299.149 52.8301L299.259 52.7101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.839 52.5101C306.839 52.5101 306.949 52.49 306.979 52.47C306.959 52.45 306.759 52.2 306.749 52.21C306.709 52.23 306.609 52.45 306.579 52.48C306.609 52.48 306.809 52.5 306.839 52.5V52.5101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.84 52.9501C306.84 52.9501 306.79 52.9501 306.76 52.9501H306.68C306.6 52.9501 306.53 52.93 306.45 52.91C306.31 52.87 306.2 52.76 306.15 52.62C306.1 52.48 306.13 52.33 306.22 52.21L306.25 52.15C306.31 52.01 306.41 51.89 306.53 51.81C306.86 51.64 307.07 51.89 307.23 52.08L307.3 52.16C307.4 52.25 307.45 52.3801 307.44 52.5101C307.43 52.6501 307.35 52.77 307.23 52.84C307.16 52.89 307.08 52.92 306.99 52.93C306.94 52.95 306.89 52.96 306.84 52.96V52.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.639 46.4001C309.639 46.4001 309.779 46.4801 309.749 46.4801C309.759 46.5001 309.579 46.4601 309.599 46.4601C309.629 46.4601 309.649 46.3902 309.679 46.3802C309.669 46.3602 309.659 46.4201 309.639 46.3901V46.4001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.719 46.9401C309.579 46.9401 309.449 46.9 309.329 46.83C309.169 46.71 309.099 46.5001 309.169 46.3101C309.229 46.1801 309.319 46.07 309.439 45.99C309.539 45.93 309.669 45.9101 309.789 45.9401C309.909 45.9701 310.009 46.05 310.069 46.16C310.169 46.26 310.219 46.4 310.199 46.53C310.179 46.65 310.119 46.76 310.029 46.83C309.939 46.9 309.839 46.93 309.729 46.93L309.719 46.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.779 47.8C304.779 47.91 304.779 48.0101 304.779 48.1201C304.779 48.1401 304.829 48.2 304.849 48.23C304.889 48.19 305.139 48.14 305.149 48.09C305.039 47.99 304.919 47.89 304.789 47.8H304.779Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.839 48.6801C304.729 48.6801 304.619 48.6401 304.539 48.5601C304.379 48.4301 304.309 48.2301 304.329 48.0301V48.0101C304.309 47.8801 304.319 47.7501 304.359 47.6301C304.409 47.5001 304.529 47.4001 304.669 47.3601C304.809 47.3301 304.959 47.3601 305.069 47.4501L305.149 47.5101C305.439 47.7201 305.629 47.8601 305.589 48.1401C305.539 48.3601 305.359 48.5401 305.139 48.5801L305.099 48.6001C305.039 48.6401 304.959 48.6701 304.879 48.6701H304.849L304.839 48.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.919 48.85C302.919 48.85 303.119 48.58 303.099 48.55C303.079 48.62 303.079 48.69 303.079 48.77C303.099 48.81 303.039 48.99 303.069 49.03C303.069 49 302.909 48.88 302.919 48.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M303.07 49.47C302.92 49.47 302.78 49.3899 302.7 49.2699C302.64 49.2099 302.58 49.1499 302.54 49.0799C302.43 48.8599 302.47 48.6 302.65 48.43C302.67 48.41 302.68 48.39 302.69 48.37C302.76 48.21 302.9 48.11 303.07 48.1C303.24 48.09 303.4 48.17 303.48 48.32C303.55 48.43 303.56 48.56 303.52 48.68V48.7099C303.52 48.7899 303.52 48.87 303.51 48.95C303.52 49.03 303.51 49.1 303.48 49.17C303.42 49.32 303.29 49.4299 303.14 49.4599C303.11 49.4599 303.09 49.4599 303.06 49.4599L303.07 49.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.41 51.5601C299.38 51.5001 299.58 51.3701 299.56 51.3201C299.47 51.3701 299.38 51.42 299.29 51.48C299.29 51.53 299.47 51.53 299.48 51.59C299.52 51.57 299.37 51.5901 299.41 51.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.48 52.04C299.43 52.04 299.37 52.0301 299.32 52.0101C299.24 51.9901 299.17 51.96 299.11 51.91C298.93 51.83 298.83 51.6401 298.84 51.4501C298.86 51.1901 299.05 51.09 299.25 50.98L299.31 50.9501C299.41 50.8601 299.55 50.8401 299.67 50.8701C299.8 50.9101 299.91 51.01 299.96 51.14C300.02 51.46 299.91 51.7801 299.68 52.0001C299.62 52.0301 299.55 52.05 299.48 52.05V52.04ZM299.28 51.1901L299.39 51.4L299.28 51.1901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.519 27.72C295.519 27.72 295.479 27.45 295.459 27.42C295.419 27.51 295.389 27.61 295.379 27.71C295.399 27.78 295.429 27.85 295.469 27.91C295.479 27.88 295.519 27.74 295.529 27.71L295.519 27.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.469 28.3701C295.339 28.3701 295.219 28.3101 295.129 28.2201C295.059 28.1301 295.009 28.0401 294.979 27.9301C294.909 27.6601 294.959 27.3701 295.119 27.1301C295.209 27.0201 295.349 26.9601 295.489 26.9701C295.629 26.9701 295.759 27.0501 295.839 27.1701C295.899 27.2701 295.929 27.3801 295.939 27.5001V27.5701C295.979 27.6601 295.979 27.7601 295.949 27.8501L295.889 28.0501C295.829 28.2401 295.659 28.3601 295.459 28.3601L295.469 28.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.529 33.0701C287.529 33.0701 287.539 33.33 287.519 33.35C287.539 33.37 287.489 33.27 287.509 33.3C287.549 33.27 288.139 33.38 288.179 33.35C288.149 33.34 287.569 33.09 287.539 33.08L287.529 33.0701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.519 33.8001C287.369 33.8001 287.229 33.7201 287.139 33.6001C287.099 33.5401 287.069 33.4701 287.069 33.3901C287.069 33.3301 287.069 33.2701 287.069 33.2101C287.039 33.0101 287.119 32.8001 287.289 32.6801C287.409 32.6101 287.559 32.5901 287.689 32.6401C287.709 32.6401 287.889 32.7201 288.059 32.8001L288.339 32.9201C288.489 32.9801 288.599 33.1201 288.619 33.2801C288.639 33.4401 288.569 33.6001 288.439 33.7001C288.279 33.8201 288.119 33.8001 287.789 33.7601H287.719C287.659 33.7801 287.589 33.8001 287.519 33.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.24 59.73C307.24 59.73 307.269 59.8899 307.279 59.8899C307.339 59.8899 307.299 59.68 307.349 59.66C307.329 59.64 307.39 59.7599 307.37 59.7699C307.31 59.7699 307.279 59.72 307.229 59.74L307.24 59.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.289 60.34C307.039 60.34 306.829 60.15 306.819 59.9C306.789 59.81 306.779 59.71 306.799 59.62C306.829 59.49 306.919 59.38 307.039 59.33H307.059C307.059 59.33 307.089 59.29 307.109 59.28C307.239 59.2 307.389 59.19 307.529 59.25C307.669 59.31 307.769 59.43 307.799 59.58C307.849 59.72 307.839 59.87 307.769 60C307.749 60.04 307.719 60.07 307.689 60.1C307.619 60.25 307.459 60.35 307.289 60.35V60.34ZM307.199 59.81L307.029 59.98L307.199 59.81ZM307.329 59.45L307.359 59.63L307.499 59.5C307.449 59.47 307.389 59.45 307.329 59.45Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M286.549 36.0001C286.609 35.9801 286.689 35.8701 286.759 35.8401C286.739 35.8101 286.719 35.9401 286.699 35.9401C286.639 35.9501 286.439 35.7101 286.379 35.7301C286.399 35.7601 286.529 35.9701 286.549 35.9901V36.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M286.549 36.4501C286.409 36.4501 286.279 36.39 286.199 36.28C286.189 36.26 286.139 36.19 286.089 36.11L286.019 36.0001C285.939 35.8801 285.919 35.74 285.959 35.61C285.999 35.48 286.099 35.3701 286.229 35.3201C286.389 35.2601 286.569 35.29 286.699 35.4C286.839 35.39 286.979 35.44 287.079 35.54C287.229 35.7 287.239 35.9601 287.099 36.1301C287.029 36.2601 286.909 36.35 286.769 36.39C286.749 36.4 286.729 36.41 286.709 36.42C286.659 36.44 286.599 36.4501 286.549 36.4501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.919 29.22C304.899 29.29 304.759 29.25 304.739 29.32C304.809 29.34 304.879 29.35 304.959 29.35C304.969 29.35 304.889 29.27 304.879 29.25C304.849 29.21 304.959 29.25 304.919 29.22Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.939 29.8001C304.869 29.8001 304.799 29.7901 304.729 29.7701C304.589 29.7701 304.469 29.6901 304.379 29.5801C304.299 29.4701 304.269 29.3301 304.299 29.1901C304.349 29.0201 304.48 28.8901 304.65 28.8401H304.68C304.68 28.8401 304.749 28.7901 304.779 28.7801C304.929 28.7301 305.089 28.7701 305.199 28.8701C305.289 28.9501 305.349 29.0501 305.359 29.1701C305.399 29.2701 305.41 29.3801 305.37 29.4901C305.32 29.6501 305.18 29.7601 305.02 29.7901C304.99 29.7901 304.96 29.7901 304.93 29.7901L304.939 29.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.899 30.66C297.899 30.66 298.059 30.55 298.069 30.52C298.029 30.52 297.849 30.59 297.819 30.6C297.819 30.63 297.899 30.7301 297.909 30.7501C297.929 30.7501 297.889 30.66 297.909 30.66H297.899Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.899 31.2002C297.629 31.2202 297.389 31.0301 297.339 30.7601C297.289 30.4901 297.449 30.2401 297.709 30.1601L297.809 30.1301C297.879 30.1101 297.939 30.0901 297.959 30.0801C298.109 30.0401 298.259 30.0801 298.369 30.1901C298.479 30.3001 298.529 30.4401 298.509 30.5901C298.489 30.7201 298.409 30.8401 298.309 30.9101C298.259 31.0401 298.169 31.1301 298.039 31.1801C297.999 31.1901 297.949 31.2002 297.899 31.2002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.069 30.02C305.069 30.02 304.949 30 304.899 30.04C304.919 30.06 305.019 30.3201 305.039 30.3201C305.099 30.3101 305.319 30.1501 305.369 30.1301C305.339 30.0901 305.099 30.07 305.059 30.03L305.069 30.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.03 30.77C304.74 30.77 304.62 30.4901 304.56 30.3501L304.53 30.2801C304.41 30.0901 304.45 29.8401 304.63 29.6901C304.74 29.6101 304.87 29.57 305 29.58C305.1 29.56 305.2 29.5801 305.29 29.6301H305.34C305.49 29.6601 305.62 29.73 305.73 29.83C305.83 29.94 305.86 30.0901 305.83 30.2301C305.8 30.3701 305.7 30.4901 305.56 30.5401C305.56 30.5401 305.54 30.56 305.51 30.58C305.4 30.66 305.28 30.7301 305.15 30.7601C305.12 30.7601 305.09 30.7601 305.05 30.7601L305.03 30.77Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.049 32.2601C288.989 32.2401 289.069 32.2301 289.019 32.2201C288.999 32.2201 289.099 32.1301 289.079 32.1601C289.119 32.1901 289.059 32.21 289.099 32.21C289.139 32.21 289.009 32.3001 289.059 32.2601H289.049Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.04 32.72C288.88 32.72 288.72 32.6301 288.64 32.4901V32.47C288.59 32.41 288.56 32.3301 288.56 32.2601C288.56 32.0201 288.71 31.8101 288.94 31.7301C289.14 31.6701 289.36 31.7601 289.46 31.9401C289.47 31.9601 289.48 31.9801 289.49 32.0101C289.52 32.0601 289.53 32.1201 289.54 32.1701C289.55 32.4101 289.4 32.6301 289.17 32.7001C289.13 32.7101 289.08 32.72 289.04 32.72ZM288.82 31.8801L288.97 32.0501L288.9 31.84C288.9 31.84 288.84 31.8601 288.81 31.8801H288.82Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.18 35.8801C306.18 35.8801 306.16 35.8001 306.18 35.8101C306.21 35.8201 306.08 35.8101 306.11 35.8101C306.11 35.7801 306.31 35.69 306.3 35.66C306.27 35.66 306.219 35.8601 306.189 35.8701L306.18 35.8801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.179 36.33C305.889 36.3 305.669 36.07 305.649 35.78C305.649 35.73 305.669 35.68 305.689 35.64C305.749 35.52 305.849 35.42 305.969 35.35C306.019 35.29 306.089 35.25 306.159 35.23C306.279 35.19 306.409 35.21 306.519 35.27C306.629 35.33 306.709 35.4301 306.739 35.5601C306.769 35.6901 306.739 35.8201 306.669 35.9301C306.629 36.0701 306.539 36.19 306.409 36.27C306.379 36.29 306.339 36.3101 306.299 36.3201C306.259 36.3201 306.229 36.33 306.189 36.33H306.179Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.579 49.49C309.579 49.49 309.679 49.45 309.689 49.48C309.689 49.51 309.689 49.74 309.709 49.73C309.739 49.71 309.619 49.5 309.579 49.49Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.709 50.18C309.629 50.18 309.549 50.16 309.469 50.11C309.359 50.04 309.279 49.93 309.259 49.8C309.179 49.72 309.129 49.61 309.129 49.5C309.139 49.27 309.309 49.07 309.539 49.03C309.779 48.97 310.029 49.1 310.119 49.33C310.149 49.41 310.159 49.5 310.149 49.58V49.62C310.199 49.82 310.099 50.02 309.929 50.12C309.859 50.16 309.789 50.18 309.709 50.18ZM309.539 49.9C309.589 49.92 309.649 49.93 309.709 49.92L309.679 49.75L309.569 49.78L309.539 49.91V49.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.619 58.7401C305.619 58.7401 305.759 58.5801 305.749 58.6101C305.739 58.6401 305.589 58.8101 305.609 58.8401C305.659 58.7701 305.709 58.6901 305.749 58.6101C305.749 58.5801 305.639 58.7701 305.619 58.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.62 59.28C305.49 59.28 305.37 59.23 305.29 59.13C305.19 59.03 305.15 58.89 305.17 58.76C305.17 58.68 305.17 58.61 305.21 58.54C305.21 58.54 305.46 58.07 305.86 58.16C306.07 58.21 306.21 58.41 306.2 58.62C306.2 58.71 306.17 58.79 306.12 58.86C306.07 58.97 306 59.07 305.92 59.16C305.84 59.24 305.73 59.28 305.62 59.28Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.289 57.7301C306.289 57.7301 306.489 57.6701 306.479 57.6401C306.479 57.6101 306.319 57.7301 306.299 57.7401C306.259 57.7301 306.269 57.7601 306.299 57.7401L306.289 57.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.279 58.19C306.119 58.19 305.979 58.11 305.889 57.98C305.799 57.85 305.789 57.68 305.859 57.54C305.909 57.43 306.009 57.35 306.129 57.3C306.259 57.19 306.439 57.15 306.609 57.2C306.749 57.24 306.849 57.35 306.899 57.48C306.949 57.63 306.919 57.79 306.819 57.92C306.729 58.02 306.619 58.09 306.489 58.13C306.419 58.16 306.349 58.18 306.269 58.18L306.279 58.19ZM306.109 57.38C306.029 57.5 306.009 57.65 306.059 57.78L306.269 57.7099L306.119 57.38H306.109Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.889 48.4501C305.889 48.4501 305.799 48.6701 305.829 48.6601C305.859 48.6601 305.829 48.6201 305.859 48.6101C305.919 48.5901 305.899 48.4101 305.889 48.4501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.83 49.11C305.7 49.11 305.579 49.06 305.499 48.97C305.359 48.8 305.339 48.56 305.449 48.37C305.449 48.36 305.449 48.38 305.449 48.4C305.479 48.18 305.659 48.01 305.879 48C306.099 48 306.3 48.15 306.34 48.37C306.38 48.56 306.339 48.75 306.219 48.9C306.159 48.99 306.079 49.06 305.979 49.1C305.929 49.12 305.89 49.12 305.84 49.12L305.83 49.11ZM305.689 48.19C305.689 48.19 305.62 48.22 305.59 48.24C305.62 48.22 305.649 48.2 305.689 48.19Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.419 48.44C306.419 48.44 306.459 48.36 306.479 48.4C306.489 48.43 306.429 48.26 306.459 48.26C306.479 48.26 306.459 48.44 306.419 48.44Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.409 48.89H306.379C306.159 48.87 305.979 48.69 305.949 48.47C305.959 48.3 306.009 48.1401 306.089 47.9901C306.179 47.8801 306.319 47.8101 306.469 47.8101C306.639 47.8101 306.779 47.9101 306.859 48.0601C306.899 48.1501 306.919 48.24 306.909 48.33C306.909 48.47 306.869 48.61 306.779 48.71C306.689 48.81 306.549 48.8801 306.409 48.8801V48.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.579 55.6001C307.579 55.6001 307.639 55.6801 307.619 55.6501C307.589 55.6701 307.759 55.5801 307.759 55.6101C307.759 55.6401 307.589 55.6701 307.619 55.7001C307.649 55.6801 307.559 55.6301 307.589 55.6001H307.579Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M307.609 56.15H307.589C307.469 56.15 307.359 56.0901 307.279 56.0001C307.239 55.9601 307.209 55.9001 307.189 55.8501C307.099 55.7001 307.109 55.5101 307.199 55.3601C307.219 55.3201 307.249 55.2801 307.289 55.2501C307.399 55.1601 307.549 55.13 307.689 55.16C307.809 55.14 307.919 55.1601 308.019 55.2401C308.149 55.3301 308.219 55.4801 308.209 55.6301C308.199 55.8201 308.069 55.9901 307.889 56.0501C307.809 56.1101 307.709 56.14 307.609 56.14V56.15ZM308.039 55.7901C308.039 55.7901 308.019 55.87 308.009 55.9C308.029 55.86 308.039 55.8301 308.049 55.7901H308.039Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.809 51.0901C309.809 51.0901 309.839 51.0401 309.809 51.0601C309.779 51.0701 309.719 51.0902 309.719 51.1302C309.719 51.1502 309.809 51.1301 309.819 51.0901H309.809Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.729 51.5901H309.719C309.479 51.5901 309.289 51.3901 309.269 51.1601C309.259 50.9201 309.419 50.7101 309.649 50.6501C309.829 50.5801 310.039 50.6301 310.169 50.7701C310.269 50.8901 310.309 51.0701 310.249 51.2201C310.179 51.4501 309.969 51.6001 309.739 51.6001L309.729 51.5901ZM309.849 51.1201L309.989 51.4701C310.069 51.4201 310.119 51.3401 310.149 51.2601L309.919 51.1201H309.849ZM309.449 50.8301L309.719 51.0001L309.739 50.7001C309.619 50.6901 309.509 50.7401 309.449 50.8401V50.8301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.689 51.9101C306.689 51.9101 306.739 52.0601 306.749 52.0401C306.749 52.0201 306.709 51.9701 306.689 51.9401C306.669 51.9601 306.769 52.0201 306.769 52.0401C306.769 52.0601 306.679 51.8901 306.689 51.9101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.759 52.4901C306.639 52.4901 306.519 52.4401 306.439 52.3501C306.419 52.3301 306.409 52.3201 306.399 52.3001C306.299 52.2101 306.249 52.0901 306.239 51.9601C306.239 51.7801 306.329 51.6101 306.479 51.5101C306.549 51.4701 306.629 51.4501 306.709 51.4601C306.749 51.4601 306.779 51.4601 306.819 51.4801C306.969 51.5301 307.089 51.6401 307.129 51.7901C307.189 51.8801 307.219 51.9901 307.209 52.0901C307.189 52.3001 307.019 52.4701 306.809 52.4901C306.789 52.4901 306.769 52.4901 306.759 52.4901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.149 60.19C306.149 60.19 305.899 59.99 305.879 59.97C305.859 60.03 305.849 60.1 305.849 60.17C305.849 60.19 305.849 60.05 305.879 60.05C305.899 60.05 306.129 60.21 306.159 60.19H306.149Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.159 60.64C306.089 60.64 306.019 60.62 305.959 60.6C305.919 60.61 305.869 60.62 305.819 60.61C305.579 60.6 305.389 60.39 305.399 60.15V60.11C305.399 59.93 305.459 59.75 305.579 59.62C305.669 59.54 305.789 59.5001 305.909 59.5101C306.029 59.5101 306.139 59.57 306.219 59.67C306.209 59.65 306.249 59.68 306.289 59.72C306.359 59.77 306.419 59.83 306.489 59.89C306.649 60.08 306.629 60.36 306.439 60.52C306.359 60.59 306.259 60.6301 306.149 60.6301L306.159 60.64Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.729 31.72C300.009 31.76 299.409 31.7501 299.189 31.9301C299.169 31.9501 299.289 32.12 299.299 32.09C299.379 31.78 299.429 31.67 299.729 31.71V31.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.289 32.55C298.939 32.55 298.789 32.17 298.769 32.13C298.699 31.94 298.749 31.7299 298.899 31.5899C298.959 31.5399 299.039 31.4899 299.109 31.4599C299.289 31.2899 299.549 31.2199 299.789 31.2799C300.039 31.2799 300.239 31.49 300.249 31.74C300.249 31.92 300.169 32.1499 299.769 32.2099H299.729C299.679 32.3999 299.509 32.54 299.319 32.55H299.289Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M310.059 31.5601C310.059 31.5601 309.869 31.6501 309.839 31.6201C309.809 31.6401 309.769 31.52 309.759 31.54C309.759 31.56 309.819 31.39 309.849 31.39C309.879 31.39 310.029 31.58 310.049 31.55L310.059 31.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.829 32.08C309.829 32.08 309.789 32.08 309.759 32.08C309.619 32.06 309.489 31.97 309.419 31.85C309.289 31.7 309.279 31.48 309.379 31.31C309.449 31.1 309.649 30.96 309.869 30.96C310.009 30.97 310.149 31.04 310.239 31.16H310.249C310.249 31.16 310.339 31.23 310.379 31.27C310.489 31.4 310.519 31.57 310.459 31.73C310.399 31.89 310.259 32 310.089 32.02C310.039 32.04 309.979 32.06 309.929 32.07C309.889 32.07 309.849 32.08 309.809 32.08H309.829Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.229 29.4C304.229 29.4 304.309 29.5 304.319 29.54C304.329 29.57 304.229 29.63 304.249 29.6C304.299 29.5 304.269 29.4 304.229 29.4Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.25 30.0601C304.14 30.0601 304.04 30.0301 303.95 29.9601C303.84 29.8601 303.78 29.7101 303.8 29.5601C303.75 29.4401 303.76 29.3101 303.82 29.2001C303.91 29.0401 304.08 28.9401 304.27 28.9601C304.43 28.9801 304.56 29.0701 304.64 29.2101C304.65 29.2301 304.66 29.2501 304.67 29.2701C304.7 29.3101 304.72 29.35 304.74 29.39C304.82 29.61 304.74 29.8501 304.53 29.9701C304.45 30.0301 304.35 30.0601 304.24 30.0601H304.25ZM304.03 29.2401C303.91 29.3401 303.85 29.49 303.89 29.64L304.17 29.4801L304.03 29.2401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.28 29.8401C299.28 29.8401 299.31 29.8401 299.31 29.8601C299.31 29.8801 299.25 30.0201 299.27 30.0501C299.29 30.0301 299.25 29.8801 299.25 29.8601C299.25 29.8401 299.31 29.8701 299.29 29.8501L299.28 29.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.26 30.4901H299.23C299.11 30.4901 299 30.43 298.92 30.33C298.84 30.24 298.8 30.1101 298.81 29.9901C298.8 29.9301 298.79 29.8801 298.79 29.8201C298.79 29.6801 298.87 29.5601 298.98 29.4801C299.03 29.4501 299.09 29.4201 299.15 29.4101C299.26 29.3801 299.38 29.3901 299.49 29.4401C299.54 29.4601 299.58 29.49 299.62 29.52C299.72 29.61 299.77 29.7401 299.76 29.8801C299.76 29.9401 299.74 30.0001 299.72 30.0501C299.72 30.2901 299.51 30.4901 299.27 30.4901H299.26Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.27 33.65C304.27 33.65 304.05 33.6101 304.02 33.6301C304.04 33.6501 304.25 33.55 304.27 33.55C304.29 33.55 304.43 33.67 304.45 33.65C304.43 33.63 304.29 33.68 304.27 33.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.299 34.1001H304.249C304.189 34.1001 304.129 34.1001 304.059 34.0801C303.919 34.0901 303.789 34.0401 303.699 33.9401C303.579 33.8101 303.539 33.6301 303.609 33.4701C303.679 33.3101 303.819 33.1901 303.989 33.1801H304.019C304.099 33.1201 304.199 33.1001 304.289 33.1001C304.399 33.1001 304.499 33.1501 304.589 33.2101C304.749 33.2601 304.859 33.3901 304.899 33.5501C304.929 33.7101 304.879 33.8701 304.759 33.9801C304.669 34.0701 304.539 34.1101 304.419 34.0901C304.379 34.0901 304.349 34.0901 304.309 34.0901L304.299 34.1001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.549 47.1C309.549 47.1 309.489 47.02 309.459 47.04C309.479 47.07 309.539 46.92 309.559 46.92C309.589 46.92 309.559 47.07 309.579 47.05C309.559 47.02 309.579 47.13 309.549 47.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.559 47.56C309.559 47.56 309.549 47.56 309.539 47.56C309.529 47.56 309.509 47.56 309.499 47.56C309.399 47.54 309.309 47.5 309.229 47.44C309.189 47.42 309.159 47.39 309.129 47.36C309.049 47.27 309.009 47.15 309.009 47.03C309.009 46.91 309.069 46.8 309.159 46.72C309.259 46.54 309.479 46.45 309.689 46.5C309.889 46.56 310.029 46.75 310.019 46.96C310.039 47.07 310.019 47.19 309.959 47.29C309.909 47.4 309.819 47.49 309.699 47.54C309.649 47.56 309.599 47.56 309.549 47.56H309.559Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.439 45.32C308.439 45.32 308.339 45.56 308.329 45.53C308.319 45.5 308.619 45.44 308.609 45.41C308.589 45.33 308.419 45.31 308.449 45.32H308.439Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.329 45.9901C308.149 45.9901 307.989 45.88 307.909 45.72C307.839 45.55 307.869 45.36 307.999 45.23C308.039 45.05 308.189 44.91 308.369 44.89C308.409 44.89 308.449 44.89 308.489 44.89H308.529C308.769 44.92 308.969 45.0801 309.039 45.3101C309.079 45.4701 309.079 45.77 308.599 45.92H308.569C308.569 45.92 308.479 45.9801 308.429 45.9901C308.399 45.9901 308.359 46.0001 308.329 46.0001V45.9901ZM308.389 45.77C308.389 45.77 308.439 45.77 308.459 45.77L308.399 45.6201L308.379 45.7601L308.389 45.77Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.809 46.2001C304.809 46.2001 304.699 45.9901 304.719 45.9701C304.699 45.9501 304.849 45.9701 304.829 45.9701C304.809 45.9701 304.839 45.9501 304.839 45.9701C304.839 45.9901 304.789 46.1701 304.809 46.1901V46.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.809 46.65H304.779C304.659 46.65 304.549 46.59 304.469 46.49C304.419 46.44 304.389 46.37 304.369 46.3C304.339 46.25 304.319 46.2 304.299 46.15C304.259 46.07 304.249 45.97 304.269 45.88C304.269 45.84 304.289 45.81 304.299 45.78C304.309 45.75 304.329 45.72 304.349 45.69C304.459 45.55 304.639 45.4799 304.819 45.5199H304.849C305.099 45.5399 305.289 45.75 305.279 46C305.279 46.04 305.279 46.07 305.259 46.11C305.259 46.13 305.259 46.15 305.249 46.17C305.269 46.31 305.209 46.45 305.099 46.53C305.019 46.6 304.909 46.6399 304.799 46.6399L304.809 46.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.319 38.77C306.319 38.77 306.359 38.5601 306.339 38.5601C306.309 38.5601 306.499 38.76 306.469 38.78C306.489 38.81 306.299 38.9401 306.319 38.9401C306.349 38.9401 306.299 38.79 306.319 38.77Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M306.319 39.3901H306.289C306.109 39.3801 305.949 39.2601 305.889 39.0801C305.869 39.0101 305.859 38.9501 305.869 38.8801C305.869 38.7801 305.869 38.6801 305.889 38.5901C305.889 38.4601 305.929 38.3401 306.019 38.2501C306.109 38.1601 306.229 38.1101 306.359 38.1101C306.489 38.1101 306.619 38.1801 306.699 38.2801C306.719 38.3101 306.739 38.3401 306.759 38.3701C306.799 38.4201 306.829 38.4801 306.859 38.5401C306.909 38.6201 306.929 38.7101 306.929 38.8001C306.909 38.9601 306.819 39.1101 306.689 39.2101C306.689 39.2101 306.679 39.2301 306.669 39.2301C306.579 39.3201 306.459 39.3801 306.339 39.3801L306.319 39.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.399 42.7001C396.449 42.8301 396.459 42.97 396.419 43.1C396.569 43.17 396.649 43.35 396.799 43.42C396.949 43.49 397.139 43.47 397.289 43.54C397.309 43.6 397.359 43.6401 397.389 43.7001C397.539 43.7601 397.609 43.96 397.739 44.05C397.849 44.12 397.809 44.1 397.869 44.27C397.629 44.27 397.509 44.4 397.309 44.33C397.049 44.54 396.649 44.6601 396.839 44.7001C397.139 44.7601 397.389 44.93 397.329 45.21C397.519 45.18 397.539 45.3 397.729 45.27C397.919 45.24 398.069 44.9701 398.259 44.9501C398.349 44.9401 398.489 45.1601 398.579 45.1801C398.539 45.2701 398.479 45.34 398.399 45.39C398.189 45.48 397.949 45.4801 397.739 45.5601C397.529 45.6501 397.369 45.88 397.159 45.97C397.219 46.1 397.299 46.28 397.369 46.41C397.429 46.53 397.429 46.67 397.369 46.79C397.309 46.99 397.599 47.1201 397.659 47.2401C397.719 47.3901 397.719 47.52 397.879 47.6C398.089 47.7 398.229 47.9001 398.259 48.1301C398.349 48.3701 398.249 48.6301 398.019 48.7401C397.819 48.9001 397.709 49.14 397.719 49.4C397.689 49.55 397.679 49.7 397.699 49.85C397.729 50.01 397.679 50.2101 397.699 50.3701C397.929 50.2201 398.139 50.0601 398.339 49.8801C398.429 49.8101 398.419 49.67 398.459 49.53C398.459 49.53 398.519 49.6 398.519 49.58C398.459 49.52 398.219 49.47 398.159 49.41C398.209 49.39 398.369 49.25 398.409 49.23C398.469 49.12 398.649 48.97 398.709 48.86C398.829 49 399.079 49.25 399.099 49.4C399.089 49.58 399.049 49.7701 398.989 49.9401C399.099 49.8701 399.319 49.99 399.419 49.92C399.529 49.84 399.249 49.58 399.229 49.6C399.239 49.59 399.419 49.66 399.539 49.55C399.729 49.3801 400.059 49.33 400.249 49.15C400.399 49 400.409 48.7201 400.539 48.5601C400.579 48.5101 400.489 48.42 400.499 48.41C400.499 48.4 400.469 48.4201 400.499 48.3701C400.469 48.3701 400.789 48.42 400.759 48.42C400.789 48.4 400.359 48.1801 400.279 47.9301C400.229 47.7501 400.259 47.5501 400.359 47.3801C400.479 47.2101 400.539 46.97 400.699 46.84C400.859 46.71 400.999 46.49 401.179 46.4C401.359 46.31 401.659 46.4501 401.859 46.3801C402.059 46.3101 402.239 46.2 402.439 46.15C402.429 45.95 402.299 45.78 402.109 45.72C401.939 45.68 401.729 45.76 401.579 45.71C401.449 45.66 401.489 45.57 401.339 45.55C401.359 45.41 401.309 45.2701 401.209 45.1801C400.949 45.0301 400.809 44.89 400.849 44.78C400.899 44.66 400.919 44.53 400.909 44.4C400.909 44.33 400.739 44.34 400.669 44.35C400.499 44.41 400.309 44.43 400.129 44.42C399.949 44.36 399.759 44.3201 399.569 44.3101C399.399 44.3101 399.349 44.5501 399.179 44.7001C399.039 44.8101 398.719 44.6 398.499 44.59C398.329 44.59 398.299 44.59 398.179 44.34L398.089 44.46C398.239 44.24 398.179 43.82 398.329 43.6C398.499 43.56 398.799 43.54 398.979 43.48C399.219 43.4 399.569 43.32 399.679 43.4L396.399 42.7001ZM418.389 49.92C418.489 49.83 418.619 49.7801 418.759 49.7601C418.759 49.8901 418.749 50.03 418.709 50.16C418.689 50.62 418.789 50.6401 419.319 50.4901C419.299 50.6901 419.189 50.86 419.029 50.98C418.869 51.08 418.659 50.9601 418.459 50.9501C418.139 50.9401 417.919 51.1901 418.039 51.4501C418.109 51.6001 418.369 51.6701 418.459 51.8201C418.579 51.8601 418.679 51.9501 418.739 52.0701C418.799 52.1901 418.799 52.3201 418.739 52.4401C418.659 52.6701 418.569 52.73 418.789 52.91C418.689 53.14 418.529 53.3401 418.339 53.5101C417.889 53.7401 417.559 54.0501 417.709 54.0701C417.899 54.0901 418.039 54.3301 418.159 54.4301C418.289 54.5401 418.319 54.7401 418.439 54.8701C418.759 55.0401 419.099 55.18 419.449 55.28C419.599 55.34 419.779 55.26 419.919 55.34C419.779 55.49 419.629 55.62 419.469 55.73C419.079 55.76 418.699 55.76 418.309 55.73C418.239 55.74 418.349 55.9801 418.279 56.0001C418.319 56.0301 418.219 55.98 418.269 55.98C418.569 56.02 419.149 56.19 419.449 56.23C419.749 56.27 419.759 56.03 420.059 56.04C419.989 55.93 419.959 55.8001 419.969 55.6801C420.119 55.6401 420.289 55.65 420.439 55.61C420.589 55.58 420.769 55.67 420.919 55.66C420.999 55.66 421.139 55.8001 421.219 55.9401C421.369 55.9401 421.469 56.0301 421.549 55.9501C421.739 55.7501 421.859 55.43 422.079 55.29C422.309 55.2 422.549 55.1701 422.799 55.1901C422.849 55.1901 422.819 55.13 422.879 55.03C422.889 55.02 422.879 55.2101 422.879 55.1901C422.799 54.9501 422.789 54.65 422.719 54.42C422.939 54.38 423.129 54.37 423.029 54.04C422.999 53.85 423.089 53.67 423.259 53.58C423.429 53.48 423.589 53.3501 423.709 53.1901C423.819 53.0601 423.769 52.7901 423.829 52.6301C423.889 52.4701 424.119 52.3601 424.159 52.1901C424.209 52.0201 424.079 51.81 424.159 51.66C424.309 51.34 423.879 51.64 423.749 51.6C423.739 51.46 423.729 51.3801 423.719 51.2401C423.479 51.2101 423.369 50.8701 423.139 50.8201C423.029 50.8001 422.709 50.95 422.599 50.9C422.719 50.76 422.869 50.64 423.019 50.55C423.089 50.48 423.179 50.44 423.269 50.41C423.089 50.27 422.799 50.1001 422.629 49.9501C422.809 49.8501 423.229 49.68 423.329 49.73C423.679 49.92 423.899 49.84 423.989 49.73C424.099 49.51 424.149 49.27 424.119 49.02C424.019 48.83 423.939 48.62 423.889 48.41C423.849 48.16 423.949 47.76 423.809 47.64C423.659 47.5 423.409 47.52 423.399 47.39C423.369 47.2 423.419 47 423.539 46.84C423.849 46.66 423.669 46.64 423.639 46.4C423.599 46.11 423.879 45.7301 423.869 45.4401C423.629 45.4001 423.389 45.36 423.329 45.23C423.279 45.06 423.329 44.8601 423.469 44.7501C423.609 44.5901 423.529 44.32 423.609 44.15C423.699 43.97 424.119 43.9 424.149 43.71C424.179 43.5 424.199 43.29 424.189 43.08C424.189 42.88 424.089 42.68 424.059 42.48C424.039 42.28 423.719 42.12 423.699 41.92C423.679 41.72 423.759 41.5001 423.749 41.3101C423.749 41.2101 423.679 41.2 423.599 41.14C423.449 40.97 423.289 40.8 423.119 40.65C423.289 40.6 423.589 40.6801 423.759 40.6301C423.789 40.6301 423.569 40.48 423.569 40.46C423.529 40.26 423.799 40 423.759 39.8C423.739 39.59 423.699 39.3901 423.649 39.1901C423.609 39.0801 423.129 39.2601 422.969 39.1901C422.879 39.1501 422.799 38.9301 422.709 38.8801C422.809 38.8401 422.949 38.7301 423.059 38.7001C423.129 38.6801 423.199 38.54 423.269 38.53C423.439 38.51 423.639 38.6301 423.719 38.5601C423.779 38.5001 423.979 38.33 423.719 38.08C423.689 38.06 423.569 37.9 423.659 37.8C423.829 37.61 424.029 37.53 423.989 37.41C423.959 37.3 423.779 37.43 423.489 37.39C423.359 37.37 423.229 36.97 423.109 36.85C423.229 36.78 423.359 36.65 423.469 36.58C423.669 36.47 423.859 36.47 423.709 36.11C423.669 36.03 423.379 35.83 423.429 35.78C423.699 35.53 423.849 35.3801 423.459 35.2601C423.259 35.2001 422.939 35.21 422.829 35.05C422.689 34.8 422.599 34.5401 422.539 34.2601C422.539 34.2401 422.649 34.25 422.709 34.21C422.809 34.41 423.039 34.49 423.179 34.67C423.289 34.81 423.359 35.1 423.529 35.15C423.639 35.18 423.669 34.89 423.799 34.84C423.739 34.7 423.839 34.6201 423.769 34.4901C423.729 34.4001 423.689 34.31 423.639 34.22C423.949 34.01 423.729 33.81 423.659 33.64C423.579 33.45 423.519 33.2001 423.449 33.0101C423.409 32.9001 423.389 32.45 423.469 32.42C423.749 32.32 423.949 32.38 423.959 32.21C424.019 32.01 424.039 31.8 424.039 31.59C424.039 31.57 423.899 31.6401 423.889 31.6201C423.809 31.4801 423.889 31.25 423.799 31.11C423.719 30.97 423.549 30.8701 423.459 30.7401C423.349 30.5901 423.399 30.55 423.519 30.46C423.629 30.37 423.549 30.37 423.309 30.22C423.439 30.03 423.549 29.8301 423.639 29.6201C423.729 29.4501 423.959 29.3601 423.979 29.1801C423.999 28.9901 423.979 28.8001 423.909 28.6301C423.849 28.4701 423.589 28.32 423.469 28.16C423.599 28.03 423.689 27.8701 423.719 27.6901C423.729 27.5201 423.719 27.3601 423.679 27.2001C423.649 27.0501 423.649 26.9001 423.669 26.7501C423.869 26.6201 423.779 26.3901 423.809 26.2001C423.829 26.0101 423.829 25.8101 423.829 25.6201C423.839 25.4201 423.799 25.2101 423.949 25.0601C423.829 24.9601 423.929 24.87 423.799 24.77C423.679 24.67 423.499 24.64 423.379 24.53C423.299 24.32 423.249 24.0901 423.239 23.8701C423.209 23.5701 423.239 23.0901 423.219 23.0601C423.399 23.0601 423.389 23.02 423.479 22.79C423.539 22.63 423.959 22.5401 423.999 22.3201C424.029 22.1401 424.069 21.93 424.089 21.73C424.109 21.53 423.889 21.3101 423.909 21.1201C423.929 20.9101 424.129 20.7401 424.159 20.5701C424.209 20.3001 424.079 20.02 424.189 19.96C424.269 19.92 424.069 19.78 424.069 19.58C423.919 19.6 423.919 19.7101 423.769 19.7001C423.639 19.7001 423.669 19.3601 423.539 19.3201C423.589 19.2801 423.619 19.22 423.649 19.17C423.699 19.04 423.729 18.9 423.729 18.77C423.729 18.72 423.519 18.7501 423.479 18.6901C423.379 18.5401 423.619 18.21 423.539 18.05C423.459 17.89 423.119 17.8601 423.049 17.7001C422.979 17.5401 422.899 17.39 422.819 17.23C422.729 17.09 422.619 16.95 422.499 16.83C422.399 16.69 422.499 16.34 422.369 16.23C422.339 16.21 422.139 16.08 422.169 16.05C422.279 16.02 422.409 16.0301 422.519 16.0601C422.599 16.1101 422.679 16.1701 422.749 16.2401C422.809 16.1501 422.869 16.1001 422.929 16.0101C422.949 16.0701 423.099 16.23 423.089 16.29C423.089 16.33 422.989 16.4001 422.969 16.4501C423.199 16.4401 423.439 16.3901 423.659 16.3201L423.719 15.98C423.589 15.85 423.249 15.92 423.109 15.8C423.059 15.76 423.069 15.5801 422.999 15.5601C422.849 15.5101 422.749 15.5601 422.609 15.5101C422.759 15.4201 422.829 15.29 422.979 15.28C423.029 15.28 423.089 15.28 423.139 15.28C423.039 15.1 423.119 14.89 423.019 14.71C422.889 14.52 422.689 14.39 422.469 14.34C422.279 14.29 422.029 14.42 421.819 14.41C421.579 14.4 421.359 14.2001 421.189 14.2001C421.129 14.2001 421.049 14.2401 420.979 14.2001C420.869 14.6801 420.769 14.8401 420.419 14.5601C420.409 14.5601 420.499 14.3101 420.489 14.3201C420.269 14.4001 420.079 14.54 419.949 14.72C419.829 14.92 419.569 15.0401 419.449 15.2401L419.669 15.3101C419.639 15.4601 419.629 15.6101 419.639 15.7601C419.639 15.9201 419.349 16.01 419.379 16.15C419.209 16.3 419.329 16.59 419.369 16.9C419.369 16.92 418.939 17.14 418.879 17.1C418.629 16.89 418.479 16.7 418.319 16.77C418.139 16.85 418.019 17.11 417.869 17.29C417.859 17.31 417.709 17.32 417.709 17.34C417.709 17.49 417.929 17.58 417.939 17.73C418.129 17.72 418.319 17.7301 418.499 17.7401C418.769 17.7101 419.039 17.54 419.129 17.64C419.219 17.74 418.999 18.02 419.029 18.28C419.039 18.42 419.029 18.5601 418.969 18.6901C418.909 18.8501 419.009 19.0901 418.909 19.2001C418.779 19.3401 418.739 19.54 418.619 19.67C418.499 19.81 418.049 19.7601 417.989 19.9301C417.929 20.0901 418.179 20.32 418.199 20.53C418.079 20.72 417.989 20.93 417.949 21.16C417.929 21.35 417.869 21.56 417.849 21.78C417.819 22 417.959 22.2401 417.929 22.4301C417.919 22.6301 417.849 22.8301 417.749 23.0001C417.559 23.1101 417.269 23.02 417.069 23.11C417.039 23.12 417.179 23.62 417.159 23.92C417.139 24.22 417.189 24.3401 417.169 24.3701C417.249 24.3901 417.169 24.6 417.239 24.64C417.349 24.71 417.589 24.78 417.579 24.84C417.549 25.01 417.499 25.19 417.459 25.36C417.389 25.53 417.319 25.69 417.239 25.85C417.039 26.38 417.589 26.4701 417.839 26.4901C417.809 26.3401 417.799 26.0901 417.759 25.9401C417.919 25.9301 417.929 25.7001 418.089 25.7001C418.189 25.7001 418.399 25.96 418.499 25.98C418.549 25.82 418.509 25.57 418.609 25.53C418.839 25.44 419.129 25.2301 419.349 25.3101C419.559 25.3901 419.389 25.53 419.359 25.66C419.339 25.79 419.569 26.02 419.509 26.15C419.479 26.22 419.479 26.3101 419.449 26.3701L419.179 26.2001C419.069 26.3201 419.179 26.6401 419.069 26.7601C418.959 26.8801 418.809 26.9501 418.699 27.0701C418.689 27.0801 418.489 26.9901 418.499 27.0101C418.499 27.1501 418.729 27.25 418.749 27.39C418.779 27.62 418.769 27.72 418.939 27.61C419.069 27.53 419.049 27.55 419.179 27.48C419.179 27.62 419.209 27.57 419.219 27.71C419.219 27.82 419.319 27.8901 419.339 28.0001C419.419 27.9001 419.609 27.94 419.699 27.85C419.739 27.81 419.669 27.69 419.719 27.67C419.729 27.86 419.939 28.03 419.939 28.21C419.939 28.4 419.739 28.5801 419.679 28.7401C419.619 28.9101 419.509 29.0701 419.369 29.1901C419.219 29.3001 419.049 29.3801 418.869 29.4301C418.819 29.2301 418.629 29.09 418.539 28.9C418.469 28.83 418.369 28.8001 418.269 28.8101C418.219 29.0001 418.369 29.0101 418.309 29.1901C418.179 29.1201 418.029 29.23 417.889 29.17C417.739 29.11 417.609 28.7101 417.469 28.7401C417.259 28.7901 417.049 28.81 416.829 28.8C416.599 28.78 416.359 28.86 416.179 28.71C416.029 28.59 416.079 28.3201 415.979 28.0701C415.979 28.0601 415.659 28.06 415.629 28.05C415.759 27.88 416.029 27.79 416.059 27.61C416.079 27.36 416.029 27.1001 415.909 26.8801C415.709 27.0101 415.459 27.3701 415.249 27.5001C415.149 27.2901 415.059 27.06 414.999 26.83C414.949 26.6 414.909 26.5801 414.709 26.5001C414.569 26.4401 414.499 26.9701 414.209 27.0601C414.139 27.0801 414.019 26.6401 413.929 26.6201C413.789 26.6001 413.659 26.9 413.539 26.96C413.299 27.06 413.029 27.07 412.779 26.98C412.619 26.92 412.579 26.62 412.369 26.4C412.249 26.27 411.919 26.31 411.749 26.33C411.639 26.33 411.529 26.38 411.459 26.47C411.389 26.56 411.359 26.67 411.369 26.78C411.379 27.01 411.299 27.31 411.129 27.35C410.949 27.4 410.739 26.8 410.549 26.85C410.379 26.92 410.199 26.9501 410.019 26.9501C409.839 26.9301 409.589 27.03 409.419 26.89C409.429 27.05 409.479 27.21 409.539 27.36C409.799 27.11 409.469 26.96 409.339 26.8C409.199 26.6 409.139 26.35 409.179 26.1C409.039 26.1 408.839 26.07 408.769 26.14C408.649 26.26 408.699 26.47 408.669 26.65C408.629 26.87 408.269 26.96 408.229 27.09C408.169 27.31 408.299 26.9 408.119 26.96C407.939 26.98 407.759 26.98 407.579 26.96C407.439 26.96 407.319 27.29 407.179 27.23C407.289 27.16 407.409 27.11 407.529 27.09C407.709 27.06 407.869 26.94 407.939 26.77C408.009 26.63 408.039 27.0501 408.029 26.8801C408.029 26.6801 407.849 26.53 407.819 26.41C407.719 26.03 407.669 26.7001 407.469 26.8701L407.379 26.77C407.279 26.86 407.109 26.88 406.999 26.97C406.649 27.27 406.799 27.1 406.819 26.8C406.639 26.85 406.279 26.8 406.109 26.86C405.939 26.93 405.879 27.26 405.709 27.34C405.539 27.42 405.399 26.9401 405.229 27.0101C405.059 27.0901 404.819 26.9901 404.649 27.0601C404.469 27.0901 404.289 27.1201 404.099 27.1301C403.919 27.1801 403.719 27.4101 403.529 27.4301C403.709 27.6501 403.779 27.6001 404.019 27.7601C404.259 27.9201 404.349 27.7801 404.579 27.9401C404.819 28.1001 404.869 28.0201 405.109 28.1801C405.349 28.3401 405.269 28.4601 405.499 28.6201C405.739 28.7801 405.719 28.8 405.959 28.96C406.199 29.12 406.149 29.19 406.379 29.35C406.619 29.51 406.629 29.49 406.869 29.65C407.109 29.81 407.149 29.74 407.389 29.9C407.629 30.06 407.649 30.0201 407.889 30.1801C408.129 30.3401 408.019 30.5 408.249 30.66C408.489 30.82 408.519 30.7701 408.759 30.9301C408.999 31.0901 408.959 31.1501 409.199 31.3101C409.439 31.4701 409.569 31.23 409.829 31.35C410.039 31.35 410.169 31.6501 410.359 31.6201C410.569 31.5601 410.749 31.44 410.899 31.29C411.039 31.15 411.239 31.08 411.429 31.09C411.669 31.13 411.899 31.2801 411.909 31.4301C411.939 31.7001 412.079 31.55 412.309 31.52C412.489 31.5 412.769 31.8001 412.969 31.7601C413.209 31.7101 413.559 31.42 413.669 31.59C413.729 31.69 413.749 32 413.909 32.03C414.069 32.06 414.369 31.77 414.429 31.85C414.559 32.02 414.669 32.27 414.859 32.39C415.059 32.5 415.429 32.4101 415.579 32.5701C415.709 32.7201 415.539 33.01 415.539 33.29C415.539 33.45 416.059 33.5401 416.199 33.7001C416.259 33.7701 416.739 33.5001 416.849 33.7001C416.929 33.8501 416.479 34.55 416.519 34.73C416.589 34.91 416.599 35.1 416.549 35.28C416.899 35.3 416.899 35.44 416.759 35.61C416.639 35.77 416.529 35.8701 416.589 36.0001C416.669 36.1501 416.569 36.4 416.639 36.55C416.729 36.7 416.879 36.81 417.039 36.86C417.169 36.91 417.279 36.8201 417.499 36.7601C417.619 36.7301 417.769 36.86 417.889 36.86C417.819 36.71 417.749 36.56 417.659 36.42C417.579 36.32 417.529 36.36 417.429 36.28C417.679 36.13 417.799 36.0301 418.049 35.8801C418.069 36.0801 417.949 36.22 418.009 36.4C418.069 36.56 418.399 36.46 418.509 36.6C418.719 36.6 418.799 36.8101 418.919 36.8101C419.169 36.8101 419.119 36.93 419.199 37.05C419.289 37.18 419.349 37.31 419.399 37.46C419.539 37.92 419.549 37.9801 419.169 37.9401C418.879 37.9401 418.599 37.9101 418.309 37.8801C418.219 37.8601 418.099 37.59 418.019 37.55C417.959 37.67 417.739 37.82 417.659 37.96C417.549 38.14 417.769 38.34 417.819 38.41C417.919 38.56 417.759 38.94 417.829 39.14C417.899 39.31 418.049 39.44 418.419 39.3C418.439 39.3 418.469 39.55 418.549 39.65C418.639 39.76 418.719 39.7201 418.829 39.8101C418.949 39.6901 418.949 39.73 419.049 39.59C419.089 39.7 419.039 39.8701 419.079 39.9901C419.309 40.1501 419.399 40.3 419.179 40.46C419.169 40.46 419.059 40.28 419.049 40.29C418.849 40.55 418.849 40.6 418.719 40.55C418.549 40.5 418.409 40.41 418.289 40.29C418.269 40.43 418.079 40.47 417.989 40.61C417.919 40.72 417.879 40.9001 418.159 41.0601C418.239 41.1601 418.279 41.29 418.269 41.42C418.229 41.57 418.149 41.7201 418.099 41.8701C418.059 42.0201 418.079 42.2 418.039 42.35C417.929 42.73 417.799 42.9401 418.109 43.0001C417.999 43.1701 418.249 43.28 418.179 43.42C418.079 43.6 417.759 43.63 417.719 43.78C417.679 43.95 417.919 44.1201 417.919 44.3101C417.919 44.4601 417.539 44.6701 417.569 44.8701L418.389 49.92ZM423.129 37.5001C423.159 37.5501 423.199 37.5501 423.239 37.6301C423.159 37.6801 423.089 37.61 423.019 37.66C422.989 37.6 422.919 37.63 422.939 37.6C422.989 37.54 423.069 37.5501 423.139 37.5101L423.129 37.5001ZM423.279 26.3C423.349 26.44 423.389 26.53 423.459 26.67C423.219 26.63 423.009 26.63 423.279 26.3ZM423.219 27.89C423.209 27.97 423.239 28.01 423.219 28.1C423.179 28.07 423.239 28.05 423.199 28.02C423.249 27.97 423.159 27.95 423.209 27.89H423.219ZM407.429 26.9401C407.429 26.9401 407.459 26.9601 407.449 26.9901C407.429 26.9401 407.529 26.91 407.519 26.86C407.539 26.89 407.409 26.9101 407.429 26.9401ZM398.969 48.17C398.949 48.11 398.899 48.05 398.919 48.03C399.089 47.86 399.319 47.81 399.489 47.66C399.589 47.74 399.609 47.6601 399.649 47.6901C399.429 47.8601 399.189 47.99 398.959 48.16L398.969 48.17ZM399.109 46.8801C399.199 46.9201 399.269 46.9 399.339 46.97C399.389 47.02 399.399 47.09 399.359 47.15C399.309 47.23 399.289 47.3201 399.209 47.3701C399.169 47.2801 399.079 47.2101 399.059 47.1201C399.039 47.0301 399.109 46.9701 399.109 46.8801ZM400.059 48.71C399.969 48.75 399.809 48.62 399.679 48.54C399.789 48.5 399.909 48.48 400.029 48.48C400.149 48.43 400.279 48.4 400.409 48.39C400.319 48.53 400.209 48.64 400.069 48.71H400.059ZM400.059 44.92C400.169 44.9 400.289 44.94 400.359 45.03C400.479 45.28 400.039 44.6701 400.049 44.9401C400.049 45.1801 400.289 45.3401 400.449 45.4401C400.639 45.5301 400.839 45.59 401.039 45.61C400.999 45.76 400.829 45.95 400.819 46.14C400.799 46.3 400.749 46.46 400.679 46.6C400.609 46.77 400.679 46.88 400.439 46.66C400.319 46.54 400.049 46.63 399.769 46.67C399.549 46.73 399.349 46.82 399.169 46.96L399.049 46.73C398.819 46.83 398.829 46.27 398.549 46.85C398.319 46.73 397.949 46.4901 397.719 46.3701C397.799 46.2901 397.889 46.22 397.959 46.22C398.279 46.26 398.609 46.15 398.829 45.92C398.959 45.8 398.979 45.58 399.129 45.47C399.269 45.37 399.419 45.2701 399.569 45.1801C399.719 45.0901 399.889 45.02 400.039 44.92H400.059ZM397.439 43.17C397.409 43.12 397.329 43.1001 397.349 43.0601C397.369 43.0101 397.459 43.0901 397.509 43.0601C397.559 43.1001 397.599 43.0301 397.649 43.0701C397.579 43.1201 397.509 43.12 397.439 43.17ZM404.339 27.41C404.399 27.4 404.459 27.4101 404.509 27.4301C404.399 27.4801 404.269 27.4101 404.179 27.4401C404.179 27.4401 404.179 27.4701 404.159 27.4301C404.219 27.4101 404.279 27.41 404.339 27.41ZM406.549 27.0701C406.469 27.0601 406.389 27.0201 406.329 26.9501C406.399 26.8901 406.489 27.36 406.559 27.35C406.629 27.35 406.689 26.8701 406.809 26.9501C406.689 27.0301 406.619 27.0701 406.549 27.0701ZM407.609 29.42C407.479 29.42 407.359 29.4201 407.239 29.3701C407.339 29.3301 407.449 29.3701 407.549 29.3701C407.639 29.3601 407.719 29.27 407.819 29.29C407.769 29.36 407.699 29.4101 407.619 29.4301L407.609 29.42ZM407.919 29.2501C407.919 29.1901 407.849 29.1801 407.889 29.1301C407.919 29.1601 407.849 29.1601 407.889 29.1801C407.849 29.2001 407.969 29.2401 407.929 29.2501H407.919ZM410.439 27.53C410.349 27.49 410.259 27.4401 410.179 27.3801C410.229 27.3401 410.309 27.4 410.469 27.27C410.509 27.35 410.549 27.3301 410.559 27.4301C410.559 27.4801 410.459 27.54 410.439 27.53ZM413.489 28.27C413.439 28.41 413.449 28.58 413.399 28.72C413.359 28.64 413.339 28.5501 413.339 28.4501C413.269 28.0801 413.359 28.0701 413.639 28.1201C413.599 28.1701 413.509 28.2001 413.489 28.2601V28.27ZM415.169 27.4901C415.169 27.4901 415.169 27.4401 415.189 27.4301C415.169 27.4501 415.129 27.36 415.109 27.39C415.109 27.37 415.159 27.5001 415.169 27.4901ZM414.139 27.55C414.139 27.55 414.279 27.4 414.289 27.41C414.409 27.52 414.389 27.6601 414.509 27.8101C414.419 27.9301 414.469 27.9801 414.409 28.0601C414.299 27.9001 414.229 27.72 414.139 27.55ZM414.959 30.67C414.759 30.48 414.599 30.27 414.469 30.03C414.419 29.88 414.609 29.71 414.669 29.54C414.699 29.43 414.749 29.32 414.829 29.23C414.929 29.31 414.989 29.42 415.009 29.54C414.959 29.56 414.759 29.57 414.719 29.59C414.719 29.78 414.749 29.96 414.779 30.15C414.849 30.34 415.109 30.46 415.189 30.65C415.089 30.67 414.989 30.7 414.959 30.67ZM414.859 28.4401C414.859 28.3401 414.819 28.1901 414.829 28.1901C415.099 28.1501 415.309 28.2201 415.579 28.1901C415.549 28.4401 415.489 28.4201 415.339 28.4401C415.179 28.4601 414.999 28.3701 414.859 28.4401ZM415.489 29.4501C415.439 29.4201 415.389 29.39 415.349 29.34C415.409 29.32 415.439 29.38 415.479 29.4C415.519 29.42 415.579 29.4 415.609 29.46C415.569 29.48 415.529 29.48 415.489 29.46V29.4501ZM415.879 30.85C415.879 30.85 415.879 30.8 415.899 30.79C415.879 30.81 415.829 30.7301 415.809 30.7501C415.809 30.7301 415.869 30.86 415.879 30.85ZM416.099 33.78C416.119 33.69 416.059 33.6 416.099 33.55C416.159 33.5 416.169 33.56 416.259 33.55C416.209 33.63 416.259 33.64 416.199 33.71C416.159 33.76 416.139 33.75 416.089 33.78H416.099ZM416.429 33.36L416.449 33.41C416.449 33.41 416.509 33.49 416.529 33.47C416.529 33.48 416.449 33.35 416.439 33.36H416.429ZM416.919 30.3C416.789 30.46 416.689 30.65 416.519 30.73C416.349 30.81 416.249 30.7601 416.029 30.7001C416.099 30.5501 416.059 30.38 416.159 30.36C416.449 30.28 416.619 30.17 416.679 30.03C416.779 29.82 416.709 29.5701 416.519 29.4401C416.599 29.3601 416.549 29.4401 416.609 29.4501C416.829 29.4801 417.009 29.49 417.069 29.71C417.119 29.92 417.069 30.14 416.919 30.3ZM418.759 29.48C418.739 29.57 418.759 29.6101 418.759 29.7001C418.719 29.6701 418.779 29.6601 418.739 29.6301C418.799 29.5701 418.709 29.5401 418.769 29.4901L418.759 29.48ZM418.719 35.11C418.719 35.11 418.789 35.1401 418.829 35.1901C418.789 35.2401 418.759 35.18 418.709 35.22C418.659 35.15 418.589 35.2001 418.539 35.1301C418.599 35.1001 418.659 35.09 418.719 35.1V35.11ZM418.669 36.34C418.519 36.34 418.369 36.33 418.219 36.3C418.249 36.13 418.399 36.23 418.509 36.11C418.589 36.08 418.629 35.9301 418.659 35.9501C418.759 36.0401 418.839 36.1501 418.919 36.2601C418.839 36.3101 418.759 36.33 418.669 36.33V36.34ZM422.989 43.35C423.089 43.56 423.169 43.79 423.239 44.02C423.239 44.02 423.159 44.04 423.149 44.02C423.049 43.81 422.859 43.6501 422.779 43.4301C422.759 43.3601 422.749 43.29 422.759 43.21C422.849 43.22 422.929 43.27 422.989 43.35ZM422.669 43.1201C422.669 43.1201 422.729 43.17 422.749 43.21C422.699 43.2 422.749 43.1301 422.699 43.1201C422.729 43.0901 422.639 43.1501 422.669 43.1201ZM422.619 45.22C422.709 45.14 422.809 45.0901 422.919 45.0601C422.889 45.1501 422.799 45.1801 422.739 45.2401C422.679 45.3001 422.659 45.4001 422.569 45.4401C422.549 45.3601 422.569 45.28 422.619 45.21V45.22ZM422.519 45.54C422.569 45.79 422.119 45.8501 422.389 46.2001C422.569 46.4301 422.439 46.5101 422.129 46.3801C421.949 46.3001 421.729 46.31 421.549 46.22C421.659 46.08 421.729 45.88 421.869 45.79C422.079 45.69 422.289 45.6 422.519 45.54ZM422.559 27.9501C422.649 27.9201 422.739 27.9 422.829 27.9C422.789 28 422.669 28.0201 422.619 28.1201C422.419 28.1901 422.289 28.36 422.089 28.41C422.039 28.33 421.999 28.24 421.959 28.14C422.149 28.06 422.349 28.0001 422.549 27.9501H422.559ZM421.939 38.5601C421.889 38.5801 421.869 38.6401 421.829 38.6301C421.779 38.6001 421.869 38.53 421.829 38.47C421.879 38.43 421.809 38.39 421.859 38.35C421.899 38.42 421.889 38.4801 421.939 38.5601ZM421.799 34.9C421.719 34.98 421.629 35.0601 421.539 35.1201C421.539 35.0301 421.579 35.0301 421.609 35.0101C421.689 34.9501 421.719 34.83 421.819 34.79C421.819 34.84 421.819 34.88 421.799 34.9ZM421.319 44.54C421.349 44.45 421.399 44.37 421.469 44.3C421.489 44.36 421.449 44.3901 421.429 44.4401C421.409 44.6101 421.369 44.7801 421.299 44.9401C421.269 44.8101 421.279 44.68 421.309 44.55L421.319 44.54ZM421.159 42.22C421.159 42.22 421.059 42.1401 421.069 42.1201C421.129 42.0501 421.209 42.12 421.279 42.08C421.309 42.14 421.339 42.0801 421.389 42.1901C421.309 42.2101 421.229 42.22 421.149 42.22H421.159ZM421.729 29.92C421.729 29.92 421.769 29.94 421.779 29.98C421.709 29.98 421.729 29.9401 421.659 29.9501C421.709 29.9001 421.669 29.97 421.729 29.92ZM421.539 28.4301C421.589 28.4901 421.619 28.4701 421.659 28.5101C421.579 28.5601 421.459 28.51 421.379 28.54C421.359 28.54 421.379 28.61 421.349 28.59C421.409 28.52 421.479 28.5001 421.539 28.4301ZM421.229 38.02C421.239 38.11 421.279 38.1601 421.289 38.2501C421.179 38.2001 421.169 38.13 421.059 38.08C421.159 38.04 421.119 38.06 421.229 38.02ZM420.759 38.39L420.729 38.33C420.949 38.47 421.159 38.6401 421.339 38.8201C421.429 38.9301 421.469 39.0601 421.459 39.2001C421.309 39.2001 421.029 39.2501 421.009 39.1901C420.939 39.0301 420.939 38.79 420.819 38.72C420.699 38.65 420.659 38.82 420.479 38.84C420.609 38.58 420.559 38.5901 420.759 38.3801V38.39ZM419.809 44.0601C419.759 44.0101 419.729 44.0001 419.669 43.9501C419.709 43.9201 419.689 43.9701 419.729 43.9501C419.739 44.0301 419.799 43.9801 419.809 44.0601ZM420.019 16.8101C420.019 16.8101 420.049 16.84 420.049 16.85L420.139 16.9301L420.019 16.8201V16.8101ZM419.979 29.2601C420.029 29.3101 420.089 29.31 420.139 29.36C420.069 29.36 420.059 29.2601 419.989 29.2601C420.009 29.2201 419.949 29.3101 419.979 29.2601ZM419.929 38.77C419.929 38.77 419.949 38.75 419.939 38.73C419.909 38.69 419.879 38.64 419.859 38.59C419.829 38.63 419.919 38.72 419.929 38.77ZM420.359 29.61C420.319 29.52 420.249 29.48 420.209 29.4C420.299 29.44 420.289 29.54 420.379 29.59C420.329 29.63 420.409 29.5701 420.369 29.6201L420.359 29.61ZM420.379 16.5701C420.319 16.6201 420.289 16.7101 420.219 16.7501C420.279 16.6501 420.449 16.5401 420.489 16.3701C420.519 16.3901 420.439 16.37 420.459 16.39C420.489 16.42 420.429 16.5301 420.379 16.5701ZM420.189 14.96C420.139 15.03 420.119 15.1401 420.069 15.2001C420.099 15.1101 420.219 15.0901 420.249 15.0001C420.279 15.0201 420.189 14.96 420.189 14.96ZM419.979 15.34C419.959 15.43 419.979 15.4801 419.969 15.5601C419.929 15.5301 419.989 15.51 419.949 15.47C420.009 15.42 419.919 15.39 419.979 15.34ZM419.619 15.11C419.619 15.11 419.649 15.1701 419.619 15.1901L419.679 15.27C419.679 15.27 419.599 15.1301 419.609 15.1201L419.619 15.11ZM419.279 18.96C419.299 19.04 419.369 19.09 419.379 19.16C419.349 19.11 419.399 18.9901 419.379 18.9401C419.379 18.9401 419.269 18.98 419.279 18.96ZM419.429 19.3201C419.559 19.4301 419.689 19.48 419.819 19.59C419.679 19.68 419.529 19.75 419.379 19.79C419.269 19.85 419.149 19.89 419.029 19.9C419.159 19.69 419.299 19.54 419.429 19.33V19.3201ZM418.859 19.98C418.789 20.03 418.779 20.04 418.709 20.09C418.709 20.09 418.729 20.13 418.709 20.09C418.799 20.07 418.779 19.99 418.869 19.97L418.859 19.98ZM418.549 20.7001C418.599 20.6501 418.589 20.59 418.639 20.58C418.789 20.55 418.809 20.76 418.909 21.05C419.019 21.23 419.099 21.41 419.179 21.61C419.219 21.8 419.289 22 419.329 22.21C419.359 22.41 419.239 22.64 419.269 22.84C419.299 23.05 419.269 23.26 419.299 23.46C419.329 23.68 419.529 23.86 419.559 24.05C419.609 24.28 419.669 24.5 419.739 24.72C419.469 24.69 419.239 24.52 419.139 24.27C419.089 24.11 419.279 23.8401 419.229 23.6201C419.189 23.4301 418.919 23.2701 418.889 23.0701C418.859 22.8701 418.979 22.6501 418.949 22.4501C418.919 22.2401 418.989 22.03 418.959 21.84C418.919 21.62 418.979 21.39 418.939 21.22C418.899 21 418.759 20.81 418.549 20.71V20.7001ZM419.449 26.5601C419.399 26.5201 419.319 26.5101 419.299 26.4501C419.279 26.4001 419.339 26.4301 419.329 26.3701C419.379 26.4001 419.369 26.3401 419.409 26.3701C419.469 26.4201 419.529 26.47 419.579 26.53C419.539 26.55 419.489 26.56 419.449 26.55V26.5601ZM419.589 30.3701C419.559 30.2801 419.539 30.18 419.519 30.09C419.579 30.14 419.619 30.2201 419.619 30.3101C419.649 30.4101 419.649 30.5301 419.619 30.6301C419.589 30.5501 419.579 30.4601 419.569 30.3801L419.589 30.3701ZM419.449 38.35C419.449 38.35 419.419 38.2801 419.449 38.2501C419.449 38.2701 419.389 38.21 419.379 38.22C419.379 38.22 419.469 38.35 419.459 38.35H419.449ZM419.249 38.77C419.159 38.63 419.059 38.54 418.969 38.4C419.089 38.38 419.129 38.43 419.249 38.41C419.219 38.57 419.279 38.6101 419.249 38.7601V38.77ZM419.579 47.35C419.639 47.31 419.779 47.37 420.059 47.47C419.869 47.6 419.659 47.7001 419.439 47.7601C419.349 47.7901 419.249 47.77 419.169 47.72C419.289 47.58 419.429 47.45 419.589 47.35H419.579ZM419.899 48.53C419.809 48.38 419.729 48.29 419.639 48.14C419.769 48.11 419.799 48.1401 419.929 48.1201C419.889 48.2901 419.929 48.35 419.899 48.53ZM419.969 48.98C419.969 48.85 419.919 48.77 419.919 48.64C419.989 48.68 419.949 48.74 420.019 48.78C419.959 48.86 420.029 48.89 419.969 48.98ZM419.789 45.7001C419.799 45.6401 419.769 45.5801 419.809 45.5601C419.889 45.5201 419.969 45.63 420.059 45.61C420.059 45.67 420.109 45.61 420.129 45.71C420.009 45.72 419.909 45.69 419.789 45.71V45.7001ZM418.999 41.3201C419.069 41.3201 419.149 41.36 419.299 41.48C419.179 41.55 419.029 41.57 418.889 41.55C418.789 41.53 418.689 41.47 418.629 41.39C418.749 41.35 418.869 41.33 418.999 41.33V41.3201ZM418.459 44.5601C418.459 44.5601 418.459 44.4701 418.489 44.4401C418.469 44.4901 418.359 44.48 418.339 44.54C418.339 44.51 418.449 44.5801 418.459 44.5701V44.5601ZM418.599 44.3101C418.679 44.2001 418.709 44.1201 418.789 44.0101C418.839 44.0801 418.789 44.1 418.849 44.17C418.719 44.2 418.729 44.2701 418.599 44.3101ZM419.039 48.7001C419.039 48.7001 418.939 48.73 418.879 48.72C418.939 48.64 419.039 48.67 419.099 48.59C419.149 48.64 419.169 48.57 419.159 48.59C419.139 48.65 419.089 48.6701 419.039 48.6901V48.7001ZM419.199 49.39C419.319 49.42 419.449 49.4001 419.569 49.4401C419.519 49.5601 419.499 49.5101 419.479 49.5601C419.369 49.4901 419.259 49.54 419.149 49.47C419.149 49.47 419.189 49.39 419.199 49.39ZM419.329 50.36C419.379 50.3 419.389 50.27 419.439 50.21C419.469 50.25 419.419 50.23 419.449 50.28C419.369 50.29 419.409 50.35 419.329 50.36ZM419.659 54.7501C419.639 54.6601 419.559 54.6001 419.539 54.5101C419.589 54.5801 419.539 54.71 419.589 54.78C419.589 54.78 419.679 54.7301 419.659 54.7501ZM419.819 53.4501C419.779 53.3101 419.699 53.2701 419.719 53.2001C419.739 53.1401 419.839 53.2201 419.909 53.1801C419.949 53.2401 420.029 53.2 420.019 53.23C419.989 53.31 419.919 53.3201 419.819 53.4501ZM420.339 54.9901C420.269 54.91 420.179 54.8901 420.109 54.8201C420.159 54.7801 420.229 54.8501 420.359 54.7401C420.409 54.8201 420.459 54.8 420.489 54.9C420.489 54.94 420.409 54.9501 420.349 55.0001L420.339 54.9901ZM419.469 45.02L419.409 45.04C419.409 45.04 419.549 45.07 419.559 45.05C419.689 44.85 419.739 44.66 419.909 44.61C420.109 44.56 420.319 44.6101 420.469 44.7401C420.519 44.7801 420.439 44.8001 420.469 44.8801C420.269 44.9201 420.069 45 419.889 45.1C419.719 45.17 419.659 45.3001 419.469 45.0101V45.02ZM420.789 53.46C420.719 53.43 420.669 53.37 420.649 53.3C420.649 53.2901 420.749 53.3101 420.789 53.3201C420.869 53.3401 420.959 53.3 421.089 53.4C420.929 53.46 420.859 53.48 420.789 53.46ZM421.119 47.9501C421.199 47.9001 421.259 47.81 421.309 47.84C421.509 47.93 421.659 48.1401 421.879 48.2501C422.069 48.3401 422.309 48.35 422.549 48.46C422.269 48.63 422.119 48.8 422.049 48.78C421.889 48.72 421.849 48.44 421.709 48.33C421.519 48.18 421.299 48.1 421.109 47.96L421.119 47.9501ZM422.359 51.39C422.299 51.42 422.299 51.4601 422.239 51.4901C422.189 51.4501 422.239 51.4101 422.189 51.3801C422.249 51.3501 422.189 51.2901 422.249 51.3C422.309 51.3 422.299 51.36 422.359 51.39ZM421.779 54.15C421.759 54.1 421.689 54.1 421.679 54.04C421.679 54.02 421.789 54.0901 421.809 54.0601C422.119 53.8501 422.179 53.6801 422.309 53.8101C422.449 53.9801 422.559 54.1701 422.649 54.3701C422.509 54.3401 422.359 54.18 422.209 54.15C422.059 54.12 421.919 54.17 421.769 54.14L421.779 54.15ZM423.079 52.27C423.059 52.21 423.009 52.17 423.039 52.14C423.099 52.06 423.189 52.1401 423.269 52.0701C423.329 52.1301 423.369 52.05 423.409 52.09C423.299 52.17 423.189 52.1901 423.079 52.2601V52.27ZM423.679 51.58C423.679 51.58 423.679 51.53 423.689 51.52C423.669 51.55 423.609 51.4601 423.589 51.4901C423.589 51.4701 423.659 51.59 423.679 51.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.51 56.6901C419.51 56.6901 419.43 56.6901 419.39 56.6901C419.01 56.6501 418.64 56.5801 418.28 56.4701C418.24 56.4701 418.19 56.4701 418.15 56.4501C417.93 56.3701 417.79 56.1601 417.81 55.9301C417.81 55.9001 417.82 55.8601 417.84 55.8301C417.81 55.5901 417.97 55.3701 418.2 55.3101V55.2901C418.2 55.2901 418.13 55.2201 418.11 55.1901C418.03 55.1001 417.96 54.9901 417.91 54.8701C417.9 54.8401 417.88 54.8101 417.86 54.7801C417.8 54.7301 417.75 54.6801 417.7 54.6301C417.67 54.6001 417.64 54.5601 417.6 54.5301C417.31 54.4601 417.09 54.2301 417.04 53.9401C417.02 53.8201 417.6 53.4001 418.13 53.1301C418.14 53.1101 418.19 53.0501 418.24 52.9801C418.16 52.7901 418.17 52.5901 418.27 52.4101L418.3 52.3201C418.3 52.3201 418.3 52.2801 418.25 52.2601C418.17 52.2201 418.1 52.1601 418.05 52.0801C418.05 52.0901 418.02 52.0801 417.99 52.0601C417.82 51.9701 417.69 51.8301 417.6 51.6701C417.49 51.4301 417.51 51.1401 417.66 50.9201C417.8 50.7201 418.01 50.5901 418.25 50.5501C418.23 50.4201 418.22 50.3001 418.23 50.1701C418.23 50.0901 418.25 50.0201 418.27 49.9401C418.27 49.9201 418.27 49.9001 418.28 49.8901L418 49.6801C418.15 49.5101 418.35 49.4001 418.57 49.3701C418.64 49.3501 418.72 49.3501 418.8 49.3701C418.8 49.3701 418.83 49.2901 418.86 49.2601H418.85C418.7 49.2301 418.58 49.1201 418.52 48.9801C418.46 48.8401 418.49 48.6801 418.58 48.5501C418.65 48.4501 418.76 48.3801 418.87 48.3401C418.93 48.2901 419 48.2601 419.08 48.2401C419.06 48.2401 419.04 48.2201 419.01 48.2101C418.88 48.1501 418.79 48.0301 418.77 47.8901C418.74 47.7501 418.78 47.6101 418.87 47.5001C419.02 47.3301 419.19 47.1801 419.38 47.0501C419.62 46.8901 419.86 46.9801 420.14 47.0801L420.26 47.1201C420.42 47.1801 420.53 47.3101 420.56 47.4801C420.58 47.6501 420.51 47.8101 420.38 47.9101L420.33 47.9401C420.41 48.0401 420.44 48.1701 420.42 48.2901C420.42 48.3201 420.42 48.3501 420.42 48.3801C420.42 48.4401 420.42 48.5001 420.42 48.5501C420.52 48.6801 420.55 48.8501 420.5 49.0001C420.5 49.1201 420.45 49.2301 420.38 49.3301C420.31 49.4201 420.2 49.4901 420.08 49.5001C420.08 49.5601 420.08 49.6201 420.05 49.6801C420.01 49.7801 419.96 49.8701 419.88 49.9401C419.87 49.9501 419.85 49.9701 419.84 49.9801C419.85 49.9901 419.87 50.0101 419.88 50.0301C419.93 50.1001 419.95 50.1701 419.96 50.2601C420 50.4401 419.93 50.6201 419.78 50.7301C419.75 50.7601 419.72 50.7901 419.69 50.8101C419.62 51.0501 419.46 51.2601 419.25 51.3901C419.09 51.4801 418.91 51.5201 418.73 51.4901C419.14 51.7001 419.32 52.1901 419.15 52.6101C419.15 52.6301 419.14 52.6501 419.13 52.6601C419.2 52.7501 419.23 52.8701 419.23 52.9801C419.21 53.1601 418.35 53.5601 418.11 53.7801C418.2 53.8501 418.29 53.9301 418.36 54.0201C418.38 54.0501 418.41 54.0701 418.43 54.0901C418.52 54.1601 419.19 54.2501 419.24 54.3301C419.29 54.2601 419.35 54.2101 419.43 54.1701C419.63 54.0801 419.86 54.1501 419.98 54.3301C420.01 54.3701 420.03 54.4101 420.04 54.4501C420.08 54.4401 420.13 54.4301 420.17 54.4201C420.36 54.3001 420.62 54.3401 420.76 54.5201C420.87 54.6001 420.94 54.7201 420.97 54.8501C421 54.9801 420.97 55.1201 420.9 55.2301C421.07 55.2301 421.23 55.3201 421.35 55.4401C421.46 55.2401 421.62 55.0601 421.81 54.9301C421.96 54.8501 422.12 54.8001 422.28 54.7801V54.7301H422.25C422.25 54.7301 422.19 54.6801 422.16 54.6601C422.13 54.6601 422.1 54.6601 422.08 54.6601C421.97 54.6601 421.86 54.6601 421.75 54.6501C421.65 54.6301 421.57 54.5801 421.5 54.5101C421.4 54.4301 421.33 54.3201 421.3 54.2001C421.27 54.0801 421.3 53.9501 421.38 53.8401C421.36 53.8501 421.33 53.8701 421.31 53.8801C421.13 53.9801 420.92 54.0001 420.72 53.9601C420.57 53.9101 420.45 53.8101 420.36 53.6801C420.33 53.7101 420.31 53.7301 420.29 53.7501C420.27 53.7701 420.25 53.7901 420.23 53.8101C420.13 53.9401 419.96 54.0001 419.8 53.9701C419.64 53.9401 419.5 53.8201 419.46 53.6601C419.46 53.6401 419.45 53.6301 419.44 53.6201C419.35 53.4801 419.32 53.3101 419.36 53.1501C419.43 52.9101 419.67 52.7701 419.91 52.8101C419.97 52.8101 420.03 52.8101 420.09 52.8101C420.13 52.8201 420.17 52.8401 420.21 52.8601C420.3 52.8901 420.38 52.9401 420.44 53.0101C420.6 52.9101 420.8 52.8901 420.98 52.9601C421.14 52.9601 421.3 53.0101 421.42 53.1101C421.55 53.2101 421.62 53.3701 421.6 53.5301C421.6 53.6101 421.56 53.6801 421.52 53.7401C421.6 53.7001 421.68 53.6801 421.77 53.6801C421.8 53.6601 421.82 53.6401 421.84 53.6201C422.22 53.3001 422.49 53.3901 422.67 53.5401C422.76 53.4001 422.88 53.2801 423.03 53.2101C423.13 53.1501 423.22 53.0701 423.3 52.9801C423.3 52.9501 423.3 52.9201 423.3 52.8901C423.3 52.8501 423.3 52.8101 423.3 52.7701C423.19 52.8201 423.06 52.8101 422.95 52.7701C422.84 52.7201 422.75 52.6301 422.71 52.5201C422.6 52.3501 422.61 52.1301 422.73 51.9601C422.83 51.8301 422.99 51.7501 423.16 51.7401C423.18 51.7401 423.19 51.7301 423.21 51.7201C423.19 51.6601 423.18 51.6001 423.19 51.5401C423.13 51.4901 423.08 51.4401 423.03 51.3801L422.99 51.3301H422.95C422.95 51.3301 422.89 51.3601 422.85 51.3701C422.85 51.4101 422.86 51.4501 422.86 51.4901C422.86 51.6201 422.79 51.7501 422.69 51.8301C422.64 51.8901 422.58 51.9401 422.51 51.9701C422.36 52.0501 422.19 52.0401 422.05 51.9501C421.94 51.8801 421.87 51.7701 421.84 51.6501C421.81 51.5901 421.8 51.5201 421.8 51.4501C421.8 51.3801 421.83 51.3001 421.86 51.2401C421.88 51.1701 421.92 51.1101 421.97 51.0601C422 51.0301 422.04 51.0001 422.08 50.9801C422.08 50.8901 422.09 50.8001 422.14 50.7201C422.21 50.6101 422.3 50.5201 422.4 50.4401C422.36 50.4101 422.32 50.3801 422.28 50.3501C422.16 50.2601 422.1 50.1101 422.12 49.9601C422.13 49.8101 422.22 49.6801 422.36 49.6101C422.87 49.3401 423.25 49.2601 423.49 49.3901C423.52 49.4101 423.56 49.4301 423.6 49.4401C423.62 49.3601 423.63 49.2701 423.63 49.1901L423.6 49.1201C423.51 48.9401 423.44 48.7401 423.4 48.5401C423.38 48.4001 423.38 48.2601 423.39 48.1301C423.39 48.0901 423.39 48.0501 423.39 48.0001C423.14 47.9501 422.95 47.7401 422.91 47.4901C422.88 47.1701 422.97 46.8501 423.17 46.5901C423.17 46.5701 423.17 46.5401 423.16 46.5201C423.14 46.2801 423.19 46.0401 423.29 45.8201C423.22 45.7901 423.15 45.7601 423.09 45.7101C423.07 45.7401 423.05 45.7601 423.03 45.7901C423 45.9101 422.95 46.0101 422.88 46.1101C423.03 46.3101 423.04 46.5801 422.88 46.7801C422.78 46.9101 422.53 47.1001 422.03 46.8901C421.97 46.8701 421.91 46.8501 421.85 46.8501C421.7 46.8301 421.56 46.7901 421.43 46.7201C421.31 46.6601 421.22 46.5501 421.19 46.4101C421.16 46.2801 421.19 46.1401 421.28 46.0301C421.31 45.9901 421.33 45.9501 421.36 45.9101C421.44 45.7501 421.56 45.6101 421.7 45.5101C421.85 45.4101 422.02 45.3401 422.2 45.3001H422.22C422.24 45.1801 422.3 45.0701 422.38 44.9901C422.52 44.8601 422.69 44.7701 422.87 44.7201C422.9 44.7201 422.94 44.7101 422.97 44.7001C423 44.6401 423.04 44.5901 423.09 44.5301C422.97 44.4901 422.87 44.4101 422.82 44.3001C422.78 44.2301 422.74 44.1701 422.69 44.1101C422.58 43.9801 422.49 43.8301 422.43 43.6701C422.41 43.6201 422.4 43.5601 422.39 43.5001L422.37 43.4801C422.24 43.3001 422.26 43.0601 422.4 42.9001C422.5 42.7901 422.64 42.7401 422.78 42.7501C422.92 42.7501 423.05 42.8101 423.13 42.9201C423.28 43.0001 423.4 43.1101 423.46 43.2601L423.52 43.4001C423.55 43.4701 423.58 43.5401 423.61 43.6101L423.65 43.5901C423.65 43.5901 423.69 43.5701 423.71 43.5601C423.72 43.4201 423.73 43.2701 423.73 43.1301C423.73 43.0601 423.71 42.9901 423.68 42.9201C423.65 42.8301 423.63 42.7301 423.61 42.6301C423.59 42.6101 423.57 42.5801 423.54 42.5601C423.38 42.4201 423.28 42.2301 423.24 42.0301C423.23 41.8801 423.24 41.7201 423.27 41.5701V41.5101C423.2 41.4401 423.13 41.3601 423.06 41.2801C423 41.2001 422.93 41.1301 422.85 41.0701C422.71 40.9701 422.64 40.8001 422.67 40.6301C422.7 40.4601 422.82 40.3201 422.98 40.2701C423.03 40.2501 423.09 40.2401 423.14 40.2401C423.17 40.1501 423.21 40.0601 423.25 39.9801C423.27 39.9501 423.28 39.9201 423.29 39.8901C423.28 39.8201 423.27 39.7601 423.26 39.6901C423.09 39.7201 422.92 39.7101 422.76 39.6401C422.62 39.5701 422.51 39.4501 422.44 39.3201C422.44 39.3101 422.42 39.2901 422.41 39.2801C422.33 39.2201 422.27 39.1301 422.25 39.0301H422.23C422.15 39.1101 422.05 39.1601 421.95 39.1701C421.95 39.2101 421.95 39.2401 421.95 39.2701C421.95 39.4001 421.91 39.5201 421.83 39.6201C421.74 39.7201 421.62 39.7701 421.49 39.7601C421.46 39.7601 421.41 39.7601 421.36 39.7601C421.15 39.7801 420.8 39.8101 420.65 39.4801C420.64 39.4501 420.62 39.4201 420.61 39.3901H420.6C420.45 39.4201 420.3 39.3701 420.2 39.2601C420.06 39.3401 419.9 39.3401 419.76 39.2601C419.71 39.2301 419.67 39.2001 419.63 39.1601C419.56 39.2401 419.47 39.2901 419.37 39.3101H419.34C419.43 39.3601 419.49 39.4301 419.52 39.5201C419.55 39.6201 419.57 39.7301 419.56 39.8401C419.7 39.9701 419.79 40.1501 419.8 40.3401C419.8 40.5701 419.68 40.7801 419.49 40.9001C419.39 40.9701 419.27 41.0001 419.16 40.9801C419.33 41.0301 419.48 41.1101 419.61 41.2301C419.73 41.3301 419.8 41.4801 419.78 41.6401C419.76 41.8001 419.67 41.9301 419.52 42.0001C419.31 42.1101 419.07 42.1501 418.84 42.1001C418.76 42.0801 418.68 42.0601 418.61 42.0201C418.61 42.0401 418.6 42.0601 418.59 42.0801C418.59 42.1301 418.58 42.1801 418.57 42.2201C418.57 42.3401 418.55 42.4501 418.52 42.5601L418.47 42.7301V42.7601C418.47 42.7601 418.54 42.8501 418.56 42.9101C418.59 42.9801 418.6 43.0501 418.6 43.1201C418.71 43.3001 418.72 43.5201 418.63 43.7101C418.7 43.6801 418.78 43.6601 418.86 43.6601C419.01 43.6601 419.14 43.7401 419.22 43.8601C419.24 43.8901 419.26 43.9301 419.28 43.9701C419.3 43.8501 419.37 43.7401 419.47 43.6801C419.54 43.6301 419.62 43.6101 419.7 43.6001C419.87 43.5701 420.05 43.6401 420.15 43.7901C420.24 43.8701 420.29 43.9801 420.3 44.1001C420.3 44.1501 420.3 44.2101 420.3 44.2601C420.49 44.2901 420.67 44.3801 420.82 44.5001C420.86 44.5301 420.89 44.5701 420.92 44.6201C420.92 44.5801 420.94 44.5401 420.95 44.5001C421.01 44.3401 421.1 44.2001 421.22 44.0901C421.33 43.9901 421.47 43.9501 421.62 43.9801C421.76 44.0101 421.88 44.1001 421.94 44.2401C422.01 44.4001 422 44.5901 421.9 44.7401C421.9 44.7301 421.9 44.7401 421.9 44.7601C421.88 44.9301 421.83 45.1001 421.75 45.2601C421.67 45.4201 421.5 45.5101 421.32 45.5001C421.14 45.4901 420.99 45.3701 420.93 45.2001C420.93 45.2201 420.91 45.2401 420.9 45.2501C420.82 45.3601 420.7 45.4301 420.57 45.4501C420.54 45.4501 420.51 45.4601 420.49 45.4701C420.56 45.5501 420.61 45.6501 420.62 45.7601C420.64 45.8801 420.61 46.0101 420.53 46.1001C420.46 46.2001 420.34 46.2601 420.22 46.2701C420.13 46.2701 420.04 46.2701 419.95 46.2701C419.93 46.2701 419.9 46.2701 419.88 46.2701C419.75 46.2801 419.61 46.2401 419.51 46.1401C419.41 46.0401 419.37 45.9101 419.38 45.7801C419.38 45.7401 419.38 45.6901 419.38 45.6501C419.37 45.6501 419.36 45.6301 419.35 45.6201C419.32 45.6201 419.28 45.6201 419.25 45.6101H419.22C419.04 45.5501 418.91 45.3901 418.89 45.2001C418.88 45.0301 418.96 44.8801 419.1 44.7901C419.16 44.7401 419.23 44.7101 419.31 44.7001C419.34 44.7001 419.36 44.7001 419.39 44.7001C419.43 44.6301 419.48 44.5701 419.53 44.5101C419.48 44.4801 419.44 44.4501 419.4 44.4101C419.38 44.3901 419.36 44.3601 419.34 44.3401C419.34 44.3801 419.33 44.4301 419.31 44.4701C419.26 44.5901 419.17 44.6801 419.05 44.7301C419.01 44.7601 418.97 44.7901 418.93 44.8101C418.92 44.8501 418.9 44.8901 418.88 44.9301C418.76 45.1301 418.52 45.2001 418.31 45.1201C418.23 45.1101 418.15 45.0701 418.09 45.0201C418.07 45.0401 418.06 45.0601 418.04 45.0801C418.05 45.0501 418.06 45.0301 418.06 45.0001C418.04 44.9801 418.02 44.9601 418 44.9301L417.17 45.0601C417.15 44.8001 417.25 44.5501 417.45 44.3801C417.32 44.2101 417.28 43.9901 417.32 43.7801C417.38 43.6001 417.5 43.4501 417.67 43.3701C417.64 43.3401 417.61 43.3001 417.58 43.2601C417.47 43.0201 417.47 42.7301 417.58 42.4901L417.63 42.3401C417.63 42.3401 417.64 42.2501 417.64 42.2001C417.64 42.0901 417.66 41.9701 417.69 41.8601C417.72 41.7701 417.75 41.6801 417.79 41.5901C417.81 41.5501 417.82 41.5201 417.84 41.4801C417.69 41.3801 417.58 41.2201 417.53 41.0401C417.48 40.8401 417.53 40.6401 417.63 40.4701C417.7 40.3701 417.79 40.2801 417.89 40.2101C417.94 40.0901 418.04 40.0001 418.17 39.9601C418.17 39.9401 418.15 39.9301 418.14 39.9101C417.82 39.9101 417.54 39.7001 417.43 39.4001C417.37 39.2101 417.36 39.0001 417.4 38.8101C417.4 38.7701 417.41 38.7401 417.41 38.7001C417.18 38.4701 417.13 38.1101 417.29 37.8201C417.36 37.7101 417.45 37.6201 417.54 37.5301C417.58 37.5001 417.61 37.4601 417.64 37.4301C417.64 37.4101 417.66 37.3901 417.67 37.3801C417.62 37.3601 417.58 37.3501 417.55 37.3301L417.5 37.3501C417.31 37.4401 417.09 37.4601 416.89 37.3901C416.69 37.3101 417.02 36.5701 416.86 36.2601C416.79 36.1001 416.76 35.9301 416.78 35.7501C416.78 35.7201 416.78 35.6801 416.78 35.6501C416.69 35.4701 416.71 35.2501 416.83 35.0901C416.7 34.9501 416.67 34.7401 416.76 34.5701C416.76 34.5701 416.73 34.4901 416.71 34.4301L416.69 34.3201C416.69 34.3201 416.66 34.2901 416.64 34.2701C416.57 34.2001 416.51 34.1201 416.46 34.0301C416.39 33.8901 416.35 33.7401 416.36 33.5901C416.32 33.5401 415.68 34.0901 415.66 34.0301C415.42 33.9301 415.09 33.7801 415.09 33.4101C415.09 33.2801 415.11 33.1501 415.14 33.0201C414.96 33.0201 414.79 32.9701 414.63 32.8901C414.48 32.7901 414.34 32.6601 414.25 32.5101C414.12 32.5801 413.97 32.6001 413.83 32.5801C413.62 32.5401 413.45 32.4001 413.37 32.2001C413.27 32.2501 413.17 32.2801 413.07 32.3101C412.83 32.3401 412.59 32.2801 412.39 32.1401C412.36 32.1201 412.34 32.1101 412.31 32.0901H412.27C412.09 32.1801 411.89 32.1601 411.73 32.0701C411.6 31.9801 411.51 31.8501 411.49 31.7001C411.45 31.6801 411.41 31.6601 411.36 31.6601C411.35 31.6601 411.29 31.6701 411.19 31.7601C410.98 31.9701 410.71 32.1201 410.43 32.1901C410.2 32.2101 409.96 32.1301 409.8 31.9501C409.79 31.9401 409.77 31.9201 409.76 31.9101C409.72 31.9101 409.68 31.8901 409.64 31.8701C409.41 31.9601 409.15 31.9301 408.95 31.7901C408.84 31.7201 408.74 31.6301 408.65 31.5401C408.61 31.4901 408.56 31.4501 408.51 31.4201C408.46 31.3801 408.4 31.3501 408.34 31.3301C408.22 31.2801 408.11 31.2201 408.01 31.1501C407.85 31.0401 407.73 30.8901 407.66 30.7001C407.6 30.6401 407.53 30.5901 407.45 30.5601C407.34 30.5101 407.24 30.4501 407.14 30.3801C407.1 30.3501 407.05 30.3201 406.99 30.3101C406.86 30.2701 406.73 30.2101 406.62 30.1301C406.52 30.0601 406.46 30.0301 406.41 30.0001C406.34 29.9601 406.27 29.9201 406.14 29.8301C406.02 29.7501 405.92 29.6601 405.83 29.5501C405.8 29.5101 405.76 29.4701 405.71 29.4401C405.62 29.3801 405.53 29.3101 405.44 29.2401C405.38 29.1901 405.32 29.1401 405.25 29.1001C405.11 29.0101 404.99 28.8801 404.92 28.7301C404.92 28.7301 404.9 28.7068 404.86 28.6601C404.86 28.6601 404.78 28.6101 404.73 28.6001C404.59 28.5601 404.46 28.5001 404.34 28.4201L404.28 28.4001C404.1 28.4001 403.93 28.3301 403.78 28.2301C403.73 28.2001 403.68 28.1701 403.63 28.1401C403.46 28.0601 403.32 27.9501 403.2 27.8101C403.09 27.6801 403.06 27.5001 403.13 27.3501C403.19 27.1901 403.34 27.0901 403.51 27.0701C403.5 27.0701 403.57 27.0201 403.61 26.9901C403.72 26.9101 403.85 27.4301 404.01 27.3901C404.12 27.3601 404.24 27.3501 404.36 27.3501C404.41 27.3501 404.46 27.3501 404.51 27.3401C404.66 27.2901 404.82 27.2701 404.98 27.2901C405.02 27.2901 405.06 27.2901 405.1 27.2901C405.13 27.2701 405.19 27.2301 405.25 27.1901C405.33 27.1401 405.41 27.0901 405.5 27.0401C405.52 27.0201 405.53 26.9901 405.54 26.9601C405.63 26.7701 405.78 26.6201 405.97 26.5301C406.15 26.4701 406.33 26.4501 406.52 26.4601C406.59 26.4601 406.66 26.4601 406.73 26.4601C406.85 26.4301 406.99 26.4601 407.09 26.5301H407.12C407.12 26.5301 407.21 26.4501 407.26 26.4301C407.32 26.2501 407.43 25.9501 407.77 25.9501H407.79C408.02 25.9601 408.21 26.1301 408.25 26.3501C408.27 26.2001 408.34 26.0601 408.44 25.9501C408.61 25.8001 408.84 25.7301 409.06 25.7701C409.09 25.7701 409.12 25.7701 409.15 25.7701C409.28 25.7701 409.41 25.8201 409.5 25.9201C409.59 26.0201 409.63 26.1601 409.61 26.2901C409.59 26.4101 409.61 26.5401 409.68 26.6401C409.7 26.6601 409.72 26.6801 409.74 26.7001C409.91 26.8301 410.03 27.0201 410.07 27.2301C410.13 27.2301 410.19 27.2101 410.25 27.1901C410.31 27.1701 410.36 27.1601 410.42 27.1401C410.53 27.1101 410.64 27.0901 410.75 27.0801C410.79 27.0801 410.84 27.0701 410.88 27.0601C410.88 27.0101 410.89 26.9701 410.89 26.9201C410.87 26.6901 410.94 26.4701 411.08 26.3001C411.23 26.1301 411.44 26.0201 411.67 26.0101C412.02 25.9301 412.38 26.0101 412.67 26.2201C412.79 26.3501 412.88 26.5001 412.95 26.6501L412.98 26.7001C413.08 26.7201 413.18 26.7201 413.28 26.7001C413.29 26.6901 413.3 26.6701 413.31 26.6601C413.45 26.4301 413.71 26.2901 413.98 26.3101C414.21 26.3501 414.33 25.9201 414.42 26.0901C414.56 26.0901 414.69 26.1301 414.82 26.1901C415.12 26.2701 415.35 26.5101 415.41 26.8101C415.48 26.7401 415.56 26.6701 415.64 26.6201C415.74 26.5601 415.86 26.5301 415.98 26.5601C416.1 26.5901 416.2 26.6601 416.26 26.7601C416.44 27.0801 416.52 27.4401 416.48 27.8101C416.46 27.9001 416.43 27.9801 416.38 28.0601C416.42 28.1801 416.45 28.3101 416.47 28.4401V28.4801C416.47 28.4801 416.54 28.4801 416.57 28.4801C416.66 28.4801 416.74 28.4801 416.83 28.4801C417 28.4901 417.17 28.4801 417.33 28.4301C417.54 28.3901 417.75 28.4701 417.88 28.6401C417.96 28.5501 418.07 28.4901 418.2 28.4901C418.48 28.4501 418.75 28.5901 418.9 28.8301C418.93 28.8701 418.96 28.9101 418.99 28.9501L419.01 28.9801L419.04 28.9601C419.12 28.8901 419.18 28.8001 419.21 28.7001C419.23 28.6601 419.24 28.6201 419.27 28.5801C419.07 28.5801 418.9 28.4301 418.85 28.2301C418.75 28.2401 418.66 28.2301 418.57 28.1901C418.38 28.0901 418.26 27.8901 418.26 27.6701C418.11 27.5401 418.01 27.3601 417.99 27.1601C417.99 27.1101 417.99 27.0501 418.01 27.0001C417.93 27.0501 417.83 27.0801 417.73 27.0701C417.36 27.0701 417.02 26.9101 416.8 26.6201C416.65 26.3801 416.63 26.0901 416.75 25.8301C416.79 25.7401 416.83 25.6501 416.87 25.5701C416.9 25.5101 416.93 25.4501 416.95 25.3901L416.98 25.2801L417 25.2001C417 25.2001 416.96 25.1801 416.94 25.1701C416.78 25.0701 416.68 24.8901 416.69 24.7001V24.6701C416.65 24.6101 416.65 24.5401 416.65 24.4801C416.63 24.3301 416.63 24.1901 416.64 24.0401C416.64 23.8701 416.61 23.7001 416.58 23.5401C416.54 23.3301 416.48 23.0101 416.8 22.8601C416.96 22.7901 417.14 22.7601 417.32 22.7601H417.37C417.39 22.6801 417.41 22.5901 417.42 22.5101C417.42 22.5001 417.4 22.4301 417.39 22.3801C417.34 22.2201 417.32 22.0501 417.34 21.8801C417.35 21.7601 417.38 21.6501 417.4 21.5401C417.42 21.4401 417.44 21.3501 417.45 21.2701C417.48 21.0501 417.54 20.8401 417.65 20.6501V20.6201C417.49 20.4201 417.44 20.1601 417.51 19.9301C417.63 19.6801 417.89 19.5101 418.17 19.4901C418.2 19.4901 418.23 19.4901 418.25 19.4701C418.26 19.4501 418.28 19.4201 418.29 19.3901C418.33 19.2901 418.39 19.2001 418.45 19.1201V19.0901C418.43 18.9501 418.45 18.8101 418.49 18.6701C418.52 18.6001 418.53 18.5301 418.53 18.4501C418.53 18.4001 418.53 18.3601 418.53 18.3101H418.49C418.39 18.3201 418.29 18.3101 418.2 18.3101C418.12 18.3001 418.05 18.3001 417.97 18.3101C417.74 18.3501 417.52 18.2201 417.46 18.0001C417.32 17.8701 417.23 17.7001 417.21 17.5101C417.21 17.4201 417.23 17.3301 417.27 17.2501C417.33 17.1401 417.43 17.0701 417.55 17.0401L417.58 16.9901C417.7 16.7801 417.87 16.6201 418.08 16.5001C418.32 16.4001 418.6 16.4401 418.79 16.6201C418.77 16.4401 418.8 16.2601 418.9 16.1001C418.95 15.9701 419.03 15.8601 419.13 15.7801V15.7501C419.13 15.7501 419.08 15.7201 419.06 15.6901C418.92 15.5501 418.89 15.3301 418.99 15.1601C419.08 15.0101 419.2 14.8701 419.35 14.7601C419.41 14.7201 419.46 14.6701 419.5 14.6101C419.69 14.3401 419.96 14.1301 420.27 14.0301C420.37 13.9901 420.48 13.9901 420.59 14.0301C420.69 13.9201 420.84 13.8701 420.99 13.8901C421.04 13.8801 421.09 13.8701 421.14 13.8801C421.3 13.8901 421.45 13.9401 421.58 14.0201C421.64 14.0501 421.7 14.0801 421.77 14.1001C421.83 14.1001 421.88 14.0901 421.94 14.0701C422.13 14.0101 422.33 14.0001 422.53 14.0501C422.87 14.1301 423.16 14.3501 423.35 14.6401C423.42 14.7901 423.46 14.9501 423.46 15.1201C423.46 15.1501 423.46 15.1901 423.46 15.2201C423.52 15.3301 423.53 15.4701 423.49 15.5901C423.67 15.6101 423.84 15.6801 423.97 15.8001C424.05 15.8801 424.1 16.0001 424.1 16.1101C424.1 16.1101 424.08 16.2401 424.06 16.3601L424.03 16.5201C424.01 16.6601 423.92 16.7901 423.79 16.8501C423.59 16.9401 423.37 16.9901 423.15 17.0001H423.06C423.09 17.0501 423.12 17.1001 423.15 17.1501C423.22 17.2901 423.29 17.4301 423.36 17.5701C423.38 17.5701 423.4 17.5901 423.42 17.6001C423.61 17.6701 423.78 17.8101 423.88 17.9901C423.95 18.1601 423.96 18.3501 423.9 18.5201C423.95 18.5501 423.98 18.5901 424.02 18.6301C424.1 18.7301 424.12 18.8701 424.1 18.9901C424.1 19.0101 424.1 19.0501 424.09 19.0801C424.09 19.1501 424.07 19.2101 424.06 19.2801C424.28 19.3101 424.44 19.5001 424.44 19.7301C424.44 19.7101 424.46 19.7301 424.47 19.7501C424.57 19.8801 424.6 20.0501 424.57 20.2101C424.57 20.2401 424.55 20.2801 424.53 20.3101C424.55 20.4801 424.55 20.6401 424.53 20.8001C424.5 20.9401 424.44 21.0801 424.36 21.2001C424.34 21.2301 424.31 21.2701 424.3 21.3001C424.31 21.3201 424.32 21.3501 424.34 21.3701C424.44 21.5401 424.49 21.7301 424.48 21.9201C424.46 22.0801 424.44 22.2401 424.41 22.3901L424.39 22.5301C424.32 22.8001 424.13 23.0101 423.88 23.1201C423.86 23.1301 423.83 23.1501 423.81 23.1601C423.77 23.2801 423.71 23.3901 423.62 23.4801V23.5001C423.62 23.6501 423.62 23.8301 423.62 23.9701C423.63 24.1101 423.66 24.2401 423.69 24.3801H423.71C423.82 24.4401 423.93 24.5001 424.02 24.5701C424.14 24.6601 424.22 24.8001 424.24 24.9401C424.37 25.1201 424.35 25.3701 424.2 25.5201C424.22 25.5001 424.21 25.5801 424.22 25.6301C424.22 25.6801 424.22 25.7401 424.22 25.7901C424.22 25.8501 424.22 25.9201 424.22 25.9801C424.22 26.1301 424.22 26.2801 424.2 26.4301C424.2 26.4601 424.2 26.4901 424.2 26.5201C424.22 26.7301 424.16 26.9301 424.05 27.1001C424.05 27.1401 424.05 27.1901 424.05 27.2301C424.1 27.4101 424.11 27.6001 424.1 27.7901C424.1 27.9501 424.06 28.1101 423.98 28.2501C424.1 28.3501 424.19 28.4801 424.26 28.6201C424.35 28.8601 424.38 29.1101 424.36 29.3701C424.33 29.5901 424.22 29.7901 424.04 29.9201C424.01 29.9401 423.99 29.9701 423.97 29.9901C423.96 30.0201 423.94 30.0601 423.91 30.1101L423.85 30.2401C423.97 30.3901 424 30.5901 423.91 30.7601C423.99 30.8401 424.07 30.9201 424.13 31.0201C424.19 31.1201 424.22 31.2401 424.23 31.3601C424.34 31.4301 424.41 31.5401 424.43 31.6701C424.46 31.8701 424.44 32.0601 424.39 32.2501C424.38 32.3001 424.37 32.3501 424.36 32.4001C424.33 32.6801 424.1 32.9101 423.82 32.9301C423.82 32.9601 423.82 32.9901 423.83 33.0201C423.85 33.0801 423.88 33.1601 423.9 33.2401C423.94 33.3601 423.98 33.4901 424.02 33.6001C424.02 33.6201 424.04 33.6401 424.05 33.6601C424.21 33.8901 424.24 34.1901 424.12 34.4401C424.19 34.5701 424.21 34.7201 424.18 34.8701C424.23 35.0501 424.17 35.2301 424.02 35.3401C424.04 35.3801 424.06 35.4201 424.07 35.4701C424.11 35.6301 424.07 35.8001 423.97 35.9301C424.01 35.9701 424.04 36.0201 424.06 36.0801C424.17 36.2501 424.19 36.4701 424.12 36.6601C424.05 36.8501 423.9 37.0001 423.71 37.0701C423.99 36.9901 424.27 37.1501 424.36 37.4201C424.42 37.6601 424.32 37.9201 424.12 38.0601C424.2 38.1801 424.25 38.3201 424.25 38.4601C424.25 38.6801 424.14 38.8801 423.97 39.0201L423.95 39.0401C423.95 39.0401 424 39.1201 424.02 39.1701C424.07 39.3201 424.11 39.4801 424.12 39.6401C424.12 39.7101 424.14 39.7801 424.15 39.8401C424.18 40.0501 424.15 40.2601 424.03 40.4401C424.14 40.5401 424.18 40.6901 424.16 40.8301C424.14 40.9301 424.09 41.0201 424.02 41.0901C424.1 41.1901 424.14 41.3101 424.15 41.4301C424.15 41.5501 424.15 41.6801 424.12 41.8001C424.12 41.8601 424.1 41.9201 424.1 41.9601C424.12 41.9801 424.14 42.0001 424.16 42.0301C424.32 42.1701 424.43 42.3601 424.46 42.5701C424.47 42.6301 424.49 42.7001 424.51 42.7601C424.56 42.9101 424.59 43.0601 424.59 43.2201C424.59 43.4601 424.58 43.7001 424.54 43.9401C424.47 44.1901 424.28 44.3901 424.04 44.4801C424.02 44.4901 423.99 44.5101 423.96 44.5201C423.96 44.5301 423.96 44.5501 423.96 44.5701C423.96 44.7701 423.91 44.9601 423.8 45.1201H423.88C424.1 45.1701 424.26 45.3501 424.26 45.5701C424.26 45.7801 424.2 46.0001 424.11 46.1901C424.07 46.2801 424.04 46.3801 424.02 46.4801C424.18 46.7601 424.09 47.1201 423.82 47.2901C423.91 47.3301 423.99 47.3801 424.06 47.4501C424.24 47.6701 424.32 47.9601 424.27 48.2401C424.27 48.3201 424.27 48.4001 424.27 48.4801C424.3 48.6001 424.34 48.7201 424.4 48.8401L424.47 48.9901C424.57 49.3801 424.5 49.8001 424.28 50.1401C424.13 50.3301 423.89 50.4401 423.64 50.4401C423.66 50.5101 423.66 50.5801 423.64 50.6501C423.63 50.6901 423.61 50.7301 423.59 50.7701C423.62 50.8001 423.65 50.8301 423.68 50.8601C423.71 50.8901 423.74 50.9201 423.77 50.9501C423.91 50.9601 424.03 51.0601 424.07 51.2001C424.22 51.1901 424.36 51.2501 424.45 51.3601C424.59 51.5201 424.62 51.7501 424.52 51.9401C424.52 51.9601 424.52 51.9801 424.53 52.0001C424.57 52.1501 424.57 52.3101 424.53 52.4601C424.47 52.6201 424.37 52.7701 424.24 52.8901C424.21 52.9101 424.19 52.9401 424.17 52.9701C424.17 52.9701 424.17 53.0001 424.17 53.0401C424.17 53.2501 424.11 53.4601 423.98 53.6301C423.82 53.8301 423.63 53.9901 423.41 54.1101C423.47 54.2901 423.44 54.4901 423.35 54.6601C423.31 54.7301 423.24 54.8001 423.17 54.8501V54.8901C423.29 55.0601 423.31 55.2801 423.24 55.4701C423.17 55.6601 422.99 55.7801 422.79 55.7801C422.77 55.7801 422.75 55.7801 422.74 55.7801H422.73C422.57 55.7701 422.41 55.7801 422.25 55.8201C422.19 55.8901 422.13 55.9601 422.09 56.0401C422.01 56.1701 421.92 56.2901 421.82 56.4001C421.66 56.5501 421.43 56.6101 421.21 56.5301C421.04 56.5301 420.88 56.4401 420.78 56.3001C420.77 56.2801 420.75 56.2501 420.73 56.2301C420.67 56.2301 420.62 56.2101 420.56 56.2001C420.53 56.2001 420.49 56.1801 420.46 56.1801C420.46 56.2301 420.45 56.2901 420.43 56.3401C420.35 56.5101 420.19 56.6201 420 56.6201C419.85 56.7401 419.66 56.8101 419.46 56.8101L419.51 56.6901ZM420.13 53.4501L420.17 53.5201C420.17 53.5201 420.21 53.4501 420.22 53.4201L420.12 53.4501H420.13ZM421.03 53.1001L421.1 53.2601L421.18 53.2401C421.16 53.1701 421.11 53.1201 421.04 53.0901L421.03 53.1001ZM422.24 51.8001C422.24 51.8001 422.3 51.8101 422.33 51.8201V51.6501L422.24 51.8001ZM419.97 50.3801C419.96 50.4601 419.92 50.5401 419.87 50.6101C419.92 50.5501 419.96 50.4701 419.97 50.3801ZM419.6 49.6801L419.55 49.8201C419.55 49.8201 419.63 49.7501 419.65 49.7101L419.6 49.6801ZM418.93 48.3701C418.87 48.4201 418.83 48.4801 418.81 48.5501L419 48.6001V48.5401L418.93 48.3601V48.3701ZM418.93 48.3701L419.01 48.5501V48.4801L418.93 48.3701ZM418.51 38.9001C418.58 38.9001 418.66 38.9201 418.72 38.9501C418.84 39.0101 418.92 39.1201 418.95 39.2501C418.99 39.2301 419.03 39.2201 419.07 39.2201C419.01 39.1901 418.97 39.1401 418.93 39.0801C418.9 39.0301 418.86 38.9801 418.82 38.9301C418.76 38.8601 418.71 38.7901 418.65 38.7101C418.59 38.6201 418.56 38.5001 418.58 38.3901C418.5 38.3901 418.42 38.3701 418.34 38.3601C418.38 38.5201 418.38 38.6901 418.34 38.8601C418.34 38.8801 418.34 38.9001 418.34 38.9201C418.34 38.9201 418.44 38.8901 418.49 38.8901L418.51 38.9001ZM418.88 38.7501L419.09 38.7901L418.88 38.7501ZM421.95 37.9801C421.95 37.9801 422.01 37.9801 422.04 37.9801C422.16 38.0001 422.27 38.0801 422.34 38.1901C422.38 38.2601 422.41 38.3401 422.43 38.4201C422.45 38.4501 422.46 38.4901 422.47 38.5201C422.5 38.5001 422.53 38.4901 422.56 38.4801C422.59 38.4601 422.62 38.4501 422.65 38.4301C422.71 38.3901 422.78 38.3601 422.85 38.3301C422.91 38.2601 422.99 38.2001 423.07 38.1601C423.04 38.1601 423 38.1601 422.97 38.1401C422.92 38.1201 422.87 38.1001 422.82 38.0601C422.72 38.0101 422.65 37.9301 422.6 37.8301C422.54 37.6901 422.56 37.5201 422.65 37.3901C422.69 37.3301 422.75 37.2801 422.81 37.2401C422.8 37.2201 422.79 37.2001 422.77 37.1801C422.67 37.0801 422.63 36.9401 422.65 36.8101C422.67 36.6701 422.76 36.5501 422.88 36.4901C422.92 36.4601 422.96 36.4301 423 36.4001C423.06 36.3501 423.12 36.3001 423.18 36.2601C423.05 36.1601 422.97 36.0001 422.96 35.8401C422.96 35.7801 422.96 35.7301 422.99 35.6701C422.77 35.6401 422.57 35.5101 422.44 35.3301C422.39 35.2601 422.35 35.1801 422.32 35.1001C422.29 35.1901 422.24 35.2601 422.16 35.3201C422.16 35.3201 422.13 35.3501 422.11 35.3701C422.03 35.4601 421.94 35.5301 421.84 35.5901C421.7 35.6701 421.53 35.6701 421.4 35.5901C421.26 35.5101 421.18 35.3601 421.18 35.2101C421.18 35.0301 421.26 34.8501 421.41 34.7501C421.48 34.6301 421.59 34.5301 421.71 34.4701C421.84 34.4101 421.99 34.4101 422.12 34.4801L422.1 34.4201C422.07 34.2901 422.1 34.1601 422.17 34.0601C422.26 33.9501 422.39 33.8801 422.53 33.8601C422.75 33.7601 423.01 33.8601 423.11 34.0701C423.14 34.1101 423.18 34.1401 423.22 34.1601C423.24 34.0901 423.27 34.0301 423.3 33.9801C423.28 33.9401 423.26 33.9001 423.24 33.8701C423.18 33.7301 423.13 33.5701 423.08 33.4201C423.06 33.3501 423.04 33.2701 423.01 33.2101C423.01 33.2001 422.75 32.2501 423.3 32.0501C423.38 32.0201 423.46 32.0001 423.54 31.9801C423.54 31.9801 423.49 31.9201 423.48 31.8901C423.4 31.7501 423.37 31.5801 423.38 31.4201C423.38 31.4001 423.38 31.3801 423.38 31.3701C423.36 31.3501 423.32 31.3101 423.3 31.2901C423.22 31.2201 423.15 31.1401 423.08 31.0601C422.96 30.9201 422.91 30.7401 422.94 30.5601C422.89 30.5001 422.86 30.4201 422.84 30.3401C422.82 30.2101 422.86 30.0801 422.95 29.9801C423.02 29.8801 423.08 29.7601 423.13 29.6501C423.16 29.5901 423.19 29.5301 423.21 29.4801C423.28 29.3601 423.37 29.2601 423.47 29.1701L423.5 29.1401C423.5 29.0401 423.49 28.9501 423.45 28.8501C423.41 28.8201 423.37 28.7901 423.33 28.7601C423.28 28.7201 423.23 28.6701 423.18 28.6301C423.13 28.6201 423.08 28.6001 423.04 28.5701C423.03 28.5701 423.02 28.5501 423.01 28.5401C422.96 28.5901 422.91 28.6201 422.84 28.6401C422.79 28.6601 422.74 28.6901 422.7 28.7301C422.57 28.8301 422.43 28.9001 422.27 28.9401C422.19 28.9601 422.1 28.9701 422.02 28.9401C422 28.9601 421.97 28.9801 421.94 29.0001C421.85 29.0601 421.74 29.0901 421.63 29.0901C421.62 29.0901 421.6 29.1001 421.59 29.1101C421.44 29.1801 421.27 29.1601 421.14 29.0701C421.04 29.0001 420.97 28.8901 420.95 28.7701C420.93 28.6501 420.96 28.5201 421.04 28.4201C421.08 28.3501 421.15 28.2901 421.22 28.2501H421.25C421.34 28.1501 421.46 28.1001 421.58 28.0901H421.61C421.64 27.9901 421.71 27.9101 421.81 27.8501C421.96 27.7701 422.12 27.7101 422.29 27.6801C422.35 27.6701 422.42 27.6501 422.48 27.6301C422.62 27.5801 422.77 27.5501 422.92 27.5501C422.98 27.5501 423.03 27.5601 423.09 27.5901C423.14 27.5601 423.19 27.5501 423.24 27.5401C423.24 27.4901 423.24 27.4301 423.22 27.3801C423.2 27.3001 423.18 27.2201 423.18 27.1401C423.01 27.0901 422.88 26.9701 422.82 26.8101C422.75 26.5601 422.82 26.2901 423.01 26.1001C423.09 26.0001 423.22 25.9401 423.35 25.9401V25.9201C423.35 25.8301 423.35 25.7501 423.35 25.6601C423.35 25.6201 423.35 25.5901 423.35 25.5501C423.35 25.4101 423.35 25.2701 423.4 25.1301H423.37C423.26 25.0701 423.15 25.0101 423.05 24.9301C422.85 24.6501 422.75 24.3101 422.75 23.9601C422.73 23.8001 422.73 23.5801 422.74 23.4001C422.74 23.3201 422.74 23.2601 422.74 23.2101C422.69 22.9901 422.8 22.7701 423.01 22.6901V22.6701C423.1 22.4901 423.25 22.3401 423.44 22.2601C423.47 22.2401 423.5 22.2201 423.53 22.2101V22.1501C423.56 22.0201 423.59 21.8801 423.6 21.7401C423.6 21.7601 423.57 21.7101 423.55 21.6701C423.46 21.5101 423.41 21.3201 423.42 21.1301C423.45 20.9501 423.52 20.7701 423.62 20.6201C423.64 20.5901 423.66 20.5601 423.68 20.5201C423.68 20.4501 423.68 20.3801 423.67 20.3101C423.67 20.2801 423.67 20.2301 423.66 20.1901C423.41 20.1301 423.23 19.9301 423.19 19.6801C423.03 19.5101 423.02 19.2501 423.17 19.0701C423.14 19.0401 423.11 19.0101 423.09 18.9701C422.97 18.7601 422.96 18.5101 423.05 18.2901C422.87 18.2201 422.71 18.0801 422.62 17.9101C422.55 17.7601 422.48 17.6101 422.4 17.4601C422.36 17.4001 422.32 17.3501 422.27 17.3001C422.22 17.2401 422.17 17.1801 422.12 17.1201C422.02 16.9601 421.97 16.7701 421.98 16.5801V16.5401C421.82 16.4501 421.72 16.2901 421.7 16.1001C421.7 15.9601 421.76 15.8201 421.87 15.7301C421.95 15.6701 422.05 15.6301 422.15 15.6201C422.15 15.6001 422.15 15.5901 422.15 15.5701C422.14 15.4001 422.23 15.2401 422.38 15.1501C422.4 15.1301 422.43 15.1101 422.45 15.0901C422.5 15.0401 422.56 15.0001 422.62 14.9601V14.9401C422.54 14.8701 422.45 14.8201 422.35 14.8001C422.35 14.8001 422.26 14.8201 422.21 14.8301C422.07 14.8701 421.93 14.8901 421.79 14.8801C421.62 14.8701 421.45 14.8201 421.3 14.7401C421.23 14.9201 421.09 15.0701 420.9 15.1401C420.86 15.1601 420.81 15.1701 420.77 15.1701C420.76 15.2401 420.72 15.3101 420.68 15.3601C420.64 15.4201 420.58 15.4801 420.53 15.5201L420.51 15.5401C420.51 15.6001 420.51 15.6601 420.49 15.7201C420.44 15.9401 420.24 16.0901 420.02 16.0801C419.97 16.1701 419.9 16.2501 419.82 16.3101C419.81 16.3501 419.78 16.3901 419.76 16.4301C419.76 16.4701 419.77 16.5201 419.78 16.5701C419.85 16.5001 419.93 16.4501 420.03 16.4301L420.06 16.4001L420.09 16.3701C420.09 16.3701 420.11 16.3001 420.12 16.2701C420.16 16.1901 420.22 16.1301 420.29 16.0801C420.33 16.0501 420.36 16.0301 420.41 16.0201C420.55 15.9701 420.7 15.9901 420.82 16.0801C420.99 16.2001 421.06 16.4101 420.99 16.6101C420.99 16.6301 420.97 16.6501 420.96 16.6701V16.6901C420.91 16.7901 420.85 16.8901 420.77 16.9701C420.74 17.0201 420.7 17.0701 420.66 17.1101C420.64 17.1901 420.6 17.2601 420.54 17.3201C420.54 17.3201 420.52 17.3501 420.51 17.3601C420.51 17.3601 420.49 17.3701 420.48 17.3801C420.41 17.4401 420.31 17.4701 420.22 17.4601C420.09 17.4601 419.96 17.3901 419.87 17.3001C419.87 17.3001 419.84 17.2801 419.83 17.2701C419.81 17.2501 419.78 17.2201 419.77 17.2001C419.7 17.2901 419.62 17.3701 419.51 17.4201C419.65 17.6301 419.67 17.8901 419.55 18.1201C419.53 18.1801 419.51 18.2401 419.5 18.3101C419.5 18.4101 419.5 18.5201 419.49 18.6201C419.64 18.6201 419.78 18.7101 419.86 18.8401C419.91 18.9401 419.93 19.0501 419.92 19.1601L419.95 19.1801C420.03 19.2301 420.11 19.2801 420.19 19.3401C420.3 19.4201 420.36 19.5501 420.36 19.6901C420.36 19.8301 420.3 19.9601 420.19 20.0401C420.05 20.1401 419.89 20.2201 419.73 20.2701L419.57 20.3301C419.46 20.3901 419.34 20.4201 419.22 20.4401H419.21V20.4601C419.28 20.5701 419.34 20.7001 419.37 20.8301C419.39 20.8801 419.4 20.9401 419.43 21.0001C419.45 21.0401 419.47 21.0901 419.5 21.1301C419.6 21.2801 419.67 21.4401 419.71 21.6201C419.72 21.6901 419.75 21.7601 419.76 21.8301C419.8 21.9601 419.83 22.1001 419.86 22.2401C419.88 22.4001 419.86 22.5701 419.83 22.7301C419.82 22.7801 419.81 22.8301 419.8 22.8901C419.82 23.0201 419.82 23.1501 419.82 23.2801C419.82 23.3601 419.82 23.4401 419.82 23.5201C419.84 23.5701 419.87 23.6201 419.9 23.6701C419.99 23.8001 420.05 23.9501 420.08 24.1101C420.1 24.2401 420.14 24.3601 420.18 24.4801C420.21 24.5701 420.24 24.6501 420.26 24.7401C420.29 24.8601 420.26 24.9901 420.19 25.0901C420.12 25.1901 420.01 25.2601 419.88 25.2701V25.2901C419.94 25.4401 419.93 25.6001 419.86 25.7401C419.97 25.9101 420.01 26.1201 419.97 26.3201C419.98 26.3301 419.99 26.3501 420 26.3601C420.09 26.4601 420.12 26.6001 420.09 26.7401C420.06 26.8701 419.98 26.9901 419.86 27.0501C419.73 27.1201 419.59 27.1401 419.45 27.1101L419.43 27.1401H419.42L419.44 27.1601C419.5 27.2001 419.56 27.2501 419.6 27.3101C419.73 27.2601 419.88 27.2701 420 27.3501C420.12 27.4301 420.2 27.5501 420.21 27.6901C420.23 27.7101 420.25 27.7301 420.26 27.7601C420.37 27.9101 420.43 28.0901 420.43 28.2801C420.41 28.4901 420.33 28.6801 420.21 28.8401C420.2 28.8601 420.18 28.8801 420.17 28.9001C420.23 28.9001 420.29 28.9301 420.35 28.9701C420.37 28.9801 420.38 28.9901 420.4 29.0101C420.42 29.0301 420.44 29.0501 420.46 29.0701C420.48 29.0901 420.51 29.1001 420.53 29.1201C420.63 29.1801 420.7 29.2501 420.76 29.3501C420.84 29.4201 420.9 29.5201 420.91 29.6301C420.92 29.7101 420.91 29.8001 420.87 29.8801C420.84 29.9501 420.8 30.0101 420.75 30.0601C420.65 30.1501 420.51 30.1901 420.37 30.1701C420.23 30.1501 420.12 30.0601 420.05 29.9401C420.03 29.9101 420 29.8901 419.98 29.8601C419.95 29.8501 419.93 29.8301 419.91 29.8101C419.88 29.8001 419.85 29.7801 419.82 29.7701C419.76 29.7301 419.72 29.6801 419.68 29.6201C419.56 29.7101 419.43 29.7801 419.3 29.8401C419.3 29.8601 419.3 29.8801 419.3 29.9001C419.34 29.8601 419.38 29.8301 419.43 29.8101C419.58 29.7401 419.76 29.7501 419.89 29.8501C420.04 29.9701 420.14 30.1401 420.17 30.3401C420.22 30.5201 420.22 30.7101 420.17 30.8901C420.11 31.0701 419.95 31.1901 419.76 31.2001C419.57 31.2001 419.4 31.1001 419.33 30.9301C419.29 30.8301 419.27 30.7301 419.26 30.6301V30.5701C419.21 30.4501 419.18 30.3301 419.18 30.2001C419.18 30.1801 419.18 30.1601 419.18 30.1301C419.14 30.1701 419.09 30.2101 419.04 30.2301C418.9 30.2901 418.74 30.2801 418.62 30.1901C418.52 30.1201 418.46 30.0201 418.43 29.9101C418.41 29.8701 418.4 29.8301 418.4 29.7901C418.4 29.7701 418.4 29.7401 418.4 29.7201C418.35 29.7201 418.29 29.7201 418.24 29.7001C418.09 29.7301 417.93 29.7201 417.79 29.6701C417.63 29.5901 417.49 29.4601 417.41 29.3101H417.37C417.5 29.4101 417.59 29.5501 417.63 29.7101C417.72 30.0601 417.63 30.4301 417.39 30.7001C417.39 30.7001 417.34 30.7701 417.31 30.8101C417.19 30.9901 417.03 31.1501 416.84 31.2501C416.67 31.3401 416.47 31.3601 416.28 31.3201C416.27 31.3201 416.26 31.3401 416.25 31.3401C416.14 31.4101 416.02 31.4301 415.9 31.4001C415.77 31.3601 415.66 31.2701 415.6 31.1501V31.1301C415.54 31.1601 415.48 31.1901 415.42 31.2001C415.19 31.3001 414.92 31.2401 414.74 31.0601C414.69 31.0001 414.64 30.9501 414.59 30.8901C414.41 30.7201 414.27 30.5201 414.17 30.2901C414.1 30.0401 414.16 29.7701 414.32 29.5701C414.34 29.5401 414.36 29.5101 414.38 29.4701C414.43 29.3001 414.52 29.1401 414.64 29.0101C414.67 28.9801 414.72 28.9501 414.76 28.9301C414.64 28.8601 414.57 28.7401 414.55 28.6101C414.55 28.6101 414.54 28.6101 414.53 28.6101C414.39 28.6101 414.27 28.5401 414.19 28.4301C414.19 28.4501 414.17 28.4701 414.16 28.4901C414.13 28.5401 414.08 28.5901 414.04 28.6301V28.6801C414.02 28.7801 414 28.8901 413.97 28.9901C413.92 29.1501 413.78 29.2601 413.61 29.2901C413.44 29.3101 413.28 29.2401 413.18 29.1101C413.1 28.9901 413.05 28.8401 413.05 28.7001C412.97 28.4401 413.02 28.1601 413.19 27.9501C413.37 27.7901 413.63 27.7501 413.86 27.8201C413.8 27.6601 413.82 27.4401 414.13 27.2001C414.3 27.0701 414.53 27.0701 414.71 27.1901C414.69 27.1301 414.68 27.0801 414.67 27.0201H414.65L414.56 26.9701C414.56 26.9701 414.52 26.9501 414.45 26.9701C414.2 27.0501 414.04 27.5401 413.93 27.4001C413.9 27.4201 413.87 26.8301 413.84 26.8401C413.49 27.0001 413.1 27.0101 412.74 26.8901C412.48 26.8001 412.36 27.1801 412.28 27.0201C412.25 26.9601 412.22 26.9001 412.19 26.8501C412.1 26.8501 412.02 26.8501 411.93 26.8601C411.93 27.3001 411.76 27.1601 411.35 27.2601C411.27 27.2801 411.19 27.3001 411.1 27.3101C411.13 27.3701 411.15 27.4401 411.15 27.5101C411.17 27.7101 411.07 27.9101 410.89 28.0101C410.74 28.1201 410.53 28.1401 410.36 28.0501H410.35L410.3 28.0201C410.19 27.9701 410.1 27.9101 410.01 27.8301C409.92 27.7401 409.88 27.6301 409.88 27.5101C409.65 27.5401 409.42 27.4801 409.24 27.3401C409.13 27.2501 409.07 27.1201 409.07 26.9801C409.07 26.8501 409.12 27.3501 409.19 27.2801C409.16 27.2501 409.13 27.2201 409.1 27.1901L409.08 27.1601C408.99 27.2601 408.9 27.3401 408.78 27.4001C408.81 27.8601 408.57 27.4201 408.37 27.4801C408.27 27.5101 408.16 27.5201 408.06 27.5201C407.96 27.5801 407.84 27.6201 407.72 27.6301C407.56 27.7901 407.32 27.8301 407.11 27.7301C407.03 27.8501 406.9 27.9401 406.75 27.9501C406.37 27.9801 406.24 27.6201 406.18 27.4501V27.4201C406.11 27.3601 406.07 27.2901 406.05 27.2101H406.04C405.98 27.2501 405.92 27.2801 405.86 27.3201C405.76 27.3901 405.66 27.4401 405.56 27.5001C405.42 27.5601 405.27 27.5801 405.12 27.5701C405.12 27.6201 405.12 27.6601 405.09 27.7101H405.1C405.24 27.7501 405.37 27.8101 405.49 27.9001C405.63 27.9901 405.74 28.1201 405.82 28.2701C405.82 28.2701 405.84 28.2934 405.88 28.3401C405.97 28.4001 406.06 28.4701 406.15 28.5401C406.21 28.5901 406.27 28.6401 406.34 28.6801C406.46 28.7601 406.56 28.8501 406.65 28.9601C406.68 29.0001 406.72 29.0401 406.77 29.0701C406.87 29.1401 406.93 29.1701 406.98 29.2001L407.04 29.2301C407.09 29.1701 407.15 29.1301 407.21 29.1001C407.34 29.0501 407.48 29.0301 407.62 29.0501H407.65V29.0101C407.73 28.9001 407.84 28.8301 407.97 28.8101C408.1 28.7901 408.22 28.8201 408.32 28.9001C408.4 28.9701 408.46 29.0701 408.49 29.1701C408.52 29.2501 408.54 29.3301 408.53 29.4101C408.51 29.5801 408.39 29.7201 408.23 29.7901H408.21C408.21 29.7901 408.18 29.8201 408.17 29.8301C408.2 29.8501 408.23 29.8701 408.27 29.8901C408.43 30.0001 408.55 30.1501 408.62 30.3401C408.67 30.4001 408.74 30.4401 408.81 30.4701C408.93 30.5201 409.04 30.5801 409.14 30.6501C409.25 30.7201 409.35 30.8101 409.44 30.9001C409.47 30.9301 409.5 30.9701 409.54 30.9901C409.71 30.9401 409.89 30.9401 410.07 30.9901C410.24 31.0201 410.39 31.1001 410.51 31.2201C410.59 31.1601 410.67 31.1001 410.75 31.0401C410.99 30.8101 411.32 30.7001 411.64 30.7401C411.93 30.7801 412.2 30.9301 412.38 31.1601H412.4C412.61 31.1501 412.81 31.2101 412.98 31.3301C413.01 31.3501 413.04 31.3701 413.07 31.3801C413.11 31.3601 413.16 31.3401 413.2 31.3201C413.4 31.2301 413.92 30.9801 414.19 31.4301C414.21 31.4601 414.23 31.5001 414.24 31.5401C414.46 31.4001 414.76 31.4501 414.92 31.6601C414.97 31.7201 415.01 31.7901 415.06 31.8701C415.1 31.9501 415.16 32.0201 415.23 32.0901C415.23 32.0901 415.32 32.0901 415.37 32.0901C415.62 32.0901 415.87 32.1701 416.06 32.3501C416.24 32.5801 416.28 32.8801 416.18 33.1501V33.1701H416.19L416.22 33.1901C416.22 33.1901 416.27 33.1301 416.31 33.1001H416.32C416.42 33.0201 416.54 33.0001 416.66 33.0201C416.8 33.0501 416.92 33.1401 416.99 33.2601C417.13 33.4001 417.16 33.6101 417.07 33.7801C417.07 33.7901 417.05 33.8101 417.05 33.8201C417.05 33.8201 417.03 33.8501 417.01 33.8701C416.97 33.9201 416.91 33.9601 416.85 33.9901H416.82V34.0301C416.81 34.0901 416.81 34.1401 416.81 34.2001C416.81 34.2001 416.84 34.2301 416.87 34.2601C417 34.3901 417.09 34.5501 417.13 34.7201L417.15 34.8101C417.17 34.8901 417.18 34.9601 417.2 35.0401C417.3 35.1001 417.37 35.1801 417.42 35.2801C417.52 35.5101 417.47 35.7801 417.29 35.9701L417.23 36.0401C417.23 36.0401 417.23 36.0901 417.24 36.1201C417.28 36.0601 417.33 36.0101 417.39 35.9801C417.5 35.9101 417.59 35.8601 417.67 35.8001C417.77 35.7301 417.87 35.6601 418.01 35.5801C418.12 35.5201 418.25 35.5001 418.37 35.5401C418.29 35.4301 418.26 35.2901 418.29 35.1601C418.32 35.0301 418.4 34.9201 418.51 34.8601C418.62 34.8001 418.75 34.7701 418.88 34.7701V34.8501H418.89V34.7701C419.09 34.7701 419.27 34.8801 419.38 35.0501C419.5 35.2201 419.48 35.4501 419.35 35.6001C419.29 35.6601 419.23 35.7001 419.15 35.7301C419.28 35.8501 419.39 35.9801 419.48 36.1301C419.55 36.2301 419.57 36.3601 419.54 36.4801C419.54 36.5001 419.53 36.5301 419.52 36.5501C419.65 36.6301 419.74 36.7501 419.78 36.9001C419.88 37.0601 419.96 37.2301 420.02 37.4201C420.11 37.7301 420.19 38.0001 420.04 38.2301V38.2701C420.19 38.2701 420.32 38.3501 420.4 38.4601C420.42 38.4201 420.45 38.3801 420.48 38.3501C420.49 38.2801 420.52 38.2101 420.57 38.1601C420.64 38.0901 420.72 38.0401 420.82 38.0201C420.87 37.9101 420.96 37.8301 421.07 37.7901C421.12 37.7701 421.17 37.7501 421.22 37.7401C421.35 37.6901 421.5 37.7001 421.62 37.7701C421.74 37.8401 421.82 37.9501 421.85 38.0801C421.91 38.0501 421.98 38.0401 422.05 38.0401L421.95 37.9801ZM422.14 38.3101L422.08 38.4101H422.13L422.21 38.3501C422.21 38.3501 422.17 38.3201 422.14 38.3001V38.3101ZM418.62 37.5001C418.73 37.5101 418.84 37.5201 418.97 37.5201H419.03C419.03 37.5201 418.98 37.4201 418.95 37.3801L418.92 37.3301C418.92 37.3301 418.9 37.3001 418.9 37.2901C418.78 37.2601 418.67 37.1901 418.58 37.1001C418.58 37.1001 418.58 37.1001 418.58 37.0901C418.53 37.0901 418.48 37.0701 418.43 37.0501C418.43 37.0801 418.41 37.1001 418.4 37.1201C418.39 37.1501 418.37 37.1701 418.35 37.2001C418.47 37.2801 418.56 37.3801 418.63 37.5001H418.62ZM418.72 35.4001L418.54 35.5301C418.54 35.5301 418.59 35.5801 418.63 35.6001C418.64 35.6001 418.66 35.6001 418.68 35.6001C418.72 35.6001 418.76 35.6001 418.8 35.6001V35.5501L418.73 35.4101L418.72 35.4001ZM415.28 30.0901C415.28 30.0901 415.34 30.1301 415.37 30.1601C415.47 30.2401 415.56 30.3401 415.63 30.4601C415.66 30.4401 415.7 30.4201 415.73 30.4101C415.77 30.2101 415.92 30.0601 416.11 30.0001C416.2 29.9801 416.28 29.9501 416.35 29.9001C416.34 29.9001 416.32 29.8901 416.29 29.8601C416.12 29.7101 416.08 29.4501 416.21 29.2601C416.1 29.2301 416 29.1801 415.91 29.1101C415.84 29.0501 415.78 28.9801 415.74 28.9001C415.66 28.9401 415.58 28.9601 415.49 28.9701H415.46C415.56 28.9701 415.66 29.0101 415.74 29.0701C415.89 29.1101 416.02 29.2201 416.08 29.3601C416.13 29.4801 416.13 29.6101 416.08 29.7301C416.03 29.8501 415.93 29.9401 415.81 29.9701C415.67 30.0201 415.52 30.0101 415.38 29.9501C415.34 29.9901 415.3 30.0201 415.25 30.0401C415.25 30.0601 415.25 30.0801 415.25 30.0901H415.28ZM415.52 29.7101C415.51 29.7601 415.49 29.8201 415.46 29.8601C415.49 29.8601 415.53 29.8601 415.56 29.8401L415.52 29.7001V29.7101ZM415.36 29.8301H415.37L415.5 29.6401L415.36 29.8301ZM415.64 29.3701V29.4001L415.76 29.2201L415.82 29.1901C415.82 29.1901 415.81 29.1701 415.8 29.1601L415.78 29.1301H415.76L415.74 29.1101L415.67 29.2601L415.62 29.3601L415.64 29.3701ZM415.63 29.0901C415.63 29.0901 415.58 29.0901 415.55 29.1001L415.61 29.3001L415.72 29.1001C415.72 29.1001 415.65 29.0801 415.62 29.0801L415.63 29.0901ZM415.18 28.9501C415.18 28.9501 415.21 28.9701 415.22 28.9901L415.24 29.0101C415.24 29.0101 415.28 28.9901 415.3 28.9901C415.32 28.9901 415.35 28.9801 415.38 28.9701C415.31 28.9701 415.25 28.9701 415.18 28.9601V28.9501ZM413.87 28.4701L413.99 28.5201L413.87 28.4701ZM413.68 28.4001L413.82 28.4601L413.68 28.4001ZM410.2 27.4501C410.2 27.4501 410.2 27.5101 410.2 27.5401L410.29 27.4901L410.27 27.4701L410.3 27.4401C410.3 27.4401 410.24 27.4401 410.21 27.4501H410.2ZM418.27 26.4101V26.4401C418.29 26.5201 418.29 26.6001 418.27 26.6801C418.37 26.6101 418.5 26.5901 418.61 26.6201L418.64 26.6001C418.64 26.6001 418.68 26.5701 418.7 26.5601V26.5301C418.7 26.5301 418.7 26.4701 418.7 26.4301C418.61 26.4701 418.51 26.4801 418.42 26.4601C418.37 26.4501 418.33 26.4301 418.28 26.4101H418.27ZM418.09 25.2901C418.14 25.2901 418.19 25.2901 418.24 25.3101C418.3 25.2401 418.38 25.1801 418.46 25.1501C418.51 25.1301 418.56 25.1001 418.62 25.0801C418.75 25.0101 418.89 24.9501 419.04 24.9101C418.92 24.8001 418.83 24.6501 418.77 24.4901C418.72 24.3001 418.74 24.1001 418.81 23.9201C418.82 23.8801 418.84 23.8301 418.84 23.8001C418.82 23.7801 418.8 23.7601 418.78 23.7401C418.64 23.6001 418.54 23.4201 418.5 23.2201C418.48 23.0601 418.5 22.9001 418.54 22.7401C418.55 22.6901 418.56 22.6401 418.57 22.5901C418.55 22.4501 418.55 22.3101 418.57 22.1701C418.57 22.1101 418.58 22.0501 418.57 21.9901C418.55 21.8501 418.55 21.7101 418.56 21.5701C418.56 21.5101 418.56 21.4601 418.56 21.4001C418.54 21.3301 418.5 21.2601 418.45 21.2001C418.43 21.2001 418.42 21.1901 418.4 21.1801C418.4 21.2001 418.4 21.2201 418.39 21.2501C418.38 21.3601 418.36 21.4801 418.33 21.6101C418.31 21.7001 418.29 21.7901 418.28 21.8901C418.28 21.9501 418.3 22.0101 418.31 22.0601C418.36 22.2201 418.38 22.3801 418.36 22.5501C418.25 23.2701 418.04 23.3901 417.96 23.4401C417.84 23.5101 417.71 23.5501 417.57 23.5501C417.59 23.7001 417.6 23.8501 417.6 24.0001C417.6 24.0901 417.6 24.1901 417.6 24.2801C417.6 24.2801 417.62 24.3501 417.63 24.3901C417.88 24.4701 418.04 24.7101 418.01 24.9701C417.99 25.0801 417.96 25.2001 417.94 25.3101C417.99 25.3001 418.03 25.2901 418.08 25.2901H418.09ZM423.36 19.1701L423.54 19.2801L423.45 19.2001C423.45 19.2001 423.39 19.1901 423.36 19.1801V19.1701ZM397.68 50.8701C397.46 50.8701 397.28 50.7101 397.24 50.5001C397.22 50.3801 397.22 50.2601 397.24 50.1401C397.24 50.0901 397.24 50.0401 397.24 49.9901C397.21 49.8201 397.21 49.6501 397.24 49.4901V49.4001C397.26 49.0101 397.45 48.6401 397.77 48.4101C397.88 48.3401 397.83 48.3601 397.83 48.3601C397.83 48.3601 397.82 48.3201 397.81 48.3001C397.81 48.1901 397.74 48.0901 397.65 48.0501C397.46 47.9401 397.32 47.7601 397.26 47.5501V47.5201L397.22 47.5001C396.97 47.3201 396.85 47.0101 396.92 46.7201L396.95 46.6301C396.86 46.5001 396.78 46.3501 396.72 46.2101C396.67 46.1001 396.67 45.9701 396.72 45.8601C396.77 45.7501 396.85 45.6601 396.97 45.6101C396.97 45.6101 396.99 45.6101 397 45.6001L396.98 45.5801C396.9 45.4901 396.86 45.3701 396.88 45.2501C396.84 45.2301 396.79 45.2101 396.74 45.2101C396.54 45.1601 396.39 45.0101 396.34 44.8101C396.29 44.4701 396.57 44.3201 396.75 44.2201C396.84 44.1701 396.93 44.1201 397.02 44.0501C397.02 44.0501 397 44.0101 396.99 43.9901H396.97C396.84 43.9701 396.71 43.9401 396.59 43.8801C396.47 43.8101 396.36 43.7301 396.27 43.6201C396.25 43.5901 396.22 43.5701 396.2 43.5501C396.03 43.4701 395.94 43.2801 395.97 43.1001C395.98 43.0401 395.99 42.9801 395.99 42.9101C395.99 42.9501 396.01 42.9801 396.03 43.0101L396.77 42.4901C396.86 42.6301 396.9 42.7901 396.89 42.9601L396.94 43.0101C396.94 43.0101 396.98 43.0501 397 43.0701C397 43.0501 397.01 43.0201 397.02 43.0001C397.11 42.7801 397.34 42.6701 397.57 42.7201C397.59 42.7201 397.62 42.7201 397.64 42.7201C397.78 42.7001 397.93 42.7501 398.03 42.8401C398.13 42.9301 398.19 43.0601 398.18 43.2001V43.2201H398.2C398.28 43.1901 398.39 43.1801 398.5 43.1601C398.61 43.1501 398.71 43.1301 398.82 43.1001C399.62 42.8301 399.86 43.0301 399.95 43.1001L399.38 43.8001C399.38 43.8001 399.47 43.8601 399.52 43.8701C399.38 43.8801 399.24 43.9101 399.11 43.9601C398.96 44.0101 398.81 44.0401 398.65 44.0601C398.65 44.0901 398.64 44.1301 398.64 44.1601V44.2301C398.72 44.2501 398.82 44.2801 398.91 44.3101L398.96 44.3301C399.07 44.1101 399.29 43.9701 399.53 43.9401C399.72 43.9401 399.9 43.9601 400.08 44.0201C400.12 44.0301 400.17 44.0501 400.21 44.0601C400.27 44.0601 400.32 44.0501 400.38 44.0301C400.45 44.0101 400.52 44.0001 400.59 43.9901C400.79 43.9401 401 43.9901 401.17 44.1101C401.27 44.2001 401.34 44.3401 401.34 44.4801C401.34 44.5901 401.34 44.7101 401.31 44.8201C401.34 44.8401 401.37 44.8601 401.42 44.8901C401.59 45.0001 401.71 45.1801 401.75 45.3801C401.76 45.3801 401.78 45.3801 401.79 45.3801C401.92 45.3601 402.05 45.3701 402.18 45.3801C402.55 45.4801 402.82 45.8001 402.86 46.1801C402.89 46.4101 402.75 46.6201 402.53 46.6801C402.44 46.7101 402.35 46.7401 402.27 46.7801C402.18 46.8201 402.09 46.8601 401.99 46.9001C401.82 46.9501 401.64 46.9601 401.46 46.9301C401.41 46.9301 401.37 46.9201 401.32 46.9201C401.28 46.9701 401.24 47.0201 401.2 47.0701C401.13 47.1501 401.05 47.2301 400.97 47.3001C400.93 47.3501 400.9 47.4101 400.88 47.4701C400.84 47.5701 400.78 47.6601 400.72 47.7501C400.7 47.8001 400.69 47.8501 400.7 47.9001C400.77 47.9701 400.84 48.0301 400.93 48.0901C401 48.1401 401.06 48.1901 401.11 48.2601C401.18 48.3401 401.21 48.4501 401.2 48.5501C401.2 48.7501 401.06 48.9201 400.87 48.9701C400.85 49.0101 400.83 49.0601 400.82 49.1101C400.77 49.2901 400.68 49.4501 400.56 49.5801C400.41 49.7101 400.24 49.8201 400.05 49.8901C399.99 49.9101 399.93 49.9401 399.88 49.9701C399.88 50.1501 399.8 50.3101 399.66 50.4101C399.5 50.5101 399.3 50.5401 399.12 50.4901H399.1C398.93 50.5401 398.74 50.4801 398.63 50.3301H398.62L398.46 50.4701C398.29 50.6201 398.11 50.7601 397.91 50.8701C397.84 50.9101 397.77 50.9301 397.69 50.9301L397.68 50.8701ZM399.1 48.6901C399.22 48.8201 399.33 48.9601 399.42 49.1101C399.48 49.0801 399.53 49.0501 399.59 49.0301L399.54 49.0001C399.4 48.9201 399.32 48.7701 399.32 48.6101C399.26 48.6601 399.18 48.6901 399.1 48.6901ZM398.11 47.2701C398.35 47.4001 398.53 47.6201 398.62 47.8701C398.64 47.8401 398.66 47.8101 398.69 47.7801C398.75 47.7201 398.82 47.6701 398.89 47.6201C398.82 47.5401 398.77 47.4501 398.74 47.3601C398.64 47.3801 398.53 47.3601 398.44 47.3201C398.33 47.2601 398.19 47.1801 398.05 47.0901C398.07 47.1501 398.09 47.2001 398.11 47.2501C398.11 47.2501 398.11 47.2601 398.11 47.2701ZM399.23 46.3601C399.29 46.3701 399.34 46.3901 399.39 46.4201C399.51 46.3601 399.65 46.3101 399.79 46.2901L399.94 46.2601C400.11 46.2201 400.28 46.2001 400.45 46.2101C400.45 46.1901 400.45 46.1701 400.45 46.1501C400.45 46.0901 400.47 46.0301 400.49 45.9801C400.42 45.9501 400.36 45.9201 400.3 45.8901C400.17 45.8101 400.05 45.7201 399.94 45.6101L399.91 45.6301C399.75 45.7301 399.62 45.8101 399.49 45.9001C399.49 45.9201 399.48 45.9501 399.46 45.9701C399.41 46.1001 399.33 46.2101 399.24 46.3101L399.2 46.3401L399.22 46.3601H399.23ZM397.67 43.2401L397.79 43.4101C397.79 43.4101 397.83 43.3501 397.85 43.3101L397.67 43.2401ZM422.16 49.3001C422.1 49.3001 422.04 49.2901 421.98 49.2601C421.79 49.1701 421.64 49.0101 421.55 48.8201C421.54 48.7901 421.52 48.7601 421.5 48.7301C421.43 48.6801 421.36 48.6401 421.28 48.6001C421.15 48.5301 421.03 48.4601 420.92 48.3701C420.8 48.2801 420.74 48.1401 420.75 47.9901C420.75 47.8401 420.84 47.7101 420.97 47.6301C421.12 47.4601 421.37 47.4001 421.58 47.4901C421.72 47.5601 421.85 47.6501 421.97 47.7601C422.03 47.8201 422.1 47.8701 422.17 47.9101C422.23 47.9401 422.3 47.9501 422.37 47.9701C422.53 48.0001 422.69 48.0601 422.84 48.1301C422.99 48.2001 423.08 48.3501 423.09 48.5101C423.09 48.6701 423.02 48.8301 422.88 48.9101C422.79 48.9601 422.71 49.0201 422.63 49.0901C422.5 49.2101 422.34 49.2801 422.17 49.3001H422.16ZM421.22 42.7401C421.01 42.7301 420.82 42.6001 420.73 42.4101C420.65 42.2401 420.67 42.0301 420.8 41.8901C420.91 41.7701 421.06 41.7101 421.23 41.7201C421.37 41.6801 421.52 41.7201 421.64 41.8101C421.74 41.8701 421.82 41.9601 421.87 42.0601C421.92 42.1701 421.93 42.3001 421.89 42.4201C421.85 42.5401 421.76 42.6301 421.64 42.6801C421.54 42.7201 421.42 42.7401 421.31 42.7401L421.29 42.6201C421.29 42.6201 421.27 42.6201 421.26 42.6201V42.7401C421.26 42.7401 421.24 42.7401 421.23 42.7401H421.22ZM421.23 42.3701L421.25 42.6101H421.28L421.24 42.3701H421.23ZM421.27 41.8501L421.38 42.0801L421.46 41.9101C421.41 41.8701 421.34 41.8501 421.28 41.8401L421.27 41.8501ZM421.82 30.5101C421.75 30.5101 421.68 30.5001 421.62 30.4701C421.46 30.4301 421.33 30.3101 421.28 30.1401C421.24 29.9801 421.29 29.8001 421.42 29.6901C421.47 29.6501 421.52 29.6201 421.57 29.6001C421.66 29.5501 421.76 29.5401 421.86 29.5601C421.97 29.5801 422.06 29.6301 422.13 29.7201C422.17 29.7601 422.21 29.8101 422.24 29.8601C422.31 29.9901 422.31 30.1401 422.24 30.2701C422.17 30.4001 422.05 30.4901 421.9 30.5101C421.87 30.5101 421.85 30.5101 421.82 30.5101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.949 45.72C418.949 45.72 418.799 45.42 418.819 45.41C418.829 45.41 418.849 45.43 418.849 45.41C418.829 45.45 418.779 45.44 418.759 45.47C418.729 45.47 418.779 45.5501 418.759 45.5601C418.739 45.5601 418.659 45.4901 418.649 45.5001C418.679 45.4701 418.919 45.75 418.959 45.72H418.949Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.969 46.17C418.789 46.15 418.619 46.07 418.499 45.94L418.459 45.91C418.459 45.91 418.399 45.88 418.369 45.86C418.189 45.73 418.139 45.48 418.249 45.28C418.269 45.25 418.289 45.21 418.319 45.19C418.379 45.13 418.449 45.08 418.529 45.06H418.549C418.619 45 418.689 44.97 418.769 44.96C418.849 44.95 418.929 44.96 419.009 44.98C419.179 45.04 419.289 45.2 419.299 45.38C419.399 45.52 419.429 45.7 419.369 45.87C419.349 45.93 419.319 45.98 419.269 46.02C419.189 46.11 419.079 46.16 418.959 46.17H418.969Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.18 31.64C423.18 31.64 423.36 31.46 423.37 31.47C423.38 31.48 423.19 31.62 423.17 31.64C423.15 31.66 423.11 31.52 423.09 31.53C423.06 31.53 423.16 31.66 423.18 31.64Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.169 32.09C423.169 32.09 423.129 32.09 423.109 32.09C423.059 32.09 423.019 32.07 422.979 32.05C422.779 31.95 422.649 31.75 422.649 31.53C422.649 31.34 422.779 31.17 422.959 31.11C423.019 31.09 423.089 31.08 423.149 31.09C423.219 31.05 423.299 31.03 423.379 31.03C423.509 31.03 423.629 31.0901 423.719 31.1801C423.809 31.2801 423.849 31.4 423.829 31.53C423.809 31.74 423.669 31.84 423.509 31.96C423.419 32.04 423.309 32.09 423.189 32.09H423.169ZM423.419 31.54H423.539C423.559 31.4 423.469 31.27 423.339 31.22L423.269 31.4L423.349 31.4901L423.379 31.46L423.419 31.53V31.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M410.849 28.4101C410.849 28.4101 410.719 28.3501 410.749 28.3301C410.769 28.3101 410.839 28.3901 410.859 28.4101C410.929 28.4701 410.959 28.6601 411.029 28.7201C411.049 28.6901 411.059 28.6201 411.079 28.5901C410.979 28.5701 410.949 28.4401 410.849 28.4201V28.4101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M411.029 29.1601C410.929 29.1601 410.829 29.1301 410.749 29.0601C410.649 28.9801 410.579 28.8701 410.539 28.7401C410.409 28.6701 410.329 28.5401 410.299 28.4001C410.279 28.2601 410.329 28.1101 410.429 28.0101C410.519 27.9201 410.639 27.8701 410.759 27.8701C410.909 27.8701 411.049 27.9401 411.149 28.0601C411.199 28.1001 411.249 28.1401 411.289 28.1901C411.499 28.3001 411.589 28.5601 411.479 28.7801C411.459 28.8501 411.429 28.9201 411.379 28.9801C411.309 29.0801 411.199 29.1401 411.079 29.1601C411.059 29.1601 411.039 29.1601 411.019 29.1601H411.029Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.09 19.1C420.09 19.1 420.31 19.15 420.29 19.17C420.27 19.19 420.25 19.01 420.23 18.99C420.2 18.91 420.139 18.85 420.109 18.76C420.099 18.79 419.97 18.9 419.98 18.92C420.01 18.98 420.05 19.04 420.09 19.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.279 19.6301C420.279 19.6301 420.189 19.63 420.149 19.61C420.109 19.6 420.079 19.5801 420.049 19.5601C419.939 19.5401 419.839 19.48 419.759 19.4C419.709 19.34 419.659 19.28 419.629 19.21C419.549 19.11 419.519 18.98 419.529 18.85C419.549 18.72 419.619 18.61 419.719 18.53C419.799 18.4 419.949 18.3201 420.099 18.3201C420.289 18.3201 420.459 18.4401 420.519 18.6201C420.559 18.6801 420.589 18.7401 420.619 18.8101C420.639 18.8601 420.659 18.91 420.669 18.96C420.749 19.1 420.739 19.27 420.659 19.41C420.579 19.55 420.429 19.6301 420.269 19.6301H420.279Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.26 46.74C421.23 46.83 421.06 46.83 421.04 46.92C421.06 46.82 421.09 46.77 421.11 46.67C421.13 46.65 420.97 46.75 420.99 46.73C420.97 46.76 421.28 46.71 421.26 46.74Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.039 47.3701C421.039 47.3701 420.969 47.3701 420.929 47.3601C420.729 47.3101 420.589 47.1401 420.589 46.9401C420.529 46.8301 420.519 46.6901 420.569 46.5701C420.609 46.4501 420.709 46.3501 420.829 46.3101C420.989 46.2001 421.209 46.1901 421.369 46.3001C421.479 46.3201 421.579 46.3901 421.639 46.4901C421.709 46.6001 421.729 46.7401 421.699 46.8701C421.649 47.0301 421.529 47.1601 421.379 47.2301C421.289 47.3201 421.169 47.3801 421.049 47.3801L421.039 47.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.959 15.89C421.989 15.8 422.339 15.64 422.369 15.55C422.349 15.64 422.159 15.89 422.139 15.98C422.119 16.01 422.139 16.0101 422.099 16.0001C421.999 15.9701 421.949 15.92 421.959 15.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.119 16.4501C422.059 16.4501 422.009 16.4501 421.959 16.4201C421.779 16.3701 421.629 16.24 421.549 16.08C421.509 15.97 421.499 15.8501 421.539 15.7401C421.619 15.5701 421.749 15.43 421.919 15.34C421.949 15.32 421.989 15.3001 422.009 15.2801C422.139 15.1101 422.369 15.05 422.559 15.14C422.749 15.23 422.859 15.44 422.809 15.65C422.769 15.77 422.709 15.8901 422.639 16.0001C422.609 16.0501 422.579 16.0901 422.559 16.1301C422.559 16.1701 422.539 16.2001 422.509 16.2301C422.429 16.3801 422.279 16.46 422.109 16.46L422.119 16.4501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.949 47.2001C422.949 47.2001 422.919 47.4001 422.939 47.4501C422.939 47.4301 423.049 47.29 423.039 47.28C423.019 47.26 422.999 47.2001 422.969 47.1801C422.899 47.1301 422.739 47.2201 422.669 47.1801C422.659 47.2101 422.699 47.1301 422.689 47.1601C422.779 47.1701 422.859 47.2 422.949 47.21V47.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.929 47.89C422.759 47.89 422.599 47.79 422.529 47.64C422.529 47.62 422.519 47.61 422.509 47.59C422.489 47.59 422.469 47.57 422.449 47.56C422.319 47.48 422.229 47.3501 422.219 47.1901C422.209 47.0401 422.279 46.89 422.399 46.8C422.519 46.7 422.679 46.67 422.829 46.71C422.969 46.69 423.109 46.71 423.219 46.79C423.299 46.84 423.359 46.91 423.409 47C423.549 47.19 423.529 47.45 423.369 47.61C423.319 47.74 423.199 47.8401 423.069 47.8801C423.029 47.8801 422.999 47.89 422.959 47.89H422.929Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M414.419 31.2201C414.359 31.2001 414.37 30.9901 414.32 31.0101C414.28 31.0201 414.27 31.2401 414.25 31.3001C414.3 31.3001 414.35 31.3001 414.4 31.2601C414.45 31.2301 414.389 31.2801 414.419 31.2201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M414.28 31.7501C414.23 31.7501 414.169 31.7501 414.119 31.7201C413.999 31.6801 413.9 31.5901 413.85 31.4801C413.8 31.3701 413.8 31.2301 413.85 31.1101C413.84 30.8901 413.969 30.6801 414.169 30.5901C414.299 30.5401 414.439 30.5601 414.559 30.6201C414.689 30.7001 414.779 30.8301 414.809 30.9801C414.819 31.0001 414.84 31.0301 414.85 31.0501C414.87 31.1101 414.879 31.1701 414.879 31.2301C414.879 31.4001 414.789 31.5601 414.639 31.6401C414.539 31.7101 414.42 31.7401 414.29 31.7501H414.28Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.199 31.71C419.179 31.66 419.159 31.6101 419.129 31.5601C419.049 31.5301 418.969 31.52 418.889 31.52C418.869 31.58 418.929 31.8101 418.919 31.8701C418.979 31.8601 419.139 31.73 419.199 31.72V31.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.929 32.3201C418.799 32.3201 418.679 32.26 418.589 32.17C418.499 32.07 418.469 31.9401 418.479 31.8101V31.79C418.429 31.65 418.429 31.5101 418.479 31.3801C418.539 31.2101 418.689 31.09 418.869 31.08C418.869 31.08 419.359 31.05 419.529 31.36C419.569 31.43 419.609 31.51 419.639 31.59C419.709 31.82 419.599 32.06 419.369 32.15C419.349 32.16 419.329 32.1701 419.309 32.1901C419.229 32.2501 419.129 32.3 419.029 32.33C418.999 32.33 418.959 32.34 418.929 32.34V32.3201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.829 16.0701C420.829 16.0701 420.929 15.8401 420.939 15.8101C420.889 15.8101 420.759 16.1101 420.699 16.1201C420.689 16.1201 420.709 15.9101 420.699 15.9401C420.749 15.9401 420.779 16.0701 420.819 16.0701H420.829Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.699 16.5701C420.579 16.5701 420.469 16.5201 420.379 16.4401C420.259 16.3101 420.219 16.14 420.249 15.97C420.249 16.07 420.289 16.1701 420.369 16.2401C420.359 16.2201 420.339 16.2101 420.329 16.1901C420.249 16.0701 420.229 15.91 420.279 15.77C420.329 15.63 420.449 15.5301 420.599 15.4901C420.699 15.3901 420.839 15.3401 420.979 15.3601C421.129 15.3701 421.259 15.46 421.329 15.59C421.399 15.72 421.399 15.8801 421.329 16.0101L421.289 16.1C421.259 16.18 421.219 16.26 421.209 16.28C421.149 16.4 421.039 16.4801 420.909 16.5101C420.849 16.5401 420.779 16.5601 420.709 16.5701H420.679H420.699Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M410.729 30.78C410.669 30.77 410.729 30.8501 410.689 30.8701C410.639 30.8901 410.509 30.84 410.479 30.89C410.539 30.89 410.669 30.94 410.709 30.92C410.759 30.9 410.709 30.82 410.729 30.77V30.78Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M410.679 31.3701C410.599 31.3701 410.519 31.36 410.439 31.33C410.289 31.3 410.169 31.2001 410.099 31.0601C410.029 30.9301 410.029 30.78 410.099 30.65C410.169 30.52 410.289 30.4401 410.439 30.4101C410.559 30.3201 410.709 30.2901 410.849 30.3201C411.079 30.3801 411.229 30.6 411.189 30.83C411.199 31.03 411.089 31.2201 410.909 31.3001C410.839 31.3301 410.759 31.3501 410.689 31.3501L410.679 31.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.879 27.33C422.819 27.31 422.849 27.2101 422.819 27.2001C422.819 27.2201 422.859 27.4501 422.869 27.4501C422.899 27.4501 422.829 27.34 422.879 27.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.859 27.9001H422.829C422.469 27.8701 422.419 27.5501 422.389 27.3701V27.3001C422.329 27.1501 422.359 26.9801 422.479 26.8701C422.599 26.7601 422.769 26.7201 422.929 26.7701C423.069 26.8201 423.179 26.9201 423.239 27.0601C423.239 27.0601 423.239 27.0801 423.249 27.0901C423.299 27.1601 423.319 27.2501 423.319 27.3401C423.319 27.3801 423.319 27.4201 423.299 27.4601C423.299 27.5601 423.259 27.6601 423.199 27.7501C423.109 27.8501 422.989 27.9101 422.849 27.9101L422.859 27.9001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.21 39.73C421.21 39.73 421.319 39.8701 421.299 39.8701C421.239 39.8701 421.08 39.7301 421.02 39.7501C421.04 39.7701 421.13 39.72 421.14 39.72C421.2 39.71 421.14 39.75 421.2 39.72L421.21 39.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.299 40.32C421.169 40.32 421.049 40.27 420.949 40.2C420.849 40.18 420.769 40.13 420.699 40.06C420.599 39.95 420.559 39.8 420.599 39.65C420.639 39.5 420.739 39.3899 420.879 39.3299C420.919 39.3199 420.949 39.31 420.989 39.3C421.019 39.29 421.049 39.28 421.079 39.27C421.139 39.26 421.209 39.26 421.269 39.27C421.369 39.28 421.469 39.33 421.549 39.4C421.569 39.43 421.599 39.45 421.609 39.48C421.749 39.63 421.789 39.83 421.729 40.02C421.669 40.16 421.539 40.27 421.389 40.29C421.359 40.29 421.339 40.29 421.309 40.29L421.299 40.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.499 40.21C420.499 40.21 420.529 40.35 420.499 40.39C420.479 40.39 420.469 40.4 420.449 40.41C420.509 40.4 420.489 40.31 420.549 40.29C420.509 40.25 420.539 40.25 420.499 40.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.449 40.85C420.249 40.85 420.069 40.72 420.019 40.52C419.989 40.42 419.999 40.31 420.049 40.22C420.049 40.09 420.109 39.96 420.209 39.87C420.389 39.71 420.659 39.72 420.829 39.9C420.869 39.94 420.899 39.98 420.919 40.03C420.989 40.13 421.019 40.26 420.989 40.39C420.979 40.44 420.959 40.48 420.939 40.53C420.919 40.58 420.899 40.63 420.859 40.67C420.819 40.72 420.759 40.76 420.699 40.79C420.649 40.82 420.599 40.84 420.549 40.85C420.519 40.85 420.489 40.86 420.449 40.86V40.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.299 48.65C423.299 48.65 423.249 48.51 423.239 48.49C423.229 48.54 423.219 48.59 423.219 48.64C423.219 48.67 423.219 48.51 423.239 48.53C423.259 48.51 423.279 48.67 423.299 48.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.299 49.1C423.299 49.1 423.26 49.1 423.24 49.1H423.21C422.99 49.08 422.82 48.92 422.79 48.71C422.79 48.64 422.79 48.5701 422.79 48.5101C422.79 48.4201 422.82 48.33 422.87 48.25C422.96 48.11 423.12 48.03 423.29 48.04C423.46 48.05 423.599 48.1601 423.669 48.3201C423.669 48.3401 423.7 48.39 423.71 48.44C423.77 48.59 423.76 48.76 423.68 48.91C423.6 49.04 423.449 49.11 423.299 49.11V49.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.499 17.7401C419.499 17.7401 419.399 17.7001 419.379 17.6701C419.359 17.6901 419.509 17.6201 419.519 17.6301C419.539 17.6701 419.369 17.8401 419.389 17.8801C419.399 17.8501 419.489 17.7701 419.499 17.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.399 18.3201C419.269 18.3201 419.139 18.26 419.059 18.16C418.969 18.06 418.929 17.92 418.959 17.79C418.919 17.63 418.959 17.46 419.079 17.34C419.139 17.28 419.219 17.24 419.299 17.23C419.459 17.14 419.669 17.16 419.809 17.27C419.959 17.39 420.009 17.5801 419.959 17.7601C419.959 17.8101 419.949 17.85 419.929 17.89C419.899 17.97 419.849 18.03 419.789 18.09C419.779 18.1 419.789 18.09 419.799 18.06C419.739 18.19 419.609 18.27 419.479 18.3C419.459 18.3 419.429 18.3 419.399 18.3V18.3201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.75 47.71C398.75 47.71 398.61 47.67 398.64 47.65C398.61 47.63 398.73 47.51 398.72 47.52C398.65 47.57 398.58 47.62 398.52 47.68C398.55 47.69 398.72 47.69 398.75 47.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.749 48.16C398.749 48.16 398.689 48.16 398.659 48.16H398.599C398.519 48.16 398.439 48.14 398.369 48.12C398.219 48.07 398.109 47.94 398.079 47.79C398.049 47.64 398.099 47.48 398.209 47.37C398.299 47.29 398.389 47.21 398.489 47.15C398.679 47.04 398.919 47.08 399.059 47.25C399.119 47.33 399.159 47.43 399.159 47.53C399.179 47.56 399.189 47.6001 399.189 47.6301C399.219 47.8001 399.149 47.98 399.009 48.08C398.929 48.14 398.839 48.17 398.739 48.17L398.749 48.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.78 43.16C418.78 43.16 418.67 43.42 418.7 43.43C418.75 43.45 418.779 43.24 418.799 43.19C418.829 43.13 418.82 43.14 418.77 43.16H418.78Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.709 43.8801C418.649 43.8801 418.579 43.87 418.519 43.84C418.339 43.75 418.229 43.56 418.239 43.36C418.239 43.31 418.289 42.82 418.649 42.72C418.819 42.66 419.019 42.71 419.149 42.84C419.269 42.99 419.289 43.19 419.219 43.36C419.199 43.56 419.079 43.73 418.909 43.83C418.849 43.86 418.779 43.8801 418.709 43.8801ZM418.839 43.19L419.159 43.3801C419.139 43.2201 419.029 43.0801 418.879 43.0101L418.819 43.14V43.18L418.839 43.19Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.619 42.82C419.599 42.88 419.589 42.82 419.579 42.87C419.619 42.87 419.649 43.1 419.689 43.09C419.709 42.99 419.709 42.9 419.709 42.8C419.689 42.76 419.659 42.85 419.629 42.82H419.619Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.669 43.55C419.529 43.55 419.309 43.49 419.199 43.13C419.129 43.03 419.109 42.9 419.139 42.78C419.159 42.7 419.199 42.63 419.249 42.57C419.309 42.49 419.39 42.43 419.48 42.4H419.509C419.719 42.3 419.959 42.37 420.079 42.56C420.169 42.79 420.179 43.05 420.089 43.28C420.029 43.42 419.899 43.52 419.749 43.54C419.729 43.54 419.699 43.54 419.679 43.54L419.669 43.55Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.869 18.81C422.869 18.81 422.869 18.7499 422.879 18.7699C422.879 18.8499 422.879 18.9399 422.879 19.0199C422.909 18.9799 422.929 18.93 422.939 18.88C422.939 18.82 422.879 18.87 422.859 18.81H422.869Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.889 19.47C422.889 19.47 422.819 19.47 422.789 19.46C422.639 19.43 422.519 19.32 422.469 19.17C422.439 19.09 422.429 19.0101 422.439 18.9301C422.419 18.8401 422.419 18.75 422.439 18.67C422.509 18.46 422.699 18.3201 422.919 18.3201C423.089 18.3301 423.239 18.44 423.309 18.6C423.359 18.66 423.389 18.7301 423.409 18.8101C423.419 19.0001 423.359 19.2 423.219 19.34C423.139 19.42 423.019 19.47 422.899 19.47H422.889ZM422.569 18.7001L422.669 18.8L422.569 18.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.96 25.4C417.96 25.4 418.02 25.36 417.99 25.37C417.99 25.39 417.93 25.39 417.94 25.39C418 25.41 418.07 25.42 418.14 25.43C418.14 25.41 417.98 25.42 417.97 25.4H417.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.119 25.8801C418.059 25.8801 417.999 25.88 417.939 25.85C417.899 25.85 417.849 25.8301 417.809 25.8201C417.789 25.8201 417.769 25.8 417.749 25.79C417.579 25.72 417.469 25.54 417.479 25.36C417.479 25.17 417.609 25.0101 417.789 24.9501C417.819 24.9401 417.849 24.93 417.879 24.92C417.999 24.89 418.139 24.92 418.239 24.99C418.369 25.03 418.479 25.12 418.539 25.24C418.599 25.36 418.589 25.5101 418.539 25.6301C418.479 25.7501 418.369 25.83 418.239 25.86C418.199 25.86 418.169 25.87 418.129 25.87L418.119 25.8801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.29 31.8201C422.29 31.8201 422.14 31.8601 422.16 31.8701C422.19 31.8801 422.25 31.8201 422.28 31.8201C422.28 31.7801 422.19 31.8601 422.18 31.8201C422.15 31.8301 422.32 31.8101 422.29 31.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.159 32.3301C422.029 32.3301 421.909 32.2701 421.819 32.1701C421.729 32.0701 421.689 31.9401 421.709 31.8101C421.709 31.7801 421.719 31.7501 421.739 31.7101C421.779 31.5601 421.889 31.4401 422.029 31.3901C422.079 31.3701 422.139 31.3601 422.199 31.3701H422.229C422.319 31.3701 422.399 31.3701 422.479 31.4101C422.489 31.4101 422.499 31.4201 422.509 31.4301C422.719 31.5401 422.799 31.8002 422.689 32.0102C422.689 32.0202 422.679 32.0401 422.669 32.0501C422.599 32.1601 422.489 32.2401 422.369 32.2801C422.299 32.3101 422.229 32.3301 422.159 32.3301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.489 31.7201C418.489 31.7201 418.429 31.6501 418.429 31.6701C418.439 31.7601 418.459 31.8601 418.479 31.9501C418.499 31.9301 418.809 31.7501 418.799 31.7301C418.799 31.6701 418.509 31.7801 418.489 31.7301V31.7201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.48 32.4101C418.48 32.4101 418.399 32.41 418.359 32.39C418.219 32.35 418.11 32.2401 418.06 32.1001C418.03 32.0001 418.01 31.8901 418 31.7801C417.97 31.5601 418.08 31.3401 418.28 31.2401C418.4 31.2001 418.54 31.21 418.65 31.27C419.15 31.23 419.24 31.55 419.26 31.65C419.32 31.95 419.11 32.0901 418.84 32.2501L418.76 32.3001C418.69 32.3701 418.59 32.4 418.49 32.4L418.48 32.4101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.559 34.28C421.559 34.28 421.439 34.04 421.399 34.03C421.399 34.08 421.659 34.17 421.649 34.21C421.679 34.21 421.509 34.16 421.529 34.14C421.539 34.14 421.549 34.3 421.549 34.27L421.559 34.28Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.559 34.73C421.559 34.73 421.46 34.73 421.41 34.7C421.26 34.64 421.14 34.52 421.08 34.36V34.34C420.93 34.19 420.91 33.96 421.02 33.79C421.13 33.62 421.34 33.54 421.54 33.6C421.61 33.62 421.68 33.66 421.73 33.72C421.82 33.77 421.909 33.83 421.989 33.91C422.079 34 422.119 34.12 422.109 34.24C422.109 34.41 422 34.55 421.85 34.63C421.77 34.7 421.67 34.74 421.57 34.74L421.559 34.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.919 29.8101C417.919 29.8101 417.869 29.8601 417.859 29.8801C417.859 29.9701 417.859 30.06 417.869 30.14C417.889 30.06 417.909 29.97 417.909 29.89C417.909 29.86 417.909 29.8401 417.909 29.8101H417.919Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.869 30.59C417.869 30.59 417.829 30.59 417.819 30.59C417.659 30.57 417.529 30.47 417.459 30.33C417.409 30.17 417.399 30.01 417.409 29.84C417.429 29.72 417.489 29.6 417.569 29.51C417.659 29.39 417.809 29.33 417.969 29.35C418.119 29.37 418.259 29.47 418.319 29.61C418.369 29.71 418.379 29.83 418.359 29.94C418.359 30.11 418.319 30.27 418.229 30.41C418.149 30.52 418.009 30.58 417.869 30.58V30.59ZM417.509 29.87L417.609 29.95L417.509 29.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M412.179 29.9101C412.249 29.9301 412.429 29.7701 412.499 29.7801C412.519 29.7801 412.529 29.8801 412.559 29.8601C412.509 29.8301 412.469 29.6301 412.419 29.6201C412.379 29.6201 412.229 29.8601 412.179 29.9001V29.9101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M412.199 30.36C412.149 30.36 412.099 30.36 412.049 30.33C411.899 30.28 411.789 30.1601 411.749 30.0101C411.709 29.8601 411.749 29.7 411.869 29.59L411.919 29.53C412.019 29.33 412.229 29.2001 412.449 29.1801C412.669 29.2001 412.859 29.36 412.919 29.58C412.919 29.59 412.919 29.59 412.919 29.58C413.059 29.77 413.039 30.0301 412.859 30.1901C412.749 30.2901 412.589 30.33 412.449 30.29C412.369 30.33 412.289 30.35 412.199 30.35V30.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.099 29.7401C413.069 29.6801 413.139 29.7401 413.109 29.6801C413.079 29.7001 412.959 29.6501 412.969 29.6701C412.989 29.7301 413.209 29.6701 413.239 29.7401C413.269 29.7201 413.069 29.7701 413.099 29.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.129 30.1901C413.019 30.1901 412.909 30.1601 412.819 30.0901C412.679 30.0401 412.579 29.9201 412.549 29.7701C412.509 29.6201 412.549 29.4601 412.669 29.3501C412.789 29.2501 412.949 29.2001 413.109 29.2301C413.189 29.2301 413.269 29.2501 413.339 29.2801C413.409 29.3001 413.469 29.3301 413.519 29.3701C413.579 29.4101 413.629 29.4701 413.659 29.5401C413.739 29.7201 413.699 29.9401 413.549 30.0701C413.459 30.1501 413.349 30.1901 413.229 30.1801C413.199 30.1801 413.169 30.1801 413.139 30.1801L413.129 30.1901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.139 30.72C419.139 30.72 419.139 30.5301 419.169 30.5401C419.199 30.5501 419.19 30.78 419.23 30.78C419.23 30.74 419.029 30.8301 419.019 30.8001C418.989 30.8101 419.169 30.7201 419.139 30.7301V30.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.029 31.2601C418.949 31.2601 418.869 31.2401 418.789 31.2001C418.769 31.1901 418.749 31.1801 418.739 31.1601C418.679 31.1101 418.629 31.0501 418.599 30.9801C418.519 30.8001 418.569 30.5901 418.719 30.4701C418.739 30.3401 418.829 30.2201 418.939 30.1501C419.069 30.0801 419.239 30.0701 419.369 30.1501C419.529 30.2501 419.629 30.4201 419.629 30.6101C419.629 30.6101 419.649 30.6501 419.649 30.6801C419.689 30.8301 419.649 30.9801 419.549 31.0901C419.459 31.1901 419.329 31.2401 419.199 31.2401C419.139 31.2601 419.079 31.2601 419.019 31.2601H419.029Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M412.639 30.39C412.639 30.39 412.899 30.7501 412.909 30.7501C412.969 30.7401 412.969 30.5301 413.029 30.5101C413.009 30.4901 413.029 30.5901 413.019 30.5901C412.959 30.6001 412.699 30.3601 412.639 30.3801V30.39Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M412.889 31.21C412.669 31.21 412.549 31.0401 412.339 30.7501L412.289 30.6801C412.209 30.5701 412.179 30.4301 412.209 30.2901C412.239 30.1601 412.339 30.0501 412.459 29.9901C412.639 29.9201 412.839 29.9501 412.999 30.0701C413.149 30.0601 413.289 30.1201 413.389 30.2401C413.479 30.3501 413.509 30.4901 413.469 30.6301C413.469 30.7301 413.419 30.82 413.359 30.89C413.299 31.04 413.169 31.1601 413.019 31.1901C412.979 31.1901 412.939 31.2 412.899 31.21H412.889ZM412.779 30.72L412.679 30.8001L412.779 30.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M407.05 29.02C407 28.99 407.08 29.06 407.03 29.06C406.98 29.06 407.09 28.99 407.03 29.02C407.08 29.05 406.96 29.25 407.01 29.25C407.06 29.25 406.99 29.04 407.04 29.01L407.05 29.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M407.02 29.71C406.87 29.71 406.74 29.64 406.65 29.52C406.57 29.41 406.54 29.2601 406.57 29.1301C406.57 29.0601 406.57 28.98 406.6 28.91C406.62 28.82 406.67 28.73 406.75 28.67C406.9 28.55 407.11 28.5401 407.27 28.6301C407.33 28.6601 407.379 28.7101 407.419 28.7601C407.469 28.8401 407.5 28.93 407.5 29.03C407.5 29.05 407.5 29.08 407.5 29.1C407.5 29.12 407.5 29.14 407.5 29.17C407.52 29.31 407.47 29.4601 407.38 29.5701C407.29 29.6601 407.17 29.72 407.04 29.72L407.02 29.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M412.159 30.21C412.159 30.21 412.179 30.33 412.189 30.35C412.189 30.41 412.069 30.48 412.089 30.54C412.109 30.52 412.119 30.5 412.109 30.49C412.099 30.43 412.189 30.27 412.159 30.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M412.079 30.9901C411.889 30.9901 411.719 30.8701 411.659 30.6901C411.619 30.5701 411.619 30.4401 411.679 30.3201C411.679 30.2801 411.699 30.2501 411.709 30.2201C411.709 30.1001 411.749 29.98 411.829 29.9C411.939 29.78 412.099 29.7301 412.249 29.7601C412.409 29.7901 412.529 29.9001 412.589 30.0501C412.609 30.1001 412.619 30.1501 412.619 30.2001C412.619 30.2301 412.629 30.2501 412.639 30.2801C412.659 30.4201 412.619 30.5601 412.539 30.6601C412.509 30.7401 412.459 30.8101 412.389 30.8701C412.309 30.9401 412.199 30.9801 412.089 30.9801L412.079 30.9901ZM411.779 30.2001L411.869 30.3001L411.779 30.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.069 55.27C421.199 55.23 421.309 55.15 421.399 55.05C421.399 55.01 421.099 54.92 421.069 54.96C421.009 55.06 421.009 55.18 421.069 55.28V55.27Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.079 55.72C421.029 55.72 420.969 55.7201 420.919 55.6901C420.759 55.6201 420.639 55.4801 420.609 55.3101C420.539 55.0901 420.589 54.85 420.739 54.66C420.899 54.47 421.149 54.4401 421.479 54.5701C421.699 54.6201 421.849 54.82 421.859 55.04C421.839 55.25 421.719 55.43 421.529 55.53C421.399 55.63 421.249 55.7 421.089 55.71L421.079 55.72ZM420.949 55.0501C420.949 55.1901 421.009 55.32 421.129 55.4C421.239 55.4 421.339 55.3401 421.409 55.2501C421.449 55.2101 421.479 55.15 421.469 55.08C421.429 54.97 421.339 54.88 421.229 54.85L421.199 54.9201L421.359 55.09L421.139 55.0701L421.069 55.27L420.999 55.0501H420.949Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M408.29 30.25C408.35 30.22 408.4 30.16 408.46 30.13C408.44 30.1 408.43 29.97 408.41 29.97C408.35 29.97 408.379 30.13 408.319 30.14C408.339 30.19 408.26 30.2 408.29 30.25Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M408.289 30.7001C408.239 30.7001 408.189 30.7 408.139 30.67C408.029 30.63 407.929 30.55 407.879 30.44C407.829 30.31 407.829 30.17 407.879 30.05C407.879 30.01 407.899 29.97 407.919 29.93C407.919 29.92 407.929 29.91 407.939 29.9C407.999 29.67 408.209 29.52 408.439 29.53C408.669 29.55 408.859 29.74 408.879 29.97C408.959 30.19 408.869 30.43 408.659 30.54C408.609 30.59 408.549 30.63 408.489 30.66C408.429 30.69 408.359 30.71 408.289 30.71V30.7001ZM408.169 30.35C408.229 30.39 408.299 30.41 408.369 30.42L408.339 30.23H408.319L408.169 30.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.35 35.18C420.41 35.16 420.66 35.09 420.72 35.07C420.67 34.96 420.62 34.85 420.56 34.75C420.47 34.76 420.38 34.78 420.29 34.8C420.3 34.85 420.34 35.13 420.35 35.18Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.349 35.6201C420.279 35.6201 420.209 35.6001 420.139 35.5701C420.029 35.5101 419.949 35.4201 419.909 35.3001C419.909 35.2701 419.879 35.1601 419.869 35.0501C419.869 34.9901 419.849 34.9301 419.849 34.9001C419.819 34.7701 419.849 34.6301 419.939 34.5201C420.019 34.4101 420.149 34.3501 420.279 34.3401C420.389 34.3001 420.509 34.2801 420.629 34.3001C420.879 34.3401 420.949 34.4901 421.099 34.8101C421.169 34.9301 421.179 35.0701 421.139 35.2001C421.099 35.3301 421.009 35.4301 420.889 35.4901C420.849 35.5001 420.759 35.5301 420.659 35.5601C420.599 35.5801 420.539 35.5901 420.509 35.6001C420.459 35.6201 420.409 35.6301 420.359 35.6301L420.349 35.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.939 50.82C421.939 50.82 421.729 50.8 421.689 50.82C421.659 50.83 421.629 50.82 421.659 50.83C421.789 50.88 421.929 50.86 421.939 50.83V50.82Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.819 51.31C421.709 51.31 421.599 51.29 421.489 51.25C421.279 51.17 421.159 50.96 421.189 50.74C421.229 50.54 421.389 50.39 421.599 50.37C421.799 50.31 422.019 50.34 422.199 50.45C422.319 50.55 422.389 50.7 422.379 50.86C422.359 51.01 422.279 51.14 422.159 51.22C422.059 51.28 421.939 51.31 421.829 51.31H421.819ZM421.639 51.07L421.589 51.11C421.589 51.11 421.619 51.15 421.639 51.16V51.06V51.07ZM421.639 50.8L421.789 50.42C421.729 50.42 421.669 50.45 421.629 50.49V50.8H421.639ZM421.479 50.7799L421.629 50.8L421.569 50.57C421.519 50.63 421.489 50.71 421.479 50.79V50.7799Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.369 53.3299C422.369 53.3299 422.339 53.22 422.339 53.24C422.339 53.32 422.339 53.4 422.359 53.48C422.399 53.41 422.429 53.33 422.449 53.25C422.449 53.23 422.389 53.3499 422.369 53.3299Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.36 53.9301H422.33C422.21 53.9301 422.1 53.86 422.02 53.77C421.9 53.61 421.85 53.41 421.89 53.22C421.9 52.99 422.09 52.8 422.33 52.79C422.37 52.79 422.41 52.7901 422.45 52.8101C422.5 52.8101 422.55 52.81 422.59 52.83C422.79 52.9 422.91 53.09 422.89 53.29C422.86 53.48 422.78 53.6701 422.65 53.8201C422.57 53.8901 422.46 53.9301 422.35 53.9301H422.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M410.969 30.74C410.969 30.74 411.189 30.8599 411.229 30.8499C411.259 30.8399 411.229 30.7999 411.199 30.7899C411.079 30.7399 410.979 30.7 410.979 30.74H410.969Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M411.219 31.3001C411.029 31.2901 410.859 31.2201 410.709 31.1101C410.579 31.0101 410.519 30.8501 410.529 30.6901C410.549 30.5501 410.629 30.42 410.749 30.34C410.949 30.25 411.179 30.2601 411.369 30.3701C411.559 30.4501 411.689 30.63 411.689 30.84C411.689 30.96 411.639 31.08 411.549 31.16C411.459 31.25 411.339 31.29 411.219 31.29V31.3001ZM410.959 31.1701C411.049 31.1701 411.149 31.15 411.219 31.1L410.969 30.73L411.149 30.7501L411.069 30.4201C410.939 30.4701 410.839 30.58 410.799 30.71L410.959 30.73L410.799 30.71C410.799 30.71 410.789 30.7801 410.779 30.8201C410.779 30.9601 410.839 31.09 410.949 31.16L410.959 31.1701ZM411.179 30.7501L411.409 30.78C411.429 30.62 411.359 30.4701 411.229 30.3801L411.179 30.7501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.579 30.8601C418.579 30.8601 418.539 30.8901 418.559 30.9201C418.569 30.9501 418.529 30.9001 418.559 30.8801C418.599 30.8501 418.619 30.8701 418.589 30.8601H418.579Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.559 31.38C418.409 31.38 418.269 31.31 418.179 31.18C418.109 31.06 418.079 30.92 418.119 30.78C418.129 30.71 418.159 30.64 418.199 30.59C418.299 30.46 418.459 30.4 418.629 30.41C418.709 30.41 418.78 30.44 418.85 30.49C419.02 30.61 419.09 30.82 419.02 31.02C419.01 31.05 418.99 31.08 418.97 31.11C418.9 31.27 418.739 31.38 418.559 31.38ZM418.54 30.94L418.34 31.23L418.54 30.94Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M415.269 28.92C415.269 28.92 415.459 28.6801 415.439 28.6801C415.359 28.7501 415.289 28.83 415.219 28.92C415.279 28.95 415.349 28.97 415.419 28.97C415.439 28.97 415.249 28.94 415.269 28.92Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M415.419 29.42C415.419 29.42 415.389 29.42 415.379 29.42C415.189 29.42 415.019 29.34 414.879 29.22C414.799 29.13 414.759 29.01 414.769 28.89C414.769 28.77 414.829 28.66 414.929 28.58L414.949 28.56C415.119 28.37 415.229 28.23 415.469 28.24C415.639 28.24 415.789 28.36 415.859 28.51C415.909 28.63 415.909 28.76 415.859 28.87C415.879 28.92 415.889 28.98 415.879 29.04C415.849 29.26 415.659 29.42 415.429 29.42H415.419Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.469 32.3301C417.469 32.3301 417.459 32.2301 417.469 32.2701C417.479 32.3001 417.599 32.1101 417.629 32.1301C417.659 32.1501 417.509 32.3401 417.469 32.3301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.47 32.7801C417.47 32.7801 417.439 32.7801 417.419 32.7801C417.189 32.7501 417.01 32.56 417 32.33C417 32.15 417.09 31.9701 417.24 31.8801C417.31 31.7801 417.429 31.7101 417.549 31.6901C417.679 31.6701 417.8 31.7001 417.9 31.7801C418.06 31.9101 418.12 32.14 418.04 32.33C418.04 32.33 417.84 32.7801 417.46 32.7801H417.47ZM417.21 31.9801C417.16 32.1001 417.17 32.2401 417.24 32.3601L417.45 32.2601L417.21 31.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.879 34.04C417.879 34.04 418.099 34.04 418.139 34.02C418.169 34.01 418.179 34.13 418.139 34.12C417.989 34.07 417.879 34 417.879 34.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.139 34.5701C418.139 34.5701 418.039 34.57 417.999 34.55C417.959 34.54 417.929 34.5201 417.889 34.5101C417.789 34.5101 417.699 34.47 417.619 34.42C417.489 34.33 417.419 34.18 417.429 34.02C417.439 33.87 417.519 33.73 417.649 33.65C417.759 33.58 417.889 33.56 418.019 33.6C418.199 33.53 418.399 33.6 418.519 33.75C418.659 33.93 418.669 34.1901 418.539 34.3801C418.449 34.5001 418.309 34.58 418.149 34.58L418.139 34.5701ZM417.719 34.03C417.709 34.13 417.739 34.23 417.799 34.31L417.879 34.25L417.919 34.09L417.879 34.04H417.889L417.949 33.97L417.789 33.85C417.749 33.9 417.729 33.96 417.719 34.02V34.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.179 25.0201C423.179 25.0201 423.429 25.1101 423.459 25.0901C423.489 25.0801 423.499 25.0202 423.459 25.0102C423.319 24.9602 423.169 24.9901 423.169 25.0201H423.179Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.439 25.54C423.249 25.54 423.069 25.49 422.909 25.39C422.789 25.29 422.719 25.14 422.729 24.98C422.749 24.83 422.829 24.7001 422.959 24.6301C423.169 24.5201 423.409 24.51 423.619 24.6C423.809 24.68 423.929 24.8601 423.929 25.0601C423.929 25.2701 423.799 25.46 423.609 25.53C423.549 25.55 423.499 25.5601 423.439 25.5601V25.54ZM423.479 25.0501L423.309 25.4201C423.479 25.3801 423.599 25.2301 423.619 25.0601L423.479 25.04V25.0501ZM423.479 25.0501H423.619C423.639 24.9101 423.569 24.7601 423.449 24.6701L423.419 25.04H423.479V25.0501ZM423.299 24.6801C423.139 24.7401 423.029 24.8801 423.029 25.0501H423.369L423.169 25.03L423.399 25.0501L423.299 24.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.88 25.7601C419.88 25.7601 419.81 25.7601 419.85 25.7401C419.88 25.7301 419.81 25.74 419.81 25.71C419.81 25.69 419.88 25.7101 419.88 25.7601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.87 26.22C419.72 26.22 419.59 26.15 419.49 26.04C419.48 26.04 419.47 26.02 419.46 26.01C419.38 25.91 419.34 25.77 419.36 25.64C419.4 25.4 419.63 25.23 419.87 25.26C420.14 25.29 420.33 25.53 420.32 25.79C420.29 26.02 420.12 26.2 419.89 26.22H419.86H419.87ZM419.86 25.32H419.84V25.44L419.86 25.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.679 16.16C420.679 16.16 420.869 16 420.849 15.97C420.839 15.94 420.849 16.1001 420.839 16.1301C420.799 16.2001 420.639 16.16 420.679 16.17V16.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.729 16.62C420.649 16.62 420.569 16.61 420.499 16.58C420.339 16.51 420.229 16.36 420.229 16.18C420.229 16.01 420.319 15.84 420.479 15.77C420.539 15.65 420.639 15.56 420.759 15.53C420.979 15.49 421.189 15.61 421.269 15.81C421.289 15.87 421.299 15.93 421.289 15.99C421.309 16.13 421.279 16.26 421.209 16.38C421.099 16.54 420.919 16.64 420.719 16.63L420.729 16.62ZM420.409 16.06C420.409 16.06 420.419 16.11 420.429 16.14L420.559 16.09L420.409 16.07V16.06ZM420.719 15.72C420.609 15.72 420.519 15.79 420.459 15.88L420.689 16.03L420.719 15.72ZM420.719 15.72L420.689 16.03L420.739 16.01L420.849 15.75C420.849 15.75 420.759 15.72 420.719 15.72ZM420.469 15.77C420.469 15.77 420.449 15.78 420.449 15.79C420.419 15.85 420.409 15.91 420.409 15.98C420.409 15.91 420.439 15.84 420.479 15.77H420.469Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.419 27.03C413.419 27.03 413.469 27.12 413.479 27.16C413.479 27.19 413.359 27.19 413.369 27.16C413.409 27.08 413.449 27.03 413.419 27.02V27.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.399 27.6301C413.269 27.6301 413.149 27.5901 413.049 27.5001C412.909 27.3601 412.869 27.14 412.959 26.97C412.959 26.91 412.989 27.46 413.029 27.4C413.129 27.25 413.309 27.1701 413.479 27.2001C413.629 27.2201 413.759 26.71 413.829 26.85C413.839 26.88 413.849 26.9101 413.859 26.9301C413.879 26.9601 413.889 27 413.899 27.04C413.949 27.24 413.869 27.4501 413.689 27.5601C413.599 27.6101 413.499 27.64 413.389 27.64L413.399 27.6301ZM413.399 27.34C413.339 27.34 413.279 27.36 413.219 27.39L413.379 27.0501L413.399 27.03L413.569 26.9501L413.669 26.85C413.669 26.85 413.529 27.34 413.399 27.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.629 43C423.629 43 423.639 43.14 423.639 43.17C423.639 43.2 423.599 43.12 423.619 43.15C423.649 43.12 423.479 43.19 423.489 43.17C423.489 43.14 423.659 43.03 423.629 43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.65 43.6301C423.65 43.6301 423.6 43.6301 423.57 43.6301C423.44 43.6501 423.3 43.6101 423.2 43.5301C423.1 43.4401 423.04 43.3101 423.04 43.1801C423.04 43.0301 423.12 42.9001 423.23 42.8101C423.25 42.7801 423.27 42.7501 423.29 42.7301C423.37 42.6301 423.5 42.5801 423.62 42.5801C423.75 42.5801 423.87 42.6401 423.96 42.7301C424.04 42.8201 424.08 42.9401 424.08 43.0701V43.1001C424.08 43.1001 424.08 43.1801 424.08 43.1901C424.08 43.4101 423.93 43.6001 423.71 43.6501C423.69 43.6501 423.66 43.6501 423.64 43.6501L423.65 43.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.259 43.51C420.259 43.51 420.37 43.43 420.35 43.39C420.34 43.36 420.279 43.39 420.259 43.43C420.219 43.48 420.219 43.51 420.259 43.51Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.259 43.9601C420.259 43.9601 420.229 43.9601 420.219 43.9601C420.039 43.9401 419.889 43.8301 419.819 43.6701C419.749 43.4901 419.789 43.2801 419.919 43.1401C420.039 42.9901 420.219 42.9201 420.409 42.9401C420.569 42.9701 420.699 43.0701 420.769 43.2201C420.839 43.3901 420.809 43.5901 420.699 43.7301C420.599 43.8701 420.439 43.9601 420.269 43.9601H420.259ZM420.339 43.4501L420.269 43.8201C420.389 43.8401 420.509 43.8001 420.599 43.7201C420.689 43.6101 420.709 43.4601 420.649 43.3201L420.339 43.4501ZM420.259 43.0601C420.149 43.0601 420.039 43.1101 419.959 43.2001C419.889 43.3101 419.879 43.4501 419.929 43.5701L420.239 43.4401L420.299 43.0701C420.299 43.0701 420.269 43.0701 420.259 43.0701V43.0601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.469 42.99C421.469 42.99 421.619 43.11 421.589 43.09C421.569 43.11 421.719 42.89 421.699 42.91C421.729 42.93 421.589 42.91 421.629 42.94C421.639 42.92 421.459 43.01 421.469 42.99Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.619 43.55C421.619 43.55 421.579 43.55 421.559 43.55C421.469 43.55 421.379 43.5 421.309 43.44L421.289 43.42C421.289 43.42 421.269 43.4 421.249 43.39C421.089 43.29 420.999 43.1 421.029 42.92C421.059 42.73 421.209 42.59 421.399 42.55C421.429 42.54 421.459 42.53 421.489 42.52C421.509 42.52 421.529 42.51 421.539 42.5C421.699 42.44 421.869 42.46 421.999 42.57C422.089 42.64 422.149 42.76 422.159 42.88C422.159 42.94 422.159 43 422.139 43.06C422.119 43.11 422.099 43.16 422.059 43.2C422.049 43.22 422.039 43.24 422.019 43.26L421.999 43.29C421.999 43.29 421.949 43.38 421.919 43.41C421.839 43.5 421.729 43.55 421.609 43.55H421.619Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.399 46.53C423.399 46.53 423.369 46.36 423.359 46.32C423.349 46.29 423.429 46.26 423.419 46.29C423.369 46.41 423.359 46.53 423.399 46.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.4 46.98C423.4 46.98 423.37 46.98 423.35 46.98C423.2 46.96 423.079 46.88 422.999 46.75C422.949 46.65 422.919 46.55 422.929 46.44C422.889 46.25 422.959 46.05 423.119 45.93C423.289 45.8 423.53 45.8 423.7 45.93C423.84 46.04 423.899 46.23 423.859 46.41C423.889 46.55 423.86 46.7 423.77 46.81C423.68 46.92 423.55 46.98 423.41 46.99L423.4 46.98ZM423.51 46.43L423.64 46.65C423.73 46.58 423.799 46.48 423.809 46.36C423.789 46.32 423.769 46.28 423.749 46.25L423.51 46.43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.929 47.1701C397.929 47.1701 397.719 47.1701 397.719 47.1901C397.719 47.2101 397.919 47.0401 397.939 47.0701C397.959 47.0501 398.069 47.2501 398.079 47.2301C398.089 47.2101 397.949 47.1901 397.929 47.1701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.069 47.68C397.999 47.68 397.929 47.6601 397.869 47.6301H397.829C397.719 47.6601 397.589 47.64 397.489 47.58C397.339 47.49 397.249 47.32 397.269 47.14C397.279 46.98 397.379 46.84 397.529 46.78C397.589 46.74 397.649 46.71 397.709 46.68C397.799 46.62 397.909 46.6 398.009 46.62C398.029 46.62 398.049 46.6201 398.059 46.6301C398.079 46.6301 398.099 46.64 398.109 46.65C398.229 46.71 398.329 46.81 398.399 46.93C398.359 46.88 398.309 46.85 398.259 46.83C398.429 46.91 398.529 47.09 398.519 47.28C398.499 47.47 398.359 47.63 398.179 47.67C398.139 47.67 398.099 47.68 398.069 47.68Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.399 44.98C399.399 44.98 399.299 44.75 399.279 44.72C399.249 44.75 399.379 44.95 399.379 44.98C399.379 45.01 399.239 44.98 399.269 45.01C399.299 44.99 399.389 45.01 399.409 44.98H399.399Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.249 45.45H399.219C399.099 45.45 398.979 45.38 398.909 45.29C398.799 45.16 398.769 44.98 398.829 44.83C398.789 44.69 398.829 44.54 398.919 44.43C399.009 44.32 399.149 44.26 399.289 44.26C399.409 44.26 399.529 44.32 399.609 44.41C399.669 44.49 399.719 44.57 399.749 44.66L399.779 44.73C399.889 44.91 399.859 45.15 399.699 45.29C399.609 45.37 399.489 45.42 399.369 45.42C399.329 45.42 399.289 45.43 399.259 45.43L399.249 45.45Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.519 34.3801C419.519 34.3801 419.589 34.4101 419.599 34.4401C419.609 34.4701 419.649 34.6301 419.669 34.6001C419.709 34.5401 419.549 34.3801 419.509 34.3801H419.519Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.669 35.05C419.669 35.05 419.619 35.05 419.599 35.05C419.419 35.02 419.269 34.88 419.219 34.7C419.099 34.58 419.049 34.41 419.089 34.25C419.159 34.04 419.359 33.91 419.579 33.93C419.679 33.94 419.769 33.98 419.849 34.05C419.899 34.08 419.949 34.13 419.979 34.18C420.029 34.23 420.059 34.29 420.089 34.36C420.169 34.52 420.149 34.72 420.049 34.87C419.959 34.99 419.829 35.06 419.679 35.06L419.669 35.05ZM419.299 34.76C419.349 34.79 419.409 34.81 419.479 34.82L419.519 34.48L419.319 34.33C419.229 34.45 419.219 34.6 419.279 34.73C419.279 34.73 419.299 34.75 419.309 34.76H419.299Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.259 34.8601C417.259 34.8601 417.439 34.7101 417.419 34.6701C417.409 34.6301 417.439 34.79 417.419 34.83C417.369 34.9 417.219 34.8601 417.259 34.8701V34.8601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.31 35.3201C417.23 35.3201 417.15 35.3101 417.08 35.2701C416.92 35.2001 416.82 35.0501 416.81 34.8801C416.81 34.7101 416.89 34.5501 417.05 34.4701C417.1 34.3501 417.2 34.2701 417.33 34.2301C417.47 34.2001 417.62 34.2301 417.73 34.3301C417.84 34.4301 417.9 34.5701 417.89 34.7101C417.9 34.8401 417.88 34.9601 417.81 35.0701C417.7 35.2301 417.52 35.3201 417.33 35.3101L417.31 35.3201ZM416.99 34.7801C416.99 34.7801 417 34.8201 417.01 34.8401L417.12 34.7901H416.99V34.7801ZM417.3 34.4101C417.19 34.4101 417.1 34.4801 417.04 34.5701L417.27 34.7201L417.3 34.4101ZM417.3 34.4101L417.27 34.7201L417.32 34.7001L417.44 34.4401C417.44 34.4401 417.35 34.4101 417.3 34.4101ZM417.03 34.4701H417.02C416.99 34.5501 416.97 34.6201 416.98 34.6901C416.98 34.6101 417.01 34.5401 417.04 34.4701H417.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.549 40.97C419.549 40.97 419.599 40.94 419.559 40.96C419.519 40.97 419.419 40.96 419.419 41C419.419 41.02 419.549 41.02 419.549 40.98V40.97Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.469 41.46C419.469 41.46 419.429 41.46 419.409 41.46C419.169 41.44 418.979 41.23 418.979 40.99C418.979 40.75 419.169 40.54 419.419 40.53C419.459 40.51 419.499 40.5 419.549 40.5C419.729 40.49 419.899 40.58 419.989 40.74C420.069 40.9 420.049 41.1 419.929 41.24C419.829 41.38 419.659 41.47 419.479 41.46H419.469ZM419.129 40.94C419.129 40.94 419.129 41.01 419.139 41.05L419.419 40.97L419.129 40.94ZM419.129 40.94L419.429 40.97L419.459 40.75L419.409 40.58C419.339 40.6 419.279 40.63 419.229 40.68C419.169 40.75 419.139 40.85 419.129 40.94ZM419.129 40.82C419.129 40.82 419.109 40.9 419.099 40.93C419.099 40.89 419.109 40.85 419.129 40.82Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.799 39.3C419.799 39.3 419.899 39.4001 419.889 39.3701C419.879 39.3401 419.74 39.44 419.72 39.42C419.69 39.37 419.769 39.3001 419.799 39.3101V39.3Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.719 39.8601C419.559 39.8601 419.409 39.78 419.329 39.64C419.229 39.48 419.239 39.2701 419.339 39.1101C419.449 38.9401 419.639 38.8401 419.829 38.8501C419.949 38.8601 420.059 38.9201 420.139 39.0001C420.199 39.0501 420.249 39.1101 420.279 39.1801C420.369 39.3801 420.299 39.6201 420.109 39.7401C420.049 39.7801 419.989 39.8001 419.929 39.8001C419.859 39.8301 419.779 39.8501 419.689 39.8501L419.719 39.8601ZM419.889 39.3701L419.989 39.7001C419.989 39.7001 420.069 39.64 420.099 39.59C420.179 39.47 420.179 39.3101 420.099 39.1801L419.979 39.2501L419.879 39.3501L419.889 39.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M326.449 37.92C326.359 37.85 326.219 38.05 326.149 38.07C326.019 38.1 325.639 37.89 325.569 38.01C325.529 38.08 325.739 38.41 325.829 38.48C325.979 38.6 326.129 38.72 326.299 38.82C326.709 39.06 326.519 38.98 326.459 39.08C326.379 39.21 325.999 39.16 325.899 39.29C325.789 39.43 325.689 39.58 325.619 39.75C325.609 39.94 325.669 40.13 325.789 40.28C325.929 40.5 326.149 40.71 326.099 40.77C326.029 40.87 325.679 40.86 325.529 40.87C325.309 40.89 325.159 40.47 324.939 40.42C324.909 40.41 324.709 40.48 324.729 40.45C324.759 40.43 324.849 40.56 324.879 40.58C325.039 40.78 325.089 41.15 325.289 41.29C325.499 41.44 325.759 41.45 325.819 41.61C325.869 41.75 325.759 41.81 325.459 42.02C325.389 42.17 325.349 42.32 325.349 42.48C325.669 42.74 325.729 42.64 325.619 42.74C325.489 42.86 325.209 42.96 325.119 43.1C325.099 43.13 325.099 43.17 325.059 43.18C325.029 43.15 324.919 43.06 324.949 43.03C324.979 43 325.079 43.1 325.109 43.13C325.219 43.22 325.429 43.58 325.479 43.56C325.879 43.35 325.999 43.22 326.039 43.33C326.099 43.47 325.779 43.77 325.759 43.98C325.739 44.16 326.039 44.36 326.029 44.53C326.009 44.71 326.009 44.88 325.999 45.06C325.979 45.23 325.709 45.39 325.689 45.56C325.679 45.74 325.609 45.91 325.589 46.08C325.579 46.23 325.749 46.43 325.829 46.52C325.979 46.69 326.219 46.82 326.269 46.98C326.329 47.18 326.069 47.39 326.009 47.57C325.979 47.76 325.919 47.94 325.839 48.11C325.739 48.27 325.769 48.52 325.659 48.68C325.389 49.1 324.809 47.98 324.929 48.38C325.009 48.65 325.189 48.82 325.139 49C325.089 49.2 325.109 49.5 324.959 49.7C324.899 49.77 324.709 49.79 324.699 49.9C324.699 49.9 324.859 50.06 324.839 50.07C324.689 50.14 324.379 49.97 324.229 50.04C324.319 50.15 324.479 50.32 324.569 50.43C324.589 50.45 324.629 50.58 324.669 50.59C324.809 50.62 324.999 50.55 325.159 50.57C325.339 50.59 325.449 50.6 325.539 50.7C325.609 50.78 325.619 50.88 325.569 51.07C325.529 51.22 325.669 51.45 325.649 51.59C325.629 51.63 325.419 51.63 325.389 51.59C325.359 51.56 325.459 51.44 325.479 51.47C325.499 51.63 325.479 51.79 325.449 51.95C325.419 52.09 325.159 52.17 325.129 52.31C325.079 52.5 325.479 52.5 325.639 52.52C325.739 52.52 325.819 52.58 325.869 52.66C325.919 52.74 325.909 52.85 325.849 52.93C325.759 53.11 325.169 53.24 325.569 53.56C325.689 53.7 325.739 53.89 325.699 54.07C325.639 54.29 325.299 54.43 325.229 54.64C325.159 54.86 325.309 55.16 325.229 55.37C325.189 55.49 325.109 55.59 324.999 55.65C324.889 55.71 324.759 55.72 324.639 55.68C324.419 55.62 324.199 55.59 323.969 55.6C323.779 55.62 323.609 55.51 323.459 55.53C323.279 55.55 323.169 55.71 323.019 55.77C322.879 55.82 322.689 55.77 322.539 55.88C322.339 56.02 322.129 56.33 321.989 55.82C321.949 55.66 321.799 56.1 321.689 55.96C321.609 56.14 321.669 55.82 321.609 56.01C321.579 56.11 321.449 56.19 321.419 56.29C321.399 56.35 321.349 56.54 321.279 56.57C321.249 56.57 321.069 56.33 321.079 56.31C321.219 55.99 321.109 56 320.929 55.98C320.749 55.96 320.529 55.92 320.489 55.7C320.429 55.48 320.309 55.29 320.139 55.14C319.979 54.99 319.789 54.88 319.589 54.81C319.269 54.66 319.489 54.38 319.669 54.21C319.899 54.04 320.119 53.85 320.319 53.64C320.369 53.57 320.629 53.43 320.659 53.3C320.679 53.2 320.529 53.17 320.239 53.11C320.189 53.1 320.299 53.01 320.309 52.99C320.439 52.82 320.209 52.55 320.189 52.41C320.169 52.25 319.999 52.19 319.919 52.04C319.839 51.89 320.029 51.65 320.019 51.49C319.979 51.06 320.099 50.87 320.349 50.8C320.379 50.9 320.279 51.23 320.309 51.33C320.309 51.3 320.629 51.1 320.629 51.09C320.589 51.03 320.459 51.01 320.419 50.95C320.309 50.79 320.199 50.62 320.109 50.44C320.089 50.36 320.099 50.32 320.229 49.9C320.289 49.67 320.299 49.43 320.269 49.19C320.249 48.98 319.989 48.78 320.069 48.72C320.319 48.52 320.259 48.36 319.989 48.15C319.879 48.06 320.009 47.8 320.039 47.62C320.069 47.42 319.959 47.22 319.979 47.06C320.009 46.85 320.129 46.68 320.129 46.52C320.139 46.33 320.129 46.15 320.109 45.96C320.079 45.81 319.859 45.68 319.799 45.47C319.739 45.24 319.739 45 319.799 44.77C319.859 44.6 320.219 44.52 320.259 44.36C320.319 44.17 320.339 43.97 320.339 43.77C320.319 43.6 319.939 43.57 319.809 43.42C319.709 43.31 319.669 43.15 319.489 43.05C319.129 42.85 319.689 42.84 319.839 42.71C319.999 42.57 319.939 42.22 320.069 42.05C319.959 41.96 319.859 41.84 319.799 41.72C319.729 41.61 319.779 41.65 319.549 41.74C319.529 41.74 319.159 41.24 319.199 41.18C319.289 41.02 319.609 41 319.709 40.85C319.809 40.7 319.789 40.47 319.889 40.32C319.979 40.37 320.099 40.31 320.189 40.35C320.189 40.35 320.239 40.26 320.269 40.24C320.149 40.22 320.039 40.31 319.919 40.29C319.929 40.13 319.899 40 319.909 39.84C319.919 39.68 319.999 39.5 320.009 39.34C320.009 39.32 319.929 39.48 319.949 39.47C320.089 39.38 320.139 39.19 320.279 39.1C320.169 38.95 320.249 38.76 320.189 38.6C320.149 38.44 320.119 38.27 320.119 38.11C320.089 37.94 319.939 37.79 319.939 37.61C319.939 37.43 319.999 37.26 320.009 37.09C320.009 36.91 319.869 36.75 319.869 36.57C319.869 36.55 320.049 36.55 320.039 36.53C320.039 36.44 319.919 36.39 319.919 36.3C319.919 36.29 319.889 36.32 319.899 36.3C319.929 36.04 319.809 35.47 319.949 35.38C320.159 35.24 320.419 35.29 320.479 35.16C320.589 34.98 320.619 34.76 320.559 34.55C320.479 34.37 320.389 34.19 320.289 34.02C320.189 33.84 320.019 33.72 320.029 33.54C320.029 33.52 319.799 33.62 319.689 33.59C319.629 33.58 319.559 33.56 319.499 33.53C319.449 33.33 319.979 33.1 320.059 32.89C320.129 32.71 319.919 32.57 319.539 32.43C319.589 32.3 319.539 31.9 319.639 31.83C319.779 31.72 319.969 31.68 320.089 31.57C320.229 31.45 320.209 31.4 320.229 31.23C320.239 31.1 320.539 30.89 320.429 30.69C320.379 30.6 320.609 30.38 320.769 30.18C321.029 29.87 321.239 29.69 321.229 29.55C321.219 29.41 320.899 29.35 320.609 29.07C320.469 28.96 320.349 28.83 320.239 28.69C320.199 28.61 320.289 28.51 320.669 28.43C321.129 28.33 320.989 28.23 320.779 27.96C320.669 27.82 320.789 27.34 321.169 27.4C321.379 27.43 321.589 27.84 321.819 27.82C322.039 27.79 322.219 27.51 322.429 27.44C322.629 27.34 322.819 27.22 322.999 27.08C323.109 27.09 323.249 27.21 323.359 27.2C323.449 27.19 323.529 27.16 323.619 27.12C323.539 27.08 323.379 26.98 323.309 27C323.219 27.02 323.079 27.19 322.989 27.25C322.959 27 322.979 26.75 323.039 26.51C323.089 26.36 323.289 26.29 323.369 26.14C323.449 26 323.539 25.86 323.629 25.73C323.629 25.73 323.539 25.89 323.609 25.95C323.769 26.1 324.169 25.98 324.329 26.15C324.349 26.16 324.249 26.11 324.229 26.11C324.049 26.16 324.039 26.37 323.869 26.42C324.049 26.45 324.079 26.67 324.249 26.71C324.269 26.71 324.199 26.49 324.219 26.48C324.309 26.48 324.449 26.39 324.539 26.39C324.549 26.39 324.539 26.64 324.539 26.63C324.719 26.52 324.809 26.14 324.959 26.15C325.169 26.23 325.329 26.4 325.399 26.62C325.499 26.8 325.589 26.99 325.669 27.18C325.719 27.37 325.439 27.65 325.479 27.84C325.519 28.03 325.819 28.18 325.849 28.38C325.889 28.58 325.739 28.8 325.789 29C325.819 29.23 325.869 29.45 325.919 29.67C325.989 29.88 326.329 30.04 326.359 30.26C326.379 30.43 326.079 30.63 326.059 30.81C326.039 30.99 326.309 31.27 326.239 31.43C326.089 31.8 326.039 32.15 326.289 32.16L326.449 37.92ZM326.609 37.23C326.329 37.49 326.729 37.59 327.089 37.53L326.609 37.23ZM323.519 48.77C323.519 48.77 323.839 48.87 323.809 48.9C323.779 48.93 323.739 48.57 323.709 48.55C323.689 48.53 323.599 48.7 323.579 48.68C323.609 48.69 323.499 48.76 323.519 48.77ZM321.769 31.22C321.769 31.22 322.059 31.1 322.079 31.12C322.099 31.14 322.119 31.14 322.139 31.15C322.099 31.12 321.919 31.16 321.879 31.13C321.859 31.11 321.919 31.23 321.909 31.21C321.939 31.22 321.749 31.21 321.779 31.21L321.769 31.22ZM325.879 35.06C325.879 35.06 325.609 35.21 325.599 35.19C325.599 35.17 325.589 35.18 325.569 35.17C325.609 35.2 325.769 35.14 325.809 35.17C325.859 35.27 325.809 35.44 325.869 35.54C325.999 35.74 326.219 35.65 326.359 35.85L325.879 35.06ZM326.869 36.77C326.839 36.61 326.699 36.7 326.689 36.7C326.519 36.7 326.149 36.28 326.059 36.37C325.869 36.56 325.869 36.94 325.729 37.18C325.789 37.26 325.849 37.33 325.919 37.39C326.069 37.3 326.039 36.9 326.189 36.81C326.349 36.71 326.729 36.85 326.869 36.77ZM324.269 53.96C324.199 54.11 324.349 54.47 324.269 54.62C324.199 54.77 323.759 54.74 323.689 54.89C323.679 54.92 323.959 55.11 323.999 55.17C324.099 55.02 324.299 54.92 324.399 54.76C324.499 54.61 324.269 54.33 324.369 54.17C324.319 54.14 324.429 54.04 324.269 53.95V53.96ZM321.439 28.36C321.389 28.49 321.419 28.64 321.509 28.75C321.619 28.87 321.609 29.28 321.739 29.38C321.779 29.21 321.789 29.04 321.789 28.87C321.689 28.69 321.569 28.52 321.439 28.36ZM323.889 48.69C324.029 48.78 324.199 48.8 324.349 48.76C324.479 48.76 324.779 49.02 324.909 48.99C324.849 48.91 324.639 48.64 324.569 48.63C324.339 48.63 324.109 48.64 323.889 48.69ZM321.849 54.85C321.789 54.92 321.959 55.01 321.929 55.05C321.989 55.09 321.819 55.41 321.889 55.42C321.939 55.42 322.069 55.18 322.129 55.15C322.049 55.09 321.929 54.91 321.859 54.84L321.849 54.85ZM322.409 53.72C322.479 53.64 322.389 53.3 322.459 53.19C322.469 53.17 322.519 53.02 322.489 52.96C322.349 53.06 322.229 53.34 322.099 53.44C322.169 53.47 322.279 53.65 322.409 53.72ZM324.349 53.55C324.279 53.53 324.139 53.74 324.079 53.75C324.019 53.76 323.749 53.71 323.699 53.75C323.839 53.78 323.989 53.8 324.129 53.81C324.219 53.73 324.289 53.64 324.349 53.54V53.55ZM327.059 33.33C327.019 33.44 327.219 33.68 327.209 33.77C327.209 33.82 327.139 34.05 327.169 34.1L327.059 33.33ZM324.979 47.66C324.919 47.63 324.729 47.78 324.669 47.78C324.609 47.78 324.359 47.63 324.309 47.67C324.429 47.73 324.549 47.77 324.679 47.8C324.789 47.77 324.889 47.72 324.979 47.66ZM322.209 48.46C322.139 48.54 322.289 48.83 322.209 48.91C322.239 48.93 322.169 49.08 322.179 49.07C322.269 49.03 322.299 48.82 322.379 48.76C322.339 48.72 322.249 48.52 322.199 48.45L322.209 48.46ZM322.929 54.62C322.839 54.6 322.719 54.77 322.669 54.79C322.619 54.81 322.299 54.65 322.289 54.71C322.289 54.74 322.559 54.86 322.599 54.9C322.669 54.83 322.849 54.7 322.929 54.62ZM322.179 39.46C322.239 39.44 322.129 39.2 322.189 39.18C322.159 39.14 322.339 38.95 322.309 38.95C322.249 38.95 322.129 39.16 322.069 39.19C322.099 39.23 322.149 39.42 322.179 39.47V39.46ZM320.339 48.7C320.339 48.7 320.559 48.65 320.579 48.66C320.609 48.68 320.699 48.97 320.729 48.97C320.729 48.93 320.579 48.75 320.569 48.71C320.539 48.72 320.369 48.69 320.339 48.71V48.7ZM323.789 52.56C323.789 52.56 323.949 52.78 323.919 52.8C323.939 52.82 323.839 52.99 323.849 52.98C323.889 52.96 323.889 52.76 323.939 52.74C323.909 52.73 323.829 52.57 323.799 52.56H323.789ZM322.879 30.88C322.879 30.88 323.049 30.63 323.079 30.63C323.089 30.63 323.279 30.7 323.289 30.67C323.199 30.67 323.109 30.68 323.019 30.7C322.959 30.75 322.919 30.82 322.869 30.88H322.879ZM322.289 55.82C322.289 55.82 322.409 55.9 322.429 55.94C322.449 55.98 322.469 56.16 322.489 56.12C322.539 56.02 322.339 55.83 322.289 55.82ZM324.729 32.24C324.729 32.24 324.539 32.39 324.519 32.37C324.499 32.39 324.279 32.17 324.279 32.2C324.349 32.25 324.439 32.3 324.519 32.33C324.589 32.31 324.659 32.28 324.719 32.25L324.729 32.24ZM321.649 48.17C321.649 48.17 321.789 48.26 321.799 48.29C321.799 48.32 321.809 48.47 321.819 48.45C321.869 48.36 321.679 48.17 321.649 48.17ZM320.669 46.87C320.669 46.87 320.539 46.78 320.529 46.74C320.519 46.71 320.509 46.54 320.489 46.57C320.439 46.66 320.629 46.86 320.669 46.87ZM322.589 46.76C322.589 46.76 322.719 46.85 322.729 46.89C322.739 46.92 322.749 47.09 322.769 47.06C322.819 46.96 322.629 46.77 322.589 46.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M321.33 57.0101C321.18 57.0101 321.04 56.95 320.93 56.84C320.8 56.72 320.7 56.56 320.65 56.38C320.35 56.32 320.12 56.08 320.06 55.78C320.02 55.67 319.96 55.57 319.87 55.5L319.82 55.44C319.73 55.37 319.63 55.31 319.53 55.27L319.41 55.22C319.19 55.13 319.03 54.9301 319 54.7001C318.98 54.3801 319.13 54.07 319.39 53.88C319.48 53.8 319.57 53.73 319.66 53.66C319.76 53.59 319.85 53.51 319.94 53.42C319.88 53.37 319.84 53.3 319.82 53.22C319.78 53.08 319.82 52.93 319.9 52.81L319.88 52.77C319.84 52.69 319.81 52.61 319.78 52.53L319.75 52.5101C319.67 52.4301 319.6 52.35 319.55 52.25C319.45 52.03 319.45 51.77 319.56 51.56C319.57 51.53 319.58 51.5 319.59 51.47C319.55 51.2 319.6 50.9301 319.75 50.7001C319.73 50.6601 319.71 50.61 319.69 50.56C319.63 50.34 319.66 50.2301 319.81 49.7601C319.85 49.5901 319.86 49.41 319.83 49.24C319.83 49.24 319.79 49.19 319.77 49.16C319.55 48.83 319.6 48.61 319.69 48.47C319.49 48.24 319.45 47.92 319.57 47.65C319.58 47.61 319.59 47.57 319.6 47.53C319.6 47.48 319.59 47.43 319.58 47.38C319.54 47.25 319.53 47.12 319.55 46.99C319.57 46.86 319.61 46.73 319.66 46.61C319.68 46.57 319.69 46.54 319.7 46.5V46.41C319.7 46.3 319.7 46.19 319.7 46.09C319.69 46.07 319.67 46.06 319.66 46.04C319.54 45.91 319.45 45.76 319.39 45.59C319.31 45.28 319.31 44.95 319.4 44.64C319.48 44.44 319.64 44.28 319.83 44.19L319.87 44.16C319.89 44.09 319.9 44.03 319.9 43.99C319.74 43.94 319.6 43.84 319.48 43.72C319.44 43.67 319.4 43.61 319.36 43.56C319.31 43.49 319.3 43.47 319.28 43.46C319.05 43.37 318.91 43.14 318.93 42.9C318.97 42.55 319.3 42.46 319.47 42.4H319.52V42.31C319.52 42.31 319.54 42.2401 319.55 42.2001C319.42 42.2001 319.29 42.13 319.2 42.04C318.98 41.79 318.63 41.33 318.81 40.99C318.92 40.81 319.09 40.67 319.3 40.61C319.32 40.61 319.34 40.59 319.36 40.59C319.36 40.57 319.37 40.5401 319.38 40.5101C319.4 40.3901 319.44 40.28 319.49 40.17V40.12C319.48 40.03 319.48 39.93 319.49 39.83C319.49 39.75 319.51 39.66 319.53 39.58C319.51 39.45 319.53 39.32 319.6 39.21C319.65 39.12 319.71 39.05 319.79 39C319.79 38.95 319.79 38.89 319.79 38.84C319.79 38.82 319.79 38.79 319.79 38.77C319.74 38.63 319.71 38.48 319.71 38.34C319.71 38.3 319.71 38.25 319.7 38.21C319.69 38.18 319.67 38.15 319.66 38.13C319.57 37.98 319.52 37.82 319.51 37.65C319.51 37.53 319.53 37.4 319.55 37.28C319.56 37.22 319.57 37.16 319.58 37.1C319.57 37.08 319.56 37.06 319.55 37.03C319.48 36.89 319.45 36.74 319.45 36.59C319.45 36.53 319.46 36.48 319.48 36.43C319.47 36.37 319.47 36.3 319.48 36.24C319.48 36.22 319.47 36.11 319.46 36C319.43 35.63 319.41 35.24 319.72 35.04C319.85 34.96 319.99 34.9 320.15 34.88C320.16 34.84 320.17 34.8001 320.17 34.7601C320.1 34.6001 320.02 34.45 319.93 34.3C319.9 34.26 319.88 34.21 319.84 34.18C319.82 34.15 319.8 34.13 319.78 34.1C319.73 34.1 319.68 34.1 319.63 34.09C319.39 34.08 319.18 33.9201 319.09 33.7001C319.04 33.3901 319.19 33.08 319.46 32.93L319.41 32.91C319.3 32.87 319.2 32.78 319.15 32.67C319.1 32.56 319.1 32.43 319.15 32.32C319.15 32.28 319.15 32.25 319.15 32.21C319.12 31.96 319.21 31.71 319.39 31.53C319.49 31.46 319.59 31.4 319.7 31.35C319.74 31.33 319.78 31.31 319.81 31.3V31.23C319.84 31.09 319.9 30.95 320 30.84L320.02 30.82C319.96 30.53 320.18 30.27 320.37 30.05L320.46 29.94C320.53 29.86 320.6 29.78 320.66 29.72V29.7001C320.55 29.6301 320.44 29.5401 320.34 29.4501L320.27 29.39C320.11 29.27 319.98 29.12 319.87 28.94C319.79 28.79 319.79 28.62 319.87 28.47C319.98 28.28 320.15 28.15 320.36 28.1C320.29 27.86 320.32 27.6 320.46 27.38C320.62 27.09 320.95 26.94 321.28 27C321.49 27.05 321.67 27.16 321.81 27.32C321.82 27.33 321.84 27.35 321.85 27.36C321.87 27.35 321.88 27.33 321.9 27.32C322.02 27.2 322.16 27.11 322.32 27.05C322.41 27.01 322.48 26.96 322.56 26.9C322.56 26.74 322.59 26.57 322.64 26.41C322.7 26.24 322.81 26.1 322.96 25.99C322.98 25.97 323 25.95 323.02 25.93L323.27 25.52C323.36 25.37 323.54 25.29 323.71 25.31C323.89 25.33 324.03 25.46 324.08 25.63C324.29 25.63 324.49 25.71 324.65 25.85C324.76 25.77 324.89 25.73 325.03 25.75C325.41 25.84 325.72 26.13 325.83 26.5C325.86 26.56 325.889 26.63 325.929 26.69C326.009 26.82 326.08 26.96 326.12 27.11C326.16 27.34 326.119 27.57 325.989 27.77L325.97 27.81L326 27.84C326.15 27.97 326.26 28.15 326.31 28.35C326.33 28.51 326.31 28.68 326.27 28.84C326.26 28.88 326.249 28.93 326.239 28.97C326.259 29.04 326.27 29.14 326.29 29.23C326.3 29.35 326.329 29.46 326.359 29.57C326.359 29.57 326.42 29.63 326.46 29.66C326.64 29.81 326.77 30.01 326.82 30.25C326.83 30.48 326.74 30.71 326.58 30.88L326.549 30.91L326.57 30.9501C326.71 31.1601 326.739 31.41 326.669 31.65C326.619 31.75 326.59 31.87 326.58 31.98C326.55 31.86 326.45 31.7701 326.33 31.7601L326.29 32.66C326.09 32.66 325.9 32.55 325.79 32.38C325.64 32.07 325.649 31.72 325.799 31.41C325.799 31.39 325.78 31.37 325.77 31.35C325.67 31.18 325.62 30.99 325.63 30.8C325.66 30.62 325.739 30.46 325.859 30.33L325.84 30.31C325.69 30.19 325.58 30.03 325.51 29.85C325.46 29.69 325.43 29.53 325.4 29.36C325.39 29.28 325.379 29.21 325.359 29.13C325.329 28.96 325.34 28.78 325.39 28.61C325.39 28.58 325.41 28.55 325.41 28.52C325.39 28.5 325.37 28.48 325.35 28.46C325.2 28.33 325.09 28.16 325.04 27.96C325.01 27.75 325.059 27.53 325.169 27.35C325.179 27.32 325.2 27.3 325.21 27.27C325.19 27.23 325.16 27.17 325.13 27.12C325.08 27.03 325.029 26.94 324.989 26.85C324.929 26.93 324.86 26.99 324.77 27.05C324.69 27.1 324.589 27.13 324.489 27.11C324.409 27.16 324.32 27.19 324.22 27.18C324.16 27.17 324.099 27.15 324.049 27.13C324.049 27.3 323.96 27.46 323.81 27.54C323.68 27.6 323.54 27.64 323.4 27.65C323.35 27.65 323.3 27.65 323.25 27.64C323.15 27.7 323.039 27.7201 322.929 27.7001C322.829 27.7701 322.72 27.82 322.6 27.86C322.58 27.86 322.52 27.92 322.48 27.96C322.33 28.11 322.14 28.2101 321.93 28.2601C322.05 28.4001 322.15 28.56 322.23 28.73C322.28 28.93 322.28 29.14 322.23 29.34C322.23 29.38 322.22 29.42 322.22 29.44C322.21 29.57 322.14 29.6901 322.03 29.7601C321.92 29.8401 321.79 29.86 321.66 29.83C321.57 29.99 321.47 30.1301 321.34 30.2601C321.29 30.3201 321.23 30.39 321.16 30.46L321.06 30.58C321.06 30.58 320.99 30.66 320.95 30.71C320.95 30.93 320.88 31.15 320.73 31.32L320.71 31.34C320.71 31.57 320.6 31.78 320.42 31.91C320.32 31.99 320.21 32.05 320.1 32.1L320.06 32.12V32.14C320.25 32.22 320.4 32.37 320.5 32.55C320.57 32.7 320.58 32.88 320.52 33.04C320.49 33.11 320.46 33.17 320.41 33.23C320.48 33.31 320.52 33.4001 320.52 33.5101C320.53 33.5301 320.55 33.55 320.57 33.57C320.63 33.64 320.68 33.71 320.72 33.79C320.83 33.98 320.93 34.17 321.01 34.36C321.12 34.69 321.09 35.04 320.91 35.34C320.8 35.53 320.6 35.66 320.37 35.69H320.36C320.36 35.76 320.36 35.83 320.37 35.88C320.37 35.97 320.38 36.05 320.38 36.13C320.47 36.23 320.52 36.3701 320.52 36.5101C320.52 36.5901 320.5 36.67 320.45 36.74C320.45 36.74 320.44 36.76 320.43 36.77C320.47 36.87 320.48 36.98 320.48 37.09C320.48 37.19 320.46 37.29 320.44 37.39C320.42 37.46 320.42 37.52 320.41 37.59C320.43 37.61 320.44 37.63 320.45 37.65C320.52 37.77 320.57 37.89 320.59 38.03C320.6 38.1 320.61 38.17 320.61 38.24C320.61 38.3 320.61 38.36 320.64 38.42C320.68 38.54 320.7 38.67 320.7 38.8C320.7 38.83 320.7 38.85 320.7 38.88C320.77 38.97 320.79 39.0901 320.76 39.2001C320.73 39.3201 320.65 39.41 320.55 39.47C320.55 39.49 320.53 39.51 320.52 39.52C320.5 39.55 320.47 39.59 320.44 39.63L320.42 39.7001C320.42 39.7001 320.4 39.76 320.39 39.79C320.54 39.82 320.66 39.93 320.71 40.08C320.76 40.22 320.74 40.3901 320.64 40.5101C320.56 40.6701 320.41 40.77 320.23 40.79C320.2 40.9 320.16 41 320.1 41.1C320.06 41.15 320.02 41.2 319.97 41.24C320.07 41.29 320.14 41.36 320.2 41.46C320.24 41.54 320.29 41.61 320.35 41.67C320.45 41.74 320.52 41.85 320.54 41.98C320.56 42.1 320.53 42.23 320.45 42.33C320.45 42.37 320.45 42.4 320.44 42.44C320.42 42.67 320.32 42.89 320.16 43.05H320.14C320.14 43.05 320.17 43.11 320.18 43.12C320.18 43.12 320.23 43.12 320.27 43.14C320.45 43.21 320.77 43.3501 320.81 43.7001C320.82 43.9501 320.79 44.2 320.72 44.44C320.65 44.65 320.49 44.83 320.29 44.92C320.27 44.93 320.25 44.9401 320.23 44.9501C320.22 45.0701 320.23 45.2 320.25 45.32C320.25 45.33 320.3 45.38 320.33 45.41C320.45 45.53 320.53 45.68 320.57 45.84C320.59 45.94 320.6 46.04 320.6 46.14C320.78 46.18 320.92 46.34 320.95 46.52C321.13 46.66 321.17 46.91 321.06 47.11C320.94 47.3 320.7 47.38 320.49 47.29C320.51 47.41 320.52 47.53 320.49 47.66C320.48 47.73 320.46 47.8 320.44 47.88V47.9C320.53 47.99 320.6 48.1 320.65 48.23C320.71 48.23 320.77 48.26 320.82 48.29C320.94 48.37 321.03 48.5 321.07 48.64L321.09 48.68C321.13 48.74 321.17 48.81 321.18 48.89C321.21 49.02 321.18 49.16 321.09 49.27C321.01 49.38 320.88 49.44 320.74 49.44C320.74 49.63 320.72 49.8301 320.66 50.0101C320.61 50.1601 320.58 50.25 320.56 50.31C320.58 50.34 320.61 50.37 320.64 50.42C320.7 50.47 320.75 50.53 320.78 50.6C320.88 50.65 320.97 50.73 321.03 50.82C321.24 51.1901 320.9 51.42 320.74 51.54C320.71 51.56 320.67 51.59 320.65 51.61C320.59 51.67 320.52 51.71 320.44 51.73C320.43 51.77 320.41 51.81 320.4 51.85C320.53 51.98 320.62 52.14 320.66 52.32C320.66 52.31 320.67 52.34 320.69 52.36C320.76 52.49 320.81 52.63 320.83 52.78C320.92 52.83 321 52.9 321.06 52.99C321.13 53.11 321.15 53.25 321.12 53.38C321.05 53.59 320.91 53.76 320.72 53.88L320.66 53.92C320.53 54.08 320.37 54.22 320.2 54.34C320.14 54.39 320.08 54.43 320.02 54.48C320.19 54.56 320.35 54.67 320.48 54.81L320.53 54.86C320.71 55.03 320.85 55.25 320.92 55.49C320.94 55.49 320.96 55.49 320.98 55.49C321.1 55.49 321.22 55.52 321.33 55.58C321.36 55.55 321.4 55.5301 321.43 55.5101C321.41 55.3901 321.43 55.27 321.46 55.15C321.34 54.96 321.36 54.72 321.51 54.56C321.72 54.56 321.93 54.47 322.08 54.32C322.23 54.24 322.41 54.24 322.57 54.3C322.7 54.19 322.879 54.15 323.049 54.19C323.229 54.23 323.36 54.38 323.38 54.56C323.5 54.44 323.65 54.37 323.82 54.33C323.82 54.3 323.81 54.26 323.81 54.23C323.72 54.23 323.629 54.2 323.549 54.17C323.409 54.11 323.3 53.99 323.27 53.84C323.24 53.69 323.29 53.53 323.4 53.43C323.45 53.38 323.51 53.35 323.57 53.32C323.56 53.31 323.55 53.3 323.54 53.29C323.43 53.17 323.4 53 323.45 52.84C323.37 52.73 323.35 52.59 323.38 52.46C323.41 52.33 323.499 52.23 323.609 52.16C323.719 52.1 323.86 52.09 323.98 52.14C324.1 52.19 324.2 52.28 324.26 52.4C324.34 52.48 324.39 52.58 324.41 52.69C324.41 52.74 324.41 52.8 324.4 52.85C324.39 52.93 324.36 53.01 324.33 53.09C324.4 53.09 324.47 53.09 324.53 53.12C324.65 53.16 324.749 53.25 324.799 53.38C324.849 53.5 324.84 53.64 324.79 53.75C324.79 53.76 324.77 53.78 324.76 53.8C324.81 53.89 324.84 53.99 324.84 54.09C324.85 54.16 324.85 54.23 324.84 54.3V54.34C324.84 54.34 324.87 54.39 324.88 54.42C324.96 54.25 325.08 54.1 325.23 53.99C325.27 53.96 325.31 53.92 325.34 53.88C325.33 53.9 325.32 53.86 325.31 53.84C325.14 53.71 325.04 53.51 325.04 53.29C325.04 53.13 325.11 52.98 325.23 52.87C325.07 52.84 324.94 52.75 324.84 52.62C324.75 52.49 324.71 52.32 324.75 52.16C324.8 51.99 324.899 51.85 325.049 51.75C324.989 51.63 324.98 51.49 325.02 51.36C325.05 51.27 325.099 51.19 325.169 51.13C325.169 51.08 325.169 51.03 325.169 50.98C325.119 50.98 325.07 50.98 325.03 50.98C324.9 51 324.77 51.01 324.63 50.98C324.45 50.94 324.299 50.81 324.239 50.63L324.16 50.54C324.07 50.44 323.98 50.33 323.91 50.25C323.83 50.14 323.8 50 323.83 49.87C323.86 49.74 323.95 49.63 324.08 49.57C324.28 49.59 324.48 49.5 324.6 49.34C324.53 49.31 324.47 49.27 324.41 49.24C324.38 49.23 324.36 49.2101 324.34 49.2001C324.28 49.2001 324.22 49.2001 324.16 49.2001C324.04 49.3101 323.87 49.36 323.71 49.31C323.66 49.29 323.61 49.27 323.56 49.24H323.54C323.42 49.2 323.3 49.14 323.21 49.05C323.15 48.99 323.12 48.91 323.1 48.82C323.09 48.68 323.13 48.55 323.21 48.44C323.22 48.42 323.24 48.4 323.25 48.37C323.27 48.35 323.29 48.32 323.32 48.3C323.41 48.16 323.56 48.07 323.73 48.07C323.83 48.07 323.92 48.1 324 48.16C324 48.16 324.03 48.18 324.04 48.19C324.19 48.17 324.309 48.16 324.419 48.15C324.319 48.11 324.22 48.07 324.12 48.02C323.98 47.94 323.9 47.79 323.9 47.64C323.9 47.48 323.98 47.34 324.12 47.25C324.3 47.16 324.52 47.16 324.7 47.25C324.87 47.14 325.08 47.13 325.25 47.22C325.37 47.29 325.46 47.42 325.47 47.56C325.48 47.7 325.43 47.84 325.33 47.94C325.36 47.97 325.38 47.9901 325.4 48.0101C325.42 47.9301 325.46 47.86 325.5 47.79C325.53 47.72 325.56 47.65 325.57 47.57C325.58 47.5 325.6 47.43 325.62 47.36C325.66 47.24 325.719 47.12 325.799 47.02L325.82 47L325.78 46.97C325.69 46.9 325.61 46.82 325.53 46.73C325.32 46.53 325.189 46.25 325.179 45.96C325.189 45.85 325.209 45.74 325.239 45.63C325.259 45.57 325.27 45.5 325.28 45.44C325.31 45.24 325.399 45.06 325.549 44.92C325.569 44.9 325.58 44.89 325.6 44.87C325.6 44.81 325.6 44.75 325.6 44.69C325.6 44.62 325.599 44.56 325.609 44.49C325.599 44.47 325.58 44.46 325.57 44.44C325.44 44.29 325.36 44.1 325.35 43.9C325.19 43.82 325.06 43.69 324.97 43.54C324.92 43.52 324.87 43.5 324.82 43.46C324.66 43.35 324.55 43.18 324.53 42.99C324.53 42.86 324.569 42.72 324.669 42.63C324.739 42.56 324.84 42.51 324.94 42.5C324.93 42.45 324.919 42.41 324.919 42.36C324.929 42.11 325.01 41.86 325.15 41.65C325.12 41.63 325.09 41.61 325.06 41.59C324.87 41.44 324.72 41.23 324.65 40.99C324.62 40.92 324.589 40.85 324.549 40.78L324.53 40.7601C324.45 40.7201 324.39 40.66 324.35 40.59C324.25 40.41 324.289 40.19 324.429 40.05C324.509 39.97 324.62 39.93 324.73 39.92C324.84 39.88 324.96 39.88 325.08 39.91C325.12 39.92 325.17 39.94 325.21 39.96C325.17 39.82 325.17 39.68 325.21 39.54C325.28 39.35 325.38 39.16 325.51 39L325.549 38.94C325.549 38.94 325.619 38.85 325.669 38.82L325.58 38.75C325.58 38.75 324.95 38.1601 325.21 37.7001C325.26 37.6001 325.35 37.53 325.45 37.48C325.31 37.33 325.28 37.12 325.37 36.94C325.41 36.86 325.44 36.77 325.46 36.68C325.51 36.44 325.62 36.21 325.78 36.03L325.799 36.0101C325.689 35.9501 325.6 35.8701 325.53 35.7601C325.49 35.7001 325.47 35.64 325.45 35.58C325.42 35.56 325.38 35.54 325.35 35.52C325.34 35.52 325.33 35.5 325.31 35.49C325.17 35.37 325.109 35.18 325.169 35C325.229 34.82 325.39 34.7001 325.58 34.7001C325.72 34.5901 325.91 34.57 326.08 34.63C326.21 34.68 326.31 34.79 326.35 34.93L326.239 34.96C326.279 35.06 326.31 35.16 326.31 35.27C326.49 35.32 326.65 35.43 326.76 35.58L326.28 35.92C326.42 35.97 326.549 36.05 326.669 36.14C326.699 36.16 326.74 36.19 326.77 36.21C326.87 36.21 326.959 36.2101 327.049 36.2601C327.209 36.3401 327.32 36.49 327.35 36.66C327.39 36.85 327.31 37.04 327.14 37.14C327.12 37.15 327.1 37.16 327.08 37.17L327.21 37.96C326.96 38.01 326.69 37.99 326.45 37.89L326.26 38.14C326.32 38.19 326.38 38.24 326.44 38.28C326.5 38.28 326.559 38.27 326.609 38.24C326.569 38.27 326.54 38.3 326.5 38.32C326.52 38.33 326.539 38.34 326.549 38.35C326.809 38.5 327.04 38.64 327.03 38.94C327.01 39.09 326.929 39.23 326.799 39.32C326.659 39.45 326.48 39.53 326.29 39.54C326.27 39.54 326.25 39.54 326.23 39.54C326.18 39.61 326.13 39.6801 326.09 39.7601C326.1 39.7601 326.13 39.8301 326.2 39.9501C326.24 40.0201 326.3 40.09 326.34 40.15C326.48 40.33 326.71 40.63 326.5 40.94C326.41 41.06 326.29 41.14 326.15 41.18C326.2 41.24 326.24 41.3 326.27 41.38C326.43 41.8 326.13 42.04 325.9 42.21C326.03 42.28 326.12 42.41 326.15 42.55C326.15 42.62 326.15 42.7001 326.12 42.7601C326.14 42.7601 326.17 42.77 326.19 42.78C326.33 42.83 326.44 42.9401 326.5 43.07C326.57 43.33 326.51 43.6 326.34 43.81C326.33 43.83 326.31 43.86 326.29 43.89H326.299C326.439 44.06 326.52 44.27 326.52 44.49C326.52 44.57 326.51 44.65 326.51 44.73C326.51 44.82 326.509 44.9201 326.489 45.0101C326.459 45.2101 326.37 45.39 326.22 45.52C326.2 45.54 326.189 45.56 326.169 45.57C326.159 45.66 326.14 45.74 326.12 45.83C326.11 45.88 326.1 45.93 326.09 45.98C326.13 46.04 326.17 46.09 326.22 46.14C326.27 46.19 326.32 46.24 326.37 46.28C326.54 46.4 326.67 46.5701 326.75 46.7601C326.81 47.0301 326.74 47.31 326.56 47.52C326.54 47.55 326.51 47.59 326.5 47.62C326.5 47.65 326.48 47.7 326.47 47.74C326.44 47.92 326.38 48.1001 326.28 48.2601C326.28 48.2701 326.26 48.34 326.26 48.38C326.24 48.54 326.19 48.7 326.1 48.84C326 49.01 325.82 49.12 325.62 49.14V49.19C325.6 49.44 325.52 49.68 325.38 49.89L325.359 49.92C325.359 49.92 325.359 50.01 325.359 50.06C325.579 50.06 325.79 50.16 325.94 50.32C326.11 50.53 326.17 50.8 326.09 51.06C326.09 51.09 326.11 51.12 326.12 51.15C326.17 51.29 326.189 51.43 326.169 51.58C326.169 51.62 326.15 51.6601 326.13 51.7001C326.1 51.7701 326.04 51.83 325.98 51.87C325.98 51.9 325.97 51.94 325.96 51.97C325.96 52 325.95 52.02 325.94 52.05C326.11 52.11 326.25 52.23 326.34 52.39C326.45 52.61 326.44 52.8601 326.32 53.07C326.26 53.17 326.18 53.26 326.08 53.33C326.23 53.57 326.27 53.86 326.21 54.13C326.14 54.33 326.01 54.51 325.84 54.64C325.8 54.67 325.76 54.71 325.72 54.75C325.73 54.75 325.74 54.82 325.75 54.88C325.79 55.08 325.78 55.29 325.71 55.49C325.55 55.94 325.069 56.19 324.609 56.06C324.439 56.01 324.26 55.99 324.09 55.99C323.94 56 323.78 55.99 323.64 55.94C323.62 55.94 323.59 55.93 323.57 55.92C323.59 55.92 323.55 55.95 323.53 55.97C323.44 56.04 323.35 56.09 323.25 56.13C323.17 56.16 323.08 56.17 323 56.18C323 56.22 322.98 56.27 322.96 56.31C322.87 56.48 322.679 56.58 322.489 56.56C322.419 56.56 322.359 56.53 322.299 56.49C322.229 56.49 322.16 56.49 322.09 56.46C322.03 56.44 321.97 56.41 321.92 56.37H321.91C321.87 56.62 321.71 56.82 321.49 56.92C321.45 56.93 321.41 56.94 321.37 56.94L321.33 57.0101ZM323.26 54.99C323.19 55.05 323.13 55.11 323.06 55.16C323.02 55.19 322.98 55.22 322.95 55.25C322.9 55.3 322.85 55.33 322.78 55.35C322.8 55.35 322.82 55.35 322.84 55.35C322.86 55.35 322.89 55.35 322.91 55.35C322.92 55.34 322.94 55.32 322.96 55.31C323.06 55.23 323.179 55.17 323.299 55.12C323.279 55.08 323.27 55.04 323.26 54.99ZM324.65 55.22L324.73 55.24C324.73 55.24 324.79 55.25 324.82 55.25C324.82 55.25 324.82 55.23 324.84 55.21C324.84 55.21 324.83 55.12 324.82 55.07V55.02L324.799 55.05C324.759 55.11 324.71 55.17 324.66 55.22H324.65ZM320.73 46.73L320.91 46.83C320.94 46.78 320.95 46.72 320.95 46.67L320.73 46.74V46.73ZM320.75 46.47L320.73 46.61L320.85 46.5C320.85 46.5 320.79 46.48 320.75 46.47ZM324.63 40.87C324.68 40.88 324.739 40.88 324.799 40.87C324.739 40.87 324.69 40.87 324.63 40.87ZM326.609 37.28L326.9 37.61L326.609 37.28ZM326.609 37.28L326.9 37.6C326.95 37.52 326.97 37.42 326.94 37.33C326.94 37.3 326.92 37.2801 326.91 37.2601C326.81 37.2801 326.709 37.29 326.609 37.28ZM322.419 54.2001C322.349 54.2001 322.29 54.19 322.23 54.16C322.1 54.09 321.98 53.99 321.88 53.88C321.74 53.81 321.65 53.68 321.64 53.53C321.64 53.37 321.7 53.22 321.83 53.13C321.85 53.11 321.9 53.04 321.93 52.99C322.01 52.86 322.11 52.74 322.22 52.65C322.32 52.57 322.45 52.54 322.57 52.56C322.69 52.58 322.8 52.6601 322.87 52.7601C322.97 52.9601 322.97 53.19 322.88 53.39C322.88 53.42 322.88 53.45 322.88 53.48C322.92 53.68 322.859 53.89 322.739 54.06C322.649 54.15 322.53 54.21 322.41 54.21L322.419 54.2001ZM322.2 49.55C322.09 49.55 321.99 49.51 321.9 49.44C321.77 49.31 321.72 49.12 321.77 48.94H321.73C321.54 48.9 321.4 48.75 321.37 48.56C321.21 48.44 321.15 48.21 321.23 48.02C321.31 47.83 321.51 47.7201 321.72 47.7601C321.83 47.7801 321.93 47.84 322.01 47.92C322.06 47.96 322.1 48 322.14 48.04C322.16 48.04 322.19 48.04 322.21 48.04C322.34 48.04 322.469 48.1 322.549 48.21C322.609 48.29 322.66 48.37 322.7 48.46C322.72 48.49 322.73 48.52 322.75 48.54C322.83 48.64 322.86 48.76 322.84 48.89C322.82 48.98 322.78 49.06 322.71 49.12C322.65 49.29 322.54 49.4201 322.39 49.5101C322.33 49.5401 322.26 49.56 322.19 49.56L322.2 49.55ZM321.43 48.29C321.43 48.29 321.39 48.38 321.39 48.43L321.6 48.37L321.43 48.29ZM322.78 47.55C322.78 47.55 322.73 47.55 322.71 47.55C322.52 47.52 322.36 47.36 322.33 47.17C322.16 47.05 322.099 46.83 322.179 46.64C322.259 46.45 322.45 46.34 322.66 46.36C322.8 46.39 322.92 46.46 323.02 46.57C323.08 46.62 323.129 46.69 323.169 46.77C323.269 46.94 323.27 47.14 323.19 47.31C323.11 47.46 322.95 47.56 322.78 47.56V47.55ZM322.44 47.22C322.44 47.22 322.51 47.24 322.54 47.25L322.56 47.11L322.44 47.23V47.22ZM322.38 46.89C322.35 46.94 322.34 47 322.34 47.05L322.56 46.98L322.38 46.89ZM322.19 39.94C322.05 39.94 321.92 39.8701 321.83 39.7601C321.77 39.6801 321.73 39.59 321.71 39.49L321.69 39.43C321.58 39.23 321.63 38.99 321.81 38.85L321.84 38.82C321.95 38.63 322.16 38.52 322.37 38.53C322.53 38.55 322.669 38.65 322.739 38.8C322.809 38.98 322.78 39.18 322.65 39.32C322.72 39.56 322.589 39.82 322.359 39.91C322.309 39.93 322.25 39.94 322.2 39.94H322.19ZM322.64 39.3C322.67 39.17 322.639 39.03 322.549 38.93C322.629 39.03 322.66 39.17 322.64 39.3ZM326.799 34.37C326.709 34.2 326.69 34.01 326.75 33.83C326.63 33.65 326.59 33.42 326.65 33.21L327.5 33.5101C327.52 33.4501 327.53 33.39 327.51 33.32C327.52 33.35 327.539 33.38 327.549 33.41C327.629 33.53 327.669 33.68 327.669 33.83C327.669 33.88 327.66 33.93 327.64 33.98C327.64 34.02 327.62 34.05 327.62 34.09C327.62 34.02 327.6 33.95 327.56 33.89L326.81 34.38L326.799 34.37ZM324.54 32.85C324.54 32.85 324.459 32.85 324.419 32.83C324.369 32.82 324.33 32.8 324.29 32.78C324.22 32.74 324.15 32.69 324.08 32.63C324.03 32.6 323.98 32.5601 323.94 32.5101C323.86 32.4101 323.83 32.29 323.84 32.17C323.86 32.01 323.959 31.87 324.109 31.81C324.259 31.75 324.43 31.77 324.56 31.86C324.74 31.77 324.96 31.82 325.09 31.98C325.17 32.07 325.2 32.19 325.19 32.31C325.18 32.43 325.12 32.54 325.03 32.61C325 32.63 324.959 32.66 324.929 32.67C324.889 32.7 324.849 32.73 324.799 32.75C324.729 32.81 324.639 32.84 324.549 32.84L324.54 32.85ZM324.75 32.0101C324.75 32.0101 324.84 32.07 324.87 32.11C324.84 32.07 324.79 32.0301 324.75 32.0101ZM321.77 31.7001C321.7 31.7001 321.63 31.68 321.57 31.65C321.52 31.62 321.47 31.59 321.44 31.55C321.34 31.44 321.3 31.29 321.33 31.14C321.36 31.01 321.44 30.91 321.55 30.85C321.57 30.82 321.6 30.8 321.63 30.78C321.73 30.72 321.84 30.7 321.95 30.72C322.07 30.69 322.2 30.7001 322.31 30.7601C322.34 30.7701 322.37 30.79 322.4 30.81C322.42 30.82 322.44 30.84 322.45 30.85C322.45 30.81 322.469 30.76 322.489 30.72C322.539 30.61 322.61 30.52 322.7 30.44C322.78 30.31 322.93 30.23 323.08 30.22C323.15 30.22 323.21 30.23 323.28 30.25H323.31C323.31 30.25 323.41 30.27 323.45 30.28C323.57 30.32 323.67 30.41 323.73 30.52C323.78 30.64 323.78 30.77 323.73 30.89C323.66 31.06 323.479 31.17 323.299 31.16C323.179 31.34 322.96 31.41 322.76 31.35C322.7 31.33 322.64 31.3 322.59 31.25C322.59 31.29 322.58 31.32 322.56 31.35C322.49 31.52 322.33 31.63 322.14 31.63C322.07 31.67 322 31.69 321.92 31.69H321.88C321.88 31.69 321.81 31.7001 321.77 31.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.749 39.8201C383.819 39.6601 383.249 39.3901 383.859 39.4501C384.109 39.4801 384.289 39.1801 384.289 39.0101C384.289 38.8701 384.159 38.69 384.149 38.53C384.139 38.38 383.939 38.3301 383.839 38.1901C383.749 38.0601 383.909 37.7501 383.829 37.6301C383.799 37.5801 383.909 37.72 384.099 37.64C384.319 37.55 384.499 37.38 384.319 37.53C384.179 37.64 383.599 37.7201 383.839 38.0701C383.849 38.0901 383.459 38.45 383.449 38.46C383.259 38.75 383.809 39.33 383.889 38.98C383.929 38.79 383.559 38.62 383.489 38.46C383.419 38.3 383.449 38.09 383.309 37.96C383.169 37.85 383.009 37.74 382.859 37.65C382.719 37.54 382.499 37.52 382.359 37.41C382.199 37.3 382.069 37.14 381.949 37.03C381.789 36.89 381.589 36.2 381.689 36.08C381.879 35.85 382.229 35.7701 382.209 35.5701C382.159 35.3201 382.059 35.0901 381.919 34.8801C381.819 34.7101 381.599 34.65 381.489 34.54C381.369 34.42 381.259 34.2801 381.169 34.1301C381.089 33.9901 381.099 33.9001 381.229 33.6901C381.319 33.7601 381.499 33.7301 381.749 33.6901C381.919 33.6601 382.079 33.5001 382.269 33.4401C382.459 33.3801 382.719 33.5301 382.879 33.4501C383.109 33.3501 383.109 33.07 383.159 32.96C383.199 32.89 382.949 32.42 382.989 32.36C382.889 32.34 383.269 32.9101 383.199 32.9501C383.139 32.9901 382.839 32.86 382.609 32.96C382.459 33.02 382.329 33.16 382.159 33.23C381.989 33.3 381.819 33.35 381.669 33.42C381.439 33.52 381.239 33.43 381.179 33.47C381.069 33.45 380.859 33.6801 380.839 33.6201C380.669 33.2201 380.759 33.0801 380.709 33.0001C380.659 32.9301 380.319 32.9201 380.259 32.5101C380.379 32.3201 380.409 32.0901 380.359 31.8701C380.299 31.6901 379.989 31.56 379.919 31.36C379.849 31.15 379.849 30.92 379.789 30.74C379.739 30.53 379.789 30.3101 379.899 30.1301C379.919 30.0701 379.649 29.82 379.649 29.83C379.419 29.94 379.319 30.24 379.089 30.36C379.209 30.46 379.319 30.58 379.389 30.72C379.489 30.89 379.389 31.2 379.509 31.39C379.619 31.58 379.979 31.62 380.079 31.79C380.249 32.07 380.299 32.31 380.349 32.35C380.409 32.4 380.569 32.54 380.629 32.59C380.499 32.69 380.199 32.6301 380.029 32.6301C379.859 32.6101 379.699 32.63 379.539 32.66C379.409 32.71 379.139 32.77 379.069 32.98C379.069 33 379.039 33.0001 379.029 33.0001C379.019 33.0001 378.999 32.99 378.989 32.97C378.899 32.83 378.709 33.0001 378.449 33.0601C378.259 33.1101 377.959 32.88 377.769 32.96C377.599 33.04 377.419 33.12 377.239 33.18C377.039 33.21 377.229 33.2101 377.459 33.0701C377.589 32.9901 377.649 32.82 377.749 32.73C377.839 32.65 377.909 32.59 377.839 32.36C377.799 32.19 377.749 32.02 377.679 31.86C377.609 31.7 377.419 31.6001 377.329 31.4501C377.239 31.2801 377.369 30.99 377.279 30.86C377.169 30.7 377.029 30.56 376.859 30.46C376.719 30.41 376.579 30.26 376.439 30.23C376.299 30.2 376.109 30.27 375.959 30.23C375.869 30.21 375.799 30.34 375.709 30.36C375.779 30.41 375.859 30.45 375.939 30.48C376.059 30.54 375.979 31.07 376.119 31.11C375.989 31.18 376.029 31.18 375.899 31.22C375.689 31.33 375.539 31.5201 375.499 31.7501C375.479 31.9401 375.479 32.1301 375.489 32.3101C375.489 32.5001 375.519 32.69 375.519 32.85C375.519 33.15 375.759 33.1901 375.619 33.0701C375.409 32.9801 375.179 32.9201 374.959 32.8801C374.749 32.8501 374.529 32.8501 374.319 32.8801C374.029 32.8501 373.699 32.82 373.679 32.98C373.629 33.31 373.549 33.44 373.359 33.35C373.209 33.28 373.079 33.0601 372.909 32.9501C372.849 32.8901 372.759 32.8601 372.669 32.8701C372.579 32.8701 372.499 32.9301 372.449 33.0001C372.449 32.9001 372.199 32.55 372.249 32.48C372.319 32.37 372.509 32.6801 372.499 33.0101C372.499 33.1701 372.299 33.34 372.279 33.53C372.259 33.72 372.309 33.9001 372.279 34.0701C372.229 34.3601 372.269 34.44 372.189 34.43C372.089 34.41 371.779 34.7201 371.779 34.8101C371.779 35.0901 371.649 35.2 371.499 35.1C371.379 35.02 371.349 34.56 371.229 34.54C370.739 34.45 371.119 34.44 371.089 34.27C371.029 33.94 371.069 34.0901 370.859 34.1901C370.709 34.2901 370.539 34.36 370.359 34.39C370.149 34.36 369.979 34.19 369.949 33.98C369.889 33.68 369.999 33.91 369.849 34.09C369.659 34.26 369.429 34.39 369.189 34.47C369.169 34.48 369.129 34.4501 369.149 34.4401C369.189 34.3801 369.419 34.24 369.419 34.17C369.419 34.01 369.219 33.81 369.209 33.65C369.099 33.72 369.039 33.9201 368.929 34.0001C368.839 34.0701 368.809 34.17 368.729 34.24C368.729 34.24 368.649 34.15 368.649 34.14C368.669 33.93 368.449 33.6 368.539 33.41C368.599 33.28 369.009 33.3001 369.159 33.2001C369.009 33.1801 368.839 32.98 368.689 32.98C368.489 33.04 368.309 33.1401 368.149 33.2601C367.959 33.3901 367.849 33.86 367.769 33.86C367.699 33.86 367.809 33.39 367.739 33.09C367.699 32.92 367.589 32.74 367.539 32.55C367.499 32.35 367.249 32.2 367.209 32.03C367.139 31.74 367.089 31.42 367.029 31.4C367.199 31.29 367.509 31.33 367.679 31.21C367.789 31.14 367.899 31.33 367.889 31.64C367.889 31.82 367.589 32.03 367.629 32.21C367.669 32.41 367.889 32.5 368.059 32.58C368.189 32.64 368.369 32.8201 368.609 32.7601C368.759 32.7201 368.879 32.51 369.079 32.41C369.259 32.35 369.429 32.2701 369.589 32.1901C369.769 32.0801 369.889 32.0201 369.979 32.0601C370.039 32.0901 369.939 32.0501 369.819 32.3801C369.779 32.5001 370.039 32.31 370.109 31.98C370.139 31.81 370.209 31.63 370.259 31.46C370.299 31.29 370.349 31.12 370.409 30.96C370.469 30.83 370.349 30.49 370.489 30.29C370.599 30.13 370.919 30.1 371.039 29.92C371.149 29.74 371.239 29.5601 371.329 29.3701C371.419 29.1901 371.469 29 371.479 28.8C371.489 28.67 371.649 29 371.709 29.41C371.739 29.63 371.709 29.88 371.739 30.1C371.769 30.32 371.809 30.5401 371.869 30.7601C371.839 30.7801 371.769 30.64 371.739 30.66C371.919 30.58 372.039 30.4001 372.039 30.2001C372.039 30.0001 371.829 29.7701 371.829 29.5701C371.829 29.2301 371.879 29.16 371.889 29.15C371.959 29.15 372.119 29.1701 372.189 29.5001C372.239 29.7001 372.369 29.91 372.409 30.11C372.479 30.43 372.239 30.5601 372.309 30.5701C372.289 30.5401 372.499 30.5 372.479 30.22C372.469 30.06 372.289 29.89 372.279 29.71C372.269 29.53 372.089 29.3601 372.079 29.1901C372.059 28.9101 372.079 28.7301 372.059 28.6901C372.009 28.4801 372.389 28.2301 372.619 28.2501C372.799 28.2601 372.939 28.63 373.089 28.68C373.269 28.74 373.479 28.5 373.639 28.41C373.779 28.33 374.029 28.3301 374.159 28.1901C374.279 28.0701 374.329 27.86 374.449 27.72C374.559 27.58 374.509 27.3 374.619 27.16C374.759 27.04 374.909 26.92 375.069 26.83C375.119 26.79 375.339 26.93 375.369 26.99C375.439 27.12 375.499 27.2501 375.559 27.3801C375.589 27.5001 375.599 27.73 375.849 27.68C376.009 27.65 375.999 27.2301 376.159 27.0601C376.309 26.8701 376.499 26.7001 376.709 26.5701C376.729 26.5701 376.709 26.85 376.729 26.85C376.959 26.81 377.219 26.9201 377.459 26.8701C377.689 26.8301 377.879 26.4701 378.109 26.4501C378.329 26.4301 378.499 26.6901 378.689 26.7601C378.859 26.8201 379.189 26.71 379.339 26.91C379.509 27.14 379.519 27 379.769 26.85C379.979 26.73 380.299 26.7701 380.509 26.7001C380.789 26.6101 381.009 26.41 381.159 26.47C381.339 26.54 381.199 26.9 381.289 27.15C381.399 27.33 381.499 27.52 381.589 27.72C381.649 27.94 381.839 27.96 381.949 28.03C382.069 28.12 382.229 28.1501 382.369 28.1301C382.589 28.1001 382.819 28.0901 383.039 28.1201C383.279 28.1601 383.399 28.39 383.529 28.52C383.659 28.69 383.829 28.83 384.019 28.92C384.189 28.97 384.409 28.6501 384.609 28.6301C385.299 28.5601 384.909 28.73 384.959 28.99C384.959 28.99 385.049 28.8201 385.039 28.8101C385.199 28.9101 385.369 29 385.539 29.1C385.699 29.2 385.849 29.31 386.019 29.4C386.169 29.46 386.279 29.6 386.299 29.77C386.319 29.93 386.249 30.0901 386.119 30.1901C386.069 30.2801 386.029 30.38 385.999 30.48C386.269 30.53 386.469 30.48 386.529 30.64C386.599 30.82 386.349 31.08 386.379 31.28C386.439 31.54 386.609 31.76 386.829 31.9C386.849 31.9 386.829 31.7401 386.829 31.7601C386.829 31.8501 386.809 31.89 386.809 31.98C386.809 31.99 386.699 31.97 386.699 31.98C386.719 32.12 387.059 32.3 387.069 32.46C387.079 32.67 386.939 32.86 387.039 32.92C387.219 33.03 387.149 33.2501 387.219 33.3701C387.309 33.5201 387.549 33.5901 387.529 33.7601C387.509 33.9101 387.219 34 387.159 34.18C387.069 34.46 387.509 34.54 387.739 34.59C388.059 34.66 388.389 34.83 387.919 34.93C387.899 34.93 387.859 34.77 387.859 34.78C387.879 34.97 387.939 35.1601 388.049 35.3201C388.149 35.4801 388.239 35.6401 388.309 35.8101C388.369 35.9801 388.239 36.17 388.269 36.36C388.319 36.53 388.349 36.7001 388.369 36.8801C388.369 37.0601 388.649 37.2601 388.639 37.4401C388.619 37.6201 388.329 37.7701 388.299 37.9501C388.269 38.1301 388.569 38.3801 388.539 38.5601C388.499 38.7401 388.059 38.8301 388.019 39.0001C387.969 39.1901 388.069 39.4001 388.029 39.5701C387.979 39.7801 387.739 40.02 387.729 40.24C387.719 40.44 388.029 40.45 388.329 40.6C388.339 40.6 388.139 40.85 388.149 40.86C388.239 40.95 388.299 41.0401 388.389 41.1301C388.399 41.1401 388.439 40.97 388.439 40.99C388.369 41.15 388.379 41.5301 388.299 41.6901C388.159 41.5701 387.909 41.34 387.769 41.22C387.629 41.09 387.649 40.7001 387.489 40.6301C387.319 40.5601 387.169 40.8601 387.069 40.9501C386.979 41.0401 386.839 41.09 386.869 41.29C386.829 41.34 386.909 41.29 386.869 41.34C386.899 41.28 386.829 41.35 386.859 41.3C387.099 41.33 387.319 41.46 387.559 41.49C387.799 41.52 387.939 41.61 388.179 41.64C388.249 41.82 388.319 41.85 388.359 42.02C388.429 42.18 388.459 42.36 388.449 42.53C388.449 42.71 388.369 42.8801 388.239 43.0101C388.119 43.1601 387.969 43.2901 387.799 43.3801C387.739 43.4001 387.759 43.51 387.739 43.64C387.859 43.64 387.999 43.83 388.109 43.8C388.259 43.76 388.389 43.53 388.539 43.47C388.519 43.63 388.459 43.78 388.349 43.9C388.249 44.02 388.479 44.3301 388.449 44.5001C388.419 44.6901 388.349 44.87 388.239 45.02C388.149 45.11 387.849 44.9601 387.619 44.9401C387.619 45.0801 387.459 45.42 387.509 45.52C387.599 45.7 387.859 45.78 387.939 45.96C388.019 46.14 388.239 46.28 388.299 46.47C388.359 46.66 388.139 46.91 388.159 47.11C388.209 47.3 388.239 47.4901 388.239 47.6901C388.239 47.7101 388.529 47.5901 388.669 47.6301C388.669 47.6301 388.469 47.83 388.479 47.84C388.559 48.02 388.669 48.17 388.599 48.36C388.529 48.55 388.639 48.7001 388.659 48.8801C388.679 49.0301 388.539 49.26 388.779 49.39C388.789 49.39 388.859 49.84 388.769 49.9C388.609 50 388.289 49.8801 388.179 50.0101C388.089 50.1701 388.009 50.34 387.959 50.52C387.889 50.68 387.709 50.82 387.659 50.99C387.609 51.16 387.639 51.35 387.589 51.52C387.569 51.58 387.889 51.91 387.969 51.9C388.269 51.85 388.399 51.8 388.449 51.9C388.549 52.08 388.549 52.3 388.449 52.48C388.369 52.6 388.129 53.06 388.039 53.17C387.949 53.27 387.869 53.36 387.789 53.47C387.909 53.49 388.029 53.51 388.149 53.55C388.249 53.56 388.189 53.5801 388.279 53.6201C388.219 53.7601 388.359 53.9 388.259 53.98C388.079 54.13 387.969 54.3501 387.799 54.5001C387.629 54.6501 387.349 54.72 387.309 54.98C387.269 55.3 387.349 55.22 387.709 55.16C388.219 55.06 387.709 55.52 387.649 55.73C387.729 55.75 387.819 55.77 387.909 55.78C387.809 55.84 387.679 55.86 387.579 55.92C387.679 55.95 387.799 55.88 387.909 55.91C387.929 55.91 387.849 55.94 387.839 55.96C387.689 56.14 387.579 56.36 387.399 56.41C387.209 56.46 386.989 56.34 386.779 56.33C386.579 56.33 386.379 56.33 386.179 56.33C385.989 56.36 385.799 56.43 385.629 56.54C385.559 56.48 385.479 56.4301 385.399 56.3801C385.209 56.2901 385.129 56.11 384.939 56.15C384.789 56.18 384.669 56.3601 384.459 56.4501C384.259 56.5101 384.049 56.5 383.849 56.43C383.649 56.39 383.479 56.2801 383.359 56.1201C383.269 55.9501 383.199 55.77 383.149 55.59C383.189 55.59 383.229 55.54 383.259 55.54C383.369 55.57 383.529 55.54 383.619 55.6C383.789 55.69 383.899 55.9501 384.019 55.93C384.129 55.91 384.219 55.7201 384.239 55.4401C384.059 55.4701 383.849 55.44 383.679 55.46C383.499 55.49 383.309 55.65 383.129 55.68C382.759 55.4401 383.239 55.2601 383.369 55.0701C383.459 54.9301 383.309 54.62 383.409 54.48C383.509 54.34 383.529 54.1401 383.629 54.0101C383.729 53.8701 383.989 53.9601 384.089 53.8201C384.129 53.9501 384.239 53.8101 384.279 53.9401C384.359 53.8601 384.469 53.91 384.539 53.83C384.409 53.79 384.349 53.6601 384.229 53.6201C384.209 53.4601 384.109 53.36 384.069 53.15C384.029 52.97 384.029 52.7601 383.969 52.5701C383.899 52.3901 383.819 52.21 383.729 52.03C383.669 51.83 383.589 51.6401 383.489 51.4501C383.449 51.4001 383.369 51.41 383.409 51.41C383.629 51.35 383.859 51.31 384.089 51.28C384.069 51.47 383.849 51.7001 383.889 51.8801C383.919 51.9901 384.239 52.0401 384.349 52.1301C384.389 52.0001 384.669 52.0801 384.799 52.0001C384.949 51.8501 384.979 51.6101 384.859 51.43C384.809 51.35 384.989 51.0801 385.139 50.8801C385.199 50.7801 385.189 50.64 385.239 50.54C385.239 50.54 385.139 50.49 385.109 50.47C385.089 50.6 385.109 50.65 385.079 50.78C384.859 50.84 384.759 51.1601 384.589 51.1201C384.389 51.0301 384.209 50.92 384.059 50.77C383.899 50.66 383.899 50.3201 383.739 50.2001C383.579 50.0801 383.279 50.1901 383.099 50.1201C383.059 49.9901 383.059 49.84 383.099 49.71C383.189 49.54 383.289 49.37 383.399 49.21C383.409 49.2 383.459 49.27 383.479 49.27C383.739 49.13 384.169 49.12 384.209 48.97C384.249 48.83 383.979 48.61 383.619 48.42C383.519 48.37 383.489 48.0001 383.449 47.8201C383.819 47.8701 384.159 47.8201 384.099 47.4501C384.159 47.3801 384.139 47.3301 384.199 47.2501C384.159 47.2301 384.029 47.18 383.989 47.16C383.979 47.26 383.959 47.28 383.949 47.39C383.629 47.39 383.349 47.53 383.419 47.9C383.199 47.82 383.019 47.87 382.849 47.73C382.729 47.57 382.689 47.3701 382.749 47.18C382.809 47 382.879 46.82 382.959 46.65C383.029 46.46 382.979 46.24 383.109 46.1C383.239 45.95 383.629 46.1301 383.919 46.1201C383.919 46.1501 383.999 46.07 384.019 46.1C384.019 46.12 384.119 46.1 384.139 46.11C384.099 46.08 383.939 46.1001 383.909 46.0601C383.849 45.9901 383.769 45.93 383.679 45.89C383.439 45.8 383.109 45.71 383.059 45.58C383.019 45.45 383.289 45.24 383.489 45.04C383.589 44.94 383.659 44.8201 383.709 44.6901C383.809 44.6401 383.729 44.6101 383.839 44.5701C383.749 44.6301 383.749 44.5701 383.649 44.6301C383.479 44.5801 383.229 44.68 383.069 44.6C382.949 44.54 382.639 44.2001 382.659 44.1301C382.709 43.9401 383.079 43.85 383.139 43.67C383.199 43.49 383.079 43.22 383.169 43.05C383.279 42.89 383.429 42.76 383.589 42.66C383.799 42.49 384.079 42.32 384.279 42.14C384.319 42.25 384.579 42.38 384.619 42.49C384.639 42.47 384.589 42.47 384.589 42.46C384.539 42.38 384.389 42.37 384.329 42.29C384.369 42.13 384.489 41.9901 384.539 41.8101C384.589 41.6401 384.449 41.4101 384.489 41.2501C384.539 41.0501 384.649 40.8901 384.619 40.7501C384.579 40.5901 384.479 40.4901 384.229 40.5001C384.209 40.5001 384.259 40.54 384.249 40.52C384.159 40.4 383.919 40.3901 383.829 40.2601C383.739 40.1401 383.829 40.11 383.749 39.99C383.839 39.98 383.849 39.8901 383.859 39.8801L383.749 39.8201ZM382.129 28.86C382.129 28.86 382.229 28.8901 382.249 28.8701C382.259 28.8601 382.089 28.6 382.089 28.58C382.059 28.62 382.089 28.74 382.069 28.78C382.029 28.81 382.119 28.73 382.129 28.78C382.149 28.86 382.099 28.89 382.129 28.86ZM374.719 30.71C374.689 30.41 374.769 30.41 374.759 30.11C374.749 29.81 374.649 29.8101 374.639 29.5001C374.629 29.1901 374.339 29.12 374.529 28.89C374.719 28.66 374.699 29.19 374.709 29.49C374.719 29.79 374.399 29.81 374.409 30.11C374.419 30.41 374.409 30.42 374.429 30.72C374.429 30.75 374.669 30.74 374.689 30.77C374.689 30.78 374.829 30.72 374.849 30.72C374.809 30.69 374.759 30.75 374.719 30.72V30.71ZM384.359 33.9501C384.359 33.9501 384.159 33.9701 384.179 33.9501C384.169 33.9701 384.229 33.7901 384.219 33.8201C384.189 33.8301 384.219 33.91 384.189 33.92C384.179 33.92 384.059 33.85 384.049 33.86C384.079 33.82 384.319 33.9801 384.349 33.9401L384.359 33.9501ZM370.289 33.18C370.349 32.98 370.389 32.78 370.389 32.58C370.389 32.42 370.289 32.24 370.289 32.05C370.289 31.88 370.199 31.69 370.199 31.52C370.199 31.33 370.049 31.15 370.059 30.99C370.049 30.86 370.059 30.72 370.119 30.59C370.059 30.71 370.029 30.85 370.039 30.99C370.039 31.15 370.279 31.33 370.279 31.52C370.279 31.7 370.029 31.88 370.029 32.05C370.029 32.24 370.029 32.42 370.029 32.58C370.019 32.7 370.029 32.82 370.089 32.93C370.059 32.95 370.229 33.02 370.249 33.05C370.299 33.11 370.269 33.2 370.279 33.18H370.289ZM376.329 32.9C376.259 32.62 376.299 32.6 376.209 32.33C376.119 32.06 376.019 32.0901 375.939 31.8201C375.849 31.5501 375.769 31.57 375.679 31.3C375.589 31.03 375.449 31.07 375.369 30.8C375.279 30.53 375.049 30.3701 375.339 30.3801C375.629 30.3901 375.259 30.5401 375.339 30.8101C375.419 31.0801 375.659 31.01 375.749 31.29C375.839 31.57 375.599 31.64 375.689 31.92C375.779 32.2 375.779 32.2 375.869 32.47C375.959 32.75 375.939 32.74 376.009 33.02C375.979 33.03 376.249 33.1001 376.229 33.1201C376.219 33.1201 376.129 33.0401 376.129 33.0601C376.159 33.0201 376.309 32.95 376.329 32.91V32.9ZM386.599 49.8201C386.599 49.8201 386.829 49.8301 386.819 49.8201C386.809 49.8001 386.749 49.98 386.759 49.96C386.779 49.94 386.749 49.89 386.729 49.86C386.689 49.8 386.619 49.8001 386.599 49.8201ZM371.639 33.17C371.729 33.14 371.819 33.62 371.899 33.59C371.889 33.59 371.889 33.1601 371.869 32.8701C371.869 32.7001 371.759 32.51 371.749 32.33C371.729 32.19 371.749 32.05 371.809 31.92C371.639 32 371.519 32.17 371.499 32.36C371.499 32.55 371.469 32.7501 371.459 32.9401C371.479 33.1601 371.529 33.37 371.619 33.58C371.589 33.59 371.409 32.94 371.389 32.96C371.369 32.97 371.599 33.2901 371.589 33.3201C371.619 33.2801 371.599 33.21 371.629 33.17H371.639ZM387.089 44.36C387.169 44.36 387.119 44.42 387.199 44.42C387.329 44.5 387.499 44.49 387.639 44.58C387.649 44.55 387.689 44.44 387.709 44.4C387.559 44.36 387.309 44.4201 387.149 44.3801C387.119 44.2601 387.209 43.85 387.179 43.73C387.139 43.85 386.939 44.05 386.909 44.17C386.899 44.2 387.079 44.26 387.079 44.29C387.079 44.35 387.079 44.3801 387.099 44.3701L387.089 44.36ZM384.469 39.2001C384.409 39.3001 384.299 39.39 384.249 39.49C384.249 39.49 384.559 39.65 384.589 39.67C384.609 39.54 384.549 39.37 384.569 39.24C384.569 39.21 384.539 39.34 384.519 39.33C384.459 39.28 384.479 39.1701 384.469 39.2001ZM384.159 44.7001C384.099 44.7401 383.959 44.74 383.909 44.8C383.849 44.87 383.869 45.08 383.829 45.16C383.889 45.18 383.949 45.2 384.009 45.21C384.079 45.15 384.019 45.01 384.059 44.93C384.089 44.8701 384.359 44.93 384.369 44.85C384.399 44.84 384.369 44.91 384.399 44.9C384.419 44.9 384.369 44.76 384.379 44.74C384.349 44.78 384.189 44.67 384.159 44.71V44.7001ZM386.459 50.9401C386.479 51.0001 386.449 51.09 386.459 51.15C386.489 51.12 386.679 50.87 386.699 50.84C386.639 50.82 386.509 50.86 386.449 50.84C386.329 50.82 386.229 50.94 386.119 50.92C386.119 50.95 386.079 51 386.079 51.04C386.209 51.02 386.319 50.9601 386.449 50.9401H386.459ZM383.269 46.6C383.179 46.66 382.969 46.72 382.929 46.8C382.889 46.9 383.059 47.18 383.069 47.3C383.169 47.22 383.259 47.1201 383.329 47.0101C383.369 46.9201 383.189 46.78 383.179 46.67C383.199 46.65 383.249 46.76 383.269 46.73C383.269 46.76 383.269 46.57 383.269 46.6ZM383.249 36.3101C383.319 36.4101 383.539 36.62 383.619 36.72C383.669 36.6 383.759 36.23 383.809 36.11C383.679 36.14 384.379 36.2201 384.239 36.2601C384.179 35.9901 383.969 35.75 383.899 35.48C383.829 35.48 383.759 35.48 383.689 35.48C383.759 35.6 383.659 35.59 383.499 35.72C383.339 35.85 383.179 36.1801 383.249 36.3101ZM385.079 53.28C385.139 53.32 385.109 53.1001 385.169 53.1301C385.109 53.1001 385.259 53.1601 385.189 53.1301C385.159 53.0001 385.049 52.8201 384.989 52.6301C384.919 52.4201 384.849 52.39 384.659 52.43C384.609 52.4401 384.409 52.48 384.369 52.53C384.479 52.57 384.569 52.73 384.679 52.89C384.779 53.04 384.919 53.17 385.079 53.27V53.28ZM387.119 42.59C387.119 42.59 387.089 42.74 387.069 42.71C387.099 42.73 386.909 42.59 386.939 42.61C386.879 42.7 386.889 42.82 386.839 42.92C386.789 43.03 386.829 43.02 386.789 43.15C386.949 43.09 387.199 43.2401 387.359 43.1901C387.289 43.0401 387.179 42.76 387.109 42.61L387.119 42.59ZM384.859 49.2001C384.749 49.3201 384.519 49.45 384.389 49.59C384.269 49.72 384.219 49.9301 384.099 50.0701C384.079 50.1001 384.269 50.39 384.329 50.39C384.469 50.4 384.609 50.34 384.679 50.22C384.759 50.08 385.109 50.04 385.159 49.89C385.209 49.73 385.269 49.54 385.319 49.39C385.169 49.31 385.009 49.2501 384.849 49.2001H384.859ZM385.659 33.28C385.809 33.21 386.149 33.17 386.279 33.05C386.409 32.85 386.479 32.6201 386.479 32.3801C386.299 32.1801 385.989 32.07 385.809 32.48C385.769 32.58 385.709 32.6801 385.629 32.7601C385.549 32.8301 385.179 32.9 385.199 32.97C385.219 33.05 385.519 33.19 385.659 33.28ZM384.409 46.72C384.339 46.97 384.279 47.2301 384.249 47.5001C384.349 47.7101 384.649 47.91 384.779 48.11C384.909 47.99 385.179 47.71 385.159 47.67C385.079 47.53 384.869 47.5 384.729 47.33C384.639 47.21 384.539 46.89 384.409 46.72ZM383.229 34.5001C383.419 34.3701 383.279 33.77 383.449 33.65C383.329 33.5 383.189 33.37 383.049 33.24C382.939 33.3 382.769 33.56 382.559 33.73C382.349 33.9 382.259 34.17 382.159 34.24C382.279 34.34 382.439 34.4 382.589 34.41C382.799 34.41 383.019 34.4401 383.219 34.5001H383.229ZM379.019 28.48C378.979 28.29 378.939 28.11 378.919 27.92C378.839 27.74 378.719 27.57 378.589 27.42C378.489 27.66 378.419 27.9 378.389 28.16C378.429 28.31 378.649 28.36 378.739 28.49C378.829 28.53 378.929 28.52 379.019 28.49V28.48ZM384.369 55.15C384.529 54.96 384.869 54.7401 384.879 54.6201C384.879 54.5301 384.499 54.2401 384.419 54.2501C384.309 54.2601 384.169 54.49 384.139 54.61C384.169 54.81 384.249 54.99 384.369 55.15ZM385.599 47.7001C385.529 47.7501 385.219 48 385.169 48.18C385.119 48.3801 385.189 48.6601 385.149 48.6901C385.279 48.8301 385.469 48.3101 385.599 48.4501C385.669 48.3801 385.679 48.3501 385.669 48.3201C385.599 48.1701 385.709 47.8601 385.599 47.7001ZM387.709 42.0001C387.639 42.0801 387.399 42.31 387.339 42.39C387.479 42.49 387.629 42.5701 387.789 42.6201C387.899 42.5701 387.939 42.38 388.029 42.3C387.939 42.25 387.829 42.0701 387.709 42.0101V42.0001ZM375.889 33.03C375.969 32.97 376.179 32.72 376.239 32.68C376.139 32.62 375.869 33.4 375.769 33.39C375.679 33.39 375.569 33.5801 375.479 33.6301C375.549 33.6601 375.469 33.41 375.529 33.22C375.589 33.07 375.739 32.99 375.889 33.03ZM387.389 53.0701C387.309 52.9501 387.099 52.22 387.059 52.16C386.959 52.25 386.829 52.92 386.739 53.02C386.789 53.1 386.839 53.17 386.909 53.23C387.029 53.18 387.269 53.1301 387.389 53.0701ZM385.749 32.1901C385.689 32.0601 385.609 31.9301 385.519 31.8201C385.459 31.8201 385.289 32.06 385.219 32.09C385.269 32.16 385.419 32.2501 385.469 32.3201C385.519 32.2701 385.699 32.2401 385.749 32.1901ZM386.749 55.68C386.609 55.6 386.359 55.33 386.279 55.34C386.219 55.34 386.049 55.71 386.059 55.77C386.079 55.84 386.289 55.91 386.369 55.92C386.509 55.87 386.639 55.7901 386.749 55.68ZM383.769 34.74C383.699 34.62 383.459 34.36 383.399 34.27C383.319 34.44 383.269 34.6201 383.229 34.8101C383.229 34.8801 383.889 34.95 383.949 35.02C383.989 34.93 383.719 34.83 383.769 34.74ZM381.589 28.5001C381.509 28.4501 381.269 28.2501 381.189 28.2001C381.149 28.3301 381.119 28.47 381.109 28.61C381.129 28.66 381.289 28.66 381.349 28.67C381.439 28.63 381.529 28.5701 381.599 28.5001H381.589ZM386.239 37.48C386.189 37.43 386.079 37.1501 386.019 37.1301C385.959 37.1101 385.739 37.34 385.669 37.35C385.749 37.43 385.839 37.5001 385.939 37.5601C386.039 37.5501 386.139 37.52 386.229 37.47L386.239 37.48ZM375.319 28.61C375.139 28.77 374.999 28.9601 374.909 29.1901C374.909 29.3801 374.909 29.58 374.909 29.77C374.909 29.96 374.939 30.15 374.969 30.33C374.969 30.66 374.899 30.78 374.989 30.67C375.009 30.95 375.049 31.2301 375.109 31.5101C375.289 31.3001 375.399 31.05 375.449 30.78C375.459 30.59 375.239 30.37 375.249 30.15C375.259 29.94 375.529 29.7401 375.539 29.5601C375.559 29.2301 375.539 29.1001 375.549 29.0701C375.479 28.9101 375.409 28.76 375.319 28.61ZM373.969 28.48C373.769 28.61 373.639 28.82 373.619 29.05C373.619 29.21 373.719 29.4 373.719 29.61C373.719 29.79 373.809 29.98 373.809 30.17C373.809 30.36 373.959 30.55 373.949 30.73C373.949 30.92 373.629 31.11 373.619 31.29C373.619 31.5 373.609 31.69 373.599 31.85C373.599 32.06 373.679 32.2701 373.799 32.4401C373.769 32.5001 373.469 32.59 373.479 32.64C373.549 32.74 373.629 32.83 373.729 32.9C373.899 32.68 374.009 32.42 374.049 32.14C374.049 31.96 373.689 31.76 373.689 31.54C373.689 31.35 373.839 31.14 373.839 30.93C373.839 30.73 373.769 30.5201 373.769 30.3201C373.769 30.1101 373.659 29.91 373.659 29.71C373.659 29.49 373.699 29.28 373.699 29.1C373.719 28.87 373.809 28.64 373.969 28.47V28.48ZM380.999 27.3701C380.999 27.3701 380.709 27.3 380.679 27.29C380.679 27.33 380.739 27.57 380.729 27.61C380.779 27.59 380.839 27.56 380.889 27.53C380.929 27.48 380.969 27.4301 380.999 27.3701ZM379.629 28.1C379.629 28.1 379.279 28.08 379.249 28.08C379.269 28.11 379.439 28.3 379.459 28.33C379.459 28.31 379.609 28.13 379.619 28.1H379.629ZM384.299 49.2601C384.229 49.2101 384.149 49.1601 384.069 49.1201C384.059 49.1201 383.999 49.4 383.989 49.43C384.049 49.43 384.099 49.41 384.149 49.4C384.199 49.36 384.249 49.3101 384.299 49.2601ZM383.579 33.91C383.559 33.99 383.409 34.16 383.409 34.22C383.519 34.28 383.619 34.3301 383.729 34.3801C383.759 34.3001 383.779 34.2101 383.779 34.1201C383.719 34.0401 383.659 33.97 383.579 33.91ZM382.999 29.7001C382.999 29.8101 383.019 29.92 383.049 30.02C383.079 30.04 383.289 29.91 383.329 29.91C383.319 29.86 383.229 29.78 383.219 29.73C383.189 29.74 383.039 29.6801 382.999 29.6901V29.7001ZM377.479 28.99C377.449 28.93 377.399 28.6801 377.369 28.6301C377.269 28.6901 377.179 28.77 377.099 28.84C377.099 28.9 377.199 28.9601 377.209 29.0101C377.259 28.9901 377.429 29.01 377.479 28.99ZM383.689 36.29C383.659 36.23 383.489 35.98 383.449 35.92C383.519 36.19 383.609 36.45 383.709 36.71C383.709 36.76 383.399 36.37 383.439 36.43C383.479 36.38 383.649 36.34 383.689 36.28V36.29ZM386.109 51.6901C386.049 51.5901 385.959 51.5101 385.859 51.4501C385.839 51.5601 385.839 51.67 385.869 51.77C385.959 51.8 386.049 51.7701 386.099 51.6901H386.109ZM376.399 30.58C376.479 30.52 376.559 30.4401 376.629 30.3701C376.539 30.3101 376.449 30.26 376.349 30.22C376.329 30.26 376.329 30.38 376.309 30.41C376.329 30.42 376.379 30.57 376.409 30.58H376.399ZM383.159 31.5001C383.159 31.5001 382.899 31.75 382.919 31.79C382.939 31.83 383.239 31.7901 383.259 31.7601C383.289 31.6601 383.249 31.5501 383.159 31.5001ZM383.789 31.9501C383.789 31.9501 383.559 31.6901 383.519 31.7001C383.489 31.8101 383.499 31.93 383.529 32.03C383.629 32.06 383.729 32.0301 383.789 31.9401V31.9501ZM373.069 32.1901C373.069 32.1901 373.329 31.95 373.309 31.9C373.289 31.86 372.989 31.9 372.969 31.93C372.939 32.03 372.979 32.1401 373.069 32.1901ZM386.739 45.98C386.839 45.91 386.909 45.82 386.969 45.72C386.859 45.7 386.749 45.7201 386.649 45.7501C386.629 45.8401 386.659 45.93 386.739 45.98ZM387.399 45.8201C387.339 45.7201 387.259 45.64 387.159 45.58C387.139 45.69 387.139 45.79 387.159 45.9C387.249 45.92 387.339 45.9001 387.399 45.8201ZM384.979 40.96C385.079 40.9 385.159 40.81 385.219 40.71C385.109 40.69 384.999 40.7 384.899 40.73C384.879 40.82 384.899 40.91 384.979 40.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M385.539 56.93C385.429 56.93 385.319 56.89 385.229 56.82C385.199 56.79 385.129 56.74 385.089 56.72C385.009 56.68 384.939 56.64 384.879 56.58C384.779 56.67 384.659 56.74 384.539 56.8C384.279 56.89 383.999 56.9 383.739 56.83H383.669C383.359 56.76 383.089 56.59 382.899 56.34C382.819 56.23 382.759 56.1 382.719 55.97C382.559 55.86 382.469 55.69 382.449 55.5C382.449 55.24 382.599 54.99 382.819 54.85L382.849 54.82V54.79C382.799 54.58 382.829 54.36 382.949 54.17C382.969 54.13 382.989 54.09 382.999 54.05C383.039 53.92 383.099 53.8 383.179 53.7C383.289 53.56 383.439 53.47 383.609 53.45C383.579 53.38 383.549 53.3 383.529 53.22C383.509 53.12 383.489 53.02 383.479 52.92C383.479 52.84 383.459 52.75 383.439 52.67C383.409 52.57 383.359 52.48 383.309 52.39C383.269 52.32 383.239 52.24 383.209 52.17C383.169 52.09 383.139 51.99 383.109 51.9C383.099 51.86 383.079 51.8 383.059 51.75C382.899 51.65 382.809 51.45 382.859 51.26C382.899 51.07 383.069 50.93 383.259 50.92C383.329 50.91 383.409 50.89 383.479 50.87H383.499C383.449 50.78 383.409 50.69 383.379 50.59V50.55C383.379 50.55 383.319 50.55 383.299 50.55C383.149 50.56 382.999 50.55 382.849 50.5C382.719 50.45 382.619 50.35 382.569 50.22C382.489 49.96 382.509 49.68 382.609 49.43C382.639 49.38 382.669 49.32 382.699 49.27C382.769 49.13 382.849 49 382.939 48.88C383.009 48.79 383.119 48.73 383.229 48.71C383.079 48.58 382.989 48.41 382.969 48.22C382.779 48.2 382.599 48.13 382.449 48.01C382.189 47.75 382.099 47.37 382.209 47.02C382.249 46.87 382.299 46.73 382.369 46.59C382.399 46.54 382.419 46.48 382.439 46.42C382.449 46.38 382.459 46.34 382.459 46.29C382.459 46.12 382.519 45.96 382.609 45.81C382.569 45.76 382.549 45.71 382.529 45.65C382.469 45.38 382.559 45.11 382.779 44.94H382.749C382.749 44.94 381.999 44.44 382.129 43.95C382.199 43.73 382.359 43.56 382.559 43.45L382.609 43.42V43.36C382.569 43.16 382.589 42.96 382.669 42.78C382.789 42.58 382.959 42.41 383.159 42.28L383.209 42.24C383.299 42.17 383.399 42.1 383.499 42.02C383.629 41.93 383.759 41.84 383.879 41.74C383.909 41.71 383.939 41.69 383.979 41.67C383.979 41.65 383.999 41.63 383.999 41.61C383.999 41.61 383.979 41.58 383.969 41.54C383.919 41.39 383.919 41.23 383.939 41.07C383.959 41.01 383.979 40.94 383.999 40.88C383.979 40.88 383.969 40.87 383.949 40.86C383.889 40.83 383.839 40.8 383.799 40.75L383.759 40.73C383.599 40.68 383.459 40.58 383.359 40.45C383.279 40.35 383.239 40.23 383.229 40.1C383.179 39.99 383.179 39.87 383.229 39.76C383.119 39.61 383.109 39.41 383.199 39.25C383.199 39.24 383.209 39.23 383.219 39.21C383.189 39.18 383.169 39.14 383.139 39.11C382.979 38.89 382.929 38.61 383.009 38.35C383.009 38.35 382.999 38.27 382.989 38.23C382.979 38.23 382.909 38.18 382.849 38.15C382.759 38.1 382.679 38.05 382.599 37.99C382.559 37.97 382.509 37.95 382.459 37.93C382.329 37.89 382.219 37.83 382.109 37.76C381.989 37.67 381.889 37.58 381.779 37.47C381.739 37.43 381.699 37.39 381.659 37.36C381.409 37.14 381.039 36.18 381.349 35.79C381.459 35.66 381.589 35.55 381.729 35.47C381.679 35.34 381.619 35.23 381.539 35.11C381.499 35.08 381.459 35.06 381.419 35.03C381.329 34.98 381.239 34.91 381.159 34.84C381.009 34.69 380.879 34.52 380.769 34.34C380.709 34.25 380.679 34.14 380.659 34.04C380.549 33.99 380.469 33.91 380.419 33.8C380.349 33.64 380.299 33.46 380.279 33.29C380.179 33.23 380.089 33.15 380.009 33.06H379.879C379.809 33.05 379.739 33.06 379.659 33.06L379.579 33.09C379.579 33.09 379.489 33.12 379.439 33.14C379.359 33.29 379.219 33.4 379.049 33.43C378.959 33.44 378.869 33.43 378.789 33.39C378.699 33.43 378.609 33.46 378.509 33.48C378.319 33.51 378.119 33.49 377.939 33.42C377.909 33.41 377.859 33.39 377.829 33.39C377.759 33.42 377.689 33.45 377.639 33.48C377.519 33.54 377.399 33.59 377.269 33.62C377.139 33.67 376.989 33.65 376.869 33.58C376.749 33.51 376.669 33.38 376.659 33.24C376.629 33.34 376.569 33.43 376.489 33.49C376.409 33.54 376.319 33.57 376.219 33.56C376.149 33.68 376.049 33.77 375.929 33.82C375.929 33.82 375.879 33.88 375.849 33.91C375.819 33.95 375.779 33.98 375.739 34.01C375.609 34.1 375.439 34.12 375.289 34.06C375.129 34 375.019 33.85 375.009 33.68C375.009 33.62 375.009 33.56 375.029 33.5C375.029 33.46 375.029 33.41 375.029 33.36C374.929 33.34 374.829 33.32 374.729 33.28C374.659 33.28 374.599 33.28 374.529 33.28C374.419 33.29 374.299 33.3 374.189 33.28C374.129 33.28 374.059 33.27 373.989 33.26C373.939 33.46 373.819 33.62 373.649 33.71C373.469 33.8 373.259 33.8 373.089 33.71C372.949 33.63 372.829 33.53 372.729 33.41L372.709 33.44C372.709 33.44 372.669 33.51 372.649 33.55C372.649 33.61 372.649 33.66 372.649 33.72C372.659 33.85 372.649 33.98 372.649 34.1C372.629 34.19 372.629 34.26 372.629 34.3C372.629 34.46 372.559 34.62 372.439 34.73C372.379 34.77 372.309 34.8 372.239 34.82C372.209 34.84 372.189 34.87 372.159 34.89C372.159 35.12 372.019 35.34 371.819 35.46C371.619 35.57 371.379 35.56 371.199 35.43C371.029 35.3 370.909 35.1 370.879 34.88C370.779 34.85 370.679 34.8 370.599 34.73C370.499 34.77 370.379 34.79 370.269 34.78C370.099 34.76 369.929 34.7 369.799 34.59C369.689 34.65 369.569 34.71 369.449 34.76L369.319 34.82C369.179 34.88 369.019 34.88 368.879 34.81C368.809 34.77 368.749 34.71 368.699 34.64C368.559 34.65 368.429 34.6 368.329 34.5C368.199 34.38 368.129 34.21 368.139 34.04V34C368.039 34.18 367.849 34.28 367.649 34.26C367.179 34.22 367.219 33.71 367.229 33.54C367.239 33.41 367.239 33.28 367.229 33.15C367.209 33.09 367.189 33.04 367.159 32.98C367.099 32.86 367.059 32.73 367.029 32.6C367.029 32.6 366.979 32.55 366.959 32.52C366.839 32.4 366.759 32.26 366.709 32.1C366.689 32.02 366.669 31.93 366.659 31.85C366.639 31.77 366.629 31.69 366.609 31.64C366.529 31.54 366.499 31.41 366.519 31.28C366.539 31.15 366.619 31.05 366.729 30.98C366.879 30.9 367.039 30.85 367.209 30.83C367.269 30.83 367.319 30.81 367.379 30.8C367.539 30.69 367.749 30.69 367.919 30.78C368.319 31.1 368.389 31.68 368.079 32.09L368.139 32.12C368.199 32.15 368.259 32.18 368.319 32.22C368.339 32.23 368.369 32.26 368.399 32.27L368.439 32.24C368.539 32.13 368.659 32.04 368.789 31.97C368.869 31.93 368.949 31.9 369.039 31.87C369.119 31.85 369.199 31.81 369.269 31.77C369.389 31.69 369.519 31.62 369.659 31.58L369.679 31.52C369.679 31.52 369.709 31.43 369.719 31.39C369.719 31.39 369.699 31.33 369.689 31.31C369.629 31.21 369.599 31.09 369.599 30.98C369.589 30.77 369.629 30.57 369.719 30.38C369.719 30.38 369.729 30.36 369.739 30.35C369.789 30.27 369.859 30.2 369.949 30.17C369.969 30.11 370.009 30.05 370.049 29.99C370.159 29.85 370.309 29.74 370.489 29.67C370.529 29.65 370.579 29.63 370.619 29.6C370.669 29.52 370.709 29.43 370.749 29.34C370.789 29.26 370.819 29.18 370.859 29.11C370.919 28.99 370.949 28.86 370.949 28.72C370.969 28.48 371.159 28.3 371.399 28.28C371.469 28.28 371.529 28.28 371.589 28.31C371.619 28.25 371.659 28.2 371.699 28.14C371.919 27.89 372.229 27.75 372.559 27.74C372.789 27.77 372.999 27.9 373.119 28.1C373.189 28.05 373.259 28 373.339 27.95C373.429 27.9 373.529 27.87 373.639 27.84C373.689 27.83 373.729 27.82 373.769 27.8C373.769 27.8 373.809 27.72 373.829 27.68C373.879 27.57 373.939 27.47 374.009 27.38C373.989 27.39 373.989 27.36 373.999 27.32C373.999 27.14 374.069 26.97 374.179 26.82C374.289 26.69 374.419 26.59 374.569 26.51C374.609 26.49 374.649 26.47 374.679 26.44C374.809 26.34 374.979 26.3 375.139 26.34C375.369 26.4 375.569 26.55 375.689 26.76C375.699 26.75 375.709 26.73 375.729 26.72C375.919 26.46 376.169 26.25 376.459 26.11C376.479 26.11 376.499 26.1 376.519 26.09C376.649 26.06 376.789 26.09 376.889 26.18C376.949 26.23 376.999 26.3 377.029 26.37H377.049C377.129 26.39 377.199 26.39 377.279 26.39C377.269 26.39 377.329 26.33 377.369 26.29C377.529 26.12 377.729 26 377.959 25.96C378.209 25.96 378.459 26.04 378.649 26.22C378.679 26.25 378.709 26.27 378.749 26.29C378.749 26.29 378.799 26.29 378.859 26.29C379.059 26.28 379.259 26.33 379.429 26.43H379.439C379.639 26.32 379.849 26.27 380.069 26.26C380.129 26.26 380.199 26.25 380.259 26.24C380.339 26.21 380.419 26.17 380.489 26.13C380.699 25.99 380.959 25.94 381.199 26.01C381.489 26.15 381.649 26.46 381.589 26.78C381.589 26.84 381.589 26.9 381.589 26.97C381.609 27.01 381.639 27.05 381.659 27.09C381.749 27.22 381.829 27.37 381.879 27.52H381.909C381.909 27.52 381.999 27.57 382.049 27.6C382.129 27.65 382.129 27.65 382.199 27.64C382.459 27.6 382.719 27.6 382.979 27.64C383.259 27.7 383.499 27.86 383.659 28.1C383.679 28.13 383.699 28.16 383.729 28.18C383.789 28.24 383.869 28.33 383.939 28.39C384.079 28.27 384.259 28.18 384.439 28.15C384.729 28.12 385.059 28.09 385.249 28.35C385.279 28.39 385.309 28.44 385.319 28.49L385.369 28.52C385.459 28.57 385.549 28.62 385.639 28.68C385.709 28.72 385.779 28.77 385.849 28.81C385.929 28.86 386.009 28.92 386.099 28.97C386.379 29.12 386.569 29.4 386.609 29.72C386.619 29.86 386.609 30 386.549 30.13C386.669 30.2 386.769 30.32 386.809 30.45C386.869 30.68 386.839 30.92 386.729 31.12C386.709 31.16 386.699 31.2 386.679 31.24C386.679 31.24 386.689 31.26 386.699 31.27C386.879 31.27 387.049 31.39 387.109 31.56C387.129 31.61 387.139 31.66 387.139 31.72C387.139 31.75 387.139 31.77 387.139 31.79C387.139 31.83 387.139 31.87 387.139 31.91C387.279 32.03 387.369 32.21 387.389 32.4C387.389 32.5 387.389 32.6 387.359 32.7C387.439 32.82 387.489 32.97 387.499 33.11L387.519 33.13C387.739 33.27 387.869 33.53 387.839 33.79C387.819 33.91 387.769 34.02 387.689 34.11C388.219 34.23 388.469 34.45 388.459 34.77C388.459 34.9 388.409 35.02 388.319 35.11C388.419 35.27 388.509 35.44 388.579 35.61C388.639 35.79 388.639 35.98 388.579 36.16C388.579 36.19 388.559 36.23 388.559 36.26C388.559 36.3 388.579 36.35 388.599 36.4C388.639 36.52 388.659 36.64 388.669 36.77C388.679 36.79 388.699 36.81 388.719 36.84C388.869 37.01 388.939 37.22 388.939 37.44C388.909 37.64 388.799 37.83 388.649 37.97C388.819 38.16 388.879 38.41 388.819 38.65C388.759 38.89 388.569 39.08 388.339 39.15H388.309V39.2C388.349 39.35 388.339 39.5 388.309 39.64C388.269 39.78 388.199 39.92 388.119 40.05C388.209 40.08 388.289 40.11 388.369 40.15C388.489 40.21 388.569 40.31 388.609 40.44C388.629 40.51 388.629 40.58 388.609 40.64C388.679 40.71 388.709 40.81 388.719 40.91C388.719 41.01 388.699 41.11 388.669 41.21C388.669 41.25 388.659 41.31 388.649 41.35C388.639 41.48 388.609 41.61 388.579 41.74C388.599 41.78 388.609 41.83 388.619 41.87C388.629 41.91 388.639 41.95 388.659 41.99C388.729 42.17 388.749 42.37 388.729 42.56C388.709 42.72 388.659 42.88 388.589 43.03C388.609 43.04 388.629 43.05 388.649 43.07C388.769 43.16 388.839 43.3 388.829 43.46C388.819 43.66 388.749 43.85 388.639 44.01V44.03C388.719 44.2 388.749 44.39 388.719 44.57C388.679 44.84 388.559 45.1 388.379 45.31C388.269 45.42 388.119 45.48 387.969 45.47C388.059 45.55 388.129 45.64 388.179 45.75C388.209 45.79 388.239 45.83 388.279 45.87C388.399 46 388.499 46.15 388.559 46.31C388.609 46.52 388.579 46.75 388.479 46.95C388.459 46.99 388.449 47.03 388.439 47.07C388.439 47.08 388.449 47.11 388.459 47.15C388.509 47.15 388.569 47.15 388.619 47.17C388.769 47.21 388.889 47.33 388.939 47.48C388.979 47.63 388.939 47.79 388.849 47.9C388.929 48.09 388.929 48.3 388.849 48.5C388.849 48.48 388.869 48.53 388.879 48.56C388.909 48.64 388.919 48.71 388.939 48.79C388.949 48.87 388.939 48.96 388.939 49.04C389.069 49.2 389.129 49.4 389.109 49.6C389.149 49.85 389.039 50.1 388.839 50.25C388.679 50.34 388.499 50.38 388.319 50.36C388.309 50.39 388.299 50.42 388.289 50.45C388.269 50.52 388.239 50.6 388.209 50.66C388.159 50.77 388.089 50.88 388.009 50.98C387.979 51.02 387.949 51.05 387.929 51.09C387.929 51.14 387.919 51.19 387.919 51.25C387.919 51.3 387.919 51.35 387.919 51.4C388.209 51.29 388.529 51.4 388.699 51.66C388.889 51.99 388.879 52.39 388.669 52.71C388.639 52.75 388.589 52.85 388.529 52.95C388.469 53.05 388.419 53.14 388.379 53.21C388.529 53.31 388.609 53.49 388.579 53.67C388.649 53.89 388.579 54.13 388.409 54.29C388.349 54.35 388.289 54.42 388.239 54.49C388.169 54.58 388.099 54.67 388.019 54.75C388.079 54.79 388.129 54.84 388.169 54.9C388.279 55.09 388.279 55.32 388.149 55.5C388.179 55.54 388.189 55.59 388.209 55.64C388.219 55.7 388.219 55.76 388.209 55.82C388.209 55.99 388.139 56.16 387.989 56.26C387.989 56.27 387.959 56.3 387.939 56.33C387.719 56.76 387.219 56.95 386.769 56.78C386.719 56.77 386.659 56.75 386.609 56.75C386.469 56.75 386.329 56.75 386.189 56.75H386.029C385.969 56.77 385.919 56.79 385.859 56.82C385.789 56.86 385.719 56.89 385.639 56.92C385.609 56.93 385.579 56.94 385.549 56.95C385.529 56.95 385.509 56.95 385.489 56.95L385.539 56.93ZM384.879 55.63C385.069 55.63 385.259 55.72 385.399 55.85C385.429 55.87 385.449 55.89 385.479 55.91C385.509 55.92 385.529 55.94 385.559 55.95C385.579 55.94 385.609 55.93 385.639 55.91C385.639 55.89 385.629 55.87 385.629 55.86C385.629 55.59 385.709 55.33 385.869 55.12C385.949 54.99 386.089 54.91 386.239 54.89C386.429 54.89 386.619 54.96 386.749 55.1C386.749 55.02 386.749 54.95 386.759 54.88C386.809 54.58 387.009 54.32 387.279 54.19C387.319 54.17 387.349 54.14 387.389 54.12C387.449 54.06 387.499 54 387.549 53.93L387.599 53.86C387.459 53.83 387.349 53.74 387.279 53.62V53.6H387.239C387.239 53.6 387.149 53.64 387.099 53.65C386.749 53.8 386.529 53.5 386.419 53.36C386.269 53.2 386.249 52.96 386.369 52.78C386.399 52.72 386.429 52.61 386.459 52.5C386.499 52.25 386.609 52.02 386.769 51.83C386.859 51.75 386.969 51.71 387.089 51.72C387.029 51.61 387.019 51.48 387.049 51.35C387.059 51.29 387.069 51.24 387.069 51.18V51.12L386.969 51.26C386.909 51.34 386.839 51.42 386.829 51.44C386.759 51.52 386.659 51.57 386.549 51.59C386.549 51.64 386.549 51.68 386.549 51.73C386.519 51.91 386.409 52.05 386.249 52.13C386.079 52.23 385.869 52.24 385.679 52.16C385.539 52.1 385.359 51.95 385.399 51.46C385.419 51.29 385.509 51.13 385.659 51.04C385.659 51.03 385.659 51.01 385.659 51C385.659 50.93 385.689 50.86 385.719 50.8C385.769 50.61 385.939 50.48 386.139 50.47C386.269 50.4 386.429 50.37 386.579 50.4C386.609 50.4 386.639 50.39 386.669 50.39C386.649 50.39 386.629 50.38 386.609 50.37C386.529 50.34 386.459 50.29 386.419 50.22C386.379 50.2 386.339 50.17 386.309 50.14C386.139 49.97 386.129 49.7 386.289 49.52C386.399 49.41 386.539 49.35 386.689 49.36C386.719 49.36 386.739 49.36 386.769 49.37C386.939 49.35 387.119 49.42 387.209 49.57C387.299 49.72 387.309 49.91 387.209 50.06C387.189 50.13 387.159 50.19 387.109 50.25C387.029 50.34 386.929 50.39 386.809 50.41H386.849C386.999 50.46 387.119 50.57 387.159 50.72C387.209 50.61 387.279 50.5 387.359 50.41C387.389 50.38 387.409 50.34 387.439 50.3C387.459 50.26 387.469 50.21 387.489 50.17C387.539 49.99 387.619 49.83 387.719 49.68C387.829 49.55 387.989 49.47 388.159 49.46C388.079 49.29 388.059 49.11 388.099 48.93C388.099 48.89 388.099 48.85 388.079 48.82C387.999 48.61 387.999 48.39 388.069 48.18C388.069 48.2 388.029 48.14 388.009 48.1C387.939 48.07 387.879 48.04 387.829 48C387.719 47.9 387.659 47.75 387.679 47.6C387.679 47.53 387.669 47.46 387.649 47.39C387.629 47.3 387.609 47.21 387.599 47.12C387.599 46.95 387.629 46.77 387.699 46.61L387.729 46.54C387.729 46.54 387.679 46.48 387.659 46.46C387.609 46.4 387.559 46.34 387.509 46.28C387.359 46.36 387.169 46.38 387.009 46.33C386.909 46.41 386.789 46.44 386.669 46.43C386.499 46.4 386.349 46.29 386.269 46.14C386.169 45.97 386.149 45.76 386.229 45.58C386.259 45.5 386.359 45.28 386.839 45.27C386.879 45.23 386.929 45.2 386.979 45.17C386.989 45.11 387.009 45.06 387.029 45.01C387.039 44.96 387.059 44.92 387.069 44.88C386.999 44.84 386.929 44.81 386.859 44.77C386.799 44.73 386.749 44.67 386.719 44.6C386.619 44.54 386.539 44.44 386.499 44.33C386.469 44.24 386.479 44.15 386.499 44.07C386.549 43.94 386.619 43.82 386.709 43.71C386.739 43.67 386.759 43.64 386.779 43.61C386.639 43.61 386.519 43.53 386.439 43.41C386.359 43.29 386.339 43.15 386.379 43.02C386.379 42.92 386.409 42.83 386.449 42.74C386.459 42.64 386.489 42.54 386.529 42.45C386.539 42.42 386.559 42.39 386.579 42.36C386.669 42.23 386.819 42.16 386.979 42.17C386.989 42.15 386.999 42.14 387.019 42.12C387.049 42.08 387.139 42 387.219 41.91L387.259 41.87C387.149 41.84 387.059 41.81 386.969 41.78C386.929 41.77 386.899 41.75 386.859 41.74C386.749 41.76 386.629 41.74 386.539 41.68C386.509 41.66 386.479 41.64 386.449 41.61C386.439 41.6 386.429 41.59 386.419 41.57C386.329 41.46 386.299 41.31 386.319 41.17C386.329 40.94 386.449 40.73 386.639 40.6C386.669 40.58 386.689 40.55 386.709 40.52C386.829 40.34 386.999 40.21 387.189 40.13C387.219 39.93 387.299 39.75 387.409 39.58C387.449 39.52 387.479 39.47 387.499 39.41C387.499 39.4 387.489 39.36 387.479 39.32C387.449 39.16 387.449 39 387.479 38.85C387.549 38.64 387.699 38.47 387.899 38.38C387.789 38.22 387.739 38.03 387.759 37.83C387.799 37.65 387.899 37.48 388.039 37.35C387.919 37.2 387.839 37.02 387.829 36.83C387.829 36.76 387.809 36.7 387.789 36.64C387.769 36.56 387.749 36.47 387.729 36.38C387.709 36.24 387.729 36.1 387.759 35.96C387.759 35.93 387.769 35.9 387.779 35.87C387.749 35.82 387.669 35.68 387.569 35.52C387.459 35.34 387.379 35.14 387.329 34.93C387.069 34.88 386.839 34.74 386.689 34.52C386.599 34.36 386.579 34.17 386.639 34C386.679 33.88 386.749 33.77 386.839 33.69C386.799 33.65 386.769 33.6 386.739 33.56C386.699 33.48 386.669 33.4 386.649 33.31C386.629 33.34 386.609 33.36 386.579 33.39C386.409 33.52 386.209 33.62 385.999 33.66C385.949 33.67 385.889 33.69 385.839 33.71C385.699 33.78 385.529 33.76 385.399 33.67C385.369 33.65 385.319 33.62 385.269 33.59C385.039 33.46 384.839 33.34 384.769 33.11C384.699 32.88 384.809 32.63 385.039 32.54C384.969 32.49 384.909 32.42 384.849 32.35C384.779 32.25 384.749 32.13 384.769 32.01C384.789 31.89 384.859 31.79 384.959 31.72C384.969 31.71 384.989 31.69 385.009 31.67C385.129 31.49 385.329 31.38 385.539 31.37C385.679 31.37 385.809 31.45 385.889 31.56C385.849 31.48 385.829 31.39 385.819 31.31C385.799 31.17 385.819 31.02 385.879 30.89C385.859 30.89 385.829 30.89 385.809 30.88C385.639 30.85 385.499 30.72 385.459 30.56C385.439 30.28 385.539 30.01 385.729 29.81C385.749 29.81 385.729 29.78 385.699 29.76C385.589 29.7 385.489 29.63 385.389 29.57C385.329 29.53 385.269 29.49 385.209 29.45C385.159 29.42 385.109 29.39 385.059 29.36C384.889 29.44 384.689 29.41 384.549 29.28C384.509 29.24 384.479 29.2 384.449 29.15C384.269 29.31 384.029 29.37 383.789 29.32C383.519 29.21 383.289 29.03 383.109 28.81C383.059 28.76 383.019 28.71 382.979 28.67C382.939 28.62 382.899 28.57 382.849 28.53C382.759 28.52 382.669 28.52 382.569 28.53C382.659 28.63 382.699 28.76 382.689 28.89C382.689 29.02 382.619 29.14 382.519 29.23C382.409 29.31 382.279 29.34 382.149 29.32C381.979 29.33 381.819 29.25 381.729 29.11V29.09C381.729 29.09 381.679 29.05 381.669 29.02C381.549 29.11 381.389 29.14 381.249 29.12C381.019 29.12 380.809 29 380.699 28.81C380.639 28.6 380.649 28.38 380.739 28.18L380.759 28.12C380.759 28.12 380.759 28.09 380.769 28.08C380.649 28.08 380.529 28.05 380.439 27.97C380.349 27.89 380.289 27.78 380.289 27.66C380.289 27.64 380.279 27.6 380.269 27.56C380.239 27.47 380.229 27.37 380.239 27.27C380.239 27.23 380.239 27.2 380.259 27.17C380.219 27.17 380.189 27.17 380.149 27.18C380.069 27.18 379.979 27.2 379.899 27.22C379.859 27.24 379.829 27.27 379.799 27.29C379.669 27.41 379.499 27.47 379.329 27.45C379.259 27.45 379.189 27.42 379.129 27.38C379.199 27.46 379.249 27.55 379.299 27.65C379.329 27.65 379.349 27.65 379.379 27.66C379.359 27.66 379.419 27.66 379.479 27.66C379.569 27.66 379.669 27.67 379.759 27.68C379.889 27.71 379.999 27.8 380.059 27.92C380.119 28.04 380.119 28.18 380.059 28.3C380.019 28.37 379.979 28.43 379.929 28.49L379.869 28.57C379.769 28.73 379.579 28.82 379.389 28.77C379.349 28.82 379.309 28.86 379.249 28.88C378.969 29.04 378.619 28.99 378.389 28.75C378.389 28.75 378.369 28.75 378.349 28.73C378.179 28.63 378.039 28.48 377.979 28.29C377.959 27.87 378.069 27.46 378.299 27.1L378.319 27.08C378.239 27.04 378.169 26.98 378.109 26.93L378.059 26.89C378.059 26.89 378.019 26.93 377.999 26.95C377.849 27.11 377.669 27.22 377.459 27.27C377.289 27.29 377.119 27.29 376.959 27.27C376.879 27.26 376.809 27.25 376.729 27.25C376.649 27.26 376.569 27.25 376.499 27.23C376.479 27.26 376.449 27.29 376.419 27.32C376.419 27.33 376.389 27.42 376.379 27.47C376.329 27.66 376.229 28.02 375.859 28.08C375.669 28.12 375.469 28.08 375.319 27.96C375.169 27.84 375.069 27.66 375.059 27.46C375.049 27.41 375.029 27.37 374.999 27.33C374.969 27.35 374.949 27.36 374.929 27.38C374.929 27.4 374.929 27.43 374.929 27.45C374.929 27.63 374.859 27.81 374.749 27.96C374.719 28.01 374.689 28.06 374.669 28.11C374.619 28.21 374.559 28.31 374.499 28.4C374.599 28.37 374.719 28.37 374.819 28.4C374.849 28.41 374.879 28.42 374.909 28.44C374.959 28.38 375.019 28.32 375.079 28.27C375.189 28.18 375.329 28.14 375.459 28.17C375.599 28.2 375.709 28.29 375.769 28.41L375.829 28.52C375.969 28.78 376.079 28.98 376.039 29.17C376.039 29.28 376.039 29.41 376.039 29.58C376.039 29.64 376.019 29.7 376.009 29.75C376.029 29.75 376.049 29.75 376.069 29.75C376.099 29.75 376.129 29.75 376.159 29.75C376.289 29.73 376.429 29.73 376.559 29.75C376.699 29.79 376.829 29.85 376.939 29.94C376.969 29.96 376.999 29.98 377.029 30C377.289 30.13 377.509 30.32 377.659 30.56C377.759 30.73 377.799 30.94 377.759 31.14C377.759 31.17 377.759 31.19 377.759 31.22C377.779 31.24 377.799 31.26 377.819 31.28C377.939 31.38 378.039 31.51 378.099 31.65C378.169 31.83 378.229 32.01 378.279 32.19C378.309 32.31 378.329 32.44 378.319 32.57C378.339 32.57 378.359 32.58 378.389 32.59C378.439 32.57 378.479 32.56 378.519 32.54C378.639 32.48 378.779 32.45 378.909 32.45C379.039 32.35 379.189 32.28 379.349 32.23C379.499 32.18 379.649 32.15 379.809 32.15C379.789 32.11 379.769 32.08 379.749 32.04C379.719 32.02 379.689 32.01 379.649 31.99C379.449 31.91 379.279 31.78 379.159 31.6C379.069 31.43 379.029 31.23 379.029 31.03C379.029 30.99 379.029 30.94 379.029 30.9C378.989 30.83 378.939 30.76 378.869 30.71C378.749 30.61 378.679 30.46 378.699 30.31C378.709 30.16 378.799 30.02 378.929 29.95C378.979 29.91 379.019 29.86 379.049 29.81C379.169 29.64 379.319 29.5 379.499 29.41C379.659 29.34 379.839 29.37 379.979 29.48C380.469 29.89 380.399 30.16 380.369 30.25C380.349 30.3 380.329 30.35 380.309 30.39C380.269 30.45 380.249 30.53 380.259 30.6C380.289 30.72 380.319 30.83 380.339 30.95C380.349 31.04 380.369 31.12 380.389 31.21C380.419 31.23 380.459 31.26 380.489 31.28C380.649 31.39 380.769 31.55 380.839 31.73C380.889 31.87 380.899 32.02 380.879 32.17C380.899 32.19 380.919 32.21 380.939 32.22C381.049 32.31 381.109 32.44 381.109 32.58C381.109 32.62 381.109 32.66 381.089 32.69C381.109 32.71 381.119 32.73 381.129 32.74C381.179 32.82 381.209 32.9 381.219 32.99C381.279 32.99 381.329 32.99 381.389 32.99C381.439 32.99 381.489 32.99 381.529 32.99C381.619 32.95 381.709 32.92 381.809 32.88C381.879 32.86 381.949 32.83 382.029 32.8C382.089 32.77 382.139 32.74 382.189 32.7C382.279 32.64 382.379 32.58 382.479 32.53C382.519 32.51 382.549 32.5 382.589 32.49C382.549 32.35 382.569 32.2 382.659 32.09C382.619 32.05 382.589 32 382.559 31.94C382.489 31.76 382.529 31.55 382.659 31.4C382.909 31.05 383.099 31.02 383.249 31.03C383.389 31.04 383.529 31.12 383.619 31.23C383.749 31.25 383.859 31.3 383.959 31.38C384.289 31.65 384.319 31.84 384.299 31.97C384.269 32.16 384.149 32.31 383.979 32.39C383.849 32.46 383.709 32.48 383.569 32.47C383.699 32.66 383.729 32.9 383.669 33.12C383.729 33.19 383.799 33.27 383.879 33.37C383.899 33.39 383.909 33.42 383.929 33.44C383.979 33.41 384.049 33.39 384.109 33.39C384.219 33.33 384.359 33.33 384.469 33.37C384.559 33.4 384.629 33.46 384.679 33.54C384.759 33.59 384.819 33.66 384.849 33.75C384.909 33.9 384.889 34.06 384.789 34.19C384.689 34.33 384.529 34.4 384.359 34.37C384.339 34.37 384.319 34.37 384.299 34.37C384.289 34.37 384.269 34.37 384.259 34.37C384.259 34.41 384.239 34.45 384.229 34.48C384.239 34.5 384.249 34.52 384.259 34.54C384.459 34.69 384.529 34.96 384.429 35.18C384.419 35.21 384.399 35.23 384.379 35.26C384.379 35.27 384.389 35.29 384.399 35.3C384.429 35.41 384.479 35.52 384.539 35.62C384.599 35.73 384.659 35.84 384.699 35.96C384.749 36.03 384.779 36.12 384.779 36.22C384.779 36.44 384.629 36.62 384.419 36.67C384.359 36.68 384.289 36.69 384.229 36.67C384.229 36.69 384.229 36.7 384.229 36.72C384.219 36.9 384.089 37.06 383.919 37.12C383.859 37.14 383.789 37.15 383.719 37.14C383.569 37.15 383.429 37.08 383.339 36.96C383.309 36.92 383.249 36.86 383.189 36.79C383.099 36.7 383.019 36.61 382.969 36.55C382.959 36.53 382.949 36.52 382.939 36.5C382.719 36.1 383.049 35.55 383.299 35.35C383.319 35.34 383.329 35.32 383.349 35.31V35.28C383.129 35.22 382.919 35.12 382.869 34.87C382.779 34.87 382.689 34.86 382.609 34.84C382.569 34.84 382.529 34.83 382.499 34.82C382.619 35.02 382.699 35.25 382.729 35.48C382.729 35.78 382.559 36.05 382.289 36.18C382.259 36.2 382.229 36.22 382.199 36.24C382.229 36.39 382.279 36.54 382.349 36.67C382.389 36.71 382.439 36.75 382.479 36.79C382.549 36.86 382.629 36.93 382.709 37C382.749 37.02 382.799 37.04 382.839 37.05C382.979 37.09 383.109 37.16 383.219 37.24C383.269 37.27 383.319 37.31 383.369 37.33C383.409 37.35 383.449 37.38 383.489 37.4C383.509 37.34 383.539 37.29 383.579 37.25C383.709 37.12 383.889 37.08 384.059 37.13H384.089C384.089 37.13 384.169 37.07 384.199 37.04C384.399 36.9 384.679 36.94 384.819 37.13C384.969 37.33 384.929 37.6 384.739 37.75L384.679 37.8C384.619 37.85 384.549 37.89 384.479 37.92C384.459 37.93 384.429 37.95 384.399 37.96C384.549 38.07 384.649 38.25 384.669 38.44C384.669 38.45 384.699 38.51 384.709 38.54C384.739 38.61 384.769 38.69 384.789 38.77C384.939 38.82 385.049 38.93 385.089 39.08C385.109 39.14 385.109 39.21 385.089 39.27C385.089 39.27 385.089 39.32 385.099 39.35C385.119 39.46 385.119 39.58 385.099 39.7C385.069 39.9 384.899 40.05 384.699 40.07C384.749 40.11 384.799 40.15 384.849 40.2C384.969 40.17 385.089 40.16 385.209 40.17C385.409 40.17 385.589 40.3 385.669 40.48C385.719 40.66 385.669 40.85 385.549 40.99C385.329 41.26 385.159 41.36 384.949 41.33C384.929 41.33 384.909 41.33 384.889 41.32C384.939 41.48 384.939 41.65 384.889 41.81C384.869 41.87 384.849 41.93 384.819 41.98C384.839 42 384.869 42.03 384.889 42.06C384.919 42.1 384.949 42.14 384.969 42.19C385.019 42.33 384.999 42.49 384.919 42.62C384.839 42.73 384.719 42.8 384.579 42.81C384.439 42.81 384.309 42.77 384.219 42.67H384.209C384.209 42.67 384.169 42.64 384.159 42.63C384.129 42.65 384.099 42.67 384.069 42.7C383.979 42.76 383.889 42.83 383.809 42.89L383.759 42.93C383.679 42.99 383.609 43.05 383.539 43.11C383.539 43.14 383.539 43.17 383.539 43.2C383.569 43.36 383.559 43.53 383.509 43.69C383.449 43.84 383.349 43.97 383.219 44.05H383.279C383.369 44.03 383.449 44.03 383.539 44.04C383.559 44.04 383.569 44.04 383.589 44.04C383.799 43.95 384.039 44.02 384.159 44.21C384.259 44.2 384.359 44.21 384.459 44.24C384.539 44.24 384.619 44.26 384.689 44.31C384.809 44.39 384.889 44.52 384.899 44.66C384.979 44.86 384.899 45.1 384.729 45.22C384.669 45.26 384.599 45.29 384.519 45.3C384.489 45.37 384.449 45.44 384.389 45.5C384.349 45.53 384.309 45.56 384.269 45.58C384.309 45.6 384.349 45.63 384.389 45.66C384.539 45.8 384.579 46.03 384.479 46.21C384.479 46.22 384.469 46.23 384.459 46.25C384.599 46.24 384.729 46.3 384.809 46.42C384.909 46.56 384.999 46.71 385.059 46.87C385.079 46.93 385.109 46.98 385.139 47.03C385.169 47.05 385.209 47.08 385.239 47.09C385.319 47.14 385.399 47.19 385.469 47.26C385.669 47.18 385.899 47.24 386.019 47.42C386.129 47.61 386.179 47.83 386.149 48.05C386.149 48.08 386.149 48.12 386.149 48.15C386.229 48.37 386.149 48.62 385.959 48.76C385.899 48.81 385.829 48.85 385.749 48.87C385.709 48.91 385.669 48.96 385.629 48.99C385.799 49.1 385.879 49.32 385.809 49.51C385.769 49.62 385.729 49.75 385.689 49.88L385.649 50.01C385.629 50.08 385.589 50.14 385.549 50.2C385.579 50.24 385.609 50.28 385.629 50.33C385.669 50.44 385.649 50.57 385.599 50.68C385.589 50.81 385.549 50.93 385.489 51.04C385.389 51.17 385.329 51.26 385.299 51.32C385.379 51.57 385.349 51.85 385.219 52.08C385.349 52.18 385.449 52.32 385.489 52.48C385.519 52.55 385.549 52.62 385.579 52.69C385.619 52.77 385.649 52.85 385.679 52.93C385.739 53.04 385.749 53.18 385.699 53.3C385.669 53.36 385.629 53.41 385.579 53.46C385.529 53.56 385.449 53.64 385.349 53.68C385.229 53.73 385.099 53.73 384.989 53.68H384.959C384.979 53.76 384.959 53.86 384.919 53.95C385.019 54.01 385.109 54.09 385.189 54.17C385.329 54.29 385.409 54.47 385.409 54.66C385.389 54.91 385.209 55.06 384.999 55.24C384.929 55.3 384.859 55.36 384.799 55.43C384.759 55.48 384.709 55.51 384.659 55.54C384.659 55.59 384.639 55.64 384.629 55.69C384.689 55.66 384.759 55.63 384.839 55.62C384.879 55.62 384.929 55.61 384.969 55.61L384.879 55.63ZM387.559 52.22C387.559 52.22 387.589 52.3 387.609 52.36C387.639 52.43 387.669 52.54 387.699 52.64C387.729 52.59 387.749 52.54 387.779 52.5C387.819 52.43 387.849 52.37 387.879 52.32C387.769 52.32 387.649 52.29 387.559 52.23V52.22ZM385.959 51.77L385.979 51.87C386.089 51.84 386.189 51.76 386.239 51.65L386.069 51.68H386.089L385.949 51.77H385.959ZM385.789 51.37C385.719 51.43 385.669 51.52 385.659 51.62L385.779 51.64L385.909 51.47L385.939 51.59L385.999 51.48C385.929 51.46 385.859 51.43 385.809 51.38L385.789 51.37ZM384.019 48.13C384.379 48.37 384.559 48.62 384.559 48.88C384.609 48.84 384.659 48.81 384.719 48.79C384.719 48.74 384.709 48.69 384.719 48.65C384.719 48.63 384.719 48.62 384.719 48.6V48.57C384.589 48.55 384.479 48.48 384.409 48.37C384.359 48.3 384.299 48.24 384.229 48.18C384.199 48.15 384.159 48.11 384.129 48.08C384.099 48.1 384.059 48.12 384.029 48.14L384.019 48.13ZM383.659 46.48C383.699 46.54 383.719 46.6 383.729 46.67C383.729 46.6 383.699 46.54 383.659 46.48ZM383.709 46.48C383.719 46.54 383.729 46.6 383.729 46.66C383.809 46.63 383.889 46.63 383.969 46.64C383.979 46.58 383.999 46.52 384.039 46.47C384.019 46.47 384.009 46.47 383.989 46.47C383.979 46.47 383.959 46.47 383.949 46.47C383.879 46.49 383.799 46.49 383.719 46.47L383.709 46.48ZM386.629 45.83L386.529 45.86C386.569 45.96 386.649 46.05 386.749 46.1C386.719 46.04 386.699 45.98 386.679 45.91L386.619 45.83H386.629ZM386.969 45.61C386.969 45.61 386.939 45.69 386.939 45.73L387.039 45.75C387.039 45.75 387.009 45.7 386.999 45.68C386.999 45.66 386.979 45.64 386.969 45.62V45.61ZM384.949 41.05C384.949 41.05 384.979 41.07 384.999 41.08L384.969 40.9V40.93L384.939 40.9C384.939 40.9 384.919 40.98 384.899 41.02C384.909 41.03 384.929 41.04 384.939 41.05H384.949ZM385.059 40.75L385.289 40.88C385.329 40.81 385.329 40.72 385.289 40.64C385.229 40.55 385.129 40.49 385.019 40.48V40.59L385.179 40.71L385.059 40.74V40.75ZM371.479 34.15C371.479 34.15 371.539 34.2 371.559 34.23C371.579 34.21 371.609 34.18 371.639 34.16C371.679 34.13 371.719 34.1 371.759 34.07V34.03H371.749C371.649 34.05 371.539 34.03 371.449 34C371.449 34.04 371.469 34.08 371.469 34.12V34.16L371.479 34.15ZM370.339 33.81V33.85C370.339 33.85 370.349 33.87 370.359 33.88C370.399 33.86 370.459 33.83 370.499 33.81L370.619 33.75C370.759 33.62 370.949 33.57 371.139 33.6H371.169C371.169 33.6 371.129 33.48 371.099 33.4C371.079 33.32 371.049 33.25 371.029 33.2C370.929 33.04 370.939 32.84 371.049 32.69L371.069 32.35C371.089 32.01 371.289 31.7 371.599 31.55C371.759 31.43 371.989 31.45 372.129 31.59C372.239 31.69 372.289 31.83 372.279 31.97C372.309 31.97 372.339 31.97 372.369 31.99C372.419 32 372.459 32.02 372.499 32.05C372.489 31.94 372.499 31.82 372.559 31.72C372.689 31.51 372.929 31.4 373.179 31.43C373.179 31.39 373.179 31.34 373.179 31.3C373.179 31.12 373.259 30.94 373.389 30.81C373.389 30.78 373.379 30.75 373.369 30.72C373.349 30.59 373.329 30.47 373.329 30.34C373.329 30.27 373.309 30.21 373.289 30.14C373.249 30.01 373.229 29.87 373.219 29.73C373.219 29.63 373.219 29.52 373.239 29.43C373.209 29.32 373.189 29.21 373.179 29.1C373.069 29.12 372.959 29.11 372.859 29.08C372.689 29.01 372.549 28.89 372.449 28.73V28.71H372.429C372.429 28.71 372.429 28.75 372.429 28.78C372.429 28.85 372.429 28.96 372.429 29.1C372.439 29.13 372.459 29.16 372.469 29.19C372.549 29.33 372.609 29.48 372.629 29.64V29.67C372.629 29.67 372.669 29.72 372.679 29.74C372.759 29.87 372.809 30.01 372.829 30.16C372.859 30.42 372.759 30.67 372.559 30.84C372.469 30.94 372.349 31 372.219 31C372.199 31 372.179 31 372.159 31C372.129 31.04 372.099 31.07 372.069 31.1C371.869 31.26 371.569 31.23 371.409 31.03C371.399 31.03 371.379 31.01 371.369 31C371.209 30.86 371.159 30.63 371.259 30.44C371.259 30.39 371.239 30.34 371.229 30.29C371.119 30.38 370.999 30.46 370.869 30.51C370.849 30.52 370.819 30.53 370.789 30.55C370.789 30.59 370.789 30.65 370.789 30.69C370.809 30.84 370.789 30.99 370.739 31.13C370.719 31.18 370.699 31.23 370.689 31.27C370.719 31.35 370.739 31.44 370.739 31.53C370.739 31.6 370.729 31.67 370.709 31.74C370.739 31.85 370.749 31.95 370.749 32.06C370.749 32.11 370.769 32.17 370.789 32.22C370.829 32.34 370.849 32.47 370.849 32.59C370.849 32.87 370.789 33.15 370.679 33.42C370.679 33.44 370.659 33.45 370.649 33.47C370.559 33.58 370.429 33.64 370.299 33.65C370.319 33.71 370.329 33.77 370.329 33.84L370.339 33.81ZM369.529 33.35C369.529 33.35 369.569 33.41 369.579 33.45C369.619 33.42 369.659 33.39 369.699 33.37C369.759 33.35 369.819 33.33 369.879 33.33C369.779 33.26 369.699 33.16 369.669 33.05C369.639 32.97 369.619 32.89 369.609 32.8C369.539 32.78 369.489 32.74 369.439 32.69L369.359 32.72C369.359 32.72 369.309 32.74 369.289 32.75C369.439 32.8 369.539 32.92 369.569 33.07C369.589 33.16 369.569 33.26 369.529 33.35ZM376.299 31.47C376.329 31.54 376.359 31.61 376.379 31.68C376.389 31.72 376.409 31.76 376.439 31.8C376.529 31.92 376.599 32.05 376.649 32.2C376.689 32.32 376.719 32.45 376.729 32.58C376.729 32.65 376.749 32.72 376.769 32.79C376.769 32.82 376.779 32.85 376.779 32.88C376.849 32.81 376.929 32.76 377.019 32.74C377.079 32.72 377.139 32.7 377.189 32.67C377.189 32.65 377.209 32.63 377.219 32.61C377.259 32.55 377.309 32.48 377.359 32.43C377.329 32.29 377.279 32.16 377.229 32.03C377.229 32.03 377.179 31.98 377.149 31.96C377.049 31.87 376.959 31.77 376.899 31.66C376.809 31.48 376.789 31.28 376.819 31.08V31.03C376.819 31.03 376.749 30.94 376.699 30.9C376.649 30.95 376.579 30.98 376.509 31V31.03C376.539 31.21 376.449 31.38 376.289 31.47H376.279H376.299ZM377.399 32.42C377.399 32.42 377.389 32.47 377.389 32.49L377.809 32.33L377.399 32.42ZM374.719 32.37C374.819 32.37 374.909 32.38 374.999 32.41C374.999 32.37 374.999 32.33 374.999 32.28V32.15C374.999 32.08 374.999 32.01 374.999 31.94C374.889 31.91 374.799 31.84 374.739 31.74C374.679 31.56 374.629 31.38 374.599 31.19H374.579C374.479 31.19 374.379 31.16 374.289 31.13C374.269 31.23 374.239 31.32 374.209 31.41C374.199 31.44 374.189 31.47 374.179 31.5C374.199 31.53 374.229 31.56 374.249 31.58C374.409 31.73 374.509 31.93 374.529 32.15C374.529 32.23 374.529 32.31 374.499 32.39C374.569 32.39 374.649 32.38 374.719 32.38V32.37ZM372.879 31.77C372.849 31.86 372.859 31.97 372.889 32.06C372.939 32.18 373.039 32.28 373.169 32.31C373.189 32.3 373.219 32.29 373.239 32.27C373.199 32.13 373.169 31.99 373.169 31.84V31.73C373.169 31.73 373.129 31.73 373.099 31.72C373.019 31.72 372.939 31.72 372.869 31.76L372.879 31.77ZM383.489 32.13C383.549 32.13 383.609 32.13 383.669 32.11C383.779 32.07 383.869 31.99 383.919 31.89L383.739 31.92H383.789L383.579 32.06C383.579 32.06 383.519 32.11 383.489 32.13ZM382.989 31.89C382.989 31.89 383.029 31.89 383.059 31.89C383.059 31.83 383.059 31.77 383.059 31.71C383.059 31.6 383.099 31.49 383.169 31.4C383.169 31.4 383.099 31.35 383.059 31.34C382.969 31.38 382.899 31.45 382.859 31.54C382.819 31.61 382.819 31.7 382.859 31.78C382.889 31.83 382.939 31.87 382.999 31.89H382.989ZM371.899 31C371.899 31 371.819 31.04 371.779 31.05C371.819 31.04 371.859 31.02 371.899 30.99V31ZM374.169 29.43C374.169 29.43 374.169 29.5 374.179 29.54L374.199 29.51V29.49C374.199 29.49 374.179 29.45 374.169 29.43ZM385.989 38C385.879 38 385.779 37.97 385.699 37.91L385.639 37.87C385.529 37.8 385.439 37.72 385.349 37.62C385.259 37.51 385.229 37.37 385.259 37.24C385.289 37.11 385.379 36.99 385.499 36.93C385.519 36.92 385.539 36.9 385.559 36.88C385.709 36.71 385.949 36.63 386.169 36.68C386.379 36.75 386.479 36.93 386.579 37.12C386.599 37.15 386.609 37.18 386.619 37.2C386.699 37.29 386.729 37.41 386.709 37.53C386.689 37.65 386.609 37.76 386.509 37.83C386.349 37.93 386.169 37.98 385.979 37.99L385.989 38ZM383.049 30.46C382.969 30.46 382.889 30.44 382.819 30.4C382.609 30.28 382.589 30.09 382.569 29.84V29.77C382.529 29.67 382.549 29.56 382.599 29.46C382.649 29.37 382.739 29.3 382.849 29.27C382.969 29.23 383.109 29.23 383.229 29.27C383.249 29.27 383.219 29.27 383.169 29.27C383.359 29.25 383.549 29.35 383.629 29.52C383.689 29.6 383.739 29.69 383.769 29.78C383.829 30.02 383.679 30.26 383.449 30.32L383.399 30.34C383.289 30.4 383.179 30.43 383.049 30.44V30.46ZM377.199 29.47C377.119 29.47 377.039 29.45 376.969 29.4C376.889 29.35 376.829 29.28 376.799 29.19C376.699 29.08 376.639 28.94 376.649 28.79C376.659 28.56 376.819 28.45 377.119 28.24C377.229 28.17 377.359 28.14 377.489 28.17C377.619 28.2 377.719 28.29 377.779 28.4C377.819 28.49 377.849 28.58 377.869 28.67C377.879 28.72 377.889 28.76 377.899 28.79C377.949 28.9 377.959 29.02 377.909 29.13C377.859 29.24 377.769 29.33 377.659 29.37C377.559 29.41 377.459 29.42 377.359 29.42C377.309 29.44 377.259 29.45 377.209 29.45L377.199 29.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M366.649 31.0001C366.619 31.1501 366.299 31.5901 366.469 31.7201C366.589 31.8101 366.939 31.7001 367.059 31.8701C367.159 32.0001 367.049 32.3001 367.149 32.4601C367.249 32.6101 367.369 32.7501 367.469 32.9001C367.569 33.0501 367.559 33.2801 367.659 33.4301C367.779 33.5801 367.909 33.7101 368.049 33.8401C368.179 33.9901 368.539 33.8401 368.679 33.9201C368.699 33.9201 368.519 34.1001 368.529 34.1101C368.699 34.1901 368.849 34.3101 369.019 34.3901C369.039 34.3901 368.879 34.2801 368.879 34.3001C368.919 34.5201 368.969 34.7501 368.999 34.9601C368.999 35.1901 368.999 35.4201 369.019 35.6601C369.079 35.8201 369.139 35.9801 369.179 36.1501C369.209 36.3701 369.439 36.5501 369.389 36.6901C369.329 36.8601 369.059 36.8201 368.889 36.9201C368.749 37.0001 368.659 37.1701 368.459 37.2501C368.229 37.3301 368.279 37.5401 368.229 37.6201C368.179 37.7101 367.999 37.8301 368.269 37.9901C368.579 38.1701 368.409 38.0901 368.259 38.3201C368.059 38.6201 367.899 38.6101 367.799 38.4001C367.679 38.1301 367.709 37.7401 367.819 38.2001C367.919 38.5901 367.769 38.6701 367.599 38.8401C367.199 39.2501 367.489 39.2101 367.759 39.2301C367.779 39.2301 367.699 39.0701 367.689 39.0901C367.629 39.2901 367.389 39.4301 367.309 39.6301C367.259 39.8501 367.219 40.0701 367.199 40.3001C367.199 40.5201 367.239 40.7401 367.309 40.9501C367.339 41.1301 367.309 41.3101 367.349 41.4801C367.379 41.6601 367.419 41.8301 367.499 41.9901C367.569 42.1401 367.579 42.3801 367.729 42.5101C368.119 42.8601 367.859 42.6601 367.579 42.7301C367.559 42.7101 367.489 42.7801 367.459 42.7601C367.489 42.7701 367.489 42.8601 367.519 42.8801C367.519 43.1001 367.489 43.3301 367.449 43.5501C367.399 43.7301 367.299 44.0001 367.699 44.1401C367.739 44.1501 367.979 44.2501 367.949 44.3101C367.759 44.7301 367.409 43.7401 367.209 44.1601C367.159 44.1301 366.949 43.9801 366.899 43.9501C366.959 43.9701 367.209 44.0401 367.269 44.0701C367.279 44.1501 367.299 44.2201 367.339 44.2901C367.419 44.4701 367.339 44.7001 367.389 44.8801C367.439 45.0601 367.649 45.2401 367.659 45.4201C367.669 45.6001 367.419 45.7901 367.379 45.9801C367.339 46.1501 367.209 46.2101 367.119 46.3901C367.019 46.3901 367.149 46.7201 367.059 46.7201C367.069 46.7601 366.969 46.5301 366.979 46.5701C367.059 46.5101 367.089 46.6101 367.159 46.5501C367.189 46.7301 367.179 46.8601 367.189 47.0401C367.189 47.2301 367.209 47.4201 367.249 47.6001C367.299 47.7601 367.549 47.8701 367.679 48.0201C367.609 48.2001 367.379 48.3801 367.369 48.5801C367.359 48.7701 367.679 48.9701 367.679 49.1701C367.679 49.3601 367.299 49.5301 367.269 49.7201C367.249 49.8901 367.199 50.0501 367.109 50.1901C367.019 50.3401 367.069 50.5801 366.889 50.7101C366.809 50.7601 367.449 50.9001 367.469 50.9101C367.669 51.0001 367.599 51.2801 367.629 51.4001C367.679 51.5501 367.909 51.7201 367.859 51.8901C367.809 52.0601 367.679 52.1801 367.689 52.3201C367.699 52.5201 367.659 52.7201 367.559 52.9001C367.469 53.0401 367.079 53.0001 366.979 53.1501C366.909 53.3301 366.879 53.5301 366.909 53.7301C366.879 53.9301 366.889 54.1401 366.939 54.3401C367.009 54.5101 367.189 54.6601 367.259 54.8401C367.329 55.0201 367.389 55.2001 367.429 55.3901C367.469 55.6101 367.519 55.8301 367.409 55.9701C367.279 56.1201 367.089 56.2201 366.889 56.2301C366.729 56.2301 366.549 55.9501 366.359 55.9401C366.179 55.9301 365.999 55.9401 365.819 55.9201C365.629 55.9001 365.439 56.1801 365.269 56.1901C365.049 56.1901 364.759 55.9601 364.659 56.0501C364.559 56.1401 364.419 56.4601 364.269 56.4501C364.069 56.4301 363.869 56.3901 363.669 56.3701C363.469 56.3501 363.279 56.1401 363.079 56.1101C362.879 56.0801 362.609 56.2401 362.419 56.1801C362.139 56.0801 362.149 56.7201 362.049 56.1701C362.019 56.0101 362.259 55.7101 362.149 55.5601C362.039 55.4101 361.619 55.4301 361.569 55.2801C361.509 55.1201 361.749 54.9901 361.919 54.8301C362.029 54.6701 362.119 54.5001 362.189 54.3201C362.279 54.1601 362.169 53.9201 362.219 53.7501C362.279 53.5801 362.469 53.3701 362.389 53.1601C362.389 53.1301 362.209 53.1301 362.229 53.1601C362.249 53.1801 362.249 53.1801 362.229 53.1601C362.109 53.0501 362.029 53.0301 361.909 52.9201C362.149 52.8501 361.979 52.5501 362.019 52.3301C362.049 52.1201 362.139 51.8201 362.459 51.8201C362.339 51.6801 362.319 51.6501 362.189 51.5101C362.179 51.5001 362.069 51.6301 362.059 51.6101C361.939 51.3901 362.099 51.1201 362.149 50.9201C362.199 50.7101 362.379 50.5401 362.449 50.3401C362.529 50.1201 362.559 49.8701 362.509 49.6401C362.479 49.5201 362.489 49.3701 362.469 49.3601C362.119 49.1901 362.219 48.9201 362.269 48.7101C362.299 48.4801 362.279 48.2501 362.219 48.0201C362.189 47.8501 362.369 47.5901 362.269 47.4201C362.179 47.2701 361.769 47.2901 361.679 47.1401C361.579 46.9801 361.749 46.6901 361.719 46.5401C361.699 46.4101 361.719 46.4701 361.989 46.3301C362.119 46.0201 362.129 45.6701 362.019 45.3501C361.869 45.2001 361.729 45.1101 361.709 44.9801C361.689 44.8101 361.609 44.5801 361.689 44.4301C361.769 44.2801 362.159 44.2701 362.219 44.1201C362.359 43.8801 362.529 43.6601 362.739 43.4701C362.549 43.3201 362.069 43.2401 361.949 43.0401C361.849 42.8701 362.069 42.6201 362.129 42.4301C362.189 42.2501 362.239 42.0501 362.279 41.8701C362.319 41.6901 362.389 41.4901 362.409 41.3001C362.429 41.1101 362.089 40.9001 362.089 40.7101C362.089 40.5201 362.229 40.3401 362.209 40.1501C362.159 39.9701 362.109 39.7901 362.039 39.6201C361.989 39.4401 361.839 39.3201 361.759 39.1401C361.669 38.9201 361.719 38.6601 361.899 38.5001C362.029 38.4201 362.209 38.3401 362.349 38.2601C362.469 38.1901 362.879 38.2701 362.879 38.1901C362.859 37.8301 362.499 37.9501 362.339 37.9801C362.129 38.0201 361.989 38.1001 361.909 38.0101C361.829 37.9201 361.849 37.7601 361.889 37.5601C361.959 37.3501 362.019 37.1401 362.069 36.9301C362.079 36.7101 362.029 36.4801 361.909 36.2901C361.859 36.2001 362.029 35.8501 362.179 35.6901C362.429 35.4201 362.539 35.1401 362.219 35.0301C361.979 34.9401 361.669 34.9901 361.609 34.8401C361.549 34.6901 361.749 34.4701 361.839 34.2501C361.839 34.2401 361.599 34.3301 361.589 34.3201C361.589 34.2301 361.809 34.0901 361.809 34.0001C361.809 33.9801 361.769 34.0101 361.769 34.0001C361.809 33.7901 361.909 33.5901 361.969 33.3901C362.029 33.1801 362.269 32.9801 362.279 32.7701C362.289 32.5701 362.019 32.3701 361.929 32.1601C361.929 32.1501 362.089 32.1801 362.089 32.1601C362.119 31.9601 361.879 31.7801 361.839 31.6001C361.809 31.4501 361.949 31.2401 361.879 31.0901C361.799 30.9301 361.479 30.7701 361.499 30.6201L366.649 31.0001ZM366.739 37.3301C366.779 37.2801 366.659 37.3701 366.699 37.3201C366.669 37.3801 366.889 37.3801 366.859 37.4401C366.829 37.4501 366.619 37.2701 366.589 37.2901C366.569 37.3001 366.709 37.5101 366.699 37.5301C366.729 37.4901 366.709 37.3801 366.739 37.3401V37.3301ZM368.549 35.3301C368.549 35.3301 368.729 35.4801 368.759 35.4701C368.779 35.4601 368.729 35.3601 368.739 35.3301C368.709 35.3701 368.519 35.2101 368.489 35.2501C368.459 35.2601 368.449 35.2901 368.419 35.3101C368.399 35.3201 368.599 35.6001 368.589 35.6301C368.619 35.5901 368.519 35.3801 368.549 35.3401V35.3301ZM366.679 33.3101C366.679 33.3101 367.179 33.3901 367.129 33.3701C367.189 33.3901 366.759 33.2201 366.809 33.2401C366.809 33.3501 367.049 33.5801 367.059 33.6901C367.109 33.6701 367.359 33.5701 367.409 33.5501C367.349 33.4701 366.749 33.4001 366.679 33.3201V33.3101ZM366.799 48.6701C366.669 48.5601 366.669 48.2901 366.579 48.2601C366.539 48.2401 366.459 48.4901 366.459 48.5101C366.479 48.6101 366.359 48.8501 366.399 48.9501C366.489 48.9101 366.639 48.7501 366.799 48.6801V48.6701ZM367.919 35.8301C367.919 35.8301 368.009 35.5901 367.989 35.5801C367.959 35.5701 367.939 35.8201 367.909 35.8101C367.909 35.8501 367.739 35.9201 367.749 35.9501C367.779 35.9401 367.889 35.8301 367.919 35.8201V35.8301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M364.319 56.8101C364.319 56.8101 364.279 56.8101 364.259 56.8101C364.159 56.8001 364.059 56.7901 363.969 56.7701C363.869 56.7601 363.769 56.7401 363.669 56.7301C363.489 56.7101 363.309 56.6401 363.159 56.5301C363.119 56.5001 363.079 56.4801 363.029 56.4601C363.029 56.4601 362.959 56.4801 362.909 56.4901C362.789 56.5301 362.659 56.5501 362.529 56.5501C362.429 56.7001 362.249 56.7701 362.079 56.7401C361.739 56.6901 361.679 56.3501 361.639 56.1501C361.619 56.0101 361.639 55.8601 361.689 55.7301C361.469 55.6901 361.279 55.5401 361.179 55.3401C361.009 54.9101 361.379 54.6201 361.539 54.4901C361.579 54.4601 361.609 54.4301 361.639 54.4001C361.669 54.3501 361.689 54.3001 361.709 54.2401C361.739 54.1701 361.769 54.1001 361.799 54.0301C361.799 54.0001 361.799 53.9701 361.799 53.9501C361.779 53.8001 361.789 53.6501 361.829 53.5101C361.849 53.4501 361.869 53.4001 361.899 53.3401L361.859 53.3101C361.779 53.2601 361.709 53.2101 361.639 53.1501C361.549 53.0701 361.499 52.9601 361.489 52.8401C361.479 52.7201 361.529 52.6001 361.609 52.5201C361.589 52.4101 361.589 52.2901 361.609 52.1701C361.629 52.0301 361.669 51.9001 361.719 51.7701C361.709 51.7501 361.699 51.7301 361.689 51.7201C361.569 51.4401 361.579 51.1201 361.709 50.8501C361.719 50.8101 361.739 50.7701 361.749 50.7301C361.789 50.5701 361.869 50.4201 361.959 50.2801C361.999 50.2201 362.029 50.1701 362.059 50.1001C362.109 49.9601 362.129 49.8101 362.109 49.6601C362.099 49.6201 362.089 49.5701 362.079 49.5301C361.819 49.2801 361.729 48.9001 361.849 48.5601C361.869 48.4201 361.869 48.2801 361.829 48.1401L361.809 48.0101C361.789 47.8801 361.809 47.7401 361.839 47.6201C361.629 47.5801 361.439 47.4601 361.319 47.2901C361.209 47.0701 361.199 46.8201 361.279 46.5901C361.279 46.5601 361.299 46.5201 361.299 46.4901C361.249 46.2301 361.409 45.9801 361.659 45.9201C361.669 45.7901 361.679 45.6601 361.659 45.5301L361.619 45.5001C361.439 45.3701 361.319 45.1701 361.279 44.9601L361.259 44.8601C361.189 44.6201 361.209 44.3701 361.309 44.1501C361.429 43.9601 361.609 43.8301 361.829 43.7701L361.879 43.7501C361.919 43.6801 361.969 43.6001 362.019 43.5401C361.839 43.4701 361.689 43.3501 361.589 43.1901C361.459 42.9101 361.489 42.5801 361.669 42.3301C361.689 42.2901 361.709 42.2501 361.729 42.2101C361.789 42.0401 361.829 41.8601 361.869 41.6901C361.889 41.6201 361.909 41.5501 361.919 41.4801C361.939 41.4101 361.959 41.3301 361.979 41.2601L361.939 41.2101C361.789 41.0601 361.689 40.8501 361.679 40.6401C361.679 40.5001 361.709 40.3701 361.759 40.2401C361.769 40.2001 361.789 40.1601 361.799 40.1201C361.779 40.0601 361.759 39.9901 361.729 39.9301C361.689 39.8401 361.659 39.7501 361.629 39.6601C361.609 39.6201 361.579 39.5801 361.549 39.5401C361.479 39.4501 361.419 39.3401 361.369 39.2301C361.219 38.8701 361.289 38.4601 361.539 38.1601C361.409 37.9201 361.389 37.6301 361.469 37.3701C361.499 37.2701 361.529 37.1601 361.569 37.0701C361.609 36.9801 361.629 36.8901 361.649 36.8001C361.649 36.6701 361.609 36.5301 361.539 36.4201C361.339 36.0401 361.709 35.4901 361.859 35.3201C361.589 35.3201 361.349 35.1701 361.219 34.9301C361.159 34.7701 361.159 34.6001 361.219 34.4401L361.199 34.4001C361.179 34.3501 361.169 34.3001 361.169 34.2401C361.169 34.0701 361.239 33.9201 361.359 33.8001C361.389 33.6601 361.439 33.5201 361.489 33.3801C361.519 33.3101 361.539 33.2301 361.569 33.1601C361.619 33.0201 361.689 32.8901 361.769 32.7701C361.789 32.7401 361.819 32.7001 361.839 32.6701C361.819 32.6401 361.789 32.6101 361.769 32.5801C361.679 32.4801 361.609 32.3601 361.549 32.2401C361.499 32.1201 361.499 31.9901 361.549 31.8701C361.409 31.6601 361.379 31.4001 361.469 31.1601L361.429 31.1301C361.209 30.9801 361.079 30.7301 361.089 30.4701L361.979 30.5901C361.989 30.5101 361.979 30.4401 361.929 30.3701C361.959 30.4001 361.989 30.4301 362.019 30.4601C362.139 30.5501 362.239 30.6701 362.309 30.7901C362.389 30.9801 362.399 31.1901 362.329 31.3901V31.4201C362.329 31.4201 362.349 31.4501 362.359 31.4701C362.509 31.6501 362.579 31.8901 362.559 32.1301C362.689 32.2901 362.759 32.4901 362.759 32.6901C362.739 32.9001 362.649 33.1001 362.519 33.2701C362.489 33.3201 362.459 33.3701 362.429 33.4201C362.399 33.5101 362.369 33.6001 362.339 33.7001C362.319 33.7501 362.299 33.8001 362.289 33.8501C362.289 33.8701 362.289 33.8801 362.289 33.9001C362.289 33.9001 362.289 33.9601 362.289 33.9901C362.339 34.1001 362.339 34.2201 362.289 34.3301C362.269 34.3701 362.249 34.4201 362.229 34.4601C362.289 34.4701 362.349 34.4901 362.399 34.5101C362.639 34.5801 362.819 34.7701 362.879 35.0101C362.929 35.3501 362.799 35.6901 362.539 35.9001C362.489 35.9601 362.439 36.0401 362.409 36.1101C362.519 36.3501 362.569 36.6101 362.549 36.8701C362.529 37.0301 362.489 37.1901 362.429 37.3501L362.409 37.4201C362.649 37.3501 362.899 37.4001 363.109 37.5301C363.269 37.6601 363.369 37.8601 363.369 38.0701C363.369 38.2001 363.329 38.3301 363.239 38.4201C363.089 38.5501 362.879 38.6101 362.679 38.5801C362.639 38.5801 362.599 38.5801 362.559 38.5801C362.509 38.6101 362.449 38.6401 362.389 38.6701C362.329 38.7001 362.279 38.7301 362.219 38.7601C362.209 38.8001 362.199 38.8401 362.219 38.8701C362.239 38.9201 362.269 38.9601 362.299 39.0001C362.399 39.1201 362.469 39.2601 362.509 39.4101C362.529 39.4701 362.549 39.5201 362.569 39.5801C362.629 39.7201 362.669 39.8601 362.699 40.0101C362.709 40.1801 362.689 40.3501 362.619 40.5101L362.599 40.5701L362.639 40.6201C362.819 40.7901 362.909 41.0201 362.899 41.2701C362.879 41.4201 362.849 41.5601 362.799 41.7001C362.779 41.7601 362.769 41.8201 362.749 41.8801C362.709 42.0701 362.649 42.2801 362.589 42.4801C362.559 42.5701 362.519 42.6601 362.469 42.7401C362.469 42.7401 362.549 42.7701 362.589 42.7901C362.759 42.8501 362.909 42.9301 363.049 43.0301C363.149 43.1101 363.199 43.2201 363.209 43.3401C363.209 43.4601 363.179 43.5801 363.099 43.6801L362.969 43.8201C362.849 43.9301 362.749 44.0601 362.659 44.2101C362.549 44.4201 362.359 44.5701 362.139 44.6201C362.139 44.6501 362.149 44.6801 362.159 44.7001C362.159 44.7301 362.169 44.7601 362.169 44.7901C362.189 44.8101 362.209 44.8201 362.229 44.8401C362.269 44.8801 362.309 44.9201 362.359 44.9601C362.659 45.2701 362.549 46.0201 362.539 46.1101C362.519 46.3301 362.399 46.5401 362.219 46.6601L362.179 46.6801C362.179 46.6801 362.159 46.7501 362.159 46.7901C362.369 46.8301 362.559 46.9501 362.679 47.1201C362.789 47.3401 362.799 47.5901 362.719 47.8101C362.709 47.8401 362.699 47.8801 362.689 47.9101L362.709 47.9801C362.769 48.2301 362.779 48.4801 362.729 48.7401C362.719 48.8001 362.699 48.8501 362.699 48.8801C362.859 48.9801 362.959 49.1501 362.959 49.3401C362.959 49.3801 362.959 49.4101 362.969 49.4501C363.039 49.7701 363.009 50.1001 362.899 50.4101C362.849 50.5401 362.789 50.6601 362.709 50.7701C362.669 50.8301 362.639 50.8901 362.609 50.9501C362.599 51.0101 362.569 51.0701 362.549 51.1401C362.609 51.2101 362.649 51.2601 362.689 51.3001L362.819 51.4501C362.929 51.5801 362.959 51.7601 362.899 51.9201C362.839 52.0801 362.689 52.1901 362.519 52.2001C362.509 52.2401 362.499 52.2801 362.489 52.3301C362.489 52.3401 362.489 52.4001 362.499 52.4401C362.499 52.5101 362.509 52.5801 362.509 52.6401C362.659 52.6901 362.779 52.8001 362.839 52.9401C362.909 53.2101 362.869 53.5001 362.709 53.7301C362.689 53.7601 362.679 53.7901 362.659 53.8201C362.659 53.8401 362.669 53.8701 362.669 53.8901C362.709 54.0901 362.669 54.2901 362.589 54.4701C362.569 54.5201 362.549 54.5601 362.529 54.6101C362.479 54.7601 362.399 54.9101 362.299 55.0301C362.389 55.0801 362.469 55.1401 362.529 55.2301C362.619 55.3501 362.659 55.5101 362.639 55.6601H362.679C362.999 55.5401 363.349 55.5901 363.609 55.7901C363.649 55.8201 363.689 55.8401 363.739 55.8601C363.849 55.8601 363.969 55.8801 364.089 55.9001C364.119 55.9001 364.149 55.9001 364.179 55.9101L364.209 55.8601C364.259 55.7801 364.309 55.7101 364.379 55.6501C364.599 55.4801 364.909 55.4601 365.149 55.6101C365.179 55.6201 365.209 55.6401 365.249 55.6501L365.279 55.6301C365.449 55.4801 365.669 55.3901 365.889 55.4001C365.969 55.4001 366.049 55.4001 366.139 55.4101C366.239 55.4101 366.329 55.4101 366.429 55.4201C366.629 55.4501 366.809 55.5401 366.949 55.6801L366.969 55.7001C366.969 55.7001 367.049 55.6601 367.079 55.6301C367.059 55.6401 367.039 55.5201 367.019 55.4401C366.989 55.2601 366.939 55.0901 366.869 54.9301C366.839 54.8801 366.809 54.8301 366.769 54.7801C366.679 54.6701 366.609 54.5501 366.549 54.4201C366.479 54.2001 366.449 53.9601 366.479 53.7201V53.5501C366.459 53.3001 366.509 53.0501 366.629 52.8301C366.769 52.6501 366.979 52.5401 367.199 52.5101H367.239C367.259 52.4301 367.269 52.3501 367.269 52.2701C367.269 52.1001 367.309 51.9301 367.409 51.7901C367.329 51.6801 367.269 51.5801 367.229 51.4601C367.209 51.3801 367.199 51.3001 367.199 51.2201C366.769 51.1101 366.529 51.0201 366.469 50.7301C366.439 50.5701 366.499 50.4101 366.619 50.3001C366.619 50.2801 366.619 50.2601 366.629 50.2401C366.649 50.1201 366.689 50.0001 366.749 49.9001C366.809 49.8101 366.839 49.7001 366.849 49.6001C366.889 49.4001 367.009 49.2101 367.179 49.0901C367.149 49.0601 367.119 49.0201 367.089 48.9801C367.069 49.0001 367.039 49.0101 367.019 49.0201C366.959 49.0501 366.909 49.0901 366.859 49.1301C366.789 49.1901 366.709 49.2501 366.619 49.2901C366.509 49.3401 366.379 49.3401 366.269 49.2901C366.159 49.2501 366.069 49.1601 366.019 49.0501C365.959 48.8801 365.959 48.6901 366.019 48.5201C366.019 48.4901 366.029 48.4701 366.039 48.4501C366.049 48.2301 366.139 48.0201 366.299 47.8601C366.429 47.7501 366.609 47.7201 366.769 47.7701C366.819 47.7901 366.869 47.8201 366.909 47.8501C366.879 47.8001 366.859 47.7501 366.839 47.6901C366.789 47.5301 366.769 47.3601 366.769 47.1901C366.769 47.1401 366.769 47.0901 366.769 47.0401C366.769 47.0201 366.769 47.0101 366.769 47.0001C366.719 46.9401 366.669 46.8701 366.639 46.8001L366.619 46.7701C366.619 46.7701 366.589 46.7101 366.579 46.6701C366.519 46.5001 366.579 46.3101 366.709 46.1901C366.729 46.1501 366.749 46.1101 366.789 46.0701C366.789 46.0701 366.809 46.0501 366.819 46.0401C366.859 45.9801 366.899 45.9301 366.949 45.8801C366.969 45.8601 366.979 45.8501 366.989 45.8301C367.029 45.6901 367.099 45.5501 367.189 45.4401C367.189 45.4301 367.209 45.4101 367.219 45.4001C367.209 45.3801 367.189 45.3601 367.179 45.3501C367.089 45.2401 367.029 45.1101 366.989 44.9801C366.959 44.8501 366.949 44.7201 366.959 44.5901C366.959 44.5701 366.959 44.5401 366.959 44.5101C366.919 44.4801 366.869 44.4501 366.819 44.4101C366.769 44.3801 366.729 44.3401 366.699 44.3301C366.499 44.2101 366.429 43.9601 366.529 43.7501C366.619 43.5601 366.819 43.4601 367.029 43.5101V43.4601C367.069 43.3401 367.089 43.2201 367.089 43.0901V42.9801C367.019 42.8301 367.029 42.6601 367.129 42.5201C367.149 42.4901 367.179 42.4601 367.199 42.4401C367.179 42.3901 367.169 42.3501 367.159 42.3101C367.159 42.2701 367.139 42.2401 367.129 42.2001C367.039 42.0001 366.979 41.7901 366.949 41.5801C366.929 41.4701 366.919 41.3501 366.919 41.2401C366.919 41.1701 366.919 41.1001 366.909 41.0401C366.899 40.9801 366.879 40.9201 366.859 40.8601C366.789 40.6601 366.759 40.4401 366.799 40.2301C366.809 40.1601 366.819 40.0901 366.819 40.0201C366.819 39.8401 366.859 39.6601 366.919 39.4901C366.939 39.4301 366.969 39.3801 367.009 39.3301C366.889 38.9901 367.169 38.7001 367.299 38.5601L367.369 38.4901C367.259 38.2501 367.279 37.9601 367.409 37.7301C367.499 37.6101 367.639 37.5501 367.779 37.5601C367.799 37.5301 367.819 37.4901 367.839 37.4601C367.879 37.1801 368.069 36.9501 368.329 36.8601C368.369 36.8301 368.409 36.8001 368.449 36.7601C368.519 36.6801 368.599 36.6201 368.689 36.5601C368.739 36.5301 368.789 36.5101 368.839 36.4901C368.799 36.4101 368.779 36.3301 368.769 36.2401C368.759 36.1701 368.739 36.1101 368.709 36.0501V36.0101C368.609 36.0101 368.529 36.0101 368.449 35.9601C368.429 35.9601 368.419 35.9401 368.399 35.9301C368.369 36.0201 368.299 36.1001 368.219 36.1501C368.149 36.2201 368.059 36.2801 367.969 36.3201C367.849 36.3701 367.709 36.3601 367.599 36.2901C367.489 36.2201 367.399 36.1201 367.379 35.9901C367.339 35.7901 367.419 35.5901 367.589 35.4901C367.619 35.3301 367.719 35.1801 367.869 35.1101C367.929 35.0801 367.999 35.0701 368.059 35.0701C368.089 35.0001 368.129 34.9401 368.189 34.9001C368.219 34.8701 368.259 34.8401 368.299 34.8101C368.369 34.7601 368.439 34.7401 368.529 34.7301V34.6901C368.529 34.6901 368.509 34.6401 368.509 34.6101C368.459 34.5801 368.419 34.5601 368.369 34.5301C368.299 34.5001 368.239 34.4401 368.189 34.3801C368.019 34.3701 367.849 34.2901 367.739 34.1601C367.699 34.1201 367.659 34.0701 367.619 34.0401C367.589 34.0101 367.559 33.9801 367.529 33.9501L367.289 34.0401C367.169 34.0901 367.039 34.0801 366.919 34.0201C366.809 33.9601 366.719 33.8601 366.689 33.7301V33.7101C366.569 33.6801 366.479 33.6201 366.399 33.5301C366.289 33.4101 366.259 33.2401 366.309 33.0901C366.349 32.9601 366.449 32.8501 366.579 32.8201C366.639 32.7701 366.719 32.7401 366.799 32.7201C366.709 32.5701 366.669 32.3901 366.679 32.2201C366.519 32.2201 366.359 32.1801 366.229 32.0901C365.799 31.7701 366.069 31.2301 366.189 30.9901C366.209 30.9501 366.229 30.9201 366.239 30.8801L367.109 31.1101C367.089 31.1901 367.059 31.2701 367.019 31.3501C367.189 31.3801 367.339 31.4701 367.449 31.6101C367.559 31.7801 367.609 31.9701 367.579 32.1701C367.579 32.2001 367.579 32.2301 367.579 32.2601C367.609 32.3101 367.649 32.3601 367.689 32.4101C367.759 32.5001 367.819 32.5801 367.879 32.6701C367.949 32.7901 367.999 32.9201 368.029 33.0601C368.029 33.1001 368.049 33.1501 368.069 33.1901C368.119 33.2601 368.179 33.3201 368.239 33.3701C368.269 33.4001 368.309 33.4401 368.339 33.4701H368.399C368.589 33.4301 368.779 33.4601 368.949 33.5501C369.059 33.6201 369.129 33.7301 369.149 33.8601C369.149 33.8801 369.149 33.9001 369.149 33.9201C369.249 33.9701 369.329 34.0401 369.409 34.1301C369.519 34.2801 369.529 34.4901 369.419 34.6501C369.439 34.7401 369.449 34.8301 369.469 34.9201C369.479 35.0501 369.489 35.1801 369.469 35.3101C369.469 35.3901 369.469 35.4701 369.469 35.5501C369.489 35.6201 369.509 35.6801 369.529 35.7301C369.579 35.8501 369.619 35.9801 369.639 36.1101C369.659 36.1501 369.679 36.1801 369.699 36.2201C369.839 36.4001 369.889 36.6401 369.819 36.8701C369.709 37.1101 369.479 37.2801 369.219 37.3101C369.189 37.3101 369.149 37.3301 369.119 37.3401C369.099 37.3601 369.079 37.3801 369.059 37.4001C368.959 37.5101 368.839 37.6001 368.699 37.6601C368.699 37.6901 368.689 37.7101 368.679 37.7401C368.809 37.8201 368.889 37.9601 368.899 38.1101C368.899 38.2801 368.829 38.4501 368.679 38.5501C368.559 38.7501 368.379 38.9101 368.159 39.0001C368.209 39.1001 368.229 39.2101 368.219 39.3201C368.189 39.5201 368.039 39.6701 367.839 39.7001C367.839 39.7001 367.769 39.7801 367.739 39.8301C367.719 39.9201 367.699 40.0001 367.699 40.0901C367.699 40.2001 367.679 40.3101 367.659 40.4201C367.669 40.4801 367.689 40.5501 367.709 40.6101C367.739 40.7101 367.759 40.8101 367.779 40.9101C367.789 41.0201 367.799 41.1201 367.799 41.2301C367.799 41.3001 367.799 41.3701 367.809 41.4301C367.829 41.5701 367.869 41.7001 367.919 41.8301C367.959 41.9101 367.979 41.9901 368.009 42.0801C368.019 42.1301 368.039 42.1801 368.059 42.2301C368.269 42.4101 368.499 42.6201 368.349 42.9401C368.279 43.1001 368.129 43.2001 367.959 43.2101C367.959 43.3701 367.929 43.5301 367.889 43.6901V43.7401C368.089 43.8001 368.259 43.9401 368.369 44.1301C368.419 44.2501 368.419 44.3901 368.369 44.5201C368.299 44.7101 368.129 44.8401 367.929 44.8801H367.909C368.029 45.0301 368.099 45.2101 368.119 45.4001C368.119 45.6201 368.039 45.8301 367.899 45.9901C367.869 46.0201 367.849 46.0601 367.829 46.0901C367.799 46.2301 367.719 46.3701 367.619 46.4801C367.639 46.5901 367.649 46.7001 367.649 46.8201C367.649 46.8701 367.649 46.9301 367.649 46.9901C367.649 47.0501 367.649 47.1201 367.659 47.1901C367.659 47.2701 367.659 47.3501 367.679 47.4201C367.709 47.4401 367.749 47.4801 367.779 47.5001C367.869 47.5601 367.949 47.6301 368.019 47.7001C368.139 47.8301 368.169 48.0201 368.109 48.1801C368.059 48.2901 367.999 48.3901 367.919 48.4901C367.899 48.5101 367.889 48.5401 367.869 48.5601L367.889 48.5801C368.039 48.7301 368.129 48.9301 368.139 49.1501C368.119 49.4001 367.989 49.6301 367.789 49.7701C367.769 49.7901 367.739 49.8101 367.719 49.8301C367.689 50.0301 367.619 50.2201 367.519 50.3901C367.519 50.4001 367.519 50.4101 367.519 50.4201H367.549C367.549 50.4201 367.639 50.4501 367.689 50.4701C367.969 50.6101 368.129 50.9101 368.109 51.2201C368.109 51.2401 368.129 51.2601 368.149 51.2901C368.319 51.4801 368.399 51.7401 368.339 51.9901C368.309 52.0901 368.269 52.1801 368.219 52.2701C368.219 52.2901 368.199 52.3001 368.199 52.3101C368.199 52.5901 368.139 52.8701 367.989 53.1101C367.849 53.2901 367.649 53.4001 367.419 53.4201H367.399C367.399 53.4201 367.399 53.5201 367.399 53.5501C367.399 53.6001 367.399 53.6501 367.399 53.6901V53.8101C367.379 53.9101 367.379 54.0201 367.399 54.1201C367.429 54.1701 367.459 54.2101 367.489 54.2501C367.579 54.3601 367.659 54.4901 367.719 54.6201C367.799 54.8301 367.869 55.0401 367.909 55.2601C368.009 55.5701 367.969 55.9101 367.799 56.1901C367.589 56.4501 367.269 56.6101 366.939 56.6201C366.729 56.6201 366.529 56.5301 366.379 56.3801C366.359 56.3601 366.329 56.3401 366.309 56.3201C366.249 56.3201 366.179 56.3201 366.119 56.3201C366.039 56.3201 365.959 56.3201 365.879 56.3201C365.859 56.3301 365.839 56.3501 365.819 56.3701C365.679 56.4901 365.499 56.5701 365.319 56.5901C365.169 56.5901 365.029 56.5601 364.899 56.5001C364.779 56.7001 364.559 56.8301 364.329 56.8501L364.319 56.8101ZM366.739 37.8901C366.539 37.8901 366.369 37.7601 366.309 37.5701L366.289 37.5201C366.079 37.1301 366.229 36.9201 366.379 36.8201C366.629 36.7201 366.909 36.7601 367.119 36.9301C367.199 36.9801 367.259 37.0601 367.299 37.1401C367.349 37.2601 367.349 37.4001 367.299 37.5301C367.249 37.6401 367.149 37.7301 367.029 37.7701C366.949 37.8401 366.839 37.8801 366.729 37.8801L366.739 37.8901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.21 53.0101C346.13 53.0001 346.06 52.9901 345.98 52.9801C346.06 52.7801 346.149 52.5801 346.239 52.3801C346.329 52.1801 346.22 51.9201 346.28 51.7201C346.31 51.5301 346.31 51.3501 346.28 51.1601C346.28 50.9701 346.489 50.7801 346.749 50.6401C346.879 50.5701 346.85 50.2401 346.98 50.1601C347.12 50.0801 347.329 50.1901 347.489 50.1401C347.649 50.0901 347.83 49.9501 347.98 49.8901C347.96 49.8301 347.77 49.4301 347.77 49.4301C347.52 49.5101 347.45 49.5701 347.29 49.4501C347.12 49.3301 346.849 49.3701 346.679 49.2601C346.589 49.2001 346.55 49.0701 346.48 49.0001C346.4 48.9301 346.199 48.6801 346.239 48.6401C346.429 48.4301 347.039 48.2601 347.009 48.1501C346.959 47.9901 346.699 47.9001 346.629 47.7301C346.559 47.5701 346.709 47.3101 346.629 47.1501C346.539 47.0001 346.26 46.9801 346.15 46.8401C346.01 46.6701 345.899 46.4701 345.829 46.2601C345.769 46.0601 345.989 45.8301 346.009 45.6201C345.999 45.2201 346.239 44.8601 346.609 44.7301C346.779 44.6401 346.689 44.4601 346.859 44.3601C346.659 44.2901 346.639 44.2501 346.439 44.1801C346.439 44.2401 346.459 44.2901 346.489 44.3401C346.699 44.2701 346.91 44.1801 347.1 44.0701C347.3 43.9501 347.439 43.7601 347.489 43.5401C347.699 43.4901 347.649 43.2801 347.859 43.2201C347.759 43.1201 347.65 43.0301 347.52 42.9701C347.26 42.8701 346.98 42.7901 346.71 42.7401C346.87 42.9501 347.07 43.1401 347.23 43.3501C346.98 43.3101 346.819 43.4701 346.609 43.3701C346.409 43.2701 346.48 42.9101 346.4 42.6301C346.4 42.6201 346.179 42.7201 346.189 42.7101C346.279 42.5401 346.23 42.2701 346.34 42.1101C346.47 41.9201 346.709 41.8501 346.699 41.6901C346.679 41.5301 346.539 41.4601 346.309 41.3301C346.179 41.2301 346.06 41.1101 345.96 40.9801C345.74 40.7201 345.549 40.4101 345.629 40.3301C345.689 40.2601 346.05 40.5201 346.35 40.4601C346.48 40.4301 346.619 40.0201 346.749 39.9601C346.869 40.1301 346.909 40.4601 347.059 40.5501C347.229 40.6501 347.41 40.7401 347.6 40.7901C347.78 40.8401 348.02 40.6501 348.21 40.6901C348.27 40.7001 348.259 40.7301 348.299 40.6901C348.329 40.6501 348.38 40.6201 348.35 40.6101C348.17 40.5301 347.9 40.5501 347.73 40.4401C347.55 40.3301 347.509 39.9501 347.309 39.9201C347.129 39.8901 346.969 40.1601 346.759 40.2901C346.719 40.2401 346.599 40.0301 346.559 39.9801C346.729 39.8401 346.999 39.7101 347.009 39.5401C346.999 39.3301 346.96 39.1301 346.9 38.9301C346.9 38.9101 346.75 38.8601 346.77 38.8601C346.92 38.8601 346.88 38.8701 347.03 38.8601C346.95 38.7601 346.879 38.8601 346.829 38.7401C346.729 38.5601 346.889 38.2401 346.799 38.0601C346.709 37.8801 346.719 37.6401 346.629 37.4501C346.539 37.2601 346.36 37.1201 346.28 36.9301C346.26 36.9001 346.51 36.5501 346.6 36.5801C346.8 36.6501 346.999 36.8601 347.129 36.7701C347.259 36.6701 347.219 36.3601 347.369 36.3101C347.319 36.1801 347.169 36.1301 347.119 36.0101C347.119 35.9901 347.179 35.9001 347.189 35.8901C347.259 35.7701 347.339 35.6501 347.429 35.5401C347.569 35.3701 347.88 35.3501 348.03 35.1801C348.18 35.0101 348.189 34.7601 348.329 34.5901C348.269 34.5501 348.109 34.7201 347.829 34.8101C347.639 34.8701 347.4 34.8201 347.21 34.9001C347.03 34.9901 346.86 35.1201 346.73 35.2701C346.64 35.3501 346.549 35.2001 346.449 35.2701C346.419 35.1601 346.37 35.2101 346.4 35.1101C346.44 34.9401 346.269 34.7001 346.319 34.5301C346.369 34.3601 346.749 34.2501 346.799 34.0801C346.799 34.0601 346.52 34.0401 346.54 34.0301C346.68 33.9401 347.039 33.9101 347.169 33.8201C347.039 33.7401 346.68 33.7201 346.54 33.6401C346.61 33.6701 346.69 33.6801 346.77 33.6901C346.85 33.4701 346.789 33.1601 346.939 32.9801C347.079 32.8301 347.149 32.6101 347.129 32.4001C347.129 32.3701 347.339 32.3401 347.359 32.3601C347.379 32.3901 347.37 32.2401 347.34 32.2401C347.14 32.1501 346.94 32.2401 346.77 32.1001C346.62 31.9601 346.489 31.7901 346.389 31.6101C346.579 31.4701 346.38 31.4001 346.28 31.2201C346.19 31.0501 346.279 30.8701 346.619 30.7901C346.629 30.8201 346.789 30.7301 346.809 30.7501C346.819 30.7601 346.849 30.7501 346.879 30.7501C346.839 30.7201 346.839 30.7901 346.799 30.7501C346.819 30.6001 346.419 30.4201 346.449 30.2701C346.509 30.0301 346.759 29.9101 346.809 29.7901C346.899 29.6001 347.009 29.7001 347.259 29.7101C347.399 29.7101 347.589 29.5501 347.829 29.5701C347.829 29.6501 347.9 29.7501 347.9 29.8301C347.9 29.9801 347.9 29.9501 347.9 30.1001C348 30.0101 347.979 30.0601 348.079 29.9701C348.139 29.9201 348.22 29.9501 348.27 29.9001C348.32 29.9501 348.41 29.9001 348.46 29.9401C348.47 29.9501 348.43 30.0301 348.46 30.0201C348.38 29.9801 348.29 29.9901 348.21 29.9501C348.05 29.8701 347.839 29.8201 347.679 29.7401C347.589 29.5901 347.779 29.2201 347.679 29.0701C347.589 28.9201 347.36 28.8501 347.27 28.6901C347.18 28.5301 347.07 28.4001 346.98 28.2401C346.92 28.1201 346.869 27.8501 346.919 27.8201C347.109 27.7001 347.379 27.7201 347.579 27.6101C347.779 27.5001 347.9 27.2601 348.1 27.1601C348.3 27.0601 348.46 26.8601 348.66 26.7701C348.78 26.7101 349.129 26.8301 349.299 26.8901C349.299 26.9201 349.129 27.1501 349.139 27.1701C349.139 27.1901 349.46 27.0501 349.48 27.0601C349.45 27.0201 349.37 27.1201 349.34 27.0901C349.45 26.8701 349.239 26.4801 349.389 26.2901C349.569 26.0901 349.78 25.9201 350.02 25.7901C350.11 25.7301 350.499 25.9001 350.499 25.9201C350.519 26.1701 350.389 26.4801 350.499 26.6601C350.609 26.8601 351.04 26.8001 351.22 26.9501C351.38 27.1001 351.559 27.2301 351.739 27.3501C351.939 27.5201 352.06 27.7701 352.04 28.0401C352.05 28.2701 351.909 28.5301 351.939 28.7501C351.939 28.7701 352.05 28.7101 352.03 28.7101C351.83 28.7901 351.639 28.8601 351.569 29.0001C351.499 29.1901 351.49 29.3901 351.53 29.5801C351.72 29.5301 351.859 29.5801 352.059 29.5301C352.129 29.5101 352.129 29.2601 352.199 29.2301C352.199 29.2301 352.239 29.3901 352.239 29.4101C352.299 29.6301 352.46 29.8201 352.52 30.0301C352.58 30.2501 352.419 30.5101 352.449 30.7401C352.469 30.9201 352.559 31.0501 352.449 31.1501C352.349 31.2401 352.179 31.2001 352.009 31.2201C351.899 31.2301 351.95 31.4301 351.84 31.4901C351.94 31.5201 351.82 31.6901 351.9 31.7501C352.01 31.8201 352.29 31.8001 352.27 31.8301C352.17 32.0301 352.24 32.2601 352.21 32.4501C352.18 32.6601 351.849 32.8901 351.879 33.1001C351.949 33.3101 352.04 33.5201 352.15 33.7201C352.23 33.9101 352.56 33.9901 352.66 34.1801C352.69 34.2401 352.599 34.4101 352.579 34.4801C352.519 34.6601 352.68 34.8701 352.65 35.0601C352.62 35.2501 352.46 35.4101 352.46 35.5901C352.46 35.7801 352.359 35.9701 352.359 36.1501C352.359 36.3301 352.449 36.5301 352.449 36.7101C352.449 36.9001 352.389 37.0901 352.379 37.2801C352.379 37.4701 352.159 37.6201 352.129 37.8101C352.099 37.9901 352.239 38.2801 352.059 38.4101C351.909 38.5101 351.61 38.3701 351.41 38.4301C351.16 38.5501 350.929 38.7301 350.749 38.9501C350.659 39.1401 350.589 39.3401 350.559 39.5501C350.769 39.5501 350.979 39.5501 351.179 39.5201C351.259 39.5001 351.4 39.0701 351.47 39.0101C351.46 39.1801 351.42 39.3501 351.35 39.5101C351.21 39.7201 351.06 39.9301 350.9 40.1201C350.9 40.1301 350.959 39.9901 350.949 40.0001C350.749 40.0601 350.58 40.1901 350.46 40.3601C350.38 40.5801 350.419 40.8201 350.559 41.0101C350.679 41.1501 350.81 41.1801 350.85 41.3401C350.89 41.4801 351.08 41.6201 350.91 41.8001C350.83 41.8801 350.709 42.2901 350.759 42.3101C350.959 42.3601 351.169 42.3401 351.359 42.2601C351.519 42.2001 351.509 41.7401 351.679 41.6601C351.779 41.6101 351.82 41.3401 351.96 41.7901C352.03 42.0101 352.52 41.9001 352.23 42.2701C352.13 42.3901 352.3 42.7101 352.21 42.8401C352.12 42.9701 351.819 42.9601 351.749 43.1001C351.669 43.2601 351.689 43.3301 351.949 43.6201C352.059 43.7401 351.879 44.0201 351.799 44.2001C351.749 44.3601 351.609 44.4801 351.449 44.5101C351.259 44.5601 350.959 44.5501 350.859 44.6601C350.759 44.8501 350.73 45.0801 350.78 45.2901C350.8 45.4401 350.999 45.5601 351.129 45.7101C351.269 45.9301 351.439 46.1301 351.619 46.3201C351.779 46.4501 351.909 46.5501 351.939 46.6801C351.969 46.7901 351.819 46.8501 351.679 47.0501C351.579 47.2401 351.559 47.4601 351.629 47.6601C351.679 47.8101 352.01 47.9001 352.02 48.0701C352.03 48.2201 351.819 48.3201 351.699 48.4801C351.619 48.6001 351.869 48.8801 351.889 49.1301C351.909 49.3301 351.659 49.4901 351.569 49.6701C351.549 49.7101 351.989 49.8101 352.069 49.9101C352.159 50.0401 352.21 50.1801 352.22 50.3401C352.13 50.4601 352.19 50.6501 352.16 50.8901C352.12 51.0801 352.089 51.2701 352.069 51.4601C352.069 51.6501 352.119 51.8401 352.129 52.0401C352.129 52.2301 351.989 52.4401 351.999 52.6301C351.999 52.8301 352.189 53.0301 352.179 53.2201C352.179 53.4301 351.93 53.6201 351.91 53.8001C351.87 53.9801 351.78 54.1401 351.66 54.2601C351.56 54.4201 351.83 54.8201 351.73 54.9601C351.55 55.1001 351.32 55.1701 351.09 55.1401C350.82 55.1401 350.639 55.2901 350.749 55.5801C350.809 55.7201 350.979 55.8301 351.009 55.9801C350.959 55.7901 351.17 55.5001 350.77 55.6101C350.66 55.6401 350.549 55.8501 350.319 55.9301C350.039 56.0201 349.64 55.5201 349.41 55.6901C349.27 55.8001 349.439 55.2601 349.359 55.4501C349.569 55.4201 349.469 55.7601 349.689 55.7201C349.779 55.9101 349.69 55.8101 349.65 56.0201C349.65 55.7301 349.819 55.6101 349.749 55.5501C349.639 55.4501 349.549 55.6901 349.369 55.8201C349.219 55.9001 349.029 55.8901 348.889 55.7901C348.709 55.7001 348.529 55.9801 348.359 56.0401C348.189 56.1001 348 56.1101 347.84 56.1601C347.64 56.2401 347.41 56.2401 347.22 56.1501C347.14 56.0901 347.38 55.7401 347.46 55.6201C347.59 55.4401 347.61 55.2101 347.53 55.0001C347.37 54.8501 347.139 54.8001 346.939 54.8801C346.819 54.9001 346.699 54.8701 346.609 54.8001C346.719 54.7201 346.859 54.6901 346.919 54.5801C346.979 54.4801 346.99 54.3601 346.97 54.2401C346.76 54.1601 346.609 53.9801 346.569 53.7501C346.569 53.5701 346.919 53.3701 346.919 53.1801C346.859 52.9301 346.779 52.6901 346.689 52.4501C346.519 52.5901 346.429 52.9801 346.259 53.1301C346.279 53.0701 346.289 53.0101 346.299 52.9501L346.21 53.0101ZM349.179 39.1001C349.179 39.1001 349.359 39.0801 349.329 39.1001C349.299 39.1301 349.289 39.0701 349.249 39.0401C349.229 39.0201 349.079 38.8601 349.069 38.8401C349.089 38.8401 349.149 39.0801 349.179 39.0901V39.1001ZM347.679 28.8501C347.759 28.8501 347.9 28.7301 347.97 28.7301C348.05 28.7301 348.14 28.7401 348.22 28.7501C348.14 29.0201 348.3 29.0401 348.41 29.1501C348.52 29.2601 348.599 29.2801 348.819 29.3101C349.289 29.3701 349.139 29.2201 349.259 28.9501C349.379 28.6701 349.469 28.4901 349.429 28.4101C349.269 28.2401 349.019 28.2001 348.819 28.3001C348.679 28.3501 348.649 28.4101 348.499 28.4201C348.229 28.1401 347.989 28.1501 347.809 28.6601C347.719 28.6601 347.829 28.6801 347.739 28.6901C347.669 28.6001 347.429 28.6901 347.359 28.6101C347.339 28.5901 347.49 28.5101 347.47 28.4901C347.49 28.5001 347.57 28.3801 347.59 28.3901C347.67 28.4701 347.589 28.7601 347.669 28.8501H347.679ZM348.53 51.5801C348.53 51.5801 348.34 51.6201 348.29 51.5901C348.35 51.6101 348.41 51.6301 348.47 51.6401C348.55 51.7301 348.809 51.7601 348.879 51.8501C348.829 51.9401 348.8 52.0401 348.77 52.1401C348.75 52.2701 348.579 52.3701 348.569 52.5001C348.699 52.4001 348.84 52.3101 348.98 52.2001C348.88 52.1001 348.909 51.8701 348.809 51.7801C348.729 51.7001 348.6 51.6501 348.53 51.5701V51.5801ZM349.449 50.3801C349.559 50.3701 349.62 50.2301 349.73 50.2201C349.7 50.1701 349.68 50.1401 349.66 50.0901C349.58 50.1601 349.639 50.3601 349.559 50.4301C349.519 50.4701 349.219 50.4901 349.179 50.5301C349.209 50.4801 349.419 50.4301 349.449 50.3701V50.3801ZM348.15 42.1101C348.24 42.0701 348.24 41.9401 348.34 41.9001C348.25 41.9501 348.169 42.0101 348.079 42.0601C348.019 42.1501 348.119 42.3301 348.069 42.4201C348.069 42.4201 347.779 42.2801 347.799 42.3101C347.829 42.1901 348.12 42.2301 348.15 42.1201V42.1101ZM348.629 32.1501C348.629 32.1501 348.579 32.2401 348.609 32.2101C348.629 32.1901 348.659 32.2201 348.669 32.2501C348.769 32.4601 348.93 32.4801 349.03 32.6801C349.12 32.5401 349.079 32.5901 349.059 32.4701C348.999 32.0601 348.869 32.0501 348.629 32.1501ZM350.919 43.4401C350.769 43.2301 350.549 43.1201 350.449 42.9901C350.379 43.1201 350.249 43.2401 350.249 43.3701C350.249 43.4701 350.449 43.4401 350.559 43.4901C350.679 43.5301 350.809 43.5101 350.919 43.4401ZM349.02 33.6301C348.84 33.5601 348.569 33.4601 348.429 33.4001C348.259 33.3301 348.11 33.2801 347.96 33.2301C347.94 33.2301 348 33.2301 347.96 33.3001C348.15 33.4001 348.349 33.4801 348.549 33.5601C348.689 33.6501 348.86 33.6701 349.02 33.6201V33.6301ZM348.799 53.4301C348.639 53.5701 348.519 53.7601 348.449 53.9601C348.509 54.1101 348.609 54.2501 348.739 54.3501C348.789 54.3801 348.869 54.2101 348.859 54.1401C348.879 53.9001 348.859 53.6601 348.799 53.4301ZM347.919 50.9701C347.839 50.8301 347.76 50.7001 347.66 50.5801C347.54 50.6701 347.419 50.7601 347.299 50.8401C347.179 50.9201 347.22 51.1101 347.1 51.2001C347.14 51.2501 346.96 51.0801 346.98 51.0801C347.24 50.9701 347.669 51.0801 347.919 50.9601V50.9701ZM349.679 49.5801C349.499 49.4401 349.31 49.2701 349.23 49.2701C349.09 49.2701 348.959 49.3101 348.829 49.3601C348.869 49.4401 348.91 49.3901 348.96 49.3901C349.13 49.3901 349.399 49.6201 349.679 49.5901V49.5801ZM347.72 37.7801C347.63 37.9001 347.6 38.1201 347.54 38.2101C347.61 38.2401 347.67 38.3101 347.73 38.2901C347.82 38.2701 347.69 38.1801 347.77 38.1201C347.7 38.0501 347.81 37.8701 347.72 37.7801ZM352.02 33.9901C351.92 33.9001 351.799 33.8201 351.679 33.7601C351.639 33.7401 351.559 33.7801 351.499 33.8001C351.569 33.9001 351.779 33.8801 351.859 33.9801C351.899 34.0201 351.959 34.0301 352.009 34.0001L352.02 33.9901ZM351.329 28.7201C351.269 28.6201 351.199 28.5401 351.109 28.4701C350.999 28.4901 350.89 28.5201 350.79 28.5501C350.83 28.6201 350.889 28.5501 350.939 28.5501C351.029 28.5501 351.23 28.7501 351.34 28.7101L351.329 28.7201ZM347.4 47.4601C347.34 47.3801 347.259 47.3201 347.169 47.2701C347.119 47.2501 347.04 47.3001 346.97 47.3101C347.03 47.3901 347.16 47.3001 347.21 47.3801C347.26 47.3401 347.35 47.4901 347.4 47.4501V47.4601ZM351.46 54.2801C351.4 54.2801 351.27 54.3701 351.22 54.3601C351.24 54.3801 351.269 54.4001 351.299 54.4001C351.329 54.4001 351.44 54.2801 351.47 54.2701L351.46 54.2801ZM351.139 46.2801C351.109 46.3301 351.139 46.5001 351.119 46.5601C351.119 46.5701 351.159 46.6001 351.179 46.6201C351.209 46.5601 351.06 46.4501 351.09 46.3901C351.09 46.3801 351.169 46.3001 351.139 46.2801ZM347.809 48.7101C347.809 48.7101 347.72 48.5701 347.73 48.5301C347.69 48.5301 347.649 48.5501 347.609 48.5501C347.619 48.5801 347.779 48.5001 347.799 48.5201C347.799 48.5201 347.799 48.7101 347.819 48.7001L347.809 48.7101ZM349.71 43.0901C349.71 43.0901 349.75 42.9301 349.78 42.9101C349.76 42.8901 349.73 42.8501 349.72 42.8501C349.68 42.8701 349.839 42.9301 349.809 42.9501C349.839 42.9601 349.69 43.0701 349.72 43.0801L349.71 43.0901ZM349.429 45.4901C349.429 45.4201 349.409 45.3501 349.389 45.2801C349.389 45.2701 349.349 45.2601 349.319 45.2501C349.309 45.2801 349.489 45.3001 349.489 45.3301C349.489 45.3401 349.409 45.4801 349.429 45.4901ZM349.16 35.9401C349.16 35.9401 349.23 35.7901 349.22 35.7401C349.22 35.7101 349.189 35.7101 349.179 35.7301C349.119 35.8201 349.12 35.9301 349.16 35.9401ZM349.179 34.0901C349.229 34.0901 349.259 33.9201 349.249 33.8701C349.249 33.8401 349.209 33.8301 349.189 33.8601C349.129 33.9601 349.129 34.0801 349.189 34.0901H349.179ZM348.03 55.0301C348.1 55.0001 348.2 54.8601 348.27 54.8301C348.25 54.8001 348.24 54.7601 348.22 54.7601C348.16 54.7501 348.229 54.8801 348.169 54.8801C348.179 54.9301 348.01 54.9801 348.03 55.0301ZM347.319 53.5101C347.319 53.5101 347.17 53.4401 347.15 53.4101C347.13 53.4401 347.11 53.4601 347.1 53.4901C347.1 53.5201 347.14 53.3601 347.15 53.3901C347.17 53.3601 347.289 53.5401 347.309 53.5201L347.319 53.5101ZM351.119 50.4101C351.119 50.4101 350.939 50.3501 350.919 50.3201C350.889 50.3401 350.85 50.3601 350.85 50.3901C350.85 50.4201 350.899 50.2501 350.919 50.2701C350.949 50.2501 351.089 50.4301 351.119 50.4101ZM347.84 55.5601C347.84 55.5601 347.77 55.7201 347.78 55.7501C347.79 55.7801 347.83 55.7901 347.84 55.7501C347.89 55.6501 347.87 55.5501 347.84 55.5501V55.5601ZM349.1 50.8201C349.1 50.8201 349.25 50.8901 349.29 50.8701C349.32 50.8601 349.33 50.8301 349.29 50.8101C349.2 50.7601 349.1 50.7701 349.09 50.8101L349.1 50.8201ZM350.639 29.9901C350.639 29.9901 350.709 29.8401 350.699 29.8001C350.689 29.7701 350.659 29.7601 350.639 29.8001C350.589 29.8901 350.609 30.0001 350.639 30.0001V29.9901ZM351.419 43.3401C351.419 43.3401 351.25 43.3201 351.23 43.3001L351.16 43.3601C351.16 43.3601 351.229 43.2101 351.259 43.2401C351.269 43.2201 351.4 43.3701 351.41 43.3401H351.419ZM350.1 41.7901C350.1 41.7901 350.03 41.9401 350.04 41.9701C350.04 42.0001 350.08 42.0101 350.09 41.9701C350.14 41.8801 350.13 41.7901 350.09 41.7801L350.1 41.7901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M347.409 56.73C347.219 56.73 347.039 56.6801 346.879 56.5701C346.449 56.2601 346.789 55.74 346.999 55.43C347.009 55.41 347.029 55.38 347.029 55.36C347.009 55.36 346.989 55.36 346.969 55.37C346.739 55.42 346.499 55.37 346.299 55.24C346.169 55.16 346.079 55.03 346.069 54.87C346.069 54.72 346.129 54.57 346.259 54.48C346.279 54.47 346.299 54.4501 346.319 54.4401C346.139 54.2801 346.039 54.05 346.029 53.8C346.029 53.74 346.039 53.68 346.059 53.62C345.969 53.6 345.879 53.54 345.819 53.47C345.789 53.43 345.769 53.4 345.749 53.35C345.689 53.32 345.639 53.27 345.599 53.22C345.519 53.1 345.499 52.94 345.559 52.81C345.619 52.67 345.679 52.53 345.739 52.39L345.819 52.2001C345.819 52.2001 345.819 52.11 345.819 52.05C345.799 51.89 345.819 51.73 345.849 51.58C345.859 51.51 345.859 51.4501 345.849 51.3801C345.849 51.3101 345.839 51.23 345.829 51.15C345.859 50.78 346.089 50.45 346.419 50.29V50.27C346.459 50.06 346.569 49.8701 346.749 49.7601C346.639 49.7401 346.529 49.7 346.429 49.64C346.319 49.56 346.219 49.46 346.159 49.34C345.969 49.15 345.559 48.69 345.889 48.33C345.999 48.22 346.139 48.12 346.279 48.05C346.239 48 346.209 47.95 346.189 47.89C346.129 47.73 346.119 47.5501 346.159 47.3801C346.009 47.3301 345.879 47.24 345.779 47.12C345.599 46.9 345.469 46.65 345.379 46.39C345.319 46.15 345.359 45.89 345.489 45.67C345.509 45.63 345.529 45.59 345.539 45.55C345.549 45.29 345.629 45.0401 345.769 44.8201C345.849 44.7101 345.939 44.61 346.049 44.53C345.939 44.35 345.939 44.1301 346.029 43.9401C346.089 43.8401 346.199 43.77 346.309 43.74C346.109 43.6 345.989 43.3701 345.979 43.1301C345.859 43.0801 345.769 42.98 345.729 42.86C345.689 42.74 345.699 42.6 345.759 42.49C345.759 42.49 345.759 42.4201 345.769 42.3801C345.769 42.2001 345.829 42.02 345.919 41.86C345.949 41.81 345.989 41.76 346.029 41.72C345.869 41.62 345.739 41.49 345.629 41.34L345.569 41.27C345.099 40.73 344.989 40.32 345.229 40.03C345.419 39.85 345.709 39.8101 345.929 39.9401C345.959 39.9501 345.999 39.97 346.039 39.98C346.029 39.84 346.079 39.71 346.189 39.62C346.249 39.57 346.309 39.52 346.379 39.48C346.409 39.46 346.449 39.43 346.479 39.41C346.469 39.34 346.449 39.2501 346.429 39.1901C346.299 39.0701 346.239 38.89 346.269 38.72C346.269 38.71 346.269 38.69 346.279 38.68C346.279 38.57 346.279 38.45 346.289 38.34C346.289 38.3 346.299 38.25 346.299 38.21C346.239 38.09 346.209 37.97 346.189 37.84C346.189 37.78 346.159 37.71 346.139 37.65C346.109 37.59 346.069 37.54 346.019 37.49C345.919 37.38 345.839 37.25 345.779 37.12C345.739 37.04 345.639 36.8001 346.029 36.3801C346.159 36.2001 346.379 36.11 346.599 36.15C346.569 36.02 346.589 35.8801 346.649 35.7601C346.559 35.7601 346.479 35.76 346.399 35.73C346.329 35.73 346.259 35.7301 346.199 35.7001C346.089 35.6601 345.999 35.57 345.949 35.46C345.859 35.33 345.829 35.17 345.869 35.02C345.869 35.04 345.849 35.01 345.839 34.97C345.769 34.79 345.749 34.6 345.799 34.41C345.839 34.29 345.909 34.18 346.009 34.1C345.999 34.01 346.009 33.92 346.049 33.84C345.999 33.73 345.989 33.59 346.049 33.48C346.099 33.37 346.189 33.2801 346.309 33.2501C346.329 33.0501 346.399 32.86 346.529 32.71C346.559 32.68 346.589 32.64 346.599 32.6C346.529 32.57 346.459 32.53 346.409 32.48C346.409 32.48 345.849 31.97 345.869 31.62C345.869 31.6 345.869 31.58 345.869 31.56C345.849 31.52 345.819 31.4901 345.799 31.4501C345.699 31.2601 345.689 31.03 345.779 30.84C345.829 30.75 345.889 30.66 345.969 30.59C345.899 30.47 345.879 30.3301 345.919 30.2001C345.979 29.9801 346.109 29.78 346.289 29.64C346.309 29.62 346.329 29.61 346.339 29.59C346.469 29.33 346.769 29.2 347.049 29.28C347.089 29.28 347.129 29.29 347.169 29.29H347.159H347.149C347.009 29.2 346.899 29.0801 346.809 28.9501C346.779 28.8901 346.729 28.83 346.689 28.77C346.629 28.68 346.569 28.58 346.509 28.49C346.509 28.49 346.149 27.75 346.609 27.47C346.759 27.39 346.919 27.33 347.089 27.31C347.159 27.31 347.219 27.2801 347.279 27.2601C347.329 27.2201 347.379 27.17 347.429 27.12C347.539 26.99 347.669 26.88 347.819 26.8C347.889 26.76 347.949 26.71 348.009 26.66C348.129 26.56 348.259 26.47 348.399 26.4C348.539 26.34 348.689 26.33 348.829 26.35C348.849 26.24 348.899 26.14 348.959 26.05C349.169 25.81 349.419 25.6001 349.699 25.4501C349.989 25.3301 350.319 25.36 350.589 25.54C350.739 25.61 350.839 25.76 350.869 25.92C350.869 26.06 350.869 26.2 350.849 26.34C350.849 26.37 350.849 26.4 350.839 26.43H350.889C351.079 26.46 351.269 26.53 351.429 26.65L351.549 26.7501C351.659 26.8501 351.769 26.9301 351.889 27.0101C352.229 27.2501 352.419 27.64 352.409 28.06C352.409 28.22 352.389 28.38 352.349 28.54C352.419 28.66 352.429 28.8 352.379 28.92C352.469 28.98 352.539 29.0801 352.559 29.1901L352.599 29.37C352.629 29.44 352.659 29.5 352.699 29.56C352.769 29.68 352.829 29.8201 352.879 29.9501C352.929 30.1601 352.919 30.3701 352.849 30.5701C352.829 30.6201 352.819 30.68 352.819 30.73C352.819 30.76 352.829 30.7901 352.839 30.8201C352.929 31.0701 352.859 31.35 352.659 31.53C352.629 31.56 352.589 31.58 352.559 31.6C352.659 31.74 352.669 31.9201 352.599 32.0701C352.589 32.1301 352.579 32.2001 352.589 32.2601C352.589 32.3601 352.589 32.46 352.579 32.56C352.539 32.75 352.449 32.92 352.329 33.06L352.279 33.1301C352.299 33.1901 352.339 33.2601 352.369 33.3201C352.419 33.4101 352.459 33.5 352.499 33.58C352.489 33.55 352.539 33.58 352.579 33.61C352.749 33.7 352.879 33.83 352.979 33.99C353.069 34.19 353.049 34.42 352.939 34.61C352.939 34.64 352.939 34.6701 352.959 34.6901C353.009 34.8401 353.029 34.99 353.009 35.14C352.989 35.28 352.939 35.41 352.869 35.53C352.849 35.57 352.829 35.6 352.819 35.64C352.819 35.76 352.789 35.8801 352.759 36.0001C352.739 36.0601 352.729 36.11 352.719 36.17C352.719 36.23 352.739 36.3 352.749 36.36C352.779 36.48 352.799 36.61 352.809 36.74C352.809 36.87 352.789 37.0001 352.769 37.1301C352.759 37.2001 352.749 37.26 352.739 37.33C352.719 37.52 352.649 37.69 352.539 37.84C352.519 37.87 352.499 37.9 352.479 37.93C352.479 37.92 352.489 37.95 352.499 37.99C352.579 38.29 352.469 38.62 352.229 38.81C352.109 38.89 351.969 38.93 351.819 38.93C351.819 38.96 351.829 38.99 351.829 39.02C351.829 39.28 351.759 39.5301 351.659 39.7601C351.569 39.9201 351.469 40.0701 351.349 40.2001C351.289 40.2701 351.239 40.34 351.189 40.41C351.099 40.55 350.939 40.62 350.769 40.61C350.769 40.61 350.789 40.72 350.809 40.74C350.829 40.77 350.859 40.79 350.889 40.81C351.039 40.92 351.139 41.06 351.199 41.24C351.229 41.29 351.249 41.3301 351.279 41.3801C351.299 41.3701 351.309 41.35 351.329 41.34C351.439 41.18 351.629 41.1001 351.819 41.1301C352.039 41.1801 352.209 41.3501 352.269 41.5701C352.459 41.6201 352.599 41.7601 352.669 41.9401C352.729 42.1201 352.699 42.32 352.579 42.48V42.5101C352.639 42.7201 352.609 42.94 352.499 43.12C352.429 43.22 352.329 43.3 352.209 43.35C352.489 43.68 352.279 44.08 352.159 44.33L352.119 44.41C352.009 44.69 351.769 44.9 351.469 44.97C351.389 44.99 351.309 45.0001 351.219 45.0101C351.189 45.0101 351.149 45.01 351.119 45.02C351.119 45.06 351.119 45.1201 351.119 45.1901C351.139 45.2101 351.169 45.2301 351.189 45.2501C351.249 45.3101 351.319 45.37 351.369 45.43C351.439 45.51 351.509 45.6101 351.569 45.7001C351.629 45.8001 351.709 45.89 351.789 45.97C352.009 46.11 352.189 46.3201 352.269 46.5701C352.319 46.8001 352.229 47.0401 352.049 47.1901C352.009 47.2301 351.969 47.27 351.939 47.31C351.939 47.36 351.939 47.4001 351.939 47.4501L351.969 47.47C352.179 47.58 352.329 47.79 352.369 48.03C352.369 48.26 352.279 48.48 352.089 48.62C352.169 48.77 352.219 48.92 352.239 49.09C352.249 49.23 352.229 49.37 352.159 49.49C352.219 49.52 352.269 49.56 352.309 49.61C352.369 49.67 352.699 50.2 352.519 50.55C352.519 50.57 352.519 50.6001 352.519 50.6301C352.519 50.7301 352.519 50.8401 352.509 50.9401C352.509 51.0201 352.479 51.09 352.469 51.17C352.449 51.26 352.429 51.3601 352.429 51.4501C352.429 51.5301 352.429 51.6 352.449 51.68C352.469 51.79 352.479 51.9 352.479 52.02C352.479 52.18 352.449 52.33 352.389 52.47C352.369 52.52 352.359 52.56 352.349 52.61C352.349 52.62 352.379 52.69 352.399 52.73C352.479 52.88 352.529 53.04 352.529 53.21C352.519 53.42 352.439 53.62 352.309 53.79C352.289 53.82 352.269 53.85 352.249 53.89C352.219 54.09 352.139 54.27 352.009 54.42L352.029 54.49C352.139 54.72 352.129 55 351.999 55.22C351.839 55.41 351.609 55.53 351.359 55.56C351.379 55.66 351.379 55.75 351.359 55.85H351.349C351.399 56.07 351.299 56.28 351.119 56.37C350.929 56.46 350.699 56.4201 350.569 56.2601C350.509 56.3001 350.439 56.33 350.369 56.35C350.199 56.4 350.019 56.39 349.859 56.33C349.769 56.42 349.639 56.47 349.509 56.46C349.399 56.45 349.299 56.4 349.229 56.33C349.059 56.35 348.899 56.33 348.739 56.27C348.639 56.36 348.529 56.43 348.399 56.47C348.289 56.5 348.179 56.53 348.069 56.55C347.999 56.56 347.929 56.58 347.869 56.6C347.709 56.65 347.549 56.68 347.389 56.68L347.409 56.73ZM347.979 55.7001H347.999C348.049 55.7001 348.099 55.7 348.149 55.68C348.159 55.66 348.179 55.6501 348.199 55.6301L347.969 55.7001H347.979ZM348.279 55.42C348.279 55.42 348.309 55.5 348.319 55.55C348.479 55.43 348.669 55.38 348.869 55.41C348.869 55.39 348.879 55.37 348.889 55.35C348.979 55.13 349.219 55 349.449 55.05C349.499 55.07 349.559 55.1 349.599 55.14L349.629 55.16C349.769 55.16 349.909 55.2101 350.009 55.3201C350.069 55.3801 350.119 55.45 350.139 55.54L350.169 55.56L350.199 55.53C350.199 55.38 350.239 55.23 350.329 55.1C350.479 54.9 350.719 54.78 350.979 54.78L350.959 54.7601C350.799 54.6401 350.739 54.42 350.809 54.23C350.869 54.09 350.989 53.99 351.129 53.96C351.209 53.92 351.299 53.88 351.399 53.87C351.399 53.87 351.399 53.85 351.399 53.84C351.429 53.68 351.489 53.52 351.599 53.39C351.619 53.35 351.649 53.32 351.669 53.28C351.669 53.28 351.639 53.24 351.619 53.21C351.539 53.06 351.499 52.9 351.479 52.73C351.479 52.57 351.509 52.42 351.569 52.27C351.589 52.22 351.599 52.1801 351.609 52.1301C351.609 52.0501 351.599 51.98 351.579 51.91C351.559 51.79 351.549 51.66 351.549 51.54C351.549 51.39 351.579 51.23 351.609 51.09C351.619 51.03 351.629 50.98 351.639 50.93C351.639 50.87 351.639 50.81 351.639 50.74C351.639 50.62 351.639 50.5001 351.669 50.3801C351.669 50.3601 351.659 50.34 351.649 50.33C351.609 50.31 351.559 50.3 351.519 50.28C351.589 50.46 351.539 50.66 351.389 50.79C351.259 50.91 351.069 50.93 350.909 50.86C350.849 50.88 350.789 50.88 350.729 50.86C350.519 50.81 350.369 50.61 350.379 50.39C350.379 50.34 350.399 50.29 350.429 50.24C350.479 50.05 350.639 49.91 350.829 49.86C350.899 49.85 350.979 49.86 351.049 49.87C351.019 49.76 351.039 49.65 351.089 49.55C351.149 49.45 351.209 49.36 351.289 49.27C351.309 49.25 351.329 49.2301 351.349 49.2001C351.329 49.1601 351.309 49.1 351.289 49.06C351.129 48.83 351.119 48.53 351.259 48.3C351.289 48.26 351.319 48.2301 351.349 48.2001C351.249 48.1201 351.169 48.01 351.129 47.89C351.049 47.63 351.049 47.35 351.129 47.1C351.029 47.09 350.939 47.05 350.869 46.98C350.689 46.79 350.609 46.53 350.669 46.27C350.679 46.24 350.689 46.2201 350.709 46.2001C350.709 46.1801 350.729 46.1501 350.739 46.1301L350.719 46.11C350.719 46.11 350.649 46.0401 350.619 46.0101C350.439 45.8801 350.319 45.68 350.269 45.46C350.199 45.12 350.269 44.76 350.459 44.47C350.639 44.3 350.869 44.2101 351.119 44.2001C351.179 44.2001 351.229 44.19 351.279 44.17C351.299 44.15 351.319 44.13 351.329 44.1L351.379 44.0001C351.379 44.0001 351.419 43.9201 351.439 43.8801C351.419 43.8601 351.409 43.8401 351.389 43.8201C351.369 43.8201 351.349 43.8201 351.329 43.8201C351.309 43.8201 351.299 43.82 351.279 43.83C351.239 43.84 351.199 43.84 351.159 43.84C350.919 43.99 350.629 44.02 350.369 43.91C350.129 43.91 349.919 43.77 349.829 43.55C349.709 43.58 349.579 43.5601 349.479 43.5001C349.369 43.4401 349.299 43.33 349.269 43.21C349.249 43.13 349.259 43.05 349.279 42.97C349.269 42.93 349.259 42.89 349.269 42.85C349.289 42.68 349.389 42.54 349.539 42.47C349.739 42.4 349.959 42.47 350.099 42.62C350.099 42.62 350.129 42.66 350.139 42.67C350.179 42.63 350.229 42.6 350.279 42.58C350.259 42.54 350.239 42.5001 350.239 42.4501V42.43C350.169 42.46 350.109 42.47 350.039 42.46C349.849 42.44 349.689 42.3101 349.619 42.1301C349.569 41.9201 349.619 41.69 349.749 41.52C349.849 41.41 349.989 41.35 350.139 41.36C349.899 41.04 349.839 40.6301 349.979 40.2601C350.029 40.1501 350.109 40.05 350.199 39.97C350.179 39.96 350.169 39.94 350.149 39.92C350.059 39.81 350.019 39.67 350.049 39.53C350.079 39.23 350.179 38.9401 350.359 38.7001L350.409 38.65C350.619 38.4 350.889 38.21 351.189 38.08C351.319 38.04 351.459 38.03 351.599 38.05C351.599 37.97 351.599 37.89 351.599 37.81C351.629 37.65 351.699 37.5101 351.789 37.3801C351.809 37.3501 351.829 37.32 351.849 37.29C351.849 37.2 351.859 37.1001 351.879 37.0101C351.899 36.9401 351.909 36.86 351.909 36.79C351.909 36.73 351.889 36.66 351.879 36.6C351.849 36.48 351.829 36.35 351.819 36.22C351.819 36.08 351.839 35.94 351.889 35.8C351.909 35.75 351.919 35.6901 351.929 35.6301C351.939 35.4601 351.989 35.3 352.079 35.16C352.099 35.12 352.119 35.09 352.129 35.05C352.119 35.03 352.109 35 352.099 34.98C352.039 34.81 352.029 34.64 352.059 34.46C351.889 34.49 351.719 34.45 351.579 34.34C351.399 34.31 351.239 34.21 351.119 34.06C351.039 33.94 351.019 33.78 351.069 33.65C351.119 33.51 351.239 33.41 351.379 33.37C351.379 33.37 351.359 33.29 351.349 33.24C351.329 32.98 351.419 32.73 351.599 32.54C351.629 32.5 351.659 32.46 351.689 32.41C351.689 32.4 351.689 32.35 351.689 32.3C351.689 32.28 351.689 32.26 351.689 32.24C351.649 32.23 351.619 32.2101 351.589 32.1901C351.429 32.0901 351.329 31.91 351.349 31.72C351.329 31.68 351.319 31.64 351.319 31.6C351.309 31.48 351.339 31.36 351.419 31.27C351.469 31.04 351.649 30.87 351.879 30.84H351.939C351.939 30.68 351.949 30.52 351.999 30.37C352.019 30.32 352.029 30.26 352.029 30.21C352.009 30.16 351.979 30.11 351.949 30.06C351.769 30.08 351.649 30.06 351.579 30.08C351.449 30.11 351.309 30.0801 351.199 30.0101C351.179 29.9901 351.149 29.9701 351.129 29.9501C351.119 30.0701 351.069 30.18 350.999 30.27C350.899 30.39 350.739 30.4601 350.579 30.4401C350.429 30.4101 350.289 30.32 350.209 30.18C350.119 29.99 350.129 29.77 350.229 29.58C350.329 29.42 350.499 29.3201 350.689 29.3201C350.809 29.3201 350.919 29.38 350.999 29.47C350.989 29.35 350.999 29.23 351.009 29.11C350.959 29.09 350.919 29.06 350.879 29.04C350.689 29.06 350.499 28.97 350.399 28.8C350.319 28.68 350.309 28.53 350.359 28.4C350.409 28.27 350.519 28.1701 350.659 28.1301L350.729 28.11C350.839 28.07 350.949 28.05 351.059 28.03C351.229 28.03 351.399 28.09 351.509 28.22C351.509 28.18 351.519 28.15 351.529 28.11C351.509 27.83 351.459 27.79 351.459 27.79C351.289 27.69 351.129 27.5701 350.989 27.4401L350.879 27.35C350.879 27.35 350.789 27.34 350.739 27.33C350.499 27.33 350.279 27.23 350.129 27.04C349.979 26.86 349.919 26.62 349.959 26.39C349.879 26.45 349.799 26.51 349.729 26.58C349.729 26.62 349.729 26.67 349.739 26.71C349.739 26.75 349.739 26.7801 349.749 26.8201C349.859 26.9401 349.899 27.11 349.849 27.27C349.799 27.43 349.659 27.5401 349.499 27.5701C349.479 27.5701 349.439 27.59 349.409 27.6C349.269 27.65 348.849 27.81 348.669 27.42C348.659 27.39 348.649 27.36 348.639 27.33L348.579 27.3801C348.469 27.4701 348.359 27.55 348.239 27.62C348.189 27.66 348.139 27.7101 348.089 27.7601L348.059 27.79C348.239 27.76 348.429 27.8 348.579 27.91C348.599 27.9 348.629 27.8901 348.649 27.8801C349.069 27.6801 349.559 27.8201 349.819 28.2001C349.959 28.4601 349.849 28.72 349.699 29.04L349.659 29.1301C349.659 29.1301 349.639 29.19 349.629 29.23C349.599 29.43 349.479 29.6001 349.309 29.7001C349.139 29.8001 348.929 29.8201 348.749 29.7601C348.799 29.8501 348.829 29.94 348.829 30.05C348.829 30.07 348.829 30.09 348.829 30.11C348.829 30.3 348.699 30.46 348.529 30.52C348.419 30.56 348.299 30.5501 348.199 30.5101H348.119C347.989 30.6301 347.809 30.66 347.659 30.6C347.499 30.54 347.399 30.39 347.379 30.22C347.309 30.24 347.239 30.2501 347.179 30.2501C347.129 30.2501 347.079 30.2501 347.029 30.2501C346.999 30.2901 346.959 30.32 346.929 30.36C346.959 30.39 346.989 30.42 347.019 30.46C347.039 30.46 347.049 30.48 347.069 30.49C347.219 30.6 347.289 30.78 347.249 30.96C347.209 31.14 347.059 31.27 346.879 31.3C346.849 31.3 346.809 31.3101 346.779 31.3201C346.849 31.4201 346.869 31.55 346.859 31.67V31.6901C346.899 31.7501 346.949 31.81 346.999 31.86C346.979 31.84 347.009 31.84 347.039 31.84C347.179 31.84 347.309 31.87 347.439 31.92C347.609 31.99 347.729 32.14 347.749 32.33C347.779 32.54 347.689 32.75 347.509 32.87H347.489C347.439 33.06 347.349 33.24 347.219 33.37C347.219 33.4 347.219 33.4301 347.219 33.4501C347.259 33.4701 347.299 33.4801 347.339 33.5101C347.469 33.5901 347.559 33.73 347.559 33.89C347.559 34.05 347.489 34.19 347.359 34.28C347.289 34.32 347.219 34.3601 347.139 34.3801C347.109 34.4501 347.059 34.51 347.009 34.56C347.159 34.51 347.319 34.48 347.469 34.48C347.529 34.48 347.579 34.48 347.639 34.46C347.729 34.43 347.809 34.39 347.889 34.34C348.079 34.19 348.329 34.17 348.539 34.29C348.649 34.36 348.719 34.48 348.739 34.61C348.759 34.74 348.719 34.87 348.629 34.97C348.599 35.02 348.579 35.07 348.559 35.12C348.509 35.28 348.429 35.42 348.329 35.55C348.199 35.68 348.039 35.78 347.869 35.84C347.819 35.86 347.769 35.88 347.729 35.91C347.699 35.95 347.669 35.99 347.639 36.03C347.689 36.09 347.729 36.15 347.749 36.22C347.789 36.33 347.789 36.4601 347.749 36.5701C347.729 36.6201 347.689 36.67 347.649 36.71C347.619 36.91 347.519 37.0801 347.369 37.2001C347.269 37.2801 347.139 37.32 347.009 37.31C347.069 37.45 347.109 37.59 347.129 37.73C347.129 37.8 347.159 37.86 347.179 37.92C347.179 37.94 347.189 37.95 347.199 37.97V37.93C347.249 37.8 347.299 37.6801 347.379 37.5701C347.459 37.4601 347.579 37.3901 347.719 37.3801C347.859 37.3701 347.989 37.42 348.079 37.52C348.209 37.66 348.259 37.86 348.229 38.05C348.249 38.1 348.249 38.16 348.239 38.22C348.219 38.33 348.199 38.43 348.179 38.54C348.109 38.65 347.999 38.74 347.869 38.78C347.699 38.82 347.529 38.78 347.389 38.68C347.479 38.81 347.489 38.9801 347.419 39.1301C347.419 39.1501 347.399 39.17 347.389 39.18C347.419 39.3 347.439 39.43 347.439 39.56C347.669 39.65 347.849 39.82 347.929 40.05C347.949 40.09 347.969 40.13 347.989 40.16C347.979 40.14 348.069 40.16 348.129 40.16C348.259 40.18 348.389 40.2101 348.509 40.2601C348.649 40.3201 348.749 40.45 348.779 40.6C348.799 40.76 348.739 40.93 348.619 41.05C348.499 41.21 348.279 41.28 348.089 41.21C348.089 41.21 348.059 41.23 348.029 41.24C347.849 41.32 347.659 41.34 347.469 41.3C347.239 41.23 347.019 41.1401 346.819 41.0101C346.759 40.9701 346.699 40.93 346.659 40.87C346.599 40.91 346.539 40.95 346.469 40.97C346.489 40.99 346.509 41.01 346.529 41.02C346.819 41.18 347.109 41.35 347.139 41.72C347.149 41.97 347.019 42.21 346.809 42.35L346.779 42.3801C346.989 42.4201 347.209 42.47 347.409 42.54C347.349 42.42 347.349 42.27 347.409 42.14C347.469 42.01 347.579 41.91 347.709 41.86V41.84C347.759 41.79 347.809 41.74 347.859 41.71L348.059 41.59C348.059 41.59 348.129 41.55 348.159 41.53C348.359 41.44 348.609 41.5101 348.719 41.7001C348.839 41.8901 348.799 42.14 348.629 42.28C348.599 42.33 348.569 42.37 348.539 42.41C348.539 42.51 348.509 42.6001 348.459 42.6901C348.389 42.8301 348.239 42.91 348.079 42.9C348.099 42.91 348.119 42.9301 348.139 42.9501C348.259 43.0501 348.319 43.2 348.309 43.35C348.289 43.5 348.199 43.6401 348.059 43.7001C348.009 43.7801 347.949 43.86 347.869 43.92C347.759 44.17 347.569 44.38 347.339 44.53L347.309 44.55C347.289 44.63 347.239 44.7001 347.179 44.7601C347.129 44.9401 347.009 45.1001 346.839 45.1901C346.729 45.2301 346.629 45.3 346.549 45.4C346.499 45.5 346.469 45.61 346.469 45.72C346.449 45.87 346.399 46.01 346.329 46.14C346.319 46.17 346.299 46.21 346.279 46.24C346.329 46.38 346.409 46.51 346.499 46.62C346.499 46.6 346.519 46.62 346.549 46.62C346.709 46.68 346.839 46.77 346.949 46.89C347.069 46.85 347.209 46.85 347.329 46.89C347.519 46.97 347.679 47.11 347.799 47.28C347.899 47.46 347.859 47.69 347.709 47.83C347.619 47.91 347.509 47.9501 347.389 47.9501C347.389 47.9501 347.419 48.02 347.429 48.05C347.439 48.09 347.449 48.12 347.449 48.16C347.469 48.16 347.489 48.15 347.509 48.14H347.579C347.579 48.14 347.629 48.12 347.649 48.12C347.839 48.07 348.039 48.13 348.149 48.29C348.209 48.39 348.239 48.5 348.239 48.61C348.259 48.68 348.259 48.75 348.239 48.83C348.219 48.95 348.149 49.05 348.049 49.11C348.209 49.3 348.319 49.5201 348.399 49.7601C348.439 49.8701 348.439 50 348.399 50.11C348.349 50.22 348.259 50.31 348.139 50.35C348.109 50.36 348.079 50.37 348.049 50.39C348.049 50.39 348.059 50.41 348.059 50.42C348.169 50.53 348.259 50.66 348.319 50.81C348.369 50.92 348.369 51.05 348.319 51.16C348.459 51.12 348.609 51.1401 348.729 51.2001C348.769 51.2201 348.809 51.25 348.839 51.28C348.859 51.29 348.869 51.3 348.889 51.31C348.959 51.35 349.029 51.4 349.089 51.46C349.129 51.49 349.169 51.52 349.199 51.56C349.279 51.65 349.319 51.78 349.309 51.91C349.309 51.91 349.309 51.95 349.309 51.96C349.449 52.16 349.409 52.43 349.219 52.58C349.149 52.64 349.069 52.69 348.999 52.74C348.939 52.78 348.869 52.83 348.809 52.87C348.669 52.98 348.479 52.99 348.319 52.91C348.159 52.82 348.069 52.66 348.089 52.48C348.109 52.33 348.169 52.19 348.259 52.08L348.229 52.06L348.169 52.04C348.169 52.04 348.079 52.01 348.029 51.99C347.849 51.89 347.759 51.67 347.819 51.47C347.689 51.49 347.559 51.5001 347.419 51.5001C347.309 51.6501 347.119 51.72 346.929 51.67C346.849 51.64 346.769 51.6 346.709 51.54C346.709 51.65 346.699 51.76 346.669 51.87C346.669 51.92 346.669 51.97 346.669 52.02C346.669 52.04 346.669 52.07 346.669 52.1H346.699C346.849 52.16 346.959 52.2901 346.989 52.4501C347.009 52.5301 347.039 52.6 347.069 52.67C347.109 52.76 347.149 52.86 347.169 52.96C347.289 52.98 347.399 53.05 347.479 53.14C347.559 53.19 347.629 53.27 347.669 53.36C347.729 53.5 347.709 53.65 347.629 53.78C347.549 53.9 347.429 53.97 347.289 53.98C347.229 53.98 347.169 53.98 347.109 53.96C347.189 54.03 347.249 54.11 347.269 54.21C347.289 54.31 347.299 54.4001 347.279 54.5001C347.419 54.5301 347.549 54.6001 347.659 54.7001C347.669 54.6901 347.689 54.67 347.699 54.66C347.719 54.58 347.769 54.5101 347.829 54.4501C347.899 54.3901 347.979 54.35 348.059 54.34C348.029 54.28 347.999 54.23 347.979 54.17C347.929 54.06 347.809 53.79 348.409 53.14C348.509 53.03 348.659 52.9801 348.809 53.0001C348.959 53.0201 349.079 53.1201 349.149 53.2501C349.239 53.4801 349.279 53.73 349.249 53.98C349.249 54.02 349.249 54.07 349.249 54.11C349.259 54.36 349.139 54.59 348.939 54.74C348.849 54.79 348.759 54.81 348.659 54.81C348.659 54.88 348.659 54.9401 348.629 55.0101C348.589 55.1101 348.519 55.19 348.429 55.24C348.369 55.31 348.289 55.37 348.209 55.42H348.279ZM348.059 55.1901C348.059 55.1901 348.119 55.21 348.149 55.22L348.169 55.0101L348.029 55.05L347.999 55.0001L347.919 55.04C347.919 55.04 347.929 55.09 347.939 55.12C347.959 55.14 347.989 55.16 348.009 55.17C348.029 55.17 348.039 55.1801 348.059 55.1901ZM347.419 53.53L347.549 53.59C347.549 53.59 347.549 53.55 347.549 53.54H347.419V53.53ZM351.199 50.65H351.209C351.209 50.65 351.259 50.59 351.269 50.55C351.249 50.58 351.229 50.62 351.199 50.65ZM351.129 50.42L351.279 50.52C351.279 50.52 351.289 50.4601 351.289 50.4401H351.129V50.42ZM346.939 48.89C346.939 48.89 347.009 48.9 347.049 48.91C347.209 48.93 347.359 48.98 347.489 49.05H347.509C347.509 49.05 347.459 49 347.439 48.97C347.319 48.92 347.219 48.8201 347.179 48.7001C347.179 48.6701 347.159 48.65 347.159 48.62C347.069 48.67 346.979 48.72 346.889 48.77H346.869C346.869 48.77 346.919 48.86 346.939 48.89ZM350.749 46.5101C350.749 46.5101 350.799 46.59 350.839 46.62L350.919 46.53L350.759 46.5101H350.749ZM350.769 46.4401L350.939 46.5001L350.779 46.4L350.759 46.4401H350.769ZM349.669 43.3C349.669 43.3 349.749 43.3 349.799 43.3C349.799 43.24 349.819 43.19 349.839 43.14L349.809 43.0701H349.769L349.679 43.31L349.669 43.3ZM351.329 42.79C351.329 42.79 351.369 42.79 351.389 42.8C351.409 42.78 351.439 42.76 351.469 42.74H351.449C351.449 42.74 351.389 42.77 351.329 42.79ZM351.689 42.58C351.689 42.58 351.629 42.64 351.599 42.67C351.629 42.65 351.669 42.6401 351.699 42.6301V42.58H351.689ZM350.029 42.24C350.099 42.25 350.179 42.24 350.239 42.22C350.259 42.1 350.289 41.9901 350.329 41.8801L350.089 41.96L350.029 42.24ZM349.699 41.78C349.669 41.86 349.679 41.94 349.719 42.02L349.919 41.92L349.699 41.79V41.78ZM350.669 29.9401L350.629 30.22C350.789 30.23 350.949 30.1501 351.029 30.0001C351.059 29.9201 351.049 29.8301 351.009 29.7601L350.669 29.9401ZM350.309 29.7001C350.239 29.7601 350.229 29.8701 350.269 29.9501L350.499 29.87L350.309 29.7001ZM348.749 28.8201C348.749 28.8201 348.799 28.83 348.829 28.84C348.829 28.82 348.839 28.8 348.849 28.78C348.819 28.79 348.789 28.8101 348.749 28.8201ZM349.259 51.33C349.099 51.33 348.949 51.2801 348.819 51.1901C348.699 51.0901 348.629 50.93 348.649 50.77C348.659 50.69 348.689 50.6301 348.729 50.5701C348.729 50.4801 348.739 50.38 348.789 50.3C348.869 50.18 348.989 50.09 349.129 50.04C349.159 50.03 349.149 50.04 349.129 50.06C349.149 50.04 349.169 50.0201 349.199 50.0101V49.97C349.139 49.94 349.059 49.9101 348.999 49.8801C348.979 49.8701 348.959 49.86 348.929 49.85C348.719 49.87 348.509 49.7601 348.419 49.5701C348.359 49.4501 348.359 49.3 348.419 49.18C348.479 49.06 348.589 48.96 348.719 48.93L348.809 48.9C348.949 48.85 349.099 48.83 349.239 48.83C349.459 48.87 349.669 48.98 349.819 49.14L349.939 49.24C350.089 49.35 350.149 49.54 350.099 49.71C350.089 49.76 350.059 49.81 350.029 49.86C350.029 49.87 350.039 49.88 350.049 49.89L350.089 49.96L350.119 50.0101C350.229 50.2101 350.169 50.46 349.979 50.59C349.949 50.66 349.899 50.72 349.839 50.77C349.819 50.8 349.789 50.82 349.759 50.84C349.759 50.86 349.759 50.88 349.759 50.89C349.739 51.08 349.609 51.24 349.429 51.31C349.379 51.33 349.319 51.34 349.259 51.34V51.33ZM349.219 51.0001L349.089 51.22C349.169 51.25 349.249 51.2401 349.319 51.2001L349.219 51.0001ZM349.419 45.93C349.349 45.93 349.279 45.9101 349.219 45.8801C349.109 45.8201 349.029 45.73 348.989 45.61C348.989 45.58 348.979 45.56 348.969 45.53C348.949 45.51 348.929 45.4801 348.919 45.4501C348.859 45.3401 348.849 45.22 348.879 45.1C348.919 44.98 349.009 44.8701 349.119 44.8201C349.239 44.7701 349.369 44.7701 349.489 44.8201C349.539 44.8301 349.579 44.8601 349.619 44.8801C349.789 44.9401 349.909 45.1 349.919 45.28C349.919 45.38 349.899 45.47 349.849 45.56C349.849 45.58 349.849 45.6 349.839 45.62C349.779 45.8 349.609 45.93 349.409 45.93H349.419ZM349.309 39.55C349.309 39.55 349.279 39.55 349.269 39.55C349.259 39.55 349.249 39.55 349.239 39.55C349.119 39.55 348.989 39.5201 348.899 39.4401C348.809 39.3501 348.739 39.24 348.709 39.12V39.08C348.569 38.88 348.629 38.61 348.819 38.48C349.009 38.34 349.279 38.3801 349.429 38.5701L349.549 38.7001C349.629 38.7401 349.689 38.81 349.739 38.89C349.829 39.07 349.789 39.28 349.649 39.42C349.559 39.51 349.439 39.56 349.309 39.56V39.55ZM349.149 36.3801C349.149 36.3801 349.079 36.38 349.049 36.37C348.899 36.33 348.779 36.23 348.719 36.09C348.649 35.89 348.679 35.6801 348.789 35.5001C348.889 35.3301 349.089 35.24 349.289 35.27C349.479 35.31 349.629 35.47 349.669 35.66C349.699 35.88 349.629 36.1001 349.479 36.2601C349.389 36.3401 349.279 36.3801 349.159 36.3801H349.149ZM349.169 35.79L348.769 35.81C348.799 35.99 348.939 36.13 349.109 36.16L349.159 35.91H349.129L349.169 35.8V35.79ZM349.349 35.8201L349.549 35.96C349.579 35.89 349.569 35.81 349.539 35.74L349.349 35.8201ZM349.149 35.48C348.979 35.48 348.829 35.58 348.759 35.73L349.159 35.77L349.249 35.49C349.249 35.49 349.179 35.48 349.149 35.48ZM349.169 34.53C349.169 34.53 349.119 34.53 349.089 34.53C348.939 34.49 348.799 34.3901 348.729 34.2501C348.709 34.2001 348.689 34.15 348.689 34.09C348.579 34.07 348.479 34.03 348.389 33.98C348.249 33.93 348.109 33.87 347.979 33.81C347.919 33.78 347.849 33.75 347.779 33.72C347.599 33.64 347.489 33.4501 347.509 33.2501C347.509 33.0901 347.569 32.95 347.689 32.87C347.809 32.78 347.959 32.76 348.099 32.81C348.259 32.86 348.409 32.92 348.599 32.99L348.789 33.06C348.719 33.02 348.669 32.96 348.639 32.89C348.629 32.87 348.619 32.86 348.569 32.81C348.499 32.75 348.429 32.68 348.369 32.6C348.209 32.49 348.139 32.3 348.169 32.12C348.209 31.95 348.329 31.81 348.489 31.74C348.699 31.64 348.949 31.64 349.159 31.74C349.379 31.9 349.509 32.14 349.519 32.41C349.579 32.59 349.549 32.79 349.419 32.93C349.329 33.07 349.179 33.1401 349.019 33.1301H348.979L349.189 33.21C349.299 33.25 349.389 33.3401 349.439 33.4501C349.569 33.5201 349.659 33.64 349.689 33.78C349.729 34 349.669 34.23 349.529 34.4C349.439 34.49 349.309 34.54 349.179 34.54L349.169 34.53ZM349.139 34.28L349.179 34.04L349.139 34.06C349.049 34.08 348.949 34.1 348.849 34.1C348.909 34.2 349.009 34.26 349.129 34.28L349.169 34.08L349.129 34.28H349.139ZM349.379 33.9501L349.569 34.08C349.599 34.01 349.589 33.93 349.559 33.87L349.379 33.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.319 14.47C419.319 14.47 419.209 14.69 419.149 14.75C418.999 14.85 418.849 14.93 418.679 15.01C418.669 15.02 418.799 15.12 418.779 15.13C418.689 15.13 418.569 15.21 418.479 15.21C418.469 15.21 418.529 15.19 418.509 15.19", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.49 15.67C418.49 15.67 418.4 15.67 418.35 15.65C418.16 15.59 418.04 15.41 418.04 15.22C418.04 15.06 418.14 14.91 418.28 14.83C418.3 14.78 418.34 14.7301 418.38 14.7001C418.4 14.6801 418.41 14.67 418.43 14.66C418.52 14.6 418.61 14.56 418.7 14.52C418.75 14.5 418.79 14.4801 418.83 14.4501C418.85 14.4201 418.88 14.39 418.89 14.36C418.83 14.51 418.86 14.67 418.97 14.79L419.02 14.7501C419.02 14.7501 419.05 14.78 419.07 14.8L419.58 14.14L419.76 14.48C419.73 14.72 419.62 14.93 419.45 15.1C419.38 15.17 419.3 15.22 419.21 15.27C419.17 15.42 419.059 15.54 418.919 15.58C418.889 15.58 418.86 15.6 418.83 15.6C418.72 15.65 418.6 15.6801 418.48 15.6901L418.49 15.67Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.46 30.5001C287.54 30.3801 287.86 30.5 288.05 30.41C288.22 30.33 288.21 29.94 288.34 29.83C288.49 29.71 288.74 29.68 288.69 29.47C288.88 29.36 289.07 29.2601 289.28 29.2001C289.22 29.2001 289.17 29.2 289.11 29.21C289.16 29.37 289.16 29.5401 289.12 29.6901C289.08 29.8501 288.96 30.09 289.2 30.22C289.09 30.35 289.1 30.3701 288.98 30.5001C288.97 30.5101 289.11 30.5501 289.1 30.5601C288.94 30.6801 288.75 30.7401 288.55 30.7401C288.36 30.7401 288.18 30.72 288 30.67C287.83 30.62 287.66 30.5501 287.51 30.4501C287.49 30.4501 287.44 30.5101 287.45 30.5001H287.46Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M288.489 31.2C288.339 31.2 288.189 31.18 288.039 31.14L287.929 31.12C287.779 31.09 287.629 31.03 287.489 30.95C287.369 30.95 287.249 30.92 287.159 30.85C286.989 30.7 286.949 30.45 287.069 30.26C287.159 30.1 287.329 30 287.519 30C287.589 30 287.669 30 287.739 30H287.769V29.98C287.809 29.79 287.909 29.62 288.049 29.48C288.109 29.43 288.169 29.39 288.239 29.36C288.279 29.15 288.499 29.03 288.769 28.92C288.829 28.85 288.909 28.8 288.989 28.77C289.049 28.75 289.519 28.63 289.689 29.01C289.759 29.18 289.729 29.37 289.599 29.5C289.599 29.6 289.579 29.7 289.559 29.79L289.529 29.88C289.689 30.05 289.699 30.31 289.559 30.49C289.579 30.63 289.539 30.77 289.439 30.87C289.209 31.07 288.909 31.18 288.609 31.18C288.569 31.18 288.529 31.18 288.489 31.18V31.2Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M324.819 49.89C324.819 49.89 324.879 50 324.909 49.99C325.059 49.95 325.189 49.79 325.339 49.75C325.489 49.71 325.619 49.54 325.769 49.5C325.799 49.59 325.819 49.68 325.829 49.77C325.659 49.83 325.479 49.87 325.299 49.87C325.129 49.9 325.029 49.99 324.849 49.83C324.839 49.82 324.809 49.87 324.819 49.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M324.909 50.4401C324.739 50.4401 324.589 50.3501 324.499 50.2101C324.469 50.1801 324.439 50.1401 324.419 50.0901C324.329 49.8701 324.399 49.6201 324.579 49.4701C324.709 49.3801 324.869 49.3601 325.009 49.4101C325.079 49.3701 325.149 49.3401 325.229 49.3201C325.229 49.3201 325.259 49.2901 325.289 49.2701C325.399 49.1801 325.529 49.1101 325.669 49.0701C325.879 49.0201 326.089 49.1201 326.179 49.3201C326.229 49.4201 326.439 49.9601 326.039 50.1701C325.869 50.2601 325.679 50.3001 325.489 50.3001C325.449 50.3001 325.409 50.3001 325.359 50.3101C325.339 50.3101 325.319 50.3101 325.299 50.3301C325.269 50.3301 325.229 50.3501 325.179 50.3601C325.129 50.3901 325.069 50.4101 325.019 50.4201C324.979 50.4301 324.939 50.4401 324.899 50.4401H324.909Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M380.039 33.53C379.839 33.62 379.679 33.78 379.599 33.99C379.499 34.26 379.459 34.48 379.399 34.46C379.309 34.42 379.269 34.31 379.209 34.19C379.419 34.17 379.619 34.11 379.809 34C379.979 33.89 379.979 33.47 380.149 33.36C380.339 33.25 380.559 33.22 380.769 33.28C380.829 33.3 380.599 33.45 380.339 33.5C380.079 33.55 379.919 33.44 380.049 33.52L380.039 33.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M379.419 34.9101C379.359 34.9101 379.289 34.9001 379.239 34.8701C379.069 34.7901 378.929 34.6401 378.859 34.4701L378.829 34.4101C378.769 34.2901 378.759 34.1601 378.799 34.0301C378.839 33.9001 378.949 33.8101 379.069 33.7701C379.119 33.7601 379.169 33.7501 379.209 33.7401H379.219C379.309 33.5501 379.449 33.3801 379.619 33.2501C379.659 33.2001 379.709 33.1501 379.759 33.1201C379.799 33.0701 379.849 33.0301 379.899 33.0001C380.199 32.8201 380.549 32.7701 380.879 32.8701C381.079 32.9301 381.219 33.1201 381.209 33.3301C381.189 33.7801 380.529 33.9301 380.399 33.9601C380.379 33.9601 380.359 33.9601 380.349 33.9601C380.299 34.1301 380.189 34.2801 380.039 34.3901C379.999 34.4201 379.949 34.4401 379.899 34.4701C379.859 34.6401 379.749 34.7901 379.589 34.8801C379.529 34.9101 379.459 34.9201 379.389 34.9201L379.419 34.9101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.819 43.8201C396.819 43.8201 396.789 44.0501 396.759 44.0701C396.519 44.2101 396.299 44.39 396.059 44.53C396.039 44.46 396.059 44.48 396.059 44.48C396.199 44.43 396.259 44.13 396.399 44.08C396.539 44.03 396.859 44.14 396.999 44.09C397.049 44.01 396.829 43.8201 396.809 43.8201H396.819Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.059 44.9801C395.849 44.9801 395.669 44.8401 395.619 44.6401C395.579 44.4701 395.619 44.2901 395.739 44.1601C395.769 44.1401 395.79 44.1101 395.82 44.1001L395.84 44.0701C395.92 43.8801 396.08 43.7401 396.27 43.6601C396.32 43.6401 396.369 43.6301 396.419 43.6301C396.439 43.6001 396.46 43.5601 396.48 43.5301C396.56 43.4301 396.689 43.3801 396.809 43.3701C397.129 43.3701 397.339 43.7301 397.369 43.7701C397.479 43.9401 397.49 44.1501 397.39 44.3201C397.33 44.4201 397.24 44.4901 397.14 44.5201C397.04 44.5501 396.93 44.5601 396.83 44.5501C396.78 44.5801 396.729 44.6201 396.679 44.6501C396.549 44.7401 396.42 44.8301 396.28 44.9101C396.21 44.9501 396.129 44.9701 396.049 44.9701L396.059 44.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.319 51.8101C418.319 52.1101 418.429 52.2601 418.069 52.0401C417.979 51.9901 418.019 51.9401 417.969 51.8201C418.059 51.8201 418.069 51.6801 418.159 51.6901C418.259 51.7001 418.369 51.81 418.469 51.83C418.409 51.78 418.319 51.7801 418.319 51.8001V51.8101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.299 52.6001C418.129 52.5901 417.979 52.5301 417.839 52.4301C417.689 52.3401 417.589 52.1901 417.559 52.0101C417.499 51.8701 417.519 51.7201 417.599 51.5901C417.639 51.5301 417.689 51.4801 417.739 51.4501C417.849 51.3101 418.029 51.2301 418.209 51.2501C418.329 51.2701 418.449 51.3101 418.549 51.3801C418.619 51.4001 418.689 51.4401 418.749 51.4901C418.909 51.6201 418.969 51.8501 418.869 52.0401C418.849 52.0901 418.809 52.1301 418.769 52.1701C418.739 52.4101 418.529 52.6001 418.289 52.6001H418.299Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M320.079 39.2601C319.919 39.1701 319.779 39.05 319.659 38.92C319.609 38.86 319.629 38.92 319.659 38.79C319.729 38.85 319.859 38.73 319.889 38.81C319.929 38.93 319.969 39.06 319.989 39.19C320.089 39.22 320.089 39.2701 320.079 39.2601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M320.079 39.71C319.989 39.71 319.899 39.68 319.829 39.64C319.629 39.52 319.459 39.38 319.309 39.21C319.169 39.07 319.139 38.86 319.229 38.68C319.259 38.53 319.379 38.41 319.519 38.36C319.589 38.34 319.669 38.33 319.739 38.35C319.979 38.3 320.209 38.42 320.309 38.64C320.349 38.73 320.379 38.82 320.389 38.92C320.469 39 320.519 39.11 320.529 39.22C320.549 39.41 320.439 39.59 320.269 39.67C320.209 39.7 320.149 39.71 320.079 39.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M319.999 29.48C319.819 29.53 319.639 29.56 319.459 29.58C319.459 29.58 319.519 29.58 319.539 29.55C319.589 29.46 319.629 29.45 319.709 29.4C319.729 29.38 319.839 29.36 319.989 29.48H319.999Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M319.469 30.03C319.469 30.03 319.399 30.03 319.369 30.03C319.179 29.99 319.039 29.84 319.009 29.65C318.979 29.46 319.079 29.2701 319.259 29.1901C319.309 29.1301 319.379 29.0901 319.449 29.0501C319.719 28.8901 320.059 28.93 320.279 29.14C320.399 29.24 320.459 29.39 320.449 29.54C320.429 29.69 320.339 29.83 320.199 29.9C320.029 29.97 319.849 30.01 319.669 30.02H319.649C319.589 30.04 319.539 30.0501 319.479 30.0501L319.469 30.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.789 45.5501C423.739 45.4601 423.459 45.4001 423.439 45.3001C423.419 45.1901 423.639 45.0301 423.659 44.9101C423.759 44.8801 423.869 44.8501 423.969 44.8401C424.019 44.9601 423.719 45.1601 423.719 45.2801C423.719 45.3601 423.879 45.4601 423.829 45.5501C423.829 45.5701 423.789 45.5501 423.789 45.5501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.809 46.0001C423.749 46.0001 423.699 46 423.639 45.97C423.569 45.95 423.509 45.9101 423.459 45.8601C423.449 45.8601 423.429 45.85 423.419 45.84C423.209 45.77 423.049 45.5901 422.999 45.3601C422.989 45.1501 423.059 44.9501 423.199 44.8001C423.209 44.7901 423.22 44.7701 423.23 44.7601C423.27 44.6301 423.389 44.43 423.919 44.39C424.119 44.37 424.309 44.4801 424.389 44.6701C424.469 44.8901 424.409 45.1401 424.249 45.3101C424.319 45.4701 424.31 45.6501 424.22 45.7901C424.18 45.8601 424.119 45.9101 424.059 45.9501C423.989 45.9901 423.899 46.0101 423.819 46.0101L423.809 46.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.149 44.41C401.089 44.32 401.029 44.2201 400.969 44.1201C401.029 44.0801 401.099 44.06 401.179 44.05C401.219 44.05 401.159 44.05 401.149 44.08C401.139 44.15 401.219 44.3 401.149 44.41Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.149 44.8601C401.019 44.8601 400.899 44.8101 400.819 44.7101C400.739 44.6201 400.679 44.5201 400.639 44.4201C400.549 44.3201 400.509 44.1901 400.539 44.0601C400.559 43.9301 400.639 43.8101 400.749 43.7401C400.849 43.6801 400.949 43.6401 401.069 43.6201C401.069 43.6201 401.169 43.6001 401.219 43.6001C401.449 43.6001 401.629 43.7801 401.659 44.0001C401.659 44.0601 401.659 44.1201 401.639 44.1801C401.669 44.3501 401.639 44.5201 401.539 44.6601C401.459 44.7801 401.339 44.8501 401.199 44.8601H401.169H401.149Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.039 56.0001C421.039 56.1401 421.239 56.35 421.189 56.47C421.149 56.58 420.949 56.6101 420.849 56.6901C420.829 56.7001 420.759 56.6901 420.729 56.6901C420.789 56.5901 420.859 56.49 420.939 56.4C421.039 56.27 421.149 56.15 421.269 56.03C421.249 55.95 421.049 55.9801 421.049 56.0001H421.039Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.819 57.15C420.759 57.15 420.699 57.1501 420.639 57.1301C420.509 57.1001 420.399 57.0201 420.339 56.9101C420.279 56.7901 420.269 56.66 420.309 56.53C420.359 56.41 420.429 56.3 420.519 56.21C420.539 56.19 420.549 56.17 420.569 56.15L420.599 56.1101C420.599 56.1101 420.599 56.0401 420.599 56.0101C420.599 55.9801 420.599 55.9401 420.609 55.9101C420.679 55.6701 420.909 55.5201 421.149 55.5501C421.409 55.5301 421.639 55.7001 421.699 55.9501C421.729 56.0801 421.699 56.2101 421.629 56.3101C421.659 56.4301 421.649 56.5501 421.599 56.6601C421.509 56.8401 421.359 56.9801 421.169 57.0501C421.149 57.0501 421.129 57.07 421.109 57.08C421.029 57.14 420.929 57.1701 420.819 57.1701V57.15Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.389 40.11C418.259 40.11 418.129 40.07 418.009 40.02C417.929 39.99 417.839 39.98 417.779 39.89C417.869 39.89 417.919 39.9701 417.979 40.0101C418.109 40.0701 418.229 40.1501 418.339 40.2401C418.399 40.2401 418.399 40.12 418.389 40.11Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.349 40.6801C418.349 40.6801 418.319 40.6801 418.309 40.6801C418.199 40.6801 418.099 40.62 418.019 40.54C417.989 40.52 417.949 40.5 417.919 40.48C417.879 40.46 417.849 40.44 417.809 40.42C417.639 40.37 417.489 40.26 417.399 40.1C417.319 39.96 417.319 39.79 417.399 39.65C417.479 39.51 417.629 39.4301 417.789 39.4301C417.949 39.4301 418.099 39.5 418.219 39.61C418.269 39.63 418.329 39.65 418.389 39.66C418.389 39.66 418.459 39.66 418.499 39.67C418.749 39.74 418.899 39.9901 418.839 40.2401C418.809 40.4901 418.599 40.6801 418.349 40.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.249 43.54C397.319 43.91 397.149 43.99 396.819 43.96C396.799 43.96 396.779 44.01 396.789 43.99C396.789 43.7 396.969 43.31 397.309 43.35C397.339 43.35 397.249 43.52 397.249 43.53V43.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.789 44.4501C396.789 44.4501 396.699 44.4501 396.659 44.4301C396.459 44.3601 396.329 44.1601 396.349 43.9401C396.359 43.6201 396.499 43.3301 396.729 43.1101C396.899 42.9601 397.139 42.88 397.369 42.91C397.509 42.93 397.629 43.0001 397.699 43.1201C397.789 43.2701 397.799 43.4501 397.719 43.6101C397.749 43.8201 397.679 44.0301 397.539 44.1901C397.389 44.3501 397.179 44.4301 396.959 44.4201C396.909 44.4401 396.849 44.4501 396.789 44.4501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.729 38.96C346.619 38.98 346.499 38.9901 346.389 38.9901C346.289 38.9901 346.289 39.0301 346.189 39.0301C346.279 38.9401 346.309 38.58 346.389 38.59C346.499 38.59 346.599 38.8601 346.709 38.9401C346.749 38.9401 346.749 38.96 346.729 38.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.209 39.48H346.179C346.009 39.48 345.859 39.37 345.789 39.22C345.719 39.07 345.739 38.89 345.839 38.76C345.839 38.73 345.859 38.7 345.869 38.67C345.909 38.52 346.029 38.11 346.439 38.14C346.669 38.18 346.869 38.32 346.969 38.53C346.969 38.54 346.989 38.56 346.999 38.57C347.079 38.62 347.129 38.69 347.169 38.77C347.229 38.92 347.209 39.09 347.119 39.22C347.039 39.32 346.929 39.38 346.809 39.4C346.689 39.42 346.559 39.43 346.439 39.44C346.369 39.47 346.299 39.48 346.229 39.48H346.209Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M388.15 40.8C388.28 40.72 388.38 40.63 388.51 40.55C388.45 40.7 388.32 40.8101 388.27 40.9501C388.27 40.9701 388.27 41.11 388.27 41.11C388.18 41.02 388.21 40.79 388.12 40.71C388.08 40.71 388.13 40.81 388.15 40.8Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M388.269 41.5601C388.149 41.5601 388.039 41.5201 387.959 41.4401C387.849 41.3301 387.789 41.2001 387.759 41.0501C387.639 40.8901 387.619 40.6701 387.709 40.4901C387.799 40.3501 387.959 40.2601 388.129 40.2601C388.179 40.2201 388.229 40.1901 388.279 40.1601C388.439 40.0701 388.649 40.0901 388.799 40.2101C388.939 40.3301 388.999 40.5301 388.929 40.7101C388.889 40.8201 388.829 40.92 388.749 41.02C388.739 41.03 388.729 41.0501 388.709 41.0701V41.1001C388.709 41.2201 388.669 41.3401 388.589 41.4301C388.509 41.5201 388.389 41.5701 388.269 41.5701V41.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.559 15.2801C419.589 15.4201 419.579 15.4501 419.609 15.5901C419.519 15.5901 419.459 15.7301 419.369 15.7301C419.419 15.6101 419.439 15.3501 419.489 15.2301C419.499 15.2001 419.729 15.2601 419.739 15.2301L419.559 15.2801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.369 16.18C419.219 16.18 419.079 16.1 418.999 15.98C418.919 15.85 418.899 15.7001 418.959 15.5601C418.969 15.5101 418.979 15.46 418.989 15.41C419.009 15.29 419.039 15.1701 419.079 15.0601C419.189 14.8401 419.439 14.73 419.669 14.79C419.859 14.76 420.049 14.86 420.139 15.04C420.229 15.21 420.189 15.4301 420.059 15.5601C420.069 15.7501 419.959 15.9301 419.779 16.0101C419.679 16.1101 419.549 16.1701 419.409 16.1901C419.399 16.1901 419.379 16.1901 419.369 16.1901V16.18Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.879 27.64C417.889 27.5 418.119 27.41 418.129 27.27C418.129 27.2 417.999 27.04 418.009 26.97C418.029 27.04 418.029 27.11 418.009 27.18C417.969 27.33 417.979 27.46 417.929 27.61C417.889 27.65 417.869 27.66 417.869 27.65L417.879 27.64Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.88 28.09C417.8 28.09 417.72 28.07 417.65 28.02C417.5 27.93 417.42 27.76 417.43 27.59C417.44 27.49 417.48 27.3901 417.53 27.3101C417.53 27.2301 417.55 27.1501 417.57 27.0701C417.56 27.0201 417.56 26.9701 417.57 26.92C417.59 26.72 417.74 26.55 417.94 26.52C418.14 26.49 418.34 26.59 418.42 26.78C418.43 26.81 418.44 26.8401 418.45 26.8801C418.54 27.0101 418.58 27.1601 418.57 27.3201C418.55 27.4801 418.47 27.6301 418.36 27.7401V27.7601C418.33 27.8301 418.29 27.8901 418.24 27.9401C418.14 28.0401 418.01 28.1 417.88 28.1V28.09Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.299 18.2001C424.219 18.2501 424.189 18.2601 424.149 18.2501C424.049 18.2301 423.959 18.1901 423.869 18.1401C423.929 18.1001 423.959 18.2101 424.009 18.2201C424.099 18.2501 424.209 18.1401 424.299 18.2101V18.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.179 18.7001C424.119 18.7001 424.059 18.69 423.999 18.67C423.959 18.67 423.919 18.66 423.879 18.65C423.829 18.63 423.779 18.61 423.739 18.58C423.689 18.56 423.649 18.5301 423.609 18.5001C423.489 18.4101 423.429 18.2701 423.429 18.1301C423.429 17.9801 423.509 17.85 423.629 17.77C423.779 17.67 423.979 17.6601 424.139 17.7501C424.289 17.7201 424.449 17.7601 424.579 17.8601C424.699 17.9501 424.759 18.1001 424.749 18.2401C424.749 18.3901 424.659 18.52 424.529 18.6C424.429 18.67 424.309 18.71 424.189 18.71L424.179 18.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.559 18.73C417.449 18.63 417.489 18.43 417.379 18.33C417.429 18.3 417.499 18.2401 417.549 18.2001C417.599 18.3401 417.649 18.53 417.699 18.67C417.699 18.73 417.569 18.74 417.559 18.72V18.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.589 19.19C417.459 19.19 417.339 19.14 417.249 19.05C417.139 18.93 417.069 18.79 417.039 18.63V18.61C416.959 18.51 416.919 18.38 416.949 18.25C416.979 18.12 417.049 18.01 417.159 17.94C417.209 17.89 417.269 17.85 417.329 17.82C417.449 17.75 417.589 17.74 417.709 17.78C417.839 17.83 417.939 17.93 417.979 18.05C418.009 18.13 418.029 18.22 418.059 18.31C418.079 18.38 418.099 18.46 418.129 18.52C418.159 18.59 418.159 18.67 418.149 18.74C418.109 18.95 417.949 19.12 417.739 19.16C417.689 19.17 417.649 19.18 417.599 19.18L417.589 19.19Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.629 28.84C302.589 28.78 302.849 28.7 302.859 28.65C302.859 28.52 302.679 28.35 302.709 28.23C302.789 28.34 302.979 28.37 303.059 28.48C303.069 28.54 303.079 28.6 303.079 28.66C302.999 28.75 302.839 28.78 302.759 28.87C302.719 28.89 302.669 28.87 302.639 28.84H302.629Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.72 29.33C302.64 29.33 302.56 29.31 302.49 29.28C302.4 29.24 302.33 29.18 302.27 29.1C302.27 29.1 302.22 29.01 302.2 28.96C302.2 28.95 302.2 28.94 302.2 28.93C302.16 28.78 302.2 28.62 302.32 28.5C302.27 28.38 302.26 28.25 302.28 28.13C302.32 27.96 302.45 27.83 302.62 27.79C302.79 27.75 302.97 27.82 303.07 27.96C303.06 27.94 303.08 27.96 303.1 27.96C303.21 28.01 303.32 28.09 303.4 28.19C303.5 28.32 303.54 28.48 303.53 28.65C303.53 28.77 303.49 28.9 303.4 28.99C303.32 29.07 303.23 29.13 303.12 29.18C303.1 29.18 303.08 29.2 303.06 29.21C303.04 29.23 303.02 29.25 302.99 29.26C302.91 29.31 302.81 29.34 302.72 29.34V29.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M351.889 28.9C352.119 28.95 352.179 28.97 352.229 29.09C352.269 29.2 352.369 29.3 352.179 29.49C352.179 29.5 352.099 29.53 352.099 29.52C352.019 29.28 352.129 28.88 352.059 28.64C351.989 28.59 351.879 28.9 351.899 28.91L351.889 28.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M352.099 29.9701C351.879 29.9701 351.699 29.8201 351.649 29.6101C351.619 29.5001 351.609 29.3801 351.609 29.2601C351.509 29.1801 351.449 29.0701 351.429 28.9401C351.429 28.6701 351.559 28.4101 351.779 28.2501C351.939 28.1601 352.139 28.1701 352.289 28.2601C352.379 28.3201 352.439 28.4001 352.469 28.5001C352.489 28.5701 352.509 28.6501 352.509 28.7201C352.559 28.7801 352.599 28.8501 352.629 28.9201C352.799 29.2101 352.739 29.5801 352.479 29.8001C352.379 29.9101 352.229 29.9701 352.089 29.9701H352.099ZM351.839 29.2301L352.129 29.3701V29.3501L351.869 29.1601C351.869 29.1601 351.849 29.2101 351.849 29.2301H351.839Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.409 25.7601C418.539 25.7501 418.639 25.8901 418.769 25.8701C418.759 25.9201 418.739 25.9101 418.729 25.9701C418.619 25.9201 418.639 25.8401 418.539 25.7901C418.509 25.7601 418.459 25.7501 418.419 25.7601H418.409Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.729 26.42C418.659 26.42 418.599 26.41 418.539 26.38C418.449 26.34 418.369 26.28 418.309 26.2C418.119 26.15 417.979 25.99 417.969 25.79C417.959 25.59 418.069 25.41 418.259 25.34C418.439 25.28 418.629 25.3 418.789 25.41L418.819 25.43C418.949 25.45 419.069 25.51 419.139 25.62C419.219 25.73 419.239 25.86 419.209 25.99C419.199 26.04 419.179 26.08 419.159 26.12C419.099 26.3 418.929 26.43 418.729 26.42Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M347.179 36.1901C347.049 36.1901 346.959 35.9701 346.829 35.9701C346.829 35.9401 346.829 35.9001 346.829 35.8701C346.959 35.9101 347.259 35.9101 347.389 35.9501C347.429 36.0301 347.189 36.1901 347.169 36.1901H347.179Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M347.179 36.64C346.989 36.64 346.809 36.54 346.689 36.4C346.489 36.33 346.369 36.14 346.389 35.93C346.389 35.88 346.389 35.85 346.389 35.83C346.399 35.7 346.469 35.57 346.589 35.5C346.699 35.42 346.839 35.4 346.969 35.44C347.029 35.45 347.099 35.46 347.159 35.46C347.289 35.46 347.409 35.49 347.529 35.52C347.649 35.56 347.749 35.6401 347.809 35.7601C347.889 35.9401 347.859 36.16 347.729 36.31C347.599 36.49 347.399 36.6 347.189 36.64H347.179Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.529 28.8701C346.589 28.9001 346.609 29.1401 346.629 29.1901C346.649 29.2401 346.719 29.2901 346.699 29.3501C346.639 29.3101 346.419 29.3401 346.389 29.2801C346.419 29.1401 346.469 29.0001 346.529 28.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.699 29.8001C346.649 29.8001 346.599 29.8001 346.549 29.7701C346.319 29.7801 346.099 29.6701 345.989 29.4701C345.889 29.2701 345.959 29.0801 346.089 28.7701L346.109 28.7101C346.159 28.5801 346.259 28.4902 346.379 28.4402C346.509 28.4002 346.649 28.4101 346.759 28.4801C346.929 28.6101 347.039 28.8002 347.049 29.0102C347.139 29.1502 347.169 29.3201 347.119 29.4701C347.059 29.6601 346.889 29.7801 346.689 29.7801L346.699 29.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.259 53.9901C424.259 53.9901 424.039 54.17 424.009 54.22C423.969 54.17 423.739 54.16 423.719 54.1C423.719 54.08 423.929 54.06 423.949 54.03C423.999 54.06 424.219 53.9601 424.269 53.9901H424.259Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.99 54.6902C423.9 54.6902 423.82 54.6601 423.75 54.6001C423.56 54.5701 423.39 54.4501 423.3 54.2801C423.25 54.1601 423.25 54.0101 423.31 53.8901C423.39 53.7401 423.55 53.6402 423.72 53.6302C423.72 53.6302 423.78 53.6101 423.81 53.6001C423.86 53.5901 423.91 53.5801 423.96 53.5801C424.14 53.5101 424.33 53.5201 424.5 53.6101C424.6 53.6801 424.68 53.7801 424.7 53.9001C424.72 54.0201 424.7 54.1501 424.63 54.2501C424.57 54.3301 424.5 54.3902 424.42 54.4502C424.39 54.4702 424.36 54.5001 424.34 54.5201C424.26 54.6301 424.13 54.6902 423.99 54.6902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M409.339 32.0102C409.279 32.0102 409.249 32.2001 409.189 32.2101C409.189 32.1801 409.299 32.2301 409.319 32.2301C409.369 32.2101 409.299 32.1601 409.359 32.1501C409.359 32.1801 409.359 31.9802 409.349 32.0102H409.339Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M409.319 32.67C409.319 32.67 409.239 32.67 409.199 32.66C409.069 32.66 408.949 32.61 408.869 32.52C408.769 32.41 408.729 32.26 408.759 32.12C408.779 32.03 408.819 31.95 408.889 31.89C408.939 31.77 409.029 31.68 409.149 31.61C409.219 31.57 409.299 31.55 409.369 31.56C409.469 31.56 409.789 31.61 409.809 32.06C409.809 32.06 409.819 32.15 409.809 32.19C409.809 32.23 409.799 32.27 409.779 32.31C409.739 32.46 409.639 32.58 409.489 32.64C409.439 32.66 409.379 32.67 409.319 32.67Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M322.439 26.3601C322.529 26.2301 322.629 26.1201 322.719 25.9901C322.749 26.0101 322.549 25.8301 322.579 25.8501C322.459 25.9501 322.479 26.17 322.349 26.27C322.329 26.33 322.429 26.3701 322.439 26.3601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M322.429 26.8C322.339 26.8 322.239 26.78 322.159 26.73C321.959 26.61 321.859 26.37 321.919 26.15C321.939 26.08 321.979 26.02 322.019 25.97C322.019 25.96 322.019 25.94 322.029 25.93C322.069 25.8 322.129 25.68 322.219 25.58C322.369 25.39 322.639 25.36 322.829 25.5C322.859 25.52 322.889 25.54 322.909 25.57L322.949 25.61C323.279 25.92 323.169 26.17 323.069 26.29L323.049 26.31C323.009 26.37 322.969 26.42 322.919 26.47C322.879 26.52 322.839 26.57 322.799 26.62C322.779 26.65 322.759 26.67 322.739 26.69C322.649 26.77 322.529 26.81 322.409 26.81L322.429 26.8Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M416.589 27.0601C416.529 27.0801 416.469 27.1 416.409 27.1C416.369 27.06 416.119 27.08 416.079 27.03C416.159 27 416.239 26.9701 416.319 26.9501C416.369 27.0001 416.539 27.0101 416.579 27.0601H416.589Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M416.43 27.5601C416.37 27.5601 416.31 27.5601 416.25 27.5301H416.22C416.04 27.5301 415.86 27.4601 415.74 27.3201C415.66 27.2301 415.63 27.1001 415.64 26.9801C415.65 26.8601 415.72 26.7501 415.81 26.6801C415.81 26.6801 416.24 26.3801 416.55 26.5701C416.69 26.6001 416.82 26.6701 416.92 26.7701C417.01 26.8701 417.05 27.0101 417.02 27.1501C416.99 27.2901 416.91 27.4001 416.79 27.4601C416.68 27.5201 416.55 27.5501 416.42 27.5601H416.43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.48 27.7001C300.51 27.6401 300.41 27.43 300.46 27.39C300.53 27.33 300.78 27.5901 300.86 27.5401C300.87 27.5701 300.87 27.46 300.86 27.47C300.8 27.54 300.69 27.54 300.61 27.58C300.56 27.61 300.61 27.8701 300.53 27.8701C300.51 27.8701 300.45 27.7001 300.47 27.7001H300.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.559 28.3299C300.369 28.3299 300.189 28.2099 300.109 28.0299C300.049 27.9099 300.029 27.7899 300.029 27.6599C299.949 27.4499 300.009 27.21 300.169 27.06C300.349 26.91 300.619 26.8999 300.809 27.0399C300.899 27.0299 300.979 27.0399 301.059 27.0799C301.259 27.1799 301.359 27.4 301.309 27.62C301.279 27.8 301.149 27.94 300.979 27.99C300.929 28.19 300.759 28.3199 300.549 28.3299H300.559Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.809 52.5101C382.929 52.4701 383.029 52.27 383.139 52.23C383.139 52.29 383.179 52.48 383.179 52.54C383.049 52.51 382.699 52.2301 382.569 52.1901C382.519 52.2801 382.779 52.5001 382.799 52.5001L382.809 52.5101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.179 52.9901C383.179 52.9901 383.109 52.9901 383.069 52.9801C383.029 52.9701 382.989 52.9501 382.949 52.9301C382.919 52.9401 382.879 52.9501 382.849 52.9501C382.509 52.9801 382.249 52.5901 382.219 52.5501C382.099 52.3801 382.079 52.1501 382.189 51.9701C382.289 51.8001 382.489 51.7101 382.689 51.7601C382.759 51.7801 382.839 51.8101 382.899 51.8501C382.929 51.8301 382.969 51.8201 382.999 51.8101C383.139 51.7601 383.289 51.7901 383.409 51.8701C383.529 51.9501 383.599 52.0901 383.599 52.2401C383.599 52.2501 383.599 52.2901 383.609 52.3201C383.619 52.4001 383.629 52.4701 383.639 52.5501C383.639 52.8001 383.439 53.0001 383.189 53.0001L383.179 52.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.479 43.16C396.439 43.28 396.399 43.41 396.359 43.53C396.319 43.5 396.059 43.33 396.009 43.3C396.099 43.22 396.309 43.18 396.409 43.1C396.449 43.09 396.499 43.15 396.489 43.16H396.479Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.36 43.98C396.27 43.98 396.18 43.9499 396.11 43.8999L395.76 43.67C395.64 43.59 395.57 43.4599 395.56 43.3299C395.56 43.1899 395.61 43.0599 395.71 42.9599C395.81 42.8799 395.92 42.8199 396.03 42.7799C396.06 42.7699 396.09 42.75 396.12 42.74C396.16 42.7 396.21 42.6799 396.27 42.6599C396.45 42.6099 396.64 42.6599 396.77 42.7899C396.9 42.9199 396.95 43.1199 396.89 43.2899L396.77 43.6599C396.71 43.8399 396.54 43.9699 396.34 43.9699L396.36 43.98Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.65 33.9501C346.53 33.9001 346.46 34.0001 346.33 33.9501C346.46 33.8501 346.5 33.8501 346.63 33.7401C346.53 33.6701 346.42 33.6101 346.31 33.5601C346.31 33.7301 346.5 34.05 346.5 34.21C346.62 34.21 346.67 33.9501 346.65 33.9401V33.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.5 34.68H346.46C346.26 34.66 346.09 34.52 346.05 34.32C345.96 34.25 345.9 34.15 345.88 34.04C345.87 33.97 345.88 33.91 345.89 33.84C345.86 33.75 345.85 33.66 345.85 33.57C345.85 33.54 345.85 33.51 345.86 33.48C345.89 33.34 345.99 33.22 346.12 33.16C346.35 33.06 346.51 33.16 346.85 33.37C347 33.46 347.08 33.63 347.06 33.81C347.1 33.96 347.09 34.13 347.02 34.27C346.95 34.51 346.73 34.67 346.48 34.68H346.5Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.159 28.39C418.159 28.39 418.149 28.3 418.099 28.34C418.069 28.27 418.059 28.37 418.049 28.3C418.049 28.25 418.079 28.2 418.129 28.17C418.149 28.23 418.129 28.33 418.159 28.39Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.14 28.85C418.01 28.85 417.89 28.8 417.81 28.7C417.69 28.61 417.61 28.47 417.6 28.32C417.6 28.09 417.72 27.8699 417.93 27.7699C418.05 27.7099 418.18 27.71 418.3 27.76C418.42 27.81 418.51 27.91 418.55 28.03C418.58 28.11 418.59 28.1899 418.59 28.2699C418.65 28.4499 418.59 28.65 418.43 28.76C418.35 28.82 418.24 28.86 418.14 28.86V28.85ZM418.2 28.3L418.34 28.57C418.45 28.52 418.52 28.4 418.51 28.28L418.2 28.3Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M384.059 56.37C383.999 56.4 384.169 56.42 384.109 56.41C384.009 56.41 383.909 56.39 383.819 56.36C383.879 56.33 384.059 56.4401 384.109 56.4501C384.159 56.4601 383.999 56.33 384.059 56.37Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M384.119 56.9H384.109C384.029 56.9 383.949 56.88 383.879 56.84C383.779 56.83 383.689 56.7901 383.599 56.7501C383.459 56.6701 383.379 56.52 383.379 56.36C383.379 56.2 383.469 56.06 383.609 55.98C383.719 55.92 383.859 55.9 383.989 55.93C384.109 55.91 384.229 55.9301 384.319 56.0001C384.349 56.0201 384.379 56.0501 384.409 56.0701C384.489 56.1401 384.549 56.23 384.579 56.33C384.599 56.42 384.599 56.52 384.559 56.6C384.489 56.78 384.319 56.89 384.129 56.89L384.119 56.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.029 50.7601C382.969 50.7601 382.919 50.5801 382.889 50.5601C382.829 50.5201 382.679 50.6301 382.629 50.5601C382.699 50.5501 382.719 50.6101 382.759 50.6301C382.809 50.6601 382.989 50.6701 383.029 50.7501V50.7601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.019 51.21C382.909 51.21 382.799 51.17 382.719 51.1C382.659 51.09 382.599 51.06 382.539 51.04C382.519 51.04 382.509 51.02 382.499 51.01C382.409 50.98 382.329 50.92 382.269 50.85C382.169 50.73 382.149 50.57 382.199 50.42C382.249 50.27 382.379 50.17 382.529 50.13C382.589 50.12 382.639 50.11 382.699 50.13C382.849 50.09 383.009 50.11 383.139 50.2C383.219 50.26 383.279 50.33 383.319 50.42C383.369 50.46 383.399 50.51 383.429 50.57C383.499 50.7 383.489 50.86 383.419 50.99C383.349 51.12 383.209 51.2 383.059 51.22C383.049 51.22 383.029 51.22 383.019 51.22V51.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.79 17.3801C417.7 17.3201 417.65 17.2 417.56 17.14C417.61 17.1 417.77 16.9901 417.82 16.9501C417.85 17.0601 418.01 17.2501 418.04 17.3701C418.02 17.4301 417.81 17.41 417.79 17.39V17.3801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.909 17.85C417.779 17.85 417.649 17.8201 417.539 17.7501C417.459 17.6901 417.379 17.62 417.319 17.53C417.199 17.45 417.129 17.32 417.119 17.17C417.109 17.03 417.159 16.89 417.269 16.79C417.299 16.76 417.359 16.72 417.429 16.67C417.469 16.64 417.509 16.61 417.529 16.6C417.649 16.5 417.799 16.4701 417.949 16.5101C418.089 16.5501 418.209 16.6601 418.249 16.8101C418.259 16.8301 418.289 16.87 418.309 16.91C418.379 17.01 418.429 17.11 418.469 17.22C418.499 17.3 418.499 17.39 418.469 17.48C418.409 17.67 418.239 17.81 418.049 17.83C418.009 17.83 417.959 17.84 417.909 17.84V17.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.119 46.09C396.889 46.04 396.689 45.9701 396.979 45.6201C396.989 45.6001 396.859 45.5401 396.869 45.5601C396.949 45.7201 396.869 45.93 396.949 46.08C396.959 46.12 397.139 46.09 397.119 46.08V46.09Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.019 46.56C396.829 46.57 396.659 46.4801 396.559 46.3201C396.499 46.2601 396.449 46.18 396.419 46.09C396.379 45.95 396.379 45.81 396.419 45.68C396.369 45.49 396.439 45.29 396.609 45.19C396.839 45.07 397.109 45.12 397.289 45.3C397.399 45.42 397.449 45.59 397.399 45.75C397.519 45.85 397.579 46 397.559 46.16C397.509 46.37 397.329 46.53 397.109 46.56C397.079 46.56 397.049 46.56 397.019 46.56ZM396.689 45.96C396.819 46.03 396.989 46.02 397.109 45.93L396.939 45.68C396.939 45.68 396.889 45.71 396.859 45.72L396.759 45.8201C396.759 45.8201 396.699 45.91 396.689 45.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M366.729 29.41C366.729 29.41 366.519 29.44 366.539 29.41C366.549 29.39 366.819 29.6699 366.839 29.6499C366.879 29.6199 366.769 29.42 366.729 29.41Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M366.839 30.1C366.659 30.08 366.489 29.99 366.379 29.85L366.339 29.8201C366.269 29.7901 366.199 29.73 366.159 29.66C366.069 29.52 366.059 29.3401 366.139 29.1901C366.209 29.0701 366.329 28.98 366.459 28.96C366.519 28.95 366.579 28.96 366.629 28.96C366.689 28.96 366.759 28.96 366.819 28.96C367.169 29.04 367.269 29.5001 367.269 29.5101C367.299 29.7001 367.229 29.88 367.079 30C367.009 30.06 366.919 30.09 366.829 30.09L366.839 30.1ZM366.539 29.31C366.449 29.39 366.389 29.51 366.399 29.64L366.549 29.4501V29.41H366.539V29.31Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.159 29.1C289.189 29.02 289.509 29.14 289.529 29.06C289.539 29.09 288.819 28.47 288.809 28.49C288.769 28.54 289.329 28.95 289.289 29C289.219 29 289.149 29.12 289.159 29.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.159 29.5501C289.029 29.5501 288.909 29.4901 288.819 29.4001C288.729 29.3001 288.699 29.1701 288.709 29.0401C288.479 28.8401 288.209 28.5701 288.439 28.2301C288.509 28.1301 288.619 28.0601 288.749 28.0401C288.959 28.0101 288.999 28.0401 289.479 28.4401C289.599 28.5401 289.709 28.6301 289.759 28.6701H289.779C289.939 28.8001 290.009 29.0001 289.949 29.1901C289.889 29.3701 289.729 29.5801 289.289 29.5201C289.239 29.5401 289.199 29.5401 289.149 29.5401L289.159 29.5501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.839 53.28C382.839 53.28 382.939 53.34 382.969 53.33C382.969 53.37 382.859 53.28 382.869 53.32C382.839 53.32 383.039 53.27 383.019 53.25C382.999 53.25 382.839 53.3 382.829 53.28H382.839Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.959 53.78C382.959 53.78 382.879 53.78 382.839 53.77C382.619 53.76 382.439 53.6 382.399 53.39C382.359 53.18 382.469 52.9601 382.659 52.8701C382.719 52.8501 382.779 52.84 382.839 52.83C382.969 52.79 383.119 52.8001 383.239 52.8701C383.389 52.9601 383.479 53.1301 383.459 53.3101C383.459 53.4001 383.409 53.4901 383.349 53.5601C383.319 53.6101 383.279 53.6501 383.239 53.6901C383.159 53.7501 383.049 53.78 382.949 53.78H382.959Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.439 39.58C383.409 39.67 383.619 39.94 383.589 40.03C383.589 40 383.449 39.9 383.459 39.89C383.499 39.83 383.529 39.83 383.579 39.78C383.519 39.67 383.459 39.57 383.439 39.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.59 40.47C383.45 40.47 383.319 40.4 383.239 40.29C383.079 40.17 383 39.9799 383.03 39.7799C382.99 39.6699 382.99 39.55 383.03 39.43C383.05 39.37 383.079 39.3199 383.119 39.2699C383.209 39.1599 383.359 39.1 383.509 39.11C383.759 39.13 383.869 39.3299 383.989 39.5299C384.039 39.6199 384.06 39.7199 384.04 39.8299C384.07 39.9299 384.07 40.0399 384.04 40.1399C383.98 40.3299 383.809 40.45 383.609 40.45L383.59 40.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.099 40.46C419.019 40.3 419.129 40.08 419.049 39.92C419.039 39.9 419.079 39.78 419.089 39.79C419.169 39.79 419.079 39.84 419.159 39.84C419.239 39.87 419.319 39.92 419.379 39.98C419.379 40.14 419.249 40.3 419.259 40.46C419.229 40.52 419.109 40.48 419.099 40.46Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.179 40.9401C419.179 40.9401 419.129 40.9401 419.109 40.9401C418.929 40.9301 418.759 40.8201 418.689 40.6501C418.629 40.5001 418.599 40.3301 418.629 40.1601C418.629 40.1401 418.629 40.1101 418.629 40.0901C418.569 39.9001 418.609 39.6801 418.729 39.5201C418.819 39.4101 418.949 39.3501 419.089 39.3501C419.209 39.3501 419.319 39.3801 419.409 39.4601C419.469 39.4901 419.529 39.5301 419.589 39.5701C419.749 39.6601 419.839 39.8301 419.839 40.0101C419.839 40.1401 419.799 40.2701 419.749 40.4001C419.739 40.4301 419.729 40.4601 419.719 40.4901C419.719 40.5601 419.699 40.6401 419.659 40.7001C419.569 40.8601 419.389 40.9601 419.199 40.9601L419.179 40.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.919 41.21C382.919 41.21 382.899 41.26 382.879 41.29C382.869 41.26 382.779 41.22 382.779 41.19C382.779 41.16 382.859 41.3 382.869 41.27C382.879 41.3 382.899 41.17 382.909 41.21H382.919Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.879 41.7401C382.879 41.7401 382.839 41.7401 382.829 41.7401C382.729 41.7301 382.639 41.6801 382.559 41.6101C382.549 41.6001 382.539 41.5901 382.529 41.5801C382.389 41.4801 382.319 41.3101 382.339 41.1401C382.359 40.9601 382.489 40.8101 382.669 40.7601C382.739 40.7401 382.809 40.7401 382.879 40.7601H382.909C383.099 40.7601 383.279 40.8801 383.339 41.0701C383.379 41.1801 383.369 41.3101 383.309 41.4201C383.289 41.4601 383.269 41.5101 383.249 41.5501C383.169 41.6801 383.029 41.7501 382.879 41.7501V41.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.89 17.5801C417.81 17.6301 417.64 17.9601 417.56 18.0201C417.65 17.9801 417.74 17.7901 417.82 17.7501C417.84 17.6501 417.9 17.5801 417.88 17.5901L417.89 17.5801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.559 18.47C417.369 18.47 417.209 18.35 417.139 18.18C417.069 18.01 417.119 17.81 417.259 17.68C417.289 17.65 417.309 17.6 417.339 17.55C417.409 17.42 417.509 17.3001 417.629 17.2001C417.669 17.1701 417.719 17.15 417.769 17.14C417.949 17.09 418.129 17.16 418.239 17.3C418.349 17.45 418.359 17.6601 418.259 17.8201C418.239 17.9401 418.169 18.04 418.069 18.11C418.059 18.12 418.049 18.14 418.039 18.15C417.969 18.26 417.869 18.35 417.749 18.41C417.689 18.44 417.619 18.46 417.549 18.46L417.559 18.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.219 49.33C383.159 49.24 383.329 49.12 383.269 49.04C383.319 49.13 383.319 49.18 383.369 49.27C383.309 49.34 383.229 49.35 383.219 49.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M383.249 49.79C383.249 49.79 383.189 49.79 383.149 49.79C383.029 49.77 382.929 49.7 382.849 49.6C382.719 49.42 382.719 49.18 382.839 48.99C382.859 48.87 382.929 48.76 383.029 48.7C383.219 48.56 383.479 48.6 383.629 48.79C383.649 48.82 383.669 48.8599 383.689 48.8999C383.709 48.9399 383.729 48.9799 383.739 49.0199C383.829 49.1899 383.829 49.4 383.719 49.57C383.609 49.72 383.429 49.81 383.239 49.81L383.249 49.79ZM382.849 48.98C382.829 49.06 382.829 49.15 382.869 49.23C382.839 49.15 382.839 49.07 382.849 48.98ZM383.249 48.8899C383.159 48.8899 383.069 48.93 383.019 49L383.169 49.12L383.289 49.0299L383.319 48.8999C383.319 48.8999 383.269 48.8999 383.249 48.8999V48.8899Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.459 15.65C417.459 15.65 417.399 15.76 417.399 15.77C417.399 15.8 417.629 15.9201 417.619 15.9501C417.599 15.9401 417.619 15.84 417.619 15.83C417.619 15.8 417.449 15.68 417.459 15.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.619 16.4C417.539 16.4 417.469 16.38 417.399 16.34C417.349 16.31 417.309 16.2801 417.279 16.2401L417.259 16.22C417.079 16.13 416.969 15.9501 416.959 15.7501C416.959 15.6601 416.999 15.5701 417.049 15.4901C417.099 15.3701 417.199 15.27 417.319 15.22C417.439 15.18 417.579 15.1901 417.699 15.2601C417.759 15.2901 417.809 15.34 417.849 15.4C417.989 15.5 418.079 15.66 418.089 15.83C418.089 15.86 418.089 15.8901 418.089 15.9201C418.089 15.9701 418.089 16.0201 418.069 16.0701C418.019 16.2601 417.839 16.4 417.639 16.4H417.619Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M362.22 51.5C362.18 51.55 362.22 51.66 362.17 51.71C362.16 51.72 362.09 51.68 362.06 51.68C362.14 51.64 362.16 51.68 362.23 51.65C362.25 51.65 362.23 51.5 362.21 51.51L362.22 51.5Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M362.169 52.16C362.089 52.16 362.009 52.14 361.929 52.11C361.739 52.08 361.599 51.92 361.589 51.73C361.569 51.56 361.659 51.39 361.809 51.3C361.829 51.27 361.849 51.24 361.869 51.21C361.919 51.15 361.989 51.1 362.059 51.07C362.219 51.01 362.409 51.05 362.529 51.18C362.669 51.35 362.719 51.57 362.659 51.78C362.629 51.86 362.579 51.94 362.509 51.99C362.499 52 362.479 52.02 362.469 52.03C362.389 52.11 362.279 52.15 362.169 52.15V52.16ZM361.819 51.49C361.769 51.61 361.799 51.74 361.899 51.82L362.069 51.63L362.009 51.56L361.809 51.49H361.819Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.269 42.59C346.169 42.58 346.039 42.66 345.929 42.65C345.959 42.6 345.909 42.82 345.929 42.77C345.999 42.84 346.219 42.88 346.289 42.94C346.369 42.89 346.279 42.59 346.259 42.59H346.269Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.299 43.39C346.199 43.39 346.109 43.36 346.029 43.3C346.009 43.3 345.989 43.28 345.959 43.28C345.889 43.26 345.829 43.2301 345.759 43.2001C345.559 43.1201 345.439 42.91 345.479 42.69C345.479 42.59 345.489 42.49 345.549 42.41C345.629 42.27 345.789 42.1901 345.949 42.2001C346.069 42.1601 346.189 42.14 346.319 42.15C346.359 42.15 346.399 42.17 346.439 42.18C346.659 42.3 346.789 42.54 346.779 42.79C346.809 43 346.719 43.22 346.529 43.33C346.459 43.37 346.379 43.4 346.299 43.4V43.39Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.739 18.5C417.829 18.51 417.809 18.72 417.899 18.73C417.879 18.73 417.819 18.8399 417.809 18.8299C417.749 18.8099 417.829 18.6699 417.779 18.6399C417.779 18.5599 417.729 18.49 417.749 18.5H417.739Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.809 19.28C417.759 19.28 417.709 19.28 417.659 19.25C417.449 19.17 417.319 18.97 417.339 18.74C417.339 18.71 417.329 18.6799 417.329 18.6499C417.259 18.4799 417.299 18.29 417.439 18.16C417.539 18.07 417.679 18.03 417.809 18.05C418.009 18.08 418.169 18.22 418.229 18.41C418.289 18.48 418.329 18.5599 418.349 18.6499C418.369 18.7899 418.329 18.93 418.229 19.04C418.139 19.18 417.989 19.27 417.819 19.28H417.809Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M400.97 43.6C400.97 43.6 400.99 43.6201 401 43.6301C400.97 43.6301 400.93 43.85 400.9 43.84C400.9 43.84 400.86 43.57 400.85 43.55C400.88 43.55 400.95 43.6 400.97 43.59V43.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M400.899 44.3001C400.899 44.3001 400.859 44.3001 400.839 44.3001C400.489 44.2601 400.439 43.9501 400.419 43.7501V43.6701C400.379 43.5601 400.399 43.4501 400.449 43.3501C400.519 43.2301 400.629 43.1501 400.769 43.1301C400.879 43.1301 400.989 43.1401 401.089 43.1801C401.189 43.2101 401.269 43.2701 401.329 43.3501C401.359 43.3901 401.389 43.4301 401.409 43.4701C401.459 43.5901 401.459 43.7301 401.389 43.8501L401.369 43.8801C401.259 44.1701 401.109 44.3001 400.899 44.3001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.979 54.6901C298.049 54.6601 298.129 54.65 298.209 54.64C298.269 54.65 298.369 54.5301 298.429 54.5601C298.409 54.5801 298.379 54.52 298.359 54.52C298.299 54.51 298.029 54.7101 297.969 54.6901H297.979Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.989 55.1401C297.919 55.1401 297.859 55.1301 297.799 55.1001C297.659 55.0401 297.559 54.9102 297.539 54.7502C297.519 54.6002 297.579 54.4401 297.699 54.3401C297.769 54.2901 297.849 54.2501 297.929 54.2301L297.969 54.2101C298.119 54.1001 298.299 54.0501 298.479 54.0801C298.539 54.1001 298.589 54.1201 298.639 54.1601C298.769 54.2301 298.869 54.3502 298.889 54.5002C298.909 54.6502 298.849 54.8001 298.739 54.9001C298.679 54.9501 298.609 54.9902 298.529 55.0102C298.439 55.0702 298.329 55.1001 298.219 55.1001C298.149 55.1301 298.079 55.1501 297.999 55.1501L297.989 55.1401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M310.409 29.16C310.409 29.31 310.539 29.5 310.539 29.65C310.539 29.67 310.689 29.65 310.689 29.65C310.689 29.49 310.659 29.29 310.659 29.13C310.579 29.06 310.409 29.13 310.409 29.15V29.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M310.629 30.1001C310.219 30.1001 310.119 29.8601 310.099 29.7101C310.099 29.6901 310.099 29.6701 310.099 29.6501C310.099 29.6301 310.079 29.6001 310.059 29.5601C309.999 29.4301 309.969 29.3001 309.959 29.1601C309.959 29.1301 309.959 29.1101 309.959 29.0801C309.999 28.8901 310.139 28.7401 310.319 28.6901C310.529 28.6101 310.769 28.6401 310.949 28.7901C311.039 28.8701 311.099 29.0001 311.099 29.1201C311.099 29.1901 311.099 29.2701 311.109 29.3401C311.109 29.4401 311.129 29.5401 311.129 29.6401C311.129 29.8801 310.949 30.0701 310.719 30.0901C310.689 30.0901 310.649 30.0901 310.619 30.0901L310.629 30.1001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M283.839 35.8401C283.839 35.7901 283.949 35.7201 283.999 35.7501C284.029 35.7601 283.999 35.9101 283.969 35.9201C283.939 35.9301 283.909 35.9301 283.879 35.9201C283.849 35.9001 283.839 35.8801 283.839 35.8501V35.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M283.93 36.3701C283.82 36.3701 283.71 36.3301 283.61 36.2701C283.45 36.1601 283.36 35.9701 283.39 35.7701C283.42 35.5901 283.53 35.4401 283.69 35.3601C283.84 35.2701 284.02 35.2601 284.18 35.3301C284.34 35.4101 284.45 35.5802 284.46 35.7602C284.47 35.9802 284.37 36.1901 284.18 36.3101C284.1 36.3501 284.02 36.3701 283.93 36.3701ZM284.01 35.7701L283.809 36.1501C283.909 36.2001 284.02 36.2001 284.12 36.1501C284.21 36.0901 284.269 36.0001 284.279 35.9001C284.299 35.7601 284.24 35.6201 284.13 35.5401C284.02 35.4601 283.88 35.4501 283.76 35.5201C283.65 35.5701 283.569 35.6801 283.559 35.8001H284.01V35.7701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M320.039 30.35C319.989 30.32 319.929 30.17 319.879 30.14C319.899 30.12 319.879 30.27 319.899 30.28C319.959 30.3 320.039 30.1501 320.089 30.1801C320.059 30.2001 320.059 30.33 320.039 30.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M320.039 30.8C319.969 30.8 319.899 30.7801 319.839 30.7501C319.819 30.7401 319.799 30.73 319.779 30.71C319.599 30.59 319.469 30.4001 319.439 30.1901C319.419 30.0401 319.479 29.89 319.599 29.8C319.729 29.69 319.909 29.66 320.069 29.73C320.149 29.73 320.239 29.74 320.309 29.78C320.439 29.85 320.529 29.99 320.549 30.14C320.549 30.21 320.549 30.29 320.519 30.36C320.499 30.5 320.429 30.62 320.329 30.71C320.249 30.77 320.159 30.8 320.059 30.8H320.039Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.469 30.5C287.399 30.56 287.329 30.62 287.259 30.68C287.239 30.64 287.309 30.78 287.289 30.74C287.389 30.74 287.499 30.69 287.599 30.68C287.629 30.65 287.48 30.5 287.46 30.5H287.469Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.329 31.1801C287.149 31.1801 286.979 31.08 286.889 30.92C286.889 30.92 286.879 30.9001 286.869 30.8801C286.759 30.6601 286.829 30.4 287.039 30.27L287.069 30.2501C287.069 30.2501 287.149 30.17 287.199 30.14C287.239 30.11 287.289 30.0801 287.349 30.0601C287.719 29.9501 287.959 30.32 287.999 30.4C288.109 30.59 288.069 30.8401 287.919 31.0001C287.849 31.0701 287.749 31.1101 287.649 31.1201C287.619 31.1201 287.599 31.13 287.569 31.14C287.529 31.15 287.489 31.16 287.449 31.17C287.409 31.18 287.379 31.1901 287.339 31.1801H287.329Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.279 56.4901C422.279 56.4901 422.149 56.6101 422.189 56.6101C422.229 56.6101 422.229 56.4501 422.249 56.4801C422.279 56.5101 422.279 56.5101 422.269 56.4901H422.279Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.179 57.05H422.149C421.909 57.03 421.729 56.83 421.729 56.59C421.729 56.43 421.809 56.28 421.919 56.17C421.969 56.11 422.039 56.06 422.109 56.03C422.209 56 422.329 56.01 422.419 56.05C422.569 56.11 422.669 56.24 422.699 56.39C422.719 56.55 422.679 56.7 422.569 56.8C422.489 56.95 422.329 57.04 422.159 57.04L422.179 57.05ZM421.819 56.46C421.819 56.46 421.819 56.53 421.819 56.56L421.989 56.53L421.819 56.46Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.689 56.4501C417.689 56.4501 417.749 56.4801 417.759 56.4501C417.759 56.4101 417.629 56.5201 417.679 56.5301C417.709 56.5301 417.719 56.4501 417.699 56.4601L417.689 56.4501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.669 56.9701C417.669 56.9701 417.609 56.9701 417.589 56.9701C417.349 56.9201 417.189 56.6801 417.229 56.4401C417.229 56.4101 417.239 56.3801 417.249 56.3601C417.289 56.2001 417.419 56.0801 417.569 56.0301H417.579C417.649 56.0001 417.729 55.9901 417.809 56.0001C418.049 56.0401 418.219 56.2601 418.189 56.5101C418.179 56.6101 418.129 56.7001 418.059 56.7701C417.969 56.9001 417.819 56.9801 417.659 56.9901L417.669 56.9701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.35 36.76C418.34 36.86 418.54 37.07 418.53 37.17C418.49 37.14 418.29 37.05 418.25 37.02C418.31 36.95 418.63 36.79 418.69 36.73C418.63 36.64 418.35 36.74 418.35 36.75V36.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.519 37.6301C418.429 37.6301 418.349 37.6001 418.269 37.5601C418.259 37.5601 418.219 37.5301 418.169 37.5101C418.089 37.4701 418.019 37.4301 417.989 37.4101C417.879 37.3401 417.809 37.2301 417.789 37.1001C417.769 36.9701 417.809 36.8401 417.889 36.7501C417.889 36.7401 417.889 36.72 417.889 36.71C417.889 36.67 417.899 36.6301 417.919 36.6001C418.029 36.3901 418.249 36.2601 418.479 36.2601C418.699 36.2201 418.909 36.3001 419.039 36.4801C419.159 36.6601 419.139 36.8901 418.999 37.0501C418.989 37.0701 418.969 37.0801 418.949 37.0901C418.949 37.1401 418.949 37.1801 418.949 37.2301C418.919 37.4601 418.729 37.6201 418.499 37.6201L418.519 37.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M388.209 54.3801C388.289 54.3801 388.369 54.3801 388.439 54.3901C388.459 54.4201 388.229 54.3901 388.239 54.4201C388.199 54.4201 388.339 54.4901 388.299 54.4901C388.309 54.4501 388.199 54.4101 388.209 54.3801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M388.299 54.9401H388.269C388.149 54.9301 388.039 54.8701 387.969 54.7901C387.929 54.7501 387.889 54.7101 387.859 54.6601C387.769 54.5401 387.749 54.4001 387.789 54.2601C387.849 54.0601 388.039 53.9201 388.249 53.9401C388.499 53.9401 388.729 53.9501 388.849 54.1901C388.919 54.3301 388.919 54.5001 388.829 54.6401C388.779 54.7201 388.709 54.7801 388.619 54.8201C388.529 54.9001 388.419 54.9401 388.309 54.9401H388.299Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M349.81 55.72C350.02 55.72 350.01 56.2 349.8 56.22C349.56 56.24 349.6 55.72 349.81 55.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M349.779 56.67C349.579 56.67 349.399 56.57 349.299 56.41C349.149 56.16 349.149 55.86 349.279 55.6C349.379 55.4 349.579 55.27 349.809 55.27C350.149 55.28 350.419 55.57 350.409 55.91C350.449 56.28 350.199 56.61 349.839 56.67C349.819 56.67 349.799 56.67 349.779 56.67ZM349.779 55.77H349.749C349.639 55.77 349.539 55.8501 349.509 55.9501C349.549 56.0801 349.669 56.17 349.809 56.17C349.919 56.17 350.019 56.12 350.069 56.03C350.069 56.01 350.089 55.99 350.049 55.91C349.989 55.82 349.889 55.77 349.779 55.77Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.169 53.04C346.169 53.04 345.969 52.9301 346.009 52.9401C345.979 52.9201 345.989 52.8901 345.959 52.8701C345.999 52.8401 346.159 53.02 346.169 53.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.169 53.4801C346.169 53.4801 346.109 53.4801 346.079 53.4801C346.009 53.4701 345.949 53.4401 345.889 53.4001C345.849 53.3801 345.809 53.3501 345.779 53.3201C345.709 53.2801 345.649 53.2201 345.609 53.1401C345.539 53.0401 345.499 52.9201 345.519 52.8001C345.539 52.6801 345.599 52.5701 345.699 52.5001C345.829 52.4101 345.989 52.3901 346.129 52.4401C346.329 52.5301 346.489 52.6801 346.589 52.8801C346.629 52.9801 346.629 53.0901 346.589 53.1901C346.519 53.3701 346.349 53.4901 346.159 53.4901L346.169 53.4801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M310.529 52.4201C310.529 52.4201 310.719 52.3901 310.749 52.4201C310.779 52.4401 310.799 52.6101 310.769 52.6101C310.659 52.6301 310.529 52.4601 310.529 52.4301V52.4201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M310.739 53.0501C310.579 53.0501 310.419 52.9801 310.299 52.8601C310.149 52.7401 310.069 52.5601 310.079 52.3701C310.099 52.2101 310.199 52.0701 310.339 52.0001C310.549 51.9201 310.779 51.9201 310.979 52.0201C311.169 52.1701 311.269 52.4101 311.219 52.6501C311.179 52.8401 311.039 52.9901 310.849 53.0301C310.819 53.0301 310.779 53.0301 310.749 53.0301L310.739 53.0501ZM310.739 52.4401L310.639 52.8401C310.819 52.8001 310.949 52.6501 310.969 52.4701L310.739 52.4401ZM310.739 52.1501C310.739 52.1501 310.699 52.1501 310.679 52.1501C310.479 52.1801 310.339 52.3501 310.329 52.5501C310.359 52.6501 310.429 52.7401 310.519 52.7901L310.729 52.4401L310.529 52.4201L310.729 52.4401L310.749 52.4101V52.4401L310.979 52.4601C310.989 52.3701 310.979 52.2801 310.919 52.2001C310.869 52.1601 310.809 52.1501 310.749 52.1501H310.739Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.969 55.16C422.969 55.16 423.059 55.1101 423.079 55.0601C423.079 55.0801 423.059 55.1 423.049 55.11C423.029 55.14 422.939 55.1101 422.919 55.1201C422.919 55.1201 422.959 55.16 422.969 55.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.979 55.6C422.809 55.6 422.649 55.52 422.549 55.39C422.419 55.21 422.439 54.9601 422.599 54.8001C422.669 54.7401 422.759 54.6901 422.849 54.6701C422.999 54.5801 423.189 54.5801 423.339 54.6801C423.489 54.7801 423.559 54.9601 423.529 55.1301C423.529 55.1601 423.509 55.19 423.499 55.21C423.499 55.21 423.479 55.25 423.469 55.27C423.449 55.31 423.419 55.35 423.389 55.39C423.349 55.44 423.289 55.4801 423.229 55.5101C423.209 55.5201 423.189 55.5401 423.159 55.5501C423.099 55.5801 423.039 55.59 422.979 55.59V55.6ZM422.979 55.04H423.019L423.279 54.8701C423.159 54.7101 422.949 54.6601 422.769 54.7501L422.859 54.9501L422.979 55.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.939 52.41C382.939 52.41 382.849 52.55 382.819 52.6C382.819 52.58 382.769 52.5 382.779 52.49C382.809 52.47 382.779 52.27 382.809 52.26C382.889 52.29 382.939 52.41 382.939 52.41Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M382.819 53.05C382.619 53.05 382.439 52.91 382.389 52.72C382.309 52.52 382.349 52.3 382.499 52.15C382.419 52.22 382.369 52.31 382.349 52.42C382.319 52.19 382.439 51.96 382.639 51.85C382.739 51.81 382.859 51.8 382.959 51.85C383.149 51.93 383.289 52.08 383.359 52.27C383.409 52.4 383.389 52.53 383.329 52.65C383.309 52.68 383.289 52.72 383.259 52.77L383.209 52.84C383.129 52.98 382.979 53.06 382.819 53.06V53.05ZM382.539 52.56L382.699 52.58L382.719 52.54L382.669 52.51L382.539 52.56Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.259 50.3401C423.259 50.3401 423.459 50.3101 423.469 50.3001C423.419 50.2501 423.269 50.3201 423.259 50.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.259 50.79C423.079 50.79 422.909 50.6801 422.839 50.5101C422.769 50.3401 422.809 50.15 422.939 50.02C422.979 49.98 423.019 49.9501 423.059 49.9301C423.279 49.7901 423.559 49.81 423.759 49.97C423.849 50.05 423.909 50.17 423.909 50.29C423.909 50.41 423.869 50.5301 423.779 50.6201C423.679 50.7101 423.549 50.76 423.419 50.77H423.369C423.369 50.77 423.299 50.79 423.259 50.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.729 51.0102C423.729 51.0102 423.899 51.0701 423.879 51.0401C423.849 51.0101 423.889 50.9502 423.859 50.9402C423.799 50.9202 423.719 51.0202 423.739 51.0102H423.729Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.859 51.49C423.799 51.49 423.749 51.49 423.699 51.46C423.589 51.46 423.489 51.41 423.419 51.33C423.269 51.18 423.239 50.9401 423.359 50.7601C423.499 50.5401 423.769 50.43 424.019 50.52C424.179 50.6 424.299 50.75 424.319 50.93C424.349 51.05 424.329 51.18 424.269 51.29C424.179 51.42 424.029 51.49 423.869 51.49H423.859ZM423.609 51.3201C423.609 51.3201 423.659 51.35 423.689 51.36C423.839 51.42 424.009 51.38 424.099 51.25L423.839 51.08L423.609 51.3201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M387.91 55.73C387.91 55.73 387.83 55.79 387.84 55.84C387.84 55.86 387.61 55.94 387.6 55.97C387.6 55.99 387.64 55.91 387.65 55.89C387.65 55.8 387.73 55.64 387.73 55.55C387.8 55.52 387.93 55.7 387.92 55.72L387.91 55.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M387.589 56.43H387.559C387.399 56.43 387.259 56.3301 387.189 56.1901C387.119 56.0501 387.119 55.8801 387.189 55.7501C387.199 55.7001 387.219 55.65 387.229 55.6C387.229 55.58 387.249 55.55 387.249 55.53C387.249 55.36 387.349 55.21 387.509 55.16C387.689 55.08 387.899 55.12 388.049 55.24C388.169 55.33 388.259 55.46 388.319 55.6C388.379 55.77 388.329 55.96 388.209 56.09C388.129 56.2 388.009 56.29 387.879 56.34H387.849C387.769 56.41 387.679 56.4401 387.579 56.4401L387.589 56.43ZM387.519 55.9401C387.519 55.9401 387.579 55.9901 387.619 56.0001H387.599L387.529 55.9401H387.519Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.319 49.33C398.319 49.33 398.679 49.4201 398.689 49.4701C398.689 49.4901 398.509 49.55 398.489 49.58C398.489 49.6 398.579 49.59 398.579 49.59C398.579 49.5 398.449 49.5601 398.449 49.4701C398.359 49.4201 398.319 49.31 398.319 49.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.569 50.04C398.359 50.06 398.149 49.94 398.079 49.74C398.039 49.7 398.01 49.66 397.98 49.62C397.84 49.45 397.84 49.21 397.98 49.04C398.12 48.87 398.359 48.83 398.549 48.95C398.569 48.95 398.599 48.96 398.619 48.97C398.789 49.02 399.089 49.09 399.129 49.41C399.159 49.57 399.1 49.73 398.97 49.83C398.89 49.96 398.75 50.04 398.6 50.05H398.569V50.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.839 49.4C396.939 49.36 397.059 49.3501 397.169 49.3601C397.189 49.3801 397.129 49.4201 397.099 49.4201C396.959 49.4201 396.839 49.43 396.839 49.4Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.939 49.87C396.769 49.89 396.599 49.82 396.489 49.69C396.399 49.58 396.369 49.44 396.399 49.3C396.439 49.14 396.559 49.02 396.709 48.97C396.949 48.88 397.219 48.9 397.439 49.01C397.589 49.13 397.649 49.34 397.589 49.52C397.509 49.73 397.309 49.86 397.089 49.87H396.929H396.939ZM396.899 49.02C396.829 49.07 396.769 49.14 396.739 49.22L396.859 49.26L396.899 49.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M319.689 33.46C319.689 33.46 319.819 33.4601 319.839 33.5001C319.849 33.5201 319.839 33.51 319.829 33.49C319.829 33.45 319.699 33.45 319.699 33.46H319.689Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M319.839 33.96C319.839 33.96 319.769 33.9601 319.739 33.9501C319.709 33.9501 319.679 33.93 319.659 33.92C319.489 33.9 319.349 33.7901 319.279 33.6301C319.219 33.4701 319.249 33.29 319.359 33.16C319.469 33.03 319.639 32.9701 319.809 33.0101C319.959 33.0201 320.099 33.1 320.189 33.22C320.209 33.25 320.229 33.2801 320.249 33.3201C320.319 33.4801 320.299 33.66 320.189 33.8C320.099 33.9 319.979 33.97 319.839 33.97V33.96ZM319.839 33.52L319.759 33.89C319.909 33.87 320.039 33.78 320.109 33.64L319.839 33.5101V33.52ZM319.399 33.58C319.399 33.58 319.419 33.64 319.429 33.68C319.419 33.65 319.399 33.62 319.399 33.58ZM319.499 33.22L319.709 33.39L319.499 33.22Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M362.019 34.15C361.989 34.08 361.969 34.01 361.959 33.94C361.959 33.92 361.579 33.96 361.599 33.94C361.669 33.91 361.739 33.9 361.809 33.91C361.809 34 361.759 34.21 361.759 34.3C361.869 34.34 362.029 34.17 362.029 34.16L362.019 34.15Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M361.789 34.7501C361.719 34.7501 361.659 34.74 361.589 34.71C361.419 34.65 361.309 34.4801 361.299 34.3001V34.2801C361.249 34.2401 361.209 34.1801 361.179 34.1201C361.109 33.9501 361.139 33.7501 361.269 33.6201C361.269 33.6201 361.349 33.5501 361.399 33.5301C361.579 33.4501 361.789 33.4301 361.989 33.5001C362.189 33.5001 362.349 33.65 362.389 33.84C362.389 33.88 362.409 33.9301 362.429 33.9701C362.449 34.0201 362.459 34.08 362.469 34.14C362.469 34.34 362.359 34.5201 362.189 34.6201C362.079 34.7101 361.939 34.7601 361.789 34.7601V34.7501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M361.82 32.09C361.82 32.09 361.84 31.91 361.81 31.89C361.84 31.91 361.95 32.03 361.98 32.05C361.9 32.09 361.83 32.1 361.82 32.09Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M361.839 32.5501C361.769 32.5501 361.709 32.5401 361.649 32.5101C361.619 32.5001 361.579 32.4801 361.549 32.4501C361.399 32.3401 361.329 32.15 361.359 31.96C361.329 31.8 361.399 31.63 361.529 31.53C361.659 31.43 361.839 31.41 361.989 31.48C362.049 31.51 362.099 31.54 362.139 31.59L362.269 31.71C362.379 31.81 362.429 31.96 362.419 32.1C362.399 32.25 362.309 32.3701 362.179 32.4401C362.069 32.5001 361.959 32.53 361.839 32.53V32.5501ZM361.839 31.65C361.839 31.65 361.799 31.65 361.769 31.65L361.859 31.83L361.999 31.6801C361.949 31.6601 361.899 31.65 361.839 31.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.819 31.4401C423.819 31.4401 424.019 31.4501 424.029 31.4301C424.009 31.4501 423.979 31.59 423.959 31.61C423.939 31.51 423.799 31.4501 423.809 31.4501L423.819 31.4401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.969 32.05C423.809 32.05 423.649 31.9601 423.569 31.8101C423.409 31.7001 423.339 31.51 423.379 31.33C423.389 31.28 423.409 31.2401 423.439 31.1901C423.549 31.0301 423.749 30.94 423.949 30.98C424.109 30.95 424.279 31.01 424.379 31.14C424.479 31.27 424.509 31.44 424.449 31.6V31.6301C424.409 31.7401 424.359 31.8401 424.289 31.9301C424.209 32.0101 424.089 32.0601 423.969 32.0601V32.05ZM423.779 31.0601C423.829 31.0201 423.889 31.0001 423.949 30.9901C423.889 31.0001 423.829 31.0301 423.779 31.0601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M386.929 31.7601C386.929 31.8401 386.649 31.9101 386.659 31.9801C386.659 32.0001 386.659 31.9401 386.669 31.9301C386.669 31.8401 386.739 31.6301 386.739 31.5401C386.809 31.5101 386.929 31.7501 386.929 31.7601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M386.659 32.44C386.459 32.44 386.279 32.3 386.229 32.11C386.219 32.07 386.209 32.04 386.209 32C386.209 31.95 386.209 31.9 386.229 31.85C386.239 31.78 386.249 31.71 386.269 31.63C386.269 31.59 386.289 31.56 386.289 31.52C386.289 31.33 386.409 31.16 386.589 31.11C386.769 31.05 386.959 31.1 387.099 31.22C387.249 31.36 387.349 31.54 387.379 31.75C387.379 31.98 387.229 32.18 387.009 32.26C386.929 32.36 386.809 32.42 386.679 32.43H386.649L386.659 32.44ZM386.699 31.99C386.699 31.99 386.769 31.99 386.809 31.99H386.699Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M324.059 25.3201C324.059 25.3201 324.009 25.32 323.999 25.34C323.979 25.36 323.979 25.5001 323.999 25.5001C324.039 25.5001 324.059 25.3301 324.049 25.3201H324.059Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M323.999 25.9501C323.819 25.9501 323.659 25.8301 323.579 25.6701C323.499 25.4601 323.529 25.2201 323.669 25.0401C323.769 24.9401 323.909 24.8701 324.049 24.8601C324.189 24.8601 324.319 24.9301 324.399 25.0401C324.519 25.2301 324.529 25.4801 324.419 25.6801C324.339 25.8401 324.169 25.9501 323.989 25.9601L323.999 25.9501ZM324.139 25.4301L324.329 25.6501C324.419 25.5701 324.449 25.4401 324.409 25.3201L324.149 25.4301H324.139ZM323.999 25.0601C323.819 25.0601 323.669 25.1601 323.599 25.3301L323.989 25.3601V25.0601H323.999Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M323.98 25.38C323.98 25.38 324.089 25.48 324.109 25.45C324.129 25.42 324.05 25.35 324.02 25.34C324 25.33 323.97 25.37 323.98 25.38Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M324.09 25.91C324.09 25.91 324.06 25.91 324.05 25.91C323.86 25.88 323.7 25.77 323.6 25.61C323.51 25.42 323.54 25.2 323.67 25.05C323.81 24.9 324.03 24.86 324.22 24.94C324.39 25.02 324.51 25.17 324.56 25.35C324.59 25.49 324.56 25.63 324.47 25.74C324.38 25.85 324.25 25.91 324.1 25.91H324.09ZM323.96 25.48L323.67 25.53C323.68 25.63 323.74 25.71 323.84 25.75L323.96 25.48ZM324.14 25.01L324.11 25.29L324.37 25.15C324.32 25.06 324.24 25.01 324.14 25.01Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M406.85 26.95C406.85 26.95 406.85 26.79 406.87 26.74C406.87 26.76 406.95 26.84 406.94 26.85C406.92 26.87 407.01 26.79 406.99 26.81C407 26.87 406.84 26.96 406.86 26.95H406.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M406.85 26.79C406.69 26.79 406.54 27.32 406.46 27.17C406.41 27.08 406.39 26.97 406.41 26.86C406.41 26.77 406.409 26.69 406.439 26.6C406.479 26.46 406.59 26.35 406.73 26.3C406.87 26.25 407.02 26.28 407.14 26.37C407.2 26.39 407.259 26.4299 407.309 26.4699C407.409 26.5699 407.459 26.72 407.429 26.86C407.399 27.05 407.27 27.22 407.1 27.31C407.09 27.31 407.069 27.3299 407.059 27.3299C406.989 27.3599 406.92 26.7699 406.85 26.7699V26.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M322.449 26.4401C322.369 26.5101 322.019 26.3201 321.939 26.3901C322.019 26.4801 322.099 26.5601 322.199 26.6301C322.279 26.5601 322.389 26.1701 322.469 26.1001C322.549 26.1301 322.469 26.4301 322.449 26.4401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M322.199 27.08C321.969 27.04 321.759 26.91 321.629 26.72C321.489 26.57 321.459 26.34 321.549 26.16C321.569 26.12 321.599 26.09 321.629 26.06C321.739 25.96 321.889 25.91 322.029 25.93C322.059 25.87 322.099 25.82 322.149 25.77C322.279 25.65 322.459 25.62 322.619 25.68C322.809 25.76 322.939 25.95 322.929 26.16C322.939 26.38 322.869 26.6 322.729 26.77C322.729 26.77 322.619 26.85 322.559 26.87C322.539 26.9 322.509 26.93 322.479 26.96C322.399 27.04 322.289 27.08 322.169 27.08H322.199Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M324.239 26.31C324.319 26.39 324.419 26.44 324.499 26.52C324.509 26.52 324.529 26.49 324.519 26.48C324.429 26.48 324.339 26.56 324.239 26.56C324.219 26.56 324.379 26.64 324.389 26.63C324.389 26.54 324.259 26.38 324.259 26.29C324.259 26.27 324.229 26.29 324.239 26.31Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M324.369 27.08C324.369 27.08 324.309 27.0801 324.269 27.0701C324.189 27.0501 323.809 26.9501 323.779 26.6001C323.779 26.5401 323.779 26.4901 323.799 26.4301C323.759 26.2901 323.789 26.14 323.869 26.02C323.959 25.89 324.109 25.82 324.259 25.83C324.409 25.83 324.559 25.9201 324.639 26.0501H324.669C324.829 26.1201 324.939 26.2701 324.959 26.4401C324.969 26.6201 324.889 26.79 324.749 26.89C324.659 27.01 324.519 27.0701 324.379 27.0701L324.369 27.08Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.21 26.43C413.24 26.53 413.25 26.63 413.23 26.74C413.22 26.76 413.25 26.72 413.25 26.69C413.25 26.55 413.18 26.42 413.21 26.43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.229 27.1901C413.139 27.1901 413.059 27.1601 412.979 27.1201C412.829 27.0201 412.749 26.83 412.789 26.65V26.6301C412.729 26.4601 412.759 26.28 412.869 26.14C412.979 26.02 413.139 25.9701 413.299 26.0001C413.449 26.0401 413.579 26.1501 413.629 26.2901C413.649 26.3601 413.659 26.4301 413.669 26.5001C413.679 26.5601 413.689 26.6301 413.689 26.7001C413.689 26.7701 413.669 26.8501 413.639 26.9101C413.629 26.9401 413.609 26.9701 413.589 27.0001C413.499 27.1201 413.359 27.1901 413.219 27.1901H413.229Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M322.119 26.4801C322.049 26.5601 321.929 26.6401 321.859 26.7201C321.859 26.7301 321.899 26.7401 321.909 26.7301C321.979 26.6501 322.219 26.6601 322.289 26.5801C322.299 26.5501 322.129 26.4701 322.109 26.4801H322.119Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M321.889 27.18C321.769 27.18 321.659 27.14 321.569 27.07C321.419 26.94 321.369 26.72 321.449 26.54C321.469 26.5 321.489 26.46 321.519 26.43C321.579 26.37 321.639 26.31 321.709 26.25C321.739 26.23 321.759 26.21 321.779 26.19C321.809 26.15 321.849 26.12 321.889 26.1C322.119 25.99 322.399 26.04 322.579 26.22C322.729 26.35 322.789 26.57 322.709 26.76C322.689 26.8 322.669 26.84 322.639 26.87C322.519 26.99 322.369 27.07 322.199 27.09H322.159C322.079 27.15 321.989 27.18 321.899 27.18H321.889ZM321.869 26.74C321.899 26.81 321.949 26.88 322.009 26.92L322.029 26.87L321.869 26.74Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M376.499 26.83C376.499 26.83 376.429 26.9 376.379 26.88C376.399 26.88 376.689 26.53 376.699 26.54C376.719 26.56 376.729 26.66 376.749 26.68C376.669 26.73 376.579 26.78 376.489 26.82L376.499 26.83Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M376.4 27.3301C376.34 27.3301 376.28 27.3201 376.22 27.3001C376.07 27.2401 375.97 27.1001 375.94 26.9501C375.91 26.8001 375.979 26.6301 376.109 26.5301C376.139 26.5001 376.18 26.4601 376.22 26.4101C376.41 26.2001 376.49 26.1101 376.69 26.1001C376.81 26.1001 376.92 26.1301 377.01 26.2101C377.1 26.2901 377.16 26.4001 377.179 26.5201C377.26 26.7201 377.18 26.9601 377 27.0701C376.9 27.1401 376.779 27.2001 376.669 27.2501C376.589 27.3001 376.5 27.3301 376.4 27.3301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M321.71 27.02C321.79 26.94 321.82 26.82 321.9 26.75C321.9 26.74 321.92 26.72 321.9 26.73C321.82 26.81 321.67 26.87 321.59 26.94C321.58 26.97 321.689 27.03 321.699 27.02H321.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M321.71 27.47C321.56 27.47 321.41 27.4 321.3 27.29C321.16 27.15 321.11 26.94 321.19 26.75C321.21 26.7 321.25 26.65 321.29 26.61C321.36 26.55 321.44 26.49 321.52 26.44C321.55 26.43 321.57 26.41 321.6 26.39C321.63 26.36 321.66 26.34 321.7 26.32C321.88 26.23 322.1 26.26 322.24 26.41C322.38 26.56 322.4 26.78 322.3 26.96C322.28 27 322.25 27.03 322.22 27.06C322.17 27.16 322.11 27.25 322.03 27.33C322 27.36 321.96 27.39 321.92 27.41C321.86 27.44 321.79 27.46 321.72 27.46L321.71 27.47ZM321.73 26.57L321.86 26.7L321.92 26.64C321.87 26.59 321.8 26.57 321.73 26.57Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.589 26.3801C417.589 26.3801 417.649 26.52 417.679 26.54C417.659 26.54 417.809 26.4 417.809 26.39C417.789 26.33 417.769 26.2601 417.749 26.2001C417.659 26.2001 417.579 26.3701 417.589 26.3801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.679 26.9901C417.589 26.9901 417.499 26.96 417.429 26.9101C417.339 26.84 417.259 26.75 417.219 26.64C417.179 26.59 417.159 26.53 417.139 26.47C417.099 26.11 417.359 25.7901 417.709 25.7501C417.929 25.7301 418.129 25.8801 418.179 26.1001C418.179 26.1201 418.199 26.1701 418.209 26.2001C418.299 26.4001 418.239 26.64 418.059 26.78C417.979 26.91 417.829 27.0001 417.669 27.0001L417.679 26.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M321.569 27.08C321.569 27.08 321.659 26.95 321.669 26.96C321.609 27.02 321.589 27.09 321.569 27.08Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M321.569 27.5301C321.449 27.5301 321.339 27.4801 321.249 27.4001C321.079 27.2301 321.069 26.9601 321.229 26.7801C321.259 26.7401 321.289 26.7001 321.319 26.6601C321.389 26.5801 321.499 26.5201 321.609 26.5101C321.799 26.4901 321.969 26.5901 322.059 26.7601C322.139 26.9301 322.109 27.13 321.979 27.27C321.959 27.29 321.949 27.3201 321.929 27.3401C321.859 27.4401 321.749 27.5101 321.619 27.5301C321.599 27.5301 321.579 27.5301 321.559 27.5301H321.569ZM321.669 26.9701L321.879 26.7601L321.669 26.9701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.77 14.17C420.77 14.17 420.85 14.29 420.88 14.25C420.91 14.3 420.99 14.08 421.02 14.13C421.04 14.13 421.09 14.06 421.07 14.05C420.99 14.05 420.87 13.99 420.79 13.99C420.77 14.05 420.76 14.11 420.77 14.17Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.869 14.7001H420.859C420.729 14.7001 420.609 14.64 420.519 14.54C420.499 14.52 420.469 14.51 420.449 14.48C420.189 14.22 420.389 13.79 420.389 13.79C420.469 13.64 420.619 13.54 420.789 13.54C420.879 13.54 420.969 13.56 421.059 13.59C421.129 13.59 421.199 13.61 421.259 13.64C421.489 13.75 421.579 14.0201 421.469 14.2501C421.429 14.3501 421.359 14.4301 421.269 14.4901C421.179 14.6201 421.039 14.6901 420.879 14.7001H420.849H420.869ZM421.079 14.17L421.169 14.2401C421.169 14.2401 421.219 14.16 421.229 14.11L421.079 14.1301V14.17Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.489 14.34C420.569 14.26 420.859 14.37 420.939 14.28C420.879 14.23 420.819 14.18 420.749 14.15C420.669 14.23 420.609 14.48 420.539 14.55C420.489 14.55 420.479 14.34 420.489 14.33V14.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.529 15.02C420.299 15.02 420.109 14.86 420.059 14.64C419.979 14.42 420.029 14.1701 420.199 14.0001C420.249 13.9501 420.319 13.9201 420.379 13.9001C420.389 13.8801 420.409 13.8701 420.419 13.8501C420.449 13.8201 420.479 13.8001 420.509 13.7801C420.829 13.5901 421.149 13.87 421.239 13.96C421.389 14.11 421.419 14.3301 421.319 14.5101C421.299 14.5401 421.279 14.5801 421.249 14.6001C421.169 14.6901 421.059 14.7401 420.939 14.7601C420.909 14.8001 420.879 14.8401 420.849 14.8801C420.769 14.9601 420.659 15.0101 420.539 15.0101H420.529V15.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.819 14.92C418.739 14.92 418.619 15.1301 418.539 15.1301C418.529 15.1301 418.479 15.21 418.489 15.22C418.579 15.22 418.729 15.16 418.819 15.16C418.859 15.09 418.859 15 418.819 14.92Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.49 15.67C418.37 15.67 418.249 15.62 418.169 15.53C418.079 15.44 418.04 15.32 418.04 15.2C418.06 15 418.17 14.83 418.34 14.73C418.45 14.58 418.63 14.48 418.82 14.47C418.86 14.47 418.9 14.47 418.94 14.49C419.09 14.54 419.2 14.65 419.26 14.79C419.34 14.99 419.32 15.22 419.2 15.41C419.12 15.54 418.98 15.61 418.83 15.61C418.83 15.61 418.8 15.62 418.78 15.63C418.69 15.66 418.6 15.67 418.5 15.68L418.49 15.67ZM418.82 15.23V15.37C418.82 15.37 418.88 15.37 418.91 15.36C418.93 15.32 418.93 15.27 418.93 15.23H418.82ZM418.45 14.91C418.41 14.97 418.399 15.04 418.419 15.1L418.49 15.07V14.93L418.45 14.9V14.91Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.14 16.9C420.14 16.9 420.14 16.86 420.12 16.88C420.1 16.9 420.25 16.74 420.28 16.76C420.24 16.81 420.19 16.86 420.14 16.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.139 17.35C420.029 17.35 419.919 17.31 419.839 17.23H419.829C419.649 17.06 419.629 16.79 419.779 16.6C419.799 16.58 419.819 16.56 419.839 16.54C420.209 16.17 420.479 16.32 420.599 16.43C420.719 16.55 420.769 16.73 420.709 16.9C420.619 17.11 420.429 17.27 420.209 17.34C420.189 17.34 420.169 17.34 420.139 17.34V17.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.449 27.6301C302.449 27.6301 302.489 27.7501 302.469 27.7301C302.449 27.7101 302.469 27.9101 302.439 27.9101C302.399 27.9001 302.439 27.6401 302.449 27.6401V27.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.439 28.3601C302.439 28.3601 302.359 28.36 302.319 28.34C302.149 28.28 302.019 28.14 301.989 27.97C301.989 27.97 301.919 27.49 302.189 27.28C302.389 27.13 302.659 27.1701 302.819 27.3601C302.929 27.5101 302.959 27.7001 302.909 27.8701C302.909 28.0301 302.839 28.18 302.709 28.27C302.629 28.33 302.539 28.35 302.439 28.35V28.3601ZM302.059 27.83C302.059 27.83 302.089 27.8901 302.109 27.9201L302.189 27.8601L302.059 27.83ZM302.549 27.66L302.859 27.7501C302.829 27.6601 302.769 27.58 302.689 27.53L302.549 27.66Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.589 27.01C418.589 27.01 418.629 27.01 418.599 26.98C418.619 27 418.789 27.12 418.809 27.14C418.789 27.16 418.589 27.02 418.579 27.01H418.589Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.799 27.59C418.799 27.59 418.74 27.59 418.71 27.59C418.55 27.54 418.41 27.4601 418.29 27.3501C418.18 27.2501 418.119 27.1001 418.129 26.9501C418.149 26.8001 418.239 26.6801 418.369 26.6001C418.499 26.5301 418.65 26.52 418.79 26.58C418.83 26.6 418.88 26.6301 418.91 26.6701L418.96 26.7001C419.03 26.7501 419.099 26.8101 419.119 26.8201C419.269 26.9701 419.299 27.22 419.169 27.4C419.079 27.52 418.94 27.6 418.79 27.59H418.799Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.029 27.7201C418.029 27.7201 417.839 27.7901 417.859 27.8101C417.879 27.8301 417.979 27.6701 418.009 27.6801C418.039 27.6801 418.049 27.7201 418.039 27.7301L418.029 27.7201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.859 28.2501C417.719 28.2501 417.589 28.1901 417.499 28.0801C417.409 27.9701 417.379 27.8301 417.409 27.7001C417.439 27.5801 417.509 27.4801 417.609 27.4201C417.709 27.2901 417.869 27.2101 418.039 27.2201C418.239 27.2501 418.399 27.3901 418.459 27.5701C418.509 27.7601 418.439 27.9501 418.289 28.0701C418.239 28.1101 418.189 28.1301 418.129 28.1501C418.049 28.2101 417.959 28.2401 417.869 28.2401H417.859V28.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.27 44.28C346.27 44.28 346.379 44.07 346.359 44.09C346.329 44.11 346.58 44.22 346.56 44.25C346.51 44.33 346.28 44.29 346.27 44.28Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M346.399 44.7601C346.209 44.7701 346.029 44.7001 345.909 44.5601C345.789 44.3501 345.799 44.1001 345.949 43.9201C346.009 43.7901 346.119 43.7001 346.259 43.6701C346.399 43.6401 346.539 43.6701 346.649 43.7601C346.669 43.7701 346.679 43.7901 346.699 43.8101C347.139 44.1001 346.999 44.4101 346.949 44.5001C346.849 44.6701 346.669 44.77 346.479 44.77C346.459 44.77 346.439 44.77 346.419 44.77L346.399 44.7601ZM346.169 44.02L346.319 44.1001L346.389 43.8601C346.299 43.8801 346.219 43.94 346.169 44.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M367.81 47.47C367.81 47.47 367.81 47.4301 367.84 47.4501C367.85 47.4501 367.86 47.47 367.87 47.48C367.87 47.49 367.87 47.51 367.87 47.52C367.85 47.55 367.81 47.51 367.82 47.47H367.81Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M367.839 47.97C367.839 47.97 367.739 47.9701 367.699 47.9501C367.479 47.8701 367.349 47.66 367.369 47.43L367.759 47.47L367.369 47.42C367.389 47.26 367.479 47.12 367.629 47.04C367.779 46.98 367.949 46.9901 368.089 47.0701C368.199 47.1401 368.279 47.2601 368.319 47.3801C368.339 47.5101 368.319 47.6501 368.249 47.7601C368.159 47.8901 368.009 47.97 367.849 47.97H367.839ZM367.789 47.53L367.439 47.58C367.459 47.68 367.529 47.77 367.609 47.83L367.789 47.53ZM367.859 47.47L368.259 47.5101L367.859 47.47ZM367.869 47.44L368.259 47.5C368.279 47.32 368.159 47.15 367.989 47.1L367.869 47.44Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M388.469 47.69C388.469 47.69 388.689 47.57 388.659 47.56C388.629 47.54 388.509 47.84 388.479 47.83C388.449 47.83 388.459 47.7 388.479 47.69H388.469Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M388.489 48.2801C388.489 48.2801 388.419 48.2801 388.379 48.2701C388.189 48.2201 388.049 48.0601 388.009 47.8701C387.969 47.6501 388.059 47.4301 388.239 47.3101L388.269 47.2901L388.309 47.2701C388.369 47.2001 388.459 47.1502 388.549 47.1302C388.689 47.1002 388.839 47.1301 388.949 47.2201C389.059 47.3101 389.119 47.4501 389.119 47.5901C389.119 47.7101 389.069 47.8201 388.979 47.9001C388.919 48.0301 388.779 48.2901 388.499 48.2901L388.489 48.2801ZM388.519 47.7901L388.689 48.0901H388.709L388.529 47.7901H388.519Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M352.129 46.17C352.129 46.17 352.149 46.19 352.129 46.22C352.109 46.24 352.059 46.2901 352.039 46.2601C352.019 46.2301 352.099 46.16 352.129 46.17Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M352.059 46.71C351.909 46.71 351.779 46.64 351.689 46.52C351.579 46.36 351.569 46.16 351.669 45.99C351.779 45.8 351.989 45.69 352.209 45.72C352.369 45.75 352.509 45.85 352.579 46C352.629 46.16 352.609 46.34 352.509 46.48C352.409 46.62 352.249 46.7 352.079 46.71H352.059ZM352.069 46.55V46.61C352.199 46.64 352.349 46.57 352.429 46.45L352.129 46.27L352.069 46.55ZM352.059 45.81C351.949 45.81 351.849 45.85 351.779 45.93L352.049 46.14V45.81H352.059Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.919 45.5901C396.999 45.5101 397.129 45.4501 397.209 45.3701C397.209 45.3601 397.209 45.4301 397.189 45.4401C397.109 45.5201 396.909 45.4201 396.829 45.5001C396.829 45.5001 396.899 45.6101 396.919 45.6001V45.5901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.91 46.0401C396.72 46.0301 396.54 45.9101 396.45 45.7401C396.33 45.5601 396.35 45.3201 396.5 45.1701C396.61 45.0601 396.76 45.0001 396.92 45.0101C397.02 44.9401 397.14 44.9001 397.26 44.9201C397.45 44.9501 397.6 45.1001 397.63 45.2901C397.65 45.4601 397.59 45.6201 397.48 45.7501C397.41 45.8201 397.32 45.87 397.22 45.9H397.21C397.21 45.9 397.14 45.9701 397.1 45.9901C397.04 46.0201 396.96 46.0401 396.89 46.0401H396.91Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.679 45.2001C401.679 45.2001 401.759 45.33 401.739 45.36C401.719 45.39 401.439 45.44 401.429 45.41C401.399 45.34 401.639 45.1901 401.669 45.2001H401.679Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.47 45.87H401.43C401.25 45.85 401.1 45.74 401.02 45.58C400.96 45.42 400.98 45.23 401.09 45.09C401.24 44.89 401.47 44.77 401.71 44.75C401.88 44.78 402.03 44.88 402.12 45.04C402.22 45.21 402.22 45.43 402.12 45.6C401.97 45.85 401.59 45.87 401.46 45.87H401.47ZM401.72 45.3L401.84 45.62C401.89 45.5 401.9 45.37 401.85 45.25L401.72 45.3ZM401.36 45.13C401.3 45.22 401.29 45.34 401.32 45.44L401.44 45.38V45.2L401.36 45.13Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M367.759 39.1C367.759 39.1 367.839 39.02 367.849 39C367.829 39.02 367.669 38.98 367.649 39C367.649 39 367.739 39.1 367.759 39.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M367.76 39.55C367.58 39.54 367.42 39.44 367.32 39.3C367.24 39.21 367.2 39.09 367.21 38.97C367.22 38.85 367.279 38.74 367.369 38.66C367.489 38.56 367.649 38.53 367.799 38.55C367.749 38.55 367.709 38.57 367.669 38.59C367.839 38.51 368.049 38.54 368.179 38.68C368.309 38.82 368.35 39.0201 368.27 39.1901C368.24 39.2501 368.2 39.31 368.15 39.36C368.07 39.47 367.939 39.54 367.809 39.55H367.78H367.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.869 37.42C418.869 37.42 418.669 37.32 418.689 37.29C418.709 37.26 418.779 37.59 418.809 37.6C418.829 37.6 418.899 37.42 418.869 37.42Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.809 38.0501C418.749 38.0501 418.689 38.0402 418.629 38.0102C418.459 37.9202 418.349 37.7501 418.319 37.5601V37.5301C418.319 37.5301 418.289 37.5001 418.279 37.4801C418.209 37.3301 418.229 37.1601 418.319 37.0201C418.419 36.8801 418.589 36.8101 418.759 36.8401C418.869 36.8601 418.969 36.9101 419.039 37.0001C419.159 37.0501 419.259 37.1501 419.299 37.2801C419.349 37.5101 419.279 37.7601 419.119 37.9301C419.029 38.0101 418.919 38.0501 418.809 38.0501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M387.719 34.6601C387.719 34.6601 387.869 34.6901 387.849 34.6801C387.829 34.6601 387.859 34.5901 387.849 34.5801C387.799 34.5601 387.709 34.6701 387.729 34.6701L387.719 34.6601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M387.819 35.1201C387.819 35.1201 387.749 35.1201 387.709 35.1101C387.589 35.1101 387.479 35.0601 387.399 34.9801C387.249 34.8301 387.219 34.5801 387.349 34.4001C387.489 34.1701 387.769 34.0601 388.019 34.1601C388.189 34.2501 388.289 34.4201 388.299 34.6101C388.309 34.7101 388.299 34.8101 388.249 34.8901C388.159 35.0301 387.999 35.1201 387.829 35.1101L387.819 35.1201ZM387.739 34.8301L387.659 34.9801C387.659 34.9801 387.689 34.9901 387.709 35.0001L387.739 34.8301ZM387.799 34.7201L387.949 34.9901C387.999 34.9701 388.049 34.9401 388.089 34.8901L387.809 34.7001L387.799 34.7201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M311.169 35.8201C311.169 35.8201 311.189 35.65 311.209 35.62C311.209 35.64 311.109 35.52 311.099 35.53C311.079 35.54 310.969 35.7 310.939 35.71C310.939 35.78 311.149 35.83 311.169 35.83V35.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M311.169 36.27C311.009 36.27 310.859 36.2101 310.729 36.1301C310.599 36.0401 310.509 35.9001 310.499 35.7501C310.489 35.6001 310.549 35.4601 310.659 35.3601L310.699 35.3201C310.749 35.2501 310.799 35.2001 310.869 35.1501C310.959 35.0901 310.599 34.9801 310.869 35.2501C311.019 35.3501 311.089 35.5301 311.049 35.7101C311.049 35.7301 311.049 35.75 311.029 35.77C311.029 35.88 310.989 35.9901 310.919 36.0901C310.859 36.1701 311.389 36.2301 311.289 36.2601C311.249 36.2701 311.209 36.2801 311.169 36.2801V36.27ZM311.219 35.6201L311.379 35.6701H310.789C310.769 35.5001 311.269 35.4001 311.219 35.3701L311.189 35.5301L311.219 35.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M319.919 36.56C319.899 36.51 319.759 36.49 319.759 36.43C319.759 36.41 320.109 36.45 320.129 36.43C320.129 36.43 319.999 36.32 319.989 36.33C319.989 36.42 320.049 36.55 320.049 36.64C320.039 36.66 319.919 36.58 319.919 36.57V36.56Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M320.03 37.0901C320.03 37.0901 319.93 37.0901 319.88 37.0701C319.77 37.0301 319.68 36.9701 319.6 36.8901C319.44 36.8101 319.33 36.6701 319.31 36.4901C319.29 36.3601 319.34 36.2301 319.43 36.1301C319.5 36.0501 319.6 36.0001 319.71 35.9901C319.76 35.9501 319.82 35.9201 319.89 35.9001C320.09 35.8601 320.3 35.9401 320.43 36.1001C320.6 36.2501 320.63 36.5001 320.51 36.6901C320.51 36.7501 320.49 36.8101 320.46 36.8601C320.37 37.0101 320.21 37.1101 320.04 37.1001L320.03 37.0901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M384.269 40.6601C384.269 40.6601 383.899 40.6101 383.889 40.5701C383.889 40.5601 384.299 40.4701 384.319 40.4501C384.319 40.4301 384.169 40.45 384.159 40.46C384.159 40.54 384.189 40.4601 384.179 40.5301C384.259 40.5701 384.259 40.6701 384.259 40.6601H384.269Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M384.269 41.1101C384.199 41.1101 384.139 41.1001 384.079 41.0701H384.019C383.849 41.0401 383.529 41.0001 383.449 40.6701C383.419 40.5501 383.449 40.43 383.499 40.33C383.589 40.2 383.729 40.1101 383.889 40.1001C384.039 40.0101 384.219 39.9701 384.399 40.0001C384.599 40.0401 384.749 40.2101 384.769 40.4101C384.759 40.7101 384.579 40.9701 384.319 41.1101C384.299 41.1101 384.289 41.1101 384.269 41.1101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M384.239 40.6201C384.239 40.6201 384.209 40.8301 384.239 40.8001C384.269 40.7701 384.079 40.6801 384.099 40.6401C384.119 40.5801 384.239 40.6001 384.239 40.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M384.229 41.2501C384.159 41.2501 384.099 41.2401 384.039 41.2101C383.979 41.1801 383.919 41.1301 383.889 41.0701C383.679 40.9501 383.589 40.6901 383.679 40.4701C383.759 40.2801 383.949 40.1601 384.159 40.1601C384.359 40.1501 384.549 40.2501 384.639 40.4201C384.689 40.5201 384.699 40.6301 384.689 40.7401C384.699 40.8801 384.659 41.0101 384.569 41.1101C384.479 41.2001 384.359 41.2601 384.229 41.2601V41.2501ZM384.019 41.0101C384.069 41.0401 384.129 41.0501 384.179 41.0501C384.319 41.0401 384.449 40.9501 384.499 40.8201C384.559 40.7601 384.589 40.6701 384.569 40.5801C384.549 40.4901 384.489 40.4201 384.409 40.3901L384.229 40.7901L384.019 41.0101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M350.909 40.21C350.989 40.29 350.979 40.4901 351.059 40.5701C351.139 40.5201 351.209 40.4601 351.259 40.3801C351.179 40.3001 351.029 40.24 350.949 40.16C350.949 40.16 350.909 40.1901 350.909 40.2001V40.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M351.059 41.0301C350.989 41.0301 350.919 41.0101 350.849 40.9801C350.809 40.9601 350.769 40.9301 350.739 40.9001C350.639 40.7901 350.569 40.6501 350.549 40.5101C350.549 40.4901 350.549 40.4801 350.549 40.4901C350.469 40.3801 350.439 40.2501 350.469 40.1201C350.499 39.9901 350.579 39.8801 350.689 39.8101C350.869 39.6901 351.099 39.7101 351.259 39.8601C351.279 39.8801 351.309 39.8901 351.329 39.9101C351.419 39.9601 351.499 40.0201 351.569 40.0801C351.599 40.1101 351.629 40.1501 351.649 40.1901C351.759 40.4001 351.699 40.6501 351.509 40.7901C351.399 40.9301 351.229 41.0201 351.049 41.0401L351.059 41.0301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M350.959 40.5601C351.049 40.6201 351.159 40.6401 351.269 40.6201C351.299 40.5901 351.169 40.29 351.119 40.29C351.009 40.29 350.949 40.5401 350.949 40.5601H350.959Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M351.229 41.0801C351.229 41.0801 351.139 41.0801 351.089 41.0701C350.739 41.0201 350.619 40.8801 350.569 40.7801C350.489 40.5901 350.499 40.3601 350.619 40.1901C350.709 40.0001 350.889 39.8701 351.099 39.8501C351.359 39.8501 351.579 40.0201 351.649 40.2701C351.779 40.4901 351.749 40.7601 351.589 40.9501C351.489 41.0401 351.369 41.0901 351.239 41.0801H351.229ZM350.839 40.6301C350.929 40.7101 351.039 40.7501 351.159 40.7401C351.259 40.7401 351.349 40.6901 351.409 40.6101L350.969 40.5101L351.349 40.3301C351.309 40.2701 351.259 40.2201 351.199 40.1801C351.109 40.1901 351.029 40.2301 350.959 40.2901C350.869 40.3701 350.819 40.4901 350.829 40.6101L350.959 40.5501L350.839 40.6201V40.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.109 36.59C304.169 36.49 304.169 36.36 304.109 36.26V36.59Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.139 35.8101C304.309 35.8201 304.459 35.93 304.529 36.09C304.589 36.21 304.609 36.35 304.599 36.48C304.679 36.53 304.749 36.59 304.809 36.67C304.879 36.78 304.899 36.91 304.869 37.03C304.839 37.15 304.749 37.2601 304.639 37.3201L304.529 37.3801C304.449 37.4301 304.349 37.48 304.269 37.52", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.34 31.7001C296.24 31.6401 296.14 31.5801 296.04 31.5201C296.14 31.4001 296.26 31.2301 296.38 31.1201C296.5 31.1901 296.62 31.2701 296.73 31.3501C296.66 31.5001 296.43 31.5501 296.35 31.7001H296.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.349 32.17C296.239 32.17 296.139 32.12 296.059 32.05C296.019 32.02 295.989 32 295.949 31.99C295.879 31.96 295.819 31.92 295.759 31.88C295.669 31.8 295.609 31.69 295.599 31.57C295.589 31.45 295.629 31.33 295.709 31.24C295.749 31.2 295.779 31.15 295.819 31.1C295.899 31 295.979 30.9 296.059 30.81C296.319 30.54 296.609 30.73 296.789 30.85C296.999 30.99 297.289 31.18 297.139 31.53C297.059 31.69 296.929 31.82 296.779 31.91C296.759 31.92 296.729 31.94 296.709 31.96C296.649 32.07 296.539 32.15 296.409 32.17C296.389 32.17 296.369 32.17 296.339 32.17H296.349Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.209 35.5601C305.179 35.4301 305.219 35.4 305.199 35.28C305.299 35.28 305.249 35.15 305.349 35.15C305.329 35.28 305.289 35.4301 305.279 35.5601C305.279 35.5801 305.339 35.49 305.319 35.48C305.269 35.45 305.229 35.29 305.169 35.29C305.109 35.29 305.129 35.4501 305.149 35.5001C305.179 35.5701 305.209 35.5901 305.209 35.5701V35.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.209 36.02C304.999 36.02 304.819 35.88 304.749 35.69C304.659 35.49 304.669 35.27 304.759 35.08C304.799 35.01 304.859 34.96 304.929 34.92C305.019 34.79 305.169 34.71 305.329 34.71C305.459 34.71 305.589 34.76 305.679 34.86C305.769 34.96 305.809 35.09 305.789 35.22C305.789 35.28 305.769 35.35 305.749 35.42C305.759 35.49 305.759 35.57 305.739 35.64C305.689 35.84 305.519 35.99 305.309 36.02C305.309 36.02 305.239 36.03 305.209 36.03V36.02ZM305.169 35.12L305.309 35.14C305.309 35.14 305.209 35.12 305.169 35.12Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M305.069 35.5102C305.019 35.5602 304.979 35.6501 304.909 35.6701C304.799 35.7001 304.679 35.7101 304.569 35.7201C304.669 35.6501 304.769 35.5801 304.869 35.5201C304.939 35.5001 305.119 35.6501 305.189 35.6401C305.209 35.6101 305.089 35.5002 305.069 35.5102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.569 36.16C304.369 36.16 304.189 36.02 304.139 35.83C304.089 35.63 304.179 35.43 304.349 35.32L304.409 35.28C304.509 35.2 304.619 35.13 304.739 35.08C304.809 35.06 304.889 35.05 304.959 35.07C305.319 34.98 305.549 35.36 305.559 35.38C305.659 35.56 305.649 35.79 305.509 35.95C305.429 36.04 305.319 36.09 305.209 36.1C305.169 36.1 305.129 36.1 305.089 36.1H305.069C304.909 36.15 304.739 36.18 304.569 36.18V36.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.579 49.5901C297.419 49.5101 297.259 49.8101 297.099 49.7301C297.259 49.8101 297.419 49.5101 297.579 49.5901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.149 50.19C297.059 50.19 296.979 50.17 296.899 50.13C296.719 50.04 296.619 49.83 296.659 49.63C296.709 49.43 296.889 49.28 297.089 49.28C297.279 49.12 297.549 49.08 297.779 49.18C297.959 49.27 298.059 49.48 298.019 49.68C297.969 49.88 297.789 50.03 297.589 50.03C297.459 50.12 297.309 50.18 297.159 50.19H297.149Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.769 48.79C299.769 48.79 299.999 48.79 299.979 48.8C299.979 48.77 299.739 48.67 299.749 48.67C299.779 48.65 299.999 48.73 300.039 48.73C300.039 48.76 299.779 48.76 299.779 48.79H299.769Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.969 49.2501C299.969 49.2501 299.919 49.2501 299.899 49.2501H299.849C299.529 49.2401 299.349 49.1101 299.319 48.8501V48.8201C299.249 48.6201 299.319 48.4001 299.499 48.2801C299.659 48.1901 299.849 48.1901 300.009 48.2601H300.059C300.179 48.2801 300.299 48.3401 300.379 48.4401C300.459 48.5401 300.489 48.6601 300.469 48.7901C300.459 48.8801 300.419 48.9601 300.359 49.0301C300.279 49.1701 300.129 49.2501 299.969 49.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M294.9 32.4501C294.9 32.4501 294.68 32.4501 294.67 32.4501C294.64 32.4601 294.6 32.7501 294.56 32.7601C294.56 32.7201 294.68 32.5901 294.68 32.5501C294.71 32.5501 294.87 32.4401 294.9 32.4501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M294.559 33.21C294.429 33.21 294.309 33.1601 294.229 33.0601C294.139 32.9701 294.099 32.8401 294.119 32.7201C294.119 32.6501 294.149 32.58 294.179 32.52V32.4901C294.209 32.3101 294.309 32.1501 294.469 32.0601C294.569 32.0201 294.669 32 294.779 32.02H294.819C294.889 32.02 294.949 32.0201 295.019 32.0301C295.229 32.0901 295.369 32.2901 295.349 32.5101C295.339 32.6901 295.219 32.84 295.049 32.89C295.029 32.89 295.019 32.9101 294.999 32.9201C294.929 33.1101 294.759 33.2301 294.569 33.2301L294.559 33.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.289 36.9801C289.289 36.9801 289.359 37.0701 289.379 37.1301C289.379 37.1501 289.149 37.2801 289.139 37.3101C289.119 37.2101 289.319 37.2401 289.299 37.1401C289.349 37.0901 289.279 36.9701 289.289 36.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.139 37.7601C289.139 37.7601 289.109 37.7601 289.099 37.7601C288.899 37.7401 288.739 37.6001 288.699 37.4101C288.659 37.2401 288.719 37.0701 288.839 36.9501C288.859 36.7601 288.999 36.6001 289.179 36.5601C289.369 36.5101 289.559 36.5901 289.659 36.7501L289.679 36.7801C289.719 36.8301 289.749 36.8901 289.779 36.9401C289.959 37.3001 289.619 37.5301 289.499 37.6001L289.439 37.64C289.359 37.72 289.249 37.7601 289.129 37.7601H289.139Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.859 37.34C304.609 37.34 304.409 37.14 304.409 36.9V36.41C304.409 36.16 304.609 35.9601 304.849 35.9501C305.099 35.9501 305.289 36.15 305.309 36.39V36.8801C305.309 37.1301 305.109 37.33 304.869 37.34H304.859Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.379 32.7001C295.379 32.7001 295.509 32.69 295.549 32.71C295.529 32.71 295.369 32.8201 295.359 32.8001C295.339 32.7701 295.459 32.7101 295.439 32.6801C295.439 32.6701 295.369 32.6801 295.379 32.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.339 33.25C295.199 33.25 295.069 33.1801 294.999 33.0701C294.909 32.9401 294.889 32.78 294.939 32.64C294.949 32.53 295.009 32.43 295.089 32.35C295.229 32.24 295.429 32.2001 295.599 32.2601C295.669 32.2701 295.739 32.3 295.789 32.33C295.929 32.42 296.009 32.5901 295.989 32.7601C295.969 32.9301 295.859 33.0701 295.699 33.1301C295.589 33.2001 295.459 33.24 295.339 33.24V33.25ZM295.549 32.72L295.679 33.03C295.789 32.96 295.839 32.81 295.789 32.69L295.549 32.72ZM295.509 32.79L295.529 32.8201L295.549 32.72L295.509 32.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M291.819 32.6001C291.819 32.6001 291.609 32.6801 291.629 32.6701C291.609 32.6701 291.679 32.6701 291.659 32.6701C291.679 32.6101 291.809 32.6001 291.819 32.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M291.66 33.1201C291.66 33.1201 291.63 33.1201 291.62 33.1201H291.59C291.4 33.1001 291.24 32.9701 291.19 32.7801C291.14 32.5801 291.24 32.3601 291.43 32.2701C291.46 32.2501 291.49 32.2301 291.52 32.2201C291.64 32.1601 291.77 32.1401 291.9 32.1601C292.03 32.1801 292.15 32.2601 292.21 32.3801C292.32 32.5801 292.27 32.8301 292.09 32.9601C292.04 32.9901 291.99 33.0201 291.94 33.0301L291.9 33.0501C291.83 33.1001 291.75 33.1201 291.66 33.1201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.559 34.81C304.559 34.81 304.339 34.81 304.369 34.81C304.339 34.8 304.309 34.69 304.279 34.67C304.369 34.62 304.549 34.78 304.549 34.8L304.559 34.81Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M303.92 34.9501C303.84 34.8401 303.81 34.7101 303.84 34.5801C303.87 34.4501 303.95 34.3401 304.07 34.2801C304.22 34.2101 304.39 34.2001 304.54 34.2601C304.66 34.3101 304.77 34.3901 304.87 34.4801C304.97 34.5701 305.02 34.7001 305.01 34.8401C305 34.9901 304.91 35.2501 304.47 35.2601H304.43C304.43 35.2601 304.39 35.2601 304.38 35.2601C304.35 35.2601 304.33 35.2601 304.3 35.2601", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M291.78 32.7001C291.78 32.7001 291.77 32.7501 291.78 32.7701C291.78 32.8001 291.61 32.66 291.62 32.64C291.63 32.62 291.79 32.6901 291.79 32.7001H291.78Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M291.769 33.23C291.579 33.21 291.399 33.11 291.279 32.96C291.149 32.81 291.129 32.6 291.219 32.42C291.289 32.31 291.389 32.22 291.519 32.19C291.649 32.16 291.779 32.19 291.889 32.25C292.129 32.32 292.269 32.56 292.209 32.8C292.189 32.98 292.079 33.13 291.909 33.19C291.859 33.21 291.809 33.22 291.759 33.22L291.769 33.23Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.859 38.58C304.859 38.58 304.699 38.6001 304.729 38.6101C304.749 38.6201 304.889 38.4301 304.909 38.4401C304.949 38.4801 304.859 38.6001 304.859 38.5701V38.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.709 39.06C304.629 39.06 304.539 39.03 304.479 38.99C304.289 38.86 304.219 38.62 304.319 38.41C304.359 38.34 304.409 38.27 304.489 38.23C304.579 38.1 304.729 38.02 304.879 38C304.999 38 305.129 38.04 305.209 38.12C305.349 38.27 305.389 38.48 305.319 38.67C305.249 38.86 305.079 39 304.879 39.02C304.829 39.04 304.769 39.06 304.709 39.06ZM304.459 38.51L304.659 38.54L304.479 38.33C304.459 38.39 304.449 38.45 304.449 38.51H304.459Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.209 35.1201C304.209 35.1201 304.379 35.0501 304.359 35.0701C304.339 35.0901 304.279 34.9701 304.259 34.9901C304.199 35.0301 304.219 35.1301 304.219 35.1201H304.209Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M303.979 34.64C304.079 34.57 304.199 34.5301 304.319 34.5501C304.429 34.5601 304.529 34.6201 304.609 34.7001C304.729 34.7801 304.799 34.9001 304.809 35.0401C304.819 35.1801 304.769 35.3101 304.669 35.4101C304.599 35.4701 304.52 35.5201 304.43 35.5301C304.38 35.5601 304.33 35.57 304.27 35.58C304.25 35.58 304.229 35.58 304.219 35.58L303.979 34.64ZM304.37 35.1001L304.409 35.4301C304.409 35.4301 304.499 35.3901 304.539 35.3601C304.609 35.3101 304.659 35.2201 304.669 35.1301C304.669 35.1001 304.669 35.0701 304.669 35.0401L304.379 35.1001H304.37Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.409 35C304.409 35 304.529 35.3 304.559 35.26C304.589 35.23 304.509 35.09 304.499 35.05C304.489 35 304.399 34.99 304.409 34.99V35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M303.979 34.8801C304.039 34.6801 304.219 34.55 304.419 34.55C304.649 34.58 304.849 34.7301 304.939 34.9501C305.029 35.1601 305.01 35.41 304.87 35.6C304.78 35.68 304.669 35.72 304.549 35.72C304.519 35.72 304.49 35.72 304.46 35.72L303.979 34.8801ZM304.18 35.3801C304.24 35.4301 304.32 35.46 304.4 35.46V35.3L304.219 35.33L304.18 35.3801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.259 46.15C399.199 46.07 399.099 45.98 399.069 45.93C399.249 45.81 399.509 45.77 399.699 45.67C399.729 45.65 399.719 45.63 399.779 45.65C399.579 45.8 399.459 46 399.269 46.15H399.259Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.26 46.6C399.26 46.6 399.22 46.6 399.2 46.6C399.08 46.58 398.97 46.51 398.9 46.41C398.88 46.38 398.85 46.35 398.82 46.32C398.78 46.28 398.74 46.23 398.71 46.19C398.64 46.09 398.61 45.97 398.64 45.85C398.66 45.73 398.73 45.63 398.84 45.56C398.98 45.48 399.12 45.41 399.28 45.37C399.34 45.35 399.41 45.33 399.47 45.3C399.6 45.19 399.79 45.17 399.95 45.23C400.1 45.28 400.219 45.42 400.239 45.58C400.269 45.74 400.2 45.9 400.07 46.01C400 46.07 399.929 46.14 399.869 46.21C399.769 46.32 399.669 46.42 399.559 46.51C399.479 46.57 399.38 46.61 399.28 46.61L399.26 46.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M421.819 54.83C421.569 54.83 421.369 54.6301 421.369 54.3801V54.1201C421.369 53.8701 421.569 53.67 421.819 53.67C422.069 53.67 422.269 53.8701 422.269 54.1201V54.3801C422.269 54.6301 422.069 54.83 421.819 54.83Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M348.199 28.7101C348.289 28.6201 348.369 28.4301 348.459 28.3501C348.369 28.4401 348.289 28.6301 348.199 28.7101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M348.199 29.16C348.019 29.16 347.849 29.0501 347.789 28.8801C347.729 28.7101 347.759 28.52 347.889 28.39C347.919 28.36 347.939 28.32 347.959 28.29C348.009 28.2 348.079 28.11 348.149 28.03C348.259 27.91 348.429 27.87 348.589 27.91C348.749 27.95 348.869 28.07 348.909 28.23C348.949 28.39 348.909 28.55 348.789 28.67C348.769 28.7 348.739 28.74 348.719 28.77C348.659 28.86 348.599 28.95 348.519 29.03C348.439 29.11 348.319 29.16 348.199 29.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.439 38.8101C418.309 38.9201 418.149 38.9901 417.979 38.9901C417.799 39.0101 417.619 38.95 417.479 38.83C417.359 38.69 417.359 38.5701 417.619 38.4401C417.779 38.3601 417.749 38.1301 417.799 38.0001C417.849 37.8701 417.999 37.69 417.919 37.54L418.439 38.8101ZM419.749 44.1301C419.449 44.1301 419.399 44.11 419.529 43.83C419.639 43.64 419.589 43.3901 419.409 43.2601C419.369 43.2201 419.489 43.1 419.479 43.04C419.459 42.86 419.379 42.69 419.249 42.55C419.109 42.43 418.939 42.3401 418.749 42.3101C418.659 42.3001 418.519 42.33 418.429 42.29C418.489 42.22 418.479 42.0101 418.549 41.9501C418.849 41.7001 418.999 41.73 418.639 41.53C418.499 41.48 418.399 41.3501 418.379 41.2001C418.319 41.0501 418.359 40.8801 418.469 40.7601C418.719 40.5001 418.649 40.5901 418.309 40.4301C418.219 40.3901 418.219 40.18 418.149 40.1C418.219 40.05 418.319 40.07 418.399 40.04C418.489 40 418.539 39.7701 418.639 39.7501C418.829 39.7201 419.109 39.7701 419.109 39.5601", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M419.689 44.26C419.529 44.26 419.419 44.25 419.369 44.16C419.309 44.06 419.359 43.93 419.419 43.8C419.509 43.65 419.469 43.46 419.329 43.36C419.239 43.28 419.299 43.17 419.339 43.1C419.349 43.08 419.359 43.06 419.369 43.05C419.349 42.9 419.279 42.76 419.179 42.65C419.049 42.54 418.899 42.47 418.739 42.44C418.709 42.44 418.679 42.44 418.639 42.44C418.549 42.45 418.459 42.44 418.379 42.4C418.349 42.38 418.329 42.36 418.329 42.32C418.329 42.29 418.329 42.25 418.349 42.23C418.359 42.19 418.369 42.16 418.379 42.12C418.379 42.03 418.419 41.95 418.479 41.88C418.549 41.82 418.619 41.77 418.669 41.74L418.709 41.71C418.709 41.71 418.649 41.67 418.599 41.65C418.429 41.58 418.309 41.42 418.279 41.24C418.219 41.05 418.259 40.85 418.399 40.7L418.419 40.68L418.459 40.63C418.459 40.63 418.349 40.59 418.269 40.55C418.189 40.5 418.129 40.41 418.119 40.31C418.119 40.27 418.099 40.23 418.079 40.2C418.059 40.18 418.049 40.15 418.049 40.11C418.049 40.08 418.069 40.05 418.089 40.03C418.149 39.99 418.219 39.97 418.289 39.97C418.319 39.97 418.339 39.97 418.369 39.96C418.389 39.93 418.409 39.9 418.419 39.87C418.469 39.79 418.519 39.68 418.629 39.66C418.679 39.66 418.729 39.66 418.779 39.65C418.969 39.65 419.009 39.62 419.009 39.58H419.229C419.229 39.85 418.949 39.86 418.789 39.87C418.749 39.87 418.699 39.87 418.659 39.87C418.649 39.9 418.629 39.93 418.609 39.96C418.579 40.04 418.519 40.11 418.439 40.15C418.399 40.17 418.349 40.18 418.299 40.18C418.299 40.2 418.309 40.21 418.309 40.23C418.309 40.27 418.329 40.3 418.349 40.34C418.419 40.37 418.479 40.39 418.529 40.41C418.619 40.44 418.689 40.47 418.709 40.55C418.729 40.64 418.669 40.69 418.549 40.82L418.529 40.84C418.429 40.94 418.439 41.01 418.469 41.18C418.489 41.3 418.519 41.35 418.669 41.44C418.829 41.53 418.929 41.59 418.929 41.69C418.929 41.79 418.859 41.84 418.759 41.91C418.709 41.94 418.649 41.99 418.589 42.04C418.579 42.08 418.569 42.12 418.559 42.16V42.21H418.589C418.589 42.21 418.689 42.21 418.729 42.21C418.939 42.25 419.129 42.34 419.289 42.48C419.439 42.63 419.529 42.83 419.549 43.04C419.549 43.1 419.529 43.16 419.489 43.21V43.23C419.659 43.4 419.699 43.67 419.579 43.89C419.559 43.93 419.539 43.98 419.529 44.02C419.589 44.02 419.639 44.02 419.699 44.02V44.24H419.649L419.689 44.26ZM417.989 39.11H417.979C417.769 39.13 417.549 39.06 417.389 38.92C417.309 38.85 417.269 38.74 417.289 38.64C417.319 38.5 417.459 38.41 417.569 38.36C417.629 38.33 417.639 38.25 417.659 38.14C417.659 38.09 417.679 38.04 417.689 37.99C417.709 37.94 417.729 37.9 417.749 37.85C417.799 37.75 417.839 37.67 417.809 37.62L418.009 37.51C418.069 37.66 418.049 37.83 417.949 37.95C417.929 37.98 417.909 38.02 417.899 38.06C417.889 38.1 417.879 38.13 417.879 38.17C417.879 38.33 417.799 38.48 417.669 38.56C417.529 38.63 417.519 38.67 417.509 38.68C417.509 38.68 417.509 38.71 417.559 38.77C417.679 38.86 417.829 38.9 417.979 38.89C418.119 38.89 418.259 38.83 418.369 38.73L418.509 38.91C418.369 39.04 418.179 39.11 417.989 39.11Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M400.359 45.23C400.339 45.31 400.199 45.27 400.109 45.33C400.089 45.34 400.139 45.42 400.109 45.43C399.949 45.48 399.849 45.44 399.899 45.73C399.949 46.02 400.069 46.07 400.229 46.03C400.509 45.97 400.769 45.9 400.809 46.19C400.839 46.45 400.639 46.75 400.699 47.01C400.739 47.19 400.859 47.59 401.189 47.52C401.229 47.52 401.139 47.54 401.169 47.64C401.209 47.84 401.299 48.02 401.439 48.17C401.539 48.27 401.789 48.25 402.029 48.25C402.149 48.25 402.279 48.25 402.399 48.25C402.839 48.2 402.719 48.12 402.719 48.54C402.709 48.71 402.679 48.88 402.629 49.04C402.599 49.22 402.529 49.38 402.499 49.56C402.469 49.72 402.619 49.72 402.849 49.68C402.869 49.68 402.919 49.82 402.939 49.83C403.129 49.88 403.409 50.07 403.599 50.13C403.599 49.94 403.519 49.62 403.539 49.43C403.539 49.36 403.519 49.21 403.579 49.17C403.769 49.06 403.979 49 404.199 48.98C404.419 48.98 404.629 49.02 404.829 49.12C405.009 49.21 405.019 49.47 405.119 49.66C405.249 49.9 405.519 49.85 405.729 49.81C405.899 49.78 406.049 49.61 406.209 49.58C406.379 49.55 406.539 49.46 406.709 49.43C406.879 49.4 407.059 49.44 407.229 49.41C407.399 49.38 407.599 49.51 407.769 49.47C407.949 49.43 408.109 49.3 408.219 49.35C408.389 49.42 408.529 49.56 408.589 49.74C408.619 49.89 408.539 50.21 408.709 50.25C408.869 50.29 409.039 50.03 409.149 49.93C409.219 49.86 409.149 49.75 409.149 49.63C409.109 49.2 409.209 49.09 409.649 49C409.819 48.97 410.029 49.07 410.159 48.99C410.299 48.89 410.409 48.74 410.479 48.58C410.589 48.29 410.839 48.28 411.139 48.32C411.319 48.35 411.509 48.37 411.689 48.37C411.879 48.37 412.069 48.31 412.239 48.21C412.349 48.15 412.459 48.34 412.609 48.39C412.689 48.41 412.919 48.36 412.979 48.43C412.899 48.47 412.719 48.67 412.639 48.68C412.459 48.69 412.289 48.77 412.149 48.89C412.009 49.01 411.629 49.07 411.649 49.35C411.669 49.55 411.739 49.59 411.589 49.62C411.439 49.65 411.289 49.69 411.139 49.71C410.989 49.73 410.799 49.56 410.649 49.59C410.449 49.61 410.259 49.69 410.099 49.81C410.059 49.89 410.289 50.1 410.319 50.34C410.319 50.38 410.329 50.42 410.339 50.45C410.419 50.7 410.289 50.84 410.029 50.88C409.819 50.91 409.459 50.85 409.489 51.25C409.399 51.38 409.269 51.46 409.119 51.49C408.989 51.45 408.869 51.4 408.759 51.32C408.619 51.26 408.399 50.95 408.249 50.9C408.339 51 408.629 51.18 408.719 51.28C408.749 51.31 408.749 51.36 408.779 51.4C408.889 51.54 409.169 51.75 409.279 51.89C409.119 51.95 408.759 52.07 408.609 52.13C408.349 52.08 407.939 52.32 407.819 51.85C407.749 51.87 407.599 51.7 407.559 51.75C407.399 51.91 407.389 52.21 407.239 52.37C407.059 52.56 406.939 52.83 406.759 52.86C406.579 52.9 406.429 52.57 406.199 52.45C406.059 52.38 405.919 52.36 405.789 52.28C405.659 52.2 405.409 52.35 405.269 52.28C405.129 52.21 405.039 52.04 404.899 52.03C404.749 52.01 404.679 52.13 404.529 52.23C404.319 52.37 403.819 52.45 404.169 52.82C404.299 52.96 404.309 52.87 404.099 52.86C403.929 52.83 403.759 52.82 403.589 52.82C403.359 52.85 403.199 53.1 403.059 53.23C402.889 53.35 402.739 53.51 402.639 53.69C402.559 53.86 402.379 53.94 402.269 54.1C402.159 54.25 402.239 54.54 402.129 54.69C402.069 54.77 401.869 54.92 401.779 54.9C401.569 54.85 401.439 54.53 401.239 54.47C401.039 54.41 400.769 54.54 400.569 54.47C400.419 54.36 400.329 54.18 400.349 53.99C400.349 53.8 400.419 53.62 400.539 53.48C400.559 53.47 400.669 53.58 400.709 53.61C400.839 53.74 400.989 53.83 401.169 53.87C401.429 53.95 401.699 53.96 401.959 53.89C402.039 53.86 401.959 53.47 401.919 53.27C401.879 53.12 401.789 52.98 401.669 52.89C401.569 52.79 401.449 52.83 401.249 52.77C401.069 52.72 400.969 52.42 400.819 52.41C400.639 52.4 400.469 52.41 400.299 52.47C400.119 52.51 399.949 52.58 399.799 52.68C399.709 52.76 399.749 53.03 399.639 53.08C399.419 53.18 399.259 53.02 399.219 52.77C399.169 52.49 399.039 52.13 399.399 51.94C399.569 51.85 399.909 52.06 400.069 51.96C400.199 51.85 400.349 51.77 400.509 51.71C400.629 51.68 400.719 51.31 400.719 51.18C400.719 51.08 400.629 50.76 400.499 50.7C400.229 50.62 399.939 50.63 399.669 50.72C399.509 50.78 399.349 50.82 399.189 50.86C399.019 50.88 398.879 51.22 398.709 51.23C398.539 51.24 398.349 51.05 398.179 51.07C397.999 51.08 398.009 50.86 398.129 50.59C398.219 50.4 398.459 50.27 398.539 50.07C398.619 49.87 398.559 49.62 398.629 49.42C398.679 49.28 398.549 49.14 398.549 48.98C398.459 49.1 398.309 49.11 398.219 49.24C398.199 49.27 398.389 49.46 398.359 49.49C398.279 49.6 398.079 49.61 397.989 49.72C397.999 49.6 397.959 49.47 397.969 49.35C397.969 49.25 398.129 49.07 398.079 49C397.979 48.85 397.919 48.79 397.929 48.68C397.929 48.58 397.919 48.55 398.159 48.48C398.299 48.44 398.369 48.03 398.589 47.89C398.659 47.8 398.649 47.67 398.589 47.59C398.519 47.5 398.399 47.47 398.299 47.52C398.069 47.63 397.879 47.49 397.689 47.48C397.469 47.48 397.299 47.54 397.109 47.43C396.929 47.31 396.759 47.18 396.609 47.04C396.439 46.9 396.299 46.68 396.119 46.57C396.049 46.53 396.049 46.58 396.099 46.52C396.179 46.42 396.229 46.08 396.349 46.1C396.519 46.13 396.619 46.45 396.779 46.54C396.959 46.67 397.149 46.78 397.359 46.86C397.569 46.9 397.789 46.69 397.989 46.63C398.169 46.58 398.269 46.41 398.449 46.26C398.539 46.18 398.629 46.17 398.679 46.07C398.709 46 398.859 45.83 398.849 45.74C398.789 45.78 398.709 46.01 398.649 46.05C398.619 46.07 398.589 46.16 398.559 46.18C398.419 46.24 398.289 46.06 398.139 46.12L400.359 45.23ZM402.659 52.67C402.839 52.51 403.029 52.37 403.229 52.24C403.549 52.03 403.399 51.78 403.109 51.63C402.969 51.54 402.799 51.53 402.659 51.6C402.569 51.62 402.369 51.6 402.299 51.89C402.269 52.01 402.509 52.19 402.479 52.31C402.419 52.52 402.379 52.67 402.659 52.68V52.67ZM402.079 51.42C402.159 51.28 402.349 50.97 402.439 50.8C402.209 50.67 401.959 50.58 401.699 50.52C401.479 50.49 401.639 50.73 401.669 50.89C401.719 51.13 401.739 51.4 402.079 51.42ZM402.899 50.83C402.849 50.8 402.769 50.66 402.729 50.64C402.729 50.64 402.609 50.8 402.599 50.81C402.629 50.85 402.789 50.77 402.829 50.81C402.829 50.81 402.869 50.87 402.909 50.83H402.899Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.769 55.0301C401.769 55.0301 401.739 55.0301 401.719 55.0301C401.589 54.9801 401.469 54.9001 401.389 54.7801C401.329 54.7001 401.259 54.6401 401.179 54.6001C401.089 54.5801 400.999 54.5901 400.909 54.6001C400.779 54.6301 400.639 54.6301 400.509 54.5801C400.309 54.4501 400.199 54.2301 400.219 53.9901C400.219 53.7701 400.309 53.5701 400.449 53.4001C400.539 53.3201 400.629 53.4001 400.749 53.5101L400.769 53.5301C400.879 53.6401 401.019 53.7201 401.169 53.7701L401.289 53.7901C401.479 53.8401 401.669 53.8501 401.859 53.8101C401.859 53.6401 401.829 53.4701 401.789 53.3001C401.759 53.1901 401.699 53.0801 401.609 53.0101L401.569 52.9701C401.569 52.9701 401.509 52.9301 401.419 52.9201C401.339 52.9201 401.269 52.9001 401.199 52.8801C401.089 52.8301 400.989 52.7501 400.929 52.6501C400.899 52.6101 400.829 52.5301 400.799 52.5301C400.639 52.5201 400.479 52.5301 400.319 52.5801C400.279 52.6001 400.229 52.6101 400.179 52.6201C400.059 52.6501 399.949 52.7001 399.849 52.7701C399.829 52.8101 399.819 52.8501 399.819 52.9001C399.799 53.0101 399.779 53.1401 399.669 53.1901C399.569 53.2401 399.439 53.2501 399.339 53.1901C399.199 53.1001 399.109 52.9601 399.099 52.8001C399.099 52.7601 399.089 52.7301 399.079 52.6901C399.029 52.4201 398.949 52.0601 399.339 51.8601C399.469 51.8101 399.609 51.8101 399.749 51.8601C399.849 51.8801 399.969 51.9101 400.009 51.8801C400.049 51.8601 400.079 51.8301 400.109 51.8101C400.219 51.7201 400.339 51.6601 400.469 51.6201C400.549 51.4901 400.589 51.3501 400.599 51.2001C400.589 51.0601 400.529 50.9201 400.439 50.8201C400.189 50.7501 399.929 50.7601 399.689 50.8501C399.629 50.8701 399.579 50.8801 399.529 50.9001C399.419 50.9401 399.309 50.9701 399.199 50.9901C399.159 50.9901 399.089 51.0701 399.029 51.1401C398.959 51.2501 398.839 51.3301 398.709 51.3601C398.589 51.3601 398.479 51.3301 398.379 51.2701C398.319 51.2301 398.239 51.2101 398.169 51.2001C398.089 51.2001 398.009 51.1701 397.959 51.1101C397.859 50.9701 397.929 50.7401 398.009 50.5601C398.069 50.4501 398.139 50.3501 398.239 50.2701C398.309 50.2101 398.379 50.1301 398.419 50.0401C398.449 49.9401 398.469 49.8401 398.459 49.7401C398.459 49.6201 398.469 49.5001 398.509 49.3901C398.509 49.3301 398.509 49.2701 398.479 49.2201V49.1901L398.429 49.2101C398.429 49.2101 398.369 49.2401 398.339 49.2601L398.369 49.3001C398.439 49.4001 398.499 49.4801 398.439 49.5601C398.379 49.6301 398.299 49.6801 398.209 49.7101C398.159 49.7301 398.109 49.7501 398.069 49.7901C398.039 49.8301 397.989 49.8401 397.939 49.8201C397.889 49.8001 397.869 49.7601 397.869 49.7101C397.869 49.6501 397.869 49.5901 397.859 49.5301C397.859 49.4701 397.849 49.4101 397.849 49.3401C397.849 49.2701 397.879 49.2001 397.919 49.1301C397.939 49.1001 397.949 49.0701 397.969 49.0301L397.949 49.0001C397.859 48.9101 397.819 48.7901 397.819 48.6601C397.829 48.4801 397.909 48.4301 398.129 48.3701C398.169 48.3201 398.199 48.2601 398.229 48.1901C398.289 48.0401 398.379 47.9101 398.499 47.8101C398.499 47.7601 398.499 47.7001 398.499 47.6501C398.449 47.6301 398.389 47.6101 398.329 47.6101C398.179 47.6701 397.999 47.6701 397.849 47.6101C397.789 47.5901 397.739 47.5801 397.679 47.5701C397.619 47.5701 397.559 47.5701 397.499 47.5701C397.349 47.6001 397.189 47.5701 397.049 47.5001C396.919 47.4201 396.799 47.3301 396.689 47.2301C396.639 47.1901 396.589 47.1401 396.529 47.1001C396.449 47.0301 396.369 46.9601 396.309 46.8801C396.239 46.7901 396.149 46.7101 396.059 46.6401C396.009 46.6401 395.969 46.6101 395.949 46.5601C395.929 46.5101 395.949 46.4601 395.999 46.4301C396.029 46.3801 396.049 46.3301 396.069 46.2701C396.129 46.1201 396.199 45.9201 396.369 45.9501C396.509 45.9701 396.599 46.1001 396.679 46.2201C396.719 46.2901 396.769 46.3501 396.829 46.4001C396.899 46.4401 396.969 46.4901 397.039 46.5301C397.139 46.6101 397.259 46.6701 397.379 46.7101C397.499 46.7101 397.609 46.6701 397.709 46.6001C397.789 46.5501 397.869 46.5101 397.959 46.4801C398.059 46.4401 398.149 46.3801 398.209 46.2901C398.239 46.2601 398.269 46.2301 398.299 46.2001C398.239 46.1701 398.209 46.1601 398.179 46.1701L398.099 45.9601C398.199 45.9301 398.309 45.9401 398.399 46.0001C398.429 46.0201 398.459 46.0301 398.499 46.0301V46.0101C398.499 46.0101 398.549 45.9301 398.589 45.9101C398.609 45.8701 398.629 45.8401 398.649 45.8001C398.679 45.7201 398.729 45.6501 398.799 45.6001C398.829 45.5801 398.869 45.5801 398.909 45.6001C398.939 45.6201 398.969 45.6501 398.969 45.6901C398.969 45.8101 398.919 45.9201 398.839 46.0101C398.819 46.0301 398.809 46.0601 398.789 46.0801C398.749 46.1601 398.689 46.2201 398.609 46.2601C398.579 46.2801 398.559 46.2901 398.529 46.3101C398.479 46.3601 398.429 46.4001 398.379 46.4501C398.289 46.5601 398.169 46.6501 398.029 46.7001C397.959 46.7301 397.889 46.7601 397.819 46.8001C397.679 46.9001 397.509 46.9501 397.339 46.9401C397.189 46.9001 397.039 46.8201 396.919 46.7301C396.859 46.6901 396.789 46.6401 396.729 46.6101C396.639 46.5501 396.559 46.4601 396.499 46.3601C396.459 46.3001 396.419 46.2401 396.359 46.1901C396.329 46.2401 396.309 46.3001 396.289 46.3601C396.269 46.4101 396.259 46.4501 396.239 46.4901C396.329 46.5601 396.419 46.6401 396.489 46.7301C396.549 46.8001 396.619 46.8701 396.689 46.9301C396.749 46.9701 396.799 47.0201 396.849 47.0701C396.949 47.1601 397.059 47.2401 397.169 47.3101C397.269 47.3601 397.379 47.3701 397.489 47.3501C397.549 47.3501 397.619 47.3501 397.689 47.3501C397.769 47.3501 397.839 47.3701 397.919 47.3901C398.029 47.4401 398.139 47.4401 398.249 47.3901C398.399 47.3501 398.559 47.3901 398.679 47.4901C398.759 47.5701 398.739 47.7501 398.739 47.8001C398.739 47.8601 398.709 47.9201 398.659 47.9601C398.559 48.0501 398.489 48.1501 398.439 48.2701C398.369 48.4101 398.309 48.5301 398.199 48.5601C398.149 48.5701 398.099 48.5901 398.049 48.6201V48.6601C398.049 48.7101 398.059 48.7401 398.139 48.8501L398.179 48.9001C398.179 48.9001 398.219 49.0101 398.199 49.0601C398.239 49.0301 398.279 49.0001 398.329 48.9701C398.379 48.9501 398.419 48.9201 398.459 48.8701C398.489 48.8301 398.539 48.8101 398.579 48.8301C398.629 48.8401 398.659 48.8901 398.659 48.9401C398.659 48.9901 398.679 49.0501 398.699 49.1001C398.749 49.2001 398.759 49.3101 398.729 49.4201C398.699 49.5101 398.689 49.6101 398.699 49.7001C398.699 49.8301 398.679 49.9601 398.639 50.0801C398.579 50.1901 398.499 50.3001 398.409 50.3801C398.339 50.4401 398.279 50.5201 398.229 50.6001C398.129 50.8201 398.149 50.9101 398.159 50.9301C398.279 50.9301 398.389 50.9601 398.489 51.0201C398.549 51.0601 398.629 51.0801 398.699 51.0901C398.739 51.0901 398.819 51.0001 398.869 50.9401C398.939 50.8301 399.049 50.7501 399.169 50.7201C399.269 50.7001 399.369 50.6801 399.459 50.6401C399.519 50.6201 399.569 50.6001 399.629 50.5901C399.919 50.4801 400.239 50.4801 400.539 50.5701C400.729 50.6601 400.819 51.0501 400.819 51.1501C400.819 51.2401 400.739 51.7201 400.529 51.7901C400.419 51.8201 400.319 51.8801 400.239 51.9501C400.199 51.9801 400.169 52.0001 400.129 52.0301C399.989 52.0901 399.839 52.0901 399.699 52.0401C399.619 52.0101 399.529 52.0001 399.449 52.0201C399.229 52.1401 399.249 52.3201 399.299 52.6101C399.299 52.6501 399.319 52.6901 399.319 52.7301C399.319 52.8201 399.369 52.9101 399.449 52.9601C399.489 52.9801 399.539 52.9801 399.579 52.9601C399.589 52.9201 399.599 52.8801 399.609 52.8301C399.609 52.7301 399.649 52.6401 399.719 52.5701C399.839 52.4801 399.979 52.4201 400.129 52.3801C400.169 52.3701 400.219 52.3501 400.249 52.3401C400.429 52.2801 400.629 52.2601 400.819 52.2701C400.949 52.2701 401.029 52.3801 401.109 52.4801C401.159 52.5401 401.219 52.6201 401.269 52.6301C401.329 52.6501 401.389 52.6601 401.449 52.6601C401.559 52.6601 401.659 52.7001 401.739 52.7701L401.769 52.8101C401.889 52.9101 401.979 53.0601 402.009 53.2101C402.129 53.7801 402.099 53.9101 401.989 53.9601C401.749 54.0301 401.489 54.0401 401.249 53.9601L401.129 53.9401C400.939 53.8901 400.759 53.7901 400.619 53.6501L400.589 53.6301C400.589 53.6301 400.559 53.6001 400.539 53.5901C400.479 53.7001 400.439 53.8301 400.439 53.9501C400.429 54.0901 400.479 54.2301 400.589 54.3201C400.679 54.3401 400.779 54.3401 400.879 54.3201C400.999 54.2901 401.129 54.2901 401.249 54.3201C401.369 54.3701 401.479 54.4601 401.559 54.5601C401.619 54.6401 401.689 54.7001 401.779 54.7401C401.869 54.7001 401.949 54.6501 402.009 54.5701C402.049 54.5001 402.059 54.4101 402.059 54.3301C402.059 54.2101 402.089 54.0901 402.149 53.9801C402.199 53.9101 402.269 53.8401 402.339 53.7901C402.409 53.7401 402.469 53.6701 402.509 53.6001C402.599 53.4301 402.719 53.2901 402.869 53.1801C402.899 53.1501 402.929 53.1301 402.959 53.1001C402.989 53.0701 403.029 53.0301 403.059 52.9901C403.179 52.8201 403.349 52.7101 403.549 52.6601C403.669 52.6601 403.789 52.6601 403.899 52.6801H403.939C403.909 52.6301 403.899 52.5601 403.909 52.5001C403.939 52.3301 404.129 52.2401 404.289 52.1701C404.339 52.1501 404.389 52.1201 404.439 52.0901C404.479 52.0701 404.509 52.0401 404.539 52.0101C404.629 51.9201 404.749 51.8701 404.879 51.8701C404.989 51.8901 405.089 51.9501 405.159 52.0301C405.199 52.0701 405.239 52.1001 405.289 52.1301C405.349 52.1301 405.409 52.1301 405.469 52.1201C405.579 52.0801 405.699 52.0901 405.809 52.1301C405.879 52.1701 405.949 52.2001 406.019 52.2201C406.079 52.2401 406.149 52.2701 406.209 52.2901C406.329 52.3501 406.429 52.4401 406.509 52.5401C406.579 52.6101 406.659 52.7001 406.699 52.6901C406.769 52.6801 406.849 52.5701 406.929 52.4601C406.989 52.3801 407.049 52.3001 407.119 52.2301C407.179 52.1501 407.229 52.0601 407.259 51.9601C407.299 51.8301 407.359 51.7101 407.449 51.6101C407.539 51.5201 407.649 51.6001 407.719 51.6401C407.739 51.6501 407.759 51.6701 407.779 51.6801C407.799 51.6801 407.819 51.6801 407.839 51.6901C407.869 51.7001 407.889 51.7301 407.899 51.7601C407.959 51.9901 408.079 51.9901 408.319 51.9601C408.399 51.9501 408.489 51.9401 408.569 51.9601L409.049 51.7901C409.049 51.7901 408.959 51.7101 408.919 51.6701C408.829 51.5901 408.739 51.5101 408.659 51.4201C408.639 51.3901 408.619 51.3601 408.609 51.3301C408.539 51.2801 408.479 51.2201 408.419 51.1601L408.379 51.1301C408.289 51.0701 408.199 51.0001 408.129 50.9201C408.099 50.8801 408.089 50.8301 408.119 50.7801C408.149 50.7301 408.199 50.7201 408.249 50.7301C408.369 50.7901 408.479 50.8701 408.569 50.9801C408.639 51.0301 408.709 51.0801 408.769 51.1401H408.779C408.779 51.1401 408.859 51.1901 408.899 51.2201C408.959 51.2601 409.019 51.2901 409.089 51.3101C409.189 51.2801 409.269 51.2301 409.339 51.1501C409.339 51.0501 409.359 50.9401 409.429 50.8601C409.549 50.7601 409.699 50.7001 409.859 50.7101C409.899 50.7101 409.939 50.7101 409.979 50.7001C410.059 50.7001 410.139 50.6601 410.199 50.6001C410.229 50.5401 410.229 50.4701 410.199 50.4101C410.199 50.3701 410.179 50.3401 410.179 50.3001C410.159 50.1801 410.109 50.0701 410.039 49.9801C409.969 49.8701 409.919 49.7701 409.959 49.6801C410.049 49.5101 410.499 49.4201 410.579 49.4001C410.689 49.4001 410.799 49.4101 410.889 49.4701C410.939 49.5001 411.009 49.5201 411.069 49.5201C411.139 49.5101 411.209 49.4901 411.279 49.4801C411.359 49.4601 411.429 49.4501 411.509 49.4301C411.499 49.3801 411.489 49.3301 411.489 49.2801C411.469 49.0101 411.709 48.8901 411.869 48.8101C411.919 48.7901 411.969 48.7601 412.019 48.7201C412.169 48.5801 412.359 48.5001 412.569 48.4801C412.599 48.4601 412.629 48.4401 412.649 48.4201C412.609 48.4201 412.559 48.4201 412.519 48.4101C412.449 48.3801 412.379 48.3401 412.319 48.2901C412.289 48.2701 412.259 48.2401 412.229 48.2301C412.049 48.3301 411.849 48.3901 411.639 48.4001C411.479 48.4001 411.319 48.3901 411.159 48.3601H411.069C410.739 48.3001 410.599 48.3501 410.539 48.5301C410.469 48.7201 410.339 48.8801 410.179 49.0001C410.069 49.0601 409.949 49.0701 409.829 49.0401C409.769 49.0301 409.699 49.0201 409.639 49.0401C409.249 49.1201 409.199 49.1801 409.229 49.5501C409.229 49.5801 409.239 49.6201 409.249 49.6501C409.289 49.7501 409.279 49.8601 409.199 49.9501C409.179 49.9701 409.149 50.0001 409.119 50.0301C409.009 50.1601 408.839 50.3401 408.659 50.2901C408.459 50.2401 408.469 50.0101 408.469 49.8401C408.469 49.7901 408.469 49.7401 408.469 49.6901C408.409 49.5501 408.299 49.4301 408.159 49.3801C408.139 49.3701 408.049 49.4101 407.999 49.4301C407.929 49.4601 407.859 49.4901 407.779 49.5101C407.669 49.5201 407.559 49.5101 407.459 49.4801C407.389 49.4601 407.319 49.4501 407.239 49.4501C407.149 49.4601 407.049 49.4701 406.949 49.4601C406.869 49.4601 406.789 49.4601 406.719 49.4601C406.639 49.4801 406.569 49.5001 406.489 49.5301C406.399 49.5701 406.309 49.5901 406.219 49.6101C406.149 49.6301 406.079 49.6601 406.009 49.7101C405.929 49.7701 405.829 49.8101 405.729 49.8401C405.499 49.8801 405.169 49.9501 404.999 49.6401C404.959 49.5701 404.929 49.4901 404.909 49.4101C404.869 49.2901 404.839 49.1801 404.759 49.1401C404.579 49.0501 404.389 49.0101 404.189 49.0101C403.989 49.0201 403.799 49.0801 403.619 49.1801C403.629 49.1801 403.629 49.2501 403.629 49.2801C403.629 49.3101 403.629 49.3301 403.629 49.3501C403.629 49.4801 403.639 49.6001 403.659 49.7201C403.679 49.8301 403.689 49.9301 403.689 50.0401C403.689 50.0801 403.669 50.1101 403.649 50.1301C403.619 50.1501 403.579 50.1601 403.549 50.1501C403.429 50.1101 403.319 50.0501 403.209 49.9901C403.109 49.9301 403.009 49.8801 402.899 49.8501C402.839 49.8301 402.819 49.7901 402.789 49.7201C402.629 49.7401 402.509 49.7301 402.429 49.6601C402.379 49.6001 402.359 49.5201 402.379 49.4501C402.399 49.3701 402.419 49.2801 402.439 49.2001C402.469 49.1101 402.489 49.0201 402.509 48.9301C402.519 48.8701 402.539 48.8101 402.549 48.7501C402.579 48.6501 402.599 48.5501 402.599 48.4501C402.599 48.3601 402.599 48.2901 402.599 48.2401C402.599 48.2401 402.489 48.2601 402.399 48.2701C402.299 48.2701 402.209 48.2801 402.109 48.2701H401.909C401.719 48.3001 401.519 48.2701 401.349 48.1501C401.199 47.9801 401.099 47.7801 401.049 47.5601C401.049 47.5601 401.049 47.5401 401.049 47.5301C400.989 47.5301 400.939 47.5001 400.889 47.4701C400.729 47.3301 400.619 47.1401 400.589 46.9301C400.569 46.7701 400.589 46.6101 400.649 46.4501C400.689 46.3401 400.709 46.2201 400.709 46.1001C400.709 46.0601 400.699 46.0301 400.669 46.0101C400.609 45.9701 400.449 46.0101 400.299 46.0401H400.259C400.169 46.0701 400.059 46.0601 399.979 46.0101C399.869 45.9201 399.809 45.7901 399.789 45.6601C399.739 45.3801 399.829 45.3001 399.989 45.2601C399.989 45.2201 400.009 45.1801 400.039 45.1501C400.099 45.1201 400.159 45.1001 400.219 45.0901C400.239 45.0901 400.249 45.0901 400.269 45.0901C400.259 45.0901 400.249 45.1101 400.249 45.1201L400.469 45.1801C400.439 45.2701 400.349 45.3301 400.259 45.3201H400.229C400.229 45.3801 400.209 45.4301 400.149 45.4501C400.119 45.4601 400.089 45.4701 400.059 45.4801C400.039 45.4801 400.019 45.4801 399.999 45.5001C399.999 45.5401 399.999 45.5901 400.009 45.6301C400.039 45.7801 400.079 45.8201 400.099 45.8401C400.109 45.8401 400.139 45.8601 400.209 45.8401H400.249C400.429 45.7601 400.619 45.7701 400.789 45.8401C400.869 45.9001 400.919 45.9901 400.919 46.0901C400.919 46.2401 400.909 46.3901 400.859 46.5301C400.819 46.6501 400.799 46.7801 400.809 46.9001C400.829 47.0501 400.899 47.1901 401.019 47.3001C401.059 47.3301 401.119 47.3401 401.169 47.3201C401.219 47.3101 401.269 47.3201 401.299 47.3701C401.319 47.4201 401.319 47.4701 401.279 47.5101C401.309 47.6901 401.389 47.8601 401.509 48.0101C401.559 48.0601 401.749 48.0601 401.909 48.0601H402.119C402.209 48.0601 402.289 48.0601 402.379 48.0601C402.459 48.0601 402.519 48.0401 402.569 48.0301C402.669 48.0101 402.739 48.0001 402.789 48.0501C402.839 48.1001 402.839 48.1701 402.829 48.2501C402.829 48.3001 402.829 48.3601 402.829 48.4501C402.829 48.5701 402.809 48.6901 402.779 48.8101C402.769 48.8601 402.749 48.9201 402.739 48.9701C402.719 49.0701 402.699 49.1701 402.669 49.2601C402.649 49.3401 402.629 49.4101 402.609 49.4901C402.609 49.4901 402.649 49.5101 402.829 49.4801C402.919 49.4601 402.969 49.5501 402.999 49.6201V49.6401C403.119 49.6801 403.219 49.7301 403.329 49.7901C403.379 49.8201 403.429 49.8401 403.469 49.8601C403.469 49.8201 403.469 49.7801 403.449 49.7401C403.429 49.6001 403.409 49.4601 403.419 49.3201C403.419 49.3101 403.419 49.2901 403.419 49.2701C403.419 49.1701 403.419 49.0301 403.509 48.9701C403.719 48.8501 403.949 48.7801 404.179 48.7701C404.419 48.7701 404.649 48.8101 404.869 48.9201C405.009 49.0101 405.099 49.1501 405.129 49.3201C405.149 49.3901 405.179 49.4501 405.209 49.5101C405.299 49.6601 405.449 49.6501 405.689 49.6001C405.769 49.5801 405.839 49.5501 405.909 49.5001C405.999 49.4401 406.089 49.4001 406.189 49.3701C406.269 49.3501 406.339 49.3301 406.419 49.3001C406.509 49.2601 406.599 49.2401 406.689 49.2201C406.779 49.2101 406.879 49.2001 406.969 49.2101C407.049 49.2101 407.129 49.2101 407.209 49.2101C407.319 49.2001 407.419 49.2101 407.529 49.2401C407.599 49.2701 407.679 49.2801 407.749 49.2701C407.809 49.2501 407.869 49.2301 407.929 49.2101C408.029 49.1401 408.159 49.1301 408.279 49.1601C408.479 49.2501 408.639 49.4201 408.709 49.6301C408.719 49.7001 408.719 49.7701 408.719 49.8301C408.719 49.8901 408.719 50.0301 408.739 50.0501C408.799 50.0501 408.919 49.9301 408.979 49.8601C409.009 49.8201 409.039 49.7901 409.069 49.7601C409.069 49.7601 409.059 49.7101 409.049 49.6801C409.039 49.6401 409.029 49.5901 409.019 49.5401C408.979 49.0601 409.109 48.9001 409.609 48.8001C409.699 48.7901 409.789 48.7901 409.879 48.8001C409.939 48.8201 410.009 48.8201 410.079 48.8001C410.199 48.7101 410.299 48.5901 410.349 48.4401C410.499 48.0301 410.929 48.0801 411.129 48.1101H411.229C411.369 48.1501 411.519 48.1601 411.669 48.1601C411.839 48.1601 412.009 48.1001 412.169 48.0201C412.299 47.9401 412.419 48.0401 412.499 48.1001C412.539 48.1401 412.579 48.1601 412.629 48.1801C412.659 48.1801 412.699 48.1801 412.729 48.1801C412.839 48.1601 412.959 48.1801 413.049 48.2501C413.069 48.2801 413.079 48.3101 413.079 48.3501C413.079 48.3801 413.049 48.4101 413.019 48.4301C412.979 48.4601 412.939 48.4901 412.909 48.5201C412.839 48.6001 412.749 48.6601 412.639 48.6901C412.479 48.6901 412.329 48.7601 412.209 48.8701C412.149 48.9201 412.079 48.9601 412.009 48.9901C411.839 49.0701 411.739 49.1301 411.749 49.2401C411.749 49.2801 411.759 49.3201 411.769 49.3601C411.799 49.4201 411.789 49.4901 411.759 49.5401C411.719 49.5901 411.659 49.6301 411.599 49.6301C411.519 49.6401 411.449 49.6601 411.379 49.6801C411.309 49.7001 411.229 49.7101 411.159 49.7301C411.049 49.7301 410.949 49.7201 410.849 49.6601C410.789 49.6301 410.729 49.6101 410.669 49.6101C410.509 49.6401 410.359 49.6901 410.219 49.7601C410.229 49.7901 410.249 49.8201 410.269 49.8501C410.349 49.9701 410.399 50.1001 410.429 50.2301C410.429 50.2601 410.429 50.3001 410.449 50.3301C410.499 50.4501 410.489 50.5901 410.419 50.7001C410.329 50.8201 410.199 50.8901 410.049 50.9001C410.009 50.9001 409.959 50.9001 409.919 50.9101C409.809 50.9101 409.689 50.9301 409.649 50.9801C409.619 51.0301 409.609 51.0901 409.619 51.1401C409.619 51.1901 409.589 51.2401 409.549 51.2801C409.449 51.3901 409.309 51.4701 409.159 51.5001C409.239 51.5701 409.309 51.6401 409.379 51.7201C409.399 51.7501 409.409 51.7901 409.399 51.8201C409.399 51.8601 409.359 51.8801 409.329 51.9001L408.659 52.1401C408.659 52.1401 408.619 52.1401 408.599 52.1401C408.529 52.1401 408.459 52.1401 408.379 52.1401C408.169 52.1601 407.869 52.2001 407.739 51.8401C407.699 51.8201 407.659 51.8001 407.629 51.7801H407.609C407.569 51.8401 407.539 51.9101 407.509 51.9901C407.469 52.1201 407.409 52.2401 407.319 52.3401C407.259 52.4001 407.209 52.4701 407.149 52.5401C407.039 52.6901 406.939 52.8301 406.779 52.8601C406.609 52.8901 406.499 52.7701 406.379 52.6401C406.309 52.5601 406.229 52.4901 406.139 52.4401C406.089 52.4201 406.029 52.3901 405.969 52.3801C405.879 52.3501 405.799 52.3201 405.709 52.2701C405.649 52.2701 405.579 52.2701 405.519 52.2801C405.409 52.3101 405.299 52.3101 405.189 52.2801C405.119 52.2401 405.059 52.2001 405.009 52.1401C404.969 52.0901 404.919 52.0601 404.859 52.0401C404.809 52.0401 404.769 52.0601 404.689 52.1301C404.649 52.1601 404.609 52.1901 404.569 52.2201C404.509 52.2601 404.449 52.2901 404.389 52.3101C404.289 52.3601 404.149 52.4201 404.139 52.4801C404.139 52.5101 404.169 52.5701 404.229 52.6301C404.239 52.6501 404.259 52.6601 404.279 52.6701C404.319 52.6901 404.339 52.7201 404.349 52.7501C404.359 52.8001 404.339 52.8501 404.289 52.8701C404.249 52.8901 404.199 52.8901 404.159 52.8701C404.129 52.8701 404.099 52.8601 404.059 52.8501C403.999 52.8501 403.929 52.8401 403.859 52.8301C403.759 52.8101 403.659 52.8001 403.569 52.8101C403.439 52.8201 403.319 52.9501 403.219 53.0701C403.179 53.1201 403.139 53.1601 403.099 53.1901C403.069 53.2201 403.039 53.2401 403.009 53.2701C402.879 53.3601 402.779 53.4801 402.709 53.6101C402.659 53.7201 402.579 53.8101 402.479 53.8801C402.419 53.9201 402.369 53.9801 402.329 54.0301C402.299 54.1001 402.279 54.1901 402.279 54.2701C402.279 54.4001 402.249 54.5201 402.179 54.6301C402.079 54.7601 401.929 54.8501 401.759 54.8901L401.769 55.0301ZM398.099 49.3101C398.099 49.3101 398.079 49.3501 398.069 49.3801C398.069 49.4301 398.069 49.4801 398.079 49.5301H398.119C398.119 49.5301 398.179 49.5001 398.209 49.4901L398.189 49.4601C398.189 49.4601 398.119 49.3701 398.099 49.3101ZM402.649 52.7801C402.539 52.7801 402.439 52.7501 402.369 52.6701C402.289 52.5601 402.329 52.4301 402.369 52.2801C402.349 52.2301 402.329 52.1901 402.299 52.1501C402.219 52.0701 402.179 51.9601 402.189 51.8501C402.219 51.6401 402.389 51.4901 402.599 51.4801C402.609 51.4801 402.629 51.4801 402.639 51.4801C402.649 51.4801 402.659 51.4801 402.669 51.4701C402.829 51.4001 403.019 51.4201 403.169 51.5201C403.359 51.5901 403.489 51.7601 403.519 51.9601C403.519 52.1201 403.429 52.2601 403.289 52.3301C403.099 52.4601 402.909 52.6001 402.729 52.7501C402.709 52.7701 402.679 52.7801 402.649 52.7801ZM402.539 52.5401C402.539 52.5401 402.579 52.5601 402.609 52.5601C402.779 52.4101 402.969 52.2801 403.159 52.1501C403.219 52.1101 403.289 52.0501 403.289 51.9801C403.289 51.9001 403.199 51.8101 403.049 51.7301C402.959 51.6601 402.839 51.6501 402.739 51.6901C402.719 51.6901 402.699 51.7001 402.679 51.7101C402.659 51.7101 402.639 51.7101 402.619 51.7101C402.529 51.7201 402.449 51.7301 402.399 51.9001C402.419 51.9401 402.449 51.9801 402.469 52.0201C402.549 52.1001 402.589 52.2101 402.579 52.3201C402.559 52.3901 402.539 52.4601 402.539 52.5301V52.5401ZM402.069 51.5301C401.669 51.5101 401.609 51.2001 401.569 50.9601V50.9101C401.569 50.9101 401.539 50.8301 401.519 50.8001C401.479 50.6901 401.439 50.5701 401.509 50.4801C401.559 50.4201 401.639 50.4001 401.709 50.4201C401.979 50.4801 402.239 50.5801 402.479 50.7101C402.489 50.7101 402.499 50.7201 402.509 50.7301C402.509 50.7301 402.509 50.7101 402.539 50.6801C402.619 50.5701 402.659 50.5101 402.749 50.5501C402.799 50.5801 402.849 50.6201 402.879 50.6801C402.899 50.7001 402.919 50.7301 402.939 50.7501C402.969 50.7701 402.989 50.8001 402.989 50.8401C402.989 50.8801 402.979 50.9101 402.949 50.9401C402.919 50.9701 402.869 50.9801 402.829 50.9801C402.799 50.9801 402.769 50.9601 402.739 50.9401H402.699C402.629 50.9701 402.549 50.9601 402.489 50.9201C402.439 51.0101 402.379 51.1101 402.309 51.2201C402.249 51.3301 402.179 51.4301 402.149 51.5001C402.129 51.5401 402.089 51.5601 402.049 51.5601L402.069 51.5301ZM401.699 50.6301C401.699 50.6301 401.719 50.6901 401.729 50.7201C401.749 50.7701 401.759 50.8201 401.769 50.8701V50.9201C401.819 51.1401 401.849 51.2601 402.009 51.3001C402.049 51.2401 402.089 51.1601 402.139 51.0801C402.189 51.0001 402.239 50.9201 402.279 50.8501C402.099 50.7501 401.899 50.6801 401.699 50.6401V50.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M416.649 51.5201C416.869 51.4101 417.129 51.2901 417.339 51.1901C417.559 51.0801 417.729 50.8901 417.939 50.7901C417.999 50.7601 417.919 50.8301 417.989 50.8301C417.959 50.8801 418.179 50.9701 418.139 51.0001C417.989 51.1201 417.869 51.2901 417.719 51.4101C417.569 51.5301 417.219 51.4101 417.069 51.5301C416.919 51.6501 416.799 51.8101 416.639 51.9301C416.489 52.0501 416.279 52.0901 416.119 52.2101C415.969 52.3301 415.829 52.4701 415.669 52.5801C415.549 52.6801 415.459 52.7201 415.419 52.5701C415.399 52.4701 415.469 52.3401 415.419 52.2501C415.279 52.0001 415.089 52.0201 414.899 52.2501C414.819 52.3701 414.759 52.4901 414.699 52.6201C414.619 52.8001 414.509 52.9701 414.369 53.1101C414.239 53.2101 413.979 53.1801 413.769 53.1801C413.669 53.1701 413.559 53.2001 413.479 53.2601C413.399 53.3201 413.349 53.4301 413.349 53.5301C413.319 53.7501 413.389 54.0301 413.269 54.1501C413.149 54.2601 412.879 54.1701 412.649 54.1901C412.269 54.2301 412.189 54.4201 412.429 54.7201C412.469 54.7701 412.559 54.7701 412.599 54.8201C412.719 54.9601 412.839 54.9201 412.559 55.0801C412.409 55.1701 412.449 55.6501 412.159 55.3601C412.029 55.2301 411.799 55.2901 411.629 55.2101C411.359 55.0801 411.229 54.7701 411.329 54.4801C411.359 54.3901 411.289 54.3801 411.249 54.3001C411.199 54.2201 411.229 54.1801 411.139 54.1201C411.089 54.1901 411.039 54.1901 411.039 54.2701C411.019 54.4301 411.009 54.6001 411.009 54.7601C410.849 54.6601 410.569 54.7301 410.429 54.6101C410.289 54.4801 410.279 54.3401 410.149 54.3401C409.999 54.3201 409.849 54.3701 409.729 54.4601C409.509 54.6401 409.269 54.7801 408.999 54.8801C408.779 54.9701 408.419 55.1601 408.199 54.9201C408.099 54.8001 407.949 54.7301 407.789 54.7301C407.729 54.7301 407.629 54.7901 407.629 54.8401C407.629 55.0201 407.559 55.2001 407.429 55.3401C407.329 55.4901 407.109 55.5201 406.979 55.6501C406.849 55.7801 406.909 56.0601 406.839 56.2301C406.789 56.3401 406.359 56.3301 406.149 56.3001C406.059 56.2901 405.909 56.0601 405.869 55.9001C405.829 55.7501 405.969 55.5701 405.939 55.4201C405.909 55.2701 405.749 55.1401 405.729 54.9901C405.699 54.7301 405.619 54.6401 405.359 54.7001C405.119 54.7501 404.909 54.9301 404.669 54.9801C404.429 55.0301 404.189 55.0601 403.949 55.1001C403.809 55.1201 403.759 55.0001 403.619 54.7901C403.469 54.5601 403.509 54.5601 403.619 54.4201C403.669 54.3301 403.699 54.2401 403.719 54.1501C403.619 54.1601 403.589 54.3601 403.509 54.4001C403.389 54.4601 403.229 54.3401 403.119 54.4201C403.189 54.2701 403.079 54.0601 403.179 53.9301C403.279 53.8001 403.579 53.8601 403.719 53.7701C403.849 53.6801 404.059 53.6901 404.189 53.6001C404.369 53.4701 404.379 53.0501 404.559 52.9901C404.759 52.9301 404.969 53.2301 405.159 53.3001C405.329 53.3601 405.639 53.2301 405.809 53.3901C406.019 53.5901 406.139 53.6501 406.359 53.5101C406.539 53.3601 406.769 53.3001 406.989 53.3401C407.159 53.4001 407.339 53.4501 407.519 53.4901C407.709 53.5301 407.889 53.6101 408.069 53.6501C408.129 53.6601 408.229 53.7901 408.239 53.8201C408.309 54.0401 408.389 53.8901 408.519 53.9001C408.659 53.9401 408.799 53.9601 408.939 53.9701C409.199 53.9301 409.449 53.8701 409.699 53.8001C409.799 53.7701 410.019 53.8001 410.039 53.7201C410.139 53.3601 410.249 53.2901 410.509 53.5301C410.639 53.6501 410.689 53.7701 410.769 53.4401C410.819 53.3101 410.919 53.2101 411.049 53.1501C411.179 53.1001 411.329 53.1001 411.449 53.1601C411.819 53.3301 411.899 53.4901 411.919 53.1101C411.919 52.9201 411.859 52.7801 411.949 52.6901C412.069 52.6001 412.209 52.5501 412.369 52.5401C412.599 52.5101 412.829 52.4801 413.059 52.4401C413.289 52.4001 413.529 52.4401 413.759 52.3901C413.999 52.3501 414.179 52.1401 414.169 51.8901C414.129 51.6801 414.169 51.4701 414.279 51.2901C414.399 51.1301 414.499 50.8701 414.699 50.7601C414.859 50.6701 415.019 50.5801 415.179 50.4901C415.339 50.4001 415.479 50.2901 415.629 50.1901C415.829 50.0601 416.099 49.9301 415.909 49.7301C415.709 49.5201 415.809 49.5401 415.949 49.3301C416.029 49.2101 415.919 48.9801 415.969 48.8501C416.079 48.5601 416.059 48.2801 416.169 48.2201C416.379 48.1401 416.619 48.1201 416.839 48.1701C417.119 48.2101 417.389 48.3401 417.669 48.3901C417.749 48.4101 418.039 48.5601 418.049 48.6201C418.059 48.6801 417.819 48.8601 417.769 48.9301C417.579 49.1701 417.269 49.4601 416.939 49.2301C416.879 49.1901 416.879 49.1401 416.779 49.1601C416.779 49.2601 416.809 49.3501 416.849 49.4401C416.969 49.6001 417.009 49.8101 416.959 50.0001C416.949 50.1501 416.859 50.1601 416.589 50.3101C416.429 50.4001 416.469 50.6601 416.429 50.8001C416.389 50.9501 416.479 51.0701 416.399 51.2001C416.519 51.2501 416.519 51.4901 416.639 51.5501L416.649 51.5201ZM413.459 53.1501C413.509 53.1701 413.779 53.2001 413.829 53.2201C413.829 53.1001 413.829 52.9801 413.809 52.8601C413.759 52.7601 413.689 52.6701 413.599 52.6001C413.539 52.6101 413.669 52.8701 413.609 52.9001C413.649 52.9601 413.419 53.0901 413.459 53.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M406.47 56.3999C406.36 56.3999 406.25 56.4 406.14 56.38C405.97 56.35 405.81 56.0499 405.77 55.8999C405.75 55.7999 405.769 55.6899 405.799 55.5899C405.819 55.5299 405.83 55.4699 405.83 55.4099C405.81 55.3499 405.78 55.29 405.74 55.25C405.68 55.17 405.63 55.08 405.62 54.98C405.61 54.87 405.58 54.81 405.56 54.79C405.51 54.77 405.45 54.77 405.39 54.79C405.28 54.82 405.18 54.86 405.08 54.92C404.96 54.99 404.83 55.04 404.69 55.07C404.49 55.11 404.28 55.14 404.08 55.17L403.97 55.19C403.77 55.22 403.69 55.08 403.58 54.92L403.53 54.8399C403.43 54.6899 403.399 54.6099 403.419 54.5199C403.379 54.5199 403.34 54.52 403.31 54.5C403.25 54.49 403.21 54.48 403.2 54.5C403.16 54.53 403.1 54.53 403.06 54.5C403.02 54.47 403.01 54.41 403.03 54.37C403.05 54.31 403.05 54.25 403.03 54.19C403.01 54.08 403.03 53.96 403.09 53.86C403.19 53.76 403.32 53.7099 403.46 53.7199C403.53 53.7199 403.6 53.7 403.66 53.68C403.74 53.63 403.83 53.5999 403.93 53.5799C404 53.5699 404.07 53.54 404.13 53.51C404.2 53.43 404.25 53.34 404.27 53.25C404.33 53.09 404.39 52.9299 404.53 52.8899C404.7 52.8399 404.86 52.96 405 53.07C405.06 53.12 405.13 53.17 405.2 53.2C405.27 53.21 405.33 53.21 405.4 53.2C405.57 53.17 405.75 53.2 405.89 53.31C406.09 53.5 406.15 53.52 406.31 53.42C406.51 53.25 406.78 53.18 407.04 53.24C407.21 53.3 407.379 53.35 407.549 53.38C407.649 53.4 407.75 53.4299 407.85 53.4599C407.93 53.4899 408.02 53.5099 408.1 53.5299C408.21 53.5799 408.3 53.6699 408.35 53.7799C408.35 53.7899 408.349 53.8 408.359 53.81H408.37C408.37 53.81 408.47 53.7799 408.52 53.7799C408.59 53.7799 408.65 53.8 408.71 53.82C408.77 53.84 408.84 53.85 408.91 53.85C409.16 53.81 409.41 53.76 409.66 53.68C409.71 53.67 409.76 53.6599 409.81 53.6599C409.85 53.6599 409.89 53.6599 409.93 53.6499C409.98 53.4799 410.05 53.3099 410.2 53.2699C410.35 53.2499 410.49 53.31 410.59 53.43C410.61 53.45 410.63 53.47 410.65 53.48C410.65 53.48 410.659 53.4299 410.669 53.3999C410.709 53.2499 410.81 53.13 410.95 53.07C411.13 52.99 411.33 52.98 411.51 53.06C411.6 53.1 411.67 53.14 411.73 53.17C411.76 53.18 411.78 53.1999 411.81 53.2099C411.81 53.1899 411.81 53.15 411.82 53.1C411.82 53.04 411.82 52.99 411.82 52.93C411.79 52.81 411.82 52.69 411.89 52.6C412.03 52.49 412.19 52.43 412.37 52.42L412.53 52.3999C412.71 52.3799 412.88 52.35 413.06 52.32C413.19 52.3 413.31 52.29 413.44 52.29C413.55 52.29 413.66 52.2899 413.76 52.2699C413.95 52.2399 414.08 52.0799 414.07 51.8899C414.03 51.6599 414.07 51.4199 414.2 51.2199C414.24 51.1699 414.269 51.12 414.299 51.06C414.379 50.9 414.5 50.7599 414.64 50.6599C414.73 50.6099 414.82 50.56 414.91 50.5C414.98 50.46 415.049 50.42 415.109 50.38C415.189 50.33 415.27 50.2799 415.35 50.2199C415.42 50.1699 415.49 50.1299 415.56 50.0799L415.609 50.05C415.699 50 415.85 49.9 415.85 49.85C415.85 49.84 415.84 49.82 415.82 49.8C415.64 49.62 415.63 49.53 415.76 49.37C415.79 49.34 415.82 49.3 415.84 49.26C415.85 49.2 415.86 49.1399 415.84 49.0799C415.82 48.9899 415.83 48.89 415.85 48.8C415.89 48.69 415.92 48.5799 415.93 48.4699C415.96 48.2999 415.99 48.17 416.09 48.11C416.33 48.02 416.58 47.99 416.83 48.04C416.99 48.07 417.14 48.1099 417.29 48.1599C417.41 48.1999 417.54 48.23 417.66 48.26C417.72 48.27 418.09 48.43 418.13 48.57C418.16 48.68 418.05 48.7699 417.91 48.8899C417.88 48.9199 417.85 48.9399 417.82 48.9699C417.51 49.3599 417.19 49.4799 416.9 49.3299C417.03 49.4999 417.08 49.71 417.04 49.92V49.9699C417.02 50.1499 416.91 50.21 416.75 50.29C416.71 50.31 416.659 50.34 416.609 50.37C416.549 50.4 416.54 50.51 416.53 50.62C416.53 50.68 416.52 50.74 416.5 50.8C416.49 50.85 416.49 50.89 416.5 50.94C416.51 51 416.51 51.07 416.5 51.13C416.54 51.18 416.57 51.23 416.59 51.29C416.6 51.32 416.61 51.35 416.63 51.37C416.72 51.32 416.819 51.28 416.919 51.23C417.039 51.18 417.15 51.12 417.25 51.07C417.35 51.02 417.44 50.95 417.53 50.88C417.63 50.8 417.74 50.73 417.85 50.67C417.9 50.65 417.95 50.65 417.99 50.68C418 50.7 418.02 50.73 418.04 50.75C418.04 50.76 418.049 50.7699 418.049 50.7799C418.059 50.7799 418.08 50.8 418.09 50.81C418.15 50.85 418.2 50.8899 418.21 50.9599C418.21 50.9999 418.19 51.04 418.16 51.06C418.09 51.12 418.02 51.18 417.96 51.25C417.89 51.33 417.819 51.3999 417.74 51.4699C417.62 51.5399 417.48 51.57 417.34 51.55C417.25 51.54 417.17 51.5499 417.09 51.5799C417.02 51.6399 416.95 51.6999 416.89 51.7699C416.82 51.8399 416.739 51.91 416.669 51.98C416.579 52.04 416.49 52.0999 416.39 52.1399C416.31 52.1699 416.23 52.2199 416.16 52.2699C416.09 52.3299 416.02 52.39 415.94 52.45C415.86 52.52 415.79 52.5799 415.71 52.6399C415.63 52.6999 415.529 52.78 415.419 52.74C415.349 52.71 415.3 52.64 415.29 52.56C415.28 52.5 415.29 52.44 415.29 52.37C415.29 52.34 415.3 52.2999 415.29 52.2699C415.27 52.2299 415.22 52.1499 415.16 52.1499C415.12 52.1499 415.03 52.19 414.95 52.29C414.9 52.35 414.87 52.41 414.84 52.48C414.82 52.53 414.79 52.5899 414.76 52.6399C414.74 52.6799 414.71 52.72 414.69 52.76C414.62 52.91 414.52 53.0499 414.4 53.1599C414.24 53.2499 414.05 53.28 413.87 53.26C413.87 53.27 413.85 53.28 413.84 53.29C413.81 53.31 413.769 53.31 413.74 53.29C413.689 53.28 413.65 53.2699 413.6 53.2699C413.5 53.2999 413.42 53.4 413.43 53.51C413.43 53.58 413.43 53.6499 413.43 53.7199C413.46 53.8899 413.42 54.06 413.31 54.19C413.18 54.28 413.009 54.3099 412.859 54.2699C412.779 54.2699 412.7 54.2599 412.62 54.2699C412.49 54.2799 412.39 54.32 412.37 54.37C412.35 54.42 412.39 54.51 412.47 54.62L412.51 54.6399C412.51 54.6399 412.6 54.6799 412.64 54.7199C412.66 54.7399 412.68 54.7599 412.71 54.7799C412.76 54.8099 412.799 54.87 412.799 54.93C412.799 55.02 412.72 55.0699 412.58 55.1499C412.55 55.1899 412.53 55.2299 412.52 55.2799C412.48 55.3899 412.44 55.4999 412.32 55.5299C412.22 55.5299 412.109 55.4899 412.049 55.4099C411.979 55.3699 411.9 55.3399 411.82 55.3399C411.73 55.3399 411.639 55.3099 411.549 55.2799C411.229 55.1199 411.08 54.76 411.19 54.42H411.18C411.18 54.42 411.14 54.3599 411.12 54.3399V54.32C411.12 54.32 411.1 54.4 411.09 54.43C411.08 54.53 411.07 54.63 411.08 54.73C411.08 54.77 411.06 54.8099 411.03 54.8299C410.99 54.8499 410.95 54.8499 410.91 54.8299C410.84 54.7999 410.76 54.7799 410.68 54.7799C410.55 54.7799 410.42 54.7399 410.31 54.6599C410.26 54.6099 410.209 54.55 410.169 54.49C410.129 54.42 410.119 54.42 410.109 54.42C409.989 54.4 409.86 54.44 409.76 54.51C409.53 54.69 409.28 54.84 409 54.94L408.919 54.9699C408.689 55.0699 408.32 55.23 408.07 54.94C407.99 54.84 407.87 54.79 407.74 54.79C407.73 54.79 407.71 54.79 407.7 54.81C407.7 54.99 407.63 55.16 407.51 55.3L407.48 55.35C407.41 55.44 407.31 55.52 407.2 55.56C407.13 55.59 407.07 55.63 407.02 55.67C406.97 55.75 406.95 55.84 406.96 55.93C406.96 56.02 406.94 56.1199 406.91 56.2099C406.86 56.3399 406.63 56.37 406.43 56.37L406.47 56.3999ZM405.5 54.54C405.57 54.54 405.64 54.56 405.69 54.6C405.79 54.69 405.85 54.82 405.85 54.95C405.87 55.01 405.9 55.07 405.94 55.12C406 55.19 406.04 55.28 406.06 55.37C406.07 55.47 406.06 55.5699 406.02 55.6599C406 55.7199 405.99 55.78 405.99 55.85C406.02 55.97 406.09 56.08 406.18 56.17C406.37 56.21 406.56 56.1999 406.75 56.1499C406.76 56.0899 406.77 56.0199 406.77 55.9599C406.77 55.8099 406.81 55.67 406.9 55.55C406.97 55.49 407.05 55.4299 407.14 55.3999C407.22 55.3699 407.28 55.32 407.34 55.26L407.37 55.2099C407.46 55.1099 407.51 54.9699 407.51 54.8399C407.51 54.7899 407.53 54.74 407.57 54.7C407.63 54.64 407.71 54.61 407.79 54.61C407.98 54.61 408.16 54.6999 408.28 54.8399C408.41 54.9899 408.62 54.91 408.87 54.81L408.95 54.7799C409.2 54.6799 409.44 54.55 409.65 54.38C409.78 54.28 409.95 54.23 410.12 54.24C410.24 54.24 410.34 54.3099 410.39 54.4099C410.42 54.4599 410.45 54.5 410.49 54.54C410.56 54.58 410.65 54.6 410.73 54.6C410.78 54.6 410.84 54.6 410.89 54.62C410.89 54.56 410.89 54.5 410.91 54.45C410.91 54.4 410.92 54.34 410.93 54.29C410.93 54.23 410.97 54.17 411.02 54.13C411.03 54.13 411.049 54.1099 411.049 54.0899C411.069 54.0599 411.09 54.05 411.12 54.04C411.15 54.04 411.18 54.04 411.21 54.05C411.27 54.08 411.32 54.1399 411.34 54.2099C411.34 54.2299 411.349 54.24 411.359 54.26C411.369 54.27 411.38 54.29 411.39 54.3C411.46 54.36 411.48 54.45 411.45 54.54C411.38 54.77 411.48 55.02 411.7 55.13C411.76 55.15 411.83 55.17 411.89 55.17C412.02 55.17 412.15 55.22 412.25 55.3C412.27 55.32 412.3 55.34 412.33 55.36C412.32 55.36 412.339 55.29 412.359 55.25C412.379 55.15 412.44 55.06 412.52 55L412.58 54.9599C412.58 54.9599 412.54 54.9199 412.53 54.8999L412.49 54.88C412.439 54.86 412.389 54.83 412.359 54.79C412.229 54.67 412.18 54.49 412.23 54.32C412.29 54.19 412.43 54.1099 412.66 54.0899C412.75 54.0899 412.84 54.0899 412.94 54.0899C413.05 54.0899 413.18 54.11 413.22 54.07C413.27 54.02 413.27 53.8899 413.26 53.7699C413.26 53.6899 413.26 53.6099 413.26 53.5299C413.26 53.4199 413.31 53.32 413.38 53.24C413.31 53.13 413.41 53.0399 413.47 52.9699C413.48 52.9599 413.5 52.94 413.51 52.93V52.9099C413.51 52.8999 413.51 52.89 413.52 52.88C413.52 52.86 413.51 52.82 413.5 52.8C413.47 52.73 413.47 52.6499 413.5 52.5799C413.51 52.5599 413.529 52.5399 413.549 52.5299H413.46C413.35 52.5299 413.23 52.53 413.12 52.55C412.94 52.58 412.76 52.61 412.58 52.63L412.419 52.6499C412.289 52.6499 412.17 52.69 412.07 52.76C412.05 52.78 412.05 52.8299 412.07 52.9099C412.07 52.9799 412.08 53.04 412.07 53.11C412.07 53.26 412.05 53.38 411.95 53.43C411.86 53.48 411.77 53.43 411.64 53.36C411.59 53.33 411.52 53.29 411.43 53.25C411.31 53.2 411.17 53.21 411.06 53.26C410.98 53.29 410.92 53.36 410.9 53.44C410.86 53.6 410.82 53.71 410.72 53.73C410.63 53.76 410.56 53.69 410.5 53.63C410.48 53.62 410.47 53.5999 410.45 53.5799C410.32 53.4599 410.28 53.4699 410.28 53.4699C410.28 53.4699 410.23 53.4899 410.16 53.7199C410.12 53.8499 409.96 53.86 409.84 53.87C409.81 53.87 409.77 53.87 409.74 53.87C409.49 53.94 409.23 54 408.97 54.04C408.87 54.04 408.77 54.04 408.68 54C408.63 53.99 408.58 53.9699 408.53 53.9699C408.51 53.9699 408.49 53.97 408.47 53.99C408.41 54.02 408.34 54.02 408.28 53.99C408.22 53.95 408.17 53.88 408.15 53.81C408.12 53.77 408.09 53.7399 408.06 53.7099C407.97 53.6899 407.879 53.66 407.799 53.63C407.709 53.6 407.62 53.57 407.52 53.55C407.34 53.51 407.16 53.4599 406.98 53.3999C406.79 53.3699 406.59 53.43 406.44 53.56C406.14 53.75 405.95 53.61 405.75 53.42C405.65 53.36 405.54 53.35 405.43 53.37C405.34 53.38 405.24 53.37 405.15 53.35C405.05 53.31 404.96 53.25 404.88 53.18C404.78 53.11 404.679 53.02 404.609 53.04C404.569 53.05 404.52 53.18 404.49 53.26C404.45 53.4 404.38 53.53 404.27 53.63C404.18 53.69 404.09 53.72 403.99 53.74C403.92 53.75 403.859 53.77 403.799 53.81C403.709 53.86 403.6 53.8899 403.5 53.8899C403.42 53.8899 403.31 53.91 403.29 53.94C403.27 54 403.26 54.06 403.27 54.12C403.27 54.15 403.27 54.1899 403.27 54.2199C403.3 54.2199 403.329 54.22 403.359 54.23C403.399 54.24 403.44 54.24 403.48 54.23C403.5 54.21 403.51 54.1799 403.52 54.1599C403.56 54.0799 403.62 53.9799 403.73 53.9699C403.77 53.9699 403.81 53.98 403.83 54.01C403.85 54.04 403.86 54.08 403.85 54.11L403.83 54.17C403.81 54.26 403.77 54.35 403.72 54.42L403.69 54.4599C403.69 54.4599 403.66 54.49 403.65 54.51C403.67 54.56 403.7 54.6099 403.73 54.6499L403.79 54.74C403.89 54.9 403.91 54.9099 403.95 54.9099L404.06 54.8899C404.26 54.8599 404.469 54.82 404.669 54.79C404.779 54.76 404.89 54.7199 404.99 54.6599C405.1 54.5999 405.23 54.55 405.35 54.51C405.4 54.5 405.45 54.49 405.5 54.49V54.54ZM413.94 53.06C414.07 53.08 414.2 53.06 414.32 53.01C414.42 52.91 414.489 52.8 414.549 52.68C414.569 52.64 414.6 52.59 414.62 52.55C414.64 52.51 414.67 52.46 414.68 52.42C414.71 52.33 414.76 52.25 414.82 52.17C414.91 52.04 415.06 51.9599 415.22 51.9599C415.35 51.9799 415.47 52.07 415.52 52.2C415.56 52.28 415.56 52.37 415.54 52.45C415.54 52.48 415.54 52.52 415.54 52.55C415.56 52.53 415.589 52.52 415.609 52.5C415.689 52.44 415.76 52.38 415.83 52.31C415.9 52.25 415.979 52.18 416.049 52.12C416.139 52.06 416.23 51.9999 416.33 51.9699C416.41 51.9399 416.49 51.8899 416.57 51.8399C416.64 51.7799 416.71 51.7199 416.77 51.6499C416.81 51.6099 416.85 51.5699 416.89 51.5299C416.83 51.5599 416.76 51.59 416.7 51.62C416.67 51.64 416.64 51.64 416.6 51.62C416.51 51.57 416.439 51.48 416.419 51.38C416.409 51.34 416.379 51.2799 416.359 51.2699C416.329 51.2599 416.309 51.23 416.299 51.2C416.299 51.17 416.3 51.13 416.31 51.11C416.33 51.07 416.34 51.0199 416.32 50.9699C416.31 50.8899 416.32 50.82 416.32 50.74C416.33 50.7 416.34 50.65 416.34 50.6C416.34 50.44 416.4 50.28 416.54 50.18C416.6 50.15 416.64 50.12 416.69 50.1C416.86 50.01 416.859 49.9999 416.859 49.9599V49.8999C416.899 49.7499 416.86 49.6 416.77 49.48C416.72 49.4 416.69 49.3099 416.68 49.2199V49.1599C416.68 49.1599 416.68 49.0999 416.69 49.0799C416.71 49.0599 416.73 49.04 416.76 49.04C416.84 49.02 416.92 49.04 416.98 49.11L417 49.13C417.2 49.27 417.43 49.17 417.68 48.85C417.72 48.81 417.749 48.77 417.799 48.74C417.829 48.71 417.889 48.66 417.919 48.62C417.829 48.57 417.74 48.52 417.64 48.49C417.51 48.46 417.38 48.43 417.25 48.38C417.11 48.33 416.96 48.2899 416.82 48.2699C416.62 48.2299 416.41 48.25 416.22 48.31C416.2 48.38 416.179 48.44 416.169 48.51C416.149 48.63 416.12 48.76 416.08 48.88C416.08 48.94 416.08 49 416.08 49.05C416.11 49.16 416.09 49.28 416.04 49.38C416.01 49.42 415.98 49.47 415.95 49.51C415.94 49.53 415.92 49.54 415.91 49.56C415.91 49.56 415.929 49.5899 415.99 49.6399C416.059 49.6999 416.09 49.79 416.09 49.88C416.07 50.04 415.899 50.14 415.74 50.24L415.69 50.2699C415.62 50.3099 415.559 50.3599 415.49 50.3999C415.41 50.4599 415.32 50.52 415.23 50.57C415.16 50.61 415.09 50.65 415.02 50.69C414.93 50.74 414.84 50.7899 414.75 50.8399C414.64 50.9299 414.55 51.04 414.48 51.17C414.44 51.23 414.399 51.3 414.359 51.35C414.269 51.51 414.24 51.69 414.28 51.87C414.3 52.17 414.08 52.44 413.78 52.49C413.72 52.49 413.669 52.5 413.609 52.51C413.619 52.51 413.63 52.5099 413.64 52.5299C413.74 52.6199 413.83 52.73 413.88 52.85C413.88 52.89 413.9 52.98 413.9 53.07L413.94 53.06ZM417.91 50.93C417.84 50.98 417.77 51.0199 417.7 51.0799C417.6 51.1599 417.5 51.23 417.38 51.29C417.34 51.31 417.29 51.33 417.25 51.35C417.29 51.35 417.34 51.35 417.38 51.35C417.47 51.35 417.55 51.35 417.63 51.32C417.7 51.26 417.77 51.2 417.83 51.13C417.87 51.08 417.91 51.04 417.96 50.99C417.94 50.97 417.92 50.95 417.9 50.93H417.91Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.41 44.7401C418.44 44.7901 418.599 44.8301 418.609 44.8801C418.649 45.2401 418.709 45.0701 418.939 44.9301C418.959 44.9201 419.14 45.1801 419.15 45.1701C419.26 45.1101 419.269 44.9201 419.379 44.8501C419.389 45.0601 419.61 45.3401 419.53 45.5101C419.44 45.7201 418.99 45.7301 418.84 45.9201C418.77 46.0401 418.73 46.1701 418.73 46.3101C418.72 46.5001 418.799 46.6901 418.949 46.8101C419.039 46.8701 419.18 46.7501 419.46 46.7001C419.61 46.6901 419.75 46.7001 419.9 46.7101C420.03 46.7201 420.14 46.7901 420.22 46.8901C420.31 47.1001 420.129 47.1201 419.949 47.1501C419.789 47.1801 419.589 47.0701 419.439 47.1001C419.159 47.1301 418.949 47.3701 418.939 47.6501C418.939 47.6901 418.83 47.9701 418.73 47.9601C418.56 47.9201 418.379 47.8801 418.199 47.8701C418.019 47.8901 417.809 47.7601 417.639 47.8001C417.469 47.8701 417.3 47.9601 417.15 48.0601C417.03 48.0801 416.91 48.0601 416.79 48.0401C416.82 47.9601 416.889 47.6801 416.949 47.6501C417.129 47.5401 417.319 47.4301 417.499 47.3301C417.689 47.2301 417.92 47.2101 418.1 47.1101C418.24 47.0301 418.389 47.0001 418.259 46.7801C418.179 46.6501 418.149 46.4901 418.179 46.3401C418.299 45.9501 418.389 46.0601 417.999 45.9601C417.779 45.9001 417.609 45.6701 417.389 45.6001C417.159 45.5601 416.94 45.5101 416.72 45.4401C416.43 45.3101 416.469 45.2401 416.769 45.1101C416.959 45.0301 417.199 45.1301 417.389 45.0701C417.579 45.0001 417.719 44.8601 417.919 44.8301C418.109 44.8301 418.3 44.8501 418.47 44.9101C418.52 44.9101 418.41 44.7201 418.41 44.7301V44.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.049 48.2001C416.949 48.2001 416.849 48.19 416.749 48.16C416.719 48.16 416.699 48.13 416.679 48.1C416.669 48.07 416.669 48.0401 416.679 48.0101C416.679 47.9901 416.699 47.96 416.709 47.92C416.779 47.7 416.819 47.6 416.889 47.56C416.949 47.52 417.019 47.48 417.079 47.44C417.199 47.37 417.319 47.29 417.439 47.23C417.539 47.18 417.649 47.14 417.759 47.11C417.859 47.09 417.949 47.0501 418.039 47.0101L418.099 46.98C418.099 46.98 418.169 46.95 418.189 46.92C418.189 46.92 418.169 46.86 418.149 46.83C418.059 46.67 418.019 46.48 418.049 46.3C418.079 46.21 418.099 46.15 418.119 46.1C418.119 46.1 418.019 46.08 417.949 46.06C417.819 46.02 417.699 45.95 417.589 45.86C417.509 45.79 417.419 45.7401 417.329 45.7001C417.239 45.6701 417.149 45.65 417.059 45.64C416.919 45.62 416.779 45.59 416.649 45.53C416.519 45.47 416.389 45.4 416.389 45.27C416.389 45.14 416.529 45.07 416.699 45C416.819 44.96 416.949 44.95 417.079 44.97C417.159 44.98 417.249 44.97 417.339 44.96C417.409 44.93 417.479 44.9 417.539 44.86C417.649 44.79 417.769 44.74 417.889 44.72C418.029 44.71 418.159 44.7201 418.289 44.7601C418.289 44.7001 418.309 44.65 418.349 44.63C418.389 44.61 418.449 44.62 418.479 44.65C418.479 44.65 418.519 44.68 418.539 44.69C418.609 44.72 418.689 44.76 418.709 44.85C418.709 44.88 418.709 44.9 418.719 44.92C418.769 44.88 418.809 44.85 418.859 44.81C418.949 44.75 419.009 44.8201 419.119 44.9501V44.97L419.149 44.93C419.179 44.85 419.239 44.77 419.309 44.72C419.339 44.7 419.379 44.7 419.419 44.72C419.449 44.74 419.479 44.77 419.479 44.81C419.489 44.9 419.519 44.98 419.559 45.06C419.639 45.2 419.669 45.37 419.629 45.52C419.529 45.67 419.379 45.77 419.209 45.8C419.099 45.83 418.999 45.8801 418.919 45.9501C418.869 46.0501 418.829 46.15 418.829 46.27C418.819 46.43 418.879 46.58 418.999 46.68C419.039 46.68 419.079 46.66 419.129 46.64C419.229 46.6 419.329 46.57 419.429 46.55C419.559 46.53 419.679 46.54 419.809 46.55H419.899C420.069 46.57 420.219 46.66 420.309 46.81C420.349 46.89 420.349 46.98 420.309 47.06C420.249 47.17 420.109 47.2 419.979 47.22H419.949C419.849 47.24 419.749 47.2201 419.659 47.2001C419.589 47.1801 419.519 47.17 419.439 47.18C419.339 47.2 419.009 47.31 419.029 47.62C419.009 47.76 418.949 47.88 418.859 47.98C418.819 48.02 418.759 48.05 418.699 48.05C418.609 48.05 418.529 48.02 418.449 48C418.369 47.97 418.279 47.96 418.189 47.96C418.089 47.96 417.989 47.95 417.899 47.92C417.819 47.89 417.729 47.88 417.649 47.89C417.549 47.92 417.469 47.97 417.379 48.03C417.309 48.07 417.239 48.11 417.169 48.15C417.119 48.17 417.069 48.18 417.029 48.17L417.049 48.2001ZM416.929 47.97C416.989 47.97 417.049 47.98 417.099 47.97C417.159 47.94 417.219 47.9 417.279 47.87C417.379 47.8 417.489 47.74 417.609 47.71C417.729 47.69 417.859 47.7 417.979 47.74C418.049 47.76 418.119 47.78 418.199 47.77C418.309 47.77 418.429 47.78 418.529 47.82C418.599 47.84 418.669 47.86 418.739 47.86C418.779 47.79 418.809 47.72 418.829 47.65C418.829 47.32 419.079 47.04 419.409 46.99C419.519 46.97 419.619 46.9801 419.729 47.0101C419.799 47.0301 419.869 47.04 419.939 47.03H419.969C420.029 47.03 420.089 47 420.139 46.98C420.139 46.96 420.139 46.95 420.119 46.93C420.059 46.87 419.979 46.83 419.889 46.82H419.789C419.689 46.79 419.579 46.79 419.469 46.8C419.379 46.82 419.289 46.84 419.209 46.88C419.089 46.92 418.979 46.96 418.879 46.89C418.699 46.75 418.589 46.53 418.609 46.3C418.569 45.97 418.809 45.67 419.129 45.62C419.249 45.57 419.389 45.52 419.419 45.46C419.449 45.4 419.389 45.27 419.349 45.17C419.349 45.15 419.329 45.13 419.329 45.11C419.299 45.17 419.259 45.2201 419.199 45.2601C419.109 45.3101 419.049 45.24 418.949 45.11L418.919 45.07C418.919 45.07 418.879 45.1 418.869 45.11C418.799 45.17 418.719 45.23 418.629 45.19C418.559 45.15 418.519 45.0901 418.509 45.0101C418.489 45.0201 418.459 45.02 418.439 45.02C418.389 45.01 418.329 45 418.289 44.99C418.169 44.95 418.049 44.9401 417.919 44.9501C417.819 44.9701 417.729 45.01 417.649 45.06C417.569 45.11 417.489 45.15 417.409 45.18C417.299 45.21 417.179 45.2201 417.069 45.2001C416.979 45.1901 416.889 45.2 416.799 45.22C416.749 45.24 416.699 45.26 416.659 45.29C416.689 45.31 416.719 45.33 416.759 45.34C416.869 45.39 416.989 45.42 417.109 45.43C417.209 45.44 417.319 45.47 417.419 45.5C417.539 45.55 417.649 45.61 417.749 45.69C417.829 45.76 417.929 45.82 418.029 45.85C418.099 45.87 418.149 45.88 418.189 45.89C418.279 45.91 418.349 45.92 418.379 45.99C418.399 46.05 418.399 46.12 418.359 46.18C418.329 46.24 418.309 46.31 418.289 46.37C418.279 46.49 418.299 46.61 418.359 46.72C418.419 46.8 418.439 46.89 418.419 46.98C418.379 47.07 418.309 47.14 418.209 47.17L418.159 47.2001C418.049 47.2501 417.939 47.29 417.829 47.32C417.739 47.34 417.639 47.38 417.559 47.42C417.439 47.48 417.319 47.55 417.209 47.62C417.139 47.66 417.079 47.7 417.009 47.74C416.999 47.76 416.959 47.8801 416.939 47.9501L416.929 47.97Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.489 44.74C418.489 44.64 418.31 44.57 418.29 44.48C418.24 44.23 418.42 44.05 418.35 43.99C418.22 43.84 418.02 43.76 417.83 43.8C417.52 43.87 417.29 44.06 417.1 43.81C416.91 43.58 416.919 43.25 417.109 43.02C417.189 42.9 417.239 42.69 417.369 42.62C417.519 42.54 417.689 42.5 417.869 42.5C418.099 42.52 418.32 42.6 418.51 42.73C418.7 42.9 418.84 43.13 418.91 43.38C418.91 43.54 418.96 43.69 419.02 43.83C419.07 43.99 419.15 44.13 419.26 44.25C419.37 44.34 419.409 44.49 419.359 44.63C419.309 44.76 419.19 44.86 419.04 44.86C418.87 44.89 418.69 44.91 418.52 44.92C418.5 44.92 418.49 44.76 418.5 44.75L418.489 44.74Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.519 45.0299C418.519 45.0299 418.459 45.02 418.439 45C418.399 44.93 418.379 44.84 418.379 44.76C418.359 44.74 418.339 44.72 418.319 44.7C418.249 44.65 418.209 44.59 418.179 44.51C418.159 44.37 418.179 44.24 418.229 44.11C418.229 44.09 418.239 44.07 418.249 44.05C418.149 43.93 417.999 43.88 417.849 43.91C417.779 43.93 417.709 43.95 417.649 43.97C417.439 44.05 417.209 44.13 417.009 43.88C416.789 43.61 416.789 43.2299 417.009 42.9599C417.029 42.9199 417.049 42.8799 417.069 42.8399C417.109 42.7099 417.199 42.5999 417.309 42.5199C417.479 42.4299 417.679 42.3799 417.869 42.3899C418.129 42.4099 418.369 42.4999 418.579 42.6499C418.789 42.8399 418.939 43.09 419.009 43.36C419.009 43.5 419.049 43.6399 419.109 43.7699C419.129 43.8199 419.149 43.8599 419.169 43.8999C419.199 43.9999 419.259 44.09 419.329 44.16C419.459 44.28 419.509 44.46 419.469 44.63C419.409 44.81 419.249 44.93 419.059 44.95C418.879 44.98 418.699 45 418.519 45.01V45.0299ZM418.609 44.75C418.609 44.75 418.609 44.78 418.609 44.8C418.749 44.8 418.889 44.77 419.019 44.75C419.119 44.75 419.209 44.6799 419.249 44.5799C419.269 44.4899 419.249 44.3899 419.169 44.3399C419.079 44.2399 419.009 44.13 418.959 44.01C418.939 43.97 418.929 43.9299 418.909 43.8899C418.829 43.7399 418.789 43.5699 418.779 43.3999C418.719 43.1799 418.589 42.97 418.419 42.82C418.249 42.7 418.049 42.63 417.839 42.62C417.689 42.62 417.539 42.65 417.409 42.72C417.339 42.78 417.289 42.85 417.269 42.94C417.249 42.99 417.219 43.0399 417.189 43.0899C417.019 43.2699 417.009 43.56 417.169 43.75C417.259 43.86 417.339 43.8499 417.559 43.7699C417.629 43.7399 417.709 43.72 417.789 43.7C418.009 43.65 418.249 43.7299 418.399 43.8999C418.479 43.9799 418.489 44.1 418.439 44.19C418.399 44.28 418.389 44.38 418.399 44.47C418.419 44.49 418.439 44.5099 418.459 44.5299C418.529 44.5799 418.579 44.66 418.599 44.74C418.599 44.74 418.599 44.75 418.599 44.76L418.609 44.75Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M409.149 55.27C409.149 55.27 409.199 55.3701 409.219 55.3801C409.419 55.3801 409.799 55.0601 409.949 55.3201C410.099 55.5801 409.639 55.68 409.479 55.83C409.359 55.94 409.429 56.31 409.629 56.35C410.039 56.43 410.019 56.23 409.799 56.59C409.599 56.92 409.339 57.0401 409.109 56.8201C408.959 56.6901 408.979 56.3701 408.829 56.2301C408.689 56.1001 408.229 56.17 408.309 55.83C408.389 55.52 408.649 55.5401 408.939 55.5101C409.019 55.5101 409.069 55.2801 409.149 55.2601V55.27Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M409.349 57.0401C409.229 57.0401 409.109 56.9901 409.019 56.9001C408.929 56.8001 408.869 56.6801 408.849 56.5601C408.829 56.4701 408.799 56.3901 408.739 56.3201C408.689 56.2901 408.629 56.2702 408.569 56.2602C408.429 56.2502 408.299 56.1801 408.219 56.0701C408.179 55.9901 408.169 55.9001 408.189 55.8101C408.279 55.4601 408.569 55.4301 408.829 55.4101H408.909C408.909 55.4101 408.939 55.3601 408.949 55.3401C408.989 55.2701 409.039 55.1801 409.129 55.1601C409.209 55.1401 409.259 55.2102 409.279 55.2602C409.329 55.2402 409.389 55.2202 409.439 55.2002C409.619 55.1202 409.899 55.0102 410.049 55.2602C410.089 55.3302 410.109 55.4101 410.089 55.4901C410.049 55.6401 409.889 55.7201 409.739 55.8001C409.679 55.8301 409.619 55.8701 409.559 55.9101C409.529 55.9701 409.529 56.0401 409.559 56.1001C409.579 56.1701 409.619 56.2301 409.659 56.2301C409.739 56.2501 409.829 56.2501 409.919 56.2501C409.979 56.2401 410.029 56.2601 410.059 56.3101C410.089 56.3701 410.069 56.4301 410.029 56.4701C409.989 56.5301 409.949 56.5801 409.909 56.6501C409.819 56.8401 409.639 56.9901 409.429 57.0401C409.409 57.0401 409.389 57.0401 409.369 57.0401H409.349ZM409.129 55.4502C409.089 55.5302 409.029 55.6101 408.939 55.6201H408.839C408.569 55.6501 408.449 55.6701 408.409 55.8501C408.399 55.8801 408.399 55.9101 408.409 55.9401C408.439 55.9801 408.539 56.0101 408.619 56.0301C408.719 56.0401 408.809 56.0801 408.879 56.1401C408.969 56.2401 409.029 56.3601 409.059 56.4901C409.079 56.5801 409.109 56.6601 409.169 56.7301C409.219 56.7901 409.299 56.8101 409.369 56.8101C409.509 56.7601 409.629 56.6601 409.689 56.5301C409.699 56.5101 409.709 56.4901 409.729 56.4701C409.689 56.4701 409.649 56.4702 409.599 56.4502C409.459 56.4102 409.359 56.3001 409.329 56.1601C409.279 56.0201 409.299 55.8601 409.399 55.7401C409.469 55.6801 409.549 55.6301 409.629 55.5901C409.719 55.5401 409.849 55.4701 409.869 55.4201C409.869 55.4201 409.869 55.4001 409.859 55.3701C409.819 55.3001 409.749 55.3101 409.529 55.4001C409.439 55.4501 409.339 55.4701 409.239 55.4801H409.229C409.229 55.4801 409.169 55.4702 409.149 55.4502H409.129Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.329 38.27C417.269 38.32 417.259 38.5301 417.179 38.5601C416.959 38.6501 416.789 38.97 416.469 38.79", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M416.669 38.96C416.579 38.96 416.499 38.93 416.429 38.89L416.539 38.7001C416.689 38.7901 416.779 38.73 416.929 38.61C416.999 38.55 417.069 38.51 417.139 38.47C417.139 38.47 417.139 38.42 417.159 38.39C417.169 38.32 417.209 38.2501 417.259 38.1901L417.399 38.3701L417.329 38.28L417.409 38.36C417.409 38.36 417.379 38.4201 417.379 38.4501C417.349 38.5401 417.319 38.64 417.239 38.67C417.179 38.7 417.129 38.74 417.079 38.78C416.969 38.88 416.829 38.95 416.679 38.96H416.669Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.169 49.53C419.969 49.46 419.6 49.45 419.45 49.33C419.31 49.22 419.34 48.82 419.25 48.65C419.49 48.64 419.73 48.6501 419.97 48.6701C420.07 48.6701 420.1 48.84 420.2 48.91C420.32 49 420.7 49.0301 420.81 49.1201C420.67 49.2101 420.35 49.4101 420.16 49.5401L420.169 49.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M420.169 49.6401C420.169 49.6401 420.139 49.6401 420.129 49.6401C420.049 49.6201 419.959 49.6001 419.879 49.5801C419.699 49.5601 419.529 49.5101 419.379 49.4101C419.269 49.2801 419.209 49.1201 419.209 48.9601C419.209 48.8701 419.179 48.7801 419.149 48.7001C419.129 48.6701 419.129 48.6301 419.149 48.5901C419.169 48.5601 419.199 48.5401 419.239 48.5301C419.439 48.5201 419.649 48.5301 419.849 48.5301H419.979C420.079 48.5601 420.159 48.6201 420.199 48.7101C420.219 48.7401 420.239 48.7701 420.269 48.8001C420.359 48.8401 420.449 48.8701 420.539 48.8801C420.659 48.9001 420.779 48.9401 420.889 49.0001C420.919 49.0201 420.939 49.0601 420.939 49.0901C420.939 49.1301 420.919 49.1601 420.889 49.1801C420.829 49.2201 420.729 49.2901 420.619 49.3601C420.489 49.4401 420.349 49.5301 420.239 49.6001C420.219 49.6101 420.199 49.6201 420.179 49.6201L420.169 49.6401ZM419.399 48.7501C419.409 48.8101 419.419 48.8701 419.429 48.9301C419.429 49.0401 419.459 49.1501 419.519 49.2401C419.639 49.3101 419.779 49.3501 419.919 49.3601C419.999 49.3801 420.079 49.3901 420.149 49.4101C420.249 49.3401 420.369 49.2701 420.489 49.1901L420.569 49.1401C420.569 49.1401 420.509 49.1301 420.489 49.1201C420.369 49.1001 420.249 49.0601 420.139 49.0001C420.089 48.9601 420.049 48.9101 420.019 48.8501C420.009 48.8201 419.989 48.8001 419.969 48.7801H419.849C419.709 48.7601 419.559 48.7501 419.419 48.7601L419.399 48.7501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M418.1 49.52C418.25 49.5 418.4 49.5 418.55 49.51C418.67 49.51 418.76 49.69 418.87 49.72C418.8 49.81 418.77 49.95 418.68 49.97C418.5 50.01 418.29 49.94 418.11 49.97C417.93 50 417.77 50.27 417.58 50.29C417.5 50.29 417.61 50.01 417.53 49.94C417.61 49.89 417.43 49.75 417.52 49.72C417.71 49.67 417.91 49.56 418.1 49.52Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.589 50.3901C417.589 50.3901 417.519 50.3801 417.489 50.3501C417.439 50.3001 417.439 50.2201 417.449 50.1301C417.449 50.0901 417.449 50.0401 417.449 50.0001C417.419 49.9801 417.409 49.9501 417.409 49.9101C417.409 49.8901 417.409 49.8801 417.429 49.8701C417.389 49.8101 417.379 49.7401 417.399 49.6801C417.419 49.6401 417.459 49.6201 417.499 49.6001C417.579 49.5801 417.659 49.5501 417.739 49.5101C417.849 49.4601 417.969 49.4201 418.089 49.4001C418.219 49.3801 418.339 49.3801 418.469 49.3801H418.559C418.659 49.3901 418.749 49.4401 418.809 49.5201C418.839 49.5501 418.869 49.5801 418.909 49.6001C418.949 49.6001 418.979 49.6401 418.989 49.6701C418.999 49.7101 418.989 49.7501 418.969 49.7801C418.949 49.8101 418.929 49.8401 418.919 49.8701C418.889 49.9601 418.819 50.0301 418.729 50.0701C418.619 50.0901 418.499 50.0901 418.389 50.0701C418.309 50.0601 418.229 50.0601 418.149 50.0701C418.069 50.1001 417.999 50.1401 417.949 50.2001C417.859 50.2901 417.739 50.3601 417.619 50.3901H417.589ZM417.669 49.9301C417.689 49.9901 417.689 50.0601 417.679 50.1201C417.719 50.1001 417.749 50.0601 417.789 50.0301C417.879 49.9401 417.979 49.8801 418.099 49.8501C418.199 49.8401 418.299 49.8401 418.399 49.8501C418.489 49.8601 418.579 49.8601 418.659 49.8501C418.679 49.8301 418.689 49.8001 418.699 49.7701V49.7501C418.699 49.7501 418.659 49.7101 418.639 49.6801C418.609 49.6501 418.559 49.6101 418.539 49.6101H418.449C418.339 49.6101 418.219 49.6101 418.109 49.6201C418.009 49.6401 417.899 49.6801 417.799 49.7201C417.739 49.7401 417.679 49.7701 417.619 49.7901C417.639 49.8301 417.649 49.8801 417.639 49.9201L417.669 49.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.71 48.48C396.49 48.43 396.2 48.32 396.06 48.28C396.18 48.04 396.44 47.79 396.57 47.54C396.73 47.7 397.07 47.7501 397.19 47.9401C397.05 48.1301 396.89 48.31 396.71 48.47V48.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.709 48.6C396.709 48.6 396.689 48.6 396.679 48.6C396.559 48.57 396.409 48.52 396.279 48.48C396.179 48.45 396.089 48.42 396.029 48.4C395.999 48.4 395.969 48.37 395.949 48.34C395.939 48.31 395.939 48.2701 395.949 48.2401C396.029 48.1001 396.109 47.97 396.209 47.85C396.299 47.74 396.379 47.6201 396.449 47.5001C396.469 47.4701 396.499 47.4501 396.529 47.4401C396.569 47.4401 396.599 47.44 396.629 47.47C396.709 47.53 396.789 47.5801 396.889 47.6201C397.039 47.6701 397.169 47.76 397.269 47.89C397.329 47.98 397.289 48.0401 396.839 48.5001L396.779 48.5601C396.779 48.5601 396.729 48.59 396.699 48.59L396.709 48.6ZM396.229 48.22L396.349 48.2601C396.449 48.2901 396.569 48.33 396.669 48.36L396.689 48.34C396.769 48.26 396.969 48.06 397.049 47.96C396.979 47.9 396.899 47.86 396.809 47.83C396.739 47.8 396.669 47.76 396.599 47.72C396.539 47.81 396.469 47.9001 396.399 47.9901C396.339 48.0701 396.279 48.15 396.229 48.22Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.439 40.33C417.369 40.38 417.279 40.41 417.199 40.4C416.949 40.26 416.729 40.07 416.489 39.91C416.479 39.91 416.429 39.96 416.439 39.96C416.609 39.95 416.769 39.9601 416.939 40.0101C417.119 40.0901 417.299 40.1901 417.449 40.3201L417.439 40.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.229 40.51C417.229 40.51 417.169 40.51 417.149 40.49C416.999 40.41 416.859 40.31 416.729 40.21C416.669 40.17 416.609 40.12 416.549 40.08C416.509 40.08 416.469 40.08 416.429 40.08C416.379 40.08 416.349 40.04 416.329 40C416.309 39.91 416.409 39.83 416.409 39.83C416.449 39.8 416.509 39.8 416.549 39.83C416.569 39.84 416.589 39.86 416.609 39.87C416.639 39.87 416.669 39.87 416.699 39.87C416.799 39.87 416.889 39.88 416.979 39.93L417.039 39.96C417.209 40.04 417.369 40.14 417.519 40.26C417.539 40.28 417.559 40.31 417.549 40.35C417.549 40.38 417.529 40.41 417.509 40.43C417.429 40.49 417.329 40.52 417.229 40.53V40.51Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.07 52.07C398.88 51.91 398.9 51.74 398.77 51.63C398.92 51.56 398.85 51.31 399.01 51.26C399.19 51.2 399.27 51.39 399.24 51.6C399.24 51.77 399.18 51.94 399.07 52.07Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.069 52.1801C399.069 52.1801 399.019 52.18 398.999 52.15C398.909 52.07 398.829 51.97 398.789 51.85C398.769 51.8 398.739 51.75 398.699 51.71C398.669 51.69 398.659 51.6501 398.659 51.6101C398.659 51.5701 398.689 51.54 398.719 51.52C398.739 51.51 398.759 51.47 398.769 51.4C398.779 51.29 398.859 51.19 398.959 51.14C399.049 51.11 399.139 51.1201 399.219 51.1801C399.329 51.2901 399.369 51.4501 399.339 51.6101V51.65C399.329 51.83 399.259 52 399.149 52.14C399.129 52.16 399.099 52.1801 399.069 52.1801ZM398.919 51.6301C398.919 51.6301 398.969 51.7101 398.989 51.7601C399.009 51.8001 399.029 51.85 399.059 51.89C399.099 51.81 399.119 51.7201 399.119 51.6301V51.59C399.139 51.51 399.119 51.4301 399.079 51.3701C399.079 51.3701 399.069 51.3601 399.039 51.3701C399.019 51.3701 399.009 51.4201 398.989 51.4801C398.979 51.5401 398.949 51.6 398.919 51.65V51.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.669 46.94C413.739 47.21 413.699 47.31 413.409 47.16C413.269 47.11 413.129 47.07 412.989 47.05C413.099 46.97 413.199 46.89 413.299 46.79C413.699 46.5 413.559 46.93 413.669 46.94Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.619 47.34C413.529 47.34 413.439 47.31 413.369 47.26C413.309 47.23 413.239 47.2101 413.169 47.2001C413.099 47.1901 413.029 47.17 412.959 47.15C412.919 47.14 412.889 47.1 412.879 47.06C412.879 47.02 412.899 46.9701 412.929 46.9501C412.989 46.9201 413.039 46.87 413.089 46.83C413.139 46.78 413.189 46.7401 413.239 46.7001C413.329 46.6101 413.459 46.57 413.589 46.59C413.669 46.63 413.729 46.72 413.729 46.81V46.84C413.729 46.84 413.779 46.88 413.789 46.91C413.829 47.05 413.849 47.21 413.749 47.3C413.719 47.33 413.669 47.34 413.629 47.34H413.619ZM413.249 46.99C413.329 47 413.399 47.03 413.469 47.06C413.509 47.08 413.549 47.1 413.589 47.11C413.589 47.08 413.589 47.05 413.579 47.01C413.539 46.97 413.519 46.91 413.509 46.85C413.509 46.84 413.509 46.82 413.499 46.8C413.459 46.82 413.409 46.84 413.369 46.87C413.329 46.9 413.279 46.94 413.249 46.98V46.99Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.719 49.79C397.759 49.86 397.729 49.9501 397.669 49.9901C397.529 50.1501 397.599 50.51 397.439 50.64C397.409 50.66 397.359 50.4701 397.279 50.4401C397.309 50.3801 397.349 50.4901 397.389 50.4401C397.529 50.3001 397.529 49.97 397.709 49.79H397.719Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.429 50.75H397.409C397.339 50.73 397.319 50.68 397.279 50.62C397.269 50.59 397.249 50.56 397.229 50.54C397.199 50.53 397.179 50.51 397.169 50.48C397.169 50.45 397.169 50.42 397.179 50.39C397.199 50.35 397.229 50.33 397.269 50.32C397.289 50.32 397.319 50.32 397.339 50.32C397.369 50.26 397.389 50.2 397.409 50.13C397.449 49.97 397.519 49.83 397.629 49.71C397.659 49.68 397.699 49.67 397.729 49.68C397.769 49.68 397.799 49.71 397.809 49.75C397.859 49.86 397.839 49.98 397.749 50.06C397.699 50.14 397.669 50.23 397.669 50.32C397.669 50.47 397.599 50.62 397.499 50.73C397.479 50.75 397.449 50.75 397.419 50.75H397.429Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.859 48.4101C413.999 48.4401 414.069 48.3301 414.179 48.3501C414.139 48.4501 414.109 48.4601 414.079 48.4601C413.929 48.4401 413.599 48.6401 413.459 48.5901C413.529 48.5201 413.789 48.4801 413.859 48.4101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M413.52 48.7101C413.52 48.7101 413.45 48.7101 413.42 48.6901C413.39 48.6801 413.36 48.6501 413.35 48.6101C413.35 48.5701 413.35 48.5401 413.38 48.5101C413.45 48.4501 413.53 48.41 413.62 48.39C413.67 48.37 413.73 48.35 413.78 48.33C413.81 48.3 413.84 48.2901 413.88 48.3001C413.92 48.3001 413.96 48.3001 414 48.2801C414.06 48.2501 414.13 48.2401 414.2 48.2501C414.23 48.2501 414.26 48.2801 414.28 48.3101C414.3 48.3401 414.3 48.3801 414.28 48.4101C414.25 48.4801 414.18 48.6001 414.06 48.5901C413.98 48.5901 413.91 48.6201 413.83 48.6501C413.73 48.6901 413.62 48.7201 413.51 48.7301L413.52 48.7101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M414.449 47.48C414.349 47.62 414.399 47.5 414.319 47.54C414.279 47.56 414.269 47.64 414.269 47.59C414.239 47.45 414.229 47.31 414.239 47.17C414.329 47.21 414.299 47.42 414.459 47.48H414.449Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M414.269 47.71H414.259C414.209 47.69 414.169 47.65 414.159 47.59C414.159 47.57 414.159 47.54 414.149 47.5C414.119 47.38 414.109 47.25 414.139 47.12C414.139 47.09 414.169 47.07 414.199 47.05C414.229 47.04 414.259 47.04 414.289 47.05C414.359 47.09 414.419 47.16 414.429 47.24C414.449 47.31 414.469 47.35 414.509 47.36C414.539 47.37 414.569 47.4 414.579 47.43C414.579 47.46 414.579 47.5 414.559 47.53C414.509 47.59 414.479 47.64 414.409 47.65C414.399 47.65 414.389 47.65 414.379 47.65C414.359 47.68 414.319 47.71 414.279 47.71H414.269Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M415.249 53.05C415.119 53.18 415.079 53.26 414.999 53.28C414.919 53.29 414.999 53.18 414.919 53.14C414.969 53.06 414.879 53.15 414.959 53.12C415.039 53.09 415.059 53 415.249 53.05Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M414.999 53.39C414.999 53.39 414.929 53.3801 414.909 53.3601C414.869 53.3301 414.859 53.28 414.859 53.23C414.839 53.22 414.829 53.2 414.819 53.17C414.819 53.14 414.819 53.1 414.829 53.08C414.829 53.08 414.849 53.04 414.869 53.02C414.899 53 414.929 52.9901 414.959 53.0001C415.049 52.9301 415.169 52.9101 415.279 52.9501C415.319 52.9501 415.349 52.99 415.359 53.03C415.369 53.07 415.359 53.11 415.329 53.14C415.289 53.18 415.259 53.2201 415.229 53.2501C415.179 53.3201 415.109 53.38 415.019 53.4C415.009 53.4 414.999 53.4 414.989 53.4L414.999 53.39Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M400.54 54.6901C400.69 54.7701 400.76 54.9 400.88 54.96C400.83 55.01 400.73 55.28 400.71 55.27C400.61 55.23 400.699 54.8101 400.609 54.7401C400.609 54.7401 400.519 54.7701 400.549 54.6901H400.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M400.709 55.3801C400.709 55.3801 400.679 55.3801 400.659 55.3801C400.529 55.3301 400.529 55.1801 400.529 55.0101C400.529 54.9701 400.529 54.9 400.529 54.86C400.499 54.86 400.469 54.8401 400.459 54.8201C400.429 54.7801 400.419 54.71 400.439 54.66C400.449 54.63 400.479 54.61 400.509 54.6C400.539 54.59 400.569 54.6 400.599 54.6C400.679 54.65 400.749 54.7 400.819 54.77C400.859 54.81 400.899 54.84 400.939 54.87C400.969 54.89 400.989 54.9201 400.999 54.9501C400.999 54.9901 400.999 55.02 400.969 55.05C400.959 55.06 400.919 55.14 400.899 55.18C400.839 55.3 400.799 55.39 400.719 55.39L400.709 55.3801ZM400.539 54.6901L400.639 54.73L400.539 54.6901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.05 60.03C302.05 60.03 302.07 59.9401 302.1 59.9401C302.38 59.8501 302.67 59.76 302.96 59.67C302.96 59.73 302.99 59.82 302.96 59.86C302.87 60.02 302.72 60.14 302.54 60.17C302.36 60.2 302.17 60.14 302.04 60.02L302.06 60.04L302.05 60.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M302.459 60.28C302.309 60.28 302.159 60.23 302.029 60.14C301.999 60.14 301.969 60.12 301.959 60.09V60.0701C301.959 60.0701 301.919 59.96 301.959 59.92L301.979 59.9C301.979 59.9 302.029 59.8301 302.069 59.8101C302.299 59.7301 302.529 59.66 302.759 59.59L302.929 59.54C302.929 59.54 302.999 59.5401 303.029 59.5601C303.059 59.5801 303.079 59.61 303.079 59.65C303.079 59.67 303.079 59.6801 303.079 59.7001C303.099 59.7701 303.089 59.84 303.059 59.91C302.939 60.12 302.719 60.26 302.469 60.27L302.459 60.28ZM302.249 60.0101C302.459 60.1201 302.729 60.04 302.839 59.83H302.809C302.619 59.9 302.439 59.9501 302.249 60.0101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.089 61.65L308.839 61.81C308.809 61.75 308.739 61.67 308.759 61.64C308.809 61.57 308.879 61.52 308.949 61.47L309.089 61.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M308.849 61.9301C308.849 61.9301 308.769 61.9101 308.749 61.8701C308.749 61.8501 308.729 61.8401 308.719 61.8201C308.679 61.7501 308.619 61.6701 308.669 61.5901C308.709 61.5301 308.769 61.4701 308.829 61.4301C308.849 61.4201 308.869 61.4001 308.889 61.3901C308.909 61.3701 308.949 61.3601 308.979 61.3601C309.009 61.3601 309.039 61.3801 309.059 61.4001L309.199 61.5801C309.199 61.5801 309.229 61.6401 309.219 61.6701C309.219 61.7001 309.199 61.7301 309.169 61.7501L308.919 61.9101C308.919 61.9101 308.879 61.9301 308.859 61.9301H308.849Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.789 62.79C297.789 62.79 297.719 62.8201 297.709 62.8101C297.689 62.7801 297.679 62.75 297.669 62.72L297.799 62.6901L297.779 62.79H297.789Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M297.719 62.9301C297.719 62.9301 297.649 62.9201 297.629 62.8901C297.599 62.8601 297.579 62.8201 297.579 62.7801C297.579 62.7501 297.579 62.7101 297.579 62.6801C297.599 62.6501 297.619 62.6201 297.649 62.6101L297.779 62.5801C297.779 62.5801 297.859 62.5801 297.879 62.6101C297.909 62.6401 297.919 62.6701 297.919 62.7101V62.8101C297.919 62.8101 297.869 62.8901 297.819 62.9001H297.799C297.799 62.9001 297.739 62.9201 297.719 62.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M301.169 60.47L301.089 60.4301L301.159 60.4901L301.169 60.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M301.159 60.6001C301.159 60.6001 301.109 60.6 301.089 60.58L301.019 60.5301C301.019 60.5301 300.959 60.4301 300.989 60.3801C301.019 60.3301 301.079 60.31 301.129 60.33L301.209 60.3701C301.209 60.3701 301.269 60.4201 301.279 60.4501C301.279 60.4901 301.279 60.5201 301.249 60.5501V60.5701C301.249 60.5701 301.179 60.6101 301.149 60.6101L301.159 60.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.959 62.7401L296.999 62.67L296.949 62.73L296.959 62.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.959 62.85C296.959 62.85 296.899 62.84 296.879 62.82H296.869C296.829 62.76 296.819 62.69 296.869 62.65L296.929 62.59C296.929 62.59 297.029 62.54 297.079 62.58C297.129 62.61 297.139 62.68 297.109 62.73L297.069 62.8C297.069 62.8 297.019 62.85 296.989 62.86H296.969L296.959 62.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.949 62.73L296.959 62.74L296.949 62.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.959 62.85C296.959 62.85 296.879 62.83 296.859 62.79C296.829 62.74 296.839 62.67 296.889 62.64C296.929 62.6 296.989 62.6 297.029 62.64H297.039C297.039 62.64 297.079 62.73 297.069 62.77C297.059 62.81 297.029 62.84 296.989 62.85C296.989 62.85 296.969 62.85 296.959 62.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.649 61.76C289.649 61.76 289.639 61.73 289.639 61.71L289.719 61.78C289.719 61.78 289.659 61.78 289.659 61.76H289.649Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M289.709 61.89H289.689C289.639 61.89 289.589 61.86 289.559 61.82C289.559 61.82 289.539 61.77 289.529 61.74C289.529 61.69 289.539 61.64 289.579 61.62C289.619 61.59 289.669 61.6 289.709 61.62L289.769 61.67C289.769 61.67 289.829 61.77 289.809 61.82C289.789 61.86 289.759 61.89 289.709 61.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M291.869 62.4301C291.869 62.3501 291.969 62.2701 292.019 62.2001L292.239 62.36C292.149 62.47 292.079 62.5401 292.019 62.6201C291.969 62.5601 291.859 62.4901 291.869 62.4401V62.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M292.019 62.7301C292.019 62.7301 291.959 62.7201 291.929 62.6901C291.909 62.6701 291.899 62.6601 291.879 62.6401C291.819 62.5801 291.739 62.5101 291.749 62.4201C291.769 62.3301 291.809 62.2601 291.869 62.1901C291.889 62.1701 291.899 62.1501 291.919 62.1301C291.939 62.1001 291.959 62.0901 291.999 62.0801C292.029 62.0801 292.059 62.0801 292.089 62.1001L292.309 62.2601C292.309 62.2601 292.349 62.3101 292.359 62.3401C292.369 62.3701 292.359 62.4001 292.329 62.4301L292.109 62.6901C292.109 62.6901 292.059 62.7301 292.019 62.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.079 62.23C300.099 62.15 300.109 62.07 300.129 61.99L300.249 62.08L300.079 62.23Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.079 62.35C300.079 62.35 300.039 62.35 300.019 62.33C299.979 62.31 299.959 62.26 299.969 62.21L300.019 61.97C300.019 61.97 300.049 61.9 300.089 61.89C300.129 61.88 300.169 61.89 300.199 61.9L300.319 61.99C300.319 61.99 300.359 62.04 300.369 62.08C300.369 62.11 300.359 62.15 300.329 62.17L300.159 62.3201C300.159 62.3201 300.109 62.35 300.079 62.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.319 61.4401C300.319 61.4401 300.319 61.42 300.319 61.41L300.379 61.47C300.379 61.47 300.339 61.4601 300.329 61.4401H300.319Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.37 61.5801C300.37 61.5801 300.33 61.5801 300.32 61.5701C300.28 61.5601 300.25 61.5301 300.23 61.5001C300.23 61.5001 300.22 61.4701 300.21 61.4501C300.2 61.4001 300.21 61.3501 300.26 61.3201C300.3 61.2901 300.36 61.3001 300.39 61.3301L300.45 61.3801C300.45 61.3801 300.49 61.4601 300.48 61.5001C300.47 61.5401 300.42 61.5701 300.37 61.5701V61.5801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.919 64.0701C300.749 64.1801 300.419 64.3 300.429 64.39C300.499 64.8 300.599 65.2 300.729 65.6C300.729 65.62 300.799 65.6201 300.829 65.6301C300.859 65.3301 300.879 65.03 300.909 64.73C300.909 64.66 300.909 64.59 300.909 64.52H300.949L300.919 64.08V64.0701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.699 62.96C293.799 62.89 293.889 62.8001 293.959 62.7001C293.829 62.6801 293.669 62.59 293.589 62.64C293.499 62.7 293.469 62.8501 293.419 62.9701C293.509 62.9901 293.609 62.98 293.699 62.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.579 63.1001C293.579 63.1001 293.509 63.1001 293.479 63.1001C293.459 63.1001 293.429 63.1001 293.409 63.1001C293.369 63.1001 293.339 63.0801 293.319 63.0501C293.299 63.0201 293.299 62.9801 293.319 62.9401C293.329 62.9101 293.339 62.8801 293.359 62.8501C293.389 62.7301 293.449 62.6301 293.539 62.5601C293.649 62.5201 293.769 62.5201 293.879 62.5701C293.919 62.5801 293.949 62.5901 293.989 62.6001C294.029 62.6001 294.059 62.6401 294.079 62.6801C294.099 62.7201 294.079 62.7601 294.049 62.7901C294.029 62.8201 293.999 62.8401 293.979 62.8701C293.919 62.9501 293.849 63.0201 293.759 63.0701C293.709 63.1001 293.649 63.1101 293.589 63.1101L293.579 63.1001ZM293.579 62.8701C293.579 62.8701 293.629 62.8701 293.649 62.8601C293.649 62.8601 293.729 62.8001 293.759 62.7601C293.719 62.7501 293.689 62.7401 293.649 62.7401C293.619 62.7801 293.589 62.8201 293.579 62.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.409 62.99V62.97C293.409 62.97 293.409 62.97 293.389 62.97V62.99H293.409Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.409 63.1001C293.409 63.1001 293.349 63.1001 293.329 63.0701C293.329 63.0701 293.289 62.9801 293.299 62.9301C293.319 62.8901 293.359 62.8701 293.399 62.8601C293.439 62.8601 293.479 62.8701 293.509 62.9101C293.529 62.9401 293.539 62.9801 293.529 63.0201C293.509 63.0601 293.479 63.0801 293.439 63.0901H293.409V63.1001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.399 63.0901C293.339 63.0901 293.279 63.0401 293.279 62.9801C293.279 62.9501 293.289 62.9201 293.309 62.9001C293.329 62.8801 293.359 62.8701 293.389 62.8701C293.449 62.8701 293.499 62.9201 293.499 62.9801C293.499 63.0401 293.449 63.0901 293.389 63.0901H293.399Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.209 63.01C296.189 62.95 296.179 62.87 296.129 62.84C296.099 62.82 296.019 62.86 295.959 62.87C295.989 62.94 296.019 63.02 296.049 63.09C296.099 63.06 296.159 63.03 296.209 63V63.01Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M296.059 63.21C296.059 63.21 296.029 63.21 296.019 63.21C295.989 63.2 295.959 63.17 295.949 63.14L295.859 62.92C295.859 62.92 295.849 62.85 295.859 62.82C295.869 62.79 295.899 62.77 295.939 62.76C295.949 62.76 295.969 62.76 295.979 62.75C296.049 62.72 296.119 62.72 296.189 62.75C296.239 62.79 296.279 62.85 296.289 62.92C296.289 62.94 296.299 62.95 296.309 62.97C296.329 63.02 296.309 63.09 296.259 63.12L296.099 63.21C296.099 63.21 296.059 63.22 296.049 63.22L296.059 63.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.399 63.0901C293.339 63.0901 293.279 63.0401 293.279 62.9801C293.279 62.9501 293.289 62.9201 293.309 62.9001C293.329 62.8801 293.359 62.8701 293.389 62.8701C293.449 62.8701 293.499 62.9201 293.499 62.9801C293.499 63.0401 293.449 63.0901 293.389 63.0901H293.399Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.409 62.99L293.399 62.98L293.389 62.97V62.99H293.409Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.399 63.1C293.399 63.1 293.379 63.1 293.369 63.1C293.319 63.09 293.279 63.04 293.279 62.99C293.279 62.94 293.319 62.9 293.359 62.88C293.399 62.86 293.449 62.87 293.479 62.9C293.519 62.94 293.519 63 293.489 63.05C293.469 63.08 293.429 63.1 293.399 63.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.389 62.97L293.399 62.98L293.389 62.97Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.399 63.1001C293.399 63.1001 293.339 63.0901 293.309 63.0601C293.289 63.0401 293.279 63.0101 293.279 62.9801C293.279 62.9501 293.289 62.9201 293.319 62.9001C293.339 62.8801 293.369 62.8701 293.399 62.8701C293.429 62.8701 293.459 62.8801 293.479 62.9101C293.479 62.9101 293.509 62.9701 293.509 62.9901C293.509 63.0201 293.499 63.0501 293.469 63.0801C293.449 63.1001 293.419 63.1101 293.389 63.1101L293.399 63.1001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M309.339 60.0001C309.289 59.9301 309.049 59.9501 308.919 60.0001C308.639 60.0901 308.579 60.0001 308.499 59.7201L304.389 58.8501C304.509 59.2801 303.609 59.8901 303.259 60.4101C302.929 60.9001 302.459 60.3901 302.179 60.7101L302.029 60.0101V60.0301C301.939 59.8701 301.819 59.7201 301.729 59.5601C301.689 59.4801 301.659 59.3901 301.639 59.3001C301.569 59.3701 301.449 59.4201 301.419 59.5001C301.309 59.8301 301.239 60.1601 301.149 60.5001V60.4801C301.329 60.8501 301.149 61.0201 300.809 61.0501C300.609 61.0701 300.389 60.9501 300.189 60.9801C299.969 61.0101 299.779 61.1501 300.039 61.3801C299.969 61.5401 299.899 61.7101 299.829 61.8701C299.709 62.1201 299.779 62.2601 300.059 62.2901C300.059 62.4301 300.059 62.5701 300.059 62.7101C299.629 62.6701 298.969 62.7801 298.839 62.5601C298.529 62.0601 298.389 62.4601 298.219 62.5601C298.119 62.6201 298.119 62.8701 298.009 62.9201C297.759 63.0401 297.489 63.1201 297.219 63.1401C297.139 63.1401 297.049 62.9001 296.959 62.7501C296.459 62.8601 296.649 63.3401 296.489 63.6301C296.379 63.8101 296.209 63.9501 296.009 64.0201C295.929 64.0501 295.709 63.8601 295.639 63.7301C295.289 63.0601 294.909 62.9901 294.399 63.5401C294.279 63.7201 294.129 63.8801 293.969 64.0201C293.779 64.1101 293.569 64.1801 293.359 64.2201C293.359 64.0201 293.339 63.8201 293.349 63.6201C293.349 63.4101 293.379 63.2001 293.399 62.9901C293.189 62.9301 292.609 63.1601 293.039 62.5901C293.529 61.9401 292.619 61.7301 292.689 61.2301C292.479 61.3001 292.269 61.3801 292.049 61.4301C291.939 61.4501 291.829 61.4401 291.729 61.4101C291.259 61.2201 290.999 61.2701 291.129 61.8701C291.129 61.8901 290.879 62.0201 290.839 61.9901C290.669 61.8601 290.549 61.5501 290.389 61.5401C290.149 61.5301 289.749 61.0801 289.619 61.6901C289.469 61.7901 289.329 61.9501 289.179 61.9701C288.759 62.0201 288.339 62.0001 287.919 62.0101C287.939 61.7601 287.949 61.5101 287.929 61.2701C287.919 61.1501 287.829 60.9601 287.739 60.9401C287.579 60.9001 287.279 60.9101 287.239 61.0001C286.979 61.5401 286.159 61.8801 286.619 62.6901C286.649 62.7501 286.539 62.9301 286.449 63.0001C286.209 63.2001 285.759 63.0801 285.489 62.8701C285.269 62.7701 285.029 62.7201 284.789 62.7301C284.749 62.7301 284.639 62.9201 284.659 62.9501C285.059 63.4501 284.659 63.9301 284.599 64.4001C284.499 65.2701 284.859 65.7001 285.869 65.7301C285.849 66.0801 285.889 66.4101 286.369 66.3801C287.429 66.3101 288.259 67.2401 289.339 67.0701C289.389 67.0701 289.469 67.1201 289.509 67.1701C289.829 67.5501 290.179 67.9101 290.539 68.2501C290.879 68.5001 291.259 68.6901 291.669 68.8201C291.779 68.8601 291.979 68.6401 292.149 68.5601C292.229 68.5401 292.309 68.5601 292.369 68.6001C293.189 69.1601 294.149 69.4701 295.139 69.4901C295.419 69.5101 295.689 69.4501 295.929 69.3101C296.179 69.1501 296.359 68.8701 296.019 68.5901C296.089 68.5101 296.189 68.3501 296.239 68.3601C296.799 68.5201 297.349 68.7301 297.919 68.8601C298.379 68.9701 298.959 69.1701 299.309 68.9901C299.609 68.8401 300.079 68.7101 300.249 68.2301C300.369 67.9001 300.699 67.7501 301.029 68.1501C301.219 68.3801 301.599 68.4701 301.609 68.1101C301.619 67.3401 301.999 67.1901 302.649 67.2201C302.829 67.2201 302.999 67.1501 303.119 67.0201C303.299 66.7801 303.409 66.8401 303.649 66.9501C304.229 67.2301 304.229 67.1901 304.379 66.5301C304.419 66.3701 304.529 66.2301 304.679 66.1501C305.179 66.0201 305.569 65.6501 306.149 65.6201C306.989 65.5701 306.979 65.4901 307.109 64.5101C307.169 64.0501 307.289 63.6101 307.939 63.8001C308.299 63.9001 308.299 63.6901 308.219 63.4401C308.129 63.2401 308.069 63.0301 308.009 62.8101C307.999 62.7301 308.169 62.5201 308.219 62.5401C308.909 62.7201 308.669 62.3201 308.569 62.0001C308.479 61.8001 308.469 61.5701 308.539 61.3601C308.619 61.1501 308.769 60.9801 308.979 60.8901C309.179 60.8101 309.359 60.6901 309.489 60.5201C309.549 60.4001 309.449 60.1401 309.349 60.0101L309.339 60.0001ZM285.759 64.2501C285.759 64.2501 285.699 64.2301 285.699 64.2201C285.699 64.1901 285.709 64.1601 285.729 64.1301C285.749 64.1401 285.789 64.1501 285.789 64.1601C285.789 64.1901 285.779 64.2201 285.769 64.2501H285.759ZM287.069 65.3301C287.069 65.3301 287.089 65.2701 287.099 65.2401C287.129 65.3101 287.149 65.3701 287.179 65.4401C287.139 65.4101 287.109 65.3701 287.069 65.3301ZM287.659 64.0901C287.659 64.0901 287.609 64.0301 287.599 63.9901C287.629 63.9901 287.659 63.9701 287.689 63.9801C287.709 63.9801 287.719 64.0201 287.739 64.0501C287.709 64.0601 287.669 64.1001 287.669 64.0901H287.659ZM287.499 63.1801C287.409 62.9601 287.749 62.4601 287.989 62.4401C288.039 62.4401 288.149 62.5201 288.149 62.5401C288.069 62.8301 287.979 63.1201 287.859 63.5001C287.649 63.3201 287.529 63.2701 287.499 63.1801ZM288.139 65.7801C288.139 65.7801 288.049 65.6901 288.009 65.6501C288.099 65.6001 288.199 65.5501 288.289 65.5101C288.239 65.6001 288.189 65.6901 288.139 65.7901V65.7801ZM288.809 66.5201C288.809 66.5201 288.749 66.4301 288.719 66.3801C288.719 66.3601 288.769 66.3001 288.779 66.3001C288.829 66.3201 288.879 66.3401 288.919 66.3701C288.879 66.4201 288.839 66.4701 288.799 66.5201H288.809ZM291.309 65.8401C291.309 65.8401 291.359 65.8601 291.359 65.8701C291.359 65.9001 291.359 65.9301 291.339 65.9601C291.319 65.9601 291.289 65.9401 291.289 65.9301C291.289 65.9001 291.289 65.8701 291.309 65.8401ZM290.979 68.1801L290.799 67.9101H291.209C291.129 67.9901 291.059 68.0901 290.979 68.1801ZM292.099 64.7601C292.149 64.4801 292.229 64.2101 292.329 63.9501C292.389 63.8301 292.589 63.7801 292.729 63.7001C292.789 63.8801 292.819 64.0601 292.809 64.2501C292.739 64.5801 292.429 64.8001 292.099 64.7601ZM292.479 67.5201C292.479 67.5201 292.429 67.4601 292.399 67.4201C292.399 67.4101 292.439 67.3801 292.459 67.3501C292.479 67.3801 292.489 67.4001 292.509 67.4301C292.509 67.4601 292.489 67.4901 292.479 67.5201ZM293.129 67.9801C293.129 67.9801 293.079 67.9001 293.049 67.8501L293.119 67.8001L293.169 67.8801L293.129 67.9701V67.9801ZM292.739 66.0501C292.709 66.1201 292.599 66.1601 292.529 66.2101C292.509 66.1501 292.459 66.0701 292.479 66.0201C292.619 65.6101 292.519 65.0301 293.179 65.0001C293.029 65.3501 292.889 65.7001 292.729 66.0401L292.739 66.0501ZM294.429 65.5501C294.429 65.5501 294.359 65.5001 294.359 65.4901C294.379 65.4301 294.399 65.3701 294.419 65.3201C294.439 65.3401 294.489 65.3701 294.479 65.3901C294.469 65.4501 294.449 65.5001 294.419 65.5601L294.429 65.5501ZM294.849 64.6201C294.749 64.6001 294.669 64.4501 294.619 64.3401C294.609 64.3101 294.759 64.1501 294.819 64.1601C294.969 64.2101 295.109 64.2901 295.229 64.3801C295.049 64.5001 294.929 64.6301 294.849 64.6201ZM295.739 66.1301C295.739 66.1301 295.759 66.0701 295.769 66.0401C295.789 66.1101 295.809 66.1801 295.829 66.2401C295.789 66.2001 295.759 66.1601 295.729 66.1201L295.739 66.1301ZM296.189 66.6801C296.079 66.6501 295.979 66.5801 295.899 66.5001C295.859 66.4601 295.879 66.3801 295.869 66.3101C295.929 66.3001 295.999 66.2901 296.059 66.3101C296.169 66.3601 296.269 66.4101 296.369 66.4701C296.309 66.5501 296.229 66.6901 296.189 66.6801ZM296.189 65.7901C296.109 65.6901 296.189 65.4801 296.189 65.3201C296.319 65.3901 296.449 65.4601 296.569 65.5301C296.619 65.5601 296.679 65.6001 296.729 65.6301C296.599 65.8401 296.469 66.1401 296.189 65.8001V65.7901ZM297.509 65.0201C297.449 64.9901 297.369 64.9801 297.329 64.9301C297.179 64.7701 297.059 64.5901 296.969 64.4001C296.919 64.2801 297.009 64.1101 297.039 63.9601C297.149 64.0501 297.309 64.1101 297.369 64.2301C297.459 64.4401 297.519 64.6501 297.569 64.8701L297.509 65.0201ZM299.979 63.4801C299.979 63.3201 299.999 63.1601 300.009 63.0101C300.009 62.9201 300.039 62.8201 300.059 62.7301C300.129 62.8401 300.239 62.9601 300.219 63.0601C300.169 63.2101 300.079 63.3601 299.979 63.4901V63.4801ZM300.889 64.7201C300.869 65.0201 300.839 65.3201 300.809 65.6201C300.769 65.6201 300.709 65.6201 300.709 65.5901C300.579 65.2001 300.479 64.7901 300.409 64.3801C300.399 64.2901 300.729 64.1701 300.899 64.0601L300.929 64.5001H300.889C300.889 64.5701 300.889 64.6401 300.889 64.7101V64.7201ZM300.979 63.3201C300.979 63.3201 300.929 63.2401 300.909 63.2001C300.939 63.1901 300.979 63.1901 301.009 63.1901C301.029 63.1901 301.049 63.2401 301.059 63.2601L300.969 63.3101L300.979 63.3201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M285.699 64.2101C285.699 64.2101 285.739 64.2301 285.759 64.2401C285.769 64.2101 285.779 64.1801 285.779 64.1501C285.779 64.1401 285.739 64.1301 285.719 64.1201C285.709 64.1501 285.699 64.1801 285.689 64.2101H285.699Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M285.749 64.35C285.749 64.35 285.729 64.35 285.719 64.35C285.669 64.33 285.589 64.3 285.589 64.22C285.589 64.22 285.599 64.15 285.609 64.11C285.619 64.08 285.649 64.05 285.679 64.03C285.709 64.01 285.749 64.01 285.779 64.03C285.829 64.05 285.899 64.08 285.899 64.16C285.899 64.2 285.899 64.23 285.879 64.27C285.869 64.3 285.839 64.33 285.809 64.35C285.789 64.35 285.769 64.36 285.749 64.37V64.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.069 65.32C287.069 65.32 287.139 65.4 287.179 65.43C287.149 65.36 287.129 65.3 287.099 65.23C287.089 65.26 287.059 65.3 287.069 65.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M287.18 65.55C287.18 65.55 287.12 65.54 287.1 65.52C287.06 65.48 287.02 65.44 286.98 65.4C286.95 65.35 286.95 65.28 286.98 65.22C287 65.17 287.04 65.14 287.09 65.14C287.09 65.14 287.18 65.1601 287.2 65.2001L287.28 65.4C287.28 65.4 287.28 65.51 287.24 65.54C287.22 65.55 287.2 65.5601 287.18 65.5601V65.55Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M288.589 63.1401H288.649L288.629 63.0901L288.589 63.1401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M288.65 63.26H288.58C288.58 63.26 288.51 63.22 288.49 63.19C288.47 63.15 288.48 63.11 288.49 63.08L288.52 63.03C288.52 63.03 288.58 62.98 288.63 62.98C288.67 62.98 288.71 63.01 288.72 63.05L288.74 63.1C288.74 63.1 288.75 63.18 288.73 63.21C288.71 63.24 288.67 63.26 288.64 63.26H288.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M288.719 66.3801C288.719 66.3801 288.769 66.48 288.809 66.52C288.849 66.47 288.889 66.4201 288.929 66.3701C288.889 66.3401 288.839 66.32 288.789 66.3C288.769 66.3 288.719 66.3601 288.729 66.3801H288.719Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M288.809 66.63C288.809 66.63 288.739 66.61 288.719 66.58L288.699 66.55C288.699 66.55 288.639 66.47 288.619 66.42C288.609 66.36 288.619 66.3 288.669 66.26C288.699 66.21 288.759 66.19 288.809 66.2C288.859 66.21 288.899 66.23 288.949 66.26L288.989 66.28C288.989 66.28 289.039 66.32 289.049 66.36C289.049 66.39 289.049 66.43 289.029 66.46L288.909 66.61C288.909 66.61 288.859 66.65 288.819 66.65L288.809 66.63Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M290.459 67.14L290.529 67.2001C290.529 67.2001 290.529 67.17 290.509 67.16C290.509 67.15 290.469 67.15 290.449 67.14H290.459Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M290.519 67.3001C290.519 67.3001 290.479 67.3001 290.459 67.2801L290.389 67.2201C290.389 67.2201 290.329 67.1301 290.359 67.0801C290.379 67.0301 290.439 67.0101 290.489 67.0201C290.529 67.0201 290.579 67.0401 290.609 67.0801C290.619 67.1001 290.639 67.1201 290.639 67.1401C290.659 67.1901 290.639 67.2401 290.599 67.2801C290.579 67.3001 290.549 67.3001 290.529 67.3001H290.519Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M290.979 68.1801C291.059 68.0901 291.129 68 291.209 67.9H290.799L290.979 68.1801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M290.979 68.29C290.979 68.29 290.909 68.2701 290.889 68.2401L290.709 67.97C290.709 67.97 290.679 67.89 290.709 67.85C290.739 67.81 290.769 67.79 290.809 67.79H291.219C291.219 67.79 291.299 67.81 291.319 67.85C291.339 67.89 291.329 67.94 291.299 67.97L291.069 68.2501C291.069 68.2501 291.019 68.29 290.979 68.29Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M292.399 67.4201C292.399 67.4201 292.449 67.4901 292.479 67.5201C292.489 67.4901 292.499 67.4601 292.509 67.4301L292.459 67.3501C292.459 67.3501 292.399 67.4001 292.399 67.4201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M292.479 67.63C292.479 67.63 292.409 67.61 292.389 67.59L292.369 67.57C292.369 67.57 292.319 67.5 292.299 67.47C292.279 67.4 292.299 67.33 292.359 67.3C292.389 67.27 292.429 67.26 292.459 67.26C292.499 67.26 292.529 67.28 292.549 67.31L292.599 67.39C292.599 67.39 292.619 67.45 292.609 67.49L292.579 67.58C292.579 67.58 292.529 67.65 292.489 67.65H292.469L292.479 67.63Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.049 67.85C293.049 67.85 293.099 67.94 293.129 67.98L293.169 67.89L293.119 67.8101L293.049 67.86V67.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M293.129 68.09C293.129 68.09 293.049 68.07 293.029 68.04L293.009 68.01C293.009 68.01 292.969 67.94 292.949 67.9C292.899 67.81 292.989 67.75 293.029 67.73L293.049 67.71C293.049 67.71 293.109 67.68 293.139 67.69C293.169 67.69 293.199 67.72 293.209 67.75L293.259 67.83C293.259 67.83 293.279 67.9 293.259 67.93L293.219 68.02C293.219 68.02 293.169 68.09 293.119 68.09H293.109H293.129Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M294.429 65.3101C294.399 65.3701 294.379 65.42 294.369 65.48C294.369 65.5 294.409 65.52 294.439 65.54C294.459 65.49 294.479 65.4301 294.499 65.3701C294.499 65.3501 294.459 65.32 294.439 65.3L294.429 65.3101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M294.429 65.66C294.429 65.66 294.369 65.6501 294.349 65.6301C294.299 65.5901 294.229 65.54 294.249 65.46C294.259 65.41 294.279 65.3601 294.299 65.3101L294.319 65.27C294.319 65.27 294.369 65.2101 294.399 65.2001C294.439 65.2001 294.479 65.2 294.499 65.23H294.519C294.569 65.28 294.599 65.34 294.599 65.4C294.589 65.45 294.569 65.5 294.549 65.55L294.529 65.59C294.529 65.59 294.489 65.65 294.449 65.66H294.429Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.75 66.1301C295.75 66.1301 295.81 66.2101 295.85 66.2501C295.83 66.1801 295.81 66.11 295.79 66.05C295.78 66.08 295.75 66.12 295.76 66.14L295.75 66.1301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M295.839 66.36C295.839 66.36 295.779 66.3501 295.759 66.3201C295.719 66.2801 295.679 66.2401 295.649 66.1901C295.619 66.1301 295.629 66.07 295.659 66.02C295.679 65.98 295.729 65.9501 295.779 65.9401C295.829 65.9401 295.869 65.9701 295.889 66.0101L295.949 66.21C295.969 66.26 295.949 66.32 295.899 66.34C295.879 66.34 295.859 66.36 295.839 66.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.03 63.01C300.01 63.17 300.01 63.33 300 63.48C300.1 63.35 300.18 63.21 300.24 63.05C300.26 62.95 300.14 62.83 300.08 62.72C300.06 62.81 300.04 62.91 300.03 63V63.01Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M299.999 63.6C299.999 63.6 299.979 63.6 299.969 63.6C299.919 63.58 299.889 63.54 299.889 63.48V63.35C299.899 63.23 299.909 63.12 299.919 63C299.919 62.92 299.939 62.84 299.959 62.76V62.7099C299.959 62.7099 300.019 62.63 300.059 62.62C300.099 62.61 300.149 62.63 300.179 62.67C300.199 62.7 300.219 62.73 300.229 62.75C300.309 62.84 300.349 62.95 300.349 63.07C300.319 63.2 300.259 63.32 300.179 63.42C300.149 63.46 300.119 63.5 300.099 63.54C300.079 63.57 300.039 63.6 299.999 63.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.919 63.21C300.919 63.21 300.969 63.29 300.989 63.33L301.079 63.28C301.079 63.28 301.049 63.21 301.029 63.21C300.999 63.21 300.959 63.21 300.929 63.22L300.919 63.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M300.989 63.44C300.989 63.44 300.969 63.44 300.959 63.44C300.929 63.44 300.899 63.4099 300.889 63.3899L300.819 63.2699C300.819 63.2699 300.799 63.2 300.819 63.16C300.839 63.13 300.869 63.1 300.909 63.1H300.929C300.929 63.1 301.019 63.08 301.059 63.1C301.109 63.12 301.139 63.16 301.159 63.2C301.179 63.23 301.189 63.26 301.179 63.3C301.179 63.33 301.159 63.36 301.129 63.38L301.039 63.43C301.039 63.43 300.999 63.45 300.979 63.45L300.989 63.44Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.839 65.03L304.879 65.04L304.869 64.98L304.839 65.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.879 65.15H304.809C304.809 65.15 304.739 65.11 304.729 65.07C304.719 65.03 304.719 64.99 304.739 64.96L304.769 64.91C304.769 64.91 304.839 64.85 304.889 64.86C304.929 64.86 304.969 64.9 304.979 64.95V65.01C304.979 65.01 304.989 65.08 304.979 65.11C304.959 65.14 304.929 65.15 304.889 65.15H304.879Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.789 58.44C304.729 58.44 304.669 58.37 304.609 58.33C304.669 58.3 304.739 58.24 304.799 58.24C304.859 58.24 304.909 58.31 304.969 58.34C304.909 58.37 304.849 58.44 304.789 58.44Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M304.8 58.5601C304.73 58.5601 304.66 58.52 304.61 58.47C304.6 58.46 304.58 58.4501 304.57 58.4401C304.54 58.4201 304.52 58.38 304.52 58.34C304.52 58.3 304.55 58.2601 304.58 58.2401C304.6 58.2401 304.61 58.22 304.63 58.21C304.69 58.17 304.75 58.14 304.82 58.14C304.89 58.14 304.96 58.18 305.01 58.23C305.02 58.24 305.04 58.2501 305.05 58.2601C305.08 58.2801 305.1 58.32 305.1 58.36C305.1 58.4 305.08 58.44 305.04 58.46C305.02 58.46 305.01 58.4801 304.99 58.4901C304.94 58.5401 304.87 58.5601 304.8 58.5701V58.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.989 28.66L425.089 28.7601C425.089 28.7601 425.039 28.75 425.039 28.73C425.029 28.7 425.019 28.67 425.019 28.64L424.999 28.66H424.989Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M425.139 21.2001C424.579 21.6801 424.939 21.68 425.249 21.85L425.139 21.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.739 17.8801C424.239 18.1601 423.769 18.4901 423.339 18.8601C423.299 18.9201 423.269 18.9901 423.279 19.0601C423.369 19.1101 423.489 19.1701 423.559 19.1401C423.949 18.9501 424.339 18.7501 424.719 18.5201C424.839 18.4501 424.889 18.2301 425.009 18.1701", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.04 16.4401L423.25 16.04L423.23 16.02L423.71 16.27L423.69 16.2501C423.75 16.7501 424.06 16.98 424.49 16.78", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.879 17.47C423.109 17.32 423.569 17.6001 423.569 17.1301C423.569 17.1101 423.469 17.0801 423.339 17.0601C423.209 17.0401 423.089 16.95 423.029 16.83C422.969 16.71 422.969 16.5601 423.029 16.4401", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.039 33.7301L423.959 33.8101L424.019 33.7101C424.019 33.7101 424.069 33.6801 424.099 33.6601C424.109 33.6501 424.119 33.6301 424.129 33.6101L424.049 33.7301H424.039Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M425.289 18.71L424.739 19.19C424.849 19.28 425.009 19.46 425.059 19.43", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.569 34.8701C424.369 34.7301 424.159 34.6101 423.929 34.5101C423.879 34.5001 423.759 34.7101 423.679 34.8201C423.809 34.9401 423.959 35.0301 424.119 35.1001C424.209 35.1201 424.339 34.9901 424.569 34.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.189 24.26L424.139 24C423.989 24.08 423.849 24.18 423.729 24.29C423.699 24.32 423.789 24.47 423.819 24.56L424.189 24.26Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M424.959 20.3C424.829 20.3 424.729 20.28 424.629 20.28C424.619 20.32 424.609 20.37 424.609 20.41C424.669 20.43 424.739 20.4401 424.809 20.4401C424.849 20.4401 424.879 20.37 424.949 20.3H424.959Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.229 27.79C423.229 27.79 423.199 27.74 423.179 27.73C423.149 27.73 423.119 27.73 423.079 27.73C423.099 27.76 423.119 27.8 423.139 27.82C423.149 27.82 423.189 27.8 423.219 27.78L423.229 27.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M423.81 17.79C423.81 17.79 423.76 17.72 423.74 17.72C423.68 17.73 423.62 17.75 423.56 17.78C423.58 17.81 423.61 17.86 423.63 17.85C423.69 17.84 423.76 17.82 423.82 17.79H423.81Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M422.549 23.3401L422.599 23.3801L422.609 23.3301L422.549 23.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M361.439 34.54C361.659 34.32 361.999 34.1199 361.519 33.8299C362.139 33.3899 361.429 32.68 361.859 32.2C361.919 32.07 362.029 31.95 362.019 31.82C362.019 31.73 361.869 31.65 361.779 31.56C361.739 31.65 361.659 31.7499 361.679 31.8299C361.729 31.9599 361.799 32.0899 361.879 32.2099C361.619 32.2699 361.359 32.29 361.089 32.26C360.879 32.2 360.699 32.05 360.609 31.84C360.569 31.72 360.769 31.46 360.929 31.35C361.619 30.9 361.629 30.91 361.129 30.24C361.039 30.12 360.959 29.99 360.889 29.86C360.689 29.48 360.529 29.13 361.209 29.09C361.429 29.05 361.639 28.97 361.829 28.86C361.949 28.8 362.149 28.66 362.129 28.63C362.029 28.42 362.009 28.1799 362.089 27.9599C362.169 27.7399 362.329 27.56 362.539 27.47C362.569 27.45 362.539 27.34 362.539 27.28L362.009 27.35L362.029 27.37C361.859 27.07 361.709 26.77 361.589 26.45C361.419 25.92 361.569 25.6699 362.179 25.5199C362.499 25.4399 362.639 25.31 362.669 25C362.669 24.93 362.789 24.87 362.849 24.8C362.919 24.89 363.049 24.98 363.039 25.06C362.999 25.31 362.949 25.55 362.889 25.8C362.869 25.89 362.839 26.0499 362.879 26.0799C362.979 26.1399 363.089 26.15 363.199 26.12C363.349 26.08 363.479 25.9999 363.569 25.8899C364.039 25.2199 365.039 25.27 365.429 24.49C365.459 24.43 365.809 24.44 365.919 24.53C366.009 24.61 366.009 24.8599 365.979 25.0199C365.909 25.3299 365.789 25.64 365.689 25.94C365.489 25.85 365.279 25.77 365.069 25.7C364.949 25.66 364.809 25.66 364.689 25.72C364.459 26.03 364.499 26.46 364.789 26.72C365.159 26.93 365.219 26.57 365.359 26.38C365.469 26.23 365.569 26.07 365.679 25.92C365.829 26.04 365.969 26.17 366.099 26.32C366.159 26.43 366.209 26.56 366.229 26.69C366.339 26.61 366.439 26.5099 366.529 26.3999C366.599 26.2499 366.659 26.1 366.699 25.94C366.789 26.07 366.939 26.2 366.959 26.34C367.049 27.01 367.439 29.04 367.799 28.85L367.779 28.8299C368.029 29.5599 367.469 27.74 367.089 28.22L367.109 28.2C366.999 28.35 366.889 28.51 366.809 28.68C366.759 28.84 366.729 29.01 366.709 29.19C366.829 29.12 366.949 29.08 367.089 29.05C367.269 29.05 367.029 31.33 367.209 31.37C367.299 31.41 367.389 31.4599 367.459 31.5199C367.409 31.5699 367.349 31.62 367.299 31.67C367.149 31.79 367.409 29.6399 367.269 29.7699C367.209 29.8399 367.149 29.92 367.109 30C367.219 30 366.919 32.74 367.029 32.72C367.209 32.67 367.379 32.1499 367.549 32.0799C367.879 31.9499 368.619 31.98 368.709 32.36", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M361.44 34.6501C361.44 34.6501 361.379 34.6401 361.359 34.6201C361.319 34.5801 361.319 34.5001 361.359 34.4601C361.389 34.4301 361.43 34.4001 361.46 34.3601C361.55 34.2801 361.66 34.1801 361.65 34.1101C361.65 34.0901 361.62 34.0201 361.46 33.9201C361.43 33.9001 361.41 33.8601 361.41 33.8301C361.41 33.7901 361.43 33.7601 361.46 33.7301C361.72 33.5401 361.7 33.3201 361.64 32.9701C361.59 32.7701 361.59 32.5601 361.64 32.3601C361.45 32.4001 361.26 32.4101 361.07 32.3801C360.82 32.3101 360.61 32.1301 360.51 31.8901C360.45 31.6901 360.72 31.3801 360.88 31.2701L360.919 31.2501C361.189 31.0701 361.36 30.9601 361.38 30.8701C361.4 30.7801 361.26 30.6001 361.06 30.3301C360.96 30.2001 360.88 30.0701 360.8 29.9301C360.66 29.6601 360.55 29.4301 360.66 29.2301C360.74 29.0901 360.92 29.0101 361.21 28.9901C361.38 28.9601 361.54 28.9001 361.69 28.8201L361.79 28.7701C361.87 28.7301 361.94 28.6801 362.01 28.6201C361.82 28.1701 362.01 27.6501 362.44 27.4201L362.109 27.4601C362.109 27.4601 362 27.4901 361.96 27.4601C361.95 27.4501 361.93 27.4301 361.93 27.4101C361.89 27.3201 361.84 27.2401 361.79 27.1501C361.67 26.9401 361.57 26.7201 361.49 26.4901C361.39 26.2701 361.4 26.0301 361.49 25.8101C361.65 25.5901 361.89 25.4501 362.16 25.4201C362.44 25.3501 362.54 25.2501 362.56 25.0001C362.58 24.9101 362.64 24.8301 362.71 24.7901C362.73 24.7701 362.75 24.7601 362.77 24.7401C362.79 24.7201 362.829 24.7101 362.859 24.7101C362.889 24.7101 362.92 24.7301 362.94 24.7501C362.96 24.7801 362.98 24.8001 363.01 24.8201C363.09 24.8801 363.15 24.9801 363.16 25.0901C363.14 25.2601 363.11 25.4201 363.07 25.5901C363.05 25.6701 363.03 25.7601 363.01 25.8401C363.01 25.8901 362.99 25.9701 362.98 26.0101C363.04 26.0301 363.109 26.0401 363.169 26.0301C363.289 26.0001 363.4 25.9301 363.49 25.8401C363.73 25.5401 364.049 25.3101 364.419 25.1801C364.799 25.0501 365.13 24.7901 365.35 24.4501C365.38 24.4001 365.43 24.3701 365.49 24.3601C365.67 24.3301 365.86 24.3601 366.01 24.4501C366.16 24.5801 366.139 24.9001 366.109 25.0501C366.059 25.2801 365.99 25.5001 365.91 25.7201C365.89 25.7801 365.87 25.8501 365.85 25.9101L365.91 25.9601C366.02 26.0501 366.13 26.1501 366.22 26.2601C366.27 26.3301 366.31 26.4101 366.32 26.4901C366.37 26.4501 366.42 26.4001 366.46 26.3401C366.51 26.2501 366.55 26.1501 366.57 26.0501C366.58 26.0001 366.6 25.9501 366.62 25.9001C366.63 25.8601 366.67 25.8301 366.71 25.8201C366.75 25.8201 366.8 25.8301 366.82 25.8701C366.85 25.9101 366.88 25.9501 366.91 25.9901C367 26.0801 367.07 26.2001 367.1 26.3201C367.18 26.9301 367.31 27.5301 367.48 28.1201C367.65 28.3001 367.79 28.5101 367.88 28.7401C367.88 28.7401 367.919 28.8001 367.919 28.8301C367.949 28.9101 367.96 28.9501 367.97 28.9601C367.99 29.0001 367.98 29.0401 367.95 29.0801C367.92 29.1101 367.88 29.1301 367.84 29.1201C367.8 29.1201 367.76 29.0801 367.75 29.0401C367.75 29.0101 367.73 28.9901 367.72 28.9601C367.7 28.9601 367.68 28.9501 367.66 28.9401C367.46 28.7601 367.32 28.5201 367.27 28.2501H367.25C367.24 28.2501 367.22 28.2501 367.21 28.2601C367.18 28.3101 367.139 28.3601 367.109 28.4101C367.039 28.5101 366.969 28.6101 366.919 28.7201C366.889 28.8101 366.869 28.9001 366.859 28.9901C366.929 28.9501 367.01 28.9301 367.09 28.9301C367.13 28.9301 367.16 28.9401 367.19 28.9701C367.26 29.0401 367.28 29.2001 367.28 29.6401C367.3 29.6401 367.32 29.6401 367.34 29.6501C367.45 29.7001 367.45 29.8101 367.4 30.6901C367.39 30.8801 367.38 31.1201 367.37 31.3001C367.4 31.3201 367.43 31.3401 367.46 31.3601C367.48 31.3801 367.51 31.3901 367.53 31.4101C367.56 31.4301 367.58 31.4601 367.58 31.5001C367.58 31.5401 367.58 31.5701 367.54 31.6001L367.49 31.6401C367.49 31.6401 367.41 31.7201 367.37 31.7501C367.33 31.7801 367.28 31.7801 367.23 31.7601C367.19 31.7401 367.17 31.7101 367.16 31.6701C367.14 31.9601 367.12 32.2501 367.12 32.4501C367.15 32.4001 367.18 32.3501 367.2 32.3201C367.3 32.1601 367.39 32.0101 367.51 31.9601C367.85 31.8401 368.22 31.8601 368.55 32.0001C368.68 32.0601 368.78 32.1801 368.82 32.3201C368.83 32.3601 368.82 32.4101 368.79 32.4401C368.76 32.4701 368.709 32.4801 368.669 32.4701C368.629 32.4601 368.6 32.4201 368.59 32.3801C368.57 32.3001 368.51 32.2401 368.44 32.2101C368.17 32.1001 367.87 32.0901 367.59 32.1801C367.51 32.2601 367.44 32.3501 367.4 32.4501C367.3 32.6301 367.2 32.8001 367.06 32.8301C367.02 32.8301 366.98 32.8301 366.95 32.8101C366.88 32.7501 366.87 32.7001 366.95 31.4201C366.99 30.9101 367.03 30.2201 367.01 30.0701C366.99 30.0201 367 29.9801 367.01 29.9401C367.02 29.9201 367.03 29.9001 367.04 29.8901C367.04 29.6601 367.04 29.4201 367.03 29.1901C366.98 29.2101 366.93 29.2301 366.88 29.2501C366.84 29.2701 366.8 29.2901 366.76 29.3101C366.72 29.3301 366.68 29.3101 366.65 29.2901C366.62 29.2601 366.599 29.2201 366.609 29.1801C366.609 29.1301 366.63 29.0801 366.63 29.0301C366.64 28.9001 366.67 28.7701 366.71 28.6501C366.77 28.5201 366.84 28.4001 366.93 28.2901C366.95 28.2601 366.98 28.2301 367 28.1901C367 28.1801 367 28.1701 367.02 28.1601C367.07 28.1001 367.13 28.0501 367.21 28.0401C367.06 27.4901 366.95 26.9301 366.87 26.3701C366.85 26.3001 366.82 26.2401 366.77 26.1901C366.74 26.2901 366.7 26.3801 366.65 26.4701C366.59 26.5601 366.509 26.6401 366.419 26.7101C366.389 26.7401 366.36 26.7601 366.33 26.7901C366.3 26.8201 366.26 26.8301 366.22 26.8201C366.18 26.8201 366.15 26.7801 366.14 26.7501C366.13 26.7101 366.12 26.6701 366.1 26.6201C366.09 26.5501 366.06 26.4801 366.02 26.4201C365.94 26.3201 365.84 26.2301 365.74 26.1501L365.71 26.1201L365.68 26.1601C365.61 26.2701 365.54 26.3701 365.46 26.4801C365.43 26.5201 365.41 26.5601 365.38 26.6101C365.33 26.7501 365.22 26.8601 365.08 26.9201C364.96 26.9501 364.84 26.9201 364.74 26.8501C364.57 26.7301 364.46 26.5301 364.45 26.3201C364.41 26.0901 364.47 25.8501 364.62 25.6701C364.77 25.5801 364.939 25.5601 365.109 25.6201C365.269 25.6701 365.42 25.7201 365.57 25.7901L365.64 25.8201C365.66 25.7701 365.68 25.7201 365.69 25.6701C365.77 25.4601 365.83 25.2401 365.88 25.0301C365.92 24.9101 365.909 24.7701 365.859 24.6501C365.759 24.6101 365.64 24.5901 365.53 24.6101C365.29 24.9901 364.93 25.2701 364.51 25.4101C364.18 25.5301 363.889 25.7301 363.669 26.0001C363.559 26.1301 363.41 26.2301 363.24 26.2801C363.1 26.3201 362.95 26.3001 362.82 26.2301C362.71 26.1701 362.74 26.0201 362.78 25.8501C362.8 25.7501 362.82 25.6601 362.84 25.5701C362.88 25.4201 362.91 25.2601 362.93 25.1101C362.9 25.0801 362.88 25.0501 362.85 25.0201C362.85 25.0201 362.81 25.0501 362.79 25.0701C362.76 25.4101 362.6 25.5801 362.22 25.6801C361.93 25.7501 361.76 25.8401 361.69 25.9601C361.63 26.1201 361.63 26.3001 361.71 26.4601C361.79 26.6701 361.88 26.8801 362 27.0801C362.04 27.1501 362.069 27.2101 362.109 27.2801L362.55 27.2201C362.55 27.2201 362.61 27.2201 362.64 27.2501C362.66 27.2701 362.68 27.3001 362.68 27.3301C362.68 27.3501 362.68 27.3701 362.68 27.3901C362.68 27.4701 362.7 27.5701 362.62 27.6201C362.18 27.9201 362.07 28.2201 362.25 28.6401C362.32 28.8101 361.94 29.0001 361.89 29.0201L361.79 29.0701C361.62 29.1701 361.43 29.2401 361.23 29.2701C361.03 29.2801 360.899 29.3301 360.859 29.3901C360.799 29.4901 360.93 29.7301 361 29.8701C361.07 30.0001 361.15 30.1201 361.24 30.2401C361.5 30.6001 361.64 30.7801 361.6 30.9601C361.57 31.1401 361.39 31.2601 361.04 31.4901L361 31.5101C360.87 31.6001 360.77 31.7201 360.73 31.8701C360.81 32.0301 360.95 32.1501 361.13 32.2101C361.3 32.2301 361.47 32.2301 361.63 32.1901H361.7C361.65 32.1001 361.6 32.0101 361.58 31.9201C361.57 31.8301 361.59 31.7301 361.65 31.6601C361.66 31.6401 361.68 31.6101 361.69 31.5901C361.7 31.5501 361.74 31.5301 361.77 31.5201C361.81 31.5201 361.85 31.5201 361.87 31.5501C361.9 31.5701 361.92 31.6001 361.95 31.6201C362.04 31.6901 362.14 31.7701 362.14 31.8801C362.14 32.0001 362.09 32.1101 362.02 32.2101L361.99 32.2601C361.99 32.2601 361.99 32.3201 361.97 32.3501C361.95 32.3801 361.93 32.3901 361.9 32.4001C361.81 32.5901 361.789 32.8101 361.859 33.0201C361.959 33.3201 361.9 33.6501 361.71 33.9001C361.8 33.9601 361.87 34.0601 361.88 34.1801C361.9 34.3601 361.75 34.4901 361.62 34.6201C361.59 34.6501 361.56 34.6801 361.53 34.7101C361.51 34.7301 361.48 34.7401 361.45 34.7401L361.44 34.6501ZM361.81 31.7401C361.81 31.7401 361.79 31.7801 361.79 31.8001C361.81 31.8501 361.829 31.9001 361.859 31.9501C361.889 31.9101 361.9 31.8601 361.91 31.8201C361.88 31.7901 361.85 31.7701 361.82 31.7401H361.81ZM364.87 25.7801C364.87 25.7801 364.8 25.7801 364.77 25.8001C364.67 25.9301 364.63 26.1001 364.66 26.2601C364.66 26.4001 364.73 26.5301 364.84 26.6201C364.89 26.6501 364.95 26.6701 365.01 26.6601C365.07 26.6401 365.119 26.5501 365.169 26.4601C365.199 26.4101 365.23 26.3601 365.26 26.3101C365.33 26.2101 365.4 26.1101 365.47 26.0001L365.49 25.9701H365.46C365.32 25.8901 365.18 25.8401 365.04 25.8001C364.99 25.7901 364.93 25.7801 364.88 25.7801H364.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M349.409 21.75C349.409 21.67 349.449 21.59 349.519 21.54C349.919 21.35 348.569 22.31 348.629 21.96C348.689 21.57 347.969 21.35 347.669 21.58C347.319 21.85 348.769 20.59 348.339 20.56C348.219 20.55 348.089 20.67 347.969 20.75C347.589 21.01 347.219 21.22 346.789 20.83C346.579 20.64 347.219 20.57 346.919 20.68C346.829 20.71 346.669 20.59 346.549 20.52C346.509 20.5 346.499 20.41 346.469 20.36C346.529 20.34 345.679 19.4 345.739 19.4C345.949 19.4 346.159 19.4201 346.379 19.4501C348.529 19.7101 347.449 21.51 346.749 19C346.849 19.02 346.959 19.02 347.059 19C347.139 18.97 347.199 18.88 347.249 18.8C347.259 18.78 347.219 18.6901 347.209 18.7001C347.119 18.7001 347.029 18.7201 346.939 18.7601C346.869 18.8301 346.809 18.9201 346.759 19.0101C346.619 18.9701 346.479 18.92 346.339 18.86C346.249 18.78 346.159 18.7 346.089 18.6C346.179 18.56 346.279 18.53 346.359 18.49C346.759 18.29 346.259 18.1 346.659 17.9C346.869 17.8 346.909 17.68 346.689 17.54C346.389 17.35 346.509 17.23 346.759 17.1C347.139 16.9 347.489 16.65 347.869 16.49C348.259 16.34 348.669 16.22 349.079 16.14C349.149 16.12 349.249 16.26 349.339 16.33C349.249 16.39 349.169 16.4901 349.069 16.5101C348.949 16.5401 348.809 16.4701 348.689 16.5101C348.589 16.5401 348.449 16.63 348.439 16.71C348.439 16.82 348.509 16.93 348.609 16.99C348.929 17.19 349.279 16.46 349.599 16.65C349.759 16.75 349.909 16.87 350.049 16.98C350.099 16.81 350.089 17.4801 350.209 17.3801C350.519 17.1101 350.719 16.7301 350.769 16.3201C350.789 16.2101 351.069 16.16 351.219 16.06C351.459 15.89 351.459 16.2 351.589 16.23C351.769 16.23 351.929 16.33 352.029 16.49C352.119 16.64 352.139 16.83 352.059 17C352.059 17.02 352.179 17.12 352.229 17.12C352.309 17.12 352.369 17.0301 352.449 17.0101C352.589 16.9601 352.729 16.9401 352.869 16.9501C352.919 16.9601 352.919 17.18 352.949 17.3C352.959 17.36 352.989 17.42 353.019 17.48C353.249 17.8 353.109 17.87 352.789 17.85C352.679 17.85 352.579 17.85 352.479 17.89C352.349 17.95 352.219 18.03 352.099 18.11C352.199 18.17 352.299 18.24 352.409 18.3C353.099 18.7 353.379 19.56 353.039 20.29C352.979 20.35 352.889 20.37 352.809 20.35C352.289 20 351.829 20.45 351.349 20.48C351.299 20.48 351.219 20.61 351.229 20.68C351.249 20.77 351.309 20.85 351.379 20.91C351.479 21 351.629 21.05 351.709 21.15C351.769 21.23 351.759 21.36 351.779 21.47C351.639 21.48 351.459 21.55 351.379 21.49C351.229 21.35 351.089 21.19 350.959 21.02C350.929 20.99 350.789 20.99 350.789 21C350.699 21.5 350.239 21.54 349.899 21.73C349.829 21.77 349.749 21.81 349.669 21.84L349.409 21.75ZM351.049 17.3L351.259 17.66C351.339 17.59 351.499 17.49 351.479 17.46C351.409 17.28 351.319 17.1101 351.219 16.9501L351.049 17.31V17.3Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M348.679 22.22C348.679 22.22 348.619 22.2201 348.589 22.2001C348.489 22.1601 348.429 22.0501 348.449 21.9401C348.459 21.8601 348.369 21.7901 348.319 21.7601C348.159 21.6601 347.949 21.64 347.779 21.73C347.729 21.76 347.589 21.8701 347.479 21.7401C347.369 21.6101 347.469 21.51 347.609 21.36C347.769 21.2 347.909 21.0601 348.009 20.9401C347.639 21.3001 347.059 21.31 346.669 20.96C346.599 20.91 346.559 20.8301 346.559 20.7401L346.519 20.71L346.459 20.67C346.389 20.62 346.339 20.55 346.319 20.46C346.319 20.44 346.309 20.42 346.299 20.4C346.259 20.33 346.049 20.08 345.909 19.92C345.519 19.45 345.509 19.4401 345.569 19.3201C345.609 19.2601 345.669 19.22 345.739 19.22C345.959 19.22 346.169 19.24 346.389 19.27C346.479 19.28 346.569 19.3001 346.649 19.3101C346.629 19.2601 346.619 19.21 346.599 19.15H346.579C346.459 19.11 346.349 19.07 346.249 19.02C346.159 18.96 346.089 18.8901 346.019 18.8001C345.999 18.7701 345.979 18.75 345.959 18.72C345.919 18.68 345.899 18.6201 345.919 18.5601C345.929 18.5001 345.969 18.4601 346.029 18.4301L346.119 18.4C346.179 18.38 346.239 18.36 346.289 18.33C346.319 18.32 346.339 18.3 346.359 18.28C346.359 18.28 346.349 18.2501 346.349 18.2401C346.309 18.1401 346.319 18.0301 346.369 17.9401C346.419 17.8501 346.499 17.7701 346.599 17.7401C346.619 17.7401 346.629 17.72 346.649 17.71L346.619 17.6901C346.469 17.6201 346.379 17.4801 346.359 17.3201C346.369 17.1201 346.579 17.0101 346.699 16.9501C346.849 16.8701 346.989 16.7901 347.129 16.7001C347.349 16.5601 347.589 16.43 347.829 16.33C348.219 16.18 348.619 16.06 349.029 15.98C349.169 15.96 349.319 16.0101 349.409 16.1301C349.429 16.1501 349.459 16.1801 349.479 16.1901C349.559 16.2501 349.569 16.3601 349.519 16.4401C349.589 16.4401 349.659 16.4601 349.729 16.5001C349.849 16.5701 349.959 16.6501 350.069 16.7401L350.119 16.78C350.269 16.79 350.289 16.9201 350.309 17.0601C350.479 16.8401 350.589 16.57 350.629 16.29C350.659 16.13 350.819 16.0601 350.979 16.0001C351.039 15.9801 351.099 15.95 351.149 15.92C351.229 15.86 351.329 15.83 351.429 15.84C351.529 15.87 351.619 15.94 351.659 16.03C351.659 16.05 351.679 16.06 351.689 16.08C351.909 16.11 352.099 16.23 352.219 16.42C352.299 16.57 352.329 16.74 352.299 16.91C352.339 16.88 352.389 16.85 352.449 16.84H352.499C352.649 16.77 352.809 16.76 352.959 16.78C353.109 16.81 353.139 16.9701 353.159 17.1301C353.159 17.1701 353.169 17.2201 353.179 17.2601C353.179 17.3001 353.199 17.3401 353.219 17.3701C353.279 17.4501 353.439 17.67 353.339 17.86C353.239 18.05 352.959 18.03 352.839 18.02C352.759 18.02 352.679 18.0201 352.609 18.0501C352.569 18.0701 352.539 18.08 352.499 18.1C352.519 18.11 352.539 18.12 352.559 18.14C353.329 18.59 353.639 19.55 353.259 20.36C353.209 20.44 353.139 20.4901 353.049 20.5101C352.959 20.5401 352.859 20.5301 352.769 20.4901C352.519 20.3201 352.299 20.3901 351.959 20.5101C351.799 20.5701 351.639 20.62 351.469 20.65C351.469 20.65 351.469 20.6701 351.459 20.6801C351.459 20.6701 351.489 20.72 351.549 20.77C351.589 20.8 351.629 20.83 351.669 20.85C351.759 20.9 351.839 20.96 351.909 21.04C351.969 21.13 351.999 21.24 351.999 21.35C351.999 21.38 351.999 21.4101 352.009 21.4401C352.009 21.4901 352.009 21.54 351.979 21.58C351.949 21.62 351.899 21.65 351.849 21.65C351.809 21.65 351.769 21.66 351.729 21.67C351.599 21.72 351.449 21.71 351.319 21.64C351.199 21.55 351.099 21.4401 351.019 21.3201C350.999 21.2901 350.979 21.2601 350.959 21.2401C350.819 21.5001 350.579 21.69 350.299 21.78C350.209 21.81 350.129 21.85 350.049 21.9C349.969 21.95 349.889 21.99 349.799 22.02C349.759 22.04 349.709 22.04 349.659 22.02C349.619 22 349.579 21.97 349.559 21.92C349.559 21.91 349.559 21.9 349.549 21.89C349.509 21.92 349.469 21.9301 349.429 21.9401C349.419 21.9401 349.399 21.9401 349.389 21.9401C349.189 22.0901 348.949 22.1901 348.699 22.2401L348.679 22.22ZM348.139 21.33C348.269 21.35 348.389 21.3901 348.499 21.4501C348.649 21.5301 348.759 21.67 348.799 21.83C348.969 21.75 349.129 21.6501 349.279 21.5501C349.309 21.4801 349.369 21.4201 349.439 21.3801C349.489 21.3501 349.629 21.29 349.729 21.4C349.779 21.46 349.779 21.5501 349.739 21.6201C349.769 21.6001 349.809 21.5901 349.839 21.5701C349.929 21.5201 350.029 21.4701 350.129 21.4301C350.419 21.3101 350.589 21.22 350.639 20.96C350.649 20.89 350.699 20.8401 350.759 20.8201C350.879 20.7901 351.009 20.82 351.109 20.89C351.169 20.95 351.219 21.02 351.269 21.09C351.329 21.18 351.409 21.27 351.499 21.34C351.529 21.33 351.569 21.3201 351.599 21.3201C351.599 21.3001 351.599 21.2701 351.589 21.2501C351.549 21.2101 351.509 21.18 351.459 21.15C351.399 21.12 351.339 21.08 351.289 21.04C351.179 20.96 351.109 20.8401 351.079 20.7001C351.079 20.5901 351.109 20.49 351.179 20.41C351.219 20.35 351.289 20.3101 351.369 20.3001C351.519 20.2801 351.669 20.2401 351.819 20.1801C352.159 20.0001 352.569 20.0001 352.919 20.1801H352.939C353.209 19.5401 352.959 18.8 352.359 18.46C352.289 18.42 352.209 18.3701 352.139 18.3201L352.049 18.2601C351.999 18.2301 351.959 18.17 351.959 18.11C351.959 18.05 351.989 17.99 352.049 17.96L352.159 17.89C352.249 17.83 352.349 17.77 352.449 17.73C352.579 17.68 352.709 17.66 352.839 17.67C352.879 17.67 352.929 17.67 352.969 17.67C352.949 17.64 352.929 17.61 352.909 17.58C352.859 17.51 352.829 17.43 352.809 17.34C352.799 17.28 352.789 17.23 352.779 17.17V17.1201C352.699 17.1301 352.639 17.15 352.569 17.17H352.519C352.519 17.17 352.489 17.2 352.469 17.21C352.409 17.26 352.339 17.2901 352.259 17.3001C352.139 17.3001 352.019 17.23 351.949 17.14C351.909 17.09 351.899 17.02 351.909 16.96C351.959 16.85 351.949 16.72 351.909 16.6C351.829 16.5 351.709 16.43 351.579 16.41C351.479 16.38 351.399 16.31 351.359 16.22C351.279 16.26 351.199 16.29 351.119 16.33C351.069 16.35 351.029 16.37 350.979 16.39C350.919 16.83 350.699 17.23 350.359 17.52C350.299 17.57 350.219 17.5801 350.149 17.5601C350.009 17.5101 349.979 17.3401 349.959 17.1301V17.11C349.959 17.11 349.879 17.05 349.839 17.02C349.749 16.94 349.649 16.8701 349.539 16.8101C349.489 16.7801 349.379 16.86 349.249 16.97C349.069 17.12 348.819 17.32 348.549 17.15C348.389 17.05 348.289 16.8801 348.299 16.6901C348.309 16.6201 348.349 16.56 348.389 16.52C348.249 16.56 348.109 16.61 347.969 16.67C347.749 16.77 347.529 16.89 347.319 17.02C347.169 17.11 347.019 17.2 346.869 17.28C346.829 17.3 346.789 17.33 346.749 17.35C346.769 17.37 346.799 17.39 346.819 17.41C346.949 17.47 347.039 17.6101 347.039 17.7501C347.029 17.9401 346.829 18.0401 346.759 18.0701C346.729 18.0801 346.709 18.1001 346.689 18.1201C346.689 18.1201 346.699 18.15 346.699 18.17C346.739 18.27 346.729 18.38 346.679 18.47C346.629 18.56 346.549 18.64 346.449 18.67C346.429 18.67 346.409 18.6901 346.389 18.7001C346.399 18.7101 346.419 18.72 346.429 18.73C346.509 18.77 346.589 18.8001 346.669 18.8201C346.709 18.7501 346.759 18.69 346.819 18.64C346.909 18.58 347.019 18.5501 347.119 18.5501H347.169C347.249 18.5501 347.319 18.58 347.359 18.65C347.419 18.73 347.429 18.8501 347.379 18.9401C347.319 19.0601 347.219 19.1501 347.099 19.2001C347.059 19.2101 347.019 19.22 346.979 19.22C347.009 19.3 347.039 19.3801 347.059 19.4501C347.629 19.6701 347.809 20.01 347.809 20.21C347.819 20.36 347.709 20.4901 347.569 20.5101C347.359 20.5401 347.059 20.3401 346.799 19.7401C346.649 19.7001 346.499 19.67 346.339 19.65C346.259 19.65 346.179 19.6301 346.109 19.6201C346.139 19.6501 346.159 19.68 346.189 19.71C346.559 20.16 346.649 20.27 346.649 20.35V20.3701C346.649 20.3701 346.659 20.38 346.659 20.39L346.699 20.42C346.699 20.42 346.769 20.46 346.799 20.48C346.869 20.46 346.939 20.45 347.009 20.46C347.089 20.48 347.149 20.5501 347.159 20.6301C347.159 20.7101 347.119 20.7801 347.049 20.8201C347.289 20.9501 347.509 20.85 347.849 20.61L347.909 20.5701C348.029 20.4601 348.179 20.4 348.329 20.39C348.429 20.39 348.519 20.4601 348.559 20.5501C348.619 20.7101 348.509 20.91 348.119 21.34L348.139 21.33ZM348.619 16.78C348.619 16.78 348.679 16.84 348.709 16.85C348.759 16.88 348.849 16.81 348.969 16.71C348.929 16.71 348.899 16.7101 348.859 16.7001C348.819 16.7001 348.779 16.6901 348.739 16.7001C348.689 16.7101 348.649 16.74 348.609 16.78H348.619ZM351.289 17.84C351.289 17.84 351.269 17.84 351.259 17.84C351.209 17.84 351.159 17.8001 351.129 17.7501L350.919 17.39C350.889 17.34 350.889 17.28 350.919 17.22L351.089 16.86C351.119 16.8 351.179 16.7601 351.249 16.7601C351.319 16.7601 351.379 16.79 351.409 16.85L351.479 16.98C351.559 17.11 351.619 17.25 351.679 17.39C351.729 17.54 351.609 17.63 351.489 17.72C351.459 17.74 351.429 17.76 351.409 17.78C351.379 17.81 351.329 17.8301 351.289 17.8201V17.84Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M350.28 16.5401C350.12 16.5701 350.02 16.6201 349.99 16.6001C349.93 16.5201 349.88 16.4201 349.85 16.3301C349.85 16.3301 349.96 16.2501 349.98 16.2601C350.09 16.3501 350.19 16.4401 350.29 16.5401H350.28Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M350.009 16.7901C349.949 16.7901 349.899 16.7701 349.859 16.7301C349.789 16.6401 349.729 16.5401 349.689 16.4401C349.639 16.3601 349.659 16.2501 349.729 16.1901C349.809 16.1301 349.949 16.0301 350.069 16.1201C350.149 16.1801 350.219 16.2501 350.289 16.3201L350.399 16.4201C350.399 16.4201 350.469 16.5301 350.449 16.6001C350.429 16.6601 350.379 16.7101 350.319 16.7301C350.269 16.7401 350.219 16.75 350.179 16.77C350.129 16.79 350.069 16.8001 350.009 16.8001V16.7901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M325.229 43.6001C325.229 43.6001 325.529 43.6001 325.559 43.6601C325.629 43.8401 325.669 44.0401 325.689 44.2301C325.549 44.2501 325.399 44.3201 325.279 44.2901L325.229 43.6001ZM324.989 36.7301C324.989 36.7301 325.069 36.7501 325.119 36.7301C325.309 36.6901 325.509 36.6501 325.699 36.6101C325.639 36.4201 325.569 36.2401 325.459 36.0601C325.329 35.8901 325.269 35.7801 325.509 35.6801C325.549 35.6601 325.579 35.6301 325.609 35.6001C326.139 35.0701 326.119 34.96 325.449 34.65C325.379 34.61 325.319 34.5601 325.269 34.5101C325.329 34.4701 325.399 34.4401 325.469 34.4201C326.079 34.3901 326.629 34.0601 326.939 33.5401C327.099 33.2501 327.049 33.1801 326.719 33.1701C326.529 33.1701 326.339 33.14 326.159 33.08C325.949 33.02 325.659 33 325.739 32.65C325.799 32.37 325.919 32.1101 326.259 32.1001C326.599 32.0801 326.939 32.1 327.279 32.08C327.399 32.08 327.579 31.98 327.599 31.89C327.619 31.76 327.559 31.6301 327.459 31.5501C327.199 31.4501 327.329 31.3801 327.419 31.2501C327.579 31.0201 327.879 30.7501 327.349 30.5901C327.349 30.5901 327.369 30.4101 327.419 30.3701C327.979 29.9701 328.639 29.7401 329.319 29.7001C329.509 29.6801 329.699 29.6901 329.889 29.6801C330.129 29.6701 330.409 29.7401 330.469 29.3601C330.469 29.3001 330.669 29.2601 330.779 29.2201C330.919 29.1801 331.059 29.1301 331.189 29.0701C331.239 29.0401 331.269 28.9301 331.279 28.8501C331.279 28.8301 331.179 28.7801 331.119 28.7801C330.969 28.7801 330.819 28.7701 330.679 28.7401C330.589 28.7101 330.529 28.5801 330.459 28.4901C330.539 28.4401 330.619 28.3401 330.699 28.3401C331.649 28.2401 332.589 28.0601 333.509 27.8101C333.749 27.7801 333.789 27.6601 333.749 27.4701C333.739 27.4101 333.709 27.3501 333.699 27.2801C333.639 26.9901 333.739 26.6901 333.969 26.5001C334.199 26.3101 334.509 26.2601 334.789 26.3801C335.019 26.4601 335.289 26.6701 335.489 26.4201C335.709 26.1601 335.489 25.9101 335.319 25.6901C335.209 25.5601 335.219 25.4501 335.409 25.4401C335.719 25.4301 336.029 25.44 336.339 25.46C336.549 25.48 336.789 25.64 336.949 25.58C337.439 25.39 337.489 25.6801 337.589 26.0301C337.739 26.5001 338.049 26.9001 338.459 27.1801C338.689 27.3501 338.909 27.42 339.119 27.15C339.169 27.08 339.239 27.0301 339.319 26.9901C339.479 26.9601 339.639 26.9401 339.809 26.9201C339.819 27.0801 339.899 27.28 339.829 27.39C339.659 27.76 339.589 28.1601 339.619 28.5701C339.619 28.7401 339.609 28.91 339.589 29.08C339.489 29.69 339.339 29.7901 338.799 29.4701C338.469 29.2701 338.429 29.52 338.259 29.64C337.939 29.87 338.279 29.96 338.349 30.08C338.479 30.32 338.669 30.5301 338.809 30.7601C338.869 30.8501 338.889 30.9601 338.869 31.0701C338.849 31.1801 338.779 31.2701 338.689 31.3201C338.569 31.4701 338.349 31.5001 338.189 31.3801C337.699 31.1201 337.129 31.0701 336.599 31.2501C335.829 31.4001 335.049 31.49 334.269 31.52C333.979 31.55 333.719 31.5101 333.739 31.9401C333.739 32.0801 333.529 32.2301 333.399 32.3601C333.189 32.5701 333.079 32.3401 332.929 32.2401C332.599 32.0001 332.459 32.0301 332.299 32.4201C332.179 32.7201 331.929 32.7301 331.689 32.7901C331.639 32.8001 331.599 32.86 331.549 32.9C331.599 32.94 331.659 32.9701 331.719 32.9901C331.869 33.0301 332.029 33.05 332.189 33.08C332.109 33.23 332.029 33.38 331.939 33.52C331.649 33.93 331.549 33.9101 331.109 33.7401C330.759 33.6001 330.389 33.5301 330.009 33.5101C329.549 33.5001 329.359 33.7901 329.519 34.2401C329.659 34.5901 329.839 34.9201 330.039 35.2401C330.089 35.3201 330.259 35.3401 330.379 35.3501C330.609 35.3701 330.849 35.3401 331.079 35.3701C331.169 35.3801 331.249 35.5001 331.329 35.5701C331.249 35.6501 331.169 35.8001 331.099 35.7901C330.679 35.7601 330.539 35.9301 330.559 36.3401C330.569 36.6401 330.369 36.7801 330.049 36.7501C329.759 36.6901 329.459 36.8201 329.299 37.0701C329.069 37.2801 328.789 37.4201 328.479 37.4801C328.099 37.6101 328.069 37.6601 328.329 37.9801C328.369 38.0301 328.419 38.0701 328.459 38.1201C328.579 38.2701 328.689 38.4201 328.809 38.5701C328.639 38.6001 328.469 38.65 328.309 38.71C328.209 38.77 328.129 38.8501 328.049 38.9301C327.819 39.1301 327.599 39.3401 327.349 39.5301C327.319 39.5501 327.139 39.4401 327.139 39.4301C327.259 39.1301 327.189 39.0901 326.919 39.2401C326.809 39.3001 326.679 39.3401 326.559 39.3601C326.349 39.4001 326.099 39.3701 325.959 39.4901C325.839 39.5801 325.889 39.8601 325.819 40.0301C325.679 40.2801 325.739 40.5901 325.959 40.7801C326.049 40.8601 326.129 40.9701 326.169 41.0901C326.219 41.2501 326.229 41.4401 325.979 41.4701C325.569 41.5101 325.439 41.84 325.289 42.15C325.229 42.28 325.119 42.5501 325.479 42.3501C325.549 42.3301 325.629 42.3501 325.679 42.4101C325.709 42.4801 325.709 42.57 325.679 42.64C325.569 42.74 325.459 42.8401 325.339 42.9201C325.189 43.0401 325.059 43.18 324.949 43.33L324.989 36.7301ZM333.519 29.8401C333.179 29.6601 332.789 29.6301 332.419 29.7501C332.229 29.8101 332.089 30.0201 331.919 30.1701C332.059 30.3401 332.229 30.4801 332.419 30.6001C332.599 30.6401 332.779 30.6001 332.929 30.4901C333.139 30.2901 333.319 30.07 333.489 29.83L333.569 29.77L333.509 29.8401H333.519ZM329.459 31.5401C329.669 31.5201 329.919 31.51 329.959 31.21C329.989 31.01 329.459 30.63 329.199 30.65C328.949 30.67 328.989 30.8701 328.979 31.0301C328.979 31.4401 329.069 31.5401 329.459 31.5401ZM336.239 31.1701C336.369 31.0901 336.539 31.0401 336.549 30.9801C336.549 30.8501 336.489 30.7201 336.399 30.6201C336.309 30.5301 336.209 30.4601 336.089 30.4201C335.939 30.3701 335.789 30.3301 335.639 30.3001C335.659 30.5001 335.609 30.74 335.709 30.89C335.809 31.04 336.049 31.0801 336.239 31.1801V31.1701ZM327.999 36.2801L328.249 36.7201C328.489 36.5701 328.729 36.4001 328.949 36.2201C328.999 36.1801 328.949 35.9 328.899 35.89C328.679 35.83 328.449 35.8201 328.229 35.8601C328.129 35.8801 328.089 36.1101 327.999 36.2901V36.2801ZM328.579 33.7601C328.519 33.6501 328.419 33.4401 328.299 33.2401C328.259 33.1901 328.199 33.1701 328.139 33.1701C328.109 33.1701 328.069 33.2601 328.069 33.3101C328.069 33.6201 328.059 33.9401 328.079 34.2501C328.109 34.3401 328.179 34.4001 328.279 34.4201C328.379 34.4201 328.459 34.36 328.509 34.27C328.549 34.1 328.569 33.9301 328.569 33.7601H328.579ZM330.929 33.1001C331.099 32.9801 331.299 32.9201 331.339 32.8001C331.419 32.5201 331.189 32.51 330.989 32.52C330.769 32.53 330.469 32.4601 330.489 32.8201C330.489 32.9201 330.749 32.9901 330.929 33.1101V33.1001ZM330.689 32.27C330.789 32.12 330.879 31.9501 330.949 31.7801C330.949 31.6901 330.889 31.6101 330.809 31.5701C330.629 31.5501 330.459 31.6101 330.479 31.8401C330.479 31.9401 330.569 32.03 330.689 32.27ZM336.359 25.9501L336.209 26.08L336.499 26.2801C336.499 26.2801 336.579 26.16 336.569 26.14C336.509 26.07 336.429 26.0101 336.359 25.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M325.359 44.4101C325.359 44.4101 325.289 44.4101 325.249 44.3901C325.189 44.3701 325.159 44.3101 325.179 44.2501C325.199 44.1901 325.259 44.1601 325.319 44.1801C325.389 44.1801 325.459 44.1801 325.529 44.1501H325.559C325.559 44.1501 325.559 44.1001 325.549 44.0801C325.539 43.9601 325.509 43.8401 325.459 43.7201C325.399 43.7001 325.339 43.6901 325.279 43.6901C325.239 43.7101 325.199 43.7101 325.169 43.6901C325.119 43.6601 325.099 43.5901 325.129 43.5401C325.179 43.4801 325.249 43.4501 325.319 43.4701C325.369 43.4701 325.599 43.4901 325.659 43.6101C325.719 43.7501 325.759 43.9001 325.779 44.0501C325.779 44.1001 325.799 44.1601 325.809 44.2101C325.809 44.2401 325.809 44.2701 325.789 44.3001C325.769 44.3301 325.749 44.3401 325.709 44.3501C325.669 44.3501 325.629 44.3702 325.589 44.3802C325.519 44.4002 325.439 44.4201 325.359 44.4201V44.4101ZM324.919 43.4201C324.919 43.4201 324.839 43.4001 324.819 43.3601C324.799 43.3201 324.799 43.2801 324.819 43.2501C324.909 43.1101 325.019 42.9901 325.149 42.8901L325.229 42.8202C325.229 42.8202 325.329 42.7402 325.379 42.7002C325.439 42.6502 325.499 42.6001 325.559 42.5501C325.559 42.5201 325.559 42.4802 325.559 42.4502C325.559 42.4502 325.519 42.4502 325.499 42.4502C325.439 42.4902 325.259 42.5901 325.149 42.4901C325.039 42.3901 325.129 42.1901 325.169 42.1001L325.189 42.0501C325.329 41.7501 325.489 41.4001 325.949 41.3601C325.989 41.3601 326.029 41.3502 326.059 41.3202C326.069 41.3002 326.089 41.2502 326.059 41.1302C326.019 41.0302 325.959 40.9401 325.879 40.8701C325.629 40.6501 325.559 40.2901 325.709 40.0001C325.729 39.9301 325.749 39.8601 325.749 39.7801C325.749 39.6501 325.789 39.5101 325.879 39.4201C326.009 39.3301 326.169 39.2901 326.329 39.2901C326.399 39.2901 326.469 39.2802 326.529 39.2602C326.639 39.2402 326.759 39.2101 326.859 39.1601C326.989 39.0801 327.149 39.0101 327.249 39.1001C327.329 39.1701 327.319 39.2801 327.279 39.4001C327.289 39.4001 327.309 39.4201 327.319 39.4201C327.489 39.2801 327.659 39.1301 327.819 38.9801L327.969 38.8501C327.969 38.8501 328.019 38.8001 328.039 38.7801C328.099 38.7101 328.169 38.6501 328.259 38.6101C328.369 38.5701 328.489 38.5302 328.609 38.5102C328.529 38.4102 328.449 38.3002 328.369 38.2002C328.349 38.1802 328.329 38.1502 328.309 38.1302C328.289 38.1102 328.269 38.0801 328.249 38.0601C328.119 37.9001 328.019 37.7602 328.059 37.6302C328.099 37.5002 328.239 37.4502 328.449 37.3802L328.559 37.3401C328.799 37.2901 329.029 37.1802 329.209 37.0102C329.389 36.7302 329.729 36.5801 330.059 36.6501C330.169 36.6701 330.279 36.6501 330.369 36.5801C330.429 36.5201 330.449 36.4401 330.439 36.3601C330.409 36.1701 330.469 35.9702 330.589 35.8202C330.729 35.7102 330.919 35.6601 331.099 35.6901C331.099 35.6901 331.129 35.6301 331.159 35.6001V35.5801C331.159 35.5801 331.069 35.4901 331.049 35.4901C330.919 35.4801 330.799 35.4701 330.669 35.4801C330.559 35.4801 330.459 35.4801 330.349 35.4801C330.169 35.4701 329.999 35.4402 329.919 35.3202C329.709 35.0002 329.529 34.6601 329.379 34.3001C329.279 34.0901 329.289 33.8501 329.409 33.6501C329.539 33.4901 329.739 33.4001 329.949 33.4201H329.979C330.369 33.4301 330.759 33.5101 331.119 33.6501C331.529 33.8101 331.569 33.8301 331.819 33.4701C331.879 33.3801 331.939 33.2801 331.989 33.1901C331.879 33.1701 331.779 33.1502 331.669 33.1302C331.609 33.1102 331.559 33.0901 331.519 33.0501C331.509 33.0401 331.489 33.0301 331.479 33.0201C331.449 33.0001 331.429 32.9701 331.419 32.9301C331.419 32.8901 331.429 32.8601 331.459 32.8301C331.469 32.8201 331.479 32.8101 331.489 32.8001C331.529 32.7501 331.579 32.7102 331.639 32.7002L331.729 32.6801C331.939 32.6401 332.089 32.6101 332.169 32.4001C332.239 32.2301 332.329 32.0602 332.489 32.0102C332.669 31.9902 332.839 32.0501 332.969 32.1701C333.009 32.2001 333.039 32.2302 333.079 32.2602C333.189 32.3702 333.209 32.3801 333.299 32.3001C333.329 32.2701 333.359 32.2401 333.389 32.2101C333.459 32.1401 333.599 32.0201 333.599 31.9701C333.579 31.4701 333.899 31.4501 334.149 31.4401H334.239C334.409 31.4201 334.579 31.4101 334.749 31.3901C335.199 31.3601 335.649 31.3201 336.099 31.2501C336.059 31.2301 336.009 31.2102 335.969 31.2002C335.809 31.1602 335.679 31.0702 335.569 30.9502C335.499 30.8102 335.469 30.6501 335.489 30.4901C335.489 30.4301 335.489 30.3701 335.489 30.3101C335.489 30.2701 335.499 30.2401 335.529 30.2101C335.559 30.1901 335.599 30.1801 335.629 30.1901C335.669 30.2001 335.719 30.2101 335.759 30.2201C335.869 30.2401 335.979 30.2802 336.089 30.3202C336.229 30.3702 336.349 30.4501 336.449 30.5601C336.549 30.6801 336.619 30.8301 336.619 30.9901C336.619 31.0901 336.519 31.1402 336.409 31.2002C336.459 31.1902 336.509 31.1801 336.559 31.1701C337.109 30.9901 337.719 31.0401 338.229 31.3101C338.389 31.4001 338.459 31.3802 338.599 31.2602C338.759 31.1202 338.789 31.0001 338.699 30.8401C338.639 30.7401 338.569 30.6401 338.499 30.5501C338.399 30.4201 338.309 30.2901 338.229 30.1501C338.209 30.1301 338.189 30.1101 338.159 30.0901C338.069 30.0401 337.999 29.9401 337.989 29.8301C337.999 29.7201 338.069 29.6202 338.169 29.5702C338.199 29.5402 338.239 29.5101 338.259 29.4801C338.319 29.3901 338.409 29.3201 338.519 29.3001C338.629 29.2801 338.739 29.3201 338.819 29.3901C339.049 29.5301 339.189 29.5801 339.259 29.5401C339.359 29.5001 339.409 29.2502 339.439 29.0702C339.459 28.9402 339.469 28.8201 339.469 28.6901V28.5801C339.469 28.5201 339.469 28.4501 339.469 28.3901C339.439 28.0301 339.519 27.6701 339.689 27.3501C339.709 27.2701 339.699 27.1901 339.679 27.1201V27.0702H339.639C339.529 27.0802 339.419 27.1001 339.309 27.1201C339.249 27.1401 339.209 27.1801 339.169 27.2401C339.079 27.3701 338.929 27.4501 338.769 27.4601C338.609 27.4701 338.459 27.4101 338.349 27.2901C337.919 27.0001 337.599 26.5701 337.439 26.0801L337.419 26.0201C337.369 25.8501 337.329 25.7101 337.239 25.6701C337.139 25.6401 337.029 25.6601 336.939 25.7101C336.799 25.7401 336.639 25.7301 336.509 25.6601C336.439 25.6301 336.359 25.6101 336.279 25.6001C335.979 25.5801 335.669 25.5701 335.359 25.5801C335.339 25.5801 335.319 25.5801 335.309 25.5801C335.329 25.6001 335.339 25.6201 335.359 25.6401L335.379 25.6601C335.549 25.8701 335.799 26.1902 335.519 26.5102C335.299 26.7702 335.029 26.6501 334.839 26.5601C334.789 26.5401 334.739 26.5201 334.699 26.5001C334.449 26.4101 334.169 26.4501 333.969 26.6201C333.789 26.7801 333.699 27.0301 333.759 27.2701C333.759 27.3001 333.769 27.3301 333.779 27.3601C333.779 27.3901 333.799 27.4202 333.799 27.4502C333.829 27.5602 333.819 27.6801 333.759 27.7801C333.689 27.8701 333.579 27.9201 333.469 27.9201C333.089 27.9801 332.709 28.0601 332.339 28.1701C331.789 28.3501 331.219 28.4502 330.639 28.4502C330.609 28.4702 330.589 28.4902 330.559 28.5102C330.589 28.5602 330.629 28.6201 330.659 28.6401C330.739 28.6601 330.819 28.6701 330.899 28.6701C330.959 28.6701 331.019 28.6701 331.079 28.6801C331.079 28.6801 331.359 28.7202 331.339 28.8802C331.319 29.0402 331.279 29.1401 331.199 29.1801C331.109 29.2301 331.009 29.2601 330.919 29.2901C330.869 29.3001 330.829 29.3201 330.779 29.3401C330.749 29.3501 330.709 29.3602 330.669 29.3802C330.619 29.3902 330.579 29.4101 330.529 29.4301C330.459 29.8201 330.159 29.8202 329.959 29.8202C329.919 29.8202 329.889 29.8202 329.849 29.8202C329.779 29.8202 329.709 29.8202 329.639 29.8202C329.519 29.8202 329.399 29.8201 329.279 29.8401C328.619 29.8801 327.979 30.1001 327.439 30.4801C327.439 30.5001 327.429 30.5201 327.429 30.5401C327.549 30.5801 327.659 30.6701 327.709 30.7801C327.759 30.9501 327.649 31.1101 327.539 31.2501C327.519 31.2801 327.489 31.3101 327.469 31.3401C327.449 31.3601 327.439 31.3901 327.419 31.4101L327.389 31.4502C327.389 31.4502 327.429 31.4701 327.459 31.4801C327.619 31.5801 327.699 31.7701 327.669 31.9601C327.589 32.1201 327.429 32.2201 327.249 32.2301C327.049 32.2501 326.859 32.2401 326.669 32.2501C326.519 32.2501 326.379 32.2501 326.229 32.2501C326.009 32.2601 325.889 32.3901 325.819 32.7201C325.779 32.9001 325.849 32.9401 326.079 32.9901C326.109 32.9901 326.139 33.0002 326.169 33.0102C326.339 33.0602 326.519 33.0901 326.699 33.0901C326.859 33.0901 327.019 33.1101 327.089 33.2301C327.149 33.3401 327.099 33.4702 327.009 33.6302C326.679 34.1902 326.099 34.5402 325.459 34.5702C325.459 34.5702 325.479 34.5801 325.489 34.5901C325.859 34.7601 326.059 34.8802 326.089 35.0702C326.119 35.2502 325.979 35.4401 325.689 35.7301C325.649 35.7701 325.599 35.8101 325.549 35.8301C325.469 35.8701 325.459 35.8901 325.459 35.8901C325.479 35.9401 325.509 36.0001 325.549 36.0401C325.629 36.1601 325.699 36.3001 325.739 36.4401C325.759 36.5001 325.779 36.5501 325.799 36.6101C325.809 36.6401 325.809 36.6801 325.799 36.7101C325.779 36.7401 325.759 36.7601 325.719 36.7701L325.569 36.8001C325.429 36.8301 325.279 36.8601 325.129 36.8901C325.059 36.9101 324.989 36.8901 324.929 36.8701C324.879 36.8401 324.859 36.7701 324.879 36.7201C324.909 36.6701 324.969 36.6401 325.029 36.6701C325.049 36.6701 325.069 36.6701 325.079 36.6701C325.219 36.6401 325.369 36.6101 325.509 36.5801H325.529L325.509 36.5201C325.479 36.4001 325.419 36.2801 325.349 36.1801C325.259 36.0901 325.209 35.9701 325.219 35.8401C325.259 35.7401 325.339 35.6602 325.439 35.6302C325.459 35.6202 325.489 35.6001 325.509 35.5801C325.699 35.3901 325.869 35.2101 325.849 35.1201C325.829 35.0301 325.609 34.9201 325.379 34.8101C325.319 34.7801 325.269 34.7402 325.229 34.7002C325.209 34.6802 325.199 34.6701 325.179 34.6501C325.149 34.6301 325.129 34.5901 325.139 34.5501C325.149 34.5101 325.169 34.4801 325.199 34.4601C325.219 34.4601 325.239 34.4401 325.249 34.4301C325.299 34.3901 325.359 34.3701 325.429 34.3601C325.999 34.3401 326.529 34.0301 326.819 33.5401C326.899 33.4001 326.899 33.3601 326.899 33.3601C326.839 33.3401 326.769 33.3401 326.699 33.3401C326.499 33.3401 326.299 33.3001 326.109 33.2501L326.029 33.2301C325.839 33.1801 325.509 33.1001 325.609 32.6901C325.679 32.4001 325.809 32.0701 326.229 32.0501C326.379 32.0501 326.529 32.0501 326.679 32.0501C326.869 32.0501 327.059 32.0501 327.249 32.0301C327.329 32.0301 327.409 31.9801 327.469 31.9201C327.469 31.8401 327.439 31.7701 327.389 31.7101C327.309 31.6801 327.199 31.6301 327.169 31.5301C327.159 31.4401 327.189 31.3501 327.249 31.2901C327.259 31.2701 327.279 31.2501 327.289 31.2301C327.309 31.2001 327.339 31.1702 327.359 31.1302C327.429 31.0402 327.509 30.9301 327.499 30.8701C327.499 30.8501 327.459 30.7901 327.279 30.7401C327.239 30.7301 327.209 30.6901 327.199 30.6501C327.199 30.6401 327.199 30.4002 327.309 30.3202C327.879 29.9102 328.559 29.6702 329.269 29.6302C329.389 29.6202 329.519 29.6201 329.639 29.6101C329.709 29.6101 329.779 29.6101 329.849 29.6101C329.889 29.6101 329.929 29.6101 329.969 29.6101C330.199 29.6101 330.289 29.6101 330.319 29.3901C330.339 29.2701 330.469 29.2301 330.609 29.1901C330.639 29.1801 330.679 29.1701 330.709 29.1601C330.759 29.1401 330.809 29.1301 330.859 29.1101C330.939 29.0901 331.019 29.0601 331.099 29.0201C331.099 29.0201 331.109 28.9802 331.119 28.9502C331.099 28.9502 331.079 28.9401 331.069 28.9301C331.019 28.9301 330.969 28.9301 330.919 28.9301C330.809 28.9301 330.709 28.9201 330.609 28.8901C330.519 28.8501 330.449 28.7701 330.399 28.6901C330.379 28.6601 330.359 28.6401 330.339 28.6101C330.319 28.5901 330.309 28.5501 330.309 28.5201C330.309 28.4901 330.329 28.4601 330.359 28.4401C330.379 28.4201 330.399 28.4101 330.429 28.3901C330.489 28.3201 330.579 28.2801 330.669 28.2701C331.229 28.2701 331.779 28.1701 332.299 28.0001C332.679 27.8801 333.069 27.8001 333.459 27.7401C333.509 27.7401 333.559 27.7201 333.599 27.6901C333.619 27.6401 333.619 27.5801 333.599 27.5301C333.599 27.5001 333.589 27.4802 333.579 27.4502C333.569 27.4102 333.559 27.3801 333.549 27.3401C333.479 27.0201 333.589 26.6901 333.839 26.4701C334.109 26.2501 334.469 26.1901 334.789 26.3101C334.839 26.3301 334.899 26.3502 334.949 26.3802C335.169 26.4802 335.269 26.5101 335.369 26.3901C335.509 26.2201 335.409 26.0602 335.219 25.8202L335.199 25.8001C335.089 25.6601 335.099 25.5601 335.129 25.5001C335.179 25.4101 335.279 25.3601 335.379 25.3701C335.689 25.3601 336.009 25.3701 336.319 25.3901C336.419 25.4001 336.509 25.4301 336.599 25.4601C336.689 25.5001 336.779 25.5202 336.879 25.5102C337.029 25.4302 337.209 25.4201 337.359 25.4801C337.529 25.5701 337.589 25.7601 337.649 25.9701L337.669 26.0301C337.819 26.4801 338.109 26.8601 338.499 27.1201C338.729 27.2901 338.869 27.2901 339.009 27.1101C339.069 27.0201 339.159 26.9501 339.269 26.9201C339.389 26.8901 339.509 26.8801 339.629 26.8701C339.679 26.8701 339.719 26.8701 339.769 26.8601C339.799 26.8601 339.829 26.8602 339.859 26.8802C339.879 26.9002 339.899 26.9301 339.899 26.9601C339.899 27.0101 339.909 27.0601 339.919 27.1001C339.959 27.2301 339.949 27.3701 339.899 27.4901C339.749 27.7801 339.689 28.0901 339.709 28.4101C339.709 28.4801 339.709 28.5401 339.709 28.6101V28.7201C339.709 28.8601 339.689 29.0002 339.669 29.1302C339.619 29.4502 339.549 29.6802 339.369 29.7602C339.179 29.8502 338.949 29.7301 338.719 29.6001C338.559 29.5001 338.529 29.5301 338.439 29.6401C338.399 29.6901 338.359 29.7301 338.309 29.7701C338.229 29.8301 338.219 29.8601 338.219 29.8601C338.239 29.8901 338.269 29.9101 338.299 29.9401C338.349 29.9701 338.389 30.0202 338.429 30.0702C338.499 30.2002 338.589 30.3201 338.679 30.4401C338.749 30.5401 338.829 30.6401 338.889 30.7501C338.959 30.8601 338.989 31.0002 338.959 31.1302C338.929 31.2602 338.849 31.3802 338.739 31.4502C338.579 31.6302 338.309 31.6601 338.109 31.5201C337.649 31.2701 337.099 31.2301 336.599 31.4101C335.989 31.5401 335.379 31.6201 334.759 31.6501C334.589 31.6601 334.419 31.6801 334.249 31.6901H334.149C333.899 31.7101 333.809 31.7201 333.809 32.0001C333.809 32.1601 333.669 32.2901 333.519 32.4201C333.489 32.4501 333.459 32.4701 333.429 32.5001C333.189 32.7401 332.999 32.5601 332.899 32.4601C332.869 32.4301 332.849 32.4101 332.819 32.3901C332.679 32.2901 332.589 32.2502 332.529 32.2602C332.479 32.2802 332.419 32.3601 332.359 32.5201C332.259 32.7601 332.019 32.9301 331.749 32.9401H331.699C331.799 32.9701 331.909 32.9902 332.009 33.0102L332.149 33.0301C332.149 33.0301 332.219 33.0601 332.229 33.0901C332.249 33.1201 332.239 33.1601 332.229 33.1901C332.199 33.2301 332.179 33.2801 332.159 33.3301C332.109 33.4401 332.049 33.5401 331.979 33.6401C331.659 34.0901 331.509 34.0901 331.009 33.8901C330.669 33.7601 330.309 33.6801 329.949 33.6701C329.809 33.6501 329.669 33.7001 329.569 33.8101C329.499 33.9501 329.499 34.1101 329.569 34.2501C329.709 34.5901 329.879 34.9201 330.079 35.2301C330.079 35.2301 330.119 35.2701 330.329 35.2801C330.429 35.2801 330.529 35.2801 330.629 35.2801C330.769 35.2801 330.899 35.2801 331.039 35.2901C331.139 35.3101 331.219 35.3702 331.279 35.4502C331.299 35.4702 331.319 35.5001 331.349 35.5201C331.369 35.5401 331.389 35.5701 331.389 35.6001C331.389 35.6301 331.379 35.6601 331.359 35.6801C331.339 35.7101 331.309 35.7302 331.289 35.7602C331.219 35.8502 331.149 35.9401 331.039 35.9401C330.919 35.9201 330.799 35.9402 330.699 36.0102C330.619 36.1202 330.589 36.2502 330.619 36.3802C330.629 36.5302 330.579 36.6701 330.479 36.7801C330.339 36.8901 330.159 36.9401 329.989 36.9101C329.739 36.8501 329.479 36.9601 329.339 37.1801C329.129 37.3901 328.869 37.5401 328.579 37.5901L328.469 37.6302C328.379 37.6502 328.299 37.6901 328.219 37.7401C328.259 37.8201 328.309 37.8901 328.369 37.9601C328.389 37.9801 328.409 38.0001 328.429 38.0201C328.449 38.0501 328.479 38.0701 328.499 38.1001C328.579 38.2101 328.669 38.3101 328.749 38.4201L328.849 38.5501C328.849 38.5501 328.879 38.6201 328.869 38.6501C328.859 38.6901 328.829 38.7101 328.789 38.7201C328.739 38.7301 328.689 38.7402 328.639 38.7602C328.529 38.7802 328.419 38.8101 328.309 38.8601C328.259 38.8901 328.209 38.9301 328.169 38.9801C328.139 39.0101 328.109 39.0401 328.089 39.0601L327.939 39.1901C327.759 39.3501 327.579 39.5101 327.389 39.6701C327.289 39.7501 327.119 39.6301 327.049 39.5801C327.009 39.5501 326.989 39.4901 327.009 39.4401C327.019 39.4101 327.039 39.3701 327.049 39.3401C327.029 39.3501 326.989 39.3701 326.949 39.3901C326.829 39.4501 326.699 39.4901 326.569 39.5201C326.489 39.5401 326.409 39.5501 326.329 39.5501C326.219 39.5501 326.099 39.5702 325.999 39.6302C325.969 39.6602 325.959 39.7601 325.949 39.8401C325.949 39.9401 325.929 40.0302 325.889 40.1302C325.769 40.3402 325.819 40.6001 326.009 40.7501C326.119 40.8501 326.199 40.9701 326.249 41.1101C326.299 41.2301 326.289 41.3701 326.229 41.4901C326.169 41.5801 326.069 41.6302 325.959 41.6302C325.629 41.6602 325.519 41.9101 325.389 42.1901L325.369 42.2401C325.369 42.2401 325.339 42.3001 325.329 42.3301C325.349 42.3301 325.369 42.3101 325.389 42.3001C325.449 42.2701 325.519 42.2701 325.579 42.2901C325.649 42.3001 325.709 42.3401 325.749 42.4001C325.809 42.5101 325.799 42.6502 325.729 42.7602C325.669 42.8302 325.589 42.8902 325.519 42.9502C325.469 42.9802 325.429 43.0201 325.379 43.0601L325.299 43.1401C325.189 43.2301 325.089 43.3302 325.009 43.4502C324.989 43.4802 324.949 43.5001 324.909 43.5001L324.919 43.4201ZM335.719 30.4101V30.4601C335.709 30.5701 335.719 30.6901 335.759 30.7901C335.839 30.8701 335.939 30.9301 336.059 30.9601C336.109 30.9801 336.159 31.0001 336.199 31.0201C336.229 31.0001 336.259 30.9901 336.289 30.9701C336.319 30.9501 336.369 30.9301 336.399 30.9201C336.379 30.8301 336.339 30.7401 336.279 30.6701C336.209 30.5901 336.109 30.5301 336.009 30.5001C335.919 30.4601 335.819 30.4401 335.719 30.4201V30.4101ZM328.219 36.8101H328.199C328.169 36.8101 328.139 36.7802 328.129 36.7602L327.879 36.3202C327.879 36.3202 327.859 36.2501 327.879 36.2101C327.909 36.1501 327.929 36.1001 327.949 36.0401C328.009 35.8901 328.059 35.7501 328.179 35.7301C328.419 35.6901 328.659 35.7002 328.899 35.7602C328.979 35.7802 329.009 35.8601 329.029 35.9401C329.059 36.0401 329.089 36.2101 328.999 36.2901C328.839 36.4301 328.659 36.5601 328.479 36.6701C328.419 36.7101 328.349 36.7601 328.289 36.8001C328.269 36.8101 328.249 36.8202 328.229 36.8202L328.219 36.8101ZM328.089 36.2501L328.249 36.5301C328.249 36.5301 328.309 36.4901 328.349 36.4701C328.519 36.3601 328.669 36.2501 328.819 36.1201C328.819 36.0701 328.819 36.0101 328.799 35.9601C328.609 35.9101 328.419 35.9001 328.219 35.9301C328.189 35.9901 328.169 36.0501 328.139 36.1101C328.119 36.1501 328.099 36.2001 328.079 36.2401L328.089 36.2501ZM328.249 34.5102C328.099 34.4902 327.979 34.3801 327.949 34.2301C327.929 33.9301 327.929 33.6301 327.939 33.3401V33.2901C327.939 33.2301 327.999 33.0501 328.119 33.0401C328.219 33.0401 328.319 33.0801 328.379 33.1701C328.469 33.3301 328.549 33.4901 328.609 33.6001L328.659 33.6901C328.659 33.6901 328.669 33.7301 328.669 33.7501C328.669 33.8401 328.659 33.9101 328.649 33.9801C328.649 34.0901 328.629 34.2001 328.599 34.3001C328.529 34.4201 328.409 34.5002 328.269 34.5102H328.249ZM328.159 33.2701V33.3401C328.159 33.6301 328.149 33.9301 328.159 34.2101C328.179 34.2401 328.219 34.2601 328.249 34.2801C328.249 34.2801 328.339 34.2402 328.369 34.2002C328.389 34.1202 328.409 34.0401 328.409 33.9601C328.409 33.9001 328.409 33.8302 328.419 33.7602L328.389 33.7002C328.329 33.5902 328.249 33.4301 328.159 33.2801H328.149L328.159 33.2701ZM330.889 33.1901C330.889 33.1901 330.849 33.1901 330.829 33.1701C330.769 33.1301 330.709 33.1002 330.649 33.0702C330.489 32.9902 330.349 32.9201 330.339 32.7901C330.319 32.6801 330.359 32.5701 330.429 32.4901C330.549 32.4001 330.689 32.3602 330.839 32.3802C330.879 32.3802 330.909 32.3802 330.949 32.3802C331.099 32.3502 331.259 32.3901 331.379 32.4901C331.439 32.5801 331.459 32.7001 331.409 32.8001C331.369 32.9201 331.249 32.9902 331.119 33.0702C331.069 33.1002 331.009 33.1301 330.959 33.1701C330.939 33.1801 330.919 33.1901 330.899 33.1901H330.889ZM330.809 32.6101C330.719 32.6101 330.629 32.6101 330.589 32.6501C330.569 32.6901 330.559 32.7401 330.559 32.7801C330.569 32.7801 330.679 32.8401 330.739 32.8701C330.789 32.8901 330.829 32.9201 330.879 32.9401C330.919 32.9201 330.959 32.8901 330.999 32.8701C331.069 32.8301 331.179 32.7701 331.189 32.7401C331.209 32.6801 331.199 32.6501 331.189 32.6401C331.179 32.6201 331.129 32.6001 330.949 32.6101C330.909 32.6101 330.869 32.6101 330.829 32.6101H330.799H330.809ZM330.649 32.3601C330.649 32.3601 330.569 32.3401 330.549 32.3001C330.509 32.2201 330.469 32.1501 330.439 32.1001C330.379 32.0201 330.349 31.9301 330.329 31.8401C330.319 31.7301 330.349 31.6301 330.419 31.5501C330.519 31.4701 330.649 31.4302 330.779 31.4502C330.849 31.4702 330.909 31.5101 330.949 31.5801C330.999 31.6401 331.019 31.7201 331.009 31.8001C330.969 31.9101 330.919 32.0201 330.859 32.1201C330.829 32.1801 330.789 32.2402 330.749 32.3202C330.729 32.3602 330.689 32.3802 330.649 32.3802V32.3601ZM330.719 31.6601C330.669 31.6601 330.619 31.6702 330.569 31.7002C330.549 31.7302 330.539 31.7701 330.539 31.8101C330.559 31.8701 330.579 31.9301 330.619 31.9801L330.639 32.0201L330.659 31.9901C330.709 31.9101 330.759 31.8201 330.789 31.7301C330.769 31.7001 330.749 31.6801 330.729 31.6601H330.719ZM329.389 31.6302C329.239 31.6502 329.079 31.6001 328.959 31.5001C328.849 31.3601 328.809 31.1801 328.829 31.0001V30.9401C328.829 30.8001 328.829 30.5402 329.149 30.5102C329.439 30.5402 329.699 30.6702 329.889 30.8802C329.979 30.9602 330.029 31.0701 330.029 31.1901C329.969 31.5701 329.649 31.5901 329.449 31.6101H329.379L329.389 31.6302ZM329.189 30.7501H329.179C329.079 30.7501 329.069 30.7802 329.069 30.9502V31.0201C329.069 31.2001 329.089 31.3101 329.129 31.3501C329.219 31.4001 329.319 31.4301 329.429 31.4101H329.449C329.689 31.3901 329.799 31.3601 329.829 31.1801C329.829 31.1701 329.819 31.1201 329.739 31.0401C329.599 30.8901 329.409 30.7901 329.199 30.7501H329.189ZM332.529 30.7002C332.469 30.7002 332.409 30.7001 332.359 30.6701C332.209 30.6001 332.069 30.4901 331.959 30.3601C331.909 30.3101 331.869 30.2701 331.819 30.2201C331.799 30.2001 331.779 30.1701 331.779 30.1401C331.779 30.1101 331.789 30.0801 331.819 30.0601C331.869 30.0201 331.919 29.9701 331.959 29.9201C332.059 29.7901 332.199 29.6901 332.349 29.6201C332.709 29.5001 333.099 29.5201 333.439 29.6801L333.479 29.6501C333.479 29.6501 333.589 29.6301 333.629 29.6701C333.669 29.7101 333.669 29.7702 333.629 29.8202L333.569 29.8901C333.569 29.8901 333.529 29.9201 333.509 29.9301C333.469 29.9801 333.439 30.0202 333.399 30.0702C333.279 30.2402 333.139 30.4001 332.979 30.5501C332.849 30.6501 332.689 30.7002 332.529 30.7002ZM332.059 30.1401C332.059 30.1401 332.099 30.1802 332.119 30.2002C332.209 30.3102 332.319 30.3901 332.439 30.4601C332.579 30.4901 332.719 30.4601 332.839 30.3701C332.979 30.2401 333.109 30.0901 333.219 29.9301C333.239 29.9001 333.259 29.8801 333.279 29.8501C333.009 29.7401 332.699 29.7401 332.419 29.8301C332.299 29.8901 332.199 29.9702 332.119 30.0702C332.099 30.0902 332.079 30.1201 332.049 30.1401H332.059ZM336.459 26.3802C336.459 26.3802 336.419 26.3801 336.399 26.3601L336.109 26.1601C336.109 26.1601 336.059 26.1102 336.059 26.0702C336.059 26.0402 336.069 26.0001 336.099 25.9801L336.249 25.8501C336.249 25.8501 336.349 25.8101 336.399 25.8501L336.459 25.9001C336.519 25.9501 336.579 26.0001 336.619 26.0501C336.679 26.1201 336.619 26.2001 336.589 26.2701C336.589 26.2801 336.569 26.3001 336.559 26.3101C336.549 26.3401 336.519 26.3601 336.489 26.3701C336.489 26.3701 336.469 26.3701 336.459 26.3701V26.3802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M327.759 40.54C327.589 40.56 327.429 40.55 327.259 40.53C327.189 40.51 327.109 40.35 327.109 40.25C327.109 40.18 327.209 40.04 327.269 40.04C327.619 40.02 327.979 40.02 328.339 40.04C328.409 40.04 328.519 40.2 328.519 40.29C328.499 40.4 328.439 40.49 328.339 40.54C328.149 40.56 327.969 40.57 327.779 40.55L327.759 40.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M328.089 40.66C328.029 40.66 327.979 40.66 327.919 40.66C327.859 40.66 327.789 40.66 327.729 40.66C327.689 40.66 327.659 40.66 327.619 40.66C327.489 40.67 327.359 40.66 327.229 40.64C327.079 40.6 326.999 40.3801 326.989 40.2601C326.989 40.1701 327.029 40.09 327.089 40.02C327.129 39.97 327.189 39.93 327.249 39.92C327.609 39.9 327.969 39.9 328.329 39.92C328.469 39.93 328.609 40.16 328.609 40.28C328.599 40.44 328.489 40.5801 328.339 40.6301C328.259 40.6501 328.169 40.65 328.079 40.65L328.089 40.66ZM327.799 40.43C327.799 40.43 327.889 40.43 327.929 40.43C328.049 40.44 328.179 40.43 328.299 40.42C328.349 40.39 328.379 40.34 328.389 40.28C328.379 40.23 328.339 40.18 328.299 40.14C327.959 40.12 327.609 40.12 327.269 40.14C327.249 40.17 327.229 40.2 327.219 40.24C327.219 40.3 327.259 40.36 327.299 40.41C327.399 40.43 327.509 40.43 327.609 40.42C327.669 40.41 327.739 40.41 327.799 40.42V40.43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M332.869 26.3701C332.929 26.3701 332.999 26.3701 333.059 26.3901C333.089 26.4001 333.119 26.5801 333.089 26.6001C332.949 26.7101 332.779 26.8001 332.599 26.8501C332.519 26.8701 332.349 26.7401 332.319 26.6401C332.259 26.4801 332.369 26.3701 332.559 26.3701C332.619 26.3701 332.679 26.3701 332.859 26.3701H332.869Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M332.589 26.96C332.419 26.94 332.279 26.83 332.209 26.67C332.169 26.58 332.189 26.47 332.239 26.39C332.319 26.3 332.439 26.2501 332.559 26.2601C332.599 26.2601 332.639 26.2601 332.699 26.2601H332.849C332.929 26.2601 333.009 26.26 333.079 26.29C333.099 26.29 333.169 26.32 333.189 26.5C333.209 26.57 333.189 26.6501 333.129 26.7001C332.969 26.8201 332.789 26.91 332.599 26.96C332.589 26.96 332.579 26.96 332.559 26.96H332.589ZM332.549 26.48C332.549 26.48 332.459 26.48 332.429 26.52C332.419 26.54 332.419 26.57 332.429 26.6C332.469 26.66 332.529 26.71 332.589 26.73C332.729 26.69 332.869 26.62 332.989 26.53C332.989 26.51 332.989 26.5 332.989 26.49C332.959 26.49 332.929 26.49 332.899 26.49C332.899 26.49 332.879 26.49 332.869 26.49H332.709C332.639 26.49 332.599 26.49 332.559 26.49L332.549 26.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M331.759 27.7601C331.679 27.7701 331.589 27.7701 331.509 27.7601C331.439 27.7201 331.339 27.6301 331.339 27.5701C331.339 27.5001 331.449 27.3801 331.509 27.3801C331.669 27.4001 331.829 27.4401 331.979 27.5001C332.049 27.5301 332.079 27.6201 332.129 27.6801C332.049 27.7101 331.959 27.7401 331.879 27.7701C331.839 27.7701 331.799 27.7701 331.759 27.7701V27.7601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M331.599 27.89C331.599 27.89 331.509 27.89 331.459 27.86C331.369 27.82 331.219 27.7001 331.229 27.5701C331.239 27.4801 331.289 27.4 331.349 27.35C331.389 27.3 331.449 27.28 331.519 27.28C331.689 27.3 331.859 27.34 332.019 27.41C332.089 27.45 332.139 27.5001 332.179 27.5701C332.189 27.5901 332.199 27.6101 332.219 27.6201C332.239 27.6501 332.249 27.69 332.239 27.72C332.239 27.76 332.199 27.78 332.169 27.8L332.099 27.8201C332.039 27.8401 331.969 27.8701 331.909 27.8801C331.869 27.8801 331.829 27.8901 331.789 27.8801H331.759C331.759 27.8801 331.739 27.8801 331.729 27.8801H331.689C331.689 27.8801 331.629 27.8801 331.599 27.8801V27.89ZM331.499 27.5001C331.499 27.5001 331.459 27.56 331.449 27.58C331.479 27.61 331.519 27.64 331.559 27.66C331.599 27.66 331.629 27.66 331.669 27.66C331.709 27.66 331.759 27.66 331.799 27.66C331.799 27.66 331.829 27.66 331.849 27.66C331.889 27.66 331.919 27.6401 331.949 27.6301C331.949 27.6301 331.939 27.61 331.929 27.61C331.789 27.55 331.649 27.5101 331.499 27.5001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M339.799 31.04C339.659 31.07 339.569 31.12 339.529 31.09C339.449 31.02 339.379 30.93 339.349 30.83C339.339 30.79 339.429 30.72 339.479 30.66L339.799 31.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M339.559 31.2C339.559 31.2 339.489 31.19 339.459 31.17C339.359 31.09 339.289 30.98 339.239 30.87C339.209 30.78 339.279 30.7099 339.339 30.6399C339.359 30.6199 339.369 30.6099 339.379 30.5899C339.399 30.5599 339.429 30.54 339.469 30.55C339.499 30.55 339.529 30.5599 339.559 30.5899L339.879 30.9699C339.879 30.9699 339.909 31.0399 339.899 31.0799C339.889 31.1199 339.859 31.1499 339.819 31.1499C339.769 31.1499 339.729 31.17 339.699 31.18C339.659 31.2 339.609 31.1999 339.559 31.2099V31.2ZM339.469 30.82C339.499 30.88 339.529 30.9299 339.579 30.9699H339.599L339.479 30.82H339.469Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M331.239 34.3101C331.149 34.3501 331.079 34.4001 331.069 34.3901C331.019 34.3401 330.969 34.2701 330.939 34.2101C330.929 34.1801 330.969 34.1401 330.979 34.1001L331.239 34.3201V34.3101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M331.069 34.5C331.069 34.5 331.009 34.49 330.989 34.47C330.929 34.41 330.869 34.33 330.839 34.25C330.819 34.19 330.839 34.13 330.869 34.08V34.05C330.869 34.05 330.929 33.99 330.959 33.98C330.989 33.97 331.029 33.98 331.059 34L331.319 34.22C331.319 34.22 331.359 34.28 331.359 34.32C331.359 34.36 331.329 34.39 331.299 34.41C331.269 34.42 331.239 34.44 331.219 34.45C331.179 34.48 331.129 34.49 331.079 34.5H331.069Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M327.099 40.76C327.029 40.8 326.989 40.83 326.979 40.83C326.909 40.76 326.849 40.69 326.779 40.62C326.809 40.6 326.859 40.57 326.879 40.58C326.959 40.64 327.029 40.7 327.099 40.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M326.98 40.9401C326.98 40.9401 326.92 40.93 326.9 40.91C326.85 40.86 326.8 40.8101 326.75 40.7501L326.7 40.7001C326.7 40.7001 326.66 40.64 326.67 40.6C326.68 40.56 326.7 40.53 326.73 40.52H326.75C326.8 40.46 326.87 40.4601 326.93 40.4901C326.99 40.5301 327.05 40.5801 327.1 40.6301L327.16 40.6801C327.16 40.6801 327.2 40.74 327.2 40.78C327.2 40.82 327.18 40.8501 327.14 40.8701L327.08 40.91C327.08 40.91 327 40.95 326.96 40.96L326.98 40.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M408.25 30.6001C408.28 30.8501 408.38 31.21 408.25 31.34C407.93 31.68 408.22 32.34 408.36 32.64C408.45 32.82 408.34 32.9201 408.13 32.8501C408.01 32.8101 407.89 32.7801 407.77 32.7301C407.41 32.5201 406.97 32.5601 406.65 32.8201C406.22 33.1001 405.65 33 405.35 32.58C405.31 32.46 405.31 32.3201 405.35 32.2001C405.69 32.1601 405.63 31.8801 405.69 31.6801C405.74 31.5601 405.8 31.44 405.87 31.33C405.73 31.38 405.06 31.09 404.92 31.14C404.55 31.35 404.13 31.4301 403.71 31.3601C403.33 31.2701 403.24 31.1301 403.28 30.8101C403.31 30.6701 403.35 30.53 403.4 30.4C403.43 30.3 403.45 30.2101 403.48 30.1101C403.38 30.1101 403.25 30.0701 403.19 30.1101C402.92 30.3401 402.71 30.1001 402.49 30.0401C402.4 29.9901 402.35 29.9001 402.35 29.8101C402.38 29.7201 402.45 29.6401 402.54 29.6101C403.25 29.3001 403.26 29.3101 403.2 28.5601C403.18 28.3701 403.16 28.1801 403.16 27.9901C403.16 27.5501 403.36 27.4201 403.78 27.5701C403.82 27.5801 403.86 27.6101 403.9 27.6201C404.05 27.6601 404.21 27.7001 404.36 27.7501C404.22 27.9001 404.07 28.03 403.89 28.14C403.66 28.24 403.51 28.33 403.71 28.58C403.88 28.8 403.76 28.95 403.66 29.15C403.62 29.28 403.65 29.42 403.74 29.53C403.88 29.61 404.03 29.5801 404.12 29.3601C404.26 29.0201 405.53 29.3001 405.7 29.6001C405.76 29.7101 405.7 29.9101 405.65 30.0601C405.6 30.2301 405.65 30.3201 405.81 30.3001C406.21 30.2401 406.66 30.4401 406.98 29.9501C407.13 29.7201 407.52 29.64 407.82 29.52", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M406.179 33.17C406.129 33.17 406.079 33.17 406.029 33.16C405.709 33.12 405.419 32.95 405.229 32.69C405.149 32.51 405.149 32.31 405.209 32.13C405.239 32.07 405.299 32.03 405.359 32.02C405.469 32.01 405.479 31.99 405.509 31.81C405.509 31.75 405.529 31.68 405.549 31.62C405.569 31.57 405.589 31.52 405.609 31.47C405.539 31.45 405.469 31.43 405.379 31.4C405.259 31.35 405.129 31.32 404.989 31.31L404.919 31.34C404.539 31.54 404.109 31.61 403.689 31.53C403.229 31.42 403.069 31.2 403.119 30.79C403.139 30.68 403.169 30.58 403.209 30.48C403.229 30.44 403.239 30.39 403.249 30.35C403.249 30.33 403.249 30.32 403.259 30.3C403.059 30.43 402.799 30.42 402.609 30.28C402.559 30.25 402.509 30.23 402.459 30.22C402.289 30.15 402.179 29.98 402.179 29.8C402.209 29.64 402.319 29.5101 402.469 29.4501C402.869 29.2767 403.053 28.9867 403.019 28.58L402.999 28.4C402.989 28.26 402.969 28.13 402.969 27.99C402.939 27.77 403.029 27.55 403.199 27.41C403.399 27.3 403.639 27.3 403.839 27.41L403.899 27.43C403.899 27.43 403.929 27.4401 403.949 27.4501L404.409 27.58C404.469 27.6 404.519 27.65 404.539 27.71C404.559 27.77 404.539 27.84 404.479 27.89C404.439 27.93 404.389 27.9701 404.349 28.0101C404.239 28.1301 404.109 28.23 403.969 28.3C403.909 28.32 403.849 28.35 403.799 28.39C403.799 28.39 403.819 28.42 403.849 28.46C404.019 28.66 404.019 28.96 403.849 29.16L403.819 29.22C403.819 29.27 403.819 29.33 403.849 29.38H403.869C403.869 29.38 403.909 29.35 403.939 29.27C403.979 29.16 404.099 29.0301 404.429 29.0101C404.849 28.9801 405.659 29.18 405.839 29.49C405.909 29.67 405.899 29.88 405.819 30.06V30.1C405.919 30.1 406.029 30.09 406.139 30.1C406.439 30.1 406.649 30.11 406.829 29.84C407.009 29.63 407.249 29.48 407.519 29.42C407.599 29.39 407.669 29.37 407.739 29.34C407.799 29.32 407.869 29.32 407.919 29.36C407.969 29.4 407.999 29.46 407.989 29.53C407.989 29.59 407.939 29.65 407.879 29.67C407.799 29.7 407.719 29.7301 407.639 29.7601C407.449 29.8001 407.269 29.9 407.129 30.04C406.909 30.37 406.519 30.53 406.139 30.47C406.039 30.47 405.939 30.47 405.839 30.47C405.729 30.5 405.609 30.47 405.529 30.38C405.449 30.27 405.429 30.1301 405.479 30.0101C405.519 29.9101 405.539 29.8 405.539 29.69C405.299 29.51 405.009 29.41 404.709 29.4C404.409 29.37 404.289 29.42 404.279 29.44C404.239 29.58 404.129 29.69 403.989 29.74C403.869 29.78 403.739 29.76 403.639 29.69C403.469 29.54 403.409 29.29 403.489 29.08L403.529 29.0101C403.629 28.8301 403.639 28.7901 403.559 28.7001C403.459 28.6001 403.419 28.45 403.439 28.31C403.479 28.13 403.669 28.04 403.809 27.98C403.879 27.95 403.939 27.9 403.999 27.85L403.839 27.81C403.839 27.81 403.779 27.79 403.739 27.77C403.489 27.68 403.419 27.71 403.399 27.72C403.349 27.75 403.329 27.86 403.329 28C403.329 28.12 403.329 28.25 403.349 28.37L403.369 28.55C403.429 29.37 403.389 29.44 402.619 29.77C402.579 29.79 402.549 29.81 402.529 29.85C402.529 29.84 402.559 29.88 402.569 29.89C402.639 29.91 402.699 29.93 402.759 29.97C402.939 30.06 402.989 30.07 403.079 29.99C403.179 29.92 403.299 29.9 403.409 29.93C403.499 29.94 403.579 29.9401 403.629 30.0101C403.659 30.0501 403.669 30.11 403.659 30.16L403.639 30.24C403.619 30.31 403.599 30.39 403.579 30.46C403.569 30.51 403.549 30.56 403.529 30.61C403.499 30.68 403.479 30.76 403.459 30.84C403.429 31.05 403.439 31.12 403.759 31.19C404.109 31.25 404.459 31.19 404.769 31.02L404.859 30.98C404.979 30.93 405.149 30.98 405.459 31.07C405.579 31.11 405.709 31.14 405.829 31.16C405.899 31.14 405.969 31.16 406.019 31.21C406.069 31.27 406.069 31.35 406.029 31.41C406.009 31.45 405.989 31.49 405.969 31.53C405.929 31.6 405.899 31.67 405.869 31.74C405.859 31.78 405.849 31.83 405.839 31.87C405.839 32.09 405.699 32.28 405.499 32.36C405.499 32.41 405.499 32.45 405.499 32.5C405.639 32.67 405.829 32.78 406.049 32.81C406.219 32.84 406.389 32.8 406.529 32.69C406.899 32.38 407.409 32.34 407.829 32.57C407.909 32.6 407.989 32.63 408.069 32.65L408.169 32.68C407.859 31.99 407.839 31.51 408.109 31.22C408.129 31.08 408.109 30.94 408.079 30.8C408.069 30.74 408.059 30.68 408.049 30.62C408.049 30.57 408.049 30.53 408.089 30.49C408.119 30.45 408.159 30.43 408.209 30.42C408.259 30.42 408.309 30.4201 408.339 30.4501C408.379 30.4801 408.399 30.52 408.409 30.57C408.409 30.62 408.429 30.68 408.439 30.73C408.489 31 408.529 31.2901 408.379 31.4501C408.289 31.5501 408.179 31.83 408.519 32.55C408.599 32.67 408.589 32.83 408.499 32.94C408.389 33.05 408.219 33.0801 408.079 33.0101L407.969 32.98C407.879 32.95 407.789 32.92 407.709 32.89C407.409 32.71 407.039 32.74 406.769 32.96C406.599 33.1 406.389 33.17 406.169 33.16L406.179 33.17Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.739 47.21C397.729 46.91 397.699 46.69 398.099 46.54C398.449 46.35 398.809 46.21 399.189 46.1C399.349 46.05 399.469 45.92 399.509 45.77C399.519 45.67 399.349 45.5101 399.219 45.4301C398.999 45.3201 398.739 45.3001 398.509 45.3701C397.969 45.4201 397.419 45.4201 396.869 45.3701C396.679 45.3601 396.689 45.05 396.849 44.78C397.079 44.4 397.309 44.0201 397.509 43.6201C397.559 43.4601 397.579 43.3 397.579 43.14C397.469 43.25 397.359 43.3701 397.259 43.4801C397.229 43.5101 397.219 43.56 397.189 43.59C397.089 43.69 396.979 43.79 396.879 43.89C396.909 43.76 396.939 43.6301 396.959 43.5001C396.979 43.4001 397.019 43.2701 396.969 43.1901C396.809 42.8801 396.649 42.6301 397.209 42.5501C397.359 42.5301 397.479 42.14 397.729 42.02C397.769 42 397.779 41.84 397.739 41.79C397.689 41.72 397.559 41.64 397.489 41.66C396.349 42.04 396.319 40.9501 395.649 40.4201C395.579 40.3101 395.569 40.16 395.629 40.04C395.739 39.93 395.899 39.89 396.049 39.91C396.219 40 396.369 40.1101 396.509 40.2401C397.019 40.6901 397.769 40.7401 398.339 40.3701C398.449 40.3001 400.079 40.81 400.139 40.71C400.189 40.64 400.149 40.5201 400.149 40.4201C400.079 40.4501 400.009 40.4801 399.949 40.5101C399.909 40.5301 398.369 39.9901 398.329 40.0001C398.179 40.0501 398.019 40.0801 397.859 40.1201L397.789 39.5001C397.869 39.4801 397.959 39.4701 398.049 39.4801C398.919 39.7901 399.819 39.95 400.739 39.97C400.789 39.95 400.829 39.88 400.869 39.84C400.819 39.82 400.769 39.8001 400.719 39.8001C400.589 39.8001 400.459 39.8001 400.339 39.8201C399.909 39.9101 400.419 39.6001 400.099 39.3101C399.549 38.8201 397.339 38.4 396.709 38.27C396.579 38.27 396.459 38.2701 396.329 38.2501C396.179 38.1801 396.039 38.1001 395.909 38.0001C395.999 37.9001 396.079 37.7901 396.179 37.6901C396.239 37.6301 396.299 37.57 396.379 37.53C396.639 37.38 396.669 37.2501 396.369 37.1201C396.269 37.0901 396.169 37.0501 396.079 36.9901C395.999 36.9201 395.959 36.82 395.959 36.72C395.999 36.28 396.279 35.9101 396.679 35.7401C396.849 35.7101 396.989 35.61 397.079 35.46C397.169 35.31 397.179 35.14 397.129 34.97C397.129 34.85 397.159 34.7401 397.209 34.6301C397.299 34.6801 397.399 34.72 397.479 34.77C397.529 34.81 397.579 34.85 397.619 34.89C397.829 35.05 397.999 35.1401 398.019 34.7401C398.019 34.6601 397.669 34.6101 397.719 34.6101C398.179 34.5501 397.539 34.43 397.769 34.09C397.939 33.84 398.139 33.7901 398.339 33.9901C398.509 34.1601 398.959 34.1401 398.779 34.6101C398.729 34.7301 399.429 34.95 399.669 34.85C399.999 34.71 400.899 35.3601 401.139 35.8001C401.199 35.9201 401.649 35.94 401.839 35.84C402.209 35.66 402.619 35.6301 403.009 35.7401C403.129 35.7801 403.259 35.8 403.379 35.78C403.489 35.75 403.569 35.6301 403.669 35.5501C403.579 35.4601 403.499 35.3 403.399 35.28C403.019 35.22 401.999 34.47 401.619 34.4C401.099 34.31 400.579 34.1801 400.089 34.0101C399.679 33.8601 399.679 33.7401 400.009 33.4301C400.289 33.1601 399.679 32.3101 399.319 32.0601C399.119 31.9201 399.109 31.68 399.329 31.64C399.959 31.45 400.559 31.1601 401.079 30.7601C401.239 30.6701 401.409 30.65 401.329 30.89C401.129 31.47 402.029 32.1201 402.419 32.3601C402.829 32.6101 402.999 32.88 402.829 33.34C402.789 33.42 402.779 33.5 402.799 33.59C402.849 33.72 402.909 33.85 402.979 33.97C403.079 33.89 403.159 33.81 403.239 33.71C403.359 33.54 403.459 33.3501 403.569 33.1701C403.709 32.9401 403.839 32.7201 403.479 32.5701C403.419 32.5201 403.379 32.44 403.389 32.35C403.399 32.3 403.519 32.2701 403.589 32.2501C403.629 32.2401 403.669 32.2301 403.719 32.2501C403.879 32.2701 404.039 32.3001 404.199 32.3201C404.159 32.5001 404.179 32.73 404.069 32.85C403.809 33.15 403.869 33.3601 404.119 33.6101C404.359 33.8501 404.929 34.8901 404.809 35.2001C404.589 35.8101 405.029 35.9 404.439 36.03C404.269 36.05 404.129 36.18 404.109 36.35C404.089 36.45 403.899 36.52 403.789 36.6C403.739 36.5 403.689 36.4101 403.629 36.3101C403.589 36.2501 403.549 36.1301 403.509 36.1301C403.409 36.1301 403.309 36.16 403.239 36.22C403.119 36.31 403.019 36.4301 402.939 36.5601C402.909 36.6201 402.969 36.76 403.029 36.83C403.399 37.33 403.629 37.74 403.029 37.84C402.969 37.85 402.879 37.87 402.839 37.84C402.629 37.69 401.989 37.59 401.739 37.89C401.259 37.65 400.829 37.89 400.389 38.03C400.219 38.08 400.099 38.04 400.089 37.83C400.089 37.7 400.069 37.58 400.009 37.46C399.859 37.27 399.929 37.1801 400.099 37.0601C400.209 36.9701 399.399 37.02 399.479 36.9C399.589 36.74 399.559 36.6301 399.379 36.5501C399.129 36.4401 398.249 35.5201 397.989 35.4301C397.819 35.3701 398.059 35.29 397.869 35.27C397.899 35.42 398.129 36.44 398.139 36.59C398.149 36.72 398.579 36.7501 398.559 36.8701C398.499 37.2701 399.139 37.49 399.279 37.84C399.519 38.44 400.489 38.4701 400.959 38.6901C401.139 38.7301 401.329 38.71 401.499 38.65C401.619 38.62 401.719 38.5201 401.839 38.4801C401.989 38.4401 402.149 38.4101 402.309 38.3801L402.379 39.0001C402.299 39.0001 402.189 39.0201 402.149 38.9801C401.979 38.8001 401.829 38.77 401.729 39.03C401.649 39.25 401.289 39.4901 401.709 39.7001C401.869 39.7801 401.999 39.8301 401.929 40.0001C401.899 40.0801 401.729 40.1101 401.629 40.1701C401.609 40.1701 401.589 40.1701 401.569 40.1701C401.399 40.2001 401.139 40.1101 401.159 40.4201C401.169 40.7301 401.429 40.6401 401.589 40.6301C401.889 40.6101 402.019 40.72 402.019 41.02C402.019 41.3 402.039 41.57 402.059 41.85C402.069 42.05 402.019 42.2901 402.369 42.2601C402.409 42.2601 401.639 42.6501 401.649 42.7601C401.699 43.2801 400.299 42.85 400.769 42.91C400.899 42.92 401.019 42.9201 401.149 42.9201C401.609 42.9201 401.119 42.59 401.069 43.02C401.029 43.39 401.419 44.0901 401.299 44.4501C401.239 44.6201 401.199 44.73 401.439 44.72C401.459 44.72 401.479 44.72 401.499 44.72C401.689 44.8 401.339 44.5501 401.529 44.6301C401.549 44.4301 401.569 44.23 401.609 44.03C401.629 43.95 401.679 43.89 401.749 43.85", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.559 47.22H397.739L397.559 47.1901C397.479 46.8401 397.689 46.4801 398.039 46.3801C398.169 46.3301 398.289 46.27 398.409 46.21C398.649 46.08 398.899 45.98 399.169 45.93C399.249 45.89 399.309 45.8301 399.339 45.7501C399.269 45.6901 399.199 45.63 399.129 45.58C398.989 45.49 398.839 45.5 398.599 45.54H398.539C398.029 45.6 397.509 45.6 396.989 45.54H396.859C396.749 45.52 396.649 45.46 396.599 45.36C396.519 45.13 396.559 44.87 396.699 44.67C396.879 44.38 397.049 44.1001 397.209 43.8101C397.169 43.8501 397.129 43.88 397.099 43.92L397.009 44.0001C396.949 44.0501 396.869 44.07 396.799 44.03C396.729 43.99 396.699 43.91 396.709 43.83L396.739 43.72C396.759 43.63 396.779 43.54 396.799 43.46V43.39C396.799 43.39 396.829 43.3001 396.829 43.2601L396.809 43.22C396.709 43.03 396.599 42.83 396.699 42.64C396.819 42.48 397.009 42.38 397.209 42.37C397.239 42.32 397.259 42.28 397.299 42.24C397.379 42.1 397.489 41.99 397.619 41.89C397.619 41.89 397.619 41.87 397.619 41.86C397.619 41.86 397.569 41.84 397.549 41.83C396.689 42.12 396.359 41.6 396.059 41.14C395.929 40.92 395.769 40.72 395.579 40.55C395.499 40.47 395.449 40.35 395.449 40.24C395.439 40.12 395.469 40 395.539 39.91C395.699 39.76 395.919 39.69 396.139 39.73C396.279 39.78 396.409 39.87 396.519 39.98C396.559 40.02 396.609 40.06 396.649 40.09C397.099 40.49 397.769 40.54 398.279 40.21H398.299C398.229 40.21 398.149 40.2401 398.079 40.2601L397.949 40.29C397.899 40.3 397.849 40.2901 397.799 40.2601C397.759 40.2301 397.729 40.1801 397.719 40.1301L397.649 39.5101C397.649 39.5101 397.649 39.4101 397.689 39.3801C397.719 39.3401 397.769 39.3201 397.809 39.3201C397.829 39.3201 397.849 39.3201 397.879 39.3101C397.969 39.2901 398.059 39.2901 398.149 39.3101C398.759 39.5001 399.389 39.6601 400.019 39.7601C400.019 39.7201 400.029 39.68 400.049 39.64C400.079 39.53 400.089 39.49 400.019 39.43C399.019 38.95 397.959 38.62 396.869 38.46L396.719 38.43C396.719 38.43 396.629 38.43 396.589 38.43C396.499 38.43 396.399 38.43 396.309 38.4C396.189 38.35 396.079 38.29 395.979 38.22C395.939 38.19 395.899 38.17 395.859 38.14C395.809 38.11 395.779 38.0701 395.779 38.0101C395.779 37.9601 395.779 37.9 395.819 37.87L395.899 37.78C395.959 37.7 396.029 37.6301 396.099 37.5601C396.169 37.4801 396.249 37.42 396.339 37.37C396.369 37.35 396.399 37.3401 396.419 37.3201C396.399 37.3101 396.369 37.29 396.339 37.28C396.309 37.27 396.289 37.2601 396.259 37.2501C396.159 37.2201 396.079 37.18 395.999 37.11C395.879 37 395.809 36.83 395.829 36.67C395.879 36.17 396.209 35.7501 396.669 35.5601C396.969 35.4701 397.049 35.32 396.999 34.99C396.989 34.88 396.999 34.77 397.049 34.67C397.059 34.64 397.069 34.61 397.079 34.58C397.089 34.53 397.129 34.48 397.179 34.46C397.229 34.44 397.289 34.44 397.339 34.46L397.419 34.5001C397.479 34.5301 397.539 34.56 397.599 34.59C397.599 34.54 397.629 34.49 397.679 34.46C397.579 34.32 397.579 34.13 397.679 33.98C397.769 33.82 397.919 33.71 398.099 33.68C398.259 33.68 398.419 33.74 398.519 33.86C398.569 33.89 398.619 33.9201 398.669 33.9401C398.799 33.9701 398.919 34.06 398.989 34.18C399.059 34.3 399.079 34.4401 399.039 34.5701C399.229 34.6601 399.449 34.7 399.669 34.68C400.149 34.48 401.119 35.2601 401.369 35.7001C401.519 35.7301 401.679 35.72 401.829 35.67C402.229 35.47 402.689 35.43 403.119 35.55L403.199 35.5701C403.269 35.5901 403.339 35.6 403.409 35.6C403.449 35.58 403.479 35.56 403.509 35.52C403.489 35.49 403.469 35.4601 403.439 35.4401C403.099 35.3301 402.769 35.18 402.479 34.97C402.229 34.81 401.959 34.6701 401.679 34.5601C401.149 34.4701 400.619 34.34 400.119 34.16C399.919 34.09 399.729 33.9901 399.689 33.8101C399.649 33.6201 399.809 33.44 399.969 33.28C399.989 33.26 399.989 33.2201 399.989 33.1901C399.879 32.7901 399.639 32.4401 399.309 32.1901C399.149 32.0901 399.059 31.91 399.089 31.72C399.119 31.57 399.239 31.4601 399.389 31.4401C399.849 31.3301 400.279 31.13 400.659 30.84C400.799 30.75 400.939 30.66 401.079 30.58C401.209 30.48 401.389 30.46 401.529 30.55C401.599 30.61 401.659 30.72 401.589 30.92C401.439 31.34 402.159 31.91 402.599 32.17C402.819 32.26 402.999 32.44 403.089 32.67C403.179 32.9 403.179 33.15 403.079 33.37C403.059 33.41 403.049 33.4601 403.049 33.5001C403.069 33.5501 403.089 33.6 403.109 33.65C403.139 33.63 403.159 33.6001 403.179 33.5701C403.249 33.4701 403.319 33.35 403.379 33.24C403.419 33.17 403.459 33.1 403.499 33.03C403.549 32.96 403.629 32.82 403.619 32.77C403.619 32.77 403.599 32.73 403.489 32.68C403.339 32.59 403.269 32.4201 403.299 32.2501C403.339 32.1201 403.469 32.07 403.569 32.04H403.609C403.679 32 403.749 32.0001 403.819 32.0101C403.929 32.0201 404.039 32.0401 404.159 32.0601L404.309 32.08C404.309 32.08 404.399 32.11 404.429 32.16C404.459 32.2 404.469 32.25 404.459 32.3C404.449 32.35 404.439 32.41 404.439 32.46C404.439 32.62 404.389 32.78 404.289 32.91C404.109 33.11 404.119 33.22 404.329 33.43C404.569 33.67 405.219 34.77 405.069 35.21C405.009 35.35 404.999 35.51 405.019 35.66C405.059 35.95 404.949 36.07 404.569 36.16C404.439 36.19 404.399 36.22 404.379 36.35C404.349 36.5 404.209 36.58 404.089 36.65C404.059 36.67 404.019 36.69 403.989 36.71C403.949 36.74 403.899 36.75 403.839 36.74C403.789 36.73 403.749 36.7 403.719 36.65L403.669 36.55C403.639 36.49 403.599 36.42 403.569 36.36C403.559 36.34 403.549 36.31 403.529 36.29C403.529 36.29 403.469 36.3001 403.449 36.3201C403.349 36.4001 403.259 36.49 403.199 36.6C403.209 36.58 403.239 36.6401 403.269 36.6901C403.529 37.0401 403.759 37.39 403.639 37.67C403.539 37.86 403.349 37.97 403.139 37.98C403.029 38.01 402.919 38.0001 402.819 37.9501C402.649 37.8301 402.139 37.76 401.969 37.97C401.919 38.04 401.829 38.06 401.749 38.02C401.429 37.9 401.079 37.92 400.779 38.09C400.699 38.12 400.619 38.15 400.529 38.17C400.409 38.22 400.269 38.21 400.159 38.14C400.059 38.06 399.999 37.9401 399.999 37.8101V37.7601C399.999 37.6801 399.989 37.61 399.959 37.54C399.879 37.45 399.839 37.33 399.849 37.21C399.849 37.19 399.849 37.17 399.869 37.15C399.619 37.13 399.469 37.11 399.409 36.98C399.379 36.91 399.389 36.84 399.429 36.78C399.439 36.76 399.449 36.74 399.459 36.72C399.459 36.72 399.439 36.7101 399.409 36.6901C399.159 36.5301 398.929 36.35 398.719 36.14C398.579 36.02 398.399 35.85 398.259 35.74C398.339 36.1 398.399 36.3701 398.419 36.5001C398.449 36.5101 398.499 36.53 398.529 36.54C398.669 36.59 398.879 36.6701 398.849 36.8801C398.829 37.0101 398.959 37.13 399.159 37.29C399.329 37.41 399.469 37.5701 399.559 37.7601C399.699 38.1001 400.179 38.23 400.599 38.34C400.789 38.38 400.969 38.44 401.149 38.52C401.269 38.54 401.389 38.52 401.499 38.49L401.579 38.47C401.579 38.47 401.669 38.43 401.709 38.41C401.769 38.37 401.839 38.3401 401.899 38.3101C402.009 38.2801 402.129 38.25 402.249 38.23L402.389 38.2001C402.389 38.2001 402.489 38.2 402.529 38.23C402.569 38.26 402.599 38.31 402.599 38.36L402.669 38.98C402.669 39.03 402.659 39.09 402.619 39.12C402.579 39.16 402.529 39.18 402.479 39.17C402.459 39.17 402.439 39.17 402.419 39.17C402.319 39.19 402.209 39.16 402.129 39.09C402.099 39.06 402.069 39.0301 402.039 39.0101C402.039 39.0201 402.029 39.04 402.009 39.08C401.979 39.15 401.939 39.22 401.889 39.29C401.849 39.34 401.819 39.4 401.799 39.46C401.799 39.46 401.809 39.49 401.899 39.53C402.059 39.61 402.339 39.74 402.209 40.05C402.149 40.16 402.039 40.24 401.909 40.27C401.879 40.28 401.849 40.2901 401.819 40.3101C401.779 40.3301 401.739 40.33 401.699 40.33C401.649 40.33 401.599 40.34 401.549 40.34C401.509 40.34 401.479 40.34 401.439 40.34C401.439 40.34 401.439 40.36 401.439 40.39C401.439 40.41 401.439 40.4301 401.449 40.4501C401.499 40.4501 401.539 40.45 401.589 40.43C401.619 40.43 401.649 40.43 401.679 40.42C401.849 40.39 402.019 40.44 402.149 40.54C402.259 40.66 402.319 40.82 402.309 40.99C402.309 41.23 402.329 41.47 402.339 41.71V41.9C402.339 41.9 402.349 42 402.359 42.05C402.359 42.05 402.419 42.05 402.449 42.05C402.529 42.05 402.609 42.09 402.639 42.17C402.679 42.31 402.589 42.37 402.419 42.47C402.249 42.56 402.089 42.67 401.929 42.78C401.929 42.92 401.829 43.05 401.699 43.1C401.589 43.14 401.469 43.16 401.349 43.16C401.379 43.3 401.409 43.4401 401.459 43.5701C401.489 43.6801 401.519 43.79 401.549 43.9C401.589 43.79 401.669 43.7 401.779 43.65C401.839 43.62 401.909 43.63 401.959 43.67C402.009 43.71 402.039 43.77 402.029 43.83C402.019 43.89 401.979 43.95 401.919 43.98C401.899 43.99 401.889 44.01 401.879 44.04C401.849 44.18 401.839 44.3201 401.819 44.4501L401.799 44.6C401.839 44.66 401.839 44.74 401.799 44.8C401.759 44.86 401.679 44.91 401.519 44.85C401.409 44.88 401.289 44.8401 401.209 44.7501C401.139 44.6301 401.139 44.49 401.209 44.37C401.229 44.13 401.199 43.9 401.109 43.68C401.049 43.5 401.009 43.3201 400.979 43.1301C400.859 43.1201 400.739 43.0701 400.639 43.0001C400.589 42.9401 400.569 42.86 400.609 42.79C400.669 42.67 400.809 42.6801 400.889 42.7001C400.959 42.7001 401.019 42.7101 401.089 42.7001C401.159 42.6201 401.259 42.57 401.369 42.58C401.449 42.58 401.519 42.62 401.569 42.68C401.589 42.55 401.729 42.44 402.059 42.24C401.999 42.13 401.969 42.01 401.969 41.89V41.72C401.939 41.47 401.929 41.22 401.929 40.97C401.929 40.91 401.929 40.84 401.889 40.79C401.829 40.76 401.759 40.7501 401.689 40.7601H401.619C401.479 40.8101 401.319 40.7801 401.199 40.7001C401.029 40.5301 401.019 40.2601 401.159 40.0701C401.259 39.9801 401.389 39.9401 401.519 39.9501C401.549 39.9501 401.589 39.9501 401.619 39.9501C401.619 39.9501 401.649 39.9501 401.669 39.9501C401.699 39.9401 401.729 39.93 401.759 39.91C401.789 39.9 401.829 39.88 401.859 39.87C401.819 39.87 401.779 39.85 401.749 39.84C401.559 39.75 401.459 39.65 401.429 39.52C401.409 39.35 401.459 39.1901 401.569 39.0601C401.599 39.0201 401.629 38.97 401.649 38.93C401.679 38.86 401.709 38.79 401.759 38.74C401.719 38.76 401.669 38.78 401.619 38.79L401.549 38.8101C401.359 38.8801 401.159 38.8801 400.969 38.8201C400.809 38.7601 400.649 38.7 400.479 38.66C399.999 38.53 399.399 38.37 399.199 37.87C399.119 37.74 399.019 37.63 398.899 37.54C398.669 37.4 398.509 37.1601 398.459 36.8801C398.429 36.8701 398.399 36.86 398.369 36.85C398.229 36.8 398.049 36.7301 398.039 36.5601C398.039 36.4801 397.929 35.9801 397.859 35.6901C397.819 35.4901 397.779 35.3101 397.769 35.2601C397.769 35.2101 397.769 35.16 397.799 35.12C397.709 35.08 397.619 35.03 397.549 34.97C397.519 34.95 397.499 34.93 397.469 34.9C397.449 34.88 397.439 34.87 397.419 34.85C397.399 34.84 397.369 34.8201 397.349 34.8101C397.349 34.8301 397.349 34.85 397.349 34.87C397.409 35.07 397.379 35.3 397.279 35.48C397.169 35.66 396.989 35.79 396.779 35.84C396.419 35.95 396.279 36.2601 396.179 36.6901C396.199 36.7301 396.219 36.76 396.249 36.79C396.289 36.82 396.329 36.83 396.379 36.85C396.419 36.86 396.449 36.88 396.479 36.89C396.559 36.92 396.789 37.02 396.799 37.24C396.809 37.43 396.639 37.5501 396.499 37.6301C396.439 37.6701 396.389 37.7101 396.349 37.7601C396.309 37.8101 396.259 37.85 396.219 37.9C396.289 37.95 396.359 37.99 396.429 38.02C396.479 38.03 396.519 38.03 396.569 38.02C396.639 38.02 396.709 38.02 396.789 38.03L396.939 38.0601C398.099 38.2101 399.229 38.57 400.259 39.11C400.389 39.22 400.459 39.3901 400.419 39.5601C400.519 39.5501 400.619 39.55 400.719 39.55C400.789 39.55 400.859 39.56 400.919 39.59C400.979 39.61 401.039 39.66 401.059 39.72C401.079 39.78 401.069 39.85 401.029 39.9C400.979 39.97 400.909 40.0301 400.839 40.0701C399.879 40.0701 398.929 39.9 398.019 39.58L398.049 39.8201C398.139 39.8001 398.219 39.7701 398.309 39.7501C398.356 39.7367 398.636 39.8134 399.149 39.98C399.439 40.08 399.819 40.2 399.959 40.24C399.989 40.22 400.029 40.2101 400.059 40.2001L400.109 40.18C400.169 40.16 400.229 40.1601 400.279 40.2001C400.329 40.2301 400.359 40.29 400.359 40.35C400.359 40.38 400.359 40.4 400.359 40.43C400.379 40.54 400.359 40.65 400.309 40.74C400.209 40.89 400.079 40.87 399.159 40.64C398.889 40.57 398.539 40.49 398.419 40.47C397.789 40.86 396.979 40.8001 396.429 40.3101C396.379 40.2701 396.319 40.22 396.269 40.18C396.199 40.11 396.109 40.0501 396.019 40.0101C395.929 40.0101 395.839 40.04 395.779 40.1C395.779 40.1 395.789 40.2 395.809 40.23C396.019 40.42 396.209 40.6401 396.349 40.8801C396.639 41.3301 396.829 41.62 397.469 41.42C397.639 41.39 397.809 41.47 397.919 41.61C397.979 41.71 397.989 41.8301 397.959 41.9501C397.949 42.0201 397.899 42.08 397.829 42.12C397.729 42.19 397.649 42.2801 397.589 42.3801C397.499 42.5101 397.409 42.64 397.259 42.66C397.049 42.69 397.019 42.74 397.019 42.74C397.039 42.83 397.079 42.9201 397.129 43.0001L397.159 43.05C397.189 43.11 397.199 43.1801 397.199 43.2501C397.259 43.1901 397.319 43.1201 397.379 43.0601L397.469 42.96C397.519 42.9 397.609 42.89 397.679 42.92C397.749 42.95 397.789 43.03 397.779 43.1C397.779 43.15 397.779 43.19 397.779 43.24C397.779 43.38 397.759 43.51 397.699 43.64C397.499 44.04 397.269 44.4201 397.029 44.8101C396.959 44.9101 396.929 45.03 396.939 45.15H397.029C397.519 45.19 398.009 45.19 398.499 45.15H398.549C398.809 45.07 399.099 45.1 399.329 45.24C399.449 45.32 399.729 45.5301 399.699 45.7601C399.649 46.0001 399.459 46.1901 399.229 46.2501C398.999 46.3001 398.779 46.3801 398.579 46.5001C398.449 46.5701 398.309 46.6301 398.169 46.6901C397.909 46.7901 397.909 46.87 397.919 47.15L397.739 47.1901H397.559V47.22ZM402.009 38.6901C402.099 38.6901 402.189 38.73 402.259 38.79L402.239 38.6301C402.149 38.6401 402.069 38.6601 401.989 38.6901C401.979 38.6901 401.969 38.6901 401.959 38.7001C401.979 38.7001 401.999 38.7001 402.009 38.7001V38.6901ZM400.189 37.3101C400.189 37.3101 400.199 37.33 400.229 37.37C400.309 37.5 400.349 37.64 400.339 37.79V37.83C400.339 37.83 400.339 37.8701 400.349 37.8801C400.349 37.8801 400.379 37.88 400.409 37.86C400.489 37.84 400.559 37.81 400.639 37.78C400.989 37.61 401.399 37.57 401.769 37.68C402.139 37.46 402.599 37.46 402.979 37.68C402.999 37.68 403.019 37.68 403.029 37.68C403.209 37.65 403.269 37.61 403.289 37.58C403.319 37.5 403.209 37.2901 402.959 36.9501C402.929 36.9001 402.759 36.67 402.859 36.49C402.949 36.34 403.059 36.2 403.209 36.09C403.319 36 403.459 35.96 403.599 35.96C403.739 35.96 403.799 36.09 403.839 36.18L403.869 36.23C403.869 36.23 403.919 36.31 403.939 36.35C403.969 36.33 403.999 36.31 404.029 36.29C404.069 36.06 404.249 35.88 404.479 35.85C404.549 35.84 404.609 35.82 404.669 35.79C404.669 35.79 404.659 35.76 404.659 35.74C404.629 35.53 404.649 35.32 404.719 35.12C404.629 34.6 404.399 34.12 404.069 33.72C403.929 33.6 403.839 33.43 403.799 33.24C403.759 33.32 403.719 33.3901 403.679 33.4501C403.609 33.5701 403.539 33.69 403.459 33.8C403.399 33.88 403.329 33.9501 403.249 34.0101C403.219 34.0301 403.199 34.06 403.169 34.08C403.129 34.12 403.069 34.1401 403.019 34.1301C402.969 34.1201 402.919 34.09 402.889 34.03L402.839 33.93C402.779 33.83 402.739 33.7301 402.699 33.6301C402.669 33.5101 402.679 33.3801 402.729 33.2601C402.859 32.9201 402.769 32.72 402.399 32.49C402.079 32.3 401.069 31.63 401.199 30.92C401.069 30.99 400.949 31.07 400.829 31.15C400.409 31.46 399.929 31.68 399.429 31.8C399.409 31.8 399.429 31.86 399.489 31.9C399.909 32.21 400.209 32.66 400.329 33.17C400.349 33.31 400.299 33.45 400.199 33.55C400.129 33.61 400.069 33.6801 400.019 33.7501C400.029 33.7501 400.079 33.78 400.219 33.83C400.709 34 401.209 34.13 401.729 34.22C402.049 34.33 402.359 34.48 402.649 34.67C402.919 34.84 403.199 34.99 403.499 35.1C403.629 35.14 403.739 35.22 403.799 35.34C403.819 35.37 403.839 35.4 403.869 35.42C403.899 35.46 403.919 35.5 403.919 35.55C403.919 35.6 403.889 35.65 403.859 35.68C403.829 35.7 403.809 35.7301 403.779 35.7501C403.699 35.8401 403.609 35.9101 403.499 35.9501C403.369 35.9801 403.239 35.97 403.109 35.93L403.039 35.91C402.689 35.81 402.319 35.84 401.989 35.99C401.769 36.1 401.189 36.12 401.049 35.87C400.809 35.44 399.979 34.9301 399.799 35.0001C399.429 35.0801 399.039 35 398.729 34.78C398.659 34.72 398.629 34.62 398.659 34.53C398.729 34.35 398.699 34.3401 398.509 34.2501C398.419 34.2101 398.329 34.16 398.259 34.1C398.229 34.07 398.189 34.01 398.129 34.03C398.079 34.03 398.029 34.09 397.969 34.17C397.939 34.21 397.929 34.2301 398.019 34.3201C398.079 34.3701 398.119 34.45 398.119 34.53C398.199 34.57 398.249 34.65 398.239 34.74C398.239 34.89 398.189 35.0301 398.089 35.1301C398.129 35.1501 398.159 35.18 398.169 35.21C398.179 35.24 398.189 35.27 398.189 35.3C398.459 35.48 398.699 35.68 398.929 35.9C399.109 36.08 399.309 36.24 399.519 36.39C399.639 36.43 399.739 36.53 399.779 36.65C399.789 36.7 399.799 36.7601 399.779 36.8101C399.829 36.8101 399.879 36.8101 399.919 36.8201C400.169 36.8401 400.299 36.85 400.339 36.99C400.359 37.07 400.329 37.1501 400.269 37.2001C400.229 37.2201 400.199 37.25 400.169 37.28L400.189 37.3101ZM403.669 32.4401C403.799 32.4901 403.899 32.59 403.939 32.72C403.939 32.74 403.949 32.77 403.949 32.79C403.969 32.77 403.979 32.75 403.999 32.73C404.039 32.65 404.059 32.56 404.059 32.48C403.959 32.45 403.859 32.44 403.749 32.42L403.659 32.4401H403.669Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.779 45.87L402.109 45.41C401.779 45.27 401.429 45.18 401.079 45.12C400.849 45.06 400.849 45.3 400.859 45.47C400.879 45.72 401.429 45.81 401.779 45.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.779 46.04C401.779 46.04 401.759 46.04 401.749 46.04H401.699C401.279 45.96 400.709 45.86 400.689 45.48C400.659 45.31 400.699 45.13 400.819 45C400.909 44.93 401.019 44.91 401.129 44.94C401.179 44.95 401.259 44.97 401.349 44.99C401.649 45.03 401.939 45.12 402.219 45.26C402.259 45.29 402.289 45.33 402.289 45.38C402.289 45.43 402.289 45.48 402.259 45.52L401.929 45.98C401.929 45.98 401.839 46.05 401.789 46.05L401.779 46.04ZM401.039 45.29C401.039 45.34 401.039 45.4 401.039 45.45C401.069 45.52 401.289 45.59 401.699 45.66L401.839 45.47C401.669 45.42 401.439 45.37 401.269 45.33C401.179 45.31 401.089 45.29 401.039 45.28V45.29Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.81 36.9501L398.47 36.77C398.41 36.86 398.37 36.9701 398.35 37.0701C398.35 37.1301 398.51 37.24 398.55 37.23C398.64 37.19 398.7 37.0801 398.82 36.9401L398.81 36.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.529 37.4201C398.469 37.4201 398.409 37.4001 398.359 37.3601C398.249 37.3001 398.179 37.2 398.159 37.08C398.159 36.97 398.199 36.87 398.259 36.78C398.269 36.75 398.289 36.7301 398.299 36.7001C398.319 36.6601 398.359 36.6201 398.399 36.6101C398.449 36.5901 398.499 36.6001 398.539 36.6101L398.879 36.78C398.879 36.78 398.959 36.85 398.969 36.91C398.979 36.96 398.969 37.0201 398.929 37.0601C398.889 37.1001 398.859 37.1401 398.839 37.1701C398.779 37.2601 398.699 37.33 398.599 37.39C398.569 37.4 398.539 37.41 398.519 37.41L398.529 37.4201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.749 45.66C401.749 45.66 401.669 45.6001 401.619 45.5701C401.619 45.5701 401.589 45.59 401.569 45.59C401.599 45.63 401.629 45.68 401.659 45.72L401.749 45.66Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M401.649 45.9C401.649 45.9 401.549 45.88 401.519 45.84C401.489 45.8 401.459 45.76 401.429 45.71C401.399 45.66 401.389 45.6101 401.399 45.5601C401.409 45.5101 401.439 45.4701 401.489 45.4401C401.549 45.3901 401.639 45.3801 401.709 45.4201C401.749 45.4401 401.779 45.4701 401.819 45.5001C401.869 45.5401 401.909 45.6001 401.909 45.6601C401.909 45.7201 401.889 45.7801 401.849 45.8201L401.799 45.8501C401.799 45.8501 401.699 45.9001 401.649 45.9101V45.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M407.959 29.08C407.619 29.26 407.269 29.42 406.919 29.56C406.549 29.42 406.089 29.63 406.019 29.07C406.019 29.01 405.859 28.97 405.769 28.91C405.589 28.81 405.419 28.68 405.269 28.54C405.029 28.26 405.079 28.18 405.429 27.99C405.609 27.88 405.779 27.75 405.929 27.61C406.169 27.35 406.579 27.32 406.849 27.54", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M406.909 29.75C406.909 29.75 406.869 29.75 406.849 29.74C406.749 29.71 406.649 29.69 406.539 29.69C406.289 29.67 405.919 29.64 405.839 29.16L405.789 29.14C405.789 29.14 405.699 29.09 405.649 29.07C405.599 29.04 405.559 29.01 405.509 28.98C405.369 28.9 405.229 28.79 405.119 28.67C404.989 28.56 404.929 28.4 404.929 28.23C404.959 28.05 405.129 27.95 405.329 27.84C405.469 27.76 405.599 27.66 405.709 27.55L405.789 27.48C406.099 27.16 406.589 27.13 406.939 27.4C407.009 27.46 407.029 27.57 406.969 27.65C406.909 27.73 406.799 27.74 406.719 27.69C406.619 27.61 406.489 27.56 406.359 27.58C406.229 27.59 406.109 27.66 406.019 27.76L405.939 27.83C405.799 27.96 405.649 28.07 405.489 28.17C405.409 28.21 405.339 28.25 405.269 28.31C405.269 28.31 405.299 28.35 405.379 28.45C405.469 28.55 405.579 28.63 405.689 28.69C405.739 28.72 405.789 28.76 405.839 28.79C405.869 28.81 405.889 28.82 405.919 28.83C406.019 28.88 406.139 28.93 406.159 29.07C406.189 29.31 406.259 29.32 406.539 29.34C406.649 29.34 406.759 29.36 406.869 29.39C406.949 29.36 407.029 29.32 407.109 29.29C407.359 29.19 407.599 29.08 407.829 28.95C407.889 28.92 407.949 28.92 408.009 28.95C408.069 28.98 408.099 29.04 408.099 29.1C408.099 29.16 408.069 29.22 408.009 29.26C407.759 29.4 407.509 29.52 407.239 29.62C407.139 29.66 407.039 29.7 406.939 29.75C406.919 29.76 406.889 29.77 406.869 29.77L406.909 29.75Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M400.949 29.2501H401.079C401.829 29.2101 401.929 29.2601 402.169 29.9501C402.169 30.0401 402.129 30.12 402.049 30.16C401.849 30.23 401.639 30.2801 401.429 30.3101C400.939 30.3401 400.479 30.58 400.169 30.96C400.069 31.09 399.939 31.2201 399.749 31.0601C399.539 30.8801 399.159 30.84 399.159 30.47C399.159 30.39 399.299 30.2801 399.399 30.2501C399.579 30.1901 399.829 30.2501 399.939 30.1301C400.039 30.0301 400.009 29.78 400.009 29.59C400.009 29.38 400.099 29.28 400.309 29.27C400.519 29.27 400.729 29.2501 400.939 29.2401L400.949 29.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M399.93 31.3201C399.82 31.3201 399.72 31.2701 399.65 31.2001C399.59 31.1501 399.53 31.1101 399.46 31.0801C399.2 30.9901 399.01 30.7501 399 30.4701C399 30.2701 399.229 30.1201 399.359 30.0701C399.449 30.0401 399.55 30.0301 399.64 30.0301C399.7 30.0301 399.77 30.0301 399.83 30.0001C399.85 29.9001 399.86 29.8001 399.85 29.7101V29.5901C399.83 29.4601 399.88 29.3301 399.97 29.2301C400.06 29.1301 400.19 29.0901 400.32 29.0901C400.46 29.0901 400.61 29.0801 400.76 29.0701H400.93C400.93 29.0701 400.95 29.0601 400.96 29.0601H401.09C401.93 29.0101 402.089 29.1201 402.359 29.8801C402.379 29.9601 402.37 30.0401 402.33 30.1201C402.29 30.2101 402.22 30.2801 402.13 30.3201C401.92 30.4001 401.7 30.4501 401.48 30.4801C401.04 30.5001 400.62 30.7201 400.34 31.0601C400.26 31.1901 400.13 31.2801 399.98 31.3001C399.97 31.3001 399.96 31.3001 399.94 31.3001L399.93 31.3201ZM400.99 29.4301C400.99 29.4301 400.97 29.4301 400.96 29.4301H400.77C400.62 29.4501 400.47 29.4601 400.32 29.4601C400.22 29.4601 400.2 29.4601 400.2 29.6001V29.7101C400.23 29.9001 400.19 30.1001 400.08 30.2601C399.96 30.3501 399.81 30.4001 399.66 30.3901C399.59 30.3901 399.53 30.4001 399.47 30.4201C399.42 30.4401 399.38 30.4701 399.35 30.5101C399.35 30.6101 399.43 30.6601 399.63 30.7601C399.72 30.8001 399.81 30.8601 399.89 30.9201C399.92 30.9501 399.94 30.9501 399.94 30.9501C399.94 30.9501 399.969 30.9501 400.049 30.8401C400.389 30.4201 400.89 30.1601 401.43 30.1201C401.63 30.0901 401.82 30.0501 402.01 29.9801C402.01 29.9801 402 29.9801 402.01 29.9601C401.8 29.3801 401.769 29.3701 401.109 29.4001H401.01L400.99 29.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.779 32.3201C398.789 32.8101 399.019 33.38 398.609 33.24C398.529 33.21 397.909 32.8501 397.839 32.8101C397.589 32.6901 397.899 32.97 397.749 33.3C397.729 33.35 397.569 33.3801 397.559 33.3701C397.429 33.1301 397.209 32.4501 397.099 32.2001C396.999 32.2001 396.899 32.2 396.799 32.22C397.289 32.23 397.419 31.97 397.369 31.53C397.369 31.47 397.499 31.34 397.529 31.35C397.939 31.5 398.399 31.5901 398.649 32.0101C398.699 32.1101 398.739 32.2101 398.779 32.3201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.569 33.55C397.499 33.55 397.439 33.51 397.399 33.46C397.289 33.22 397.189 32.98 397.109 32.73C397.059 32.6 397.019 32.48 396.979 32.39C396.919 32.39 396.859 32.4 396.799 32.39C396.709 32.39 396.629 32.32 396.619 32.23C396.609 32.14 396.669 32.06 396.749 32.04C396.839 32.02 396.939 32.0101 397.029 32.0101C397.069 32.0001 397.099 31.9801 397.129 31.9501C397.199 31.8301 397.219 31.69 397.189 31.55C397.169 31.39 397.339 31.26 397.369 31.23C397.429 31.17 397.519 31.15 397.589 31.18C397.649 31.2 397.719 31.2201 397.779 31.2501C398.189 31.3401 398.559 31.58 398.799 31.92C398.849 32 398.889 32.09 398.909 32.18L398.929 32.2501C398.929 32.2501 398.939 32.2901 398.939 32.3101C398.939 32.4401 398.959 32.5601 398.979 32.6901C399.019 33.0001 399.059 33.24 398.889 33.37C398.779 33.45 398.649 33.46 398.529 33.4C398.469 33.38 398.319 33.3 397.969 33.1L397.939 33.08C397.939 33.18 397.919 33.28 397.879 33.37C397.809 33.53 397.549 33.55 397.539 33.55H397.569ZM397.749 32.6C397.809 32.6 397.859 32.62 397.909 32.65C397.939 32.66 398.039 32.72 398.169 32.79C398.329 32.88 398.619 33.0501 398.669 33.0701C398.669 32.9601 398.659 32.85 398.639 32.74C398.619 32.62 398.599 32.48 398.599 32.35L398.579 32.3C398.559 32.23 398.529 32.16 398.499 32.1C398.299 31.83 397.999 31.65 397.669 31.58C397.629 31.57 397.589 31.55 397.559 31.54C397.599 31.77 397.549 32.0001 397.409 32.1901C397.389 32.2201 397.359 32.2401 397.329 32.2601C397.369 32.3601 397.409 32.48 397.459 32.6C397.509 32.74 397.569 32.89 397.619 33.02C397.619 32.98 397.599 32.95 397.589 32.91C397.549 32.82 397.559 32.7001 397.639 32.6301C397.679 32.6001 397.719 32.58 397.769 32.58L397.749 32.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M395.819 39.2501C395.659 39.2101 395.539 39.15 395.459 39.18C395.099 39.29 395.039 39.1201 395.029 38.8101C395.029 38.3501 395.009 38.37 395.459 38.53C395.779 38.63 396.099 38.71 396.429 38.78C396.489 38.79 396.549 38.8001 396.609 38.8201C396.559 38.8801 396.529 38.96 396.469 38.99C396.239 39.09 396.009 39.1801 395.819 39.2601V39.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M395.819 39.43C395.819 39.43 395.789 39.43 395.779 39.43C395.719 39.42 395.659 39.4001 395.609 39.3801C395.569 39.3701 395.539 39.36 395.499 39.35C395.349 39.42 395.169 39.4001 395.029 39.3201C394.889 39.1901 394.829 39.0001 394.849 38.8201C394.849 38.5301 394.849 38.39 394.959 38.3C395.079 38.21 395.219 38.26 395.459 38.35L395.509 38.37C395.719 38.44 395.939 38.5 396.169 38.54C396.269 38.56 396.369 38.58 396.469 38.61C396.509 38.61 396.549 38.6301 396.589 38.6301H396.649C396.709 38.6501 396.759 38.7001 396.779 38.7601C396.799 38.8201 396.789 38.88 396.749 38.93C396.739 38.94 396.729 38.96 396.719 38.98C396.679 39.05 396.619 39.11 396.549 39.15C396.379 39.23 396.209 39.3 396.049 39.36L395.889 39.43C395.889 39.43 395.849 39.44 395.819 39.44V39.43ZM395.499 38.99C395.569 38.99 395.649 39.01 395.719 39.03C395.749 39.03 395.779 39.05 395.809 39.06L395.919 39.02C396.009 38.98 396.099 38.95 396.199 38.91L396.099 38.89C395.859 38.84 395.629 38.7801 395.399 38.7001L395.349 38.68C395.349 38.68 395.259 38.6501 395.219 38.6301C395.219 38.6701 395.219 38.72 395.219 38.77C395.219 39 395.249 39.03 395.259 39.03C395.309 39.03 395.369 39.0301 395.419 39.0101C395.449 39.0101 395.479 39 395.519 39L395.499 38.99Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M402.789 30.95C402.709 31.15 402.609 31.34 402.489 31.51C402.429 31.58 401.949 30.99 401.939 30.81C401.939 30.51 402.159 30.55 402.339 30.54C402.529 30.54 402.789 30.43 402.789 30.95Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M402.469 31.7C402.469 31.7 402.429 31.7 402.419 31.7C402.109 31.49 401.879 31.18 401.779 30.82C401.769 30.7 401.809 30.58 401.889 30.49C401.999 30.4 402.149 30.35 402.289 30.37H402.419C402.569 30.33 402.719 30.37 402.829 30.46C402.949 30.6 403.009 30.78 402.989 30.96C402.989 30.99 402.989 31.01 402.969 31.04C402.959 31.06 402.949 31.09 402.929 31.13C402.859 31.31 402.759 31.47 402.649 31.63C402.609 31.68 402.549 31.71 402.479 31.7H402.469ZM402.129 30.74C402.129 30.74 402.129 30.79 402.129 30.81C402.209 30.98 402.319 31.14 402.449 31.27C402.499 31.18 402.549 31.08 402.589 30.98L402.619 30.92C402.619 30.76 402.579 30.73 402.579 30.73C402.569 30.72 402.479 30.73 402.439 30.73C402.409 30.73 402.379 30.73 402.349 30.73H402.279C402.279 30.73 402.179 30.73 402.129 30.74Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M395.729 42.29C395.509 42.21 395.809 42.0501 395.669 42.0001L396.159 41.29C396.299 41.48 396.029 41.76 396.129 41.97C396.149 42.01 395.879 42.18 395.739 42.29H395.729Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M395.729 42.4701C395.729 42.4701 395.689 42.4701 395.669 42.4601C395.589 42.4301 395.519 42.3701 395.489 42.2901C395.469 42.2201 395.469 42.1401 395.509 42.0701V42.0501C395.489 42.0001 395.499 41.9401 395.529 41.9001L396.019 41.1901C396.019 41.1901 396.109 41.1101 396.159 41.1101C396.219 41.1101 396.269 41.1401 396.309 41.1801C396.399 41.3401 396.409 41.5301 396.329 41.6901C396.299 41.7501 396.289 41.8201 396.299 41.8901C396.369 42.0501 396.239 42.1501 396.009 42.3101C395.959 42.3501 395.899 42.3901 395.859 42.4201C395.829 42.4401 395.789 42.4601 395.749 42.4601L395.729 42.4701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.71 46.36L397.29 45.9C397.45 45.84 397.61 45.79 397.78 45.74C397.98 45.7 398.14 45.79 398.09 46C398.06 46.11 397.89 46.19 397.71 46.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.709 46.5401C397.709 46.5401 397.619 46.5201 397.589 46.4801L397.169 46.02C397.169 46.02 397.109 45.9101 397.129 45.8501C397.149 45.7901 397.189 45.7401 397.249 45.7301L397.389 45.6801C397.509 45.6301 397.629 45.6001 397.749 45.5701C397.899 45.5301 398.069 45.5701 398.179 45.6801C398.269 45.7801 398.299 45.9201 398.259 46.0501C398.209 46.1801 398.119 46.2901 397.999 46.3601C397.949 46.4001 397.889 46.4401 397.839 46.4901C397.809 46.5201 397.759 46.5401 397.719 46.5401H397.709ZM397.609 45.9801L397.729 46.1101L397.779 46.0701C397.829 46.0401 397.879 46.0001 397.919 45.9501C397.919 45.9101 397.879 45.9001 397.819 45.9101C397.749 45.9301 397.679 45.9501 397.609 45.9701V45.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.609 43.9501C396.639 44.0901 396.709 44.2301 396.679 44.2601C396.519 44.4001 396.339 44.53 396.149 44.64C396.109 44.66 396.009 44.57 395.939 44.54C395.969 44.48 396.009 44.4201 396.059 44.3701C396.219 44.2401 396.389 44.12 396.609 43.96V43.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M396.13 44.8201C396.05 44.8201 395.97 44.7801 395.91 44.7301C395.89 44.7201 395.87 44.7001 395.85 44.6901C395.8 44.6701 395.77 44.6201 395.76 44.5701C395.75 44.5201 395.76 44.4701 395.79 44.4201L395.82 44.3701C395.85 44.3101 395.89 44.26 395.94 44.21C396.05 44.12 396.17 44.0301 396.3 43.9301L396.49 43.7901C396.49 43.7901 396.6 43.7401 396.66 43.7601C396.72 43.7801 396.76 43.83 396.77 43.89C396.78 43.93 396.8 43.98 396.81 44.02C396.85 44.15 396.89 44.2801 396.79 44.3701C396.62 44.5201 396.43 44.66 396.23 44.77C396.2 44.79 396.16 44.8001 396.13 44.8001V44.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M397.85 38.73L398.21 39.03C398.16 39.05 398.09 39.11 398.06 39.1C397.96 39.05 397.87 38.99 397.79 38.91C397.78 38.9 397.82 38.83 397.86 38.73H397.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M398.059 39.28C398.059 39.28 397.999 39.28 397.979 39.26C397.869 39.2 397.759 39.13 397.659 39.04C397.549 38.95 397.609 38.82 397.639 38.75C397.649 38.73 397.659 38.7 397.679 38.66C397.699 38.61 397.749 38.57 397.799 38.55C397.859 38.54 397.909 38.55 397.959 38.59L398.319 38.89C398.319 38.89 398.389 38.99 398.379 39.05C398.369 39.11 398.329 39.16 398.279 39.19C398.219 39.24 398.139 39.27 398.059 39.28Z", fill: "#FF2A45" }));
const SvgStripe$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 208, height: 82, viewBox: "0 0 208 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M58.8696 0.135742H57.8696V81.4957H58.8696V0.135742Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M207.519 40.9557C207.519 32.4657 203.409 25.7657 195.549 25.7657C187.689 25.7657 182.879 32.4657 182.879 40.8857C182.879 50.8657 188.519 55.9058 196.609 55.9058C200.559 55.9058 203.539 55.0057 205.799 53.7457V47.1157C203.549 48.2457 200.959 48.9357 197.679 48.9357C194.399 48.9357 191.609 47.8058 191.249 43.8958H207.459C207.459 43.4658 207.529 41.7357 207.529 40.9457L207.519 40.9557ZM191.139 37.8057C191.139 34.0557 193.429 32.4957 195.519 32.4957C197.609 32.4957 199.699 34.0557 199.699 37.8057H191.139Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { d: "M170.08 25.7657C166.83 25.7657 164.74 27.2958 163.58 28.3558L163.15 26.2958H155.85V64.9557L164.14 63.1957L164.17 53.8157C165.36 54.6757 167.12 55.9058 170.04 55.9058C175.98 55.9058 181.38 51.1357 181.38 40.6157C181.35 30.9957 175.88 25.7557 170.07 25.7557L170.08 25.7657ZM168.09 48.6157C166.13 48.6157 164.97 47.9157 164.18 47.0557L164.15 34.7557C165.01 33.7957 166.21 33.1357 168.1 33.1357C171.12 33.1357 173.21 36.5157 173.21 40.8657C173.21 45.2157 171.15 48.6257 168.1 48.6257L168.09 48.6157Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M144.45 23.8157L152.77 22.0258V15.2858L144.45 17.0458V23.8157Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { d: "M152.77 26.3357H144.45V55.3457H152.77V26.3357Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M135.53 28.7858L135 26.3358H127.84V55.3458H136.13V35.6857C138.09 33.1357 141.4 33.5958 142.43 33.9658V26.3358C141.37 25.9358 137.49 25.2058 135.53 28.7858Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M118.95 19.1357L110.86 20.8558L110.83 47.4158C110.83 52.3258 114.51 55.9357 119.42 55.9357C122.14 55.9357 124.13 55.4358 125.22 54.8458V48.1157C124.16 48.5457 118.92 50.0758 118.92 45.1658V33.3958H125.22V26.3358H118.92L118.95 19.1357Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M96.5296 34.7557C96.5296 33.4657 97.5896 32.9658 99.3496 32.9658C101.87 32.9658 105.05 33.7258 107.57 35.0858V27.2958C104.82 26.2058 102.1 25.7657 99.3496 25.7657C92.6196 25.7657 88.1396 29.2758 88.1396 35.1458C88.1396 44.2958 100.74 42.8358 100.74 46.7858C100.74 48.3158 99.4097 48.8057 97.5597 48.8057C94.8097 48.8057 91.2897 47.6758 88.5097 46.1558V54.0458C91.5897 55.3758 94.7097 55.9357 97.5597 55.9357C104.46 55.9357 109.2 52.5158 109.2 46.5858C109.17 36.7058 96.5296 38.4657 96.5296 34.7457V34.7557Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { d: "M21.6698 18.7257C19.8998 15.7857 17.0398 14.1057 12.8398 14.1057C4.97982 14.1557 0.319824 20.4057 0.319824 29.0757C0.319824 37.7457 4.96982 43.9957 12.8398 43.9957C14.2798 44.0757 15.7298 43.8257 17.0698 43.2657C18.4098 42.7057 19.6098 41.8457 20.5798 40.7557V44.9257C20.5798 47.7657 19.0798 51.1357 14.3198 51.1357C10.7098 51.1357 8.92982 49.1157 8.30982 46.9457L1.92982 50.0357C3.52982 54.1357 7.34982 57.5757 14.7698 57.5757C25.7698 57.5757 28.5998 50.1557 28.5998 43.6557V14.5157H21.8698L21.6898 18.7157L21.6698 18.7257ZM14.5598 37.1957C10.6298 37.1957 8.30982 33.9957 8.30982 29.0157C8.30982 24.0357 10.6298 20.8357 14.5598 20.8357C18.4898 20.8357 20.7598 24.0357 20.7598 29.0157C20.7598 33.9957 18.4898 37.1957 14.5598 37.1957Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.5898 59.8457V69.7357H0.569824V63.8957H22.8598V59.8457H28.5798H28.5898Z", fill: "#5532FA" }));
const SvgBennie = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 436, height: 83, viewBox: "0 0 436 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M435.09 40.07C435.09 34.3 430.98 26.72 421.68 26.72C413.57 26.72 407.9 33.27 407.9 41.23V41.33C407.9 49.86 414.09 55.73 422.46 55.73C426.51 55.73 429.69 54.43 432.13 52.35C432.7 51.83 433.17 51.05 433.17 50.01C433.17 48.24 431.87 46.89 430.1 46.89C429.27 46.89 428.75 47.1 428.17 47.51C426.56 48.71 424.74 49.38 422.55 49.38C419.02 49.38 416.52 47.51 415.74 43.92H431.22C433.22 43.92 435.08 42.23 435.08 40.06L435.09 40.07ZM415.51 38.05C416.41 34.89 418.55 32.9 421.68 32.9C424.81 32.9 426.95 34.94 427.73 38.05H415.51Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M402.05 24.84C404.414 24.84 406.33 22.9237 406.33 20.56C406.33 18.1962 404.414 16.28 402.05 16.28C399.686 16.28 397.77 18.1962 397.77 20.56C397.77 22.9237 399.686 24.84 402.05 24.84Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M402.05 26.9299C399.87 26.9299 398.1 28.7 398.1 30.88V45.07H398.08V45.33C398.08 45.33 398.08 47.88 395.8 47.88C393.78 47.88 393.78 45.36 393.78 45.31C393.78 45.31 393.78 45.19 393.78 45.11C393.78 45.1 393.78 45.09 393.78 45.07V37.06C393.78 30.66 390.3 26.71 384.32 26.71C380.32 26.71 377.97 28.8399 376.16 31.1799V30.8699C376.16 28.6899 374.39 26.92 372.21 26.92C370.03 26.92 368.26 28.6899 368.26 30.8699V45.33C368.26 45.33 368.26 47.88 365.98 47.88C363.96 47.88 363.96 45.36 363.96 45.31C363.96 45.31 363.95 45.15 363.95 45.07V37.06C363.95 30.66 360.47 26.71 354.49 26.71C350.49 26.71 348.14 28.8399 346.33 31.1799V30.8699C346.33 28.6899 344.56 26.92 342.38 26.92C340.2 26.92 338.43 28.6899 338.43 30.8699V51.46C338.43 53.64 340.2 55.41 342.38 55.41C344.56 55.41 346.33 53.64 346.33 51.46V39.55C346.33 35.81 348.26 33.88 351.27 33.88C354.28 33.88 356.05 35.81 356.05 39.55V45.2C356.05 45.68 356.05 49.97 359.01 52.99C360.23 54.24 362.43 55.7299 365.94 55.7299C365.96 55.7299 365.98 55.7299 366 55.7299C366 55.7299 366.02 55.7299 366.03 55.7299C369.65 55.6999 371.91 54.19 373.17 52.91C376.14 49.89 376.18 45.6999 376.17 45.2299V39.56C376.17 35.82 378.09 33.89 381.11 33.89C384.13 33.89 385.89 35.82 385.89 39.56V45.07C385.89 45.07 385.9 45.16 385.9 45.2C385.9 45.68 385.9 49.97 388.85 52.99C390.07 54.23 392.24 55.7 395.69 55.72C395.69 55.72 395.71 55.72 395.72 55.72C395.74 55.72 395.76 55.72 395.78 55.72H395.83C399.48 55.7 401.75 54.1799 403.02 52.8999C405.99 49.8799 406.03 45.69 406.02 45.22C406.02 45.16 406.03 45.11 406.03 45.06V30.8699C406.03 28.6899 404.26 26.92 402.08 26.92L402.05 26.9299Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M322.91 26.72C314.8 26.72 309.13 33.2699 309.13 41.2299V41.33C309.13 49.86 315.32 55.7299 323.69 55.7299C327.74 55.7299 330.92 54.43 333.36 52.35C333.93 51.83 334.4 51.0499 334.4 50.0099C334.4 48.2399 333.1 46.89 331.33 46.89C330.5 46.89 329.98 47.0999 329.4 47.5099C327.79 48.7099 325.97 49.38 323.78 49.38C320.25 49.38 317.75 47.51 316.97 43.92H332.45C334.45 43.92 336.3 42.23 336.3 40.06C336.3 34.29 332.19 26.71 322.89 26.71L322.91 26.72ZM316.75 38.05C317.65 34.89 319.79 32.8999 322.92 32.8999C326.05 32.8999 328.19 34.94 328.97 38.05H316.75Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M303.33 35.07C304.71 33.14 305.52 30.77 305.52 28.22C305.52 21.69 300.19 16.38 293.65 16.38H282.18C279.99 16.38 278.21 18.16 278.21 20.35V51.86C278.21 52.91 278.63 53.92 279.37 54.66C280.11 55.4 281.12 55.82 282.17 55.82H295.52C302.07 55.82 307.39 50.51 307.39 43.98C307.39 40.43 305.82 37.24 303.32 35.07H303.33ZM286.14 24.32H293.65C295.83 24.32 297.6 26.07 297.6 28.23C297.6 30.39 295.83 32.14 293.65 32.14H286.14V24.33V24.32ZM295.52 47.89H286.14V40.08H295.52C297.7 40.08 299.47 41.83 299.47 43.99C299.47 46.15 297.7 47.9 295.52 47.9V47.89Z", fill: "#15385A" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.01C19.58 28.07 16.72 26.39 12.52 26.39C4.66 26.44 0 32.69 0 41.36C0 50.03 4.65 56.28 12.52 56.28C13.96 56.36 15.41 56.11 16.75 55.55C18.09 54.99 19.29 54.13 20.26 53.04V57.21C20.26 60.05 18.76 63.42 14 63.42C10.39 63.42 8.61 61.4 7.99 59.23L1.6 62.32C3.2 66.42 7.02 69.86 14.44 69.86C25.44 69.86 28.27 62.44 28.27 55.94V26.8H21.54L21.36 31L21.35 31.01ZM14.24 49.48C10.31 49.48 7.99 46.28 7.99 41.3C7.99 36.32 10.31 33.12 14.24 33.12C18.17 33.12 20.44 36.32 20.44 41.3C20.44 46.28 18.17 49.48 14.24 49.48Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.34C176.63 26.34 175.11 26.68 173.73 27.36C172.34 28.04 171.12 29.02 170.16 30.25L169.64 26.81H162.53V55.82H170.83V39.44C170.83 34.91 172.51 33.14 175.84 33.14C178.16 33.14 180.08 34.17 180.08 38.59V55.83H188.38V36.9C188.38 30.77 184.58 26.35 178.16 26.35L178.17 26.34Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.17C49.6201 47.15 47.9401 49.47 44.6201 49.47C42.3001 49.47 40.3601 48.44 40.3601 44.02V26.8H32.0601V45.69C32.0601 51.81 35.8601 56.26 42.2801 56.26C43.8201 56.26 45.3401 55.91 46.7301 55.23C48.1201 54.55 49.3401 53.56 50.3001 52.34L50.8201 55.79H57.9101V26.8H49.6101V43.17H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.81H62.2798V55.82H70.5798V26.81Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.94C91.6001 27.21 89.0201 26.34 86.4001 26.49C78.5001 26.49 73.8301 32.75 73.8301 41.41C73.8301 50.07 78.5001 56.33 86.4001 56.33C88.0801 56.44 89.7601 56.1 91.2701 55.34C92.7801 54.58 94.0701 53.43 95.0101 52L95.2101 55.82H101.94V13.34H93.6401L93.6001 28.94H93.6101ZM88.2101 49.48C84.2801 49.48 81.9601 46.28 81.9601 41.3C81.9601 36.32 84.2801 33.12 88.2101 33.12C92.1401 33.12 94.4601 36.32 94.4601 41.3C94.4601 46.28 92.1401 49.48 88.2101 49.48Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.64C65.5099 12.64 64.6199 12.92 63.8599 13.43C63.0999 13.95 62.5099 14.68 62.1599 15.55C61.8099 16.41 61.7199 17.36 61.8999 18.27C62.0799 19.18 62.5199 20.02 63.1699 20.68C63.8199 21.34 64.6399 21.79 65.5399 21.97C66.4399 22.15 67.3699 22.06 68.2099 21.7C69.0599 21.34 69.7799 20.74 70.2899 19.96C70.7999 19.18 71.0699 18.27 71.0699 17.34C71.0699 16.09 70.5799 14.89 69.7099 14.01C68.8399 13.13 67.6599 12.63 66.4399 12.63L66.4299 12.64Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.81H149.84V55.82H158.14V26.81Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.64C153.08 12.64 152.19 12.92 151.43 13.43C150.67 13.95 150.08 14.68 149.72 15.55C149.37 16.41 149.28 17.36 149.46 18.27C149.64 19.18 150.08 20.02 150.73 20.68C151.38 21.34 152.2 21.79 153.1 21.97C154 22.15 154.93 22.06 155.77 21.7C156.62 21.34 157.34 20.74 157.85 19.96C158.36 19.18 158.63 18.27 158.63 17.34C158.63 16.09 158.14 14.89 157.27 14.01C156.4 13.13 155.22 12.63 154 12.63V12.64Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.24V41.36C218.63 32.4 213.58 26.44 205.25 26.44C196.92 26.44 191.31 32.4 191.31 41.36C191.31 50.32 196.93 56.28 205.25 56.28C211.01 56.28 215.3 53.49 217.33 48.78L211.32 45.88C210.93 47.14 210.14 48.22 209.08 48.98C208.02 49.74 206.75 50.12 205.45 50.07C203.92 50.11 202.42 49.56 201.28 48.52C200.14 47.48 199.42 46.03 199.29 44.48H199.35L218.63 42.25V42.24ZM199.09 39.31C199.09 35.1 201.55 32.34 205.22 32.34C206.73 32.31 208.19 32.88 209.31 33.91C210.43 34.95 211.11 36.38 211.23 37.91L199.09 39.31Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.44C110.47 26.44 104.85 32.4 104.85 41.36C104.85 50.32 110.47 56.28 118.8 56.28C124.55 56.28 128.84 53.49 130.82 48.78L124.81 45.88C124.42 47.12 123.65 48.19 122.61 48.95C121.57 49.7 120.32 50.1 119.05 50.07C117.5 50.14 115.99 49.59 114.83 48.55C113.67 47.51 112.94 46.05 112.81 44.48L132.05 42.23V41.35C132.17 32.41 127.12 26.45 118.8 26.45V26.44ZM112.61 39.32C112.61 35.11 115.02 32.35 118.75 32.35C120.26 32.32 121.72 32.89 122.84 33.92C123.96 34.96 124.64 36.39 124.76 37.92L112.6 39.32H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.08V13.34H134.99V47.94C134.99 51.96 135.78 56.15 142.81 56.15C144.14 56.22 145.47 56 146.71 55.49V49.01C146.71 49.01 143.29 49.89 143.29 47.08Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.45H33.04V76.18H0.25V82.02H38.77V69.28H218.65V63.45Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.609985H247.93V81.97H248.93V0.609985Z", fill: "#777675" }));
const SvgBrex = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 458, height: 82, viewBox: "0 0 458 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.4C19.58 27.46 16.72 25.78 12.52 25.78C4.66 25.83 0 32.08 0 40.75C0 49.42 4.65 55.67 12.52 55.67C13.96 55.75 15.41 55.5 16.75 54.94C18.09 54.38 19.29 53.52 20.26 52.43V56.6C20.26 59.44 18.76 62.81 14 62.81C10.39 62.81 8.61 60.79 7.99 58.62L1.6 61.71C3.2 65.81 7.02 69.25 14.44 69.25C25.44 69.25 28.27 61.83 28.27 55.33V26.2H21.54L21.36 30.4H21.35ZM14.24 48.87C10.31 48.87 7.99 45.67 7.99 40.69C7.99 35.71 10.31 32.51 14.24 32.51C18.17 32.51 20.44 35.71 20.44 40.69C20.44 45.67 18.17 48.87 14.24 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.73C176.63 25.73 175.11 26.07 173.73 26.75C172.34 27.43 171.12 28.41 170.16 29.64L169.64 26.2H162.53V55.21H170.83V38.83C170.83 34.3 172.51 32.53 175.84 32.53C178.16 32.53 180.08 33.56 180.08 37.98V55.22H188.38V36.29C188.38 30.16 184.58 25.74 178.16 25.74L178.17 25.73Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.57C49.6201 46.55 47.9401 48.87 44.6201 48.87C42.3001 48.87 40.3601 47.84 40.3601 43.42V26.2H32.0601V45.09C32.0601 51.21 35.8601 55.66 42.2801 55.66C43.8201 55.66 45.3401 55.31 46.7301 54.63C48.1201 53.95 49.3401 52.96 50.3001 51.74L50.8201 55.19H57.9101V26.2H49.6101V42.57H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.2H62.2798V55.21H70.5798V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.33C91.6001 26.6 89.0201 25.73 86.4001 25.88C78.5001 25.88 73.8301 32.14 73.8301 40.8C73.8301 49.46 78.5001 55.72 86.4001 55.72C88.0801 55.83 89.7601 55.49 91.2701 54.73C92.7801 53.97 94.0701 52.82 95.0101 51.39L95.2101 55.21H101.94V12.73H93.6401L93.6001 28.33H93.6101ZM88.2101 48.87C84.2801 48.87 81.9601 45.67 81.9601 40.69C81.9601 35.71 84.2801 32.51 88.2101 32.51C92.1401 32.51 94.4601 35.71 94.4601 40.69C94.4601 45.67 92.1401 48.87 88.2101 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.03C65.5099 12.03 64.6199 12.31 63.8599 12.82C63.0999 13.34 62.5099 14.07 62.1599 14.94C61.8099 15.8 61.7199 16.75 61.8999 17.66C62.0799 18.57 62.5199 19.41 63.1699 20.07C63.8199 20.73 64.6399 21.18 65.5399 21.36C66.4399 21.54 67.3699 21.45 68.2099 21.09C69.0599 20.73 69.7799 20.13 70.2899 19.35C70.7999 18.57 71.0699 17.66 71.0699 16.73C71.0699 15.48 70.5799 14.28 69.7099 13.4C68.8399 12.52 67.6599 12.02 66.4399 12.02L66.4299 12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.2H149.84V55.21H158.14V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.03C153.08 12.03 152.19 12.31 151.43 12.82C150.67 13.34 150.08 14.07 149.72 14.94C149.37 15.8 149.28 16.75 149.46 17.66C149.64 18.57 150.08 19.41 150.73 20.07C151.38 20.73 152.2 21.18 153.1 21.36C154 21.54 154.93 21.45 155.77 21.09C156.62 20.73 157.34 20.13 157.85 19.35C158.36 18.57 158.63 17.66 158.63 16.73C158.63 15.48 158.14 14.28 157.27 13.4C156.4 12.52 155.22 12.02 154 12.02V12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.64V40.76C218.63 31.8 213.58 25.84 205.25 25.84C196.92 25.84 191.31 31.8 191.31 40.76C191.31 49.72 196.93 55.68 205.25 55.68C211.01 55.68 215.3 52.89 217.33 48.18L211.32 45.28C210.93 46.54 210.14 47.62 209.08 48.38C208.02 49.14 206.75 49.52 205.45 49.47C203.92 49.51 202.42 48.96 201.28 47.92C200.14 46.88 199.42 45.43 199.29 43.88H199.35L218.63 41.65V41.64ZM199.09 38.71C199.09 34.5 201.55 31.74 205.22 31.74C206.73 31.71 208.19 32.28 209.31 33.31C210.43 34.35 211.11 35.78 211.23 37.31L199.09 38.71Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.83C110.47 25.83 104.85 31.79 104.85 40.75C104.85 49.71 110.47 55.67 118.8 55.67C124.55 55.67 128.84 52.88 130.82 48.17L124.81 45.27C124.42 46.51 123.65 47.58 122.61 48.34C121.57 49.09 120.32 49.49 119.05 49.46C117.5 49.53 115.99 48.98 114.83 47.94C113.67 46.9 112.94 45.44 112.81 43.87L132.05 41.62V40.74C132.17 31.8 127.12 25.84 118.8 25.84V25.83ZM112.61 38.71C112.61 34.5 115.02 31.74 118.75 31.74C120.26 31.71 121.72 32.28 122.84 33.31C123.96 34.35 124.64 35.78 124.76 37.31L112.6 38.71H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.47V12.73H134.99V47.33C134.99 51.35 135.78 55.54 142.81 55.54C144.14 55.61 145.47 55.39 146.71 54.88V48.4C146.71 48.4 143.29 49.28 143.29 46.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.84H33.04V75.57H0.25V81.41H38.77V68.67H218.65V62.84Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M248.93 0H247.93V81.36H248.93V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M399.54 25.65C396.36 25.65 393.91 26.78 391.63 29.15V26.2H385.38V55.21H392.1V38.38C392.1 34.53 394.39 32.09 397.87 32.09C398.5 32.09 399.06 32.17 399.45 32.25L404.12 26.12C402.3 25.81 400.72 25.65 399.53 25.65H399.54Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M457.51 26.2H449.76L442.6 35.67L435.44 26.2H427.69L438.63 40.82L427.69 55.22H435.6L442.56 46.04L449.52 55.22H457.51L446.5 40.84L457.51 26.2Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M316.33 19.68C314.04 22.75 313.48 23.77 311.27 23.77H278.21V63.08H291.18C294.11 63.08 296.95 61.66 298.77 59.31C301.14 56.17 301.46 55.22 303.75 55.22H336.89V15.9H323.84C320.91 15.9 318.07 17.32 316.33 19.67V19.68ZM326.61 45.08H312.77C309.76 45.08 307 46.34 305.18 48.77C302.81 51.92 302.33 52.86 300.12 52.86H288.41V33.99H302.25C305.25 33.99 308.02 32.57 309.84 30.22C312.21 27.15 312.85 26.21 314.98 26.21H326.61V45.08Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M376.28 35.4C379.21 33.75 381.26 30.84 381.26 26.99C381.26 21.33 376.91 15.9 370.58 15.9H351.6V55.22H370.58C377.46 55.22 382.21 50.34 382.21 44.21C382.21 40.59 380.55 37.45 376.28 35.4ZM358.33 22.03H370.04C372.97 22.03 374.71 24.78 374.71 27.22C374.71 30.21 372.1 32.25 369.65 32.25H358.34V22.03H358.33ZM369.64 49.08H358.33V38.39H370.04C373.05 38.39 375.5 40.98 375.5 43.66C375.5 46.65 372.42 49.09 369.65 49.09L369.64 49.08Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M420.97 46.88C419.86 48.61 417.73 49.63 415.35 49.63C411.64 49.63 408.55 47.11 408.55 43.26H428.64C428.96 42.08 429.04 41.53 429.04 40.51C429.04 31.7 423.58 25.65 415.36 25.65C407.14 25.65 401.6 31.39 401.6 40.75C401.6 50.11 407.06 55.77 415.52 55.77C421.45 55.77 426.67 52.86 428.17 46.89H420.97V46.88ZM415.35 31.78C419.07 31.78 421.92 34.14 421.84 37.68H408.63C408.63 34.22 411.64 31.78 415.35 31.78Z", fill: "black" }));
const SvgCapitalOneBusinessDeals = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 715, height: 85, viewBox: "0 0 715 85", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9116_21327)" }, /* @__PURE__ */ React.createElement("path", { d: "M413.86 52.0265C413.86 52.0265 413.84 52.0365 413.83 52.0465C405.32 58.0765 395.24 64.4066 384.39 71.0466L383.96 71.2966C383.82 71.3966 383.78 71.5965 383.88 71.7466C383.98 71.8966 384.18 71.9266 384.33 71.8266L384.69 71.6366C393.89 66.8365 404.46 61.1365 415.09 55.2865C415.15 55.2565 415.2 55.2265 415.26 55.1965C414.68 54.2365 414.2 53.1866 413.85 52.0365L413.86 52.0265ZM469.73 6.80655C456.31 -7.99345 369.98 5.31655 333.27 13.3365L332.41 13.5165C332.23 13.5465 332.12 13.7165 332.15 13.8965C332.18 14.0765 332.35 14.1865 332.53 14.1565L333.38 13.9865C363.8 8.56655 427.05 1.06655 440.66 14.5565C444.81 18.6765 443.82 23.9765 439.01 30.2365C441.61 31.9065 443.45 34.5265 444.29 37.8065C463.09 25.2965 475.72 13.3865 469.74 6.78655L469.73 6.80655Z", fill: "#CC2427" }), /* @__PURE__ */ React.createElement("path", { d: "M419.29 48.1465C419.46 53.3565 422.76 57.6165 427.05 57.6165C435.38 57.6165 438.92 47.3965 438.67 40.5565C438.49 35.3365 435.11 31.0865 430.82 31.0865C423.66 31.0865 419.03 41.2665 419.28 48.1465H419.29ZM414.89 47.8665C414.58 38.9765 421.54 29.8965 431.66 29.8965C438.42 29.8965 442.85 34.4065 443.1 41.3065C443.42 50.6765 436.92 59.2865 426.33 59.2865C419.56 59.2865 415.14 54.7865 414.89 47.8765V47.8665Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M319.1 45.5167C318.74 45.6567 318.27 45.7867 317.69 45.9067C317.11 46.0367 316.06 46.2267 314.53 46.4667C313.48 46.6367 312.74 46.8566 312.33 47.1466C311.93 47.4466 311.7 47.7966 311.63 48.2267C311.55 48.6867 311.7 49.0567 312.09 49.3367C312.49 49.6167 313.17 49.7667 314.13 49.7667C314.85 49.7667 315.55 49.6466 316.23 49.4366C316.92 49.2066 317.5 48.9066 317.95 48.5266C318.28 48.2466 318.51 47.8867 318.69 47.4467C318.79 47.1667 318.94 46.5267 319.11 45.5167H319.1ZM327.89 40.0466C327.85 40.8667 327.71 41.5766 327.49 42.8266L326 51.1767C325.87 51.9167 326.15 52.4966 326.84 52.8966L326.79 53.2267H318.27L318.19 51.0966C316.95 51.8466 315.45 52.4766 314.1 52.8466C312.75 53.1966 311.66 53.3466 310.02 53.3466C307.27 53.3466 305.69 53.0567 304.61 52.1067C303.5 51.1267 302.97 50.4667 303.02 49.1166C303.06 48.3366 303.47 47.3366 304.05 46.6367C304.64 45.9267 305.44 45.4666 306.32 45.0566C307.2 44.6366 308.23 44.3366 309.74 44.0966C311.25 43.8466 313.34 43.6067 316.15 43.3767C317.63 43.2567 318.53 42.9067 318.95 42.7467C319.54 42.5167 319.77 42.2667 319.85 41.7867C320.01 40.9267 319.73 40.4367 318.59 40.2167C315.52 39.6167 309.77 40.6066 306.81 41.3466L308.42 37.0066C312.33 36.4366 315.99 36.0667 319.85 36.0667C325.98 36.0667 327.94 37.8166 327.88 40.0566L327.89 40.0466Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M352.57 53.2265L355.53 36.5465H363.68L360.72 53.2265H352.57ZM355.98 32.6865C356.22 31.3165 358.39 30.2065 360.81 30.2065C363.23 30.2065 365 31.3165 364.77 32.6865C364.51 34.0565 362.35 35.1665 359.93 35.1665C357.51 35.1665 355.74 34.0565 355.99 32.6865H355.98Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M392.64 45.5567C392.27 45.6767 391.8 45.8167 391.23 45.9467C390.66 46.0867 389.6 46.2467 388.06 46.5067C387.01 46.6767 386.27 46.8967 385.86 47.1967C385.47 47.4867 385.24 47.8367 385.15 48.2667C385.06 48.7267 385.23 49.0967 385.62 49.3767C386.03 49.6567 386.71 49.7967 387.67 49.7967C388.38 49.7967 389.08 49.6867 389.76 49.4767C390.46 49.2467 391.03 48.9467 391.48 48.5667C391.79 48.2867 392.03 47.9167 392.21 47.4867C392.31 47.2067 392.46 46.5667 392.64 45.5667V45.5567ZM401.43 40.0767C401.4 40.8967 401.25 41.6167 401.03 42.8567L399.55 51.2167C399.42 51.9567 399.69 52.5367 400.38 52.9467L400.33 53.2367L391.82 53.2567L391.75 51.1267C390.51 51.8767 389 52.5067 387.66 52.8767C386.3 53.2367 385.21 53.3767 383.56 53.3767C380.81 53.3767 379.25 53.0967 378.16 52.1367C377.05 51.1467 376.51 50.5067 376.57 49.1567C376.6 48.3767 377.01 47.3667 377.6 46.6767C378.19 45.9567 378.99 45.5067 379.87 45.0867C380.75 44.6767 381.79 44.3667 383.27 44.1167C384.78 43.8867 386.89 43.6267 389.7 43.3967C391.16 43.2767 392.06 42.9367 392.48 42.7767C393.07 42.5467 393.31 42.2867 393.4 41.8067C393.55 40.9667 393.28 40.4667 392.15 40.2367C389.07 39.6267 383.33 40.6267 380.37 41.3667L381.97 37.0267C385.89 36.4567 389.54 36.0867 393.4 36.0867C399.53 36.0867 401.48 37.8467 401.43 40.0867V40.0767Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M301.92 47.2266C299.27 47.7566 297.77 47.9566 295.15 47.9566C291.25 47.9566 288.16 46.0266 288.33 42.4766C288.45 40.1166 291.25 35.1366 298.35 35.1366C300.59 35.1366 302.34 35.5366 304.69 36.8766L305.72 31.0866C302.52 29.8766 300.4 29.6966 297.66 29.7266C288.35 29.8266 279.4 34.0666 278.29 42.6766C277.16 51.4266 287.85 53.6266 292.59 53.6066C295.33 53.6066 298.18 53.4866 300.84 53.2066L301.92 47.2366V47.2266Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M368.18 36.4465L368.77 33.0465L377.3 31.1865L376.39 36.4365H380.57L379.78 39.7965H375.73L373.27 53.1965C373.27 53.1965 365.06 53.1465 365.03 53.1965L367.48 39.8165H364.38L365.01 36.4365H368.19L368.18 36.4465Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M409.71 53.2165L401.4 53.2265L405.58 29.9565L413.67 30.1865L409.71 53.2165Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M341.79 40.4567C340.72 40.4567 339.75 40.7767 338.89 41.4267C338.04 42.0767 337.5 43.0267 337.28 44.2867C337.02 45.7467 337.17 46.7867 337.75 47.4367C338.33 48.0767 339.17 48.3967 340.27 48.3967C341.01 48.3967 341.78 48.2667 342.35 47.9867C343.05 47.6167 343.53 47.2267 343.95 46.6167C344.4 45.9667 344.69 45.2467 344.85 44.4167C345.08 43.0967 344.89 42.1167 344.28 41.4667C343.69 40.7967 342.87 40.4667 341.8 40.4667L341.79 40.4567ZM326.94 58.9867L330.91 36.6267H338.07L337.52 39.4767C338.14 38.6267 339.13 37.9267 340.5 37.3567C341.88 36.7867 343.44 36.3767 345.13 36.3767C347 36.3767 348.15 36.4767 349.55 37.2067C350.94 37.9367 351.91 38.9967 352.44 40.3767C352.98 41.7367 353.09 43.2567 352.8 44.9167C352.32 47.6667 350.97 49.8467 348.77 51.4367C346.58 53.0367 344.62 53.4467 341.81 53.4667C340.82 53.4667 339.98 53.3667 339.29 53.1967C338.61 53.0167 338.08 52.8067 337.67 52.5467C337.28 52.2867 336.86 51.9167 336.33 51.3367L335 58.9967H326.96L326.94 58.9867Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M474.97 42.5066C474.92 41.1566 474.25 40.2566 472.86 40.2566C469.52 40.2566 465.96 46.8067 465.35 49.4467C470.84 49.4467 475.11 46.1766 474.97 42.5066ZM475.69 52.7766L476.34 53.2167C474.71 56.5367 471.38 59.2167 467.48 59.2167C464.29 59.2167 461.67 57.0967 461.53 53.1067C461.27 45.9567 467.97 39.3167 473.46 39.3167C475.81 39.3167 477.99 40.3467 478.09 42.8767C478.29 48.5667 470.31 50.2966 465.05 50.4166C464.88 51.0066 464.82 51.6067 464.85 52.5167C464.94 54.8767 466.36 56.8567 469.31 56.8567C471.86 56.8567 474.41 54.8067 475.69 52.7867V52.7766Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M442.98 42.3167C443.55 42.2367 444.46 42.1466 444.85 42.1466C445.45 42.1466 446.01 42.2567 446.04 42.8567C446.05 43.2067 445.41 45.7366 445.28 46.3266L444.01 51.9366C443.5 54.2266 442.94 56.6367 442.45 58.5367H445.72L447.56 49.6567C453.16 43.8167 455.32 41.9166 456.64 41.9166C457.23 41.9166 457.65 42.2266 457.67 42.9366C457.7 43.9666 457.07 46.2967 456.84 46.9667L454.97 53.4467C454.54 54.9067 454.23 56.2167 454.26 57.1567C454.32 58.5767 455.18 59.2066 456.45 59.2066C458.84 59.2066 460.57 56.7167 462.09 54.2766L461.65 53.4767C461.04 54.4566 459.62 56.6067 458.5 56.6067C458.15 56.6067 457.81 56.3666 457.8 55.7766C457.77 55.0166 458.09 53.8867 458.31 53.1367L460.39 45.5466C460.95 43.4566 461.22 42.1066 461.2 41.3966C461.15 39.9766 460.32 39.3167 459.05 39.3167C456.9 39.3167 454.04 40.8866 448 47.8466H447.91L448.67 44.4566C449.08 42.5966 449.49 40.6666 449.88 39.3266C447.79 40.0766 444.79 40.9266 442.94 41.2766L442.97 42.3367L442.98 42.3167Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M491.34 58.6066L496.3 33.0566C497.12 32.8366 498.21 32.6366 499.56 32.4766C500.91 32.3166 502.14 32.2366 503.23 32.2366C505.87 32.2366 507.88 32.7666 509.27 33.8266C510.66 34.8866 511.36 36.4066 511.36 38.3966C511.36 40.0166 510.89 41.3966 509.94 42.5366C508.99 43.6766 507.65 44.4966 505.91 44.9966C506.88 45.2466 507.71 45.6266 508.39 46.1566C509.07 46.6766 509.59 47.3066 509.94 48.0366C510.29 48.7666 510.46 49.5866 510.46 50.4766C510.46 53.0666 509.58 55.0666 507.83 56.4866C506.08 57.9066 503.62 58.6166 500.46 58.6166H491.32L491.34 58.6066ZM500.48 55.8866C502.49 55.8866 504.07 55.4066 505.2 54.4466C506.33 53.4866 506.9 52.1666 506.9 50.4766C506.9 49.2066 506.5 48.2366 505.69 47.5466C504.88 46.8666 503.74 46.5166 502.28 46.5166H497.13L495.3 55.8766H500.48V55.8866ZM503.09 34.8866C501.57 34.8866 500.32 35.0066 499.32 35.2566L497.6 43.9066H501.96C503.75 43.9066 505.19 43.4366 506.27 42.5066C507.35 41.5766 507.89 40.3366 507.89 38.7966C507.89 36.1866 506.29 34.8766 503.08 34.8766L503.09 34.8866Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M519.351 39.6565L516.931 52.1165C516.831 52.7165 516.781 53.2265 516.781 53.6465C516.781 54.5465 517.061 55.2365 517.621 55.7365C518.181 56.2365 518.971 56.4865 519.991 56.4865C520.711 56.4865 521.481 56.3665 522.301 56.1365C523.121 55.8965 523.871 55.5865 524.541 55.1865L527.561 39.6665H530.951L527.291 58.3865L524.491 58.6865V57.4165C522.451 58.5865 520.521 59.1665 518.711 59.1665C517.041 59.1665 515.731 58.7265 514.761 57.8465C513.791 56.9665 513.311 55.7365 513.311 54.1765C513.311 53.5265 513.371 52.9165 513.501 52.3465L515.961 39.6665H519.351V39.6565Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M531.36 54.8364C532.26 55.3564 533.21 55.7664 534.23 56.0664C535.25 56.3664 536.23 56.5164 537.18 56.5164C538.57 56.5164 539.67 56.2164 540.46 55.6164C541.26 55.0164 541.65 54.1964 541.65 53.1564C541.65 52.5064 541.49 51.9864 541.16 51.5664C540.83 51.1464 540.3 50.7864 539.56 50.4664L537.02 49.3864C535.75 48.8364 534.83 48.2164 534.26 47.5264C533.69 46.8264 533.4 45.9864 533.4 44.9864C533.4 43.2664 534.07 41.8564 535.41 40.7564C536.75 39.6464 538.47 39.0964 540.56 39.0964C541.55 39.0964 542.56 39.2264 543.56 39.4864C544.57 39.7464 545.49 40.1264 546.34 40.6264L545.85 43.1664C544.03 42.2264 542.34 41.7464 540.78 41.7464C539.54 41.7464 538.56 42.0064 537.85 42.5064C537.14 43.0164 536.79 43.7164 536.79 44.6164C536.79 45.1364 536.95 45.5664 537.26 45.9064C537.57 46.2464 538.12 46.5864 538.92 46.9364L541.46 48.0164C542.68 48.5364 543.58 49.1864 544.16 49.9764C544.74 50.7564 545.04 51.7264 545.04 52.8664C545.04 54.7564 544.34 56.2764 542.93 57.4364C541.52 58.5964 539.68 59.1664 537.39 59.1664C536.25 59.1664 535.15 59.0364 534.09 58.7764C533.03 58.5164 532.12 58.1564 531.35 57.7164V54.8464L531.36 54.8364Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M547.18 58.6065L550.8 39.9965L554.27 39.5865L550.58 58.6065H547.19H547.18ZM553.45 35.7765C552.83 35.7765 552.34 35.6165 551.98 35.3065C551.62 34.9965 551.44 34.5665 551.44 34.0165C551.44 33.2165 551.67 32.5965 552.13 32.1365C552.59 31.6765 553.22 31.4465 554.01 31.4465C554.63 31.4465 555.12 31.6065 555.48 31.9165C555.84 32.2265 556.02 32.6565 556.02 33.2065C556.02 34.0065 555.79 34.6265 555.33 35.0865C554.87 35.5465 554.24 35.7765 553.45 35.7765Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M566.65 58.6064L569.07 46.1464C569.17 45.5464 569.22 45.0364 569.22 44.6164C569.22 43.6964 568.93 42.9964 568.36 42.5064C567.79 42.0264 566.95 41.7764 565.86 41.7764C565.14 41.7764 564.37 41.8964 563.55 42.1264C562.73 42.3664 561.98 42.6764 561.31 43.0764L558.29 58.5964H554.9L558.56 39.8764L561.36 39.5764V40.8464C563.4 39.6764 565.33 39.0964 567.14 39.0964C568.95 39.0964 570.27 39.5364 571.24 40.4164C572.21 41.2964 572.69 42.5264 572.69 44.0864C572.69 44.7364 572.63 45.3464 572.5 45.9164L570.04 58.5964H566.65V58.6064Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M588.36 57.8964C587.56 58.2964 586.66 58.6064 585.64 58.8264C584.62 59.0464 583.63 59.1664 582.66 59.1664C580.17 59.1664 578.26 58.4964 576.93 57.1664C575.6 55.8364 574.93 53.9264 574.93 51.4364C574.93 48.9464 575.38 46.8764 576.27 44.9864C577.17 43.0964 578.35 41.6464 579.83 40.6264C581.31 39.6064 582.94 39.0964 584.73 39.0964C586.77 39.0964 588.37 39.6464 589.52 40.7364C590.68 41.8264 591.25 43.3364 591.25 45.2464C591.25 46.5864 591 48.1164 590.5 49.8364H578.38C578.36 50.1364 578.33 50.4364 578.31 50.7464C578.28 51.0564 578.27 51.3664 578.27 51.6564C578.27 54.8664 579.91 56.4664 583.19 56.4664C584.18 56.4664 585.19 56.3564 586.19 56.1464C587.2 55.9364 588.09 55.6564 588.86 55.3064L588.34 57.8764L588.36 57.8964ZM584.56 41.5964C583.22 41.5964 582.05 42.1064 581.07 43.1264C580.09 44.1464 579.36 45.5764 578.89 47.4164H587.88C588.03 46.6964 588.1 45.9864 588.1 45.2864C588.1 44.0664 587.8 43.1464 587.2 42.5264C586.6 41.9064 585.72 41.5964 584.55 41.5964H584.56Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M592.13 54.8364C593.03 55.3564 593.98 55.7664 595 56.0664C596.02 56.3664 597 56.5164 597.95 56.5164C599.34 56.5164 600.44 56.2164 601.23 55.6164C602.03 55.0164 602.42 54.1964 602.42 53.1564C602.42 52.5064 602.26 51.9864 601.93 51.5664C601.6 51.1464 601.07 50.7864 600.33 50.4664L597.79 49.3864C596.52 48.8364 595.6 48.2164 595.03 47.5264C594.46 46.8264 594.17 45.9864 594.17 44.9864C594.17 43.2664 594.84 41.8564 596.18 40.7564C597.52 39.6464 599.24 39.0964 601.33 39.0964C602.32 39.0964 603.33 39.2264 604.33 39.4864C605.34 39.7464 606.26 40.1264 607.11 40.6264L606.62 43.1664C604.8 42.2264 603.11 41.7464 601.55 41.7464C600.31 41.7464 599.33 42.0064 598.62 42.5064C597.91 43.0164 597.56 43.7164 597.56 44.6164C597.56 45.1364 597.72 45.5664 598.03 45.9064C598.34 46.2464 598.89 46.5864 599.69 46.9364L602.23 48.0164C603.45 48.5364 604.35 49.1864 604.93 49.9764C605.51 50.7564 605.81 51.7264 605.81 52.8664C605.81 54.7564 605.11 56.2764 603.7 57.4364C602.29 58.5964 600.45 59.1664 598.16 59.1664C597.02 59.1664 595.92 59.0364 594.86 58.7764C593.8 58.5164 592.89 58.1564 592.12 57.7164V54.8464L592.13 54.8364Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M607.79 54.8364C608.69 55.3564 609.64 55.7664 610.66 56.0664C611.68 56.3664 612.66 56.5164 613.61 56.5164C615 56.5164 616.1 56.2164 616.89 55.6164C617.69 55.0164 618.08 54.1964 618.08 53.1564C618.08 52.5064 617.92 51.9864 617.59 51.5664C617.26 51.1464 616.73 50.7864 615.99 50.4664L613.45 49.3864C612.18 48.8364 611.26 48.2164 610.69 47.5264C610.12 46.8264 609.83 45.9864 609.83 44.9864C609.83 43.2664 610.5 41.8564 611.84 40.7564C613.18 39.6464 614.9 39.0964 616.99 39.0964C617.98 39.0964 618.99 39.2264 619.99 39.4864C621 39.7464 621.92 40.1264 622.77 40.6264L622.28 43.1664C620.46 42.2264 618.77 41.7464 617.21 41.7464C615.97 41.7464 614.99 42.0064 614.28 42.5064C613.57 43.0164 613.22 43.7164 613.22 44.6164C613.22 45.1364 613.38 45.5664 613.69 45.9064C614 46.2464 614.55 46.5864 615.35 46.9364L617.89 48.0164C619.11 48.5364 620.01 49.1864 620.59 49.9764C621.17 50.7564 621.47 51.7264 621.47 52.8664C621.47 54.7564 620.77 56.2764 619.36 57.4364C617.95 58.5964 616.11 59.1664 613.82 59.1664C612.68 59.1664 611.58 59.0364 610.52 58.7764C609.46 58.5164 608.55 58.1564 607.78 57.7164V54.8464L607.79 54.8364Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M632.71 58.6066L637.67 33.0966C638.64 32.8466 639.78 32.6466 641.1 32.4766C642.42 32.3166 643.64 32.2366 644.76 32.2366C648.12 32.2366 650.67 33.1666 652.41 35.0166C654.15 36.8666 655.02 39.5566 655.02 43.0966C655.02 46.3066 654.4 49.0766 653.16 51.4166C651.92 53.7566 650.17 55.5366 647.92 56.7666C645.67 57.9966 643.06 58.6166 640.11 58.6166H632.72L632.71 58.6066ZM640.66 55.6966C642.8 55.6966 644.67 55.1666 646.27 54.0966C647.87 53.0266 649.11 51.5466 649.96 49.6366C650.81 47.7266 651.25 45.5566 651.25 43.0866C651.25 40.3766 650.7 38.3766 649.59 37.0766C648.48 35.7866 646.75 35.1366 644.39 35.1366C643.05 35.1366 641.85 35.2766 640.81 35.5466L636.89 55.6866H640.66V55.6966Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M669.86 57.8964C669.06 58.2964 668.16 58.6064 667.14 58.8264C666.12 59.0464 665.13 59.1664 664.16 59.1664C661.67 59.1664 659.76 58.4964 658.43 57.1664C657.1 55.8364 656.43 53.9264 656.43 51.4364C656.43 48.9464 656.88 46.8764 657.77 44.9864C658.67 43.0964 659.85 41.6464 661.33 40.6264C662.81 39.6064 664.44 39.0964 666.23 39.0964C668.27 39.0964 669.87 39.6464 671.02 40.7364C672.18 41.8264 672.75 43.3364 672.75 45.2464C672.75 46.5864 672.5 48.1164 672 49.8364H659.88C659.86 50.1364 659.83 50.4364 659.81 50.7464C659.78 51.0564 659.77 51.3664 659.77 51.6564C659.77 54.8664 661.41 56.4664 664.69 56.4664C665.68 56.4664 666.69 56.3564 667.69 56.1464C668.7 55.9364 669.59 55.6564 670.36 55.3064L669.84 57.8764L669.86 57.8964ZM666.06 41.5964C664.72 41.5964 663.55 42.1064 662.57 43.1264C661.59 44.1464 660.86 45.5764 660.39 47.4164H669.38C669.53 46.6964 669.6 45.9864 669.6 45.2864C669.6 44.0664 669.3 43.1464 668.7 42.5264C668.1 41.9064 667.22 41.5964 666.05 41.5964H666.06Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M685.08 58.6764V57.4064C683.04 58.5764 681.11 59.1564 679.3 59.1564C677.58 59.1564 676.22 58.6864 675.22 57.7364C674.21 56.7964 673.71 55.5064 673.71 53.8964C673.71 52.6064 674.05 51.4664 674.74 50.4864C675.42 49.5064 676.35 48.7464 677.52 48.2064C678.69 47.6764 679.99 47.4064 681.44 47.4064C683.08 47.4064 684.8 47.6264 686.59 48.0764L686.96 46.1364C687.03 45.6864 687.07 45.2864 687.07 44.9464C687.07 43.9064 686.7 43.1164 685.97 42.5764C685.24 42.0464 684.17 41.7764 682.78 41.7764C680.59 41.7764 678.6 42.1364 676.81 42.8564L677.3 40.3164C679.24 39.4964 681.3 39.0864 683.49 39.0864C685.68 39.0864 687.41 39.5564 688.62 40.5064C689.83 41.4564 690.43 42.7864 690.43 44.4964C690.43 45.1664 690.37 45.7864 690.24 46.3564L687.89 58.3664L685.09 58.6664L685.08 58.6764ZM680.57 56.5164C681.34 56.5164 682.14 56.3964 682.96 56.1664C683.78 55.9264 684.53 55.5964 685.2 55.1764L686.13 50.2864C684.81 49.9664 683.44 49.8064 682.03 49.8064C680.49 49.8064 679.3 50.1364 678.47 50.7964C677.64 51.4564 677.22 52.4064 677.22 53.6464C677.22 55.5664 678.34 56.5164 680.58 56.5164H680.57Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M692.09 58.6065L697.54 30.5965L701.01 30.1865L695.49 58.6065H692.1H692.09Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M699.92 54.8364C700.82 55.3564 701.77 55.7664 702.79 56.0664C703.81 56.3664 704.79 56.5164 705.74 56.5164C707.13 56.5164 708.23 56.2164 709.02 55.6164C709.82 55.0164 710.21 54.1964 710.21 53.1564C710.21 52.5064 710.05 51.9864 709.72 51.5664C709.39 51.1464 708.86 50.7864 708.12 50.4664L705.58 49.3864C704.31 48.8364 703.39 48.2164 702.82 47.5264C702.25 46.8264 701.96 45.9864 701.96 44.9864C701.96 43.2664 702.63 41.8564 703.97 40.7564C705.31 39.6464 707.03 39.0964 709.12 39.0964C710.11 39.0964 711.12 39.2264 712.12 39.4864C713.13 39.7464 714.05 40.1264 714.9 40.6264L714.41 43.1664C712.59 42.2264 710.9 41.7464 709.34 41.7464C708.1 41.7464 707.12 42.0064 706.41 42.5064C705.7 43.0164 705.35 43.7164 705.35 44.6164C705.35 45.1364 705.51 45.5664 705.82 45.9064C706.13 46.2464 706.68 46.5864 707.48 46.9364L710.02 48.0164C711.24 48.5364 712.14 49.1864 712.72 49.9764C713.3 50.7564 713.6 51.7264 713.6 52.8664C713.6 54.7564 712.9 56.2764 711.49 57.4364C710.08 58.5964 708.24 59.1664 705.95 59.1664C704.81 59.1664 703.71 59.0364 702.65 58.7764C701.59 58.5164 700.68 58.1564 699.91 57.7164V54.8464L699.92 54.8364Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M248.92 3.48657H247.92V84.8466H248.92V3.48657Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.3402 33.8866C19.5702 30.9466 16.7102 29.2666 12.5102 29.2666C4.65023 29.3166 -0.00976562 35.5666 -0.00976562 44.2366C-0.00976562 52.9066 4.64023 59.1566 12.5102 59.1566C13.9502 59.2366 15.4002 58.9866 16.7402 58.4266C18.0802 57.8666 19.2802 57.0066 20.2502 55.9166V60.0866C20.2502 62.9266 18.7502 66.2966 13.9902 66.2966C10.3802 66.2966 8.60023 64.2766 7.98023 62.1066L1.59023 65.1966C3.19023 69.2966 7.01023 72.7366 14.4302 72.7366C25.4302 72.7366 28.2602 65.3166 28.2602 58.8166V29.6866H21.5302L21.3502 33.8866H21.3402ZM14.2302 52.3566C10.3002 52.3566 7.98023 49.1566 7.98023 44.1766C7.98023 39.1966 10.3002 35.9966 14.2302 35.9966C18.1602 35.9966 20.4302 39.1966 20.4302 44.1766C20.4302 49.1566 18.1602 52.3566 14.2302 52.3566Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.16 29.2166C176.62 29.2166 175.1 29.5566 173.72 30.2366C172.33 30.9166 171.11 31.8966 170.15 33.1266L169.63 29.6866H162.52V58.6966H170.82V42.3166C170.82 37.7866 172.5 36.0166 175.83 36.0166C178.15 36.0166 180.07 37.0466 180.07 41.4666V58.7066H188.37V39.7766C188.37 33.6466 184.57 29.2266 178.15 29.2266L178.16 29.2166Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6103 46.0565C49.6103 50.0365 47.9303 52.3565 44.6103 52.3565C42.2903 52.3565 40.3503 51.3265 40.3503 46.9065V29.6865H32.0503V48.5765C32.0503 54.6965 35.8503 59.1465 42.2703 59.1465C43.8103 59.1465 45.3303 58.7965 46.7203 58.1165C48.1103 57.4365 49.3303 56.4465 50.2903 55.2265L50.8103 58.6765H57.9003V29.6865H49.6003V46.0565H49.6103Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.57 29.6865H62.27V58.6965H70.57V29.6865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6003 31.8166C91.5903 30.0866 89.0103 29.2166 86.3903 29.3666C78.4903 29.3666 73.8203 35.6266 73.8203 44.2866C73.8203 52.9466 78.4903 59.2066 86.3903 59.2066C88.0703 59.3166 89.7503 58.9766 91.2603 58.2166C92.7703 57.4566 94.0603 56.3066 95.0003 54.8766L95.2003 58.6966H101.93V16.2166H93.6303L93.5903 31.8166H93.6003ZM88.2003 52.3566C84.2703 52.3566 81.9503 49.1566 81.9503 44.1766C81.9503 39.1966 84.2703 35.9966 88.2003 35.9966C92.1303 35.9966 94.4503 39.1966 94.4503 44.1766C94.4503 49.1566 92.1303 52.3566 88.2003 52.3566Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4202 15.5166C65.5002 15.5166 64.6102 15.7966 63.8502 16.3066C63.0902 16.8266 62.5002 17.5566 62.1502 18.4266C61.8002 19.2866 61.7102 20.2366 61.8902 21.1466C62.0702 22.0566 62.5102 22.8966 63.1602 23.5566C63.8102 24.2166 64.6302 24.6666 65.5302 24.8466C66.4302 25.0266 67.3602 24.9366 68.2002 24.5766C69.0502 24.2166 69.7702 23.6166 70.2802 22.8366C70.7902 22.0566 71.0602 21.1466 71.0602 20.2166C71.0602 18.9666 70.5702 17.7666 69.7002 16.8866C68.8302 16.0066 67.6502 15.5066 66.4302 15.5066L66.4202 15.5166Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.13 29.6865H149.83V58.6965H158.13V29.6865Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M153.99 15.5166C153.07 15.5166 152.18 15.7966 151.42 16.3066C150.66 16.8266 150.07 17.5566 149.71 18.4266C149.36 19.2866 149.27 20.2366 149.45 21.1466C149.63 22.0566 150.07 22.8966 150.72 23.5566C151.37 24.2166 152.19 24.6666 153.09 24.8466C153.99 25.0266 154.92 24.9366 155.76 24.5766C156.61 24.2166 157.33 23.6166 157.84 22.8366C158.35 22.0566 158.62 21.1466 158.62 20.2166C158.62 18.9666 158.13 17.7666 157.26 16.8866C156.39 16.0066 155.21 15.5066 153.99 15.5066V15.5166Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.62 45.1267V44.2467C218.62 35.2867 213.57 29.3267 205.24 29.3267C196.91 29.3267 191.3 35.2867 191.3 44.2467C191.3 53.2067 196.92 59.1667 205.24 59.1667C211 59.1667 215.29 56.3767 217.32 51.6667L211.31 48.7667C210.92 50.0267 210.13 51.1067 209.07 51.8667C208.01 52.6267 206.74 53.0067 205.44 52.9567C203.91 52.9967 202.41 52.4467 201.27 51.4067C200.13 50.3667 199.41 48.9167 199.28 47.3667H199.34L218.62 45.1367V45.1267ZM199.08 42.1967C199.08 37.9867 201.54 35.2267 205.21 35.2267C206.72 35.1967 208.18 35.7667 209.3 36.7967C210.42 37.8367 211.1 39.2667 211.22 40.7967L199.08 42.1967Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.79 29.3167C110.46 29.3167 104.84 35.2766 104.84 44.2366C104.84 53.1966 110.46 59.1567 118.79 59.1567C124.54 59.1567 128.83 56.3666 130.81 51.6567L124.8 48.7566C124.41 49.9966 123.64 51.0666 122.6 51.8266C121.56 52.5766 120.31 52.9767 119.04 52.9467C117.49 53.0167 115.98 52.4667 114.82 51.4267C113.66 50.3867 112.93 48.9267 112.8 47.3567L132.04 45.1067V44.2267C132.16 35.2867 127.11 29.3267 118.79 29.3267V29.3167ZM112.6 42.1967C112.6 37.9867 115.01 35.2267 118.74 35.2267C120.25 35.1967 121.71 35.7667 122.83 36.7966C123.95 37.8366 124.63 39.2667 124.75 40.7966L112.59 42.1967H112.6Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.28 49.9566V16.2166H134.98V50.8166C134.98 54.8366 135.77 59.0266 142.8 59.0266C144.13 59.0965 145.46 58.8766 146.7 58.3666V51.8866C146.7 51.8866 143.28 52.7666 143.28 49.9566Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 66.3267H33.0302V79.0567H0.240234V84.8967H38.7602V72.1567H218.64V66.3267Z", fill: "#5532FA" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9116_21327" }, /* @__PURE__ */ React.createElement("rect", { width: 714.92, height: 84.76, fill: "white", transform: "translate(0 0.136475)" }))));
const SvgCapitalOneSpring = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 426, height: 98, viewBox: "0 0 426 98", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 16.3164H247.93V97.6764H248.93V16.3164Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 46.7164C19.58 43.7764 16.72 42.0964 12.52 42.0964C4.66 42.1464 0 48.3964 0 57.0664C0 65.7364 4.65 71.9864 12.52 71.9864C13.96 72.0664 15.41 71.8164 16.75 71.2564C18.09 70.6964 19.29 69.8364 20.26 68.7464V72.9164C20.26 75.7564 18.76 79.1264 14 79.1264C10.39 79.1264 8.61 77.1064 7.99 74.9364L1.6 78.0264C3.2 82.1264 7.02 85.5664 14.44 85.5664C25.44 85.5664 28.27 78.1464 28.27 71.6464V42.5064H21.54L21.36 46.7064L21.35 46.7164ZM14.24 65.1864C10.31 65.1864 7.99 61.9864 7.99 57.0064C7.99 52.0264 10.31 48.8264 14.24 48.8264C18.17 48.8264 20.44 52.0264 20.44 57.0064C20.44 61.9864 18.17 65.1864 14.24 65.1864Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 42.0464C176.63 42.0464 175.11 42.3864 173.73 43.0664C172.34 43.7464 171.12 44.7264 170.16 45.9564L169.64 42.5164H162.53V71.5264H170.83V55.1464C170.83 50.6164 172.51 48.8464 175.84 48.8464C178.16 48.8464 180.08 49.8764 180.08 54.2964V71.5364H188.38V52.6064C188.38 46.4764 184.58 42.0564 178.16 42.0564L178.17 42.0464Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 58.8864C49.6201 62.8664 47.9401 65.1864 44.6201 65.1864C42.3001 65.1864 40.3601 64.1564 40.3601 59.7364V42.5164H32.0601V61.4064C32.0601 67.5264 35.8601 71.9764 42.2801 71.9764C43.8201 71.9764 45.3401 71.6264 46.7301 70.9464C48.1201 70.2664 49.3401 69.2764 50.3001 68.0564L50.8201 71.5064H57.9101V42.5164H49.6101V58.8864H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 42.5164H62.2798V71.5264H70.5798V42.5164Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 44.6464C91.6001 42.9164 89.0201 42.0464 86.4001 42.1964C78.5001 42.1964 73.8301 48.4564 73.8301 57.1164C73.8301 65.7764 78.5001 72.0364 86.4001 72.0364C88.0801 72.1464 89.7601 71.8064 91.2701 71.0464C92.7801 70.2864 94.0701 69.1364 95.0101 67.7064L95.2101 71.5264H101.94V29.0464H93.6401L93.6001 44.6464H93.6101ZM88.2101 65.1864C84.2801 65.1864 81.9601 61.9864 81.9601 57.0064C81.9601 52.0264 84.2801 48.8264 88.2101 48.8264C92.1401 48.8264 94.4601 52.0264 94.4601 57.0064C94.4601 61.9864 92.1401 65.1864 88.2101 65.1864Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 28.3564C65.5099 28.3564 64.6199 28.6364 63.8599 29.1464C63.0999 29.6664 62.5099 30.3964 62.1599 31.2664C61.8099 32.1264 61.7199 33.0764 61.8999 33.9864C62.0799 34.8964 62.5199 35.7364 63.1699 36.3964C63.8199 37.0564 64.6399 37.5064 65.5399 37.6864C66.4399 37.8664 67.3699 37.7764 68.2099 37.4164C69.0599 37.0564 69.7799 36.4564 70.2899 35.6764C70.7999 34.8964 71.0699 33.9864 71.0699 33.0564C71.0699 31.8064 70.5799 30.6064 69.7099 29.7264C68.8399 28.8464 67.6599 28.3464 66.4399 28.3464L66.4299 28.3564Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 42.5164H149.84V71.5264H158.14V42.5164Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 28.3564C153.08 28.3564 152.19 28.6364 151.43 29.1464C150.67 29.6664 150.08 30.3964 149.72 31.2664C149.37 32.1264 149.28 33.0764 149.46 33.9864C149.64 34.8964 150.08 35.7364 150.73 36.3964C151.38 37.0564 152.2 37.5064 153.1 37.6864C154 37.8664 154.93 37.7764 155.77 37.4164C156.62 37.0564 157.34 36.4564 157.85 35.6764C158.36 34.8964 158.63 33.9864 158.63 33.0564C158.63 31.8064 158.14 30.6064 157.27 29.7264C156.4 28.8464 155.22 28.3464 154 28.3464V28.3564Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 57.9565V57.0765C218.63 48.1165 213.58 42.1565 205.25 42.1565C196.92 42.1565 191.31 48.1165 191.31 57.0765C191.31 66.0365 196.93 71.9965 205.25 71.9965C211.01 71.9965 215.3 69.2065 217.33 64.4965L211.32 61.5965C210.93 62.8565 210.14 63.9365 209.08 64.6965C208.02 65.4565 206.75 65.8365 205.45 65.7865C203.92 65.8265 202.42 65.2765 201.28 64.2365C200.14 63.1965 199.42 61.7465 199.29 60.1965H199.35L218.63 57.9665V57.9565ZM199.09 55.0265C199.09 50.8165 201.55 48.0565 205.22 48.0565C206.73 48.0265 208.19 48.5965 209.31 49.6265C210.43 50.6665 211.11 52.0965 211.23 53.6265L199.09 55.0265Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 42.1465C110.47 42.1465 104.85 48.1065 104.85 57.0665C104.85 66.0265 110.47 71.9865 118.8 71.9865C124.55 71.9865 128.84 69.1965 130.82 64.4865L124.81 61.5865C124.42 62.8265 123.65 63.8965 122.61 64.6565C121.57 65.4065 120.32 65.8065 119.05 65.7765C117.5 65.8465 115.99 65.2965 114.83 64.2565C113.67 63.2165 112.94 61.7565 112.81 60.1865L132.05 57.9365V57.0565C132.17 48.1165 127.12 42.1565 118.8 42.1565V42.1465ZM112.61 55.0265C112.61 50.8165 115.02 48.0565 118.75 48.0565C120.26 48.0265 121.72 48.5965 122.84 49.6265C123.96 50.6665 124.64 52.0965 124.76 53.6265L112.6 55.0265H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 62.7864V29.0464H134.99V63.6464C134.99 67.6664 135.78 71.8564 142.81 71.8564C144.14 71.9264 145.47 71.7064 146.71 71.1964V64.7164C146.71 64.7164 143.29 65.5964 143.29 62.7864Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 79.1565H33.04V91.8865H0.25V97.7265H38.77V84.9865H218.65V79.1565Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M344.78 41.7863C342.11 41.7863 339.55 42.7163 337.18 44.5363L336.93 42.3063L333.41 42.6563V71.5463H337.48V47.9763C339.75 46.1963 342.15 45.2963 344.62 45.2963C345.32 45.2963 346.15 45.4063 347.08 45.6263L347.54 45.7363V42.2263L347.29 42.1363C346.66 41.8963 345.84 41.7763 344.79 41.7763L344.78 41.7863ZM405.73 41.6163C401.22 41.6163 397.71 43.0063 395.31 45.7463C392.92 48.4763 391.7 52.4263 391.7 57.4863C391.7 61.9563 392.77 65.5063 394.89 68.0463C397.02 70.6063 399.98 71.8963 403.69 71.8963C404.97 71.8963 406.37 71.6663 407.86 71.2063C409.14 70.8063 410.42 70.2763 411.66 69.6163V72.8663C411.66 78.4863 408.76 81.2163 402.81 81.2163C400.14 81.2163 397.3 80.5863 394.33 79.3263L393.71 79.0663L394.28 82.8063L394.46 82.8963C396.79 84.0863 399.65 84.6863 402.97 84.6863C407.03 84.6863 410.2 83.6263 412.4 81.5463C414.61 79.4563 415.72 76.4463 415.72 72.5963V43.5463L415.48 43.4563C412.39 42.2463 409.1 41.6263 405.72 41.6263L405.73 41.6163ZM411.65 66.2763C410.49 66.9163 409.24 67.4363 407.94 67.8263C406.58 68.2263 405.3 68.4363 404.12 68.4363C401.42 68.4363 399.42 67.5363 398.03 65.6863C396.63 63.8263 395.93 61.0563 395.93 57.4463C395.93 53.2463 396.76 50.0963 398.41 48.0863C400.04 46.1063 402.6 45.0963 406 45.0963C407.95 45.0963 409.85 45.3663 411.65 45.8963V66.2863V66.2763ZM316.15 41.6163C313.62 41.6163 310.83 42.4463 307.84 44.0963L307.64 42.3163L304.12 42.6663V84.1663L308.19 83.6163V71.6263C310 72.1363 312 72.3963 314.11 72.3963C318.62 72.3963 322.13 71.0063 324.53 68.2663C326.92 65.5363 328.14 61.5863 328.14 56.5263C328.14 51.9163 327.07 48.2363 324.96 45.6163C322.83 42.9663 319.87 41.6163 316.16 41.6163H316.15ZM321.42 65.9463C319.79 67.9263 317.23 68.9363 313.83 68.9363C311.87 68.9363 309.97 68.6663 308.18 68.1363V47.2363C309.34 46.5963 310.59 46.0663 311.89 45.6863C313.25 45.2863 314.54 45.0763 315.71 45.0763C318.41 45.0763 320.4 46.0163 321.79 47.9563C323.19 49.9063 323.9 52.8063 323.9 56.5763C323.9 60.7863 323.06 63.9363 321.42 65.9363V65.9463ZM291.9 55.2663L287.53 53.8063C285.82 53.2263 284.63 52.6163 283.99 52.0063C283.38 51.4163 283.09 50.6563 283.09 49.6663C283.09 48.2463 283.64 47.1663 284.78 46.3463C285.94 45.5163 287.59 45.0863 289.68 45.0863C292.02 45.0863 294.42 45.5663 296.84 46.5263L297.35 46.7263V43.2663L297.12 43.1663C294.73 42.1363 292.16 41.6163 289.51 41.6163C286.35 41.6163 283.79 42.3563 281.91 43.8063C280 45.2863 279.02 47.2863 279.02 49.7763C279.02 51.6363 279.6 53.1863 280.73 54.4063C281.83 55.5963 283.62 56.5863 286.02 57.3463L290.22 58.6963C291.81 59.1963 292.95 59.8263 293.62 60.5563C294.28 61.2763 294.6 62.2063 294.6 63.3963C294.6 67.1163 292.28 68.9263 287.51 68.9263C284.63 68.9263 281.8 68.3163 279.09 67.0963L278.46 66.8163L279.05 70.5263L279.23 70.6163C281.74 71.7963 284.6 72.3963 287.73 72.3963C291.15 72.3963 293.86 71.6063 295.76 70.0563C297.69 68.4863 298.66 66.2263 298.66 63.3363C298.66 61.3363 298.1 59.6563 296.99 58.3563C295.91 57.0763 294.19 56.0363 291.89 55.2563L291.9 55.2663ZM375.85 36.4363C378.32 36.4563 381.61 35.7763 383.08 36.0263C384.83 36.3263 385.62 37.1663 386.31 37.7963C386.4 37.8763 386.55 37.7963 386.55 37.6763V25.4563C386.55 19.4063 381.89 14.2863 375.95 14.1163C369.79 13.9463 364.74 18.9963 364.75 25.2363C364.75 31.3963 369.81 36.3963 375.85 36.4463V36.4363ZM353.57 71.5563H357.64V42.2363L353.57 42.7863V71.5563ZM377.12 41.6163C374.17 41.6163 371.12 42.4463 368.03 44.0963L367.83 42.3163L364.31 42.6663V71.5563H368.38V47.2463C369.69 46.5963 371.03 46.0663 372.39 45.6863C373.8 45.2863 375.12 45.0763 376.3 45.0763C380.7 45.0763 382.84 47.2163 382.84 51.6263V71.5563H386.91V51.0663C386.91 48.0763 386.04 45.7263 384.33 44.0863C382.62 42.4463 380.2 41.6163 377.14 41.6163H377.12ZM396.84 35.0063C399.17 34.6063 404.35 35.6863 408.26 35.6563C417.79 35.5963 425.77 27.6863 425.79 17.9663C425.81 8.10634 417.84 0.14634 408.12 0.41634C398.74 0.66634 391.38 8.74634 391.38 18.3063V37.5963C391.38 37.7963 391.61 37.9263 391.76 37.7863C392.85 36.8063 394.08 35.4763 396.85 34.9963L396.84 35.0063ZM355.58 33.6763C354.14 33.6763 352.97 34.8663 352.97 36.3363C352.97 37.8063 354.14 38.9963 355.58 38.9963C357.02 38.9963 358.19 37.8063 358.19 36.3363C358.19 34.8763 357.02 33.6763 355.58 33.6763Z", fill: "#013D5B" }), /* @__PURE__ */ React.createElement("path", { d: "M394.48 18.3063V32.3363C395.04 32.1563 395.65 31.9963 396.32 31.8763C396.87 31.7863 397.47 31.7463 398.13 31.7463C399.51 31.7463 401.11 31.9163 402.87 32.0963C404.72 32.2963 406.64 32.4963 408.22 32.4763C416.17 32.4263 422.64 25.9063 422.65 17.9563C422.65 14.0463 421.15 10.3763 418.4 7.64627C415.65 4.91627 412.03 3.48627 408.17 3.57627C400.61 3.78627 394.47 10.3863 394.47 18.2963L394.48 18.3063Z", fill: "#00C0E5" }), /* @__PURE__ */ React.createElement("path", { d: "M375.89 16.1164C373.45 16.0464 371.13 16.9764 369.4 18.6964C367.66 20.4264 366.7 22.7464 366.7 25.2264C366.7 30.2664 370.81 34.3964 375.85 34.4264H376.02C376.93 34.4264 377.99 34.3164 379.01 34.2064L379.25 34.1764C380.81 34.0164 382.41 33.8664 383.45 34.0464L384.57 34.2064V25.4364C384.57 20.4164 380.67 16.2364 375.89 16.1064V16.1164Z", fill: "#CC2427" }));
const SvgDeel = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 398, height: 82, viewBox: "0 0 398 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0H247.93V81.36H248.93V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M375.92 55.06C375.74 55.06 375.6 54.92 375.6 54.74V16.5499C375.6 16.3999 375.71 16.27 375.85 16.24L382.52 14.86C382.72 14.82 382.9 14.9699 382.9 15.1699V54.74C382.9 54.92 382.76 55.06 382.58 55.06H375.91H375.92Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M292.13 55.87C289.47 55.87 287.09 55.22 285 53.93C282.91 52.6399 281.25 50.87 280.04 48.62C278.82 46.38 278.21 43.83 278.21 40.97C278.21 38.11 278.82 35.59 280.04 33.38C281.26 31.14 282.91 29.39 285 28.13C287.09 26.84 289.47 26.19 292.13 26.19C294.26 26.19 296.12 26.59 297.72 27.39C299 28.03 300.09 28.88 300.98 29.94C301.18 30.18 301.6 30.04 301.6 29.73V15.86C301.6 15.71 301.71 15.5799 301.85 15.5499L308.52 14.1699C308.72 14.1299 308.9 14.28 308.9 14.48V54.86C308.9 55.04 308.76 55.18 308.58 55.18H302.65C302.5 55.18 302.37 55.0699 302.34 54.9199L301.73 51.84C301.68 51.57 301.32 51.49 301.14 51.7C300.29 52.72 299.22 53.63 297.93 54.44C296.45 55.39 294.51 55.87 292.11 55.87H292.13ZM293.67 49.48C296.03 49.48 297.95 48.7 299.43 47.14C300.95 45.54 301.71 43.51 301.71 41.03C301.71 38.55 300.95 36.54 299.43 34.98C297.95 33.38 296.02 32.58 293.67 32.58C291.32 32.58 289.43 33.3599 287.91 34.9199C286.39 36.4799 285.63 38.5 285.63 40.97C285.63 43.44 286.39 45.48 287.91 47.08C289.43 48.68 291.35 49.48 293.67 49.48Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M326.72 55.87C323.87 55.87 321.34 55.2599 319.13 54.0399C316.92 52.8199 315.19 51.11 313.94 48.9C312.68 46.69 312.06 44.14 312.06 41.25C312.06 38.36 312.67 35.7099 313.89 33.4299C315.15 31.1499 316.86 29.38 319.03 28.12C321.24 26.83 323.82 26.1799 326.79 26.1799C329.57 26.1799 332.02 26.79 334.15 28.01C336.28 29.23 337.94 30.9 339.11 33.03C340.33 35.12 340.94 37.4599 340.94 40.0499C340.94 40.4699 340.92 40.91 340.88 41.36C340.88 41.73 340.87 42.1 340.84 42.49C340.83 42.66 340.69 42.78 340.53 42.78H319.65C319.47 42.78 319.32 42.94 319.34 43.12C319.54 45.17 320.3 46.78 321.59 47.97C323 49.23 324.69 49.85 326.67 49.85C328.15 49.85 329.39 49.53 330.38 48.88C331.35 48.23 332.08 47.4199 332.57 46.4399C332.63 46.3299 332.74 46.26 332.86 46.26H339.65C339.86 46.26 340.01 46.4599 339.95 46.6699C339.41 48.2999 338.56 49.7999 337.4 51.1699C336.18 52.6199 334.66 53.76 332.83 54.59C331.04 55.43 329.01 55.85 326.72 55.85V55.87ZM326.78 32.13C324.99 32.13 323.41 32.6399 322.04 33.6699C320.75 34.5999 319.91 36 319.49 37.86C319.45 38.05 319.6 38.23 319.8 38.23H333.18C333.36 38.23 333.51 38.08 333.49 37.89C333.32 36.18 332.64 34.81 331.46 33.77C330.2 32.67 328.64 32.12 326.78 32.12V32.13Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M358.5 55.87C355.65 55.87 353.12 55.2599 350.91 54.0399C348.7 52.8199 346.97 51.11 345.72 48.9C344.46 46.69 343.84 44.14 343.84 41.25C343.84 38.36 344.45 35.7099 345.67 33.4299C346.93 31.1499 348.64 29.38 350.81 28.12C353.02 26.83 355.6 26.1799 358.57 26.1799C361.35 26.1799 363.8 26.79 365.93 28.01C368.06 29.23 369.72 30.9 370.89 33.03C372.11 35.12 372.72 37.4599 372.72 40.0499C372.72 40.4699 372.7 40.91 372.66 41.36C372.66 41.73 372.65 42.1 372.62 42.49C372.61 42.66 372.47 42.78 372.31 42.78H351.43C351.25 42.78 351.1 42.94 351.12 43.12C351.32 45.17 352.08 46.78 353.37 47.97C354.78 49.23 356.47 49.85 358.45 49.85C359.93 49.85 361.17 49.53 362.16 48.88C363.13 48.23 363.86 47.4199 364.35 46.4399C364.41 46.3299 364.52 46.26 364.64 46.26H371.43C371.64 46.26 371.79 46.4599 371.73 46.6699C371.19 48.2999 370.34 49.7999 369.18 51.1699C367.96 52.6199 366.44 53.76 364.61 54.59C362.82 55.43 360.79 55.85 358.5 55.85V55.87ZM358.56 32.13C356.77 32.13 355.19 32.6399 353.82 33.6699C352.53 34.5999 351.69 36 351.27 37.86C351.23 38.05 351.38 38.23 351.58 38.23H364.96C365.14 38.23 365.29 38.08 365.27 37.89C365.1 36.18 364.42 34.81 363.24 33.77C361.98 32.67 360.42 32.12 358.56 32.12V32.13Z", fill: "#1C4396" }), /* @__PURE__ */ React.createElement("path", { d: "M392.48 55.0699C395.197 55.0699 397.4 52.8673 397.4 50.15C397.4 47.4328 395.197 45.23 392.48 45.23C389.763 45.23 387.56 47.4328 387.56 50.15C387.56 52.8673 389.763 55.0699 392.48 55.0699Z", fill: "#2C71F0" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.39C19.58 27.45 16.72 25.77 12.52 25.77C4.66 25.82 0 32.07 0 40.74C0 49.41 4.65 55.66 12.52 55.66C13.96 55.74 15.41 55.4899 16.75 54.9299C18.09 54.3699 19.29 53.5099 20.26 52.4199V56.59C20.26 59.43 18.76 62.7999 14 62.7999C10.39 62.7999 8.61 60.78 7.99 58.61L1.6 61.7C3.2 65.7999 7.02 69.24 14.44 69.24C25.44 69.24 28.27 61.8199 28.27 55.3199V26.1799H21.54L21.36 30.38L21.35 30.39ZM14.24 48.86C10.31 48.86 7.99 45.6599 7.99 40.6799C7.99 35.6999 10.31 32.5 14.24 32.5C18.17 32.5 20.44 35.6999 20.44 40.6799C20.44 45.6599 18.17 48.86 14.24 48.86Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.73C176.63 25.73 175.11 26.07 173.73 26.75C172.34 27.43 171.12 28.41 170.16 29.64L169.64 26.2H162.53V55.21H170.83V38.83C170.83 34.3 172.51 32.53 175.84 32.53C178.16 32.53 180.08 33.56 180.08 37.98V55.22H188.38V36.2899C188.38 30.1599 184.58 25.74 178.16 25.74L178.17 25.73Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.5599C49.6201 46.5399 47.9401 48.86 44.6201 48.86C42.3001 48.86 40.3601 47.83 40.3601 43.41V26.1899H32.0601V45.08C32.0601 51.2 35.8601 55.65 42.2801 55.65C43.8201 55.65 45.3401 55.3 46.7301 54.62C48.1201 53.94 49.3401 52.95 50.3001 51.73L50.8201 55.1799H57.9101V26.1899H49.6101V42.5599H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.2H62.2798V55.21H70.5798V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.33C91.6001 26.6 89.0201 25.73 86.4001 25.88C78.5001 25.88 73.8301 32.1399 73.8301 40.7999C73.8301 49.4599 78.5001 55.72 86.4001 55.72C88.0801 55.83 89.7601 55.49 91.2701 54.73C92.7801 53.97 94.0701 52.82 95.0101 51.39L95.2101 55.21H101.94V12.73H93.6401L93.6001 28.33H93.6101ZM88.2101 48.87C84.2801 48.87 81.9601 45.6699 81.9601 40.6899C81.9601 35.7099 84.2801 32.51 88.2101 32.51C92.1401 32.51 94.4601 35.7099 94.4601 40.6899C94.4601 45.6699 92.1401 48.87 88.2101 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.03C65.5099 12.03 64.6199 12.3099 63.8599 12.8199C63.0999 13.3399 62.5099 14.0699 62.1599 14.9399C61.8099 15.7999 61.7199 16.75 61.8999 17.66C62.0799 18.57 62.5199 19.4099 63.1699 20.0699C63.8199 20.7299 64.6399 21.18 65.5399 21.36C66.4399 21.54 67.3699 21.45 68.2099 21.09C69.0599 20.73 69.7799 20.13 70.2899 19.35C70.7999 18.57 71.0699 17.66 71.0699 16.73C71.0699 15.48 70.5799 14.28 69.7099 13.4C68.8399 12.52 67.6599 12.02 66.4399 12.02L66.4299 12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.2H149.84V55.21H158.14V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.03C153.08 12.03 152.19 12.3099 151.43 12.8199C150.67 13.3399 150.08 14.0699 149.72 14.9399C149.37 15.7999 149.28 16.75 149.46 17.66C149.64 18.57 150.08 19.4099 150.73 20.0699C151.38 20.7299 152.2 21.18 153.1 21.36C154 21.54 154.93 21.45 155.77 21.09C156.62 20.73 157.34 20.13 157.85 19.35C158.36 18.57 158.63 17.66 158.63 16.73C158.63 15.48 158.14 14.28 157.27 13.4C156.4 12.52 155.22 12.02 154 12.02V12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.63V40.75C218.63 31.79 213.58 25.83 205.25 25.83C196.92 25.83 191.31 31.79 191.31 40.75C191.31 49.71 196.93 55.6699 205.25 55.6699C211.01 55.6699 215.3 52.8799 217.33 48.1699L211.32 45.27C210.93 46.53 210.14 47.61 209.08 48.37C208.02 49.13 206.75 49.51 205.45 49.46C203.92 49.5 202.42 48.95 201.28 47.91C200.14 46.87 199.42 45.42 199.29 43.87H199.35L218.63 41.64V41.63ZM199.09 38.7C199.09 34.49 201.55 31.73 205.22 31.73C206.73 31.7 208.19 32.2699 209.31 33.2999C210.43 34.3399 211.11 35.7699 211.23 37.2999L199.09 38.7Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.83C110.47 25.83 104.85 31.79 104.85 40.75C104.85 49.71 110.47 55.6699 118.8 55.6699C124.55 55.6699 128.84 52.8799 130.82 48.1699L124.81 45.27C124.42 46.51 123.65 47.58 122.61 48.34C121.57 49.09 120.32 49.49 119.05 49.46C117.5 49.53 115.99 48.9799 114.83 47.9399C113.67 46.8999 112.94 45.44 112.81 43.87L132.05 41.62V40.74C132.17 31.8 127.12 25.84 118.8 25.84V25.83ZM112.61 38.71C112.61 34.5 115.02 31.74 118.75 31.74C120.26 31.71 121.72 32.2799 122.84 33.3099C123.96 34.3499 124.64 35.7799 124.76 37.3099L112.6 38.71H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.47V12.73H134.99V47.33C134.99 51.35 135.78 55.5399 142.81 55.5399C144.14 55.6099 145.47 55.39 146.71 54.88V48.4C146.71 48.4 143.29 49.28 143.29 46.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.84H33.04V75.5699H0.25V81.41H38.77V68.6699H218.65V62.84Z", fill: "#5532FA" }));
const SvgExpensify = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 517, height: 83, viewBox: "0 0 517 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.820068H247.93V82.1801H248.93V0.820068Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.22C19.58 28.28 16.72 26.6 12.52 26.6C4.66 26.65 0 32.9001 0 41.5701C0 50.2401 4.65 56.4901 12.52 56.4901C13.96 56.5701 15.41 56.3201 16.75 55.7601C18.09 55.2001 19.29 54.3401 20.26 53.2501V57.42C20.26 60.26 18.76 63.6301 14 63.6301C10.39 63.6301 8.61 61.6101 7.99 59.4401L1.6 62.5301C3.2 66.6301 7.02 70.0701 14.44 70.0701C25.44 70.0701 28.27 62.6501 28.27 56.1501V27.0101H21.54L21.36 31.2101L21.35 31.22ZM14.24 49.6901C10.31 49.6901 7.99 46.4901 7.99 41.5101C7.99 36.5301 10.31 33.3301 14.24 33.3301C18.17 33.3301 20.44 36.5301 20.44 41.5101C20.44 46.4901 18.17 49.6901 14.24 49.6901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.5601C176.63 26.5601 175.11 26.9001 173.73 27.5801C172.34 28.2601 171.12 29.24 170.16 30.47L169.64 27.0301H162.53V56.04H170.83V39.66C170.83 35.13 172.51 33.36 175.84 33.36C178.16 33.36 180.08 34.3901 180.08 38.8101V56.05H188.38V37.1201C188.38 30.9901 184.58 26.5701 178.16 26.5701L178.17 26.5601Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.3901C49.6201 47.3701 47.9401 49.6901 44.6201 49.6901C42.3001 49.6901 40.3601 48.6601 40.3601 44.2401V27.0201H32.0601V45.91C32.0601 52.03 35.8601 56.48 42.2801 56.48C43.8201 56.48 45.3401 56.1301 46.7301 55.4501C48.1201 54.7701 49.3401 53.7801 50.3001 52.5601L50.8201 56.0101H57.9101V27.0201H49.6101V43.3901H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 27.0201H62.2798V56.0301H70.5798V27.0201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.1501C91.6001 27.4201 89.0201 26.5501 86.4001 26.7001C78.5001 26.7001 73.8301 32.9601 73.8301 41.6201C73.8301 50.2801 78.5001 56.54 86.4001 56.54C88.0801 56.65 89.7601 56.31 91.2701 55.55C92.7801 54.7901 94.0701 53.6401 95.0101 52.2101L95.2101 56.0301H101.94V13.55H93.6401L93.6001 29.1501H93.6101ZM88.2101 49.6901C84.2801 49.6901 81.9601 46.4901 81.9601 41.5101C81.9601 36.5301 84.2801 33.3301 88.2101 33.3301C92.1401 33.3301 94.4601 36.5301 94.4601 41.5101C94.4601 46.4901 92.1401 49.6901 88.2101 49.6901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.86C65.5099 12.86 64.6199 13.1401 63.8599 13.6501C63.0999 14.1701 62.5099 14.9001 62.1599 15.7701C61.8099 16.6301 61.7199 17.5801 61.8999 18.4901C62.0799 19.4001 62.5199 20.2401 63.1699 20.9001C63.8199 21.5601 64.6399 22.0101 65.5399 22.1901C66.4399 22.3701 67.3699 22.28 68.2099 21.92C69.0599 21.56 69.7799 20.9601 70.2899 20.1801C70.7999 19.4001 71.0699 18.4901 71.0699 17.5601C71.0699 16.3101 70.5799 15.11 69.7099 14.23C68.8399 13.35 67.6599 12.85 66.4399 12.85L66.4299 12.86Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 27.0201H149.84V56.0301H158.14V27.0201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.86C153.08 12.86 152.19 13.1401 151.43 13.6501C150.67 14.1701 150.08 14.9001 149.72 15.7701C149.37 16.6301 149.28 17.5801 149.46 18.4901C149.64 19.4001 150.08 20.2401 150.73 20.9001C151.38 21.5601 152.2 22.0101 153.1 22.1901C154 22.3701 154.93 22.28 155.77 21.92C156.62 21.56 157.34 20.9601 157.85 20.1801C158.36 19.4001 158.63 18.4901 158.63 17.5601C158.63 16.3101 158.14 15.11 157.27 14.23C156.4 13.35 155.22 12.85 154 12.85V12.86Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.4601V41.5801C218.63 32.6201 213.58 26.66 205.25 26.66C196.92 26.66 191.31 32.6201 191.31 41.5801C191.31 50.5401 196.93 56.5001 205.25 56.5001C211.01 56.5001 215.3 53.7101 217.33 49.0001L211.32 46.1C210.93 47.36 210.14 48.4401 209.08 49.2001C208.02 49.9601 206.75 50.34 205.45 50.29C203.92 50.33 202.42 49.7801 201.28 48.7401C200.14 47.7001 199.42 46.2501 199.29 44.7001H199.35L218.63 42.47V42.4601ZM199.09 39.5301C199.09 35.3201 201.55 32.5601 205.22 32.5601C206.73 32.5301 208.19 33.1001 209.31 34.1301C210.43 35.1701 211.11 36.6001 211.23 38.1301L199.09 39.5301Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.6501C110.47 26.6501 104.85 32.6101 104.85 41.5701C104.85 50.5301 110.47 56.4901 118.8 56.4901C124.55 56.4901 128.84 53.7001 130.82 48.9901L124.81 46.0901C124.42 47.3301 123.65 48.4 122.61 49.16C121.57 49.91 120.32 50.3101 119.05 50.2801C117.5 50.3501 115.99 49.8001 114.83 48.7601C113.67 47.7201 112.94 46.2601 112.81 44.6901L132.05 42.4401V41.5601C132.17 32.6201 127.12 26.66 118.8 26.66V26.6501ZM112.61 39.5301C112.61 35.3201 115.02 32.5601 118.75 32.5601C120.26 32.5301 121.72 33.1001 122.84 34.1301C123.96 35.1701 124.64 36.6001 124.76 38.1301L112.6 39.5301H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.3V13.5601H134.99V48.16C134.99 52.18 135.78 56.3701 142.81 56.3701C144.14 56.4401 145.47 56.2201 146.71 55.7101V49.23C146.71 49.23 143.29 50.1101 143.29 47.3Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.66H33.04V76.3901H0.25V82.23H38.77V69.4901H218.65V63.66Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M278.21 56.04H304.17V48.2101H287.75V40.9601H301.68V32.9401H287.75V26.0701H304.17V18.2401H278.21V56.0301V56.04Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M355.51 26.0701C351.5 26.0701 348.83 27.2201 346.54 30.4601H346.35L345.2 26.8301H338.33V66.1501H347.3V53.7401H347.49C349.21 55.6501 351.69 56.6 355.13 56.6C363.15 56.6 368.87 49.9201 368.87 41.7101V40.5601C368.87 31.5901 362.19 26.05 355.51 26.05V26.0701ZM353.22 49.36C349.02 49.36 347.11 45.9201 347.11 41.3401C347.11 36.7601 349.02 33.5101 353.22 33.5101C357.42 33.5101 359.33 37.1401 359.33 41.5301C359.33 45.9201 357.23 49.36 353.22 49.36Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M399.61 40.5801C399.61 30.8501 392.74 26.0701 385.29 26.0701C376.89 26.0701 370.4 31.9901 370.4 41.1501V42.1C370.4 51.45 377.46 56.9901 385.67 56.9901C392.35 56.9901 398.27 53.7501 399.6 47.0601H391.01C390.06 49.3501 388.15 50.11 385.86 50.11C382.04 50.11 379.94 47.4401 379.56 43.8101H399.41C399.41 43.0501 399.6 41.7101 399.6 40.5701L399.61 40.5801ZM379.76 37.91C380.14 34.86 382.05 32.5701 385.49 32.5701C388.54 32.5701 390.64 34.67 390.64 37.91H379.76Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M418.5 26.0701C414.87 26.0701 412.01 27.4101 409.91 30.6501H409.72L408.57 26.8301H401.51V55.8401H410.67V39.04C410.67 35.41 412.39 33.5001 415.44 33.5001C417.92 33.5001 419.83 35.03 419.83 39.04V55.8401H428.99V36.3701C428.99 30.8301 425.75 26.0601 418.49 26.0601L418.5 26.0701Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M442.75 37.3301C441.22 36.9501 440.08 36.38 440.08 34.66C440.08 33.32 441.03 32.3701 443.13 32.3701C445.42 32.3701 446.57 33.52 446.57 35.42H454.78V34.85C454.78 28.74 449.24 26.2601 442.95 26.2601C437.41 26.2601 431.12 28.55 431.12 35.42V35.8C431.12 37.9 431.88 39.8101 433.22 41.1401C436.08 44.0001 440.47 44.3801 443.53 45.1501C446.01 45.7201 446.58 46.8701 446.58 48.2001C446.58 49.9201 445.24 50.8701 443.14 50.8701C440.66 50.8701 439.13 49.53 438.94 46.67H430.73V47.2401C431.11 54.3001 436.46 56.97 443.14 56.97C449.06 56.97 455.55 54.3001 455.55 47.4301V46.67C455.55 44.57 454.79 42.6601 453.64 41.3301C450.97 38.2801 446.39 37.8901 442.76 37.3201L442.75 37.3301Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M466.61 27.0301H457.45V56.04H466.61V27.0301Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M336.43 27.0301H326.31L321.54 34.2801L316.58 27.0301H306.27L316 40.5801L304.93 56.04H315.05L321.16 47.2601L327.27 56.04H337.77L326.51 40.3901L336.44 27.0301H336.43Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M462.03 12.9001C458.98 12.9001 456.49 15.3801 456.49 18.4401C456.49 21.5001 458.97 23.98 462.03 23.98C465.09 23.98 467.56 21.5001 467.56 18.4401C467.56 15.3801 465.08 12.9001 462.03 12.9001Z", fill: "#0C1B33" }), /* @__PURE__ */ React.createElement("path", { d: "M483.02 27.0301V26.0801C483.02 23.6001 484.74 21.1201 487.41 21.1201H490.08V13.1H486.84C479.01 13.29 473.86 19.2101 473.86 26.6501V27.0301H468.52V33.9001H473.86V55.85H483.02V33.9001H488.94L496.58 53.9401L491.24 66.35H500.78L517 27.0301H507.46L501.16 44.4001L495.43 27.0301H483.02Z", fill: "#0C1B33" }));
const SvgGosite = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 473, height: 82, viewBox: "0 0 473 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.469971H247.93V81.83H248.93V0.469971Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.87C19.58 27.93 16.72 26.25 12.52 26.25C4.66 26.3 0 32.55 0 41.22C0 49.89 4.65 56.14 12.52 56.14C13.96 56.22 15.41 55.97 16.75 55.41C18.09 54.85 19.29 53.99 20.26 52.9V57.0699C20.26 59.9099 18.76 63.28 14 63.28C10.39 63.28 8.61 61.26 7.99 59.09L1.6 62.1801C3.2 66.2801 7.02 69.72 14.44 69.72C25.44 69.72 28.27 62.3 28.27 55.8V26.66H21.54L21.36 30.86L21.35 30.87ZM14.24 49.34C10.31 49.34 7.99 46.14 7.99 41.16C7.99 36.18 10.31 32.98 14.24 32.98C18.17 32.98 20.44 36.18 20.44 41.16C20.44 46.14 18.17 49.34 14.24 49.34Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.2C176.63 26.2 175.11 26.54 173.73 27.22C172.34 27.9 171.12 28.88 170.16 30.11L169.64 26.67H162.53V55.6899H170.83V39.3101C170.83 34.7801 172.51 33.01 175.84 33.01C178.16 33.01 180.08 34.04 180.08 38.46V55.7H188.38V36.77C188.38 30.64 184.58 26.22 178.16 26.22L178.17 26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.04C49.6201 47.02 47.9401 49.35 44.6201 49.35C42.3001 49.35 40.3601 48.32 40.3601 43.9V26.67H32.0601V45.5601C32.0601 51.6801 35.8601 56.13 42.2801 56.13C43.8201 56.13 45.3401 55.78 46.7301 55.1C48.1201 54.42 49.3401 53.43 50.3001 52.21L50.8201 55.66H57.9101V26.67H49.6101V43.04H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.67H62.2798V55.6899H70.5798V26.67Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6098 28.8C91.5998 27.07 89.0198 26.19 86.3898 26.35C78.4898 26.35 73.8198 32.61 73.8198 41.27C73.8198 49.93 78.4898 56.1899 86.3898 56.1899C88.0698 56.2999 89.7498 55.9599 91.2598 55.2C92.7698 54.44 94.0598 53.29 94.9998 51.86L95.1998 55.6801H101.93V13.2H93.6298L93.5898 28.8H93.6098ZM88.2098 49.34C84.2798 49.34 81.9598 46.14 81.9598 41.16C81.9598 36.18 84.2798 32.98 88.2098 32.98C92.1398 32.98 94.4598 36.18 94.4598 41.16C94.4598 46.14 92.1398 49.34 88.2098 49.34Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4399 12.5C65.5199 12.5 64.6299 12.78 63.8699 13.29C63.1099 13.81 62.5199 14.54 62.1599 15.41C61.8099 16.27 61.7199 17.22 61.8999 18.13C62.0799 19.04 62.5199 19.88 63.1699 20.54C63.8199 21.2 64.6399 21.65 65.5399 21.83C66.4399 22.01 67.3699 21.9201 68.2099 21.5601C69.0599 21.2001 69.7799 20.5999 70.2899 19.8199C70.7999 19.0399 71.0699 18.13 71.0699 17.2C71.0699 15.95 70.5799 14.75 69.7099 13.87C68.8399 12.99 67.6599 12.49 66.4399 12.49V12.5Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.15 26.67H149.85V55.6899H158.15V26.67Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.5C153.08 12.5 152.19 12.78 151.43 13.29C150.67 13.81 150.08 14.54 149.72 15.41C149.37 16.27 149.28 17.22 149.46 18.13C149.64 19.04 150.08 19.88 150.73 20.54C151.38 21.2 152.2 21.65 153.1 21.83C154 22.01 154.93 21.9201 155.77 21.5601C156.62 21.2001 157.34 20.5999 157.85 19.8199C158.36 19.0399 158.63 18.13 158.63 17.2C158.63 15.95 158.14 14.75 157.27 13.87C156.4 12.99 155.22 12.49 154 12.49V12.5Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 42.11V41.23C218.64 32.27 213.59 26.3101 205.26 26.3101C196.93 26.3101 191.32 32.27 191.32 41.23C191.32 50.19 196.94 56.15 205.26 56.15C211.02 56.15 215.31 53.36 217.35 48.65L211.34 45.75C210.95 47.01 210.16 48.09 209.1 48.85C208.04 49.61 206.77 49.9899 205.47 49.9399C203.94 49.9799 202.44 49.43 201.3 48.39C200.16 47.35 199.44 45.9 199.31 44.35H199.37L218.65 42.12L218.64 42.11ZM199.1 39.1801C199.1 34.9701 201.57 32.21 205.23 32.21C206.74 32.18 208.2 32.75 209.32 33.78C210.44 34.82 211.12 36.25 211.24 37.78L199.1 39.1801Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.3C110.47 26.3 104.85 32.26 104.85 41.22C104.85 50.18 110.47 56.14 118.8 56.14C124.55 56.14 128.84 53.35 130.82 48.64L124.81 45.74C124.42 46.98 123.65 48.0501 122.61 48.8101C121.57 49.5601 120.32 49.9601 119.05 49.9301C117.5 50.0001 115.99 49.45 114.83 48.41C113.67 47.37 112.94 45.91 112.81 44.34L132.05 42.09V41.21C132.17 32.27 127.12 26.3101 118.8 26.3101V26.3ZM112.61 39.1801C112.61 34.9701 115.02 32.21 118.75 32.21C120.26 32.18 121.72 32.75 122.84 33.78C123.96 34.82 124.64 36.25 124.76 37.78L112.6 39.1801H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.3 46.9399V13.2H135V47.8C135 51.82 135.79 56.01 142.82 56.01C144.15 56.08 145.48 55.86 146.72 55.35V48.87C146.72 48.87 143.3 49.7499 143.3 46.9399Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.66 63.3101H33.04V76.04H0.25V81.88H38.77V69.14H218.66V63.3101Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M280.7 47.03L303.72 23.88L326.75 47.03C331.29 37.49 329.62 25.74 321.77 17.84C311.8 7.81995 295.66 7.81995 285.69 17.84C277.83 25.74 276.17 37.49 280.71 47.03H280.7Z", fill: "#0058FF" }), /* @__PURE__ */ React.createElement("path", { d: "M303.71 23.88L280.69 47.03C281.9 49.58 283.56 51.99 285.67 54.11L290.17 58.65L303.7 45.05L317.23 58.65L321.73 54.12C323.84 52 325.5 49.61 326.71 47.04L303.69 23.87L303.71 23.88Z", fill: "#08B2FA" }), /* @__PURE__ */ React.createElement("path", { d: "M303.71 45.04L290.18 58.64L303.71 72.24L317.24 58.64L303.71 45.04Z", fill: "#86EAFA" }), /* @__PURE__ */ React.createElement("path", { d: "M368.75 30.71V51.45C368.75 53.51 368.49 55.37 368 57.02C367.49 58.67 366.72 60.09 365.67 61.24C364.62 62.4 363.29 63.3 361.68 63.92C360.08 64.55 358.17 64.87 355.96 64.87C353.75 64.87 351.86 64.5999 349.97 64.0699C348.09 63.5199 346.33 62.54 344.73 61.13L348.13 56.47C349.26 57.51 350.45 58.32 351.68 58.89C352.91 59.45 354.33 59.74 355.93 59.74C357.29 59.74 358.42 59.5501 359.35 59.1801C360.28 58.7901 361.01 58.28 361.57 57.61C362.11 56.95 362.51 56.15 362.75 55.22C362.99 54.29 363.1 53.25 363.1 52.11V50.46H363C362.19 51.57 361.1 52.4 359.74 52.95C358.38 53.5 357.01 53.78 355.59 53.78C353.9 53.78 352.35 53.47 350.96 52.85C349.57 52.24 348.39 51.41 347.4 50.36C346.41 49.32 345.64 48.08 345.12 46.65C344.58 45.22 344.32 43.71 344.32 42.09C344.32 40.47 344.58 38.85 345.07 37.39C345.57 35.93 346.32 34.68 347.29 33.6C348.26 32.52 349.45 31.6701 350.8 31.0601C352.17 30.4501 353.74 30.13 355.5 30.13C357.11 30.13 358.6 30.45 359.99 31.08C361.38 31.71 362.48 32.72 363.3 34.11H363.4V30.71H368.77H368.75ZM356.66 35.27C355.65 35.27 354.74 35.43 353.93 35.77C353.12 36.11 352.41 36.56 351.82 37.15C351.25 37.73 350.78 38.45 350.45 39.29C350.11 40.12 349.95 41.0599 349.95 42.0699C349.95 42.9899 350.11 43.84 350.45 44.64C350.79 45.43 351.25 46.13 351.84 46.73C352.43 47.32 353.15 47.81 353.96 48.16C354.77 48.51 355.65 48.6899 356.61 48.6899C357.65 48.6899 358.59 48.51 359.42 48.16C360.25 47.81 360.97 47.34 361.54 46.76C362.12 46.18 362.58 45.48 362.88 44.64C363.2 43.82 363.36 42.94 363.36 41.97C363.36 39.98 362.77 38.36 361.57 37.14C360.37 35.89 358.73 35.28 356.65 35.28L356.66 35.27Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M373.05 42.1C373.05 40.3 373.37 38.6599 374.02 37.1899C374.66 35.7099 375.54 34.46 376.64 33.42C377.74 32.38 379.05 31.57 380.55 31C382.07 30.44 383.66 30.15 385.36 30.15C387.06 30.15 388.67 30.44 390.18 31C391.7 31.56 392.99 32.38 394.09 33.42C395.19 34.46 396.07 35.7199 396.71 37.1899C397.35 38.6699 397.68 40.3 397.68 42.1C397.68 43.9 397.36 45.54 396.71 47.01C396.07 48.49 395.19 49.74 394.09 50.78C392.99 51.82 391.68 52.63 390.18 53.2C388.66 53.76 387.07 54.05 385.36 54.05C383.65 54.05 382.05 53.76 380.55 53.2C379.03 52.64 377.74 51.82 376.64 50.78C375.54 49.74 374.66 48.48 374.02 47.01C373.37 45.55 373.05 43.91 373.05 42.1ZM378.72 42.1C378.72 42.98 378.86 43.83 379.17 44.67C379.47 45.49 379.9 46.23 380.5 46.85C381.07 47.48 381.78 47.99 382.61 48.38C383.44 48.77 384.35 48.9399 385.39 48.9399C386.43 48.9399 387.35 48.75 388.17 48.38C388.98 47.99 389.69 47.5 390.28 46.85C390.85 46.22 391.3 45.49 391.61 44.67C391.91 43.85 392.06 43 392.06 42.1C392.06 41.2 391.92 40.37 391.61 39.53C391.31 38.71 390.88 37.97 390.28 37.35C389.7 36.72 389 36.2099 388.17 35.8199C387.36 35.4299 386.43 35.26 385.39 35.26C384.35 35.26 383.43 35.4499 382.61 35.8199C381.8 36.2099 381.09 36.7 380.5 37.35C379.92 37.98 379.48 38.71 379.17 39.53C378.87 40.36 378.72 41.22 378.72 42.1Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M414.08 37.03C412.98 35.47 411.49 34.7 409.64 34.7C408.89 34.7 408.14 34.89 407.42 35.26C406.7 35.65 406.33 36.26 406.33 37.11C406.33 37.8 406.63 38.31 407.22 38.64C407.81 38.96 408.58 39.2199 409.49 39.4399C410.4 39.6599 411.39 39.89 412.44 40.13C413.49 40.37 414.48 40.72 415.39 41.22C416.3 41.72 417.05 42.38 417.66 43.24C418.25 44.09 418.55 45.26 418.55 46.76C418.55 48.12 418.26 49.26 417.67 50.2C417.1 51.13 416.33 51.89 415.4 52.45C414.47 53.01 413.42 53.4299 412.25 53.6899C411.08 53.9499 409.92 54.08 408.75 54.08C406.99 54.08 405.36 53.82 403.89 53.33C402.4 52.82 401.09 51.9 399.93 50.58L403.7 47.02C404.42 47.84 405.2 48.51 406.03 49.04C406.86 49.55 407.88 49.83 409.08 49.83C409.5 49.83 409.91 49.7799 410.36 49.6899C410.81 49.5899 411.21 49.43 411.59 49.21C411.97 48.99 412.28 48.71 412.52 48.38C412.76 48.04 412.87 47.66 412.87 47.22C412.87 46.43 412.57 45.84 411.98 45.47C411.39 45.08 410.62 44.78 409.71 44.54C408.8 44.3 407.81 44.07 406.76 43.88C405.71 43.67 404.72 43.35 403.81 42.88C402.9 42.41 402.15 41.79 401.54 40.95C400.95 40.13 400.65 38.99 400.65 37.53C400.65 36.26 400.91 35.17 401.43 34.24C401.96 33.31 402.63 32.5399 403.49 31.9399C404.34 31.3499 405.31 30.9 406.41 30.61C407.51 30.32 408.63 30.1801 409.76 30.1801C411.28 30.1801 412.76 30.44 414.25 30.97C415.74 31.48 416.92 32.38 417.84 33.65L414.05 37.05L414.08 37.03Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M421.25 22.98C421.25 22.06 421.58 21.26 422.27 20.59C422.94 19.92 423.8 19.5601 424.84 19.5601C425.88 19.5601 426.76 19.88 427.46 20.54C428.16 21.18 428.53 22 428.53 22.98C428.53 23.96 428.18 24.78 427.46 25.42C426.76 26.06 425.88 26.4 424.84 26.4C423.8 26.4 422.94 26.06 422.27 25.37C421.58 24.7 421.25 23.89 421.25 22.98ZM422.05 30.72H427.72V53.5H422.05V30.72Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M430.6 35.55V30.72H435.28V24.12H440.95V30.72H447.18V35.55H440.95V45.52C440.95 46.66 441.16 47.56 441.59 48.22C442.02 48.88 442.85 49.22 444.11 49.22C444.62 49.22 445.16 49.1701 445.76 49.0601C446.35 48.9501 446.83 48.77 447.18 48.51V53.3101C446.59 53.6001 445.85 53.79 444.99 53.9C444.13 54.01 443.36 54.0601 442.71 54.0601C441.19 54.0601 439.96 53.9001 439 53.5601C438.04 53.2201 437.29 52.73 436.73 52.03C436.19 51.36 435.8 50.5 435.6 49.49C435.39 48.48 435.3 47.31 435.3 45.97V35.53H430.6V35.55Z", fill: "#082344" }), /* @__PURE__ */ React.createElement("path", { d: "M455.14 44.09C455.33 45.79 455.99 47.1199 457.12 48.0699C458.25 49.0199 459.63 49.5 461.22 49.5C462.64 49.5 463.82 49.21 464.78 48.62C465.74 48.04 466.58 47.3 467.3 46.42L471.36 49.5C470.03 51.14 468.56 52.31 466.92 53.02C465.29 53.71 463.56 54.0601 461.78 54.0601C460.09 54.0601 458.47 53.77 456.96 53.21C455.44 52.63 454.15 51.83 453.05 50.79C451.95 49.75 451.07 48.49 450.43 47.02C449.79 45.54 449.46 43.91 449.46 42.11C449.46 40.31 449.78 38.67 450.43 37.2C451.07 35.72 451.95 34.4701 453.05 33.4301C454.15 32.3901 455.46 31.58 456.96 31.01C458.48 30.45 460.07 30.16 461.78 30.16C463.35 30.16 464.8 30.43 466.09 31C467.4 31.55 468.52 32.35 469.44 33.39C470.37 34.43 471.09 35.72 471.61 37.26C472.14 38.8 472.39 40.5501 472.39 42.5601V44.13H455.12V44.11L455.14 44.09ZM466.75 39.8199C466.72 38.1499 466.19 36.82 465.18 35.85C464.17 34.89 462.77 34.41 460.98 34.41C459.29 34.41 457.93 34.91 456.94 35.89C455.95 36.87 455.34 38.1899 455.12 39.8199H466.75Z", fill: "#082344" }));
const SvgHeard = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 432, height: 83, viewBox: "0 0 432 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9109_21262)" }, /* @__PURE__ */ React.createElement("path", { d: "M248.92 0.726562H247.92V82.0866H248.92V0.726562Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.3402 31.1266C19.5702 28.1866 16.7102 26.5066 12.5102 26.5066C4.65023 26.5566 -0.00976562 32.8066 -0.00976562 41.4766C-0.00976562 50.1466 4.64023 56.3966 12.5102 56.3966C13.9502 56.4766 15.4002 56.2266 16.7402 55.6666C18.0802 55.1066 19.2802 54.2466 20.2502 53.1566V57.3266C20.2502 60.1666 18.7502 63.5366 13.9902 63.5366C10.3802 63.5366 8.60023 61.5166 7.98023 59.3466L1.59023 62.4366C3.19023 66.5366 7.01023 69.9766 14.4302 69.9766C25.4302 69.9766 28.2602 62.5566 28.2602 56.0566V26.9266H21.5302L21.3502 31.1266H21.3402ZM14.2302 49.5966C10.3002 49.5966 7.98023 46.3966 7.98023 41.4166C7.98023 36.4366 10.3002 33.2366 14.2302 33.2366C18.1602 33.2366 20.4302 36.4366 20.4302 41.4166C20.4302 46.3966 18.1602 49.5966 14.2302 49.5966Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.16 26.4565C176.62 26.4565 175.1 26.7965 173.72 27.4765C172.33 28.1565 171.11 29.1365 170.15 30.3665L169.63 26.9265H162.52V55.9365H170.82V39.5565C170.82 35.0265 172.5 33.2565 175.83 33.2565C178.15 33.2565 180.07 34.2865 180.07 38.7065V55.9465H188.37V37.0165C188.37 30.8865 184.57 26.4665 178.15 26.4665L178.16 26.4565Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6103 43.2965C49.6103 47.2765 47.9303 49.5965 44.6103 49.5965C42.2903 49.5965 40.3503 48.5665 40.3503 44.1465V26.9265H32.0503V45.8165C32.0503 51.9365 35.8503 56.3865 42.2703 56.3865C43.8103 56.3865 45.3303 56.0365 46.7203 55.3565C48.1103 54.6765 49.3303 53.6865 50.2903 52.4665L50.8103 55.9165H57.9003V26.9265H49.6003V43.2965H49.6103Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.57 26.9265H62.27V55.9365H70.57V26.9265Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6003 29.0565C91.5903 27.3265 89.0103 26.4565 86.3903 26.6065C78.4903 26.6065 73.8203 32.8665 73.8203 41.5265C73.8203 50.1865 78.4903 56.4465 86.3903 56.4465C88.0703 56.5565 89.7503 56.2165 91.2603 55.4565C92.7703 54.6965 94.0603 53.5465 95.0003 52.1165L95.2003 55.9365H101.93V13.4565H93.6303L93.5903 29.0565H93.6003ZM88.2003 49.5965C84.2703 49.5965 81.9503 46.3965 81.9503 41.4165C81.9503 36.4365 84.2703 33.2365 88.2003 33.2365C92.1303 33.2365 94.4503 36.4365 94.4503 41.4165C94.4503 46.3965 92.1303 49.5965 88.2003 49.5965Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4202 12.7566C65.5002 12.7566 64.6102 13.0366 63.8502 13.5466C63.0902 14.0666 62.5002 14.7966 62.1502 15.6666C61.8002 16.5266 61.7102 17.4766 61.8902 18.3866C62.0702 19.2966 62.5102 20.1366 63.1602 20.7966C63.8102 21.4566 64.6302 21.9066 65.5302 22.0866C66.4302 22.2666 67.3602 22.1766 68.2002 21.8166C69.0502 21.4566 69.7702 20.8566 70.2802 20.0766C70.7902 19.2966 71.0602 18.3866 71.0602 17.4566C71.0602 16.2066 70.5702 15.0066 69.7002 14.1266C68.8302 13.2466 67.6502 12.7466 66.4302 12.7466L66.4202 12.7566Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.13 26.9265H149.83V55.9365H158.13V26.9265Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M153.99 12.7566C153.07 12.7566 152.18 13.0366 151.42 13.5466C150.66 14.0666 150.07 14.7966 149.71 15.6666C149.36 16.5266 149.27 17.4766 149.45 18.3866C149.63 19.2966 150.07 20.1366 150.72 20.7966C151.37 21.4566 152.19 21.9066 153.09 22.0866C153.99 22.2666 154.92 22.1766 155.76 21.8166C156.61 21.4566 157.33 20.8566 157.84 20.0766C158.35 19.2966 158.62 18.3866 158.62 17.4566C158.62 16.2066 158.13 15.0066 157.26 14.1266C156.39 13.2466 155.21 12.7466 153.99 12.7466V12.7566Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.62 42.3666V41.4866C218.62 32.5266 213.57 26.5667 205.24 26.5667C196.91 26.5667 191.3 32.5266 191.3 41.4866C191.3 50.4466 196.92 56.4067 205.24 56.4067C211 56.4067 215.29 53.6166 217.32 48.9067L211.31 46.0066C210.92 47.2666 210.13 48.3467 209.07 49.1067C208.01 49.8667 206.74 50.2467 205.44 50.1967C203.91 50.2367 202.41 49.6866 201.27 48.6466C200.13 47.6066 199.41 46.1567 199.28 44.6067H199.34L218.62 42.3767V42.3666ZM199.08 39.4366C199.08 35.2266 201.54 32.4667 205.21 32.4667C206.72 32.4366 208.18 33.0067 209.3 34.0367C210.42 35.0767 211.1 36.5067 211.22 38.0367L199.08 39.4366Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.79 26.5566C110.46 26.5566 104.84 32.5166 104.84 41.4766C104.84 50.4366 110.46 56.3966 118.79 56.3966C124.54 56.3966 128.83 53.6066 130.81 48.8966L124.8 45.9966C124.41 47.2366 123.64 48.3066 122.6 49.0666C121.56 49.8166 120.31 50.2166 119.04 50.1866C117.49 50.2566 115.98 49.7066 114.82 48.6666C113.66 47.6266 112.93 46.1666 112.8 44.5966L132.04 42.3466V41.4666C132.16 32.5266 127.11 26.5666 118.79 26.5666V26.5566ZM112.6 39.4366C112.6 35.2266 115.01 32.4666 118.74 32.4666C120.25 32.4366 121.71 33.0066 122.83 34.0366C123.95 35.0766 124.63 36.5066 124.75 38.0366L112.59 39.4366H112.6Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.28 47.1965V13.4565H134.98V48.0565C134.98 52.0765 135.77 56.2665 142.8 56.2665C144.13 56.3365 145.46 56.1165 146.7 55.6065V49.1265C146.7 49.1265 143.28 50.0065 143.28 47.1965Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 63.5667H33.0302V76.2966H0.240234V82.1367H38.7602V69.3966H218.64V63.5667Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M304.36 15.5767V33.4367H285.43V15.5767H278.19V55.8967H285.43V37.4467H304.36V55.8967H311.6V15.5767H304.36Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M376.85 48.9066V37.2566C376.85 34.9066 376.32 30.5666 371.22 28.1466C366.12 25.7266 357.73 24.4366 351.01 31.8266L353.6 34.0166C353.6 34.0166 359.2 28.6166 365.83 31.4266C367.86 32.2966 369.29 34.6866 369.51 36.2366C369.7 37.5666 369.51 40.0066 369.51 40.0066C367.58 38.8266 364.63 37.5866 360.66 37.5866C353.07 37.5866 348.7 41.6566 348.7 47.2666C348.7 52.8766 353.07 56.5466 360.66 56.5466C364.85 56.5466 367.92 54.5566 369.83 52.7666C369.99 53.7466 370.2 54.6766 370.5 55.7166H377.69C376.91 53.6366 376.86 49.7066 376.86 48.9166L376.85 48.9066ZM362.73 52.7666C355.7 52.7666 356.1 47.2666 356.1 47.2666C356.1 47.2666 355.7 41.3666 362.73 41.3666C365.66 41.3666 367.95 42.4666 369.49 43.4966V48.9366C367.94 50.9166 365.7 52.7666 362.73 52.7666Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M331.37 26.2467C319.89 26.7567 315.95 35.0967 315.95 41.0967C315.95 51.9967 324.93 56.5367 331.37 56.5367C337.81 56.5367 341.79 54.8867 345.01 50.2467L342.39 48.3267C342.39 48.3267 339.8 52.1967 334.07 52.1967C327.38 52.1967 323.76 47.1967 323.76 43.1167H346.49C347.82 34.8967 341.72 25.7867 331.37 26.2467ZM323.77 39.1067C323.77 39.1067 324.56 30.3267 331.16 30.0567C338.51 30.0567 338.98 39.1067 338.98 39.1067H323.77Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M391.11 29.1266C390.22 30.0566 389.54 31.1166 388.88 32.2266V26.9366H381.16C381.55 27.9966 381.76 29.6466 381.85 30.9566V55.7166H389.11V40.2666C389.12 39.3766 389.21 38.4766 389.37 37.5966C390.08 33.8566 392.82 31.5266 396.64 31.3866H399.35V26.2566C396.31 26.0466 393.24 26.8666 391.09 29.1166L391.11 29.1266Z", fill: "#226752" }), /* @__PURE__ */ React.createElement("path", { d: "M431.39 55.9166C431 54.8666 430.79 53.2266 430.7 51.9066V15.5266H423.32V31.0166C421.23 28.0666 417.97 26.1766 413.45 26.1766C406.42 26.1766 399.78 32.6266 399.78 41.1866C399.78 50.8866 406.43 56.5266 413.45 56.5266C418.19 56.5266 421.41 54.9666 423.42 51.9166C423.44 52.1666 423.48 52.5866 423.53 52.9766C423.69 53.9566 423.9 54.8866 424.2 55.9266H431.39C431.39 55.9266 431.39 55.9166 431.39 55.9066V55.9166ZM415.75 51.6066C411.38 51.6066 407.18 47.7766 407.18 41.3666C407.18 35.4266 411.37 31.5966 415.75 31.5966C418.9 31.5966 421.89 33.6566 423.32 37.0366V46.2266C421.89 49.6866 418.9 51.5966 415.75 51.5966V51.6066Z", fill: "#226752" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9109_21262" }, /* @__PURE__ */ React.createElement("rect", { width: 431.39, height: 81.41, fill: "white", transform: "translate(0 0.726562)" }))));
const SvgLoot = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 360, height: 82, viewBox: "0 0 360 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 -0.000244141H247.93V81.3598H248.93V-0.000244141Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.3998C19.58 27.4598 16.72 25.7798 12.52 25.7798C4.66 25.8298 0 32.0798 0 40.7498C0 49.4198 4.65 55.6698 12.52 55.6698C13.96 55.7498 15.41 55.4998 16.75 54.9398C18.09 54.3798 19.29 53.5198 20.26 52.4298V56.5998C20.26 59.4398 18.76 62.8098 14 62.8098C10.39 62.8098 8.61 60.7898 7.99 58.6198L1.6 61.7098C3.2 65.8098 7.02 69.2498 14.44 69.2498C25.44 69.2498 28.27 61.8298 28.27 55.3298V26.1998H21.54L21.36 30.3998H21.35ZM14.24 48.8698C10.31 48.8698 7.99 45.6698 7.99 40.6898C7.99 35.7098 10.31 32.5098 14.24 32.5098C18.17 32.5098 20.44 35.7098 20.44 40.6898C20.44 45.6698 18.17 48.8698 14.24 48.8698Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.7297C176.63 25.7297 175.11 26.0697 173.73 26.7497C172.34 27.4297 171.12 28.4097 170.16 29.6397L169.64 26.1997H162.53V55.2097H170.83V38.8297C170.83 34.2997 172.51 32.5297 175.84 32.5297C178.16 32.5297 180.08 33.5597 180.08 37.9797V55.2197H188.38V36.2897C188.38 30.1597 184.58 25.7397 178.16 25.7397L178.17 25.7297Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.5697C49.6201 46.5497 47.9401 48.8697 44.6201 48.8697C42.3001 48.8697 40.3601 47.8397 40.3601 43.4197V26.1997H32.0601V45.0897C32.0601 51.2097 35.8601 55.6597 42.2801 55.6597C43.8201 55.6597 45.3401 55.3097 46.7301 54.6297C48.1201 53.9497 49.3401 52.9597 50.3001 51.7397L50.8201 55.1897H57.9101V26.1997H49.6101V42.5697H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.1997H62.2798V55.2097H70.5798V26.1997Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.3297C91.6001 26.5997 89.0201 25.7297 86.4001 25.8797C78.5001 25.8797 73.8301 32.1397 73.8301 40.7997C73.8301 49.4597 78.5001 55.7197 86.4001 55.7197C88.0801 55.8297 89.7601 55.4897 91.2701 54.7297C92.7801 53.9697 94.0701 52.8197 95.0101 51.3897L95.2101 55.2097H101.94V12.7297H93.6401L93.6001 28.3297H93.6101ZM88.2101 48.8697C84.2801 48.8697 81.9601 45.6697 81.9601 40.6897C81.9601 35.7097 84.2801 32.5097 88.2101 32.5097C92.1401 32.5097 94.4601 35.7097 94.4601 40.6897C94.4601 45.6697 92.1401 48.8697 88.2101 48.8697Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.0298C65.5099 12.0298 64.6199 12.3098 63.8599 12.8198C63.0999 13.3398 62.5099 14.0698 62.1599 14.9398C61.8099 15.7998 61.7199 16.7498 61.8999 17.6598C62.0799 18.5698 62.5199 19.4098 63.1699 20.0698C63.8199 20.7298 64.6399 21.1798 65.5399 21.3598C66.4399 21.5398 67.3699 21.4498 68.2099 21.0898C69.0599 20.7298 69.7799 20.1298 70.2899 19.3498C70.7999 18.5698 71.0699 17.6598 71.0699 16.7298C71.0699 15.4798 70.5799 14.2798 69.7099 13.3998C68.8399 12.5198 67.6599 12.0198 66.4399 12.0198L66.4299 12.0298Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.1997H149.84V55.2097H158.14V26.1997Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.0298C153.08 12.0298 152.19 12.3098 151.43 12.8198C150.67 13.3398 150.08 14.0698 149.72 14.9398C149.37 15.7998 149.28 16.7498 149.46 17.6598C149.64 18.5698 150.08 19.4098 150.73 20.0698C151.38 20.7298 152.2 21.1798 153.1 21.3598C154 21.5398 154.93 21.4498 155.77 21.0898C156.62 20.7298 157.34 20.1298 157.85 19.3498C158.36 18.5698 158.63 17.6598 158.63 16.7298C158.63 15.4798 158.14 14.2798 157.27 13.3998C156.4 12.5198 155.22 12.0198 154 12.0198V12.0298Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.6398V40.7598C218.63 31.7998 213.58 25.8398 205.25 25.8398C196.92 25.8398 191.31 31.7998 191.31 40.7598C191.31 49.7198 196.93 55.6798 205.25 55.6798C211.01 55.6798 215.3 52.8898 217.33 48.1798L211.32 45.2798C210.93 46.5398 210.14 47.6198 209.08 48.3798C208.02 49.1398 206.75 49.5198 205.45 49.4698C203.92 49.5098 202.42 48.9598 201.28 47.9198C200.14 46.8798 199.42 45.4298 199.29 43.8798H199.35L218.63 41.6498V41.6398ZM199.09 38.7098C199.09 34.4998 201.55 31.7398 205.22 31.7398C206.73 31.7098 208.19 32.2798 209.31 33.3098C210.43 34.3498 211.11 35.7798 211.23 37.3098L199.09 38.7098Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.8298C110.47 25.8298 104.85 31.7898 104.85 40.7498C104.85 49.7098 110.47 55.6698 118.8 55.6698C124.55 55.6698 128.84 52.8798 130.82 48.1698L124.81 45.2698C124.42 46.5098 123.65 47.5798 122.61 48.3398C121.57 49.0898 120.32 49.4898 119.05 49.4598C117.5 49.5298 115.99 48.9798 114.83 47.9398C113.67 46.8998 112.94 45.4398 112.81 43.8698L132.05 41.6198V40.7398C132.17 31.7998 127.12 25.8398 118.8 25.8398V25.8298ZM112.61 38.7098C112.61 34.4998 115.02 31.7398 118.75 31.7398C120.26 31.7098 121.72 32.2798 122.84 33.3098C123.96 34.3498 124.64 35.7798 124.76 37.3098L112.6 38.7098H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.4697V12.7297H134.99V47.3297C134.99 51.3497 135.78 55.5397 142.81 55.5397C144.14 55.6097 145.47 55.3897 146.71 54.8797V48.3997C146.71 48.3997 143.29 49.2797 143.29 46.4697Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.8398H33.04V75.5698H0.25V81.4098H38.77V68.6698H218.65V62.8398Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M285.43 41.6098V15.7498H278.5V41.6098C278.5 49.2098 284.69 55.3998 292.3 55.3998V48.4198C288.55 48.4198 285.43 45.3598 285.43 41.6098Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M352.27 39.1599V28.9699H358.81V21.0899H352.27V16.3499H344.38V39.1599C344.38 47.7399 351.37 54.7299 359.97 54.7299V46.8499C355.73 46.8499 352.27 43.3899 352.27 39.1599Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M306.67 32.8797V25.9297C298.55 25.9297 291.95 32.4697 291.95 40.5197H298.96C298.96 36.2997 302.42 32.8697 306.68 32.8697L306.67 32.8797Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M314.39 40.5197C314.39 36.9197 315.7 33.6097 317.86 31.0497C315.16 27.9297 311.15 25.9297 306.67 25.9297V32.8797C310.93 32.8797 314.39 36.3097 314.39 40.5297V40.5197Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M336.82 40.5198C336.82 44.7698 333.37 48.2298 329.1 48.2298C324.83 48.2298 321.39 44.7698 321.39 40.5198C321.39 44.1298 320.05 47.4398 317.86 49.9898C320.56 53.1898 324.6 55.3698 329.1 55.3698C337.22 55.3698 343.84 48.6298 343.84 40.5198H336.82Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M329.11 25.8198C324.61 25.8198 320.56 27.8598 317.86 31.0498C315.69 33.6098 314.39 36.9198 314.39 40.5198C314.39 44.7398 310.94 48.1698 306.67 48.1698C302.4 48.1698 298.95 44.7498 298.95 40.5198H291.94C291.94 48.5698 298.54 55.1098 306.66 55.1098C311.14 55.1098 315.15 53.1198 317.85 49.9898C320.06 47.4398 321.38 44.1298 321.38 40.5198C321.38 36.2698 324.83 32.8098 329.1 32.8098C333.37 32.8098 336.82 36.2598 336.82 40.5198H343.83C343.83 32.4098 337.21 25.8198 329.11 25.8198Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M321.56 39.9497C321.25 43.5397 320.15 47.8497 317.77 50.2197C320.19 53.5697 323.52 55.3497 329.15 55.3497V48.2597C324.91 47.8897 321.19 44.1497 321.56 39.9497Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M310.69 41.3498L318.46 33.5498L326.23 41.3498L318.46 49.1498L310.69 41.3498Z", fill: "#BFF0D4", stroke: "white", strokeWidth: 1.99, strokeMiterlimit: 10 }));
const SvgOwnerActions = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 450, height: 83, viewBox: "0 0 450 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8174_21244)" }, /* @__PURE__ */ React.createElement("path", { d: "M327.62 28.9248L302.69 53.8548L286.68 37.8048L291.85 32.5948L302.69 43.4348L323.12 23.0348C318.34 18.3248 311.82 15.4048 304.58 15.4048C290 15.4048 278.19 27.2048 278.19 41.7948C278.19 56.3848 289.99 68.1848 304.58 68.1848C319.17 68.1848 330.97 56.3848 330.97 41.7948C330.93 37.1248 329.72 32.7348 327.62 28.9248Z", fill: "url(#paint0_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M353.26 29.0348V26.7148C352.65 21.7548 348.2 18.3748 342.67 18.3748C336.64 18.3748 331.9 22.2648 331.9 27.8648C331.9 33.4648 336.21 37.3148 342.67 37.3148C348.41 37.3548 352.69 33.9248 353.26 29.0448V29.0348ZM342.63 32.0648C340.13 32.0648 338.46 30.3148 338.46 27.8948C338.46 25.4748 340.31 23.6848 342.63 23.6848C344.95 23.6848 346.77 25.4348 346.77 27.8948C346.81 30.3148 345.06 32.0648 342.63 32.0648Z", fill: "url(#paint1_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M377.55 28.5648L373.27 18.9348H369.02L364.74 28.5648L360.39 18.9348H353.33V19.0848L362.85 36.8048H367.03L371.13 27.5648L375.26 36.8048H379.44L388.99 18.9348H381.9L377.55 28.5648Z", fill: "url(#paint2_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M401.76 18.4048C399.8 18.4048 398.05 19.4048 396.63 20.7948H396.56V18.9048H390.39V36.7748H396.56V26.7148C396.56 24.9348 398.38 23.2248 400.23 23.2248C402.23 23.2248 403.44 24.9348 403.44 26.7148V36.8048H409.61V25.0348C409.57 20.0448 405.05 18.4048 401.76 18.4048Z", fill: "url(#paint3_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M431.21 32.6648L426.75 30.4148C425.25 32.0148 424.4 32.4148 422.4 32.4148C420.83 32.4148 418.55 31.4848 418.55 28.7048H431.49C431.53 28.4948 431.53 28.1348 431.53 27.8848C431.53 21.6048 427.39 18.3948 421.94 18.3948C416.49 18.3948 412.13 22.6348 412.13 27.8848C412.13 33.1348 416.55 37.3348 421.94 37.3348C425.93 37.3348 429.21 36.0148 431.21 32.6648ZM422.12 22.3948C423.94 22.3948 425.22 23.3948 425.51 25.2848H418.73C418.84 23.6848 420.01 22.3948 422.12 22.3948Z", fill: "url(#paint4_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M440.02 21.5047H439.95V18.9347H433.78V36.8047H439.95V27.3947C439.95 26.9347 440.41 23.7547 443.62 23.7547C445.69 23.7547 446.83 24.7147 446.83 24.7147L449.4 19.4747C449.4 19.4747 447.8 18.3647 445.51 18.3647C441.98 18.4047 440.02 21.5047 440.02 21.5047Z", fill: "url(#paint5_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M346.67 48.5347C345.21 47.1047 343.21 46.2847 340.82 46.2847C335.58 46.2847 331.94 50.5247 331.94 55.7747C331.94 61.0247 335.58 65.1847 340.82 65.2247H340.86C343.28 65.2247 345.39 64.1547 346.71 62.6947H346.78V64.7247H352.88V46.8547H346.68V48.5347H346.67ZM342.64 59.9447C340.14 59.9447 338.47 58.1947 338.47 55.7747C338.47 53.3547 340.32 51.5647 342.64 51.5647C344.96 51.5647 346.78 53.3147 346.78 55.7747C346.82 58.1947 345.07 59.9447 342.64 59.9447Z", fill: "url(#paint6_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M367.46 59.3049C367.46 59.3049 366.32 60.1249 364.46 60.1249C362.14 60.1249 360.22 58.1649 360.22 55.7049C360.22 53.2449 362.15 51.3149 364.46 51.3149C366.31 51.3149 367.46 52.1349 367.46 52.1349L369.56 47.9249C369.56 47.9249 367.53 46.2449 363.57 46.2449C358.36 46.2449 353.69 50.4849 353.69 55.7649C353.69 61.0449 358.43 65.1749 363.57 65.1749C367.53 65.1749 369.56 63.5749 369.56 63.5749L367.46 59.2949V59.3049Z", fill: "url(#paint7_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M381.61 59.1248C381.61 59.1248 380.86 59.6948 380.08 59.6948C379.12 59.6948 378.69 58.9148 378.69 57.2348V51.5648H382.43V46.8548H378.69V40.1848H372.52V46.8548H369.95V51.5648H372.52V58.4148C372.52 61.5848 373.7 65.2248 378.58 65.2248H378.65C381.18 65.2248 383.14 64.1148 383.14 64.1148L381.61 59.1248Z", fill: "url(#paint8_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M387.35 38.0547C385.32 38.0547 383.68 39.6947 383.68 41.7247C383.68 43.7547 385.32 45.3947 387.35 45.3947C389.38 45.3947 391.02 43.7547 391.02 41.7247C390.98 39.6547 389.34 38.0547 387.35 38.0547Z", fill: "url(#paint9_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M390.35 46.8247H384.18V64.6947H390.35V46.8247Z", fill: "url(#paint10_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M402.29 46.2947C396.26 46.2947 391.52 50.1847 391.52 55.7847C391.52 61.3847 395.83 65.1947 402.25 65.2347H402.29C408.42 65.2347 412.92 61.3147 412.92 55.8247V55.7847C412.96 50.1847 408.21 46.2947 402.29 46.2947ZM402.25 59.9547C399.75 59.9547 398.08 58.2047 398.08 55.7847C398.08 53.3647 399.93 51.5747 402.25 51.5747C404.57 51.5747 406.39 53.3247 406.39 55.7847C406.43 58.2047 404.68 59.9547 402.25 59.9547Z", fill: "url(#paint11_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M424.97 46.2947H424.9C422.97 46.2947 421.19 47.2947 419.8 48.6847H419.73V46.7947H413.56V64.6647H419.73V54.5747C419.73 52.7947 421.55 51.0847 423.4 51.0847C425.4 51.0847 426.61 52.7947 426.61 54.5747V64.6647H432.78V52.8647C432.74 47.9447 428.22 46.3347 424.97 46.3047V46.2947Z", fill: "url(#paint12_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M443.59 53.3847C442.06 52.8847 440.81 52.6347 440.81 51.6747C440.81 50.8547 441.38 50.6047 442.74 50.6047C444.63 50.6047 446.7 51.7147 446.7 51.7147L448.73 47.6847C448.73 47.6847 446.2 46.2947 442.77 46.2947H442.7C438.03 46.2947 434.93 48.3947 434.93 52.0347C434.93 54.7047 436.75 55.9547 438.57 56.9247C440.6 57.9547 442.53 58.0647 442.53 59.3447C442.53 60.5247 441.5 60.6247 440.6 60.6247C438.6 60.6247 436.18 58.5547 436.18 58.5547L433.68 62.7647C433.68 62.7647 436.25 65.1547 440.56 65.1547C444.23 65.1547 449.01 64.3347 449.01 59.0547C449.01 55.4547 445.94 54.1347 443.59 53.3847Z", fill: "url(#paint13_linear_8174_21244)" }), /* @__PURE__ */ React.createElement("path", { d: "M248.92 0.984863H247.92V82.3449H248.92V0.984863Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.3402 31.3849C19.5702 28.4449 16.7102 26.7649 12.5102 26.7649C4.65023 26.8149 -0.00976562 33.0649 -0.00976562 41.7349C-0.00976562 50.4049 4.64023 56.6549 12.5102 56.6549C13.9502 56.7349 15.4002 56.4849 16.7402 55.9249C18.0802 55.3649 19.2802 54.5049 20.2502 53.4149V57.5849C20.2502 60.4249 18.7502 63.7949 13.9902 63.7949C10.3802 63.7949 8.60023 61.7749 7.98023 59.6049L1.59023 62.6949C3.19023 66.7949 7.01023 70.2349 14.4302 70.2349C25.4302 70.2349 28.2602 62.8149 28.2602 56.3149V27.1849H21.5302L21.3502 31.3849H21.3402ZM14.2302 49.8549C10.3002 49.8549 7.98023 46.6549 7.98023 41.6749C7.98023 36.6949 10.3002 33.4949 14.2302 33.4949C18.1602 33.4949 20.4302 36.6949 20.4302 41.6749C20.4302 46.6549 18.1602 49.8549 14.2302 49.8549Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.16 26.7148C176.62 26.7148 175.1 27.0548 173.72 27.7348C172.33 28.4148 171.11 29.3948 170.15 30.6248L169.63 27.1848H162.52V56.2048H170.82V39.8248C170.82 35.2948 172.5 33.5248 175.83 33.5248C178.15 33.5248 180.07 34.5548 180.07 38.9748V56.2148H188.37V37.2848C188.37 31.1548 184.57 26.7348 178.15 26.7348L178.16 26.7148Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6103 43.5548C49.6103 47.5348 47.9303 49.8648 44.6103 49.8648C42.2903 49.8648 40.3503 48.8348 40.3503 44.4148V27.1848H32.0503V46.0748C32.0503 52.1948 35.8503 56.6448 42.2703 56.6448C43.8103 56.6448 45.3303 56.2948 46.7203 55.6148C48.1103 54.9348 49.3303 53.9448 50.2903 52.7248L50.8103 56.1748H57.9003V27.1848H49.6003V43.5548H49.6103Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.57 27.1848H62.27V56.2048H70.57V27.1848Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6001 29.3148C91.5901 27.5848 89.0101 26.7048 86.3801 26.8648C78.4801 26.8648 73.8101 33.1248 73.8101 41.7848C73.8101 50.4448 78.4801 56.7048 86.3801 56.7048C88.0601 56.8148 89.7401 56.4748 91.2501 55.7148C92.7601 54.9548 94.0501 53.8048 94.9901 52.3748L95.1901 56.1948H101.92V13.7148H93.6201L93.5801 29.3148H93.6001ZM88.2001 49.8548C84.2701 49.8548 81.9501 46.6548 81.9501 41.6748C81.9501 36.6948 84.2701 33.4948 88.2001 33.4948C92.1301 33.4948 94.4501 36.6948 94.4501 41.6748C94.4501 46.6548 92.1301 49.8548 88.2001 49.8548Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4302 13.0149C65.5102 13.0149 64.6202 13.2949 63.8602 13.8049C63.1002 14.3249 62.5102 15.0549 62.1502 15.9249C61.8002 16.7849 61.7102 17.7349 61.8902 18.6449C62.0702 19.5549 62.5102 20.3949 63.1602 21.0549C63.8102 21.7149 64.6302 22.1649 65.5302 22.3449C66.4302 22.5249 67.3602 22.4349 68.2002 22.0749C69.0502 21.7149 69.7702 21.1149 70.2802 20.3349C70.7902 19.5549 71.0602 18.6449 71.0602 17.7149C71.0602 16.4649 70.5702 15.2649 69.7002 14.3849C68.8302 13.5049 67.6502 13.0049 66.4302 13.0049V13.0149Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 27.1848H149.84V56.2048H158.14V27.1848Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M153.99 13.0149C153.07 13.0149 152.18 13.2949 151.42 13.8049C150.66 14.3249 150.07 15.0549 149.71 15.9249C149.36 16.7849 149.27 17.7349 149.45 18.6449C149.63 19.5549 150.07 20.3949 150.72 21.0549C151.37 21.7149 152.19 22.1649 153.09 22.3449C153.99 22.5249 154.92 22.4349 155.76 22.0749C156.61 21.7149 157.33 21.1149 157.84 20.3349C158.35 19.5549 158.62 18.6449 158.62 17.7149C158.62 16.4649 158.13 15.2649 157.26 14.3849C156.39 13.5049 155.21 13.0049 153.99 13.0049V13.0149Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.6149V41.7349C218.63 32.7749 213.58 26.8149 205.25 26.8149C196.92 26.8149 191.31 32.7749 191.31 41.7349C191.31 50.6949 196.93 56.6549 205.25 56.6549C211.01 56.6549 215.3 53.8649 217.34 49.1549L211.33 46.2549C210.94 47.5149 210.15 48.5949 209.09 49.3549C208.03 50.1149 206.76 50.4949 205.46 50.4449C203.93 50.4849 202.43 49.9349 201.29 48.8949C200.15 47.8549 199.43 46.4049 199.3 44.8549H199.36L218.64 42.6249L218.63 42.6149ZM199.09 39.6849C199.09 35.4749 201.56 32.7149 205.22 32.7149C206.73 32.6849 208.19 33.2549 209.31 34.2849C210.43 35.3249 211.11 36.7549 211.23 38.2849L199.09 39.6849Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.79 26.8149C110.46 26.8149 104.84 32.7749 104.84 41.7349C104.84 50.6949 110.46 56.6549 118.79 56.6549C124.54 56.6549 128.83 53.8649 130.81 49.1549L124.8 46.2549C124.41 47.4949 123.64 48.5649 122.6 49.3249C121.56 50.0749 120.31 50.4749 119.04 50.4449C117.49 50.5149 115.98 49.9649 114.82 48.9249C113.66 47.8849 112.93 46.4249 112.8 44.8549L132.04 42.6049V41.7249C132.16 32.7849 127.11 26.8249 118.79 26.8249V26.8149ZM112.6 39.6949C112.6 35.4849 115.01 32.7249 118.74 32.7249C120.25 32.6949 121.71 33.2649 122.83 34.2949C123.95 35.3349 124.63 36.7649 124.75 38.2949L112.59 39.6949H112.6Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.4548V13.7148H134.99V48.3148C134.99 52.3348 135.78 56.5248 142.81 56.5248C144.14 56.5948 145.47 56.3748 146.71 55.8648V49.3848C146.71 49.3848 143.29 50.2648 143.29 47.4548Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.825H33.0302V76.555H0.240234V82.395H38.7602V69.6549H218.65V63.825Z", fill: "#5532FA" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_8174_21244", x1: 321.745, y1: 57.2156, x2: 285.107, y2: 20.5775, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint1_linear_8174_21244", x1: 346.983, y1: -3.10235, x2: 346.983, y2: 63.8109, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint2_linear_8174_21244", x1: 374.809, y1: -3.10229, x2: 374.809, y2: 63.8109, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint3_linear_8174_21244", x1: 403.766, y1: -3.10231, x2: 403.766, y2: 63.8109, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint4_linear_8174_21244", x1: 425.984, y1: 401166, x2: 425.984, y2: 63.8191, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint5_linear_8174_21244", x1: 446.048, y1: -3.10235, x2: 446.048, y2: 63.8108, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#141414" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.35, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#424242" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.65, stopColor: "#343434" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#141414" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint6_linear_8174_21244", x1: 340.28, y1: 46.7592, x2: 340.28, y2: 68.8884, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint7_linear_8174_21244", x1: 359.817, y1: 46.7594, x2: 359.817, y2: 68.8886, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint8_linear_8174_21244", x1: 374.62, y1: 46.7593, x2: 374.62, y2: 68.8885, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint9_linear_8174_21244", x1: 385.259, y1: 46.7592, x2: 385.259, y2: 68.8884, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint10_linear_8174_21244", x1: 385.259, y1: 46.7592, x2: 385.259, y2: 68.8884, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint11_linear_8174_21244", x1: 400.518, y1: 46.7592, x2: 400.518, y2: 68.8884, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint12_linear_8174_21244", x1: 421.156, y1: 46.7592, x2: 421.156, y2: 68.8884, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint13_linear_8174_21244", x1: 439.547, y1: 46.7592, x2: 439.547, y2: 68.8884, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#82BCEA" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.5, stopColor: "#2BA8DA" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#3C4C9C" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8174_21244" }, /* @__PURE__ */ React.createElement("rect", { width: 449.4, height: 81.41, fill: "white", transform: "translate(0 0.984863)" }))));
const SvgPrimePay = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 534, height: 82, viewBox: "0 0 534 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0H247.93V81.36H248.93V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.4C19.58 27.46 16.72 25.78 12.52 25.78C4.66 25.83 0 32.08 0 40.75C0 49.42 4.65 55.67 12.52 55.67C13.96 55.75 15.41 55.5001 16.75 54.9401C18.09 54.3801 19.29 53.5201 20.26 52.4301V56.6001C20.26 59.4401 18.76 62.8101 14 62.8101C10.39 62.8101 8.61 60.79 7.99 58.62L1.6 61.7101C3.2 65.8101 7.02 69.25 14.44 69.25C25.44 69.25 28.27 61.8301 28.27 55.3301V26.1901H21.54L21.36 30.39L21.35 30.4ZM14.24 48.87C10.31 48.87 7.99 45.6701 7.99 40.6901C7.99 35.7101 10.31 32.51 14.24 32.51C18.17 32.51 20.44 35.7101 20.44 40.6901C20.44 45.6701 18.17 48.87 14.24 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.73C176.63 25.73 175.11 26.07 173.73 26.75C172.34 27.43 171.12 28.41 170.16 29.64L169.64 26.2001H162.53V55.2101H170.83V38.8301C170.83 34.3001 172.51 32.53 175.84 32.53C178.16 32.53 180.08 33.56 180.08 37.98V55.2201H188.38V36.29C188.38 30.16 184.58 25.74 178.16 25.74L178.17 25.73Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.5701C49.6201 46.5501 47.9401 48.87 44.6201 48.87C42.3001 48.87 40.3601 47.84 40.3601 43.42V26.2001H32.0601V45.0901C32.0601 51.2101 35.8601 55.66 42.2801 55.66C43.8201 55.66 45.3401 55.31 46.7301 54.63C48.1201 53.95 49.3401 52.96 50.3001 51.74L50.8201 55.1901H57.9101V26.2001H49.6101V42.5701H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.2001H62.2798V55.2101H70.5798V26.2001Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.3301C91.6001 26.6001 89.0201 25.73 86.4001 25.88C78.5001 25.88 73.8301 32.14 73.8301 40.8C73.8301 49.46 78.5001 55.7201 86.4001 55.7201C88.0801 55.8301 89.7601 55.49 91.2701 54.73C92.7801 53.97 94.0701 52.82 95.0101 51.39L95.2101 55.2101H101.94V12.73H93.6401L93.6001 28.3301H93.6101ZM88.2101 48.87C84.2801 48.87 81.9601 45.6701 81.9601 40.6901C81.9601 35.7101 84.2801 32.51 88.2101 32.51C92.1401 32.51 94.4601 35.7101 94.4601 40.6901C94.4601 45.6701 92.1401 48.87 88.2101 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.04C65.5099 12.04 64.6199 12.3201 63.8599 12.8301C63.0999 13.3501 62.5099 14.0801 62.1599 14.9501C61.8099 15.8101 61.7199 16.76 61.8999 17.67C62.0799 18.58 62.5199 19.4201 63.1699 20.0801C63.8199 20.7401 64.6399 21.19 65.5399 21.37C66.4399 21.55 67.3699 21.4601 68.2099 21.1001C69.0599 20.7401 69.7799 20.14 70.2899 19.36C70.7999 18.58 71.0699 17.67 71.0699 16.74C71.0699 15.49 70.5799 14.29 69.7099 13.41C68.8399 12.53 67.6599 12.03 66.4399 12.03L66.4299 12.04Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.2001H149.84V55.2101H158.14V26.2001Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.04C153.08 12.04 152.19 12.3201 151.43 12.8301C150.67 13.3501 150.08 14.0801 149.72 14.9501C149.37 15.8101 149.28 16.76 149.46 17.67C149.64 18.58 150.08 19.4201 150.73 20.0801C151.38 20.7401 152.2 21.19 153.1 21.37C154 21.55 154.93 21.4601 155.77 21.1001C156.62 20.7401 157.34 20.14 157.85 19.36C158.36 18.58 158.63 17.67 158.63 16.74C158.63 15.49 158.14 14.29 157.27 13.41C156.4 12.53 155.22 12.03 154 12.03V12.04Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.64V40.76C218.63 31.8 213.58 25.8401 205.25 25.8401C196.92 25.8401 191.31 31.8 191.31 40.76C191.31 49.72 196.93 55.6801 205.25 55.6801C211.01 55.6801 215.3 52.8901 217.33 48.1801L211.32 45.28C210.93 46.54 210.14 47.62 209.08 48.38C208.02 49.14 206.75 49.5201 205.45 49.4701C203.92 49.5101 202.42 48.96 201.28 47.92C200.14 46.88 199.42 45.43 199.29 43.88H199.35L218.63 41.65V41.64ZM199.09 38.7101C199.09 34.5001 201.55 31.74 205.22 31.74C206.73 31.71 208.19 32.2801 209.31 33.3101C210.43 34.3501 211.11 35.7801 211.23 37.3101L199.09 38.7101Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.8301C110.47 25.8301 104.85 31.79 104.85 40.75C104.85 49.71 110.47 55.67 118.8 55.67C124.55 55.67 128.84 52.88 130.82 48.17L124.81 45.27C124.42 46.51 123.65 47.5801 122.61 48.3401C121.57 49.0901 120.32 49.4901 119.05 49.4601C117.5 49.5301 115.99 48.9801 114.83 47.9401C113.67 46.9001 112.94 45.44 112.81 43.87L132.05 41.62V40.74C132.17 31.8 127.12 25.8401 118.8 25.8401V25.8301ZM112.61 38.7101C112.61 34.5001 115.02 31.74 118.75 31.74C120.26 31.71 121.72 32.2801 122.84 33.3101C123.96 34.3501 124.64 35.7801 124.76 37.3101L112.6 38.7101H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.4701V12.73H134.99V47.3301C134.99 51.3501 135.78 55.54 142.81 55.54C144.14 55.61 145.47 55.39 146.71 54.88V48.4C146.71 48.4 143.29 49.2801 143.29 46.4701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.8401H33.04V75.5701H0.25V81.41H38.77V68.67H218.65V62.8401Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M530.73 58.91C530.73 58.91 530.92 59.01 531.02 59.01C531.12 59.01 531.21 59.0101 531.31 58.9601C531.45 58.8601 531.55 58.67 531.55 58.39C531.55 57.96 531.31 57.7201 530.93 57.7201C530.83 57.7201 530.79 57.72 530.74 57.77V58.92L530.73 58.91ZM530.73 59.2001V59.49C530.73 60.11 530.78 60.1601 530.78 60.2101C530.83 60.2601 530.88 60.26 531.02 60.26C531.02 60.26 531.037 60.2767 531.07 60.3101C531.07 60.3101 531.02 60.36 530.97 60.36H529.82C529.82 60.36 529.77 60.3601 529.77 60.3101C529.77 60.2601 529.82 60.26 529.87 60.26C530.11 60.26 530.16 60.2601 530.16 60.0701V57.77C530.16 57.63 530.06 57.5801 529.82 57.5801C529.82 57.5801 529.803 57.5634 529.77 57.53C529.77 57.53 529.82 57.48 529.87 57.48H530.92C531.45 57.48 531.64 57.58 531.73 57.62C531.87 57.72 531.97 57.86 531.97 58.15C531.97 58.39 531.87 58.63 531.44 59.01C531.82 59.44 532.06 59.78 532.3 60.02C532.44 60.16 532.54 60.26 532.59 60.26C532.64 60.26 532.64 60.3101 532.64 60.3101C532.64 60.3101 532.607 60.3267 532.54 60.36H532.4C532.26 60.36 532.06 60.36 531.92 60.26C531.78 60.16 531.63 59.9701 531.39 59.6901C531.25 59.5001 531.1 59.26 531.01 59.12H530.72V59.2201L530.73 59.2001ZM531.07 61.26C532.36 61.26 533.27 60.2501 533.27 58.9601C533.27 57.6701 532.31 56.66 531.07 56.66C529.83 56.66 528.87 57.6701 528.87 58.9601C528.87 60.2501 529.88 61.26 531.07 61.26ZM528.44 58.9601C528.44 57.5201 529.59 56.3301 531.07 56.3301C532.55 56.3301 533.7 57.4301 533.7 58.9601C533.7 60.4001 532.55 61.55 531.07 61.55C529.59 61.55 528.44 60.4501 528.44 58.9601Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M515.22 54.99C515.22 55.56 515.22 57.1 515.08 58.63C514.98 59.68 514.7 60.4 513.93 60.55C513.59 60.65 513.12 60.6901 512.59 60.6901C512.16 60.6901 509.72 60.8801 509.72 61.0701C509.72 61.3601 512.31 61.4501 512.78 61.4501C514.17 61.4501 516.71 61.3101 517.66 61.3101C518.67 61.3101 521.2 61.4501 523.55 61.4501C524.08 61.4501 524.36 61.3101 524.36 61.0701C524.36 60.8801 524.12 60.6901 523.74 60.6901C523.21 60.6901 522.4 60.64 521.87 60.55C520.77 60.36 520.43 59.69 520.34 58.63C520.24 57.1 520.24 55.61 520.24 54.99V52.0701C520.24 50.8701 520.14 49.7701 520.72 48.4301C521.39 46.9001 526.8 38.28 528 36.79C528.81 35.83 529.15 35.4501 529.96 35.0701C530.53 34.8301 531.21 34.64 531.59 34.64C532.02 34.64 532.31 34.4501 532.31 34.2101C532.31 34.0201 532.07 33.92 531.64 33.92C530.92 33.92 528.43 34.02 527.62 34.02C526.52 34.02 525.18 33.92 523.93 33.92C523.5 33.92 523.31 34.02 523.31 34.26C523.31 34.55 523.65 34.6001 523.98 34.6901C524.6 34.8301 524.79 35.17 524.79 35.5C524.79 35.98 524.6 36.6 524.22 37.42C523.65 38.52 519.1 46.33 518.62 47.14C518 46.13 513.06 37.61 512.39 36.51C512.1 35.98 511.91 35.55 511.91 35.26C511.91 34.97 512.15 34.7801 512.44 34.6901C513.01 34.5001 513.3 34.5001 513.3 34.2101C513.3 33.9701 513.11 33.87 512.73 33.87C511.01 33.87 509.28 33.9701 508.47 33.9701C507.22 33.9701 504.4 33.87 503.78 33.87C503.3 33.87 503.06 33.9701 503.06 34.2101C503.06 34.4501 503.3 34.5901 503.63 34.5901C504.11 34.5901 504.73 34.7801 505.21 35.0701C505.93 35.4501 506.69 36.32 507.65 37.66C508.99 39.58 514.12 47.57 514.35 48.15C514.88 49.2 515.21 49.9701 515.21 51.9301V54.99H515.22Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M511.05 60.5901C510.62 60.5901 510.19 60.5401 509.66 60.4501C508.99 60.3101 507.89 59.8801 506.45 56.5701C504.06 51.0601 497.78 36.2201 496.87 34.2101C496.49 33.4001 496.3 33.0601 495.77 33.0601C495.39 33.0601 495.1 33.49 494.67 34.5L484.85 57.3401C484.08 59.1601 483.46 60.26 481.74 60.55C481.4 60.55 480.97 60.6001 480.64 60.6001C480.35 60.6001 480.21 60.79 480.21 60.98C480.21 61.27 480.4 61.36 480.88 61.36C482.84 61.36 484.85 61.2201 485.24 61.2201C486.44 61.2201 488.21 61.36 489.41 61.36C489.79 61.36 489.98 61.26 489.98 60.98C489.98 60.74 489.88 60.6001 489.41 60.6001H488.88C487.73 60.6001 487.4 60.2201 487.4 59.5901C487.4 59.1601 487.59 58.25 487.97 57.39L489.98 52.51C490.08 52.32 490.12 52.27 490.32 52.27H499.13C499.32 52.27 499.42 52.32 499.51 52.51L502.43 59.79C502.62 60.22 502.33 60.5601 502.09 60.6001C501.71 60.6501 501.61 60.79 501.61 60.98C501.61 61.22 502.04 61.22 502.71 61.27C505.87 61.37 508.6 61.37 509.94 61.37C511.28 61.37 513.82 61.27 513.82 60.99C513.82 60.75 511.38 60.61 511.04 60.61L511.05 60.5901ZM498.26 50.25H491.03C490.89 50.25 490.84 50.15 490.89 50.01L494.53 40.8201C494.58 40.6801 494.63 40.48 494.72 40.48C494.81 40.48 494.86 40.7201 494.91 40.8201L498.45 50.0601C498.5 50.2001 498.45 50.25 498.26 50.25Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M465.84 48.24C465.84 52.41 465.84 56.0501 465.6 57.9601C465.41 59.3001 465.17 60.2601 464.26 60.4501C463.83 60.5501 463.3 60.64 462.63 60.64C462.1 60.64 461.91 60.78 461.91 61.02C461.91 61.36 462.25 61.4501 462.82 61.4501C464.64 61.4501 467.51 61.3101 468.57 61.3101C469.77 61.3101 472.64 61.4501 475.61 61.4501C476.09 61.4501 476.47 61.31 476.47 61.02C476.47 60.78 476.23 60.64 475.75 60.64C475.08 60.64 474.07 60.5401 473.45 60.4501C472.06 60.2601 471.82 59.25 471.68 58.01C471.44 56.05 471.44 52.45 471.44 48.24V29.99C471.44 29.46 471.58 29.22 471.82 29.13C472.25 28.99 472.92 28.9401 473.59 28.9401C474.64 28.9401 476.51 29.2301 478.14 30.7101C480.68 33.0101 480.82 36.0301 480.82 37.5601C480.82 42.2101 477.28 45.0801 474.74 45.0801C473.78 45.0801 473.45 45.2201 473.45 45.5601C473.45 45.9001 473.79 45.94 473.98 45.99C474.22 46.04 474.7 46.04 474.94 46.04C481.41 46.04 486.15 41.49 486.15 35.03C486.15 32.64 484.86 30.58 483.85 29.62C483.13 28.95 481.07 27.03 475.37 27.03C473.26 27.03 470.63 27.17 468.76 27.17C467.47 27.17 464.59 27.03 462.2 27.03C461.53 27.03 461.19 27.1301 461.19 27.4601C461.19 27.7901 461.48 27.89 461.96 27.89C462.58 27.89 463.4 27.94 463.73 28.03C465.21 28.37 465.6 29.08 465.69 30.62C465.79 32.06 465.79 33.35 465.79 40.29V48.24H465.84Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M443.33 50.87C443.33 54.22 443.33 57.0501 443.14 58.5801C443 59.6301 442.8 60.35 442.04 60.5C441.7 60.6 441.27 60.64 440.7 60.64C440.22 60.64 440.08 60.83 440.08 61.02C440.08 61.26 440.32 61.4 440.8 61.4C441.57 61.4 442.52 61.35 443.39 61.3C444.3 61.3 445.11 61.25 445.55 61.25C446.65 61.25 448.09 61.3001 449.91 61.3501C451.73 61.4501 454.03 61.49 456.81 61.49C458.2 61.49 458.58 61.49 458.82 60.53C459.01 59.81 459.35 57.32 459.35 56.51C459.35 56.13 459.3 55.65 459.01 55.65C458.77 55.65 458.67 55.8401 458.58 56.2201C458.34 57.7001 457.91 58.47 456.95 58.9C455.99 59.33 454.36 59.38 453.41 59.38C449.58 59.38 448.43 58.81 448.33 56.36C448.28 55.31 448.33 52.24 448.33 51V48.0801C448.33 47.8401 448.38 47.7001 448.52 47.7001C449.48 47.7001 453.74 47.8 454.41 47.89C455.8 48.03 456.28 48.56 456.52 49.28C456.62 49.76 456.62 50.24 456.66 50.62C456.66 50.81 456.76 50.91 457 50.91C457.34 50.91 457.38 50.3801 457.38 50.1001C457.38 49.8601 457.48 48.38 457.57 47.66C457.76 45.84 457.86 45.22 457.86 45.03C457.86 44.84 457.72 44.65 457.57 44.65C457.38 44.65 457.28 44.84 456.95 45.13C456.61 45.51 456.04 45.6101 455.18 45.7001C454.32 45.8001 449.48 45.8 448.62 45.8C448.43 45.8 448.38 45.61 448.38 45.42V36.42C448.38 36.23 448.48 36.0801 448.62 36.0801C449.39 36.0801 453.89 36.18 454.51 36.27C456.38 36.46 456.71 36.94 457 37.61C457.24 38.04 457.24 38.6601 457.24 38.9501C457.24 39.2401 457.29 39.4301 457.53 39.4301C457.82 39.4301 457.91 39 457.96 38.86C458.06 38.43 458.15 36.8501 458.15 36.4701C458.25 34.7901 458.44 34.36 458.44 34.12C458.44 33.93 458.39 33.78 458.2 33.78C458.01 33.78 457.82 33.9201 457.58 33.9701C457.29 34.0201 456.67 34.1601 456 34.2101C455.28 34.2601 446.95 34.2101 445.75 34.2101C444.7 34.2101 442.3 34.11 440.34 34.11C439.77 34.11 439.48 34.2101 439.48 34.4501C439.48 34.6901 439.72 34.8301 440.1 34.8301C440.67 34.8301 441.3 34.8801 441.58 34.9701C442.78 35.3101 443.11 35.6901 443.21 36.9301C443.26 38.0801 443.26 39.0901 443.26 44.5901V50.86H443.36L443.33 50.87Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M405.45 57.77C405.26 58.97 404.92 60.4 403.92 60.55C403.35 60.65 403.06 60.65 402.77 60.65C402.39 60.65 399.9 60.84 399.9 60.99C399.9 61.33 402.49 61.42 402.87 61.42C404.07 61.42 405.84 61.28 406.61 61.28C407.28 61.28 409 61.42 410.58 61.42C411.15 61.42 411.49 61.32 411.49 60.99C411.49 60.8 411.25 60.65 410.92 60.65C410.59 60.65 410.25 60.6001 409.58 60.4601C408.91 60.3201 408.43 60.08 408.43 59.41C408.43 58.84 408.48 58.3601 408.57 57.6901L410.34 43.51H410.48C411.73 46.05 413.93 50.6 414.26 51.27C414.69 52.28 417.66 57.83 418.57 59.51C419.14 60.61 419.58 61.3301 420.05 61.3301C420.48 61.3301 420.67 60.99 421.53 59.27L429.62 43.04H429.76L431.87 58.75C432.01 59.76 431.92 60.19 431.68 60.28C431.44 60.37 431.25 60.47 431.25 60.66C431.25 60.85 431.44 61.0401 432.35 61.0901C433.83 61.1901 439.2 61.3301 440.11 61.3301C440.68 61.3301 441.12 61.19 441.12 60.9C441.12 60.66 440.88 60.5601 440.55 60.5601C440.07 60.5601 439.5 60.5101 438.39 60.2201C437.24 59.8801 436.91 58.88 436.57 56.63L433.03 34.3101C432.89 33.5401 432.46 33.16 432.17 33.16C431.83 33.16 431.5 33.4501 431.16 34.0701L421.1 54.5701L411.04 34.3101C410.51 33.3001 410.27 33.16 409.89 33.16C409.6 33.16 409.27 33.5 409.17 34.12L405.43 57.78L405.45 57.77Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M392.71 50.87C392.71 54.37 392.71 57.29 392.52 58.77C392.38 59.82 392.18 60.35 391.42 60.54C391.08 60.64 390.65 60.6801 390.08 60.6801C389.6 60.6801 389.51 60.8701 389.51 61.0601C389.51 61.3001 389.75 61.4401 390.23 61.4401C391.71 61.4401 394.3 61.3 395.16 61.3C396.17 61.3 398.75 61.4401 401.24 61.4401C401.67 61.4401 404.26 61.3001 404.26 61.0601C404.26 60.8701 401.82 60.6801 401.39 60.6801C400.82 60.6801 400 60.63 399.47 60.54C398.37 60.35 398.08 59.8201 397.99 58.8201C397.85 57.2901 397.85 54.37 397.85 50.87V44.4501C397.85 38.9401 397.85 37.94 397.95 36.79C398.05 35.5 398.33 34.9701 399.34 34.8301C399.77 34.7301 400.06 34.6901 400.44 34.6901C400.82 34.6901 401.01 34.59 401.01 34.26C401.01 34.07 400.72 33.9701 400.24 33.9701C398.8 33.9701 396.36 34.0701 395.4 34.0701C394.35 34.0701 391.76 33.9701 390.37 33.9701C389.75 33.9701 389.46 34.07 389.46 34.26C389.46 34.6 389.65 34.6901 390.03 34.6901C390.51 34.6901 390.99 34.74 391.42 34.88C392.23 35.12 392.62 35.55 392.71 36.8C392.76 37.95 392.76 38.9601 392.76 44.4601V50.88H392.71V50.87Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M390.65 60.64C390.36 60.64 390.12 60.64 389.74 60.54C389.17 60.4 387.82 60.25 385.72 58.15C383.47 55.9 380.79 52.59 377.48 48.52C381.17 45.55 382.7 43.1601 382.7 40.4701C382.7 38.0301 381.12 36.21 380.07 35.49C378.06 34.15 375.33 33.9601 372.93 33.9601C371.78 33.9601 368.38 34.0601 367.09 34.0601C366.32 34.0601 363.93 33.9601 361.97 33.9601C361.4 33.9601 361.11 34.06 361.11 34.3C361.11 34.54 361.35 34.6801 361.73 34.6801C362.3 34.6801 362.93 34.7301 363.21 34.8201C364.41 35.1601 364.74 35.54 364.84 36.78C364.89 37.93 364.89 38.9401 364.89 44.4401V50.86H364.94C364.94 54.21 364.94 57.0401 364.75 58.5701C364.61 59.6201 364.41 60.34 363.65 60.49C363.31 60.59 362.88 60.63 362.31 60.63C361.83 60.63 361.74 60.82 361.74 61.01C361.74 61.25 361.98 61.39 362.46 61.39C363.94 61.39 366.34 61.25 367.06 61.25C367.63 61.25 370.75 61.39 372.9 61.39C373.38 61.39 373.67 61.25 373.67 61.01C373.67 60.82 373.48 60.63 373.19 60.63C372.71 60.63 371.9 60.58 371.37 60.49C370.22 60.3 370.03 59.6301 369.93 58.5701C369.74 57.0401 369.74 54.21 369.74 50.86V50.3301C369.74 50.0901 369.88 50.04 370.03 50.04L373.38 50.14C373.62 50.14 373.86 50.19 374.05 50.38C374.53 50.95 376.11 53.3501 377.59 55.3101C379.7 58.1401 381.09 59.86 382.71 60.67C383.67 61.2 384.72 61.39 386.83 61.39H390.42C390.9 61.39 391.14 61.29 391.14 61.01C391.14 60.82 390.95 60.63 390.66 60.63L390.65 60.64ZM375.47 47.61C374.85 48.09 374.32 48.23 372.84 48.23C371.88 48.23 370.78 48.13 369.97 47.89C369.73 47.75 369.63 47.65 369.63 47.27V36.4501H369.68C369.68 36.1601 369.78 36.02 370.02 35.92C370.4 35.82 371.31 35.78 372.22 35.78C374.42 35.78 377.92 37.12 377.92 42.25C377.92 45.22 376.63 46.8 375.48 47.61H375.47Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M338.5 48.24C338.5 52.41 338.5 56.0501 338.26 57.9601C338.07 59.3001 337.83 60.2601 336.92 60.4501C336.49 60.5501 335.96 60.64 335.29 60.64C334.76 60.64 334.57 60.78 334.57 61.02C334.57 61.36 334.91 61.4501 335.48 61.4501C337.3 61.4501 340.17 61.3101 341.23 61.3101C342.43 61.3101 345.3 61.4501 348.32 61.4501C348.8 61.4501 349.18 61.31 349.18 61.02C349.18 60.78 348.94 60.64 348.46 60.64C347.79 60.64 346.78 60.5401 346.16 60.4501C344.77 60.2601 344.53 59.25 344.39 58.01C344.15 56.05 344.15 52.45 344.15 48.24V29.99C344.15 29.46 344.29 29.22 344.53 29.13C344.96 28.99 345.63 28.9401 346.3 28.9401C347.35 28.9401 349.22 29.2301 350.85 30.7101C353.39 33.0101 353.53 36.0301 353.53 37.5601C353.53 42.2101 349.99 45.0801 347.45 45.0801C346.49 45.0801 346.16 45.2201 346.16 45.5601C346.16 45.9001 346.5 45.94 346.69 45.99C346.93 46.04 347.41 46.04 347.65 46.04C354.12 46.04 358.86 41.49 358.86 35.03C358.86 32.64 357.57 30.58 356.56 29.62C355.84 28.95 353.78 27.03 348.08 27.03C345.97 27.03 343.34 27.17 341.47 27.17C340.18 27.17 337.3 27.03 334.91 27.03C334.24 27.03 333.9 27.1301 333.9 27.4601C333.9 27.7901 334.19 27.89 334.67 27.89C335.29 27.89 336.06 27.94 336.44 28.03C337.92 28.37 338.31 29.08 338.4 30.62C338.5 32.06 338.5 33.35 338.5 40.29V48.24Z", fill: "#221F1F" }), /* @__PURE__ */ React.createElement("path", { d: "M312.74 19.79V53.4601L320.69 61.41V27.4L312.74 19.79Z", fill: "#FEE656" }), /* @__PURE__ */ React.createElement("path", { d: "M278.21 19.79V53.8401L286.21 61.41V27.79L278.21 19.79Z", fill: "#F2B826" }), /* @__PURE__ */ React.createElement("path", { d: "M305.07 34.6801H293.82V46.0801H305.07V34.6801Z", fill: "#F2B826" }), /* @__PURE__ */ React.createElement("path", { d: "M305.08 27.79V19.79H278.21L286.21 27.79H305.08Z", fill: "#FEE656" }), /* @__PURE__ */ React.createElement("path", { d: "M312.74 53.4601H293.82V61.41H320.69L312.74 53.4601Z", fill: "#F2B826" }));
const SvgProliant = (props2) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 520 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.429932H247.93V81.7899H248.93V0.429932Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.83C19.58 27.89 16.72 26.21 12.52 26.21C4.66 26.26 0 32.5099 0 41.1799C0 49.8499 4.65 56.0999 12.52 56.0999C13.96 56.1799 15.41 55.9299 16.75 55.3699C18.09 54.8099 19.29 53.9499 20.26 52.8599V57.03C20.26 59.87 18.76 63.2399 14 63.2399C10.39 63.2399 8.61 61.2199 7.99 59.0499L1.6 62.14C3.2 66.24 7.02 69.6799 14.44 69.6799C25.44 69.6799 28.27 62.2599 28.27 55.7599V26.6199H21.54L21.36 30.8199L21.35 30.83ZM14.24 49.2999C10.31 49.2999 7.99 46.0999 7.99 41.1199C7.99 36.1399 10.31 32.9399 14.24 32.9399C18.17 32.9399 20.44 36.1399 20.44 41.1199C20.44 46.0999 18.17 49.2999 14.24 49.2999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.1599C176.63 26.1599 175.11 26.4999 173.73 27.1799C172.34 27.8599 171.12 28.8399 170.16 30.0699L169.64 26.6299H162.53V55.64H170.83V39.2599C170.83 34.7299 172.51 32.96 175.84 32.96C178.16 32.96 180.08 33.9899 180.08 38.4099V55.65H188.38V36.7199C188.38 30.5899 184.58 26.1699 178.16 26.1699L178.17 26.1599Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.9999C49.6201 46.9799 47.9401 49.2999 44.6201 49.2999C42.3001 49.2999 40.3601 48.2699 40.3601 43.8499V26.6299H32.0601V45.5199C32.0601 51.6399 35.8601 56.0899 42.2801 56.0899C43.8201 56.0899 45.3401 55.7399 46.7301 55.0599C48.1201 54.3799 49.3401 53.3899 50.3001 52.1699L50.8201 55.6199H57.9101V26.6299H49.6101V42.9999H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.6299H62.2798V55.6399H70.5798V26.6299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.7599C91.6001 27.0299 89.0201 26.1599 86.4001 26.3099C78.5001 26.3099 73.8301 32.5699 73.8301 41.2299C73.8301 49.8899 78.5001 56.15 86.4001 56.15C88.0801 56.26 89.7601 55.9199 91.2701 55.1599C92.7801 54.3999 94.0701 53.2499 95.0101 51.8199L95.2101 55.64H101.94V13.1599H93.6401L93.6001 28.7599H93.6101ZM88.2101 49.2999C84.2801 49.2999 81.9601 46.0999 81.9601 41.1199C81.9601 36.1399 84.2801 32.9399 88.2101 32.9399C92.1401 32.9399 94.4601 36.1399 94.4601 41.1199C94.4601 46.0999 92.1401 49.2999 88.2101 49.2999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.4699C65.5099 12.4699 64.6199 12.7499 63.8599 13.2599C63.0999 13.7799 62.5099 14.5099 62.1599 15.3799C61.8099 16.2399 61.7199 17.1899 61.8999 18.0999C62.0799 19.0099 62.5199 19.8499 63.1699 20.5099C63.8199 21.1699 64.6399 21.6199 65.5399 21.7999C66.4399 21.9799 67.3699 21.89 68.2099 21.53C69.0599 21.17 69.7799 20.5699 70.2899 19.7899C70.7999 19.0099 71.0699 18.0999 71.0699 17.1699C71.0699 15.9199 70.5799 14.72 69.7099 13.84C68.8399 12.96 67.6599 12.46 66.4399 12.46L66.4299 12.4699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.6299H149.84V55.6399H158.14V26.6299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.4699C153.08 12.4699 152.19 12.7499 151.43 13.2599C150.67 13.7799 150.08 14.5099 149.72 15.3799C149.37 16.2399 149.28 17.1899 149.46 18.0999C149.64 19.0099 150.08 19.8499 150.73 20.5099C151.38 21.1699 152.2 21.6199 153.1 21.7999C154 21.9799 154.93 21.89 155.77 21.53C156.62 21.17 157.34 20.5699 157.85 19.7899C158.36 19.0099 158.63 18.0999 158.63 17.1699C158.63 15.9199 158.14 14.72 157.27 13.84C156.4 12.96 155.22 12.46 154 12.46V12.4699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.07V41.19C218.63 32.23 213.58 26.27 205.25 26.27C196.92 26.27 191.31 32.23 191.31 41.19C191.31 50.15 196.93 56.11 205.25 56.11C211.01 56.11 215.3 53.32 217.33 48.61L211.32 45.71C210.93 46.97 210.14 48.05 209.08 48.81C208.02 49.57 206.75 49.95 205.45 49.9C203.92 49.94 202.42 49.39 201.28 48.35C200.14 47.31 199.42 45.86 199.29 44.31H199.35L218.63 42.08V42.07ZM199.09 39.14C199.09 34.93 201.55 32.17 205.22 32.17C206.73 32.14 208.19 32.71 209.31 33.74C210.43 34.78 211.11 36.21 211.23 37.74L199.09 39.14Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.26C110.47 26.26 104.85 32.22 104.85 41.18C104.85 50.14 110.47 56.1 118.8 56.1C124.55 56.1 128.84 53.31 130.82 48.6L124.81 45.7C124.42 46.94 123.65 48.01 122.61 48.77C121.57 49.52 120.32 49.92 119.05 49.89C117.5 49.96 115.99 49.41 114.83 48.37C113.67 47.33 112.94 45.87 112.81 44.3L132.05 42.05V41.17C132.17 32.23 127.12 26.27 118.8 26.27V26.26ZM112.61 39.14C112.61 34.93 115.02 32.17 118.75 32.17C120.26 32.14 121.72 32.71 122.84 33.74C123.96 34.78 124.64 36.21 124.76 37.74L112.6 39.14H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.9V13.1599H134.99V47.7599C134.99 51.7799 135.78 55.9699 142.81 55.9699C144.14 56.0399 145.47 55.8199 146.71 55.3099V48.83C146.71 48.83 143.29 49.71 143.29 46.9Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.27H33.04V76H0.25V81.84H38.77V69.1H218.65V63.27Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("text", { style: {
  fontSize: 36,
  fontFamily: "Roboto",
  whiteSpace: "pre"
}, x: 284.615, y: 66.169 }, "18.3"), /* @__PURE__ */ React.createElement("text", { style: {
  fontSize: 36,
  fontFamily: "Roboto",
  whiteSpace: "pre"
}, x: 306.477, y: 66.398 }, "18.3"), /* @__PURE__ */ React.createElement("g", { transform: "matrix(0.013375001028180122, 0, 0, -0.013375001028180122, 277.77764892578125, 65.79328918457034)", fill: "#000000", stroke: "none" }, /* @__PURE__ */ React.createElement("path", { d: "M468 3934 c-3 -5 -9 -43 -12 -84 -4 -41 -9 -91 -12 -111 -5 -34 -4 -36 35 -48 57 -17 153 -108 182 -173 21 -47 24 -67 23 -173 -1 -107 -26 -269 -242 -1553 -199 -1182 -239 -1438 -230 -1463 20 -59 21 -59 531 -59 l465 0 7 77 c4 48 3 79 -3 81 -39 13 -104 67 -127 106 -47 80 -45 115 34 596 45 275 79 451 91 477 14 30 31 48 59 63 38 19 58 20 424 20 637 0 952 44 1149 161 199 117 377 323 470 543 60 139 80 244 85 436 4 148 2 190 -15 270 -67 323 -255 571 -539 711 -135 66 -260 97 -443 109 -196 14 -1925 26 -1932 14z m1851 -664 c80 -17 121 -41 183 -109 75 -81 99 -144 106 -280 8 -170 -32 -290 -134 -401 -64 -69 -131 -105 -224 -120 -90 -14 -544 -33 -713 -28 l-139 3 -29 33 c-16 18 -29 42 -29 55 0 12 29 195 64 407 l64 385 42 39 42 38 356 -5 c209 -3 380 -10 411 -17z" }), /* @__PURE__ */ React.createElement("path", { d: "M7976 3888 c-3 -29 -8 -82 -11 -118 l-6 -65 48 -19 c67 -28 145 -108 171 -177 45 -121 54 -50 -212 -1646 -135 -810 -246 -1487 -246 -1504 0 -20 10 -40 29 -60 l29 -29 437 0 c340 0 436 3 439 13 3 6 7 42 10 78 l6 66 -40 18 c-52 23 -92 69 -116 131 l-19 49 268 1605 c148 883 268 1613 268 1623 -2 32 -32 66 -70 77 -22 6 -220 10 -507 10 l-472 0 -6 -52z" }), /* @__PURE__ */ React.createElement("path", { d: "M9615 3925 c-44 -15 -82 -53 -90 -88 -12 -57 -95 -557 -95 -576 0 -13 13 -36 29 -52 l29 -29 293 0 c273 0 294 1 324 20 17 11 39 34 48 52 9 18 37 160 63 314 51 304 51 321 1 354 -33 22 -544 26 -602 5z" }), /* @__PURE__ */ React.createElement("path", { d: "M16380 3764 c-107 -8 -211 -18 -230 -24 -20 -5 -50 -25 -68 -43 -30 -31 -36 -50 -93 -303 -33 -148 -67 -279 -75 -292 -8 -13 -29 -32 -47 -42 -30 -19 -52 -20 -313 -20 -316 0 -294 6 -294 -77 0 -42 5 -50 66 -116 80 -84 143 -209 170 -334 l17 -83 104 0 c102 0 105 -1 134 -29 16 -16 29 -40 29 -52 0 -13 -40 -259 -90 -548 -114 -673 -134 -810 -134 -951 -1 -142 24 -228 96 -337 63 -94 133 -155 233 -203 117 -56 188 -71 361 -77 146 -5 413 16 470 37 27 11 36 46 79 297 37 221 42 282 25 299 -7 7 -39 6 -103 -3 -180 -28 -355 1 -411 68 -53 62 -52 66 79 852 61 360 100 568 110 583 9 14 30 34 48 44 29 18 52 20 227 20 221 0 264 11 295 69 8 17 31 124 50 238 30 183 32 210 20 238 -7 18 -19 36 -26 41 -8 5 -109 11 -225 14 -194 5 -214 7 -234 25 -43 38 -42 52 5 335 25 148 45 284 45 302 -1 37 -14 59 -47 76 -25 14 -13 14 -273 -4z" }), /* @__PURE__ */ React.createElement("path", { d: "M4974 3099 c-153 -19 -400 -165 -609 -361 -62 -57 -88 -70 -98 -45 -2 6 4 64 14 127 22 130 19 161 -18 190 -24 19 -40 20 -277 20 -231 0 -254 -2 -283 -20 -18 -10 -39 -30 -48 -43 -10 -16 -91 -474 -230 -1308 -118 -706 -215 -1294 -215 -1307 0 -13 13 -37 29 -53 l29 -29 272 0 c302 0 322 4 359 64 13 22 43 175 105 548 109 651 180 946 262 1085 94 161 276 296 462 344 56 14 110 19 209 19 l133 0 11 28 c15 37 79 580 79 665 0 45 -4 69 -12 71 -31 10 -118 12 -174 5z" }), /* @__PURE__ */ React.createElement("path", { d: "M11465 3098 c-275 -23 -590 -182 -918 -466 -102 -87 -230 -228 -224 -246 2 -5 14 -18 28 -28 33 -24 524 -178 569 -178 33 0 42 7 88 64 117 143 288 255 437 286 105 22 250 -1 355 -55 18 -9 55 -37 81 -62 63 -58 89 -126 89 -227 0 -70 -2 -76 -30 -100 -40 -33 -53 -34 -330 -40 -718 -13 -1174 -192 -1410 -552 -95 -145 -135 -307 -128 -509 5 -111 10 -144 37 -225 109 -324 387 -531 748 -556 283 -19 548 78 760 278 40 37 76 68 80 68 26 0 33 -29 33 -130 0 -76 4 -112 14 -126 14 -18 29 -19 339 -19 239 0 328 3 339 12 12 10 13 26 5 95 -17 145 11 365 132 1033 67 372 107 629 116 755 12 156 -28 343 -102 470 -79 135 -235 271 -397 345 -189 88 -475 133 -711 113z m370 -1523 c14 -13 25 -31 25 -40 0 -26 -68 -201 -121 -314 -60 -127 -120 -212 -193 -275 -129 -110 -243 -156 -385 -156 -120 0 -177 19 -244 80 -82 75 -109 161 -87 280 15 85 49 148 110 208 111 109 256 153 765 230 94 15 104 14 130 -13z" }), /* @__PURE__ */ React.createElement("path", { d: "M14400 3099 c-216 -19 -392 -107 -546 -275 -48 -52 -90 -94 -95 -94 -15 0 -16 29 -3 100 20 115 18 137 -15 171 l-29 29 -259 0 c-234 0 -261 -2 -286 -19 -15 -10 -35 -28 -43 -40 -16 -22 -444 -2541 -444 -2609 0 -24 9 -42 29 -63 l29 -29 274 0 c253 0 275 2 305 20 18 10 40 31 49 45 11 18 47 205 110 578 51 304 105 604 119 667 37 160 137 457 189 565 108 222 291 357 481 357 99 0 153 -20 200 -74 49 -58 65 -114 65 -229 0 -124 -12 -206 -165 -1101 -74 -433 -123 -748 -119 -763 3 -14 18 -34 31 -45 24 -19 42 -20 297 -20 246 0 275 2 306 19 19 10 43 31 52 47 11 19 63 303 152 839 168 1011 161 960 160 1145 -1 138 -3 164 -27 243 -48 157 -119 267 -234 362 -159 132 -363 193 -583 174z" }), /* @__PURE__ */ React.createElement("path", { d: "M6275 3089 c-440 -68 -781 -334 -1005 -784 -78 -156 -120 -280 -150 -434 -115 -592 37 -1151 383 -1414 345 -263 899 -322 1292 -138 176 83 331 211 461 383 190 253 310 531 360 834 25 149 24 440 0 579 -62 346 -221 619 -461 791 -89 63 -236 130 -350 160 -87 23 -124 27 -285 30 -102 1 -212 -1 -245 -7z m286 -603 c87 -19 136 -44 191 -100 53 -54 91 -128 120 -234 18 -66 22 -105 22 -272 1 -209 -7 -273 -54 -455 -111 -422 -279 -605 -557 -606 -227 -1 -388 124 -449 346 -22 81 -29 288 -15 416 25 218 101 483 184 643 113 217 317 313 558 262z" }), /* @__PURE__ */ React.createElement("path", { d: "M9409 2992 c-21 -21 -40 -49 -43 -63 -16 -70 -426 -2544 -426 -2570 0 -20 10 -40 29 -60 l29 -29 290 0 c284 0 290 0 323 23 19 12 41 38 50 57 10 20 108 583 230 1315 192 1151 212 1283 201 1311 -8 17 -25 36 -38 43 -17 7 -121 11 -316 11 l-290 0 -39 -38z" }), /* @__PURE__ */ React.createElement("path", { d: "M17353 856 c-82 -27 -165 -107 -192 -185 -16 -48 -14 -161 4 -211 22 -61 74 -121 136 -155 49 -27 63 -30 144 -30 82 0 95 3 145 31 61 34 121 105 139 164 19 66 14 169 -13 225 -29 61 -84 117 -144 146 -55 27 -160 34 -219 15z m163 -51 c58 -17 127 -80 155 -140 38 -81 16 -199 -49 -269 -15 -16 -49 -39 -77 -52 -160 -76 -344 45 -345 227 0 104 73 203 173 235 56 17 84 17 143 -1z" }), /* @__PURE__ */ React.createElement("path", { d: "M17310 565 l0 -165 45 0 45 0 0 60 c0 59 0 60 28 60 44 0 63 -21 69 -73 l6 -47 41 0 42 0 -6 56 c-5 44 -12 62 -32 79 l-25 21 29 17 c23 13 28 23 28 56 0 85 -27 101 -170 101 l-100 0 0 -165z m178 93 c32 -27 -3 -78 -55 -78 -32 0 -33 1 -33 43 0 24 3 47 7 51 9 8 63 -3 81 -16z" })));
const SvgRubyMoney = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 631, height: 83, viewBox: "0 0 631 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.859863H247.93V82.2198H248.93V0.859863Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.2599C19.58 28.3199 16.72 26.6399 12.52 26.6399C4.66 26.6899 0 32.9399 0 41.6099C0 50.2799 4.65 56.5299 12.52 56.5299C13.96 56.6099 15.41 56.3599 16.75 55.7999C18.09 55.2399 19.29 54.3799 20.26 53.2899V57.4598C20.26 60.2998 18.76 63.6699 14 63.6699C10.39 63.6699 8.61 61.6499 7.99 59.4799L1.6 62.5698C3.2 66.6698 7.02 70.1099 14.44 70.1099C25.44 70.1099 28.27 62.6898 28.27 56.1898V27.0499H21.54L21.36 31.2499L21.35 31.2599ZM14.24 49.7299C10.31 49.7299 7.99 46.5299 7.99 41.5499C7.99 36.5699 10.31 33.3699 14.24 33.3699C18.17 33.3699 20.44 36.5699 20.44 41.5499C20.44 46.5299 18.17 49.7299 14.24 49.7299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.5999C176.63 26.5999 175.11 26.9399 173.73 27.6199C172.34 28.2999 171.12 29.2799 170.16 30.5099L169.64 27.0698H162.53V56.0798H170.83V39.6998C170.83 35.1698 172.51 33.3999 175.84 33.3999C178.16 33.3999 180.08 34.4299 180.08 38.8499V56.0898H188.38V37.1599C188.38 31.0299 184.58 26.6099 178.16 26.6099L178.17 26.5999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.4299C49.6201 47.4099 47.9401 49.7299 44.6201 49.7299C42.3001 49.7299 40.3601 48.6999 40.3601 44.2799V27.0599H32.0601V45.9498C32.0601 52.0698 35.8601 56.5199 42.2801 56.5199C43.8201 56.5199 45.3401 56.1699 46.7301 55.4899C48.1201 54.8099 49.3401 53.8199 50.3001 52.5999L50.8201 56.0499H57.9101V27.0599H49.6101V43.4299H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 27.0599H62.2798V56.0698H70.5798V27.0599Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.1898C91.6001 27.4598 89.0201 26.5899 86.4001 26.7399C78.5001 26.7399 73.8301 32.9999 73.8301 41.6599C73.8301 50.3199 78.5001 56.5798 86.4001 56.5798C88.0801 56.6898 89.7601 56.3498 91.2701 55.5898C92.7801 54.8298 94.0701 53.6799 95.0101 52.2499L95.2101 56.0698H101.94V13.5898H93.6401L93.6001 29.1898H93.6101ZM88.2101 49.7299C84.2801 49.7299 81.9601 46.5299 81.9601 41.5499C81.9601 36.5699 84.2801 33.3699 88.2101 33.3699C92.1401 33.3699 94.4601 36.5699 94.4601 41.5499C94.4601 46.5299 92.1401 49.7299 88.2101 49.7299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.8999C65.5099 12.8999 64.6199 13.1798 63.8599 13.6898C63.0999 14.2098 62.5099 14.9399 62.1599 15.8099C61.8099 16.6699 61.7199 17.6199 61.8999 18.5299C62.0799 19.4399 62.5199 20.2798 63.1699 20.9398C63.8199 21.5998 64.6399 22.0499 65.5399 22.2299C66.4399 22.4099 67.3699 22.3198 68.2099 21.9598C69.0599 21.5998 69.7799 20.9998 70.2899 20.2198C70.7999 19.4398 71.0699 18.5299 71.0699 17.5999C71.0699 16.3499 70.5799 15.1499 69.7099 14.2699C68.8399 13.3899 67.6599 12.8899 66.4399 12.8899L66.4299 12.8999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 27.0599H149.84V56.0698H158.14V27.0599Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.8999C153.08 12.8999 152.19 13.1798 151.43 13.6898C150.67 14.2098 150.08 14.9399 149.72 15.8099C149.37 16.6699 149.28 17.6199 149.46 18.5299C149.64 19.4399 150.08 20.2798 150.73 20.9398C151.38 21.5998 152.2 22.0499 153.1 22.2299C154 22.4099 154.93 22.3198 155.77 21.9598C156.62 21.5998 157.34 20.9998 157.85 20.2198C158.36 19.4398 158.63 18.5299 158.63 17.5999C158.63 16.3499 158.14 15.1499 157.27 14.2699C156.4 13.3899 155.22 12.8899 154 12.8899V12.8999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.4999V41.6199C218.63 32.6599 213.58 26.6998 205.25 26.6998C196.92 26.6998 191.31 32.6599 191.31 41.6199C191.31 50.5799 196.93 56.5399 205.25 56.5399C211.01 56.5399 215.3 53.7499 217.33 49.0399L211.32 46.1399C210.93 47.3999 210.14 48.4799 209.08 49.2399C208.02 49.9999 206.75 50.3798 205.45 50.3298C203.92 50.3698 202.42 49.8199 201.28 48.7799C200.14 47.7399 199.42 46.2899 199.29 44.7399H199.35L218.63 42.5099V42.4999ZM199.09 39.5698C199.09 35.3598 201.55 32.5999 205.22 32.5999C206.73 32.5699 208.19 33.1399 209.31 34.1699C210.43 35.2099 211.11 36.6399 211.23 38.1699L199.09 39.5698Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.6898C110.47 26.6898 104.85 32.6499 104.85 41.6099C104.85 50.5699 110.47 56.5299 118.8 56.5299C124.55 56.5299 128.84 53.7399 130.82 49.0299L124.81 46.1299C124.42 47.3699 123.65 48.4398 122.61 49.1998C121.57 49.9498 120.32 50.3498 119.05 50.3198C117.5 50.3898 115.99 49.8399 114.83 48.7999C113.67 47.7599 112.94 46.2999 112.81 44.7299L132.05 42.4799V41.5999C132.17 32.6599 127.12 26.6998 118.8 26.6998V26.6898ZM112.61 39.5698C112.61 35.3598 115.02 32.5999 118.75 32.5999C120.26 32.5699 121.72 33.1399 122.84 34.1699C123.96 35.2099 124.64 36.6399 124.76 38.1699L112.6 39.5698H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.3298V13.5898H134.99V48.1898C134.99 52.2098 135.78 56.3999 142.81 56.3999C144.14 56.4699 145.47 56.2499 146.71 55.7399V49.2599C146.71 49.2599 143.29 50.1398 143.29 47.3298Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.6998H33.04V76.4299H0.25V82.2699H38.77V69.5299H218.65V63.6998Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M387.35 47.0299C386.9 45.8099 386.28 44.8999 385.5 44.2999C384.99 43.8999 384.42 43.6399 383.81 43.5099C385.02 43.1199 386.05 42.5399 386.92 41.7699C388.66 40.1899 389.52 38.1199 389.52 35.5299C389.52 32.8099 388.68 30.7199 386.99 29.2499C385.31 27.7599 382.82 27.0099 379.53 27.0099H367.02V56.0299H373.1V44.3298H377.08C377.9 44.3298 378.62 44.4799 379.25 44.7799C379.88 45.0499 380.34 45.5799 380.63 46.3699L384.22 56.0299H390.73L387.34 47.0199L387.35 47.0299ZM378.63 39.4899H373.07V31.9099H378.63C380.42 31.9099 381.71 32.2199 382.5 32.8499C383.32 33.4499 383.72 34.3998 383.72 35.6998C383.72 36.9998 383.31 37.9299 382.5 38.5499C381.68 39.1799 380.4 39.4899 378.63 39.4899Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M411.69 27.0199V44.3398C411.69 46.6498 411.18 48.4199 410.15 49.6399C409.12 50.8599 407.65 51.4698 405.73 51.4698C403.81 51.4698 402.22 50.8599 401.19 49.6399C400.16 48.4199 399.65 46.6498 399.65 44.3398V27.0199H393.65V44.0599C393.65 48.1099 394.66 51.1799 396.69 53.2699C398.74 55.3599 401.75 56.4099 405.72 56.4099C409.69 56.4099 412.6 55.3599 414.68 53.2699C416.76 51.1499 417.8 48.0799 417.8 44.0599V27.0199H411.68H411.69Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M443.69 43.4099C442.81 42.2799 441.56 41.4899 439.98 41.0299C441.3 40.5499 442.36 39.7999 443.14 38.7599C444.01 37.5599 444.44 36.1599 444.44 34.5599C444.44 32.2199 443.59 30.3899 441.88 29.0599C440.17 27.6999 437.87 27.0199 434.98 27.0199H422.04V56.0399H435.38C438.43 56.0399 440.82 55.3299 442.56 53.9199C444.32 52.4799 445.2 50.5398 445.2 48.0898C445.2 46.2198 444.7 44.6499 443.7 43.3999L443.69 43.4099ZM428.07 31.9199H433.95C435.53 31.9199 436.7 32.2099 437.46 32.7799C438.22 33.3199 438.6 34.1899 438.6 35.3899C438.6 36.5899 438.22 37.4299 437.46 37.9999C436.72 38.5699 435.55 38.8599 433.95 38.8599H428.07V31.9299V31.9199ZM438.25 50.2999C437.51 50.8699 436.32 51.1599 434.66 51.1599H428.07V43.7399H434.66C436.32 43.7399 437.51 44.0499 438.25 44.6799C439.01 45.2799 439.39 46.2199 439.39 47.4899C439.39 48.7599 439.01 49.7299 438.25 50.2999Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M474.49 27.0199H467.47L459.74 39.4199L452.08 27.0199H445.1L456.66 44.6799V56.0399H462.85V44.7999L474.49 27.0199Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M509.76 27.0199L500.74 48.3799L491.69 27.0199H486.79V56.0399H492.2V40.3999L498.71 56.0399H502.69L509.13 40.2599L509.16 56.0399H514.61V27.0199H509.76Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M544.38 33.6199C543.28 31.3899 541.7 29.6799 539.65 28.4799C537.62 27.2599 535.2 26.6499 532.39 26.6499C529.58 26.6499 527.14 27.2599 525.09 28.4799C523.04 29.6799 521.45 31.3899 520.32 33.6199C519.22 35.8499 518.66 38.4699 518.66 41.4899C518.66 44.5099 519.21 47.1699 520.32 49.3999C521.45 51.6299 523.04 53.3498 525.09 54.5798C527.14 55.7998 529.58 56.4099 532.39 56.4099C535.2 56.4099 537.62 55.7998 539.65 54.5798C541.7 53.3598 543.28 51.6299 544.38 49.3999C545.48 47.1699 546.04 44.5399 546.04 41.4899C546.04 38.4399 545.49 35.8499 544.38 33.6199ZM537.87 48.9398C536.53 50.6198 534.7 51.4698 532.38 51.4698C530.06 51.4698 528.2 50.6298 526.86 48.9398C525.52 47.2598 524.85 44.7699 524.85 41.4799C524.85 38.1899 525.52 35.7599 526.86 34.0999C528.2 32.4199 530.04 31.5698 532.38 31.5698C534.72 31.5698 536.52 32.4099 537.87 34.0999C539.24 35.7599 539.92 38.2199 539.92 41.4799C539.92 44.7399 539.24 47.2298 537.87 48.9398Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M568.6 27.0199V45.4899L554.6 27.0199H550.06V56.0399H555.82V37.5599L569.83 56.0399H574.4V27.0199H568.6Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M598.62 31.9498V27.0199H579.25V56.0399H598.62V51.1099H585.28V43.7699H597.79V38.7999H585.28V31.9498H598.62Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M630.96 27.0199H623.94L616.21 39.4199L608.55 27.0199H601.57L613.12 44.6799V56.0399H619.32V44.7999L630.96 27.0199Z", fill: "#31526C" }), /* @__PURE__ */ React.createElement("path", { d: "M326.7 17.5599C325.38 15.2699 323.02 13.9099 320.39 13.9099H290.52C287.89 13.9099 285.53 15.2699 284.21 17.5599C282.87 19.8699 282.87 22.6298 284.19 24.9398L299.13 50.9899C300.45 53.2899 302.82 54.6699 305.46 54.6699C308.1 54.6699 310.47 53.2899 311.79 50.9899L326.73 24.9398C328.06 22.6298 328.05 19.8699 326.71 17.5599H326.7ZM323.55 23.1099L308.61 49.1599C307.95 50.3099 306.77 50.9999 305.45 50.9999C304.13 50.9999 302.95 50.3099 302.29 49.1599L287.35 23.1099C286.68 21.9499 286.69 20.5599 287.35 19.3999C288.01 18.2599 289.19 17.5698 290.5 17.5698H320.37C321.68 17.5698 322.86 18.2499 323.52 19.3999C324.19 20.5599 324.19 21.9399 323.52 23.0999L323.55 23.1099Z", fill: "#7EC4CF" }), /* @__PURE__ */ React.createElement("path", { d: "M331.68 23.3499C330.36 21.0599 328 19.6998 325.37 19.6998H285.54C282.91 19.6998 280.55 21.0599 279.23 23.3499C277.89 25.6599 277.89 28.4199 279.21 30.7299L299.13 65.4698C300.45 67.7698 302.82 69.1499 305.46 69.1499C308.1 69.1499 310.47 67.7698 311.79 65.4698L331.71 30.7299C333.04 28.4199 333.03 25.6599 331.69 23.3499H331.68ZM328.53 28.8999L308.61 63.6399C307.95 64.7899 306.77 65.4799 305.45 65.4799C304.13 65.4799 302.95 64.7899 302.29 63.6399L282.37 28.8999C281.7 27.7399 281.71 26.3498 282.37 25.1898C283.03 24.0498 284.21 23.3599 285.52 23.3599H325.35C326.66 23.3599 327.84 24.0398 328.5 25.1898C329.17 26.3498 329.17 27.7299 328.5 28.8999H328.53Z", fill: "#FF3E3E" }));
const SvgSvb = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 399, height: 82, viewBox: "0 0 399 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.219971H247.93V81.58H248.93V0.219971Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M293.59 37.7299C289.79 37.0999 286.55 36.5699 286.55 33.9699C286.55 31.8299 288.51 30.5599 291.78 30.5599C295.23 30.5599 297.18 32.2899 297.18 35.3599H304.46C304.46 29.3499 299.71 25.8199 291.75 25.8199C283.79 25.8199 278.96 29.1199 278.96 34.5999C278.96 41.2499 285.14 42.2299 290.3 43.0399C294.22 43.6699 297.72 44.2499 297.72 47.3199C297.72 49.7499 295.52 51.1099 291.72 51.1099C287.92 51.1099 285.49 49.2099 285.49 45.9599H278.21C278.21 52.2899 283.21 55.9899 291.75 55.9899C300.29 55.9899 305.29 52.41 305.29 46.45C305.29 39.63 298.88 38.5899 293.62 37.7199", fill: "#003149" }), /* @__PURE__ */ React.createElement("path", { d: "M320.58 52.65H320.49L313.68 26.41H305.28L313.96 55.42H327.11L335.79 26.41H327.38L320.57 52.65H320.58Z", fill: "#003149" }), /* @__PURE__ */ React.createElement("path", { d: "M353.15 50.03C349.61 50.03 347.15 48.02 346.13 44.74C345.77 43.53 345.59 42.28 345.61 41.02C345.61 39.79 345.78 38.57 346.13 37.39C347.07 34.33 349.32 31.94 353.15 31.94C358.86 31.94 360.69 36.43 360.69 41.02C360.69 46.35 358.18 50.03 353.15 50.03ZM355.64 25.9C353.62 25.83 351.62 26.38 349.93 27.46C348.24 28.54 346.93 30.11 346.19 31.94H346.1V10.91H338.26V55.42H343.25L346.15 50.33H346.24C347.1 52.06 348.44 53.51 350.12 54.53C351.79 55.55 353.72 56.08 355.7 56.08C363.65 56.19 368.76 49.88 368.76 41C368.76 32.12 364.02 25.91 355.7 25.91", fill: "#003149" }), /* @__PURE__ */ React.createElement("path", { d: "M378.48 16.9L372.3 20.63L384.01 40.9L372.3 61.17L378.48 64.9L398.39 40.89L378.48 16.88V16.9Z", fill: "#00C0FF" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.61C19.58 27.67 16.72 25.99 12.52 25.99C4.66 26.04 0 32.29 0 40.96C0 49.63 4.65 55.88 12.52 55.88C13.96 55.96 15.41 55.71 16.75 55.15C18.09 54.59 19.29 53.73 20.26 52.64V56.81C20.26 59.65 18.76 63.02 14 63.02C10.39 63.02 8.61 61 7.99 58.83L1.6 61.92C3.2 66.02 7.02 69.46 14.44 69.46C25.44 69.46 28.27 62.04 28.27 55.54V26.4H21.54L21.36 30.6L21.35 30.61ZM14.24 49.08C10.31 49.08 7.99 45.88 7.99 40.9C7.99 35.92 10.31 32.72 14.24 32.72C18.17 32.72 20.44 35.92 20.44 40.9C20.44 45.88 18.17 49.08 14.24 49.08Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.95C176.63 25.95 175.11 26.29 173.73 26.97C172.34 27.65 171.12 28.63 170.16 29.86L169.64 26.42H162.53V55.43H170.83V39.05C170.83 34.52 172.51 32.75 175.84 32.75C178.16 32.75 180.08 33.78 180.08 38.2V55.44H188.38V36.51C188.38 30.38 184.58 25.96 178.16 25.96L178.17 25.95Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.78C49.6201 46.76 47.9401 49.08 44.6201 49.08C42.3001 49.08 40.3601 48.05 40.3601 43.63V26.41H32.0601V45.3C32.0601 51.42 35.8601 55.87 42.2801 55.87C43.8201 55.87 45.3401 55.52 46.7301 54.84C48.1201 54.16 49.3401 53.17 50.3001 51.95L50.8201 55.4H57.9101V26.41H49.6101V42.78H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.41H62.2798V55.42H70.5798V26.41Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.54C91.6001 26.81 89.0201 25.94 86.4001 26.09C78.5001 26.09 73.8301 32.35 73.8301 41.01C73.8301 49.67 78.5001 55.93 86.4001 55.93C88.0801 56.04 89.7601 55.7 91.2701 54.94C92.7801 54.18 94.0701 53.03 95.0101 51.6L95.2101 55.42H101.94V12.94H93.6401L93.6001 28.54H93.6101ZM88.2101 49.08C84.2801 49.08 81.9601 45.88 81.9601 40.9C81.9601 35.92 84.2801 32.72 88.2101 32.72C92.1401 32.72 94.4601 35.92 94.4601 40.9C94.4601 45.88 92.1401 49.08 88.2101 49.08Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.25C65.5099 12.25 64.6199 12.53 63.8599 13.04C63.0999 13.56 62.5099 14.29 62.1599 15.16C61.8099 16.02 61.7199 16.97 61.8999 17.88C62.0799 18.79 62.5199 19.63 63.1699 20.29C63.8199 20.95 64.6399 21.4 65.5399 21.58C66.4399 21.76 67.3699 21.67 68.2099 21.31C69.0599 20.95 69.7799 20.35 70.2899 19.57C70.7999 18.79 71.0699 17.88 71.0699 16.95C71.0699 15.7 70.5799 14.5 69.7099 13.62C68.8399 12.74 67.6599 12.24 66.4399 12.24L66.4299 12.25Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.41H149.84V55.42H158.14V26.41Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.25C153.08 12.25 152.19 12.53 151.43 13.04C150.67 13.56 150.08 14.29 149.72 15.16C149.37 16.02 149.28 16.97 149.46 17.88C149.64 18.79 150.08 19.63 150.73 20.29C151.38 20.95 152.2 21.4 153.1 21.58C154 21.76 154.93 21.67 155.77 21.31C156.62 20.95 157.34 20.35 157.85 19.57C158.36 18.79 158.63 17.88 158.63 16.95C158.63 15.7 158.14 14.5 157.27 13.62C156.4 12.74 155.22 12.24 154 12.24V12.25Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.85V40.97C218.63 32.01 213.58 26.05 205.25 26.05C196.92 26.05 191.31 32.01 191.31 40.97C191.31 49.93 196.93 55.89 205.25 55.89C211.01 55.89 215.3 53.1 217.33 48.39L211.32 45.49C210.93 46.75 210.14 47.83 209.08 48.59C208.02 49.35 206.75 49.73 205.45 49.68C203.92 49.72 202.42 49.17 201.28 48.13C200.14 47.09 199.42 45.64 199.29 44.09H199.35L218.63 41.86V41.85ZM199.09 38.92C199.09 34.71 201.55 31.95 205.22 31.95C206.73 31.92 208.19 32.49 209.31 33.52C210.43 34.56 211.11 35.99 211.23 37.52L199.09 38.92Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.05C110.47 26.05 104.85 32.01 104.85 40.97C104.85 49.93 110.47 55.89 118.8 55.89C124.55 55.89 128.84 53.1 130.82 48.39L124.81 45.49C124.42 46.73 123.65 47.8 122.61 48.56C121.57 49.31 120.32 49.71 119.05 49.68C117.5 49.75 115.99 49.2 114.83 48.16C113.67 47.12 112.94 45.66 112.81 44.09L132.05 41.84V40.96C132.17 32.02 127.12 26.06 118.8 26.06V26.05ZM112.61 38.93C112.61 34.72 115.02 31.96 118.75 31.96C120.26 31.93 121.72 32.5 122.84 33.53C123.96 34.57 124.64 36 124.76 37.53L112.6 38.93H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.69V12.95H134.99V47.55C134.99 51.57 135.78 55.76 142.81 55.76C144.14 55.83 145.47 55.61 146.71 55.1V48.62C146.71 48.62 143.29 49.5 143.29 46.69Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.06H33.04V75.79H0.25V81.63H38.77V68.89H218.65V63.06Z", fill: "#5532FA" }));
const SvgStartupGrind = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 616, height: 82, viewBox: "0 0 616 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.0400391H247.93V81.4001H248.93V0.0400391Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M479.4 38.8401V38.85L479.39 38.86L479.4 38.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M474.34 43.9902C474.28 43.9702 474.22 43.9402 474.16 43.9102L474.26 43.7902C474.26 43.7902 474.34 43.8702 474.38 43.9102C474.38 43.9202 474.34 43.9902 474.34 43.9902ZM474.51 39.7602L474.46 39.6402C474.46 39.6402 474.53 39.6402 474.56 39.6402C474.58 39.6402 474.58 39.6902 474.59 39.7102L474.51 39.7602ZM478.54 50.5202C478.54 50.5202 478.48 50.4602 478.46 50.4302C478.49 50.4102 478.52 50.3802 478.55 50.3802C478.61 50.3802 478.67 50.4002 478.73 50.4102C478.67 50.4502 478.61 50.4802 478.55 50.5102L478.54 50.5202ZM478.64 38.9202C478.68 39.0002 478.7 39.1002 478.71 39.1902C478.69 39.2802 478.66 39.3702 478.61 39.4602C478.53 39.3602 478.85 38.8202 478.84 38.7202C478.84 38.6502 478.55 39.0102 478.64 38.9302V38.9202ZM477.14 38.1902L477.01 38.3802L476.91 38.2802L477.14 38.1902ZM479.41 51.0202C479.41 51.0202 479.33 50.9102 479.34 50.8802C479.36 50.8302 479.43 50.8002 479.48 50.7602L479.56 50.9202L479.4 51.0202H479.41ZM478.27 43.7802H478.18C478.18 43.7802 478.24 43.6902 478.27 43.6602C478.27 43.6602 478.32 43.6902 478.35 43.7102L478.28 43.7802H478.27ZM478.94 46.2602C478.94 46.2602 479.03 46.1702 479.08 46.1302C479.13 46.2102 479.18 46.3002 479.22 46.3902C479.24 46.4502 479.25 46.5102 479.26 46.5702C479.2 46.5702 479.14 46.5402 479.08 46.5102C479.01 46.4402 478.96 46.3602 478.94 46.2602ZM479.31 46.8302L479.34 46.9902C479.34 46.9902 479.28 46.9202 479.26 46.8902C479.26 46.8902 479.28 46.8602 479.31 46.8302ZM479.41 47.4202C479.41 47.2902 479.41 47.1602 479.41 47.0302C479.6 47.1602 479.58 47.2902 479.41 47.4202ZM480.44 45.6702C479.71 45.3702 479.71 45.3602 480.28 44.8302C480.33 45.1102 480.39 45.3902 480.44 45.6702ZM482.29 49.1902L482.47 49.3402L482.36 49.4302C482.33 49.3502 482.31 49.2702 482.28 49.1902H482.29ZM482.58 50.1302C482.58 50.1302 482.51 50.0902 482.51 50.0702C482.51 50.0102 482.53 49.9602 482.55 49.9002L482.63 49.9602C482.61 50.0202 482.6 50.0702 482.58 50.1302ZM485.7 49.1202C485.7 49.1202 485.64 49.1202 485.6 49.1202C485.6 49.0902 485.6 49.0502 485.62 49.0502C485.65 49.0502 485.68 49.0502 485.72 49.0502C485.72 49.0802 485.72 49.1202 485.7 49.1202ZM488.57 53.5402L488.52 53.4402C488.52 53.4402 488.58 53.4402 488.61 53.4402C488.63 53.4402 488.63 53.4802 488.64 53.5002L488.57 53.5502V53.5402ZM489.4 52.4802C489.4 52.4802 489.35 52.4502 489.33 52.4302C489.38 52.4002 489.43 52.3702 489.49 52.3402C489.51 52.3402 489.54 52.3702 489.56 52.3902C489.51 52.4202 489.46 52.4502 489.4 52.4802ZM489.8 49.0402C489.74 49.0002 489.68 48.9502 489.63 48.9002C489.72 48.7502 489.82 48.6102 489.92 48.4702C489.96 48.5202 490.05 48.5902 490.04 48.6102C489.97 48.7602 489.89 48.9002 489.8 49.0502V49.0402ZM489.14 47.9002C488.74 47.8202 488.23 47.8002 488.57 48.5102C488.6 48.5702 488.43 48.7302 488.35 48.8402C488.28 48.7402 488.13 48.6302 488.15 48.5602C488.29 48.0302 487.87 48.0602 487.57 47.9602C487.3 47.8202 486.97 47.9102 486.8 48.1702C486.35 48.7602 486.33 48.7402 485.65 48.3202C485.03 47.9402 484.84 47.9702 484.42 48.5302C484.23 48.7502 484.06 48.9902 483.9 49.2402C483.74 49.5402 483.77 49.9802 483.29 50.0302C483.4 49.7402 483.49 49.4302 483.62 49.1502C483.78 48.5802 484.17 48.1002 484.7 47.8402C484.77 47.8202 484.78 47.6502 484.82 47.5502C484.7 47.5302 484.56 47.4502 484.48 47.5002C484.12 47.6802 484 47.6102 484.07 47.2002C484.08 47.1302 483.99 47.0302 483.94 46.9502C483.88 47.0302 483.78 47.1102 483.75 47.2002C483.73 47.3802 483.7 47.5602 483.66 47.7302C483.61 47.8402 483.45 47.9002 483.33 47.9802C483.33 47.8602 483.28 47.7102 483.33 47.6102C483.58 47.1202 483.38 46.8502 482.94 46.6502C482.49 46.4402 482.24 46.5302 482.11 46.9902C482.06 47.1602 482.11 47.3602 482.06 47.5302C481.96 47.8402 481.67 47.8502 481.37 47.5802C481.32 47.5302 481.24 47.4702 481.19 47.4802C480.57 47.5502 480.82 47.3302 481.11 47.2002C481.54 47.0002 481.54 46.9502 481.06 46.8902C480.7 46.8402 480.75 46.6702 481 46.4802C481.07 46.4302 481.07 46.3002 481.1 46.2102C481 46.1902 480.87 46.1302 480.79 46.1602C480.03 46.5002 480.45 45.9502 480.44 45.7202C481.3 45.4502 480.78 44.6402 481.03 44.1402C480.94 44.0702 480.84 44.0002 480.73 43.9402C480.49 43.8002 480.24 43.6602 480 43.5202H480.02C479.71 43.4502 479.45 43.9902 479.06 43.5302C478.59 42.9702 478.98 43.4402 479.51 42.5702L479.21 42.5202L479.47 42.3602C479.42 42.3002 479.38 42.2402 479.34 42.1802C478.85 41.2602 478.4 41.2702 479.33 40.7102C479.48 40.6102 479.62 40.5102 479.75 40.4002C479.5 39.7902 479.79 39.7002 478.96 39.7302C478.99 39.5002 478.57 39.7302 478.6 39.5002L479.38 38.8902L474.83 34.4502C474.6 35.0602 474.5 35.7102 474.51 36.3602C474.51 36.4602 474.35 36.5902 474.25 36.6902C473.72 37.2202 473.72 37.2702 474.22 37.8102C474.33 37.9102 474.41 38.0502 474.45 38.1902C474.48 38.5102 474.49 38.8302 474.47 39.1502C474.46 39.5102 474.17 38.2302 473.98 38.4602C473.35 39.2302 473.28 40.3402 472.41 40.9602C472.07 41.2002 472.22 41.4902 472.54 41.6402C472.71 41.6902 472.88 41.7202 473.06 41.7202C473.04 41.8502 473 41.9902 472.96 42.1102C472.89 42.2802 472.79 42.4502 472.71 42.6102C472.93 42.6402 473.16 42.6502 473.39 42.6402C473.53 42.6202 473.64 42.4702 473.76 42.3702C473.79 42.5402 473.8 42.7102 473.76 42.8802C473.62 43.2502 473.43 43.5902 473.26 43.9402C473.18 44.1002 473.09 44.2402 473 44.4002C473.18 44.4802 473.37 44.5602 473.55 44.6402C473.59 44.6402 473.62 44.6402 473.66 44.6402C474.17 44.4302 474.13 44.9702 474.34 45.1702C474.37 45.2002 474.15 45.4802 474.06 45.6502C473.9 45.9302 473.76 46.2202 473.66 46.5202C473.63 46.6302 473.83 46.8202 473.96 46.9202C474.02 46.9702 474.21 46.9202 474.3 46.8402C474.45 46.7102 474.58 46.5702 474.71 46.4102C474.76 46.6302 474.78 46.8602 474.78 47.0802C474.76 47.3002 474.68 47.5202 474.55 47.6902C474.28 48.0102 474.46 48.1102 474.72 48.2402C475.3 48.5402 475.86 48.8802 476.44 49.1802C476.71 49.3202 476.73 49.4102 476.64 49.7402C476.52 50.2202 477.35 50.9802 477.86 51.2102C478.81 51.6402 479.98 51.8702 480.15 53.2202C480.17 53.3502 480.32 53.4502 480.41 53.5702C480.62 53.8602 480.84 54.0402 481.03 53.5702C481.25 53.0402 481.68 53.1902 482.06 53.2102C482.12 53.2102 482.24 53.4302 482.21 53.5102C482.13 53.7902 482.25 53.9702 482.56 53.9902C482.82 53.9702 483.07 53.9902 483.32 54.0502C483.77 54.2302 484 54.1502 484.1 53.6602C484.11 53.5902 484.24 53.5502 484.32 53.4902C484.32 53.5902 484.35 53.7002 484.38 53.7902C484.44 53.9002 484.55 54.0702 484.61 54.0602C485.07 53.9602 485.26 54.3402 485.54 54.5602C486.09 55.0002 486.4 54.9302 486.8 54.3602C487 54.1102 487.24 53.8902 487.51 53.7102C487.77 53.5102 487.99 53.5802 488.09 53.9102C488.12 54.0602 488.17 54.2002 488.23 54.3302C488.34 54.4702 488.46 54.5902 488.59 54.7102C488.7 54.5902 488.8 54.4502 488.9 54.3202C489.15 53.9002 489.21 53.2802 489.96 53.4702C490.03 53.4902 490.17 53.2502 490.27 53.1302C490.33 53.0502 490.38 52.9702 490.43 52.8802C490.46 52.9702 490.48 53.0702 490.49 53.1602C490.49 53.4402 490.56 53.5602 490.88 53.4702C491.36 53.3302 491.85 53.0602 492.36 53.3602C492.76 53.5902 492.9 53.4302 492.93 53.0402", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.79 40.3501L479.77 40.3601L479.78 40.3701L479.79 40.3501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M280.72 46.9901C280.85 46.7801 281.06 46.6302 281.31 46.5902C281.55 46.5502 281.81 46.6101 282 46.7601C284.69 48.7701 287.93 49.9302 291.29 50.0902C294.6 50.0902 296.16 48.9501 296.16 47.1402C296.16 45.1002 293.63 44.3802 290.33 43.7102C285.34 42.7502 278.91 41.5501 278.91 34.6301C278.91 29.7601 283.18 25.4901 290.81 25.4901C294.79 25.4401 298.67 26.6601 301.9 28.9801C302.26 29.2501 302.36 29.7501 302.13 30.1301L300.02 33.7301C299.89 33.9501 299.66 34.1102 299.4 34.1502C299.14 34.1902 298.88 34.1201 298.68 33.9501C296.44 32.2301 293.69 31.3001 290.87 31.3101C288.1 31.3101 286.3 32.3302 286.3 34.0202C286.3 35.8202 288.58 36.4802 291.83 37.1502C296.82 38.1102 303.49 39.4302 303.49 46.6502C303.49 51.9402 298.98 55.9701 290.93 55.9701C286.46 56.0601 282.09 54.6502 278.52 51.9602C278.19 51.6802 278.11 51.1901 278.35 50.8201L280.72 46.9801V46.9901Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M310.34 48.05V33.79C310.34 33.3 309.94 32.91 309.46 32.91H306.42C306.19 32.91 305.96 32.8201 305.8 32.6501C305.63 32.4801 305.54 32.2601 305.54 32.0301V27.1201C305.54 26.8901 305.63 26.6601 305.8 26.5001C305.97 26.3301 306.19 26.2401 306.42 26.2401H309.46C309.95 26.2401 310.34 25.84 310.34 25.36V19.1901C310.34 18.7001 310.74 18.3101 311.22 18.3101H317.15C317.64 18.3101 318.03 18.7101 318.03 19.1901V25.36C318.03 25.85 318.43 26.2401 318.91 26.2401H323.03C323.52 26.2401 323.91 26.6401 323.91 27.1201V32.0301C323.91 32.5201 323.51 32.91 323.03 32.91H318.91C318.42 32.91 318.03 33.31 318.03 33.79V46.0101C318.03 47.8101 318.99 49.2001 320.67 49.2001C321.28 49.2001 321.89 49.0801 322.46 48.8701C322.69 48.7801 322.95 48.7901 323.17 48.9001C323.39 49.0101 323.56 49.2101 323.62 49.4501L324.77 53.5601C324.87 53.9301 324.73 54.3201 324.42 54.5301C322.66 55.6001 320.62 56.1001 318.56 55.9901C313.21 55.9901 310.33 53.2201 310.33 48.0601L310.34 48.05Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M346.29 54.2901C346.29 53.9501 346.09 53.6401 345.79 53.5001C345.48 53.3501 345.12 53.3901 344.86 53.6101C342.59 55.2101 339.87 56.0501 337.1 55.9901C332.47 55.9901 327 52.8601 327 46.3701C327 39.8801 332.47 37.1101 337.1 37.1101C339.85 37.0101 342.57 37.7801 344.86 39.3101C345.13 39.5201 345.49 39.5601 345.79 39.4101C346.09 39.2601 346.29 38.9601 346.29 38.6201V36.6301C346.29 33.6801 343.76 31.7601 339.92 31.7601C337.11 31.7601 334.38 32.7301 332.22 34.5201C332.02 34.6801 331.76 34.7401 331.51 34.6801C331.26 34.6201 331.05 34.4701 330.92 34.2501L328.93 30.7201C328.72 30.3501 328.8 29.8801 329.13 29.6001C332.58 26.8901 336.86 25.4501 341.25 25.5101C347.86 25.5101 353.93 28.1501 353.93 36.5101V54.3801C353.93 54.8701 353.53 55.2601 353.05 55.2601H347.18C346.69 55.2601 346.3 54.8601 346.3 54.3801V54.3001L346.29 54.2901ZM346.29 45.0001C346.29 44.7901 346.22 44.5901 346.09 44.4301C344.52 42.8701 342.37 42.0401 340.16 42.1601C337.16 42.1601 334.69 43.7201 334.69 46.5501C334.69 49.3801 337.15 50.8201 340.16 50.8201C342.37 50.9301 344.52 50.1101 346.09 48.5501C346.22 48.3901 346.29 48.1901 346.29 47.9801V45.0201V45.0001Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M362.07 26.2302H367.94C368.43 26.2302 368.82 26.6302 368.82 27.1102V28.0002C368.82 28.3502 369.03 28.6702 369.35 28.8102C369.67 28.9502 370.04 28.8902 370.3 28.6502C372.2 26.9702 374.57 25.9202 377.09 25.6102C377.34 25.5802 377.59 25.6602 377.78 25.8302C377.97 26.0002 378.08 26.2402 378.08 26.4902V31.9602C378.08 32.2102 377.97 32.4502 377.78 32.6202C377.59 32.7902 377.34 32.8702 377.09 32.8302C376.72 32.7802 376.35 32.7602 375.98 32.7602C373.56 32.7602 370.38 34.0802 369 35.8302C368.88 35.9902 368.82 36.1802 368.82 36.3702V54.3602C368.82 54.8502 368.42 55.2402 367.94 55.2402H362.07C361.58 55.2402 361.19 54.8402 361.19 54.3602V27.1002C361.19 26.8702 361.28 26.6402 361.45 26.4802C361.62 26.3202 361.84 26.2202 362.07 26.2202V26.2302Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M384.03 48.05V33.79C384.03 33.56 383.94 33.33 383.77 33.17C383.6 33 383.38 32.91 383.15 32.91H381.17C380.68 32.91 380.29 32.5101 380.29 32.0301V27.1201C380.29 26.6301 380.69 26.2401 381.17 26.2401H383.15C383.38 26.2401 383.61 26.15 383.77 25.98C383.94 25.81 384.03 25.59 384.03 25.36V19.1901C384.03 18.7001 384.43 18.3101 384.91 18.3101H390.84C391.33 18.3101 391.72 18.7101 391.72 19.1901V25.36C391.72 25.59 391.81 25.82 391.98 25.98C392.15 26.15 392.37 26.2401 392.6 26.2401H396.72C397.21 26.2401 397.6 26.6401 397.6 27.1201V32.0301C397.6 32.5201 397.2 32.91 396.72 32.91H392.6C392.11 32.91 391.72 33.31 391.72 33.79V46.0101C391.72 47.8101 392.68 49.2001 394.36 49.2001C394.97 49.2001 395.58 49.0801 396.15 48.8701C396.38 48.7801 396.64 48.7901 396.86 48.9001C397.08 49.0101 397.25 49.2101 397.31 49.4501L398.46 53.5601C398.56 53.9301 398.42 54.3201 398.11 54.5301C396.35 55.6001 394.31 56.1001 392.25 55.9901C386.9 55.9901 384.02 53.2301 384.02 48.0601L384.03 48.05Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M422.14 53.6501C422.14 53.3101 421.94 53.0001 421.63 52.8501C421.32 52.7001 420.95 52.7501 420.69 52.9801C418.2 54.9601 415.11 56.0201 411.93 55.9901C405.56 55.9901 402.55 52.5001 402.55 46.8501V27.1201C402.55 26.8901 402.64 26.6601 402.81 26.5001C402.98 26.3401 403.2 26.2401 403.43 26.2401H409.3C409.53 26.2401 409.76 26.3301 409.92 26.5001C410.08 26.6701 410.18 26.8901 410.18 27.1201V43.8501C410.18 47.8801 412.28 49.2001 415.53 49.2001C418.01 49.1601 420.35 48.0501 421.94 46.1401C422.07 45.9801 422.14 45.7801 422.14 45.5701V27.1201C422.14 26.6301 422.54 26.2401 423.02 26.2401H428.89C429.38 26.2401 429.77 26.6401 429.77 27.1201V54.3801C429.77 54.8701 429.37 55.2601 428.89 55.2601H423.02C422.53 55.2601 422.14 54.8601 422.14 54.3801V53.6501Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M437.04 65.44V27.12C437.04 26.89 437.13 26.66 437.3 26.5C437.47 26.34 437.69 26.24 437.92 26.24H443.79C444.28 26.24 444.67 26.64 444.67 27.12V27.69C444.67 28.04 444.87 28.35 445.19 28.49C445.51 28.63 445.88 28.5701 446.13 28.3401C448.19 26.5001 450.86 25.4901 453.62 25.5101C461.07 25.5101 466.48 31.04 466.48 40.72C466.48 50.4 461.07 55.99 453.62 55.99C450.85 56.02 448.17 54.99 446.13 53.12C445.87 52.89 445.5 52.83 445.18 52.97C444.86 53.11 444.66 53.4301 444.66 53.7701V65.44C444.66 65.93 444.26 66.3201 443.78 66.3201H437.91C437.42 66.3201 437.03 65.92 437.03 65.44H437.04ZM451.22 32.3C448.75 32.37 446.43 33.48 444.84 35.37C444.73 35.52 444.67 35.7101 444.67 35.9001V45.5801C444.67 45.7801 444.73 45.9701 444.85 46.1301C446.45 47.9901 448.76 49.1 451.22 49.1901C455.61 49.1901 458.55 45.7601 458.55 40.7101C458.55 35.7201 455.61 32.3 451.22 32.3Z", fill: "#262626" }), /* @__PURE__ */ React.createElement("path", { d: "M488.7 53.1601C488.77 52.9801 488.93 52.8602 489.11 52.8302C489.2 52.8302 489.16 53.0102 489.33 53.2702C489.44 53.4402 489.79 53.4402 489.91 53.6102C490.03 53.7802 490.06 53.8801 490.18 54.0401C490.22 53.8701 490.19 53.8002 490.23 53.6302C490.23 53.4502 490.26 53.2702 490.3 53.0902C490.36 52.9502 490.7 52.9602 490.79 52.8302C490.88 52.7002 490.77 52.5802 490.86 52.4602C490.93 52.7002 491.2 52.7902 491.26 53.0302C491.3 53.1702 491.1 53.3702 491.12 53.5102C491.14 53.6402 491.28 53.7102 491.29 53.8402C491.41 53.7802 491.52 53.6902 491.61 53.5902C491.73 53.4602 492.08 53.5202 492.19 53.3802C492.3 53.2402 492.39 53.0902 492.5 52.9602C492.59 52.8102 492.68 52.6702 492.78 52.5302C492.9 52.4102 492.85 52.0502 493 51.9502C493.14 51.8602 493.26 51.9702 493.43 51.9202C493.37 51.7302 493.37 51.7702 493.3 51.5802C493.43 51.5002 493.58 51.4502 493.73 51.4402C493.96 51.4202 494.12 51.1901 494.3 51.1601C494.51 51.1201 494.79 51.3402 494.97 51.2602C495.14 51.1902 495.14 50.7802 495.32 50.6502C495.46 50.5502 495.74 50.6002 495.92 50.4602C495.98 50.4102 496 50.4002 496.03 50.4402C496.21 50.6802 496.55 50.7402 496.81 50.5902C496.9 50.5702 496.99 50.5702 497.08 50.5902C497.01 50.6602 496.93 50.7302 496.84 50.7802C496.72 50.8802 496.77 51.1701 496.66 51.3501C496.57 51.5001 496.49 51.6602 496.43 51.8302C496.36 52.0202 496 52.1502 496 52.3202C495.99 52.5802 496.08 52.7502 495.93 52.8302C495.79 52.9102 495.67 52.7802 495.43 52.6702C495.32 52.6202 495.11 52.8102 495.08 52.8702C495.02 52.9702 494.83 53.3001 494.89 53.3501C495.02 53.4501 495.38 53.2102 495.52 53.3002C495.66 53.3902 495.63 53.7302 495.77 53.8102C495.91 53.9002 496.04 53.9501 496.17 54.0401C496.17 54.1502 496.2 54.2202 496.15 54.2702C496 54.3902 495.87 54.5201 495.74 54.6601C495.59 54.8201 495.63 55.0102 495.59 55.1902C495.56 55.3302 495.62 55.5002 495.61 55.7302C495.61 55.8702 495.76 55.9402 495.83 56.0802C495.88 56.3002 495.78 56.5302 495.58 56.6502C495.58 56.6502 495.53 56.9702 495.62 57.0002C495.88 57.1002 495.84 57.1301 495.87 57.2901C495.9 57.4701 496.04 57.6602 496.01 57.8602C495.83 57.7202 495.55 57.7201 495.36 57.6001C495.24 57.5301 495.16 57.2102 495.05 57.2502C494.97 57.2702 494.95 57.5502 494.96 57.6702C495.02 57.8902 495.06 58.1002 495.09 58.3202C495.11 58.5702 495.04 58.8202 494.9 59.0202C494.87 59.0502 494.46 59.3502 494.56 59.5202C494.62 59.6302 494.91 59.5001 495.19 59.4101C495.16 59.5301 495.14 59.6402 495.13 59.7602C495.13 59.8002 495.25 59.8402 495.2 59.8402C495.02 59.8602 494.83 59.8702 494.65 59.8602C494.5 59.8202 494.39 59.6702 494.25 59.6102C494.5 59.7902 494.45 59.8702 494.71 60.0302C494.97 60.1902 495.03 60.0902 495.3 60.2502C495.56 60.4102 495.62 60.3101 495.88 60.4701C496.14 60.6301 496.02 60.8302 496.29 60.9902C496.55 61.1502 496.5 61.2402 496.76 61.4002C497.02 61.5602 497.18 61.3002 497.45 61.4602C497.71 61.6202 497.59 61.8502 497.87 61.9802C497.74 61.8302 497.6 61.7101 497.93 61.6601C498.05 61.6601 498.17 61.5902 498.24 61.4902C498.31 61.3902 498.34 61.2602 498.31 61.1402C498.27 60.8602 498.26 60.5701 498.28 60.2901C498.45 60.1702 498.58 60.0202 498.68 59.8402C498.76 59.6502 498.87 59.4802 498.99 59.3102C499.13 59.1502 499.33 59.0402 499.55 59.0102C499.61 59.0102 499.82 58.8102 499.79 58.7602C499.62 58.4902 499.49 58.2801 499.62 58.1001C499.75 57.9101 499.89 57.8002 499.92 57.5702C499.92 57.5702 500.16 57.5902 500.15 57.5902C500.21 57.2802 499.98 57.0902 499.93 56.9402C499.86 56.7302 499.86 56.7802 499.53 56.8602C499.34 56.8902 499.15 56.8601 498.98 56.7901C498.89 56.7101 499.06 56.4301 499.02 56.2901C499.18 56.2601 499.33 56.4002 499.49 56.3702C499.73 56.3302 499.96 56.1402 500.2 56.0902C500.24 56.0902 500.45 55.8702 500.44 55.8102C500.3 55.7102 500.15 55.6202 500 55.5602C499.84 55.6902 499.77 56.0202 499.65 55.9802C499.52 55.9302 499.45 55.6201 499.33 55.5401C499.6 55.4601 499.89 55.3702 500.16 55.3002C500.17 55.3002 500.16 55.3201 500.17 55.3501C500.21 55.2701 500.43 55.4502 500.64 55.4202C500.71 55.4202 500.76 54.9902 500.74 54.8802C500.7 54.7302 500.69 54.5802 500.7 54.4302C500.75 54.2402 500.45 54.0402 500.44 53.8702C500.44 53.6902 500.7 53.4802 500.66 53.3102C500.62 53.1402 500.51 52.9802 500.45 52.8002C500.4 52.6302 500.17 52.5002 500.13 52.3202C500.07 52.0602 500.13 51.9202 500.02 51.9002C499.87 51.8602 499.48 52.0502 499.35 51.9902C499.42 51.8502 499.73 51.7102 499.8 51.5702C499.98 51.5702 500.2 51.7302 500.36 51.6902C500.53 51.6502 500.58 51.3302 500.6 51.0802C500.62 50.8902 500.45 50.7502 500.39 50.5602C500.34 50.3802 500.39 50.1501 500.34 49.9701C500.34 49.9401 500.25 50.1102 500.17 50.1402C500.03 50.1902 499.85 50.1102 499.71 50.1402C499.54 50.1602 499.37 50.1602 499.2 50.1402C499.27 50.0702 499.4 49.7702 499.47 49.7002C499.57 49.6102 499.98 49.8202 500.11 49.7302C500.29 49.6002 500.11 49.3602 500.09 49.2802C500.04 49.1002 500.29 48.8902 500.34 48.7402C500.4 48.5802 500.36 48.3902 500.41 48.2302C500.47 48.0702 500.72 47.9102 500.67 47.7402C500.63 47.6102 500.51 47.5302 500.5 47.3902C500.38 47.5002 500.22 47.4702 500.09 47.5502C499.94 47.6302 499.79 47.8402 499.63 47.9002C499.64 47.7302 499.54 47.3502 499.63 47.2602C499.76 47.1402 499.91 47.0302 500.07 46.9402C500.24 46.8402 500.37 46.8402 500.42 46.7102C500.47 46.5602 500.65 46.3702 500.58 46.1802C500.52 46.0202 500.11 45.9202 500.09 45.7602C500.09 45.5102 500.16 45.2601 500.29 45.0401C500.41 44.8501 500.51 44.7702 500.53 44.5802C500.55 44.4002 500.74 44.1802 500.66 43.9802C500.58 43.8202 500.53 43.6502 500.49 43.4802C500.47 43.3002 500.19 43.0602 500.16 42.8802C500.27 42.7902 500.55 42.7602 500.54 42.6902C500.51 42.4802 500.51 42.2702 500.47 42.0602C500.43 41.8502 500.62 41.6201 500.6 41.4101C500.58 41.2001 500.4 41.0102 500.39 40.8002C500.38 40.5902 500.39 40.3802 500.39 40.1702C500.44 39.9702 500.51 39.7602 500.59 39.5702C500.65 39.3502 500.48 39.0902 500.51 38.8702C500.54 38.6402 500.67 38.3901 500.7 38.1601C500.86 38.1301 501.22 38.3102 501.32 38.2302C501.4 38.1702 501.15 38.0402 501.02 37.7702C500.95 37.6402 501.27 37.3701 501.25 37.2201C501.23 37.0901 501.24 36.9602 501.27 36.8302C501.31 36.6702 500.91 36.5502 501.11 36.4302C500.95 36.2802 501.32 36.1402 501.2 35.9602C501.13 35.8502 501.25 35.6802 501.23 35.5302C501.23 35.5202 501.19 35.5602 501.19 35.5402C501.15 35.3802 501.03 35.2202 501.06 35.0802C501.1 34.9202 501.3 34.8202 501.36 34.6702C501.42 34.5202 500.92 34.3502 500.96 34.2002C501.01 34.0302 501.38 33.8201 501.36 33.6601C501.34 33.4601 501.29 33.2502 501.26 33.0402C501.23 32.8302 501.15 32.6402 501.1 32.4402C501.04 32.2502 500.96 32.0602 500.88 31.8702C500.8 31.6702 500.88 31.4102 500.76 31.2402C500.62 31.0802 500.51 30.9002 500.43 30.7002C500.39 30.4902 500.67 30.3102 500.71 30.1102C500.74 29.9102 500.74 29.7302 500.77 29.5202C500.77 29.4802 500.76 29.4402 500.74 29.4002C500.64 29.3102 500.38 29.3002 500.28 29.2102C500.38 29.1402 500.66 29.2202 500.76 29.1502C500.78 29.1402 500.5 29.1102 500.49 29.0902C500.44 28.9202 500.7 28.6102 500.65 28.4402C500.59 28.2602 500.49 28.1802 500.52 28.0102C500.58 27.8302 500.69 27.6702 500.84 27.5602C500.74 27.3502 500.47 27.1101 500.47 26.9101C500.47 26.7001 500.65 26.5202 500.7 26.3102C500.75 26.1102 500.61 25.8502 500.66 25.6402C500.68 25.5702 500.66 25.5902 500.61 25.5102C500.55 25.6102 500.44 25.6101 500.41 25.7201C500.34 26.0401 500.18 26.1902 499.96 25.8802C499.87 25.7602 500.04 25.4402 499.95 25.3302C499.85 25.2102 499.55 25.3102 499.43 25.2402C499.23 25.1302 498.72 24.9702 498.65 25.0802C498.41 25.4402 498.97 25.3502 499.06 25.5002C499.09 25.5502 499.25 25.6502 499.23 25.7102C499.2 25.8302 498.97 25.9601 498.8 26.1001C498.67 26.2001 498.45 26.1802 498.29 26.2602C498.15 26.3602 498 26.4402 497.85 26.5202C497.61 26.5902 497.39 26.6602 497.34 26.5502C497.24 26.3402 497.05 26.3202 496.87 26.2402C496.68 26.1502 496.43 26.0102 496.38 25.7602C496.36 25.6802 495.92 25.3702 495.84 25.4502C495.48 25.7502 496.05 25.8902 496.16 26.0102C496.44 26.3302 496.41 26.3202 495.9 26.4202C495.87 26.4202 495.81 26.4802 495.78 26.4802C495.83 26.6302 495.82 26.8002 495.74 26.9402C495.69 27.0702 495.51 27.2701 495.77 27.3501C495.7 27.5001 495.76 27.6602 495.61 27.7402C495.46 27.8202 495.07 27.5601 494.95 27.6601C494.83 27.8401 494.77 28.0602 494.79 28.2802C494.81 28.7702 494.7 28.6102 494.54 28.4402C494.41 28.2802 494.26 28.1502 494.08 28.0402C493.87 27.9702 493.65 27.9602 493.44 28.0102C493.28 28.0502 493.25 28.4202 493.09 28.5302C493.01 28.6102 492.99 28.6802 492.91 28.7602C492.91 28.7702 492.8 28.6302 492.8 28.6402C492.8 28.7802 492.8 28.8602 492.8 29.0002C492.6 28.8302 492.61 28.6602 492.53 28.5402C492.43 28.3802 492.12 28.2802 492.19 28.0302C492.23 27.8902 492.61 27.7502 492.7 27.5202C492.6 27.4502 492.48 27.3702 492.47 27.3002C492.45 27.0602 492.16 27.0402 492.1 27.0102C492.05 26.9802 492.14 26.9702 491.99 27.2602C491.93 27.3702 491.55 27.2202 491.44 27.3102C491.37 27.3702 491.51 27.4902 491.46 27.5602C491.75 27.6602 491.61 27.8602 491.6 28.0002C491.59 28.1502 491.81 28.4301 491.73 28.6001C491.64 28.8101 491.31 29.1002 491.82 29.0802C492.12 29.0702 492.06 29.0502 492.02 29.2102C491.98 29.4002 492.03 29.5902 492.16 29.7302C491.98 29.8102 491.66 29.9202 491.49 30.0002C491.33 29.6402 491.21 29.6902 490.99 29.9002C490.85 29.9702 490.71 30.0102 490.56 30.0302C490.6 29.8702 490.67 29.7202 490.77 29.5902C491.01 29.3602 490.96 29.3002 490.9 29.2402C490.84 29.1702 490.74 29.2602 490.5 29.2502C490.37 29.2502 490.38 28.7302 490.25 28.5602L490.28 28.7102C490.34 28.5202 490.18 28.2502 490.25 28.0602C490.31 27.8702 490.31 27.7502 490.38 27.5602C490.21 27.4702 490.31 27.1902 490.25 27.0002C490.23 26.9002 490.18 26.8102 490.1 26.7502C490.02 26.6902 489.92 26.6702 489.82 26.6902C489.66 26.7102 489.51 26.7902 489.35 26.8102C489.19 26.8202 489.02 26.7002 488.86 26.7102C488.64 26.7302 488.43 26.8002 488.24 26.9202C488.03 27.0102 487.89 27.2102 487.86 27.4402C487.82 27.8402 487.83 27.5402 487.7 27.4302C487.54 27.2902 487.36 27.1702 487.2 27.0302C487.04 26.8902 486.86 26.7802 486.7 26.6402C486.54 26.5002 486.36 26.3802 486.2 26.2402C486.05 26.1602 485.88 26.1202 485.71 26.1202C485.59 26.3702 485.5 26.5402 485.27 26.5802C485.07 26.6002 484.89 26.7102 484.79 26.8802C484.64 27.0702 484.34 27.1202 484.16 27.2102C483.98 27.3502 483.77 27.4602 483.55 27.5302C483.34 27.5702 483.08 27.2402 482.86 27.2502C482.63 27.2702 482.4 27.2902 482.17 27.3102C481.94 27.3102 481.71 27.4102 481.55 27.5802C481.46 27.7002 481.33 27.8001 481.18 27.8501C481.05 27.9201 480.9 27.9401 480.75 27.9101C480.72 27.9101 480.72 28.1602 480.75 28.2802C480.78 28.4302 480.73 28.5702 480.83 28.7002C480.68 28.6502 480.56 28.6402 480.41 28.5902C480.26 28.5402 480.14 28.3302 479.99 28.3102C479.72 28.2702 479.74 28.2902 479.52 28.4202C479.4 28.4902 479.57 29.0002 479.55 29.2402C479.52 29.3902 479.5 29.6402 479.47 29.9002C479.44 30.1602 479.43 30.4202 479.4 30.5702C479.37 30.7302 479.32 30.8802 479.27 31.0302C479.21 30.9002 479.14 30.7902 479.05 30.6802C478.92 30.5802 479.21 30.3602 479.07 30.2702C479.01 30.4702 479.09 30.8802 478.94 31.0002C478.76 31.1302 478.56 31.2402 478.35 31.3002C478.17 31.3602 477.91 31.1802 477.71 31.1902C477.52 31.2402 477.32 31.2702 477.12 31.2902C476.62 31.2202 476.65 31.3802 476.78 31.6402C476.84 31.7602 477.1 31.7502 477.18 31.8602L477.13 31.9202C477.13 32.1302 476.95 31.8602 476.7 31.8102C476.55 31.7802 476.35 31.9402 476.17 32.0502C476 32.1502 475.68 32.1302 475.53 32.2702C475.39 32.4602 475.3 32.6702 475.26 32.9002C475.2 33.0602 475.32 33.3602 475.21 33.5102C475.09 33.6602 474.96 33.8002 474.81 33.9202C474.68 34.0402 474.34 33.9202 474.19 34.0202C474.04 34.1302 474.02 34.4302 473.88 34.5202C473.81 34.5702 473.82 34.5802 473.79 34.7102C473.94 34.7102 474.01 34.7802 474.06 34.7102C474.19 34.5502 474.38 34.4601 474.59 34.4701C474.79 34.4601 475 34.5102 475.17 34.6302C475.23 34.6902 475.08 34.8002 475.17 34.8202C474.99 35.1202 475.1 35.2402 474.54 35.1102C474.48 35.0802 474.41 35.1102 474.38 35.1702C474.32 35.3602 474.32 35.5702 474.4 35.7502C474.51 36.1202 474.79 36.2201 474.23 36.1601C473.98 36.1301 474.01 36.2801 473.96 36.4101C473.92 36.5301 473.81 36.6202 473.99 36.7802C474.37 37.1302 474.09 37.0802 473.76 37.2602C473.62 37.3402 473.58 37.8502 473.59 37.8602C473.87 37.9402 473.8 38.1902 474.08 38.2702C474.36 38.3502 474.46 38.0002 474.75 38.0802C475.03 38.1602 475.01 38.2402 475.29 38.3202C475.57 38.4002 475.51 38.6102 475.79 38.6902C476.07 38.7702 476.17 38.4102 476.46 38.4902C476.74 38.5702 476.69 38.7602 476.97 38.8402C477.25 38.9202 477.3 38.7502 477.58 38.8402C477.86 38.9202 477.77 39.2601 478.05 39.3501C478.33 39.4301 478.4 39.5802 478.69 39.5102C478.57 39.3302 478.53 39.1201 478.57 38.9101C478.59 38.8101 478.65 38.8302 478.97 38.7902C479.16 38.6802 479.31 38.5202 479.4 38.3202C479.21 38.4402 479.14 38.4002 479.06 38.1202C479 37.9102 478.7 37.7802 478.6 37.5902C478.53 37.4402 478.46 37.2802 478.41 37.1302C478.36 37.0402 478.37 36.9202 478.42 36.8402C478.47 36.7602 478.57 36.7002 478.68 36.7002C478.8 36.7002 478.88 36.7002 479.09 36.7002C479.13 36.5202 479.2 36.4502 479.24 36.2602C479.28 36.0702 479.51 35.9502 479.56 35.7702C479.61 35.5502 479.78 35.3802 480 35.3202C480.23 35.2602 480.48 35.2801 480.71 35.3501C480.93 35.4301 481.01 35.2902 481.11 35.2102C481.22 35.1302 481.14 35.0702 481.16 34.8702C481.17 34.7202 481.54 34.5702 481.52 34.3902C481.51 34.2002 481.14 34.0302 481.12 33.8302C481.07 33.6102 481.15 33.3902 481.34 33.2602C481.16 33.2302 481.19 33.1802 481.01 33.1502C480.91 32.9602 480.64 32.9302 480.61 32.8102C480.56 32.6202 480.74 32.4502 480.88 32.3202C481.01 32.2202 481.15 32.1302 481.3 32.0602C481.35 32.0202 481.44 32.0402 481.49 32.0002C481.62 31.8802 481.8 31.8202 481.97 31.8402C482.15 31.8002 482.33 31.8402 482.48 31.9502C482.59 32.0502 482.67 32.2502 482.86 32.3602C482.89 32.3802 482.93 32.4802 482.97 32.4902L483.08 32.2502C483.26 32.4102 483.39 32.6202 483.61 32.6102C483.82 32.6002 483.97 32.4202 484.15 32.2502C484.3 32.1002 484.33 32.7302 484.48 32.5702C484.6 32.4302 484.85 32.4702 484.99 32.4402C485.13 32.4102 485.27 32.1702 485.43 32.3002C485.45 32.1702 485.65 32.2102 485.69 31.9802C485.72 31.8102 485.45 31.5602 485.49 31.3602C485.53 31.1802 485.49 30.9602 485.54 30.7702C485.59 30.5802 485.72 30.4001 485.77 30.2201C485.83 30.0201 486.1 29.9002 486.16 29.7402C486.25 29.5102 486.26 29.3002 486.35 29.2002C486.45 29.1102 486.57 29.0402 486.69 28.9902C486.71 29.0802 486.51 29.3702 486.55 29.4502C486.63 29.6202 486.84 29.7302 486.91 29.9202C486.98 30.1002 487.05 30.2802 487.11 30.4602C487.17 30.6502 487.36 30.8001 487.41 30.9701C487.47 31.1701 487.53 31.3602 487.57 31.5202C487.64 31.7902 487.55 32.0302 487.59 32.1102C487.6 32.1402 487.66 31.6702 487.69 31.6802C487.88 31.7102 488.08 31.8902 488.3 31.8802C488.5 31.8802 488.7 31.6702 488.91 31.6502C489.12 31.6302 489.33 31.6902 489.54 31.6702C489.75 31.6502 489.96 31.8302 490.16 31.8202C490.38 31.8202 490.6 31.3901 490.79 31.4101C490.89 31.4201 490.92 31.1002 491.12 31.5302C491.19 31.7002 491.3 31.8501 491.43 31.9701C491.57 32.1001 491.65 32.3502 491.82 32.4202C491.99 32.5002 492.25 32.3601 492.42 32.4101C492.61 32.4601 492.74 32.6002 492.88 32.6302C493.07 32.6702 493.38 32.5001 493.49 32.6001C493.61 32.7701 493.69 32.9602 493.72 33.1702C493.76 33.3902 493.78 33.6002 493.81 33.8002C493.86 34.0302 493.73 34.3002 493.83 34.4502C493.97 34.6402 494.2 34.7502 494.44 34.7502C494.36 34.6402 494.38 34.4902 494.31 34.3802C494.4 34.3502 494.36 34.4802 494.45 34.4802C494.68 34.4802 494.9 34.4302 495.12 34.4402C495.35 34.4402 495.53 34.4302 495.75 34.4302C495.75 34.4902 495.84 34.3902 495.87 34.4302C495.93 34.5902 495.98 34.7602 496.01 34.9302C496.1 35.1502 496.07 35.1402 495.84 35.2002C495.72 35.2302 495.71 35.5102 495.49 35.5402C495.48 35.6902 495.29 35.6502 495.28 35.8002C495.14 35.9502 495.01 36.1102 494.87 36.2602C494.97 36.2802 494.92 36.3102 495.02 36.3202C494.92 36.4502 495.15 36.5702 495.05 36.7002C495.15 36.8602 495.01 37.0702 495.08 37.2502C495.15 37.4302 495.34 37.5402 495.47 37.6802C495.58 37.8102 495.74 37.9002 495.92 37.9202C495.97 37.9202 495.97 38.2602 495.99 38.3802C495.75 38.4102 495.5 38.4802 495.42 38.6502C495.34 38.8202 495.56 39.1302 495.48 39.3002C495.36 39.4902 495.17 39.6202 494.95 39.6502C494.94 39.6502 494.77 40.1002 494.86 40.2102C494.99 40.3602 495.1 40.4102 495.15 40.5802C495.2 40.7502 495.54 40.8802 495.55 41.0602C495.56 41.2402 495.24 41.4502 495.27 41.6302C495.31 41.8202 495.37 42.0001 495.47 42.1601C495.56 42.3301 495.35 42.2902 495.25 42.4302C495.18 42.5302 495.3 42.7302 495.44 42.9302C495.5 43.0202 495.52 43.1302 495.48 43.2302C495.45 43.3302 495.37 43.4102 495.28 43.4502C495.13 43.5102 494.8 43.2602 494.68 43.3202C494.59 43.3702 494.52 43.7602 494.55 43.8702C494.61 44.0502 494.65 44.2402 494.67 44.4402C494.66 44.6302 494.62 44.8202 494.56 45.0002C494.5 45.1802 494.42 45.3502 494.31 45.5102C494.21 45.6702 494.29 46.0102 494.14 46.1502C494 46.2802 493.75 46.3102 493.58 46.4202C493.43 46.5502 493.26 46.6702 493.09 46.7802C492.81 46.9102 492.81 46.8402 492.8 47.1502C492.8 47.4402 492.36 47.4302 492.16 47.5102C491.96 47.6002 491.9 47.8401 491.79 48.0401C491.66 48.0602 491.52 48.0402 491.39 48.0102C491.11 47.7802 491.07 47.5601 490.87 47.8501C490.72 47.8801 490.38 47.9402 490.36 48.0102C490.29 48.2502 490.49 48.5402 490.36 48.6902C490.29 48.7602 490.26 48.8502 490.26 48.9402C490.26 49.0302 490.31 49.1202 490.38 49.1802C490.44 49.2702 490.54 49.2201 490.78 49.2201C490.89 49.2201 490.95 49.3902 491.06 49.4002C490.97 49.4802 490.75 49.4302 490.67 49.5302C490.55 49.6902 490.5 49.7802 490.34 49.8402C490.19 49.9102 490.07 50.0702 489.87 50.0102C489.81 49.8702 489.59 49.7302 489.53 49.5602C489.43 49.3102 489.51 49.0602 489.45 49.0602C489.25 49.1302 489.05 49.2102 488.86 49.3002C488.66 49.3602 488.42 49.3002 488.22 49.3602C488.02 49.4302 488.02 49.5901 487.81 49.6601C487.85 49.9401 487.81 50.1302 487.28 50.0702L488.7 53.1601ZM496.02 53.7602C495.94 53.6002 495.63 53.5302 495.96 53.2702C496.1 53.1602 496.23 53.3102 496.43 53.2802C496.44 53.4802 496.71 53.5902 496.65 53.7702C496.62 53.8702 496.33 54.0201 496.2 54.1001C496.17 54.0101 496.06 53.8502 496.01 53.7602H496.02ZM495.72 55.5902C495.79 55.5402 495.98 55.4402 496.02 55.4602C496.15 55.5102 496.1 55.5902 496.27 55.7102C496.11 55.7702 496.13 55.9402 496.07 55.9202C495.95 55.8702 495.81 55.6802 495.71 55.5902H495.72ZM497.17 26.7402C497.17 26.7402 497.17 26.9302 497.19 26.9902C497.13 27.0102 497.17 26.9202 497.13 26.9002C497.08 26.8702 496.87 26.9002 496.84 26.8402C496.91 26.8202 497.11 26.7202 497.17 26.7402ZM496.81 28.5902C496.9 28.6102 496.92 28.7802 497 28.8202C496.95 28.9002 496.92 28.8002 496.83 28.9502C496.74 28.8202 496.58 28.9402 496.56 28.8602C496.56 28.8102 496.77 28.5802 496.8 28.5902H496.81ZM496.25 30.9302C496.25 30.9302 496.23 31.1202 496.21 31.1802C496.2 31.2202 496.21 31.1002 496.11 31.1402C496.11 31.0402 495.92 31.0402 495.91 30.9502C495.97 30.9502 496.21 30.9102 496.24 30.9302H496.25ZM496.13 31.6102C496.33 31.6702 496.48 31.8802 496.67 31.9602C496.67 32.0302 496.57 31.9402 496.56 32.0102C496.45 32.0402 496.35 32.3502 496.28 32.3102C496.08 32.1502 495.89 31.9802 495.72 31.8002C495.81 31.7802 496.05 31.5902 496.13 31.6102ZM496.05 33.8602C496 33.9702 495.89 34.0702 495.84 34.1802C495.78 34.0202 495.92 34.0402 495.93 33.8702C495.99 33.8702 495.98 33.8702 496.04 33.8702L496.05 33.8602ZM494.99 33.2402C494.99 33.2402 495.08 33.3902 495.12 33.4302C495.02 33.4902 495.02 33.3602 494.9 33.3602C494.94 33.3002 494.95 33.3102 494.99 33.2402ZM494 30.1402C494.02 30.2202 494.02 30.3002 494 30.3702C493.96 30.4202 493.97 30.3002 493.91 30.3402C493.89 30.2802 493.68 30.3102 493.7 30.2702C493.72 30.2202 493.94 30.1702 494.01 30.1402H494ZM493.77 31.6302C493.62 31.7102 493.34 31.8402 493.25 31.7902C493.03 31.6802 493 31.5602 492.81 31.4002C493.03 31.4302 493.11 31.3202 493.32 31.3702C493.45 31.4002 493.64 31.5802 493.76 31.6302H493.77ZM492.61 29.4902C492.7 29.5502 492.72 29.7202 492.81 29.7902C492.95 29.8402 492.94 29.9202 493.08 29.9802C492.99 30.0702 493.03 30.2002 492.94 30.2902C492.89 30.1502 492.78 29.9901 492.73 29.8501C492.62 29.8101 492.56 29.7402 492.46 29.7002C492.48 29.6802 492.6 29.5002 492.61 29.5002V29.4902ZM491.79 30.4302C491.85 30.1402 492.1 30.3701 492.28 30.4101C492.52 30.4501 492.49 30.5902 492.55 30.7402C492.61 30.9002 492.85 31.0602 492.82 31.2502C492.78 31.4602 492.6 31.7502 492.59 31.8802C492.38 31.7502 492.11 32.0102 491.93 31.8402C491.82 31.6202 491.76 31.3802 491.76 31.1402C491.76 30.9002 491.76 30.6702 491.8 30.4402L491.79 30.4302ZM491.15 30.4302C491.09 30.6502 491.05 30.8802 491.03 31.1202C491.03 31.2702 491.02 31.4202 491 31.5602C490.91 31.4402 490.87 31.2902 490.86 31.1402C490.84 30.8702 490.83 30.5302 490.8 30.4802C490.86 30.4702 491.08 30.4402 491.14 30.4302H491.15ZM488.58 27.0702C488.64 27.1202 488.68 27.1902 488.71 27.2602C488.71 27.3202 488.64 27.2202 488.61 27.2902C488.57 27.2502 488.45 27.3901 488.44 27.3501C488.44 27.2901 488.55 27.1302 488.58 27.0702ZM488.8 28.6902C488.91 28.8302 488.95 29.0002 489.02 29.0902C488.88 29.1802 488.75 29.1502 488.6 29.1802C488.48 29.2002 488.37 29.1701 488.27 29.1001C488.39 29.0001 488.62 28.8302 488.8 28.6902ZM489.23 30.2902C489.12 30.4202 488.98 30.5102 488.91 30.5902C488.77 30.4502 488.75 30.2402 488.62 30.0902C488.61 30.0502 488.61 30.0002 488.62 29.9602C488.8 30.0402 489.02 30.1902 489.24 30.2902H489.23ZM485.83 26.6802C485.91 26.6702 486.01 26.8902 486.1 26.9602C485.96 27.0202 485.84 26.9302 485.69 27.0002C485.55 26.9402 485.34 27.0102 485.23 26.9602C485.42 26.8502 485.62 26.7602 485.83 26.6902V26.6802ZM485.7 28.9101C485.64 28.9101 485.5 28.9002 485.44 28.9002C485.44 28.7802 485.41 28.8502 485.41 28.7302C485.48 28.8502 485.64 28.8001 485.7 28.9101ZM483.34 31.1802C483.49 31.1402 483.68 31.2501 483.84 31.2201C484 31.2001 484.17 31.3202 484.33 31.3002C484.38 31.3102 484.41 31.3502 484.43 31.3902C484.24 31.4402 484.07 31.5402 483.94 31.6802C483.77 31.8602 483.7 32.0202 483.59 32.1502C483.4 32.3202 483.15 32.4002 482.89 32.3902C483 32.1702 483.36 31.9202 483.46 31.6902C483.51 31.5702 483.3 31.1802 483.35 31.1702L483.34 31.1802ZM483.05 29.7002C483.07 29.9602 482.93 29.9702 482.93 30.2402C482.93 30.5002 482.83 30.4902 482.81 30.7602C482.75 30.8002 482.84 30.9502 482.78 30.9902C482.77 30.9302 482.66 30.7002 482.68 30.6502C482.74 30.5002 482.78 30.3502 482.8 30.1902C482.83 30.0102 482.92 29.8402 483.05 29.7002ZM482.57 28.9701C482.59 29.0501 482.57 29.1302 482.55 29.2102C482.53 29.2502 482.54 29.1302 482.48 29.1502C482.46 29.0902 482.25 29.1302 482.27 29.0902C482.29 29.0502 482.51 28.9901 482.56 28.9701H482.57ZM480.54 29.7802C480.76 29.7602 480.99 29.8802 481.21 29.8702C481.17 29.9302 481.17 29.8501 481.14 29.8501C480.94 29.8201 480.69 30.0402 480.49 29.9902C480.5 29.9902 480.53 29.7802 480.54 29.7802ZM479.96 29.6802C480.09 29.6802 480.3 29.7002 480.43 29.7002C480.43 29.6302 480.43 29.7602 480.43 29.7002C480.3 29.6402 480.08 29.7502 479.95 29.6902L479.96 29.6802ZM480.42 32.1902C480.37 32.2602 480.3 32.3302 480.22 32.3702C480.18 32.3902 480.24 32.3102 480.22 32.2702C480.2 32.2202 480.06 32.1102 480.09 32.0402C480.15 32.0702 480.35 32.1602 480.41 32.1902H480.42ZM480.03 29.0002C480.04 29.1202 480.04 29.2502 480.03 29.3702C480.03 29.4602 480.06 29.3902 480.03 29.4802C479.97 29.3802 479.76 29.4502 479.75 29.3402C479.75 29.2702 479.98 29.0802 480.04 29.0002H480.03ZM478.45 37.6102C478.55 37.5902 478.66 37.7702 478.81 37.8102C478.72 37.9802 478.73 37.9701 478.71 37.9701C478.55 37.9201 478.25 38.0401 478.1 37.9701C478.19 37.8901 478.35 37.6302 478.45 37.6102ZM476.36 34.3702C476.44 34.3902 476.44 34.6102 476.5 34.7002C476.41 34.7502 476.35 34.6602 476.26 34.6702C476.11 34.6702 475.97 34.9602 475.82 34.9602C475.67 34.9602 475.41 34.8802 475.25 34.8802C475.44 34.4602 475.91 34.2502 476.35 34.3702H476.36ZM475.71 33.3302C475.71 33.3302 475.71 33.1502 475.68 33.0902C475.74 33.0702 475.71 33.1702 475.75 33.1902C475.8 33.2102 476 33.1902 476.03 33.2402C475.96 33.2602 475.76 33.3502 475.7 33.3302H475.71ZM487.8 51.7702C487.8 51.9602 487.84 52.1402 487.91 52.3202C487.97 52.4402 488.02 52.6802 488.18 52.7702C488.3 52.8202 488.37 52.9502 488.34 53.0802C488.31 53.2102 488.2 53.3002 488.07 53.3002C487.91 53.0702 488 52.9901 487.95 52.7201C487.9 52.4501 487.95 52.4401 487.91 52.1601C487.86 51.8901 487.79 51.9002 487.74 51.6302C487.69 51.3602 487.99 51.3002 487.94 51.0302C487.89 50.7602 487.82 50.7802 487.8 50.5002C487.85 50.5102 487.92 50.6702 487.91 50.7102C487.87 50.8002 487.66 50.7702 487.58 50.8002L487.8 51.7702ZM489.26 51.1202C489.05 51.2302 488.73 51.3002 488.52 51.4202C488.31 51.5302 488.27 51.5902 488.06 51.7102C488.16 51.5202 488.19 51.3002 488.16 51.0902C488.18 50.8502 488.26 50.6102 488.4 50.4202C488.56 50.2602 488.74 50.1102 488.92 49.9902C488.92 49.9902 489.01 49.9002 489.02 49.9002C489.24 49.9802 489.27 50.2802 489.49 50.3602C489.45 50.5402 489.29 50.4102 489.13 50.5302C488.99 50.6302 489.08 50.8702 489.25 51.1402L489.26 51.1202ZM490.96 47.9802C491.12 48.0802 491.34 48.2701 491.51 48.3501C491.71 48.4501 491.77 48.5201 491.97 48.6001C491.81 48.7801 491.82 49.0302 491.67 49.2002C491.57 49.0202 491.36 48.8002 491.26 48.6202C491.16 48.4402 491.07 48.1501 490.97 47.9701L490.96 47.9802ZM491.62 52.0102C491.6 51.9302 491.59 51.8402 491.59 51.7502C491.59 51.7302 491.56 51.8402 491.58 51.8402C491.63 51.8502 491.82 51.7202 491.87 51.7402C491.82 51.8002 491.67 51.9502 491.62 52.0002V52.0102ZM492.58 52.2702C492.51 52.3502 492.34 52.3102 492.26 52.3802C492.23 52.3302 492.31 52.3802 492.32 52.3702C492.37 52.2902 492.25 52.0201 492.33 51.9701C492.44 51.9501 492.55 51.9501 492.66 51.9701C492.64 52.0701 492.62 52.1802 492.58 52.2702ZM493.47 50.7802C493.26 50.8802 493.03 50.9601 492.81 51.0401C492.61 51.1301 492.52 51.0802 492.26 50.9902C492.18 50.7602 491.85 50.6702 491.81 50.4302C491.76 50.0602 491.55 50.2902 491.38 50.3002C491.41 50.1202 491.47 49.8602 491.51 49.6902C491.54 49.5102 491.6 49.2201 491.63 49.0401C491.76 49.1801 491.8 49.5202 491.89 49.6902C491.98 49.8602 492.1 50.0402 492.2 50.2002C492.31 50.3802 492.58 50.3402 492.77 50.3902C492.92 50.4302 493.11 50.6402 493.36 50.5401C493.4 50.5201 493.51 50.4602 493.54 50.5102C493.55 50.6102 493.53 50.7101 493.48 50.7901L493.47 50.7802ZM493.33 50.1502C493.31 50.0602 493.31 49.9702 493.33 49.8802C493.35 49.8402 493.36 49.9702 493.42 49.9502C493.44 50.0002 493.63 50.0002 493.61 50.0202C493.57 50.0702 493.38 50.1202 493.31 50.1502H493.33ZM495.42 50.4802C495.38 50.5402 495.24 50.4802 495.18 50.5202C495.17 50.4602 495.26 50.4902 495.29 50.4502C495.32 50.4002 495.29 50.2001 495.36 50.1601C495.36 50.2201 495.45 50.4502 495.42 50.4802ZM495.59 39.0402C495.59 39.0402 495.78 39.0602 495.84 39.0402C495.88 39.0702 495.81 38.9502 495.85 38.9802C495.75 39.0802 495.9 39.3001 495.78 39.3501C495.76 39.2901 495.58 39.0902 495.59 39.0502V39.0402ZM495.89 49.1202C495.89 49.1202 495.86 48.9402 495.84 48.8802C496.05 48.8302 496.27 48.9102 496.47 48.8802C496.47 48.8802 496.54 48.9102 496.58 49.0202C496.36 49.0502 496.09 49.1102 495.88 49.1302L495.89 49.1202ZM496.63 50.0102C496.54 49.9102 496.47 49.7101 496.38 49.6001C496.47 49.5801 496.39 49.6602 496.48 49.6302C496.48 49.7602 496.63 49.8802 496.63 50.0002V50.0102ZM497.31 60.9701C497.24 60.8701 497.19 60.7602 497.15 60.6402C497.13 60.6002 497.18 60.6502 497.22 60.6502C497.3 60.6502 497.47 60.5202 497.58 60.5602C497.5 60.6902 497.36 60.8901 497.31 60.9701ZM497.31 54.0102C497.15 53.8202 497.09 53.6202 497 53.5202C497.14 53.4302 497.32 53.4702 497.47 53.4002C497.5 53.3902 497.69 53.4301 497.68 53.4701C497.57 53.6601 497.45 53.8402 497.31 54.0102ZM497.31 49.8102C496.97 49.8102 496.95 49.6902 496.67 49.4902C496.7 49.2302 496.89 49.1702 497.03 49.0202C497.18 48.8702 497.29 48.5602 497.55 48.5102C497.74 48.7002 497.8 48.9802 497.69 49.2302C497.58 49.4102 497.31 49.6102 497.31 49.8102ZM497.49 48.6802C497.36 48.4902 497.26 48.2902 497.17 48.0802C497.13 47.9802 497.17 47.8702 497.25 47.8102C497.36 47.7102 497.3 47.4102 497.43 47.3202C497.56 47.2302 497.68 47.1502 497.81 47.0702C497.91 47.1302 497.99 47.2101 498.06 47.2901C498.16 47.5401 498.16 47.8202 498.06 48.0702C497.92 48.3102 497.73 48.5202 497.5 48.6802H497.49ZM497.84 58.8302C497.84 58.7002 497.89 58.5002 497.89 58.3702C498 58.4002 497.92 58.4202 498.03 58.4502C497.92 58.5502 497.95 58.7302 497.85 58.8302H497.84ZM498.49 36.6601C498.41 36.6101 498.34 36.5402 498.29 36.4602C498.27 36.3702 498.35 36.4302 498.35 36.3102C498.45 36.3602 498.58 36.2402 498.58 36.2702C498.56 36.4002 498.53 36.5301 498.48 36.6601H498.49ZM498.97 47.9402C499 48.0402 499.01 48.1302 499 48.2302C498.97 48.3802 499.02 48.3602 498.96 48.5502C498.73 48.2602 498.53 48.3102 498.49 48.2502C498.62 48.1602 498.83 48.0302 498.96 47.9402H498.97ZM499.18 50.6001C499.1 50.7201 498.86 50.6902 498.73 50.7802C498.68 50.6802 498.73 50.6601 498.75 50.6001C498.78 50.3701 498.86 50.1502 498.98 49.9502C499.05 50.2202 499.22 50.5301 499.17 50.6001H499.18ZM500.06 52.8302C500.14 52.8702 500.12 53.0202 500.21 53.0802C500.14 53.1302 500.22 53.0802 500.22 53.0802C500.16 53.0102 499.88 53.0802 499.83 53.0002C499.9 52.9402 499.98 52.8902 500.06 52.8402V52.8302ZM499.45 53.4202C499.53 53.4202 499.58 53.6102 499.69 53.6802C499.57 53.7902 499.62 53.7102 499.54 53.7802C499.4 53.7002 499.21 53.8802 499.14 53.7302C499.21 53.6702 499.37 53.4202 499.44 53.4202H499.45ZM500.51 38.5102C500.43 38.5502 500.32 38.4501 500.23 38.4701C500.28 38.3601 500.32 38.3402 500.39 38.3302C500.52 38.3002 500.74 38.1602 500.89 38.1902C500.79 38.2602 500.63 38.4602 500.52 38.5102H500.51Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M493.44 34.7001C493.33 34.5101 493.29 34.2801 493.34 34.0601C493.35 34.0001 493.35 33.9501 493.35 33.8901C493.33 33.7801 493.32 33.6701 493.3 33.5601C493.29 33.4601 493.27 33.3601 493.26 33.2601C493.25 33.1901 493.23 33.1301 493.21 33.0701C493.07 33.1101 492.91 33.1101 492.77 33.0901C492.65 33.0601 492.53 33.0101 492.43 32.9301C492.39 32.9001 492.35 32.8801 492.3 32.8601C492.29 32.8601 492.25 32.8701 492.21 32.8801C492.02 32.9301 491.81 32.9201 491.62 32.8501C491.44 32.7601 491.29 32.6101 491.19 32.4301C491.17 32.3901 491.14 32.3601 491.11 32.3201C491.01 32.2301 490.92 32.1301 490.85 32.0201C490.81 32.0101 490.78 31.9901 490.75 31.9701C490.6 32.1501 490.39 32.2601 490.16 32.2901C490 32.2901 489.84 32.2501 489.69 32.1901C489.65 32.1701 489.6 32.1601 489.55 32.1401C489.42 32.1401 489.29 32.1401 489.17 32.1301C489.09 32.1301 489.02 32.1201 488.94 32.1201C488.89 32.1401 488.85 32.1601 488.81 32.1901C488.66 32.2901 488.48 32.3401 488.31 32.3601C488.2 32.3601 488.1 32.3501 487.99 32.3101C487.94 32.4601 487.8 32.5701 487.64 32.5901C487.45 32.6201 487.26 32.5201 487.17 32.3401C487.11 32.2101 487.1 32.0701 487.13 31.9301C487.14 31.8401 487.14 31.7601 487.13 31.6701C487.11 31.5901 487.08 31.5001 487.05 31.4101C487.02 31.3201 486.99 31.2201 486.96 31.1201C486.96 31.1101 486.91 31.0501 486.89 31.0101C486.79 30.8901 486.72 30.7601 486.67 30.6201C486.63 30.4801 486.57 30.3401 486.52 30.2001L486.48 30.1001C486.42 30.1701 486.35 30.2401 486.28 30.3101C486.25 30.3401 486.21 30.3701 486.18 30.4001C486.15 30.5101 486.1 30.6101 486.05 30.7001C486.02 30.7601 485.99 30.8301 485.96 30.8901C485.95 30.9601 485.94 31.0301 485.94 31.1101C485.94 31.2101 485.94 31.3101 485.92 31.4101C485.93 31.4401 485.95 31.4801 485.97 31.5001C486.08 31.6701 486.13 31.8801 486.11 32.0801C486.08 32.2801 485.96 32.4601 485.78 32.5701C485.73 32.6501 485.66 32.7001 485.57 32.7401C485.5 32.7701 485.41 32.7801 485.33 32.7701C485.25 32.8301 485.16 32.8701 485.06 32.9001C484.99 32.9201 484.91 32.9301 484.83 32.9301C484.8 32.9301 484.76 32.9301 484.73 32.9301C484.61 33.0301 484.46 33.0701 484.31 33.0501C484.21 33.0301 484.12 32.9901 484.05 32.9201C483.92 33.0101 483.76 33.0701 483.59 33.0801C483.41 33.0801 483.24 33.0401 483.09 32.9301C483.01 32.9601 482.92 32.9701 482.84 32.9501C482.7 32.9201 482.58 32.8301 482.51 32.7101C482.39 32.6201 482.29 32.5101 482.21 32.3801C482.19 32.3501 482.17 32.3301 482.15 32.3001C482.11 32.3001 482.07 32.2901 482.03 32.3001H481.95C481.81 32.3001 481.8 32.3001 481.74 32.3601C481.66 32.4301 481.56 32.4701 481.45 32.4901C481.39 32.5301 481.33 32.5601 481.28 32.5901C481.24 32.6101 481.2 32.6301 481.16 32.6601L481.13 32.6901C481.13 32.6901 481.2 32.7501 481.24 32.7801C481.28 32.8001 481.32 32.8101 481.36 32.8301C481.55 32.8601 481.7 33.0001 481.74 33.1801C481.78 33.3601 481.71 33.5501 481.56 33.6601C481.55 33.6601 481.54 33.6901 481.54 33.7301C481.56 33.7501 481.59 33.7801 481.61 33.8001C481.79 33.9401 481.91 34.1501 481.95 34.3801C481.95 34.6401 481.81 34.8801 481.6 35.0201C481.64 35.2501 481.54 35.4701 481.35 35.6001C481.14 35.8201 480.82 35.9001 480.54 35.7901C480.4 35.7401 480.25 35.7401 480.11 35.7701C480.08 35.7701 480.02 35.7901 479.99 35.9201C479.94 36.0701 479.85 36.2101 479.74 36.3201C479.71 36.3501 479.69 36.3801 479.67 36.4101C479.65 36.5001 479.62 36.5901 479.58 36.6801C479.56 36.7201 479.54 36.7701 479.53 36.8101C479.49 37.0201 479.3 37.1701 479.08 37.1701C479 37.1701 478.94 37.1701 478.89 37.1701C478.92 37.2501 478.96 37.3301 479 37.4101C479.04 37.4501 479.07 37.4801 479.11 37.5201C479.25 37.6301 479.36 37.7601 479.45 37.9201C479.6 37.9401 479.72 38.0301 479.79 38.1601C479.86 38.2901 479.86 38.4501 479.79 38.5801C479.67 38.8401 479.47 39.0501 479.23 39.2001C479.18 39.2401 479.11 39.2601 479.05 39.2801V39.3001C479.15 39.4201 479.16 39.5801 479.11 39.7201C479.05 39.8601 478.93 39.9601 478.79 39.9901C478.55 40.0501 478.3 40.0101 478.09 39.8901C478.04 39.8601 477.98 39.8401 477.93 39.8201C477.69 39.7501 477.49 39.5601 477.41 39.3201H477.39C477.21 39.3801 477.02 39.3801 476.84 39.3201C476.66 39.2701 476.49 39.1601 476.37 39.0101C476.17 39.1801 475.91 39.2401 475.66 39.1701C475.46 39.1201 475.29 38.9901 475.17 38.8301C475.03 38.7801 474.89 38.7101 474.77 38.6301C474.74 38.6101 474.71 38.5901 474.67 38.5801H474.66C474.46 38.7601 474.2 38.8201 473.94 38.7501C473.73 38.6901 473.55 38.5501 473.44 38.3601C473.4 38.3401 473.37 38.3201 473.33 38.2901C473.19 38.2001 473.11 38.0401 473.12 37.8701C473.1 37.5201 473.24 37.1801 473.49 36.9401C473.4 36.7501 473.4 36.5301 473.51 36.3401L473.53 36.2801C473.56 36.0601 473.71 35.8801 473.92 35.8001C473.87 35.6201 473.86 35.4301 473.89 35.2401C473.86 35.2401 473.84 35.2401 473.81 35.2301C473.79 35.2301 473.77 35.2301 473.75 35.2301C473.62 35.2301 473.5 35.1601 473.42 35.0601C473.34 34.9601 473.31 34.8201 473.33 34.7001C473.34 34.5201 473.43 34.3601 473.57 34.2501C473.58 34.2301 473.59 34.2001 473.6 34.1801C473.66 34.0001 473.77 33.8401 473.91 33.7301C474.08 33.6201 474.28 33.5801 474.48 33.6001C474.5 33.6001 474.53 33.6001 474.55 33.6001C474.63 33.5201 474.71 33.4401 474.79 33.3601C474.79 33.3301 474.79 33.3001 474.79 33.2701C474.77 33.1201 474.78 32.9701 474.82 32.8201C474.83 32.7801 474.84 32.7401 474.86 32.7001C474.91 32.4401 475.03 32.2101 475.21 32.0101C475.38 31.8701 475.58 31.7801 475.8 31.7601C475.85 31.7601 475.9 31.7401 475.94 31.7301L476.02 31.6801C476.09 31.6401 476.16 31.5901 476.25 31.5401C476.23 31.4001 476.27 31.2601 476.35 31.1401C476.56 30.9201 476.88 30.8301 477.18 30.9101C477.2 30.9101 477.28 30.8901 477.33 30.8701C477.44 30.8401 477.56 30.8201 477.68 30.8001C477.84 30.8001 477.99 30.8201 478.14 30.8801C478.17 30.8901 478.22 30.9101 478.25 30.9201C478.36 30.8801 478.47 30.8301 478.57 30.7701C478.56 30.6801 478.57 30.5901 478.59 30.5001C478.59 30.4001 478.61 30.3001 478.63 30.2001C478.68 30.0201 478.84 29.9001 479.02 29.8801V29.8401C479.05 29.6201 479.07 29.4001 479.1 29.2501C479.1 29.1601 479.08 29.0801 479.07 28.9901C479.02 28.6701 478.96 28.2801 479.29 28.0801L479.35 28.0401C479.55 27.8901 479.81 27.8401 480.05 27.9101C480.13 27.9201 480.21 27.9501 480.28 27.9901C480.28 27.8601 480.34 27.7401 480.42 27.6501C480.53 27.5401 480.68 27.4901 480.83 27.5201C480.88 27.5301 480.93 27.5201 480.97 27.5001L481.04 27.4701C481.04 27.4701 481.12 27.4301 481.16 27.4001C481.4 27.1101 481.75 26.9401 482.13 26.9201C482.24 26.9201 482.36 26.9001 482.47 26.8901C482.59 26.8801 482.7 26.8701 482.82 26.8601C483.04 26.8601 483.26 26.9401 483.43 27.0701C483.45 27.0901 483.49 27.1101 483.51 27.1201C483.58 27.0801 483.64 27.0501 483.7 27.0001C483.78 26.9501 483.85 26.9001 483.93 26.8601C484.01 26.8201 484.1 26.7801 484.19 26.7501C484.27 26.7301 484.35 26.6901 484.42 26.6501C484.59 26.3901 484.87 26.2201 485.18 26.1801C485.18 26.1701 485.25 26.0501 485.29 25.9601C485.35 25.8401 485.47 25.7501 485.61 25.7201C485.91 25.7001 486.21 25.7801 486.47 25.9401C486.54 26.0001 486.61 26.0501 486.68 26.1001C486.78 26.1801 486.88 26.2601 486.98 26.3401C487.05 26.4001 487.12 26.4501 487.2 26.5101C487.3 26.5801 487.4 26.6601 487.49 26.7401C487.54 26.7901 487.6 26.8301 487.65 26.8701C487.76 26.7501 487.88 26.6501 488.02 26.5801C488.27 26.4201 488.55 26.3301 488.84 26.3101C488.98 26.3101 489.11 26.3401 489.24 26.3801C489.27 26.3901 489.3 26.4001 489.33 26.4101C489.33 26.4101 489.39 26.3901 489.44 26.3701C489.55 26.3301 489.66 26.3001 489.77 26.2901C490.19 26.2301 490.58 26.5001 490.67 26.9101C490.71 27.0301 490.72 27.1601 490.72 27.2901V27.3201C490.82 27.4401 490.85 27.6101 490.8 27.7501C490.78 27.8101 490.76 27.8801 490.75 27.9401C490.73 28.0401 490.7 28.1501 490.67 28.2501C490.67 28.2301 490.69 28.2901 490.7 28.3401C490.72 28.4301 490.74 28.5301 490.74 28.6201C490.76 28.6801 490.77 28.7401 490.79 28.8101C490.9 28.8101 491.01 28.8301 491.11 28.8801C491.14 28.7601 491.2 28.6501 491.27 28.5501L491.29 28.5301C491.29 28.5301 491.27 28.4801 491.26 28.4601C491.19 28.3201 491.15 28.1601 491.16 28.0101C491.16 27.9901 491.16 27.9601 491.17 27.9301C491.11 27.8801 491.07 27.8101 491.05 27.7401C491.05 27.7101 491.03 27.6701 491.03 27.6401C490.93 27.4301 490.98 27.1701 491.16 27.0201C491.31 26.9101 491.49 26.8601 491.67 26.8901C491.72 26.7601 491.82 26.6701 491.95 26.6301C492.08 26.5901 492.22 26.6101 492.33 26.6801C492.6 26.7301 492.81 26.9201 492.9 27.1701L492.93 27.1901C493.11 27.3101 493.19 27.5401 493.13 27.7501C493.19 27.7001 493.27 27.6601 493.35 27.6401C493.65 27.5701 493.97 27.5801 494.26 27.6801C494.32 27.7001 494.38 27.7301 494.43 27.7701C494.47 27.6201 494.55 27.4801 494.67 27.3701C494.82 27.2501 495.01 27.2101 495.19 27.2501C495.19 27.1101 495.24 26.9801 495.31 26.8601C495.34 26.8101 495.36 26.7501 495.37 26.6801C495.3 26.5601 495.3 26.4101 495.37 26.2901C495.4 26.2301 495.45 26.1801 495.51 26.1401C495.38 26.0301 495.3 25.8801 495.28 25.7201C495.26 25.4901 495.37 25.2701 495.55 25.1401C495.71 25.0101 495.92 24.9901 496.1 25.0701C496.1 25.0701 496.74 25.3301 496.82 25.7201C496.82 25.7201 496.85 25.7901 497.05 25.8701C497.08 25.8801 497.11 25.9001 497.14 25.9101C497.3 25.9601 497.45 26.0501 497.58 26.1701C497.62 26.1601 497.66 26.1501 497.69 26.1401C497.75 26.1201 497.8 26.0901 497.85 26.0501C497.92 26.0001 498 25.9501 498.08 25.9101C498.2 25.8501 498.32 25.8101 498.45 25.8001H498.47C498.34 25.7301 498.24 25.6201 498.18 25.4901C498.11 25.2801 498.15 25.0601 498.28 24.8901C498.59 24.4301 499.38 24.7701 499.6 24.8801C499.62 24.8801 499.64 24.8801 499.66 24.8801C499.9 24.8501 500.14 24.9401 500.31 25.1101C500.33 25.1401 500.35 25.1701 500.37 25.1901C500.44 25.1401 500.52 25.1101 500.61 25.1101C500.77 25.1101 500.92 25.1801 501.01 25.3201C501.12 25.4501 501.16 25.6301 501.11 25.8001C501.11 25.8101 501.13 25.8901 501.14 25.9401C501.19 26.1101 501.19 26.3001 501.16 26.4701C501.12 26.6001 501.07 26.7201 501.01 26.8301C500.98 26.8801 500.96 26.9201 500.94 26.9701C500.94 26.9401 501.02 27.0501 501.06 27.1101C501.14 27.2101 501.2 27.3101 501.26 27.4201C501.35 27.6001 501.31 27.8101 501.16 27.9501C501.09 28.0101 501.02 28.0801 500.97 28.1601C501.02 28.2201 501.06 28.2901 501.08 28.3701C501.13 28.5301 501.12 28.7101 501.05 28.8701C501.13 28.9301 501.18 29.0201 501.2 29.1201C501.22 29.2001 501.21 29.2901 501.19 29.3601C501.22 29.4501 501.23 29.5501 501.22 29.6501C501.21 29.7401 501.2 29.8201 501.19 29.9101C501.19 30.0201 501.17 30.1301 501.15 30.2501C501.11 30.4101 501.04 30.5701 500.93 30.7001L500.9 30.7401C500.93 30.7901 500.99 30.8701 501.03 30.9201L501.13 31.0501C501.24 31.2201 501.3 31.4201 501.29 31.6301C501.29 31.6801 501.29 31.7301 501.3 31.7701C501.32 31.8201 501.35 31.8701 501.37 31.9301C501.43 32.0701 500.89 32.2201 500.94 32.4001C500.96 32.4701 500.98 32.5401 501 32.6101C501.05 32.7501 501.08 32.9001 501.11 33.0401L501.15 33.2501C501.18 33.3901 501.2 33.5401 501.22 33.6801C501.22 33.6601 501.24 33.6801 501.26 33.7201C501.41 33.9101 501.47 34.1701 501.41 34.4101C501.37 34.5301 501.32 34.6401 501.26 34.7501C501.23 34.8001 501.2 34.8601 501.18 34.9101C501.12 35.0401 501.04 35.1501 500.94 35.2501V35.2701H500.95C501.02 35.3501 501.07 35.4501 501.08 35.5501C501.08 35.6601 501.08 35.7601 501.05 35.8601C501.09 35.9001 501.15 35.9401 501.2 35.9801C501.28 36.0401 501.36 36.1101 501.43 36.1701C501.53 36.2701 501.58 36.4101 501.57 36.5501C501.56 36.6901 501.47 36.8101 501.35 36.8901C501.26 36.9401 501.18 36.9901 501.1 37.0501C501.09 37.1101 501.09 37.1801 501.1 37.2401C501.11 37.4401 501.05 37.6301 500.92 37.7801L500.97 37.8301C501.11 37.9501 501.19 38.1301 501.19 38.3101C501.18 38.4401 501.71 38.5801 501.61 38.6601C501.44 38.7701 501.23 38.8101 501.04 38.7501C501.01 38.8301 500.99 38.9201 500.97 39.0001C500.97 39.0501 500.99 39.1001 501.01 39.1601C501.08 39.3601 501.09 39.5701 501.04 39.7801C501.01 39.8801 500.98 39.9701 500.94 40.0601C500.9 40.1401 500.88 40.2201 500.86 40.3001C500.85 40.4401 500.84 40.5801 500.86 40.7201V40.8701C500.86 40.8701 500.9 40.9601 500.92 41.0001C500.99 41.1301 501.04 41.2801 501.06 41.4301C501.07 41.6101 501.04 41.7801 500.97 41.9401C500.95 41.9801 500.94 42.0301 500.93 42.0801C500.95 42.1701 500.96 42.2801 500.97 42.4001C500.97 42.4901 500.98 42.5901 501 42.6801C501.03 42.8601 500.96 43.0301 500.81 43.1301C500.88 43.2301 500.92 43.3501 500.94 43.4701C500.96 43.5701 500.99 43.6601 501.03 43.7501L501.08 43.8701C501.16 44.1101 501.14 44.3801 501.01 44.6001C501 44.6301 500.98 44.6601 500.97 44.6901C500.95 44.8901 500.87 45.0801 500.74 45.2301L500.67 45.3401C500.62 45.4401 500.58 45.5401 500.56 45.6401C500.76 45.7301 500.91 45.8801 501.01 46.0701C501.09 46.3301 501.04 46.6101 500.89 46.8301C500.88 46.8501 500.86 46.8801 500.85 46.9001C500.83 46.9501 500.81 47.0001 500.78 47.0501C500.89 47.1301 500.96 47.2601 500.96 47.4001C501.03 47.4701 501.08 47.5601 501.11 47.6501C501.18 47.9201 501.09 48.2001 500.89 48.3901C500.87 48.4101 500.85 48.4401 500.83 48.4601C500.83 48.4901 500.83 48.5201 500.83 48.5501C500.83 48.6801 500.81 48.8101 500.77 48.9301C500.73 49.0301 500.67 49.1301 500.6 49.2201C500.59 49.2401 500.57 49.2601 500.56 49.2801C500.61 49.4001 500.64 49.5401 500.63 49.6801C500.7 49.7401 500.75 49.8101 500.77 49.9001C500.8 50.0401 500.82 50.1801 500.81 50.3201C500.81 50.3701 500.81 50.4301 500.81 50.4801C500.83 50.5201 500.85 50.5601 500.87 50.6001C500.99 50.7701 501.04 50.9701 501.04 51.1701C501.02 51.4201 500.97 51.9901 500.54 52.1601C500.54 52.2001 500.54 52.2401 500.56 52.2901C500.56 52.2901 500.59 52.3101 500.62 52.3401C500.73 52.4501 500.82 52.5901 500.87 52.7301C500.89 52.7901 500.92 52.8501 500.94 52.9001C501 53.0201 501.04 53.1401 501.08 53.2601C501.12 53.4901 501.06 53.7201 500.92 53.9001C501.1 54.0901 501.17 54.3601 501.12 54.6101C501.13 54.6401 501.14 54.6601 501.14 54.6901C501.15 54.7501 501.16 54.8201 501.17 54.8901C501.17 54.8901 501.23 55.6201 500.87 55.8601C500.82 56.1901 500.6 56.4701 500.29 56.5901C500.27 56.5901 500.24 56.6001 500.22 56.6101C500.27 56.6901 500.31 56.7701 500.34 56.8601C500.34 56.8601 500.36 56.8901 500.37 56.9001C500.54 57.1401 500.62 57.4301 500.57 57.7301C500.53 57.9101 500.39 58.0501 500.21 58.0801C500.16 58.1601 500.11 58.2301 500.05 58.3001L500.02 58.3401C500.05 58.4001 500.1 58.4901 500.14 58.5501C500.22 58.7001 500.23 58.8801 500.17 59.0401C500.04 59.2701 499.83 59.4301 499.58 59.5001C499.47 59.5201 499.38 59.5801 499.31 59.6601C499.26 59.7301 499.21 59.8101 499.17 59.9001C499.13 59.9701 499.1 60.0401 499.06 60.1101C498.97 60.2801 498.85 60.4301 498.71 60.5601C498.71 60.7401 498.72 60.9201 498.74 61.1001C498.81 61.4901 498.62 61.8701 498.28 62.0501C498.28 62.1301 498.25 62.2001 498.2 62.2701C498.12 62.3901 497.98 62.4601 497.83 62.4701C497.77 62.4701 497.72 62.4601 497.66 62.4301C497.44 62.3401 497.28 62.1501 497.2 61.9301C496.96 61.9801 496.71 61.9401 496.5 61.8301C496.36 61.7501 496.25 61.6501 496.15 61.5201C496.12 61.4801 496.08 61.4401 496.03 61.4101C495.85 61.3001 495.71 61.1301 495.64 60.9301C495.56 60.8501 495.54 60.8501 495.48 60.8401C495.32 60.8101 495.17 60.7601 495.03 60.6701C494.99 60.6401 494.94 60.6301 494.89 60.6201C494.73 60.6001 494.58 60.5401 494.44 60.4501C494.3 60.3701 494.18 60.2601 494.08 60.1301C494.05 60.0801 494 60.0401 493.95 60.0101C493.8 59.9101 493.73 59.7201 493.77 59.5501C493.81 59.3701 493.95 59.2401 494.13 59.2001C494.23 59.0201 494.37 58.8701 494.53 58.7501C494.59 58.6201 494.61 58.4801 494.6 58.3401C494.6 58.2601 494.58 58.1801 494.55 58.1101C494.51 57.9901 494.49 57.8701 494.47 57.7401C494.47 57.6601 494.41 56.9801 494.87 56.8401C494.93 56.8201 495 56.8101 495.07 56.8201C495.05 56.6201 495.13 56.4201 495.29 56.3001C495.31 56.2901 495.33 56.2701 495.34 56.2501C495.2 56.1201 495.12 55.9301 495.12 55.7301C495.12 55.6601 495.12 55.5801 495.11 55.5101C495.09 55.3801 495.09 55.2501 495.11 55.1201C495.11 55.0801 495.12 55.0501 495.12 55.0101C495.12 54.7701 495.21 54.5501 495.37 54.3701C495.41 54.3301 495.46 54.2801 495.51 54.2301H495.49C495.35 54.1201 495.25 53.9701 495.2 53.8101C495 53.8801 494.77 53.8501 494.59 53.7401C494.17 53.4301 494.52 52.8901 494.66 52.6601C494.84 52.3701 495.18 52.2101 495.52 52.2601C495.57 52.0501 495.71 51.8601 495.89 51.7401C495.93 51.7101 495.96 51.6801 496 51.6501C496.06 51.4701 496.14 51.3001 496.24 51.1401V51.1101C496.12 51.0901 496 51.0401 495.9 50.9701C495.81 51.0001 495.72 51.0201 495.62 51.0301H495.57C495.57 51.0301 495.55 51.1001 495.54 51.1301C495.49 51.3601 495.34 51.5601 495.13 51.6801C494.91 51.7601 494.67 51.7501 494.46 51.6501C494.43 51.6501 494.39 51.6301 494.36 51.6201C494.34 51.6301 494.32 51.6501 494.3 51.6601C494.17 51.7601 494.02 51.8401 493.86 51.8801C493.88 52.0901 493.75 52.2901 493.56 52.3501C493.48 52.3801 493.39 52.4001 493.3 52.3901C493.28 52.5601 493.21 52.7201 493.09 52.8501C493.06 52.8901 493.03 52.9401 493.01 52.9801C492.96 53.0701 492.91 53.1601 492.85 53.2401C492.79 53.3101 492.74 53.3901 492.69 53.4601C492.64 53.5301 492.6 53.5901 492.55 53.6601C492.4 53.8301 492.19 53.9301 491.97 53.9401C491.95 53.9401 491.92 53.9401 491.9 53.9501C491.79 54.0701 491.65 54.1701 491.51 54.2501C491.39 54.3201 491.24 54.3201 491.12 54.2701C490.99 54.2201 490.9 54.1101 490.86 53.9701C490.78 53.8701 490.72 53.7601 490.69 53.6301C490.69 53.6601 490.69 53.7001 490.68 53.7301C490.68 53.7801 490.67 53.8201 490.67 53.8701C490.67 53.9701 490.66 54.0601 490.64 54.1501C490.6 54.3201 490.47 54.4601 490.29 54.4901C490.12 54.5301 489.94 54.4601 489.83 54.3201C489.77 54.2401 489.72 54.1501 489.67 54.0601C489.64 54.0001 489.61 53.9401 489.57 53.8901C489.59 53.9201 489.53 53.8901 489.49 53.8901C489.29 53.8301 489.11 53.7101 488.98 53.5501C488.92 53.4601 488.87 53.3601 488.83 53.2501L488.79 53.2301V53.2601C488.7 53.5701 488.41 53.7901 488.08 53.7801C487.93 53.7801 487.8 53.7101 487.72 53.5801C487.59 53.4101 487.53 53.2001 487.54 52.9801C487.54 52.9301 487.54 52.8701 487.53 52.8201C487.51 52.7101 487.5 52.6001 487.5 52.4901C487.44 52.3301 487.4 52.1701 487.39 52.0001C487.36 51.9201 487.33 51.8301 487.32 51.7401C487.28 51.5101 487.35 51.2701 487.5 51.0901C487.5 51.0901 487.48 51.0201 487.46 50.9801C487.4 50.8501 487.37 50.7101 487.36 50.5701C487.36 50.5701 487.29 50.5601 487.25 50.5501L487.35 49.6601H487.38C487.4 49.4801 487.52 49.3301 487.69 49.2701C487.79 49.1301 487.93 49.0301 488.09 48.9701C488.31 48.9301 488.53 48.9001 488.75 48.9001C488.81 48.8801 488.87 48.8501 488.93 48.8201C489.07 48.7401 489.23 48.6801 489.39 48.6501C489.52 48.6301 489.66 48.6701 489.76 48.7501C489.78 48.7701 489.8 48.7901 489.82 48.8101C489.84 48.7001 489.88 48.5901 489.95 48.5001V48.4501C489.89 48.2701 489.89 48.0801 489.93 47.9001C490.01 47.6101 490.29 47.5201 490.63 47.4601C490.73 47.3601 490.86 47.3001 491 47.2801C491.21 47.2801 491.42 47.3701 491.54 47.5501C491.63 47.3601 491.79 47.2101 491.98 47.1201C492.07 47.0801 492.16 47.0601 492.26 47.0401C492.29 47.0401 492.32 47.0301 492.35 47.0201C492.35 46.7501 492.53 46.5201 492.78 46.4401L492.89 46.3901C492.96 46.3501 493.02 46.3001 493.08 46.2501C493.16 46.1801 493.24 46.1201 493.32 46.0601C493.43 46.0001 493.54 45.9401 493.66 45.9001C493.69 45.8901 493.74 45.8701 493.77 45.8601C493.77 45.8301 493.77 45.8001 493.77 45.7801C493.77 45.6101 493.82 45.4401 493.9 45.2901C493.98 45.1701 494.05 45.0401 494.1 44.9001C494.15 44.7601 494.18 44.6101 494.19 44.4501C494.19 44.3801 494.17 44.3101 494.14 44.2501C494.11 44.1601 494.09 44.0701 494.07 43.9801C494.05 43.8901 494.04 43.1601 494.44 42.9501C494.57 42.8901 494.71 42.8701 494.85 42.9001C494.72 42.6801 494.72 42.4101 494.85 42.2001C494.87 42.1801 494.89 42.1501 494.91 42.1301C494.85 42.0001 494.82 41.8601 494.79 41.7201C494.77 41.5101 494.84 41.3001 494.98 41.1401C494.84 41.0401 494.74 40.9001 494.68 40.7301C494.67 40.7201 494.65 40.7001 494.62 40.6801C494.58 40.6401 494.53 40.5901 494.48 40.5301C494.31 40.3401 494.3 40.0601 494.44 39.6501C494.48 39.4501 494.62 39.2901 494.82 39.2401C494.88 39.2301 494.94 39.2101 495 39.1701C495 39.1501 495 39.1401 494.99 39.1201C494.91 38.9201 494.91 38.6901 494.99 38.4801C495.05 38.3501 495.15 38.2301 495.28 38.1601C495.22 38.1101 495.16 38.0601 495.11 38.0001C495.08 37.9701 495.04 37.9301 495.01 37.9101C494.85 37.7901 494.72 37.6201 494.64 37.4301C494.59 37.2701 494.58 37.1101 494.61 36.9401V36.9001C494.59 36.8301 494.57 36.7401 494.58 36.6601V36.6301C494.47 36.5501 494.41 36.4301 494.4 36.3101C494.39 36.1901 494.44 36.0601 494.52 35.9701C494.59 35.9001 494.65 35.8301 494.71 35.7601C494.76 35.7001 494.81 35.6501 494.86 35.5901C494.91 35.4901 494.98 35.4001 495.08 35.3401C495.13 35.2501 495.21 35.1801 495.31 35.1401C495.36 35.0401 495.43 34.9601 495.51 34.8901H495.44C495.33 34.8901 495.22 34.9001 495.1 34.8901C495.02 34.8901 494.93 34.8901 494.84 34.9001C494.84 34.9101 494.83 34.9301 494.82 34.9401C494.75 35.0901 494.6 35.1901 494.43 35.2001L493.44 34.7001ZM497.84 61.2201C497.84 61.2201 497.85 61.2301 497.84 61.1901C497.84 61.1101 497.83 61.0301 497.82 60.9501C497.8 60.9801 497.77 61.0201 497.75 61.0501L497.7 61.1201C497.7 61.1201 497.78 61.1801 497.82 61.2201H497.83H497.84ZM495.63 59.9201H495.65C495.81 59.9501 495.96 60.0001 496.09 60.0901C496.27 60.2001 496.41 60.3701 496.48 60.5701C496.56 60.6301 496.63 60.6901 496.7 60.7501C496.65 60.6101 496.68 60.4501 496.77 60.3301C496.87 60.2101 497.01 60.1501 497.17 60.1701C497.35 60.0801 497.55 60.0701 497.73 60.1401C497.79 60.2201 497.9 60.2301 497.98 60.1801C498.06 60.1301 498.08 60.0201 498.03 59.9401C498.14 59.8601 498.23 59.7601 498.29 59.6401C498.32 59.5901 498.34 59.5401 498.37 59.4801C498.44 59.3201 498.54 59.1601 498.66 59.0301C498.81 58.8601 499 58.7401 499.21 58.6601C499.08 58.4101 499.09 58.1101 499.25 57.8701C499.29 57.8201 499.33 57.7701 499.36 57.7201C499.44 57.6201 499.46 57.5801 499.47 57.5501C499.47 57.5201 499.47 57.5001 499.49 57.4701C499.5 57.4301 499.52 57.3901 499.54 57.3501C499.24 57.4001 498.93 57.3301 498.68 57.1601C498.51 56.9701 498.46 56.6901 498.56 56.4601C498.56 56.4401 498.57 56.4101 498.58 56.3901C498.55 56.1601 498.71 55.9501 498.93 55.9001C498.95 55.9001 498.98 55.9001 499 55.8901C498.89 55.7801 498.85 55.6101 498.89 55.4601C498.93 55.3101 499.05 55.1901 499.2 55.1501C499.32 55.1201 499.44 55.0801 499.56 55.0401C499.72 54.9901 499.88 54.9501 500.03 54.9001C500.11 54.8801 500.2 54.8801 500.28 54.9001C500.28 54.8801 500.28 54.8501 500.27 54.8301C500.24 54.7101 500.23 54.5801 500.24 54.4601C500.23 54.4401 500.22 54.4301 500.21 54.4101C500.1 54.2801 500.03 54.1301 500 53.9701C500 53.9801 499.98 53.9901 499.97 54.0001C499.91 54.0601 499.84 54.1101 499.77 54.1401C499.66 54.2101 499.54 54.2301 499.41 54.2001C499.14 54.3001 498.84 54.1701 498.72 53.9201C498.63 53.7301 498.67 53.5101 498.83 53.3801C498.83 53.3801 498.85 53.3501 498.87 53.3201C498.98 53.1401 499.15 53.0201 499.35 52.9601C499.35 52.9301 499.35 52.9101 499.35 52.8801C499.38 52.7601 499.45 52.6501 499.56 52.5901C499.6 52.5601 499.65 52.5201 499.69 52.4901C499.69 52.4701 499.68 52.4501 499.68 52.4401C499.52 52.4801 499.34 52.4801 499.18 52.4301C499.06 52.3801 498.97 52.2901 498.92 52.1801C498.87 52.0701 498.88 51.9301 498.93 51.8201C499.02 51.6601 499.14 51.5301 499.3 51.4401C499.34 51.4101 499.38 51.3801 499.42 51.3501C499.49 51.2001 499.65 51.1201 499.81 51.1401C499.92 51.1401 500.03 51.1701 500.13 51.2101C500.13 51.1701 500.14 51.1201 500.15 51.0601C500.15 51.0701 500.12 51.0501 500.1 51.0101C500.04 50.9101 499.99 50.8101 499.95 50.7001C499.95 50.6701 499.93 50.6401 499.93 50.6101C499.91 50.6101 499.88 50.6101 499.86 50.6101C499.83 50.6101 499.82 50.6101 499.78 50.6101C499.72 50.6201 499.65 50.6301 499.59 50.6301C499.59 50.7101 499.56 50.7901 499.51 50.8501C499.38 51.0201 499.19 51.1301 498.98 51.1501C498.95 51.1501 498.93 51.1601 498.9 51.1701C498.8 51.2401 498.67 51.2601 498.55 51.2201C498.43 51.1801 498.33 51.0901 498.28 50.9801C498.18 50.8001 498.19 50.5901 498.29 50.4101C498.29 50.4101 498.29 50.3701 498.3 50.3401C498.33 50.0901 498.43 49.8601 498.58 49.6701C498.69 49.5401 498.86 49.4801 499.02 49.5201H499.04C499.04 49.5201 499.11 49.4301 499.15 49.3901C499.28 49.2801 499.45 49.2301 499.62 49.2601C499.63 49.0501 499.71 48.8501 499.85 48.6901C499.87 48.6601 499.89 48.6301 499.91 48.6001C499.91 48.6001 499.91 48.5301 499.91 48.4801C499.91 48.4001 499.92 48.3301 499.93 48.2501C499.87 48.2901 499.81 48.3201 499.75 48.3401C499.63 48.3801 499.49 48.3701 499.38 48.3001V48.3201C499.38 48.4401 499.37 48.5601 499.33 48.6801C499.28 48.8401 499.15 48.9601 498.99 49.0001C498.83 49.0301 498.66 48.9701 498.55 48.8401C498.52 48.7801 498.46 48.7401 498.39 48.7301C498.3 48.7101 498.22 48.6701 498.15 48.6201C498.13 48.6501 498.1 48.6701 498.08 48.7001C498.16 48.9601 498.13 49.2401 498 49.4801C497.94 49.5701 497.87 49.6601 497.8 49.7401C497.76 49.7901 497.72 49.8301 497.68 49.8801C497.66 50.0801 497.5 50.2401 497.3 50.2701C497.48 50.4201 497.52 50.6801 497.38 50.8801C497.31 50.9701 497.22 51.0501 497.12 51.1201V51.1601C497.1 51.3201 497.05 51.4801 496.98 51.6201C496.9 51.7401 496.84 51.8801 496.79 52.0101C496.71 52.1901 496.58 52.3501 496.42 52.4601L496.38 52.4901V52.5501C496.4 52.6601 496.4 52.7701 496.38 52.8801C496.48 52.8801 496.57 52.9301 496.65 52.9901C496.7 53.0301 496.74 53.0801 496.77 53.1301C496.88 53.0801 497.01 53.0401 497.13 53.0301C497.16 53.0301 497.19 53.0301 497.22 53.0201C497.45 52.9401 497.71 52.9901 497.9 53.1501C498.03 53.2801 498.09 53.4701 498.03 53.6501C497.97 53.8001 497.88 53.9401 497.78 54.0701C497.72 54.1401 497.67 54.2101 497.62 54.2901C497.55 54.4101 497.41 54.5001 497.27 54.5101C497.13 54.5201 496.98 54.4601 496.89 54.3501C496.87 54.3201 496.85 54.3001 496.83 54.2701C496.73 54.3501 496.62 54.4201 496.51 54.4801C496.48 54.5601 496.43 54.6201 496.36 54.6801C496.23 54.7901 496.11 54.9001 495.99 55.0201C495.99 55.0401 495.99 55.0601 495.99 55.0801C496.04 55.0801 496.08 55.0901 496.12 55.1101C496.26 55.1601 496.38 55.2601 496.46 55.4001C496.59 55.4901 496.66 55.6301 496.66 55.7801C496.66 55.9301 496.59 56.0801 496.46 56.1601C496.41 56.2701 496.32 56.3501 496.21 56.4001C496.18 56.5501 496.12 56.6901 496.03 56.8201C496.15 56.9301 496.22 57.0801 496.23 57.2401C496.23 57.3001 496.26 57.3501 496.28 57.4101C496.36 57.5901 496.4 57.7901 496.38 57.9901C496.36 58.1501 496.25 58.2901 496.1 58.3501C495.95 58.4101 495.78 58.3901 495.65 58.2901C495.59 58.2601 495.53 58.2401 495.47 58.2301H495.45C495.45 58.2901 495.46 58.3501 495.46 58.4201C495.46 58.6601 495.42 58.8901 495.34 59.1201C495.37 59.1401 495.39 59.1501 495.42 59.1801C495.56 59.3101 495.61 59.5201 495.54 59.7001V59.7401C495.57 59.8201 495.59 59.9201 495.58 60.0101L495.63 59.9201ZM491.27 52.3101V52.3301C491.27 52.3301 491.33 52.3901 491.36 52.4201C491.51 52.5501 491.62 52.7201 491.68 52.9101C491.69 52.9601 491.7 53.0101 491.7 53.0601C491.74 53.0601 491.78 53.0501 491.81 53.0401C491.83 53.0401 491.85 53.0401 491.87 53.0401L491.94 52.9401C491.98 52.8901 492.01 52.8401 492.05 52.7901C491.97 52.7501 491.91 52.7001 491.86 52.6301C491.82 52.5701 491.8 52.5001 491.79 52.4301C491.61 52.5201 491.4 52.4801 491.27 52.3401V52.3101ZM489.67 52.9801C489.67 52.9801 489.74 53.0101 489.77 53.0201L489.83 53.0401C489.83 53.0401 489.85 52.9501 489.87 52.9101C489.96 52.7101 490.15 52.5601 490.37 52.5201C490.37 52.4001 490.42 52.2901 490.48 52.2001C490.56 52.0901 490.68 52.0201 490.81 52.0001C490.94 51.9901 491.08 52.0401 491.17 52.1401C491.15 52.0901 491.14 52.0401 491.14 51.9901C491.11 51.9201 491.1 51.8401 491.1 51.7701C491.1 51.5201 491.29 51.3101 491.54 51.3001C491.59 51.3001 491.64 51.3001 491.69 51.3201C491.77 51.3001 491.85 51.2901 491.93 51.3101C491.88 51.2601 491.84 51.2001 491.81 51.1301C491.81 51.1301 491.76 51.1001 491.73 51.0701C491.61 50.9801 491.51 50.8701 491.43 50.7401C491.41 50.7401 491.38 50.7401 491.36 50.7401C491.23 50.7401 491.1 50.6801 491.02 50.5801C490.93 50.4801 490.9 50.3501 490.92 50.2101C490.94 50.1201 490.96 50.0101 490.98 49.9001H490.94C490.83 50.0601 490.68 50.1901 490.51 50.2601C490.49 50.2701 490.47 50.2801 490.45 50.3001C490.3 50.4201 490.11 50.4801 489.91 50.4801C489.87 50.6401 489.75 50.7801 489.6 50.8501L489.62 50.8901C489.68 51.0001 489.7 51.1201 489.67 51.2401C489.64 51.3601 489.56 51.4601 489.45 51.5201C489.31 51.5901 489.16 51.6501 489.01 51.7001C488.91 51.7301 488.81 51.7701 488.71 51.8201C488.64 51.8601 488.58 51.8901 488.52 51.9401C488.46 51.9801 488.4 52.0201 488.32 52.0701V52.1001C488.34 52.1601 488.35 52.2301 488.35 52.3001C488.37 52.3501 488.39 52.3901 488.41 52.4401C488.48 52.4801 488.55 52.5301 488.6 52.6001C488.73 52.4901 488.89 52.4301 489.06 52.4101C489.33 52.3901 489.57 52.5901 489.6 52.8501C489.61 52.9001 489.63 52.9601 489.66 53.0001L489.67 52.9801ZM492.7 51.5101C492.7 51.5101 492.75 51.5201 492.77 51.5301C492.79 51.5201 492.81 51.5101 492.83 51.5001V51.4801C492.83 51.4801 492.75 51.5001 492.7 51.5101ZM492.15 51.4201C492.15 51.4201 492.2 51.4801 492.22 51.5101C492.27 51.5001 492.32 51.4901 492.37 51.4901C492.3 51.4701 492.22 51.4501 492.15 51.4201ZM493.35 50.5801L493.49 50.9201H493.52L493.43 50.7701L493.52 50.9101C493.52 50.9101 493.55 50.9101 493.56 50.9001L493.35 50.5801H493.34H493.35ZM487.46 50.5401C487.43 50.6301 487.42 50.7101 487.44 50.8001C487.47 50.8501 487.52 50.8901 487.58 50.9101L487.46 50.5401ZM493.92 50.3301C493.97 50.4901 493.96 50.6601 493.92 50.8101C494 50.7601 494.1 50.7201 494.19 50.7001C494.36 50.6801 494.54 50.7001 494.71 50.7601C494.71 50.7301 494.73 50.7101 494.74 50.6801C494.73 50.6501 494.72 50.6301 494.71 50.6001C494.69 50.4701 494.71 50.3401 494.79 50.2301C494.81 50.2101 494.83 50.1801 494.85 50.1601C494.87 49.9801 494.98 49.8301 495.14 49.7501C495.26 49.6901 495.39 49.6901 495.51 49.7401C495.63 49.7901 495.72 49.8901 495.76 50.0101C495.85 49.9701 495.95 49.9501 496.04 49.9701H496.06C496.06 49.9701 496.03 49.9101 496.01 49.8801C495.94 49.7901 495.9 49.6801 495.91 49.5601C495.77 49.5701 495.47 49.5501 495.4 49.0701V48.9901C495.33 48.7501 495.47 48.5001 495.71 48.4301C495.87 48.4001 496.03 48.3901 496.18 48.4101C496.24 48.4101 496.3 48.4101 496.36 48.4101C496.51 48.3901 496.66 48.4301 496.77 48.5301L496.82 48.4601C496.82 48.4601 496.79 48.4001 496.78 48.3801L496.72 48.2501C496.6 48.0001 496.64 47.7101 496.84 47.5101V47.4701C496.86 47.2501 496.96 47.0501 497.14 46.9101L497.22 46.8601C497.32 46.7901 497.42 46.7201 497.52 46.6601C497.63 46.5901 497.76 46.5701 497.89 46.6001C498.11 46.7001 498.3 46.8601 498.42 47.0601C498.5 47.2401 498.54 47.4301 498.54 47.6301L498.69 47.5301C498.81 47.4501 498.96 47.4301 499.1 47.4801C499.12 47.4801 499.15 47.5001 499.17 47.5101C499.13 47.2901 499.19 47.0701 499.34 46.9001C499.5 46.7501 499.67 46.6301 499.86 46.5201C499.92 46.4901 499.98 46.4601 500.04 46.4301C500.06 46.4001 500.07 46.3601 500.09 46.3301C499.86 46.2301 499.7 46.0301 499.65 45.7901C499.64 45.4301 499.73 45.0701 499.92 44.7701C499.95 44.7201 499.99 44.6701 500.02 44.6301C500.08 44.5401 500.09 44.5301 500.09 44.5101C500.11 44.3901 500.14 44.2701 500.2 44.1601C500.21 44.1301 500.23 44.1001 500.24 44.0701L500.22 44.0101C500.15 43.8501 500.09 43.6801 500.07 43.5101C500.07 43.5201 500.02 43.4501 499.99 43.4101C499.87 43.2701 499.79 43.1101 499.75 42.9301C499.72 42.7701 499.78 42.6201 499.9 42.5101C499.96 42.4601 500.02 42.4201 500.09 42.3901C500.09 42.2901 500.08 42.1901 500.06 42.1001C500.04 41.9101 500.06 41.7201 500.14 41.5501C500.16 41.5101 500.17 41.4601 500.18 41.4201C500.18 41.4201 500.14 41.3401 500.12 41.2901C500.03 41.1301 499.98 40.9601 499.97 40.7801V40.6401C499.96 40.4601 499.97 40.2701 499.98 40.0901C500 39.9201 500.05 39.7601 500.12 39.6101C500.15 39.5501 500.17 39.4801 500.19 39.4201C500.19 39.4201 500.17 39.3401 500.15 39.2901C500.11 39.1501 500.08 39.0101 500.08 38.8601C499.95 38.8301 499.85 38.7401 499.79 38.6201C499.73 38.5001 499.73 38.3601 499.79 38.2401C499.87 38.0301 500.05 37.8801 500.26 37.8401C500.28 37.8401 500.31 37.8201 500.34 37.8001C500.38 37.7801 500.43 37.7601 500.48 37.7401C500.51 37.7201 500.54 37.7101 500.57 37.7001C500.58 37.5201 500.65 37.3401 500.77 37.2001C500.78 37.1801 500.8 37.1601 500.81 37.1401C500.8 36.9901 500.81 36.8301 500.85 36.6801C500.88 36.5601 500.94 36.4601 501.01 36.3701C500.95 36.3101 500.89 36.2401 500.84 36.1701C500.74 36.0001 500.71 35.8001 500.77 35.6101C500.77 35.6001 500.77 35.5801 500.77 35.5701C500.76 35.5501 500.75 35.5301 500.74 35.5101C500.64 35.3301 500.61 35.1301 500.65 34.9301C500.7 34.7701 500.79 34.6201 500.91 34.5101C500.93 34.4901 500.95 34.4701 500.97 34.4401C500.99 34.3801 501.03 34.3001 501.07 34.2301C501.09 34.1901 501.11 34.1501 501.13 34.1101L501.11 34.0701C501.03 33.9501 500.97 33.8101 500.95 33.6701C500.93 33.5401 500.91 33.4201 500.89 33.2901L500.85 33.0701C500.83 32.9601 500.8 32.8601 500.77 32.7601C500.74 32.6801 500.72 32.5901 500.7 32.5101C500.67 32.4001 500.63 32.2901 500.58 32.1901C500.55 32.1301 500.52 32.0601 500.5 32.0001C500.45 31.8601 500.42 31.7101 500.42 31.5701C500.42 31.5301 500.42 31.4801 500.41 31.4401L500.34 31.3501C500.19 31.1801 500.09 30.9801 500.03 30.7601C499.99 30.5101 500.08 30.2501 500.25 30.0601C500.27 30.0301 500.3 30.0001 500.31 29.9701C500.31 29.9201 500.32 29.8301 500.33 29.7501C500.33 29.7301 500.33 29.7101 500.33 29.6901C500.21 29.6601 500.1 29.6001 500 29.5201C499.9 29.4301 499.85 29.2901 499.86 29.1601C499.87 29.0301 499.94 28.9001 500.05 28.8201C500.07 28.8101 500.08 28.8001 500.1 28.7901C500.12 28.7201 500.15 28.6401 500.18 28.5701C500.19 28.5401 500.2 28.5201 500.21 28.4901V28.4601C500.1 28.2901 500.07 28.0901 500.1 27.9001C500.13 27.7501 500.2 27.6101 500.29 27.4901C500.15 27.3201 500.06 27.1101 500.04 26.8901C500.04 26.7401 500.07 26.6001 500.14 26.4701C499.93 26.4301 499.74 26.3101 499.62 26.1201C499.6 26.0901 499.58 26.0601 499.56 26.0201C499.46 26.1401 499.34 26.2501 499.21 26.3301C499.17 26.3601 499.12 26.3901 499.09 26.4201C498.95 26.5201 498.79 26.5801 498.62 26.6001C498.58 26.6001 498.54 26.6101 498.5 26.6301C498.45 26.6601 498.41 26.6901 498.36 26.7201C498.24 26.8101 498.11 26.8801 497.98 26.9201C497.86 26.9601 497.75 26.9901 497.63 27.0101C497.63 27.0601 497.61 27.1101 497.59 27.1501C497.54 27.2701 497.44 27.3601 497.31 27.4001C497.17 27.4401 497.02 27.4201 496.9 27.3401C496.88 27.3301 496.87 27.3101 496.85 27.3001C496.69 27.2901 496.54 27.2001 496.45 27.0601C496.39 26.9701 496.37 26.8501 496.39 26.7401C496.35 26.7501 496.3 26.7701 496.25 26.7801C496.23 26.8801 496.2 26.9901 496.16 27.0801C496.16 27.0801 496.18 27.1201 496.19 27.1401C496.24 27.2601 496.24 27.3901 496.19 27.5101C496.19 27.7601 496.04 27.9801 495.83 28.1001C495.65 28.1801 495.44 28.1901 495.26 28.1201C495.26 28.1501 495.26 28.1901 495.26 28.2201C495.27 28.4301 495.29 28.8301 494.94 28.9801C494.68 29.0601 494.4 28.9601 494.25 28.7401L494.51 28.3601L494.18 28.6701C494.1 28.5801 494.02 28.5001 493.92 28.4201C493.84 28.4001 493.76 28.3901 493.69 28.3901C493.63 28.5601 493.54 28.7001 493.41 28.8201C493.4 28.8301 493.39 28.8501 493.38 28.8601C493.34 28.9201 493.3 28.9801 493.25 29.0301C493.23 29.1501 493.17 29.2501 493.07 29.3201C493.08 29.3501 493.1 29.3701 493.11 29.4001C493.16 29.4301 493.21 29.4801 493.26 29.5201C493.39 29.5701 493.48 29.6701 493.52 29.8001C493.61 29.7601 493.7 29.7201 493.79 29.7001C493.91 29.6501 494.04 29.6501 494.16 29.7001C494.28 29.7401 494.37 29.8301 494.42 29.9501C494.49 30.1701 494.47 30.4001 494.36 30.6001C494.26 30.7301 494.11 30.8001 493.95 30.7901C493.87 30.7901 493.79 30.7501 493.72 30.7001H493.7C493.55 30.6801 493.41 30.6101 493.32 30.4801C493.3 30.5001 493.28 30.5301 493.26 30.5501C493.21 30.6001 493.14 30.6501 493.07 30.6701C493.12 30.7301 493.16 30.8001 493.2 30.8701C493.27 30.8701 493.35 30.8701 493.42 30.8901C493.57 30.9301 493.71 31.0001 493.83 31.1001C493.86 31.1301 493.9 31.1501 493.94 31.1701C494.1 31.2301 494.22 31.3901 494.22 31.5601C494.22 31.7401 494.13 31.9001 493.98 31.9801C493.88 32.0401 493.77 32.0901 493.66 32.1301C493.7 32.1501 493.75 32.1801 493.78 32.2101C493.98 32.4401 494.1 32.7201 494.15 33.0201C494.17 33.1401 494.19 33.2601 494.2 33.3801C494.21 33.4701 494.22 33.5701 494.24 33.6501C494.25 33.7201 494.26 33.7901 494.26 33.8601C494.39 33.8401 494.52 33.8701 494.62 33.9501C494.65 33.9501 494.68 33.9501 494.72 33.9501C494.85 33.9301 494.99 33.9301 495.12 33.9301C495.22 33.9301 495.31 33.9301 495.4 33.9301C495.42 33.8601 495.46 33.7901 495.5 33.7201C495.52 33.6301 495.57 33.5401 495.65 33.4801C495.74 33.4101 495.85 33.3701 495.96 33.3701C496.01 33.3701 496.06 33.3701 496.1 33.3701C496.24 33.3901 496.37 33.4701 496.44 33.5901C496.51 33.7101 496.52 33.8701 496.46 34.0001C496.42 34.0901 496.36 34.1701 496.3 34.2501C496.35 34.3801 496.39 34.5101 496.4 34.6501C496.4 34.6701 496.4 34.7001 496.41 34.7201C496.5 34.8901 496.51 35.0901 496.43 35.2601C496.36 35.4001 496.22 35.5001 496.07 35.5401C496 35.6601 495.91 35.7601 495.79 35.8401C495.75 35.8901 495.7 35.9301 495.65 35.9701C495.63 36.0001 495.61 36.0301 495.58 36.0601C495.53 36.1101 495.48 36.1601 495.44 36.2201C495.44 36.2601 495.44 36.3001 495.44 36.3401C495.48 36.4401 495.5 36.5401 495.49 36.6501C495.51 36.7701 495.51 36.8901 495.49 37.0101C495.49 37.0401 495.49 37.0601 495.49 37.0901C495.49 37.0701 495.55 37.1201 495.59 37.1601C495.66 37.2201 495.72 37.2801 495.78 37.3501C495.82 37.4001 495.83 37.4101 495.97 37.4401C496.33 37.5101 496.36 37.8701 496.38 38.1101C496.38 38.1601 496.38 38.2201 496.39 38.2501C496.41 38.3701 496.39 38.5001 496.31 38.6001C496.28 38.6401 496.25 38.6701 496.21 38.7001C496.24 38.7501 496.25 38.8101 496.26 38.8701C496.26 38.9001 496.26 38.9201 496.26 38.9501C496.26 39.0001 496.26 39.0601 496.24 39.1101C496.28 39.3601 496.14 39.6101 495.9 39.7001C495.82 39.7301 495.74 39.7401 495.66 39.7201C495.54 39.8301 495.41 39.9201 495.26 39.9701C495.38 40.0701 495.47 40.2001 495.53 40.3501C495.55 40.3701 495.57 40.3901 495.6 40.4101C495.8 40.5401 495.93 40.7501 495.97 40.9801C495.97 41.2001 495.88 41.4101 495.73 41.5701L495.7 41.6101C495.73 41.7101 495.78 41.8101 495.83 41.9101C495.91 42.0401 495.93 42.2001 495.88 42.3501C495.85 42.4401 495.8 42.5101 495.74 42.5701L495.78 42.6201C495.92 42.8201 495.96 43.0701 495.89 43.3001C495.82 43.5401 495.64 43.7301 495.41 43.8201C495.27 43.8701 495.11 43.8701 494.97 43.8201C494.97 43.8501 494.99 43.8901 495 43.9201C495.05 44.0701 495.08 44.2301 495.08 44.3901C495.08 44.6001 495.03 44.8201 494.97 45.0201C494.9 45.2601 494.8 45.4901 494.66 45.6901C494.66 45.6901 494.66 45.7301 494.66 45.7801C494.66 46.0201 494.58 46.2401 494.42 46.4201C494.28 46.5401 494.13 46.6201 493.95 46.6701C493.89 46.6901 493.84 46.7101 493.78 46.7401C493.73 46.7701 493.68 46.8101 493.64 46.8501C493.52 46.9601 493.39 47.0501 493.24 47.1201H493.21C493.17 47.6601 492.63 47.7801 492.43 47.8301C492.39 47.8301 492.35 47.8501 492.31 47.8601C492.31 47.8601 492.27 47.9601 492.24 48.0201C492.22 48.0701 492.2 48.1201 492.17 48.1601C492.28 48.2301 492.36 48.3501 492.38 48.4801C492.4 48.6101 492.36 48.7401 492.27 48.8401C492.24 48.8901 492.22 48.9401 492.21 48.9901C492.2 49.0301 492.18 49.0601 492.17 49.1001C492.18 49.1401 492.19 49.1801 492.21 49.2201C492.22 49.2801 492.24 49.3401 492.27 49.3901C492.32 49.4901 492.38 49.5801 492.44 49.6701C492.47 49.7201 492.5 49.7701 492.53 49.8201C492.56 49.8201 492.59 49.8201 492.62 49.8301C492.7 49.8301 492.78 49.8501 492.86 49.8701C492.86 49.7801 492.89 49.7001 492.92 49.6201C492.99 49.4601 493.15 49.3501 493.33 49.3501C493.45 49.3501 493.57 49.4001 493.66 49.4901C493.82 49.5301 493.96 49.6301 494.04 49.7801C494.1 49.9301 494.07 50.1101 493.96 50.2301L493.93 50.2601L493.92 50.3301ZM488.24 49.9101C488.29 49.8701 488.35 49.8301 488.4 49.7901C488.38 49.7901 488.36 49.7901 488.34 49.7901C488.31 49.8301 488.28 49.8601 488.25 49.9001L488.24 49.9101ZM489.9 49.3301C489.9 49.3301 489.9 49.3901 489.92 49.4101C489.92 49.4201 489.97 49.4701 490.01 49.5001H490.03C490.03 49.5001 490 49.4601 489.99 49.4401C489.96 49.4001 489.93 49.3701 489.91 49.3301H489.9ZM477.42 38.3701C477.51 38.3701 477.6 38.3801 477.69 38.4101C477.88 38.4601 478.04 38.5901 478.13 38.7601C478.17 38.6201 478.27 38.5001 478.41 38.4401C478.23 38.4701 478.05 38.4601 477.89 38.3901C477.75 38.3301 477.66 38.2001 477.63 38.0501C477.61 37.9001 477.67 37.7501 477.78 37.6501C477.79 37.6401 477.82 37.6001 477.84 37.5701C477.89 37.5001 477.94 37.4401 478 37.3801L477.98 37.3101C477.88 37.0701 477.9 36.7901 478.03 36.5701C478.17 36.3701 478.39 36.2501 478.63 36.2401C478.68 36.2401 478.72 36.2401 478.76 36.2401C478.76 36.2201 478.77 36.2001 478.78 36.1701C478.82 35.9901 478.92 35.8301 479.05 35.7001C479.08 35.6701 479.1 35.6401 479.12 35.6101C479.22 35.2501 479.5 34.9701 479.86 34.8801C480.13 34.8101 480.41 34.8101 480.68 34.8801V34.8301C480.71 34.6601 480.8 34.5001 480.94 34.3901C480.79 34.2601 480.69 34.0901 480.65 33.8901C480.63 33.7501 480.63 33.6101 480.66 33.4701C480.63 33.4401 480.6 33.4001 480.58 33.3601C480.59 33.3901 480.55 33.3601 480.52 33.3501C480.34 33.2701 480.2 33.1201 480.14 32.9401C480.14 32.9101 480.12 32.8701 480.12 32.8401C480.03 32.8301 479.95 32.7901 479.89 32.7301C479.81 32.6501 479.75 32.5401 479.75 32.4201C479.63 32.2701 479.6 32.0701 479.66 31.8901C479.7 31.7801 479.79 31.6901 479.9 31.6401C480.01 31.5901 480.14 31.5901 480.25 31.6401L480.58 31.7901C480.58 31.7901 480.66 31.8301 480.7 31.8701C480.75 31.8401 480.8 31.8101 480.84 31.7801C480.89 31.7501 480.95 31.7201 481.01 31.6801C481.08 31.6401 481.16 31.6101 481.24 31.5901C481.42 31.4501 481.65 31.3801 481.88 31.3901H481.97C482.25 31.3501 482.52 31.4301 482.74 31.6101C482.78 31.6501 482.82 31.6901 482.86 31.7401C482.9 31.7001 482.94 31.6601 482.98 31.6201C482.97 31.5901 482.96 31.5601 482.95 31.5301C482.94 31.5001 482.93 31.4701 482.92 31.4401C482.8 31.4801 482.67 31.4601 482.56 31.4001C482.45 31.3401 482.37 31.2301 482.35 31.1001L482.33 31.0601C482.22 30.8801 482.21 30.6601 482.29 30.4601C482.32 30.3601 482.35 30.2501 482.36 30.1501C482.39 29.9801 482.44 29.8301 482.53 29.6801H482.5C482.41 29.6701 482.33 29.6301 482.26 29.5701C482.11 29.5601 481.97 29.4701 481.89 29.3401C481.81 29.2101 481.81 29.0401 481.88 28.9001C481.99 28.7301 482.15 28.6201 482.35 28.5801C482.47 28.5301 482.61 28.5201 482.73 28.5801C482.85 28.6301 482.95 28.7201 483 28.8401C483.04 28.9801 483.05 29.1301 483.01 29.2801C483.1 29.2801 483.19 29.2901 483.26 29.3301C483.39 29.4001 483.48 29.5401 483.5 29.6901C483.52 29.8701 483.48 30.0401 483.4 30.2001C483.4 30.3801 483.36 30.5601 483.29 30.7201C483.29 30.7401 483.28 30.7501 483.27 30.7601C483.41 30.7401 483.56 30.7501 483.7 30.7901C483.73 30.7901 483.76 30.8001 483.79 30.8101C483.93 30.8001 484.08 30.8101 484.21 30.8701C484.24 30.8801 484.27 30.8901 484.3 30.8901C484.55 30.8901 484.77 31.0501 484.85 31.2801C484.89 31.3901 484.88 31.5201 484.83 31.6301C484.78 31.7401 484.68 31.8201 484.56 31.8601C484.53 31.8701 484.5 31.8801 484.47 31.8901C484.52 31.9301 484.57 31.9801 484.6 32.0401C484.66 32.0401 484.73 32.0301 484.78 32.0201H484.83C484.93 31.9501 485.03 31.8901 485.15 31.8601C485.04 31.6901 485 31.4801 485.04 31.2801C485.04 31.2201 485.05 31.1501 485.05 31.0901C485.05 30.9501 485.06 30.8201 485.09 30.6901C485.13 30.5501 485.18 30.4201 485.25 30.3001C485.28 30.2501 485.31 30.1901 485.33 30.1301C485.4 29.9401 485.51 29.7701 485.67 29.6501C485.7 29.6301 485.72 29.6001 485.75 29.5701C485.75 29.5401 485.77 29.4701 485.79 29.4001C485.76 29.4001 485.73 29.4001 485.7 29.4001C485.66 29.4001 485.6 29.4001 485.55 29.4001C485.52 29.4001 485.49 29.4001 485.46 29.4001C485.23 29.4001 485.04 29.2301 485.01 29.0101C484.98 28.9401 484.97 28.8701 484.97 28.7901C484.97 28.6101 485.07 28.4401 485.24 28.3701C485.4 28.3001 485.6 28.3301 485.73 28.4501C485.89 28.4901 486.03 28.6001 486.11 28.7401C486.12 28.7601 486.13 28.7901 486.14 28.8201C486.27 28.7201 486.41 28.6501 486.55 28.5901C486.67 28.5501 486.8 28.5701 486.9 28.6301C487.01 28.6901 487.09 28.7901 487.12 28.9101C487.15 29.0701 487.12 29.2401 487.04 29.3801C487.16 29.4901 487.26 29.6301 487.33 29.7901L487.37 29.8901C487.43 30.0401 487.49 30.2001 487.53 30.3501C487.55 30.4001 487.58 30.4401 487.62 30.4801C487.72 30.6001 487.79 30.7301 487.84 30.8801C487.87 30.9701 487.89 31.0601 487.92 31.1501C487.94 31.2101 487.96 31.2701 487.97 31.3301C488.03 31.3501 488.08 31.3801 488.13 31.4001C488.18 31.4301 488.23 31.4501 488.29 31.4701C488.32 31.4501 488.35 31.4301 488.39 31.4101C488.54 31.3201 488.7 31.2601 488.87 31.2401C489 31.2401 489.13 31.2401 489.26 31.2501C489.34 31.2601 489.41 31.2601 489.49 31.2601C489.67 31.2601 489.86 31.2901 490.03 31.3601C490.05 31.3601 490.07 31.3801 490.1 31.3901C490.13 31.3701 490.15 31.3401 490.18 31.3201C490.26 31.2401 490.34 31.1701 490.43 31.1101C490.43 31.0501 490.43 30.9901 490.42 30.9301C490.42 30.8201 490.41 30.7201 490.4 30.6601C490.38 30.6001 490.38 30.5401 490.39 30.4701C490.21 30.3801 490.11 30.1901 490.14 29.9901C490.16 29.8701 490.2 29.7601 490.25 29.6601C490.08 29.5001 489.98 29.2901 489.96 29.0601V29.0201C489.91 28.9401 489.87 28.8601 489.86 28.7701C489.81 28.6701 489.81 28.5501 489.84 28.4501C489.8 28.2901 489.81 28.1201 489.85 27.9701C489.87 27.9101 489.89 27.8401 489.9 27.7701C489.9 27.7501 489.9 27.7301 489.91 27.7101C489.86 27.5801 489.84 27.4301 489.84 27.2901C489.84 27.2601 489.84 27.2301 489.84 27.2001C489.81 27.2001 489.77 27.2201 489.74 27.2301C489.63 27.2701 489.51 27.3001 489.4 27.3101C489.33 27.3101 489.25 27.3101 489.18 27.3001C489.18 27.4601 489.12 27.6101 488.99 27.7101C488.92 27.7601 488.83 27.7901 488.75 27.7901H488.72C488.59 27.8801 488.42 27.8901 488.28 27.8301C488.24 28.0001 488.09 28.1201 487.92 28.1401C487.7 28.1401 487.5 28.0201 487.41 27.8201C487.35 27.7601 487.28 27.7001 487.21 27.6501C487.11 27.5801 487.02 27.5001 486.93 27.4201C486.86 27.3601 486.78 27.3001 486.7 27.2401C486.66 27.2101 486.62 27.1801 486.57 27.1501C486.52 27.2701 486.43 27.3701 486.31 27.4201C486.18 27.4801 486.03 27.4901 485.88 27.4701C485.77 27.5201 485.64 27.5101 485.53 27.4501C485.54 27.4501 485.51 27.4601 485.48 27.4701C485.34 27.4901 485.2 27.4701 485.06 27.4201C485.03 27.4101 485 27.3901 484.97 27.3701C484.83 27.4701 484.68 27.5401 484.52 27.6001C484.47 27.6201 484.42 27.6401 484.37 27.6601C484.32 27.6901 484.27 27.7201 484.22 27.7601C484.05 27.8901 483.85 27.9801 483.64 28.0301C483.4 28.0601 483.16 27.9801 482.97 27.8301C482.94 27.8101 482.89 27.7801 482.86 27.7601C482.77 27.7601 482.67 27.7801 482.58 27.7901C482.46 27.8001 482.34 27.8101 482.22 27.8201C482.11 27.8201 482.01 27.8601 481.92 27.9201C481.81 28.0901 481.64 28.2201 481.45 28.2901C481.38 28.3301 481.3 28.3601 481.23 28.3801C481.23 28.4201 481.23 28.4601 481.23 28.4901C481.34 28.6501 481.34 28.8701 481.22 29.0201C481.1 29.1801 480.9 29.2401 480.71 29.1901C480.66 29.1701 480.6 29.1601 480.54 29.1501H480.51C480.51 29.1501 480.51 29.2401 480.51 29.3001C480.6 29.3101 480.68 29.3501 480.75 29.4101C480.84 29.4201 480.92 29.4401 481 29.4601H481.05C481.11 29.4601 481.17 29.4601 481.23 29.4801C481.26 29.4801 481.29 29.4901 481.32 29.5101C481.46 29.5401 481.58 29.6301 481.64 29.7601C481.7 29.8901 481.69 30.0401 481.62 30.1701C481.53 30.3201 481.38 30.4101 481.21 30.4201C481.16 30.4201 481.1 30.4201 481.06 30.3901C481.04 30.3901 481.02 30.4101 481.01 30.4101C480.82 30.5001 480.61 30.5301 480.41 30.5001C480.26 30.4701 480.15 30.3601 480.09 30.2201C480.03 30.2201 479.97 30.2201 479.91 30.2001V30.2901C479.89 30.4401 479.87 30.5901 479.85 30.7401C479.81 30.9201 479.76 31.1001 479.69 31.2801C479.62 31.4401 479.47 31.5401 479.3 31.5501C479.24 31.5501 479.17 31.5501 479.11 31.5201C478.92 31.6501 478.71 31.7401 478.5 31.8201C478.29 31.8701 478.07 31.8501 477.87 31.7701C477.83 31.7501 477.78 31.7401 477.74 31.7301C477.69 31.7301 477.65 31.7501 477.6 31.7601C477.67 31.9101 477.65 32.0901 477.55 32.2201C477.51 32.3301 477.43 32.4201 477.34 32.4701C477.15 32.5701 476.91 32.5401 476.74 32.4001C476.72 32.3901 476.69 32.3701 476.66 32.3501C476.62 32.3701 476.56 32.4101 476.52 32.4401L476.4 32.5101C476.27 32.5801 476.12 32.6301 475.97 32.6501C475.91 32.6501 475.86 32.6701 475.81 32.6901V32.7101C475.81 32.7101 475.9 32.7401 475.94 32.7601C475.97 32.7801 475.99 32.7901 476.01 32.8101C476.17 32.8201 476.32 32.9101 476.41 33.0401C476.49 33.1601 476.51 33.3101 476.45 33.4501C476.4 33.5901 476.28 33.6901 476.14 33.7201C475.97 33.8101 475.77 33.8401 475.58 33.8101C475.58 33.8201 475.56 33.8401 475.55 33.8501C475.45 33.9801 475.34 34.1001 475.22 34.2101C475.23 34.2101 475.25 34.2201 475.26 34.2301C475.36 34.1501 475.47 34.0801 475.59 34.0401C475.87 33.9401 476.18 33.9201 476.47 34.0001C476.69 34.0801 476.84 34.2701 476.87 34.4901C476.87 34.5101 476.87 34.5201 476.87 34.5101C476.94 34.6201 476.96 34.7501 476.93 34.8701C476.9 34.9901 476.82 35.1001 476.71 35.1501C476.6 35.2101 476.47 35.2301 476.34 35.2101C476.21 35.3601 476.02 35.4501 475.83 35.4601C475.71 35.4601 475.59 35.4401 475.47 35.4101H475.42C475.29 35.5901 475.07 35.6901 474.85 35.6701C474.87 35.7401 474.9 35.8001 474.93 35.8501C475.06 36.0301 475.07 36.2701 474.96 36.4601C474.85 36.6101 474.67 36.7001 474.49 36.6801C474.61 36.8101 474.67 37.0001 474.64 37.1801C474.58 37.4001 474.4 37.5801 474.17 37.6301C474.15 37.6301 474.12 37.6501 474.1 37.6601V37.6801C474.1 37.6801 474.18 37.7801 474.22 37.8301C474.41 37.6801 474.67 37.6301 474.9 37.6901C475.04 37.7301 475.17 37.7801 475.28 37.8601C475.33 37.8901 475.38 37.9201 475.44 37.9301C475.63 37.9801 475.79 38.1001 475.91 38.2501C476.1 38.0901 476.37 38.0301 476.61 38.1001C476.8 38.1501 476.96 38.2601 477.08 38.4101L477.14 38.4501C477.25 38.4201 477.35 38.4001 477.46 38.4001L477.42 38.3701ZM492.17 31.0501C492.17 31.0501 492.17 31.1101 492.17 31.1301C492.17 31.2301 492.19 31.3301 492.21 31.4201H492.25C492.27 31.3601 492.3 31.3001 492.32 31.2501L492.29 31.2201C492.24 31.1701 492.2 31.1101 492.16 31.0501H492.17ZM491.77 30.4501L492.21 30.5401L491.77 30.4501ZM493.61 30.1201C493.61 30.1201 493.55 30.2201 493.54 30.2801L493.68 30.2401V30.1901L493.61 30.1201ZM480.35 29.1401C480.35 29.1401 480.4 29.2101 480.41 29.2401C480.41 29.2401 480.37 29.1701 480.34 29.1401H480.35ZM492.74 28.1401C492.74 28.1401 492.78 28.1801 492.8 28.2001C492.82 28.1701 492.83 28.1401 492.84 28.1001C492.84 28.0801 492.86 28.0601 492.87 28.0301C492.83 28.0701 492.78 28.1101 492.74 28.1401ZM491.07 27.3101C491.02 27.3801 490.99 27.4701 491 27.5601C491 27.4701 491.02 27.3801 491.07 27.3101ZM497.79 59.2601C497.55 59.2601 497.35 59.0701 497.34 58.8201C497.34 58.7201 497.34 58.6101 497.37 58.5101C497.37 58.4601 497.39 58.4101 497.39 58.3501C497.39 58.2101 497.45 58.0701 497.57 57.9801C497.69 57.8901 497.84 57.8701 497.97 57.9101C498.05 57.9301 498.13 57.9701 498.19 58.0301C498.3 58.1001 498.38 58.2101 498.41 58.3401C498.44 58.4701 498.41 58.6001 498.32 58.7101C498.29 58.8701 498.21 59.0301 498.09 59.1401C498.01 59.2101 497.9 59.2501 497.79 59.2501V59.2601ZM498.44 37.0901C498.36 37.0901 498.28 37.0701 498.21 37.0201C498.03 36.9101 497.89 36.7501 497.81 36.5501C497.76 36.3901 497.8 36.2201 497.9 36.1001C497.94 36.0201 498.01 35.9401 498.09 35.9001C498.24 35.7601 498.46 35.7201 498.65 35.8001C498.84 35.8701 498.97 36.0501 498.99 36.2501C498.99 36.3801 498.96 36.5201 498.91 36.6401C498.9 36.6701 498.89 36.7001 498.88 36.7301C498.85 36.8701 498.75 36.9901 498.62 37.0501C498.56 37.0701 498.5 37.0901 498.44 37.0901ZM495.04 33.9201C494.93 33.9201 494.82 33.8801 494.73 33.8101C494.6 33.7701 494.5 33.6701 494.46 33.5401C494.42 33.4101 494.43 33.2701 494.49 33.1601C494.52 33.1101 494.55 33.0601 494.59 33.0201C494.66 32.9001 494.78 32.8201 494.92 32.8101C495.06 32.8001 495.2 32.8601 495.29 32.9601C495.33 33.0101 495.37 33.0701 495.41 33.1301C495.5 33.2301 495.55 33.3701 495.53 33.5101C495.51 33.6501 495.43 33.7701 495.31 33.8401C495.23 33.8901 495.13 33.9101 495.04 33.9101V33.9201ZM496.28 32.7901C496.18 32.7901 496.09 32.7601 496.01 32.7101C495.84 32.5801 495.68 32.4401 495.53 32.2901L495.39 32.1601C495.27 32.0501 495.22 31.8701 495.27 31.7101C495.32 31.5501 495.45 31.4301 495.61 31.3901C495.58 31.3901 495.61 31.3801 495.64 31.3601C495.53 31.2701 495.46 31.1401 495.46 31.0001C495.46 30.8801 495.49 30.7601 495.58 30.6701C495.66 30.5801 495.78 30.5301 495.9 30.5201C496.17 30.4901 496.39 30.4601 496.56 30.6401C496.72 30.8301 496.75 31.0901 496.64 31.3101C496.63 31.3401 496.62 31.3701 496.6 31.4001C496.63 31.4301 496.66 31.4501 496.69 31.4801C496.73 31.5201 496.77 31.5501 496.82 31.5801C497.01 31.6501 497.13 31.8501 497.1 32.0501C497.08 32.1801 497.02 32.3001 496.91 32.3801C496.87 32.4101 496.82 32.4401 496.77 32.4501V32.4701C496.68 32.6301 496.54 32.7501 496.37 32.8001C496.34 32.8001 496.31 32.8101 496.28 32.8101V32.7901ZM495.8 31.1001C495.8 31.1001 495.84 31.1901 495.87 31.2301H495.9V31.1301L495.8 31.1001ZM488.89 31.0601C488.77 31.0601 488.65 31.0201 488.56 30.9401C488.45 30.8301 488.37 30.6901 488.31 30.5501C488.29 30.5101 488.27 30.4601 488.25 30.4201C488.1 30.2201 488.09 29.9401 488.22 29.7301C488.24 29.7001 488.27 29.6701 488.29 29.6501C488.16 29.6201 488.04 29.5601 487.94 29.4701C487.84 29.3801 487.79 29.2501 487.79 29.1201C487.79 28.9901 487.86 28.8601 487.96 28.7801L488.49 28.3701C488.68 28.2201 488.97 28.2501 489.12 28.4401C489.2 28.5401 489.26 28.6601 489.31 28.7801C489.32 28.8101 489.33 28.8301 489.34 28.8501C489.42 28.9501 489.45 29.0701 489.43 29.2001C489.41 29.3201 489.33 29.4301 489.22 29.5001C489.11 29.5701 488.99 29.6101 488.86 29.6301C488.94 29.6701 489.03 29.7201 489.12 29.7701C489.21 29.8201 489.3 29.8701 489.39 29.9201C489.51 29.9801 489.6 30.0901 489.63 30.2301C489.66 30.3601 489.63 30.5001 489.54 30.6101C489.46 30.7001 489.37 30.7901 489.28 30.8601C489.26 30.8801 489.23 30.9001 489.22 30.9101C489.13 31.0001 489.02 31.0501 488.89 31.0601ZM496.81 29.4301C496.51 29.3901 496.25 29.2301 496.09 28.9701C496.08 28.7401 496.18 28.5201 496.36 28.3801C496.48 28.2301 496.67 28.1601 496.86 28.1801C497.04 28.2201 497.2 28.3501 497.27 28.5201C497.43 28.6701 497.46 28.9001 497.35 29.0801C497.3 29.1701 497.21 29.2501 497.12 29.2901C497.04 29.3701 496.93 29.4201 496.81 29.4201V29.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.15 46.5701C498.15 46.6201 498.17 46.73 498.16 46.79C498.14 46.75 498.22 46.64 498.21 46.6C498.21 46.59 498.12 46.5901 498.15 46.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.16 47.24C497.98 47.24 497.81 47.1301 497.74 46.9601C497.71 46.8901 497.7 46.8201 497.71 46.7501C497.71 46.7201 497.71 46.69 497.71 46.67C497.68 46.48 497.76 46.3001 497.91 46.2001C498.05 46.1101 498.23 46.1101 498.38 46.2001L498.41 46.22C498.54 46.29 498.63 46.4 498.66 46.54C498.68 46.65 498.66 46.76 498.61 46.86C498.58 47.06 498.43 47.21 498.24 47.24C498.22 47.24 498.19 47.24 498.17 47.24H498.16ZM498.26 46.7501L498.39 46.9501L498.26 46.7501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.06 27.1702C496.06 27.1702 495.99 27.1202 495.96 27.1402C495.96 27.1202 496.02 27.2302 496.03 27.2202C496.04 27.2102 496.03 27.1802 496.06 27.1802V27.1702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.03 27.6602H496.01C495.87 27.6402 495.74 27.5702 495.65 27.4602C495.52 27.3402 495.48 27.1502 495.54 26.9802C495.6 26.8202 495.74 26.7102 495.91 26.6902C495.96 26.6902 496.01 26.6902 496.06 26.7002C496.1 26.7002 496.14 26.7202 496.17 26.7302C496.32 26.7902 496.43 26.9102 496.47 27.0602C496.51 27.2102 496.47 27.3702 496.38 27.4902C496.29 27.5902 496.17 27.6502 496.03 27.6502V27.6602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.77 33.54C494.77 33.54 495 33.6501 495.01 33.6501C494.99 33.6701 494.83 33.6701 494.81 33.6901C494.81 33.6701 494.76 33.55 494.77 33.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.8 34.1301C494.58 34.1301 494.4 33.9701 494.36 33.7601C494.26 33.5601 494.32 33.3101 494.5 33.1701C494.68 33.0601 494.91 33.0601 495.08 33.1901L495.14 33.2201C495.27 33.2701 495.38 33.3701 495.42 33.5101C495.46 33.6401 495.44 33.7901 495.36 33.9101C495.26 34.0401 495.1 34.1201 494.94 34.1201C494.96 34.1201 494.97 34.1101 494.98 34.1001C494.92 34.1301 494.86 34.1401 494.8 34.1401V34.1301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.56 31.5302C491.58 31.6302 491.1 31.5701 491.09 31.6801C491.07 31.5901 491.62 31.6301 491.61 31.5401C491.61 31.4901 491.09 31.9801 491.08 31.9301C491.12 31.9701 491.55 31.4901 491.56 31.5401V31.5302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.07 32.3701C490.97 32.3701 490.88 32.3301 490.81 32.2701C490.66 32.1501 490.59 31.9501 490.66 31.7701C490.66 31.7301 490.65 31.6801 490.66 31.6301C490.66 31.5301 490.71 31.4301 490.78 31.3501C490.87 31.2601 490.98 31.2001 491.1 31.1801C491.17 31.1601 491.24 31.1501 491.31 31.1501H491.32C491.4 31.0901 491.5 31.0601 491.6 31.0701C491.66 31.0701 491.71 31.0801 491.77 31.1001C491.92 31.1601 492.03 31.2901 492.06 31.4501C492.08 31.5801 492.05 31.7101 491.97 31.8201C491.91 31.9001 491.82 31.9601 491.73 31.9901C491.7 32.0201 491.67 32.0401 491.63 32.0701C491.5 32.2101 491.33 32.3201 491.14 32.3701C491.12 32.3701 491.1 32.3701 491.07 32.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.89 29.1401C485.89 29.1401 485.94 29.1101 485.93 29.1401C485.85 29.1001 485.65 28.9301 485.57 28.8901C485.66 28.8901 485.8 29.1301 485.9 29.1401H485.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.93 29.6001H485.9C485.82 29.6001 485.73 29.5801 485.66 29.5401C485.57 29.4901 485.48 29.4202 485.41 29.3402V29.3201C485.41 29.3201 485.37 29.3001 485.36 29.3001C485.17 29.2101 485.07 28.9901 485.12 28.7901C485.18 28.5801 485.37 28.4402 485.59 28.4602C485.74 28.4702 485.87 28.5401 485.97 28.6401L486.01 28.6701C486.01 28.6701 486.07 28.7101 486.09 28.7301C486.14 28.7501 486.18 28.7801 486.22 28.8101C486.36 28.9401 486.41 29.1501 486.33 29.3301C486.28 29.4401 486.19 29.5301 486.08 29.5701C486.03 29.5901 485.97 29.6001 485.92 29.6001H485.93Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.32 28.47C485.32 28.47 485.4 28.36 485.38 28.36C485.37 28.35 485.25 28.53 485.24 28.51C485.26 28.54 485.3 28.45 485.31 28.47H485.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.24 28.9601C485.24 28.9601 485.21 28.9601 485.2 28.9601C485.02 28.9401 484.87 28.8201 484.82 28.6501C484.76 28.4801 484.82 28.3001 484.94 28.1801C485.02 28.0401 485.16 27.9401 485.32 27.9101C485.51 27.8901 485.69 27.9801 485.77 28.1501C485.86 28.3201 485.83 28.5201 485.71 28.6601C485.69 28.7001 485.66 28.7502 485.63 28.7802C485.59 28.8202 485.54 28.8501 485.49 28.8801C485.47 28.8901 485.45 28.9101 485.42 28.9201C485.37 28.9501 485.32 28.9601 485.26 28.9601C485.25 28.9601 485.24 28.9601 485.22 28.9601H485.24Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.38 28.9901C485.38 28.9901 485.39 29.1602 485.38 29.2002C485.35 29.1702 485.19 28.9701 485.16 28.9401C485.2 28.8901 485.31 28.9901 485.38 28.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.38 29.6502C485.27 29.6502 485.16 29.6102 485.08 29.5302C485.06 29.5102 484.99 29.4301 484.92 29.3501C484.89 29.3101 484.86 29.2701 484.84 29.2501C484.69 29.0901 484.68 28.8501 484.81 28.6701C484.97 28.4601 485.26 28.4101 485.48 28.5501C485.71 28.6001 485.87 28.8101 485.84 29.0501C485.85 29.1501 485.84 29.2501 485.82 29.3501C485.76 29.5301 485.59 29.6601 485.39 29.6601L485.38 29.6502ZM485.39 29.1901V29.3202C485.44 29.2902 485.48 29.2602 485.52 29.2102L485.43 29.1502L485.39 29.1901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M475.65 36.4001C475.65 36.4001 475.65 36.3801 475.62 36.4101C475.56 36.3401 475.49 36.3502 475.43 36.2802C475.51 36.3202 475.56 36.3601 475.65 36.4001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M475.63 36.86C475.52 36.86 475.41 36.8201 475.33 36.7401C475.25 36.7001 475.17 36.6501 475.11 36.5801C474.97 36.4201 474.96 36.1801 475.09 36.0101C475.22 35.8401 475.45 35.7801 475.64 35.8801C475.69 35.9101 475.73 35.9301 475.78 35.9601C475.8 35.9701 475.83 35.9901 475.86 36.0001C475.99 36.0601 476.08 36.1801 476.11 36.3201C476.14 36.4601 476.09 36.6101 476 36.7101C475.93 36.7801 475.84 36.83 475.74 36.85C475.71 36.85 475.67 36.86 475.64 36.86H475.63Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.19 49.8101C489.25 49.7801 489.13 49.8601 489.19 49.8301C489.19 49.8301 489.24 49.8901 489.27 49.9101C489.19 49.9201 489.27 49.7901 489.19 49.8001V49.8101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.27 50.3702C489.16 50.3702 489.05 50.3302 488.96 50.2602C488.93 50.2402 488.91 50.2102 488.89 50.1802C488.86 50.1602 488.84 50.1302 488.82 50.1102C488.68 49.8802 488.74 49.5802 488.96 49.4402C489.16 49.3202 489.42 49.3602 489.57 49.5402C489.59 49.5602 489.6 49.5802 489.61 49.6102C489.61 49.6302 489.63 49.6402 489.63 49.6602C489.72 49.7702 489.75 49.9302 489.7 50.0702C489.65 50.2302 489.51 50.3502 489.35 50.3802C489.32 50.3802 489.3 50.3802 489.27 50.3802V50.3702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.18 50.4102C491.18 50.4102 491.13 50.3602 491.11 50.3302C491.2 50.3002 491.39 50.2002 491.48 50.1702C491.41 50.2202 491.25 50.3602 491.18 50.4102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.18 50.8601H491.15C491 50.8401 490.87 50.7601 490.79 50.6401C490.7 50.5201 490.67 50.3701 490.7 50.2201C490.74 50.0701 490.85 49.9501 490.99 49.9001C491.02 49.8901 491.07 49.8701 491.12 49.8401C491.2 49.8001 491.28 49.7701 491.37 49.7401C491.58 49.6801 491.8 49.7701 491.89 49.9601C491.98 50.1501 491.94 50.3801 491.77 50.5201C491.66 50.6101 491.51 50.7201 491.45 50.7701C491.37 50.8201 491.28 50.8501 491.19 50.8501L491.18 50.8601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.12 51.2601C492.12 51.2601 492.13 51.2701 492.15 51.2601L492.25 51.0001C492.29 51.0501 492.14 51.2301 492.12 51.2601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.15 51.7101C492.04 51.7101 491.93 51.6701 491.85 51.6001C491.71 51.4901 491.65 51.3201 491.69 51.1501C491.71 51.0901 491.74 51.0201 491.78 50.9701C491.81 50.8201 491.9 50.6901 492.02 50.6101C492.21 50.5001 492.45 50.5401 492.59 50.7101C492.74 50.9101 492.73 51.2001 492.57 51.3901C492.54 51.4701 492.49 51.5501 492.42 51.6001C492.34 51.6701 492.24 51.7001 492.13 51.7001L492.15 51.7101ZM491.83 51.1101C491.84 51.1701 491.87 51.2301 491.91 51.2801L492.01 51.1901L491.82 51.1101H491.83Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.25 46.9202C498.23 46.8702 498.28 47.0002 498.26 46.9402C498.31 46.9602 498.16 46.9102 498.2 46.9402C498.17 46.9702 498.27 46.8902 498.24 46.9202H498.25Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.28 47.4001C498.28 47.4001 498.18 47.4001 498.14 47.3801H498.13C498.03 47.3701 497.93 47.3201 497.86 47.2401C497.76 47.1101 497.72 46.9401 497.77 46.7801C497.8 46.6901 497.87 46.6201 497.95 46.5701C498.08 46.4501 498.28 46.4201 498.44 46.5101C498.5 46.5301 498.55 46.5701 498.6 46.6201C498.71 46.7601 498.74 46.9301 498.7 47.1001C498.68 47.1401 498.66 47.1801 498.63 47.2201C498.58 47.2901 498.5 47.3501 498.42 47.3801C498.38 47.3901 498.33 47.4001 498.28 47.4001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.48 45.9801C498.48 45.9801 498.39 45.9501 498.4 45.9001C498.43 45.9201 498.37 45.9801 498.4 46.0001C498.36 46.0201 498.52 45.9601 498.48 45.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.44 46.4302C498.33 46.4302 498.23 46.4001 498.13 46.3501C498.13 46.3501 498.08 46.3201 498.07 46.3001C498.03 46.2701 498 46.2202 497.98 46.1802C497.95 46.1002 497.94 46.0202 497.96 45.9402V45.9101C497.96 45.9101 497.96 45.8301 497.97 45.8001C498.01 45.6501 498.12 45.5401 498.26 45.4901C498.4 45.4401 498.56 45.4702 498.68 45.5602C498.7 45.5802 498.72 45.6002 498.74 45.6202C498.76 45.6402 498.78 45.6602 498.8 45.6802C498.85 45.7202 498.88 45.7702 498.9 45.8202C498.99 46.0502 498.87 46.3102 498.64 46.4002C498.62 46.4002 498.59 46.4201 498.57 46.4201C498.57 46.4201 498.53 46.4201 498.51 46.4201C498.48 46.4201 498.46 46.4201 498.43 46.4201L498.44 46.4302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.65 51.47C499.65 51.47 499.86 51.5401 499.87 51.5901C499.82 51.5701 499.57 51.4601 499.53 51.4501C499.56 51.4201 499.62 51.51 499.65 51.48V51.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.88 52.04C499.88 52.04 499.78 52.0401 499.74 52.0201C499.71 52.0201 499.62 51.97 499.53 51.93C499.47 51.9 499.41 51.88 499.39 51.87C499.25 51.82 499.14 51.69 499.11 51.55C499.08 51.4 499.11 51.25 499.22 51.14C499.36 51.02 499.55 50.98 499.73 51.04H499.76C499.82 51.06 499.88 51.08 499.93 51.12C500.1 51.16 500.25 51.2901 500.32 51.4601C500.37 51.6001 500.35 51.75 500.26 51.87C500.17 51.99 500.04 52.06 499.89 52.06L499.88 52.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.6 51.8901C499.58 51.9701 499.65 52.2801 499.63 52.3601C499.6 52.3401 499.28 52.1301 499.25 52.1101C499.3 52.0601 499.55 51.9401 499.59 51.8901H499.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.63 52.8101C499.53 52.8101 499.42 52.7702 499.34 52.7102C499.34 52.7102 499.26 52.6601 499.19 52.6101C499.09 52.5401 498.99 52.4802 498.97 52.4602C498.87 52.3802 498.81 52.2702 498.8 52.1502C498.79 52.0302 498.83 51.9101 498.91 51.8101C498.99 51.7301 499.09 51.6601 499.2 51.6101C499.23 51.5901 499.27 51.5701 499.29 51.5601C499.43 51.4301 499.63 51.4101 499.8 51.4901C499.97 51.5801 500.06 51.7501 500.04 51.9401C500.04 51.9701 500.04 52.0201 500.06 52.0601C500.09 52.2001 500.09 52.3401 500.06 52.4701C500.02 52.6201 499.91 52.7302 499.76 52.7802C499.72 52.7902 499.67 52.8001 499.62 52.8001L499.63 52.8101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.79 28.1001C489.79 28.1001 489.86 28.2101 489.88 28.2301C489.9 28.2501 489.78 28.1101 489.78 28.1101C489.76 28.1301 489.82 28.3101 489.8 28.3301C489.81 28.3001 489.79 28.1301 489.8 28.1001H489.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.8 28.7801C489.68 28.7801 489.56 28.7301 489.48 28.6401C489.4 28.5501 489.35 28.4301 489.35 28.3101C489.29 28.1301 489.33 27.9401 489.45 27.7901C489.47 27.7701 489.5 27.7401 489.53 27.7201C489.63 27.6501 489.77 27.6201 489.89 27.6501C490.05 27.6901 490.19 27.8101 490.25 27.9701C490.39 28.1501 490.36 28.4001 490.19 28.5501C490.17 28.5801 490.15 28.6101 490.13 28.6401C490.05 28.7301 489.93 28.7801 489.81 28.7801H489.8Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.7 51.1802C498.7 51.1802 498.7 51.3402 498.67 51.3202C498.7 51.3302 498.65 51.2301 498.67 51.2401C498.69 51.2601 498.57 51.1602 498.6 51.1802C498.57 51.1802 498.73 51.1802 498.7 51.1802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.67 51.7702C498.62 51.7702 498.57 51.7702 498.52 51.7402H498.5C498.28 51.6002 498.15 51.3601 498.15 51.1001C498.15 51.0801 498.15 51.0601 498.17 51.0401C498.19 50.9901 498.21 50.9402 498.25 50.9002C498.34 50.7902 498.48 50.7201 498.62 50.7301H498.64C498.78 50.7101 498.92 50.7602 499.02 50.8702C499.12 50.9702 499.16 51.1202 499.14 51.2602C499.14 51.2802 499.13 51.3002 499.12 51.3302V51.3501C499.11 51.5301 499 51.6802 498.83 51.7502C498.78 51.7702 498.72 51.7802 498.67 51.7802V51.7702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M488.22 49.9401C488.22 49.9401 488.08 49.8401 488.06 49.8201C488.04 49.8001 488.07 49.8401 488.09 49.8201C488.13 49.7801 488.26 49.58 488.3 49.54C488.27 49.59 488.25 49.9001 488.22 49.9501V49.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M488.22 50.3901C488.03 50.3701 487.85 50.2701 487.74 50.1201C487.65 50.0201 487.6 49.8901 487.62 49.7501C487.64 49.6101 487.71 49.5001 487.83 49.4201L487.85 49.4001C487.91 49.3201 487.97 49.2501 487.99 49.2201C488.14 49.0601 488.37 49.0301 488.55 49.1501C488.73 49.2601 488.81 49.4901 488.74 49.6901C488.74 49.7201 488.73 49.7601 488.72 49.8001C488.72 49.9301 488.68 50.0601 488.62 50.1701C488.54 50.3101 488.39 50.3901 488.23 50.3901H488.22Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.94 49.7101C497.88 49.7701 498 49.91 497.94 49.97C497.96 49.99 497.82 49.94 497.85 49.97C497.88 49.88 497.9 49.7901 497.93 49.7001C497.94 49.6801 497.96 49.7001 497.97 49.6801C497.98 49.6501 497.95 49.69 497.94 49.72V49.7101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.9 50.4201C497.9 50.4201 497.86 50.4201 497.84 50.4201C497.72 50.4201 497.61 50.3701 497.53 50.2901C497.39 50.1601 497.36 49.9502 497.44 49.7802L497.46 49.7201C497.47 49.6701 497.49 49.6101 497.51 49.5601C497.52 49.5301 497.53 49.5001 497.55 49.4701C497.62 49.3601 497.73 49.2901 497.85 49.2601C497.96 49.2201 498.09 49.2302 498.19 49.2802C498.38 49.3902 498.47 49.6202 498.4 49.8302C498.42 49.9402 498.4 50.0601 498.36 50.1601C498.36 50.1701 498.35 50.1902 498.34 50.2002C498.24 50.3402 498.08 50.4301 497.91 50.4201H497.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.88 58.7802C498.88 58.7802 498.53 58.7802 498.5 58.7802C498.52 58.8302 498.67 58.9701 498.69 59.0201C498.69 59.0401 498.77 59.0001 498.8 59.0001C498.79 58.9401 498.89 58.8301 498.88 58.7701V58.7802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.71 59.48C498.54 59.48 498.39 59.3901 498.31 59.2401H498.29C498.2 59.1401 498.13 59.04 498.08 58.92C498.04 58.78 498.06 58.6401 498.14 58.5201C498.22 58.4001 498.36 58.3401 498.5 58.3301H498.88C499.09 58.3301 499.27 58.4701 499.32 58.6801C499.35 58.8201 499.32 58.97 499.24 59.1C499.2 59.29 499.05 59.4301 498.86 59.4601C498.81 59.4701 498.76 59.48 498.71 59.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.97 52.1902C497.97 52.1902 498.07 52.3202 498.05 52.3302C497.99 52.3402 497.79 52.1802 497.74 52.2002C497.8 52.2302 497.86 52.2602 497.92 52.2702C497.98 52.2602 497.92 52.2202 497.97 52.1902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.04 52.7801C497.93 52.7801 497.82 52.7401 497.72 52.6801C497.62 52.6501 497.52 52.6001 497.44 52.5401C497.32 52.4401 497.26 52.2801 497.29 52.1301C497.32 51.9701 497.42 51.8401 497.57 51.7901C497.66 51.7501 497.76 51.7501 497.85 51.7701C498.05 51.7101 498.27 51.8101 498.37 51.9901C498.5 52.1301 498.53 52.3301 498.47 52.5101C498.41 52.6501 498.29 52.7501 498.14 52.7801C498.11 52.7801 498.08 52.7801 498.04 52.7801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.67 51.4901C497.67 51.4901 497.36 51.5101 497.33 51.4601C497.39 51.4201 497.45 51.3901 497.51 51.3501C497.53 51.4001 497.31 51.6301 497.33 51.6801C497.35 51.6601 497.65 51.5101 497.67 51.4901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.33 52.1302C497.13 52.0602 496.97 51.9002 496.91 51.7002C496.85 51.5002 496.91 51.2701 497.04 51.1101C497.06 51.0901 497.08 51.0802 497.1 51.0702C497.25 50.9302 497.46 50.8701 497.65 50.9301C497.73 50.9601 497.81 51.0202 497.86 51.0902C497.95 51.1402 498.03 51.2102 498.07 51.3102C498.15 51.4802 498.11 51.6902 497.97 51.8202C497.89 51.8902 497.8 51.9401 497.71 51.9801C497.66 52.0101 497.61 52.0301 497.58 52.0501C497.5 52.1001 497.41 52.1302 497.32 52.1302H497.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.5 52.4002C489.45 52.4202 489.26 52.2502 489.21 52.2802C489.28 52.3702 489.35 52.4601 489.43 52.5401C489.49 52.5301 489.47 52.3602 489.52 52.3402C489.5 52.3202 489.52 52.4301 489.5 52.4101V52.4002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.42 52.9902C489.2 52.9902 489.07 52.8302 488.92 52.6402L488.87 52.5802C488.76 52.4802 488.72 52.3302 488.75 52.1902C488.78 52.0402 488.89 51.9202 489.03 51.8702C489.17 51.8102 489.33 51.8202 489.46 51.8902C489.6 51.8702 489.74 51.9202 489.84 52.0202C489.95 52.1202 490 52.2802 489.97 52.4202V52.4502C489.92 52.6902 489.76 52.8902 489.53 52.9802C489.49 52.9802 489.46 52.9902 489.42 52.9902ZM489.32 52.5402L489.21 52.6602L489.32 52.5402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.9 52.3401C496.9 52.3401 497.01 52.3201 497.04 52.3001C497.02 52.2801 496.82 52.0301 496.81 52.0401C496.77 52.0601 496.67 52.2801 496.64 52.3101C496.67 52.3101 496.87 52.3301 496.9 52.3301V52.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.9 52.7801C496.9 52.7801 496.85 52.7801 496.82 52.7801H496.74C496.66 52.7801 496.59 52.7601 496.51 52.7401C496.37 52.7001 496.26 52.5901 496.21 52.4501C496.16 52.3101 496.19 52.1601 496.28 52.0401L496.31 51.9801C496.37 51.8401 496.47 51.7201 496.59 51.6401C496.92 51.4701 497.13 51.7201 497.29 51.9101L497.36 51.9901C497.46 52.0801 497.51 52.2101 497.5 52.3401C497.49 52.4801 497.41 52.6001 497.29 52.6701C497.22 52.7201 497.14 52.7501 497.05 52.7601C497 52.7801 496.95 52.7901 496.9 52.7901V52.7801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.7 46.2302C499.7 46.2302 499.84 46.3102 499.81 46.3102C499.82 46.3302 499.64 46.2902 499.66 46.2902C499.69 46.2902 499.71 46.2202 499.74 46.2102C499.73 46.1902 499.72 46.2502 499.7 46.2202V46.2302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.78 46.7701C499.64 46.7701 499.51 46.7301 499.39 46.6601C499.23 46.5401 499.16 46.3301 499.23 46.1401C499.29 46.0101 499.38 45.9001 499.5 45.8201C499.6 45.7601 499.73 45.7401 499.85 45.7701C499.97 45.8001 500.07 45.8801 500.13 45.9901C500.23 46.0901 500.28 46.2301 500.26 46.3601C500.24 46.4801 500.18 46.5901 500.09 46.6601C500 46.7301 499.9 46.7601 499.79 46.7601L499.78 46.7701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.84 47.6301C494.84 47.7401 494.84 47.8401 494.84 47.9501C494.84 47.9701 494.89 48.0301 494.91 48.0601C494.95 48.0201 495.2 47.9701 495.21 47.9201C495.1 47.8201 494.98 47.7201 494.85 47.6301H494.84Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.9 48.5102C494.79 48.5102 494.68 48.4702 494.6 48.3902C494.44 48.2602 494.37 48.0602 494.39 47.8602V47.8402C494.37 47.7102 494.38 47.5802 494.42 47.4602C494.47 47.3302 494.59 47.2302 494.73 47.1902C494.87 47.1602 495.02 47.1902 495.13 47.2802L495.21 47.3402C495.5 47.5502 495.69 47.6902 495.65 47.9702C495.6 48.1902 495.42 48.3702 495.2 48.4102L495.16 48.4302C495.1 48.4702 495.02 48.5002 494.94 48.5002H494.91L494.9 48.5102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.98 48.6801C492.98 48.6801 493.18 48.4101 493.16 48.3801C493.14 48.4501 493.14 48.5201 493.14 48.6001C493.16 48.6401 493.1 48.8201 493.13 48.8601C493.13 48.8301 492.97 48.7101 492.98 48.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M493.13 49.3C492.98 49.3 492.84 49.22 492.76 49.1C492.7 49.04 492.64 48.98 492.6 48.91C492.49 48.69 492.53 48.4301 492.71 48.2601C492.73 48.2401 492.74 48.2201 492.75 48.2001C492.82 48.0401 492.96 47.94 493.13 47.93C493.3 47.92 493.46 48.0001 493.54 48.1501C493.61 48.2601 493.62 48.3901 493.58 48.5101V48.54C493.58 48.62 493.58 48.7001 493.57 48.7801C493.58 48.8601 493.57 48.93 493.54 49C493.48 49.15 493.35 49.26 493.2 49.29C493.17 49.29 493.15 49.29 493.12 49.29L493.13 49.3Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.47 51.3901C489.44 51.3301 489.64 51.2001 489.62 51.1501C489.53 51.2001 489.44 51.2501 489.35 51.3101C489.35 51.3601 489.53 51.3601 489.54 51.4201C489.58 51.4001 489.43 51.4201 489.47 51.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.54 51.8701C489.49 51.8701 489.43 51.8601 489.38 51.8401C489.3 51.8201 489.23 51.7901 489.17 51.7401C488.99 51.6601 488.89 51.4702 488.9 51.2802C488.92 51.0202 489.11 50.9201 489.31 50.8101L489.37 50.7802C489.47 50.6902 489.61 50.6701 489.73 50.7001C489.86 50.7401 489.97 50.8401 490.02 50.9701C490.08 51.2901 489.97 51.6101 489.74 51.8301C489.68 51.8601 489.61 51.8801 489.54 51.8801V51.8701ZM489.34 51.0201L489.45 51.2301L489.34 51.0201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.58 27.5501C485.58 27.5501 485.54 27.2801 485.52 27.2501C485.48 27.3401 485.45 27.4401 485.44 27.5401C485.46 27.6101 485.49 27.6801 485.53 27.7401C485.54 27.7101 485.58 27.5701 485.59 27.5401L485.58 27.5501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.53 28.2002C485.4 28.2002 485.28 28.1402 485.19 28.0502C485.12 27.9602 485.07 27.8702 485.04 27.7602C484.97 27.4902 485.02 27.2002 485.18 26.9602C485.27 26.8502 485.41 26.7902 485.55 26.8002C485.69 26.8002 485.82 26.8802 485.9 27.0002C485.96 27.1002 485.99 27.2102 486 27.3302V27.4002C486.04 27.4902 486.04 27.5902 486.01 27.6802L485.95 27.8802C485.89 28.0702 485.72 28.1902 485.52 28.1902L485.53 28.2002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.59 32.9001C477.59 32.9001 477.6 33.1601 477.58 33.1801C477.6 33.2001 477.55 33.1001 477.57 33.1301C477.61 33.1001 478.2 33.2101 478.24 33.1801C478.21 33.1701 477.63 32.9201 477.6 32.9101L477.59 32.9001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.58 33.6302C477.43 33.6302 477.29 33.5502 477.2 33.4302C477.16 33.3702 477.13 33.3001 477.13 33.2201C477.13 33.1601 477.13 33.1002 477.13 33.0402C477.1 32.8402 477.18 32.6302 477.35 32.5102C477.47 32.4402 477.62 32.4201 477.75 32.4701C477.77 32.4701 477.95 32.5502 478.12 32.6302L478.4 32.7502C478.55 32.8102 478.66 32.9502 478.68 33.1102C478.7 33.2702 478.63 33.4302 478.5 33.5302C478.34 33.6502 478.18 33.6302 477.85 33.5902H477.78C477.72 33.6102 477.65 33.6302 477.58 33.6302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.3 59.56C497.3 59.56 497.33 59.72 497.34 59.72C497.4 59.72 497.36 59.51 497.41 59.49C497.39 59.47 497.45 59.59 497.43 59.6C497.37 59.6 497.34 59.5501 497.29 59.5701L497.3 59.56Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.35 60.1701C497.1 60.1701 496.89 59.9801 496.88 59.7301C496.85 59.6401 496.84 59.5401 496.86 59.4501C496.89 59.3201 496.98 59.21 497.1 59.16H497.12C497.12 59.16 497.15 59.1201 497.17 59.1101C497.3 59.0301 497.45 59.0201 497.59 59.0801C497.73 59.1401 497.83 59.26 497.86 59.41C497.91 59.55 497.9 59.7001 497.83 59.8301C497.81 59.8701 497.78 59.9001 497.75 59.9301C497.68 60.0801 497.52 60.1801 497.35 60.1801V60.1701ZM497.26 59.6401L497.09 59.8101L497.26 59.6401ZM497.39 59.2801L497.42 59.4601L497.56 59.3301C497.51 59.3001 497.45 59.2801 497.39 59.2801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M476.61 35.8302C476.67 35.8102 476.75 35.7001 476.82 35.6701C476.8 35.6401 476.78 35.7702 476.76 35.7702C476.7 35.7802 476.5 35.5401 476.44 35.5601C476.46 35.5901 476.59 35.8002 476.61 35.8202V35.8302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M476.61 36.2801C476.47 36.2801 476.34 36.2201 476.26 36.1101C476.25 36.0901 476.2 36.0201 476.15 35.9401L476.08 35.8301C476 35.7101 475.98 35.5701 476.02 35.4401C476.06 35.3101 476.16 35.2001 476.29 35.1501C476.45 35.0901 476.63 35.1201 476.76 35.2301C476.9 35.2201 477.04 35.2701 477.14 35.3701C477.29 35.5301 477.3 35.7901 477.16 35.9601C477.09 36.0901 476.97 36.1801 476.83 36.2201C476.81 36.2301 476.79 36.2401 476.77 36.2501C476.72 36.2701 476.66 36.2801 476.61 36.2801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.98 29.05C494.96 29.12 494.82 29.0801 494.8 29.1501C494.87 29.1701 494.94 29.1801 495.02 29.1801C495.03 29.1801 494.95 29.1001 494.94 29.0801C494.91 29.0401 495.02 29.08 494.98 29.05Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495 29.6302C494.93 29.6302 494.86 29.6201 494.79 29.6001C494.65 29.6001 494.53 29.5201 494.44 29.4101C494.36 29.3001 494.33 29.1602 494.36 29.0202C494.41 28.8502 494.54 28.7201 494.71 28.6701H494.74C494.74 28.6701 494.81 28.6201 494.84 28.6101C494.99 28.5601 495.15 28.6002 495.26 28.7002C495.35 28.7802 495.41 28.8802 495.42 29.0002C495.46 29.1002 495.47 29.2102 495.43 29.3202C495.38 29.4802 495.24 29.5902 495.08 29.6202C495.05 29.6202 495.02 29.6202 494.99 29.6202L495 29.6302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.96 30.4901C487.96 30.4901 488.12 30.3801 488.13 30.3501C488.09 30.3501 487.91 30.4201 487.88 30.4301C487.88 30.4601 487.96 30.5601 487.97 30.5801C487.99 30.5801 487.95 30.4901 487.97 30.4901H487.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.96 31.0302C487.69 31.0502 487.45 30.8602 487.4 30.5902C487.35 30.3202 487.51 30.0702 487.77 29.9902L487.87 29.9602C487.94 29.9402 488 29.9202 488.02 29.9102C488.17 29.8702 488.32 29.9102 488.43 30.0202C488.54 30.1302 488.59 30.2702 488.57 30.4202C488.55 30.5502 488.47 30.6702 488.37 30.7402C488.32 30.8702 488.23 30.9602 488.1 31.0102C488.06 31.0202 488.01 31.0302 487.96 31.0302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.13 29.8501C495.13 29.8501 495.01 29.8301 494.96 29.8701C494.98 29.8901 495.08 30.1501 495.1 30.1501C495.16 30.1401 495.38 29.9801 495.43 29.9601C495.4 29.9201 495.16 29.9001 495.12 29.8601L495.13 29.8501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.09 30.6001C494.8 30.6001 494.68 30.3201 494.62 30.1801L494.59 30.1101C494.47 29.9201 494.51 29.6702 494.69 29.5202C494.8 29.4402 494.93 29.4001 495.06 29.4101C495.16 29.3901 495.26 29.4102 495.35 29.4602H495.4C495.55 29.4902 495.68 29.5601 495.79 29.6601C495.89 29.7701 495.92 29.9201 495.89 30.0601C495.86 30.2001 495.76 30.3201 495.62 30.3701C495.62 30.3701 495.6 30.3901 495.57 30.4101C495.46 30.4901 495.34 30.5602 495.21 30.5902C495.18 30.5902 495.15 30.5902 495.11 30.5902L495.09 30.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.11 32.0902C479.05 32.0702 479.13 32.0601 479.08 32.0501C479.06 32.0501 479.16 31.9601 479.14 31.9901C479.18 32.0201 479.12 32.0401 479.16 32.0401C479.2 32.0401 479.07 32.1302 479.12 32.0902H479.11Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.1 32.5501C478.94 32.5501 478.78 32.4601 478.7 32.3201V32.3001C478.65 32.2401 478.62 32.1602 478.62 32.0902C478.62 31.8502 478.77 31.6401 479 31.5601C479.2 31.5001 479.42 31.5902 479.52 31.7702C479.53 31.7902 479.54 31.8102 479.55 31.8402C479.58 31.8902 479.59 31.9501 479.6 32.0001C479.61 32.2401 479.46 32.4602 479.23 32.5302C479.19 32.5402 479.14 32.5501 479.1 32.5501ZM478.88 31.7102L479.03 31.8801L478.96 31.6701C478.96 31.6701 478.9 31.6902 478.87 31.7102H478.88Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.24 35.7101C496.24 35.7101 496.22 35.6301 496.24 35.6401C496.27 35.6501 496.14 35.6401 496.17 35.6401C496.17 35.6101 496.37 35.5201 496.36 35.4901C496.33 35.4901 496.28 35.6901 496.25 35.7001L496.24 35.7101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.24 36.1601C495.95 36.1301 495.73 35.9001 495.71 35.6101C495.71 35.5601 495.73 35.5101 495.75 35.4701C495.81 35.3501 495.91 35.2501 496.03 35.1801C496.08 35.1201 496.15 35.0801 496.22 35.0601C496.34 35.0201 496.47 35.0401 496.58 35.1001C496.69 35.1601 496.77 35.2601 496.8 35.3901C496.83 35.5201 496.8 35.6501 496.73 35.7601C496.69 35.9001 496.6 36.0201 496.47 36.1001C496.44 36.1201 496.4 36.1402 496.36 36.1502C496.32 36.1502 496.29 36.1601 496.25 36.1601H496.24Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.64 49.3201C499.64 49.3201 499.74 49.2801 499.75 49.3101C499.75 49.3401 499.75 49.5701 499.77 49.5601C499.8 49.5401 499.68 49.3301 499.64 49.3201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.77 50.0101C499.69 50.0101 499.61 49.9901 499.53 49.9401C499.42 49.8701 499.34 49.7601 499.32 49.6301C499.24 49.5501 499.19 49.4401 499.19 49.3301C499.2 49.1001 499.37 48.9 499.6 48.86C499.84 48.8 500.09 48.93 500.18 49.16C500.21 49.24 500.22 49.33 500.21 49.41V49.4501C500.26 49.6501 500.16 49.8501 499.99 49.9501C499.92 49.9901 499.85 50.0101 499.77 50.0101ZM499.6 49.73C499.65 49.75 499.71 49.7601 499.77 49.7501L499.74 49.5801L499.63 49.61L499.6 49.7401V49.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.68 58.5702C495.68 58.5702 495.82 58.4101 495.81 58.4401C495.8 58.4701 495.65 58.6401 495.67 58.6701C495.72 58.6001 495.77 58.5201 495.81 58.4401C495.81 58.4101 495.7 58.6002 495.68 58.5702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.68 59.1101C495.55 59.1101 495.43 59.0601 495.35 58.9601C495.25 58.8601 495.21 58.7201 495.23 58.5901C495.23 58.5101 495.23 58.4401 495.27 58.3701C495.27 58.3701 495.52 57.9001 495.92 57.9901C496.13 58.0401 496.27 58.2401 496.26 58.4501C496.26 58.5401 496.23 58.6201 496.18 58.6901C496.13 58.8001 496.06 58.9001 495.98 58.9901C495.9 59.0701 495.79 59.1101 495.68 59.1101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.35 57.5602C496.35 57.5602 496.55 57.5001 496.54 57.4701C496.54 57.4401 496.38 57.5602 496.36 57.5702C496.32 57.5602 496.33 57.5902 496.36 57.5702L496.35 57.5602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.34 58.0201C496.18 58.0201 496.04 57.94 495.95 57.81C495.86 57.68 495.85 57.51 495.92 57.37C495.97 57.26 496.07 57.1801 496.19 57.1301C496.32 57.0201 496.5 56.9801 496.67 57.0301C496.81 57.0701 496.91 57.18 496.96 57.31C497.01 57.46 496.98 57.62 496.88 57.75C496.79 57.85 496.68 57.9201 496.55 57.9601C496.48 57.9901 496.41 58.0101 496.33 58.0101L496.34 58.0201ZM496.17 57.2101C496.09 57.3301 496.07 57.48 496.12 57.61L496.33 57.54L496.18 57.2101H496.17Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.95 48.2802C495.95 48.2802 495.86 48.5002 495.89 48.4902C495.92 48.4902 495.89 48.4502 495.92 48.4402C495.98 48.4202 495.96 48.2402 495.95 48.2802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.89 48.9401C495.76 48.9401 495.64 48.89 495.56 48.8C495.42 48.63 495.4 48.3901 495.51 48.2001C495.51 48.1901 495.51 48.21 495.51 48.23C495.54 48.01 495.72 47.8401 495.94 47.8301C496.16 47.8301 496.36 47.9801 496.4 48.2001C496.44 48.3901 496.4 48.58 496.28 48.73C496.22 48.82 496.14 48.8901 496.04 48.9301C495.99 48.9501 495.95 48.9501 495.9 48.9501L495.89 48.9401ZM495.75 48.0201C495.75 48.0201 495.68 48.0501 495.65 48.0701C495.68 48.0501 495.71 48.0301 495.75 48.0201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.48 48.2701C496.48 48.2701 496.52 48.19 496.54 48.23C496.55 48.26 496.49 48.0901 496.52 48.0901C496.54 48.0901 496.52 48.2701 496.48 48.2701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.47 48.7201H496.44C496.22 48.7001 496.04 48.5201 496.01 48.3001C496.02 48.1301 496.07 47.9701 496.15 47.8201C496.24 47.7101 496.38 47.6401 496.53 47.6401C496.7 47.6401 496.84 47.7401 496.92 47.8901C496.96 47.9801 496.98 48.0701 496.97 48.1601C496.97 48.3001 496.93 48.4401 496.84 48.5401C496.75 48.6401 496.61 48.7101 496.47 48.7101V48.7201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.64 55.4302C497.64 55.4302 497.7 55.5102 497.68 55.4802C497.65 55.5002 497.82 55.4102 497.82 55.4402C497.82 55.4702 497.65 55.5002 497.68 55.5302C497.71 55.5102 497.62 55.4602 497.65 55.4302H497.64Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M497.67 55.9801H497.65C497.53 55.9801 497.42 55.9202 497.34 55.8302C497.3 55.7902 497.27 55.7301 497.25 55.6801C497.16 55.5301 497.17 55.3401 497.26 55.1901C497.28 55.1501 497.31 55.1102 497.35 55.0802C497.46 54.9902 497.61 54.9601 497.75 54.9901C497.87 54.9701 497.98 54.9901 498.08 55.0701C498.21 55.1601 498.28 55.3102 498.27 55.4602C498.26 55.6502 498.13 55.8201 497.95 55.8801C497.87 55.9401 497.77 55.9701 497.67 55.9701V55.9801ZM498.1 55.6201C498.1 55.6201 498.08 55.7001 498.07 55.7301C498.09 55.6901 498.1 55.6601 498.11 55.6201H498.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.87 50.9202C499.87 50.9202 499.9 50.8702 499.87 50.8902C499.84 50.9002 499.78 50.9202 499.78 50.9602C499.78 50.9802 499.87 50.9602 499.88 50.9202H499.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.79 51.4201H499.78C499.54 51.4201 499.35 51.2202 499.33 50.9902C499.32 50.7502 499.48 50.5401 499.71 50.4801C499.89 50.4101 500.1 50.4601 500.23 50.6001C500.33 50.7201 500.37 50.9002 500.31 51.0502C500.24 51.2802 500.03 51.4302 499.8 51.4302L499.79 51.4201ZM499.91 50.9502L500.05 51.3002C500.13 51.2502 500.18 51.1702 500.21 51.0902L499.98 50.9502H499.91ZM499.51 50.6601L499.78 50.8302L499.8 50.5302C499.68 50.5202 499.57 50.5701 499.51 50.6701V50.6601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.75 51.7402C496.75 51.7402 496.8 51.8902 496.81 51.8702C496.81 51.8502 496.77 51.8002 496.75 51.7702C496.73 51.7902 496.83 51.8502 496.83 51.8702C496.83 51.8902 496.74 51.7202 496.75 51.7402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.82 52.3202C496.7 52.3202 496.58 52.2702 496.5 52.1802C496.48 52.1602 496.47 52.1502 496.46 52.1302C496.36 52.0402 496.31 51.9201 496.3 51.7901C496.3 51.6101 496.39 51.4402 496.54 51.3402C496.61 51.3002 496.69 51.2801 496.77 51.2901C496.81 51.2901 496.84 51.2902 496.88 51.3102C497.03 51.3602 497.15 51.4702 497.19 51.6202C497.25 51.7102 497.28 51.8201 497.27 51.9201C497.25 52.1301 497.08 52.3002 496.87 52.3202C496.85 52.3202 496.83 52.3202 496.82 52.3202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.21 60.0201C496.21 60.0201 495.96 59.82 495.94 59.8C495.92 59.86 495.91 59.9301 495.91 60.0001C495.91 60.0201 495.91 59.8801 495.94 59.8801C495.96 59.8801 496.19 60.0401 496.22 60.0201H496.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.22 60.4701C496.15 60.4701 496.08 60.4501 496.02 60.4301C495.98 60.4401 495.93 60.4501 495.88 60.4401C495.64 60.4301 495.45 60.2201 495.46 59.9801V59.9401C495.46 59.7601 495.52 59.5801 495.64 59.4501C495.73 59.3701 495.85 59.3301 495.97 59.3401C496.09 59.3401 496.2 59.4001 496.28 59.5001C496.27 59.4801 496.31 59.5101 496.35 59.5501C496.42 59.6001 496.48 59.6601 496.55 59.7201C496.71 59.9101 496.69 60.1901 496.5 60.3501C496.42 60.4201 496.32 60.4601 496.21 60.4601L496.22 60.4701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.79 31.5501C490.07 31.5901 489.47 31.5801 489.25 31.7601C489.23 31.7801 489.35 31.9501 489.36 31.9201C489.44 31.6101 489.49 31.5001 489.79 31.5401V31.5501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.35 32.38C489 32.38 488.85 32.0001 488.83 31.9601C488.76 31.7701 488.81 31.56 488.96 31.42C489.02 31.37 489.1 31.32 489.17 31.29C489.35 31.12 489.61 31.05 489.85 31.11C490.1 31.11 490.3 31.32 490.31 31.57C490.31 31.75 490.23 31.98 489.83 32.04H489.79C489.74 32.23 489.57 32.37 489.38 32.38H489.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M500.12 31.3901C500.12 31.3901 499.93 31.4801 499.9 31.4501C499.87 31.4701 499.83 31.3501 499.82 31.3701C499.82 31.3901 499.88 31.2201 499.91 31.2201C499.94 31.2201 500.09 31.4101 500.11 31.3801L500.12 31.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.89 31.91C499.89 31.91 499.85 31.91 499.82 31.91C499.68 31.89 499.55 31.8001 499.48 31.6801C499.35 31.5301 499.34 31.3101 499.44 31.1401C499.51 30.9301 499.71 30.79 499.93 30.79C500.07 30.8 500.21 30.8701 500.3 30.9901H500.31C500.31 30.9901 500.4 31.06 500.44 31.1C500.55 31.23 500.58 31.4001 500.52 31.5601C500.46 31.7201 500.32 31.83 500.15 31.85C500.1 31.87 500.04 31.8901 499.99 31.9001C499.95 31.9001 499.91 31.91 499.87 31.91H499.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.29 29.2301C494.29 29.2301 494.37 29.3301 494.38 29.3701C494.39 29.4001 494.29 29.4601 494.31 29.4301C494.36 29.3301 494.33 29.2301 494.29 29.2301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.31 29.8902C494.2 29.8902 494.1 29.8601 494.01 29.7901C493.9 29.6901 493.84 29.5402 493.86 29.3902C493.81 29.2702 493.82 29.1402 493.88 29.0302C493.97 28.8702 494.14 28.7701 494.33 28.7901C494.49 28.8101 494.62 28.9001 494.7 29.0401C494.71 29.0601 494.72 29.0801 494.73 29.1001C494.76 29.1401 494.78 29.1801 494.8 29.2201C494.88 29.4401 494.8 29.6801 494.59 29.8001C494.51 29.8601 494.41 29.8902 494.3 29.8902H494.31ZM494.09 29.0702C493.97 29.1702 493.91 29.3201 493.95 29.4701L494.23 29.3102L494.09 29.0702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.34 29.6702C489.34 29.6702 489.37 29.6702 489.37 29.6902C489.37 29.7102 489.31 29.8502 489.33 29.8802C489.35 29.8602 489.31 29.7102 489.31 29.6902C489.31 29.6702 489.37 29.7002 489.35 29.6802L489.34 29.6702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.32 30.3201H489.29C489.17 30.3201 489.06 30.2601 488.98 30.1601C488.9 30.0701 488.86 29.9401 488.87 29.8201C488.86 29.7601 488.85 29.7102 488.85 29.6502C488.85 29.5102 488.93 29.3901 489.04 29.3101C489.09 29.2801 489.15 29.2501 489.21 29.2401C489.32 29.2101 489.44 29.2202 489.55 29.2702C489.6 29.2902 489.64 29.3201 489.68 29.3501C489.78 29.4401 489.83 29.5702 489.82 29.7102C489.82 29.7702 489.8 29.8301 489.78 29.8801C489.78 30.1201 489.57 30.3201 489.33 30.3201H489.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.33 33.4801C494.33 33.4801 494.11 33.4401 494.08 33.4601C494.1 33.4801 494.31 33.3801 494.33 33.3801C494.35 33.3801 494.49 33.5001 494.51 33.4801C494.49 33.4601 494.35 33.5101 494.33 33.4801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.36 33.9302H494.31C494.25 33.9302 494.19 33.9302 494.12 33.9102C493.98 33.9202 493.85 33.8702 493.76 33.7702C493.64 33.6402 493.6 33.4602 493.67 33.3002C493.74 33.1402 493.88 33.0202 494.05 33.0102H494.08C494.16 32.9502 494.26 32.9302 494.35 32.9302C494.46 32.9302 494.56 32.9802 494.65 33.0402C494.81 33.0902 494.92 33.2202 494.96 33.3802C494.99 33.5402 494.94 33.7002 494.82 33.8102C494.73 33.9002 494.6 33.9402 494.48 33.9202C494.44 33.9202 494.41 33.9202 494.37 33.9202L494.36 33.9302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.61 46.9301C499.61 46.9301 499.55 46.8501 499.52 46.8701C499.54 46.9001 499.6 46.7501 499.62 46.7501C499.65 46.7501 499.62 46.9001 499.64 46.8801C499.62 46.8501 499.64 46.9601 499.61 46.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.62 47.3901C499.62 47.3901 499.61 47.3901 499.6 47.3901C499.59 47.3901 499.57 47.3901 499.56 47.3901C499.46 47.3701 499.37 47.3301 499.29 47.2701C499.25 47.2501 499.22 47.2201 499.19 47.1901C499.11 47.1001 499.07 46.9801 499.07 46.8601C499.07 46.7401 499.13 46.6301 499.22 46.5501C499.32 46.3701 499.54 46.2801 499.75 46.3301C499.95 46.3901 500.09 46.5801 500.08 46.7901C500.1 46.9001 500.08 47.0201 500.02 47.1201C499.97 47.2301 499.88 47.3201 499.76 47.3701C499.71 47.3901 499.66 47.3901 499.61 47.3901H499.62Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.5 45.1501C498.5 45.1501 498.4 45.39 498.39 45.36C498.38 45.33 498.68 45.27 498.67 45.24C498.65 45.16 498.48 45.1401 498.51 45.1501H498.5Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.39 45.8201C498.21 45.8201 498.05 45.7101 497.97 45.5501C497.9 45.3801 497.93 45.1901 498.06 45.0601C498.1 44.8801 498.25 44.7401 498.43 44.7201C498.47 44.7201 498.51 44.7201 498.55 44.7201H498.59C498.83 44.7501 499.03 44.9101 499.1 45.1401C499.14 45.3001 499.14 45.6001 498.66 45.7501H498.63C498.63 45.7501 498.54 45.8101 498.49 45.8201C498.46 45.8201 498.42 45.8301 498.39 45.8301V45.8201ZM498.45 45.6001C498.45 45.6001 498.5 45.6001 498.52 45.6001L498.46 45.4501L498.44 45.5901L498.45 45.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.87 46.0302C494.87 46.0302 494.76 45.8201 494.78 45.8001C494.76 45.7801 494.91 45.8001 494.89 45.8001C494.87 45.8001 494.9 45.7801 494.9 45.8001C494.9 45.8201 494.85 46.0002 494.87 46.0202V46.0302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.87 46.48H494.84C494.72 46.48 494.61 46.4201 494.53 46.3201C494.48 46.2701 494.45 46.2001 494.43 46.1301C494.4 46.0801 494.38 46.03 494.36 45.98C494.32 45.9 494.31 45.8001 494.33 45.7101C494.33 45.6701 494.35 45.64 494.36 45.61C494.37 45.58 494.39 45.5501 494.41 45.5201C494.52 45.3801 494.7 45.31 494.88 45.35H494.91C495.16 45.37 495.35 45.5801 495.34 45.8301C495.34 45.8701 495.34 45.9001 495.32 45.9401C495.32 45.9601 495.32 45.98 495.31 46C495.33 46.14 495.27 46.28 495.16 46.36C495.08 46.43 494.97 46.47 494.86 46.47L494.87 46.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.38 38.6001C496.38 38.6001 496.42 38.3901 496.4 38.3901C496.37 38.3901 496.56 38.5901 496.53 38.6101C496.55 38.6401 496.36 38.7701 496.38 38.7701C496.41 38.7701 496.36 38.6201 496.38 38.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M496.38 39.2202H496.35C496.17 39.2102 496.01 39.0902 495.95 38.9102C495.93 38.8402 495.92 38.7802 495.93 38.7102C495.93 38.6102 495.93 38.5102 495.95 38.4202C495.95 38.2902 495.99 38.1702 496.08 38.0802C496.17 37.9902 496.29 37.9402 496.42 37.9402C496.55 37.9402 496.68 38.0102 496.76 38.1102C496.78 38.1402 496.8 38.1702 496.82 38.2002C496.86 38.2502 496.89 38.3102 496.92 38.3702C496.97 38.4502 496.99 38.5402 496.99 38.6302C496.97 38.7902 496.88 38.9402 496.75 39.0402C496.75 39.0402 496.74 39.0602 496.73 39.0602C496.64 39.1502 496.52 39.2102 496.4 39.2102L496.38 39.2202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.46 42.5302C586.51 42.6602 586.52 42.8001 586.48 42.9301C586.63 43.0001 586.71 43.1801 586.86 43.2501C587.01 43.3201 587.2 43.3001 587.35 43.3701C587.37 43.4301 587.42 43.4702 587.45 43.5302C587.6 43.5902 587.67 43.7901 587.8 43.8801C587.91 43.9501 587.87 43.9301 587.93 44.1001C587.69 44.1001 587.57 44.2301 587.37 44.1601C587.11 44.3701 586.71 44.4902 586.9 44.5302C587.2 44.5902 587.45 44.7601 587.39 45.0401C587.58 45.0101 587.6 45.1301 587.79 45.1001C587.98 45.0701 588.13 44.8002 588.32 44.7802C588.41 44.7702 588.55 44.9901 588.64 45.0101C588.6 45.1001 588.54 45.1701 588.46 45.2201C588.25 45.3101 588.01 45.3101 587.8 45.3901C587.59 45.4801 587.43 45.7101 587.22 45.8001C587.28 45.9301 587.36 46.1101 587.43 46.2401C587.49 46.3601 587.49 46.5001 587.43 46.6201C587.37 46.8201 587.66 46.9501 587.72 47.0701C587.78 47.2201 587.78 47.3501 587.94 47.4301C588.15 47.5301 588.29 47.7301 588.32 47.9601C588.41 48.2001 588.31 48.4601 588.08 48.5701C587.88 48.7301 587.77 48.9701 587.78 49.2301C587.75 49.3801 587.74 49.5301 587.76 49.6801C587.79 49.8401 587.74 50.0401 587.76 50.2001C587.99 50.0501 588.2 49.8901 588.4 49.7101C588.49 49.6401 588.48 49.5001 588.52 49.3601C588.52 49.3601 588.58 49.4301 588.58 49.4101C588.52 49.3501 588.28 49.3001 588.22 49.2401C588.27 49.2201 588.43 49.0801 588.47 49.0601C588.53 48.9501 588.71 48.8001 588.77 48.6901C588.89 48.8301 589.14 49.0801 589.16 49.2301C589.15 49.4101 589.11 49.6001 589.05 49.7701C589.16 49.7001 589.38 49.8201 589.48 49.7501C589.59 49.6701 589.31 49.4101 589.29 49.4301C589.3 49.4201 589.48 49.4901 589.6 49.3801C589.79 49.2101 590.12 49.1601 590.31 48.9801C590.46 48.8301 590.47 48.5501 590.6 48.3901C590.64 48.3401 590.55 48.2501 590.56 48.2401C590.56 48.2301 590.53 48.2501 590.56 48.2001C590.53 48.2001 590.85 48.2501 590.82 48.2501C590.85 48.2301 590.42 48.0101 590.34 47.7601C590.29 47.5801 590.32 47.3801 590.42 47.2101C590.54 47.0401 590.6 46.8001 590.76 46.6701C590.92 46.5401 591.06 46.3201 591.24 46.2301C591.42 46.1401 591.72 46.2801 591.92 46.2101C592.12 46.1401 592.3 46.0301 592.5 45.9801C592.49 45.7801 592.36 45.6101 592.17 45.5501C592 45.5101 591.79 45.5901 591.64 45.5401C591.51 45.4901 591.55 45.4001 591.4 45.3801C591.42 45.2401 591.37 45.1001 591.27 45.0101C591.01 44.8601 590.87 44.7201 590.91 44.6101C590.96 44.4901 590.98 44.3601 590.97 44.2301C590.97 44.1601 590.8 44.1701 590.73 44.1801C590.56 44.2401 590.37 44.2601 590.19 44.2501C590.01 44.1901 589.82 44.1501 589.63 44.1401C589.46 44.1401 589.41 44.3802 589.24 44.5302C589.1 44.6402 588.78 44.4301 588.56 44.4201C588.39 44.4201 588.36 44.4201 588.24 44.1701L588.15 44.2901C588.3 44.0701 588.24 43.6501 588.39 43.4301C588.56 43.3901 588.86 43.3701 589.04 43.3101C589.28 43.2301 589.63 43.1501 589.74 43.2301L586.46 42.5302ZM608.45 49.7501C608.55 49.6601 608.68 49.6101 608.82 49.5901C608.82 49.7201 608.81 49.8601 608.77 49.9901C608.75 50.4501 608.85 50.4701 609.38 50.3201C609.36 50.5201 609.25 50.6901 609.09 50.8101C608.93 50.9101 608.72 50.7901 608.52 50.7802C608.2 50.7702 607.98 51.0202 608.1 51.2802C608.17 51.4302 608.43 51.5001 608.52 51.6501C608.64 51.6901 608.74 51.7801 608.8 51.9001C608.86 52.0201 608.86 52.1501 608.8 52.2701C608.72 52.5001 608.63 52.5601 608.85 52.7401C608.75 52.9701 608.59 53.1702 608.4 53.3401C607.95 53.5701 607.62 53.8801 607.77 53.9001C607.96 53.9201 608.1 54.1601 608.22 54.2601C608.35 54.3701 608.38 54.5701 608.5 54.7001C608.82 54.8701 609.16 55.0101 609.51 55.1101C609.66 55.1701 609.84 55.0901 609.98 55.1701C609.84 55.3201 609.69 55.4501 609.53 55.5601C609.14 55.5901 608.76 55.5901 608.37 55.5601C608.3 55.5701 608.41 55.8101 608.34 55.8301C608.38 55.8601 608.28 55.8101 608.33 55.8101C608.63 55.8501 609.21 56.0201 609.51 56.0601C609.81 56.1001 609.82 55.8601 610.12 55.8701C610.05 55.7601 610.02 55.6301 610.03 55.5101C610.18 55.4701 610.35 55.4801 610.5 55.4401C610.65 55.4101 610.83 55.5001 610.98 55.4901C611.06 55.4901 611.2 55.6301 611.28 55.7701C611.43 55.7701 611.53 55.8602 611.61 55.7802C611.8 55.5802 611.92 55.2601 612.14 55.1201C612.37 55.0301 612.61 55.0001 612.86 55.0201C612.91 55.0201 612.88 54.9601 612.94 54.8601C612.95 54.8501 612.94 55.0401 612.94 55.0201C612.86 54.7801 612.85 54.4801 612.78 54.2501C613 54.2101 613.19 54.2001 613.09 53.8701C613.06 53.6801 613.15 53.5001 613.32 53.4101C613.49 53.3101 613.65 53.1801 613.77 53.0201C613.88 52.8901 613.83 52.6201 613.89 52.4601C613.95 52.3001 614.18 52.1901 614.22 52.0201C614.27 51.8501 614.14 51.6401 614.22 51.4901C614.37 51.1701 613.94 51.4701 613.81 51.4301C613.8 51.2901 613.79 51.2101 613.78 51.0701C613.54 51.0401 613.43 50.7001 613.2 50.6501C613.09 50.6301 612.77 50.7801 612.66 50.7301C612.78 50.5901 612.93 50.4701 613.08 50.3801C613.15 50.3101 613.24 50.2701 613.33 50.2401C613.15 50.1001 612.86 49.9302 612.69 49.7802C612.87 49.6802 613.29 49.5101 613.39 49.5601C613.74 49.7501 613.96 49.6701 614.05 49.5601C614.16 49.3401 614.21 49.1001 614.18 48.8501C614.08 48.6601 614 48.4501 613.95 48.2401C613.91 47.9901 614.01 47.5901 613.87 47.4701C613.72 47.3301 613.47 47.3501 613.46 47.2201C613.43 47.0301 613.48 46.8301 613.6 46.6701C613.91 46.4901 613.73 46.4701 613.7 46.2301C613.66 45.9401 613.94 45.5601 613.93 45.2701C613.69 45.2301 613.45 45.1901 613.39 45.0601C613.34 44.8901 613.39 44.6901 613.53 44.5801C613.67 44.4201 613.59 44.1501 613.67 43.9801C613.76 43.8001 614.18 43.7301 614.21 43.5401C614.24 43.3301 614.26 43.1201 614.25 42.9101C614.25 42.7101 614.15 42.5101 614.12 42.3101C614.1 42.1101 613.78 41.9501 613.76 41.7501C613.74 41.5501 613.82 41.3301 613.81 41.1401C613.81 41.0401 613.74 41.0301 613.66 40.9701C613.51 40.8001 613.35 40.6301 613.18 40.4801C613.35 40.4301 613.65 40.5101 613.82 40.4601C613.85 40.4601 613.63 40.3101 613.63 40.2901C613.59 40.0901 613.86 39.8301 613.82 39.6301C613.8 39.4201 613.76 39.2201 613.71 39.0201C613.67 38.9101 613.19 39.0901 613.03 39.0201C612.94 38.9801 612.86 38.7601 612.77 38.7101C612.87 38.6701 613.01 38.5602 613.12 38.5302C613.19 38.5102 613.26 38.3701 613.33 38.3601C613.5 38.3401 613.7 38.4601 613.78 38.3901C613.84 38.3301 614.04 38.1601 613.78 37.9101C613.75 37.8901 613.63 37.7301 613.72 37.6301C613.89 37.4401 614.09 37.3601 614.05 37.2401C614.02 37.1301 613.84 37.2601 613.55 37.2201C613.42 37.2001 613.29 36.8001 613.17 36.6801C613.29 36.6101 613.42 36.4801 613.53 36.4101C613.73 36.3001 613.92 36.3001 613.77 35.9401C613.73 35.8601 613.44 35.6601 613.49 35.6101C613.76 35.3601 613.91 35.2101 613.52 35.0901C613.32 35.0301 613 35.0401 612.89 34.8801C612.75 34.6301 612.66 34.3701 612.6 34.0901C612.6 34.0701 612.71 34.0801 612.77 34.0401C612.87 34.2401 613.1 34.3201 613.24 34.5001C613.35 34.6401 613.42 34.9301 613.59 34.9801C613.7 35.0101 613.73 34.7201 613.86 34.6701C613.8 34.5301 613.9 34.4501 613.83 34.3201C613.79 34.2301 613.75 34.1401 613.7 34.0501C614.01 33.8401 613.79 33.6401 613.72 33.4701C613.64 33.2801 613.58 33.0301 613.51 32.8401C613.47 32.7301 613.45 32.2801 613.53 32.2501C613.81 32.1501 614.01 32.2101 614.02 32.0401C614.08 31.8401 614.1 31.6301 614.1 31.4201C614.1 31.4001 613.96 31.4701 613.95 31.4501C613.87 31.3101 613.95 31.0801 613.86 30.9401C613.78 30.8001 613.61 30.7001 613.52 30.5701C613.41 30.4201 613.46 30.3801 613.58 30.2901C613.69 30.2001 613.61 30.2001 613.37 30.0501C613.5 29.8601 613.61 29.6601 613.7 29.4501C613.79 29.2801 614.02 29.1901 614.04 29.0101C614.06 28.8201 614.04 28.6301 613.97 28.4601C613.91 28.3001 613.65 28.1501 613.53 27.9901C613.66 27.8601 613.75 27.7001 613.78 27.5201C613.79 27.3501 613.78 27.1902 613.74 27.0302C613.71 26.8802 613.71 26.7301 613.73 26.5801C613.93 26.4501 613.84 26.2202 613.87 26.0302C613.89 25.8402 613.89 25.6401 613.89 25.4501C613.9 25.2501 613.86 25.0401 614.01 24.8901C613.89 24.7901 613.99 24.7001 613.86 24.6001C613.74 24.5001 613.56 24.4701 613.44 24.3601C613.36 24.1501 613.31 23.9201 613.3 23.7001C613.27 23.4001 613.3 22.9201 613.28 22.8901C613.46 22.8901 613.45 22.8501 613.54 22.6201C613.6 22.4601 614.02 22.3701 614.06 22.1501C614.09 21.9701 614.13 21.7601 614.15 21.5601C614.17 21.3601 613.95 21.1401 613.97 20.9501C613.99 20.7401 614.19 20.5701 614.22 20.4001C614.27 20.1301 614.14 19.8501 614.25 19.7901C614.33 19.7501 614.13 19.6101 614.13 19.4101C613.98 19.4301 613.98 19.5402 613.83 19.5302C613.7 19.5302 613.73 19.1901 613.6 19.1501C613.65 19.1101 613.68 19.0501 613.71 19.0001C613.76 18.8701 613.79 18.7301 613.79 18.6001C613.79 18.5501 613.58 18.5801 613.54 18.5201C613.44 18.3701 613.68 18.0401 613.6 17.8801C613.52 17.7201 613.18 17.6902 613.11 17.5302C613.04 17.3702 612.96 17.2201 612.88 17.0601C612.79 16.9201 612.68 16.7801 612.56 16.6601C612.46 16.5201 612.56 16.1701 612.43 16.0601C612.4 16.0401 612.2 15.9101 612.23 15.8801C612.34 15.8501 612.47 15.8601 612.58 15.8901C612.66 15.9401 612.74 16.0001 612.81 16.0701C612.87 15.9801 612.93 15.9301 612.99 15.8401C613.01 15.9001 613.16 16.0601 613.15 16.1201C613.15 16.1601 613.05 16.2302 613.03 16.2802C613.26 16.2702 613.5 16.2201 613.72 16.1501L613.78 15.8101C613.65 15.6801 613.31 15.7501 613.17 15.6301C613.12 15.5901 613.13 15.4101 613.06 15.3901C612.91 15.3401 612.81 15.3901 612.67 15.3401C612.82 15.2501 612.89 15.1201 613.04 15.1101C613.09 15.1101 613.15 15.1101 613.2 15.1101C613.1 14.9301 613.18 14.7201 613.08 14.5401C612.95 14.3501 612.75 14.2201 612.53 14.1701C612.34 14.1201 612.09 14.2501 611.88 14.2401C611.64 14.2301 611.42 14.0302 611.25 14.0302C611.19 14.0302 611.11 14.0702 611.04 14.0302C610.93 14.5102 610.83 14.6701 610.48 14.3901C610.47 14.3901 610.56 14.1401 610.55 14.1501C610.33 14.2301 610.14 14.3701 610.01 14.5501C609.89 14.7501 609.63 14.8701 609.51 15.0701L609.73 15.1401C609.7 15.2901 609.69 15.4401 609.7 15.5901C609.7 15.7501 609.41 15.8401 609.44 15.9801C609.27 16.1301 609.39 16.4201 609.43 16.7301C609.43 16.7501 609 16.9701 608.94 16.9301C608.69 16.7201 608.54 16.5301 608.38 16.6001C608.2 16.6801 608.08 16.9401 607.93 17.1201C607.92 17.1401 607.77 17.1501 607.77 17.1701C607.77 17.3201 607.99 17.4101 608 17.5601C608.19 17.5501 608.38 17.5601 608.56 17.5701C608.83 17.5401 609.1 17.3701 609.19 17.4701C609.28 17.5701 609.06 17.8501 609.09 18.1101C609.1 18.2501 609.09 18.3901 609.03 18.5201C608.97 18.6801 609.07 18.9202 608.97 19.0302C608.84 19.1702 608.8 19.3701 608.68 19.5001C608.56 19.6401 608.11 19.5901 608.05 19.7601C607.99 19.9201 608.24 20.1501 608.26 20.3601C608.14 20.5501 608.05 20.7601 608.01 20.9901C607.99 21.1801 607.93 21.3901 607.91 21.6101C607.88 21.8301 608.02 22.0701 607.99 22.2601C607.98 22.4601 607.91 22.6601 607.81 22.8301C607.62 22.9401 607.33 22.8501 607.13 22.9401C607.1 22.9501 607.24 23.4501 607.22 23.7501C607.2 24.0501 607.25 24.1701 607.23 24.2001C607.31 24.2201 607.23 24.4301 607.3 24.4701C607.41 24.5401 607.65 24.6101 607.64 24.6701C607.61 24.8401 607.56 25.0201 607.52 25.1901C607.45 25.3601 607.38 25.5201 607.3 25.6801C607.1 26.2101 607.65 26.3001 607.9 26.3201C607.87 26.1701 607.86 25.9201 607.82 25.7701C607.98 25.7601 607.99 25.5302 608.15 25.5302C608.25 25.5302 608.46 25.7901 608.56 25.8101C608.61 25.6501 608.57 25.4001 608.67 25.3601C608.9 25.2701 609.19 25.0601 609.41 25.1401C609.62 25.2201 609.45 25.3601 609.42 25.4901C609.4 25.6201 609.63 25.8501 609.57 25.9801C609.54 26.0501 609.54 26.1401 609.51 26.2001L609.24 26.0302C609.13 26.1502 609.24 26.4701 609.13 26.5901C609.02 26.7101 608.87 26.7801 608.76 26.9001C608.75 26.9101 608.55 26.8201 608.56 26.8401C608.56 26.9801 608.79 27.0801 608.81 27.2201C608.84 27.4501 608.83 27.5501 609 27.4401C609.13 27.3601 609.11 27.3801 609.24 27.3101C609.24 27.4501 609.27 27.4001 609.28 27.5401C609.28 27.6501 609.38 27.7201 609.4 27.8301C609.48 27.7301 609.67 27.7701 609.76 27.6801C609.8 27.6401 609.73 27.5201 609.78 27.5001C609.79 27.6901 610 27.8601 610 28.0401C610 28.2301 609.8 28.4101 609.74 28.5701C609.68 28.7401 609.57 28.9001 609.43 29.0201C609.28 29.1301 609.11 29.2101 608.93 29.2601C608.88 29.0601 608.69 28.9201 608.6 28.7301C608.53 28.6601 608.43 28.6301 608.33 28.6401C608.28 28.8301 608.43 28.8401 608.37 29.0201C608.24 28.9501 608.09 29.0601 607.95 29.0001C607.8 28.9401 607.67 28.5401 607.53 28.5701C607.32 28.6201 607.11 28.6401 606.89 28.6301C606.66 28.6101 606.42 28.6901 606.24 28.5401C606.09 28.4201 606.14 28.1501 606.04 27.9001C606.04 27.8901 605.72 27.8901 605.69 27.8801C605.82 27.7101 606.09 27.6201 606.12 27.4401C606.14 27.1901 606.09 26.9301 605.97 26.7101C605.77 26.8401 605.52 27.2001 605.31 27.3301C605.21 27.1201 605.12 26.8901 605.06 26.6601C605.01 26.4301 604.97 26.4101 604.77 26.3301C604.63 26.2701 604.56 26.8001 604.27 26.8901C604.2 26.9101 604.08 26.4701 603.99 26.4501C603.85 26.4301 603.72 26.7301 603.6 26.7901C603.36 26.8901 603.09 26.9001 602.84 26.8101C602.68 26.7501 602.64 26.4501 602.43 26.2301C602.31 26.1001 601.98 26.1401 601.81 26.1601C601.7 26.1601 601.59 26.2101 601.52 26.3001C601.45 26.3901 601.42 26.5001 601.43 26.6101C601.44 26.8401 601.36 27.1401 601.19 27.1801C601.01 27.2301 600.8 26.6301 600.61 26.6801C600.44 26.7501 600.26 26.7802 600.08 26.7802C599.9 26.7602 599.65 26.8601 599.48 26.7201C599.49 26.8801 599.54 27.0401 599.6 27.1901C599.86 26.9401 599.53 26.7901 599.4 26.6301C599.26 26.4301 599.2 26.1801 599.24 25.9301C599.1 25.9301 598.9 25.9001 598.83 25.9701C598.71 26.0901 598.76 26.3001 598.73 26.4801C598.69 26.7001 598.33 26.7901 598.29 26.9201C598.23 27.1401 598.36 26.7301 598.18 26.7901C598 26.8101 597.82 26.8101 597.64 26.7901C597.5 26.7901 597.38 27.1201 597.24 27.0601C597.35 26.9901 597.47 26.9401 597.59 26.9201C597.77 26.8901 597.93 26.7701 598 26.6001C598.07 26.4601 598.1 26.8801 598.09 26.7101C598.09 26.5101 597.91 26.3601 597.88 26.2401C597.78 25.8601 597.73 26.5301 597.53 26.7001L597.44 26.6001C597.34 26.6901 597.17 26.7101 597.06 26.8001C596.71 27.1001 596.86 26.9301 596.88 26.6301C596.7 26.6801 596.34 26.6301 596.17 26.6901C596 26.7601 595.94 27.0901 595.77 27.1701C595.6 27.2501 595.46 26.7701 595.29 26.8401C595.12 26.9201 594.88 26.8201 594.71 26.8901C594.53 26.9201 594.35 26.9501 594.16 26.9601C593.98 27.0101 593.78 27.2401 593.59 27.2601C593.77 27.4801 593.84 27.4301 594.08 27.5901C594.32 27.7501 594.41 27.6101 594.64 27.7701C594.88 27.9301 594.93 27.8501 595.17 28.0101C595.41 28.1701 595.33 28.2901 595.56 28.4501C595.8 28.6101 595.78 28.6301 596.02 28.7901C596.26 28.9501 596.21 29.0201 596.44 29.1801C596.68 29.3401 596.69 29.3201 596.93 29.4801C597.17 29.6401 597.21 29.5701 597.45 29.7301C597.69 29.8901 597.71 29.8501 597.95 30.0101C598.19 30.1701 598.08 30.3301 598.31 30.4901C598.55 30.6501 598.58 30.6001 598.82 30.7601C599.06 30.9201 599.02 30.9801 599.26 31.1401C599.5 31.3001 599.63 31.0601 599.89 31.1801C600.1 31.1801 600.23 31.4801 600.42 31.4501C600.63 31.3901 600.81 31.2701 600.96 31.1201C601.1 30.9801 601.3 30.9101 601.49 30.9201C601.73 30.9601 601.96 31.1101 601.97 31.2601C602 31.5301 602.14 31.3801 602.37 31.3501C602.55 31.3301 602.83 31.6301 603.03 31.5901C603.27 31.5401 603.62 31.2501 603.73 31.4201C603.79 31.5201 603.81 31.8301 603.97 31.8601C604.13 31.8901 604.43 31.6001 604.49 31.6801C604.62 31.8501 604.73 32.1001 604.92 32.2201C605.12 32.3301 605.49 32.2401 605.64 32.4001C605.77 32.5501 605.6 32.8401 605.6 33.1201C605.6 33.2801 606.12 33.3702 606.26 33.5302C606.32 33.6002 606.8 33.3302 606.91 33.5302C606.99 33.6802 606.54 34.3801 606.58 34.5601C606.65 34.7401 606.66 34.9301 606.61 35.1101C606.96 35.1301 606.96 35.2701 606.82 35.4401C606.7 35.6001 606.59 35.7001 606.65 35.8301C606.73 35.9801 606.63 36.2301 606.7 36.3801C606.79 36.5301 606.94 36.6401 607.1 36.6901C607.23 36.7401 607.34 36.6501 607.56 36.5901C607.68 36.5601 607.83 36.6901 607.95 36.6901C607.88 36.5401 607.81 36.3901 607.72 36.2501C607.64 36.1501 607.59 36.1901 607.49 36.1101C607.74 35.9601 607.86 35.8601 608.11 35.7101C608.13 35.9101 608.01 36.0501 608.07 36.2301C608.13 36.3901 608.46 36.2901 608.57 36.4301C608.78 36.4301 608.86 36.6401 608.98 36.6401C609.23 36.6401 609.18 36.7601 609.26 36.8801C609.35 37.0101 609.41 37.1401 609.46 37.2901C609.6 37.7501 609.61 37.8101 609.23 37.7701C608.94 37.7701 608.66 37.7401 608.37 37.7101C608.28 37.6901 608.16 37.4201 608.08 37.3801C608.02 37.5001 607.8 37.6501 607.72 37.7901C607.61 37.9701 607.83 38.1701 607.88 38.2401C607.98 38.3901 607.82 38.7701 607.89 38.9701C607.96 39.1401 608.11 39.2701 608.48 39.1301C608.5 39.1301 608.53 39.3801 608.61 39.4801C608.7 39.5901 608.78 39.5501 608.89 39.6401C609.01 39.5201 609.01 39.5601 609.11 39.4201C609.15 39.5301 609.1 39.7001 609.14 39.8201C609.37 39.9801 609.46 40.1301 609.24 40.2901C609.23 40.2901 609.12 40.1101 609.11 40.1201C608.91 40.3801 608.91 40.4301 608.78 40.3801C608.61 40.3301 608.47 40.2401 608.35 40.1201C608.33 40.2601 608.14 40.3001 608.05 40.4401C607.98 40.5501 607.94 40.7301 608.22 40.8901C608.3 40.9901 608.34 41.1201 608.33 41.2501C608.29 41.4001 608.21 41.5501 608.16 41.7001C608.12 41.8501 608.14 42.0301 608.1 42.1801C607.99 42.5601 607.86 42.7701 608.17 42.8301C608.06 43.0001 608.31 43.1101 608.24 43.2501C608.14 43.4301 607.82 43.4601 607.78 43.6101C607.74 43.7801 607.98 43.9501 607.98 44.1401C607.98 44.2901 607.6 44.5001 607.63 44.7001L608.45 49.7501ZM613.19 37.3301C613.22 37.3801 613.26 37.3801 613.3 37.4601C613.22 37.5101 613.15 37.4401 613.08 37.4901C613.05 37.4301 612.98 37.4601 613 37.4301C613.05 37.3701 613.13 37.3801 613.2 37.3401L613.19 37.3301ZM613.34 26.1301C613.41 26.2701 613.45 26.3601 613.52 26.5001C613.28 26.4601 613.07 26.4601 613.34 26.1301ZM613.28 27.7201C613.27 27.8001 613.3 27.8401 613.28 27.9301C613.24 27.9001 613.3 27.8801 613.26 27.8501C613.31 27.8001 613.22 27.7801 613.27 27.7201H613.28ZM597.49 26.7701C597.49 26.7701 597.52 26.7901 597.51 26.8201C597.49 26.7701 597.59 26.7401 597.58 26.6901C597.6 26.7201 597.47 26.7401 597.49 26.7701ZM589.03 48.0001C589.01 47.9401 588.96 47.8801 588.98 47.8601C589.15 47.6901 589.38 47.6401 589.55 47.4901C589.65 47.5701 589.67 47.4901 589.71 47.5201C589.49 47.6901 589.25 47.8201 589.02 47.9901L589.03 48.0001ZM589.17 46.7101C589.26 46.7501 589.33 46.7301 589.4 46.8001C589.45 46.8501 589.46 46.9201 589.42 46.9801C589.37 47.0601 589.35 47.1501 589.27 47.2001C589.23 47.1101 589.14 47.0401 589.12 46.9501C589.1 46.8601 589.17 46.8001 589.17 46.7101ZM590.12 48.5401C590.03 48.5801 589.87 48.4501 589.74 48.3701C589.85 48.3301 589.97 48.3101 590.09 48.3101C590.21 48.2601 590.34 48.2301 590.47 48.2201C590.38 48.3601 590.27 48.4701 590.13 48.5401H590.12ZM590.12 44.7501C590.23 44.7301 590.35 44.7701 590.42 44.8601C590.54 45.1101 590.1 44.5001 590.11 44.7701C590.11 45.0101 590.35 45.1701 590.51 45.2701C590.7 45.3601 590.9 45.4201 591.1 45.4401C591.06 45.5901 590.89 45.7801 590.88 45.9701C590.86 46.1301 590.81 46.2901 590.74 46.4301C590.67 46.6001 590.74 46.7101 590.5 46.4901C590.38 46.3701 590.11 46.4601 589.83 46.5001C589.61 46.5601 589.41 46.6501 589.23 46.7901L589.11 46.5601C588.88 46.6601 588.89 46.1001 588.61 46.6801C588.38 46.5601 588.01 46.3201 587.78 46.2001C587.86 46.1201 587.95 46.0501 588.02 46.0501C588.34 46.0901 588.67 45.9801 588.89 45.7501C589.02 45.6301 589.04 45.4101 589.19 45.3001C589.33 45.2001 589.48 45.1001 589.63 45.0101C589.78 44.9201 589.95 44.8501 590.1 44.7501H590.12ZM587.5 43.0001C587.47 42.9501 587.39 42.9301 587.41 42.8901C587.43 42.8401 587.52 42.9201 587.57 42.8901C587.62 42.9301 587.66 42.8601 587.71 42.9001C587.64 42.9501 587.57 42.9501 587.5 43.0001ZM594.4 27.2401C594.46 27.2301 594.52 27.2401 594.57 27.2601C594.46 27.3101 594.33 27.2401 594.24 27.2701C594.24 27.2701 594.24 27.3001 594.22 27.2601C594.28 27.2401 594.34 27.2401 594.4 27.2401ZM596.61 26.9001C596.53 26.8901 596.45 26.8502 596.39 26.7802C596.46 26.7202 596.55 27.1901 596.62 27.1801C596.69 27.1801 596.75 26.7002 596.87 26.7802C596.75 26.8602 596.68 26.9001 596.61 26.9001ZM597.67 29.2501C597.54 29.2501 597.42 29.2501 597.3 29.2001C597.4 29.1601 597.51 29.2001 597.61 29.2001C597.7 29.1901 597.78 29.1001 597.88 29.1201C597.83 29.1901 597.76 29.2401 597.68 29.2601L597.67 29.2501ZM597.98 29.0801C597.98 29.0201 597.91 29.0101 597.95 28.9601C597.98 28.9901 597.91 28.9901 597.95 29.0101C597.91 29.0301 598.03 29.0701 597.99 29.0801H597.98ZM600.5 27.3601C600.41 27.3201 600.32 27.2701 600.24 27.2101C600.29 27.1701 600.37 27.2301 600.53 27.1001C600.57 27.1801 600.61 27.1601 600.62 27.2601C600.62 27.3101 600.52 27.3701 600.5 27.3601ZM603.55 28.1001C603.5 28.2401 603.51 28.4101 603.46 28.5501C603.42 28.4701 603.4 28.3802 603.4 28.2802C603.33 27.9102 603.42 27.9001 603.7 27.9501C603.66 28.0001 603.57 28.0301 603.55 28.0901V28.1001ZM605.23 27.3201C605.23 27.3201 605.23 27.2701 605.25 27.2601C605.23 27.2801 605.19 27.1901 605.17 27.2201C605.17 27.2001 605.22 27.3301 605.23 27.3201ZM604.2 27.3801C604.2 27.3801 604.34 27.2301 604.35 27.2401C604.47 27.3501 604.45 27.4901 604.57 27.6401C604.48 27.7601 604.53 27.8101 604.47 27.8901C604.36 27.7301 604.29 27.5501 604.2 27.3801ZM605.02 30.5001C604.82 30.3101 604.66 30.1001 604.53 29.8601C604.48 29.7101 604.67 29.5401 604.73 29.3701C604.76 29.2601 604.81 29.1501 604.89 29.0601C604.99 29.1401 605.05 29.2501 605.07 29.3701C605.02 29.3901 604.82 29.4001 604.78 29.4201C604.78 29.6101 604.81 29.7901 604.84 29.9801C604.91 30.1701 605.17 30.2901 605.25 30.4801C605.15 30.5001 605.05 30.5301 605.02 30.5001ZM604.92 28.2701C604.92 28.1701 604.88 28.0201 604.89 28.0201C605.16 27.9801 605.37 28.0501 605.64 28.0201C605.61 28.2701 605.55 28.2501 605.4 28.2701C605.24 28.2901 605.06 28.2001 604.92 28.2701ZM605.55 29.2802C605.5 29.2502 605.45 29.2201 605.41 29.1701C605.47 29.1501 605.5 29.2101 605.54 29.2301C605.58 29.2501 605.64 29.2301 605.67 29.2901C605.63 29.3101 605.59 29.3101 605.55 29.2901V29.2802ZM605.94 30.6801C605.94 30.6801 605.94 30.6301 605.96 30.6201C605.94 30.6401 605.89 30.5601 605.87 30.5801C605.87 30.5601 605.93 30.6901 605.94 30.6801ZM606.16 33.6101C606.18 33.5201 606.12 33.4301 606.16 33.3801C606.22 33.3301 606.23 33.3901 606.32 33.3801C606.27 33.4601 606.32 33.4701 606.26 33.5401C606.22 33.5901 606.2 33.5801 606.15 33.6101H606.16ZM606.49 33.1901L606.51 33.2401C606.51 33.2401 606.57 33.3201 606.59 33.3001C606.59 33.3101 606.51 33.1801 606.5 33.1901H606.49ZM606.98 30.1301C606.85 30.2901 606.75 30.4801 606.58 30.5601C606.41 30.6401 606.31 30.5902 606.09 30.5302C606.16 30.3802 606.12 30.2101 606.22 30.1901C606.51 30.1101 606.68 30.0001 606.74 29.8601C606.84 29.6501 606.77 29.4001 606.58 29.2701C606.66 29.1901 606.61 29.2702 606.67 29.2802C606.89 29.3102 607.07 29.3201 607.13 29.5401C607.18 29.7501 607.13 29.9701 606.98 30.1301ZM608.82 29.3101C608.8 29.4001 608.82 29.4402 608.82 29.5302C608.78 29.5002 608.84 29.4901 608.8 29.4601C608.86 29.4001 608.77 29.3701 608.83 29.3201L608.82 29.3101ZM608.78 34.9401C608.78 34.9401 608.85 34.9701 608.89 35.0201C608.85 35.0701 608.82 35.0101 608.77 35.0501C608.72 34.9801 608.65 35.0301 608.6 34.9601C608.66 34.9301 608.72 34.9201 608.78 34.9301V34.9401ZM608.73 36.1701C608.58 36.1701 608.43 36.1601 608.28 36.1301C608.31 35.9601 608.46 36.0601 608.57 35.9401C608.65 35.9101 608.69 35.7602 608.72 35.7802C608.82 35.8702 608.9 35.9801 608.98 36.0901C608.9 36.1401 608.82 36.1601 608.73 36.1601V36.1701ZM613.05 43.1801C613.15 43.3901 613.23 43.6201 613.3 43.8501C613.3 43.8501 613.22 43.8701 613.21 43.8501C613.11 43.6401 612.92 43.4801 612.84 43.2601C612.82 43.1901 612.81 43.1201 612.82 43.0401C612.91 43.0501 612.99 43.1001 613.05 43.1801ZM612.73 42.9501C612.73 42.9501 612.79 43.0001 612.81 43.0401C612.76 43.0301 612.81 42.9601 612.76 42.9501C612.79 42.9201 612.7 42.9801 612.73 42.9501ZM612.68 45.0501C612.77 44.9701 612.87 44.9201 612.98 44.8901C612.95 44.9801 612.86 45.0101 612.8 45.0701C612.74 45.1301 612.72 45.2301 612.63 45.2701C612.61 45.1901 612.63 45.1101 612.68 45.0401V45.0501ZM612.58 45.3701C612.63 45.6201 612.18 45.6802 612.45 46.0302C612.63 46.2602 612.5 46.3401 612.19 46.2101C612.01 46.1301 611.79 46.1401 611.61 46.0501C611.72 45.9101 611.79 45.7101 611.93 45.6201C612.14 45.5201 612.35 45.4301 612.58 45.3701ZM612.62 27.7802C612.71 27.7502 612.8 27.7301 612.89 27.7301C612.85 27.8301 612.73 27.8501 612.68 27.9501C612.48 28.0201 612.35 28.1901 612.15 28.2401C612.1 28.1601 612.06 28.0701 612.02 27.9701C612.21 27.8901 612.41 27.8302 612.61 27.7802H612.62ZM612 38.3901C611.95 38.4101 611.93 38.4701 611.89 38.4601C611.84 38.4301 611.93 38.3601 611.89 38.3001C611.94 38.2601 611.87 38.2201 611.92 38.1801C611.96 38.2501 611.95 38.3101 612 38.3901ZM611.86 34.7301C611.78 34.8101 611.69 34.8901 611.6 34.9501C611.6 34.8601 611.64 34.8601 611.67 34.8401C611.75 34.7801 611.78 34.6601 611.88 34.6201C611.88 34.6701 611.88 34.7101 611.86 34.7301ZM611.38 44.3701C611.41 44.2801 611.46 44.2001 611.53 44.1301C611.55 44.1901 611.51 44.2201 611.49 44.2701C611.47 44.4401 611.43 44.6101 611.36 44.7701C611.33 44.6401 611.34 44.5101 611.37 44.3801L611.38 44.3701ZM611.22 42.0501C611.22 42.0501 611.12 41.9701 611.13 41.9501C611.19 41.8801 611.27 41.9501 611.34 41.9101C611.37 41.9701 611.4 41.9101 611.45 42.0201C611.37 42.0401 611.29 42.0501 611.21 42.0501H611.22ZM611.79 29.7501C611.79 29.7501 611.83 29.7701 611.84 29.8101C611.77 29.8101 611.79 29.7702 611.72 29.7802C611.77 29.7302 611.73 29.8001 611.79 29.7501ZM611.6 28.2601C611.65 28.3201 611.68 28.3001 611.72 28.3401C611.64 28.3901 611.52 28.3401 611.44 28.3701C611.42 28.3701 611.44 28.4401 611.41 28.4201C611.47 28.3501 611.54 28.3301 611.6 28.2601ZM611.29 37.8501C611.3 37.9401 611.34 37.9901 611.35 38.0801C611.24 38.0301 611.23 37.9601 611.12 37.9101C611.22 37.8701 611.18 37.8901 611.29 37.8501ZM610.82 38.2201L610.79 38.1601C611.01 38.3001 611.22 38.4701 611.4 38.6501C611.49 38.7601 611.53 38.8902 611.52 39.0302C611.37 39.0302 611.09 39.0801 611.07 39.0201C611 38.8601 611 38.6201 610.88 38.5501C610.76 38.4801 610.72 38.6501 610.54 38.6701C610.67 38.4101 610.62 38.4201 610.82 38.2101V38.2201ZM609.87 43.8901C609.82 43.8401 609.79 43.8302 609.73 43.7802C609.77 43.7502 609.75 43.8002 609.79 43.7802C609.8 43.8602 609.86 43.8101 609.87 43.8901ZM610.08 16.6401C610.08 16.6401 610.11 16.6701 610.11 16.6801L610.2 16.7601L610.08 16.6501V16.6401ZM610.04 29.0901C610.09 29.1401 610.15 29.1401 610.2 29.1901C610.13 29.1901 610.12 29.0901 610.05 29.0901C610.07 29.0501 610.01 29.1401 610.04 29.0901ZM609.99 38.6001C609.99 38.6001 610.01 38.5801 610 38.5601C609.97 38.5201 609.94 38.4701 609.92 38.4201C609.89 38.4601 609.98 38.5501 609.99 38.6001ZM610.42 29.4401C610.38 29.3501 610.31 29.3101 610.27 29.2301C610.36 29.2701 610.35 29.3701 610.44 29.4201C610.39 29.4601 610.47 29.4001 610.43 29.4501L610.42 29.4401ZM610.44 16.4001C610.38 16.4501 610.35 16.5401 610.28 16.5801C610.34 16.4801 610.51 16.3701 610.55 16.2001C610.58 16.2201 610.5 16.2001 610.52 16.2201C610.55 16.2501 610.49 16.3601 610.44 16.4001ZM610.25 14.7901C610.2 14.8601 610.18 14.9702 610.13 15.0302C610.16 14.9402 610.28 14.9201 610.31 14.8301C610.34 14.8501 610.25 14.7901 610.25 14.7901ZM610.04 15.1701C610.02 15.2601 610.04 15.3101 610.03 15.3901C609.99 15.3601 610.05 15.3401 610.01 15.3001C610.07 15.2501 609.98 15.2201 610.04 15.1701ZM609.68 14.9401C609.68 14.9401 609.71 15.0001 609.68 15.0201L609.74 15.1001C609.74 15.1001 609.66 14.9601 609.67 14.9501L609.68 14.9401ZM609.34 18.7901C609.36 18.8701 609.43 18.9201 609.44 18.9901C609.41 18.9401 609.46 18.8201 609.44 18.7701C609.44 18.7701 609.33 18.8101 609.34 18.7901ZM609.49 19.1501C609.62 19.2601 609.75 19.3101 609.88 19.4201C609.74 19.5101 609.59 19.5801 609.44 19.6201C609.33 19.6801 609.21 19.7201 609.09 19.7301C609.22 19.5201 609.36 19.3701 609.49 19.1601V19.1501ZM608.92 19.8101C608.85 19.8601 608.84 19.8701 608.77 19.9201C608.77 19.9201 608.79 19.9601 608.77 19.9201C608.86 19.9001 608.84 19.8201 608.93 19.8001L608.92 19.8101ZM608.61 20.5302C608.66 20.4802 608.65 20.4201 608.7 20.4101C608.85 20.3801 608.87 20.5901 608.97 20.8801C609.08 21.0601 609.16 21.2401 609.24 21.4401C609.28 21.6301 609.35 21.8301 609.39 22.0401C609.42 22.2401 609.3 22.4701 609.33 22.6701C609.36 22.8801 609.33 23.0901 609.36 23.2901C609.39 23.5101 609.59 23.6901 609.62 23.8801C609.67 24.1101 609.73 24.3301 609.8 24.5501C609.53 24.5201 609.3 24.3501 609.2 24.1001C609.15 23.9401 609.34 23.6701 609.29 23.4501C609.25 23.2601 608.98 23.1001 608.95 22.9001C608.92 22.7001 609.04 22.4802 609.01 22.2802C608.98 22.0702 609.05 21.8601 609.02 21.6701C608.98 21.4501 609.04 21.2201 609 21.0501C608.96 20.8301 608.82 20.6401 608.61 20.5401V20.5302ZM609.51 26.3901C609.46 26.3501 609.38 26.3402 609.36 26.2802C609.34 26.2302 609.4 26.2601 609.39 26.2001C609.44 26.2301 609.43 26.1701 609.47 26.2001C609.53 26.2501 609.59 26.3001 609.64 26.3601C609.6 26.3801 609.55 26.3901 609.51 26.3801V26.3901ZM609.65 30.2001C609.62 30.1101 609.6 30.0101 609.58 29.9201C609.64 29.9701 609.68 30.0501 609.68 30.1401C609.71 30.2401 609.71 30.3601 609.68 30.4601C609.65 30.3801 609.64 30.2901 609.63 30.2101L609.65 30.2001ZM609.51 38.1801C609.51 38.1801 609.48 38.1101 609.51 38.0801C609.51 38.1001 609.45 38.0401 609.44 38.0501C609.44 38.0501 609.53 38.1801 609.52 38.1801H609.51ZM609.31 38.6001C609.22 38.4601 609.12 38.3701 609.03 38.2301C609.15 38.2101 609.19 38.2601 609.31 38.2401C609.28 38.4001 609.34 38.4401 609.31 38.5901V38.6001ZM609.64 47.1801C609.7 47.1401 609.84 47.2001 610.12 47.3001C609.93 47.4301 609.72 47.5301 609.5 47.5901C609.41 47.6201 609.31 47.6001 609.23 47.5501C609.35 47.4101 609.49 47.2801 609.65 47.1801H609.64ZM609.96 48.3601C609.87 48.2101 609.79 48.1201 609.7 47.9701C609.83 47.9401 609.86 47.9701 609.99 47.9501C609.95 48.1201 609.99 48.1801 609.96 48.3601ZM610.03 48.8101C610.03 48.6801 609.98 48.6001 609.98 48.4701C610.05 48.5101 610.01 48.5701 610.08 48.6101C610.02 48.6901 610.09 48.7201 610.03 48.8101ZM609.85 45.5302C609.86 45.4702 609.83 45.4101 609.87 45.3901C609.95 45.3501 610.03 45.4601 610.12 45.4401C610.12 45.5001 610.17 45.4401 610.19 45.5401C610.07 45.5501 609.97 45.5201 609.85 45.5401V45.5302ZM609.06 41.1501C609.13 41.1501 609.21 41.1901 609.36 41.3101C609.24 41.3801 609.09 41.4001 608.95 41.3801C608.85 41.3601 608.75 41.3001 608.69 41.2201C608.81 41.1801 608.93 41.1601 609.06 41.1601V41.1501ZM608.52 44.3901C608.52 44.3901 608.52 44.3001 608.55 44.2701C608.53 44.3201 608.42 44.3101 608.4 44.3701C608.4 44.3401 608.51 44.4101 608.52 44.4001V44.3901ZM608.66 44.1401C608.74 44.0301 608.77 43.9501 608.85 43.8401C608.9 43.9101 608.85 43.9301 608.91 44.0001C608.78 44.0301 608.79 44.1001 608.66 44.1401ZM609.1 48.5302C609.1 48.5302 609 48.5601 608.94 48.5501C609 48.4701 609.1 48.5001 609.16 48.4201C609.21 48.4701 609.23 48.4001 609.22 48.4201C609.2 48.4801 609.15 48.5001 609.1 48.5201V48.5302ZM609.26 49.2201C609.38 49.2501 609.51 49.2301 609.63 49.2701C609.58 49.3901 609.56 49.3401 609.54 49.3901C609.43 49.3201 609.32 49.3701 609.21 49.3001C609.21 49.3001 609.25 49.2201 609.26 49.2201ZM609.39 50.1901C609.44 50.1301 609.45 50.1001 609.5 50.0401C609.53 50.0801 609.48 50.0601 609.51 50.1101C609.43 50.1201 609.47 50.1801 609.39 50.1901ZM609.72 54.5801C609.7 54.4901 609.62 54.4301 609.6 54.3401C609.65 54.4101 609.6 54.5401 609.65 54.6101C609.65 54.6101 609.74 54.5601 609.72 54.5801ZM609.88 53.2802C609.84 53.1402 609.76 53.1002 609.78 53.0302C609.8 52.9701 609.9 53.0501 609.97 53.0101C610.01 53.0701 610.09 53.0301 610.08 53.0601C610.05 53.1401 609.98 53.1502 609.88 53.2802ZM610.4 54.8201C610.33 54.7401 610.24 54.7201 610.17 54.6501C610.22 54.6101 610.29 54.6801 610.42 54.5701C610.47 54.6501 610.52 54.6301 610.55 54.7301C610.55 54.7701 610.47 54.7801 610.41 54.8301L610.4 54.8201ZM609.53 44.8501L609.47 44.8701C609.47 44.8701 609.61 44.9001 609.62 44.8801C609.75 44.6801 609.8 44.4901 609.97 44.4401C610.17 44.3901 610.38 44.4401 610.53 44.5701C610.58 44.6101 610.5 44.6301 610.53 44.7101C610.33 44.7501 610.13 44.8301 609.95 44.9301C609.78 45.0001 609.72 45.1301 609.53 44.8401V44.8501ZM610.85 53.2901C610.78 53.2601 610.73 53.2001 610.71 53.1301C610.71 53.1201 610.81 53.1401 610.85 53.1501C610.93 53.1701 611.02 53.1301 611.15 53.2301C610.99 53.2901 610.92 53.3101 610.85 53.2901ZM611.18 47.7802C611.26 47.7302 611.32 47.6401 611.37 47.6701C611.57 47.7601 611.72 47.9701 611.94 48.0801C612.13 48.1701 612.37 48.1801 612.61 48.2901C612.33 48.4601 612.18 48.6301 612.11 48.6101C611.95 48.5501 611.91 48.2701 611.77 48.1601C611.58 48.0101 611.36 47.9301 611.17 47.7901L611.18 47.7802ZM612.42 51.2201C612.36 51.2501 612.36 51.2901 612.3 51.3201C612.25 51.2801 612.3 51.2401 612.25 51.2101C612.31 51.1801 612.25 51.1201 612.31 51.1301C612.37 51.1301 612.36 51.1901 612.42 51.2201ZM611.84 53.9801C611.82 53.9301 611.75 53.9301 611.74 53.8701C611.74 53.8501 611.85 53.9201 611.87 53.8901C612.18 53.6801 612.24 53.5101 612.37 53.6401C612.51 53.8101 612.62 54.0001 612.71 54.2001C612.57 54.1701 612.42 54.0101 612.27 53.9801C612.12 53.9501 611.98 54.0001 611.83 53.9701L611.84 53.9801ZM613.14 52.1001C613.12 52.0401 613.07 52.0001 613.1 51.9701C613.16 51.8901 613.25 51.9701 613.33 51.9001C613.39 51.9601 613.43 51.8801 613.47 51.9201C613.36 52.0001 613.25 52.0201 613.14 52.0901V52.1001ZM613.74 51.4101C613.74 51.4101 613.74 51.3601 613.75 51.3501C613.73 51.3801 613.67 51.2901 613.65 51.3201C613.65 51.3001 613.72 51.4201 613.74 51.4101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.57 56.5202C609.57 56.5202 609.49 56.5202 609.45 56.5202C609.07 56.4802 608.7 56.4102 608.34 56.3002C608.3 56.3002 608.25 56.3002 608.21 56.2802C607.99 56.2002 607.85 55.9902 607.87 55.7602C607.87 55.7302 607.88 55.6902 607.9 55.6602C607.87 55.4202 608.03 55.2002 608.26 55.1402V55.1202C608.26 55.1202 608.19 55.0502 608.17 55.0202C608.09 54.9302 608.02 54.8202 607.97 54.7002C607.96 54.6702 607.94 54.6402 607.92 54.6102C607.86 54.5602 607.81 54.5102 607.76 54.4602C607.73 54.4302 607.7 54.3902 607.66 54.3602C607.37 54.2902 607.15 54.0602 607.1 53.7702C607.08 53.6502 607.66 53.2302 608.19 52.9602C608.2 52.9402 608.25 52.8802 608.3 52.8102C608.22 52.6202 608.23 52.4202 608.33 52.2402L608.36 52.1502C608.36 52.1502 608.36 52.1102 608.31 52.0902C608.23 52.0502 608.16 51.9902 608.11 51.9102C608.11 51.9202 608.08 51.9102 608.05 51.8902C607.88 51.8002 607.75 51.6602 607.66 51.5002C607.55 51.2602 607.57 50.9702 607.72 50.7502C607.86 50.5502 608.07 50.4202 608.31 50.3802C608.29 50.2502 608.28 50.1302 608.29 50.0002C608.29 49.9202 608.31 49.8502 608.33 49.7702C608.33 49.7502 608.33 49.7302 608.34 49.7202L608.06 49.5102C608.21 49.3402 608.41 49.2302 608.63 49.2002C608.7 49.1802 608.78 49.1802 608.86 49.2002C608.86 49.2002 608.89 49.1202 608.92 49.0902H608.91C608.76 49.0602 608.64 48.9502 608.58 48.8102C608.52 48.6702 608.55 48.5102 608.64 48.3802C608.71 48.2802 608.82 48.2102 608.93 48.1702C608.99 48.1202 609.06 48.0902 609.14 48.0702C609.12 48.0702 609.1 48.0502 609.07 48.0402C608.94 47.9802 608.85 47.8602 608.83 47.7202C608.8 47.5802 608.84 47.4402 608.93 47.3302C609.08 47.1602 609.25 47.0102 609.44 46.8802C609.68 46.7202 609.92 46.8102 610.2 46.9102L610.32 46.9502C610.48 47.0102 610.59 47.1402 610.62 47.3102C610.64 47.4802 610.57 47.6402 610.44 47.7402L610.39 47.7702C610.47 47.8702 610.5 48.0002 610.48 48.1202C610.48 48.1502 610.48 48.1802 610.48 48.2102C610.48 48.2702 610.48 48.3302 610.48 48.3802C610.58 48.5102 610.61 48.6802 610.56 48.8302C610.56 48.9502 610.51 49.0602 610.44 49.1602C610.37 49.2502 610.26 49.3202 610.14 49.3302C610.14 49.3902 610.14 49.4502 610.11 49.5102C610.07 49.6102 610.02 49.7002 609.94 49.7702C609.93 49.7802 609.91 49.8002 609.9 49.8102C609.91 49.8202 609.93 49.8402 609.94 49.8602C609.99 49.9302 610.01 50.0002 610.02 50.0902C610.06 50.2702 609.99 50.4502 609.84 50.5602C609.81 50.5902 609.78 50.6202 609.75 50.6402C609.68 50.8802 609.52 51.0902 609.31 51.2202C609.15 51.3102 608.97 51.3502 608.79 51.3202C609.2 51.5302 609.38 52.0202 609.21 52.4402C609.21 52.4602 609.2 52.4802 609.19 52.4902C609.26 52.5802 609.29 52.7002 609.29 52.8102C609.27 52.9902 608.41 53.3902 608.17 53.6102C608.26 53.6802 608.35 53.7602 608.42 53.8502C608.44 53.8802 608.47 53.9002 608.49 53.9202C608.58 53.9902 609.25 54.0802 609.3 54.1602C609.35 54.0902 609.41 54.0402 609.49 54.0002C609.69 53.9102 609.92 53.9802 610.04 54.1602C610.07 54.2002 610.09 54.2402 610.1 54.2802C610.14 54.2702 610.19 54.2602 610.23 54.2502C610.42 54.1302 610.68 54.1702 610.82 54.3502C610.93 54.4302 611 54.5502 611.03 54.6802C611.06 54.8102 611.03 54.9502 610.96 55.0602C611.13 55.0602 611.29 55.1502 611.41 55.2702C611.52 55.0702 611.68 54.8902 611.87 54.7602C612.02 54.6802 612.18 54.6302 612.34 54.6102V54.5602H612.31C612.31 54.5602 612.25 54.5102 612.22 54.4902C612.19 54.4902 612.16 54.4902 612.14 54.4902C612.03 54.4902 611.92 54.4902 611.81 54.4802C611.71 54.4602 611.63 54.4102 611.56 54.3402C611.46 54.2602 611.39 54.1502 611.36 54.0302C611.33 53.9102 611.36 53.7802 611.44 53.6702C611.42 53.6802 611.39 53.7002 611.37 53.7102C611.19 53.8102 610.98 53.8302 610.78 53.7902C610.63 53.7402 610.51 53.6402 610.42 53.5102C610.39 53.5402 610.37 53.5602 610.35 53.5802C610.33 53.6002 610.31 53.6202 610.29 53.6402C610.19 53.7702 610.02 53.8302 609.86 53.8002C609.7 53.7702 609.56 53.6502 609.52 53.4902C609.52 53.4702 609.51 53.4602 609.5 53.4502C609.41 53.3102 609.38 53.1402 609.42 52.9802C609.49 52.7402 609.73 52.6002 609.97 52.6402C610.03 52.6402 610.09 52.6402 610.15 52.6402C610.19 52.6502 610.23 52.6702 610.27 52.6902C610.36 52.7202 610.44 52.7702 610.5 52.8402C610.66 52.7402 610.86 52.7202 611.04 52.7902C611.2 52.7902 611.36 52.8402 611.48 52.9402C611.61 53.0402 611.68 53.2002 611.66 53.3602C611.66 53.4402 611.62 53.5102 611.58 53.5702C611.66 53.5302 611.74 53.5102 611.83 53.5102C611.86 53.4902 611.88 53.4702 611.9 53.4502C612.28 53.1302 612.55 53.2202 612.73 53.3702C612.82 53.2302 612.94 53.1102 613.09 53.0402C613.19 52.9802 613.28 52.9002 613.36 52.8102C613.36 52.7802 613.36 52.7502 613.36 52.7202C613.36 52.6802 613.36 52.6402 613.36 52.6002C613.25 52.6502 613.12 52.6402 613.01 52.6002C612.9 52.5502 612.81 52.4602 612.77 52.3502C612.66 52.1802 612.67 51.9602 612.79 51.7902C612.89 51.6602 613.05 51.5802 613.22 51.5702C613.24 51.5702 613.25 51.5602 613.27 51.5502C613.25 51.4902 613.24 51.4302 613.25 51.3702C613.19 51.3202 613.14 51.2702 613.09 51.2102L613.05 51.1602H613.01C613.01 51.1602 612.95 51.1902 612.91 51.2002C612.91 51.2402 612.92 51.2802 612.92 51.3202C612.92 51.4502 612.85 51.5802 612.75 51.6602C612.7 51.7202 612.64 51.7702 612.57 51.8002C612.42 51.8802 612.25 51.8702 612.11 51.7802C612 51.7102 611.93 51.6002 611.9 51.4802C611.87 51.4202 611.86 51.3502 611.86 51.2802C611.86 51.2102 611.89 51.1302 611.92 51.0702C611.94 51.0002 611.98 50.9402 612.03 50.8902C612.06 50.8602 612.1 50.8302 612.14 50.8102C612.14 50.7202 612.15 50.6302 612.2 50.5502C612.27 50.4402 612.36 50.3502 612.46 50.2702C612.42 50.2402 612.38 50.2102 612.34 50.1802C612.22 50.0902 612.16 49.9402 612.18 49.7902C612.19 49.6402 612.28 49.5102 612.42 49.4402C612.93 49.1702 613.31 49.0902 613.55 49.2202C613.58 49.2402 613.62 49.2602 613.66 49.2702C613.68 49.1902 613.69 49.1002 613.69 49.0202L613.66 48.9502C613.57 48.7702 613.5 48.5702 613.46 48.3702C613.44 48.2302 613.44 48.0902 613.45 47.9602C613.45 47.9202 613.45 47.8802 613.45 47.8302C613.2 47.7802 613.01 47.5702 612.97 47.3202C612.94 47.0002 613.03 46.6802 613.23 46.4202C613.23 46.4002 613.23 46.3702 613.22 46.3502C613.2 46.1102 613.25 45.8702 613.35 45.6502C613.28 45.6202 613.21 45.5902 613.15 45.5402C613.13 45.5702 613.11 45.5902 613.09 45.6202C613.06 45.7402 613.01 45.8402 612.94 45.9402C613.09 46.1402 613.1 46.4102 612.94 46.6102C612.84 46.7402 612.59 46.9302 612.09 46.7202C612.03 46.7002 611.97 46.6802 611.91 46.6802C611.76 46.6602 611.62 46.6202 611.49 46.5502C611.37 46.4902 611.28 46.3802 611.25 46.2402C611.22 46.1102 611.25 45.9702 611.34 45.8602C611.37 45.8202 611.39 45.7802 611.42 45.7402C611.5 45.5802 611.62 45.4402 611.76 45.3402C611.91 45.2402 612.08 45.1702 612.26 45.1302H612.28C612.3 45.0102 612.36 44.9002 612.44 44.8202C612.58 44.6902 612.75 44.6002 612.93 44.5502C612.96 44.5502 613 44.5402 613.03 44.5302C613.06 44.4702 613.1 44.4202 613.15 44.3602C613.03 44.3202 612.93 44.2402 612.88 44.1302C612.84 44.0602 612.8 44.0002 612.75 43.9402C612.64 43.8102 612.55 43.6602 612.49 43.5002C612.47 43.4502 612.46 43.3902 612.45 43.3302L612.43 43.3102C612.3 43.1302 612.32 42.8902 612.46 42.7302C612.56 42.6202 612.7 42.5702 612.84 42.5802C612.98 42.5802 613.11 42.6402 613.19 42.7502C613.34 42.8302 613.46 42.9402 613.52 43.0902L613.58 43.2302C613.61 43.3002 613.64 43.3702 613.67 43.4402L613.71 43.4202C613.71 43.4202 613.75 43.4002 613.77 43.3902C613.78 43.2502 613.79 43.1002 613.79 42.9602C613.79 42.8902 613.77 42.8202 613.74 42.7502C613.71 42.6602 613.69 42.5602 613.67 42.4602C613.65 42.4402 613.63 42.4102 613.6 42.3902C613.44 42.2502 613.34 42.0602 613.3 41.8602C613.29 41.7102 613.3 41.5502 613.33 41.4002V41.3402C613.26 41.2702 613.19 41.1902 613.12 41.1102C613.06 41.0302 612.99 40.9602 612.91 40.9002C612.77 40.8002 612.7 40.6302 612.73 40.4602C612.76 40.2902 612.88 40.1502 613.04 40.1002C613.09 40.0802 613.15 40.0702 613.2 40.0702C613.23 39.9802 613.27 39.8902 613.31 39.8102C613.33 39.7802 613.34 39.7502 613.35 39.7202C613.34 39.6502 613.33 39.5902 613.32 39.5202C613.15 39.5502 612.98 39.5402 612.82 39.4702C612.68 39.4002 612.57 39.2802 612.5 39.1502C612.5 39.1402 612.48 39.1202 612.47 39.1102C612.39 39.0502 612.33 38.9602 612.31 38.8602H612.29C612.21 38.9402 612.11 38.9902 612.01 39.0002C612.01 39.0402 612.01 39.0702 612.01 39.1002C612.01 39.2302 611.97 39.3502 611.89 39.4502C611.8 39.5502 611.68 39.6002 611.55 39.5902C611.52 39.5902 611.47 39.5902 611.42 39.5902C611.21 39.6102 610.86 39.6402 610.71 39.3102C610.7 39.2802 610.68 39.2502 610.67 39.2202H610.66C610.51 39.2502 610.36 39.2002 610.26 39.0902C610.12 39.1702 609.96 39.1702 609.82 39.0902C609.77 39.0602 609.73 39.0302 609.69 38.9902C609.62 39.0702 609.53 39.1202 609.43 39.1402H609.4C609.49 39.1902 609.55 39.2602 609.58 39.3502C609.61 39.4502 609.63 39.5602 609.62 39.6702C609.76 39.8002 609.85 39.9802 609.86 40.1702C609.86 40.4002 609.74 40.6102 609.55 40.7302C609.45 40.8002 609.33 40.8302 609.22 40.8102C609.39 40.8602 609.54 40.9402 609.67 41.0602C609.79 41.1602 609.86 41.3102 609.84 41.4702C609.82 41.6302 609.73 41.7602 609.58 41.8302C609.37 41.9402 609.13 41.9802 608.9 41.9302C608.82 41.9102 608.74 41.8902 608.67 41.8502C608.67 41.8702 608.66 41.8902 608.65 41.9102C608.65 41.9602 608.64 42.0102 608.63 42.0502C608.63 42.1702 608.61 42.2802 608.58 42.3902L608.53 42.5602V42.5902C608.53 42.5902 608.6 42.6802 608.62 42.7402C608.65 42.8102 608.66 42.8802 608.66 42.9502C608.77 43.1302 608.78 43.3502 608.69 43.5402C608.76 43.5102 608.84 43.4902 608.92 43.4902C609.07 43.4902 609.2 43.5702 609.28 43.6902C609.3 43.7202 609.32 43.7602 609.34 43.8002C609.36 43.6802 609.43 43.5702 609.53 43.5102C609.6 43.4602 609.68 43.4402 609.76 43.4302C609.93 43.4002 610.11 43.4702 610.21 43.6202C610.3 43.7002 610.35 43.8102 610.36 43.9302C610.36 43.9802 610.36 44.0402 610.36 44.0902C610.55 44.1202 610.73 44.2102 610.88 44.3302C610.92 44.3602 610.95 44.4002 610.98 44.4502C610.98 44.4102 611 44.3702 611.01 44.3302C611.07 44.1702 611.16 44.0302 611.28 43.9202C611.39 43.8202 611.53 43.7802 611.68 43.8102C611.82 43.8402 611.94 43.9302 612 44.0702C612.07 44.2302 612.06 44.4202 611.96 44.5702C611.96 44.5602 611.96 44.5702 611.96 44.5902C611.94 44.7602 611.89 44.9302 611.81 45.0902C611.73 45.2502 611.56 45.3402 611.38 45.3302C611.2 45.3202 611.05 45.2002 610.99 45.0302C610.99 45.0502 610.97 45.0702 610.96 45.0802C610.88 45.1902 610.76 45.2602 610.63 45.2802C610.6 45.2802 610.57 45.2902 610.55 45.3002C610.62 45.3802 610.67 45.4802 610.68 45.5902C610.7 45.7102 610.67 45.8402 610.59 45.9302C610.52 46.0302 610.4 46.0902 610.28 46.1002C610.19 46.1002 610.1 46.1002 610.01 46.1002C609.99 46.1002 609.96 46.1002 609.94 46.1002C609.81 46.1102 609.67 46.0702 609.57 45.9702C609.47 45.8702 609.43 45.7402 609.44 45.6102C609.44 45.5702 609.44 45.5202 609.44 45.4802C609.43 45.4802 609.42 45.4602 609.41 45.4502C609.38 45.4502 609.34 45.4502 609.31 45.4402H609.28C609.1 45.3802 608.97 45.2202 608.95 45.0302C608.94 44.8602 609.02 44.7102 609.16 44.6202C609.22 44.5702 609.29 44.5402 609.37 44.5302C609.4 44.5302 609.42 44.5302 609.45 44.5302C609.49 44.4602 609.54 44.4002 609.59 44.3402C609.54 44.3102 609.5 44.2802 609.46 44.2402C609.44 44.2202 609.42 44.1902 609.4 44.1702C609.4 44.2102 609.39 44.2602 609.37 44.3002C609.32 44.4202 609.23 44.5102 609.11 44.5602C609.07 44.5902 609.03 44.6202 608.99 44.6402C608.98 44.6802 608.96 44.7202 608.94 44.7602C608.82 44.9602 608.58 45.0302 608.37 44.9502C608.29 44.9402 608.21 44.9002 608.15 44.8502C608.13 44.8702 608.12 44.8902 608.1 44.9102C608.11 44.8802 608.12 44.8602 608.12 44.8302C608.1 44.8102 608.08 44.7902 608.06 44.7602L607.23 44.8902C607.21 44.6302 607.31 44.3802 607.51 44.2102C607.38 44.0402 607.34 43.8202 607.38 43.6102C607.44 43.4302 607.56 43.2802 607.73 43.2002C607.7 43.1702 607.67 43.1302 607.64 43.0902C607.53 42.8502 607.53 42.5602 607.64 42.3202L607.69 42.1702C607.69 42.1702 607.7 42.0802 607.7 42.0302C607.7 41.9202 607.72 41.8002 607.75 41.6902C607.78 41.6002 607.81 41.5102 607.85 41.4202C607.87 41.3802 607.88 41.3502 607.9 41.3102C607.75 41.2102 607.64 41.0502 607.59 40.8702C607.54 40.6702 607.59 40.4702 607.69 40.3002C607.76 40.2002 607.85 40.1102 607.95 40.0402C608 39.9202 608.1 39.8302 608.23 39.7902C608.23 39.7702 608.21 39.7602 608.2 39.7402C607.88 39.7402 607.6 39.5302 607.49 39.2302C607.43 39.0402 607.42 38.8302 607.46 38.6402C607.46 38.6002 607.47 38.5702 607.47 38.5302C607.24 38.3002 607.19 37.9402 607.35 37.6502C607.42 37.5402 607.51 37.4502 607.6 37.3602C607.64 37.3302 607.67 37.2902 607.7 37.2602C607.7 37.2402 607.72 37.2202 607.73 37.2102C607.68 37.1902 607.64 37.1802 607.61 37.1602L607.56 37.1802C607.37 37.2702 607.15 37.2902 606.95 37.2202C606.75 37.1402 607.08 36.4002 606.92 36.0902C606.85 35.9302 606.82 35.7602 606.84 35.5802C606.84 35.5502 606.84 35.5102 606.84 35.4802C606.75 35.3002 606.77 35.0802 606.89 34.9202C606.76 34.7802 606.73 34.5702 606.82 34.4002C606.82 34.4002 606.79 34.3202 606.77 34.2602L606.75 34.1502C606.75 34.1502 606.72 34.1202 606.7 34.1002C606.63 34.0302 606.57 33.9502 606.52 33.8602C606.45 33.7202 606.41 33.5702 606.42 33.4202C606.38 33.3702 605.74 33.9202 605.72 33.8602C605.48 33.7602 605.15 33.6102 605.15 33.2402C605.15 33.1102 605.17 32.9802 605.2 32.8502C605.02 32.8502 604.85 32.8002 604.69 32.7202C604.54 32.6202 604.4 32.4902 604.31 32.3402C604.18 32.4102 604.03 32.4302 603.89 32.4102C603.68 32.3702 603.51 32.2302 603.43 32.0302C603.33 32.0802 603.23 32.1102 603.13 32.1402C602.89 32.1702 602.65 32.1102 602.45 31.9702C602.42 31.9502 602.4 31.9402 602.37 31.9202H602.33C602.15 32.0102 601.95 31.9902 601.79 31.9002C601.66 31.8102 601.57 31.6802 601.55 31.5302C601.51 31.5102 601.47 31.4902 601.42 31.4902C601.41 31.4902 601.35 31.5002 601.25 31.5902C601.04 31.8002 600.77 31.9502 600.49 32.0202C600.26 32.0402 600.02 31.9602 599.86 31.7802C599.85 31.7702 599.83 31.7502 599.82 31.7402C599.78 31.7402 599.74 31.7202 599.7 31.7002C599.47 31.7902 599.21 31.7602 599.01 31.6202C598.9 31.5502 598.8 31.4602 598.71 31.3702C598.67 31.3202 598.62 31.2802 598.57 31.2502C598.52 31.2102 598.46 31.1802 598.4 31.1602C598.28 31.1102 598.17 31.0502 598.07 30.9802C597.91 30.8702 597.79 30.7202 597.72 30.5302C597.66 30.4702 597.59 30.4202 597.51 30.3902C597.4 30.3402 597.3 30.2802 597.2 30.2102C597.16 30.1802 597.11 30.1502 597.05 30.1402C596.92 30.1002 596.79 30.0402 596.68 29.9602C596.58 29.8902 596.52 29.8602 596.47 29.8302C596.4 29.7902 596.33 29.7502 596.2 29.6602C596.08 29.5802 595.98 29.4902 595.89 29.3802C595.86 29.3402 595.82 29.3002 595.77 29.2702C595.68 29.2102 595.59 29.1402 595.5 29.0702C595.44 29.0202 595.38 28.9702 595.31 28.9302C595.17 28.8402 595.05 28.7102 594.98 28.5602C594.98 28.5602 594.96 28.5368 594.92 28.4902C594.92 28.4902 594.84 28.4402 594.79 28.4302C594.65 28.3902 594.52 28.3302 594.4 28.2502L594.34 28.2302C594.16 28.2302 593.99 28.1602 593.84 28.0602C593.79 28.0302 593.74 28.0002 593.69 27.9702C593.52 27.8902 593.38 27.7802 593.26 27.6402C593.15 27.5102 593.12 27.3302 593.19 27.1802C593.25 27.0202 593.4 26.9202 593.57 26.9002C593.56 26.9002 593.63 26.8502 593.67 26.8202C593.78 26.7402 593.91 27.2602 594.07 27.2202C594.18 27.1902 594.3 27.1802 594.42 27.1802C594.47 27.1802 594.52 27.1802 594.57 27.1702C594.72 27.1202 594.88 27.1002 595.04 27.1202C595.08 27.1202 595.12 27.1202 595.16 27.1202C595.19 27.1002 595.25 27.0602 595.31 27.0202C595.39 26.9702 595.47 26.9202 595.56 26.8702C595.58 26.8502 595.59 26.8202 595.6 26.7902C595.69 26.6002 595.84 26.4502 596.03 26.3602C596.21 26.3002 596.39 26.2802 596.58 26.2902C596.65 26.2902 596.72 26.2902 596.79 26.2902C596.91 26.2602 597.05 26.2902 597.15 26.3602H597.18C597.18 26.3602 597.27 26.2802 597.32 26.2602C597.38 26.0802 597.49 25.7802 597.83 25.7802H597.85C598.08 25.7902 598.27 25.9602 598.31 26.1802C598.33 26.0302 598.4 25.8902 598.5 25.7802C598.67 25.6302 598.9 25.5602 599.12 25.6002C599.15 25.6002 599.18 25.6002 599.21 25.6002C599.34 25.6002 599.47 25.6502 599.56 25.7502C599.65 25.8502 599.69 25.9902 599.67 26.1202C599.65 26.2402 599.67 26.3702 599.74 26.4702C599.76 26.4902 599.78 26.5102 599.8 26.5302C599.97 26.6602 600.09 26.8502 600.13 27.0602C600.19 27.0602 600.25 27.0402 600.31 27.0202C600.37 27.0002 600.42 26.9902 600.48 26.9702C600.59 26.9402 600.7 26.9202 600.81 26.9102C600.85 26.9102 600.9 26.9002 600.94 26.8902C600.94 26.8402 600.95 26.8002 600.95 26.7502C600.93 26.5202 601 26.3002 601.14 26.1302C601.29 25.9602 601.5 25.8502 601.73 25.8402C602.08 25.7602 602.44 25.8402 602.73 26.0502C602.85 26.1802 602.94 26.3302 603.01 26.4802L603.04 26.5302C603.14 26.5502 603.24 26.5502 603.34 26.5302C603.35 26.5202 603.36 26.5002 603.37 26.4902C603.51 26.2602 603.77 26.1202 604.04 26.1402C604.27 26.1802 604.39 25.7502 604.48 25.9202C604.62 25.9202 604.75 25.9602 604.88 26.0202C605.18 26.1002 605.41 26.3402 605.47 26.6402C605.54 26.5702 605.62 26.5002 605.7 26.4502C605.8 26.3902 605.92 26.3602 606.04 26.3902C606.16 26.4202 606.26 26.4902 606.32 26.5902C606.5 26.9102 606.58 27.2702 606.54 27.6402C606.52 27.7302 606.49 27.8102 606.44 27.8902C606.48 28.0102 606.51 28.1402 606.53 28.2702V28.3102C606.53 28.3102 606.6 28.3102 606.63 28.3102C606.72 28.3102 606.8 28.3102 606.89 28.3102C607.06 28.3202 607.23 28.3102 607.39 28.2602C607.6 28.2202 607.81 28.3002 607.94 28.4702C608.02 28.3802 608.13 28.3202 608.26 28.3202C608.54 28.2802 608.81 28.4202 608.96 28.6602C608.99 28.7002 609.02 28.7402 609.05 28.7802L609.07 28.8102L609.1 28.7902C609.18 28.7202 609.24 28.6302 609.27 28.5302C609.29 28.4902 609.3 28.4502 609.33 28.4102C609.13 28.4102 608.96 28.2602 608.91 28.0602C608.81 28.0702 608.72 28.0602 608.63 28.0202C608.44 27.9202 608.32 27.7202 608.32 27.5002C608.17 27.3702 608.07 27.1902 608.05 26.9902C608.05 26.9402 608.05 26.8802 608.07 26.8302C607.99 26.8802 607.89 26.9102 607.79 26.9002C607.42 26.9002 607.08 26.7402 606.86 26.4502C606.71 26.2102 606.69 25.9202 606.81 25.6602C606.85 25.5702 606.89 25.4802 606.93 25.4002C606.96 25.3402 606.99 25.2802 607.01 25.2202L607.04 25.1102L607.06 25.0302C607.06 25.0302 607.02 25.0102 607 25.0002C606.84 24.9002 606.74 24.7202 606.75 24.5302V24.5002C606.71 24.4402 606.71 24.3702 606.71 24.3102C606.69 24.1602 606.69 24.0202 606.7 23.8702C606.7 23.7002 606.67 23.5302 606.64 23.3702C606.6 23.1602 606.54 22.8402 606.86 22.6902C607.02 22.6202 607.2 22.5902 607.38 22.5902H607.43C607.45 22.5102 607.47 22.4202 607.48 22.3402C607.48 22.3302 607.46 22.2602 607.45 22.2102C607.4 22.0502 607.38 21.8802 607.4 21.7102C607.41 21.5902 607.44 21.4802 607.46 21.3702C607.48 21.2702 607.5 21.1802 607.51 21.1002C607.54 20.8802 607.6 20.6702 607.71 20.4802V20.4502C607.55 20.2502 607.5 19.9902 607.57 19.7602C607.69 19.5102 607.95 19.3402 608.23 19.3202C608.26 19.3202 608.29 19.3202 608.31 19.3002C608.32 19.2802 608.34 19.2502 608.35 19.2202C608.39 19.1202 608.45 19.0302 608.51 18.9502V18.9202C608.49 18.7802 608.51 18.6402 608.55 18.5002C608.58 18.4302 608.59 18.3602 608.59 18.2802C608.59 18.2302 608.59 18.1902 608.59 18.1402H608.55C608.45 18.1502 608.35 18.1402 608.26 18.1402C608.18 18.1302 608.11 18.1302 608.03 18.1402C607.8 18.1802 607.58 18.0502 607.52 17.8302C607.38 17.7002 607.29 17.5302 607.27 17.3402C607.27 17.2502 607.29 17.1602 607.33 17.0802C607.39 16.9702 607.49 16.9002 607.61 16.8702L607.64 16.8202C607.76 16.6102 607.93 16.4502 608.14 16.3302C608.38 16.2302 608.66 16.2702 608.85 16.4502C608.83 16.2702 608.86 16.0902 608.96 15.9302C609.01 15.8002 609.09 15.6902 609.19 15.6102V15.5802C609.19 15.5802 609.14 15.5502 609.12 15.5202C608.98 15.3802 608.95 15.1602 609.05 14.9902C609.14 14.8402 609.26 14.7002 609.41 14.5902C609.47 14.5502 609.52 14.5002 609.56 14.4402C609.75 14.1702 610.02 13.9602 610.33 13.8602C610.43 13.8202 610.54 13.8202 610.65 13.8602C610.75 13.7502 610.9 13.7002 611.05 13.7202C611.1 13.7102 611.15 13.7002 611.2 13.7102C611.36 13.7202 611.51 13.7702 611.64 13.8502C611.7 13.8802 611.76 13.9102 611.83 13.9302C611.89 13.9302 611.94 13.9202 612 13.9002C612.19 13.8402 612.39 13.8302 612.59 13.8802C612.93 13.9602 613.22 14.1802 613.41 14.4702C613.48 14.6202 613.52 14.7802 613.52 14.9502C613.52 14.9802 613.52 15.0202 613.52 15.0502C613.58 15.1602 613.59 15.3002 613.55 15.4202C613.73 15.4402 613.9 15.5102 614.03 15.6302C614.11 15.7102 614.16 15.8302 614.16 15.9402C614.16 15.9402 614.14 16.0702 614.12 16.1902L614.09 16.3502C614.07 16.4902 613.98 16.6202 613.85 16.6802C613.65 16.7702 613.43 16.8202 613.21 16.8302H613.12C613.15 16.8802 613.18 16.9302 613.21 16.9802C613.28 17.1202 613.35 17.2602 613.42 17.4002C613.44 17.4002 613.46 17.4202 613.48 17.4302C613.67 17.5002 613.84 17.6402 613.94 17.8202C614.01 17.9902 614.02 18.1802 613.96 18.3502C614.01 18.3802 614.04 18.4202 614.08 18.4602C614.16 18.5602 614.18 18.7002 614.16 18.8202C614.16 18.8402 614.16 18.8802 614.15 18.9102C614.15 18.9802 614.13 19.0402 614.12 19.1102C614.34 19.1402 614.5 19.3302 614.5 19.5602C614.5 19.5402 614.52 19.5602 614.53 19.5802C614.63 19.7102 614.66 19.8802 614.63 20.0402C614.63 20.0702 614.61 20.1102 614.59 20.1402C614.61 20.3102 614.61 20.4702 614.59 20.6302C614.56 20.7702 614.5 20.9102 614.42 21.0302C614.4 21.0602 614.37 21.1002 614.36 21.1302C614.37 21.1502 614.38 21.1802 614.4 21.2002C614.5 21.3702 614.55 21.5602 614.54 21.7502C614.52 21.9102 614.5 22.0702 614.47 22.2202L614.45 22.3602C614.38 22.6302 614.19 22.8402 613.94 22.9502C613.92 22.9602 613.89 22.9802 613.87 22.9902C613.83 23.1102 613.77 23.2202 613.68 23.3102V23.3302C613.68 23.4802 613.68 23.6602 613.68 23.8002C613.69 23.9402 613.72 24.0702 613.75 24.2102H613.77C613.88 24.2702 613.99 24.3302 614.08 24.4002C614.2 24.4902 614.28 24.6302 614.3 24.7702C614.43 24.9502 614.41 25.2002 614.26 25.3502C614.28 25.3302 614.27 25.4102 614.28 25.4602C614.28 25.5102 614.28 25.5702 614.28 25.6202C614.28 25.6802 614.28 25.7502 614.28 25.8102C614.28 25.9602 614.28 26.1102 614.26 26.2602C614.26 26.2902 614.26 26.3202 614.26 26.3502C614.28 26.5602 614.22 26.7602 614.11 26.9302C614.11 26.9702 614.11 27.0202 614.11 27.0602C614.16 27.2402 614.17 27.4302 614.16 27.6202C614.16 27.7802 614.12 27.9402 614.04 28.0802C614.16 28.1802 614.25 28.3102 614.32 28.4502C614.41 28.6902 614.44 28.9402 614.42 29.2002C614.39 29.4202 614.28 29.6202 614.1 29.7502C614.07 29.7702 614.05 29.8002 614.03 29.8202C614.02 29.8502 614 29.8902 613.97 29.9402L613.91 30.0702C614.03 30.2202 614.06 30.4202 613.97 30.5902C614.05 30.6702 614.13 30.7502 614.19 30.8502C614.25 30.9502 614.28 31.0702 614.29 31.1902C614.4 31.2602 614.47 31.3702 614.49 31.5002C614.52 31.7002 614.5 31.8902 614.45 32.0802C614.44 32.1302 614.43 32.1802 614.42 32.2302C614.39 32.5102 614.16 32.7402 613.88 32.7602C613.88 32.7902 613.88 32.8202 613.89 32.8502C613.91 32.9102 613.94 32.9902 613.96 33.0702C614 33.1902 614.04 33.3202 614.08 33.4302C614.08 33.4502 614.1 33.4702 614.11 33.4902C614.27 33.7202 614.3 34.0202 614.18 34.2702C614.25 34.4002 614.27 34.5502 614.24 34.7002C614.29 34.8802 614.23 35.0602 614.08 35.1702C614.1 35.2102 614.12 35.2502 614.13 35.3002C614.17 35.4602 614.13 35.6302 614.03 35.7602C614.07 35.8002 614.1 35.8502 614.12 35.9102C614.23 36.0802 614.25 36.3002 614.18 36.4902C614.11 36.6802 613.96 36.8302 613.77 36.9002C614.05 36.8202 614.33 36.9802 614.42 37.2502C614.48 37.4902 614.38 37.7502 614.18 37.8902C614.26 38.0102 614.31 38.1502 614.31 38.2902C614.31 38.5102 614.2 38.7102 614.03 38.8502L614.01 38.8702C614.01 38.8702 614.06 38.9502 614.08 39.0002C614.13 39.1502 614.17 39.3102 614.18 39.4702C614.18 39.5402 614.2 39.6102 614.21 39.6702C614.24 39.8802 614.21 40.0902 614.09 40.2702C614.2 40.3702 614.24 40.5202 614.22 40.6602C614.2 40.7602 614.15 40.8502 614.08 40.9202C614.16 41.0202 614.2 41.1402 614.21 41.2602C614.21 41.3802 614.21 41.5102 614.18 41.6302C614.18 41.6902 614.16 41.7502 614.16 41.7902C614.18 41.8102 614.2 41.8302 614.22 41.8602C614.38 42.0002 614.49 42.1902 614.52 42.4002C614.53 42.4602 614.55 42.5302 614.57 42.5902C614.62 42.7402 614.65 42.8902 614.65 43.0502C614.65 43.2902 614.64 43.5302 614.6 43.7702C614.53 44.0202 614.34 44.2202 614.1 44.3102C614.08 44.3202 614.05 44.3402 614.02 44.3502C614.02 44.3602 614.02 44.3802 614.02 44.4002C614.02 44.6002 613.97 44.7902 613.86 44.9502H613.94C614.16 45.0002 614.32 45.1802 614.32 45.4002C614.32 45.6102 614.26 45.8302 614.17 46.0202C614.13 46.1102 614.1 46.2102 614.08 46.3102C614.24 46.5902 614.15 46.9502 613.88 47.1202C613.97 47.1602 614.05 47.2102 614.12 47.2802C614.3 47.5002 614.38 47.7902 614.33 48.0702C614.33 48.1502 614.33 48.2302 614.33 48.3102C614.36 48.4302 614.4 48.5502 614.46 48.6702L614.53 48.8202C614.63 49.2102 614.56 49.6302 614.34 49.9702C614.19 50.1602 613.95 50.2702 613.7 50.2702C613.72 50.3402 613.72 50.4102 613.7 50.4802C613.69 50.5202 613.67 50.5602 613.65 50.6002C613.68 50.6302 613.71 50.6602 613.74 50.6902C613.77 50.7202 613.8 50.7502 613.83 50.7802C613.97 50.7902 614.09 50.8902 614.13 51.0302C614.28 51.0202 614.42 51.0802 614.51 51.1902C614.65 51.3502 614.68 51.5802 614.58 51.7702C614.58 51.7902 614.58 51.8102 614.59 51.8302C614.63 51.9802 614.63 52.1402 614.59 52.2902C614.53 52.4502 614.43 52.6002 614.3 52.7202C614.27 52.7402 614.25 52.7702 614.23 52.8002C614.23 52.8002 614.23 52.8302 614.23 52.8702C614.23 53.0802 614.17 53.2902 614.04 53.4602C613.88 53.6602 613.69 53.8202 613.47 53.9402C613.53 54.1202 613.5 54.3202 613.41 54.4902C613.37 54.5602 613.3 54.6302 613.23 54.6802V54.7202C613.35 54.8902 613.37 55.1102 613.3 55.3002C613.23 55.4902 613.05 55.6102 612.85 55.6102C612.83 55.6102 612.81 55.6102 612.8 55.6102H612.79C612.63 55.6002 612.47 55.6102 612.31 55.6502C612.25 55.7202 612.19 55.7902 612.15 55.8702C612.07 56.0002 611.98 56.1202 611.88 56.2302C611.72 56.3802 611.49 56.4402 611.27 56.3602C611.1 56.3602 610.94 56.2702 610.84 56.1302C610.83 56.1102 610.81 56.0802 610.79 56.0602C610.73 56.0602 610.68 56.0402 610.62 56.0302C610.59 56.0302 610.55 56.0102 610.52 56.0102C610.52 56.0602 610.51 56.1202 610.49 56.1702C610.41 56.3402 610.25 56.4502 610.06 56.4502C609.91 56.5702 609.72 56.6402 609.52 56.6402L609.57 56.5202ZM610.19 53.2802L610.23 53.3502C610.23 53.3502 610.27 53.2802 610.28 53.2502L610.18 53.2802H610.19ZM611.09 52.9302L611.16 53.0902L611.24 53.0702C611.22 53.0002 611.17 52.9502 611.1 52.9202L611.09 52.9302ZM612.3 51.6302C612.3 51.6302 612.36 51.6402 612.39 51.6502V51.4802L612.3 51.6302ZM610.03 50.2102C610.02 50.2902 609.98 50.3702 609.93 50.4402C609.98 50.3802 610.02 50.3002 610.03 50.2102ZM609.66 49.5102L609.61 49.6502C609.61 49.6502 609.69 49.5802 609.71 49.5402L609.66 49.5102ZM608.99 48.2002C608.93 48.2502 608.89 48.3102 608.87 48.3802L609.06 48.4302V48.3702L608.99 48.1902V48.2002ZM608.99 48.2002L609.07 48.3802V48.3102L608.99 48.2002ZM608.57 38.7302C608.64 38.7302 608.72 38.7502 608.78 38.7802C608.9 38.8402 608.98 38.9502 609.01 39.0802C609.05 39.0602 609.09 39.0502 609.13 39.0502C609.07 39.0202 609.03 38.9702 608.99 38.9102C608.96 38.8602 608.92 38.8102 608.88 38.7602C608.82 38.6902 608.77 38.6202 608.71 38.5402C608.65 38.4502 608.62 38.3302 608.64 38.2202C608.56 38.2202 608.48 38.2002 608.4 38.1902C608.44 38.3502 608.44 38.5202 608.4 38.6902C608.4 38.7102 608.4 38.7302 608.4 38.7502C608.4 38.7502 608.5 38.7202 608.55 38.7202L608.57 38.7302ZM608.94 38.5802L609.15 38.6202L608.94 38.5802ZM612.01 37.8102C612.01 37.8102 612.07 37.8102 612.1 37.8102C612.22 37.8302 612.33 37.9102 612.4 38.0202C612.44 38.0902 612.47 38.1702 612.49 38.2502C612.51 38.2802 612.52 38.3202 612.53 38.3502C612.56 38.3302 612.59 38.3202 612.62 38.3102C612.65 38.2902 612.68 38.2802 612.71 38.2602C612.77 38.2202 612.84 38.1902 612.91 38.1602C612.97 38.0902 613.05 38.0302 613.13 37.9902C613.1 37.9902 613.06 37.9902 613.03 37.9702C612.98 37.9502 612.93 37.9302 612.88 37.8902C612.78 37.8402 612.71 37.7602 612.66 37.6602C612.6 37.5202 612.62 37.3502 612.71 37.2202C612.75 37.1602 612.81 37.1102 612.87 37.0702C612.86 37.0502 612.85 37.0302 612.83 37.0102C612.73 36.9102 612.69 36.7702 612.71 36.6402C612.73 36.5002 612.82 36.3802 612.94 36.3202C612.98 36.2902 613.02 36.2602 613.06 36.2302C613.12 36.1802 613.18 36.1302 613.24 36.0902C613.11 35.9902 613.03 35.8302 613.02 35.6702C613.02 35.6102 613.02 35.5602 613.05 35.5002C612.83 35.4702 612.63 35.3402 612.5 35.1602C612.45 35.0902 612.41 35.0102 612.38 34.9302C612.35 35.0202 612.3 35.0902 612.22 35.1502C612.22 35.1502 612.19 35.1802 612.17 35.2002C612.09 35.2902 612 35.3602 611.9 35.4202C611.76 35.5002 611.59 35.5002 611.46 35.4202C611.32 35.3402 611.24 35.1902 611.24 35.0402C611.24 34.8602 611.32 34.6802 611.47 34.5802C611.54 34.4602 611.65 34.3602 611.77 34.3002C611.9 34.2402 612.05 34.2402 612.18 34.3102L612.16 34.2502C612.13 34.1202 612.16 33.9902 612.23 33.8902C612.32 33.7802 612.45 33.7102 612.59 33.6902C612.81 33.5902 613.07 33.6902 613.17 33.9002C613.2 33.9402 613.24 33.9702 613.28 33.9902C613.3 33.9202 613.33 33.8602 613.36 33.8102C613.34 33.7702 613.32 33.7302 613.3 33.7002C613.24 33.5602 613.19 33.4002 613.14 33.2502C613.12 33.1802 613.1 33.1002 613.07 33.0402C613.07 33.0302 612.81 32.0802 613.36 31.8802C613.44 31.8502 613.52 31.8302 613.6 31.8102C613.6 31.8102 613.55 31.7502 613.54 31.7202C613.46 31.5802 613.43 31.4102 613.44 31.2502C613.44 31.2302 613.44 31.2102 613.44 31.2002C613.42 31.1802 613.38 31.1402 613.36 31.1202C613.28 31.0502 613.21 30.9702 613.14 30.8902C613.02 30.7502 612.97 30.5702 613 30.3902C612.95 30.3302 612.92 30.2502 612.9 30.1702C612.88 30.0402 612.92 29.9102 613.01 29.8102C613.08 29.7102 613.14 29.5902 613.19 29.4802C613.22 29.4202 613.25 29.3602 613.27 29.3102C613.34 29.1902 613.43 29.0902 613.53 29.0002L613.56 28.9702C613.56 28.8702 613.55 28.7802 613.51 28.6802C613.47 28.6502 613.43 28.6202 613.39 28.5902C613.34 28.5502 613.29 28.5002 613.24 28.4602C613.19 28.4502 613.14 28.4302 613.1 28.4002C613.09 28.4002 613.08 28.3802 613.07 28.3702C613.02 28.4202 612.97 28.4502 612.9 28.4702C612.85 28.4902 612.8 28.5202 612.76 28.5602C612.63 28.6602 612.49 28.7302 612.33 28.7702C612.25 28.7902 612.16 28.8002 612.08 28.7702C612.06 28.7902 612.03 28.8102 612 28.8302C611.91 28.8902 611.8 28.9202 611.69 28.9202C611.68 28.9202 611.66 28.9302 611.65 28.9402C611.5 29.0102 611.33 28.9902 611.2 28.9002C611.1 28.8302 611.03 28.7202 611.01 28.6002C610.99 28.4802 611.02 28.3502 611.1 28.2502C611.14 28.1802 611.21 28.1202 611.28 28.0802H611.31C611.4 27.9802 611.52 27.9302 611.64 27.9202H611.67C611.7 27.8202 611.77 27.7402 611.87 27.6802C612.02 27.6002 612.18 27.5402 612.35 27.5102C612.41 27.5002 612.48 27.4802 612.54 27.4602C612.68 27.4102 612.83 27.3802 612.98 27.3802C613.04 27.3802 613.09 27.3902 613.15 27.4202C613.2 27.3902 613.25 27.3802 613.3 27.3702C613.3 27.3202 613.3 27.2602 613.28 27.2102C613.26 27.1302 613.24 27.0502 613.24 26.9702C613.07 26.9202 612.94 26.8002 612.88 26.6402C612.81 26.3902 612.88 26.1202 613.07 25.9302C613.15 25.8302 613.28 25.7702 613.41 25.7702V25.7502C613.41 25.6602 613.41 25.5802 613.41 25.4902C613.41 25.4502 613.41 25.4202 613.41 25.3802C613.41 25.2402 613.41 25.1002 613.46 24.9602H613.43C613.32 24.9002 613.21 24.8402 613.11 24.7602C612.91 24.4802 612.81 24.1402 612.81 23.7902C612.79 23.6302 612.79 23.4102 612.8 23.2302C612.8 23.1502 612.8 23.0902 612.8 23.0402C612.75 22.8202 612.86 22.6002 613.07 22.5202V22.5002C613.16 22.3202 613.31 22.1702 613.5 22.0902C613.53 22.0702 613.56 22.0502 613.59 22.0402V21.9802C613.62 21.8502 613.65 21.7102 613.66 21.5702C613.66 21.5902 613.63 21.5402 613.61 21.5002C613.52 21.3402 613.47 21.1502 613.48 20.9602C613.51 20.7802 613.58 20.6002 613.68 20.4502C613.7 20.4202 613.72 20.3902 613.74 20.3502C613.74 20.2802 613.74 20.2102 613.73 20.1402C613.73 20.1102 613.73 20.0602 613.72 20.0202C613.47 19.9602 613.29 19.7602 613.25 19.5102C613.09 19.3402 613.08 19.0802 613.23 18.9002C613.2 18.8702 613.17 18.8402 613.15 18.8002C613.03 18.5902 613.02 18.3402 613.11 18.1202C612.93 18.0502 612.77 17.9102 612.68 17.7402C612.61 17.5902 612.54 17.4402 612.46 17.2902C612.42 17.2302 612.38 17.1802 612.33 17.1302C612.28 17.0702 612.23 17.0102 612.18 16.9502C612.08 16.7902 612.03 16.6002 612.04 16.4102V16.3702C611.88 16.2802 611.78 16.1202 611.76 15.9302C611.76 15.7902 611.82 15.6502 611.93 15.5602C612.01 15.5002 612.11 15.4602 612.21 15.4502C612.21 15.4302 612.21 15.4202 612.21 15.4002C612.2 15.2302 612.29 15.0702 612.44 14.9802C612.46 14.9602 612.49 14.9402 612.51 14.9202C612.56 14.8702 612.62 14.8302 612.68 14.7902V14.7702C612.6 14.7002 612.51 14.6502 612.41 14.6302C612.41 14.6302 612.32 14.6502 612.27 14.6602C612.13 14.7002 611.99 14.7202 611.85 14.7102C611.68 14.7002 611.51 14.6502 611.36 14.5702C611.29 14.7502 611.15 14.9002 610.96 14.9702C610.92 14.9902 610.87 15.0002 610.83 15.0002C610.82 15.0702 610.78 15.1402 610.74 15.1902C610.7 15.2502 610.64 15.3102 610.59 15.3502L610.57 15.3702C610.57 15.4302 610.57 15.4902 610.55 15.5502C610.5 15.7702 610.3 15.9202 610.08 15.9102C610.03 16.0002 609.96 16.0802 609.88 16.1402C609.87 16.1802 609.84 16.2202 609.82 16.2602C609.82 16.3002 609.83 16.3502 609.84 16.4002C609.91 16.3302 609.99 16.2802 610.09 16.2602L610.12 16.2302L610.15 16.2002C610.15 16.2002 610.17 16.1302 610.18 16.1002C610.22 16.0202 610.28 15.9602 610.35 15.9102C610.39 15.8802 610.42 15.8602 610.47 15.8502C610.61 15.8002 610.76 15.8202 610.88 15.9102C611.05 16.0302 611.12 16.2402 611.05 16.4402C611.05 16.4602 611.03 16.4802 611.02 16.5002V16.5202C610.97 16.6202 610.91 16.7202 610.83 16.8002C610.8 16.8502 610.76 16.9002 610.72 16.9402C610.7 17.0202 610.66 17.0902 610.6 17.1502C610.6 17.1502 610.58 17.1802 610.57 17.1902C610.57 17.1902 610.55 17.2002 610.54 17.2102C610.47 17.2702 610.37 17.3002 610.28 17.2902C610.15 17.2902 610.02 17.2202 609.93 17.1302C609.93 17.1302 609.9 17.1102 609.89 17.1002C609.87 17.0802 609.84 17.0502 609.83 17.0302C609.76 17.1202 609.68 17.2002 609.57 17.2502C609.71 17.4602 609.73 17.7202 609.61 17.9502C609.59 18.0102 609.57 18.0702 609.56 18.1402C609.56 18.2402 609.56 18.3502 609.55 18.4502C609.7 18.4502 609.84 18.5402 609.92 18.6702C609.97 18.7702 609.99 18.8802 609.98 18.9902L610.01 19.0102C610.09 19.0602 610.17 19.1102 610.25 19.1702C610.36 19.2502 610.42 19.3802 610.42 19.5202C610.42 19.6602 610.36 19.7902 610.25 19.8702C610.11 19.9702 609.95 20.0502 609.79 20.1002L609.63 20.1602C609.52 20.2202 609.4 20.2502 609.28 20.2702H609.27V20.2902C609.34 20.4002 609.4 20.5302 609.43 20.6602C609.45 20.7102 609.46 20.7702 609.49 20.8302C609.51 20.8702 609.53 20.9202 609.56 20.9602C609.66 21.1102 609.73 21.2702 609.77 21.4502C609.78 21.5202 609.81 21.5902 609.82 21.6602C609.86 21.7902 609.89 21.9302 609.92 22.0702C609.94 22.2302 609.92 22.4002 609.89 22.5602C609.88 22.6102 609.87 22.6602 609.86 22.7202C609.88 22.8502 609.88 22.9802 609.88 23.1102C609.88 23.1902 609.88 23.2702 609.88 23.3502C609.9 23.4002 609.93 23.4502 609.96 23.5002C610.05 23.6302 610.11 23.7802 610.14 23.9402C610.16 24.0702 610.2 24.1902 610.24 24.3102C610.27 24.4002 610.3 24.4802 610.32 24.5702C610.35 24.6902 610.32 24.8202 610.25 24.9202C610.18 25.0202 610.07 25.0902 609.94 25.1002V25.1202C610 25.2702 609.99 25.4302 609.92 25.5702C610.03 25.7402 610.07 25.9502 610.03 26.1502C610.04 26.1602 610.05 26.1802 610.06 26.1902C610.15 26.2902 610.18 26.4302 610.15 26.5702C610.12 26.7002 610.04 26.8202 609.92 26.8802C609.79 26.9502 609.65 26.9702 609.51 26.9402L609.49 26.9702H609.48L609.5 26.9902C609.56 27.0302 609.62 27.0802 609.66 27.1402C609.79 27.0902 609.94 27.1002 610.06 27.1802C610.18 27.2602 610.26 27.3802 610.27 27.5202C610.29 27.5402 610.31 27.5602 610.32 27.5902C610.43 27.7402 610.49 27.9202 610.49 28.1102C610.47 28.3202 610.39 28.5102 610.27 28.6702C610.26 28.6902 610.24 28.7102 610.23 28.7302C610.29 28.7302 610.35 28.7602 610.41 28.8002C610.43 28.8102 610.44 28.8202 610.46 28.8402C610.48 28.8602 610.5 28.8802 610.52 28.9002C610.54 28.9202 610.57 28.9302 610.59 28.9502C610.69 29.0102 610.76 29.0802 610.82 29.1802C610.9 29.2502 610.96 29.3502 610.97 29.4602C610.98 29.5402 610.97 29.6302 610.93 29.7102C610.9 29.7802 610.86 29.8402 610.81 29.8902C610.71 29.9802 610.57 30.0202 610.43 30.0002C610.29 29.9802 610.18 29.8902 610.11 29.7702C610.09 29.7402 610.06 29.7202 610.04 29.6902C610.01 29.6802 609.99 29.6602 609.97 29.6402C609.94 29.6302 609.91 29.6102 609.88 29.6002C609.82 29.5602 609.78 29.5102 609.74 29.4502C609.62 29.5402 609.49 29.6102 609.36 29.6702C609.36 29.6902 609.36 29.7102 609.36 29.7302C609.4 29.6902 609.44 29.6602 609.49 29.6402C609.64 29.5702 609.82 29.5802 609.95 29.6802C610.1 29.8002 610.2 29.9702 610.23 30.1702C610.28 30.3502 610.28 30.5402 610.23 30.7202C610.17 30.9002 610.01 31.0202 609.82 31.0302C609.63 31.0302 609.46 30.9302 609.39 30.7602C609.35 30.6602 609.33 30.5602 609.32 30.4602V30.4002C609.27 30.2802 609.24 30.1602 609.24 30.0302C609.24 30.0102 609.24 29.9902 609.24 29.9602C609.2 30.0002 609.15 30.0402 609.1 30.0602C608.96 30.1202 608.8 30.1102 608.68 30.0202C608.58 29.9502 608.52 29.8502 608.49 29.7402C608.47 29.7002 608.46 29.6602 608.46 29.6202C608.46 29.6002 608.46 29.5702 608.46 29.5502C608.41 29.5502 608.35 29.5502 608.3 29.5302C608.15 29.5602 607.99 29.5502 607.85 29.5002C607.69 29.4202 607.55 29.2902 607.47 29.1402H607.43C607.56 29.2402 607.65 29.3802 607.69 29.5402C607.78 29.8902 607.69 30.2602 607.45 30.5302C607.45 30.5302 607.4 30.6002 607.37 30.6402C607.25 30.8202 607.09 30.9802 606.9 31.0802C606.73 31.1702 606.53 31.1902 606.34 31.1502C606.33 31.1502 606.32 31.1702 606.31 31.1702C606.2 31.2402 606.08 31.2602 605.96 31.2302C605.83 31.1902 605.72 31.1002 605.66 30.9802V30.9602C605.6 30.9902 605.54 31.0202 605.48 31.0302C605.25 31.1302 604.98 31.0702 604.8 30.8902C604.75 30.8302 604.7 30.7802 604.65 30.7202C604.47 30.5502 604.33 30.3502 604.23 30.1202C604.16 29.8702 604.22 29.6002 604.38 29.4002C604.4 29.3702 604.42 29.3402 604.44 29.3002C604.49 29.1302 604.58 28.9702 604.7 28.8402C604.73 28.8102 604.78 28.7802 604.82 28.7602C604.7 28.6902 604.63 28.5702 604.61 28.4402C604.61 28.4402 604.6 28.4402 604.59 28.4402C604.45 28.4402 604.33 28.3702 604.25 28.2602C604.25 28.2802 604.23 28.3002 604.22 28.3202C604.19 28.3702 604.14 28.4202 604.1 28.4602V28.5102C604.08 28.6102 604.06 28.7202 604.03 28.8202C603.98 28.9802 603.84 29.0902 603.67 29.1202C603.5 29.1402 603.34 29.0702 603.24 28.9402C603.16 28.8202 603.11 28.6702 603.11 28.5302C603.03 28.2702 603.08 27.9902 603.25 27.7802C603.43 27.6202 603.69 27.5802 603.92 27.6502C603.86 27.4902 603.88 27.2702 604.19 27.0302C604.36 26.9002 604.59 26.9002 604.77 27.0202C604.75 26.9602 604.74 26.9102 604.73 26.8502H604.71L604.62 26.8002C604.62 26.8002 604.58 26.7802 604.51 26.8002C604.26 26.8802 604.1 27.3702 603.99 27.2302C603.96 27.2502 603.93 26.6602 603.9 26.6702C603.55 26.8302 603.16 26.8402 602.8 26.7202C602.54 26.6302 602.42 27.0102 602.34 26.8502C602.31 26.7902 602.28 26.7302 602.25 26.6802C602.16 26.6802 602.08 26.6802 601.99 26.6902C601.99 27.1302 601.82 26.9902 601.41 27.0902C601.33 27.1102 601.25 27.1302 601.16 27.1402C601.19 27.2002 601.21 27.2702 601.21 27.3402C601.23 27.5402 601.13 27.7402 600.95 27.8402C600.8 27.9502 600.59 27.9702 600.42 27.8802H600.41L600.36 27.8502C600.25 27.8002 600.16 27.7402 600.07 27.6602C599.98 27.5702 599.94 27.4602 599.94 27.3402C599.71 27.3702 599.48 27.3102 599.3 27.1702C599.19 27.0802 599.13 26.9502 599.13 26.8102C599.13 26.6802 599.18 27.1802 599.25 27.1102C599.22 27.0802 599.19 27.0502 599.16 27.0202L599.14 26.9902C599.05 27.0902 598.96 27.1702 598.84 27.2302C598.87 27.6902 598.63 27.2502 598.43 27.3102C598.33 27.3402 598.22 27.3502 598.12 27.3502C598.02 27.4102 597.9 27.4502 597.78 27.4602C597.62 27.6202 597.38 27.6602 597.17 27.5602C597.09 27.6802 596.96 27.7702 596.81 27.7802C596.43 27.8102 596.3 27.4502 596.24 27.2802V27.2502C596.17 27.1902 596.13 27.1202 596.11 27.0402H596.1C596.04 27.0802 595.98 27.1102 595.92 27.1502C595.82 27.2202 595.72 27.2702 595.62 27.3302C595.48 27.3902 595.33 27.4102 595.18 27.4002C595.18 27.4502 595.18 27.4902 595.15 27.5402H595.16C595.3 27.5802 595.43 27.6402 595.55 27.7302C595.69 27.8202 595.8 27.9502 595.88 28.1002C595.88 28.1002 595.9 28.1235 595.94 28.1702C596.03 28.2302 596.12 28.3002 596.21 28.3702C596.27 28.4202 596.33 28.4702 596.4 28.5102C596.52 28.5902 596.62 28.6802 596.71 28.7902C596.74 28.8302 596.78 28.8702 596.83 28.9002C596.93 28.9702 596.99 29.0002 597.04 29.0302L597.1 29.0602C597.15 29.0002 597.21 28.9602 597.27 28.9302C597.4 28.8802 597.54 28.8602 597.68 28.8802H597.71V28.8402C597.79 28.7302 597.9 28.6602 598.03 28.6402C598.16 28.6202 598.28 28.6502 598.38 28.7302C598.46 28.8002 598.52 28.9002 598.55 29.0002C598.58 29.0802 598.6 29.1602 598.59 29.2402C598.57 29.4102 598.45 29.5502 598.29 29.6202H598.27C598.27 29.6202 598.24 29.6502 598.23 29.6602C598.26 29.6802 598.29 29.7002 598.33 29.7202C598.49 29.8302 598.61 29.9802 598.68 30.1702C598.73 30.2302 598.8 30.2702 598.87 30.3002C598.99 30.3502 599.1 30.4102 599.2 30.4802C599.31 30.5502 599.41 30.6402 599.5 30.7302C599.53 30.7602 599.56 30.8002 599.6 30.8202C599.77 30.7702 599.95 30.7702 600.13 30.8202C600.3 30.8502 600.45 30.9302 600.57 31.0502C600.65 30.9902 600.73 30.9302 600.81 30.8702C601.05 30.6402 601.38 30.5302 601.7 30.5702C601.99 30.6102 602.26 30.7602 602.44 30.9902H602.46C602.67 30.9802 602.87 31.0402 603.04 31.1602C603.07 31.1802 603.1 31.2002 603.13 31.2102C603.17 31.1902 603.22 31.1702 603.26 31.1502C603.46 31.0602 603.98 30.8102 604.25 31.2602C604.27 31.2902 604.29 31.3302 604.3 31.3702C604.52 31.2302 604.82 31.2802 604.98 31.4902C605.03 31.5502 605.07 31.6202 605.12 31.7002C605.16 31.7802 605.22 31.8502 605.29 31.9202C605.29 31.9202 605.38 31.9202 605.43 31.9202C605.68 31.9202 605.93 32.0002 606.12 32.1802C606.3 32.4102 606.34 32.7102 606.24 32.9802V33.0002H606.25L606.28 33.0202C606.28 33.0202 606.33 32.9602 606.37 32.9302H606.38C606.48 32.8502 606.6 32.8302 606.72 32.8502C606.86 32.8802 606.98 32.9702 607.05 33.0902C607.19 33.2302 607.22 33.4402 607.13 33.6102C607.13 33.6202 607.11 33.6402 607.11 33.6502C607.11 33.6502 607.09 33.6802 607.07 33.7002C607.03 33.7502 606.97 33.7902 606.91 33.8202H606.88V33.8602C606.87 33.9202 606.87 33.9702 606.87 34.0302C606.87 34.0302 606.9 34.0602 606.93 34.0902C607.06 34.2202 607.15 34.3802 607.19 34.5502L607.21 34.6402C607.23 34.7202 607.24 34.7902 607.26 34.8702C607.36 34.9302 607.43 35.0102 607.48 35.1102C607.58 35.3402 607.53 35.6102 607.35 35.8002L607.29 35.8702C607.29 35.8702 607.29 35.9202 607.3 35.9502C607.34 35.8902 607.39 35.8402 607.45 35.8102C607.56 35.7402 607.65 35.6902 607.73 35.6302C607.83 35.5602 607.93 35.4902 608.07 35.4102C608.18 35.3502 608.31 35.3302 608.43 35.3702C608.35 35.2602 608.32 35.1202 608.35 34.9902C608.38 34.8602 608.46 34.7502 608.57 34.6902C608.68 34.6302 608.81 34.6002 608.94 34.6002V34.6802H608.95V34.6002C609.15 34.6002 609.33 34.7102 609.44 34.8802C609.56 35.0502 609.54 35.2802 609.41 35.4302C609.35 35.4902 609.29 35.5302 609.21 35.5602C609.34 35.6802 609.45 35.8102 609.54 35.9602C609.61 36.0602 609.63 36.1902 609.6 36.3102C609.6 36.3302 609.59 36.3602 609.58 36.3802C609.71 36.4602 609.8 36.5802 609.84 36.7302C609.94 36.8902 610.02 37.0602 610.08 37.2502C610.17 37.5602 610.25 37.8302 610.1 38.0602V38.1002C610.25 38.1002 610.38 38.1802 610.46 38.2902C610.48 38.2502 610.51 38.2102 610.54 38.1802C610.55 38.1102 610.58 38.0402 610.63 37.9902C610.7 37.9202 610.78 37.8702 610.88 37.8502C610.93 37.7402 611.02 37.6602 611.13 37.6202C611.18 37.6002 611.23 37.5802 611.28 37.5702C611.41 37.5202 611.56 37.5302 611.68 37.6002C611.8 37.6702 611.88 37.7802 611.91 37.9102C611.97 37.8802 612.04 37.8702 612.11 37.8702L612.01 37.8102ZM612.2 38.1402L612.14 38.2402H612.19L612.27 38.1802C612.27 38.1802 612.23 38.1502 612.2 38.1302V38.1402ZM608.68 37.3302C608.79 37.3402 608.9 37.3502 609.03 37.3502H609.09C609.09 37.3502 609.04 37.2502 609.01 37.2102L608.98 37.1602C608.98 37.1602 608.96 37.1302 608.96 37.1202C608.84 37.0902 608.73 37.0202 608.64 36.9302C608.64 36.9302 608.64 36.9302 608.64 36.9202C608.59 36.9202 608.54 36.9002 608.49 36.8802C608.49 36.9102 608.47 36.9302 608.46 36.9502C608.45 36.9802 608.43 37.0002 608.41 37.0302C608.53 37.1102 608.62 37.2102 608.69 37.3302H608.68ZM608.78 35.2302L608.6 35.3602C608.6 35.3602 608.65 35.4102 608.69 35.4302C608.7 35.4302 608.72 35.4302 608.74 35.4302C608.78 35.4302 608.82 35.4302 608.86 35.4302V35.3802L608.79 35.2402L608.78 35.2302ZM605.34 29.9202C605.34 29.9202 605.4 29.9602 605.43 29.9902C605.53 30.0702 605.62 30.1702 605.69 30.2902C605.72 30.2702 605.76 30.2502 605.79 30.2402C605.83 30.0402 605.98 29.8902 606.17 29.8302C606.26 29.8102 606.34 29.7802 606.41 29.7302C606.4 29.7302 606.38 29.7202 606.35 29.6902C606.18 29.5402 606.14 29.2802 606.27 29.0902C606.16 29.0602 606.06 29.0102 605.97 28.9402C605.9 28.8802 605.84 28.8102 605.8 28.7302C605.72 28.7702 605.64 28.7902 605.55 28.8002H605.52C605.62 28.8002 605.72 28.8402 605.8 28.9002C605.95 28.9402 606.08 29.0502 606.14 29.1902C606.19 29.3102 606.19 29.4402 606.14 29.5602C606.09 29.6802 605.99 29.7702 605.87 29.8002C605.73 29.8502 605.58 29.8402 605.44 29.7802C605.4 29.8202 605.36 29.8502 605.31 29.8702C605.31 29.8902 605.31 29.9102 605.31 29.9202H605.34ZM605.58 29.5402C605.57 29.5902 605.55 29.6502 605.52 29.6902C605.55 29.6902 605.59 29.6902 605.62 29.6702L605.58 29.5302V29.5402ZM605.42 29.6602H605.43L605.56 29.4702L605.42 29.6602ZM605.7 29.2002V29.2302L605.82 29.0502L605.88 29.0202C605.88 29.0202 605.87 29.0002 605.86 28.9902L605.84 28.9602H605.82L605.8 28.9402L605.73 29.0902L605.68 29.1902L605.7 29.2002ZM605.69 28.9202C605.69 28.9202 605.64 28.9202 605.61 28.9302L605.67 29.1302L605.78 28.9302C605.78 28.9302 605.71 28.9102 605.68 28.9102L605.69 28.9202ZM605.24 28.7802C605.24 28.7802 605.27 28.8002 605.28 28.8202L605.3 28.8402C605.3 28.8402 605.34 28.8202 605.36 28.8202C605.38 28.8202 605.41 28.8102 605.44 28.8002C605.37 28.8002 605.31 28.8002 605.24 28.7902V28.7802ZM603.93 28.3002L604.05 28.3502L603.93 28.3002ZM603.74 28.2302L603.88 28.2902L603.74 28.2302ZM600.26 27.2802C600.26 27.2802 600.26 27.3402 600.26 27.3702L600.35 27.3202L600.33 27.3002L600.36 27.2702C600.36 27.2702 600.3 27.2702 600.27 27.2802H600.26ZM608.33 26.2402V26.2702C608.35 26.3502 608.35 26.4302 608.33 26.5102C608.43 26.4402 608.56 26.4202 608.67 26.4502L608.7 26.4302C608.7 26.4302 608.74 26.4002 608.76 26.3902V26.3602C608.76 26.3602 608.76 26.3002 608.76 26.2602C608.67 26.3002 608.57 26.3102 608.48 26.2902C608.43 26.2802 608.39 26.2602 608.34 26.2402H608.33ZM608.15 25.1202C608.2 25.1202 608.25 25.1202 608.3 25.1402C608.36 25.0702 608.44 25.0102 608.52 24.9802C608.57 24.9602 608.62 24.9302 608.68 24.9102C608.81 24.8402 608.95 24.7802 609.1 24.7402C608.98 24.6302 608.89 24.4802 608.83 24.3202C608.78 24.1302 608.8 23.9302 608.87 23.7502C608.88 23.7102 608.9 23.6602 608.9 23.6302C608.88 23.6102 608.86 23.5902 608.84 23.5702C608.7 23.4302 608.6 23.2502 608.56 23.0502C608.54 22.8902 608.56 22.7302 608.6 22.5702C608.61 22.5202 608.62 22.4702 608.63 22.4202C608.61 22.2802 608.61 22.1402 608.63 22.0002C608.63 21.9402 608.64 21.8802 608.63 21.8202C608.61 21.6802 608.61 21.5402 608.62 21.4002C608.62 21.3402 608.62 21.2902 608.62 21.2302C608.6 21.1602 608.56 21.0902 608.51 21.0302C608.49 21.0302 608.48 21.0202 608.46 21.0102C608.46 21.0302 608.46 21.0502 608.45 21.0802C608.44 21.1902 608.42 21.3102 608.39 21.4402C608.37 21.5302 608.35 21.6202 608.34 21.7202C608.34 21.7802 608.36 21.8402 608.37 21.8902C608.42 22.0502 608.44 22.2102 608.42 22.3802C608.31 23.1002 608.1 23.2202 608.02 23.2702C607.9 23.3402 607.77 23.3802 607.63 23.3802C607.65 23.5302 607.66 23.6802 607.66 23.8302C607.66 23.9202 607.66 24.0202 607.66 24.1102C607.66 24.1102 607.68 24.1802 607.69 24.2202C607.94 24.3002 608.1 24.5402 608.07 24.8002C608.05 24.9102 608.02 25.0302 608 25.1402C608.05 25.1302 608.09 25.1202 608.14 25.1202H608.15ZM613.42 19.0002L613.6 19.1102L613.51 19.0302C613.51 19.0302 613.45 19.0202 613.42 19.0102V19.0002ZM587.74 50.7002C587.52 50.7002 587.34 50.5402 587.3 50.3302C587.28 50.2102 587.28 50.0902 587.3 49.9702C587.3 49.9202 587.3 49.8702 587.3 49.8202C587.27 49.6502 587.27 49.4802 587.3 49.3202V49.2302C587.32 48.8402 587.51 48.4702 587.83 48.2402C587.94 48.1702 587.89 48.1902 587.89 48.1902C587.89 48.1902 587.88 48.1502 587.87 48.1302C587.87 48.0202 587.8 47.9202 587.71 47.8802C587.52 47.7702 587.38 47.5902 587.32 47.3802V47.3502L587.28 47.3302C587.03 47.1502 586.91 46.8402 586.98 46.5502L587.01 46.4602C586.92 46.3302 586.84 46.1802 586.78 46.0402C586.73 45.9302 586.73 45.8002 586.78 45.6902C586.83 45.5802 586.91 45.4902 587.03 45.4402C587.03 45.4402 587.05 45.4402 587.06 45.4302L587.04 45.4102C586.96 45.3202 586.92 45.2002 586.94 45.0802C586.9 45.0602 586.85 45.0402 586.8 45.0402C586.6 44.9902 586.45 44.8402 586.4 44.6402C586.35 44.3002 586.63 44.1502 586.81 44.0502C586.9 44.0002 586.99 43.9502 587.08 43.8802C587.08 43.8802 587.06 43.8402 587.05 43.8202H587.03C586.9 43.8002 586.77 43.7702 586.65 43.7102C586.53 43.6402 586.42 43.5602 586.33 43.4502C586.31 43.4202 586.28 43.4002 586.26 43.3802C586.09 43.3002 586 43.1102 586.03 42.9302C586.04 42.8702 586.05 42.8102 586.05 42.7402C586.05 42.7802 586.07 42.8102 586.09 42.8402L586.83 42.3202C586.92 42.4602 586.96 42.6202 586.95 42.7902L587 42.8402C587 42.8402 587.04 42.8802 587.06 42.9002C587.06 42.8802 587.07 42.8502 587.08 42.8302C587.17 42.6102 587.4 42.5002 587.63 42.5502C587.65 42.5502 587.68 42.5502 587.7 42.5502C587.84 42.5302 587.99 42.5802 588.09 42.6702C588.19 42.7602 588.25 42.8902 588.24 43.0302V43.0502H588.26C588.34 43.0202 588.45 43.0102 588.56 42.9902C588.67 42.9802 588.77 42.9602 588.88 42.9302C589.68 42.6602 589.92 42.8602 590.01 42.9302L589.44 43.6302C589.44 43.6302 589.53 43.6902 589.58 43.7002C589.44 43.7102 589.3 43.7402 589.17 43.7902C589.02 43.8402 588.87 43.8702 588.71 43.8902C588.71 43.9202 588.7 43.9602 588.7 43.9902V44.0602C588.78 44.0802 588.88 44.1102 588.97 44.1402L589.02 44.1602C589.13 43.9402 589.35 43.8002 589.59 43.7702C589.78 43.7702 589.96 43.7902 590.14 43.8502C590.18 43.8602 590.23 43.8802 590.27 43.8902C590.33 43.8902 590.38 43.8802 590.44 43.8602C590.51 43.8402 590.58 43.8302 590.65 43.8202C590.85 43.7702 591.06 43.8202 591.23 43.9402C591.33 44.0302 591.4 44.1702 591.4 44.3102C591.4 44.4202 591.4 44.5402 591.37 44.6502C591.4 44.6702 591.43 44.6902 591.48 44.7202C591.65 44.8302 591.77 45.0102 591.81 45.2102C591.82 45.2102 591.84 45.2102 591.85 45.2102C591.98 45.1902 592.11 45.2002 592.24 45.2102C592.61 45.3102 592.88 45.6302 592.92 46.0102C592.95 46.2402 592.81 46.4502 592.59 46.5102C592.5 46.5402 592.41 46.5702 592.33 46.6102C592.24 46.6502 592.15 46.6902 592.05 46.7302C591.88 46.7802 591.7 46.7902 591.52 46.7602C591.47 46.7602 591.43 46.7502 591.38 46.7502C591.34 46.8002 591.3 46.8502 591.26 46.9002C591.19 46.9802 591.11 47.0602 591.03 47.1302C590.99 47.1802 590.96 47.2402 590.94 47.3002C590.9 47.4002 590.84 47.4902 590.78 47.5802C590.76 47.6302 590.75 47.6802 590.76 47.7302C590.83 47.8002 590.9 47.8602 590.99 47.9202C591.06 47.9702 591.12 48.0202 591.17 48.0902C591.24 48.1702 591.27 48.2802 591.26 48.3802C591.26 48.5802 591.12 48.7502 590.93 48.8002C590.91 48.8402 590.89 48.8902 590.88 48.9402C590.83 49.1202 590.74 49.2802 590.62 49.4102C590.47 49.5402 590.3 49.6502 590.11 49.7202C590.05 49.7402 589.99 49.7702 589.94 49.8002C589.94 49.9802 589.86 50.1402 589.72 50.2402C589.56 50.3402 589.36 50.3702 589.18 50.3202H589.16C588.99 50.3702 588.8 50.3102 588.69 50.1602H588.68L588.52 50.3002C588.35 50.4502 588.17 50.5902 587.97 50.7002C587.9 50.7402 587.83 50.7602 587.75 50.7602L587.74 50.7002ZM589.16 48.5202C589.28 48.6502 589.39 48.7902 589.48 48.9402C589.54 48.9102 589.59 48.8802 589.65 48.8602L589.6 48.8302C589.46 48.7502 589.38 48.6002 589.38 48.4402C589.32 48.4902 589.24 48.5202 589.16 48.5202ZM588.17 47.1002C588.41 47.2302 588.59 47.4502 588.68 47.7002C588.7 47.6702 588.72 47.6402 588.75 47.6102C588.81 47.5502 588.88 47.5002 588.95 47.4502C588.88 47.3702 588.83 47.2802 588.8 47.1902C588.7 47.2102 588.59 47.1902 588.5 47.1502C588.39 47.0902 588.25 47.0102 588.11 46.9202C588.13 46.9802 588.15 47.0302 588.17 47.0802C588.17 47.0802 588.17 47.0902 588.17 47.1002ZM589.29 46.1902C589.35 46.2002 589.4 46.2202 589.45 46.2502C589.57 46.1902 589.71 46.1402 589.85 46.1202L590 46.0902C590.17 46.0502 590.34 46.0302 590.51 46.0402C590.51 46.0202 590.51 46.0002 590.51 45.9802C590.51 45.9202 590.53 45.8602 590.55 45.8102C590.48 45.7802 590.42 45.7502 590.36 45.7202C590.23 45.6402 590.11 45.5502 590 45.4402L589.97 45.4602C589.81 45.5602 589.68 45.6402 589.55 45.7302C589.55 45.7502 589.54 45.7802 589.52 45.8002C589.47 45.9302 589.39 46.0402 589.3 46.1402L589.26 46.1702L589.28 46.1902H589.29ZM587.73 43.0702L587.85 43.2402C587.85 43.2402 587.89 43.1802 587.91 43.1402L587.73 43.0702ZM612.22 49.1302C612.16 49.1302 612.1 49.1202 612.04 49.0902C611.85 49.0002 611.7 48.8402 611.61 48.6502C611.6 48.6202 611.58 48.5902 611.56 48.5602C611.49 48.5102 611.42 48.4702 611.34 48.4302C611.21 48.3602 611.09 48.2902 610.98 48.2002C610.86 48.1102 610.8 47.9702 610.81 47.8202C610.81 47.6702 610.9 47.5402 611.03 47.4602C611.18 47.2902 611.43 47.2302 611.64 47.3202C611.78 47.3902 611.91 47.4802 612.03 47.5902C612.09 47.6502 612.16 47.7002 612.23 47.7402C612.29 47.7702 612.36 47.7802 612.43 47.8002C612.59 47.8302 612.75 47.8902 612.9 47.9602C613.05 48.0302 613.14 48.1802 613.15 48.3402C613.15 48.5002 613.08 48.6602 612.94 48.7402C612.85 48.7902 612.77 48.8502 612.69 48.9202C612.56 49.0402 612.4 49.1102 612.23 49.1302H612.22ZM611.28 42.5702C611.07 42.5602 610.88 42.4302 610.79 42.2402C610.71 42.0702 610.73 41.8602 610.86 41.7202C610.97 41.6002 611.12 41.5402 611.29 41.5502C611.43 41.5102 611.58 41.5502 611.7 41.6402C611.8 41.7002 611.88 41.7902 611.93 41.8902C611.98 42.0002 611.99 42.1302 611.95 42.2502C611.91 42.3702 611.82 42.4602 611.7 42.5102C611.6 42.5502 611.48 42.5702 611.37 42.5702L611.35 42.4502C611.35 42.4502 611.33 42.4502 611.32 42.4502V42.5702C611.32 42.5702 611.3 42.5702 611.29 42.5702H611.28ZM611.29 42.2002L611.31 42.4402H611.34L611.3 42.2002H611.29ZM611.33 41.6802L611.44 41.9102L611.52 41.7402C611.47 41.7002 611.4 41.6802 611.34 41.6702L611.33 41.6802ZM611.88 30.3402C611.81 30.3402 611.74 30.3302 611.68 30.3002C611.52 30.2602 611.39 30.1402 611.34 29.9702C611.3 29.8102 611.35 29.6302 611.48 29.5202C611.53 29.4802 611.58 29.4502 611.63 29.4302C611.72 29.3802 611.82 29.3702 611.92 29.3902C612.03 29.4102 612.12 29.4602 612.19 29.5502C612.23 29.5902 612.27 29.6402 612.3 29.6902C612.37 29.8202 612.37 29.9702 612.3 30.1002C612.23 30.2302 612.11 30.3202 611.96 30.3402C611.93 30.3402 611.91 30.3402 611.88 30.3402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.01 45.5501C609.01 45.5501 608.86 45.2501 608.88 45.2401C608.89 45.2401 608.91 45.2601 608.91 45.2401C608.89 45.2801 608.84 45.2701 608.82 45.3001C608.79 45.3001 608.84 45.3801 608.82 45.3901C608.8 45.3901 608.72 45.3201 608.71 45.3301C608.74 45.3001 608.98 45.5801 609.02 45.5501H609.01Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.03 46.0001C608.85 45.9801 608.68 45.9001 608.56 45.7701L608.52 45.7401C608.52 45.7401 608.46 45.7101 608.43 45.6901C608.25 45.5601 608.2 45.3101 608.31 45.1101C608.33 45.0801 608.35 45.0401 608.38 45.0201C608.44 44.9601 608.51 44.9101 608.59 44.8901H608.61C608.68 44.8301 608.75 44.8001 608.83 44.7901C608.91 44.7801 608.99 44.7901 609.07 44.8101C609.24 44.8701 609.35 45.0301 609.36 45.2101C609.46 45.3501 609.49 45.5301 609.43 45.7001C609.41 45.7601 609.38 45.8101 609.33 45.85C609.25 45.9401 609.14 45.9901 609.02 46.0001H609.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.24 31.4701C613.24 31.4701 613.42 31.2901 613.43 31.3001C613.44 31.3101 613.25 31.4501 613.23 31.4701C613.21 31.4901 613.17 31.3501 613.15 31.3601C613.12 31.3601 613.22 31.4901 613.24 31.4701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.23 31.9201C613.23 31.9201 613.19 31.9201 613.17 31.9201C613.12 31.9201 613.08 31.9001 613.04 31.8801C612.84 31.7801 612.71 31.5801 612.71 31.3601C612.71 31.1701 612.84 31.0001 613.02 30.9401C613.08 30.9201 613.15 30.9101 613.21 30.9201C613.28 30.8801 613.36 30.8601 613.44 30.8601C613.57 30.8601 613.69 30.9201 613.78 31.0101C613.87 31.1101 613.91 31.2301 613.89 31.3601C613.87 31.5701 613.73 31.6701 613.57 31.7901C613.48 31.8701 613.37 31.9201 613.25 31.9201H613.23ZM613.48 31.3701H613.6C613.62 31.2301 613.53 31.1001 613.4 31.0501L613.33 31.2301L613.41 31.3201L613.44 31.2901L613.48 31.3601V31.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M600.91 28.2402C600.91 28.2402 600.78 28.1802 600.81 28.1602C600.83 28.1402 600.9 28.2202 600.92 28.2402C600.99 28.3002 601.02 28.4902 601.09 28.5502C601.11 28.5202 601.12 28.4502 601.14 28.4202C601.04 28.4002 601.01 28.2702 600.91 28.2502V28.2402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M601.09 28.9902C600.99 28.9902 600.89 28.9602 600.81 28.8902C600.71 28.8102 600.64 28.7002 600.6 28.5702C600.47 28.5002 600.39 28.3702 600.36 28.2302C600.34 28.0902 600.39 27.9402 600.49 27.8402C600.58 27.7502 600.7 27.7002 600.82 27.7002C600.97 27.7002 601.11 27.7702 601.21 27.8902C601.26 27.9302 601.31 27.9702 601.35 28.0202C601.56 28.1302 601.65 28.3902 601.54 28.6102C601.52 28.6802 601.49 28.7502 601.44 28.8102C601.37 28.9102 601.26 28.9702 601.14 28.9902C601.12 28.9902 601.1 28.9902 601.08 28.9902H601.09Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.15 18.9301C610.15 18.9301 610.37 18.9801 610.35 19.0001C610.33 19.0201 610.31 18.8401 610.29 18.8201C610.26 18.7401 610.2 18.6801 610.17 18.5901C610.16 18.6201 610.03 18.7301 610.04 18.7501C610.07 18.8101 610.11 18.8701 610.15 18.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.34 19.4601C610.34 19.4601 610.25 19.4601 610.21 19.4401C610.17 19.4301 610.14 19.4101 610.11 19.3901C610 19.3701 609.9 19.3101 609.82 19.2301C609.77 19.1701 609.72 19.1101 609.69 19.0401C609.61 18.9401 609.58 18.8101 609.59 18.6801C609.61 18.5501 609.68 18.4401 609.78 18.3601C609.86 18.2301 610.01 18.1501 610.16 18.1501C610.35 18.1501 610.52 18.2701 610.58 18.4501C610.62 18.5101 610.65 18.5701 610.68 18.6401C610.7 18.6901 610.72 18.7401 610.73 18.7901C610.81 18.9301 610.8 19.1001 610.72 19.2401C610.64 19.3801 610.49 19.4601 610.33 19.4601H610.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.32 46.5701C611.29 46.6601 611.12 46.6601 611.1 46.7501C611.12 46.6501 611.15 46.6001 611.17 46.5001C611.19 46.4801 611.03 46.5801 611.05 46.5601C611.03 46.5901 611.34 46.5401 611.32 46.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.1 47.2002C611.1 47.2002 611.03 47.2002 610.99 47.1902C610.79 47.1402 610.65 46.9702 610.65 46.7702C610.59 46.6602 610.58 46.5202 610.63 46.4002C610.67 46.2802 610.77 46.1802 610.89 46.1402C611.05 46.0302 611.27 46.0202 611.43 46.1302C611.54 46.1502 611.64 46.2202 611.7 46.3202C611.77 46.4302 611.79 46.5702 611.76 46.7002C611.71 46.8602 611.59 46.9901 611.44 47.0601C611.35 47.1501 611.23 47.2102 611.11 47.2102L611.1 47.2002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.02 15.7201C612.05 15.6301 612.4 15.4701 612.43 15.3801C612.41 15.4701 612.22 15.7201 612.2 15.8101C612.18 15.8401 612.2 15.8401 612.16 15.8301C612.06 15.8001 612.01 15.7501 612.02 15.7201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.18 16.2802C612.12 16.2802 612.07 16.2801 612.02 16.2501C611.84 16.2001 611.69 16.0701 611.61 15.9101C611.57 15.8001 611.56 15.6802 611.6 15.5702C611.68 15.4002 611.81 15.2601 611.98 15.1701C612.01 15.1501 612.05 15.1301 612.07 15.1101C612.2 14.9401 612.43 14.8801 612.62 14.9701C612.81 15.0601 612.92 15.2701 612.87 15.4801C612.83 15.6001 612.77 15.7202 612.7 15.8302C612.67 15.8802 612.64 15.9202 612.62 15.9602C612.62 16.0002 612.6 16.0301 612.57 16.0601C612.49 16.2101 612.34 16.2901 612.17 16.2901L612.18 16.2802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.01 47.0302C613.01 47.0302 612.98 47.2302 613 47.2802C613 47.2602 613.11 47.1201 613.1 47.1101C613.08 47.0901 613.06 47.0301 613.03 47.0101C612.96 46.9601 612.8 47.0501 612.73 47.0101C612.72 47.0401 612.76 46.9601 612.75 46.9901C612.84 47.0001 612.92 47.0301 613.01 47.0401V47.0302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.99 47.7201C612.82 47.7201 612.66 47.6201 612.59 47.4701C612.59 47.4501 612.58 47.4401 612.57 47.4201C612.55 47.4201 612.53 47.4001 612.51 47.3901C612.38 47.3101 612.29 47.1801 612.28 47.0201C612.27 46.8701 612.34 46.7201 612.46 46.6301C612.58 46.5301 612.74 46.5001 612.89 46.5401C613.03 46.5201 613.17 46.5401 613.28 46.6201C613.36 46.6701 613.42 46.7401 613.47 46.8301C613.61 47.0201 613.59 47.2801 613.43 47.4401C613.38 47.5701 613.26 47.6701 613.13 47.7101C613.09 47.7101 613.06 47.7201 613.02 47.7201H612.99Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M604.48 31.0502C604.42 31.0302 604.43 30.8202 604.38 30.8402C604.34 30.8502 604.33 31.0702 604.31 31.1302C604.36 31.1302 604.41 31.1302 604.46 31.0902C604.51 31.0602 604.45 31.1102 604.48 31.0502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M604.34 31.5802C604.29 31.5802 604.23 31.5802 604.18 31.5502C604.06 31.5102 603.96 31.4202 603.91 31.3102C603.86 31.2002 603.86 31.0602 603.91 30.9402C603.9 30.7202 604.03 30.5102 604.23 30.4202C604.36 30.3702 604.5 30.3902 604.62 30.4502C604.75 30.5302 604.84 30.6602 604.87 30.8102C604.88 30.8302 604.9 30.8602 604.91 30.8802C604.93 30.9402 604.94 31.0002 604.94 31.0602C604.94 31.2302 604.85 31.3902 604.7 31.4702C604.6 31.5402 604.48 31.5702 604.35 31.5802H604.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.26 31.5401C609.24 31.4901 609.22 31.4401 609.19 31.3901C609.11 31.3601 609.03 31.3501 608.95 31.3501C608.93 31.4101 608.99 31.6401 608.98 31.7001C609.04 31.6901 609.2 31.5601 609.26 31.5501V31.5401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.99 32.1501C608.86 32.1501 608.74 32.0901 608.65 32.0001C608.56 31.9001 608.53 31.7701 608.54 31.6401V31.6201C608.49 31.4801 608.49 31.3401 608.54 31.2101C608.6 31.0401 608.75 30.9201 608.93 30.9101C608.93 30.9101 609.42 30.8801 609.59 31.1901C609.63 31.2601 609.67 31.3401 609.7 31.4201C609.77 31.6501 609.66 31.8901 609.43 31.9801C609.41 31.9901 609.39 32.0001 609.37 32.0201C609.29 32.0801 609.19 32.1301 609.09 32.1601C609.06 32.1601 609.02 32.1701 608.99 32.1701V32.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.89 15.9001C610.89 15.9001 610.99 15.6701 611 15.6401C610.95 15.6401 610.82 15.9401 610.76 15.9501C610.75 15.9501 610.77 15.7401 610.76 15.7701C610.81 15.7701 610.84 15.9001 610.88 15.9001H610.89Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.76 16.4002C610.64 16.4002 610.53 16.3502 610.44 16.2702C610.32 16.1402 610.28 15.9701 610.31 15.8001C610.31 15.9001 610.35 16.0001 610.43 16.0701C610.42 16.0501 610.4 16.0402 610.39 16.0202C610.31 15.9002 610.29 15.7401 610.34 15.6001C610.39 15.4601 610.51 15.3601 610.66 15.3201C610.76 15.2201 610.9 15.1701 611.04 15.1901C611.19 15.2001 611.32 15.2901 611.39 15.4201C611.46 15.5501 611.46 15.7102 611.39 15.8402L611.35 15.9301C611.32 16.0101 611.28 16.0901 611.27 16.1101C611.21 16.2301 611.1 16.3102 610.97 16.3402C610.91 16.3702 610.84 16.3902 610.77 16.4002H610.74H610.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M600.79 30.6101C600.73 30.6001 600.79 30.6801 600.75 30.7001C600.7 30.7201 600.57 30.6701 600.54 30.7201C600.6 30.7201 600.73 30.7701 600.77 30.7501C600.82 30.7301 600.77 30.6501 600.79 30.6001V30.6101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M600.74 31.2002C600.66 31.2002 600.58 31.1901 600.5 31.1601C600.35 31.1301 600.23 31.0302 600.16 30.8902C600.09 30.7602 600.09 30.6101 600.16 30.4801C600.23 30.3501 600.35 30.2701 600.5 30.2401C600.62 30.1501 600.77 30.1202 600.91 30.1502C601.14 30.2102 601.29 30.4301 601.25 30.6601C601.26 30.8601 601.15 31.0502 600.97 31.1302C600.9 31.1602 600.82 31.1801 600.75 31.1801L600.74 31.2002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.94 27.1601C612.88 27.1401 612.91 27.0402 612.88 27.0302C612.88 27.0502 612.92 27.2802 612.93 27.2802C612.96 27.2802 612.89 27.1701 612.94 27.1601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.92 27.7301H612.89C612.53 27.7001 612.48 27.3802 612.45 27.2002V27.1302C612.39 26.9802 612.42 26.8102 612.54 26.7002C612.66 26.5902 612.83 26.5501 612.99 26.6001C613.13 26.6501 613.24 26.7502 613.3 26.8902C613.3 26.8902 613.3 26.9101 613.31 26.9201C613.36 26.9901 613.38 27.0801 613.38 27.1701C613.38 27.2101 613.38 27.2501 613.36 27.2901C613.36 27.3901 613.32 27.4902 613.26 27.5802C613.17 27.6802 613.05 27.7401 612.91 27.7401L612.92 27.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.27 39.5601C611.27 39.5601 611.38 39.7001 611.36 39.7001C611.3 39.7001 611.14 39.5601 611.08 39.5801C611.1 39.6001 611.19 39.5501 611.2 39.5501C611.26 39.5401 611.2 39.5801 611.26 39.5501L611.27 39.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.36 40.1501C611.23 40.1501 611.11 40.1001 611.01 40.0301C610.91 40.0101 610.83 39.9601 610.76 39.8901C610.66 39.7801 610.62 39.63 610.66 39.48C610.7 39.33 610.8 39.22 610.94 39.16C610.98 39.15 611.01 39.1401 611.05 39.1301C611.08 39.1201 611.11 39.11 611.14 39.1C611.2 39.09 611.27 39.09 611.33 39.1C611.43 39.11 611.53 39.16 611.61 39.23C611.63 39.26 611.66 39.2801 611.67 39.3101C611.81 39.4601 611.85 39.66 611.79 39.85C611.73 39.99 611.6 40.1 611.45 40.12C611.42 40.12 611.4 40.12 611.37 40.12L611.36 40.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.56 40.04C610.56 40.04 610.59 40.18 610.56 40.22C610.54 40.22 610.53 40.2301 610.51 40.2401C610.57 40.2301 610.55 40.1401 610.61 40.1201C610.57 40.0801 610.6 40.08 610.56 40.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.51 40.6801C610.31 40.6801 610.13 40.5501 610.08 40.3501C610.05 40.2501 610.06 40.1401 610.11 40.0501C610.11 39.9201 610.17 39.7901 610.27 39.7001C610.45 39.5401 610.72 39.5501 610.89 39.7301C610.93 39.7701 610.96 39.8101 610.98 39.8601C611.05 39.9601 611.08 40.0901 611.05 40.2201C611.04 40.2701 611.02 40.3101 611 40.3601C610.98 40.4101 610.96 40.4601 610.92 40.5001C610.88 40.5501 610.82 40.5901 610.76 40.6201C610.71 40.6501 610.66 40.6701 610.61 40.6801C610.58 40.6801 610.55 40.6901 610.51 40.6901V40.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.36 48.48C613.36 48.48 613.31 48.3401 613.3 48.3201C613.29 48.3701 613.28 48.42 613.28 48.47C613.28 48.5 613.28 48.34 613.3 48.36C613.32 48.34 613.34 48.5 613.36 48.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.36 48.9301C613.36 48.9301 613.32 48.9301 613.3 48.9301H613.27C613.05 48.9101 612.88 48.7501 612.85 48.5401C612.85 48.4701 612.85 48.4001 612.85 48.3401C612.85 48.2501 612.88 48.1601 612.93 48.0801C613.02 47.9401 613.18 47.8601 613.35 47.8701C613.52 47.8801 613.66 47.9901 613.73 48.1501C613.73 48.1701 613.76 48.2201 613.77 48.2701C613.83 48.4201 613.82 48.5901 613.74 48.7401C613.66 48.8701 613.51 48.9401 613.36 48.9401V48.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.56 17.5702C609.56 17.5702 609.46 17.5302 609.44 17.5002C609.42 17.5202 609.57 17.4502 609.58 17.4602C609.6 17.5002 609.43 17.6702 609.45 17.7102C609.46 17.6802 609.55 17.6002 609.56 17.5702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.46 18.1501C609.33 18.1501 609.2 18.0901 609.12 17.9901C609.03 17.8901 608.99 17.7501 609.02 17.6201C608.98 17.4601 609.02 17.2901 609.14 17.1701C609.2 17.1101 609.28 17.0701 609.36 17.0601C609.52 16.9701 609.73 16.9901 609.87 17.1001C610.02 17.2201 610.07 17.4101 610.02 17.5901C610.02 17.6401 610.01 17.6801 609.99 17.7201C609.96 17.8001 609.91 17.8601 609.85 17.9201C609.84 17.9301 609.85 17.9201 609.86 17.8901C609.8 18.0201 609.67 18.1001 609.54 18.1301C609.52 18.1301 609.49 18.1301 609.46 18.1301V18.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.81 47.5401C588.81 47.5401 588.67 47.5001 588.7 47.4801C588.67 47.4601 588.79 47.3401 588.78 47.3501C588.71 47.4001 588.64 47.4501 588.58 47.5101C588.61 47.5201 588.78 47.5201 588.81 47.5401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.81 47.9901C588.81 47.9901 588.75 47.9901 588.72 47.9901H588.66C588.58 47.9901 588.5 47.9701 588.43 47.9501C588.28 47.9001 588.17 47.7701 588.14 47.6201C588.11 47.4701 588.16 47.3101 588.27 47.2001C588.36 47.1201 588.45 47.0401 588.55 46.9801C588.74 46.8701 588.98 46.9101 589.12 47.0801C589.18 47.1601 589.22 47.2601 589.22 47.3601C589.24 47.3901 589.25 47.4301 589.25 47.4601C589.28 47.6301 589.21 47.8101 589.07 47.9101C588.99 47.9701 588.9 48.0001 588.8 48.0001L588.81 47.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.84 42.9901C608.84 42.9901 608.73 43.2501 608.76 43.2601C608.81 43.2801 608.84 43.0701 608.86 43.0201C608.89 42.9601 608.88 42.9701 608.83 42.9901H608.84Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.77 43.7101C608.71 43.7101 608.64 43.7001 608.58 43.6701C608.4 43.5801 608.29 43.3901 608.3 43.1901C608.3 43.1401 608.35 42.6501 608.71 42.5501C608.88 42.4901 609.08 42.5401 609.21 42.6701C609.33 42.8201 609.35 43.0201 609.28 43.1901C609.26 43.3901 609.14 43.5601 608.97 43.6601C608.91 43.6901 608.84 43.7101 608.77 43.7101ZM608.9 43.0201L609.22 43.2101C609.2 43.0501 609.09 42.9101 608.94 42.8401L608.88 42.9701V43.0101L608.9 43.0201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.68 42.6501C609.66 42.7101 609.65 42.6501 609.64 42.7001C609.68 42.7001 609.71 42.93 609.75 42.92C609.77 42.82 609.77 42.7301 609.77 42.6301C609.75 42.5901 609.72 42.6801 609.69 42.6501H609.68Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.73 43.3801C609.59 43.3801 609.37 43.3201 609.26 42.9601C609.19 42.8601 609.17 42.73 609.2 42.61C609.22 42.53 609.26 42.4601 609.31 42.4001C609.37 42.3201 609.45 42.26 609.54 42.23H609.57C609.78 42.13 610.02 42.2001 610.14 42.3901C610.23 42.6201 610.24 42.88 610.15 43.11C610.09 43.25 609.96 43.3501 609.81 43.3701C609.79 43.3701 609.76 43.3701 609.74 43.3701L609.73 43.3801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.93 18.6401C612.93 18.6401 612.93 18.58 612.94 18.6C612.94 18.68 612.94 18.77 612.94 18.85C612.97 18.81 612.99 18.7601 613 18.7101C613 18.6501 612.94 18.7001 612.92 18.6401H612.93Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.95 19.3001C612.95 19.3001 612.88 19.3001 612.85 19.2901C612.7 19.2601 612.58 19.1501 612.53 19.0001C612.5 18.9201 612.49 18.8401 612.5 18.7601C612.48 18.6701 612.48 18.5801 612.5 18.5001C612.57 18.2901 612.76 18.1501 612.98 18.1501C613.15 18.1601 613.3 18.2701 613.37 18.4301C613.42 18.4901 613.45 18.5601 613.47 18.6401C613.48 18.8301 613.42 19.0301 613.28 19.1701C613.2 19.2501 613.08 19.3001 612.96 19.3001H612.95ZM612.63 18.5302L612.73 18.6301L612.63 18.5302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.02 25.2301C608.02 25.2301 608.08 25.1901 608.05 25.2001C608.05 25.2201 607.99 25.2201 608 25.2201C608.06 25.2401 608.13 25.2501 608.2 25.2601C608.2 25.2401 608.04 25.2501 608.03 25.2301H608.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.18 25.7101C608.12 25.7101 608.06 25.7101 608 25.6801C607.96 25.6801 607.91 25.6601 607.87 25.6501C607.85 25.6501 607.83 25.6301 607.81 25.6201C607.64 25.5501 607.53 25.3701 607.54 25.1901C607.54 25.0001 607.67 24.8401 607.85 24.7801C607.88 24.7701 607.91 24.7601 607.94 24.7501C608.06 24.7201 608.2 24.7501 608.3 24.8201C608.43 24.8601 608.54 24.9501 608.6 25.0701C608.66 25.1901 608.65 25.3401 608.6 25.4601C608.54 25.5801 608.43 25.6601 608.3 25.6901C608.26 25.6901 608.23 25.7001 608.19 25.7001L608.18 25.7101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.35 31.6502C612.35 31.6502 612.2 31.6902 612.22 31.7002C612.25 31.7102 612.31 31.6502 612.34 31.6502C612.34 31.6102 612.25 31.6902 612.24 31.6502C612.21 31.6602 612.38 31.6402 612.35 31.6502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.22 32.1602C612.09 32.1602 611.97 32.1002 611.88 32.0002C611.79 31.9002 611.75 31.7702 611.77 31.6402C611.77 31.6102 611.78 31.5802 611.8 31.5402C611.84 31.3902 611.95 31.2702 612.09 31.2202C612.14 31.2002 612.2 31.1902 612.26 31.2002H612.29C612.38 31.2002 612.46 31.2002 612.54 31.2402C612.55 31.2402 612.56 31.2502 612.57 31.2602C612.78 31.3702 612.86 31.6302 612.75 31.8402C612.75 31.8502 612.74 31.8702 612.73 31.8802C612.66 31.9902 612.55 32.0702 612.43 32.1102C612.36 32.1402 612.29 32.1602 612.22 32.1602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.55 31.5502C608.55 31.5502 608.49 31.4802 608.49 31.5002C608.5 31.5902 608.52 31.6902 608.54 31.7802C608.56 31.7602 608.87 31.5802 608.86 31.5602C608.86 31.5002 608.57 31.6102 608.55 31.5602V31.5502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.54 32.2401C608.54 32.2401 608.46 32.2401 608.42 32.2201C608.28 32.1801 608.17 32.0701 608.12 31.9301C608.09 31.8301 608.07 31.7201 608.06 31.6101C608.03 31.3901 608.14 31.1702 608.34 31.0702C608.46 31.0302 608.6 31.0401 608.71 31.1001C609.21 31.0601 609.3 31.3801 609.32 31.4801C609.38 31.7801 609.17 31.9202 608.9 32.0802L608.82 32.1302C608.75 32.2002 608.65 32.2301 608.55 32.2301L608.54 32.2401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.62 34.1101C611.62 34.1101 611.5 33.8701 611.46 33.8601C611.46 33.9101 611.72 34.0001 611.71 34.0401C611.74 34.0401 611.57 33.9901 611.59 33.9701C611.6 33.9701 611.61 34.1301 611.61 34.1001L611.62 34.1101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.62 34.5601C611.62 34.5601 611.52 34.5601 611.47 34.5301C611.32 34.4701 611.2 34.3501 611.14 34.1901V34.1701C610.99 34.0201 610.97 33.7901 611.08 33.6201C611.19 33.4501 611.4 33.3701 611.6 33.4301C611.67 33.4501 611.74 33.4901 611.79 33.5501C611.88 33.6001 611.97 33.6601 612.05 33.7401C612.14 33.8301 612.18 33.9501 612.17 34.0701C612.17 34.2401 612.06 34.3801 611.91 34.4601C611.83 34.5301 611.73 34.5701 611.63 34.5701L611.62 34.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.98 29.6401C607.98 29.6401 607.93 29.6901 607.92 29.7101C607.92 29.8001 607.92 29.8901 607.93 29.9701C607.95 29.8901 607.97 29.8001 607.97 29.7201C607.97 29.6901 607.97 29.6701 607.97 29.6401H607.98Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.93 30.42C607.93 30.42 607.89 30.42 607.88 30.42C607.72 30.4 607.59 30.3 607.52 30.16C607.47 30 607.46 29.84 607.47 29.67C607.49 29.55 607.55 29.4301 607.63 29.3401C607.72 29.2201 607.87 29.1601 608.03 29.1801C608.18 29.2001 608.32 29.3001 608.38 29.4401C608.43 29.5401 608.44 29.6601 608.42 29.7701C608.42 29.9401 608.38 30.1001 608.29 30.2401C608.21 30.3501 608.07 30.41 607.93 30.41V30.42ZM607.57 29.7001L607.67 29.7801L607.57 29.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M602.24 29.7402C602.31 29.7602 602.49 29.6002 602.56 29.6102C602.58 29.6102 602.59 29.7102 602.62 29.6902C602.57 29.6602 602.53 29.4602 602.48 29.4502C602.44 29.4502 602.29 29.6902 602.24 29.7302V29.7402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M602.26 30.1901C602.21 30.1901 602.16 30.1901 602.11 30.1601C601.96 30.1101 601.85 29.9901 601.81 29.8401C601.77 29.6901 601.81 29.5301 601.93 29.4201L601.98 29.3601C602.08 29.1601 602.29 29.0301 602.51 29.0101C602.73 29.0301 602.92 29.1901 602.98 29.4101C602.98 29.4201 602.98 29.4201 602.98 29.4101C603.12 29.6001 603.1 29.8601 602.92 30.0201C602.81 30.1201 602.65 30.1601 602.51 30.1201C602.43 30.1601 602.35 30.1801 602.26 30.1801V30.1901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.16 29.5702C603.13 29.5102 603.2 29.5702 603.17 29.5102C603.14 29.5302 603.02 29.4802 603.03 29.5002C603.05 29.5602 603.27 29.5002 603.3 29.5702C603.33 29.5502 603.13 29.6002 603.16 29.5702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.19 30.0202C603.08 30.0202 602.97 29.9901 602.88 29.9201C602.74 29.8701 602.64 29.7501 602.61 29.6001C602.57 29.4501 602.61 29.2902 602.73 29.1802C602.85 29.0802 603.01 29.0302 603.17 29.0602C603.25 29.0602 603.33 29.0801 603.4 29.1101C603.47 29.1301 603.53 29.1602 603.58 29.2002C603.64 29.2402 603.69 29.3002 603.72 29.3702C603.8 29.5502 603.76 29.7702 603.61 29.9002C603.52 29.9802 603.41 30.0202 603.29 30.0102C603.26 30.0102 603.23 30.0102 603.2 30.0102L603.19 30.0202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.2 30.5501C609.2 30.5501 609.2 30.3601 609.23 30.3701C609.26 30.3801 609.25 30.6101 609.29 30.6101C609.29 30.5701 609.09 30.6601 609.08 30.6301C609.05 30.6401 609.23 30.5501 609.2 30.5601V30.5501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.09 31.0902C609.01 31.0902 608.93 31.0702 608.85 31.0302C608.83 31.0202 608.81 31.0102 608.8 30.9902C608.74 30.9402 608.69 30.8802 608.66 30.8102C608.58 30.6302 608.63 30.4201 608.78 30.3001C608.8 30.1701 608.89 30.0501 609 29.9801C609.13 29.9101 609.3 29.9001 609.43 29.9801C609.59 30.0801 609.69 30.2502 609.69 30.4402C609.69 30.4402 609.71 30.4802 609.71 30.5102C609.75 30.6602 609.71 30.8101 609.61 30.9201C609.52 31.0201 609.39 31.0702 609.26 31.0702C609.2 31.0902 609.14 31.0902 609.08 31.0902H609.09Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M602.7 30.2201C602.7 30.2201 602.96 30.5802 602.97 30.5802C603.03 30.5702 603.03 30.3602 603.09 30.3402C603.07 30.3202 603.09 30.4201 603.08 30.4201C603.02 30.4301 602.76 30.1902 602.7 30.2102V30.2201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M602.95 31.0401C602.73 31.0401 602.61 30.8702 602.4 30.5802L602.35 30.5101C602.27 30.4001 602.24 30.2601 602.27 30.1201C602.3 29.9901 602.4 29.8801 602.52 29.8201C602.7 29.7501 602.9 29.7802 603.06 29.9002C603.21 29.8902 603.35 29.9501 603.45 30.0701C603.54 30.1801 603.57 30.3202 603.53 30.4602C603.53 30.5602 603.48 30.6501 603.42 30.7201C603.36 30.8701 603.23 30.9902 603.08 31.0202C603.04 31.0202 603 31.0301 602.96 31.0401H602.95ZM602.84 30.5501L602.74 30.6301L602.84 30.5501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M597.11 28.85C597.06 28.82 597.14 28.8901 597.09 28.8901C597.04 28.8901 597.15 28.82 597.09 28.85C597.14 28.88 597.02 29.0801 597.07 29.0801C597.12 29.0801 597.05 28.8701 597.1 28.8401L597.11 28.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M597.08 29.5401C596.93 29.5401 596.8 29.4701 596.71 29.3501C596.63 29.2401 596.6 29.0901 596.63 28.9601C596.63 28.8901 596.63 28.8101 596.66 28.7401C596.68 28.6501 596.73 28.5601 596.81 28.5001C596.96 28.3801 597.17 28.3701 597.33 28.4601C597.39 28.4901 597.44 28.5402 597.48 28.5902C597.53 28.6702 597.56 28.7601 597.56 28.8601C597.56 28.8801 597.56 28.9101 597.56 28.9301C597.56 28.9501 597.56 28.9701 597.56 29.0001C597.58 29.1401 597.53 29.2901 597.44 29.4001C597.35 29.4901 597.23 29.5501 597.1 29.5501L597.08 29.5401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M602.22 30.04C602.22 30.04 602.24 30.1601 602.25 30.1801C602.25 30.2401 602.13 30.3101 602.15 30.3701C602.17 30.3501 602.18 30.3301 602.17 30.3201C602.16 30.2601 602.25 30.1 602.22 30.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M602.14 30.8202C601.95 30.8202 601.78 30.7002 601.72 30.5202C601.68 30.4002 601.68 30.2702 601.74 30.1502C601.74 30.1102 601.76 30.0801 601.77 30.0501C601.77 29.9301 601.81 29.8101 601.89 29.7301C602 29.6101 602.16 29.5602 602.31 29.5902C602.47 29.6202 602.59 29.7302 602.65 29.8802C602.67 29.9302 602.68 29.9802 602.68 30.0302C602.68 30.0602 602.69 30.0801 602.7 30.1101C602.72 30.2501 602.68 30.3901 602.6 30.4901C602.57 30.5701 602.52 30.6402 602.45 30.7002C602.37 30.7702 602.26 30.8101 602.15 30.8101L602.14 30.8202ZM601.84 30.0302L601.93 30.1302L601.84 30.0302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.13 55.1C611.26 55.06 611.37 54.9801 611.46 54.8801C611.46 54.8401 611.16 54.75 611.13 54.79C611.07 54.89 611.07 55.0101 611.13 55.1101V55.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.14 55.5501C611.09 55.5501 611.03 55.5501 610.98 55.5201C610.82 55.4501 610.7 55.3101 610.67 55.1401C610.6 54.9201 610.65 54.6801 610.8 54.4901C610.96 54.3001 611.21 54.2702 611.54 54.4002C611.76 54.4502 611.91 54.6501 611.92 54.8701C611.9 55.0801 611.78 55.2601 611.59 55.3601C611.46 55.4601 611.31 55.5301 611.15 55.5401L611.14 55.5501ZM611.01 54.8801C611.01 55.0201 611.07 55.1501 611.19 55.2301C611.3 55.2301 611.4 55.1701 611.47 55.0801C611.51 55.0401 611.54 54.9801 611.53 54.9101C611.49 54.8001 611.4 54.7101 611.29 54.6801L611.26 54.7501L611.42 54.9201L611.2 54.9002L611.13 55.1001L611.06 54.8801H611.01Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M598.35 30.0801C598.41 30.0501 598.46 29.9901 598.52 29.9601C598.5 29.9301 598.49 29.8 598.47 29.8C598.41 29.8 598.44 29.96 598.38 29.97C598.4 30.02 598.32 30.0301 598.35 30.0801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M598.35 30.5301C598.3 30.5301 598.25 30.5301 598.2 30.5001C598.09 30.4601 597.99 30.3801 597.94 30.2701C597.89 30.1401 597.89 30.0001 597.94 29.8801C597.94 29.8401 597.96 29.8001 597.98 29.7601C597.98 29.7501 597.99 29.7401 598 29.7301C598.06 29.5001 598.27 29.3501 598.5 29.3601C598.73 29.3801 598.92 29.5701 598.94 29.8001C599.02 30.0201 598.93 30.2601 598.72 30.3701C598.67 30.4201 598.61 30.4601 598.55 30.4901C598.49 30.5201 598.42 30.5401 598.35 30.5401V30.5301ZM598.23 30.1801C598.29 30.2201 598.36 30.2401 598.43 30.2501L598.4 30.0601H598.38L598.23 30.1801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.41 35.0101C610.47 34.9901 610.72 34.9201 610.78 34.9001C610.73 34.7901 610.68 34.6801 610.62 34.5801C610.53 34.5901 610.44 34.6101 610.35 34.6301C610.36 34.6801 610.4 34.9601 610.41 35.0101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.41 35.4502C610.34 35.4502 610.27 35.4302 610.2 35.4002C610.09 35.3402 610.01 35.2502 609.97 35.1302C609.97 35.1002 609.94 34.9902 609.93 34.8802C609.93 34.8202 609.91 34.7601 609.91 34.7301C609.88 34.6001 609.91 34.4601 610 34.3501C610.08 34.2401 610.21 34.1801 610.34 34.1701C610.45 34.1301 610.57 34.1102 610.69 34.1302C610.94 34.1702 611.01 34.3202 611.16 34.6402C611.23 34.7602 611.24 34.9002 611.2 35.0302C611.16 35.1602 611.07 35.2602 610.95 35.3202C610.91 35.3302 610.82 35.3602 610.72 35.3902C610.66 35.4102 610.6 35.4202 610.57 35.4302C610.52 35.4502 610.47 35.4602 610.42 35.4602L610.41 35.4502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612 50.6501C612 50.6501 611.79 50.6301 611.75 50.6501C611.72 50.6601 611.69 50.6501 611.72 50.6601C611.85 50.7101 611.99 50.6901 612 50.6601V50.6501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.88 51.1401C611.77 51.1401 611.66 51.1201 611.55 51.0801C611.34 51.0001 611.22 50.79 611.25 50.57C611.29 50.37 611.45 50.2201 611.66 50.2001C611.86 50.1401 612.08 50.1701 612.26 50.2801C612.38 50.3801 612.45 50.53 612.44 50.69C612.42 50.84 612.34 50.97 612.22 51.05C612.12 51.11 612 51.1401 611.89 51.1401H611.88ZM611.7 50.9001L611.65 50.94C611.65 50.94 611.68 50.98 611.7 50.99V50.8901V50.9001ZM611.7 50.63L611.85 50.25C611.79 50.25 611.73 50.28 611.69 50.32V50.63H611.7ZM611.54 50.61L611.69 50.63L611.63 50.4001C611.58 50.4601 611.55 50.54 611.54 50.62V50.61Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.43 53.16C612.43 53.16 612.4 53.0501 612.4 53.0701C612.4 53.1501 612.4 53.23 612.42 53.31C612.46 53.24 612.49 53.1601 612.51 53.0801C612.51 53.0601 612.45 53.18 612.43 53.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.42 53.7601H612.39C612.27 53.7601 612.16 53.6901 612.08 53.6001C611.96 53.4401 611.91 53.2401 611.95 53.0501C611.96 52.8201 612.15 52.6301 612.39 52.6201C612.43 52.6201 612.47 52.6201 612.51 52.6401C612.56 52.6401 612.61 52.6401 612.65 52.6601C612.85 52.7301 612.97 52.9201 612.95 53.1201C612.92 53.3101 612.84 53.5001 612.71 53.6501C612.63 53.7201 612.52 53.7601 612.41 53.7601H612.42Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M601.03 30.57C601.03 30.57 601.25 30.69 601.29 30.68C601.32 30.67 601.29 30.63 601.26 30.62C601.14 30.57 601.04 30.53 601.04 30.57H601.03Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M601.28 31.1301C601.09 31.1201 600.92 31.0501 600.77 30.9401C600.64 30.8401 600.58 30.6801 600.59 30.5201C600.61 30.3801 600.69 30.2501 600.81 30.1701C601.01 30.0801 601.24 30.0901 601.43 30.2001C601.62 30.2801 601.75 30.4601 601.75 30.6701C601.75 30.7901 601.7 30.9101 601.61 30.9901C601.52 31.0801 601.4 31.1201 601.28 31.1201V31.1301ZM601.02 31.0001C601.11 31.0001 601.21 30.9801 601.28 30.9301L601.03 30.5601L601.21 30.5801L601.13 30.2501C601 30.3001 600.9 30.4101 600.86 30.5401L601.02 30.5601L600.86 30.5401C600.86 30.5401 600.85 30.6102 600.84 30.6502C600.84 30.7902 600.9 30.9201 601.01 30.9901L601.02 31.0001ZM601.24 30.5801L601.47 30.6101C601.49 30.4501 601.42 30.3002 601.29 30.2102L601.24 30.5801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.64 30.6902C608.64 30.6902 608.6 30.7202 608.62 30.7502C608.63 30.7802 608.59 30.7302 608.62 30.7102C608.66 30.6802 608.68 30.7002 608.65 30.6902H608.64Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.62 31.2101C608.47 31.2101 608.33 31.1401 608.24 31.0101C608.17 30.8901 608.14 30.7501 608.18 30.6101C608.19 30.5401 608.22 30.4701 608.26 30.4201C608.36 30.2901 608.52 30.2301 608.69 30.2401C608.77 30.2401 608.84 30.2701 608.91 30.3201C609.08 30.4401 609.15 30.6501 609.08 30.8501C609.07 30.8801 609.05 30.9101 609.03 30.9401C608.96 31.1001 608.8 31.2101 608.62 31.2101ZM608.6 30.7701L608.4 31.0601L608.6 30.7701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M605.33 28.7501C605.33 28.7501 605.52 28.5101 605.5 28.5101C605.42 28.5801 605.35 28.6601 605.28 28.7501C605.34 28.7801 605.41 28.8001 605.48 28.8001C605.5 28.8001 605.31 28.7701 605.33 28.7501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M605.48 29.2501C605.48 29.2501 605.45 29.2501 605.44 29.2501C605.25 29.2501 605.08 29.1701 604.94 29.0501C604.86 28.9601 604.82 28.84 604.83 28.72C604.83 28.6 604.89 28.49 604.99 28.41L605.01 28.3901C605.18 28.2001 605.29 28.0601 605.53 28.0701C605.7 28.0701 605.85 28.1901 605.92 28.3401C605.97 28.4601 605.97 28.5901 605.92 28.7001C605.94 28.7501 605.95 28.8101 605.94 28.8701C605.91 29.0901 605.72 29.2501 605.49 29.2501H605.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.53 32.1602C607.53 32.1602 607.52 32.0602 607.53 32.1002C607.54 32.1302 607.66 31.9402 607.69 31.9602C607.72 31.9802 607.57 32.1702 607.53 32.1602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.53 32.6101C607.53 32.6101 607.5 32.6101 607.48 32.6101C607.25 32.5801 607.07 32.3901 607.06 32.1601C607.06 31.9801 607.15 31.8002 607.3 31.7102C607.37 31.6102 607.49 31.5402 607.61 31.5202C607.74 31.5002 607.86 31.5301 607.96 31.6101C608.12 31.7401 608.18 31.9701 608.1 32.1601C608.1 32.1601 607.9 32.6101 607.52 32.6101H607.53ZM607.27 31.8101C607.22 31.9301 607.23 32.0701 607.3 32.1901L607.51 32.0902L607.27 31.8101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.94 33.8701C607.94 33.8701 608.16 33.8701 608.2 33.8501C608.23 33.8401 608.24 33.9601 608.2 33.9501C608.05 33.9001 607.94 33.8301 607.94 33.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.2 34.4001C608.2 34.4001 608.1 34.4001 608.06 34.3801C608.02 34.3701 607.99 34.3501 607.95 34.3401C607.85 34.3401 607.76 34.3001 607.68 34.2501C607.55 34.1601 607.48 34.0101 607.49 33.8501C607.5 33.7001 607.58 33.5601 607.71 33.4801C607.82 33.4101 607.95 33.3901 608.08 33.4301C608.26 33.3601 608.46 33.4301 608.58 33.5801C608.72 33.7601 608.73 34.0201 608.6 34.2101C608.51 34.3301 608.37 34.4101 608.21 34.4101L608.2 34.4001ZM607.78 33.8601C607.77 33.9601 607.8 34.0601 607.86 34.1401L607.94 34.0801L607.98 33.9201L607.94 33.8701H607.95L608.01 33.8001L607.85 33.6801C607.81 33.7301 607.79 33.7901 607.78 33.8501V33.8601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.24 24.8502C613.24 24.8502 613.49 24.9402 613.52 24.9202C613.55 24.9102 613.56 24.8502 613.52 24.8402C613.38 24.7902 613.23 24.8202 613.23 24.8502H613.24Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.5 25.3701C613.31 25.3701 613.13 25.3201 612.97 25.2201C612.85 25.1201 612.78 24.9701 612.79 24.8101C612.81 24.6601 612.89 24.5302 613.02 24.4602C613.23 24.3502 613.47 24.3401 613.68 24.4301C613.87 24.5101 613.99 24.6901 613.99 24.8901C613.99 25.1001 613.86 25.2901 613.67 25.3601C613.61 25.3801 613.56 25.3901 613.5 25.3901V25.3701ZM613.54 24.8801L613.37 25.2501C613.54 25.2101 613.66 25.0601 613.68 24.8901L613.54 24.8701V24.8801ZM613.54 24.8801H613.68C613.7 24.7401 613.63 24.5901 613.51 24.5001L613.48 24.8701H613.54V24.8801ZM613.36 24.5101C613.2 24.5701 613.09 24.7101 613.09 24.8801H613.43L613.23 24.8601L613.46 24.8801L613.36 24.5101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.94 25.5902C609.94 25.5902 609.87 25.5902 609.91 25.5702C609.94 25.5602 609.87 25.5701 609.87 25.5401C609.87 25.5201 609.94 25.5402 609.94 25.5902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.93 26.0501C609.78 26.0501 609.65 25.9801 609.55 25.8701C609.54 25.8701 609.53 25.8501 609.52 25.8401C609.44 25.7401 609.4 25.6 609.42 25.47C609.46 25.23 609.69 25.0601 609.93 25.0901C610.2 25.1201 610.39 25.3601 610.38 25.6201C610.35 25.8501 610.18 26.0301 609.95 26.0501H609.92H609.93ZM609.92 25.1501H609.9V25.2701L609.92 25.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.74 15.9901C610.74 15.9901 610.93 15.8301 610.91 15.8001C610.9 15.7701 610.91 15.9301 610.9 15.9601C610.86 16.0301 610.7 15.9901 610.74 16.0001V15.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.79 16.4501C610.71 16.4501 610.63 16.4401 610.56 16.4101C610.4 16.3401 610.29 16.1901 610.29 16.0101C610.29 15.8401 610.38 15.6701 610.54 15.6001C610.6 15.4801 610.7 15.3901 610.82 15.3601C611.04 15.3201 611.25 15.4401 611.33 15.6401C611.35 15.7001 611.36 15.7601 611.35 15.8201C611.37 15.9601 611.34 16.0901 611.27 16.2101C611.16 16.3701 610.98 16.4701 610.78 16.4601L610.79 16.4501ZM610.47 15.8901C610.47 15.8901 610.48 15.9401 610.49 15.9701L610.62 15.9201L610.47 15.9001V15.8901ZM610.78 15.5501C610.67 15.5501 610.58 15.6201 610.52 15.7101L610.75 15.8601L610.78 15.5501ZM610.78 15.5501L610.75 15.8601L610.8 15.8401L610.91 15.5801C610.91 15.5801 610.82 15.5501 610.78 15.5501ZM610.53 15.6001C610.53 15.6001 610.51 15.6101 610.51 15.6201C610.48 15.6801 610.47 15.7401 610.47 15.8101C610.47 15.7401 610.5 15.6701 610.54 15.6001H610.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.48 26.8601C603.48 26.8601 603.53 26.9501 603.54 26.9901C603.54 27.0201 603.42 27.0201 603.43 26.9901C603.47 26.9101 603.51 26.8601 603.48 26.8501V26.8601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.46 27.4602C603.33 27.4602 603.21 27.4201 603.11 27.3301C602.97 27.1901 602.93 26.9701 603.02 26.8001C603.02 26.7401 603.05 27.2901 603.09 27.2301C603.19 27.0801 603.37 27.0002 603.54 27.0302C603.69 27.0502 603.82 26.5401 603.89 26.6801C603.9 26.7101 603.91 26.7401 603.92 26.7601C603.94 26.7901 603.95 26.8301 603.96 26.8701C604.01 27.0701 603.93 27.2801 603.75 27.3901C603.66 27.4401 603.56 27.4701 603.45 27.4701L603.46 27.4602ZM603.46 27.1701C603.4 27.1701 603.34 27.1901 603.28 27.2201L603.44 26.8801L603.46 26.8601L603.63 26.7802L603.73 26.6801C603.73 26.6801 603.59 27.1701 603.46 27.1701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.69 42.8301C613.69 42.8301 613.7 42.9701 613.7 43.0001C613.7 43.0301 613.66 42.95 613.68 42.98C613.71 42.95 613.54 43.0201 613.55 43.0001C613.55 42.9701 613.72 42.8601 613.69 42.8301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.71 43.4602C613.71 43.4602 613.66 43.4602 613.63 43.4602C613.5 43.4802 613.36 43.4402 613.26 43.3602C613.16 43.2702 613.1 43.1402 613.1 43.0102C613.1 42.8602 613.18 42.7302 613.29 42.6402C613.31 42.6102 613.33 42.5802 613.35 42.5602C613.43 42.4602 613.56 42.4102 613.68 42.4102C613.81 42.4102 613.93 42.4702 614.02 42.5602C614.1 42.6502 614.14 42.7702 614.14 42.9002V42.9302C614.14 42.9302 614.14 43.0102 614.14 43.0202C614.14 43.2402 613.99 43.4302 613.77 43.4802C613.75 43.4802 613.72 43.4802 613.7 43.4802L613.71 43.4602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.32 43.3401C610.32 43.3401 610.43 43.2601 610.41 43.2201C610.4 43.1901 610.34 43.2201 610.32 43.2601C610.28 43.3101 610.28 43.3401 610.32 43.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.32 43.7902C610.32 43.7902 610.29 43.7902 610.28 43.7902C610.1 43.7702 609.95 43.6602 609.88 43.5002C609.81 43.3202 609.85 43.1101 609.98 42.9701C610.1 42.8201 610.28 42.7502 610.47 42.7702C610.63 42.8002 610.76 42.9002 610.83 43.0502C610.9 43.2202 610.87 43.4202 610.76 43.5602C610.66 43.7002 610.5 43.7902 610.33 43.7902H610.32ZM610.4 43.2802L610.33 43.6502C610.45 43.6702 610.57 43.6302 610.66 43.5502C610.75 43.4402 610.77 43.2902 610.71 43.1502L610.4 43.2802ZM610.32 42.8902C610.21 42.8902 610.1 42.9402 610.02 43.0302C609.95 43.1402 609.94 43.2802 609.99 43.4002L610.3 43.2702L610.36 42.9002C610.36 42.9002 610.33 42.9002 610.32 42.9002V42.8902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.53 42.8201C611.53 42.8201 611.68 42.94 611.65 42.92C611.63 42.94 611.78 42.7201 611.76 42.7401C611.79 42.7601 611.65 42.7401 611.69 42.7701C611.7 42.7501 611.52 42.8401 611.53 42.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.68 43.3801C611.68 43.3801 611.64 43.3801 611.62 43.3801C611.53 43.3801 611.44 43.3301 611.37 43.2701L611.35 43.2501C611.35 43.2501 611.33 43.2301 611.31 43.2201C611.15 43.1201 611.06 42.9301 611.09 42.7501C611.12 42.5601 611.27 42.4201 611.46 42.3801C611.49 42.3701 611.52 42.3601 611.55 42.3501C611.57 42.3501 611.59 42.3401 611.6 42.3301C611.76 42.2701 611.93 42.2901 612.06 42.4001C612.15 42.4701 612.21 42.5901 612.22 42.7101C612.22 42.7701 612.22 42.8301 612.2 42.8901C612.18 42.9401 612.16 42.9901 612.12 43.0301C612.11 43.0501 612.1 43.0701 612.08 43.0901L612.06 43.1201C612.06 43.1201 612.01 43.2101 611.98 43.2401C611.9 43.3301 611.79 43.3801 611.67 43.3801H611.68Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.46 46.3601C613.46 46.3601 613.43 46.1901 613.42 46.1501C613.41 46.1201 613.49 46.0901 613.48 46.1201C613.43 46.2401 613.42 46.3601 613.46 46.3601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.46 46.8101C613.46 46.8101 613.43 46.8101 613.41 46.8101C613.26 46.7901 613.14 46.7101 613.06 46.5801C613.01 46.4801 612.98 46.3801 612.99 46.2701C612.95 46.0801 613.02 45.8801 613.18 45.7601C613.35 45.6301 613.59 45.6301 613.76 45.7601C613.9 45.8701 613.96 46.0601 613.92 46.2401C613.95 46.3801 613.92 46.5301 613.83 46.6401C613.74 46.7501 613.61 46.8101 613.47 46.8201L613.46 46.8101ZM613.57 46.2601L613.7 46.4801C613.79 46.4101 613.86 46.3101 613.87 46.1901C613.85 46.1501 613.83 46.1101 613.81 46.0801L613.57 46.2601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.99 47.0001C587.99 47.0001 587.78 47.0002 587.78 47.0202C587.78 47.0402 587.98 46.8702 588 46.9002C588.02 46.8802 588.13 47.0801 588.14 47.0601C588.15 47.0401 588.01 47.0201 587.99 47.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.13 47.5101C588.06 47.5101 587.99 47.4901 587.93 47.4601H587.89C587.78 47.4901 587.65 47.4701 587.55 47.4101C587.4 47.3201 587.31 47.1501 587.33 46.9701C587.34 46.8101 587.44 46.6701 587.59 46.6101C587.65 46.5701 587.71 46.5401 587.77 46.5101C587.86 46.4501 587.97 46.4301 588.07 46.4501C588.09 46.4501 588.11 46.4501 588.12 46.4601C588.14 46.4601 588.16 46.4701 588.17 46.4801C588.29 46.5401 588.39 46.6401 588.46 46.7601C588.42 46.7101 588.37 46.6801 588.32 46.6601C588.49 46.7401 588.59 46.9201 588.58 47.1101C588.56 47.3001 588.42 47.4601 588.24 47.5001C588.2 47.5001 588.16 47.5101 588.13 47.5101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.46 44.8101C589.46 44.8101 589.36 44.58 589.34 44.55C589.31 44.58 589.44 44.7801 589.44 44.8101C589.44 44.8401 589.3 44.8101 589.33 44.8401C589.36 44.8201 589.45 44.8401 589.47 44.8101H589.46Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.31 45.2801H589.28C589.16 45.2801 589.04 45.2101 588.97 45.1201C588.86 44.9901 588.83 44.81 588.89 44.66C588.85 44.52 588.89 44.3701 588.98 44.2601C589.07 44.1501 589.21 44.0901 589.35 44.0901C589.47 44.0901 589.59 44.1501 589.67 44.2401C589.73 44.3201 589.78 44.4001 589.81 44.4901L589.84 44.5601C589.95 44.7401 589.92 44.9801 589.76 45.1201C589.67 45.2001 589.55 45.2501 589.43 45.2501C589.39 45.2501 589.35 45.2601 589.32 45.2601L589.31 45.2801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.58 34.2102C609.58 34.2102 609.65 34.2402 609.66 34.2702C609.67 34.3002 609.71 34.4602 609.73 34.4302C609.77 34.3702 609.61 34.2102 609.57 34.2102H609.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.73 34.8801C609.73 34.8801 609.68 34.8801 609.66 34.8801C609.48 34.8501 609.33 34.7101 609.28 34.5301C609.16 34.4101 609.11 34.2401 609.15 34.0801C609.22 33.8701 609.42 33.7401 609.64 33.7601C609.74 33.7701 609.83 33.8101 609.91 33.8801C609.96 33.9101 610.01 33.9601 610.04 34.0101C610.09 34.0601 610.12 34.1201 610.15 34.1901C610.23 34.3501 610.21 34.5501 610.11 34.7001C610.02 34.8201 609.89 34.8901 609.74 34.8901L609.73 34.8801ZM609.36 34.5901C609.41 34.6201 609.47 34.6401 609.54 34.6501L609.58 34.3101L609.38 34.16C609.29 34.28 609.28 34.4301 609.34 34.5601C609.34 34.5601 609.36 34.5801 609.37 34.5901H609.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.32 34.6901C607.32 34.6901 607.5 34.5401 607.48 34.5001C607.47 34.4601 607.5 34.6201 607.48 34.6601C607.43 34.7301 607.28 34.6902 607.32 34.7002V34.6901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.37 35.1502C607.29 35.1502 607.21 35.1402 607.14 35.1002C606.98 35.0302 606.88 34.8802 606.87 34.7102C606.87 34.5402 606.95 34.3802 607.11 34.3002C607.16 34.1802 607.26 34.1002 607.39 34.0602C607.53 34.0302 607.68 34.0601 607.79 34.1601C607.9 34.2601 607.96 34.4002 607.95 34.5402C607.96 34.6702 607.94 34.7902 607.87 34.9002C607.76 35.0602 607.58 35.1502 607.39 35.1402L607.37 35.1502ZM607.05 34.6102C607.05 34.6102 607.06 34.6502 607.07 34.6702L607.18 34.6202H607.05V34.6102ZM607.36 34.2402C607.25 34.2402 607.16 34.3102 607.1 34.4002L607.33 34.5502L607.36 34.2402ZM607.36 34.2402L607.33 34.5502L607.38 34.5302L607.5 34.2702C607.5 34.2702 607.41 34.2402 607.36 34.2402ZM607.09 34.3002H607.08C607.05 34.3802 607.03 34.4502 607.04 34.5202C607.04 34.4402 607.07 34.3702 607.1 34.3002H607.09Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.61 40.8001C609.61 40.8001 609.66 40.7701 609.62 40.7901C609.58 40.8001 609.48 40.7901 609.48 40.8301C609.48 40.8501 609.61 40.8501 609.61 40.8101V40.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.53 41.2901C609.53 41.2901 609.49 41.2901 609.47 41.2901C609.23 41.2701 609.04 41.0601 609.04 40.8201C609.04 40.5801 609.23 40.3701 609.48 40.3601C609.52 40.3401 609.56 40.3301 609.61 40.3301C609.79 40.3201 609.96 40.4101 610.05 40.5701C610.13 40.7301 610.11 40.9301 609.99 41.0701C609.89 41.2101 609.72 41.3001 609.54 41.2901H609.53ZM609.19 40.7701C609.19 40.7701 609.19 40.8401 609.2 40.8801L609.48 40.8001L609.19 40.7701ZM609.19 40.7701L609.49 40.8001L609.52 40.5801L609.47 40.4101C609.4 40.4301 609.34 40.4601 609.29 40.5101C609.23 40.5801 609.2 40.6801 609.19 40.7701ZM609.19 40.6501C609.19 40.6501 609.17 40.7301 609.16 40.7601C609.16 40.7201 609.17 40.6801 609.19 40.6501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.86 39.1301C609.86 39.1301 609.96 39.2301 609.95 39.2001C609.94 39.1701 609.8 39.2701 609.78 39.2501C609.75 39.2001 609.83 39.1301 609.86 39.1401V39.1301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.78 39.6901C609.62 39.6901 609.47 39.6101 609.39 39.4701C609.29 39.3101 609.3 39.1001 609.4 38.9401C609.51 38.7701 609.7 38.6701 609.89 38.6801C610.01 38.6901 610.12 38.7502 610.2 38.8302C610.26 38.8802 610.31 38.9401 610.34 39.0101C610.43 39.2101 610.36 39.4501 610.17 39.5701C610.11 39.6101 610.05 39.6301 609.99 39.6301C609.92 39.6601 609.84 39.6801 609.75 39.6801L609.78 39.6901ZM609.95 39.2001L610.05 39.5302C610.05 39.5302 610.13 39.4701 610.16 39.4201C610.24 39.3001 610.24 39.1401 610.16 39.0101L610.04 39.0802L609.94 39.1801L609.95 39.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M516.51 37.7501C516.42 37.6801 516.28 37.8801 516.21 37.9001C516.08 37.9301 515.7 37.7201 515.63 37.8401C515.59 37.9101 515.8 38.2401 515.89 38.3101C516.04 38.4301 516.19 38.5501 516.36 38.6501C516.77 38.8901 516.58 38.81 516.52 38.91C516.44 39.04 516.06 38.9901 515.96 39.1201C515.85 39.2601 515.75 39.4101 515.68 39.5801C515.67 39.7701 515.73 39.96 515.85 40.11C515.99 40.33 516.21 40.54 516.16 40.6C516.09 40.7 515.74 40.6901 515.59 40.7001C515.37 40.7201 515.22 40.3001 515 40.2501C514.97 40.2401 514.77 40.3101 514.79 40.2801C514.82 40.2601 514.91 40.39 514.94 40.41C515.1 40.61 515.15 40.9801 515.35 41.1201C515.56 41.2701 515.82 41.2801 515.88 41.4401C515.93 41.5801 515.82 41.64 515.52 41.85C515.45 42 515.41 42.1501 515.41 42.3101C515.73 42.5701 515.79 42.4701 515.68 42.5701C515.55 42.6901 515.27 42.7901 515.18 42.9301C515.16 42.9601 515.16 43.0001 515.12 43.0101C515.09 42.9801 514.98 42.89 515.01 42.86C515.04 42.83 515.14 42.9301 515.17 42.9601C515.28 43.0501 515.49 43.4101 515.54 43.3901C515.94 43.1801 516.06 43.05 516.1 43.16C516.16 43.3 515.84 43.6001 515.82 43.8101C515.8 43.9901 516.1 44.19 516.09 44.36C516.07 44.54 516.07 44.7101 516.06 44.8901C516.04 45.0601 515.77 45.2201 515.75 45.3901C515.74 45.5701 515.67 45.74 515.65 45.91C515.64 46.06 515.81 46.26 515.89 46.35C516.04 46.52 516.28 46.6501 516.33 46.8101C516.39 47.0101 516.13 47.2201 516.07 47.4001C516.04 47.5901 515.98 47.7701 515.9 47.9401C515.8 48.1001 515.83 48.3501 515.72 48.5101C515.45 48.9301 514.87 47.8101 514.99 48.2101C515.07 48.4801 515.25 48.6501 515.2 48.8301C515.15 49.0301 515.17 49.3301 515.02 49.5301C514.96 49.6001 514.77 49.62 514.76 49.73C514.76 49.73 514.92 49.8901 514.9 49.9001C514.75 49.9701 514.44 49.8001 514.29 49.8701C514.38 49.9801 514.54 50.1501 514.63 50.2601C514.65 50.2801 514.69 50.41 514.73 50.42C514.87 50.45 515.06 50.3801 515.22 50.4001C515.4 50.4201 515.51 50.4301 515.6 50.5301C515.67 50.6101 515.68 50.7101 515.63 50.9001C515.59 51.0501 515.73 51.28 515.71 51.42C515.69 51.46 515.48 51.46 515.45 51.42C515.42 51.39 515.52 51.27 515.54 51.3C515.56 51.46 515.54 51.6201 515.51 51.7801C515.48 51.9201 515.22 52.0001 515.19 52.1401C515.14 52.3301 515.54 52.33 515.7 52.35C515.8 52.35 515.88 52.4101 515.93 52.4901C515.98 52.5701 515.97 52.6801 515.91 52.7601C515.82 52.9401 515.23 53.0701 515.63 53.3901C515.75 53.5301 515.8 53.7201 515.76 53.9001C515.7 54.1201 515.36 54.26 515.29 54.47C515.22 54.69 515.37 54.9901 515.29 55.2001C515.25 55.3201 515.17 55.42 515.06 55.48C514.95 55.54 514.82 55.5501 514.7 55.5101C514.48 55.4501 514.26 55.4201 514.03 55.4301C513.84 55.4501 513.67 55.34 513.52 55.36C513.34 55.38 513.23 55.54 513.08 55.6C512.94 55.65 512.75 55.6001 512.6 55.7101C512.4 55.8501 512.19 56.1601 512.05 55.6501C512.01 55.4901 511.86 55.93 511.75 55.79C511.67 55.97 511.73 55.6501 511.67 55.8401C511.64 55.9401 511.51 56.0201 511.48 56.1201C511.46 56.1801 511.41 56.3701 511.34 56.4001C511.31 56.4001 511.13 56.1601 511.14 56.1401C511.28 55.8201 511.17 55.8301 510.99 55.8101C510.81 55.7901 510.59 55.7501 510.55 55.5301C510.49 55.3101 510.37 55.12 510.2 54.97C510.04 54.82 509.85 54.7101 509.65 54.6401C509.33 54.4901 509.55 54.21 509.73 54.04C509.96 53.87 510.18 53.68 510.38 53.47C510.43 53.4 510.69 53.2601 510.72 53.1301C510.74 53.0301 510.59 53.0001 510.3 52.9401C510.25 52.9301 510.36 52.8401 510.37 52.8201C510.5 52.6501 510.27 52.3801 510.25 52.2401C510.23 52.0801 510.06 52.0201 509.98 51.8701C509.9 51.7201 510.09 51.4801 510.08 51.3201C510.04 50.8901 510.16 50.7001 510.41 50.6301C510.44 50.7301 510.34 51.06 510.37 51.16C510.37 51.13 510.69 50.93 510.69 50.92C510.65 50.86 510.52 50.8401 510.48 50.7801C510.37 50.6201 510.26 50.4501 510.17 50.2701C510.15 50.1901 510.16 50.15 510.29 49.73C510.35 49.5 510.36 49.2601 510.33 49.0201C510.31 48.8101 510.05 48.61 510.13 48.55C510.38 48.35 510.32 48.19 510.05 47.98C509.94 47.89 510.07 47.6301 510.1 47.4501C510.13 47.2501 510.02 47.0501 510.04 46.8901C510.07 46.6801 510.19 46.51 510.19 46.35C510.2 46.16 510.19 45.98 510.17 45.79C510.14 45.64 509.92 45.51 509.86 45.3C509.8 45.07 509.8 44.83 509.86 44.6C509.92 44.43 510.28 44.3501 510.32 44.1901C510.38 44.0001 510.4 43.8 510.4 43.6C510.38 43.43 510 43.4001 509.87 43.2501C509.77 43.1401 509.73 42.9801 509.55 42.8801C509.19 42.6801 509.75 42.67 509.9 42.54C510.06 42.4 510 42.0501 510.13 41.8801C510.02 41.7901 509.92 41.67 509.86 41.55C509.79 41.44 509.84 41.4801 509.61 41.5701C509.59 41.5701 509.22 41.0701 509.26 41.0101C509.35 40.8501 509.67 40.8301 509.77 40.6801C509.87 40.5301 509.85 40.3001 509.95 40.1501C510.04 40.2001 510.16 40.1401 510.25 40.1801C510.25 40.1801 510.3 40.0901 510.33 40.0701C510.21 40.0501 510.1 40.1401 509.98 40.1201C509.99 39.9601 509.96 39.83 509.97 39.67C509.98 39.51 510.06 39.33 510.07 39.17C510.07 39.15 509.99 39.31 510.01 39.3C510.15 39.21 510.2 39.0201 510.34 38.9301C510.23 38.7801 510.31 38.5901 510.25 38.4301C510.21 38.2701 510.18 38.1001 510.18 37.9401C510.15 37.7701 510 37.6201 510 37.4401C510 37.2601 510.06 37.09 510.07 36.92C510.07 36.74 509.93 36.5801 509.93 36.4001C509.93 36.3801 510.11 36.38 510.1 36.36C510.1 36.27 509.98 36.2201 509.98 36.1301C509.98 36.1201 509.95 36.1501 509.96 36.1301C509.99 35.8701 509.87 35.3001 510.01 35.2101C510.22 35.0701 510.48 35.1201 510.54 34.9901C510.65 34.8101 510.68 34.5901 510.62 34.3801C510.54 34.2001 510.45 34.02 510.35 33.85C510.25 33.67 510.08 33.5501 510.09 33.3701C510.09 33.3501 509.86 33.45 509.75 33.42C509.69 33.41 509.62 33.39 509.56 33.36C509.51 33.16 510.04 32.93 510.12 32.72C510.19 32.54 509.98 32.4001 509.6 32.2601C509.65 32.1301 509.6 31.73 509.7 31.66C509.84 31.55 510.03 31.5101 510.15 31.4001C510.29 31.2801 510.27 31.2301 510.29 31.0601C510.3 30.9301 510.6 30.7201 510.49 30.5201C510.44 30.4301 510.67 30.2101 510.83 30.0101C511.09 29.7001 511.3 29.5201 511.29 29.3801C511.28 29.2401 510.96 29.1801 510.67 28.9001C510.53 28.7901 510.41 28.6601 510.3 28.5201C510.26 28.4401 510.35 28.3401 510.73 28.2601C511.19 28.1601 511.05 28.06 510.84 27.79C510.73 27.65 510.85 27.17 511.23 27.23C511.44 27.26 511.65 27.6701 511.88 27.6501C512.1 27.6201 512.28 27.3401 512.49 27.2701C512.69 27.1701 512.88 27.05 513.06 26.91C513.17 26.92 513.31 27.0401 513.42 27.0301C513.51 27.0201 513.59 26.9901 513.68 26.9501C513.6 26.9101 513.44 26.8101 513.37 26.8301C513.28 26.8501 513.14 27.0201 513.05 27.0801C513.02 26.8301 513.04 26.5801 513.1 26.3401C513.15 26.1901 513.35 26.12 513.43 25.97C513.51 25.83 513.6 25.6901 513.69 25.5601C513.69 25.5601 513.6 25.7201 513.67 25.7801C513.83 25.9301 514.23 25.81 514.39 25.98C514.41 25.99 514.31 25.9401 514.29 25.9401C514.11 25.9901 514.1 26.2001 513.93 26.2501C514.11 26.2801 514.14 26.5 514.31 26.54C514.33 26.54 514.26 26.3201 514.28 26.3101C514.37 26.3101 514.51 26.22 514.6 26.22C514.61 26.22 514.6 26.4701 514.6 26.4601C514.78 26.3501 514.87 25.97 515.02 25.98C515.23 26.06 515.39 26.2301 515.46 26.4501C515.56 26.6301 515.65 26.8201 515.73 27.0101C515.78 27.2001 515.5 27.48 515.54 27.67C515.58 27.86 515.88 28.0101 515.91 28.2101C515.95 28.4101 515.8 28.6301 515.85 28.8301C515.88 29.0601 515.93 29.2801 515.98 29.5001C516.05 29.7101 516.39 29.8701 516.42 30.0901C516.44 30.2601 516.14 30.4601 516.12 30.6401C516.1 30.8201 516.37 31.1001 516.3 31.2601C516.15 31.6301 516.1 31.9801 516.35 31.9901L516.51 37.7501ZM516.67 37.0601C516.39 37.3201 516.79 37.42 517.15 37.36L516.67 37.0601ZM513.58 48.6C513.58 48.6 513.9 48.7 513.87 48.73C513.84 48.76 513.8 48.4001 513.77 48.3801C513.75 48.3601 513.66 48.5301 513.64 48.5101C513.67 48.5201 513.56 48.59 513.58 48.6ZM511.83 31.05C511.83 31.05 512.12 30.9301 512.14 30.9501C512.16 30.9701 512.18 30.97 512.2 30.98C512.16 30.95 511.98 30.9901 511.94 30.9601C511.92 30.9401 511.98 31.06 511.97 31.04C512 31.05 511.81 31.04 511.84 31.04L511.83 31.05ZM515.94 34.8901C515.94 34.8901 515.67 35.0401 515.66 35.0201C515.66 35.0001 515.65 35.0101 515.63 35.0001C515.67 35.0301 515.83 34.9701 515.87 35.0001C515.92 35.1001 515.87 35.2701 515.93 35.3701C516.06 35.5701 516.28 35.4801 516.42 35.6801L515.94 34.8901ZM516.93 36.6C516.9 36.44 516.76 36.5301 516.75 36.5301C516.58 36.5301 516.21 36.1101 516.12 36.2001C515.93 36.3901 515.93 36.7701 515.79 37.0101C515.85 37.0901 515.91 37.16 515.98 37.22C516.13 37.13 516.1 36.7301 516.25 36.6401C516.41 36.5401 516.79 36.68 516.93 36.6ZM514.33 53.79C514.26 53.94 514.41 54.3001 514.33 54.4501C514.26 54.6001 513.82 54.57 513.75 54.72C513.74 54.75 514.02 54.9401 514.06 55.0001C514.16 54.8501 514.36 54.7501 514.46 54.5901C514.56 54.4401 514.33 54.1601 514.43 54.0001C514.38 53.9701 514.49 53.8701 514.33 53.7801V53.79ZM511.5 28.1901C511.45 28.3201 511.48 28.4701 511.57 28.5801C511.68 28.7001 511.67 29.1101 511.8 29.2101C511.84 29.0401 511.85 28.8701 511.85 28.7001C511.75 28.5201 511.63 28.3501 511.5 28.1901ZM513.95 48.5201C514.09 48.6101 514.26 48.6301 514.41 48.5901C514.54 48.5901 514.84 48.8501 514.97 48.8201C514.91 48.7401 514.7 48.4701 514.63 48.4601C514.4 48.4601 514.17 48.4701 513.95 48.5201ZM511.91 54.6801C511.85 54.7501 512.02 54.8401 511.99 54.8801C512.05 54.9201 511.88 55.2401 511.95 55.2501C512 55.2501 512.13 55.01 512.19 54.98C512.11 54.92 511.99 54.74 511.92 54.67L511.91 54.6801ZM512.47 53.55C512.54 53.47 512.45 53.1301 512.52 53.0201C512.53 53.0001 512.58 52.85 512.55 52.79C512.41 52.89 512.29 53.1701 512.16 53.2701C512.23 53.3001 512.34 53.48 512.47 53.55ZM514.41 53.3801C514.34 53.3601 514.2 53.5701 514.14 53.5801C514.08 53.5901 513.81 53.5401 513.76 53.5801C513.9 53.6101 514.05 53.6301 514.19 53.6401C514.28 53.5601 514.35 53.4701 514.41 53.3701V53.3801ZM517.12 33.16C517.08 33.27 517.28 33.51 517.27 33.6C517.27 33.65 517.2 33.8801 517.23 33.9301L517.12 33.16ZM515.04 47.4901C514.98 47.4601 514.79 47.61 514.73 47.61C514.67 47.61 514.42 47.4601 514.37 47.5001C514.49 47.5601 514.61 47.6001 514.74 47.6301C514.85 47.6001 514.95 47.5501 515.04 47.4901ZM512.27 48.29C512.2 48.37 512.35 48.6601 512.27 48.7401C512.3 48.7601 512.23 48.9101 512.24 48.9001C512.33 48.8601 512.36 48.6501 512.44 48.5901C512.4 48.5501 512.31 48.3501 512.26 48.2801L512.27 48.29ZM512.99 54.4501C512.9 54.4301 512.78 54.6001 512.73 54.6201C512.68 54.6401 512.36 54.48 512.35 54.54C512.35 54.57 512.62 54.69 512.66 54.73C512.73 54.66 512.91 54.5301 512.99 54.4501ZM512.24 39.29C512.3 39.27 512.19 39.0301 512.25 39.0101C512.22 38.9701 512.4 38.7801 512.37 38.7801C512.31 38.7801 512.19 38.9901 512.13 39.0201C512.16 39.0601 512.21 39.25 512.24 39.3V39.29ZM510.4 48.5301C510.4 48.5301 510.62 48.4801 510.64 48.4901C510.67 48.5101 510.76 48.8 510.79 48.8C510.79 48.76 510.64 48.58 510.63 48.54C510.6 48.55 510.43 48.52 510.4 48.54V48.5301ZM513.85 52.3901C513.85 52.3901 514.01 52.6101 513.98 52.6301C514 52.6501 513.9 52.8201 513.91 52.8101C513.95 52.7901 513.95 52.5901 514 52.5701C513.97 52.5601 513.89 52.4001 513.86 52.3901H513.85ZM512.94 30.7101C512.94 30.7101 513.11 30.4601 513.14 30.4601C513.15 30.4601 513.34 30.5301 513.35 30.5001C513.26 30.5001 513.17 30.5101 513.08 30.5301C513.02 30.5801 512.98 30.6501 512.93 30.7101H512.94ZM512.35 55.6501C512.35 55.6501 512.47 55.7301 512.49 55.7701C512.51 55.8101 512.53 55.9901 512.55 55.9501C512.6 55.8501 512.4 55.6601 512.35 55.6501ZM514.79 32.0701C514.79 32.0701 514.6 32.2201 514.58 32.2001C514.56 32.2201 514.34 32.0001 514.34 32.0301C514.41 32.0801 514.5 32.13 514.58 32.16C514.65 32.14 514.72 32.1101 514.78 32.0801L514.79 32.0701ZM511.71 48.0001C511.71 48.0001 511.85 48.0901 511.86 48.1201C511.86 48.1501 511.87 48.3001 511.88 48.2801C511.93 48.1901 511.74 48.0001 511.71 48.0001ZM510.73 46.7001C510.73 46.7001 510.6 46.6101 510.59 46.5701C510.58 46.5401 510.57 46.3701 510.55 46.4001C510.5 46.4901 510.69 46.6901 510.73 46.7001ZM512.65 46.5901C512.65 46.5901 512.78 46.68 512.79 46.72C512.8 46.75 512.81 46.9201 512.83 46.8901C512.88 46.7901 512.69 46.6001 512.65 46.5901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M511.39 56.8401C511.24 56.8401 511.1 56.7801 510.99 56.6701C510.86 56.5501 510.76 56.3901 510.71 56.2101C510.41 56.1501 510.18 55.9101 510.12 55.6101C510.08 55.5001 510.02 55.4001 509.93 55.3301L509.88 55.2701C509.79 55.2001 509.69 55.1401 509.59 55.1001L509.47 55.0501C509.25 54.9601 509.09 54.7601 509.06 54.5301C509.04 54.2101 509.19 53.9001 509.45 53.7101C509.54 53.6301 509.63 53.5601 509.72 53.4901C509.82 53.4201 509.91 53.3401 510 53.2501C509.94 53.2001 509.9 53.1301 509.88 53.0501C509.84 52.9101 509.88 52.7601 509.96 52.6401L509.94 52.6001C509.9 52.5201 509.87 52.4401 509.84 52.3601L509.81 52.3401C509.73 52.2601 509.66 52.1801 509.61 52.0801C509.51 51.8601 509.51 51.6001 509.62 51.3901C509.63 51.3601 509.64 51.3301 509.65 51.3001C509.61 51.0301 509.66 50.7601 509.81 50.5301C509.79 50.4901 509.77 50.4401 509.75 50.3901C509.69 50.1701 509.72 50.0601 509.87 49.5901C509.91 49.4201 509.92 49.2401 509.89 49.0701C509.89 49.0701 509.85 49.0201 509.83 48.9901C509.61 48.6601 509.66 48.4401 509.75 48.3001C509.55 48.0701 509.51 47.7501 509.63 47.4801C509.64 47.4401 509.65 47.4001 509.66 47.3601C509.66 47.3101 509.65 47.2601 509.64 47.2101C509.6 47.0801 509.59 46.9501 509.61 46.8201C509.63 46.6901 509.67 46.5601 509.72 46.4401C509.74 46.4001 509.75 46.3701 509.76 46.3301V46.2401C509.76 46.1301 509.76 46.0201 509.76 45.9201C509.75 45.9001 509.73 45.8901 509.72 45.8701C509.6 45.7401 509.51 45.5901 509.45 45.4201C509.37 45.1101 509.37 44.7801 509.46 44.4701C509.54 44.2701 509.7 44.1101 509.89 44.0201L509.93 43.9901C509.95 43.9201 509.96 43.8601 509.96 43.8201C509.8 43.7701 509.66 43.6701 509.54 43.5501C509.5 43.5001 509.46 43.4401 509.42 43.3901C509.37 43.3201 509.36 43.3001 509.34 43.2901C509.11 43.2001 508.97 42.9701 508.99 42.7301C509.03 42.3801 509.36 42.2901 509.53 42.2301H509.58V42.1401C509.58 42.1401 509.6 42.0701 509.61 42.0301C509.48 42.0301 509.35 41.9601 509.26 41.8701C509.04 41.6201 508.69 41.1601 508.87 40.8201C508.98 40.6401 509.15 40.5001 509.36 40.4401C509.38 40.4401 509.4 40.4201 509.42 40.4201C509.42 40.4001 509.43 40.3701 509.44 40.3401C509.46 40.2201 509.5 40.1101 509.55 40.0001V39.9501C509.54 39.8601 509.54 39.7601 509.55 39.6601C509.55 39.5801 509.57 39.4901 509.59 39.4101C509.57 39.2801 509.59 39.1501 509.66 39.0401C509.71 38.9501 509.77 38.8801 509.85 38.8301C509.85 38.7801 509.85 38.7201 509.85 38.6701C509.85 38.6501 509.85 38.6201 509.85 38.6001C509.8 38.4601 509.77 38.3101 509.77 38.1701C509.77 38.1301 509.77 38.0801 509.76 38.0401C509.75 38.0101 509.73 37.9801 509.72 37.9601C509.63 37.8101 509.58 37.6501 509.57 37.4801C509.57 37.3601 509.59 37.2301 509.61 37.1101C509.62 37.0501 509.63 36.9901 509.64 36.9301C509.63 36.9101 509.62 36.8901 509.61 36.8601C509.54 36.7201 509.51 36.5701 509.51 36.4201C509.51 36.3601 509.52 36.3101 509.54 36.2601C509.53 36.2001 509.53 36.1301 509.54 36.0701C509.54 36.0501 509.53 35.9401 509.52 35.8301C509.49 35.4601 509.47 35.0701 509.78 34.8701C509.91 34.7901 510.05 34.7301 510.21 34.7101C510.22 34.6701 510.23 34.6301 510.23 34.5901C510.16 34.4301 510.08 34.2801 509.99 34.1301C509.96 34.0901 509.94 34.0401 509.9 34.0101C509.88 33.9801 509.86 33.9601 509.84 33.9301C509.79 33.9301 509.74 33.9301 509.69 33.9201C509.45 33.9101 509.24 33.7501 509.15 33.5301C509.1 33.2201 509.25 32.9101 509.52 32.7601L509.47 32.7401C509.36 32.7001 509.26 32.6101 509.21 32.5001C509.16 32.3901 509.16 32.2601 509.21 32.1501C509.21 32.1101 509.21 32.0801 509.21 32.0401C509.18 31.7901 509.27 31.5401 509.45 31.3601C509.55 31.2901 509.65 31.2301 509.76 31.1801C509.8 31.1601 509.84 31.1401 509.87 31.1301V31.0601C509.9 30.9201 509.96 30.7801 510.06 30.6701L510.08 30.6501C510.02 30.3601 510.24 30.1001 510.43 29.8801L510.52 29.7701C510.59 29.6901 510.66 29.6101 510.72 29.5501V29.5301C510.61 29.4601 510.5 29.3701 510.4 29.2801L510.33 29.2201C510.17 29.1001 510.04 28.9501 509.93 28.7701C509.85 28.6201 509.85 28.4501 509.93 28.3001C510.04 28.1101 510.21 27.9801 510.42 27.9301C510.35 27.6901 510.38 27.4301 510.52 27.2101C510.68 26.9201 511.01 26.7701 511.34 26.8301C511.55 26.8801 511.73 26.9901 511.87 27.1501C511.88 27.1601 511.9 27.1801 511.91 27.1901C511.93 27.1801 511.94 27.1601 511.96 27.1501C512.08 27.0301 512.22 26.9401 512.38 26.8801C512.47 26.8401 512.54 26.7901 512.62 26.7301C512.62 26.5701 512.65 26.4001 512.7 26.2401C512.76 26.0701 512.87 25.9301 513.02 25.8201C513.04 25.8001 513.06 25.7801 513.08 25.7601L513.33 25.3501C513.42 25.2001 513.6 25.1201 513.77 25.1401C513.95 25.1601 514.09 25.2901 514.14 25.4601C514.35 25.4601 514.55 25.5401 514.71 25.6801C514.82 25.6001 514.95 25.5601 515.09 25.5801C515.47 25.6701 515.78 25.9601 515.89 26.3301C515.92 26.3901 515.95 26.4601 515.99 26.5201C516.07 26.6501 516.14 26.7901 516.18 26.9401C516.22 27.1701 516.18 27.4001 516.05 27.6001L516.03 27.6401L516.06 27.6701C516.21 27.8001 516.32 27.9801 516.37 28.1801C516.39 28.3401 516.37 28.5101 516.33 28.6701C516.32 28.7101 516.31 28.7601 516.3 28.8001C516.32 28.8701 516.33 28.9701 516.35 29.0601C516.36 29.1801 516.39 29.2901 516.42 29.4001C516.42 29.4001 516.48 29.4601 516.52 29.4901C516.7 29.6401 516.83 29.8401 516.88 30.0801C516.89 30.3101 516.8 30.5401 516.64 30.7101L516.61 30.7401L516.63 30.7801C516.77 30.9901 516.8 31.2401 516.73 31.4801C516.68 31.5801 516.65 31.7001 516.64 31.8101C516.61 31.6901 516.51 31.6001 516.39 31.5901L516.35 32.4901C516.15 32.4901 515.96 32.3801 515.85 32.2101C515.7 31.9001 515.71 31.5501 515.86 31.2401C515.86 31.2201 515.84 31.2001 515.83 31.1801C515.73 31.0101 515.68 30.8201 515.69 30.6301C515.72 30.4501 515.8 30.2901 515.92 30.1601L515.9 30.1401C515.75 30.0201 515.64 29.8601 515.57 29.6801C515.52 29.5201 515.49 29.3601 515.46 29.1901C515.45 29.1101 515.44 29.0401 515.42 28.9601C515.39 28.7901 515.4 28.6101 515.45 28.4401C515.45 28.4101 515.47 28.3801 515.47 28.3501C515.45 28.3301 515.43 28.3101 515.41 28.2901C515.26 28.1601 515.15 27.9901 515.1 27.7901C515.07 27.5801 515.12 27.3601 515.23 27.1801C515.24 27.1501 515.26 27.1301 515.27 27.1001C515.25 27.0601 515.22 27.0001 515.19 26.9501C515.14 26.8601 515.09 26.7701 515.05 26.6801C514.99 26.7601 514.92 26.8201 514.83 26.8801C514.75 26.9301 514.65 26.9601 514.55 26.9401C514.47 26.9901 514.38 27.0201 514.28 27.0101C514.22 27.0001 514.16 26.9801 514.11 26.9601C514.11 27.1301 514.02 27.2901 513.87 27.3701C513.74 27.4301 513.6 27.4701 513.46 27.4801C513.41 27.4801 513.36 27.4801 513.31 27.4701C513.21 27.5301 513.1 27.5501 512.99 27.5301C512.89 27.6001 512.78 27.6501 512.66 27.6901C512.64 27.6901 512.58 27.7501 512.54 27.7901C512.39 27.9401 512.2 28.0401 511.99 28.0901C512.11 28.2301 512.21 28.3901 512.29 28.5601C512.34 28.7601 512.34 28.9701 512.29 29.1701C512.29 29.2101 512.28 29.2501 512.28 29.2701C512.27 29.4001 512.2 29.5201 512.09 29.5901C511.98 29.6701 511.85 29.6901 511.72 29.6601C511.63 29.8201 511.53 29.9601 511.4 30.0901C511.35 30.1501 511.29 30.2201 511.22 30.2901L511.12 30.4101C511.12 30.4101 511.05 30.4901 511.01 30.5401C511.01 30.7601 510.94 30.9801 510.79 31.1501L510.77 31.1701C510.77 31.4001 510.66 31.6101 510.48 31.7401C510.38 31.8201 510.27 31.8801 510.16 31.9301L510.12 31.9501V31.9701C510.31 32.0501 510.46 32.2001 510.56 32.3801C510.63 32.5301 510.64 32.7101 510.58 32.8701C510.55 32.9401 510.52 33.0001 510.47 33.0601C510.54 33.1401 510.58 33.2301 510.58 33.3401C510.59 33.3601 510.61 33.3801 510.63 33.4001C510.69 33.4701 510.74 33.5401 510.78 33.6201C510.89 33.8101 510.99 34.0001 511.07 34.1901C511.18 34.5201 511.15 34.8701 510.97 35.1701C510.86 35.3601 510.66 35.4901 510.43 35.5201H510.42C510.42 35.5901 510.42 35.6601 510.43 35.7101C510.43 35.8001 510.44 35.8801 510.44 35.9601C510.53 36.0601 510.58 36.2001 510.58 36.3401C510.58 36.4201 510.56 36.5001 510.51 36.5701C510.51 36.5701 510.5 36.5901 510.49 36.6001C510.53 36.7001 510.54 36.8101 510.54 36.9201C510.54 37.0201 510.52 37.1201 510.5 37.2201C510.48 37.2901 510.48 37.3501 510.47 37.4201C510.49 37.4401 510.5 37.4601 510.51 37.4801C510.58 37.6001 510.63 37.7201 510.65 37.8601C510.66 37.9301 510.67 38.0001 510.67 38.0701C510.67 38.1301 510.67 38.1901 510.7 38.2501C510.74 38.3701 510.76 38.5001 510.76 38.6301C510.76 38.6601 510.76 38.6801 510.76 38.7101C510.83 38.8001 510.85 38.9201 510.82 39.0301C510.79 39.1501 510.71 39.2401 510.61 39.3001C510.61 39.3201 510.59 39.3401 510.58 39.3501C510.56 39.3801 510.53 39.4201 510.5 39.4601L510.48 39.5301C510.48 39.5301 510.46 39.5901 510.45 39.6201C510.6 39.6501 510.72 39.7601 510.77 39.9101C510.82 40.0501 510.8 40.2201 510.7 40.3401C510.62 40.5001 510.47 40.6001 510.29 40.6201C510.26 40.7301 510.22 40.8301 510.16 40.9301C510.12 40.9801 510.08 41.0301 510.03 41.0701C510.13 41.1201 510.2 41.1901 510.26 41.2901C510.3 41.3701 510.35 41.4401 510.41 41.5001C510.51 41.5701 510.58 41.6801 510.6 41.8101C510.62 41.9301 510.59 42.0601 510.51 42.1601C510.51 42.2001 510.51 42.2301 510.5 42.2701C510.48 42.5001 510.38 42.7201 510.22 42.8801H510.2C510.2 42.8801 510.23 42.9401 510.24 42.9501C510.24 42.9501 510.29 42.9501 510.33 42.9701C510.51 43.0401 510.83 43.1801 510.87 43.5301C510.88 43.7801 510.85 44.0301 510.78 44.2701C510.71 44.4801 510.55 44.6601 510.35 44.7501C510.33 44.7601 510.31 44.7701 510.29 44.7801C510.28 44.9001 510.29 45.0301 510.31 45.1501C510.31 45.1601 510.36 45.2101 510.39 45.2401C510.51 45.3601 510.59 45.5101 510.63 45.6701C510.65 45.7701 510.66 45.8701 510.66 45.9701C510.84 46.0101 510.98 46.1701 511.01 46.3501C511.19 46.4901 511.23 46.7401 511.12 46.9401C511 47.1301 510.76 47.2101 510.55 47.1201C510.57 47.2401 510.58 47.3601 510.55 47.4901C510.54 47.5601 510.52 47.6301 510.5 47.7101V47.7301C510.59 47.8201 510.66 47.9301 510.71 48.0601C510.77 48.0601 510.83 48.0901 510.88 48.1201C511 48.2001 511.09 48.3301 511.13 48.4701L511.15 48.5101C511.19 48.5701 511.23 48.6401 511.24 48.7201C511.27 48.8501 511.24 48.9901 511.15 49.1001C511.07 49.2101 510.94 49.2701 510.8 49.2701C510.8 49.4601 510.78 49.6601 510.72 49.8401C510.67 49.9901 510.64 50.0801 510.62 50.1401C510.64 50.1701 510.67 50.2001 510.7 50.2501C510.76 50.3001 510.81 50.3601 510.84 50.4301C510.94 50.4801 511.03 50.5601 511.09 50.6501C511.3 51.0201 510.96 51.2501 510.8 51.3701C510.77 51.3901 510.73 51.4201 510.71 51.4401C510.65 51.5001 510.58 51.5401 510.5 51.5601C510.49 51.6001 510.47 51.6401 510.46 51.6801C510.59 51.8101 510.68 51.9701 510.72 52.1501C510.72 52.1401 510.73 52.1701 510.75 52.1901C510.82 52.3201 510.87 52.4601 510.89 52.6101C510.98 52.6601 511.06 52.7301 511.12 52.8201C511.19 52.9401 511.21 53.0801 511.18 53.2101C511.11 53.4201 510.97 53.5901 510.78 53.7101L510.72 53.7501C510.59 53.9101 510.43 54.0501 510.26 54.1701C510.2 54.2201 510.14 54.2601 510.08 54.3101C510.25 54.3901 510.41 54.5001 510.54 54.6401L510.59 54.6901C510.77 54.8601 510.91 55.0801 510.98 55.3201C511 55.3201 511.02 55.3201 511.04 55.3201C511.16 55.3201 511.28 55.3501 511.39 55.4101C511.42 55.3801 511.46 55.3601 511.49 55.3401C511.47 55.2201 511.49 55.1001 511.52 54.9801C511.4 54.7901 511.42 54.5501 511.57 54.3901C511.78 54.3901 511.99 54.3001 512.14 54.1501C512.29 54.0701 512.47 54.0701 512.63 54.1301C512.76 54.0201 512.94 53.9801 513.11 54.0201C513.29 54.0601 513.42 54.2101 513.44 54.3901C513.56 54.2701 513.71 54.2001 513.88 54.1601C513.88 54.1301 513.87 54.0901 513.87 54.0601C513.78 54.0601 513.69 54.0301 513.61 54.0001C513.47 53.9401 513.36 53.8201 513.33 53.6701C513.3 53.5201 513.35 53.3601 513.46 53.2601C513.51 53.2101 513.57 53.1801 513.63 53.1501C513.62 53.1401 513.61 53.1301 513.6 53.1201C513.49 53.0001 513.46 52.8301 513.51 52.6701C513.43 52.5601 513.41 52.4201 513.44 52.2901C513.47 52.1601 513.56 52.0601 513.67 51.9901C513.78 51.9301 513.92 51.9201 514.04 51.9701C514.16 52.0201 514.26 52.1101 514.32 52.2301C514.4 52.3101 514.45 52.4101 514.47 52.5201C514.47 52.5701 514.47 52.6301 514.46 52.6801C514.45 52.7601 514.42 52.8401 514.39 52.9201C514.46 52.9201 514.53 52.9201 514.59 52.9501C514.71 52.9901 514.81 53.0801 514.86 53.2101C514.91 53.3301 514.9 53.4701 514.85 53.5801C514.85 53.5901 514.83 53.6101 514.82 53.6301C514.87 53.7201 514.9 53.8201 514.9 53.9201C514.91 53.9901 514.91 54.0601 514.9 54.1301V54.1701C514.9 54.1701 514.93 54.2201 514.94 54.2501C515.02 54.0801 515.14 53.9301 515.29 53.8201C515.33 53.7901 515.37 53.7501 515.4 53.7101C515.39 53.7301 515.38 53.6901 515.37 53.6701C515.2 53.5401 515.1 53.3401 515.1 53.1201C515.1 52.9601 515.17 52.8101 515.29 52.7001C515.13 52.6701 515 52.5801 514.9 52.4501C514.81 52.3201 514.77 52.1501 514.81 51.9901C514.86 51.8201 514.96 51.6801 515.11 51.5801C515.05 51.4601 515.04 51.3201 515.08 51.1901C515.11 51.1001 515.16 51.0201 515.23 50.9601C515.23 50.9101 515.23 50.8601 515.23 50.8101C515.18 50.8101 515.13 50.8101 515.09 50.8101C514.96 50.8301 514.83 50.8401 514.69 50.8101C514.51 50.7701 514.36 50.6401 514.3 50.4601L514.22 50.3701C514.13 50.2701 514.04 50.1601 513.97 50.0801C513.89 49.9701 513.86 49.8301 513.89 49.7001C513.92 49.5701 514.01 49.4601 514.14 49.4001C514.34 49.4201 514.54 49.3301 514.66 49.1701C514.59 49.1401 514.53 49.1001 514.47 49.0701C514.44 49.0601 514.42 49.0401 514.4 49.0301C514.34 49.0301 514.28 49.0301 514.22 49.0301C514.1 49.1401 513.93 49.1901 513.77 49.1401C513.72 49.1201 513.67 49.1001 513.62 49.0701H513.6C513.48 49.0301 513.36 48.9701 513.27 48.8801C513.21 48.8201 513.18 48.7401 513.16 48.6501C513.15 48.5101 513.19 48.3801 513.27 48.2701C513.28 48.2501 513.3 48.2301 513.31 48.2001C513.33 48.1801 513.35 48.1501 513.38 48.1301C513.47 47.9901 513.62 47.9001 513.79 47.9001C513.89 47.9001 513.98 47.9301 514.06 47.9901C514.06 47.9901 514.09 48.0101 514.1 48.0201C514.25 48.0001 514.37 47.9901 514.48 47.9801C514.38 47.9401 514.28 47.9001 514.18 47.8501C514.04 47.7701 513.96 47.6201 513.96 47.4701C513.96 47.3101 514.04 47.1701 514.18 47.0801C514.36 46.9901 514.58 46.9901 514.76 47.0801C514.93 46.9701 515.14 46.9601 515.31 47.0501C515.43 47.1201 515.52 47.2501 515.53 47.3901C515.54 47.5301 515.49 47.6701 515.39 47.7701C515.42 47.8001 515.44 47.8201 515.46 47.8401C515.48 47.7601 515.52 47.6901 515.56 47.6201C515.59 47.5501 515.62 47.4801 515.63 47.4001C515.64 47.3301 515.66 47.2601 515.68 47.1901C515.72 47.0701 515.78 46.9501 515.86 46.8501L515.88 46.8301L515.84 46.8001C515.75 46.7301 515.67 46.6501 515.59 46.5601C515.38 46.3601 515.25 46.0801 515.24 45.7901C515.25 45.6801 515.27 45.5701 515.3 45.4601C515.32 45.4001 515.33 45.3301 515.34 45.2701C515.37 45.0701 515.46 44.8901 515.61 44.7501C515.63 44.7301 515.64 44.7201 515.66 44.7001C515.66 44.6401 515.66 44.5801 515.66 44.5201C515.66 44.4501 515.66 44.3901 515.67 44.3201C515.66 44.3001 515.64 44.2901 515.63 44.2701C515.5 44.1201 515.42 43.9301 515.41 43.7301C515.25 43.6501 515.12 43.5201 515.03 43.3701C514.98 43.3501 514.93 43.3301 514.88 43.2901C514.72 43.1801 514.61 43.0101 514.59 42.8201C514.59 42.6901 514.63 42.5501 514.73 42.4601C514.8 42.3901 514.9 42.3401 515 42.3301C514.99 42.2801 514.98 42.2401 514.98 42.1901C514.99 41.9401 515.07 41.6901 515.21 41.4801C515.18 41.4601 515.15 41.4401 515.12 41.4201C514.93 41.2701 514.78 41.0601 514.71 40.8201C514.68 40.7501 514.65 40.6801 514.61 40.6101L514.59 40.5901C514.51 40.5501 514.45 40.4901 514.41 40.4201C514.31 40.2401 514.35 40.0201 514.49 39.8801C514.57 39.8001 514.68 39.7601 514.79 39.7501C514.9 39.7101 515.02 39.7101 515.14 39.7401C515.18 39.7501 515.23 39.7701 515.27 39.7901C515.23 39.6501 515.23 39.5101 515.27 39.3701C515.34 39.1801 515.44 38.9901 515.57 38.8301L515.61 38.7701C515.61 38.7701 515.68 38.6801 515.73 38.6501L515.64 38.5801C515.64 38.5801 515.01 37.9901 515.27 37.5301C515.32 37.4301 515.41 37.3601 515.51 37.3101C515.37 37.1601 515.34 36.9501 515.43 36.7701C515.47 36.6901 515.5 36.6001 515.52 36.5101C515.57 36.2701 515.68 36.0401 515.84 35.8601L515.86 35.8401C515.75 35.7801 515.66 35.7001 515.59 35.5901C515.55 35.5301 515.53 35.4701 515.51 35.4101C515.48 35.3901 515.44 35.3701 515.41 35.3501C515.4 35.3501 515.39 35.3301 515.37 35.3201C515.23 35.2001 515.17 35.0101 515.23 34.8301C515.29 34.6501 515.45 34.5301 515.64 34.5301C515.78 34.4201 515.97 34.4001 516.14 34.4601C516.27 34.5101 516.37 34.6201 516.41 34.7601L516.3 34.7901C516.34 34.8901 516.37 34.9901 516.37 35.1001C516.55 35.1501 516.71 35.2601 516.82 35.4101L516.34 35.7501C516.48 35.8001 516.61 35.8801 516.73 35.9701C516.76 35.9901 516.8 36.0201 516.83 36.0401C516.93 36.0401 517.02 36.0401 517.11 36.0901C517.27 36.1701 517.38 36.3201 517.41 36.4901C517.45 36.6801 517.37 36.8701 517.2 36.9701C517.18 36.9801 517.16 36.9901 517.14 37.0001L517.27 37.7901C517.02 37.8401 516.75 37.8201 516.51 37.7201L516.32 37.9701C516.38 38.0201 516.44 38.0701 516.5 38.1101C516.56 38.1101 516.62 38.1001 516.67 38.0701C516.63 38.1001 516.6 38.1301 516.56 38.1501C516.58 38.1601 516.6 38.1701 516.61 38.1801C516.87 38.3301 517.1 38.4701 517.09 38.7701C517.07 38.9201 516.99 39.0601 516.86 39.1501C516.72 39.2801 516.54 39.3601 516.35 39.3701C516.33 39.3701 516.31 39.3701 516.29 39.3701C516.24 39.4401 516.19 39.5101 516.15 39.5901C516.16 39.5901 516.19 39.6601 516.26 39.7801C516.3 39.8501 516.36 39.9201 516.4 39.9801C516.54 40.1601 516.77 40.4601 516.56 40.7701C516.47 40.8901 516.35 40.9701 516.21 41.0101C516.26 41.0701 516.3 41.1301 516.33 41.2101C516.49 41.6301 516.19 41.8701 515.96 42.0401C516.09 42.1101 516.18 42.2401 516.21 42.3801C516.21 42.4501 516.21 42.5301 516.18 42.5901C516.2 42.5901 516.23 42.6001 516.25 42.6101C516.39 42.6601 516.5 42.7701 516.56 42.9001C516.63 43.1601 516.57 43.4301 516.4 43.6401C516.39 43.6601 516.37 43.6901 516.35 43.7201H516.36C516.5 43.8901 516.58 44.1001 516.58 44.3201C516.58 44.4001 516.57 44.4801 516.57 44.5601C516.57 44.6501 516.57 44.7501 516.55 44.8401C516.52 45.0401 516.43 45.2201 516.28 45.3501C516.26 45.3701 516.25 45.3901 516.23 45.4001C516.22 45.4901 516.2 45.5701 516.18 45.6601C516.17 45.7101 516.16 45.7601 516.15 45.8101C516.19 45.8701 516.23 45.9201 516.28 45.9701C516.33 46.0201 516.38 46.0701 516.43 46.1101C516.6 46.2301 516.73 46.4001 516.81 46.5901C516.87 46.8601 516.8 47.1401 516.62 47.3501C516.6 47.3801 516.57 47.4201 516.56 47.4501C516.56 47.4801 516.54 47.5301 516.53 47.5701C516.5 47.7501 516.44 47.9301 516.34 48.0901C516.34 48.1001 516.32 48.1701 516.32 48.2101C516.3 48.3701 516.25 48.5301 516.16 48.6701C516.06 48.8401 515.88 48.9501 515.68 48.9701V49.0201C515.66 49.2701 515.58 49.5101 515.44 49.7201L515.42 49.7501C515.42 49.7501 515.42 49.8401 515.42 49.8901C515.64 49.8901 515.85 49.9901 516 50.1501C516.17 50.3601 516.23 50.6301 516.15 50.8901C516.15 50.9201 516.17 50.9501 516.18 50.9801C516.23 51.1201 516.25 51.2601 516.23 51.4101C516.23 51.4501 516.21 51.4901 516.19 51.5301C516.16 51.6001 516.1 51.6601 516.04 51.7001C516.04 51.7301 516.03 51.7701 516.02 51.8001C516.02 51.8301 516.01 51.8501 516 51.8801C516.17 51.9401 516.31 52.0601 516.4 52.2201C516.51 52.4401 516.5 52.6901 516.38 52.9001C516.32 53.0001 516.24 53.0901 516.14 53.1601C516.29 53.4001 516.33 53.6901 516.27 53.9601C516.2 54.1601 516.07 54.3401 515.9 54.4701C515.86 54.5001 515.82 54.5401 515.78 54.5801C515.79 54.5801 515.8 54.6501 515.81 54.7101C515.85 54.9101 515.84 55.1201 515.77 55.3201C515.61 55.7701 515.13 56.0201 514.67 55.8901C514.5 55.8401 514.32 55.8201 514.15 55.8201C514 55.8301 513.84 55.8201 513.7 55.7701C513.68 55.7701 513.65 55.7601 513.63 55.7501C513.65 55.7501 513.61 55.7801 513.59 55.8001C513.5 55.8701 513.41 55.9201 513.31 55.9601C513.23 55.9901 513.14 56.0001 513.06 56.0101C513.06 56.0501 513.04 56.1001 513.02 56.1401C512.93 56.3101 512.74 56.4101 512.55 56.3901C512.48 56.3901 512.42 56.3601 512.36 56.3201C512.29 56.3201 512.22 56.3201 512.15 56.2901C512.09 56.2701 512.03 56.2401 511.98 56.2001H511.97C511.93 56.4501 511.77 56.6501 511.55 56.7501C511.51 56.7601 511.47 56.7701 511.43 56.7701L511.39 56.8401ZM513.32 54.8201C513.25 54.8801 513.19 54.9401 513.12 54.9901C513.08 55.0201 513.04 55.0501 513.01 55.0801C512.96 55.1301 512.91 55.1601 512.84 55.1801C512.86 55.1801 512.88 55.1801 512.9 55.1801C512.92 55.1801 512.95 55.1801 512.97 55.1801C512.98 55.1701 513 55.1501 513.02 55.1401C513.12 55.0601 513.24 55.0001 513.36 54.9501C513.34 54.9101 513.33 54.8701 513.32 54.8201ZM514.71 55.0501L514.79 55.0701C514.79 55.0701 514.85 55.0801 514.88 55.0801C514.88 55.0801 514.88 55.0601 514.9 55.0401C514.9 55.0401 514.89 54.9501 514.88 54.9001V54.8501L514.86 54.8801C514.82 54.9401 514.77 55.0001 514.72 55.0501H514.71ZM510.79 46.5601L510.97 46.6601C511 46.6101 511.01 46.5501 511.01 46.5001L510.79 46.5701V46.5601ZM510.81 46.3001L510.79 46.4401L510.91 46.3301C510.91 46.3301 510.85 46.3101 510.81 46.3001ZM514.69 40.7001C514.74 40.7101 514.8 40.7101 514.86 40.7001C514.8 40.7001 514.75 40.7001 514.69 40.7001ZM516.67 37.1101L516.96 37.4401L516.67 37.1101ZM516.67 37.1101L516.96 37.4301C517.01 37.3501 517.03 37.2501 517 37.1601C517 37.1301 516.98 37.1101 516.97 37.0901C516.87 37.1101 516.77 37.1201 516.67 37.1101ZM512.48 54.0301C512.41 54.0301 512.35 54.0201 512.29 53.9901C512.16 53.9201 512.04 53.8201 511.94 53.7101C511.8 53.6401 511.71 53.5101 511.7 53.3601C511.7 53.2001 511.76 53.0501 511.89 52.9601C511.91 52.9401 511.96 52.8701 511.99 52.8201C512.07 52.6901 512.17 52.5701 512.28 52.4801C512.38 52.4001 512.51 52.3701 512.63 52.3901C512.75 52.4101 512.86 52.4901 512.93 52.5901C513.03 52.7901 513.03 53.0201 512.94 53.2201C512.94 53.2501 512.94 53.2801 512.94 53.3101C512.98 53.5101 512.92 53.7201 512.8 53.8901C512.71 53.9801 512.59 54.0401 512.47 54.0401L512.48 54.0301ZM512.26 49.3801C512.15 49.3801 512.05 49.3401 511.96 49.2701C511.83 49.1401 511.78 48.9501 511.83 48.7701H511.79C511.6 48.7301 511.46 48.5801 511.43 48.3901C511.27 48.2701 511.21 48.0401 511.29 47.8501C511.37 47.6601 511.57 47.5501 511.78 47.5901C511.89 47.6101 511.99 47.6701 512.07 47.7501C512.12 47.7901 512.16 47.8301 512.2 47.8701C512.22 47.8701 512.25 47.8701 512.27 47.8701C512.4 47.8701 512.53 47.9301 512.61 48.0401C512.67 48.1201 512.72 48.2001 512.76 48.2901C512.78 48.3201 512.79 48.3501 512.81 48.3701C512.89 48.4701 512.92 48.5901 512.9 48.7201C512.88 48.8101 512.84 48.8901 512.77 48.9501C512.71 49.1201 512.6 49.2501 512.45 49.3401C512.39 49.3701 512.32 49.3901 512.25 49.3901L512.26 49.3801ZM511.49 48.1201C511.49 48.1201 511.45 48.2101 511.45 48.2601L511.66 48.2001L511.49 48.1201ZM512.84 47.3801C512.84 47.3801 512.79 47.3801 512.77 47.3801C512.58 47.3501 512.42 47.1901 512.39 47.0001C512.22 46.8801 512.16 46.6601 512.24 46.4701C512.32 46.2801 512.51 46.1701 512.72 46.1901C512.86 46.2201 512.98 46.2901 513.08 46.4001C513.14 46.4501 513.19 46.5201 513.23 46.6001C513.33 46.7701 513.33 46.9701 513.25 47.1401C513.17 47.2901 513.01 47.3901 512.84 47.3901V47.3801ZM512.5 47.0501C512.5 47.0501 512.57 47.0701 512.6 47.0801L512.62 46.9401L512.5 47.0601V47.0501ZM512.44 46.7201C512.41 46.7701 512.4 46.8301 512.4 46.8801L512.62 46.8101L512.44 46.7201ZM512.25 39.7701C512.11 39.7701 511.98 39.7001 511.89 39.5901C511.83 39.5101 511.79 39.4201 511.77 39.3201L511.75 39.2601C511.64 39.0601 511.69 38.8201 511.87 38.6801L511.9 38.6501C512.01 38.4601 512.22 38.3501 512.43 38.3601C512.59 38.3801 512.73 38.4801 512.8 38.6301C512.87 38.8101 512.84 39.0101 512.71 39.1501C512.78 39.3901 512.65 39.6501 512.42 39.7401C512.37 39.7601 512.31 39.7701 512.26 39.7701H512.25ZM512.7 39.1301C512.73 39.0001 512.7 38.8601 512.61 38.7601C512.69 38.8601 512.72 39.0001 512.7 39.1301ZM516.86 34.2001C516.77 34.0301 516.75 33.8401 516.81 33.6601C516.69 33.4801 516.65 33.2501 516.71 33.0401L517.56 33.3401C517.58 33.2801 517.59 33.2201 517.57 33.1501C517.58 33.1801 517.6 33.2101 517.61 33.2401C517.69 33.3601 517.73 33.5101 517.73 33.6601C517.73 33.7101 517.72 33.7601 517.7 33.8101C517.7 33.8501 517.68 33.8801 517.68 33.9201C517.68 33.8501 517.66 33.7801 517.62 33.7201L516.87 34.2101L516.86 34.2001ZM514.6 32.6801C514.6 32.6801 514.52 32.6801 514.48 32.6601C514.43 32.6501 514.39 32.6301 514.35 32.6101C514.28 32.5701 514.21 32.5201 514.14 32.4601C514.09 32.4301 514.04 32.3901 514 32.3401C513.92 32.2401 513.89 32.1201 513.9 32.0001C513.92 31.8401 514.02 31.7001 514.17 31.6401C514.32 31.5801 514.49 31.6001 514.62 31.6901C514.8 31.6001 515.02 31.6501 515.15 31.8101C515.23 31.9001 515.26 32.0201 515.25 32.1401C515.24 32.2601 515.18 32.3701 515.09 32.4401C515.06 32.4601 515.02 32.4901 514.99 32.5001C514.95 32.5301 514.91 32.5601 514.86 32.5801C514.79 32.6401 514.7 32.6701 514.61 32.6701L514.6 32.6801ZM514.81 31.8401C514.81 31.8401 514.9 31.9001 514.93 31.9401C514.9 31.9001 514.85 31.8601 514.81 31.8401ZM511.83 31.5301C511.76 31.5301 511.69 31.5101 511.63 31.4801C511.58 31.4501 511.53 31.4201 511.5 31.3801C511.4 31.2701 511.36 31.1201 511.39 30.9701C511.42 30.8401 511.5 30.7401 511.61 30.6801C511.63 30.6501 511.66 30.6301 511.69 30.6101C511.79 30.5501 511.9 30.5301 512.01 30.5501C512.13 30.5201 512.26 30.5301 512.37 30.5901C512.4 30.6001 512.43 30.6201 512.46 30.6401C512.48 30.6501 512.5 30.6701 512.51 30.6801C512.51 30.6401 512.53 30.5901 512.55 30.5501C512.6 30.4401 512.67 30.3501 512.76 30.2701C512.84 30.1401 512.99 30.0601 513.14 30.0501C513.21 30.0501 513.27 30.0601 513.34 30.0801H513.37C513.37 30.0801 513.47 30.1001 513.51 30.1101C513.63 30.1501 513.73 30.2401 513.79 30.3501C513.84 30.4701 513.84 30.6001 513.79 30.7201C513.72 30.8901 513.54 31.0001 513.36 30.9901C513.24 31.1701 513.02 31.2401 512.82 31.1801C512.76 31.1601 512.7 31.1301 512.65 31.0801C512.65 31.1201 512.64 31.1501 512.62 31.1801C512.55 31.3501 512.39 31.4601 512.2 31.4601C512.13 31.5001 512.06 31.5201 511.98 31.5201H511.94C511.94 31.5201 511.87 31.5301 511.83 31.5301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.81 39.6501C573.88 39.4901 573.31 39.2201 573.92 39.2801C574.17 39.3101 574.35 39.0101 574.35 38.8401C574.35 38.7001 574.22 38.5201 574.21 38.3601C574.2 38.2101 574 38.1601 573.9 38.0201C573.81 37.8901 573.97 37.5801 573.89 37.4601C573.86 37.4101 573.97 37.5501 574.16 37.4701C574.38 37.3801 574.56 37.2101 574.38 37.3601C574.24 37.4701 573.66 37.5501 573.9 37.9001C573.91 37.9201 573.52 38.2801 573.51 38.2901C573.32 38.5801 573.87 39.1601 573.95 38.8101C573.99 38.6201 573.62 38.4501 573.55 38.2901C573.48 38.1301 573.51 37.9201 573.37 37.7901C573.23 37.6801 573.07 37.5701 572.92 37.4801C572.78 37.3701 572.56 37.3501 572.42 37.2401C572.26 37.1301 572.13 36.9701 572.01 36.8601C571.85 36.7201 571.65 36.0301 571.75 35.9101C571.94 35.6801 572.29 35.6001 572.27 35.4001C572.22 35.1501 572.12 34.9201 571.98 34.7101C571.88 34.5401 571.66 34.4801 571.55 34.3701C571.43 34.2501 571.32 34.1101 571.23 33.9601C571.15 33.8201 571.16 33.7301 571.29 33.5201C571.38 33.5901 571.56 33.5601 571.81 33.5201C571.98 33.4901 572.14 33.3301 572.33 33.2701C572.52 33.2101 572.78 33.3601 572.94 33.2801C573.17 33.1801 573.17 32.9001 573.22 32.7901C573.26 32.7201 573.01 32.2501 573.05 32.1901C572.95 32.1701 573.33 32.7401 573.26 32.7801C573.2 32.8201 572.9 32.6901 572.67 32.7901C572.52 32.8501 572.39 32.9901 572.22 33.0601C572.05 33.1301 571.88 33.1801 571.73 33.2501C571.5 33.3501 571.3 33.2601 571.24 33.3001C571.13 33.2801 570.92 33.5101 570.9 33.4501C570.73 33.0501 570.82 32.9101 570.77 32.8301C570.72 32.7601 570.38 32.7501 570.32 32.3401C570.44 32.1501 570.47 31.9201 570.42 31.7001C570.36 31.5201 570.05 31.3901 569.98 31.1901C569.91 30.9801 569.91 30.7501 569.85 30.5701C569.8 30.3601 569.85 30.1401 569.96 29.9601C569.98 29.9001 569.71 29.6501 569.71 29.6601C569.48 29.7701 569.38 30.0701 569.15 30.1901C569.27 30.2901 569.38 30.4101 569.45 30.5501C569.55 30.7201 569.45 31.0301 569.57 31.2201C569.68 31.4101 570.04 31.4501 570.14 31.6201C570.31 31.9001 570.36 32.1401 570.41 32.1801C570.47 32.2301 570.63 32.3701 570.69 32.4201C570.56 32.5201 570.26 32.4601 570.09 32.4601C569.92 32.4401 569.76 32.4601 569.6 32.4901C569.47 32.5401 569.2 32.6001 569.13 32.8101C569.13 32.8301 569.1 32.8301 569.09 32.8301C569.08 32.8301 569.06 32.8201 569.05 32.8001C568.96 32.6601 568.77 32.8301 568.51 32.8901C568.32 32.9401 568.02 32.7101 567.83 32.7901C567.66 32.8701 567.48 32.9501 567.3 33.0101C567.1 33.0401 567.29 33.0401 567.52 32.9001C567.65 32.8201 567.71 32.6501 567.81 32.5601C567.9 32.4801 567.97 32.4201 567.9 32.1901C567.86 32.0201 567.81 31.8501 567.74 31.6901C567.67 31.5301 567.48 31.4301 567.39 31.2801C567.3 31.1101 567.43 30.8201 567.34 30.6901C567.23 30.5301 567.09 30.3901 566.92 30.2901C566.78 30.2401 566.64 30.0901 566.5 30.0601C566.36 30.0301 566.17 30.1001 566.02 30.0601C565.93 30.0401 565.86 30.1701 565.77 30.1901C565.84 30.2401 565.92 30.2801 566 30.3101C566.12 30.3701 566.04 30.9001 566.18 30.9401C566.05 31.0101 566.09 31.0101 565.96 31.0501C565.75 31.1601 565.6 31.3501 565.56 31.5801C565.54 31.7701 565.54 31.9601 565.55 32.1401C565.55 32.3301 565.58 32.5201 565.58 32.6801C565.58 32.9801 565.82 33.0201 565.68 32.9001C565.47 32.8101 565.24 32.7501 565.02 32.7101C564.81 32.6801 564.59 32.6801 564.38 32.7101C564.09 32.6801 563.76 32.6501 563.74 32.8101C563.69 33.1401 563.61 33.2701 563.42 33.1801C563.27 33.1101 563.14 32.8901 562.97 32.7801C562.91 32.7201 562.82 32.6901 562.73 32.7001C562.64 32.7001 562.56 32.7601 562.51 32.8301C562.51 32.7301 562.26 32.3801 562.31 32.3101C562.38 32.2001 562.57 32.5101 562.56 32.8401C562.56 33.0001 562.36 33.1701 562.34 33.3601C562.32 33.5501 562.37 33.7301 562.34 33.9001C562.29 34.1901 562.33 34.2701 562.25 34.2601C562.15 34.2401 561.84 34.5501 561.84 34.6401C561.84 34.9201 561.71 35.0301 561.56 34.9301C561.44 34.8501 561.41 34.3901 561.29 34.3701C560.8 34.2801 561.18 34.2701 561.15 34.1001C561.09 33.7701 561.13 33.9201 560.92 34.0201C560.77 34.1201 560.6 34.1901 560.42 34.2201C560.21 34.1901 560.04 34.0201 560.01 33.8101C559.95 33.5101 560.06 33.7401 559.91 33.9201C559.72 34.0901 559.49 34.2201 559.25 34.3001C559.23 34.3101 559.19 34.2801 559.21 34.2701C559.25 34.2101 559.48 34.0701 559.48 34.0001C559.48 33.8401 559.28 33.6401 559.27 33.4801C559.16 33.5501 559.1 33.7501 558.99 33.8301C558.9 33.9001 558.87 34.0001 558.79 34.0701C558.79 34.0701 558.71 33.9801 558.71 33.9701C558.73 33.7601 558.51 33.4301 558.6 33.2401C558.66 33.1101 559.07 33.1301 559.22 33.0301C559.07 33.0101 558.9 32.8101 558.75 32.8101C558.55 32.8701 558.37 32.9701 558.21 33.0901C558.02 33.2201 557.91 33.6901 557.83 33.6901C557.76 33.6901 557.87 33.2201 557.8 32.9201C557.76 32.7501 557.65 32.5701 557.6 32.3801C557.56 32.1801 557.31 32.0301 557.27 31.8601C557.2 31.5701 557.15 31.2501 557.09 31.2301C557.26 31.1201 557.57 31.1601 557.74 31.0401C557.85 30.9701 557.96 31.1601 557.95 31.4701C557.95 31.6501 557.65 31.8601 557.69 32.0401C557.73 32.2401 557.95 32.3301 558.12 32.4101C558.25 32.4701 558.43 32.6501 558.67 32.5901C558.82 32.5501 558.94 32.3401 559.14 32.2401C559.32 32.1801 559.49 32.1001 559.65 32.0201C559.83 31.9101 559.95 31.8501 560.04 31.8901C560.1 31.9201 560 31.8801 559.88 32.2101C559.84 32.3301 560.1 32.1401 560.17 31.8101C560.2 31.6401 560.27 31.4601 560.32 31.2901C560.36 31.1201 560.41 30.9501 560.47 30.7901C560.53 30.6601 560.41 30.3201 560.55 30.1201C560.66 29.9601 560.98 29.9301 561.1 29.7501C561.21 29.5701 561.3 29.3901 561.39 29.2001C561.48 29.0201 561.53 28.8301 561.54 28.6301C561.55 28.5001 561.71 28.8301 561.77 29.2401C561.8 29.4601 561.77 29.7101 561.8 29.9301C561.83 30.1501 561.87 30.3701 561.93 30.5901C561.9 30.6101 561.83 30.4701 561.8 30.4901C561.98 30.4101 562.1 30.2301 562.1 30.0301C562.1 29.8301 561.89 29.6001 561.89 29.4001C561.89 29.0601 561.94 28.9901 561.95 28.9801C562.02 28.9801 562.18 29.0001 562.25 29.3301C562.3 29.5301 562.43 29.7401 562.47 29.9401C562.54 30.2601 562.3 30.3901 562.37 30.4001C562.35 30.3701 562.56 30.3301 562.54 30.0501C562.53 29.8901 562.35 29.7201 562.34 29.5401C562.33 29.3601 562.15 29.1901 562.14 29.0201C562.12 28.7401 562.14 28.5601 562.12 28.5201C562.07 28.3101 562.45 28.0601 562.68 28.0801C562.86 28.0901 563 28.4601 563.15 28.5101C563.33 28.5701 563.54 28.3301 563.7 28.2401C563.84 28.1601 564.09 28.1601 564.22 28.0201C564.34 27.9001 564.39 27.6901 564.51 27.5501C564.62 27.4101 564.57 27.1301 564.68 26.9901C564.82 26.8701 564.97 26.7501 565.13 26.6601C565.18 26.6201 565.4 26.7601 565.43 26.8201C565.5 26.9501 565.56 27.0801 565.62 27.2101C565.65 27.3301 565.66 27.5601 565.91 27.5101C566.07 27.4801 566.06 27.0601 566.22 26.8901C566.37 26.7001 566.56 26.5301 566.77 26.4001C566.79 26.4001 566.77 26.6801 566.79 26.6801C567.02 26.6401 567.28 26.7501 567.52 26.7001C567.75 26.6601 567.94 26.3001 568.17 26.2801C568.39 26.2601 568.56 26.5201 568.75 26.5901C568.92 26.6501 569.25 26.5401 569.4 26.7401C569.57 26.9701 569.58 26.8301 569.83 26.6801C570.04 26.5601 570.36 26.6001 570.57 26.5301C570.85 26.4401 571.07 26.2401 571.22 26.3001C571.4 26.3701 571.26 26.7301 571.35 26.9801C571.46 27.1601 571.56 27.3501 571.65 27.5501C571.71 27.7701 571.9 27.7901 572.01 27.8601C572.13 27.9501 572.29 27.9801 572.43 27.9601C572.65 27.9301 572.88 27.9201 573.1 27.9501C573.34 27.9901 573.46 28.2201 573.59 28.3501C573.72 28.5201 573.89 28.6601 574.08 28.7501C574.25 28.8001 574.47 28.4801 574.67 28.4601C575.36 28.3901 574.97 28.5601 575.02 28.8201C575.02 28.8201 575.11 28.6501 575.1 28.6401C575.26 28.7401 575.43 28.8301 575.6 28.9301C575.76 29.0301 575.91 29.1401 576.08 29.2301C576.23 29.2901 576.34 29.4301 576.36 29.6001C576.38 29.7601 576.31 29.9201 576.18 30.0201C576.13 30.1101 576.09 30.2101 576.06 30.3101C576.33 30.3601 576.53 30.3101 576.59 30.4701C576.66 30.6501 576.41 30.9101 576.44 31.1101C576.5 31.3701 576.67 31.5901 576.89 31.7301C576.91 31.7301 576.89 31.5701 576.89 31.5901C576.89 31.6801 576.87 31.7201 576.87 31.8101C576.87 31.8201 576.76 31.8001 576.76 31.8101C576.78 31.9501 577.12 32.1301 577.13 32.2901C577.14 32.5001 577 32.6901 577.1 32.7501C577.28 32.8601 577.21 33.0801 577.28 33.2001C577.37 33.3501 577.61 33.4201 577.59 33.5901C577.57 33.7401 577.28 33.8301 577.22 34.0101C577.13 34.2901 577.57 34.3701 577.8 34.4201C578.12 34.4901 578.45 34.6601 577.98 34.7601C577.96 34.7601 577.92 34.6001 577.92 34.6101C577.94 34.8001 578 34.9901 578.11 35.1501C578.21 35.3101 578.3 35.4701 578.37 35.6401C578.43 35.8101 578.3 36.0001 578.33 36.1901C578.38 36.3601 578.41 36.5301 578.43 36.7101C578.43 36.8901 578.71 37.0901 578.7 37.2701C578.68 37.4501 578.39 37.6001 578.36 37.7801C578.33 37.9601 578.63 38.2101 578.6 38.3901C578.56 38.5701 578.12 38.6601 578.08 38.8301C578.03 39.0201 578.13 39.2301 578.09 39.4001C578.04 39.6101 577.8 39.8501 577.79 40.0701C577.78 40.2701 578.09 40.2801 578.39 40.4301C578.4 40.4301 578.2 40.6801 578.21 40.6901C578.3 40.7801 578.36 40.8701 578.45 40.9601C578.46 40.9701 578.5 40.8001 578.5 40.8201C578.43 40.9801 578.44 41.3601 578.36 41.5201C578.22 41.4001 577.97 41.1701 577.83 41.0501C577.69 40.9201 577.71 40.5301 577.55 40.4601C577.38 40.3901 577.23 40.6901 577.13 40.7801C577.04 40.8701 576.9 40.9201 576.93 41.1201C576.89 41.1701 576.97 41.1201 576.93 41.1701C576.96 41.1101 576.89 41.1801 576.92 41.1301C577.16 41.1601 577.38 41.2901 577.62 41.3201C577.86 41.3501 578 41.4401 578.24 41.4701C578.31 41.6501 578.38 41.6801 578.42 41.8501C578.49 42.0101 578.52 42.1901 578.51 42.3601C578.51 42.5401 578.43 42.7101 578.3 42.8401C578.18 42.9901 578.03 43.1201 577.86 43.2101C577.8 43.2301 577.82 43.3401 577.8 43.4701C577.92 43.4701 578.06 43.6601 578.17 43.6301C578.32 43.5901 578.45 43.3601 578.6 43.3001C578.58 43.4601 578.52 43.6101 578.41 43.7301C578.31 43.8501 578.54 44.1601 578.51 44.3301C578.48 44.5201 578.41 44.7001 578.3 44.8501C578.21 44.9401 577.91 44.7901 577.68 44.7701C577.68 44.9101 577.52 45.2501 577.57 45.3501C577.66 45.5301 577.92 45.6101 578 45.7901C578.08 45.9701 578.3 46.1101 578.36 46.3001C578.42 46.4901 578.2 46.7401 578.22 46.9401C578.27 47.1301 578.3 47.3201 578.3 47.5201C578.3 47.5401 578.59 47.4201 578.73 47.4601C578.73 47.4601 578.53 47.6601 578.54 47.6701C578.62 47.8501 578.73 48.0001 578.66 48.1901C578.59 48.3801 578.7 48.5301 578.72 48.7101C578.74 48.8601 578.6 49.0901 578.84 49.2201C578.85 49.2201 578.92 49.6701 578.83 49.7301C578.67 49.8301 578.35 49.7101 578.24 49.8401C578.15 50.0001 578.07 50.1701 578.02 50.3501C577.95 50.5101 577.77 50.6501 577.72 50.8201C577.67 50.9901 577.7 51.1801 577.65 51.3501C577.63 51.4101 577.95 51.7401 578.03 51.7301C578.33 51.6801 578.46 51.6301 578.51 51.7301C578.61 51.9101 578.61 52.1301 578.51 52.3101C578.43 52.4301 578.19 52.8901 578.1 53.0001C578.01 53.1001 577.93 53.1901 577.85 53.3001C577.97 53.3201 578.09 53.3401 578.21 53.3801C578.31 53.3901 578.25 53.4101 578.34 53.4501C578.28 53.5901 578.42 53.7301 578.32 53.8101C578.14 53.9601 578.03 54.1801 577.86 54.3301C577.69 54.4801 577.41 54.5501 577.37 54.8101C577.33 55.1301 577.41 55.0501 577.77 54.9901C578.28 54.8901 577.77 55.3501 577.71 55.5601C577.79 55.5801 577.88 55.6001 577.97 55.6101C577.87 55.6701 577.74 55.6901 577.64 55.7501C577.74 55.7801 577.86 55.7101 577.97 55.7401C577.99 55.7401 577.91 55.7701 577.9 55.7901C577.75 55.9701 577.64 56.1901 577.46 56.2401C577.27 56.2901 577.05 56.1701 576.84 56.1601C576.64 56.1601 576.44 56.1601 576.24 56.1601C576.05 56.1901 575.86 56.2601 575.69 56.3701C575.62 56.3101 575.54 56.2601 575.46 56.2101C575.27 56.1201 575.19 55.9401 575 55.9801C574.85 56.0101 574.73 56.1901 574.52 56.2801C574.32 56.3401 574.11 56.3301 573.91 56.2601C573.71 56.2201 573.54 56.1101 573.42 55.9501C573.33 55.7801 573.26 55.6001 573.21 55.4201C573.25 55.4201 573.29 55.3701 573.32 55.3701C573.43 55.4001 573.59 55.3701 573.68 55.4301C573.85 55.5201 573.96 55.7801 574.08 55.7601C574.19 55.7401 574.28 55.5501 574.3 55.2701C574.12 55.3001 573.91 55.2701 573.74 55.2901C573.56 55.3201 573.37 55.4801 573.19 55.5101C572.82 55.2701 573.3 55.0901 573.43 54.9001C573.52 54.7601 573.37 54.4501 573.47 54.3101C573.57 54.1701 573.59 53.9701 573.69 53.8401C573.79 53.7001 574.05 53.7901 574.15 53.6501C574.19 53.7801 574.3 53.6401 574.34 53.7701C574.42 53.6901 574.53 53.7401 574.6 53.6601C574.47 53.6201 574.41 53.4901 574.29 53.4501C574.27 53.2901 574.17 53.1901 574.13 52.9801C574.09 52.8001 574.09 52.5901 574.03 52.4001C573.96 52.2201 573.88 52.0401 573.79 51.8601C573.73 51.6601 573.65 51.4701 573.55 51.2801C573.51 51.2301 573.43 51.2401 573.47 51.2401C573.69 51.1801 573.92 51.1401 574.15 51.1101C574.13 51.3001 573.91 51.5301 573.95 51.7101C573.98 51.8201 574.3 51.8701 574.41 51.9601C574.45 51.8301 574.73 51.9101 574.86 51.8301C575.01 51.6801 575.04 51.4401 574.92 51.2601C574.87 51.1801 575.05 50.9101 575.2 50.7101C575.26 50.6101 575.25 50.4701 575.3 50.3701C575.3 50.3701 575.2 50.3201 575.17 50.3001C575.15 50.4301 575.17 50.4801 575.14 50.6101C574.92 50.6701 574.82 50.9901 574.65 50.9501C574.45 50.8601 574.27 50.7501 574.12 50.6001C573.96 50.4901 573.96 50.1501 573.8 50.0301C573.64 49.9101 573.34 50.0201 573.16 49.9501C573.12 49.8201 573.12 49.6701 573.16 49.5401C573.25 49.3701 573.35 49.2001 573.46 49.0401C573.47 49.0301 573.52 49.1001 573.54 49.1001C573.8 48.9601 574.23 48.9501 574.27 48.8001C574.31 48.6601 574.04 48.4401 573.68 48.2501C573.58 48.2001 573.55 47.8301 573.51 47.6501C573.88 47.7001 574.22 47.6501 574.16 47.2801C574.22 47.2101 574.2 47.1601 574.26 47.0801C574.22 47.0601 574.09 47.0101 574.05 46.9901C574.04 47.0901 574.02 47.1101 574.01 47.2201C573.69 47.2201 573.41 47.3601 573.48 47.7301C573.26 47.6501 573.08 47.7001 572.91 47.5601C572.79 47.4001 572.75 47.2001 572.81 47.0101C572.87 46.8301 572.94 46.6501 573.02 46.4801C573.09 46.2901 573.04 46.0701 573.17 45.9301C573.3 45.7801 573.69 45.9601 573.98 45.9501C573.98 45.9801 574.06 45.9001 574.08 45.9301C574.08 45.9501 574.18 45.9301 574.2 45.9401C574.16 45.9101 574 45.9301 573.97 45.8901C573.91 45.8201 573.83 45.7601 573.74 45.7201C573.5 45.6301 573.17 45.5401 573.12 45.4101C573.08 45.2801 573.35 45.0701 573.55 44.8701C573.65 44.7701 573.72 44.6501 573.77 44.5201C573.87 44.4701 573.79 44.4401 573.9 44.4001C573.81 44.4601 573.81 44.4001 573.71 44.4601C573.54 44.4101 573.29 44.5101 573.13 44.4301C573.01 44.3701 572.7 44.0301 572.72 43.9601C572.77 43.7701 573.14 43.6801 573.2 43.5001C573.26 43.3201 573.14 43.0501 573.23 42.8801C573.34 42.7201 573.49 42.5901 573.65 42.4901C573.86 42.3201 574.14 42.1501 574.34 41.9701C574.38 42.0801 574.64 42.2101 574.68 42.3201C574.7 42.3001 574.65 42.3001 574.65 42.2901C574.6 42.2101 574.45 42.2001 574.39 42.1201C574.43 41.9601 574.55 41.8201 574.6 41.6401C574.65 41.4701 574.51 41.2401 574.55 41.0801C574.6 40.8801 574.71 40.7201 574.68 40.5801C574.64 40.4201 574.54 40.3201 574.29 40.3301C574.27 40.3301 574.32 40.3701 574.31 40.3501C574.22 40.2301 573.98 40.2201 573.89 40.0901C573.8 39.9701 573.89 39.9401 573.81 39.8201C573.9 39.8101 573.91 39.7201 573.92 39.7101L573.81 39.6501ZM572.19 28.6901C572.19 28.6901 572.29 28.7201 572.31 28.7001C572.32 28.6901 572.15 28.4301 572.15 28.4101C572.12 28.4501 572.15 28.5701 572.13 28.6101C572.09 28.6401 572.18 28.5601 572.19 28.6101C572.21 28.6901 572.16 28.7201 572.19 28.6901ZM564.78 30.5401C564.75 30.2401 564.83 30.2401 564.82 29.9401C564.81 29.6401 564.71 29.6401 564.7 29.3301C564.69 29.0201 564.4 28.9501 564.59 28.7201C564.78 28.4901 564.76 29.0201 564.77 29.3201C564.78 29.6201 564.46 29.6401 564.47 29.9401C564.48 30.2401 564.47 30.2501 564.49 30.5501C564.49 30.5801 564.73 30.5701 564.75 30.6001C564.75 30.6101 564.89 30.5501 564.91 30.5501C564.87 30.5201 564.82 30.5801 564.78 30.5501V30.5401ZM574.42 33.7801C574.42 33.7801 574.22 33.8001 574.24 33.7801C574.23 33.8001 574.29 33.6201 574.28 33.6501C574.25 33.6601 574.28 33.7401 574.25 33.7501C574.24 33.7501 574.12 33.6801 574.11 33.6901C574.14 33.6501 574.38 33.8101 574.41 33.7701L574.42 33.7801ZM560.35 33.0101C560.41 32.8101 560.45 32.6101 560.45 32.4101C560.45 32.2501 560.35 32.0701 560.35 31.8801C560.35 31.7101 560.26 31.5201 560.26 31.3501C560.26 31.1601 560.11 30.9801 560.12 30.8201C560.11 30.6901 560.12 30.5501 560.18 30.4201C560.12 30.5401 560.09 30.6801 560.1 30.8201C560.1 30.9801 560.34 31.1601 560.34 31.3501C560.34 31.5301 560.09 31.7101 560.09 31.8801C560.09 32.0701 560.09 32.2501 560.09 32.4101C560.08 32.5301 560.09 32.6501 560.15 32.7601C560.12 32.7801 560.29 32.8501 560.31 32.8801C560.36 32.9401 560.33 33.0301 560.34 33.0101H560.35ZM566.39 32.7301C566.32 32.4501 566.36 32.4301 566.27 32.1601C566.18 31.8901 566.08 31.9201 566 31.6501C565.91 31.3801 565.83 31.4001 565.74 31.1301C565.65 30.8601 565.51 30.9001 565.43 30.6301C565.34 30.3601 565.11 30.2001 565.4 30.2101C565.69 30.2201 565.32 30.3701 565.4 30.6401C565.48 30.9101 565.72 30.8401 565.81 31.1201C565.9 31.4001 565.66 31.4701 565.75 31.7501C565.84 32.0301 565.84 32.0301 565.93 32.3001C566.02 32.5801 566 32.5701 566.07 32.8501C566.04 32.8601 566.31 32.9301 566.29 32.9501C566.28 32.9501 566.19 32.8701 566.19 32.8901C566.22 32.8501 566.37 32.7801 566.39 32.7401V32.7301ZM576.66 49.6501C576.66 49.6501 576.89 49.6601 576.88 49.6501C576.87 49.6301 576.81 49.8101 576.82 49.7901C576.84 49.7701 576.81 49.7201 576.79 49.6901C576.75 49.6301 576.68 49.6301 576.66 49.6501ZM561.7 33.0001C561.79 32.9701 561.88 33.4501 561.96 33.4201C561.95 33.4201 561.95 32.9901 561.93 32.7001C561.93 32.5301 561.82 32.3401 561.81 32.1601C561.79 32.0201 561.81 31.8801 561.87 31.7501C561.7 31.8301 561.58 32.0001 561.56 32.1901C561.56 32.3801 561.53 32.5801 561.52 32.7701C561.54 32.9901 561.59 33.2001 561.68 33.4101C561.65 33.4201 561.47 32.7701 561.45 32.7901C561.43 32.8001 561.66 33.1201 561.65 33.1501C561.68 33.1101 561.66 33.0401 561.69 33.0001H561.7ZM577.15 44.1901C577.23 44.1901 577.18 44.2501 577.26 44.2501C577.39 44.3301 577.56 44.3201 577.7 44.4101C577.71 44.3801 577.75 44.2701 577.77 44.2301C577.62 44.1901 577.37 44.2501 577.21 44.2101C577.18 44.0901 577.27 43.6801 577.24 43.5601C577.2 43.6801 577 43.8801 576.97 44.0001C576.96 44.0301 577.14 44.0901 577.14 44.1201C577.14 44.1801 577.14 44.2101 577.16 44.2001L577.15 44.1901ZM574.53 39.0301C574.47 39.1301 574.36 39.2201 574.31 39.3201C574.31 39.3201 574.62 39.4801 574.65 39.5001C574.67 39.3701 574.61 39.2001 574.63 39.0701C574.63 39.0401 574.6 39.1701 574.58 39.1601C574.52 39.1101 574.54 39.0001 574.53 39.0301ZM574.22 44.5301C574.16 44.5701 574.02 44.5701 573.97 44.6301C573.91 44.7001 573.93 44.9101 573.89 44.9901C573.95 45.0101 574.01 45.0301 574.07 45.0401C574.14 44.9801 574.08 44.8401 574.12 44.7601C574.15 44.7001 574.42 44.7601 574.43 44.6801C574.46 44.6701 574.43 44.7401 574.46 44.7301C574.48 44.7301 574.43 44.5901 574.44 44.5701C574.41 44.6101 574.25 44.5001 574.22 44.5401V44.5301ZM576.52 50.7701C576.54 50.8301 576.51 50.9201 576.52 50.9801C576.55 50.9501 576.74 50.7001 576.76 50.6701C576.7 50.6501 576.57 50.6901 576.51 50.6701C576.39 50.6501 576.29 50.7701 576.18 50.7501C576.18 50.7801 576.14 50.8301 576.14 50.8701C576.27 50.8501 576.38 50.7901 576.51 50.7701H576.52ZM573.33 46.4301C573.24 46.4901 573.03 46.5501 572.99 46.6301C572.95 46.7301 573.12 47.0101 573.13 47.1301C573.23 47.0501 573.32 46.9501 573.39 46.8401C573.43 46.7501 573.25 46.6101 573.24 46.5001C573.26 46.4801 573.31 46.5901 573.33 46.5601C573.33 46.5901 573.33 46.4001 573.33 46.4301ZM573.31 36.1401C573.38 36.2401 573.6 36.4501 573.68 36.5501C573.73 36.4301 573.82 36.0601 573.87 35.9401C573.74 35.9701 574.44 36.0501 574.3 36.0901C574.24 35.8201 574.03 35.5801 573.96 35.3101C573.89 35.3101 573.82 35.3101 573.75 35.3101C573.82 35.4301 573.72 35.4201 573.56 35.5501C573.4 35.6801 573.24 36.0101 573.31 36.1401ZM575.14 53.1101C575.2 53.1501 575.17 52.9301 575.23 52.9601C575.17 52.9301 575.32 52.9901 575.25 52.9601C575.22 52.8301 575.11 52.6501 575.05 52.4601C574.98 52.2501 574.91 52.2201 574.72 52.2601C574.67 52.2701 574.47 52.3101 574.43 52.3601C574.54 52.4001 574.63 52.5601 574.74 52.7201C574.84 52.8701 574.98 53.0001 575.14 53.1001V53.1101ZM577.18 42.4201C577.18 42.4201 577.15 42.5701 577.13 42.5401C577.16 42.5601 576.97 42.4201 577 42.4401C576.94 42.5301 576.95 42.6501 576.9 42.7501C576.85 42.8601 576.89 42.8501 576.85 42.9801C577.01 42.9201 577.26 43.0701 577.42 43.0201C577.35 42.8701 577.24 42.5901 577.17 42.4401L577.18 42.4201ZM574.92 49.0301C574.81 49.1501 574.58 49.2801 574.45 49.4201C574.33 49.5501 574.28 49.7601 574.16 49.9001C574.14 49.9301 574.33 50.2201 574.39 50.2201C574.53 50.2301 574.67 50.1701 574.74 50.0501C574.82 49.9101 575.17 49.8701 575.22 49.7201C575.27 49.5601 575.33 49.3701 575.38 49.2201C575.23 49.1401 575.07 49.0801 574.91 49.0301H574.92ZM575.72 33.1101C575.87 33.0401 576.21 33.0001 576.34 32.8801C576.47 32.6801 576.54 32.4501 576.54 32.2101C576.36 32.0101 576.05 31.9001 575.87 32.3101C575.83 32.4101 575.77 32.5101 575.69 32.5901C575.61 32.6601 575.24 32.7301 575.26 32.8001C575.28 32.8801 575.58 33.0201 575.72 33.1101ZM574.47 46.5501C574.4 46.8001 574.34 47.0601 574.31 47.3301C574.41 47.5401 574.71 47.7401 574.84 47.9401C574.97 47.8201 575.24 47.5401 575.22 47.5001C575.14 47.3601 574.93 47.3301 574.79 47.1601C574.7 47.0401 574.6 46.7201 574.47 46.5501ZM573.29 34.3301C573.48 34.2001 573.34 33.6001 573.51 33.4801C573.39 33.3301 573.25 33.2001 573.11 33.0701C573 33.1301 572.83 33.3901 572.62 33.5601C572.41 33.7301 572.32 34.0001 572.22 34.0701C572.34 34.1701 572.5 34.2301 572.65 34.2401C572.86 34.2401 573.08 34.2701 573.28 34.3301H573.29ZM569.08 28.3101C569.04 28.1201 569 27.9401 568.98 27.7501C568.9 27.5701 568.78 27.4001 568.65 27.2501C568.55 27.4901 568.48 27.7301 568.45 27.9901C568.49 28.1401 568.71 28.1901 568.8 28.3201C568.89 28.3601 568.99 28.3501 569.08 28.3201V28.3101ZM574.43 54.9801C574.59 54.7901 574.93 54.5701 574.94 54.4501C574.94 54.3601 574.56 54.0701 574.48 54.0801C574.37 54.0901 574.23 54.3201 574.2 54.4401C574.23 54.6401 574.31 54.8201 574.43 54.9801ZM575.66 47.5301C575.59 47.5801 575.28 47.8301 575.23 48.0101C575.18 48.2101 575.25 48.4901 575.21 48.5201C575.34 48.6601 575.53 48.1401 575.66 48.2801C575.73 48.2101 575.74 48.1801 575.73 48.1501C575.66 48.0001 575.77 47.6901 575.66 47.5301ZM577.77 41.8301C577.7 41.9101 577.46 42.1401 577.4 42.2201C577.54 42.3201 577.69 42.4001 577.85 42.4501C577.96 42.4001 578 42.2101 578.09 42.1301C578 42.0801 577.89 41.9001 577.77 41.8401V41.8301ZM565.95 32.8601C566.03 32.8001 566.24 32.5501 566.3 32.5101C566.2 32.4501 565.93 33.2301 565.83 33.2201C565.74 33.2201 565.63 33.4101 565.54 33.4601C565.61 33.4901 565.53 33.2401 565.59 33.0501C565.65 32.9001 565.8 32.8201 565.95 32.8601ZM577.45 52.9001C577.37 52.7801 577.16 52.0501 577.12 51.9901C577.02 52.0801 576.89 52.7501 576.8 52.8501C576.85 52.9301 576.9 53.0001 576.97 53.0601C577.09 53.0101 577.33 52.9601 577.45 52.9001ZM575.81 32.0201C575.75 31.8901 575.67 31.7601 575.58 31.6501C575.52 31.6501 575.35 31.8901 575.28 31.9201C575.33 31.9901 575.48 32.0801 575.53 32.1501C575.58 32.1001 575.76 32.0701 575.81 32.0201ZM576.81 55.5101C576.67 55.4301 576.42 55.1601 576.34 55.1701C576.28 55.1701 576.11 55.5401 576.12 55.6001C576.14 55.6701 576.35 55.7401 576.43 55.7501C576.57 55.7001 576.7 55.6201 576.81 55.5101ZM573.83 34.5701C573.76 34.4501 573.52 34.1901 573.46 34.1001C573.38 34.2701 573.33 34.4501 573.29 34.6401C573.29 34.7101 573.95 34.7801 574.01 34.8501C574.05 34.7601 573.78 34.6601 573.83 34.5701ZM571.65 28.3301C571.57 28.2801 571.33 28.0801 571.25 28.0301C571.21 28.1601 571.18 28.3001 571.17 28.4401C571.19 28.4901 571.35 28.4901 571.41 28.5001C571.5 28.4601 571.59 28.4001 571.66 28.3301H571.65ZM576.3 37.3101C576.25 37.2601 576.14 36.9801 576.08 36.9601C576.02 36.9401 575.8 37.1701 575.73 37.1801C575.81 37.2601 575.9 37.3301 576 37.3901C576.1 37.3801 576.2 37.3501 576.29 37.3001L576.3 37.3101ZM565.38 28.4401C565.2 28.6001 565.06 28.7901 564.97 29.0201C564.97 29.2101 564.97 29.4101 564.97 29.6001C564.97 29.7901 565 29.9801 565.03 30.1601C565.03 30.4901 564.96 30.6101 565.05 30.5001C565.07 30.7801 565.11 31.0601 565.17 31.3401C565.35 31.1301 565.46 30.8801 565.51 30.6101C565.52 30.4201 565.3 30.2001 565.31 29.9801C565.32 29.7701 565.59 29.5701 565.6 29.3901C565.62 29.0601 565.6 28.9301 565.61 28.9001C565.54 28.7401 565.47 28.5901 565.38 28.4401ZM564.03 28.3101C563.83 28.4401 563.7 28.6501 563.68 28.8801C563.68 29.0401 563.78 29.2301 563.78 29.4401C563.78 29.6201 563.87 29.8101 563.87 30.0001C563.87 30.1901 564.02 30.3801 564.01 30.5601C564.01 30.7501 563.69 30.9401 563.68 31.1201C563.68 31.3301 563.67 31.5201 563.66 31.6801C563.66 31.8901 563.74 32.1001 563.86 32.2701C563.83 32.3301 563.53 32.4201 563.54 32.4701C563.61 32.5701 563.69 32.6601 563.79 32.7301C563.96 32.5101 564.07 32.2501 564.11 31.9701C564.11 31.7901 563.75 31.5901 563.75 31.3701C563.75 31.1801 563.9 30.9701 563.9 30.7601C563.9 30.5601 563.83 30.3501 563.83 30.1501C563.83 29.9401 563.72 29.7401 563.72 29.5401C563.72 29.3201 563.76 29.1101 563.76 28.9301C563.78 28.7001 563.87 28.4701 564.03 28.3001V28.3101ZM571.06 27.2001C571.06 27.2001 570.77 27.1301 570.74 27.1201C570.74 27.1601 570.8 27.4001 570.79 27.4401C570.84 27.4201 570.9 27.3901 570.95 27.3601C570.99 27.3101 571.03 27.2601 571.06 27.2001ZM569.69 27.9301C569.69 27.9301 569.34 27.9101 569.31 27.9101C569.33 27.9401 569.5 28.1301 569.52 28.1601C569.52 28.1401 569.67 27.9601 569.68 27.9301H569.69ZM574.36 49.0901C574.29 49.0401 574.21 48.9901 574.13 48.9501C574.12 48.9501 574.06 49.2301 574.05 49.2601C574.11 49.2601 574.16 49.2401 574.21 49.2301C574.26 49.1901 574.31 49.1401 574.36 49.0901ZM573.64 33.7401C573.62 33.8201 573.47 33.9901 573.47 34.0501C573.58 34.1101 573.68 34.1601 573.79 34.2101C573.82 34.1301 573.84 34.0401 573.84 33.9501C573.78 33.8701 573.72 33.8001 573.64 33.7401ZM573.06 29.5301C573.06 29.6401 573.08 29.7501 573.11 29.8501C573.14 29.8701 573.35 29.7401 573.39 29.7401C573.38 29.6901 573.29 29.6101 573.28 29.5601C573.25 29.5701 573.1 29.5101 573.06 29.5201V29.5301ZM567.54 28.8201C567.51 28.7601 567.46 28.5101 567.43 28.4601C567.33 28.5201 567.24 28.6001 567.16 28.6701C567.16 28.7301 567.26 28.7901 567.27 28.8401C567.32 28.8201 567.49 28.8401 567.54 28.8201ZM573.75 36.1201C573.72 36.0601 573.55 35.8101 573.51 35.7501C573.58 36.0201 573.67 36.2801 573.77 36.5401C573.77 36.5901 573.46 36.2001 573.5 36.2601C573.54 36.2101 573.71 36.1701 573.75 36.1101V36.1201ZM576.17 51.5201C576.11 51.4201 576.02 51.3401 575.92 51.2801C575.9 51.3901 575.9 51.5001 575.93 51.6001C576.02 51.6301 576.11 51.6001 576.16 51.5201H576.17ZM566.46 30.4101C566.54 30.3501 566.62 30.2701 566.69 30.2001C566.6 30.1401 566.51 30.0901 566.41 30.0501C566.39 30.0901 566.39 30.2101 566.37 30.2401C566.39 30.2501 566.44 30.4001 566.47 30.4101H566.46ZM573.22 31.3301C573.22 31.3301 572.96 31.5801 572.98 31.6201C573 31.6601 573.3 31.6201 573.32 31.5901C573.35 31.4901 573.31 31.3801 573.22 31.3301ZM573.85 31.7801C573.85 31.7801 573.62 31.5201 573.58 31.5301C573.55 31.6401 573.56 31.7601 573.59 31.8601C573.69 31.8901 573.79 31.8601 573.85 31.7701V31.7801ZM563.13 32.0201C563.13 32.0201 563.39 31.7801 563.37 31.7301C563.35 31.6901 563.05 31.7301 563.03 31.7601C563 31.8601 563.04 31.9701 563.13 32.0201ZM576.8 45.8101C576.9 45.7401 576.97 45.6501 577.03 45.5501C576.92 45.5301 576.81 45.5501 576.71 45.5801C576.69 45.6701 576.72 45.7601 576.8 45.8101ZM577.46 45.6501C577.4 45.5501 577.32 45.4701 577.22 45.4101C577.2 45.5201 577.2 45.6201 577.22 45.7301C577.31 45.7501 577.4 45.7301 577.46 45.6501ZM575.04 40.7901C575.14 40.7301 575.22 40.6401 575.28 40.5401C575.17 40.5201 575.06 40.5301 574.96 40.5601C574.94 40.6501 574.96 40.7401 575.04 40.7901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M575.6 56.7601C575.49 56.7601 575.38 56.7201 575.29 56.6501C575.26 56.6201 575.19 56.57 575.15 56.55C575.07 56.51 575 56.47 574.94 56.41C574.84 56.5 574.72 56.5701 574.6 56.6301C574.34 56.7201 574.06 56.73 573.8 56.66H573.73C573.42 56.59 573.15 56.42 572.96 56.17C572.88 56.06 572.82 55.93 572.78 55.8C572.62 55.69 572.53 55.5201 572.51 55.3301C572.51 55.0701 572.66 54.8201 572.88 54.6801L572.91 54.6501V54.6201C572.86 54.4101 572.89 54.1901 573.01 54.0001C573.03 53.9601 573.05 53.9201 573.06 53.8801C573.1 53.7501 573.16 53.6301 573.24 53.5301C573.35 53.3901 573.5 53.3001 573.67 53.2801C573.64 53.2101 573.61 53.13 573.59 53.05C573.57 52.95 573.55 52.8501 573.54 52.7501C573.54 52.6701 573.52 52.5801 573.5 52.5001C573.47 52.4001 573.42 52.31 573.37 52.22C573.33 52.15 573.3 52.0701 573.27 52.0001C573.23 51.9201 573.2 51.82 573.17 51.73C573.16 51.69 573.14 51.6301 573.12 51.5801C572.96 51.4801 572.87 51.2801 572.92 51.0901C572.96 50.9001 573.13 50.7601 573.32 50.7501C573.39 50.7401 573.47 50.7201 573.54 50.7001H573.56C573.51 50.6101 573.47 50.52 573.44 50.42V50.3801C573.44 50.3801 573.38 50.3801 573.36 50.3801C573.21 50.3901 573.06 50.3801 572.91 50.3301C572.78 50.2801 572.68 50.18 572.63 50.05C572.55 49.79 572.57 49.5101 572.67 49.2601C572.7 49.2101 572.73 49.15 572.76 49.1C572.83 48.96 572.91 48.8301 573 48.7101C573.07 48.6201 573.18 48.56 573.29 48.54C573.14 48.41 573.05 48.24 573.03 48.05C572.84 48.03 572.66 47.9601 572.51 47.8401C572.25 47.5801 572.16 47.2 572.27 46.85C572.31 46.7 572.36 46.56 572.43 46.42C572.46 46.37 572.48 46.3101 572.5 46.2501C572.51 46.2101 572.52 46.1701 572.52 46.1201C572.52 45.9501 572.58 45.7901 572.67 45.6401C572.63 45.5901 572.61 45.54 572.59 45.48C572.53 45.21 572.62 44.9401 572.84 44.7701H572.81C572.81 44.7701 572.06 44.2701 572.19 43.7801C572.26 43.5601 572.42 43.3901 572.62 43.2801L572.67 43.2501V43.1901C572.63 42.9901 572.65 42.79 572.73 42.61C572.85 42.41 573.02 42.24 573.22 42.11L573.27 42.0701C573.36 42.0001 573.46 41.93 573.56 41.85C573.69 41.76 573.82 41.6701 573.94 41.5701C573.97 41.5401 574 41.5201 574.04 41.5001C574.04 41.4801 574.06 41.4601 574.06 41.4401C574.06 41.4401 574.04 41.4101 574.03 41.3701C573.98 41.2201 573.98 41.0601 574 40.9001C574.02 40.8401 574.04 40.7701 574.06 40.7101C574.04 40.7101 574.03 40.7001 574.01 40.6901C573.95 40.6601 573.9 40.6301 573.86 40.5801L573.82 40.5601C573.66 40.5101 573.52 40.4101 573.42 40.2801C573.34 40.1801 573.3 40.0601 573.29 39.9301C573.24 39.8201 573.24 39.7001 573.29 39.5901C573.18 39.4401 573.17 39.2401 573.26 39.0801C573.26 39.0701 573.27 39.06 573.28 39.04C573.25 39.01 573.23 38.9701 573.2 38.9401C573.04 38.7201 572.99 38.4401 573.07 38.1801C573.07 38.1801 573.06 38.1001 573.05 38.0601C573.04 38.0601 572.97 38.01 572.91 37.98C572.82 37.93 572.74 37.8801 572.66 37.8201C572.62 37.8001 572.57 37.7801 572.52 37.7601C572.39 37.7201 572.28 37.6601 572.17 37.5901C572.05 37.5001 571.95 37.41 571.84 37.3C571.8 37.26 571.76 37.2201 571.72 37.1901C571.47 36.9701 571.1 36.0101 571.41 35.6201C571.52 35.4901 571.65 35.38 571.79 35.3C571.74 35.17 571.68 35.0601 571.6 34.9401C571.56 34.9101 571.52 34.89 571.48 34.86C571.39 34.81 571.3 34.74 571.22 34.67C571.07 34.52 570.94 34.35 570.83 34.17C570.77 34.08 570.74 33.9701 570.72 33.8701C570.61 33.8201 570.53 33.7401 570.48 33.6301C570.41 33.4701 570.36 33.2901 570.34 33.1201C570.24 33.0601 570.15 32.9801 570.07 32.8901H569.94C569.87 32.8801 569.8 32.8901 569.72 32.8901L569.64 32.92C569.64 32.92 569.55 32.95 569.5 32.97C569.42 33.12 569.28 33.2301 569.11 33.2601C569.02 33.2701 568.93 33.26 568.85 33.22C568.76 33.26 568.67 33.2901 568.57 33.3101C568.38 33.3401 568.18 33.3201 568 33.2501C567.97 33.2401 567.92 33.22 567.89 33.22C567.82 33.25 567.75 33.2801 567.7 33.3101C567.58 33.3701 567.46 33.4201 567.33 33.4501C567.2 33.5001 567.05 33.48 566.93 33.41C566.81 33.34 566.73 33.2101 566.72 33.0701C566.69 33.1701 566.63 33.2601 566.55 33.3201C566.47 33.3701 566.38 33.4001 566.28 33.3901C566.21 33.5101 566.11 33.6001 565.99 33.6501C565.99 33.6501 565.94 33.7101 565.91 33.7401C565.88 33.7801 565.84 33.8101 565.8 33.8401C565.67 33.9301 565.5 33.9501 565.35 33.8901C565.19 33.8301 565.08 33.6801 565.07 33.5101C565.07 33.4501 565.07 33.3901 565.09 33.3301C565.09 33.2901 565.09 33.2401 565.09 33.1901C564.99 33.1701 564.89 33.15 564.79 33.11C564.72 33.11 564.66 33.11 564.59 33.11C564.48 33.12 564.36 33.13 564.25 33.11C564.19 33.11 564.12 33.1001 564.05 33.0901C564 33.2901 563.88 33.45 563.71 33.54C563.53 33.63 563.32 33.63 563.15 33.54C563.01 33.46 562.89 33.3601 562.79 33.2401L562.77 33.2701C562.77 33.2701 562.73 33.3401 562.71 33.3801C562.71 33.4401 562.71 33.49 562.71 33.55C562.72 33.68 562.71 33.8101 562.71 33.9301C562.69 34.0201 562.69 34.0901 562.69 34.1301C562.69 34.2901 562.62 34.4501 562.5 34.5601C562.44 34.6001 562.37 34.6301 562.3 34.6501C562.27 34.6701 562.25 34.7 562.22 34.72C562.22 34.95 562.08 35.17 561.88 35.29C561.68 35.4 561.44 35.3901 561.26 35.2601C561.09 35.1301 560.97 34.9301 560.94 34.7101C560.84 34.6801 560.74 34.6301 560.66 34.5601C560.56 34.6001 560.44 34.62 560.33 34.61C560.16 34.59 559.99 34.53 559.86 34.42C559.75 34.48 559.63 34.5401 559.51 34.5901L559.38 34.6501C559.24 34.7101 559.08 34.7101 558.94 34.6401C558.87 34.6001 558.81 34.54 558.76 34.47C558.62 34.48 558.49 34.4301 558.39 34.3301C558.26 34.2101 558.19 34.0401 558.2 33.8701V33.8301C558.1 34.0101 557.91 34.1101 557.71 34.0901C557.24 34.0501 557.28 33.5401 557.29 33.3701C557.3 33.2401 557.3 33.11 557.29 32.98C557.27 32.92 557.25 32.8701 557.22 32.8101C557.16 32.6901 557.12 32.5601 557.09 32.4301C557.09 32.4301 557.04 32.38 557.02 32.35C556.9 32.23 556.82 32.0901 556.77 31.9301C556.75 31.8501 556.73 31.7601 556.72 31.6801C556.7 31.6001 556.69 31.52 556.67 31.47C556.59 31.37 556.56 31.24 556.58 31.11C556.6 30.98 556.68 30.8801 556.79 30.8101C556.94 30.7301 557.1 30.68 557.27 30.66C557.33 30.66 557.38 30.6401 557.44 30.6301C557.6 30.5201 557.81 30.52 557.98 30.61C558.38 30.93 558.45 31.51 558.14 31.92L558.2 31.9501C558.26 31.9801 558.32 32.01 558.38 32.05C558.4 32.06 558.43 32.09 558.46 32.1L558.5 32.0701C558.6 31.9601 558.72 31.87 558.85 31.8C558.93 31.76 559.01 31.7301 559.1 31.7001C559.18 31.6801 559.26 31.64 559.33 31.6C559.45 31.52 559.58 31.45 559.72 31.41L559.74 31.35C559.74 31.35 559.77 31.26 559.78 31.22C559.78 31.22 559.76 31.1601 559.75 31.1401C559.69 31.0401 559.66 30.9201 559.66 30.8101C559.65 30.6001 559.69 30.4001 559.78 30.2101C559.78 30.2101 559.79 30.1901 559.8 30.1801C559.85 30.1001 559.92 30.0301 560.01 30.0001C560.03 29.9401 560.07 29.8801 560.11 29.8201C560.22 29.6801 560.37 29.5701 560.55 29.5001C560.59 29.4801 560.64 29.4601 560.68 29.4301C560.73 29.3501 560.77 29.26 560.81 29.17C560.85 29.09 560.88 29.0101 560.92 28.9401C560.98 28.8201 561.01 28.69 561.01 28.55C561.03 28.31 561.22 28.13 561.46 28.11C561.53 28.11 561.59 28.1101 561.65 28.1401C561.68 28.0801 561.72 28.03 561.76 27.97C561.98 27.72 562.29 27.5801 562.62 27.5701C562.85 27.6001 563.06 27.7301 563.18 27.9301C563.25 27.8801 563.32 27.8301 563.4 27.7801C563.49 27.7301 563.59 27.7 563.7 27.67C563.75 27.66 563.79 27.6501 563.83 27.6301C563.83 27.6301 563.87 27.5501 563.89 27.5101C563.94 27.4001 564 27.3001 564.07 27.2101C564.05 27.2201 564.05 27.1901 564.06 27.1501C564.06 26.9701 564.13 26.8001 564.24 26.6501C564.35 26.5201 564.48 26.4201 564.63 26.3401C564.67 26.3201 564.71 26.3001 564.74 26.2701C564.87 26.1701 565.04 26.13 565.2 26.17C565.43 26.23 565.63 26.3801 565.75 26.5901C565.76 26.5801 565.77 26.56 565.79 26.55C565.98 26.29 566.23 26.0801 566.52 25.9401C566.54 25.9401 566.56 25.93 566.58 25.92C566.71 25.89 566.85 25.9201 566.95 26.0101C567.01 26.0601 567.06 26.1301 567.09 26.2001H567.11C567.19 26.2201 567.26 26.22 567.34 26.22C567.33 26.22 567.39 26.1601 567.43 26.1201C567.59 25.9501 567.79 25.83 568.02 25.79C568.27 25.79 568.52 25.87 568.71 26.05C568.74 26.08 568.77 26.1001 568.81 26.1201C568.81 26.1201 568.86 26.1201 568.92 26.1201C569.12 26.1101 569.32 26.1601 569.49 26.2601H569.5C569.7 26.1501 569.91 26.1001 570.13 26.0901C570.19 26.0901 570.26 26.0801 570.32 26.0701C570.4 26.0401 570.48 26.0001 570.55 25.9601C570.76 25.8201 571.02 25.7701 571.26 25.8401C571.55 25.9801 571.71 26.29 571.65 26.61C571.65 26.67 571.65 26.73 571.65 26.8C571.67 26.84 571.7 26.88 571.72 26.92C571.81 27.05 571.89 27.2 571.94 27.35H571.97C571.97 27.35 572.06 27.4001 572.11 27.4301C572.19 27.4801 572.19 27.48 572.26 27.47C572.52 27.43 572.78 27.43 573.04 27.47C573.32 27.53 573.56 27.6901 573.72 27.9301C573.74 27.9601 573.76 27.9901 573.79 28.0101C573.85 28.0701 573.93 28.16 574 28.22C574.14 28.1 574.32 28.01 574.5 27.98C574.79 27.95 575.12 27.9201 575.31 28.1801C575.34 28.2201 575.37 28.2701 575.38 28.3201L575.43 28.35C575.52 28.4 575.61 28.4501 575.7 28.5101C575.77 28.5501 575.84 28.6001 575.91 28.6401C575.99 28.6901 576.07 28.75 576.16 28.8C576.44 28.95 576.63 29.23 576.67 29.55C576.68 29.69 576.67 29.8301 576.61 29.9601C576.73 30.0301 576.83 30.1501 576.87 30.2801C576.93 30.5101 576.9 30.7501 576.79 30.9501C576.77 30.9901 576.76 31.0301 576.74 31.0701C576.74 31.0701 576.75 31.09 576.76 31.1C576.94 31.1 577.11 31.2201 577.17 31.3901C577.19 31.4401 577.2 31.49 577.2 31.55C577.2 31.58 577.2 31.6001 577.2 31.6201C577.2 31.6601 577.2 31.7001 577.2 31.7401C577.34 31.8601 577.43 32.04 577.45 32.23C577.45 32.33 577.45 32.4301 577.42 32.5301C577.5 32.6501 577.55 32.8001 577.56 32.9401L577.58 32.9601C577.8 33.1001 577.93 33.3601 577.9 33.6201C577.88 33.7401 577.83 33.8501 577.75 33.9401C578.28 34.0601 578.53 34.28 578.52 34.6C578.52 34.73 578.47 34.8501 578.38 34.9401C578.48 35.1001 578.57 35.2701 578.64 35.4401C578.7 35.6201 578.7 35.8101 578.64 35.9901C578.64 36.0201 578.62 36.0601 578.62 36.0901C578.62 36.1301 578.64 36.18 578.66 36.23C578.7 36.35 578.72 36.47 578.73 36.6C578.74 36.62 578.76 36.64 578.78 36.67C578.93 36.84 579 37.0501 579 37.2701C578.97 37.4701 578.86 37.66 578.71 37.8C578.88 37.99 578.94 38.24 578.88 38.48C578.82 38.72 578.63 38.91 578.4 38.98H578.37V39.0301C578.41 39.1801 578.4 39.33 578.37 39.47C578.33 39.61 578.26 39.7501 578.18 39.8801C578.27 39.9101 578.35 39.94 578.43 39.98C578.55 40.04 578.63 40.1401 578.67 40.2701C578.69 40.3401 578.69 40.41 578.67 40.47C578.74 40.54 578.77 40.6401 578.78 40.7401C578.78 40.8401 578.76 40.94 578.73 41.04C578.73 41.08 578.72 41.1401 578.71 41.1801C578.7 41.3101 578.67 41.4401 578.64 41.5701C578.66 41.6101 578.67 41.6601 578.68 41.7001C578.69 41.7401 578.7 41.7801 578.72 41.8201C578.79 42.0001 578.81 42.2001 578.79 42.3901C578.77 42.5501 578.72 42.71 578.65 42.86C578.67 42.87 578.69 42.8801 578.71 42.9001C578.83 42.9901 578.9 43.13 578.89 43.29C578.88 43.49 578.81 43.6801 578.7 43.8401V43.86C578.78 44.03 578.81 44.2201 578.78 44.4001C578.74 44.6701 578.62 44.9301 578.44 45.1401C578.33 45.2501 578.18 45.31 578.03 45.3C578.12 45.38 578.19 45.4701 578.24 45.5801C578.27 45.6201 578.3 45.6601 578.34 45.7001C578.46 45.8301 578.56 45.9801 578.62 46.1401C578.67 46.3501 578.64 46.5801 578.54 46.7801C578.52 46.8201 578.51 46.8601 578.5 46.9001C578.5 46.9101 578.51 46.94 578.52 46.98C578.57 46.98 578.63 46.9801 578.68 47.0001C578.83 47.0401 578.95 47.1601 579 47.3101C579.04 47.4601 579 47.62 578.91 47.73C578.99 47.92 578.99 48.1301 578.91 48.3301C578.91 48.3101 578.93 48.3601 578.94 48.3901C578.97 48.4701 578.98 48.5401 579 48.6201C579.01 48.7001 579 48.7901 579 48.8701C579.13 49.0301 579.19 49.2301 579.17 49.4301C579.21 49.6801 579.1 49.9301 578.9 50.0801C578.74 50.1701 578.56 50.2101 578.38 50.1901C578.37 50.2201 578.36 50.2501 578.35 50.2801C578.33 50.3501 578.3 50.4301 578.27 50.4901C578.22 50.6001 578.15 50.7101 578.07 50.8101C578.04 50.8501 578.01 50.88 577.99 50.92C577.99 50.97 577.98 51.0201 577.98 51.0801C577.98 51.1301 577.98 51.18 577.98 51.23C578.27 51.12 578.59 51.2301 578.76 51.4901C578.95 51.8201 578.94 52.22 578.73 52.54C578.7 52.58 578.65 52.6801 578.59 52.7801C578.53 52.8801 578.48 52.97 578.44 53.04C578.59 53.14 578.67 53.3201 578.64 53.5001C578.71 53.7201 578.64 53.9601 578.47 54.1201C578.41 54.1801 578.35 54.2501 578.3 54.3201C578.23 54.4101 578.16 54.5001 578.08 54.5801C578.14 54.6201 578.19 54.67 578.23 54.73C578.34 54.92 578.34 55.1501 578.21 55.3301C578.24 55.3701 578.25 55.42 578.27 55.47C578.28 55.53 578.28 55.5901 578.27 55.6501C578.27 55.8201 578.2 55.9901 578.05 56.0901C578.05 56.1001 578.02 56.13 578 56.16C577.78 56.59 577.28 56.78 576.83 56.61C576.78 56.6 576.72 56.5801 576.67 56.5801C576.53 56.5801 576.39 56.5801 576.25 56.5801H576.09C576.03 56.6001 575.98 56.6201 575.92 56.6501C575.85 56.6901 575.78 56.7201 575.7 56.7501C575.67 56.7601 575.64 56.7701 575.61 56.7801C575.59 56.7801 575.57 56.7801 575.55 56.7801L575.6 56.7601ZM574.94 55.4601C575.13 55.4601 575.32 55.5501 575.46 55.6801C575.49 55.7001 575.51 55.7201 575.54 55.7401C575.57 55.7501 575.59 55.7701 575.62 55.7801C575.64 55.7701 575.67 55.7601 575.7 55.7401C575.7 55.7201 575.69 55.7001 575.69 55.6901C575.69 55.4201 575.77 55.1601 575.93 54.9501C576.01 54.8201 576.15 54.74 576.3 54.72C576.49 54.72 576.68 54.7901 576.81 54.9301C576.81 54.8501 576.81 54.7801 576.82 54.7101C576.87 54.4101 577.07 54.1501 577.34 54.0201C577.38 54.0001 577.41 53.9701 577.45 53.9501C577.51 53.8901 577.56 53.8301 577.61 53.7601L577.66 53.6901C577.52 53.6601 577.41 53.5701 577.34 53.4501V53.4301H577.3C577.3 53.4301 577.21 53.47 577.16 53.48C576.81 53.63 576.59 53.3301 576.48 53.1901C576.33 53.0301 576.31 52.79 576.43 52.61C576.46 52.55 576.49 52.4401 576.52 52.3301C576.56 52.0801 576.67 51.85 576.83 51.66C576.92 51.58 577.03 51.54 577.15 51.55C577.09 51.44 577.08 51.3101 577.11 51.1801C577.12 51.1201 577.13 51.0701 577.13 51.0101V50.9501L577.03 51.0901C576.97 51.1701 576.9 51.2501 576.89 51.2701C576.82 51.3501 576.72 51.4 576.61 51.42C576.61 51.47 576.61 51.5101 576.61 51.5601C576.58 51.7401 576.47 51.8801 576.31 51.9601C576.14 52.0601 575.93 52.0701 575.74 51.9901C575.6 51.9301 575.42 51.78 575.46 51.29C575.48 51.12 575.57 50.9601 575.72 50.8701C575.72 50.8601 575.72 50.8401 575.72 50.8301C575.72 50.7601 575.75 50.6901 575.78 50.6301C575.83 50.4401 576 50.31 576.2 50.3C576.33 50.23 576.49 50.2 576.64 50.23C576.67 50.23 576.7 50.22 576.73 50.22C576.71 50.22 576.69 50.2101 576.67 50.2001C576.59 50.1701 576.52 50.12 576.48 50.05C576.44 50.03 576.4 50 576.37 49.97C576.2 49.8 576.19 49.53 576.35 49.35C576.46 49.24 576.6 49.1801 576.75 49.1901C576.78 49.1901 576.8 49.1901 576.83 49.2001C577 49.1801 577.18 49.2501 577.27 49.4001C577.36 49.5501 577.37 49.7401 577.27 49.8901C577.25 49.9601 577.22 50.0201 577.17 50.0801C577.09 50.1701 576.99 50.2201 576.87 50.2401H576.91C577.06 50.2901 577.18 50.4 577.22 50.55C577.27 50.44 577.34 50.3301 577.42 50.2401C577.45 50.2101 577.47 50.1701 577.5 50.1301C577.52 50.0901 577.53 50.0401 577.55 50.0001C577.6 49.8201 577.68 49.6601 577.78 49.5101C577.89 49.3801 578.05 49.3 578.22 49.29C578.14 49.12 578.12 48.9401 578.16 48.7601C578.16 48.7201 578.16 48.6801 578.14 48.6501C578.06 48.4401 578.06 48.2201 578.13 48.0101C578.13 48.0301 578.09 47.9701 578.07 47.9301C578 47.9001 577.94 47.8701 577.89 47.8301C577.78 47.7301 577.72 47.5801 577.74 47.4301C577.74 47.3601 577.73 47.29 577.71 47.22C577.69 47.13 577.67 47.0401 577.66 46.9501C577.66 46.7801 577.69 46.6001 577.76 46.4401L577.79 46.3701C577.79 46.3701 577.74 46.31 577.72 46.29C577.67 46.23 577.62 46.17 577.57 46.11C577.42 46.19 577.23 46.21 577.07 46.16C576.97 46.24 576.85 46.2701 576.73 46.2601C576.56 46.2301 576.41 46.12 576.33 45.97C576.23 45.8 576.21 45.59 576.29 45.41C576.32 45.33 576.42 45.11 576.9 45.1C576.94 45.06 576.99 45.0301 577.04 45.0001C577.05 44.9401 577.07 44.8901 577.09 44.8401C577.1 44.7901 577.12 44.7501 577.13 44.7101C577.06 44.6701 576.99 44.64 576.92 44.6C576.86 44.56 576.81 44.5001 576.78 44.4301C576.68 44.3701 576.6 44.27 576.56 44.16C576.53 44.07 576.54 43.9801 576.56 43.9001C576.61 43.7701 576.68 43.65 576.77 43.54C576.8 43.5 576.82 43.4701 576.84 43.4401C576.7 43.4401 576.58 43.3601 576.5 43.2401C576.42 43.1201 576.4 42.98 576.44 42.85C576.44 42.75 576.47 42.6601 576.51 42.5701C576.52 42.4701 576.55 42.3701 576.59 42.2801C576.6 42.2501 576.62 42.2201 576.64 42.1901C576.73 42.0601 576.88 41.9901 577.04 42.0001C577.05 41.9801 577.06 41.9701 577.08 41.9501C577.11 41.9101 577.2 41.8301 577.28 41.7401L577.32 41.7001C577.21 41.6701 577.12 41.64 577.03 41.61C576.99 41.6 576.96 41.5801 576.92 41.5701C576.81 41.5901 576.69 41.5701 576.6 41.5101C576.57 41.4901 576.54 41.4701 576.51 41.4401C576.5 41.4301 576.49 41.4201 576.48 41.4001C576.39 41.2901 576.36 41.1401 576.38 41.0001C576.39 40.7701 576.51 40.5601 576.7 40.4301C576.73 40.4101 576.75 40.38 576.77 40.35C576.89 40.17 577.06 40.0401 577.25 39.9601C577.28 39.7601 577.36 39.58 577.47 39.41C577.51 39.35 577.54 39.3001 577.56 39.2401C577.56 39.2301 577.55 39.1901 577.54 39.1501C577.51 38.9901 577.51 38.8301 577.54 38.6801C577.61 38.4701 577.76 38.3001 577.96 38.2101C577.85 38.0501 577.8 37.86 577.82 37.66C577.86 37.48 577.96 37.3101 578.1 37.1801C577.98 37.0301 577.9 36.85 577.89 36.66C577.89 36.59 577.87 36.53 577.85 36.47C577.83 36.39 577.81 36.3001 577.79 36.2101C577.77 36.0701 577.79 35.93 577.82 35.79C577.82 35.76 577.83 35.7301 577.84 35.7001C577.81 35.6501 577.73 35.51 577.63 35.35C577.52 35.17 577.44 34.9701 577.39 34.7601C577.13 34.7101 576.9 34.57 576.75 34.35C576.66 34.19 576.64 34.0001 576.7 33.8301C576.74 33.7101 576.81 33.6001 576.9 33.5201C576.86 33.4801 576.83 33.4301 576.8 33.3901C576.76 33.3101 576.73 33.2301 576.71 33.1401C576.69 33.1701 576.67 33.19 576.64 33.22C576.47 33.35 576.27 33.4501 576.06 33.4901C576.01 33.5001 575.95 33.52 575.9 33.54C575.76 33.61 575.59 33.5901 575.46 33.5001C575.43 33.4801 575.38 33.45 575.33 33.42C575.1 33.29 574.9 33.1701 574.83 32.9401C574.76 32.7101 574.87 32.4601 575.1 32.3701C575.03 32.3201 574.97 32.2501 574.91 32.1801C574.84 32.0801 574.81 31.9601 574.83 31.8401C574.85 31.7201 574.92 31.62 575.02 31.55C575.03 31.54 575.05 31.5201 575.07 31.5001C575.19 31.3201 575.39 31.2101 575.6 31.2001C575.74 31.2001 575.87 31.2801 575.95 31.3901C575.91 31.3101 575.89 31.2201 575.88 31.1401C575.86 31.0001 575.88 30.85 575.94 30.72C575.92 30.72 575.89 30.7201 575.87 30.7101C575.7 30.6801 575.56 30.5501 575.52 30.3901C575.5 30.1101 575.6 29.8401 575.79 29.6401C575.81 29.6401 575.79 29.6101 575.76 29.5901C575.65 29.5301 575.55 29.4601 575.45 29.4001C575.39 29.3601 575.33 29.3201 575.27 29.2801C575.22 29.2501 575.17 29.2201 575.12 29.1901C574.95 29.2701 574.75 29.24 574.61 29.11C574.57 29.07 574.54 29.03 574.51 28.98C574.33 29.14 574.09 29.2001 573.85 29.1501C573.58 29.0401 573.35 28.8601 573.17 28.6401C573.12 28.5901 573.08 28.5401 573.04 28.5001C573 28.4501 572.96 28.4 572.91 28.36C572.82 28.35 572.73 28.35 572.63 28.36C572.72 28.46 572.76 28.59 572.75 28.72C572.75 28.85 572.68 28.9701 572.58 29.0601C572.47 29.1401 572.34 29.1701 572.21 29.1501C572.04 29.1601 571.88 29.0801 571.79 28.9401V28.92C571.79 28.92 571.74 28.88 571.73 28.85C571.61 28.94 571.45 28.9701 571.31 28.9501C571.08 28.9501 570.87 28.8301 570.76 28.6401C570.7 28.4301 570.71 28.2101 570.8 28.0101L570.82 27.9501C570.82 27.9501 570.82 27.92 570.83 27.91C570.71 27.91 570.59 27.88 570.5 27.8C570.41 27.72 570.35 27.6101 570.35 27.4901C570.35 27.4701 570.34 27.4301 570.33 27.3901C570.3 27.3001 570.29 27.2 570.3 27.1C570.3 27.06 570.3 27.0301 570.32 27.0001C570.28 27.0001 570.25 27.0001 570.21 27.0101C570.13 27.0101 570.04 27.03 569.96 27.05C569.92 27.07 569.89 27.1001 569.86 27.1201C569.73 27.2401 569.56 27.3001 569.39 27.2801C569.32 27.2801 569.25 27.2501 569.19 27.2101C569.26 27.2901 569.31 27.38 569.36 27.48C569.39 27.48 569.41 27.4801 569.44 27.4901C569.42 27.4901 569.48 27.4901 569.54 27.4901C569.63 27.4901 569.73 27.5001 569.82 27.5101C569.95 27.5401 570.06 27.6301 570.12 27.7501C570.18 27.8701 570.18 28.0101 570.12 28.1301C570.08 28.2001 570.04 28.2601 569.99 28.3201L569.93 28.4001C569.83 28.5601 569.64 28.65 569.45 28.6C569.41 28.65 569.37 28.6901 569.31 28.7101C569.03 28.8701 568.68 28.8201 568.45 28.5801C568.45 28.5801 568.43 28.5801 568.41 28.5601C568.24 28.4601 568.1 28.3101 568.04 28.1201C568.02 27.7001 568.13 27.2901 568.36 26.9301L568.38 26.91C568.3 26.87 568.23 26.8101 568.17 26.7601L568.12 26.72C568.12 26.72 568.08 26.7601 568.06 26.7801C567.91 26.9401 567.73 27.05 567.52 27.1C567.35 27.12 567.18 27.12 567.02 27.1C566.94 27.09 566.87 27.0801 566.79 27.0801C566.71 27.0901 566.63 27.0801 566.56 27.0601C566.54 27.0901 566.51 27.1201 566.48 27.1501C566.48 27.1601 566.45 27.25 566.44 27.3C566.39 27.49 566.29 27.85 565.92 27.91C565.73 27.95 565.53 27.91 565.38 27.79C565.23 27.67 565.13 27.49 565.12 27.29C565.11 27.24 565.09 27.2 565.06 27.16C565.03 27.18 565.01 27.1901 564.99 27.2101C564.99 27.2301 564.99 27.2601 564.99 27.2801C564.99 27.4601 564.92 27.64 564.81 27.79C564.78 27.84 564.75 27.8901 564.73 27.9401C564.68 28.0401 564.62 28.14 564.56 28.23C564.66 28.2 564.78 28.2 564.88 28.23C564.91 28.24 564.94 28.2501 564.97 28.2701C565.02 28.2101 565.08 28.15 565.14 28.1C565.25 28.01 565.39 27.9701 565.52 28.0001C565.66 28.0301 565.77 28.1201 565.83 28.2401L565.89 28.35C566.03 28.61 566.14 28.8101 566.1 29.0001C566.1 29.1101 566.1 29.24 566.1 29.41C566.1 29.47 566.08 29.5301 566.07 29.5801C566.09 29.5801 566.11 29.5801 566.13 29.5801C566.16 29.5801 566.19 29.5801 566.22 29.5801C566.35 29.5601 566.49 29.5601 566.62 29.5801C566.76 29.6201 566.89 29.6801 567 29.7701C567.03 29.7901 567.06 29.8101 567.09 29.8301C567.35 29.9601 567.57 30.1501 567.72 30.3901C567.82 30.5601 567.86 30.77 567.82 30.97C567.82 31 567.82 31.02 567.82 31.05C567.84 31.07 567.86 31.09 567.88 31.11C568 31.21 568.1 31.34 568.16 31.48C568.23 31.66 568.29 31.8401 568.34 32.0201C568.37 32.1401 568.39 32.2701 568.38 32.4001C568.4 32.4001 568.42 32.41 568.45 32.42C568.5 32.4 568.54 32.3901 568.58 32.3701C568.7 32.3101 568.84 32.2801 568.97 32.2801C569.1 32.1801 569.25 32.1101 569.41 32.0601C569.56 32.0101 569.71 31.98 569.87 31.98C569.85 31.94 569.83 31.9101 569.81 31.8701C569.78 31.8501 569.75 31.8401 569.71 31.8201C569.51 31.7401 569.34 31.6101 569.22 31.4301C569.13 31.2601 569.09 31.06 569.09 30.86C569.09 30.82 569.09 30.77 569.09 30.73C569.05 30.66 569 30.59 568.93 30.54C568.81 30.44 568.74 30.2901 568.76 30.1401C568.77 29.9901 568.86 29.8501 568.99 29.7801C569.04 29.7401 569.08 29.6901 569.11 29.6401C569.23 29.4701 569.38 29.3301 569.56 29.2401C569.72 29.1701 569.9 29.2001 570.04 29.3101C570.53 29.7201 570.46 29.9901 570.43 30.0801C570.41 30.1301 570.39 30.18 570.37 30.22C570.33 30.28 570.31 30.3601 570.32 30.4301C570.35 30.5501 570.38 30.6601 570.4 30.7801C570.41 30.8701 570.43 30.95 570.45 31.04C570.48 31.06 570.52 31.09 570.55 31.11C570.71 31.22 570.83 31.3801 570.9 31.5601C570.95 31.7001 570.96 31.8501 570.94 32.0001C570.96 32.0201 570.98 32.04 571 32.05C571.11 32.14 571.17 32.27 571.17 32.41C571.17 32.45 571.17 32.4901 571.15 32.5201C571.17 32.5401 571.18 32.5601 571.19 32.5701C571.24 32.6501 571.27 32.7301 571.28 32.8201C571.34 32.8201 571.39 32.8201 571.45 32.8201C571.5 32.8201 571.55 32.8201 571.59 32.8201C571.68 32.7801 571.77 32.7501 571.87 32.7101C571.94 32.6901 572.01 32.6601 572.09 32.6301C572.15 32.6001 572.2 32.5701 572.25 32.5301C572.34 32.4701 572.44 32.41 572.54 32.36C572.58 32.34 572.61 32.3301 572.65 32.3201C572.61 32.1801 572.63 32.03 572.72 31.92C572.68 31.88 572.65 31.8301 572.62 31.7701C572.55 31.5901 572.59 31.38 572.72 31.23C572.97 30.88 573.16 30.85 573.31 30.86C573.45 30.87 573.59 30.9501 573.68 31.0601C573.81 31.0801 573.92 31.1301 574.02 31.2101C574.35 31.4801 574.38 31.67 574.36 31.8C574.33 31.99 574.21 32.14 574.04 32.22C573.91 32.29 573.77 32.31 573.63 32.3C573.76 32.49 573.79 32.7301 573.73 32.9501C573.79 33.0201 573.86 33.1001 573.94 33.2001C573.96 33.2201 573.97 33.2501 573.99 33.2701C574.04 33.2401 574.11 33.22 574.17 33.22C574.28 33.16 574.42 33.1601 574.53 33.2001C574.62 33.2301 574.69 33.2901 574.74 33.3701C574.82 33.4201 574.88 33.4901 574.91 33.5801C574.97 33.7301 574.95 33.8901 574.85 34.0201C574.75 34.1601 574.59 34.2301 574.42 34.2001C574.4 34.2001 574.38 34.2001 574.36 34.2001C574.35 34.2001 574.33 34.2001 574.32 34.2001C574.32 34.2401 574.3 34.2801 574.29 34.3101C574.3 34.3301 574.31 34.3501 574.32 34.3701C574.52 34.5201 574.59 34.7901 574.49 35.0101C574.48 35.0401 574.46 35.0601 574.44 35.0901C574.44 35.1001 574.45 35.1201 574.46 35.1301C574.49 35.2401 574.54 35.3501 574.6 35.4501C574.66 35.5601 574.72 35.67 574.76 35.79C574.81 35.86 574.84 35.95 574.84 36.05C574.84 36.27 574.69 36.4501 574.48 36.5001C574.42 36.5101 574.35 36.5201 574.29 36.5001C574.29 36.5201 574.29 36.53 574.29 36.55C574.28 36.73 574.15 36.8901 573.98 36.9501C573.92 36.9701 573.85 36.98 573.78 36.97C573.63 36.98 573.49 36.91 573.4 36.79C573.37 36.75 573.31 36.6901 573.25 36.6201C573.16 36.5301 573.08 36.4401 573.03 36.3801C573.02 36.3601 573.01 36.3501 573 36.3301C572.78 35.9301 573.11 35.3801 573.36 35.1801C573.38 35.1701 573.39 35.1501 573.41 35.1401V35.11C573.19 35.05 572.98 34.9501 572.93 34.7001C572.84 34.7001 572.75 34.69 572.67 34.67C572.63 34.67 572.59 34.6601 572.56 34.6501C572.68 34.8501 572.76 35.0801 572.79 35.3101C572.79 35.6101 572.62 35.8801 572.35 36.0101C572.32 36.0301 572.29 36.0501 572.26 36.0701C572.29 36.2201 572.34 36.3701 572.41 36.5001C572.45 36.5401 572.5 36.5801 572.54 36.6201C572.61 36.6901 572.69 36.7601 572.77 36.8301C572.81 36.8501 572.86 36.8701 572.9 36.8801C573.04 36.9201 573.17 36.9901 573.28 37.0701C573.33 37.1001 573.38 37.14 573.43 37.16C573.47 37.18 573.51 37.21 573.55 37.23C573.57 37.17 573.6 37.1201 573.64 37.0801C573.77 36.9501 573.95 36.9101 574.12 36.9601H574.15C574.15 36.9601 574.23 36.9001 574.26 36.8701C574.46 36.7301 574.74 36.7701 574.88 36.9601C575.03 37.1601 574.99 37.4301 574.8 37.5801L574.74 37.6301C574.68 37.6801 574.61 37.7201 574.54 37.7501C574.52 37.7601 574.49 37.78 574.46 37.79C574.61 37.9 574.71 38.0801 574.73 38.2701C574.73 38.2801 574.76 38.3401 574.77 38.3701C574.8 38.4401 574.83 38.52 574.85 38.6C575 38.65 575.11 38.76 575.15 38.91C575.17 38.97 575.17 39.04 575.15 39.1C575.15 39.1 575.15 39.1501 575.16 39.1801C575.18 39.2901 575.18 39.4101 575.16 39.5301C575.13 39.7301 574.96 39.8801 574.76 39.9001C574.81 39.9401 574.86 39.9801 574.91 40.0301C575.03 40.0001 575.15 39.9901 575.27 40.0001C575.47 40.0001 575.65 40.1301 575.73 40.3101C575.78 40.4901 575.73 40.6801 575.61 40.8201C575.39 41.0901 575.22 41.19 575.01 41.16C574.99 41.16 574.97 41.1601 574.95 41.1501C575 41.3101 575 41.4801 574.95 41.6401C574.93 41.7001 574.91 41.7601 574.88 41.8101C574.9 41.8301 574.93 41.8601 574.95 41.8901C574.98 41.9301 575.01 41.9701 575.03 42.0201C575.08 42.1601 575.06 42.3201 574.98 42.4501C574.9 42.5601 574.78 42.6301 574.64 42.6401C574.5 42.6401 574.37 42.6001 574.28 42.5001H574.27C574.27 42.5001 574.23 42.4701 574.22 42.4601C574.19 42.4801 574.16 42.5001 574.13 42.5301C574.04 42.5901 573.95 42.66 573.87 42.72L573.82 42.7601C573.74 42.8201 573.67 42.8801 573.6 42.9401C573.6 42.9701 573.6 43.0001 573.6 43.0301C573.63 43.1901 573.62 43.3601 573.57 43.5201C573.51 43.6701 573.41 43.8001 573.28 43.8801H573.34C573.43 43.8601 573.51 43.8601 573.6 43.8701C573.62 43.8701 573.63 43.8701 573.65 43.8701C573.86 43.7801 574.1 43.85 574.22 44.04C574.32 44.03 574.42 44.0401 574.52 44.0701C574.6 44.0701 574.68 44.0901 574.75 44.1401C574.87 44.2201 574.95 44.3501 574.96 44.4901C575.04 44.6901 574.96 44.93 574.79 45.05C574.73 45.09 574.66 45.1201 574.58 45.1301C574.55 45.2001 574.51 45.2701 574.45 45.3301C574.41 45.3601 574.37 45.39 574.33 45.41C574.37 45.43 574.41 45.4601 574.45 45.4901C574.6 45.6301 574.64 45.86 574.54 46.04C574.54 46.05 574.53 46.0601 574.52 46.0801C574.66 46.0701 574.79 46.1301 574.87 46.2501C574.97 46.3901 575.06 46.5401 575.12 46.7001C575.14 46.7601 575.17 46.81 575.2 46.86C575.23 46.88 575.27 46.91 575.3 46.92C575.38 46.97 575.46 47.0201 575.53 47.0901C575.73 47.0101 575.96 47.0701 576.08 47.2501C576.19 47.4401 576.24 47.6601 576.21 47.8801C576.21 47.9101 576.21 47.95 576.21 47.98C576.29 48.2 576.21 48.4501 576.02 48.5901C575.96 48.6401 575.89 48.6801 575.81 48.7001C575.77 48.7401 575.73 48.7901 575.69 48.8201C575.86 48.9301 575.94 49.1501 575.87 49.3401C575.83 49.4501 575.79 49.5801 575.75 49.7101L575.71 49.8401C575.69 49.9101 575.65 49.9701 575.61 50.0301C575.64 50.0701 575.67 50.11 575.69 50.16C575.73 50.27 575.71 50.4001 575.66 50.5101C575.65 50.6401 575.61 50.7601 575.55 50.8701C575.45 51.0001 575.39 51.0901 575.36 51.1501C575.44 51.4001 575.41 51.68 575.28 51.91C575.41 52.01 575.51 52.1501 575.55 52.3101C575.58 52.3801 575.61 52.4501 575.64 52.5201C575.68 52.6001 575.71 52.6801 575.74 52.7601C575.8 52.8701 575.81 53.0101 575.76 53.1301C575.73 53.1901 575.69 53.24 575.64 53.29C575.59 53.39 575.51 53.4701 575.41 53.5101C575.29 53.5601 575.16 53.5601 575.05 53.5101H575.02C575.04 53.5901 575.02 53.6901 574.98 53.7801C575.08 53.8401 575.17 53.9201 575.25 54.0001C575.39 54.1201 575.47 54.3001 575.47 54.4901C575.45 54.7401 575.27 54.8901 575.06 55.0701C574.99 55.1301 574.92 55.1901 574.86 55.2601C574.82 55.3101 574.77 55.3401 574.72 55.3701C574.72 55.4201 574.7 55.4701 574.69 55.5201C574.75 55.4901 574.82 55.4601 574.9 55.4501C574.94 55.4501 574.99 55.4401 575.03 55.4401L574.94 55.4601ZM577.62 52.05C577.62 52.05 577.65 52.1301 577.67 52.1901C577.7 52.2601 577.73 52.37 577.76 52.47C577.79 52.42 577.81 52.3701 577.84 52.3301C577.88 52.2601 577.91 52.2001 577.94 52.1501C577.83 52.1501 577.71 52.1201 577.62 52.0601V52.05ZM576.02 51.6L576.04 51.7001C576.15 51.6701 576.25 51.59 576.3 51.48L576.13 51.5101H576.15L576.01 51.6H576.02ZM575.85 51.2001C575.78 51.2601 575.73 51.3501 575.72 51.4501L575.84 51.47L575.97 51.3L576 51.42L576.06 51.3101C575.99 51.2901 575.92 51.2601 575.87 51.2101L575.85 51.2001ZM574.08 47.9601C574.44 48.2001 574.62 48.4501 574.62 48.7101C574.67 48.6701 574.72 48.6401 574.78 48.6201C574.78 48.5701 574.77 48.52 574.78 48.48C574.78 48.46 574.78 48.4501 574.78 48.4301V48.4001C574.65 48.3801 574.54 48.3101 574.47 48.2001C574.42 48.1301 574.36 48.0701 574.29 48.0101C574.26 47.9801 574.22 47.94 574.19 47.91C574.16 47.93 574.12 47.95 574.09 47.97L574.08 47.9601ZM573.72 46.3101C573.76 46.3701 573.78 46.4301 573.79 46.5001C573.79 46.4301 573.76 46.3701 573.72 46.3101ZM573.77 46.3101C573.78 46.3701 573.79 46.4301 573.79 46.4901C573.87 46.4601 573.95 46.46 574.03 46.47C574.04 46.41 574.06 46.35 574.1 46.3C574.08 46.3 574.07 46.3 574.05 46.3C574.04 46.3 574.02 46.3 574.01 46.3C573.94 46.32 573.86 46.32 573.78 46.3L573.77 46.3101ZM576.69 45.66L576.59 45.6901C576.63 45.7901 576.71 45.8801 576.81 45.9301C576.78 45.8701 576.76 45.8101 576.74 45.7401L576.68 45.66H576.69ZM577.03 45.4401C577.03 45.4401 577 45.5201 577 45.5601L577.1 45.5801C577.1 45.5801 577.07 45.5301 577.06 45.5101C577.06 45.4901 577.04 45.4701 577.03 45.4501V45.4401ZM575.01 40.8801C575.01 40.8801 575.04 40.9 575.06 40.91L575.03 40.73V40.7601L575 40.73C575 40.73 574.98 40.81 574.96 40.85C574.97 40.86 574.99 40.8701 575 40.8801H575.01ZM575.12 40.5801L575.35 40.7101C575.39 40.6401 575.39 40.55 575.35 40.47C575.29 40.38 575.19 40.3201 575.08 40.3101V40.42L575.24 40.54L575.12 40.5701V40.5801ZM561.54 33.98C561.54 33.98 561.6 34.0301 561.62 34.0601C561.64 34.0401 561.67 34.0101 561.7 33.9901C561.74 33.9601 561.78 33.9301 561.82 33.9001V33.86H561.81C561.71 33.88 561.6 33.8601 561.51 33.8301C561.51 33.8701 561.53 33.9101 561.53 33.9501V33.9901L561.54 33.98ZM560.4 33.6401V33.6801C560.4 33.6801 560.41 33.7001 560.42 33.7101C560.46 33.6901 560.52 33.6601 560.56 33.6401L560.68 33.5801C560.82 33.4501 561.01 33.4001 561.2 33.4301H561.23C561.23 33.4301 561.19 33.31 561.16 33.23C561.14 33.15 561.11 33.0801 561.09 33.0301C560.99 32.8701 561 32.6701 561.11 32.5201L561.13 32.1801C561.15 31.8401 561.35 31.5301 561.66 31.3801C561.82 31.2601 562.05 31.28 562.19 31.42C562.3 31.52 562.35 31.66 562.34 31.8C562.37 31.8 562.4 31.8001 562.43 31.8201C562.48 31.8301 562.52 31.8501 562.56 31.8801C562.55 31.7701 562.56 31.65 562.62 31.55C562.75 31.34 562.99 31.2301 563.24 31.2601C563.24 31.2201 563.24 31.1701 563.24 31.1301C563.24 30.9501 563.32 30.7701 563.45 30.6401C563.45 30.6101 563.44 30.58 563.43 30.55C563.41 30.42 563.39 30.3 563.39 30.17C563.39 30.1 563.37 30.04 563.35 29.97C563.31 29.84 563.29 29.7001 563.28 29.5601C563.28 29.4601 563.28 29.3501 563.3 29.2601C563.27 29.1501 563.25 29.0401 563.24 28.9301C563.13 28.9501 563.02 28.94 562.92 28.91C562.75 28.84 562.61 28.7201 562.51 28.5601V28.54H562.49C562.49 28.54 562.49 28.58 562.49 28.61C562.49 28.68 562.49 28.7901 562.49 28.9301C562.5 28.9601 562.52 28.9901 562.53 29.0201C562.61 29.1601 562.67 29.31 562.69 29.47V29.5001C562.69 29.5001 562.73 29.5501 562.74 29.5701C562.82 29.7001 562.87 29.8401 562.89 29.9901C562.92 30.2501 562.82 30.5 562.62 30.67C562.53 30.77 562.41 30.8301 562.28 30.8301C562.26 30.8301 562.24 30.8301 562.22 30.8301C562.19 30.8701 562.16 30.9001 562.13 30.9301C561.93 31.0901 561.63 31.06 561.47 30.86C561.46 30.86 561.44 30.8401 561.43 30.8301C561.27 30.6901 561.22 30.4601 561.32 30.2701C561.32 30.2201 561.3 30.1701 561.29 30.1201C561.18 30.2101 561.06 30.2901 560.93 30.3401C560.91 30.3501 560.88 30.3601 560.85 30.3801C560.85 30.4201 560.85 30.4801 560.85 30.5201C560.87 30.6701 560.85 30.8201 560.8 30.9601C560.78 31.0101 560.76 31.06 560.75 31.1C560.78 31.18 560.8 31.27 560.8 31.36C560.8 31.43 560.79 31.5001 560.77 31.5701C560.8 31.6801 560.81 31.7801 560.81 31.8901C560.81 31.9401 560.83 32 560.85 32.05C560.89 32.17 560.91 32.3 560.91 32.42C560.91 32.7 560.85 32.9801 560.74 33.2501C560.74 33.2701 560.72 33.28 560.71 33.3C560.62 33.41 560.49 33.47 560.36 33.48C560.38 33.54 560.39 33.6 560.39 33.67L560.4 33.6401ZM559.59 33.1801C559.59 33.1801 559.63 33.2401 559.64 33.2801C559.68 33.2501 559.72 33.2201 559.76 33.2001C559.82 33.1801 559.88 33.16 559.94 33.16C559.84 33.09 559.76 32.9901 559.73 32.8801C559.7 32.8001 559.68 32.7201 559.67 32.6301C559.6 32.6101 559.55 32.5701 559.5 32.5201L559.42 32.55C559.42 32.55 559.37 32.5701 559.35 32.5801C559.5 32.6301 559.6 32.7501 559.63 32.9001C559.65 32.9901 559.63 33.0901 559.59 33.1801ZM566.36 31.3C566.39 31.37 566.42 31.4401 566.44 31.5101C566.45 31.5501 566.47 31.5901 566.5 31.6301C566.59 31.7501 566.66 31.8801 566.71 32.0301C566.75 32.1501 566.78 32.28 566.79 32.41C566.79 32.48 566.81 32.5501 566.83 32.6201C566.83 32.6501 566.84 32.6801 566.84 32.7101C566.91 32.6401 566.99 32.5901 567.08 32.5701C567.14 32.5501 567.2 32.5301 567.25 32.5001C567.25 32.4801 567.27 32.4601 567.28 32.4401C567.32 32.3801 567.37 32.3101 567.42 32.2601C567.39 32.1201 567.34 31.99 567.29 31.86C567.29 31.86 567.24 31.81 567.21 31.79C567.11 31.7 567.02 31.6001 566.96 31.4901C566.87 31.3101 566.85 31.11 566.88 30.91V30.86C566.88 30.86 566.81 30.77 566.76 30.73C566.71 30.78 566.64 30.8101 566.57 30.8301V30.86C566.6 31.04 566.51 31.21 566.35 31.3H566.34H566.36ZM567.46 32.2501C567.46 32.2501 567.45 32.3001 567.45 32.3201L567.87 32.16L567.46 32.2501ZM564.78 32.2001C564.88 32.2001 564.97 32.2101 565.06 32.2401C565.06 32.2001 565.06 32.16 565.06 32.11V31.98C565.06 31.91 565.06 31.8401 565.06 31.7701C564.95 31.7401 564.86 31.6701 564.8 31.5701C564.74 31.3901 564.69 31.2101 564.66 31.0201H564.64C564.54 31.0201 564.44 30.9901 564.35 30.9601C564.33 31.0601 564.3 31.1501 564.27 31.2401C564.26 31.2701 564.25 31.3001 564.24 31.3301C564.26 31.3601 564.29 31.39 564.31 31.41C564.47 31.56 564.57 31.76 564.59 31.98C564.59 32.06 564.59 32.14 564.56 32.22C564.63 32.22 564.71 32.2101 564.78 32.2101V32.2001ZM562.94 31.6C562.91 31.69 562.92 31.8001 562.95 31.8901C563 32.0101 563.1 32.1101 563.23 32.1401C563.25 32.1301 563.28 32.12 563.3 32.1C563.26 31.96 563.23 31.82 563.23 31.67V31.5601C563.23 31.5601 563.19 31.56 563.16 31.55C563.08 31.55 563 31.5501 562.93 31.5901L562.94 31.6ZM573.55 31.9601C573.61 31.9601 573.67 31.9601 573.73 31.9401C573.84 31.9001 573.93 31.82 573.98 31.72L573.8 31.7501H573.85L573.64 31.8901C573.64 31.8901 573.58 31.9401 573.55 31.9601ZM573.05 31.72C573.05 31.72 573.09 31.72 573.12 31.72C573.12 31.66 573.12 31.6 573.12 31.54C573.12 31.43 573.16 31.32 573.23 31.23C573.23 31.23 573.16 31.18 573.12 31.17C573.03 31.21 572.96 31.2801 572.92 31.3701C572.88 31.4401 572.88 31.53 572.92 31.61C572.95 31.66 573 31.7 573.06 31.72H573.05ZM561.96 30.8301C561.96 30.8301 561.88 30.8701 561.84 30.8801C561.88 30.8701 561.92 30.8501 561.96 30.8201V30.8301ZM564.23 29.2601C564.23 29.2601 564.23 29.3301 564.24 29.3701L564.26 29.3401V29.3201C564.26 29.3201 564.24 29.2801 564.23 29.2601ZM576.05 37.8301C575.94 37.8301 575.84 37.8001 575.76 37.7401L575.7 37.7001C575.59 37.6301 575.5 37.5501 575.41 37.4501C575.32 37.3401 575.29 37.2001 575.32 37.0701C575.35 36.9401 575.44 36.8201 575.56 36.7601C575.58 36.7501 575.6 36.7301 575.62 36.7101C575.77 36.5401 576.01 36.4601 576.23 36.5101C576.44 36.5801 576.54 36.7601 576.64 36.9501C576.66 36.9801 576.67 37.0101 576.68 37.0301C576.76 37.1201 576.79 37.24 576.77 37.36C576.75 37.48 576.67 37.59 576.57 37.66C576.41 37.76 576.23 37.8101 576.04 37.8201L576.05 37.8301ZM573.11 30.29C573.03 30.29 572.95 30.27 572.88 30.23C572.67 30.11 572.65 29.92 572.63 29.67V29.6C572.59 29.5 572.61 29.39 572.66 29.29C572.71 29.2 572.8 29.13 572.91 29.1C573.03 29.06 573.17 29.06 573.29 29.1C573.31 29.1 573.28 29.1 573.23 29.1C573.42 29.08 573.61 29.18 573.69 29.35C573.75 29.43 573.8 29.52 573.83 29.61C573.89 29.85 573.74 30.0901 573.51 30.1501L573.46 30.17C573.35 30.23 573.24 30.2601 573.11 30.2701V30.29ZM567.26 29.3C567.18 29.3 567.1 29.28 567.03 29.23C566.95 29.18 566.89 29.1101 566.86 29.0201C566.76 28.9101 566.7 28.7701 566.71 28.6201C566.72 28.3901 566.88 28.2801 567.18 28.0701C567.29 28.0001 567.42 27.9701 567.55 28.0001C567.68 28.0301 567.78 28.12 567.84 28.23C567.88 28.32 567.91 28.4101 567.93 28.5001C567.94 28.5501 567.95 28.5901 567.96 28.6201C568.01 28.7301 568.02 28.8501 567.97 28.9601C567.92 29.0701 567.83 29.1601 567.72 29.2001C567.62 29.2401 567.52 29.2501 567.42 29.2501C567.37 29.2701 567.32 29.2801 567.27 29.2801L567.26 29.3Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M556.71 30.8302C556.68 30.9802 556.36 31.4202 556.53 31.5502C556.65 31.6402 557 31.5302 557.12 31.7002C557.22 31.8302 557.11 32.1302 557.21 32.2902C557.31 32.4402 557.43 32.5802 557.53 32.7302C557.63 32.8802 557.62 33.1102 557.72 33.2602C557.84 33.4102 557.97 33.5402 558.11 33.6702C558.24 33.8202 558.6 33.6702 558.74 33.7502C558.76 33.7502 558.58 33.9302 558.59 33.9402C558.76 34.0202 558.91 34.1402 559.08 34.2202C559.1 34.2202 558.94 34.1102 558.94 34.1302C558.98 34.3502 559.03 34.5802 559.06 34.7902C559.06 35.0202 559.06 35.2502 559.08 35.4902C559.14 35.6502 559.2 35.8102 559.24 35.9802C559.27 36.2002 559.5 36.3802 559.45 36.5202C559.39 36.6902 559.12 36.6502 558.95 36.7502C558.81 36.8302 558.72 37.0002 558.52 37.0802C558.29 37.1602 558.34 37.3702 558.29 37.4502C558.24 37.5402 558.06 37.6602 558.33 37.8202C558.64 38.0002 558.47 37.9202 558.32 38.1502C558.12 38.4502 557.96 38.4402 557.86 38.2302C557.74 37.9602 557.77 37.5702 557.88 38.0302C557.98 38.4202 557.83 38.5002 557.66 38.6702C557.26 39.0802 557.55 39.0402 557.82 39.0602C557.84 39.0602 557.76 38.9002 557.75 38.9202C557.69 39.1202 557.45 39.2602 557.37 39.4602C557.32 39.6802 557.28 39.9002 557.26 40.1302C557.26 40.3502 557.3 40.5702 557.37 40.7802C557.4 40.9602 557.37 41.1402 557.41 41.3102C557.44 41.4902 557.48 41.6602 557.56 41.8202C557.63 41.9702 557.64 42.2102 557.79 42.3402C558.18 42.6902 557.92 42.4902 557.64 42.5602C557.62 42.5402 557.55 42.6102 557.52 42.5902C557.55 42.6002 557.55 42.6902 557.58 42.7102C557.58 42.9302 557.55 43.1602 557.51 43.3802C557.46 43.5602 557.36 43.8302 557.76 43.9702C557.8 43.9802 558.04 44.0802 558.01 44.1402C557.82 44.5602 557.47 43.5702 557.27 43.9902C557.22 43.9602 557.01 43.8102 556.96 43.7802C557.02 43.8002 557.27 43.8702 557.33 43.9002C557.34 43.9802 557.36 44.0502 557.4 44.1202C557.48 44.3002 557.4 44.5302 557.45 44.7102C557.5 44.8902 557.71 45.0702 557.72 45.2502C557.73 45.4302 557.48 45.6202 557.44 45.8102C557.4 45.9802 557.27 46.0402 557.18 46.2202C557.08 46.2202 557.21 46.5502 557.12 46.5502C557.13 46.5902 557.03 46.3602 557.04 46.4002C557.12 46.3402 557.15 46.4402 557.22 46.3802C557.25 46.5602 557.24 46.6902 557.25 46.8702C557.25 47.0602 557.27 47.2502 557.31 47.4302C557.36 47.5902 557.61 47.7002 557.74 47.8502C557.67 48.0302 557.44 48.2102 557.43 48.4102C557.42 48.6002 557.74 48.8002 557.74 49.0002C557.74 49.1902 557.36 49.3602 557.33 49.5502C557.31 49.7202 557.26 49.8802 557.17 50.0202C557.08 50.1702 557.13 50.4102 556.95 50.5402C556.87 50.5902 557.51 50.7302 557.53 50.7402C557.73 50.8302 557.66 51.1102 557.69 51.2302C557.74 51.3802 557.97 51.5502 557.92 51.7202C557.87 51.8902 557.74 52.0102 557.75 52.1502C557.76 52.3502 557.72 52.5502 557.62 52.7302C557.53 52.8702 557.14 52.8302 557.04 52.9802C556.97 53.1602 556.94 53.3602 556.97 53.5602C556.94 53.7602 556.95 53.9702 557 54.1702C557.07 54.3402 557.25 54.4902 557.32 54.6702C557.39 54.8502 557.45 55.0302 557.49 55.2202C557.53 55.4402 557.58 55.6602 557.47 55.8002C557.34 55.9502 557.15 56.0502 556.95 56.0602C556.79 56.0602 556.61 55.7802 556.42 55.7702C556.24 55.7602 556.06 55.7702 555.88 55.7502C555.69 55.7302 555.5 56.0102 555.33 56.0202C555.11 56.0202 554.82 55.7902 554.72 55.8802C554.62 55.9702 554.48 56.2902 554.33 56.2802C554.13 56.2602 553.93 56.2202 553.73 56.2002C553.53 56.1802 553.34 55.9702 553.14 55.9402C552.94 55.9102 552.67 56.0702 552.48 56.0102C552.2 55.9102 552.21 56.5502 552.11 56.0002C552.08 55.8402 552.32 55.5402 552.21 55.3902C552.1 55.2402 551.68 55.2602 551.63 55.1102C551.57 54.9502 551.81 54.8202 551.98 54.6602C552.09 54.5002 552.18 54.3302 552.25 54.1502C552.34 53.9902 552.23 53.7502 552.28 53.5802C552.34 53.4102 552.53 53.2002 552.45 52.9902C552.45 52.9602 552.27 52.9602 552.29 52.9902C552.31 53.0102 552.31 53.0102 552.29 52.9902C552.17 52.8802 552.09 52.8602 551.97 52.7502C552.21 52.6802 552.04 52.3802 552.08 52.1602C552.11 51.9502 552.2 51.6502 552.52 51.6502C552.4 51.5102 552.38 51.4802 552.25 51.3402C552.24 51.3302 552.13 51.4602 552.12 51.4402C552 51.2202 552.16 50.9502 552.21 50.7502C552.26 50.5402 552.44 50.3702 552.51 50.1702C552.59 49.9502 552.62 49.7002 552.57 49.4702C552.54 49.3502 552.55 49.2002 552.53 49.1902C552.18 49.0202 552.28 48.7502 552.33 48.5402C552.36 48.3102 552.34 48.0802 552.28 47.8502C552.25 47.6802 552.43 47.4202 552.33 47.2502C552.24 47.1002 551.83 47.1202 551.74 46.9702C551.64 46.8102 551.81 46.5202 551.78 46.3702C551.76 46.2402 551.78 46.3002 552.05 46.1602C552.18 45.8502 552.19 45.5002 552.08 45.1802C551.93 45.0302 551.79 44.9402 551.77 44.8102C551.75 44.6402 551.67 44.4102 551.75 44.2602C551.83 44.1102 552.22 44.1002 552.28 43.9502C552.42 43.7102 552.59 43.4902 552.8 43.3002C552.61 43.1502 552.13 43.0702 552.01 42.8702C551.91 42.7002 552.13 42.4502 552.19 42.2602C552.25 42.0802 552.3 41.8802 552.34 41.7002C552.38 41.5202 552.45 41.3202 552.47 41.1302C552.49 40.9402 552.15 40.7302 552.15 40.5402C552.15 40.3502 552.29 40.1702 552.27 39.9802C552.22 39.8002 552.17 39.6202 552.1 39.4502C552.05 39.2702 551.9 39.1502 551.82 38.9702C551.73 38.7502 551.78 38.4902 551.96 38.3302C552.09 38.2502 552.27 38.1702 552.41 38.0902C552.53 38.0202 552.94 38.1002 552.94 38.0202C552.92 37.6602 552.56 37.7802 552.4 37.8102C552.19 37.8502 552.05 37.9302 551.97 37.8402C551.89 37.7502 551.91 37.5902 551.95 37.3902C552.02 37.1802 552.08 36.9702 552.13 36.7602C552.14 36.5402 552.09 36.3102 551.97 36.1202C551.92 36.0302 552.09 35.6802 552.24 35.5202C552.49 35.2502 552.6 34.9702 552.28 34.8602C552.04 34.7702 551.73 34.8202 551.67 34.6702C551.61 34.5202 551.81 34.3002 551.9 34.0802C551.9 34.0702 551.66 34.1602 551.65 34.1502C551.65 34.0602 551.87 33.9202 551.87 33.8302C551.87 33.8102 551.83 33.8402 551.83 33.8302C551.87 33.6202 551.97 33.4202 552.03 33.2202C552.09 33.0102 552.33 32.8102 552.34 32.6002C552.35 32.4002 552.08 32.2002 551.99 31.9902C551.99 31.9802 552.15 32.0102 552.15 31.9902C552.18 31.7902 551.94 31.6102 551.9 31.4302C551.87 31.2802 552.01 31.0702 551.94 30.9202C551.86 30.7602 551.54 30.6002 551.56 30.4502L556.71 30.8302ZM556.8 37.1602C556.84 37.1102 556.72 37.2002 556.76 37.1502C556.73 37.2102 556.95 37.2102 556.92 37.2702C556.89 37.2802 556.68 37.1002 556.65 37.1202C556.63 37.1302 556.77 37.3402 556.76 37.3602C556.79 37.3202 556.77 37.2102 556.8 37.1702V37.1602ZM558.61 35.1602C558.61 35.1602 558.79 35.3102 558.82 35.3002C558.84 35.2902 558.79 35.1902 558.8 35.1602C558.77 35.2002 558.58 35.0402 558.55 35.0802C558.52 35.0902 558.51 35.1202 558.48 35.1402C558.46 35.1502 558.66 35.4302 558.65 35.4602C558.68 35.4202 558.58 35.2102 558.61 35.1702V35.1602ZM556.74 33.1402C556.74 33.1402 557.24 33.2202 557.19 33.2002C557.25 33.2202 556.82 33.0502 556.87 33.0702C556.87 33.1802 557.11 33.4102 557.12 33.5202C557.17 33.5002 557.42 33.4002 557.47 33.3802C557.41 33.3002 556.81 33.2302 556.74 33.1502V33.1402ZM556.86 48.5002C556.73 48.3902 556.73 48.1202 556.64 48.0902C556.6 48.0702 556.52 48.3202 556.52 48.3402C556.54 48.4402 556.42 48.6802 556.46 48.7802C556.55 48.7402 556.7 48.5802 556.86 48.5102V48.5002ZM557.98 35.6602C557.98 35.6602 558.07 35.4202 558.05 35.4102C558.02 35.4002 558 35.6502 557.97 35.6402C557.97 35.6802 557.8 35.7502 557.81 35.7802C557.84 35.7702 557.95 35.6602 557.98 35.6502V35.6602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M554.38 56.6402C554.38 56.6402 554.34 56.6402 554.32 56.6402C554.22 56.6302 554.12 56.6202 554.03 56.6002C553.93 56.5902 553.83 56.5702 553.73 56.5602C553.55 56.5402 553.37 56.4702 553.22 56.3602C553.18 56.3302 553.14 56.3102 553.09 56.2902C553.09 56.2902 553.02 56.3102 552.97 56.3202C552.85 56.3602 552.72 56.3802 552.59 56.3802C552.49 56.5302 552.31 56.6002 552.14 56.5702C551.8 56.5202 551.74 56.1802 551.7 55.9802C551.68 55.8402 551.7 55.6902 551.75 55.5602C551.53 55.5202 551.34 55.3702 551.24 55.1702C551.07 54.7402 551.44 54.4502 551.6 54.3202C551.64 54.2902 551.67 54.2602 551.7 54.2302C551.73 54.1802 551.75 54.1302 551.77 54.0702C551.8 54.0002 551.83 53.9302 551.86 53.8602C551.86 53.8302 551.86 53.8002 551.86 53.7802C551.84 53.6302 551.85 53.4802 551.89 53.3402C551.91 53.2802 551.93 53.2302 551.96 53.1702L551.92 53.1402C551.84 53.0902 551.77 53.0402 551.7 52.9802C551.61 52.9002 551.56 52.7902 551.55 52.6702C551.54 52.5502 551.59 52.4302 551.67 52.3502C551.65 52.2402 551.65 52.1202 551.67 52.0002C551.69 51.8602 551.73 51.7302 551.78 51.6002C551.77 51.5802 551.76 51.5602 551.75 51.5502C551.63 51.2702 551.64 50.9502 551.77 50.6802C551.78 50.6402 551.8 50.6002 551.81 50.5602C551.85 50.4002 551.93 50.2502 552.02 50.1102C552.06 50.0502 552.09 50.0002 552.12 49.9302C552.17 49.7902 552.19 49.6402 552.17 49.4902C552.16 49.4502 552.15 49.4002 552.14 49.3602C551.88 49.1102 551.79 48.7302 551.91 48.3902C551.93 48.2502 551.93 48.1102 551.89 47.9702L551.87 47.8402C551.85 47.7102 551.87 47.5702 551.9 47.4502C551.69 47.4102 551.5 47.2902 551.38 47.1202C551.27 46.9002 551.26 46.6502 551.34 46.4202C551.34 46.3902 551.36 46.3502 551.36 46.3202C551.31 46.0602 551.47 45.8102 551.72 45.7502C551.73 45.6202 551.74 45.4902 551.72 45.3602L551.68 45.3302C551.5 45.2002 551.38 45.0002 551.34 44.7902L551.32 44.6902C551.25 44.4502 551.27 44.2002 551.37 43.9802C551.49 43.7902 551.67 43.6602 551.89 43.6002L551.94 43.5802C551.98 43.5102 552.03 43.4302 552.08 43.3702C551.9 43.3002 551.75 43.1802 551.65 43.0202C551.52 42.7402 551.55 42.4102 551.73 42.1602C551.75 42.1202 551.77 42.0802 551.79 42.0402C551.85 41.8702 551.89 41.6902 551.93 41.5202C551.95 41.4502 551.97 41.3802 551.98 41.3102C552 41.2402 552.02 41.1602 552.04 41.0902L552 41.0402C551.85 40.8902 551.75 40.6802 551.74 40.4702C551.74 40.3302 551.77 40.2002 551.82 40.0702C551.83 40.0302 551.85 39.9902 551.86 39.9502C551.84 39.8902 551.82 39.8202 551.79 39.7602C551.75 39.6702 551.72 39.5802 551.69 39.4902C551.67 39.4502 551.64 39.4102 551.61 39.3702C551.54 39.2802 551.48 39.1702 551.43 39.0602C551.28 38.7002 551.35 38.2902 551.6 37.9902C551.47 37.7502 551.45 37.4602 551.53 37.2002C551.56 37.1002 551.59 36.9902 551.63 36.9002C551.67 36.8102 551.69 36.7202 551.71 36.6302C551.71 36.5002 551.67 36.3602 551.6 36.2502C551.4 35.8702 551.77 35.3202 551.92 35.1502C551.65 35.1502 551.41 35.0002 551.28 34.7602C551.22 34.6002 551.22 34.4302 551.28 34.2702L551.26 34.2302C551.24 34.1802 551.23 34.1302 551.23 34.0702C551.23 33.9002 551.3 33.7502 551.42 33.6302C551.45 33.4902 551.5 33.3502 551.55 33.2102C551.58 33.1402 551.6 33.0602 551.63 32.9902C551.68 32.8502 551.75 32.7202 551.83 32.6002C551.85 32.5702 551.88 32.5302 551.9 32.5002C551.88 32.4702 551.85 32.4402 551.83 32.4102C551.74 32.3102 551.67 32.1902 551.61 32.0702C551.56 31.9502 551.56 31.8202 551.61 31.7002C551.47 31.4902 551.44 31.2302 551.53 30.9902L551.49 30.9602C551.27 30.8102 551.14 30.5602 551.15 30.3002L552.04 30.4202C552.05 30.3402 552.04 30.2702 551.99 30.2002C552.02 30.2302 552.05 30.2602 552.08 30.2902C552.2 30.3802 552.3 30.5002 552.37 30.6202C552.45 30.8102 552.46 31.0202 552.39 31.2202V31.2502C552.39 31.2502 552.41 31.2802 552.42 31.3002C552.57 31.4802 552.64 31.7202 552.62 31.9602C552.75 32.1202 552.82 32.3202 552.82 32.5202C552.8 32.7302 552.71 32.9302 552.58 33.1002C552.55 33.1502 552.52 33.2002 552.49 33.2502C552.46 33.3402 552.43 33.4302 552.4 33.5302C552.38 33.5802 552.36 33.6302 552.35 33.6802C552.35 33.7002 552.35 33.7102 552.35 33.7302C552.35 33.7302 552.35 33.7902 552.35 33.8202C552.4 33.9302 552.4 34.0502 552.35 34.1602C552.33 34.2002 552.31 34.2502 552.29 34.2902C552.35 34.3002 552.41 34.3202 552.46 34.3402C552.7 34.4102 552.88 34.6002 552.94 34.8402C552.99 35.1802 552.86 35.5202 552.6 35.7302C552.55 35.7902 552.5 35.8702 552.47 35.9402C552.58 36.1802 552.63 36.4402 552.61 36.7002C552.59 36.8602 552.55 37.0202 552.49 37.1802L552.47 37.2502C552.71 37.1802 552.96 37.2302 553.17 37.3602C553.33 37.4902 553.43 37.6902 553.43 37.9002C553.43 38.0302 553.39 38.1602 553.3 38.2502C553.15 38.3802 552.94 38.4402 552.74 38.4102C552.7 38.4102 552.66 38.4102 552.62 38.4102C552.57 38.4402 552.51 38.4702 552.45 38.5002C552.39 38.5302 552.34 38.5602 552.28 38.5902C552.27 38.6302 552.26 38.6702 552.28 38.7002C552.3 38.7502 552.33 38.7902 552.36 38.8302C552.46 38.9502 552.53 39.0902 552.57 39.2402C552.59 39.3002 552.61 39.3502 552.63 39.4102C552.69 39.5502 552.73 39.6902 552.76 39.8402C552.77 40.0102 552.75 40.1802 552.68 40.3402L552.66 40.4002L552.7 40.4502C552.88 40.6202 552.97 40.8502 552.96 41.1002C552.94 41.2502 552.91 41.3902 552.86 41.5302C552.84 41.5902 552.83 41.6502 552.81 41.7102C552.77 41.9002 552.71 42.1102 552.65 42.3102C552.62 42.4002 552.58 42.4902 552.53 42.5702C552.53 42.5702 552.61 42.6002 552.65 42.6202C552.82 42.6802 552.97 42.7602 553.11 42.8602C553.21 42.9402 553.26 43.0502 553.27 43.1702C553.27 43.2902 553.24 43.4102 553.16 43.5102L553.03 43.6502C552.91 43.7602 552.81 43.8902 552.72 44.0402C552.61 44.2502 552.42 44.4002 552.2 44.4502C552.2 44.4802 552.21 44.5102 552.22 44.5302C552.22 44.5602 552.23 44.5902 552.23 44.6202C552.25 44.6402 552.27 44.6502 552.29 44.6702C552.33 44.7102 552.37 44.7502 552.42 44.7902C552.72 45.1002 552.61 45.8502 552.6 45.9402C552.58 46.1602 552.46 46.3702 552.28 46.4902L552.24 46.5102C552.24 46.5102 552.22 46.5802 552.22 46.6202C552.43 46.6602 552.62 46.7802 552.74 46.9502C552.85 47.1702 552.86 47.4202 552.78 47.6402C552.77 47.6702 552.76 47.7102 552.75 47.7402L552.77 47.8102C552.83 48.0602 552.84 48.3102 552.79 48.5702C552.78 48.6302 552.76 48.6802 552.76 48.7102C552.92 48.8102 553.02 48.9802 553.02 49.1702C553.02 49.2102 553.02 49.2402 553.03 49.2802C553.1 49.6002 553.07 49.9302 552.96 50.2402C552.91 50.3702 552.85 50.4902 552.77 50.6002C552.73 50.6602 552.7 50.7202 552.67 50.7802C552.66 50.8402 552.63 50.9002 552.61 50.9702C552.67 51.0402 552.71 51.0902 552.75 51.1302L552.88 51.2802C552.99 51.4102 553.02 51.5902 552.96 51.7502C552.9 51.9102 552.75 52.0202 552.58 52.0302C552.57 52.0702 552.56 52.1102 552.55 52.1602C552.55 52.1702 552.55 52.2302 552.56 52.2702C552.56 52.3402 552.57 52.4102 552.57 52.4702C552.72 52.5202 552.84 52.6302 552.9 52.7702C552.97 53.0402 552.93 53.3302 552.77 53.5602C552.75 53.5902 552.74 53.6202 552.72 53.6502C552.72 53.6702 552.73 53.7002 552.73 53.7202C552.77 53.9202 552.73 54.1202 552.65 54.3002C552.63 54.3502 552.61 54.3902 552.59 54.4402C552.54 54.5902 552.46 54.7402 552.36 54.8602C552.45 54.9102 552.53 54.9702 552.59 55.0602C552.68 55.1802 552.72 55.3402 552.7 55.4902H552.74C553.06 55.3702 553.41 55.4202 553.67 55.6202C553.71 55.6502 553.75 55.6702 553.8 55.6902C553.91 55.6902 554.03 55.7102 554.15 55.7302C554.18 55.7302 554.21 55.7302 554.24 55.7402L554.27 55.6902C554.32 55.6102 554.37 55.5402 554.44 55.4802C554.66 55.3102 554.97 55.2902 555.21 55.4402C555.24 55.4502 555.27 55.4702 555.31 55.4802L555.34 55.4602C555.51 55.3102 555.73 55.2202 555.95 55.2302C556.03 55.2302 556.11 55.2302 556.2 55.2402C556.3 55.2402 556.39 55.2402 556.49 55.2502C556.69 55.2802 556.87 55.3702 557.01 55.5102L557.03 55.5302C557.03 55.5302 557.11 55.4902 557.14 55.4602C557.12 55.4702 557.1 55.3502 557.08 55.2702C557.05 55.0902 557 54.9202 556.93 54.7602C556.9 54.7102 556.87 54.6602 556.83 54.6102C556.74 54.5002 556.67 54.3802 556.61 54.2502C556.54 54.0302 556.51 53.7902 556.54 53.5502V53.3802C556.52 53.1302 556.57 52.8802 556.69 52.6602C556.83 52.4802 557.04 52.3702 557.26 52.3402H557.3C557.32 52.2602 557.33 52.1802 557.33 52.1002C557.33 51.9302 557.37 51.7602 557.47 51.6202C557.39 51.5102 557.33 51.4102 557.29 51.2902C557.27 51.2102 557.26 51.1302 557.26 51.0502C556.83 50.9402 556.59 50.8502 556.53 50.5602C556.5 50.4002 556.56 50.2402 556.68 50.1302C556.68 50.1102 556.68 50.0902 556.69 50.0702C556.71 49.9502 556.75 49.8302 556.81 49.7302C556.87 49.6402 556.9 49.5302 556.91 49.4302C556.95 49.2302 557.07 49.0402 557.24 48.9202C557.21 48.8902 557.18 48.8502 557.15 48.8102C557.13 48.8302 557.1 48.8402 557.08 48.8502C557.02 48.8802 556.97 48.9202 556.92 48.9602C556.85 49.0202 556.77 49.0802 556.68 49.1202C556.57 49.1702 556.44 49.1702 556.33 49.1202C556.22 49.0802 556.13 48.9902 556.08 48.8802C556.02 48.7102 556.02 48.5202 556.08 48.3502C556.08 48.3202 556.09 48.3002 556.1 48.2802C556.11 48.0602 556.2 47.8502 556.36 47.6902C556.49 47.5802 556.67 47.5502 556.83 47.6002C556.88 47.6202 556.93 47.6502 556.97 47.6802C556.94 47.6302 556.92 47.5802 556.9 47.5202C556.85 47.3602 556.83 47.1902 556.83 47.0202C556.83 46.9702 556.83 46.9202 556.83 46.8702C556.83 46.8502 556.83 46.8402 556.83 46.8302C556.78 46.7702 556.73 46.7002 556.7 46.6302L556.68 46.6002C556.68 46.6002 556.65 46.5402 556.64 46.5002C556.58 46.3302 556.64 46.1402 556.77 46.0202C556.79 45.9802 556.81 45.9402 556.85 45.9002C556.85 45.9002 556.87 45.8802 556.88 45.8702C556.92 45.8102 556.96 45.7602 557.01 45.7102C557.03 45.6902 557.04 45.6802 557.05 45.6602C557.09 45.5202 557.16 45.3802 557.25 45.2702C557.25 45.2602 557.27 45.2402 557.28 45.2302C557.27 45.2102 557.25 45.1902 557.24 45.1802C557.15 45.0702 557.09 44.9402 557.05 44.8102C557.02 44.6802 557.01 44.5502 557.02 44.4202C557.02 44.4002 557.02 44.3702 557.02 44.3402C556.98 44.3102 556.93 44.2802 556.88 44.2402C556.83 44.2102 556.79 44.1702 556.76 44.1602C556.56 44.0402 556.49 43.7902 556.59 43.5802C556.68 43.3902 556.88 43.2902 557.09 43.3402V43.2902C557.13 43.1702 557.15 43.0502 557.15 42.9202V42.8102C557.08 42.6602 557.09 42.4902 557.19 42.3502C557.21 42.3202 557.24 42.2902 557.26 42.2702C557.24 42.2202 557.23 42.1802 557.22 42.1402C557.22 42.1002 557.2 42.0702 557.19 42.0302C557.1 41.8302 557.04 41.6202 557.01 41.4102C556.99 41.3002 556.98 41.1802 556.98 41.0702C556.98 41.0002 556.98 40.9302 556.97 40.8702C556.96 40.8102 556.94 40.7502 556.92 40.6902C556.85 40.4902 556.82 40.2702 556.86 40.0602C556.87 39.9902 556.88 39.9202 556.88 39.8502C556.88 39.6702 556.92 39.4902 556.98 39.3202C557 39.2602 557.03 39.2102 557.07 39.1602C556.95 38.8202 557.23 38.5302 557.36 38.3902L557.43 38.3202C557.32 38.0802 557.34 37.7902 557.47 37.5602C557.56 37.4402 557.7 37.3802 557.84 37.3902C557.86 37.3602 557.88 37.3202 557.9 37.2902C557.94 37.0102 558.13 36.7802 558.39 36.6902C558.43 36.6602 558.47 36.6302 558.51 36.5902C558.58 36.5102 558.66 36.4502 558.75 36.3902C558.8 36.3602 558.85 36.3402 558.9 36.3202C558.86 36.2402 558.84 36.1602 558.83 36.0702C558.82 36.0002 558.8 35.9402 558.77 35.8802V35.8402C558.67 35.8402 558.59 35.8402 558.51 35.7902C558.49 35.7902 558.48 35.7702 558.46 35.7602C558.43 35.8502 558.36 35.9302 558.28 35.9802C558.21 36.0502 558.12 36.1102 558.03 36.1502C557.91 36.2002 557.77 36.1902 557.66 36.1202C557.55 36.0502 557.46 35.9502 557.44 35.8202C557.4 35.6202 557.48 35.4202 557.65 35.3202C557.68 35.1602 557.78 35.0102 557.93 34.9402C557.99 34.9102 558.06 34.9002 558.12 34.9002C558.15 34.8302 558.19 34.7702 558.25 34.7302C558.28 34.7002 558.32 34.6702 558.36 34.6402C558.43 34.5902 558.5 34.5702 558.59 34.5602V34.5202C558.59 34.5202 558.57 34.4702 558.57 34.4402C558.52 34.4102 558.48 34.3902 558.43 34.3602C558.36 34.3302 558.3 34.2702 558.25 34.2102C558.08 34.2002 557.91 34.1202 557.8 33.9902C557.76 33.9502 557.72 33.9002 557.68 33.8702C557.65 33.8402 557.62 33.8102 557.59 33.7802L557.35 33.8702C557.23 33.9202 557.1 33.9102 556.98 33.8502C556.87 33.7902 556.78 33.6902 556.75 33.5602V33.5402C556.63 33.5102 556.54 33.4502 556.46 33.3602C556.35 33.2402 556.32 33.0702 556.37 32.9202C556.41 32.7902 556.51 32.6802 556.64 32.6502C556.7 32.6002 556.78 32.5702 556.86 32.5502C556.77 32.4002 556.73 32.2202 556.74 32.0502C556.58 32.0502 556.42 32.0102 556.29 31.9202C555.86 31.6002 556.13 31.0602 556.25 30.8202C556.27 30.7802 556.29 30.7502 556.3 30.7102L557.17 30.9402C557.15 31.0202 557.12 31.1002 557.08 31.1802C557.25 31.2102 557.4 31.3002 557.51 31.4402C557.62 31.6102 557.67 31.8002 557.64 32.0002C557.64 32.0302 557.64 32.0602 557.64 32.0902C557.67 32.1402 557.71 32.1902 557.75 32.2402C557.82 32.3302 557.88 32.4102 557.94 32.5002C558.01 32.6202 558.06 32.7502 558.09 32.8902C558.09 32.9302 558.11 32.9802 558.13 33.0202C558.18 33.0902 558.24 33.1502 558.3 33.2002C558.33 33.2302 558.37 33.2702 558.4 33.3002H558.46C558.65 33.2602 558.84 33.2902 559.01 33.3802C559.12 33.4502 559.19 33.5602 559.21 33.6902C559.21 33.7102 559.21 33.7302 559.21 33.7502C559.31 33.8002 559.39 33.8702 559.47 33.9602C559.58 34.1102 559.59 34.3202 559.48 34.4802C559.5 34.5702 559.51 34.6602 559.53 34.7502C559.54 34.8802 559.55 35.0102 559.53 35.1402C559.53 35.2202 559.53 35.3002 559.53 35.3802C559.55 35.4502 559.57 35.5102 559.59 35.5602C559.64 35.6802 559.68 35.8102 559.7 35.9402C559.72 35.9802 559.74 36.0102 559.76 36.0502C559.9 36.2302 559.95 36.4702 559.88 36.7002C559.77 36.9402 559.54 37.1102 559.28 37.1402C559.25 37.1402 559.21 37.1602 559.18 37.1702C559.16 37.1902 559.14 37.2102 559.12 37.2302C559.02 37.3402 558.9 37.4302 558.76 37.4902C558.76 37.5202 558.75 37.5402 558.74 37.5702C558.87 37.6502 558.95 37.7902 558.96 37.9402C558.96 38.1102 558.89 38.2802 558.74 38.3802C558.62 38.5802 558.44 38.7402 558.22 38.8302C558.27 38.9302 558.29 39.0402 558.28 39.1502C558.25 39.3502 558.1 39.5002 557.9 39.5302C557.9 39.5302 557.83 39.6102 557.8 39.6602C557.78 39.7502 557.76 39.8302 557.76 39.9202C557.76 40.0302 557.74 40.1402 557.72 40.2502C557.73 40.3102 557.75 40.3802 557.77 40.4402C557.8 40.5402 557.82 40.6402 557.84 40.7402C557.85 40.8502 557.86 40.9502 557.86 41.0602C557.86 41.1302 557.86 41.2002 557.87 41.2602C557.89 41.4002 557.93 41.5302 557.98 41.6602C558.02 41.7402 558.04 41.8202 558.07 41.9102C558.08 41.9602 558.1 42.0102 558.12 42.0602C558.33 42.2402 558.56 42.4502 558.41 42.7702C558.34 42.9302 558.19 43.0302 558.02 43.0402C558.02 43.2002 557.99 43.3602 557.95 43.5202V43.5702C558.15 43.6302 558.32 43.7702 558.43 43.9602C558.48 44.0802 558.48 44.2202 558.43 44.3502C558.36 44.5402 558.19 44.6702 557.99 44.7102H557.97C558.09 44.8602 558.16 45.0402 558.18 45.2302C558.18 45.4502 558.1 45.6602 557.96 45.8202C557.93 45.8502 557.91 45.8902 557.89 45.9202C557.86 46.0602 557.78 46.2002 557.68 46.3102C557.7 46.4202 557.71 46.5302 557.71 46.6502C557.71 46.7002 557.71 46.7602 557.71 46.8202C557.71 46.8802 557.71 46.9502 557.72 47.0202C557.72 47.1002 557.72 47.1802 557.74 47.2502C557.77 47.2702 557.81 47.3102 557.84 47.3302C557.93 47.3902 558.01 47.4602 558.08 47.5302C558.2 47.6602 558.23 47.8502 558.17 48.0102C558.12 48.1202 558.06 48.2202 557.98 48.3202C557.96 48.3402 557.95 48.3702 557.93 48.3902L557.95 48.4102C558.1 48.5602 558.19 48.7602 558.2 48.9802C558.18 49.2302 558.05 49.4602 557.85 49.6002C557.83 49.6202 557.8 49.6402 557.78 49.6602C557.75 49.8602 557.68 50.0502 557.58 50.2202C557.58 50.2302 557.58 50.2402 557.58 50.2502H557.61C557.61 50.2502 557.7 50.2802 557.75 50.3002C558.03 50.4402 558.19 50.7402 558.17 51.0502C558.17 51.0702 558.19 51.0902 558.21 51.1202C558.38 51.3102 558.46 51.5702 558.4 51.8202C558.37 51.9202 558.33 52.0102 558.28 52.1002C558.28 52.1202 558.26 52.1302 558.26 52.1402C558.26 52.4202 558.2 52.7002 558.05 52.9402C557.91 53.1202 557.71 53.2302 557.48 53.2502H557.46C557.46 53.2502 557.46 53.3502 557.46 53.3802C557.46 53.4302 557.46 53.4802 557.46 53.5202V53.6402C557.44 53.7402 557.44 53.8502 557.46 53.9502C557.49 54.0002 557.52 54.0402 557.55 54.0802C557.64 54.1902 557.72 54.3202 557.78 54.4502C557.86 54.6602 557.93 54.8702 557.97 55.0902C558.07 55.4002 558.03 55.7402 557.86 56.0202C557.65 56.2802 557.33 56.4402 557 56.4502C556.79 56.4502 556.59 56.3602 556.44 56.2102C556.42 56.1902 556.39 56.1702 556.37 56.1502C556.31 56.1502 556.24 56.1502 556.18 56.1502C556.1 56.1502 556.02 56.1502 555.94 56.1502C555.92 56.1602 555.9 56.1802 555.88 56.2002C555.74 56.3202 555.56 56.4002 555.38 56.4202C555.23 56.4202 555.09 56.3902 554.96 56.3302C554.84 56.5302 554.62 56.6602 554.39 56.6802L554.38 56.6402ZM556.8 37.7202C556.6 37.7202 556.43 37.5902 556.37 37.4002L556.35 37.3502C556.14 36.9602 556.29 36.7502 556.44 36.6502C556.69 36.5502 556.97 36.5902 557.18 36.7602C557.26 36.8102 557.32 36.8902 557.36 36.9702C557.41 37.0902 557.41 37.2302 557.36 37.3602C557.31 37.4702 557.21 37.5602 557.09 37.6002C557.01 37.6702 556.9 37.7102 556.79 37.7102L556.8 37.7202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.27 52.8402C536.19 52.8302 536.12 52.8202 536.04 52.8102C536.12 52.6102 536.21 52.4102 536.3 52.2102C536.39 52.0102 536.28 51.7502 536.34 51.5502C536.37 51.3602 536.37 51.1802 536.34 50.9902C536.34 50.8002 536.55 50.6102 536.81 50.4702C536.94 50.4002 536.91 50.0702 537.04 49.9902C537.18 49.9102 537.39 50.0202 537.55 49.9702C537.71 49.9202 537.89 49.7802 538.04 49.7202C538.02 49.6602 537.83 49.2602 537.83 49.2602C537.58 49.3402 537.51 49.4002 537.35 49.2802C537.18 49.1602 536.91 49.2002 536.74 49.0902C536.65 49.0302 536.61 48.9002 536.54 48.8302C536.46 48.7602 536.26 48.5102 536.3 48.4702C536.49 48.2602 537.1 48.0902 537.07 47.9802C537.02 47.8202 536.76 47.7302 536.69 47.5602C536.62 47.4002 536.77 47.1402 536.69 46.9802C536.6 46.8302 536.32 46.8102 536.21 46.6702C536.07 46.5002 535.96 46.3002 535.89 46.0902C535.83 45.8902 536.05 45.6602 536.07 45.4502C536.06 45.0502 536.3 44.6902 536.67 44.5602C536.84 44.4702 536.75 44.2902 536.92 44.1902C536.72 44.1202 536.7 44.0802 536.5 44.0102C536.5 44.0702 536.52 44.1202 536.55 44.1702C536.76 44.1002 536.97 44.0102 537.16 43.9002C537.36 43.7802 537.5 43.5902 537.55 43.3702C537.76 43.3202 537.71 43.1102 537.92 43.0502C537.82 42.9502 537.71 42.8602 537.58 42.8002C537.32 42.7002 537.04 42.6202 536.77 42.5702C536.93 42.7802 537.13 42.9702 537.29 43.1802C537.04 43.1402 536.88 43.3002 536.67 43.2002C536.47 43.1002 536.54 42.7402 536.46 42.4602C536.46 42.4502 536.24 42.5502 536.25 42.5402C536.34 42.3702 536.29 42.1002 536.4 41.9402C536.53 41.7502 536.77 41.6802 536.76 41.5202C536.74 41.3602 536.6 41.2902 536.37 41.1602C536.24 41.0602 536.12 40.9402 536.02 40.8102C535.8 40.5502 535.61 40.2402 535.69 40.1602C535.75 40.0902 536.11 40.3502 536.41 40.2902C536.54 40.2602 536.68 39.8502 536.81 39.7902C536.93 39.9602 536.97 40.2902 537.12 40.3802C537.29 40.4802 537.47 40.5702 537.66 40.6202C537.84 40.6702 538.08 40.4802 538.27 40.5202C538.33 40.5302 538.32 40.5602 538.36 40.5202C538.39 40.4802 538.44 40.4502 538.41 40.4402C538.23 40.3602 537.96 40.3802 537.79 40.2702C537.61 40.1602 537.57 39.7802 537.37 39.7502C537.19 39.7202 537.03 39.9902 536.82 40.1202C536.78 40.0702 536.66 39.8602 536.62 39.8102C536.79 39.6702 537.06 39.5402 537.07 39.3702C537.06 39.1602 537.02 38.9602 536.96 38.7602C536.96 38.7402 536.81 38.6902 536.83 38.6902C536.98 38.6902 536.94 38.7002 537.09 38.6902C537.01 38.5902 536.94 38.6902 536.89 38.5702C536.79 38.3902 536.95 38.0702 536.86 37.8902C536.77 37.7102 536.78 37.4702 536.69 37.2802C536.6 37.0902 536.42 36.9502 536.34 36.7602C536.32 36.7302 536.57 36.3802 536.66 36.4102C536.86 36.4802 537.06 36.6902 537.19 36.6002C537.32 36.5002 537.28 36.1902 537.43 36.1402C537.38 36.0102 537.23 35.9602 537.18 35.8402C537.18 35.8202 537.24 35.7302 537.25 35.7202C537.32 35.6002 537.4 35.4802 537.49 35.3702C537.63 35.2002 537.94 35.1802 538.09 35.0102C538.24 34.8402 538.25 34.5902 538.39 34.4202C538.33 34.3802 538.17 34.5502 537.89 34.6402C537.7 34.7002 537.46 34.6502 537.27 34.7302C537.09 34.8202 536.92 34.9502 536.79 35.1002C536.7 35.1802 536.61 35.0302 536.51 35.1002C536.48 34.9902 536.43 35.0402 536.46 34.9402C536.5 34.7702 536.33 34.5302 536.38 34.3602C536.43 34.1902 536.81 34.0802 536.86 33.9102C536.86 33.8902 536.58 33.8702 536.6 33.8602C536.74 33.7702 537.1 33.7402 537.23 33.6502C537.1 33.5702 536.74 33.5502 536.6 33.4702C536.67 33.5002 536.75 33.5102 536.83 33.5202C536.91 33.3002 536.85 32.9902 537 32.8102C537.14 32.6602 537.21 32.4402 537.19 32.2302C537.19 32.2002 537.4 32.1702 537.42 32.1902C537.44 32.2202 537.43 32.0702 537.4 32.0702C537.2 31.9802 537 32.0702 536.83 31.9302C536.68 31.7902 536.55 31.6202 536.45 31.4402C536.64 31.3002 536.44 31.2302 536.34 31.0502C536.25 30.8802 536.34 30.7002 536.68 30.6202C536.69 30.6502 536.85 30.5602 536.87 30.5802C536.88 30.5902 536.91 30.5802 536.94 30.5802C536.9 30.5502 536.9 30.6202 536.86 30.5802C536.88 30.4302 536.48 30.2502 536.51 30.1002C536.57 29.8602 536.82 29.7402 536.87 29.6202C536.96 29.4302 537.07 29.5302 537.32 29.5402C537.46 29.5402 537.65 29.3802 537.89 29.4002C537.89 29.4802 537.96 29.5802 537.96 29.6602C537.96 29.8102 537.96 29.7802 537.96 29.9302C538.06 29.8402 538.04 29.8902 538.14 29.8002C538.2 29.7502 538.28 29.7802 538.33 29.7302C538.38 29.7802 538.47 29.7302 538.52 29.7702C538.53 29.7802 538.49 29.8602 538.52 29.8502C538.44 29.8102 538.35 29.8202 538.27 29.7802C538.11 29.7002 537.9 29.6502 537.74 29.5702C537.65 29.4202 537.84 29.0502 537.74 28.9002C537.65 28.7502 537.42 28.6802 537.33 28.5202C537.24 28.3602 537.13 28.2302 537.04 28.0702C536.98 27.9502 536.93 27.6802 536.98 27.6502C537.17 27.5302 537.44 27.5502 537.64 27.4402C537.84 27.3302 537.96 27.0902 538.16 26.9902C538.36 26.8902 538.52 26.6902 538.72 26.6002C538.84 26.5402 539.19 26.6602 539.36 26.7202C539.36 26.7502 539.19 26.9802 539.2 27.0002C539.2 27.0202 539.52 26.8802 539.54 26.8902C539.51 26.8502 539.43 26.9502 539.4 26.9202C539.51 26.7002 539.3 26.3102 539.45 26.1202C539.63 25.9202 539.84 25.7502 540.08 25.6202C540.17 25.5602 540.56 25.7302 540.56 25.7502C540.58 26.0002 540.45 26.3102 540.56 26.4902C540.67 26.6902 541.1 26.6302 541.28 26.7802C541.44 26.9302 541.62 27.0602 541.8 27.1802C542 27.3502 542.12 27.6002 542.1 27.8702C542.11 28.1002 541.97 28.3602 542 28.5802C542 28.6002 542.11 28.5402 542.09 28.5402C541.89 28.6202 541.7 28.6902 541.63 28.8302C541.56 29.0202 541.55 29.2202 541.59 29.4102C541.78 29.3602 541.92 29.4102 542.12 29.3602C542.19 29.3402 542.19 29.0902 542.26 29.0602C542.26 29.0602 542.3 29.2202 542.3 29.2402C542.36 29.4602 542.52 29.6502 542.58 29.8602C542.64 30.0802 542.48 30.3402 542.51 30.5702C542.53 30.7502 542.62 30.8802 542.51 30.9802C542.41 31.0702 542.24 31.0302 542.07 31.0502C541.96 31.0602 542.01 31.2602 541.9 31.3202C542 31.3502 541.88 31.5202 541.96 31.5802C542.07 31.6502 542.35 31.6302 542.33 31.6602C542.23 31.8602 542.3 32.0902 542.27 32.2802C542.24 32.4902 541.91 32.7202 541.94 32.9302C542.01 33.1402 542.1 33.3502 542.21 33.5502C542.29 33.7402 542.62 33.8202 542.72 34.0102C542.75 34.0702 542.66 34.2402 542.64 34.3102C542.58 34.4902 542.74 34.7002 542.71 34.8902C542.68 35.0802 542.52 35.2402 542.52 35.4202C542.52 35.6102 542.42 35.8002 542.42 35.9802C542.42 36.1602 542.51 36.3602 542.51 36.5402C542.51 36.7302 542.45 36.9202 542.44 37.1102C542.44 37.3002 542.22 37.4502 542.19 37.6402C542.16 37.8202 542.3 38.1102 542.12 38.2402C541.97 38.3402 541.67 38.2002 541.47 38.2602C541.22 38.3802 540.99 38.5602 540.81 38.7802C540.72 38.9702 540.65 39.1702 540.62 39.3802C540.83 39.3802 541.04 39.3802 541.24 39.3502C541.32 39.3302 541.46 38.9002 541.53 38.8402C541.52 39.0102 541.48 39.1802 541.41 39.3402C541.27 39.5502 541.12 39.7602 540.96 39.9502C540.96 39.9602 541.02 39.8202 541.01 39.8302C540.81 39.8902 540.64 40.0202 540.52 40.1902C540.44 40.4102 540.48 40.6502 540.62 40.8402C540.74 40.9802 540.87 41.0102 540.91 41.1702C540.95 41.3102 541.14 41.4502 540.97 41.6302C540.89 41.7102 540.77 42.1202 540.82 42.1402C541.02 42.1902 541.23 42.1702 541.42 42.0902C541.58 42.0302 541.57 41.5702 541.74 41.4902C541.84 41.4402 541.88 41.1702 542.02 41.6202C542.09 41.8402 542.58 41.7302 542.29 42.1002C542.19 42.2202 542.36 42.5402 542.27 42.6702C542.18 42.8002 541.88 42.7902 541.81 42.9302C541.73 43.0902 541.75 43.1602 542.01 43.4502C542.12 43.5702 541.94 43.8502 541.86 44.0302C541.81 44.1902 541.67 44.3102 541.51 44.3402C541.32 44.3902 541.02 44.3802 540.92 44.4902C540.82 44.6802 540.79 44.9102 540.84 45.1202C540.86 45.2702 541.06 45.3902 541.19 45.5402C541.33 45.7602 541.5 45.9602 541.68 46.1502C541.84 46.2802 541.97 46.3802 542 46.5102C542.03 46.6202 541.88 46.6802 541.74 46.8802C541.64 47.0702 541.62 47.2902 541.69 47.4902C541.74 47.6402 542.07 47.7302 542.08 47.9002C542.09 48.0502 541.88 48.1502 541.76 48.3102C541.68 48.4302 541.93 48.7102 541.95 48.9602C541.97 49.1602 541.72 49.3202 541.63 49.5002C541.61 49.5402 542.05 49.6402 542.13 49.7402C542.22 49.8702 542.27 50.0102 542.28 50.1702C542.19 50.2902 542.25 50.4802 542.22 50.7202C542.18 50.9102 542.15 51.1002 542.13 51.2902C542.13 51.4802 542.18 51.6702 542.19 51.8702C542.19 52.0602 542.05 52.2702 542.06 52.4602C542.06 52.6602 542.25 52.8602 542.24 53.0502C542.24 53.2602 541.99 53.4502 541.97 53.6302C541.93 53.8102 541.84 53.9702 541.72 54.0902C541.62 54.2502 541.89 54.6502 541.79 54.7902C541.61 54.9302 541.38 55.0002 541.15 54.9702C540.88 54.9702 540.7 55.1202 540.81 55.4102C540.87 55.5502 541.04 55.6602 541.07 55.8102C541.02 55.6202 541.23 55.3302 540.83 55.4402C540.72 55.4702 540.61 55.6802 540.38 55.7602C540.1 55.8502 539.7 55.3502 539.47 55.5202C539.33 55.6302 539.5 55.0902 539.42 55.2802C539.63 55.2502 539.53 55.5902 539.75 55.5502C539.84 55.7402 539.75 55.6402 539.71 55.8502C539.71 55.5602 539.88 55.4402 539.81 55.3802C539.7 55.2802 539.61 55.5202 539.43 55.6502C539.28 55.7302 539.09 55.7202 538.95 55.6202C538.77 55.5302 538.59 55.8102 538.42 55.8702C538.25 55.9302 538.06 55.9402 537.9 55.9902C537.7 56.0702 537.47 56.0702 537.28 55.9802C537.2 55.9202 537.44 55.5702 537.52 55.4502C537.65 55.2702 537.67 55.0402 537.59 54.8302C537.43 54.6802 537.2 54.6302 537 54.7102C536.88 54.7302 536.76 54.7002 536.67 54.6302C536.78 54.5502 536.92 54.5202 536.98 54.4102C537.04 54.3102 537.05 54.1902 537.03 54.0702C536.82 53.9902 536.67 53.8102 536.63 53.5802C536.63 53.4002 536.98 53.2002 536.98 53.0102C536.92 52.7602 536.84 52.5202 536.75 52.2802C536.58 52.4202 536.49 52.8102 536.32 52.9602C536.34 52.9002 536.35 52.8402 536.36 52.7802L536.27 52.8402ZM539.24 38.9302C539.24 38.9302 539.42 38.9102 539.39 38.9302C539.36 38.9602 539.35 38.9002 539.31 38.8702C539.29 38.8502 539.14 38.6902 539.13 38.6702C539.15 38.6702 539.21 38.9102 539.24 38.9202V38.9302ZM537.74 28.6802C537.82 28.6802 537.96 28.5602 538.03 28.5602C538.11 28.5602 538.2 28.5702 538.28 28.5802C538.2 28.8502 538.36 28.8702 538.47 28.9802C538.58 29.0902 538.66 29.1102 538.88 29.1402C539.35 29.2002 539.2 29.0502 539.32 28.7802C539.44 28.5002 539.53 28.3202 539.49 28.2402C539.33 28.0702 539.08 28.0302 538.88 28.1302C538.74 28.1802 538.71 28.2402 538.56 28.2502C538.29 27.9702 538.05 27.9802 537.87 28.4902C537.78 28.4902 537.89 28.5102 537.8 28.5202C537.73 28.4302 537.49 28.5202 537.42 28.4402C537.4 28.4202 537.55 28.3402 537.53 28.3202C537.55 28.3302 537.63 28.2102 537.65 28.2202C537.73 28.3002 537.65 28.5902 537.73 28.6802H537.74ZM538.59 51.4102C538.59 51.4102 538.4 51.4502 538.35 51.4202C538.41 51.4402 538.47 51.4602 538.53 51.4702C538.61 51.5602 538.87 51.5902 538.94 51.6802C538.89 51.7702 538.86 51.8702 538.83 51.9702C538.81 52.1002 538.64 52.2002 538.63 52.3302C538.76 52.2302 538.9 52.1402 539.04 52.0302C538.94 51.9302 538.97 51.7002 538.87 51.6102C538.79 51.5302 538.66 51.4802 538.59 51.4002V51.4102ZM539.51 50.2102C539.62 50.2002 539.68 50.0602 539.79 50.0502C539.76 50.0002 539.74 49.9702 539.72 49.9202C539.64 49.9902 539.7 50.1902 539.62 50.2602C539.58 50.3002 539.28 50.3202 539.24 50.3602C539.27 50.3102 539.48 50.2602 539.51 50.2002V50.2102ZM538.21 41.9402C538.3 41.9002 538.3 41.7702 538.4 41.7302C538.31 41.7802 538.23 41.8402 538.14 41.8902C538.08 41.9802 538.18 42.1602 538.13 42.2502C538.13 42.2502 537.84 42.1102 537.86 42.1402C537.89 42.0202 538.18 42.0602 538.21 41.9502V41.9402ZM538.69 31.9802C538.69 31.9802 538.64 32.0702 538.67 32.0402C538.69 32.0202 538.72 32.0502 538.73 32.0802C538.83 32.2902 538.99 32.3102 539.09 32.5102C539.18 32.3702 539.14 32.4202 539.12 32.3002C539.06 31.8902 538.93 31.8802 538.69 31.9802ZM540.98 43.2702C540.83 43.0602 540.61 42.9502 540.51 42.8202C540.44 42.9502 540.31 43.0702 540.31 43.2002C540.31 43.3002 540.51 43.2702 540.62 43.3202C540.74 43.3602 540.87 43.3402 540.98 43.2702ZM539.08 33.4602C538.9 33.3902 538.63 33.2902 538.49 33.2302C538.32 33.1602 538.17 33.1102 538.02 33.0602C538 33.0602 538.06 33.0602 538.02 33.1302C538.21 33.2302 538.41 33.3102 538.61 33.3902C538.75 33.4802 538.92 33.5002 539.08 33.4502V33.4602ZM538.86 53.2602C538.7 53.4002 538.58 53.5902 538.51 53.7902C538.57 53.9402 538.67 54.0802 538.8 54.1802C538.85 54.2102 538.93 54.0402 538.92 53.9702C538.94 53.7302 538.92 53.4902 538.86 53.2602ZM537.98 50.8002C537.9 50.6602 537.82 50.5302 537.72 50.4102C537.6 50.5002 537.48 50.5902 537.36 50.6702C537.24 50.7502 537.28 50.9402 537.16 51.0302C537.2 51.0802 537.02 50.9102 537.04 50.9102C537.3 50.8002 537.73 50.9102 537.98 50.7902V50.8002ZM539.74 49.4102C539.56 49.2702 539.37 49.1002 539.29 49.1002C539.15 49.1002 539.02 49.1402 538.89 49.1902C538.93 49.2702 538.97 49.2202 539.02 49.2202C539.19 49.2202 539.46 49.4502 539.74 49.4202V49.4102ZM537.78 37.6102C537.69 37.7302 537.66 37.9502 537.6 38.0402C537.67 38.0702 537.73 38.1402 537.79 38.1202C537.88 38.1002 537.75 38.0102 537.83 37.9502C537.76 37.8802 537.87 37.7002 537.78 37.6102ZM542.08 33.8202C541.98 33.7302 541.86 33.6502 541.74 33.5902C541.7 33.5702 541.62 33.6102 541.56 33.6302C541.63 33.7302 541.84 33.7102 541.92 33.8102C541.96 33.8502 542.02 33.8602 542.07 33.8302L542.08 33.8202ZM541.39 28.5502C541.33 28.4502 541.26 28.3702 541.17 28.3002C541.06 28.3202 540.95 28.3502 540.85 28.3802C540.89 28.4502 540.95 28.3802 541 28.3802C541.09 28.3802 541.29 28.5802 541.4 28.5402L541.39 28.5502ZM537.46 47.2902C537.4 47.2102 537.32 47.1502 537.23 47.1002C537.18 47.0802 537.1 47.1302 537.03 47.1402C537.09 47.2202 537.22 47.1302 537.27 47.2102C537.32 47.1702 537.41 47.3202 537.46 47.2802V47.2902ZM541.52 54.1102C541.46 54.1102 541.33 54.2002 541.28 54.1902C541.3 54.2102 541.33 54.2302 541.36 54.2302C541.39 54.2302 541.5 54.1102 541.53 54.1002L541.52 54.1102ZM541.2 46.1102C541.17 46.1602 541.2 46.3302 541.18 46.3902C541.18 46.4002 541.22 46.4302 541.24 46.4502C541.27 46.3902 541.12 46.2802 541.15 46.2202C541.15 46.2102 541.23 46.1302 541.2 46.1102ZM537.87 48.5402C537.87 48.5402 537.78 48.4002 537.79 48.3602C537.75 48.3602 537.71 48.3802 537.67 48.3802C537.68 48.4102 537.84 48.3302 537.86 48.3502C537.86 48.3502 537.86 48.5402 537.88 48.5302L537.87 48.5402ZM539.77 42.9202C539.77 42.9202 539.81 42.7602 539.84 42.7402C539.82 42.7202 539.79 42.6802 539.78 42.6802C539.74 42.7002 539.9 42.7602 539.87 42.7802C539.9 42.7902 539.75 42.9002 539.78 42.9102L539.77 42.9202ZM539.49 45.3202C539.49 45.2502 539.47 45.1802 539.45 45.1102C539.45 45.1002 539.41 45.0902 539.38 45.0802C539.37 45.1102 539.55 45.1302 539.55 45.1602C539.55 45.1702 539.47 45.3102 539.49 45.3202ZM539.22 35.7702C539.22 35.7702 539.29 35.6202 539.28 35.5702C539.28 35.5402 539.25 35.5402 539.24 35.5602C539.18 35.6502 539.18 35.7602 539.22 35.7702ZM539.24 33.9202C539.29 33.9202 539.32 33.7502 539.31 33.7002C539.31 33.6702 539.27 33.6602 539.25 33.6902C539.19 33.7902 539.19 33.9102 539.25 33.9202H539.24ZM538.09 54.8602C538.16 54.8302 538.26 54.6902 538.33 54.6602C538.31 54.6302 538.3 54.5902 538.28 54.5902C538.22 54.5802 538.29 54.7102 538.23 54.7102C538.24 54.7602 538.07 54.8102 538.09 54.8602ZM537.38 53.3402C537.38 53.3402 537.23 53.2702 537.21 53.2402C537.19 53.2702 537.17 53.2902 537.16 53.3202C537.16 53.3502 537.2 53.1902 537.21 53.2202C537.23 53.1902 537.35 53.3702 537.37 53.3502L537.38 53.3402ZM541.18 50.2402C541.18 50.2402 541 50.1802 540.98 50.1502C540.95 50.1702 540.91 50.1902 540.91 50.2202C540.91 50.2502 540.96 50.0802 540.98 50.1002C541.01 50.0802 541.15 50.2602 541.18 50.2402ZM537.9 55.3902C537.9 55.3902 537.83 55.5502 537.84 55.5802C537.85 55.6102 537.89 55.6202 537.9 55.5802C537.95 55.4802 537.93 55.3802 537.9 55.3802V55.3902ZM539.16 50.6502C539.16 50.6502 539.31 50.7202 539.35 50.7002C539.38 50.6902 539.39 50.6602 539.35 50.6402C539.26 50.5902 539.16 50.6002 539.15 50.6402L539.16 50.6502ZM540.7 29.8202C540.7 29.8202 540.77 29.6702 540.76 29.6302C540.75 29.6002 540.72 29.5902 540.7 29.6302C540.65 29.7202 540.67 29.8302 540.7 29.8302V29.8202ZM541.48 43.1702C541.48 43.1702 541.31 43.1502 541.29 43.1302L541.22 43.1902C541.22 43.1902 541.29 43.0402 541.32 43.0702C541.33 43.0502 541.46 43.2002 541.47 43.1702H541.48ZM540.16 41.6202C540.16 41.6202 540.09 41.7702 540.1 41.8002C540.1 41.8302 540.14 41.8402 540.15 41.8002C540.2 41.7102 540.19 41.6202 540.15 41.6102L540.16 41.6202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M537.47 56.5601C537.28 56.5601 537.1 56.5101 536.94 56.4001C536.51 56.0901 536.85 55.5701 537.06 55.2601C537.07 55.2401 537.09 55.2101 537.09 55.1901C537.07 55.1901 537.05 55.1901 537.03 55.2001C536.8 55.2501 536.56 55.2001 536.36 55.0701C536.23 54.9901 536.14 54.8601 536.13 54.7001C536.13 54.5501 536.19 54.4001 536.32 54.3101C536.34 54.3001 536.36 54.2801 536.38 54.2701C536.2 54.1101 536.1 53.8801 536.09 53.6301C536.09 53.5701 536.1 53.5101 536.12 53.4501C536.03 53.4301 535.94 53.3701 535.88 53.3001C535.85 53.2601 535.83 53.2301 535.81 53.1801C535.75 53.1501 535.7 53.1001 535.66 53.0501C535.58 52.9301 535.56 52.7701 535.62 52.6401C535.68 52.5001 535.74 52.3601 535.8 52.2201L535.88 52.0301C535.88 52.0301 535.88 51.9401 535.88 51.8801C535.86 51.7201 535.88 51.5601 535.91 51.4101C535.92 51.3401 535.92 51.2801 535.91 51.2101C535.91 51.1401 535.9 51.0601 535.89 50.9801C535.92 50.6101 536.15 50.2801 536.48 50.1201V50.1001C536.52 49.8901 536.63 49.7001 536.81 49.5901C536.7 49.5701 536.59 49.5301 536.49 49.4701C536.38 49.3901 536.28 49.2901 536.22 49.1701C536.03 48.9801 535.62 48.5201 535.95 48.1601C536.06 48.0501 536.2 47.9501 536.34 47.8801C536.3 47.8301 536.27 47.7801 536.25 47.7201C536.19 47.5601 536.18 47.3801 536.22 47.2101C536.07 47.1601 535.94 47.0701 535.84 46.9501C535.66 46.7301 535.53 46.4801 535.44 46.2201C535.38 45.9801 535.42 45.7201 535.55 45.5001C535.57 45.4601 535.59 45.4201 535.6 45.3801C535.61 45.1201 535.69 44.8701 535.83 44.6501C535.91 44.5401 536 44.4401 536.11 44.3601C536 44.1801 536 43.9601 536.09 43.7701C536.15 43.6701 536.26 43.6001 536.37 43.5701C536.17 43.4301 536.05 43.2001 536.04 42.9601C535.92 42.9101 535.83 42.8101 535.79 42.6901C535.75 42.5701 535.76 42.4301 535.82 42.3201C535.82 42.3201 535.82 42.2501 535.83 42.2101C535.83 42.0301 535.89 41.8501 535.98 41.6901C536.01 41.6401 536.05 41.5901 536.09 41.5501C535.93 41.4501 535.8 41.3201 535.69 41.1701L535.63 41.1001C535.16 40.5601 535.05 40.1501 535.29 39.8601C535.48 39.6801 535.77 39.6401 535.99 39.7701C536.02 39.7801 536.06 39.8001 536.1 39.8101C536.09 39.6701 536.14 39.5401 536.25 39.4501C536.31 39.4001 536.37 39.3501 536.44 39.3101C536.47 39.2901 536.51 39.2601 536.54 39.2401C536.53 39.1701 536.51 39.0801 536.49 39.0201C536.36 38.9001 536.3 38.7201 536.33 38.5501C536.33 38.5401 536.33 38.5201 536.34 38.5101C536.34 38.4001 536.34 38.2801 536.35 38.1701C536.35 38.1301 536.36 38.0801 536.36 38.0401C536.3 37.9201 536.27 37.8001 536.25 37.6701C536.25 37.6101 536.22 37.5401 536.2 37.4801C536.17 37.4201 536.13 37.3701 536.08 37.3201C535.98 37.2101 535.9 37.0801 535.84 36.9501C535.8 36.8701 535.7 36.6301 536.09 36.2101C536.22 36.0301 536.44 35.9401 536.66 35.9801C536.63 35.8501 536.65 35.7101 536.71 35.5901C536.62 35.5901 536.54 35.5901 536.46 35.5601C536.39 35.5601 536.32 35.5601 536.26 35.5301C536.15 35.4901 536.06 35.4001 536.01 35.2901C535.92 35.1601 535.89 35.0001 535.93 34.8501C535.93 34.8701 535.91 34.8401 535.9 34.8001C535.83 34.6201 535.81 34.4301 535.86 34.2401C535.9 34.1201 535.97 34.0101 536.07 33.9301C536.06 33.8401 536.07 33.7501 536.11 33.6701C536.06 33.5601 536.05 33.4201 536.11 33.3101C536.16 33.2001 536.25 33.1101 536.37 33.0801C536.39 32.8801 536.46 32.6901 536.59 32.5401C536.62 32.5101 536.65 32.4701 536.66 32.4301C536.59 32.4001 536.52 32.3601 536.47 32.3101C536.47 32.3101 535.91 31.8001 535.93 31.4501C535.93 31.4301 535.93 31.4101 535.93 31.3901C535.91 31.3501 535.88 31.3201 535.86 31.2801C535.76 31.0901 535.75 30.8601 535.84 30.6701C535.89 30.5801 535.95 30.4901 536.03 30.4201C535.96 30.3001 535.94 30.1601 535.98 30.0301C536.04 29.8101 536.17 29.6101 536.35 29.4701C536.37 29.4501 536.39 29.4401 536.4 29.4201C536.53 29.1601 536.83 29.0301 537.11 29.1101C537.15 29.1101 537.19 29.1201 537.23 29.1201H537.22H537.21C537.07 29.0301 536.96 28.9101 536.87 28.7801C536.84 28.7201 536.79 28.6601 536.75 28.6001C536.69 28.5101 536.63 28.4101 536.57 28.3201C536.57 28.3201 536.21 27.5801 536.67 27.3001C536.82 27.2201 536.98 27.1601 537.15 27.1401C537.22 27.1401 537.28 27.1101 537.34 27.0901C537.39 27.0501 537.44 27.0001 537.49 26.9501C537.6 26.8201 537.73 26.7101 537.88 26.6301C537.95 26.5901 538.01 26.5401 538.07 26.4901C538.19 26.3901 538.32 26.3001 538.46 26.2301C538.6 26.1701 538.75 26.1601 538.89 26.1801C538.91 26.0701 538.96 25.9701 539.02 25.8801C539.23 25.6401 539.48 25.4301 539.76 25.2801C540.05 25.1601 540.38 25.1901 540.65 25.3701C540.8 25.4401 540.9 25.5901 540.93 25.7501C540.93 25.8901 540.93 26.0301 540.91 26.1701C540.91 26.2001 540.91 26.2301 540.9 26.2601H540.95C541.14 26.2901 541.33 26.3601 541.49 26.4801L541.61 26.5801C541.72 26.6801 541.83 26.7601 541.95 26.8401C542.29 27.0801 542.48 27.4701 542.47 27.8901C542.47 28.0501 542.45 28.2101 542.41 28.3701C542.48 28.4901 542.49 28.6301 542.44 28.7501C542.53 28.8101 542.6 28.9101 542.62 29.0201L542.66 29.2001C542.69 29.2701 542.72 29.3301 542.76 29.3901C542.83 29.5101 542.89 29.6501 542.94 29.7801C542.99 29.9901 542.98 30.2001 542.91 30.4001C542.89 30.4501 542.88 30.5101 542.88 30.5601C542.88 30.5901 542.89 30.6201 542.9 30.6501C542.99 30.9001 542.92 31.1801 542.72 31.3601C542.69 31.3901 542.65 31.4101 542.62 31.4301C542.72 31.5701 542.73 31.7501 542.66 31.9001C542.65 31.9601 542.64 32.0301 542.65 32.0901C542.65 32.1901 542.65 32.2901 542.64 32.3901C542.6 32.5801 542.51 32.7501 542.39 32.8901L542.34 32.9601C542.36 33.0201 542.4 33.0901 542.43 33.1501C542.48 33.2401 542.52 33.3301 542.56 33.4101C542.55 33.3801 542.6 33.4101 542.64 33.4401C542.81 33.5301 542.94 33.6601 543.04 33.8201C543.13 34.0201 543.11 34.2501 543 34.4401C543 34.4701 543 34.5001 543.02 34.5201C543.07 34.6701 543.09 34.8201 543.07 34.9701C543.05 35.1101 543 35.2401 542.93 35.3601C542.91 35.4001 542.89 35.4301 542.88 35.4701C542.88 35.5901 542.85 35.7101 542.82 35.8301C542.8 35.8901 542.79 35.9401 542.78 36.0001C542.78 36.0601 542.8 36.1301 542.81 36.1901C542.84 36.3101 542.86 36.4401 542.87 36.5701C542.87 36.7001 542.85 36.8301 542.83 36.9601C542.82 37.0301 542.81 37.0901 542.8 37.1601C542.78 37.3501 542.71 37.5201 542.6 37.6701C542.58 37.7001 542.56 37.7301 542.54 37.7601C542.54 37.7501 542.55 37.7801 542.56 37.8201C542.64 38.1201 542.53 38.4501 542.29 38.6401C542.17 38.7201 542.03 38.7601 541.88 38.7601C541.88 38.7901 541.89 38.8201 541.89 38.8501C541.89 39.1101 541.82 39.3601 541.72 39.5901C541.63 39.7501 541.53 39.9001 541.41 40.0301C541.35 40.1001 541.3 40.1701 541.25 40.2401C541.16 40.3801 541 40.4501 540.83 40.4401C540.83 40.4401 540.85 40.5501 540.87 40.5701C540.89 40.6001 540.92 40.6201 540.95 40.6401C541.1 40.7501 541.2 40.8901 541.26 41.0701C541.29 41.1201 541.31 41.1601 541.34 41.2101C541.36 41.2001 541.37 41.1801 541.39 41.1701C541.5 41.0101 541.69 40.9301 541.88 40.9601C542.1 41.0101 542.27 41.1801 542.33 41.4001C542.52 41.4501 542.66 41.5901 542.73 41.7701C542.79 41.9501 542.76 42.1501 542.64 42.3101V42.3401C542.7 42.5501 542.67 42.7701 542.56 42.9501C542.49 43.0501 542.39 43.1301 542.27 43.1801C542.55 43.5101 542.34 43.9101 542.22 44.1601L542.18 44.2401C542.07 44.5201 541.83 44.7301 541.53 44.8001C541.45 44.8201 541.37 44.8301 541.28 44.8401C541.25 44.8401 541.21 44.8401 541.18 44.8501C541.18 44.8901 541.18 44.9501 541.18 45.0201C541.2 45.0401 541.23 45.0601 541.25 45.0801C541.31 45.1401 541.38 45.2001 541.43 45.2601C541.5 45.3401 541.57 45.4401 541.63 45.5301C541.69 45.6301 541.77 45.7201 541.85 45.8001C542.07 45.9401 542.25 46.1501 542.33 46.4001C542.38 46.6301 542.29 46.8701 542.11 47.0201C542.07 47.0601 542.03 47.1001 542 47.1401C542 47.1901 542 47.2301 542 47.2801L542.03 47.3001C542.24 47.4101 542.39 47.6201 542.43 47.8601C542.43 48.0901 542.34 48.3101 542.15 48.4501C542.23 48.6001 542.28 48.7501 542.3 48.9201C542.31 49.0601 542.29 49.2001 542.22 49.3201C542.28 49.3501 542.33 49.3901 542.37 49.4401C542.43 49.5001 542.76 50.0301 542.58 50.3801C542.58 50.4001 542.58 50.4301 542.58 50.4601C542.58 50.5601 542.58 50.6701 542.57 50.7701C542.57 50.8501 542.54 50.9201 542.53 51.0001C542.51 51.0901 542.49 51.1901 542.49 51.2801C542.49 51.3601 542.49 51.4301 542.51 51.5101C542.53 51.6201 542.54 51.7301 542.54 51.8501C542.54 52.0101 542.51 52.1601 542.45 52.3001C542.43 52.3501 542.42 52.3901 542.41 52.4401C542.41 52.4501 542.44 52.5201 542.46 52.5601C542.54 52.7101 542.59 52.8701 542.59 53.0401C542.58 53.2501 542.5 53.4501 542.37 53.6201C542.35 53.6501 542.33 53.6801 542.31 53.7201C542.28 53.9201 542.2 54.1001 542.07 54.2501L542.09 54.3201C542.2 54.5501 542.19 54.8301 542.06 55.0501C541.9 55.2401 541.67 55.3601 541.42 55.3901C541.44 55.4901 541.44 55.5801 541.42 55.6801H541.41C541.46 55.9001 541.36 56.1101 541.18 56.2001C540.99 56.2901 540.76 56.2501 540.63 56.0901C540.57 56.1301 540.5 56.1601 540.43 56.1801C540.26 56.2301 540.08 56.2201 539.92 56.1601C539.83 56.2501 539.7 56.3001 539.57 56.2901C539.46 56.2801 539.36 56.2301 539.29 56.1601C539.12 56.1801 538.96 56.1601 538.8 56.1001C538.7 56.1901 538.59 56.2601 538.46 56.3001C538.35 56.3301 538.24 56.3601 538.13 56.3801C538.06 56.3901 537.99 56.4101 537.93 56.4301C537.77 56.4801 537.61 56.5101 537.45 56.5101L537.47 56.5601ZM538.04 55.5301H538.06C538.11 55.5301 538.16 55.5301 538.21 55.5101C538.22 55.4901 538.24 55.4801 538.26 55.4601L538.03 55.5301H538.04ZM538.34 55.2501C538.34 55.2501 538.37 55.3301 538.38 55.3801C538.54 55.2601 538.73 55.2101 538.93 55.2401C538.93 55.2201 538.94 55.2001 538.95 55.1801C539.04 54.9601 539.28 54.8301 539.51 54.8801C539.56 54.9001 539.62 54.9301 539.66 54.9701L539.69 54.9901C539.83 54.9901 539.97 55.0401 540.07 55.1501C540.13 55.2101 540.18 55.2801 540.2 55.3701L540.23 55.3901L540.26 55.3601C540.26 55.2101 540.3 55.0601 540.39 54.9301C540.54 54.7301 540.78 54.6101 541.04 54.6101L541.02 54.5901C540.86 54.4701 540.8 54.2501 540.87 54.0601C540.93 53.9201 541.05 53.8201 541.19 53.7901C541.27 53.7501 541.36 53.7101 541.46 53.7001C541.46 53.7001 541.46 53.6801 541.46 53.6701C541.49 53.5101 541.55 53.3501 541.66 53.2201C541.68 53.1801 541.71 53.1501 541.73 53.1101C541.73 53.1101 541.7 53.0701 541.68 53.0401C541.6 52.8901 541.56 52.7301 541.54 52.5601C541.54 52.4001 541.57 52.2501 541.63 52.1001C541.65 52.0501 541.66 52.0101 541.67 51.9601C541.67 51.8801 541.66 51.8101 541.64 51.7401C541.62 51.6201 541.61 51.4901 541.61 51.3701C541.61 51.2201 541.64 51.0601 541.67 50.9201C541.68 50.8601 541.69 50.8101 541.7 50.7601C541.7 50.7001 541.7 50.6401 541.7 50.5701C541.7 50.4501 541.7 50.3301 541.73 50.2101C541.73 50.1901 541.72 50.1701 541.71 50.1601C541.67 50.1401 541.62 50.1301 541.58 50.1101C541.65 50.2901 541.6 50.4901 541.45 50.6201C541.32 50.7401 541.13 50.7601 540.97 50.6901C540.91 50.7101 540.85 50.7101 540.79 50.6901C540.58 50.6401 540.43 50.4401 540.44 50.2201C540.44 50.1701 540.46 50.1201 540.49 50.0701C540.54 49.8801 540.7 49.7401 540.89 49.6901C540.96 49.6801 541.04 49.6901 541.11 49.7001C541.08 49.5901 541.1 49.4801 541.15 49.3801C541.21 49.2801 541.27 49.1901 541.35 49.1001C541.37 49.0801 541.39 49.0601 541.41 49.0301C541.39 48.9901 541.37 48.9301 541.35 48.8901C541.19 48.6601 541.18 48.3601 541.32 48.1301C541.35 48.0901 541.38 48.0601 541.41 48.0301C541.31 47.9501 541.23 47.8401 541.19 47.7201C541.11 47.4601 541.11 47.1801 541.19 46.9301C541.09 46.9201 541 46.8801 540.93 46.8101C540.75 46.6201 540.67 46.3601 540.73 46.1001C540.74 46.0701 540.75 46.0501 540.77 46.0301C540.77 46.0101 540.79 45.9801 540.8 45.9601L540.78 45.9401C540.78 45.9401 540.71 45.8701 540.68 45.8401C540.5 45.7101 540.38 45.5101 540.33 45.2901C540.26 44.9501 540.33 44.5901 540.52 44.3001C540.7 44.1301 540.93 44.0401 541.18 44.0301C541.24 44.0301 541.29 44.0201 541.34 44.0001C541.36 43.9801 541.38 43.9601 541.39 43.9301L541.44 43.8301C541.44 43.8301 541.48 43.7501 541.5 43.7101C541.48 43.6901 541.47 43.6701 541.45 43.6501C541.43 43.6501 541.41 43.6501 541.39 43.6501C541.37 43.6501 541.36 43.6501 541.34 43.6601C541.3 43.6701 541.26 43.6701 541.22 43.6701C540.98 43.8201 540.69 43.8501 540.43 43.7401C540.19 43.7401 539.98 43.6001 539.89 43.3801C539.77 43.4101 539.64 43.3901 539.54 43.3301C539.43 43.2701 539.36 43.1601 539.33 43.0401C539.31 42.9601 539.32 42.8801 539.34 42.8001C539.33 42.7601 539.32 42.7201 539.33 42.6801C539.35 42.5101 539.45 42.3701 539.6 42.3001C539.8 42.2301 540.02 42.3001 540.16 42.4501C540.16 42.4501 540.19 42.4901 540.2 42.5001C540.24 42.4601 540.29 42.4301 540.34 42.4101C540.32 42.3701 540.3 42.3301 540.3 42.2801V42.2601C540.23 42.2901 540.17 42.3001 540.1 42.2901C539.91 42.2701 539.75 42.1401 539.68 41.9601C539.63 41.7501 539.68 41.5201 539.81 41.3501C539.91 41.2401 540.05 41.1801 540.2 41.1901C539.96 40.8701 539.9 40.4601 540.04 40.0901C540.09 39.9801 540.17 39.8801 540.26 39.8001C540.24 39.7901 540.23 39.7701 540.21 39.7501C540.12 39.6401 540.08 39.5001 540.11 39.3601C540.14 39.0601 540.24 38.7701 540.42 38.5301L540.47 38.4801C540.68 38.2301 540.95 38.0401 541.25 37.9101C541.38 37.8701 541.52 37.8601 541.66 37.8801C541.66 37.8001 541.66 37.7201 541.66 37.6401C541.69 37.4801 541.76 37.3401 541.85 37.2101C541.87 37.1801 541.89 37.1501 541.91 37.1201C541.91 37.0301 541.92 36.9301 541.94 36.8401C541.96 36.7701 541.97 36.6901 541.97 36.6201C541.97 36.5601 541.95 36.4901 541.94 36.4301C541.91 36.3101 541.89 36.1801 541.88 36.0501C541.88 35.9101 541.9 35.7701 541.95 35.6301C541.97 35.5801 541.98 35.5201 541.99 35.4601C542 35.2901 542.05 35.1301 542.14 34.9901C542.16 34.9501 542.18 34.9201 542.19 34.8801C542.18 34.8601 542.17 34.8301 542.16 34.8101C542.1 34.6401 542.09 34.4701 542.12 34.2901C541.95 34.3201 541.78 34.2801 541.64 34.1701C541.46 34.1401 541.3 34.0401 541.18 33.8901C541.1 33.7701 541.08 33.6101 541.13 33.4801C541.18 33.3401 541.3 33.2401 541.44 33.2001C541.44 33.2001 541.42 33.1201 541.41 33.0701C541.39 32.8101 541.48 32.5601 541.66 32.3701C541.69 32.3301 541.72 32.2901 541.75 32.2401C541.75 32.2301 541.75 32.1801 541.75 32.1301C541.75 32.1101 541.75 32.0901 541.75 32.0701C541.71 32.0601 541.68 32.0401 541.65 32.0201C541.49 31.9201 541.39 31.7401 541.41 31.5501C541.39 31.5101 541.38 31.4701 541.38 31.4301C541.37 31.3101 541.4 31.1901 541.48 31.1001C541.53 30.8701 541.71 30.7001 541.94 30.6701H542C542 30.5101 542.01 30.3501 542.06 30.2001C542.08 30.1501 542.09 30.0901 542.09 30.0401C542.07 29.9901 542.04 29.9401 542.01 29.8901C541.83 29.9101 541.71 29.8901 541.64 29.9101C541.51 29.9401 541.37 29.9101 541.26 29.8401C541.24 29.8201 541.21 29.8001 541.19 29.7801C541.18 29.9001 541.13 30.0101 541.06 30.1001C540.96 30.2201 540.8 30.2901 540.64 30.2701C540.49 30.2401 540.35 30.1501 540.27 30.0101C540.18 29.8201 540.19 29.6001 540.29 29.4101C540.39 29.2501 540.56 29.1501 540.75 29.1501C540.87 29.1501 540.98 29.2101 541.06 29.3001C541.05 29.1801 541.06 29.0601 541.07 28.9401C541.02 28.9201 540.98 28.8901 540.94 28.8701C540.75 28.8901 540.56 28.8001 540.46 28.6301C540.38 28.5101 540.37 28.3601 540.42 28.2301C540.47 28.1001 540.58 28.0001 540.72 27.9601L540.79 27.9401C540.9 27.9001 541.01 27.8801 541.12 27.8601C541.29 27.8601 541.46 27.9201 541.57 28.0501C541.57 28.0101 541.58 27.9801 541.59 27.9401C541.57 27.6601 541.52 27.6201 541.52 27.6201C541.35 27.5201 541.19 27.4001 541.05 27.2701L540.94 27.1801C540.94 27.1801 540.85 27.1701 540.8 27.1601C540.56 27.1601 540.34 27.0601 540.19 26.8701C540.04 26.6901 539.98 26.4501 540.02 26.2201C539.94 26.2801 539.86 26.3401 539.79 26.4101C539.79 26.4501 539.79 26.5001 539.8 26.5401C539.8 26.5801 539.8 26.6101 539.81 26.6501C539.92 26.7701 539.96 26.9401 539.91 27.1001C539.86 27.2601 539.72 27.3701 539.56 27.4001C539.54 27.4001 539.5 27.4201 539.47 27.4301C539.33 27.4801 538.91 27.6401 538.73 27.2501C538.72 27.2201 538.71 27.1901 538.7 27.1601L538.64 27.2101C538.53 27.3001 538.42 27.3801 538.3 27.4501C538.25 27.4901 538.2 27.5401 538.15 27.5901L538.12 27.6201C538.3 27.5901 538.49 27.6301 538.64 27.7401C538.66 27.7301 538.69 27.7201 538.71 27.7101C539.13 27.5101 539.62 27.6501 539.88 28.0301C540.02 28.2901 539.91 28.5501 539.76 28.8701L539.72 28.9601C539.72 28.9601 539.7 29.0201 539.69 29.0601C539.66 29.2601 539.54 29.4301 539.37 29.5301C539.2 29.6301 538.99 29.6501 538.81 29.5901C538.86 29.6801 538.89 29.7701 538.89 29.8801C538.89 29.9001 538.89 29.9201 538.89 29.9401C538.89 30.1301 538.76 30.2901 538.59 30.3501C538.48 30.3901 538.36 30.3801 538.26 30.3401H538.18C538.05 30.4601 537.87 30.4901 537.72 30.4301C537.56 30.3701 537.46 30.2201 537.44 30.0501C537.37 30.0701 537.3 30.0801 537.24 30.0801C537.19 30.0801 537.14 30.0801 537.09 30.0801C537.06 30.1201 537.02 30.1501 536.99 30.1901C537.02 30.2201 537.05 30.2501 537.08 30.2901C537.1 30.2901 537.11 30.3101 537.13 30.3201C537.28 30.4301 537.35 30.6101 537.31 30.7901C537.27 30.9701 537.12 31.1001 536.94 31.1301C536.91 31.1301 536.87 31.1401 536.84 31.1501C536.91 31.2501 536.93 31.3801 536.92 31.5001V31.5201C536.96 31.5801 537.01 31.6401 537.06 31.6901C537.04 31.6701 537.07 31.6701 537.1 31.6701C537.24 31.6701 537.37 31.7001 537.5 31.7501C537.67 31.8201 537.79 31.9701 537.81 32.1601C537.84 32.3701 537.75 32.5801 537.57 32.7001H537.55C537.5 32.8901 537.41 33.0701 537.28 33.2001C537.28 33.2301 537.28 33.2601 537.28 33.2801C537.32 33.3001 537.36 33.3101 537.4 33.3401C537.53 33.4201 537.62 33.5601 537.62 33.7201C537.62 33.8801 537.55 34.0201 537.42 34.1101C537.35 34.1501 537.28 34.1901 537.2 34.2101C537.17 34.2801 537.12 34.3401 537.07 34.3901C537.22 34.3401 537.38 34.3101 537.53 34.3101C537.59 34.3101 537.64 34.3101 537.7 34.2901C537.79 34.2601 537.87 34.2201 537.95 34.1701C538.14 34.0201 538.39 34.0001 538.6 34.1201C538.71 34.1901 538.78 34.3101 538.8 34.4401C538.82 34.5701 538.78 34.7001 538.69 34.8001C538.66 34.8501 538.64 34.9001 538.62 34.9501C538.57 35.1101 538.49 35.2501 538.39 35.3801C538.26 35.5101 538.1 35.6101 537.93 35.6701C537.88 35.6901 537.83 35.7101 537.79 35.7401C537.76 35.7801 537.73 35.8201 537.7 35.8601C537.75 35.9201 537.79 35.9801 537.81 36.0501C537.85 36.1601 537.85 36.2901 537.81 36.4001C537.79 36.4501 537.75 36.5001 537.71 36.5401C537.68 36.7401 537.58 36.9101 537.43 37.0301C537.33 37.1101 537.2 37.1501 537.07 37.1401C537.13 37.2801 537.17 37.4201 537.19 37.5601C537.19 37.6301 537.22 37.6901 537.24 37.7501C537.24 37.7701 537.25 37.7801 537.26 37.8001V37.7601C537.31 37.6301 537.36 37.5101 537.44 37.4001C537.52 37.2901 537.64 37.2201 537.78 37.2101C537.92 37.2001 538.05 37.2501 538.14 37.3501C538.27 37.4901 538.32 37.6901 538.29 37.8801C538.31 37.9301 538.31 37.9901 538.3 38.0501C538.28 38.1601 538.26 38.2601 538.24 38.3701C538.17 38.4801 538.06 38.5701 537.93 38.6101C537.76 38.6501 537.59 38.6101 537.45 38.5101C537.54 38.6401 537.55 38.8101 537.48 38.9601C537.48 38.9801 537.46 39.0001 537.45 39.0101C537.48 39.1301 537.5 39.2601 537.5 39.3901C537.73 39.4801 537.91 39.6501 537.99 39.8801C538.01 39.9201 538.03 39.9601 538.05 39.9901C538.04 39.9701 538.13 39.9901 538.19 39.9901C538.32 40.0101 538.45 40.0401 538.57 40.0901C538.71 40.1501 538.81 40.2801 538.84 40.4301C538.86 40.5901 538.8 40.7601 538.68 40.8801C538.56 41.0401 538.34 41.1101 538.15 41.0401C538.15 41.0401 538.12 41.0601 538.09 41.0701C537.91 41.1501 537.72 41.1701 537.53 41.1301C537.3 41.0601 537.08 40.9701 536.88 40.8401C536.82 40.8001 536.76 40.7601 536.72 40.7001C536.66 40.7401 536.6 40.7801 536.53 40.8001C536.55 40.8201 536.57 40.8401 536.59 40.8501C536.88 41.0101 537.17 41.1801 537.2 41.5501C537.21 41.8001 537.08 42.0401 536.87 42.1801L536.84 42.2101C537.05 42.2501 537.27 42.3001 537.47 42.3701C537.41 42.2501 537.41 42.1001 537.47 41.9701C537.53 41.8401 537.64 41.7401 537.77 41.6901V41.6701C537.82 41.6201 537.87 41.5701 537.92 41.5401L538.12 41.4201C538.12 41.4201 538.19 41.3801 538.22 41.3601C538.42 41.2701 538.67 41.3401 538.78 41.5301C538.9 41.7201 538.86 41.9701 538.69 42.1101C538.66 42.1601 538.63 42.2001 538.6 42.2401C538.6 42.3401 538.57 42.4301 538.52 42.5201C538.45 42.6601 538.3 42.7401 538.14 42.7301C538.16 42.7401 538.18 42.7601 538.2 42.7801C538.32 42.8801 538.38 43.0301 538.37 43.1801C538.35 43.3301 538.26 43.4701 538.12 43.5301C538.07 43.6101 538.01 43.6901 537.93 43.7501C537.82 44.0001 537.63 44.2101 537.4 44.3601L537.37 44.3801C537.35 44.4601 537.3 44.5301 537.24 44.5901C537.19 44.7701 537.07 44.9301 536.9 45.0201C536.79 45.0601 536.69 45.1301 536.61 45.2301C536.56 45.3301 536.53 45.4401 536.53 45.5501C536.51 45.7001 536.46 45.8401 536.39 45.9701C536.38 46.0001 536.36 46.0401 536.34 46.0701C536.39 46.2101 536.47 46.3401 536.56 46.4501C536.56 46.4301 536.58 46.4501 536.61 46.4501C536.77 46.5101 536.9 46.6001 537.01 46.7201C537.13 46.6801 537.27 46.6801 537.39 46.7201C537.58 46.8001 537.74 46.9401 537.86 47.1101C537.96 47.2901 537.92 47.5201 537.77 47.6601C537.68 47.7401 537.57 47.7801 537.45 47.7801C537.45 47.7801 537.48 47.8501 537.49 47.8801C537.5 47.9201 537.51 47.9501 537.51 47.9901C537.53 47.9901 537.55 47.9801 537.57 47.9701H537.64C537.64 47.9701 537.69 47.9501 537.71 47.9501C537.9 47.9001 538.1 47.9601 538.21 48.1201C538.27 48.2201 538.3 48.3301 538.3 48.4401C538.32 48.5101 538.32 48.5801 538.3 48.6601C538.28 48.7801 538.21 48.8801 538.11 48.9401C538.27 49.1301 538.38 49.3501 538.46 49.5901C538.5 49.7001 538.5 49.8301 538.46 49.9401C538.41 50.0501 538.32 50.1401 538.2 50.1801C538.17 50.1901 538.14 50.2001 538.11 50.2201C538.11 50.2201 538.12 50.2401 538.12 50.2501C538.23 50.3601 538.32 50.4901 538.38 50.6401C538.43 50.7501 538.43 50.8801 538.38 50.9901C538.52 50.9501 538.67 50.9701 538.79 51.0301C538.83 51.0501 538.87 51.0801 538.9 51.1101C538.92 51.1201 538.93 51.1301 538.95 51.1401C539.02 51.1801 539.09 51.2301 539.15 51.2901C539.19 51.3201 539.23 51.3501 539.26 51.3901C539.34 51.4801 539.38 51.6101 539.37 51.7401C539.37 51.7401 539.37 51.7801 539.37 51.7901C539.51 51.9901 539.47 52.2601 539.28 52.4101C539.21 52.4701 539.13 52.5201 539.06 52.5701C539 52.6101 538.93 52.6601 538.87 52.7001C538.73 52.8101 538.54 52.8201 538.38 52.7401C538.22 52.6501 538.13 52.4901 538.15 52.3101C538.17 52.1601 538.23 52.0201 538.32 51.9101L538.29 51.8901L538.23 51.8701C538.23 51.8701 538.14 51.8401 538.09 51.8201C537.91 51.7201 537.82 51.5001 537.88 51.3001C537.75 51.3201 537.62 51.3301 537.48 51.3301C537.37 51.4801 537.18 51.5501 536.99 51.5001C536.91 51.4701 536.83 51.4301 536.77 51.3701C536.77 51.4801 536.76 51.5901 536.73 51.7001C536.73 51.7501 536.73 51.8001 536.73 51.8501C536.73 51.8701 536.73 51.9001 536.73 51.9301H536.76C536.91 51.9901 537.02 52.1201 537.05 52.2801C537.07 52.3601 537.1 52.4301 537.13 52.5001C537.17 52.5901 537.21 52.6901 537.23 52.7901C537.35 52.8101 537.46 52.8801 537.54 52.9701C537.62 53.0201 537.69 53.1001 537.73 53.1901C537.79 53.3301 537.77 53.4801 537.69 53.6101C537.61 53.7301 537.49 53.8001 537.35 53.8101C537.29 53.8101 537.23 53.8101 537.17 53.7901C537.25 53.8601 537.31 53.9401 537.33 54.0401C537.35 54.1401 537.36 54.2301 537.34 54.3301C537.48 54.3601 537.61 54.4301 537.72 54.5301C537.73 54.5201 537.75 54.5001 537.76 54.4901C537.78 54.4101 537.83 54.3401 537.89 54.2801C537.96 54.2201 538.04 54.1801 538.12 54.1701C538.09 54.1101 538.06 54.0601 538.04 54.0001C537.99 53.8901 537.87 53.6201 538.47 52.9701C538.57 52.8601 538.72 52.8101 538.87 52.8301C539.02 52.8501 539.14 52.9501 539.21 53.0801C539.3 53.3101 539.34 53.5601 539.31 53.8101C539.31 53.8501 539.31 53.9001 539.31 53.9401C539.32 54.1901 539.2 54.4201 539 54.5701C538.91 54.6201 538.82 54.6401 538.72 54.6401C538.72 54.7101 538.72 54.7701 538.69 54.8401C538.65 54.9401 538.58 55.0201 538.49 55.0701C538.43 55.1401 538.35 55.2001 538.27 55.2501H538.34ZM538.12 55.0201C538.12 55.0201 538.18 55.0401 538.21 55.0501L538.23 54.8401L538.09 54.8801L538.06 54.8301L537.98 54.8701C537.98 54.8701 537.99 54.9201 538 54.9501C538.02 54.9701 538.05 54.9901 538.07 55.0001C538.09 55.0001 538.1 55.0101 538.12 55.0201ZM537.48 53.3601L537.61 53.4201C537.61 53.4201 537.61 53.3801 537.61 53.3701H537.48V53.3601ZM541.26 50.4801H541.27C541.27 50.4801 541.32 50.4201 541.33 50.3801C541.31 50.4101 541.29 50.4501 541.26 50.4801ZM541.19 50.2501L541.34 50.3501C541.34 50.3501 541.35 50.2901 541.35 50.2701H541.19V50.2501ZM537 48.7201C537 48.7201 537.07 48.7301 537.11 48.7401C537.27 48.7601 537.42 48.8101 537.55 48.8801H537.57C537.57 48.8801 537.52 48.8301 537.5 48.8001C537.38 48.7501 537.28 48.6501 537.24 48.5301C537.24 48.5001 537.22 48.4801 537.22 48.4501C537.13 48.5001 537.04 48.5501 536.95 48.6001H536.93C536.93 48.6001 536.98 48.6901 537 48.7201ZM540.81 46.3401C540.81 46.3401 540.86 46.4201 540.9 46.4501L540.98 46.3601L540.82 46.3401H540.81ZM540.83 46.2701L541 46.3301L540.84 46.2301L540.82 46.2701H540.83ZM539.73 43.1301C539.73 43.1301 539.81 43.1301 539.86 43.1301C539.86 43.0701 539.88 43.0201 539.9 42.9701L539.87 42.9001H539.83L539.74 43.1401L539.73 43.1301ZM541.39 42.6201C541.39 42.6201 541.43 42.6201 541.45 42.6301C541.47 42.6101 541.5 42.5901 541.53 42.5701H541.51C541.51 42.5701 541.45 42.6001 541.39 42.6201ZM541.75 42.4101C541.75 42.4101 541.69 42.4701 541.66 42.5001C541.69 42.4801 541.73 42.4701 541.76 42.4601V42.4101H541.75ZM540.09 42.0701C540.16 42.0801 540.24 42.0701 540.3 42.0501C540.32 41.9301 540.35 41.8201 540.39 41.7101L540.15 41.7901L540.09 42.0701ZM539.76 41.6101C539.73 41.6901 539.74 41.7701 539.78 41.8501L539.98 41.7501L539.76 41.6201V41.6101ZM540.73 29.7701L540.69 30.0501C540.85 30.0601 541.01 29.9801 541.09 29.8301C541.12 29.7501 541.11 29.6601 541.07 29.5901L540.73 29.7701ZM540.37 29.5301C540.3 29.5901 540.29 29.7001 540.33 29.7801L540.56 29.7001L540.37 29.5301ZM538.81 28.6501C538.81 28.6501 538.86 28.6601 538.89 28.6701C538.89 28.6501 538.9 28.6301 538.91 28.6101C538.88 28.6201 538.85 28.6401 538.81 28.6501ZM539.32 51.1601C539.16 51.1601 539.01 51.1101 538.88 51.0201C538.76 50.9201 538.69 50.7601 538.71 50.6001C538.72 50.5201 538.75 50.4601 538.79 50.4001C538.79 50.3101 538.8 50.2101 538.85 50.1301C538.93 50.0101 539.05 49.9201 539.19 49.8701C539.22 49.8601 539.21 49.8701 539.19 49.8901C539.21 49.8701 539.23 49.8501 539.26 49.8401V49.8001C539.2 49.7701 539.12 49.7401 539.06 49.7101C539.04 49.7001 539.02 49.6901 538.99 49.6801C538.78 49.7001 538.57 49.5901 538.48 49.4001C538.42 49.2801 538.42 49.1301 538.48 49.0101C538.54 48.8901 538.65 48.7901 538.78 48.7601L538.87 48.7301C539.01 48.6801 539.16 48.6601 539.3 48.6601C539.52 48.7001 539.73 48.8101 539.88 48.9701L540 49.0701C540.15 49.1801 540.21 49.3701 540.16 49.5401C540.15 49.5901 540.12 49.6401 540.09 49.6901C540.09 49.7001 540.1 49.7101 540.11 49.7201L540.15 49.7901L540.18 49.8401C540.29 50.0401 540.23 50.2901 540.04 50.4201C540.01 50.4901 539.96 50.5501 539.9 50.6001C539.88 50.6301 539.85 50.6501 539.82 50.6701C539.82 50.6901 539.82 50.7101 539.82 50.7201C539.8 50.9101 539.67 51.0701 539.49 51.1401C539.44 51.1601 539.38 51.1701 539.32 51.1701V51.1601ZM539.28 50.8301L539.15 51.0501C539.23 51.0801 539.31 51.0701 539.38 51.0301L539.28 50.8301ZM539.48 45.7601C539.41 45.7601 539.34 45.7401 539.28 45.7101C539.17 45.6501 539.09 45.5601 539.05 45.4401C539.05 45.4101 539.04 45.3901 539.03 45.3601C539.01 45.3401 538.99 45.3101 538.98 45.2801C538.92 45.1701 538.91 45.0501 538.94 44.9301C538.98 44.8101 539.07 44.7001 539.18 44.6501C539.3 44.6001 539.43 44.6001 539.55 44.6501C539.6 44.6601 539.64 44.6901 539.68 44.7101C539.85 44.7701 539.97 44.9301 539.98 45.1101C539.98 45.2101 539.96 45.3001 539.91 45.3901C539.91 45.4101 539.91 45.4301 539.9 45.4501C539.84 45.6301 539.67 45.7601 539.47 45.7601H539.48ZM539.37 39.3801C539.37 39.3801 539.34 39.3801 539.33 39.3801C539.32 39.3801 539.31 39.3801 539.3 39.3801C539.18 39.3801 539.05 39.3501 538.96 39.2701C538.87 39.1801 538.8 39.0701 538.77 38.9501V38.9101C538.63 38.7101 538.69 38.4401 538.88 38.3101C539.07 38.1701 539.34 38.2101 539.49 38.4001L539.61 38.5301C539.69 38.5701 539.75 38.6401 539.8 38.7201C539.89 38.9001 539.85 39.1101 539.71 39.2501C539.62 39.3401 539.5 39.3901 539.37 39.3901V39.3801ZM539.21 36.2101C539.21 36.2101 539.14 36.2101 539.11 36.2001C538.96 36.1601 538.84 36.0601 538.78 35.9201C538.71 35.7201 538.74 35.5101 538.85 35.3301C538.95 35.1601 539.15 35.0701 539.35 35.1001C539.54 35.1401 539.69 35.3001 539.73 35.4901C539.76 35.7101 539.69 35.9301 539.54 36.0901C539.45 36.1701 539.34 36.2101 539.22 36.2101H539.21ZM539.23 35.6201L538.83 35.6401C538.86 35.8201 539 35.9601 539.17 35.9901L539.22 35.7401H539.19L539.23 35.6301V35.6201ZM539.41 35.6501L539.61 35.7901C539.64 35.7201 539.63 35.6401 539.6 35.5701L539.41 35.6501ZM539.21 35.3101C539.04 35.3101 538.89 35.4101 538.82 35.5601L539.22 35.6001L539.31 35.3201C539.31 35.3201 539.24 35.3101 539.21 35.3101ZM539.23 34.3601C539.23 34.3601 539.18 34.3601 539.15 34.3601C539 34.3201 538.86 34.2201 538.79 34.0801C538.77 34.0301 538.75 33.9801 538.75 33.9201C538.64 33.9001 538.54 33.8601 538.45 33.8101C538.31 33.7601 538.17 33.7001 538.04 33.6401C537.98 33.6101 537.91 33.5801 537.84 33.5501C537.66 33.4701 537.55 33.2801 537.57 33.0801C537.57 32.9201 537.63 32.7801 537.75 32.7001C537.87 32.6101 538.02 32.5901 538.16 32.6401C538.32 32.6901 538.47 32.7501 538.66 32.8201L538.85 32.8901C538.78 32.8501 538.73 32.7901 538.7 32.7201C538.69 32.7001 538.68 32.6901 538.63 32.6401C538.56 32.5801 538.49 32.5101 538.43 32.4301C538.27 32.3201 538.2 32.1301 538.23 31.9501C538.27 31.7801 538.39 31.6401 538.55 31.5701C538.76 31.4701 539.01 31.4701 539.22 31.5701C539.44 31.7301 539.57 31.9701 539.58 32.2401C539.64 32.4201 539.61 32.6201 539.48 32.7601C539.39 32.9001 539.24 32.9701 539.08 32.9601H539.04L539.25 33.0401C539.36 33.0801 539.45 33.1701 539.5 33.2801C539.63 33.3501 539.72 33.4701 539.75 33.6101C539.79 33.8301 539.73 34.0601 539.59 34.2301C539.5 34.3201 539.37 34.3701 539.24 34.3701L539.23 34.3601ZM539.2 34.1101L539.24 33.8701L539.2 33.8901C539.11 33.9101 539.01 33.9301 538.91 33.9301C538.97 34.0301 539.07 34.0901 539.19 34.1101L539.23 33.9101L539.19 34.1101H539.2ZM539.44 33.7801L539.63 33.9101C539.66 33.8401 539.65 33.7601 539.62 33.7001L539.44 33.7801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.38 14.3C609.38 14.3 609.27 14.5201 609.21 14.5801C609.06 14.6801 608.91 14.7601 608.74 14.8401C608.73 14.8501 608.86 14.9501 608.84 14.9601C608.75 14.9601 608.63 15.04 608.54 15.04C608.53 15.04 608.59 15.0201 608.57 15.0201", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.55 15.5001C608.55 15.5001 608.46 15.5001 608.41 15.4801C608.22 15.4201 608.1 15.2401 608.1 15.0501C608.1 14.8901 608.2 14.7401 608.34 14.6601C608.36 14.6101 608.4 14.5602 608.44 14.5302C608.46 14.5102 608.47 14.5001 608.49 14.4901C608.58 14.4301 608.67 14.3901 608.76 14.3501C608.81 14.3301 608.85 14.3102 608.89 14.2802C608.91 14.2502 608.94 14.2201 608.95 14.1901C608.89 14.3401 608.92 14.5001 609.03 14.6201L609.08 14.5801C609.08 14.5801 609.11 14.6101 609.13 14.6301L609.64 13.9701L609.82 14.3101C609.79 14.5501 609.68 14.7601 609.51 14.9301C609.44 15.0001 609.36 15.0501 609.27 15.1001C609.23 15.2501 609.12 15.3701 608.98 15.4101C608.95 15.4101 608.92 15.4301 608.89 15.4301C608.78 15.4801 608.66 15.5101 608.54 15.5201L608.55 15.5001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.52 30.3301C477.6 30.2101 477.92 30.3301 478.11 30.2401C478.28 30.1601 478.27 29.7701 478.4 29.6601C478.55 29.5401 478.8 29.5101 478.75 29.3001C478.94 29.1901 479.13 29.0902 479.34 29.0302C479.28 29.0302 479.23 29.0301 479.17 29.0401C479.22 29.2001 479.22 29.3701 479.18 29.5201C479.14 29.6801 479.02 29.9201 479.26 30.0501C479.15 30.1801 479.16 30.2001 479.04 30.3301C479.03 30.3401 479.17 30.3801 479.16 30.3901C479 30.5101 478.81 30.5701 478.61 30.5701C478.42 30.5701 478.24 30.5501 478.06 30.5001C477.89 30.4501 477.72 30.3802 477.57 30.2802C477.55 30.2802 477.5 30.3401 477.51 30.3301H477.52Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M478.55 31.0301C478.4 31.0301 478.25 31.0101 478.1 30.9701L477.99 30.9501C477.84 30.9201 477.69 30.8601 477.55 30.7801C477.43 30.7801 477.31 30.7501 477.22 30.6801C477.05 30.5301 477.01 30.2801 477.13 30.0901C477.22 29.9301 477.39 29.8301 477.58 29.8301C477.65 29.8301 477.73 29.8301 477.8 29.8301H477.83V29.8101C477.87 29.6201 477.97 29.4501 478.11 29.3101C478.17 29.2601 478.23 29.2201 478.3 29.1901C478.34 28.9801 478.56 28.8601 478.83 28.7501C478.89 28.6801 478.97 28.6301 479.05 28.6001C479.11 28.5801 479.58 28.4601 479.75 28.8401C479.82 29.0101 479.79 29.2001 479.66 29.3301C479.66 29.4301 479.64 29.5301 479.62 29.6201L479.59 29.7101C479.75 29.8801 479.76 30.1401 479.62 30.3201C479.64 30.4601 479.6 30.6001 479.5 30.7001C479.27 30.9001 478.97 31.0101 478.67 31.0101C478.63 31.0101 478.59 31.0101 478.55 31.0101V31.0301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.88 49.72C514.88 49.72 514.94 49.8301 514.97 49.8201C515.12 49.7801 515.25 49.6201 515.4 49.5801C515.55 49.5401 515.68 49.3701 515.83 49.3301C515.86 49.4201 515.88 49.51 515.89 49.6C515.72 49.66 515.54 49.7001 515.36 49.7001C515.19 49.7301 515.09 49.82 514.91 49.66C514.9 49.65 514.87 49.7 514.88 49.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.97 50.2702C514.8 50.2702 514.65 50.1801 514.56 50.0401C514.53 50.0101 514.5 49.9702 514.48 49.9202C514.39 49.7002 514.46 49.4502 514.64 49.3002C514.77 49.2102 514.93 49.1902 515.07 49.2402C515.14 49.2002 515.21 49.1702 515.29 49.1502C515.29 49.1502 515.32 49.1201 515.35 49.1001C515.46 49.0101 515.59 48.9402 515.73 48.9002C515.94 48.8502 516.15 48.9502 516.24 49.1502C516.29 49.2502 516.5 49.7902 516.1 50.0002C515.93 50.0902 515.74 50.1302 515.55 50.1302C515.51 50.1302 515.47 50.1302 515.42 50.1402C515.4 50.1402 515.38 50.1401 515.36 50.1601C515.33 50.1601 515.29 50.1802 515.24 50.1902C515.19 50.2202 515.13 50.2402 515.08 50.2502C515.04 50.2602 515 50.2702 514.96 50.2702H514.97Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M570.1 33.3601C569.9 33.4501 569.74 33.6101 569.66 33.8201C569.56 34.0901 569.52 34.3101 569.46 34.2901C569.37 34.2501 569.33 34.1401 569.27 34.0201C569.48 34.0001 569.68 33.9401 569.87 33.8301C570.04 33.7201 570.04 33.3001 570.21 33.1901C570.4 33.0801 570.62 33.0501 570.83 33.1101C570.89 33.1301 570.66 33.2801 570.4 33.3301C570.14 33.3801 569.98 33.2701 570.11 33.3501L570.1 33.3601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M569.48 34.7402C569.42 34.7402 569.35 34.7302 569.3 34.7002C569.13 34.6202 568.99 34.4702 568.92 34.3002L568.89 34.2402C568.83 34.1202 568.82 33.9902 568.86 33.8602C568.9 33.7302 569.01 33.6401 569.13 33.6001C569.18 33.5901 569.23 33.5802 569.27 33.5702H569.28C569.37 33.3802 569.51 33.2102 569.68 33.0802C569.72 33.0302 569.77 32.9802 569.82 32.9502C569.86 32.9002 569.91 32.8602 569.96 32.8302C570.26 32.6502 570.61 32.6002 570.94 32.7002C571.14 32.7602 571.28 32.9501 571.27 33.1601C571.25 33.6101 570.59 33.7601 570.46 33.7901C570.44 33.7901 570.42 33.7901 570.41 33.7901C570.36 33.9601 570.25 34.1101 570.1 34.2201C570.06 34.2501 570.01 34.2702 569.96 34.3002C569.92 34.4702 569.81 34.6202 569.65 34.7102C569.59 34.7402 569.52 34.7502 569.45 34.7502L569.48 34.7402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.88 43.6501C586.88 43.6501 586.85 43.8801 586.82 43.9001C586.58 44.0401 586.36 44.2201 586.12 44.3601C586.1 44.2901 586.12 44.3101 586.12 44.3101C586.26 44.2601 586.32 43.9601 586.46 43.9101C586.6 43.8601 586.92 43.9701 587.06 43.9201C587.11 43.8401 586.89 43.6501 586.87 43.6501H586.88Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.12 44.8102C585.91 44.8102 585.73 44.6702 585.68 44.4702C585.64 44.3002 585.68 44.1202 585.8 43.9902C585.83 43.9702 585.85 43.9402 585.88 43.9302L585.9 43.9002C585.98 43.7102 586.14 43.5702 586.33 43.4902C586.38 43.4702 586.43 43.4602 586.48 43.4602C586.5 43.4302 586.52 43.3902 586.54 43.3602C586.62 43.2602 586.75 43.2102 586.87 43.2002C587.19 43.2002 587.4 43.5602 587.43 43.6002C587.54 43.7702 587.55 43.9802 587.45 44.1502C587.39 44.2502 587.3 44.3202 587.2 44.3502C587.1 44.3802 586.99 44.3902 586.89 44.3802C586.84 44.4102 586.79 44.4502 586.74 44.4802C586.61 44.5702 586.48 44.6602 586.34 44.7402C586.27 44.7802 586.19 44.8002 586.11 44.8002L586.12 44.8102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.38 51.6402C608.38 51.9402 608.49 52.0901 608.13 51.8701C608.04 51.8201 608.08 51.7702 608.03 51.6502C608.12 51.6502 608.13 51.5102 608.22 51.5202C608.32 51.5302 608.43 51.6401 608.53 51.6601C608.47 51.6101 608.38 51.6101 608.38 51.6301V51.6402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.36 52.4302C608.19 52.4202 608.04 52.3602 607.9 52.2602C607.75 52.1702 607.65 52.0202 607.62 51.8402C607.56 51.7002 607.58 51.5502 607.66 51.4202C607.7 51.3602 607.75 51.3102 607.8 51.2802C607.91 51.1402 608.09 51.0602 608.27 51.0802C608.39 51.1002 608.51 51.1402 608.61 51.2102C608.68 51.2302 608.75 51.2702 608.81 51.3202C608.97 51.4502 609.03 51.6802 608.93 51.8702C608.91 51.9202 608.87 51.9602 608.83 52.0002C608.8 52.2402 608.59 52.4302 608.35 52.4302H608.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M510.14 39.0901C509.98 39.0001 509.84 38.8801 509.72 38.7501C509.67 38.6901 509.69 38.7501 509.72 38.6201C509.79 38.6801 509.92 38.5601 509.95 38.6401C509.99 38.7601 510.03 38.8901 510.05 39.0201C510.15 39.0501 510.15 39.1001 510.14 39.0901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M510.14 39.5401C510.05 39.5401 509.96 39.5101 509.89 39.4701C509.69 39.3501 509.52 39.2101 509.37 39.0401C509.23 38.9001 509.2 38.6901 509.29 38.5101C509.32 38.3601 509.44 38.2401 509.58 38.1901C509.65 38.1701 509.73 38.1601 509.8 38.1801C510.04 38.1301 510.27 38.2501 510.37 38.4701C510.41 38.5601 510.44 38.6501 510.45 38.7501C510.53 38.8301 510.58 38.9401 510.59 39.0501C510.61 39.2401 510.5 39.4201 510.33 39.5001C510.27 39.5301 510.21 39.5401 510.14 39.5401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M510.06 29.3101C509.88 29.3601 509.7 29.3901 509.52 29.4101C509.52 29.4101 509.58 29.4101 509.6 29.3801C509.65 29.2901 509.69 29.2801 509.77 29.2301C509.79 29.2101 509.9 29.1901 510.05 29.3101H510.06Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M509.53 29.8601C509.53 29.8601 509.46 29.8601 509.43 29.8601C509.24 29.8201 509.1 29.6701 509.07 29.4801C509.04 29.2901 509.14 29.1001 509.32 29.0201C509.37 28.9601 509.44 28.9201 509.51 28.8801C509.78 28.7201 510.12 28.7601 510.34 28.9701C510.46 29.0701 510.52 29.2201 510.51 29.3701C510.49 29.5201 510.4 29.6601 510.26 29.7301C510.09 29.8001 509.91 29.8401 509.73 29.8501H509.71C509.65 29.8701 509.6 29.8801 509.54 29.8801L509.53 29.8601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.85 45.3802C613.8 45.2902 613.52 45.2302 613.5 45.1302C613.48 45.0202 613.7 44.8602 613.72 44.7402C613.82 44.7102 613.93 44.6802 614.03 44.6702C614.08 44.7902 613.78 44.9902 613.78 45.1102C613.78 45.1902 613.94 45.2902 613.89 45.3802C613.89 45.4002 613.85 45.3802 613.85 45.3802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.87 45.8302C613.81 45.8302 613.76 45.8301 613.7 45.8001C613.63 45.7801 613.57 45.7401 613.52 45.6901C613.51 45.6901 613.49 45.6801 613.48 45.6701C613.27 45.6001 613.11 45.4201 613.06 45.1901C613.05 44.9801 613.12 44.7801 613.26 44.6301C613.27 44.6201 613.28 44.6002 613.29 44.5902C613.33 44.4602 613.45 44.2601 613.98 44.2201C614.18 44.2001 614.37 44.3101 614.45 44.5001C614.53 44.7201 614.47 44.9701 614.31 45.1401C614.38 45.3001 614.37 45.4801 614.28 45.6201C614.24 45.6901 614.18 45.7402 614.12 45.7802C614.05 45.8202 613.96 45.8402 613.88 45.8402L613.87 45.8302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.21 44.2401C591.15 44.1501 591.09 44.0501 591.03 43.9501C591.09 43.9101 591.16 43.8901 591.24 43.8801C591.28 43.8801 591.22 43.8801 591.21 43.9101C591.2 43.9801 591.28 44.1301 591.21 44.2401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.21 44.6902C591.08 44.6902 590.96 44.6402 590.88 44.5402C590.8 44.4502 590.74 44.3502 590.7 44.2502C590.61 44.1502 590.57 44.0202 590.6 43.8902C590.62 43.7602 590.7 43.6402 590.81 43.5702C590.91 43.5102 591.01 43.4702 591.13 43.4502C591.13 43.4502 591.23 43.4302 591.28 43.4302C591.51 43.4302 591.69 43.6102 591.72 43.8302C591.72 43.8902 591.72 43.9502 591.7 44.0102C591.73 44.1802 591.7 44.3502 591.6 44.4902C591.52 44.6102 591.4 44.6802 591.26 44.6902H591.23H591.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.1 55.8301C611.1 55.9701 611.3 56.1801 611.25 56.3001C611.21 56.4101 611.01 56.4401 610.91 56.5201C610.89 56.5301 610.82 56.5201 610.79 56.5201C610.85 56.4201 610.92 56.3201 611 56.2301C611.1 56.1001 611.21 55.9801 611.33 55.8601C611.31 55.7801 611.11 55.8101 611.11 55.8301H611.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.88 56.9801C610.82 56.9801 610.76 56.9802 610.7 56.9602C610.57 56.9302 610.46 56.8501 610.4 56.7401C610.34 56.6201 610.33 56.4901 610.37 56.3601C610.42 56.2401 610.49 56.1301 610.58 56.0401C610.6 56.0201 610.61 56.0001 610.63 55.9801L610.66 55.9401C610.66 55.9401 610.66 55.8702 610.66 55.8402C610.66 55.8102 610.66 55.7701 610.67 55.7401C610.74 55.5001 610.97 55.3501 611.21 55.3801C611.47 55.3601 611.7 55.5302 611.76 55.7802C611.79 55.9102 611.76 56.0402 611.69 56.1402C611.72 56.2602 611.71 56.3801 611.66 56.4901C611.57 56.6701 611.42 56.8101 611.23 56.8801C611.21 56.8801 611.19 56.9001 611.17 56.9101C611.09 56.9701 610.99 57.0001 610.88 57.0001V56.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.45 39.9401C608.32 39.9401 608.19 39.9001 608.07 39.8501C607.99 39.8201 607.9 39.8101 607.84 39.7201C607.93 39.7201 607.98 39.8001 608.04 39.8401C608.17 39.9001 608.29 39.9801 608.4 40.0701C608.46 40.0701 608.46 39.9501 608.45 39.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.41 40.5101C608.41 40.5101 608.38 40.5101 608.37 40.5101C608.26 40.5101 608.16 40.4501 608.08 40.3701C608.05 40.3501 608.01 40.3301 607.98 40.3101C607.94 40.2901 607.91 40.2701 607.87 40.2501C607.7 40.2001 607.55 40.0901 607.46 39.9301C607.38 39.7901 607.38 39.6201 607.46 39.4801C607.54 39.3401 607.69 39.2601 607.85 39.2601C608.01 39.2601 608.16 39.3301 608.28 39.4401C608.33 39.4601 608.39 39.4801 608.45 39.4901C608.45 39.4901 608.52 39.4901 608.56 39.5001C608.81 39.5701 608.96 39.8201 608.9 40.0701C608.87 40.3201 608.66 40.5101 608.41 40.5101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.31 43.3701C587.38 43.7401 587.21 43.8201 586.88 43.7901C586.86 43.7901 586.84 43.8401 586.85 43.8201C586.85 43.5301 587.03 43.1401 587.37 43.1801C587.4 43.1801 587.31 43.3501 587.31 43.3601V43.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.85 44.2802C586.85 44.2802 586.76 44.2801 586.72 44.2601C586.52 44.1901 586.39 43.9902 586.41 43.7702C586.42 43.4502 586.56 43.1601 586.79 42.9401C586.96 42.7901 587.2 42.7101 587.43 42.7401C587.57 42.7601 587.69 42.8301 587.76 42.9501C587.85 43.1001 587.86 43.2801 587.78 43.4401C587.81 43.6501 587.74 43.8602 587.6 44.0202C587.45 44.1802 587.24 44.2601 587.02 44.2501C586.97 44.2701 586.91 44.2802 586.85 44.2802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.79 38.7901C536.68 38.8101 536.56 38.8202 536.45 38.8202C536.35 38.8202 536.35 38.8601 536.25 38.8601C536.34 38.7701 536.37 38.4101 536.45 38.4201C536.56 38.4201 536.66 38.6902 536.77 38.7702C536.81 38.7702 536.81 38.7901 536.79 38.7901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.27 39.3101H536.24C536.07 39.3101 535.92 39.2001 535.85 39.0501C535.78 38.9001 535.8 38.7201 535.9 38.5901C535.9 38.5601 535.92 38.5301 535.93 38.5001C535.97 38.3501 536.09 37.9401 536.5 37.9701C536.73 38.0101 536.93 38.1501 537.03 38.3601C537.03 38.3701 537.05 38.3901 537.06 38.4001C537.14 38.4501 537.19 38.5201 537.23 38.6001C537.29 38.7501 537.27 38.9201 537.18 39.0501C537.1 39.1501 536.99 39.2101 536.87 39.2301C536.75 39.2501 536.62 39.2601 536.5 39.2701C536.43 39.3001 536.36 39.3101 536.29 39.3101H536.27Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M578.21 40.6301C578.34 40.5501 578.44 40.4601 578.57 40.3801C578.51 40.5301 578.38 40.6402 578.33 40.7802C578.33 40.8002 578.33 40.9401 578.33 40.9401C578.24 40.8501 578.27 40.6201 578.18 40.5401C578.14 40.5401 578.19 40.6401 578.21 40.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M578.33 41.3902C578.21 41.3902 578.1 41.3502 578.02 41.2702C577.91 41.1602 577.85 41.0302 577.82 40.8802C577.7 40.7202 577.68 40.5002 577.77 40.3202C577.86 40.1802 578.02 40.0902 578.19 40.0902C578.24 40.0502 578.29 40.0201 578.34 39.9901C578.5 39.9001 578.71 39.9201 578.86 40.0401C579 40.1601 579.06 40.3601 578.99 40.5401C578.95 40.6501 578.89 40.7501 578.81 40.8501C578.8 40.8601 578.79 40.8802 578.77 40.9002V40.9301C578.77 41.0501 578.73 41.1702 578.65 41.2602C578.57 41.3502 578.45 41.4002 578.33 41.4002V41.3902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.62 15.1102C609.65 15.2502 609.64 15.2802 609.67 15.4202C609.58 15.4202 609.52 15.5602 609.43 15.5602C609.48 15.4402 609.5 15.1802 609.55 15.0602C609.56 15.0302 609.79 15.0902 609.8 15.0602L609.62 15.1102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.43 16.0101C609.28 16.0101 609.14 15.9301 609.06 15.8101C608.98 15.6801 608.96 15.5301 609.02 15.3901C609.03 15.3401 609.04 15.2901 609.05 15.2401C609.07 15.1201 609.1 15.0001 609.14 14.8901C609.25 14.6701 609.5 14.5601 609.73 14.6201C609.92 14.5901 610.11 14.6901 610.2 14.8701C610.29 15.0401 610.25 15.2601 610.12 15.3901C610.13 15.5801 610.02 15.7601 609.84 15.8401C609.74 15.9401 609.61 16.0001 609.47 16.0201C609.46 16.0201 609.44 16.0201 609.43 16.0201V16.0101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.94 27.47C607.95 27.33 608.18 27.24 608.19 27.1C608.19 27.03 608.06 26.87 608.07 26.8C608.09 26.87 608.09 26.9401 608.07 27.0101C608.03 27.1601 608.04 27.2901 607.99 27.4401C607.95 27.4801 607.93 27.49 607.93 27.48L607.94 27.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.94 27.9201C607.86 27.9201 607.78 27.9001 607.71 27.8501C607.56 27.7601 607.48 27.5901 607.49 27.4201C607.5 27.3201 607.54 27.2201 607.59 27.1401C607.59 27.0601 607.61 26.9802 607.63 26.9002C607.62 26.8502 607.62 26.8001 607.63 26.7501C607.65 26.5501 607.8 26.3801 608 26.3501C608.2 26.3201 608.4 26.4201 608.48 26.6101C608.49 26.6401 608.5 26.6702 608.51 26.7102C608.6 26.8402 608.64 26.9902 608.63 27.1502C608.61 27.3102 608.53 27.4601 608.42 27.5701V27.5902C608.39 27.6602 608.35 27.7201 608.3 27.7701C608.2 27.8701 608.07 27.9301 607.94 27.9301V27.9201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.36 18.0302C614.28 18.0802 614.25 18.0902 614.21 18.0802C614.11 18.0602 614.02 18.0201 613.93 17.9701C613.99 17.9301 614.02 18.0402 614.07 18.0502C614.16 18.0802 614.27 17.9702 614.36 18.0402V18.0302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.24 18.5302C614.18 18.5302 614.12 18.5201 614.06 18.5001C614.02 18.5001 613.98 18.4901 613.94 18.4801C613.89 18.4601 613.84 18.4401 613.8 18.4101C613.75 18.3901 613.71 18.3601 613.67 18.3301C613.55 18.2401 613.49 18.1001 613.49 17.9601C613.49 17.8101 613.57 17.6801 613.69 17.6001C613.84 17.5001 614.04 17.4901 614.2 17.5801C614.35 17.5501 614.51 17.5901 614.64 17.6901C614.76 17.7801 614.82 17.9301 614.81 18.0701C614.81 18.2201 614.72 18.3501 614.59 18.4301C614.49 18.5001 614.37 18.5401 614.25 18.5401L614.24 18.5302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.62 18.5601C607.51 18.4601 607.55 18.2601 607.44 18.1601C607.49 18.1301 607.56 18.0702 607.61 18.0302C607.66 18.1702 607.71 18.3601 607.76 18.5001C607.76 18.5601 607.63 18.5701 607.62 18.5501V18.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.65 19.0201C607.52 19.0201 607.4 18.9701 607.31 18.8801C607.2 18.7601 607.13 18.6201 607.1 18.4601V18.4401C607.02 18.3401 606.98 18.2101 607.01 18.0801C607.04 17.9501 607.11 17.8401 607.22 17.7701C607.27 17.7201 607.33 17.6801 607.39 17.6501C607.51 17.5801 607.65 17.5701 607.77 17.6101C607.9 17.6601 608 17.7601 608.04 17.8801C608.07 17.9601 608.09 18.0501 608.12 18.1401C608.14 18.2101 608.16 18.29 608.19 18.35C608.22 18.42 608.22 18.5001 608.21 18.5701C608.17 18.7801 608.01 18.9501 607.8 18.9901C607.75 19.0001 607.71 19.0101 607.66 19.0101L607.65 19.0201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.69 28.67C492.65 28.61 492.91 28.53 492.92 28.48C492.92 28.35 492.74 28.1801 492.77 28.0601C492.85 28.1701 493.04 28.2001 493.12 28.3101C493.13 28.3701 493.14 28.4301 493.14 28.4901C493.06 28.5801 492.9 28.6101 492.82 28.7001C492.78 28.7201 492.73 28.7 492.7 28.67H492.69Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.78 29.16C492.7 29.16 492.62 29.14 492.55 29.11C492.46 29.07 492.39 29.01 492.33 28.93C492.33 28.93 492.28 28.84 492.26 28.79C492.26 28.78 492.26 28.7701 492.26 28.7601C492.22 28.6101 492.26 28.4501 492.38 28.3301C492.33 28.2101 492.32 28.0801 492.34 27.9601C492.38 27.7901 492.51 27.6601 492.68 27.6201C492.85 27.5801 493.03 27.65 493.13 27.79C493.12 27.77 493.14 27.79 493.16 27.79C493.27 27.84 493.38 27.9201 493.46 28.0201C493.56 28.1501 493.6 28.31 493.59 28.48C493.59 28.6 493.55 28.7301 493.46 28.8201C493.38 28.9001 493.29 28.9601 493.18 29.0101C493.16 29.0101 493.14 29.03 493.12 29.04C493.1 29.06 493.08 29.0801 493.05 29.0901C492.97 29.1401 492.87 29.17 492.78 29.17V29.16Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M541.95 28.7301C542.18 28.7801 542.24 28.8001 542.29 28.9201C542.33 29.0301 542.43 29.1301 542.24 29.3201C542.24 29.3301 542.16 29.3601 542.16 29.3501C542.08 29.1101 542.19 28.7101 542.12 28.4701C542.05 28.4201 541.94 28.7301 541.96 28.7401L541.95 28.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M542.16 29.8001C541.94 29.8001 541.76 29.6501 541.71 29.4401C541.68 29.3301 541.67 29.2102 541.67 29.0902C541.57 29.0102 541.51 28.9002 541.49 28.7702C541.49 28.5002 541.62 28.2402 541.84 28.0802C542 27.9902 542.2 28.0002 542.35 28.0902C542.44 28.1502 542.5 28.2302 542.53 28.3302C542.55 28.4002 542.57 28.4801 542.57 28.5501C542.62 28.6101 542.66 28.6801 542.69 28.7501C542.86 29.0401 542.8 29.4101 542.54 29.6301C542.44 29.7401 542.29 29.8001 542.15 29.8001H542.16ZM541.9 29.0601L542.19 29.2002V29.1801L541.93 28.9901C541.93 28.9901 541.91 29.0401 541.91 29.0601H541.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.47 25.5902C608.6 25.5802 608.7 25.7202 608.83 25.7002C608.82 25.7502 608.8 25.7401 608.79 25.8001C608.68 25.7501 608.7 25.6701 608.6 25.6201C608.57 25.5901 608.52 25.5802 608.48 25.5902H608.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.79 26.2501C608.72 26.2501 608.66 26.2401 608.6 26.2101C608.51 26.1701 608.43 26.1101 608.37 26.0301C608.18 25.9801 608.04 25.8201 608.03 25.6201C608.02 25.4201 608.13 25.2401 608.32 25.1701C608.5 25.1101 608.69 25.1301 608.85 25.2401L608.88 25.2601C609.01 25.2801 609.13 25.3401 609.2 25.4501C609.28 25.5601 609.3 25.6901 609.27 25.8201C609.26 25.8701 609.24 25.9101 609.22 25.9501C609.16 26.1301 608.99 26.2601 608.79 26.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M537.24 36.0202C537.11 36.0202 537.02 35.8002 536.89 35.8002C536.89 35.7702 536.89 35.7302 536.89 35.7002C537.02 35.7402 537.32 35.7402 537.45 35.7802C537.49 35.8602 537.25 36.0202 537.23 36.0202H537.24Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M537.24 36.4701C537.05 36.4701 536.87 36.3701 536.75 36.2301C536.55 36.1601 536.43 35.9701 536.45 35.7601C536.45 35.7101 536.45 35.6801 536.45 35.6601C536.46 35.5301 536.53 35.4001 536.65 35.3301C536.76 35.2501 536.9 35.2301 537.03 35.2701C537.09 35.2801 537.16 35.2901 537.22 35.2901C537.35 35.2901 537.47 35.3201 537.59 35.3501C537.71 35.3901 537.81 35.4701 537.87 35.5901C537.95 35.7701 537.92 35.9901 537.79 36.1401C537.66 36.3201 537.46 36.4301 537.25 36.4701H537.24Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.59 28.7002C536.65 28.7302 536.67 28.9702 536.69 29.0202C536.71 29.0702 536.78 29.1202 536.76 29.1802C536.7 29.1402 536.48 29.1702 536.45 29.1102C536.48 28.9702 536.53 28.8302 536.59 28.7002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.76 29.6302C536.71 29.6302 536.66 29.6302 536.61 29.6002C536.38 29.6102 536.16 29.5002 536.05 29.3002C535.95 29.1002 536.02 28.9102 536.15 28.6002L536.17 28.5402C536.22 28.4102 536.32 28.3202 536.44 28.2702C536.57 28.2302 536.71 28.2402 536.82 28.3102C536.99 28.4402 537.1 28.6302 537.11 28.8402C537.2 28.9802 537.23 29.1502 537.18 29.3002C537.12 29.4902 536.95 29.6102 536.75 29.6102L536.76 29.6302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.32 53.8201C614.32 53.8201 614.1 54.0001 614.07 54.0501C614.03 54.0001 613.8 53.9901 613.78 53.9301C613.78 53.9101 613.99 53.8901 614.01 53.8601C614.06 53.8901 614.28 53.7901 614.33 53.8201H614.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.05 54.5202C613.96 54.5202 613.88 54.4902 613.81 54.4302C613.62 54.4002 613.45 54.2802 613.36 54.1102C613.31 53.9902 613.31 53.8402 613.37 53.7202C613.45 53.5702 613.61 53.4702 613.78 53.4602C613.78 53.4602 613.84 53.4402 613.87 53.4302C613.92 53.4202 613.97 53.4102 614.02 53.4102C614.2 53.3402 614.39 53.3502 614.56 53.4402C614.66 53.5102 614.74 53.6102 614.76 53.7302C614.78 53.8502 614.76 53.9802 614.69 54.0802C614.63 54.1602 614.56 54.2202 614.48 54.2802C614.45 54.3002 614.42 54.3302 614.4 54.3502C614.32 54.4602 614.19 54.5202 614.05 54.5202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M599.4 31.8402C599.34 31.8402 599.31 32.0302 599.25 32.0402C599.25 32.0102 599.36 32.0602 599.38 32.0602C599.43 32.0402 599.36 31.9902 599.42 31.9802C599.42 32.0102 599.42 31.8102 599.41 31.8402H599.4Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M599.38 32.5001C599.38 32.5001 599.3 32.5001 599.26 32.4901C599.13 32.4901 599.01 32.4401 598.93 32.3501C598.83 32.2401 598.79 32.0901 598.82 31.9501C598.84 31.8601 598.88 31.7801 598.95 31.7201C599 31.6001 599.09 31.5101 599.21 31.4401C599.28 31.4001 599.36 31.3801 599.43 31.3901C599.53 31.3901 599.85 31.4401 599.87 31.8901C599.87 31.8901 599.88 31.9801 599.87 32.0201C599.87 32.0601 599.86 32.1001 599.84 32.1401C599.8 32.2901 599.7 32.4101 599.55 32.4701C599.5 32.4901 599.44 32.5001 599.38 32.5001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M512.5 26.1902C512.59 26.0602 512.69 25.9502 512.78 25.8202C512.81 25.8402 512.61 25.6601 512.64 25.6801C512.52 25.7801 512.54 26.0001 512.41 26.1001C512.39 26.1601 512.49 26.2002 512.5 26.1902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M512.49 26.6301C512.4 26.6301 512.3 26.6101 512.22 26.5601C512.02 26.4401 511.92 26.2001 511.98 25.9801C512 25.9101 512.04 25.8501 512.08 25.8001C512.08 25.7901 512.08 25.7701 512.09 25.7601C512.13 25.6301 512.19 25.5101 512.28 25.4101C512.43 25.2201 512.7 25.1901 512.89 25.3301C512.92 25.3501 512.95 25.3701 512.97 25.4001L513.01 25.4401C513.34 25.7501 513.23 26.0001 513.13 26.1201L513.11 26.1401C513.07 26.2001 513.03 26.2501 512.98 26.3001C512.94 26.3501 512.9 26.4001 512.86 26.4501C512.84 26.4801 512.82 26.5001 512.8 26.5201C512.71 26.6001 512.59 26.6401 512.47 26.6401L512.49 26.6301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M606.65 26.8901C606.59 26.9101 606.53 26.9301 606.47 26.9301C606.43 26.8901 606.18 26.9101 606.14 26.8601C606.22 26.8301 606.3 26.8002 606.38 26.7802C606.43 26.8302 606.6 26.8401 606.64 26.8901H606.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M606.49 27.3902C606.43 27.3902 606.37 27.3902 606.31 27.3602H606.28C606.1 27.3602 605.92 27.2902 605.8 27.1502C605.72 27.0602 605.69 26.9302 605.7 26.8102C605.71 26.6902 605.78 26.5802 605.87 26.5102C605.87 26.5102 606.3 26.2102 606.61 26.4002C606.75 26.4302 606.88 26.5002 606.98 26.6002C607.07 26.7002 607.11 26.8402 607.08 26.9802C607.05 27.1202 606.97 27.2302 606.85 27.2902C606.74 27.3502 606.61 27.3802 606.48 27.3902H606.49Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.54 27.5302C490.57 27.4702 490.47 27.2601 490.52 27.2201C490.59 27.1601 490.84 27.4201 490.92 27.3701C490.93 27.4001 490.93 27.2901 490.92 27.3001C490.86 27.3701 490.75 27.3701 490.67 27.4101C490.62 27.4401 490.67 27.7001 490.59 27.7001C490.57 27.7001 490.51 27.5302 490.53 27.5302H490.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.62 28.16C490.43 28.16 490.25 28.04 490.17 27.86C490.11 27.74 490.09 27.62 490.09 27.49C490.01 27.28 490.07 27.04 490.23 26.89C490.41 26.74 490.68 26.73 490.87 26.87C490.96 26.86 491.04 26.87 491.12 26.91C491.32 27.01 491.42 27.23 491.37 27.45C491.34 27.63 491.21 27.77 491.04 27.82C490.99 28.02 490.82 28.15 490.61 28.16H490.62Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M572.87 52.3401C572.99 52.3001 573.09 52.1001 573.2 52.0601C573.2 52.1201 573.24 52.3101 573.24 52.3701C573.11 52.3401 572.76 52.0601 572.63 52.0201C572.58 52.1101 572.84 52.3301 572.86 52.3301L572.87 52.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.24 52.8202C573.24 52.8202 573.17 52.8201 573.13 52.8101C573.09 52.8001 573.05 52.7802 573.01 52.7602C572.98 52.7702 572.94 52.7802 572.91 52.7802C572.57 52.8102 572.31 52.4202 572.28 52.3802C572.16 52.2102 572.14 51.9801 572.25 51.8001C572.35 51.6301 572.55 51.5402 572.75 51.5902C572.82 51.6102 572.9 51.6401 572.96 51.6801C572.99 51.6601 573.03 51.6502 573.06 51.6402C573.2 51.5902 573.35 51.6202 573.47 51.7002C573.59 51.7802 573.66 51.9202 573.66 52.0702C573.66 52.0802 573.66 52.1202 573.67 52.1502C573.68 52.2302 573.69 52.3002 573.7 52.3802C573.7 52.6302 573.5 52.8302 573.25 52.8302L573.24 52.8202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.54 42.9901C586.5 43.1101 586.46 43.2401 586.42 43.3601C586.38 43.3301 586.12 43.1601 586.07 43.1301C586.16 43.0501 586.37 43.0101 586.47 42.9301C586.51 42.9201 586.56 42.9801 586.55 42.9901H586.54Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.42 43.81C586.33 43.81 586.24 43.78 586.17 43.73L585.82 43.5C585.7 43.42 585.63 43.29 585.62 43.16C585.62 43.02 585.67 42.89 585.77 42.79C585.87 42.71 585.98 42.65 586.09 42.61C586.12 42.6 586.15 42.58 586.18 42.57C586.22 42.53 586.27 42.51 586.33 42.49C586.51 42.44 586.7 42.49 586.83 42.62C586.96 42.75 587.01 42.95 586.95 43.12L586.83 43.49C586.77 43.67 586.6 43.8 586.4 43.8L586.42 43.81Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.71 33.7802C536.59 33.7302 536.52 33.8302 536.39 33.7802C536.52 33.6802 536.56 33.6801 536.69 33.5701C536.59 33.5001 536.48 33.4401 536.37 33.3901C536.37 33.5601 536.56 33.8801 536.56 34.0401C536.68 34.0401 536.73 33.7801 536.71 33.7701V33.7802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.56 34.5101H536.52C536.32 34.4901 536.15 34.3501 536.11 34.1501C536.02 34.0801 535.96 33.9801 535.94 33.8701C535.93 33.8001 535.94 33.7401 535.95 33.6701C535.92 33.5801 535.91 33.4901 535.91 33.4001C535.91 33.3701 535.91 33.3401 535.92 33.3101C535.95 33.1701 536.05 33.0501 536.18 32.9901C536.41 32.8901 536.57 32.9901 536.91 33.2001C537.06 33.2901 537.14 33.4601 537.12 33.6401C537.16 33.7901 537.15 33.9601 537.08 34.1001C537.01 34.3401 536.79 34.5001 536.54 34.5101H536.56Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.22 28.2201C608.22 28.2201 608.21 28.1301 608.16 28.1701C608.13 28.1001 608.12 28.2001 608.11 28.1301C608.11 28.0801 608.14 28.0301 608.19 28.0001C608.21 28.0601 608.19 28.1601 608.22 28.2201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.2 28.68C608.07 28.68 607.95 28.6301 607.87 28.5301C607.75 28.4401 607.67 28.3001 607.66 28.1501C607.66 27.9201 607.78 27.7 607.99 27.6C608.11 27.54 608.24 27.5401 608.36 27.5901C608.48 27.6401 608.57 27.74 608.61 27.86C608.64 27.94 608.65 28.02 608.65 28.1C608.71 28.28 608.65 28.4801 608.49 28.5901C608.41 28.6501 608.3 28.69 608.2 28.69V28.68ZM608.26 28.13L608.4 28.4001C608.51 28.3501 608.58 28.23 608.57 28.11L608.26 28.13Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M574.12 56.2001C574.06 56.2301 574.23 56.2501 574.17 56.2401C574.07 56.2401 573.97 56.2201 573.88 56.1901C573.94 56.1601 574.12 56.2701 574.17 56.2801C574.22 56.2901 574.06 56.1601 574.12 56.2001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M574.18 56.7301H574.17C574.09 56.7301 574.01 56.7101 573.94 56.6701C573.84 56.6601 573.75 56.6201 573.66 56.5801C573.52 56.5001 573.44 56.3501 573.44 56.1901C573.44 56.0301 573.53 55.8901 573.67 55.8101C573.78 55.7501 573.92 55.7301 574.05 55.7601C574.17 55.7401 574.29 55.7601 574.38 55.8301C574.41 55.8501 574.44 55.8801 574.47 55.9001C574.55 55.9701 574.61 56.0601 574.64 56.1601C574.66 56.2501 574.66 56.3501 574.62 56.4301C574.55 56.6101 574.38 56.7201 574.19 56.7201L574.18 56.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.09 50.5901C573.03 50.5901 572.98 50.4101 572.95 50.3901C572.89 50.3501 572.74 50.4601 572.69 50.3901C572.76 50.3801 572.78 50.4401 572.82 50.4601C572.87 50.4901 573.05 50.5001 573.09 50.5801V50.5901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.08 51.04C572.97 51.04 572.86 51 572.78 50.93C572.72 50.92 572.66 50.89 572.6 50.87C572.58 50.87 572.57 50.8501 572.56 50.8401C572.47 50.8101 572.39 50.75 572.33 50.68C572.23 50.56 572.21 50.4001 572.26 50.2501C572.31 50.1001 572.44 50.0001 572.59 49.9601C572.65 49.9501 572.7 49.9401 572.76 49.9601C572.91 49.9201 573.07 49.9401 573.2 50.0301C573.28 50.0901 573.34 50.1601 573.38 50.2501C573.43 50.2901 573.46 50.3401 573.49 50.4001C573.56 50.5301 573.55 50.6901 573.48 50.8201C573.41 50.9501 573.27 51.03 573.12 51.05C573.11 51.05 573.09 51.05 573.08 51.05V51.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.85 17.2101C607.76 17.1501 607.71 17.0301 607.62 16.9701C607.67 16.9301 607.83 16.8202 607.88 16.7802C607.91 16.8902 608.07 17.0801 608.1 17.2001C608.08 17.2601 607.87 17.2401 607.85 17.2201V17.2101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.97 17.6801C607.84 17.6801 607.71 17.6501 607.6 17.5801C607.52 17.5201 607.44 17.4501 607.38 17.3601C607.26 17.2801 607.19 17.1501 607.18 17.0001C607.17 16.8601 607.22 16.7201 607.33 16.6201C607.36 16.5901 607.42 16.5501 607.49 16.5001C607.53 16.4701 607.57 16.4401 607.59 16.4301C607.71 16.3301 607.86 16.3001 608.01 16.3401C608.15 16.3801 608.27 16.4901 608.31 16.6401C608.32 16.6601 608.35 16.7001 608.37 16.7401C608.44 16.8401 608.49 16.9401 608.53 17.0501C608.56 17.1301 608.56 17.2201 608.53 17.3101C608.47 17.5001 608.3 17.6401 608.11 17.6601C608.07 17.6601 608.02 17.6701 607.97 17.6701V17.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.18 45.9201C586.95 45.8701 586.75 45.8001 587.04 45.4501C587.05 45.4301 586.92 45.3701 586.93 45.3901C587.01 45.5501 586.93 45.7601 587.01 45.9101C587.02 45.9501 587.2 45.9201 587.18 45.9101V45.9201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.08 46.3901C586.89 46.4001 586.72 46.3101 586.62 46.1501C586.56 46.0901 586.51 46.0101 586.48 45.9201C586.44 45.7801 586.44 45.6401 586.48 45.5101C586.43 45.3201 586.5 45.1201 586.67 45.0201C586.9 44.9001 587.17 44.9501 587.35 45.1301C587.46 45.2501 587.51 45.4201 587.46 45.5801C587.58 45.6801 587.64 45.8301 587.62 45.9901C587.57 46.2001 587.39 46.3601 587.17 46.3901C587.14 46.3901 587.11 46.3901 587.08 46.3901ZM586.75 45.7901C586.88 45.8601 587.05 45.8501 587.17 45.7601L587 45.5101C587 45.5101 586.95 45.5401 586.92 45.5501L586.82 45.6501C586.82 45.6501 586.76 45.7401 586.75 45.7901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M556.79 29.24C556.79 29.24 556.58 29.27 556.6 29.24C556.61 29.22 556.88 29.5 556.9 29.48C556.94 29.45 556.83 29.25 556.79 29.24Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M556.9 29.9301C556.72 29.9101 556.55 29.8201 556.44 29.6801L556.4 29.6501C556.33 29.6201 556.26 29.5601 556.22 29.4901C556.13 29.3501 556.12 29.1701 556.2 29.0201C556.27 28.9001 556.39 28.8101 556.52 28.7901C556.58 28.7801 556.64 28.7901 556.69 28.7901C556.75 28.7901 556.82 28.7901 556.88 28.7901C557.23 28.8701 557.33 29.3301 557.33 29.3401C557.36 29.5301 557.29 29.7101 557.14 29.8301C557.07 29.8901 556.98 29.9201 556.89 29.9201L556.9 29.9301ZM556.6 29.1401C556.51 29.2201 556.45 29.3401 556.46 29.4701L556.61 29.2801V29.2401H556.6V29.1401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.22 28.93C479.25 28.85 479.57 28.9701 479.59 28.8901C479.6 28.9201 478.88 28.3001 478.87 28.3201C478.83 28.3701 479.39 28.7801 479.35 28.8301C479.28 28.8301 479.21 28.95 479.22 28.93Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.22 29.3802C479.09 29.3802 478.97 29.3201 478.88 29.2301C478.79 29.1301 478.76 29.0001 478.77 28.8701C478.54 28.6701 478.27 28.4002 478.5 28.0602C478.57 27.9602 478.68 27.8901 478.81 27.8701C479.02 27.8401 479.06 27.8702 479.54 28.2702C479.66 28.3702 479.77 28.4602 479.82 28.5002H479.84C480 28.6302 480.07 28.8302 480.01 29.0202C479.95 29.2002 479.79 29.4101 479.35 29.3501C479.3 29.3701 479.26 29.3701 479.21 29.3701L479.22 29.3802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M572.9 53.11C572.9 53.11 573 53.17 573.03 53.16C573.03 53.2 572.92 53.1101 572.93 53.1501C572.9 53.1501 573.1 53.1001 573.08 53.0801C573.06 53.0801 572.9 53.13 572.89 53.11H572.9Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.02 53.6101C573.02 53.6101 572.94 53.6101 572.9 53.6001C572.68 53.5901 572.5 53.4301 572.46 53.2201C572.42 53.0101 572.53 52.7901 572.72 52.7001C572.78 52.6801 572.84 52.6701 572.9 52.6601C573.03 52.6201 573.18 52.6301 573.3 52.7001C573.45 52.7901 573.54 52.9601 573.52 53.1401C573.52 53.2301 573.47 53.3201 573.41 53.3901C573.38 53.4401 573.34 53.4801 573.3 53.5201C573.22 53.5801 573.11 53.6101 573.01 53.6101H573.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.5 39.4101C573.47 39.5001 573.68 39.7701 573.65 39.8601C573.65 39.8301 573.51 39.7301 573.52 39.7201C573.56 39.6601 573.59 39.6601 573.64 39.6101C573.58 39.5001 573.52 39.4001 573.5 39.4101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.65 40.3C573.51 40.3 573.38 40.23 573.3 40.12C573.14 40 573.06 39.81 573.09 39.61C573.05 39.5 573.05 39.3801 573.09 39.2601C573.11 39.2001 573.14 39.15 573.18 39.1C573.27 38.99 573.42 38.93 573.57 38.94C573.82 38.96 573.93 39.16 574.05 39.36C574.1 39.45 574.12 39.55 574.1 39.66C574.13 39.76 574.13 39.87 574.1 39.97C574.04 40.16 573.87 40.2801 573.67 40.2801L573.65 40.3Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.16 40.2901C609.08 40.1301 609.19 39.9101 609.11 39.7501C609.1 39.7301 609.14 39.6101 609.15 39.6201C609.23 39.6201 609.14 39.6701 609.22 39.6701C609.3 39.7001 609.38 39.7501 609.44 39.8101C609.44 39.9701 609.31 40.1301 609.32 40.2901C609.29 40.3501 609.17 40.3101 609.16 40.2901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.24 40.7702C609.24 40.7702 609.19 40.7702 609.17 40.7702C608.99 40.7602 608.82 40.6502 608.75 40.4802C608.69 40.3302 608.66 40.1602 608.69 39.9902C608.69 39.9702 608.69 39.9402 608.69 39.9202C608.63 39.7302 608.67 39.5102 608.79 39.3502C608.88 39.2402 609.01 39.1802 609.15 39.1802C609.27 39.1802 609.38 39.2102 609.47 39.2902C609.53 39.3202 609.59 39.3602 609.65 39.4002C609.81 39.4902 609.9 39.6602 609.9 39.8402C609.9 39.9702 609.86 40.1002 609.81 40.2302C609.8 40.2602 609.79 40.2902 609.78 40.3202C609.78 40.3902 609.76 40.4702 609.72 40.5302C609.63 40.6902 609.45 40.7902 609.26 40.7902L609.24 40.7702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M572.98 41.0401C572.98 41.0401 572.96 41.0901 572.94 41.1201C572.93 41.0901 572.84 41.0501 572.84 41.0201C572.84 40.9901 572.92 41.1301 572.93 41.1001C572.94 41.1301 572.96 41.0001 572.97 41.0401H572.98Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M572.94 41.5702C572.94 41.5702 572.9 41.5702 572.89 41.5702C572.79 41.5602 572.7 41.5102 572.62 41.4402C572.61 41.4302 572.6 41.4201 572.59 41.4101C572.45 41.3101 572.38 41.1401 572.4 40.9701C572.42 40.7901 572.55 40.6402 572.73 40.5902C572.8 40.5702 572.87 40.5702 572.94 40.5902H572.97C573.16 40.5902 573.34 40.7102 573.4 40.9002C573.44 41.0102 573.43 41.1402 573.37 41.2502C573.35 41.2902 573.33 41.3402 573.31 41.3802C573.23 41.5102 573.09 41.5802 572.94 41.5802V41.5702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.95 17.4102C607.87 17.4602 607.7 17.7902 607.62 17.8502C607.71 17.8102 607.8 17.6202 607.88 17.5802C607.9 17.4802 607.96 17.4102 607.94 17.4202L607.95 17.4102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.62 18.3001C607.43 18.3001 607.27 18.1801 607.2 18.0101C607.13 17.8401 607.18 17.6401 607.32 17.5101C607.35 17.4801 607.37 17.4301 607.4 17.3801C607.47 17.2501 607.57 17.1301 607.69 17.0301C607.73 17.0001 607.78 16.9801 607.83 16.9701C608.01 16.9201 608.19 16.9901 608.3 17.1301C608.41 17.2801 608.42 17.4901 608.32 17.6501C608.3 17.7701 608.23 17.8701 608.13 17.9401C608.12 17.9501 608.11 17.9701 608.1 17.9801C608.03 18.0901 607.93 18.1801 607.81 18.2401C607.75 18.2701 607.68 18.2901 607.61 18.2901L607.62 18.3001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.28 49.1601C573.22 49.0701 573.39 48.9501 573.33 48.8701C573.38 48.9601 573.38 49.0101 573.43 49.1001C573.37 49.1701 573.29 49.1801 573.28 49.1601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573.31 49.62C573.31 49.62 573.25 49.62 573.21 49.62C573.09 49.6 572.99 49.53 572.91 49.43C572.78 49.25 572.78 49.01 572.9 48.82C572.92 48.7 572.99 48.5901 573.09 48.5301C573.28 48.3901 573.54 48.43 573.69 48.62C573.71 48.65 573.73 48.69 573.75 48.73C573.77 48.77 573.79 48.81 573.8 48.85C573.89 49.02 573.89 49.2301 573.78 49.4001C573.67 49.5501 573.49 49.6401 573.3 49.6401L573.31 49.62ZM572.91 48.81C572.89 48.89 572.89 48.98 572.93 49.06C572.9 48.98 572.9 48.9 572.91 48.81ZM573.31 48.72C573.22 48.72 573.13 48.7601 573.08 48.8301L573.23 48.9501L573.35 48.86L573.38 48.73C573.38 48.73 573.33 48.73 573.31 48.73V48.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.52 15.4801C607.52 15.4801 607.46 15.5901 607.46 15.6001C607.46 15.6301 607.69 15.7502 607.68 15.7802C607.66 15.7702 607.68 15.6701 607.68 15.6601C607.68 15.6301 607.51 15.5101 607.52 15.4801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.68 16.2301C607.6 16.2301 607.53 16.2101 607.46 16.1701C607.41 16.1401 607.37 16.1101 607.34 16.0701L607.32 16.0501C607.14 15.9601 607.03 15.7801 607.02 15.5801C607.02 15.4901 607.06 15.4001 607.11 15.3201C607.16 15.2001 607.26 15.1001 607.38 15.0501C607.5 15.0101 607.64 15.0202 607.76 15.0902C607.82 15.1202 607.87 15.1701 607.91 15.2301C608.05 15.3301 608.14 15.4901 608.15 15.6601C608.15 15.6901 608.15 15.7201 608.15 15.7501C608.15 15.8001 608.15 15.8502 608.13 15.9002C608.08 16.0902 607.9 16.2301 607.7 16.2301H607.68Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M552.28 51.3301C552.24 51.3801 552.28 51.49 552.23 51.54C552.22 51.55 552.15 51.5101 552.12 51.5101C552.2 51.4701 552.22 51.51 552.29 51.48C552.31 51.48 552.29 51.3301 552.27 51.3401L552.28 51.3301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M552.23 51.99C552.15 51.99 552.07 51.9701 551.99 51.9401C551.8 51.9101 551.66 51.7501 551.65 51.5601C551.63 51.3901 551.72 51.2201 551.87 51.1301C551.89 51.1001 551.91 51.07 551.93 51.04C551.98 50.98 552.05 50.9301 552.12 50.9001C552.28 50.8401 552.47 50.8801 552.59 51.0101C552.73 51.1801 552.78 51.4 552.72 51.61C552.69 51.69 552.64 51.7701 552.57 51.8201C552.56 51.8301 552.54 51.85 552.53 51.86C552.45 51.94 552.34 51.98 552.23 51.98V51.99ZM551.88 51.3201C551.83 51.4401 551.86 51.5701 551.96 51.6501L552.13 51.4601L552.07 51.3901L551.87 51.3201H551.88Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.33 42.4201C536.23 42.4101 536.1 42.4901 535.99 42.4801C536.02 42.4301 535.97 42.65 535.99 42.6C536.06 42.67 536.28 42.7101 536.35 42.7701C536.43 42.7201 536.34 42.4201 536.32 42.4201H536.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.36 43.2201C536.26 43.2201 536.17 43.1901 536.09 43.1301C536.07 43.1301 536.05 43.1101 536.02 43.1101C535.95 43.0901 535.89 43.0601 535.82 43.0301C535.62 42.9501 535.5 42.7401 535.54 42.5201C535.54 42.4201 535.55 42.3201 535.61 42.2401C535.69 42.1001 535.85 42.0201 536.01 42.0301C536.13 41.9901 536.25 41.9701 536.38 41.9801C536.42 41.9801 536.46 42.0001 536.5 42.0101C536.72 42.1301 536.85 42.3701 536.84 42.6201C536.87 42.8301 536.78 43.0501 536.59 43.1601C536.52 43.2001 536.44 43.2301 536.36 43.2301V43.2201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.8 18.3301C607.89 18.3401 607.87 18.55 607.96 18.56C607.94 18.56 607.88 18.67 607.87 18.66C607.81 18.64 607.89 18.5 607.84 18.47C607.84 18.39 607.79 18.3201 607.81 18.3301H607.8Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.87 19.11C607.82 19.11 607.77 19.1101 607.72 19.0801C607.51 19.0001 607.38 18.8001 607.4 18.5701C607.4 18.5401 607.39 18.51 607.39 18.48C607.32 18.31 607.36 18.12 607.5 17.99C607.6 17.9 607.74 17.86 607.87 17.88C608.07 17.91 608.23 18.05 608.29 18.24C608.35 18.31 608.39 18.39 608.41 18.48C608.43 18.62 608.39 18.76 608.29 18.87C608.2 19.01 608.05 19.1 607.88 19.11H607.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.03 43.4301C591.03 43.4301 591.05 43.4501 591.06 43.4601C591.03 43.4601 590.99 43.6801 590.96 43.6701C590.96 43.6701 590.92 43.4001 590.91 43.3801C590.94 43.3801 591.01 43.4301 591.03 43.4201V43.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M590.96 44.1302C590.96 44.1302 590.92 44.1302 590.9 44.1302C590.55 44.0902 590.5 43.7802 590.48 43.5802V43.5002C590.44 43.3902 590.46 43.2802 590.51 43.1802C590.58 43.0602 590.69 42.9802 590.83 42.9602C590.94 42.9602 591.05 42.9702 591.15 43.0102C591.25 43.0402 591.33 43.1002 591.39 43.1802C591.42 43.2202 591.45 43.2602 591.47 43.3002C591.52 43.4202 591.52 43.5602 591.45 43.6802L591.43 43.7102C591.32 44.0002 591.17 44.1302 590.96 44.1302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M488.04 54.5201C488.11 54.4901 488.19 54.4801 488.27 54.4701C488.33 54.4801 488.43 54.3601 488.49 54.3901C488.47 54.4101 488.44 54.3501 488.42 54.3501C488.36 54.3401 488.09 54.5401 488.03 54.5201H488.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M488.05 54.9702C487.98 54.9702 487.92 54.9602 487.86 54.9302C487.72 54.8702 487.62 54.7402 487.6 54.5802C487.58 54.4302 487.64 54.2702 487.76 54.1702C487.83 54.1202 487.91 54.0802 487.99 54.0602L488.03 54.0402C488.18 53.9302 488.36 53.8802 488.54 53.9102C488.6 53.9302 488.65 53.9502 488.7 53.9902C488.83 54.0602 488.93 54.1802 488.95 54.3302C488.97 54.4802 488.91 54.6302 488.8 54.7302C488.74 54.7802 488.67 54.8202 488.59 54.8402C488.5 54.9002 488.39 54.9302 488.28 54.9302C488.21 54.9602 488.14 54.9802 488.06 54.9802L488.05 54.9702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M500.47 28.9901C500.47 29.1401 500.6 29.3301 500.6 29.4801C500.6 29.5001 500.75 29.4801 500.75 29.4801C500.75 29.3201 500.72 29.1201 500.72 28.9601C500.64 28.8901 500.47 28.9601 500.47 28.9801V28.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M500.69 29.9302C500.28 29.9302 500.18 29.6902 500.16 29.5402C500.16 29.5202 500.16 29.5002 500.16 29.4802C500.16 29.4602 500.14 29.4302 500.12 29.3902C500.06 29.2602 500.03 29.1302 500.02 28.9902C500.02 28.9602 500.02 28.9402 500.02 28.9102C500.06 28.7202 500.2 28.5702 500.38 28.5202C500.59 28.4402 500.83 28.4702 501.01 28.6202C501.1 28.7002 501.16 28.8302 501.16 28.9502C501.16 29.0202 501.16 29.1002 501.17 29.1702C501.17 29.2702 501.19 29.3702 501.19 29.4702C501.19 29.7102 501.01 29.9002 500.78 29.9202C500.75 29.9202 500.71 29.9202 500.68 29.9202L500.69 29.9302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M473.9 35.6702C473.9 35.6202 474.01 35.5502 474.06 35.5802C474.09 35.5902 474.06 35.7402 474.03 35.7502C474 35.7602 473.97 35.7602 473.94 35.7502C473.91 35.7302 473.9 35.7102 473.9 35.6802V35.6702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M473.99 36.2002C473.88 36.2002 473.77 36.1602 473.67 36.1002C473.51 35.9902 473.42 35.8002 473.45 35.6002C473.48 35.4202 473.59 35.2702 473.75 35.1902C473.9 35.1002 474.08 35.0902 474.24 35.1602C474.4 35.2402 474.51 35.4102 474.52 35.5902C474.53 35.8102 474.43 36.0202 474.24 36.1402C474.16 36.1802 474.08 36.2002 473.99 36.2002ZM474.07 35.6002L473.87 35.9802C473.97 36.0302 474.08 36.0302 474.18 35.9802C474.27 35.9202 474.33 35.8302 474.34 35.7302C474.36 35.5902 474.3 35.4502 474.19 35.3702C474.08 35.2902 473.94 35.2802 473.82 35.3502C473.71 35.4002 473.63 35.5102 473.62 35.6302H474.07V35.6002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M510.1 30.1801C510.05 30.1501 509.99 30.0001 509.94 29.9701C509.96 29.9501 509.94 30.1001 509.96 30.1101C510.02 30.1301 510.1 29.9801 510.15 30.0101C510.12 30.0301 510.12 30.1601 510.1 30.1801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M510.1 30.6301C510.03 30.6301 509.96 30.6101 509.9 30.5801C509.88 30.5701 509.86 30.5601 509.84 30.5401C509.66 30.4201 509.53 30.2301 509.5 30.0201C509.48 29.8701 509.54 29.7201 509.66 29.6301C509.79 29.5201 509.97 29.4901 510.13 29.5601C510.21 29.5601 510.3 29.5701 510.37 29.6101C510.5 29.6801 510.59 29.8201 510.61 29.9701C510.61 30.0401 510.61 30.1201 510.58 30.1901C510.56 30.3301 510.49 30.4501 510.39 30.5401C510.31 30.6001 510.22 30.6301 510.12 30.6301H510.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.53 30.3301C477.46 30.3901 477.39 30.4501 477.32 30.5101C477.3 30.4701 477.37 30.6101 477.35 30.5701C477.45 30.5701 477.56 30.5201 477.66 30.5101C477.69 30.4801 477.54 30.3301 477.52 30.3301H477.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.39 31.0101C477.21 31.0101 477.04 30.9101 476.95 30.7501C476.95 30.7501 476.94 30.7301 476.93 30.7101C476.82 30.4901 476.89 30.2301 477.1 30.1001L477.13 30.0801C477.13 30.0801 477.21 30.0001 477.26 29.9701C477.3 29.9401 477.35 29.9101 477.41 29.8901C477.78 29.7801 478.02 30.1501 478.06 30.2301C478.17 30.4201 478.13 30.6701 477.98 30.8301C477.91 30.9001 477.81 30.9401 477.71 30.9501C477.68 30.9501 477.66 30.9601 477.63 30.9701C477.59 30.9801 477.55 30.9901 477.51 31.0001C477.47 31.0101 477.44 31.0201 477.4 31.0101H477.39Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.34 56.3202C612.34 56.3202 612.21 56.4401 612.25 56.4401C612.29 56.4401 612.29 56.2801 612.31 56.3101C612.34 56.3401 612.34 56.3402 612.33 56.3202H612.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.24 56.8801H612.21C611.97 56.8601 611.79 56.6601 611.79 56.4201C611.79 56.2601 611.87 56.1101 611.98 56.0001C612.03 55.9401 612.1 55.8901 612.17 55.8601C612.27 55.8301 612.39 55.8401 612.48 55.8801C612.63 55.9401 612.73 56.0701 612.76 56.2201C612.78 56.3801 612.74 56.5301 612.63 56.6301C612.55 56.7801 612.39 56.8701 612.22 56.8701L612.24 56.8801ZM611.88 56.2901C611.88 56.2901 611.88 56.3601 611.88 56.3901L612.05 56.3601L611.88 56.2901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.75 56.2802C607.75 56.2802 607.81 56.3102 607.82 56.2802C607.82 56.2402 607.69 56.3502 607.74 56.3602C607.77 56.3602 607.78 56.2802 607.76 56.2902L607.75 56.2802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.73 56.8001C607.73 56.8001 607.67 56.8001 607.65 56.8001C607.41 56.7501 607.25 56.5102 607.29 56.2702C607.29 56.2402 607.3 56.2102 607.31 56.1902C607.35 56.0302 607.48 55.9101 607.63 55.8601H607.64C607.71 55.8301 607.79 55.8202 607.87 55.8302C608.11 55.8702 608.28 56.0902 608.25 56.3402C608.24 56.4402 608.19 56.5301 608.12 56.6001C608.03 56.7301 607.88 56.8102 607.72 56.8202L607.73 56.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.41 36.5901C608.4 36.6901 608.6 36.9001 608.59 37.0001C608.55 36.9701 608.35 36.8801 608.31 36.8501C608.37 36.7801 608.69 36.6201 608.75 36.5601C608.69 36.4701 608.41 36.5701 608.41 36.5801V36.5901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.58 37.4602C608.49 37.4602 608.41 37.4302 608.33 37.3902C608.32 37.3902 608.28 37.3602 608.23 37.3402C608.15 37.3002 608.08 37.2601 608.05 37.2401C607.94 37.1701 607.87 37.0601 607.85 36.9301C607.83 36.8001 607.87 36.6702 607.95 36.5802C607.95 36.5702 607.95 36.5501 607.95 36.5401C607.95 36.5001 607.96 36.4601 607.98 36.4301C608.09 36.2201 608.31 36.0902 608.54 36.0902C608.76 36.0502 608.97 36.1301 609.1 36.3101C609.22 36.4901 609.2 36.7202 609.06 36.8802C609.05 36.9002 609.03 36.9101 609.01 36.9201C609.01 36.9701 609.01 37.0101 609.01 37.0601C608.98 37.2901 608.79 37.4502 608.56 37.4502L608.58 37.4602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M578.27 54.2102C578.35 54.2102 578.43 54.2102 578.5 54.2202C578.52 54.2502 578.29 54.2202 578.3 54.2502C578.26 54.2502 578.4 54.3202 578.36 54.3202C578.37 54.2802 578.26 54.2402 578.27 54.2102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M578.36 54.7702H578.33C578.21 54.7602 578.1 54.7002 578.03 54.6202C577.99 54.5802 577.95 54.5402 577.92 54.4902C577.83 54.3702 577.81 54.2302 577.85 54.0902C577.91 53.8902 578.1 53.7502 578.31 53.7702C578.56 53.7702 578.79 53.7802 578.91 54.0202C578.98 54.1602 578.98 54.3302 578.89 54.4702C578.84 54.5502 578.77 54.6102 578.68 54.6502C578.59 54.7302 578.48 54.7702 578.37 54.7702H578.36Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M539.87 55.55C540.08 55.55 540.07 56.03 539.86 56.05C539.62 56.07 539.66 55.55 539.87 55.55Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M539.84 56.5001C539.64 56.5001 539.46 56.4001 539.36 56.2401C539.21 55.9901 539.21 55.6901 539.34 55.4301C539.44 55.2301 539.64 55.1001 539.87 55.1001C540.21 55.1101 540.48 55.4001 540.47 55.7401C540.51 56.1101 540.26 56.4401 539.9 56.5001C539.88 56.5001 539.86 56.5001 539.84 56.5001ZM539.84 55.6001H539.81C539.7 55.6001 539.6 55.6802 539.57 55.7802C539.61 55.9102 539.73 56.0001 539.87 56.0001C539.98 56.0001 540.08 55.9501 540.13 55.8601C540.13 55.8401 540.15 55.8201 540.11 55.7401C540.05 55.6501 539.95 55.6001 539.84 55.6001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.23 52.8701C536.23 52.8701 536.03 52.7601 536.07 52.7701C536.04 52.7501 536.05 52.7201 536.02 52.7001C536.06 52.6701 536.22 52.8501 536.23 52.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.23 53.3102C536.23 53.3102 536.17 53.3102 536.14 53.3102C536.07 53.3002 536.01 53.2702 535.95 53.2302C535.91 53.2102 535.87 53.1802 535.84 53.1502C535.77 53.1102 535.71 53.0501 535.67 52.9701C535.6 52.8701 535.56 52.7502 535.58 52.6302C535.6 52.5102 535.66 52.4002 535.76 52.3302C535.89 52.2402 536.05 52.2202 536.19 52.2702C536.39 52.3602 536.55 52.5102 536.65 52.7102C536.69 52.8102 536.69 52.9202 536.65 53.0202C536.58 53.2002 536.41 53.3202 536.22 53.3202L536.23 53.3102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M500.59 52.2501C500.59 52.2501 500.78 52.2201 500.81 52.2501C500.84 52.2701 500.86 52.4402 500.83 52.4402C500.72 52.4602 500.59 52.2902 500.59 52.2602V52.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M500.8 52.8802C500.64 52.8802 500.48 52.8102 500.36 52.6902C500.21 52.5702 500.13 52.3902 500.14 52.2002C500.16 52.0402 500.26 51.9002 500.4 51.8302C500.61 51.7502 500.84 51.7501 501.04 51.8501C501.23 52.0001 501.33 52.2402 501.28 52.4802C501.24 52.6702 501.1 52.8202 500.91 52.8602C500.88 52.8602 500.84 52.8602 500.81 52.8602L500.8 52.8802ZM500.8 52.2702L500.7 52.6702C500.88 52.6302 501.01 52.4802 501.03 52.3002L500.8 52.2702ZM500.8 51.9802C500.8 51.9802 500.76 51.9802 500.74 51.9802C500.54 52.0102 500.4 52.1802 500.39 52.3802C500.42 52.4802 500.49 52.5702 500.58 52.6202L500.79 52.2702L500.59 52.2502L500.79 52.2702L500.81 52.2402V52.2702L501.04 52.2901C501.05 52.2001 501.04 52.1102 500.98 52.0302C500.93 51.9902 500.87 51.9802 500.81 51.9802H500.8Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.03 54.9901C613.03 54.9901 613.12 54.9401 613.14 54.8901C613.14 54.9101 613.12 54.9301 613.11 54.9401C613.09 54.9701 613 54.9401 612.98 54.9501C612.98 54.9501 613.02 54.9901 613.03 54.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.04 55.4301C612.87 55.4301 612.71 55.3501 612.61 55.2201C612.48 55.0401 612.5 54.7901 612.66 54.6301C612.73 54.5701 612.82 54.5201 612.91 54.5001C613.06 54.4101 613.25 54.4101 613.4 54.5101C613.55 54.6101 613.62 54.7902 613.59 54.9602C613.59 54.9902 613.57 55.0201 613.56 55.0401C613.56 55.0401 613.54 55.0801 613.53 55.1001C613.51 55.1401 613.48 55.1801 613.45 55.2201C613.41 55.2701 613.35 55.3102 613.29 55.3402C613.27 55.3502 613.25 55.3701 613.22 55.3801C613.16 55.4101 613.1 55.4201 613.04 55.4201V55.4301ZM613.04 54.8701H613.08L613.34 54.7001C613.22 54.5401 613.01 54.4901 612.83 54.5801L612.92 54.7802L613.04 54.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M573 52.2401C573 52.2401 572.91 52.3801 572.88 52.4301C572.88 52.4101 572.83 52.3301 572.84 52.3201C572.87 52.3001 572.84 52.1001 572.87 52.0901C572.95 52.1201 573 52.2401 573 52.2401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M572.88 52.8801C572.68 52.8801 572.5 52.7401 572.45 52.5501C572.37 52.3501 572.41 52.1301 572.56 51.9801C572.48 52.0501 572.43 52.1401 572.41 52.2501C572.38 52.0201 572.5 51.7901 572.7 51.6801C572.8 51.6401 572.92 51.6301 573.02 51.6801C573.21 51.7601 573.35 51.9101 573.42 52.1001C573.47 52.2301 573.45 52.3601 573.39 52.4801C573.37 52.5101 573.35 52.5501 573.32 52.6001L573.27 52.6701C573.19 52.8101 573.04 52.8901 572.88 52.8901V52.8801ZM572.6 52.3901L572.76 52.4101L572.78 52.3701L572.73 52.3401L572.6 52.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.32 50.1702C613.32 50.1702 613.52 50.1402 613.53 50.1302C613.48 50.0802 613.33 50.1502 613.32 50.1702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.32 50.6201C613.14 50.6201 612.97 50.5102 612.9 50.3402C612.83 50.1702 612.87 49.9801 613 49.8501C613.04 49.8101 613.08 49.7801 613.12 49.7601C613.34 49.6201 613.62 49.6401 613.82 49.8001C613.91 49.8801 613.97 50.0001 613.97 50.1201C613.97 50.2401 613.93 50.3601 613.84 50.4501C613.74 50.5401 613.61 50.5901 613.48 50.6001H613.43C613.43 50.6001 613.36 50.6201 613.32 50.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.79 50.8402C613.79 50.8402 613.96 50.9002 613.94 50.8702C613.91 50.8402 613.95 50.7802 613.92 50.7702C613.86 50.7502 613.78 50.8502 613.8 50.8402H613.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.92 51.3201C613.86 51.3201 613.81 51.3201 613.76 51.2901C613.65 51.2901 613.55 51.2401 613.48 51.1601C613.33 51.0101 613.3 50.7701 613.42 50.5901C613.56 50.3701 613.83 50.2601 614.08 50.3501C614.24 50.4301 614.36 50.5801 614.38 50.7601C614.41 50.8801 614.39 51.0101 614.33 51.1201C614.24 51.2501 614.09 51.3201 613.93 51.3201H613.92ZM613.67 51.1501C613.67 51.1501 613.72 51.1801 613.75 51.1901C613.9 51.2501 614.07 51.2101 614.16 51.0801L613.9 50.9101L613.67 51.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M577.97 55.5601C577.97 55.5601 577.89 55.6201 577.9 55.6701C577.9 55.6901 577.67 55.7701 577.66 55.8001C577.66 55.8201 577.7 55.74 577.71 55.72C577.71 55.63 577.79 55.4701 577.79 55.3801C577.86 55.3501 577.99 55.5301 577.98 55.5501L577.97 55.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M577.65 56.2601H577.62C577.46 56.2601 577.32 56.1601 577.25 56.0201C577.18 55.8801 577.18 55.7101 577.25 55.5801C577.26 55.5301 577.28 55.4801 577.29 55.4301C577.29 55.4101 577.31 55.3801 577.31 55.3601C577.31 55.1901 577.41 55.0401 577.57 54.9901C577.75 54.9101 577.96 54.9501 578.11 55.0701C578.23 55.1601 578.32 55.2901 578.38 55.4301C578.44 55.6001 578.39 55.7901 578.27 55.9201C578.19 56.0301 578.07 56.1201 577.94 56.1701H577.91C577.83 56.2401 577.74 56.2701 577.64 56.2701L577.65 56.2601ZM577.58 55.7701C577.58 55.7701 577.64 55.8201 577.68 55.8301H577.66L577.59 55.7701H577.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.38 49.1601C588.38 49.1601 588.74 49.2501 588.75 49.3001C588.75 49.3201 588.57 49.3801 588.55 49.4101C588.55 49.4301 588.64 49.4201 588.64 49.4201C588.64 49.3301 588.51 49.3901 588.51 49.3001C588.42 49.2501 588.38 49.1401 588.38 49.1601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.63 49.8701C588.42 49.8901 588.21 49.7701 588.14 49.5701C588.1 49.5301 588.07 49.4901 588.04 49.4501C587.9 49.2801 587.9 49.0401 588.04 48.8701C588.18 48.7001 588.42 48.6601 588.61 48.7801C588.63 48.7801 588.66 48.7901 588.68 48.8001C588.85 48.8501 589.15 48.9201 589.19 49.2401C589.22 49.4001 589.16 49.5601 589.03 49.6601C588.95 49.7901 588.81 49.8701 588.66 49.8801H588.63V49.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.9 49.2301C587 49.1901 587.12 49.1801 587.23 49.1901C587.25 49.2101 587.19 49.2501 587.16 49.2501C587.02 49.2501 586.9 49.2601 586.9 49.2301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587 49.7001C586.83 49.7201 586.66 49.6501 586.55 49.5201C586.46 49.4101 586.43 49.2701 586.46 49.1301C586.5 48.9701 586.62 48.8501 586.77 48.8001C587.01 48.7101 587.28 48.7301 587.5 48.8401C587.65 48.9601 587.71 49.1701 587.65 49.3501C587.57 49.5601 587.37 49.6901 587.15 49.7001H586.99H587ZM586.96 48.8501C586.89 48.9001 586.83 48.9701 586.8 49.0501L586.92 49.0901L586.96 48.8501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M509.75 33.2901C509.75 33.2901 509.88 33.2901 509.9 33.3301C509.91 33.3501 509.9 33.3401 509.89 33.3201C509.89 33.2801 509.76 33.2801 509.76 33.2901H509.75Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M509.9 33.7901C509.9 33.7901 509.83 33.7901 509.8 33.7801C509.77 33.7801 509.74 33.7601 509.72 33.7501C509.55 33.7301 509.41 33.6201 509.34 33.4601C509.28 33.3001 509.31 33.1201 509.42 32.9901C509.53 32.8601 509.7 32.8001 509.87 32.8401C510.02 32.8501 510.16 32.9301 510.25 33.0501C510.27 33.0801 510.29 33.1101 510.31 33.1501C510.38 33.3101 510.36 33.4901 510.25 33.6301C510.16 33.7301 510.04 33.8001 509.9 33.8001V33.7901ZM509.9 33.3501L509.82 33.7201C509.97 33.7001 510.1 33.6101 510.17 33.4701L509.9 33.3401V33.3501ZM509.46 33.4101C509.46 33.4101 509.48 33.4701 509.49 33.5101C509.48 33.4801 509.46 33.4501 509.46 33.4101ZM509.56 33.0501L509.77 33.2201L509.56 33.0501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M552.08 33.9801C552.05 33.9101 552.03 33.8401 552.02 33.7701C552.02 33.7501 551.64 33.7901 551.66 33.7701C551.73 33.7401 551.8 33.7301 551.87 33.7401C551.87 33.8301 551.82 34.0401 551.82 34.1301C551.93 34.1701 552.09 34.0001 552.09 33.9901L552.08 33.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M551.85 34.5802C551.78 34.5802 551.72 34.5701 551.65 34.5401C551.48 34.4801 551.37 34.3101 551.36 34.1301V34.1101C551.31 34.0701 551.27 34.0102 551.24 33.9502C551.17 33.7802 551.2 33.5802 551.33 33.4502C551.33 33.4502 551.41 33.3801 551.46 33.3601C551.64 33.2801 551.85 33.2602 552.05 33.3302C552.25 33.3302 552.41 33.4801 552.45 33.6701C552.45 33.7101 552.47 33.7601 552.49 33.8001C552.51 33.8501 552.52 33.9101 552.53 33.9701C552.53 34.1701 552.42 34.3502 552.25 34.4502C552.14 34.5402 552 34.5902 551.85 34.5902V34.5802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M551.88 31.9201C551.88 31.9201 551.9 31.7401 551.87 31.7201C551.9 31.7401 552.01 31.8601 552.04 31.8801C551.96 31.9201 551.89 31.9301 551.88 31.9201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M551.9 32.3801C551.83 32.3801 551.77 32.3702 551.71 32.3402C551.68 32.3302 551.64 32.3102 551.61 32.2802C551.46 32.1702 551.39 31.9801 551.42 31.7901C551.39 31.6301 551.46 31.4601 551.59 31.3601C551.72 31.2601 551.9 31.2401 552.05 31.3101C552.11 31.3401 552.16 31.3701 552.2 31.4201L552.33 31.5401C552.44 31.6401 552.49 31.7901 552.48 31.9301C552.46 32.0801 552.37 32.2001 552.24 32.2701C552.13 32.3301 552.02 32.3601 551.9 32.3601V32.3801ZM551.9 31.4801C551.9 31.4801 551.86 31.4801 551.83 31.4801L551.92 31.6601L552.06 31.5101C552.01 31.4901 551.96 31.4801 551.9 31.4801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.88 31.2701C613.88 31.2701 614.08 31.2801 614.09 31.2601C614.07 31.2801 614.04 31.4201 614.02 31.4401C614 31.3401 613.86 31.2802 613.87 31.2802L613.88 31.2701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.03 31.8801C613.87 31.8801 613.71 31.7901 613.63 31.6401C613.47 31.5301 613.4 31.3401 613.44 31.1601C613.45 31.1101 613.47 31.0701 613.5 31.0201C613.61 30.8601 613.81 30.7701 614.01 30.8101C614.17 30.7801 614.34 30.8401 614.44 30.9701C614.54 31.1001 614.57 31.2701 614.51 31.4301V31.4601C614.47 31.5701 614.42 31.6701 614.35 31.7601C614.27 31.8401 614.15 31.8901 614.03 31.8901V31.8801ZM613.84 30.8901C613.89 30.8501 613.95 30.8301 614.01 30.8201C613.95 30.8301 613.89 30.8601 613.84 30.8901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M576.99 31.5902C576.99 31.6702 576.71 31.7401 576.72 31.8101C576.72 31.8301 576.72 31.7702 576.73 31.7602C576.73 31.6702 576.8 31.4601 576.8 31.3701C576.87 31.3401 576.99 31.5802 576.99 31.5902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M576.72 32.2701C576.52 32.2701 576.34 32.1301 576.29 31.9401C576.28 31.9001 576.27 31.8701 576.27 31.8301C576.27 31.7801 576.27 31.7301 576.29 31.6801C576.3 31.6101 576.31 31.5401 576.33 31.4601C576.33 31.4201 576.35 31.3901 576.35 31.3501C576.35 31.1601 576.47 30.9901 576.65 30.9401C576.83 30.8801 577.02 30.9301 577.16 31.0501C577.31 31.1901 577.41 31.3701 577.44 31.5801C577.44 31.8101 577.29 32.0101 577.07 32.0901C576.99 32.1901 576.87 32.2501 576.74 32.2601H576.71L576.72 32.2701ZM576.76 31.8201C576.76 31.8201 576.83 31.8201 576.87 31.8201H576.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.12 25.1501C514.12 25.1501 514.07 25.1501 514.06 25.1701C514.04 25.1901 514.04 25.3301 514.06 25.3301C514.1 25.3301 514.12 25.1601 514.11 25.1501H514.12Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.06 25.7802C513.88 25.7802 513.72 25.6602 513.64 25.5002C513.56 25.2902 513.59 25.0502 513.73 24.8702C513.83 24.7702 513.97 24.7002 514.11 24.6902C514.25 24.6902 514.38 24.7602 514.46 24.8702C514.58 25.0602 514.59 25.3102 514.48 25.5102C514.4 25.6702 514.23 25.7802 514.05 25.7902L514.06 25.7802ZM514.2 25.2602L514.39 25.4802C514.48 25.4002 514.51 25.2702 514.47 25.1502L514.21 25.2602H514.2ZM514.06 24.8902C513.88 24.8902 513.73 24.9902 513.66 25.1602L514.05 25.1902V24.8902H514.06Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.04 25.2101C514.04 25.2101 514.15 25.3101 514.17 25.2801C514.19 25.2501 514.11 25.18 514.08 25.17C514.06 25.16 514.03 25.2001 514.04 25.2101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.15 25.7401C514.15 25.7401 514.12 25.7401 514.11 25.7401C513.92 25.7101 513.76 25.6001 513.66 25.4401C513.57 25.2501 513.6 25.0301 513.73 24.8801C513.87 24.7301 514.09 24.6901 514.28 24.7701C514.45 24.8501 514.57 25.0001 514.62 25.1801C514.65 25.3201 514.62 25.4601 514.53 25.5701C514.44 25.6801 514.31 25.7401 514.16 25.7401H514.15ZM514.02 25.3101L513.73 25.3601C513.74 25.4601 513.8 25.5401 513.9 25.5801L514.02 25.3101ZM514.2 24.8401L514.17 25.1201L514.43 24.9801C514.38 24.8901 514.3 24.8401 514.2 24.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M596.91 26.7801C596.91 26.7801 596.91 26.6201 596.93 26.5701C596.93 26.5901 597.01 26.6701 597 26.6801C596.98 26.7001 597.07 26.6201 597.05 26.6401C597.06 26.7001 596.9 26.7901 596.92 26.7801H596.91Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M596.91 26.62C596.75 26.62 596.6 27.15 596.52 27C596.47 26.91 596.45 26.8 596.47 26.69C596.47 26.6 596.47 26.52 596.5 26.43C596.54 26.29 596.65 26.18 596.79 26.13C596.93 26.08 597.08 26.11 597.2 26.2C597.26 26.22 597.32 26.26 597.37 26.3C597.47 26.4 597.52 26.55 597.49 26.69C597.46 26.88 597.33 27.0501 597.16 27.1401C597.15 27.1401 597.13 27.16 597.12 27.16C597.05 27.19 596.98 26.6 596.91 26.6V26.62Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M512.51 26.2702C512.43 26.3402 512.08 26.1502 512 26.2202C512.08 26.3102 512.16 26.3902 512.26 26.4602C512.34 26.3902 512.45 26.0002 512.53 25.9302C512.61 25.9602 512.53 26.2602 512.51 26.2702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M512.26 26.9101C512.03 26.8701 511.82 26.7401 511.69 26.5501C511.55 26.4001 511.52 26.1701 511.61 25.9901C511.63 25.9501 511.66 25.9201 511.69 25.8901C511.8 25.7901 511.95 25.7401 512.09 25.7601C512.12 25.7001 512.16 25.6501 512.21 25.6001C512.34 25.4801 512.52 25.4501 512.68 25.5101C512.87 25.5901 513 25.7801 512.99 25.9901C513 26.2101 512.93 26.4301 512.79 26.6001C512.79 26.6001 512.68 26.6801 512.62 26.7001C512.6 26.7301 512.57 26.7601 512.54 26.7901C512.46 26.8701 512.35 26.9101 512.23 26.9101H512.26Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.3 26.1401C514.38 26.2201 514.48 26.2701 514.56 26.3501C514.57 26.3501 514.59 26.3201 514.58 26.3101C514.49 26.3101 514.4 26.3901 514.3 26.3901C514.28 26.3901 514.44 26.4701 514.45 26.4601C514.45 26.3701 514.32 26.2101 514.32 26.1201C514.32 26.1001 514.29 26.1201 514.3 26.1401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M514.43 26.9101C514.43 26.9101 514.37 26.9102 514.33 26.9002C514.25 26.8802 513.87 26.7801 513.84 26.4301C513.84 26.3701 513.84 26.3202 513.86 26.2602C513.82 26.1202 513.85 25.9701 513.93 25.8501C514.02 25.7201 514.17 25.6501 514.32 25.6601C514.47 25.6601 514.62 25.7502 514.7 25.8802H514.73C514.89 25.9502 515 26.1002 515.02 26.2702C515.03 26.4502 514.95 26.6201 514.81 26.7201C514.72 26.8401 514.58 26.9002 514.44 26.9002L514.43 26.9101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.27 26.2601C603.3 26.3601 603.31 26.4601 603.29 26.5701C603.28 26.5901 603.31 26.5501 603.31 26.5201C603.31 26.3801 603.24 26.2501 603.27 26.2601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.29 27.0202C603.2 27.0202 603.12 26.9902 603.04 26.9502C602.89 26.8502 602.81 26.6601 602.85 26.4801V26.4602C602.79 26.2902 602.82 26.1101 602.93 25.9701C603.04 25.8501 603.2 25.8002 603.36 25.8302C603.51 25.8702 603.64 25.9801 603.69 26.1201C603.71 26.1901 603.72 26.2602 603.73 26.3302C603.74 26.3902 603.75 26.4602 603.75 26.5302C603.75 26.6002 603.73 26.6801 603.7 26.7401C603.69 26.7701 603.67 26.8002 603.65 26.8302C603.56 26.9502 603.42 27.0202 603.28 27.0202H603.29Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M512.18 26.3102C512.11 26.3902 511.99 26.4702 511.92 26.5502C511.92 26.5602 511.96 26.5702 511.97 26.5602C512.04 26.4802 512.28 26.4902 512.35 26.4102C512.36 26.3802 512.19 26.3002 512.17 26.3102H512.18Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M511.95 27.0101C511.83 27.0101 511.72 26.9701 511.63 26.9001C511.48 26.7701 511.43 26.5501 511.51 26.3701C511.53 26.3301 511.55 26.2901 511.58 26.2601C511.64 26.2001 511.7 26.1401 511.77 26.0801C511.8 26.0601 511.82 26.0401 511.84 26.0201C511.87 25.9801 511.91 25.9501 511.95 25.9301C512.18 25.8201 512.46 25.8701 512.64 26.0501C512.79 26.1801 512.85 26.4001 512.77 26.5901C512.75 26.6301 512.73 26.6701 512.7 26.7001C512.58 26.8201 512.43 26.9001 512.26 26.9201H512.22C512.14 26.9801 512.05 27.0101 511.96 27.0101H511.95ZM511.93 26.5701C511.96 26.6401 512.01 26.7101 512.07 26.7501L512.09 26.7001L511.93 26.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M566.56 26.6601C566.56 26.6601 566.49 26.7301 566.44 26.7101C566.46 26.7101 566.75 26.3601 566.76 26.3701C566.78 26.3901 566.79 26.4901 566.81 26.5101C566.73 26.5601 566.64 26.6101 566.55 26.6501L566.56 26.6601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M566.46 27.1602C566.4 27.1602 566.34 27.1502 566.28 27.1302C566.13 27.0702 566.03 26.9302 566 26.7802C565.97 26.6302 566.04 26.4602 566.17 26.3602C566.2 26.3302 566.24 26.2902 566.28 26.2402C566.47 26.0302 566.55 25.9402 566.75 25.9302C566.87 25.9302 566.98 25.9602 567.07 26.0402C567.16 26.1202 567.22 26.2302 567.24 26.3502C567.32 26.5502 567.24 26.7902 567.06 26.9002C566.96 26.9702 566.84 27.0302 566.73 27.0802C566.65 27.1302 566.56 27.1602 566.46 27.1602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M511.77 26.8501C511.85 26.7701 511.88 26.6501 511.96 26.5801C511.96 26.5701 511.98 26.5501 511.96 26.5601C511.88 26.6401 511.73 26.7001 511.65 26.7701C511.64 26.8001 511.75 26.8601 511.76 26.8501H511.77Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M511.77 27.3001C511.62 27.3001 511.47 27.2301 511.36 27.1201C511.22 26.9801 511.17 26.7701 511.25 26.5801C511.27 26.5301 511.31 26.4801 511.35 26.4401C511.42 26.3801 511.5 26.3201 511.58 26.2701C511.61 26.2601 511.63 26.2401 511.66 26.2201C511.69 26.1901 511.72 26.1701 511.76 26.1501C511.94 26.0601 512.16 26.0901 512.3 26.2401C512.44 26.3901 512.46 26.6101 512.36 26.7901C512.34 26.8301 512.31 26.8601 512.28 26.8901C512.23 26.9901 512.17 27.0801 512.09 27.1601C512.06 27.1901 512.02 27.2201 511.98 27.2401C511.92 27.2701 511.85 27.2901 511.78 27.2901L511.77 27.3001ZM511.79 26.4001L511.92 26.5301L511.98 26.4701C511.93 26.4201 511.86 26.4001 511.79 26.4001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.65 26.2101C607.65 26.2101 607.71 26.3501 607.74 26.3701C607.72 26.3701 607.87 26.2301 607.87 26.2201C607.85 26.1601 607.83 26.0902 607.81 26.0302C607.72 26.0302 607.64 26.2001 607.65 26.2101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.74 26.8201C607.65 26.8201 607.56 26.7901 607.49 26.7401C607.4 26.6701 607.32 26.5801 607.28 26.4701C607.24 26.4201 607.22 26.3601 607.2 26.3001C607.16 25.9401 607.42 25.6202 607.77 25.5802C607.99 25.5602 608.19 25.7101 608.24 25.9301C608.24 25.9501 608.26 26.0002 608.27 26.0302C608.36 26.2302 608.3 26.4701 608.12 26.6101C608.04 26.7401 607.89 26.8302 607.73 26.8302L607.74 26.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M511.63 26.9101C511.63 26.9101 511.72 26.7801 511.73 26.7901C511.67 26.8501 511.65 26.9201 511.63 26.9101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M511.63 27.3601C511.51 27.3601 511.4 27.3101 511.31 27.2301C511.14 27.0601 511.13 26.7901 511.29 26.6101C511.32 26.5701 511.35 26.5301 511.38 26.4901C511.45 26.4101 511.56 26.3502 511.67 26.3402C511.86 26.3202 512.03 26.4202 512.12 26.5902C512.2 26.7602 512.17 26.9601 512.04 27.1001C512.02 27.1201 512.01 27.1501 511.99 27.1701C511.92 27.2701 511.81 27.3401 511.68 27.3601C511.66 27.3601 511.64 27.3601 511.62 27.3601H511.63ZM511.73 26.8001L511.94 26.5902L511.73 26.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.83 14.0001C610.83 14.0001 610.91 14.1201 610.94 14.0801C610.97 14.1301 611.05 13.9101 611.08 13.9601C611.1 13.9601 611.15 13.8901 611.13 13.8801C611.05 13.8801 610.93 13.8201 610.85 13.8201C610.83 13.8801 610.82 13.9401 610.83 14.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.93 14.5302H610.92C610.79 14.5302 610.67 14.4701 610.58 14.3701C610.56 14.3501 610.53 14.3401 610.51 14.3101C610.25 14.0501 610.45 13.6201 610.45 13.6201C610.53 13.4701 610.68 13.3701 610.85 13.3701C610.94 13.3701 611.03 13.3901 611.12 13.4201C611.19 13.4201 611.26 13.4401 611.32 13.4701C611.55 13.5801 611.64 13.8501 611.53 14.0801C611.49 14.1801 611.42 14.2601 611.33 14.3201C611.24 14.4501 611.1 14.5202 610.94 14.5302H610.91H610.93ZM611.14 14.0001L611.23 14.0701C611.23 14.0701 611.28 13.9901 611.29 13.9401L611.14 13.9601V14.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.55 14.1701C610.63 14.0901 610.92 14.2001 611 14.1101C610.94 14.0601 610.88 14.0101 610.81 13.9801C610.73 14.0601 610.67 14.3101 610.6 14.3801C610.55 14.3801 610.54 14.1701 610.55 14.1601V14.1701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.59 14.8501C610.36 14.8501 610.17 14.6901 610.12 14.4701C610.04 14.2501 610.09 14.0002 610.26 13.8302C610.31 13.7802 610.38 13.7501 610.44 13.7301C610.45 13.7101 610.47 13.7001 610.48 13.6801C610.51 13.6501 610.54 13.6301 610.57 13.6101C610.89 13.4201 611.21 13.7001 611.3 13.7901C611.45 13.9401 611.48 14.1602 611.38 14.3402C611.36 14.3702 611.34 14.4101 611.31 14.4301C611.23 14.5201 611.12 14.5702 611 14.5902C610.97 14.6302 610.94 14.6702 610.91 14.7102C610.83 14.7902 610.72 14.8402 610.6 14.8402H610.59V14.8501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.88 14.7501C608.8 14.7501 608.68 14.9601 608.6 14.9601C608.59 14.9601 608.54 15.0401 608.55 15.0501C608.64 15.0501 608.79 14.9901 608.88 14.9901C608.92 14.9201 608.92 14.8301 608.88 14.7501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.55 15.5001C608.43 15.5001 608.31 15.45 608.23 15.36C608.14 15.27 608.1 15.1501 608.1 15.0301C608.12 14.8301 608.23 14.6601 608.4 14.5601C608.51 14.4101 608.69 14.31 608.88 14.3C608.92 14.3 608.96 14.3001 609 14.3201C609.15 14.3701 609.26 14.4801 609.32 14.6201C609.4 14.8201 609.38 15.0501 609.26 15.2401C609.18 15.3701 609.04 15.4401 608.89 15.4401C608.89 15.4401 608.86 15.4501 608.84 15.4601C608.75 15.4901 608.66 15.5001 608.56 15.5101L608.55 15.5001ZM608.88 15.0601V15.2001C608.88 15.2001 608.94 15.2001 608.97 15.1901C608.99 15.1501 608.99 15.1001 608.99 15.0601H608.88ZM608.51 14.7401C608.47 14.8001 608.46 14.8701 608.48 14.9301L608.55 14.9001V14.7601L608.51 14.73V14.7401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.2 16.7301C610.2 16.7301 610.2 16.6901 610.18 16.7101C610.16 16.7301 610.31 16.5701 610.34 16.5901C610.3 16.6401 610.25 16.6901 610.2 16.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.2 17.1801C610.09 17.1801 609.98 17.1401 609.9 17.0601H609.89C609.71 16.8901 609.69 16.6201 609.84 16.4301C609.86 16.4101 609.88 16.3901 609.9 16.3701C610.27 16.0001 610.54 16.1501 610.66 16.2601C610.78 16.3801 610.83 16.5601 610.77 16.7301C610.68 16.9401 610.49 17.1001 610.27 17.1701C610.25 17.1701 610.23 17.1701 610.2 17.1701V17.1801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.51 27.4602C492.51 27.4602 492.55 27.5802 492.53 27.5602C492.51 27.5402 492.53 27.7402 492.5 27.7402C492.46 27.7302 492.5 27.4702 492.51 27.4702V27.4602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.5 28.1901C492.5 28.1901 492.42 28.1901 492.38 28.1701C492.21 28.1101 492.08 27.9701 492.05 27.8001C492.05 27.8001 491.98 27.3201 492.25 27.1101C492.45 26.9601 492.72 27.0001 492.88 27.1901C492.99 27.3401 493.02 27.5301 492.97 27.7001C492.97 27.8601 492.9 28.0101 492.77 28.1001C492.69 28.1601 492.6 28.1801 492.5 28.1801V28.1901ZM492.12 27.6601C492.12 27.6601 492.15 27.7201 492.17 27.7501L492.25 27.6901L492.12 27.6601ZM492.61 27.4901L492.92 27.5801C492.89 27.4901 492.83 27.4101 492.75 27.3601L492.61 27.4901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.65 26.8401C608.65 26.8401 608.69 26.8401 608.66 26.8101C608.68 26.8301 608.85 26.95 608.87 26.97C608.85 26.99 608.65 26.8501 608.64 26.8401H608.65Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.86 27.4201C608.86 27.4201 608.8 27.4201 608.77 27.4201C608.61 27.3701 608.47 27.2901 608.35 27.1801C608.24 27.0801 608.18 26.9302 608.19 26.7802C608.21 26.6302 608.3 26.5101 608.43 26.4301C608.56 26.3601 608.71 26.3501 608.85 26.4101C608.89 26.4301 608.94 26.4601 608.97 26.5001L609.02 26.5302C609.09 26.5802 609.16 26.6402 609.18 26.6502C609.33 26.8002 609.36 27.0501 609.23 27.2301C609.14 27.3501 609 27.4301 608.85 27.4201H608.86Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.09 27.5502C608.09 27.5502 607.9 27.6202 607.92 27.6402C607.94 27.6602 608.04 27.5002 608.07 27.5102C608.1 27.5102 608.11 27.5502 608.1 27.5602L608.09 27.5502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.92 28.0802C607.78 28.0802 607.65 28.0201 607.56 27.9101C607.47 27.8001 607.44 27.6602 607.47 27.5302C607.5 27.4102 607.57 27.3102 607.67 27.2502C607.77 27.1202 607.93 27.0402 608.1 27.0502C608.3 27.0802 608.46 27.2202 608.52 27.4002C608.57 27.5902 608.5 27.7802 608.35 27.9002C608.3 27.9402 608.25 27.9601 608.19 27.9801C608.11 28.0401 608.02 28.0702 607.93 28.0702H607.92V28.0802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.33 44.11C536.33 44.11 536.44 43.9 536.42 43.92C536.39 43.94 536.64 44.0501 536.62 44.0801C536.57 44.1601 536.34 44.12 536.33 44.11Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M536.46 44.5902C536.27 44.6002 536.09 44.5302 535.97 44.3902C535.85 44.1802 535.86 43.9301 536.01 43.7501C536.07 43.6201 536.18 43.5301 536.32 43.5001C536.46 43.4701 536.6 43.5002 536.71 43.5902C536.73 43.6002 536.74 43.6202 536.76 43.6402C537.2 43.9302 537.06 44.2402 537.01 44.3302C536.91 44.5002 536.73 44.6001 536.54 44.6001C536.52 44.6001 536.5 44.6001 536.48 44.6001L536.46 44.5902ZM536.23 43.8501L536.38 43.9301L536.45 43.6901C536.36 43.7101 536.28 43.7701 536.23 43.8501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M557.87 47.3001C557.87 47.3001 557.87 47.2601 557.9 47.2801C557.91 47.2801 557.92 47.3001 557.93 47.3101C557.93 47.3201 557.93 47.3401 557.93 47.3501C557.91 47.3801 557.87 47.3401 557.88 47.3001H557.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M557.9 47.8001C557.9 47.8001 557.8 47.8001 557.76 47.7801C557.54 47.7001 557.41 47.4901 557.43 47.2601L557.82 47.3001L557.43 47.2501C557.45 47.0901 557.54 46.9501 557.69 46.8701C557.84 46.8101 558.01 46.8201 558.15 46.9001C558.26 46.9701 558.34 47.0901 558.38 47.2101C558.4 47.3401 558.38 47.4801 558.31 47.5901C558.22 47.7201 558.07 47.8001 557.91 47.8001H557.9ZM557.85 47.3601L557.5 47.4101C557.52 47.5101 557.59 47.6001 557.67 47.6601L557.85 47.3601ZM557.92 47.3001L558.32 47.3401L557.92 47.3001ZM557.93 47.2701L558.32 47.3301C558.34 47.1501 558.22 46.9801 558.05 46.9301L557.93 47.2701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M578.53 47.5201C578.53 47.5201 578.75 47.4001 578.72 47.3901C578.69 47.3701 578.57 47.6701 578.54 47.6601C578.51 47.6601 578.52 47.5301 578.54 47.5201H578.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M578.55 48.1102C578.55 48.1102 578.48 48.1102 578.44 48.1002C578.25 48.0502 578.11 47.8902 578.07 47.7002C578.03 47.4802 578.12 47.2602 578.3 47.1402L578.33 47.1202L578.37 47.1002C578.43 47.0302 578.52 46.9802 578.61 46.9602C578.75 46.9302 578.9 46.9602 579.01 47.0502C579.12 47.1402 579.18 47.2802 579.18 47.4202C579.18 47.5402 579.13 47.6502 579.04 47.7302C578.98 47.8602 578.84 48.1202 578.56 48.1202L578.55 48.1102ZM578.58 47.6202L578.75 47.9202H578.77L578.59 47.6202H578.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M542.19 46.0001C542.19 46.0001 542.21 46.0201 542.19 46.0501C542.17 46.0701 542.12 46.1201 542.1 46.0901C542.08 46.0601 542.16 45.9901 542.19 46.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M542.12 46.5401C541.97 46.5401 541.84 46.4701 541.75 46.3501C541.64 46.1901 541.63 45.9901 541.73 45.8201C541.84 45.6301 542.05 45.5201 542.27 45.5501C542.43 45.5801 542.57 45.6801 542.64 45.8301C542.69 45.9901 542.67 46.1701 542.57 46.3101C542.47 46.4501 542.31 46.5301 542.14 46.5401H542.12ZM542.13 46.3801V46.4401C542.26 46.4701 542.41 46.4001 542.49 46.2801L542.19 46.1001L542.13 46.3801ZM542.12 45.6401C542.01 45.6401 541.91 45.6801 541.84 45.7601L542.11 45.97V45.6401H542.12Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.98 45.4202C587.06 45.3402 587.19 45.2802 587.27 45.2002C587.27 45.1902 587.27 45.2602 587.25 45.2702C587.17 45.3502 586.97 45.2502 586.89 45.3302C586.89 45.3302 586.96 45.4402 586.98 45.4302V45.4202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.97 45.8701C586.78 45.8601 586.6 45.7401 586.51 45.5701C586.39 45.3901 586.41 45.1501 586.56 45.0001C586.67 44.8901 586.82 44.8302 586.98 44.8402C587.08 44.7702 587.2 44.7301 587.32 44.7501C587.51 44.7801 587.66 44.9301 587.69 45.1201C587.71 45.2901 587.65 45.4502 587.54 45.5802C587.47 45.6502 587.38 45.7001 587.28 45.7301H587.27C587.27 45.7301 587.2 45.8001 587.16 45.8201C587.1 45.8501 587.02 45.8701 586.95 45.8701H586.97Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.74 45.0301C591.74 45.0301 591.82 45.1601 591.8 45.1901C591.78 45.2201 591.5 45.2701 591.49 45.2401C591.46 45.1701 591.7 45.0201 591.73 45.0301H591.74Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.53 45.7001H591.49C591.31 45.6801 591.16 45.57 591.08 45.41C591.02 45.25 591.04 45.06 591.15 44.92C591.3 44.72 591.53 44.6001 591.77 44.5801C591.94 44.6101 592.09 44.7101 592.18 44.8701C592.28 45.0401 592.28 45.2601 592.18 45.4301C592.03 45.6801 591.65 45.7001 591.52 45.7001H591.53ZM591.78 45.1301L591.9 45.4501C591.95 45.3301 591.96 45.2001 591.91 45.0801L591.78 45.1301ZM591.42 44.9601C591.36 45.0501 591.35 45.1701 591.38 45.2701L591.5 45.2101V45.0301L591.42 44.9601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M557.82 38.9301C557.82 38.9301 557.9 38.8501 557.91 38.8301C557.89 38.8501 557.73 38.8101 557.71 38.8301C557.71 38.8301 557.8 38.9301 557.82 38.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M557.82 39.3801C557.64 39.3701 557.48 39.2701 557.38 39.1301C557.3 39.0401 557.26 38.9201 557.27 38.8001C557.28 38.6801 557.34 38.5701 557.43 38.4901C557.55 38.3901 557.71 38.3601 557.86 38.3801C557.81 38.3801 557.77 38.4001 557.73 38.4201C557.9 38.3401 558.11 38.3701 558.24 38.5101C558.37 38.6501 558.41 38.8501 558.33 39.0201C558.3 39.0801 558.26 39.1401 558.21 39.1901C558.13 39.3001 558 39.3701 557.87 39.3801H557.84H557.82Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.93 37.2501C608.93 37.2501 608.73 37.1501 608.75 37.1201C608.77 37.0901 608.84 37.4201 608.87 37.4301C608.89 37.4301 608.96 37.2501 608.93 37.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.87 37.8802C608.81 37.8802 608.75 37.8702 608.69 37.8402C608.52 37.7502 608.41 37.5802 608.38 37.3902V37.3602C608.38 37.3602 608.35 37.3302 608.34 37.3102C608.27 37.1602 608.29 36.9902 608.38 36.8502C608.48 36.7102 608.65 36.6402 608.82 36.6702C608.93 36.6902 609.03 36.7402 609.1 36.8302C609.22 36.8802 609.32 36.9802 609.36 37.1102C609.41 37.3402 609.34 37.5902 609.18 37.7602C609.09 37.8402 608.98 37.8802 608.87 37.8802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M577.78 34.4902C577.78 34.4902 577.93 34.5202 577.91 34.5102C577.89 34.4902 577.92 34.4201 577.91 34.4101C577.86 34.3901 577.77 34.5002 577.79 34.5002L577.78 34.4902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M577.88 34.9502C577.88 34.9502 577.81 34.9502 577.77 34.9402C577.65 34.9402 577.54 34.8902 577.46 34.8102C577.31 34.6602 577.28 34.4101 577.41 34.2301C577.55 34.0001 577.83 33.8902 578.08 33.9902C578.25 34.0802 578.35 34.2502 578.36 34.4402C578.37 34.5402 578.36 34.6401 578.31 34.7201C578.22 34.8601 578.06 34.9502 577.89 34.9402L577.88 34.9502ZM577.8 34.6601L577.72 34.8102C577.72 34.8102 577.75 34.8202 577.77 34.8302L577.8 34.6601ZM577.86 34.5502L578.01 34.8202C578.06 34.8002 578.11 34.7701 578.15 34.7201L577.87 34.5302L577.86 34.5502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M501.23 35.6501C501.23 35.6501 501.25 35.4801 501.27 35.4501C501.27 35.4701 501.17 35.3501 501.16 35.3601C501.14 35.3701 501.03 35.5301 501 35.5401C501 35.6101 501.21 35.6601 501.23 35.6601V35.6501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M501.23 36.1001C501.07 36.1001 500.92 36.0402 500.79 35.9602C500.66 35.8702 500.57 35.7302 500.56 35.5802C500.55 35.4302 500.61 35.2902 500.72 35.1902L500.76 35.1502C500.81 35.0802 500.86 35.0301 500.93 34.9801C501.02 34.9201 500.66 34.8102 500.93 35.0802C501.08 35.1802 501.15 35.3601 501.11 35.5401C501.11 35.5601 501.11 35.5801 501.09 35.6001C501.09 35.7101 501.05 35.8201 500.98 35.9201C500.92 36.0001 501.45 36.0602 501.35 36.0902C501.31 36.1002 501.27 36.1101 501.23 36.1101V36.1001ZM501.28 35.4502L501.44 35.5002H500.85C500.83 35.3302 501.33 35.2302 501.28 35.2002L501.25 35.3601L501.28 35.4502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M509.98 36.3901C509.96 36.3401 509.82 36.3201 509.82 36.2601C509.82 36.2401 510.17 36.2801 510.19 36.2601C510.19 36.2601 510.06 36.1501 510.05 36.1601C510.05 36.2501 510.11 36.3801 510.11 36.4701C510.1 36.4901 509.98 36.4101 509.98 36.4001V36.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M510.09 36.9202C510.09 36.9202 509.99 36.9202 509.94 36.9002C509.83 36.8602 509.74 36.8002 509.66 36.7202C509.5 36.6402 509.39 36.5002 509.37 36.3202C509.35 36.1902 509.4 36.0602 509.49 35.9602C509.56 35.8802 509.66 35.8302 509.77 35.8202C509.82 35.7802 509.88 35.7502 509.95 35.7302C510.15 35.6902 510.36 35.7702 510.49 35.9302C510.66 36.0802 510.69 36.3302 510.57 36.5202C510.57 36.5802 510.55 36.6402 510.52 36.6902C510.43 36.8402 510.27 36.9402 510.1 36.9302L510.09 36.9202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M574.33 40.4901C574.33 40.4901 573.96 40.4402 573.95 40.4002C573.95 40.3902 574.36 40.3002 574.38 40.2802C574.38 40.2602 574.23 40.2801 574.22 40.2901C574.22 40.3701 574.25 40.2901 574.24 40.3601C574.32 40.4001 574.32 40.5001 574.32 40.4901H574.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M574.33 40.9402C574.26 40.9402 574.2 40.9302 574.14 40.9002H574.08C573.91 40.8702 573.59 40.8301 573.51 40.5001C573.48 40.3801 573.51 40.2601 573.56 40.1601C573.65 40.0301 573.79 39.9401 573.95 39.9301C574.1 39.8401 574.28 39.8002 574.46 39.8302C574.66 39.8702 574.81 40.0401 574.83 40.2401C574.82 40.5401 574.64 40.8002 574.38 40.9402C574.36 40.9402 574.35 40.9402 574.33 40.9402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M574.3 40.4502C574.3 40.4502 574.27 40.6602 574.3 40.6302C574.33 40.6002 574.14 40.5102 574.16 40.4702C574.18 40.4102 574.3 40.4302 574.3 40.4502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M574.29 41.0802C574.22 41.0802 574.16 41.0702 574.1 41.0402C574.04 41.0102 573.98 40.9602 573.95 40.9002C573.74 40.7802 573.65 40.5202 573.74 40.3002C573.82 40.1102 574.01 39.9902 574.22 39.9902C574.42 39.9802 574.61 40.0802 574.7 40.2502C574.75 40.3502 574.76 40.4602 574.75 40.5702C574.76 40.7102 574.72 40.8402 574.63 40.9402C574.54 41.0302 574.42 41.0902 574.29 41.0902V41.0802ZM574.08 40.8402C574.13 40.8702 574.19 40.8802 574.24 40.8802C574.38 40.8702 574.51 40.7802 574.56 40.6502C574.62 40.5902 574.65 40.5002 574.63 40.4102C574.61 40.3202 574.55 40.2502 574.47 40.2202L574.29 40.6202L574.08 40.8402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M540.97 40.0401C541.05 40.1201 541.04 40.3201 541.12 40.4001C541.2 40.3501 541.27 40.2901 541.32 40.2101C541.24 40.1301 541.09 40.0701 541.01 39.9901C541.01 39.9901 540.97 40.0202 540.97 40.0302V40.0401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M541.12 40.8602C541.05 40.8602 540.98 40.8402 540.91 40.8102C540.87 40.7902 540.83 40.7602 540.8 40.7302C540.7 40.6202 540.63 40.4802 540.61 40.3402C540.61 40.3202 540.61 40.3102 540.61 40.3202C540.53 40.2102 540.5 40.0802 540.53 39.9502C540.56 39.8202 540.64 39.7102 540.75 39.6402C540.93 39.5202 541.16 39.5402 541.32 39.6902C541.34 39.7102 541.37 39.7202 541.39 39.7402C541.48 39.7902 541.56 39.8502 541.63 39.9102C541.66 39.9402 541.69 39.9802 541.71 40.0202C541.82 40.2302 541.76 40.4802 541.57 40.6202C541.46 40.7602 541.29 40.8502 541.11 40.8702L541.12 40.8602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M541.02 40.3901C541.11 40.4501 541.22 40.4701 541.33 40.4501C541.36 40.4201 541.23 40.1201 541.18 40.1201C541.07 40.1201 541.01 40.3701 541.01 40.3901H541.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M541.29 40.9102C541.29 40.9102 541.2 40.9102 541.15 40.9002C540.8 40.8502 540.68 40.7102 540.63 40.6102C540.55 40.4202 540.56 40.1902 540.68 40.0202C540.77 39.8302 540.95 39.7002 541.16 39.6802C541.42 39.6802 541.64 39.8502 541.71 40.1002C541.84 40.3202 541.81 40.5902 541.65 40.7802C541.55 40.8702 541.43 40.9202 541.3 40.9102H541.29ZM540.9 40.4602C540.99 40.5402 541.1 40.5802 541.22 40.5702C541.32 40.5702 541.41 40.5202 541.47 40.4402L541.03 40.3402L541.41 40.1602C541.37 40.1002 541.32 40.0502 541.26 40.0102C541.17 40.0202 541.09 40.0602 541.02 40.1202C540.93 40.2002 540.88 40.3202 540.89 40.4402L541.02 40.3802L540.9 40.4502V40.4602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.17 36.42C494.23 36.32 494.23 36.1901 494.17 36.0901V36.42Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.2 35.6401C494.37 35.6501 494.52 35.7601 494.59 35.9201C494.65 36.0401 494.67 36.1801 494.66 36.3101C494.74 36.3601 494.81 36.4201 494.87 36.5001C494.94 36.6101 494.96 36.7401 494.93 36.8601C494.9 36.9801 494.81 37.0901 494.7 37.1501L494.59 37.2101C494.51 37.2601 494.41 37.3101 494.33 37.3501", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M486.4 31.5302C486.3 31.4702 486.2 31.4102 486.1 31.3502C486.2 31.2302 486.32 31.0602 486.44 30.9502C486.56 31.0202 486.68 31.1002 486.79 31.1802C486.72 31.3302 486.49 31.3802 486.41 31.5302H486.4Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M486.41 32.0001C486.3 32.0001 486.2 31.9501 486.12 31.8801C486.08 31.8501 486.05 31.8301 486.01 31.8201C485.94 31.7901 485.88 31.7501 485.82 31.7101C485.73 31.6301 485.67 31.5201 485.66 31.4001C485.65 31.2801 485.69 31.1601 485.77 31.0701C485.81 31.0301 485.84 30.9801 485.88 30.9301C485.96 30.8301 486.04 30.7301 486.12 30.6401C486.38 30.3701 486.67 30.5601 486.85 30.6801C487.06 30.8201 487.35 31.0101 487.2 31.3601C487.12 31.5201 486.99 31.6501 486.84 31.7401C486.82 31.7501 486.79 31.77 486.77 31.79C486.71 31.9 486.6 31.9801 486.47 32.0001C486.45 32.0001 486.43 32.0001 486.4 32.0001H486.41Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.27 35.3901C495.24 35.2601 495.28 35.2301 495.26 35.1101C495.36 35.1101 495.31 34.9801 495.41 34.9801C495.39 35.1101 495.35 35.2601 495.34 35.3901C495.34 35.4101 495.4 35.3201 495.38 35.3101C495.33 35.2801 495.29 35.1201 495.23 35.1201C495.17 35.1201 495.19 35.2801 495.21 35.3301C495.24 35.4001 495.27 35.4201 495.27 35.4001V35.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.27 35.85C495.06 35.85 494.88 35.7101 494.81 35.5201C494.72 35.3201 494.73 35.1 494.82 34.91C494.86 34.84 494.92 34.7901 494.99 34.7501C495.08 34.6201 495.23 34.54 495.39 34.54C495.52 34.54 495.65 34.5901 495.74 34.6901C495.83 34.7901 495.87 34.92 495.85 35.05C495.85 35.11 495.83 35.1801 495.81 35.2501C495.82 35.3201 495.82 35.4 495.8 35.47C495.75 35.67 495.58 35.82 495.37 35.85C495.37 35.85 495.3 35.86 495.27 35.86V35.85ZM495.23 34.9501L495.37 34.97C495.37 34.97 495.27 34.9501 495.23 34.9501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M495.13 35.3402C495.08 35.3902 495.04 35.4802 494.97 35.5002C494.86 35.5302 494.74 35.5402 494.63 35.5502C494.73 35.4802 494.83 35.4102 494.93 35.3502C495 35.3302 495.18 35.4802 495.25 35.4702C495.27 35.4402 495.15 35.3302 495.13 35.3402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.63 35.9901C494.43 35.9901 494.25 35.8501 494.2 35.6601C494.15 35.4601 494.24 35.2601 494.41 35.1501L494.47 35.1101C494.57 35.0301 494.68 34.9601 494.8 34.9101C494.87 34.8901 494.95 34.8801 495.02 34.9001C495.38 34.8101 495.61 35.1901 495.62 35.2101C495.72 35.3901 495.71 35.6201 495.57 35.7801C495.49 35.8701 495.38 35.9201 495.27 35.9301C495.23 35.9301 495.19 35.9301 495.15 35.9301H495.13C494.97 35.9801 494.8 36.0101 494.63 36.0101V35.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.64 49.4202C487.48 49.3402 487.32 49.6402 487.16 49.5602C487.32 49.6402 487.48 49.3402 487.64 49.4202Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.21 50.0201C487.12 50.0201 487.04 50.0001 486.96 49.9601C486.78 49.8701 486.68 49.6601 486.72 49.4601C486.77 49.2601 486.95 49.1101 487.15 49.1101C487.34 48.9501 487.61 48.9101 487.84 49.0101C488.02 49.1001 488.12 49.3101 488.08 49.5101C488.03 49.7101 487.85 49.8601 487.65 49.8601C487.52 49.9501 487.37 50.0101 487.22 50.0201H487.21Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M489.83 48.62C489.83 48.62 490.06 48.62 490.04 48.63C490.04 48.6 489.8 48.5 489.81 48.5C489.84 48.48 490.06 48.56 490.1 48.56C490.1 48.59 489.84 48.59 489.84 48.62H489.83Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.03 49.0802C490.03 49.0802 489.98 49.0802 489.96 49.0802H489.91C489.59 49.0702 489.41 48.9401 489.38 48.6801V48.6502C489.31 48.4502 489.38 48.2301 489.56 48.1101C489.72 48.0201 489.91 48.0202 490.07 48.0902H490.12C490.24 48.1102 490.36 48.1702 490.44 48.2702C490.52 48.3702 490.55 48.4901 490.53 48.6201C490.52 48.7101 490.48 48.7901 490.42 48.8601C490.34 49.0001 490.19 49.0802 490.03 49.0802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M484.96 32.2802C484.96 32.2802 484.74 32.2802 484.73 32.2802C484.7 32.2902 484.66 32.5802 484.62 32.5902C484.62 32.5502 484.74 32.4202 484.74 32.3802C484.77 32.3802 484.93 32.2702 484.96 32.2802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M484.62 33.0401C484.49 33.0401 484.37 32.9902 484.29 32.8902C484.2 32.8002 484.16 32.6701 484.18 32.5501C484.18 32.4801 484.21 32.4101 484.24 32.3501V32.3202C484.27 32.1402 484.37 31.9802 484.53 31.8902C484.63 31.8502 484.73 31.8301 484.84 31.8501H484.88C484.95 31.8501 485.01 31.8501 485.08 31.8601C485.29 31.9201 485.43 32.1202 485.41 32.3402C485.4 32.5202 485.28 32.6701 485.11 32.7201C485.09 32.7201 485.08 32.7401 485.06 32.7501C484.99 32.9401 484.82 33.0601 484.63 33.0601L484.62 33.0401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.35 36.8102C479.35 36.8102 479.42 36.9002 479.44 36.9602C479.44 36.9802 479.21 37.1102 479.2 37.1402C479.18 37.0402 479.38 37.0701 479.36 36.9701C479.41 36.9201 479.34 36.8002 479.35 36.8102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.2 37.5902C479.2 37.5902 479.17 37.5902 479.16 37.5902C478.96 37.5702 478.8 37.4301 478.76 37.2401C478.72 37.0701 478.78 36.9002 478.9 36.7802C478.92 36.5902 479.06 36.4302 479.24 36.3902C479.43 36.3402 479.62 36.4202 479.72 36.5802L479.74 36.6101C479.78 36.6601 479.81 36.7202 479.84 36.7702C480.02 37.1302 479.68 37.3601 479.56 37.4301L479.5 37.4701C479.42 37.5501 479.31 37.5902 479.19 37.5902H479.2Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.92 37.1701C494.67 37.1701 494.47 36.9701 494.47 36.7301V36.2401C494.47 35.9901 494.67 35.7902 494.91 35.7802C495.16 35.7802 495.35 35.9801 495.37 36.2201V36.7101C495.37 36.9601 495.17 37.1601 494.93 37.1701H494.92Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.44 32.5302C485.44 32.5302 485.57 32.5201 485.61 32.5401C485.59 32.5401 485.43 32.6501 485.42 32.6301C485.4 32.6001 485.52 32.5401 485.5 32.5101C485.5 32.5001 485.43 32.5102 485.44 32.5302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.4 33.0801C485.26 33.0801 485.13 33.0101 485.06 32.9001C484.97 32.7701 484.95 32.6101 485 32.4701C485.01 32.3601 485.07 32.2601 485.15 32.1801C485.29 32.0701 485.49 32.0301 485.66 32.0901C485.73 32.1001 485.8 32.1301 485.85 32.1601C485.99 32.2501 486.07 32.4201 486.05 32.5901C486.03 32.7601 485.92 32.9001 485.76 32.9601C485.65 33.0301 485.52 33.0701 485.4 33.0701V33.0801ZM485.61 32.5501L485.74 32.8601C485.85 32.7901 485.9 32.6401 485.85 32.5201L485.61 32.5501ZM485.57 32.6201L485.59 32.6501L485.61 32.5501L485.57 32.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.88 32.4302C481.88 32.4302 481.67 32.5102 481.69 32.5002C481.67 32.5002 481.74 32.5002 481.72 32.5002C481.74 32.4402 481.87 32.4302 481.88 32.4302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.72 32.9502C481.72 32.9502 481.69 32.9502 481.68 32.9502H481.65C481.46 32.9302 481.3 32.8002 481.25 32.6102C481.2 32.4102 481.3 32.1902 481.49 32.1002C481.52 32.0802 481.55 32.0602 481.58 32.0502C481.7 31.9902 481.83 31.9702 481.96 31.9902C482.09 32.0102 482.21 32.0902 482.27 32.2102C482.38 32.4102 482.33 32.6602 482.15 32.7902C482.1 32.8202 482.05 32.8502 482 32.8602L481.96 32.8802C481.89 32.9302 481.81 32.9502 481.72 32.9502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.62 34.6401C494.62 34.6401 494.4 34.6401 494.43 34.6401C494.4 34.6301 494.37 34.5201 494.34 34.5001C494.43 34.4501 494.61 34.6101 494.61 34.6301L494.62 34.6401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M493.98 34.7802C493.9 34.6702 493.87 34.5401 493.9 34.4101C493.93 34.2801 494.01 34.1702 494.13 34.1102C494.28 34.0402 494.45 34.0302 494.6 34.0902C494.72 34.1402 494.83 34.2202 494.93 34.3102C495.03 34.4002 495.08 34.5302 495.07 34.6702C495.06 34.8202 494.97 35.0802 494.53 35.0902H494.49C494.49 35.0902 494.45 35.0902 494.44 35.0902C494.41 35.0902 494.39 35.0902 494.36 35.0902", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.84 32.5302C481.84 32.5302 481.83 32.5801 481.84 32.6001C481.84 32.6301 481.67 32.4901 481.68 32.4701C481.69 32.4501 481.85 32.5202 481.85 32.5302H481.84Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.83 33.06C481.64 33.04 481.46 32.94 481.34 32.79C481.21 32.64 481.19 32.4301 481.28 32.2501C481.35 32.1401 481.45 32.0501 481.58 32.0201C481.71 31.9901 481.84 32.0201 481.95 32.0801C482.19 32.1501 482.33 32.3901 482.27 32.6301C482.25 32.8101 482.14 32.9601 481.97 33.0201C481.92 33.0401 481.87 33.05 481.82 33.05L481.83 33.06Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.92 38.4101C494.92 38.4101 494.76 38.4301 494.79 38.4401C494.81 38.4501 494.95 38.2602 494.97 38.2702C495.01 38.3102 494.92 38.4302 494.92 38.4002V38.4101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.77 38.8901C494.69 38.8901 494.6 38.8601 494.54 38.8201C494.35 38.6901 494.28 38.4501 494.38 38.2401C494.42 38.1701 494.47 38.1001 494.55 38.0601C494.64 37.9301 494.79 37.8501 494.94 37.8301C495.06 37.8301 495.19 37.8701 495.27 37.9501C495.41 38.1001 495.45 38.3101 495.38 38.5001C495.31 38.6901 495.14 38.83 494.94 38.85C494.89 38.87 494.83 38.8901 494.77 38.8901ZM494.52 38.3401L494.72 38.3701L494.54 38.16C494.52 38.22 494.51 38.2801 494.51 38.3401H494.52Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.27 34.9501C494.27 34.9501 494.44 34.8801 494.42 34.9001C494.4 34.9201 494.34 34.8001 494.32 34.8201C494.26 34.8601 494.28 34.9601 494.28 34.9501H494.27Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.04 34.4701C494.14 34.4001 494.26 34.3602 494.38 34.3802C494.49 34.3902 494.59 34.4502 494.67 34.5302C494.79 34.6102 494.86 34.7301 494.87 34.8701C494.88 35.0101 494.83 35.1401 494.73 35.2401C494.66 35.3001 494.58 35.3501 494.49 35.3601C494.44 35.3901 494.39 35.4001 494.33 35.4101C494.31 35.4101 494.29 35.4101 494.28 35.4101L494.04 34.4701ZM494.43 34.9301L494.47 35.2602C494.47 35.2602 494.56 35.2201 494.6 35.1901C494.67 35.1401 494.72 35.0502 494.73 34.9602C494.73 34.9302 494.73 34.9001 494.73 34.8701L494.44 34.9301H494.43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.47 34.8301C494.47 34.8301 494.59 35.1301 494.62 35.0901C494.65 35.0601 494.57 34.9201 494.56 34.8801C494.55 34.8301 494.46 34.8201 494.47 34.8201V34.8301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.04 34.7101C494.1 34.5101 494.28 34.3801 494.48 34.3801C494.71 34.4101 494.91 34.5602 495 34.7802C495.09 34.9902 495.07 35.2401 494.93 35.4301C494.84 35.5101 494.73 35.5501 494.61 35.5501C494.58 35.5501 494.55 35.5501 494.52 35.5501L494.04 34.7101ZM494.24 35.2101C494.3 35.2601 494.38 35.2901 494.46 35.2901V35.1301L494.28 35.1601L494.24 35.2101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.32 45.9801C589.26 45.9001 589.16 45.8101 589.13 45.7601C589.31 45.6401 589.57 45.6001 589.76 45.5001C589.79 45.4801 589.78 45.4601 589.84 45.4801C589.64 45.6301 589.52 45.8301 589.33 45.9801H589.32Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.32 46.4301C589.32 46.4301 589.28 46.4301 589.26 46.4301C589.14 46.4101 589.03 46.3401 588.96 46.2401C588.94 46.2101 588.91 46.1801 588.88 46.1501C588.84 46.1101 588.8 46.0601 588.77 46.0201C588.7 45.9201 588.67 45.8001 588.7 45.6801C588.72 45.5601 588.79 45.4601 588.9 45.3901C589.04 45.3101 589.18 45.2401 589.34 45.2001C589.4 45.1801 589.47 45.1601 589.53 45.1301C589.66 45.0201 589.85 45.0001 590.01 45.0601C590.16 45.1101 590.28 45.2501 590.3 45.4101C590.33 45.5701 590.26 45.7301 590.13 45.8401C590.06 45.9001 589.99 45.9701 589.93 46.0401C589.83 46.1501 589.73 46.2501 589.62 46.3401C589.54 46.4001 589.44 46.4401 589.34 46.4401L589.32 46.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M611.88 54.6601C611.63 54.6601 611.43 54.4601 611.43 54.2101V53.9501C611.43 53.7001 611.63 53.5001 611.88 53.5001C612.13 53.5001 612.33 53.7001 612.33 53.9501V54.2101C612.33 54.4601 612.13 54.6601 611.88 54.6601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M538.26 28.5402C538.35 28.4502 538.43 28.2602 538.52 28.1802C538.43 28.2702 538.35 28.4602 538.26 28.5402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M538.26 28.9901C538.08 28.9901 537.91 28.8801 537.85 28.7101C537.79 28.5401 537.82 28.3501 537.95 28.2201C537.98 28.1901 538 28.1501 538.02 28.1201C538.07 28.0301 538.14 27.9401 538.21 27.8601C538.32 27.7401 538.49 27.7001 538.65 27.7401C538.81 27.7801 538.93 27.9001 538.97 28.0601C539.01 28.2201 538.97 28.3801 538.85 28.5001C538.83 28.5301 538.8 28.5701 538.78 28.6001C538.72 28.6901 538.66 28.7801 538.58 28.8601C538.5 28.9401 538.38 28.9901 538.26 28.9901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.5 38.6401C608.37 38.7501 608.21 38.8201 608.04 38.8201C607.86 38.8401 607.68 38.7801 607.54 38.6601C607.42 38.5201 607.42 38.4001 607.68 38.2701C607.84 38.1901 607.81 37.9601 607.86 37.8301C607.91 37.7001 608.06 37.5201 607.98 37.3701L608.5 38.6401ZM609.81 43.9601C609.51 43.9601 609.46 43.9401 609.59 43.6601C609.7 43.4701 609.65 43.2201 609.47 43.0901C609.43 43.0501 609.55 42.9301 609.54 42.8701C609.52 42.6901 609.44 42.5201 609.31 42.3801C609.17 42.2601 609 42.1701 608.81 42.1401C608.72 42.1301 608.58 42.1601 608.49 42.1201C608.55 42.0501 608.54 41.8402 608.61 41.7802C608.91 41.5302 609.06 41.5601 608.7 41.3601C608.56 41.3101 608.46 41.1802 608.44 41.0302C608.38 40.8802 608.42 40.7101 608.53 40.5901C608.78 40.3301 608.71 40.4201 608.37 40.2601C608.28 40.2201 608.28 40.0101 608.21 39.9301C608.28 39.8801 608.38 39.9001 608.46 39.8701C608.55 39.8301 608.6 39.6001 608.7 39.5801C608.89 39.5501 609.17 39.6001 609.17 39.3901", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M609.75 44.0901C609.59 44.0901 609.48 44.0801 609.43 43.9901C609.37 43.8901 609.42 43.7601 609.48 43.6301C609.57 43.4801 609.53 43.2901 609.39 43.1901C609.3 43.1101 609.36 43.0001 609.4 42.9301C609.41 42.9101 609.42 42.8901 609.43 42.8801C609.41 42.7301 609.34 42.59 609.24 42.48C609.11 42.37 608.96 42.3001 608.8 42.2701C608.77 42.2701 608.74 42.2701 608.7 42.2701C608.61 42.2801 608.52 42.27 608.44 42.23C608.41 42.21 608.39 42.1901 608.39 42.1501C608.39 42.1201 608.39 42.0801 608.41 42.0601C608.42 42.0201 608.43 41.9901 608.44 41.9501C608.44 41.8601 608.48 41.7801 608.54 41.7101C608.61 41.6501 608.68 41.6001 608.73 41.5701L608.77 41.54C608.77 41.54 608.71 41.5 608.66 41.48C608.49 41.41 608.37 41.2501 608.34 41.0701C608.28 40.8801 608.32 40.6801 608.46 40.5301L608.48 40.5101L608.52 40.4601C608.52 40.4601 608.41 40.4201 608.33 40.3801C608.25 40.3301 608.19 40.2401 608.18 40.1401C608.18 40.1001 608.16 40.0601 608.14 40.0301C608.12 40.0101 608.11 39.9801 608.11 39.9401C608.11 39.9101 608.13 39.88 608.15 39.86C608.21 39.82 608.28 39.8 608.35 39.8C608.38 39.8 608.4 39.8 608.43 39.79C608.45 39.76 608.47 39.7301 608.48 39.7001C608.53 39.6201 608.58 39.5101 608.69 39.4901C608.74 39.4901 608.79 39.49 608.84 39.48C609.03 39.48 609.07 39.45 609.07 39.41H609.29C609.29 39.68 609.01 39.6901 608.85 39.7001C608.81 39.7001 608.76 39.7001 608.72 39.7001C608.71 39.7301 608.69 39.76 608.67 39.79C608.64 39.87 608.58 39.94 608.5 39.98C608.46 40 608.41 40.0101 608.36 40.0101C608.36 40.0301 608.37 40.0401 608.37 40.0601C608.37 40.1001 608.39 40.13 608.41 40.17C608.48 40.2 608.54 40.2201 608.59 40.2401C608.68 40.2701 608.75 40.3001 608.77 40.3801C608.79 40.4701 608.73 40.5201 608.61 40.6501L608.59 40.67C608.49 40.77 608.5 40.8401 608.53 41.0101C608.55 41.1301 608.58 41.1801 608.73 41.2701C608.89 41.3601 608.99 41.4201 608.99 41.5201C608.99 41.6201 608.92 41.6701 608.82 41.7401C608.77 41.7701 608.71 41.8201 608.65 41.8701C608.64 41.9101 608.63 41.9501 608.62 41.9901V42.04H608.65C608.65 42.04 608.75 42.04 608.79 42.04C609 42.08 609.19 42.1701 609.35 42.3101C609.5 42.4601 609.59 42.6601 609.61 42.8701C609.61 42.9301 609.59 42.99 609.55 43.04V43.0601C609.72 43.2301 609.76 43.5 609.64 43.72C609.62 43.76 609.6 43.81 609.59 43.85C609.65 43.85 609.7 43.85 609.76 43.85V44.0701H609.71L609.75 44.0901ZM608.05 38.9401H608.04C607.83 38.9601 607.61 38.8901 607.45 38.7501C607.37 38.6801 607.33 38.57 607.35 38.47C607.38 38.33 607.52 38.2401 607.63 38.1901C607.69 38.1601 607.7 38.08 607.72 37.97C607.72 37.92 607.74 37.8701 607.75 37.8201C607.77 37.7701 607.79 37.7301 607.81 37.6801C607.86 37.5801 607.9 37.5001 607.87 37.4501L608.07 37.3401C608.13 37.4901 608.11 37.6601 608.01 37.7801C607.99 37.8101 607.97 37.8501 607.96 37.8901C607.95 37.9301 607.94 37.9601 607.94 38.0001C607.94 38.1601 607.86 38.3101 607.73 38.3901C607.59 38.4601 607.58 38.5001 607.57 38.5101C607.57 38.5101 607.57 38.54 607.62 38.6C607.74 38.69 607.89 38.73 608.04 38.72C608.18 38.72 608.32 38.6601 608.43 38.5601L608.57 38.7401C608.43 38.8701 608.24 38.9401 608.05 38.9401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M590.42 45.0601C590.4 45.1401 590.26 45.1 590.17 45.16C590.15 45.17 590.2 45.2501 590.17 45.2601C590.01 45.3101 589.91 45.2701 589.96 45.5601C590.01 45.8501 590.13 45.9 590.29 45.86C590.57 45.8 590.83 45.7301 590.87 46.0201C590.9 46.2801 590.7 46.5801 590.76 46.8401C590.8 47.0201 590.92 47.42 591.25 47.35C591.29 47.35 591.2 47.37 591.23 47.47C591.27 47.67 591.36 47.8501 591.5 48.0001C591.6 48.1001 591.85 48.0801 592.09 48.0801C592.21 48.0801 592.34 48.0801 592.46 48.0801C592.9 48.0301 592.78 47.9501 592.78 48.3701C592.77 48.5401 592.74 48.7101 592.69 48.8701C592.66 49.0501 592.59 49.2101 592.56 49.3901C592.53 49.5501 592.68 49.5501 592.91 49.5101C592.93 49.5101 592.98 49.65 593 49.66C593.19 49.71 593.47 49.9001 593.66 49.9601C593.66 49.7701 593.58 49.4501 593.6 49.2601C593.6 49.1901 593.58 49.0401 593.64 49.0001C593.83 48.8901 594.04 48.8301 594.26 48.8101C594.48 48.8101 594.69 48.8501 594.89 48.9501C595.07 49.0401 595.08 49.3001 595.18 49.4901C595.31 49.7301 595.58 49.6801 595.79 49.6401C595.96 49.6101 596.11 49.44 596.27 49.41C596.44 49.38 596.6 49.2901 596.77 49.2601C596.94 49.2301 597.12 49.2701 597.29 49.2401C597.46 49.2101 597.66 49.34 597.83 49.3C598.01 49.26 598.17 49.1301 598.28 49.1801C598.45 49.2501 598.59 49.3901 598.65 49.5701C598.68 49.7201 598.6 50.0401 598.77 50.0801C598.93 50.1201 599.1 49.8601 599.21 49.7601C599.28 49.6901 599.21 49.5801 599.21 49.4601C599.17 49.0301 599.27 48.9201 599.71 48.8301C599.88 48.8001 600.09 48.9001 600.22 48.8201C600.36 48.7201 600.47 48.57 600.54 48.41C600.65 48.12 600.9 48.1101 601.2 48.1501C601.38 48.1801 601.57 48.2001 601.75 48.2001C601.94 48.2001 602.13 48.14 602.3 48.04C602.41 47.98 602.52 48.17 602.67 48.22C602.75 48.24 602.98 48.1901 603.04 48.2601C602.96 48.3001 602.78 48.5001 602.7 48.5101C602.52 48.5201 602.35 48.6 602.21 48.72C602.07 48.84 601.69 48.9001 601.71 49.1801C601.73 49.3801 601.8 49.4201 601.65 49.4501C601.5 49.4801 601.35 49.52 601.2 49.54C601.05 49.56 600.86 49.39 600.71 49.42C600.51 49.44 600.32 49.5201 600.16 49.6401C600.12 49.7201 600.35 49.93 600.38 50.17C600.38 50.21 600.39 50.2501 600.4 50.2801C600.48 50.5301 600.35 50.6701 600.09 50.7101C599.88 50.7401 599.52 50.6801 599.55 51.0801C599.46 51.2101 599.33 51.2901 599.18 51.3201C599.05 51.2801 598.93 51.2301 598.82 51.1501C598.68 51.0901 598.46 50.78 598.31 50.73C598.4 50.83 598.69 51.01 598.78 51.11C598.81 51.14 598.81 51.19 598.84 51.23C598.95 51.37 599.23 51.58 599.34 51.72C599.18 51.78 598.82 51.9001 598.67 51.9601C598.41 51.9101 598 52.1501 597.88 51.6801C597.81 51.7001 597.66 51.5301 597.62 51.5801C597.46 51.7401 597.45 52.0401 597.3 52.2001C597.12 52.3901 597 52.6601 596.82 52.6901C596.64 52.7301 596.49 52.4001 596.26 52.2801C596.12 52.2101 595.98 52.19 595.85 52.11C595.72 52.03 595.47 52.18 595.33 52.11C595.19 52.04 595.1 51.87 594.96 51.86C594.81 51.84 594.74 51.9601 594.59 52.0601C594.38 52.2001 593.88 52.2801 594.23 52.6501C594.36 52.7901 594.37 52.7001 594.16 52.6901C593.99 52.6601 593.82 52.6501 593.65 52.6501C593.42 52.6801 593.26 52.9301 593.12 53.0601C592.95 53.1801 592.8 53.3401 592.7 53.5201C592.62 53.6901 592.44 53.7701 592.33 53.9301C592.22 54.0801 592.3 54.3701 592.19 54.5201C592.13 54.6001 591.93 54.75 591.84 54.73C591.63 54.68 591.5 54.36 591.3 54.3C591.1 54.24 590.83 54.37 590.63 54.3C590.48 54.19 590.39 54.0101 590.41 53.8201C590.41 53.6301 590.48 53.4501 590.6 53.3101C590.62 53.3001 590.73 53.4101 590.77 53.4401C590.9 53.5701 591.05 53.6601 591.23 53.7001C591.49 53.7801 591.76 53.79 592.02 53.72C592.1 53.69 592.02 53.3 591.98 53.1C591.94 52.95 591.85 52.81 591.73 52.72C591.63 52.62 591.51 52.66 591.31 52.6C591.13 52.55 591.03 52.2501 590.88 52.2401C590.7 52.2301 590.53 52.24 590.36 52.3C590.18 52.34 590.01 52.4101 589.86 52.5101C589.77 52.5901 589.81 52.86 589.7 52.91C589.48 53.01 589.32 52.85 589.28 52.6C589.23 52.32 589.1 51.9601 589.46 51.7701C589.63 51.6801 589.97 51.89 590.13 51.79C590.26 51.68 590.41 51.6 590.57 51.54C590.69 51.51 590.78 51.1401 590.78 51.0101C590.78 50.9101 590.69 50.5901 590.56 50.5301C590.29 50.4501 590 50.46 589.73 50.55C589.57 50.61 589.41 50.6501 589.25 50.6901C589.08 50.7101 588.94 51.0501 588.77 51.0601C588.6 51.0701 588.41 50.8801 588.24 50.9001C588.06 50.9101 588.07 50.69 588.19 50.42C588.28 50.23 588.52 50.1001 588.6 49.9001C588.68 49.7001 588.62 49.4501 588.69 49.2501C588.74 49.1101 588.61 48.9701 588.61 48.8101C588.52 48.9301 588.37 48.9401 588.28 49.0701C588.26 49.1001 588.45 49.2901 588.42 49.3201C588.34 49.4301 588.14 49.44 588.05 49.55C588.06 49.43 588.02 49.3001 588.03 49.1801C588.03 49.0801 588.19 48.9001 588.14 48.8301C588.04 48.6801 587.98 48.6201 587.99 48.5101C587.99 48.4101 587.98 48.3801 588.22 48.3101C588.36 48.2701 588.43 47.86 588.65 47.72C588.72 47.63 588.71 47.5 588.65 47.42C588.58 47.33 588.46 47.3 588.36 47.35C588.13 47.46 587.94 47.3201 587.75 47.3101C587.53 47.3101 587.36 47.3701 587.17 47.2601C586.99 47.1401 586.82 47.0101 586.67 46.8701C586.5 46.7301 586.36 46.5101 586.18 46.4001C586.11 46.3601 586.11 46.41 586.16 46.35C586.24 46.25 586.29 45.9101 586.41 45.9301C586.58 45.9601 586.68 46.2801 586.84 46.3701C587.02 46.5001 587.21 46.6101 587.42 46.6901C587.63 46.7301 587.85 46.5201 588.05 46.4601C588.23 46.4101 588.33 46.2401 588.51 46.0901C588.6 46.0101 588.69 46.0001 588.74 45.9001C588.77 45.8301 588.92 45.6601 588.91 45.5701C588.85 45.6101 588.77 45.8401 588.71 45.8801C588.68 45.9001 588.65 45.9901 588.62 46.0101C588.48 46.0701 588.35 45.8901 588.2 45.9501L590.42 45.0601ZM592.72 52.5001C592.9 52.3401 593.09 52.2001 593.29 52.0701C593.61 51.8601 593.46 51.6101 593.17 51.4601C593.03 51.3701 592.86 51.3601 592.72 51.4301C592.63 51.4501 592.43 51.43 592.36 51.72C592.33 51.84 592.57 52.0201 592.54 52.1401C592.48 52.3501 592.44 52.5001 592.72 52.5101V52.5001ZM592.14 51.2501C592.22 51.1101 592.41 50.8001 592.5 50.6301C592.27 50.5001 592.02 50.41 591.76 50.35C591.54 50.32 591.7 50.56 591.73 50.72C591.78 50.96 591.8 51.2301 592.14 51.2501ZM592.96 50.66C592.91 50.63 592.83 50.49 592.79 50.47C592.79 50.47 592.67 50.6301 592.66 50.6401C592.69 50.6801 592.85 50.6001 592.89 50.6401C592.89 50.6401 592.93 50.7 592.97 50.66H592.96Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.83 54.8602C591.83 54.8602 591.8 54.8602 591.78 54.8602C591.65 54.8102 591.53 54.7302 591.45 54.6102C591.39 54.5302 591.32 54.4702 591.24 54.4302C591.15 54.4102 591.06 54.4202 590.97 54.4302C590.84 54.4602 590.7 54.4602 590.57 54.4102C590.37 54.2802 590.26 54.0602 590.28 53.8202C590.28 53.6002 590.37 53.4002 590.51 53.2302C590.6 53.1502 590.69 53.2302 590.81 53.3402L590.83 53.3602C590.94 53.4702 591.08 53.5502 591.23 53.6002L591.35 53.6202C591.54 53.6702 591.73 53.6802 591.92 53.6402C591.92 53.4702 591.89 53.3002 591.85 53.1302C591.82 53.0202 591.76 52.9102 591.67 52.8402L591.63 52.8002C591.63 52.8002 591.57 52.7602 591.48 52.7502C591.4 52.7502 591.33 52.7302 591.26 52.7102C591.15 52.6602 591.05 52.5802 590.99 52.4802C590.96 52.4402 590.89 52.3602 590.86 52.3602C590.7 52.3502 590.54 52.3602 590.38 52.4102C590.34 52.4302 590.29 52.4402 590.24 52.4502C590.12 52.4802 590.01 52.5302 589.91 52.6002C589.89 52.6402 589.88 52.6802 589.88 52.7302C589.86 52.8402 589.84 52.9702 589.73 53.0202C589.63 53.0702 589.5 53.0802 589.4 53.0202C589.26 52.9302 589.17 52.7902 589.16 52.6302C589.16 52.5902 589.15 52.5602 589.14 52.5202C589.09 52.2502 589.01 51.8902 589.4 51.6902C589.53 51.6402 589.67 51.6402 589.81 51.6902C589.91 51.7102 590.03 51.7402 590.07 51.7102C590.11 51.6902 590.14 51.6602 590.17 51.6402C590.28 51.5502 590.4 51.4902 590.53 51.4502C590.61 51.3202 590.65 51.1802 590.66 51.0302C590.65 50.8902 590.59 50.7502 590.5 50.6502C590.25 50.5802 589.99 50.5902 589.75 50.6802C589.69 50.7002 589.64 50.7102 589.59 50.7302C589.48 50.7702 589.37 50.8002 589.26 50.8202C589.22 50.8202 589.15 50.9002 589.09 50.9702C589.02 51.0802 588.9 51.1602 588.77 51.1902C588.65 51.1902 588.54 51.1602 588.44 51.1002C588.38 51.0602 588.3 51.0402 588.23 51.0302C588.15 51.0302 588.07 51.0002 588.02 50.9402C587.92 50.8002 587.99 50.5702 588.07 50.3902C588.13 50.2802 588.2 50.1802 588.3 50.1002C588.37 50.0402 588.44 49.9602 588.48 49.8702C588.51 49.7702 588.53 49.6702 588.52 49.5702C588.52 49.4502 588.53 49.3302 588.57 49.2202C588.57 49.1602 588.57 49.1002 588.54 49.0502V49.0202L588.49 49.0402C588.49 49.0402 588.43 49.0702 588.4 49.0902L588.43 49.1302C588.5 49.2302 588.56 49.3102 588.5 49.3902C588.44 49.4602 588.36 49.5102 588.27 49.5402C588.22 49.5602 588.17 49.5802 588.13 49.6202C588.1 49.6602 588.05 49.6702 588 49.6502C587.95 49.6302 587.93 49.5902 587.93 49.5402C587.93 49.4802 587.93 49.4202 587.92 49.3602C587.92 49.3002 587.91 49.2402 587.91 49.1702C587.91 49.1002 587.94 49.0302 587.98 48.9602C588 48.9302 588.01 48.9002 588.03 48.8602L588.01 48.8302C587.92 48.7402 587.88 48.6202 587.88 48.4902C587.89 48.3102 587.97 48.2602 588.19 48.2002C588.23 48.1502 588.26 48.0902 588.29 48.0202C588.35 47.8702 588.44 47.7402 588.56 47.6402C588.56 47.5902 588.56 47.5302 588.56 47.4802C588.51 47.4602 588.45 47.4402 588.39 47.4402C588.24 47.5002 588.06 47.5002 587.91 47.4402C587.85 47.4202 587.8 47.4102 587.74 47.4002C587.68 47.4002 587.62 47.4002 587.56 47.4002C587.41 47.4302 587.25 47.4002 587.11 47.3302C586.98 47.2502 586.86 47.1602 586.75 47.0602C586.7 47.0202 586.65 46.9702 586.59 46.9302C586.51 46.8602 586.43 46.7902 586.37 46.7102C586.3 46.6202 586.21 46.5402 586.12 46.4702C586.07 46.4702 586.03 46.4402 586.01 46.3902C585.99 46.3402 586.01 46.2902 586.06 46.2602C586.09 46.2102 586.11 46.1602 586.13 46.1002C586.19 45.9502 586.26 45.7502 586.43 45.7802C586.57 45.8002 586.66 45.9302 586.74 46.0502C586.78 46.1202 586.83 46.1802 586.89 46.2302C586.96 46.2702 587.03 46.3202 587.1 46.3602C587.2 46.4402 587.32 46.5002 587.44 46.5402C587.56 46.5402 587.67 46.5002 587.77 46.4302C587.85 46.3802 587.93 46.3402 588.02 46.3102C588.12 46.2702 588.21 46.2102 588.27 46.1202C588.3 46.0902 588.33 46.0602 588.36 46.0302C588.3 46.0002 588.27 45.9902 588.24 46.0002L588.16 45.7902C588.26 45.7602 588.37 45.7702 588.46 45.8302C588.49 45.8502 588.52 45.8602 588.56 45.8602V45.8402C588.56 45.8402 588.61 45.7602 588.65 45.7402C588.67 45.7002 588.69 45.6702 588.71 45.6302C588.74 45.5502 588.79 45.4802 588.86 45.4302C588.89 45.4102 588.93 45.4102 588.97 45.4302C589 45.4502 589.03 45.4802 589.03 45.5202C589.03 45.6402 588.98 45.7502 588.9 45.8402C588.88 45.8602 588.87 45.8902 588.85 45.9102C588.81 45.9902 588.75 46.0502 588.67 46.0902C588.64 46.1102 588.62 46.1202 588.59 46.1402C588.54 46.1902 588.49 46.2302 588.44 46.2802C588.35 46.3902 588.23 46.4802 588.09 46.5302C588.02 46.5602 587.95 46.5902 587.88 46.6302C587.74 46.7302 587.57 46.7802 587.4 46.7702C587.25 46.7302 587.1 46.6502 586.98 46.5602C586.92 46.5202 586.85 46.4702 586.79 46.4402C586.7 46.3802 586.62 46.2902 586.56 46.1902C586.52 46.1302 586.48 46.0702 586.42 46.0202C586.39 46.0702 586.37 46.1302 586.35 46.1902C586.33 46.2402 586.32 46.2802 586.3 46.3202C586.39 46.3902 586.48 46.4702 586.55 46.5602C586.61 46.6302 586.68 46.7002 586.75 46.7602C586.81 46.8002 586.86 46.8502 586.91 46.9002C587.01 46.9902 587.12 47.0702 587.23 47.1402C587.33 47.1902 587.44 47.2002 587.55 47.1802C587.61 47.1802 587.68 47.1802 587.75 47.1802C587.83 47.1802 587.9 47.2002 587.98 47.2202C588.09 47.2702 588.2 47.2702 588.31 47.2202C588.46 47.1802 588.62 47.2202 588.74 47.3202C588.82 47.4002 588.8 47.5802 588.8 47.6302C588.8 47.6902 588.77 47.7502 588.72 47.7902C588.62 47.8802 588.55 47.9802 588.5 48.1002C588.43 48.2402 588.37 48.3602 588.26 48.3902C588.21 48.4002 588.16 48.4202 588.11 48.4502V48.4902C588.11 48.5402 588.12 48.5702 588.2 48.6802L588.24 48.7302C588.24 48.7302 588.28 48.8402 588.26 48.8902C588.3 48.8602 588.34 48.8302 588.39 48.8002C588.44 48.7802 588.48 48.7502 588.52 48.7002C588.55 48.6602 588.6 48.6402 588.64 48.6602C588.69 48.6702 588.72 48.7202 588.72 48.7702C588.72 48.8202 588.74 48.8802 588.76 48.9302C588.81 49.0302 588.82 49.1402 588.79 49.2502C588.76 49.3402 588.75 49.4402 588.76 49.5302C588.76 49.6602 588.74 49.7902 588.7 49.9102C588.64 50.0202 588.56 50.1302 588.47 50.2102C588.4 50.2702 588.34 50.3502 588.29 50.4302C588.19 50.6502 588.21 50.7402 588.22 50.7602C588.34 50.7602 588.45 50.7902 588.55 50.8502C588.61 50.8902 588.69 50.9102 588.76 50.9202C588.8 50.9202 588.88 50.8302 588.93 50.7702C589 50.6602 589.11 50.5802 589.23 50.5502C589.33 50.5302 589.43 50.5102 589.52 50.4702C589.58 50.4502 589.63 50.4302 589.69 50.4202C589.98 50.3102 590.3 50.3102 590.6 50.4002C590.79 50.4902 590.88 50.8802 590.88 50.9802C590.88 51.0702 590.8 51.5502 590.59 51.6202C590.48 51.6502 590.38 51.7102 590.3 51.7802C590.26 51.8102 590.23 51.8302 590.19 51.8602C590.05 51.9202 589.9 51.9202 589.76 51.8702C589.68 51.8402 589.59 51.8302 589.51 51.8502C589.29 51.9702 589.31 52.1502 589.36 52.4402C589.36 52.4802 589.38 52.5202 589.38 52.5602C589.38 52.6502 589.43 52.7402 589.51 52.7902C589.55 52.8102 589.6 52.8102 589.64 52.7902C589.65 52.7502 589.66 52.7102 589.67 52.6602C589.67 52.5602 589.71 52.4702 589.78 52.4002C589.9 52.3102 590.04 52.2502 590.19 52.2102C590.23 52.2002 590.28 52.1802 590.31 52.1702C590.49 52.1102 590.69 52.0902 590.88 52.1002C591.01 52.1002 591.09 52.2102 591.17 52.3102C591.22 52.3702 591.28 52.4502 591.33 52.4602C591.39 52.4802 591.45 52.4902 591.51 52.4902C591.62 52.4902 591.72 52.5302 591.8 52.6002L591.83 52.6402C591.95 52.7402 592.04 52.8902 592.07 53.0402C592.19 53.6102 592.16 53.7402 592.05 53.7902C591.81 53.8602 591.55 53.8702 591.31 53.7902L591.19 53.7702C591 53.7202 590.82 53.6202 590.68 53.4802L590.65 53.4602C590.65 53.4602 590.62 53.4302 590.6 53.4202C590.54 53.5302 590.5 53.6602 590.5 53.7802C590.49 53.9202 590.54 54.0602 590.65 54.1502C590.74 54.1702 590.84 54.1702 590.94 54.1502C591.06 54.1202 591.19 54.1202 591.31 54.1502C591.43 54.2002 591.54 54.2902 591.62 54.3902C591.68 54.4702 591.75 54.5302 591.84 54.5702C591.93 54.5302 592.01 54.4802 592.07 54.4002C592.11 54.3302 592.12 54.2402 592.12 54.1602C592.12 54.0402 592.15 53.9202 592.21 53.8102C592.26 53.7402 592.33 53.6702 592.4 53.6202C592.47 53.5702 592.53 53.5002 592.57 53.4302C592.66 53.2602 592.78 53.1202 592.93 53.0102C592.96 52.9802 592.99 52.9602 593.02 52.9302C593.05 52.9002 593.09 52.8602 593.12 52.8202C593.24 52.6502 593.41 52.5402 593.61 52.4902C593.73 52.4902 593.85 52.4902 593.96 52.5102H594C593.97 52.4602 593.96 52.3902 593.97 52.3302C594 52.1602 594.19 52.0702 594.35 52.0002C594.4 51.9802 594.45 51.9502 594.5 51.9202C594.54 51.9002 594.57 51.8702 594.6 51.8402C594.69 51.7502 594.81 51.7002 594.94 51.7002C595.05 51.7202 595.15 51.7802 595.22 51.8602C595.26 51.9002 595.3 51.9302 595.35 51.9602C595.41 51.9602 595.47 51.9602 595.53 51.9502C595.64 51.9102 595.76 51.9202 595.87 51.9602C595.94 52.0002 596.01 52.0302 596.08 52.0502C596.14 52.0702 596.21 52.1002 596.27 52.1202C596.39 52.1802 596.49 52.2702 596.57 52.3702C596.64 52.4402 596.72 52.5302 596.76 52.5202C596.83 52.5102 596.91 52.4002 596.99 52.2902C597.05 52.2102 597.11 52.1302 597.18 52.0602C597.24 51.9802 597.29 51.8902 597.32 51.7902C597.36 51.6602 597.42 51.5402 597.51 51.4402C597.6 51.3502 597.71 51.4302 597.78 51.4702C597.8 51.4802 597.82 51.5002 597.84 51.5102C597.86 51.5102 597.88 51.5102 597.9 51.5202C597.93 51.5302 597.95 51.5602 597.96 51.5902C598.02 51.8202 598.14 51.8202 598.38 51.7902C598.46 51.7802 598.55 51.7702 598.63 51.7902L599.11 51.6202C599.11 51.6202 599.02 51.5402 598.98 51.5002C598.89 51.4202 598.8 51.3402 598.72 51.2502C598.7 51.2202 598.68 51.1902 598.67 51.1602C598.6 51.1102 598.54 51.0502 598.48 50.9902L598.44 50.9602C598.35 50.9002 598.26 50.8302 598.19 50.7502C598.16 50.7102 598.15 50.6602 598.18 50.6102C598.21 50.5602 598.26 50.5502 598.31 50.5602C598.43 50.6202 598.54 50.7002 598.63 50.8102C598.7 50.8602 598.77 50.9102 598.83 50.9702H598.84C598.84 50.9702 598.92 51.0202 598.96 51.0502C599.02 51.0902 599.08 51.1202 599.15 51.1402C599.25 51.1102 599.33 51.0602 599.4 50.9802C599.4 50.8802 599.42 50.7702 599.49 50.6902C599.61 50.5902 599.76 50.5302 599.92 50.5402C599.96 50.5402 600 50.5402 600.04 50.5302C600.12 50.5302 600.2 50.4902 600.26 50.4302C600.29 50.3702 600.29 50.3002 600.26 50.2402C600.26 50.2002 600.24 50.1702 600.24 50.1302C600.22 50.0102 600.17 49.9002 600.1 49.8102C600.03 49.7002 599.98 49.6002 600.02 49.5102C600.11 49.3402 600.56 49.2502 600.64 49.2302C600.75 49.2302 600.86 49.2402 600.95 49.3002C601 49.3302 601.07 49.3502 601.13 49.3502C601.2 49.3402 601.27 49.3202 601.34 49.3102C601.42 49.2902 601.49 49.2802 601.57 49.2602C601.56 49.2102 601.55 49.1602 601.55 49.1102C601.53 48.8402 601.77 48.7202 601.93 48.6402C601.98 48.6202 602.03 48.5902 602.08 48.5502C602.23 48.4102 602.42 48.3302 602.63 48.3102C602.66 48.2902 602.69 48.2702 602.71 48.2502C602.67 48.2502 602.62 48.2502 602.58 48.2402C602.51 48.2102 602.44 48.1702 602.38 48.1202C602.35 48.1002 602.32 48.0702 602.29 48.0602C602.11 48.1602 601.91 48.2202 601.7 48.2302C601.54 48.2302 601.38 48.2202 601.22 48.1902H601.13C600.8 48.1302 600.66 48.1802 600.6 48.3602C600.53 48.5502 600.4 48.7102 600.24 48.8302C600.13 48.8902 600.01 48.9002 599.89 48.8702C599.83 48.8602 599.76 48.8502 599.7 48.8702C599.31 48.9502 599.26 49.0102 599.29 49.3802C599.29 49.4102 599.3 49.4502 599.31 49.4802C599.35 49.5802 599.34 49.6902 599.26 49.7802C599.24 49.8002 599.21 49.8302 599.18 49.8602C599.07 49.9902 598.9 50.1702 598.72 50.1202C598.52 50.0702 598.53 49.8402 598.53 49.6702C598.53 49.6202 598.53 49.5702 598.53 49.5202C598.47 49.3802 598.36 49.2602 598.22 49.2102C598.2 49.2002 598.11 49.2402 598.06 49.2602C597.99 49.2902 597.92 49.3202 597.84 49.3402C597.73 49.3502 597.62 49.3402 597.52 49.3102C597.45 49.2902 597.38 49.2802 597.3 49.2802C597.21 49.2902 597.11 49.3002 597.01 49.2902C596.93 49.2902 596.85 49.2902 596.78 49.2902C596.7 49.3102 596.63 49.3302 596.55 49.3602C596.46 49.4002 596.37 49.4202 596.28 49.4402C596.21 49.4602 596.14 49.4902 596.07 49.5402C595.99 49.6002 595.89 49.6402 595.79 49.6702C595.56 49.7102 595.23 49.7802 595.06 49.4702C595.02 49.4002 594.99 49.3202 594.97 49.2402C594.93 49.1202 594.9 49.0102 594.82 48.9702C594.64 48.8802 594.45 48.8402 594.25 48.8402C594.05 48.8502 593.86 48.9102 593.68 49.0102C593.69 49.0102 593.69 49.0802 593.69 49.1102C593.69 49.1402 593.69 49.1602 593.69 49.1802C593.69 49.3102 593.7 49.4302 593.72 49.5502C593.74 49.6602 593.75 49.7602 593.75 49.8702C593.75 49.9102 593.73 49.9402 593.71 49.9602C593.68 49.9802 593.64 49.9902 593.61 49.9802C593.49 49.9402 593.38 49.8802 593.27 49.8202C593.17 49.7602 593.07 49.7102 592.96 49.6802C592.9 49.6602 592.88 49.6202 592.85 49.5502C592.69 49.5702 592.57 49.5602 592.49 49.4902C592.44 49.4302 592.42 49.3502 592.44 49.2802C592.46 49.2002 592.48 49.1102 592.5 49.0302C592.53 48.9402 592.55 48.8502 592.57 48.7602C592.58 48.7002 592.6 48.6402 592.61 48.5802C592.64 48.4802 592.66 48.3802 592.66 48.2802C592.66 48.1902 592.66 48.1202 592.66 48.0702C592.66 48.0702 592.55 48.0902 592.46 48.1002C592.36 48.1002 592.27 48.1102 592.17 48.1002H591.97C591.78 48.1302 591.58 48.1002 591.41 47.9802C591.26 47.8102 591.16 47.6102 591.11 47.3902C591.11 47.3902 591.11 47.3702 591.11 47.3602C591.05 47.3602 591 47.3302 590.95 47.3002C590.79 47.1602 590.68 46.9702 590.65 46.7602C590.63 46.6002 590.65 46.4402 590.71 46.2802C590.75 46.1702 590.77 46.0502 590.77 45.9302C590.77 45.8902 590.76 45.8602 590.73 45.8402C590.67 45.8002 590.51 45.8402 590.36 45.8702H590.32C590.23 45.9002 590.12 45.8902 590.04 45.8402C589.93 45.7502 589.87 45.6202 589.85 45.4902C589.8 45.2102 589.89 45.1302 590.05 45.0902C590.05 45.0502 590.07 45.0102 590.1 44.9802C590.16 44.9502 590.22 44.9302 590.28 44.9202C590.3 44.9202 590.31 44.9202 590.33 44.9202C590.32 44.9202 590.31 44.9402 590.31 44.9502L590.53 45.0102C590.5 45.1002 590.41 45.1602 590.32 45.1502H590.29C590.29 45.2102 590.27 45.2602 590.21 45.2802C590.18 45.2902 590.15 45.3002 590.12 45.3102C590.1 45.3102 590.08 45.3102 590.06 45.3302C590.06 45.3702 590.06 45.4202 590.07 45.4602C590.1 45.6102 590.14 45.6502 590.16 45.6702C590.17 45.6702 590.2 45.6902 590.27 45.6702H590.31C590.49 45.5902 590.68 45.6002 590.85 45.6702C590.93 45.7302 590.98 45.8202 590.98 45.9202C590.98 46.0702 590.97 46.2202 590.92 46.3602C590.88 46.4802 590.86 46.6102 590.87 46.7302C590.89 46.8802 590.96 47.0202 591.08 47.1302C591.12 47.1602 591.18 47.1702 591.23 47.1502C591.28 47.1402 591.33 47.1502 591.36 47.2002C591.38 47.2502 591.38 47.3002 591.34 47.3402C591.37 47.5202 591.45 47.6902 591.57 47.8402C591.62 47.8902 591.81 47.8902 591.97 47.8902H592.18C592.27 47.8902 592.35 47.8902 592.44 47.8902C592.52 47.8902 592.58 47.8702 592.63 47.8602C592.73 47.8402 592.8 47.8302 592.85 47.8802C592.9 47.9302 592.9 48.0002 592.89 48.0802C592.89 48.1302 592.89 48.1902 592.89 48.2802C592.89 48.4002 592.87 48.5202 592.84 48.6402C592.83 48.6902 592.81 48.7502 592.8 48.8002C592.78 48.9002 592.76 49.0002 592.73 49.0902C592.71 49.1702 592.69 49.2402 592.67 49.3202C592.67 49.3202 592.71 49.3402 592.89 49.3102C592.98 49.2902 593.03 49.3802 593.06 49.4502V49.4702C593.18 49.5102 593.28 49.5602 593.39 49.6202C593.44 49.6502 593.49 49.6702 593.53 49.6902C593.53 49.6502 593.53 49.6102 593.51 49.5702C593.49 49.4302 593.47 49.2902 593.48 49.1502C593.48 49.1402 593.48 49.1202 593.48 49.1002C593.48 49.0002 593.48 48.8602 593.57 48.8002C593.78 48.6802 594.01 48.6102 594.24 48.6002C594.48 48.6002 594.71 48.6402 594.93 48.7502C595.07 48.8402 595.16 48.9802 595.19 49.1502C595.21 49.2202 595.24 49.2802 595.27 49.3402C595.36 49.4902 595.51 49.4802 595.75 49.4302C595.83 49.4102 595.9 49.3802 595.97 49.3302C596.06 49.2702 596.15 49.2302 596.25 49.2002C596.33 49.1802 596.4 49.1602 596.48 49.1302C596.57 49.0902 596.66 49.0702 596.75 49.0502C596.84 49.0402 596.94 49.0302 597.03 49.0402C597.11 49.0402 597.19 49.0402 597.27 49.0402C597.38 49.0302 597.48 49.0402 597.59 49.0702C597.66 49.1002 597.74 49.1102 597.81 49.1002C597.87 49.0802 597.93 49.0602 597.99 49.0402C598.09 48.9702 598.22 48.9602 598.34 48.9902C598.54 49.0802 598.7 49.2502 598.77 49.4602C598.78 49.5302 598.78 49.6002 598.78 49.6602C598.78 49.7202 598.78 49.8602 598.8 49.8802C598.86 49.8802 598.98 49.7602 599.04 49.6902C599.07 49.6502 599.1 49.6202 599.13 49.5902C599.13 49.5902 599.12 49.5402 599.11 49.5102C599.1 49.4702 599.09 49.4202 599.08 49.3702C599.04 48.8902 599.17 48.7302 599.67 48.6302C599.76 48.6202 599.85 48.6202 599.94 48.6302C600 48.6502 600.07 48.6502 600.14 48.6302C600.26 48.5402 600.36 48.4202 600.41 48.2702C600.56 47.8602 600.99 47.9102 601.19 47.9402H601.29C601.43 47.9802 601.58 47.9902 601.73 47.9902C601.9 47.9902 602.07 47.9302 602.23 47.8502C602.36 47.7702 602.48 47.8702 602.56 47.9302C602.6 47.9702 602.64 47.9902 602.69 48.0102C602.72 48.0102 602.76 48.0102 602.79 48.0102C602.9 47.9902 603.02 48.0102 603.11 48.0802C603.13 48.1102 603.14 48.1402 603.14 48.1802C603.14 48.2102 603.11 48.2402 603.08 48.2602C603.04 48.2902 603 48.3202 602.97 48.3502C602.9 48.4302 602.81 48.4902 602.7 48.5202C602.54 48.5202 602.39 48.5902 602.27 48.7002C602.21 48.7502 602.14 48.7902 602.07 48.8202C601.9 48.9002 601.8 48.9602 601.81 49.0702C601.81 49.1102 601.82 49.1502 601.83 49.1902C601.86 49.2502 601.85 49.3202 601.82 49.3702C601.78 49.4202 601.72 49.4602 601.66 49.4602C601.58 49.4702 601.51 49.4902 601.44 49.5102C601.37 49.5302 601.29 49.5402 601.22 49.5602C601.11 49.5602 601.01 49.5502 600.91 49.4902C600.85 49.4602 600.79 49.4402 600.73 49.4402C600.57 49.4702 600.42 49.5202 600.28 49.5902C600.29 49.6202 600.31 49.6502 600.33 49.6802C600.41 49.8002 600.46 49.9302 600.49 50.0602C600.49 50.0902 600.49 50.1302 600.51 50.1602C600.56 50.2802 600.55 50.4202 600.48 50.5302C600.39 50.6502 600.26 50.7202 600.11 50.7302C600.07 50.7302 600.02 50.7302 599.98 50.7402C599.87 50.7402 599.75 50.7602 599.71 50.8102C599.68 50.8602 599.67 50.9202 599.68 50.9702C599.68 51.0202 599.65 51.0702 599.61 51.1102C599.51 51.2202 599.37 51.3002 599.22 51.3302C599.3 51.4002 599.37 51.4702 599.44 51.5502C599.46 51.5802 599.47 51.6202 599.46 51.6502C599.46 51.6902 599.42 51.7102 599.39 51.7302L598.72 51.9702C598.72 51.9702 598.68 51.9702 598.66 51.9702C598.59 51.9702 598.52 51.9702 598.44 51.9702C598.23 51.9902 597.93 52.0302 597.8 51.6702C597.76 51.6502 597.72 51.6302 597.69 51.6102H597.67C597.63 51.6702 597.6 51.7402 597.57 51.8202C597.53 51.9502 597.47 52.0702 597.38 52.1702C597.32 52.2302 597.27 52.3002 597.21 52.3702C597.1 52.5202 597 52.6602 596.84 52.6902C596.67 52.7202 596.56 52.6002 596.44 52.4702C596.37 52.3902 596.29 52.3202 596.2 52.2702C596.15 52.2502 596.09 52.2202 596.03 52.2102C595.94 52.1802 595.86 52.1502 595.77 52.1002C595.71 52.1002 595.64 52.1002 595.58 52.1102C595.47 52.1402 595.36 52.1402 595.25 52.1102C595.18 52.0702 595.12 52.0302 595.07 51.9702C595.03 51.9202 594.98 51.8902 594.92 51.8702C594.87 51.8702 594.83 51.8902 594.75 51.9602C594.71 51.9902 594.67 52.0202 594.63 52.0502C594.57 52.0902 594.51 52.1202 594.45 52.1402C594.35 52.1902 594.21 52.2502 594.2 52.3102C594.2 52.3402 594.23 52.4002 594.29 52.4602C594.3 52.4802 594.32 52.4902 594.34 52.5002C594.38 52.5202 594.4 52.5502 594.41 52.5802C594.42 52.6302 594.4 52.6802 594.35 52.7002C594.31 52.7202 594.26 52.7202 594.22 52.7002C594.19 52.7002 594.16 52.6902 594.12 52.6802C594.06 52.6802 593.99 52.6702 593.92 52.6602C593.82 52.6402 593.72 52.6302 593.63 52.6402C593.5 52.6502 593.38 52.7802 593.28 52.9002C593.24 52.9502 593.2 52.9902 593.16 53.0202C593.13 53.0502 593.1 53.0702 593.07 53.1002C592.94 53.1902 592.84 53.3102 592.77 53.4402C592.72 53.5502 592.64 53.6402 592.54 53.7102C592.48 53.7502 592.43 53.8102 592.39 53.8602C592.36 53.9302 592.34 54.0202 592.34 54.1002C592.34 54.2302 592.31 54.3502 592.24 54.4602C592.14 54.5902 591.99 54.6802 591.82 54.7202L591.83 54.8602ZM588.16 49.1402C588.16 49.1402 588.14 49.1802 588.13 49.2102C588.13 49.2602 588.13 49.3102 588.14 49.3602H588.18C588.18 49.3602 588.24 49.3302 588.27 49.3202L588.25 49.2902C588.25 49.2902 588.18 49.2002 588.16 49.1402ZM592.71 52.6102C592.6 52.6102 592.5 52.5802 592.43 52.5002C592.35 52.3902 592.39 52.2602 592.43 52.1102C592.41 52.0602 592.39 52.0202 592.36 51.9802C592.28 51.9002 592.24 51.7902 592.25 51.6802C592.28 51.4702 592.45 51.3202 592.66 51.3102C592.67 51.3102 592.69 51.3102 592.7 51.3102C592.71 51.3102 592.72 51.3102 592.73 51.3002C592.89 51.2302 593.08 51.2502 593.23 51.3502C593.42 51.4202 593.55 51.5902 593.58 51.7902C593.58 51.9502 593.49 52.0902 593.35 52.1602C593.16 52.2902 592.97 52.4302 592.79 52.5802C592.77 52.6002 592.74 52.6102 592.71 52.6102ZM592.6 52.3702C592.6 52.3702 592.64 52.3902 592.67 52.3902C592.84 52.2402 593.03 52.1102 593.22 51.9802C593.28 51.9402 593.35 51.8802 593.35 51.8102C593.35 51.7302 593.26 51.6402 593.11 51.5602C593.02 51.4902 592.9 51.4802 592.8 51.5202C592.78 51.5202 592.76 51.5302 592.74 51.5402C592.72 51.5402 592.7 51.5402 592.68 51.5402C592.59 51.5502 592.51 51.5602 592.46 51.7302C592.48 51.7702 592.51 51.8102 592.53 51.8502C592.61 51.9302 592.65 52.0402 592.64 52.1502C592.62 52.2202 592.6 52.2902 592.6 52.3602V52.3702ZM592.13 51.3602C591.73 51.3402 591.67 51.0302 591.63 50.7902V50.7402C591.63 50.7402 591.6 50.6602 591.58 50.6302C591.54 50.5202 591.5 50.4002 591.57 50.3102C591.62 50.2502 591.7 50.2302 591.77 50.2502C592.04 50.3102 592.3 50.4102 592.54 50.5402C592.55 50.5402 592.56 50.5502 592.57 50.5602C592.57 50.5602 592.57 50.5402 592.6 50.5102C592.68 50.4002 592.72 50.3402 592.81 50.3802C592.86 50.4102 592.91 50.4502 592.94 50.5102C592.96 50.5302 592.98 50.5602 593 50.5802C593.03 50.6002 593.05 50.6302 593.05 50.6702C593.05 50.7102 593.04 50.7402 593.01 50.7702C592.98 50.8002 592.93 50.8102 592.89 50.8102C592.86 50.8102 592.83 50.7902 592.8 50.7702H592.76C592.69 50.8002 592.61 50.7902 592.55 50.7502C592.5 50.8402 592.44 50.9402 592.37 51.0502C592.31 51.1602 592.24 51.2602 592.21 51.3302C592.19 51.3702 592.15 51.3902 592.11 51.3902L592.13 51.3602ZM591.76 50.4602C591.76 50.4602 591.78 50.5202 591.79 50.5502C591.81 50.6002 591.82 50.6502 591.83 50.7002V50.7502C591.88 50.9702 591.91 51.0902 592.07 51.1302C592.11 51.0702 592.15 50.9902 592.2 50.9102C592.25 50.8302 592.3 50.7502 592.34 50.6802C592.16 50.5802 591.96 50.5102 591.76 50.4702V50.4602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M606.71 51.3501C606.93 51.2401 607.19 51.1202 607.4 51.0202C607.62 50.9102 607.79 50.7202 608 50.6202C608.06 50.5902 607.98 50.6601 608.05 50.6601C608.02 50.7101 608.24 50.8002 608.2 50.8302C608.05 50.9502 607.93 51.1202 607.78 51.2402C607.63 51.3602 607.28 51.2401 607.13 51.3601C606.98 51.4801 606.86 51.6402 606.7 51.7602C606.55 51.8802 606.34 51.9201 606.18 52.0401C606.03 52.1601 605.89 52.3001 605.73 52.4101C605.61 52.5101 605.52 52.5502 605.48 52.4002C605.46 52.3002 605.53 52.1702 605.48 52.0802C605.34 51.8302 605.15 51.8502 604.96 52.0802C604.88 52.2002 604.82 52.3202 604.76 52.4502C604.68 52.6302 604.57 52.8002 604.43 52.9402C604.3 53.0402 604.04 53.0102 603.83 53.0102C603.73 53.0002 603.62 53.0302 603.54 53.0902C603.46 53.1502 603.41 53.2601 603.41 53.3601C603.38 53.5801 603.45 53.8601 603.33 53.9801C603.21 54.0901 602.94 54.0002 602.71 54.0202C602.33 54.0602 602.25 54.2502 602.49 54.5502C602.53 54.6002 602.62 54.6002 602.66 54.6502C602.78 54.7902 602.9 54.7501 602.62 54.9101C602.47 55.0001 602.51 55.4802 602.22 55.1902C602.09 55.0602 601.86 55.1201 601.69 55.0401C601.42 54.9101 601.29 54.6002 601.39 54.3102C601.42 54.2202 601.35 54.2102 601.31 54.1302C601.26 54.0502 601.29 54.0102 601.2 53.9502C601.15 54.0202 601.1 54.0201 601.1 54.1001C601.08 54.2601 601.07 54.4302 601.07 54.5902C600.91 54.4902 600.63 54.5602 600.49 54.4402C600.35 54.3102 600.34 54.1701 600.21 54.1701C600.06 54.1501 599.91 54.2001 599.79 54.2901C599.57 54.4701 599.33 54.6102 599.06 54.7102C598.84 54.8002 598.48 54.9902 598.26 54.7502C598.16 54.6302 598.01 54.5602 597.85 54.5602C597.79 54.5602 597.69 54.6201 597.69 54.6701C597.69 54.8501 597.62 55.0301 597.49 55.1701C597.39 55.3201 597.17 55.3501 597.04 55.4801C596.91 55.6101 596.97 55.8902 596.9 56.0602C596.85 56.1702 596.42 56.1602 596.21 56.1302C596.12 56.1202 595.97 55.8901 595.93 55.7301C595.89 55.5801 596.03 55.4002 596 55.2502C595.97 55.1002 595.81 54.9702 595.79 54.8202C595.76 54.5602 595.68 54.4702 595.42 54.5302C595.18 54.5802 594.97 54.7602 594.73 54.8102C594.49 54.8602 594.25 54.8902 594.01 54.9302C593.87 54.9502 593.82 54.8302 593.68 54.6202C593.53 54.3902 593.57 54.3902 593.68 54.2502C593.73 54.1602 593.76 54.0701 593.78 53.9801C593.68 53.9901 593.65 54.1901 593.57 54.2301C593.45 54.2901 593.29 54.1702 593.18 54.2502C593.25 54.1002 593.14 53.8902 593.24 53.7602C593.34 53.6302 593.64 53.6901 593.78 53.6001C593.91 53.5101 594.12 53.5202 594.25 53.4302C594.43 53.3002 594.44 52.8802 594.62 52.8202C594.82 52.7602 595.03 53.0602 595.22 53.1302C595.39 53.1902 595.7 53.0601 595.87 53.2201C596.08 53.4201 596.2 53.4802 596.42 53.3402C596.6 53.1902 596.83 53.1301 597.05 53.1701C597.22 53.2301 597.4 53.2802 597.58 53.3202C597.77 53.3602 597.95 53.4401 598.13 53.4801C598.19 53.4901 598.29 53.6202 598.3 53.6502C598.37 53.8702 598.45 53.7201 598.58 53.7301C598.72 53.7701 598.86 53.7902 599 53.8002C599.26 53.7602 599.51 53.7002 599.76 53.6302C599.86 53.6002 600.08 53.6302 600.1 53.5502C600.2 53.1902 600.31 53.1201 600.57 53.3601C600.7 53.4801 600.75 53.6002 600.83 53.2702C600.88 53.1402 600.98 53.0401 601.11 52.9801C601.24 52.9301 601.39 52.9302 601.51 52.9902C601.88 53.1602 601.96 53.3202 601.98 52.9402C601.98 52.7502 601.92 52.6102 602.01 52.5202C602.13 52.4302 602.27 52.3802 602.43 52.3702C602.66 52.3402 602.89 52.3102 603.12 52.2702C603.35 52.2302 603.59 52.2701 603.82 52.2201C604.06 52.1801 604.24 51.9701 604.23 51.7201C604.19 51.5101 604.23 51.3002 604.34 51.1202C604.46 50.9602 604.56 50.7002 604.76 50.5902C604.92 50.5002 605.08 50.4102 605.24 50.3202C605.4 50.2302 605.54 50.1202 605.69 50.0202C605.89 49.8902 606.16 49.7602 605.97 49.5602C605.77 49.3502 605.87 49.3701 606.01 49.1601C606.09 49.0401 605.98 48.8102 606.03 48.6802C606.14 48.3902 606.12 48.1102 606.23 48.0502C606.44 47.9702 606.68 47.9502 606.9 48.0002C607.18 48.0402 607.45 48.1701 607.73 48.2201C607.81 48.2401 608.1 48.3902 608.11 48.4502C608.12 48.5102 607.88 48.6902 607.83 48.7602C607.64 49.0002 607.33 49.2902 607 49.0602C606.94 49.0202 606.94 48.9702 606.84 48.9902C606.84 49.0902 606.87 49.1802 606.91 49.2702C607.03 49.4302 607.07 49.6402 607.02 49.8302C607.01 49.9802 606.92 49.9902 606.65 50.1402C606.49 50.2302 606.53 50.4902 606.49 50.6302C606.45 50.7802 606.54 50.9002 606.46 51.0302C606.58 51.0802 606.58 51.3202 606.7 51.3802L606.71 51.3501ZM603.52 52.9801C603.57 53.0001 603.84 53.0302 603.89 53.0502C603.89 52.9302 603.89 52.8102 603.87 52.6902C603.82 52.5902 603.75 52.5002 603.66 52.4302C603.6 52.4402 603.73 52.7001 603.67 52.7301C603.71 52.7901 603.48 52.9201 603.52 52.9801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M596.53 56.23C596.42 56.23 596.31 56.2301 596.2 56.2101C596.03 56.1801 595.87 55.88 595.83 55.73C595.81 55.63 595.83 55.52 595.86 55.42C595.88 55.36 595.89 55.3 595.89 55.24C595.87 55.18 595.84 55.1201 595.8 55.0801C595.74 55.0001 595.69 54.91 595.68 54.81C595.67 54.7 595.64 54.64 595.62 54.62C595.57 54.6 595.51 54.6 595.45 54.62C595.34 54.65 595.24 54.69 595.14 54.75C595.02 54.82 594.89 54.8701 594.75 54.9001C594.55 54.9401 594.34 54.97 594.14 55L594.03 55.0201C593.83 55.0501 593.75 54.91 593.64 54.75L593.59 54.67C593.49 54.52 593.46 54.44 593.48 54.35C593.44 54.35 593.4 54.3501 593.37 54.3301C593.31 54.3201 593.27 54.3101 593.26 54.3301C593.22 54.3601 593.16 54.3601 593.12 54.3301C593.08 54.3001 593.07 54.24 593.09 54.2C593.11 54.14 593.11 54.0801 593.09 54.0201C593.07 53.9101 593.09 53.79 593.15 53.69C593.25 53.59 593.38 53.54 593.52 53.55C593.59 53.55 593.66 53.53 593.72 53.51C593.8 53.46 593.89 53.43 593.99 53.41C594.06 53.4 594.13 53.3701 594.19 53.3401C594.26 53.2601 594.31 53.1701 594.33 53.0801C594.39 52.9201 594.45 52.76 594.59 52.72C594.76 52.67 594.92 52.7901 595.06 52.9001C595.12 52.9501 595.19 53.0001 595.26 53.0301C595.33 53.0401 595.39 53.0401 595.46 53.0301C595.63 53.0001 595.81 53.0301 595.95 53.1401C596.15 53.3301 596.21 53.35 596.37 53.25C596.57 53.08 596.84 53.01 597.1 53.07C597.27 53.13 597.44 53.1801 597.61 53.2101C597.71 53.2301 597.81 53.26 597.91 53.29C597.99 53.32 598.08 53.34 598.16 53.36C598.27 53.41 598.36 53.5 598.41 53.61C598.41 53.62 598.41 53.6301 598.42 53.6401H598.43C598.43 53.6401 598.53 53.61 598.58 53.61C598.65 53.61 598.71 53.6301 598.77 53.6501C598.83 53.6701 598.9 53.68 598.97 53.68C599.22 53.64 599.47 53.59 599.72 53.51C599.77 53.5 599.82 53.49 599.87 53.49C599.91 53.49 599.95 53.49 599.99 53.48C600.04 53.31 600.11 53.14 600.26 53.1C600.41 53.08 600.55 53.14 600.65 53.26C600.67 53.28 600.69 53.3 600.71 53.31C600.71 53.31 600.72 53.26 600.73 53.23C600.77 53.08 600.87 52.9601 601.01 52.9001C601.19 52.8201 601.39 52.8101 601.57 52.8901C601.66 52.9301 601.73 52.97 601.79 53C601.82 53.01 601.84 53.03 601.87 53.04C601.87 53.02 601.87 52.98 601.88 52.93C601.88 52.87 601.88 52.82 601.88 52.76C601.85 52.64 601.88 52.52 601.95 52.43C602.09 52.32 602.25 52.26 602.43 52.25L602.59 52.23C602.77 52.21 602.94 52.1801 603.12 52.1501C603.25 52.1301 603.37 52.12 603.5 52.12C603.61 52.12 603.72 52.12 603.82 52.1C604.01 52.07 604.14 51.91 604.13 51.72C604.09 51.49 604.13 51.25 604.26 51.05C604.3 51 604.33 50.9501 604.36 50.8901C604.44 50.7301 604.56 50.59 604.7 50.49C604.79 50.44 604.88 50.3901 604.97 50.3301C605.04 50.2901 605.11 50.2501 605.17 50.2101C605.25 50.1601 605.33 50.11 605.41 50.05C605.48 50 605.55 49.96 605.62 49.91L605.67 49.88C605.76 49.83 605.91 49.73 605.91 49.68C605.91 49.67 605.9 49.65 605.88 49.63C605.7 49.45 605.69 49.36 605.82 49.2C605.85 49.17 605.88 49.1301 605.9 49.0901C605.91 49.0301 605.92 48.97 605.9 48.91C605.88 48.82 605.89 48.72 605.91 48.63C605.95 48.52 605.98 48.41 605.99 48.3C606.02 48.13 606.05 48 606.15 47.94C606.39 47.85 606.64 47.82 606.89 47.87C607.05 47.9 607.2 47.94 607.35 47.99C607.47 48.03 607.6 48.0601 607.72 48.0901C607.78 48.1001 608.15 48.2601 608.19 48.4001C608.22 48.5101 608.11 48.6 607.97 48.72C607.94 48.75 607.91 48.77 607.88 48.8C607.57 49.19 607.25 49.31 606.96 49.16C607.09 49.33 607.14 49.54 607.1 49.75V49.8C607.08 49.98 606.97 50.04 606.81 50.12C606.77 50.14 606.72 50.17 606.67 50.2C606.61 50.23 606.6 50.34 606.59 50.45C606.59 50.51 606.58 50.57 606.56 50.63C606.55 50.68 606.55 50.7201 606.56 50.7701C606.57 50.8301 606.57 50.9001 606.56 50.9601C606.6 51.0101 606.63 51.06 606.65 51.12C606.66 51.15 606.67 51.18 606.69 51.2C606.78 51.15 606.88 51.11 606.98 51.06C607.1 51.01 607.21 50.9501 607.31 50.9001C607.41 50.8501 607.5 50.7801 607.59 50.7101C607.69 50.6301 607.8 50.56 607.91 50.5C607.96 50.48 608.01 50.48 608.05 50.51C608.06 50.53 608.08 50.5601 608.1 50.5801C608.1 50.5901 608.11 50.6 608.11 50.61C608.12 50.61 608.14 50.6301 608.15 50.6401C608.21 50.6801 608.26 50.72 608.27 50.79C608.27 50.83 608.25 50.8701 608.22 50.8901C608.15 50.9501 608.08 51.0101 608.02 51.0801C607.95 51.1601 607.88 51.23 607.8 51.3C607.68 51.37 607.54 51.4 607.4 51.38C607.31 51.37 607.23 51.38 607.15 51.41C607.08 51.47 607.01 51.53 606.95 51.6C606.88 51.67 606.8 51.74 606.73 51.81C606.64 51.87 606.55 51.93 606.45 51.97C606.37 52 606.29 52.05 606.22 52.1C606.15 52.16 606.08 52.2201 606 52.2801C605.92 52.3501 605.85 52.41 605.77 52.47C605.69 52.53 605.59 52.61 605.48 52.57C605.41 52.54 605.36 52.4701 605.35 52.3901C605.34 52.3301 605.35 52.27 605.35 52.2C605.35 52.17 605.36 52.13 605.35 52.1C605.33 52.06 605.28 51.98 605.22 51.98C605.18 51.98 605.09 52.02 605.01 52.12C604.96 52.18 604.93 52.24 604.9 52.31C604.88 52.36 604.85 52.42 604.82 52.47C604.8 52.51 604.77 52.5501 604.75 52.5901C604.68 52.7401 604.58 52.88 604.46 52.99C604.3 53.08 604.11 53.1101 603.93 53.0901C603.93 53.1001 603.91 53.11 603.9 53.12C603.87 53.14 603.83 53.14 603.8 53.12C603.75 53.11 603.71 53.1 603.66 53.1C603.56 53.13 603.48 53.2301 603.49 53.3401C603.49 53.4101 603.49 53.48 603.49 53.55C603.52 53.72 603.48 53.8901 603.37 54.0201C603.24 54.1101 603.07 54.14 602.92 54.1C602.84 54.1 602.76 54.09 602.68 54.1C602.55 54.11 602.45 54.15 602.43 54.2C602.41 54.25 602.45 54.34 602.53 54.45L602.57 54.47C602.57 54.47 602.66 54.51 602.7 54.55C602.72 54.57 602.74 54.59 602.77 54.61C602.82 54.64 602.86 54.7 602.86 54.76C602.86 54.85 602.78 54.9 602.64 54.98C602.61 55.02 602.59 55.06 602.58 55.11C602.54 55.22 602.5 55.33 602.38 55.36C602.28 55.36 602.17 55.32 602.11 55.24C602.04 55.2 601.96 55.17 601.88 55.17C601.79 55.17 601.7 55.14 601.61 55.11C601.29 54.95 601.14 54.59 601.25 54.25H601.24C601.24 54.25 601.2 54.19 601.18 54.17V54.1501C601.18 54.1501 601.16 54.23 601.15 54.26C601.14 54.36 601.13 54.46 601.14 54.56C601.14 54.6 601.12 54.64 601.09 54.66C601.05 54.68 601.01 54.68 600.97 54.66C600.9 54.63 600.82 54.61 600.74 54.61C600.61 54.61 600.48 54.57 600.37 54.49C600.32 54.44 600.27 54.38 600.23 54.32C600.19 54.25 600.18 54.25 600.17 54.25C600.05 54.23 599.92 54.2701 599.82 54.3401C599.59 54.5201 599.34 54.6701 599.06 54.7701L598.98 54.8C598.75 54.9 598.38 55.0601 598.13 54.7701C598.05 54.6701 597.93 54.62 597.8 54.62C597.79 54.62 597.77 54.6201 597.76 54.6401C597.76 54.8201 597.69 54.99 597.57 55.13L597.54 55.18C597.47 55.27 597.37 55.3501 597.26 55.3901C597.19 55.4201 597.13 55.46 597.08 55.5C597.03 55.58 597.01 55.67 597.02 55.76C597.02 55.85 597 55.95 596.97 56.04C596.92 56.17 596.69 56.2 596.49 56.2L596.53 56.23ZM595.56 54.37C595.63 54.37 595.7 54.39 595.75 54.43C595.85 54.52 595.91 54.6501 595.91 54.7801C595.93 54.8401 595.96 54.9 596 54.95C596.06 55.02 596.1 55.11 596.12 55.2C596.13 55.3 596.12 55.4 596.08 55.49C596.06 55.55 596.05 55.61 596.05 55.68C596.08 55.8 596.15 55.91 596.24 56C596.43 56.04 596.62 56.03 596.81 55.98C596.82 55.92 596.83 55.85 596.83 55.79C596.83 55.64 596.87 55.5 596.96 55.38C597.03 55.32 597.11 55.26 597.2 55.23C597.28 55.2 597.34 55.1501 597.4 55.0901L597.43 55.04C597.52 54.94 597.57 54.8 597.57 54.67C597.57 54.62 597.59 54.5701 597.63 54.5301C597.69 54.4701 597.77 54.44 597.85 54.44C598.04 54.44 598.22 54.53 598.34 54.67C598.47 54.82 598.68 54.7401 598.93 54.6401L599.01 54.61C599.26 54.51 599.5 54.3801 599.71 54.2101C599.84 54.1101 600.01 54.06 600.18 54.07C600.3 54.07 600.4 54.14 600.45 54.24C600.48 54.29 600.51 54.33 600.55 54.37C600.62 54.41 600.71 54.43 600.79 54.43C600.84 54.43 600.9 54.43 600.95 54.45C600.95 54.39 600.95 54.3301 600.97 54.2801C600.97 54.2301 600.98 54.17 600.99 54.12C600.99 54.06 601.03 54.0001 601.08 53.9601C601.09 53.9601 601.11 53.94 601.11 53.92C601.13 53.89 601.15 53.88 601.18 53.87C601.21 53.87 601.24 53.87 601.27 53.88C601.33 53.91 601.38 53.97 601.4 54.04C601.4 54.06 601.41 54.0701 601.42 54.0901C601.43 54.1001 601.44 54.12 601.45 54.13C601.52 54.19 601.54 54.28 601.51 54.37C601.44 54.6 601.54 54.8501 601.76 54.9601C601.82 54.9801 601.89 55 601.95 55C602.08 55 602.21 55.05 602.31 55.13C602.33 55.15 602.36 55.17 602.39 55.19C602.38 55.19 602.4 55.1201 602.42 55.0801C602.44 54.9801 602.5 54.8901 602.58 54.8301L602.64 54.79C602.64 54.79 602.6 54.75 602.59 54.73L602.55 54.7101C602.5 54.6901 602.45 54.66 602.42 54.62C602.29 54.5 602.24 54.3201 602.29 54.1501C602.35 54.0201 602.49 53.94 602.72 53.92C602.81 53.92 602.9 53.92 603 53.92C603.11 53.92 603.24 53.9401 603.28 53.9001C603.33 53.8501 603.33 53.72 603.32 53.6C603.32 53.52 603.32 53.44 603.32 53.36C603.32 53.25 603.37 53.15 603.44 53.07C603.37 52.96 603.47 52.87 603.53 52.8C603.54 52.79 603.56 52.77 603.57 52.76V52.74C603.57 52.73 603.57 52.7201 603.58 52.7101C603.58 52.6901 603.57 52.65 603.56 52.63C603.53 52.56 603.53 52.48 603.56 52.41C603.57 52.39 603.59 52.37 603.61 52.36H603.52C603.41 52.36 603.29 52.36 603.18 52.38C603 52.41 602.82 52.4401 602.64 52.4601L602.48 52.48C602.35 52.48 602.23 52.5201 602.13 52.5901C602.11 52.6101 602.11 52.66 602.13 52.74C602.13 52.81 602.14 52.87 602.13 52.94C602.13 53.09 602.11 53.21 602.01 53.26C601.92 53.31 601.83 53.26 601.7 53.19C601.65 53.16 601.58 53.1201 601.49 53.0801C601.37 53.0301 601.23 53.0401 601.12 53.0901C601.04 53.1201 600.98 53.1901 600.96 53.2701C600.92 53.4301 600.88 53.54 600.78 53.56C600.69 53.59 600.62 53.5201 600.56 53.4601C600.54 53.4501 600.53 53.43 600.51 53.41C600.38 53.29 600.34 53.3 600.34 53.3C600.34 53.3 600.29 53.32 600.22 53.55C600.18 53.68 600.02 53.69 599.9 53.7C599.87 53.7 599.83 53.7 599.8 53.7C599.55 53.77 599.29 53.83 599.03 53.87C598.93 53.87 598.83 53.8701 598.74 53.8301C598.69 53.8201 598.64 53.8 598.59 53.8C598.57 53.8 598.55 53.8 598.53 53.82C598.47 53.85 598.4 53.85 598.34 53.82C598.28 53.78 598.23 53.7101 598.21 53.6401C598.18 53.6001 598.15 53.57 598.12 53.54C598.03 53.52 597.94 53.4901 597.86 53.4601C597.77 53.4301 597.68 53.4 597.58 53.38C597.4 53.34 597.22 53.29 597.04 53.23C596.85 53.2 596.65 53.2601 596.5 53.3901C596.2 53.5801 596.01 53.44 595.81 53.25C595.71 53.19 595.6 53.18 595.49 53.2C595.4 53.21 595.3 53.2 595.21 53.18C595.11 53.14 595.02 53.08 594.94 53.01C594.84 52.94 594.74 52.85 594.67 52.87C594.63 52.88 594.58 53.0101 594.55 53.0901C594.51 53.2301 594.44 53.3601 594.33 53.4601C594.24 53.5201 594.15 53.55 594.05 53.57C593.98 53.58 593.92 53.6001 593.86 53.6401C593.77 53.6901 593.66 53.72 593.56 53.72C593.48 53.72 593.37 53.7401 593.35 53.7701C593.33 53.8301 593.32 53.89 593.33 53.95C593.33 53.98 593.33 54.02 593.33 54.05C593.36 54.05 593.39 54.05 593.42 54.06C593.46 54.07 593.5 54.07 593.54 54.06C593.56 54.04 593.57 54.01 593.58 53.99C593.62 53.91 593.68 53.81 593.79 53.8C593.83 53.8 593.87 53.8101 593.89 53.8401C593.91 53.8701 593.92 53.91 593.91 53.94L593.89 54C593.87 54.09 593.83 54.18 593.78 54.25L593.75 54.29C593.75 54.29 593.72 54.3201 593.71 54.3401C593.73 54.3901 593.76 54.44 593.79 54.48L593.85 54.57C593.95 54.73 593.97 54.74 594.01 54.74L594.12 54.72C594.32 54.69 594.53 54.65 594.73 54.62C594.84 54.59 594.95 54.55 595.05 54.49C595.16 54.43 595.29 54.3801 595.41 54.3401C595.46 54.3301 595.51 54.32 595.56 54.32V54.37ZM604 52.8901C604.13 52.9101 604.26 52.8901 604.38 52.8401C604.48 52.7401 604.55 52.63 604.61 52.51C604.63 52.47 604.66 52.42 604.68 52.38C604.7 52.34 604.73 52.29 604.74 52.25C604.77 52.16 604.82 52.08 604.88 52C604.97 51.87 605.12 51.79 605.28 51.79C605.41 51.81 605.53 51.9001 605.58 52.0301C605.62 52.1101 605.62 52.2001 605.6 52.2801C605.6 52.3101 605.6 52.35 605.6 52.38C605.62 52.36 605.65 52.3501 605.67 52.3301C605.75 52.2701 605.82 52.2101 605.89 52.1401C605.96 52.0801 606.04 52.01 606.11 51.95C606.2 51.89 606.29 51.83 606.39 51.8C606.47 51.77 606.55 51.72 606.63 51.67C606.7 51.61 606.77 51.55 606.83 51.48C606.87 51.44 606.91 51.4 606.95 51.36C606.89 51.39 606.82 51.42 606.76 51.45C606.73 51.47 606.7 51.47 606.66 51.45C606.57 51.4 606.5 51.3101 606.48 51.2101C606.47 51.1701 606.44 51.11 606.42 51.1C606.39 51.09 606.37 51.0601 606.36 51.0301C606.36 51.0001 606.36 50.96 606.37 50.94C606.39 50.9 606.4 50.85 606.38 50.8C606.37 50.72 606.38 50.65 606.38 50.57C606.39 50.53 606.4 50.48 606.4 50.43C606.4 50.27 606.46 50.11 606.6 50.01C606.66 49.98 606.7 49.95 606.75 49.93C606.92 49.84 606.92 49.83 606.92 49.79V49.73C606.96 49.58 606.92 49.43 606.83 49.31C606.78 49.23 606.75 49.14 606.74 49.05V48.99C606.74 48.99 606.74 48.93 606.75 48.91C606.77 48.89 606.79 48.87 606.82 48.87C606.9 48.85 606.98 48.87 607.04 48.94L607.06 48.9601C607.26 49.1001 607.49 49 607.74 48.68C607.78 48.64 607.81 48.6 607.86 48.57C607.89 48.54 607.95 48.49 607.98 48.45C607.89 48.4 607.8 48.35 607.7 48.32C607.57 48.29 607.44 48.2601 607.31 48.2101C607.17 48.1601 607.02 48.12 606.88 48.1C606.68 48.06 606.47 48.0801 606.28 48.1401C606.26 48.2101 606.24 48.2701 606.23 48.3401C606.21 48.4601 606.18 48.5901 606.14 48.7101C606.14 48.7701 606.14 48.83 606.14 48.88C606.17 48.99 606.15 49.1101 606.1 49.2101C606.07 49.2501 606.04 49.3001 606.01 49.3401C606 49.3601 605.98 49.3701 605.97 49.3901C605.97 49.3901 605.99 49.42 606.05 49.47C606.12 49.53 606.15 49.6201 606.15 49.7101C606.13 49.8701 605.96 49.97 605.8 50.07L605.75 50.1C605.68 50.14 605.62 50.19 605.55 50.23C605.47 50.29 605.38 50.3501 605.29 50.4001C605.22 50.4401 605.15 50.4801 605.08 50.5201C604.99 50.5701 604.9 50.62 604.81 50.67C604.7 50.76 604.61 50.87 604.54 51C604.5 51.06 604.46 51.13 604.42 51.18C604.33 51.34 604.3 51.52 604.34 51.7C604.36 52 604.14 52.27 603.84 52.32C603.78 52.32 603.73 52.3301 603.67 52.3401C603.68 52.3401 603.69 52.34 603.7 52.36C603.8 52.45 603.89 52.56 603.94 52.68C603.94 52.72 603.96 52.8101 603.96 52.9001L604 52.8901ZM607.97 50.76C607.9 50.81 607.83 50.85 607.76 50.91C607.66 50.99 607.56 51.06 607.44 51.12C607.4 51.14 607.35 51.16 607.31 51.18C607.35 51.18 607.4 51.18 607.44 51.18C607.53 51.18 607.61 51.1801 607.69 51.1501C607.76 51.0901 607.83 51.0301 607.89 50.9601C607.93 50.9101 607.97 50.87 608.02 50.82C608 50.8 607.98 50.78 607.96 50.76H607.97Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.47 44.5702C608.5 44.6202 608.66 44.6602 608.67 44.7102C608.71 45.0702 608.77 44.9002 609 44.7602C609.02 44.7502 609.2 45.0102 609.21 45.0002C609.32 44.9402 609.33 44.7502 609.44 44.6802C609.45 44.8902 609.67 45.1702 609.59 45.3402C609.5 45.5502 609.05 45.5602 608.9 45.7502C608.83 45.8702 608.79 46.0002 608.79 46.1402C608.78 46.3302 608.86 46.5202 609.01 46.6402C609.1 46.7002 609.24 46.5802 609.52 46.5302C609.67 46.5202 609.81 46.5302 609.96 46.5402C610.09 46.5502 610.2 46.6202 610.28 46.7202C610.37 46.9302 610.19 46.9502 610.01 46.9802C609.85 47.0102 609.65 46.9002 609.5 46.9302C609.22 46.9602 609.01 47.2002 609 47.4802C609 47.5202 608.89 47.8002 608.79 47.7902C608.62 47.7502 608.44 47.7102 608.26 47.7002C608.08 47.7202 607.87 47.5902 607.7 47.6302C607.53 47.7002 607.36 47.7902 607.21 47.8902C607.09 47.9102 606.97 47.8902 606.85 47.8702C606.88 47.7902 606.95 47.5102 607.01 47.4802C607.19 47.3702 607.38 47.2602 607.56 47.1602C607.75 47.0602 607.98 47.0402 608.16 46.9402C608.3 46.8602 608.45 46.8302 608.32 46.6102C608.24 46.4802 608.21 46.3202 608.24 46.1702C608.36 45.7802 608.45 45.8902 608.06 45.7902C607.84 45.7302 607.67 45.5002 607.45 45.4302C607.22 45.3902 607 45.3402 606.78 45.2702C606.49 45.1402 606.53 45.0702 606.83 44.9402C607.02 44.8602 607.26 44.9602 607.45 44.9002C607.64 44.8302 607.78 44.6902 607.98 44.6602C608.17 44.6602 608.36 44.6802 608.53 44.7402C608.58 44.7402 608.47 44.5502 608.47 44.5602V44.5702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.11 48.0301C607.01 48.0301 606.91 48.0201 606.81 47.9901C606.78 47.9901 606.76 47.9601 606.74 47.9301C606.73 47.9001 606.73 47.8701 606.74 47.8401C606.74 47.8201 606.76 47.7901 606.77 47.7501C606.84 47.5301 606.88 47.4301 606.95 47.3901C607.01 47.3501 607.08 47.3101 607.14 47.2701C607.26 47.2001 607.38 47.1201 607.5 47.0601C607.6 47.0101 607.71 46.9701 607.82 46.9401C607.92 46.9201 608.01 46.8801 608.1 46.8401L608.16 46.8101C608.16 46.8101 608.23 46.7801 608.25 46.7501C608.25 46.7501 608.23 46.6901 608.21 46.6601C608.12 46.5001 608.08 46.3101 608.11 46.1301C608.14 46.0401 608.16 45.9801 608.18 45.9301C608.18 45.9301 608.08 45.9101 608.01 45.8901C607.88 45.8501 607.76 45.7801 607.65 45.6901C607.57 45.6201 607.48 45.5701 607.39 45.5301C607.3 45.5001 607.21 45.4801 607.12 45.4701C606.98 45.4501 606.84 45.4201 606.71 45.3601C606.58 45.3001 606.45 45.2301 606.45 45.1001C606.45 44.9701 606.59 44.9001 606.76 44.8301C606.88 44.7901 607.01 44.7801 607.14 44.8001C607.22 44.8101 607.31 44.8001 607.4 44.7901C607.47 44.7601 607.54 44.7301 607.6 44.6901C607.71 44.6201 607.83 44.5701 607.95 44.5501C608.09 44.5401 608.22 44.5501 608.35 44.5901C608.35 44.5301 608.37 44.4801 608.41 44.4601C608.45 44.4401 608.51 44.4501 608.54 44.4801C608.54 44.4801 608.58 44.5101 608.6 44.5201C608.67 44.5501 608.75 44.5901 608.77 44.6801C608.77 44.7101 608.77 44.7301 608.78 44.7501C608.83 44.7101 608.87 44.6801 608.92 44.6401C609.01 44.5801 609.07 44.6501 609.18 44.7801V44.8001L609.21 44.7601C609.24 44.6801 609.3 44.6001 609.37 44.5501C609.4 44.5301 609.44 44.5301 609.48 44.5501C609.51 44.5701 609.54 44.6001 609.54 44.6401C609.55 44.7301 609.58 44.8101 609.62 44.8901C609.7 45.0301 609.73 45.2001 609.69 45.3501C609.59 45.5001 609.44 45.6001 609.27 45.6301C609.16 45.6601 609.06 45.7101 608.98 45.7801C608.93 45.8801 608.89 45.9801 608.89 46.1001C608.88 46.2601 608.94 46.4101 609.06 46.5101C609.1 46.5101 609.14 46.4901 609.19 46.4701C609.29 46.4301 609.39 46.4001 609.49 46.3801C609.62 46.3601 609.74 46.3701 609.87 46.3801H609.96C610.13 46.4001 610.28 46.4901 610.37 46.6401C610.41 46.7201 610.41 46.8101 610.37 46.8901C610.31 47.0001 610.17 47.0301 610.04 47.0501H610.01C609.91 47.0701 609.81 47.0501 609.72 47.0301C609.65 47.0101 609.58 47.0001 609.5 47.0101C609.4 47.0301 609.07 47.1401 609.09 47.4501C609.07 47.5901 609.01 47.7101 608.92 47.8101C608.88 47.8501 608.82 47.8801 608.76 47.8801C608.67 47.8801 608.59 47.8501 608.51 47.8301C608.43 47.8001 608.34 47.7901 608.25 47.7901C608.15 47.7901 608.05 47.7801 607.96 47.7501C607.88 47.7201 607.79 47.7101 607.71 47.7201C607.61 47.7501 607.53 47.8001 607.44 47.8601C607.37 47.9001 607.3 47.9401 607.23 47.9801C607.18 48.0001 607.13 48.0101 607.09 48.0001L607.11 48.0301ZM606.99 47.8001C607.05 47.8001 607.11 47.8101 607.16 47.8001C607.22 47.7701 607.28 47.7301 607.34 47.7001C607.44 47.6301 607.55 47.5701 607.67 47.5401C607.79 47.5201 607.92 47.5301 608.04 47.5701C608.11 47.5901 608.18 47.6101 608.26 47.6001C608.37 47.6001 608.49 47.6101 608.59 47.6501C608.66 47.6701 608.73 47.6901 608.8 47.6901C608.84 47.6201 608.87 47.5501 608.89 47.4801C608.89 47.1501 609.14 46.8701 609.47 46.8201C609.58 46.8001 609.68 46.8101 609.79 46.8401C609.86 46.8601 609.93 46.8701 610 46.8601H610.03C610.09 46.8601 610.15 46.8301 610.2 46.8101C610.2 46.7901 610.2 46.7801 610.18 46.7601C610.12 46.7001 610.04 46.6601 609.95 46.6501H609.85C609.75 46.6201 609.64 46.6201 609.53 46.6301C609.44 46.6501 609.35 46.6701 609.27 46.7101C609.15 46.7501 609.04 46.7901 608.94 46.7201C608.76 46.5801 608.65 46.3601 608.67 46.1301C608.63 45.8001 608.87 45.5001 609.19 45.4501C609.31 45.4001 609.45 45.3501 609.48 45.2901C609.51 45.2301 609.45 45.1001 609.41 45.0001C609.41 44.9801 609.39 44.9601 609.39 44.9401C609.36 45.0001 609.32 45.0501 609.26 45.0901C609.17 45.1401 609.11 45.0701 609.01 44.9401L608.98 44.9001C608.98 44.9001 608.94 44.9301 608.93 44.9401C608.86 45.0001 608.78 45.0601 608.69 45.0201C608.62 44.9801 608.58 44.9201 608.57 44.8401C608.55 44.8501 608.52 44.8501 608.5 44.8501C608.45 44.8401 608.39 44.8301 608.35 44.8201C608.23 44.7801 608.11 44.7701 607.98 44.7801C607.88 44.8001 607.79 44.8401 607.71 44.8901C607.63 44.9401 607.55 44.9801 607.47 45.0101C607.36 45.0401 607.24 45.0501 607.13 45.0301C607.04 45.0201 606.95 45.0301 606.86 45.0501C606.81 45.0701 606.76 45.0901 606.72 45.1201C606.75 45.1401 606.78 45.1601 606.82 45.1701C606.93 45.2201 607.05 45.2501 607.17 45.2601C607.27 45.2701 607.38 45.3001 607.48 45.3301C607.6 45.3801 607.71 45.4401 607.81 45.5201C607.89 45.5901 607.99 45.6501 608.09 45.6801C608.16 45.7001 608.21 45.7101 608.25 45.7201C608.34 45.7401 608.41 45.7501 608.44 45.8201C608.46 45.8801 608.46 45.9501 608.42 46.0101C608.39 46.0701 608.37 46.1401 608.35 46.2001C608.34 46.3201 608.36 46.4401 608.42 46.5501C608.48 46.6301 608.5 46.7201 608.48 46.8101C608.44 46.9001 608.37 46.9701 608.27 47.0001L608.22 47.0301C608.11 47.0801 608 47.1201 607.89 47.1501C607.8 47.1701 607.7 47.2101 607.62 47.2501C607.5 47.3101 607.38 47.3801 607.27 47.4501C607.2 47.4901 607.14 47.5301 607.07 47.5701C607.06 47.5901 607.02 47.7101 607 47.7801L606.99 47.8001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.55 44.5701C608.55 44.4701 608.37 44.4001 608.35 44.3101C608.3 44.0601 608.48 43.8801 608.41 43.8201C608.28 43.6701 608.08 43.5901 607.89 43.6301C607.58 43.7001 607.35 43.8901 607.16 43.6401C606.97 43.4101 606.98 43.08 607.17 42.85C607.25 42.73 607.3 42.5201 607.43 42.4501C607.58 42.3701 607.75 42.3301 607.93 42.3301C608.16 42.3501 608.38 42.4301 608.57 42.5601C608.76 42.7301 608.9 42.9601 608.97 43.2101C608.97 43.3701 609.02 43.52 609.08 43.66C609.13 43.82 609.21 43.9601 609.32 44.0801C609.43 44.1701 609.47 44.3201 609.42 44.4601C609.37 44.5901 609.25 44.6901 609.1 44.6901C608.93 44.7201 608.75 44.7401 608.58 44.7501C608.56 44.7501 608.55 44.5901 608.56 44.5801L608.55 44.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.58 44.86C608.58 44.86 608.52 44.8501 608.5 44.8301C608.46 44.7601 608.44 44.6701 608.44 44.5901C608.42 44.5701 608.4 44.5501 608.38 44.5301C608.31 44.4801 608.27 44.4201 608.24 44.3401C608.22 44.2001 608.24 44.07 608.29 43.94C608.29 43.92 608.3 43.9 608.31 43.88C608.21 43.76 608.06 43.71 607.91 43.74C607.84 43.76 607.77 43.78 607.71 43.8C607.5 43.88 607.27 43.9601 607.07 43.7101C606.85 43.4401 606.85 43.06 607.07 42.79C607.09 42.75 607.11 42.71 607.13 42.67C607.17 42.54 607.26 42.43 607.37 42.35C607.54 42.26 607.74 42.21 607.93 42.22C608.19 42.24 608.43 42.33 608.64 42.48C608.85 42.67 609 42.92 609.07 43.19C609.07 43.33 609.11 43.47 609.17 43.6C609.19 43.65 609.21 43.69 609.23 43.73C609.26 43.83 609.32 43.92 609.39 43.99C609.52 44.11 609.57 44.2901 609.53 44.4601C609.47 44.6401 609.31 44.7601 609.12 44.7801C608.94 44.8101 608.76 44.8301 608.58 44.8401V44.86ZM608.67 44.5801C608.67 44.5801 608.67 44.61 608.67 44.63C608.81 44.63 608.95 44.6001 609.08 44.5801C609.18 44.5801 609.27 44.51 609.31 44.41C609.33 44.32 609.31 44.22 609.23 44.17C609.14 44.07 609.07 43.9601 609.02 43.8401C609 43.8001 608.99 43.76 608.97 43.72C608.89 43.57 608.85 43.4 608.84 43.23C608.78 43.01 608.65 42.8001 608.48 42.6501C608.31 42.5301 608.11 42.4601 607.9 42.4501C607.75 42.4501 607.6 42.48 607.47 42.55C607.4 42.61 607.35 42.6801 607.33 42.7701C607.31 42.8201 607.28 42.87 607.25 42.92C607.08 43.1 607.07 43.3901 607.23 43.5801C607.32 43.6901 607.4 43.68 607.62 43.6C607.69 43.57 607.77 43.5501 607.85 43.5301C608.07 43.4801 608.31 43.56 608.46 43.73C608.54 43.81 608.55 43.9301 608.5 44.0201C608.46 44.1101 608.45 44.21 608.46 44.3C608.48 44.32 608.5 44.34 608.52 44.36C608.59 44.41 608.64 44.49 608.66 44.57C608.66 44.57 608.66 44.5801 608.66 44.5901L608.67 44.5801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M599.21 55.1001C599.21 55.1001 599.26 55.2002 599.28 55.2102C599.48 55.2102 599.86 54.8902 600.01 55.1502C600.16 55.4102 599.7 55.5101 599.54 55.6601C599.42 55.7701 599.49 56.1401 599.69 56.1801C600.1 56.2601 600.08 56.0601 599.86 56.4201C599.66 56.7501 599.4 56.8702 599.17 56.6502C599.02 56.5202 599.04 56.2001 598.89 56.0601C598.75 55.9301 598.29 56.0001 598.37 55.6601C598.45 55.3501 598.71 55.3702 599 55.3402C599.08 55.3402 599.13 55.1102 599.21 55.0902V55.1001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M599.41 56.8702C599.29 56.8702 599.17 56.8202 599.08 56.7302C598.99 56.6302 598.93 56.5102 598.91 56.3902C598.89 56.3002 598.86 56.2202 598.8 56.1502C598.75 56.1202 598.69 56.1002 598.63 56.0902C598.49 56.0802 598.36 56.0102 598.28 55.9002C598.24 55.8202 598.23 55.7302 598.25 55.6402C598.34 55.2902 598.63 55.2602 598.89 55.2402H598.97C598.97 55.2402 599 55.1902 599.01 55.1702C599.05 55.1002 599.1 55.0102 599.19 54.9902C599.27 54.9702 599.32 55.0402 599.34 55.0902C599.39 55.0702 599.45 55.0502 599.5 55.0302C599.68 54.9502 599.96 54.8402 600.11 55.0902C600.15 55.1602 600.17 55.2402 600.15 55.3202C600.11 55.4702 599.95 55.5502 599.8 55.6302C599.74 55.6602 599.68 55.7002 599.62 55.7402C599.59 55.8002 599.59 55.8702 599.62 55.9302C599.64 56.0002 599.68 56.0602 599.72 56.0602C599.8 56.0802 599.89 56.0802 599.98 56.0802C600.04 56.0702 600.09 56.0902 600.12 56.1402C600.15 56.2002 600.13 56.2602 600.09 56.3002C600.05 56.3602 600.01 56.4102 599.97 56.4802C599.88 56.6702 599.7 56.8202 599.49 56.8702C599.47 56.8702 599.45 56.8702 599.43 56.8702H599.41ZM599.19 55.2802C599.15 55.3602 599.09 55.4402 599 55.4502H598.9C598.63 55.4802 598.51 55.5002 598.47 55.6802C598.46 55.7102 598.46 55.7402 598.47 55.7702C598.5 55.8102 598.6 55.8402 598.68 55.8602C598.78 55.8702 598.87 55.9102 598.94 55.9702C599.03 56.0702 599.09 56.1902 599.12 56.3202C599.14 56.4102 599.17 56.4902 599.23 56.5602C599.28 56.6202 599.36 56.6402 599.43 56.6402C599.57 56.5902 599.69 56.4902 599.75 56.3602C599.76 56.3402 599.77 56.3202 599.79 56.3002C599.75 56.3002 599.71 56.3002 599.66 56.2802C599.52 56.2402 599.42 56.1302 599.39 55.9902C599.34 55.8502 599.36 55.6902 599.46 55.5702C599.53 55.5102 599.61 55.4602 599.69 55.4202C599.78 55.3702 599.91 55.3002 599.93 55.2502C599.93 55.2502 599.93 55.2302 599.92 55.2002C599.88 55.1302 599.81 55.1402 599.59 55.2302C599.5 55.2802 599.4 55.3002 599.3 55.3102H599.29C599.29 55.3102 599.23 55.3002 599.21 55.2802H599.19Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.39 38.1001C607.33 38.1501 607.32 38.3601 607.24 38.3901C607.02 38.4801 606.85 38.8001 606.53 38.6201", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M606.73 38.7901C606.64 38.7901 606.56 38.7601 606.49 38.7201L606.6 38.5302C606.75 38.6202 606.84 38.5601 606.99 38.4401C607.06 38.3801 607.13 38.3401 607.2 38.3001C607.2 38.3001 607.2 38.2501 607.22 38.2201C607.23 38.1501 607.27 38.0801 607.32 38.0201L607.46 38.2001L607.39 38.1101L607.47 38.1901C607.47 38.1901 607.44 38.2502 607.44 38.2802C607.41 38.3702 607.38 38.4701 607.3 38.5001C607.24 38.5301 607.19 38.5701 607.14 38.6101C607.03 38.7101 606.89 38.7801 606.74 38.7901H606.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.23 49.3601C610.03 49.2901 609.66 49.2801 609.51 49.1601C609.37 49.0501 609.4 48.6501 609.31 48.4801C609.55 48.4701 609.79 48.4801 610.03 48.5001C610.13 48.5001 610.16 48.6701 610.26 48.7401C610.38 48.8301 610.76 48.8601 610.87 48.9501C610.73 49.0401 610.41 49.2401 610.22 49.3701L610.23 49.3601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M610.23 49.4701C610.23 49.4701 610.2 49.4701 610.19 49.4701C610.11 49.4501 610.02 49.4301 609.94 49.4101C609.76 49.3901 609.59 49.3402 609.44 49.2402C609.33 49.1102 609.27 48.9502 609.27 48.7902C609.27 48.7002 609.24 48.6102 609.21 48.5302C609.19 48.5002 609.19 48.4602 609.21 48.4202C609.23 48.3902 609.26 48.3702 609.3 48.3602C609.5 48.3502 609.71 48.3602 609.91 48.3602H610.04C610.14 48.3902 610.22 48.4502 610.26 48.5402C610.28 48.5702 610.3 48.6002 610.33 48.6302C610.42 48.6702 610.51 48.7002 610.6 48.7102C610.72 48.7302 610.84 48.7702 610.95 48.8302C610.98 48.8502 611 48.8902 611 48.9202C611 48.9602 610.98 48.9902 610.95 49.0102C610.89 49.0502 610.79 49.1202 610.68 49.1902C610.55 49.2702 610.41 49.3602 610.3 49.4302C610.28 49.4402 610.26 49.4502 610.24 49.4502L610.23 49.4701ZM609.46 48.5802C609.47 48.6402 609.48 48.7002 609.49 48.7602C609.49 48.8702 609.52 48.9802 609.58 49.0702C609.7 49.1402 609.84 49.1802 609.98 49.1902C610.06 49.2102 610.14 49.2202 610.21 49.2402C610.31 49.1702 610.43 49.1002 610.55 49.0202L610.63 48.9701C610.63 48.9701 610.57 48.9602 610.55 48.9502C610.43 48.9302 610.31 48.8902 610.2 48.8302C610.15 48.7902 610.11 48.7402 610.08 48.6802C610.07 48.6502 610.05 48.6302 610.03 48.6102H609.91C609.77 48.5902 609.62 48.5802 609.48 48.5902L609.46 48.5802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M608.16 49.35C608.31 49.33 608.46 49.3301 608.61 49.3401C608.73 49.3401 608.82 49.52 608.93 49.55C608.86 49.64 608.83 49.78 608.74 49.8C608.56 49.84 608.35 49.77 608.17 49.8C607.99 49.83 607.83 50.1001 607.64 50.1201C607.56 50.1201 607.67 49.8401 607.59 49.7701C607.67 49.7201 607.49 49.58 607.58 49.55C607.77 49.5 607.97 49.39 608.16 49.35Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.65 50.2202C607.65 50.2202 607.58 50.2102 607.55 50.1802C607.5 50.1302 607.5 50.0502 607.51 49.9602C607.51 49.9202 607.51 49.8702 607.51 49.8302C607.48 49.8102 607.47 49.7802 607.47 49.7402C607.47 49.7202 607.47 49.7102 607.49 49.7002C607.45 49.6402 607.44 49.5702 607.46 49.5102C607.48 49.4702 607.52 49.4502 607.56 49.4302C607.64 49.4102 607.72 49.3802 607.8 49.3402C607.91 49.2902 608.03 49.2502 608.15 49.2302C608.28 49.2102 608.4 49.2102 608.53 49.2102H608.62C608.72 49.2202 608.81 49.2702 608.87 49.3502C608.9 49.3802 608.93 49.4102 608.97 49.4302C609.01 49.4302 609.04 49.4702 609.05 49.5002C609.06 49.5402 609.05 49.5802 609.03 49.6102C609.01 49.6402 608.99 49.6702 608.98 49.7002C608.95 49.7902 608.88 49.8602 608.79 49.9002C608.68 49.9202 608.56 49.9202 608.45 49.9002C608.37 49.8902 608.29 49.8902 608.21 49.9002C608.13 49.9302 608.06 49.9702 608.01 50.0302C607.92 50.1202 607.8 50.1902 607.68 50.2202H607.65ZM607.73 49.7602C607.75 49.8202 607.75 49.8902 607.74 49.9502C607.78 49.9302 607.81 49.8902 607.85 49.8602C607.94 49.7702 608.04 49.7102 608.16 49.6802C608.26 49.6702 608.36 49.6702 608.46 49.6802C608.55 49.6902 608.64 49.6902 608.72 49.6802C608.74 49.6602 608.75 49.6302 608.76 49.6002V49.5802C608.76 49.5802 608.72 49.5402 608.7 49.5102C608.67 49.4802 608.62 49.4402 608.6 49.4402H608.51C608.4 49.4402 608.28 49.4402 608.17 49.4502C608.07 49.4702 607.96 49.5102 607.86 49.5502C607.8 49.5702 607.74 49.6002 607.68 49.6202C607.7 49.6602 607.71 49.7102 607.7 49.7502L607.73 49.7602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.77 48.3101C586.55 48.2601 586.26 48.1501 586.12 48.1101C586.24 47.8701 586.5 47.6201 586.63 47.3701C586.79 47.5301 587.13 47.5801 587.25 47.7701C587.11 47.9601 586.95 48.1401 586.77 48.3001V48.3101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.77 48.4301C586.77 48.4301 586.75 48.4301 586.74 48.4301C586.62 48.4001 586.47 48.3501 586.34 48.3101C586.24 48.2801 586.15 48.2501 586.09 48.2301C586.06 48.2301 586.03 48.2001 586.01 48.1701C586 48.1401 586 48.1001 586.01 48.0701C586.09 47.9301 586.17 47.8001 586.27 47.6801C586.36 47.5701 586.44 47.4501 586.51 47.3301C586.53 47.3001 586.56 47.2801 586.59 47.2701C586.63 47.2701 586.66 47.2701 586.69 47.3001C586.77 47.3601 586.85 47.4101 586.95 47.4501C587.1 47.5001 587.23 47.5901 587.33 47.7201C587.39 47.8101 587.35 47.8701 586.9 48.3301L586.84 48.3901C586.84 48.3901 586.79 48.4201 586.76 48.4201L586.77 48.4301ZM586.29 48.0501L586.41 48.0901C586.51 48.1201 586.63 48.1601 586.73 48.1901L586.75 48.1701C586.83 48.0901 587.03 47.8901 587.11 47.7901C587.04 47.7301 586.96 47.6901 586.87 47.6601C586.8 47.6301 586.73 47.5901 586.66 47.5501C586.6 47.6401 586.53 47.7301 586.46 47.8201C586.4 47.9001 586.34 47.9801 586.29 48.0501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.5 40.1601C607.43 40.2101 607.34 40.2401 607.26 40.2301C607.01 40.0901 606.79 39.9001 606.55 39.7401C606.54 39.7401 606.49 39.7901 606.5 39.7901C606.67 39.7801 606.83 39.7901 607 39.8401C607.18 39.9201 607.36 40.0201 607.51 40.1501L607.5 40.1601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M607.29 40.3401C607.29 40.3401 607.23 40.3401 607.21 40.3201C607.06 40.2401 606.92 40.1401 606.79 40.0401C606.73 40.0001 606.67 39.9501 606.61 39.9101C606.57 39.9101 606.53 39.9101 606.49 39.9101C606.44 39.9101 606.41 39.8701 606.39 39.8301C606.37 39.7401 606.47 39.6601 606.47 39.6601C606.51 39.6301 606.57 39.6301 606.61 39.6601C606.63 39.6701 606.65 39.6901 606.67 39.7001C606.7 39.7001 606.73 39.7001 606.76 39.7001C606.86 39.7001 606.95 39.7101 607.04 39.7601L607.1 39.7901C607.27 39.8701 607.43 39.9701 607.58 40.0901C607.6 40.1101 607.62 40.1401 607.61 40.1801C607.61 40.2101 607.59 40.2401 607.57 40.2601C607.49 40.3201 607.39 40.3501 607.29 40.3601V40.3401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.13 51.9001C588.94 51.7401 588.96 51.5701 588.83 51.4601C588.98 51.3901 588.91 51.1401 589.07 51.0901C589.25 51.0301 589.33 51.2201 589.3 51.4301C589.3 51.6001 589.24 51.7701 589.13 51.9001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.13 52.0101C589.13 52.0101 589.08 52.0101 589.06 51.9801C588.97 51.9001 588.89 51.8001 588.85 51.6801C588.83 51.6301 588.8 51.5801 588.76 51.5401C588.73 51.5201 588.72 51.4801 588.72 51.4401C588.72 51.4001 588.75 51.3701 588.78 51.3501C588.8 51.3401 588.82 51.3001 588.83 51.2301C588.84 51.1201 588.92 51.0201 589.02 50.9701C589.11 50.9401 589.2 50.9501 589.28 51.0101C589.39 51.1201 589.43 51.2801 589.4 51.4401V51.4801C589.39 51.6601 589.32 51.8301 589.21 51.9701C589.19 51.9901 589.16 52.0101 589.13 52.0101ZM588.98 51.4602C588.98 51.4602 589.03 51.5402 589.05 51.5902C589.07 51.6302 589.09 51.6801 589.12 51.7201C589.16 51.6401 589.18 51.5502 589.18 51.4602V51.4201C589.2 51.3401 589.18 51.2601 589.14 51.2001C589.14 51.2001 589.13 51.1901 589.1 51.2001C589.08 51.2001 589.07 51.2501 589.05 51.3101C589.04 51.3701 589.01 51.4301 588.98 51.4801V51.4602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.73 46.7701C603.8 47.0401 603.76 47.1401 603.47 46.9901C603.33 46.9401 603.19 46.9001 603.05 46.8801C603.16 46.8001 603.26 46.7201 603.36 46.6201C603.76 46.3301 603.62 46.7601 603.73 46.7701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.68 47.1701C603.59 47.1701 603.5 47.1401 603.43 47.0901C603.37 47.0601 603.3 47.0401 603.23 47.0301C603.16 47.0201 603.09 47.0001 603.02 46.9801C602.98 46.9701 602.95 46.9301 602.94 46.8901C602.94 46.8501 602.96 46.8001 602.99 46.7801C603.05 46.7501 603.1 46.7001 603.15 46.6601C603.2 46.6101 603.25 46.5701 603.3 46.5301C603.39 46.4401 603.52 46.4001 603.65 46.4201C603.73 46.4601 603.79 46.5501 603.79 46.6401V46.6701C603.79 46.6701 603.84 46.7101 603.85 46.7401C603.89 46.8801 603.91 47.0401 603.81 47.1301C603.78 47.1601 603.73 47.1701 603.69 47.1701H603.68ZM603.31 46.8201C603.39 46.8301 603.46 46.8601 603.53 46.8901C603.57 46.9101 603.61 46.9301 603.65 46.9401C603.65 46.9101 603.65 46.8801 603.64 46.8401C603.6 46.8001 603.58 46.7401 603.57 46.6801C603.57 46.6701 603.57 46.6501 603.56 46.6301C603.52 46.6501 603.47 46.6701 603.43 46.7001C603.39 46.7301 603.34 46.7701 603.31 46.8101V46.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.78 49.6201C587.82 49.6901 587.79 49.7801 587.73 49.8201C587.59 49.9801 587.66 50.3401 587.5 50.4701C587.47 50.4901 587.42 50.3001 587.34 50.2701C587.37 50.2101 587.41 50.3201 587.45 50.2701C587.59 50.1301 587.59 49.8001 587.77 49.6201H587.78Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.49 50.5801H587.47C587.4 50.5601 587.38 50.5101 587.34 50.4501C587.33 50.4201 587.31 50.3901 587.29 50.3701C587.26 50.3601 587.24 50.3401 587.23 50.3101C587.23 50.2801 587.23 50.2501 587.24 50.2201C587.26 50.1801 587.29 50.1601 587.33 50.1501C587.35 50.1501 587.38 50.1501 587.4 50.1501C587.43 50.0901 587.45 50.0301 587.47 49.9601C587.51 49.8001 587.58 49.6601 587.69 49.5401C587.72 49.5101 587.76 49.5001 587.79 49.5101C587.83 49.5101 587.86 49.5401 587.87 49.5801C587.92 49.6901 587.9 49.8101 587.81 49.8901C587.76 49.9701 587.73 50.0601 587.73 50.1501C587.73 50.3001 587.66 50.4501 587.56 50.5601C587.54 50.5801 587.51 50.5801 587.48 50.5801H587.49Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.92 48.2402C604.06 48.2702 604.13 48.1602 604.24 48.1802C604.2 48.2802 604.17 48.2902 604.14 48.2902C603.99 48.2702 603.66 48.4702 603.52 48.4202C603.59 48.3502 603.85 48.3102 603.92 48.2402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M603.58 48.5401C603.58 48.5401 603.51 48.5402 603.48 48.5202C603.45 48.5102 603.42 48.4802 603.41 48.4402C603.41 48.4002 603.41 48.3702 603.44 48.3402C603.51 48.2802 603.59 48.2401 603.68 48.2201C603.73 48.2001 603.79 48.1801 603.84 48.1601C603.87 48.1301 603.9 48.1202 603.94 48.1302C603.98 48.1302 604.02 48.1301 604.06 48.1101C604.12 48.0801 604.19 48.0702 604.26 48.0802C604.29 48.0802 604.32 48.1102 604.34 48.1402C604.36 48.1702 604.36 48.2101 604.34 48.2401C604.31 48.3101 604.24 48.4301 604.12 48.4201C604.04 48.4201 603.97 48.4501 603.89 48.4801C603.79 48.5201 603.68 48.5502 603.57 48.5602L603.58 48.5401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M604.51 47.3101C604.41 47.4501 604.46 47.3301 604.38 47.3701C604.34 47.3901 604.33 47.4701 604.33 47.4201C604.3 47.2801 604.29 47.1401 604.3 47.0001C604.39 47.0401 604.36 47.2501 604.52 47.3101H604.51Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M604.33 47.54H604.32C604.27 47.52 604.23 47.48 604.22 47.42C604.22 47.4 604.22 47.3701 604.21 47.3301C604.18 47.2101 604.17 47.0801 604.2 46.9501C604.2 46.9201 604.23 46.9001 604.26 46.8801C604.29 46.8701 604.32 46.8701 604.35 46.8801C604.42 46.9201 604.48 46.9901 604.49 47.0701C604.51 47.1401 604.53 47.1801 604.57 47.1901C604.6 47.2001 604.63 47.2301 604.64 47.2601C604.64 47.2901 604.64 47.33 604.62 47.36C604.57 47.42 604.54 47.47 604.47 47.48C604.46 47.48 604.45 47.48 604.44 47.48C604.42 47.51 604.38 47.54 604.34 47.54H604.33Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M605.31 52.8801C605.18 53.0101 605.14 53.09 605.06 53.11C604.98 53.12 605.06 53.01 604.98 52.97C605.03 52.89 604.94 52.9801 605.02 52.9501C605.1 52.9201 605.12 52.8301 605.31 52.8801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M605.06 53.2201C605.06 53.2201 604.99 53.2101 604.97 53.1901C604.93 53.1601 604.92 53.1101 604.92 53.0601C604.9 53.0501 604.89 53.0301 604.88 53.0001C604.88 52.9701 604.88 52.9301 604.89 52.9101C604.89 52.9101 604.91 52.8701 604.93 52.8501C604.96 52.8301 604.99 52.8201 605.02 52.8301C605.11 52.7601 605.23 52.7402 605.34 52.7802C605.38 52.7802 605.41 52.8201 605.42 52.8601C605.43 52.9001 605.42 52.9401 605.39 52.9701C605.35 53.0101 605.32 53.0501 605.29 53.0801C605.24 53.1501 605.17 53.2101 605.08 53.2301C605.07 53.2301 605.06 53.2301 605.05 53.2301L605.06 53.2201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M590.6 54.5201C590.75 54.6001 590.82 54.7301 590.94 54.7901C590.89 54.8401 590.79 55.1101 590.77 55.1001C590.67 55.0601 590.76 54.6401 590.67 54.5701C590.67 54.5701 590.58 54.6001 590.61 54.5201H590.6Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M590.77 55.2101C590.77 55.2101 590.74 55.2101 590.72 55.2101C590.59 55.1601 590.59 55.0101 590.59 54.8401C590.59 54.8001 590.59 54.7301 590.59 54.6901C590.56 54.6901 590.53 54.6701 590.52 54.6501C590.49 54.6101 590.48 54.5401 590.5 54.4901C590.51 54.4601 590.54 54.4401 590.57 54.4301C590.6 54.4201 590.63 54.4301 590.66 54.4301C590.74 54.4801 590.81 54.5301 590.88 54.6001C590.92 54.6401 590.96 54.6701 591 54.7001C591.03 54.7201 591.05 54.7501 591.06 54.7801C591.06 54.8201 591.06 54.8501 591.03 54.8801C591.02 54.8901 590.98 54.9701 590.96 55.0101C590.9 55.1301 590.86 55.2201 590.78 55.2201L590.77 55.2101ZM590.6 54.5201L590.7 54.5601L590.6 54.5201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.11 59.8601C492.11 59.8601 492.13 59.7701 492.16 59.7701C492.44 59.6801 492.73 59.5901 493.02 59.5001C493.02 59.5601 493.05 59.6501 493.02 59.6901C492.93 59.8501 492.78 59.9701 492.6 60.0001C492.42 60.0301 492.23 59.9701 492.1 59.8501L492.12 59.8701L492.11 59.8601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M492.52 60.1101C492.37 60.1101 492.22 60.0601 492.09 59.9701C492.06 59.9701 492.03 59.9501 492.02 59.9201V59.9001C492.02 59.9001 491.98 59.7901 492.02 59.7501L492.04 59.7301C492.04 59.7301 492.09 59.6601 492.13 59.6401C492.36 59.5601 492.59 59.4901 492.82 59.4201L492.99 59.3701C492.99 59.3701 493.06 59.3701 493.09 59.3901C493.12 59.4101 493.14 59.4401 493.14 59.4801C493.14 59.5001 493.14 59.5102 493.14 59.5302C493.16 59.6002 493.15 59.6701 493.12 59.7401C493 59.9501 492.78 60.0901 492.53 60.1001L492.52 60.1101ZM492.31 59.8401C492.52 59.9501 492.79 59.8701 492.9 59.6601H492.87C492.68 59.7301 492.5 59.7801 492.31 59.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.15 61.48L498.9 61.6401C498.87 61.5801 498.8 61.5 498.82 61.47C498.87 61.4 498.94 61.35 499.01 61.3L499.15 61.48Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M498.91 61.7602C498.91 61.7602 498.83 61.7402 498.81 61.7002C498.81 61.6802 498.79 61.6702 498.78 61.6502C498.74 61.5802 498.68 61.5002 498.73 61.4202C498.77 61.3602 498.83 61.3002 498.89 61.2602C498.91 61.2502 498.93 61.2302 498.95 61.2202C498.97 61.2002 499.01 61.1902 499.04 61.1902C499.07 61.1902 499.1 61.2102 499.12 61.2302L499.26 61.4102C499.26 61.4102 499.29 61.4702 499.28 61.5002C499.28 61.5302 499.26 61.5602 499.23 61.5802L498.98 61.7402C498.98 61.7402 498.94 61.7602 498.92 61.7602H498.91Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.85 62.6201C487.85 62.6201 487.78 62.6501 487.77 62.6401C487.75 62.6101 487.74 62.5801 487.73 62.5501L487.86 62.5201L487.84 62.6201H487.85Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.78 62.7602C487.78 62.7602 487.71 62.7502 487.69 62.7202C487.66 62.6902 487.64 62.6502 487.64 62.6102C487.64 62.5802 487.64 62.5402 487.64 62.5102C487.66 62.4802 487.68 62.4502 487.71 62.4402L487.84 62.4102C487.84 62.4102 487.92 62.4102 487.94 62.4402C487.97 62.4702 487.98 62.5002 487.98 62.5402V62.6402C487.98 62.6402 487.93 62.7202 487.88 62.7302H487.86C487.86 62.7302 487.8 62.7502 487.78 62.7602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.23 60.3001L491.15 60.2601L491.22 60.3201L491.23 60.3001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.22 60.4301C491.22 60.4301 491.17 60.4301 491.15 60.4101L491.08 60.3601C491.08 60.3601 491.02 60.2602 491.05 60.2102C491.08 60.1602 491.14 60.1401 491.19 60.1601L491.27 60.2002C491.27 60.2002 491.33 60.2502 491.34 60.2802C491.34 60.3202 491.34 60.3502 491.31 60.3802V60.4002C491.31 60.4002 491.24 60.4402 491.21 60.4402L491.22 60.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.02 62.5701L487.06 62.5001L487.01 62.5601L487.02 62.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.02 62.6801C487.02 62.6801 486.96 62.6701 486.94 62.6501H486.93C486.89 62.5901 486.88 62.52 486.93 62.48L486.99 62.42C486.99 62.42 487.09 62.37 487.14 62.41C487.19 62.44 487.2 62.5101 487.17 62.5601L487.13 62.6301C487.13 62.6301 487.08 62.6801 487.05 62.6901H487.03L487.02 62.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.01 62.5601L487.02 62.5701L487.01 62.5601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M487.02 62.6801C487.02 62.6801 486.94 62.6601 486.92 62.6201C486.89 62.5701 486.9 62.5001 486.95 62.4701C486.99 62.4301 487.05 62.4301 487.09 62.4701H487.1C487.1 62.4701 487.14 62.5601 487.13 62.6001C487.12 62.6401 487.09 62.6701 487.05 62.6801C487.05 62.6801 487.03 62.6801 487.02 62.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.71 61.5901C479.71 61.5901 479.7 61.56 479.7 61.54L479.78 61.61C479.78 61.61 479.72 61.6101 479.72 61.5901H479.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M479.77 61.72H479.75C479.7 61.72 479.65 61.6901 479.62 61.6501C479.62 61.6501 479.6 61.6001 479.59 61.5701C479.59 61.5201 479.6 61.4701 479.64 61.4501C479.68 61.4201 479.73 61.4301 479.77 61.4501L479.83 61.5001C479.83 61.5001 479.89 61.6001 479.87 61.6501C479.85 61.6901 479.82 61.72 479.77 61.72Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.93 62.2601C481.93 62.1801 482.03 62.1002 482.08 62.0302L482.3 62.1901C482.21 62.3001 482.14 62.3701 482.08 62.4501C482.03 62.3901 481.92 62.3201 481.93 62.2701V62.2601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M482.08 62.5602C482.08 62.5602 482.02 62.5502 481.99 62.5202C481.97 62.5002 481.96 62.4902 481.94 62.4702C481.88 62.4102 481.8 62.3402 481.81 62.2502C481.83 62.1602 481.87 62.0902 481.93 62.0202C481.95 62.0002 481.96 61.9802 481.98 61.9602C482 61.9302 482.02 61.9202 482.06 61.9102C482.09 61.9102 482.12 61.9102 482.15 61.9302L482.37 62.0902C482.37 62.0902 482.41 62.1402 482.42 62.1702C482.43 62.2002 482.42 62.2302 482.39 62.2602L482.17 62.5202C482.17 62.5202 482.12 62.5602 482.08 62.5602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.14 62.0601C490.16 61.9801 490.17 61.9001 490.19 61.8201L490.31 61.91L490.14 62.0601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.14 62.1801C490.14 62.1801 490.1 62.1801 490.08 62.1601C490.04 62.1401 490.02 62.0901 490.03 62.0401L490.08 61.8001C490.08 61.8001 490.11 61.7301 490.15 61.7201C490.19 61.7101 490.23 61.7201 490.26 61.7301L490.38 61.8201C490.38 61.8201 490.42 61.8701 490.43 61.9101C490.43 61.9401 490.42 61.9801 490.39 62.0001L490.22 62.1501C490.22 62.1501 490.17 62.1801 490.14 62.1801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.38 61.2701C490.38 61.2701 490.38 61.2501 490.38 61.2401L490.44 61.3001C490.44 61.3001 490.4 61.2901 490.39 61.2701H490.38Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.43 61.4102C490.43 61.4102 490.39 61.4102 490.38 61.4002C490.34 61.3902 490.31 61.3602 490.29 61.3302C490.29 61.3302 490.28 61.3002 490.27 61.2802C490.26 61.2302 490.27 61.1802 490.32 61.1502C490.36 61.1202 490.42 61.1302 490.45 61.1602L490.51 61.2102C490.51 61.2102 490.55 61.2902 490.54 61.3302C490.53 61.3702 490.48 61.4002 490.43 61.4002V61.4102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.98 63.9001C490.81 64.0101 490.48 64.1301 490.49 64.2201C490.56 64.6301 490.66 65.0301 490.79 65.4301C490.79 65.4501 490.86 65.4501 490.89 65.4601C490.92 65.1601 490.94 64.8601 490.97 64.5601C490.97 64.4901 490.97 64.4201 490.97 64.3501H491.01L490.98 63.9101V63.9001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.76 62.7901C483.86 62.7201 483.95 62.6302 484.02 62.5302C483.89 62.5102 483.73 62.4201 483.65 62.4701C483.56 62.5301 483.53 62.6801 483.48 62.8001C483.57 62.8201 483.67 62.8101 483.76 62.7901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.64 62.9302C483.64 62.9302 483.57 62.9302 483.54 62.9302C483.52 62.9302 483.49 62.9302 483.47 62.9302C483.43 62.9302 483.4 62.9102 483.38 62.8802C483.36 62.8502 483.36 62.8102 483.38 62.7702C483.39 62.7402 483.4 62.7102 483.42 62.6802C483.45 62.5602 483.51 62.4602 483.6 62.3902C483.71 62.3502 483.83 62.3502 483.94 62.4002C483.98 62.4102 484.01 62.4202 484.05 62.4302C484.09 62.4302 484.12 62.4702 484.14 62.5102C484.16 62.5502 484.14 62.5902 484.11 62.6202C484.09 62.6502 484.06 62.6702 484.04 62.7002C483.98 62.7802 483.91 62.8502 483.82 62.9002C483.77 62.9302 483.71 62.9402 483.65 62.9402L483.64 62.9302ZM483.64 62.7002C483.64 62.7002 483.69 62.7002 483.71 62.6902C483.71 62.6902 483.79 62.6302 483.82 62.5902C483.78 62.5802 483.75 62.5702 483.71 62.5702C483.68 62.6102 483.65 62.6502 483.64 62.7002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.47 62.8201V62.8C483.47 62.8 483.47 62.8 483.45 62.8V62.8201H483.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.47 62.9302C483.47 62.9302 483.41 62.9302 483.39 62.9002C483.39 62.9002 483.35 62.8102 483.36 62.7602C483.38 62.7202 483.42 62.7002 483.46 62.6902C483.5 62.6902 483.54 62.7002 483.57 62.7402C483.59 62.7702 483.6 62.8102 483.59 62.8502C483.57 62.8902 483.54 62.9102 483.5 62.9202H483.47V62.9302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.46 62.9202C483.4 62.9202 483.34 62.8702 483.34 62.8102C483.34 62.7802 483.35 62.7502 483.37 62.7302C483.39 62.7102 483.42 62.7002 483.45 62.7002C483.51 62.7002 483.56 62.7502 483.56 62.8102C483.56 62.8702 483.51 62.9202 483.45 62.9202H483.46Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M486.27 62.8401C486.25 62.7801 486.24 62.7001 486.19 62.6701C486.16 62.6501 486.08 62.6901 486.02 62.7001C486.05 62.7701 486.08 62.8501 486.11 62.9201C486.16 62.8901 486.22 62.8601 486.27 62.8301V62.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M486.12 63.0401C486.12 63.0401 486.09 63.0401 486.08 63.0401C486.05 63.0301 486.02 63.0001 486.01 62.9701L485.92 62.7501C485.92 62.7501 485.91 62.6801 485.92 62.6501C485.93 62.6201 485.96 62.6001 486 62.5901C486.01 62.5901 486.03 62.5901 486.04 62.5801C486.11 62.5501 486.18 62.5501 486.25 62.5801C486.3 62.6201 486.34 62.6801 486.35 62.7501C486.35 62.7701 486.36 62.7801 486.37 62.8001C486.39 62.8501 486.37 62.9201 486.32 62.9501L486.16 63.0401C486.16 63.0401 486.12 63.0501 486.11 63.0501L486.12 63.0401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.46 62.9202C483.4 62.9202 483.34 62.8702 483.34 62.8102C483.34 62.7802 483.35 62.7502 483.37 62.7302C483.39 62.7102 483.42 62.7002 483.45 62.7002C483.51 62.7002 483.56 62.7502 483.56 62.8102C483.56 62.8702 483.51 62.9202 483.45 62.9202H483.46Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.47 62.8201L483.46 62.8101L483.45 62.8V62.8201H483.47Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.46 62.9301C483.46 62.9301 483.44 62.9301 483.43 62.9301C483.38 62.9201 483.34 62.8701 483.34 62.8201C483.34 62.7701 483.38 62.7301 483.42 62.7101C483.46 62.6901 483.51 62.7001 483.54 62.7301C483.58 62.7701 483.58 62.8301 483.55 62.8801C483.53 62.9101 483.49 62.9301 483.46 62.9301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.45 62.8L483.46 62.8101L483.45 62.8Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.46 62.9302C483.46 62.9302 483.4 62.9202 483.37 62.8902C483.35 62.8702 483.34 62.8402 483.34 62.8102C483.34 62.7802 483.35 62.7502 483.38 62.7302C483.4 62.7102 483.43 62.7002 483.46 62.7002C483.49 62.7002 483.52 62.7102 483.54 62.7402C483.54 62.7402 483.57 62.8002 483.57 62.8202C483.57 62.8502 483.56 62.8802 483.53 62.9102C483.51 62.9302 483.48 62.9402 483.45 62.9402L483.46 62.9302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M499.4 59.8302C499.35 59.7602 499.11 59.7802 498.98 59.8302C498.7 59.9202 498.64 59.8302 498.56 59.5502L494.45 58.6802C494.57 59.1102 493.67 59.7202 493.32 60.2402C492.99 60.7302 492.52 60.2202 492.24 60.5402L492.09 59.8402V59.8602C492 59.7002 491.88 59.5502 491.79 59.3902C491.75 59.3102 491.72 59.2202 491.7 59.1302C491.63 59.2002 491.51 59.2502 491.48 59.3302C491.37 59.6602 491.3 59.9902 491.21 60.3302V60.3102C491.39 60.6802 491.21 60.8502 490.87 60.8802C490.67 60.9002 490.45 60.7802 490.25 60.8102C490.03 60.8402 489.84 60.9802 490.1 61.2102C490.03 61.3702 489.96 61.5402 489.89 61.7002C489.77 61.9502 489.84 62.0902 490.12 62.1202C490.12 62.2602 490.12 62.4002 490.12 62.5402C489.69 62.5002 489.03 62.6102 488.9 62.3902C488.59 61.8902 488.45 62.2902 488.28 62.3902C488.18 62.4502 488.18 62.7002 488.07 62.7502C487.82 62.8702 487.55 62.9502 487.28 62.9702C487.2 62.9702 487.11 62.7302 487.02 62.5802C486.52 62.6902 486.71 63.1702 486.55 63.4602C486.44 63.6402 486.27 63.7802 486.07 63.8502C485.99 63.8802 485.77 63.6902 485.7 63.5602C485.35 62.8902 484.97 62.8202 484.46 63.3702C484.34 63.5502 484.19 63.7102 484.03 63.8502C483.84 63.9402 483.63 64.0102 483.42 64.0502C483.42 63.8502 483.4 63.6502 483.41 63.4502C483.41 63.2402 483.44 63.0302 483.46 62.8202C483.25 62.7602 482.67 62.9902 483.1 62.4202C483.59 61.7702 482.68 61.5602 482.75 61.0602C482.54 61.1302 482.33 61.2102 482.11 61.2602C482 61.2802 481.89 61.2702 481.79 61.2402C481.32 61.0502 481.06 61.1002 481.19 61.7002C481.19 61.7202 480.94 61.8502 480.9 61.8202C480.73 61.6902 480.61 61.3802 480.45 61.3702C480.21 61.3602 479.81 60.9102 479.68 61.5202C479.53 61.6202 479.39 61.7802 479.24 61.8002C478.82 61.8502 478.4 61.8302 477.98 61.8402C478 61.5902 478.01 61.3402 477.99 61.1002C477.98 60.9802 477.89 60.7902 477.8 60.7702C477.64 60.7302 477.34 60.7402 477.3 60.8302C477.04 61.3702 476.22 61.7102 476.68 62.5202C476.71 62.5802 476.6 62.7602 476.51 62.8302C476.27 63.0302 475.82 62.9102 475.55 62.7002C475.33 62.6002 475.09 62.5502 474.85 62.5602C474.81 62.5602 474.7 62.7502 474.72 62.7802C475.12 63.2802 474.72 63.7602 474.66 64.2302C474.56 65.1002 474.92 65.5302 475.93 65.5602C475.91 65.9102 475.95 66.2402 476.43 66.2102C477.49 66.1402 478.32 67.0702 479.4 66.9002C479.45 66.9002 479.53 66.9502 479.57 67.0002C479.89 67.3802 480.24 67.7402 480.6 68.0802C480.94 68.3302 481.32 68.5202 481.73 68.6502C481.84 68.6902 482.04 68.4702 482.21 68.3902C482.29 68.3702 482.37 68.3902 482.43 68.4302C483.25 68.9902 484.21 69.3002 485.2 69.3202C485.48 69.3402 485.75 69.2802 485.99 69.1402C486.24 68.9802 486.42 68.7002 486.08 68.4202C486.15 68.3402 486.25 68.1802 486.3 68.1902C486.86 68.3502 487.41 68.5602 487.98 68.6902C488.44 68.8002 489.02 69.0002 489.37 68.8202C489.67 68.6702 490.14 68.5402 490.31 68.0602C490.43 67.7302 490.76 67.5802 491.09 67.9802C491.28 68.2102 491.66 68.3002 491.67 67.9402C491.68 67.1702 492.06 67.0202 492.71 67.0502C492.89 67.0502 493.06 66.9802 493.18 66.8502C493.36 66.6102 493.47 66.6702 493.71 66.7802C494.29 67.0602 494.29 67.0202 494.44 66.3602C494.48 66.2002 494.59 66.0602 494.74 65.9802C495.24 65.8502 495.63 65.4802 496.21 65.4502C497.05 65.4002 497.04 65.3202 497.17 64.3402C497.23 63.8802 497.35 63.4402 498 63.6302C498.36 63.7302 498.36 63.5202 498.28 63.2702C498.19 63.0702 498.13 62.8602 498.07 62.6402C498.06 62.5602 498.23 62.3502 498.28 62.3702C498.97 62.5502 498.73 62.1502 498.63 61.8302C498.54 61.6302 498.53 61.4002 498.6 61.1902C498.68 60.9802 498.83 60.8102 499.04 60.7202C499.24 60.6402 499.42 60.5202 499.55 60.3502C499.61 60.2302 499.51 59.9702 499.41 59.8402L499.4 59.8302ZM475.82 64.0802C475.82 64.0802 475.76 64.0602 475.76 64.0502C475.76 64.0202 475.77 63.9902 475.79 63.9602C475.81 63.9702 475.85 63.9802 475.85 63.9902C475.85 64.0202 475.84 64.0502 475.83 64.0802H475.82ZM477.13 65.1602C477.13 65.1602 477.15 65.1002 477.16 65.0702C477.19 65.1402 477.21 65.2002 477.24 65.2702C477.2 65.2402 477.17 65.2002 477.13 65.1602ZM477.72 63.9202C477.72 63.9202 477.67 63.8602 477.66 63.8202C477.69 63.8202 477.72 63.8002 477.75 63.8102C477.77 63.8102 477.78 63.8502 477.8 63.8802C477.77 63.8902 477.73 63.9302 477.73 63.9202H477.72ZM477.56 63.0102C477.47 62.7902 477.81 62.2902 478.05 62.2702C478.1 62.2702 478.21 62.3502 478.21 62.3702C478.13 62.6602 478.04 62.9502 477.92 63.3302C477.71 63.1502 477.59 63.1002 477.56 63.0102ZM478.2 65.6102C478.2 65.6102 478.11 65.5202 478.07 65.4802C478.16 65.4302 478.26 65.3802 478.35 65.3402C478.3 65.4302 478.25 65.5202 478.2 65.6202V65.6102ZM478.87 66.3502C478.87 66.3502 478.81 66.2602 478.78 66.2102C478.78 66.1902 478.83 66.1302 478.84 66.1302C478.89 66.1502 478.94 66.1702 478.98 66.2002C478.94 66.2502 478.9 66.3002 478.86 66.3502H478.87ZM481.37 65.6702C481.37 65.6702 481.42 65.6902 481.42 65.7002C481.42 65.7302 481.42 65.7602 481.4 65.7902C481.38 65.7902 481.35 65.7702 481.35 65.7602C481.35 65.7302 481.35 65.7002 481.37 65.6702ZM481.04 68.0102L480.86 67.7402H481.27C481.19 67.8202 481.12 67.9202 481.04 68.0102ZM482.16 64.5902C482.21 64.3102 482.29 64.0402 482.39 63.7802C482.45 63.6602 482.65 63.6102 482.79 63.5302C482.85 63.7102 482.88 63.8902 482.87 64.0802C482.8 64.4102 482.49 64.6302 482.16 64.5902ZM482.54 67.3502C482.54 67.3502 482.49 67.2902 482.46 67.2502C482.46 67.2402 482.5 67.2102 482.52 67.1802C482.54 67.2102 482.55 67.2302 482.57 67.2602C482.57 67.2902 482.55 67.3202 482.54 67.3502ZM483.19 67.8102C483.19 67.8102 483.14 67.7302 483.11 67.6802L483.18 67.6302L483.23 67.7102L483.19 67.8002V67.8102ZM482.8 65.8802C482.77 65.9502 482.66 65.9902 482.59 66.0402C482.57 65.9802 482.52 65.9002 482.54 65.8502C482.68 65.4402 482.58 64.8602 483.24 64.8302C483.09 65.1802 482.95 65.5302 482.79 65.8702L482.8 65.8802ZM484.49 65.3802C484.49 65.3802 484.42 65.3302 484.42 65.3202C484.44 65.2602 484.46 65.2002 484.48 65.1502C484.5 65.1702 484.55 65.2002 484.54 65.2202C484.53 65.2802 484.51 65.3302 484.48 65.3902L484.49 65.3802ZM484.91 64.4502C484.81 64.4302 484.73 64.2802 484.68 64.1702C484.67 64.1402 484.82 63.9802 484.88 63.9902C485.03 64.0402 485.17 64.1202 485.29 64.2102C485.11 64.3302 484.99 64.4602 484.91 64.4502ZM485.8 65.9602C485.8 65.9602 485.82 65.9002 485.83 65.8702C485.85 65.9402 485.87 66.0102 485.89 66.0702C485.85 66.0302 485.82 65.9902 485.79 65.9502L485.8 65.9602ZM486.25 66.5102C486.14 66.4802 486.04 66.4102 485.96 66.3302C485.92 66.2902 485.94 66.2102 485.93 66.1402C485.99 66.1302 486.06 66.1202 486.12 66.1402C486.23 66.1902 486.33 66.2402 486.43 66.3002C486.37 66.3802 486.29 66.5202 486.25 66.5102ZM486.25 65.6202C486.17 65.5202 486.25 65.3102 486.25 65.1502C486.38 65.2202 486.51 65.2902 486.63 65.3602C486.68 65.3902 486.74 65.4302 486.79 65.4602C486.66 65.6702 486.53 65.9702 486.25 65.6302V65.6202ZM487.57 64.8502C487.51 64.8202 487.43 64.8102 487.39 64.7602C487.24 64.6002 487.12 64.4202 487.03 64.2302C486.98 64.1102 487.07 63.9402 487.1 63.7902C487.21 63.8802 487.37 63.9402 487.43 64.0602C487.52 64.2702 487.58 64.4802 487.63 64.7002L487.57 64.8502ZM490.04 63.3102C490.04 63.1502 490.06 62.9902 490.07 62.8402C490.07 62.7502 490.1 62.6502 490.12 62.5602C490.19 62.6702 490.3 62.7902 490.28 62.8902C490.23 63.0402 490.14 63.1902 490.04 63.3202V63.3102ZM490.95 64.5502C490.93 64.8502 490.9 65.1502 490.87 65.4502C490.83 65.4502 490.77 65.4502 490.77 65.4202C490.64 65.0302 490.54 64.6202 490.47 64.2102C490.46 64.1202 490.79 64.0002 490.96 63.8902L490.99 64.3302H490.95C490.95 64.4002 490.95 64.4702 490.95 64.5402V64.5502ZM491.04 63.1502C491.04 63.1502 490.99 63.0702 490.97 63.0302C491 63.0202 491.04 63.0202 491.07 63.0202C491.09 63.0202 491.11 63.0702 491.12 63.0902L491.03 63.1402L491.04 63.1502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M475.76 64.0402C475.76 64.0402 475.8 64.0602 475.82 64.0702C475.83 64.0402 475.84 64.0102 475.84 63.9802C475.84 63.9702 475.8 63.9602 475.78 63.9502C475.77 63.9802 475.76 64.0102 475.75 64.0402H475.76Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M475.81 64.1801C475.81 64.1801 475.79 64.1801 475.78 64.1801C475.73 64.1601 475.65 64.1301 475.65 64.0501C475.65 64.0501 475.66 63.9801 475.67 63.9401C475.68 63.9101 475.71 63.8801 475.74 63.8601C475.77 63.8401 475.81 63.8401 475.84 63.8601C475.89 63.8801 475.96 63.9101 475.96 63.9901C475.96 64.0301 475.96 64.0601 475.94 64.1001C475.93 64.1301 475.9 64.1601 475.87 64.1801C475.85 64.1801 475.83 64.1901 475.81 64.2001V64.1801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.13 65.1501C477.13 65.1501 477.2 65.2301 477.24 65.2601C477.21 65.1901 477.19 65.1301 477.16 65.0601C477.15 65.0901 477.12 65.1301 477.13 65.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M477.24 65.3801C477.24 65.3801 477.18 65.3701 477.16 65.3501C477.12 65.3101 477.08 65.2701 477.04 65.2301C477.01 65.1801 477.01 65.1101 477.04 65.0501C477.06 65.0001 477.1 64.9701 477.15 64.9701C477.15 64.9701 477.24 64.9902 477.26 65.0302L477.34 65.2301C477.34 65.2301 477.34 65.3401 477.3 65.3701C477.28 65.3801 477.26 65.3901 477.24 65.3901V65.3801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M478.65 62.9702H478.71L478.69 62.9202L478.65 62.9702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M478.71 63.0901H478.64C478.64 63.0901 478.57 63.0501 478.55 63.0201C478.53 62.9801 478.54 62.94 478.55 62.91L478.58 62.86C478.58 62.86 478.64 62.8101 478.69 62.8101C478.73 62.8101 478.77 62.8401 478.78 62.8801L478.8 62.9301C478.8 62.9301 478.81 63.01 478.79 63.04C478.77 63.07 478.73 63.0901 478.7 63.0901H478.71Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M478.78 66.2101C478.78 66.2101 478.83 66.3101 478.87 66.3501C478.91 66.3001 478.95 66.2501 478.99 66.2001C478.95 66.1701 478.9 66.1501 478.85 66.1301C478.83 66.1301 478.78 66.1901 478.79 66.2101H478.78Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M478.87 66.4601C478.87 66.4601 478.8 66.44 478.78 66.41L478.76 66.3801C478.76 66.3801 478.7 66.3001 478.68 66.2501C478.67 66.1901 478.68 66.1301 478.73 66.0901C478.76 66.0401 478.82 66.0201 478.87 66.0301C478.92 66.0401 478.96 66.0601 479.01 66.0901L479.05 66.11C479.05 66.11 479.1 66.1501 479.11 66.1901C479.11 66.2201 479.11 66.26 479.09 66.29L478.97 66.4401C478.97 66.4401 478.92 66.48 478.88 66.48L478.87 66.4601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M480.52 66.9701L480.59 67.0302C480.59 67.0302 480.59 67.0001 480.57 66.9901C480.57 66.9801 480.53 66.9801 480.51 66.9701H480.52Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M480.58 67.1302C480.58 67.1302 480.54 67.1302 480.52 67.1102L480.45 67.0502C480.45 67.0502 480.39 66.9602 480.42 66.9102C480.44 66.8602 480.5 66.8402 480.55 66.8502C480.59 66.8502 480.64 66.8702 480.67 66.9102C480.68 66.9302 480.7 66.9502 480.7 66.9702C480.72 67.0202 480.7 67.0702 480.66 67.1102C480.64 67.1302 480.61 67.1302 480.59 67.1302H480.58Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.04 68.0101C481.12 67.9201 481.19 67.8301 481.27 67.7301H480.86L481.04 68.0101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M481.04 68.1201C481.04 68.1201 480.97 68.1001 480.95 68.0701L480.77 67.8001C480.77 67.8001 480.74 67.7201 480.77 67.6801C480.8 67.6401 480.83 67.6201 480.87 67.6201H481.28C481.28 67.6201 481.36 67.6401 481.38 67.6801C481.4 67.7201 481.39 67.7701 481.36 67.8001L481.13 68.0801C481.13 68.0801 481.08 68.1201 481.04 68.1201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M482.46 67.2502C482.46 67.2502 482.51 67.3202 482.54 67.3502C482.55 67.3202 482.56 67.2902 482.57 67.2602L482.52 67.1802C482.52 67.1802 482.46 67.2302 482.46 67.2502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M482.54 67.4601C482.54 67.4601 482.47 67.44 482.45 67.42L482.43 67.4001C482.43 67.4001 482.38 67.33 482.36 67.3C482.34 67.23 482.36 67.1601 482.42 67.1301C482.45 67.1001 482.49 67.0901 482.52 67.0901C482.56 67.0901 482.59 67.1101 482.61 67.1401L482.66 67.22C482.66 67.22 482.68 67.2801 482.67 67.3201L482.64 67.41C482.64 67.41 482.59 67.48 482.55 67.48H482.53L482.54 67.4601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.11 67.6801C483.11 67.6801 483.16 67.7701 483.19 67.8101L483.23 67.7201L483.18 67.6401L483.11 67.6901V67.6801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M483.19 67.9201C483.19 67.9201 483.11 67.9001 483.09 67.8701L483.07 67.8401C483.07 67.8401 483.03 67.7701 483.01 67.7301C482.96 67.6401 483.05 67.5801 483.09 67.5601L483.11 67.5401C483.11 67.5401 483.17 67.5101 483.2 67.5201C483.23 67.5201 483.26 67.5501 483.27 67.5801L483.32 67.6601C483.32 67.6601 483.34 67.7301 483.32 67.7601L483.28 67.8501C483.28 67.8501 483.23 67.9201 483.18 67.9201H483.17H483.19Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M484.49 65.1401C484.46 65.2001 484.44 65.2501 484.43 65.3101C484.43 65.3301 484.47 65.3501 484.5 65.3701C484.52 65.3201 484.54 65.2601 484.56 65.2001C484.56 65.1801 484.52 65.1501 484.5 65.1301L484.49 65.1401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M484.49 65.4901C484.49 65.4901 484.43 65.4801 484.41 65.4601C484.36 65.4201 484.29 65.3701 484.31 65.2901C484.32 65.2401 484.34 65.1901 484.36 65.1401L484.38 65.1001C484.38 65.1001 484.43 65.0402 484.46 65.0302C484.5 65.0302 484.54 65.0301 484.56 65.0601H484.58C484.63 65.1101 484.66 65.1701 484.66 65.2301C484.65 65.2801 484.63 65.3301 484.61 65.3801L484.59 65.4201C484.59 65.4201 484.55 65.4801 484.51 65.4901H484.49Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.81 65.9601C485.81 65.9601 485.87 66.0401 485.91 66.0801C485.89 66.0101 485.87 65.9401 485.85 65.8801C485.84 65.9101 485.81 65.9501 485.82 65.9701L485.81 65.9601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M485.9 66.1901C485.9 66.1901 485.84 66.1801 485.82 66.1501C485.78 66.1101 485.74 66.0701 485.71 66.0201C485.68 65.9601 485.69 65.9001 485.72 65.8501C485.74 65.8101 485.79 65.7801 485.84 65.7701C485.89 65.7701 485.93 65.8001 485.95 65.8401L486.01 66.0401C486.03 66.0901 486.01 66.1501 485.96 66.1701C485.94 66.1701 485.92 66.1901 485.9 66.1901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.09 62.8401C490.07 63.0001 490.07 63.1601 490.06 63.3101C490.16 63.1801 490.24 63.0401 490.3 62.8801C490.32 62.7801 490.2 62.66 490.14 62.55C490.12 62.64 490.1 62.7401 490.09 62.8301V62.8401Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.06 63.43C490.06 63.43 490.04 63.43 490.03 63.43C489.98 63.41 489.95 63.37 489.95 63.31V63.18C489.96 63.06 489.97 62.9501 489.98 62.8301C489.98 62.7501 490 62.6701 490.02 62.5901V62.54C490.02 62.54 490.08 62.4601 490.12 62.4501C490.16 62.4401 490.21 62.46 490.24 62.5C490.26 62.53 490.28 62.5601 490.29 62.5801C490.37 62.6701 490.41 62.7801 490.41 62.9001C490.38 63.0301 490.32 63.15 490.24 63.25C490.21 63.29 490.18 63.33 490.16 63.37C490.14 63.4 490.1 63.43 490.06 63.43Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M490.98 63.04C490.98 63.04 491.03 63.12 491.05 63.16L491.14 63.11C491.14 63.11 491.11 63.04 491.09 63.04C491.06 63.04 491.02 63.04 490.99 63.05L490.98 63.04Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M491.05 63.2701C491.05 63.2701 491.03 63.2701 491.02 63.2701C490.99 63.2701 490.96 63.24 490.95 63.22L490.88 63.1C490.88 63.1 490.86 63.03 490.88 62.99C490.9 62.96 490.93 62.93 490.97 62.93H490.99C490.99 62.93 491.08 62.91 491.12 62.93C491.17 62.95 491.2 62.9901 491.22 63.0301C491.24 63.0601 491.25 63.09 491.24 63.13C491.24 63.16 491.22 63.1901 491.19 63.2101L491.1 63.26C491.1 63.26 491.06 63.2801 491.04 63.2801L491.05 63.2701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.9 64.86L494.94 64.8701L494.93 64.8101L494.9 64.86Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.94 64.9801H494.87C494.87 64.9801 494.8 64.9401 494.79 64.9001C494.78 64.8601 494.78 64.8201 494.8 64.7901L494.83 64.7401C494.83 64.7401 494.9 64.6801 494.95 64.6901C494.99 64.6901 495.03 64.7301 495.04 64.7801V64.8401C495.04 64.8401 495.05 64.9101 495.04 64.9401C495.02 64.9701 494.99 64.9801 494.95 64.9801H494.94Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.85 58.2701C494.79 58.2701 494.73 58.2 494.67 58.16C494.73 58.13 494.8 58.0701 494.86 58.0701C494.92 58.0701 494.97 58.14 495.03 58.17C494.97 58.2 494.91 58.2701 494.85 58.2701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M494.86 58.3901C494.79 58.3901 494.72 58.3501 494.67 58.3001C494.66 58.2901 494.64 58.2801 494.63 58.2701C494.6 58.2501 494.58 58.2101 494.58 58.1701C494.58 58.1301 494.61 58.0901 494.64 58.0701C494.66 58.0701 494.67 58.0501 494.69 58.0401C494.75 58.0001 494.81 57.9701 494.88 57.9701C494.95 57.9701 495.02 58.0101 495.07 58.0601C495.08 58.0701 495.1 58.0801 495.11 58.0901C495.14 58.1101 495.16 58.1501 495.16 58.1901C495.16 58.2301 495.14 58.2701 495.1 58.2901C495.08 58.2901 495.07 58.3101 495.05 58.3201C495 58.3701 494.93 58.3901 494.86 58.4001V58.3901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M615.05 28.4901L615.15 28.5901C615.15 28.5901 615.1 28.5801 615.1 28.5601C615.09 28.5301 615.08 28.5001 615.08 28.4701L615.06 28.4901H615.05Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M615.2 21.0302C614.64 21.5102 615 21.5101 615.31 21.6801L615.2 21.0302Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.8 17.7102C614.3 17.9902 613.83 18.3202 613.4 18.6902C613.36 18.7502 613.33 18.8202 613.34 18.8902C613.43 18.9402 613.55 19.0002 613.62 18.9702C614.01 18.7802 614.4 18.5802 614.78 18.3502C614.9 18.2802 614.95 18.0602 615.07 18.0002", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.1 16.2701L613.31 15.8701L613.29 15.8501L613.77 16.1001L613.75 16.0801C613.81 16.5801 614.12 16.8101 614.55 16.6101", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.94 17.3001C613.17 17.1501 613.63 17.4301 613.63 16.9601C613.63 16.9401 613.53 16.9101 613.4 16.8901C613.27 16.8701 613.15 16.7801 613.09 16.6601C613.03 16.5401 613.03 16.3901 613.09 16.2701", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.1 33.5602L614.02 33.6402L614.08 33.5402C614.08 33.5402 614.13 33.5102 614.16 33.4902C614.17 33.4802 614.18 33.4602 614.19 33.4402L614.11 33.5602H614.1Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M615.35 18.54L614.8 19.0201C614.91 19.1101 615.07 19.2901 615.12 19.2601", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.63 34.7002C614.43 34.5602 614.22 34.4402 613.99 34.3402C613.94 34.3302 613.82 34.5402 613.74 34.6502C613.87 34.7702 614.02 34.8602 614.18 34.9302C614.27 34.9502 614.4 34.8202 614.63 34.7002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M614.25 24.0901L614.2 23.8301C614.05 23.9101 613.91 24.0101 613.79 24.1201C613.76 24.1501 613.85 24.3001 613.88 24.3901L614.25 24.0901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M615.02 20.1301C614.89 20.1301 614.79 20.1101 614.69 20.1101C614.68 20.1501 614.67 20.2001 614.67 20.2401C614.73 20.2601 614.8 20.2701 614.87 20.2701C614.91 20.2701 614.94 20.2001 615.01 20.1301H615.02Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.29 27.6201C613.29 27.6201 613.26 27.5701 613.24 27.5601C613.21 27.5601 613.18 27.5601 613.14 27.5601C613.16 27.5901 613.18 27.6301 613.2 27.6501C613.21 27.6501 613.25 27.63 613.28 27.61L613.29 27.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M613.87 17.6201C613.87 17.6201 613.82 17.55 613.8 17.55C613.74 17.56 613.68 17.58 613.62 17.61C613.64 17.64 613.67 17.6901 613.69 17.6801C613.75 17.6701 613.82 17.6501 613.88 17.6201H613.87Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M612.61 23.1702L612.66 23.2102L612.67 23.1602L612.61 23.1702Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M551.5 34.37C551.72 34.15 552.06 33.95 551.58 33.66C552.2 33.22 551.49 32.5101 551.92 32.0301C551.98 31.9001 552.09 31.7801 552.08 31.6501C552.08 31.5601 551.93 31.4801 551.84 31.3901C551.8 31.4801 551.72 31.58 551.74 31.66C551.79 31.79 551.86 31.92 551.94 32.04C551.68 32.1 551.42 32.1201 551.15 32.0901C550.94 32.0301 550.76 31.88 550.67 31.67C550.63 31.55 550.83 31.29 550.99 31.18C551.68 30.73 551.69 30.7401 551.19 30.0701C551.1 29.9501 551.02 29.82 550.95 29.69C550.75 29.31 550.59 28.96 551.27 28.92C551.49 28.88 551.7 28.8 551.89 28.69C552.01 28.63 552.21 28.4901 552.19 28.4601C552.09 28.2501 552.07 28.01 552.15 27.79C552.23 27.57 552.39 27.39 552.6 27.3C552.63 27.28 552.6 27.17 552.6 27.11L552.07 27.18L552.09 27.2001C551.92 26.9001 551.77 26.6001 551.65 26.2801C551.48 25.7501 551.63 25.5 552.24 25.35C552.56 25.27 552.7 25.1401 552.73 24.8301C552.73 24.7601 552.85 24.7001 552.91 24.6301C552.98 24.7201 553.11 24.8101 553.1 24.8901C553.06 25.1401 553.01 25.3801 552.95 25.6301C552.93 25.7201 552.9 25.88 552.94 25.91C553.04 25.97 553.15 25.9801 553.26 25.9501C553.41 25.9101 553.54 25.83 553.63 25.72C554.1 25.05 555.1 25.1001 555.49 24.3201C555.52 24.2601 555.87 24.27 555.98 24.36C556.07 24.44 556.07 24.69 556.04 24.85C555.97 25.16 555.85 25.4701 555.75 25.7701C555.55 25.6801 555.34 25.6001 555.13 25.5301C555.01 25.4901 554.87 25.49 554.75 25.55C554.52 25.86 554.56 26.29 554.85 26.55C555.22 26.76 555.28 26.4001 555.42 26.2101C555.53 26.0601 555.63 25.9 555.74 25.75C555.89 25.87 556.03 26.0001 556.16 26.1501C556.22 26.2601 556.27 26.3901 556.29 26.5201C556.4 26.4401 556.5 26.34 556.59 26.23C556.66 26.08 556.72 25.9301 556.76 25.7701C556.85 25.9001 557 26.03 557.02 26.17C557.11 26.84 557.5 28.87 557.86 28.68L557.84 28.66C558.09 29.39 557.53 27.57 557.15 28.05L557.17 28.0301C557.06 28.1801 556.95 28.3401 556.87 28.5101C556.82 28.6701 556.79 28.8401 556.77 29.0201C556.89 28.9501 557.01 28.9101 557.15 28.8801C557.33 28.8801 557.09 31.1601 557.27 31.2001C557.36 31.2401 557.45 31.29 557.52 31.35C557.47 31.4 557.41 31.45 557.36 31.5C557.21 31.62 557.47 29.47 557.33 29.6C557.27 29.67 557.21 29.7501 557.17 29.8301C557.28 29.8301 556.98 32.57 557.09 32.55C557.27 32.5 557.44 31.98 557.61 31.91C557.94 31.78 558.68 31.81 558.77 32.19", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M551.5 34.4802C551.5 34.4802 551.44 34.4702 551.42 34.4502C551.38 34.4102 551.38 34.3302 551.42 34.2902C551.45 34.2602 551.49 34.2302 551.52 34.1902C551.61 34.1102 551.72 34.0102 551.71 33.9402C551.71 33.9202 551.68 33.8502 551.52 33.7502C551.49 33.7302 551.47 33.6902 551.47 33.6602C551.47 33.6202 551.49 33.5902 551.52 33.5602C551.78 33.3702 551.76 33.1502 551.7 32.8002C551.65 32.6002 551.65 32.3902 551.7 32.1902C551.51 32.2302 551.32 32.2402 551.13 32.2102C550.88 32.1402 550.67 31.9602 550.57 31.7202C550.51 31.5202 550.78 31.2102 550.94 31.1002L550.98 31.0802C551.25 30.9002 551.42 30.7902 551.44 30.7002C551.46 30.6102 551.32 30.4302 551.12 30.1602C551.02 30.0302 550.94 29.9002 550.86 29.7602C550.72 29.4902 550.61 29.2602 550.72 29.0602C550.8 28.9202 550.98 28.8402 551.27 28.8202C551.44 28.7902 551.6 28.7302 551.75 28.6502L551.85 28.6002C551.93 28.5602 552 28.5102 552.07 28.4502C551.88 28.0002 552.07 27.4802 552.5 27.2502L552.17 27.2902C552.17 27.2902 552.06 27.3202 552.02 27.2902C552.01 27.2802 551.99 27.2602 551.99 27.2402C551.95 27.1502 551.9 27.0702 551.85 26.9802C551.73 26.7702 551.63 26.5502 551.55 26.3202C551.45 26.1002 551.46 25.8602 551.55 25.6402C551.71 25.4202 551.95 25.2802 552.22 25.2502C552.5 25.1802 552.6 25.0802 552.62 24.8302C552.64 24.7402 552.7 24.6602 552.77 24.6202C552.79 24.6002 552.81 24.5902 552.83 24.5702C552.85 24.5502 552.89 24.5402 552.92 24.5402C552.95 24.5402 552.98 24.5602 553 24.5802C553.02 24.6102 553.04 24.6302 553.07 24.6502C553.15 24.7102 553.21 24.8102 553.22 24.9202C553.2 25.0902 553.17 25.2502 553.13 25.4202C553.11 25.5002 553.09 25.5902 553.07 25.6702C553.07 25.7202 553.05 25.8002 553.04 25.8402C553.1 25.8602 553.17 25.8702 553.23 25.8602C553.35 25.8302 553.46 25.7602 553.55 25.6702C553.79 25.3702 554.11 25.1402 554.48 25.0102C554.86 24.8802 555.19 24.6202 555.41 24.2802C555.44 24.2302 555.49 24.2002 555.55 24.1902C555.73 24.1602 555.92 24.1902 556.07 24.2802C556.22 24.4102 556.2 24.7302 556.17 24.8802C556.12 25.1102 556.05 25.3302 555.97 25.5502C555.95 25.6102 555.93 25.6802 555.91 25.7402L555.97 25.7902C556.08 25.8802 556.19 25.9802 556.28 26.0902C556.33 26.1602 556.37 26.2402 556.38 26.3202C556.43 26.2802 556.48 26.2302 556.52 26.1702C556.57 26.0802 556.61 25.9802 556.63 25.8802C556.64 25.8302 556.66 25.7802 556.68 25.7302C556.69 25.6902 556.73 25.6602 556.77 25.6502C556.81 25.6502 556.86 25.6602 556.88 25.7002C556.91 25.7402 556.94 25.7802 556.97 25.8202C557.06 25.9102 557.13 26.0302 557.16 26.1502C557.24 26.7602 557.37 27.3602 557.54 27.9502C557.71 28.1302 557.85 28.3402 557.94 28.5702C557.94 28.5702 557.98 28.6302 557.98 28.6602C558.01 28.7402 558.02 28.7802 558.03 28.7902C558.05 28.8302 558.04 28.8702 558.01 28.9102C557.98 28.9402 557.94 28.9602 557.9 28.9502C557.86 28.9502 557.82 28.9102 557.81 28.8702C557.81 28.8402 557.79 28.8202 557.78 28.7902C557.76 28.7902 557.74 28.7802 557.72 28.7702C557.52 28.5902 557.38 28.3502 557.33 28.0802H557.31C557.3 28.0802 557.28 28.0802 557.27 28.0902C557.24 28.1402 557.2 28.1902 557.17 28.2402C557.1 28.3402 557.03 28.4402 556.98 28.5502C556.95 28.6402 556.93 28.7302 556.92 28.8202C556.99 28.7802 557.07 28.7602 557.15 28.7602C557.19 28.7602 557.22 28.7702 557.25 28.8002C557.32 28.8702 557.34 29.0302 557.34 29.4702C557.36 29.4702 557.38 29.4702 557.4 29.4802C557.51 29.5302 557.51 29.6402 557.46 30.5202C557.45 30.7102 557.44 30.9502 557.43 31.1302C557.46 31.1502 557.49 31.1702 557.52 31.1902C557.54 31.2102 557.57 31.2202 557.59 31.2402C557.62 31.2602 557.64 31.2902 557.64 31.3302C557.64 31.3702 557.64 31.4002 557.6 31.4302L557.55 31.4702C557.55 31.4702 557.47 31.5502 557.43 31.5802C557.39 31.6102 557.34 31.6102 557.29 31.5902C557.25 31.5702 557.23 31.5402 557.22 31.5002C557.2 31.7902 557.18 32.0802 557.18 32.2802C557.21 32.2302 557.24 32.1802 557.26 32.1502C557.36 31.9902 557.45 31.8402 557.57 31.7902C557.91 31.6702 558.28 31.6902 558.61 31.8302C558.74 31.8902 558.84 32.0102 558.88 32.1502C558.89 32.1902 558.88 32.2402 558.85 32.2702C558.82 32.3002 558.77 32.3102 558.73 32.3002C558.69 32.2902 558.66 32.2502 558.65 32.2102C558.63 32.1302 558.57 32.0702 558.5 32.0402C558.23 31.9302 557.93 31.9202 557.65 32.0102C557.57 32.0902 557.5 32.1802 557.46 32.2802C557.36 32.4602 557.26 32.6302 557.12 32.6602C557.08 32.6602 557.04 32.6602 557.01 32.6402C556.94 32.5802 556.93 32.5302 557.01 31.2502C557.05 30.7402 557.09 30.0502 557.07 29.9002C557.05 29.8502 557.06 29.8102 557.07 29.7702C557.08 29.7502 557.09 29.7302 557.1 29.7202C557.1 29.4902 557.1 29.2502 557.09 29.0202C557.04 29.0402 556.99 29.0602 556.94 29.0802C556.9 29.1002 556.86 29.1202 556.82 29.1402C556.78 29.1602 556.74 29.1402 556.71 29.1202C556.68 29.0902 556.66 29.0502 556.67 29.0102C556.67 28.9602 556.69 28.9102 556.69 28.8602C556.7 28.7302 556.73 28.6002 556.77 28.4802C556.83 28.3502 556.9 28.2302 556.99 28.1202C557.01 28.0902 557.04 28.0602 557.06 28.0202C557.06 28.0102 557.06 28.0002 557.08 27.9902C557.13 27.9302 557.19 27.8802 557.27 27.8702C557.12 27.3202 557.01 26.7602 556.93 26.2002C556.91 26.1302 556.88 26.0702 556.83 26.0202C556.8 26.1202 556.76 26.2102 556.71 26.3002C556.65 26.3902 556.57 26.4702 556.48 26.5402C556.45 26.5702 556.42 26.5902 556.39 26.6202C556.36 26.6502 556.32 26.6602 556.28 26.6502C556.24 26.6502 556.21 26.6102 556.2 26.5802C556.19 26.5402 556.18 26.5002 556.16 26.4502C556.15 26.3802 556.12 26.3102 556.08 26.2502C556 26.1502 555.9 26.0602 555.8 25.9802L555.77 25.9502L555.74 25.9902C555.67 26.1002 555.6 26.2002 555.52 26.3102C555.49 26.3502 555.47 26.3902 555.44 26.4402C555.39 26.5802 555.28 26.6902 555.14 26.7502C555.02 26.7802 554.9 26.7502 554.8 26.6802C554.63 26.5602 554.52 26.3602 554.51 26.1502C554.47 25.9202 554.53 25.6802 554.68 25.5002C554.83 25.4102 555 25.3902 555.17 25.4502C555.33 25.5002 555.48 25.5502 555.63 25.6202L555.7 25.6502C555.72 25.6002 555.74 25.5502 555.75 25.5002C555.83 25.2902 555.89 25.0702 555.94 24.8602C555.98 24.7402 555.97 24.6002 555.92 24.4802C555.82 24.4402 555.7 24.4202 555.59 24.4402C555.35 24.8202 554.99 25.1002 554.57 25.2402C554.24 25.3602 553.95 25.5602 553.73 25.8302C553.62 25.9602 553.47 26.0602 553.3 26.1102C553.16 26.1502 553.01 26.1302 552.88 26.0602C552.77 26.0002 552.8 25.8502 552.84 25.6802C552.86 25.5802 552.88 25.4902 552.9 25.4002C552.94 25.2502 552.97 25.0902 552.99 24.9402C552.96 24.9102 552.94 24.8802 552.91 24.8502C552.91 24.8502 552.87 24.8802 552.85 24.9002C552.82 25.2402 552.66 25.4102 552.28 25.5102C551.99 25.5802 551.82 25.6702 551.75 25.7902C551.69 25.9502 551.69 26.1302 551.77 26.2902C551.85 26.5002 551.94 26.7102 552.06 26.9102C552.1 26.9802 552.13 27.0402 552.17 27.1102L552.61 27.0502C552.61 27.0502 552.67 27.0502 552.7 27.0802C552.72 27.1002 552.74 27.1302 552.74 27.1602C552.74 27.1802 552.74 27.2002 552.74 27.2202C552.74 27.3002 552.76 27.4002 552.68 27.4502C552.24 27.7502 552.13 28.0502 552.31 28.4702C552.38 28.6402 552 28.8302 551.95 28.8502L551.85 28.9002C551.68 29.0002 551.49 29.0702 551.29 29.1002C551.09 29.1102 550.96 29.1602 550.92 29.2202C550.86 29.3202 550.99 29.5602 551.06 29.7002C551.13 29.8302 551.21 29.9502 551.3 30.0702C551.56 30.4302 551.7 30.6102 551.66 30.7902C551.63 30.9702 551.45 31.0902 551.1 31.3202L551.06 31.3402C550.93 31.4302 550.83 31.5502 550.79 31.7002C550.87 31.8602 551.01 31.9802 551.19 32.0402C551.36 32.0602 551.53 32.0602 551.69 32.0202H551.76C551.71 31.9302 551.66 31.8402 551.64 31.7502C551.63 31.6602 551.65 31.5602 551.71 31.4902C551.72 31.4702 551.74 31.4402 551.75 31.4202C551.76 31.3802 551.8 31.3602 551.83 31.3502C551.87 31.3502 551.91 31.3502 551.93 31.3802C551.96 31.4002 551.98 31.4302 552.01 31.4502C552.1 31.5202 552.2 31.6002 552.2 31.7102C552.2 31.8302 552.15 31.9402 552.08 32.0402L552.05 32.0902C552.05 32.0902 552.05 32.1502 552.03 32.1802C552.01 32.2102 551.99 32.2202 551.96 32.2302C551.87 32.4202 551.85 32.6402 551.92 32.8502C552.02 33.1502 551.96 33.4802 551.77 33.7302C551.86 33.7902 551.93 33.8902 551.94 34.0102C551.96 34.1902 551.81 34.3202 551.68 34.4502C551.65 34.4802 551.62 34.5102 551.59 34.5402C551.57 34.5602 551.54 34.5702 551.51 34.5702L551.5 34.4802ZM551.87 31.5702C551.87 31.5702 551.85 31.6102 551.85 31.6302C551.87 31.6802 551.89 31.7302 551.92 31.7802C551.95 31.7402 551.96 31.6902 551.97 31.6502C551.94 31.6202 551.91 31.6002 551.88 31.5702H551.87ZM554.93 25.6102C554.93 25.6102 554.86 25.6102 554.83 25.6302C554.73 25.7602 554.69 25.9302 554.72 26.0902C554.72 26.2302 554.79 26.3602 554.9 26.4502C554.95 26.4802 555.01 26.5002 555.07 26.4902C555.13 26.4702 555.18 26.3802 555.23 26.2902C555.26 26.2402 555.29 26.1902 555.32 26.1402C555.39 26.0402 555.46 25.9402 555.53 25.8302L555.55 25.8002H555.52C555.38 25.7202 555.24 25.6702 555.1 25.6302C555.05 25.6202 554.99 25.6102 554.94 25.6102H554.93Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M539.47 21.5801C539.47 21.5001 539.51 21.4201 539.58 21.3701C539.98 21.1801 538.63 22.1401 538.69 21.7901C538.75 21.4001 538.03 21.1801 537.73 21.4101C537.38 21.6801 538.83 20.4201 538.4 20.3901C538.28 20.3801 538.15 20.5001 538.03 20.5801C537.65 20.8401 537.28 21.0501 536.85 20.6601C536.64 20.4701 537.28 20.4001 536.98 20.5101C536.89 20.5401 536.73 20.4201 536.61 20.3501C536.57 20.3301 536.56 20.2401 536.53 20.1901C536.59 20.1701 535.74 19.2301 535.8 19.2301C536.01 19.2301 536.22 19.2501 536.44 19.2801C538.59 19.5401 537.51 21.3401 536.81 18.8301C536.91 18.8501 537.02 18.8501 537.12 18.8301C537.2 18.8001 537.26 18.7101 537.31 18.6301C537.32 18.6101 537.28 18.5201 537.27 18.5301C537.18 18.5301 537.09 18.5501 537 18.5901C536.93 18.6601 536.87 18.7501 536.82 18.8401C536.68 18.8001 536.54 18.7501 536.4 18.6901C536.31 18.6101 536.22 18.5301 536.15 18.4301C536.24 18.3901 536.34 18.3601 536.42 18.3201C536.82 18.1201 536.32 17.9301 536.72 17.7301C536.93 17.6301 536.97 17.5101 536.75 17.3701C536.45 17.1801 536.57 17.0601 536.82 16.9301C537.2 16.7301 537.55 16.4801 537.93 16.3201C538.32 16.1701 538.73 16.0501 539.14 15.9701C539.21 15.9501 539.31 16.0901 539.4 16.1601C539.31 16.2201 539.23 16.3201 539.13 16.3401C539.01 16.3701 538.87 16.3001 538.75 16.3401C538.65 16.3701 538.51 16.4601 538.5 16.5401C538.5 16.6501 538.57 16.7601 538.67 16.8201C538.99 17.0201 539.34 16.2901 539.66 16.4801C539.82 16.5801 539.97 16.7001 540.11 16.8101C540.16 16.6401 540.15 17.3101 540.27 17.2101C540.58 16.9401 540.78 16.5601 540.83 16.1501C540.85 16.0401 541.13 15.9901 541.28 15.8901C541.52 15.7201 541.52 16.0301 541.65 16.0601C541.83 16.0601 541.99 16.1601 542.09 16.3201C542.18 16.4701 542.2 16.6601 542.12 16.8301C542.12 16.8501 542.24 16.9501 542.29 16.9501C542.37 16.9501 542.43 16.8601 542.51 16.8401C542.65 16.7901 542.79 16.7701 542.93 16.7801C542.98 16.7901 542.98 17.0101 543.01 17.1301C543.02 17.1901 543.05 17.2501 543.08 17.3101C543.31 17.6301 543.17 17.7001 542.85 17.6801C542.74 17.6801 542.64 17.6801 542.54 17.7201C542.41 17.7801 542.28 17.8601 542.16 17.9401C542.26 18.0001 542.36 18.0701 542.47 18.1301C543.16 18.5301 543.44 19.3901 543.1 20.1201C543.04 20.1801 542.95 20.2001 542.87 20.1801C542.35 19.8301 541.89 20.2801 541.41 20.3101C541.36 20.3101 541.28 20.4401 541.29 20.5101C541.31 20.6001 541.37 20.6801 541.44 20.7401C541.54 20.8301 541.69 20.8801 541.77 20.9801C541.83 21.0601 541.82 21.1901 541.84 21.3001C541.7 21.3101 541.52 21.3801 541.44 21.3201C541.29 21.1801 541.15 21.0201 541.02 20.8501C540.99 20.8201 540.85 20.8201 540.85 20.8301C540.76 21.3301 540.3 21.3701 539.96 21.5601C539.89 21.6001 539.81 21.6401 539.73 21.6701L539.47 21.5801ZM541.11 17.1301L541.32 17.4901C541.4 17.4201 541.56 17.3201 541.54 17.2901C541.47 17.1101 541.38 16.9401 541.28 16.7801L541.11 17.1401V17.1301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M538.74 22.0501C538.74 22.0501 538.68 22.0502 538.65 22.0302C538.55 21.9902 538.49 21.8801 538.51 21.7701C538.52 21.6901 538.43 21.6202 538.38 21.5902C538.22 21.4902 538.01 21.4701 537.84 21.5601C537.79 21.5901 537.65 21.7001 537.54 21.5701C537.43 21.4401 537.53 21.3401 537.67 21.1901C537.83 21.0301 537.97 20.8901 538.07 20.7701C537.7 21.1301 537.12 21.1401 536.73 20.7901C536.66 20.7401 536.62 20.6601 536.62 20.5701L536.58 20.5401L536.52 20.5001C536.45 20.4501 536.4 20.3801 536.38 20.2901C536.38 20.2701 536.37 20.2501 536.36 20.2301C536.32 20.1601 536.11 19.9101 535.97 19.7501C535.58 19.2801 535.57 19.2701 535.63 19.1501C535.67 19.0901 535.73 19.0501 535.8 19.0501C536.02 19.0501 536.23 19.0701 536.45 19.1001C536.54 19.1101 536.63 19.1301 536.71 19.1401C536.69 19.0901 536.68 19.0401 536.66 18.9801H536.64C536.52 18.9401 536.41 18.9001 536.31 18.8501C536.22 18.7901 536.15 18.7201 536.08 18.6301C536.06 18.6001 536.04 18.5801 536.02 18.5501C535.98 18.5101 535.96 18.4501 535.98 18.3901C535.99 18.3301 536.03 18.2901 536.09 18.2601L536.18 18.2301C536.24 18.2101 536.3 18.1901 536.35 18.1601C536.38 18.1501 536.4 18.1301 536.42 18.1101C536.42 18.1101 536.41 18.0801 536.41 18.0701C536.37 17.9701 536.38 17.8601 536.43 17.7701C536.48 17.6801 536.56 17.6001 536.66 17.5701C536.68 17.5701 536.69 17.5501 536.71 17.5401L536.68 17.5201C536.53 17.4501 536.44 17.3101 536.42 17.1501C536.43 16.9501 536.64 16.8402 536.76 16.7802C536.91 16.7002 537.05 16.6202 537.19 16.5302C537.41 16.3902 537.65 16.2601 537.89 16.1601C538.28 16.0101 538.68 15.8901 539.09 15.8101C539.23 15.7901 539.38 15.8401 539.47 15.9601C539.49 15.9801 539.52 16.0101 539.54 16.0201C539.62 16.0801 539.63 16.1901 539.58 16.2701C539.65 16.2701 539.72 16.2901 539.79 16.3301C539.91 16.4001 540.02 16.4801 540.13 16.5701L540.18 16.6101C540.33 16.6201 540.35 16.7501 540.37 16.8901C540.54 16.6701 540.65 16.4001 540.69 16.1201C540.72 15.9601 540.88 15.8901 541.04 15.8301C541.1 15.8101 541.16 15.7801 541.21 15.7501C541.29 15.6901 541.39 15.6601 541.49 15.6701C541.59 15.7001 541.68 15.7701 541.72 15.8601C541.72 15.8801 541.74 15.8901 541.75 15.9101C541.97 15.9401 542.16 16.0601 542.28 16.2501C542.36 16.4001 542.39 16.5701 542.36 16.7401C542.4 16.7101 542.45 16.6801 542.51 16.6701H542.56C542.71 16.6001 542.87 16.5901 543.02 16.6101C543.17 16.6401 543.2 16.8001 543.22 16.9601C543.22 17.0001 543.23 17.0502 543.24 17.0902C543.24 17.1302 543.26 17.1701 543.28 17.2001C543.34 17.2801 543.5 17.5001 543.4 17.6901C543.3 17.8801 543.02 17.8601 542.9 17.8501C542.82 17.8501 542.74 17.8501 542.67 17.8801C542.63 17.9001 542.6 17.9101 542.56 17.9301C542.58 17.9401 542.6 17.9501 542.62 17.9701C543.39 18.4201 543.7 19.3801 543.32 20.1901C543.27 20.2701 543.2 20.3202 543.11 20.3402C543.02 20.3702 542.92 20.3601 542.83 20.3201C542.58 20.1501 542.36 20.2202 542.02 20.3402C541.86 20.4002 541.7 20.4501 541.53 20.4801C541.53 20.4801 541.53 20.5001 541.52 20.5101C541.52 20.5001 541.55 20.5501 541.61 20.6001C541.65 20.6301 541.69 20.6601 541.73 20.6801C541.82 20.7301 541.9 20.7901 541.97 20.8701C542.03 20.9601 542.06 21.0701 542.06 21.1801C542.06 21.2101 542.06 21.2401 542.07 21.2701C542.07 21.3201 542.07 21.3701 542.04 21.4101C542.01 21.4501 541.96 21.4801 541.91 21.4801C541.87 21.4801 541.83 21.4901 541.79 21.5001C541.66 21.5501 541.51 21.5401 541.38 21.4701C541.26 21.3801 541.16 21.2701 541.08 21.1501C541.06 21.1201 541.04 21.0901 541.02 21.0701C540.88 21.3301 540.64 21.5201 540.36 21.6101C540.27 21.6401 540.19 21.6801 540.11 21.7301C540.03 21.7801 539.95 21.8201 539.86 21.8501C539.82 21.8701 539.77 21.8701 539.72 21.8501C539.68 21.8301 539.64 21.8001 539.62 21.7501C539.62 21.7401 539.62 21.7301 539.61 21.7201C539.57 21.7501 539.53 21.7601 539.49 21.7701C539.48 21.7701 539.46 21.7701 539.45 21.7701C539.25 21.9201 539.01 22.0201 538.76 22.0701L538.74 22.0501ZM538.2 21.1601C538.33 21.1801 538.45 21.2202 538.56 21.2802C538.71 21.3602 538.82 21.5001 538.86 21.6601C539.03 21.5801 539.19 21.4801 539.34 21.3801C539.37 21.3101 539.43 21.2501 539.5 21.2101C539.55 21.1801 539.69 21.1201 539.79 21.2301C539.84 21.2901 539.84 21.3801 539.8 21.4501C539.83 21.4301 539.87 21.4201 539.9 21.4001C539.99 21.3501 540.09 21.3001 540.19 21.2601C540.48 21.1401 540.65 21.0501 540.7 20.7901C540.71 20.7201 540.76 20.6701 540.82 20.6501C540.94 20.6201 541.07 20.6501 541.17 20.7201C541.23 20.7801 541.28 20.8501 541.33 20.9201C541.39 21.0101 541.47 21.1001 541.56 21.1701C541.59 21.1601 541.63 21.1501 541.66 21.1501C541.66 21.1301 541.66 21.1001 541.65 21.0801C541.61 21.0401 541.57 21.0101 541.52 20.9801C541.46 20.9501 541.4 20.9101 541.35 20.8701C541.24 20.7901 541.17 20.6702 541.14 20.5302C541.14 20.4202 541.17 20.3201 541.24 20.2401C541.28 20.1801 541.35 20.1401 541.43 20.1301C541.58 20.1101 541.73 20.0701 541.88 20.0101C542.22 19.8301 542.63 19.8301 542.98 20.0101H543C543.27 19.3701 543.02 18.6301 542.42 18.2901C542.35 18.2501 542.27 18.2001 542.2 18.1501L542.11 18.0902C542.06 18.0602 542.02 18.0001 542.02 17.9401C542.02 17.8801 542.05 17.8201 542.11 17.7901L542.22 17.7201C542.31 17.6601 542.41 17.6001 542.51 17.5601C542.64 17.5101 542.77 17.4901 542.9 17.5001C542.94 17.5001 542.99 17.5001 543.03 17.5001C543.01 17.4701 542.99 17.4401 542.97 17.4101C542.92 17.3401 542.89 17.2601 542.87 17.1701C542.86 17.1101 542.85 17.0601 542.84 17.0001V16.9501C542.76 16.9601 542.7 16.9801 542.63 17.0001H542.58C542.58 17.0001 542.55 17.0301 542.53 17.0401C542.47 17.0901 542.4 17.1201 542.32 17.1301C542.2 17.1301 542.08 17.0601 542.01 16.9701C541.97 16.9201 541.96 16.8501 541.97 16.7901C542.02 16.6801 542.01 16.5501 541.97 16.4301C541.89 16.3301 541.77 16.2601 541.64 16.2401C541.54 16.2101 541.46 16.1401 541.42 16.0501C541.34 16.0901 541.26 16.1201 541.18 16.1601C541.13 16.1801 541.09 16.2001 541.04 16.2201C540.98 16.6601 540.76 17.0601 540.42 17.3501C540.36 17.4001 540.28 17.4101 540.21 17.3901C540.07 17.3401 540.04 17.1701 540.02 16.9601V16.9401C540.02 16.9401 539.94 16.8801 539.9 16.8501C539.81 16.7701 539.71 16.7001 539.6 16.6401C539.55 16.6101 539.44 16.6901 539.31 16.8001C539.13 16.9501 538.88 17.1501 538.61 16.9801C538.45 16.8801 538.35 16.7101 538.36 16.5201C538.37 16.4501 538.41 16.3901 538.45 16.3501C538.31 16.3901 538.17 16.4401 538.03 16.5001C537.81 16.6001 537.59 16.7201 537.38 16.8501C537.23 16.9401 537.08 17.0301 536.93 17.1101C536.89 17.1301 536.85 17.1601 536.81 17.1801C536.83 17.2001 536.86 17.2201 536.88 17.2401C537.01 17.3001 537.1 17.4401 537.1 17.5801C537.09 17.7701 536.89 17.8701 536.82 17.9001C536.79 17.9101 536.77 17.9301 536.75 17.9501C536.75 17.9501 536.76 17.9801 536.76 18.0001C536.8 18.1001 536.79 18.2101 536.74 18.3001C536.69 18.3901 536.61 18.4701 536.51 18.5001C536.49 18.5001 536.47 18.5202 536.45 18.5302C536.46 18.5402 536.48 18.5501 536.49 18.5601C536.57 18.6001 536.65 18.6301 536.73 18.6501C536.77 18.5801 536.82 18.5201 536.88 18.4701C536.97 18.4101 537.08 18.3801 537.18 18.3801H537.23C537.31 18.3801 537.38 18.4101 537.42 18.4801C537.48 18.5601 537.49 18.6801 537.44 18.7701C537.38 18.8901 537.28 18.9802 537.16 19.0302C537.12 19.0402 537.08 19.0501 537.04 19.0501C537.07 19.1301 537.1 19.2102 537.12 19.2802C537.69 19.5002 537.87 19.8401 537.87 20.0401C537.88 20.1901 537.77 20.3202 537.63 20.3402C537.42 20.3702 537.12 20.1701 536.86 19.5701C536.71 19.5301 536.56 19.5001 536.4 19.4801C536.32 19.4801 536.24 19.4601 536.17 19.4501C536.2 19.4801 536.22 19.5101 536.25 19.5401C536.62 19.9901 536.71 20.1001 536.71 20.1801V20.2001C536.71 20.2001 536.72 20.2101 536.72 20.2201L536.76 20.2501C536.76 20.2501 536.83 20.2901 536.86 20.3101C536.93 20.2901 537 20.2801 537.07 20.2901C537.15 20.3101 537.21 20.3801 537.22 20.4601C537.22 20.5401 537.18 20.6101 537.11 20.6501C537.35 20.7801 537.57 20.6801 537.91 20.4401L537.97 20.4001C538.09 20.2901 538.24 20.2301 538.39 20.2201C538.49 20.2201 538.58 20.2901 538.62 20.3801C538.68 20.5401 538.57 20.7401 538.18 21.1701L538.2 21.1601ZM538.68 16.6101C538.68 16.6101 538.74 16.6701 538.77 16.6801C538.82 16.7101 538.91 16.6401 539.03 16.5401C538.99 16.5401 538.96 16.5402 538.92 16.5302C538.88 16.5302 538.84 16.5202 538.8 16.5302C538.75 16.5402 538.71 16.5701 538.67 16.6101H538.68ZM541.35 17.6701C541.35 17.6701 541.33 17.6701 541.32 17.6701C541.27 17.6701 541.22 17.6301 541.19 17.5801L540.98 17.2201C540.95 17.1701 540.95 17.1101 540.98 17.0501L541.15 16.6901C541.18 16.6301 541.24 16.5902 541.31 16.5902C541.38 16.5902 541.44 16.6201 541.47 16.6801L541.54 16.8101C541.62 16.9401 541.68 17.0801 541.74 17.2201C541.79 17.3701 541.67 17.4601 541.55 17.5501C541.52 17.5701 541.49 17.5901 541.47 17.6101C541.44 17.6401 541.39 17.6601 541.35 17.6501V17.6701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M540.34 16.3702C540.18 16.4002 540.08 16.4502 540.05 16.4302C539.99 16.3502 539.94 16.2502 539.91 16.1602C539.91 16.1602 540.02 16.0802 540.04 16.0902C540.15 16.1802 540.25 16.2702 540.35 16.3702H540.34Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M540.07 16.6201C540.01 16.6201 539.96 16.6001 539.92 16.5601C539.85 16.4701 539.79 16.3702 539.75 16.2702C539.7 16.1902 539.72 16.0802 539.79 16.0202C539.87 15.9602 540.01 15.8602 540.13 15.9502C540.21 16.0102 540.28 16.0802 540.35 16.1502L540.46 16.2501C540.46 16.2501 540.53 16.3601 540.51 16.4301C540.49 16.4901 540.44 16.5401 540.38 16.5601C540.33 16.5701 540.28 16.5801 540.24 16.6001C540.19 16.6201 540.13 16.6302 540.07 16.6302V16.6201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M515.29 43.4301C515.29 43.4301 515.59 43.4301 515.62 43.4901C515.69 43.6701 515.73 43.8701 515.75 44.0601C515.61 44.0801 515.46 44.1501 515.34 44.1201L515.29 43.4301ZM515.05 36.5601C515.05 36.5601 515.13 36.5801 515.18 36.5601C515.37 36.5201 515.57 36.4801 515.76 36.4401C515.7 36.2501 515.63 36.0702 515.52 35.8902C515.39 35.7202 515.33 35.6102 515.57 35.5102C515.61 35.4902 515.64 35.4601 515.67 35.4301C516.2 34.9001 516.18 34.7901 515.51 34.4801C515.44 34.4401 515.38 34.3902 515.33 34.3402C515.39 34.3002 515.46 34.2701 515.53 34.2501C516.14 34.2201 516.69 33.8901 517 33.3701C517.16 33.0801 517.11 33.0101 516.78 33.0001C516.59 33.0001 516.4 32.9701 516.22 32.9101C516.01 32.8501 515.72 32.8301 515.8 32.4801C515.86 32.2001 515.98 31.9401 516.32 31.9301C516.66 31.9101 517 31.9301 517.34 31.9101C517.46 31.9101 517.64 31.8101 517.66 31.7201C517.68 31.5901 517.62 31.4602 517.52 31.3802C517.26 31.2802 517.39 31.2102 517.48 31.0802C517.64 30.8502 517.94 30.5801 517.41 30.4201C517.41 30.4201 517.43 30.2402 517.48 30.2002C518.04 29.8002 518.7 29.5702 519.38 29.5302C519.57 29.5102 519.76 29.5202 519.95 29.5102C520.19 29.5002 520.47 29.5701 520.53 29.1901C520.53 29.1301 520.73 29.0901 520.84 29.0501C520.98 29.0101 521.12 28.9602 521.25 28.9002C521.3 28.8702 521.33 28.7601 521.34 28.6801C521.34 28.6601 521.24 28.6101 521.18 28.6101C521.03 28.6101 520.88 28.6002 520.74 28.5702C520.65 28.5402 520.59 28.4102 520.52 28.3202C520.6 28.2702 520.68 28.1701 520.76 28.1701C521.71 28.0701 522.65 27.8902 523.57 27.6402C523.81 27.6102 523.85 27.4901 523.81 27.3001C523.8 27.2401 523.77 27.1801 523.76 27.1101C523.7 26.8201 523.8 26.5202 524.03 26.3302C524.26 26.1402 524.57 26.0902 524.85 26.2102C525.08 26.2902 525.35 26.5001 525.55 26.2501C525.77 25.9901 525.55 25.7402 525.38 25.5202C525.27 25.3902 525.28 25.2802 525.47 25.2702C525.78 25.2602 526.09 25.2701 526.4 25.2901C526.61 25.3101 526.85 25.4701 527.01 25.4101C527.5 25.2201 527.55 25.5101 527.65 25.8601C527.8 26.3301 528.11 26.7302 528.52 27.0102C528.75 27.1802 528.97 27.2501 529.18 26.9801C529.23 26.9101 529.3 26.8602 529.38 26.8202C529.54 26.7902 529.7 26.7701 529.87 26.7501C529.88 26.9101 529.96 27.1101 529.89 27.2201C529.72 27.5901 529.65 27.9902 529.68 28.4002C529.68 28.5702 529.67 28.7401 529.65 28.9101C529.55 29.5201 529.4 29.6201 528.86 29.3001C528.53 29.1001 528.49 29.3501 528.32 29.4701C528 29.7001 528.34 29.7901 528.41 29.9101C528.54 30.1501 528.73 30.3602 528.87 30.5902C528.93 30.6802 528.95 30.7902 528.93 30.9002C528.91 31.0102 528.84 31.1002 528.75 31.1502C528.63 31.3002 528.41 31.3302 528.25 31.2102C527.76 30.9502 527.19 30.9002 526.66 31.0802C525.89 31.2302 525.11 31.3201 524.33 31.3501C524.04 31.3801 523.78 31.3402 523.8 31.7702C523.8 31.9102 523.59 32.0601 523.46 32.1901C523.25 32.4001 523.14 32.1702 522.99 32.0702C522.66 31.8302 522.52 31.8601 522.36 32.2501C522.24 32.5501 521.99 32.5601 521.75 32.6201C521.7 32.6301 521.66 32.6901 521.61 32.7301C521.66 32.7701 521.72 32.8002 521.78 32.8202C521.93 32.8602 522.09 32.8801 522.25 32.9101C522.17 33.0601 522.09 33.2101 522 33.3501C521.71 33.7601 521.61 33.7402 521.17 33.5702C520.82 33.4302 520.45 33.3602 520.07 33.3402C519.61 33.3302 519.42 33.6202 519.58 34.0702C519.72 34.4202 519.9 34.7502 520.1 35.0702C520.15 35.1502 520.32 35.1701 520.44 35.1801C520.67 35.2001 520.91 35.1702 521.14 35.2002C521.23 35.2102 521.31 35.3302 521.39 35.4002C521.31 35.4802 521.23 35.6301 521.16 35.6201C520.74 35.5901 520.6 35.7601 520.62 36.1701C520.63 36.4701 520.43 36.6102 520.11 36.5802C519.82 36.5202 519.52 36.6502 519.36 36.9002C519.13 37.1102 518.85 37.2501 518.54 37.3101C518.16 37.4401 518.13 37.4901 518.39 37.8101C518.43 37.8601 518.48 37.9002 518.52 37.9502C518.64 38.1002 518.75 38.2502 518.87 38.4002C518.7 38.4302 518.53 38.4801 518.37 38.5401C518.27 38.6001 518.19 38.6802 518.11 38.7602C517.88 38.9602 517.66 39.1701 517.41 39.3601C517.38 39.3801 517.2 39.2702 517.2 39.2602C517.32 38.9602 517.25 38.9202 516.98 39.0702C516.87 39.1302 516.74 39.1701 516.62 39.1901C516.41 39.2301 516.16 39.2002 516.02 39.3202C515.9 39.4102 515.95 39.6901 515.88 39.8601C515.74 40.1101 515.8 40.4201 516.02 40.6101C516.11 40.6901 516.19 40.8001 516.23 40.9201C516.28 41.0801 516.29 41.2701 516.04 41.3001C515.63 41.3401 515.5 41.6701 515.35 41.9801C515.29 42.1101 515.18 42.3801 515.54 42.1801C515.61 42.1601 515.69 42.1801 515.74 42.2401C515.77 42.3101 515.77 42.4001 515.74 42.4701C515.63 42.5701 515.52 42.6701 515.4 42.7501C515.25 42.8701 515.12 43.0101 515.01 43.1601L515.05 36.5601ZM523.58 29.6701C523.24 29.4901 522.85 29.4602 522.48 29.5802C522.29 29.6402 522.15 29.8501 521.98 30.0001C522.12 30.1701 522.29 30.3101 522.48 30.4301C522.66 30.4701 522.84 30.4302 522.99 30.3202C523.2 30.1202 523.38 29.9001 523.55 29.6601L523.63 29.6001L523.57 29.6701H523.58ZM519.52 31.3701C519.73 31.3501 519.98 31.3401 520.02 31.0401C520.05 30.8401 519.52 30.4601 519.26 30.4801C519.01 30.5001 519.05 30.7001 519.04 30.8601C519.04 31.2701 519.13 31.3701 519.52 31.3701ZM526.3 31.0001C526.43 30.9201 526.6 30.8701 526.61 30.8101C526.61 30.6801 526.55 30.5502 526.46 30.4502C526.37 30.3602 526.27 30.2901 526.15 30.2501C526 30.2001 525.85 30.1602 525.7 30.1302C525.72 30.3302 525.67 30.5701 525.77 30.7201C525.87 30.8701 526.11 30.9102 526.3 31.0102V31.0001ZM518.06 36.1101L518.31 36.5501C518.55 36.4001 518.79 36.2301 519.01 36.0501C519.06 36.0101 519.01 35.7301 518.96 35.7201C518.74 35.6601 518.51 35.6501 518.29 35.6901C518.19 35.7101 518.15 35.9401 518.06 36.1201V36.1101ZM518.64 33.5902C518.58 33.4802 518.48 33.2702 518.36 33.0702C518.32 33.0202 518.26 33.0001 518.2 33.0001C518.17 33.0001 518.13 33.0902 518.13 33.1402C518.13 33.4502 518.12 33.7702 518.14 34.0802C518.17 34.1702 518.24 34.2301 518.34 34.2501C518.44 34.2501 518.52 34.1901 518.57 34.1001C518.61 33.9301 518.63 33.7602 518.63 33.5902H518.64ZM520.99 32.9301C521.16 32.8101 521.36 32.7502 521.4 32.6302C521.48 32.3502 521.25 32.3401 521.05 32.3501C520.83 32.3601 520.53 32.2902 520.55 32.6502C520.55 32.7502 520.81 32.8201 520.99 32.9401V32.9301ZM520.75 32.1001C520.85 31.9501 520.94 31.7801 521.01 31.6101C521.01 31.5201 520.95 31.4402 520.87 31.4002C520.69 31.3802 520.52 31.4401 520.54 31.6701C520.54 31.7701 520.63 31.8601 520.75 32.1001ZM526.42 25.7802L526.27 25.9101L526.56 26.1101C526.56 26.1101 526.64 25.9901 526.63 25.9701C526.57 25.9001 526.49 25.8402 526.42 25.7802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M515.42 44.2402C515.42 44.2402 515.35 44.2402 515.31 44.2202C515.25 44.2002 515.22 44.1402 515.24 44.0802C515.26 44.0202 515.32 43.9902 515.38 44.0102C515.45 44.0102 515.52 44.0102 515.59 43.9802H515.62C515.62 43.9802 515.62 43.9302 515.61 43.9102C515.6 43.7902 515.57 43.6702 515.52 43.5502C515.46 43.5302 515.4 43.5202 515.34 43.5202C515.3 43.5402 515.26 43.5402 515.23 43.5202C515.18 43.4902 515.16 43.4202 515.19 43.3702C515.24 43.3102 515.31 43.2802 515.38 43.3002C515.43 43.3002 515.66 43.3202 515.72 43.4402C515.78 43.5802 515.82 43.7302 515.84 43.8802C515.84 43.9302 515.86 43.9902 515.87 44.0402C515.87 44.0702 515.87 44.1002 515.85 44.1302C515.83 44.1602 515.81 44.1702 515.77 44.1802C515.73 44.1802 515.69 44.2002 515.65 44.2102C515.58 44.2302 515.5 44.2502 515.42 44.2502V44.2402ZM514.98 43.2502C514.98 43.2502 514.9 43.2302 514.88 43.1902C514.86 43.1502 514.86 43.1102 514.88 43.0802C514.97 42.9402 515.08 42.8202 515.21 42.7202L515.29 42.6502C515.29 42.6502 515.39 42.5702 515.44 42.5302C515.5 42.4802 515.56 42.4302 515.62 42.3802C515.62 42.3502 515.62 42.3102 515.62 42.2802C515.62 42.2802 515.58 42.2802 515.56 42.2802C515.5 42.3202 515.32 42.4202 515.21 42.3202C515.1 42.2202 515.19 42.0202 515.23 41.9302L515.25 41.8802C515.39 41.5802 515.55 41.2302 516.01 41.1902C516.05 41.1902 516.09 41.1802 516.12 41.1502C516.13 41.1302 516.15 41.0802 516.12 40.9602C516.08 40.8602 516.02 40.7702 515.94 40.7002C515.69 40.4802 515.62 40.1202 515.77 39.8302C515.79 39.7602 515.81 39.6902 515.81 39.6102C515.81 39.4802 515.85 39.3402 515.94 39.2502C516.07 39.1602 516.23 39.1202 516.39 39.1202C516.46 39.1202 516.53 39.1102 516.59 39.0902C516.7 39.0702 516.82 39.0402 516.92 38.9902C517.05 38.9102 517.21 38.8402 517.31 38.9302C517.39 39.0002 517.38 39.1102 517.34 39.2302C517.35 39.2302 517.37 39.2502 517.38 39.2502C517.55 39.1102 517.72 38.9602 517.88 38.8102L518.03 38.6802C518.03 38.6802 518.08 38.6302 518.1 38.6102C518.16 38.5402 518.23 38.4802 518.32 38.4402C518.43 38.4002 518.55 38.3602 518.67 38.3402C518.59 38.2402 518.51 38.1302 518.43 38.0302C518.41 38.0102 518.39 37.9802 518.37 37.9602C518.35 37.9402 518.33 37.9102 518.31 37.8902C518.18 37.7302 518.08 37.5902 518.12 37.4602C518.16 37.3302 518.3 37.2802 518.51 37.2102L518.62 37.1702C518.86 37.1202 519.09 37.0102 519.27 36.8402C519.45 36.5602 519.79 36.4102 520.12 36.4802C520.23 36.5002 520.34 36.4802 520.43 36.4102C520.49 36.3502 520.51 36.2702 520.5 36.1902C520.47 36.0002 520.53 35.8002 520.65 35.6502C520.79 35.5402 520.98 35.4902 521.16 35.5202C521.16 35.5202 521.19 35.4602 521.22 35.4302V35.4102C521.22 35.4102 521.13 35.3202 521.11 35.3202C520.98 35.3102 520.86 35.3002 520.73 35.3102C520.62 35.3102 520.52 35.3102 520.41 35.3102C520.23 35.3002 520.06 35.2702 519.98 35.1502C519.77 34.8302 519.59 34.4902 519.44 34.1302C519.34 33.9202 519.35 33.6802 519.47 33.4802C519.6 33.3202 519.8 33.2302 520.01 33.2502H520.04C520.43 33.2602 520.82 33.3402 521.18 33.4802C521.59 33.6402 521.63 33.6602 521.88 33.3002C521.94 33.2102 522 33.1102 522.05 33.0202C521.94 33.0002 521.84 32.9802 521.73 32.9602C521.67 32.9402 521.62 32.9202 521.58 32.8802C521.57 32.8702 521.55 32.8602 521.54 32.8502C521.51 32.8302 521.49 32.8002 521.48 32.7602C521.48 32.7202 521.49 32.6902 521.52 32.6602C521.53 32.6502 521.54 32.6402 521.55 32.6302C521.59 32.5802 521.64 32.5402 521.7 32.5302L521.79 32.5102C522 32.4702 522.15 32.4402 522.23 32.2302C522.3 32.0602 522.39 31.8902 522.55 31.8402C522.73 31.8202 522.9 31.8802 523.03 32.0002C523.07 32.0302 523.1 32.0602 523.14 32.0902C523.25 32.2002 523.27 32.2102 523.36 32.1302C523.39 32.1002 523.42 32.0702 523.45 32.0402C523.52 31.9702 523.66 31.8502 523.66 31.8002C523.64 31.3002 523.96 31.2802 524.21 31.2702H524.3C524.47 31.2502 524.64 31.2402 524.81 31.2202C525.26 31.1902 525.71 31.1502 526.16 31.0802C526.12 31.0602 526.07 31.0402 526.03 31.0302C525.87 30.9902 525.74 30.9002 525.63 30.7802C525.56 30.6402 525.53 30.4802 525.55 30.3202C525.55 30.2602 525.55 30.2002 525.55 30.1402C525.55 30.1002 525.56 30.0702 525.59 30.0402C525.62 30.0202 525.66 30.0102 525.69 30.0202C525.73 30.0302 525.78 30.0402 525.82 30.0502C525.93 30.0702 526.04 30.1102 526.15 30.1502C526.29 30.2002 526.41 30.2802 526.51 30.3902C526.61 30.5102 526.68 30.6602 526.68 30.8202C526.68 30.9202 526.58 30.9702 526.47 31.0302C526.52 31.0202 526.57 31.0102 526.62 31.0002C527.17 30.8202 527.78 30.8702 528.29 31.1402C528.45 31.2302 528.52 31.2102 528.66 31.0902C528.82 30.9502 528.85 30.8302 528.76 30.6702C528.7 30.5702 528.63 30.4702 528.56 30.3802C528.46 30.2502 528.37 30.1202 528.29 29.9802C528.27 29.9602 528.25 29.9402 528.22 29.9202C528.13 29.8702 528.06 29.7702 528.05 29.6602C528.06 29.5502 528.13 29.4502 528.23 29.4002C528.26 29.3702 528.3 29.3402 528.32 29.3102C528.38 29.2202 528.47 29.1502 528.58 29.1302C528.69 29.1102 528.8 29.1502 528.88 29.2202C529.11 29.3602 529.25 29.4102 529.32 29.3702C529.42 29.3302 529.47 29.0802 529.5 28.9002C529.52 28.7702 529.53 28.6502 529.53 28.5202V28.4102C529.53 28.3502 529.53 28.2802 529.53 28.2202C529.5 27.8602 529.58 27.5002 529.75 27.1802C529.77 27.1002 529.76 27.0202 529.74 26.9502V26.9002H529.7C529.59 26.9102 529.48 26.9302 529.37 26.9502C529.31 26.9702 529.27 27.0102 529.23 27.0702C529.14 27.2002 528.99 27.2802 528.83 27.2902C528.67 27.3002 528.52 27.2402 528.41 27.1202C527.98 26.8302 527.66 26.4002 527.5 25.9102L527.48 25.8502C527.43 25.6802 527.39 25.5402 527.3 25.5002C527.2 25.4702 527.09 25.4902 527 25.5402C526.86 25.5702 526.7 25.5602 526.57 25.4902C526.5 25.4602 526.42 25.4402 526.34 25.4302C526.04 25.4102 525.73 25.4002 525.42 25.4102C525.4 25.4102 525.38 25.4102 525.37 25.4102C525.39 25.4302 525.4 25.4502 525.42 25.4702L525.44 25.4902C525.61 25.7002 525.86 26.0202 525.58 26.3402C525.36 26.6002 525.09 26.4802 524.9 26.3902C524.85 26.3702 524.8 26.3502 524.76 26.3302C524.51 26.2402 524.23 26.2802 524.03 26.4502C523.85 26.6102 523.76 26.8602 523.82 27.1002C523.82 27.1302 523.83 27.1602 523.84 27.1902C523.84 27.2202 523.86 27.2502 523.86 27.2802C523.89 27.3902 523.88 27.5102 523.82 27.6102C523.75 27.7002 523.64 27.7502 523.53 27.7502C523.15 27.8102 522.77 27.8902 522.4 28.0002C521.85 28.1802 521.28 28.2802 520.7 28.2802C520.67 28.3002 520.65 28.3202 520.62 28.3402C520.65 28.3902 520.69 28.4502 520.72 28.4702C520.8 28.4902 520.88 28.5002 520.96 28.5002C521.02 28.5002 521.08 28.5002 521.14 28.5102C521.14 28.5102 521.42 28.5502 521.4 28.7102C521.38 28.8702 521.34 28.9702 521.26 29.0102C521.17 29.0602 521.07 29.0902 520.98 29.1202C520.93 29.1302 520.89 29.1502 520.84 29.1702C520.81 29.1802 520.77 29.1902 520.73 29.2102C520.68 29.2202 520.64 29.2402 520.59 29.2602C520.52 29.6502 520.22 29.6502 520.02 29.6502C519.98 29.6502 519.95 29.6502 519.91 29.6502C519.84 29.6502 519.77 29.6502 519.7 29.6502C519.58 29.6502 519.46 29.6502 519.34 29.6702C518.68 29.7102 518.04 29.9302 517.5 30.3102C517.5 30.3302 517.49 30.3502 517.49 30.3702C517.61 30.4102 517.72 30.5002 517.77 30.6102C517.82 30.7802 517.71 30.9402 517.6 31.0802C517.58 31.1102 517.55 31.1402 517.53 31.1702C517.51 31.1902 517.5 31.2202 517.48 31.2402L517.45 31.2802C517.45 31.2802 517.49 31.3002 517.52 31.3102C517.68 31.4102 517.76 31.6002 517.73 31.7902C517.65 31.9502 517.49 32.0502 517.31 32.0602C517.11 32.0802 516.92 32.0702 516.73 32.0802C516.58 32.0802 516.44 32.0802 516.29 32.0802C516.07 32.0902 515.95 32.2202 515.88 32.5502C515.84 32.7302 515.91 32.7702 516.14 32.8202C516.17 32.8202 516.2 32.8302 516.23 32.8402C516.4 32.8902 516.58 32.9202 516.76 32.9202C516.92 32.9202 517.08 32.9402 517.15 33.0602C517.21 33.1702 517.16 33.3002 517.07 33.4602C516.74 34.0202 516.16 34.3702 515.52 34.4002C515.52 34.4002 515.54 34.4102 515.55 34.4202C515.92 34.5902 516.12 34.7102 516.15 34.9002C516.18 35.0802 516.04 35.2702 515.75 35.5602C515.71 35.6002 515.66 35.6402 515.61 35.6602C515.53 35.7002 515.52 35.7202 515.52 35.7202C515.54 35.7702 515.57 35.8302 515.61 35.8702C515.69 35.9902 515.76 36.1302 515.8 36.2702C515.82 36.3302 515.84 36.3802 515.86 36.4402C515.87 36.4702 515.87 36.5102 515.86 36.5402C515.84 36.5702 515.82 36.5902 515.78 36.6002L515.63 36.6302C515.49 36.6602 515.34 36.6902 515.19 36.7202C515.12 36.7402 515.05 36.7202 514.99 36.7002C514.94 36.6702 514.92 36.6002 514.94 36.5502C514.97 36.5002 515.03 36.4702 515.09 36.5002C515.11 36.5002 515.13 36.5002 515.14 36.5002C515.28 36.4702 515.43 36.4402 515.57 36.4102H515.59L515.57 36.3502C515.54 36.2302 515.48 36.1102 515.41 36.0102C515.32 35.9202 515.27 35.8002 515.28 35.6702C515.32 35.5702 515.4 35.4902 515.5 35.4602C515.52 35.4502 515.55 35.4302 515.57 35.4102C515.76 35.2202 515.93 35.0402 515.91 34.9502C515.89 34.8602 515.67 34.7502 515.44 34.6402C515.38 34.6102 515.33 34.5702 515.29 34.5302C515.27 34.5102 515.26 34.5002 515.24 34.4802C515.21 34.4602 515.19 34.4202 515.2 34.3802C515.21 34.3402 515.23 34.3102 515.26 34.2902C515.28 34.2902 515.3 34.2702 515.31 34.2602C515.36 34.2202 515.42 34.2002 515.49 34.1902C516.06 34.1702 516.59 33.8602 516.88 33.3702C516.96 33.2302 516.96 33.1902 516.96 33.1902C516.9 33.1702 516.83 33.1702 516.76 33.1702C516.56 33.1702 516.36 33.1302 516.17 33.0802L516.09 33.0602C515.9 33.0102 515.57 32.9302 515.67 32.5202C515.74 32.2302 515.87 31.9002 516.29 31.8802C516.44 31.8802 516.59 31.8802 516.74 31.8802C516.93 31.8802 517.12 31.8802 517.31 31.8602C517.39 31.8602 517.47 31.8102 517.53 31.7502C517.53 31.6702 517.5 31.6002 517.45 31.5402C517.37 31.5102 517.26 31.4602 517.23 31.3602C517.22 31.2702 517.25 31.1802 517.31 31.1202C517.32 31.1002 517.34 31.0802 517.35 31.0602C517.37 31.0302 517.4 31.0002 517.42 30.9602C517.49 30.8702 517.57 30.7602 517.56 30.7002C517.56 30.6802 517.52 30.6202 517.34 30.5702C517.3 30.5602 517.27 30.5202 517.26 30.4802C517.26 30.4702 517.26 30.2302 517.37 30.1502C517.94 29.7402 518.62 29.5002 519.33 29.4602C519.45 29.4502 519.58 29.4502 519.7 29.4402C519.77 29.4402 519.84 29.4402 519.91 29.4402C519.95 29.4402 519.99 29.4402 520.03 29.4402C520.26 29.4402 520.35 29.4402 520.38 29.2202C520.4 29.1002 520.53 29.0602 520.67 29.0202C520.7 29.0102 520.74 29.0002 520.77 28.9902C520.82 28.9702 520.87 28.9602 520.92 28.9402C521 28.9202 521.08 28.8902 521.16 28.8502C521.16 28.8502 521.17 28.8102 521.18 28.7802C521.16 28.7802 521.14 28.7702 521.13 28.7602C521.08 28.7602 521.03 28.7602 520.98 28.7602C520.87 28.7602 520.77 28.7502 520.67 28.7202C520.58 28.6802 520.51 28.6002 520.46 28.5202C520.44 28.4902 520.42 28.4702 520.4 28.4402C520.38 28.4202 520.37 28.3802 520.37 28.3502C520.37 28.3202 520.39 28.2902 520.42 28.2702C520.44 28.2502 520.46 28.2402 520.49 28.2202C520.55 28.1502 520.64 28.1102 520.73 28.1002C521.29 28.1002 521.84 28.0002 522.36 27.8302C522.74 27.7102 523.13 27.6302 523.52 27.5702C523.57 27.5702 523.62 27.5502 523.66 27.5202C523.68 27.4702 523.68 27.4102 523.66 27.3602C523.66 27.3302 523.65 27.3102 523.64 27.2802C523.63 27.2402 523.62 27.2102 523.61 27.1702C523.54 26.8502 523.65 26.5202 523.9 26.3002C524.17 26.0802 524.53 26.0202 524.85 26.1402C524.9 26.1602 524.96 26.1802 525.01 26.2102C525.23 26.3102 525.33 26.3402 525.43 26.2202C525.57 26.0502 525.47 25.8902 525.28 25.6502L525.26 25.6302C525.15 25.4902 525.16 25.3902 525.19 25.3302C525.24 25.2402 525.34 25.1902 525.44 25.2002C525.75 25.1902 526.07 25.2002 526.38 25.2202C526.48 25.2302 526.57 25.2602 526.66 25.2902C526.75 25.3302 526.84 25.3502 526.94 25.3402C527.09 25.2602 527.27 25.2502 527.42 25.3102C527.59 25.4002 527.65 25.5902 527.71 25.8002L527.73 25.8602C527.88 26.3102 528.17 26.6902 528.56 26.9502C528.79 27.1202 528.93 27.1202 529.07 26.9402C529.13 26.8502 529.22 26.7802 529.33 26.7502C529.45 26.7202 529.57 26.7102 529.69 26.7002C529.74 26.7002 529.78 26.7002 529.83 26.6902C529.86 26.6902 529.89 26.6902 529.92 26.7102C529.94 26.7302 529.96 26.7602 529.96 26.7902C529.96 26.8402 529.97 26.8902 529.98 26.9302C530.02 27.0602 530.01 27.2002 529.96 27.3202C529.81 27.6102 529.75 27.9202 529.77 28.2402C529.77 28.3102 529.77 28.3702 529.77 28.4402V28.5502C529.77 28.6902 529.75 28.8302 529.73 28.9602C529.68 29.2802 529.61 29.5102 529.43 29.5902C529.24 29.6802 529.01 29.5602 528.78 29.4302C528.62 29.3302 528.59 29.3602 528.5 29.4702C528.46 29.5202 528.42 29.5602 528.37 29.6002C528.29 29.6602 528.28 29.6902 528.28 29.6902C528.3 29.7202 528.33 29.7402 528.36 29.7702C528.41 29.8002 528.45 29.8502 528.49 29.9002C528.56 30.0302 528.65 30.1502 528.74 30.2702C528.81 30.3702 528.89 30.4702 528.95 30.5802C529.02 30.6902 529.05 30.8302 529.02 30.9602C528.99 31.0902 528.91 31.2102 528.8 31.2802C528.64 31.4602 528.37 31.4902 528.17 31.3502C527.71 31.1002 527.16 31.0602 526.66 31.2402C526.05 31.3702 525.44 31.4502 524.82 31.4802C524.65 31.4902 524.48 31.5102 524.31 31.5202H524.21C523.96 31.5402 523.87 31.5502 523.87 31.8302C523.87 31.9902 523.73 32.1202 523.58 32.2502C523.55 32.2802 523.52 32.3002 523.49 32.3302C523.25 32.5702 523.06 32.3902 522.96 32.2902C522.93 32.2602 522.91 32.2402 522.88 32.2202C522.74 32.1202 522.65 32.0802 522.59 32.0902C522.54 32.1102 522.48 32.1902 522.42 32.3502C522.32 32.5902 522.08 32.7602 521.81 32.7702H521.76C521.86 32.8002 521.97 32.8202 522.07 32.8402L522.21 32.8602C522.21 32.8602 522.28 32.8902 522.29 32.9202C522.31 32.9502 522.3 32.9902 522.29 33.0202C522.26 33.0602 522.24 33.1102 522.22 33.1602C522.17 33.2702 522.11 33.3702 522.04 33.4702C521.72 33.9202 521.57 33.9202 521.07 33.7202C520.73 33.5902 520.37 33.5102 520.01 33.5002C519.87 33.4802 519.73 33.5302 519.63 33.6402C519.56 33.7802 519.56 33.9402 519.63 34.0802C519.77 34.4202 519.94 34.7502 520.14 35.0602C520.14 35.0602 520.18 35.1002 520.39 35.1102C520.49 35.1102 520.59 35.1102 520.69 35.1102C520.83 35.1102 520.96 35.1102 521.1 35.1202C521.2 35.1402 521.28 35.2002 521.34 35.2802C521.36 35.3002 521.38 35.3302 521.41 35.3502C521.43 35.3702 521.45 35.4002 521.45 35.4302C521.45 35.4602 521.44 35.4902 521.42 35.5102C521.4 35.5402 521.37 35.5602 521.35 35.5902C521.28 35.6802 521.21 35.7702 521.1 35.7702C520.98 35.7502 520.86 35.7702 520.76 35.8402C520.68 35.9502 520.65 36.0802 520.68 36.2102C520.69 36.3602 520.64 36.5002 520.54 36.6102C520.4 36.7202 520.22 36.7702 520.05 36.7402C519.8 36.6802 519.54 36.7902 519.4 37.0102C519.19 37.2202 518.93 37.3702 518.64 37.4202L518.53 37.4602C518.44 37.4802 518.36 37.5202 518.28 37.5702C518.32 37.6502 518.37 37.7202 518.43 37.7902C518.45 37.8102 518.47 37.8302 518.49 37.8502C518.51 37.8802 518.54 37.9002 518.56 37.9302C518.64 38.0402 518.73 38.1402 518.81 38.2502L518.91 38.3802C518.91 38.3802 518.94 38.4502 518.93 38.4802C518.92 38.5202 518.89 38.5402 518.85 38.5502C518.8 38.5602 518.75 38.5702 518.7 38.5902C518.59 38.6102 518.48 38.6402 518.37 38.6902C518.32 38.7202 518.27 38.7602 518.23 38.8102C518.2 38.8402 518.17 38.8702 518.15 38.8902L518 39.0202C517.82 39.1802 517.64 39.3402 517.45 39.5002C517.35 39.5802 517.18 39.4602 517.11 39.4102C517.07 39.3802 517.05 39.3202 517.07 39.2702C517.08 39.2402 517.1 39.2002 517.11 39.1702C517.09 39.1802 517.05 39.2002 517.01 39.2202C516.89 39.2802 516.76 39.3202 516.63 39.3502C516.55 39.3702 516.47 39.3802 516.39 39.3802C516.28 39.3802 516.16 39.4002 516.06 39.4602C516.03 39.4902 516.02 39.5902 516.01 39.6702C516.01 39.7702 515.99 39.8602 515.95 39.9602C515.83 40.1702 515.88 40.4302 516.07 40.5802C516.18 40.6802 516.26 40.8002 516.31 40.9402C516.36 41.0602 516.35 41.2002 516.29 41.3202C516.23 41.4102 516.13 41.4602 516.02 41.4602C515.69 41.4902 515.58 41.7402 515.45 42.0202L515.43 42.0702C515.43 42.0702 515.4 42.1302 515.39 42.1602C515.41 42.1602 515.43 42.1402 515.45 42.1302C515.51 42.1002 515.58 42.1002 515.64 42.1202C515.71 42.1302 515.77 42.1702 515.81 42.2302C515.87 42.3402 515.86 42.4802 515.79 42.5902C515.73 42.6602 515.65 42.7202 515.58 42.7802C515.53 42.8102 515.49 42.8502 515.44 42.8902L515.36 42.9702C515.25 43.0602 515.15 43.1602 515.07 43.2802C515.05 43.3102 515.01 43.3302 514.97 43.3302L514.98 43.2502ZM525.78 30.2402V30.2902C525.77 30.4002 525.78 30.5202 525.82 30.6202C525.9 30.7002 526 30.7602 526.12 30.7902C526.17 30.8102 526.22 30.8302 526.26 30.8502C526.29 30.8302 526.32 30.8202 526.35 30.8002C526.38 30.7802 526.43 30.7602 526.46 30.7502C526.44 30.6602 526.4 30.5702 526.34 30.5002C526.27 30.4202 526.17 30.3602 526.07 30.3302C525.98 30.2902 525.88 30.2702 525.78 30.2502V30.2402ZM518.28 36.6402H518.26C518.23 36.6402 518.2 36.6102 518.19 36.5902L517.94 36.1502C517.94 36.1502 517.92 36.0802 517.94 36.0402C517.97 35.9802 517.99 35.9302 518.01 35.8702C518.07 35.7202 518.12 35.5802 518.24 35.5602C518.48 35.5202 518.72 35.5302 518.96 35.5902C519.04 35.6102 519.07 35.6902 519.09 35.7702C519.12 35.8702 519.15 36.0402 519.06 36.1202C518.9 36.2602 518.72 36.3902 518.54 36.5002C518.48 36.5402 518.41 36.5902 518.35 36.6302C518.33 36.6402 518.31 36.6502 518.29 36.6502L518.28 36.6402ZM518.15 36.0802L518.31 36.3602C518.31 36.3602 518.37 36.3202 518.41 36.3002C518.58 36.1902 518.73 36.0802 518.88 35.9502C518.88 35.9002 518.88 35.8402 518.86 35.7902C518.67 35.7402 518.48 35.7302 518.28 35.7602C518.25 35.8202 518.23 35.8802 518.2 35.9402C518.18 35.9802 518.16 36.0302 518.14 36.0702L518.15 36.0802ZM518.31 34.3402C518.16 34.3202 518.04 34.2102 518.01 34.0602C517.99 33.7602 517.99 33.4602 518 33.1702V33.1202C518 33.0602 518.06 32.8802 518.18 32.8702C518.28 32.8702 518.38 32.9102 518.44 33.0002C518.53 33.1602 518.61 33.3202 518.67 33.4302L518.72 33.5202C518.72 33.5202 518.73 33.5602 518.73 33.5802C518.73 33.6702 518.72 33.7402 518.71 33.8102C518.71 33.9202 518.69 34.0302 518.66 34.1302C518.59 34.2502 518.47 34.3302 518.33 34.3402H518.31ZM518.22 33.1002V33.1702C518.22 33.4602 518.21 33.7602 518.22 34.0402C518.24 34.0702 518.28 34.0902 518.31 34.1102C518.31 34.1102 518.4 34.0702 518.43 34.0302C518.45 33.9502 518.47 33.8702 518.47 33.7902C518.47 33.7302 518.47 33.6602 518.48 33.5902L518.45 33.5302C518.39 33.4202 518.31 33.2602 518.22 33.1102H518.21L518.22 33.1002ZM520.95 33.0202C520.95 33.0202 520.91 33.0202 520.89 33.0002C520.83 32.9602 520.77 32.9302 520.71 32.9002C520.55 32.8202 520.41 32.7502 520.4 32.6202C520.38 32.5102 520.42 32.4002 520.49 32.3202C520.61 32.2302 520.75 32.1902 520.9 32.2102C520.94 32.2102 520.97 32.2102 521.01 32.2102C521.16 32.1802 521.32 32.2202 521.44 32.3202C521.5 32.4102 521.52 32.5302 521.47 32.6302C521.43 32.7502 521.31 32.8202 521.18 32.9002C521.13 32.9302 521.07 32.9602 521.02 33.0002C521 33.0102 520.98 33.0202 520.96 33.0202H520.95ZM520.87 32.4402C520.78 32.4402 520.69 32.4402 520.65 32.4802C520.63 32.5202 520.62 32.5702 520.62 32.6102C520.63 32.6102 520.74 32.6702 520.8 32.7002C520.85 32.7202 520.89 32.7502 520.94 32.7702C520.98 32.7502 521.02 32.7202 521.06 32.7002C521.13 32.6602 521.24 32.6002 521.25 32.5702C521.27 32.5102 521.26 32.4802 521.25 32.4702C521.24 32.4502 521.19 32.4302 521.01 32.4402C520.97 32.4402 520.93 32.4402 520.89 32.4402H520.86H520.87ZM520.71 32.1902C520.71 32.1902 520.63 32.1702 520.61 32.1302C520.57 32.0502 520.53 31.9802 520.5 31.9302C520.44 31.8502 520.41 31.7602 520.39 31.6702C520.38 31.5602 520.41 31.4602 520.48 31.3802C520.58 31.3002 520.71 31.2602 520.84 31.2802C520.91 31.3002 520.97 31.3402 521.01 31.4102C521.06 31.4702 521.08 31.5502 521.07 31.6302C521.03 31.7402 520.98 31.8502 520.92 31.9502C520.89 32.0102 520.85 32.0702 520.81 32.1502C520.79 32.1902 520.75 32.2102 520.71 32.2102V32.1902ZM520.78 31.4902C520.73 31.4902 520.68 31.5002 520.63 31.5302C520.61 31.5602 520.6 31.6002 520.6 31.6402C520.62 31.7002 520.64 31.7602 520.68 31.8102L520.7 31.8502L520.72 31.8202C520.77 31.7402 520.82 31.6502 520.85 31.5602C520.83 31.5302 520.81 31.5102 520.79 31.4902H520.78ZM519.45 31.4602C519.3 31.4802 519.14 31.4302 519.02 31.3302C518.91 31.1902 518.87 31.0102 518.89 30.8302V30.7702C518.89 30.6302 518.89 30.3702 519.21 30.3402C519.5 30.3702 519.76 30.5002 519.95 30.7102C520.04 30.7902 520.09 30.9002 520.09 31.0202C520.03 31.4002 519.71 31.4202 519.51 31.4402H519.44L519.45 31.4602ZM519.25 30.5802H519.24C519.14 30.5802 519.13 30.6102 519.13 30.7802V30.8502C519.13 31.0302 519.15 31.1402 519.19 31.1802C519.28 31.2302 519.38 31.2602 519.49 31.2402H519.51C519.75 31.2202 519.86 31.1902 519.89 31.0102C519.89 31.0002 519.88 30.9502 519.8 30.8702C519.66 30.7202 519.47 30.6202 519.26 30.5802H519.25ZM522.59 30.5302C522.53 30.5302 522.47 30.5302 522.42 30.5002C522.27 30.4302 522.13 30.3202 522.02 30.1902C521.97 30.1402 521.93 30.1002 521.88 30.0502C521.86 30.0302 521.84 30.0002 521.84 29.9702C521.84 29.9402 521.85 29.9102 521.88 29.8902C521.93 29.8502 521.98 29.8002 522.02 29.7502C522.12 29.6202 522.26 29.5202 522.41 29.4502C522.77 29.3302 523.16 29.3502 523.5 29.5102L523.54 29.4802C523.54 29.4802 523.65 29.4602 523.69 29.5002C523.73 29.5402 523.73 29.6002 523.69 29.6502L523.63 29.7202C523.63 29.7202 523.59 29.7502 523.57 29.7602C523.53 29.8102 523.5 29.8502 523.46 29.9002C523.34 30.0702 523.2 30.2302 523.04 30.3802C522.91 30.4802 522.75 30.5302 522.59 30.5302ZM522.12 29.9702C522.12 29.9702 522.16 30.0102 522.18 30.0302C522.27 30.1402 522.38 30.2202 522.5 30.2902C522.64 30.3202 522.78 30.2902 522.9 30.2002C523.04 30.0702 523.17 29.9202 523.28 29.7602C523.3 29.7302 523.32 29.7102 523.34 29.6802C523.07 29.5702 522.76 29.5702 522.48 29.6602C522.36 29.7202 522.26 29.8002 522.18 29.9002C522.16 29.9202 522.14 29.9502 522.11 29.9702H522.12ZM526.52 26.2102C526.52 26.2102 526.48 26.2102 526.46 26.1902L526.17 25.9902C526.17 25.9902 526.12 25.9402 526.12 25.9002C526.12 25.8702 526.13 25.8302 526.16 25.8102L526.31 25.6802C526.31 25.6802 526.41 25.6402 526.46 25.6802L526.52 25.7302C526.58 25.7802 526.64 25.8302 526.68 25.8802C526.74 25.9502 526.68 26.0302 526.65 26.1002C526.65 26.1102 526.63 26.1302 526.62 26.1402C526.61 26.1702 526.58 26.1902 526.55 26.2002C526.55 26.2002 526.53 26.2002 526.52 26.2002V26.2102Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M517.82 40.3701C517.65 40.3901 517.49 40.3801 517.32 40.3601C517.25 40.3401 517.17 40.1801 517.17 40.0801C517.17 40.0101 517.27 39.8701 517.33 39.8701C517.68 39.8501 518.04 39.8501 518.4 39.8701C518.47 39.8701 518.58 40.0301 518.58 40.1201C518.56 40.2301 518.5 40.3201 518.4 40.3701C518.21 40.3901 518.03 40.4001 517.84 40.3801L517.82 40.3701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M518.15 40.4901C518.09 40.4901 518.04 40.4901 517.98 40.4901C517.92 40.4901 517.85 40.4901 517.79 40.4901C517.75 40.4901 517.72 40.4901 517.68 40.4901C517.55 40.5001 517.42 40.4901 517.29 40.4701C517.14 40.4301 517.06 40.2101 517.05 40.0901C517.05 40.0001 517.09 39.9201 517.15 39.8501C517.19 39.8001 517.25 39.7601 517.31 39.7501C517.67 39.7301 518.03 39.7301 518.39 39.7501C518.53 39.7601 518.67 39.9901 518.67 40.1101C518.66 40.2701 518.55 40.4101 518.4 40.4601C518.32 40.4801 518.23 40.4801 518.14 40.4801L518.15 40.4901ZM517.86 40.2601C517.86 40.2601 517.95 40.2601 517.99 40.2601C518.11 40.2701 518.24 40.2601 518.36 40.2501C518.41 40.2201 518.44 40.1701 518.45 40.1101C518.44 40.0601 518.4 40.0101 518.36 39.9701C518.02 39.9501 517.67 39.9501 517.33 39.9701C517.31 40.0001 517.29 40.0301 517.28 40.0701C517.28 40.1301 517.32 40.1901 517.36 40.2401C517.46 40.2601 517.57 40.2601 517.67 40.2501C517.73 40.2401 517.8 40.2401 517.86 40.2501V40.2601Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M522.93 26.2002C522.99 26.2002 523.06 26.2002 523.12 26.2202C523.15 26.2302 523.18 26.4102 523.15 26.4302C523.01 26.5402 522.84 26.6302 522.66 26.6802C522.58 26.7002 522.41 26.5702 522.38 26.4702C522.32 26.3102 522.43 26.2002 522.62 26.2002C522.68 26.2002 522.74 26.2002 522.92 26.2002H522.93Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M522.65 26.7901C522.48 26.7701 522.34 26.6601 522.27 26.5001C522.23 26.4101 522.25 26.3001 522.3 26.2201C522.38 26.1301 522.5 26.0801 522.62 26.0901C522.66 26.0901 522.7 26.0901 522.76 26.0901H522.91C522.99 26.0901 523.07 26.0901 523.14 26.1201C523.16 26.1201 523.23 26.1501 523.25 26.3301C523.27 26.4001 523.25 26.4801 523.19 26.5301C523.03 26.6501 522.85 26.7401 522.66 26.7901C522.65 26.7901 522.64 26.7901 522.62 26.7901H522.65ZM522.61 26.3101C522.61 26.3101 522.52 26.3101 522.49 26.3501C522.48 26.3701 522.48 26.4001 522.49 26.4301C522.53 26.4901 522.59 26.5401 522.65 26.5601C522.79 26.5201 522.93 26.4501 523.05 26.3601C523.05 26.3401 523.05 26.3301 523.05 26.3201C523.02 26.3201 522.99 26.3201 522.96 26.3201C522.96 26.3201 522.94 26.3201 522.93 26.3201H522.77C522.7 26.3201 522.66 26.3201 522.62 26.3201L522.61 26.3101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M521.82 27.5902C521.74 27.6002 521.65 27.6002 521.57 27.5902C521.5 27.5502 521.4 27.4602 521.4 27.4002C521.4 27.3302 521.51 27.2102 521.57 27.2102C521.73 27.2302 521.89 27.2702 522.04 27.3302C522.11 27.3602 522.14 27.4502 522.19 27.5102C522.11 27.5402 522.02 27.5702 521.94 27.6002C521.9 27.6002 521.86 27.6002 521.82 27.6002V27.5902Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M521.66 27.7201C521.66 27.7201 521.57 27.7201 521.52 27.6901C521.43 27.6501 521.28 27.5301 521.29 27.4001C521.3 27.3101 521.35 27.2301 521.41 27.1801C521.45 27.1301 521.51 27.1101 521.58 27.1101C521.75 27.1301 521.92 27.1701 522.08 27.2401C522.15 27.2801 522.2 27.3301 522.24 27.4001C522.25 27.4201 522.26 27.4401 522.28 27.4501C522.3 27.4801 522.31 27.5201 522.3 27.5501C522.3 27.5901 522.26 27.6101 522.23 27.6301L522.16 27.6501C522.1 27.6701 522.03 27.7001 521.97 27.7101C521.93 27.7101 521.89 27.7201 521.85 27.7101H521.82C521.82 27.7101 521.8 27.7101 521.79 27.7101H521.75C521.75 27.7101 521.69 27.7101 521.66 27.7101V27.7201ZM521.56 27.3301C521.56 27.3301 521.52 27.3901 521.51 27.4101C521.54 27.4401 521.58 27.4701 521.62 27.4901C521.66 27.4901 521.69 27.4901 521.73 27.4901C521.77 27.4901 521.82 27.4901 521.86 27.4901C521.86 27.4901 521.89 27.4901 521.91 27.4901C521.95 27.4901 521.98 27.4701 522.01 27.4601C522.01 27.4601 522 27.4401 521.99 27.4401C521.85 27.3801 521.71 27.3401 521.56 27.3301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M529.86 30.8701C529.72 30.9001 529.63 30.9501 529.59 30.9201C529.51 30.8501 529.44 30.7601 529.41 30.6601C529.4 30.6201 529.49 30.5501 529.54 30.4901L529.86 30.8701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M529.62 31.0301C529.62 31.0301 529.55 31.02 529.52 31C529.42 30.92 529.35 30.8101 529.3 30.7001C529.27 30.6101 529.34 30.54 529.4 30.47C529.42 30.45 529.43 30.44 529.44 30.42C529.46 30.39 529.49 30.37 529.53 30.38C529.56 30.38 529.59 30.39 529.62 30.42L529.94 30.8C529.94 30.8 529.97 30.87 529.96 30.91C529.95 30.95 529.92 30.98 529.88 30.98C529.83 30.98 529.79 31 529.76 31.01C529.72 31.03 529.67 31.03 529.62 31.04V31.0301ZM529.53 30.6501C529.56 30.7101 529.59 30.76 529.64 30.8H529.66L529.54 30.6501H529.53Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M521.3 34.1402C521.21 34.1802 521.14 34.2302 521.13 34.2202C521.08 34.1702 521.03 34.1002 521 34.0402C520.99 34.0102 521.03 33.9702 521.04 33.9302L521.3 34.1502V34.1402Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M521.13 34.3301C521.13 34.3301 521.07 34.3201 521.05 34.3001C520.99 34.2401 520.93 34.1601 520.9 34.0801C520.88 34.0201 520.9 33.96 520.93 33.91V33.8801C520.93 33.8801 520.99 33.8201 521.02 33.8101C521.05 33.8001 521.09 33.8101 521.12 33.8301L521.38 34.0501C521.38 34.0501 521.42 34.1101 521.42 34.1501C521.42 34.1901 521.39 34.2201 521.36 34.2401C521.33 34.2501 521.3 34.2701 521.28 34.2801C521.24 34.3101 521.19 34.3201 521.14 34.3301H521.13Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M517.16 40.5901C517.09 40.6301 517.05 40.6601 517.04 40.6601C516.97 40.5901 516.91 40.5201 516.84 40.4501C516.87 40.4301 516.92 40.4001 516.94 40.4101C517.02 40.4701 517.09 40.5301 517.16 40.5901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M517.04 40.7701C517.04 40.7701 516.98 40.7601 516.96 40.7401C516.91 40.6901 516.86 40.6401 516.81 40.5801L516.76 40.5302C516.76 40.5302 516.72 40.4701 516.73 40.4301C516.74 40.3901 516.76 40.3601 516.79 40.3501H516.81C516.86 40.2901 516.93 40.2901 516.99 40.3201C517.05 40.3601 517.11 40.4101 517.16 40.4601L517.22 40.5101C517.22 40.5101 517.26 40.5701 517.26 40.6101C517.26 40.6501 517.24 40.6801 517.2 40.7001L517.14 40.7401C517.14 40.7401 517.06 40.7801 517.02 40.7901L517.04 40.7701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M598.31 30.4301C598.34 30.6801 598.44 31.0401 598.31 31.1701C597.99 31.5101 598.28 32.1701 598.42 32.4701C598.51 32.6501 598.4 32.7501 598.19 32.6801C598.07 32.6401 597.95 32.6101 597.83 32.5601C597.47 32.3501 597.03 32.3902 596.71 32.6502C596.28 32.9302 595.71 32.8301 595.41 32.4101C595.37 32.2901 595.37 32.1502 595.41 32.0302C595.75 31.9902 595.69 31.7101 595.75 31.5101C595.8 31.3901 595.86 31.2701 595.93 31.1601C595.79 31.2101 595.12 30.9201 594.98 30.9701C594.61 31.1801 594.19 31.2601 593.77 31.1901C593.39 31.1001 593.3 30.9602 593.34 30.6402C593.37 30.5002 593.41 30.3601 593.46 30.2301C593.49 30.1301 593.51 30.0401 593.54 29.9401C593.44 29.9401 593.31 29.9001 593.25 29.9401C592.98 30.1701 592.77 29.9301 592.55 29.8701C592.46 29.8201 592.41 29.7302 592.41 29.6402C592.44 29.5502 592.51 29.4701 592.6 29.4401C593.31 29.1301 593.32 29.1402 593.26 28.3902C593.24 28.2002 593.22 28.0101 593.22 27.8201C593.22 27.3801 593.42 27.2502 593.84 27.4002C593.88 27.4102 593.92 27.4401 593.96 27.4501C594.11 27.4901 594.27 27.5302 594.42 27.5802C594.28 27.7302 594.13 27.8601 593.95 27.9701C593.72 28.0701 593.57 28.1601 593.77 28.4101C593.94 28.6301 593.82 28.7801 593.72 28.9801C593.68 29.1101 593.71 29.2501 593.8 29.3601C593.94 29.4401 594.09 29.4101 594.18 29.1901C594.32 28.8501 595.59 29.1301 595.76 29.4301C595.82 29.5401 595.76 29.7402 595.71 29.8902C595.66 30.0602 595.71 30.1501 595.87 30.1301C596.27 30.0701 596.72 30.2702 597.04 29.7802C597.19 29.5502 597.58 29.4701 597.88 29.3501", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M596.24 33.0001C596.19 33.0001 596.14 33.0001 596.09 32.9901C595.77 32.9501 595.48 32.7801 595.29 32.5201C595.21 32.3401 595.21 32.1401 595.27 31.9601C595.3 31.9001 595.36 31.8601 595.42 31.8501C595.53 31.8401 595.54 31.8201 595.57 31.6401C595.57 31.5801 595.59 31.5101 595.61 31.4501C595.63 31.4001 595.65 31.3501 595.67 31.3001C595.6 31.2801 595.53 31.2601 595.44 31.2301C595.32 31.1801 595.19 31.1501 595.05 31.1401L594.98 31.1701C594.6 31.3701 594.17 31.4401 593.75 31.3601C593.29 31.2501 593.13 31.0301 593.18 30.6201C593.2 30.5101 593.23 30.4101 593.27 30.3101C593.29 30.2701 593.3 30.2201 593.31 30.1801C593.31 30.1601 593.31 30.1501 593.32 30.1301C593.12 30.2601 592.86 30.2501 592.67 30.1101C592.62 30.0801 592.57 30.0601 592.52 30.0501C592.35 29.9801 592.24 29.8101 592.24 29.6301C592.27 29.4701 592.38 29.3401 592.53 29.2801C592.93 29.1068 593.113 28.8167 593.08 28.4101L593.06 28.2301C593.05 28.0901 593.03 27.9601 593.03 27.8201C593 27.6001 593.09 27.3801 593.26 27.2401C593.46 27.1301 593.7 27.1301 593.9 27.2401L593.96 27.2601C593.96 27.2601 593.99 27.2701 594.01 27.2801L594.47 27.4101C594.53 27.4301 594.58 27.4801 594.6 27.5401C594.62 27.6001 594.6 27.6701 594.54 27.7201C594.5 27.7601 594.45 27.8001 594.41 27.8401C594.3 27.9601 594.17 28.0601 594.03 28.1301C593.97 28.1501 593.91 28.1801 593.86 28.2201C593.86 28.2201 593.88 28.2501 593.91 28.2901C594.08 28.4901 594.08 28.7901 593.91 28.9901L593.88 29.0501C593.88 29.1001 593.88 29.1601 593.91 29.2101H593.93C593.93 29.2101 593.97 29.1801 594 29.1001C594.04 28.9901 594.16 28.8601 594.49 28.8401C594.91 28.8101 595.72 29.0101 595.9 29.3201C595.97 29.5001 595.96 29.7101 595.88 29.8901V29.9301C595.98 29.9301 596.09 29.9201 596.2 29.9301C596.5 29.9301 596.71 29.9401 596.89 29.6701C597.07 29.4601 597.31 29.3101 597.58 29.2501C597.66 29.2201 597.73 29.2001 597.8 29.1701C597.86 29.1501 597.93 29.1501 597.98 29.1901C598.03 29.2301 598.06 29.2901 598.05 29.3601C598.05 29.4201 598 29.4801 597.94 29.5001C597.86 29.5301 597.78 29.5601 597.7 29.5901C597.51 29.6301 597.33 29.7301 597.19 29.8701C596.97 30.2001 596.58 30.3601 596.2 30.3001C596.1 30.3001 596 30.3001 595.9 30.3001C595.79 30.3301 595.67 30.3001 595.59 30.2101C595.51 30.1001 595.49 29.9601 595.54 29.8401C595.58 29.7401 595.6 29.6301 595.6 29.5201C595.36 29.3401 595.07 29.2401 594.77 29.2301C594.47 29.2001 594.35 29.2501 594.34 29.2701C594.3 29.4101 594.19 29.5201 594.05 29.5701C593.93 29.6101 593.8 29.5901 593.7 29.5201C593.53 29.3701 593.47 29.1201 593.55 28.9101L593.59 28.8401C593.69 28.6601 593.7 28.6201 593.62 28.5301C593.52 28.4301 593.48 28.2801 593.5 28.1401C593.54 27.9601 593.73 27.8701 593.87 27.8101C593.94 27.7801 594 27.7301 594.06 27.6801L593.9 27.6401C593.9 27.6401 593.84 27.6201 593.8 27.6001C593.55 27.5101 593.48 27.5401 593.46 27.5501C593.41 27.5801 593.39 27.6901 593.39 27.8301C593.39 27.9501 593.39 28.0801 593.41 28.2001L593.43 28.3801C593.49 29.2001 593.45 29.2701 592.68 29.6001C592.64 29.6201 592.61 29.6401 592.59 29.6801C592.59 29.6701 592.62 29.7101 592.63 29.7201C592.7 29.7401 592.76 29.7601 592.82 29.8001C593 29.8901 593.05 29.9001 593.14 29.8201C593.24 29.7501 593.36 29.7301 593.47 29.7601C593.56 29.7701 593.64 29.7701 593.69 29.8401C593.72 29.8801 593.73 29.9401 593.72 29.9901L593.7 30.0701C593.68 30.1401 593.66 30.2201 593.64 30.2901C593.63 30.3401 593.61 30.3901 593.59 30.4401C593.56 30.5101 593.54 30.5901 593.52 30.6701C593.49 30.8801 593.5 30.9501 593.82 31.0201C594.17 31.0801 594.52 31.0201 594.83 30.8501L594.92 30.8101C595.04 30.7601 595.21 30.8101 595.52 30.9001C595.64 30.9401 595.77 30.9701 595.89 30.9901C595.96 30.9701 596.03 30.9901 596.08 31.0401C596.13 31.1001 596.13 31.1801 596.09 31.2401C596.07 31.2801 596.05 31.3201 596.03 31.3601C595.99 31.4301 595.96 31.5001 595.93 31.5701C595.92 31.6101 595.91 31.6601 595.9 31.7001C595.9 31.9201 595.76 32.1101 595.56 32.1901C595.56 32.2401 595.56 32.2801 595.56 32.3301C595.7 32.5001 595.89 32.6101 596.11 32.6401C596.28 32.6701 596.45 32.6301 596.59 32.5201C596.96 32.2101 597.47 32.1701 597.89 32.4001C597.97 32.4301 598.05 32.4601 598.13 32.4801L598.23 32.5101C597.92 31.8201 597.9 31.3401 598.17 31.0501C598.19 30.9101 598.17 30.7701 598.14 30.6301C598.13 30.5701 598.12 30.5101 598.11 30.4501C598.11 30.4001 598.11 30.3601 598.15 30.3201C598.18 30.2801 598.22 30.2601 598.27 30.2501C598.32 30.2501 598.37 30.2501 598.4 30.2801C598.44 30.3101 598.46 30.3501 598.47 30.4001C598.47 30.4501 598.49 30.5101 598.5 30.5601C598.55 30.8301 598.59 31.1201 598.44 31.2801C598.35 31.3801 598.24 31.6601 598.58 32.3801C598.66 32.5001 598.65 32.6601 598.56 32.7701C598.45 32.8801 598.28 32.9101 598.14 32.8401L598.03 32.8101C597.94 32.7801 597.85 32.7501 597.77 32.7201C597.47 32.5401 597.1 32.5701 596.83 32.7901C596.66 32.9301 596.45 33.0001 596.23 32.9901L596.24 33.0001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.8 47.0401C587.79 46.7401 587.76 46.5201 588.16 46.3701C588.51 46.1801 588.87 46.0401 589.25 45.9301C589.41 45.8801 589.53 45.7501 589.57 45.6001C589.58 45.5001 589.41 45.3401 589.28 45.2601C589.06 45.1501 588.8 45.1301 588.57 45.2001C588.03 45.2501 587.48 45.2501 586.93 45.2001C586.74 45.1901 586.75 44.8801 586.91 44.6101C587.14 44.2301 587.37 43.8501 587.57 43.4501C587.62 43.2901 587.64 43.1301 587.64 42.9701C587.53 43.0801 587.42 43.2001 587.32 43.3101C587.29 43.3401 587.28 43.3901 587.25 43.4201C587.15 43.5201 587.04 43.6201 586.94 43.7201C586.97 43.5901 587 43.4601 587.02 43.3301C587.04 43.2301 587.08 43.1002 587.03 43.0202C586.87 42.7102 586.71 42.4601 587.27 42.3801C587.42 42.3601 587.54 41.9701 587.79 41.8501C587.83 41.8301 587.84 41.6701 587.8 41.6201C587.75 41.5501 587.62 41.4701 587.55 41.4901C586.41 41.8701 586.38 40.7801 585.71 40.2501C585.64 40.1401 585.63 39.9901 585.69 39.8701C585.8 39.7601 585.96 39.7201 586.11 39.7401C586.28 39.8301 586.43 39.9401 586.57 40.0701C587.08 40.5201 587.83 40.5701 588.4 40.2001C588.51 40.1301 590.14 40.6401 590.2 40.5401C590.25 40.4701 590.21 40.3501 590.21 40.2501C590.14 40.2801 590.07 40.3102 590.01 40.3402C589.97 40.3602 588.43 39.8201 588.39 39.8301C588.24 39.8801 588.08 39.9101 587.92 39.9501L587.85 39.3301C587.93 39.3101 588.02 39.3001 588.11 39.3101C588.98 39.6201 589.88 39.7801 590.8 39.8001C590.85 39.7801 590.89 39.7101 590.93 39.6701C590.88 39.6501 590.83 39.6301 590.78 39.6301C590.65 39.6301 590.52 39.6302 590.4 39.6502C589.97 39.7402 590.48 39.4301 590.16 39.1401C589.61 38.6501 587.4 38.2301 586.77 38.1001C586.64 38.1001 586.52 38.1001 586.39 38.0801C586.24 38.0101 586.1 37.9301 585.97 37.8301C586.06 37.7301 586.14 37.6202 586.24 37.5202C586.3 37.4602 586.36 37.4001 586.44 37.3601C586.7 37.2101 586.73 37.0801 586.43 36.9501C586.33 36.9201 586.23 36.8801 586.14 36.8201C586.06 36.7501 586.02 36.6501 586.02 36.5501C586.06 36.1101 586.34 35.7401 586.74 35.5701C586.91 35.5401 587.05 35.4401 587.14 35.2901C587.23 35.1401 587.24 34.9701 587.19 34.8001C587.19 34.6801 587.22 34.5702 587.27 34.4602C587.36 34.5102 587.46 34.5501 587.54 34.6001C587.59 34.6401 587.64 34.6801 587.68 34.7201C587.89 34.8801 588.06 34.9701 588.08 34.5701C588.08 34.4901 587.73 34.4401 587.78 34.4401C588.24 34.3801 587.6 34.2601 587.83 33.9201C588 33.6701 588.2 33.6201 588.4 33.8201C588.57 33.9901 589.02 33.9701 588.84 34.4401C588.79 34.5601 589.49 34.7801 589.73 34.6801C590.06 34.5401 590.96 35.1901 591.2 35.6301C591.26 35.7501 591.71 35.7701 591.9 35.6701C592.27 35.4901 592.68 35.4601 593.07 35.5701C593.19 35.6101 593.32 35.6301 593.44 35.6101C593.55 35.5801 593.63 35.4601 593.73 35.3801C593.64 35.2901 593.56 35.1301 593.46 35.1101C593.08 35.0501 592.06 34.3001 591.68 34.2301C591.16 34.1401 590.64 34.0102 590.15 33.8402C589.74 33.6902 589.74 33.5701 590.07 33.2601C590.35 32.9901 589.74 32.1401 589.38 31.8901C589.18 31.7501 589.17 31.5101 589.39 31.4701C590.02 31.2801 590.62 30.9902 591.14 30.5902C591.3 30.5002 591.47 30.4801 591.39 30.7201C591.19 31.3001 592.09 31.9501 592.48 32.1901C592.89 32.4401 593.06 32.7101 592.89 33.1701C592.85 33.2501 592.84 33.3301 592.86 33.4201C592.91 33.5501 592.97 33.6801 593.04 33.8001C593.14 33.7201 593.22 33.6401 593.3 33.5401C593.42 33.3701 593.52 33.1801 593.63 33.0001C593.77 32.7701 593.9 32.5502 593.54 32.4002C593.48 32.3502 593.44 32.2701 593.45 32.1801C593.46 32.1301 593.58 32.1001 593.65 32.0801C593.69 32.0701 593.73 32.0601 593.78 32.0801C593.94 32.1001 594.1 32.1302 594.26 32.1502C594.22 32.3302 594.24 32.5601 594.13 32.6801C593.87 32.9801 593.93 33.1901 594.18 33.4401C594.42 33.6801 594.99 34.7202 594.87 35.0302C594.65 35.6402 595.09 35.7301 594.5 35.8601C594.33 35.8801 594.19 36.0101 594.17 36.1801C594.15 36.2801 593.96 36.3501 593.85 36.4301C593.8 36.3301 593.75 36.2401 593.69 36.1401C593.65 36.0801 593.61 35.9602 593.57 35.9602C593.47 35.9602 593.37 35.9901 593.3 36.0501C593.18 36.1401 593.08 36.2601 593 36.3901C592.97 36.4501 593.03 36.5901 593.09 36.6601C593.46 37.1601 593.69 37.5701 593.09 37.6701C593.03 37.6801 592.94 37.7001 592.9 37.6701C592.69 37.5201 592.05 37.4201 591.8 37.7201C591.32 37.4801 590.89 37.7201 590.45 37.8601C590.28 37.9101 590.16 37.8701 590.15 37.6601C590.15 37.5301 590.13 37.4101 590.07 37.2901C589.92 37.1001 589.99 37.0101 590.16 36.8901C590.27 36.8001 589.46 36.8501 589.54 36.7301C589.65 36.5701 589.62 36.4601 589.44 36.3801C589.19 36.2701 588.31 35.3501 588.05 35.2601C587.88 35.2001 588.12 35.1201 587.93 35.1001C587.96 35.2501 588.19 36.2701 588.2 36.4201C588.21 36.5501 588.64 36.5801 588.62 36.7001C588.56 37.1001 589.2 37.3201 589.34 37.6701C589.58 38.2701 590.55 38.3002 591.02 38.5202C591.2 38.5602 591.39 38.5401 591.56 38.4801C591.68 38.4501 591.78 38.3501 591.9 38.3101C592.05 38.2701 592.21 38.2402 592.37 38.2102L592.44 38.8301C592.36 38.8301 592.25 38.8501 592.21 38.8101C592.04 38.6301 591.89 38.6001 591.79 38.8601C591.71 39.0801 591.35 39.3202 591.77 39.5302C591.93 39.6102 592.06 39.6601 591.99 39.8301C591.96 39.9101 591.79 39.9401 591.69 40.0001C591.67 40.0001 591.65 40.0001 591.63 40.0001C591.46 40.0301 591.2 39.9401 591.22 40.2501C591.23 40.5601 591.49 40.4702 591.65 40.4602C591.95 40.4402 592.08 40.5501 592.08 40.8501C592.08 41.1301 592.1 41.4001 592.12 41.6801C592.13 41.8801 592.08 42.1202 592.43 42.0902C592.47 42.0902 591.7 42.4802 591.71 42.5902C591.76 43.1102 590.36 42.6801 590.83 42.7401C590.96 42.7501 591.08 42.7501 591.21 42.7501C591.67 42.7501 591.18 42.4201 591.13 42.8501C591.09 43.2201 591.48 43.9202 591.36 44.2802C591.3 44.4502 591.26 44.5601 591.5 44.5501C591.52 44.5501 591.54 44.5501 591.56 44.5501C591.75 44.6301 591.4 44.3802 591.59 44.4602C591.61 44.2602 591.63 44.0601 591.67 43.8601C591.69 43.7801 591.74 43.7201 591.81 43.6801", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.62 47.0501H587.8L587.62 47.0201C587.54 46.6701 587.75 46.3101 588.1 46.2101C588.23 46.1601 588.35 46.1001 588.47 46.0401C588.71 45.9101 588.96 45.8101 589.23 45.7601C589.31 45.7201 589.37 45.6601 589.4 45.5801C589.33 45.5201 589.26 45.4601 589.19 45.4101C589.05 45.3201 588.9 45.3301 588.66 45.3701H588.6C588.09 45.4301 587.57 45.4301 587.05 45.3701H586.92C586.81 45.3501 586.71 45.2901 586.66 45.1901C586.58 44.9601 586.62 44.7001 586.76 44.5001C586.94 44.2101 587.11 43.9301 587.27 43.6401C587.23 43.6801 587.19 43.7101 587.16 43.7501L587.07 43.8301C587.01 43.8801 586.93 43.9001 586.86 43.8601C586.79 43.8201 586.76 43.7401 586.77 43.6601L586.8 43.5501C586.82 43.4601 586.84 43.3701 586.86 43.2901V43.2201C586.86 43.2201 586.89 43.1301 586.89 43.0901L586.87 43.0501C586.77 42.8601 586.66 42.6601 586.76 42.4701C586.88 42.3101 587.07 42.2101 587.27 42.2001C587.3 42.1501 587.32 42.1101 587.36 42.0701C587.44 41.9301 587.55 41.8201 587.68 41.7201C587.68 41.7201 587.68 41.7001 587.68 41.6901C587.68 41.6901 587.63 41.6701 587.61 41.6601C586.75 41.9501 586.42 41.4301 586.12 40.9701C585.99 40.7501 585.83 40.5501 585.64 40.3801C585.56 40.3001 585.51 40.1801 585.51 40.0701C585.5 39.9501 585.53 39.8301 585.6 39.7401C585.76 39.5901 585.98 39.5201 586.2 39.5601C586.34 39.6101 586.47 39.7001 586.58 39.8101C586.62 39.8501 586.67 39.8901 586.71 39.9201C587.16 40.3201 587.83 40.3701 588.34 40.0401H588.36C588.29 40.0401 588.21 40.0701 588.14 40.0901L588.01 40.1201C587.96 40.1301 587.91 40.1201 587.86 40.0901C587.82 40.0601 587.79 40.0101 587.78 39.9601L587.71 39.3401C587.71 39.3401 587.71 39.2401 587.75 39.2101C587.78 39.1701 587.83 39.1501 587.87 39.1501C587.89 39.1501 587.91 39.1501 587.94 39.1401C588.03 39.1201 588.12 39.1201 588.21 39.1401C588.82 39.3301 589.45 39.4901 590.08 39.5901C590.08 39.5501 590.09 39.5101 590.11 39.4701C590.14 39.3601 590.15 39.3201 590.08 39.2601C589.08 38.7801 588.02 38.4501 586.93 38.2901L586.78 38.2601C586.78 38.2601 586.69 38.2601 586.65 38.2601C586.56 38.2601 586.46 38.2601 586.37 38.2301C586.25 38.1801 586.14 38.1201 586.04 38.0501C586 38.0201 585.96 38.0001 585.92 37.9701C585.87 37.9401 585.84 37.9001 585.84 37.8401C585.84 37.7901 585.84 37.7301 585.88 37.7001L585.96 37.6101C586.02 37.5301 586.09 37.4601 586.16 37.3901C586.23 37.3101 586.31 37.2501 586.4 37.2001C586.43 37.1801 586.46 37.1701 586.48 37.1501C586.46 37.1401 586.43 37.1201 586.4 37.1101C586.37 37.1001 586.35 37.0901 586.32 37.0801C586.22 37.0501 586.14 37.0101 586.06 36.9401C585.94 36.8301 585.87 36.6601 585.89 36.5001C585.94 36.0001 586.27 35.5801 586.73 35.3901C587.03 35.3001 587.11 35.1501 587.06 34.8201C587.05 34.7101 587.06 34.6001 587.11 34.5001C587.12 34.4701 587.13 34.4401 587.14 34.4101C587.15 34.3601 587.19 34.3101 587.24 34.2901C587.29 34.2701 587.35 34.2701 587.4 34.2901L587.48 34.3301C587.54 34.3601 587.6 34.3901 587.66 34.4201C587.66 34.3701 587.69 34.3201 587.74 34.2901C587.64 34.1501 587.64 33.9601 587.74 33.8101C587.83 33.6501 587.98 33.5401 588.16 33.5101C588.32 33.5101 588.48 33.5701 588.58 33.6901C588.63 33.7201 588.68 33.7501 588.73 33.7701C588.86 33.8001 588.98 33.8901 589.05 34.0101C589.12 34.1301 589.14 34.2701 589.1 34.4001C589.29 34.4901 589.51 34.5301 589.73 34.5101C590.21 34.3101 591.18 35.0901 591.43 35.5301C591.58 35.5601 591.74 35.5501 591.89 35.5001C592.29 35.3001 592.75 35.2601 593.18 35.3801L593.26 35.4001C593.33 35.4201 593.4 35.4301 593.47 35.4301C593.51 35.4101 593.54 35.3901 593.57 35.3501C593.55 35.3201 593.53 35.2901 593.5 35.2701C593.16 35.1601 592.83 35.0101 592.54 34.8001C592.29 34.6401 592.02 34.5001 591.74 34.3901C591.21 34.3001 590.68 34.1701 590.18 33.9901C589.98 33.9201 589.79 33.8201 589.75 33.6401C589.71 33.4501 589.87 33.2701 590.03 33.1101C590.05 33.0901 590.05 33.0501 590.05 33.0201C589.94 32.6201 589.7 32.2701 589.37 32.0201C589.21 31.9201 589.12 31.7401 589.15 31.5501C589.18 31.4001 589.3 31.2901 589.45 31.2701C589.91 31.1601 590.34 30.9601 590.72 30.6701C590.86 30.5801 591 30.4901 591.14 30.4101C591.27 30.3101 591.45 30.2901 591.59 30.3801C591.66 30.4401 591.72 30.5501 591.65 30.7501C591.5 31.1701 592.22 31.7401 592.66 32.0001C592.88 32.0901 593.06 32.2701 593.15 32.5001C593.24 32.7301 593.24 32.9801 593.14 33.2001C593.12 33.2401 593.11 33.2901 593.11 33.3301C593.13 33.3801 593.15 33.4301 593.17 33.4801C593.2 33.4601 593.22 33.4301 593.24 33.4001C593.31 33.3001 593.38 33.1801 593.44 33.0701C593.48 33.0001 593.52 32.9301 593.56 32.8601C593.61 32.7901 593.69 32.6501 593.68 32.6001C593.68 32.6001 593.66 32.5601 593.55 32.5101C593.4 32.4201 593.33 32.2501 593.36 32.0801C593.4 31.9501 593.53 31.9001 593.63 31.8701H593.67C593.74 31.8301 593.81 31.8301 593.88 31.8401C593.99 31.8501 594.1 31.8701 594.22 31.8901L594.37 31.9101C594.37 31.9101 594.46 31.9401 594.49 31.9901C594.52 32.0301 594.53 32.0801 594.52 32.1301C594.51 32.1801 594.5 32.2401 594.5 32.2901C594.5 32.4501 594.45 32.6101 594.35 32.7401C594.17 32.9401 594.18 33.0501 594.39 33.2601C594.63 33.5001 595.28 34.6001 595.13 35.0401C595.07 35.1801 595.06 35.3401 595.08 35.4901C595.12 35.7801 595.01 35.9001 594.63 35.9901C594.5 36.0201 594.46 36.0501 594.44 36.1801C594.41 36.3301 594.27 36.4101 594.15 36.4801C594.12 36.5001 594.08 36.5201 594.05 36.5401C594.01 36.5701 593.96 36.5801 593.9 36.5701C593.85 36.5601 593.81 36.5301 593.78 36.4801L593.73 36.3801C593.7 36.3201 593.66 36.2501 593.63 36.1901C593.62 36.1701 593.61 36.1401 593.59 36.1201C593.59 36.1201 593.53 36.1301 593.51 36.1501C593.41 36.2301 593.32 36.3201 593.26 36.4301C593.27 36.4101 593.3 36.4701 593.33 36.5201C593.59 36.8701 593.82 37.2201 593.7 37.5001C593.6 37.6901 593.41 37.8001 593.2 37.8101C593.09 37.8401 592.98 37.8301 592.88 37.7801C592.71 37.6601 592.2 37.5901 592.03 37.8001C591.98 37.8701 591.89 37.8901 591.81 37.8501C591.49 37.7301 591.14 37.7501 590.84 37.9201C590.76 37.9501 590.68 37.9801 590.59 38.0001C590.47 38.0501 590.33 38.0401 590.22 37.9701C590.12 37.8901 590.06 37.7701 590.06 37.6401V37.5901C590.06 37.5101 590.05 37.4401 590.02 37.3701C589.94 37.2801 589.9 37.1601 589.91 37.0401C589.91 37.0201 589.91 37.0001 589.93 36.9801C589.68 36.9601 589.53 36.9401 589.47 36.8101C589.44 36.7401 589.45 36.6701 589.49 36.6101C589.5 36.5901 589.51 36.5701 589.52 36.5501C589.52 36.5501 589.5 36.5401 589.47 36.5201C589.22 36.3601 588.99 36.1801 588.78 35.9701C588.64 35.8501 588.46 35.6801 588.32 35.5701C588.4 35.9301 588.46 36.2001 588.48 36.3301C588.51 36.3401 588.56 36.3601 588.59 36.3701C588.73 36.4201 588.94 36.5001 588.91 36.7101C588.89 36.8401 589.02 36.9601 589.22 37.1201C589.39 37.2401 589.53 37.4001 589.62 37.5901C589.76 37.9301 590.24 38.0601 590.66 38.1701C590.85 38.2101 591.03 38.2701 591.21 38.3501C591.33 38.3701 591.45 38.3501 591.56 38.3201L591.64 38.3001C591.64 38.3001 591.73 38.2601 591.77 38.2401C591.83 38.2001 591.9 38.1701 591.96 38.1401C592.07 38.1101 592.19 38.0801 592.31 38.0601L592.45 38.0301C592.45 38.0301 592.55 38.0301 592.59 38.0601C592.63 38.0901 592.66 38.1401 592.66 38.1901L592.73 38.8101C592.73 38.8601 592.72 38.9201 592.68 38.9501C592.64 38.9901 592.59 39.0101 592.54 39.0001C592.52 39.0001 592.5 39.0001 592.48 39.0001C592.38 39.0201 592.27 38.9901 592.19 38.9201C592.16 38.8901 592.13 38.8601 592.1 38.8401C592.1 38.8501 592.09 38.8701 592.07 38.9101C592.04 38.9801 592 39.0501 591.95 39.1201C591.91 39.1701 591.88 39.2301 591.86 39.2901C591.86 39.2901 591.87 39.3201 591.96 39.3601C592.12 39.4401 592.4 39.5701 592.27 39.8801C592.21 39.9901 592.1 40.0701 591.97 40.1001C591.94 40.1101 591.91 40.1201 591.88 40.1401C591.84 40.1601 591.8 40.1601 591.76 40.1601C591.71 40.1601 591.66 40.1701 591.61 40.1701C591.57 40.1701 591.54 40.1701 591.5 40.1701C591.5 40.1701 591.5 40.1901 591.5 40.2201C591.5 40.2401 591.5 40.2601 591.51 40.2801C591.56 40.2801 591.6 40.2801 591.65 40.2601C591.68 40.2601 591.71 40.2601 591.74 40.2501C591.91 40.2201 592.08 40.2701 592.21 40.3701C592.32 40.4901 592.38 40.6501 592.37 40.8201C592.37 41.0601 592.39 41.3001 592.4 41.5401V41.7301C592.4 41.7301 592.41 41.8301 592.42 41.8801C592.42 41.8801 592.48 41.8801 592.51 41.8801C592.59 41.8801 592.67 41.9201 592.7 42.0001C592.74 42.1401 592.65 42.2001 592.48 42.3001C592.31 42.3901 592.15 42.5001 591.99 42.6101C591.99 42.7501 591.89 42.8801 591.76 42.9301C591.65 42.9701 591.53 42.9901 591.41 42.9901C591.44 43.1301 591.47 43.2701 591.52 43.4001C591.55 43.5101 591.58 43.6201 591.61 43.7301C591.65 43.6201 591.73 43.5301 591.84 43.4801C591.9 43.4501 591.97 43.4601 592.02 43.5001C592.07 43.5401 592.1 43.6001 592.09 43.6601C592.08 43.7201 592.04 43.7801 591.98 43.8101C591.96 43.8201 591.95 43.8401 591.94 43.8701C591.91 44.0101 591.9 44.1501 591.88 44.2801L591.86 44.4301C591.9 44.4901 591.9 44.5701 591.86 44.6301C591.82 44.6901 591.74 44.7401 591.58 44.6801C591.47 44.7101 591.35 44.6701 591.27 44.5801C591.2 44.4601 591.2 44.3201 591.27 44.2001C591.29 43.9601 591.26 43.7301 591.17 43.5101C591.11 43.3301 591.07 43.1501 591.04 42.9601C590.92 42.9501 590.8 42.9001 590.7 42.8301C590.65 42.7701 590.63 42.6901 590.67 42.6201C590.73 42.5001 590.87 42.5101 590.95 42.5301C591.02 42.5301 591.08 42.5401 591.15 42.5301C591.22 42.4501 591.32 42.4001 591.43 42.4101C591.51 42.4101 591.58 42.4501 591.63 42.5101C591.65 42.3801 591.79 42.2701 592.12 42.0701C592.06 41.9601 592.03 41.8401 592.03 41.7201V41.5501C592 41.3001 591.99 41.0501 591.99 40.8001C591.99 40.7401 591.99 40.6701 591.95 40.6201C591.89 40.5901 591.82 40.5801 591.75 40.5901H591.68C591.54 40.6401 591.38 40.6101 591.26 40.5301C591.09 40.3601 591.08 40.0901 591.22 39.9001C591.32 39.8101 591.45 39.7701 591.58 39.7801C591.61 39.7801 591.65 39.7801 591.68 39.7801C591.68 39.7801 591.71 39.7801 591.73 39.7801C591.76 39.7701 591.79 39.7601 591.82 39.7401C591.85 39.7301 591.89 39.7101 591.92 39.7001C591.88 39.7001 591.84 39.6801 591.81 39.6701C591.62 39.5801 591.52 39.4801 591.49 39.3501C591.47 39.1801 591.52 39.0201 591.63 38.8901C591.66 38.8501 591.69 38.8001 591.71 38.7601C591.74 38.6901 591.77 38.6201 591.82 38.5701C591.78 38.5901 591.73 38.6101 591.68 38.6201L591.61 38.6401C591.42 38.7101 591.22 38.7101 591.03 38.6501C590.87 38.5901 590.71 38.5301 590.54 38.4901C590.06 38.3601 589.46 38.2001 589.26 37.7001C589.18 37.5701 589.08 37.4601 588.96 37.3701C588.73 37.2301 588.57 36.9901 588.52 36.7101C588.49 36.7001 588.46 36.6901 588.43 36.6801C588.29 36.6301 588.11 36.5601 588.1 36.3901C588.1 36.3101 587.99 35.8101 587.92 35.5201C587.88 35.3201 587.84 35.1401 587.83 35.0901C587.83 35.0401 587.83 34.9901 587.86 34.9501C587.77 34.9101 587.68 34.8601 587.61 34.8001C587.58 34.7801 587.56 34.7601 587.53 34.7301C587.51 34.7101 587.5 34.7001 587.48 34.6801C587.46 34.6701 587.43 34.6501 587.41 34.6401C587.41 34.6601 587.41 34.6801 587.41 34.7001C587.47 34.9001 587.44 35.1301 587.34 35.3101C587.23 35.4901 587.05 35.6201 586.84 35.6701C586.48 35.7801 586.34 36.0901 586.24 36.5201C586.26 36.5601 586.28 36.5901 586.31 36.6201C586.35 36.6501 586.39 36.6601 586.44 36.6801C586.48 36.6901 586.51 36.7101 586.54 36.7201C586.62 36.7501 586.85 36.8501 586.86 37.0701C586.87 37.2601 586.7 37.3801 586.56 37.4601C586.5 37.5001 586.45 37.5401 586.41 37.5901C586.37 37.6401 586.32 37.6801 586.28 37.7301C586.35 37.7801 586.42 37.8201 586.49 37.8501C586.54 37.8601 586.58 37.8601 586.63 37.8501C586.7 37.8501 586.77 37.8501 586.85 37.8601L587 37.8901C588.16 38.0401 589.29 38.4001 590.32 38.9401C590.45 39.0501 590.52 39.2201 590.48 39.3901C590.58 39.3801 590.68 39.3801 590.78 39.3801C590.85 39.3801 590.92 39.3901 590.98 39.4201C591.04 39.4401 591.1 39.4901 591.12 39.5501C591.14 39.6101 591.13 39.6801 591.09 39.7301C591.04 39.8001 590.97 39.8601 590.9 39.9001C589.94 39.9001 588.99 39.7301 588.08 39.4101L588.11 39.6501C588.2 39.6301 588.28 39.6001 588.37 39.5801C588.416 39.5668 588.696 39.6434 589.21 39.8101C589.5 39.9101 589.88 40.0301 590.02 40.0701C590.05 40.0501 590.09 40.0401 590.12 40.0301L590.17 40.0101C590.23 39.9901 590.29 39.9901 590.34 40.0301C590.39 40.0601 590.42 40.1201 590.42 40.1801C590.42 40.2101 590.42 40.2301 590.42 40.2601C590.44 40.3701 590.42 40.4801 590.37 40.5701C590.27 40.7201 590.14 40.7001 589.22 40.4701C588.95 40.4001 588.6 40.3201 588.48 40.3001C587.85 40.6901 587.04 40.6301 586.49 40.1401C586.44 40.1001 586.38 40.0501 586.33 40.0101C586.26 39.9401 586.17 39.8801 586.08 39.8401C585.99 39.8401 585.9 39.8701 585.84 39.9301C585.84 39.9301 585.85 40.0301 585.87 40.0601C586.08 40.2501 586.27 40.4701 586.41 40.7101C586.7 41.1601 586.89 41.4501 587.53 41.2501C587.7 41.2201 587.87 41.3001 587.98 41.4401C588.04 41.5401 588.05 41.6601 588.02 41.7801C588.01 41.8501 587.96 41.9101 587.89 41.9501C587.79 42.0201 587.71 42.1101 587.65 42.2101C587.56 42.3401 587.47 42.4701 587.32 42.4901C587.11 42.5201 587.08 42.5701 587.08 42.5701C587.1 42.6601 587.14 42.7501 587.19 42.8301L587.22 42.8801C587.25 42.9401 587.26 43.0101 587.26 43.0801C587.32 43.0201 587.38 42.9501 587.44 42.8901L587.53 42.7901C587.58 42.7301 587.67 42.7201 587.74 42.7501C587.81 42.7801 587.85 42.8601 587.84 42.9301C587.84 42.9801 587.84 43.0201 587.84 43.0701C587.84 43.2101 587.82 43.3401 587.76 43.4701C587.56 43.8701 587.33 44.2501 587.09 44.6401C587.02 44.7401 586.99 44.8601 587 44.9801H587.09C587.58 45.0201 588.07 45.0201 588.56 44.9801H588.61C588.87 44.9001 589.16 44.9301 589.39 45.0701C589.51 45.1501 589.79 45.3601 589.76 45.5901C589.71 45.8301 589.52 46.0201 589.29 46.0801C589.06 46.1301 588.84 46.2101 588.64 46.3301C588.51 46.4001 588.37 46.4601 588.23 46.5201C587.97 46.6201 587.97 46.7001 587.98 46.9801L587.8 47.0201H587.62V47.0501ZM592.07 38.5201C592.16 38.5201 592.25 38.5601 592.32 38.6201L592.3 38.4601C592.21 38.4701 592.13 38.4901 592.05 38.5201C592.04 38.5201 592.03 38.5201 592.02 38.5301C592.04 38.5301 592.06 38.5301 592.07 38.5301V38.5201ZM590.25 37.1401C590.25 37.1401 590.26 37.1601 590.29 37.2001C590.37 37.3301 590.41 37.4701 590.4 37.6201V37.6601C590.4 37.6601 590.4 37.7001 590.41 37.7101C590.41 37.7101 590.44 37.7101 590.47 37.6901C590.55 37.6701 590.62 37.6401 590.7 37.6101C591.05 37.4401 591.46 37.4001 591.83 37.5101C592.2 37.2901 592.66 37.2901 593.04 37.5101C593.06 37.5101 593.08 37.5101 593.09 37.5101C593.27 37.4801 593.33 37.4401 593.35 37.4101C593.38 37.3301 593.27 37.1201 593.02 36.7801C592.99 36.7301 592.82 36.5001 592.92 36.3201C593.01 36.1701 593.12 36.0301 593.27 35.9201C593.38 35.8301 593.52 35.7901 593.66 35.7901C593.8 35.7901 593.86 35.9201 593.9 36.0101L593.93 36.0601C593.93 36.0601 593.98 36.1401 594 36.1801C594.03 36.1601 594.06 36.1401 594.09 36.1201C594.13 35.8901 594.31 35.7101 594.54 35.6801C594.61 35.6701 594.67 35.6501 594.73 35.6201C594.73 35.6201 594.72 35.5901 594.72 35.5701C594.69 35.3601 594.71 35.1501 594.78 34.9501C594.69 34.4301 594.46 33.9501 594.13 33.5501C593.99 33.4301 593.9 33.2601 593.86 33.0701C593.82 33.1501 593.78 33.2201 593.74 33.2801C593.67 33.4001 593.6 33.5201 593.52 33.6301C593.46 33.7101 593.39 33.7801 593.31 33.8401C593.28 33.8601 593.26 33.8901 593.23 33.9101C593.19 33.9501 593.13 33.9701 593.08 33.9601C593.03 33.9501 592.98 33.9201 592.95 33.8601L592.9 33.7601C592.84 33.6601 592.8 33.5601 592.76 33.4601C592.73 33.3401 592.74 33.2101 592.79 33.0901C592.92 32.7501 592.83 32.5501 592.46 32.3201C592.14 32.1301 591.13 31.4601 591.26 30.7501C591.13 30.8201 591.01 30.9001 590.89 30.9801C590.47 31.2901 589.99 31.5101 589.49 31.6301C589.47 31.6301 589.49 31.6901 589.55 31.7301C589.97 32.0401 590.27 32.4901 590.39 33.0001C590.41 33.1401 590.36 33.2801 590.26 33.3801C590.19 33.4401 590.13 33.5101 590.08 33.5801C590.09 33.5801 590.14 33.6101 590.28 33.6601C590.77 33.8301 591.27 33.9601 591.79 34.0501C592.11 34.1601 592.42 34.3101 592.71 34.5001C592.98 34.6701 593.26 34.8201 593.56 34.9301C593.69 34.9701 593.8 35.0501 593.86 35.1701C593.88 35.2001 593.9 35.2301 593.93 35.2501C593.96 35.2901 593.98 35.3301 593.98 35.3801C593.98 35.4301 593.95 35.4801 593.92 35.5101C593.89 35.5301 593.87 35.5601 593.84 35.5801C593.76 35.6701 593.67 35.7401 593.56 35.7801C593.43 35.8101 593.3 35.8001 593.17 35.7601L593.1 35.7401C592.75 35.6401 592.38 35.6701 592.05 35.8201C591.83 35.9301 591.25 35.9501 591.11 35.7001C590.87 35.2701 590.04 34.7601 589.86 34.8301C589.49 34.9101 589.1 34.8301 588.79 34.6101C588.72 34.5501 588.69 34.4501 588.72 34.3601C588.79 34.1801 588.76 34.1701 588.57 34.0801C588.48 34.0401 588.39 33.9901 588.32 33.9301C588.29 33.9001 588.25 33.8401 588.19 33.8601C588.14 33.8601 588.09 33.9201 588.03 34.0001C588 34.0401 587.99 34.0601 588.08 34.1501C588.14 34.2001 588.18 34.2801 588.18 34.3601C588.26 34.4001 588.31 34.4801 588.3 34.5701C588.3 34.7201 588.25 34.8601 588.15 34.9601C588.19 34.9801 588.22 35.0101 588.23 35.0401C588.24 35.0701 588.25 35.1001 588.25 35.1301C588.52 35.3101 588.76 35.5101 588.99 35.7301C589.17 35.9101 589.37 36.0701 589.58 36.2201C589.7 36.2601 589.8 36.3601 589.84 36.4801C589.85 36.5301 589.86 36.5901 589.84 36.6401C589.89 36.6401 589.94 36.6401 589.98 36.6501C590.23 36.6701 590.36 36.6801 590.4 36.8201C590.42 36.9001 590.39 36.9801 590.33 37.0301C590.29 37.0501 590.26 37.0801 590.23 37.1101L590.25 37.1401ZM593.73 32.2701C593.86 32.3201 593.96 32.4201 594 32.5501C594 32.5701 594.01 32.6001 594.01 32.6201C594.03 32.6001 594.04 32.5801 594.06 32.5601C594.1 32.4801 594.12 32.3901 594.12 32.3101C594.02 32.2801 593.92 32.2701 593.81 32.2501L593.72 32.2701H593.73Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.84 45.7001L592.17 45.2401C591.84 45.1001 591.49 45.0101 591.14 44.9501C590.91 44.8901 590.91 45.1301 590.92 45.3001C590.94 45.5501 591.49 45.6401 591.84 45.7001Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.84 45.8701C591.84 45.8701 591.82 45.8701 591.81 45.8701H591.76C591.34 45.7901 590.77 45.6901 590.75 45.3101C590.72 45.1401 590.76 44.9601 590.88 44.8301C590.97 44.7601 591.08 44.7401 591.19 44.7701C591.24 44.7801 591.32 44.8001 591.41 44.8201C591.71 44.8601 592 44.9501 592.28 45.0901C592.32 45.1201 592.35 45.1601 592.35 45.2101C592.35 45.2601 592.35 45.31 592.32 45.35L591.99 45.8101C591.99 45.8101 591.9 45.8801 591.85 45.8801L591.84 45.8701ZM591.1 45.1201C591.1 45.1701 591.1 45.2301 591.1 45.2801C591.13 45.3501 591.35 45.4201 591.76 45.4901L591.9 45.3001C591.73 45.2501 591.5 45.2 591.33 45.16C591.24 45.14 591.15 45.1201 591.1 45.1101V45.1201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.87 36.7802L588.53 36.6001C588.47 36.6901 588.43 36.8001 588.41 36.9001C588.41 36.9601 588.57 37.0701 588.61 37.0601C588.7 37.0201 588.76 36.9101 588.88 36.7701L588.87 36.7802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.59 37.2501C588.53 37.2501 588.47 37.2301 588.42 37.1901C588.31 37.1301 588.24 37.0301 588.22 36.9101C588.22 36.8001 588.26 36.7001 588.32 36.6101C588.33 36.5801 588.35 36.5602 588.36 36.5302C588.38 36.4902 588.42 36.4501 588.46 36.4401C588.51 36.4201 588.56 36.4301 588.6 36.4401L588.94 36.6101C588.94 36.6101 589.02 36.6801 589.03 36.7401C589.04 36.7901 589.03 36.8501 588.99 36.8901C588.95 36.9301 588.92 36.9701 588.9 37.0001C588.84 37.0901 588.76 37.1601 588.66 37.2201C588.63 37.2301 588.6 37.2401 588.58 37.2401L588.59 37.2501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.81 45.4901C591.81 45.4901 591.73 45.4301 591.68 45.4001C591.68 45.4001 591.65 45.4201 591.63 45.4201C591.66 45.4601 591.69 45.5101 591.72 45.5501L591.81 45.4901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.71 45.7301C591.71 45.7301 591.61 45.7101 591.58 45.6701C591.55 45.6301 591.52 45.5901 591.49 45.5401C591.46 45.4901 591.45 45.4402 591.46 45.3902C591.47 45.3402 591.5 45.3002 591.55 45.2702C591.61 45.2202 591.7 45.2101 591.77 45.2501C591.81 45.2701 591.84 45.3002 591.88 45.3302C591.93 45.3702 591.97 45.4301 591.97 45.4901C591.97 45.5501 591.95 45.6102 591.91 45.6502L591.86 45.6801C591.86 45.6801 591.76 45.7301 591.71 45.7401V45.7301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M598.02 28.9101C597.68 29.0901 597.33 29.2501 596.98 29.3901C596.61 29.2501 596.15 29.4601 596.08 28.9001C596.08 28.8401 595.92 28.8001 595.83 28.7401C595.65 28.6401 595.48 28.5101 595.33 28.3701C595.09 28.0901 595.14 28.0101 595.49 27.8201C595.67 27.7101 595.84 27.5801 595.99 27.4401C596.23 27.1801 596.64 27.1501 596.91 27.3701", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M596.97 29.5801C596.97 29.5801 596.93 29.5801 596.91 29.5701C596.81 29.5401 596.71 29.5201 596.6 29.5201C596.35 29.5001 595.98 29.47 595.9 28.99L595.85 28.97C595.85 28.97 595.76 28.9201 595.71 28.9001C595.66 28.8701 595.62 28.8401 595.57 28.8101C595.43 28.7301 595.29 28.6201 595.18 28.5001C595.05 28.3901 594.99 28.2301 594.99 28.0601C595.02 27.8801 595.19 27.78 595.39 27.67C595.53 27.59 595.66 27.4901 595.77 27.3801L595.85 27.3101C596.16 26.9901 596.65 26.96 597 27.23C597.07 27.29 597.09 27.4 597.03 27.48C596.97 27.56 596.86 27.5701 596.78 27.5201C596.68 27.4401 596.55 27.39 596.42 27.41C596.29 27.42 596.17 27.4901 596.08 27.5901L596 27.66C595.86 27.79 595.71 27.9001 595.55 28.0001C595.47 28.0401 595.4 28.0801 595.33 28.1401C595.33 28.1401 595.36 28.1801 595.44 28.2801C595.53 28.3801 595.64 28.4601 595.75 28.5201C595.8 28.5501 595.85 28.5901 595.9 28.6201C595.93 28.6401 595.95 28.65 595.98 28.66C596.08 28.71 596.2 28.7601 596.22 28.9001C596.25 29.1401 596.32 29.15 596.6 29.17C596.71 29.17 596.82 29.19 596.93 29.22C597.01 29.19 597.09 29.1501 597.17 29.1201C597.42 29.0201 597.66 28.9101 597.89 28.7801C597.95 28.7501 598.01 28.7501 598.07 28.7801C598.13 28.8101 598.16 28.8701 598.16 28.9301C598.16 28.9901 598.13 29.0501 598.07 29.0901C597.82 29.2301 597.57 29.3501 597.3 29.4501C597.2 29.4901 597.1 29.5301 597 29.5801C596.98 29.5901 596.95 29.6 596.93 29.6L596.97 29.5801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M591.01 29.0801H591.14C591.89 29.0401 591.99 29.0902 592.23 29.7802C592.23 29.8702 592.19 29.9501 592.11 29.9901C591.91 30.0601 591.7 30.1101 591.49 30.1401C591 30.1701 590.54 30.4101 590.23 30.7901C590.13 30.9201 590 31.0501 589.81 30.8901C589.6 30.7101 589.22 30.6701 589.22 30.3001C589.22 30.2201 589.36 30.1101 589.46 30.0801C589.64 30.0201 589.89 30.0801 590 29.9601C590.1 29.8601 590.07 29.6101 590.07 29.4201C590.07 29.2101 590.16 29.1101 590.37 29.1001C590.58 29.1001 590.79 29.0801 591 29.0701L591.01 29.0801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M589.99 31.1502C589.88 31.1502 589.78 31.1002 589.71 31.0302C589.65 30.9802 589.59 30.9402 589.52 30.9102C589.26 30.8202 589.07 30.5802 589.06 30.3002C589.06 30.1002 589.29 29.9502 589.42 29.9002C589.51 29.8702 589.61 29.8602 589.7 29.8602C589.76 29.8602 589.83 29.8602 589.89 29.8302C589.91 29.7302 589.92 29.6302 589.91 29.5402V29.4202C589.89 29.2902 589.94 29.1602 590.03 29.0602C590.12 28.9602 590.25 28.9202 590.38 28.9202C590.52 28.9202 590.67 28.9102 590.82 28.9002H590.99C590.99 28.9002 591.01 28.8902 591.02 28.8902H591.15C591.99 28.8402 592.15 28.9502 592.42 29.7102C592.44 29.7902 592.43 29.8702 592.39 29.9502C592.35 30.0402 592.28 30.1102 592.19 30.1502C591.98 30.2302 591.76 30.2802 591.54 30.3102C591.1 30.3302 590.68 30.5502 590.4 30.8902C590.32 31.0202 590.19 31.1102 590.04 31.1302C590.03 31.1302 590.02 31.1302 590 31.1302L589.99 31.1502ZM591.05 29.2602C591.05 29.2602 591.03 29.2602 591.02 29.2602H590.83C590.68 29.2802 590.53 29.2902 590.38 29.2902C590.28 29.2902 590.26 29.2902 590.26 29.4302V29.5402C590.29 29.7302 590.25 29.9302 590.14 30.0902C590.02 30.1802 589.87 30.2301 589.72 30.2201C589.65 30.2201 589.59 30.2302 589.53 30.2502C589.48 30.2702 589.44 30.3002 589.41 30.3402C589.41 30.4402 589.49 30.4902 589.69 30.5902C589.78 30.6302 589.87 30.6902 589.95 30.7502C589.98 30.7802 590 30.7802 590 30.7802C590 30.7802 590.03 30.7802 590.11 30.6702C590.45 30.2502 590.95 29.9902 591.49 29.9502C591.69 29.9202 591.88 29.8802 592.07 29.8102C592.07 29.8102 592.06 29.8102 592.07 29.7902C591.86 29.2102 591.83 29.2002 591.17 29.2302H591.07L591.05 29.2602Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.84 32.1501C588.85 32.6401 589.08 33.2101 588.67 33.0701C588.59 33.0401 587.97 32.6801 587.9 32.6401C587.65 32.5201 587.96 32.8001 587.81 33.1301C587.79 33.1801 587.63 33.2101 587.62 33.2001C587.49 32.9601 587.27 32.2801 587.16 32.0301C587.06 32.0301 586.96 32.0301 586.86 32.0501C587.35 32.0601 587.48 31.8001 587.43 31.3601C587.43 31.3001 587.56 31.1701 587.59 31.1801C588 31.3301 588.46 31.4201 588.71 31.8401C588.76 31.9401 588.8 32.0401 588.84 32.1501Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.63 33.3801C587.56 33.3801 587.5 33.3401 587.46 33.2901C587.35 33.0501 587.25 32.8101 587.17 32.5601C587.12 32.4301 587.08 32.3101 587.04 32.2201C586.98 32.2201 586.92 32.2301 586.86 32.2201C586.77 32.2201 586.69 32.1501 586.68 32.0601C586.67 31.9701 586.73 31.8901 586.81 31.8701C586.9 31.8501 587 31.8401 587.09 31.8401C587.13 31.8301 587.16 31.8101 587.19 31.7801C587.26 31.6601 587.28 31.5201 587.25 31.3801C587.23 31.2201 587.4 31.0901 587.43 31.0601C587.49 31.0001 587.58 30.9801 587.65 31.0101C587.71 31.0301 587.78 31.0501 587.84 31.0801C588.25 31.1701 588.62 31.4101 588.86 31.7501C588.91 31.8301 588.95 31.9201 588.97 32.0101L588.99 32.0801C588.99 32.0801 589 32.1201 589 32.1401C589 32.2701 589.02 32.3901 589.04 32.5201C589.08 32.8301 589.12 33.0701 588.95 33.2001C588.84 33.2801 588.71 33.2901 588.59 33.2301C588.53 33.2101 588.38 33.1301 588.03 32.9301L588 32.9101C588 33.0101 587.98 33.1101 587.94 33.2001C587.87 33.3601 587.61 33.3801 587.6 33.3801H587.63ZM587.81 32.4301C587.87 32.4301 587.92 32.4501 587.97 32.4801C588 32.4901 588.1 32.5501 588.23 32.6201C588.39 32.7101 588.68 32.8801 588.73 32.9001C588.73 32.7901 588.72 32.6801 588.7 32.5701C588.68 32.4501 588.66 32.3101 588.66 32.1801L588.64 32.1301C588.62 32.0601 588.59 31.9901 588.56 31.9301C588.36 31.6601 588.06 31.4801 587.73 31.4101C587.69 31.4001 587.65 31.3801 587.62 31.3701C587.66 31.6001 587.61 31.8301 587.47 32.0201C587.45 32.0501 587.42 32.0701 587.39 32.0901C587.43 32.1901 587.47 32.3101 587.52 32.4301C587.57 32.5701 587.63 32.7201 587.68 32.8501C587.68 32.8101 587.66 32.7801 587.65 32.7401C587.61 32.6501 587.62 32.5301 587.7 32.4601C587.74 32.4301 587.78 32.4101 587.83 32.4101L587.81 32.4301Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M585.88 39.0801C585.72 39.0401 585.6 38.9801 585.52 39.0101C585.16 39.1201 585.1 38.9501 585.09 38.6401C585.09 38.1801 585.07 38.2001 585.52 38.3601C585.84 38.4601 586.16 38.5401 586.49 38.6101C586.55 38.6201 586.61 38.6301 586.67 38.6501C586.62 38.7101 586.59 38.7901 586.53 38.8201C586.3 38.9201 586.07 39.0101 585.88 39.0901V39.0801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M585.88 39.2601C585.88 39.2601 585.85 39.2601 585.84 39.2601C585.78 39.2501 585.72 39.2301 585.67 39.2101C585.63 39.2001 585.6 39.1901 585.56 39.1801C585.41 39.2501 585.23 39.2301 585.09 39.1501C584.95 39.0201 584.89 38.8301 584.91 38.6501C584.91 38.3601 584.91 38.2201 585.02 38.1301C585.14 38.0401 585.28 38.0901 585.52 38.1801L585.57 38.2001C585.78 38.2701 586 38.3301 586.23 38.3701C586.33 38.3901 586.43 38.4101 586.53 38.4401C586.57 38.4401 586.61 38.4601 586.65 38.4601H586.71C586.77 38.4801 586.82 38.5301 586.84 38.5901C586.86 38.6501 586.85 38.7101 586.81 38.7601C586.8 38.7701 586.79 38.7901 586.78 38.8101C586.74 38.8801 586.68 38.9401 586.61 38.9801C586.44 39.0601 586.27 39.1301 586.11 39.1901L585.95 39.2601C585.95 39.2601 585.91 39.2701 585.88 39.2701V39.2601ZM585.56 38.8201C585.63 38.8201 585.71 38.8401 585.78 38.8601C585.81 38.8601 585.84 38.8801 585.87 38.8901L585.98 38.8501C586.07 38.8101 586.16 38.7801 586.26 38.7401L586.16 38.7201C585.92 38.6701 585.69 38.6101 585.46 38.5301L585.41 38.5101C585.41 38.5101 585.32 38.4801 585.28 38.4601C585.28 38.5001 585.28 38.5501 585.28 38.6001C585.28 38.8301 585.31 38.8601 585.32 38.8601C585.37 38.8601 585.43 38.8601 585.48 38.8401C585.51 38.8401 585.54 38.8301 585.58 38.8301L585.56 38.8201Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M592.85 30.7801C592.77 30.9801 592.67 31.1701 592.55 31.3401C592.49 31.4101 592.01 30.8201 592 30.6401C592 30.3401 592.22 30.3801 592.4 30.3701C592.59 30.3701 592.85 30.2601 592.85 30.7801Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M592.53 31.5301C592.53 31.5301 592.49 31.5301 592.48 31.5301C592.17 31.3201 591.94 31.0101 591.84 30.6501C591.83 30.5301 591.87 30.4101 591.95 30.3201C592.06 30.2301 592.21 30.1801 592.35 30.2001H592.48C592.63 30.1601 592.78 30.2 592.89 30.29C593.01 30.43 593.07 30.61 593.05 30.79C593.05 30.82 593.05 30.8401 593.03 30.8701C593.02 30.8901 593.01 30.9201 592.99 30.9601C592.92 31.1401 592.82 31.3001 592.71 31.4601C592.67 31.5101 592.61 31.5401 592.54 31.5301H592.53ZM592.19 30.5701C592.19 30.5701 592.19 30.6201 592.19 30.6401C592.27 30.8101 592.38 30.97 592.51 31.1C592.56 31.01 592.61 30.9101 592.65 30.8101L592.68 30.7501C592.68 30.5901 592.64 30.5601 592.64 30.5601C592.63 30.5501 592.54 30.5601 592.5 30.5601C592.47 30.5601 592.44 30.5601 592.41 30.5601H592.34C592.34 30.5601 592.24 30.5601 592.19 30.5701Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M585.79 42.1201C585.57 42.0401 585.87 41.8801 585.73 41.8301L586.22 41.1201C586.36 41.3101 586.09 41.5901 586.19 41.8001C586.21 41.8401 585.94 42.0101 585.8 42.1201H585.79Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M585.79 42.3002C585.79 42.3002 585.75 42.3002 585.73 42.2902C585.65 42.2602 585.58 42.2002 585.55 42.1202C585.53 42.0502 585.53 41.9702 585.57 41.9002V41.8802C585.55 41.8302 585.56 41.7702 585.59 41.7302L586.08 41.0202C586.08 41.0202 586.17 40.9402 586.22 40.9402C586.28 40.9402 586.33 40.9702 586.37 41.0102C586.46 41.1702 586.47 41.3602 586.39 41.5202C586.36 41.5802 586.35 41.6502 586.36 41.7202C586.43 41.8802 586.3 41.9802 586.07 42.1402C586.02 42.1802 585.96 42.2202 585.92 42.2502C585.89 42.2702 585.85 42.2902 585.81 42.2902L585.79 42.3002Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.77 46.1901L587.35 45.73C587.51 45.67 587.67 45.6201 587.84 45.5701C588.04 45.5301 588.2 45.6201 588.15 45.8301C588.12 45.9401 587.95 46.0201 587.77 46.1901Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.77 46.3701C587.77 46.3701 587.68 46.3501 587.65 46.3101L587.23 45.8501C587.23 45.8501 587.17 45.7401 587.19 45.6801C587.21 45.6201 587.25 45.5701 587.31 45.5601L587.45 45.5102C587.57 45.4602 587.69 45.4302 587.81 45.4002C587.96 45.3602 588.13 45.4002 588.24 45.5102C588.33 45.6102 588.36 45.7502 588.32 45.8802C588.27 46.0102 588.18 46.1202 588.06 46.1902C588.01 46.2302 587.95 46.2702 587.9 46.3202C587.87 46.3502 587.82 46.3701 587.78 46.3701H587.77ZM587.67 45.8101L587.79 45.9402L587.84 45.9002C587.89 45.8702 587.94 45.8302 587.98 45.7802C587.98 45.7402 587.94 45.7301 587.88 45.7401C587.81 45.7601 587.74 45.7801 587.67 45.8001V45.8101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.67 43.7802C586.7 43.9202 586.77 44.0601 586.74 44.0901C586.58 44.2301 586.4 44.3601 586.21 44.4701C586.17 44.4901 586.07 44.4001 586 44.3701C586.03 44.3101 586.07 44.2501 586.12 44.2001C586.28 44.0701 586.45 43.9501 586.67 43.7901V43.7802Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M586.19 44.6502C586.11 44.6502 586.03 44.6101 585.97 44.5601C585.95 44.5501 585.93 44.5302 585.91 44.5202C585.86 44.5002 585.83 44.4502 585.82 44.4002C585.81 44.3502 585.82 44.3001 585.85 44.2501L585.88 44.2002C585.91 44.1402 585.95 44.0901 586 44.0401C586.11 43.9501 586.23 43.8602 586.36 43.7602L586.55 43.6201C586.55 43.6201 586.66 43.5702 586.72 43.5902C586.78 43.6102 586.82 43.6601 586.83 43.7201C586.84 43.7601 586.86 43.8101 586.87 43.8501C586.91 43.9801 586.95 44.1102 586.85 44.2002C586.68 44.3502 586.49 44.4901 586.29 44.6001C586.26 44.6201 586.22 44.6302 586.19 44.6302V44.6502Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M587.91 38.5601L588.27 38.86C588.22 38.88 588.15 38.9401 588.12 38.9301C588.02 38.8801 587.93 38.8201 587.85 38.7401C587.84 38.7301 587.88 38.6601 587.92 38.5601H587.91Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M588.12 39.1101C588.12 39.1101 588.06 39.1101 588.04 39.0901C587.93 39.0301 587.82 38.9601 587.72 38.8701C587.61 38.7801 587.67 38.6501 587.7 38.5801C587.71 38.5601 587.72 38.5301 587.74 38.4901C587.76 38.4401 587.81 38.4001 587.86 38.3801C587.92 38.3701 587.97 38.3801 588.02 38.4201L588.38 38.72C588.38 38.72 588.45 38.8201 588.44 38.8801C588.43 38.9401 588.39 38.9901 588.34 39.0201C588.28 39.0701 588.2 39.1001 588.12 39.1101Z", fill: "#FF2A45" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.4401C19.58 27.5001 16.72 25.8201 12.52 25.8201C4.66 25.8701 0 32.12 0 40.79C0 49.46 4.65 55.7101 12.52 55.7101C13.96 55.7901 15.41 55.54 16.75 54.98C18.09 54.42 19.29 53.56 20.26 52.47V56.6401C20.26 59.4801 18.76 62.85 14 62.85C10.39 62.85 8.61 60.83 7.99 58.66L1.6 61.7501C3.2 65.8501 7.02 69.29 14.44 69.29C25.44 69.29 28.27 61.8701 28.27 55.3701V26.23H21.54L21.36 30.4301L21.35 30.4401ZM14.24 48.91C10.31 48.91 7.99 45.71 7.99 40.73C7.99 35.75 10.31 32.55 14.24 32.55C18.17 32.55 20.44 35.75 20.44 40.73C20.44 45.71 18.17 48.91 14.24 48.91Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.77C176.63 25.77 175.11 26.11 173.73 26.79C172.34 27.47 171.12 28.45 170.16 29.68L169.64 26.24H162.53V55.25H170.83V38.87C170.83 34.34 172.51 32.57 175.84 32.57C178.16 32.57 180.08 33.6 180.08 38.02V55.26H188.38V36.33C188.38 30.2 184.58 25.78 178.16 25.78L178.17 25.77Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.61C49.6201 46.59 47.9401 48.91 44.6201 48.91C42.3001 48.91 40.3601 47.88 40.3601 43.46V26.24H32.0601V45.13C32.0601 51.25 35.8601 55.7 42.2801 55.7C43.8201 55.7 45.3401 55.35 46.7301 54.67C48.1201 53.99 49.3401 53 50.3001 51.78L50.8201 55.23H57.9101V26.24H49.6101V42.61H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.24H62.2798V55.25H70.5798V26.24Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.37C91.6001 26.64 89.0201 25.77 86.4001 25.92C78.5001 25.92 73.8301 32.18 73.8301 40.84C73.8301 49.5 78.5001 55.76 86.4001 55.76C88.0801 55.87 89.7601 55.53 91.2701 54.77C92.7801 54.01 94.0701 52.86 95.0101 51.43L95.2101 55.25H101.94V12.77H93.6401L93.6001 28.37H93.6101ZM88.2101 48.91C84.2801 48.91 81.9601 45.71 81.9601 40.73C81.9601 35.75 84.2801 32.55 88.2101 32.55C92.1401 32.55 94.4601 35.75 94.4601 40.73C94.4601 45.71 92.1401 48.91 88.2101 48.91Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.0701C65.5099 12.0701 64.6199 12.35 63.8599 12.86C63.0999 13.38 62.5099 14.11 62.1599 14.98C61.8099 15.84 61.7199 16.7901 61.8999 17.7001C62.0799 18.6101 62.5199 19.45 63.1699 20.11C63.8199 20.77 64.6399 21.2201 65.5399 21.4001C66.4399 21.5801 67.3699 21.4901 68.2099 21.1301C69.0599 20.7701 69.7799 20.1701 70.2899 19.3901C70.7999 18.6101 71.0699 17.7001 71.0699 16.7701C71.0699 15.5201 70.5799 14.3201 69.7099 13.4401C68.8399 12.5601 67.6599 12.0601 66.4399 12.0601L66.4299 12.0701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.24H149.84V55.25H158.14V26.24Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.0701C153.08 12.0701 152.19 12.35 151.43 12.86C150.67 13.38 150.08 14.11 149.72 14.98C149.37 15.84 149.28 16.7901 149.46 17.7001C149.64 18.6101 150.08 19.45 150.73 20.11C151.38 20.77 152.2 21.2201 153.1 21.4001C154 21.5801 154.93 21.4901 155.77 21.1301C156.62 20.7701 157.34 20.1701 157.85 19.3901C158.36 18.6101 158.63 17.7001 158.63 16.7701C158.63 15.5201 158.14 14.3201 157.27 13.4401C156.4 12.5601 155.22 12.0601 154 12.0601V12.0701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.6801V40.8001C218.63 31.8401 213.58 25.8801 205.25 25.8801C196.92 25.8801 191.31 31.8401 191.31 40.8001C191.31 49.7601 196.93 55.7201 205.25 55.7201C211.01 55.7201 215.3 52.9301 217.33 48.2201L211.32 45.3201C210.93 46.5801 210.14 47.6601 209.08 48.4201C208.02 49.1801 206.75 49.5601 205.45 49.5101C203.92 49.5501 202.42 49.0001 201.28 47.9601C200.14 46.9201 199.42 45.4701 199.29 43.9201H199.35L218.63 41.6901V41.6801ZM199.09 38.7501C199.09 34.5401 201.55 31.7802 205.22 31.7802C206.73 31.7502 208.19 32.3201 209.31 33.3501C210.43 34.3901 211.11 35.8201 211.23 37.3501L199.09 38.7501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.8701C110.47 25.8701 104.85 31.8301 104.85 40.7901C104.85 49.7501 110.47 55.7101 118.8 55.7101C124.55 55.7101 128.84 52.9201 130.82 48.2101L124.81 45.3101C124.42 46.5501 123.65 47.6201 122.61 48.3801C121.57 49.1301 120.32 49.5301 119.05 49.5001C117.5 49.5701 115.99 49.0201 114.83 47.9801C113.67 46.9401 112.94 45.4801 112.81 43.9101L132.05 41.6601V40.7802C132.17 31.8402 127.12 25.8801 118.8 25.8801V25.8701ZM112.61 38.7501C112.61 34.5401 115.02 31.7802 118.75 31.7802C120.26 31.7502 121.72 32.3201 122.84 33.3501C123.96 34.3901 124.64 35.8201 124.76 37.3501L112.6 38.7501H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.51V12.77H134.99V47.37C134.99 51.39 135.78 55.58 142.81 55.58C144.14 55.65 145.47 55.43 146.71 54.92V48.44C146.71 48.44 143.29 49.32 143.29 46.51Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.8801H33.04V75.6101H0.25V81.4501H38.77V68.7101H218.65V62.8801Z", fill: "#5532FA" }));
const SvgStripe = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 398, height: 82, viewBox: "0 0 398 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.429932H247.93V81.7899H248.93V0.429932Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M397.58 41.2499C397.58 32.7599 393.47 26.0599 385.61 26.0599C377.75 26.0599 372.94 32.7599 372.94 41.1799C372.94 51.1599 378.58 56.2 386.67 56.2C390.62 56.2 393.6 55.2999 395.86 54.0399V47.4099C393.61 48.5399 391.02 49.2299 387.74 49.2299C384.46 49.2299 381.67 48.0999 381.31 44.1899H397.52C397.52 43.7599 397.59 42.0299 397.59 41.2399L397.58 41.2499ZM381.2 38.0999C381.2 34.3499 383.49 32.7899 385.58 32.7899C387.67 32.7899 389.76 34.3499 389.76 38.0999H381.2Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { d: "M360.15 26.0599C356.9 26.0599 354.81 27.59 353.65 28.65L353.22 26.59H345.92V65.2499L354.21 63.4899L354.24 54.1099C355.43 54.9699 357.19 56.2 360.11 56.2C366.05 56.2 371.45 51.4299 371.45 40.9099C371.42 31.2899 365.95 26.0499 360.14 26.0499L360.15 26.0599ZM358.16 48.9099C356.2 48.9099 355.04 48.2099 354.25 47.3499L354.22 35.0499C355.08 34.0899 356.28 33.4299 358.17 33.4299C361.19 33.4299 363.28 36.8099 363.28 41.1599C363.28 45.5099 361.22 48.9199 358.17 48.9199L358.16 48.9099Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M334.51 24.1099L342.84 22.3199V15.58L334.51 17.34V24.1099Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { d: "M342.83 26.6299H334.51V55.6399H342.83V26.6299Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M325.59 29.08L325.06 26.6299H317.9V55.64H326.19V35.9799C328.15 33.4299 331.46 33.8899 332.49 34.2599V26.6299C331.43 26.2299 327.55 25.5 325.59 29.08Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M309.01 19.4299L300.92 21.15L300.89 47.71C300.89 52.62 304.57 56.2299 309.48 56.2299C312.2 56.2299 314.19 55.73 315.28 55.14V48.4099C314.22 48.8399 308.98 50.37 308.98 45.46V33.6899H315.28V26.6299H308.98L309.01 19.4299Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M286.6 35.0499C286.6 33.7599 287.66 33.2599 289.42 33.2599C291.94 33.2599 295.12 34.0199 297.64 35.3799V27.59C294.89 26.5 292.17 26.0599 289.42 26.0599C282.69 26.0599 278.21 29.5699 278.21 35.4399C278.21 44.5899 290.81 43.13 290.81 47.08C290.81 48.61 289.48 49.0999 287.63 49.0999C284.88 49.0999 281.36 47.97 278.58 46.45V54.34C281.66 55.67 284.78 56.2299 287.63 56.2299C294.53 56.2299 299.27 52.8099 299.27 46.8799C299.24 36.9999 286.6 38.7599 286.6 35.0399V35.0499Z", fill: "#0A2540" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.83C19.58 27.89 16.72 26.21 12.52 26.21C4.66 26.26 0 32.5099 0 41.1799C0 49.8499 4.65 56.0999 12.52 56.0999C13.96 56.1799 15.41 55.9299 16.75 55.3699C18.09 54.8099 19.29 53.9499 20.26 52.8599V57.03C20.26 59.87 18.76 63.2399 14 63.2399C10.39 63.2399 8.61 61.2199 7.99 59.0499L1.6 62.14C3.2 66.24 7.02 69.6799 14.44 69.6799C25.44 69.6799 28.27 62.2599 28.27 55.7599V26.6199H21.54L21.36 30.8199L21.35 30.83ZM14.24 49.2999C10.31 49.2999 7.99 46.0999 7.99 41.1199C7.99 36.1399 10.31 32.9399 14.24 32.9399C18.17 32.9399 20.44 36.1399 20.44 41.1199C20.44 46.0999 18.17 49.2999 14.24 49.2999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.1599C176.63 26.1599 175.11 26.4999 173.73 27.1799C172.34 27.8599 171.12 28.8399 170.16 30.0699L169.64 26.6299H162.53V55.64H170.83V39.2599C170.83 34.7299 172.51 32.96 175.84 32.96C178.16 32.96 180.08 33.9899 180.08 38.4099V55.65H188.38V36.7199C188.38 30.5899 184.58 26.1699 178.16 26.1699L178.17 26.1599Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.9999C49.6201 46.9799 47.9401 49.2999 44.6201 49.2999C42.3001 49.2999 40.3601 48.2699 40.3601 43.8499V26.6299H32.0601V45.5199C32.0601 51.6399 35.8601 56.0899 42.2801 56.0899C43.8201 56.0899 45.3401 55.7399 46.7301 55.0599C48.1201 54.3799 49.3401 53.3899 50.3001 52.1699L50.8201 55.6199H57.9101V26.6299H49.6101V42.9999H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.5798 26.6299H62.2798V55.6399H70.5798V26.6299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.7599C91.6001 27.0299 89.0201 26.1599 86.4001 26.3099C78.5001 26.3099 73.8301 32.5699 73.8301 41.2299C73.8301 49.8899 78.5001 56.15 86.4001 56.15C88.0801 56.26 89.7601 55.9199 91.2701 55.1599C92.7801 54.3999 94.0701 53.2499 95.0101 51.8199L95.2101 55.64H101.94V13.1599H93.6401L93.6001 28.7599H93.6101ZM88.2101 49.2999C84.2801 49.2999 81.9601 46.0999 81.9601 41.1199C81.9601 36.1399 84.2801 32.9399 88.2101 32.9399C92.1401 32.9399 94.4601 36.1399 94.4601 41.1199C94.4601 46.0999 92.1401 49.2999 88.2101 49.2999Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.4699C65.5099 12.4699 64.6199 12.7499 63.8599 13.2599C63.0999 13.7799 62.5099 14.5099 62.1599 15.3799C61.8099 16.2399 61.7199 17.1899 61.8999 18.0999C62.0799 19.0099 62.5199 19.8499 63.1699 20.5099C63.8199 21.1699 64.6399 21.6199 65.5399 21.7999C66.4399 21.9799 67.3699 21.89 68.2099 21.53C69.0599 21.17 69.7799 20.5699 70.2899 19.7899C70.7999 19.0099 71.0699 18.0999 71.0699 17.1699C71.0699 15.9199 70.5799 14.72 69.7099 13.84C68.8399 12.96 67.6599 12.46 66.4399 12.46L66.4299 12.4699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.6299H149.84V55.6399H158.14V26.6299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.4699C153.08 12.4699 152.19 12.7499 151.43 13.2599C150.67 13.7799 150.08 14.5099 149.72 15.3799C149.37 16.2399 149.28 17.1899 149.46 18.0999C149.64 19.0099 150.08 19.8499 150.73 20.5099C151.38 21.1699 152.2 21.6199 153.1 21.7999C154 21.9799 154.93 21.89 155.77 21.53C156.62 21.17 157.34 20.5699 157.85 19.7899C158.36 19.0099 158.63 18.0999 158.63 17.1699C158.63 15.9199 158.14 14.72 157.27 13.84C156.4 12.96 155.22 12.46 154 12.46V12.4699Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.07V41.19C218.63 32.23 213.58 26.27 205.25 26.27C196.92 26.27 191.31 32.23 191.31 41.19C191.31 50.15 196.93 56.11 205.25 56.11C211.01 56.11 215.3 53.32 217.33 48.61L211.32 45.71C210.93 46.97 210.14 48.05 209.08 48.81C208.02 49.57 206.75 49.95 205.45 49.9C203.92 49.94 202.42 49.39 201.28 48.35C200.14 47.31 199.42 45.86 199.29 44.31H199.35L218.63 42.08V42.07ZM199.09 39.14C199.09 34.93 201.55 32.17 205.22 32.17C206.73 32.14 208.19 32.71 209.31 33.74C210.43 34.78 211.11 36.21 211.23 37.74L199.09 39.14Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.26C110.47 26.26 104.85 32.22 104.85 41.18C104.85 50.14 110.47 56.1 118.8 56.1C124.55 56.1 128.84 53.31 130.82 48.6L124.81 45.7C124.42 46.94 123.65 48.01 122.61 48.77C121.57 49.52 120.32 49.92 119.05 49.89C117.5 49.96 115.99 49.41 114.83 48.37C113.67 47.33 112.94 45.87 112.81 44.3L132.05 42.05V41.17C132.17 32.23 127.12 26.27 118.8 26.27V26.26ZM112.61 39.14C112.61 34.93 115.02 32.17 118.75 32.17C120.26 32.14 121.72 32.71 122.84 33.74C123.96 34.78 124.64 36.21 124.76 37.74L112.6 39.14H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.9V13.1599H134.99V47.7599C134.99 51.7799 135.78 55.9699 142.81 55.9699C144.14 56.0399 145.47 55.8199 146.71 55.3099V48.83C146.71 48.83 143.29 49.71 143.29 46.9Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.27H33.04V76H0.25V81.84H38.77V69.1H218.65V63.27Z", fill: "#5532FA" }));
const SvgAdp$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 190, height: 82, viewBox: "0 0 190 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M22.1254 15.4159C20.3554 12.4759 17.4954 10.7959 13.2954 10.7959C5.43539 10.8459 0.775391 17.0959 0.775391 25.7659C0.775391 34.4359 5.42539 40.6859 13.2954 40.6859C14.7354 40.7659 16.1854 40.5159 17.5254 39.9559C18.8654 39.3959 20.0654 38.5359 21.0354 37.4459V41.616C21.0354 44.456 19.5354 47.8259 14.7754 47.8259C11.1654 47.8259 9.38539 45.806 8.76539 43.636L2.38539 46.726C3.98539 50.826 7.80539 54.2659 15.2254 54.2659C26.2254 54.2659 29.0554 46.8459 29.0554 40.3459V11.2059H22.3254L22.1454 15.4059L22.1254 15.4159ZM15.0154 33.886C11.0854 33.886 8.76539 30.6859 8.76539 25.7059C8.76539 20.7259 11.0854 17.5259 15.0154 17.5259C18.9454 17.5259 21.2154 20.7259 21.2154 25.7059C21.2154 30.6859 18.9454 33.886 15.0154 33.886Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 56.5459V66.4359H1.02539V60.5959H23.3154V56.5459H29.0354H29.0454Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.455933H58.3252V81.8159H59.3252V0.455933Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M152.325 39.1353C152.305 46.4053 146.415 52.2953 139.145 52.3153H134.075V46.5253H139.145C143.225 46.5253 146.535 43.2153 146.535 39.1353C146.535 35.0553 143.225 31.7452 139.145 31.7452H134.075V25.9552H139.145C146.415 25.9752 152.305 31.8653 152.325 39.1353ZM124.225 25.9552V36.6753H115.095L111.765 42.4652H130.015V25.9552H124.225ZM189.985 34.2152C189.985 44.2152 181.875 52.3153 171.875 52.3153V62.1653H156.235V54.4852C151.875 59.4252 145.585 62.2353 138.995 62.1653H124.225V52.3153H112.635L106.845 62.1653H88.5952L115.395 16.1052H139.145C145.705 16.1652 151.955 18.9453 156.385 23.7853V16.1052H172.025C181.975 16.1652 190.005 24.2652 189.985 34.2052V34.2152ZM139.145 56.3652C145.825 56.3852 151.915 52.5453 154.785 46.5153H162.175V56.3652H166.235V46.5153H172.025C178.815 46.5153 184.325 41.0252 184.335 34.2352C184.335 34.2352 184.335 34.2152 184.335 34.2052C184.275 27.3752 178.705 21.8753 171.875 21.8953H162.025V36.6653H156.235C154.955 28.2053 147.705 21.9353 139.145 21.8953H118.865L98.7352 56.3652H103.515L109.305 46.5153H130.015V56.3652H139.145ZM171.875 25.9453H166.085V31.7352H171.875C173.225 31.7352 174.325 32.8153 174.335 34.1653C174.335 34.1653 174.335 34.1853 174.335 34.1953C174.295 35.5353 173.215 36.6153 171.875 36.6553H166.085V42.4453H171.875C176.435 42.4453 180.135 38.7453 180.135 34.1853C180.085 29.6453 176.415 25.9753 171.875 25.9253", fill: "#D0271D" }), /* @__PURE__ */ React.createElement("path", { d: "M178.755 58.6553C178.755 59.8953 177.745 60.9053 176.505 60.9053C175.265 60.9053 174.255 59.8953 174.255 58.6553C174.255 57.4153 175.265 56.4053 176.505 56.4053C177.735 56.3853 178.735 57.3752 178.755 58.5952C178.755 58.6152 178.755 58.6353 178.755 58.6553ZM179.315 58.6553C179.315 57.1053 178.055 55.8452 176.505 55.8452C174.955 55.8452 173.695 57.1053 173.695 58.6553C173.695 60.2053 174.955 61.4652 176.505 61.4652C178.055 61.4652 179.315 60.2053 179.315 58.6553Z", fill: "#D0271D" }), /* @__PURE__ */ React.createElement("path", { d: "M176.645 57.3953C176.955 57.3953 177.205 57.6452 177.205 57.9552C177.205 58.2652 176.955 58.5153 176.645 58.5153H176.085V57.3953H176.645ZM177.345 57.2552C177.155 57.0752 176.905 56.9752 176.645 56.9752H175.525V60.3452H175.945V59.0852H176.505L177.205 60.3452H177.765L176.925 58.9453C177.065 58.9453 177.205 58.8053 177.345 58.6653C177.455 58.5053 177.505 58.3052 177.485 58.1052C177.605 57.8252 177.555 57.4953 177.345 57.2653", fill: "#D0271D" }));
const SvgBambooHr$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 390, height: 83, viewBox: "0 0 390 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.865234H58.3252V82.2252H59.3252V0.865234Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M386.935 30.4852C386.735 30.6552 386.495 30.7453 386.195 30.7753L387.315 32.5253H386.655L385.585 30.8252H384.935V32.5253H384.325V28.5652H385.845C386.315 28.5652 386.655 28.6552 386.885 28.8452C387.105 29.0352 387.225 29.3152 387.225 29.6952C387.225 30.0552 387.125 30.3152 386.925 30.4752L386.935 30.4852ZM385.585 30.3252C385.725 30.3252 385.855 30.3252 385.975 30.3152C386.095 30.3152 386.205 30.2852 386.305 30.2352C386.405 30.1952 386.475 30.1253 386.535 30.0453C386.595 29.9553 386.625 29.8353 386.625 29.6753C386.625 29.5453 386.605 29.4352 386.545 29.3552C386.495 29.2752 386.425 29.2153 386.345 29.1753C386.265 29.1353 386.175 29.1052 386.065 29.0852C385.955 29.0652 385.855 29.0652 385.755 29.0652H384.945V30.3252H385.585ZM388.745 29.2052C388.925 29.6152 389.015 30.0553 389.015 30.5353C389.015 31.0153 388.925 31.4753 388.745 31.8853C388.565 32.2953 388.325 32.6552 388.015 32.9652C387.705 33.2652 387.355 33.5053 386.945 33.6753C386.535 33.8453 386.105 33.9253 385.645 33.9253C385.185 33.9253 384.745 33.8453 384.335 33.6753C383.925 33.5053 383.565 33.2652 383.255 32.9652C382.945 32.6652 382.705 32.3053 382.525 31.8853C382.345 31.4753 382.255 31.0153 382.255 30.5353C382.255 30.0553 382.345 29.6152 382.525 29.2052C382.705 28.7952 382.945 28.4353 383.255 28.1353C383.565 27.8353 383.925 27.5953 384.335 27.4253C384.745 27.2553 385.185 27.1653 385.645 27.1653C386.105 27.1653 386.545 27.2553 386.945 27.4253C387.355 27.5953 387.705 27.8353 388.015 28.1353C388.325 28.4353 388.565 28.7952 388.745 29.2052ZM388.195 31.6853C388.335 31.3353 388.405 30.9453 388.405 30.5353C388.405 30.1253 388.335 29.7553 388.195 29.4053C388.055 29.0553 387.855 28.7552 387.615 28.4952C387.365 28.2352 387.075 28.0353 386.735 27.8853C386.395 27.7353 386.035 27.6653 385.645 27.6653C385.255 27.6653 384.885 27.7353 384.545 27.8853C384.205 28.0353 383.915 28.2352 383.665 28.4952C383.415 28.7552 383.225 29.0553 383.085 29.4053C382.945 29.7553 382.875 30.1353 382.875 30.5353C382.875 30.9353 382.945 31.3353 383.085 31.6853C383.225 32.0353 383.425 32.3452 383.665 32.6052C383.915 32.8652 384.205 33.0652 384.545 33.2152C384.885 33.3652 385.255 33.4353 385.645 33.4353C386.035 33.4353 386.395 33.3652 386.735 33.2152C387.075 33.0652 387.365 32.8652 387.615 32.6052C387.865 32.3452 388.055 32.0353 388.195 31.6853ZM104.995 15.3853C108.565 19.1753 108.935 21.2952 110.205 24.9752L112.325 31.9752C112.325 31.9752 110.235 31.5752 108.525 31.3152C106.535 31.0152 105.655 30.7153 103.135 29.6753C100.605 28.6353 98.325 26.0953 96.075 23.2653C93.835 20.4353 88.605 15.9852 88.605 15.9852C88.605 15.9852 90.225 16.0952 91.865 16.5052C93.205 16.8452 96.705 17.9852 100.315 19.8752C101.115 20.2952 101.555 20.5653 102.345 21.0553C103.545 21.8053 104.805 22.9153 106.015 24.1553C107.435 25.6053 108.675 26.7752 109.745 28.0752C108.585 25.9352 105.595 18.2152 99.735 11.8352C99.165 11.2152 103.785 14.0752 105.005 15.3752L104.995 15.3853ZM246.955 25.7753C255.265 25.7753 262.445 33.0053 262.445 41.4153C262.445 50.4753 255.565 57.5253 246.475 57.5253C238.225 57.5253 231.035 51.6653 231.035 42.2653V14.5752H235.815V30.3752L236.385 29.7753C238.465 27.6953 241.435 25.7853 246.965 25.7853L246.955 25.7753ZM246.475 53.1353C253.255 53.1353 257.555 48.2752 257.555 41.8652C257.555 35.9752 253.485 30.3452 246.575 30.3452C239.665 30.3452 235.385 35.5952 235.385 41.9852C235.385 48.3752 240.465 53.1353 246.465 53.1353H246.475ZM130.495 25.7753C138.805 25.7753 145.985 33.0053 145.985 41.4153C145.985 50.4753 139.105 57.5253 130.015 57.5253C121.765 57.5253 114.575 51.6653 114.575 42.2653V11.7052H119.355V30.3752L119.925 29.7753C122.005 27.6953 124.965 25.7853 130.495 25.7853V25.7753ZM130.015 53.1353C136.795 53.1353 141.095 48.2752 141.095 41.8652C141.095 35.9752 137.025 30.3452 130.115 30.3452C123.205 30.3452 118.925 35.5952 118.925 41.9852C118.925 48.3752 124.005 53.1353 130.005 53.1353H130.015ZM378.935 35.6353C378.935 39.7453 375.905 42.9253 372.295 43.6453L381.335 56.0652H376.915L368.255 43.9852H364.425V56.0652H360.935V27.1653H369.225C376.375 27.1653 378.945 31.6553 378.945 35.6453L378.935 35.6353ZM364.425 40.7653H369.635C373.425 40.7653 375.315 38.4353 375.315 35.6353C375.315 32.2453 373.295 30.3853 369.595 30.3853H364.425V40.7653ZM352.105 39.4952V27.1653H355.595V56.0652H352.105V42.7152H336.845V56.0652H333.355V27.1653H336.845V39.4952H352.105ZM314.185 26.0952C323.145 26.0952 329.575 32.7553 329.575 41.5353C329.575 50.3153 323.085 57.0952 314.185 57.0952C305.285 57.0952 298.805 50.3153 298.805 41.5353C298.805 32.7553 305.535 26.0952 314.185 26.0952ZM314.185 52.7352C320.255 52.7352 324.645 47.8953 324.645 41.5353C324.645 35.1753 320.495 30.3953 314.185 30.3953C307.875 30.3953 303.735 35.1153 303.735 41.5353C303.735 47.9553 308.665 52.7352 314.185 52.7352ZM280.375 26.0952C289.325 26.0952 295.755 32.7553 295.755 41.5353C295.755 50.3153 289.265 57.0952 280.375 57.0952C271.485 57.0952 264.985 50.3153 264.985 41.5353C264.985 32.7553 271.715 26.0952 280.375 26.0952ZM280.375 52.7352C286.445 52.7352 290.835 47.8953 290.835 41.5353C290.835 35.1753 286.685 30.3953 280.375 30.3953C274.065 30.3953 269.915 35.1153 269.915 41.5353C269.915 47.9553 274.845 52.7352 280.375 52.7352ZM216.675 26.0952C223.165 26.0952 227.675 30.6353 227.675 39.1753V56.0652H222.925V38.8053C222.925 34.3253 220.885 30.3953 216.015 30.3953C211.985 30.3953 208.205 33.3052 208.205 39.9652V56.0752H203.395V38.8152C203.395 34.0352 200.815 30.4053 196.545 30.4053C191.735 30.4053 188.675 33.9152 188.675 39.9752V56.0852H183.925V27.0852H188.675V30.7152H188.795C190.715 28.1152 193.665 26.1152 197.385 26.1152C201.895 26.1152 205.555 28.7152 206.765 32.1052C208.205 29.1952 211.695 26.1152 216.685 26.1152L216.675 26.0952ZM174.835 31.2352V27.0553H179.585V56.0553H174.835V52.1853H174.715C172.615 54.7253 169.065 57.0852 164.195 57.0852C156.385 57.0852 149.415 50.9653 149.415 41.5253C149.415 32.0853 155.905 26.0852 164.495 26.0852C169.725 26.0852 172.785 28.8652 174.765 31.2252H174.825L174.835 31.2352ZM164.855 52.8552C170.265 52.8552 175.255 48.2552 175.255 41.7152C175.255 34.8152 170.625 30.2753 164.975 30.2753C157.765 30.2753 154.335 35.9653 154.335 41.5353C154.335 47.1053 157.765 52.8552 164.855 52.8552Z", fill: "#73C41D" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 18.5453C20.3554 15.6053 17.4954 13.9253 13.2954 13.9253C5.43539 13.9753 0.775391 20.2253 0.775391 28.8953C0.775391 37.5653 5.42539 43.8152 13.2954 43.8152C14.7354 43.8952 16.1854 43.6452 17.5254 43.0852C18.8654 42.5252 20.0654 41.6652 21.0354 40.5752V44.7452C21.0354 47.5852 19.5354 50.9552 14.7754 50.9552C11.1654 50.9552 9.38539 48.9353 8.76539 46.7653L2.38539 49.8552C3.98539 53.9552 7.80539 57.3953 15.2254 57.3953C26.2254 57.3953 29.0554 49.9752 29.0554 43.4752V14.3352H22.3254L22.1454 18.5353L22.1254 18.5453ZM15.0154 37.0153C11.0854 37.0153 8.76539 33.8152 8.76539 28.8352C8.76539 23.8552 11.0854 20.6553 15.0154 20.6553C18.9454 20.6553 21.2154 23.8552 21.2154 28.8352C21.2154 33.8152 18.9454 37.0153 15.0154 37.0153Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 59.6753V69.5652H1.02539V63.7252H23.3154V59.6753H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgGusto$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 221, height: 82, viewBox: "0 0 221 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M205.915 18.7C197.735 18.7 191.105 25.33 191.105 33.51C191.105 41.69 197.735 48.32 205.915 48.32C214.095 48.32 220.725 41.69 220.725 33.51C220.715 25.33 214.095 18.71 205.915 18.7ZM205.915 41.29C201.615 41.29 198.135 37.8 198.135 33.51C198.135 29.22 201.625 25.73 205.915 25.73C210.215 25.73 213.695 29.21 213.695 33.51C213.695 37.81 210.205 41.29 205.915 41.3V41.29Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M162.315 30.51L159.725 29.22C158.605 28.67 157.905 28.23 157.615 27.91C157.345 27.63 157.195 27.25 157.185 26.86C157.185 26.36 157.405 25.94 157.855 25.61C158.305 25.28 158.925 25.11 159.715 25.11C161.165 25.11 162.775 25.99 164.555 27.75L168.925 23.38C166.765 20.44 163.325 18.71 159.665 18.73C156.995 18.73 154.795 19.52 153.085 21.1C151.375 22.68 150.515 24.58 150.515 26.8C150.515 30.25 152.795 33.12 157.345 35.41L159.725 36.6C161.775 37.63 162.795 38.69 162.795 39.78C162.795 40.37 162.515 40.88 161.945 41.33C161.375 41.78 160.625 42 159.695 42C158.835 42 157.845 41.7 156.735 41.1C155.625 40.51 154.635 39.73 153.795 38.8L149.495 43.49C151.945 46.7 155.215 48.3 159.325 48.3C162.415 48.3 164.875 47.46 166.705 45.79C168.535 44.12 169.455 42.03 169.455 39.53C169.455 37.65 168.945 36.02 167.925 34.62C166.905 33.22 165.035 31.85 162.315 30.51Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M118.365 19.28H111.345L111.365 21.81C109.095 19.51 106.285 18.7 103.405 18.7C95.2252 18.7 88.5952 25.33 88.5952 33.51C88.5952 41.69 95.2252 48.32 103.405 48.32C106.815 48.32 109.735 46.81 111.235 44.89C111.235 45.01 111.225 46.4 111.225 46.55C111.195 47.5 111.055 49.03 110.155 50.6C107.975 54.29 103.215 55.51 99.5252 53.33C99.4652 53.3 99.4052 53.26 99.3552 53.22L95.8652 59.3C98.1552 60.69 100.795 61.43 103.475 61.43C107.365 61.43 112.205 59.89 115.645 55.13C118.505 51.17 118.365 47.43 118.365 43.81V19.28ZM103.405 41.29C99.1052 41.29 95.6252 37.8 95.6252 33.51C95.6252 29.21 99.1152 25.73 103.405 25.73C107.695 25.73 111.185 29.21 111.185 33.51C111.185 37.81 107.695 41.29 103.405 41.3V41.29Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M146.365 19.28H139.305V33.36C139.315 35.35 139.315 38.81 137.845 40.29C137.135 41 136.375 41.63 134.745 41.63C133.115 41.63 132.345 40.99 131.635 40.29C130.165 38.81 130.165 35.35 130.185 33.36V19.28H123.135V33.31C123.115 36.2 123.075 41.58 126.625 45.14C128.705 47.23 131.175 48.29 134.755 48.29C138.335 48.29 140.815 47.23 142.885 45.14C146.425 41.58 146.395 36.2 146.375 33.31V19.28H146.365Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M182.875 41.2C182.065 41.09 181.275 40.52 180.825 39.47C180.515 38.75 180.405 37.81 180.405 36.64V25.32H188.705V19.26H180.405V11.39H173.365V36.07C173.365 38.49 173.555 41.42 175.155 44.13C176.515 46.43 178.915 48.3 182.865 48.3C187.645 48.3 191.085 44.84 191.085 44.84L186.865 39.65C186.865 39.65 185.015 41.49 182.885 41.2H182.875Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0H58.3252V81.36H59.3252V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 17.48C20.3554 14.54 17.4954 12.86 13.2954 12.86C5.43539 12.91 0.775391 19.16 0.775391 27.83C0.775391 36.5 5.42539 42.75 13.2954 42.75C14.7354 42.83 16.1854 42.58 17.5254 42.02C18.8654 41.46 20.0654 40.6 21.0354 39.51V43.68C21.0354 46.52 19.5354 49.89 14.7754 49.89C11.1654 49.89 9.38539 47.87 8.76539 45.7L2.38539 48.79C3.98539 52.89 7.80539 56.33 15.2254 56.33C26.2254 56.33 29.0554 48.91 29.0554 42.41V13.28H22.3254L22.1454 17.48H22.1254ZM15.0154 35.95C11.0854 35.95 8.76539 32.75 8.76539 27.77C8.76539 22.79 11.0854 19.59 15.0154 19.59C18.9454 19.59 21.2154 22.79 21.2154 27.77C21.2154 32.75 18.9454 35.95 15.0154 35.95Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 58.61V68.5H1.02539V62.66H23.3154V58.61H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgISolved$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 281, height: 82, viewBox: "0 0 281 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M274.515 19.1746V55.0245C274.515 55.1945 274.515 55.5345 274.015 55.5345H267.135C266.635 55.5345 266.485 55.3245 266.475 54.8645V53.6445C266.415 53.5845 266.585 53.5845 266.475 53.6445C263.135 56.0245 259.315 56.9545 255.505 55.8645C250.055 54.2945 246.795 50.4545 245.535 45.0045C244.565 40.7745 244.985 36.6345 247.085 32.7545C250.255 26.8945 257.615 24.2345 263.565 26.7745C264.415 27.1345 265.205 27.6445 266.095 28.1345V27.3346C266.095 22.9746 266.095 23.5446 266.045 19.1846C266.045 19.1846 265.985 18.6946 266.435 18.6946C268.725 18.7146 271.435 18.7046 273.725 18.6946H274.055C274.515 18.6946 274.515 19.0146 274.515 19.1746ZM266.235 40.6145C266.215 39.9145 266.105 39.2246 265.915 38.5446C265.315 36.1746 263.955 34.4745 261.485 33.8745C259.055 33.2745 256.985 33.9046 255.345 35.7946C252.985 38.5046 252.905 43.0545 255.125 45.8745C257.525 48.9245 262.055 49.1145 264.525 46.2645C265.825 44.7445 266.175 42.9245 266.235 40.6145Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M221.895 44.1946C222.235 46.1946 224.185 48.0945 226.515 48.6545C229.045 49.2545 232.125 49.1546 234.265 45.4446C234.405 45.2046 234.695 45.1046 234.955 45.1946L241.975 47.3845C242.415 47.5245 242.295 47.8346 242.235 47.9846C241.745 49.2346 241.015 50.3746 240.095 51.3346C236.475 55.2546 231.915 56.6646 226.715 56.2146C223.645 55.9446 220.845 54.9046 218.425 52.9746C215.335 50.5146 213.575 47.2845 213.065 43.3945C212.605 39.9145 213.015 36.5445 214.675 33.4145C217.135 28.7945 221.155 26.5045 226.265 25.9145C229.285 25.5645 232.245 25.8545 235.025 27.1145C238.955 28.8845 241.235 32.0345 242.305 36.1245C242.885 38.3245 242.995 40.5646 242.885 42.8246C242.855 43.4646 242.705 43.6746 242.025 43.6846C235.565 43.7246 229.095 43.8145 222.635 43.8745H222.195C221.995 43.8745 221.845 43.9246 221.895 44.1846V44.1946ZM233.735 36.8346C233.465 34.7046 230.695 32.9146 227.715 32.9446C225.055 32.9646 222.225 34.9445 222.005 36.8845C221.985 36.9745 222.035 37.0646 222.125 37.0846C222.145 37.0846 222.165 37.0846 222.195 37.0846H233.555C233.825 37.0846 233.755 36.9146 233.745 36.8346H233.735Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M136.625 40.8645C136.625 32.4045 143.375 25.6846 151.895 25.6746C160.245 25.6146 167.065 32.3246 167.125 40.6746C167.125 40.7546 167.125 40.8246 167.125 40.9046C167.105 49.4546 160.255 56.4146 151.865 56.3846C143.435 56.3446 136.625 49.4145 136.625 40.8645ZM151.935 33.5946C150.505 33.5946 149.115 34.0646 147.985 34.9446C144.715 37.4446 144.155 42.6346 146.805 45.9146C149.705 49.5046 155.325 49.1045 157.635 45.1245C158.645 43.3745 158.925 41.4846 158.595 39.5045C158.045 36.1145 155.195 33.5846 151.935 33.5946Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M181.475 26.4746C182.895 26.4746 188.055 26.5246 190.335 26.4746C190.555 26.4746 190.745 26.6445 190.785 26.8645C192.565 31.6345 196.235 41.2746 197.145 43.6746C197.375 44.2746 197.535 43.8546 197.615 43.7046C197.655 43.6246 201.945 32.2845 204.005 26.8645C204.075 26.6345 204.295 26.4746 204.535 26.4746C206.725 26.5146 211.375 26.4746 212.975 26.4746C213.315 26.4746 213.485 26.7245 213.325 27.1145C211.905 30.5045 205.145 46.6945 201.665 54.9146C201.475 55.3546 201.255 55.5445 200.755 55.5345H193.875C193.505 55.5845 193.145 55.3546 193.045 54.9846C189.445 46.4946 182.395 29.6245 181.255 26.8645C181.155 26.6245 181.285 26.4746 181.485 26.4746H181.475Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M170.655 18.7046H178.285C178.885 18.7046 178.985 18.8345 178.975 19.4045C178.965 32.9245 178.975 41.2946 178.975 54.8146C178.975 55.3946 178.805 55.5546 178.235 55.5446C175.745 55.5146 173.255 55.5246 170.765 55.5446C170.285 55.5446 170.075 55.4445 170.075 54.9045C170.095 41.2945 170.075 32.8446 170.075 19.2246C170.045 18.9546 170.245 18.7146 170.515 18.6846C170.555 18.6846 170.605 18.6846 170.645 18.6846L170.655 18.7046Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M105.195 27.2346V26.8446C105.195 26.6446 105.035 26.4846 104.835 26.4846H96.705C96.505 26.4846 96.345 26.6446 96.345 26.8546V33.5546C96.345 33.7046 96.445 33.8445 96.585 33.8945C100.575 35.3845 102.605 39.8346 101.115 43.8346C100.335 45.9246 98.685 47.5845 96.585 48.3645C96.445 48.4145 96.345 48.5446 96.335 48.6946V54.7346C96.335 55.5046 96.705 55.5045 97.075 55.4945H104.495C105.105 55.4945 105.205 55.2746 105.205 54.7146C105.185 45.1046 105.205 36.8346 105.205 27.2346H105.195Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M108.905 47.6745L115.695 44.6945C115.875 44.5945 116.105 44.6646 116.205 44.8546C116.205 44.8746 116.225 44.8945 116.225 44.9145L116.325 45.1545C117.545 48.1445 120.895 49.6646 123.945 48.5946C124.085 48.5446 124.225 48.4945 124.365 48.4245C124.985 48.0945 125.575 47.7145 125.585 46.9045C125.595 46.1245 125.105 45.6245 124.465 45.3945C123.105 44.9145 121.725 44.5345 120.345 44.1545C118.675 43.6945 116.905 43.4745 115.315 42.8245C112.785 41.7745 110.865 39.9445 110.045 37.2445C109.385 35.0645 109.935 33.0145 111.105 31.1445C112.935 28.2245 115.695 26.5746 119.025 25.9646C123.635 25.1146 127.525 26.1745 131.095 29.5745C132.305 30.9445 132.885 31.7145 133.405 33.0245C133.515 33.3145 133.585 33.5345 133.215 33.6845C130.995 34.5845 128.785 35.4845 126.575 36.3845C126.425 36.4545 126.255 36.3846 126.185 36.2346C125.205 34.0646 123.385 33.1545 121.055 33.2745C118.495 33.4045 117.535 35.4045 118.715 36.0445C119.385 36.3945 120.085 36.6546 120.815 36.8346C122.865 37.3846 124.955 37.8245 126.995 38.4145C129.035 39.0145 130.825 40.0645 132.165 41.7645C134.845 45.1045 134.505 49.9445 131.385 52.8745C129.465 54.7045 127.135 55.6846 124.555 56.0946C120.715 56.7046 117.035 56.2545 113.675 54.1945C111.315 52.7445 109.725 50.8145 108.705 48.1545C108.605 47.9945 108.665 47.7745 108.825 47.6745C108.845 47.6645 108.875 47.6445 108.895 47.6445L108.905 47.6745Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M93.705 46.2146C96.5216 46.2146 98.805 43.9312 98.805 41.1145C98.805 38.2978 96.5216 36.0145 93.705 36.0145C90.8883 36.0145 88.605 38.2978 88.605 41.1145C88.605 43.9312 90.8883 46.2146 93.705 46.2146Z", fill: "#F7008C" }), /* @__PURE__ */ React.createElement("path", { d: "M276.585 19.2046H275.835V18.7046H277.915V19.2146H277.165V21.2246H276.595V19.2146L276.585 19.2046ZM278.445 18.7046H279.055L279.715 19.7645L280.375 18.7046H280.955V21.2146H280.415V19.5145L279.715 20.6145H279.665L278.965 19.5145V21.2146H278.425V18.7046H278.445Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.274536H58.3252V81.6345H59.3252V0.274536Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 16.3645C20.3554 13.4245 17.4954 11.7445 13.2954 11.7445C5.43539 11.7945 0.775391 18.0446 0.775391 26.7146C0.775391 35.3846 5.42539 41.6345 13.2954 41.6345C14.7354 41.7145 16.1854 41.4645 17.5254 40.9045C18.8654 40.3445 20.0654 39.4845 21.0354 38.3945V42.5646C21.0354 45.4046 19.5354 48.7745 14.7754 48.7745C11.1654 48.7745 9.38539 46.7546 8.76539 44.5846L2.38539 47.6746C3.98539 51.7746 7.80539 55.2146 15.2254 55.2146C26.2254 55.2146 29.0554 47.7946 29.0554 41.2946V12.1545H22.3254L22.1454 16.3546L22.1254 16.3645ZM15.0154 34.8346C11.0854 34.8346 8.76539 31.6345 8.76539 26.6545C8.76539 21.6745 11.0854 18.4746 15.0154 18.4746C18.9454 18.4746 21.2154 21.6745 21.2154 26.6545C21.2154 31.6345 18.9454 34.8346 15.0154 34.8346Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 57.4846V67.3745H1.02539V61.5345H23.3154V57.4846H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgJustworks$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 323, height: 83, viewBox: "0 0 323 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.683838H58.3252V82.0438H59.3252V0.683838Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M320.825 51.6539H89.8647V61.3639H320.825V51.6539Z", fill: "#1E98FF" }), /* @__PURE__ */ React.createElement("path", { d: "M88.595 41.8639L96.735 40.3239C96.885 44.4839 98.205 46.4939 100.955 46.4939C103.355 46.4939 104.455 45.3938 104.455 42.1738V18.2239H112.925V40.1638C112.925 48.7438 109.375 52.2938 100.765 52.2938C92.155 52.2938 89.255 47.1039 88.585 41.8639H88.595Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M118.195 43.4739V27.3639H126.465V43.6339C126.465 45.9739 127.575 46.8939 129.375 46.8939C131.775 46.8939 133.215 45.4339 133.215 42.0339V27.3639H141.485V51.6439H133.605V45.0939H133.395C132.185 50.7739 129.505 52.2339 125.845 52.2339C120.715 52.2039 118.195 49.5139 118.195 43.4739Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M145.705 46.4839L150.165 43.4739C151.635 46.1939 153.955 47.2539 156.995 47.2539C159.285 47.2539 160.295 46.5838 160.295 45.3038C160.295 43.8438 159.315 43.0639 156.585 42.5839L153.185 41.9438C148.605 41.1238 146.125 38.4538 146.125 34.6938C146.125 29.6838 150.165 26.7839 156.355 26.7839C162.545 26.7839 165.365 29.3039 166.915 32.1239L162.585 34.9039C161.475 32.3839 159.235 31.5638 157.175 31.5638C155.115 31.5638 153.905 32.3339 153.905 33.5939C153.905 34.8539 154.835 35.4938 157.175 35.9338L160.625 36.5739C165.725 37.5039 168.225 39.5839 168.225 44.1039C168.225 48.3739 165.495 52.2239 157.455 52.2239C151.535 52.2239 147.515 49.9639 145.705 46.4939V46.4839Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M173.135 45.0939V32.2239H169.835V27.3639H173.135V20.9939H181.405V27.3639H185.395V32.2239H181.405V44.3539C181.405 45.9439 182.045 46.5939 183.255 46.5939H185.395V51.6539H179.985C174.785 51.6539 173.135 50.0139 173.135 45.1039V45.0939Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M187.995 27.3639H196.955L200.305 42.6539H200.515L204.795 27.3639H211.625L215.745 42.6539H215.955L219.665 27.3639H226.185L218.635 51.6439H211.525L207.195 36.3839H206.985L202.865 51.6439H195.755L188.005 27.3639H187.995Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M226.935 39.4939C226.935 31.7339 232.005 26.7739 239.585 26.7739C247.165 26.7739 252.235 31.7339 252.235 39.4939C252.235 47.2539 247.165 52.2139 239.585 52.2139C232.005 52.2139 226.935 47.2839 226.935 39.4939ZM243.575 39.4939C243.575 33.2239 242.205 31.5839 239.585 31.5839C236.965 31.5839 235.595 33.2239 235.595 39.4939C235.595 45.7639 236.965 47.4039 239.585 47.4039C242.205 47.4039 243.575 45.7639 243.575 39.4939Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M255.885 27.3639H263.665V35.4338H263.875C265.035 28.7738 267.275 27.2139 270.885 27.2139H271.325V34.4839H267.335C264.935 34.4839 264.165 35.2539 264.165 38.1339V51.6239H255.895V27.3639H255.885Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M285.095 41.9338L282.725 44.5538V51.6439H274.535V18.2639H282.725V37.7938L291.175 27.3639H298.545L290.505 36.1039L299.055 51.6539H290.295L285.095 41.9438V41.9338Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M299.595 46.4839L304.075 43.4739C305.545 46.1939 307.865 47.2539 310.905 47.2539C313.195 47.2539 314.205 46.5838 314.205 45.3038C314.205 43.8438 313.225 43.0639 310.495 42.5839L307.095 41.9438C302.505 41.1238 300.035 38.4538 300.035 34.6938C300.035 29.6838 304.075 26.7839 310.265 26.7839C316.455 26.7839 319.275 29.3039 320.825 32.1239L316.495 34.9039C315.385 32.3839 313.145 31.5638 311.085 31.5638C309.025 31.5638 307.815 32.3339 307.815 33.5939C307.815 34.8539 308.745 35.4938 311.085 35.9338L314.535 36.5739C319.635 37.5039 322.135 39.5839 322.135 44.1039C322.135 48.3739 319.405 52.2239 311.365 52.2239C305.445 52.2239 301.395 49.9639 299.595 46.4939V46.4839Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 15.1638C20.3554 12.2238 17.4954 10.5438 13.2954 10.5438C5.43539 10.5938 0.775391 16.8439 0.775391 25.5139C0.775391 34.1839 5.42539 40.4338 13.2954 40.4338C14.7354 40.5138 16.1854 40.2639 17.5254 39.7039C18.8654 39.1439 20.0654 38.2838 21.0354 37.1938V41.3639C21.0354 44.2039 19.5354 47.5739 14.7754 47.5739C11.1654 47.5739 9.38539 45.5539 8.76539 43.3839L2.38539 46.4739C3.98539 50.5739 7.80539 54.0139 15.2254 54.0139C26.2254 54.0139 29.0554 46.5939 29.0554 40.0939V10.9539H22.3254L22.1454 15.1539L22.1254 15.1638ZM15.0154 33.6339C11.0854 33.6339 8.76539 30.4339 8.76539 25.4539C8.76539 20.4739 11.0854 17.2739 15.0154 17.2739C18.9454 17.2739 21.2154 20.4739 21.2154 25.4539C21.2154 30.4339 18.9454 33.6339 15.0154 33.6339Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 56.2938V66.1838H1.02539V60.3439H23.3154V56.2938H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgNamely$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 310, height: 86, viewBox: "0 0 310 86", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 3.74316H58.3252V85.1031H59.3252V3.74316Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M116.755 59.5632H111.705C110.625 59.5632 109.845 59.2132 109.025 57.8232L97.275 37.4432C97.065 37.1332 96.845 36.9933 96.685 36.9933C96.525 36.9933 96.305 37.0633 96.305 37.3733V58.2533C96.305 58.8233 96.085 59.5732 95.515 59.5732H89.435C88.865 59.5732 88.605 58.8133 88.605 58.2533V22.9432C88.605 21.8632 89.285 21.0833 90.365 21.0833H95.575C96.605 21.0833 97.125 21.5533 97.745 22.6333L109.965 43.8433C110.175 44.1533 110.175 44.2433 110.325 44.2433C110.425 44.2433 110.535 44.1333 110.535 43.7633V21.9633C110.535 21.3933 111.105 21.0732 111.665 21.0732H117.745C118.315 21.0732 118.825 21.3933 118.825 21.9633V57.3232C118.825 58.4032 117.855 59.5732 116.765 59.5732L116.755 59.5632Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M146.695 59.5632H140.925C140.355 59.5632 140.125 58.8033 140.125 58.2433V57.4232C137.755 58.8632 136.045 59.7433 132.955 59.7433C128.475 59.7433 124.135 57.5733 124.135 50.8733V50.4133C124.135 44.3833 127.775 41.8032 136.595 41.8032H139.535V39.8433C139.535 36.9033 138.015 36.2032 135.585 36.2032C132.285 36.2032 128.545 36.4733 126.945 36.4733H126.685C126.165 36.4733 125.905 36.3933 125.905 35.7233V31.5432C125.905 30.9732 126.195 30.5633 126.815 30.4133C128.725 29.9533 132.345 29.3333 135.745 29.3333C143.165 29.3333 147.825 32.3233 147.825 39.8533V58.2533C147.825 58.8233 147.265 59.5732 146.695 59.5732V59.5632ZM139.535 46.5333H136.595C132.985 46.5333 131.835 47.8833 131.835 50.4033V50.8633C131.835 53.0333 133.035 53.4432 135.195 53.4432C136.745 53.4432 138.355 52.9232 139.535 52.3132V46.5333Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M191.235 59.5632H184.995C184.425 59.5632 183.955 58.7532 183.955 58.1832V40.6033C183.955 37.3033 183.185 36.3232 180.815 36.3232C179.935 36.3232 178.315 36.5333 176.765 37.2533C176.865 38.2833 176.845 39.4733 176.845 40.6033V58.1832C176.845 58.7532 176.535 59.5632 175.965 59.5632H169.725C169.155 59.5632 168.545 58.7532 168.545 58.1832V40.6033C168.545 37.3033 167.825 36.3232 165.455 36.3232C164.475 36.3232 163.215 36.8433 161.435 37.6633V58.1832C161.435 58.7532 161.265 59.5632 160.705 59.5632H154.465C153.895 59.5632 153.145 58.7532 153.145 58.1832V30.7633C153.145 30.1933 153.845 29.9432 154.415 29.9432H160.295C160.865 29.9432 161.445 30.1933 161.445 30.7633V31.8933C163.225 30.4533 166.025 29.3132 169.015 29.3132C171.745 29.3132 173.625 30.0833 175.065 31.8433C178.055 30.1433 180.075 29.3132 183.425 29.3132C190.225 29.3132 192.245 33.8533 192.245 40.6033V58.1832C192.245 58.7532 191.795 59.5632 191.225 59.5632H191.235Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M221.905 47.1233H205.285V47.2032C205.285 50.1432 206.615 52.8733 210.685 52.8733C213.935 52.8733 218.605 52.4532 220.675 52.4532H220.825C221.395 52.4532 221.875 52.6132 221.875 53.1832V57.1033C221.875 57.9233 221.635 58.2933 220.755 58.4933C217.455 59.3133 214.545 59.7333 210.065 59.7333C203.825 59.7333 196.995 56.4333 196.995 46.4833V42.8733C196.995 34.5733 201.985 29.3132 210.185 29.3132C218.385 29.3132 223.065 35.0833 223.065 42.8733V45.8633C223.065 46.6333 222.585 47.1233 221.915 47.1233H221.905ZM214.765 41.7433C214.765 37.9333 212.965 36.0233 210.075 36.0233C207.185 36.0233 205.285 37.9833 205.285 41.7433V41.7932H214.765V41.7433Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M235.255 59.5632H228.965C228.395 59.5632 227.795 58.7532 227.795 58.1832V20.7633C227.795 20.1933 228.405 19.8833 228.965 19.8833H235.255C235.825 19.8833 236.085 20.2033 236.085 20.7633V58.1832C236.085 58.7532 235.825 59.5632 235.255 59.5632Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M268.135 30.9231L259.475 61.2832C257.875 66.8532 255.765 69.6831 248.185 69.6831C246.275 69.6831 243.215 69.2732 241.925 68.8632C241.355 68.6532 240.815 68.5031 240.815 67.9331V63.7532C240.815 63.1832 241.325 62.5232 241.895 62.5232H241.995C243.695 63.1132 246.735 63.0631 248.435 63.0631C250.295 63.0631 251.215 62.5331 251.835 60.4731L252.295 58.9731H251.525C249.615 58.9731 248.015 58.6332 246.735 54.1432L239.935 30.9331C239.885 30.7831 239.885 30.7731 239.885 30.6731C239.885 30.1531 240.195 29.9531 240.915 29.9531H247.775C248.295 29.9531 248.655 30.3131 248.755 30.8231L253.395 50.2532C253.545 50.9732 253.705 51.2732 254.015 51.2732H254.475L259.265 30.9231C259.365 30.4031 259.785 29.9531 260.345 29.9531H267.205C267.725 29.9531 268.185 30.2532 268.185 30.7732C268.185 30.8732 268.135 30.8231 268.135 30.9231Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M298.205 0.0932617L294.505 7.90332C294.365 7.73332 294.325 7.64328 294.165 7.48328C293.585 6.90328 292.925 6.45329 292.175 6.12329C291.425 5.79329 290.625 5.6333 289.785 5.6333C288.545 5.6333 287.425 5.96328 286.405 6.61328C285.385 7.26328 284.625 8.15332 284.125 9.27332L277.235 24.5933L288.285 29.7233L291.985 21.9432C292.125 22.1232 292.125 22.2033 292.295 22.3633C292.875 22.9433 293.545 23.3933 294.315 23.7233C295.085 24.0533 295.895 24.2133 296.745 24.2133C297.975 24.2133 299.085 23.8832 300.065 23.2032C301.055 22.5332 301.805 21.6333 302.345 20.5233L309.225 5.21326L298.225 0.103271L298.205 0.0932617Z", fill: "#0073DD" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 21.2233C20.3554 18.2833 17.4954 16.6033 13.2954 16.6033C5.43539 16.6533 0.775391 22.9032 0.775391 31.5732C0.775391 40.2432 5.42539 46.4933 13.2954 46.4933C14.7354 46.5733 16.1854 46.3233 17.5254 45.7633C18.8654 45.2033 20.0654 44.3433 21.0354 43.2533V47.4232C21.0354 50.2632 19.5354 53.6333 14.7754 53.6333C11.1654 53.6333 9.38539 51.6132 8.76539 49.4432L2.38539 52.5333C3.98539 56.6333 7.80539 60.0732 15.2254 60.0732C26.2254 60.0732 29.0554 52.6533 29.0554 46.1533V17.0133H22.3254L22.1454 21.2133L22.1254 21.2233ZM15.0154 39.6932C11.0854 39.6932 8.76539 36.4933 8.76539 31.5133C8.76539 26.5333 11.0854 23.3333 15.0154 23.3333C18.9454 23.3333 21.2154 26.5333 21.2154 31.5133C21.2154 36.4933 18.9454 39.6932 15.0154 39.6932Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 62.3533V72.2433H1.02539V66.4033H23.3154V62.3533H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgOnpay$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 285, height: 82, viewBox: "0 0 285 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M107.195 40.9779H99.9054C98.6654 40.9779 97.7354 40.0479 97.7354 38.8079V32.7579C97.7354 31.5179 98.6654 30.5879 99.9054 30.5879H107.195C108.435 30.5879 109.365 31.5179 109.365 32.7579V38.8079C109.365 40.0479 108.275 40.9779 107.195 40.9779Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M98.0552 55.5479H90.7652C89.5252 55.5479 88.5952 54.6179 88.5952 53.3779V45.3179C88.5952 44.0779 89.5252 43.1479 90.7652 43.1479H98.0552C99.2952 43.1479 100.225 44.0779 100.225 45.3179V53.3779C100.225 54.4679 99.1352 55.5479 98.0552 55.5479Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M112.935 55.5479H105.645C104.405 55.5479 103.475 54.6179 103.475 53.3779V46.0879C103.475 44.8479 104.405 43.9179 105.645 43.9179H112.935C114.175 43.9179 115.105 44.8479 115.105 46.0879V53.3779C115.105 54.4679 114.175 55.5479 112.935 55.5479Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M134.485 26.4079C126.115 26.4079 119.445 32.7679 119.445 41.1379C119.445 49.5079 126.265 55.3979 134.485 55.3979C142.705 55.3979 149.525 49.3479 149.525 41.1379C149.525 32.9279 142.855 26.4079 134.485 26.4079ZM134.485 49.9679C129.675 49.9679 125.955 46.2479 125.955 40.9779C125.955 35.7079 129.835 31.8279 134.485 31.8279C139.135 31.8279 143.015 35.8579 143.015 40.9779C143.015 46.0979 139.135 49.9679 134.485 49.9679Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M167.185 26.4079C153.695 26.4079 153.385 37.8779 153.385 37.8779V55.3979H159.745V39.8979C159.745 31.9879 167.185 32.1479 167.185 32.1479C167.185 32.1479 174.625 31.8379 174.625 39.8979V55.3979H180.985V37.8779C180.985 37.8779 180.675 26.4079 167.185 26.4079Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M199.735 26.4079C191.205 26.4079 185.005 32.1479 185.005 40.9779V66.7079H187.955C189.815 66.7079 191.215 65.3079 191.215 63.4479V51.8179C192.765 53.6779 196.335 55.6979 199.745 55.6979C208.275 55.6979 214.475 49.9579 214.475 41.1279C214.475 32.2979 208.275 26.3979 199.745 26.3979L199.735 26.4079ZM199.585 49.6579C194.625 49.6579 190.905 46.0879 190.905 40.8179C190.905 35.5479 194.625 31.9779 199.585 31.9779C204.545 31.9779 208.265 35.5479 208.265 40.8179C208.265 46.2479 204.545 49.6579 199.585 49.6579Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M232.445 26.4079C224.535 26.4079 218.185 32.9179 218.185 40.9779C218.185 49.0379 224.545 55.5479 232.445 55.5479C236.325 55.5479 239.885 53.5279 241.745 51.2079V52.7579C241.745 54.1579 242.985 55.3979 244.385 55.3979H247.795V40.8279C247.795 32.9179 242.525 26.4079 232.445 26.4079ZM233.065 49.6579C228.105 49.6579 224.385 45.9379 224.385 40.9779C224.385 36.0179 228.105 32.2979 233.065 32.2979C238.025 32.2979 241.745 36.0179 241.745 40.9779C241.745 45.9379 238.025 49.6579 233.065 49.6579Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M249.645 26.4079L258.635 51.8279C258.635 51.8279 259.565 53.8479 257.235 56.0179C255.995 57.2579 254.135 58.6579 252.895 59.7379C251.805 60.6679 251.345 62.3779 251.965 63.7679L253.205 66.7179C253.205 66.7179 259.565 63.6179 266.225 55.0879C266.225 55.0879 268.705 52.1379 270.875 47.3379C273.045 42.5279 279.865 26.2579 279.865 26.2579H273.505L264.205 47.8079L256.455 26.2579H249.635V26.4179L249.645 26.4079Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M280.335 61.1279C277.855 61.1279 275.835 59.1079 275.835 56.6279C275.835 54.1479 277.855 52.1279 280.335 52.1279C282.815 52.1279 284.835 54.1479 284.835 56.6279C284.835 59.1079 282.815 61.1279 280.335 61.1279ZM280.335 52.9079C278.315 52.9079 276.615 54.6179 276.615 56.6279C276.615 58.6379 278.325 60.3479 280.335 60.3479C282.345 60.3479 284.055 58.6379 284.055 56.6279C284.055 54.6179 282.505 52.9079 280.335 52.9079Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M282.195 58.9579L280.795 57.0979C281.255 56.9379 281.725 56.6279 281.725 55.8579C281.725 54.9279 280.945 54.6179 280.485 54.6179H278.935V58.9579H279.395V57.0979H280.175L281.415 58.9579H282.195ZM279.555 55.0779H280.645C280.805 55.0779 281.425 55.0779 281.425 55.8579C281.425 56.6379 280.645 56.6379 280.645 56.6379H279.555V55.0879V55.0779Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.227905H58.3252V81.5879H59.3252V0.227905Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 17.7779C20.3554 14.8379 17.4954 13.1579 13.2954 13.1579C5.43539 13.2079 0.775391 19.4579 0.775391 28.1279C0.775391 36.7979 5.42539 43.0479 13.2954 43.0479C14.7354 43.1279 16.1854 42.8779 17.5254 42.3179C18.8654 41.7579 20.0654 40.8979 21.0354 39.8079V43.9779C21.0354 46.8179 19.5354 50.1879 14.7754 50.1879C11.1654 50.1879 9.38539 48.1679 8.76539 45.9979L2.38539 49.0879C3.98539 53.1879 7.80539 56.6279 15.2254 56.6279C26.2254 56.6279 29.0554 49.2079 29.0554 42.7079V13.5679H22.3254L22.1454 17.7679L22.1254 17.7779ZM15.0154 36.2479C11.0854 36.2479 8.76539 33.0479 8.76539 28.0679C8.76539 23.0879 11.0854 19.8879 15.0154 19.8879C18.9454 19.8879 21.2154 23.0879 21.2154 28.0679C21.2154 33.0479 18.9454 36.2479 15.0154 36.2479Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 58.9079V68.7979H1.02539V62.9579H23.3154V58.9079H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgPaychex$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 279, height: 82, viewBox: "0 0 279 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M22.1254 18.5526C20.3554 15.6126 17.4954 13.9326 13.2954 13.9326C5.43539 13.9826 0.775391 20.2327 0.775391 28.9027C0.775391 37.5727 5.42539 43.8226 13.2954 43.8226C14.7354 43.9026 16.1854 43.6527 17.5254 43.0927C18.8654 42.5327 20.0654 41.6726 21.0354 40.5826V44.7527C21.0354 47.5927 19.5354 50.9626 14.7754 50.9626C11.1654 50.9626 9.38539 48.9427 8.76539 46.7727L2.38539 49.8627C3.98539 53.9627 7.80539 57.4027 15.2254 57.4027C26.2254 57.4027 29.0554 49.9827 29.0554 43.4827V14.3427H22.3254L22.1454 18.5427L22.1254 18.5526ZM15.0154 37.0227C11.0854 37.0227 8.76539 33.8227 8.76539 28.8427C8.76539 23.8627 11.0854 20.6627 15.0154 20.6627C18.9454 20.6627 21.2154 23.8627 21.2154 28.8427C21.2154 33.8227 18.9454 37.0227 15.0154 37.0227Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 59.6726V69.5626H1.02539V63.7227H23.3154V59.6726H29.0354H29.0454Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.152588H58.3252V81.5126H59.3252V0.152588Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M101.975 33.8223H105.015C106.885 33.8223 108.885 34.1922 108.885 36.4222C108.885 38.3622 107.705 39.6923 104.125 39.6923H100.715L101.975 33.8223ZM88.5952 55.3823H97.4152L99.2452 46.6123H105.265C112.905 46.6123 117.825 41.5623 117.825 35.7223C117.825 29.3023 114.375 26.3623 109.045 26.3623H94.6452L88.5952 55.3823Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M128.665 36.3325H128.745L129.725 45.0326H124.155L128.675 36.3325H128.665ZM109.565 55.3926H118.675L120.915 51.2526H130.385L130.875 55.3926H139.665L135.145 26.3726H126.375L109.585 55.3926H109.565Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M143.265 44.7426L137.045 26.3726H146.015L148.785 37.1925L155.855 26.3726H166.345L152.205 44.6626L150.005 55.3926H141.065L143.265 44.7426Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M187.685 44.3724C187.145 47.3324 184.885 56.0824 172.805 56.0824C164.395 56.0824 160.335 50.6324 160.335 42.8724C160.335 33.4924 166.185 25.6724 176.065 25.6724C182.525 25.6724 188.295 28.4924 188.465 37.1824H180.015C180.105 34.4624 178.785 32.9125 176.035 32.9125C171.065 32.9125 169.275 38.6024 169.275 42.7024C169.275 45.1024 169.855 48.8224 173.955 48.8224C176.765 48.8224 178.345 46.9124 178.925 44.3624H187.695L187.685 44.3724Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M192.845 26.3726H201.795L199.685 36.4525H207.855L209.975 26.3726H218.925L212.865 55.3926H203.905L206.315 43.9126H198.135L195.735 55.3926H186.785L192.845 26.3726Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M221.275 26.3723H245.255L243.745 33.8223H228.705L227.935 37.4023H241.875L240.455 44.3223H226.465L225.695 47.9323H241.065L239.515 55.3823H215.215L221.275 26.3623V26.3723Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M251.405 40.0126L244.745 26.3726H254.455L257.275 33.9126L263.045 26.3726H273.655L261.585 40.0126L268.615 55.3826H258.575L255.365 47.2726L248.655 55.3826H237.675L251.415 40.0126H251.405Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M274.795 27.7024C274.795 26.6424 275.595 25.8324 276.615 25.8324C277.635 25.8324 278.435 26.6424 278.435 27.7024C278.435 28.7624 277.635 29.5924 276.615 29.5924C275.595 29.5924 274.795 28.7824 274.795 27.7024ZM274.395 27.7024C274.395 28.9624 275.415 29.9125 276.615 29.9125C277.815 29.9125 278.845 28.9624 278.845 27.7024C278.845 26.4424 277.825 25.5024 276.615 25.5024C275.405 25.5024 274.395 26.4524 274.395 27.7024ZM275.765 29.0024H276.165V27.8925H276.585L277.295 29.0024H277.715L276.975 27.8624C277.355 27.8224 277.655 27.6225 277.655 27.1625C277.655 26.6625 277.365 26.4224 276.755 26.4224H275.765V29.0125V29.0024ZM276.165 26.7424H276.695C276.965 26.7424 277.255 26.7925 277.255 27.1425C277.255 27.5525 276.935 27.5624 276.575 27.5624H276.165V26.7424Z", fill: "#004B8D" }));
const SvgPaycom$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 316, height: 82, viewBox: "0 0 316 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.562012H58.3252V81.9219H59.3252V0.562012Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M129.405 16.4919C127.655 16.4919 126.235 16.4919 126.235 16.4919C126.235 16.4919 124.805 16.4919 123.065 16.4919H91.775C90.035 16.4919 88.605 17.9219 88.605 19.6619V62.9719C88.605 64.7219 90.035 66.1421 91.775 66.1421H98.455C100.205 66.1421 101.625 64.7119 101.625 62.9719V32.6919C101.625 30.9419 103.055 29.522 104.795 29.522H122.045C123.795 29.522 125.215 30.9519 125.215 32.6919V49.8921C125.215 51.6421 123.785 53.062 122.045 53.062H112.115C110.365 53.062 108.945 54.4919 108.945 56.2319V62.9219C108.945 64.6619 110.375 66.092 112.115 66.092H122.045C123.795 66.092 125.215 66.092 125.215 66.092H135.075C136.815 66.092 138.245 64.6619 138.245 62.9219V19.6521C138.245 17.9121 136.815 16.4819 135.075 16.4819H129.395L129.405 16.4919Z", fill: "url(#paint0_linear_8657_21568)" }), /* @__PURE__ */ React.createElement("path", { d: "M149.315 37.582H153.615V40.332H153.715C154.905 38.882 157.675 37.1221 161.985 37.1221C169.055 37.1221 172.495 41.7519 172.495 46.9819C172.495 52.2119 169.385 57.532 162.035 57.532C157.735 57.532 155.295 56.1921 153.915 54.4021H153.825V65.1021H149.335V37.582H149.315ZM161.025 40.032C156.155 40.032 153.805 43.7421 153.805 47.3721C153.805 50.6221 155.905 54.6321 160.975 54.6321C166.045 54.6321 167.805 50.312 167.715 47.262C167.815 43.742 165.895 40.032 161.025 40.032Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M178.085 38.9619C180.335 37.8919 183.005 37.1221 186.115 37.1221C193.095 37.1221 195.915 39.8719 195.915 45.1919V53.262C195.915 55.482 196.015 56.512 196.105 57.082H191.905V54.562H191.805C190.755 55.742 188.365 57.542 184.255 57.542C179.005 57.542 175.315 55.7119 175.315 51.4619C175.315 46.5719 182.005 45.042 186.635 45.042C188.405 45.042 189.645 45.0421 191.415 45.1221C191.415 41.7621 189.885 40.042 185.395 40.042C182.865 40.042 180.135 40.802 178.325 42.032L178.085 38.9719V38.9619ZM191.415 47.792C190.455 47.792 189.505 47.7119 188.545 47.7119C186.105 47.7119 180.085 48.0219 180.085 51.4619C180.085 53.5219 182.575 54.6321 184.625 54.6321C189.065 54.6321 191.405 52.412 191.405 49.512V47.792H191.415Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M200.105 62.3521C200.675 62.5021 201.445 62.6619 202.205 62.6619C206.215 62.6619 207.555 58.222 207.555 57.842C207.555 57.422 206.985 56.432 206.695 55.782L198.425 37.582H203.345L209.895 53.7119H209.995L216.685 37.582H221.225L212.245 57.502C210.575 61.252 208.805 65.572 202.885 65.572C201.445 65.572 200.635 65.422 199.825 65.302L200.105 62.3521Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M239.725 40.8721C238.005 40.3021 236.285 40.032 234.855 40.032C229.835 40.032 227.025 43.622 227.025 47.332C227.025 50.812 229.365 54.6321 235.145 54.6321C236.665 54.6321 238.585 54.252 239.965 53.522L240.295 56.7319C238.435 57.4219 236.285 57.532 234.665 57.532C227.305 57.532 222.245 52.912 222.245 47.332C222.245 41.402 227.215 37.1221 234.665 37.1221C236.475 37.1221 238.815 37.4621 240.105 37.8921L239.725 40.8721Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M254.675 37.1221C262.085 37.1221 267.055 41.402 267.055 47.332C267.055 52.912 261.995 57.532 254.675 57.532C247.355 57.532 242.255 52.912 242.255 47.332C242.255 41.402 247.225 37.1221 254.675 37.1221ZM254.675 54.6321C259.935 54.6321 262.275 50.812 262.275 47.332C262.275 43.622 259.455 40.032 254.675 40.032C249.895 40.032 247.035 43.622 247.035 47.332C247.035 50.812 249.375 54.6321 254.675 54.6321Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M271.445 37.582H275.655V40.4119H275.755C277.475 38.1519 279.915 37.1221 283.495 37.1221C286.315 37.1221 289.135 38.2721 290.425 40.9021C292.095 38.1121 295.775 37.1221 297.975 37.1221C304.185 37.1221 306.435 40.332 306.435 44.582V57.082H301.945V45.4619C301.945 43.0519 301.235 40.032 297.595 40.032C293.005 40.032 291.195 43.622 291.195 47.262V57.082H286.705V45.4619C286.705 43.0519 285.985 40.032 282.355 40.032C277.765 40.032 275.945 43.622 275.945 47.262V57.082H271.455V37.592L271.445 37.582Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M308.935 40.9719C308.935 39.1519 310.415 37.6619 312.245 37.6619C314.075 37.6619 315.555 39.1419 315.555 40.9719C315.555 42.8019 314.075 44.282 312.245 44.282C310.415 44.282 308.935 42.8019 308.935 40.9719ZM314.745 40.9719C314.745 39.4219 313.625 38.312 312.245 38.312C310.865 38.312 309.745 39.4319 309.745 40.9719C309.745 42.5119 310.865 43.6421 312.245 43.6421C313.625 43.6421 314.745 42.5219 314.745 40.9719ZM310.965 39.082H312.355C313.255 39.082 313.735 39.3919 313.735 40.1819C313.735 40.8219 313.365 41.1319 312.755 41.1919L313.765 42.832H313.055L312.085 41.2219H311.675V42.832H310.975V39.092L310.965 39.082ZM311.665 40.6819H312.275C312.685 40.6819 313.045 40.6221 313.045 40.1221C313.045 39.6821 312.645 39.6121 312.285 39.6121H311.665V40.6819Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 18.7119C20.3554 15.7719 17.4954 14.092 13.2954 14.092C5.43539 14.142 0.775391 20.392 0.775391 29.062C0.775391 37.732 5.42539 43.9819 13.2954 43.9819C14.7354 44.0619 16.1854 43.812 17.5254 43.252C18.8654 42.692 20.0654 41.8319 21.0354 40.7419V44.9119C21.0354 47.7519 19.5354 51.1221 14.7754 51.1221C11.1654 51.1221 9.38539 49.1019 8.76539 46.9319L2.38539 50.022C3.98539 54.122 7.80539 57.562 15.2254 57.562C26.2254 57.562 29.0554 50.1421 29.0554 43.6421V14.502H22.3254L22.1454 18.7019L22.1254 18.7119ZM15.0154 37.1819C11.0854 37.1819 8.76539 33.982 8.76539 29.002C8.76539 24.022 11.0854 20.822 15.0154 20.822C18.9454 20.822 21.2154 24.022 21.2154 29.002C21.2154 33.982 18.9454 37.1819 15.0154 37.1819Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 59.832V69.7219H1.02539V63.8821H23.3154V59.832H29.0354H29.0454Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_8657_21568", x1: 91.245, y1: 21.832, x2: 132.415, y2: 57.9919, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#A2CE60" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.7, stopColor: "#008E4C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#006242" }))));
const SvgPaycor$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 241, height: 83, viewBox: "0 0 241 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.971191H58.3252V82.3313H59.3252V0.971191Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M113.565 40.8213C115.055 39.3113 115.885 37.2613 115.845 35.1313C115.885 33.3313 115.205 31.5813 113.955 30.2913C111.235 27.5713 106.505 27.1714 100.855 27.1714H88.605V55.7014C88.605 55.9714 88.825 56.1914 89.095 56.1914H95.295V44.4414C95.295 44.4414 98.115 44.5112 99.895 44.5112C104.385 44.5112 110.125 44.3313 113.575 40.8313L113.565 40.8213ZM95.285 42.2312V29.4314C96.425 29.3314 97.575 29.2913 98.725 29.3213C102.355 29.3213 109.055 29.8113 109.055 35.5713C109.055 41.3313 102.845 42.3113 98.275 42.3113C96.505 42.3113 95.275 42.2312 95.275 42.2312H95.285Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M240.885 37.2912C240.885 37.0112 240.885 36.8214 240.525 36.6914C239.035 36.2214 237.465 36.0113 235.905 36.0813C233.175 36.1013 230.465 36.5313 227.865 37.3413V36.8613C227.865 36.5913 227.645 36.3713 227.375 36.3713H221.165V55.7112C221.165 55.9812 221.375 56.2014 221.635 56.2014H227.845V44.1914C227.845 40.5614 231.335 39.0613 234.985 39.0613C236.995 39.0913 238.995 39.4814 240.875 40.2014V37.3012L240.885 37.2912Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M127.335 35.7014C122.045 35.7014 118.725 37.0612 117.865 37.4812C117.645 37.5812 117.505 37.8013 117.495 38.0513V40.9514C119.875 39.5214 122.595 38.7712 125.365 38.7612C127.045 38.6912 128.685 39.2814 129.915 40.4214C130.705 41.2214 131.095 42.1914 131.095 44.2014C131.095 44.2014 128.075 43.9712 125.705 43.9712C121.405 43.9712 113.185 44.7513 113.185 50.5813C113.185 53.3513 115.275 56.3813 121.975 56.3813C125.085 56.3413 128.165 55.7812 131.085 54.7312V55.7014C131.085 55.9714 131.305 56.1914 131.575 56.1914H137.775V43.1113C137.775 38.2913 134.715 35.7112 127.335 35.7112V35.7014ZM131.135 52.2913C129.345 53.1413 127.385 53.5913 125.405 53.6313C122.525 53.6313 120.105 52.6414 120.105 49.9514C120.105 47.0014 122.685 46.0212 128.715 46.0212C129.925 46.0212 131.145 46.0713 131.145 46.0713V52.2913H131.135Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M160.955 36.3613C160.685 36.3613 160.445 36.5212 160.325 36.7712L152.485 51.4214C152.485 51.4214 144.845 37.1612 144.605 36.7712C144.485 36.5312 144.235 36.3914 143.965 36.4014H138.515L149.555 56.8113L144.265 66.4114H149.995C150.325 66.4314 150.625 66.2612 150.765 65.9612L166.915 36.3713H160.945L160.955 36.3613Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M164.055 23.3813C165.505 24.2413 166.055 26.0813 165.315 27.5913L163.055 31.7412C162.995 31.9512 163.105 32.1712 163.315 32.2412C163.375 32.2612 163.435 32.2612 163.495 32.2512L181.855 26.6514C182.375 26.4614 182.725 25.9614 182.715 25.4114C182.715 24.8314 182.335 24.3214 181.785 24.1514L149.405 14.1514C149.405 14.1514 149.305 14.1514 149.255 14.1514C149.005 14.1514 148.805 14.3513 148.805 14.6013C148.805 14.7513 148.885 14.9012 149.025 14.9712L164.065 23.3713L164.055 23.3813Z", fill: "#F37322" }), /* @__PURE__ */ React.createElement("path", { d: "M204.155 35.7014C194.855 35.7014 190.645 40.8713 190.645 46.3613C190.645 51.8513 194.945 56.9214 204.355 56.9214C213.765 56.9214 218.485 52.2713 218.485 46.3013C218.485 40.0113 213.295 35.7014 204.145 35.7014H204.155ZM204.635 54.1514C200.625 54.1514 197.405 50.6312 197.405 46.2612C197.405 41.8912 200.265 38.5613 204.695 38.5613C209.125 38.5613 211.745 42.8012 211.745 46.4612C211.745 50.3412 209.325 54.1614 204.635 54.1614V54.1414V54.1514Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M188.725 51.3613C186.305 52.7613 183.575 53.5213 180.775 53.5613C176.225 53.5613 172.725 50.8213 172.725 46.3113C172.725 41.8013 176.215 38.5513 181.375 38.5513C183.855 38.5213 186.275 39.2414 188.335 40.6414L189.655 38.3013C189.755 38.0913 189.665 37.8412 189.455 37.7412H189.445C188.275 37.2112 185.275 35.7014 179.495 35.7014C170.195 35.7014 165.985 40.8713 165.985 46.3613C165.985 51.8513 170.285 56.9214 179.705 56.9214C183.185 56.9214 186.595 55.9413 189.545 54.0813C189.765 53.9813 189.855 53.7212 189.755 53.5012V53.4712L188.725 51.3613Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M233.105 53.5613C233.105 53.0913 232.825 52.9114 232.245 52.9114H231.385V55.1814H231.755V54.2112H232.105L232.695 55.1814H233.115L232.475 54.1814C232.795 54.2114 233.075 53.9814 233.105 53.6614C233.105 53.6314 233.105 53.6013 233.105 53.5713V53.5613ZM231.785 53.8914V53.2312H232.235C232.455 53.2312 232.735 53.2312 232.735 53.5312C232.735 53.8313 232.485 53.8914 232.205 53.8914H231.785Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M232.185 51.9515C231.055 51.9315 230.115 52.8313 230.095 53.9613C230.075 55.0913 230.965 56.0314 232.105 56.0514C233.245 56.0714 234.175 55.1713 234.195 54.0413V54.0013C234.225 52.9013 233.365 51.9815 232.265 51.9515C232.235 51.9515 232.215 51.9515 232.185 51.9515ZM232.185 55.7015C231.245 55.5415 230.625 54.6415 230.785 53.7015C230.915 52.9815 231.465 52.4214 232.185 52.3014C233.125 52.4614 233.745 53.3614 233.585 54.3014C233.455 55.0214 232.905 55.5815 232.185 55.7015Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 19.1213C20.3554 16.1813 17.4954 14.5012 13.2954 14.5012C5.43539 14.5512 0.775391 20.8012 0.775391 29.4712C0.775391 38.1412 5.42539 44.3914 13.2954 44.3914C14.7354 44.4714 16.1854 44.2214 17.5254 43.6614C18.8654 43.1014 20.0654 42.2414 21.0354 41.1514V45.3213C21.0354 48.1613 19.5354 51.5312 14.7754 51.5312C11.1654 51.5312 9.38539 49.5113 8.76539 47.3413L2.38539 50.4314C3.98539 54.5314 7.80539 57.9712 15.2254 57.9712C26.2254 57.9712 29.0554 50.5513 29.0554 44.0513V14.9114H22.3254L22.1454 19.1113L22.1254 19.1213ZM15.0154 37.5913C11.0854 37.5913 8.76539 34.3914 8.76539 29.4114C8.76539 24.4314 11.0854 21.2312 15.0154 21.2312C18.9454 21.2312 21.2154 24.4314 21.2154 29.4114C21.2154 34.3914 18.9454 37.5913 15.0154 37.5913Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 60.2412V70.1313H1.02539V64.2913H23.3154V60.2412H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgPaylocity$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 322, height: 82, viewBox: "0 0 322 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M22.1254 18.5205C20.3554 15.5805 17.4954 13.9006 13.2954 13.9006C5.43539 13.9506 0.775391 20.2006 0.775391 28.8706C0.775391 37.5406 5.42539 43.7905 13.2954 43.7905C14.7354 43.8705 16.1854 43.6205 17.5254 43.0605C18.8654 42.5005 20.0654 41.6405 21.0354 40.5505V44.7207C21.0354 47.5607 19.5354 50.9307 14.7754 50.9307C11.1654 50.9307 9.38539 48.9107 8.76539 46.7407L2.38539 49.8306C3.98539 53.9306 7.80539 57.3706 15.2254 57.3706C26.2254 57.3706 29.0554 49.9507 29.0554 43.4507V14.3105H22.3254L22.1454 18.5105L22.1254 18.5205ZM15.0154 36.9907C11.0854 36.9907 8.76539 33.7905 8.76539 28.8105C8.76539 23.8305 11.0854 20.6306 15.0154 20.6306C18.9454 20.6306 21.2154 23.8305 21.2154 28.8105C21.2154 33.7905 18.9454 36.9907 15.0154 36.9907Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 59.6506V69.5405H1.02539V63.7007H23.3154V59.6506H29.0354H29.0454Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.380615H58.3252V81.7407H59.3252V0.380615Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M319.455 31.8906C318.495 31.8906 317.685 32.6806 317.685 33.6306C317.655 34.6206 318.445 35.4307 319.425 35.4307C320.415 35.4607 321.225 34.6707 321.225 33.6907C321.225 32.7107 320.435 31.8906 319.455 31.8906ZM319.455 35.1807C318.665 35.1807 318.035 34.5405 318.035 33.7605C318.005 32.9505 318.645 32.2805 319.455 32.2805C320.265 32.2505 320.935 32.8907 320.935 33.7007C320.935 34.5107 320.295 35.1807 319.455 35.1807Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M320.125 33.4106V33.3205C320.095 33.0305 319.836 32.8305 319.546 32.8505H318.875V34.5905H319.195V33.9806H319.395L319.835 34.5905H320.185L319.745 33.9506C320.005 33.8906 320.125 33.7205 320.125 33.4005V33.4106ZM319.546 33.7306H319.195V33.2106H319.546C319.696 33.2106 319.805 33.3306 319.805 33.4706C319.805 33.6106 319.686 33.7306 319.546 33.7306Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M212.125 41.6707L208.235 31.9507H201.625L209.045 48.5007L204.425 59.9607H210.785L222.365 31.9507H215.965L212.125 41.6707Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M230.005 22.0706H224.045V50.7107H230.005V22.0706Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M242.715 31.4607C242.595 31.4607 242.515 31.4607 242.395 31.4907C236.955 31.2907 232.425 35.5307 232.215 40.9707V41.3206C232.245 46.7306 236.635 51.1206 242.075 51.1206H242.395C247.835 51.3206 252.395 47.0806 252.605 41.6106V41.3206C252.575 35.8506 248.155 31.4607 242.715 31.4607ZM246.525 41.0605V41.2905C246.645 43.5305 244.895 45.4505 242.655 45.5605C242.565 45.5605 242.485 45.5605 242.395 45.5305C240.155 45.5905 238.295 43.7905 238.235 41.5505V41.2605C238.145 39.0205 239.865 37.1007 242.135 36.9907H242.365C244.635 36.9607 246.495 38.7905 246.525 41.0305V41.0605Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M264.525 36.9806H264.905C266.305 37.0106 267.635 37.6804 268.485 38.7804L273.075 35.8705C271.275 33.0805 268.185 31.4206 264.875 31.4506C259.405 31.4506 254.525 35.2606 254.525 41.2206C254.525 47.1806 259.415 51.0504 264.875 51.0504C268.195 51.0805 271.305 49.4205 273.075 46.6305L268.485 43.7206C267.645 44.8506 266.305 45.5204 264.905 45.5204C262.635 45.6404 260.685 43.8905 260.575 41.6205V41.2106C260.515 38.9406 262.295 37.0506 264.525 36.9606V36.9806Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M278.315 22.1808H278.255C276.275 22.0908 274.625 23.6307 274.535 25.6107V25.6407C274.625 27.6207 276.275 29.1607 278.225 29.1007C280.175 29.1307 281.805 27.5907 281.835 25.6407C281.835 23.7207 280.235 22.1508 278.315 22.1808Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M281.185 31.9507H275.225V50.7107H281.185V31.9507Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M310.505 31.9507L306.665 41.6707L302.765 31.9507H293.255V25.2107H287.295V31.9807H283.865V36.4607H287.295V50.7705H293.255V36.4307H298.145L303.555 48.5007L298.925 59.9607H305.295L316.895 31.9507H310.505Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M168.655 31.4907H168.275C166.065 31.4307 163.945 32.3307 162.455 33.9907V31.9807H156.495V59.9807H162.455V48.5806C163.935 50.2106 166.065 51.1105 168.275 51.0205C173.395 50.9605 177.495 46.7706 177.435 41.6606V41.2507C177.695 36.1307 173.775 31.7707 168.655 31.4807V31.4907ZM167.025 45.5405C164.665 45.4805 162.805 43.5607 162.865 41.2107C162.925 38.8507 164.845 36.9905 167.195 37.0505C169.495 37.1105 171.325 38.9705 171.355 41.2705C171.325 43.6505 169.375 45.5405 167.025 45.5405Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M193.985 34.0204C192.505 32.3604 190.375 31.4604 188.145 31.5204C183.025 31.6104 178.955 35.8206 179.045 40.9406V41.3204C178.755 46.4404 182.655 50.8005 187.765 51.0905H188.145C190.355 51.1505 192.475 50.2205 193.985 48.5905V50.7106H199.915V31.9506H194.015L193.985 34.0104V34.0204ZM189.445 45.5404C187.115 45.4804 185.255 43.5606 185.315 41.2406C185.375 38.9106 187.295 37.0505 189.615 37.1105C191.915 37.1705 193.775 39.0305 193.745 41.3305C193.685 43.6605 191.765 45.5504 189.445 45.5504V45.5404Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M126.835 44.0806C125.755 54.8706 122.995 62.7205 118.255 67.0505C118.105 67.1705 118.105 67.4005 118.225 67.5205L118.315 67.6106C119.685 68.0506 121.105 68.2805 122.535 68.2805C132.075 68.2805 140.095 57.9906 142.865 44.1206C142.865 43.9506 142.745 43.8305 142.605 43.8005L127.105 43.8306C126.955 43.8306 126.845 43.9506 126.845 44.0906L126.835 44.0806Z", fill: "url(#paint0_linear_8657_21661)" }), /* @__PURE__ */ React.createElement("path", { d: "M142.885 38.4707V38.4106C140.065 24.4206 132.035 14.3005 122.555 14.3005C119.535 14.3005 110.105 14.3005 106.935 34.8005C106.875 35.1805 107.345 35.3207 107.455 34.9707C108.935 29.9107 111.935 21.7407 115.745 21.7407C118.475 21.7407 121.645 25.9606 124.965 38.5806C124.995 38.7006 125.085 38.7805 125.225 38.8105H142.615C142.785 38.7805 142.905 38.6407 142.875 38.4607L142.885 38.4707Z", fill: "url(#paint1_linear_8657_21661)" }), /* @__PURE__ */ React.createElement("path", { d: "M104.655 38.5506C105.755 27.7606 108.495 19.9106 113.235 15.5806C113.385 15.4306 113.385 15.2306 113.235 15.0906C113.205 15.0606 113.175 15.0306 113.145 15.0306C111.775 14.5906 110.355 14.3607 108.925 14.3607C99.4152 14.3307 91.3652 24.6208 88.5952 38.5008C88.5952 38.6708 88.7152 38.7906 88.8552 38.8206H104.385C104.535 38.8206 104.645 38.7006 104.645 38.5606L104.655 38.5506Z", fill: "url(#paint2_linear_8657_21661)" }), /* @__PURE__ */ React.createElement("path", { d: "M124.545 47.8306C124.605 47.4506 124.135 47.3106 124.025 47.6606C122.545 52.6906 119.545 60.8606 115.735 60.8606C113.005 60.8606 109.835 56.6405 106.515 44.0205C106.485 43.9005 106.395 43.8205 106.255 43.7905L88.865 43.8206C88.715 43.8506 88.605 43.9706 88.605 44.1106V44.2307C91.335 57.7907 98.965 67.7105 108.055 68.3105H110.145C113.955 68.0905 121.725 66.0806 124.545 47.8406V47.8306Z", fill: "url(#paint3_linear_8657_21661)" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_8657_21661", x1: 139.639, y1: 56.228, x2: 89.6482, y2: 56.228, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint1_linear_8657_21661", x1: 91.9394, y1: 26.6325, x2: 141.136, y2: 26.6325, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint2_linear_8657_21661", x1: -233010, y1: 26.6315, x2: 141.139, y2: 26.6315, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint3_linear_8657_21661", x1: 139.638, y1: 56.228, x2: 89.648, y2: 56.228, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" }))));
const SvgQbo$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 308, height: 82, viewBox: "0 0 308 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M22.1254 17.8893C20.3554 14.9493 17.4954 13.2693 13.2954 13.2693C5.43539 13.3193 0.775391 19.5693 0.775391 28.2393C0.775391 36.9093 5.42539 43.1593 13.2954 43.1593C14.7354 43.2393 16.1854 42.9893 17.5254 42.4293C18.8654 41.8693 20.0654 41.0093 21.0354 39.9193V44.0893C21.0354 46.9293 19.5354 50.2993 14.7754 50.2993C11.1654 50.2993 9.38539 48.2793 8.76539 46.1093L2.38539 49.1993C3.98539 53.2993 7.80539 56.7393 15.2254 56.7393C26.2254 56.7393 29.0554 49.3193 29.0554 42.8193V13.6793H22.3254L22.1454 17.8793L22.1254 17.8893ZM15.0154 36.3593C11.0854 36.3593 8.76539 33.1593 8.76539 28.1793C8.76539 23.1993 11.0854 19.9993 15.0154 19.9993C18.9454 19.9993 21.2154 23.1993 21.2154 28.1793C21.2154 33.1593 18.9454 36.3593 15.0154 36.3593Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 59.0093V68.8993H1.02539V63.0593H23.3154V59.0093H29.0354H29.0454Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.409302H58.3252V81.7693H59.3252V0.409302Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9193_21251)" }, /* @__PURE__ */ React.createElement("path", { d: "M113.97 62.9406C127.761 62.9406 138.941 51.761 138.941 37.9703C138.941 24.1796 127.761 13 113.97 13C100.18 13 89 24.1796 89 37.9703C89 51.761 100.18 62.9406 113.97 62.9406Z", fill: "#2CA01C" }), /* @__PURE__ */ React.createElement("path", { d: "M105.647 28.2596C100.281 28.2596 95.936 32.61 95.936 37.9703C95.936 43.3362 100.281 47.681 105.647 47.681C106.107 47.681 106.573 47.681 107.034 47.681V44.0741H105.647C102.278 44.0741 99.5429 41.3385 99.5429 37.9703C99.5429 34.6021 102.278 31.8665 105.647 31.8665H108.982C108.982 31.8665 108.982 50.3778 108.982 50.7329C108.982 52.725 110.596 54.3397 112.588 54.3397V28.2596C112.588 28.2596 108.854 28.2596 105.647 28.2596Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M122.299 47.681C127.665 47.681 132.009 43.3306 132.009 37.9703C132.009 32.6045 127.665 28.2596 122.299 28.2596C121.838 28.2596 121.372 28.2596 120.911 28.2596V31.8665H122.299C125.667 31.8665 128.403 34.6021 128.403 37.9703C128.403 41.3385 125.667 44.0741 122.299 44.0741H118.964C118.964 44.0741 118.964 25.5629 118.964 25.2077C118.964 23.2156 117.349 21.6009 115.357 21.6009V47.681C115.357 47.681 119.091 47.681 122.299 47.681Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M162.651 69.0001H158.789V59.2173H158.722C157.724 60.7599 155.759 61.7254 153.606 61.7254C148.906 61.7254 146.01 57.991 146.01 53.4852C146.01 48.9129 149.1 45.3727 153.506 45.3727C156.336 45.3727 158.079 46.7543 158.85 47.9807H158.944V45.8221H162.645V69.0001H162.651ZM154.383 58.507C157.213 58.507 158.922 55.9656 158.922 53.5518C158.922 51.138 157.219 48.53 154.383 48.53C151.392 48.53 149.944 51.0714 149.944 53.4852C149.938 55.899 151.387 58.507 154.383 58.507Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M179.997 61.276H176.329V58.7955H176.263C175.586 60.3381 173.754 61.7254 171.468 61.7254C167.445 61.7254 165.77 58.6346 165.77 55.4828V45.8277H169.632V54.3897C169.632 56.2264 170.048 58.507 172.528 58.507C174.975 58.507 176.135 56.3817 176.135 54.3231V45.8277H179.997V61.276Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M183.871 45.4891H187.733V60.9374H183.871V45.4891Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M202.182 50.1059C201.572 49.2347 200.251 48.591 198.997 48.591C196.167 48.591 194.746 51.1325 194.746 53.5462C194.746 55.96 196.195 58.5015 199.125 58.5015C200.317 58.5015 201.632 58.0187 202.376 57.1198L204.79 59.5669C203.502 60.9485 201.377 61.7254 199.091 61.7254C194.519 61.7254 190.723 58.7012 190.723 53.5518C190.723 48.5299 194.458 45.3782 198.997 45.3782C201.25 45.3782 203.597 46.2772 204.823 47.792L202.182 50.1059Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M206.721 36.9438H210.583V52.3255H210.678L216.537 45.8221H221.492L214.8 52.8082L221.914 61.2704H216.798L210.683 53.3521H210.589V61.2704H206.727V36.9438H206.721Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M227.541 36.9438V47.792H227.635C228.439 46.7932 229.982 45.3782 232.818 45.3782C237.229 45.3782 240.314 48.9185 240.314 53.4908C240.314 57.9965 237.417 61.731 232.718 61.731C230.559 61.731 228.466 60.7321 227.407 58.9621H227.341V61.2815H223.673V36.9438H227.541ZM231.952 48.53C229.122 48.53 227.413 51.138 227.413 53.5518C227.413 55.9656 229.116 58.5071 231.952 58.5071C234.943 58.5071 236.39 55.899 236.39 53.4853C236.39 51.0715 234.943 48.53 231.952 48.53Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M250.392 45.3782C255.058 45.3782 258.794 48.6299 258.794 53.4908C258.794 58.3516 255.058 61.7309 250.392 61.7309C245.725 61.7309 241.991 58.3516 241.991 53.4908C241.991 48.6299 245.725 45.3782 250.392 45.3782ZM250.392 58.507C253.449 58.507 254.864 55.899 254.864 53.4852C254.864 51.0714 253.449 48.5299 250.392 48.5299C247.334 48.5299 245.919 51.0714 245.919 53.4852C245.919 55.899 247.334 58.507 250.392 58.507Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M268.869 45.3782C273.536 45.3782 277.27 48.6299 277.27 53.4908C277.27 58.3516 273.536 61.7309 268.869 61.7309C264.203 61.7309 260.468 58.3516 260.468 53.4908C260.468 48.6299 264.203 45.3782 268.869 45.3782ZM268.869 58.507C271.927 58.507 273.342 55.899 273.342 53.4852C273.342 51.0714 271.927 48.5299 268.869 48.5299C265.812 48.5299 264.397 51.0714 264.397 53.4852C264.391 55.899 265.812 58.507 268.869 58.507Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M279.617 36.9438H283.479V52.3255H283.574L289.434 45.8221H294.389L287.697 52.8082L294.811 61.2704H289.694L283.579 53.3521H283.485V61.2704H279.623V36.9438H279.617Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M305.348 49.945C304.67 49.0461 303.383 48.2692 301.968 48.2692C300.747 48.2692 299.487 48.7187 299.487 49.945C299.487 51.138 300.681 51.4599 302.833 51.9703C305.12 52.5197 307.822 53.5463 307.822 56.5704C307.822 60.3382 304.765 61.7198 301.386 61.7198C299.005 61.7198 296.525 60.8209 295.043 59.1785L297.584 56.798C298.423 57.8911 299.871 58.729 301.541 58.729C302.667 58.729 304.022 58.2795 304.022 56.8923C304.022 55.6049 302.828 55.2165 300.481 54.6727C298.195 54.1233 295.909 53.1911 295.909 50.2946C295.909 46.8487 298.999 45.3727 302.057 45.3727C304.276 45.3727 306.596 46.144 307.85 47.7198L305.348 49.945Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M188.326 24.7362C188.326 28.6536 191.461 31.5169 195.445 31.5169C199.429 31.5169 202.57 28.6592 202.57 24.7362V15.7413H198.708V24.2756C198.708 26.3898 197.293 27.8047 195.434 27.8047C193.569 27.8047 192.16 26.3898 192.16 24.2756V15.7413H188.303L188.326 24.7362Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M212.886 19.3536H217.492V31.2062H221.348V19.3536H225.948V15.7413H212.886V19.3536Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M210.389 15.7413H206.533V31.2062H210.389V15.7413Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M172.745 19.3536H177.35V31.2062H181.207V19.3536H185.807V15.7413H172.745V19.3536Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M152.507 15.7413H148.651V31.2062H152.507V23.4765V15.7413Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M170.714 22.2113C170.714 18.2937 167.573 15.4305 163.589 15.4305C159.605 15.4305 156.464 18.2882 156.464 22.2113V31.2062H160.32V22.6719C160.32 20.5577 161.735 19.1427 163.594 19.1427C165.453 19.1427 166.868 20.5577 166.868 22.6719V31.2062H170.725L170.714 22.2113Z", fill: "black" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9193_21251" }, /* @__PURE__ */ React.createElement("rect", { width: 218.867, height: 56, fill: "white", transform: "translate(89 13)" }))));
const SvgRippling$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 409, height: 82, viewBox: "0 0 409 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.637207H58.3252V81.9973H59.3252V0.637207Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M95.855 31.1672C95.855 26.1472 93.325 22.0072 88.605 18.5272H99.585C103.435 21.5072 105.805 26.0672 105.805 31.1672C105.805 36.2672 103.445 40.8273 99.585 43.8073C103.145 45.2973 105.185 48.9472 105.185 54.1672V64.1172H95.235V54.1672C95.235 49.1972 92.875 45.7073 88.605 43.8073C93.325 40.3273 95.855 36.1772 95.855 31.1672ZM117.405 31.1672C117.405 26.1472 114.875 22.0072 110.155 18.5272H121.135C124.985 21.5072 127.355 26.0672 127.355 31.1672C127.355 36.2672 124.995 40.8273 121.135 43.8073C124.695 45.2973 126.725 48.9472 126.725 54.1672V64.1172H116.775V54.1672C116.775 49.1972 114.415 45.7073 110.145 43.8073C114.865 40.3273 117.395 36.1772 117.395 31.1672M138.945 31.1672C138.945 26.1472 136.415 22.0072 131.695 18.5272H142.675C146.525 21.5072 148.895 26.0672 148.895 31.1672C148.895 36.2672 146.535 40.8273 142.675 43.8073C146.235 45.2973 148.275 48.9472 148.275 54.1672V64.1172H138.325V54.1672C138.325 49.1972 135.965 45.7073 131.695 43.8073C136.415 40.3273 138.945 36.1772 138.945 31.1672Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M179.195 55.8271H171.655V26.8171H190.185C199.095 26.8171 203.485 30.1372 203.485 35.5572C203.485 39.2472 201.325 42.0272 197.305 43.4272C201.445 44.0472 203.315 46.2471 203.315 50.1871V55.8271H195.685V50.5172C195.685 47.1972 194.025 45.8771 189.675 45.8771H179.185V55.8271H179.195ZM189.765 31.0372H179.195V41.6472H189.685C193.495 41.6472 195.865 39.5372 195.865 36.2172C195.865 32.8972 193.665 31.0372 189.775 31.0372", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M216.575 26.8073H209.035V55.8172H216.575V26.8073Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M239.705 46.3771H230.505V55.8271H222.965V26.8171H239.875C248.785 26.8171 253.465 30.5472 253.465 36.5172C253.465 42.4872 248.695 46.3771 239.705 46.3771ZM239.535 31.0372H230.495V42.1472H239.445C243.345 42.1472 245.745 40.1572 245.745 36.5472C245.745 32.9372 243.345 31.0372 239.525 31.0372", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M274.675 46.3771H265.475V55.8271H257.935V26.8171H274.845C283.755 26.8171 288.435 30.5472 288.435 36.5172C288.435 42.4872 283.665 46.3771 274.675 46.3771ZM274.505 31.0372H265.465V42.1472H274.415C278.315 42.1472 280.715 40.1572 280.715 36.5472C280.715 32.9372 278.315 31.0372 274.495 31.0372", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M300.455 26.8073V51.5172H319.275V55.8272H292.915V26.8073H300.455Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M331.535 26.8073H323.995V55.8172H331.535V26.8073Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M342.895 36.5072V55.8272H337.925V26.8073H343.555L364.115 46.1272V26.8073H369.085V55.8272H363.455L342.895 36.5072Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M393.705 30.2072C386.535 30.2072 381.855 34.7671 381.855 41.5671C381.855 48.3671 386.335 52.4272 393.295 52.4272H393.795C396.155 52.4272 398.815 51.9272 401.255 51.1472V43.3171H389.075V39.1772H408.635V52.8171C404.575 54.9271 398.435 56.5872 393.465 56.5872H392.805C381.365 56.5872 373.985 50.5372 373.985 41.7472C373.985 32.9572 381.575 26.0771 393.215 26.0771H393.875C398.725 26.0771 404.275 27.6072 408.385 30.0172L406.225 33.5372C402.535 31.5072 398.145 30.2172 394.205 30.2172H393.705V30.2072Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 18.9471C20.3554 16.0071 17.4954 14.3271 13.2954 14.3271C5.43539 14.3771 0.775391 20.6272 0.775391 29.2972C0.775391 37.9672 5.42539 44.2172 13.2954 44.2172C14.7354 44.2972 16.1854 44.0472 17.5254 43.4872C18.8654 42.9272 20.0654 42.0672 21.0354 40.9772V45.1472C21.0354 47.9872 19.5354 51.3572 14.7754 51.3572C11.1654 51.3572 9.38539 49.3372 8.76539 47.1672L2.38539 50.2571C3.98539 54.3571 7.80539 57.7972 15.2254 57.7972C26.2254 57.7972 29.0554 50.3771 29.0554 43.8771V14.7372H22.3254L22.1454 18.9371L22.1254 18.9471ZM15.0154 37.4172C11.0854 37.4172 8.76539 34.2172 8.76539 29.2372C8.76539 24.2572 11.0854 21.0572 15.0154 21.0572C18.9454 21.0572 21.2154 24.2572 21.2154 29.2372C21.2154 34.2172 18.9454 37.4172 15.0154 37.4172Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 60.0771V69.9672H1.02539V64.1271H23.3154V60.0771H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgSquare$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 283, height: 83, viewBox: "0 0 283 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M59.3252 0.818604H58.3252V82.1786H59.3252V0.818604Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M129.145 17.1586H96.735C92.245 17.1586 88.605 20.7986 88.605 25.2886V57.6985C88.605 62.1885 92.245 65.8386 96.735 65.8386H129.145C133.635 65.8386 137.285 62.1985 137.285 57.6985V25.2886C137.285 20.7986 133.645 17.1586 129.145 17.1586ZM128.425 54.4185C128.425 55.8385 127.275 56.9886 125.855 56.9886H100.015C98.595 56.9886 97.445 55.8385 97.445 54.4185V28.5786C97.445 27.1586 98.595 26.0086 100.015 26.0086H125.855C127.275 26.0086 128.425 27.1586 128.425 28.5786V54.4185ZM107.775 48.0986C106.955 48.0986 106.305 47.4386 106.305 46.6186V36.2986C106.305 35.4786 106.965 34.8186 107.775 34.8186H118.105C118.915 34.8186 119.575 35.4786 119.575 36.2986V46.6186C119.575 47.4386 118.915 48.0986 118.105 48.0986H107.775ZM150.185 47.3986H155.505C155.775 50.4086 157.805 52.7586 161.925 52.7586C165.605 52.7586 167.865 50.9385 167.865 48.1985C167.865 45.6285 166.095 44.4785 162.905 43.7285L158.785 42.8386C154.315 41.8686 150.945 38.9886 150.945 34.2886C150.945 29.1086 155.555 25.5586 161.535 25.5586C167.865 25.5586 171.945 28.8786 172.295 33.7986H167.155C166.535 31.4986 164.635 30.1186 161.525 30.1186C158.245 30.1186 155.985 31.8886 155.985 34.1486C155.985 36.4086 157.935 37.7786 161.305 38.5386L165.385 39.4286C169.855 40.3986 172.915 43.1086 172.915 47.8486C172.915 53.8686 168.395 57.4586 161.925 57.4586C154.665 57.4586 150.625 53.5186 150.185 47.4086V47.3986ZM191.925 65.8386V57.0186L192.275 53.1486H191.925C190.705 55.9286 188.145 57.4485 184.675 57.4485C179.075 57.4485 174.905 52.8885 174.905 45.8885C174.905 38.8885 179.075 34.3286 184.675 34.3286C188.105 34.3286 190.535 35.9386 191.925 38.4586H192.275V34.7686H196.875V65.8286H191.925V65.8386ZM192.095 45.8986C192.095 41.4286 189.355 38.8186 186.015 38.8186C182.675 38.8186 179.935 41.4286 179.935 45.8986C179.935 50.3686 182.675 52.9785 186.015 52.9785C189.355 52.9785 192.095 50.3686 192.095 45.8986ZM200.555 48.1985V34.7786H205.505V47.7686C205.505 51.2886 207.195 52.9785 210.025 52.9785C213.505 52.9785 215.755 50.4986 215.755 46.6385V34.7786H220.705V57.0186H216.105V52.4185H215.755C214.665 55.3685 212.275 57.4586 208.585 57.4586C203.285 57.4586 200.545 54.0686 200.545 48.2086L200.555 48.1985ZM223.735 50.8086C223.735 46.6386 226.645 44.2086 231.815 43.8986L237.945 43.5086V41.7686C237.945 39.6786 236.425 38.4185 233.735 38.4185C231.255 38.4185 229.785 39.6786 229.395 41.4586H224.445C224.965 36.9386 228.705 34.3386 233.745 34.3386C239.435 34.3386 242.915 36.7686 242.915 41.4586V57.0086H238.315V52.8786H237.965C236.925 55.6186 234.755 57.4386 230.575 57.4386C226.395 57.4386 223.755 54.7486 223.755 50.7886L223.735 50.8086ZM237.945 48.0686V46.8986L232.945 47.2486C230.255 47.4186 229.035 48.4185 229.035 50.4185C229.035 52.1085 230.425 53.3286 232.385 53.3286C235.905 53.3286 237.945 51.0686 237.945 48.0686ZM246.585 57.0186V34.7786H251.185V39.0386H251.535C252.185 36.1286 254.405 34.7786 257.705 34.7786H259.965V39.2486H257.145C253.935 39.2486 251.545 41.3386 251.545 45.2886V57.0186H246.595H246.585ZM282.635 46.8086H265.735C265.995 50.8886 268.865 53.1985 272.035 53.1985C274.725 53.1985 276.425 52.1086 277.375 50.2886H282.285C280.935 54.8086 276.985 57.4586 271.985 57.4586C265.425 57.4586 260.825 52.5486 260.825 45.8986C260.825 39.2486 265.565 34.3386 272.035 34.3386C278.505 34.3386 282.805 38.8086 282.805 44.3786C282.805 45.4686 282.715 46.0286 282.635 46.8086ZM277.895 43.3786C277.725 40.2986 275.155 38.2086 272.035 38.2086C269.085 38.2086 266.605 40.0786 265.995 43.3786H277.895Z", fill: "#1A1A1A" }), /* @__PURE__ */ React.createElement("path", { d: "M22.1254 17.5986C20.3554 14.6586 17.4954 12.9786 13.2954 12.9786C5.43539 13.0286 0.775391 19.2786 0.775391 27.9486C0.775391 36.6186 5.42539 42.8686 13.2954 42.8686C14.7354 42.9486 16.1854 42.6986 17.5254 42.1386C18.8654 41.5786 20.0654 40.7186 21.0354 39.6286V43.7986C21.0354 46.6386 19.5354 50.0086 14.7754 50.0086C11.1654 50.0086 9.38539 47.9886 8.76539 45.8186L2.38539 48.9086C3.98539 53.0086 7.80539 56.4486 15.2254 56.4486C26.2254 56.4486 29.0554 49.0286 29.0554 42.5286V13.3886H22.3254L22.1454 17.5886L22.1254 17.5986ZM15.0154 36.0686C11.0854 36.0686 8.76539 32.8686 8.76539 27.8886C8.76539 22.9086 11.0854 19.7086 15.0154 19.7086C18.9454 19.7086 21.2154 22.9086 21.2154 27.8886C21.2154 32.8686 18.9454 36.0686 15.0154 36.0686Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M29.0454 58.7286V68.6186H1.02539V62.7786H23.3154V58.7286H29.0354H29.0454Z", fill: "#5532FA" }));
const SvgZenefits$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 315, height: 82, viewBox: "0 0 315 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_9595_21355)" }, /* @__PURE__ */ React.createElement("path", { d: "M21.3 17.5C19.5 14.6 16.7 12.9 12.5 12.9C4.7 12.9 0 19.2 0 27.8C0 36.4 4.7 42.7 12.5 42.7C13.9 42.8 15.4 42.5 16.7 42C18 41.5 19.2 40.6 20.2 39.5V43.7C20.2 46.5 18.7 49.9 13.9 49.9C10.3 49.9 8.5 47.9 7.9 45.7L1.5 48.8C3.1 52.9 6.9 56.3 14.3 56.3C25.3 56.3 28.1 48.9 28.1 42.4V13.3H21.4L21.3 17.5ZM14.2 35.9C10.3 35.9 8 32.7 8 27.7C8 22.7 10.3 19.5 14.2 19.5C18.1 19.5 20.4 22.7 20.4 27.7C20.4 32.7 18.2 35.9 14.2 35.9Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M28.2998 58.6V68.5H0.299805V62.7H22.5998V58.7H28.2998V58.6Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M58.5 0H57.5V81.4H58.5V0Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M175.9 38.8C171.2 38.8 167.4 41.1001 165.6 45.4001C164.7 47.4001 164.4 49.8 164.4 52.6V52.9001C164.4 63.5001 169.8 67.1 176.8 67.1C180.7 67.1 184.3 65.5 186.9 62.7001C187 62.6 187 62.5001 186.9 62.4001L183.6 59.4001C183.5 59.3001 183.4 59.3001 183.3 59.4001C181.4 61.3001 179.6 62.1 176.9 62.1C172.3 62.1 170 59.3 170 54.5H187.4C187.5 54.5 187.6 54.4 187.6 54.3V50.2001C187.5 43.4001 183.3 38.8 175.9 38.8ZM182.2 49.9001H170V49.4001C170.1 48.1001 170.2 47.5 170.7 46.5C171.6 44.9 173.5 43.9001 176.1 43.9001C178.7 43.9001 180.6 45 181.4 46.5C181.9 47.4 182.1 48.1001 182.2 49.4001V49.9001Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M230.3 38.8C225.6 38.8 221.8 41.1001 220 45.4001C219.1 47.4001 218.8 49.8 218.8 52.6V52.9001C218.8 63.5001 224.2 67.1 231.2 67.1C235.1 67.1 238.7 65.5 241.3 62.7001C241.4 62.6 241.4 62.5001 241.3 62.4001L238 59.4001C237.9 59.3001 237.8 59.3001 237.7 59.4001C235.8 61.3001 234 62.1 231.3 62.1C226.7 62.1 224.4 59.3 224.4 54.5H241.8C241.9 54.5 242 54.4 242 54.3V50.2001C241.9 43.4001 237.6 38.8 230.3 38.8ZM236.6 49.9001H224.4V49.4001C224.5 48.1001 224.6 47.5 225.1 46.5C226 44.9 227.9 43.9001 230.5 43.9001C233.1 43.9001 235 45 235.8 46.5C236.3 47.4 236.5 48.1001 236.6 49.4001V49.9001Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M139.9 39.3V43.9C139.9 44 140 44.1 140.1 44.1H152.8L139.2 66.4C139.1 66.5 139.2 66.6 139.3 66.7H139.4H161.7C161.8 66.7 161.9 66.6 161.9 66.5V61.9C161.9 61.8 161.8 61.7 161.7 61.7H148.5L162 39.4C162.1 39.3 162 39.2 161.9 39.1H161.8H140.1C140 39.1 139.9 39.2 139.9 39.3Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M285.6 32H280.7C280.6 32 280.5 32.1 280.5 32.2V39.1H276.9C276.8 39.1 276.7 39.2 276.7 39.3V43.9C276.7 44 276.8 44.1 276.9 44.1H280.5V58.6C280.5 64.6 284.9 67 289.7 67C290.2 67 290.5 67 290.8 67C290.9 67 291 66.9 291 66.8V62C291 61.9 290.9 61.8 290.8 61.8C290.5 61.8 290.3 61.8 290 61.8C287.3 61.7 285.9 60.2 285.9 57.1V44.1H291.3C291.4 44.1 291.5 44 291.5 43.9V39.3C291.5 39.2 291.4 39.1 291.3 39.1H285.9V32.2C285.8 32 285.7 32 285.6 32Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M312.1 52.8C310.3 51.5 307.6 50.8 304.2 50.3C299.8 49.5 299.2 48.7 299.2 46.9C299.2 45.9 299.7 45 300.6 44.6C302 43.8 303.4 43.8 304.8 44C306.4 44.2 308.4 44.8 309.8 46.3C309.9 46.4 310 46.4 310.1 46.3L313.4 43.3C313.5 43.2 313.5 43.1 313.4 43C312.8 42.2 312 41.5 311.1 41C310.1 40.4 308.9 39.8 307.8 39.5C306.5 39.2 305.2 39 303.8 39C302 39 300.2 39.3 298.6 39.9C297.5 40.4 296.4 41.1 295.6 42.1C294.8 43 294.2 44.2 294 45.4C293.7 46.8 293.7 48.3 294.2 49.7C294.5 50.6 295 51.5 295.7 52.3C297.7 54.5 300.8 55.1 303.8 55.6C305.8 56 309.6 56.1 309.5 59C309.4 61.8 306.1 62.6 303.8 62.6C301.2 62.6 299 61.7 297.1 59.8C297 59.7 296.9 59.7 296.8 59.8L293.5 62.8C293.4 62.9 293.4 63 293.5 63.1C295.9 65.8 300 67.4 304.1 67.4C309.4 67.4 314.4 64.8 314.7 59.3C315.1 56.2 314.1 54.2 312.1 52.8Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M269.7 26.3C271.8 26.3 273.5 28.0001 273.5 30.1C273.5 32.2 271.8 33.9001 269.7 33.9001C267.6 33.9001 265.9 32.2 265.9 30.1C265.9 28.0001 267.6 26.3 269.7 26.3Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M254.2 39.0999V35.2999C254.4 32.4999 256.3 31.3999 258.5 31.2999C259.6 31.2999 260.8 31.4 261.9 31.5C262 31.5 262.1 31.4999 262.1 31.2999V26.7C262.1 26.6 262 26.5 261.9 26.5C260.8 26.3 259.6 26.2 258.5 26.2H258C252.6 26.2 248.8 29.1999 248.8 34.7999V39.0999H244.7C244.6 39.0999 244.5 39.1999 244.5 39.2999V43.9C244.5 44 244.6 44.0999 244.7 44.0999H248.8V66.5C248.8 66.5999 248.9 66.6999 249 66.6999H253.9C254 66.6999 254.1 66.5999 254.1 66.5V44.2H266.9V66.5999C266.9 66.6999 267 66.8 267.1 66.8H272C272.1 66.8 272.2 66.6999 272.2 66.5999V39.2999C272.2 39.1999 272.1 39.0999 272 39.0999H254.2Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M211.1 41.2C209.4 39.6 207.1 38.7 204 38.7C201.9 38.7 200.1 39 198.3 40.2C197.9 40.5 197.5 40.7 197.2 41C197.1 41.1 197 41.2 196.9 41.2V39.2C196.9 39.1 196.8 39 196.7 39H191.8C191.7 39 191.6 39.1 191.6 39.2V66.4C191.6 66.5 191.7 66.5999 191.8 66.5999H196.7C196.8 66.5999 196.9 66.5 196.9 66.4V48.5C196.9 47.1 198 45.7999 199.1 45.0999C200.5 44.1999 202.9 44.1 204.6 44.4C207.2 44.8 209 46.8999 209 49.5999V66.5999C209 66.6999 209.1 66.8 209.2 66.8H214.1C214.2 66.8 214.3 66.6999 214.3 66.5999V49.5999C214.5 46.4999 213.6 43.6 211.1 41.2Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M122.9 30.8V36.4L87.8999 54.7V49.1L101.8 41.8L87.8999 38.3V33.2L108.5 38.4L116.4 34.3L87.8999 27.1V22L122.9 30.8ZM87.8999 66.5L122.9 75.3V70.2L94.4999 63L102.4 58.9L123 64V59L109.1 55.5L123 48.2V42.6L87.9999 60.9L87.8999 66.5Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M169.6 8.29995H175.4V27.6H169.6V8.29995ZM172.5 0.199951C170.6 0.199951 169.1 1.69995 169.1 3.49995C169.1 5.29995 170.6 6.89995 172.5 6.89995C174.4 6.89995 175.9 5.39995 175.9 3.49995C175.9 1.59995 174.3 0.199951 172.5 0.199951ZM160.5 11.4V8.29995H154.9V27.6H160.7V20C160.7 16.2 162.5 13.9 165.6 13.9C166.2 13.9 166.8 14 167.1 14.1V8.19995C167 8.19995 166.5 8.09995 166.1 8.09995C163.7 8.09995 161.7 8.89995 160.5 11.4ZM145.7 1.99995H139.9V18.9C139.9 24.2 142.8 28 149.4 28C150.4 28 151.3 27.9 152 27.7999V22.7999C151.5 22.9 151 22.9 150.3 22.9C147.2 22.9 145.7 21.1999 145.7 18.2999V13.3H152V8.29995H145.7V1.99995ZM230.5 11.1V8.29995H223.6V1.99995H220.5V20.1C220.5 25.1 223.4 28 228.7 28C229.3 28 229.9 28 230.5 27.7999V25.1C230.1 25.2 229.5 25.2 229 25.2C225.2 25.2 223.5 23.2 223.5 19.6V11.1H230.5ZM188.6 7.89995C185.7 7.89995 183.3 9.19995 182.1 11.1V8.29995H179V27.6H182.1V17.4C182.1 13.2999 184.6 10.8 188.1 10.8C191.6 10.8 193.6 13.2 193.6 16.9V27.7999H196.7V16.1C196.7 11.4 193.6 7.89995 188.6 7.89995ZM218.1 17.6C218.1 17.9 218.1 18.7 218.1 19.1H202.2C202.6 22.9 205.3 25.4 209 25.4C211.9 25.4 213.8 24.0999 215 21.7999L217.5 23.2C215.9 26.4 212.9 28.2 209 28.2C202.7 28.2 199.1 23.9 199.1 18.1C199.1 12.3 203.2 7.99995 208.7 7.99995C214.2 7.99995 218.1 12.1 218.1 17.6ZM214.9 16.4C214.6 13.0999 212.4 10.6 208.7 10.6C205.2 10.6 202.7 13.0999 202.2 16.4H214.9Z", fill: "#232B45" }), /* @__PURE__ */ React.createElement("path", { d: "M227 2V4.8H233.8V11.1H236.7V2H227Z", fill: "#232B45" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_9595_21355" }, /* @__PURE__ */ React.createElement("rect", { width: 314.9, height: 81.4, fill: "white" }))));
const SvgAdp = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 380, height: 82, viewBox: "0 0 380 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.460083H247.93V81.8201H248.93V0.460083Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.8501C19.58 27.9101 16.72 26.2301 12.52 26.2301C4.66 26.2801 0 32.5301 0 41.2001C0 49.8701 4.65 56.1201 12.52 56.1201C13.96 56.2001 15.41 55.95 16.75 55.39C18.09 54.83 19.29 53.97 20.26 52.88V57.05C20.26 59.89 18.76 63.26 14 63.26C10.39 63.26 8.61 61.2401 7.99 59.0701L1.6 62.16C3.2 66.26 7.02 69.7001 14.44 69.7001C25.44 69.7001 28.27 62.28 28.27 55.78V26.64H21.54L21.36 30.8401L21.35 30.8501ZM14.24 49.3201C10.31 49.3201 7.99 46.12 7.99 41.14C7.99 36.16 10.31 32.9601 14.24 32.9601C18.17 32.9601 20.44 36.16 20.44 41.14C20.44 46.12 18.17 49.3201 14.24 49.3201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.1901C176.63 26.1901 175.11 26.5301 173.73 27.2101C172.34 27.8901 171.12 28.8701 170.16 30.1001L169.64 26.66H162.53V55.6801H170.83V39.3C170.83 34.77 172.51 33 175.84 33C178.16 33 180.08 34.0301 180.08 38.4501V55.6901H188.38V36.76C188.38 30.63 184.58 26.2101 178.16 26.2101L178.17 26.1901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.02C49.6201 47 47.9401 49.3301 44.6201 49.3301C42.3001 49.3301 40.3601 48.3 40.3601 43.88V26.65H32.0601V45.54C32.0601 51.66 35.8601 56.1101 42.2801 56.1101C43.8201 56.1101 45.3401 55.7601 46.7301 55.0801C48.1201 54.4001 49.3401 53.4101 50.3001 52.1901L50.8201 55.64H57.9101V26.65H49.6101V43.02H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.65H62.28V55.67H70.58V26.65Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.78C91.6001 27.05 89.0201 26.1701 86.4001 26.3301C78.5001 26.3301 73.8301 32.59 73.8301 41.25C73.8301 49.91 78.5001 56.17 86.4001 56.17C88.0801 56.28 89.7601 55.9401 91.2701 55.1801C92.7801 54.4201 94.0701 53.2701 95.0101 51.8401L95.2101 55.66H101.94V13.1801H93.6401L93.6001 28.78H93.6101ZM88.2101 49.3201C84.2801 49.3201 81.9601 46.12 81.9601 41.14C81.9601 36.16 84.2801 32.9601 88.2101 32.9601C92.1401 32.9601 94.4601 36.16 94.4601 41.14C94.4601 46.12 92.1401 49.3201 88.2101 49.3201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.4901C65.5099 12.4901 64.6199 12.77 63.8599 13.28C63.0999 13.8 62.5099 14.53 62.1599 15.4C61.8099 16.26 61.7199 17.2101 61.8999 18.1201C62.0799 19.0301 62.5199 19.87 63.1699 20.53C63.8199 21.19 64.6399 21.6401 65.5399 21.8201C66.4399 22.0001 67.3699 21.91 68.2099 21.55C69.0599 21.19 69.7799 20.5901 70.2899 19.8101C70.7999 19.0301 71.0699 18.1201 71.0699 17.1901C71.0699 15.9401 70.5799 14.7401 69.7099 13.8601C68.8399 12.9801 67.6599 12.4801 66.4399 12.4801L66.4299 12.4901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.65H149.84V55.67H158.14V26.65Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.4901C153.08 12.4901 152.19 12.77 151.43 13.28C150.67 13.8 150.08 14.53 149.72 15.4C149.37 16.26 149.28 17.2101 149.46 18.1201C149.64 19.0301 150.08 19.87 150.73 20.53C151.38 21.19 152.2 21.6401 153.1 21.8201C154 22.0001 154.93 21.91 155.77 21.55C156.62 21.19 157.34 20.5901 157.85 19.8101C158.36 19.0301 158.63 18.1201 158.63 17.1901C158.63 15.9401 158.14 14.7401 157.27 13.8601C156.4 12.9801 155.22 12.4801 154 12.4801V12.4901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.0901V41.2101C218.63 32.2501 213.58 26.29 205.25 26.29C196.92 26.29 191.31 32.2501 191.31 41.2101C191.31 50.1701 196.93 56.13 205.25 56.13C211.01 56.13 215.3 53.34 217.33 48.63L211.32 45.7301C210.93 46.9901 210.14 48.0701 209.08 48.8301C208.02 49.5901 206.75 49.97 205.45 49.92C203.92 49.96 202.42 49.4101 201.28 48.3701C200.14 47.3301 199.42 45.8801 199.29 44.3301H199.35L218.63 42.1001V42.0901ZM199.09 39.16C199.09 34.95 201.55 32.1901 205.22 32.1901C206.73 32.1601 208.19 32.73 209.31 33.76C210.43 34.8 211.11 36.23 211.23 37.76L199.09 39.16Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.29C110.47 26.29 104.85 32.2501 104.85 41.2101C104.85 50.1701 110.47 56.13 118.8 56.13C124.55 56.13 128.84 53.34 130.82 48.63L124.81 45.7301C124.42 46.9701 123.65 48.04 122.61 48.8C121.57 49.55 120.32 49.95 119.05 49.92C117.5 49.99 115.99 49.44 114.83 48.4C113.67 47.36 112.94 45.9001 112.81 44.3301L132.05 42.0801V41.2001C132.17 32.2601 127.12 26.3 118.8 26.3V26.29ZM112.61 39.17C112.61 34.96 115.02 32.2001 118.75 32.2001C120.26 32.1701 121.72 32.74 122.84 33.77C123.96 34.81 124.64 36.24 124.76 37.77L112.6 39.17H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.9301V13.1901H134.99V47.79C134.99 51.81 135.78 56 142.81 56C144.14 56.07 145.47 55.8501 146.71 55.3401V48.8601C146.71 48.8601 143.29 49.7401 143.29 46.9301Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.3H33.04V76.03H0.25V81.8701H38.77V69.13H218.65V63.3Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M341.94 40.9301C341.92 48.2001 336.03 54.0901 328.76 54.1101H323.69V48.3201H328.76C332.84 48.3201 336.15 45.0101 336.15 40.9301C336.15 36.8501 332.84 33.54 328.76 33.54H323.69V27.75H328.76C336.03 27.77 341.92 33.6601 341.94 40.9301ZM313.84 27.75V38.4701H304.71L301.38 44.26H319.63V27.75H313.84ZM379.6 36.01C379.6 46.01 371.49 54.1101 361.49 54.1101V63.9601H345.85V56.28C341.49 61.22 335.2 64.0301 328.61 63.9601H313.84V54.1101H302.25L296.46 63.9601H278.21L305.01 17.9H328.76C335.32 17.96 341.57 20.7401 346 25.5801V17.9H361.64C371.59 17.96 379.62 26.06 379.6 36V36.01ZM328.76 58.16C335.44 58.18 341.53 54.3401 344.4 48.3101H351.79V58.16H355.85V48.3101H361.64C368.43 48.3101 373.94 42.82 373.95 36.03C373.95 36.03 373.95 36.01 373.95 36C373.89 29.17 368.32 23.6701 361.49 23.6901H351.64V38.4601H345.85C344.57 30.0001 337.32 23.7301 328.76 23.6901H308.48L288.35 58.16H293.13L298.92 48.3101H319.63V58.16H328.76ZM361.49 27.7401H355.7V33.53H361.49C362.84 33.53 363.94 34.6101 363.95 35.9601C363.95 35.9601 363.95 35.9801 363.95 35.9901C363.91 37.3301 362.83 38.4101 361.49 38.4501H355.7V44.2401H361.49C366.05 44.2401 369.75 40.5401 369.75 35.9801C369.7 31.4401 366.03 27.7701 361.49 27.7201", fill: "#D0271D" }), /* @__PURE__ */ React.createElement("path", { d: "M368.37 60.4501C368.37 61.6901 367.36 62.7001 366.12 62.7001C364.88 62.7001 363.87 61.6901 363.87 60.4501C363.87 59.2101 364.88 58.2001 366.12 58.2001C367.35 58.1801 368.35 59.17 368.37 60.39C368.37 60.41 368.37 60.4301 368.37 60.4501ZM368.93 60.4501C368.93 58.9001 367.67 57.64 366.12 57.64C364.57 57.64 363.31 58.9001 363.31 60.4501C363.31 62.0001 364.57 63.26 366.12 63.26C367.67 63.26 368.93 62.0001 368.93 60.4501Z", fill: "#D0271D" }), /* @__PURE__ */ React.createElement("path", { d: "M366.26 59.1901C366.57 59.1901 366.82 59.44 366.82 59.75C366.82 60.06 366.57 60.3101 366.26 60.3101H365.7V59.1901H366.26ZM366.96 59.05C366.77 58.87 366.52 58.77 366.26 58.77H365.14V62.14H365.56V60.88H366.12L366.82 62.14H367.38L366.54 60.7401C366.68 60.7401 366.82 60.6001 366.96 60.4601C367.07 60.3001 367.12 60.1 367.1 59.9C367.22 59.62 367.17 59.2901 366.96 59.0601", fill: "#D0271D" }));
const SvgBambooHr = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 579, height: 83, viewBox: "0 0 579 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.870117H247.93V82.2301H248.93V0.870117Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M576.54 30.5001C576.34 30.6701 576.1 30.7602 575.8 30.7902L576.92 32.5402H576.26L575.19 30.8401H574.54V32.5402H573.93V28.5801H575.45C575.92 28.5801 576.26 28.6701 576.49 28.8601C576.71 29.0501 576.83 29.3301 576.83 29.7101C576.83 30.0701 576.73 30.3301 576.53 30.4901L576.54 30.5001ZM575.19 30.3401C575.33 30.3401 575.46 30.3401 575.58 30.3301C575.7 30.3301 575.81 30.3001 575.91 30.2501C576.01 30.2101 576.08 30.1401 576.14 30.0601C576.2 29.9701 576.23 29.8501 576.23 29.6901C576.23 29.5601 576.21 29.4501 576.15 29.3701C576.1 29.2901 576.03 29.2301 575.95 29.1901C575.87 29.1501 575.78 29.1201 575.67 29.1001C575.56 29.0801 575.46 29.0801 575.36 29.0801H574.55V30.3401H575.19ZM578.35 29.2201C578.53 29.6301 578.62 30.0702 578.62 30.5502C578.62 31.0302 578.53 31.4901 578.35 31.9001C578.17 32.3101 577.93 32.6701 577.62 32.9801C577.31 33.2801 576.96 33.5201 576.55 33.6901C576.14 33.8601 575.71 33.9401 575.25 33.9401C574.79 33.9401 574.35 33.8601 573.94 33.6901C573.53 33.5201 573.17 33.2801 572.86 32.9801C572.55 32.6801 572.31 32.3201 572.13 31.9001C571.95 31.4901 571.86 31.0302 571.86 30.5502C571.86 30.0702 571.95 29.6301 572.13 29.2201C572.31 28.8101 572.55 28.4501 572.86 28.1501C573.17 27.8501 573.53 27.6101 573.94 27.4401C574.35 27.2701 574.79 27.1802 575.25 27.1802C575.71 27.1802 576.15 27.2701 576.55 27.4401C576.96 27.6101 577.31 27.8501 577.62 28.1501C577.93 28.4501 578.17 28.8101 578.35 29.2201ZM577.8 31.7001C577.94 31.3501 578.01 30.9602 578.01 30.5502C578.01 30.1402 577.94 29.7702 577.8 29.4202C577.66 29.0702 577.46 28.7701 577.22 28.5101C576.97 28.2501 576.68 28.0501 576.34 27.9001C576 27.7501 575.64 27.6802 575.25 27.6802C574.86 27.6802 574.49 27.7501 574.15 27.9001C573.81 28.0501 573.52 28.2501 573.27 28.5101C573.02 28.7701 572.83 29.0702 572.69 29.4202C572.55 29.7702 572.48 30.1502 572.48 30.5502C572.48 30.9502 572.55 31.3501 572.69 31.7001C572.83 32.0501 573.03 32.3601 573.27 32.6201C573.52 32.8801 573.81 33.0801 574.15 33.2301C574.49 33.3801 574.86 33.4501 575.25 33.4501C575.64 33.4501 576 33.3801 576.34 33.2301C576.68 33.0801 576.97 32.8801 577.22 32.6201C577.47 32.3601 577.66 32.0501 577.8 31.7001ZM294.6 15.4001C298.17 19.1901 298.54 21.3101 299.81 24.9901L301.93 31.9901C301.93 31.9901 299.84 31.5901 298.13 31.3301C296.14 31.0301 295.26 30.7301 292.74 29.6901C290.21 28.6501 287.93 26.1102 285.68 23.2802C283.44 20.4502 278.21 16.0001 278.21 16.0001C278.21 16.0001 279.83 16.1101 281.47 16.5201C282.81 16.8601 286.31 18.0001 289.92 19.8901C290.72 20.3101 291.16 20.5801 291.95 21.0701C293.15 21.8201 294.41 22.9302 295.62 24.1702C297.04 25.6202 298.28 26.7901 299.35 28.0901C298.19 25.9501 295.2 18.2301 289.34 11.8501C288.77 11.2301 293.39 14.0901 294.61 15.3901L294.6 15.4001ZM436.56 25.7902C444.87 25.7902 452.05 33.0202 452.05 41.4302C452.05 50.4902 445.17 57.5402 436.08 57.5402C427.83 57.5402 420.64 51.6802 420.64 42.2802V14.5901H425.42V30.3901L425.99 29.7902C428.07 27.7102 431.04 25.8002 436.57 25.8002L436.56 25.7902ZM436.08 53.1501C442.86 53.1501 447.16 48.2901 447.16 41.8801C447.16 35.9901 443.09 30.3601 436.18 30.3601C429.27 30.3601 424.99 35.6101 424.99 42.0001C424.99 48.3901 430.07 53.1501 436.07 53.1501H436.08ZM320.1 25.7902C328.41 25.7902 335.59 33.0202 335.59 41.4302C335.59 50.4902 328.71 57.5402 319.62 57.5402C311.37 57.5402 304.18 51.6802 304.18 42.2802V11.7201H308.96V30.3901L309.53 29.7902C311.61 27.7102 314.57 25.8002 320.1 25.8002V25.7902ZM319.62 53.1501C326.4 53.1501 330.7 48.2901 330.7 41.8801C330.7 35.9901 326.63 30.3601 319.72 30.3601C312.81 30.3601 308.53 35.6101 308.53 42.0001C308.53 48.3901 313.61 53.1501 319.61 53.1501H319.62ZM568.54 35.6501C568.54 39.7601 565.51 42.9402 561.9 43.6602L570.94 56.0801H566.52L557.86 44.0001H554.03V56.0801H550.54V27.1802H558.83C565.98 27.1802 568.55 31.6702 568.55 35.6602L568.54 35.6501ZM554.03 40.7802H559.24C563.03 40.7802 564.92 38.4501 564.92 35.6501C564.92 32.2601 562.9 30.4001 559.2 30.4001H554.03V40.7802ZM541.71 39.5101V27.1802H545.2V56.0801H541.71V42.7301H526.45V56.0801H522.96V27.1802H526.45V39.5101H541.71ZM503.79 26.1101C512.75 26.1101 519.18 32.7702 519.18 41.5502C519.18 50.3302 512.69 57.1101 503.79 57.1101C494.89 57.1101 488.41 50.3302 488.41 41.5502C488.41 32.7702 495.14 26.1101 503.79 26.1101ZM503.79 52.7501C509.86 52.7501 514.25 47.9102 514.25 41.5502C514.25 35.1902 510.1 30.4102 503.79 30.4102C497.48 30.4102 493.34 35.1302 493.34 41.5502C493.34 47.9702 498.27 52.7501 503.79 52.7501ZM469.98 26.1101C478.93 26.1101 485.36 32.7702 485.36 41.5502C485.36 50.3302 478.87 57.1101 469.98 57.1101C461.09 57.1101 454.59 50.3302 454.59 41.5502C454.59 32.7702 461.32 26.1101 469.98 26.1101ZM469.98 52.7501C476.05 52.7501 480.44 47.9102 480.44 41.5502C480.44 35.1902 476.29 30.4102 469.98 30.4102C463.67 30.4102 459.52 35.1302 459.52 41.5502C459.52 47.9702 464.45 52.7501 469.98 52.7501ZM406.28 26.1101C412.77 26.1101 417.28 30.6501 417.28 39.1901V56.0801H412.53V38.8201C412.53 34.3401 410.49 30.4102 405.62 30.4102C401.59 30.4102 397.81 33.3201 397.81 39.9801V56.0901H393V38.8301C393 34.0501 390.42 30.4202 386.15 30.4202C381.34 30.4202 378.28 33.9301 378.28 39.9901V56.1001H373.53V27.1001H378.28V30.7301H378.4C380.32 28.1301 383.27 26.1301 386.99 26.1301C391.5 26.1301 395.16 28.7301 396.37 32.1201C397.81 29.2101 401.3 26.1301 406.29 26.1301L406.28 26.1101ZM364.44 31.2501V27.0701H369.19V56.0701H364.44V52.2001H364.32C362.22 54.7401 358.67 57.1001 353.8 57.1001C345.99 57.1001 339.02 50.9802 339.02 41.5402C339.02 32.1002 345.51 26.1001 354.1 26.1001C359.33 26.1001 362.39 28.8801 364.37 31.2401H364.43L364.44 31.2501ZM354.46 52.8701C359.87 52.8701 364.86 48.2701 364.86 41.7301C364.86 34.8301 360.23 30.2902 354.58 30.2902C347.37 30.2902 343.94 35.9802 343.94 41.5502C343.94 47.1202 347.37 52.8701 354.46 52.8701Z", fill: "#73C41D" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.2701C19.58 28.3301 16.72 26.6501 12.52 26.6501C4.66 26.7001 0 32.9501 0 41.6201C0 50.2901 4.65 56.5402 12.52 56.5402C13.96 56.6202 15.41 56.3701 16.75 55.8101C18.09 55.2501 19.29 54.3902 20.26 53.3002V57.4701C20.26 60.3101 18.76 63.6802 14 63.6802C10.39 63.6802 8.61 61.6601 7.99 59.4901L1.6 62.5801C3.2 66.6801 7.02 70.1201 14.44 70.1201C25.44 70.1201 28.27 62.7001 28.27 56.2001V27.0601H21.54L21.36 31.2601L21.35 31.2701ZM14.24 49.7401C10.31 49.7401 7.99 46.5401 7.99 41.5601C7.99 36.5801 10.31 33.3801 14.24 33.3801C18.17 33.3801 20.44 36.5801 20.44 41.5601C20.44 46.5401 18.17 49.7401 14.24 49.7401Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.6101C176.63 26.6101 175.11 26.9501 173.73 27.6301C172.34 28.3101 171.12 29.2901 170.16 30.5201L169.64 27.0801H162.53V56.0901H170.83V39.7101C170.83 35.1801 172.51 33.4102 175.84 33.4102C178.16 33.4102 180.08 34.4401 180.08 38.8601V56.1001H188.38V37.1702C188.38 31.0402 184.58 26.6201 178.16 26.6201L178.17 26.6101Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.4401C49.6201 47.4201 47.9401 49.7401 44.6201 49.7401C42.3001 49.7401 40.3601 48.7102 40.3601 44.2902V27.0701H32.0601V45.9601C32.0601 52.0801 35.8601 56.5302 42.2801 56.5302C43.8201 56.5302 45.3401 56.1801 46.7301 55.5001C48.1201 54.8201 49.3401 53.8301 50.3001 52.6101L50.8201 56.0601H57.9101V27.0701H49.6101V43.4401H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 27.0701H62.28V56.0801H70.58V27.0701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.2001C91.6001 27.4701 89.0201 26.6001 86.4001 26.7501C78.5001 26.7501 73.8301 33.0102 73.8301 41.6702C73.8301 50.3302 78.5001 56.5901 86.4001 56.5901C88.0801 56.7001 89.7601 56.3601 91.2701 55.6001C92.7801 54.8401 94.0701 53.6901 95.0101 52.2601L95.2101 56.0801H101.94V13.6001H93.6401L93.6001 29.2001H93.6101ZM88.2101 49.7401C84.2801 49.7401 81.9601 46.5401 81.9601 41.5601C81.9601 36.5801 84.2801 33.3801 88.2101 33.3801C92.1401 33.3801 94.4601 36.5801 94.4601 41.5601C94.4601 46.5401 92.1401 49.7401 88.2101 49.7401Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.9102C65.5099 12.9102 64.6199 13.1901 63.8599 13.7001C63.0999 14.2201 62.5099 14.9501 62.1599 15.8201C61.8099 16.6801 61.7199 17.6302 61.8999 18.5402C62.0799 19.4502 62.5199 20.2901 63.1699 20.9501C63.8199 21.6101 64.6399 22.0601 65.5399 22.2401C66.4399 22.4201 67.3699 22.3301 68.2099 21.9701C69.0599 21.6101 69.7799 21.0101 70.2899 20.2301C70.7999 19.4501 71.0699 18.5401 71.0699 17.6101C71.0699 16.3601 70.5799 15.1602 69.7099 14.2802C68.8399 13.4002 67.6599 12.9001 66.4399 12.9001L66.4299 12.9102Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 27.0701H149.84V56.0801H158.14V27.0701Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.9102C153.08 12.9102 152.19 13.1901 151.43 13.7001C150.67 14.2201 150.08 14.9501 149.72 15.8201C149.37 16.6801 149.28 17.6302 149.46 18.5402C149.64 19.4502 150.08 20.2901 150.73 20.9501C151.38 21.6101 152.2 22.0601 153.1 22.2401C154 22.4201 154.93 22.3301 155.77 21.9701C156.62 21.6101 157.34 21.0101 157.85 20.2301C158.36 19.4501 158.63 18.5401 158.63 17.6101C158.63 16.3601 158.14 15.1602 157.27 14.2802C156.4 13.4002 155.22 12.9001 154 12.9001V12.9102Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.5101V41.6301C218.63 32.6701 213.58 26.7101 205.25 26.7101C196.92 26.7101 191.31 32.6701 191.31 41.6301C191.31 50.5901 196.93 56.5502 205.25 56.5502C211.01 56.5502 215.3 53.7602 217.33 49.0502L211.32 46.1501C210.93 47.4101 210.14 48.4901 209.08 49.2501C208.02 50.0101 206.75 50.3901 205.45 50.3401C203.92 50.3801 202.42 49.8302 201.28 48.7902C200.14 47.7502 199.42 46.3001 199.29 44.7501H199.35L218.63 42.5201V42.5101ZM199.09 39.5801C199.09 35.3701 201.55 32.6101 205.22 32.6101C206.73 32.5801 208.19 33.1502 209.31 34.1802C210.43 35.2202 211.11 36.6502 211.23 38.1802L199.09 39.5801Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.7101C110.47 26.7101 104.85 32.6701 104.85 41.6301C104.85 50.5901 110.47 56.5502 118.8 56.5502C124.55 56.5502 128.84 53.7602 130.82 49.0502L124.81 46.1501C124.42 47.3901 123.65 48.4601 122.61 49.2201C121.57 49.9701 120.32 50.3701 119.05 50.3401C117.5 50.4101 115.99 49.8601 114.83 48.8201C113.67 47.7801 112.94 46.3201 112.81 44.7501L132.05 42.5001V41.6201C132.17 32.6801 127.12 26.7201 118.8 26.7201V26.7101ZM112.61 39.5901C112.61 35.3801 115.02 32.6201 118.75 32.6201C120.26 32.5901 121.72 33.1601 122.84 34.1901C123.96 35.2301 124.64 36.6601 124.76 38.1901L112.6 39.5901H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.3501V13.6101H134.99V48.2101C134.99 52.2301 135.78 56.4202 142.81 56.4202C144.14 56.4902 145.47 56.2701 146.71 55.7601V49.2802C146.71 49.2802 143.29 50.1601 143.29 47.3501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.7101H33.04V76.4401H0.25V82.2802H38.77V69.5402H218.65V63.7101Z", fill: "#5532FA" }));
const SvgGusto = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 411, height: 82, viewBox: "0 0 411 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.4C19.58 27.46 16.72 25.78 12.52 25.78C4.66 25.83 0 32.08 0 40.75C0 49.42 4.65 55.67 12.52 55.67C13.96 55.75 15.41 55.5 16.75 54.94C18.09 54.38 19.29 53.52 20.26 52.43V56.6C20.26 59.44 18.76 62.81 14 62.81C10.39 62.81 8.61 60.79 7.99 58.62L1.6 61.71C3.2 65.81 7.02 69.25 14.44 69.25C25.44 69.25 28.27 61.83 28.27 55.33V26.2H21.54L21.36 30.4H21.35ZM14.24 48.87C10.31 48.87 7.99 45.67 7.99 40.69C7.99 35.71 10.31 32.51 14.24 32.51C18.17 32.51 20.44 35.71 20.44 40.69C20.44 45.67 18.17 48.87 14.24 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.73C176.63 25.73 175.11 26.07 173.73 26.75C172.34 27.43 171.12 28.41 170.16 29.64L169.64 26.2H162.53V55.21H170.83V38.83C170.83 34.3 172.51 32.53 175.84 32.53C178.16 32.53 180.08 33.56 180.08 37.98V55.22H188.38V36.29C188.38 30.16 184.58 25.74 178.16 25.74L178.17 25.73Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.57C49.6201 46.55 47.9401 48.87 44.6201 48.87C42.3001 48.87 40.3601 47.84 40.3601 43.42V26.2H32.0601V45.09C32.0601 51.21 35.8601 55.66 42.2801 55.66C43.8201 55.66 45.3401 55.31 46.7301 54.63C48.1201 53.95 49.3401 52.96 50.3001 51.74L50.8201 55.19H57.9101V26.2H49.6101V42.57H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.2H62.28V55.21H70.58V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.33C91.6001 26.6 89.0201 25.73 86.4001 25.88C78.5001 25.88 73.8301 32.14 73.8301 40.8C73.8301 49.46 78.5001 55.72 86.4001 55.72C88.0801 55.83 89.7601 55.49 91.2701 54.73C92.7801 53.97 94.0701 52.82 95.0101 51.39L95.2101 55.21H101.94V12.73H93.6401L93.6001 28.33H93.6101ZM88.2101 48.87C84.2801 48.87 81.9601 45.67 81.9601 40.69C81.9601 35.71 84.2801 32.51 88.2101 32.51C92.1401 32.51 94.4601 35.71 94.4601 40.69C94.4601 45.67 92.1401 48.87 88.2101 48.87Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.03C65.5099 12.03 64.6199 12.31 63.8599 12.82C63.0999 13.34 62.5099 14.07 62.1599 14.94C61.8099 15.8 61.7199 16.75 61.8999 17.66C62.0799 18.57 62.5199 19.41 63.1699 20.07C63.8199 20.73 64.6399 21.18 65.5399 21.36C66.4399 21.54 67.3699 21.45 68.2099 21.09C69.0599 20.73 69.7799 20.13 70.2899 19.35C70.7999 18.57 71.0699 17.66 71.0699 16.73C71.0699 15.48 70.5799 14.28 69.7099 13.4C68.8399 12.52 67.6599 12.02 66.4399 12.02L66.4299 12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.2H149.84V55.21H158.14V26.2Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.03C153.08 12.03 152.19 12.31 151.43 12.82C150.67 13.34 150.08 14.07 149.72 14.94C149.37 15.8 149.28 16.75 149.46 17.66C149.64 18.57 150.08 19.41 150.73 20.07C151.38 20.73 152.2 21.18 153.1 21.36C154 21.54 154.93 21.45 155.77 21.09C156.62 20.73 157.34 20.13 157.85 19.35C158.36 18.57 158.63 17.66 158.63 16.73C158.63 15.48 158.14 14.28 157.27 13.4C156.4 12.52 155.22 12.02 154 12.02V12.03Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.64V40.76C218.63 31.8 213.58 25.84 205.25 25.84C196.92 25.84 191.31 31.8 191.31 40.76C191.31 49.72 196.93 55.68 205.25 55.68C211.01 55.68 215.3 52.89 217.33 48.18L211.32 45.28C210.93 46.54 210.14 47.62 209.08 48.38C208.02 49.14 206.75 49.52 205.45 49.47C203.92 49.51 202.42 48.96 201.28 47.92C200.14 46.88 199.42 45.43 199.29 43.88H199.35L218.63 41.65V41.64ZM199.09 38.71C199.09 34.5 201.55 31.74 205.22 31.74C206.73 31.71 208.19 32.28 209.31 33.31C210.43 34.35 211.11 35.78 211.23 37.31L199.09 38.71Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.83C110.47 25.83 104.85 31.79 104.85 40.75C104.85 49.71 110.47 55.67 118.8 55.67C124.55 55.67 128.84 52.88 130.82 48.17L124.81 45.27C124.42 46.51 123.65 47.58 122.61 48.34C121.57 49.09 120.32 49.49 119.05 49.46C117.5 49.53 115.99 48.98 114.83 47.94C113.67 46.9 112.94 45.44 112.81 43.87L132.05 41.62V40.74C132.17 31.8 127.12 25.84 118.8 25.84V25.83ZM112.61 38.71C112.61 34.5 115.02 31.74 118.75 31.74C120.26 31.71 121.72 32.28 122.84 33.31C123.96 34.35 124.64 35.78 124.76 37.31L112.6 38.71H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.47V12.73H134.99V47.33C134.99 51.35 135.78 55.54 142.81 55.54C144.14 55.61 145.47 55.39 146.71 54.88V48.4C146.71 48.4 143.29 49.28 143.29 46.47Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.84H33.04V75.57H0.25V81.41H38.77V68.67H218.65V62.84Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M395.53 25.61C387.35 25.61 380.72 32.24 380.72 40.42C380.72 48.6 387.35 55.23 395.53 55.23C403.71 55.23 410.34 48.6 410.34 40.42C410.33 32.24 403.71 25.62 395.53 25.61ZM395.53 48.2C391.23 48.2 387.75 44.71 387.75 40.42C387.75 36.13 391.24 32.64 395.53 32.64C399.83 32.64 403.31 36.12 403.31 40.42C403.31 44.72 399.82 48.2 395.53 48.21V48.2Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M351.93 37.42L349.34 36.13C348.22 35.58 347.52 35.14 347.23 34.82C346.96 34.54 346.81 34.16 346.8 33.77C346.8 33.27 347.02 32.85 347.47 32.52C347.92 32.19 348.54 32.02 349.33 32.02C350.78 32.02 352.39 32.9 354.17 34.66L358.54 30.29C356.38 27.35 352.94 25.62 349.28 25.64C346.61 25.64 344.41 26.43 342.7 28.01C340.99 29.59 340.13 31.49 340.13 33.71C340.13 37.16 342.41 40.03 346.96 42.32L349.34 43.51C351.39 44.54 352.41 45.6 352.41 46.69C352.41 47.28 352.13 47.79 351.56 48.24C350.99 48.69 350.24 48.91 349.31 48.91C348.45 48.91 347.46 48.61 346.35 48.01C345.24 47.42 344.25 46.64 343.41 45.71L339.11 50.4C341.56 53.61 344.83 55.21 348.94 55.21C352.03 55.21 354.49 54.37 356.32 52.7C358.16 51.03 359.07 48.94 359.07 46.44C359.07 44.56 358.56 42.93 357.54 41.53C356.52 40.13 354.65 38.76 351.93 37.42Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M307.98 26.2H300.96L300.98 28.73C298.71 26.43 295.9 25.62 293.02 25.62C284.84 25.62 278.21 32.25 278.21 40.43C278.21 48.61 284.84 55.24 293.02 55.24C296.43 55.24 299.35 53.73 300.85 51.81C300.85 51.93 300.84 53.32 300.84 53.47C300.81 54.42 300.67 55.95 299.77 57.52C297.59 61.21 292.83 62.43 289.14 60.25C289.08 60.22 289.02 60.18 288.97 60.14L285.48 66.22C287.77 67.61 290.41 68.35 293.09 68.35C296.98 68.35 301.82 66.81 305.26 62.05C308.12 58.09 307.98 54.35 307.98 50.73V26.2ZM293.02 48.21C288.72 48.21 285.24 44.72 285.24 40.43C285.24 36.13 288.73 32.65 293.02 32.65C297.31 32.65 300.8 36.13 300.8 40.43C300.8 44.73 297.31 48.21 293.02 48.22V48.21Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M335.97 26.2H328.91V40.28C328.92 42.27 328.92 45.73 327.45 47.21C326.74 47.92 325.98 48.55 324.35 48.55C322.72 48.55 321.95 47.91 321.24 47.21C319.77 45.73 319.77 42.27 319.79 40.28V26.2H312.74V40.23C312.72 43.12 312.68 48.5 316.23 52.06C318.31 54.15 320.78 55.21 324.36 55.21C327.94 55.21 330.42 54.15 332.49 52.06C336.03 48.5 336 43.12 335.98 40.23V26.2H335.97Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M372.49 48.12C371.68 48.01 370.89 47.44 370.44 46.39C370.13 45.67 370.02 44.73 370.02 43.56V32.24H378.32V26.18H370.02V18.31H362.98V42.99C362.98 45.41 363.17 48.34 364.77 51.05C366.13 53.35 368.53 55.22 372.48 55.22C377.26 55.22 380.7 51.76 380.7 51.76L376.48 46.57C376.48 46.57 374.63 48.41 372.5 48.12H372.49Z", fill: "#F45D48" }), /* @__PURE__ */ React.createElement("path", { d: "M248.93 0H247.93V81.36H248.93V0Z", fill: "#777675" }));
const SvgISolved = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 471, height: 82, viewBox: "0 0 471 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M464.13 19.1802V55.0302C464.13 55.2001 464.13 55.5402 463.63 55.5402H456.75C456.25 55.5402 456.1 55.3301 456.09 54.8701V53.6501C456.03 53.5901 456.2 53.5901 456.09 53.6501C452.75 56.0301 448.93 56.9601 445.12 55.8701C439.67 54.3001 436.41 50.4601 435.15 45.0101C434.18 40.7801 434.6 36.6401 436.7 32.7601C439.87 26.9001 447.23 24.2402 453.18 26.7802C454.03 27.1402 454.82 27.6501 455.71 28.1401V27.3402C455.71 22.9802 455.71 23.5502 455.66 19.1902C455.66 19.1902 455.6 18.7002 456.05 18.7002C458.34 18.7202 461.05 18.7102 463.34 18.7002H463.67C464.13 18.7002 464.13 19.0202 464.13 19.1802ZM455.85 40.6201C455.83 39.9201 455.72 39.2302 455.53 38.5502C454.93 36.1802 453.57 34.4801 451.1 33.8801C448.67 33.2801 446.6 33.9102 444.96 35.8002C442.6 38.5102 442.52 43.0601 444.74 45.8801C447.14 48.9301 451.67 49.1201 454.14 46.2701C455.44 44.7501 455.79 42.9301 455.85 40.6201Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M411.51 44.2002C411.85 46.2002 413.8 48.1001 416.13 48.6601C418.66 49.2601 421.74 49.1602 423.88 45.4502C424.02 45.2102 424.31 45.1102 424.57 45.2002L431.59 47.3901C432.03 47.5301 431.91 47.8401 431.85 47.9901C431.36 49.2401 430.63 50.3802 429.71 51.3402C426.09 55.2602 421.53 56.6702 416.33 56.2202C413.26 55.9502 410.46 54.9102 408.04 52.9802C404.95 50.5202 403.19 47.2901 402.68 43.4001C402.22 39.9201 402.63 36.5502 404.29 33.4202C406.75 28.8002 410.77 26.5102 415.88 25.9202C418.9 25.5702 421.86 25.8601 424.64 27.1201C428.57 28.8901 430.85 32.0401 431.92 36.1301C432.5 38.3301 432.61 40.5702 432.5 42.8302C432.47 43.4702 432.32 43.6802 431.64 43.6902C425.18 43.7302 418.71 43.8201 412.25 43.8801H411.81C411.61 43.8801 411.46 43.9302 411.51 44.1902V44.2002ZM423.35 36.8402C423.08 34.7102 420.31 32.9202 417.33 32.9502C414.67 32.9702 411.84 34.9501 411.62 36.8901C411.6 36.9801 411.65 37.0702 411.74 37.0902C411.76 37.0902 411.78 37.0902 411.81 37.0902H423.17C423.44 37.0902 423.37 36.9202 423.36 36.8402H423.35Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M326.24 40.8703C326.24 32.4103 332.99 25.6903 341.51 25.6803C349.86 25.6203 356.68 32.3303 356.74 40.6803C356.74 40.7603 356.74 40.8303 356.74 40.9103C356.72 49.4603 349.87 56.4203 341.48 56.3903C333.05 56.3503 326.24 49.4203 326.24 40.8703ZM341.55 33.6004C340.12 33.6004 338.73 34.0704 337.6 34.9504C334.33 37.4504 333.77 42.6403 336.42 45.9203C339.32 49.5103 344.94 49.1103 347.25 45.1303C348.26 43.3803 348.54 41.4903 348.21 39.5103C347.66 36.1203 344.81 33.5904 341.55 33.6004Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M371.08 26.4805C372.5 26.4805 377.66 26.5305 379.94 26.4805C380.16 26.4805 380.35 26.6504 380.39 26.8704C382.17 31.6404 385.84 41.2804 386.75 43.6804C386.98 44.2804 387.14 43.8604 387.22 43.7104C387.26 43.6304 391.55 32.2904 393.61 26.8704C393.68 26.6404 393.9 26.4805 394.14 26.4805C396.33 26.5205 400.98 26.4805 402.58 26.4805C402.92 26.4805 403.09 26.7304 402.93 27.1204C401.51 30.5104 394.75 46.7004 391.27 54.9204C391.08 55.3604 390.86 55.5504 390.36 55.5404H383.48C383.11 55.5904 382.75 55.3604 382.65 54.9904C379.05 46.5004 372 29.6304 370.86 26.8704C370.76 26.6304 370.89 26.4805 371.09 26.4805H371.08Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M360.27 18.7104H367.9C368.5 18.7104 368.6 18.8404 368.59 19.4104C368.58 32.9304 368.59 41.3004 368.59 54.8204C368.59 55.4004 368.42 55.5604 367.85 55.5504C365.36 55.5204 362.87 55.5304 360.38 55.5504C359.9 55.5504 359.69 55.4504 359.69 54.9104C359.71 41.3004 359.69 32.8505 359.69 19.2305C359.66 18.9605 359.86 18.7204 360.13 18.6904C360.17 18.6904 360.22 18.6904 360.26 18.6904L360.27 18.7104Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M294.8 27.2402V26.8503C294.8 26.6503 294.64 26.4902 294.44 26.4902H286.31C286.11 26.4902 285.95 26.6502 285.95 26.8602V33.5603C285.95 33.7103 286.05 33.8503 286.19 33.9003C290.18 35.3903 292.21 39.8403 290.72 43.8403C289.94 45.9303 288.29 47.5902 286.19 48.3702C286.05 48.4202 285.95 48.5503 285.94 48.7003V54.7402C285.94 55.5102 286.31 55.5102 286.68 55.5002H294.1C294.71 55.5002 294.81 55.2803 294.81 54.7203C294.79 45.1103 294.81 36.8402 294.81 27.2402H294.8Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M298.52 47.6903L305.31 44.7103C305.49 44.6103 305.72 44.6802 305.82 44.8702C305.82 44.8902 305.84 44.9103 305.84 44.9303L305.94 45.1703C307.16 48.1603 310.51 49.6802 313.56 48.6102C313.7 48.5602 313.84 48.5103 313.98 48.4403C314.6 48.1103 315.19 47.7303 315.2 46.9203C315.21 46.1403 314.72 45.6402 314.08 45.4102C312.72 44.9302 311.34 44.5503 309.96 44.1703C308.29 43.7103 306.52 43.4903 304.93 42.8403C302.4 41.7903 300.48 39.9602 299.66 37.2602C299 35.0802 299.55 33.0302 300.72 31.1602C302.55 28.2402 305.31 26.5903 308.64 25.9803C313.25 25.1303 317.14 26.1903 320.71 29.5903C321.92 30.9603 322.5 31.7302 323.02 33.0402C323.13 33.3302 323.2 33.5503 322.83 33.7003C320.61 34.6003 318.4 35.5002 316.19 36.4002C316.04 36.4702 315.87 36.4002 315.8 36.2502C314.82 34.0802 313 33.1702 310.67 33.2902C308.11 33.4202 307.15 35.4203 308.33 36.0603C309 36.4103 309.7 36.6703 310.43 36.8503C312.48 37.4003 314.57 37.8403 316.61 38.4303C318.65 39.0303 320.44 40.0802 321.78 41.7802C324.46 45.1202 324.12 49.9602 321 52.8902C319.08 54.7202 316.75 55.7002 314.17 56.1102C310.33 56.7202 306.65 56.2703 303.29 54.2103C300.93 52.7603 299.34 50.8303 298.32 48.1703C298.22 48.0103 298.28 47.7903 298.44 47.6903C298.46 47.6803 298.49 47.6602 298.51 47.6602L298.52 47.6903Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M283.31 46.2203C286.127 46.2203 288.41 43.9369 288.41 41.1202C288.41 38.3036 286.127 36.0203 283.31 36.0203C280.493 36.0203 278.21 38.3036 278.21 41.1202C278.21 43.9369 280.493 46.2203 283.31 46.2203Z", fill: "#F7008C" }), /* @__PURE__ */ React.createElement("path", { d: "M466.2 19.2104H465.45V18.7104H467.53V19.2205H466.78V21.2305H466.21V19.2205L466.2 19.2104ZM468.06 18.7104H468.67L469.33 19.7704L469.99 18.7104H470.57V21.2205H470.03V19.5204L469.33 20.6204H469.28L468.58 19.5204V21.2205H468.04V18.7104H468.06Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.280273H247.93V81.6403H248.93V0.280273Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.6803C19.58 27.7403 16.72 26.0603 12.52 26.0603C4.66 26.1103 0 32.3603 0 41.0303C0 49.7003 4.65 55.9503 12.52 55.9503C13.96 56.0303 15.41 55.7803 16.75 55.2203C18.09 54.6603 19.29 53.8003 20.26 52.7103V56.8802C20.26 59.7202 18.76 63.0903 14 63.0903C10.39 63.0903 8.61 61.0703 7.99 58.9003L1.6 61.9902C3.2 66.0902 7.02 69.5303 14.44 69.5303C25.44 69.5303 28.27 62.1102 28.27 55.6102V26.4703H21.54L21.36 30.6703L21.35 30.6803ZM14.24 49.1503C10.31 49.1503 7.99 45.9503 7.99 40.9703C7.99 35.9903 10.31 32.7903 14.24 32.7903C18.17 32.7903 20.44 35.9903 20.44 40.9703C20.44 45.9503 18.17 49.1503 14.24 49.1503Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.0203C176.63 26.0203 175.11 26.3603 173.73 27.0403C172.34 27.7203 171.12 28.7003 170.16 29.9303L169.64 26.4902H162.53V55.5002H170.83V39.1202C170.83 34.5902 172.51 32.8203 175.84 32.8203C178.16 32.8203 180.08 33.8503 180.08 38.2703V55.5103H188.38V36.5803C188.38 30.4503 184.58 26.0303 178.16 26.0303L178.17 26.0203Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.8505C49.6201 46.8305 47.9401 49.1504 44.6201 49.1504C42.3001 49.1504 40.3601 48.1204 40.3601 43.7004V26.4805H32.0601V45.3704C32.0601 51.4904 35.8601 55.9404 42.2801 55.9404C43.8201 55.9404 45.3401 55.5904 46.7301 54.9104C48.1201 54.2304 49.3401 53.2404 50.3001 52.0204L50.8201 55.4705H57.9101V26.4805H49.6101V42.8505H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.4805H62.28V55.4904H70.58V26.4805Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.6102C91.6001 26.8802 89.0201 26.0103 86.4001 26.1603C78.5001 26.1603 73.8301 32.4203 73.8301 41.0803C73.8301 49.7403 78.5001 56.0002 86.4001 56.0002C88.0801 56.1102 89.7601 55.7703 91.2701 55.0103C92.7801 54.2503 94.0701 53.1003 95.0101 51.6703L95.2101 55.4902H101.94V13.0103H93.6401L93.6001 28.6102H93.6101ZM88.2101 49.1503C84.2801 49.1503 81.9601 45.9503 81.9601 40.9703C81.9601 35.9903 84.2801 32.7903 88.2101 32.7903C92.1401 32.7903 94.4601 35.9903 94.4601 40.9703C94.4601 45.9503 92.1401 49.1503 88.2101 49.1503Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.3203C65.5099 12.3203 64.6199 12.6002 63.8599 13.1102C63.0999 13.6302 62.5099 14.3603 62.1599 15.2303C61.8099 16.0903 61.7199 17.0403 61.8999 17.9503C62.0799 18.8603 62.5199 19.7002 63.1699 20.3602C63.8199 21.0202 64.6399 21.4703 65.5399 21.6503C66.4399 21.8303 67.3699 21.7402 68.2099 21.3802C69.0599 21.0202 69.7799 20.4203 70.2899 19.6403C70.7999 18.8603 71.0699 17.9503 71.0699 17.0203C71.0699 15.7703 70.5799 14.5703 69.7099 13.6903C68.8399 12.8103 67.6599 12.3103 66.4399 12.3103L66.4299 12.3203Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.4805H149.84V55.4904H158.14V26.4805Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.3203C153.08 12.3203 152.19 12.6002 151.43 13.1102C150.67 13.6302 150.08 14.3603 149.72 15.2303C149.37 16.0903 149.28 17.0403 149.46 17.9503C149.64 18.8603 150.08 19.7002 150.73 20.3602C151.38 21.0202 152.2 21.4703 153.1 21.6503C154 21.8303 154.93 21.7402 155.77 21.3802C156.62 21.0202 157.34 20.4203 157.85 19.6403C158.36 18.8603 158.63 17.9503 158.63 17.0203C158.63 15.7703 158.14 14.5703 157.27 13.6903C156.4 12.8103 155.22 12.3103 154 12.3103V12.3203Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.9202V41.0402C218.63 32.0802 213.58 26.1201 205.25 26.1201C196.92 26.1201 191.31 32.0802 191.31 41.0402C191.31 50.0002 196.93 55.9602 205.25 55.9602C211.01 55.9602 215.3 53.1702 217.33 48.4602L211.32 45.5602C210.93 46.8202 210.14 47.9002 209.08 48.6602C208.02 49.4202 206.75 49.8001 205.45 49.7501C203.92 49.7901 202.42 49.2402 201.28 48.2002C200.14 47.1602 199.42 45.7102 199.29 44.1602H199.35L218.63 41.9302V41.9202ZM199.09 38.9901C199.09 34.7801 201.55 32.0201 205.22 32.0201C206.73 31.9901 208.19 32.5602 209.31 33.5902C210.43 34.6302 211.11 36.0602 211.23 37.5902L199.09 38.9901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.1104C110.47 26.1104 104.85 32.0704 104.85 41.0304C104.85 49.9904 110.47 55.9504 118.8 55.9504C124.55 55.9504 128.84 53.1604 130.82 48.4504L124.81 45.5504C124.42 46.7904 123.65 47.8604 122.61 48.6204C121.57 49.3704 120.32 49.7704 119.05 49.7404C117.5 49.8104 115.99 49.2605 114.83 48.2205C113.67 47.1805 112.94 45.7204 112.81 44.1504L132.05 41.9004V41.0204C132.17 32.0804 127.12 26.1204 118.8 26.1204V26.1104ZM112.61 38.9904C112.61 34.7804 115.02 32.0204 118.75 32.0204C120.26 31.9904 121.72 32.5605 122.84 33.5905C123.96 34.6305 124.64 36.0605 124.76 37.5905L112.6 38.9904H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.7502V13.0103H134.99V47.6102C134.99 51.6302 135.78 55.8203 142.81 55.8203C144.14 55.8903 145.47 55.6703 146.71 55.1603V48.6803C146.71 48.6803 143.29 49.5602 143.29 46.7502Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.1201H33.04V75.8502H0.25V81.6902H38.77V68.9502H218.65V63.1201Z", fill: "#5532FA" }));
const SvgJustworks = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 512, height: 83, viewBox: "0 0 512 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.690186H247.93V82.0502H248.93V0.690186Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M510.43 51.6602H279.47V61.3702H510.43V51.6602Z", fill: "#1E98FF" }), /* @__PURE__ */ React.createElement("path", { d: "M278.21 41.8702L286.35 40.3302C286.5 44.4902 287.82 46.5002 290.57 46.5002C292.97 46.5002 294.07 45.4002 294.07 42.1802V18.2302H302.54V40.1702C302.54 48.7502 298.99 52.3002 290.38 52.3002C281.77 52.3002 278.87 47.1102 278.2 41.8702H278.21Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M307.8 43.4904V27.3804H316.07V43.6504C316.07 45.9904 317.18 46.9103 318.98 46.9103C321.38 46.9103 322.82 45.4503 322.82 42.0503V27.3804H331.09V51.6603H323.21V45.1104H323C321.79 50.7904 319.11 52.2504 315.45 52.2504C310.32 52.2204 307.8 49.5304 307.8 43.4904Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M335.31 46.4901L339.77 43.4801C341.24 46.2001 343.56 47.2601 346.6 47.2601C348.89 47.2601 349.9 46.5901 349.9 45.3101C349.9 43.8501 348.92 43.0701 346.19 42.5901L342.79 41.9501C338.21 41.1301 335.73 38.4601 335.73 34.7001C335.73 29.6901 339.77 26.79 345.96 26.79C352.15 26.79 354.97 29.3101 356.52 32.1301L352.19 34.91C351.08 32.39 348.84 31.5701 346.78 31.5701C344.72 31.5701 343.51 32.3401 343.51 33.6001C343.51 34.8601 344.44 35.5001 346.78 35.9401L350.23 36.5801C355.33 37.5101 357.83 39.5901 357.83 44.1101C357.83 48.3801 355.1 52.2301 347.06 52.2301C341.14 52.2301 337.12 49.9701 335.31 46.5001V46.4901Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M362.74 45.1102V32.2402H359.44V27.3802H362.74V21.0103H371.01V27.3802H375V32.2402H371.01V44.3702C371.01 45.9602 371.65 46.6102 372.86 46.6102H375V51.6702H369.59C364.39 51.6702 362.74 50.0302 362.74 45.1202V45.1102Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M377.61 27.3804H386.57L389.92 42.6703H390.13L394.41 27.3804H401.24L405.36 42.6703H405.57L409.28 27.3804H415.8L408.25 51.6603H401.14L396.81 36.4004H396.6L392.48 51.6603H385.37L377.62 27.3804H377.61Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M416.55 39.5002C416.55 31.7402 421.62 26.7803 429.2 26.7803C436.78 26.7803 441.85 31.7402 441.85 39.5002C441.85 47.2602 436.78 52.2202 429.2 52.2202C421.62 52.2202 416.55 47.2902 416.55 39.5002ZM433.19 39.5002C433.19 33.2302 431.82 31.5902 429.2 31.5902C426.58 31.5902 425.21 33.2302 425.21 39.5002C425.21 45.7702 426.58 47.4102 429.2 47.4102C431.82 47.4102 433.19 45.7702 433.19 39.5002Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M445.5 27.3802H453.28V35.4502H453.49C454.65 28.7902 456.89 27.2302 460.5 27.2302H460.94V34.5002H456.95C454.55 34.5002 453.78 35.2703 453.78 38.1503V51.6403H445.51V27.3802H445.5Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M474.71 41.9502L472.34 44.5702V51.6602H464.15V18.2803H472.34V37.8102L480.79 27.3802H488.16L480.12 36.1202L488.67 51.6702H479.91L474.71 41.9602V41.9502Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M489.21 46.4901L493.69 43.4801C495.16 46.2001 497.48 47.2601 500.52 47.2601C502.81 47.2601 503.82 46.5901 503.82 45.3101C503.82 43.8501 502.84 43.0701 500.11 42.5901L496.71 41.9501C492.12 41.1301 489.65 38.4601 489.65 34.7001C489.65 29.6901 493.69 26.79 499.88 26.79C506.07 26.79 508.89 29.3101 510.44 32.1301L506.11 34.91C505 32.39 502.76 31.5701 500.7 31.5701C498.64 31.5701 497.43 32.3401 497.43 33.6001C497.43 34.8601 498.36 35.5001 500.7 35.9401L504.15 36.5801C509.25 37.5101 511.75 39.5901 511.75 44.1101C511.75 48.3801 509.02 52.2301 500.98 52.2301C495.06 52.2301 491.01 49.9701 489.21 46.5001V46.4901Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.0902C19.58 28.1502 16.72 26.4702 12.52 26.4702C4.66 26.5202 0 32.7702 0 41.4402C0 50.1102 4.65 56.3602 12.52 56.3602C13.96 56.4402 15.41 56.1902 16.75 55.6302C18.09 55.0702 19.29 54.2102 20.26 53.1202V57.2902C20.26 60.1302 18.76 63.5002 14 63.5002C10.39 63.5002 8.61 61.4802 7.99 59.3102L1.6 62.4003C3.2 66.5003 7.02 69.9402 14.44 69.9402C25.44 69.9402 28.27 62.5203 28.27 56.0203V26.8802H21.54L21.36 31.0802L21.35 31.0902ZM14.24 49.5602C10.31 49.5602 7.99 46.3602 7.99 41.3802C7.99 36.4002 10.31 33.2002 14.24 33.2002C18.17 33.2002 20.44 36.4002 20.44 41.3802C20.44 46.3602 18.17 49.5602 14.24 49.5602Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.4202C176.63 26.4202 175.11 26.7602 173.73 27.4402C172.34 28.1202 171.12 29.1002 170.16 30.3302L169.64 26.8903H162.53V55.9003H170.83V39.5203C170.83 34.9903 172.51 33.2202 175.84 33.2202C178.16 33.2202 180.08 34.2502 180.08 38.6702V55.9102H188.38V36.9802C188.38 30.8502 184.58 26.4302 178.16 26.4302L178.17 26.4202Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.2601C49.6201 47.2401 47.9401 49.5601 44.6201 49.5601C42.3001 49.5601 40.3601 48.5301 40.3601 44.1101V26.8901H32.0601V45.7802C32.0601 51.9002 35.8601 56.3501 42.2801 56.3501C43.8201 56.3501 45.3401 56.0001 46.7301 55.3201C48.1201 54.6401 49.3401 53.6501 50.3001 52.4301L50.8201 55.8801H57.9101V26.8901H49.6101V43.2601H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.8901H62.28V55.9001H70.58V26.8901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.0203C91.6001 27.2903 89.0201 26.4202 86.4001 26.5702C78.5001 26.5702 73.8301 32.8302 73.8301 41.4902C73.8301 50.1502 78.5001 56.4102 86.4001 56.4102C88.0801 56.5202 89.7601 56.1802 91.2701 55.4202C92.7801 54.6602 94.0701 53.5102 95.0101 52.0802L95.2101 55.9003H101.94V13.4202H93.6401L93.6001 29.0203H93.6101ZM88.2101 49.5602C84.2801 49.5602 81.9601 46.3602 81.9601 41.3802C81.9601 36.4002 84.2801 33.2002 88.2101 33.2002C92.1401 33.2002 94.4601 36.4002 94.4601 41.3802C94.4601 46.3602 92.1401 49.5602 88.2101 49.5602Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.7202C65.5099 12.7202 64.6199 13.0003 63.8599 13.5103C63.0999 14.0303 62.5099 14.7602 62.1599 15.6302C61.8099 16.4902 61.7199 17.4402 61.8999 18.3502C62.0799 19.2602 62.5199 20.1003 63.1699 20.7603C63.8199 21.4203 64.6399 21.8702 65.5399 22.0502C66.4399 22.2302 67.3699 22.1403 68.2099 21.7803C69.0599 21.4203 69.7799 20.8202 70.2899 20.0402C70.7999 19.2602 71.0699 18.3502 71.0699 17.4202C71.0699 16.1702 70.5799 14.9702 69.7099 14.0902C68.8399 13.2102 67.6599 12.7102 66.4399 12.7102L66.4299 12.7202Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.8901H149.84V55.9001H158.14V26.8901Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.7202C153.08 12.7202 152.19 13.0003 151.43 13.5103C150.67 14.0303 150.08 14.7602 149.72 15.6302C149.37 16.4902 149.28 17.4402 149.46 18.3502C149.64 19.2602 150.08 20.1003 150.73 20.7603C151.38 21.4203 152.2 21.8702 153.1 22.0502C154 22.2302 154.93 22.1403 155.77 21.7803C156.62 21.4203 157.34 20.8202 157.85 20.0402C158.36 19.2602 158.63 18.3502 158.63 17.4202C158.63 16.1702 158.14 14.9702 157.27 14.0902C156.4 13.2102 155.22 12.7102 154 12.7102V12.7202Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.3302V41.4502C218.63 32.4902 213.58 26.5303 205.25 26.5303C196.92 26.5303 191.31 32.4902 191.31 41.4502C191.31 50.4102 196.93 56.3702 205.25 56.3702C211.01 56.3702 215.3 53.5802 217.33 48.8702L211.32 45.9702C210.93 47.2302 210.14 48.3102 209.08 49.0702C208.02 49.8302 206.75 50.2102 205.45 50.1602C203.92 50.2002 202.42 49.6502 201.28 48.6102C200.14 47.5702 199.42 46.1202 199.29 44.5702H199.35L218.63 42.3402V42.3302ZM199.09 39.4003C199.09 35.1903 201.55 32.4302 205.22 32.4302C206.73 32.4002 208.19 32.9702 209.31 34.0002C210.43 35.0402 211.11 36.4702 211.23 38.0002L199.09 39.4003Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.5203C110.47 26.5203 104.85 32.4802 104.85 41.4402C104.85 50.4002 110.47 56.3602 118.8 56.3602C124.55 56.3602 128.84 53.5702 130.82 48.8602L124.81 45.9602C124.42 47.2002 123.65 48.2703 122.61 49.0303C121.57 49.7803 120.32 50.1803 119.05 50.1503C117.5 50.2203 115.99 49.6702 114.83 48.6302C113.67 47.5902 112.94 46.1302 112.81 44.5602L132.05 42.3102V41.4302C132.17 32.4902 127.12 26.5303 118.8 26.5303V26.5203ZM112.61 39.4003C112.61 35.1903 115.02 32.4302 118.75 32.4302C120.26 32.4002 121.72 32.9702 122.84 34.0002C123.96 35.0402 124.64 36.4702 124.76 38.0002L112.6 39.4003H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.1602V13.4202H134.99V48.0203C134.99 52.0403 135.78 56.2302 142.81 56.2302C144.14 56.3002 145.47 56.0802 146.71 55.5702V49.0902C146.71 49.0902 143.29 49.9702 143.29 47.1602Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.5303H33.04V76.2603H0.25V82.1002H38.77V69.3602H218.65V63.5303Z", fill: "#5532FA" }));
const SvgNamely = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 499, height: 86, viewBox: "0 0 499 86", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 3.74023H247.93V85.1002H248.93V3.74023Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 34.14C19.58 31.2 16.72 29.52 12.52 29.52C4.66 29.57 0 35.82 0 44.49C0 53.16 4.65 59.4099 12.52 59.4099C13.96 59.4899 15.41 59.2399 16.75 58.6799C18.09 58.1199 19.29 57.2599 20.26 56.1699V60.34C20.26 63.18 18.76 66.5499 14 66.5499C10.39 66.5499 8.61 64.53 7.99 62.36L1.6 65.45C3.2 69.5499 7.02 72.99 14.44 72.99C25.44 72.99 28.27 65.5699 28.27 59.0699V29.9299H21.54L21.36 34.13L21.35 34.14ZM14.24 52.61C10.31 52.61 7.99 49.4099 7.99 44.4299C7.99 39.4499 10.31 36.25 14.24 36.25C18.17 36.25 20.44 39.4499 20.44 44.4299C20.44 49.4099 18.17 52.61 14.24 52.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 29.4702C176.63 29.4702 175.11 29.8102 173.73 30.4902C172.34 31.1702 171.12 32.1502 170.16 33.3802L169.64 29.9402H162.53V58.9502H170.83V42.5702C170.83 38.0402 172.51 36.2703 175.84 36.2703C178.16 36.2703 180.08 37.3002 180.08 41.7202V58.9602H188.38V40.0302C188.38 33.9002 184.58 29.4802 178.16 29.4802L178.17 29.4702Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 46.3099C49.6201 50.2899 47.9401 52.61 44.6201 52.61C42.3001 52.61 40.3601 51.5799 40.3601 47.1599V29.9399H32.0601V48.83C32.0601 54.95 35.8601 59.4 42.2801 59.4C43.8201 59.4 45.3401 59.05 46.7301 58.37C48.1201 57.69 49.3401 56.7 50.3001 55.48L50.8201 58.9299H57.9101V29.9399H49.6101V46.3099H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 29.9399H62.28V58.95H70.58V29.9399Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 32.0702C91.6001 30.3402 89.0201 29.4702 86.4001 29.6202C78.5001 29.6202 73.8301 35.8802 73.8301 44.5402C73.8301 53.2002 78.5001 59.4602 86.4001 59.4602C88.0801 59.5702 89.7601 59.2302 91.2701 58.4702C92.7801 57.7102 94.0701 56.5602 95.0101 55.1302L95.2101 58.9502H101.94V16.4702H93.6401L93.6001 32.0702H93.6101ZM88.2101 52.6102C84.2801 52.6102 81.9601 49.4102 81.9601 44.4302C81.9601 39.4502 84.2801 36.2502 88.2101 36.2502C92.1401 36.2502 94.4601 39.4502 94.4601 44.4302C94.4601 49.4102 92.1401 52.6102 88.2101 52.6102Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 15.7799C65.5099 15.7799 64.6199 16.0599 63.8599 16.5699C63.0999 17.0899 62.5099 17.8199 62.1599 18.6899C61.8099 19.5499 61.7199 20.4999 61.8999 21.4099C62.0799 22.3199 62.5199 23.1599 63.1699 23.8199C63.8199 24.4799 64.6399 24.93 65.5399 25.11C66.4399 25.29 67.3699 25.2 68.2099 24.84C69.0599 24.48 69.7799 23.88 70.2899 23.1C70.7999 22.32 71.0699 21.41 71.0699 20.48C71.0699 19.23 70.5799 18.03 69.7099 17.15C68.8399 16.27 67.6599 15.77 66.4399 15.77L66.4299 15.7799Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 29.9399H149.84V58.95H158.14V29.9399Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 15.7799C153.08 15.7799 152.19 16.0599 151.43 16.5699C150.67 17.0899 150.08 17.8199 149.72 18.6899C149.37 19.5499 149.28 20.4999 149.46 21.4099C149.64 22.3199 150.08 23.1599 150.73 23.8199C151.38 24.4799 152.2 24.93 153.1 25.11C154 25.29 154.93 25.2 155.77 24.84C156.62 24.48 157.34 23.88 157.85 23.1C158.36 22.32 158.63 21.41 158.63 20.48C158.63 19.23 158.14 18.03 157.27 17.15C156.4 16.27 155.22 15.77 154 15.77V15.7799Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 45.3801V44.5001C218.63 35.5401 213.58 29.5801 205.25 29.5801C196.92 29.5801 191.31 35.5401 191.31 44.5001C191.31 53.4601 196.93 59.42 205.25 59.42C211.01 59.42 215.3 56.63 217.33 51.92L211.32 49.0201C210.93 50.2801 210.14 51.3601 209.08 52.1201C208.02 52.8801 206.75 53.2601 205.45 53.2101C203.92 53.2501 202.42 52.7 201.28 51.66C200.14 50.62 199.42 49.1701 199.29 47.6201H199.35L218.63 45.3901V45.3801ZM199.09 42.4501C199.09 38.2401 201.55 35.4801 205.22 35.4801C206.73 35.4501 208.19 36.02 209.31 37.05C210.43 38.09 211.11 39.52 211.23 41.05L199.09 42.4501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 29.5701C110.47 29.5701 104.85 35.5301 104.85 44.4901C104.85 53.4501 110.47 59.41 118.8 59.41C124.55 59.41 128.84 56.62 130.82 51.91L124.81 49.0101C124.42 50.2501 123.65 51.3201 122.61 52.0801C121.57 52.8301 120.32 53.2301 119.05 53.2001C117.5 53.2701 115.99 52.7201 114.83 51.6801C113.67 50.6401 112.94 49.1801 112.81 47.6101L132.05 45.3601V44.4801C132.17 35.5401 127.12 29.5801 118.8 29.5801V29.5701ZM112.61 42.4501C112.61 38.2401 115.02 35.4801 118.75 35.4801C120.26 35.4501 121.72 36.02 122.84 37.05C123.96 38.09 124.64 39.52 124.76 41.05L112.6 42.4501H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 50.2102V16.4702H134.99V51.0702C134.99 55.0902 135.78 59.2802 142.81 59.2802C144.14 59.3502 145.47 59.1302 146.71 58.6202V52.1403C146.71 52.1403 143.29 53.0202 143.29 50.2102Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 66.5801H33.04V79.3101H0.25V85.1501H38.77V72.41H218.65V66.5801Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M306.36 59.5601H301.31C300.23 59.5601 299.45 59.2101 298.63 57.8201L286.88 37.4401C286.67 37.1301 286.45 36.9901 286.29 36.9901C286.13 36.9901 285.91 37.0601 285.91 37.3701V58.2501C285.91 58.8201 285.69 59.5701 285.12 59.5701H279.04C278.47 59.5701 278.21 58.8101 278.21 58.2501V22.9401C278.21 21.8601 278.89 21.0801 279.97 21.0801H285.18C286.21 21.0801 286.73 21.5501 287.35 22.6301L299.57 43.8401C299.78 44.1501 299.78 44.2401 299.93 44.2401C300.03 44.2401 300.14 44.1301 300.14 43.7601V21.9601C300.14 21.3901 300.71 21.0701 301.27 21.0701H307.35C307.92 21.0701 308.43 21.3901 308.43 21.9601V57.3201C308.43 58.4001 307.46 59.5701 306.37 59.5701L306.36 59.5601Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M336.31 59.5601H330.54C329.97 59.5601 329.74 58.8001 329.74 58.2401V57.42C327.37 58.86 325.66 59.7401 322.57 59.7401C318.09 59.7401 313.75 57.5701 313.75 50.8701V50.41C313.75 44.38 317.39 41.8 326.21 41.8H329.15V39.8401C329.15 36.9001 327.63 36.2001 325.2 36.2001C321.9 36.2001 318.16 36.4701 316.56 36.4701H316.3C315.78 36.4701 315.52 36.3901 315.52 35.7201V31.54C315.52 30.97 315.81 30.56 316.43 30.41C318.34 29.95 321.96 29.3301 325.36 29.3301C332.78 29.3301 337.44 32.3201 337.44 39.8501V58.2501C337.44 58.8201 336.88 59.5701 336.31 59.5701V59.5601ZM329.15 46.53H326.21C322.6 46.53 321.45 47.8801 321.45 50.4001V50.8601C321.45 53.0301 322.65 53.4401 324.81 53.4401C326.36 53.4401 327.97 52.9201 329.15 52.3101V46.53Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M380.84 59.5601H374.6C374.03 59.5601 373.56 58.7501 373.56 58.1801V40.6001C373.56 37.3001 372.79 36.3201 370.42 36.3201C369.54 36.3201 367.92 36.5301 366.37 37.2501C366.47 38.2801 366.45 39.4701 366.45 40.6001V58.1801C366.45 58.7501 366.14 59.5601 365.57 59.5601H359.33C358.76 59.5601 358.15 58.7501 358.15 58.1801V40.6001C358.15 37.3001 357.43 36.3201 355.06 36.3201C354.08 36.3201 352.82 36.84 351.04 37.66V58.1801C351.04 58.7501 350.87 59.5601 350.31 59.5601H344.07C343.5 59.5601 342.75 58.7501 342.75 58.1801V30.7601C342.75 30.1901 343.45 29.9401 344.02 29.9401H349.9C350.47 29.9401 351.05 30.1901 351.05 30.7601V31.8901C352.83 30.4501 355.63 29.3101 358.62 29.3101C361.35 29.3101 363.23 30.0801 364.67 31.8401C367.66 30.1401 369.68 29.3101 373.03 29.3101C379.83 29.3101 381.85 33.8501 381.85 40.6001V58.1801C381.85 58.7501 381.4 59.5601 380.83 59.5601H380.84Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M411.51 47.1301H394.89V47.2101C394.89 50.1501 396.22 52.8801 400.29 52.8801C403.54 52.8801 408.21 52.4601 410.28 52.4601H410.43C411 52.4601 411.48 52.6201 411.48 53.1901V57.1101C411.48 57.9301 411.24 58.3001 410.36 58.5001C407.06 59.3201 404.15 59.7401 399.67 59.7401C393.43 59.7401 386.6 56.4401 386.6 46.4901V42.8801C386.6 34.5801 391.59 29.3201 399.79 29.3201C407.99 29.3201 412.67 35.0901 412.67 42.8801V45.8701C412.67 46.6401 412.19 47.1301 411.52 47.1301H411.51ZM404.37 41.7501C404.37 37.9401 402.57 36.03 399.68 36.03C396.79 36.03 394.89 37.9901 394.89 41.7501V41.8H404.37V41.7501Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M424.86 59.5601H418.57C418 59.5601 417.4 58.7501 417.4 58.1801V20.7601C417.4 20.1901 418.01 19.8801 418.57 19.8801H424.86C425.43 19.8801 425.69 20.2001 425.69 20.7601V58.1801C425.69 58.7501 425.43 59.5601 424.86 59.5601Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M457.75 30.9202L449.09 61.2802C447.49 66.8502 445.38 69.6802 437.8 69.6802C435.89 69.6802 432.83 69.2702 431.54 68.8602C430.97 68.6502 430.43 68.5002 430.43 67.9302V63.7502C430.43 63.1802 430.94 62.5203 431.51 62.5203H431.61C433.31 63.1103 436.35 63.0602 438.05 63.0602C439.91 63.0602 440.83 62.5302 441.45 60.4702L441.91 58.9702H441.14C439.23 58.9702 437.63 58.6303 436.35 54.1403L429.55 30.9302C429.5 30.7802 429.5 30.7702 429.5 30.6702C429.5 30.1502 429.81 29.9502 430.53 29.9502H437.39C437.91 29.9502 438.27 30.3102 438.37 30.8202L443.01 50.2502C443.16 50.9702 443.32 51.2703 443.63 51.2703H444.09L448.88 30.9202C448.98 30.4002 449.4 29.9502 449.96 29.9502H456.82C457.34 29.9502 457.8 30.2503 457.8 30.7703C457.8 30.8703 457.75 30.8202 457.75 30.9202Z", fill: "#15212D" }), /* @__PURE__ */ React.createElement("path", { d: "M487.81 0.100098L484.11 7.91003C483.97 7.74003 483.93 7.65011 483.77 7.49011C483.19 6.91011 482.53 6.46013 481.78 6.13013C481.03 5.80013 480.23 5.64014 479.39 5.64014C478.15 5.64014 477.03 5.97012 476.01 6.62012C474.99 7.27012 474.23 8.16003 473.73 9.28003L466.84 24.6001L477.89 29.7301L481.59 21.9501C481.73 22.1301 481.73 22.2101 481.9 22.3701C482.48 22.9501 483.15 23.4001 483.92 23.7301C484.69 24.0601 485.5 24.2201 486.35 24.2201C487.58 24.2201 488.69 23.8901 489.67 23.2101C490.66 22.5401 491.41 21.64 491.95 20.53L498.83 5.22009L487.83 0.110107L487.81 0.100098Z", fill: "#0073DD" }));
const SvgOnpay = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 475, height: 82, viewBox: "0 0 475 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M296.81 40.99H289.52C288.28 40.99 287.35 40.0599 287.35 38.8199V32.77C287.35 31.53 288.28 30.6 289.52 30.6H296.81C298.05 30.6 298.98 31.53 298.98 32.77V38.8199C298.98 40.0599 297.89 40.99 296.81 40.99Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M287.66 55.5599H280.37C279.13 55.5599 278.2 54.6299 278.2 53.3899V45.3299C278.2 44.0899 279.13 43.1599 280.37 43.1599H287.66C288.9 43.1599 289.83 44.0899 289.83 45.3299V53.3899C289.83 54.4799 288.74 55.5599 287.66 55.5599Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M302.55 55.5599H295.26C294.02 55.5599 293.09 54.6299 293.09 53.3899V46.0999C293.09 44.8599 294.02 43.9299 295.26 43.9299H302.55C303.79 43.9299 304.72 44.8599 304.72 46.0999V53.3899C304.72 54.4799 303.79 55.5599 302.55 55.5599Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M324.09 26.4099C315.72 26.4099 309.05 32.7699 309.05 41.1399C309.05 49.5099 315.87 55.3999 324.09 55.3999C332.31 55.3999 339.13 49.3499 339.13 41.1399C339.13 32.9299 332.46 26.4099 324.09 26.4099ZM324.09 49.9699C319.28 49.9699 315.56 46.2499 315.56 40.9799C315.56 35.7099 319.44 31.8299 324.09 31.8299C328.74 31.8299 332.62 35.8599 332.62 40.9799C332.62 46.0999 328.74 49.9699 324.09 49.9699Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M356.8 26.4099C343.31 26.4099 343 37.8799 343 37.8799V55.3999H349.36V39.8999C349.36 31.9899 356.8 32.1499 356.8 32.1499C356.8 32.1499 364.24 31.8399 364.24 39.8999V55.3999H370.6V37.8799C370.6 37.8799 370.29 26.4099 356.8 26.4099Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M389.35 26.4099C380.82 26.4099 374.62 32.1499 374.62 40.9799V66.7099H377.57C379.43 66.7099 380.83 65.3099 380.83 63.4499V51.8199C382.38 53.6799 385.95 55.6999 389.36 55.6999C397.89 55.6999 404.09 49.9599 404.09 41.1299C404.09 32.2999 397.89 26.3999 389.36 26.3999L389.35 26.4099ZM389.2 49.6599C384.24 49.6599 380.52 46.0899 380.52 40.8199C380.52 35.5499 384.24 31.9799 389.2 31.9799C394.16 31.9799 397.88 35.5499 397.88 40.8199C397.88 46.2499 394.16 49.6599 389.2 49.6599Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M422.05 26.4099C414.14 26.4099 407.79 32.9199 407.79 40.9799C407.79 49.0399 414.15 55.5499 422.05 55.5499C425.93 55.5499 429.49 53.5299 431.35 51.2099V52.7599C431.35 54.1599 432.59 55.3999 433.99 55.3999H437.4V40.8299C437.4 32.9199 432.13 26.4099 422.05 26.4099ZM422.67 49.6599C417.71 49.6599 413.99 45.9399 413.99 40.9799C413.99 36.0199 417.71 32.2999 422.67 32.2999C427.63 32.2999 431.35 36.0199 431.35 40.9799C431.35 45.9399 427.63 49.6599 422.67 49.6599Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M439.26 26.41L448.25 51.83C448.25 51.83 449.18 53.85 446.85 56.02C445.61 57.26 443.75 58.66 442.51 59.7401C441.42 60.6701 440.96 62.38 441.58 63.77L442.82 66.72C442.82 66.72 449.18 63.62 455.84 55.09C455.84 55.09 458.32 52.14 460.49 47.34C462.66 42.53 469.48 26.26 469.48 26.26H463.12L453.82 47.8101L446.07 26.26H439.25V26.42L439.26 26.41Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M469.95 61.1399C467.47 61.1399 465.45 59.1199 465.45 56.6399C465.45 54.1599 467.47 52.1399 469.95 52.1399C472.43 52.1399 474.45 54.1599 474.45 56.6399C474.45 59.1199 472.43 61.1399 469.95 61.1399ZM469.95 52.9199C467.93 52.9199 466.23 54.6299 466.23 56.6399C466.23 58.6499 467.94 60.3599 469.95 60.3599C471.96 60.3599 473.67 58.6499 473.67 56.6399C473.67 54.6299 472.12 52.9199 469.95 52.9199Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M471.81 58.9699L470.41 57.1099C470.87 56.9499 471.34 56.6399 471.34 55.8699C471.34 54.9399 470.56 54.6299 470.1 54.6299H468.55V58.9699H469.01V57.1099H469.79L471.03 58.9699H471.81ZM469.17 55.0899H470.26C470.42 55.0899 471.04 55.0899 471.04 55.8699C471.04 56.6499 470.26 56.6499 470.26 56.6499H469.17V55.0999V55.0899Z", fill: "#2588D3" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.63C19.58 27.69 16.72 26.01 12.52 26.01C4.66 26.06 0 32.31 0 40.98C0 49.65 4.65 55.9 12.52 55.9C13.96 55.98 15.41 55.73 16.75 55.17C18.09 54.61 19.29 53.75 20.26 52.66V56.83C20.26 59.67 18.76 63.04 14 63.04C10.39 63.04 8.61 61.02 7.99 58.85L1.6 61.9401C3.2 66.0401 7.02 69.48 14.44 69.48C25.44 69.48 28.27 62.0601 28.27 55.5601V26.42H21.54L21.36 30.6201L21.35 30.63ZM14.24 49.1C10.31 49.1 7.99 45.9 7.99 40.92C7.99 35.94 10.31 32.7401 14.24 32.7401C18.17 32.7401 20.44 35.94 20.44 40.92C20.44 45.9 18.17 49.1 14.24 49.1Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.97C176.63 25.97 175.11 26.31 173.73 26.99C172.34 27.67 171.12 28.6499 170.16 29.8799L169.64 26.44H162.53V55.45H170.83V39.0699C170.83 34.5399 172.51 32.77 175.84 32.77C178.16 32.77 180.08 33.8 180.08 38.22V55.46H188.38V36.53C188.38 30.4 184.58 25.98 178.16 25.98L178.17 25.97Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.7999C49.6201 46.7799 47.9401 49.0999 44.6201 49.0999C42.3001 49.0999 40.3601 48.0699 40.3601 43.6499V26.4299H32.0601V45.3199C32.0601 51.4399 35.8601 55.8899 42.2801 55.8899C43.8201 55.8899 45.3401 55.5399 46.7301 54.8599C48.1201 54.1799 49.3401 53.1899 50.3001 51.9699L50.8201 55.4199H57.9101V26.4299H49.6101V42.7999H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.4299H62.28V55.4399H70.58V26.4299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.56C91.6001 26.83 89.0201 25.96 86.4001 26.11C78.5001 26.11 73.8301 32.37 73.8301 41.03C73.8301 49.69 78.5001 55.95 86.4001 55.95C88.0801 56.06 89.7601 55.72 91.2701 54.96C92.7801 54.2 94.0701 53.05 95.0101 51.62L95.2101 55.44H101.94V12.96H93.6401L93.6001 28.56H93.6101ZM88.2101 49.1C84.2801 49.1 81.9601 45.9 81.9601 40.92C81.9601 35.94 84.2801 32.74 88.2101 32.74C92.1401 32.74 94.4601 35.94 94.4601 40.92C94.4601 45.9 92.1401 49.1 88.2101 49.1Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.27C65.5099 12.27 64.6199 12.5501 63.8599 13.0601C63.0999 13.5801 62.5099 14.3101 62.1599 15.1801C61.8099 16.0401 61.7199 16.99 61.8999 17.9C62.0799 18.81 62.5199 19.6501 63.1699 20.3101C63.8199 20.9701 64.6399 21.42 65.5399 21.6C66.4399 21.78 67.3699 21.69 68.2099 21.33C69.0599 20.97 69.7799 20.37 70.2899 19.59C70.7999 18.81 71.0699 17.9 71.0699 16.97C71.0699 15.72 70.5799 14.52 69.7099 13.64C68.8399 12.76 67.6599 12.26 66.4399 12.26L66.4299 12.27Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.4299H149.84V55.4399H158.14V26.4299Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.27C153.08 12.27 152.19 12.5501 151.43 13.0601C150.67 13.5801 150.08 14.3101 149.72 15.1801C149.37 16.0401 149.28 16.99 149.46 17.9C149.64 18.81 150.08 19.6501 150.73 20.3101C151.38 20.9701 152.2 21.42 153.1 21.6C154 21.78 154.93 21.69 155.77 21.33C156.62 20.97 157.34 20.37 157.85 19.59C158.36 18.81 158.63 17.9 158.63 16.97C158.63 15.72 158.14 14.52 157.27 13.64C156.4 12.76 155.22 12.26 154 12.26V12.27Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.87V40.99C218.63 32.03 213.58 26.0699 205.25 26.0699C196.92 26.0699 191.31 32.03 191.31 40.99C191.31 49.95 196.93 55.91 205.25 55.91C211.01 55.91 215.3 53.12 217.33 48.41L211.32 45.5099C210.93 46.7699 210.14 47.85 209.08 48.61C208.02 49.37 206.75 49.75 205.45 49.7C203.92 49.74 202.42 49.19 201.28 48.15C200.14 47.11 199.42 45.66 199.29 44.11H199.35L218.63 41.8799V41.87ZM199.09 38.94C199.09 34.73 201.55 31.97 205.22 31.97C206.73 31.94 208.19 32.51 209.31 33.54C210.43 34.58 211.11 36.01 211.23 37.54L199.09 38.94Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.0601C110.47 26.0601 104.85 32.02 104.85 40.98C104.85 49.94 110.47 55.9 118.8 55.9C124.55 55.9 128.84 53.11 130.82 48.4L124.81 45.5001C124.42 46.7401 123.65 47.81 122.61 48.57C121.57 49.32 120.32 49.7201 119.05 49.6901C117.5 49.7601 115.99 49.21 114.83 48.17C113.67 47.13 112.94 45.67 112.81 44.1L132.05 41.85V40.97C132.17 32.03 127.12 26.07 118.8 26.07V26.0601ZM112.61 38.9401C112.61 34.7301 115.02 31.97 118.75 31.97C120.26 31.94 121.72 32.51 122.84 33.54C123.96 34.58 124.64 36.01 124.76 37.54L112.6 38.9401H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.71V12.97H134.99V47.5699C134.99 51.5899 135.78 55.78 142.81 55.78C144.14 55.85 145.47 55.63 146.71 55.12V48.64C146.71 48.64 143.29 49.52 143.29 46.71Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.0699H33.04V75.8H0.25V81.64H38.77V68.9H218.65V63.0699Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.22998H247.93V81.59H248.93V0.22998Z", fill: "#777675" }));
const SvgPaychex = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 469, height: 82, viewBox: "0 0 469 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.150391H247.93V81.5105H248.93V0.150391Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.5404C19.58 27.6004 16.72 25.9204 12.52 25.9204C4.66 25.9704 0 32.2205 0 40.8905C0 49.5605 4.65 55.8104 12.52 55.8104C13.96 55.8904 15.41 55.6404 16.75 55.0804C18.09 54.5204 19.29 53.6604 20.26 52.5704V56.7405C20.26 59.5805 18.76 62.9504 14 62.9504C10.39 62.9504 8.61 60.9305 7.99 58.7605L1.6 61.8505C3.2 65.9505 7.02 69.3905 14.44 69.3905C25.44 69.3905 28.27 61.9705 28.27 55.4705V26.3304H21.54L21.36 30.5304L21.35 30.5404ZM14.24 49.0105C10.31 49.0105 7.99 45.8104 7.99 40.8304C7.99 35.8504 10.31 32.6504 14.24 32.6504C18.17 32.6504 20.44 35.8504 20.44 40.8304C20.44 45.8104 18.17 49.0105 14.24 49.0105Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.8804C176.63 25.8804 175.11 26.2203 173.73 26.9003C172.34 27.5803 171.12 28.5603 170.16 29.7903L169.64 26.3503H162.53V55.3604H170.83V38.9803C170.83 34.4503 172.51 32.6803 175.84 32.6803C178.16 32.6803 180.08 33.7104 180.08 38.1304V55.3704H188.38V36.4403C188.38 30.3103 184.58 25.8904 178.16 25.8904L178.17 25.8804Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.7103C49.6201 46.6903 47.9401 49.0104 44.6201 49.0104C42.3001 49.0104 40.3601 47.9803 40.3601 43.5603V26.3403H32.0601V45.2303C32.0601 51.3503 35.8601 55.8003 42.2801 55.8003C43.8201 55.8003 45.3401 55.4504 46.7301 54.7704C48.1201 54.0904 49.3401 53.1004 50.3001 51.8804L50.8201 55.3303H57.9101V26.3403H49.6101V42.7103H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.3403H62.28V55.3503H70.58V26.3403Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.4706C91.6001 26.7406 89.0201 25.8706 86.4001 26.0206C78.5001 26.0206 73.8301 32.2806 73.8301 40.9406C73.8301 49.6006 78.5001 55.8606 86.4001 55.8606C88.0801 55.9706 89.7601 55.6306 91.2701 54.8706C92.7801 54.1106 94.0701 52.9605 95.0101 51.5305L95.2101 55.3506H101.94V12.8706H93.6401L93.6001 28.4706H93.6101ZM88.2101 49.0106C84.2801 49.0106 81.9601 45.8106 81.9601 40.8306C81.9601 35.8506 84.2801 32.6505 88.2101 32.6505C92.1401 32.6505 94.4601 35.8506 94.4601 40.8306C94.4601 45.8106 92.1401 49.0106 88.2101 49.0106Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.1804C65.5099 12.1804 64.6199 12.4605 63.8599 12.9705C63.0999 13.4905 62.5099 14.2205 62.1599 15.0905C61.8099 15.9505 61.7199 16.9004 61.8999 17.8104C62.0799 18.7204 62.5199 19.5605 63.1699 20.2205C63.8199 20.8805 64.6399 21.3305 65.5399 21.5105C66.4399 21.6905 67.3699 21.6005 68.2099 21.2405C69.0599 20.8805 69.7799 20.2805 70.2899 19.5005C70.7999 18.7205 71.0699 17.8105 71.0699 16.8805C71.0699 15.6305 70.5799 14.4304 69.7099 13.5504C68.8399 12.6704 67.6599 12.1704 66.4399 12.1704L66.4299 12.1804Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.3403H149.84V55.3503H158.14V26.3403Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.1804C153.08 12.1804 152.19 12.4605 151.43 12.9705C150.67 13.4905 150.08 14.2205 149.72 15.0905C149.37 15.9505 149.28 16.9004 149.46 17.8104C149.64 18.7204 150.08 19.5605 150.73 20.2205C151.38 20.8805 152.2 21.3305 153.1 21.5105C154 21.6905 154.93 21.6005 155.77 21.2405C156.62 20.8805 157.34 20.2805 157.85 19.5005C158.36 18.7205 158.63 17.8105 158.63 16.8805C158.63 15.6305 158.14 14.4304 157.27 13.5504C156.4 12.6704 155.22 12.1704 154 12.1704V12.1804Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.7804V40.9004C218.63 31.9404 213.58 25.9805 205.25 25.9805C196.92 25.9805 191.31 31.9404 191.31 40.9004C191.31 49.8604 196.93 55.8204 205.25 55.8204C211.01 55.8204 215.3 53.0304 217.33 48.3204L211.32 45.4204C210.93 46.6804 210.14 47.7605 209.08 48.5205C208.02 49.2805 206.75 49.6605 205.45 49.6105C203.92 49.6505 202.42 49.1004 201.28 48.0604C200.14 47.0204 199.42 45.5705 199.29 44.0205H199.35L218.63 41.7904V41.7804ZM199.09 38.8505C199.09 34.6405 201.55 31.8805 205.22 31.8805C206.73 31.8505 208.19 32.4204 209.31 33.4504C210.43 34.4904 211.11 35.9204 211.23 37.4504L199.09 38.8505Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.9805C110.47 25.9805 104.85 31.9404 104.85 40.9004C104.85 49.8604 110.47 55.8204 118.8 55.8204C124.55 55.8204 128.84 53.0304 130.82 48.3204L124.81 45.4204C124.42 46.6604 123.65 47.7305 122.61 48.4905C121.57 49.2405 120.32 49.6405 119.05 49.6105C117.5 49.6805 115.99 49.1305 114.83 48.0905C113.67 47.0505 112.94 45.5905 112.81 44.0205L132.05 41.7705V40.8905C132.17 31.9505 127.12 25.9905 118.8 25.9905V25.9805ZM112.61 38.8605C112.61 34.6505 115.02 31.8905 118.75 31.8905C120.26 31.8605 121.72 32.4304 122.84 33.4604C123.96 34.5004 124.64 35.9304 124.76 37.4604L112.6 38.8605H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.6204V12.8804H134.99V47.4803C134.99 51.5003 135.78 55.6903 142.81 55.6903C144.14 55.7603 145.47 55.5403 146.71 55.0303V48.5503C146.71 48.5503 143.29 49.4304 143.29 46.6204Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 62.9905H33.04V75.7205H0.25V81.5604H38.77V68.8204H218.65V62.9905Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M291.59 33.8203H294.63C296.5 33.8203 298.5 34.1903 298.5 36.4203C298.5 38.3603 297.32 39.6903 293.74 39.6903H290.33L291.59 33.8203ZM278.21 55.3804H287.03L288.86 46.6104H294.88C302.52 46.6104 307.44 41.5603 307.44 35.7203C307.44 29.3003 303.99 26.3604 298.66 26.3604H284.26L278.21 55.3804Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M318.27 36.3203H318.35L319.33 45.0204H313.76L318.28 36.3203H318.27ZM299.17 55.3804H308.28L310.52 51.2404H319.99L320.48 55.3804H329.27L324.75 26.3604H315.98L299.19 55.3804H299.17Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M332.87 44.7303L326.65 26.3604H335.62L338.39 37.1803L345.46 26.3604H355.95L341.81 44.6503L339.61 55.3804H330.67L332.87 44.7303Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M377.29 44.3605C376.75 47.3205 374.49 56.0704 362.41 56.0704C354 56.0704 349.94 50.6205 349.94 42.8605C349.94 33.4805 355.79 25.6604 365.67 25.6604C372.13 25.6604 377.9 28.4804 378.07 37.1704H369.62C369.71 34.4504 368.39 32.9004 365.64 32.9004C360.67 32.9004 358.88 38.5904 358.88 42.6904C358.88 45.0904 359.46 48.8104 363.56 48.8104C366.37 48.8104 367.95 46.9005 368.53 44.3505H377.3L377.29 44.3605Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M382.46 26.3604H391.41L389.3 36.4403H397.47L399.59 26.3604H408.54L402.48 55.3804H393.52L395.93 43.9003H387.75L385.35 55.3804H376.4L382.46 26.3604Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M410.89 26.3704H434.87L433.36 33.8203H418.32L417.55 37.4003H431.49L430.07 44.3203H416.08L415.31 47.9303H430.68L429.13 55.3804H404.83L410.89 26.3604V26.3704Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M441.01 40.0106L434.35 26.3706H444.06L446.88 33.9105L452.65 26.3706H463.26L451.19 40.0106L458.22 55.3806H448.18L444.97 47.2706L438.26 55.3806H427.28L441.02 40.0106H441.01Z", fill: "#004B8D" }), /* @__PURE__ */ React.createElement("path", { d: "M464.41 27.6904C464.41 26.6304 465.21 25.8204 466.23 25.8204C467.25 25.8204 468.05 26.6304 468.05 27.6904C468.05 28.7504 467.25 29.5804 466.23 29.5804C465.21 29.5804 464.41 28.7704 464.41 27.6904ZM464.01 27.6904C464.01 28.9504 465.03 29.9004 466.23 29.9004C467.43 29.9004 468.46 28.9504 468.46 27.6904C468.46 26.4304 467.44 25.4905 466.23 25.4905C465.02 25.4905 464.01 26.4404 464.01 27.6904ZM465.38 28.9905H465.78V27.8805H466.2L466.91 28.9905H467.33L466.59 27.8505C466.97 27.8105 467.27 27.6104 467.27 27.1504C467.27 26.6504 466.98 26.4104 466.37 26.4104H465.38V29.0005V28.9905ZM465.78 26.7305H466.31C466.58 26.7305 466.87 26.7805 466.87 27.1305C466.87 27.5405 466.55 27.5504 466.19 27.5504H465.78V26.7305Z", fill: "#004B8D" }));
const SvgPaycom = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 506, height: 82, viewBox: "0 0 506 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.560303H247.93V81.9202H248.93V0.560303Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.9602C19.58 28.0202 16.72 26.3403 12.52 26.3403C4.66 26.3903 0 32.6403 0 41.3103C0 49.9803 4.65 56.2302 12.52 56.2302C13.96 56.3102 15.41 56.0602 16.75 55.5002C18.09 54.9402 19.29 54.0802 20.26 52.9902V57.1602C20.26 60.0002 18.76 63.3704 14 63.3704C10.39 63.3704 8.61 61.3502 7.99 59.1802L1.6 62.2703C3.2 66.3703 7.02 69.8103 14.44 69.8103C25.44 69.8103 28.27 62.3904 28.27 55.8904V26.7502H21.54L21.36 30.9502L21.35 30.9602ZM14.24 49.4302C10.31 49.4302 7.99 46.2302 7.99 41.2502C7.99 36.2702 10.31 33.0703 14.24 33.0703C18.17 33.0703 20.44 36.2702 20.44 41.2502C20.44 46.2302 18.17 49.4302 14.24 49.4302Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.3003C176.63 26.3003 175.11 26.6403 173.73 27.3203C172.34 28.0003 171.12 28.9802 170.16 30.2102L169.64 26.7703H162.53V55.7803H170.83V39.4001C170.83 34.8701 172.51 33.1003 175.84 33.1003C178.16 33.1003 180.08 34.1303 180.08 38.5503V55.7903H188.38V36.8604C188.38 30.7304 184.58 26.3103 178.16 26.3103L178.17 26.3003Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.1304C49.6201 47.1104 47.9401 49.4302 44.6201 49.4302C42.3001 49.4302 40.3601 48.4002 40.3601 43.9802V26.7603H32.0601V45.6501C32.0601 51.7701 35.8601 56.2202 42.2801 56.2202C43.8201 56.2202 45.3401 55.8702 46.7301 55.1902C48.1201 54.5102 49.3401 53.5203 50.3001 52.3003L50.8201 55.7502H57.9101V26.7603H49.6101V43.1304H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.7603H62.28V55.7703H70.58V26.7603Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.8904C91.6001 27.1604 89.0201 26.2902 86.4001 26.4402C78.5001 26.4402 73.8301 32.7004 73.8301 41.3604C73.8301 50.0204 78.5001 56.2803 86.4001 56.2803C88.0801 56.3903 89.7601 56.0503 91.2701 55.2903C92.7801 54.5303 94.0701 53.3802 95.0101 51.9502L95.2101 55.7703H101.94V13.2903H93.6401L93.6001 28.8904H93.6101ZM88.2101 49.4302C84.2801 49.4302 81.9601 46.2302 81.9601 41.2502C81.9601 36.2702 84.2801 33.0703 88.2101 33.0703C92.1401 33.0703 94.4601 36.2702 94.4601 41.2502C94.4601 46.2302 92.1401 49.4302 88.2101 49.4302Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.6001C65.5099 12.6001 64.6199 12.8803 63.8599 13.3903C63.0999 13.9103 62.5099 14.6401 62.1599 15.5101C61.8099 16.3701 61.7199 17.3201 61.8999 18.2301C62.0799 19.1401 62.5199 19.9803 63.1699 20.6403C63.8199 21.3003 64.6399 21.7501 65.5399 21.9301C66.4399 22.1101 67.3699 22.02 68.2099 21.66C69.0599 21.3 69.7799 20.7 70.2899 19.92C70.7999 19.14 71.0699 18.2302 71.0699 17.3002C71.0699 16.0502 70.5799 14.8501 69.7099 13.9701C68.8399 13.0901 67.6599 12.5901 66.4399 12.5901L66.4299 12.6001Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.7603H149.84V55.7703H158.14V26.7603Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.6001C153.08 12.6001 152.19 12.8803 151.43 13.3903C150.67 13.9103 150.08 14.6401 149.72 15.5101C149.37 16.3701 149.28 17.3201 149.46 18.2301C149.64 19.1401 150.08 19.9803 150.73 20.6403C151.38 21.3003 152.2 21.7501 153.1 21.9301C154 22.1101 154.93 22.02 155.77 21.66C156.62 21.3 157.34 20.7 157.85 19.92C158.36 19.14 158.63 18.2302 158.63 17.3002C158.63 16.0502 158.14 14.8501 157.27 13.9701C156.4 13.0901 155.22 12.5901 154 12.5901V12.6001Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.2002V41.3203C218.63 32.3603 213.58 26.4001 205.25 26.4001C196.92 26.4001 191.31 32.3603 191.31 41.3203C191.31 50.2803 196.93 56.2402 205.25 56.2402C211.01 56.2402 215.3 53.4502 217.33 48.7402L211.32 45.8403C210.93 47.1003 210.14 48.1802 209.08 48.9402C208.02 49.7002 206.75 50.0803 205.45 50.0303C203.92 50.0703 202.42 49.5202 201.28 48.4802C200.14 47.4402 199.42 45.9902 199.29 44.4402H199.35L218.63 42.2102V42.2002ZM199.09 39.2703C199.09 35.0603 201.55 32.3003 205.22 32.3003C206.73 32.2703 208.19 32.8404 209.31 33.8704C210.43 34.9104 211.11 36.3404 211.23 37.8704L199.09 39.2703Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.4001C110.47 26.4001 104.85 32.3603 104.85 41.3203C104.85 50.2803 110.47 56.2402 118.8 56.2402C124.55 56.2402 128.84 53.4502 130.82 48.7402L124.81 45.8403C124.42 47.0803 123.65 48.1502 122.61 48.9102C121.57 49.6602 120.32 50.0603 119.05 50.0303C117.5 50.1003 115.99 49.5503 114.83 48.5103C113.67 47.4703 112.94 46.0102 112.81 44.4402L132.05 42.1902V41.3103C132.17 32.3703 127.12 26.4102 118.8 26.4102V26.4001ZM112.61 39.2803C112.61 35.0703 115.02 32.3103 118.75 32.3103C120.26 32.2803 121.72 32.8504 122.84 33.8804C123.96 34.9204 124.64 36.3504 124.76 37.8804L112.6 39.2803H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.0403V13.3003H134.99V47.9001C134.99 51.9201 135.78 56.1104 142.81 56.1104C144.14 56.1804 145.47 55.9602 146.71 55.4502V48.9702C146.71 48.9702 143.29 49.8503 143.29 47.0403Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.4001H33.04V76.1304H0.25V81.9702H38.77V69.2302H218.65V63.4001Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M319.02 16.4902C317.27 16.4902 315.85 16.4902 315.85 16.4902C315.85 16.4902 314.42 16.4902 312.68 16.4902H281.39C279.65 16.4902 278.22 17.9202 278.22 19.6602V62.9702C278.22 64.7202 279.65 66.1404 281.39 66.1404H288.07C289.82 66.1404 291.24 64.7102 291.24 62.9702V32.6902C291.24 30.9402 292.67 29.5203 294.41 29.5203H311.66C313.41 29.5203 314.83 30.9502 314.83 32.6902V49.8904C314.83 51.6404 313.4 53.0603 311.66 53.0603H301.73C299.98 53.0603 298.56 54.4902 298.56 56.2302V62.9202C298.56 64.6602 299.99 66.0903 301.73 66.0903H311.66C313.41 66.0903 314.83 66.0903 314.83 66.0903H324.69C326.43 66.0903 327.86 64.6602 327.86 62.9202V19.6501C327.86 17.9101 326.43 16.4802 324.69 16.4802H319.01L319.02 16.4902Z", fill: "url(#paint0_linear_8135_21229)" }), /* @__PURE__ */ React.createElement("path", { d: "M338.93 37.5803H343.23V40.3303H343.33C344.52 38.8803 347.29 37.1204 351.6 37.1204C358.67 37.1204 362.11 41.7502 362.11 46.9802C362.11 52.2102 359 57.5303 351.65 57.5303C347.35 57.5303 344.91 56.1901 343.53 54.4001H343.44V65.1003H338.95V37.5803H338.93ZM350.64 40.0303C345.77 40.0303 343.42 43.7404 343.42 47.3704C343.42 50.6204 345.52 54.6304 350.59 54.6304C355.66 54.6304 357.42 50.3103 357.33 47.2603C357.43 43.7403 355.51 40.0303 350.64 40.0303Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M367.69 38.9602C369.94 37.8902 372.61 37.1204 375.72 37.1204C382.7 37.1204 385.52 39.8702 385.52 45.1902V53.2603C385.52 55.4803 385.62 56.5103 385.71 57.0803H381.51V54.5603H381.41C380.36 55.7403 377.97 57.5403 373.86 57.5403C368.61 57.5403 364.92 55.7102 364.92 51.4602C364.92 46.5702 371.61 45.0403 376.24 45.0403C378.01 45.0403 379.25 45.0404 381.02 45.1204C381.02 41.7604 379.49 40.0403 375 40.0403C372.47 40.0403 369.74 40.8003 367.93 42.0303L367.69 38.9702V38.9602ZM381.02 47.7903C380.06 47.7903 379.11 47.7102 378.15 47.7102C375.71 47.7102 369.69 48.0202 369.69 51.4602C369.69 53.5202 372.18 54.6304 374.23 54.6304C378.67 54.6304 381.01 52.4103 381.01 49.5103V47.7903H381.02Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M389.72 62.3503C390.29 62.5003 391.06 62.6602 391.82 62.6602C395.83 62.6602 397.17 58.2203 397.17 57.8403C397.17 57.4203 396.6 56.4303 396.31 55.7803L388.04 37.5803H392.96L399.51 53.7102H399.61L406.3 37.5803H410.84L401.86 57.5002C400.19 61.2502 398.42 65.5703 392.5 65.5703C391.06 65.5703 390.25 65.4203 389.44 65.3003L389.72 62.3503Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M429.33 40.8704C427.61 40.3004 425.89 40.0303 424.46 40.0303C419.44 40.0303 416.63 43.6203 416.63 47.3303C416.63 50.8103 418.97 54.6304 424.75 54.6304C426.27 54.6304 428.19 54.2503 429.57 53.5203L429.9 56.7302C428.04 57.4202 425.89 57.5303 424.27 57.5303C416.91 57.5303 411.85 52.9103 411.85 47.3303C411.85 41.4003 416.82 37.1204 424.27 37.1204C426.08 37.1204 428.42 37.4604 429.71 37.8904L429.33 40.8704Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M444.29 37.1204C451.7 37.1204 456.67 41.4003 456.67 47.3303C456.67 52.9103 451.61 57.5303 444.29 57.5303C436.97 57.5303 431.87 52.9103 431.87 47.3303C431.87 41.4003 436.84 37.1204 444.29 37.1204ZM444.29 54.6304C449.55 54.6304 451.89 50.8103 451.89 47.3303C451.89 43.6203 449.07 40.0303 444.29 40.0303C439.51 40.0303 436.65 43.6203 436.65 47.3303C436.65 50.8103 438.99 54.6304 444.29 54.6304Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M461.06 37.5803H465.27V40.4102H465.37C467.09 38.1502 469.53 37.1204 473.11 37.1204C475.93 37.1204 478.75 38.2701 480.04 40.9001C481.71 38.1101 485.39 37.1204 487.59 37.1204C493.8 37.1204 496.05 40.3303 496.05 44.5803V57.0803H491.56V45.4602C491.56 43.0502 490.85 40.0303 487.21 40.0303C482.62 40.0303 480.81 43.6203 480.81 47.2603V57.0803H476.32V45.4602C476.32 43.0502 475.6 40.0303 471.97 40.0303C467.38 40.0303 465.56 43.6203 465.56 47.2603V57.0803H461.07V37.5903L461.06 37.5803Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("path", { d: "M498.55 40.9702C498.55 39.1502 500.03 37.6602 501.86 37.6602C503.69 37.6602 505.17 39.1402 505.17 40.9702C505.17 42.8002 503.69 44.2803 501.86 44.2803C500.03 44.2803 498.55 42.8002 498.55 40.9702ZM504.36 40.9702C504.36 39.4202 503.24 38.3103 501.86 38.3103C500.48 38.3103 499.36 39.4302 499.36 40.9702C499.36 42.5102 500.48 43.6404 501.86 43.6404C503.24 43.6404 504.36 42.5202 504.36 40.9702ZM500.58 39.0803H501.97C502.87 39.0803 503.35 39.3902 503.35 40.1802C503.35 40.8202 502.98 41.1302 502.37 41.1902L503.38 42.8303H502.67L501.7 41.2202H501.29V42.8303H500.59V39.0903L500.58 39.0803ZM501.28 40.6802H501.89C502.3 40.6802 502.66 40.6204 502.66 40.1204C502.66 39.6804 502.26 39.6104 501.9 39.6104H501.28V40.6802Z", fill: "#0B0204" }), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_8135_21229", x1: 280.86, y1: 21.8302, x2: 322.02, y2: 57.9902, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#A2CE60" }), /* @__PURE__ */ React.createElement("stop", { offset: 0.7, stopColor: "#008E4C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#006242" }))));
const SvgPaycor = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 431, height: 83, viewBox: "0 0 431 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.970215H247.93V82.3303H248.93V0.970215Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.3704C19.58 28.4304 16.72 26.7502 12.52 26.7502C4.66 26.8002 0 33.0502 0 41.7202C0 50.3902 4.65 56.6404 12.52 56.6404C13.96 56.7204 15.41 56.4704 16.75 55.9104C18.09 55.3504 19.29 54.4904 20.26 53.4004V57.5703C20.26 60.4103 18.76 63.7803 14 63.7803C10.39 63.7803 8.61 61.7603 7.99 59.5903L1.6 62.6804C3.2 66.7804 7.02 70.2202 14.44 70.2202C25.44 70.2202 28.27 62.8003 28.27 56.3003V27.1604H21.54L21.36 31.3604L21.35 31.3704ZM14.24 49.8403C10.31 49.8403 7.99 46.6404 7.99 41.6604C7.99 36.6804 10.31 33.4802 14.24 33.4802C18.17 33.4802 20.44 36.6804 20.44 41.6604C20.44 46.6404 18.17 49.8403 14.24 49.8403Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.7002C176.63 26.7002 175.11 27.0402 173.73 27.7202C172.34 28.4002 171.12 29.3804 170.16 30.6104L169.64 27.1704H162.53V56.1804H170.83V39.8003C170.83 35.2703 172.51 33.5002 175.84 33.5002C178.16 33.5002 180.08 34.5302 180.08 38.9502V56.1904H188.38V37.2603C188.38 31.1303 184.58 26.7102 178.16 26.7102L178.17 26.7002Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.5403C49.6201 47.5203 47.9401 49.8403 44.6201 49.8403C42.3001 49.8403 40.3601 48.8104 40.3601 44.3904V27.1704H32.0601V46.0603C32.0601 52.1803 35.8601 56.6304 42.2801 56.6304C43.8201 56.6304 45.3401 56.2803 46.7301 55.6003C48.1201 54.9203 49.3401 53.9302 50.3001 52.7102L50.8201 56.1604H57.9101V27.1704H49.6101V43.5403H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 27.1704H62.28V56.1804H70.58V27.1704Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.3003C91.6001 27.5703 89.0201 26.7003 86.4001 26.8503C78.5001 26.8503 73.8301 33.1103 73.8301 41.7703C73.8301 50.4303 78.5001 56.6904 86.4001 56.6904C88.0801 56.8004 89.7601 56.4602 91.2701 55.7002C92.7801 54.9402 94.0701 53.7904 95.0101 52.3604L95.2101 56.1804H101.94V13.7002H93.6401L93.6001 29.3003H93.6101ZM88.2101 49.8403C84.2801 49.8403 81.9601 46.6404 81.9601 41.6604C81.9601 36.6804 84.2801 33.4802 88.2101 33.4802C92.1401 33.4802 94.4601 36.6804 94.4601 41.6604C94.4601 46.6404 92.1401 49.8403 88.2101 49.8403Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 13.0103C65.5099 13.0103 64.6199 13.2903 63.8599 13.8003C63.0999 14.3203 62.5099 15.0504 62.1599 15.9204C61.8099 16.7804 61.7199 17.7304 61.8999 18.6404C62.0799 19.5504 62.5199 20.3903 63.1699 21.0503C63.8199 21.7103 64.6399 22.1603 65.5399 22.3403C66.4399 22.5203 67.3699 22.4303 68.2099 22.0703C69.0599 21.7103 69.7799 21.1103 70.2899 20.3303C70.7999 19.5503 71.0699 18.6402 71.0699 17.7102C71.0699 16.4602 70.5799 15.2604 69.7099 14.3804C68.8399 13.5004 67.6599 13.0002 66.4399 13.0002L66.4299 13.0103Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 27.1704H149.84V56.1804H158.14V27.1704Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 13.0103C153.08 13.0103 152.19 13.2903 151.43 13.8003C150.67 14.3203 150.08 15.0504 149.72 15.9204C149.37 16.7804 149.28 17.7304 149.46 18.6404C149.64 19.5504 150.08 20.3903 150.73 21.0503C151.38 21.7103 152.2 22.1603 153.1 22.3403C154 22.5203 154.93 22.4303 155.77 22.0703C156.62 21.7103 157.34 21.1103 157.85 20.3303C158.36 19.5503 158.63 18.6402 158.63 17.7102C158.63 16.4602 158.14 15.2604 157.27 14.3804C156.4 13.5004 155.22 13.0002 154 13.0002V13.0103Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.6104V41.7302C218.63 32.7702 213.58 26.8103 205.25 26.8103C196.92 26.8103 191.31 32.7702 191.31 41.7302C191.31 50.6902 196.93 56.6504 205.25 56.6504C211.01 56.6504 215.3 53.8604 217.33 49.1504L211.32 46.2502C210.93 47.5102 210.14 48.5903 209.08 49.3503C208.02 50.1103 206.75 50.4904 205.45 50.4404C203.92 50.4804 202.42 49.9304 201.28 48.8904C200.14 47.8504 199.42 46.4003 199.29 44.8503H199.35L218.63 42.6204V42.6104ZM199.09 39.6804C199.09 35.4704 201.55 32.7102 205.22 32.7102C206.73 32.6802 208.19 33.2503 209.31 34.2803C210.43 35.3203 211.11 36.7503 211.23 38.2803L199.09 39.6804Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.8003C110.47 26.8003 104.85 32.7602 104.85 41.7202C104.85 50.6802 110.47 56.6404 118.8 56.6404C124.55 56.6404 128.84 53.8504 130.82 49.1404L124.81 46.2402C124.42 47.4802 123.65 48.5503 122.61 49.3103C121.57 50.0603 120.32 50.4604 119.05 50.4304C117.5 50.5004 115.99 49.9504 114.83 48.9104C113.67 47.8704 112.94 46.4103 112.81 44.8403L132.05 42.5903V41.7102C132.17 32.7702 127.12 26.8103 118.8 26.8103V26.8003ZM112.61 39.6804C112.61 35.4704 115.02 32.7102 118.75 32.7102C120.26 32.6802 121.72 33.2503 122.84 34.2803C123.96 35.3203 124.64 36.7503 124.76 38.2803L112.6 39.6804H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.4404V13.7002H134.99V48.3003C134.99 52.3203 135.78 56.5103 142.81 56.5103C144.14 56.5803 145.47 56.3603 146.71 55.8503V49.3704C146.71 49.3704 143.29 50.2504 143.29 47.4404Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.8103H33.04V76.5403H0.25V82.3804H38.77V69.6404H218.65V63.8103Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M303.17 40.8303C304.66 39.3203 305.49 37.2704 305.45 35.1404C305.49 33.3404 304.81 31.5903 303.56 30.3003C300.84 27.5803 296.11 27.1804 290.46 27.1804H278.21V55.7102C278.21 55.9802 278.43 56.2002 278.7 56.2002H284.9V44.4502C284.9 44.4502 287.72 44.5203 289.5 44.5203C293.99 44.5203 299.73 44.3403 303.18 40.8403L303.17 40.8303ZM284.89 42.2402V29.4404C286.03 29.3404 287.18 29.3003 288.33 29.3303C291.96 29.3303 298.66 29.8203 298.66 35.5803C298.66 41.3403 292.45 42.3203 287.88 42.3203C286.11 42.3203 284.88 42.2402 284.88 42.2402H284.89Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M430.49 37.2903C430.49 37.0103 430.49 36.8204 430.13 36.6904C428.64 36.2204 427.07 36.0103 425.51 36.0803C422.78 36.1003 420.07 36.5303 417.47 37.3403V36.8603C417.47 36.5903 417.25 36.3703 416.98 36.3703H410.77V55.7102C410.77 55.9802 410.98 56.2002 411.24 56.2002H417.45V44.1904C417.45 40.5604 420.94 39.0603 424.59 39.0603C426.6 39.0903 428.6 39.4802 430.48 40.2002V37.3003L430.49 37.2903Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M316.95 35.7102C311.66 35.7102 308.34 37.0702 307.48 37.4902C307.26 37.5902 307.12 37.8103 307.11 38.0603V40.9602C309.49 39.5302 312.21 38.7803 314.98 38.7703C316.66 38.7003 318.3 39.2904 319.53 40.4304C320.32 41.2304 320.71 42.2002 320.71 44.2102C320.71 44.2102 317.69 43.9802 315.32 43.9802C311.02 43.9802 302.8 44.7603 302.8 50.5903C302.8 53.3603 304.89 56.3904 311.59 56.3904C314.7 56.3504 317.78 55.7902 320.7 54.7402V55.7102C320.7 55.9802 320.92 56.2002 321.19 56.2002H327.39V43.1204C327.39 38.3004 324.33 35.7202 316.95 35.7202V35.7102ZM320.75 52.3003C318.96 53.1503 317 53.6004 315.02 53.6404C312.14 53.6404 309.72 52.6502 309.72 49.9602C309.72 47.0102 312.3 46.0303 318.33 46.0303C319.54 46.0303 320.76 46.0803 320.76 46.0803V52.3003H320.75Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M350.57 36.3604C350.3 36.3604 350.06 36.5203 349.94 36.7703L342.1 51.4204C342.1 51.4204 334.46 37.1603 334.22 36.7703C334.1 36.5303 333.85 36.3904 333.58 36.4004H328.13L339.17 56.8103L333.88 66.4104H339.61C339.94 66.4304 340.24 66.2602 340.38 65.9602L356.53 36.3704H350.56L350.57 36.3604Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M353.67 23.3804C355.12 24.2404 355.67 26.0803 354.93 27.5903L352.67 31.7402C352.61 31.9502 352.72 32.1702 352.93 32.2402C352.99 32.2602 353.05 32.2602 353.11 32.2502L371.47 26.6504C371.99 26.4604 372.34 25.9604 372.33 25.4104C372.33 24.8304 371.95 24.3204 371.4 24.1504L339.02 14.1504C339.02 14.1504 338.92 14.1504 338.87 14.1504C338.62 14.1504 338.42 14.3503 338.42 14.6003C338.42 14.7503 338.5 14.9002 338.64 14.9702L353.68 23.3704L353.67 23.3804Z", fill: "#F37322" }), /* @__PURE__ */ React.createElement("path", { d: "M393.76 35.7102C384.46 35.7102 380.25 40.8804 380.25 46.3704C380.25 51.8604 384.55 56.9304 393.96 56.9304C403.37 56.9304 408.09 52.2803 408.09 46.3103C408.09 40.0203 402.9 35.7102 393.75 35.7102H393.76ZM394.24 54.1604C390.23 54.1604 387.01 50.6403 387.01 46.2703C387.01 41.9003 389.87 38.5703 394.3 38.5703C398.73 38.5703 401.35 42.8102 401.35 46.4702C401.35 50.3502 398.93 54.1704 394.24 54.1704V54.1504V54.1604Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M378.34 51.3704C375.92 52.7704 373.19 53.5303 370.39 53.5703C365.84 53.5703 362.34 50.8303 362.34 46.3203C362.34 41.8103 365.83 38.5603 370.99 38.5603C373.47 38.5303 375.89 39.2504 377.95 40.6504L379.27 38.3103C379.37 38.1003 379.28 37.8502 379.07 37.7502H379.06C377.89 37.2202 374.89 35.7102 369.11 35.7102C359.81 35.7102 355.6 40.8804 355.6 46.3704C355.6 51.8604 359.9 56.9304 369.32 56.9304C372.8 56.9304 376.21 55.9503 379.16 54.0903C379.38 53.9903 379.47 53.7303 379.37 53.5103V53.4802L378.34 51.3704Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M422.71 53.5603C422.71 53.0903 422.43 52.9104 421.85 52.9104H420.99V55.1804H421.36V54.2102H421.71L422.3 55.1804H422.72L422.08 54.1804C422.4 54.2104 422.68 53.9804 422.71 53.6604C422.71 53.6304 422.71 53.6003 422.71 53.5703V53.5603ZM421.39 53.8904V53.2302H421.84C422.06 53.2302 422.34 53.2303 422.34 53.5303C422.34 53.8303 422.09 53.8904 421.81 53.8904H421.39Z", fill: "#6D6E71" }), /* @__PURE__ */ React.createElement("path", { d: "M421.8 51.9503C420.67 51.9303 419.73 52.8303 419.71 53.9603C419.69 55.0903 420.58 56.0304 421.72 56.0504C422.85 56.0704 423.79 55.1704 423.81 54.0404V54.0003C423.84 52.9003 422.98 51.9803 421.88 51.9503C421.85 51.9503 421.83 51.9503 421.8 51.9503ZM421.8 55.7003C420.86 55.5403 420.24 54.6403 420.4 53.7003C420.53 52.9803 421.08 52.4204 421.8 52.3004C422.74 52.4604 423.36 53.3604 423.2 54.3004C423.07 55.0204 422.52 55.5803 421.8 55.7003Z", fill: "#6D6E71" }));
const SvgPaylocity = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 511, height: 82, viewBox: "0 0 511 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8137_21253)" }, /* @__PURE__ */ React.createElement("path", { d: "M248.92 0.380371H247.92V81.7404H248.92V0.380371Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.34 30.7804C19.57 27.8404 16.71 26.1604 12.51 26.1604C4.64999 26.2104 -0.0100098 32.4604 -0.0100098 41.1304C-0.0100098 49.8004 4.63999 56.0504 12.51 56.0504C13.95 56.1304 15.4 55.8804 16.74 55.3204C18.08 54.7604 19.28 53.9004 20.25 52.8104V56.9804C20.25 59.8204 18.75 63.1904 13.99 63.1904C10.38 63.1904 8.59999 61.1704 7.97999 59.0004L1.58999 62.0904C3.18999 66.1904 7.00999 69.6304 14.43 69.6304C25.43 69.6304 28.26 62.2104 28.26 55.7104V26.5804H21.53L21.35 30.7804H21.34ZM14.23 49.2504C10.3 49.2504 7.97999 46.0504 7.97999 41.0704C7.97999 36.0904 10.3 32.8904 14.23 32.8904C18.16 32.8904 20.43 36.0904 20.43 41.0704C20.43 46.0504 18.16 49.2504 14.23 49.2504Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.16 26.1104C176.62 26.1104 175.1 26.4504 173.72 27.1304C172.33 27.8104 171.11 28.7904 170.15 30.0204L169.63 26.5804H162.52V55.6004H170.82V39.2204C170.82 34.6904 172.5 32.9204 175.83 32.9204C178.15 32.9204 180.07 33.9504 180.07 38.3704V55.6104H188.37V36.6804C188.37 30.5504 184.57 26.1304 178.15 26.1304L178.16 26.1104Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6101 42.9503C49.6101 46.9303 47.93 49.2603 44.6101 49.2603C42.2901 49.2603 40.35 48.2303 40.35 43.8103V26.5803H32.05V45.4703C32.05 51.5903 35.85 56.0403 42.2701 56.0403C43.8101 56.0403 45.3301 55.6903 46.7201 55.0103C48.1101 54.3303 49.3301 53.3403 50.2901 52.1203L50.8101 55.5703H57.9001V26.5803H49.6V42.9503H49.6101Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.57 26.5803H62.27V55.6003H70.57V26.5803Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6001 28.7104C91.5901 26.9804 89.0101 26.1004 86.3901 26.2604C78.4901 26.2604 73.8201 32.5204 73.8201 41.1804C73.8201 49.8404 78.4901 56.1004 86.3901 56.1004C88.0701 56.2104 89.7501 55.8703 91.2601 55.1104C92.7701 54.3504 94.0601 53.2004 95.0001 51.7704L95.2001 55.5904H101.93V13.1104H93.6301L93.5901 28.7104H93.6001ZM88.2001 49.2504C84.2701 49.2504 81.9501 46.0504 81.9501 41.0704C81.9501 36.0904 84.2701 32.8904 88.2001 32.8904C92.1301 32.8904 94.4501 36.0904 94.4501 41.0704C94.4501 46.0504 92.1301 49.2504 88.2001 49.2504Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4199 12.4104C65.4999 12.4104 64.6099 12.6904 63.8499 13.2004C63.0899 13.7204 62.4999 14.4504 62.1499 15.3204C61.7999 16.1804 61.7099 17.1304 61.8899 18.0404C62.0699 18.9504 62.5099 19.7904 63.1599 20.4504C63.8099 21.1104 64.6299 21.5604 65.5299 21.7404C66.4299 21.9204 67.3599 21.8304 68.1999 21.4704C69.0499 21.1104 69.7699 20.5104 70.2799 19.7304C70.7899 18.9504 71.0599 18.0404 71.0599 17.1104C71.0599 15.8604 70.5699 14.6604 69.6999 13.7804C68.8299 12.9004 67.6499 12.4004 66.4299 12.4004L66.4199 12.4104Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.13 26.5803H149.83V55.6003H158.13V26.5803Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M153.99 12.4104C153.07 12.4104 152.18 12.6904 151.42 13.2004C150.66 13.7204 150.07 14.4504 149.71 15.3204C149.36 16.1804 149.27 17.1304 149.45 18.0404C149.63 18.9504 150.07 19.7904 150.72 20.4504C151.37 21.1104 152.19 21.5604 153.09 21.7404C153.99 21.9204 154.92 21.8304 155.76 21.4704C156.61 21.1104 157.33 20.5104 157.84 19.7304C158.35 18.9504 158.62 18.0404 158.62 17.1104C158.62 15.8604 158.13 14.6604 157.26 13.7804C156.39 12.9004 155.21 12.4004 153.99 12.4004V12.4104Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.62 42.0105V41.1304C218.62 32.1704 213.57 26.2104 205.24 26.2104C196.91 26.2104 191.3 32.1704 191.3 41.1304C191.3 50.0905 196.92 56.0504 205.24 56.0504C211 56.0504 215.29 53.2604 217.32 48.5504L211.31 45.6504C210.92 46.9104 210.13 47.9904 209.07 48.7504C208.01 49.5104 206.74 49.8904 205.44 49.8404C203.91 49.8804 202.41 49.3304 201.27 48.2904C200.13 47.2505 199.41 45.8004 199.28 44.2504H199.34L218.62 42.0204V42.0105ZM199.08 39.0805C199.08 34.8705 201.54 32.1104 205.21 32.1104C206.72 32.0804 208.18 32.6504 209.3 33.6804C210.42 34.7204 211.1 36.1504 211.22 37.6804L199.08 39.0805Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.79 26.2104C110.46 26.2104 104.84 32.1704 104.84 41.1304C104.84 50.0905 110.46 56.0504 118.79 56.0504C124.54 56.0504 128.83 53.2604 130.81 48.5504L124.8 45.6504C124.41 46.8904 123.64 47.9604 122.6 48.7204C121.56 49.4704 120.31 49.8704 119.04 49.8404C117.49 49.9104 115.98 49.3604 114.82 48.3204C113.66 47.2804 112.93 45.8204 112.8 44.2504L132.04 42.0004V41.1205C132.16 32.1805 127.11 26.2204 118.79 26.2204V26.2104ZM112.6 39.0904C112.6 34.8804 115.01 32.1204 118.74 32.1204C120.25 32.0904 121.71 32.6605 122.83 33.6905C123.95 34.7305 124.63 36.1605 124.75 37.6905L112.59 39.0904H112.6Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.28 46.8504V13.1104H134.98V47.7104C134.98 51.7304 135.77 55.9204 142.8 55.9204C144.13 55.9904 145.46 55.7704 146.7 55.2604V48.7804C146.7 48.7804 143.28 49.6604 143.28 46.8504Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 63.2205H33.03V75.9505H0.23999V81.7905H38.76V69.0505H218.64V63.2205Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M509.06 31.9004C508.1 31.9004 507.29 32.6904 507.29 33.6404C507.26 34.6304 508.05 35.4404 509.03 35.4404C510.02 35.4704 510.83 34.6804 510.83 33.7004C510.83 32.7204 510.04 31.9004 509.06 31.9004ZM509.06 35.1904C508.27 35.1904 507.64 34.5504 507.64 33.7704C507.61 32.9604 508.25 32.2904 509.06 32.2904C509.87 32.2604 510.54 32.9004 510.54 33.7104C510.54 34.5204 509.9 35.1904 509.06 35.1904Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M509.73 33.4105V33.3205C509.7 33.0305 509.44 32.8305 509.15 32.8505H508.48V34.5905H508.8V33.9805H509L509.44 34.5905H509.79L509.35 33.9505C509.61 33.8905 509.73 33.7205 509.73 33.4005V33.4105ZM509.15 33.7305H508.8V33.2105H509.15C509.3 33.2105 509.41 33.3305 509.41 33.4705C509.41 33.6105 509.29 33.7305 509.15 33.7305Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M401.73 41.6702L397.83 31.9602H391.23L398.65 48.5002L394.02 59.9602H400.39L411.96 31.9602H405.57L401.73 41.6702Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M419.61 22.0703H413.65V50.7103H419.61V22.0703Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M432.32 31.4602C432.2 31.4602 432.12 31.4602 432 31.4902C426.56 31.2902 422.03 35.5302 421.82 40.9702V41.3202C421.85 46.7302 426.24 51.1202 431.68 51.1202H432C437.44 51.3202 442 47.0802 442.21 41.6102V41.3202C442.18 35.8502 437.76 31.4602 432.32 31.4602ZM436.13 41.0602V41.2902C436.25 43.5302 434.5 45.4502 432.26 45.5602C432.17 45.5602 432.09 45.5602 432 45.5302C429.76 45.5902 427.9 43.7902 427.84 41.5502V41.2602C427.75 39.0202 429.47 37.1002 431.74 36.9902H431.97C434.24 36.9602 436.1 38.7902 436.13 41.0302V41.0602Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M454.13 36.9904H454.51C455.91 37.0204 457.24 37.6904 458.09 38.7904L462.68 35.8804C460.88 33.0904 457.79 31.4304 454.48 31.4604C449.01 31.4604 444.13 35.2704 444.13 41.2304C444.13 47.1904 449.02 51.0604 454.48 51.0604C457.8 51.0904 460.91 49.4304 462.68 46.6404L458.09 43.7304C457.25 44.8604 455.91 45.5304 454.51 45.5304C452.24 45.6504 450.29 43.9004 450.18 41.6304V41.2204C450.12 38.9504 451.9 37.0604 454.13 36.9704V36.9904Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M467.91 22.1903H467.85C465.87 22.1003 464.22 23.6403 464.13 25.6203V25.6503C464.22 27.6303 465.87 29.1703 467.82 29.1103C469.77 29.1403 471.4 27.6003 471.43 25.6503C471.43 23.7303 469.83 22.1603 467.91 22.1903Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M470.79 31.9602H464.83V50.7202H470.79V31.9602Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M500.1 31.9602L496.26 41.6702L492.37 31.9602H482.86V25.2102H476.9V31.9802H473.47V36.4602H476.9V50.7702H482.86V36.4302H487.74L493.15 48.5002L488.53 59.9602H494.9L506.5 31.9602H500.1Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M358.25 31.4902H357.87C355.66 31.4302 353.54 32.3302 352.05 33.9902V31.9802H346.09V59.9802H352.05V48.5802C353.53 50.2102 355.66 51.1102 357.87 51.0202C362.99 50.9602 367.09 46.7702 367.03 41.6602V41.2502C367.29 36.1302 363.37 31.7702 358.25 31.4802V31.4902ZM356.62 45.5402C354.26 45.4802 352.4 43.5602 352.46 41.2102C352.52 38.8502 354.44 36.9902 356.79 37.0502C359.09 37.1102 360.92 38.9702 360.95 41.2702C360.92 43.6502 358.97 45.5402 356.62 45.5402Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M383.58 34.0204C382.1 32.3604 379.97 31.4604 377.74 31.5204C372.62 31.6104 368.55 35.8204 368.64 40.9404V41.3204C368.35 46.4404 372.25 50.8004 377.36 51.0904H377.74C379.95 51.1504 382.07 50.2204 383.58 48.5904V50.7104H389.51V31.9604H383.61L383.58 34.0204ZM379.04 45.5404C376.71 45.4804 374.85 43.5604 374.91 41.2404C374.97 38.9104 376.89 37.0504 379.21 37.1104C381.51 37.1704 383.37 39.0304 383.34 41.3304C383.28 43.6604 381.36 45.5504 379.04 45.5504V45.5404Z", fill: "#323E48" }), /* @__PURE__ */ React.createElement("path", { d: "M316.44 44.0803C315.36 54.8703 312.6 62.7203 307.86 67.0503C307.71 67.1703 307.71 67.4003 307.83 67.5203L307.92 67.6103C309.29 68.0503 310.71 68.2803 312.14 68.2803C321.68 68.2803 329.7 57.9903 332.47 44.1203C332.47 43.9503 332.35 43.8303 332.21 43.8003L316.71 43.8303C316.56 43.8303 316.45 43.9503 316.45 44.0903L316.44 44.0803Z", fill: "url(#paint0_linear_8137_21253)" }), /* @__PURE__ */ React.createElement("path", { d: "M332.49 38.4703V38.4103C329.67 24.4203 321.64 14.3003 312.16 14.3003C309.14 14.3003 299.71 14.3003 296.54 34.8003C296.48 35.1803 296.95 35.3203 297.06 34.9703C298.54 29.9103 301.54 21.7403 305.35 21.7403C308.08 21.7403 311.25 25.9603 314.57 38.5803C314.6 38.7003 314.69 38.7803 314.83 38.8103H332.22C332.39 38.7803 332.51 38.6403 332.48 38.4603L332.49 38.4703Z", fill: "url(#paint1_linear_8137_21253)" }), /* @__PURE__ */ React.createElement("path", { d: "M294.25 38.5602C295.35 27.7702 298.09 19.9202 302.83 15.5902C302.98 15.4402 302.98 15.2402 302.83 15.1002C302.8 15.0702 302.77 15.0402 302.74 15.0402C301.37 14.6002 299.95 14.3702 298.52 14.3702C289.01 14.3402 280.96 24.6302 278.19 38.5102C278.19 38.6802 278.31 38.8002 278.45 38.8302H293.98C294.13 38.8302 294.24 38.7102 294.24 38.5702L294.25 38.5602Z", fill: "url(#paint2_linear_8137_21253)" }), /* @__PURE__ */ React.createElement("path", { d: "M314.14 47.8303C314.2 47.4503 313.73 47.3103 313.62 47.6603C312.14 52.6903 309.14 60.8603 305.33 60.8603C302.6 60.8603 299.43 56.6403 296.11 44.0203C296.08 43.9003 295.99 43.8203 295.85 43.7903L278.46 43.8203C278.31 43.8503 278.2 43.9703 278.2 44.1103V44.2303C280.93 57.7903 288.56 67.7103 297.65 68.3103H299.74C303.55 68.0903 311.32 66.0803 314.14 47.8403V47.8303Z", fill: "url(#paint3_linear_8137_21253)" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("linearGradient", { id: "paint0_linear_8137_21253", x1: 329.781, y1: 56.3403, x2: 279.791, y2: 56.3403, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint1_linear_8137_21253", x1: 281.267, y1: 26.8998, x2: 331.257, y2: 26.8998, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint2_linear_8137_21253", x1: 281.267, y1: 26.8997, x2: 331.257, y2: 26.8997, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("linearGradient", { id: "paint3_linear_8137_21253", x1: 329.781, y1: 56.3403, x2: 279.791, y2: 56.3403, gradientUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("stop", { stopColor: "#FF8F1C" }), /* @__PURE__ */ React.createElement("stop", { offset: 1, stopColor: "#ED2024" })), /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8137_21253" }, /* @__PURE__ */ React.createElement("rect", { width: 510.83, height: 81.41, fill: "white", transform: "translate(0 0.380371)" }))));
const SvgQbo = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 524, height: 83, viewBox: "0 0 524 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.790222H247.93V82.1502H248.93V0.790222Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.1802C19.58 28.2402 16.72 26.5602 12.52 26.5602C4.66 26.6102 0 32.8602 0 41.5302C0 50.2002 4.65 56.4502 12.52 56.4502C13.96 56.5302 15.41 56.2802 16.75 55.7202C18.09 55.1602 19.29 54.3002 20.26 53.2102V57.3802C20.26 60.2202 18.76 63.5902 14 63.5902C10.39 63.5902 8.61 61.5702 7.99 59.4002L1.6 62.4902C3.2 66.5902 7.02 70.0302 14.44 70.0302C25.44 70.0302 28.27 62.6102 28.27 56.1102V26.9702H21.54L21.36 31.1702L21.35 31.1802ZM14.24 49.6502C10.31 49.6502 7.99 46.4502 7.99 41.4702C7.99 36.4902 10.31 33.2902 14.24 33.2902C18.17 33.2902 20.44 36.4902 20.44 41.4702C20.44 46.4502 18.17 49.6502 14.24 49.6502Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.5202C176.63 26.5202 175.11 26.8602 173.73 27.5402C172.34 28.2202 171.12 29.2002 170.16 30.4302L169.64 26.9902H162.53V56.0102H170.83V39.6302C170.83 35.1002 172.51 33.3302 175.84 33.3302C178.16 33.3302 180.08 34.3602 180.08 38.7802V56.0202H188.38V37.0902C188.38 30.9602 184.58 26.5402 178.16 26.5402L178.17 26.5202Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.3502C49.6201 47.3302 47.9401 49.6602 44.6201 49.6602C42.3001 49.6602 40.3601 48.6302 40.3601 44.2102V26.9802H32.0601V45.8702C32.0601 51.9902 35.8601 56.4402 42.2801 56.4402C43.8201 56.4402 45.3401 56.0902 46.7301 55.4102C48.1201 54.7302 49.3401 53.7402 50.3001 52.5202L50.8201 55.9702H57.9101V26.9802H49.6101V43.3502H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.9802H62.28V56.0002H70.58V26.9802Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.1102C91.6001 27.3802 89.0201 26.5002 86.3901 26.6602C78.4901 26.6602 73.8201 32.9202 73.8201 41.5802C73.8201 50.2402 78.4901 56.5003 86.3901 56.5003C88.0701 56.6103 89.7501 56.2703 91.2601 55.5103C92.7701 54.7503 94.0601 53.6003 95.0001 52.1703L95.2001 55.9902H101.93V13.5103H93.6301L93.5901 29.1102H93.6101ZM88.2101 49.6503C84.2801 49.6503 81.9601 46.4502 81.9601 41.4702C81.9601 36.4902 84.2801 33.2903 88.2101 33.2903C92.1401 33.2903 94.4601 36.4902 94.4601 41.4702C94.4601 46.4502 92.1401 49.6503 88.2101 49.6503Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4399 12.8202C65.5199 12.8202 64.6299 13.1002 63.8699 13.6102C63.1099 14.1302 62.5199 14.8602 62.1599 15.7302C61.8099 16.5902 61.7199 17.5402 61.8999 18.4502C62.0799 19.3602 62.5199 20.2002 63.1699 20.8602C63.8199 21.5202 64.6399 21.9702 65.5399 22.1502C66.4399 22.3302 67.3699 22.2402 68.2099 21.8802C69.0599 21.5202 69.7799 20.9202 70.2899 20.1402C70.7999 19.3602 71.0699 18.4502 71.0699 17.5202C71.0699 16.2702 70.5799 15.0702 69.7099 14.1902C68.8399 13.3102 67.6599 12.8102 66.4399 12.8102V12.8202Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.15 26.9802H149.85V56.0002H158.15V26.9802Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.8202C153.08 12.8202 152.19 13.1002 151.43 13.6102C150.67 14.1302 150.08 14.8602 149.72 15.7302C149.37 16.5902 149.28 17.5402 149.46 18.4502C149.64 19.3602 150.08 20.2002 150.73 20.8602C151.38 21.5202 152.2 21.9702 153.1 22.1502C154 22.3302 154.93 22.2402 155.77 21.8802C156.62 21.5202 157.34 20.9202 157.85 20.1402C158.36 19.3602 158.63 18.4502 158.63 17.5202C158.63 16.2702 158.14 15.0702 157.27 14.1902C156.4 13.3102 155.22 12.8102 154 12.8102V12.8202Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 42.4202V41.5402C218.64 32.5802 213.59 26.6202 205.26 26.6202C196.93 26.6202 191.32 32.5802 191.32 41.5402C191.32 50.5002 196.94 56.4602 205.26 56.4602C211.02 56.4602 215.31 53.6702 217.35 48.9602L211.34 46.0602C210.95 47.3202 210.16 48.4002 209.1 49.1602C208.04 49.9202 206.77 50.3002 205.47 50.2502C203.94 50.2902 202.44 49.7402 201.3 48.7002C200.16 47.6602 199.44 46.2102 199.31 44.6602H199.37L218.65 42.4302L218.64 42.4202ZM199.1 39.4902C199.1 35.2802 201.57 32.5202 205.23 32.5202C206.74 32.4902 208.2 33.0602 209.32 34.0902C210.44 35.1302 211.12 36.5602 211.24 38.0902L199.1 39.4902Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.6202C110.47 26.6202 104.85 32.5802 104.85 41.5402C104.85 50.5002 110.47 56.4602 118.8 56.4602C124.55 56.4602 128.84 53.6702 130.82 48.9602L124.81 46.0602C124.42 47.3002 123.65 48.3702 122.61 49.1302C121.57 49.8802 120.32 50.2802 119.05 50.2502C117.5 50.3202 115.99 49.7702 114.83 48.7302C113.67 47.6902 112.94 46.2302 112.81 44.6602L132.05 42.4102V41.5302C132.17 32.5902 127.12 26.6302 118.8 26.6302V26.6202ZM112.61 39.5002C112.61 35.2902 115.02 32.5302 118.75 32.5302C120.26 32.5002 121.72 33.0702 122.84 34.1002C123.96 35.1402 124.64 36.5702 124.76 38.1002L112.6 39.5002H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.3 47.2602V13.5202H135V48.1202C135 52.1402 135.79 56.3302 142.82 56.3302C144.15 56.4002 145.48 56.1802 146.72 55.6702V49.1902C146.72 49.1902 143.3 50.0702 143.3 47.2602Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.66 63.6302H33.04V76.3602H0.25V82.2002H38.77V69.4602H218.66V63.6302Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_8135_21218)" }, /* @__PURE__ */ React.createElement("path", { d: "M306.066 66.2725C321.566 66.2725 334.132 53.7069 334.132 38.2066C334.132 22.7062 321.566 10.1407 306.066 10.1407C290.566 10.1407 278 22.7062 278 38.2066C278 53.7069 290.566 66.2725 306.066 66.2725Z", fill: "#2CA01C" }), /* @__PURE__ */ React.createElement("path", { d: "M296.711 27.2921C290.68 27.2921 285.796 32.1818 285.796 38.2066C285.796 44.2377 290.68 49.1212 296.711 49.1212C297.228 49.1212 297.752 49.1212 298.27 49.1212V45.0672H296.711C292.925 45.0672 289.85 41.9924 289.85 38.2066C289.85 34.4209 292.925 31.3461 296.711 31.3461H300.459C300.459 31.3461 300.459 52.1523 300.459 52.5514C300.459 54.7905 302.274 56.6053 304.513 56.6053V27.2921C304.513 27.2921 300.316 27.2921 296.711 27.2921Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M315.427 49.1212C321.458 49.1212 326.342 44.2315 326.342 38.2066C326.342 32.1756 321.458 27.2921 315.427 27.2921C314.91 27.2921 314.386 27.2921 313.868 27.2921V31.3461H315.427C319.213 31.3461 322.288 34.4209 322.288 38.2066C322.288 41.9924 319.213 45.0672 315.427 45.0672H311.679C311.679 45.0672 311.679 24.261 311.679 23.8618C311.679 21.6228 309.864 19.8079 307.625 19.8079V49.1212C307.625 49.1212 311.822 49.1212 315.427 49.1212Z", fill: "white" }), /* @__PURE__ */ React.createElement("path", { d: "M360.782 73.0832H356.441V62.0876H356.366C355.244 63.8215 353.036 64.9067 350.616 64.9067C345.333 64.9067 342.078 60.7093 342.078 55.6449C342.078 50.5058 345.552 46.5267 350.504 46.5267C353.684 46.5267 355.643 48.0796 356.51 49.458H356.616V47.0318H360.776V73.0832H360.782ZM351.489 61.2893C354.67 61.2893 356.591 58.4329 356.591 55.7197C356.591 53.0067 354.676 50.0754 351.489 50.0754C348.127 50.0754 346.5 52.9319 346.5 55.6449C346.493 58.358 348.121 61.2893 351.489 61.2893Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M380.278 64.4015H376.156V61.6136H376.081C375.32 63.3474 373.262 64.9067 370.692 64.9067C366.171 64.9067 364.287 61.4327 364.287 57.8902V47.0381H368.628V56.6616C368.628 58.726 369.096 61.2893 371.884 61.2893C374.634 61.2893 375.938 58.9005 375.938 56.5867V47.0381H380.278V64.4015Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M384.632 46.6576H388.973V64.021H384.632V46.6576Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M405.214 51.8466C404.528 50.8675 403.044 50.1439 401.634 50.1439C398.453 50.1439 396.856 53.0005 396.856 55.7135C396.856 58.4265 398.485 61.2831 401.777 61.2831C403.118 61.2831 404.596 60.7404 405.432 59.7301L408.145 62.4806C406.697 64.0335 404.309 64.9067 401.74 64.9067C396.6 64.9067 392.334 61.5076 392.334 55.7198C392.334 50.0753 396.532 46.5328 401.634 46.5328C404.166 46.5328 406.804 47.5433 408.182 49.2459L405.214 51.8466Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M410.315 37.0528H414.656V54.3414H414.762L421.348 47.0318H426.918L419.396 54.884L427.392 64.3952H421.642L414.769 55.4952H414.663V64.3952H410.322V37.0528H410.315Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M433.717 37.0528V49.2459H433.823C434.727 48.1232 436.461 46.5329 439.648 46.5329C444.606 46.5329 448.074 50.512 448.074 55.6511C448.074 60.7155 444.818 64.9129 439.536 64.9129C437.109 64.9129 434.757 63.7902 433.567 61.8007H433.492V64.4077H429.369V37.0528H433.717ZM438.674 50.0754C435.494 50.0754 433.573 53.0067 433.573 55.7197C433.573 58.4328 435.487 61.2893 438.674 61.2893C442.037 61.2893 443.664 58.358 443.664 55.6449C443.664 52.9319 442.037 50.0754 438.674 50.0754Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M459.399 46.5328C464.644 46.5328 468.843 50.1877 468.843 55.6512C468.843 61.1146 464.644 64.9129 459.399 64.9129C454.154 64.9129 449.957 61.1146 449.957 55.6512C449.957 50.1877 454.154 46.5328 459.399 46.5328ZM459.399 61.2893C462.836 61.2893 464.426 58.3579 464.426 55.6449C464.426 52.9319 462.836 50.0753 459.399 50.0753C455.963 50.0753 454.372 52.9319 454.372 55.6449C454.372 58.3579 455.963 61.2893 459.399 61.2893Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M480.168 46.5328C485.413 46.5328 489.61 50.1877 489.61 55.6512C489.61 61.1146 485.413 64.9129 480.168 64.9129C474.923 64.9129 470.726 61.1146 470.726 55.6512C470.726 50.1877 474.923 46.5328 480.168 46.5328ZM480.168 61.2893C483.605 61.2893 485.195 58.3579 485.195 55.6449C485.195 52.9319 483.605 50.0753 480.168 50.0753C476.731 50.0753 475.141 52.9319 475.141 55.6449C475.135 58.3579 476.731 61.2893 480.168 61.2893Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M492.249 37.0528H496.589V54.3414H496.695L503.282 47.0318H508.852L501.33 54.884L509.326 64.3952H503.575L496.702 55.4952H496.596V64.3952H492.255V37.0528H492.249Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M521.17 51.6658C520.408 50.6555 518.961 49.7823 517.371 49.7823C515.999 49.7823 514.583 50.2875 514.583 51.6658C514.583 53.0067 515.924 53.3685 518.343 53.9422C520.914 54.5597 523.951 55.7135 523.951 59.1126C523.951 63.3475 520.514 64.9004 516.716 64.9004C514.04 64.9004 511.253 63.8901 509.587 62.044L512.444 59.3684C513.386 60.597 515.014 61.5388 516.891 61.5388C518.157 61.5388 519.679 61.0335 519.679 59.4743C519.679 58.0274 518.337 57.5908 515.7 56.9796C513.13 56.3622 510.561 55.3144 510.561 52.0588C510.561 48.1856 514.034 46.5267 517.471 46.5267C519.965 46.5267 522.572 47.3936 523.982 49.1648L521.17 51.6658Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M389.64 23.3318C389.64 27.735 393.164 30.9532 397.642 30.9532C402.12 30.9532 405.65 27.7412 405.65 23.3318V13.2218H401.309V22.8141C401.309 25.1904 399.719 26.7807 397.629 26.7807C395.533 26.7807 393.949 25.1904 393.949 22.8141V13.2218H389.615L389.64 23.3318Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M417.244 17.282H422.421V30.604H426.756V17.282H431.926V13.2218H417.244V17.282Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M414.438 13.2218H410.104V30.604H414.438V13.2218Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M372.127 17.282H377.304V30.604H381.638V17.282H386.809V13.2218H372.127V17.282Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M349.381 13.2218H345.046V30.604H349.381V21.916V13.2218Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M369.844 20.4939C369.844 16.0907 366.314 12.8724 361.836 12.8724C357.358 12.8724 353.828 16.0844 353.828 20.4939V30.6039H358.163V21.0116C358.163 18.6353 359.753 17.0449 361.842 17.0449C363.932 17.0449 365.522 18.6353 365.522 21.0116V30.6039H369.857L369.844 20.4939Z", fill: "black" })), /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_8135_21218" }, /* @__PURE__ */ React.createElement("rect", { width: 246, height: 62.9424, fill: "white", transform: "translate(278 10.1407)" }))));
const SvgRippling = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 599, height: 82, viewBox: "0 0 599 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.200195H247.93V81.5602H248.93V0.200195Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.6002C19.58 27.6602 16.72 25.9802 12.52 25.9802C4.66 26.0302 0 32.2802 0 40.9502C0 49.6202 4.65 55.8702 12.52 55.8702C13.96 55.9502 15.41 55.7002 16.75 55.1402C18.09 54.5802 19.29 53.7202 20.26 52.6302V56.8002C20.26 59.6402 18.76 63.0102 14 63.0102C10.39 63.0102 8.61 60.9902 7.99 58.8202L1.6 61.9102C3.2 66.0102 7.02 69.4502 14.44 69.4502C25.44 69.4502 28.27 62.0302 28.27 55.5302V26.3902H21.54L21.36 30.5902L21.35 30.6002ZM14.24 49.0702C10.31 49.0702 7.99 45.8702 7.99 40.8902C7.99 35.9102 10.31 32.7102 14.24 32.7102C18.17 32.7102 20.44 35.9102 20.44 40.8902C20.44 45.8702 18.17 49.0702 14.24 49.0702Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.9302C176.63 25.9302 175.11 26.2702 173.73 26.9502C172.34 27.6302 171.12 28.6102 170.16 29.8402L169.64 26.4002H162.53V55.4102H170.83V39.0302C170.83 34.5002 172.51 32.7302 175.84 32.7302C178.16 32.7302 180.08 33.7602 180.08 38.1802V55.4202H188.38V36.4902C188.38 30.3602 184.58 25.9402 178.16 25.9402L178.17 25.9302Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.7703C49.6201 46.7503 47.9401 49.0703 44.6201 49.0703C42.3001 49.0703 40.3601 48.0402 40.3601 43.6202V26.4003H32.0601V45.2903C32.0601 51.4103 35.8601 55.8603 42.2801 55.8603C43.8201 55.8603 45.3401 55.5103 46.7301 54.8303C48.1201 54.1503 49.3401 53.1602 50.3001 51.9402L50.8201 55.3903H57.9101V26.4003H49.6101V42.7703H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.4003H62.28V55.4103H70.58V26.4003Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.5302C91.6001 26.8002 89.0201 25.9302 86.4001 26.0802C78.5001 26.0802 73.8301 32.3402 73.8301 41.0002C73.8301 49.6602 78.5001 55.9202 86.4001 55.9202C88.0801 56.0302 89.7601 55.6902 91.2701 54.9302C92.7801 54.1702 94.0701 53.0202 95.0101 51.5902L95.2101 55.4102H101.94V12.9302H93.6401L93.6001 28.5302H93.6101ZM88.2101 49.0702C84.2801 49.0702 81.9601 45.8702 81.9601 40.8902C81.9601 35.9102 84.2801 32.7102 88.2101 32.7102C92.1401 32.7102 94.4601 35.9102 94.4601 40.8902C94.4601 45.8702 92.1401 49.0702 88.2101 49.0702Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.2402C65.5099 12.2402 64.6199 12.5202 63.8599 13.0302C63.0999 13.5502 62.5099 14.2802 62.1599 15.1502C61.8099 16.0102 61.7199 16.9602 61.8999 17.8702C62.0799 18.7802 62.5199 19.6202 63.1699 20.2802C63.8199 20.9402 64.6399 21.3902 65.5399 21.5702C66.4399 21.7502 67.3699 21.6602 68.2099 21.3002C69.0599 20.9402 69.7799 20.3402 70.2899 19.5602C70.7999 18.7802 71.0699 17.8702 71.0699 16.9402C71.0699 15.6902 70.5799 14.4902 69.7099 13.6102C68.8399 12.7302 67.6599 12.2302 66.4399 12.2302L66.4299 12.2402Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 26.4003H149.84V55.4103H158.14V26.4003Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.2402C153.08 12.2402 152.19 12.5202 151.43 13.0302C150.67 13.5502 150.08 14.2802 149.72 15.1502C149.37 16.0102 149.28 16.9602 149.46 17.8702C149.64 18.7802 150.08 19.6202 150.73 20.2802C151.38 20.9402 152.2 21.3902 153.1 21.5702C154 21.7502 154.93 21.6602 155.77 21.3002C156.62 20.9402 157.34 20.3402 157.85 19.5602C158.36 18.7802 158.63 17.8702 158.63 16.9402C158.63 15.6902 158.14 14.4902 157.27 13.6102C156.4 12.7302 155.22 12.2302 154 12.2302V12.2402Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 41.8401V40.9601C218.63 32.0001 213.58 26.0402 205.25 26.0402C196.92 26.0402 191.31 32.0001 191.31 40.9601C191.31 49.9201 196.93 55.8801 205.25 55.8801C211.01 55.8801 215.3 53.0901 217.33 48.3801L211.32 45.4802C210.93 46.7402 210.14 47.8201 209.08 48.5801C208.02 49.3401 206.75 49.7202 205.45 49.6702C203.92 49.7102 202.42 49.1601 201.28 48.1201C200.14 47.0801 199.42 45.6301 199.29 44.0801H199.35L218.63 41.8502V41.8401ZM199.09 38.9102C199.09 34.7002 201.55 31.9401 205.22 31.9401C206.73 31.9101 208.19 32.4801 209.31 33.5101C210.43 34.5501 211.11 35.9801 211.23 37.5101L199.09 38.9102Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.0302C110.47 26.0302 104.85 31.9901 104.85 40.9501C104.85 49.9101 110.47 55.8701 118.8 55.8701C124.55 55.8701 128.84 53.0801 130.82 48.3701L124.81 45.4702C124.42 46.7102 123.65 47.7802 122.61 48.5402C121.57 49.2902 120.32 49.6902 119.05 49.6602C117.5 49.7302 115.99 49.1801 114.83 48.1401C113.67 47.1001 112.94 45.6401 112.81 44.0701L132.05 41.8201V40.9401C132.17 32.0001 127.12 26.0402 118.8 26.0402V26.0302ZM112.61 38.9102C112.61 34.7002 115.02 31.9401 118.75 31.9401C120.26 31.9101 121.72 32.4801 122.84 33.5101C123.96 34.5501 124.64 35.9801 124.76 37.5101L112.6 38.9102H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 46.6702V12.9302H134.99V47.5302C134.99 51.5502 135.78 55.7402 142.81 55.7402C144.14 55.8102 145.47 55.5902 146.71 55.0802V48.6002C146.71 48.6002 143.29 49.4802 143.29 46.6702Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.0402H33.04V75.7701H0.25V81.6102H38.77V68.8701H218.65V63.0402Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M285.46 30.7302C285.46 25.7102 282.93 21.5702 278.21 18.0902H289.19C293.04 21.0702 295.41 25.6302 295.41 30.7302C295.41 35.8302 293.05 40.3902 289.19 43.3702C292.75 44.8602 294.79 48.5102 294.79 53.7302V63.6802H284.84V53.7302C284.84 48.7602 282.48 45.2702 278.21 43.3702C282.93 39.8902 285.46 35.7402 285.46 30.7302ZM307.01 30.7302C307.01 25.7102 304.48 21.5702 299.76 18.0902H310.74C314.59 21.0702 316.96 25.6302 316.96 30.7302C316.96 35.8302 314.6 40.3902 310.74 43.3702C314.3 44.8602 316.33 48.5102 316.33 53.7302V63.6802H306.38V53.7302C306.38 48.7602 304.02 45.2702 299.75 43.3702C304.47 39.8902 307 35.7402 307 30.7302H307.01ZM328.55 30.7302C328.55 25.7102 326.02 21.5702 321.3 18.0902H332.28C336.13 21.0702 338.5 25.6302 338.5 30.7302C338.5 35.8302 336.14 40.3902 332.28 43.3702C335.84 44.8602 337.88 48.5102 337.88 53.7302V63.6802H327.93V53.7302C327.93 48.7602 325.57 45.2702 321.3 43.3702C326.02 39.8902 328.55 35.7402 328.55 30.7302Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M368.8 55.3903H361.26V26.3802H379.79C388.7 26.3802 393.09 29.7002 393.09 35.1202C393.09 38.8102 390.93 41.5902 386.91 42.9902C391.05 43.6102 392.92 45.8102 392.92 49.7502V55.3903H385.29V50.0803C385.29 46.7603 383.63 45.4402 379.28 45.4402H368.79V55.3903H368.8ZM379.37 30.6003H368.8V41.2103H379.29C383.1 41.2103 385.47 39.1003 385.47 35.7803C385.47 32.4603 383.27 30.6003 379.38 30.6003", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M406.18 26.3802H398.64V55.3903H406.18V26.3802Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M429.31 45.9402H420.11V55.3903H412.57V26.3802H429.48C438.39 26.3802 443.07 30.1103 443.07 36.0803C443.07 42.0503 438.3 45.9402 429.31 45.9402ZM429.14 30.6003H420.1V41.7103H429.05C432.95 41.7103 435.35 39.7203 435.35 36.1103C435.35 32.5003 432.95 30.6003 429.13 30.6003", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M464.29 45.9402H455.09V55.3903H447.55V26.3802H464.46C473.37 26.3802 478.05 30.1103 478.05 36.0803C478.05 42.0503 473.28 45.9402 464.29 45.9402ZM464.12 30.6003H455.08V41.7103H464.03C467.93 41.7103 470.33 39.7203 470.33 36.1103C470.33 32.5003 467.93 30.6003 464.11 30.6003", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M490.07 26.3802V51.0803H508.88V55.3903H482.52V26.3802H490.07Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M521.15 26.3802H513.61V55.3903H521.15V26.3802Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M532.5 36.0703V55.3903H527.53V26.3802H533.17L553.73 45.6902V26.3802H558.7V55.3903H553.06L532.5 36.0703Z", fill: "black" }), /* @__PURE__ */ React.createElement("path", { d: "M583.32 29.7703C576.15 29.7703 571.47 34.3302 571.47 41.1302C571.47 47.9302 575.95 51.9902 582.91 51.9902H583.41C585.77 51.9902 588.43 51.4903 590.87 50.7103V42.8802H578.69V38.7402H598.25V52.3802C594.19 54.4902 588.05 56.1503 583.08 56.1503H582.42C570.98 56.1503 563.6 50.1002 563.6 41.3102C563.6 32.5202 571.19 25.6403 582.83 25.6403H583.49C588.34 25.6403 593.89 27.1703 598 29.5803L595.84 33.1003C592.15 31.0703 587.76 29.7803 583.82 29.7803H583.32V29.7703Z", fill: "black" }));
const SvgSquare = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 473, height: 83, viewBox: "0 0 473 83", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.820068H247.93V82.1801H248.93V0.820068Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 31.2101C19.58 28.2701 16.72 26.5901 12.52 26.5901C4.66 26.6401 0 32.8901 0 41.5601C0 50.2301 4.65 56.4801 12.52 56.4801C13.96 56.5601 15.41 56.3101 16.75 55.7501C18.09 55.1901 19.29 54.3301 20.26 53.2401V57.4101C20.26 60.2501 18.76 63.6201 14 63.6201C10.39 63.6201 8.61 61.6001 7.99 59.4301L1.6 62.5201C3.2 66.6201 7.02 70.0601 14.44 70.0601C25.44 70.0601 28.27 62.6401 28.27 56.1401V27.0001H21.54L21.36 31.2001L21.35 31.2101ZM14.24 49.6801C10.31 49.6801 7.99 46.4801 7.99 41.5001C7.99 36.5201 10.31 33.3201 14.24 33.3201C18.17 33.3201 20.44 36.5201 20.44 41.5001C20.44 46.4801 18.17 49.6801 14.24 49.6801Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 26.55C176.63 26.55 175.11 26.89 173.73 27.57C172.34 28.25 171.12 29.23 170.16 30.46L169.64 27.0201H162.53V56.03H170.83V39.65C170.83 35.12 172.51 33.35 175.84 33.35C178.16 33.35 180.08 34.38 180.08 38.8V56.04H188.38V37.11C188.38 30.98 184.58 26.56 178.16 26.56L178.17 26.55Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 43.38C49.6201 47.36 47.9401 49.68 44.6201 49.68C42.3001 49.68 40.3601 48.65 40.3601 44.23V27.01H32.0601V45.9C32.0601 52.02 35.8601 56.47 42.2801 56.47C43.8201 56.47 45.3401 56.12 46.7301 55.44C48.1201 54.76 49.3401 53.77 50.3001 52.55L50.8201 56H57.9101V27.01H49.6101V43.38H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 27.01H62.28V56.02H70.58V27.01Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 29.14C91.6001 27.41 89.0201 26.54 86.4001 26.69C78.5001 26.69 73.8301 32.95 73.8301 41.61C73.8301 50.27 78.5001 56.53 86.4001 56.53C88.0801 56.64 89.7601 56.3 91.2701 55.54C92.7801 54.78 94.0701 53.63 95.0101 52.2L95.2101 56.0201H101.94V13.54H93.6401L93.6001 29.14H93.6101ZM88.2101 49.68C84.2801 49.68 81.9601 46.48 81.9601 41.5C81.9601 36.52 84.2801 33.32 88.2101 33.32C92.1401 33.32 94.4601 36.52 94.4601 41.5C94.4601 46.48 92.1401 49.68 88.2101 49.68Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4299 12.8501C65.5099 12.8501 64.6199 13.1301 63.8599 13.6401C63.0999 14.1601 62.5099 14.8901 62.1599 15.7601C61.8099 16.6201 61.7199 17.5701 61.8999 18.4801C62.0799 19.3901 62.5199 20.2301 63.1699 20.8901C63.8199 21.5501 64.6399 22.0001 65.5399 22.1801C66.4399 22.3601 67.3699 22.2701 68.2099 21.9101C69.0599 21.5501 69.7799 20.9501 70.2899 20.1701C70.7999 19.3901 71.0699 18.4801 71.0699 17.5501C71.0699 16.3001 70.5799 15.1001 69.7099 14.2201C68.8399 13.3401 67.6599 12.8401 66.4399 12.8401L66.4299 12.8501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.14 27.01H149.84V56.02H158.14V27.01Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.8501C153.08 12.8501 152.19 13.1301 151.43 13.6401C150.67 14.1601 150.08 14.8901 149.72 15.7601C149.37 16.6201 149.28 17.5701 149.46 18.4801C149.64 19.3901 150.08 20.2301 150.73 20.8901C151.38 21.5501 152.2 22.0001 153.1 22.1801C154 22.3601 154.93 22.2701 155.77 21.9101C156.62 21.5501 157.34 20.9501 157.85 20.1701C158.36 19.3901 158.63 18.4801 158.63 17.5501C158.63 16.3001 158.14 15.1001 157.27 14.2201C156.4 13.3401 155.22 12.8401 154 12.8401V12.8501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.63 42.45V41.57C218.63 32.61 213.58 26.65 205.25 26.65C196.92 26.65 191.31 32.61 191.31 41.57C191.31 50.53 196.93 56.4901 205.25 56.4901C211.01 56.4901 215.3 53.7001 217.33 48.9901L211.32 46.09C210.93 47.35 210.14 48.43 209.08 49.19C208.02 49.95 206.75 50.33 205.45 50.28C203.92 50.32 202.42 49.77 201.28 48.73C200.14 47.69 199.42 46.24 199.29 44.69H199.35L218.63 42.46V42.45ZM199.09 39.5201C199.09 35.3101 201.55 32.55 205.22 32.55C206.73 32.52 208.19 33.09 209.31 34.12C210.43 35.16 211.11 36.59 211.23 38.12L199.09 39.5201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 26.65C110.47 26.65 104.85 32.61 104.85 41.57C104.85 50.53 110.47 56.4901 118.8 56.4901C124.55 56.4901 128.84 53.7001 130.82 48.9901L124.81 46.09C124.42 47.33 123.65 48.4 122.61 49.16C121.57 49.91 120.32 50.31 119.05 50.28C117.5 50.35 115.99 49.8 114.83 48.76C113.67 47.72 112.94 46.26 112.81 44.69L132.05 42.44V41.56C132.17 32.62 127.12 26.66 118.8 26.66V26.65ZM112.61 39.53C112.61 35.32 115.02 32.56 118.75 32.56C120.26 32.53 121.72 33.1 122.84 34.13C123.96 35.17 124.64 36.6 124.76 38.13L112.6 39.53H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.29 47.29V13.55H134.99V48.15C134.99 52.17 135.78 56.36 142.81 56.36C144.14 56.43 145.47 56.21 146.71 55.7V49.22C146.71 49.22 143.29 50.1 143.29 47.29Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.65 63.66H33.04V76.39H0.25V82.23H38.77V69.4901H218.65V63.66Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M318.76 17.16H286.35C281.86 17.16 278.22 20.8 278.22 25.29V57.7C278.22 62.19 281.86 65.84 286.35 65.84H318.76C323.25 65.84 326.9 62.2 326.9 57.7V25.29C326.9 20.8 323.26 17.16 318.76 17.16ZM318.04 54.42C318.04 55.84 316.89 56.9901 315.47 56.9901H289.63C288.21 56.9901 287.06 55.84 287.06 54.42V28.58C287.06 27.16 288.21 26.01 289.63 26.01H315.47C316.89 26.01 318.04 27.16 318.04 28.58V54.42ZM297.39 48.1C296.57 48.1 295.92 47.44 295.92 46.62V36.3C295.92 35.48 296.58 34.82 297.39 34.82H307.72C308.53 34.82 309.19 35.48 309.19 36.3V46.62C309.19 47.44 308.53 48.1 307.72 48.1H297.39ZM339.8 47.4H345.12C345.39 50.41 347.42 52.76 351.54 52.76C355.22 52.76 357.48 50.94 357.48 48.2C357.48 45.63 355.71 44.48 352.52 43.73L348.4 42.84C343.93 41.87 340.56 38.99 340.56 34.29C340.56 29.11 345.17 25.56 351.15 25.56C357.48 25.56 361.56 28.88 361.91 33.8H356.77C356.15 31.5 354.25 30.12 351.14 30.12C347.86 30.12 345.6 31.89 345.6 34.15C345.6 36.41 347.55 37.78 350.92 38.54L355 39.43C359.47 40.4 362.53 43.11 362.53 47.85C362.53 53.87 358.01 57.46 351.54 57.46C344.28 57.46 340.24 53.52 339.8 47.41V47.4ZM381.54 65.84V57.0201L381.89 53.15H381.54C380.32 55.93 377.76 57.45 374.29 57.45C368.69 57.45 364.52 52.89 364.52 45.89C364.52 38.89 368.69 34.33 374.29 34.33C377.72 34.33 380.15 35.94 381.54 38.46H381.89V34.7701H386.49V65.83H381.54V65.84ZM381.71 45.9C381.71 41.43 378.97 38.82 375.63 38.82C372.29 38.82 369.55 41.43 369.55 45.9C369.55 50.37 372.29 52.98 375.63 52.98C378.97 52.98 381.71 50.37 381.71 45.9ZM390.17 48.2V34.78H395.12V47.7701C395.12 51.2901 396.81 52.98 399.64 52.98C403.12 52.98 405.37 50.5 405.37 46.64V34.78H410.32V57.0201H405.72V52.42H405.37C404.28 55.37 401.89 57.46 398.2 57.46C392.9 57.46 390.16 54.07 390.16 48.21L390.17 48.2ZM413.35 50.81C413.35 46.64 416.26 44.21 421.43 43.9L427.56 43.51V41.7701C427.56 39.68 426.04 38.42 423.35 38.42C420.87 38.42 419.4 39.68 419.01 41.46H414.06C414.58 36.94 418.32 34.34 423.36 34.34C429.05 34.34 432.53 36.77 432.53 41.46V57.01H427.93V52.88H427.58C426.54 55.62 424.37 57.44 420.19 57.44C416.01 57.44 413.37 54.75 413.37 50.79L413.35 50.81ZM427.56 48.07V46.9L422.56 47.25C419.87 47.42 418.65 48.42 418.65 50.42C418.65 52.11 420.04 53.33 422 53.33C425.52 53.33 427.56 51.07 427.56 48.07ZM436.2 57.0201V34.78H440.8V39.04H441.15C441.8 36.13 444.02 34.78 447.32 34.78H449.58V39.25H446.76C443.55 39.25 441.16 41.34 441.16 45.29V57.0201H436.21H436.2ZM472.25 46.81H455.35C455.61 50.89 458.48 53.2 461.65 53.2C464.34 53.2 466.04 52.11 466.99 50.29H471.9C470.55 54.81 466.6 57.46 461.6 57.46C455.04 57.46 450.44 52.55 450.44 45.9C450.44 39.25 455.18 34.34 461.65 34.34C468.12 34.34 472.42 38.81 472.42 44.38C472.42 45.47 472.33 46.03 472.25 46.81ZM467.51 43.38C467.34 40.3 464.77 38.21 461.65 38.21C458.7 38.21 456.22 40.08 455.61 43.38H467.51Z", fill: "#1A1A1A" }));
const SvgZenefits = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 506, height: 82, viewBox: "0 0 506 82", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("path", { d: "M248.93 0.0500488H247.93V81.4101H248.93V0.0500488Z", fill: "#777675" }), /* @__PURE__ */ React.createElement("path", { d: "M21.35 30.4401C19.58 27.5001 16.72 25.8201 12.52 25.8201C4.66 25.8701 0 32.1201 0 40.7901C0 49.4601 4.65 55.7101 12.52 55.7101C13.96 55.7901 15.41 55.54 16.75 54.98C18.09 54.42 19.29 53.5601 20.26 52.4701V56.6401C20.26 59.4801 18.76 62.8501 14 62.8501C10.39 62.8501 8.61 60.8301 7.99 58.6601L1.6 61.7501C3.2 65.8501 7.02 69.2901 14.44 69.2901C25.44 69.2901 28.27 61.8701 28.27 55.3701V26.23H21.54L21.36 30.4301L21.35 30.4401ZM14.24 48.9101C10.31 48.9101 7.99 45.71 7.99 40.73C7.99 35.75 10.31 32.55 14.24 32.55C18.17 32.55 20.44 35.75 20.44 40.73C20.44 45.71 18.17 48.9101 14.24 48.9101Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M178.17 25.78C176.63 25.78 175.11 26.12 173.73 26.8C172.34 27.48 171.12 28.46 170.16 29.69L169.64 26.25H162.53V55.27H170.83V38.89C170.83 34.36 172.51 32.59 175.84 32.59C178.16 32.59 180.08 33.62 180.08 38.04V55.28H188.38V36.35C188.38 30.22 184.58 25.8 178.16 25.8L178.17 25.78Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M49.6201 42.61C49.6201 46.59 47.9401 48.92 44.6201 48.92C42.3001 48.92 40.3601 47.89 40.3601 43.47V26.24H32.0601V45.13C32.0601 51.25 35.8601 55.7 42.2801 55.7C43.8201 55.7 45.3401 55.35 46.7301 54.67C48.1201 53.99 49.3401 53 50.3001 51.78L50.8201 55.23H57.9101V26.24H49.6101V42.61H49.6201Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M70.58 26.25H62.28V55.27H70.58V26.25Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M93.6101 28.38C91.6001 26.65 89.0201 25.77 86.3901 25.93C78.4901 25.93 73.8201 32.19 73.8201 40.85C73.8201 49.51 78.4901 55.77 86.3901 55.77C88.0701 55.88 89.7501 55.54 91.2601 54.78C92.7701 54.02 94.0601 52.87 95.0001 51.44L95.2001 55.26H101.93V12.78H93.6301L93.5901 28.38H93.6101ZM88.2101 48.92C84.2801 48.92 81.9601 45.72 81.9601 40.74C81.9601 35.76 84.2801 32.56 88.2101 32.56C92.1401 32.56 94.4601 35.76 94.4601 40.74C94.4601 45.72 92.1401 48.92 88.2101 48.92Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M66.4399 12.0801C65.5199 12.0801 64.6299 12.3601 63.8699 12.8701C63.1099 13.3901 62.5199 14.1201 62.1599 14.9901C61.8099 15.8501 61.7199 16.8001 61.8999 17.7101C62.0799 18.6201 62.5199 19.4601 63.1699 20.1201C63.8199 20.7801 64.6399 21.2301 65.5399 21.4101C66.4399 21.5901 67.3699 21.5001 68.2099 21.1401C69.0599 20.7801 69.7799 20.1801 70.2899 19.4001C70.7999 18.6201 71.0699 17.7101 71.0699 16.7801C71.0699 15.5301 70.5799 14.3301 69.7099 13.4501C68.8399 12.5701 67.6599 12.0701 66.4399 12.0701V12.0801Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M158.15 26.25H149.85V55.27H158.15V26.25Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M154 12.0801C153.08 12.0801 152.19 12.3601 151.43 12.8701C150.67 13.3901 150.08 14.1201 149.72 14.9901C149.37 15.8501 149.28 16.8001 149.46 17.7101C149.64 18.6201 150.08 19.4601 150.73 20.1201C151.38 20.7801 152.2 21.2301 153.1 21.4101C154 21.5901 154.93 21.5001 155.77 21.1401C156.62 20.7801 157.34 20.1801 157.85 19.4001C158.36 18.6201 158.63 17.7101 158.63 16.7801C158.63 15.5301 158.14 14.3301 157.27 13.4501C156.4 12.5701 155.22 12.0701 154 12.0701V12.0801Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.64 41.6801V40.8001C218.64 31.8401 213.59 25.8801 205.26 25.8801C196.93 25.8801 191.32 31.8401 191.32 40.8001C191.32 49.7601 196.94 55.7202 205.26 55.7202C211.02 55.7202 215.31 52.9302 217.35 48.2202L211.34 45.3201C210.95 46.5801 210.16 47.6601 209.1 48.4201C208.04 49.1801 206.77 49.5601 205.47 49.5101C203.94 49.5501 202.44 49.0001 201.3 47.9601C200.16 46.9201 199.44 45.4701 199.31 43.9201H199.37L218.65 41.6901L218.64 41.6801ZM199.1 38.7501C199.1 34.5401 201.57 31.7802 205.23 31.7802C206.74 31.7502 208.2 32.3202 209.32 33.3502C210.44 34.3902 211.12 35.8202 211.24 37.3502L199.1 38.7501Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M118.8 25.8801C110.47 25.8801 104.85 31.8401 104.85 40.8001C104.85 49.7601 110.47 55.7202 118.8 55.7202C124.55 55.7202 128.84 52.9302 130.82 48.2202L124.81 45.3201C124.42 46.5601 123.65 47.6301 122.61 48.3901C121.57 49.1401 120.32 49.5401 119.05 49.5101C117.5 49.5801 115.99 49.0301 114.83 47.9901C113.67 46.9501 112.94 45.4901 112.81 43.9201L132.05 41.6701V40.7902C132.17 31.8502 127.12 25.8901 118.8 25.8901V25.8801ZM112.61 38.7601C112.61 34.5501 115.02 31.7902 118.75 31.7902C120.26 31.7602 121.72 32.3301 122.84 33.3601C123.96 34.4001 124.64 35.8301 124.76 37.3601L112.6 38.7601H112.61Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M143.3 46.52V12.78H135V47.38C135 51.4 135.79 55.59 142.82 55.59C144.15 55.66 145.48 55.44 146.72 54.93V48.45C146.72 48.45 143.3 49.33 143.3 46.52Z", fill: "#150A45" }), /* @__PURE__ */ React.createElement("path", { d: "M218.66 62.8901H33.04V75.6201H0.25V81.4601H38.77V68.7202H218.66V62.8901Z", fill: "#5532FA" }), /* @__PURE__ */ React.createElement("path", { d: "M366.2 38.7999C361.5 38.7999 357.7 41.0999 355.9 45.3999C355 47.3999 354.7 49.7999 354.7 52.5999V52.8999C354.7 63.4999 360.1 67.0999 367.1 67.0999C371 67.0999 374.6 65.4999 377.2 62.6999C377.3 62.5999 377.3 62.4999 377.2 62.3999L373.9 59.3999C373.8 59.2999 373.7 59.2999 373.6 59.3999C371.7 61.2999 369.9 62.0999 367.2 62.0999C362.6 62.0999 360.3 59.2999 360.3 54.4999H377.7C377.8 54.4999 377.9 54.3999 377.9 54.2999V50.1999C377.8 43.3999 373.6 38.7999 366.2 38.7999ZM372.5 49.8999H360.3V49.3999C360.4 48.0999 360.5 47.4999 361 46.4999C361.9 44.8999 363.8 43.8999 366.4 43.8999C369 43.8999 370.9 44.9999 371.7 46.4999C372.2 47.3999 372.4 48.0999 372.5 49.3999V49.8999Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M420.6 38.7999C415.9 38.7999 412.1 41.0999 410.3 45.3999C409.4 47.3999 409.1 49.7999 409.1 52.5999V52.8999C409.1 63.4999 414.5 67.0999 421.5 67.0999C425.4 67.0999 429 65.4999 431.6 62.6999C431.7 62.5999 431.7 62.4999 431.6 62.3999L428.3 59.3999C428.2 59.2999 428.1 59.2999 428 59.3999C426.1 61.2999 424.3 62.0999 421.6 62.0999C417 62.0999 414.7 59.2999 414.7 54.4999H432.1C432.2 54.4999 432.3 54.3999 432.3 54.2999V50.1999C432.2 43.3999 427.9 38.7999 420.6 38.7999ZM426.9 49.8999H414.7V49.3999C414.8 48.0999 414.9 47.4999 415.4 46.4999C416.3 44.8999 418.2 43.8999 420.8 43.8999C423.4 43.8999 425.3 44.9999 426.1 46.4999C426.6 47.3999 426.8 48.0999 426.9 49.3999V49.8999Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M330.2 39.3V43.9C330.2 44 330.3 44.1 330.4 44.1H343.1L329.5 66.4C329.4 66.5 329.5 66.6 329.6 66.7H329.7H352C352.1 66.7 352.2 66.6 352.2 66.5V61.9C352.2 61.8 352.1 61.7 352 61.7H338.8L352.3 39.4C352.4 39.3 352.3 39.2 352.2 39.1H352.1H330.4C330.3 39.1 330.2 39.2 330.2 39.3Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M475.9 32H471C470.9 32 470.8 32.1 470.8 32.2V39.1H467.2C467.1 39.1 467 39.2 467 39.3V43.9C467 44 467.1 44.1 467.2 44.1H470.8V58.6C470.8 64.6 475.2 67 480 67C480.5 67 480.8 67 481.1 67C481.2 67 481.3 66.9 481.3 66.8V62C481.3 61.9 481.2 61.8 481.1 61.8C480.8 61.8 480.6 61.8 480.3 61.8C477.6 61.7 476.2 60.2 476.2 57.1V44.1H481.6C481.7 44.1 481.8 44 481.8 43.9V39.3C481.8 39.2 481.7 39.1 481.6 39.1H476.2V32.2C476.1 32 476 32 475.9 32Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M502.4 52.8C500.6 51.5 497.9 50.8 494.5 50.3C490.1 49.5 489.5 48.7 489.5 46.9C489.5 45.9 490 45 490.9 44.6C492.3 43.8 493.7 43.8 495.1 44C496.7 44.2 498.7 44.8 500.1 46.3C500.2 46.4 500.3 46.4 500.4 46.3L503.7 43.3C503.8 43.2 503.8 43.1 503.7 43C503.1 42.2 502.3 41.5 501.4 41C500.4 40.4 499.2 39.8 498.1 39.5C496.8 39.2 495.5 39 494.1 39C492.3 39 490.5 39.3 488.9 39.9C487.8 40.4 486.7 41.1 485.9 42.1C485.1 43 484.5 44.2 484.3 45.4C484 46.8 484 48.3 484.5 49.7C484.8 50.6 485.3 51.5 486 52.3C488 54.5 491.1 55.1 494.1 55.6C496.1 56 499.9 56.1 499.8 59C499.7 61.8 496.4 62.6 494.1 62.6C491.5 62.6 489.3 61.7 487.4 59.8C487.3 59.7 487.2 59.7 487.1 59.8L483.8 62.8C483.7 62.9 483.7 63 483.8 63.1C486.2 65.8 490.3 67.4 494.4 67.4C499.7 67.4 504.7 64.8 505 59.3C505.4 56.2 504.4 54.2 502.4 52.8Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M460 26.2999C462.1 26.2999 463.8 27.9999 463.8 30.0999C463.8 32.1999 462.1 33.8999 460 33.8999C457.9 33.8999 456.2 32.1999 456.2 30.0999C456.2 27.9999 457.9 26.2999 460 26.2999Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M444.5 39.0999V35.2999C444.7 32.4999 446.6 31.3999 448.8 31.2999C449.9 31.2999 451.1 31.4 452.2 31.5C452.3 31.5 452.4 31.4999 452.4 31.2999V26.7C452.4 26.6 452.3 26.5 452.2 26.5C451.1 26.3 449.9 26.2 448.8 26.2H448.3C442.9 26.2 439.1 29.1999 439.1 34.7999V39.0999H435C434.9 39.0999 434.8 39.1999 434.8 39.2999V43.9C434.8 44 434.9 44.0999 435 44.0999H439.1V66.5C439.1 66.5999 439.2 66.6999 439.3 66.6999H444.2C444.3 66.6999 444.4 66.5999 444.4 66.5V44.2H457.2V66.5999C457.2 66.6999 457.3 66.8 457.4 66.8H462.3C462.4 66.8 462.5 66.6999 462.5 66.5999V39.2999C462.5 39.1999 462.4 39.0999 462.3 39.0999H444.5Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M401.4 41.2C399.7 39.6 397.4 38.7 394.3 38.7C392.2 38.7 390.4 39 388.6 40.2C388.2 40.5 387.8 40.7 387.5 41C387.4 41.1 387.3 41.2 387.2 41.2V39.2C387.2 39.1 387.1 39 387 39H382.1C382 39 381.9 39.1 381.9 39.2V66.4C381.9 66.5 382 66.5999 382.1 66.5999H387C387.1 66.5999 387.2 66.5 387.2 66.4V48.5C387.2 47.1 388.3 45.7999 389.4 45.0999C390.8 44.1999 393.2 44.1 394.9 44.4C397.5 44.8 399.3 46.8999 399.3 49.5999V66.5999C399.3 66.6999 399.4 66.8 399.5 66.8H404.4C404.5 66.8 404.6 66.6999 404.6 66.5999V49.5999C404.8 46.4999 403.9 43.6 401.4 41.2Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M313.2 30.8V36.4L278.2 54.7V49.1L292.1 41.8L278.2 38.3V33.2L298.8 38.4L306.7 34.3L278.2 27.1V22L313.2 30.8ZM278.2 66.5L313.2 75.3V70.2L284.8 63L292.7 58.9L313.3 64V59L299.4 55.5L313.3 48.2V42.6L278.3 60.9L278.2 66.5Z", fill: "#F15949" }), /* @__PURE__ */ React.createElement("path", { d: "M359.9 8.29995H365.7V27.6H359.9V8.29995ZM362.8 0.199951C360.9 0.199951 359.4 1.69995 359.4 3.49995C359.4 5.29995 360.9 6.89995 362.8 6.89995C364.7 6.89995 366.2 5.39995 366.2 3.49995C366.2 1.59995 364.6 0.199951 362.8 0.199951ZM350.8 11.4V8.29995H345.2V27.6H351V20C351 16.2 352.8 13.9 355.9 13.9C356.5 13.9 357.1 14 357.4 14.1V8.19995C357.3 8.19995 356.8 8.09995 356.4 8.09995C354 8.09995 352 8.89995 350.8 11.4ZM336 1.99995H330.2V18.9C330.2 24.2 333.1 28 339.7 28C340.7 28 341.6 27.9 342.3 27.7999V22.7999C341.8 22.9 341.3 22.9 340.6 22.9C337.5 22.9 336 21.1999 336 18.2999V13.3H342.3V8.29995H336V1.99995ZM420.8 11.1V8.29995H413.9V1.99995H410.8V20.1C410.8 25.1 413.7 28 419 28C419.6 28 420.2 28 420.8 27.7999V25.1C420.4 25.2 419.8 25.2 419.3 25.2C415.5 25.2 413.8 23.2 413.8 19.6V11.1H420.8ZM378.9 7.89995C376 7.89995 373.6 9.19995 372.4 11.1V8.29995H369.3V27.6H372.4V17.4C372.4 13.2999 374.9 10.8 378.4 10.8C381.9 10.8 383.9 13.2 383.9 16.9V27.7999H387V16.1C387 11.4 383.9 7.89995 378.9 7.89995ZM408.4 17.6C408.4 17.9 408.4 18.7 408.4 19.1H392.5C392.9 22.9 395.6 25.4 399.3 25.4C402.2 25.4 404.1 24.0999 405.3 21.7999L407.8 23.2C406.2 26.4 403.2 28.2 399.3 28.2C393 28.2 389.4 23.9 389.4 18.1C389.4 12.3 393.5 7.99995 399 7.99995C404.5 7.99995 408.4 12.1 408.4 17.6ZM405.2 16.4C404.9 13.0999 402.7 10.6 399 10.6C395.5 10.6 393 13.0999 392.5 16.4H405.2Z", fill: "#232B45" }), /* @__PURE__ */ React.createElement("path", { d: "M417.3 2V4.8H424.1V11.1H427V2H417.3Z", fill: "#232B45" }));
const SvgGProBlack$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 148, height: 59, viewBox: "0 0 148 59", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 47, y: 7, width: 101, height: 43.5895, rx: 21.7947, fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M63.0449 15.6689H74.3585C75.7903 15.6689 77.0942 15.894 78.2703 16.344C79.4464 16.769 80.4563 17.3815 81.3001 18.1816C82.1438 18.9566 82.7958 19.8816 83.256 20.9567C83.7162 22.0318 83.9463 23.2068 83.9463 24.4819C83.9463 25.7569 83.7162 26.932 83.256 28.007C82.7958 29.0821 82.1438 30.0196 81.3001 30.8197C80.4563 31.5947 79.4464 32.2072 78.2703 32.6573C77.0942 33.0823 75.7903 33.2948 74.3585 33.2948H68.7976V41.9202H63.0449V15.6689ZM74.1668 28.0445C75.3173 28.0445 76.2377 27.7195 76.928 27.0695C77.6439 26.3945 78.0019 25.5319 78.0019 24.4819C78.0019 23.4318 77.6439 22.5818 76.928 21.9317C76.2377 21.2567 75.3173 20.9192 74.1668 20.9192H68.7976V28.0445H74.1668Z", fill: "white", style: {
  fill: "white",
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M87.4854 15.6689H99.3743C100.806 15.6689 102.097 15.8815 103.248 16.3065C104.424 16.7315 105.421 17.3315 106.239 18.1066C107.057 18.8816 107.684 19.8191 108.118 20.9192C108.553 21.9943 108.77 23.1818 108.77 24.4819C108.77 25.9819 108.527 27.232 108.042 28.2321C107.581 29.2321 107.057 30.0196 106.469 30.5947C105.805 31.2697 105.037 31.7947 104.168 32.1697L109.729 41.9202H103.401L98.6073 33.2948H93.2381V41.9202H87.4854V15.6689ZM99.1825 28.0445C100.256 28.0445 101.126 27.7195 101.79 27.0695C102.481 26.3945 102.826 25.5319 102.826 24.4819C102.826 23.4318 102.481 22.5818 101.79 21.9317C101.126 21.2567 100.256 20.9192 99.1825 20.9192H93.2381V28.0445H99.1825Z", fill: "white", style: {
  fill: "white",
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M124.781 41.9202C122.916 41.9202 121.177 41.5726 119.565 40.8773C117.976 40.1821 116.595 39.2471 115.42 38.0724C114.246 36.8737 113.325 35.4833 112.657 33.901C111.989 32.2947 111.655 30.5926 111.655 28.7946C111.655 26.9965 111.989 25.3064 112.657 23.7241C113.325 22.1179 114.246 20.7274 115.42 19.5527C116.595 18.354 117.976 17.407 119.565 16.7118C121.177 16.0166 122.916 15.6689 124.781 15.6689C126.646 15.6689 128.373 16.0166 129.962 16.7118C131.574 17.407 132.967 18.354 134.142 19.5527C135.316 20.7274 136.237 22.1179 136.905 23.7241C137.573 25.3064 137.907 26.9965 137.907 28.7946C137.907 30.5926 137.573 32.2947 136.905 33.901C136.237 35.4833 135.316 36.8737 134.142 38.0724C132.967 39.2471 131.574 40.1821 129.962 40.8773C128.373 41.5726 126.646 41.9202 124.781 41.9202ZM124.781 36.8857C125.863 36.8857 126.876 36.6819 127.821 36.2744C128.765 35.8429 129.582 35.2675 130.273 34.5483C130.987 33.8051 131.539 32.942 131.931 31.9591C132.345 30.9762 132.553 29.9213 132.553 28.7946C132.553 27.6678 132.345 26.613 131.931 25.63C131.539 24.6471 130.987 23.7961 130.273 23.0768C129.582 22.3337 128.765 21.7583 127.821 21.3507C126.876 20.9192 125.863 20.7034 124.781 20.7034C123.699 20.7034 122.685 20.9192 121.741 21.3507C120.797 21.7583 119.968 22.3337 119.254 23.0768C118.564 23.7961 118.011 24.6471 117.596 25.63C117.205 26.613 117.009 27.6678 117.009 28.7946C117.009 29.9213 117.205 30.9762 117.596 31.9591C118.011 32.942 118.564 33.8051 119.254 34.5483C119.968 35.2675 120.797 35.8429 121.741 36.2744C122.685 36.6819 123.699 36.8857 124.781 36.8857Z", fill: "white", style: {
  fill: "white",
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M23.4786 0.688358L23.009 5.04796C22.0698 2.52398 19.2524 0 14.0871 0C11.0349 0 8.92185 0.688358 6.80878 1.83562C2.34786 4.58905 0 9.63701 0 15.8322C0 22.4864 2.58264 27.3049 6.80878 29.8288C8.92185 30.9761 11.2697 31.6645 13.8524 31.6645C18.7829 31.6645 20.8959 29.3699 21.6003 27.5343V28.4521V32.1234C21.6003 35.3357 19.0176 37.8597 15.4959 38.0891C11.9741 38.3186 9.39143 36.9419 8.92185 33.959L1.87829 37.4008C3.52178 42.2193 8.45228 44.9727 15.7306 44.9727C24.6525 44.9727 30.9917 40.1542 30.9917 31.6645V27.5343V24.322V0.688358H23.4786ZM19.722 22.7158C18.5481 23.6336 17.1394 24.0925 15.7306 24.0925C14.3219 24.0925 12.9132 23.6336 11.7393 22.7158C10.0958 21.3391 9.15664 19.274 9.15664 15.8322C9.15664 12.3904 10.0958 10.3254 11.7393 8.94866C12.9132 8.03084 14.3219 7.57194 15.7306 7.57194C17.1394 7.57194 18.5481 8.03084 19.722 8.94866C21.3655 10.3254 22.3046 12.3904 22.3046 15.8322C22.0698 19.274 21.1307 21.1096 19.722 22.7158Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.9916 48.0879V58.4684L25.3908 58.4684V58.4687H0V52.5369H25.0173V48.0879L30.9916 48.0879Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }));
const SvgGProColor$1 = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 148, height: 59, viewBox: "0 0 148 59", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 47, y: 7, width: 101, height: 43.5895, rx: 21.7947, fill: "#CFC7FC", style: {
  fill: "#CFC7FC",
  fill: "color(display-p3 0.8118 0.7804 0.9882)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M63.0449 15.6689H74.3585C75.7903 15.6689 77.0942 15.894 78.2703 16.344C79.4464 16.769 80.4563 17.3815 81.3001 18.1816C82.1438 18.9566 82.7958 19.8816 83.256 20.9567C83.7162 22.0318 83.9463 23.2068 83.9463 24.4819C83.9463 25.7569 83.7162 26.932 83.256 28.007C82.7958 29.0821 82.1438 30.0196 81.3001 30.8197C80.4563 31.5947 79.4464 32.2072 78.2703 32.6573C77.0942 33.0823 75.7903 33.2948 74.3585 33.2948H68.7976V41.9202H63.0449V15.6689ZM74.1668 28.0445C75.3173 28.0445 76.2377 27.7195 76.928 27.0695C77.6439 26.3945 78.0019 25.5319 78.0019 24.4819C78.0019 23.4318 77.6439 22.5818 76.928 21.9317C76.2377 21.2567 75.3173 20.9192 74.1668 20.9192H68.7976V28.0445H74.1668Z", fill: "#4428CE", style: {
  fill: "#4428CE",
  fill: "color(display-p3 0.2667 0.1569 0.8078)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M87.4854 15.6689H99.3743C100.806 15.6689 102.097 15.8815 103.248 16.3065C104.424 16.7315 105.421 17.3315 106.239 18.1066C107.057 18.8816 107.684 19.8191 108.118 20.9192C108.553 21.9943 108.77 23.1818 108.77 24.4819C108.77 25.9819 108.527 27.232 108.042 28.2321C107.581 29.2321 107.057 30.0196 106.469 30.5947C105.805 31.2697 105.037 31.7947 104.168 32.1697L109.729 41.9202H103.401L98.6073 33.2948H93.2381V41.9202H87.4854V15.6689ZM99.1825 28.0445C100.256 28.0445 101.126 27.7195 101.79 27.0695C102.481 26.3945 102.826 25.5319 102.826 24.4819C102.826 23.4318 102.481 22.5818 101.79 21.9317C101.126 21.2567 100.256 20.9192 99.1825 20.9192H93.2381V28.0445H99.1825Z", fill: "#4428CE", style: {
  fill: "#4428CE",
  fill: "color(display-p3 0.2667 0.1569 0.8078)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M124.781 41.9202C122.916 41.9202 121.177 41.5726 119.565 40.8773C117.976 40.1821 116.595 39.2471 115.42 38.0724C114.246 36.8737 113.325 35.4833 112.657 33.901C111.989 32.2947 111.655 30.5926 111.655 28.7946C111.655 26.9965 111.989 25.3064 112.657 23.7241C113.325 22.1179 114.246 20.7274 115.42 19.5527C116.595 18.354 117.976 17.407 119.565 16.7118C121.177 16.0166 122.916 15.6689 124.781 15.6689C126.646 15.6689 128.373 16.0166 129.962 16.7118C131.574 17.407 132.967 18.354 134.142 19.5527C135.316 20.7274 136.237 22.1179 136.905 23.7241C137.573 25.3064 137.907 26.9965 137.907 28.7946C137.907 30.5926 137.573 32.2947 136.905 33.901C136.237 35.4833 135.316 36.8737 134.142 38.0724C132.967 39.2471 131.574 40.1821 129.962 40.8773C128.373 41.5726 126.646 41.9202 124.781 41.9202ZM124.781 36.8857C125.863 36.8857 126.876 36.6819 127.821 36.2744C128.765 35.8429 129.582 35.2675 130.273 34.5483C130.987 33.8051 131.539 32.942 131.931 31.9591C132.345 30.9762 132.553 29.9213 132.553 28.7946C132.553 27.6678 132.345 26.613 131.931 25.63C131.539 24.6471 130.987 23.7961 130.273 23.0768C129.582 22.3337 128.765 21.7583 127.821 21.3507C126.876 20.9192 125.863 20.7034 124.781 20.7034C123.699 20.7034 122.685 20.9192 121.741 21.3507C120.797 21.7583 119.968 22.3337 119.254 23.0768C118.564 23.7961 118.011 24.6471 117.596 25.63C117.205 26.613 117.009 27.6678 117.009 28.7946C117.009 29.9213 117.205 30.9762 117.596 31.9591C118.011 32.942 118.564 33.8051 119.254 34.5483C119.968 35.2675 120.797 35.8429 121.741 36.2744C122.685 36.6819 123.699 36.8857 124.781 36.8857Z", fill: "#4428CE", style: {
  fill: "#4428CE",
  fill: "color(display-p3 0.2667 0.1569 0.8078)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M23.4786 0.688358L23.009 5.04796C22.0698 2.52398 19.2524 0 14.0871 0C11.0349 0 8.92185 0.688358 6.80878 1.83562C2.34786 4.58905 0 9.63701 0 15.8322C0 22.4864 2.58264 27.3049 6.80878 29.8288C8.92185 30.9761 11.2697 31.6645 13.8524 31.6645C18.7829 31.6645 20.8959 29.3699 21.6003 27.5343V28.4521V32.1234C21.6003 35.3357 19.0176 37.8597 15.4959 38.0891C11.9741 38.3186 9.39143 36.9419 8.92185 33.959L1.87829 37.4008C3.52178 42.2193 8.45228 44.9727 15.7306 44.9727C24.6525 44.9727 30.9917 40.1542 30.9917 31.6645V27.5343V24.322V0.688358H23.4786ZM19.722 22.7158C18.5481 23.6336 17.1394 24.0925 15.7306 24.0925C14.3219 24.0925 12.9132 23.6336 11.7393 22.7158C10.0958 21.3391 9.15664 19.274 9.15664 15.8322C9.15664 12.3904 10.0958 10.3254 11.7393 8.94866C12.9132 8.03084 14.3219 7.57194 15.7306 7.57194C17.1394 7.57194 18.5481 8.03084 19.722 8.94866C21.3655 10.3254 22.3046 12.3904 22.3046 15.8322C22.0698 19.274 21.1307 21.1096 19.722 22.7158Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.9916 48.0879V58.4684L25.3908 58.4684V58.4687H0V52.5369H25.0173V48.0879L30.9916 48.0879Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }));
const SvgGProBlack = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 320, height: 69, viewBox: "0 0 320 69", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 230.989, y: 9.47412, width: 88.4255, height: 38.1626, rx: 19.0813, fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M245.036 17.064H254.941C256.194 17.064 257.336 17.261 258.365 17.655C259.395 18.0271 260.279 18.5633 261.018 19.2638C261.757 19.9423 262.328 20.7522 262.73 21.6934C263.133 22.6346 263.335 23.6634 263.335 24.7797C263.335 25.896 263.133 26.9248 262.73 27.866C262.328 28.8072 261.757 29.628 261.018 30.3284C260.279 31.007 259.395 31.5432 258.365 31.9372C257.336 32.3093 256.194 32.4954 254.941 32.4954H250.072V40.0469H245.036V17.064ZM254.773 27.8988C255.78 27.8988 256.586 27.6142 257.19 27.0451C257.817 26.4542 258.13 25.699 258.13 24.7797C258.13 23.8604 257.817 23.1161 257.19 22.547C256.586 21.9561 255.78 21.6606 254.773 21.6606H250.072V27.8988H254.773Z", fill: "white", style: {
  fill: "white",
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M266.433 17.064H276.842C278.096 17.064 279.226 17.25 280.233 17.6221C281.263 17.9942 282.136 18.5196 282.852 19.1981C283.568 19.8766 284.117 20.6975 284.497 21.6606C284.878 22.6018 285.068 23.6415 285.068 24.7797C285.068 26.093 284.856 27.1874 284.43 28.063C284.027 28.9385 283.568 29.628 283.054 30.1314C282.472 30.7224 281.8 31.1821 281.039 31.5104L285.908 40.0469H280.368L276.17 32.4954H271.47V40.0469H266.433V17.064ZM276.674 27.8988C277.614 27.8988 278.375 27.6142 278.957 27.0451C279.562 26.4542 279.864 25.699 279.864 24.7797C279.864 23.8604 279.562 23.1161 278.957 22.547C278.375 21.9561 277.614 21.6606 276.674 21.6606H271.47V27.8988H276.674Z", fill: "white", style: {
  fill: "white",
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M299.086 40.0469C297.453 40.0469 295.931 39.7426 294.52 39.1339C293.129 38.5252 291.919 37.7067 290.891 36.6782C289.863 35.6287 289.056 34.4114 288.472 33.0261C287.887 31.6198 287.595 30.1296 287.595 28.5554C287.595 26.9813 287.887 25.5015 288.472 24.1163C289.056 22.71 289.863 21.4926 290.891 20.4642C291.919 19.4147 293.129 18.5857 294.52 17.977C295.931 17.3683 297.453 17.064 299.086 17.064C300.719 17.064 302.231 17.3683 303.622 17.977C305.034 18.5857 306.253 19.4147 307.281 20.4642C308.31 21.4926 309.116 22.71 309.701 24.1163C310.285 25.5015 310.578 26.9813 310.578 28.5554C310.578 30.1296 310.285 31.6198 309.701 33.0261C309.116 34.4114 308.31 35.6287 307.281 36.6782C306.253 37.7067 305.034 38.5252 303.622 39.1339C302.231 39.7426 300.719 40.0469 299.086 40.0469ZM299.086 35.6392C300.034 35.6392 300.921 35.4608 301.747 35.104C302.574 34.7262 303.29 34.2225 303.894 33.5928C304.519 32.9422 305.003 32.1865 305.346 31.326C305.709 30.4654 305.89 29.5419 305.89 28.5554C305.89 27.569 305.709 26.6454 305.346 25.7849C305.003 24.9243 304.519 24.1792 303.894 23.5496C303.29 22.8989 302.574 22.3952 301.747 22.0384C300.921 21.6606 300.034 21.4717 299.086 21.4717C298.139 21.4717 297.252 21.6606 296.425 22.0384C295.598 22.3952 294.873 22.8989 294.248 23.5496C293.643 24.1792 293.159 24.9243 292.796 25.7849C292.453 26.6454 292.282 27.569 292.282 28.5554C292.282 29.5419 292.453 30.4654 292.796 31.326C293.159 32.1865 293.643 32.9422 294.248 33.5928C294.873 34.2225 295.598 34.7262 296.425 35.104C297.252 35.4608 298.139 35.6392 299.086 35.6392Z", fill: "white", style: {
  fill: "white",
  fill: "white",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M21.2276 18.2641C19.4696 15.3419 16.6233 13.6738 12.4495 13.6738C4.62821 13.7225 0 19.9443 0 28.5648C0 37.1852 4.62821 43.407 12.4495 43.407C13.8863 43.4851 15.3221 43.2361 16.6524 42.6779C17.9826 42.1197 19.1739 41.2665 20.1393 40.1804V44.3323C20.1393 47.1571 18.6444 50.5054 13.9086 50.5054C10.3208 50.5054 8.55083 48.4964 7.92896 46.3413L1.57862 49.4096C3.16919 53.4885 6.97222 56.9099 14.3511 56.9099C25.2937 56.9099 28.1041 49.5314 28.1041 43.0661V14.0878H21.407L21.2276 18.2641ZM14.1597 36.6373C10.249 36.6373 7.94092 33.4594 7.94092 28.5039C7.94092 23.5484 10.249 20.3705 14.1597 20.3705C18.0704 20.3705 20.3307 23.5484 20.3307 28.5039C20.3307 33.4594 18.0704 36.6373 14.1597 36.6373Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M177.188 13.6246C175.659 13.6195 174.148 13.9662 172.769 14.6388C171.39 15.3113 170.178 16.2924 169.223 17.5086L168.709 14.0872H161.641V42.9437H169.893V26.6526C169.893 22.1476 171.567 20.3821 174.88 20.3821C177.188 20.3821 179.102 21.4049 179.102 25.8003V42.9437H187.353V24.1201C187.353 18.02 183.574 13.6246 177.188 13.6246Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M49.3437 30.3659C49.3437 34.323 47.6695 36.6364 44.3687 36.6364C42.0606 36.6364 40.1352 35.6136 40.1352 31.2182V14.0869H31.8833V32.8741C31.8833 38.9619 35.6624 43.3817 42.0486 43.3817C43.5805 43.3854 45.0935 43.0369 46.4746 42.3623C47.8558 41.6876 49.0696 40.7043 50.0254 39.4855L50.5397 42.9191H57.5956V14.0869H49.3437V30.3659Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M70.1889 14.0869H61.937V42.9434H70.1889V14.0869Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M93.0904 16.2062C91.094 14.4873 88.525 13.6154 85.9149 13.7711C78.0577 13.7711 73.4175 19.9929 73.4175 28.6133C73.4175 37.2337 78.0577 43.4555 85.9149 43.4555C87.5879 43.5639 89.2596 43.2227 90.7624 42.4663C92.2652 41.7098 93.5464 40.5646 94.4776 39.1453L94.681 42.9442H101.378V0.694336H93.1263L93.0904 16.2062ZM87.7207 36.6371C83.81 36.6371 81.5019 33.4593 81.5019 28.5037C81.5019 23.5482 83.81 20.3703 87.7207 20.3703C91.6314 20.3703 93.9395 23.5482 93.9395 28.5037C93.9395 33.4593 91.6314 36.6371 87.7207 36.6371Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M66.0623 0C65.1517 0 64.2615 0.274926 63.5043 0.790013C62.7471 1.3051 62.157 2.03721 61.8085 2.89377C61.46 3.75033 61.3688 4.69286 61.5465 5.60218C61.7241 6.51149 62.1627 7.34675 62.8066 8.00234C63.4505 8.65792 64.2709 9.10437 65.1641 9.28525C66.0572 9.46612 66.983 9.37329 67.8243 9.01849C68.6656 8.66369 69.3847 8.06287 69.8906 7.29198C70.3966 6.5211 70.6666 5.61479 70.6666 4.68766C70.6666 3.44441 70.1815 2.25209 69.318 1.37298C68.4546 0.493877 67.2834 0 66.0623 0Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M157.276 14.0869H149.024V42.9434H157.276V14.0869Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M153.15 0C152.239 0 151.349 0.274926 150.592 0.790013C149.835 1.3051 149.244 2.03721 148.896 2.89377C148.547 3.75033 148.456 4.69286 148.634 5.60218C148.812 6.51149 149.25 7.34675 149.894 8.00234C150.538 8.65792 151.358 9.10437 152.251 9.28525C153.145 9.46612 154.07 9.37329 154.912 9.01849C155.753 8.66369 156.472 8.06287 156.978 7.29198C157.484 6.5211 157.754 5.61479 157.754 4.68766C157.754 3.44441 157.269 2.25209 156.405 1.37298C155.542 0.493877 154.371 0 153.15 0Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M217.431 29.4406C217.431 29.1483 217.431 28.8561 217.431 28.5639C217.431 19.6513 212.408 13.7217 204.12 13.7217C195.832 13.7217 190.259 19.6513 190.259 28.5639C190.259 37.4766 195.844 43.4061 204.12 43.4061C209.848 43.4061 214.118 40.6301 216.139 35.9424L210.159 33.0568C209.768 34.3052 208.985 35.3886 207.931 36.1407C206.877 36.8928 205.61 37.2723 204.323 37.2209C202.798 37.2639 201.314 36.7116 200.176 35.6771C199.038 34.6427 198.331 33.2043 198.2 31.6566H198.26L217.431 29.4406ZM197.997 26.5306C197.997 22.3421 200.449 19.6026 204.096 19.6026C205.599 19.5763 207.054 20.1351 208.165 21.1647C209.277 22.1944 209.96 23.6172 210.076 25.1425L197.997 26.5306Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M118.144 13.7217C109.856 13.7217 104.271 19.6513 104.271 28.5639C104.271 37.4766 109.856 43.4061 118.144 43.4061C123.861 43.4061 128.13 40.6301 130.103 35.9424L124.124 33.0568C123.739 34.2878 122.973 35.3589 121.94 36.1095C120.908 36.8602 119.664 37.2501 118.395 37.2209C116.856 37.2862 115.351 36.744 114.195 35.7073C113.038 34.6706 112.32 33.2195 112.188 31.6566L131.323 29.4162C131.323 29.124 131.323 28.8318 131.323 28.5396C131.443 19.6513 126.42 13.7217 118.144 13.7217ZM111.985 26.5306C111.985 22.3421 114.377 19.6026 118.096 19.6026C119.599 19.5763 121.054 20.1351 122.166 21.1647C123.277 22.1944 123.96 23.6172 124.076 25.1425L111.985 26.5306Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M142.506 34.2507V0.694336H134.254V35.103C134.254 39.0966 135.043 43.2729 142.027 43.2729C143.351 43.3435 144.673 43.1191 145.902 42.6154V36.1744C145.902 36.1744 142.506 37.0511 142.506 34.2507Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M217.454 50.5288H32.8874H32.8515V63.1916H0.23877V68.9994H38.5441V56.3245H217.454V50.5288Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }));
const SvgGProColor = (props2) => /* @__PURE__ */ React.createElement("svg", { width: 320, height: 69, viewBox: "0 0 320 69", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React.createElement("rect", { x: 230.989, y: 9.47412, width: 88.4255, height: 38.1626, rx: 19.0813, fill: "#CFC7FC", style: {
  fill: "#CFC7FC",
  fill: "color(display-p3 0.8118 0.7804 0.9882)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M245.036 17.064H254.941C256.194 17.064 257.336 17.261 258.365 17.655C259.395 18.0271 260.279 18.5633 261.018 19.2638C261.757 19.9423 262.328 20.7522 262.73 21.6934C263.133 22.6346 263.335 23.6634 263.335 24.7797C263.335 25.896 263.133 26.9248 262.73 27.866C262.328 28.8072 261.757 29.628 261.018 30.3284C260.279 31.007 259.395 31.5432 258.365 31.9372C257.336 32.3093 256.194 32.4954 254.941 32.4954H250.072V40.0469H245.036V17.064ZM254.773 27.8988C255.78 27.8988 256.586 27.6142 257.19 27.0451C257.817 26.4542 258.13 25.699 258.13 24.7797C258.13 23.8604 257.817 23.1161 257.19 22.547C256.586 21.9561 255.78 21.6606 254.773 21.6606H250.072V27.8988H254.773Z", fill: "#4428CE", style: {
  fill: "#4428CE",
  fill: "color(display-p3 0.2667 0.1569 0.8078)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M266.433 17.064H276.842C278.096 17.064 279.226 17.25 280.233 17.6221C281.263 17.9942 282.136 18.5196 282.852 19.1981C283.568 19.8766 284.117 20.6975 284.497 21.6606C284.878 22.6018 285.068 23.6415 285.068 24.7797C285.068 26.093 284.856 27.1874 284.43 28.063C284.027 28.9385 283.568 29.628 283.054 30.1314C282.472 30.7224 281.8 31.1821 281.039 31.5104L285.908 40.0469H280.368L276.17 32.4954H271.47V40.0469H266.433V17.064ZM276.674 27.8988C277.614 27.8988 278.375 27.6142 278.957 27.0451C279.562 26.4542 279.864 25.699 279.864 24.7797C279.864 23.8604 279.562 23.1161 278.957 22.547C278.375 21.9561 277.614 21.6606 276.674 21.6606H271.47V27.8988H276.674Z", fill: "#4428CE", style: {
  fill: "#4428CE",
  fill: "color(display-p3 0.2667 0.1569 0.8078)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M299.086 40.0469C297.453 40.0469 295.931 39.7426 294.52 39.1339C293.129 38.5252 291.919 37.7067 290.891 36.6782C289.863 35.6287 289.056 34.4114 288.472 33.0261C287.887 31.6198 287.595 30.1296 287.595 28.5554C287.595 26.9813 287.887 25.5015 288.472 24.1163C289.056 22.71 289.863 21.4926 290.891 20.4642C291.919 19.4147 293.129 18.5857 294.52 17.977C295.931 17.3683 297.453 17.064 299.086 17.064C300.719 17.064 302.231 17.3683 303.622 17.977C305.034 18.5857 306.253 19.4147 307.281 20.4642C308.31 21.4926 309.116 22.71 309.701 24.1163C310.285 25.5015 310.578 26.9813 310.578 28.5554C310.578 30.1296 310.285 31.6198 309.701 33.0261C309.116 34.4114 308.31 35.6287 307.281 36.6782C306.253 37.7067 305.034 38.5252 303.622 39.1339C302.231 39.7426 300.719 40.0469 299.086 40.0469ZM299.086 35.6392C300.034 35.6392 300.921 35.4608 301.747 35.104C302.574 34.7262 303.29 34.2225 303.894 33.5928C304.519 32.9422 305.003 32.1865 305.346 31.326C305.709 30.4654 305.89 29.5419 305.89 28.5554C305.89 27.569 305.709 26.6454 305.346 25.7849C305.003 24.9243 304.519 24.1792 303.894 23.5496C303.29 22.8989 302.574 22.3952 301.747 22.0384C300.921 21.6606 300.034 21.4717 299.086 21.4717C298.139 21.4717 297.252 21.6606 296.425 22.0384C295.598 22.3952 294.873 22.8989 294.248 23.5496C293.643 24.1792 293.159 24.9243 292.796 25.7849C292.453 26.6454 292.282 27.569 292.282 28.5554C292.282 29.5419 292.453 30.4654 292.796 31.326C293.159 32.1865 293.643 32.9422 294.248 33.5928C294.873 34.2225 295.598 34.7262 296.425 35.104C297.252 35.4608 298.139 35.6392 299.086 35.6392Z", fill: "#4428CE", style: {
  fill: "#4428CE",
  fill: "color(display-p3 0.2667 0.1569 0.8078)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M21.2276 18.2641C19.4696 15.3419 16.6233 13.6738 12.4495 13.6738C4.62821 13.7225 0 19.9443 0 28.5648C0 37.1852 4.62821 43.407 12.4495 43.407C13.8863 43.4851 15.3221 43.2361 16.6524 42.6779C17.9826 42.1197 19.1739 41.2665 20.1393 40.1804V44.3323C20.1393 47.1571 18.6444 50.5054 13.9086 50.5054C10.3208 50.5054 8.55083 48.4964 7.92896 46.3413L1.57862 49.4096C3.16919 53.4885 6.97222 56.9099 14.3511 56.9099C25.2937 56.9099 28.1041 49.5314 28.1041 43.0661V14.0878H21.407L21.2276 18.2641ZM14.1597 36.6373C10.249 36.6373 7.94092 33.4594 7.94092 28.5039C7.94092 23.5484 10.249 20.3705 14.1597 20.3705C18.0704 20.3705 20.3307 23.5484 20.3307 28.5039C20.3307 33.4594 18.0704 36.6373 14.1597 36.6373Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M177.188 13.6246C175.659 13.6195 174.148 13.9662 172.769 14.6388C171.39 15.3113 170.178 16.2924 169.223 17.5086L168.709 14.0872H161.641V42.9437H169.893V26.6526C169.893 22.1476 171.567 20.3821 174.88 20.3821C177.188 20.3821 179.102 21.4049 179.102 25.8003V42.9437H187.353V24.1201C187.353 18.02 183.574 13.6246 177.188 13.6246Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M49.3437 30.3659C49.3437 34.323 47.6695 36.6364 44.3687 36.6364C42.0606 36.6364 40.1352 35.6136 40.1352 31.2182V14.0869H31.8833V32.8741C31.8833 38.9619 35.6624 43.3817 42.0486 43.3817C43.5805 43.3854 45.0935 43.0369 46.4746 42.3623C47.8558 41.6876 49.0696 40.7043 50.0254 39.4855L50.5397 42.9191H57.5956V14.0869H49.3437V30.3659Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M70.1889 14.0869H61.937V42.9434H70.1889V14.0869Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M93.0904 16.2062C91.094 14.4873 88.525 13.6154 85.9149 13.7711C78.0577 13.7711 73.4175 19.9929 73.4175 28.6133C73.4175 37.2337 78.0577 43.4555 85.9149 43.4555C87.5879 43.5639 89.2596 43.2227 90.7624 42.4663C92.2652 41.7098 93.5464 40.5646 94.4776 39.1453L94.681 42.9442H101.378V0.694336H93.1263L93.0904 16.2062ZM87.7207 36.6371C83.81 36.6371 81.5019 33.4593 81.5019 28.5037C81.5019 23.5482 83.81 20.3703 87.7207 20.3703C91.6314 20.3703 93.9395 23.5482 93.9395 28.5037C93.9395 33.4593 91.6314 36.6371 87.7207 36.6371Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M66.0623 0C65.1517 0 64.2615 0.274926 63.5043 0.790013C62.7471 1.3051 62.157 2.03721 61.8085 2.89377C61.46 3.75033 61.3688 4.69286 61.5465 5.60218C61.7241 6.51149 62.1627 7.34675 62.8066 8.00234C63.4505 8.65792 64.2709 9.10437 65.1641 9.28525C66.0572 9.46612 66.983 9.37329 67.8243 9.01849C68.6656 8.66369 69.3847 8.06287 69.8906 7.29198C70.3966 6.5211 70.6666 5.61479 70.6666 4.68766C70.6666 3.44441 70.1815 2.25209 69.318 1.37298C68.4546 0.493877 67.2834 0 66.0623 0Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M157.276 14.0869H149.024V42.9434H157.276V14.0869Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M153.15 0C152.239 0 151.349 0.274926 150.592 0.790013C149.835 1.3051 149.244 2.03721 148.896 2.89377C148.547 3.75033 148.456 4.69286 148.634 5.60218C148.812 6.51149 149.25 7.34675 149.894 8.00234C150.538 8.65792 151.358 9.10437 152.251 9.28525C153.145 9.46612 154.07 9.37329 154.912 9.01849C155.753 8.66369 156.472 8.06287 156.978 7.29198C157.484 6.5211 157.754 5.61479 157.754 4.68766C157.754 3.44441 157.269 2.25209 156.405 1.37298C155.542 0.493877 154.371 0 153.15 0Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M217.431 29.4406C217.431 29.1483 217.431 28.8561 217.431 28.5639C217.431 19.6513 212.408 13.7217 204.12 13.7217C195.832 13.7217 190.259 19.6513 190.259 28.5639C190.259 37.4766 195.844 43.4061 204.12 43.4061C209.848 43.4061 214.118 40.6301 216.139 35.9424L210.159 33.0568C209.768 34.3052 208.985 35.3886 207.931 36.1407C206.877 36.8928 205.61 37.2723 204.323 37.2209C202.798 37.2639 201.314 36.7116 200.176 35.6771C199.038 34.6427 198.331 33.2043 198.2 31.6566H198.26L217.431 29.4406ZM197.997 26.5306C197.997 22.3421 200.449 19.6026 204.096 19.6026C205.599 19.5763 207.054 20.1351 208.165 21.1647C209.277 22.1944 209.96 23.6172 210.076 25.1425L197.997 26.5306Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M118.144 13.7217C109.856 13.7217 104.271 19.6513 104.271 28.5639C104.271 37.4766 109.856 43.4061 118.144 43.4061C123.861 43.4061 128.13 40.6301 130.103 35.9424L124.124 33.0568C123.739 34.2878 122.973 35.3589 121.94 36.1095C120.908 36.8602 119.664 37.2501 118.395 37.2209C116.856 37.2862 115.351 36.744 114.195 35.7073C113.038 34.6706 112.32 33.2195 112.188 31.6566L131.323 29.4162C131.323 29.124 131.323 28.8318 131.323 28.5396C131.443 19.6513 126.42 13.7217 118.144 13.7217ZM111.985 26.5306C111.985 22.3421 114.377 19.6026 118.096 19.6026C119.599 19.5763 121.054 20.1351 122.166 21.1647C123.277 22.1944 123.96 23.6172 124.076 25.1425L111.985 26.5306Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M142.506 34.2507V0.694336H134.254V35.103C134.254 39.0966 135.043 43.2729 142.027 43.2729C143.351 43.3435 144.673 43.1191 145.902 42.6154V36.1744C145.902 36.1744 142.506 37.0511 142.506 34.2507Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M217.454 50.5288H32.8874H32.8515V63.1916H0.23877V68.9994H38.5441V56.3245H217.454V50.5288Z", fill: "#150A45", style: {
  fill: "#150A45",
  fill: "color(display-p3 0.0824 0.0392 0.2706)",
  fillOpacity: 1
} }));
const cobrandedLogos = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GuidelineCobrandedADP: SvgAdp,
  GuidelineCobrandedAmex: SvgAmex,
  GuidelineCobrandedBambooHR: SvgBambooHr,
  GuidelineCobrandedBennie: SvgBennie,
  GuidelineCobrandedBoxGroup: SvgBoxGroup,
  GuidelineCobrandedBrex: SvgBrex,
  GuidelineCobrandedCapitalOneBusinessDeals: SvgCapitalOneBusinessDeals,
  GuidelineCobrandedCapitalOneSpring: SvgCapitalOneSpring,
  GuidelineCobrandedCompactADP: SvgAdp$1,
  GuidelineCobrandedCompactAmex: SvgAmex$1,
  GuidelineCobrandedCompactBambooHR: SvgBambooHr$1,
  GuidelineCobrandedCompactBennie: SvgBennie$1,
  GuidelineCobrandedCompactBoxGroup: SvgBoxGroup$1,
  GuidelineCobrandedCompactBrex: SvgBrex$1,
  GuidelineCobrandedCompactCapitalOneBusinessDeals: SvgCapitalOneBusinessDeals$1,
  GuidelineCobrandedCompactCapitalOneSpring: SvgCapitalOneSpring$1,
  GuidelineCobrandedCompactDeel: SvgDeel$1,
  GuidelineCobrandedCompactExpensify: SvgExpensify$1,
  GuidelineCobrandedCompactFelicis: SvgFelicis$1,
  GuidelineCobrandedCompactGProBlack: SvgGProBlack$1,
  GuidelineCobrandedCompactGProColor: SvgGProColor$1,
  GuidelineCobrandedCompactGeneralAtlantic: SvgGeneralAtlantic$1,
  GuidelineCobrandedCompactGenerationIM: SvgGenerationIm$1,
  GuidelineCobrandedCompactGosite: SvgGosite$1,
  GuidelineCobrandedCompactGusto: SvgGusto$1,
  GuidelineCobrandedCompactHeard: SvgHeard$1,
  GuidelineCobrandedCompactISolved: SvgISolved$1,
  GuidelineCobrandedCompactJustworks: SvgJustworks$1,
  GuidelineCobrandedCompactLererHippeau: SvgLererHippeau$1,
  GuidelineCobrandedCompactLoot: SvgLoot$1,
  GuidelineCobrandedCompactNamely: SvgNamely$1,
  GuidelineCobrandedCompactOnpay: SvgOnpay$1,
  GuidelineCobrandedCompactOwnerActions: SvgOwnerActions$1,
  GuidelineCobrandedCompactPaychex: SvgPaychex$1,
  GuidelineCobrandedCompactPaycom: SvgPaycom$1,
  GuidelineCobrandedCompactPaycor: SvgPaycor$1,
  GuidelineCobrandedCompactPaylocity: SvgPaylocity$1,
  GuidelineCobrandedCompactPrimePay: SvgPrimePay$1,
  GuidelineCobrandedCompactProliant: SvgProliant$1,
  GuidelineCobrandedCompactPropel: SvgPropel$1,
  GuidelineCobrandedCompactQBO: SvgQbo$1,
  GuidelineCobrandedCompactRippling: SvgRippling$1,
  GuidelineCobrandedCompactRubyMoney: SvgRubyMoney$1,
  GuidelineCobrandedCompactSVB: SvgSvb$1,
  GuidelineCobrandedCompactSquare: SvgSquare$1,
  GuidelineCobrandedCompactStartupGrind: SvgStartupGrind$1,
  GuidelineCobrandedCompactStripe: SvgStripe$1,
  GuidelineCobrandedCompactTigerGlobal: SvgTigerGlobal$1,
  GuidelineCobrandedCompactXfund: SvgXfund$1,
  GuidelineCobrandedCompactZenefits: SvgZenefits$1,
  GuidelineCobrandedDeel: SvgDeel,
  GuidelineCobrandedExpensify: SvgExpensify,
  GuidelineCobrandedFelicis: SvgFelicis,
  GuidelineCobrandedGProBlack: SvgGProBlack,
  GuidelineCobrandedGProColor: SvgGProColor,
  GuidelineCobrandedGeneralAtlantic: SvgGeneralAtlantic,
  GuidelineCobrandedGenerationIM: SvgGenerationIm,
  GuidelineCobrandedGosite: SvgGosite,
  GuidelineCobrandedGusto: SvgGusto,
  GuidelineCobrandedHeard: SvgHeard,
  GuidelineCobrandedISolved: SvgISolved,
  GuidelineCobrandedJustworks: SvgJustworks,
  GuidelineCobrandedLererHippeau: SvgLererHippeau,
  GuidelineCobrandedLoot: SvgLoot,
  GuidelineCobrandedNamely: SvgNamely,
  GuidelineCobrandedOnpay: SvgOnpay,
  GuidelineCobrandedOwnerActions: SvgOwnerActions,
  GuidelineCobrandedPaychex: SvgPaychex,
  GuidelineCobrandedPaycom: SvgPaycom,
  GuidelineCobrandedPaycor: SvgPaycor,
  GuidelineCobrandedPaylocity: SvgPaylocity,
  GuidelineCobrandedPrimePay: SvgPrimePay,
  GuidelineCobrandedProliant: SvgProliant,
  GuidelineCobrandedPropel: SvgPropel,
  GuidelineCobrandedQBO: SvgQbo,
  GuidelineCobrandedRippling: SvgRippling,
  GuidelineCobrandedRubyMoney: SvgRubyMoney,
  GuidelineCobrandedSVB: SvgSvb,
  GuidelineCobrandedSquare: SvgSquare,
  GuidelineCobrandedStartupGrind: SvgStartupGrind,
  GuidelineCobrandedStripe: SvgStripe,
  GuidelineCobrandedTigerGlobal: SvgTigerGlobal,
  GuidelineCobrandedXfund: SvgXfund,
  GuidelineCobrandedZenefits: SvgZenefits
}, Symbol.toStringTag, { value: "Module" }));
const allLogos = {
  ...logos,
  ...cobrandedLogos
};
function getLogoByKey(key) {
  if (key in allLogos) {
    return allLogos[key];
  }
  console.warn(
    `Could not find logo for ${key}, defaulting to GuidelineDefault logo.`
  );
  return allLogos.GuidelineDefault;
}
var classnames2 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(module2) {
  (function() {
    var hasOwn2 = {}.hasOwnProperty;
    function classNames2() {
      var classes = "";
      for (var i2 = 0; i2 < arguments.length; i2++) {
        var arg = arguments[i2];
        if (arg) {
          classes = appendClass(classes, parseValue(arg));
        }
      }
      return classes;
    }
    function parseValue(arg) {
      if (typeof arg === "string" || typeof arg === "number") {
        return arg;
      }
      if (typeof arg !== "object") {
        return "";
      }
      if (Array.isArray(arg)) {
        return classNames2.apply(null, arg);
      }
      if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
        return arg.toString();
      }
      var classes = "";
      for (var key in arg) {
        if (hasOwn2.call(arg, key) && arg[key]) {
          classes = appendClass(classes, key);
        }
      }
      return classes;
    }
    function appendClass(value, newClass) {
      if (!newClass) {
        return value;
      }
      if (value) {
        return value + " " + newClass;
      }
      return value + newClass;
    }
    if (module2.exports) {
      classNames2.default = classNames2;
      module2.exports = classNames2;
    } else {
      window.classNames = classNames2;
    }
  })();
})(classnames2);
var classnamesExports = classnames2.exports;
const classNames = /* @__PURE__ */ getDefaultExportFromCjs(classnamesExports);
const Text$1 = forwardRef(
  ({
    children: children2,
    as = "span",
    className = void 0,
    color: color2,
    ...restOfProps
  }, ref2) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text$2,
      {
        as,
        className: classNames(className, "gui"),
        color: color2,
        ref: ref2,
        ...restOfProps,
        children: children2
      }
    );
  }
);
var TextColors = /* @__PURE__ */ ((TextColors2) => {
  TextColors2["primary"] = "text.primary";
  TextColors2["secondary"] = "text.secondary";
  TextColors2["tertiary"] = "text.tertiary";
  TextColors2["disable"] = "text.subdued";
  TextColors2["white"] = "text.white";
  return TextColors2;
})(TextColors || {});
const base$e = {
  fontFamily: "body",
  fontWeight: "normal"
};
var CaptionSizes = /* @__PURE__ */ ((CaptionSizes2) => {
  CaptionSizes2["default"] = "12";
  CaptionSizes2["Caption12"] = "12";
  return CaptionSizes2;
})(CaptionSizes || {});
const variants$b = {
  "caption-12": {
    ...base$e,
    fontSize: 12,
    lineHeight: 1,
    letterSpacing: 0
  }
};
const Caption = ({
  as = "span",
  bottomSpace = void 0,
  children: children2 = null,
  color: color2 = TextColors.secondary,
  sx: sx2 = {},
  variant: variant3 = CaptionSizes.default,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2, { bottomSpace });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$1,
    {
      as,
      color: color2,
      sx: {
        ...style2(captionStyles(variant3)),
        ...bottomSpace != null && { mb: bottomSpace },
        ...sx2
      },
      variant: `caption-${variant3}`,
      ...restOfProps,
      children: children2
    }
  );
};
const captionStyles = (variant3) => ({
  mb: `caption.${variant3}`
});
const baseLabelStyles$3 = {
  fontWeight: "bold"
};
var LabelSizes = /* @__PURE__ */ ((LabelSizes2) => {
  LabelSizes2["default"] = "16";
  LabelSizes2["Label24"] = "24";
  LabelSizes2["Label18"] = "18";
  LabelSizes2["Label16"] = "16";
  LabelSizes2["Label14"] = "14";
  return LabelSizes2;
})(LabelSizes || {});
const labelVariants = {
  default: {
    ...baseLabelStyles$3,
    color: "foreground.primary"
  },
  disabled: {
    ...baseLabelStyles$3,
    color: "foreground.secondary"
  }
};
const Label2 = ({
  children: children2 = null,
  color: color2 = TextColors.primary,
  id = void 0,
  htmlFor,
  sx: sx2 = {},
  disallowSelect = false,
  variant: variant3 = LabelSizes.default,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$1,
    {
      ...restOfProps,
      as: "label",
      color: color2,
      htmlFor,
      id,
      sx: style2({
        width: "100%",
        display: "flex",
        userSelect: disallowSelect ? "none" : "auto"
      }),
      variant: `paragraph-${variant3}`,
      children: children2
    }
  );
};
const base$d = {
  fontFamily: "body",
  fontWeight: "normal"
};
var ParagraphSizes = /* @__PURE__ */ ((ParagraphSizes2) => {
  ParagraphSizes2["default"] = "16";
  ParagraphSizes2["Paragraph24"] = "24";
  ParagraphSizes2["Paragraph18"] = "18";
  ParagraphSizes2["Paragraph16"] = "16";
  ParagraphSizes2["Paragraph14"] = "14";
  return ParagraphSizes2;
})(ParagraphSizes || {});
var SpanSizes = /* @__PURE__ */ ((SpanSizes2) => {
  SpanSizes2["default"] = "16";
  SpanSizes2["Span24"] = "24";
  SpanSizes2["Span18"] = "18";
  SpanSizes2["Span16"] = "16";
  SpanSizes2["Span14"] = "14";
  return SpanSizes2;
})(SpanSizes || {});
const variants$a = {
  "paragraph-24": {
    ...base$d,
    fontSize: buildResponsiveValues({ mdUp: 24, smDown: 18 }),
    lineHeight: buildResponsiveValues({ mdUp: 2, smDown: 1.625 }),
    letterSpacing: buildResponsiveValues({ mdUp: -0.6, smDown: -0.4 })
  },
  "paragraph-18": {
    ...base$d,
    fontSize: 18,
    lineHeight: 1.625,
    letterSpacing: -0.4
  },
  "paragraph-16": {
    ...base$d,
    fontSize: 16,
    lineHeight: 1.375,
    letterSpacing: 0
  },
  "paragraph-14": {
    ...base$d,
    fontSize: 14,
    lineHeight: 1.25,
    letterSpacing: 0
  }
};
const Paragraph2 = ({
  children: children2 = null,
  color: color2 = TextColors.secondary,
  sx: sx2 = {},
  variant: variant3 = "16",
  className = void 0,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$1,
    {
      as: "p",
      className,
      color: color2,
      sx: style2(paragraphStyles(variant3)),
      variant: `paragraph-${variant3}`,
      ...restOfProps,
      children: children2
    }
  );
};
const paragraphStyles = (variant3) => ({
  mb: `paragraph.${variant3}`
});
const Span = ({
  children: children2 = null,
  color: color2 = TextColors.secondary,
  sx: sx2 = {},
  variant: variant3 = SpanSizes.default,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$1,
    {
      as: "span",
      color: color2,
      sx: style2(),
      variant: `paragraph-${variant3}`,
      ...restOfProps,
      children: children2
    }
  );
};
const base$c = {
  fontFamily: "heading",
  fontWeight: "demibold",
  textWrap: "pretty"
};
var TitleSizes$1 = /* @__PURE__ */ ((TitleSizes2) => {
  TitleSizes2["Title80"] = "80";
  TitleSizes2["Title64"] = "64";
  TitleSizes2["Title48"] = "48";
  TitleSizes2["Title40"] = "40";
  TitleSizes2["Title32"] = "32";
  TitleSizes2["Title24"] = "24";
  TitleSizes2["Title18"] = "18";
  TitleSizes2["Title16"] = "16";
  TitleSizes2["Title14"] = "14";
  return TitleSizes2;
})(TitleSizes$1 || {});
const variants$9 = {
  "title-80": {
    ...base$c,
    fontSize: buildResponsiveValues({ mdUp: 80, smDown: 48 }),
    lineHeight: buildResponsiveValues({ mdUp: 5.5, smDown: 3.375 }),
    letterSpacing: -2
  },
  "title-64": {
    ...base$c,
    fontSize: buildResponsiveValues({ mdUp: 64, smDown: 48 }),
    lineHeight: buildResponsiveValues({ mdUp: 4.5, smDown: 3.375 }),
    letterSpacing: -2
  },
  "title-48": {
    ...base$c,
    fontSize: 48,
    lineHeight: 3.375,
    letterSpacing: -2
  },
  "title-40": {
    ...base$c,
    fontSize: 40,
    lineHeight: 3,
    letterSpacing: -2
  },
  "title-32": {
    ...base$c,
    fontSize: 32,
    lineHeight: 2.5,
    letterSpacing: -1.6
  },
  "title-24": {
    ...base$c,
    fontSize: 24,
    lineHeight: 2,
    letterSpacing: -0.6
  },
  "title-18": {
    ...base$c,
    fontSize: 18,
    lineHeight: 1.625,
    letterSpacing: -0.4
  },
  "title-16": {
    ...base$c,
    fontSize: 16,
    lineHeight: 1.375,
    letterSpacing: 0
  },
  "title-14": {
    ...base$c,
    fontSize: 14,
    lineHeight: 1.25,
    letterSpacing: 0
  },
  "title-12": {
    ...base$c,
    fontSize: 12,
    lineHeight: 1,
    letterSpacing: 0
  }
};
const Title = forwardRef(
  ({
    as = "span",
    bottomSpace = 0,
    children: children2,
    color: color2 = TextColors.primary,
    dataTestId,
    sx: sx2 = {},
    variant: variant3,
    ...restOfProps
  }, ref2) => {
    const { style: style2 } = useStyle(sx2, { bottomSpace });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text$1,
      {
        as,
        color: color2,
        "data-test-id": dataTestId,
        ref: ref2,
        sx: style2(),
        variant: `title-${variant3}`,
        ...restOfProps,
        children: children2
      }
    );
  }
);
const base$b = {
  textDecoration: "underline",
  "&:hover": {
    textDecoration: "none"
  },
  "&:active": {
    opacity: 0.7
  },
  "&:focus-visible": {
    outline: "solid transparent",
    border: "link.focusedVisible",
    borderRadius: "link.focus",
    borderColor: "link.border.focused"
  },
  cursor: "pointer"
};
const variants$8 = {
  default: {
    ...base$b,
    color: "link"
  },
  standalone: {
    ...base$b,
    color: "link.standalone",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  standaloneVibrant: {
    ...base$b,
    color: "link.vibrant",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  subtle: {
    ...base$b,
    color: "link.subtle"
  },
  vibrant: {
    ...base$b,
    color: "link.vibrant"
  }
};
var LinkVariant = /* @__PURE__ */ ((LinkVariant2) => {
  LinkVariant2["default"] = "links.default";
  LinkVariant2["standalone"] = "links.standalone";
  LinkVariant2["standaloneVibrant"] = "links.standaloneVibrant";
  LinkVariant2["subtle"] = "links.subtle";
  LinkVariant2["vibrant"] = "links.vibrant";
  return LinkVariant2;
})(LinkVariant || {});
var PopoverDelayCloseTime = /* @__PURE__ */ ((PopoverDelayCloseTime2) => {
  PopoverDelayCloseTime2[PopoverDelayCloseTime2["immediate"] = 0] = "immediate";
  PopoverDelayCloseTime2[PopoverDelayCloseTime2["short"] = 500] = "short";
  PopoverDelayCloseTime2[PopoverDelayCloseTime2["long"] = 1e3] = "long";
  return PopoverDelayCloseTime2;
})(PopoverDelayCloseTime || {});
const noop$6 = () => {
};
const callAllFunctions = (...fns) => (...args) => {
  if (fns) {
    fns.forEach((fn2) => fn2 && fn2(...args));
  }
};
const toRem = (val) => `${val / 16}rem`;
const base$a = {
  0: "0",
  0.25: "0.25rem",
  0.375: "0.375rem",
  0.5: "0.5rem",
  0.625: "0.625rem",
  0.75: "0.75rem",
  1: "1rem",
  1.25: "1.25rem",
  1.5: "1.5rem",
  2: "2rem",
  2.25: "2.25rem",
  2.5: "2.5rem",
  2.75: "2.75rem",
  3: "3rem",
  4: "4rem",
  5: "5rem",
  6: "6rem",
  8: "8rem"
};
Object.keys(base$a).map((v) => +v);
const popoverSpacing = {
  // px used to nudge the tail into it's correct position
  // on its parent.
  baseTailNudge: 0,
  padding: base$a[1],
  gap: base$a[0.5]
};
var PopoverVariant = /* @__PURE__ */ ((PopoverVariant2) => {
  PopoverVariant2["default"] = "default";
  PopoverVariant2["tooltip"] = "tooltip";
  return PopoverVariant2;
})(PopoverVariant || {});
const { baseTailNudge } = popoverSpacing;
const popoverStyleBase = {
  minWidth: "",
  overflowWrap: "break-word",
  position: "absolute",
  visibility: "hidden",
  zIndex: "popover"
};
const baseTailStyle = {
  position: "absolute"
};
const popoverVariants = {
  [
    "default"
    /* default */
  ]: {
    ...popoverStyleBase,
    backgroundColor: "popover.default.background",
    borderRadius: "popover.default",
    boxShadow: "elevation.four",
    color: "popover.default.text",
    justifyContent: "center",
    maxWidth: "popover.default.maxWidth",
    minWidth: "popover.default.minWidth",
    padding: "popover.padding",
    textAlign: "center"
  },
  [
    "tooltip"
    /* tooltip */
  ]: {
    ...popoverStyleBase,
    backgroundColor: "popover.tooltip.background",
    borderColor: "popover.tooltip.border",
    borderRadius: "popover.tooltip",
    color: "popover.tooltip.text",
    display: "inline-block",
    justifyContent: "center",
    maxWidth: "popover.tooltip.maxWidth",
    minWidth: "popover.tooltip.minWidth",
    textAlign: "center",
    padding: "tooltip.padding"
  },
  tail: {
    bottom: (nudge) => {
      return {
        ...baseTailStyle,
        top: toRem(nudge + baseTailNudge)
      };
    },
    right: (nudge) => {
      return {
        ...baseTailStyle,
        left: toRem(nudge + baseTailNudge)
      };
    },
    left: (nudge) => {
      return {
        ...baseTailStyle,
        right: toRem(nudge + baseTailNudge)
      };
    },
    top: (nudge) => {
      return {
        ...baseTailStyle,
        bottom: toRem(nudge + baseTailNudge)
      };
    }
  }
};
const tailStyleProps = {
  [
    "default"
    /* default */
  ]: {
    fill: popoverVariants.default.backgroundColor,
    stroke: popoverVariants.default.backgroundColor
  },
  [
    "tooltip"
    /* tooltip */
  ]: {
    fill: popoverVariants.tooltip.backgroundColor,
    stroke: popoverVariants.tooltip.backgroundColor
  }
};
const popoverMargin = 8;
const Context$a = React__default.createContext(void 0);
const Provider$1 = ({
  children: children2,
  variant: variant3 = PopoverVariant.default,
  delayClosingTime = PopoverDelayCloseTime.immediate,
  persistContentOnHover = false
}) => {
  const [popoverState, preparePopover] = useState({
    source: null,
    visible: false
  });
  const memoizedContext = useMemo(() => {
    let closingTimeOutId = null;
    const cancelDismissOrMakeItVisible = (source) => {
      if (closingTimeOutId) {
        clearTimeout(closingTimeOutId);
      } else {
        preparePopover({ source, visible: true });
      }
    };
    const triggerDelayDismiss = () => {
      return setTimeout(() => {
        preparePopover({ source: null, visible: false });
      }, delayClosingTime);
    };
    return {
      popoverState,
      toggle: async (source, { onAction, onOpen }, handleError) => {
        try {
          if (popoverState.visible) {
            await (onAction == null ? void 0 : onAction(source));
            closingTimeOutId = triggerDelayDismiss();
          } else {
            await (onOpen == null ? void 0 : onOpen(source));
            cancelDismissOrMakeItVisible(source);
          }
        } catch (e3) {
          handleError == null ? void 0 : handleError(e3);
        }
      },
      open: async (source, action2, handleError) => {
        try {
          await (action2 == null ? void 0 : action2(source));
          cancelDismissOrMakeItVisible(source);
        } catch (e3) {
          handleError == null ? void 0 : handleError(e3);
        }
      },
      dismiss: async (action2, handleError) => {
        try {
          await (action2 == null ? void 0 : action2());
          closingTimeOutId = triggerDelayDismiss();
        } catch (e3) {
          handleError == null ? void 0 : handleError(e3);
        }
      },
      variant: variant3,
      delayClosingTime,
      persistContentOnHover
    };
  }, [popoverState, variant3, delayClosingTime, persistContentOnHover]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$a.Provider, { value: memoizedContext, children: children2 });
};
const usePlaceablePopover = () => {
  const context = useContext(Context$a);
  if (context === void 0 || context === null) {
    throw new Error(
      "usePlaceablePopover must be used within a Popover Provider"
    );
  }
  return context;
};
var Alignment = /* @__PURE__ */ ((Alignment2) => {
  Alignment2["center"] = "center";
  Alignment2["left"] = "left";
  Alignment2["right"] = "right";
  Alignment2["top"] = "top";
  Alignment2["bottom"] = "bottom";
  Alignment2["initial"] = "initial";
  return Alignment2;
})(Alignment || {});
var Triggers = /* @__PURE__ */ ((Triggers2) => {
  Triggers2["hover"] = "hover";
  Triggers2["click"] = "click";
  return Triggers2;
})(Triggers || {});
var PositionAlignment = /* @__PURE__ */ ((PositionAlignment2) => {
  PositionAlignment2["start"] = "start";
  PositionAlignment2["end"] = "end";
  return PositionAlignment2;
})(PositionAlignment || {});
const AlignmentToChevronMapping = {
  [
    "top"
    /* top */
  ]: "Down",
  [
    "bottom"
    /* bottom */
  ]: "Up",
  [
    "right"
    /* right */
  ]: "Left",
  [
    "left"
    /* left */
  ]: "Right",
  [
    "initial"
    /* initial */
  ]: null,
  [
    "center"
    /* center */
  ]: null
};
const Tail = React__default.forwardRef(
  ({
    // varaint as defined in syles/theme
    variant: variant3 = PopoverVariant.default,
    // Alignment of the popover determines the placement of the tail.
    placement = Alignment.bottom,
    // Nudges the tail so that it's placed correctly on the parent.
    nudgingValue,
    tailStyles
  }, ref2) => {
    if (placement === Alignment.initial)
      return null;
    const chevronDirection = AlignmentToChevronMapping[placement];
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        ref: ref2,
        sx: (theme2) => ({
          ...tailStyles,
          ...theme2.popover.tail[placement](nudgingValue)
        }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            "data-test-id": "tail",
            name: `popoverTail${chevronDirection}`,
            size: IconSizes.Icon16,
            ...tailStyleProps[variant3]
          }
        )
      }
    );
  }
);
var fromEntries = function fromEntries2(entries6) {
  return entries6.reduce(function(acc, _ref2) {
    var key = _ref2[0], value = _ref2[1];
    acc[key] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect$3 = typeof window !== "undefined" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto$1 = "auto";
var basePlacements = [top, bottom, right, left];
var start$3 = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start$3, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto$1]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start$3, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main$1 = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main$1, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node2) {
  if (node2 == null) {
    return window;
  }
  if (node2.toString() !== "[object Window]") {
    var ownerDocument = node2.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node2;
}
function isElement$2(node2) {
  var OwnElement = getWindow(node2).Element;
  return node2 instanceof OwnElement || node2 instanceof Element;
}
function isHTMLElement(node2) {
  var OwnElement = getWindow(node2).HTMLElement;
  return node2 instanceof OwnElement || node2 instanceof HTMLElement;
}
function isShadowRoot(node2) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node2).ShadowRoot;
  return node2 instanceof OwnElement || node2 instanceof ShadowRoot;
}
function applyStyles(_ref2) {
  var state = _ref2.state;
  Object.keys(state.elements).forEach(function(name2) {
    var style2 = state.styles[name2] || {};
    var attributes = state.attributes[name2] || {};
    var element = state.elements[name2];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name3) {
      var value = attributes[name3];
      if (value === false) {
        element.removeAttribute(name3);
      } else {
        element.setAttribute(name3, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name2) {
      var element = state.elements[name2];
      var attributes = state.attributes[name2] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name2) ? state.styles[name2] : initialStyles[name2]);
      var style2 = styleProperties.reduce(function(style3, property2) {
        style3[property2] = "";
        return style3;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
const applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
var max$3 = Math.max;
var min$2 = Math.min;
var round = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref2 = isElement$2(element) ? getWindow(element) : window, visualViewport = _ref2.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x3 = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y4 = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y4,
    right: x3 + width,
    bottom: y4 + height,
    left: x3,
    x: x3,
    y: y4
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains$1(parent2, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent2.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next2 = child;
    do {
      if (next2 && parent2.isSameNode(next2)) {
        return true;
      }
      next2 = next2.parentNode || next2.host;
    } while (next2);
  }
  return false;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement$2(element) ? element.ownerDocument : (
    // $FlowFixMe[prop-missing]
    element.document
  )) || window.document).documentElement;
}
function getParentNode$1(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    (isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element)
  );
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle$1(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode$1(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css3 = getComputedStyle$1(currentNode);
    if (css3.transform !== "none" || css3.perspective !== "none" || css3.contain === "paint" || ["transform", "perspective"].indexOf(css3.willChange) !== -1 || isFirefox && css3.willChange === "filter" || isFirefox && css3.filter && css3.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min2, value, max2) {
  return max$3(min2, min$2(value, max2));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys8) {
  return keys8.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding2, state) {
  padding2 = typeof padding2 === "function" ? padding2(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding2;
  return mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
};
function arrow(_ref2) {
  var _state$modifiersData$;
  var state = _ref2.state, name2 = _ref2.name, options2 = _ref2.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical2 = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical2 ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options2.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name2] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options2 = _ref2.options;
  var _options$element = options2.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains$1(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
const arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref2, win) {
  var x3 = _ref2.x, y4 = _ref2.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x3 * dpr) / dpr || 0,
    y: round(y4 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position2 = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x3 = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y4 = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x: x3,
    y: y4
  }) : {
    x: x3,
    y: y4
  };
  x3 = _ref3.x;
  y4 = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle$1(offsetParent).position !== "static" && position2 === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        offsetParent[heightProp]
      );
      y4 -= offsetY - popperRect.height;
      y4 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        offsetParent[widthProp]
      );
      x3 -= offsetX - popperRect.width;
      x3 *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x3,
    y: y4
  }, getWindow(popper2)) : {
    x: x3,
    y: y4
  };
  x3 = _ref4.x;
  y4 = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x3 + "px, " + y4 + "px)" : "translate3d(" + x3 + "px, " + y4 + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y4 + "px" : "", _Object$assign2[sideX] = hasX ? x3 + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options2 = _ref5.options;
  var _options$gpuAccelerat = options2.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options2.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options2.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref2) {
  var state = _ref2.state, instance = _ref2.instance, options2 = _ref2.options;
  var _options$scroll = options2.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options2.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node2) {
  var win = getWindow(node2);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x3 = 0;
  var y4 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x3 = visualViewport.offsetLeft;
      y4 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x3 + getWindowScrollBarX(element),
    y: y4
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max$3(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max$3(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x3 = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y4 = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x3 += max$3(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x: x3,
    y: y4
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node2) {
  if (["html", "body", "#document"].indexOf(getNodeName(node2)) >= 0) {
    return node2.ownerDocument.body;
  }
  if (isHTMLElement(node2) && isScrollParent(node2)) {
    return node2;
  }
  return getScrollParent(getParentNode$1(node2));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode$1(target)))
  );
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$2(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement$2(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$2(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max$3(rect.top, accRect.top);
    accRect.right = min$2(rect.right, accRect.right);
    accRect.bottom = min$2(rect.bottom, accRect.bottom);
    accRect.left = max$3(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref2) {
  var reference2 = _ref2.reference, element = _ref2.element, placement = _ref2.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start$3:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$2(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding2 = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a4, b10) {
    return overflows[a4] - overflows[b10];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto$1) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref2) {
  var state = _ref2.state, options2 = _ref2.options, name2 = _ref2.name;
  if (state.modifiersData[name2]._skip) {
    return;
  }
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options2.fallbackPlacements, padding2 = options2.padding, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, _options$flipVariatio = options2.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options2.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto$1 ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i2 = 0; i2 < placements2.length; i2++) {
    var placement = placements2[i2];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start$3;
    var isVertical2 = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical2 ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding: padding2
    });
    var mainVariationSide = isVertical2 ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop3 = function _loop4(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop3(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name2]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
const flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref2) {
  var state = _ref2.state, name2 = _ref2.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name2] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
const hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref2 = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref2[0], distance = _ref2[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options2 = _ref2.options, name2 = _ref2.name;
  var _options$offset = options2.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x3 = _data$state$placement.x, y4 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x3;
    state.modifiersData.popperOffsets.y += y4;
  }
  state.modifiersData[name2] = data;
}
const offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref2) {
  var state = _ref2.state, name2 = _ref2.name;
  state.modifiersData[name2] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref2) {
  var state = _ref2.state, options2 = _ref2.options, name2 = _ref2.name;
  var _options$mainAxis = options2.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options2.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options2.boundary, rootBoundary = options2.rootBoundary, altBoundary = options2.altBoundary, padding2 = options2.padding, _options$tether = options2.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options2.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding: padding2,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min2 = offset2 + overflow[mainSide];
    var max2 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start$3 ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start$3 ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min$2(min2, tetherMin) : min2, offset2, tether ? max$3(max2, tetherMax) : max2);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name2] = data;
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node2) {
  if (node2 === getWindow(node2) || !isHTMLElement(node2)) {
    return getWindowScroll(node2);
  } else {
    return getHTMLElementScroll(node2);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map2 = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map2.set(modifier.name, modifier);
  });
  function sort3(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map2.get(dep);
        if (depModifier) {
          sort3(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort3(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$2(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS$1 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options2) {
    if (options2 === void 0) {
      options2 = defaultOptions2;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS$1, defaultOptions2),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options3 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions2, state.options, options3);
        state.scrollParents = {
          reference: isElement$2(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m3) {
          return m3.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name2 = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name: name2,
              instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options2).then(function(state2) {
      if (!isDestroyed && options2.onFirstUpdate) {
        options2.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref2) {
        var name2 = _ref2.name, _ref$options = _ref2.options, options3 = _ref$options === void 0 ? {} : _ref$options, effect2 = _ref2.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name: name2,
            instance,
            options: options3
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var hasElementType$5 = typeof Element !== "undefined";
var hasMap$5 = typeof Map === "function";
var hasSet$5 = typeof Set === "function";
var hasArrayBuffer$4 = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal$5(a4, b10) {
  if (a4 === b10)
    return true;
  if (a4 && b10 && typeof a4 == "object" && typeof b10 == "object") {
    if (a4.constructor !== b10.constructor)
      return false;
    var length2, i2, keys8;
    if (Array.isArray(a4)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal$5(a4[i2], b10[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap$5 && a4 instanceof Map && b10 instanceof Map) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!equal$5(i2.value[1], b10.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet$5 && a4 instanceof Set && b10 instanceof Set) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer$4 && ArrayBuffer.isView(a4) && ArrayBuffer.isView(b10)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a4[i2] !== b10[i2])
          return false;
      return true;
    }
    if (a4.constructor === RegExp)
      return a4.source === b10.source && a4.flags === b10.flags;
    if (a4.valueOf !== Object.prototype.valueOf && typeof a4.valueOf === "function" && typeof b10.valueOf === "function")
      return a4.valueOf() === b10.valueOf();
    if (a4.toString !== Object.prototype.toString && typeof a4.toString === "function" && typeof b10.toString === "function")
      return a4.toString() === b10.toString();
    keys8 = Object.keys(a4);
    length2 = keys8.length;
    if (length2 !== Object.keys(b10).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b10, keys8[i2]))
        return false;
    if (hasElementType$5 && a4 instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys8[i2] === "_owner" || keys8[i2] === "__v" || keys8[i2] === "__o") && a4.$$typeof) {
        continue;
      }
      if (!equal$5(a4[keys8[i2]], b10[keys8[i2]]))
        return false;
    }
    return true;
  }
  return a4 !== a4 && b10 !== b10;
}
var reactFastCompare$5 = function isEqual(a4, b10) {
  try {
    return equal$5(a4, b10);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
const isEqual$9 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare$5);
var EMPTY_MODIFIERS = [];
var usePopper$1 = function usePopper(referenceElement, popperElement, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options2.onFirstUpdate,
    placement: options2.placement || "bottom",
    strategy: options2.strategy || "absolute",
    modifiers: options2.modifiers || EMPTY_MODIFIERS
  };
  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      },
      arrow: {
        position: "absolute"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref2) {
        var state2 = _ref2.state;
        var elements = Object.keys(state2.elements);
        ReactDOM.flushSync(function() {
          setState({
            styles: fromEntries(elements.map(function(element) {
              return [element, state2.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function(element) {
              return [element, state2.attributes[element]];
            }))
          });
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (isEqual$9(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect$3(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect$3(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options2.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options2.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
const usePopper2 = ({
  source,
  popoverElement,
  positionAndAlignment,
  arrowElement
}) => {
  return usePopper$1(source, popoverElement, {
    placement: positionAndAlignment,
    modifiers: [
      {
        name: "offset",
        options: {
          // offset dimensions are x, y
          // and measured in px
          offset: [0, popoverMargin]
        }
      },
      { name: "arrow", options: { element: arrowElement } }
    ]
  });
};
const Portal$1 = ({
  children: children2,
  /** Node in which the portal will be mounted to */
  parentNode = document.body
}) => {
  return ReactDOM__default.createPortal(children2, parentNode);
};
const useContainerDimensions = (container2) => {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0
  });
  const handleWindowResize = useCallback(
    debounce$3(() => {
      setWindowSize({
        width: container2.clientWidth,
        height: container2.clientHeight
      });
    }, Throttle.movement),
    []
  );
  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    setWindowSize({
      width: container2.clientWidth,
      height: container2.clientHeight
    });
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);
  return windowSize;
};
const getTailNudgingValue = (tailElement, position2) => {
  if (tailElement) {
    const svgPathRect = tailElement.getElementsByTagName("path")[0].getBoundingClientRect();
    const svgRect = tailElement.getElementsByTagName("svg")[0].getBoundingClientRect();
    return position2 !== Alignment.top && position2 !== Alignment.bottom ? svgPathRect.width - svgRect.width : svgPathRect.height - svgRect.height;
  }
};
const getPlacement = (source, containerDimensions, popover2) => {
  const sourceRect = source.getBoundingClientRect();
  const positioning = [
    {
      positionAxis: Alignment.bottom,
      value: containerDimensions.height - sourceRect.bottom,
      orthogonalDimensions: {
        cartesianDimension: "x",
        dimension: "width"
      }
    },
    {
      positionAxis: Alignment.top,
      value: sourceRect.y,
      orthogonalDimensions: {
        cartesianDimension: "x",
        dimension: "width"
      }
    },
    {
      positionAxis: Alignment.right,
      value: containerDimensions.width - sourceRect.right,
      orthogonalDimensions: {
        cartesianDimension: "y",
        dimension: "height"
      }
    },
    {
      positionAxis: Alignment.left,
      value: sourceRect.x,
      orthogonalDimensions: {
        cartesianDimension: "y",
        dimension: "height"
      }
    }
  ];
  const highestPositionValue = positioning.reduce(
    (prev2, current) => prev2.value > current.value ? prev2 : current
  );
  const alignment = getPositionAlignment(
    highestPositionValue,
    containerDimensions,
    popover2.getBoundingClientRect(),
    sourceRect
  );
  return alignment;
};
const getPositionAlignment = ({
  positionAxis,
  orthogonalDimensions: { cartesianDimension, dimension }
}, containerDimensions, elRect, sourceRect) => {
  const offSet = sourceRect[dimension] - elRect[dimension];
  const sourceIsSmaller = sourceRect[dimension] <= elRect[dimension];
  const testingPoint = sourceRect[cartesianDimension] + offSet / 2;
  if (testingPoint <= 0 && sourceIsSmaller) {
    return {
      position: positionAxis,
      positionAndAlignment: `${positionAxis}-${PositionAlignment.start}`
    };
  } else if (testingPoint + elRect[dimension] >= containerDimensions[dimension] && sourceIsSmaller) {
    return {
      position: positionAxis,
      positionAndAlignment: `${positionAxis}-${PositionAlignment.end}`
    };
  } else {
    return {
      positionAndAlignment: positionAxis,
      position: positionAxis
    };
  }
};
const animatePopover = (visible, placement) => {
  const popOverAnimation = {
    animation: placement ? slideToTransform(visible, placement) : ""
  };
  return { ...popOverAnimation };
};
const reverseAnimation = (animation) => {
  return {
    from: animation.to,
    to: animation.from
  };
};
const slideTo = (transform) => ({
  from: {
    visibility: "hidden",
    opacity: 0
  },
  to: {
    transform,
    visibility: "visible",
    opacity: 1
  }
});
const slideToTransform = (visible, transform) => `0.5s ${visible ? keyframes$1(slideTo(transform)) : keyframes$1(reverseAnimation(slideTo(transform)))} forwards`;
const MatchMedia = ({
  children: children2,
  xs = false,
  sm = false,
  smDown = false,
  smUp = false,
  md = false,
  mdDown = false,
  mdUp = false,
  lg = false,
  lgDown = false,
  lgUp = false,
  xl = false,
  print = false
}) => {
  const { matchMediaQuery } = useMatchMedia();
  const queryProps = {
    xs,
    sm,
    smDown,
    smUp,
    md,
    mdDown,
    mdUp,
    lg,
    lgDown,
    lgUp,
    xl,
    print
  };
  const mediaRestrictions = Object.keys(queryProps).map((key) => key).filter((key) => queryProps[key]);
  if (mediaRestrictions.length) {
    const restrictionsMet = mediaRestrictions.some(
      (mediaType) => matchMediaQuery[mediaType]
    );
    if (restrictionsMet === false) {
      return null;
    }
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: typeof children2 === "function" ? children2(matchMediaQuery) : children2 });
};
function useResponsiveMedia(value) {
  const { matchMediaQuery } = useMatchMedia();
  const finalMedia = useMemo(() => {
    let matchMediaDirection;
    if (typeof value === "object") {
      const orderedMatchMediaQuery = mediaQueryKeys.map((key) => [
        key,
        matchMediaQuery[key]
      ]);
      matchMediaDirection = orderedMatchMediaQuery.filter(([_mediaKey, enabled]) => enabled).map(
        ([mediaKey]) => value[mediaKey]
      ).find((val) => val !== void 0);
    }
    return matchMediaDirection || value;
  }, [value, matchMediaQuery]);
  return finalMedia;
}
const buildGap = (spacing, direction, wrap) => {
  if (!spacing)
    return {};
  else if (wrap !== "wrap" && wrap !== "wrap-reverse" || direction === "column" || direction === "column-reverse") {
    return {
      gap: spacing
    };
  }
  const innerPadding = `calc(${spacing} / 2)`;
  const margin2 = `calc(${spacing} / -2)`;
  return {
    mx: margin2,
    rowGap: spacing,
    "> *": {
      px: innerPadding
    }
  };
};
const Stack$3 = ({
  children: children2 = null,
  as = "div",
  direction = "row",
  align = void 0,
  justify = void 0,
  wrap = void 0,
  spacing = 0,
  ...restOfProps
}) => {
  const finalDirection = useResponsiveMedia(
    direction
  );
  const finalSpacing = useFinalSpacing(spacing);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      alignItems: align,
      as,
      flexDirection: finalDirection,
      flexWrap: wrap,
      justifyContent: justify,
      sx: {
        ...buildGap(finalSpacing, finalDirection, wrap)
      },
      ...restOfProps,
      children: children2
    }
  );
};
const VStack = (props2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack$3, { ...props2, direction: "column" });
};
const HStack = (props2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Stack$3, { ...props2, direction: "row" });
};
const PopoverContent = ({
  children: children2,
  viewContainer = document.documentElement,
  hideTail = false,
  placementOverride = null,
  sx: sx2 = {},
  ...restOfProps
}) => {
  const {
    popoverState: { visible, source },
    variant: variant3,
    dismiss,
    open,
    persistContentOnHover
  } = usePlaceablePopover();
  const { style: style2 } = useStyle(sx2);
  const containerDimensions = useContainerDimensions(viewContainer);
  const [arrowElement, setArrowElement] = useState();
  const [popoverPlacement, setPlacement] = useState({
    position: Alignment.initial,
    positionAndAlignment: "auto"
  });
  const [popoverElement, setElement] = useState();
  const { position: position2, positionAndAlignment } = popoverPlacement;
  const openPopover = () => {
    if (!source) {
      return;
    }
    return open(source);
  };
  const closePopover = () => {
    return dismiss();
  };
  const setPopoverElement = useCallback(
    (node2) => {
      if (node2 !== null && source) {
        placementOverride ? setPlacement(placementOverride) : setPlacement(getPlacement(source, containerDimensions, node2));
        setElement(node2);
      }
    },
    [source, placementOverride, containerDimensions]
  );
  const { styles: styles2, attributes } = usePopper2({
    source,
    popoverElement,
    positionAndAlignment,
    arrowElement
  });
  const animatedStyle = animatePopover(visible, styles2.popper.transform);
  const popover2 = /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box$1,
    {
      "data-test-id": "popover-container",
      onMouseLeave: persistContentOnHover ? closePopover : void 0,
      onMouseOver: persistContentOnHover ? openPopover : void 0,
      ref: setPopoverElement,
      role: "tooltip",
      sx: style2({
        variant: `popover.${variant3}`,
        ...styles2.popper,
        ...animatedStyle
      }),
      ...attributes.popper,
      ...restOfProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { spacing: "popover.gap", children: children2 }),
        !hideTail && position2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Tail,
          {
            nudgingValue: getTailNudgingValue(arrowElement, position2),
            placement: position2,
            ref: setArrowElement,
            tailStyles: styles2.arrow,
            variant: variant3
          }
        ) : null
      ]
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Portal$1({ children: popover2 }) });
};
const isMobile = () => {
  let isMobileDevice = false;
  if (typeof window !== "undefined") {
    const mQ = typeof window.matchMedia === "function" && window.matchMedia("(pointer:coarse)");
    if (mQ && mQ.matches === true) {
      isMobileDevice = !!mQ.matches;
    } else if ("orientation" in window) {
      isMobileDevice = true;
    }
  } else if (typeof navigator !== "undefined") {
    const UA = navigator.userAgent;
    isMobileDevice = /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(UA) || /\b(Android|Windows Phone|iPad|iPod)\b/i.test(UA);
  }
  return isMobileDevice;
};
const isPointerFineDevice = () => {
  let isPointerFineDevice2 = false;
  if (typeof window !== "undefined") {
    const mQ = typeof window.matchMedia === "function" && window.matchMedia("(pointer:fine)");
    if (mQ && mQ.matches === true) {
      isPointerFineDevice2 = !!mQ.matches;
    }
  }
  return isPointerFineDevice2;
};
const useKeyDown = (key, callback) => {
  useEffect(() => {
    const onKeyDown = (event2) => {
      if (event2.key === key) {
        callback(event2);
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [key, callback]);
};
const ESCAPE_KEY = "Escape";
const useEscapeDown = function(callback) {
  useKeyDown(ESCAPE_KEY, callback);
};
const PopoverSource = ({
  children: children2,
  onAction = void 0,
  onError = void 0,
  onOpen = void 0,
  trigger = Triggers.click,
  ...props2
}) => {
  const { toggle, dismiss, open, persistContentOnHover } = usePlaceablePopover();
  const togglePopover = (e3) => {
    return toggle(e3.currentTarget, { onAction, onOpen }, onError);
  };
  const openPopover = (e3) => {
    return open(e3.currentTarget, onOpen, onError);
  };
  const closePopover = () => {
    return dismiss(onAction, onError);
  };
  useEventListener("scroll", () => {
    return dismiss(onAction, onError);
  });
  useEscapeDown(() => dismiss(onAction, onError));
  const isMobileWidth = window.innerWidth >= 767;
  const event2 = trigger === Triggers.click ? {
    onClick: togglePopover,
    onBlur: persistContentOnHover ? noop$7 : closePopover,
    ...isMobile() && { onMouseLeave: closePopover }
  } : {
    onClick: togglePopover,
    ...(isMobile() || isMobileWidth) && {
      onTouchStart: togglePopover
    },
    ...!isMobile() && {
      onFocus: openPopover,
      onMouseEnter: openPopover
    },
    onBlur: closePopover,
    onMouseLeave: closePopover
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: React__default.cloneElement(children2, { tabIndex: 0, ...props2, ...event2 }) });
};
const Tooltip = ({ children: children2 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider$1, { variant: PopoverVariant.tooltip, children: children2 });
};
Tooltip.Content = PopoverContent;
Tooltip.Source = PopoverSource;
const ConditionalWrapper = ({
  condition,
  wrapper: wrapper2,
  children: children2
}) => condition ? wrapper2(children2) : children2;
const Link$1 = forwardRef(
  ({
    "aria-current": ariaCurrent,
    as = "a",
    bottomSpace = 0,
    children: children2,
    className = void 0,
    color: color2,
    disabled,
    external = false,
    href,
    icon: icon2 = void 0,
    iconAlignment = IconAlignment.leading,
    onClick = void 0,
    size = void 0,
    sx: sx2 = {},
    tooltip = "",
    variant: variant3 = LinkVariant.default,
    ...restOfProps
  }, ref2) => {
    if (isDevEnvironment()) {
      invariant$1(
        children2,
        "Rendered Link without children. If you meant to conditionally render the link, hide the entire `Link` component instead of removing the content"
      );
      invariant$1(href, "Rendered Link without href.");
    }
    const { style: style2 } = useStyle(sx2, { bottomSpace });
    const isUsingButtonVariant = variant3.includes("buttons");
    const themeUIStyled = style2(icon2 && styles$y.icon);
    const hasTooltip = !!tooltip;
    const TooltipWrapper = useCallback(
      (children22) => CreateTooltip$1({
        children: children22,
        id: uniqueId$1("link-tool-tip-"),
        tooltip
      }),
      [tooltip]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ConditionalWrapper, { condition: hasTooltip, wrapper: TooltipWrapper, children: disabled ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Span,
      {
        color: "link.disabled",
        sx: {
          cursor: "not-allowed",
          textDecoration: "underline"
        },
        children: children2
      }
    ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Link$2,
      {
        ...isUsingButtonVariant && size && { "data-button-size": size },
        "aria-current": ariaCurrent,
        as,
        className: classNames(className, "gui"),
        color: color2,
        href,
        onClick,
        ref: ref2,
        sx: isUsingButtonVariant ? {
          ...styles$y.reset,
          ...styles$y.button,
          ...themeUIStyled
        } : themeUIStyled,
        target: external ? "_blank" : void 0,
        variant: variant3,
        ...restOfProps,
        children: [
          icon2 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box,
            {
              sx: {
                display: "inline-block",
                marginRight: iconAlignment === IconAlignment.leading && "clickables.withIcon.spacing",
                marginLeft: iconAlignment === IconAlignment.trailing && "clickables.withIcon.spacing",
                order: iconAlignment === IconAlignment.trailing ? 1 : 0
              },
              children: React__default.cloneElement(icon2)
            }
          ),
          children2
        ]
      }
    ) });
  }
);
const CreateTooltip$1 = ({ children: children2, id, tooltip = "" }) => {
  const tooltipStyle = {
    width: "fit-content"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Source, { "data-test-id": id, trigger: Triggers.hover, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "aria-labelledby": id, role: "tooltip", style: tooltipStyle, children: children2 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tooltip.Content,
      {
        hideTail: true,
        placementOverride: {
          position: Alignment.bottom,
          positionAndAlignment: "bottom"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "aria-live": "polite", id, role: "tooltip", children: tooltip })
      }
    )
  ] });
};
const styles$y = {
  reset: {
    textDecoration: "none"
  },
  button: {
    display: "flex",
    maxWidth: "fit-content",
    "&:hover": {
      // overwrites app legacy css
      textDecoration: "none"
    }
  },
  icon: {
    alignItems: "center",
    display: "flex"
  }
};
const typeToLogoName = (type2) => {
  const prefix2 = "Guideline";
  let suffix = "Default";
  if (type2) {
    const typeSplit = type2.split(/-+/);
    const firstLetterCapitalized = typeSplit.map(
      (s4) => s4[0].toUpperCase() + s4.slice(1)
    );
    suffix = firstLetterCapitalized.join("");
  }
  return `${prefix2}${suffix}`;
};
(function(module2, exports2) {
  (function(global2, factory) {
    factory();
  })(commonjsGlobal, function() {
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        "datetime-local": true
      };
      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) {
          return true;
        }
        return false;
      }
      function focusTriggersKeyboardModality(el) {
        var type2 = el.type;
        var tagName = el.tagName;
        if (tagName === "INPUT" && inputTypesAllowlist[type2] && !el.readOnly) {
          return true;
        }
        if (tagName === "TEXTAREA" && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }
      function addFocusVisibleClass(el) {
        if (el.classList.contains("focus-visible")) {
          return;
        }
        el.classList.add("focus-visible");
        el.setAttribute("data-focus-visible-added", "");
      }
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute("data-focus-visible-added")) {
          return;
        }
        el.classList.remove("focus-visible");
        el.removeAttribute("data-focus-visible-added");
      }
      function onKeyDown(e3) {
        if (e3.metaKey || e3.altKey || e3.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }
      function onPointerDown(e3) {
        hadKeyboardEvent = false;
      }
      function onFocus3(e3) {
        if (!isValidFocusTarget(e3.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e3.target)) {
          addFocusVisibleClass(e3.target);
        }
      }
      function onBlur3(e3) {
        if (!isValidFocusTarget(e3.target)) {
          return;
        }
        if (e3.target.classList.contains("focus-visible") || e3.target.hasAttribute("data-focus-visible-added")) {
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e3.target);
        }
      }
      function onVisibilityChange(e3) {
        if (document.visibilityState === "hidden") {
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }
      function addInitialPointerMoveListeners() {
        document.addEventListener("mousemove", onInitialPointerMove);
        document.addEventListener("mousedown", onInitialPointerMove);
        document.addEventListener("mouseup", onInitialPointerMove);
        document.addEventListener("pointermove", onInitialPointerMove);
        document.addEventListener("pointerdown", onInitialPointerMove);
        document.addEventListener("pointerup", onInitialPointerMove);
        document.addEventListener("touchmove", onInitialPointerMove);
        document.addEventListener("touchstart", onInitialPointerMove);
        document.addEventListener("touchend", onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener("mousemove", onInitialPointerMove);
        document.removeEventListener("mousedown", onInitialPointerMove);
        document.removeEventListener("mouseup", onInitialPointerMove);
        document.removeEventListener("pointermove", onInitialPointerMove);
        document.removeEventListener("pointerdown", onInitialPointerMove);
        document.removeEventListener("pointerup", onInitialPointerMove);
        document.removeEventListener("touchmove", onInitialPointerMove);
        document.removeEventListener("touchstart", onInitialPointerMove);
        document.removeEventListener("touchend", onInitialPointerMove);
      }
      function onInitialPointerMove(e3) {
        if (e3.target.nodeName && e3.target.nodeName.toLowerCase() === "html") {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }
      document.addEventListener("keydown", onKeyDown, true);
      document.addEventListener("mousedown", onPointerDown, true);
      document.addEventListener("pointerdown", onPointerDown, true);
      document.addEventListener("touchstart", onPointerDown, true);
      document.addEventListener("visibilitychange", onVisibilityChange, true);
      addInitialPointerMoveListeners();
      scope.addEventListener("focus", onFocus3, true);
      scope.addEventListener("blur", onBlur3, true);
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        scope.host.setAttribute("data-js-focus-visible", "");
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add("js-focus-visible");
        document.documentElement.setAttribute("data-js-focus-visible", "");
      }
    }
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
      var event2;
      try {
        event2 = new CustomEvent("focus-visible-polyfill-ready");
      } catch (error2) {
        event2 = document.createEvent("CustomEvent");
        event2.initCustomEvent("focus-visible-polyfill-ready", false, false, {});
      }
      window.dispatchEvent(event2);
    }
    if (typeof document !== "undefined") {
      applyFocusVisiblePolyfill(document);
    }
  });
})();
const LogoLink = ({
  as = "a",
  href,
  linkProps = {},
  name: name2 = "GuidelineDefault",
  sx: sx2 = {},
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Link$1,
    {
      "aria-label": "Guideline Logo",
      as,
      href,
      sx: { ...logo, ...sx2 },
      ...linkProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Svg, { getSvgByKey: getLogoByKey, name: name2, stroke: "none", ...props2 })
    }
  );
};
const Logo = ({
  href = void 0,
  linkProps = {},
  name: name2 = "GuidelineDefault",
  ...props2
}) => {
  if (href) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LogoLink, { href, linkProps, name: name2, ...props2 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Svg, { getSvgByKey: getLogoByKey, name: name2, stroke: "none", ...props2 });
};
const CobrandedLogo = ({
  href = void 0,
  linkProps = {},
  name: name2 = void 0,
  sx: sx2 = {},
  ...props2
}) => {
  if (!name2) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Logo,
    {
      href,
      linkProps,
      name: name2,
      sx: {
        ...cobranded,
        ...sx2
      },
      ...props2
    }
  );
};
const coral = {
  80: "#640030",
  70: "#8F4236",
  60: "#BE715C",
  50: "#EFA185",
  40: "#FFBCA3",
  30: "#FDCBB2",
  20: "#FCDAC4",
  10: "#FBE8D9",
  "05": "#FAF6F4"
};
const dawn = {
  80: "#4E0E0E",
  70: "#AF4715",
  60: "#DB6D00",
  50: "#FFAE3D",
  40: "#FFCD85",
  30: "#FFDEA4",
  20: "#FFEDC3",
  10: "#FFF5D8",
  "05": "#FFFBEE"
};
const dusk$2 = {
  80: "#24157B",
  70: "#331EA4",
  60: "#4428CE",
  50: "#5532FA",
  40: "#7E64FB",
  30: "#A695FB",
  20: "#CFC7FC",
  10: "#E3DEFD",
  "05": "#F7F5FE"
};
const ember = {
  80: "#601415",
  70: "#912525",
  60: "#C13536",
  50: "#F24646",
  40: "#FB716C",
  30: "#FF9691",
  20: "#FFBDBB",
  10: "#FCDCDB",
  "05": "#FEF1EF"
};
const eucalyptus = {
  80: "#07404E",
  70: "#215E68",
  60: "#3C7E81",
  50: "#609F9A",
  40: "#8FBEB6",
  30: "#C0DDD6",
  20: "#D0E6E0",
  10: "#E0EEEA",
  "05": "#F0F7F5"
};
const fern = {
  80: "#004528",
  70: "#00693D",
  60: "#01864E",
  50: "#00B066",
  40: "#50C087",
  30: "#7CD0A6",
  20: "#B0E3CB",
  10: "#D4F0E3",
  "05": "#EBF9F3"
};
const fog$3 = {
  80: "#191817",
  70: "#292827",
  60: "#535251",
  50: "#777675",
  40: "#A6A5A4",
  30: "#C3C2C1",
  20: "#E5E4E3",
  15: "#EEEDEC",
  10: "#F7F6F5",
  "05": "#FBFAF9",
  "00": "#FFFFFF"
};
const midnight$1 = {
  80: "#150A45",
  70: "#003699",
  60: "#0D54D7",
  50: "#3477F3",
  40: "#6F9BF8",
  30: "#94B6FB",
  20: "#BCD3FC",
  10: "#E6EFFF",
  "05": "#F5F8FF"
};
const palettes$1 = {
  coral,
  dawn,
  dusk: dusk$2,
  ember,
  eucalyptus,
  fern,
  fog: fog$3,
  midnight: midnight$1
};
const rekeyedPalettes$1 = Object.keys(palettes$1).map((colorKey) => {
  return Object.keys(palettes$1[colorKey]).reduce((palette, scale) => {
    return {
      ...palette,
      [`${colorKey}-${scale}`]: palettes$1[colorKey][scale]
    };
  }, {});
});
const combinedPalettes$1 = rekeyedPalettes$1.reduce((combined, palette) => {
  return {
    ...combined,
    ...palette
  };
}, {});
const FlexDirection = {
  Initial: "initial",
  Revert: "revert",
  Column: "column",
  ColumnReverse: "column-reverse",
  Row: "row",
  RowReverse: "row-reverse"
};
const AlignItems = {
  Initial: "initial",
  Revert: "revert",
  Unset: "unset",
  Center: "center",
  End: "end",
  FlexEnd: "flex-end",
  FlexStart: "flex-start",
  SelfEnd: "self-end",
  SelfStart: "self-start",
  Start: "start",
  Baseline: "baseline",
  Normal: "normal",
  Stretch: "stretch"
};
const JustifyContent = {
  Initial: "initial",
  Revert: "revert",
  Unset: "unset",
  SpaceAround: "space-around",
  SpaceBetween: "space-between",
  SpaceEvenly: "space-evenly",
  Stretch: "stretch",
  Center: "center",
  End: "end",
  FlexEnd: "flex-end",
  FlexStart: "flex-start",
  Start: "start",
  Left: "left",
  Normal: "normal",
  Right: "right"
};
const FlexWrap = {
  Inherit: "inherit",
  Initial: "initial",
  Revert: "revert",
  Unset: "unset",
  Nowrap: "nowrap",
  Wrap: "wrap",
  WrapReverse: "wrap-reverse"
};
const CSSProperties = {
  FlexDirection,
  AlignItems,
  JustifyContent,
  FlexWrap
};
function buildFunctionRadioControlArgTypes(functions) {
  const argTypes = {};
  functions.forEach((argument) => {
    const functionName = typeof argument === "object" ? argument.name : argument;
    const functionMapping = {
      Disabled: null,
      Enabled: () => console.info(`${functionName} invoked`)
      // eslint-disable-line no-console
    };
    const description = argument == null ? void 0 : argument.description;
    argTypes[functionName] = {
      options: Object.keys(functionMapping),
      mapping: functionMapping,
      defaultValue: "Disabled",
      control: {
        type: "inline-radio"
      },
      ...description ? { description } : {}
    };
  });
  return argTypes;
}
function buildSelectControlArgTypes(selectableProps) {
  const argTypes = {};
  Object.entries(selectableProps).forEach(
    ([prop, { options: options2, required, defaultValueDisplay, ...extraOptions }]) => {
      const selectMapping = {
        ...options2
      };
      if (required === false) {
        selectMapping["-"] = null;
      }
      argTypes[prop] = {
        options: Object.keys(selectMapping).sort(),
        mapping: selectMapping,
        control: {
          type: "select"
        },
        ...extraOptions
      };
      if (defaultValueDisplay) {
        argTypes[prop].table = {
          defaultValue: { summary: defaultValueDisplay }
        };
      }
    }
  );
  return argTypes;
}
const buildNamedOptions = (options2, optionMapper = (key) => key) => {
  const keys8 = Array.isArray(options2) ? options2 : Object.keys(options2);
  return keys8.reduce(
    (obj, key) => ({
      ...obj,
      [key]: optionMapper(key)
    }),
    {}
  );
};
const colorPaletteOptions = buildNamedOptions(combinedPalettes$1);
const icon12Options = buildNamedOptions(icon12Keys, (key) => /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: key, size: IconSizes.Icon12 }));
const icon16Options = buildNamedOptions(icon16Keys, (key) => /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: key, size: IconSizes.Icon16 }));
const icon20Options = buildNamedOptions(icon20Keys, (key) => /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: key, size: IconSizes.Icon20 }));
const icon24Options = buildNamedOptions(icon24Keys, (key) => /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: key, size: IconSizes.Icon24 }));
const illustrationOptions = buildNamedOptions(illustrationKeys, (key) => /* @__PURE__ */ jsxRuntimeExports.jsx(Illustration, { name: key }));
const flexBaseArgTypesBuilder = ({
  flexDirection,
  alignItems,
  justifyContent: justifyContent2,
  flexWrap
}) => {
  return {
    spacing: { control: { type: "number", min: 0, step: 0.5 } },
    ...buildSelectControlArgTypes({
      [flexDirection || "flexDirection"]: {
        options: CSSProperties.FlexDirection,
        defaultValueDisplay: CSSProperties.FlexDirection.Row
      },
      [alignItems || "alignItems"]: {
        options: CSSProperties.AlignItems,
        defaultValueDisplay: CSSProperties.AlignItems.Stretch
      },
      [justifyContent2 || "justifyContent"]: {
        options: CSSProperties.JustifyContent,
        defaultValueDisplay: CSSProperties.AlignItems.FlexStart
      },
      [flexWrap || "flexWrap"]: {
        options: CSSProperties.FlexWrap,
        defaultValueDisplay: CSSProperties.FlexWrap.Nowrap
      }
    })
  };
};
const disableArgTypes = (propsToDisable) => {
  propsToDisable = [].concat(propsToDisable);
  return propsToDisable.reduce((acc, prop) => {
    acc[prop] = {
      table: {
        disable: true
      }
    };
    return acc;
  }, {});
};
const disableArgControl = (propsToDisableControl) => {
  propsToDisableControl = [].concat(propsToDisableControl);
  return propsToDisableControl.reduce((acc, prop) => {
    acc[prop] = {
      control: {
        type: "none"
      }
    };
    return acc;
  }, {});
};
const arrToOptions = (arr) => arr.reduce((options2, item) => {
  options2[item] = item.toString();
  return options2;
}, {});
const StorybookUtilities = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CSSProperties,
  FlexWrap,
  arrToOptions,
  buildFunctionRadioControlArgTypes,
  buildNamedOptions,
  buildSelectControlArgTypes,
  colorPaletteOptions,
  disableArgControl,
  disableArgTypes,
  flexBaseArgTypesBuilder,
  icon12Options,
  icon16Options,
  icon20Options,
  icon24Options,
  illustrationOptions
}, Symbol.toStringTag, { value: "Module" }));
var reactTestRenderer = { exports: {} };
var reactTestRenderer_production_min = { exports: {} };
var unstable_mock = { exports: {} };
var schedulerUnstable_mock_production_min = {};
/** @license React v0.20.2
 * scheduler-unstable_mock.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredSchedulerUnstable_mock_production_min;
function requireSchedulerUnstable_mock_production_min() {
  if (hasRequiredSchedulerUnstable_mock_production_min)
    return schedulerUnstable_mock_production_min;
  hasRequiredSchedulerUnstable_mock_production_min = 1;
  var f = 0, g2 = null, h3 = null, k3 = -1, l = null, m3 = -1, n = false, p = false, q2 = false, r = false;
  function t2() {
    return -1 !== m3 && null !== l && l.length >= m3 || r && q2 ? n = true : false;
  }
  function x3() {
    if (p)
      throw Error("Already flushing work.");
    if (null !== g2) {
      var a4 = g2;
      p = true;
      try {
        var b10 = true;
        do
          b10 = a4(true, f);
        while (b10);
        b10 || (g2 = null);
        return true;
      } finally {
        p = false;
      }
    } else
      return false;
  }
  function z2(a4, b10) {
    var c7 = a4.length;
    a4.push(b10);
    a:
      for (; ; ) {
        var d3 = c7 - 1 >>> 1, e3 = a4[d3];
        if (void 0 !== e3 && 0 < A(e3, b10))
          a4[d3] = b10, a4[c7] = e3, c7 = d3;
        else
          break a;
      }
  }
  function B2(a4) {
    a4 = a4[0];
    return void 0 === a4 ? null : a4;
  }
  function C(a4) {
    var b10 = a4[0];
    if (void 0 !== b10) {
      var c7 = a4.pop();
      if (c7 !== b10) {
        a4[0] = c7;
        a:
          for (var d3 = 0, e3 = a4.length; d3 < e3; ) {
            var u2 = 2 * (d3 + 1) - 1, v = a4[u2], w2 = u2 + 1, y4 = a4[w2];
            if (void 0 !== v && 0 > A(v, c7))
              void 0 !== y4 && 0 > A(y4, v) ? (a4[d3] = y4, a4[w2] = c7, d3 = w2) : (a4[d3] = v, a4[u2] = c7, d3 = u2);
            else if (void 0 !== y4 && 0 > A(y4, c7))
              a4[d3] = y4, a4[w2] = c7, d3 = w2;
            else
              break a;
          }
      }
      return b10;
    }
    return null;
  }
  function A(a4, b10) {
    var c7 = a4.sortIndex - b10.sortIndex;
    return 0 !== c7 ? c7 : a4.id - b10.id;
  }
  var D2 = [], E2 = [], F = 1, G2 = null, H3 = 3, I2 = false, J = false, K2 = false;
  function L2(a4) {
    for (var b10 = B2(E2); null !== b10; ) {
      if (null === b10.callback)
        C(E2);
      else if (b10.startTime <= a4)
        C(E2), b10.sortIndex = b10.expirationTime, z2(D2, b10);
      else
        break;
      b10 = B2(E2);
    }
  }
  function M3(a4) {
    K2 = false;
    L2(a4);
    if (!J)
      if (null !== B2(D2))
        J = true, g2 = N;
      else {
        var b10 = B2(E2);
        null !== b10 && (a4 = b10.startTime - a4, h3 = M3, k3 = f + a4);
      }
  }
  function N(a4, b10) {
    J = false;
    K2 && (K2 = false, h3 = null, k3 = -1);
    I2 = true;
    var c7 = H3;
    try {
      L2(b10);
      for (G2 = B2(D2); null !== G2 && (!(G2.expirationTime > b10) || a4 && !t2()); ) {
        var d3 = G2.callback;
        if ("function" === typeof d3) {
          G2.callback = null;
          H3 = G2.priorityLevel;
          var e3 = d3(G2.expirationTime <= b10);
          b10 = f;
          "function" === typeof e3 ? G2.callback = e3 : G2 === B2(D2) && C(D2);
          L2(b10);
        } else
          C(D2);
        G2 = B2(D2);
      }
      if (null !== G2)
        var u2 = true;
      else {
        var v = B2(E2);
        if (null !== v) {
          var w2 = v.startTime - b10;
          h3 = M3;
          k3 = f + w2;
        }
        u2 = false;
      }
      return u2;
    } finally {
      G2 = null, H3 = c7, I2 = false;
    }
  }
  schedulerUnstable_mock_production_min.unstable_IdlePriority = 5;
  schedulerUnstable_mock_production_min.unstable_ImmediatePriority = 1;
  schedulerUnstable_mock_production_min.unstable_LowPriority = 4;
  schedulerUnstable_mock_production_min.unstable_NormalPriority = 3;
  schedulerUnstable_mock_production_min.unstable_Profiling = null;
  schedulerUnstable_mock_production_min.unstable_UserBlockingPriority = 2;
  schedulerUnstable_mock_production_min.unstable_advanceTime = function(a4) {
    "disabledLog" !== console.log.name && (f += a4, null !== h3 && k3 <= f && (h3(f), k3 = -1, h3 = null));
  };
  schedulerUnstable_mock_production_min.unstable_cancelCallback = function(a4) {
    a4.callback = null;
  };
  schedulerUnstable_mock_production_min.unstable_clearYields = function() {
    if (null === l)
      return [];
    var a4 = l;
    l = null;
    return a4;
  };
  schedulerUnstable_mock_production_min.unstable_continueExecution = function() {
    J || I2 || (J = true, g2 = N);
  };
  schedulerUnstable_mock_production_min.unstable_flushAll = function() {
    if (null !== l)
      throw Error("Log is not empty. Assert on the log of yielded values before flushing additional work.");
    x3();
    if (null !== l)
      throw Error("While flushing work, something yielded a value. Use an assertion helper to assert on the log of yielded values, e.g. expect(Scheduler).toFlushAndYield([...])");
  };
  schedulerUnstable_mock_production_min.unstable_flushAllWithoutAsserting = x3;
  schedulerUnstable_mock_production_min.unstable_flushExpired = function() {
    if (p)
      throw Error("Already flushing work.");
    if (null !== g2) {
      p = true;
      try {
        g2(false, f) || (g2 = null);
      } finally {
        p = false;
      }
    }
  };
  schedulerUnstable_mock_production_min.unstable_flushNumberOfYields = function(a4) {
    if (p)
      throw Error("Already flushing work.");
    if (null !== g2) {
      var b10 = g2;
      m3 = a4;
      p = true;
      try {
        a4 = true;
        do
          a4 = b10(true, f);
        while (a4 && !n);
        a4 || (g2 = null);
      } finally {
        m3 = -1, p = n = false;
      }
    }
  };
  schedulerUnstable_mock_production_min.unstable_flushUntilNextPaint = function() {
    if (p)
      throw Error("Already flushing work.");
    if (null !== g2) {
      var a4 = g2;
      r = true;
      q2 = false;
      p = true;
      try {
        var b10 = true;
        do
          b10 = a4(true, f);
        while (b10 && !n);
        b10 || (g2 = null);
      } finally {
        p = n = r = false;
      }
    }
  };
  schedulerUnstable_mock_production_min.unstable_forceFrameRate = function() {
  };
  schedulerUnstable_mock_production_min.unstable_getCurrentPriorityLevel = function() {
    return H3;
  };
  schedulerUnstable_mock_production_min.unstable_getFirstCallbackNode = function() {
    return B2(D2);
  };
  schedulerUnstable_mock_production_min.unstable_next = function(a4) {
    switch (H3) {
      case 1:
      case 2:
      case 3:
        var b10 = 3;
        break;
      default:
        b10 = H3;
    }
    var c7 = H3;
    H3 = b10;
    try {
      return a4();
    } finally {
      H3 = c7;
    }
  };
  schedulerUnstable_mock_production_min.unstable_now = function() {
    return f;
  };
  schedulerUnstable_mock_production_min.unstable_pauseExecution = function() {
  };
  schedulerUnstable_mock_production_min.unstable_requestPaint = function() {
    q2 = true;
  };
  schedulerUnstable_mock_production_min.unstable_runWithPriority = function(a4, b10) {
    switch (a4) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a4 = 3;
    }
    var c7 = H3;
    H3 = a4;
    try {
      return b10();
    } finally {
      H3 = c7;
    }
  };
  schedulerUnstable_mock_production_min.unstable_scheduleCallback = function(a4, b10, c7) {
    var d3 = f;
    "object" === typeof c7 && null !== c7 ? (c7 = c7.delay, c7 = "number" === typeof c7 && 0 < c7 ? d3 + c7 : d3) : c7 = d3;
    switch (a4) {
      case 1:
        var e3 = -1;
        break;
      case 2:
        e3 = 250;
        break;
      case 5:
        e3 = 1073741823;
        break;
      case 4:
        e3 = 1e4;
        break;
      default:
        e3 = 5e3;
    }
    e3 = c7 + e3;
    a4 = { id: F++, callback: b10, priorityLevel: a4, startTime: c7, expirationTime: e3, sortIndex: -1 };
    c7 > d3 ? (a4.sortIndex = c7, z2(E2, a4), null === B2(D2) && a4 === B2(E2) && (K2 ? (h3 = null, k3 = -1) : K2 = true, h3 = M3, k3 = f + (c7 - d3))) : (a4.sortIndex = e3, z2(D2, a4), J || I2 || (J = true, g2 = N));
    return a4;
  };
  schedulerUnstable_mock_production_min.unstable_shouldYield = t2;
  schedulerUnstable_mock_production_min.unstable_wrapCallback = function(a4) {
    var b10 = H3;
    return function() {
      var c7 = H3;
      H3 = b10;
      try {
        return a4.apply(this, arguments);
      } finally {
        H3 = c7;
      }
    };
  };
  schedulerUnstable_mock_production_min.unstable_yieldValue = function(a4) {
    "disabledLog" !== console.log.name && (null === l ? l = [a4] : l.push(a4));
  };
  return schedulerUnstable_mock_production_min;
}
var schedulerUnstable_mock_development = {};
/** @license React v0.20.2
 * scheduler-unstable_mock.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredSchedulerUnstable_mock_development;
function requireSchedulerUnstable_mock_development() {
  if (hasRequiredSchedulerUnstable_mock_development)
    return schedulerUnstable_mock_development;
  hasRequiredSchedulerUnstable_mock_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var enableSchedulerDebugging = false;
      var enableProfiling = false;
      var currentTime = 0;
      var scheduledCallback = null;
      var scheduledTimeout = null;
      var timeoutTime = -1;
      var yieldedValues = null;
      var expectedNumberOfYields = -1;
      var didStop = false;
      var isFlushing = false;
      var needsPaint = false;
      var shouldYieldForPaint = false;
      function requestHostCallback(callback) {
        scheduledCallback = callback;
      }
      function requestHostTimeout(callback, ms) {
        scheduledTimeout = callback;
        timeoutTime = currentTime + ms;
      }
      function cancelHostTimeout() {
        scheduledTimeout = null;
        timeoutTime = -1;
      }
      function shouldYieldToHost() {
        if (expectedNumberOfYields !== -1 && yieldedValues !== null && yieldedValues.length >= expectedNumberOfYields || shouldYieldForPaint && needsPaint) {
          didStop = true;
          return true;
        }
        return false;
      }
      function getCurrentTime() {
        return currentTime;
      }
      function forceFrameRate() {
      }
      function unstable_flushNumberOfYields(count) {
        if (isFlushing) {
          throw new Error("Already flushing work.");
        }
        if (scheduledCallback !== null) {
          var cb = scheduledCallback;
          expectedNumberOfYields = count;
          isFlushing = true;
          try {
            var hasMoreWork = true;
            do {
              hasMoreWork = cb(true, currentTime);
            } while (hasMoreWork && !didStop);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
          } finally {
            expectedNumberOfYields = -1;
            didStop = false;
            isFlushing = false;
          }
        }
      }
      function unstable_flushUntilNextPaint() {
        if (isFlushing) {
          throw new Error("Already flushing work.");
        }
        if (scheduledCallback !== null) {
          var cb = scheduledCallback;
          shouldYieldForPaint = true;
          needsPaint = false;
          isFlushing = true;
          try {
            var hasMoreWork = true;
            do {
              hasMoreWork = cb(true, currentTime);
            } while (hasMoreWork && !didStop);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
          } finally {
            shouldYieldForPaint = false;
            didStop = false;
            isFlushing = false;
          }
        }
      }
      function unstable_flushExpired() {
        if (isFlushing) {
          throw new Error("Already flushing work.");
        }
        if (scheduledCallback !== null) {
          isFlushing = true;
          try {
            var hasMoreWork = scheduledCallback(false, currentTime);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
          } finally {
            isFlushing = false;
          }
        }
      }
      function unstable_flushAllWithoutAsserting() {
        if (isFlushing) {
          throw new Error("Already flushing work.");
        }
        if (scheduledCallback !== null) {
          var cb = scheduledCallback;
          isFlushing = true;
          try {
            var hasMoreWork = true;
            do {
              hasMoreWork = cb(true, currentTime);
            } while (hasMoreWork);
            if (!hasMoreWork) {
              scheduledCallback = null;
            }
            return true;
          } finally {
            isFlushing = false;
          }
        } else {
          return false;
        }
      }
      function unstable_clearYields() {
        if (yieldedValues === null) {
          return [];
        }
        var values6 = yieldedValues;
        yieldedValues = null;
        return values6;
      }
      function unstable_flushAll() {
        if (yieldedValues !== null) {
          throw new Error("Log is not empty. Assert on the log of yielded values before flushing additional work.");
        }
        unstable_flushAllWithoutAsserting();
        if (yieldedValues !== null) {
          throw new Error("While flushing work, something yielded a value. Use an assertion helper to assert on the log of yielded values, e.g. expect(Scheduler).toFlushAndYield([...])");
        }
      }
      function unstable_yieldValue(value) {
        if (console.log.name === "disabledLog") {
          return;
        }
        if (yieldedValues === null) {
          yieldedValues = [value];
        } else {
          yieldedValues.push(value);
        }
      }
      function unstable_advanceTime(ms) {
        if (console.log.name === "disabledLog") {
          return;
        }
        currentTime += ms;
        if (scheduledTimeout !== null && timeoutTime <= currentTime) {
          scheduledTimeout(currentTime);
          timeoutTime = -1;
          scheduledTimeout = null;
        }
      }
      function requestPaint() {
        needsPaint = true;
      }
      function push(heap, node2) {
        var index2 = heap.length;
        heap.push(node2);
        siftUp(heap, node2, index2);
      }
      function peek2(heap) {
        var first = heap[0];
        return first === void 0 ? null : first;
      }
      function pop(heap) {
        var first = heap[0];
        if (first !== void 0) {
          var last2 = heap.pop();
          if (last2 !== first) {
            heap[0] = last2;
            siftDown(heap, last2, 0);
          }
          return first;
        } else {
          return null;
        }
      }
      function siftUp(heap, node2, i2) {
        var index2 = i2;
        while (true) {
          var parentIndex = index2 - 1 >>> 1;
          var parent2 = heap[parentIndex];
          if (parent2 !== void 0 && compare(parent2, node2) > 0) {
            heap[parentIndex] = node2;
            heap[index2] = parent2;
            index2 = parentIndex;
          } else {
            return;
          }
        }
      }
      function siftDown(heap, node2, i2) {
        var index2 = i2;
        var length2 = heap.length;
        while (index2 < length2) {
          var leftIndex = (index2 + 1) * 2 - 1;
          var left2 = heap[leftIndex];
          var rightIndex = leftIndex + 1;
          var right2 = heap[rightIndex];
          if (left2 !== void 0 && compare(left2, node2) < 0) {
            if (right2 !== void 0 && compare(right2, left2) < 0) {
              heap[index2] = right2;
              heap[rightIndex] = node2;
              index2 = rightIndex;
            } else {
              heap[index2] = left2;
              heap[leftIndex] = node2;
              index2 = leftIndex;
            }
          } else if (right2 !== void 0 && compare(right2, node2) < 0) {
            heap[index2] = right2;
            heap[rightIndex] = node2;
            index2 = rightIndex;
          } else {
            return;
          }
        }
      }
      function compare(a4, b10) {
        var diff = a4.sortIndex - b10.sortIndex;
        return diff !== 0 ? diff : a4.id - b10.id;
      }
      var ImmediatePriority = 1;
      var UserBlockingPriority = 2;
      var NormalPriority = 3;
      var LowPriority = 4;
      var IdlePriority = 5;
      function markTaskErrored(task, ms) {
      }
      var maxSigned31BitInt = 1073741823;
      var IMMEDIATE_PRIORITY_TIMEOUT = -1;
      var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
      var NORMAL_PRIORITY_TIMEOUT = 5e3;
      var LOW_PRIORITY_TIMEOUT = 1e4;
      var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
      var taskQueue = [];
      var timerQueue = [];
      var taskIdCounter = 1;
      var currentTask = null;
      var currentPriorityLevel = NormalPriority;
      var isPerformingWork = false;
      var isHostCallbackScheduled = false;
      var isHostTimeoutScheduled = false;
      function advanceTimers(currentTime2) {
        var timer2 = peek2(timerQueue);
        while (timer2 !== null) {
          if (timer2.callback === null) {
            pop(timerQueue);
          } else if (timer2.startTime <= currentTime2) {
            pop(timerQueue);
            timer2.sortIndex = timer2.expirationTime;
            push(taskQueue, timer2);
          } else {
            return;
          }
          timer2 = peek2(timerQueue);
        }
      }
      function handleTimeout(currentTime2) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime2);
        if (!isHostCallbackScheduled) {
          if (peek2(taskQueue) !== null) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          } else {
            var firstTimer = peek2(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime2);
            }
          }
        }
      }
      function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
          isHostTimeoutScheduled = false;
          cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
          var currentTime2;
          if (enableProfiling)
            ;
          else {
            return workLoop(hasTimeRemaining, initialTime);
          }
        } finally {
          currentTask = null;
          currentPriorityLevel = previousPriorityLevel;
          isPerformingWork = false;
        }
      }
      function workLoop(hasTimeRemaining, initialTime) {
        var currentTime2 = initialTime;
        advanceTimers(currentTime2);
        currentTask = peek2(taskQueue);
        while (currentTask !== null && !enableSchedulerDebugging) {
          if (currentTask.expirationTime > currentTime2 && (!hasTimeRemaining || shouldYieldToHost())) {
            break;
          }
          var callback = currentTask.callback;
          if (typeof callback === "function") {
            currentTask.callback = null;
            currentPriorityLevel = currentTask.priorityLevel;
            var didUserCallbackTimeout = currentTask.expirationTime <= currentTime2;
            var continuationCallback = callback(didUserCallbackTimeout);
            currentTime2 = getCurrentTime();
            if (typeof continuationCallback === "function") {
              currentTask.callback = continuationCallback;
            } else {
              if (currentTask === peek2(taskQueue)) {
                pop(taskQueue);
              }
            }
            advanceTimers(currentTime2);
          } else {
            pop(taskQueue);
          }
          currentTask = peek2(taskQueue);
        }
        if (currentTask !== null) {
          return true;
        } else {
          var firstTimer = peek2(timerQueue);
          if (firstTimer !== null) {
            requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime2);
          }
          return false;
        }
      }
      function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
          case LowPriority:
          case IdlePriority:
            break;
          default:
            priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_next(eventHandler) {
        var priorityLevel;
        switch (currentPriorityLevel) {
          case ImmediatePriority:
          case UserBlockingPriority:
          case NormalPriority:
            priorityLevel = NormalPriority;
            break;
          default:
            priorityLevel = currentPriorityLevel;
            break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      }
      function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      }
      function unstable_scheduleCallback(priorityLevel, callback, options2) {
        var currentTime2 = getCurrentTime();
        var startTime;
        if (typeof options2 === "object" && options2 !== null) {
          var delay = options2.delay;
          if (typeof delay === "number" && delay > 0) {
            startTime = currentTime2 + delay;
          } else {
            startTime = currentTime2;
          }
        } else {
          startTime = currentTime2;
        }
        var timeout2;
        switch (priorityLevel) {
          case ImmediatePriority:
            timeout2 = IMMEDIATE_PRIORITY_TIMEOUT;
            break;
          case UserBlockingPriority:
            timeout2 = USER_BLOCKING_PRIORITY_TIMEOUT;
            break;
          case IdlePriority:
            timeout2 = IDLE_PRIORITY_TIMEOUT;
            break;
          case LowPriority:
            timeout2 = LOW_PRIORITY_TIMEOUT;
            break;
          case NormalPriority:
          default:
            timeout2 = NORMAL_PRIORITY_TIMEOUT;
            break;
        }
        var expirationTime = startTime + timeout2;
        var newTask = {
          id: taskIdCounter++,
          callback,
          priorityLevel,
          startTime,
          expirationTime,
          sortIndex: -1
        };
        if (startTime > currentTime2) {
          newTask.sortIndex = startTime;
          push(timerQueue, newTask);
          if (peek2(taskQueue) === null && newTask === peek2(timerQueue)) {
            if (isHostTimeoutScheduled) {
              cancelHostTimeout();
            } else {
              isHostTimeoutScheduled = true;
            }
            requestHostTimeout(handleTimeout, startTime - currentTime2);
          }
        } else {
          newTask.sortIndex = expirationTime;
          push(taskQueue, newTask);
          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }
        return newTask;
      }
      function unstable_pauseExecution() {
      }
      function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
          isHostCallbackScheduled = true;
          requestHostCallback(flushWork);
        }
      }
      function unstable_getFirstCallbackNode() {
        return peek2(taskQueue);
      }
      function unstable_cancelCallback(task) {
        task.callback = null;
      }
      function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
      }
      var unstable_requestPaint = requestPaint;
      var unstable_Profiling = null;
      schedulerUnstable_mock_development.unstable_IdlePriority = IdlePriority;
      schedulerUnstable_mock_development.unstable_ImmediatePriority = ImmediatePriority;
      schedulerUnstable_mock_development.unstable_LowPriority = LowPriority;
      schedulerUnstable_mock_development.unstable_NormalPriority = NormalPriority;
      schedulerUnstable_mock_development.unstable_Profiling = unstable_Profiling;
      schedulerUnstable_mock_development.unstable_UserBlockingPriority = UserBlockingPriority;
      schedulerUnstable_mock_development.unstable_advanceTime = unstable_advanceTime;
      schedulerUnstable_mock_development.unstable_cancelCallback = unstable_cancelCallback;
      schedulerUnstable_mock_development.unstable_clearYields = unstable_clearYields;
      schedulerUnstable_mock_development.unstable_continueExecution = unstable_continueExecution;
      schedulerUnstable_mock_development.unstable_flushAll = unstable_flushAll;
      schedulerUnstable_mock_development.unstable_flushAllWithoutAsserting = unstable_flushAllWithoutAsserting;
      schedulerUnstable_mock_development.unstable_flushExpired = unstable_flushExpired;
      schedulerUnstable_mock_development.unstable_flushNumberOfYields = unstable_flushNumberOfYields;
      schedulerUnstable_mock_development.unstable_flushUntilNextPaint = unstable_flushUntilNextPaint;
      schedulerUnstable_mock_development.unstable_forceFrameRate = forceFrameRate;
      schedulerUnstable_mock_development.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
      schedulerUnstable_mock_development.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
      schedulerUnstable_mock_development.unstable_next = unstable_next;
      schedulerUnstable_mock_development.unstable_now = getCurrentTime;
      schedulerUnstable_mock_development.unstable_pauseExecution = unstable_pauseExecution;
      schedulerUnstable_mock_development.unstable_requestPaint = unstable_requestPaint;
      schedulerUnstable_mock_development.unstable_runWithPriority = unstable_runWithPriority;
      schedulerUnstable_mock_development.unstable_scheduleCallback = unstable_scheduleCallback;
      schedulerUnstable_mock_development.unstable_shouldYield = shouldYieldToHost;
      schedulerUnstable_mock_development.unstable_wrapCallback = unstable_wrapCallback;
      schedulerUnstable_mock_development.unstable_yieldValue = unstable_yieldValue;
    })();
  }
  return schedulerUnstable_mock_development;
}
var hasRequiredUnstable_mock;
function requireUnstable_mock() {
  if (hasRequiredUnstable_mock)
    return unstable_mock.exports;
  hasRequiredUnstable_mock = 1;
  if (process.env.NODE_ENV === "production") {
    unstable_mock.exports = requireSchedulerUnstable_mock_production_min();
  } else {
    unstable_mock.exports = requireSchedulerUnstable_mock_development();
  }
  return unstable_mock.exports;
}
var scheduler = { exports: {} };
var scheduler_production_min = {};
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_production_min;
function requireScheduler_production_min() {
  if (hasRequiredScheduler_production_min)
    return scheduler_production_min;
  hasRequiredScheduler_production_min = 1;
  (function(exports2) {
    var f, g2, h3, k3;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var l = performance;
      exports2.unstable_now = function() {
        return l.now();
      };
    } else {
      var p = Date, q2 = p.now();
      exports2.unstable_now = function() {
        return p.now() - q2;
      };
    }
    if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
      var t2 = null, u2 = null, w2 = function() {
        if (null !== t2)
          try {
            var a4 = exports2.unstable_now();
            t2(true, a4);
            t2 = null;
          } catch (b10) {
            throw setTimeout(w2, 0), b10;
          }
      };
      f = function(a4) {
        null !== t2 ? setTimeout(f, 0, a4) : (t2 = a4, setTimeout(w2, 0));
      };
      g2 = function(a4, b10) {
        u2 = setTimeout(a4, b10);
      };
      h3 = function() {
        clearTimeout(u2);
      };
      exports2.unstable_shouldYield = function() {
        return false;
      };
      k3 = exports2.unstable_forceFrameRate = function() {
      };
    } else {
      var x3 = window.setTimeout, y4 = window.clearTimeout;
      if ("undefined" !== typeof console) {
        var z2 = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof z2 && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
      }
      var A = false, B2 = null, C = -1, D2 = 5, E2 = 0;
      exports2.unstable_shouldYield = function() {
        return exports2.unstable_now() >= E2;
      };
      k3 = function() {
      };
      exports2.unstable_forceFrameRate = function(a4) {
        0 > a4 || 125 < a4 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D2 = 0 < a4 ? Math.floor(1e3 / a4) : 5;
      };
      var F = new MessageChannel(), G2 = F.port2;
      F.port1.onmessage = function() {
        if (null !== B2) {
          var a4 = exports2.unstable_now();
          E2 = a4 + D2;
          try {
            B2(true, a4) ? G2.postMessage(null) : (A = false, B2 = null);
          } catch (b10) {
            throw G2.postMessage(null), b10;
          }
        } else
          A = false;
      };
      f = function(a4) {
        B2 = a4;
        A || (A = true, G2.postMessage(null));
      };
      g2 = function(a4, b10) {
        C = x3(function() {
          a4(exports2.unstable_now());
        }, b10);
      };
      h3 = function() {
        y4(C);
        C = -1;
      };
    }
    function H3(a4, b10) {
      var c7 = a4.length;
      a4.push(b10);
      a:
        for (; ; ) {
          var d3 = c7 - 1 >>> 1, e3 = a4[d3];
          if (void 0 !== e3 && 0 < I2(e3, b10))
            a4[d3] = b10, a4[c7] = e3, c7 = d3;
          else
            break a;
        }
    }
    function J(a4) {
      a4 = a4[0];
      return void 0 === a4 ? null : a4;
    }
    function K2(a4) {
      var b10 = a4[0];
      if (void 0 !== b10) {
        var c7 = a4.pop();
        if (c7 !== b10) {
          a4[0] = c7;
          a:
            for (var d3 = 0, e3 = a4.length; d3 < e3; ) {
              var m3 = 2 * (d3 + 1) - 1, n = a4[m3], v = m3 + 1, r = a4[v];
              if (void 0 !== n && 0 > I2(n, c7))
                void 0 !== r && 0 > I2(r, n) ? (a4[d3] = r, a4[v] = c7, d3 = v) : (a4[d3] = n, a4[m3] = c7, d3 = m3);
              else if (void 0 !== r && 0 > I2(r, c7))
                a4[d3] = r, a4[v] = c7, d3 = v;
              else
                break a;
            }
        }
        return b10;
      }
      return null;
    }
    function I2(a4, b10) {
      var c7 = a4.sortIndex - b10.sortIndex;
      return 0 !== c7 ? c7 : a4.id - b10.id;
    }
    var L2 = [], M3 = [], N = 1, O2 = null, P = 3, Q2 = false, R2 = false, S3 = false;
    function T2(a4) {
      for (var b10 = J(M3); null !== b10; ) {
        if (null === b10.callback)
          K2(M3);
        else if (b10.startTime <= a4)
          K2(M3), b10.sortIndex = b10.expirationTime, H3(L2, b10);
        else
          break;
        b10 = J(M3);
      }
    }
    function U(a4) {
      S3 = false;
      T2(a4);
      if (!R2)
        if (null !== J(L2))
          R2 = true, f(V2);
        else {
          var b10 = J(M3);
          null !== b10 && g2(U, b10.startTime - a4);
        }
    }
    function V2(a4, b10) {
      R2 = false;
      S3 && (S3 = false, h3());
      Q2 = true;
      var c7 = P;
      try {
        T2(b10);
        for (O2 = J(L2); null !== O2 && (!(O2.expirationTime > b10) || a4 && !exports2.unstable_shouldYield()); ) {
          var d3 = O2.callback;
          if ("function" === typeof d3) {
            O2.callback = null;
            P = O2.priorityLevel;
            var e3 = d3(O2.expirationTime <= b10);
            b10 = exports2.unstable_now();
            "function" === typeof e3 ? O2.callback = e3 : O2 === J(L2) && K2(L2);
            T2(b10);
          } else
            K2(L2);
          O2 = J(L2);
        }
        if (null !== O2)
          var m3 = true;
        else {
          var n = J(M3);
          null !== n && g2(U, n.startTime - b10);
          m3 = false;
        }
        return m3;
      } finally {
        O2 = null, P = c7, Q2 = false;
      }
    }
    var W = k3;
    exports2.unstable_IdlePriority = 5;
    exports2.unstable_ImmediatePriority = 1;
    exports2.unstable_LowPriority = 4;
    exports2.unstable_NormalPriority = 3;
    exports2.unstable_Profiling = null;
    exports2.unstable_UserBlockingPriority = 2;
    exports2.unstable_cancelCallback = function(a4) {
      a4.callback = null;
    };
    exports2.unstable_continueExecution = function() {
      R2 || Q2 || (R2 = true, f(V2));
    };
    exports2.unstable_getCurrentPriorityLevel = function() {
      return P;
    };
    exports2.unstable_getFirstCallbackNode = function() {
      return J(L2);
    };
    exports2.unstable_next = function(a4) {
      switch (P) {
        case 1:
        case 2:
        case 3:
          var b10 = 3;
          break;
        default:
          b10 = P;
      }
      var c7 = P;
      P = b10;
      try {
        return a4();
      } finally {
        P = c7;
      }
    };
    exports2.unstable_pauseExecution = function() {
    };
    exports2.unstable_requestPaint = W;
    exports2.unstable_runWithPriority = function(a4, b10) {
      switch (a4) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          a4 = 3;
      }
      var c7 = P;
      P = a4;
      try {
        return b10();
      } finally {
        P = c7;
      }
    };
    exports2.unstable_scheduleCallback = function(a4, b10, c7) {
      var d3 = exports2.unstable_now();
      "object" === typeof c7 && null !== c7 ? (c7 = c7.delay, c7 = "number" === typeof c7 && 0 < c7 ? d3 + c7 : d3) : c7 = d3;
      switch (a4) {
        case 1:
          var e3 = -1;
          break;
        case 2:
          e3 = 250;
          break;
        case 5:
          e3 = 1073741823;
          break;
        case 4:
          e3 = 1e4;
          break;
        default:
          e3 = 5e3;
      }
      e3 = c7 + e3;
      a4 = { id: N++, callback: b10, priorityLevel: a4, startTime: c7, expirationTime: e3, sortIndex: -1 };
      c7 > d3 ? (a4.sortIndex = c7, H3(M3, a4), null === J(L2) && a4 === J(M3) && (S3 ? h3() : S3 = true, g2(U, c7 - d3))) : (a4.sortIndex = e3, H3(L2, a4), R2 || Q2 || (R2 = true, f(V2)));
      return a4;
    };
    exports2.unstable_wrapCallback = function(a4) {
      var b10 = P;
      return function() {
        var c7 = P;
        P = b10;
        try {
          return a4.apply(this, arguments);
        } finally {
          P = c7;
        }
      };
    };
  })(scheduler_production_min);
  return scheduler_production_min;
}
var scheduler_development = {};
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredScheduler_development;
function requireScheduler_development() {
  if (hasRequiredScheduler_development)
    return scheduler_development;
  hasRequiredScheduler_development = 1;
  (function(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var enableSchedulerDebugging = false;
        var enableProfiling = false;
        var requestHostCallback;
        var requestHostTimeout;
        var cancelHostTimeout;
        var requestPaint;
        var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
        if (hasPerformanceNow) {
          var localPerformance = performance;
          exports2.unstable_now = function() {
            return localPerformance.now();
          };
        } else {
          var localDate2 = Date;
          var initialTime = localDate2.now();
          exports2.unstable_now = function() {
            return localDate2.now() - initialTime;
          };
        }
        if (
          // If Scheduler runs in a non-DOM environment, it falls back to a naive
          // implementation using setTimeout.
          typeof window === "undefined" || // Check if MessageChannel is supported, too.
          typeof MessageChannel !== "function"
        ) {
          var _callback = null;
          var _timeoutID = null;
          var _flushCallback = function() {
            if (_callback !== null) {
              try {
                var currentTime = exports2.unstable_now();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
              } catch (e3) {
                setTimeout(_flushCallback, 0);
                throw e3;
              }
            }
          };
          requestHostCallback = function(cb) {
            if (_callback !== null) {
              setTimeout(requestHostCallback, 0, cb);
            } else {
              _callback = cb;
              setTimeout(_flushCallback, 0);
            }
          };
          requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
          };
          cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
          };
          exports2.unstable_shouldYield = function() {
            return false;
          };
          requestPaint = exports2.unstable_forceFrameRate = function() {
          };
        } else {
          var _setTimeout = window.setTimeout;
          var _clearTimeout = window.clearTimeout;
          if (typeof console !== "undefined") {
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame !== "function") {
              console["error"]("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            }
            if (typeof cancelAnimationFrame !== "function") {
              console["error"]("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            }
          }
          var isMessageLoopRunning = false;
          var scheduledHostCallback = null;
          var taskTimeoutID = -1;
          var yieldInterval = 5;
          var deadline = 0;
          {
            exports2.unstable_shouldYield = function() {
              return exports2.unstable_now() >= deadline;
            };
            requestPaint = function() {
            };
          }
          exports2.unstable_forceFrameRate = function(fps) {
            if (fps < 0 || fps > 125) {
              console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
              return;
            }
            if (fps > 0) {
              yieldInterval = Math.floor(1e3 / fps);
            } else {
              yieldInterval = 5;
            }
          };
          var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
              var currentTime = exports2.unstable_now();
              deadline = currentTime + yieldInterval;
              var hasTimeRemaining = true;
              try {
                var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                if (!hasMoreWork) {
                  isMessageLoopRunning = false;
                  scheduledHostCallback = null;
                } else {
                  port.postMessage(null);
                }
              } catch (error2) {
                port.postMessage(null);
                throw error2;
              }
            } else {
              isMessageLoopRunning = false;
            }
          };
          var channel2 = new MessageChannel();
          var port = channel2.port2;
          channel2.port1.onmessage = performWorkUntilDeadline;
          requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
              isMessageLoopRunning = true;
              port.postMessage(null);
            }
          };
          requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
              callback(exports2.unstable_now());
            }, ms);
          };
          cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
          };
        }
        function push(heap, node2) {
          var index2 = heap.length;
          heap.push(node2);
          siftUp(heap, node2, index2);
        }
        function peek2(heap) {
          var first = heap[0];
          return first === void 0 ? null : first;
        }
        function pop(heap) {
          var first = heap[0];
          if (first !== void 0) {
            var last2 = heap.pop();
            if (last2 !== first) {
              heap[0] = last2;
              siftDown(heap, last2, 0);
            }
            return first;
          } else {
            return null;
          }
        }
        function siftUp(heap, node2, i2) {
          var index2 = i2;
          while (true) {
            var parentIndex = index2 - 1 >>> 1;
            var parent2 = heap[parentIndex];
            if (parent2 !== void 0 && compare(parent2, node2) > 0) {
              heap[parentIndex] = node2;
              heap[index2] = parent2;
              index2 = parentIndex;
            } else {
              return;
            }
          }
        }
        function siftDown(heap, node2, i2) {
          var index2 = i2;
          var length2 = heap.length;
          while (index2 < length2) {
            var leftIndex = (index2 + 1) * 2 - 1;
            var left2 = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right2 = heap[rightIndex];
            if (left2 !== void 0 && compare(left2, node2) < 0) {
              if (right2 !== void 0 && compare(right2, left2) < 0) {
                heap[index2] = right2;
                heap[rightIndex] = node2;
                index2 = rightIndex;
              } else {
                heap[index2] = left2;
                heap[leftIndex] = node2;
                index2 = leftIndex;
              }
            } else if (right2 !== void 0 && compare(right2, node2) < 0) {
              heap[index2] = right2;
              heap[rightIndex] = node2;
              index2 = rightIndex;
            } else {
              return;
            }
          }
        }
        function compare(a4, b10) {
          var diff = a4.sortIndex - b10.sortIndex;
          return diff !== 0 ? diff : a4.id - b10.id;
        }
        var ImmediatePriority = 1;
        var UserBlockingPriority = 2;
        var NormalPriority = 3;
        var LowPriority = 4;
        var IdlePriority = 5;
        function markTaskErrored(task, ms) {
        }
        var maxSigned31BitInt = 1073741823;
        var IMMEDIATE_PRIORITY_TIMEOUT = -1;
        var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
        var NORMAL_PRIORITY_TIMEOUT = 5e3;
        var LOW_PRIORITY_TIMEOUT = 1e4;
        var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt;
        var taskQueue = [];
        var timerQueue = [];
        var taskIdCounter = 1;
        var currentTask = null;
        var currentPriorityLevel = NormalPriority;
        var isPerformingWork = false;
        var isHostCallbackScheduled = false;
        var isHostTimeoutScheduled = false;
        function advanceTimers(currentTime) {
          var timer2 = peek2(timerQueue);
          while (timer2 !== null) {
            if (timer2.callback === null) {
              pop(timerQueue);
            } else if (timer2.startTime <= currentTime) {
              pop(timerQueue);
              timer2.sortIndex = timer2.expirationTime;
              push(taskQueue, timer2);
            } else {
              return;
            }
            timer2 = peek2(timerQueue);
          }
        }
        function handleTimeout(currentTime) {
          isHostTimeoutScheduled = false;
          advanceTimers(currentTime);
          if (!isHostCallbackScheduled) {
            if (peek2(taskQueue) !== null) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            } else {
              var firstTimer = peek2(timerQueue);
              if (firstTimer !== null) {
                requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
              }
            }
          }
        }
        function flushWork(hasTimeRemaining, initialTime2) {
          isHostCallbackScheduled = false;
          if (isHostTimeoutScheduled) {
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
          }
          isPerformingWork = true;
          var previousPriorityLevel = currentPriorityLevel;
          try {
            var currentTime;
            if (enableProfiling)
              ;
            else {
              return workLoop(hasTimeRemaining, initialTime2);
            }
          } finally {
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
          }
        }
        function workLoop(hasTimeRemaining, initialTime2) {
          var currentTime = initialTime2;
          advanceTimers(currentTime);
          currentTask = peek2(taskQueue);
          while (currentTask !== null && !enableSchedulerDebugging) {
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || exports2.unstable_shouldYield())) {
              break;
            }
            var callback = currentTask.callback;
            if (typeof callback === "function") {
              currentTask.callback = null;
              currentPriorityLevel = currentTask.priorityLevel;
              var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
              var continuationCallback = callback(didUserCallbackTimeout);
              currentTime = exports2.unstable_now();
              if (typeof continuationCallback === "function") {
                currentTask.callback = continuationCallback;
              } else {
                if (currentTask === peek2(taskQueue)) {
                  pop(taskQueue);
                }
              }
              advanceTimers(currentTime);
            } else {
              pop(taskQueue);
            }
            currentTask = peek2(taskQueue);
          }
          if (currentTask !== null) {
            return true;
          } else {
            var firstTimer = peek2(timerQueue);
            if (firstTimer !== null) {
              requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
            return false;
          }
        }
        function unstable_runWithPriority(priorityLevel, eventHandler) {
          switch (priorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
              break;
            default:
              priorityLevel = NormalPriority;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_next(eventHandler) {
          var priorityLevel;
          switch (currentPriorityLevel) {
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
              priorityLevel = NormalPriority;
              break;
            default:
              priorityLevel = currentPriorityLevel;
              break;
          }
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = priorityLevel;
          try {
            return eventHandler();
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        }
        function unstable_wrapCallback(callback) {
          var parentPriorityLevel = currentPriorityLevel;
          return function() {
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
              return callback.apply(this, arguments);
            } finally {
              currentPriorityLevel = previousPriorityLevel;
            }
          };
        }
        function unstable_scheduleCallback(priorityLevel, callback, options2) {
          var currentTime = exports2.unstable_now();
          var startTime;
          if (typeof options2 === "object" && options2 !== null) {
            var delay = options2.delay;
            if (typeof delay === "number" && delay > 0) {
              startTime = currentTime + delay;
            } else {
              startTime = currentTime;
            }
          } else {
            startTime = currentTime;
          }
          var timeout2;
          switch (priorityLevel) {
            case ImmediatePriority:
              timeout2 = IMMEDIATE_PRIORITY_TIMEOUT;
              break;
            case UserBlockingPriority:
              timeout2 = USER_BLOCKING_PRIORITY_TIMEOUT;
              break;
            case IdlePriority:
              timeout2 = IDLE_PRIORITY_TIMEOUT;
              break;
            case LowPriority:
              timeout2 = LOW_PRIORITY_TIMEOUT;
              break;
            case NormalPriority:
            default:
              timeout2 = NORMAL_PRIORITY_TIMEOUT;
              break;
          }
          var expirationTime = startTime + timeout2;
          var newTask = {
            id: taskIdCounter++,
            callback,
            priorityLevel,
            startTime,
            expirationTime,
            sortIndex: -1
          };
          if (startTime > currentTime) {
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek2(taskQueue) === null && newTask === peek2(timerQueue)) {
              if (isHostTimeoutScheduled) {
                cancelHostTimeout();
              } else {
                isHostTimeoutScheduled = true;
              }
              requestHostTimeout(handleTimeout, startTime - currentTime);
            }
          } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            if (!isHostCallbackScheduled && !isPerformingWork) {
              isHostCallbackScheduled = true;
              requestHostCallback(flushWork);
            }
          }
          return newTask;
        }
        function unstable_pauseExecution() {
        }
        function unstable_continueExecution() {
          if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
          }
        }
        function unstable_getFirstCallbackNode() {
          return peek2(taskQueue);
        }
        function unstable_cancelCallback(task) {
          task.callback = null;
        }
        function unstable_getCurrentPriorityLevel() {
          return currentPriorityLevel;
        }
        var unstable_requestPaint = requestPaint;
        var unstable_Profiling = null;
        exports2.unstable_IdlePriority = IdlePriority;
        exports2.unstable_ImmediatePriority = ImmediatePriority;
        exports2.unstable_LowPriority = LowPriority;
        exports2.unstable_NormalPriority = NormalPriority;
        exports2.unstable_Profiling = unstable_Profiling;
        exports2.unstable_UserBlockingPriority = UserBlockingPriority;
        exports2.unstable_cancelCallback = unstable_cancelCallback;
        exports2.unstable_continueExecution = unstable_continueExecution;
        exports2.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
        exports2.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
        exports2.unstable_next = unstable_next;
        exports2.unstable_pauseExecution = unstable_pauseExecution;
        exports2.unstable_requestPaint = unstable_requestPaint;
        exports2.unstable_runWithPriority = unstable_runWithPriority;
        exports2.unstable_scheduleCallback = unstable_scheduleCallback;
        exports2.unstable_wrapCallback = unstable_wrapCallback;
      })();
    }
  })(scheduler_development);
  return scheduler_development;
}
var hasRequiredScheduler;
function requireScheduler() {
  if (hasRequiredScheduler)
    return scheduler.exports;
  hasRequiredScheduler = 1;
  if (process.env.NODE_ENV === "production") {
    scheduler.exports = requireScheduler_production_min();
  } else {
    scheduler.exports = requireScheduler_development();
  }
  return scheduler.exports;
}
/** @license React v17.0.2
 * react-test-renderer.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
reactTestRenderer_production_min.exports;
var hasRequiredReactTestRenderer_production_min;
function requireReactTestRenderer_production_min() {
  if (hasRequiredReactTestRenderer_production_min)
    return reactTestRenderer_production_min.exports;
  hasRequiredReactTestRenderer_production_min = 1;
  (function(module2, exports2) {
    var aa = requireObjectAssign(), ba = requireUnstable_mock(), ca = React__default, n = requireScheduler();
    function q2(a4) {
      for (var b10 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a4, c7 = 1; c7 < arguments.length; c7++)
        b10 += "&args[]=" + encodeURIComponent(arguments[c7]);
      return "Minified React error #" + a4 + "; visit " + b10 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function da(a4, b10) {
      for (var c7 = 0; c7 < b10.length; c7++) {
        var d3 = b10[c7];
        d3.enumerable = d3.enumerable || false;
        d3.configurable = true;
        "value" in d3 && (d3.writable = true);
        Object.defineProperty(a4, d3.key, d3);
      }
    }
    function ea(a4, b10, c7) {
      b10 && da(a4.prototype, b10);
      c7 && da(a4, c7);
      return a4;
    }
    var fa = ca.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, ha = 60103, ia = 60106, ja = 60107, ka2 = 60108, la = 60114, ma = 60109, na = 60110, oa = 60112, pa = 60113, qa = 60120, ra = 60115, sa = 60116, ta = 60121, ua = 60129, va = 60130, wa = 60131;
    if ("function" === typeof Symbol && Symbol.for) {
      var w2 = Symbol.for;
      ha = w2("react.element");
      ia = w2("react.portal");
      ja = w2("react.fragment");
      ka2 = w2("react.strict_mode");
      la = w2("react.profiler");
      ma = w2("react.provider");
      na = w2("react.context");
      oa = w2("react.forward_ref");
      pa = w2("react.suspense");
      qa = w2("react.suspense_list");
      ra = w2("react.memo");
      sa = w2("react.lazy");
      ta = w2("react.block");
      w2("react.scope");
      ua = w2("react.debug_trace_mode");
      va = w2("react.offscreen");
      wa = w2("react.legacy_hidden");
    }
    var xa = "function" === typeof Symbol && Symbol.iterator;
    function ya(a4) {
      if (null === a4 || "object" !== typeof a4)
        return null;
      a4 = xa && a4[xa] || a4["@@iterator"];
      return "function" === typeof a4 ? a4 : null;
    }
    function za(a4) {
      if (null == a4)
        return null;
      if ("function" === typeof a4)
        return a4.displayName || a4.name || null;
      if ("string" === typeof a4)
        return a4;
      switch (a4) {
        case ja:
          return "Fragment";
        case ia:
          return "Portal";
        case la:
          return "Profiler";
        case ka2:
          return "StrictMode";
        case pa:
          return "Suspense";
        case qa:
          return "SuspenseList";
      }
      if ("object" === typeof a4)
        switch (a4.$$typeof) {
          case na:
            return (a4.displayName || "Context") + ".Consumer";
          case ma:
            return (a4._context.displayName || "Context") + ".Provider";
          case oa:
            var b10 = a4.render;
            b10 = b10.displayName || b10.name || "";
            return a4.displayName || ("" !== b10 ? "ForwardRef(" + b10 + ")" : "ForwardRef");
          case ra:
            return za(a4.type);
          case ta:
            return za(a4._render);
          case sa:
            b10 = a4._payload;
            a4 = a4._init;
            try {
              return za(a4(b10));
            } catch (c7) {
            }
        }
      return null;
    }
    function Ba(a4) {
      var b10 = a4, c7 = a4;
      if (a4.alternate)
        for (; b10.return; )
          b10 = b10.return;
      else {
        a4 = b10;
        do
          b10 = a4, 0 !== (b10.flags & 1026) && (c7 = b10.return), a4 = b10.return;
        while (a4);
      }
      return 3 === b10.tag ? c7 : null;
    }
    function Ca(a4) {
      if (Ba(a4) !== a4)
        throw Error(q2(188));
    }
    function Da(a4) {
      var b10 = a4.alternate;
      if (!b10) {
        b10 = Ba(a4);
        if (null === b10)
          throw Error(q2(188));
        return b10 !== a4 ? null : a4;
      }
      for (var c7 = a4, d3 = b10; ; ) {
        var e3 = c7.return;
        if (null === e3)
          break;
        var f = e3.alternate;
        if (null === f) {
          d3 = e3.return;
          if (null !== d3) {
            c7 = d3;
            continue;
          }
          break;
        }
        if (e3.child === f.child) {
          for (f = e3.child; f; ) {
            if (f === c7)
              return Ca(e3), a4;
            if (f === d3)
              return Ca(e3), b10;
            f = f.sibling;
          }
          throw Error(q2(188));
        }
        if (c7.return !== d3.return)
          c7 = e3, d3 = f;
        else {
          for (var h3 = false, g2 = e3.child; g2; ) {
            if (g2 === c7) {
              h3 = true;
              c7 = e3;
              d3 = f;
              break;
            }
            if (g2 === d3) {
              h3 = true;
              d3 = e3;
              c7 = f;
              break;
            }
            g2 = g2.sibling;
          }
          if (!h3) {
            for (g2 = f.child; g2; ) {
              if (g2 === c7) {
                h3 = true;
                c7 = f;
                d3 = e3;
                break;
              }
              if (g2 === d3) {
                h3 = true;
                d3 = f;
                c7 = e3;
                break;
              }
              g2 = g2.sibling;
            }
            if (!h3)
              throw Error(q2(189));
          }
        }
        if (c7.alternate !== d3)
          throw Error(q2(190));
      }
      if (3 !== c7.tag)
        throw Error(q2(188));
      return c7.stateNode.current === c7 ? a4 : b10;
    }
    function Ea(a4) {
      a4 = Da(a4);
      if (!a4)
        return null;
      for (var b10 = a4; ; ) {
        if (5 === b10.tag || 6 === b10.tag)
          return b10;
        if (b10.child)
          b10.child.return = b10, b10 = b10.child;
        else {
          if (b10 === a4)
            break;
          for (; !b10.sibling; ) {
            if (!b10.return || b10.return === a4)
              return null;
            b10 = b10.return;
          }
          b10.sibling.return = b10.return;
          b10 = b10.sibling;
        }
      }
      return null;
    }
    function Fa(a4, b10) {
      for (var c7 = a4.alternate; null !== b10; ) {
        if (b10 === a4 || b10 === c7)
          return true;
        b10 = b10.return;
      }
      return false;
    }
    var Ga = {}, Ha = {}, Ia = /* @__PURE__ */ new WeakMap();
    function Ja(a4) {
      switch (a4.tag) {
        case "INSTANCE":
          var b10 = a4.rootContainerInstance.createNodeMock;
          b10 = b10({ type: a4.type, props: a4.props });
          "object" === typeof b10 && null !== b10 && Ia.set(b10, a4);
          return b10;
        default:
          return a4;
      }
    }
    function Ka(a4, b10) {
      var c7 = a4.children.indexOf(b10);
      -1 !== c7 && a4.children.splice(c7, 1);
      a4.children.push(b10);
    }
    function La(a4, b10, c7) {
      var d3 = a4.children.indexOf(b10);
      -1 !== d3 && a4.children.splice(d3, 1);
      c7 = a4.children.indexOf(c7);
      a4.children.splice(c7, 0, b10);
    }
    var Ma = setTimeout, Na = clearTimeout, Oa = 0, Pa;
    function Qa(a4) {
      if (void 0 === Pa)
        try {
          throw Error();
        } catch (c7) {
          var b10 = c7.stack.trim().match(/\n( *(at )?)/);
          Pa = b10 && b10[1] || "";
        }
      return "\n" + Pa + a4;
    }
    var Ra = false;
    function Sa(a4, b10) {
      if (!a4 || Ra)
        return "";
      Ra = true;
      var c7 = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (b10)
          if (b10 = function() {
            throw Error();
          }, Object.defineProperty(b10.prototype, "props", { set: function() {
            throw Error();
          } }), "object" === typeof Reflect && Reflect.construct) {
            try {
              Reflect.construct(b10, []);
            } catch (k3) {
              var d3 = k3;
            }
            Reflect.construct(a4, [], b10);
          } else {
            try {
              b10.call();
            } catch (k3) {
              d3 = k3;
            }
            a4.call(b10.prototype);
          }
        else {
          try {
            throw Error();
          } catch (k3) {
            d3 = k3;
          }
          a4();
        }
      } catch (k3) {
        if (k3 && d3 && "string" === typeof k3.stack) {
          for (var e3 = k3.stack.split("\n"), f = d3.stack.split("\n"), h3 = e3.length - 1, g2 = f.length - 1; 1 <= h3 && 0 <= g2 && e3[h3] !== f[g2]; )
            g2--;
          for (; 1 <= h3 && 0 <= g2; h3--, g2--)
            if (e3[h3] !== f[g2]) {
              if (1 !== h3 || 1 !== g2) {
                do
                  if (h3--, g2--, 0 > g2 || e3[h3] !== f[g2])
                    return "\n" + e3[h3].replace(" at new ", " at ");
                while (1 <= h3 && 0 <= g2);
              }
              break;
            }
        }
      } finally {
        Ra = false, Error.prepareStackTrace = c7;
      }
      return (a4 = a4 ? a4.displayName || a4.name : "") ? Qa(a4) : "";
    }
    var Ta = [], Ua = -1;
    function Va(a4) {
      return { current: a4 };
    }
    function A(a4) {
      0 > Ua || (a4.current = Ta[Ua], Ta[Ua] = null, Ua--);
    }
    function B2(a4, b10) {
      Ua++;
      Ta[Ua] = a4.current;
      a4.current = b10;
    }
    var Wa = {}, C = Va(Wa), D2 = Va(false), Xa = Wa;
    function Ya(a4, b10) {
      var c7 = a4.type.contextTypes;
      if (!c7)
        return Wa;
      var d3 = a4.stateNode;
      if (d3 && d3.__reactInternalMemoizedUnmaskedChildContext === b10)
        return d3.__reactInternalMemoizedMaskedChildContext;
      var e3 = {}, f;
      for (f in c7)
        e3[f] = b10[f];
      d3 && (a4 = a4.stateNode, a4.__reactInternalMemoizedUnmaskedChildContext = b10, a4.__reactInternalMemoizedMaskedChildContext = e3);
      return e3;
    }
    function E2(a4) {
      a4 = a4.childContextTypes;
      return null !== a4 && void 0 !== a4;
    }
    function Za() {
      A(D2);
      A(C);
    }
    function $a(a4, b10, c7) {
      if (C.current !== Wa)
        throw Error(q2(168));
      B2(C, b10);
      B2(D2, c7);
    }
    function ab(a4, b10, c7) {
      var d3 = a4.stateNode;
      a4 = b10.childContextTypes;
      if ("function" !== typeof d3.getChildContext)
        return c7;
      d3 = d3.getChildContext();
      for (var e3 in d3)
        if (!(e3 in a4))
          throw Error(q2(108, za(b10) || "Unknown", e3));
      return aa({}, c7, d3);
    }
    function bb(a4) {
      a4 = (a4 = a4.stateNode) && a4.__reactInternalMemoizedMergedChildContext || Wa;
      Xa = C.current;
      B2(C, a4);
      B2(D2, D2.current);
      return true;
    }
    function cb(a4, b10, c7) {
      var d3 = a4.stateNode;
      if (!d3)
        throw Error(q2(169));
      c7 ? (a4 = ab(a4, b10, Xa), d3.__reactInternalMemoizedMergedChildContext = a4, A(D2), A(C), B2(C, a4)) : A(D2);
      B2(D2, c7);
    }
    var db = null, eb = null, fb = n.unstable_now;
    fb();
    var F = 8;
    function gb(a4) {
      if (0 !== (1 & a4))
        return F = 15, 1;
      if (0 !== (2 & a4))
        return F = 14, 2;
      if (0 !== (4 & a4))
        return F = 13, 4;
      var b10 = 24 & a4;
      if (0 !== b10)
        return F = 12, b10;
      if (0 !== (a4 & 32))
        return F = 11, 32;
      b10 = 192 & a4;
      if (0 !== b10)
        return F = 10, b10;
      if (0 !== (a4 & 256))
        return F = 9, 256;
      b10 = 3584 & a4;
      if (0 !== b10)
        return F = 8, b10;
      if (0 !== (a4 & 4096))
        return F = 7, 4096;
      b10 = 4186112 & a4;
      if (0 !== b10)
        return F = 6, b10;
      b10 = 62914560 & a4;
      if (0 !== b10)
        return F = 5, b10;
      if (a4 & 67108864)
        return F = 4, 67108864;
      if (0 !== (a4 & 134217728))
        return F = 3, 134217728;
      b10 = 805306368 & a4;
      if (0 !== b10)
        return F = 2, b10;
      if (0 !== (1073741824 & a4))
        return F = 1, 1073741824;
      F = 8;
      return a4;
    }
    function hb(a4) {
      switch (a4) {
        case 99:
          return 15;
        case 98:
          return 10;
        case 97:
        case 96:
          return 8;
        case 95:
          return 2;
        default:
          return 0;
      }
    }
    function ib(a4) {
      switch (a4) {
        case 15:
        case 14:
          return 99;
        case 13:
        case 12:
        case 11:
        case 10:
          return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
          return 97;
        case 3:
        case 2:
        case 1:
          return 95;
        case 0:
          return 90;
        default:
          throw Error(q2(358, a4));
      }
    }
    function jb(a4, b10) {
      var c7 = a4.pendingLanes;
      if (0 === c7)
        return F = 0;
      var d3 = 0, e3 = 0, f = a4.expiredLanes, h3 = a4.suspendedLanes, g2 = a4.pingedLanes;
      if (0 !== f)
        d3 = f, e3 = F = 15;
      else if (f = c7 & 134217727, 0 !== f) {
        var k3 = f & ~h3;
        0 !== k3 ? (d3 = gb(k3), e3 = F) : (g2 &= f, 0 !== g2 && (d3 = gb(g2), e3 = F));
      } else
        f = c7 & ~h3, 0 !== f ? (d3 = gb(f), e3 = F) : 0 !== g2 && (d3 = gb(g2), e3 = F);
      if (0 === d3)
        return 0;
      d3 = 31 - kb(d3);
      d3 = c7 & ((0 > d3 ? 0 : 1 << d3) << 1) - 1;
      if (0 !== b10 && b10 !== d3 && 0 === (b10 & h3)) {
        gb(b10);
        if (e3 <= F)
          return b10;
        F = e3;
      }
      b10 = a4.entangledLanes;
      if (0 !== b10)
        for (a4 = a4.entanglements, b10 &= d3; 0 < b10; )
          c7 = 31 - kb(b10), e3 = 1 << c7, d3 |= a4[c7], b10 &= ~e3;
      return d3;
    }
    function lb(a4) {
      a4 = a4.pendingLanes & -1073741825;
      return 0 !== a4 ? a4 : a4 & 1073741824 ? 1073741824 : 0;
    }
    function mb(a4, b10) {
      switch (a4) {
        case 15:
          return 1;
        case 14:
          return 2;
        case 12:
          return a4 = nb(24 & ~b10), 0 === a4 ? mb(10, b10) : a4;
        case 10:
          return a4 = nb(192 & ~b10), 0 === a4 ? mb(8, b10) : a4;
        case 8:
          return a4 = nb(3584 & ~b10), 0 === a4 && (a4 = nb(4186112 & ~b10), 0 === a4 && (a4 = 512)), a4;
        case 2:
          return b10 = nb(805306368 & ~b10), 0 === b10 && (b10 = 268435456), b10;
      }
      throw Error(q2(358, a4));
    }
    function nb(a4) {
      return a4 & -a4;
    }
    function ob(a4) {
      for (var b10 = [], c7 = 0; 31 > c7; c7++)
        b10.push(a4);
      return b10;
    }
    function pb(a4, b10, c7) {
      a4.pendingLanes |= b10;
      var d3 = b10 - 1;
      a4.suspendedLanes &= d3;
      a4.pingedLanes &= d3;
      a4 = a4.eventTimes;
      b10 = 31 - kb(b10);
      a4[b10] = c7;
    }
    var kb = Math.clz32 ? Math.clz32 : qb, rb = Math.log, sb = Math.LN2;
    function qb(a4) {
      return 0 === a4 ? 32 : 31 - (rb(a4) / sb | 0) | 0;
    }
    var tb = n.unstable_runWithPriority, ub = n.unstable_scheduleCallback, vb = n.unstable_cancelCallback, wb = n.unstable_shouldYield, xb = n.unstable_requestPaint, yb = n.unstable_now, zb = n.unstable_getCurrentPriorityLevel, Ab = n.unstable_ImmediatePriority, Bb = n.unstable_UserBlockingPriority, Cb = n.unstable_NormalPriority, Db = n.unstable_LowPriority, Eb = n.unstable_IdlePriority, Fb = {}, Gb = void 0 !== xb ? xb : function() {
    }, Hb = null, Ib = null, Jb = false, Kb = yb(), G2 = 1e4 > Kb ? yb : function() {
      return yb() - Kb;
    };
    function Lb() {
      switch (zb()) {
        case Ab:
          return 99;
        case Bb:
          return 98;
        case Cb:
          return 97;
        case Db:
          return 96;
        case Eb:
          return 95;
        default:
          throw Error(q2(332));
      }
    }
    function Mb(a4) {
      switch (a4) {
        case 99:
          return Ab;
        case 98:
          return Bb;
        case 97:
          return Cb;
        case 96:
          return Db;
        case 95:
          return Eb;
        default:
          throw Error(q2(332));
      }
    }
    function Nb(a4, b10) {
      a4 = Mb(a4);
      return tb(a4, b10);
    }
    function Ob(a4, b10, c7) {
      a4 = Mb(a4);
      return ub(a4, b10, c7);
    }
    function Pb() {
      if (null !== Ib) {
        var a4 = Ib;
        Ib = null;
        vb(a4);
      }
      Qb();
    }
    function Qb() {
      if (!Jb && null !== Hb) {
        Jb = true;
        var a4 = 0;
        try {
          var b10 = Hb;
          Nb(99, function() {
            for (; a4 < b10.length; a4++) {
              var c7 = b10[a4];
              do
                c7 = c7(true);
              while (null !== c7);
            }
          });
          Hb = null;
        } catch (c7) {
          throw null !== Hb && (Hb = Hb.slice(a4 + 1)), ub(Ab, Pb), c7;
        } finally {
          Jb = false;
        }
      }
    }
    var Rb = fa.ReactCurrentBatchConfig;
    function Sb(a4, b10) {
      return a4 === b10 && (0 !== a4 || 1 / a4 === 1 / b10) || a4 !== a4 && b10 !== b10;
    }
    var H3 = "function" === typeof Object.is ? Object.is : Sb, Tb = Object.prototype.hasOwnProperty;
    function Ub(a4, b10) {
      if (H3(a4, b10))
        return true;
      if ("object" !== typeof a4 || null === a4 || "object" !== typeof b10 || null === b10)
        return false;
      var c7 = Object.keys(a4), d3 = Object.keys(b10);
      if (c7.length !== d3.length)
        return false;
      for (d3 = 0; d3 < c7.length; d3++)
        if (!Tb.call(b10, c7[d3]) || !H3(a4[c7[d3]], b10[c7[d3]]))
          return false;
      return true;
    }
    function Vb(a4) {
      switch (a4.tag) {
        case 5:
          return Qa(a4.type);
        case 16:
          return Qa("Lazy");
        case 13:
          return Qa("Suspense");
        case 19:
          return Qa("SuspenseList");
        case 0:
        case 2:
        case 15:
          return a4 = Sa(a4.type, false), a4;
        case 11:
          return a4 = Sa(a4.type.render, false), a4;
        case 22:
          return a4 = Sa(a4.type._render, false), a4;
        case 1:
          return a4 = Sa(a4.type, true), a4;
        default:
          return "";
      }
    }
    function I2(a4, b10) {
      if (a4 && a4.defaultProps) {
        b10 = aa({}, b10);
        a4 = a4.defaultProps;
        for (var c7 in a4)
          void 0 === b10[c7] && (b10[c7] = a4[c7]);
        return b10;
      }
      return b10;
    }
    var Wb = Va(null), Xb = null, Yb = null, Zb = null;
    function $b() {
      Zb = Yb = Xb = null;
    }
    function ac(a4) {
      var b10 = Wb.current;
      A(Wb);
      a4.type._context._currentValue2 = b10;
    }
    function bc(a4, b10) {
      for (; null !== a4; ) {
        var c7 = a4.alternate;
        if ((a4.childLanes & b10) === b10)
          if (null === c7 || (c7.childLanes & b10) === b10)
            break;
          else
            c7.childLanes |= b10;
        else
          a4.childLanes |= b10, null !== c7 && (c7.childLanes |= b10);
        a4 = a4.return;
      }
    }
    function cc(a4, b10) {
      Xb = a4;
      Zb = Yb = null;
      a4 = a4.dependencies;
      null !== a4 && null !== a4.firstContext && (0 !== (a4.lanes & b10) && (J = true), a4.firstContext = null);
    }
    function K2(a4, b10) {
      if (Zb !== a4 && false !== b10 && 0 !== b10) {
        if ("number" !== typeof b10 || 1073741823 === b10)
          Zb = a4, b10 = 1073741823;
        b10 = { context: a4, observedBits: b10, next: null };
        if (null === Yb) {
          if (null === Xb)
            throw Error(q2(308));
          Yb = b10;
          Xb.dependencies = { lanes: 0, firstContext: b10, responders: null };
        } else
          Yb = Yb.next = b10;
      }
      return a4._currentValue2;
    }
    var dc = false;
    function ec(a4) {
      a4.updateQueue = { baseState: a4.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null }, effects: null };
    }
    function fc(a4, b10) {
      a4 = a4.updateQueue;
      b10.updateQueue === a4 && (b10.updateQueue = { baseState: a4.baseState, firstBaseUpdate: a4.firstBaseUpdate, lastBaseUpdate: a4.lastBaseUpdate, shared: a4.shared, effects: a4.effects });
    }
    function gc(a4, b10) {
      return { eventTime: a4, lane: b10, tag: 0, payload: null, callback: null, next: null };
    }
    function hc(a4, b10) {
      a4 = a4.updateQueue;
      if (null !== a4) {
        a4 = a4.shared;
        var c7 = a4.pending;
        null === c7 ? b10.next = b10 : (b10.next = c7.next, c7.next = b10);
        a4.pending = b10;
      }
    }
    function ic(a4, b10) {
      var c7 = a4.updateQueue, d3 = a4.alternate;
      if (null !== d3 && (d3 = d3.updateQueue, c7 === d3)) {
        var e3 = null, f = null;
        c7 = c7.firstBaseUpdate;
        if (null !== c7) {
          do {
            var h3 = { eventTime: c7.eventTime, lane: c7.lane, tag: c7.tag, payload: c7.payload, callback: c7.callback, next: null };
            null === f ? e3 = f = h3 : f = f.next = h3;
            c7 = c7.next;
          } while (null !== c7);
          null === f ? e3 = f = b10 : f = f.next = b10;
        } else
          e3 = f = b10;
        c7 = { baseState: d3.baseState, firstBaseUpdate: e3, lastBaseUpdate: f, shared: d3.shared, effects: d3.effects };
        a4.updateQueue = c7;
        return;
      }
      a4 = c7.lastBaseUpdate;
      null === a4 ? c7.firstBaseUpdate = b10 : a4.next = b10;
      c7.lastBaseUpdate = b10;
    }
    function jc(a4, b10, c7, d3) {
      var e3 = a4.updateQueue;
      dc = false;
      var f = e3.firstBaseUpdate, h3 = e3.lastBaseUpdate, g2 = e3.shared.pending;
      if (null !== g2) {
        e3.shared.pending = null;
        var k3 = g2, l = k3.next;
        k3.next = null;
        null === h3 ? f = l : h3.next = l;
        h3 = k3;
        var p = a4.alternate;
        if (null !== p) {
          p = p.updateQueue;
          var r = p.lastBaseUpdate;
          r !== h3 && (null === r ? p.firstBaseUpdate = l : r.next = l, p.lastBaseUpdate = k3);
        }
      }
      if (null !== f) {
        r = e3.baseState;
        h3 = 0;
        p = l = k3 = null;
        do {
          g2 = f.lane;
          var m3 = f.eventTime;
          if ((d3 & g2) === g2) {
            null !== p && (p = p.next = {
              eventTime: m3,
              lane: 0,
              tag: f.tag,
              payload: f.payload,
              callback: f.callback,
              next: null
            });
            a: {
              var z2 = a4, x3 = f;
              g2 = b10;
              m3 = c7;
              switch (x3.tag) {
                case 1:
                  z2 = x3.payload;
                  if ("function" === typeof z2) {
                    r = z2.call(m3, r, g2);
                    break a;
                  }
                  r = z2;
                  break a;
                case 3:
                  z2.flags = z2.flags & -4097 | 64;
                case 0:
                  z2 = x3.payload;
                  g2 = "function" === typeof z2 ? z2.call(m3, r, g2) : z2;
                  if (null === g2 || void 0 === g2)
                    break a;
                  r = aa({}, r, g2);
                  break a;
                case 2:
                  dc = true;
              }
            }
            null !== f.callback && (a4.flags |= 32, g2 = e3.effects, null === g2 ? e3.effects = [f] : g2.push(f));
          } else
            m3 = { eventTime: m3, lane: g2, tag: f.tag, payload: f.payload, callback: f.callback, next: null }, null === p ? (l = p = m3, k3 = r) : p = p.next = m3, h3 |= g2;
          f = f.next;
          if (null === f)
            if (g2 = e3.shared.pending, null === g2)
              break;
            else
              f = g2.next, g2.next = null, e3.lastBaseUpdate = g2, e3.shared.pending = null;
        } while (1);
        null === p && (k3 = r);
        e3.baseState = k3;
        e3.firstBaseUpdate = l;
        e3.lastBaseUpdate = p;
        kc |= h3;
        a4.lanes = h3;
        a4.memoizedState = r;
      }
    }
    function lc(a4, b10, c7) {
      a4 = b10.effects;
      b10.effects = null;
      if (null !== a4)
        for (b10 = 0; b10 < a4.length; b10++) {
          var d3 = a4[b10], e3 = d3.callback;
          if (null !== e3) {
            d3.callback = null;
            d3 = c7;
            if ("function" !== typeof e3)
              throw Error(q2(191, e3));
            e3.call(d3);
          }
        }
    }
    var mc = new ca.Component().refs;
    function nc(a4, b10, c7, d3) {
      b10 = a4.memoizedState;
      c7 = c7(d3, b10);
      c7 = null === c7 || void 0 === c7 ? b10 : aa({}, b10, c7);
      a4.memoizedState = c7;
      0 === a4.lanes && (a4.updateQueue.baseState = c7);
    }
    var rc = { isMounted: function(a4) {
      return (a4 = a4._reactInternals) ? Ba(a4) === a4 : false;
    }, enqueueSetState: function(a4, b10, c7) {
      a4 = a4._reactInternals;
      var d3 = oc(), e3 = pc(a4), f = gc(d3, e3);
      f.payload = b10;
      void 0 !== c7 && null !== c7 && (f.callback = c7);
      hc(a4, f);
      qc(a4, e3, d3);
    }, enqueueReplaceState: function(a4, b10, c7) {
      a4 = a4._reactInternals;
      var d3 = oc(), e3 = pc(a4), f = gc(d3, e3);
      f.tag = 1;
      f.payload = b10;
      void 0 !== c7 && null !== c7 && (f.callback = c7);
      hc(a4, f);
      qc(a4, e3, d3);
    }, enqueueForceUpdate: function(a4, b10) {
      a4 = a4._reactInternals;
      var c7 = oc(), d3 = pc(a4), e3 = gc(c7, d3);
      e3.tag = 2;
      void 0 !== b10 && null !== b10 && (e3.callback = b10);
      hc(a4, e3);
      qc(a4, d3, c7);
    } };
    function sc(a4, b10, c7, d3, e3, f, h3) {
      a4 = a4.stateNode;
      return "function" === typeof a4.shouldComponentUpdate ? a4.shouldComponentUpdate(d3, f, h3) : b10.prototype && b10.prototype.isPureReactComponent ? !Ub(c7, d3) || !Ub(e3, f) : true;
    }
    function tc(a4, b10, c7) {
      var d3 = false, e3 = Wa;
      var f = b10.contextType;
      "object" === typeof f && null !== f ? f = K2(f) : (e3 = E2(b10) ? Xa : C.current, d3 = b10.contextTypes, f = (d3 = null !== d3 && void 0 !== d3) ? Ya(a4, e3) : Wa);
      b10 = new b10(c7, f);
      a4.memoizedState = null !== b10.state && void 0 !== b10.state ? b10.state : null;
      b10.updater = rc;
      a4.stateNode = b10;
      b10._reactInternals = a4;
      d3 && (a4 = a4.stateNode, a4.__reactInternalMemoizedUnmaskedChildContext = e3, a4.__reactInternalMemoizedMaskedChildContext = f);
      return b10;
    }
    function uc(a4, b10, c7, d3) {
      a4 = b10.state;
      "function" === typeof b10.componentWillReceiveProps && b10.componentWillReceiveProps(c7, d3);
      "function" === typeof b10.UNSAFE_componentWillReceiveProps && b10.UNSAFE_componentWillReceiveProps(c7, d3);
      b10.state !== a4 && rc.enqueueReplaceState(b10, b10.state, null);
    }
    function vc(a4, b10, c7, d3) {
      var e3 = a4.stateNode;
      e3.props = c7;
      e3.state = a4.memoizedState;
      e3.refs = mc;
      ec(a4);
      var f = b10.contextType;
      "object" === typeof f && null !== f ? e3.context = K2(f) : (f = E2(b10) ? Xa : C.current, e3.context = Ya(a4, f));
      jc(a4, c7, e3, d3);
      e3.state = a4.memoizedState;
      f = b10.getDerivedStateFromProps;
      "function" === typeof f && (nc(a4, b10, f, c7), e3.state = a4.memoizedState);
      "function" === typeof b10.getDerivedStateFromProps || "function" === typeof e3.getSnapshotBeforeUpdate || "function" !== typeof e3.UNSAFE_componentWillMount && "function" !== typeof e3.componentWillMount || (b10 = e3.state, "function" === typeof e3.componentWillMount && e3.componentWillMount(), "function" === typeof e3.UNSAFE_componentWillMount && e3.UNSAFE_componentWillMount(), b10 !== e3.state && rc.enqueueReplaceState(e3, e3.state, null), jc(a4, c7, e3, d3), e3.state = a4.memoizedState);
      "function" === typeof e3.componentDidMount && (a4.flags |= 4);
    }
    var wc = Array.isArray;
    function xc(a4, b10, c7) {
      a4 = c7.ref;
      if (null !== a4 && "function" !== typeof a4 && "object" !== typeof a4) {
        if (c7._owner) {
          c7 = c7._owner;
          if (c7) {
            if (1 !== c7.tag)
              throw Error(q2(309));
            var d3 = c7.stateNode;
          }
          if (!d3)
            throw Error(q2(147, a4));
          var e3 = "" + a4;
          if (null !== b10 && null !== b10.ref && "function" === typeof b10.ref && b10.ref._stringRef === e3)
            return b10.ref;
          b10 = function(a5) {
            var b11 = d3.refs;
            b11 === mc && (b11 = d3.refs = {});
            null === a5 ? delete b11[e3] : b11[e3] = a5;
          };
          b10._stringRef = e3;
          return b10;
        }
        if ("string" !== typeof a4)
          throw Error(q2(284));
        if (!c7._owner)
          throw Error(q2(290, a4));
      }
      return a4;
    }
    function yc(a4, b10) {
      if ("textarea" !== a4.type)
        throw Error(q2(31, "[object Object]" === Object.prototype.toString.call(b10) ? "object with keys {" + Object.keys(b10).join(", ") + "}" : b10));
    }
    function zc(a4) {
      function b10(b11, c8) {
        if (a4) {
          var d4 = b11.lastEffect;
          null !== d4 ? (d4.nextEffect = c8, b11.lastEffect = c8) : b11.firstEffect = b11.lastEffect = c8;
          c8.nextEffect = null;
          c8.flags = 8;
        }
      }
      function c7(c8, d4) {
        if (!a4)
          return null;
        for (; null !== d4; )
          b10(c8, d4), d4 = d4.sibling;
        return null;
      }
      function d3(a5, b11) {
        for (a5 = /* @__PURE__ */ new Map(); null !== b11; )
          null !== b11.key ? a5.set(b11.key, b11) : a5.set(b11.index, b11), b11 = b11.sibling;
        return a5;
      }
      function e3(a5, b11) {
        a5 = Ac(a5, b11);
        a5.index = 0;
        a5.sibling = null;
        return a5;
      }
      function f(b11, c8, d4) {
        b11.index = d4;
        if (!a4)
          return c8;
        d4 = b11.alternate;
        if (null !== d4)
          return d4 = d4.index, d4 < c8 ? (b11.flags = 2, c8) : d4;
        b11.flags = 2;
        return c8;
      }
      function h3(b11) {
        a4 && null === b11.alternate && (b11.flags = 2);
        return b11;
      }
      function g2(a5, b11, c8, d4) {
        if (null === b11 || 6 !== b11.tag)
          return b11 = Bc(c8, a5.mode, d4), b11.return = a5, b11;
        b11 = e3(b11, c8);
        b11.return = a5;
        return b11;
      }
      function k3(a5, b11, c8, d4) {
        if (null !== b11 && b11.elementType === c8.type)
          return d4 = e3(b11, c8.props), d4.ref = xc(a5, b11, c8), d4.return = a5, d4;
        d4 = Cc(c8.type, c8.key, c8.props, null, a5.mode, d4);
        d4.ref = xc(a5, b11, c8);
        d4.return = a5;
        return d4;
      }
      function l(a5, b11, c8, d4) {
        if (null === b11 || 4 !== b11.tag || b11.stateNode.containerInfo !== c8.containerInfo || b11.stateNode.implementation !== c8.implementation)
          return b11 = Dc(c8, a5.mode, d4), b11.return = a5, b11;
        b11 = e3(b11, c8.children || []);
        b11.return = a5;
        return b11;
      }
      function p(a5, b11, c8, d4, f2) {
        if (null === b11 || 7 !== b11.tag)
          return b11 = Ec(c8, a5.mode, d4, f2), b11.return = a5, b11;
        b11 = e3(b11, c8);
        b11.return = a5;
        return b11;
      }
      function r(a5, b11, c8) {
        if ("string" === typeof b11 || "number" === typeof b11)
          return b11 = Bc("" + b11, a5.mode, c8), b11.return = a5, b11;
        if ("object" === typeof b11 && null !== b11) {
          switch (b11.$$typeof) {
            case ha:
              return c8 = Cc(b11.type, b11.key, b11.props, null, a5.mode, c8), c8.ref = xc(a5, null, b11), c8.return = a5, c8;
            case ia:
              return b11 = Dc(b11, a5.mode, c8), b11.return = a5, b11;
          }
          if (wc(b11) || ya(b11))
            return b11 = Ec(
              b11,
              a5.mode,
              c8,
              null
            ), b11.return = a5, b11;
          yc(a5, b11);
        }
        return null;
      }
      function m3(a5, b11, c8, d4) {
        var e4 = null !== b11 ? b11.key : null;
        if ("string" === typeof c8 || "number" === typeof c8)
          return null !== e4 ? null : g2(a5, b11, "" + c8, d4);
        if ("object" === typeof c8 && null !== c8) {
          switch (c8.$$typeof) {
            case ha:
              return c8.key === e4 ? c8.type === ja ? p(a5, b11, c8.props.children, d4, e4) : k3(a5, b11, c8, d4) : null;
            case ia:
              return c8.key === e4 ? l(a5, b11, c8, d4) : null;
          }
          if (wc(c8) || ya(c8))
            return null !== e4 ? null : p(a5, b11, c8, d4, null);
          yc(a5, c8);
        }
        return null;
      }
      function z2(a5, b11, c8, d4, e4) {
        if ("string" === typeof d4 || "number" === typeof d4)
          return a5 = a5.get(c8) || null, g2(b11, a5, "" + d4, e4);
        if ("object" === typeof d4 && null !== d4) {
          switch (d4.$$typeof) {
            case ha:
              return a5 = a5.get(null === d4.key ? c8 : d4.key) || null, d4.type === ja ? p(b11, a5, d4.props.children, e4, d4.key) : k3(b11, a5, d4, e4);
            case ia:
              return a5 = a5.get(null === d4.key ? c8 : d4.key) || null, l(b11, a5, d4, e4);
          }
          if (wc(d4) || ya(d4))
            return a5 = a5.get(c8) || null, p(b11, a5, d4, e4, null);
          yc(b11, d4);
        }
        return null;
      }
      function x3(e4, h4, g3, k4) {
        for (var u2 = null, l2 = null, t2 = h4, y4 = h4 = 0, p2 = null; null !== t2 && y4 < g3.length; y4++) {
          t2.index > y4 ? (p2 = t2, t2 = null) : p2 = t2.sibling;
          var v = m3(e4, t2, g3[y4], k4);
          if (null === v) {
            null === t2 && (t2 = p2);
            break;
          }
          a4 && t2 && null === v.alternate && b10(e4, t2);
          h4 = f(v, h4, y4);
          null === l2 ? u2 = v : l2.sibling = v;
          l2 = v;
          t2 = p2;
        }
        if (y4 === g3.length)
          return c7(e4, t2), u2;
        if (null === t2) {
          for (; y4 < g3.length; y4++)
            t2 = r(e4, g3[y4], k4), null !== t2 && (h4 = f(t2, h4, y4), null === l2 ? u2 = t2 : l2.sibling = t2, l2 = t2);
          return u2;
        }
        for (t2 = d3(e4, t2); y4 < g3.length; y4++)
          p2 = z2(t2, e4, y4, g3[y4], k4), null !== p2 && (a4 && null !== p2.alternate && t2.delete(null === p2.key ? y4 : p2.key), h4 = f(p2, h4, y4), null === l2 ? u2 = p2 : l2.sibling = p2, l2 = p2);
        a4 && t2.forEach(function(a5) {
          return b10(e4, a5);
        });
        return u2;
      }
      function V2(e4, h4, g3, k4) {
        var t2 = ya(g3);
        if ("function" !== typeof t2)
          throw Error(q2(150));
        g3 = t2.call(g3);
        if (null == g3)
          throw Error(q2(151));
        for (var l2 = t2 = null, u2 = h4, y4 = h4 = 0, p2 = null, v = g3.next(); null !== u2 && !v.done; y4++, v = g3.next()) {
          u2.index > y4 ? (p2 = u2, u2 = null) : p2 = u2.sibling;
          var x4 = m3(e4, u2, v.value, k4);
          if (null === x4) {
            null === u2 && (u2 = p2);
            break;
          }
          a4 && u2 && null === x4.alternate && b10(e4, u2);
          h4 = f(x4, h4, y4);
          null === l2 ? t2 = x4 : l2.sibling = x4;
          l2 = x4;
          u2 = p2;
        }
        if (v.done)
          return c7(e4, u2), t2;
        if (null === u2) {
          for (; !v.done; y4++, v = g3.next())
            v = r(e4, v.value, k4), null !== v && (h4 = f(v, h4, y4), null === l2 ? t2 = v : l2.sibling = v, l2 = v);
          return t2;
        }
        for (u2 = d3(e4, u2); !v.done; y4++, v = g3.next())
          v = z2(u2, e4, y4, v.value, k4), null !== v && (a4 && null !== v.alternate && u2.delete(null === v.key ? y4 : v.key), h4 = f(v, h4, y4), null === l2 ? t2 = v : l2.sibling = v, l2 = v);
        a4 && u2.forEach(function(a5) {
          return b10(e4, a5);
        });
        return t2;
      }
      return function(a5, d4, f2, g3) {
        var k4 = "object" === typeof f2 && null !== f2 && f2.type === ja && null === f2.key;
        k4 && (f2 = f2.props.children);
        var l2 = "object" === typeof f2 && null !== f2;
        if (l2)
          switch (f2.$$typeof) {
            case ha:
              a: {
                l2 = f2.key;
                for (k4 = d4; null !== k4; ) {
                  if (k4.key === l2) {
                    switch (k4.tag) {
                      case 7:
                        if (f2.type === ja) {
                          c7(a5, k4.sibling);
                          d4 = e3(k4, f2.props.children);
                          d4.return = a5;
                          a5 = d4;
                          break a;
                        }
                        break;
                      default:
                        if (k4.elementType === f2.type) {
                          c7(a5, k4.sibling);
                          d4 = e3(k4, f2.props);
                          d4.ref = xc(a5, k4, f2);
                          d4.return = a5;
                          a5 = d4;
                          break a;
                        }
                    }
                    c7(a5, k4);
                    break;
                  } else
                    b10(a5, k4);
                  k4 = k4.sibling;
                }
                f2.type === ja ? (d4 = Ec(f2.props.children, a5.mode, g3, f2.key), d4.return = a5, a5 = d4) : (g3 = Cc(f2.type, f2.key, f2.props, null, a5.mode, g3), g3.ref = xc(a5, d4, f2), g3.return = a5, a5 = g3);
              }
              return h3(a5);
            case ia:
              a: {
                for (k4 = f2.key; null !== d4; ) {
                  if (d4.key === k4)
                    if (4 === d4.tag && d4.stateNode.containerInfo === f2.containerInfo && d4.stateNode.implementation === f2.implementation) {
                      c7(a5, d4.sibling);
                      d4 = e3(d4, f2.children || []);
                      d4.return = a5;
                      a5 = d4;
                      break a;
                    } else {
                      c7(a5, d4);
                      break;
                    }
                  else
                    b10(a5, d4);
                  d4 = d4.sibling;
                }
                d4 = Dc(f2, a5.mode, g3);
                d4.return = a5;
                a5 = d4;
              }
              return h3(a5);
          }
        if ("string" === typeof f2 || "number" === typeof f2)
          return f2 = "" + f2, null !== d4 && 6 === d4.tag ? (c7(a5, d4.sibling), d4 = e3(d4, f2), d4.return = a5, a5 = d4) : (c7(a5, d4), d4 = Bc(f2, a5.mode, g3), d4.return = a5, a5 = d4), h3(a5);
        if (wc(f2))
          return x3(a5, d4, f2, g3);
        if (ya(f2))
          return V2(a5, d4, f2, g3);
        l2 && yc(a5, f2);
        if ("undefined" === typeof f2 && !k4)
          switch (a5.tag) {
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
              throw Error(q2(152, za(a5.type) || "Component"));
          }
        return c7(a5, d4);
      };
    }
    var Fc = zc(true), Gc = zc(false), Hc = {}, Ic = Va(Hc), Jc = Va(Hc), Kc = Va(Hc);
    function Lc(a4) {
      if (a4 === Hc)
        throw Error(q2(174));
      return a4;
    }
    function Mc(a4, b10) {
      B2(Kc, b10);
      B2(Jc, a4);
      B2(Ic, Hc);
      A(Ic);
      B2(Ic, Ga);
    }
    function Nc() {
      A(Ic);
      A(Jc);
      A(Kc);
    }
    function Oc(a4) {
      Lc(Kc.current);
      Lc(Ic.current) !== Ga && (B2(Jc, a4), B2(Ic, Ga));
    }
    function Qc(a4) {
      Jc.current === a4 && (A(Ic), A(Jc));
    }
    var L2 = Va(0);
    function Rc(a4) {
      for (var b10 = a4; null !== b10; ) {
        if (13 === b10.tag) {
          var c7 = b10.memoizedState, d3;
          if (d3 = null !== c7) {
            if (!(c7 = null === c7.dehydrated))
              throw Error(q2(305));
            if (!c7)
              throw Error(q2(305));
            d3 = c7;
          }
          if (d3)
            return b10;
        } else if (19 === b10.tag && void 0 !== b10.memoizedProps.revealOrder) {
          if (0 !== (b10.flags & 64))
            return b10;
        } else if (null !== b10.child) {
          b10.child.return = b10;
          b10 = b10.child;
          continue;
        }
        if (b10 === a4)
          break;
        for (; null === b10.sibling; ) {
          if (null === b10.return || b10.return === a4)
            return null;
          b10 = b10.return;
        }
        b10.sibling.return = b10.return;
        b10 = b10.sibling;
      }
      return null;
    }
    var Sc = [];
    function Tc() {
      for (var a4 = 0; a4 < Sc.length; a4++)
        Sc[a4]._workInProgressVersionSecondary = null;
      Sc.length = 0;
    }
    var Uc = fa.ReactCurrentDispatcher, M3 = fa.ReactCurrentBatchConfig, Vc = 0, N = null, O2 = null, P = null, Wc = false, Xc = false;
    function Q2() {
      throw Error(q2(321));
    }
    function Yc(a4, b10) {
      if (null === b10)
        return false;
      for (var c7 = 0; c7 < b10.length && c7 < a4.length; c7++)
        if (!H3(a4[c7], b10[c7]))
          return false;
      return true;
    }
    function Zc(a4, b10, c7, d3, e3, f) {
      Vc = f;
      N = b10;
      b10.memoizedState = null;
      b10.updateQueue = null;
      b10.lanes = 0;
      Uc.current = null === a4 || null === a4.memoizedState ? $c : ad;
      a4 = c7(d3, e3);
      if (Xc) {
        f = 0;
        do {
          Xc = false;
          if (!(25 > f))
            throw Error(q2(301));
          f += 1;
          P = O2 = null;
          b10.updateQueue = null;
          Uc.current = bd;
          a4 = c7(d3, e3);
        } while (Xc);
      }
      Uc.current = cd;
      b10 = null !== O2 && null !== O2.next;
      Vc = 0;
      P = O2 = N = null;
      Wc = false;
      if (b10)
        throw Error(q2(300));
      return a4;
    }
    function dd() {
      var a4 = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      null === P ? N.memoizedState = P = a4 : P = P.next = a4;
      return P;
    }
    function ed() {
      if (null === O2) {
        var a4 = N.alternate;
        a4 = null !== a4 ? a4.memoizedState : null;
      } else
        a4 = O2.next;
      var b10 = null === P ? N.memoizedState : P.next;
      if (null !== b10)
        P = b10, O2 = a4;
      else {
        if (null === a4)
          throw Error(q2(310));
        O2 = a4;
        a4 = { memoizedState: O2.memoizedState, baseState: O2.baseState, baseQueue: O2.baseQueue, queue: O2.queue, next: null };
        null === P ? N.memoizedState = P = a4 : P = P.next = a4;
      }
      return P;
    }
    function fd(a4, b10) {
      return "function" === typeof b10 ? b10(a4) : b10;
    }
    function gd(a4) {
      var b10 = ed(), c7 = b10.queue;
      if (null === c7)
        throw Error(q2(311));
      c7.lastRenderedReducer = a4;
      var d3 = O2, e3 = d3.baseQueue, f = c7.pending;
      if (null !== f) {
        if (null !== e3) {
          var h3 = e3.next;
          e3.next = f.next;
          f.next = h3;
        }
        d3.baseQueue = e3 = f;
        c7.pending = null;
      }
      if (null !== e3) {
        e3 = e3.next;
        d3 = d3.baseState;
        var g2 = h3 = f = null, k3 = e3;
        do {
          var l = k3.lane;
          if ((Vc & l) === l)
            null !== g2 && (g2 = g2.next = { lane: 0, action: k3.action, eagerReducer: k3.eagerReducer, eagerState: k3.eagerState, next: null }), d3 = k3.eagerReducer === a4 ? k3.eagerState : a4(d3, k3.action);
          else {
            var p = {
              lane: l,
              action: k3.action,
              eagerReducer: k3.eagerReducer,
              eagerState: k3.eagerState,
              next: null
            };
            null === g2 ? (h3 = g2 = p, f = d3) : g2 = g2.next = p;
            N.lanes |= l;
            kc |= l;
          }
          k3 = k3.next;
        } while (null !== k3 && k3 !== e3);
        null === g2 ? f = d3 : g2.next = h3;
        H3(d3, b10.memoizedState) || (J = true);
        b10.memoizedState = d3;
        b10.baseState = f;
        b10.baseQueue = g2;
        c7.lastRenderedState = d3;
      }
      return [b10.memoizedState, c7.dispatch];
    }
    function hd(a4) {
      var b10 = ed(), c7 = b10.queue;
      if (null === c7)
        throw Error(q2(311));
      c7.lastRenderedReducer = a4;
      var d3 = c7.dispatch, e3 = c7.pending, f = b10.memoizedState;
      if (null !== e3) {
        c7.pending = null;
        var h3 = e3 = e3.next;
        do
          f = a4(f, h3.action), h3 = h3.next;
        while (h3 !== e3);
        H3(f, b10.memoizedState) || (J = true);
        b10.memoizedState = f;
        null === b10.baseQueue && (b10.baseState = f);
        c7.lastRenderedState = f;
      }
      return [f, d3];
    }
    function id(a4, b10, c7) {
      var d3 = b10._getVersion;
      d3 = d3(b10._source);
      var e3 = b10._workInProgressVersionSecondary;
      if (null !== e3)
        a4 = e3 === d3;
      else if (a4 = a4.mutableReadLanes, a4 = (Vc & a4) === a4)
        b10._workInProgressVersionSecondary = d3, Sc.push(b10);
      if (a4)
        return c7(b10._source);
      Sc.push(b10);
      throw Error(q2(350));
    }
    function jd(a4, b10, c7, d3) {
      var e3 = R2;
      if (null === e3)
        throw Error(q2(349));
      var f = b10._getVersion, h3 = f(b10._source), g2 = Uc.current, k3 = g2.useState(function() {
        return id(e3, b10, c7);
      }), l = k3[1], p = k3[0];
      k3 = P;
      var r = a4.memoizedState, m3 = r.refs, z2 = m3.getSnapshot, x3 = r.source;
      r = r.subscribe;
      var V2 = N;
      a4.memoizedState = { refs: m3, source: b10, subscribe: d3 };
      g2.useEffect(function() {
        m3.getSnapshot = c7;
        m3.setSnapshot = l;
        var a5 = f(b10._source);
        if (!H3(h3, a5)) {
          a5 = c7(b10._source);
          H3(p, a5) || (l(a5), a5 = pc(V2), e3.mutableReadLanes |= a5 & e3.pendingLanes);
          a5 = e3.mutableReadLanes;
          e3.entangledLanes |= a5;
          for (var d4 = e3.entanglements, g3 = a5; 0 < g3; ) {
            var k4 = 31 - kb(g3), r2 = 1 << k4;
            d4[k4] |= a5;
            g3 &= ~r2;
          }
        }
      }, [c7, b10, d3]);
      g2.useEffect(function() {
        return d3(b10._source, function() {
          var a5 = m3.getSnapshot, c8 = m3.setSnapshot;
          try {
            c8(a5(b10._source));
            var d4 = pc(V2);
            e3.mutableReadLanes |= d4 & e3.pendingLanes;
          } catch (Aa) {
            c8(function() {
              throw Aa;
            });
          }
        });
      }, [b10, d3]);
      H3(z2, c7) && H3(x3, b10) && H3(r, d3) || (a4 = { pending: null, dispatch: null, lastRenderedReducer: fd, lastRenderedState: p }, a4.dispatch = l = kd.bind(null, N, a4), k3.queue = a4, k3.baseQueue = null, p = id(e3, b10, c7), k3.memoizedState = k3.baseState = p);
      return p;
    }
    function ld(a4, b10, c7) {
      var d3 = ed();
      return jd(d3, a4, b10, c7);
    }
    function md(a4) {
      var b10 = dd();
      "function" === typeof a4 && (a4 = a4());
      b10.memoizedState = b10.baseState = a4;
      a4 = b10.queue = { pending: null, dispatch: null, lastRenderedReducer: fd, lastRenderedState: a4 };
      a4 = a4.dispatch = kd.bind(null, N, a4);
      return [b10.memoizedState, a4];
    }
    function nd(a4, b10, c7, d3) {
      a4 = { tag: a4, create: b10, destroy: c7, deps: d3, next: null };
      b10 = N.updateQueue;
      null === b10 ? (b10 = { lastEffect: null }, N.updateQueue = b10, b10.lastEffect = a4.next = a4) : (c7 = b10.lastEffect, null === c7 ? b10.lastEffect = a4.next = a4 : (d3 = c7.next, c7.next = a4, a4.next = d3, b10.lastEffect = a4));
      return a4;
    }
    function od(a4) {
      var b10 = dd();
      a4 = { current: a4 };
      return b10.memoizedState = a4;
    }
    function pd() {
      return ed().memoizedState;
    }
    function qd(a4, b10, c7, d3) {
      var e3 = dd();
      N.flags |= a4;
      e3.memoizedState = nd(1 | b10, c7, void 0, void 0 === d3 ? null : d3);
    }
    function rd(a4, b10, c7, d3) {
      var e3 = ed();
      d3 = void 0 === d3 ? null : d3;
      var f = void 0;
      if (null !== O2) {
        var h3 = O2.memoizedState;
        f = h3.destroy;
        if (null !== d3 && Yc(d3, h3.deps)) {
          nd(b10, c7, f, d3);
          return;
        }
      }
      N.flags |= a4;
      e3.memoizedState = nd(1 | b10, c7, f, d3);
    }
    function sd(a4, b10) {
      return qd(516, 4, a4, b10);
    }
    function td(a4, b10) {
      return rd(516, 4, a4, b10);
    }
    function ud(a4, b10) {
      return rd(4, 2, a4, b10);
    }
    function vd(a4, b10) {
      if ("function" === typeof b10)
        return a4 = a4(), b10(a4), function() {
          b10(null);
        };
      if (null !== b10 && void 0 !== b10)
        return a4 = a4(), b10.current = a4, function() {
          b10.current = null;
        };
    }
    function wd(a4, b10, c7) {
      c7 = null !== c7 && void 0 !== c7 ? c7.concat([a4]) : null;
      return rd(4, 2, vd.bind(null, b10, a4), c7);
    }
    function xd() {
    }
    function yd(a4, b10) {
      var c7 = ed();
      b10 = void 0 === b10 ? null : b10;
      var d3 = c7.memoizedState;
      if (null !== d3 && null !== b10 && Yc(b10, d3[1]))
        return d3[0];
      c7.memoizedState = [a4, b10];
      return a4;
    }
    function zd(a4, b10) {
      var c7 = ed();
      b10 = void 0 === b10 ? null : b10;
      var d3 = c7.memoizedState;
      if (null !== d3 && null !== b10 && Yc(b10, d3[1]))
        return d3[0];
      a4 = a4();
      c7.memoizedState = [a4, b10];
      return a4;
    }
    function Ad(a4, b10) {
      var c7 = Lb();
      Nb(98 > c7 ? 98 : c7, function() {
        a4(true);
      });
      Nb(97 < c7 ? 97 : c7, function() {
        var c8 = M3.transition;
        M3.transition = 1;
        try {
          a4(false), b10();
        } finally {
          M3.transition = c8;
        }
      });
    }
    function kd(a4, b10, c7) {
      var d3 = oc(), e3 = pc(a4), f = { lane: e3, action: c7, eagerReducer: null, eagerState: null, next: null }, h3 = b10.pending;
      null === h3 ? f.next = f : (f.next = h3.next, h3.next = f);
      b10.pending = f;
      h3 = a4.alternate;
      if (a4 === N || null !== h3 && h3 === N)
        Xc = Wc = true;
      else {
        if (0 === a4.lanes && (null === h3 || 0 === h3.lanes) && (h3 = b10.lastRenderedReducer, null !== h3))
          try {
            var g2 = b10.lastRenderedState, k3 = h3(g2, c7);
            f.eagerReducer = h3;
            f.eagerState = k3;
            if (H3(k3, g2))
              return;
          } catch (l) {
          } finally {
          }
        qc(a4, e3, d3);
      }
    }
    var cd = { readContext: K2, useCallback: Q2, useContext: Q2, useEffect: Q2, useImperativeHandle: Q2, useLayoutEffect: Q2, useMemo: Q2, useReducer: Q2, useRef: Q2, useState: Q2, useDebugValue: Q2, useDeferredValue: Q2, useTransition: Q2, useMutableSource: Q2, useOpaqueIdentifier: Q2, unstable_isNewReconciler: false }, $c = { readContext: K2, useCallback: function(a4, b10) {
      dd().memoizedState = [a4, void 0 === b10 ? null : b10];
      return a4;
    }, useContext: K2, useEffect: sd, useImperativeHandle: function(a4, b10, c7) {
      c7 = null !== c7 && void 0 !== c7 ? c7.concat([a4]) : null;
      return qd(4, 2, vd.bind(null, b10, a4), c7);
    }, useLayoutEffect: function(a4, b10) {
      return qd(4, 2, a4, b10);
    }, useMemo: function(a4, b10) {
      var c7 = dd();
      b10 = void 0 === b10 ? null : b10;
      a4 = a4();
      c7.memoizedState = [a4, b10];
      return a4;
    }, useReducer: function(a4, b10, c7) {
      var d3 = dd();
      b10 = void 0 !== c7 ? c7(b10) : b10;
      d3.memoizedState = d3.baseState = b10;
      a4 = d3.queue = { pending: null, dispatch: null, lastRenderedReducer: a4, lastRenderedState: b10 };
      a4 = a4.dispatch = kd.bind(null, N, a4);
      return [d3.memoizedState, a4];
    }, useRef: od, useState: md, useDebugValue: xd, useDeferredValue: function(a4) {
      var b10 = md(a4), c7 = b10[0], d3 = b10[1];
      sd(function() {
        var b11 = M3.transition;
        M3.transition = 1;
        try {
          d3(a4);
        } finally {
          M3.transition = b11;
        }
      }, [a4]);
      return c7;
    }, useTransition: function() {
      var a4 = md(false), b10 = a4[0];
      a4 = Ad.bind(null, a4[1]);
      od(a4);
      return [a4, b10];
    }, useMutableSource: function(a4, b10, c7) {
      var d3 = dd();
      d3.memoizedState = { refs: { getSnapshot: b10, setSnapshot: null }, source: a4, subscribe: c7 };
      return jd(d3, a4, b10, c7);
    }, useOpaqueIdentifier: function() {
      var a4 = "c_" + (Oa++).toString(36);
      md(a4);
      return a4;
    }, unstable_isNewReconciler: false }, ad = {
      readContext: K2,
      useCallback: yd,
      useContext: K2,
      useEffect: td,
      useImperativeHandle: wd,
      useLayoutEffect: ud,
      useMemo: zd,
      useReducer: gd,
      useRef: pd,
      useState: function() {
        return gd(fd);
      },
      useDebugValue: xd,
      useDeferredValue: function(a4) {
        var b10 = gd(fd), c7 = b10[0], d3 = b10[1];
        td(function() {
          var b11 = M3.transition;
          M3.transition = 1;
          try {
            d3(a4);
          } finally {
            M3.transition = b11;
          }
        }, [a4]);
        return c7;
      },
      useTransition: function() {
        var a4 = gd(fd)[0];
        return [pd().current, a4];
      },
      useMutableSource: ld,
      useOpaqueIdentifier: function() {
        return gd(fd)[0];
      },
      unstable_isNewReconciler: false
    }, bd = {
      readContext: K2,
      useCallback: yd,
      useContext: K2,
      useEffect: td,
      useImperativeHandle: wd,
      useLayoutEffect: ud,
      useMemo: zd,
      useReducer: hd,
      useRef: pd,
      useState: function() {
        return hd(fd);
      },
      useDebugValue: xd,
      useDeferredValue: function(a4) {
        var b10 = hd(fd), c7 = b10[0], d3 = b10[1];
        td(function() {
          var b11 = M3.transition;
          M3.transition = 1;
          try {
            d3(a4);
          } finally {
            M3.transition = b11;
          }
        }, [a4]);
        return c7;
      },
      useTransition: function() {
        var a4 = hd(fd)[0];
        return [pd().current, a4];
      },
      useMutableSource: ld,
      useOpaqueIdentifier: function() {
        return hd(fd)[0];
      },
      unstable_isNewReconciler: false
    }, Bd = fa.ReactCurrentOwner, J = false;
    function S3(a4, b10, c7, d3) {
      b10.child = null === a4 ? Gc(b10, null, c7, d3) : Fc(b10, a4.child, c7, d3);
    }
    function Cd(a4, b10, c7, d3, e3) {
      c7 = c7.render;
      var f = b10.ref;
      cc(b10, e3);
      d3 = Zc(a4, b10, c7, d3, f, e3);
      if (null !== a4 && !J)
        return b10.updateQueue = a4.updateQueue, b10.flags &= -517, a4.lanes &= ~e3, Dd(a4, b10, e3);
      b10.flags |= 1;
      S3(a4, b10, d3, e3);
      return b10.child;
    }
    function Ed(a4, b10, c7, d3, e3, f) {
      if (null === a4) {
        var h3 = c7.type;
        if ("function" === typeof h3 && !Fd(h3) && void 0 === h3.defaultProps && null === c7.compare && void 0 === c7.defaultProps)
          return b10.tag = 15, b10.type = h3, Gd(a4, b10, h3, d3, e3, f);
        a4 = Cc(c7.type, null, d3, b10, b10.mode, f);
        a4.ref = b10.ref;
        a4.return = b10;
        return b10.child = a4;
      }
      h3 = a4.child;
      if (0 === (e3 & f) && (e3 = h3.memoizedProps, c7 = c7.compare, c7 = null !== c7 ? c7 : Ub, c7(e3, d3) && a4.ref === b10.ref))
        return Dd(a4, b10, f);
      b10.flags |= 1;
      a4 = Ac(h3, d3);
      a4.ref = b10.ref;
      a4.return = b10;
      return b10.child = a4;
    }
    function Gd(a4, b10, c7, d3, e3, f) {
      if (null !== a4 && Ub(a4.memoizedProps, d3) && a4.ref === b10.ref)
        if (J = false, 0 !== (f & e3))
          0 !== (a4.flags & 16384) && (J = true);
        else
          return b10.lanes = a4.lanes, Dd(a4, b10, f);
      return Hd(a4, b10, c7, d3, f);
    }
    function Id(a4, b10, c7) {
      var d3 = b10.pendingProps, e3 = d3.children, f = null !== a4 ? a4.memoizedState : null;
      if ("hidden" === d3.mode || "unstable-defer-without-hiding" === d3.mode)
        if (0 === (b10.mode & 4))
          b10.memoizedState = { baseLanes: 0 }, Jd(b10, c7);
        else if (0 !== (c7 & 1073741824))
          b10.memoizedState = { baseLanes: 0 }, Jd(b10, null !== f ? f.baseLanes : c7);
        else
          return a4 = null !== f ? f.baseLanes | c7 : c7, b10.lanes = b10.childLanes = 1073741824, b10.memoizedState = { baseLanes: a4 }, Jd(b10, a4), null;
      else
        null !== f ? (d3 = f.baseLanes | c7, b10.memoizedState = null) : d3 = c7, Jd(b10, d3);
      S3(a4, b10, e3, c7);
      return b10.child;
    }
    function Kd(a4, b10) {
      var c7 = b10.ref;
      if (null === a4 && null !== c7 || null !== a4 && a4.ref !== c7)
        b10.flags |= 128;
    }
    function Hd(a4, b10, c7, d3, e3) {
      var f = E2(c7) ? Xa : C.current;
      f = Ya(b10, f);
      cc(b10, e3);
      c7 = Zc(a4, b10, c7, d3, f, e3);
      if (null !== a4 && !J)
        return b10.updateQueue = a4.updateQueue, b10.flags &= -517, a4.lanes &= ~e3, Dd(a4, b10, e3);
      b10.flags |= 1;
      S3(a4, b10, c7, e3);
      return b10.child;
    }
    function Ld(a4, b10, c7, d3, e3) {
      if (E2(c7)) {
        var f = true;
        bb(b10);
      } else
        f = false;
      cc(b10, e3);
      if (null === b10.stateNode)
        null !== a4 && (a4.alternate = null, b10.alternate = null, b10.flags |= 2), tc(b10, c7, d3), vc(b10, c7, d3, e3), d3 = true;
      else if (null === a4) {
        var h3 = b10.stateNode, g2 = b10.memoizedProps;
        h3.props = g2;
        var k3 = h3.context, l = c7.contextType;
        "object" === typeof l && null !== l ? l = K2(l) : (l = E2(c7) ? Xa : C.current, l = Ya(b10, l));
        var p = c7.getDerivedStateFromProps, r = "function" === typeof p || "function" === typeof h3.getSnapshotBeforeUpdate;
        r || "function" !== typeof h3.UNSAFE_componentWillReceiveProps && "function" !== typeof h3.componentWillReceiveProps || (g2 !== d3 || k3 !== l) && uc(b10, h3, d3, l);
        dc = false;
        var m3 = b10.memoizedState;
        h3.state = m3;
        jc(b10, d3, h3, e3);
        k3 = b10.memoizedState;
        g2 !== d3 || m3 !== k3 || D2.current || dc ? ("function" === typeof p && (nc(b10, c7, p, d3), k3 = b10.memoizedState), (g2 = dc || sc(b10, c7, g2, d3, m3, k3, l)) ? (r || "function" !== typeof h3.UNSAFE_componentWillMount && "function" !== typeof h3.componentWillMount || ("function" === typeof h3.componentWillMount && h3.componentWillMount(), "function" === typeof h3.UNSAFE_componentWillMount && h3.UNSAFE_componentWillMount()), "function" === typeof h3.componentDidMount && (b10.flags |= 4)) : ("function" === typeof h3.componentDidMount && (b10.flags |= 4), b10.memoizedProps = d3, b10.memoizedState = k3), h3.props = d3, h3.state = k3, h3.context = l, d3 = g2) : ("function" === typeof h3.componentDidMount && (b10.flags |= 4), d3 = false);
      } else {
        h3 = b10.stateNode;
        fc(a4, b10);
        g2 = b10.memoizedProps;
        l = b10.type === b10.elementType ? g2 : I2(b10.type, g2);
        h3.props = l;
        r = b10.pendingProps;
        m3 = h3.context;
        k3 = c7.contextType;
        "object" === typeof k3 && null !== k3 ? k3 = K2(k3) : (k3 = E2(c7) ? Xa : C.current, k3 = Ya(b10, k3));
        var z2 = c7.getDerivedStateFromProps;
        (p = "function" === typeof z2 || "function" === typeof h3.getSnapshotBeforeUpdate) || "function" !== typeof h3.UNSAFE_componentWillReceiveProps && "function" !== typeof h3.componentWillReceiveProps || (g2 !== r || m3 !== k3) && uc(b10, h3, d3, k3);
        dc = false;
        m3 = b10.memoizedState;
        h3.state = m3;
        jc(b10, d3, h3, e3);
        var x3 = b10.memoizedState;
        g2 !== r || m3 !== x3 || D2.current || dc ? ("function" === typeof z2 && (nc(b10, c7, z2, d3), x3 = b10.memoizedState), (l = dc || sc(b10, c7, l, d3, m3, x3, k3)) ? (p || "function" !== typeof h3.UNSAFE_componentWillUpdate && "function" !== typeof h3.componentWillUpdate || ("function" === typeof h3.componentWillUpdate && h3.componentWillUpdate(d3, x3, k3), "function" === typeof h3.UNSAFE_componentWillUpdate && h3.UNSAFE_componentWillUpdate(d3, x3, k3)), "function" === typeof h3.componentDidUpdate && (b10.flags |= 4), "function" === typeof h3.getSnapshotBeforeUpdate && (b10.flags |= 256)) : ("function" !== typeof h3.componentDidUpdate || g2 === a4.memoizedProps && m3 === a4.memoizedState || (b10.flags |= 4), "function" !== typeof h3.getSnapshotBeforeUpdate || g2 === a4.memoizedProps && m3 === a4.memoizedState || (b10.flags |= 256), b10.memoizedProps = d3, b10.memoizedState = x3), h3.props = d3, h3.state = x3, h3.context = k3, d3 = l) : ("function" !== typeof h3.componentDidUpdate || g2 === a4.memoizedProps && m3 === a4.memoizedState || (b10.flags |= 4), "function" !== typeof h3.getSnapshotBeforeUpdate || g2 === a4.memoizedProps && m3 === a4.memoizedState || (b10.flags |= 256), d3 = false);
      }
      return Md(a4, b10, c7, d3, f, e3);
    }
    function Md(a4, b10, c7, d3, e3, f) {
      Kd(a4, b10);
      var h3 = 0 !== (b10.flags & 64);
      if (!d3 && !h3)
        return e3 && cb(b10, c7, false), Dd(a4, b10, f);
      d3 = b10.stateNode;
      Bd.current = b10;
      var g2 = h3 && "function" !== typeof c7.getDerivedStateFromError ? null : d3.render();
      b10.flags |= 1;
      null !== a4 && h3 ? (b10.child = Fc(b10, a4.child, null, f), b10.child = Fc(b10, null, g2, f)) : S3(a4, b10, g2, f);
      b10.memoizedState = d3.state;
      e3 && cb(b10, c7, true);
      return b10.child;
    }
    function Nd(a4) {
      var b10 = a4.stateNode;
      b10.pendingContext ? $a(a4, b10.pendingContext, b10.pendingContext !== b10.context) : b10.context && $a(a4, b10.context, false);
      Mc(a4, b10.containerInfo);
    }
    var Od = { dehydrated: null, retryLane: 0 };
    function Pd(a4, b10, c7) {
      var d3 = b10.pendingProps, e3 = L2.current, f = false, h3;
      (h3 = 0 !== (b10.flags & 64)) || (h3 = null !== a4 && null === a4.memoizedState ? false : 0 !== (e3 & 2));
      h3 ? (f = true, b10.flags &= -65) : null !== a4 && null === a4.memoizedState || void 0 === d3.fallback || true === d3.unstable_avoidThisFallback || (e3 |= 1);
      B2(L2, e3 & 1);
      if (null === a4) {
        a4 = d3.children;
        e3 = d3.fallback;
        if (f)
          return a4 = Qd(b10, a4, e3, c7), b10.child.memoizedState = { baseLanes: c7 }, b10.memoizedState = Od, a4;
        if ("number" === typeof d3.unstable_expectedLoadTime)
          return a4 = Qd(b10, a4, e3, c7), b10.child.memoizedState = { baseLanes: c7 }, b10.memoizedState = Od, b10.lanes = 33554432, a4;
        c7 = Rd({ mode: "visible", children: a4 }, b10.mode, c7, null);
        c7.return = b10;
        return b10.child = c7;
      }
      if (null !== a4.memoizedState) {
        if (f)
          return d3 = Sd(a4, b10, d3.children, d3.fallback, c7), f = b10.child, e3 = a4.child.memoizedState, f.memoizedState = null === e3 ? { baseLanes: c7 } : { baseLanes: e3.baseLanes | c7 }, f.childLanes = a4.childLanes & ~c7, b10.memoizedState = Od, d3;
        c7 = Td(a4, b10, d3.children, c7);
        b10.memoizedState = null;
        return c7;
      }
      if (f)
        return d3 = Sd(a4, b10, d3.children, d3.fallback, c7), f = b10.child, e3 = a4.child.memoizedState, f.memoizedState = null === e3 ? { baseLanes: c7 } : { baseLanes: e3.baseLanes | c7 }, f.childLanes = a4.childLanes & ~c7, b10.memoizedState = Od, d3;
      c7 = Td(a4, b10, d3.children, c7);
      b10.memoizedState = null;
      return c7;
    }
    function Qd(a4, b10, c7, d3) {
      var e3 = a4.mode, f = a4.child;
      b10 = { mode: "hidden", children: b10 };
      0 === (e3 & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b10) : f = Rd(b10, e3, 0, null);
      c7 = Ec(c7, e3, d3, null);
      f.return = a4;
      c7.return = a4;
      f.sibling = c7;
      a4.child = f;
      return c7;
    }
    function Td(a4, b10, c7, d3) {
      var e3 = a4.child;
      a4 = e3.sibling;
      c7 = Ac(e3, { mode: "visible", children: c7 });
      0 === (b10.mode & 2) && (c7.lanes = d3);
      c7.return = b10;
      c7.sibling = null;
      null !== a4 && (a4.nextEffect = null, a4.flags = 8, b10.firstEffect = b10.lastEffect = a4);
      return b10.child = c7;
    }
    function Sd(a4, b10, c7, d3, e3) {
      var f = b10.mode, h3 = a4.child;
      a4 = h3.sibling;
      var g2 = { mode: "hidden", children: c7 };
      0 === (f & 2) && b10.child !== h3 ? (c7 = b10.child, c7.childLanes = 0, c7.pendingProps = g2, h3 = c7.lastEffect, null !== h3 ? (b10.firstEffect = c7.firstEffect, b10.lastEffect = h3, h3.nextEffect = null) : b10.firstEffect = b10.lastEffect = null) : c7 = Ac(h3, g2);
      null !== a4 ? d3 = Ac(a4, d3) : (d3 = Ec(d3, f, e3, null), d3.flags |= 2);
      d3.return = b10;
      c7.return = b10;
      c7.sibling = d3;
      b10.child = c7;
      return d3;
    }
    function Ud(a4, b10) {
      a4.lanes |= b10;
      var c7 = a4.alternate;
      null !== c7 && (c7.lanes |= b10);
      bc(a4.return, b10);
    }
    function Vd(a4, b10, c7, d3, e3, f) {
      var h3 = a4.memoizedState;
      null === h3 ? a4.memoizedState = { isBackwards: b10, rendering: null, renderingStartTime: 0, last: d3, tail: c7, tailMode: e3, lastEffect: f } : (h3.isBackwards = b10, h3.rendering = null, h3.renderingStartTime = 0, h3.last = d3, h3.tail = c7, h3.tailMode = e3, h3.lastEffect = f);
    }
    function Wd(a4, b10, c7) {
      var d3 = b10.pendingProps, e3 = d3.revealOrder, f = d3.tail;
      S3(a4, b10, d3.children, c7);
      d3 = L2.current;
      if (0 !== (d3 & 2))
        d3 = d3 & 1 | 2, b10.flags |= 64;
      else {
        if (null !== a4 && 0 !== (a4.flags & 64))
          a:
            for (a4 = b10.child; null !== a4; ) {
              if (13 === a4.tag)
                null !== a4.memoizedState && Ud(a4, c7);
              else if (19 === a4.tag)
                Ud(a4, c7);
              else if (null !== a4.child) {
                a4.child.return = a4;
                a4 = a4.child;
                continue;
              }
              if (a4 === b10)
                break a;
              for (; null === a4.sibling; ) {
                if (null === a4.return || a4.return === b10)
                  break a;
                a4 = a4.return;
              }
              a4.sibling.return = a4.return;
              a4 = a4.sibling;
            }
        d3 &= 1;
      }
      B2(L2, d3);
      if (0 === (b10.mode & 2))
        b10.memoizedState = null;
      else
        switch (e3) {
          case "forwards":
            c7 = b10.child;
            for (e3 = null; null !== c7; )
              a4 = c7.alternate, null !== a4 && null === Rc(a4) && (e3 = c7), c7 = c7.sibling;
            c7 = e3;
            null === c7 ? (e3 = b10.child, b10.child = null) : (e3 = c7.sibling, c7.sibling = null);
            Vd(b10, false, e3, c7, f, b10.lastEffect);
            break;
          case "backwards":
            c7 = null;
            e3 = b10.child;
            for (b10.child = null; null !== e3; ) {
              a4 = e3.alternate;
              if (null !== a4 && null === Rc(a4)) {
                b10.child = e3;
                break;
              }
              a4 = e3.sibling;
              e3.sibling = c7;
              c7 = e3;
              e3 = a4;
            }
            Vd(b10, true, c7, null, f, b10.lastEffect);
            break;
          case "together":
            Vd(b10, false, null, null, void 0, b10.lastEffect);
            break;
          default:
            b10.memoizedState = null;
        }
      return b10.child;
    }
    function Dd(a4, b10, c7) {
      null !== a4 && (b10.dependencies = a4.dependencies);
      kc |= b10.lanes;
      if (0 !== (c7 & b10.childLanes)) {
        if (null !== a4 && b10.child !== a4.child)
          throw Error(q2(153));
        if (null !== b10.child) {
          a4 = b10.child;
          c7 = Ac(a4, a4.pendingProps);
          b10.child = c7;
          for (c7.return = b10; null !== a4.sibling; )
            a4 = a4.sibling, c7 = c7.sibling = Ac(a4, a4.pendingProps), c7.return = b10;
          c7.sibling = null;
        }
        return b10.child;
      }
      return null;
    }
    var Xd, Yd, Zd, $d;
    Xd = function(a4, b10) {
      for (var c7 = b10.child; null !== c7; ) {
        if (5 === c7.tag || 6 === c7.tag) {
          var d3 = a4, e3 = c7.stateNode, f = d3.children.indexOf(e3);
          -1 !== f && d3.children.splice(f, 1);
          d3.children.push(e3);
        } else if (4 !== c7.tag && null !== c7.child) {
          c7.child.return = c7;
          c7 = c7.child;
          continue;
        }
        if (c7 === b10)
          break;
        for (; null === c7.sibling; ) {
          if (null === c7.return || c7.return === b10)
            return;
          c7 = c7.return;
        }
        c7.sibling.return = c7.return;
        c7 = c7.sibling;
      }
    };
    Yd = function() {
    };
    Zd = function(a4, b10, c7, d3) {
      a4.memoizedProps !== d3 && (Lc(Ic.current), b10.updateQueue = Ha) && (b10.flags |= 4);
    };
    $d = function(a4, b10, c7, d3) {
      c7 !== d3 && (b10.flags |= 4);
    };
    function ae(a4, b10) {
      switch (a4.tailMode) {
        case "hidden":
          b10 = a4.tail;
          for (var c7 = null; null !== b10; )
            null !== b10.alternate && (c7 = b10), b10 = b10.sibling;
          null === c7 ? a4.tail = null : c7.sibling = null;
          break;
        case "collapsed":
          c7 = a4.tail;
          for (var d3 = null; null !== c7; )
            null !== c7.alternate && (d3 = c7), c7 = c7.sibling;
          null === d3 ? b10 || null === a4.tail ? a4.tail = null : a4.tail.sibling = null : d3.sibling = null;
      }
    }
    function be(a4, b10, c7) {
      var d3 = b10.pendingProps;
      switch (b10.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return null;
        case 1:
          return E2(b10.type) && Za(), null;
        case 3:
          return Nc(), A(D2), A(C), Tc(), d3 = b10.stateNode, d3.pendingContext && (d3.context = d3.pendingContext, d3.pendingContext = null), null !== a4 && null !== a4.child || d3.hydrate || (b10.flags |= 256), Yd(b10), null;
        case 5:
          Qc(b10);
          var e3 = Lc(Kc.current);
          c7 = b10.type;
          if (null !== a4 && null != b10.stateNode)
            Zd(a4, b10, c7, d3, e3), a4.ref !== b10.ref && (b10.flags |= 128);
          else {
            if (!d3) {
              if (null === b10.stateNode)
                throw Error(q2(166));
              return null;
            }
            Lc(Ic.current);
            a4 = { type: c7, props: d3, isHidden: false, children: [], internalInstanceHandle: b10, rootContainerInstance: e3, tag: "INSTANCE" };
            Xd(a4, b10, false, false);
            b10.stateNode = a4;
            null !== b10.ref && (b10.flags |= 128);
          }
          return null;
        case 6:
          if (a4 && null != b10.stateNode)
            $d(a4, b10, a4.memoizedProps, d3);
          else {
            if ("string" !== typeof d3 && null === b10.stateNode)
              throw Error(q2(166));
            Lc(Kc.current);
            Lc(Ic.current);
            b10.stateNode = { text: d3, isHidden: false, tag: "TEXT" };
          }
          return null;
        case 13:
          A(L2);
          d3 = b10.memoizedState;
          if (0 !== (b10.flags & 64))
            return b10.lanes = c7, b10;
          d3 = null !== d3;
          e3 = false;
          null !== a4 && (e3 = null !== a4.memoizedState);
          if (d3 && !e3 && 0 !== (b10.mode & 2))
            if (null === a4 && true !== b10.memoizedProps.unstable_avoidThisFallback || 0 !== (L2.current & 1))
              0 === T2 && (T2 = 3);
            else {
              if (0 === T2 || 3 === T2)
                T2 = 4;
              null === R2 || 0 === (kc & 134217727) && 0 === (ce & 134217727) || de(R2, U);
            }
          if (d3 || e3)
            b10.flags |= 4;
          return null;
        case 4:
          return Nc(), Yd(b10), null;
        case 10:
          return ac(b10), null;
        case 17:
          return E2(b10.type) && Za(), null;
        case 19:
          A(L2);
          d3 = b10.memoizedState;
          if (null === d3)
            return null;
          e3 = 0 !== (b10.flags & 64);
          var f = d3.rendering;
          if (null === f)
            if (e3)
              ae(d3, false);
            else {
              if (0 !== T2 || null !== a4 && 0 !== (a4.flags & 64))
                for (a4 = b10.child; null !== a4; ) {
                  f = Rc(a4);
                  if (null !== f) {
                    b10.flags |= 64;
                    ae(d3, false);
                    a4 = f.updateQueue;
                    null !== a4 && (b10.updateQueue = a4, b10.flags |= 4);
                    null === d3.lastEffect && (b10.firstEffect = null);
                    b10.lastEffect = d3.lastEffect;
                    a4 = c7;
                    for (d3 = b10.child; null !== d3; )
                      e3 = d3, c7 = a4, e3.flags &= 2, e3.nextEffect = null, e3.firstEffect = null, e3.lastEffect = null, f = e3.alternate, null === f ? (e3.childLanes = 0, e3.lanes = c7, e3.child = null, e3.memoizedProps = null, e3.memoizedState = null, e3.updateQueue = null, e3.dependencies = null, e3.stateNode = null) : (e3.childLanes = f.childLanes, e3.lanes = f.lanes, e3.child = f.child, e3.memoizedProps = f.memoizedProps, e3.memoizedState = f.memoizedState, e3.updateQueue = f.updateQueue, e3.type = f.type, c7 = f.dependencies, e3.dependencies = null === c7 ? null : { lanes: c7.lanes, firstContext: c7.firstContext }), d3 = d3.sibling;
                    B2(L2, L2.current & 1 | 2);
                    return b10.child;
                  }
                  a4 = a4.sibling;
                }
              null !== d3.tail && G2() > ee && (b10.flags |= 64, e3 = true, ae(d3, false), b10.lanes = 33554432);
            }
          else {
            if (!e3)
              if (a4 = Rc(f), null !== a4) {
                if (b10.flags |= 64, e3 = true, a4 = a4.updateQueue, null !== a4 && (b10.updateQueue = a4, b10.flags |= 4), ae(d3, true), null === d3.tail && "hidden" === d3.tailMode && !f.alternate)
                  return b10 = b10.lastEffect = d3.lastEffect, null !== b10 && (b10.nextEffect = null), null;
              } else
                2 * G2() - d3.renderingStartTime > ee && 1073741824 !== c7 && (b10.flags |= 64, e3 = true, ae(d3, false), b10.lanes = 33554432);
            d3.isBackwards ? (f.sibling = b10.child, b10.child = f) : (a4 = d3.last, null !== a4 ? a4.sibling = f : b10.child = f, d3.last = f);
          }
          return null !== d3.tail ? (a4 = d3.tail, d3.rendering = a4, d3.tail = a4.sibling, d3.lastEffect = b10.lastEffect, d3.renderingStartTime = G2(), a4.sibling = null, b10 = L2.current, B2(L2, e3 ? b10 & 1 | 2 : b10 & 1), a4) : null;
        case 23:
        case 24:
          return fe(), null !== a4 && null !== a4.memoizedState !== (null !== b10.memoizedState) && "unstable-defer-without-hiding" !== d3.mode && (b10.flags |= 4), null;
      }
      throw Error(q2(156, b10.tag));
    }
    function ge(a4) {
      switch (a4.tag) {
        case 1:
          E2(a4.type) && Za();
          var b10 = a4.flags;
          return b10 & 4096 ? (a4.flags = b10 & -4097 | 64, a4) : null;
        case 3:
          Nc();
          A(D2);
          A(C);
          Tc();
          b10 = a4.flags;
          if (0 !== (b10 & 64))
            throw Error(q2(285));
          a4.flags = b10 & -4097 | 64;
          return a4;
        case 5:
          return Qc(a4), null;
        case 13:
          return A(L2), b10 = a4.flags, b10 & 4096 ? (a4.flags = b10 & -4097 | 64, a4) : null;
        case 19:
          return A(L2), null;
        case 4:
          return Nc(), null;
        case 10:
          return ac(a4), null;
        case 23:
        case 24:
          return fe(), null;
        default:
          return null;
      }
    }
    function he(a4, b10) {
      try {
        var c7 = "", d3 = b10;
        do
          c7 += Vb(d3), d3 = d3.return;
        while (d3);
        var e3 = c7;
      } catch (f) {
        e3 = "\nError generating stack: " + f.message + "\n" + f.stack;
      }
      return { value: a4, source: b10, stack: e3 };
    }
    function ie(a4, b10) {
      try {
        console.error(b10.value);
      } catch (c7) {
        setTimeout(function() {
          throw c7;
        });
      }
    }
    var je = "function" === typeof WeakMap ? WeakMap : Map;
    function le(a4, b10, c7) {
      c7 = gc(-1, c7);
      c7.tag = 3;
      c7.payload = { element: null };
      var d3 = b10.value;
      c7.callback = function() {
        me || (me = true, ne = d3);
        ie(a4, b10);
      };
      return c7;
    }
    function oe(a4, b10, c7) {
      c7 = gc(-1, c7);
      c7.tag = 3;
      var d3 = a4.type.getDerivedStateFromError;
      if ("function" === typeof d3) {
        var e3 = b10.value;
        c7.payload = function() {
          ie(a4, b10);
          return d3(e3);
        };
      }
      var f = a4.stateNode;
      null !== f && "function" === typeof f.componentDidCatch && (c7.callback = function() {
        "function" !== typeof d3 && (null === pe ? pe = /* @__PURE__ */ new Set([this]) : pe.add(this), ie(a4, b10));
        var c8 = b10.stack;
        this.componentDidCatch(b10.value, { componentStack: null !== c8 ? c8 : "" });
      });
      return c7;
    }
    var qe = "function" === typeof WeakSet ? WeakSet : Set;
    function re2(a4) {
      var b10 = a4.ref;
      if (null !== b10)
        if ("function" === typeof b10)
          try {
            b10(null);
          } catch (c7) {
            se(a4, c7);
          }
        else
          b10.current = null;
    }
    function te(a4, b10) {
      switch (b10.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          return;
        case 1:
          if (b10.flags & 256 && null !== a4) {
            var c7 = a4.memoizedProps, d3 = a4.memoizedState;
            a4 = b10.stateNode;
            b10 = a4.getSnapshotBeforeUpdate(b10.elementType === b10.type ? c7 : I2(b10.type, c7), d3);
            a4.__reactInternalSnapshotBeforeUpdate = b10;
          }
          return;
        case 3:
          b10.flags & 256 && b10.stateNode.containerInfo.children.splice(0);
          return;
        case 5:
        case 6:
        case 4:
        case 17:
          return;
      }
      throw Error(q2(163));
    }
    function ue(a4, b10, c7) {
      switch (c7.tag) {
        case 0:
        case 11:
        case 15:
        case 22:
          b10 = c7.updateQueue;
          b10 = null !== b10 ? b10.lastEffect : null;
          if (null !== b10) {
            a4 = b10 = b10.next;
            do {
              if (3 === (a4.tag & 3)) {
                var d3 = a4.create;
                a4.destroy = d3();
              }
              a4 = a4.next;
            } while (a4 !== b10);
          }
          b10 = c7.updateQueue;
          b10 = null !== b10 ? b10.lastEffect : null;
          if (null !== b10) {
            a4 = b10 = b10.next;
            do {
              var e3 = a4;
              d3 = e3.next;
              e3 = e3.tag;
              0 !== (e3 & 4) && 0 !== (e3 & 1) && (ve(c7, a4), we(c7, a4));
              a4 = d3;
            } while (a4 !== b10);
          }
          return;
        case 1:
          a4 = c7.stateNode;
          c7.flags & 4 && (null === b10 ? a4.componentDidMount() : (d3 = c7.elementType === c7.type ? b10.memoizedProps : I2(c7.type, b10.memoizedProps), a4.componentDidUpdate(
            d3,
            b10.memoizedState,
            a4.__reactInternalSnapshotBeforeUpdate
          )));
          b10 = c7.updateQueue;
          null !== b10 && lc(c7, b10, a4);
          return;
        case 3:
          b10 = c7.updateQueue;
          if (null !== b10) {
            a4 = null;
            if (null !== c7.child)
              switch (c7.child.tag) {
                case 5:
                  a4 = Ja(c7.child.stateNode);
                  break;
                case 1:
                  a4 = c7.child.stateNode;
              }
            lc(c7, b10, a4);
          }
          return;
        case 5:
          return;
        case 6:
          return;
        case 4:
          return;
        case 12:
          return;
        case 13:
          return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
          return;
      }
      throw Error(q2(163));
    }
    function xe(a4, b10) {
      for (var c7 = a4; ; ) {
        if (5 === c7.tag) {
          var d3 = c7.stateNode;
          b10 ? d3.isHidden = true : c7.stateNode.isHidden = false;
        } else if (6 === c7.tag)
          c7.stateNode.isHidden = b10 ? true : false;
        else if ((23 !== c7.tag && 24 !== c7.tag || null === c7.memoizedState || c7 === a4) && null !== c7.child) {
          c7.child.return = c7;
          c7 = c7.child;
          continue;
        }
        if (c7 === a4)
          break;
        for (; null === c7.sibling; ) {
          if (null === c7.return || c7.return === a4)
            return;
          c7 = c7.return;
        }
        c7.sibling.return = c7.return;
        c7 = c7.sibling;
      }
    }
    function ye(a4, b10) {
      if (eb && "function" === typeof eb.onCommitFiberUnmount)
        try {
          eb.onCommitFiberUnmount(db, b10);
        } catch (f) {
        }
      switch (b10.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          a4 = b10.updateQueue;
          if (null !== a4 && (a4 = a4.lastEffect, null !== a4)) {
            var c7 = a4 = a4.next;
            do {
              var d3 = c7, e3 = d3.destroy;
              d3 = d3.tag;
              if (void 0 !== e3)
                if (0 !== (d3 & 4))
                  ve(b10, c7);
                else {
                  d3 = b10;
                  try {
                    e3();
                  } catch (f) {
                    se(d3, f);
                  }
                }
              c7 = c7.next;
            } while (c7 !== a4);
          }
          break;
        case 1:
          re2(b10);
          a4 = b10.stateNode;
          if ("function" === typeof a4.componentWillUnmount)
            try {
              a4.props = b10.memoizedProps, a4.state = b10.memoizedState, a4.componentWillUnmount();
            } catch (f) {
              se(
                b10,
                f
              );
            }
          break;
        case 5:
          re2(b10);
          break;
        case 4:
          ze(a4, b10);
      }
    }
    function Ae(a4) {
      a4.alternate = null;
      a4.child = null;
      a4.dependencies = null;
      a4.firstEffect = null;
      a4.lastEffect = null;
      a4.memoizedProps = null;
      a4.memoizedState = null;
      a4.pendingProps = null;
      a4.return = null;
      a4.updateQueue = null;
    }
    function Be(a4) {
      return 5 === a4.tag || 3 === a4.tag || 4 === a4.tag;
    }
    function Ce(a4) {
      a: {
        for (var b10 = a4.return; null !== b10; ) {
          if (Be(b10))
            break a;
          b10 = b10.return;
        }
        throw Error(q2(160));
      }
      var c7 = b10;
      b10 = c7.stateNode;
      switch (c7.tag) {
        case 5:
          var d3 = false;
          break;
        case 3:
          b10 = b10.containerInfo;
          d3 = true;
          break;
        case 4:
          b10 = b10.containerInfo;
          d3 = true;
          break;
        default:
          throw Error(q2(161));
      }
      c7.flags & 16 && (c7.flags &= -17);
      a:
        b:
          for (c7 = a4; ; ) {
            for (; null === c7.sibling; ) {
              if (null === c7.return || Be(c7.return)) {
                c7 = null;
                break a;
              }
              c7 = c7.return;
            }
            c7.sibling.return = c7.return;
            for (c7 = c7.sibling; 5 !== c7.tag && 6 !== c7.tag && 18 !== c7.tag; ) {
              if (c7.flags & 2)
                continue b;
              if (null === c7.child || 4 === c7.tag)
                continue b;
              else
                c7.child.return = c7, c7 = c7.child;
            }
            if (!(c7.flags & 2)) {
              c7 = c7.stateNode;
              break a;
            }
          }
      d3 ? De(a4, c7, b10) : Ee(a4, c7, b10);
    }
    function De(a4, b10, c7) {
      var d3 = a4.tag, e3 = 5 === d3 || 6 === d3;
      if (e3)
        a4 = e3 ? a4.stateNode : a4.stateNode.instance, b10 ? La(c7, a4, b10) : Ka(c7, a4);
      else if (4 !== d3 && (a4 = a4.child, null !== a4))
        for (De(a4, b10, c7), a4 = a4.sibling; null !== a4; )
          De(a4, b10, c7), a4 = a4.sibling;
    }
    function Ee(a4, b10, c7) {
      var d3 = a4.tag, e3 = 5 === d3 || 6 === d3;
      if (e3)
        a4 = e3 ? a4.stateNode : a4.stateNode.instance, b10 ? La(c7, a4, b10) : Ka(c7, a4);
      else if (4 !== d3 && (a4 = a4.child, null !== a4))
        for (Ee(a4, b10, c7), a4 = a4.sibling; null !== a4; )
          Ee(a4, b10, c7), a4 = a4.sibling;
    }
    function ze(a4, b10) {
      for (var c7 = b10, d3 = false, e3; ; ) {
        if (!d3) {
          d3 = c7.return;
          a:
            for (; ; ) {
              if (null === d3)
                throw Error(q2(160));
              e3 = d3.stateNode;
              switch (d3.tag) {
                case 5:
                  break a;
                case 3:
                  e3 = e3.containerInfo;
                  break a;
                case 4:
                  e3 = e3.containerInfo;
                  break a;
              }
              d3 = d3.return;
            }
          d3 = true;
        }
        if (5 === c7.tag || 6 === c7.tag) {
          a:
            for (var f = a4, h3 = c7, g2 = h3; ; )
              if (ye(f, g2), null !== g2.child && 4 !== g2.tag)
                g2.child.return = g2, g2 = g2.child;
              else {
                if (g2 === h3)
                  break a;
                for (; null === g2.sibling; ) {
                  if (null === g2.return || g2.return === h3)
                    break a;
                  g2 = g2.return;
                }
                g2.sibling.return = g2.return;
                g2 = g2.sibling;
              }
          f = e3;
          h3 = f.children.indexOf(c7.stateNode);
          f.children.splice(h3, 1);
        } else if (4 === c7.tag) {
          if (null !== c7.child) {
            e3 = c7.stateNode.containerInfo;
            c7.child.return = c7;
            c7 = c7.child;
            continue;
          }
        } else if (ye(a4, c7), null !== c7.child) {
          c7.child.return = c7;
          c7 = c7.child;
          continue;
        }
        if (c7 === b10)
          break;
        for (; null === c7.sibling; ) {
          if (null === c7.return || c7.return === b10)
            return;
          c7 = c7.return;
          4 === c7.tag && (d3 = false);
        }
        c7.sibling.return = c7.return;
        c7 = c7.sibling;
      }
    }
    function Fe(a4, b10) {
      switch (b10.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
          b10 = b10.updateQueue;
          b10 = null !== b10 ? b10.lastEffect : null;
          if (null !== b10) {
            a4 = b10 = b10.next;
            do {
              if (3 === (a4.tag & 3)) {
                var c7 = a4.destroy;
                a4.destroy = void 0;
                void 0 !== c7 && c7();
              }
              a4 = a4.next;
            } while (a4 !== b10);
          }
          return;
        case 1:
          return;
        case 5:
          a4 = b10.stateNode;
          if (null != a4) {
            c7 = b10.memoizedProps;
            var d3 = b10.type, e3 = b10.updateQueue;
            b10.updateQueue = null;
            null !== e3 && (a4.type = d3, a4.props = c7);
          }
          return;
        case 6:
          if (null === b10.stateNode)
            throw Error(q2(162));
          b10.stateNode.text = b10.memoizedProps;
          return;
        case 3:
          return;
        case 12:
          return;
        case 13:
          null !== b10.memoizedState && (Ge = G2(), xe(b10.child, true));
          He(b10);
          return;
        case 19:
          He(b10);
          return;
        case 17:
          return;
        case 23:
        case 24:
          xe(b10, null !== b10.memoizedState);
          return;
      }
      throw Error(q2(163));
    }
    function He(a4) {
      var b10 = a4.updateQueue;
      if (null !== b10) {
        a4.updateQueue = null;
        var c7 = a4.stateNode;
        null === c7 && (c7 = a4.stateNode = new qe());
        b10.forEach(function(b11) {
          var d3 = Ie.bind(null, a4, b11);
          c7.has(b11) || (c7.add(b11), b11.then(d3, d3));
        });
      }
    }
    function Je(a4, b10) {
      return null !== a4 && (a4 = a4.memoizedState, null === a4 || null !== a4.dehydrated) ? (b10 = b10.memoizedState, null !== b10 && null === b10.dehydrated) : false;
    }
    var Ke = null;
    function Le(a4) {
      if (null === Ke)
        try {
          var b10 = ("require" + Math.random()).slice(0, 7);
          Ke = (module2 && module2[b10]).call(module2, "timers").setImmediate;
        } catch (c7) {
          Ke = function(a5) {
            var b11 = new MessageChannel();
            b11.port1.onmessage = a5;
            b11.port2.postMessage(void 0);
          };
        }
      return Ke(a4);
    }
    var Me = Math.ceil, Ne = fa.ReactCurrentDispatcher, Oe = fa.ReactCurrentOwner, Pe = fa.IsSomeRendererActing, W = 0, R2 = null, X2 = null, U = 0, Qe = 0, Re = Va(0), T2 = 0, Se = null, Te = 0, kc = 0, ce = 0, Ue = 0, Ve = null, Ge = 0, ee = Infinity, Y2 = null, me = false, ne = null, pe = null, We = false, Xe = null, Ye = 90, Ze = [], $e = [], af = null, bf = 0, cf = null, df = -1, ef = 0, ff = 0, gf = null, hf = false;
    function oc() {
      return 0 !== (W & 48) ? G2() : -1 !== df ? df : df = G2();
    }
    function pc(a4) {
      a4 = a4.mode;
      if (0 === (a4 & 2))
        return 1;
      if (0 === (a4 & 4))
        return 99 === Lb() ? 1 : 2;
      0 === ef && (ef = Te);
      if (0 !== Rb.transition) {
        0 !== ff && (ff = null !== Ve ? Ve.pendingLanes : 0);
        a4 = ef;
        var b10 = 4186112 & ~ff;
        b10 &= -b10;
        0 === b10 && (a4 = 4186112 & ~a4, b10 = a4 & -a4, 0 === b10 && (b10 = 8192));
        return b10;
      }
      a4 = Lb();
      0 !== (W & 4) && 98 === a4 ? a4 = mb(12, ef) : (a4 = hb(a4), a4 = mb(a4, ef));
      return a4;
    }
    function qc(a4, b10, c7) {
      if (50 < bf)
        throw bf = 0, cf = null, Error(q2(185));
      a4 = jf(a4, b10);
      if (null === a4)
        return null;
      pb(a4, b10, c7);
      a4 === R2 && (ce |= b10, 4 === T2 && de(a4, U));
      var d3 = Lb();
      1 === b10 ? 0 !== (W & 8) && 0 === (W & 48) ? kf(a4) : (Z(a4, c7), 0 === W && (ee = G2() + 500, Pb())) : (0 === (W & 4) || 98 !== d3 && 99 !== d3 || (null === af ? af = /* @__PURE__ */ new Set([a4]) : af.add(a4)), Z(a4, c7));
      Ve = a4;
    }
    function jf(a4, b10) {
      a4.lanes |= b10;
      var c7 = a4.alternate;
      null !== c7 && (c7.lanes |= b10);
      c7 = a4;
      for (a4 = a4.return; null !== a4; )
        a4.childLanes |= b10, c7 = a4.alternate, null !== c7 && (c7.childLanes |= b10), c7 = a4, a4 = a4.return;
      return 3 === c7.tag ? c7.stateNode : null;
    }
    function Z(a4, b10) {
      for (var c7 = a4.callbackNode, d3 = a4.suspendedLanes, e3 = a4.pingedLanes, f = a4.expirationTimes, h3 = a4.pendingLanes; 0 < h3; ) {
        var g2 = 31 - kb(h3), k3 = 1 << g2, l = f[g2];
        if (-1 === l) {
          if (0 === (k3 & d3) || 0 !== (k3 & e3)) {
            l = b10;
            gb(k3);
            var p = F;
            f[g2] = 10 <= p ? l + 250 : 6 <= p ? l + 5e3 : -1;
          }
        } else
          l <= b10 && (a4.expiredLanes |= k3);
        h3 &= ~k3;
      }
      d3 = jb(a4, a4 === R2 ? U : 0);
      b10 = F;
      if (0 === d3)
        null !== c7 && (c7 !== Fb && vb(c7), a4.callbackNode = null, a4.callbackPriority = 0);
      else {
        if (null !== c7) {
          if (a4.callbackPriority === b10)
            return;
          c7 !== Fb && vb(c7);
        }
        15 === b10 ? (c7 = kf.bind(null, a4), null === Hb ? (Hb = [c7], Ib = ub(Ab, Qb)) : Hb.push(c7), c7 = Fb) : 14 === b10 ? c7 = Ob(99, kf.bind(null, a4)) : (c7 = ib(b10), c7 = Ob(c7, lf.bind(null, a4)));
        a4.callbackPriority = b10;
        a4.callbackNode = c7;
      }
    }
    function lf(a4) {
      df = -1;
      ff = ef = 0;
      if (0 !== (W & 48))
        throw Error(q2(327));
      var b10 = a4.callbackNode;
      if (mf() && a4.callbackNode !== b10)
        return null;
      var c7 = jb(a4, a4 === R2 ? U : 0);
      if (0 === c7)
        return null;
      var d3 = c7;
      var e3 = W;
      W |= 16;
      var f = nf();
      if (R2 !== a4 || U !== d3)
        ee = G2() + 500, of(a4, d3);
      do
        try {
          pf();
          break;
        } catch (g2) {
          qf(a4, g2);
        }
      while (1);
      $b();
      Ne.current = f;
      W = e3;
      null !== X2 ? d3 = 0 : (R2 = null, U = 0, d3 = T2);
      if (0 !== (Te & ce))
        of(a4, 0);
      else if (0 !== d3) {
        2 === d3 && (W |= 64, a4.hydrate && (a4.hydrate = false, a4.containerInfo.children.splice(0)), c7 = lb(a4), 0 !== c7 && (d3 = rf(a4, c7)));
        if (1 === d3)
          throw b10 = Se, of(a4, 0), de(
            a4,
            c7
          ), Z(a4, G2()), b10;
        a4.finishedWork = a4.current.alternate;
        a4.finishedLanes = c7;
        switch (d3) {
          case 0:
          case 1:
            throw Error(q2(345));
          case 2:
            sf(a4);
            break;
          case 3:
            de(a4, c7);
            if ((c7 & 62914560) === c7 && (d3 = Ge + 500 - G2(), 10 < d3)) {
              if (0 !== jb(a4, 0))
                break;
              e3 = a4.suspendedLanes;
              if ((e3 & c7) !== c7) {
                oc();
                a4.pingedLanes |= a4.suspendedLanes & e3;
                break;
              }
              a4.timeoutHandle = Ma(sf.bind(null, a4), d3);
              break;
            }
            sf(a4);
            break;
          case 4:
            de(a4, c7);
            if ((c7 & 4186112) === c7)
              break;
            d3 = a4.eventTimes;
            for (e3 = -1; 0 < c7; ) {
              var h3 = 31 - kb(c7);
              f = 1 << h3;
              h3 = d3[h3];
              h3 > e3 && (e3 = h3);
              c7 &= ~f;
            }
            c7 = e3;
            c7 = G2() - c7;
            c7 = (120 > c7 ? 120 : 480 > c7 ? 480 : 1080 > c7 ? 1080 : 1920 > c7 ? 1920 : 3e3 > c7 ? 3e3 : 4320 > c7 ? 4320 : 1960 * Me(c7 / 1960)) - c7;
            if (10 < c7) {
              a4.timeoutHandle = Ma(sf.bind(null, a4), c7);
              break;
            }
            sf(a4);
            break;
          case 5:
            sf(a4);
            break;
          default:
            throw Error(q2(329));
        }
      }
      Z(a4, G2());
      return a4.callbackNode === b10 ? lf.bind(null, a4) : null;
    }
    function de(a4, b10) {
      b10 &= ~Ue;
      b10 &= ~ce;
      a4.suspendedLanes |= b10;
      a4.pingedLanes &= ~b10;
      for (a4 = a4.expirationTimes; 0 < b10; ) {
        var c7 = 31 - kb(b10), d3 = 1 << c7;
        a4[c7] = -1;
        b10 &= ~d3;
      }
    }
    function kf(a4) {
      if (0 !== (W & 48))
        throw Error(q2(327));
      mf();
      if (a4 === R2 && 0 !== (a4.expiredLanes & U)) {
        var b10 = U;
        var c7 = rf(a4, b10);
        0 !== (Te & ce) && (b10 = jb(a4, b10), c7 = rf(a4, b10));
      } else
        b10 = jb(a4, 0), c7 = rf(a4, b10);
      0 !== a4.tag && 2 === c7 && (W |= 64, a4.hydrate && (a4.hydrate = false, a4.containerInfo.children.splice(0)), b10 = lb(a4), 0 !== b10 && (c7 = rf(a4, b10)));
      if (1 === c7)
        throw c7 = Se, of(a4, 0), de(a4, b10), Z(a4, G2()), c7;
      a4.finishedWork = a4.current.alternate;
      a4.finishedLanes = b10;
      sf(a4);
      Z(a4, G2());
      return null;
    }
    function tf(a4, b10) {
      var c7 = W;
      W |= 1;
      try {
        return a4(b10);
      } finally {
        W = c7, 0 === W && (ee = G2() + 500, Pb());
      }
    }
    function Jd(a4, b10) {
      B2(Re, Qe);
      Qe |= b10;
      Te |= b10;
    }
    function fe() {
      Qe = Re.current;
      A(Re);
    }
    function of(a4, b10) {
      a4.finishedWork = null;
      a4.finishedLanes = 0;
      var c7 = a4.timeoutHandle;
      -1 !== c7 && (a4.timeoutHandle = -1, Na(c7));
      if (null !== X2)
        for (c7 = X2.return; null !== c7; ) {
          var d3 = c7;
          switch (d3.tag) {
            case 1:
              d3 = d3.type.childContextTypes;
              null !== d3 && void 0 !== d3 && Za();
              break;
            case 3:
              Nc();
              A(D2);
              A(C);
              Tc();
              break;
            case 5:
              Qc(d3);
              break;
            case 4:
              Nc();
              break;
            case 13:
              A(L2);
              break;
            case 19:
              A(L2);
              break;
            case 10:
              ac(d3);
              break;
            case 23:
            case 24:
              fe();
          }
          c7 = c7.return;
        }
      R2 = a4;
      X2 = Ac(a4.current, null);
      U = Qe = Te = b10;
      T2 = 0;
      Se = null;
      Ue = ce = kc = 0;
    }
    function qf(a4, b10) {
      do {
        var c7 = X2;
        try {
          $b();
          Uc.current = cd;
          if (Wc) {
            for (var d3 = N.memoizedState; null !== d3; ) {
              var e3 = d3.queue;
              null !== e3 && (e3.pending = null);
              d3 = d3.next;
            }
            Wc = false;
          }
          Vc = 0;
          P = O2 = N = null;
          Xc = false;
          Oe.current = null;
          if (null === c7 || null === c7.return) {
            T2 = 1;
            Se = b10;
            X2 = null;
            break;
          }
          a: {
            var f = a4, h3 = c7.return, g2 = c7, k3 = b10;
            b10 = U;
            g2.flags |= 2048;
            g2.firstEffect = g2.lastEffect = null;
            if (null !== k3 && "object" === typeof k3 && "function" === typeof k3.then) {
              var l = k3;
              if (0 === (g2.mode & 2)) {
                var p = g2.alternate;
                p ? (g2.updateQueue = p.updateQueue, g2.memoizedState = p.memoizedState, g2.lanes = p.lanes) : (g2.updateQueue = null, g2.memoizedState = null);
              }
              var r = 0 !== (L2.current & 1), m3 = h3;
              do {
                var z2;
                if (z2 = 13 === m3.tag) {
                  var x3 = m3.memoizedState;
                  if (null !== x3)
                    z2 = null !== x3.dehydrated ? true : false;
                  else {
                    var V2 = m3.memoizedProps;
                    z2 = void 0 === V2.fallback ? false : true !== V2.unstable_avoidThisFallback ? true : r ? false : true;
                  }
                }
                if (z2) {
                  var t2 = m3.updateQueue;
                  if (null === t2) {
                    var u2 = /* @__PURE__ */ new Set();
                    u2.add(l);
                    m3.updateQueue = u2;
                  } else
                    t2.add(l);
                  if (0 === (m3.mode & 2)) {
                    m3.flags |= 64;
                    g2.flags |= 16384;
                    g2.flags &= -2981;
                    if (1 === g2.tag)
                      if (null === g2.alternate)
                        g2.tag = 17;
                      else {
                        var y4 = gc(-1, 1);
                        y4.tag = 2;
                        hc(g2, y4);
                      }
                    g2.lanes |= 1;
                    break a;
                  }
                  k3 = void 0;
                  g2 = b10;
                  var Aa = f.pingCache;
                  null === Aa ? (Aa = f.pingCache = new je(), k3 = /* @__PURE__ */ new Set(), Aa.set(l, k3)) : (k3 = Aa.get(l), void 0 === k3 && (k3 = /* @__PURE__ */ new Set(), Aa.set(l, k3)));
                  if (!k3.has(g2)) {
                    k3.add(g2);
                    var ke = uf.bind(null, f, l, g2);
                    l.then(ke, ke);
                  }
                  m3.flags |= 4096;
                  m3.lanes = b10;
                  break a;
                }
                m3 = m3.return;
              } while (null !== m3);
              k3 = Error((za(g2.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
            }
            5 !== T2 && (T2 = 2);
            k3 = he(k3, g2);
            m3 = h3;
            do {
              switch (m3.tag) {
                case 3:
                  f = k3;
                  m3.flags |= 4096;
                  b10 &= -b10;
                  m3.lanes |= b10;
                  var Ef = le(m3, f, b10);
                  ic(m3, Ef);
                  break a;
                case 1:
                  f = k3;
                  var Ff = m3.type, Pc = m3.stateNode;
                  if (0 === (m3.flags & 64) && ("function" === typeof Ff.getDerivedStateFromError || null !== Pc && "function" === typeof Pc.componentDidCatch && (null === pe || !pe.has(Pc)))) {
                    m3.flags |= 4096;
                    b10 &= -b10;
                    m3.lanes |= b10;
                    var Gf = oe(m3, f, b10);
                    ic(m3, Gf);
                    break a;
                  }
              }
              m3 = m3.return;
            } while (null !== m3);
          }
          vf(c7);
        } catch (v) {
          b10 = v;
          X2 === c7 && null !== c7 && (X2 = c7 = c7.return);
          continue;
        }
        break;
      } while (1);
    }
    function nf() {
      var a4 = Ne.current;
      Ne.current = cd;
      return null === a4 ? cd : a4;
    }
    function rf(a4, b10) {
      var c7 = W;
      W |= 16;
      var d3 = nf();
      R2 === a4 && U === b10 || of(a4, b10);
      do
        try {
          wf();
          break;
        } catch (e3) {
          qf(a4, e3);
        }
      while (1);
      $b();
      W = c7;
      Ne.current = d3;
      if (null !== X2)
        throw Error(q2(261));
      R2 = null;
      U = 0;
      return T2;
    }
    function wf() {
      for (; null !== X2; )
        xf(X2);
    }
    function pf() {
      for (; null !== X2 && !wb(); )
        xf(X2);
    }
    function xf(a4) {
      var b10 = yf(a4.alternate, a4, Qe);
      a4.memoizedProps = a4.pendingProps;
      null === b10 ? vf(a4) : X2 = b10;
      Oe.current = null;
    }
    function vf(a4) {
      var b10 = a4;
      do {
        var c7 = b10.alternate;
        a4 = b10.return;
        if (0 === (b10.flags & 2048)) {
          c7 = be(c7, b10, Qe);
          if (null !== c7) {
            X2 = c7;
            return;
          }
          c7 = b10;
          if (24 !== c7.tag && 23 !== c7.tag || null === c7.memoizedState || 0 !== (Qe & 1073741824) || 0 === (c7.mode & 4)) {
            for (var d3 = 0, e3 = c7.child; null !== e3; )
              d3 |= e3.lanes | e3.childLanes, e3 = e3.sibling;
            c7.childLanes = d3;
          }
          null !== a4 && 0 === (a4.flags & 2048) && (null === a4.firstEffect && (a4.firstEffect = b10.firstEffect), null !== b10.lastEffect && (null !== a4.lastEffect && (a4.lastEffect.nextEffect = b10.firstEffect), a4.lastEffect = b10.lastEffect), 1 < b10.flags && (null !== a4.lastEffect ? a4.lastEffect.nextEffect = b10 : a4.firstEffect = b10, a4.lastEffect = b10));
        } else {
          c7 = ge(b10);
          if (null !== c7) {
            c7.flags &= 2047;
            X2 = c7;
            return;
          }
          null !== a4 && (a4.firstEffect = a4.lastEffect = null, a4.flags |= 2048);
        }
        b10 = b10.sibling;
        if (null !== b10) {
          X2 = b10;
          return;
        }
        X2 = b10 = a4;
      } while (null !== b10);
      0 === T2 && (T2 = 5);
    }
    function sf(a4) {
      var b10 = Lb();
      Nb(99, zf.bind(null, a4, b10));
      return null;
    }
    function zf(a4, b10) {
      do
        mf();
      while (null !== Xe);
      if (0 !== (W & 48))
        throw Error(q2(327));
      var c7 = a4.finishedWork;
      if (null === c7)
        return null;
      a4.finishedWork = null;
      a4.finishedLanes = 0;
      if (c7 === a4.current)
        throw Error(q2(177));
      a4.callbackNode = null;
      var d3 = c7.lanes | c7.childLanes, e3 = d3, f = a4.pendingLanes & ~e3;
      a4.pendingLanes = e3;
      a4.suspendedLanes = 0;
      a4.pingedLanes = 0;
      a4.expiredLanes &= e3;
      a4.mutableReadLanes &= e3;
      a4.entangledLanes &= e3;
      e3 = a4.entanglements;
      for (var h3 = a4.eventTimes, g2 = a4.expirationTimes; 0 < f; ) {
        var k3 = 31 - kb(f), l = 1 << k3;
        e3[k3] = 0;
        h3[k3] = -1;
        g2[k3] = -1;
        f &= ~l;
      }
      null !== af && 0 === (d3 & 24) && af.has(a4) && af.delete(a4);
      a4 === R2 && (X2 = R2 = null, U = 0);
      1 < c7.flags ? null !== c7.lastEffect ? (c7.lastEffect.nextEffect = c7, d3 = c7.firstEffect) : d3 = c7 : d3 = c7.firstEffect;
      if (null !== d3) {
        e3 = W;
        W |= 32;
        gf = Oe.current = null;
        hf = false;
        Y2 = d3;
        do
          try {
            Af();
          } catch (u2) {
            if (null === Y2)
              throw Error(q2(330));
            se(Y2, u2);
            Y2 = Y2.nextEffect;
          }
        while (null !== Y2);
        gf = null;
        Y2 = d3;
        do
          try {
            for (h3 = a4; null !== Y2; ) {
              var p = Y2.flags;
              if (p & 128) {
                var r = Y2.alternate;
                if (null !== r) {
                  var m3 = r.ref;
                  null !== m3 && ("function" === typeof m3 ? m3(null) : m3.current = null);
                }
              }
              switch (p & 1038) {
                case 2:
                  Ce(Y2);
                  Y2.flags &= -3;
                  break;
                case 6:
                  Ce(Y2);
                  Y2.flags &= -3;
                  Fe(Y2.alternate, Y2);
                  break;
                case 1024:
                  Y2.flags &= -1025;
                  break;
                case 1028:
                  Y2.flags &= -1025;
                  Fe(Y2.alternate, Y2);
                  break;
                case 4:
                  Fe(Y2.alternate, Y2);
                  break;
                case 8:
                  g2 = Y2;
                  ze(h3, g2);
                  var z2 = g2.alternate;
                  Ae(g2);
                  null !== z2 && Ae(z2);
              }
              Y2 = Y2.nextEffect;
            }
          } catch (u2) {
            if (null === Y2)
              throw Error(q2(330));
            se(Y2, u2);
            Y2 = Y2.nextEffect;
          }
        while (null !== Y2);
        a4.current = c7;
        Y2 = d3;
        do
          try {
            for (p = a4; null !== Y2; ) {
              var x3 = Y2.flags;
              x3 & 36 && ue(p, Y2.alternate, Y2);
              if (x3 & 128) {
                r = void 0;
                var V2 = Y2.ref;
                if (null !== V2) {
                  var t2 = Y2.stateNode;
                  switch (Y2.tag) {
                    case 5:
                      r = Ja(t2);
                      break;
                    default:
                      r = t2;
                  }
                  "function" === typeof V2 ? V2(r) : V2.current = r;
                }
              }
              Y2 = Y2.nextEffect;
            }
          } catch (u2) {
            if (null === Y2)
              throw Error(q2(330));
            se(Y2, u2);
            Y2 = Y2.nextEffect;
          }
        while (null !== Y2);
        Y2 = null;
        Gb();
        W = e3;
      } else
        a4.current = c7;
      if (We)
        We = false, Xe = a4, Ye = b10;
      else
        for (Y2 = d3; null !== Y2; )
          b10 = Y2.nextEffect, Y2.nextEffect = null, Y2.flags & 8 && (x3 = Y2, x3.sibling = null, x3.stateNode = null), Y2 = b10;
      d3 = a4.pendingLanes;
      0 === d3 && (pe = null);
      1 === d3 ? a4 === cf ? bf++ : (bf = 0, cf = a4) : bf = 0;
      c7 = c7.stateNode;
      if (eb && "function" === typeof eb.onCommitFiberRoot)
        try {
          eb.onCommitFiberRoot(db, c7, void 0, 64 === (c7.current.flags & 64));
        } catch (u2) {
        }
      Z(
        a4,
        G2()
      );
      if (me)
        throw me = false, a4 = ne, ne = null, a4;
      if (0 !== (W & 8))
        return null;
      Pb();
      return null;
    }
    function Af() {
      for (; null !== Y2; ) {
        var a4 = Y2.alternate;
        hf || null === gf || (0 !== (Y2.flags & 8) ? Fa(Y2, gf) && (hf = true) : 13 === Y2.tag && Je(a4, Y2) && Fa(Y2, gf) && (hf = true));
        var b10 = Y2.flags;
        0 !== (b10 & 256) && te(a4, Y2);
        0 === (b10 & 512) || We || (We = true, Ob(97, function() {
          mf();
          return null;
        }));
        Y2 = Y2.nextEffect;
      }
    }
    function mf() {
      if (90 !== Ye) {
        var a4 = 97 < Ye ? 97 : Ye;
        Ye = 90;
        return Nb(a4, Bf);
      }
      return false;
    }
    function we(a4, b10) {
      Ze.push(b10, a4);
      We || (We = true, Ob(97, function() {
        mf();
        return null;
      }));
    }
    function ve(a4, b10) {
      $e.push(b10, a4);
      We || (We = true, Ob(97, function() {
        mf();
        return null;
      }));
    }
    function Bf() {
      if (null === Xe)
        return false;
      var a4 = Xe;
      Xe = null;
      if (0 !== (W & 48))
        throw Error(q2(331));
      var b10 = W;
      W |= 32;
      var c7 = $e;
      $e = [];
      for (var d3 = 0; d3 < c7.length; d3 += 2) {
        var e3 = c7[d3], f = c7[d3 + 1], h3 = e3.destroy;
        e3.destroy = void 0;
        if ("function" === typeof h3)
          try {
            h3();
          } catch (k3) {
            if (null === f)
              throw Error(q2(330));
            se(f, k3);
          }
      }
      c7 = Ze;
      Ze = [];
      for (d3 = 0; d3 < c7.length; d3 += 2) {
        e3 = c7[d3];
        f = c7[d3 + 1];
        try {
          var g2 = e3.create;
          e3.destroy = g2();
        } catch (k3) {
          if (null === f)
            throw Error(q2(330));
          se(f, k3);
        }
      }
      for (g2 = a4.current.firstEffect; null !== g2; )
        a4 = g2.nextEffect, g2.nextEffect = null, g2.flags & 8 && (g2.sibling = null, g2.stateNode = null), g2 = a4;
      W = b10;
      Pb();
      return true;
    }
    function Cf(a4, b10, c7) {
      b10 = he(c7, b10);
      b10 = le(a4, b10, 1);
      hc(a4, b10);
      b10 = oc();
      a4 = jf(a4, 1);
      null !== a4 && (pb(a4, 1, b10), Z(a4, b10));
    }
    function se(a4, b10) {
      if (3 === a4.tag)
        Cf(a4, a4, b10);
      else
        for (var c7 = a4.return; null !== c7; ) {
          if (3 === c7.tag) {
            Cf(c7, a4, b10);
            break;
          } else if (1 === c7.tag) {
            var d3 = c7.stateNode;
            if ("function" === typeof c7.type.getDerivedStateFromError || "function" === typeof d3.componentDidCatch && (null === pe || !pe.has(d3))) {
              a4 = he(b10, a4);
              var e3 = oe(c7, a4, 1);
              hc(c7, e3);
              e3 = oc();
              c7 = jf(c7, 1);
              if (null !== c7)
                pb(c7, 1, e3), Z(c7, e3);
              else if ("function" === typeof d3.componentDidCatch && (null === pe || !pe.has(d3)))
                try {
                  d3.componentDidCatch(b10, a4);
                } catch (f) {
                }
              break;
            }
          }
          c7 = c7.return;
        }
    }
    function uf(a4, b10, c7) {
      var d3 = a4.pingCache;
      null !== d3 && d3.delete(b10);
      b10 = oc();
      a4.pingedLanes |= a4.suspendedLanes & c7;
      R2 === a4 && (U & c7) === c7 && (4 === T2 || 3 === T2 && (U & 62914560) === U && 500 > G2() - Ge ? of(a4, 0) : Ue |= c7);
      Z(a4, b10);
    }
    function Ie(a4, b10) {
      var c7 = a4.stateNode;
      null !== c7 && c7.delete(b10);
      b10 = 0;
      0 === b10 && (b10 = a4.mode, 0 === (b10 & 2) ? b10 = 1 : 0 === (b10 & 4) ? b10 = 99 === Lb() ? 1 : 2 : (0 === ef && (ef = Te), b10 = nb(62914560 & ~ef), 0 === b10 && (b10 = 4194304)));
      c7 = oc();
      a4 = jf(a4, b10);
      null !== a4 && (pb(a4, b10, c7), Z(a4, c7));
    }
    var yf;
    yf = function(a4, b10, c7) {
      var d3 = b10.lanes;
      if (null !== a4)
        if (a4.memoizedProps !== b10.pendingProps || D2.current)
          J = true;
        else if (0 !== (c7 & d3))
          J = 0 !== (a4.flags & 16384) ? true : false;
        else {
          J = false;
          switch (b10.tag) {
            case 3:
              Nd(b10);
              break;
            case 5:
              Oc(b10);
              break;
            case 1:
              E2(b10.type) && bb(b10);
              break;
            case 4:
              Mc(b10, b10.stateNode.containerInfo);
              break;
            case 10:
              d3 = b10.memoizedProps.value;
              var e3 = b10.type._context;
              B2(Wb, e3._currentValue2);
              e3._currentValue2 = d3;
              break;
            case 13:
              if (null !== b10.memoizedState) {
                if (0 !== (c7 & b10.child.childLanes))
                  return Pd(a4, b10, c7);
                B2(L2, L2.current & 1);
                b10 = Dd(a4, b10, c7);
                return null !== b10 ? b10.sibling : null;
              }
              B2(L2, L2.current & 1);
              break;
            case 19:
              d3 = 0 !== (c7 & b10.childLanes);
              if (0 !== (a4.flags & 64)) {
                if (d3)
                  return Wd(a4, b10, c7);
                b10.flags |= 64;
              }
              e3 = b10.memoizedState;
              null !== e3 && (e3.rendering = null, e3.tail = null, e3.lastEffect = null);
              B2(L2, L2.current);
              if (d3)
                break;
              else
                return null;
            case 23:
            case 24:
              return b10.lanes = 0, Id(a4, b10, c7);
          }
          return Dd(a4, b10, c7);
        }
      else
        J = false;
      b10.lanes = 0;
      switch (b10.tag) {
        case 2:
          d3 = b10.type;
          null !== a4 && (a4.alternate = null, b10.alternate = null, b10.flags |= 2);
          a4 = b10.pendingProps;
          e3 = Ya(b10, C.current);
          cc(b10, c7);
          e3 = Zc(null, b10, d3, a4, e3, c7);
          b10.flags |= 1;
          if ("object" === typeof e3 && null !== e3 && "function" === typeof e3.render && void 0 === e3.$$typeof) {
            b10.tag = 1;
            b10.memoizedState = null;
            b10.updateQueue = null;
            if (E2(d3)) {
              var f = true;
              bb(b10);
            } else
              f = false;
            b10.memoizedState = null !== e3.state && void 0 !== e3.state ? e3.state : null;
            ec(b10);
            var h3 = d3.getDerivedStateFromProps;
            "function" === typeof h3 && nc(b10, d3, h3, a4);
            e3.updater = rc;
            b10.stateNode = e3;
            e3._reactInternals = b10;
            vc(b10, d3, a4, c7);
            b10 = Md(null, b10, d3, true, f, c7);
          } else
            b10.tag = 0, S3(null, b10, e3, c7), b10 = b10.child;
          return b10;
        case 16:
          e3 = b10.elementType;
          a: {
            null !== a4 && (a4.alternate = null, b10.alternate = null, b10.flags |= 2);
            a4 = b10.pendingProps;
            f = e3._init;
            e3 = f(e3._payload);
            b10.type = e3;
            f = b10.tag = Df(e3);
            a4 = I2(e3, a4);
            switch (f) {
              case 0:
                b10 = Hd(null, b10, e3, a4, c7);
                break a;
              case 1:
                b10 = Ld(null, b10, e3, a4, c7);
                break a;
              case 11:
                b10 = Cd(null, b10, e3, a4, c7);
                break a;
              case 14:
                b10 = Ed(null, b10, e3, I2(e3.type, a4), d3, c7);
                break a;
            }
            throw Error(q2(306, e3, ""));
          }
          return b10;
        case 0:
          return d3 = b10.type, e3 = b10.pendingProps, e3 = b10.elementType === d3 ? e3 : I2(d3, e3), Hd(a4, b10, d3, e3, c7);
        case 1:
          return d3 = b10.type, e3 = b10.pendingProps, e3 = b10.elementType === d3 ? e3 : I2(d3, e3), Ld(a4, b10, d3, e3, c7);
        case 3:
          Nd(b10);
          d3 = b10.updateQueue;
          if (null === a4 || null === d3)
            throw Error(q2(282));
          d3 = b10.pendingProps;
          e3 = b10.memoizedState;
          e3 = null !== e3 ? e3.element : null;
          fc(a4, b10);
          jc(b10, d3, null, c7);
          d3 = b10.memoizedState.element;
          d3 === e3 ? b10 = Dd(a4, b10, c7) : (S3(a4, b10, d3, c7), b10 = b10.child);
          return b10;
        case 5:
          return Oc(b10), d3 = b10.pendingProps.children, Kd(a4, b10), S3(a4, b10, d3, c7), b10.child;
        case 6:
          return null;
        case 13:
          return Pd(a4, b10, c7);
        case 4:
          return Mc(b10, b10.stateNode.containerInfo), d3 = b10.pendingProps, null === a4 ? b10.child = Fc(b10, null, d3, c7) : S3(a4, b10, d3, c7), b10.child;
        case 11:
          return d3 = b10.type, e3 = b10.pendingProps, e3 = b10.elementType === d3 ? e3 : I2(d3, e3), Cd(a4, b10, d3, e3, c7);
        case 7:
          return S3(
            a4,
            b10,
            b10.pendingProps,
            c7
          ), b10.child;
        case 8:
          return S3(a4, b10, b10.pendingProps.children, c7), b10.child;
        case 12:
          return S3(a4, b10, b10.pendingProps.children, c7), b10.child;
        case 10:
          a: {
            d3 = b10.type._context;
            e3 = b10.pendingProps;
            h3 = b10.memoizedProps;
            f = e3.value;
            var g2 = b10.type._context;
            B2(Wb, g2._currentValue2);
            g2._currentValue2 = f;
            if (null !== h3)
              if (g2 = h3.value, f = H3(g2, f) ? 0 : ("function" === typeof d3._calculateChangedBits ? d3._calculateChangedBits(g2, f) : 1073741823) | 0, 0 === f) {
                if (h3.children === e3.children && !D2.current) {
                  b10 = Dd(a4, b10, c7);
                  break a;
                }
              } else
                for (g2 = b10.child, null !== g2 && (g2.return = b10); null !== g2; ) {
                  var k3 = g2.dependencies;
                  if (null !== k3) {
                    h3 = g2.child;
                    for (var l = k3.firstContext; null !== l; ) {
                      if (l.context === d3 && 0 !== (l.observedBits & f)) {
                        1 === g2.tag && (l = gc(-1, c7 & -c7), l.tag = 2, hc(g2, l));
                        g2.lanes |= c7;
                        l = g2.alternate;
                        null !== l && (l.lanes |= c7);
                        bc(g2.return, c7);
                        k3.lanes |= c7;
                        break;
                      }
                      l = l.next;
                    }
                  } else
                    h3 = 10 === g2.tag ? g2.type === b10.type ? null : g2.child : g2.child;
                  if (null !== h3)
                    h3.return = g2;
                  else
                    for (h3 = g2; null !== h3; ) {
                      if (h3 === b10) {
                        h3 = null;
                        break;
                      }
                      g2 = h3.sibling;
                      if (null !== g2) {
                        g2.return = h3.return;
                        h3 = g2;
                        break;
                      }
                      h3 = h3.return;
                    }
                  g2 = h3;
                }
            S3(a4, b10, e3.children, c7);
            b10 = b10.child;
          }
          return b10;
        case 9:
          return e3 = b10.type, f = b10.pendingProps, d3 = f.children, cc(b10, c7), e3 = K2(e3, f.unstable_observedBits), d3 = d3(e3), b10.flags |= 1, S3(a4, b10, d3, c7), b10.child;
        case 14:
          return e3 = b10.type, f = I2(e3, b10.pendingProps), f = I2(e3.type, f), Ed(a4, b10, e3, f, d3, c7);
        case 15:
          return Gd(a4, b10, b10.type, b10.pendingProps, d3, c7);
        case 17:
          return d3 = b10.type, e3 = b10.pendingProps, e3 = b10.elementType === d3 ? e3 : I2(d3, e3), null !== a4 && (a4.alternate = null, b10.alternate = null, b10.flags |= 2), b10.tag = 1, E2(d3) ? (a4 = true, bb(b10)) : a4 = false, cc(b10, c7), tc(b10, d3, e3), vc(b10, d3, e3, c7), Md(null, b10, d3, true, a4, c7);
        case 19:
          return Wd(a4, b10, c7);
        case 23:
          return Id(a4, b10, c7);
        case 24:
          return Id(
            a4,
            b10,
            c7
          );
      }
      throw Error(q2(156, b10.tag));
    };
    var Hf = n.unstable_flushAllWithoutAsserting, If = "function" === typeof Hf;
    function Jf() {
      if (void 0 !== Hf)
        return Hf();
      for (var a4 = false; mf(); )
        a4 = true;
      return a4;
    }
    function Kf(a4) {
      try {
        Jf(), Le(function() {
          Jf() ? Kf(a4) : a4();
        });
      } catch (b10) {
        a4(b10);
      }
    }
    var Lf = 0, Mf = false;
    function Nf(a4, b10, c7, d3) {
      this.tag = a4;
      this.key = c7;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.ref = null;
      this.pendingProps = b10;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = d3;
      this.flags = 0;
      this.lastEffect = this.firstEffect = this.nextEffect = null;
      this.childLanes = this.lanes = 0;
      this.alternate = null;
    }
    function Of(a4, b10, c7, d3) {
      return new Nf(a4, b10, c7, d3);
    }
    function Fd(a4) {
      a4 = a4.prototype;
      return !(!a4 || !a4.isReactComponent);
    }
    function Df(a4) {
      if ("function" === typeof a4)
        return Fd(a4) ? 1 : 0;
      if (void 0 !== a4 && null !== a4) {
        a4 = a4.$$typeof;
        if (a4 === oa)
          return 11;
        if (a4 === ra)
          return 14;
      }
      return 2;
    }
    function Ac(a4, b10) {
      var c7 = a4.alternate;
      null === c7 ? (c7 = Of(a4.tag, b10, a4.key, a4.mode), c7.elementType = a4.elementType, c7.type = a4.type, c7.stateNode = a4.stateNode, c7.alternate = a4, a4.alternate = c7) : (c7.pendingProps = b10, c7.type = a4.type, c7.flags = 0, c7.nextEffect = null, c7.firstEffect = null, c7.lastEffect = null);
      c7.childLanes = a4.childLanes;
      c7.lanes = a4.lanes;
      c7.child = a4.child;
      c7.memoizedProps = a4.memoizedProps;
      c7.memoizedState = a4.memoizedState;
      c7.updateQueue = a4.updateQueue;
      b10 = a4.dependencies;
      c7.dependencies = null === b10 ? null : { lanes: b10.lanes, firstContext: b10.firstContext };
      c7.sibling = a4.sibling;
      c7.index = a4.index;
      c7.ref = a4.ref;
      return c7;
    }
    function Cc(a4, b10, c7, d3, e3, f) {
      var h3 = 2;
      d3 = a4;
      if ("function" === typeof a4)
        Fd(a4) && (h3 = 1);
      else if ("string" === typeof a4)
        h3 = 5;
      else
        a:
          switch (a4) {
            case ja:
              return Ec(c7.children, e3, f, b10);
            case ua:
              h3 = 8;
              e3 |= 16;
              break;
            case ka2:
              h3 = 8;
              e3 |= 1;
              break;
            case la:
              return a4 = Of(12, c7, b10, e3 | 8), a4.elementType = la, a4.type = la, a4.lanes = f, a4;
            case pa:
              return a4 = Of(13, c7, b10, e3), a4.type = pa, a4.elementType = pa, a4.lanes = f, a4;
            case qa:
              return a4 = Of(19, c7, b10, e3), a4.elementType = qa, a4.lanes = f, a4;
            case va:
              return Rd(c7, e3, f, b10);
            case wa:
              return a4 = Of(24, c7, b10, e3), a4.elementType = wa, a4.lanes = f, a4;
            default:
              if ("object" === typeof a4 && null !== a4)
                switch (a4.$$typeof) {
                  case ma:
                    h3 = 10;
                    break a;
                  case na:
                    h3 = 9;
                    break a;
                  case oa:
                    h3 = 11;
                    break a;
                  case ra:
                    h3 = 14;
                    break a;
                  case sa:
                    h3 = 16;
                    d3 = null;
                    break a;
                  case ta:
                    h3 = 22;
                    break a;
                }
              throw Error(q2(130, null == a4 ? a4 : typeof a4, ""));
          }
      b10 = Of(h3, c7, b10, e3);
      b10.elementType = a4;
      b10.type = d3;
      b10.lanes = f;
      return b10;
    }
    function Ec(a4, b10, c7, d3) {
      a4 = Of(7, a4, d3, b10);
      a4.lanes = c7;
      return a4;
    }
    function Rd(a4, b10, c7, d3) {
      a4 = Of(23, a4, d3, b10);
      a4.elementType = va;
      a4.lanes = c7;
      return a4;
    }
    function Bc(a4, b10, c7) {
      a4 = Of(6, a4, null, b10);
      a4.lanes = c7;
      return a4;
    }
    function Dc(a4, b10, c7) {
      b10 = Of(4, null !== a4.children ? a4.children : [], a4.key, b10);
      b10.lanes = c7;
      b10.stateNode = { containerInfo: a4.containerInfo, pendingChildren: null, implementation: a4.implementation };
      return b10;
    }
    function Pf(a4, b10, c7) {
      this.tag = b10;
      this.containerInfo = a4;
      this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
      this.timeoutHandle = -1;
      this.pendingContext = this.context = null;
      this.hydrate = c7;
      this.callbackNode = null;
      this.callbackPriority = 0;
      this.eventTimes = ob(0);
      this.expirationTimes = ob(-1);
      this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
      this.entanglements = ob(0);
    }
    function Qf(a4, b10, c7) {
      a4 = new Pf(a4, b10, c7);
      b10 = Of(3, null, null, 2 === b10 ? 7 : 1 === b10 ? 3 : 0);
      a4.current = b10;
      b10.stateNode = a4;
      ec(b10);
      return a4;
    }
    function Rf(a4, b10, c7, d3) {
      var e3 = b10.current, f = oc(), h3 = pc(e3);
      a:
        if (c7) {
          c7 = c7._reactInternals;
          b: {
            if (Ba(c7) !== c7 || 1 !== c7.tag)
              throw Error(q2(170));
            var g2 = c7;
            do {
              switch (g2.tag) {
                case 3:
                  g2 = g2.stateNode.context;
                  break b;
                case 1:
                  if (E2(g2.type)) {
                    g2 = g2.stateNode.__reactInternalMemoizedMergedChildContext;
                    break b;
                  }
              }
              g2 = g2.return;
            } while (null !== g2);
            throw Error(q2(171));
          }
          if (1 === c7.tag) {
            var k3 = c7.type;
            if (E2(k3)) {
              c7 = ab(c7, k3, g2);
              break a;
            }
          }
          c7 = g2;
        } else
          c7 = Wa;
      null === b10.context ? b10.context = c7 : b10.pendingContext = c7;
      b10 = gc(f, h3);
      b10.payload = { element: a4 };
      d3 = void 0 === d3 ? null : d3;
      null !== d3 && (b10.callback = d3);
      hc(e3, b10);
      qc(e3, h3, f);
      return h3;
    }
    function Sf() {
      return null;
    }
    var Tf = fa.IsSomeRendererActing, Uf = { createNodeMock: function() {
      return null;
    } };
    function Vf(a4) {
      if (a4.isHidden)
        return null;
      switch (a4.tag) {
        case "TEXT":
          return a4.text;
        case "INSTANCE":
          var b10 = a4.props;
          var c7 = ["children"];
          if (null == b10)
            b10 = {};
          else {
            var d3 = {}, e3 = Object.keys(b10), f;
            for (f = 0; f < e3.length; f++) {
              var h3 = e3[f];
              0 <= c7.indexOf(h3) || (d3[h3] = b10[h3]);
            }
            b10 = d3;
          }
          c7 = null;
          if (a4.children && a4.children.length)
            for (d3 = 0; d3 < a4.children.length; d3++)
              e3 = Vf(a4.children[d3]), null !== e3 && (null === c7 ? c7 = [e3] : c7.push(e3));
          a4 = { type: a4.type, props: b10, children: c7 };
          Object.defineProperty(a4, "$$typeof", { value: Symbol.for("react.test.json") });
          return a4;
        default:
          throw Error("Unexpected node type in toJSON: " + a4.tag);
      }
    }
    function Wf(a4) {
      if (!a4)
        return null;
      a4 = Xf(a4);
      return 0 === a4.length ? null : 1 === a4.length ? Yf(a4[0]) : Zf(a4.map(Yf));
    }
    function Xf(a4) {
      for (var b10 = []; null != a4; )
        b10.push(a4), a4 = a4.sibling;
      return b10;
    }
    function Zf(a4) {
      var b10 = [];
      for (a4 = [{ i: 0, array: a4 }]; a4.length; )
        for (var c7 = a4.pop(); c7.i < c7.array.length; ) {
          var d3 = c7.array[c7.i];
          c7.i += 1;
          if (Array.isArray(d3)) {
            a4.push(c7);
            a4.push({ i: 0, array: d3 });
            break;
          }
          b10.push(d3);
        }
      return b10;
    }
    function Yf(a4) {
      if (null == a4)
        return null;
      switch (a4.tag) {
        case 3:
          return Wf(a4.child);
        case 4:
          return Wf(a4.child);
        case 1:
          return { nodeType: "component", type: a4.type, props: aa({}, a4.memoizedProps), instance: a4.stateNode, rendered: Wf(a4.child) };
        case 0:
        case 15:
          return { nodeType: "component", type: a4.type, props: aa({}, a4.memoizedProps), instance: null, rendered: Wf(a4.child) };
        case 22:
          return { nodeType: "block", type: a4.type, props: aa({}, a4.memoizedProps), instance: null, rendered: Wf(a4.child) };
        case 5:
          return { nodeType: "host", type: a4.type, props: aa(
            {},
            a4.memoizedProps
          ), instance: null, rendered: Zf(Xf(a4.child).map(Yf)) };
        case 6:
          return a4.stateNode.text;
        case 7:
        case 10:
        case 9:
        case 8:
        case 12:
        case 11:
        case 14:
        case 17:
        case 21:
          return Wf(a4.child);
        default:
          throw Error(q2(214, a4.tag));
      }
    }
    var $f = /* @__PURE__ */ new Set([0, 1, 5, 11, 14, 15, 22, 3]);
    function ag(a4) {
      var b10 = [], c7 = a4;
      if (null === c7.child)
        return b10;
      c7.child.return = c7;
      c7 = c7.child;
      a:
        for (; ; ) {
          var d3 = false;
          $f.has(c7.tag) ? b10.push(bg(c7)) : 6 === c7.tag ? b10.push("" + c7.memoizedProps) : d3 = true;
          if (d3 && null !== c7.child)
            c7.child.return = c7, c7 = c7.child;
          else {
            for (; null === c7.sibling; ) {
              if (c7.return === a4)
                break a;
              c7 = c7.return;
            }
            c7.sibling.return = c7.return;
            c7 = c7.sibling;
          }
        }
      return b10;
    }
    var eg = function() {
      function a4(a5) {
        if (!$f.has(a5.tag))
          throw Error(q2(225, a5.tag));
        this._fiber = a5;
      }
      var b10 = a4.prototype;
      b10._currentFiber = function() {
        var a5 = Da(this._fiber);
        if (null === a5)
          throw Error(q2(224));
        return a5;
      };
      b10.find = function(a5) {
        return cg(this.findAll(a5, { deep: false }), "matching custom predicate: " + a5.toString());
      };
      b10.findByType = function(a5) {
        return cg(this.findAllByType(a5, { deep: false }), 'with node type: "' + (za(a5) || "Unknown") + '"');
      };
      b10.findByProps = function(a5) {
        return cg(this.findAllByProps(a5, { deep: false }), "with props: " + JSON.stringify(a5));
      };
      b10.findAll = function(a5) {
        return dg(this, a5, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null);
      };
      b10.findAllByType = function(a5) {
        return dg(this, function(b11) {
          return b11.type === a5;
        }, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null);
      };
      b10.findAllByProps = function(a5) {
        return dg(this, function(b11) {
          var c7;
          if (c7 = b11.props)
            a: {
              for (var d3 in a5)
                if (b11.props[d3] !== a5[d3]) {
                  c7 = false;
                  break a;
                }
              c7 = true;
            }
          return c7;
        }, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : null);
      };
      ea(a4, [{ key: "instance", get: function() {
        return 5 === this._fiber.tag ? Ja(this._fiber.stateNode) : this._fiber.stateNode;
      } }, { key: "type", get: function() {
        return this._fiber.type;
      } }, { key: "props", get: function() {
        return this._currentFiber().memoizedProps;
      } }, { key: "parent", get: function() {
        for (var a5 = this._fiber.return; null !== a5; ) {
          if ($f.has(a5.tag)) {
            if (3 === a5.tag && 2 > ag(a5).length)
              break;
            return bg(a5);
          }
          a5 = a5.return;
        }
        return null;
      } }, { key: "children", get: function() {
        return ag(this._currentFiber());
      } }]);
      return a4;
    }();
    function dg(a4, b10, c7) {
      var d3 = c7 ? c7.deep : true, e3 = [];
      if (b10(a4) && (e3.push(a4), !d3))
        return e3;
      a4.children.forEach(function(a5) {
        "string" !== typeof a5 && e3.push.apply(e3, dg(a5, b10, c7));
      });
      return e3;
    }
    function cg(a4, b10) {
      if (1 === a4.length)
        return a4[0];
      throw Error((0 === a4.length ? "No instances found " : "Expected 1 but found " + a4.length + " instances ") + b10);
    }
    var fg = /* @__PURE__ */ new WeakMap();
    function bg(a4) {
      var b10 = fg.get(a4);
      void 0 === b10 && null !== a4.alternate && (b10 = fg.get(a4.alternate));
      void 0 === b10 && (b10 = new eg(a4), fg.set(a4, b10));
      return b10;
    }
    var gg = { findFiberByHostInstance: function() {
      throw Error("TestRenderer does not support findFiberByHostInstance()");
    }, bundleType: 0, version: "17.0.2", rendererPackageName: "react-test-renderer" };
    var hg = { bundleType: gg.bundleType, version: gg.version, rendererPackageName: gg.rendererPackageName, rendererConfig: gg.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: fa.ReactCurrentDispatcher, findHostInstanceByFiber: function(a4) {
      a4 = Ea(a4);
      return null === a4 ? null : a4.stateNode;
    }, findFiberByHostInstance: gg.findFiberByHostInstance || Sf, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null };
    if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
      var ig = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!ig.isDisabled && ig.supportsFiber)
        try {
          db = ig.inject(hg), eb = ig;
        } catch (a4) {
        }
    }
    function jg(a4, b10) {
      jest.runOnlyPendingTimers();
      Le(function() {
        try {
          ba.unstable_flushAllWithoutAsserting() ? jg(a4, b10) : a4();
        } catch (c7) {
          b10(c7);
        }
      });
    }
    exports2._Scheduler = ba;
    exports2.act = function(a4) {
      function b10() {
        Lf--;
        Pe.current = c7;
      }
      false === Mf && (Mf = true, console.error("act(...) is not supported in production builds of React, and might not behave as expected."));
      Lf++;
      var c7 = Pe.current;
      Pe.current = true;
      try {
        var d3 = tf(a4);
      } catch (e3) {
        throw b10(), e3;
      }
      if (null !== d3 && "object" === typeof d3 && "function" === typeof d3.then)
        return { then: function(a5, f) {
          d3.then(function() {
            1 < Lf || true === If && true === c7 ? (b10(), a5()) : Kf(function(c8) {
              b10();
              c8 ? f(c8) : a5();
            });
          }, function(a6) {
            b10();
            f(a6);
          });
        } };
      try {
        1 !== Lf || false !== If && false !== c7 || Jf(), b10();
      } catch (e3) {
        throw b10(), e3;
      }
      return { then: function(a5) {
        a5();
      } };
    };
    exports2.create = function(a4, b10) {
      var c7 = Uf.createNodeMock, d3 = false;
      "object" === typeof b10 && null !== b10 && ("function" === typeof b10.createNodeMock && (c7 = b10.createNodeMock), true === b10.unstable_isConcurrent && (d3 = true));
      var e3 = { children: [], createNodeMock: c7, tag: "CONTAINER" }, f = Qf(e3, d3 ? 2 : 0, false);
      if (null == f)
        throw Error(q2(215));
      Rf(a4, f, null, null);
      a4 = { _Scheduler: ba, root: void 0, toJSON: function() {
        if (null == f || null == f.current || null == e3 || 0 === e3.children.length)
          return null;
        if (1 === e3.children.length)
          return Vf(e3.children[0]);
        if (2 === e3.children.length && true === e3.children[0].isHidden && false === e3.children[1].isHidden)
          return Vf(e3.children[1]);
        var a5 = null;
        if (e3.children && e3.children.length)
          for (var b11 = 0; b11 < e3.children.length; b11++) {
            var c8 = Vf(e3.children[b11]);
            null !== c8 && (null === a5 ? a5 = [c8] : a5.push(c8));
          }
        return a5;
      }, toTree: function() {
        return null == f || null == f.current ? null : Yf(f.current);
      }, update: function(a5) {
        null != f && null != f.current && Rf(a5, f, null, null);
      }, unmount: function() {
        null != f && null != f.current && (Rf(null, f, null, null), f = e3 = null);
      }, getInstance: function() {
        if (null == f || null == f.current)
          return null;
        a: {
          var a5 = f.current;
          if (a5.child)
            switch (a5.child.tag) {
              case 5:
                a5 = Ja(a5.child.stateNode);
                break a;
              default:
                a5 = a5.child.stateNode;
            }
          else
            a5 = null;
        }
        return a5;
      }, unstable_flushSync: function(a5) {
        a: {
          var b11 = W;
          if (0 !== (b11 & 48))
            var c8 = a5(void 0);
          else {
            W |= 1;
            try {
              c8 = a5 ? Nb(99, a5.bind(null, void 0)) : void 0;
              break a;
            } finally {
              W = b11, Pb();
            }
            c8 = void 0;
          }
        }
        return c8;
      } };
      Object.defineProperty(a4, "root", { configurable: true, enumerable: true, get: function() {
        if (null === f)
          throw Error("Can't access .root on unmounted test renderer");
        var a5 = ag(f.current);
        if (0 === a5.length)
          throw Error("Can't access .root on unmounted test renderer");
        return 1 === a5.length ? a5[0] : bg(f.current);
      } });
      return a4;
    };
    exports2.unstable_batchedUpdates = tf;
    exports2.unstable_concurrentAct = function(a4) {
      if (void 0 === ba.unstable_flushAllWithoutAsserting)
        throw Error("This version of `act` requires a special mock build of Scheduler.");
      if (true !== setTimeout._isMockFunction)
        throw Error("This version of `act` requires Jest's timer mocks (i.e. jest.useFakeTimers).");
      var b10 = Tf.current;
      Tf.current = true;
      try {
        var c7 = tf(a4);
        if ("object" === typeof c7 && null !== c7 && "function" === typeof c7.then)
          return { then: function(a5, d4) {
            c7.then(function() {
              jg(function() {
                Tf.current = b10;
                a5();
              }, function(a6) {
                Tf.current = b10;
                d4(a6);
              });
            }, function(a6) {
              Tf.current = b10;
              d4(a6);
            });
          } };
        try {
          do
            var d3 = ba.unstable_flushAllWithoutAsserting();
          while (d3);
        } finally {
          Tf.current = b10;
        }
      } catch (e3) {
        throw Tf.current = b10, e3;
      }
    };
  })(reactTestRenderer_production_min, reactTestRenderer_production_min.exports);
  return reactTestRenderer_production_min.exports;
}
var reactTestRenderer_development = { exports: {} };
var tracing = { exports: {} };
var schedulerTracing_production_min = {};
/** @license React v0.20.2
 * scheduler-tracing.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredSchedulerTracing_production_min;
function requireSchedulerTracing_production_min() {
  if (hasRequiredSchedulerTracing_production_min)
    return schedulerTracing_production_min;
  hasRequiredSchedulerTracing_production_min = 1;
  var b10 = 0;
  schedulerTracing_production_min.__interactionsRef = null;
  schedulerTracing_production_min.__subscriberRef = null;
  schedulerTracing_production_min.unstable_clear = function(a4) {
    return a4();
  };
  schedulerTracing_production_min.unstable_getCurrent = function() {
    return null;
  };
  schedulerTracing_production_min.unstable_getThreadID = function() {
    return ++b10;
  };
  schedulerTracing_production_min.unstable_subscribe = function() {
  };
  schedulerTracing_production_min.unstable_trace = function(a4, d3, c7) {
    return c7();
  };
  schedulerTracing_production_min.unstable_unsubscribe = function() {
  };
  schedulerTracing_production_min.unstable_wrap = function(a4) {
    return a4;
  };
  return schedulerTracing_production_min;
}
var schedulerTracing_development = {};
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredSchedulerTracing_development;
function requireSchedulerTracing_development() {
  if (hasRequiredSchedulerTracing_development)
    return schedulerTracing_development;
  hasRequiredSchedulerTracing_development = 1;
  (function(exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var DEFAULT_THREAD_ID = 0;
        var interactionIDCounter = 0;
        var threadIDCounter = 0;
        exports2.__interactionsRef = null;
        exports2.__subscriberRef = null;
        {
          exports2.__interactionsRef = {
            current: /* @__PURE__ */ new Set()
          };
          exports2.__subscriberRef = {
            current: null
          };
        }
        function unstable_clear(callback) {
          var prevInteractions = exports2.__interactionsRef.current;
          exports2.__interactionsRef.current = /* @__PURE__ */ new Set();
          try {
            return callback();
          } finally {
            exports2.__interactionsRef.current = prevInteractions;
          }
        }
        function unstable_getCurrent() {
          {
            return exports2.__interactionsRef.current;
          }
        }
        function unstable_getThreadID() {
          return ++threadIDCounter;
        }
        function unstable_trace(name2, timestamp, callback) {
          var threadID = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : DEFAULT_THREAD_ID;
          var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name2,
            timestamp
          };
          var prevInteractions = exports2.__interactionsRef.current;
          var interactions = new Set(prevInteractions);
          interactions.add(interaction);
          exports2.__interactionsRef.current = interactions;
          var subscriber = exports2.__subscriberRef.current;
          var returnValue;
          try {
            if (subscriber !== null) {
              subscriber.onInteractionTraced(interaction);
            }
          } finally {
            try {
              if (subscriber !== null) {
                subscriber.onWorkStarted(interactions, threadID);
              }
            } finally {
              try {
                returnValue = callback();
              } finally {
                exports2.__interactionsRef.current = prevInteractions;
                try {
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(interactions, threadID);
                  }
                } finally {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                }
              }
            }
          }
          return returnValue;
        }
        function unstable_wrap(callback) {
          var threadID = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_THREAD_ID;
          var wrappedInteractions = exports2.__interactionsRef.current;
          var subscriber = exports2.__subscriberRef.current;
          if (subscriber !== null) {
            subscriber.onWorkScheduled(wrappedInteractions, threadID);
          }
          wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
          });
          var hasRun = false;
          function wrapped2() {
            var prevInteractions = exports2.__interactionsRef.current;
            exports2.__interactionsRef.current = wrappedInteractions;
            subscriber = exports2.__subscriberRef.current;
            try {
              var returnValue;
              try {
                if (subscriber !== null) {
                  subscriber.onWorkStarted(wrappedInteractions, threadID);
                }
              } finally {
                try {
                  returnValue = callback.apply(void 0, arguments);
                } finally {
                  exports2.__interactionsRef.current = prevInteractions;
                  if (subscriber !== null) {
                    subscriber.onWorkStopped(wrappedInteractions, threadID);
                  }
                }
              }
              return returnValue;
            } finally {
              if (!hasRun) {
                hasRun = true;
                wrappedInteractions.forEach(function(interaction) {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    subscriber.onInteractionScheduledWorkCompleted(interaction);
                  }
                });
              }
            }
          }
          wrapped2.cancel = function cancel2() {
            subscriber = exports2.__subscriberRef.current;
            try {
              if (subscriber !== null) {
                subscriber.onWorkCanceled(wrappedInteractions, threadID);
              }
            } finally {
              wrappedInteractions.forEach(function(interaction) {
                interaction.__count--;
                if (subscriber && interaction.__count === 0) {
                  subscriber.onInteractionScheduledWorkCompleted(interaction);
                }
              });
            }
          };
          return wrapped2;
        }
        var subscribers = null;
        {
          subscribers = /* @__PURE__ */ new Set();
        }
        function unstable_subscribe(subscriber) {
          {
            subscribers.add(subscriber);
            if (subscribers.size === 1) {
              exports2.__subscriberRef.current = {
                onInteractionScheduledWorkCompleted,
                onInteractionTraced,
                onWorkCanceled,
                onWorkScheduled,
                onWorkStarted,
                onWorkStopped
              };
            }
          }
        }
        function unstable_unsubscribe(subscriber) {
          {
            subscribers.delete(subscriber);
            if (subscribers.size === 0) {
              exports2.__subscriberRef.current = null;
            }
          }
        }
        function onInteractionTraced(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onInteractionTraced(interaction);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onInteractionScheduledWorkCompleted(interaction) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkScheduled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkScheduled(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkStarted(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkStarted(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkStopped(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkStopped(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        function onWorkCanceled(interactions, threadID) {
          var didCatchError = false;
          var caughtError = null;
          subscribers.forEach(function(subscriber) {
            try {
              subscriber.onWorkCanceled(interactions, threadID);
            } catch (error2) {
              if (!didCatchError) {
                didCatchError = true;
                caughtError = error2;
              }
            }
          });
          if (didCatchError) {
            throw caughtError;
          }
        }
        exports2.unstable_clear = unstable_clear;
        exports2.unstable_getCurrent = unstable_getCurrent;
        exports2.unstable_getThreadID = unstable_getThreadID;
        exports2.unstable_subscribe = unstable_subscribe;
        exports2.unstable_trace = unstable_trace;
        exports2.unstable_unsubscribe = unstable_unsubscribe;
        exports2.unstable_wrap = unstable_wrap;
      })();
    }
  })(schedulerTracing_development);
  return schedulerTracing_development;
}
var hasRequiredTracing;
function requireTracing() {
  if (hasRequiredTracing)
    return tracing.exports;
  hasRequiredTracing = 1;
  if (process.env.NODE_ENV === "production") {
    tracing.exports = requireSchedulerTracing_production_min();
  } else {
    tracing.exports = requireSchedulerTracing_development();
  }
  return tracing.exports;
}
/** @license React v17.0.2
 * react-test-renderer.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
reactTestRenderer_development.exports;
var hasRequiredReactTestRenderer_development;
function requireReactTestRenderer_development() {
  if (hasRequiredReactTestRenderer_development)
    return reactTestRenderer_development.exports;
  hasRequiredReactTestRenderer_development = 1;
  (function(module2, exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var React2 = React__default;
        var _assign2 = requireObjectAssign();
        var Scheduler2 = requireUnstable_mock();
        var Scheduler$1 = requireScheduler();
        var tracing2 = requireTracing();
        var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function warn2(format2) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format2, args);
          }
        }
        function error2(format2) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
        function printWarning(level, format2, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack2 = ReactDebugCurrentFrame2.getStackAddendum();
            if (stack2 !== "") {
              format2 += "%s";
              args = args.concat([stack2]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format2);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        function _defineProperties2(target, props2) {
          for (var i2 = 0; i2 < props2.length; i2++) {
            var descriptor = props2[i2];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor)
              descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        function _createClass2(Constructor, protoProps, staticProps) {
          if (protoProps)
            _defineProperties2(Constructor.prototype, protoProps);
          if (staticProps)
            _defineProperties2(Constructor, staticProps);
          return Constructor;
        }
        function _objectWithoutPropertiesLoose2(source, excluded) {
          if (source == null)
            return {};
          var target = {};
          var sourceKeys = Object.keys(source);
          var key, i2;
          for (i2 = 0; i2 < sourceKeys.length; i2++) {
            key = sourceKeys[i2];
            if (excluded.indexOf(key) >= 0)
              continue;
            target[key] = source[key];
          }
          return target;
        }
        var FunctionComponent = 0;
        var ClassComponent = 1;
        var IndeterminateComponent = 2;
        var HostRoot = 3;
        var HostPortal = 4;
        var HostComponent = 5;
        var HostText = 6;
        var Fragment2 = 7;
        var Mode = 8;
        var ContextConsumer = 9;
        var ContextProvider = 10;
        var ForwardRef = 11;
        var Profiler = 12;
        var SuspenseComponent = 13;
        var MemoComponent = 14;
        var SimpleMemoComponent = 15;
        var LazyComponent = 16;
        var IncompleteClassComponent = 17;
        var DehydratedFragment = 18;
        var SuspenseListComponent = 19;
        var FundamentalComponent = 20;
        var ScopeComponent = 21;
        var Block = 22;
        var OffscreenComponent = 23;
        var LegacyHiddenComponent = 24;
        function get9(key) {
          return key._reactInternals;
        }
        function set(key, value) {
          key._reactInternals = value;
        }
        var REACT_ELEMENT_TYPE2 = 60103;
        var REACT_PORTAL_TYPE = 60106;
        var REACT_FRAGMENT_TYPE = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SCOPE_TYPE = 60119;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_OFFSCREEN_TYPE = 60130;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE2 = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          symbolFor("react.server.block");
          symbolFor("react.fundamental");
          REACT_SCOPE_TYPE = symbolFor("react.scope");
          symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          REACT_OFFSCREEN_TYPE = symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getContextName(type2) {
          return type2.displayName || "Context";
        }
        function getComponentName(type2) {
          if (type2 == null) {
            return null;
          }
          {
            if (typeof type2.tag === "number") {
              error2("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type2 === "function") {
            return type2.displayName || type2.name || null;
          }
          if (typeof type2 === "string") {
            return type2;
          }
          switch (type2) {
            case REACT_FRAGMENT_TYPE:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type2 === "object") {
            switch (type2.$$typeof) {
              case REACT_CONTEXT_TYPE:
                var context = type2;
                return getContextName(context) + ".Consumer";
              case REACT_PROVIDER_TYPE:
                var provider = type2;
                return getContextName(provider._context) + ".Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type2, type2.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type2.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type2._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type2;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  return getComponentName(init2(payload));
                } catch (x3) {
                  return null;
                }
              }
            }
          }
          return null;
        }
        var NoFlags = (
          /*                      */
          0
        );
        var PerformedWork = (
          /*                */
          1
        );
        var Placement = (
          /*                    */
          2
        );
        var Update = (
          /*                       */
          4
        );
        var PlacementAndUpdate = (
          /*           */
          6
        );
        var Deletion = (
          /*                     */
          8
        );
        var ContentReset = (
          /*                 */
          16
        );
        var Callback = (
          /*                     */
          32
        );
        var DidCapture = (
          /*                   */
          64
        );
        var Ref = (
          /*                          */
          128
        );
        var Snapshot = (
          /*                     */
          256
        );
        var Passive = (
          /*                      */
          512
        );
        var PassiveUnmountPendingDev = (
          /*     */
          8192
        );
        var Hydrating = (
          /*                    */
          1024
        );
        var HydratingAndUpdate = (
          /*           */
          1028
        );
        var LifecycleEffectMask = (
          /*          */
          932
        );
        var HostEffectMask = (
          /*               */
          2047
        );
        var Incomplete = (
          /*                   */
          2048
        );
        var ShouldCapture = (
          /*                */
          4096
        );
        var ForceUpdateForLegacySuspense = (
          /* */
          16384
        );
        var enableProfilerTimer = true;
        var enableFundamentalAPI = false;
        var warnAboutStringRefs = false;
        var enableNewReconciler = false;
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        function getNearestMountedFiber(fiber) {
          var node2 = fiber;
          var nearestMounted = fiber;
          if (!fiber.alternate) {
            var nextNode = node2;
            do {
              node2 = nextNode;
              if ((node2.flags & (Placement | Hydrating)) !== NoFlags) {
                nearestMounted = node2.return;
              }
              nextNode = node2.return;
            } while (nextNode);
          } else {
            while (node2.return) {
              node2 = node2.return;
            }
          }
          if (node2.tag === HostRoot) {
            return nearestMounted;
          }
          return null;
        }
        function isFiberMounted(fiber) {
          return getNearestMountedFiber(fiber) === fiber;
        }
        function isMounted(component) {
          {
            var owner = ReactCurrentOwner.current;
            if (owner !== null && owner.tag === ClassComponent) {
              var ownerFiber = owner;
              var instance = ownerFiber.stateNode;
              if (!instance._warnedAboutRefsInRender) {
                error2("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || "A component");
              }
              instance._warnedAboutRefsInRender = true;
            }
          }
          var fiber = get9(component);
          if (!fiber) {
            return false;
          }
          return getNearestMountedFiber(fiber) === fiber;
        }
        function assertIsMounted(fiber) {
          if (!(getNearestMountedFiber(fiber) === fiber)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
        }
        function findCurrentFiberUsingSlowPath(fiber) {
          var alternate = fiber.alternate;
          if (!alternate) {
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
            if (nearestMounted !== fiber) {
              return null;
            }
            return fiber;
          }
          var a4 = fiber;
          var b10 = alternate;
          while (true) {
            var parentA = a4.return;
            if (parentA === null) {
              break;
            }
            var parentB = parentA.alternate;
            if (parentB === null) {
              var nextParent = parentA.return;
              if (nextParent !== null) {
                a4 = b10 = nextParent;
                continue;
              }
              break;
            }
            if (parentA.child === parentB.child) {
              var child = parentA.child;
              while (child) {
                if (child === a4) {
                  assertIsMounted(parentA);
                  return fiber;
                }
                if (child === b10) {
                  assertIsMounted(parentA);
                  return alternate;
                }
                child = child.sibling;
              }
              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            }
            if (a4.return !== b10.return) {
              a4 = parentA;
              b10 = parentB;
            } else {
              var didFindChild = false;
              var _child = parentA.child;
              while (_child) {
                if (_child === a4) {
                  didFindChild = true;
                  a4 = parentA;
                  b10 = parentB;
                  break;
                }
                if (_child === b10) {
                  didFindChild = true;
                  b10 = parentA;
                  a4 = parentB;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                _child = parentB.child;
                while (_child) {
                  if (_child === a4) {
                    didFindChild = true;
                    a4 = parentB;
                    b10 = parentA;
                    break;
                  }
                  if (_child === b10) {
                    didFindChild = true;
                    b10 = parentB;
                    a4 = parentA;
                    break;
                  }
                  _child = _child.sibling;
                }
                if (!didFindChild) {
                  {
                    throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                  }
                }
              }
            }
            if (!(a4.alternate === b10)) {
              {
                throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (!(a4.tag === HostRoot)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (a4.stateNode.current === a4) {
            return fiber;
          }
          return alternate;
        }
        function findCurrentHostFiber(parent2) {
          var currentParent = findCurrentFiberUsingSlowPath(parent2);
          if (!currentParent) {
            return null;
          }
          var node2 = currentParent;
          while (true) {
            if (node2.tag === HostComponent || node2.tag === HostText) {
              return node2;
            } else if (node2.child) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === currentParent) {
              return null;
            }
            while (!node2.sibling) {
              if (!node2.return || node2.return === currentParent) {
                return null;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
          return null;
        }
        function doesFiberContain(parentFiber, childFiber) {
          var node2 = childFiber;
          var parentFiberAlternate = parentFiber.alternate;
          while (node2 !== null) {
            if (node2 === parentFiber || node2 === parentFiberAlternate) {
              return true;
            }
            node2 = node2.return;
          }
          return false;
        }
        function shim2() {
          {
            {
              throw Error("The current renderer does not support hydration. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        var isSuspenseInstancePending = shim2;
        var isSuspenseInstanceFallback = shim2;
        var NO_CONTEXT = {};
        var UPDATE_SIGNAL = {};
        var nodeToInstanceMap = /* @__PURE__ */ new WeakMap();
        {
          Object.freeze(NO_CONTEXT);
          Object.freeze(UPDATE_SIGNAL);
        }
        function getPublicInstance(inst) {
          switch (inst.tag) {
            case "INSTANCE":
              var createNodeMock = inst.rootContainerInstance.createNodeMock;
              var mockNode = createNodeMock({
                type: inst.type,
                props: inst.props
              });
              if (typeof mockNode === "object" && mockNode !== null) {
                nodeToInstanceMap.set(mockNode, inst);
              }
              return mockNode;
            default:
              return inst;
          }
        }
        function appendChild(parentInstance, child) {
          {
            if (!Array.isArray(parentInstance.children)) {
              error2("An invalid container has been provided. This may indicate that another renderer is being used in addition to the test renderer. (For example, ReactDOM.createPortal inside of a ReactTestRenderer tree.) This is not supported.");
            }
          }
          var index3 = parentInstance.children.indexOf(child);
          if (index3 !== -1) {
            parentInstance.children.splice(index3, 1);
          }
          parentInstance.children.push(child);
        }
        function insertBefore(parentInstance, child, beforeChild) {
          var index3 = parentInstance.children.indexOf(child);
          if (index3 !== -1) {
            parentInstance.children.splice(index3, 1);
          }
          var beforeIndex = parentInstance.children.indexOf(beforeChild);
          parentInstance.children.splice(beforeIndex, 0, child);
        }
        function removeChild(parentInstance, child) {
          var index3 = parentInstance.children.indexOf(child);
          parentInstance.children.splice(index3, 1);
        }
        function clearContainer(container2) {
          container2.children.splice(0);
        }
        function getRootHostContext(rootContainerInstance) {
          return NO_CONTEXT;
        }
        function getChildHostContext(parentHostContext, type2, rootContainerInstance) {
          return NO_CONTEXT;
        }
        function prepareForCommit(containerInfo) {
          return null;
        }
        function resetAfterCommit(containerInfo) {
        }
        function createInstance2(type2, props2, rootContainerInstance, hostContext, internalInstanceHandle) {
          return {
            type: type2,
            props: props2,
            isHidden: false,
            children: [],
            internalInstanceHandle,
            rootContainerInstance,
            tag: "INSTANCE"
          };
        }
        function appendInitialChild(parentInstance, child) {
          var index3 = parentInstance.children.indexOf(child);
          if (index3 !== -1) {
            parentInstance.children.splice(index3, 1);
          }
          parentInstance.children.push(child);
        }
        function prepareUpdate(testElement, type2, oldProps, newProps, rootContainerInstance, hostContext) {
          return UPDATE_SIGNAL;
        }
        function shouldSetTextContent(type2, props2) {
          return false;
        }
        function createTextInstance(text2, rootContainerInstance, hostContext, internalInstanceHandle) {
          return {
            text: text2,
            isHidden: false,
            tag: "TEXT"
          };
        }
        var scheduleTimeout = setTimeout;
        var cancelTimeout = clearTimeout;
        var noTimeout = -1;
        function commitUpdate(instance, updatePayload, type2, oldProps, newProps, internalInstanceHandle) {
          instance.type = type2;
          instance.props = newProps;
        }
        function commitTextUpdate(textInstance, oldText, newText) {
          textInstance.text = newText;
        }
        function resetTextContent(testElement) {
        }
        var appendChildToContainer = appendChild;
        var insertInContainerBefore = insertBefore;
        var removeChildFromContainer = removeChild;
        function hideInstance(instance) {
          instance.isHidden = true;
        }
        function hideTextInstance(textInstance) {
          textInstance.isHidden = true;
        }
        function unhideInstance(instance, props2) {
          instance.isHidden = false;
        }
        function unhideTextInstance(textInstance, text2) {
          textInstance.isHidden = false;
        }
        var clientId = 0;
        function makeClientIdInDEV(warnOnAccessInDEV) {
          var id = "c_" + (clientId++).toString(36);
          return {
            toString: function() {
              warnOnAccessInDEV();
              return id;
            },
            valueOf: function() {
              warnOnAccessInDEV();
              return id;
            }
          };
        }
        function preparePortalMount(portalInstance) {
        }
        var disabledDepth = 0;
        var prevLog;
        var prevInfo;
        var prevWarn;
        var prevError;
        var prevGroup;
        var prevGroupCollapsed;
        var prevGroupEnd;
        function disabledLog() {
        }
        disabledLog.__reactDisabledLog = true;
        function disableLogs() {
          {
            if (disabledDepth === 0) {
              prevLog = console.log;
              prevInfo = console.info;
              prevWarn = console.warn;
              prevError = console.error;
              prevGroup = console.group;
              prevGroupCollapsed = console.groupCollapsed;
              prevGroupEnd = console.groupEnd;
              var props2 = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
              };
              Object.defineProperties(console, {
                info: props2,
                log: props2,
                warn: props2,
                error: props2,
                group: props2,
                groupCollapsed: props2,
                groupEnd: props2
              });
            }
            disabledDepth++;
          }
        }
        function reenableLogs() {
          {
            disabledDepth--;
            if (disabledDepth === 0) {
              var props2 = {
                configurable: true,
                enumerable: true,
                writable: true
              };
              Object.defineProperties(console, {
                log: _assign2({}, props2, {
                  value: prevLog
                }),
                info: _assign2({}, props2, {
                  value: prevInfo
                }),
                warn: _assign2({}, props2, {
                  value: prevWarn
                }),
                error: _assign2({}, props2, {
                  value: prevError
                }),
                group: _assign2({}, props2, {
                  value: prevGroup
                }),
                groupCollapsed: _assign2({}, props2, {
                  value: prevGroupCollapsed
                }),
                groupEnd: _assign2({}, props2, {
                  value: prevGroupEnd
                })
              });
            }
            if (disabledDepth < 0) {
              error2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
            }
          }
        }
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        var prefix2;
        function describeBuiltInComponentFrame(name2, source, ownerFn) {
          {
            if (prefix2 === void 0) {
              try {
                throw Error();
              } catch (x3) {
                var match2 = x3.stack.trim().match(/\n( *(at )?)/);
                prefix2 = match2 && match2[1] || "";
              }
            }
            return "\n" + prefix2 + name2;
          }
        }
        var reentry = false;
        var componentFrameCache;
        {
          var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
          componentFrameCache = new PossiblyWeakMap();
        }
        function describeNativeComponentFrame(fn2, construct) {
          if (!fn2 || reentry) {
            return "";
          }
          {
            var frame2 = componentFrameCache.get(fn2);
            if (frame2 !== void 0) {
              return frame2;
            }
          }
          var control;
          reentry = true;
          var previousPrepareStackTrace = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var previousDispatcher;
          {
            previousDispatcher = ReactCurrentDispatcher.current;
            ReactCurrentDispatcher.current = null;
            disableLogs();
          }
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if (typeof Reflect === "object" && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x3) {
                  control = x3;
                }
                Reflect.construct(fn2, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x3) {
                  control = x3;
                }
                fn2.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x3) {
                control = x3;
              }
              fn2();
            }
          } catch (sample) {
            if (sample && control && typeof sample.stack === "string") {
              var sampleLines = sample.stack.split("\n");
              var controlLines = control.stack.split("\n");
              var s4 = sampleLines.length - 1;
              var c7 = controlLines.length - 1;
              while (s4 >= 1 && c7 >= 0 && sampleLines[s4] !== controlLines[c7]) {
                c7--;
              }
              for (; s4 >= 1 && c7 >= 0; s4--, c7--) {
                if (sampleLines[s4] !== controlLines[c7]) {
                  if (s4 !== 1 || c7 !== 1) {
                    do {
                      s4--;
                      c7--;
                      if (c7 < 0 || sampleLines[s4] !== controlLines[c7]) {
                        var _frame = "\n" + sampleLines[s4].replace(" at new ", " at ");
                        {
                          if (typeof fn2 === "function") {
                            componentFrameCache.set(fn2, _frame);
                          }
                        }
                        return _frame;
                      }
                    } while (s4 >= 1 && c7 >= 0);
                  }
                  break;
                }
              }
            }
          } finally {
            reentry = false;
            {
              ReactCurrentDispatcher.current = previousDispatcher;
              reenableLogs();
            }
            Error.prepareStackTrace = previousPrepareStackTrace;
          }
          var name2 = fn2 ? fn2.displayName || fn2.name : "";
          var syntheticFrame = name2 ? describeBuiltInComponentFrame(name2) : "";
          {
            if (typeof fn2 === "function") {
              componentFrameCache.set(fn2, syntheticFrame);
            }
          }
          return syntheticFrame;
        }
        function describeClassComponentFrame(ctor, source, ownerFn) {
          {
            return describeNativeComponentFrame(ctor, true);
          }
        }
        function describeFunctionComponentFrame(fn2, source, ownerFn) {
          {
            return describeNativeComponentFrame(fn2, false);
          }
        }
        function shouldConstruct(Component2) {
          var prototype2 = Component2.prototype;
          return !!(prototype2 && prototype2.isReactComponent);
        }
        function describeUnknownElementTypeFrameInDEV(type2, source, ownerFn) {
          if (type2 == null) {
            return "";
          }
          if (typeof type2 === "function") {
            {
              return describeNativeComponentFrame(type2, shouldConstruct(type2));
            }
          }
          if (typeof type2 === "string") {
            return describeBuiltInComponentFrame(type2);
          }
          switch (type2) {
            case REACT_SUSPENSE_TYPE:
              return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
              return describeBuiltInComponentFrame("SuspenseList");
          }
          if (typeof type2 === "object") {
            switch (type2.$$typeof) {
              case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type2.render);
              case REACT_MEMO_TYPE:
                return describeUnknownElementTypeFrameInDEV(type2.type, source, ownerFn);
              case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type2._render);
              case REACT_LAZY_TYPE: {
                var lazyComponent = type2;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  return describeUnknownElementTypeFrameInDEV(init2(payload), source, ownerFn);
                } catch (x3) {
                }
              }
            }
          }
          return "";
        }
        var loggedTypeFailures = {};
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement(element) {
          {
            if (element) {
              var owner = element._owner;
              var stack2 = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
              ReactDebugCurrentFrame.setExtraStackFrame(stack2);
            } else {
              ReactDebugCurrentFrame.setExtraStackFrame(null);
            }
          }
        }
        function checkPropTypes(typeSpecs, values6, location, componentName, element) {
          {
            var has7 = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has7(typeSpecs, typeSpecName)) {
                var error$12 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$12 = typeSpecs[typeSpecName](values6, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$12 = ex;
                }
                if (error$12 && !(error$12 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$12);
                  setCurrentlyValidatingElement(null);
                }
                if (error$12 instanceof Error && !(error$12.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$12.message] = true;
                  setCurrentlyValidatingElement(element);
                  error2("Failed %s type: %s", location, error$12.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var valueStack = [];
        var fiberStack;
        {
          fiberStack = [];
        }
        var index2 = -1;
        function createCursor(defaultValue) {
          return {
            current: defaultValue
          };
        }
        function pop(cursor2, fiber) {
          if (index2 < 0) {
            {
              error2("Unexpected pop.");
            }
            return;
          }
          {
            if (fiber !== fiberStack[index2]) {
              error2("Unexpected Fiber popped.");
            }
          }
          cursor2.current = valueStack[index2];
          valueStack[index2] = null;
          {
            fiberStack[index2] = null;
          }
          index2--;
        }
        function push(cursor2, value, fiber) {
          index2++;
          valueStack[index2] = cursor2.current;
          {
            fiberStack[index2] = fiber;
          }
          cursor2.current = value;
        }
        var warnedAboutMissingGetChildContext;
        {
          warnedAboutMissingGetChildContext = {};
        }
        var emptyContextObject = {};
        {
          Object.freeze(emptyContextObject);
        }
        var contextStackCursor = createCursor(emptyContextObject);
        var didPerformWorkStackCursor = createCursor(false);
        var previousContext = emptyContextObject;
        function getUnmaskedContext(workInProgress2, Component2, didPushOwnContextIfProvider) {
          {
            if (didPushOwnContextIfProvider && isContextProvider(Component2)) {
              return previousContext;
            }
            return contextStackCursor.current;
          }
        }
        function cacheContext(workInProgress2, unmaskedContext, maskedContext) {
          {
            var instance = workInProgress2.stateNode;
            instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
            instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
          }
        }
        function getMaskedContext(workInProgress2, unmaskedContext) {
          {
            var type2 = workInProgress2.type;
            var contextTypes = type2.contextTypes;
            if (!contextTypes) {
              return emptyContextObject;
            }
            var instance = workInProgress2.stateNode;
            if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) {
              return instance.__reactInternalMemoizedMaskedChildContext;
            }
            var context = {};
            for (var key in contextTypes) {
              context[key] = unmaskedContext[key];
            }
            {
              var name2 = getComponentName(type2) || "Unknown";
              checkPropTypes(contextTypes, context, "context", name2);
            }
            if (instance) {
              cacheContext(workInProgress2, unmaskedContext, context);
            }
            return context;
          }
        }
        function hasContextChanged() {
          {
            return didPerformWorkStackCursor.current;
          }
        }
        function isContextProvider(type2) {
          {
            var childContextTypes = type2.childContextTypes;
            return childContextTypes !== null && childContextTypes !== void 0;
          }
        }
        function popContext(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }
        function popTopLevelContextObject(fiber) {
          {
            pop(didPerformWorkStackCursor, fiber);
            pop(contextStackCursor, fiber);
          }
        }
        function pushTopLevelContextObject(fiber, context, didChange) {
          {
            if (!(contextStackCursor.current === emptyContextObject)) {
              {
                throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            push(contextStackCursor, context, fiber);
            push(didPerformWorkStackCursor, didChange, fiber);
          }
        }
        function processChildContext(fiber, type2, parentContext) {
          {
            var instance = fiber.stateNode;
            var childContextTypes = type2.childContextTypes;
            if (typeof instance.getChildContext !== "function") {
              {
                var componentName = getComponentName(type2) || "Unknown";
                if (!warnedAboutMissingGetChildContext[componentName]) {
                  warnedAboutMissingGetChildContext[componentName] = true;
                  error2("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
                }
              }
              return parentContext;
            }
            var childContext = instance.getChildContext();
            for (var contextKey in childContext) {
              if (!(contextKey in childContextTypes)) {
                {
                  throw Error((getComponentName(type2) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
                }
              }
            }
            {
              var name2 = getComponentName(type2) || "Unknown";
              checkPropTypes(childContextTypes, childContext, "child context", name2);
            }
            return _assign2({}, parentContext, childContext);
          }
        }
        function pushContextProvider(workInProgress2) {
          {
            var instance = workInProgress2.stateNode;
            var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject;
            previousContext = contextStackCursor.current;
            push(contextStackCursor, memoizedMergedChildContext, workInProgress2);
            push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress2);
            return true;
          }
        }
        function invalidateContextProvider(workInProgress2, type2, didChange) {
          {
            var instance = workInProgress2.stateNode;
            if (!instance) {
              {
                throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            if (didChange) {
              var mergedContext = processChildContext(workInProgress2, type2, previousContext);
              instance.__reactInternalMemoizedMergedChildContext = mergedContext;
              pop(didPerformWorkStackCursor, workInProgress2);
              pop(contextStackCursor, workInProgress2);
              push(contextStackCursor, mergedContext, workInProgress2);
              push(didPerformWorkStackCursor, didChange, workInProgress2);
            } else {
              pop(didPerformWorkStackCursor, workInProgress2);
              push(didPerformWorkStackCursor, didChange, workInProgress2);
            }
          }
        }
        function findCurrentUnmaskedContext(fiber) {
          {
            if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) {
              {
                throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            var node2 = fiber;
            do {
              switch (node2.tag) {
                case HostRoot:
                  return node2.stateNode.context;
                case ClassComponent: {
                  var Component2 = node2.type;
                  if (isContextProvider(Component2)) {
                    return node2.stateNode.__reactInternalMemoizedMergedChildContext;
                  }
                  break;
                }
              }
              node2 = node2.return;
            } while (node2 !== null);
            {
              {
                throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        var LegacyRoot = 0;
        var BlockingRoot = 1;
        var ConcurrentRoot = 2;
        var rendererID = null;
        var injectedHook = null;
        var hasLoggedError = false;
        var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
        function injectInternals(internals) {
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") {
            return false;
          }
          var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (hook.isDisabled) {
            return true;
          }
          if (!hook.supportsFiber) {
            {
              error2("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            }
            return true;
          }
          try {
            rendererID = hook.inject(internals);
            injectedHook = hook;
          } catch (err) {
            {
              error2("React instrumentation encountered an error: %s.", err);
            }
          }
          return true;
        }
        function onScheduleRoot(root2, children2) {
          {
            if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") {
              try {
                injectedHook.onScheduleFiberRoot(rendererID, root2, children2);
              } catch (err) {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error2("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
        function onCommitRoot(root2, priorityLevel) {
          if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") {
            try {
              var didError = (root2.current.flags & DidCapture) === DidCapture;
              if (enableProfilerTimer) {
                injectedHook.onCommitFiberRoot(rendererID, root2, priorityLevel, didError);
              }
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error2("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
        function onCommitUnmount(fiber) {
          if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") {
            try {
              injectedHook.onCommitFiberUnmount(rendererID, fiber);
            } catch (err) {
              {
                if (!hasLoggedError) {
                  hasLoggedError = true;
                  error2("React instrumentation encountered an error: %s", err);
                }
              }
            }
          }
        }
        var Scheduler_now = Scheduler$1.unstable_now;
        {
          if (!(tracing2.__interactionsRef != null && tracing2.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
            }
          }
        }
        var ImmediatePriority = 99;
        var UserBlockingPriority = 98;
        var NormalPriority = 97;
        var LowPriority = 96;
        var IdlePriority = 95;
        var NoPriority = 90;
        Scheduler_now();
        var SyncLanePriority = 15;
        var SyncBatchedLanePriority = 14;
        var InputDiscreteHydrationLanePriority = 13;
        var InputDiscreteLanePriority = 12;
        var InputContinuousHydrationLanePriority = 11;
        var InputContinuousLanePriority = 10;
        var DefaultHydrationLanePriority = 9;
        var DefaultLanePriority = 8;
        var TransitionHydrationPriority = 7;
        var TransitionPriority = 6;
        var RetryLanePriority = 5;
        var SelectiveHydrationLanePriority = 4;
        var IdleHydrationLanePriority = 3;
        var IdleLanePriority = 2;
        var OffscreenLanePriority = 1;
        var NoLanePriority = 0;
        var TotalLanes = 31;
        var NoLanes = (
          /*                        */
          0
        );
        var NoLane = (
          /*                          */
          0
        );
        var SyncLane = (
          /*                        */
          1
        );
        var SyncBatchedLane = (
          /*                 */
          2
        );
        var InputDiscreteHydrationLane = (
          /*      */
          4
        );
        var InputDiscreteLanes = (
          /*                    */
          24
        );
        var InputContinuousHydrationLane = (
          /*           */
          32
        );
        var InputContinuousLanes = (
          /*                  */
          192
        );
        var DefaultHydrationLane = (
          /*            */
          256
        );
        var DefaultLanes = (
          /*                   */
          3584
        );
        var TransitionHydrationLane = (
          /*                */
          4096
        );
        var TransitionLanes = (
          /*                       */
          4186112
        );
        var RetryLanes = (
          /*                            */
          62914560
        );
        var SomeRetryLane = (
          /*                  */
          33554432
        );
        var SelectiveHydrationLane = (
          /*          */
          67108864
        );
        var NonIdleLanes = (
          /*                                 */
          134217727
        );
        var IdleHydrationLane = (
          /*               */
          134217728
        );
        var IdleLanes = (
          /*                             */
          805306368
        );
        var OffscreenLane = (
          /*                   */
          1073741824
        );
        var NoTimestamp = -1;
        var return_highestLanePriority = DefaultLanePriority;
        function getHighestPriorityLanes(lanes) {
          if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
          }
          if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
          }
          if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
          }
          var inputDiscreteLanes = InputDiscreteLanes & lanes;
          if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
          }
          if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
          }
          var inputContinuousLanes = InputContinuousLanes & lanes;
          if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
          }
          if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
          }
          var defaultLanes = DefaultLanes & lanes;
          if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
          }
          if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
          }
          var transitionLanes = TransitionLanes & lanes;
          if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
          }
          var retryLanes = RetryLanes & lanes;
          if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
          }
          if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
          }
          if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
          }
          var idleLanes = IdleLanes & lanes;
          if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
          }
          if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
          }
          {
            error2("Should have found matching lanes. This is a bug in React.");
          }
          return_highestLanePriority = DefaultLanePriority;
          return lanes;
        }
        function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
          switch (schedulerPriorityLevel) {
            case ImmediatePriority:
              return SyncLanePriority;
            case UserBlockingPriority:
              return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
              return DefaultLanePriority;
            case IdlePriority:
              return IdleLanePriority;
            default:
              return NoLanePriority;
          }
        }
        function lanePriorityToSchedulerPriority(lanePriority) {
          switch (lanePriority) {
            case SyncLanePriority:
            case SyncBatchedLanePriority:
              return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
              return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
              return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
              return IdlePriority;
            case NoLanePriority:
              return NoPriority;
            default: {
              {
                throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
              }
            }
          }
        }
        function getNextLanes(root2, wipLanes) {
          var pendingLanes = root2.pendingLanes;
          if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
          }
          var nextLanes = NoLanes;
          var nextLanePriority = NoLanePriority;
          var expiredLanes = root2.expiredLanes;
          var suspendedLanes = root2.suspendedLanes;
          var pingedLanes = root2.pingedLanes;
          if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
          } else {
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
            if (nonIdlePendingLanes !== NoLanes) {
              var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
              if (nonIdleUnblockedLanes !== NoLanes) {
                nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                nextLanePriority = return_highestLanePriority;
              } else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) {
                  nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                  nextLanePriority = return_highestLanePriority;
                }
              }
            } else {
              var unblockedLanes = pendingLanes & ~suspendedLanes;
              if (unblockedLanes !== NoLanes) {
                nextLanes = getHighestPriorityLanes(unblockedLanes);
                nextLanePriority = return_highestLanePriority;
              } else {
                if (pingedLanes !== NoLanes) {
                  nextLanes = getHighestPriorityLanes(pingedLanes);
                  nextLanePriority = return_highestLanePriority;
                }
              }
            }
          }
          if (nextLanes === NoLanes) {
            return NoLanes;
          }
          nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes);
          if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
          // bother waiting until the root is complete.
          (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;
            if (nextLanePriority <= wipLanePriority) {
              return wipLanes;
            } else {
              return_highestLanePriority = nextLanePriority;
            }
          }
          var entangledLanes = root2.entangledLanes;
          if (entangledLanes !== NoLanes) {
            var entanglements = root2.entanglements;
            var lanes = nextLanes & entangledLanes;
            while (lanes > 0) {
              var index3 = pickArbitraryLaneIndex(lanes);
              var lane = 1 << index3;
              nextLanes |= entanglements[index3];
              lanes &= ~lane;
            }
          }
          return nextLanes;
        }
        function getMostRecentEventTime(root2, lanes) {
          var eventTimes = root2.eventTimes;
          var mostRecentEventTime = NoTimestamp;
          while (lanes > 0) {
            var index3 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index3;
            var eventTime = eventTimes[index3];
            if (eventTime > mostRecentEventTime) {
              mostRecentEventTime = eventTime;
            }
            lanes &= ~lane;
          }
          return mostRecentEventTime;
        }
        function computeExpirationTime(lane, currentTime) {
          getHighestPriorityLanes(lane);
          var priority2 = return_highestLanePriority;
          if (priority2 >= InputContinuousLanePriority) {
            return currentTime + 250;
          } else if (priority2 >= TransitionPriority) {
            return currentTime + 5e3;
          } else {
            return NoTimestamp;
          }
        }
        function markStarvedLanesAsExpired(root2, currentTime) {
          var pendingLanes = root2.pendingLanes;
          var suspendedLanes = root2.suspendedLanes;
          var pingedLanes = root2.pingedLanes;
          var expirationTimes = root2.expirationTimes;
          var lanes = pendingLanes;
          while (lanes > 0) {
            var index3 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index3;
            var expirationTime = expirationTimes[index3];
            if (expirationTime === NoTimestamp) {
              if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) {
                expirationTimes[index3] = computeExpirationTime(lane, currentTime);
              }
            } else if (expirationTime <= currentTime) {
              root2.expiredLanes |= lane;
            }
            lanes &= ~lane;
          }
        }
        function getLanesToRetrySynchronouslyOnError(root2) {
          var everythingButOffscreen = root2.pendingLanes & ~OffscreenLane;
          if (everythingButOffscreen !== NoLanes) {
            return everythingButOffscreen;
          }
          if (everythingButOffscreen & OffscreenLane) {
            return OffscreenLane;
          }
          return NoLanes;
        }
        function returnNextLanesPriority() {
          return return_highestLanePriority;
        }
        function includesNonIdleWork(lanes) {
          return (lanes & NonIdleLanes) !== NoLanes;
        }
        function includesOnlyRetries(lanes) {
          return (lanes & RetryLanes) === lanes;
        }
        function includesOnlyTransitions(lanes) {
          return (lanes & TransitionLanes) === lanes;
        }
        function findUpdateLane(lanePriority, wipLanes) {
          switch (lanePriority) {
            case NoLanePriority:
              break;
            case SyncLanePriority:
              return SyncLane;
            case SyncBatchedLanePriority:
              return SyncBatchedLane;
            case InputDiscreteLanePriority: {
              var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
              if (_lane === NoLane) {
                return findUpdateLane(InputContinuousLanePriority, wipLanes);
              }
              return _lane;
            }
            case InputContinuousLanePriority: {
              var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
              if (_lane2 === NoLane) {
                return findUpdateLane(DefaultLanePriority, wipLanes);
              }
              return _lane2;
            }
            case DefaultLanePriority: {
              var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
              if (_lane3 === NoLane) {
                _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                if (_lane3 === NoLane) {
                  _lane3 = pickArbitraryLane(DefaultLanes);
                }
              }
              return _lane3;
            }
            case TransitionPriority:
            case RetryLanePriority:
              break;
            case IdleLanePriority:
              var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
              if (lane === NoLane) {
                lane = pickArbitraryLane(IdleLanes);
              }
              return lane;
          }
          {
            {
              throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
            }
          }
        }
        function findTransitionLane(wipLanes, pendingLanes) {
          var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
          if (lane === NoLane) {
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
            if (lane === NoLane) {
              lane = pickArbitraryLane(TransitionLanes);
            }
          }
          return lane;
        }
        function findRetryLane(wipLanes) {
          var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
          if (lane === NoLane) {
            lane = pickArbitraryLane(RetryLanes);
          }
          return lane;
        }
        function getHighestPriorityLane(lanes) {
          return lanes & -lanes;
        }
        function getLowestPriorityLane(lanes) {
          var index3 = 31 - clz32(lanes);
          return index3 < 0 ? NoLanes : 1 << index3;
        }
        function getEqualOrHigherPriorityLanes(lanes) {
          return (getLowestPriorityLane(lanes) << 1) - 1;
        }
        function pickArbitraryLane(lanes) {
          return getHighestPriorityLane(lanes);
        }
        function pickArbitraryLaneIndex(lanes) {
          return 31 - clz32(lanes);
        }
        function laneToIndex(lane) {
          return pickArbitraryLaneIndex(lane);
        }
        function includesSomeLane(a4, b10) {
          return (a4 & b10) !== NoLanes;
        }
        function isSubsetOfLanes(set2, subset) {
          return (set2 & subset) === subset;
        }
        function mergeLanes(a4, b10) {
          return a4 | b10;
        }
        function removeLanes(set2, subset) {
          return set2 & ~subset;
        }
        function laneToLanes(lane) {
          return lane;
        }
        function createLaneMap(initial) {
          var laneMap = [];
          for (var i2 = 0; i2 < TotalLanes; i2++) {
            laneMap.push(initial);
          }
          return laneMap;
        }
        function markRootUpdated(root2, updateLane, eventTime) {
          root2.pendingLanes |= updateLane;
          var higherPriorityLanes = updateLane - 1;
          root2.suspendedLanes &= higherPriorityLanes;
          root2.pingedLanes &= higherPriorityLanes;
          var eventTimes = root2.eventTimes;
          var index3 = laneToIndex(updateLane);
          eventTimes[index3] = eventTime;
        }
        function markRootSuspended(root2, suspendedLanes) {
          root2.suspendedLanes |= suspendedLanes;
          root2.pingedLanes &= ~suspendedLanes;
          var expirationTimes = root2.expirationTimes;
          var lanes = suspendedLanes;
          while (lanes > 0) {
            var index3 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index3;
            expirationTimes[index3] = NoTimestamp;
            lanes &= ~lane;
          }
        }
        function markRootPinged(root2, pingedLanes, eventTime) {
          root2.pingedLanes |= root2.suspendedLanes & pingedLanes;
        }
        function hasDiscreteLanes(lanes) {
          return (lanes & InputDiscreteLanes) !== NoLanes;
        }
        function markRootMutableRead(root2, updateLane) {
          root2.mutableReadLanes |= updateLane & root2.pendingLanes;
        }
        function markRootFinished(root2, remainingLanes) {
          var noLongerPendingLanes = root2.pendingLanes & ~remainingLanes;
          root2.pendingLanes = remainingLanes;
          root2.suspendedLanes = 0;
          root2.pingedLanes = 0;
          root2.expiredLanes &= remainingLanes;
          root2.mutableReadLanes &= remainingLanes;
          root2.entangledLanes &= remainingLanes;
          var entanglements = root2.entanglements;
          var eventTimes = root2.eventTimes;
          var expirationTimes = root2.expirationTimes;
          var lanes = noLongerPendingLanes;
          while (lanes > 0) {
            var index3 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index3;
            entanglements[index3] = NoLanes;
            eventTimes[index3] = NoTimestamp;
            expirationTimes[index3] = NoTimestamp;
            lanes &= ~lane;
          }
        }
        function markRootEntangled(root2, entangledLanes) {
          root2.entangledLanes |= entangledLanes;
          var entanglements = root2.entanglements;
          var lanes = entangledLanes;
          while (lanes > 0) {
            var index3 = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index3;
            entanglements[index3] |= entangledLanes;
            lanes &= ~lane;
          }
        }
        var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback;
        var log2 = Math.log;
        var LN2 = Math.LN2;
        function clz32Fallback(lanes) {
          if (lanes === 0) {
            return 32;
          }
          return 31 - (log2(lanes) / LN2 | 0) | 0;
        }
        var Scheduler_runWithPriority = Scheduler$1.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler$1.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler$1.unstable_cancelCallback, Scheduler_shouldYield = Scheduler$1.unstable_shouldYield, Scheduler_requestPaint = Scheduler$1.unstable_requestPaint, Scheduler_now$1 = Scheduler$1.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler$1.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler$1.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler$1.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler$1.unstable_NormalPriority, Scheduler_LowPriority = Scheduler$1.unstable_LowPriority, Scheduler_IdlePriority = Scheduler$1.unstable_IdlePriority;
        {
          if (!(tracing2.__interactionsRef != null && tracing2.__interactionsRef.current != null)) {
            {
              throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
            }
          }
        }
        var fakeCallbackNode = {};
        var ImmediatePriority$1 = 99;
        var UserBlockingPriority$1 = 98;
        var NormalPriority$1 = 97;
        var LowPriority$1 = 96;
        var IdlePriority$1 = 95;
        var NoPriority$1 = 90;
        var shouldYield = Scheduler_shouldYield;
        var requestPaint = (
          // Fall back gracefully if we're running an older version of Scheduler.
          Scheduler_requestPaint !== void 0 ? Scheduler_requestPaint : function() {
          }
        );
        var syncQueue = null;
        var immediateQueueCallbackNode = null;
        var isFlushingSyncQueue = false;
        var initialTimeMs$1 = Scheduler_now$1();
        var now2 = initialTimeMs$1 < 1e4 ? Scheduler_now$1 : function() {
          return Scheduler_now$1() - initialTimeMs$1;
        };
        function getCurrentPriorityLevel() {
          switch (Scheduler_getCurrentPriorityLevel()) {
            case Scheduler_ImmediatePriority:
              return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
              return UserBlockingPriority$1;
            case Scheduler_NormalPriority:
              return NormalPriority$1;
            case Scheduler_LowPriority:
              return LowPriority$1;
            case Scheduler_IdlePriority:
              return IdlePriority$1;
            default: {
              {
                throw Error("Unknown priority level.");
              }
            }
          }
        }
        function reactPriorityToSchedulerPriority(reactPriorityLevel) {
          switch (reactPriorityLevel) {
            case ImmediatePriority$1:
              return Scheduler_ImmediatePriority;
            case UserBlockingPriority$1:
              return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
              return Scheduler_NormalPriority;
            case LowPriority$1:
              return Scheduler_LowPriority;
            case IdlePriority$1:
              return Scheduler_IdlePriority;
            default: {
              {
                throw Error("Unknown priority level.");
              }
            }
          }
        }
        function runWithPriority(reactPriorityLevel, fn2) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_runWithPriority(priorityLevel, fn2);
        }
        function scheduleCallback(reactPriorityLevel, callback, options2) {
          var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
          return Scheduler_scheduleCallback(priorityLevel, callback, options2);
        }
        function scheduleSyncCallback(callback) {
          if (syncQueue === null) {
            syncQueue = [callback];
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
          } else {
            syncQueue.push(callback);
          }
          return fakeCallbackNode;
        }
        function cancelCallback(callbackNode) {
          if (callbackNode !== fakeCallbackNode) {
            Scheduler_cancelCallback(callbackNode);
          }
        }
        function flushSyncCallbackQueue() {
          if (immediateQueueCallbackNode !== null) {
            var node2 = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node2);
          }
          flushSyncCallbackQueueImpl();
        }
        function flushSyncCallbackQueueImpl() {
          if (!isFlushingSyncQueue && syncQueue !== null) {
            isFlushingSyncQueue = true;
            var i2 = 0;
            {
              try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority(ImmediatePriority$1, function() {
                  for (; i2 < _queue.length; i2++) {
                    var callback = _queue[i2];
                    do {
                      callback = callback(_isSync2);
                    } while (callback !== null);
                  }
                });
                syncQueue = null;
              } catch (error3) {
                if (syncQueue !== null) {
                  syncQueue = syncQueue.slice(i2 + 1);
                }
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error3;
              } finally {
                isFlushingSyncQueue = false;
              }
            }
          }
        }
        var ReactVersion = "17.0.2";
        var NoMode = 0;
        var StrictMode = 1;
        var BlockingMode = 2;
        var ConcurrentMode = 4;
        var ProfileMode = 8;
        var DebugTracingMode = 16;
        var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
        var NoTransition = 0;
        function requestCurrentTransition() {
          return ReactCurrentBatchConfig.transition;
        }
        function is3(x3, y4) {
          return x3 === y4 && (x3 !== 0 || 1 / x3 === 1 / y4) || x3 !== x3 && y4 !== y4;
        }
        var objectIs2 = typeof Object.is === "function" ? Object.is : is3;
        var hasOwnProperty2 = Object.prototype.hasOwnProperty;
        function shallowEqual(objA, objB) {
          if (objectIs2(objA, objB)) {
            return true;
          }
          if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
            return false;
          }
          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);
          if (keysA.length !== keysB.length) {
            return false;
          }
          for (var i2 = 0; i2 < keysA.length; i2++) {
            if (!hasOwnProperty2.call(objB, keysA[i2]) || !objectIs2(objA[keysA[i2]], objB[keysA[i2]])) {
              return false;
            }
          }
          return true;
        }
        function describeFiber(fiber) {
          fiber._debugOwner ? fiber._debugOwner.type : null;
          fiber._debugSource;
          switch (fiber.tag) {
            case HostComponent:
              return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
              return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
              return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
              return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
              return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
              return describeFunctionComponentFrame(fiber.type.render);
            case Block:
              return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
              return describeClassComponentFrame(fiber.type);
            default:
              return "";
          }
        }
        function getStackByFiberInDevAndProd(workInProgress2) {
          try {
            var info = "";
            var node2 = workInProgress2;
            do {
              info += describeFiber(node2);
              node2 = node2.return;
            } while (node2);
            return info;
          } catch (x3) {
            return "\nError generating stack: " + x3.message + "\n" + x3.stack;
          }
        }
        var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
        var current = null;
        var isRendering = false;
        function getCurrentFiberOwnerNameInDevOrNull() {
          {
            if (current === null) {
              return null;
            }
            var owner = current._debugOwner;
            if (owner !== null && typeof owner !== "undefined") {
              return getComponentName(owner.type);
            }
          }
          return null;
        }
        function getCurrentFiberStackInDev() {
          {
            if (current === null) {
              return "";
            }
            return getStackByFiberInDevAndProd(current);
          }
        }
        function resetCurrentFiber() {
          {
            ReactDebugCurrentFrame$1.getCurrentStack = null;
            current = null;
            isRendering = false;
          }
        }
        function setCurrentFiber(fiber) {
          {
            ReactDebugCurrentFrame$1.getCurrentStack = getCurrentFiberStackInDev;
            current = fiber;
            isRendering = false;
          }
        }
        function setIsRendering(rendering) {
          {
            isRendering = rendering;
          }
        }
        function getIsRendering() {
          {
            return isRendering;
          }
        }
        var ReactStrictModeWarnings = {
          recordUnsafeLifecycleWarnings: function(fiber, instance) {
          },
          flushPendingUnsafeLifecycleWarnings: function() {
          },
          recordLegacyContextWarning: function(fiber, instance) {
          },
          flushLegacyContextWarning: function() {
          },
          discardPendingWarnings: function() {
          }
        };
        {
          var findStrictRoot = function(fiber) {
            var maybeStrictRoot = null;
            var node2 = fiber;
            while (node2 !== null) {
              if (node2.mode & StrictMode) {
                maybeStrictRoot = node2;
              }
              node2 = node2.return;
            }
            return maybeStrictRoot;
          };
          var setToSortedString = function(set2) {
            var array2 = [];
            set2.forEach(function(value) {
              array2.push(value);
            });
            return array2.sort().join(", ");
          };
          var pendingComponentWillMountWarnings = [];
          var pendingUNSAFE_ComponentWillMountWarnings = [];
          var pendingComponentWillReceivePropsWarnings = [];
          var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
          var pendingComponentWillUpdateWarnings = [];
          var pendingUNSAFE_ComponentWillUpdateWarnings = [];
          var didWarnAboutUnsafeLifecycles = /* @__PURE__ */ new Set();
          ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
            if (didWarnAboutUnsafeLifecycles.has(fiber.type)) {
              return;
            }
            if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
            instance.componentWillMount.__suppressDeprecationWarning !== true) {
              pendingComponentWillMountWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === "function") {
              pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
            }
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
              pendingComponentWillReceivePropsWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
            }
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
              pendingComponentWillUpdateWarnings.push(fiber);
            }
            if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === "function") {
              pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
            }
          };
          ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
            var componentWillMountUniqueNames = /* @__PURE__ */ new Set();
            if (pendingComponentWillMountWarnings.length > 0) {
              pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillMountWarnings = [];
            }
            var UNSAFE_componentWillMountUniqueNames = /* @__PURE__ */ new Set();
            if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
              pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillMountWarnings = [];
            }
            var componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
            if (pendingComponentWillReceivePropsWarnings.length > 0) {
              pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillReceivePropsWarnings = [];
            }
            var UNSAFE_componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
            if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
              pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            }
            var componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
            if (pendingComponentWillUpdateWarnings.length > 0) {
              pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingComponentWillUpdateWarnings = [];
            }
            var UNSAFE_componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
            if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
              pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
              });
              pendingUNSAFE_ComponentWillUpdateWarnings = [];
            }
            if (UNSAFE_componentWillMountUniqueNames.size > 0) {
              var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
              error2("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
            }
            if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
              error2("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
            }
            if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
              error2("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
            }
            if (componentWillMountUniqueNames.size > 0) {
              var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
              warn2("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
            }
            if (componentWillReceivePropsUniqueNames.size > 0) {
              var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
              warn2("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
            }
            if (componentWillUpdateUniqueNames.size > 0) {
              var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
              warn2("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
            }
          };
          var pendingLegacyContextWarning = /* @__PURE__ */ new Map();
          var didWarnAboutLegacyContext = /* @__PURE__ */ new Set();
          ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
            var strictRoot = findStrictRoot(fiber);
            if (strictRoot === null) {
              error2("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
              return;
            }
            if (didWarnAboutLegacyContext.has(fiber.type)) {
              return;
            }
            var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
            if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
              if (warningsForRoot === void 0) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
              }
              warningsForRoot.push(fiber);
            }
          };
          ReactStrictModeWarnings.flushLegacyContextWarning = function() {
            pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
              if (fiberArray.length === 0) {
                return;
              }
              var firstFiber = fiberArray[0];
              var uniqueNames = /* @__PURE__ */ new Set();
              fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
              });
              var sortedNames = setToSortedString(uniqueNames);
              try {
                setCurrentFiber(firstFiber);
                error2("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
              } finally {
                resetCurrentFiber();
              }
            });
          };
          ReactStrictModeWarnings.discardPendingWarnings = function() {
            pendingComponentWillMountWarnings = [];
            pendingUNSAFE_ComponentWillMountWarnings = [];
            pendingComponentWillReceivePropsWarnings = [];
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
            pendingComponentWillUpdateWarnings = [];
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
            pendingLegacyContextWarning = /* @__PURE__ */ new Map();
          };
        }
        function resolveDefaultProps(Component2, baseProps2) {
          if (Component2 && Component2.defaultProps) {
            var props2 = _assign2({}, baseProps2);
            var defaultProps2 = Component2.defaultProps;
            for (var propName in defaultProps2) {
              if (props2[propName] === void 0) {
                props2[propName] = defaultProps2[propName];
              }
            }
            return props2;
          }
          return baseProps2;
        }
        var MAX_SIGNED_31_BIT_INT = 1073741823;
        var valueCursor = createCursor(null);
        var rendererSigil;
        {
          rendererSigil = {};
        }
        var currentlyRenderingFiber = null;
        var lastContextDependency = null;
        var lastContextWithAllBitsObserved = null;
        var isDisallowedContextReadInDEV = false;
        function resetContextDependencies() {
          currentlyRenderingFiber = null;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          {
            isDisallowedContextReadInDEV = false;
          }
        }
        function enterDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = true;
          }
        }
        function exitDisallowedContextReadInDEV() {
          {
            isDisallowedContextReadInDEV = false;
          }
        }
        function pushProvider(providerFiber, nextValue) {
          var context = providerFiber.type._context;
          {
            push(valueCursor, context._currentValue2, providerFiber);
            context._currentValue2 = nextValue;
            {
              if (context._currentRenderer2 !== void 0 && context._currentRenderer2 !== null && context._currentRenderer2 !== rendererSigil) {
                error2("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
              }
              context._currentRenderer2 = rendererSigil;
            }
          }
        }
        function popProvider(providerFiber) {
          var currentValue = valueCursor.current;
          pop(valueCursor, providerFiber);
          var context = providerFiber.type._context;
          {
            context._currentValue2 = currentValue;
          }
        }
        function calculateChangedBits(context, newValue, oldValue) {
          if (objectIs2(oldValue, newValue)) {
            return 0;
          } else {
            var changedBits = typeof context._calculateChangedBits === "function" ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            {
              if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) {
                error2("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
              }
            }
            return changedBits | 0;
          }
        }
        function scheduleWorkOnParentPath(parent2, renderLanes2) {
          var node2 = parent2;
          while (node2 !== null) {
            var alternate = node2.alternate;
            if (!isSubsetOfLanes(node2.childLanes, renderLanes2)) {
              node2.childLanes = mergeLanes(node2.childLanes, renderLanes2);
              if (alternate !== null) {
                alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes2);
              }
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes2)) {
              alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes2);
            } else {
              break;
            }
            node2 = node2.return;
          }
        }
        function propagateContextChange(workInProgress2, context, changedBits, renderLanes2) {
          var fiber = workInProgress2.child;
          if (fiber !== null) {
            fiber.return = workInProgress2;
          }
          while (fiber !== null) {
            var nextFiber = void 0;
            var list = fiber.dependencies;
            if (list !== null) {
              nextFiber = fiber.child;
              var dependency = list.firstContext;
              while (dependency !== null) {
                if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                  if (fiber.tag === ClassComponent) {
                    var update2 = createUpdate2(NoTimestamp, pickArbitraryLane(renderLanes2));
                    update2.tag = ForceUpdate;
                    enqueueUpdate(fiber, update2);
                  }
                  fiber.lanes = mergeLanes(fiber.lanes, renderLanes2);
                  var alternate = fiber.alternate;
                  if (alternate !== null) {
                    alternate.lanes = mergeLanes(alternate.lanes, renderLanes2);
                  }
                  scheduleWorkOnParentPath(fiber.return, renderLanes2);
                  list.lanes = mergeLanes(list.lanes, renderLanes2);
                  break;
                }
                dependency = dependency.next;
              }
            } else if (fiber.tag === ContextProvider) {
              nextFiber = fiber.type === workInProgress2.type ? null : fiber.child;
            } else {
              nextFiber = fiber.child;
            }
            if (nextFiber !== null) {
              nextFiber.return = fiber;
            } else {
              nextFiber = fiber;
              while (nextFiber !== null) {
                if (nextFiber === workInProgress2) {
                  nextFiber = null;
                  break;
                }
                var sibling = nextFiber.sibling;
                if (sibling !== null) {
                  sibling.return = nextFiber.return;
                  nextFiber = sibling;
                  break;
                }
                nextFiber = nextFiber.return;
              }
            }
            fiber = nextFiber;
          }
        }
        function prepareToReadContext(workInProgress2, renderLanes2) {
          currentlyRenderingFiber = workInProgress2;
          lastContextDependency = null;
          lastContextWithAllBitsObserved = null;
          var dependencies2 = workInProgress2.dependencies;
          if (dependencies2 !== null) {
            var firstContext = dependencies2.firstContext;
            if (firstContext !== null) {
              if (includesSomeLane(dependencies2.lanes, renderLanes2)) {
                markWorkInProgressReceivedUpdate();
              }
              dependencies2.firstContext = null;
            }
          }
        }
        function readContext(context, observedBits) {
          {
            if (isDisallowedContextReadInDEV) {
              error2("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            }
          }
          if (lastContextWithAllBitsObserved === context)
            ;
          else if (observedBits === false || observedBits === 0)
            ;
          else {
            var resolvedObservedBits;
            if (typeof observedBits !== "number" || observedBits === MAX_SIGNED_31_BIT_INT) {
              lastContextWithAllBitsObserved = context;
              resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else {
              resolvedObservedBits = observedBits;
            }
            var contextItem = {
              context,
              observedBits: resolvedObservedBits,
              next: null
            };
            if (lastContextDependency === null) {
              if (!(currentlyRenderingFiber !== null)) {
                {
                  throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                }
              }
              lastContextDependency = contextItem;
              currentlyRenderingFiber.dependencies = {
                lanes: NoLanes,
                firstContext: contextItem,
                responders: null
              };
            } else {
              lastContextDependency = lastContextDependency.next = contextItem;
            }
          }
          return context._currentValue2;
        }
        var UpdateState = 0;
        var ReplaceState = 1;
        var ForceUpdate = 2;
        var CaptureUpdate = 3;
        var hasForceUpdate = false;
        var didWarnUpdateInsideUpdate;
        var currentlyProcessingQueue;
        {
          didWarnUpdateInsideUpdate = false;
          currentlyProcessingQueue = null;
        }
        function initializeUpdateQueue(fiber) {
          var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
              pending: null
            },
            effects: null
          };
          fiber.updateQueue = queue;
        }
        function cloneUpdateQueue(current2, workInProgress2) {
          var queue = workInProgress2.updateQueue;
          var currentQueue = current2.updateQueue;
          if (queue === currentQueue) {
            var clone2 = {
              baseState: currentQueue.baseState,
              firstBaseUpdate: currentQueue.firstBaseUpdate,
              lastBaseUpdate: currentQueue.lastBaseUpdate,
              shared: currentQueue.shared,
              effects: currentQueue.effects
            };
            workInProgress2.updateQueue = clone2;
          }
        }
        function createUpdate2(eventTime, lane) {
          var update2 = {
            eventTime,
            lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
          };
          return update2;
        }
        function enqueueUpdate(fiber, update2) {
          var updateQueue2 = fiber.updateQueue;
          if (updateQueue2 === null) {
            return;
          }
          var sharedQueue = updateQueue2.shared;
          var pending = sharedQueue.pending;
          if (pending === null) {
            update2.next = update2;
          } else {
            update2.next = pending.next;
            pending.next = update2;
          }
          sharedQueue.pending = update2;
          {
            if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
              error2("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
              didWarnUpdateInsideUpdate = true;
            }
          }
        }
        function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
          var queue = workInProgress2.updateQueue;
          var current2 = workInProgress2.alternate;
          if (current2 !== null) {
            var currentQueue = current2.updateQueue;
            if (queue === currentQueue) {
              var newFirst = null;
              var newLast = null;
              var firstBaseUpdate = queue.firstBaseUpdate;
              if (firstBaseUpdate !== null) {
                var update2 = firstBaseUpdate;
                do {
                  var clone2 = {
                    eventTime: update2.eventTime,
                    lane: update2.lane,
                    tag: update2.tag,
                    payload: update2.payload,
                    callback: update2.callback,
                    next: null
                  };
                  if (newLast === null) {
                    newFirst = newLast = clone2;
                  } else {
                    newLast.next = clone2;
                    newLast = clone2;
                  }
                  update2 = update2.next;
                } while (update2 !== null);
                if (newLast === null) {
                  newFirst = newLast = capturedUpdate;
                } else {
                  newLast.next = capturedUpdate;
                  newLast = capturedUpdate;
                }
              } else {
                newFirst = newLast = capturedUpdate;
              }
              queue = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: currentQueue.shared,
                effects: currentQueue.effects
              };
              workInProgress2.updateQueue = queue;
              return;
            }
          }
          var lastBaseUpdate = queue.lastBaseUpdate;
          if (lastBaseUpdate === null) {
            queue.firstBaseUpdate = capturedUpdate;
          } else {
            lastBaseUpdate.next = capturedUpdate;
          }
          queue.lastBaseUpdate = capturedUpdate;
        }
        function getStateFromUpdate(workInProgress2, queue, update2, prevState, nextProps, instance) {
          switch (update2.tag) {
            case ReplaceState: {
              var payload = update2.payload;
              if (typeof payload === "function") {
                {
                  enterDisallowedContextReadInDEV();
                }
                var nextState = payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
                return nextState;
              }
              return payload;
            }
            case CaptureUpdate: {
              workInProgress2.flags = workInProgress2.flags & ~ShouldCapture | DidCapture;
            }
            case UpdateState: {
              var _payload = update2.payload;
              var partialState;
              if (typeof _payload === "function") {
                {
                  enterDisallowedContextReadInDEV();
                }
                partialState = _payload.call(instance, prevState, nextProps);
                {
                  exitDisallowedContextReadInDEV();
                }
              } else {
                partialState = _payload;
              }
              if (partialState === null || partialState === void 0) {
                return prevState;
              }
              return _assign2({}, prevState, partialState);
            }
            case ForceUpdate: {
              hasForceUpdate = true;
              return prevState;
            }
          }
          return prevState;
        }
        function processUpdateQueue(workInProgress2, props2, instance, renderLanes2) {
          var queue = workInProgress2.updateQueue;
          hasForceUpdate = false;
          {
            currentlyProcessingQueue = queue.shared;
          }
          var firstBaseUpdate = queue.firstBaseUpdate;
          var lastBaseUpdate = queue.lastBaseUpdate;
          var pendingQueue = queue.shared.pending;
          if (pendingQueue !== null) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            if (lastBaseUpdate === null) {
              firstBaseUpdate = firstPendingUpdate;
            } else {
              lastBaseUpdate.next = firstPendingUpdate;
            }
            lastBaseUpdate = lastPendingUpdate;
            var current2 = workInProgress2.alternate;
            if (current2 !== null) {
              var currentQueue = current2.updateQueue;
              var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
              if (currentLastBaseUpdate !== lastBaseUpdate) {
                if (currentLastBaseUpdate === null) {
                  currentQueue.firstBaseUpdate = firstPendingUpdate;
                } else {
                  currentLastBaseUpdate.next = firstPendingUpdate;
                }
                currentQueue.lastBaseUpdate = lastPendingUpdate;
              }
            }
          }
          if (firstBaseUpdate !== null) {
            var newState = queue.baseState;
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update2 = firstBaseUpdate;
            do {
              var updateLane = update2.lane;
              var updateEventTime = update2.eventTime;
              if (!isSubsetOfLanes(renderLanes2, updateLane)) {
                var clone2 = {
                  eventTime: updateEventTime,
                  lane: updateLane,
                  tag: update2.tag,
                  payload: update2.payload,
                  callback: update2.callback,
                  next: null
                };
                if (newLastBaseUpdate === null) {
                  newFirstBaseUpdate = newLastBaseUpdate = clone2;
                  newBaseState = newState;
                } else {
                  newLastBaseUpdate = newLastBaseUpdate.next = clone2;
                }
                newLanes = mergeLanes(newLanes, updateLane);
              } else {
                if (newLastBaseUpdate !== null) {
                  var _clone = {
                    eventTime: updateEventTime,
                    // This update is going to be committed so we never want uncommit
                    // it. Using NoLane works because 0 is a subset of all bitmasks, so
                    // this will never be skipped by the check above.
                    lane: NoLane,
                    tag: update2.tag,
                    payload: update2.payload,
                    callback: update2.callback,
                    next: null
                  };
                  newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                }
                newState = getStateFromUpdate(workInProgress2, queue, update2, newState, props2, instance);
                var callback = update2.callback;
                if (callback !== null) {
                  workInProgress2.flags |= Callback;
                  var effects = queue.effects;
                  if (effects === null) {
                    queue.effects = [update2];
                  } else {
                    effects.push(update2);
                  }
                }
              }
              update2 = update2.next;
              if (update2 === null) {
                pendingQueue = queue.shared.pending;
                if (pendingQueue === null) {
                  break;
                } else {
                  var _lastPendingUpdate = pendingQueue;
                  var _firstPendingUpdate = _lastPendingUpdate.next;
                  _lastPendingUpdate.next = null;
                  update2 = _firstPendingUpdate;
                  queue.lastBaseUpdate = _lastPendingUpdate;
                  queue.shared.pending = null;
                }
              }
            } while (true);
            if (newLastBaseUpdate === null) {
              newBaseState = newState;
            }
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate;
            markSkippedUpdateLanes(newLanes);
            workInProgress2.lanes = newLanes;
            workInProgress2.memoizedState = newState;
          }
          {
            currentlyProcessingQueue = null;
          }
        }
        function callCallback(callback, context) {
          if (!(typeof callback === "function")) {
            {
              throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
            }
          }
          callback.call(context);
        }
        function resetHasForceUpdateBeforeProcessing() {
          hasForceUpdate = false;
        }
        function checkHasForceUpdateAfterProcessing() {
          return hasForceUpdate;
        }
        function commitUpdateQueue(finishedWork, finishedQueue, instance) {
          var effects = finishedQueue.effects;
          finishedQueue.effects = null;
          if (effects !== null) {
            for (var i2 = 0; i2 < effects.length; i2++) {
              var effect2 = effects[i2];
              var callback = effect2.callback;
              if (callback !== null) {
                effect2.callback = null;
                callCallback(callback, instance);
              }
            }
          }
        }
        var fakeInternalInstance = {};
        var isArray2 = Array.isArray;
        var emptyRefsObject = new React2.Component().refs;
        var didWarnAboutStateAssignmentForComponent;
        var didWarnAboutUninitializedState;
        var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
        var didWarnAboutLegacyLifecyclesAndDerivedState;
        var didWarnAboutUndefinedDerivedState;
        var warnOnUndefinedDerivedState;
        var warnOnInvalidCallback;
        var didWarnAboutDirectlyAssigningPropsToState;
        var didWarnAboutContextTypeAndContextTypes;
        var didWarnAboutInvalidateContextType;
        {
          didWarnAboutStateAssignmentForComponent = /* @__PURE__ */ new Set();
          didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
          didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
          didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
          didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
          didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
          didWarnAboutContextTypeAndContextTypes = /* @__PURE__ */ new Set();
          didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
          var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
          warnOnInvalidCallback = function(callback, callerName) {
            if (callback === null || typeof callback === "function") {
              return;
            }
            var key = callerName + "_" + callback;
            if (!didWarnOnInvalidCallback.has(key)) {
              didWarnOnInvalidCallback.add(key);
              error2("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
            }
          };
          warnOnUndefinedDerivedState = function(type2, partialState) {
            if (partialState === void 0) {
              var componentName = getComponentName(type2) || "Component";
              if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error2("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
              }
            }
          };
          Object.defineProperty(fakeInternalInstance, "_processChildContext", {
            enumerable: false,
            value: function() {
              {
                {
                  throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
                }
              }
            }
          });
          Object.freeze(fakeInternalInstance);
        }
        function applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, nextProps) {
          var prevState = workInProgress2.memoizedState;
          var partialState = getDerivedStateFromProps(nextProps, prevState);
          {
            warnOnUndefinedDerivedState(ctor, partialState);
          }
          var memoizedState = partialState === null || partialState === void 0 ? prevState : _assign2({}, prevState, partialState);
          workInProgress2.memoizedState = memoizedState;
          if (workInProgress2.lanes === NoLanes) {
            var updateQueue2 = workInProgress2.updateQueue;
            updateQueue2.baseState = memoizedState;
          }
        }
        var classComponentUpdater = {
          isMounted,
          enqueueSetState: function(inst, payload, callback) {
            var fiber = get9(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update2 = createUpdate2(eventTime, lane);
            update2.payload = payload;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "setState");
              }
              update2.callback = callback;
            }
            enqueueUpdate(fiber, update2);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          },
          enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get9(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update2 = createUpdate2(eventTime, lane);
            update2.tag = ReplaceState;
            update2.payload = payload;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "replaceState");
              }
              update2.callback = callback;
            }
            enqueueUpdate(fiber, update2);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          },
          enqueueForceUpdate: function(inst, callback) {
            var fiber = get9(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update2 = createUpdate2(eventTime, lane);
            update2.tag = ForceUpdate;
            if (callback !== void 0 && callback !== null) {
              {
                warnOnInvalidCallback(callback, "forceUpdate");
              }
              update2.callback = callback;
            }
            enqueueUpdate(fiber, update2);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          }
        };
        function checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext) {
          var instance = workInProgress2.stateNode;
          if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            {
              if (shouldUpdate === void 0) {
                error2("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || "Component");
              }
            }
            return shouldUpdate;
          }
          if (ctor.prototype && ctor.prototype.isPureReactComponent) {
            return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
          }
          return true;
        }
        function checkClassInstance(workInProgress2, ctor, newProps) {
          var instance = workInProgress2.stateNode;
          {
            var name2 = getComponentName(ctor) || "Component";
            var renderPresent = instance.render;
            if (!renderPresent) {
              if (ctor.prototype && typeof ctor.prototype.render === "function") {
                error2("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name2);
              } else {
                error2("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name2);
              }
            }
            if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) {
              error2("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name2);
            }
            if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) {
              error2("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name2);
            }
            if (instance.propTypes) {
              error2("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name2);
            }
            if (instance.contextType) {
              error2("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name2);
            }
            {
              if (instance.contextTypes) {
                error2("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name2);
              }
              if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
                didWarnAboutContextTypeAndContextTypes.add(ctor);
                error2("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name2);
              }
            }
            if (typeof instance.componentShouldUpdate === "function") {
              error2("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name2);
            }
            if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") {
              error2("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || "A pure component");
            }
            if (typeof instance.componentDidUnmount === "function") {
              error2("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name2);
            }
            if (typeof instance.componentDidReceiveProps === "function") {
              error2("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name2);
            }
            if (typeof instance.componentWillRecieveProps === "function") {
              error2("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name2);
            }
            if (typeof instance.UNSAFE_componentWillRecieveProps === "function") {
              error2("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name2);
            }
            var hasMutatedProps = instance.props !== newProps;
            if (instance.props !== void 0 && hasMutatedProps) {
              error2("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name2, name2);
            }
            if (instance.defaultProps) {
              error2("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name2, name2);
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
              didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
              error2("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
            }
            if (typeof instance.getDerivedStateFromProps === "function") {
              error2("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name2);
            }
            if (typeof instance.getDerivedStateFromError === "function") {
              error2("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name2);
            }
            if (typeof ctor.getSnapshotBeforeUpdate === "function") {
              error2("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name2);
            }
            var _state = instance.state;
            if (_state && (typeof _state !== "object" || isArray2(_state))) {
              error2("%s.state: must be set to an object or null", name2);
            }
            if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") {
              error2("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name2);
            }
          }
        }
        function adoptClassInstance(workInProgress2, instance) {
          instance.updater = classComponentUpdater;
          workInProgress2.stateNode = instance;
          set(instance, workInProgress2);
          {
            instance._reactInternalInstance = fakeInternalInstance;
          }
        }
        function constructClassInstance(workInProgress2, ctor, props2) {
          var isLegacyContextConsumer = false;
          var unmaskedContext = emptyContextObject;
          var context = emptyContextObject;
          var contextType = ctor.contextType;
          {
            if ("contextType" in ctor) {
              var isValid2 = (
                // Allow null for conditional declaration
                contextType === null || contextType !== void 0 && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === void 0
              );
              if (!isValid2 && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === void 0) {
                  addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                } else if (typeof contextType !== "object") {
                  addendum = " However, it is set to a " + typeof contextType + ".";
                } else if (contextType.$$typeof === REACT_PROVIDER_TYPE) {
                  addendum = " Did you accidentally pass the Context.Provider instead?";
                } else if (contextType._context !== void 0) {
                  addendum = " Did you accidentally pass the Context.Consumer instead?";
                } else {
                  addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                }
                error2("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || "Component", addendum);
              }
            }
          }
          if (typeof contextType === "object" && contextType !== null) {
            context = readContext(contextType);
          } else {
            unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== void 0;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress2, unmaskedContext) : emptyContextObject;
          }
          var instance = new ctor(props2, context);
          var state = workInProgress2.memoizedState = instance.state !== null && instance.state !== void 0 ? instance.state : null;
          adoptClassInstance(workInProgress2, instance);
          {
            if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
              var componentName = getComponentName(ctor) || "Component";
              if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error2("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
              }
            }
            if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
              var foundWillMountName = null;
              var foundWillReceivePropsName = null;
              var foundWillUpdateName = null;
              if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) {
                foundWillMountName = "componentWillMount";
              } else if (typeof instance.UNSAFE_componentWillMount === "function") {
                foundWillMountName = "UNSAFE_componentWillMount";
              }
              if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) {
                foundWillReceivePropsName = "componentWillReceiveProps";
              } else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
                foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
              }
              if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) {
                foundWillUpdateName = "componentWillUpdate";
              } else if (typeof instance.UNSAFE_componentWillUpdate === "function") {
                foundWillUpdateName = "UNSAFE_componentWillUpdate";
              }
              if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                  didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                  error2("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
              }
            }
          }
          if (isLegacyContextConsumer) {
            cacheContext(workInProgress2, unmaskedContext, context);
          }
          return instance;
        }
        function callComponentWillMount(workInProgress2, instance) {
          var oldState = instance.state;
          if (typeof instance.componentWillMount === "function") {
            instance.componentWillMount();
          }
          if (typeof instance.UNSAFE_componentWillMount === "function") {
            instance.UNSAFE_componentWillMount();
          }
          if (oldState !== instance.state) {
            {
              error2("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress2.type) || "Component");
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }
        function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
          var oldState = instance.state;
          if (typeof instance.componentWillReceiveProps === "function") {
            instance.componentWillReceiveProps(newProps, nextContext);
          }
          if (typeof instance.UNSAFE_componentWillReceiveProps === "function") {
            instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
          }
          if (instance.state !== oldState) {
            {
              var componentName = getComponentName(workInProgress2.type) || "Component";
              if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error2("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
              }
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
          }
        }
        function mountClassInstance(workInProgress2, ctor, newProps, renderLanes2) {
          {
            checkClassInstance(workInProgress2, ctor, newProps);
          }
          var instance = workInProgress2.stateNode;
          instance.props = newProps;
          instance.state = workInProgress2.memoizedState;
          instance.refs = emptyRefsObject;
          initializeUpdateQueue(workInProgress2);
          var contextType = ctor.contextType;
          if (typeof contextType === "object" && contextType !== null) {
            instance.context = readContext(contextType);
          } else {
            var unmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            instance.context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          {
            if (instance.state === newProps) {
              var componentName = getComponentName(ctor) || "Component";
              if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error2("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
              }
            }
            if (workInProgress2.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, instance);
            }
            {
              ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress2, instance);
            }
          }
          processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
          instance.state = workInProgress2.memoizedState;
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress2.memoizedState;
          }
          if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress2, instance);
            processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
            instance.state = workInProgress2.memoizedState;
          }
          if (typeof instance.componentDidMount === "function") {
            workInProgress2.flags |= Update;
          }
        }
        function resumeMountClassInstance(workInProgress2, ctor, newProps, renderLanes2) {
          var instance = workInProgress2.stateNode;
          var oldProps = workInProgress2.memoizedProps;
          instance.props = oldProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;
          if (typeof contextType === "object" && contextType !== null) {
            nextContext = readContext(contextType);
          } else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            nextContext = getMaskedContext(workInProgress2, nextLegacyUnmaskedContext);
          }
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function";
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext);
            }
          }
          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress2.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
          newState = workInProgress2.memoizedState;
          if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.flags |= Update;
            }
            return false;
          }
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress2.memoizedState;
          }
          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
          if (shouldUpdate) {
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
              if (typeof instance.componentWillMount === "function") {
                instance.componentWillMount();
              }
              if (typeof instance.UNSAFE_componentWillMount === "function") {
                instance.UNSAFE_componentWillMount();
              }
            }
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.flags |= Update;
            }
          } else {
            if (typeof instance.componentDidMount === "function") {
              workInProgress2.flags |= Update;
            }
            workInProgress2.memoizedProps = newProps;
            workInProgress2.memoizedState = newState;
          }
          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }
        function updateClassInstance(current2, workInProgress2, ctor, newProps, renderLanes2) {
          var instance = workInProgress2.stateNode;
          cloneUpdateQueue(current2, workInProgress2);
          var unresolvedOldProps = workInProgress2.memoizedProps;
          var oldProps = workInProgress2.type === workInProgress2.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress2.type, unresolvedOldProps);
          instance.props = oldProps;
          var unresolvedNewProps = workInProgress2.pendingProps;
          var oldContext = instance.context;
          var contextType = ctor.contextType;
          var nextContext = emptyContextObject;
          if (typeof contextType === "object" && contextType !== null) {
            nextContext = readContext(contextType);
          } else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress2, ctor, true);
            nextContext = getMaskedContext(workInProgress2, nextUnmaskedContext);
          }
          var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
          var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function";
          if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) {
              callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext);
            }
          }
          resetHasForceUpdateBeforeProcessing();
          var oldState = workInProgress2.memoizedState;
          var newState = instance.state = oldState;
          processUpdateQueue(workInProgress2, newProps, instance, renderLanes2);
          newState = workInProgress2.memoizedState;
          if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            if (typeof instance.componentDidUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Update;
              }
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Snapshot;
              }
            }
            return false;
          }
          if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress2, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress2.memoizedState;
          }
          var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress2, ctor, oldProps, newProps, oldState, newState, nextContext);
          if (shouldUpdate) {
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
              if (typeof instance.componentWillUpdate === "function") {
                instance.componentWillUpdate(newProps, newState, nextContext);
              }
              if (typeof instance.UNSAFE_componentWillUpdate === "function") {
                instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
              }
            }
            if (typeof instance.componentDidUpdate === "function") {
              workInProgress2.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              workInProgress2.flags |= Snapshot;
            }
          } else {
            if (typeof instance.componentDidUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Update;
              }
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
              if (unresolvedOldProps !== current2.memoizedProps || oldState !== current2.memoizedState) {
                workInProgress2.flags |= Snapshot;
              }
            }
            workInProgress2.memoizedProps = newProps;
            workInProgress2.memoizedState = newState;
          }
          instance.props = newProps;
          instance.state = newState;
          instance.context = nextContext;
          return shouldUpdate;
        }
        var didWarnAboutMaps;
        var didWarnAboutGenerators;
        var didWarnAboutStringRefs;
        var ownerHasKeyUseWarning;
        var ownerHasFunctionTypeWarning;
        var warnForMissingKey = function(child, returnFiber) {
        };
        {
          didWarnAboutMaps = false;
          didWarnAboutGenerators = false;
          didWarnAboutStringRefs = {};
          ownerHasKeyUseWarning = {};
          ownerHasFunctionTypeWarning = {};
          warnForMissingKey = function(child, returnFiber) {
            if (child === null || typeof child !== "object") {
              return;
            }
            if (!child._store || child._store.validated || child.key != null) {
              return;
            }
            if (!(typeof child._store === "object")) {
              {
                throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            child._store.validated = true;
            var componentName = getComponentName(returnFiber.type) || "Component";
            if (ownerHasKeyUseWarning[componentName]) {
              return;
            }
            ownerHasKeyUseWarning[componentName] = true;
            error2('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
          };
        }
        var isArray$12 = Array.isArray;
        function coerceRef(returnFiber, current2, element) {
          var mixedRef = element.ref;
          if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            {
              if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
              // because these cannot be automatically converted to an arrow function
              // using a codemod. Therefore, we don't have to warn about string refs again.
              !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                  {
                    error2('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                  }
                  didWarnAboutStringRefs[componentName] = true;
                }
              }
            }
            if (element._owner) {
              var owner = element._owner;
              var inst;
              if (owner) {
                var ownerFiber = owner;
                if (!(ownerFiber.tag === ClassComponent)) {
                  {
                    throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                  }
                }
                inst = ownerFiber.stateNode;
              }
              if (!inst) {
                {
                  throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var stringRef = "" + mixedRef;
              if (current2 !== null && current2.ref !== null && typeof current2.ref === "function" && current2.ref._stringRef === stringRef) {
                return current2.ref;
              }
              var ref2 = function(value) {
                var refs = inst.refs;
                if (refs === emptyRefsObject) {
                  refs = inst.refs = {};
                }
                if (value === null) {
                  delete refs[stringRef];
                } else {
                  refs[stringRef] = value;
                }
              };
              ref2._stringRef = stringRef;
              return ref2;
            } else {
              if (!(typeof mixedRef === "string")) {
                {
                  throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                }
              }
              if (!element._owner) {
                {
                  throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
                }
              }
            }
          }
          return mixedRef;
        }
        function throwOnInvalidObjectType(returnFiber, newChild) {
          if (returnFiber.type !== "textarea") {
            {
              {
                throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : newChild) + "). If you meant to render a collection of children, use an array instead.");
              }
            }
          }
        }
        function warnOnFunctionType(returnFiber) {
          {
            var componentName = getComponentName(returnFiber.type) || "Component";
            if (ownerHasFunctionTypeWarning[componentName]) {
              return;
            }
            ownerHasFunctionTypeWarning[componentName] = true;
            error2("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
          }
        }
        function ChildReconciler(shouldTrackSideEffects) {
          function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) {
              return;
            }
            var last2 = returnFiber.lastEffect;
            if (last2 !== null) {
              last2.nextEffect = childToDelete;
              returnFiber.lastEffect = childToDelete;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            }
            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
          }
          function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) {
              return null;
            }
            var childToDelete = currentFirstChild;
            while (childToDelete !== null) {
              deleteChild(returnFiber, childToDelete);
              childToDelete = childToDelete.sibling;
            }
            return null;
          }
          function mapRemainingChildren(returnFiber, currentFirstChild) {
            var existingChildren = /* @__PURE__ */ new Map();
            var existingChild = currentFirstChild;
            while (existingChild !== null) {
              if (existingChild.key !== null) {
                existingChildren.set(existingChild.key, existingChild);
              } else {
                existingChildren.set(existingChild.index, existingChild);
              }
              existingChild = existingChild.sibling;
            }
            return existingChildren;
          }
          function useFiber(fiber, pendingProps) {
            var clone2 = createWorkInProgress(fiber, pendingProps);
            clone2.index = 0;
            clone2.sibling = null;
            return clone2;
          }
          function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
              return lastPlacedIndex;
            }
            var current2 = newFiber.alternate;
            if (current2 !== null) {
              var oldIndex = current2.index;
              if (oldIndex < lastPlacedIndex) {
                newFiber.flags = Placement;
                return lastPlacedIndex;
              } else {
                return oldIndex;
              }
            } else {
              newFiber.flags = Placement;
              return lastPlacedIndex;
            }
          }
          function placeSingleChild(newFiber) {
            if (shouldTrackSideEffects && newFiber.alternate === null) {
              newFiber.flags = Placement;
            }
            return newFiber;
          }
          function updateTextNode(returnFiber, current2, textContent, lanes) {
            if (current2 === null || current2.tag !== HostText) {
              var created = createFiberFromText(textContent, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current2, textContent);
              existing.return = returnFiber;
              return existing;
            }
          }
          function updateElement(returnFiber, current2, element, lanes) {
            if (current2 !== null) {
              if (current2.elementType === element.type || // Keep this check inline so it only runs on the false path:
              isCompatibleFamilyForHotReloading(current2, element)) {
                var existing = useFiber(current2, element.props);
                existing.ref = coerceRef(returnFiber, current2, element);
                existing.return = returnFiber;
                {
                  existing._debugSource = element._source;
                  existing._debugOwner = element._owner;
                }
                return existing;
              }
            }
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current2, element);
            created.return = returnFiber;
            return created;
          }
          function updatePortal(returnFiber, current2, portal, lanes) {
            if (current2 === null || current2.tag !== HostPortal || current2.stateNode.containerInfo !== portal.containerInfo || current2.stateNode.implementation !== portal.implementation) {
              var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current2, portal.children || []);
              existing.return = returnFiber;
              return existing;
            }
          }
          function updateFragment2(returnFiber, current2, fragment, lanes, key) {
            if (current2 === null || current2.tag !== Fragment2) {
              var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
              created.return = returnFiber;
              return created;
            } else {
              var existing = useFiber(current2, fragment);
              existing.return = returnFiber;
              return existing;
            }
          }
          function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
              var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
              created.return = returnFiber;
              return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE2: {
                  var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                  _created.ref = coerceRef(returnFiber, null, newChild);
                  _created.return = returnFiber;
                  return _created;
                }
                case REACT_PORTAL_TYPE: {
                  var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                  _created2.return = returnFiber;
                  return _created2;
                }
              }
              if (isArray$12(newChild) || getIteratorFn(newChild)) {
                var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                _created3.return = returnFiber;
                return _created3;
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" || typeof newChild === "number") {
              if (key !== null) {
                return null;
              }
              return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE2: {
                  if (newChild.key === key) {
                    if (newChild.type === REACT_FRAGMENT_TYPE) {
                      return updateFragment2(returnFiber, oldFiber, newChild.props.children, lanes, key);
                    }
                    return updateElement(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }
                case REACT_PORTAL_TYPE: {
                  if (newChild.key === key) {
                    return updatePortal(returnFiber, oldFiber, newChild, lanes);
                  } else {
                    return null;
                  }
                }
              }
              if (isArray$12(newChild) || getIteratorFn(newChild)) {
                if (key !== null) {
                  return null;
                }
                return updateFragment2(returnFiber, oldFiber, newChild, lanes, null);
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" || typeof newChild === "number") {
              var matchedFiber = existingChildren.get(newIdx) || null;
              return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE2: {
                  var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  if (newChild.type === REACT_FRAGMENT_TYPE) {
                    return updateFragment2(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                  }
                  return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                }
                case REACT_PORTAL_TYPE: {
                  var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                  return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }
              }
              if (isArray$12(newChild) || getIteratorFn(newChild)) {
                var _matchedFiber3 = existingChildren.get(newIdx) || null;
                return updateFragment2(returnFiber, _matchedFiber3, newChild, lanes, null);
              }
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            return null;
          }
          function warnOnInvalidKey(child, knownKeys, returnFiber) {
            {
              if (typeof child !== "object" || child === null) {
                return knownKeys;
              }
              switch (child.$$typeof) {
                case REACT_ELEMENT_TYPE2:
                case REACT_PORTAL_TYPE:
                  warnForMissingKey(child, returnFiber);
                  var key = child.key;
                  if (typeof key !== "string") {
                    break;
                  }
                  if (knownKeys === null) {
                    knownKeys = /* @__PURE__ */ new Set();
                    knownKeys.add(key);
                    break;
                  }
                  if (!knownKeys.has(key)) {
                    knownKeys.add(key);
                    break;
                  }
                  error2("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", key);
                  break;
              }
            }
            return knownKeys;
          }
          function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            {
              var knownKeys = null;
              for (var i2 = 0; i2 < newChildren.length; i2++) {
                var child = newChildren[i2];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for (; oldFiber !== null && newIdx < newChildren.length; newIdx++) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }
              var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
              if (newFiber === null) {
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }
                break;
              }
              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  deleteChild(returnFiber, oldFiber);
                }
              }
              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = newFiber;
              } else {
                previousNewFiber.sibling = newFiber;
              }
              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }
            if (oldFiber === null) {
              for (; newIdx < newChildren.length; newIdx++) {
                var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                if (_newFiber === null) {
                  continue;
                }
                lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber;
                } else {
                  previousNewFiber.sibling = _newFiber;
                }
                previousNewFiber = _newFiber;
              }
              return resultingFirstChild;
            }
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
            for (; newIdx < newChildren.length; newIdx++) {
              var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
              if (_newFiber2 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber2.alternate !== null) {
                    existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                  }
                }
                lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber2;
                } else {
                  previousNewFiber.sibling = _newFiber2;
                }
                previousNewFiber = _newFiber2;
              }
            }
            if (shouldTrackSideEffects) {
              existingChildren.forEach(function(child2) {
                return deleteChild(returnFiber, child2);
              });
            }
            return resultingFirstChild;
          }
          function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === "function")) {
              {
                throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            {
              if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
              newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) {
                  error2("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                }
                didWarnAboutGenerators = true;
              }
              if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) {
                  error2("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                }
                didWarnAboutMaps = true;
              }
              var _newChildren = iteratorFn.call(newChildrenIterable);
              if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for (; !_step.done; _step = _newChildren.next()) {
                  var child = _step.value;
                  knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
              }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) {
              {
                throw Error("An iterable object provided no iterator.");
              }
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step2 = newChildren.next();
            for (; oldFiber !== null && !step2.done; newIdx++, step2 = newChildren.next()) {
              if (oldFiber.index > newIdx) {
                nextOldFiber = oldFiber;
                oldFiber = null;
              } else {
                nextOldFiber = oldFiber.sibling;
              }
              var newFiber = updateSlot(returnFiber, oldFiber, step2.value, lanes);
              if (newFiber === null) {
                if (oldFiber === null) {
                  oldFiber = nextOldFiber;
                }
                break;
              }
              if (shouldTrackSideEffects) {
                if (oldFiber && newFiber.alternate === null) {
                  deleteChild(returnFiber, oldFiber);
                }
              }
              lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
              if (previousNewFiber === null) {
                resultingFirstChild = newFiber;
              } else {
                previousNewFiber.sibling = newFiber;
              }
              previousNewFiber = newFiber;
              oldFiber = nextOldFiber;
            }
            if (step2.done) {
              deleteRemainingChildren(returnFiber, oldFiber);
              return resultingFirstChild;
            }
            if (oldFiber === null) {
              for (; !step2.done; newIdx++, step2 = newChildren.next()) {
                var _newFiber3 = createChild(returnFiber, step2.value, lanes);
                if (_newFiber3 === null) {
                  continue;
                }
                lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber3;
                } else {
                  previousNewFiber.sibling = _newFiber3;
                }
                previousNewFiber = _newFiber3;
              }
              return resultingFirstChild;
            }
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber);
            for (; !step2.done; newIdx++, step2 = newChildren.next()) {
              var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step2.value, lanes);
              if (_newFiber4 !== null) {
                if (shouldTrackSideEffects) {
                  if (_newFiber4.alternate !== null) {
                    existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                  }
                }
                lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) {
                  resultingFirstChild = _newFiber4;
                } else {
                  previousNewFiber.sibling = _newFiber4;
                }
                previousNewFiber = _newFiber4;
              }
            }
            if (shouldTrackSideEffects) {
              existingChildren.forEach(function(child2) {
                return deleteChild(returnFiber, child2);
              });
            }
            return resultingFirstChild;
          }
          function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
              deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
              var existing = useFiber(currentFirstChild, textContent);
              existing.return = returnFiber;
              return existing;
            }
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          }
          function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while (child !== null) {
              if (child.key === key) {
                switch (child.tag) {
                  case Fragment2: {
                    if (element.type === REACT_FRAGMENT_TYPE) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var existing = useFiber(child, element.props.children);
                      existing.return = returnFiber;
                      {
                        existing._debugSource = element._source;
                        existing._debugOwner = element._owner;
                      }
                      return existing;
                    }
                    break;
                  }
                  case Block:
                  default: {
                    if (child.elementType === element.type || // Keep this check inline so it only runs on the false path:
                    isCompatibleFamilyForHotReloading(child, element)) {
                      deleteRemainingChildren(returnFiber, child.sibling);
                      var _existing3 = useFiber(child, element.props);
                      _existing3.ref = coerceRef(returnFiber, child, element);
                      _existing3.return = returnFiber;
                      {
                        _existing3._debugSource = element._source;
                        _existing3._debugOwner = element._owner;
                      }
                      return _existing3;
                    }
                    break;
                  }
                }
                deleteRemainingChildren(returnFiber, child);
                break;
              } else {
                deleteChild(returnFiber, child);
              }
              child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
              var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
              created.return = returnFiber;
              return created;
            } else {
              var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
              _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
              _created4.return = returnFiber;
              return _created4;
            }
          }
          function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while (child !== null) {
              if (child.key === key) {
                if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                  deleteRemainingChildren(returnFiber, child.sibling);
                  var existing = useFiber(child, portal.children || []);
                  existing.return = returnFiber;
                  return existing;
                } else {
                  deleteRemainingChildren(returnFiber, child);
                  break;
                }
              } else {
                deleteChild(returnFiber, child);
              }
              child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
          }
          function reconcileChildFibers2(returnFiber, currentFirstChild, newChild, lanes) {
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) {
              newChild = newChild.props.children;
            }
            var isObject3 = typeof newChild === "object" && newChild !== null;
            if (isObject3) {
              switch (newChild.$$typeof) {
                case REACT_ELEMENT_TYPE2:
                  return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                case REACT_PORTAL_TYPE:
                  return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
              }
            }
            if (typeof newChild === "string" || typeof newChild === "number") {
              return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            }
            if (isArray$12(newChild)) {
              return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (getIteratorFn(newChild)) {
              return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isObject3) {
              throwOnInvalidObjectType(returnFiber, newChild);
            }
            {
              if (typeof newChild === "function") {
                warnOnFunctionType(returnFiber);
              }
            }
            if (typeof newChild === "undefined" && !isUnkeyedTopLevelFragment) {
              switch (returnFiber.tag) {
                case ClassComponent: {
                  {
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) {
                      break;
                    }
                  }
                }
                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent: {
                  {
                    {
                      throw Error((getComponentName(returnFiber.type) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
                    }
                  }
                }
              }
            }
            return deleteRemainingChildren(returnFiber, currentFirstChild);
          }
          return reconcileChildFibers2;
        }
        var reconcileChildFibers = ChildReconciler(true);
        var mountChildFibers = ChildReconciler(false);
        function cloneChildFibers(current2, workInProgress2) {
          if (!(current2 === null || workInProgress2.child === current2.child)) {
            {
              throw Error("Resuming work not yet implemented.");
            }
          }
          if (workInProgress2.child === null) {
            return;
          }
          var currentChild = workInProgress2.child;
          var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
          workInProgress2.child = newChild;
          newChild.return = workInProgress2;
          while (currentChild.sibling !== null) {
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress2;
          }
          newChild.sibling = null;
        }
        function resetChildFibers(workInProgress2, lanes) {
          var child = workInProgress2.child;
          while (child !== null) {
            resetWorkInProgress(child, lanes);
            child = child.sibling;
          }
        }
        var NO_CONTEXT$1 = {};
        var contextStackCursor$1 = createCursor(NO_CONTEXT$1);
        var contextFiberStackCursor = createCursor(NO_CONTEXT$1);
        var rootInstanceStackCursor = createCursor(NO_CONTEXT$1);
        function requiredContext(c7) {
          if (!(c7 !== NO_CONTEXT$1)) {
            {
              throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          return c7;
        }
        function getRootHostContainer() {
          var rootInstance = requiredContext(rootInstanceStackCursor.current);
          return rootInstance;
        }
        function pushHostContainer(fiber, nextRootInstance) {
          push(rootInstanceStackCursor, nextRootInstance, fiber);
          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, NO_CONTEXT$1, fiber);
          var nextRootContext = getRootHostContext();
          pop(contextStackCursor$1, fiber);
          push(contextStackCursor$1, nextRootContext, fiber);
        }
        function popHostContainer(fiber) {
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
          pop(rootInstanceStackCursor, fiber);
        }
        function getHostContext() {
          var context = requiredContext(contextStackCursor$1.current);
          return context;
        }
        function pushHostContext(fiber) {
          requiredContext(rootInstanceStackCursor.current);
          var context = requiredContext(contextStackCursor$1.current);
          var nextContext = getChildHostContext(context, fiber.type);
          if (context === nextContext) {
            return;
          }
          push(contextFiberStackCursor, fiber, fiber);
          push(contextStackCursor$1, nextContext, fiber);
        }
        function popHostContext(fiber) {
          if (contextFiberStackCursor.current !== fiber) {
            return;
          }
          pop(contextStackCursor$1, fiber);
          pop(contextFiberStackCursor, fiber);
        }
        var DefaultSuspenseContext = 0;
        var SubtreeSuspenseContextMask = 1;
        var InvisibleParentSuspenseContext = 1;
        var ForceSuspenseFallback = 2;
        var suspenseStackCursor = createCursor(DefaultSuspenseContext);
        function hasSuspenseContext(parentContext, flag) {
          return (parentContext & flag) !== 0;
        }
        function setDefaultShallowSuspenseContext(parentContext) {
          return parentContext & SubtreeSuspenseContextMask;
        }
        function setShallowSuspenseContext(parentContext, shallowContext) {
          return parentContext & SubtreeSuspenseContextMask | shallowContext;
        }
        function addSubtreeSuspenseContext(parentContext, subtreeContext) {
          return parentContext | subtreeContext;
        }
        function pushSuspenseContext(fiber, newContext) {
          push(suspenseStackCursor, newContext, fiber);
        }
        function popSuspenseContext(fiber) {
          pop(suspenseStackCursor, fiber);
        }
        function shouldCaptureSuspense(workInProgress2, hasInvisibleParent) {
          var nextState = workInProgress2.memoizedState;
          if (nextState !== null) {
            if (nextState.dehydrated !== null) {
              return true;
            }
            return false;
          }
          var props2 = workInProgress2.memoizedProps;
          if (props2.fallback === void 0) {
            return false;
          }
          if (props2.unstable_avoidThisFallback !== true) {
            return true;
          }
          if (hasInvisibleParent) {
            return false;
          }
          return true;
        }
        function findFirstSuspended(row) {
          var node2 = row;
          while (node2 !== null) {
            if (node2.tag === SuspenseComponent) {
              var state = node2.memoizedState;
              if (state !== null) {
                var dehydrated = state.dehydrated;
                if (dehydrated === null || isSuspenseInstancePending() || isSuspenseInstanceFallback()) {
                  return node2;
                }
              }
            } else if (node2.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node2.memoizedProps.revealOrder !== void 0) {
              var didSuspend = (node2.flags & DidCapture) !== NoFlags;
              if (didSuspend) {
                return node2;
              }
            } else if (node2.child !== null) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === row) {
              return null;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === row) {
                return null;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
          return null;
        }
        var NoFlags$1 = (
          /*  */
          0
        );
        var HasEffect = (
          /* */
          1
        );
        var Layout = (
          /*    */
          2
        );
        var Passive$1 = (
          /*   */
          4
        );
        var isHydrating = false;
        function enterHydrationState(fiber) {
          {
            return false;
          }
        }
        function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
          {
            {
              {
                throw Error("Expected prepareToHydrateHostInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        function prepareToHydrateHostTextInstance(fiber) {
          {
            {
              {
                throw Error("Expected prepareToHydrateHostTextInstance() to never be called. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        function popHydrationState(fiber) {
          {
            return false;
          }
        }
        function getIsHydrating() {
          return isHydrating;
        }
        var workInProgressSources = [];
        var rendererSigil$1;
        {
          rendererSigil$1 = {};
        }
        function markSourceAsDirty(mutableSource) {
          workInProgressSources.push(mutableSource);
        }
        function resetWorkInProgressVersions() {
          for (var i2 = 0; i2 < workInProgressSources.length; i2++) {
            var mutableSource = workInProgressSources[i2];
            {
              mutableSource._workInProgressVersionSecondary = null;
            }
          }
          workInProgressSources.length = 0;
        }
        function getWorkInProgressVersion(mutableSource) {
          {
            return mutableSource._workInProgressVersionSecondary;
          }
        }
        function setWorkInProgressVersion(mutableSource, version2) {
          {
            mutableSource._workInProgressVersionSecondary = version2;
          }
          workInProgressSources.push(mutableSource);
        }
        function warnAboutMultipleRenderersDEV(mutableSource) {
          {
            {
              if (mutableSource._currentSecondaryRenderer == null) {
                mutableSource._currentSecondaryRenderer = rendererSigil$1;
              } else if (mutableSource._currentSecondaryRenderer !== rendererSigil$1) {
                error2("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
              }
            }
          }
        }
        var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
        var didWarnAboutMismatchedHooksForComponent;
        var didWarnAboutUseOpaqueIdentifier;
        {
          didWarnAboutUseOpaqueIdentifier = {};
          didWarnAboutMismatchedHooksForComponent = /* @__PURE__ */ new Set();
        }
        var renderLanes = NoLanes;
        var currentlyRenderingFiber$1 = null;
        var currentHook = null;
        var workInProgressHook = null;
        var didScheduleRenderPhaseUpdate = false;
        var didScheduleRenderPhaseUpdateDuringThisPass = false;
        var RE_RENDER_LIMIT = 25;
        var currentHookNameInDev = null;
        var hookTypesDev = null;
        var hookTypesUpdateIndexDev = -1;
        var ignorePreviousDependencies = false;
        function mountHookTypesDev() {
          {
            var hookName = currentHookNameInDev;
            if (hookTypesDev === null) {
              hookTypesDev = [hookName];
            } else {
              hookTypesDev.push(hookName);
            }
          }
        }
        function updateHookTypesDev() {
          {
            var hookName = currentHookNameInDev;
            if (hookTypesDev !== null) {
              hookTypesUpdateIndexDev++;
              if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) {
                warnOnHookMismatchInDev(hookName);
              }
            }
          }
        }
        function checkDepsAreArrayDev(deps) {
          {
            if (deps !== void 0 && deps !== null && !Array.isArray(deps)) {
              error2("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
            }
          }
        }
        function warnOnHookMismatchInDev(currentHookName) {
          {
            var componentName = getComponentName(currentlyRenderingFiber$1.type);
            if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
              didWarnAboutMismatchedHooksForComponent.add(componentName);
              if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for (var i2 = 0; i2 <= hookTypesUpdateIndexDev; i2++) {
                  var oldHookName = hookTypesDev[i2];
                  var newHookName = i2 === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                  var row = i2 + 1 + ". " + oldHookName;
                  while (row.length < secondColumnStart) {
                    row += " ";
                  }
                  row += newHookName + "\n";
                  table += row;
                }
                error2("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
              }
            }
          }
        }
        function throwInvalidHookError() {
          {
            {
              throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
            }
          }
        }
        function areHookInputsEqual(nextDeps, prevDeps) {
          {
            if (ignorePreviousDependencies) {
              return false;
            }
          }
          if (prevDeps === null) {
            {
              error2("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            }
            return false;
          }
          {
            if (nextDeps.length !== prevDeps.length) {
              error2("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
            }
          }
          for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++) {
            if (objectIs2(nextDeps[i2], prevDeps[i2])) {
              continue;
            }
            return false;
          }
          return true;
        }
        function renderWithHooks(current2, workInProgress2, Component2, props2, secondArg, nextRenderLanes) {
          renderLanes = nextRenderLanes;
          currentlyRenderingFiber$1 = workInProgress2;
          {
            hookTypesDev = current2 !== null ? current2._debugHookTypes : null;
            hookTypesUpdateIndexDev = -1;
            ignorePreviousDependencies = current2 !== null && current2.type !== workInProgress2.type;
          }
          workInProgress2.memoizedState = null;
          workInProgress2.updateQueue = null;
          workInProgress2.lanes = NoLanes;
          {
            if (current2 !== null && current2.memoizedState !== null) {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
            } else if (hookTypesDev !== null) {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
            } else {
              ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
            }
          }
          var children2 = Component2(props2, secondArg);
          if (didScheduleRenderPhaseUpdateDuringThisPass) {
            var numberOfReRenders = 0;
            do {
              didScheduleRenderPhaseUpdateDuringThisPass = false;
              if (!(numberOfReRenders < RE_RENDER_LIMIT)) {
                {
                  throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                }
              }
              numberOfReRenders += 1;
              {
                ignorePreviousDependencies = false;
              }
              currentHook = null;
              workInProgressHook = null;
              workInProgress2.updateQueue = null;
              {
                hookTypesUpdateIndexDev = -1;
              }
              ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
              children2 = Component2(props2, secondArg);
            } while (didScheduleRenderPhaseUpdateDuringThisPass);
          }
          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
          {
            workInProgress2._debugHookTypes = hookTypesDev;
          }
          var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
          renderLanes = NoLanes;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            currentHookNameInDev = null;
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
          }
          didScheduleRenderPhaseUpdate = false;
          if (!!didRenderTooFewHooks) {
            {
              throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
            }
          }
          return children2;
        }
        function bailoutHooks(current2, workInProgress2, lanes) {
          workInProgress2.updateQueue = current2.updateQueue;
          workInProgress2.flags &= ~(Passive | Update);
          current2.lanes = removeLanes(current2.lanes, lanes);
        }
        function resetHooksAfterThrow() {
          ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
          if (didScheduleRenderPhaseUpdate) {
            var hook = currentlyRenderingFiber$1.memoizedState;
            while (hook !== null) {
              var queue = hook.queue;
              if (queue !== null) {
                queue.pending = null;
              }
              hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
          }
          renderLanes = NoLanes;
          currentlyRenderingFiber$1 = null;
          currentHook = null;
          workInProgressHook = null;
          {
            hookTypesDev = null;
            hookTypesUpdateIndexDev = -1;
            currentHookNameInDev = null;
            isUpdatingOpaqueValueInRenderPhase = false;
          }
          didScheduleRenderPhaseUpdateDuringThisPass = false;
        }
        function mountWorkInProgressHook() {
          var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
          };
          if (workInProgressHook === null) {
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
          } else {
            workInProgressHook = workInProgressHook.next = hook;
          }
          return workInProgressHook;
        }
        function updateWorkInProgressHook() {
          var nextCurrentHook;
          if (currentHook === null) {
            var current2 = currentlyRenderingFiber$1.alternate;
            if (current2 !== null) {
              nextCurrentHook = current2.memoizedState;
            } else {
              nextCurrentHook = null;
            }
          } else {
            nextCurrentHook = currentHook.next;
          }
          var nextWorkInProgressHook;
          if (workInProgressHook === null) {
            nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
          } else {
            nextWorkInProgressHook = workInProgressHook.next;
          }
          if (nextWorkInProgressHook !== null) {
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
          } else {
            if (!(nextCurrentHook !== null)) {
              {
                throw Error("Rendered more hooks than during the previous render.");
              }
            }
            currentHook = nextCurrentHook;
            var newHook = {
              memoizedState: currentHook.memoizedState,
              baseState: currentHook.baseState,
              baseQueue: currentHook.baseQueue,
              queue: currentHook.queue,
              next: null
            };
            if (workInProgressHook === null) {
              currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            } else {
              workInProgressHook = workInProgressHook.next = newHook;
            }
          }
          return workInProgressHook;
        }
        function createFunctionComponentUpdateQueue() {
          return {
            lastEffect: null
          };
        }
        function basicStateReducer(state, action2) {
          return typeof action2 === "function" ? action2(state) : action2;
        }
        function mountReducer(reducer2, initialArg, init2) {
          var hook = mountWorkInProgressHook();
          var initialState2;
          if (init2 !== void 0) {
            initialState2 = init2(initialArg);
          } else {
            initialState2 = initialArg;
          }
          hook.memoizedState = hook.baseState = initialState2;
          var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer2,
            lastRenderedState: initialState2
          };
          var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
          return [hook.memoizedState, dispatch];
        }
        function updateReducer(reducer2, initialArg, init2) {
          var hook = updateWorkInProgressHook();
          var queue = hook.queue;
          if (!(queue !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }
          queue.lastRenderedReducer = reducer2;
          var current2 = currentHook;
          var baseQueue = current2.baseQueue;
          var pendingQueue = queue.pending;
          if (pendingQueue !== null) {
            if (baseQueue !== null) {
              var baseFirst = baseQueue.next;
              var pendingFirst = pendingQueue.next;
              baseQueue.next = pendingFirst;
              pendingQueue.next = baseFirst;
            }
            {
              if (current2.baseQueue !== baseQueue) {
                error2("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
              }
            }
            current2.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
          }
          if (baseQueue !== null) {
            var first = baseQueue.next;
            var newState = current2.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update2 = first;
            do {
              var updateLane = update2.lane;
              if (!isSubsetOfLanes(renderLanes, updateLane)) {
                var clone2 = {
                  lane: updateLane,
                  action: update2.action,
                  eagerReducer: update2.eagerReducer,
                  eagerState: update2.eagerState,
                  next: null
                };
                if (newBaseQueueLast === null) {
                  newBaseQueueFirst = newBaseQueueLast = clone2;
                  newBaseState = newState;
                } else {
                  newBaseQueueLast = newBaseQueueLast.next = clone2;
                }
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                markSkippedUpdateLanes(updateLane);
              } else {
                if (newBaseQueueLast !== null) {
                  var _clone = {
                    // This update is going to be committed so we never want uncommit
                    // it. Using NoLane works because 0 is a subset of all bitmasks, so
                    // this will never be skipped by the check above.
                    lane: NoLane,
                    action: update2.action,
                    eagerReducer: update2.eagerReducer,
                    eagerState: update2.eagerState,
                    next: null
                  };
                  newBaseQueueLast = newBaseQueueLast.next = _clone;
                }
                if (update2.eagerReducer === reducer2) {
                  newState = update2.eagerState;
                } else {
                  var action2 = update2.action;
                  newState = reducer2(newState, action2);
                }
              }
              update2 = update2.next;
            } while (update2 !== null && update2 !== first);
            if (newBaseQueueLast === null) {
              newBaseState = newState;
            } else {
              newBaseQueueLast.next = newBaseQueueFirst;
            }
            if (!objectIs2(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
          }
          var dispatch = queue.dispatch;
          return [hook.memoizedState, dispatch];
        }
        function rerenderReducer(reducer2, initialArg, init2) {
          var hook = updateWorkInProgressHook();
          var queue = hook.queue;
          if (!(queue !== null)) {
            {
              throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
            }
          }
          queue.lastRenderedReducer = reducer2;
          var dispatch = queue.dispatch;
          var lastRenderPhaseUpdate = queue.pending;
          var newState = hook.memoizedState;
          if (lastRenderPhaseUpdate !== null) {
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update2 = firstRenderPhaseUpdate;
            do {
              var action2 = update2.action;
              newState = reducer2(newState, action2);
              update2 = update2.next;
            } while (update2 !== firstRenderPhaseUpdate);
            if (!objectIs2(newState, hook.memoizedState)) {
              markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = newState;
            if (hook.baseQueue === null) {
              hook.baseState = newState;
            }
            queue.lastRenderedState = newState;
          }
          return [newState, dispatch];
        }
        function readFromUnsubcribedMutableSource(root2, source, getSnapshot) {
          {
            warnAboutMultipleRenderersDEV(source);
          }
          var getVersion = source._getVersion;
          var version2 = getVersion(source._source);
          var isSafeToReadFromSource = false;
          var currentRenderVersion = getWorkInProgressVersion(source);
          if (currentRenderVersion !== null) {
            isSafeToReadFromSource = currentRenderVersion === version2;
          } else {
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root2.mutableReadLanes);
            if (isSafeToReadFromSource) {
              setWorkInProgressVersion(source, version2);
            }
          }
          if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            {
              if (typeof snapshot === "function") {
                error2("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
              }
            }
            return snapshot;
          } else {
            markSourceAsDirty(source);
            {
              {
                throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
              }
            }
          }
        }
        function useMutableSource(hook, source, getSnapshot, subscribe) {
          var root2 = getWorkInProgressRoot();
          if (!(root2 !== null)) {
            {
              throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            }
          }
          var getVersion = source._getVersion;
          var version2 = getVersion(source._source);
          var dispatcher = ReactCurrentDispatcher$1.current;
          var _dispatcher$useState = dispatcher.useState(function() {
            return readFromUnsubcribedMutableSource(root2, source, getSnapshot);
          }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
          var snapshot = currentSnapshot;
          var stateHook = workInProgressHook;
          var memoizedState = hook.memoizedState;
          var refs = memoizedState.refs;
          var prevGetSnapshot = refs.getSnapshot;
          var prevSource = memoizedState.source;
          var prevSubscribe = memoizedState.subscribe;
          var fiber = currentlyRenderingFiber$1;
          hook.memoizedState = {
            refs,
            source,
            subscribe
          };
          dispatcher.useEffect(function() {
            refs.getSnapshot = getSnapshot;
            refs.setSnapshot = setSnapshot;
            var maybeNewVersion = getVersion(source._source);
            if (!objectIs2(version2, maybeNewVersion)) {
              var maybeNewSnapshot = getSnapshot(source._source);
              {
                if (typeof maybeNewSnapshot === "function") {
                  error2("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
                }
              }
              if (!objectIs2(snapshot, maybeNewSnapshot)) {
                setSnapshot(maybeNewSnapshot);
                var lane = requestUpdateLane(fiber);
                markRootMutableRead(root2, lane);
              }
              markRootEntangled(root2, root2.mutableReadLanes);
            }
          }, [getSnapshot, source, subscribe]);
          dispatcher.useEffect(function() {
            var handleChange = function() {
              var latestGetSnapshot = refs.getSnapshot;
              var latestSetSnapshot = refs.setSnapshot;
              try {
                latestSetSnapshot(latestGetSnapshot(source._source));
                var lane = requestUpdateLane(fiber);
                markRootMutableRead(root2, lane);
              } catch (error3) {
                latestSetSnapshot(function() {
                  throw error3;
                });
              }
            };
            var unsubscribe = subscribe(source._source, handleChange);
            {
              if (typeof unsubscribe !== "function") {
                error2("Mutable source subscribe function must return an unsubscribe function.");
              }
            }
            return unsubscribe;
          }, [source, subscribe]);
          if (!objectIs2(prevGetSnapshot, getSnapshot) || !objectIs2(prevSource, source) || !objectIs2(prevSubscribe, subscribe)) {
            var newQueue = {
              pending: null,
              dispatch: null,
              lastRenderedReducer: basicStateReducer,
              lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root2, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
          }
          return snapshot;
        }
        function mountMutableSource(source, getSnapshot, subscribe) {
          var hook = mountWorkInProgressHook();
          hook.memoizedState = {
            refs: {
              getSnapshot,
              setSnapshot: null
            },
            source,
            subscribe
          };
          return useMutableSource(hook, source, getSnapshot, subscribe);
        }
        function updateMutableSource(source, getSnapshot, subscribe) {
          var hook = updateWorkInProgressHook();
          return useMutableSource(hook, source, getSnapshot, subscribe);
        }
        function mountState(initialState2) {
          var hook = mountWorkInProgressHook();
          if (typeof initialState2 === "function") {
            initialState2 = initialState2();
          }
          hook.memoizedState = hook.baseState = initialState2;
          var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState2
          };
          var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
          return [hook.memoizedState, dispatch];
        }
        function updateState(initialState2) {
          return updateReducer(basicStateReducer);
        }
        function rerenderState(initialState2) {
          return rerenderReducer(basicStateReducer);
        }
        function pushEffect(tag2, create3, destroy, deps) {
          var effect2 = {
            tag: tag2,
            create: create3,
            destroy,
            deps,
            // Circular
            next: null
          };
          var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
          if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect2.next = effect2;
          } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) {
              componentUpdateQueue.lastEffect = effect2.next = effect2;
            } else {
              var firstEffect = lastEffect.next;
              lastEffect.next = effect2;
              effect2.next = firstEffect;
              componentUpdateQueue.lastEffect = effect2;
            }
          }
          return effect2;
        }
        function mountRef(initialValue2) {
          var hook = mountWorkInProgressHook();
          var ref2 = {
            current: initialValue2
          };
          {
            Object.seal(ref2);
          }
          hook.memoizedState = ref2;
          return ref2;
        }
        function updateRef2(initialValue2) {
          var hook = updateWorkInProgressHook();
          return hook.memoizedState;
        }
        function mountEffectImpl(fiberFlags, hookFlags, create3, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          currentlyRenderingFiber$1.flags |= fiberFlags;
          hook.memoizedState = pushEffect(HasEffect | hookFlags, create3, void 0, nextDeps);
        }
        function updateEffectImpl(fiberFlags, hookFlags, create3, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var destroy = void 0;
          if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
              var prevDeps = prevEffect.deps;
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                pushEffect(hookFlags, create3, destroy, nextDeps);
                return;
              }
            }
          }
          currentlyRenderingFiber$1.flags |= fiberFlags;
          hook.memoizedState = pushEffect(HasEffect | hookFlags, create3, destroy, nextDeps);
        }
        function mountEffect(create3, deps) {
          {
            if ("undefined" !== typeof jest) {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return mountEffectImpl(Update | Passive, Passive$1, create3, deps);
        }
        function updateEffect(create3, deps) {
          {
            if ("undefined" !== typeof jest) {
              warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
            }
          }
          return updateEffectImpl(Update | Passive, Passive$1, create3, deps);
        }
        function mountLayoutEffect(create3, deps) {
          return mountEffectImpl(Update, Layout, create3, deps);
        }
        function updateLayoutEffect(create3, deps) {
          return updateEffectImpl(Update, Layout, create3, deps);
        }
        function imperativeHandleEffect(create3, ref2) {
          if (typeof ref2 === "function") {
            var refCallback = ref2;
            var _inst = create3();
            refCallback(_inst);
            return function() {
              refCallback(null);
            };
          } else if (ref2 !== null && ref2 !== void 0) {
            var refObject = ref2;
            {
              if (!refObject.hasOwnProperty("current")) {
                error2("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
              }
            }
            var _inst2 = create3();
            refObject.current = _inst2;
            return function() {
              refObject.current = null;
            };
          }
        }
        function mountImperativeHandle(ref2, create3, deps) {
          {
            if (typeof create3 !== "function") {
              error2("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create3 !== null ? typeof create3 : "null");
            }
          }
          var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref2]) : null;
          return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create3, ref2), effectDeps);
        }
        function updateImperativeHandle(ref2, create3, deps) {
          {
            if (typeof create3 !== "function") {
              error2("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create3 !== null ? typeof create3 : "null");
            }
          }
          var effectDeps = deps !== null && deps !== void 0 ? deps.concat([ref2]) : null;
          return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create3, ref2), effectDeps);
        }
        function mountDebugValue(value, formatterFn) {
        }
        var updateDebugValue = mountDebugValue;
        function mountCallback(callback, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }
        function updateCallback(callback, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var prevState = hook.memoizedState;
          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
          hook.memoizedState = [callback, nextDeps];
          return callback;
        }
        function mountMemo(nextCreate, deps) {
          var hook = mountWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }
        function updateMemo(nextCreate, deps) {
          var hook = updateWorkInProgressHook();
          var nextDeps = deps === void 0 ? null : deps;
          var prevState = hook.memoizedState;
          if (prevState !== null) {
            if (nextDeps !== null) {
              var prevDeps = prevState[1];
              if (areHookInputsEqual(nextDeps, prevDeps)) {
                return prevState[0];
              }
            }
          }
          var nextValue = nextCreate();
          hook.memoizedState = [nextValue, nextDeps];
          return nextValue;
        }
        function mountDeferredValue(value) {
          var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
          mountEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }
        function updateDeferredValue(value) {
          var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
          updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }
        function rerenderDeferredValue(value) {
          var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
          updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
              setValue(value);
            } finally {
              ReactCurrentBatchConfig$1.transition = prevTransition;
            }
          }, [value]);
          return prevValue;
        }
        function startTransition(setPending, callback) {
          var priorityLevel = getCurrentPriorityLevel();
          {
            runWithPriority(priorityLevel < UserBlockingPriority$1 ? UserBlockingPriority$1 : priorityLevel, function() {
              setPending(true);
            });
            runWithPriority(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function() {
              var prevTransition = ReactCurrentBatchConfig$1.transition;
              ReactCurrentBatchConfig$1.transition = 1;
              try {
                setPending(false);
                callback();
              } finally {
                ReactCurrentBatchConfig$1.transition = prevTransition;
              }
            });
          }
        }
        function mountTransition() {
          var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1];
          var start2 = startTransition.bind(null, setPending);
          mountRef(start2);
          return [start2, isPending];
        }
        function updateTransition() {
          var _updateState2 = updateState(), isPending = _updateState2[0];
          var startRef = updateRef2();
          var start2 = startRef.current;
          return [start2, isPending];
        }
        function rerenderTransition() {
          var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
          var startRef = updateRef2();
          var start2 = startRef.current;
          return [start2, isPending];
        }
        var isUpdatingOpaqueValueInRenderPhase = false;
        function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
          {
            return isUpdatingOpaqueValueInRenderPhase;
          }
        }
        function warnOnOpaqueIdentifierAccessInDEV(fiber) {
          {
            var name2 = getComponentName(fiber.type) || "Unknown";
            if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name2]) {
              error2("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
              didWarnAboutUseOpaqueIdentifier[name2] = true;
            }
          }
        }
        function mountOpaqueIdentifier() {
          var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
          {
            var _id = makeId();
            mountState(_id);
            return _id;
          }
        }
        function updateOpaqueIdentifier() {
          var id = updateState()[0];
          return id;
        }
        function rerenderOpaqueIdentifier() {
          var id = rerenderState()[0];
          return id;
        }
        function dispatchAction(fiber, queue, action2) {
          {
            if (typeof arguments[3] === "function") {
              error2("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
            }
          }
          var eventTime = requestEventTime();
          var lane = requestUpdateLane(fiber);
          var update2 = {
            lane,
            action: action2,
            eagerReducer: null,
            eagerState: null,
            next: null
          };
          var pending = queue.pending;
          if (pending === null) {
            update2.next = update2;
          } else {
            update2.next = pending.next;
            pending.next = update2;
          }
          queue.pending = update2;
          var alternate = fiber.alternate;
          if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) {
            didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
          } else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
              var lastRenderedReducer = queue.lastRenderedReducer;
              if (lastRenderedReducer !== null) {
                var prevDispatcher;
                {
                  prevDispatcher = ReactCurrentDispatcher$1.current;
                  ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                }
                try {
                  var currentState = queue.lastRenderedState;
                  var eagerState = lastRenderedReducer(currentState, action2);
                  update2.eagerReducer = lastRenderedReducer;
                  update2.eagerState = eagerState;
                  if (objectIs2(eagerState, currentState)) {
                    return;
                  }
                } catch (error3) {
                } finally {
                  {
                    ReactCurrentDispatcher$1.current = prevDispatcher;
                  }
                }
              }
            }
            {
              if ("undefined" !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
              }
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
          }
        }
        var ContextOnlyDispatcher = {
          readContext,
          useCallback: throwInvalidHookError,
          useContext: throwInvalidHookError,
          useEffect: throwInvalidHookError,
          useImperativeHandle: throwInvalidHookError,
          useLayoutEffect: throwInvalidHookError,
          useMemo: throwInvalidHookError,
          useReducer: throwInvalidHookError,
          useRef: throwInvalidHookError,
          useState: throwInvalidHookError,
          useDebugValue: throwInvalidHookError,
          useDeferredValue: throwInvalidHookError,
          useTransition: throwInvalidHookError,
          useMutableSource: throwInvalidHookError,
          useOpaqueIdentifier: throwInvalidHookError,
          unstable_isNewReconciler: enableNewReconciler
        };
        var HooksDispatcherOnMountInDEV = null;
        var HooksDispatcherOnMountWithHookTypesInDEV = null;
        var HooksDispatcherOnUpdateInDEV = null;
        var HooksDispatcherOnRerenderInDEV = null;
        var InvalidNestedHooksDispatcherOnMountInDEV = null;
        var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
        var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
        {
          var warnInvalidContextAccess = function() {
            error2("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          };
          var warnInvalidHookAccess = function() {
            error2("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
          };
          HooksDispatcherOnMountInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              mountHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              return mountLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              mountHookTypesDev();
              checkDepsAreArrayDev(deps);
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              mountHookTypesDev();
              return mountRef(initialValue2);
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              mountHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              mountHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              mountHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              mountHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              mountHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnMountWithHookTypesInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return mountEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return mountImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return mountLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return mountRef(initialValue2);
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              updateHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              updateHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnUpdateInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return updateEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return updateImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return updateLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return updateRef2();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return updateDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return updateTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              updateHookTypesDev();
              return updateOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          HooksDispatcherOnRerenderInDEV = {
            readContext: function(context, observedBits) {
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              updateHookTypesDev();
              return updateEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              updateHookTypesDev();
              return updateImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              updateHookTypesDev();
              return updateLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return updateMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return rerenderReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              updateHookTypesDev();
              return updateRef2();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
              try {
                return rerenderState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              updateHookTypesDev();
              return rerenderDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              updateHookTypesDev();
              return rerenderTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              updateHookTypesDev();
              return rerenderOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnMountInDEV = {
            readContext: function(context, observedBits) {
              warnInvalidContextAccess();
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountRef(initialValue2);
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              mountHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
              try {
                return mountState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              warnInvalidHookAccess();
              mountHookTypesDev();
              return mountOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnUpdateInDEV = {
            readContext: function(context, observedBits) {
              warnInvalidContextAccess();
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef2();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
          InvalidNestedHooksDispatcherOnRerenderInDEV = {
            readContext: function(context, observedBits) {
              warnInvalidContextAccess();
              return readContext(context, observedBits);
            },
            useCallback: function(callback, deps) {
              currentHookNameInDev = "useCallback";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateCallback(callback, deps);
            },
            useContext: function(context, observedBits) {
              currentHookNameInDev = "useContext";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return readContext(context, observedBits);
            },
            useEffect: function(create3, deps) {
              currentHookNameInDev = "useEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateEffect(create3, deps);
            },
            useImperativeHandle: function(ref2, create3, deps) {
              currentHookNameInDev = "useImperativeHandle";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateImperativeHandle(ref2, create3, deps);
            },
            useLayoutEffect: function(create3, deps) {
              currentHookNameInDev = "useLayoutEffect";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateLayoutEffect(create3, deps);
            },
            useMemo: function(create3, deps) {
              currentHookNameInDev = "useMemo";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return updateMemo(create3, deps);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useReducer: function(reducer2, initialArg, init2) {
              currentHookNameInDev = "useReducer";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return rerenderReducer(reducer2, initialArg, init2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useRef: function(initialValue2) {
              currentHookNameInDev = "useRef";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateRef2();
            },
            useState: function(initialState2) {
              currentHookNameInDev = "useState";
              warnInvalidHookAccess();
              updateHookTypesDev();
              var prevDispatcher = ReactCurrentDispatcher$1.current;
              ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
              try {
                return rerenderState(initialState2);
              } finally {
                ReactCurrentDispatcher$1.current = prevDispatcher;
              }
            },
            useDebugValue: function(value, formatterFn) {
              currentHookNameInDev = "useDebugValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateDebugValue();
            },
            useDeferredValue: function(value) {
              currentHookNameInDev = "useDeferredValue";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderDeferredValue(value);
            },
            useTransition: function() {
              currentHookNameInDev = "useTransition";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderTransition();
            },
            useMutableSource: function(source, getSnapshot, subscribe) {
              currentHookNameInDev = "useMutableSource";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return updateMutableSource(source, getSnapshot, subscribe);
            },
            useOpaqueIdentifier: function() {
              currentHookNameInDev = "useOpaqueIdentifier";
              warnInvalidHookAccess();
              updateHookTypesDev();
              return rerenderOpaqueIdentifier();
            },
            unstable_isNewReconciler: enableNewReconciler
          };
        }
        var now$12 = Scheduler$1.unstable_now;
        var commitTime = 0;
        var profilerStartTime = -1;
        function getCommitTime() {
          return commitTime;
        }
        function recordCommitTime() {
          commitTime = now$12();
        }
        function startProfilerTimer(fiber) {
          profilerStartTime = now$12();
          if (fiber.actualStartTime < 0) {
            fiber.actualStartTime = now$12();
          }
        }
        function stopProfilerTimerIfRunning(fiber) {
          profilerStartTime = -1;
        }
        function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
          if (profilerStartTime >= 0) {
            var elapsedTime = now$12() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) {
              fiber.selfBaseDuration = elapsedTime;
            }
            profilerStartTime = -1;
          }
        }
        function transferActualDuration(fiber) {
          var child = fiber.child;
          while (child) {
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        var didReceiveUpdate = false;
        var didWarnAboutBadClass;
        var didWarnAboutModulePatternComponent;
        var didWarnAboutContextTypeOnFunctionComponent;
        var didWarnAboutGetDerivedStateOnFunctionComponent;
        var didWarnAboutFunctionRefs;
        var didWarnAboutReassigningProps;
        var didWarnAboutRevealOrder;
        var didWarnAboutTailOptions;
        {
          didWarnAboutBadClass = {};
          didWarnAboutModulePatternComponent = {};
          didWarnAboutContextTypeOnFunctionComponent = {};
          didWarnAboutGetDerivedStateOnFunctionComponent = {};
          didWarnAboutFunctionRefs = {};
          didWarnAboutReassigningProps = false;
          didWarnAboutRevealOrder = {};
          didWarnAboutTailOptions = {};
        }
        function reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2) {
          if (current2 === null) {
            workInProgress2.child = mountChildFibers(workInProgress2, null, nextChildren, renderLanes2);
          } else {
            workInProgress2.child = reconcileChildFibers(workInProgress2, current2.child, nextChildren, renderLanes2);
          }
        }
        function forceUnmountCurrentAndReconcile(current2, workInProgress2, nextChildren, renderLanes2) {
          workInProgress2.child = reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
          workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderLanes2);
        }
        function updateForwardRef(current2, workInProgress2, Component2, nextProps, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component2.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(Component2)
                );
              }
            }
          }
          var render = Component2.render;
          var ref2 = workInProgress2.ref;
          var nextChildren;
          prepareToReadContext(workInProgress2, renderLanes2);
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            nextChildren = renderWithHooks(current2, workInProgress2, render, nextProps, ref2, renderLanes2);
            setIsRendering(false);
          }
          if (current2 !== null && !didReceiveUpdate) {
            bailoutHooks(current2, workInProgress2, renderLanes2);
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          workInProgress2.flags |= PerformedWork;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateMemoComponent(current2, workInProgress2, Component2, nextProps, updateLanes, renderLanes2) {
          if (current2 === null) {
            var type2 = Component2.type;
            if (isSimpleFunctionComponent(type2) && Component2.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component2.defaultProps === void 0) {
              var resolvedType = type2;
              {
                resolvedType = resolveFunctionForHotReloading(type2);
              }
              workInProgress2.tag = SimpleMemoComponent;
              workInProgress2.type = resolvedType;
              {
                validateFunctionComponentInDev(workInProgress2, type2);
              }
              return updateSimpleMemoComponent(current2, workInProgress2, resolvedType, nextProps, updateLanes, renderLanes2);
            }
            {
              var innerPropTypes = type2.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(type2)
                );
              }
            }
            var child = createFiberFromTypeAndProps(Component2.type, null, nextProps, workInProgress2, workInProgress2.mode, renderLanes2);
            child.ref = workInProgress2.ref;
            child.return = workInProgress2;
            workInProgress2.child = child;
            return child;
          }
          {
            var _type = Component2.type;
            var _innerPropTypes = _type.propTypes;
            if (_innerPropTypes) {
              checkPropTypes(
                _innerPropTypes,
                nextProps,
                // Resolved props
                "prop",
                getComponentName(_type)
              );
            }
          }
          var currentChild = current2.child;
          if (!includesSomeLane(updateLanes, renderLanes2)) {
            var prevProps = currentChild.memoizedProps;
            var compare = Component2.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current2.ref === workInProgress2.ref) {
              return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
            }
          }
          workInProgress2.flags |= PerformedWork;
          var newChild = createWorkInProgress(currentChild, nextProps);
          newChild.ref = workInProgress2.ref;
          newChild.return = workInProgress2;
          workInProgress2.child = newChild;
          return newChild;
        }
        function updateSimpleMemoComponent(current2, workInProgress2, Component2, nextProps, updateLanes, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var outerMemoType = workInProgress2.elementType;
              if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init2 = lazyComponent._init;
                try {
                  outerMemoType = init2(payload);
                } catch (x3) {
                  outerMemoType = null;
                }
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) {
                  checkPropTypes(
                    outerPropTypes,
                    nextProps,
                    // Resolved (SimpleMemoComponent has no defaultProps)
                    "prop",
                    getComponentName(outerMemoType)
                  );
                }
              }
            }
          }
          if (current2 !== null) {
            var prevProps = current2.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current2.ref === workInProgress2.ref && // Prevent bailout if the implementation changed due to hot reload.
            workInProgress2.type === current2.type) {
              didReceiveUpdate = false;
              if (!includesSomeLane(renderLanes2, updateLanes)) {
                workInProgress2.lanes = current2.lanes;
                return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
              } else if ((current2.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                didReceiveUpdate = true;
              }
            }
          }
          return updateFunctionComponent(current2, workInProgress2, Component2, nextProps, renderLanes2);
        }
        function updateOffscreenComponent(current2, workInProgress2, renderLanes2) {
          var nextProps = workInProgress2.pendingProps;
          var nextChildren = nextProps.children;
          var prevState = current2 !== null ? current2.memoizedState : null;
          if (nextProps.mode === "hidden" || nextProps.mode === "unstable-defer-without-hiding") {
            if ((workInProgress2.mode & ConcurrentMode) === NoMode) {
              var nextState = {
                baseLanes: NoLanes
              };
              workInProgress2.memoizedState = nextState;
              pushRenderLanes(workInProgress2, renderLanes2);
            } else if (!includesSomeLane(renderLanes2, OffscreenLane)) {
              var nextBaseLanes;
              if (prevState !== null) {
                var prevBaseLanes = prevState.baseLanes;
                nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes2);
              } else {
                nextBaseLanes = renderLanes2;
              }
              {
                markSpawnedWork(OffscreenLane);
              }
              workInProgress2.lanes = workInProgress2.childLanes = laneToLanes(OffscreenLane);
              var _nextState = {
                baseLanes: nextBaseLanes
              };
              workInProgress2.memoizedState = _nextState;
              pushRenderLanes(workInProgress2, nextBaseLanes);
              return null;
            } else {
              var _nextState2 = {
                baseLanes: NoLanes
              };
              workInProgress2.memoizedState = _nextState2;
              var subtreeRenderLanes2 = prevState !== null ? prevState.baseLanes : renderLanes2;
              pushRenderLanes(workInProgress2, subtreeRenderLanes2);
            }
          } else {
            var _subtreeRenderLanes;
            if (prevState !== null) {
              _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes2);
              workInProgress2.memoizedState = null;
            } else {
              _subtreeRenderLanes = renderLanes2;
            }
            pushRenderLanes(workInProgress2, _subtreeRenderLanes);
          }
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        var updateLegacyHiddenComponent = updateOffscreenComponent;
        function updateFragment(current2, workInProgress2, renderLanes2) {
          var nextChildren = workInProgress2.pendingProps;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateMode(current2, workInProgress2, renderLanes2) {
          var nextChildren = workInProgress2.pendingProps.children;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateProfiler(current2, workInProgress2, renderLanes2) {
          {
            workInProgress2.flags |= Update;
            var stateNode = workInProgress2.stateNode;
            stateNode.effectDuration = 0;
            stateNode.passiveEffectDuration = 0;
          }
          var nextProps = workInProgress2.pendingProps;
          var nextChildren = nextProps.children;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function markRef(current2, workInProgress2) {
          var ref2 = workInProgress2.ref;
          if (current2 === null && ref2 !== null || current2 !== null && current2.ref !== ref2) {
            workInProgress2.flags |= Ref;
          }
        }
        function updateFunctionComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component2.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(Component2)
                );
              }
            }
          }
          var context;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress2, Component2, true);
            context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          var nextChildren;
          prepareToReadContext(workInProgress2, renderLanes2);
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            nextChildren = renderWithHooks(current2, workInProgress2, Component2, nextProps, context, renderLanes2);
            setIsRendering(false);
          }
          if (current2 !== null && !didReceiveUpdate) {
            bailoutHooks(current2, workInProgress2, renderLanes2);
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          workInProgress2.flags |= PerformedWork;
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateClassComponent(current2, workInProgress2, Component2, nextProps, renderLanes2) {
          {
            if (workInProgress2.type !== workInProgress2.elementType) {
              var innerPropTypes = Component2.propTypes;
              if (innerPropTypes) {
                checkPropTypes(
                  innerPropTypes,
                  nextProps,
                  // Resolved props
                  "prop",
                  getComponentName(Component2)
                );
              }
            }
          }
          var hasContext;
          if (isContextProvider(Component2)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          var instance = workInProgress2.stateNode;
          var shouldUpdate;
          if (instance === null) {
            if (current2 !== null) {
              current2.alternate = null;
              workInProgress2.alternate = null;
              workInProgress2.flags |= Placement;
            }
            constructClassInstance(workInProgress2, Component2, nextProps);
            mountClassInstance(workInProgress2, Component2, nextProps, renderLanes2);
            shouldUpdate = true;
          } else if (current2 === null) {
            shouldUpdate = resumeMountClassInstance(workInProgress2, Component2, nextProps, renderLanes2);
          } else {
            shouldUpdate = updateClassInstance(current2, workInProgress2, Component2, nextProps, renderLanes2);
          }
          var nextUnitOfWork = finishClassComponent(current2, workInProgress2, Component2, shouldUpdate, hasContext, renderLanes2);
          {
            var inst = workInProgress2.stateNode;
            if (shouldUpdate && inst.props !== nextProps) {
              if (!didWarnAboutReassigningProps) {
                error2("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress2.type) || "a component");
              }
              didWarnAboutReassigningProps = true;
            }
          }
          return nextUnitOfWork;
        }
        function finishClassComponent(current2, workInProgress2, Component2, shouldUpdate, hasContext, renderLanes2) {
          markRef(current2, workInProgress2);
          var didCaptureError = (workInProgress2.flags & DidCapture) !== NoFlags;
          if (!shouldUpdate && !didCaptureError) {
            if (hasContext) {
              invalidateContextProvider(workInProgress2, Component2, false);
            }
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          var instance = workInProgress2.stateNode;
          ReactCurrentOwner$1.current = workInProgress2;
          var nextChildren;
          if (didCaptureError && typeof Component2.getDerivedStateFromError !== "function") {
            nextChildren = null;
            {
              stopProfilerTimerIfRunning();
            }
          } else {
            {
              setIsRendering(true);
              nextChildren = instance.render();
              setIsRendering(false);
            }
          }
          workInProgress2.flags |= PerformedWork;
          if (current2 !== null && didCaptureError) {
            forceUnmountCurrentAndReconcile(current2, workInProgress2, nextChildren, renderLanes2);
          } else {
            reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          }
          workInProgress2.memoizedState = instance.state;
          if (hasContext) {
            invalidateContextProvider(workInProgress2, Component2, true);
          }
          return workInProgress2.child;
        }
        function pushHostRootContext(workInProgress2) {
          var root2 = workInProgress2.stateNode;
          if (root2.pendingContext) {
            pushTopLevelContextObject(workInProgress2, root2.pendingContext, root2.pendingContext !== root2.context);
          } else if (root2.context) {
            pushTopLevelContextObject(workInProgress2, root2.context, false);
          }
          pushHostContainer(workInProgress2, root2.containerInfo);
        }
        function updateHostRoot(current2, workInProgress2, renderLanes2) {
          pushHostRootContext(workInProgress2);
          var updateQueue2 = workInProgress2.updateQueue;
          if (!(current2 !== null && updateQueue2 !== null)) {
            {
              throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          var nextProps = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          var prevChildren = prevState !== null ? prevState.element : null;
          cloneUpdateQueue(current2, workInProgress2);
          processUpdateQueue(workInProgress2, nextProps, null, renderLanes2);
          var nextState = workInProgress2.memoizedState;
          var nextChildren = nextState.element;
          if (nextChildren === prevChildren) {
            return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
          }
          var root2 = workInProgress2.stateNode;
          if (root2.hydrate && enterHydrationState()) {
            var child = mountChildFibers(workInProgress2, null, nextChildren, renderLanes2);
            workInProgress2.child = child;
            var node2 = child;
            while (node2) {
              node2.flags = node2.flags & ~Placement | Hydrating;
              node2 = node2.sibling;
            }
          } else {
            reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          }
          return workInProgress2.child;
        }
        function updateHostComponent(current2, workInProgress2, renderLanes2) {
          pushHostContext(workInProgress2);
          workInProgress2.type;
          var nextProps = workInProgress2.pendingProps;
          var prevProps = current2 !== null ? current2.memoizedProps : null;
          var nextChildren = nextProps.children;
          if (prevProps !== null && shouldSetTextContent()) {
            workInProgress2.flags |= ContentReset;
          }
          markRef(current2, workInProgress2);
          reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          return workInProgress2.child;
        }
        function updateHostText(current2, workInProgress2) {
          return null;
        }
        function mountLazyComponent(_current, workInProgress2, elementType, updateLanes, renderLanes2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          var props2 = workInProgress2.pendingProps;
          var lazyComponent = elementType;
          var payload = lazyComponent._payload;
          var init2 = lazyComponent._init;
          var Component2 = init2(payload);
          workInProgress2.type = Component2;
          var resolvedTag = workInProgress2.tag = resolveLazyComponentTag(Component2);
          var resolvedProps = resolveDefaultProps(Component2, props2);
          var child;
          switch (resolvedTag) {
            case FunctionComponent: {
              {
                validateFunctionComponentInDev(workInProgress2, Component2);
                workInProgress2.type = Component2 = resolveFunctionForHotReloading(Component2);
              }
              child = updateFunctionComponent(null, workInProgress2, Component2, resolvedProps, renderLanes2);
              return child;
            }
            case ClassComponent: {
              {
                workInProgress2.type = Component2 = resolveClassForHotReloading(Component2);
              }
              child = updateClassComponent(null, workInProgress2, Component2, resolvedProps, renderLanes2);
              return child;
            }
            case ForwardRef: {
              {
                workInProgress2.type = Component2 = resolveForwardRefForHotReloading(Component2);
              }
              child = updateForwardRef(null, workInProgress2, Component2, resolvedProps, renderLanes2);
              return child;
            }
            case MemoComponent: {
              {
                if (workInProgress2.type !== workInProgress2.elementType) {
                  var outerPropTypes = Component2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(
                      outerPropTypes,
                      resolvedProps,
                      // Resolved for outer only
                      "prop",
                      getComponentName(Component2)
                    );
                  }
                }
              }
              child = updateMemoComponent(
                null,
                workInProgress2,
                Component2,
                resolveDefaultProps(Component2.type, resolvedProps),
                // The inner type can have defaults too
                updateLanes,
                renderLanes2
              );
              return child;
            }
          }
          var hint = "";
          {
            if (Component2 !== null && typeof Component2 === "object" && Component2.$$typeof === REACT_LAZY_TYPE) {
              hint = " Did you wrap a component in React.lazy() more than once?";
            }
          }
          {
            {
              throw Error("Element type is invalid. Received a promise that resolves to: " + Component2 + ". Lazy element type must resolve to a class or function." + hint);
            }
          }
        }
        function mountIncompleteClassComponent(_current, workInProgress2, Component2, nextProps, renderLanes2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          workInProgress2.tag = ClassComponent;
          var hasContext;
          if (isContextProvider(Component2)) {
            hasContext = true;
            pushContextProvider(workInProgress2);
          } else {
            hasContext = false;
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          constructClassInstance(workInProgress2, Component2, nextProps);
          mountClassInstance(workInProgress2, Component2, nextProps, renderLanes2);
          return finishClassComponent(null, workInProgress2, Component2, true, hasContext, renderLanes2);
        }
        function mountIndeterminateComponent(_current, workInProgress2, Component2, renderLanes2) {
          if (_current !== null) {
            _current.alternate = null;
            workInProgress2.alternate = null;
            workInProgress2.flags |= Placement;
          }
          var props2 = workInProgress2.pendingProps;
          var context;
          {
            var unmaskedContext = getUnmaskedContext(workInProgress2, Component2, false);
            context = getMaskedContext(workInProgress2, unmaskedContext);
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          var value;
          {
            if (Component2.prototype && typeof Component2.prototype.render === "function") {
              var componentName = getComponentName(Component2) || "Unknown";
              if (!didWarnAboutBadClass[componentName]) {
                error2("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
              }
            }
            if (workInProgress2.mode & StrictMode) {
              ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress2, null);
            }
            setIsRendering(true);
            ReactCurrentOwner$1.current = workInProgress2;
            value = renderWithHooks(null, workInProgress2, Component2, props2, context, renderLanes2);
            setIsRendering(false);
          }
          workInProgress2.flags |= PerformedWork;
          {
            if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0) {
              var _componentName = getComponentName(Component2) || "Unknown";
              if (!didWarnAboutModulePatternComponent[_componentName]) {
                error2("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
              }
            }
          }
          if (
            // Run these checks in production only if the flag is off.
            // Eventually we'll delete this branch altogether.
            typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === void 0
          ) {
            {
              var _componentName2 = getComponentName(Component2) || "Unknown";
              if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error2("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
              }
            }
            workInProgress2.tag = ClassComponent;
            workInProgress2.memoizedState = null;
            workInProgress2.updateQueue = null;
            var hasContext = false;
            if (isContextProvider(Component2)) {
              hasContext = true;
              pushContextProvider(workInProgress2);
            } else {
              hasContext = false;
            }
            workInProgress2.memoizedState = value.state !== null && value.state !== void 0 ? value.state : null;
            initializeUpdateQueue(workInProgress2);
            var getDerivedStateFromProps = Component2.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === "function") {
              applyDerivedStateFromProps(workInProgress2, Component2, getDerivedStateFromProps, props2);
            }
            adoptClassInstance(workInProgress2, value);
            mountClassInstance(workInProgress2, Component2, props2, renderLanes2);
            return finishClassComponent(null, workInProgress2, Component2, true, hasContext, renderLanes2);
          } else {
            workInProgress2.tag = FunctionComponent;
            reconcileChildren(null, workInProgress2, value, renderLanes2);
            {
              validateFunctionComponentInDev(workInProgress2, Component2);
            }
            return workInProgress2.child;
          }
        }
        function validateFunctionComponentInDev(workInProgress2, Component2) {
          {
            if (Component2) {
              if (Component2.childContextTypes) {
                error2("%s(...): childContextTypes cannot be defined on a function component.", Component2.displayName || Component2.name || "Component");
              }
            }
            if (workInProgress2.ref !== null) {
              var info = "";
              var ownerName = getCurrentFiberOwnerNameInDevOrNull();
              if (ownerName) {
                info += "\n\nCheck the render method of `" + ownerName + "`.";
              }
              var warningKey = ownerName || workInProgress2._debugID || "";
              var debugSource = workInProgress2._debugSource;
              if (debugSource) {
                warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
              }
              if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error2("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
              }
            }
            if (typeof Component2.getDerivedStateFromProps === "function") {
              var _componentName3 = getComponentName(Component2) || "Unknown";
              if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error2("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
              }
            }
            if (typeof Component2.contextType === "object" && Component2.contextType !== null) {
              var _componentName4 = getComponentName(Component2) || "Unknown";
              if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error2("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
              }
            }
          }
        }
        var SUSPENDED_MARKER = {
          dehydrated: null,
          retryLane: NoLane
        };
        function mountSuspenseOffscreenState(renderLanes2) {
          return {
            baseLanes: renderLanes2
          };
        }
        function updateSuspenseOffscreenState(prevOffscreenState, renderLanes2) {
          return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes2)
          };
        }
        function shouldRemainOnFallback(suspenseContext, current2, workInProgress2, renderLanes2) {
          if (current2 !== null) {
            var suspenseState = current2.memoizedState;
            if (suspenseState === null) {
              return false;
            }
          }
          return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        }
        function getRemainingWorkInPrimaryTree(current2, renderLanes2) {
          return removeLanes(current2.childLanes, renderLanes2);
        }
        function updateSuspenseComponent(current2, workInProgress2, renderLanes2) {
          var nextProps = workInProgress2.pendingProps;
          {
            if (shouldSuspend(workInProgress2)) {
              workInProgress2.flags |= DidCapture;
            }
          }
          var suspenseContext = suspenseStackCursor.current;
          var showFallback = false;
          var didSuspend = (workInProgress2.flags & DidCapture) !== NoFlags;
          if (didSuspend || shouldRemainOnFallback(suspenseContext, current2)) {
            showFallback = true;
            workInProgress2.flags &= ~DidCapture;
          } else {
            if (current2 === null || current2.memoizedState !== null) {
              if (nextProps.fallback !== void 0 && nextProps.unstable_avoidThisFallback !== true) {
                suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
              }
            }
          }
          suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          pushSuspenseContext(workInProgress2, suspenseContext);
          if (current2 === null) {
            if (nextProps.fallback !== void 0)
              ;
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
              var fallbackFragment = mountSuspenseFallbackChildren(workInProgress2, nextPrimaryChildren, nextFallbackChildren, renderLanes2);
              var primaryChildFragment = workInProgress2.child;
              primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes2);
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === "number") {
              var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress2, nextPrimaryChildren, nextFallbackChildren, renderLanes2);
              var _primaryChildFragment = workInProgress2.child;
              _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes2);
              workInProgress2.memoizedState = SUSPENDED_MARKER;
              workInProgress2.lanes = SomeRetryLane;
              {
                markSpawnedWork(SomeRetryLane);
              }
              return _fallbackFragment;
            } else {
              return mountSuspensePrimaryChildren(workInProgress2, nextPrimaryChildren, renderLanes2);
            }
          } else {
            var prevState = current2.memoizedState;
            if (prevState !== null) {
              if (showFallback) {
                var _nextFallbackChildren2 = nextProps.fallback;
                var _nextPrimaryChildren2 = nextProps.children;
                var _fallbackChildFragment = updateSuspenseFallbackChildren(current2, workInProgress2, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes2);
                var _primaryChildFragment3 = workInProgress2.child;
                var prevOffscreenState = current2.child.memoizedState;
                _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes2) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes2);
                _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current2, renderLanes2);
                workInProgress2.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment;
              } else {
                var _nextPrimaryChildren3 = nextProps.children;
                var _primaryChildFragment4 = updateSuspensePrimaryChildren(current2, workInProgress2, _nextPrimaryChildren3, renderLanes2);
                workInProgress2.memoizedState = null;
                return _primaryChildFragment4;
              }
            } else {
              if (showFallback) {
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;
                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current2, workInProgress2, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes2);
                var _primaryChildFragment5 = workInProgress2.child;
                var _prevOffscreenState = current2.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes2) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes2);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current2, renderLanes2);
                workInProgress2.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
              } else {
                var _nextPrimaryChildren5 = nextProps.children;
                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current2, workInProgress2, _nextPrimaryChildren5, renderLanes2);
                workInProgress2.memoizedState = null;
                return _primaryChildFragment6;
              }
            }
          }
        }
        function mountSuspensePrimaryChildren(workInProgress2, primaryChildren, renderLanes2) {
          var mode = workInProgress2.mode;
          var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
          };
          var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes2, null);
          primaryChildFragment.return = workInProgress2;
          workInProgress2.child = primaryChildFragment;
          return primaryChildFragment;
        }
        function mountSuspenseFallbackChildren(workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
          var mode = workInProgress2.mode;
          var progressedPrimaryFragment = workInProgress2.child;
          var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
          };
          var primaryChildFragment;
          var fallbackChildFragment;
          if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress2.mode & ProfileMode) {
              primaryChildFragment.actualDuration = 0;
              primaryChildFragment.actualStartTime = -1;
              primaryChildFragment.selfBaseDuration = 0;
              primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes2, null);
          } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes2, null);
          }
          primaryChildFragment.return = workInProgress2;
          fallbackChildFragment.return = workInProgress2;
          primaryChildFragment.sibling = fallbackChildFragment;
          workInProgress2.child = primaryChildFragment;
          return fallbackChildFragment;
        }
        function createWorkInProgressOffscreenFiber(current2, offscreenProps) {
          return createWorkInProgress(current2, offscreenProps);
        }
        function updateSuspensePrimaryChildren(current2, workInProgress2, primaryChildren, renderLanes2) {
          var currentPrimaryChildFragment = current2.child;
          var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
          var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
          });
          if ((workInProgress2.mode & BlockingMode) === NoMode) {
            primaryChildFragment.lanes = renderLanes2;
          }
          primaryChildFragment.return = workInProgress2;
          primaryChildFragment.sibling = null;
          if (currentFallbackChildFragment !== null) {
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress2.firstEffect = workInProgress2.lastEffect = currentFallbackChildFragment;
          }
          workInProgress2.child = primaryChildFragment;
          return primaryChildFragment;
        }
        function updateSuspenseFallbackChildren(current2, workInProgress2, primaryChildren, fallbackChildren, renderLanes2) {
          var mode = workInProgress2.mode;
          var currentPrimaryChildFragment = current2.child;
          var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
          var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
          };
          var primaryChildFragment;
          if (
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
            // already cloned. In legacy mode, the only case where this isn't true is
            // when DevTools forces us to display a fallback; we skip the first render
            // pass entirely and go straight to rendering the fallback. (In Concurrent
            // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
            // only codepath.)
            workInProgress2.child !== currentPrimaryChildFragment
          ) {
            var progressedPrimaryFragment = workInProgress2.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress2.mode & ProfileMode) {
              primaryChildFragment.actualDuration = 0;
              primaryChildFragment.actualStartTime = -1;
              primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
              primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            }
            var progressedLastEffect = primaryChildFragment.lastEffect;
            if (progressedLastEffect !== null) {
              workInProgress2.firstEffect = primaryChildFragment.firstEffect;
              workInProgress2.lastEffect = progressedLastEffect;
              progressedLastEffect.nextEffect = null;
            } else {
              workInProgress2.firstEffect = workInProgress2.lastEffect = null;
            }
          } else {
            primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
          }
          var fallbackChildFragment;
          if (currentFallbackChildFragment !== null) {
            fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
          } else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes2, null);
            fallbackChildFragment.flags |= Placement;
          }
          fallbackChildFragment.return = workInProgress2;
          primaryChildFragment.return = workInProgress2;
          primaryChildFragment.sibling = fallbackChildFragment;
          workInProgress2.child = primaryChildFragment;
          return fallbackChildFragment;
        }
        function scheduleWorkOnFiber(fiber, renderLanes2) {
          fiber.lanes = mergeLanes(fiber.lanes, renderLanes2);
          var alternate = fiber.alternate;
          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, renderLanes2);
          }
          scheduleWorkOnParentPath(fiber.return, renderLanes2);
        }
        function propagateSuspenseContextChange(workInProgress2, firstChild, renderLanes2) {
          var node2 = firstChild;
          while (node2 !== null) {
            if (node2.tag === SuspenseComponent) {
              var state = node2.memoizedState;
              if (state !== null) {
                scheduleWorkOnFiber(node2, renderLanes2);
              }
            } else if (node2.tag === SuspenseListComponent) {
              scheduleWorkOnFiber(node2, renderLanes2);
            } else if (node2.child !== null) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === workInProgress2) {
              return;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === workInProgress2) {
                return;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function findLastContentRow(firstChild) {
          var row = firstChild;
          var lastContentRow = null;
          while (row !== null) {
            var currentRow = row.alternate;
            if (currentRow !== null && findFirstSuspended(currentRow) === null) {
              lastContentRow = row;
            }
            row = row.sibling;
          }
          return lastContentRow;
        }
        function validateRevealOrder(revealOrder) {
          {
            if (revealOrder !== void 0 && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
              didWarnAboutRevealOrder[revealOrder] = true;
              if (typeof revealOrder === "string") {
                switch (revealOrder.toLowerCase()) {
                  case "together":
                  case "forwards":
                  case "backwards": {
                    error2('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                  case "forward":
                  case "backward": {
                    error2('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                  }
                  default:
                    error2('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
                }
              } else {
                error2('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
              }
            }
          }
        }
        function validateTailOptions(tailMode, revealOrder) {
          {
            if (tailMode !== void 0 && !didWarnAboutTailOptions[tailMode]) {
              if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error2('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
              } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error2('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
              }
            }
          }
        }
        function validateSuspenseListNestedChild(childSlot, index3) {
          {
            var isArray3 = Array.isArray(childSlot);
            var isIterable2 = !isArray3 && typeof getIteratorFn(childSlot) === "function";
            if (isArray3 || isIterable2) {
              var type2 = isArray3 ? "array" : "iterable";
              error2("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type2, index3, type2);
              return false;
            }
          }
          return true;
        }
        function validateSuspenseListChildren(children2, revealOrder) {
          {
            if ((revealOrder === "forwards" || revealOrder === "backwards") && children2 !== void 0 && children2 !== null && children2 !== false) {
              if (Array.isArray(children2)) {
                for (var i2 = 0; i2 < children2.length; i2++) {
                  if (!validateSuspenseListNestedChild(children2[i2], i2)) {
                    return;
                  }
                }
              } else {
                var iteratorFn = getIteratorFn(children2);
                if (typeof iteratorFn === "function") {
                  var childrenIterator = iteratorFn.call(children2);
                  if (childrenIterator) {
                    var step2 = childrenIterator.next();
                    var _i = 0;
                    for (; !step2.done; step2 = childrenIterator.next()) {
                      if (!validateSuspenseListNestedChild(step2.value, _i)) {
                        return;
                      }
                      _i++;
                    }
                  }
                } else {
                  error2('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
                }
              }
            }
          }
        }
        function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
          var renderState = workInProgress2.memoizedState;
          if (renderState === null) {
            workInProgress2.memoizedState = {
              isBackwards,
              rendering: null,
              renderingStartTime: 0,
              last: lastContentRow,
              tail,
              tailMode,
              lastEffect: lastEffectBeforeRendering
            };
          } else {
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
          }
        }
        function updateSuspenseListComponent(current2, workInProgress2, renderLanes2) {
          var nextProps = workInProgress2.pendingProps;
          var revealOrder = nextProps.revealOrder;
          var tailMode = nextProps.tail;
          var newChildren = nextProps.children;
          validateRevealOrder(revealOrder);
          validateTailOptions(tailMode, revealOrder);
          validateSuspenseListChildren(newChildren, revealOrder);
          reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
          var suspenseContext = suspenseStackCursor.current;
          var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
          if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress2.flags |= DidCapture;
          } else {
            var didSuspendBefore = current2 !== null && (current2.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) {
              propagateSuspenseContextChange(workInProgress2, workInProgress2.child, renderLanes2);
            }
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
          }
          pushSuspenseContext(workInProgress2, suspenseContext);
          if ((workInProgress2.mode & BlockingMode) === NoMode) {
            workInProgress2.memoizedState = null;
          } else {
            switch (revealOrder) {
              case "forwards": {
                var lastContentRow = findLastContentRow(workInProgress2.child);
                var tail;
                if (lastContentRow === null) {
                  tail = workInProgress2.child;
                  workInProgress2.child = null;
                } else {
                  tail = lastContentRow.sibling;
                  lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(
                  workInProgress2,
                  false,
                  // isBackwards
                  tail,
                  lastContentRow,
                  tailMode,
                  workInProgress2.lastEffect
                );
                break;
              }
              case "backwards": {
                var _tail = null;
                var row = workInProgress2.child;
                workInProgress2.child = null;
                while (row !== null) {
                  var currentRow = row.alternate;
                  if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                    workInProgress2.child = row;
                    break;
                  }
                  var nextRow = row.sibling;
                  row.sibling = _tail;
                  _tail = row;
                  row = nextRow;
                }
                initSuspenseListRenderState(
                  workInProgress2,
                  true,
                  // isBackwards
                  _tail,
                  null,
                  // last
                  tailMode,
                  workInProgress2.lastEffect
                );
                break;
              }
              case "together": {
                initSuspenseListRenderState(
                  workInProgress2,
                  false,
                  // isBackwards
                  null,
                  // tail
                  null,
                  // last
                  void 0,
                  workInProgress2.lastEffect
                );
                break;
              }
              default: {
                workInProgress2.memoizedState = null;
              }
            }
          }
          return workInProgress2.child;
        }
        function updatePortalComponent(current2, workInProgress2, renderLanes2) {
          pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
          var nextChildren = workInProgress2.pendingProps;
          if (current2 === null) {
            workInProgress2.child = reconcileChildFibers(workInProgress2, null, nextChildren, renderLanes2);
          } else {
            reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
          }
          return workInProgress2.child;
        }
        var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
        function updateContextProvider(current2, workInProgress2, renderLanes2) {
          var providerType = workInProgress2.type;
          var context = providerType._context;
          var newProps = workInProgress2.pendingProps;
          var oldProps = workInProgress2.memoizedProps;
          var newValue = newProps.value;
          {
            if (!("value" in newProps)) {
              if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error2("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
              }
            }
            var providerPropTypes = workInProgress2.type.propTypes;
            if (providerPropTypes) {
              checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
            }
          }
          pushProvider(workInProgress2, newValue);
          if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
              if (oldProps.children === newProps.children && !hasContextChanged()) {
                return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
              }
            } else {
              propagateContextChange(workInProgress2, context, changedBits, renderLanes2);
            }
          }
          var newChildren = newProps.children;
          reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
          return workInProgress2.child;
        }
        var hasWarnedAboutUsingContextAsConsumer = false;
        function updateContextConsumer(current2, workInProgress2, renderLanes2) {
          var context = workInProgress2.type;
          {
            if (context._context === void 0) {
              if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                  hasWarnedAboutUsingContextAsConsumer = true;
                  error2("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
              }
            } else {
              context = context._context;
            }
          }
          var newProps = workInProgress2.pendingProps;
          var render = newProps.children;
          {
            if (typeof render !== "function") {
              error2("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
            }
          }
          prepareToReadContext(workInProgress2, renderLanes2);
          var newValue = readContext(context, newProps.unstable_observedBits);
          var newChildren;
          {
            ReactCurrentOwner$1.current = workInProgress2;
            setIsRendering(true);
            newChildren = render(newValue);
            setIsRendering(false);
          }
          workInProgress2.flags |= PerformedWork;
          reconcileChildren(current2, workInProgress2, newChildren, renderLanes2);
          return workInProgress2.child;
        }
        function markWorkInProgressReceivedUpdate() {
          didReceiveUpdate = true;
        }
        function bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2) {
          if (current2 !== null) {
            workInProgress2.dependencies = current2.dependencies;
          }
          {
            stopProfilerTimerIfRunning();
          }
          markSkippedUpdateLanes(workInProgress2.lanes);
          if (!includesSomeLane(renderLanes2, workInProgress2.childLanes)) {
            return null;
          } else {
            cloneChildFibers(current2, workInProgress2);
            return workInProgress2.child;
          }
        }
        function remountFiber(current2, oldWorkInProgress, newWorkInProgress) {
          {
            var returnFiber = oldWorkInProgress.return;
            if (returnFiber === null) {
              throw new Error("Cannot swap the root fiber.");
            }
            current2.alternate = null;
            oldWorkInProgress.alternate = null;
            newWorkInProgress.index = oldWorkInProgress.index;
            newWorkInProgress.sibling = oldWorkInProgress.sibling;
            newWorkInProgress.return = oldWorkInProgress.return;
            newWorkInProgress.ref = oldWorkInProgress.ref;
            if (oldWorkInProgress === returnFiber.child) {
              returnFiber.child = newWorkInProgress;
            } else {
              var prevSibling = returnFiber.child;
              if (prevSibling === null) {
                throw new Error("Expected parent to have a child.");
              }
              while (prevSibling.sibling !== oldWorkInProgress) {
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) {
                  throw new Error("Expected to find the previous sibling.");
                }
              }
              prevSibling.sibling = newWorkInProgress;
            }
            var last2 = returnFiber.lastEffect;
            if (last2 !== null) {
              last2.nextEffect = current2;
              returnFiber.lastEffect = current2;
            } else {
              returnFiber.firstEffect = returnFiber.lastEffect = current2;
            }
            current2.nextEffect = null;
            current2.flags = Deletion;
            newWorkInProgress.flags |= Placement;
            return newWorkInProgress;
          }
        }
        function beginWork(current2, workInProgress2, renderLanes2) {
          var updateLanes = workInProgress2.lanes;
          {
            if (workInProgress2._debugNeedsRemount && current2 !== null) {
              return remountFiber(current2, workInProgress2, createFiberFromTypeAndProps(workInProgress2.type, workInProgress2.key, workInProgress2.pendingProps, workInProgress2._debugOwner || null, workInProgress2.mode, workInProgress2.lanes));
            }
          }
          if (current2 !== null) {
            var oldProps = current2.memoizedProps;
            var newProps = workInProgress2.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || // Force a re-render if the implementation changed due to hot reload:
            workInProgress2.type !== current2.type) {
              didReceiveUpdate = true;
            } else if (!includesSomeLane(renderLanes2, updateLanes)) {
              didReceiveUpdate = false;
              switch (workInProgress2.tag) {
                case HostRoot:
                  pushHostRootContext(workInProgress2);
                  break;
                case HostComponent:
                  pushHostContext(workInProgress2);
                  break;
                case ClassComponent: {
                  var Component2 = workInProgress2.type;
                  if (isContextProvider(Component2)) {
                    pushContextProvider(workInProgress2);
                  }
                  break;
                }
                case HostPortal:
                  pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
                  break;
                case ContextProvider: {
                  var newValue = workInProgress2.memoizedProps.value;
                  pushProvider(workInProgress2, newValue);
                  break;
                }
                case Profiler:
                  {
                    var hasChildWork = includesSomeLane(renderLanes2, workInProgress2.childLanes);
                    if (hasChildWork) {
                      workInProgress2.flags |= Update;
                    }
                    var stateNode = workInProgress2.stateNode;
                    stateNode.effectDuration = 0;
                    stateNode.passiveEffectDuration = 0;
                  }
                  break;
                case SuspenseComponent: {
                  var state = workInProgress2.memoizedState;
                  if (state !== null) {
                    var primaryChildFragment = workInProgress2.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes2, primaryChildLanes)) {
                      return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
                    } else {
                      pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                      var child = bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
                      if (child !== null) {
                        return child.sibling;
                      } else {
                        return null;
                      }
                    }
                  } else {
                    pushSuspenseContext(workInProgress2, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                  }
                  break;
                }
                case SuspenseListComponent: {
                  var didSuspendBefore = (current2.flags & DidCapture) !== NoFlags;
                  var _hasChildWork = includesSomeLane(renderLanes2, workInProgress2.childLanes);
                  if (didSuspendBefore) {
                    if (_hasChildWork) {
                      return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
                    }
                    workInProgress2.flags |= DidCapture;
                  }
                  var renderState = workInProgress2.memoizedState;
                  if (renderState !== null) {
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                  }
                  pushSuspenseContext(workInProgress2, suspenseStackCursor.current);
                  if (_hasChildWork) {
                    break;
                  } else {
                    return null;
                  }
                }
                case OffscreenComponent:
                case LegacyHiddenComponent: {
                  workInProgress2.lanes = NoLanes;
                  return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
                }
              }
              return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
            } else {
              if ((current2.flags & ForceUpdateForLegacySuspense) !== NoFlags) {
                didReceiveUpdate = true;
              } else {
                didReceiveUpdate = false;
              }
            }
          } else {
            didReceiveUpdate = false;
          }
          workInProgress2.lanes = NoLanes;
          switch (workInProgress2.tag) {
            case IndeterminateComponent: {
              return mountIndeterminateComponent(current2, workInProgress2, workInProgress2.type, renderLanes2);
            }
            case LazyComponent: {
              var elementType = workInProgress2.elementType;
              return mountLazyComponent(current2, workInProgress2, elementType, updateLanes, renderLanes2);
            }
            case FunctionComponent: {
              var _Component = workInProgress2.type;
              var unresolvedProps = workInProgress2.pendingProps;
              var resolvedProps = workInProgress2.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
              return updateFunctionComponent(current2, workInProgress2, _Component, resolvedProps, renderLanes2);
            }
            case ClassComponent: {
              var _Component2 = workInProgress2.type;
              var _unresolvedProps = workInProgress2.pendingProps;
              var _resolvedProps = workInProgress2.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
              return updateClassComponent(current2, workInProgress2, _Component2, _resolvedProps, renderLanes2);
            }
            case HostRoot:
              return updateHostRoot(current2, workInProgress2, renderLanes2);
            case HostComponent:
              return updateHostComponent(current2, workInProgress2, renderLanes2);
            case HostText:
              return updateHostText();
            case SuspenseComponent:
              return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
            case HostPortal:
              return updatePortalComponent(current2, workInProgress2, renderLanes2);
            case ForwardRef: {
              var type2 = workInProgress2.type;
              var _unresolvedProps2 = workInProgress2.pendingProps;
              var _resolvedProps2 = workInProgress2.elementType === type2 ? _unresolvedProps2 : resolveDefaultProps(type2, _unresolvedProps2);
              return updateForwardRef(current2, workInProgress2, type2, _resolvedProps2, renderLanes2);
            }
            case Fragment2:
              return updateFragment(current2, workInProgress2, renderLanes2);
            case Mode:
              return updateMode(current2, workInProgress2, renderLanes2);
            case Profiler:
              return updateProfiler(current2, workInProgress2, renderLanes2);
            case ContextProvider:
              return updateContextProvider(current2, workInProgress2, renderLanes2);
            case ContextConsumer:
              return updateContextConsumer(current2, workInProgress2, renderLanes2);
            case MemoComponent: {
              var _type2 = workInProgress2.type;
              var _unresolvedProps3 = workInProgress2.pendingProps;
              var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
              {
                if (workInProgress2.type !== workInProgress2.elementType) {
                  var outerPropTypes = _type2.propTypes;
                  if (outerPropTypes) {
                    checkPropTypes(
                      outerPropTypes,
                      _resolvedProps3,
                      // Resolved for outer only
                      "prop",
                      getComponentName(_type2)
                    );
                  }
                }
              }
              _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
              return updateMemoComponent(current2, workInProgress2, _type2, _resolvedProps3, updateLanes, renderLanes2);
            }
            case SimpleMemoComponent: {
              return updateSimpleMemoComponent(current2, workInProgress2, workInProgress2.type, workInProgress2.pendingProps, updateLanes, renderLanes2);
            }
            case IncompleteClassComponent: {
              var _Component3 = workInProgress2.type;
              var _unresolvedProps4 = workInProgress2.pendingProps;
              var _resolvedProps4 = workInProgress2.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
              return mountIncompleteClassComponent(current2, workInProgress2, _Component3, _resolvedProps4, renderLanes2);
            }
            case SuspenseListComponent: {
              return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
            }
            case FundamentalComponent: {
              break;
            }
            case ScopeComponent: {
              break;
            }
            case Block: {
              break;
            }
            case OffscreenComponent: {
              return updateOffscreenComponent(current2, workInProgress2, renderLanes2);
            }
            case LegacyHiddenComponent: {
              return updateLegacyHiddenComponent(current2, workInProgress2, renderLanes2);
            }
          }
          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function markUpdate(workInProgress2) {
          workInProgress2.flags |= Update;
        }
        function markRef$1(workInProgress2) {
          workInProgress2.flags |= Ref;
        }
        var appendAllChildren;
        var updateHostContainer;
        var updateHostComponent$1;
        var updateHostText$1;
        {
          appendAllChildren = function(parent2, workInProgress2, needsVisibilityToggle, isHidden2) {
            var node2 = workInProgress2.child;
            while (node2 !== null) {
              if (node2.tag === HostComponent || node2.tag === HostText) {
                appendInitialChild(parent2, node2.stateNode);
              } else if (node2.tag === HostPortal)
                ;
              else if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              if (node2 === workInProgress2) {
                return;
              }
              while (node2.sibling === null) {
                if (node2.return === null || node2.return === workInProgress2) {
                  return;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          };
          updateHostContainer = function(workInProgress2) {
          };
          updateHostComponent$1 = function(current2, workInProgress2, type2, newProps, rootContainerInstance) {
            var oldProps = current2.memoizedProps;
            if (oldProps === newProps) {
              return;
            }
            workInProgress2.stateNode;
            getHostContext();
            var updatePayload = prepareUpdate();
            workInProgress2.updateQueue = updatePayload;
            if (updatePayload) {
              markUpdate(workInProgress2);
            }
          };
          updateHostText$1 = function(current2, workInProgress2, oldText, newText) {
            if (oldText !== newText) {
              markUpdate(workInProgress2);
            }
          };
        }
        function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
          switch (renderState.tailMode) {
            case "hidden": {
              var tailNode = renderState.tail;
              var lastTailNode = null;
              while (tailNode !== null) {
                if (tailNode.alternate !== null) {
                  lastTailNode = tailNode;
                }
                tailNode = tailNode.sibling;
              }
              if (lastTailNode === null) {
                renderState.tail = null;
              } else {
                lastTailNode.sibling = null;
              }
              break;
            }
            case "collapsed": {
              var _tailNode = renderState.tail;
              var _lastTailNode = null;
              while (_tailNode !== null) {
                if (_tailNode.alternate !== null) {
                  _lastTailNode = _tailNode;
                }
                _tailNode = _tailNode.sibling;
              }
              if (_lastTailNode === null) {
                if (!hasRenderedATailFallback && renderState.tail !== null) {
                  renderState.tail.sibling = null;
                } else {
                  renderState.tail = null;
                }
              } else {
                _lastTailNode.sibling = null;
              }
              break;
            }
          }
        }
        function completeWork(current2, workInProgress2, renderLanes2) {
          var newProps = workInProgress2.pendingProps;
          switch (workInProgress2.tag) {
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment2:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
              return null;
            case ClassComponent: {
              var Component2 = workInProgress2.type;
              if (isContextProvider(Component2)) {
                popContext(workInProgress2);
              }
              return null;
            }
            case HostRoot: {
              popHostContainer(workInProgress2);
              popTopLevelContextObject(workInProgress2);
              resetWorkInProgressVersions();
              var fiberRoot = workInProgress2.stateNode;
              if (fiberRoot.pendingContext) {
                fiberRoot.context = fiberRoot.pendingContext;
                fiberRoot.pendingContext = null;
              }
              if (current2 === null || current2.child === null) {
                var wasHydrated = popHydrationState();
                if (wasHydrated) {
                  markUpdate(workInProgress2);
                } else if (!fiberRoot.hydrate) {
                  workInProgress2.flags |= Snapshot;
                }
              }
              updateHostContainer(workInProgress2);
              return null;
            }
            case HostComponent: {
              popHostContext(workInProgress2);
              var rootContainerInstance = getRootHostContainer();
              var type2 = workInProgress2.type;
              if (current2 !== null && workInProgress2.stateNode != null) {
                updateHostComponent$1(current2, workInProgress2, type2, newProps, rootContainerInstance);
                if (current2.ref !== workInProgress2.ref) {
                  markRef$1(workInProgress2);
                }
              } else {
                if (!newProps) {
                  if (!(workInProgress2.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                  return null;
                }
                var currentHostContext = getHostContext();
                var _wasHydrated = popHydrationState();
                if (_wasHydrated) {
                  if (prepareToHydrateHostInstance()) {
                    markUpdate(workInProgress2);
                  }
                } else {
                  var instance = createInstance2(type2, newProps, rootContainerInstance, currentHostContext, workInProgress2);
                  appendAllChildren(instance, workInProgress2, false, false);
                  workInProgress2.stateNode = instance;
                }
                if (workInProgress2.ref !== null) {
                  markRef$1(workInProgress2);
                }
              }
              return null;
            }
            case HostText: {
              var newText = newProps;
              if (current2 && workInProgress2.stateNode != null) {
                var oldText = current2.memoizedProps;
                updateHostText$1(current2, workInProgress2, oldText, newText);
              } else {
                if (typeof newText !== "string") {
                  if (!(workInProgress2.stateNode !== null)) {
                    {
                      throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                }
                getRootHostContainer();
                getHostContext();
                var _wasHydrated2 = popHydrationState();
                if (_wasHydrated2) {
                  if (prepareToHydrateHostTextInstance()) {
                    markUpdate(workInProgress2);
                  }
                } else {
                  workInProgress2.stateNode = createTextInstance(newText);
                }
              }
              return null;
            }
            case SuspenseComponent: {
              popSuspenseContext(workInProgress2);
              var nextState = workInProgress2.memoizedState;
              if ((workInProgress2.flags & DidCapture) !== NoFlags) {
                workInProgress2.lanes = renderLanes2;
                if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress2);
                }
                return workInProgress2;
              }
              var nextDidTimeout = nextState !== null;
              var prevDidTimeout = false;
              if (current2 === null) {
                if (workInProgress2.memoizedProps.fallback !== void 0)
                  ;
              } else {
                var prevState = current2.memoizedState;
                prevDidTimeout = prevState !== null;
              }
              if (nextDidTimeout && !prevDidTimeout) {
                if ((workInProgress2.mode & BlockingMode) !== NoMode) {
                  var hasInvisibleChildContext = current2 === null && workInProgress2.memoizedProps.unstable_avoidThisFallback !== true;
                  if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) {
                    renderDidSuspend();
                  } else {
                    renderDidSuspendDelayIfPossible();
                  }
                }
              }
              {
                if (nextDidTimeout || prevDidTimeout) {
                  workInProgress2.flags |= Update;
                }
              }
              return null;
            }
            case HostPortal:
              popHostContainer(workInProgress2);
              updateHostContainer(workInProgress2);
              if (current2 === null) {
                preparePortalMount(workInProgress2.stateNode.containerInfo);
              }
              return null;
            case ContextProvider:
              popProvider(workInProgress2);
              return null;
            case IncompleteClassComponent: {
              var _Component = workInProgress2.type;
              if (isContextProvider(_Component)) {
                popContext(workInProgress2);
              }
              return null;
            }
            case SuspenseListComponent: {
              popSuspenseContext(workInProgress2);
              var renderState = workInProgress2.memoizedState;
              if (renderState === null) {
                return null;
              }
              var didSuspendAlready = (workInProgress2.flags & DidCapture) !== NoFlags;
              var renderedTail = renderState.rendering;
              if (renderedTail === null) {
                if (!didSuspendAlready) {
                  var cannotBeSuspended = renderHasNotSuspendedYet() && (current2 === null || (current2.flags & DidCapture) === NoFlags);
                  if (!cannotBeSuspended) {
                    var row = workInProgress2.child;
                    while (row !== null) {
                      var suspended = findFirstSuspended(row);
                      if (suspended !== null) {
                        didSuspendAlready = true;
                        workInProgress2.flags |= DidCapture;
                        cutOffTailIfNeeded(renderState, false);
                        var newThennables = suspended.updateQueue;
                        if (newThennables !== null) {
                          workInProgress2.updateQueue = newThennables;
                          workInProgress2.flags |= Update;
                        }
                        if (renderState.lastEffect === null) {
                          workInProgress2.firstEffect = null;
                        }
                        workInProgress2.lastEffect = renderState.lastEffect;
                        resetChildFibers(workInProgress2, renderLanes2);
                        pushSuspenseContext(workInProgress2, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                        return workInProgress2.child;
                      }
                      row = row.sibling;
                    }
                  }
                  if (renderState.tail !== null && now2() > getRenderTargetTime()) {
                    workInProgress2.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress2.lanes = SomeRetryLane;
                    {
                      markSpawnedWork(SomeRetryLane);
                    }
                  }
                } else {
                  cutOffTailIfNeeded(renderState, false);
                }
              } else {
                if (!didSuspendAlready) {
                  var _suspended = findFirstSuspended(renderedTail);
                  if (_suspended !== null) {
                    workInProgress2.flags |= DidCapture;
                    didSuspendAlready = true;
                    var _newThennables = _suspended.updateQueue;
                    if (_newThennables !== null) {
                      workInProgress2.updateQueue = _newThennables;
                      workInProgress2.flags |= Update;
                    }
                    cutOffTailIfNeeded(renderState, true);
                    if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating()) {
                      var lastEffect = workInProgress2.lastEffect = renderState.lastEffect;
                      if (lastEffect !== null) {
                        lastEffect.nextEffect = null;
                      }
                      return null;
                    }
                  } else if (
                    // The time it took to render last row is greater than the remaining
                    // time we have to render. So rendering one more row would likely
                    // exceed it.
                    now2() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes2 !== OffscreenLane
                  ) {
                    workInProgress2.flags |= DidCapture;
                    didSuspendAlready = true;
                    cutOffTailIfNeeded(renderState, false);
                    workInProgress2.lanes = SomeRetryLane;
                    {
                      markSpawnedWork(SomeRetryLane);
                    }
                  }
                }
                if (renderState.isBackwards) {
                  renderedTail.sibling = workInProgress2.child;
                  workInProgress2.child = renderedTail;
                } else {
                  var previousSibling = renderState.last;
                  if (previousSibling !== null) {
                    previousSibling.sibling = renderedTail;
                  } else {
                    workInProgress2.child = renderedTail;
                  }
                  renderState.last = renderedTail;
                }
              }
              if (renderState.tail !== null) {
                var next2 = renderState.tail;
                renderState.rendering = next2;
                renderState.tail = next2.sibling;
                renderState.lastEffect = workInProgress2.lastEffect;
                renderState.renderingStartTime = now2();
                next2.sibling = null;
                var suspenseContext = suspenseStackCursor.current;
                if (didSuspendAlready) {
                  suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                } else {
                  suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                }
                pushSuspenseContext(workInProgress2, suspenseContext);
                return next2;
              }
              return null;
            }
            case FundamentalComponent: {
              break;
            }
            case ScopeComponent: {
              break;
            }
            case Block:
              break;
            case OffscreenComponent:
            case LegacyHiddenComponent: {
              popRenderLanes(workInProgress2);
              if (current2 !== null) {
                var _nextState = workInProgress2.memoizedState;
                var _prevState = current2.memoizedState;
                var prevIsHidden = _prevState !== null;
                var nextIsHidden = _nextState !== null;
                if (prevIsHidden !== nextIsHidden && newProps.mode !== "unstable-defer-without-hiding") {
                  workInProgress2.flags |= Update;
                }
              }
              return null;
            }
          }
          {
            {
              throw Error("Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function unwindWork(workInProgress2, renderLanes2) {
          switch (workInProgress2.tag) {
            case ClassComponent: {
              var Component2 = workInProgress2.type;
              if (isContextProvider(Component2)) {
                popContext(workInProgress2);
              }
              var flags3 = workInProgress2.flags;
              if (flags3 & ShouldCapture) {
                workInProgress2.flags = flags3 & ~ShouldCapture | DidCapture;
                if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress2);
                }
                return workInProgress2;
              }
              return null;
            }
            case HostRoot: {
              popHostContainer(workInProgress2);
              popTopLevelContextObject(workInProgress2);
              resetWorkInProgressVersions();
              var _flags = workInProgress2.flags;
              if (!((_flags & DidCapture) === NoFlags)) {
                {
                  throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                }
              }
              workInProgress2.flags = _flags & ~ShouldCapture | DidCapture;
              return workInProgress2;
            }
            case HostComponent: {
              popHostContext(workInProgress2);
              return null;
            }
            case SuspenseComponent: {
              popSuspenseContext(workInProgress2);
              var _flags2 = workInProgress2.flags;
              if (_flags2 & ShouldCapture) {
                workInProgress2.flags = _flags2 & ~ShouldCapture | DidCapture;
                if ((workInProgress2.mode & ProfileMode) !== NoMode) {
                  transferActualDuration(workInProgress2);
                }
                return workInProgress2;
              }
              return null;
            }
            case SuspenseListComponent: {
              popSuspenseContext(workInProgress2);
              return null;
            }
            case HostPortal:
              popHostContainer(workInProgress2);
              return null;
            case ContextProvider:
              popProvider(workInProgress2);
              return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
              popRenderLanes(workInProgress2);
              return null;
            default:
              return null;
          }
        }
        function unwindInterruptedWork(interruptedWork) {
          switch (interruptedWork.tag) {
            case ClassComponent: {
              var childContextTypes = interruptedWork.type.childContextTypes;
              if (childContextTypes !== null && childContextTypes !== void 0) {
                popContext(interruptedWork);
              }
              break;
            }
            case HostRoot: {
              popHostContainer(interruptedWork);
              popTopLevelContextObject(interruptedWork);
              resetWorkInProgressVersions();
              break;
            }
            case HostComponent: {
              popHostContext(interruptedWork);
              break;
            }
            case HostPortal:
              popHostContainer(interruptedWork);
              break;
            case SuspenseComponent:
              popSuspenseContext(interruptedWork);
              break;
            case SuspenseListComponent:
              popSuspenseContext(interruptedWork);
              break;
            case ContextProvider:
              popProvider(interruptedWork);
              break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
              popRenderLanes(interruptedWork);
              break;
          }
        }
        function createCapturedValue(value, source) {
          return {
            value,
            source,
            stack: getStackByFiberInDevAndProd(source)
          };
        }
        function showErrorDialog(boundary, errorInfo) {
          return true;
        }
        function logCapturedError(boundary, errorInfo) {
          try {
            var logError = showErrorDialog(boundary, errorInfo);
            if (logError === false) {
              return;
            }
            var error3 = errorInfo.value;
            if (true) {
              var source = errorInfo.source;
              var stack2 = errorInfo.stack;
              var componentStack = stack2 !== null ? stack2 : "";
              if (error3 != null && error3._suppressLogging) {
                if (boundary.tag === ClassComponent) {
                  return;
                }
                console["error"](error3);
              }
              var componentName = source ? getComponentName(source.type) : null;
              var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
              var errorBoundaryMessage;
              var errorBoundaryName = getComponentName(boundary.type);
              if (errorBoundaryName) {
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
              } else {
                errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
              }
              var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage);
              console["error"](combinedMessage);
            }
          } catch (e3) {
            setTimeout(function() {
              throw e3;
            });
          }
        }
        var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
        function createRootErrorUpdate(fiber, errorInfo, lane) {
          var update2 = createUpdate2(NoTimestamp, lane);
          update2.tag = CaptureUpdate;
          update2.payload = {
            element: null
          };
          var error3 = errorInfo.value;
          update2.callback = function() {
            onUncaughtError(error3);
            logCapturedError(fiber, errorInfo);
          };
          return update2;
        }
        function createClassErrorUpdate(fiber, errorInfo, lane) {
          var update2 = createUpdate2(NoTimestamp, lane);
          update2.tag = CaptureUpdate;
          var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
          if (typeof getDerivedStateFromError === "function") {
            var error$12 = errorInfo.value;
            update2.payload = function() {
              logCapturedError(fiber, errorInfo);
              return getDerivedStateFromError(error$12);
            };
          }
          var inst = fiber.stateNode;
          if (inst !== null && typeof inst.componentDidCatch === "function") {
            update2.callback = function callback() {
              {
                markFailedErrorBoundaryForHotReloading(fiber);
              }
              if (typeof getDerivedStateFromError !== "function") {
                markLegacyErrorBoundaryAsFailed(this);
                logCapturedError(fiber, errorInfo);
              }
              var error$13 = errorInfo.value;
              var stack2 = errorInfo.stack;
              this.componentDidCatch(error$13, {
                componentStack: stack2 !== null ? stack2 : ""
              });
              {
                if (typeof getDerivedStateFromError !== "function") {
                  if (!includesSomeLane(fiber.lanes, SyncLane)) {
                    error2("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || "Unknown");
                  }
                }
              }
            };
          } else {
            update2.callback = function() {
              markFailedErrorBoundaryForHotReloading(fiber);
            };
          }
          return update2;
        }
        function attachPingListener(root2, wakeable, lanes) {
          var pingCache = root2.pingCache;
          var threadIDs;
          if (pingCache === null) {
            pingCache = root2.pingCache = new PossiblyWeakMap$1();
            threadIDs = /* @__PURE__ */ new Set();
            pingCache.set(wakeable, threadIDs);
          } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === void 0) {
              threadIDs = /* @__PURE__ */ new Set();
              pingCache.set(wakeable, threadIDs);
            }
          }
          if (!threadIDs.has(lanes)) {
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root2, wakeable, lanes);
            wakeable.then(ping, ping);
          }
        }
        function throwException(root2, returnFiber, sourceFiber, value, rootRenderLanes) {
          sourceFiber.flags |= Incomplete;
          sourceFiber.firstEffect = sourceFiber.lastEffect = null;
          if (value !== null && typeof value === "object" && typeof value.then === "function") {
            var wakeable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
              var currentSource = sourceFiber.alternate;
              if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
              } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
              }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext);
            var _workInProgress = returnFiber;
            do {
              if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                var wakeables = _workInProgress.updateQueue;
                if (wakeables === null) {
                  var updateQueue2 = /* @__PURE__ */ new Set();
                  updateQueue2.add(wakeable);
                  _workInProgress.updateQueue = updateQueue2;
                } else {
                  wakeables.add(wakeable);
                }
                if ((_workInProgress.mode & BlockingMode) === NoMode) {
                  _workInProgress.flags |= DidCapture;
                  sourceFiber.flags |= ForceUpdateForLegacySuspense;
                  sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                  if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) {
                      sourceFiber.tag = IncompleteClassComponent;
                    } else {
                      var update2 = createUpdate2(NoTimestamp, SyncLane);
                      update2.tag = ForceUpdate;
                      enqueueUpdate(sourceFiber, update2);
                    }
                  }
                  sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
                  return;
                }
                attachPingListener(root2, wakeable, rootRenderLanes);
                _workInProgress.flags |= ShouldCapture;
                _workInProgress.lanes = rootRenderLanes;
                return;
              }
              _workInProgress = _workInProgress.return;
            } while (_workInProgress !== null);
            value = new Error((getComponentName(sourceFiber.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
          }
          renderDidError();
          value = createCapturedValue(value, sourceFiber);
          var workInProgress2 = returnFiber;
          do {
            switch (workInProgress2.tag) {
              case HostRoot: {
                var _errorInfo = value;
                workInProgress2.flags |= ShouldCapture;
                var lane = pickArbitraryLane(rootRenderLanes);
                workInProgress2.lanes = mergeLanes(workInProgress2.lanes, lane);
                var _update = createRootErrorUpdate(workInProgress2, _errorInfo, lane);
                enqueueCapturedUpdate(workInProgress2, _update);
                return;
              }
              case ClassComponent:
                var errorInfo = value;
                var ctor = workInProgress2.type;
                var instance = workInProgress2.stateNode;
                if ((workInProgress2.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                  workInProgress2.flags |= ShouldCapture;
                  var _lane = pickArbitraryLane(rootRenderLanes);
                  workInProgress2.lanes = mergeLanes(workInProgress2.lanes, _lane);
                  var _update2 = createClassErrorUpdate(workInProgress2, errorInfo, _lane);
                  enqueueCapturedUpdate(workInProgress2, _update2);
                  return;
                }
                break;
            }
            workInProgress2 = workInProgress2.return;
          } while (workInProgress2 !== null);
        }
        function invokeGuardedCallbackProd(name2, func, context, a4, b10, c7, d3, e3, f) {
          var funcArgs = Array.prototype.slice.call(arguments, 3);
          try {
            func.apply(context, funcArgs);
          } catch (error3) {
            this.onError(error3);
          }
        }
        var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
        {
          if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
            var fakeNode = document.createElement("react");
            invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name2, func, context, a4, b10, c7, d3, e3, f) {
              if (!(typeof document !== "undefined")) {
                {
                  throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
                }
              }
              var evt = document.createEvent("Event");
              var didCall = false;
              var didError = true;
              var windowEvent = window.event;
              var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
              function restoreAfterDispatch() {
                fakeNode.removeEventListener(evtType, callCallback2, false);
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) {
                  window.event = windowEvent;
                }
              }
              var funcArgs = Array.prototype.slice.call(arguments, 3);
              function callCallback2() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
              }
              var error3;
              var didSetError = false;
              var isCrossOriginError = false;
              function handleWindowError(event2) {
                error3 = event2.error;
                didSetError = true;
                if (error3 === null && event2.colno === 0 && event2.lineno === 0) {
                  isCrossOriginError = true;
                }
                if (event2.defaultPrevented) {
                  if (error3 != null && typeof error3 === "object") {
                    try {
                      error3._suppressLogging = true;
                    } catch (inner) {
                    }
                  }
                }
              }
              var evtType = "react-" + (name2 ? name2 : "invokeguardedcallback");
              window.addEventListener("error", handleWindowError);
              fakeNode.addEventListener(evtType, callCallback2, false);
              evt.initEvent(evtType, false, false);
              fakeNode.dispatchEvent(evt);
              if (windowEventDescriptor) {
                Object.defineProperty(window, "event", windowEventDescriptor);
              }
              if (didCall && didError) {
                if (!didSetError) {
                  error3 = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`);
                } else if (isCrossOriginError) {
                  error3 = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                }
                this.onError(error3);
              }
              window.removeEventListener("error", handleWindowError);
              if (!didCall) {
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
              }
            };
          }
        }
        var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
        var hasError = false;
        var caughtError = null;
        var reporter = {
          onError: function(error3) {
            hasError = true;
            caughtError = error3;
          }
        };
        function invokeGuardedCallback(name2, func, context, a4, b10, c7, d3, e3, f) {
          hasError = false;
          caughtError = null;
          invokeGuardedCallbackImpl$1.apply(reporter, arguments);
        }
        function hasCaughtError() {
          return hasError;
        }
        function clearCaughtError() {
          if (hasError) {
            var error3 = caughtError;
            hasError = false;
            caughtError = null;
            return error3;
          } else {
            {
              {
                throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
        {
          didWarnAboutUndefinedSnapshotBeforeUpdate = /* @__PURE__ */ new Set();
        }
        var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
        var callComponentWillUnmountWithTimer = function(current2, instance) {
          instance.props = current2.memoizedProps;
          instance.state = current2.memoizedState;
          {
            instance.componentWillUnmount();
          }
        };
        function safelyCallComponentWillUnmount(current2, instance) {
          {
            invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current2, instance);
            if (hasCaughtError()) {
              var unmountError = clearCaughtError();
              captureCommitPhaseError(current2, unmountError);
            }
          }
        }
        function safelyDetachRef(current2) {
          var ref2 = current2.ref;
          if (ref2 !== null) {
            if (typeof ref2 === "function") {
              {
                invokeGuardedCallback(null, ref2, null, null);
                if (hasCaughtError()) {
                  var refError = clearCaughtError();
                  captureCommitPhaseError(current2, refError);
                }
              }
            } else {
              ref2.current = null;
            }
          }
        }
        function safelyCallDestroy(current2, destroy) {
          {
            invokeGuardedCallback(null, destroy, null);
            if (hasCaughtError()) {
              var error3 = clearCaughtError();
              captureCommitPhaseError(current2, error3);
            }
          }
        }
        function commitBeforeMutationLifeCycles(current2, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block: {
              return;
            }
            case ClassComponent: {
              if (finishedWork.flags & Snapshot) {
                if (current2 !== null) {
                  var prevProps = current2.memoizedProps;
                  var prevState = current2.memoizedState;
                  var instance = finishedWork.stateNode;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error2("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error2("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                  {
                    var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                    if (snapshot === void 0 && !didWarnSet.has(finishedWork.type)) {
                      didWarnSet.add(finishedWork.type);
                      error2("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                    }
                  }
                  instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                }
              }
              return;
            }
            case HostRoot: {
              {
                if (finishedWork.flags & Snapshot) {
                  var root2 = finishedWork.stateNode;
                  clearContainer(root2.containerInfo);
                }
              }
              return;
            }
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
              return;
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function commitHookEffectListUnmount(tag2, finishedWork) {
          var updateQueue2 = finishedWork.updateQueue;
          var lastEffect = updateQueue2 !== null ? updateQueue2.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect2 = firstEffect;
            do {
              if ((effect2.tag & tag2) === tag2) {
                var destroy = effect2.destroy;
                effect2.destroy = void 0;
                if (destroy !== void 0) {
                  destroy();
                }
              }
              effect2 = effect2.next;
            } while (effect2 !== firstEffect);
          }
        }
        function commitHookEffectListMount(tag2, finishedWork) {
          var updateQueue2 = finishedWork.updateQueue;
          var lastEffect = updateQueue2 !== null ? updateQueue2.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect2 = firstEffect;
            do {
              if ((effect2.tag & tag2) === tag2) {
                var create3 = effect2.create;
                effect2.destroy = create3();
                {
                  var destroy = effect2.destroy;
                  if (destroy !== void 0 && typeof destroy !== "function") {
                    var addendum = void 0;
                    if (destroy === null) {
                      addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                    } else if (typeof destroy.then === "function") {
                      addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                    } else {
                      addendum = " You returned: " + destroy;
                    }
                    error2("An effect function must not return anything besides a function, which is used for clean-up.%s", addendum);
                  }
                }
              }
              effect2 = effect2.next;
            } while (effect2 !== firstEffect);
          }
        }
        function schedulePassiveEffects(finishedWork) {
          var updateQueue2 = finishedWork.updateQueue;
          var lastEffect = updateQueue2 !== null ? updateQueue2.lastEffect : null;
          if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect2 = firstEffect;
            do {
              var _effect = effect2, next2 = _effect.next, tag2 = _effect.tag;
              if ((tag2 & Passive$1) !== NoFlags$1 && (tag2 & HasEffect) !== NoFlags$1) {
                enqueuePendingPassiveHookEffectUnmount(finishedWork, effect2);
                enqueuePendingPassiveHookEffectMount(finishedWork, effect2);
              }
              effect2 = next2;
            } while (effect2 !== firstEffect);
          }
        }
        function commitLifeCycles(finishedRoot, current2, finishedWork, committedLanes) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block: {
              {
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
              }
              schedulePassiveEffects(finishedWork);
              return;
            }
            case ClassComponent: {
              var instance = finishedWork.stateNode;
              if (finishedWork.flags & Update) {
                if (current2 === null) {
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error2("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error2("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  {
                    instance.componentDidMount();
                  }
                } else {
                  var prevProps = finishedWork.elementType === finishedWork.type ? current2.memoizedProps : resolveDefaultProps(finishedWork.type, current2.memoizedProps);
                  var prevState = current2.memoizedState;
                  {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                      if (instance.props !== finishedWork.memoizedProps) {
                        error2("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                      if (instance.state !== finishedWork.memoizedState) {
                        error2("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                      }
                    }
                  }
                  {
                    instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                  }
                }
              }
              var updateQueue2 = finishedWork.updateQueue;
              if (updateQueue2 !== null) {
                {
                  if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                    if (instance.props !== finishedWork.memoizedProps) {
                      error2("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                    if (instance.state !== finishedWork.memoizedState) {
                      error2("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || "instance");
                    }
                  }
                }
                commitUpdateQueue(finishedWork, updateQueue2, instance);
              }
              return;
            }
            case HostRoot: {
              var _updateQueue = finishedWork.updateQueue;
              if (_updateQueue !== null) {
                var _instance = null;
                if (finishedWork.child !== null) {
                  switch (finishedWork.child.tag) {
                    case HostComponent:
                      _instance = getPublicInstance(finishedWork.child.stateNode);
                      break;
                    case ClassComponent:
                      _instance = finishedWork.child.stateNode;
                      break;
                  }
                }
                commitUpdateQueue(finishedWork, _updateQueue, _instance);
              }
              return;
            }
            case HostComponent: {
              finishedWork.stateNode;
              if (current2 === null && finishedWork.flags & Update) {
                finishedWork.type;
                finishedWork.memoizedProps;
              }
              return;
            }
            case HostText: {
              return;
            }
            case HostPortal: {
              return;
            }
            case Profiler: {
              {
                var _finishedWork$memoize2 = finishedWork.memoizedProps;
                _finishedWork$memoize2.onCommit;
                var onRender = _finishedWork$memoize2.onRender;
                finishedWork.stateNode.effectDuration;
                var commitTime2 = getCommitTime();
                if (typeof onRender === "function") {
                  {
                    onRender(finishedWork.memoizedProps.id, current2 === null ? "mount" : "update", finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime2, finishedRoot.memoizedInteractions);
                  }
                }
              }
              return;
            }
            case SuspenseComponent: {
              return;
            }
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
              return;
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function hideOrUnhideAllChildren(finishedWork, isHidden2) {
          {
            var node2 = finishedWork;
            while (true) {
              if (node2.tag === HostComponent) {
                var instance = node2.stateNode;
                if (isHidden2) {
                  hideInstance(instance);
                } else {
                  unhideInstance(node2.stateNode, node2.memoizedProps);
                }
              } else if (node2.tag === HostText) {
                var _instance3 = node2.stateNode;
                if (isHidden2) {
                  hideTextInstance(_instance3);
                } else {
                  unhideTextInstance(_instance3, node2.memoizedProps);
                }
              } else if ((node2.tag === OffscreenComponent || node2.tag === LegacyHiddenComponent) && node2.memoizedState !== null && node2 !== finishedWork)
                ;
              else if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              if (node2 === finishedWork) {
                return;
              }
              while (node2.sibling === null) {
                if (node2.return === null || node2.return === finishedWork) {
                  return;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          }
        }
        function commitAttachRef(finishedWork) {
          var ref2 = finishedWork.ref;
          if (ref2 !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch (finishedWork.tag) {
              case HostComponent:
                instanceToUse = getPublicInstance(instance);
                break;
              default:
                instanceToUse = instance;
            }
            if (typeof ref2 === "function") {
              ref2(instanceToUse);
            } else {
              {
                if (!ref2.hasOwnProperty("current")) {
                  error2("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentName(finishedWork.type));
                }
              }
              ref2.current = instanceToUse;
            }
          }
        }
        function commitDetachRef(current2) {
          var currentRef = current2.ref;
          if (currentRef !== null) {
            if (typeof currentRef === "function") {
              currentRef(null);
            } else {
              currentRef.current = null;
            }
          }
        }
        function commitUnmount(finishedRoot, current2, renderPriorityLevel) {
          onCommitUnmount(current2);
          switch (current2.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block: {
              var updateQueue2 = current2.updateQueue;
              if (updateQueue2 !== null) {
                var lastEffect = updateQueue2.lastEffect;
                if (lastEffect !== null) {
                  var firstEffect = lastEffect.next;
                  var effect2 = firstEffect;
                  do {
                    var _effect2 = effect2, destroy = _effect2.destroy, tag2 = _effect2.tag;
                    if (destroy !== void 0) {
                      if ((tag2 & Passive$1) !== NoFlags$1) {
                        enqueuePendingPassiveHookEffectUnmount(current2, effect2);
                      } else {
                        {
                          safelyCallDestroy(current2, destroy);
                        }
                      }
                    }
                    effect2 = effect2.next;
                  } while (effect2 !== firstEffect);
                }
              }
              return;
            }
            case ClassComponent: {
              safelyDetachRef(current2);
              var instance = current2.stateNode;
              if (typeof instance.componentWillUnmount === "function") {
                safelyCallComponentWillUnmount(current2, instance);
              }
              return;
            }
            case HostComponent: {
              safelyDetachRef(current2);
              return;
            }
            case HostPortal: {
              {
                unmountHostComponents(finishedRoot, current2);
              }
              return;
            }
            case FundamentalComponent: {
              return;
            }
            case DehydratedFragment: {
              return;
            }
            case ScopeComponent: {
              return;
            }
          }
        }
        function commitNestedUnmounts(finishedRoot, root2, renderPriorityLevel) {
          var node2 = root2;
          while (true) {
            commitUnmount(finishedRoot, node2);
            if (node2.child !== null && // If we use mutation we drill down into portals using commitUnmount above.
            // If we don't use mutation we drill down into portals here instead.
            node2.tag !== HostPortal) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === root2) {
              return;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === root2) {
                return;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function detachFiberMutation(fiber) {
          fiber.alternate = null;
          fiber.child = null;
          fiber.dependencies = null;
          fiber.firstEffect = null;
          fiber.lastEffect = null;
          fiber.memoizedProps = null;
          fiber.memoizedState = null;
          fiber.pendingProps = null;
          fiber.return = null;
          fiber.updateQueue = null;
          {
            fiber._debugOwner = null;
          }
        }
        function getHostParentFiber(fiber) {
          var parent2 = fiber.return;
          while (parent2 !== null) {
            if (isHostParent(parent2)) {
              return parent2;
            }
            parent2 = parent2.return;
          }
          {
            {
              throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function isHostParent(fiber) {
          return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
        }
        function getHostSibling(fiber) {
          var node2 = fiber;
          siblings:
            while (true) {
              while (node2.sibling === null) {
                if (node2.return === null || isHostParent(node2.return)) {
                  return null;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
              while (node2.tag !== HostComponent && node2.tag !== HostText && node2.tag !== DehydratedFragment) {
                if (node2.flags & Placement) {
                  continue siblings;
                }
                if (node2.child === null || node2.tag === HostPortal) {
                  continue siblings;
                } else {
                  node2.child.return = node2;
                  node2 = node2.child;
                }
              }
              if (!(node2.flags & Placement)) {
                return node2.stateNode;
              }
            }
        }
        function commitPlacement(finishedWork) {
          var parentFiber = getHostParentFiber(finishedWork);
          var parent2;
          var isContainer;
          var parentStateNode = parentFiber.stateNode;
          switch (parentFiber.tag) {
            case HostComponent:
              parent2 = parentStateNode;
              isContainer = false;
              break;
            case HostRoot:
              parent2 = parentStateNode.containerInfo;
              isContainer = true;
              break;
            case HostPortal:
              parent2 = parentStateNode.containerInfo;
              isContainer = true;
              break;
            case FundamentalComponent:
            default: {
              {
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (parentFiber.flags & ContentReset) {
            parentFiber.flags &= ~ContentReset;
          }
          var before = getHostSibling(finishedWork);
          if (isContainer) {
            insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent2);
          } else {
            insertOrAppendPlacementNode(finishedWork, before, parent2);
          }
        }
        function insertOrAppendPlacementNodeIntoContainer(node2, before, parent2) {
          var tag2 = node2.tag;
          var isHost = tag2 === HostComponent || tag2 === HostText;
          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node2.stateNode : node2.stateNode.instance;
            if (before) {
              insertInContainerBefore(parent2, stateNode, before);
            } else {
              appendChildToContainer(parent2, stateNode);
            }
          } else if (tag2 === HostPortal)
            ;
          else {
            var child = node2.child;
            if (child !== null) {
              insertOrAppendPlacementNodeIntoContainer(child, before, parent2);
              var sibling = child.sibling;
              while (sibling !== null) {
                insertOrAppendPlacementNodeIntoContainer(sibling, before, parent2);
                sibling = sibling.sibling;
              }
            }
          }
        }
        function insertOrAppendPlacementNode(node2, before, parent2) {
          var tag2 = node2.tag;
          var isHost = tag2 === HostComponent || tag2 === HostText;
          if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node2.stateNode : node2.stateNode.instance;
            if (before) {
              insertBefore(parent2, stateNode, before);
            } else {
              appendChild(parent2, stateNode);
            }
          } else if (tag2 === HostPortal)
            ;
          else {
            var child = node2.child;
            if (child !== null) {
              insertOrAppendPlacementNode(child, before, parent2);
              var sibling = child.sibling;
              while (sibling !== null) {
                insertOrAppendPlacementNode(sibling, before, parent2);
                sibling = sibling.sibling;
              }
            }
          }
        }
        function unmountHostComponents(finishedRoot, current2, renderPriorityLevel) {
          var node2 = current2;
          var currentParentIsValid = false;
          var currentParent;
          var currentParentIsContainer;
          while (true) {
            if (!currentParentIsValid) {
              var parent2 = node2.return;
              findParent:
                while (true) {
                  if (!(parent2 !== null)) {
                    {
                      throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    }
                  }
                  var parentStateNode = parent2.stateNode;
                  switch (parent2.tag) {
                    case HostComponent:
                      currentParent = parentStateNode;
                      currentParentIsContainer = false;
                      break findParent;
                    case HostRoot:
                      currentParent = parentStateNode.containerInfo;
                      currentParentIsContainer = true;
                      break findParent;
                    case HostPortal:
                      currentParent = parentStateNode.containerInfo;
                      currentParentIsContainer = true;
                      break findParent;
                  }
                  parent2 = parent2.return;
                }
              currentParentIsValid = true;
            }
            if (node2.tag === HostComponent || node2.tag === HostText) {
              commitNestedUnmounts(finishedRoot, node2);
              if (currentParentIsContainer) {
                removeChildFromContainer(currentParent, node2.stateNode);
              } else {
                removeChild(currentParent, node2.stateNode);
              }
            } else if (node2.tag === HostPortal) {
              if (node2.child !== null) {
                currentParent = node2.stateNode.containerInfo;
                currentParentIsContainer = true;
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
            } else {
              commitUnmount(finishedRoot, node2);
              if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
            }
            if (node2 === current2) {
              return;
            }
            while (node2.sibling === null) {
              if (node2.return === null || node2.return === current2) {
                return;
              }
              node2 = node2.return;
              if (node2.tag === HostPortal) {
                currentParentIsValid = false;
              }
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function commitDeletion(finishedRoot, current2, renderPriorityLevel) {
          {
            unmountHostComponents(finishedRoot, current2);
          }
          var alternate = current2.alternate;
          detachFiberMutation(current2);
          if (alternate !== null) {
            detachFiberMutation(alternate);
          }
        }
        function commitWork(current2, finishedWork) {
          switch (finishedWork.tag) {
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block: {
              {
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
              }
              return;
            }
            case ClassComponent: {
              return;
            }
            case HostComponent: {
              var instance = finishedWork.stateNode;
              if (instance != null) {
                var newProps = finishedWork.memoizedProps;
                var oldProps = current2 !== null ? current2.memoizedProps : newProps;
                var type2 = finishedWork.type;
                var updatePayload = finishedWork.updateQueue;
                finishedWork.updateQueue = null;
                if (updatePayload !== null) {
                  commitUpdate(instance, updatePayload, type2, oldProps, newProps);
                }
              }
              return;
            }
            case HostText: {
              if (!(finishedWork.stateNode !== null)) {
                {
                  throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                }
              }
              var textInstance = finishedWork.stateNode;
              var newText = finishedWork.memoizedProps;
              var oldText = current2 !== null ? current2.memoizedProps : newText;
              commitTextUpdate(textInstance, oldText, newText);
              return;
            }
            case HostRoot: {
              return;
            }
            case Profiler: {
              return;
            }
            case SuspenseComponent: {
              commitSuspenseComponent(finishedWork);
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case SuspenseListComponent: {
              attachSuspenseRetryListeners(finishedWork);
              return;
            }
            case IncompleteClassComponent: {
              return;
            }
            case FundamentalComponent: {
              break;
            }
            case ScopeComponent: {
              break;
            }
            case OffscreenComponent:
            case LegacyHiddenComponent: {
              var newState = finishedWork.memoizedState;
              var isHidden2 = newState !== null;
              hideOrUnhideAllChildren(finishedWork, isHidden2);
              return;
            }
          }
          {
            {
              throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
        }
        function commitSuspenseComponent(finishedWork) {
          var newState = finishedWork.memoizedState;
          if (newState !== null) {
            markCommitTimeOfFallback();
            {
              var primaryChildParent = finishedWork.child;
              hideOrUnhideAllChildren(primaryChildParent, true);
            }
          }
        }
        function attachSuspenseRetryListeners(finishedWork) {
          var wakeables = finishedWork.updateQueue;
          if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) {
              retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            }
            wakeables.forEach(function(wakeable) {
              var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
              if (!retryCache.has(wakeable)) {
                {
                  if (wakeable.__reactDoNotTraceInteractions !== true) {
                    retry = tracing2.unstable_wrap(retry);
                  }
                }
                retryCache.add(wakeable);
                wakeable.then(retry, retry);
              }
            });
          }
        }
        function isSuspenseBoundaryBeingHidden(current2, finishedWork) {
          if (current2 !== null) {
            var oldState = current2.memoizedState;
            if (oldState === null || oldState.dehydrated !== null) {
              var newState = finishedWork.memoizedState;
              return newState !== null && newState.dehydrated === null;
            }
          }
          return false;
        }
        function commitResetTextContent(current2) {
          resetTextContent(current2.stateNode);
        }
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor$1 = Symbol.for;
          symbolFor$1("selector.component");
          symbolFor$1("selector.has_pseudo_class");
          symbolFor$1("selector.role");
          symbolFor$1("selector.test_id");
          symbolFor$1("selector.text");
        }
        var didWarnAboutMessageChannel = false;
        var enqueueTaskImpl = null;
        function enqueueTask(task) {
          if (enqueueTaskImpl === null) {
            try {
              var requireString = ("require" + Math.random()).slice(0, 7);
              var nodeRequire = module2 && module2[requireString];
              enqueueTaskImpl = nodeRequire.call(module2, "timers").setImmediate;
            } catch (_err) {
              enqueueTaskImpl = function(callback) {
                {
                  if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") {
                      error2("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                    }
                  }
                }
                var channel2 = new MessageChannel();
                channel2.port1.onmessage = callback;
                channel2.port2.postMessage(void 0);
              };
            }
          }
          return enqueueTaskImpl(task);
        }
        var ceil = Math.ceil;
        var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
        var NoContext = (
          /*             */
          0
        );
        var BatchedContext = (
          /*               */
          1
        );
        var DiscreteEventContext = (
          /*         */
          4
        );
        var LegacyUnbatchedContext = (
          /*       */
          8
        );
        var RenderContext = (
          /*                */
          16
        );
        var CommitContext = (
          /*                */
          32
        );
        var RetryAfterError = (
          /*       */
          64
        );
        var RootIncomplete = 0;
        var RootFatalErrored = 1;
        var RootErrored = 2;
        var RootSuspended = 3;
        var RootSuspendedWithDelay = 4;
        var RootCompleted = 5;
        var executionContext = NoContext;
        var workInProgressRoot = null;
        var workInProgress = null;
        var workInProgressRootRenderLanes = NoLanes;
        var subtreeRenderLanes = NoLanes;
        var subtreeRenderLanesCursor = createCursor(NoLanes);
        var workInProgressRootExitStatus = RootIncomplete;
        var workInProgressRootFatalError = null;
        var workInProgressRootIncludedLanes = NoLanes;
        var workInProgressRootSkippedLanes = NoLanes;
        var workInProgressRootUpdatedLanes = NoLanes;
        var workInProgressRootPingedLanes = NoLanes;
        var mostRecentlyUpdatedRoot = null;
        var globalMostRecentFallbackTime = 0;
        var FALLBACK_THROTTLE_MS = 500;
        var workInProgressRootRenderTargetTime = Infinity;
        var RENDER_TIMEOUT_MS = 500;
        function resetRenderTimer() {
          workInProgressRootRenderTargetTime = now2() + RENDER_TIMEOUT_MS;
        }
        function getRenderTargetTime() {
          return workInProgressRootRenderTargetTime;
        }
        var nextEffect = null;
        var hasUncaughtError = false;
        var firstUncaughtError = null;
        var legacyErrorBoundariesThatAlreadyFailed = null;
        var rootDoesHavePassiveEffects = false;
        var rootWithPendingPassiveEffects = null;
        var pendingPassiveEffectsRenderPriority = NoPriority$1;
        var pendingPassiveEffectsLanes = NoLanes;
        var pendingPassiveHookEffectsMount = [];
        var pendingPassiveHookEffectsUnmount = [];
        var rootsWithPendingDiscreteUpdates = null;
        var NESTED_UPDATE_LIMIT = 50;
        var nestedUpdateCount = 0;
        var rootWithNestedUpdates = null;
        var NESTED_PASSIVE_UPDATE_LIMIT = 50;
        var nestedPassiveUpdateCount = 0;
        var spawnedWorkDuringRender = null;
        var currentEventTime = NoTimestamp;
        var currentEventWipLanes = NoLanes;
        var currentEventPendingLanes = NoLanes;
        var isFlushingPassiveEffects = false;
        var focusedInstanceHandle = null;
        var shouldFireAfterActiveInstanceBlur = false;
        function getWorkInProgressRoot() {
          return workInProgressRoot;
        }
        function requestEventTime() {
          if ((executionContext & (RenderContext | CommitContext)) !== NoContext) {
            return now2();
          }
          if (currentEventTime !== NoTimestamp) {
            return currentEventTime;
          }
          currentEventTime = now2();
          return currentEventTime;
        }
        function requestUpdateLane(fiber) {
          var mode = fiber.mode;
          if ((mode & BlockingMode) === NoMode) {
            return SyncLane;
          } else if ((mode & ConcurrentMode) === NoMode) {
            return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
          }
          if (currentEventWipLanes === NoLanes) {
            currentEventWipLanes = workInProgressRootIncludedLanes;
          }
          var isTransition = requestCurrentTransition() !== NoTransition;
          if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) {
              currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            }
            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
          }
          var schedulerPriority = getCurrentPriorityLevel();
          var lane;
          if (
            // TODO: Temporary. We're removing the concept of discrete updates.
            (executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$1
          ) {
            lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
          } else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
          }
          return lane;
        }
        function requestRetryLane(fiber) {
          var mode = fiber.mode;
          if ((mode & BlockingMode) === NoMode) {
            return SyncLane;
          } else if ((mode & ConcurrentMode) === NoMode) {
            return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
          }
          if (currentEventWipLanes === NoLanes) {
            currentEventWipLanes = workInProgressRootIncludedLanes;
          }
          return findRetryLane(currentEventWipLanes);
        }
        function scheduleUpdateOnFiber(fiber, lane, eventTime) {
          checkForNestedUpdates();
          warnAboutRenderPhaseUpdatesInDEV(fiber);
          var root2 = markUpdateLaneFromFiberToRoot(fiber, lane);
          if (root2 === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
          }
          markRootUpdated(root2, lane, eventTime);
          if (root2 === workInProgressRoot) {
            {
              workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            }
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) {
              markRootSuspended$1(root2, workInProgressRootRenderLanes);
            }
          }
          var priorityLevel = getCurrentPriorityLevel();
          if (lane === SyncLane) {
            if (
              // Check if we're inside unbatchedUpdates
              (executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
              (executionContext & (RenderContext | CommitContext)) === NoContext
            ) {
              schedulePendingInteractions(root2, lane);
              performSyncWorkOnRoot(root2);
            } else {
              ensureRootIsScheduled(root2, eventTime);
              schedulePendingInteractions(root2, lane);
              if (executionContext === NoContext) {
                resetRenderTimer();
                flushSyncCallbackQueue();
              }
            }
          } else {
            if ((executionContext & DiscreteEventContext) !== NoContext && // Only updates at user-blocking priority or greater are considered
            // discrete, even inside a discrete event.
            (priorityLevel === UserBlockingPriority$1 || priorityLevel === ImmediatePriority$1)) {
              if (rootsWithPendingDiscreteUpdates === null) {
                rootsWithPendingDiscreteUpdates = /* @__PURE__ */ new Set([root2]);
              } else {
                rootsWithPendingDiscreteUpdates.add(root2);
              }
            }
            ensureRootIsScheduled(root2, eventTime);
            schedulePendingInteractions(root2, lane);
          }
          mostRecentlyUpdatedRoot = root2;
        }
        function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
          sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
          var alternate = sourceFiber.alternate;
          if (alternate !== null) {
            alternate.lanes = mergeLanes(alternate.lanes, lane);
          }
          {
            if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) {
              warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            }
          }
          var node2 = sourceFiber;
          var parent2 = sourceFiber.return;
          while (parent2 !== null) {
            parent2.childLanes = mergeLanes(parent2.childLanes, lane);
            alternate = parent2.alternate;
            if (alternate !== null) {
              alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            } else {
              {
                if ((parent2.flags & (Placement | Hydrating)) !== NoFlags) {
                  warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
                }
              }
            }
            node2 = parent2;
            parent2 = parent2.return;
          }
          if (node2.tag === HostRoot) {
            var root2 = node2.stateNode;
            return root2;
          } else {
            return null;
          }
        }
        function ensureRootIsScheduled(root2, currentTime) {
          var existingCallbackNode = root2.callbackNode;
          markStarvedLanesAsExpired(root2, currentTime);
          var nextLanes = getNextLanes(root2, root2 === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
          var newCallbackPriority = returnNextLanesPriority();
          if (nextLanes === NoLanes) {
            if (existingCallbackNode !== null) {
              cancelCallback(existingCallbackNode);
              root2.callbackNode = null;
              root2.callbackPriority = NoLanePriority;
            }
            return;
          }
          if (existingCallbackNode !== null) {
            var existingCallbackPriority = root2.callbackPriority;
            if (existingCallbackPriority === newCallbackPriority) {
              return;
            }
            cancelCallback(existingCallbackNode);
          }
          var newCallbackNode;
          if (newCallbackPriority === SyncLanePriority) {
            newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root2));
          } else if (newCallbackPriority === SyncBatchedLanePriority) {
            newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root2));
          } else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root2));
          }
          root2.callbackPriority = newCallbackPriority;
          root2.callbackNode = newCallbackNode;
        }
        function performConcurrentWorkOnRoot(root2) {
          currentEventTime = NoTimestamp;
          currentEventWipLanes = NoLanes;
          currentEventPendingLanes = NoLanes;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          var originalCallbackNode = root2.callbackNode;
          var didFlushPassiveEffects = flushPassiveEffects();
          if (didFlushPassiveEffects) {
            if (root2.callbackNode !== originalCallbackNode) {
              return null;
            }
          }
          var lanes = getNextLanes(root2, root2 === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
          if (lanes === NoLanes) {
            return null;
          }
          var exitStatus = renderRootConcurrent(root2, lanes);
          if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
            prepareFreshStack(root2, NoLanes);
          } else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
              executionContext |= RetryAfterError;
              if (root2.hydrate) {
                root2.hydrate = false;
                clearContainer(root2.containerInfo);
              }
              lanes = getLanesToRetrySynchronouslyOnError(root2);
              if (lanes !== NoLanes) {
                exitStatus = renderRootSync(root2, lanes);
              }
            }
            if (exitStatus === RootFatalErrored) {
              var fatalError = workInProgressRootFatalError;
              prepareFreshStack(root2, NoLanes);
              markRootSuspended$1(root2, lanes);
              ensureRootIsScheduled(root2, now2());
              throw fatalError;
            }
            var finishedWork = root2.current.alternate;
            root2.finishedWork = finishedWork;
            root2.finishedLanes = lanes;
            finishConcurrentRender(root2, exitStatus, lanes);
          }
          ensureRootIsScheduled(root2, now2());
          if (root2.callbackNode === originalCallbackNode) {
            return performConcurrentWorkOnRoot.bind(null, root2);
          }
          return null;
        }
        function finishConcurrentRender(root2, exitStatus, lanes) {
          switch (exitStatus) {
            case RootIncomplete:
            case RootFatalErrored: {
              {
                {
                  throw Error("Root did not complete. This is a bug in React.");
                }
              }
            }
            case RootErrored: {
              commitRoot(root2);
              break;
            }
            case RootSuspended: {
              markRootSuspended$1(root2, lanes);
              if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
              !shouldForceFlushFallbacksInDEV()) {
                var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now2();
                if (msUntilTimeout > 10) {
                  var nextLanes = getNextLanes(root2, NoLanes);
                  if (nextLanes !== NoLanes) {
                    break;
                  }
                  var suspendedLanes = root2.suspendedLanes;
                  if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                    requestEventTime();
                    markRootPinged(root2, suspendedLanes);
                    break;
                  }
                  root2.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root2), msUntilTimeout);
                  break;
                }
              }
              commitRoot(root2);
              break;
            }
            case RootSuspendedWithDelay: {
              markRootSuspended$1(root2, lanes);
              if (includesOnlyTransitions(lanes)) {
                break;
              }
              if (!shouldForceFlushFallbacksInDEV()) {
                var mostRecentEventTime = getMostRecentEventTime(root2, lanes);
                var eventTimeMs = mostRecentEventTime;
                var timeElapsedMs = now2() - eventTimeMs;
                var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs;
                if (_msUntilTimeout > 10) {
                  root2.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root2), _msUntilTimeout);
                  break;
                }
              }
              commitRoot(root2);
              break;
            }
            case RootCompleted: {
              commitRoot(root2);
              break;
            }
            default: {
              {
                {
                  throw Error("Unknown root exit status.");
                }
              }
            }
          }
        }
        function markRootSuspended$1(root2, suspendedLanes) {
          suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
          suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
          markRootSuspended(root2, suspendedLanes);
        }
        function performSyncWorkOnRoot(root2) {
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          flushPassiveEffects();
          var lanes;
          var exitStatus;
          if (root2 === workInProgressRoot && includesSomeLane(root2.expiredLanes, workInProgressRootRenderLanes)) {
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root2, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
              lanes = getNextLanes(root2, lanes);
              exitStatus = renderRootSync(root2, lanes);
            }
          } else {
            lanes = getNextLanes(root2, NoLanes);
            exitStatus = renderRootSync(root2, lanes);
          }
          if (root2.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError;
            if (root2.hydrate) {
              root2.hydrate = false;
              clearContainer(root2.containerInfo);
            }
            lanes = getLanesToRetrySynchronouslyOnError(root2);
            if (lanes !== NoLanes) {
              exitStatus = renderRootSync(root2, lanes);
            }
          }
          if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root2, NoLanes);
            markRootSuspended$1(root2, lanes);
            ensureRootIsScheduled(root2, now2());
            throw fatalError;
          }
          var finishedWork = root2.current.alternate;
          root2.finishedWork = finishedWork;
          root2.finishedLanes = lanes;
          commitRoot(root2);
          ensureRootIsScheduled(root2, now2());
          return null;
        }
        function batchedUpdates(fn2, a4) {
          var prevExecutionContext = executionContext;
          executionContext |= BatchedContext;
          try {
            return fn2(a4);
          } finally {
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
              resetRenderTimer();
              flushSyncCallbackQueue();
            }
          }
        }
        function flushSync(fn2, a4) {
          var prevExecutionContext = executionContext;
          if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            {
              error2("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
            }
            return fn2(a4);
          }
          executionContext |= BatchedContext;
          {
            try {
              if (fn2) {
                return runWithPriority(ImmediatePriority$1, fn2.bind(null, a4));
              } else {
                return void 0;
              }
            } finally {
              executionContext = prevExecutionContext;
              flushSyncCallbackQueue();
            }
          }
        }
        function pushRenderLanes(fiber, lanes) {
          push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
          subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
          workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
        }
        function popRenderLanes(fiber) {
          subtreeRenderLanes = subtreeRenderLanesCursor.current;
          pop(subtreeRenderLanesCursor, fiber);
        }
        function prepareFreshStack(root2, lanes) {
          root2.finishedWork = null;
          root2.finishedLanes = NoLanes;
          var timeoutHandle = root2.timeoutHandle;
          if (timeoutHandle !== noTimeout) {
            root2.timeoutHandle = noTimeout;
            cancelTimeout(timeoutHandle);
          }
          if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while (interruptedWork !== null) {
              unwindInterruptedWork(interruptedWork);
              interruptedWork = interruptedWork.return;
            }
          }
          workInProgressRoot = root2;
          workInProgress = createWorkInProgress(root2.current, null);
          workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
          workInProgressRootExitStatus = RootIncomplete;
          workInProgressRootFatalError = null;
          workInProgressRootSkippedLanes = NoLanes;
          workInProgressRootUpdatedLanes = NoLanes;
          workInProgressRootPingedLanes = NoLanes;
          {
            spawnedWorkDuringRender = null;
          }
          {
            ReactStrictModeWarnings.discardPendingWarnings();
          }
        }
        function handleError(root2, thrownValue) {
          do {
            var erroredWork = workInProgress;
            try {
              resetContextDependencies();
              resetHooksAfterThrow();
              resetCurrentFiber();
              ReactCurrentOwner$2.current = null;
              if (erroredWork === null || erroredWork.return === null) {
                workInProgressRootExitStatus = RootFatalErrored;
                workInProgressRootFatalError = thrownValue;
                workInProgress = null;
                return;
              }
              if (enableProfilerTimer && erroredWork.mode & ProfileMode) {
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
              }
              throwException(root2, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
              completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
              thrownValue = yetAnotherThrownValue;
              if (workInProgress === erroredWork && erroredWork !== null) {
                erroredWork = erroredWork.return;
                workInProgress = erroredWork;
              } else {
                erroredWork = workInProgress;
              }
              continue;
            }
            return;
          } while (true);
        }
        function pushDispatcher() {
          var prevDispatcher = ReactCurrentDispatcher$2.current;
          ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
          if (prevDispatcher === null) {
            return ContextOnlyDispatcher;
          } else {
            return prevDispatcher;
          }
        }
        function popDispatcher(prevDispatcher) {
          ReactCurrentDispatcher$2.current = prevDispatcher;
        }
        function pushInteractions(root2) {
          {
            var prevInteractions = tracing2.__interactionsRef.current;
            tracing2.__interactionsRef.current = root2.memoizedInteractions;
            return prevInteractions;
          }
        }
        function popInteractions(prevInteractions) {
          {
            tracing2.__interactionsRef.current = prevInteractions;
          }
        }
        function markCommitTimeOfFallback() {
          globalMostRecentFallbackTime = now2();
        }
        function markSkippedUpdateLanes(lane) {
          workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
        }
        function renderDidSuspend() {
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootSuspended;
          }
        }
        function renderDidSuspendDelayIfPossible() {
          if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) {
            workInProgressRootExitStatus = RootSuspendedWithDelay;
          }
          if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) {
            markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
          }
        }
        function renderDidError() {
          if (workInProgressRootExitStatus !== RootCompleted) {
            workInProgressRootExitStatus = RootErrored;
          }
        }
        function renderHasNotSuspendedYet() {
          return workInProgressRootExitStatus === RootIncomplete;
        }
        function renderRootSync(root2, lanes) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root2, lanes);
            startWorkOnPendingInteractions(root2, lanes);
          }
          var prevInteractions = pushInteractions(root2);
          do {
            try {
              workLoopSync();
              break;
            } catch (thrownValue) {
              handleError(root2, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          {
            popInteractions(prevInteractions);
          }
          executionContext = prevExecutionContext;
          popDispatcher(prevDispatcher);
          if (workInProgress !== null) {
            {
              {
                throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          workInProgressRoot = null;
          workInProgressRootRenderLanes = NoLanes;
          return workInProgressRootExitStatus;
        }
        function workLoopSync() {
          while (workInProgress !== null) {
            performUnitOfWork(workInProgress);
          }
        }
        function renderRootConcurrent(root2, lanes) {
          var prevExecutionContext = executionContext;
          executionContext |= RenderContext;
          var prevDispatcher = pushDispatcher();
          if (workInProgressRoot !== root2 || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root2, lanes);
            startWorkOnPendingInteractions(root2, lanes);
          }
          var prevInteractions = pushInteractions(root2);
          do {
            try {
              workLoopConcurrent();
              break;
            } catch (thrownValue) {
              handleError(root2, thrownValue);
            }
          } while (true);
          resetContextDependencies();
          {
            popInteractions(prevInteractions);
          }
          popDispatcher(prevDispatcher);
          executionContext = prevExecutionContext;
          if (workInProgress !== null) {
            return RootIncomplete;
          } else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes;
            return workInProgressRootExitStatus;
          }
        }
        function workLoopConcurrent() {
          while (workInProgress !== null && !shouldYield()) {
            performUnitOfWork(workInProgress);
          }
        }
        function performUnitOfWork(unitOfWork) {
          var current2 = unitOfWork.alternate;
          setCurrentFiber(unitOfWork);
          var next2;
          if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next2 = beginWork$1(current2, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
          } else {
            next2 = beginWork$1(current2, unitOfWork, subtreeRenderLanes);
          }
          resetCurrentFiber();
          unitOfWork.memoizedProps = unitOfWork.pendingProps;
          if (next2 === null) {
            completeUnitOfWork(unitOfWork);
          } else {
            workInProgress = next2;
          }
          ReactCurrentOwner$2.current = null;
        }
        function completeUnitOfWork(unitOfWork) {
          var completedWork = unitOfWork;
          do {
            var current2 = completedWork.alternate;
            var returnFiber = completedWork.return;
            if ((completedWork.flags & Incomplete) === NoFlags) {
              setCurrentFiber(completedWork);
              var next2 = void 0;
              if ((completedWork.mode & ProfileMode) === NoMode) {
                next2 = completeWork(current2, completedWork, subtreeRenderLanes);
              } else {
                startProfilerTimer(completedWork);
                next2 = completeWork(current2, completedWork, subtreeRenderLanes);
                stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
              }
              resetCurrentFiber();
              if (next2 !== null) {
                workInProgress = next2;
                return;
              }
              resetChildLanes(completedWork);
              if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
              (returnFiber.flags & Incomplete) === NoFlags) {
                if (returnFiber.firstEffect === null) {
                  returnFiber.firstEffect = completedWork.firstEffect;
                }
                if (completedWork.lastEffect !== null) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                  }
                  returnFiber.lastEffect = completedWork.lastEffect;
                }
                var flags3 = completedWork.flags;
                if (flags3 > PerformedWork) {
                  if (returnFiber.lastEffect !== null) {
                    returnFiber.lastEffect.nextEffect = completedWork;
                  } else {
                    returnFiber.firstEffect = completedWork;
                  }
                  returnFiber.lastEffect = completedWork;
                }
              }
            } else {
              var _next = unwindWork(completedWork);
              if (_next !== null) {
                _next.flags &= HostEffectMask;
                workInProgress = _next;
                return;
              }
              if ((completedWork.mode & ProfileMode) !== NoMode) {
                stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                var actualDuration = completedWork.actualDuration;
                var child = completedWork.child;
                while (child !== null) {
                  actualDuration += child.actualDuration;
                  child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
              }
              if (returnFiber !== null) {
                returnFiber.firstEffect = returnFiber.lastEffect = null;
                returnFiber.flags |= Incomplete;
              }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
              workInProgress = siblingFiber;
              return;
            }
            completedWork = returnFiber;
            workInProgress = completedWork;
          } while (completedWork !== null);
          if (workInProgressRootExitStatus === RootIncomplete) {
            workInProgressRootExitStatus = RootCompleted;
          }
        }
        function resetChildLanes(completedWork) {
          if (
            // TODO: Move this check out of the hot path by moving `resetChildLanes`
            // to switch statement in `completeWork`.
            (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes
          ) {
            return;
          }
          var newChildLanes = NoLanes;
          if ((completedWork.mode & ProfileMode) !== NoMode) {
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration;
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while (child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
              if (shouldBubbleActualDurations) {
                actualDuration += child.actualDuration;
              }
              treeBaseDuration += child.treeBaseDuration;
              child = child.sibling;
            }
            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
            if (isTimedOutSuspense) {
              var primaryChildFragment = completedWork.child;
              if (primaryChildFragment !== null) {
                treeBaseDuration -= primaryChildFragment.treeBaseDuration;
              }
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
          } else {
            var _child = completedWork.child;
            while (_child !== null) {
              newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
              _child = _child.sibling;
            }
          }
          completedWork.childLanes = newChildLanes;
        }
        function commitRoot(root2) {
          var renderPriorityLevel = getCurrentPriorityLevel();
          runWithPriority(ImmediatePriority$1, commitRootImpl.bind(null, root2, renderPriorityLevel));
          return null;
        }
        function commitRootImpl(root2, renderPriorityLevel) {
          do {
            flushPassiveEffects();
          } while (rootWithPendingPassiveEffects !== null);
          flushRenderPhaseStrictModeWarningsInDEV();
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Should not already be working.");
            }
          }
          var finishedWork = root2.finishedWork;
          var lanes = root2.finishedLanes;
          if (finishedWork === null) {
            return null;
          }
          root2.finishedWork = null;
          root2.finishedLanes = NoLanes;
          if (!(finishedWork !== root2.current)) {
            {
              throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
            }
          }
          root2.callbackNode = null;
          var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
          markRootFinished(root2, remainingLanes);
          if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root2)) {
              rootsWithPendingDiscreteUpdates.delete(root2);
            }
          }
          if (root2 === workInProgressRoot) {
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
          }
          var firstEffect;
          if (finishedWork.flags > PerformedWork) {
            if (finishedWork.lastEffect !== null) {
              finishedWork.lastEffect.nextEffect = finishedWork;
              firstEffect = finishedWork.firstEffect;
            } else {
              firstEffect = finishedWork;
            }
          } else {
            firstEffect = finishedWork.firstEffect;
          }
          if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root2);
            ReactCurrentOwner$2.current = null;
            focusedInstanceHandle = prepareForCommit(root2.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var error3 = clearCaughtError();
                  captureCommitPhaseError(nextEffect, error3);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            focusedInstanceHandle = null;
            {
              recordCommitTime();
            }
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitMutationEffects, null, root2, renderPriorityLevel);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error = clearCaughtError();
                  captureCommitPhaseError(nextEffect, _error);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            resetAfterCommit(root2.containerInfo);
            root2.current = finishedWork;
            nextEffect = firstEffect;
            do {
              {
                invokeGuardedCallback(null, commitLayoutEffects, null, root2, lanes);
                if (hasCaughtError()) {
                  if (!(nextEffect !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var _error2 = clearCaughtError();
                  captureCommitPhaseError(nextEffect, _error2);
                  nextEffect = nextEffect.nextEffect;
                }
              }
            } while (nextEffect !== null);
            nextEffect = null;
            requestPaint();
            {
              popInteractions(prevInteractions);
            }
            executionContext = prevExecutionContext;
          } else {
            root2.current = finishedWork;
            {
              recordCommitTime();
            }
          }
          var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
          if (rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root2;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
          } else {
            nextEffect = firstEffect;
            while (nextEffect !== null) {
              var nextNextEffect = nextEffect.nextEffect;
              nextEffect.nextEffect = null;
              if (nextEffect.flags & Deletion) {
                detachFiberAfterEffects(nextEffect);
              }
              nextEffect = nextNextEffect;
            }
          }
          remainingLanes = root2.pendingLanes;
          if (remainingLanes !== NoLanes) {
            {
              if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for (var i2 = 0; i2 < expirationTimes.length; i2++) {
                  scheduleInteractions(root2, expirationTimes[i2], root2.memoizedInteractions);
                }
              }
              schedulePendingInteractions(root2, remainingLanes);
            }
          } else {
            legacyErrorBoundariesThatAlreadyFailed = null;
          }
          {
            if (!rootDidHavePassiveEffects) {
              finishPendingInteractions(root2, lanes);
            }
          }
          if (remainingLanes === SyncLane) {
            if (root2 === rootWithNestedUpdates) {
              nestedUpdateCount++;
            } else {
              nestedUpdateCount = 0;
              rootWithNestedUpdates = root2;
            }
          } else {
            nestedUpdateCount = 0;
          }
          onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
          ensureRootIsScheduled(root2, now2());
          if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
          }
          if ((executionContext & LegacyUnbatchedContext) !== NoContext) {
            return null;
          }
          flushSyncCallbackQueue();
          return null;
        }
        function commitBeforeMutationEffects() {
          while (nextEffect !== null) {
            var current2 = nextEffect.alternate;
            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
              if ((nextEffect.flags & Deletion) !== NoFlags) {
                if (doesFiberContain(nextEffect, focusedInstanceHandle)) {
                  shouldFireAfterActiveInstanceBlur = true;
                }
              } else {
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current2, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) {
                  shouldFireAfterActiveInstanceBlur = true;
                }
              }
            }
            var flags3 = nextEffect.flags;
            if ((flags3 & Snapshot) !== NoFlags) {
              setCurrentFiber(nextEffect);
              commitBeforeMutationLifeCycles(current2, nextEffect);
              resetCurrentFiber();
            }
            if ((flags3 & Passive) !== NoFlags) {
              if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                scheduleCallback(NormalPriority$1, function() {
                  flushPassiveEffects();
                  return null;
                });
              }
            }
            nextEffect = nextEffect.nextEffect;
          }
        }
        function commitMutationEffects(root2, renderPriorityLevel) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var flags3 = nextEffect.flags;
            if (flags3 & ContentReset) {
              commitResetTextContent(nextEffect);
            }
            if (flags3 & Ref) {
              var current2 = nextEffect.alternate;
              if (current2 !== null) {
                commitDetachRef(current2);
              }
            }
            var primaryFlags = flags3 & (Placement | Update | Deletion | Hydrating);
            switch (primaryFlags) {
              case Placement: {
                commitPlacement(nextEffect);
                nextEffect.flags &= ~Placement;
                break;
              }
              case PlacementAndUpdate: {
                commitPlacement(nextEffect);
                nextEffect.flags &= ~Placement;
                var _current = nextEffect.alternate;
                commitWork(_current, nextEffect);
                break;
              }
              case Hydrating: {
                nextEffect.flags &= ~Hydrating;
                break;
              }
              case HydratingAndUpdate: {
                nextEffect.flags &= ~Hydrating;
                var _current2 = nextEffect.alternate;
                commitWork(_current2, nextEffect);
                break;
              }
              case Update: {
                var _current3 = nextEffect.alternate;
                commitWork(_current3, nextEffect);
                break;
              }
              case Deletion: {
                commitDeletion(root2, nextEffect);
                break;
              }
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }
        function commitLayoutEffects(root2, committedLanes) {
          while (nextEffect !== null) {
            setCurrentFiber(nextEffect);
            var flags3 = nextEffect.flags;
            if (flags3 & (Update | Callback)) {
              var current2 = nextEffect.alternate;
              commitLifeCycles(root2, current2, nextEffect);
            }
            {
              if (flags3 & Ref) {
                commitAttachRef(nextEffect);
              }
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
          }
        }
        function flushPassiveEffects() {
          if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            {
              return runWithPriority(priorityLevel, flushPassiveEffectsImpl);
            }
          }
          return false;
        }
        function enqueuePendingPassiveHookEffectMount(fiber, effect2) {
          pendingPassiveHookEffectsMount.push(effect2, fiber);
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
              flushPassiveEffects();
              return null;
            });
          }
        }
        function enqueuePendingPassiveHookEffectUnmount(fiber, effect2) {
          pendingPassiveHookEffectsUnmount.push(effect2, fiber);
          {
            fiber.flags |= PassiveUnmountPendingDev;
            var alternate = fiber.alternate;
            if (alternate !== null) {
              alternate.flags |= PassiveUnmountPendingDev;
            }
          }
          if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
              flushPassiveEffects();
              return null;
            });
          }
        }
        function invokePassiveEffectCreate(effect2) {
          var create3 = effect2.create;
          effect2.destroy = create3();
        }
        function flushPassiveEffectsImpl() {
          if (rootWithPendingPassiveEffects === null) {
            return false;
          }
          var root2 = rootWithPendingPassiveEffects;
          var lanes = pendingPassiveEffectsLanes;
          rootWithPendingPassiveEffects = null;
          pendingPassiveEffectsLanes = NoLanes;
          if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) {
            {
              throw Error("Cannot flush passive effects while already rendering.");
            }
          }
          {
            isFlushingPassiveEffects = true;
          }
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          var prevInteractions = pushInteractions(root2);
          var unmountEffects = pendingPassiveHookEffectsUnmount;
          pendingPassiveHookEffectsUnmount = [];
          for (var i2 = 0; i2 < unmountEffects.length; i2 += 2) {
            var _effect = unmountEffects[i2];
            var fiber = unmountEffects[i2 + 1];
            var destroy = _effect.destroy;
            _effect.destroy = void 0;
            {
              fiber.flags &= ~PassiveUnmountPendingDev;
              var alternate = fiber.alternate;
              if (alternate !== null) {
                alternate.flags &= ~PassiveUnmountPendingDev;
              }
            }
            if (typeof destroy === "function") {
              {
                setCurrentFiber(fiber);
                {
                  invokeGuardedCallback(null, destroy, null);
                }
                if (hasCaughtError()) {
                  if (!(fiber !== null)) {
                    {
                      throw Error("Should be working on an effect.");
                    }
                  }
                  var error3 = clearCaughtError();
                  captureCommitPhaseError(fiber, error3);
                }
                resetCurrentFiber();
              }
            }
          }
          var mountEffects = pendingPassiveHookEffectsMount;
          pendingPassiveHookEffectsMount = [];
          for (var _i = 0; _i < mountEffects.length; _i += 2) {
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            {
              setCurrentFiber(_fiber);
              {
                invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
              }
              if (hasCaughtError()) {
                if (!(_fiber !== null)) {
                  {
                    throw Error("Should be working on an effect.");
                  }
                }
                var _error4 = clearCaughtError();
                captureCommitPhaseError(_fiber, _error4);
              }
              resetCurrentFiber();
            }
          }
          var effect2 = root2.current.firstEffect;
          while (effect2 !== null) {
            var nextNextEffect = effect2.nextEffect;
            effect2.nextEffect = null;
            if (effect2.flags & Deletion) {
              detachFiberAfterEffects(effect2);
            }
            effect2 = nextNextEffect;
          }
          {
            popInteractions(prevInteractions);
            finishPendingInteractions(root2, lanes);
          }
          {
            isFlushingPassiveEffects = false;
          }
          executionContext = prevExecutionContext;
          flushSyncCallbackQueue();
          nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
          return true;
        }
        function isAlreadyFailedLegacyErrorBoundary(instance) {
          return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
        }
        function markLegacyErrorBoundaryAsFailed(instance) {
          if (legacyErrorBoundariesThatAlreadyFailed === null) {
            legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([instance]);
          } else {
            legacyErrorBoundariesThatAlreadyFailed.add(instance);
          }
        }
        function prepareToThrowUncaughtError(error3) {
          if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error3;
          }
        }
        var onUncaughtError = prepareToThrowUncaughtError;
        function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error3) {
          var errorInfo = createCapturedValue(error3, sourceFiber);
          var update2 = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
          enqueueUpdate(rootFiber, update2);
          var eventTime = requestEventTime();
          var root2 = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
          if (root2 !== null) {
            markRootUpdated(root2, SyncLane, eventTime);
            ensureRootIsScheduled(root2, eventTime);
            schedulePendingInteractions(root2, SyncLane);
          }
        }
        function captureCommitPhaseError(sourceFiber, error3) {
          if (sourceFiber.tag === HostRoot) {
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error3);
            return;
          }
          var fiber = sourceFiber.return;
          while (fiber !== null) {
            if (fiber.tag === HostRoot) {
              captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error3);
              return;
            } else if (fiber.tag === ClassComponent) {
              var ctor = fiber.type;
              var instance = fiber.stateNode;
              if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                var errorInfo = createCapturedValue(error3, sourceFiber);
                var update2 = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                enqueueUpdate(fiber, update2);
                var eventTime = requestEventTime();
                var root2 = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                if (root2 !== null) {
                  markRootUpdated(root2, SyncLane, eventTime);
                  ensureRootIsScheduled(root2, eventTime);
                  schedulePendingInteractions(root2, SyncLane);
                } else {
                  if (typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    try {
                      instance.componentDidCatch(error3, errorInfo);
                    } catch (errorToIgnore) {
                    }
                  }
                }
                return;
              }
            }
            fiber = fiber.return;
          }
        }
        function pingSuspendedRoot(root2, wakeable, pingedLanes) {
          var pingCache = root2.pingCache;
          if (pingCache !== null) {
            pingCache.delete(wakeable);
          }
          var eventTime = requestEventTime();
          markRootPinged(root2, pingedLanes);
          if (workInProgressRoot === root2 && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now2() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) {
              prepareFreshStack(root2, NoLanes);
            } else {
              workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
            }
          }
          ensureRootIsScheduled(root2, eventTime);
          schedulePendingInteractions(root2, pingedLanes);
        }
        function retryTimedOutBoundary(boundaryFiber, retryLane) {
          if (retryLane === NoLane) {
            retryLane = requestRetryLane(boundaryFiber);
          }
          var eventTime = requestEventTime();
          var root2 = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
          if (root2 !== null) {
            markRootUpdated(root2, retryLane, eventTime);
            ensureRootIsScheduled(root2, eventTime);
            schedulePendingInteractions(root2, retryLane);
          }
        }
        function resolveRetryWakeable(boundaryFiber, wakeable) {
          var retryLane = NoLane;
          var retryCache;
          {
            retryCache = boundaryFiber.stateNode;
          }
          if (retryCache !== null) {
            retryCache.delete(wakeable);
          }
          retryTimedOutBoundary(boundaryFiber, retryLane);
        }
        function jnd(timeElapsed) {
          return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3e3 ? 3e3 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
        }
        function checkForNestedUpdates() {
          if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            {
              {
                throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
              }
            }
          }
          {
            if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
              nestedPassiveUpdateCount = 0;
              error2("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
            }
          }
        }
        function flushRenderPhaseStrictModeWarningsInDEV() {
          {
            ReactStrictModeWarnings.flushLegacyContextWarning();
            {
              ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
            }
          }
        }
        var didWarnStateUpdateForNotYetMountedComponent = null;
        function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
          {
            if ((executionContext & RenderContext) !== NoContext) {
              return;
            }
            if (!(fiber.mode & (BlockingMode | ConcurrentMode))) {
              return;
            }
            var tag2 = fiber.tag;
            if (tag2 !== IndeterminateComponent && tag2 !== HostRoot && tag2 !== ClassComponent && tag2 !== FunctionComponent && tag2 !== ForwardRef && tag2 !== MemoComponent && tag2 !== SimpleMemoComponent && tag2 !== Block) {
              return;
            }
            var componentName = getComponentName(fiber.type) || "ReactComponent";
            if (didWarnStateUpdateForNotYetMountedComponent !== null) {
              if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) {
                return;
              }
              didWarnStateUpdateForNotYetMountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForNotYetMountedComponent = /* @__PURE__ */ new Set([componentName]);
            }
            var previousFiber = current;
            try {
              setCurrentFiber(fiber);
              error2("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
            } finally {
              if (previousFiber) {
                setCurrentFiber(fiber);
              } else {
                resetCurrentFiber();
              }
            }
          }
        }
        var didWarnStateUpdateForUnmountedComponent = null;
        function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
          {
            var tag2 = fiber.tag;
            if (tag2 !== HostRoot && tag2 !== ClassComponent && tag2 !== FunctionComponent && tag2 !== ForwardRef && tag2 !== MemoComponent && tag2 !== SimpleMemoComponent && tag2 !== Block) {
              return;
            }
            if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) {
              return;
            }
            var componentName = getComponentName(fiber.type) || "ReactComponent";
            if (didWarnStateUpdateForUnmountedComponent !== null) {
              if (didWarnStateUpdateForUnmountedComponent.has(componentName)) {
                return;
              }
              didWarnStateUpdateForUnmountedComponent.add(componentName);
            } else {
              didWarnStateUpdateForUnmountedComponent = /* @__PURE__ */ new Set([componentName]);
            }
            if (isFlushingPassiveEffects)
              ;
            else {
              var previousFiber = current;
              try {
                setCurrentFiber(fiber);
                error2("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", tag2 === ClassComponent ? "the componentWillUnmount method" : "a useEffect cleanup function");
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }
        var beginWork$1;
        {
          beginWork$1 = beginWork;
        }
        var didWarnAboutUpdateInRender = false;
        var didWarnAboutUpdateInRenderForAnotherComponent;
        {
          didWarnAboutUpdateInRenderForAnotherComponent = /* @__PURE__ */ new Set();
        }
        function warnAboutRenderPhaseUpdatesInDEV(fiber) {
          {
            if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) {
              switch (fiber.tag) {
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent: {
                  var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || "Unknown";
                  var dedupeKey = renderingComponentName;
                  if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || "Unknown";
                    error2("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                  }
                  break;
                }
                case ClassComponent: {
                  if (!didWarnAboutUpdateInRender) {
                    error2("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                  }
                  break;
                }
              }
            }
          }
        }
        var IsThisRendererActing = {
          current: false
        };
        function warnIfNotScopedWithMatchingAct(fiber) {
          {
            if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
              var previousFiber = current;
              try {
                setCurrentFiber(fiber);
                error2("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);");
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }
        function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
          {
            if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              error2("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
            }
          }
        }
        function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
          {
            if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
              var previousFiber = current;
              try {
                setCurrentFiber(fiber);
                error2("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
              } finally {
                if (previousFiber) {
                  setCurrentFiber(fiber);
                } else {
                  resetCurrentFiber();
                }
              }
            }
          }
        }
        var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV;
        var didWarnAboutUnmockedScheduler = false;
        function warnIfUnmockedScheduler(fiber) {
          {
            if (didWarnAboutUnmockedScheduler === false && Scheduler$1.unstable_flushAllWithoutAsserting === void 0) {
              if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error2(`In Concurrent or Sync modes, the "scheduler" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: 
jest.mock('scheduler', () => require('scheduler/unstable_mock'));

For more info, visit https://reactjs.org/link/mock-scheduler`);
              }
            }
          }
        }
        function computeThreadID(root2, lane) {
          return lane * 1e3 + root2.interactionThreadID;
        }
        function markSpawnedWork(lane) {
          if (spawnedWorkDuringRender === null) {
            spawnedWorkDuringRender = [lane];
          } else {
            spawnedWorkDuringRender.push(lane);
          }
        }
        function scheduleInteractions(root2, lane, interactions) {
          if (interactions.size > 0) {
            var pendingInteractionMap = root2.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);
            if (pendingInteractions != null) {
              interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) {
                  interaction.__count++;
                }
                pendingInteractions.add(interaction);
              });
            } else {
              pendingInteractionMap.set(lane, new Set(interactions));
              interactions.forEach(function(interaction) {
                interaction.__count++;
              });
            }
            var subscriber = tracing2.__subscriberRef.current;
            if (subscriber !== null) {
              var threadID = computeThreadID(root2, lane);
              subscriber.onWorkScheduled(interactions, threadID);
            }
          }
        }
        function schedulePendingInteractions(root2, lane) {
          scheduleInteractions(root2, lane, tracing2.__interactionsRef.current);
        }
        function startWorkOnPendingInteractions(root2, lanes) {
          var interactions = /* @__PURE__ */ new Set();
          root2.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) {
              scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
              });
            }
          });
          root2.memoizedInteractions = interactions;
          if (interactions.size > 0) {
            var subscriber = tracing2.__subscriberRef.current;
            if (subscriber !== null) {
              var threadID = computeThreadID(root2, lanes);
              try {
                subscriber.onWorkStarted(interactions, threadID);
              } catch (error3) {
                scheduleCallback(ImmediatePriority$1, function() {
                  throw error3;
                });
              }
            }
          }
        }
        function finishPendingInteractions(root2, committedLanes) {
          var remainingLanesAfterCommit = root2.pendingLanes;
          var subscriber;
          try {
            subscriber = tracing2.__subscriberRef.current;
            if (subscriber !== null && root2.memoizedInteractions.size > 0) {
              var threadID = computeThreadID(root2, committedLanes);
              subscriber.onWorkStopped(root2.memoizedInteractions, threadID);
            }
          } catch (error3) {
            scheduleCallback(ImmediatePriority$1, function() {
              throw error3;
            });
          } finally {
            var pendingInteractionMap = root2.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, lane) {
              if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                pendingInteractionMap.delete(lane);
                scheduledInteractions.forEach(function(interaction) {
                  interaction.__count--;
                  if (subscriber !== null && interaction.__count === 0) {
                    try {
                      subscriber.onInteractionScheduledWorkCompleted(interaction);
                    } catch (error3) {
                      scheduleCallback(ImmediatePriority$1, function() {
                        throw error3;
                      });
                    }
                  }
                });
              }
            });
          }
        }
        function shouldForceFlushFallbacksInDEV() {
          return actingUpdatesScopeDepth > 0;
        }
        var flushMockScheduler = Scheduler$1.unstable_flushAllWithoutAsserting;
        var isSchedulerMocked = typeof flushMockScheduler === "function";
        function flushActWork() {
          if (flushMockScheduler !== void 0) {
            try {
              return flushMockScheduler();
            } finally {
            }
          } else {
            try {
              var didFlushWork = false;
              while (flushPassiveEffects()) {
                didFlushWork = true;
              }
              return didFlushWork;
            } finally {
            }
          }
        }
        function flushWorkAndMicroTasks(onDone) {
          try {
            flushActWork();
            enqueueTask(function() {
              if (flushActWork()) {
                flushWorkAndMicroTasks(onDone);
              } else {
                onDone();
              }
            });
          } catch (err) {
            onDone(err);
          }
        }
        var actingUpdatesScopeDepth = 0;
        function act2(callback) {
          var previousActingUpdatesScopeDepth = actingUpdatesScopeDepth;
          actingUpdatesScopeDepth++;
          var previousIsSomeRendererActing = IsSomeRendererActing.current;
          var previousIsThisRendererActing = IsThisRendererActing.current;
          IsSomeRendererActing.current = true;
          IsThisRendererActing.current = true;
          function onDone() {
            actingUpdatesScopeDepth--;
            IsSomeRendererActing.current = previousIsSomeRendererActing;
            IsThisRendererActing.current = previousIsThisRendererActing;
            {
              if (actingUpdatesScopeDepth > previousActingUpdatesScopeDepth) {
                error2("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
              }
            }
          }
          var result;
          try {
            result = batchedUpdates(callback);
          } catch (error3) {
            onDone();
            throw error3;
          }
          if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var called = false;
            {
              if (typeof Promise !== "undefined") {
                Promise.resolve().then(function() {
                }).then(function() {
                  if (called === false) {
                    error2("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                  }
                });
              }
            }
            return {
              then: function(resolve, reject) {
                called = true;
                result.then(function() {
                  if (actingUpdatesScopeDepth > 1 || isSchedulerMocked === true && previousIsSomeRendererActing === true) {
                    onDone();
                    resolve();
                    return;
                  }
                  flushWorkAndMicroTasks(function(err) {
                    onDone();
                    if (err) {
                      reject(err);
                    } else {
                      resolve();
                    }
                  });
                }, function(err) {
                  onDone();
                  reject(err);
                });
              }
            };
          } else {
            {
              if (result !== void 0) {
                error2("The callback passed to act(...) function must return undefined, or a Promise. You returned %s", result);
              }
            }
            try {
              if (actingUpdatesScopeDepth === 1 && (isSchedulerMocked === false || previousIsSomeRendererActing === false)) {
                flushActWork();
              }
              onDone();
            } catch (err) {
              onDone();
              throw err;
            }
            return {
              then: function(resolve) {
                {
                  error2("Do not await the result of calling act(...) with sync logic, it is not a Promise.");
                }
                resolve();
              }
            };
          }
        }
        function detachFiberAfterEffects(fiber) {
          fiber.sibling = null;
          fiber.stateNode = null;
        }
        var resolveFamily = null;
        var failedBoundaries = null;
        var setRefreshHandler = function(handler) {
          {
            resolveFamily = handler;
          }
        };
        function resolveFunctionForHotReloading(type2) {
          {
            if (resolveFamily === null) {
              return type2;
            }
            var family = resolveFamily(type2);
            if (family === void 0) {
              return type2;
            }
            return family.current;
          }
        }
        function resolveClassForHotReloading(type2) {
          return resolveFunctionForHotReloading(type2);
        }
        function resolveForwardRefForHotReloading(type2) {
          {
            if (resolveFamily === null) {
              return type2;
            }
            var family = resolveFamily(type2);
            if (family === void 0) {
              if (type2 !== null && type2 !== void 0 && typeof type2.render === "function") {
                var currentRender = resolveFunctionForHotReloading(type2.render);
                if (type2.render !== currentRender) {
                  var syntheticType = {
                    $$typeof: REACT_FORWARD_REF_TYPE,
                    render: currentRender
                  };
                  if (type2.displayName !== void 0) {
                    syntheticType.displayName = type2.displayName;
                  }
                  return syntheticType;
                }
              }
              return type2;
            }
            return family.current;
          }
        }
        function isCompatibleFamilyForHotReloading(fiber, element) {
          {
            if (resolveFamily === null) {
              return false;
            }
            var prevType = fiber.elementType;
            var nextType = element.type;
            var needsCompareFamilies = false;
            var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
            switch (fiber.tag) {
              case ClassComponent: {
                if (typeof nextType === "function") {
                  needsCompareFamilies = true;
                }
                break;
              }
              case FunctionComponent: {
                if (typeof nextType === "function") {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              case ForwardRef: {
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              case MemoComponent:
              case SimpleMemoComponent: {
                if ($$typeofNextType === REACT_MEMO_TYPE) {
                  needsCompareFamilies = true;
                } else if ($$typeofNextType === REACT_LAZY_TYPE) {
                  needsCompareFamilies = true;
                }
                break;
              }
              default:
                return false;
            }
            if (needsCompareFamilies) {
              var prevFamily = resolveFamily(prevType);
              if (prevFamily !== void 0 && prevFamily === resolveFamily(nextType)) {
                return true;
              }
            }
            return false;
          }
        }
        function markFailedErrorBoundaryForHotReloading(fiber) {
          {
            if (resolveFamily === null) {
              return;
            }
            if (typeof WeakSet !== "function") {
              return;
            }
            if (failedBoundaries === null) {
              failedBoundaries = /* @__PURE__ */ new WeakSet();
            }
            failedBoundaries.add(fiber);
          }
        }
        var scheduleRefresh = function(root2, update2) {
          {
            if (resolveFamily === null) {
              return;
            }
            var staleFamilies = update2.staleFamilies, updatedFamilies = update2.updatedFamilies;
            flushPassiveEffects();
            flushSync(function() {
              scheduleFibersWithFamiliesRecursively(root2.current, updatedFamilies, staleFamilies);
            });
          }
        };
        var scheduleRoot = function(root2, element) {
          {
            if (root2.context !== emptyContextObject) {
              return;
            }
            flushPassiveEffects();
            flushSync(function() {
              updateContainer(element, root2, null, null);
            });
          }
        };
        function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
          {
            var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag2 = fiber.tag, type2 = fiber.type;
            var candidateType = null;
            switch (tag2) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type2;
                break;
              case ForwardRef:
                candidateType = type2.render;
                break;
            }
            if (resolveFamily === null) {
              throw new Error("Expected resolveFamily to be set during hot reload.");
            }
            var needsRender = false;
            var needsRemount = false;
            if (candidateType !== null) {
              var family = resolveFamily(candidateType);
              if (family !== void 0) {
                if (staleFamilies.has(family)) {
                  needsRemount = true;
                } else if (updatedFamilies.has(family)) {
                  if (tag2 === ClassComponent) {
                    needsRemount = true;
                  } else {
                    needsRender = true;
                  }
                }
              }
            }
            if (failedBoundaries !== null) {
              if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) {
                needsRemount = true;
              }
            }
            if (needsRemount) {
              fiber._debugNeedsRemount = true;
            }
            if (needsRemount || needsRender) {
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
            if (child !== null && !needsRemount) {
              scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
            }
            if (sibling !== null) {
              scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
            }
          }
        }
        var findHostInstancesForRefresh = function(root2, families) {
          {
            var hostInstances = /* @__PURE__ */ new Set();
            var types2 = new Set(families.map(function(family) {
              return family.current;
            }));
            findHostInstancesForMatchingFibersRecursively(root2.current, types2, hostInstances);
            return hostInstances;
          }
        };
        function findHostInstancesForMatchingFibersRecursively(fiber, types2, hostInstances) {
          {
            var child = fiber.child, sibling = fiber.sibling, tag2 = fiber.tag, type2 = fiber.type;
            var candidateType = null;
            switch (tag2) {
              case FunctionComponent:
              case SimpleMemoComponent:
              case ClassComponent:
                candidateType = type2;
                break;
              case ForwardRef:
                candidateType = type2.render;
                break;
            }
            var didMatch = false;
            if (candidateType !== null) {
              if (types2.has(candidateType)) {
                didMatch = true;
              }
            }
            if (didMatch) {
              findHostInstancesForFiberShallowly(fiber, hostInstances);
            } else {
              if (child !== null) {
                findHostInstancesForMatchingFibersRecursively(child, types2, hostInstances);
              }
            }
            if (sibling !== null) {
              findHostInstancesForMatchingFibersRecursively(sibling, types2, hostInstances);
            }
          }
        }
        function findHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
            if (foundHostInstances) {
              return;
            }
            var node2 = fiber;
            while (true) {
              switch (node2.tag) {
                case HostComponent:
                  hostInstances.add(node2.stateNode);
                  return;
                case HostPortal:
                  hostInstances.add(node2.stateNode.containerInfo);
                  return;
                case HostRoot:
                  hostInstances.add(node2.stateNode.containerInfo);
                  return;
              }
              if (node2.return === null) {
                throw new Error("Expected to reach root first.");
              }
              node2 = node2.return;
            }
          }
        }
        function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
          {
            var node2 = fiber;
            var foundHostInstances = false;
            while (true) {
              if (node2.tag === HostComponent) {
                foundHostInstances = true;
                hostInstances.add(node2.stateNode);
              } else if (node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              if (node2 === fiber) {
                return foundHostInstances;
              }
              while (node2.sibling === null) {
                if (node2.return === null || node2.return === fiber) {
                  return foundHostInstances;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          }
          return false;
        }
        var hasBadMapPolyfill;
        {
          hasBadMapPolyfill = false;
          try {
            var nonExtensibleObject = Object.preventExtensions({});
            /* @__PURE__ */ new Map([[nonExtensibleObject, null]]);
            /* @__PURE__ */ new Set([nonExtensibleObject]);
          } catch (e3) {
            hasBadMapPolyfill = true;
          }
        }
        var debugCounter = 1;
        function FiberNode(tag2, pendingProps, key, mode) {
          this.tag = tag2;
          this.key = key;
          this.elementType = null;
          this.type = null;
          this.stateNode = null;
          this.return = null;
          this.child = null;
          this.sibling = null;
          this.index = 0;
          this.ref = null;
          this.pendingProps = pendingProps;
          this.memoizedProps = null;
          this.updateQueue = null;
          this.memoizedState = null;
          this.dependencies = null;
          this.mode = mode;
          this.flags = NoFlags;
          this.nextEffect = null;
          this.firstEffect = null;
          this.lastEffect = null;
          this.lanes = NoLanes;
          this.childLanes = NoLanes;
          this.alternate = null;
          {
            this.actualDuration = Number.NaN;
            this.actualStartTime = Number.NaN;
            this.selfBaseDuration = Number.NaN;
            this.treeBaseDuration = Number.NaN;
            this.actualDuration = 0;
            this.actualStartTime = -1;
            this.selfBaseDuration = 0;
            this.treeBaseDuration = 0;
          }
          {
            this._debugID = debugCounter++;
            this._debugSource = null;
            this._debugOwner = null;
            this._debugNeedsRemount = false;
            this._debugHookTypes = null;
            if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") {
              Object.preventExtensions(this);
            }
          }
        }
        var createFiber = function(tag2, pendingProps, key, mode) {
          return new FiberNode(tag2, pendingProps, key, mode);
        };
        function shouldConstruct$1(Component2) {
          var prototype2 = Component2.prototype;
          return !!(prototype2 && prototype2.isReactComponent);
        }
        function isSimpleFunctionComponent(type2) {
          return typeof type2 === "function" && !shouldConstruct$1(type2) && type2.defaultProps === void 0;
        }
        function resolveLazyComponentTag(Component2) {
          if (typeof Component2 === "function") {
            return shouldConstruct$1(Component2) ? ClassComponent : FunctionComponent;
          } else if (Component2 !== void 0 && Component2 !== null) {
            var $$typeof = Component2.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) {
              return ForwardRef;
            }
            if ($$typeof === REACT_MEMO_TYPE) {
              return MemoComponent;
            }
          }
          return IndeterminateComponent;
        }
        function createWorkInProgress(current2, pendingProps) {
          var workInProgress2 = current2.alternate;
          if (workInProgress2 === null) {
            workInProgress2 = createFiber(current2.tag, pendingProps, current2.key, current2.mode);
            workInProgress2.elementType = current2.elementType;
            workInProgress2.type = current2.type;
            workInProgress2.stateNode = current2.stateNode;
            {
              workInProgress2._debugID = current2._debugID;
              workInProgress2._debugSource = current2._debugSource;
              workInProgress2._debugOwner = current2._debugOwner;
              workInProgress2._debugHookTypes = current2._debugHookTypes;
            }
            workInProgress2.alternate = current2;
            current2.alternate = workInProgress2;
          } else {
            workInProgress2.pendingProps = pendingProps;
            workInProgress2.type = current2.type;
            workInProgress2.flags = NoFlags;
            workInProgress2.nextEffect = null;
            workInProgress2.firstEffect = null;
            workInProgress2.lastEffect = null;
            {
              workInProgress2.actualDuration = 0;
              workInProgress2.actualStartTime = -1;
            }
          }
          workInProgress2.childLanes = current2.childLanes;
          workInProgress2.lanes = current2.lanes;
          workInProgress2.child = current2.child;
          workInProgress2.memoizedProps = current2.memoizedProps;
          workInProgress2.memoizedState = current2.memoizedState;
          workInProgress2.updateQueue = current2.updateQueue;
          var currentDependencies = current2.dependencies;
          workInProgress2.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
          };
          workInProgress2.sibling = current2.sibling;
          workInProgress2.index = current2.index;
          workInProgress2.ref = current2.ref;
          {
            workInProgress2.selfBaseDuration = current2.selfBaseDuration;
            workInProgress2.treeBaseDuration = current2.treeBaseDuration;
          }
          {
            workInProgress2._debugNeedsRemount = current2._debugNeedsRemount;
            switch (workInProgress2.tag) {
              case IndeterminateComponent:
              case FunctionComponent:
              case SimpleMemoComponent:
                workInProgress2.type = resolveFunctionForHotReloading(current2.type);
                break;
              case ClassComponent:
                workInProgress2.type = resolveClassForHotReloading(current2.type);
                break;
              case ForwardRef:
                workInProgress2.type = resolveForwardRefForHotReloading(current2.type);
                break;
            }
          }
          return workInProgress2;
        }
        function resetWorkInProgress(workInProgress2, renderLanes2) {
          workInProgress2.flags &= Placement;
          workInProgress2.nextEffect = null;
          workInProgress2.firstEffect = null;
          workInProgress2.lastEffect = null;
          var current2 = workInProgress2.alternate;
          if (current2 === null) {
            workInProgress2.childLanes = NoLanes;
            workInProgress2.lanes = renderLanes2;
            workInProgress2.child = null;
            workInProgress2.memoizedProps = null;
            workInProgress2.memoizedState = null;
            workInProgress2.updateQueue = null;
            workInProgress2.dependencies = null;
            workInProgress2.stateNode = null;
            {
              workInProgress2.selfBaseDuration = 0;
              workInProgress2.treeBaseDuration = 0;
            }
          } else {
            workInProgress2.childLanes = current2.childLanes;
            workInProgress2.lanes = current2.lanes;
            workInProgress2.child = current2.child;
            workInProgress2.memoizedProps = current2.memoizedProps;
            workInProgress2.memoizedState = current2.memoizedState;
            workInProgress2.updateQueue = current2.updateQueue;
            workInProgress2.type = current2.type;
            var currentDependencies = current2.dependencies;
            workInProgress2.dependencies = currentDependencies === null ? null : {
              lanes: currentDependencies.lanes,
              firstContext: currentDependencies.firstContext
            };
            {
              workInProgress2.selfBaseDuration = current2.selfBaseDuration;
              workInProgress2.treeBaseDuration = current2.treeBaseDuration;
            }
          }
          return workInProgress2;
        }
        function createHostRootFiber(tag2) {
          var mode;
          if (tag2 === ConcurrentRoot) {
            mode = ConcurrentMode | BlockingMode | StrictMode;
          } else if (tag2 === BlockingRoot) {
            mode = BlockingMode | StrictMode;
          } else {
            mode = NoMode;
          }
          if (isDevToolsPresent) {
            mode |= ProfileMode;
          }
          return createFiber(HostRoot, null, null, mode);
        }
        function createFiberFromTypeAndProps(type2, key, pendingProps, owner, mode, lanes) {
          var fiberTag = IndeterminateComponent;
          var resolvedType = type2;
          if (typeof type2 === "function") {
            if (shouldConstruct$1(type2)) {
              fiberTag = ClassComponent;
              {
                resolvedType = resolveClassForHotReloading(resolvedType);
              }
            } else {
              {
                resolvedType = resolveFunctionForHotReloading(resolvedType);
              }
            }
          } else if (typeof type2 === "string") {
            fiberTag = HostComponent;
          } else {
            getTag:
              switch (type2) {
                case REACT_FRAGMENT_TYPE:
                  return createFiberFromFragment(pendingProps.children, mode, lanes, key);
                case REACT_DEBUG_TRACING_MODE_TYPE:
                  fiberTag = Mode;
                  mode |= DebugTracingMode;
                  break;
                case REACT_STRICT_MODE_TYPE:
                  fiberTag = Mode;
                  mode |= StrictMode;
                  break;
                case REACT_PROFILER_TYPE:
                  return createFiberFromProfiler(pendingProps, mode, lanes, key);
                case REACT_SUSPENSE_TYPE:
                  return createFiberFromSuspense(pendingProps, mode, lanes, key);
                case REACT_SUSPENSE_LIST_TYPE:
                  return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
                case REACT_OFFSCREEN_TYPE:
                  return createFiberFromOffscreen(pendingProps, mode, lanes, key);
                case REACT_LEGACY_HIDDEN_TYPE:
                  return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
                case REACT_SCOPE_TYPE:
                default: {
                  if (typeof type2 === "object" && type2 !== null) {
                    switch (type2.$$typeof) {
                      case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                      case REACT_CONTEXT_TYPE:
                        fiberTag = ContextConsumer;
                        break getTag;
                      case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        {
                          resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        }
                        break getTag;
                      case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                      case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                      case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                    }
                  }
                  var info = "";
                  {
                    if (type2 === void 0 || typeof type2 === "object" && type2 !== null && Object.keys(type2).length === 0) {
                      info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                    }
                    var ownerName = owner ? getComponentName(owner.type) : null;
                    if (ownerName) {
                      info += "\n\nCheck the render method of `" + ownerName + "`.";
                    }
                  }
                  {
                    {
                      throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type2 == null ? type2 : typeof type2) + "." + info);
                    }
                  }
                }
              }
          }
          var fiber = createFiber(fiberTag, pendingProps, key, mode);
          fiber.elementType = type2;
          fiber.type = resolvedType;
          fiber.lanes = lanes;
          {
            fiber._debugOwner = owner;
          }
          return fiber;
        }
        function createFiberFromElement(element, mode, lanes) {
          var owner = null;
          {
            owner = element._owner;
          }
          var type2 = element.type;
          var key = element.key;
          var pendingProps = element.props;
          var fiber = createFiberFromTypeAndProps(type2, key, pendingProps, owner, mode, lanes);
          {
            fiber._debugSource = element._source;
            fiber._debugOwner = element._owner;
          }
          return fiber;
        }
        function createFiberFromFragment(elements, mode, lanes, key) {
          var fiber = createFiber(Fragment2, elements, key, mode);
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromProfiler(pendingProps, mode, lanes, key) {
          {
            if (typeof pendingProps.id !== "string") {
              error2('Profiler must specify an "id" as a prop');
            }
          }
          var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
          fiber.elementType = REACT_PROFILER_TYPE;
          fiber.type = REACT_PROFILER_TYPE;
          fiber.lanes = lanes;
          {
            fiber.stateNode = {
              effectDuration: 0,
              passiveEffectDuration: 0
            };
          }
          return fiber;
        }
        function createFiberFromSuspense(pendingProps, mode, lanes, key) {
          var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
          fiber.type = REACT_SUSPENSE_TYPE;
          fiber.elementType = REACT_SUSPENSE_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
          var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
          {
            fiber.type = REACT_SUSPENSE_LIST_TYPE;
          }
          fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
          var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
          {
            fiber.type = REACT_OFFSCREEN_TYPE;
          }
          fiber.elementType = REACT_OFFSCREEN_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
          var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode);
          {
            fiber.type = REACT_LEGACY_HIDDEN_TYPE;
          }
          fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromText(content2, mode, lanes) {
          var fiber = createFiber(HostText, content2, null, mode);
          fiber.lanes = lanes;
          return fiber;
        }
        function createFiberFromPortal(portal, mode, lanes) {
          var pendingProps = portal.children !== null ? portal.children : [];
          var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
          fiber.lanes = lanes;
          fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
          };
          return fiber;
        }
        function FiberRootNode(containerInfo, tag2, hydrate) {
          this.tag = tag2;
          this.containerInfo = containerInfo;
          this.pendingChildren = null;
          this.current = null;
          this.pingCache = null;
          this.finishedWork = null;
          this.timeoutHandle = noTimeout;
          this.context = null;
          this.pendingContext = null;
          this.hydrate = hydrate;
          this.callbackNode = null;
          this.callbackPriority = NoLanePriority;
          this.eventTimes = createLaneMap(NoLanes);
          this.expirationTimes = createLaneMap(NoTimestamp);
          this.pendingLanes = NoLanes;
          this.suspendedLanes = NoLanes;
          this.pingedLanes = NoLanes;
          this.expiredLanes = NoLanes;
          this.mutableReadLanes = NoLanes;
          this.finishedLanes = NoLanes;
          this.entangledLanes = NoLanes;
          this.entanglements = createLaneMap(NoLanes);
          {
            this.interactionThreadID = tracing2.unstable_getThreadID();
            this.memoizedInteractions = /* @__PURE__ */ new Set();
            this.pendingInteractionMap = /* @__PURE__ */ new Map();
          }
          {
            switch (tag2) {
              case BlockingRoot:
                this._debugRootType = "createBlockingRoot()";
                break;
              case ConcurrentRoot:
                this._debugRootType = "createRoot()";
                break;
              case LegacyRoot:
                this._debugRootType = "createLegacyRoot()";
                break;
            }
          }
        }
        function createFiberRoot(containerInfo, tag2, hydrate, hydrationCallbacks) {
          var root2 = new FiberRootNode(containerInfo, tag2, hydrate);
          var uninitializedFiber = createHostRootFiber(tag2);
          root2.current = uninitializedFiber;
          uninitializedFiber.stateNode = root2;
          initializeUpdateQueue(uninitializedFiber);
          return root2;
        }
        var didWarnAboutNestedUpdates;
        {
          didWarnAboutNestedUpdates = false;
        }
        function getContextForSubtree(parentComponent) {
          if (!parentComponent) {
            return emptyContextObject;
          }
          var fiber = get9(parentComponent);
          var parentContext = findCurrentUnmaskedContext(fiber);
          if (fiber.tag === ClassComponent) {
            var Component2 = fiber.type;
            if (isContextProvider(Component2)) {
              return processChildContext(fiber, Component2, parentContext);
            }
          }
          return parentContext;
        }
        function createContainer(containerInfo, tag2, hydrate, hydrationCallbacks) {
          return createFiberRoot(containerInfo, tag2, hydrate);
        }
        function updateContainer(element, container2, parentComponent, callback) {
          {
            onScheduleRoot(container2, element);
          }
          var current$1 = container2.current;
          var eventTime = requestEventTime();
          {
            if ("undefined" !== typeof jest) {
              warnIfUnmockedScheduler(current$1);
              warnIfNotScopedWithMatchingAct(current$1);
            }
          }
          var lane = requestUpdateLane(current$1);
          var context = getContextForSubtree(parentComponent);
          if (container2.context === null) {
            container2.context = context;
          } else {
            container2.pendingContext = context;
          }
          {
            if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
              didWarnAboutNestedUpdates = true;
              error2("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || "Unknown");
            }
          }
          var update2 = createUpdate2(eventTime, lane);
          update2.payload = {
            element
          };
          callback = callback === void 0 ? null : callback;
          if (callback !== null) {
            {
              if (typeof callback !== "function") {
                error2("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
              }
            }
            update2.callback = callback;
          }
          enqueueUpdate(current$1, update2);
          scheduleUpdateOnFiber(current$1, lane, eventTime);
          return lane;
        }
        function getPublicRootInstance(container2) {
          var containerFiber = container2.current;
          if (!containerFiber.child) {
            return null;
          }
          switch (containerFiber.child.tag) {
            case HostComponent:
              return getPublicInstance(containerFiber.child.stateNode);
            default:
              return containerFiber.child.stateNode;
          }
        }
        var shouldSuspendImpl = function(fiber) {
          return false;
        };
        function shouldSuspend(fiber) {
          return shouldSuspendImpl(fiber);
        }
        var overrideHookState = null;
        var overrideHookStateDeletePath = null;
        var overrideHookStateRenamePath = null;
        var overrideProps = null;
        var overridePropsDeletePath = null;
        var overridePropsRenamePath = null;
        var scheduleUpdate = null;
        var setSuspenseHandler = null;
        {
          var copyWithDeleteImpl = function(obj, path2, index3) {
            var key = path2[index3];
            var updated = Array.isArray(obj) ? obj.slice() : _assign2({}, obj);
            if (index3 + 1 === path2.length) {
              if (Array.isArray(updated)) {
                updated.splice(key, 1);
              } else {
                delete updated[key];
              }
              return updated;
            }
            updated[key] = copyWithDeleteImpl(obj[key], path2, index3 + 1);
            return updated;
          };
          var copyWithDelete = function(obj, path2) {
            return copyWithDeleteImpl(obj, path2, 0);
          };
          var copyWithRenameImpl = function(obj, oldPath, newPath, index3) {
            var oldKey = oldPath[index3];
            var updated = Array.isArray(obj) ? obj.slice() : _assign2({}, obj);
            if (index3 + 1 === oldPath.length) {
              var newKey = newPath[index3];
              updated[newKey] = updated[oldKey];
              if (Array.isArray(updated)) {
                updated.splice(oldKey, 1);
              } else {
                delete updated[oldKey];
              }
            } else {
              updated[oldKey] = copyWithRenameImpl(
                // $FlowFixMe number or string is fine here
                obj[oldKey],
                oldPath,
                newPath,
                index3 + 1
              );
            }
            return updated;
          };
          var copyWithRename = function(obj, oldPath, newPath) {
            if (oldPath.length !== newPath.length) {
              warn2("copyWithRename() expects paths of the same length");
              return;
            } else {
              for (var i2 = 0; i2 < newPath.length - 1; i2++) {
                if (oldPath[i2] !== newPath[i2]) {
                  warn2("copyWithRename() expects paths to be the same except for the deepest key");
                  return;
                }
              }
            }
            return copyWithRenameImpl(obj, oldPath, newPath, 0);
          };
          var copyWithSetImpl = function(obj, path2, index3, value) {
            if (index3 >= path2.length) {
              return value;
            }
            var key = path2[index3];
            var updated = Array.isArray(obj) ? obj.slice() : _assign2({}, obj);
            updated[key] = copyWithSetImpl(obj[key], path2, index3 + 1, value);
            return updated;
          };
          var copyWithSet = function(obj, path2, value) {
            return copyWithSetImpl(obj, path2, 0, value);
          };
          var findHook = function(fiber, id) {
            var currentHook2 = fiber.memoizedState;
            while (currentHook2 !== null && id > 0) {
              currentHook2 = currentHook2.next;
              id--;
            }
            return currentHook2;
          };
          overrideHookState = function(fiber, id, path2, value) {
            var hook = findHook(fiber, id);
            if (hook !== null) {
              var newState = copyWithSet(hook.memoizedState, path2, value);
              hook.memoizedState = newState;
              hook.baseState = newState;
              fiber.memoizedProps = _assign2({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };
          overrideHookStateDeletePath = function(fiber, id, path2) {
            var hook = findHook(fiber, id);
            if (hook !== null) {
              var newState = copyWithDelete(hook.memoizedState, path2);
              hook.memoizedState = newState;
              hook.baseState = newState;
              fiber.memoizedProps = _assign2({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };
          overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
            var hook = findHook(fiber, id);
            if (hook !== null) {
              var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
              hook.memoizedState = newState;
              hook.baseState = newState;
              fiber.memoizedProps = _assign2({}, fiber.memoizedProps);
              scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
            }
          };
          overrideProps = function(fiber, path2, value) {
            fiber.pendingProps = copyWithSet(fiber.memoizedProps, path2, value);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          overridePropsDeletePath = function(fiber, path2) {
            fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path2);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          overridePropsRenamePath = function(fiber, oldPath, newPath) {
            fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
            if (fiber.alternate) {
              fiber.alternate.pendingProps = fiber.pendingProps;
            }
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          scheduleUpdate = function(fiber) {
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
          };
          setSuspenseHandler = function(newShouldSuspendImpl) {
            shouldSuspendImpl = newShouldSuspendImpl;
          };
        }
        function findHostInstanceByFiber(fiber) {
          var hostFiber = findCurrentHostFiber(fiber);
          if (hostFiber === null) {
            return null;
          }
          return hostFiber.stateNode;
        }
        function emptyFindFiberByHostInstance(instance) {
          return null;
        }
        function getCurrentFiberForDevTools() {
          return current;
        }
        function injectIntoDevTools(devToolsConfig) {
          var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
          var ReactCurrentDispatcher2 = ReactSharedInternals.ReactCurrentDispatcher;
          return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState,
            overrideHookStateDeletePath,
            overrideHookStateRenamePath,
            overrideProps,
            overridePropsDeletePath,
            overridePropsRenamePath,
            setSuspenseHandler,
            scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher2,
            findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh,
            scheduleRefresh,
            scheduleRoot,
            setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools
          });
        }
        var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
        var defaultTestOptions = {
          createNodeMock: function() {
            return null;
          }
        };
        function toJSON2(inst) {
          if (inst.isHidden) {
            return null;
          }
          switch (inst.tag) {
            case "TEXT":
              return inst.text;
            case "INSTANCE": {
              var _inst$props = inst.props;
              _inst$props.children;
              var props2 = _objectWithoutPropertiesLoose2(_inst$props, ["children"]);
              var renderedChildren = null;
              if (inst.children && inst.children.length) {
                for (var i2 = 0; i2 < inst.children.length; i2++) {
                  var renderedChild = toJSON2(inst.children[i2]);
                  if (renderedChild !== null) {
                    if (renderedChildren === null) {
                      renderedChildren = [renderedChild];
                    } else {
                      renderedChildren.push(renderedChild);
                    }
                  }
                }
              }
              var json = {
                type: inst.type,
                props: props2,
                children: renderedChildren
              };
              Object.defineProperty(json, "$$typeof", {
                value: Symbol.for("react.test.json")
              });
              return json;
            }
            default:
              throw new Error("Unexpected node type in toJSON: " + inst.tag);
          }
        }
        function childrenToTree(node2) {
          if (!node2) {
            return null;
          }
          var children2 = nodeAndSiblingsArray(node2);
          if (children2.length === 0) {
            return null;
          } else if (children2.length === 1) {
            return toTree(children2[0]);
          }
          return flatten2(children2.map(toTree));
        }
        function nodeAndSiblingsArray(nodeWithSibling) {
          var array2 = [];
          var node2 = nodeWithSibling;
          while (node2 != null) {
            array2.push(node2);
            node2 = node2.sibling;
          }
          return array2;
        }
        function flatten2(arr) {
          var result = [];
          var stack2 = [{
            i: 0,
            array: arr
          }];
          while (stack2.length) {
            var n = stack2.pop();
            while (n.i < n.array.length) {
              var el = n.array[n.i];
              n.i += 1;
              if (Array.isArray(el)) {
                stack2.push(n);
                stack2.push({
                  i: 0,
                  array: el
                });
                break;
              }
              result.push(el);
            }
          }
          return result;
        }
        function toTree(node2) {
          if (node2 == null) {
            return null;
          }
          switch (node2.tag) {
            case HostRoot:
              return childrenToTree(node2.child);
            case HostPortal:
              return childrenToTree(node2.child);
            case ClassComponent:
              return {
                nodeType: "component",
                type: node2.type,
                props: _assign2({}, node2.memoizedProps),
                instance: node2.stateNode,
                rendered: childrenToTree(node2.child)
              };
            case FunctionComponent:
            case SimpleMemoComponent:
              return {
                nodeType: "component",
                type: node2.type,
                props: _assign2({}, node2.memoizedProps),
                instance: null,
                rendered: childrenToTree(node2.child)
              };
            case Block:
              return {
                nodeType: "block",
                type: node2.type,
                props: _assign2({}, node2.memoizedProps),
                instance: null,
                rendered: childrenToTree(node2.child)
              };
            case HostComponent: {
              return {
                nodeType: "host",
                type: node2.type,
                props: _assign2({}, node2.memoizedProps),
                instance: null,
                // TODO: use createNodeMock here somehow?
                rendered: flatten2(nodeAndSiblingsArray(node2.child).map(toTree))
              };
            }
            case HostText:
              return node2.stateNode.text;
            case Fragment2:
            case ContextProvider:
            case ContextConsumer:
            case Mode:
            case Profiler:
            case ForwardRef:
            case MemoComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
              return childrenToTree(node2.child);
            default: {
              {
                throw Error("toTree() does not yet know how to handle nodes with tag=" + node2.tag);
              }
            }
          }
        }
        var validWrapperTypes = /* @__PURE__ */ new Set([
          FunctionComponent,
          ClassComponent,
          HostComponent,
          ForwardRef,
          MemoComponent,
          SimpleMemoComponent,
          Block,
          // Normally skipped, but used when there's more than one root child.
          HostRoot
        ]);
        function getChildren2(parent2) {
          var children2 = [];
          var startingNode = parent2;
          var node2 = startingNode;
          if (node2.child === null) {
            return children2;
          }
          node2.child.return = node2;
          node2 = node2.child;
          outer:
            while (true) {
              var descend = false;
              if (validWrapperTypes.has(node2.tag)) {
                children2.push(wrapFiber(node2));
              } else if (node2.tag === HostText) {
                children2.push("" + node2.memoizedProps);
              } else {
                descend = true;
              }
              if (descend && node2.child !== null) {
                node2.child.return = node2;
                node2 = node2.child;
                continue;
              }
              while (node2.sibling === null) {
                if (node2.return === startingNode) {
                  break outer;
                }
                node2 = node2.return;
              }
              node2.sibling.return = node2.return;
              node2 = node2.sibling;
            }
          return children2;
        }
        var ReactTestInstance = /* @__PURE__ */ function() {
          var _proto = ReactTestInstance2.prototype;
          _proto._currentFiber = function _currentFiber() {
            var fiber = findCurrentFiberUsingSlowPath(this._fiber);
            if (!(fiber !== null)) {
              {
                throw Error("Can't read from currently-mounting component. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
            return fiber;
          };
          function ReactTestInstance2(fiber) {
            if (!validWrapperTypes.has(fiber.tag)) {
              {
                throw Error("Unexpected object passed to ReactTestInstance constructor (tag: " + fiber.tag + "). This is probably a bug in React.");
              }
            }
            this._fiber = fiber;
          }
          _proto.find = function find(predicate) {
            return expectOne(this.findAll(predicate, {
              deep: false
            }), "matching custom predicate: " + predicate.toString());
          };
          _proto.findByType = function findByType(type2) {
            return expectOne(this.findAllByType(type2, {
              deep: false
            }), 'with node type: "' + (getComponentName(type2) || "Unknown") + '"');
          };
          _proto.findByProps = function findByProps(props2) {
            return expectOne(this.findAllByProps(props2, {
              deep: false
            }), "with props: " + JSON.stringify(props2));
          };
          _proto.findAll = function findAll(predicate) {
            var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            return _findAll(this, predicate, options2);
          };
          _proto.findAllByType = function findAllByType(type2) {
            var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            return _findAll(this, function(node2) {
              return node2.type === type2;
            }, options2);
          };
          _proto.findAllByProps = function findAllByProps(props2) {
            var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
            return _findAll(this, function(node2) {
              return node2.props && propsMatch(node2.props, props2);
            }, options2);
          };
          _createClass2(ReactTestInstance2, [{
            key: "instance",
            get: function() {
              if (this._fiber.tag === HostComponent) {
                return getPublicInstance(this._fiber.stateNode);
              } else {
                return this._fiber.stateNode;
              }
            }
          }, {
            key: "type",
            get: function() {
              return this._fiber.type;
            }
          }, {
            key: "props",
            get: function() {
              return this._currentFiber().memoizedProps;
            }
          }, {
            key: "parent",
            get: function() {
              var parent2 = this._fiber.return;
              while (parent2 !== null) {
                if (validWrapperTypes.has(parent2.tag)) {
                  if (parent2.tag === HostRoot) {
                    if (getChildren2(parent2).length < 2) {
                      return null;
                    }
                  }
                  return wrapFiber(parent2);
                }
                parent2 = parent2.return;
              }
              return null;
            }
          }, {
            key: "children",
            get: function() {
              return getChildren2(this._currentFiber());
            }
          }]);
          return ReactTestInstance2;
        }();
        function _findAll(root2, predicate, options2) {
          var deep = options2 ? options2.deep : true;
          var results = [];
          if (predicate(root2)) {
            results.push(root2);
            if (!deep) {
              return results;
            }
          }
          root2.children.forEach(function(child) {
            if (typeof child === "string") {
              return;
            }
            results.push.apply(results, _findAll(child, predicate, options2));
          });
          return results;
        }
        function expectOne(all2, message) {
          if (all2.length === 1) {
            return all2[0];
          }
          var prefix3 = all2.length === 0 ? "No instances found " : "Expected 1 but found " + all2.length + " instances ";
          throw new Error(prefix3 + message);
        }
        function propsMatch(props2, filter2) {
          for (var key in filter2) {
            if (props2[key] !== filter2[key]) {
              return false;
            }
          }
          return true;
        }
        function create2(element, options2) {
          var createNodeMock = defaultTestOptions.createNodeMock;
          var isConcurrent = false;
          if (typeof options2 === "object" && options2 !== null) {
            if (typeof options2.createNodeMock === "function") {
              createNodeMock = options2.createNodeMock;
            }
            if (options2.unstable_isConcurrent === true) {
              isConcurrent = true;
            }
          }
          var container2 = {
            children: [],
            createNodeMock,
            tag: "CONTAINER"
          };
          var root2 = createContainer(container2, isConcurrent ? ConcurrentRoot : LegacyRoot, false);
          if (!(root2 != null)) {
            {
              throw Error("something went wrong");
            }
          }
          updateContainer(element, root2, null, null);
          var entry = {
            _Scheduler: Scheduler2,
            root: void 0,
            // makes flow happy
            // we define a 'getter' for 'root' below using 'Object.defineProperty'
            toJSON: function() {
              if (root2 == null || root2.current == null || container2 == null) {
                return null;
              }
              if (container2.children.length === 0) {
                return null;
              }
              if (container2.children.length === 1) {
                return toJSON2(container2.children[0]);
              }
              if (container2.children.length === 2 && container2.children[0].isHidden === true && container2.children[1].isHidden === false) {
                return toJSON2(container2.children[1]);
              }
              var renderedChildren = null;
              if (container2.children && container2.children.length) {
                for (var i2 = 0; i2 < container2.children.length; i2++) {
                  var renderedChild = toJSON2(container2.children[i2]);
                  if (renderedChild !== null) {
                    if (renderedChildren === null) {
                      renderedChildren = [renderedChild];
                    } else {
                      renderedChildren.push(renderedChild);
                    }
                  }
                }
              }
              return renderedChildren;
            },
            toTree: function() {
              if (root2 == null || root2.current == null) {
                return null;
              }
              return toTree(root2.current);
            },
            update: function(newElement) {
              if (root2 == null || root2.current == null) {
                return;
              }
              updateContainer(newElement, root2, null, null);
            },
            unmount: function() {
              if (root2 == null || root2.current == null) {
                return;
              }
              updateContainer(null, root2, null, null);
              container2 = null;
              root2 = null;
            },
            getInstance: function() {
              if (root2 == null || root2.current == null) {
                return null;
              }
              return getPublicRootInstance(root2);
            },
            unstable_flushSync: function(fn2) {
              return flushSync(fn2);
            }
          };
          Object.defineProperty(entry, "root", {
            configurable: true,
            enumerable: true,
            get: function() {
              if (root2 === null) {
                throw new Error("Can't access .root on unmounted test renderer");
              }
              var children2 = getChildren2(root2.current);
              if (children2.length === 0) {
                throw new Error("Can't access .root on unmounted test renderer");
              } else if (children2.length === 1) {
                return children2[0];
              } else {
                return wrapFiber(root2.current);
              }
            }
          });
          return entry;
        }
        var fiberToWrapper = /* @__PURE__ */ new WeakMap();
        function wrapFiber(fiber) {
          var wrapper2 = fiberToWrapper.get(fiber);
          if (wrapper2 === void 0 && fiber.alternate !== null) {
            wrapper2 = fiberToWrapper.get(fiber.alternate);
          }
          if (wrapper2 === void 0) {
            wrapper2 = new ReactTestInstance(fiber);
            fiberToWrapper.set(fiber, wrapper2);
          }
          return wrapper2;
        }
        injectIntoDevTools({
          findFiberByHostInstance: function() {
            throw new Error("TestRenderer does not support findFiberByHostInstance()");
          },
          bundleType: 1,
          version: ReactVersion,
          rendererPackageName: "react-test-renderer"
        });
        var actingUpdatesScopeDepth$1 = 0;
        function unstable_concurrentAct(scope) {
          if (Scheduler2.unstable_flushAllWithoutAsserting === void 0) {
            throw Error("This version of `act` requires a special mock build of Scheduler.");
          }
          if (setTimeout._isMockFunction !== true) {
            throw Error("This version of `act` requires Jest's timer mocks (i.e. jest.useFakeTimers).");
          }
          var previousActingUpdatesScopeDepth = actingUpdatesScopeDepth$1;
          var previousIsSomeRendererActing = IsSomeRendererActing$1.current;
          var previousIsThisRendererActing = IsThisRendererActing.current;
          IsSomeRendererActing$1.current = true;
          IsThisRendererActing.current = true;
          actingUpdatesScopeDepth$1++;
          var unwind = function() {
            actingUpdatesScopeDepth$1--;
            IsSomeRendererActing$1.current = previousIsSomeRendererActing;
            IsThisRendererActing.current = previousIsThisRendererActing;
            {
              if (actingUpdatesScopeDepth$1 > previousActingUpdatesScopeDepth) {
                error2("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
              }
            }
          };
          try {
            var thenable = batchedUpdates(scope);
            if (typeof thenable === "object" && thenable !== null && typeof thenable.then === "function") {
              return {
                then: function(resolve, reject) {
                  thenable.then(function() {
                    flushActWork$1(function() {
                      unwind();
                      resolve();
                    }, function(error3) {
                      unwind();
                      reject(error3);
                    });
                  }, function(error3) {
                    unwind();
                    reject(error3);
                  });
                }
              };
            } else {
              try {
                var didFlushWork;
                do {
                  didFlushWork = Scheduler2.unstable_flushAllWithoutAsserting();
                } while (didFlushWork);
              } finally {
                unwind();
              }
            }
          } catch (error3) {
            unwind();
            throw error3;
          }
        }
        function flushActWork$1(resolve, reject) {
          jest.runOnlyPendingTimers();
          enqueueTask(function() {
            try {
              var didFlushWork = Scheduler2.unstable_flushAllWithoutAsserting();
              if (didFlushWork) {
                flushActWork$1(resolve, reject);
              } else {
                resolve();
              }
            } catch (error3) {
              reject(error3);
            }
          });
        }
        exports2._Scheduler = Scheduler2;
        exports2.act = act2;
        exports2.create = create2;
        exports2.unstable_batchedUpdates = batchedUpdates;
        exports2.unstable_concurrentAct = unstable_concurrentAct;
      })();
    }
  })(reactTestRenderer_development, reactTestRenderer_development.exports);
  return reactTestRenderer_development.exports;
}
if (process.env.NODE_ENV === "production") {
  reactTestRenderer.exports = requireReactTestRenderer_production_min();
} else {
  reactTestRenderer.exports = requireReactTestRenderer_development();
}
var reactTestRendererExports = reactTestRenderer.exports;
const TestRenderer = /* @__PURE__ */ getDefaultExportFromCjs(reactTestRendererExports);
const physicsTypes = {
  molasses: {
    clamp: true,
    tension: 280,
    friction: 120
  },
  stiff: {
    clamp: true,
    mass: 1,
    tension: 210,
    friction: 20
  }
};
const physics$4 = {
  type: {
    ...physicsTypes
  }
};
const physics$3 = {
  type: physics$4.type.stiff
};
const accountInfo = {
  physics: physics$3,
  from: { height: 0, marginTop: 0, opacity: 0, scaleY: 0 },
  enter: { height: 1, marginTop: 1, opacity: 1, scaleY: 1 },
  leave: { height: 0, marginTop: 0, opacity: 0, scaleY: 0 }
};
const physics$2 = {
  type: physics$4.type.stiff
};
const modal$5 = {
  physics: physics$2,
  from: { opacity: 0, y: -10 },
  enter: { opacity: 1, y: 0 },
  leave: { opacity: 0, y: -10 }
};
const physics$1 = {
  type: physics$4.type.stiff
};
const overlay$1 = {
  physics: physics$1,
  from: { opacity: 0 },
  enter: { opacity: 1 },
  leave: { opacity: 0 }
};
const physics = {
  type: physics$4.type.stiff
};
const sheet$3 = {
  physics,
  from: { opacity: 0, y: 100 },
  enter: { opacity: 1, y: 0 },
  leave: { opacity: 0, y: 100 }
};
const Durations = {
  [
    "Duration0"
    /* Duration0 */
  ]: "0",
  [
    "Duration75"
    /* Duration75 */
  ]: "75",
  [
    "Duration100"
    /* Duration100 */
  ]: "100",
  [
    "Duration150"
    /* Duration150 */
  ]: "150",
  [
    "Duration200"
    /* Duration200 */
  ]: "200",
  [
    "Duration350"
    /* Duration350 */
  ]: "350",
  [
    "Duration400"
    /* Duration400 */
  ]: "400",
  [
    "Duration700"
    /* Duration700 */
  ]: "700",
  [
    "Duration3000"
    /* Duration3000 */
  ]: "3000"
};
const timings = {
  easeOut: "ease-out",
  easeInOut: "ease-in-out"
};
const show = keyframes$1({
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
});
const opacity = {
  fadeIn: `${Durations.Duration700}ms ${show} backwards`
};
const slide$1 = keyframes$1({
  from: {
    backgroundPosition: "0 0"
  },
  to: {
    backgroundPosition: "100% 0"
  }
});
const skeletonContentAnimation = {
  animation: `${slide$1} ${Durations.Duration3000}ms infinite linear`,
  backgroundSize: "300% 100%",
  backgroundImage: `linear-gradient(90deg, var(--theme-ui-colors-skeletonContent-secondaryBackground), var(--theme-ui-colors-skeletonContent-background), var(--theme-ui-colors-skeletonContent-secondaryBackground), var(--theme-ui-colors-skeletonContent-background));`
};
const skeletonContentRainbowAnimation = {
  animation: `${slide$1} ${Durations.Duration3000}ms infinite linear`,
  backgroundSize: "200% 100%",
  backgroundImage: `linear-gradient(90deg,
  rgba(255, 0, 0, 1),
  rgba(255, 154, 0, 1),
  rgba(208, 222, 33, 1),
  rgba(79, 220, 74, 1),
  rgba(63, 218, 216, 1),
  rgba(47, 201, 226, 1),
  rgba(28, 127, 238, 1),
  rgba(95, 21, 242, 1),
  rgba(186, 12, 248, 1),
  rgba(251, 7, 217, 1),
  rgba(255, 0, 0, 1),
  rgba(255, 154, 0, 1),
  rgba(208, 222, 33, 1),
  rgba(79, 220, 74, 1),
  rgba(63, 218, 216, 1),
  rgba(47, 201, 226, 1),
  rgba(28, 127, 238, 1),
  rgba(95, 21, 242, 1),
  rgba(186, 12, 248, 1),
  rgba(251, 7, 217, 1),
  rgba(255, 0, 0, 1)
  );`
};
const slideRightKeyFrame = keyframes$1({
  from: {
    opacity: "0",
    transform: "translateX(-10%)"
  },
  to: {
    opacity: "1",
    transform: "translateX(0%)"
  }
});
const slideLeftKeyframe = keyframes$1({
  from: {
    transform: "translateX(100%)",
    opacity: 0
  },
  to: {
    transform: "translateX(0%)",
    opacity: 1
  }
});
const slideDownKeyframe = keyframes$1({
  from: {
    transform: "translateY(-10%)"
  },
  to: {
    transform: "translateY(0%)"
  }
});
const slideUpKeyframe = keyframes$1({
  from: {
    transform: "translateY(100%)",
    opacity: 0
  },
  to: {
    transform: "translateY(0%)",
    opacity: 1
  }
});
const slide = {
  right: `0.5s ${slideRightKeyFrame}`,
  left: `0.5s ${slideLeftKeyframe}`,
  up: `0.5s ${slideUpKeyframe}`,
  down: `0.5s ${slideDownKeyframe}`
};
const stepper$1 = {
  springConfig: physics$4.type.molasses,
  duration: {
    collapse: 100,
    expand: 200
  }
};
const keyframes2 = {
  opacity,
  slide
};
const components$2 = {
  accountInfo,
  popoverSlide: animatePopover,
  modal: modal$5,
  overlay: overlay$1,
  sheet: sheet$3,
  skeletonContentAnimation,
  skeletonContentRainbowAnimation,
  stepper: stepper$1
};
const animations = {
  physics: physics$4,
  keyframes: keyframes2,
  ...components$2
};
const cardBorders = {
  locked: `1px solid ${combinedPalettes$1["fog-20"]}`
};
const linkBorderWidth = "2px";
const navbarBorders = {
  __default: "1px solid"
};
const paginationBorderWidth = 2;
const pagination$1 = {
  active: `${paginationBorderWidth}px solid`
};
const radio$2 = {
  unchecked: "1.5px solid",
  checked: "6px solid",
  focusRing: "2px solid",
  checkMark: "2px solid"
};
const baseBorders = {
  default: "1px solid"
};
const componentBorders = {
  button: baseBorders.default,
  card: cardBorders,
  focusedComponents: {
    focusVisible: "0px solid",
    focus: "0px solid"
  },
  link: {
    focused: "0px solid",
    focusedVisible: "2px solid"
  },
  input: baseBorders.default,
  pagination: pagination$1,
  radio: radio$2,
  tail: {
    __default: "7px solid transparent"
  },
  table: baseBorders.default,
  navbar: navbarBorders
};
const borders = {
  ...baseBorders,
  ...componentBorders
};
const borderWidths = {
  tail: {
    borderBottom: "8px"
  },
  focused: {
    borderBottom: "2px"
  }
};
const borderStyles = {};
const surface = {
  __default: combinedPalettes$1["fog-00"],
  brand: {
    dawn: combinedPalettes$1["dawn-30"],
    dusk: combinedPalettes$1["dusk-30"],
    eucalyptus: {
      dark: combinedPalettes$1["eucalyptus-80"],
      light: combinedPalettes$1["eucalyptus-30"]
    }
  },
  dark: combinedPalettes$1["fog-70"],
  default: {
    __default: combinedPalettes$1["fog-10"],
    subdued: combinedPalettes$1["fog-05"]
  },
  error: {
    __default: combinedPalettes$1["ember-10"],
    subdued: combinedPalettes$1["ember-05"]
  },
  info: {
    __default: combinedPalettes$1["midnight-10"],
    subdued: combinedPalettes$1["midnight-05"]
  },
  neutral: {
    __default: combinedPalettes$1["fog-10"],
    subdued: combinedPalettes$1["fog-05"]
  },
  success: {
    __default: combinedPalettes$1["fern-10"],
    subdued: combinedPalettes$1["fern-05"]
  },
  warning: {
    __default: combinedPalettes$1["dawn-10"],
    subdued: combinedPalettes$1["dawn-05"]
  }
};
const action$1 = {
  destructive: {
    __default: combinedPalettes$1["ember-60"],
    disabled: combinedPalettes$1["fog-10"],
    hover: combinedPalettes$1["ember-70"],
    pressed: combinedPalettes$1["ember-80"],
    loading: alpha(combinedPalettes$1["ember-70"], 0.8)
  },
  primary: {
    __default: combinedPalettes$1["dusk-50"],
    disabled: combinedPalettes$1["fog-10"],
    hover: combinedPalettes$1["dusk-60"],
    pressed: combinedPalettes$1["dusk-70"],
    loading: alpha(combinedPalettes$1["dusk-70"], 0.8),
    loadingBorder: alpha(combinedPalettes$1["dusk-70"], 0.1)
  },
  secondary: {
    __default: combinedPalettes$1["fog-00"],
    disabled: combinedPalettes$1["fog-10"],
    hover: combinedPalettes$1["fog-10"],
    pressed: combinedPalettes$1["fog-20"],
    loading: alpha(surface.neutral.subdued, 0.8)
  }
};
const background = {
  __default: combinedPalettes$1["fog-10"]
};
const border$1 = {
  __default: combinedPalettes$1["fog-30"],
  active: combinedPalettes$1["dusk-50"],
  disabled: combinedPalettes$1["fog-30"],
  error: {
    __default: combinedPalettes$1["ember-30"],
    hover: combinedPalettes$1["ember-40"],
    pressed: combinedPalettes$1["ember-50"],
    active: combinedPalettes$1["ember-60"]
  },
  focused: combinedPalettes$1["dusk-50"],
  hover: combinedPalettes$1["fog-40"],
  pressed: combinedPalettes$1["fog-50"],
  primary: {
    __default: combinedPalettes$1["dusk-30"],
    hover: combinedPalettes$1["dusk-40"],
    pressed: combinedPalettes$1["dusk-50"],
    active: combinedPalettes$1["dusk-60"]
  },
  secondary: combinedPalettes$1["fog-60"],
  subdued: combinedPalettes$1["fog-20"],
  success: {
    __default: combinedPalettes$1["fern-30"],
    hover: combinedPalettes$1["fern-40"],
    pressed: combinedPalettes$1["fern-50"],
    active: combinedPalettes$1["fern-60"]
  }
};
const avatarColors = {
  default: {
    background: combinedPalettes$1["dawn-30"],
    text: combinedPalettes$1["dawn-70"]
  },
  dusk: {
    background: combinedPalettes$1["dusk-80"],
    text: combinedPalettes$1["dusk-20"]
  }
};
const icon$2 = {
  __default: alpha(combinedPalettes$1["fog-80"], 0.75),
  error: combinedPalettes$1["ember-50"],
  info: combinedPalettes$1["midnight-50"],
  primary: combinedPalettes$1["dusk-50"],
  subdued: alpha(combinedPalettes$1["fog-80"], 0.4),
  success: combinedPalettes$1["fern-50"],
  warning: combinedPalettes$1["dawn-50"],
  white: combinedPalettes$1["fog-00"]
};
const bannerColors = {
  background: {
    error: surface.error.__default,
    info: surface.info.__default,
    success: surface.success.__default,
    warning: surface.warning.__default,
    announcement: combinedPalettes$1["dusk-10"]
  },
  icon: {
    error: icon$2.error,
    info: icon$2.info,
    success: icon$2.success,
    warning: icon$2.warning,
    announcement: combinedPalettes$1["fog-50"]
  }
};
const text$1 = {
  error: combinedPalettes$1["ember-70"],
  info: combinedPalettes$1["midnight-60"],
  brand: {
    dawn: combinedPalettes$1["dawn-80"],
    dusk: combinedPalettes$1["dusk-80"],
    eucalyptus: {
      dark: combinedPalettes$1["eucalyptus-30"],
      light: combinedPalettes$1["eucalyptus-80"]
    }
  },
  primary: combinedPalettes$1["fog-80"],
  secondary: alpha(combinedPalettes$1["fog-80"], 0.75),
  subdued: alpha(combinedPalettes$1["fog-80"], 0.4),
  success: combinedPalettes$1["fern-60"],
  tertiary: alpha(combinedPalettes$1["fog-80"], 0.6),
  warning: combinedPalettes$1["dawn-70"],
  white: combinedPalettes$1["fog-00"]
};
const textLoading = {
  loading: {
    primary: alpha(text$1.white, 0.2),
    secondary: alpha(text$1.primary, 0.2),
    tertiary: alpha(text$1.primary, 0.2),
    destructive: alpha(text$1.white, 0.2)
  }
};
const text$2 = {
  ...text$1,
  ...textLoading
};
const opaque = {
  "dusk-50": {
    8: alpha(combinedPalettes$1["dusk-50"], 0.08),
    12: alpha(combinedPalettes$1["dusk-50"], 0.12),
    20: alpha(combinedPalettes$1["dusk-50"], 0.2)
  },
  "fog-00": {
    4: alpha(combinedPalettes$1["fog-00"], 0.04),
    8: alpha(combinedPalettes$1["fog-00"], 0.08),
    12: alpha(combinedPalettes$1["fog-00"], 0.12),
    64: alpha(combinedPalettes$1["fog-00"], 0.64),
    80: alpha(combinedPalettes$1["fog-00"], 0.8)
  },
  "fog-80": {
    4: alpha(combinedPalettes$1["fog-80"], 0.04),
    8: alpha(combinedPalettes$1["fog-80"], 0.08),
    12: alpha(combinedPalettes$1["fog-80"], 0.12),
    32: alpha(combinedPalettes$1["fog-80"], 0.32),
    64: alpha(combinedPalettes$1["fog-80"], 0.64),
    80: alpha(combinedPalettes$1["fog-80"], 0.8)
  }
};
const buttonColors$1 = {
  // Variants
  primary: {
    background: {
      __default: action$1.primary.__default,
      active: action$1.primary.pressed,
      disabled: action$1.primary.disabled,
      hover: action$1.primary.hover,
      loading: action$1.primary.loading
    },
    border: {
      __default: action$1.primary.__default,
      active: action$1.primary.pressed,
      disabled: action$1.primary.disabled,
      focused: border$1.primary.pressed,
      hover: action$1.primary.hover,
      loading: action$1.primary.loadingBorder
    },
    foreground: {
      loading: icon$2.white
    },
    text: {
      __default: text$2.white,
      disabled: text$2.subdued,
      loading: text$2.loading.primary
    }
  },
  secondary: {
    background: {
      __default: "transparent",
      active: opaque["fog-80"][12],
      disabled: "transparent",
      hover: opaque["fog-80"][8],
      loading: action$1.secondary.loading
    },
    border: {
      __default: border$1.secondary,
      active: border$1.pressed,
      disabled: border$1.disabled,
      focused: border$1.primary.pressed,
      hover: border$1.hover
    },
    foreground: {
      loading: icon$2.__default
    },
    text: {
      __default: text$2.secondary,
      disabled: text$2.subdued,
      loading: text$2.loading.secondary
    }
  },
  tertiary: {
    background: {
      __default: "transparent",
      active: opaque["fog-80"][12],
      disabled: "transparent",
      focused: opaque["fog-80"][8],
      hover: opaque["fog-80"][8],
      loading: action$1.secondary.loading
    },
    foreground: {
      loading: icon$2.__default
    },
    text: {
      __default: text$2.secondary,
      disabled: text$2.subdued,
      loading: text$2.loading.tertiary
    }
  },
  destructive: {
    background: {
      __default: action$1.destructive.__default,
      active: action$1.destructive.pressed,
      disabled: action$1.destructive.disabled,
      focused: action$1.destructive.hover,
      hover: action$1.destructive.hover,
      loading: action$1.destructive.loading
    },
    foreground: {
      loading: icon$2.white
    },
    text: {
      __default: text$2.white,
      disabled: text$2.subdued,
      loading: text$2.loading.destructive
    }
  },
  back: {
    text: {
      __default: text$2.secondary,
      active: text$2.primary,
      hover: text$2.tertiary
    }
  }
};
const cardColors = {
  background: surface.__default,
  locked: surface.neutral.__default
};
const checkboxColors = {
  default: {
    indeterminate: {
      rectStroke: combinedPalettes$1["fog-00"],
      stroke: combinedPalettes$1["fog-00"],
      fill: action$1.primary.__default
    },
    checked: {
      rectStroke: combinedPalettes$1["fog-00"],
      stroke: combinedPalettes$1["fog-00"],
      fill: action$1.primary.__default
    },
    unchecked: {
      stroke: border$1.__default
    }
  },
  // Checkbox is clicked
  active: {
    checked: {
      fill: action$1.primary.pressed
    },
    unchecked: {
      stroke: border$1.pressed
    }
  },
  disabled: {
    checked: {
      fill: combinedPalettes$1["fog-30"],
      stroke: border$1.disabled,
      path: {
        fill: "transparent"
      }
    },
    indeterminate: {
      fill: combinedPalettes$1["fog-30"],
      stroke: border$1.disabled,
      path: {
        fill: icon$2.subdued
      }
    },
    unchecked: {
      fill: action$1.secondary.disabled,
      stroke: border$1.disabled
    }
  },
  focused: {
    checked: {
      fill: action$1.primary.hover
    },
    indeterminate: {
      fill: action$1.primary.hover
    },
    unchecked: {
      stroke: border$1.primary.hover
    }
  },
  hover: {
    checked: {
      fill: action$1.primary.hover
    },
    indeterminate: {
      fill: action$1.primary.hover
    },
    unchecked: {
      stroke: border$1.hover
    }
  }
};
const dividerColors = {
  primary: combinedPalettes$1["fog-40"],
  secondary: combinedPalettes$1["fog-20"]
};
const footerColors = {
  background: surface.neutral.__default
};
const inlineCalloutColors = {
  background: {
    __default: surface.default.__default,
    error: surface.error.__default,
    info: surface.info.__default,
    success: surface.success.__default,
    warning: surface.warning.__default
  },
  stroke: {
    dismiss: icon$2.__default
  }
};
const formColors$1 = {
  background: surface.__default,
  disabled: {
    border: surface.neutral.subdued,
    background: surface.neutral.subdued,
    hintText: text$2.secondary,
    text: text$2.secondary
  },
  placeholder: text$2.subdued,
  // Variant based color definitions
  default: {
    border: {
      __default: border$1.__default,
      active: border$1.active,
      hover: border$1.hover
    },
    hintText: text$2.primary
  },
  error: {
    border: {
      __default: border$1.error.__default,
      active: border$1.error.active,
      hover: border$1.error.hover
    },
    hintText: text$2.error
  },
  success: {
    border: {
      __default: border$1.success.__default,
      active: border$1.success.active,
      hover: border$1.success.hover
    },
    hintText: text$2.success
  }
};
const linkColors$1 = {
  __default: "inherit",
  border: {
    focused: border$1.focused
  },
  disabled: text$2.subdued,
  subtle: combinedPalettes$1["fog-50"],
  vibrant: combinedPalettes$1["dusk-50"],
  standalone: text$2.tertiary
};
const listItemColors = {
  background: {
    bubble: combinedPalettes$1["fog-20"]
  }
};
const menuListItemColors = {
  background: {
    __default: surface.__default,
    active: combinedPalettes$1["dusk-05"],
    hover: surface.neutral.__default
  }
};
const modalColors = {
  background: surface.__default
};
const overlayColors = {
  background: opaque["fog-80"][64]
};
const notificationColors = {
  background: {
    info: combinedPalettes$1["midnight-70"],
    success: combinedPalettes$1["fern-70"],
    warning: combinedPalettes$1["dawn-70"],
    error: combinedPalettes$1["ember-70"]
  }
};
const paginationColors = {
  number: {
    borderColor: {
      active: combinedPalettes$1["fog-80"],
      disabled: combinedPalettes$1["fog-30"]
    }
  }
};
const popoverColors = {
  default: {
    background: surface.__default,
    border: border$1.__default,
    text: text$2.secondary
  },
  tooltip: {
    background: surface.dark,
    border: border$1.__default,
    text: text$2.white
  }
};
const progressBarColors = {
  trackBackground: combinedPalettes$1["fog-05"],
  indicatorBackground: combinedPalettes$1["dusk-70"]
};
const radioColors = {
  center: {
    __default: action$1.secondary.__default,
    checked: icon$2.white,
    disabled: icon$2.subdued
  },
  fill: {
    // Used for disabled checked state only
    disabled: action$1.secondary.disabled
  },
  border: {
    __default: border$1.__default,
    checked: action$1.primary.__default,
    disabled: border$1.disabled,
    // Disabled checked state is handled by box shadow
    focused: {
      __default: border$1.hover,
      ring: dusk$2[50]
    },
    hover: {
      __default: border$1.hover,
      checked: action$1.primary.hover
    },
    press: {
      __default: border$1.pressed,
      checked: action$1.primary.pressed
    }
  }
};
const sheetColors = {
  background: {
    __default: surface.__default
  }
};
const skeletonContentColors = {
  background: combinedPalettes$1["fog-20"],
  secondaryBackground: combinedPalettes$1["fog-10"]
};
const { fog: fog$2, dusk: dusk$1 } = palettes$1;
const fog80Alpha0 = alpha(fog$2["80"], 0);
const fog80Alpha4 = alpha(fog$2["80"], 0.04);
const fog80Alpha8$1 = alpha(fog$2["80"], 0.08);
const fog80Alpha12 = alpha(fog$2["80"], 0.12);
const fog80Alpha16 = alpha(fog$2["80"], 0.16);
const dusk50Alpha20$1 = alpha(dusk$1["50"], 0.2);
const shadowVariants = {
  checkbox: {
    hover: `0 0 0 6px ${fog80Alpha8$1}`,
    active: `0 0 0 6px ${dusk50Alpha20$1}`
  },
  elevation: {
    one: `0px 1px 0px ${fog80Alpha8$1}`,
    two: `0px 1px 2px ${fog80Alpha16},0px 2px 4px ${fog80Alpha4}`,
    three: `0px 1px 0px ${fog80Alpha4},0px 2px 8px ${fog80Alpha12}`,
    four: `0px 1px 0px ${fog80Alpha4},0px 4px 16px ${fog80Alpha16}`,
    five: `0px 4px 8px ${fog80Alpha4},0px 8px 24px ${fog80Alpha16}`,
    six: `0px 8px 16px ${fog80Alpha4},0px 12px 32px ${fog80Alpha16}`
  },
  input: `0px 0px 0px 4px ${dusk$1["10"]}`,
  "one-pixel-soft": `
  0px 0px 0px 1px ${fog$2["00"]},
  0px 0px 0px 2px ${dusk$1["50"]}`,
  "two-pixel-soft": `
      0px 0px 0px 2px ${fog$2["00"]},
      0px 0px 0px 4px ${dusk$1["50"]}`,
  "two-pixel-soft-minimize-inner-border": `
      inset 0px 0px 0px 3px ${fog$2["00"]},
      0px 0px 0px 2px ${fog$2["00"]},
      0px 0px 0px 4px ${dusk$1["50"]}`,
  "two-pixel-dusk": `
      0px 0px 0px 2px ${dusk$1["60"]}`,
  "three-pixel-padded": `
      0 0 0 1px ${fog$2["00"]},
      0 0 0 3px ${dusk$1["50"]}`,
  menuListItem: {
    active: `0px 0px 0px 2px ${dusk$1["50"]}`,
    navigation: {
      active: `inset 0px 0px 0px 2px ${dusk$1["50"]}`
    }
  },
  modal: {
    container: `0px 8px 16px ${fog80Alpha4}, 0px 12px 32px ${fog80Alpha16}`
  },
  primary: `0 0 0 2px ${fog$2["00"]}, 0 0 0 4px ${dusk$1["50"]}`,
  radio: {
    hover: `0 0 0 8px ${fog80Alpha8$1}`,
    active: `0 0 0 8px ${dusk50Alpha20$1}`,
    focus: `0 0 0 8px ${dusk$1["10"]}`,
    disabled: `0 0 0 1px ${fog$2["20"]}`,
    checkMark: `0 0 0 8px ${fog80Alpha12}`
  },
  // Adds shadows to hint that content is available in scroll direction
  scroll: {
    vertical: {
      background: `linear-gradient(${fog$2["00"]}, ${fog$2["00"]}), linear-gradient(${fog$2["00"]}, ${fog$2["00"]}) 0 100%,linear-gradient(${fog80Alpha4}, ${fog80Alpha0}), linear-gradient(${fog80Alpha0}, ${fog80Alpha4}) 0 100%`,
      // Shadows
      backgroundRepeat: "no-repeat",
      backgroundSize: "100% 48px, 100% 48px, 100% 16px, 100% 16px",
      backgroundAttachment: "local, local, scroll, scroll"
    }
  },
  slider: {
    focus: `0 0 0 2px #FFF, 0 0 0 4px ${action$1.primary.pressed}`
  }
};
const sliderColors = {
  track: {
    background: border$1.__default,
    disabled: {
      background: border$1.subdued
    },
    activeSelectionRange: {
      enable: {
        backgroundImage: `linear-gradient(${surface.dark},${surface.dark})`
      },
      focus: {
        backgroundImage: `linear-gradient(${action$1.primary.pressed},${action$1.primary.pressed})`
      },
      disabled: {
        backgroundImage: `linear-gradient(${border$1.__default},${border$1.__default})`
      }
    }
  },
  thumb: {
    enable: {
      background: surface.dark
    },
    focus: {
      background: action$1.primary.pressed,
      boxShadow: shadowVariants.slider.focus
    },
    disabled: {
      background: border$1.__default
    }
  }
};
const spinnerColors = {
  primary: background.__default,
  secondary: combinedPalettes$1["fog-60"]
};
const stepperColors = {
  step: {
    icon: {
      background: combinedPalettes$1["fog-00"],
      complete: combinedPalettes$1["dusk-70"],
      locked: combinedPalettes$1["fog-20"]
    },
    rail: {
      __default: combinedPalettes$1["fog-30"],
      complete: combinedPalettes$1["dusk-70"]
    }
  }
};
const { fog: fog$1, dusk } = palettes$1;
const fog80Alpha8 = alpha(fog$1["80"], 0.08);
const dusk50Alpha20 = alpha(dusk["50"], 0.2);
const superRadioColors = {
  background: {
    __default: action$1.secondary.__default,
    disabled: action$1.secondary.disabled,
    hover: fog80Alpha8,
    active: dusk50Alpha20
  },
  border: {
    __default: border$1.subdued,
    checked: combinedPalettes$1["fog-80"],
    hover: {
      __default: border$1.hover,
      checked: border$1.pressed
    },
    disabled: border$1.disabled
  },
  footer: {
    __default: surface.neutral.subdued
  }
};
const tableColors = {
  background: {
    even: surface.neutral.__default,
    odd: surface.__default
  },
  header: {
    border: border$1.__default
  },
  data: {
    border: border$1.subdued
  }
};
const timelineColors = {
  icon: {
    __default: combinedPalettes$1["fern-50"],
    inactive: combinedPalettes$1["fog-30"],
    stroke: combinedPalettes$1["fog-00"]
  },
  firstTimeStep: {
    background: `linear-gradient(90deg, rgba(255,0,0,0) 50%, ${surface.neutral.__default} 50%)`
  },
  middleTimeStep: {
    background: surface.neutral.__default
  },
  lastTimeStep: {
    background: `linear-gradient(90deg, ${surface.neutral.__default} 50%, rgba(255,0,0,0) 50%)`
  }
};
const tagColors = {
  background: {
    __default: surface.neutral.__default,
    error: surface.error.__default,
    info: surface.info.__default,
    success: surface.success.__default,
    warning: surface.warning.__default,
    indeterminate: combinedPalettes$1["fog-20"],
    dusk: combinedPalettes$1["dusk-10"],
    eucalyptus: combinedPalettes$1["eucalyptus-10"],
    dark: {
      info: combinedPalettes$1["midnight-70"],
      success: combinedPalettes$1["fern-70"],
      warning: combinedPalettes$1["dawn-70"],
      error: combinedPalettes$1["ember-60"],
      dusk: combinedPalettes$1["dusk-70"],
      indeterminate: combinedPalettes$1["fog-60"],
      eucalyptus: combinedPalettes$1["eucalyptus-70"]
    }
  },
  foreground: {
    __default: text$2.primary,
    error: text$2.error,
    info: text$2.info,
    success: text$2.success,
    warning: text$2.warning,
    indeterminate: text$2.secondary,
    dusk: combinedPalettes$1["dusk-70"],
    eucalyptus: combinedPalettes$1["eucalyptus-80"],
    dark: {
      info: text$2.white,
      success: text$2.white,
      warning: text$2.white,
      error: text$2.white,
      indeterminate: text$2.white,
      dusk: text$2.white,
      eucalyptus: text$2.white
    }
  }
};
const toastColors = {
  background: surface.dark,
  text: text$2.white,
  icon: {
    error: icon$2.error,
    info: icon$2.info,
    success: icon$2.success,
    warning: icon$2.warning
  }
};
const transactionsHistoryColors = {
  breakdownControl: {
    icon: text$2.tertiary,
    content: text$2.tertiary
  },
  breakdownSubItem: {
    label: text$2.primary,
    text: text$2.tertiary,
    surface: surface.neutral.subdued
  }
};
const navbarColors = {
  background: surface.__default,
  link: {
    background: {
      __default: surface.__default,
      hover: surface.neutral.__default
    },
    borderColor: {
      active: combinedPalettes$1["dusk-50"]
    }
  },
  dropdown: {
    item: {
      active: surface.neutral.__default
    },
    footer: {
      background: surface.neutral.__default,
      color: text$2.primary
    }
  }
};
const summaryCard$1 = {
  background: {
    __default: action$1.secondary.__default
  },
  border: {
    __default: border$1.__default
  }
};
const percentageStackedBarChart$2 = {
  trackBackground: combinedPalettes$1["fog-20"],
  otherFilledBackground: combinedPalettes$1["fog-80"]
};
const components$1 = {
  avatar: avatarColors,
  banner: bannerColors,
  button: buttonColors$1,
  card: cardColors,
  checkbox: checkboxColors,
  divider: dividerColors,
  footer: footerColors,
  inlineCallout: inlineCalloutColors,
  forms: formColors$1,
  link: linkColors$1,
  listItem: listItemColors,
  menuListItem: menuListItemColors,
  modal: modalColors,
  navbar: navbarColors,
  notification: notificationColors,
  overlay: overlayColors,
  pagination: paginationColors,
  percentageStackedBarChart: percentageStackedBarChart$2,
  popover: popoverColors,
  progressBar: progressBarColors,
  radio: radioColors,
  sheet: sheetColors,
  skeletonContent: skeletonContentColors,
  slider: sliderColors,
  spinner: spinnerColors,
  stepper: stepperColors,
  summaryCard: summaryCard$1,
  superRadio: superRadioColors,
  table: tableColors,
  tag: tagColors,
  timeline: timelineColors,
  toast: toastColors,
  transactionsHistory: transactionsHistoryColors
};
const lightColors$1 = {
  action: action$1,
  background,
  border: border$1,
  icon: icon$2,
  opaque,
  surface,
  text: text$2,
  ...components$1
};
const colorModes$1 = { light: lightColors$1 };
const fonts$2 = {
  heading: "TTNormsPro, Helvetica, sans-serif",
  body: "TTNormsPro, arial, sans-serif",
  monospace: "Menlo, monospace"
};
const fontWeights$2 = {
  normal: 400,
  demibold: 600,
  bold: 700
};
const fontSizes$2 = {
  9: "0.5625rem",
  10: "0.625rem",
  11: "0.6875rem",
  12: "0.75rem",
  14: "0.875rem",
  15: "0.9375rem",
  16: "1rem",
  17: "1.0625rem",
  18: "1.125rem",
  20: "1.25rem",
  24: "1.5rem",
  28: "1.75rem",
  30: "1.875rem",
  32: "2rem",
  34: "2.125rem",
  36: "2.25rem",
  40: "2.5rem",
  44: "2.75rem",
  48: "3rem",
  56: "3.5rem",
  64: "4rem",
  80: "5rem",
  90: "5.625rem"
};
const letterSpacings$2 = {
  "-2": "-0.02em",
  "-1.6": "-0.016em",
  "-0.6": "-0.006em",
  "-0.4": "-0.004em",
  0: "0em",
  0.4: "0.004em",
  0.8: "0.008em"
};
const lineHeights$1 = {
  1: "1rem",
  1.25: "1.25rem",
  1.375: "1.375rem",
  1.625: "1.625rem",
  2: "2rem",
  2.5: "2.5rem",
  3: "3rem",
  3.375: "3.375rem",
  4.5: "4.5rem",
  5.5: "5.5rem"
};
const tokenInputLetterSpacing = 12;
const tokenInput = {
  fontSize: fontSizes$2[34],
  letterSpacing: `${tokenInputLetterSpacing}px`
};
const avatarFonts = {
  fontWeight: fontWeights$2.bold
};
const fontSizes$1 = {
  ...fontSizes$2,
  tokenInput: { fontSize: tokenInput.fontSize }
};
const fontWeights$1 = {
  ...fontWeights$2,
  avatar: avatarFonts.fontWeight
};
const letterSpacings$1 = {
  ...letterSpacings$2,
  tokenInput: { letterSpacing: tokenInput.letterSpacing }
};
const baseRadii = {
  0: "0",
  2: "2px",
  4: "4px",
  6: "6px",
  8: "8px",
  12: "12px",
  24: "24px",
  36: "36px",
  48: "48px",
  50: "50px",
  "50%": "50%",
  "100%": "100%"
};
const avatar$1 = {
  human: baseRadii["50%"],
  entity: baseRadii[4]
};
const button$1 = {
  default: baseRadii[4],
  circle: baseRadii["50%"]
};
const card$2 = {
  container: baseRadii[8]
};
const contributionChartProgressBarHeight = 8;
const contributionChart$2 = {
  tooltip: {
    width: "224px",
    item: {
      height: "12px",
      width: "12px"
    }
  },
  progressBar: {
    height: `${contributionChartProgressBarHeight}px`
  }
};
const contributionChart$1 = {
  progressBar: {
    borderRadius: `${Math.round(contributionChartProgressBarHeight / 2)}px`
  }
};
const checkbox$1 = {
  default: baseRadii[4],
  action: baseRadii[36]
};
const deltaDisplay = {
  button: baseRadii[2]
};
const form = {
  input: baseRadii[4]
};
const inlineCallout = {
  container: baseRadii[8]
};
const link$1 = {
  focus: baseRadii[2]
};
const listItem$1 = {
  ordered: baseRadii["100%"]
};
const menuList$1 = {
  container: baseRadii[8]
};
const menuListItem$1 = {
  container: baseRadii[4]
};
const modal$4 = {
  container: baseRadii[8]
};
const notification$1 = {
  default: baseRadii["50"],
  dot: baseRadii["50%"]
};
const popover$2 = {
  default: baseRadii[4],
  tooltip: baseRadii[8]
};
const portfolioChart$1 = {
  chartWrapper: baseRadii[2]
};
const progressBar$2 = {
  default: baseRadii[4]
};
const radio$1 = {
  default: baseRadii["50%"]
};
const workflowInsight$1 = {
  __default: baseRadii[8]
};
const sheet$2 = {
  __default: `${baseRadii[8]} ${baseRadii[8]} ${baseRadii[0]} ${baseRadii[0]}`
};
const skeletonContent$1 = {
  container: baseRadii[4]
};
const superRadio$1 = {
  container: baseRadii[8],
  checkMark: baseRadii[12]
};
const summaryCard = {
  container: baseRadii[4]
};
const tag$1 = {
  default: baseRadii[4]
};
const timeline$2 = {
  default: baseRadii["100%"]
};
const componentRadii = {
  avatar: avatar$1,
  button: button$1,
  card: card$2,
  contributionChart: contributionChart$1,
  checkbox: checkbox$1,
  deltaDisplay,
  form,
  inlineCallout,
  link: link$1,
  listItem: listItem$1,
  menuList: menuList$1,
  menuListItem: menuListItem$1,
  modal: modal$4,
  notification: notification$1,
  popover: popover$2,
  portfolioChart: portfolioChart$1,
  progressBar: progressBar$2,
  radio: radio$1,
  workflowInsight: workflowInsight$1,
  sheet: sheet$2,
  skeletonContent: skeletonContent$1,
  summaryCard,
  superRadio: superRadio$1,
  tag: tag$1,
  timeline: timeline$2
};
const radii = {
  ...baseRadii,
  ...componentRadii
};
var AvatarSize = /* @__PURE__ */ ((AvatarSize2) => {
  AvatarSize2["large"] = "large";
  AvatarSize2["medium"] = "medium";
  AvatarSize2["small"] = "small";
  return AvatarSize2;
})(AvatarSize || {});
const avatar = {
  [
    "large"
    /* large */
  ]: "64px",
  [
    "medium"
    /* medium */
  ]: "48px",
  [
    "small"
    /* small */
  ]: "32px"
};
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2["default"] = "default";
  ButtonSize2["compact"] = "compact";
  return ButtonSize2;
})(ButtonSize || {});
const button = {
  [
    "default"
    /* default */
  ]: "48px",
  [
    "compact"
    /* compact */
  ]: "36px"
};
const checkbox = {
  [
    "default"
    /* default */
  ]: {
    height: "20px"
  }
};
const collapsibleContent = {
  minWidth: "100%"
};
var ContainerVariants = /* @__PURE__ */ ((ContainerVariants2) => {
  ContainerVariants2["xSmall"] = "xSmall";
  ContainerVariants2["small"] = "small";
  ContainerVariants2["medium"] = "medium";
  ContainerVariants2["large"] = "large";
  ContainerVariants2["fluid"] = "fluid";
  return ContainerVariants2;
})(ContainerVariants || {});
const base$9 = {
  marginX: "auto",
  paddingX: buildResponsiveValues({
    smDown: base$a[1],
    mdUp: base$a[2]
  }),
  width: "100%"
};
const variants$7 = {
  [
    "xSmall"
    /* xSmall */
  ]: {
    ...base$9,
    maxWidth: `container.${"xSmall"}.maxWidth`
  },
  [
    "small"
    /* small */
  ]: {
    ...base$9,
    maxWidth: `container.${"small"}.maxWidth`
  },
  [
    "medium"
    /* medium */
  ]: {
    ...base$9,
    maxWidth: `container.${"medium"}.maxWidth`
  },
  [
    "large"
    /* large */
  ]: {
    ...base$9,
    maxWidth: `container.${"large"}.maxWidth`
  },
  [
    "fluid"
    /* fluid */
  ]: {
    ...base$9,
    maxWidth: `container.${"fluid"}.maxWidth`
  }
};
const sizes$2 = {
  [ContainerVariants.xSmall]: {
    maxWidth: `${screenSizes$1[`${ContainerVariants.xSmall}Max`]}px`
  },
  [ContainerVariants.small]: {
    maxWidth: `${screenSizes$1[`${ContainerVariants.small}Max`]}px`
  },
  [ContainerVariants.medium]: {
    maxWidth: `${screenSizes$1[`${ContainerVariants.medium}Max`]}px`
  },
  [ContainerVariants.large]: {
    maxWidth: `${screenSizes$1[`${ContainerVariants.large}Max`]}px`
  },
  [ContainerVariants.fluid]: {
    maxWidth: "100%"
  }
};
const dividerThickness = "1px";
const divider = {
  horizontal: {
    height: dividerThickness,
    width: "100%"
  },
  vertical: {
    width: dividerThickness
  }
};
const salesFunnel$2 = {
  innerContainer: {
    maxWidth: buildResponsiveValues({
      smDown: "100%",
      mdUp: "1200px"
    })
  }
};
const headers$2 = {
  salesFunnel: salesFunnel$2
};
const icon$1 = {
  12: "12px",
  16: "16px",
  20: "20px",
  24: "24px",
  40: "40px"
};
var InputHeights = /* @__PURE__ */ ((InputHeights2) => {
  InputHeights2["compact"] = "compact";
  InputHeights2["default"] = "default";
  return InputHeights2;
})(InputHeights || {});
const input = {
  [
    "compact"
    /* compact */
  ]: {
    height: "36px"
  },
  [
    "default"
    /* default */
  ]: {
    height: "48px"
  }
};
var OrderedListSizes = /* @__PURE__ */ ((OrderedListSizes2) => {
  OrderedListSizes2["default"] = "16";
  return OrderedListSizes2;
})(OrderedListSizes || {});
const OrderedListItemDecorationValues = {
  size: "1.4rem",
  padding: "0.5rem"
};
const orderedListVariants = {
  [
    "16"
    /* default */
  ]: {
    listStyle: "none",
    counterRest: "item",
    paddingLeft: 0,
    marginLeft: "orderedList.left"
  }
};
const listItem = {
  circular: OrderedListItemDecorationValues.size
};
var MenuListItemSizes = /* @__PURE__ */ ((MenuListItemSizes2) => {
  MenuListItemSizes2["default"] = "default";
  MenuListItemSizes2["small"] = "small";
  MenuListItemSizes2["large"] = "large";
  MenuListItemSizes2["workflowNavigation"] = "workflowNavigation";
  return MenuListItemSizes2;
})(MenuListItemSizes || {});
const menuListItem = {
  [
    "default"
    /* default */
  ]: {
    height: "48px"
  },
  [
    "small"
    /* small */
  ]: {
    height: "36px"
  },
  [
    "large"
    /* large */
  ]: {
    height: "62px"
  },
  [
    "workflowNavigation"
    /* workflowNavigation */
  ]: {
    height: "120px"
  }
};
const menuList = {
  maxHeight: "404px"
};
const modal$3 = {
  small: "464px",
  large: "800px",
  medium: "600px",
  fluid: "100vw",
  card: {
    maxHeight: "100%"
  },
  cardFlex: {
    width: "100vw"
  },
  focusLock: {
    height: "100%"
  }
};
const navbarDropdownOffsetValue = 12;
const navbarDropdownFooterPaddingX = base$a[1.5];
const navbarBrandMarginX = base$a[1];
const navbarSpacing = {
  brand: {
    marginX: navbarBrandMarginX
  },
  drawer: {
    px: base$a[0.5],
    pt: base$a[1]
  },
  dropdown: {
    offset: `${navbarDropdownOffsetValue}px`,
    item: {
      px: base$a[1]
    },
    footer: {
      px: navbarDropdownFooterPaddingX,
      paddingBottom: base$a[0.25],
      marginX: `-${base$a[0.5]}`,
      content: {
        px: base$a[0.75],
        drawer: {
          py: base$a[2]
        },
        py: base$a[1.25]
      }
    },
    tail: {
      right: "25px",
      top: "70px"
    }
  },
  link: {
    paddingX: base$a[1.25],
    borderOffset: linkBorderWidth
  }
};
var NavbarDropdownVariant = /* @__PURE__ */ ((NavbarDropdownVariant2) => {
  NavbarDropdownVariant2["default"] = "default";
  NavbarDropdownVariant2["workflow"] = "workflow";
  return NavbarDropdownVariant2;
})(NavbarDropdownVariant || {});
const base$8 = {};
const navbarDropdownVariants = {
  [
    "default"
    /* default */
  ]: {
    menuList: {
      ...base$8
    }
  },
  [
    "workflow"
    /* workflow */
  ]: {
    ...base$8
  }
};
const defaultNavbarHeight = 62;
const navbar = {
  linkBorder: {
    height: linkBorderWidth
  },
  dropdown: {
    [NavbarDropdownVariant.default]: {
      width: "220px"
    },
    [NavbarDropdownVariant.workflow]: {
      width: "355px"
    },
    divider: {
      width: `calc(100% - ${navbarDropdownFooterPaddingX})`
    }
  }
};
const notification = {
  dot: "6px"
};
const overlayContent = {
  focusLock: {
    height: "100%",
    width: "100vw"
  },
  contentContainer: {
    maxHeight: "100vh",
    height: "100%",
    minHeight: "100%"
  }
};
const pagination = {
  number: {
    mobile: {
      minWidth: base$a[2.75],
      height: base$a[2.75]
    },
    minWidth: base$a[2],
    height: base$a[2],
    activeBorderMinWidth: "15px"
  },
  chevron: {
    mobile: {
      width: base$a[2.75],
      height: base$a[2.75]
    },
    width: base$a[2],
    height: base$a[2]
  },
  ellipsis: {
    mobile: {
      width: base$a[2.75],
      height: base$a[2.75]
    },
    width: base$a[2],
    height: base$a[2]
  }
};
const minWidth = (borderRadiusPXValue) => {
  const borderRadiusNumberValue = parseInt(
    String(borderRadiusPXValue).split("px")[0],
    10
  );
  if (Number.isNaN(borderRadiusNumberValue)) {
    return "auto";
  }
  return `${2 * borderRadiusNumberValue + 14}px`;
};
const popover$1 = {
  default: {
    maxWidth: "300px",
    minWidth: minWidth(popover$2.default)
  },
  tooltip: {
    maxWidth: "300px",
    minWidth: minWidth(popover$2.tooltip)
  }
};
const progressBar$1 = {
  height: "0.25rem"
};
const radio = {
  height: "1.25rem",
  width: "1.25rem",
  focusRing: {
    height: "1.525rem",
    width: "1.525rem"
  }
};
const sheet$1 = {
  height: {
    auto: "unset",
    half: "50vh"
  },
  maxHeight: "90vh"
};
const skeletonContent = {
  height: "22px",
  width: "100%"
};
var SpinnerSizes = /* @__PURE__ */ ((SpinnerSizes2) => {
  SpinnerSizes2["default"] = "default";
  return SpinnerSizes2;
})(SpinnerSizes || {});
const spinner$1 = {
  [
    "default"
    /* default */
  ]: "1rem"
  // 24px
};
const step$1 = {
  rail: {
    width: "2px"
  }
};
const superRadio = {
  radio: {
    wrapper: { width: base$a[1.5] }
  }
};
const tag = {
  default: "1.375em"
};
const workflow$1 = {
  content: {
    rowGap: base$a[1.5]
  },
  main: {
    marginX: {
      mdDown: base$a[1],
      lgUp: base$a[2]
    },
    paddingTop: base$a[2.5]
  }
};
const asideWidth = "16rem";
const contentMaxWidth = `calc(
  ${sizes$2[ContainerVariants.large].maxWidth}
    - ${asideWidth}
    - 2 * ${workflow$1.main.marginX.lgUp}
)`;
const sizes$1 = {
  aside: {
    width: asideWidth
  },
  footer: {
    maxWidth: {
      lgUp: contentMaxWidth,
      mdDown: "unset"
    }
  },
  main: {
    maxWidth: {
      lgUp: contentMaxWidth,
      mdDown: "unset"
    }
  }
};
const templates$2 = {
  workflow: sizes$1
};
const textarea = {
  default: {
    minHeight: "186px"
  }
};
const timeline$1 = {
  line: "32px"
};
const toast$1 = {
  minHeight: "48px"
};
const workflowInsight = {
  width: "220px"
};
const PercentageStackedBarChartBarHeight = 8;
const percentageStackedBarChart$1 = {
  tooltip: {
    width: "224px",
    item: {
      height: "12px",
      width: "12px"
    }
  },
  percentageBar: {
    height: `${PercentageStackedBarChartBarHeight}px`
  }
};
const sizes = {
  avatar,
  button,
  checkbox,
  collapsibleContent,
  container: sizes$2,
  contributionChart: contributionChart$2,
  divider,
  headers: headers$2,
  icon: icon$1,
  input,
  listItem,
  menuListItem,
  modal: modal$3,
  navbar,
  notification,
  overlayContent,
  pagination,
  percentageStackedBarChart: percentageStackedBarChart$1,
  popover: popover$1,
  progressBar: progressBar$1,
  radio,
  sheet: sheet$1,
  skeletonContent,
  spinner: spinner$1,
  step: step$1,
  superRadio,
  tag,
  templates: templates$2,
  textarea,
  timeline: timeline$1,
  toast: toast$1,
  menuList,
  workflowInsight
};
const buttonSpacing = {
  paddingY: {
    default: "13px",
    compact: "7px"
  },
  paddingX: {
    default: base$a[1],
    compact: base$a[0.75]
  }
};
const card$1 = {
  header: {
    padding: base$a[1.5]
  },
  content: {
    padding: base$a[1.5],
    paddingTop: base$a[0.5],
    paddingBottom: base$a[2]
  }
};
const checkboxSpacing = {
  container: {
    marginRight: "12px"
  },
  marginRight: "12px"
};
const clickablesSpacing = {
  withIcon: {
    spacing: base$a[0.625]
  }
};
const contributionChart = {
  tooltip: {
    container: {
      p: base$a[0.5]
    },
    title: {
      mb: base$a[1]
    }
  }
};
const drawer$2 = {
  closeButton: {
    padding: base$a[1],
    top: base$a[1],
    right: 0
  },
  header: {
    pt: base$a[2],
    pb: base$a[1.5],
    px: {
      mobile: base$a[1],
      desktop: base$a[2]
    },
    icon: {
      gap: base$a[1.5]
    }
  },
  body: {
    pb: base$a[2],
    px: {
      mobile: base$a[1],
      desktop: base$a[2]
    }
  }
};
var GridVariants = /* @__PURE__ */ ((GridVariants2) => {
  GridVariants2["standard"] = "standard";
  GridVariants2["unstyled"] = "unstyled";
  return GridVariants2;
})(GridVariants || {});
var GridTemplateColumns = /* @__PURE__ */ ((GridTemplateColumns2) => {
  GridTemplateColumns2["standard"] = "repeat(12, minmax(0, 4.5rem))";
  return GridTemplateColumns2;
})(GridTemplateColumns || {});
const gridVariants = {
  [
    "standard"
    /* standard */
  ]: {
    columnGap: buildResponsiveValues({
      lgUp: `grid.${"standard"}.columnGap.lgUp`,
      mdDown: `grid.${"standard"}.columnGap.mdDown`
    }),
    gridTemplateColumns: "repeat(12, minmax(0, 4.5rem))",
    marginX: buildResponsiveValues({
      lgUp: "templates.workflow.main.marginX.lgUp",
      mdDown: "templates.workflow.main.marginX.mdDown"
    })
  },
  [
    "unstyled"
    /* unstyled */
  ]: {}
};
const grid = {
  [GridVariants.standard]: {
    columnGap: {
      lgUp: base$a[2],
      mdDown: base$a[1]
    }
  }
};
const salesFunnel$1 = {
  innerContainerGap: base$a[0.5],
  innerContainer: {
    paddingX: buildResponsiveValues({
      xs: 1,
      sm: 2,
      md: 2.5,
      lg: 2.5,
      xl: 0
    })
  },
  outerContainer: {
    padding: buildResponsiveValues({
      xs: "1.25rem 0",
      smUp: "1.75rem 0"
    })
  }
};
const headers$1 = {
  salesFunnel: salesFunnel$1
};
const inputSpacing = {
  marginY: base$a[0.375],
  // Definitions for specific input heights: default vs compact
  default: {
    paddingX: base$a[1],
    paddingY: "13px"
  },
  compact: {
    paddingX: base$a[1],
    paddingY: "7px"
  },
  // Definitions for specific sub-elements of Input
  icon: {
    paddingX: base$a[1]
  }
};
const listItemSpacing = {
  bottom: "1rem",
  bubble: {
    right: "0.5rem"
  }
};
const menuListItemSpacing = {
  default: {
    paddingX: base$a[0.75],
    paddingY: "0.8125rem"
  },
  small: {
    paddingX: base$a[0.5],
    paddingY: "0.375rem"
  },
  large: {
    paddingX: base$a[0.75]
  }
};
const menuListSpacing = {
  submenu: {
    left: "100%",
    top: "-0.5rem"
  }
};
const modal$2 = {
  body: {
    px: {
      mobile: base$a[1],
      desktop: base$a[1.5]
    },
    marginBottom: base$a[2],
    title: {
      paddingY: "1rem"
    }
  },
  childrenContainer: {
    marginBottom: base$a[1.5]
  },
  focusLock: {
    padding: base$a[1]
  },
  header: {
    padding: {
      mobile: `${base$a[1.5]} ${base$a[1]}`,
      desktop: `${base$a[1.5]} ${base$a[1.5]}`
    }
  },
  footer: {
    padding: {
      mobile: `${base$a[1.5]} ${base$a[1]} 0`,
      desktop: `${base$a[1.5]} ${base$a[1.5]} 0`
    },
    gap: {
      mobile: base$a[1],
      desktop: base$a[0.625]
    }
  }
};
const notificationSpacing = {
  paddingX: "10px",
  paddingY: "2px"
};
const orderedListSpacing = {
  left: `calc(${OrderedListItemDecorationValues.size} + ${OrderedListItemDecorationValues.padding})`
};
const paginationSpacing = {
  number: {
    marginBottom: {
      offset: `-${paginationBorderWidth}px`
    },
    paddingX: "6px"
  }
};
const LEGACY_PADDING = 24;
const portfolioChart = {
  chartDisplay: {
    default: {
      pb: "1rem"
    },
    legacy: {
      pb: "0.9rem"
    }
  },
  legacyPadding: `${LEGACY_PADDING}px`,
  select: {
    margin: base$a[0],
    top: base$a[0]
  }
};
const radioSpacing = {
  default: {
    gap: base$a[1],
    marginTop: base$a[1],
    marginBottomWithError: base$a[1]
  },
  superRadio: {
    marginBottom: base$a[1.5]
  },
  description: {
    marginTop: base$a[0.5],
    marginBottom: base$a[1.25]
  }
};
const sheet = {
  wrapper: {
    paddingTop: base$a[2],
    paddingBottom: base$a[1],
    paddingX: base$a[1]
  }
};
const stepSpacing = {
  paddingBottom: base$a[2],
  marginTop: "2px",
  button: base$a[1],
  lock: {
    marginBottom: "2px"
  },
  rail: {
    left: "7px",
    top: "16px"
  }
};
const subStepSpacing = {
  marginLeft: base$a[2],
  marginTop: base$a[0.5],
  paddingLeft: base$a[0.5]
};
const mobileSpacing = {
  paddingBottom: base$a[0]
};
const stepper = {
  step: stepSpacing,
  subStep: subStepSpacing,
  mobile: mobileSpacing
};
const subMenuListItemSpacing = {
  pseudoElement: {
    left: base$a[1]
  }
};
const superRadioSpacing = {
  compact: {
    paddingBottom: base$a[2.25],
    paddingTop: base$a[2],
    paddingX: base$a[1],
    marginRight: base$a[1],
    radio: {
      marginBottom: base$a[1]
    },
    tag: {
      top: "-1rem"
    },
    label: {
      marginBottom: base$a[0.5]
    },
    eyebrow: {
      marginBottom: base$a[0.25]
    }
  },
  default: {
    contentsInnerWrapperWithIcon: {
      gap: base$a[1]
    },
    paddingY: base$a[1.25],
    paddingX: base$a[1.5],
    marginBottom: base$a[1],
    gap: base$a[1.5],
    tag: {
      marginBottom: base$a[0.75]
    },
    label: {
      marginBottom: base$a[0.25]
    },
    eyebrow: {
      marginBottom: base$a[0.5]
    },
    description: {
      marginTop: base$a[0.25]
    },
    radio: {
      marginTop: "0.125rem"
    }
  },
  mobile: {
    gap: base$a[1]
  }
};
const switcherModalSpacing = {
  outlinePadding: base$a[0.5]
};
const tableSpacing = {
  row: {
    header: {
      padding: base$a[1.25]
    },
    data: {
      padding: base$a[1.25]
    }
  },
  card: {
    row: {
      data: {
        padding: base$a[0.75]
      }
    }
  },
  compact: {
    row: {
      data: {
        padding: base$a[0.75]
      }
    }
  }
};
const tagSpacing = {
  default: "0 0.5em"
};
const templates$1 = {
  // Base template values
  main: {
    columnGap: {
      mdDown: base$a[1],
      lgUp: base$a[2]
    },
    rowGap: base$a[1.5]
  },
  // Additional templates
  workflow: workflow$1
};
const timeline = {
  lockedText: {
    margin: "auto",
    paddingLeft: base$a[0.25]
  },
  icon: {
    padding: base$a[0.5]
  }
};
const toastSpacing = {
  marginY: "5px",
  paddingX: base$a[1],
  paddingY: "0.625rem",
  container: {
    default: {
      paddingRight: base$a[1.5],
      paddingTop: base$a[1.5]
    },
    small: {
      left: base$a[0.5],
      right: base$a[0.5],
      bottom: base$a[0.5]
    }
  },
  icon: {
    marginRight: base$a[0.5]
  },
  action: {
    marginLeft: base$a[1],
    marginRight: "-0.5rem"
  }
};
const tooltipSpacing = {
  padding: `${base$a[0.625]} ${base$a[0.75]}`
};
const transactionContainerPadding = base$a[1];
const transactionsHistorySpacing = {
  breakdownControl: {
    paddingRight: "0.125rem"
  },
  breakdownSubItem: {
    paddingX: base$a[1],
    paddingY: base$a[0.5],
    title: {
      marginBottom: 0
    }
  },
  transaction: {
    container: {
      paddingY: transactionContainerPadding
    },
    content: {
      paddingRight: base$a[1.5]
    },
    afterElement: {
      marginLeft: "auto",
      paddingRight: base$a[1.5]
    },
    expandedContent: {
      marginTop: base$a[1],
      marginBottom: `-${transactionContainerPadding}`
    },
    list: {
      margin: 0,
      padding: 0
    },
    subtitle: {
      paddingTop: base$a[0.25]
    }
  }
};
const typography = {
  caption: {
    "12": base$a[0.75]
  },
  paragraph: {
    "24": base$a[1.25],
    "18": base$a[1],
    "16": base$a[1],
    "14": base$a[0.75]
  }
};
const summaryCardSpacing = {
  default: {
    paddingY: base$a[1.25],
    paddingX: base$a[1.5],
    marginBottom: base$a[1],
    wrapperGap: base$a[1.5],
    label: {
      marginTop: base$a[0.25]
    },
    eyebrow: {
      paddingBottom: base$a[0.25]
    },
    description: {
      marginTop: base$a[0.25]
    },
    actionButton: {
      marginTop: "0.125rem"
    }
  }
};
const PercentageStackedBarChartBarGap = base$a[1];
const percentageStackedBarChart = {
  tooltip: {
    container: {
      p: base$a[0.5]
    }
  },
  legend: {
    list: {
      padding: `${PercentageStackedBarChartBarGap} 0 0 0`,
      gap: PercentageStackedBarChartBarGap
    }
  }
};
const space = {
  ...base$a,
  button: buttonSpacing,
  card: card$1,
  checkbox: checkboxSpacing,
  clickables: clickablesSpacing,
  contributionChart,
  drawer: drawer$2,
  grid,
  headers: headers$1,
  input: inputSpacing,
  listItem: listItemSpacing,
  menuListItem: menuListItemSpacing,
  menuList: menuListSpacing,
  modal: modal$2,
  navbar: navbarSpacing,
  notification: notificationSpacing,
  orderedList: orderedListSpacing,
  pagination: paginationSpacing,
  percentageStackedBarChart,
  popover: popoverSpacing,
  portfolioChart,
  radio: radioSpacing,
  sheet,
  stepper,
  subMenuListItem: subMenuListItemSpacing,
  summaryCard: summaryCardSpacing,
  superRadio: superRadioSpacing,
  switcherModal: switcherModalSpacing,
  table: tableSpacing,
  tag: tagSpacing,
  templates: templates$1,
  timeline,
  toast: toastSpacing,
  tooltip: tooltipSpacing,
  transactionsHistory: transactionsHistorySpacing,
  ...typography
};
const progressBar = {
  indicator: `${Durations.Duration200}ms ${timings.easeInOut}`
};
const slider = {
  base: `${Durations.Duration200}ms ${timings.easeInOut}`,
  thumb: {
    base: `${Durations.Duration200}ms ${timings.easeOut}`,
    hover: `${Durations.Duration200}ms ${timings.easeOut}`,
    active: `${Durations.Duration200}ms ${timings.easeOut}`
  }
};
const card = {
  header: `padding ${Durations.Duration350}ms`
};
const drawer$1 = {
  slide: `width ${Durations.Duration400}ms`,
  header: `box-shadow ${Durations.Duration350}ms`
};
const componentTransitions = {
  card,
  drawer: drawer$1,
  progressBar,
  slider
};
const transitions = {
  durations: Durations,
  timings,
  ...componentTransitions
};
const baseAvatarStyles = {
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexShrink: 0
};
const sizeVariants = {
  [AvatarSize.small]: {
    ...baseAvatarStyles,
    width: "avatar.small",
    height: "avatar.small"
  },
  [AvatarSize.medium]: {
    ...baseAvatarStyles,
    width: "avatar.medium",
    height: "avatar.medium"
  },
  [AvatarSize.large]: {
    ...baseAvatarStyles,
    width: "avatar.large",
    height: "avatar.large"
  }
};
const avatarVariants = {
  human: {
    [AvatarSize.small]: {
      ...sizeVariants.small,
      borderRadius: "avatar.human"
    },
    [AvatarSize.medium]: {
      ...sizeVariants.medium,
      borderRadius: "avatar.human"
    },
    [AvatarSize.large]: {
      ...sizeVariants.large,
      borderRadius: "avatar.human"
    }
  },
  entity: {
    [AvatarSize.small]: {
      ...sizeVariants.small,
      borderRadius: "avatar.entity"
    },
    [AvatarSize.medium]: {
      ...sizeVariants.medium,
      borderRadius: "avatar.entity"
    },
    [AvatarSize.large]: {
      ...sizeVariants.large,
      borderRadius: "avatar.entity"
    }
  }
};
var AvatarVariant = /* @__PURE__ */ ((AvatarVariant2) => {
  AvatarVariant2["human"] = "human";
  AvatarVariant2["entity"] = "entity";
  return AvatarVariant2;
})(AvatarVariant || {});
const sizedVariant = (size, variant3) => {
  return {
    variant: `avatar.${variant3}.${size}`,
    iconSize: iconSizeMap[size],
    textVariant: textSizeMap[size],
    textLength: textLengthMap[size]
  };
};
const textSizeMap = {
  [AvatarSize.small]: SpanSizes.Span14,
  [AvatarSize.medium]: SpanSizes.Span16,
  [AvatarSize.large]: SpanSizes.Span18
};
const iconSizeMap = {
  [AvatarSize.small]: IconSizes.Icon16,
  [AvatarSize.medium]: IconSizes.Icon24,
  [AvatarSize.large]: IconSizes.Icon40
};
const textLengthMap = {
  [AvatarSize.small]: 1,
  [AvatarSize.medium]: 2,
  [AvatarSize.large]: 2
};
const responsiveVariant = (mediaQueries2, variant3) => {
  const { smDown, md } = mediaQueries2;
  if (smDown) {
    return sizedVariant(AvatarSize.small, variant3);
  } else if (md) {
    return sizedVariant(AvatarSize.medium, variant3);
  }
  return sizedVariant(AvatarSize.large, variant3);
};
const bannerBaseStyles = {
  p: "0.375rem",
  pl: 1,
  pr: 0.75,
  minHeight: 3,
  width: "100%"
};
const bannerVariants = {
  info: {
    ...bannerBaseStyles,
    backgroundColor: "banner.background.info"
  },
  warning: {
    ...bannerBaseStyles,
    backgroundColor: "banner.background.warning"
  },
  success: {
    ...bannerBaseStyles,
    backgroundColor: "banner.background.success"
  },
  error: {
    ...bannerBaseStyles,
    backgroundColor: "banner.background.error"
  },
  announcement: {
    ...bannerBaseStyles,
    backgroundColor: "banner.background.announcement"
  }
};
var BannerVariant = /* @__PURE__ */ ((BannerVariant2) => {
  BannerVariant2["info"] = "info";
  BannerVariant2["warning"] = "warning";
  BannerVariant2["success"] = "success";
  BannerVariant2["error"] = "error";
  BannerVariant2["announcement"] = "announcement";
  return BannerVariant2;
})(BannerVariant || {});
const breadcrumbsVariant = {
  container: {
    gap: 0.75,
    paddingTop: 2,
    paddingBottom: 2
  },
  crumb: {
    paragraph: {
      marginBottom: 0
    }
  },
  navigationContainer: {
    alignItems: "center",
    flexWrap: "wrap",
    gap: 0.5,
    paddingLeft: 0
  }
};
var ButtonShape = /* @__PURE__ */ ((ButtonShape2) => {
  ButtonShape2["default"] = "default";
  ButtonShape2["circle"] = "circle";
  return ButtonShape2;
})(ButtonShape || {});
const buttonBaseStyles = {
  alignItems: "center",
  cursor: "pointer",
  textAlign: "center",
  fontFamily: "body",
  fontWeight: "demibold",
  height: "button.default",
  paddingY: "button.paddingY.default",
  paddingX: "button.paddingX.default",
  borderRadius: `button.${ButtonShape.default}`,
  [`&[data-button-size='${ButtonSize.compact}']`]: {
    height: `button.${ButtonSize.compact}`,
    paddingY: `button.paddingY.${ButtonSize.compact}`,
    paddingX: `button.paddingX.${ButtonSize.compact}`
  },
  [`&[data-button-shape='${ButtonShape.circle}']`]: {
    borderRadius: `button.${ButtonShape.circle}`
  },
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
  "& span": {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
};
var ButtonVariant = /* @__PURE__ */ ((ButtonVariant2) => {
  ButtonVariant2["back"] = "buttons.back";
  ButtonVariant2["primary"] = "buttons.primary";
  ButtonVariant2["secondary"] = "buttons.secondary";
  ButtonVariant2["tertiary"] = "buttons.tertiary";
  ButtonVariant2["destructive"] = "buttons.destructive";
  ButtonVariant2["unstyled"] = "buttons.unstyled";
  return ButtonVariant2;
})(ButtonVariant || {});
const buttonVariants = {
  unstyled: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    padding: 0,
    "&[aria-disabled='true']": {
      cursor: "not-allowed"
    },
    "&.focus-visible": {
      outline: "solid transparent",
      // not set to "none", so will show up in high contrast mode
      boxShadow: "two-pixel-soft"
      // boxShadow instead of outline since Safari does not respect border radius when using outline
    },
    "&:focus:not(&.focus-visible)": {
      outline: "solid transparent"
    }
  },
  back: {
    ...buttonBaseStyles,
    border: "0px",
    borderColor: "none",
    backgroundColor: "unset",
    color: "button.back.text",
    "&.focus-visible": {
      outline: "solid transparent",
      // not set to "none", so will show up in high contrast mode
      boxShadow: "two-pixel-soft-minimize-inner-border"
      // boxShadow instead of outline since Safari does not respect border radius when using outline. Also, there is a light inner grey border on the edge that displays when just using 'two-pixel-soft' on the backButton. An inset border was used to minimize this grey border.
    },
    "&:focus:not(&.focus-visible)": {
      outline: "solid transparent"
    },
    "&:hover": {
      color: "button.back.text.hover"
    },
    "&[aria-disabled='true']": {
      cursor: "not-allowed",
      pointerEvents: "none"
    },
    "&:active": {
      color: "button.back.text.active"
    },
    p: 0
  },
  primary: {
    ...buttonBaseStyles,
    color: "button.primary.text",
    backgroundColor: "button.primary.background",
    border: "button",
    borderColor: "button.primary.border",
    "&:hover": {
      backgroundColor: "button.primary.background.hover",
      borderColor: "button.primary.border.hover"
    },
    "&:active": {
      backgroundColor: "button.primary.background.active",
      borderColor: "button.primary.border.active"
    },
    "&.focus-visible": {
      outline: "solid transparent",
      // not set to "none", so will show up in high contrast mode
      boxShadow: "two-pixel-soft"
      // boxShadow instead of outline since Safari does not respect border radius when using outline
    },
    "&:focus:not(&.focus-visible)": {
      outline: "solid transparent"
    },
    "&[aria-disabled='true']": {
      borderColor: "button.primary.border.disabled",
      backgroundColor: "button.primary.background.disabled",
      color: "button.primary.text.disabled",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  },
  secondary: {
    ...buttonBaseStyles,
    backgroundColor: "button.secondary.background",
    border: "button",
    borderColor: "button.secondary.border",
    color: "button.secondary.text",
    "&:hover": {
      backgroundColor: "button.secondary.background.hover",
      borderColor: "button.secondary.border.hover"
    },
    "&:active": {
      backgroundColor: "button.secondary.background.active",
      borderColor: "button.secondary.border.active"
    },
    "&.focus-visible": {
      outline: "solid transparent",
      // not set to "none", so will show up in high contrast mode
      boxShadow: "two-pixel-soft"
      // boxShadow instead of outline since Safari does not respect border radius when using outline
    },
    "&:focus:not(&.focus-visible)": {
      outline: "solid transparent"
    },
    "&[aria-disabled='true']": {
      border: "button",
      borderColor: "button.secondary.border.disabled",
      backgroundColor: "button.secondary.background.disabled",
      color: "button.secondary.text.disabled",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  },
  tertiary: {
    ...buttonBaseStyles,
    backgroundColor: "button.tertiary.background",
    color: "button.tertiary.text",
    "&:hover": {
      backgroundColor: "button.tertiary.background.hover"
    },
    "&.focus-visible": {
      backgroundColor: "button.tertiary.background.focused",
      outline: "solid transparent",
      // not set to "none", so will show up in high contrast mode
      boxShadow: "two-pixel-soft"
      // boxShadow instead of outline since Safari does not respect border radius when using outline
    },
    "&:focus:not(&.focus-visible)": {
      outline: "solid transparent"
    },
    "&:active": {
      backgroundColor: "button.tertiary.background.active"
    },
    "&[aria-disabled='true']": {
      color: "button.tertiary.text.disabled",
      backgroundColor: "button.tertiary.background.disabled",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  },
  destructive: {
    ...buttonBaseStyles,
    backgroundColor: "button.destructive.background",
    color: "button.destructive.text",
    "&:hover": {
      backgroundColor: "button.destructive.background.hover"
    },
    "&:active": {
      backgroundColor: "button.destructive.background.active"
    },
    "&.focus-visible": {
      backgroundColor: "button.destructive.background.focused",
      outline: "solid transparent",
      // not set to "none", so will show up in high contrast mode
      boxShadow: "two-pixel-soft"
      // boxShadow instead of outline since Safari does not respect border radius when using outline
    },
    "&:focus:not(&.focus-visible)": {
      outline: "solid transparent"
    },
    "&[aria-disabled='true']": {
      backgroundColor: "button.destructive.background.disabled",
      color: "button.destructive.text.disabled",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  }
};
const loadingStyles = {
  [
    "buttons.primary"
    /* primary */
  ]: {
    "&[aria-disabled='true']": {
      backgroundColor: "button.primary.background.loading",
      border: "button",
      borderColor: "button.primary.border.loading",
      color: "button.primary.text.loading",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  },
  [
    "buttons.secondary"
    /* secondary */
  ]: {
    "&[aria-disabled='true']": {
      backgroundColor: "button.secondary.background.loading",
      color: "button.secondary.text.loading",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  },
  [
    "buttons.tertiary"
    /* tertiary */
  ]: {
    "&[aria-disabled='true']": {
      color: "button.tertiary.text.loading",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  },
  [
    "buttons.destructive"
    /* destructive */
  ]: {
    "&[aria-disabled='true']": {
      backgroundColor: "button.destructive.background.loading",
      color: "button.destructive.text.loading",
      cursor: "not-allowed",
      pointerEvents: "none"
    }
  }
};
const spinnerStyles = {
  [
    "buttons.primary"
    /* primary */
  ]: {
    color: "button.primary.foreground.loading"
  },
  [
    "buttons.secondary"
    /* secondary */
  ]: {
    color: "button.secondary.foreground.loading"
  },
  [
    "buttons.tertiary"
    /* tertiary */
  ]: {
    color: "button.tertiary.foreground.loading"
  },
  [
    "buttons.destructive"
    /* destructive */
  ]: {
    color: "button.destructive.foreground.loading"
  }
};
var CardVariants = /* @__PURE__ */ ((CardVariants2) => {
  CardVariants2["shadow"] = "shadow";
  CardVariants2["border"] = "border";
  return CardVariants2;
})(CardVariants || {});
const sharedStyle = {
  borderRadius: "card.container",
  backgroundColor: "card.background"
};
const cardVariants = {
  [
    "shadow"
    /* shadow */
  ]: {
    ...sharedStyle,
    boxShadow: "elevation.one"
  },
  [
    "border"
    /* border */
  ]: {
    ...sharedStyle,
    border: "default",
    borderColor: "border.subdued"
  }
};
var PortfolioChartTypes = /* @__PURE__ */ ((PortfolioChartTypes2) => {
  PortfolioChartTypes2["LEGACY_DASHBOARD"] = "LEGACY_DASHBOARD";
  PortfolioChartTypes2["LEGACY_FULL_PAGE_WIDTH"] = "LEGACY_FULL_PAGE_WIDTH";
  PortfolioChartTypes2["DEFAULT"] = "DEFAULT";
  return PortfolioChartTypes2;
})(PortfolioChartTypes || {});
var PortfolioAumDataKeys = /* @__PURE__ */ ((PortfolioAumDataKeys2) => {
  PortfolioAumDataKeys2["date"] = "date";
  PortfolioAumDataKeys2["balance"] = "balance";
  return PortfolioAumDataKeys2;
})(PortfolioAumDataKeys || {});
var TimeFrames = /* @__PURE__ */ ((TimeFrames2) => {
  TimeFrames2["OneMonth"] = "1";
  TimeFrames2["ThreeMonths"] = "3";
  TimeFrames2["SixMonths"] = "6";
  TimeFrames2["OneYear"] = "12";
  TimeFrames2["AllTime"] = "-1";
  return TimeFrames2;
})(TimeFrames || {});
var PortfolioChartStates = /* @__PURE__ */ ((PortfolioChartStates2) => {
  PortfolioChartStates2["ANIMATING_ON_LOAD"] = "ANIMATING_ON_LOAD";
  PortfolioChartStates2["DISPLAYING"] = "DISPLAYING";
  PortfolioChartStates2["EMPTY_CHART"] = "EMPTY_CHART";
  PortfolioChartStates2["EMPTY_W_CTA"] = "EMPTY_W_CTA";
  PortfolioChartStates2["LOADING"] = "LOADING";
  PortfolioChartStates2["NEW_DATA_LOADED"] = "NEW_DATA_LOADED";
  PortfolioChartStates2["UNKNOWN"] = "UNKNOWN";
  return PortfolioChartStates2;
})(PortfolioChartStates || {});
var FontSizes = /* @__PURE__ */ ((FontSizes2) => {
  FontSizes2[FontSizes2["Font4"] = 4] = "Font4";
  FontSizes2[FontSizes2["Font5"] = 5] = "Font5";
  FontSizes2[FontSizes2["Font6"] = 6] = "Font6";
  FontSizes2[FontSizes2["Font8"] = 8] = "Font8";
  FontSizes2[FontSizes2["Font9"] = 9] = "Font9";
  FontSizes2[FontSizes2["Font10"] = 10] = "Font10";
  FontSizes2[FontSizes2["Font12"] = 12] = "Font12";
  FontSizes2[FontSizes2["Font14"] = 14] = "Font14";
  FontSizes2[FontSizes2["Font16"] = 16] = "Font16";
  FontSizes2[FontSizes2["Font18"] = 18] = "Font18";
  FontSizes2[FontSizes2["Font20"] = 20] = "Font20";
  FontSizes2[FontSizes2["Font22"] = 22] = "Font22";
  FontSizes2[FontSizes2["Font26"] = 26] = "Font26";
  FontSizes2[FontSizes2["Font30"] = 30] = "Font30";
  FontSizes2[FontSizes2["Font34"] = 34] = "Font34";
  FontSizes2[FontSizes2["Font36"] = 36] = "Font36";
  FontSizes2[FontSizes2["Font38"] = 38] = "Font38";
  FontSizes2[FontSizes2["Font40"] = 40] = "Font40";
  FontSizes2[FontSizes2["Font44"] = 44] = "Font44";
  FontSizes2[FontSizes2["Font48"] = 48] = "Font48";
  return FontSizes2;
})(FontSizes || {});
var AspectRatios = /* @__PURE__ */ ((AspectRatios2) => {
  AspectRatios2["Ratio3x1"] = "Ratio3x1";
  AspectRatios2["Ratio4x1"] = "Ratio4x1";
  AspectRatios2["Ratio6x1"] = "Ratio6x1";
  AspectRatios2["Ratio12x1"] = "Ratio12x1";
  return AspectRatios2;
})(AspectRatios || {});
var ChartMatchMediaQuery = /* @__PURE__ */ ((ChartMatchMediaQuery2) => {
  ChartMatchMediaQuery2["xxs"] = "xxs";
  ChartMatchMediaQuery2["xs"] = "xs";
  ChartMatchMediaQuery2["sm"] = "sm";
  ChartMatchMediaQuery2["md"] = "md";
  ChartMatchMediaQuery2["lg"] = "lg";
  ChartMatchMediaQuery2["xl"] = "xl";
  ChartMatchMediaQuery2["xxl"] = "xxl";
  return ChartMatchMediaQuery2;
})(ChartMatchMediaQuery || {});
var AxisDisplayType = /* @__PURE__ */ ((AxisDisplayType2) => {
  AxisDisplayType2["MonthDay"] = "MonthDay";
  AxisDisplayType2["Month"] = "Month";
  AxisDisplayType2["MonthYear"] = "MonthYear";
  return AxisDisplayType2;
})(AxisDisplayType || {});
const base$7 = {
  ...base$c,
  fontWeight: "normal"
};
var TitleSizes = /* @__PURE__ */ ((TitleSizes2) => {
  TitleSizes2["Title80"] = "80";
  TitleSizes2["Title64"] = "64";
  TitleSizes2["Title48"] = "48";
  TitleSizes2["Title40"] = "40";
  TitleSizes2["Title32"] = "32";
  TitleSizes2["Title24"] = "24";
  TitleSizes2["Title18"] = "18";
  TitleSizes2["Title16"] = "16";
  TitleSizes2["Title14"] = "14";
  return TitleSizes2;
})(TitleSizes || {});
const variants$6 = {
  ...variants$9,
  "title-40": {
    ...base$7,
    fontSize: 40,
    lineHeight: 2.875
    // 46px
  },
  "title-20": {
    ...base$7,
    fontSize: 20,
    lineHeight: 1.875
    // 30px
  },
  "title-18": {
    ...base$7,
    fontSize: 18,
    lineHeight: 1.6875
    // 18px
  }
};
const timeFrameSelectBaseStyles = {
  select: { my: "unset" },
  // remove margin top/bottom set in inputSpacing.hintText.marginTop
  position: "absolute",
  right: "portfolioChart.select.margin",
  top: "portfolioChart.select.top",
  // set the timeframe container to the top of the chart container
  marginTop: `calc(${button.compact} / 2)`
  // this is to vertically center the TimeFrame select text with the "Account Balance". The "Account Balance" text is center adjusted by it's sibling, the Disclaimer button ("button.compact" sizing).
};
const ACCOUNT_INFO_TITLE_SIZE = TitleSizes.Title16;
const ACCOUNT_INFO_TITLE_SIZE_LINE_HEIGHT = variants$6[`title-${TitleSizes.Title16}`].lineHeight;
const accountInfoBaseStyles = {
  position: "relative",
  // The disclaimer button is 36px while the lineheight for a Title16 is 1.375rem (22px). This adjusts the Balance Info vertical position. This "top" is to reset the vertical position so the Balance Info can be vertically aligned with the title for other panels to the right.
  top: `calc((${ACCOUNT_INFO_TITLE_SIZE_LINE_HEIGHT}rem - ${button.compact})/2)`
};
const accountInfoTitleBaseStyles = {
  marginRight: 0.5
};
const legacyBaseTimeFrameSelectStyles = {
  pr: "portfolioChart.legacyPadding"
};
const chartDisplayBaseStyles = {
  position: "relative",
  pb: "portfolioChart.chartDisplay.default.pb"
};
const portfolioChartVariants = {
  [PortfolioChartTypes.LEGACY_DASHBOARD]: {
    chartDisplay: {
      ...chartDisplayBaseStyles,
      pb: "portfolioChart.chartDisplay.legacy.pb"
    },
    accountInfo: {
      ...accountInfoBaseStyles,
      pt: "portfolioChart.legacyPadding",
      pl: "portfolioChart.legacyPadding",
      pr: "portfolioChart.legacyPadding"
    },
    accountInfoTitle: {
      ...accountInfoTitleBaseStyles
    },
    timeFrameSelect: {
      ...timeFrameSelectBaseStyles,
      ...legacyBaseTimeFrameSelectStyles
    }
  },
  [PortfolioChartTypes.LEGACY_FULL_PAGE_WIDTH]: {
    chartDisplay: {
      ...chartDisplayBaseStyles,
      pb: "portfolioChart.chartDisplay.legacy.pb"
    },
    accountInfo: {
      ...accountInfoBaseStyles,
      pt: "portfolioChart.legacyPadding",
      pl: "portfolioChart.legacyPadding",
      pr: "portfolioChart.legacyPadding"
    },
    accountInfoTitle: {
      ...accountInfoTitleBaseStyles
    },
    timeFrameSelect: {
      ...timeFrameSelectBaseStyles,
      ...legacyBaseTimeFrameSelectStyles
    }
  },
  [PortfolioChartTypes.DEFAULT]: {
    chartDisplay: chartDisplayBaseStyles,
    accountInfo: {
      ...accountInfoBaseStyles,
      pt: "card.content.padding",
      pl: "card.content.padding",
      pr: "card.content.padding"
    },
    accountInfoTitle: {
      ...accountInfoTitleBaseStyles
    },
    timeFrameSelect: {
      ...timeFrameSelectBaseStyles,
      pr: "card.content.padding"
    }
  }
};
const charts = {
  portfolioCharts: portfolioChartVariants
};
const checkboxVariants = {
  default: {
    cursor: "pointer",
    alignItems: "center",
    display: "inline-flex",
    width: "auto",
    height: "44px",
    // tap target
    marginRight: "checkbox.container.marginRight",
    '&[data-checkbox-state="disabled"]': {
      cursor: "not-allowed"
    },
    div: {
      marginRight: "checkbox.marginRight"
    },
    input: {
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      overflow: "hidden",
      position: "absolute",
      whiteSpace: "nowrap",
      width: "1px"
    },
    "input ~ div.guideline-ui--checkbox--indeterminate": {
      rect: {
        stroke: "checkbox.default.indeterminate.rectStroke",
        fill: "checkbox.default.indeterminate.fill"
      },
      path: {
        stroke: "checkbox.default.indeterminate.stroke"
      }
    },
    "input:checked ~ div ": {
      rect: {
        stroke: "checkbox.default.checked.rectStroke",
        fill: "checkbox.default.checked.fill"
      },
      path: {
        stroke: "checkbox.default.checked.stroke"
      }
    },
    "input:not(:checked)": {
      "~ div.guideline-ui--checkbox--unchecked rect": {
        stroke: "checkbox.default.unchecked.stroke"
      }
    },
    "input.focus-visible": {
      "~ div": {
        boxShadow: "two-pixel-soft",
        height: "checkbox.default",
        borderRadius: "checkbox.default",
        outline: "solid transparent"
      },
      "&:not(:checked) ~ div:not(.guideline-ui--checkbox--indeterminate) rect": {
        stroke: "checkbox.focused.unchecked.stroke"
      },
      "&:checked ~ div rect": {
        fill: "checkbox.focused.checked.fill"
      }
    },
    "&:hover": {
      "div:not(.guideline-ui--checkbox--disabled)": {
        cursor: "pointer",
        boxShadow: "checkbox.hover",
        height: "checkbox.default",
        borderRadius: "checkbox.action",
        "&.guideline-ui--checkbox--indeterminate rect": {
          fill: "checkbox.hover.indeterminate.fill"
        }
      },
      "input:not(:checked) ~ div:not(.guideline-ui--checkbox--indeterminate) rect": {
        stroke: "checkbox.hover.unchecked.stroke"
      },
      "input:checked ~ div rect": {
        fill: "checkbox.hover.checked.fill"
      }
    },
    "&:active": {
      "div:not(.guideline-ui--checkbox--disabled)": {
        boxShadow: "checkbox.active",
        height: "checkbox.default",
        borderRadius: "checkbox.action"
      },
      "input:not(:checked) ~ div:not(.guideline-ui--checkbox--indeterminate) rect": {
        stroke: "checkbox.active.unchecked.stroke"
      },
      "input:checked ~ div rect": {
        fill: "checkbox.active.checked.fill"
      }
    },
    "input:disabled": {
      "~ div": {
        cursor: "not-allowed",
        boxShadow: "none",
        "&.guideline-ui--checkbox--indeterminate rect": {
          fill: "checkbox.disabled.indeterminate.fill",
          stroke: "checkbox.disabled.indeterminate.stroke",
          "~ path": {
            fill: "checkbox.disabled.indeterminate.path.fill"
          }
        }
      },
      "&:checked ~ div rect": {
        fill: "checkbox.disabled.checked.fill",
        stroke: "checkbox.disabled.checked.stroke",
        "~ path": {
          fill: "checkbox.disabled.checked.path.fill"
        }
      },
      "&:not(:checked) ~ div:not(.guideline-ui--checkbox--indeterminate) rect": {
        fill: "checkbox.disabled.unchecked.fill",
        stroke: "checkbox.disabled.unchecked.stroke"
      }
    }
  }
};
var DividerVariant = /* @__PURE__ */ ((DividerVariant2) => {
  DividerVariant2["primary"] = "primary";
  DividerVariant2["secondary"] = "secondary";
  return DividerVariant2;
})(DividerVariant || {});
const variants$5 = {
  [
    "primary"
    /* primary */
  ]: {
    backgroundColor: "divider.primary"
  },
  [
    "secondary"
    /* secondary */
  ]: {
    backgroundColor: "divider.secondary"
  }
};
const NAVBAR_DRAWER_WIDTH = "375px";
const DRAWER_WIDTH = {
  md: "768px",
  lg: "840px",
  xl: "1080px"
};
const base$6 = {
  position: "fixed",
  right: 0,
  bottom: 0,
  backgroundColor: "navbar.background",
  overflowX: "hidden",
  zIndex: "drawer",
  overflowY: "hidden",
  whiteSpace: "nowrap"
};
const drawerVariants = {
  default: {
    ...base$6
  },
  navbar: {
    ...base$6,
    marginTop: `${defaultNavbarHeight}px`,
    paddingX: "navbar.drawer.px",
    paddingTop: "navbar.drawer.pt",
    overflowY: "scroll"
  }
};
var DrawerVariant = /* @__PURE__ */ ((DrawerVariant2) => {
  DrawerVariant2["default"] = "default";
  DrawerVariant2["navbar"] = "navbar";
  return DrawerVariant2;
})(DrawerVariant || {});
const searchBarVariants = {
  flexDirection: "column"
};
const styles$x = {
  dropDownMenu: {
    zIndex: "dropdown",
    width: "100%"
  }
};
var DropdownControlVariants = /* @__PURE__ */ ((DropdownControlVariants2) => {
  DropdownControlVariants2["default"] = "default";
  DropdownControlVariants2["navigation"] = "navigation";
  return DropdownControlVariants2;
})(DropdownControlVariants || {});
const controlVariants = {
  [
    "default"
    /* default */
  ]: {},
  [
    "navigation"
    /* navigation */
  ]: {
    backgroundColor: "navbar.link.background",
    px: 1,
    height: "100%",
    ":hover": {
      backgroundColor: "navbar.link.background.hover"
    },
    "+ #tail": {
      border: "tail",
      display: "inline-block",
      position: "absolute",
      right: "navbar.dropdown.tail.right",
      top: "navbar.dropdown.tail.top",
      borderBottomWidth: "tail.borderBottom",
      borderBottomColor: "navbar.background",
      borderTop: "none",
      zIndex: "sticky"
    }
  }
};
const dropdownVariants = {
  control: controlVariants
};
var ExpansionPanelVariant = /* @__PURE__ */ ((ExpansionPanelVariant2) => {
  ExpansionPanelVariant2["default"] = "default";
  return ExpansionPanelVariant2;
})(ExpansionPanelVariant || {});
const expansionPanelVariants = {
  [
    "default"
    /* default */
  ]: {
    titleContainer: {
      flexDirection: "row",
      alignItems: "center",
      gap: 0.5,
      padding: 0.75,
      display: "inline-block",
      position: "relative",
      margin: -0.75,
      zIndex: "sticky"
    },
    contentContainer: {
      flexDirection: "column",
      flexGrow: 1,
      marginTop: 0.25,
      marginBottom: 0.25,
      paddingTop: 0.5
    }
  }
};
const footerVariants = {
  default: {
    p: 2,
    backgroundColor: "footer.background"
  }
};
var FormInputVariants = /* @__PURE__ */ ((FormInputVariants2) => {
  FormInputVariants2["default"] = "default";
  FormInputVariants2["error"] = "error";
  FormInputVariants2["success"] = "success";
  return FormInputVariants2;
})(FormInputVariants || {});
const baseWrapperStyles$1 = {
  border: "input",
  borderRadius: "form.input",
  backgroundColor: "forms.background",
  alignItems: "center",
  marginTop: "input.marginY",
  marginBottom: "input.marginY",
  "input::placeholder": {
    color: "forms.placeholder"
  }
};
const baseInputStyles$1 = {
  fontFamily: "body",
  fontWeight: "normal"
};
const formVariants$1 = {
  [
    "default"
    /* default */
  ]: {
    wrapperStyles: {
      ...baseWrapperStyles$1
    },
    inputStyles: {
      ...baseInputStyles$1,
      borderColor: "forms.default.border"
    }
  },
  [
    "error"
    /* error */
  ]: {
    wrapperStyles: {
      ...baseWrapperStyles$1
    },
    inputStyles: {
      ...baseInputStyles$1,
      borderColor: "forms.error.border"
    }
  },
  [
    "success"
    /* success */
  ]: {
    wrapperStyles: {
      ...baseWrapperStyles$1
    },
    inputStyles: {
      ...baseInputStyles$1,
      borderColor: "forms.success.border"
    }
  }
};
const asExactTheme = (theme2) => theme2;
const salesFunnel = {
  outerContainer: {
    boxShadow: "elevation.three",
    padding: (theme2) => asExactTheme(theme2).space.headers.salesFunnel.outerContainer.padding
  },
  innerContainer: {
    margin: "auto",
    maxWidth: (theme2) => asExactTheme(theme2).sizes.headers.salesFunnel.innerContainer.maxWidth,
    paddingX: (theme2) => asExactTheme(theme2).space.headers.salesFunnel.innerContainer.paddingX
  },
  logo: {
    flexShrink: 0
  }
};
const headers = {
  salesFunnel
};
var HeroBannerVariant = /* @__PURE__ */ ((HeroBannerVariant2) => {
  HeroBannerVariant2["default"] = "default";
  return HeroBannerVariant2;
})(HeroBannerVariant || {});
const container = {
  border: "default",
  borderRadius: baseRadii == null ? void 0 : baseRadii[8],
  flexDirection: buildResponsiveValues({
    xs: "column-reverse",
    smUp: "row"
  })
};
const imageContainer = {
  backgroundColor: "surface.default",
  maxWidth: buildResponsiveValues({
    xs: "none",
    sm: "250px",
    mdUp: "350px"
  }),
  height: buildResponsiveValues({
    xs: "80px",
    smUp: "auto"
  }),
  position: "relative",
  width: buildResponsiveValues({
    xs: "100%",
    smUp: "40%"
  }),
  minWidth: buildResponsiveValues({
    xs: "100%",
    smUp: "40%"
  }),
  backgroundSize: "cover",
  backgroundPosition: "50% 50%"
};
const contentContainer = {
  padding: buildResponsiveValues({
    xs: "1rem 1.5rem 1.5rem",
    smUp: "1.5rem"
  })
};
const heroBannerVariants = {
  default: {
    container: {
      ...container,
      backgroundColor: "surface.__default",
      borderColor: "border.subdued",
      overflow: "hidden"
    },
    imageContainer,
    contentContainer
  }
};
const inlineCalloutContainerStyles = {
  borderRadius: "inlineCallout.container",
  padding: 1,
  flexDirection: "column"
};
const styles$w = {
  header: {
    icon: {
      flexShrink: 0
    },
    title: {
      margin: 0.5
    },
    dismiss: {
      flexShrink: 0,
      height: "fit-content",
      margin: "-10px",
      padding: "10px",
      marginLeft: "auto"
    }
  },
  body: {
    container: {
      marginTop: 0.5,
      marginLeft: 2
    }
  },
  footer: {
    button: {
      marginLeft: "auto",
      marginTop: 1.5
    }
  }
};
const inlineCalloutVariants = {
  default: {
    ...inlineCalloutContainerStyles,
    backgroundColor: "inlineCallout.background"
  },
  info: {
    ...inlineCalloutContainerStyles,
    backgroundColor: "inlineCallout.background.info"
  },
  warning: {
    ...inlineCalloutContainerStyles,
    backgroundColor: "inlineCallout.background.warning"
  },
  success: {
    ...inlineCalloutContainerStyles,
    backgroundColor: "inlineCallout.background.success"
  },
  error: {
    ...inlineCalloutContainerStyles,
    backgroundColor: "inlineCallout.background.error"
  }
};
var ListItemVariants = /* @__PURE__ */ ((ListItemVariants2) => {
  ListItemVariants2["ordered"] = "ordered";
  ListItemVariants2["unstyled"] = "unstyled";
  return ListItemVariants2;
})(ListItemVariants || {});
const listItemVariants = {
  [
    "ordered"
    /* ordered */
  ]: {
    counterIncrement: "item",
    marginBottom: "listItem.bottom",
    position: "relative",
    "&:before": {
      backgroundColor: "listItem.background.bubble",
      borderRadius: "listItem.ordered",
      color: "text.secondary",
      content: "counter(item)",
      display: "inline-block",
      fontSize: 12,
      height: "listItem.circular",
      left: `calc(-${OrderedListItemDecorationValues.size} - ${OrderedListItemDecorationValues.padding})`,
      lineHeight: "1.5rem",
      position: "absolute",
      textAlign: "center",
      width: "listItem.circular"
    }
  },
  [
    "unstyled"
    /* unstyled */
  ]: {
    listStyleType: "none"
  }
};
var MenuListVariants = /* @__PURE__ */ ((MenuListVariants2) => {
  MenuListVariants2["default"] = "default";
  MenuListVariants2["submenu"] = "submenu";
  MenuListVariants2["mobile"] = "mobile";
  MenuListVariants2["navigation"] = "navigation";
  MenuListVariants2["workflow"] = "workflow";
  return MenuListVariants2;
})(MenuListVariants || {});
const baseMenuListStyles = {
  backgroundColor: "menuListItem.background",
  borderRadius: "menuList.container",
  boxShadow: "elevation.four",
  maxHeight: "menuList.maxHeight",
  position: "absolute",
  overflowY: "scroll",
  overflowX: "hidden",
  marginTop: "0",
  padding: 0.5,
  flexDirection: "column",
  "> li": {
    paddingY: 0.25
  }
};
const menuListVariants = {
  [
    "default"
    /* default */
  ]: {
    ...baseMenuListStyles
  },
  [
    "mobile"
    /* mobile */
  ]: {
    ...baseMenuListStyles,
    maxHeight: "unset",
    borderRadius: "0",
    position: "initial",
    overflowY: "initial",
    width: "max-content"
  },
  [
    "submenu"
    /* submenu */
  ]: {
    ...baseMenuListStyles,
    position: "fixed",
    marginLeft: "subMenuListItem.pseudoElement.left",
    animation: animations.keyframes.slide.right
  },
  [
    "navigation"
    /* navigation */
  ]: {
    ...baseMenuListStyles,
    maxHeight: "unset",
    overflowY: "hidden",
    padding: 0,
    right: 0,
    width: "navbar.dropdown.default.width"
  },
  [
    "workflow"
    /* workflow */
  ]: {
    ...baseMenuListStyles,
    marginTop: 1,
    maxHeight: "unset",
    overflowY: "hidden",
    padding: 1,
    right: 0,
    width: "navbar.dropdown.workflow.width"
  }
};
var MenuListItemVariants = /* @__PURE__ */ ((MenuListItemVariants2) => {
  MenuListItemVariants2["default"] = "default";
  MenuListItemVariants2["navigation"] = "navigation";
  return MenuListItemVariants2;
})(MenuListItemVariants || {});
const baseMenuListItemStyles = {
  backgroundColor: "menuListItem.background",
  position: "relative",
  flexDirection: "row",
  alignItems: "center",
  borderRadius: "menuListItem.container",
  "&:hover": {
    backgroundColor: "menuListItem.background.hover"
  },
  "&:focus": {
    boxShadow: "menuListItem.active",
    outline: "none",
    zIndex: "dropdown"
  },
  "&:focus-within": {
    boxShadow: "menuListItem.active",
    outline: "none",
    zIndex: "dropdown"
  },
  "&:focus-visible": {
    outline: "none"
  },
  "&.focus-visible": {
    boxShadow: "menuListItem.active",
    zIndex: "dropdown"
  }
};
const menuListItemVariants = {
  default: {
    ...baseMenuListItemStyles,
    "&:active": {
      backgroundColor: "menuListItem.background.active"
    }
  },
  navigation: {
    ...baseMenuListItemStyles,
    width: "100%",
    "&:focus-within": {
      boxShadow: "menuListItem.navigation.active",
      outline: "none",
      zIndex: "dropdown",
      borderRadius: "menuListItem.container"
    }
  }
};
const styles$v = {
  leadingElement: {
    paddingRight: 0.5
  },
  trailingElement: {
    marginLeft: "auto"
  },
  titleVariant: (variant3) => {
    if (variant3 === "navigation") {
      return TitleSizes$1.Title14;
    }
    return TitleSizes$1.Title16;
  }
};
var NavbarVariant = /* @__PURE__ */ ((NavbarVariant2) => {
  NavbarVariant2["default"] = "default";
  NavbarVariant2["workflow"] = "workflow";
  return NavbarVariant2;
})(NavbarVariant || {});
const base$5 = {
  width: "100%",
  backgroundColor: "navbar.background",
  fontWeight: "demibold",
  position: "sticky",
  zIndex: "navigation",
  top: 0,
  borderBottom: "navbar",
  borderColor: "border.subdued"
};
const navbarVariants = {
  [
    "default"
    /* default */
  ]: {
    ...base$5,
    height: "62px"
  },
  [
    "workflow"
    /* workflow */
  ]: {
    ...base$5,
    height: "62px"
  }
};
const base$4 = {
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  marginX: "navbar.brand.marginX"
};
const navbarBrandVariants = {
  compact: {
    ...base$4
  }
};
var NavbarBrandVariant = /* @__PURE__ */ ((NavbarBrandVariant2) => {
  NavbarBrandVariant2["default"] = "compact";
  NavbarBrandVariant2["compact"] = "compact";
  return NavbarBrandVariant2;
})(NavbarBrandVariant || {});
var NavbarDropdownFooterVariant = /* @__PURE__ */ ((NavbarDropdownFooterVariant2) => {
  NavbarDropdownFooterVariant2["default"] = "default";
  NavbarDropdownFooterVariant2["workflow"] = "workflow";
  return NavbarDropdownFooterVariant2;
})(NavbarDropdownFooterVariant || {});
const base$3 = {
  fontWeight: "normal",
  marginTop: "auto"
};
const navbarDropdownFooterVariants = {
  [
    "default"
    /* default */
  ]: {
    ...base$3,
    backgroundColor: "navbar.dropdown.footer.background",
    paddingBottom: "navbar.dropdown.footer.paddingBottom"
  },
  [
    "workflow"
    /* workflow */
  ]: {
    ...base$3,
    borderTop: "1px solid",
    borderColor: "border.subdued",
    padding: "1"
  }
};
var NotificationVariant = /* @__PURE__ */ ((NotificationVariant2) => {
  NotificationVariant2["default"] = "default";
  NotificationVariant2["dot"] = "dot";
  return NotificationVariant2;
})(NotificationVariant || {});
const notificationBaseStyle = {
  display: "inline-block",
  borderRadius: "notification.default",
  paddingX: "notification.paddingX",
  paddingY: "notification.paddingY"
};
const notificationVariants = {
  [
    "default"
    /* default */
  ]: {
    ...notificationBaseStyle
  },
  [
    "dot"
    /* dot */
  ]: {
    width: "notification.dot",
    height: "notification.dot",
    borderRadius: "notification.dot"
  }
};
var OverlayVariant = /* @__PURE__ */ ((OverlayVariant2) => {
  OverlayVariant2["default"] = "default";
  return OverlayVariant2;
})(OverlayVariant || {});
const overlayVariants = {
  [
    "default"
    /* default */
  ]: {
    backgroundColor: "overlay.background",
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: "overlay"
  }
};
var RadioVariant = /* @__PURE__ */ ((RadioVariant2) => {
  RadioVariant2["default"] = "default";
  RadioVariant2["superRadio"] = "superRadio";
  RadioVariant2["checkMark"] = "checkMark";
  return RadioVariant2;
})(RadioVariant || {});
const label = {
  "&:hover input:not([disabled]) ~ div": {
    borderColor: "radio.border.hover",
    boxShadow: "radio.hover"
  },
  "&:hover input:not([disabled]):checked ~ div": {
    borderColor: "radio.border.hover.checked"
  },
  "&:active input:not([disabled]) ~ div": {
    borderColor: "radio.border.press",
    boxShadow: "radio.active"
  }
};
const checkMarkLabel = {
  "&:hover input:not([disabled]) ~ div[data-radio-type='checkMark']": {
    boxShadow: "radio.hover",
    "> svg": {
      fill: "radio.border.hover"
    }
  },
  "&:hover input:not([disabled]):checked ~ div[data-radio-type='checkMark']": {
    borderColor: "radio.border.hover.checked",
    "> svg": {
      fill: "dusk-60"
    }
  },
  "&:active input:not([disabled]) ~ [data-radio-type='checkMark']": {
    borderColor: "radio.border.press",
    boxShadow: "radio.checkMark",
    "> svg": {
      fill: "dusk-70"
    }
  }
};
const basePseudoRadioInput = {
  backgroundColor: "radio.center",
  border: "radio.unchecked",
  borderColor: "radio.border",
  borderRadius: "radio.default",
  flex: "0 0 auto",
  height: "radio.height",
  marginRight: "0.75rem",
  width: "radio.width",
  alignSelf: "flex-start"
};
const pseudoRadioInput = {
  ...basePseudoRadioInput,
  marginRight: base$a[0.625]
};
const pseudoSuperRadioInput = {
  ...basePseudoRadioInput
};
const radioInput = {
  opacity: "0",
  height: "0px",
  width: "0px",
  m: "0px",
  p: "0px",
  // TODO: Test - no checked version?...
  "&.focus-visible": {
    "+ div": {
      "&::after": {
        content: '""',
        width: "radio.focusRing.width",
        height: "radio.focusRing.height",
        backgroundColor: "transparent",
        position: "absolute",
        top: "50%",
        left: "50%",
        borderRadius: "50%",
        transform: "translate(-50%, -50%)",
        border: "radio.focusRing",
        borderColor: "radio.border.focused.ring"
      },
      position: "relative",
      borderColor: "radio.border.focused"
    }
  },
  "&:disabled": {
    "+ div": {
      borderColor: "radio.border.disabled",
      boxShadow: "none"
    }
  },
  "&:checked": {
    "+ div": {
      // Center
      backgroundColor: "radio.center.checked",
      border: "radio.checked",
      // Fill + border in one
      borderColor: "radio.border.checked"
    },
    "&:active": {
      "+ div": {
        border: "radio.checked",
        borderColor: "radio.border.press.checked"
      }
    },
    // Disabled styles diverge from typical pattern
    "&:disabled": {
      "+ div": {
        backgroundColor: "radio.center.disabled",
        // Center of radio
        borderColor: "radio.fill.disabled",
        // Fill of radio
        boxShadow: "radio.disabled"
        // Border of radio
      }
    }
  }
};
const pseudoCheckMarkRadioInput = {
  border: "radio.unchecked",
  borderColor: "radio.border",
  borderRadius: "radio.default",
  flex: "0 0 auto",
  height: "radio.height",
  width: "radio.width",
  alignSelf: "flex-start"
};
const checkMarkradioInput = {
  ...radioInput,
  // hide all icon from uncheked radio
  "&:not([checked])": {
    "+ div[data-radio-type='checkMark']": {
      "> svg": {
        display: "none"
      }
    }
  },
  // TODO: Test - no checked version?...
  "&:checked": {
    "+ div[data-radio-type='checkMark']": {
      height: "auto",
      width: "auto",
      border: "none",
      "> svg": {
        fill: "dusk-50",
        display: "block !important",
        border: "none"
      }
    },
    "&:active": {
      "+ div[data-radio-type='checkMark']": {
        border: "radio.checkMark",
        borderColor: "radio.border.press.checked"
      }
    },
    "&:disabled": {
      "+ div[data-radio-type='checkMark']": {
        border: "none",
        "> svg": {
          fill: "radio.border.disabled"
        }
      }
    }
  }
};
const radioVariants = {
  [
    "default"
    /* default */
  ]: {
    label,
    div: pseudoRadioInput,
    input: radioInput
  },
  [
    "superRadio"
    /* superRadio */
  ]: {
    label: { ...label, marginBottom: 0 },
    div: pseudoSuperRadioInput,
    input: radioInput
  },
  [
    "checkMark"
    /* checkMark */
  ]: {
    label: { ...checkMarkLabel },
    div: pseudoCheckMarkRadioInput,
    input: checkMarkradioInput
  }
};
var SkeletonContentVariants = /* @__PURE__ */ ((SkeletonContentVariants2) => {
  SkeletonContentVariants2["default"] = "default";
  SkeletonContentVariants2["static"] = "static";
  SkeletonContentVariants2["rainbow"] = "rainbow";
  return SkeletonContentVariants2;
})(SkeletonContentVariants || {});
const variants$4 = {
  [
    "static"
    /* static */
  ]: {
    backgroundColor: "skeletonContent.background",
    height: "skeletonContent.height",
    width: "skeletonContent.width",
    animated: false
  },
  [
    "default"
    /* default */
  ]: {
    backgroundColor: "skeletonContent.background",
    height: "skeletonContent.height",
    width: "skeletonContent.width",
    borderRadius: "skeletonContent.container",
    animated: true
  },
  [
    "rainbow"
    /* rainbow */
  ]: {
    backgroundColor: "skeletonContent.background",
    height: "skeletonContent.height",
    width: "skeletonContent.width",
    borderRadius: "skeletonContent.container",
    animated: true
  }
};
var SpinnerVariants = /* @__PURE__ */ ((SpinnerVariants2) => {
  SpinnerVariants2["primary"] = "primary";
  SpinnerVariants2["secondary"] = "secondary";
  return SpinnerVariants2;
})(SpinnerVariants || {});
const baseStyle = {
  margin: "auto",
  zIndex: "spinner",
  display: "flex"
};
const spinnerVariants = {
  primary: {
    color: "spinner.primary",
    ...baseStyle
  },
  secondary: {
    color: "spinner.secondary",
    ...baseStyle
  },
  tertiary: {
    color: "spinner.secondary",
    ...baseStyle
  },
  destructive: {
    color: "spinner.primary",
    ...baseStyle
  }
};
const defaultCounterStyles = {
  flexDirection: "row",
  alignItems: "center"
};
var CounterVariant = /* @__PURE__ */ ((CounterVariant2) => {
  CounterVariant2["default"] = "default";
  CounterVariant2["percentage"] = "percentage";
  CounterVariant2["currency"] = "currency";
  return CounterVariant2;
})(CounterVariant || {});
const counterButtonBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "32px",
  width: "32px",
  padding: 0
};
const styles$u = {
  incrementButton: { ...counterButtonBase, ml: 0.5 },
  decrementButton: { ...counterButtonBase, mr: 0.5 },
  input: {
    padding: 0,
    textAlign: "center",
    width: "60px"
  }
};
const CounterVariants = {
  [
    "default"
    /* default */
  ]: defaultCounterStyles,
  [
    "percentage"
    /* percentage */
  ]: defaultCounterStyles,
  [
    "currency"
    /* currency */
  ]: defaultCounterStyles
};
const serversideSearch = {
  menuList: {
    ...styles$x.dropDownMenu,
    top: "100%",
    left: "0"
  }
};
var SubMenuListItemVariants = /* @__PURE__ */ ((SubMenuListItemVariants2) => {
  SubMenuListItemVariants2["default"] = "default";
  return SubMenuListItemVariants2;
})(SubMenuListItemVariants || {});
const baseSubMenuListItemStyles = {
  backgroundColor: "menuListItem.background",
  position: "relative",
  flexDirection: "row",
  alignItems: "center",
  borderRadius: "menuListItem.container",
  "&:hover": {
    backgroundColor: "menuListItem.background.hover"
  },
  "&:focus": {
    boxShadow: "menuListItem.active",
    outline: "none",
    zIndex: "dropdown"
  },
  "&:focus-visible": {
    outline: "none"
  },
  "&.focus-visible": {
    boxShadow: "menuListItem.active"
  },
  "&:active": {
    backgroundColor: "menuListItem.background.active"
  }
};
const subMenuListItemVariants = {
  [
    "default"
    /* default */
  ]: {
    ...baseSubMenuListItemStyles
  }
};
const wideWrapperPadding = {
  p: base$a[1.5],
  pb: base$a[1.25],
  pt: base$a[1.25]
};
const defaultSummaryCardStyles = {
  display: "inline-flex",
  borderRadius: "summaryCard.container",
  backgroundColor: "summaryCard.background",
  border: "default",
  borderColor: "summaryCard.border",
  position: "relative"
};
const summaryCardVariants = {
  [
    "default"
    /* default */
  ]: {
    ...defaultSummaryCardStyles,
    flexDirection: "row",
    wordBreak: "break-word",
    ...wideWrapperPadding
  }
};
const styles$t = {
  wrapper: {
    width: "100%",
    alignItems: "center"
  },
  default: {
    action: {
      mr: base$a[0],
      justifyContent: "flex-end",
      position: "absolute",
      right: wideWrapperPadding.p,
      alignItems: "center"
    },
    description: {
      marginTop: "summaryCard.default.description.marginTop"
    },
    eyebrow: {
      paddingBottom: "summaryCard.default.eyebrow.paddingBottom",
      alignItems: "flex-end"
    },
    label: {
      alignItems: "center",
      justifyContent: "center"
    }
  }
};
const defaultSuperRadioStyles = {
  display: "inline-flex",
  flex: 1,
  cursor: "pointer",
  borderRadius: "superRadio.container",
  backgroundColor: "superRadio.background",
  border: "1px solid",
  borderColor: "superRadio.border",
  position: "relative",
  "&:focus-within": {
    borderColor: "border.hover",
    boxShadow: "one-pixel-soft",
    outline: "none",
    zIndex: "sticky"
    // If two compact radios are right next to each other, one focus border can be behind another. Want the one selected to have their focused border be higher than the other.
  },
  "&:hover": {
    borderColor: "superRadio.border.hover"
  },
  // For some reason the click / hover events are not passed to radio component so need to update manually
  // Styles for applying hover look to radio pseduo element when hovering over parent
  "&:hover input:not([disabled]) ~ div": {
    borderColor: "radio.border.hover",
    boxShadow: "radio.hover"
  },
  "&:hover input:not([disabled]):checked ~ div": {
    backgroundColor: "superRadio.background.hover",
    borderColor: "radio.border.hover.checked"
  },
  // pressed state
  "&:active input:not([disabled]) ~ div": {
    backgroundColor: "superRadio.background.active",
    borderColor: "radio.border.press",
    boxShadow: "radio.active"
  },
  // checked state needs a different focus size
  "& input:not([disabled]):checked.focus-visible": {
    "+ div": {
      "&::after": {
        width: "1.325rem",
        height: "1.325rem"
      }
    }
  }
};
const superRadioVariants$1 = {
  [
    "default"
    /* default */
  ]: {
    ...defaultSuperRadioStyles
  }
};
const styles$s = {
  parentWrapper: {
    flex: 1
  },
  innerLabelWrapper: {
    position: "relative",
    width: "100%"
  },
  contentsWrapper: {
    position: "relative",
    width: "100%",
    alignItems: "center",
    padding: "1.25rem 1.5rem"
  },
  iconWrapper: {
    position: "relative",
    minWidth: "2.5rem",
    "& div": {
      borderRadius: "50%",
      backgroundColor: "opaque.fog-80.8",
      width: "2.5rem",
      height: "2.5rem"
    },
    "& svg": {
      position: "absolute",
      borderWidth: "0.5rem",
      width: "1.5rem",
      height: "1.5rem",
      transform: "translate(8px, 8px)"
    }
  },
  eyebrow: {
    marginBottom: 0
  },
  option: {
    flexShrink: "0"
  },
  disabled: {
    backgroundColor: "superRadio.background.disabled",
    borderColor: "superRadio.border.disabled",
    cursor: "not-allowed",
    "&:hover": {
      borderColor: "radio.border.disabled"
    }
  },
  checked: {
    borderWidth: "1.5px",
    borderColor: "superRadio.border.checked",
    "&:hover": {
      borderColor: "superRadio.border.hover.checked"
    }
  },
  radio: {
    base: {
      minWidth: `calc(0.5rem + ${radio.width})`
    },
    desktop: {
      alignSelf: "center"
    },
    mobile: {
      alignSelf: "flex-start"
    }
  },
  label: {
    alignItems: "center",
    justifyContent: "center"
  },
  description: {
    marginBottom: 0
  },
  footer: {
    content: {
      backgroundColor: "superRadio.footer",
      borderTopWidth: "1px",
      borderTopStyle: "solid",
      borderColor: "border.subdued",
      borderBottomLeftRadius: "superRadio.container",
      borderBottomRightRadius: "superRadio.container",
      px: 1.5,
      py: 1
    }
  }
};
function wrapperStateStyles(disabled = false, checked = false) {
  if (disabled) {
    return styles$s.disabled;
  } else if (checked) {
    return styles$s.checked;
  }
}
var SuperRadioGroupVariants = /* @__PURE__ */ ((SuperRadioGroupVariants2) => {
  SuperRadioGroupVariants2["default"] = "default";
  return SuperRadioGroupVariants2;
})(SuperRadioGroupVariants || {});
const defaultSuperRadioGroupStyles = {
  display: "inline-flex",
  gap: base$a[1],
  width: "100%"
};
const superRadioGroupVariants = {
  [
    "default"
    /* default */
  ]: {
    ...defaultSuperRadioGroupStyles,
    flexDirection: "column"
  }
};
const baseStyles = {
  borderCollapse: "separate",
  borderSpacing: "0",
  width: "100%",
  overflow: "hidden",
  "&.guideline-ui--table--overflow": {
    "th:nth-of-type(1)": {
      left: 0,
      position: "sticky",
      zIndex: "sticky",
      boxShadow: "elevation.three"
    },
    "td:nth-of-type(1)": {
      left: 0,
      position: "sticky",
      zIndex: "sticky",
      boxShadow: "elevation.three"
    }
  },
  tr: {
    backgroundColor: "table.background.odd",
    th: {
      borderBottom: "table",
      borderColor: "table.header.border",
      textAlign: "left",
      verticalAlign: "bottom",
      padding: "table.row.header.padding",
      "&:nth-of-type(1)": {
        backgroundColor: "inherit"
      }
    },
    td: {
      padding: "table.row.data.padding",
      wordWrap: "break-word",
      borderBottom: "table",
      borderColor: "table.data.border",
      "&:nth-of-type(1)": {
        backgroundColor: "inherit"
      }
    }
  }
};
const tableVariants = {
  container: {
    overflowX: "auto"
  },
  default: {
    ...baseStyles,
    tr: {
      ...baseStyles.tr,
      "&:nth-last-of-type(1)": {
        td: {
          border: "none"
        }
      }
    }
  },
  compact: {
    ...baseStyles,
    tr: {
      ...baseStyles.tr,
      "&:nth-last-of-type(1)": {
        td: {
          border: "none"
        }
      },
      th: {
        ...baseStyles.tr.th,
        padding: "table.compact.row.data.padding"
      },
      td: {
        ...baseStyles.tr.td,
        padding: "table.compact.row.data.padding"
      }
    }
  },
  card: {
    ...baseStyles,
    thead: {
      display: "none"
    },
    tr: {
      ...baseStyles.tr,
      display: "flex",
      flexDirection: "column",
      marginBottom: 1.5,
      td: {
        ...baseStyles.tr.td,
        "&:last-child": {
          border: "none"
        },
        padding: "table.card.row.data.padding",
        textAlign: "right",
        display: "flex",
        alignItems: "center",
        width: "100%",
        "&:first-of-type": {
          borderColor: "table.header.border",
          fontWeight: "bold",
          "& *:first-of-type": {
            fontWeight: "bold"
          }
        }
      }
    }
  },
  reduced: {
    ...baseStyles,
    tr: {
      ...baseStyles.tr,
      "&:nth-last-of-type(1)": {
        td: {
          border: "none"
        }
      },
      th: {
        ...baseStyles.tr.th,
        "&.guideline-ui--table--collapse": {
          display: "none"
        }
      },
      td: {
        ...baseStyles.tr.td,
        "&.guideline-ui--table--collapse": {
          display: "none"
        }
      }
    }
  }
};
var TableVariant = /* @__PURE__ */ ((TableVariant2) => {
  TableVariant2["default"] = "default";
  TableVariant2["compact"] = "compact";
  return TableVariant2;
})(TableVariant || {});
var TableResponsiveVariant = /* @__PURE__ */ ((TableResponsiveVariant2) => {
  TableResponsiveVariant2["card"] = "card";
  TableResponsiveVariant2["reduced"] = "reduced";
  return TableResponsiveVariant2;
})(TableResponsiveVariant || {});
const base$2 = {
  textAlign: "center",
  borderRadius: "tag.default",
  height: "tag.default",
  p: "tag.default"
};
const tagVariants = {
  success: {
    ...base$2,
    backgroundColor: "tag.background.success",
    color: "tag.foreground.success"
  },
  info: {
    ...base$2,
    backgroundColor: "tag.background.info",
    color: "tag.foreground.info"
  },
  warning: {
    ...base$2,
    backgroundColor: "tag.background.warning",
    color: "tag.foreground.warning"
  },
  error: {
    ...base$2,
    backgroundColor: "tag.background.error",
    color: "tag.foreground.error"
  },
  indeterminate: {
    ...base$2,
    backgroundColor: "tag.background.indeterminate",
    color: "tag.foreground.indeterminate"
  },
  dusk: {
    ...base$2,
    backgroundColor: "tag.background.dusk",
    color: "tag.foreground.dusk"
  },
  eucalyptus: {
    ...base$2,
    backgroundColor: "tag.background.eucalyptus",
    color: "tag.foreground.eucalyptus"
  },
  dark: {
    success: {
      ...base$2,
      backgroundColor: "tag.background.dark.success",
      color: "tag.foreground.dark.success"
    },
    info: {
      ...base$2,
      backgroundColor: "tag.background.dark.info",
      color: "tag.foreground.dark.info"
    },
    warning: {
      ...base$2,
      backgroundColor: "tag.background.dark.warning",
      color: "tag.foreground.dark.warning"
    },
    error: {
      ...base$2,
      backgroundColor: "tag.background.dark.error",
      color: "tag.foreground.dark.error"
    },
    indeterminate: {
      ...base$2,
      backgroundColor: "tag.background.dark.indeterminate",
      color: "tag.foreground.dark.indeterminate"
    },
    dusk: {
      ...base$2,
      backgroundColor: "tag.background.dark.dusk",
      color: "tag.foreground.dark.dusk"
    },
    eucalyptus: {
      ...base$2,
      backgroundColor: "tag.background.dark.eucalyptus",
      color: "tag.foreground.dark.eucalyptus"
    }
  }
};
var TagVariant = /* @__PURE__ */ ((TagVariant2) => {
  TagVariant2["info"] = "info";
  TagVariant2["success"] = "success";
  TagVariant2["warning"] = "warning";
  TagVariant2["error"] = "error";
  TagVariant2["indeterminate"] = "indeterminate";
  TagVariant2["dusk"] = "dusk";
  TagVariant2["eucalyptus"] = "eucalyptus";
  return TagVariant2;
})(TagVariant || {});
const baseToastStyles = {
  container: {
    alignItems: "flex-end",
    flexDirection: "column-reverse",
    position: "absolute",
    overflow: "hidden"
  },
  toast: {
    minHeight: "toast.minHeight",
    overflowWrap: "break-word",
    marginY: "toast.marginY",
    borderRadius: 8,
    alignItems: "center",
    zIndex: "toast",
    paddingX: "toast.paddingX",
    paddingY: "toast.paddingY"
  }
};
const toastVariants = {
  default: {
    ...baseToastStyles.toast,
    animation: animations.keyframes.slide.left,
    width: "auto"
  },
  small: {
    ...baseToastStyles.toast,
    animation: animations.keyframes.slide.up,
    width: "100%",
    wordWrap: "normal"
  },
  container: {
    default: {
      ...baseToastStyles.container,
      top: 0,
      right: 0,
      paddingRight: "toast.container.default.paddingRight",
      paddingTop: "toast.container.default.paddingTop"
    },
    small: {
      ...baseToastStyles.container,
      left: "toast.container.small.left",
      right: "toast.container.small.right",
      bottom: "toast.container.small.bottom"
    }
  }
};
const styles$r = {
  icon: {
    flexShrink: 0,
    marginRight: "toast.icon.marginRight"
  },
  content: {
    marginBottom: "0"
  },
  actionButton: (mediaQueries2) => ({
    width: "auto",
    marginLeft: mediaQueries2.smDown ? "auto" : "toast.action.marginLeft",
    marginRight: "toast.action.marginRight"
  })
};
var WorkflowTemplateVariant = /* @__PURE__ */ ((WorkflowTemplateVariant2) => {
  WorkflowTemplateVariant2["default"] = "default";
  WorkflowTemplateVariant2["fullWidth"] = "fullWidth";
  return WorkflowTemplateVariant2;
})(WorkflowTemplateVariant || {});
const defaultStyles$5 = {
  borderRight: "default",
  borderColor: "border.subdued",
  gridArea: "aside",
  overflowY: "auto",
  width: "templates.workflow.aside.width"
};
const aside = {
  [WorkflowTemplateVariant.default]: {
    ...defaultStyles$5
  },
  [WorkflowTemplateVariant.fullWidth]: {
    ...defaultStyles$5
  }
};
const defaultStyles$4 = {
  display: "grid",
  gridArea: "content",
  gridTemplateAreas: buildResponsiveValues({
    lgUp: `
      "main ."
      "footer ."
    `,
    mdDown: `
      "main"
      "footer"
    `
  }),
  gridTemplateRows: "1fr auto",
  gridTemplateColumns: buildResponsiveValues({
    lgUp: "auto 1fr",
    mdDown: "auto"
  }),
  overflowY: "auto",
  rowGap: "templates.workflow.content.rowGap"
};
const content = {
  [WorkflowTemplateVariant.default]: {
    ...defaultStyles$4
  },
  [WorkflowTemplateVariant.fullWidth]: {
    ...defaultStyles$4
  }
};
const defaultStyles$3 = {
  gridArea: "footer",
  marginX: buildResponsiveValues({ lgUp: 2, mdDown: 1 }),
  maxWidth: buildResponsiveValues({
    lgUp: "templates.workflow.footer.maxWidth.lgUp",
    mdDown: "templates.workflow.footer.maxWidth.mdDown"
  })
};
const footer = {
  [WorkflowTemplateVariant.default]: {
    ...defaultStyles$3
  },
  [WorkflowTemplateVariant.fullWidth]: {
    ...defaultStyles$3,
    maxWidth: "100%"
  }
};
const header$1 = {
  [WorkflowTemplateVariant.default]: {
    gridArea: "header"
  },
  [WorkflowTemplateVariant.fullWidth]: {
    gridArea: "header"
  }
};
const defaultStyles$2 = {
  paddingTop: "templates.workflow.main.paddingTop",
  marginBottom: "auto",
  marginX: buildResponsiveValues({
    lgUp: "templates.workflow.main.marginX.lgUp",
    mdDown: "templates.workflow.main.marginX.mdDown"
  }),
  maxWidth: buildResponsiveValues({
    lgUp: "templates.workflow.main.maxWidth.lgUp",
    mdDown: "templates.workflow.main.maxWidth.mdDown"
  }),
  // Grid Item / Contain Definition
  columnGap: buildResponsiveValues({
    lgUp: `grid.${GridVariants.standard}.columnGap.lgUp`,
    mdDown: `grid.${GridVariants.standard}.columnGap.mdDown`
  }),
  display: "grid",
  gridArea: "main",
  gridTemplateColumns: GridTemplateColumns.standard,
  rowGap: "templates.main.rowGap"
};
const main = {
  [WorkflowTemplateVariant.default]: defaultStyles$2,
  [WorkflowTemplateVariant.fullWidth]: {
    ...defaultStyles$2,
    maxWidth: "100%"
  }
};
const defaultStyles$1 = {
  backgroundColor: "background",
  gridTemplateColumns: buildResponsiveValues({
    lgUp: `auto minmax(0px, ${sizes$1.aside.width}) auto`,
    mdDown: "auto"
  }),
  gridTemplateRows: "auto minmax(1rem, 1fr)",
  gridTemplateAreas: buildResponsiveValues({
    lgUp: `
        "header header header"
        ". aside content"
      `,
    mdDown: `
        "header"
        "content"
      `
  }),
  height: "100vh"
};
const root$a = {
  [WorkflowTemplateVariant.default]: {
    ...defaultStyles$1
  },
  [WorkflowTemplateVariant.fullWidth]: {
    ...defaultStyles$1,
    gridTemplateColumns: "1/-1"
  }
};
const workflow = {
  [WorkflowTemplateVariant.default]: {
    aside: aside.default,
    content: content.default,
    footer: footer.default,
    header: header$1.default,
    main: main.default,
    root: root$a.default
  },
  [WorkflowTemplateVariant.fullWidth]: {
    aside: aside.fullWidth,
    content: content.fullWidth,
    footer: footer.fullWidth,
    header: header$1.fullWidth,
    main: main.fullWidth,
    root: root$a.fullWidth
  }
};
const templates = {
  workflow
};
const variants$3 = {
  avatar: avatarVariants,
  banner: bannerVariants,
  breadcrumbs: breadcrumbsVariant,
  buttons: {
    icon: {
      cursor: "pointer"
    },
    ...buttonVariants
  },
  // TODO: look into buttons and see what's wrong here with the typing. Also {icon: ... } doesn't seem to work
  card: cardVariants,
  charts,
  checkbox: checkboxVariants,
  container: variants$7,
  counter: CounterVariants,
  divider: variants$5,
  drawer: drawerVariants,
  dropDownMenuList: searchBarVariants,
  dropdown: dropdownVariants,
  expansionPanel: expansionPanelVariants,
  footer: footerVariants,
  forms: {
    checkbox: checkboxVariants,
    label: labelVariants,
    radio: radioVariants,
    selectIcon: {
      ml: "-28px",
      alignSelf: "center",
      pointerEvents: "none"
    },
    ...formVariants$1
  },
  // TODO: look into forms and see what's wrong here with the typing.
  grid: gridVariants,
  headers,
  heroBanner: heroBannerVariants,
  inlineCallout: inlineCalloutVariants,
  label: labelVariants,
  links: variants$8,
  listItem: listItemVariants,
  menuList: menuListVariants,
  menuListItems: menuListItemVariants,
  navbar: navbarVariants,
  navbarBrand: navbarBrandVariants,
  navbarDropdown: navbarDropdownVariants,
  navbarDropdownFooter: navbarDropdownFooterVariants,
  notifications: notificationVariants,
  orderedList: orderedListVariants,
  overlay: overlayVariants,
  popover: popoverVariants,
  subMenuListItems: subMenuListItemVariants,
  radio: radioVariants,
  serversideSearch,
  shadows: shadowVariants,
  skeletonContent: variants$4,
  spinner: spinnerVariants,
  summaryCard: summaryCardVariants,
  superRadio: superRadioVariants$1,
  superRadioGroup: superRadioGroupVariants,
  table: tableVariants,
  tag: tagVariants,
  // TODO: consider doing this in the root theme file and bring in as `templates`
  // use this object for grouping templates, not just single components
  templates,
  text: {
    ...variants$b,
    ...variants$a,
    ...variants$9
  },
  // TODO: look into forms and see what's wrong here with the typing.
  toast: toastVariants
};
const base$1 = 0;
const above = 1;
const below = -1;
const auto = "auto";
const behind = below + base$1;
const sticky = above + base$1;
const header = above + sticky;
const toast = above + header;
const dropdown = above + toast;
const overlay = above + dropdown;
const spinner = above + overlay;
const navigation = above + spinner;
const modal$1 = above + navigation;
const drawer = above + modal$1;
const popover = above + drawer;
const zIndices = {
  auto,
  behind,
  base: base$1,
  sticky,
  header,
  toast,
  dropdown,
  overlay,
  spinner,
  drawer,
  navigation,
  modal: modal$1,
  popover
};
const theme$2 = {
  animations,
  borders,
  borderStyles,
  borderWidths,
  breakpoints: Object.values(breakpoints$2).map((pixelValue) => `${pixelValue}px`),
  mediaQueries: mediaQueries$3,
  config: {
    useColorSchemeMediaQuery: false,
    initialColorModeName: "light"
  },
  colors: {
    ...combinedPalettes$1,
    ...colorModes$1.light
  },
  fonts: fonts$2,
  fontWeights: fontWeights$1,
  fontSizes: fontSizes$1,
  letterSpacings: letterSpacings$1,
  lineHeights: lineHeights$1,
  radii,
  sizes,
  space,
  transitions,
  zIndices,
  ...variants$3
};
const ProvidersWrapper = ({
  children: children2 = void 0,
  theme: theme2 = theme$2
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: theme2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMediaProvider, { children: children2 }) });
const { create } = TestRenderer;
const createWithWrappedProviders = (element, options2, wrap = true) => create(
  wrap ? /* @__PURE__ */ jsxRuntimeExports.jsx(ProvidersWrapper, { children: element }) : element,
  options2
);
TestRenderer.create = createWithWrappedProviders;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error2) {
    reject(error2);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn2) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn2.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
var regeneratorRuntime$1 = { exports: {} };
var _typeof$4 = { exports: {} };
(function(module2) {
  function _typeof2(o) {
    "@babel/helpers - typeof";
    return module2.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
      return typeof o2;
    } : function(o2) {
      return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
    }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports, _typeof2(o);
  }
  module2.exports = _typeof2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(_typeof$4);
var _typeofExports = _typeof$4.exports;
(function(module2) {
  var _typeof2 = _typeofExports["default"];
  function _regeneratorRuntime2() {
    module2.exports = _regeneratorRuntime2 = function _regeneratorRuntime3() {
      return e3;
    }, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
    var t2, e3 = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t3, e4, r2) {
      t3[e4] = r2.value;
    }, i2 = "function" == typeof Symbol ? Symbol : {}, a4 = i2.iterator || "@@iterator", c7 = i2.asyncIterator || "@@asyncIterator", u2 = i2.toStringTag || "@@toStringTag";
    function define2(t3, e4, r2) {
      return Object.defineProperty(t3, e4, {
        value: r2,
        enumerable: true,
        configurable: true,
        writable: true
      }), t3[e4];
    }
    try {
      define2({}, "");
    } catch (t3) {
      define2 = function define3(t4, e4, r2) {
        return t4[e4] = r2;
      };
    }
    function wrap(t3, e4, r2, n2) {
      var i3 = e4 && e4.prototype instanceof Generator ? e4 : Generator, a5 = Object.create(i3.prototype), c8 = new Context2(n2 || []);
      return o(a5, "_invoke", {
        value: makeInvokeMethod(t3, r2, c8)
      }), a5;
    }
    function tryCatch(t3, e4, r2) {
      try {
        return {
          type: "normal",
          arg: t3.call(e4, r2)
        };
      } catch (t4) {
        return {
          type: "throw",
          arg: t4
        };
      }
    }
    e3.wrap = wrap;
    var h3 = "suspendedStart", l = "suspendedYield", f = "executing", s4 = "completed", y4 = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var p = {};
    define2(p, a4, function() {
      return this;
    });
    var d3 = Object.getPrototypeOf, v = d3 && d3(d3(values6([])));
    v && v !== r && n.call(v, a4) && (p = v);
    var g2 = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t3) {
      ["next", "throw", "return"].forEach(function(e4) {
        define2(t3, e4, function(t4) {
          return this._invoke(e4, t4);
        });
      });
    }
    function AsyncIterator(t3, e4) {
      function invoke2(r3, o2, i3, a5) {
        var c8 = tryCatch(t3[r3], t3, o2);
        if ("throw" !== c8.type) {
          var u3 = c8.arg, h4 = u3.value;
          return h4 && "object" == _typeof2(h4) && n.call(h4, "__await") ? e4.resolve(h4.__await).then(function(t4) {
            invoke2("next", t4, i3, a5);
          }, function(t4) {
            invoke2("throw", t4, i3, a5);
          }) : e4.resolve(h4).then(function(t4) {
            u3.value = t4, i3(u3);
          }, function(t4) {
            return invoke2("throw", t4, i3, a5);
          });
        }
        a5(c8.arg);
      }
      var r2;
      o(this, "_invoke", {
        value: function value(t4, n2) {
          function callInvokeWithMethodAndArg() {
            return new e4(function(e6, r3) {
              invoke2(t4, n2, e6, r3);
            });
          }
          return r2 = r2 ? r2.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e4, r2, n2) {
      var o2 = h3;
      return function(i3, a5) {
        if (o2 === f)
          throw Error("Generator is already running");
        if (o2 === s4) {
          if ("throw" === i3)
            throw a5;
          return {
            value: t2,
            done: true
          };
        }
        for (n2.method = i3, n2.arg = a5; ; ) {
          var c8 = n2.delegate;
          if (c8) {
            var u3 = maybeInvokeDelegate(c8, n2);
            if (u3) {
              if (u3 === y4)
                continue;
              return u3;
            }
          }
          if ("next" === n2.method)
            n2.sent = n2._sent = n2.arg;
          else if ("throw" === n2.method) {
            if (o2 === h3)
              throw o2 = s4, n2.arg;
            n2.dispatchException(n2.arg);
          } else
            "return" === n2.method && n2.abrupt("return", n2.arg);
          o2 = f;
          var p2 = tryCatch(e4, r2, n2);
          if ("normal" === p2.type) {
            if (o2 = n2.done ? s4 : l, p2.arg === y4)
              continue;
            return {
              value: p2.arg,
              done: n2.done
            };
          }
          "throw" === p2.type && (o2 = s4, n2.method = "throw", n2.arg = p2.arg);
        }
      };
    }
    function maybeInvokeDelegate(e4, r2) {
      var n2 = r2.method, o2 = e4.iterator[n2];
      if (o2 === t2)
        return r2.delegate = null, "throw" === n2 && e4.iterator["return"] && (r2.method = "return", r2.arg = t2, maybeInvokeDelegate(e4, r2), "throw" === r2.method) || "return" !== n2 && (r2.method = "throw", r2.arg = new TypeError("The iterator does not provide a '" + n2 + "' method")), y4;
      var i3 = tryCatch(o2, e4.iterator, r2.arg);
      if ("throw" === i3.type)
        return r2.method = "throw", r2.arg = i3.arg, r2.delegate = null, y4;
      var a5 = i3.arg;
      return a5 ? a5.done ? (r2[e4.resultName] = a5.value, r2.next = e4.nextLoc, "return" !== r2.method && (r2.method = "next", r2.arg = t2), r2.delegate = null, y4) : a5 : (r2.method = "throw", r2.arg = new TypeError("iterator result is not an object"), r2.delegate = null, y4);
    }
    function pushTryEntry(t3) {
      var e4 = {
        tryLoc: t3[0]
      };
      1 in t3 && (e4.catchLoc = t3[1]), 2 in t3 && (e4.finallyLoc = t3[2], e4.afterLoc = t3[3]), this.tryEntries.push(e4);
    }
    function resetTryEntry(t3) {
      var e4 = t3.completion || {};
      e4.type = "normal", delete e4.arg, t3.completion = e4;
    }
    function Context2(t3) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t3.forEach(pushTryEntry, this), this.reset(true);
    }
    function values6(e4) {
      if (e4 || "" === e4) {
        var r2 = e4[a4];
        if (r2)
          return r2.call(e4);
        if ("function" == typeof e4.next)
          return e4;
        if (!isNaN(e4.length)) {
          var o2 = -1, i3 = function next2() {
            for (; ++o2 < e4.length; )
              if (n.call(e4, o2))
                return next2.value = e4[o2], next2.done = false, next2;
            return next2.value = t2, next2.done = true, next2;
          };
          return i3.next = i3;
        }
      }
      throw new TypeError(_typeof2(e4) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g2, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u2, "GeneratorFunction"), e3.isGeneratorFunction = function(t3) {
      var e4 = "function" == typeof t3 && t3.constructor;
      return !!e4 && (e4 === GeneratorFunction || "GeneratorFunction" === (e4.displayName || e4.name));
    }, e3.mark = function(t3) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t3, GeneratorFunctionPrototype) : (t3.__proto__ = GeneratorFunctionPrototype, define2(t3, u2, "GeneratorFunction")), t3.prototype = Object.create(g2), t3;
    }, e3.awrap = function(t3) {
      return {
        __await: t3
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define2(AsyncIterator.prototype, c7, function() {
      return this;
    }), e3.AsyncIterator = AsyncIterator, e3.async = function(t3, r2, n2, o2, i3) {
      void 0 === i3 && (i3 = Promise);
      var a5 = new AsyncIterator(wrap(t3, r2, n2, o2), i3);
      return e3.isGeneratorFunction(r2) ? a5 : a5.next().then(function(t4) {
        return t4.done ? t4.value : a5.next();
      });
    }, defineIteratorMethods(g2), define2(g2, u2, "Generator"), define2(g2, a4, function() {
      return this;
    }), define2(g2, "toString", function() {
      return "[object Generator]";
    }), e3.keys = function(t3) {
      var e4 = Object(t3), r2 = [];
      for (var n2 in e4)
        r2.push(n2);
      return r2.reverse(), function next2() {
        for (; r2.length; ) {
          var t4 = r2.pop();
          if (t4 in e4)
            return next2.value = t4, next2.done = false, next2;
        }
        return next2.done = true, next2;
      };
    }, e3.values = values6, Context2.prototype = {
      constructor: Context2,
      reset: function reset(e4) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t2, this.done = false, this.delegate = null, this.method = "next", this.arg = t2, this.tryEntries.forEach(resetTryEntry), !e4)
          for (var r2 in this)
            "t" === r2.charAt(0) && n.call(this, r2) && !isNaN(+r2.slice(1)) && (this[r2] = t2);
      },
      stop: function stop2() {
        this.done = true;
        var t3 = this.tryEntries[0].completion;
        if ("throw" === t3.type)
          throw t3.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e4) {
        if (this.done)
          throw e4;
        var r2 = this;
        function handle(n2, o3) {
          return a5.type = "throw", a5.arg = e4, r2.next = n2, o3 && (r2.method = "next", r2.arg = t2), !!o3;
        }
        for (var o2 = this.tryEntries.length - 1; o2 >= 0; --o2) {
          var i3 = this.tryEntries[o2], a5 = i3.completion;
          if ("root" === i3.tryLoc)
            return handle("end");
          if (i3.tryLoc <= this.prev) {
            var c8 = n.call(i3, "catchLoc"), u3 = n.call(i3, "finallyLoc");
            if (c8 && u3) {
              if (this.prev < i3.catchLoc)
                return handle(i3.catchLoc, true);
              if (this.prev < i3.finallyLoc)
                return handle(i3.finallyLoc);
            } else if (c8) {
              if (this.prev < i3.catchLoc)
                return handle(i3.catchLoc, true);
            } else {
              if (!u3)
                throw Error("try statement without catch or finally");
              if (this.prev < i3.finallyLoc)
                return handle(i3.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t3, e4) {
        for (var r2 = this.tryEntries.length - 1; r2 >= 0; --r2) {
          var o2 = this.tryEntries[r2];
          if (o2.tryLoc <= this.prev && n.call(o2, "finallyLoc") && this.prev < o2.finallyLoc) {
            var i3 = o2;
            break;
          }
        }
        i3 && ("break" === t3 || "continue" === t3) && i3.tryLoc <= e4 && e4 <= i3.finallyLoc && (i3 = null);
        var a5 = i3 ? i3.completion : {};
        return a5.type = t3, a5.arg = e4, i3 ? (this.method = "next", this.next = i3.finallyLoc, y4) : this.complete(a5);
      },
      complete: function complete(t3, e4) {
        if ("throw" === t3.type)
          throw t3.arg;
        return "break" === t3.type || "continue" === t3.type ? this.next = t3.arg : "return" === t3.type ? (this.rval = this.arg = t3.arg, this.method = "return", this.next = "end") : "normal" === t3.type && e4 && (this.next = e4), y4;
      },
      finish: function finish(t3) {
        for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
          var r2 = this.tryEntries[e4];
          if (r2.finallyLoc === t3)
            return this.complete(r2.completion, r2.afterLoc), resetTryEntry(r2), y4;
        }
      },
      "catch": function _catch(t3) {
        for (var e4 = this.tryEntries.length - 1; e4 >= 0; --e4) {
          var r2 = this.tryEntries[e4];
          if (r2.tryLoc === t3) {
            var n2 = r2.completion;
            if ("throw" === n2.type) {
              var o2 = n2.arg;
              resetTryEntry(r2);
            }
            return o2;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e4, r2, n2) {
        return this.delegate = {
          iterator: values6(e4),
          resultName: r2,
          nextLoc: n2
        }, "next" === this.method && (this.arg = t2), y4;
      }
    }, e3;
  }
  module2.exports = _regeneratorRuntime2, module2.exports.__esModule = true, module2.exports["default"] = module2.exports;
})(regeneratorRuntime$1);
var regeneratorRuntimeExports = regeneratorRuntime$1.exports;
var runtime = regeneratorRuntimeExports();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
const _regeneratorRuntime = /* @__PURE__ */ getDefaultExportFromCjs(regenerator);
var build = {};
var ansiStyles = { exports: {} };
ansiStyles.exports;
(function(module2) {
  const ANSI_BACKGROUND_OFFSET = 10;
  const wrapAnsi256 = (offset2 = 0) => (code) => `\x1B[${38 + offset2};5;${code}m`;
  const wrapAnsi16m = (offset2 = 0) => (red, green, blue) => `\x1B[${38 + offset2};2;${red};${green};${blue}m`;
  function assembleStyles() {
    const codes = /* @__PURE__ */ new Map();
    const styles2 = {
      modifier: {
        reset: [0, 0],
        // 21 isn't widely supported and 22 does the same thing
        bold: [1, 22],
        dim: [2, 22],
        italic: [3, 23],
        underline: [4, 24],
        overline: [53, 55],
        inverse: [7, 27],
        hidden: [8, 28],
        strikethrough: [9, 29]
      },
      color: {
        black: [30, 39],
        red: [31, 39],
        green: [32, 39],
        yellow: [33, 39],
        blue: [34, 39],
        magenta: [35, 39],
        cyan: [36, 39],
        white: [37, 39],
        // Bright color
        blackBright: [90, 39],
        redBright: [91, 39],
        greenBright: [92, 39],
        yellowBright: [93, 39],
        blueBright: [94, 39],
        magentaBright: [95, 39],
        cyanBright: [96, 39],
        whiteBright: [97, 39]
      },
      bgColor: {
        bgBlack: [40, 49],
        bgRed: [41, 49],
        bgGreen: [42, 49],
        bgYellow: [43, 49],
        bgBlue: [44, 49],
        bgMagenta: [45, 49],
        bgCyan: [46, 49],
        bgWhite: [47, 49],
        // Bright color
        bgBlackBright: [100, 49],
        bgRedBright: [101, 49],
        bgGreenBright: [102, 49],
        bgYellowBright: [103, 49],
        bgBlueBright: [104, 49],
        bgMagentaBright: [105, 49],
        bgCyanBright: [106, 49],
        bgWhiteBright: [107, 49]
      }
    };
    styles2.color.gray = styles2.color.blackBright;
    styles2.bgColor.bgGray = styles2.bgColor.bgBlackBright;
    styles2.color.grey = styles2.color.blackBright;
    styles2.bgColor.bgGrey = styles2.bgColor.bgBlackBright;
    for (const [groupName, group] of Object.entries(styles2)) {
      for (const [styleName, style2] of Object.entries(group)) {
        styles2[styleName] = {
          open: `\x1B[${style2[0]}m`,
          close: `\x1B[${style2[1]}m`
        };
        group[styleName] = styles2[styleName];
        codes.set(style2[0], style2[1]);
      }
      Object.defineProperty(styles2, groupName, {
        value: group,
        enumerable: false
      });
    }
    Object.defineProperty(styles2, "codes", {
      value: codes,
      enumerable: false
    });
    styles2.color.close = "\x1B[39m";
    styles2.bgColor.close = "\x1B[49m";
    styles2.color.ansi256 = wrapAnsi256();
    styles2.color.ansi16m = wrapAnsi16m();
    styles2.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
    styles2.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);
    Object.defineProperties(styles2, {
      rgbToAnsi256: {
        value: (red, green, blue) => {
          if (red === green && green === blue) {
            if (red < 8) {
              return 16;
            }
            if (red > 248) {
              return 231;
            }
            return Math.round((red - 8) / 247 * 24) + 232;
          }
          return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
        },
        enumerable: false
      },
      hexToRgb: {
        value: (hex2) => {
          const matches2 = /(?<colorString>[a-f\d]{6}|[a-f\d]{3})/i.exec(hex2.toString(16));
          if (!matches2) {
            return [0, 0, 0];
          }
          let { colorString } = matches2.groups;
          if (colorString.length === 3) {
            colorString = colorString.split("").map((character2) => character2 + character2).join("");
          }
          const integer = Number.parseInt(colorString, 16);
          return [
            integer >> 16 & 255,
            integer >> 8 & 255,
            integer & 255
          ];
        },
        enumerable: false
      },
      hexToAnsi256: {
        value: (hex2) => styles2.rgbToAnsi256(...styles2.hexToRgb(hex2)),
        enumerable: false
      }
    });
    return styles2;
  }
  Object.defineProperty(module2, "exports", {
    enumerable: true,
    get: assembleStyles
  });
})(ansiStyles);
var ansiStylesExports = ansiStyles.exports;
var collections = {};
Object.defineProperty(collections, "__esModule", {
  value: true
});
collections.printIteratorEntries = printIteratorEntries;
collections.printIteratorValues = printIteratorValues;
collections.printListItems = printListItems;
collections.printObjectProperties = printObjectProperties;
const getKeysOfEnumerableProperties = (object2, compareKeys) => {
  const keys8 = Object.keys(object2).sort(compareKeys);
  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(object2).forEach((symbol) => {
      if (Object.getOwnPropertyDescriptor(object2, symbol).enumerable) {
        keys8.push(symbol);
      }
    });
  }
  return keys8;
};
function printIteratorEntries(iterator, config2, indentation, depth, refs, printer2, separator = ": ") {
  let result = "";
  let current = iterator.next();
  if (!current.done) {
    result += config2.spacingOuter;
    const indentationNext = indentation + config2.indent;
    while (!current.done) {
      const name2 = printer2(
        current.value[0],
        config2,
        indentationNext,
        depth,
        refs
      );
      const value = printer2(
        current.value[1],
        config2,
        indentationNext,
        depth,
        refs
      );
      result += indentationNext + name2 + separator + value;
      current = iterator.next();
      if (!current.done) {
        result += "," + config2.spacingInner;
      } else if (!config2.min) {
        result += ",";
      }
    }
    result += config2.spacingOuter + indentation;
  }
  return result;
}
function printIteratorValues(iterator, config2, indentation, depth, refs, printer2) {
  let result = "";
  let current = iterator.next();
  if (!current.done) {
    result += config2.spacingOuter;
    const indentationNext = indentation + config2.indent;
    while (!current.done) {
      result += indentationNext + printer2(current.value, config2, indentationNext, depth, refs);
      current = iterator.next();
      if (!current.done) {
        result += "," + config2.spacingInner;
      } else if (!config2.min) {
        result += ",";
      }
    }
    result += config2.spacingOuter + indentation;
  }
  return result;
}
function printListItems(list, config2, indentation, depth, refs, printer2) {
  let result = "";
  if (list.length) {
    result += config2.spacingOuter;
    const indentationNext = indentation + config2.indent;
    for (let i2 = 0; i2 < list.length; i2++) {
      result += indentationNext;
      if (i2 in list) {
        result += printer2(list[i2], config2, indentationNext, depth, refs);
      }
      if (i2 < list.length - 1) {
        result += "," + config2.spacingInner;
      } else if (!config2.min) {
        result += ",";
      }
    }
    result += config2.spacingOuter + indentation;
  }
  return result;
}
function printObjectProperties(val, config2, indentation, depth, refs, printer2) {
  let result = "";
  const keys8 = getKeysOfEnumerableProperties(val, config2.compareKeys);
  if (keys8.length) {
    result += config2.spacingOuter;
    const indentationNext = indentation + config2.indent;
    for (let i2 = 0; i2 < keys8.length; i2++) {
      const key = keys8[i2];
      const name2 = printer2(key, config2, indentationNext, depth, refs);
      const value = printer2(val[key], config2, indentationNext, depth, refs);
      result += indentationNext + name2 + ": " + value;
      if (i2 < keys8.length - 1) {
        result += "," + config2.spacingInner;
      } else if (!config2.min) {
        result += ",";
      }
    }
    result += config2.spacingOuter + indentation;
  }
  return result;
}
var AsymmetricMatcher = {};
Object.defineProperty(AsymmetricMatcher, "__esModule", {
  value: true
});
AsymmetricMatcher.test = AsymmetricMatcher.serialize = AsymmetricMatcher.default = void 0;
var _collections$3 = collections;
var global$2 = function() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  } else if (typeof global$2 !== "undefined") {
    return global$2;
  } else if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
}();
var Symbol$9 = global$2["jest-symbol-do-not-touch"] || global$2.Symbol;
const asymmetricMatcher = typeof Symbol$9 === "function" && Symbol$9.for ? Symbol$9.for("jest.asymmetricMatcher") : 1267621;
const SPACE$2 = " ";
const serialize$6 = (val, config2, indentation, depth, refs, printer2) => {
  const stringedValue = val.toString();
  if (stringedValue === "ArrayContaining" || stringedValue === "ArrayNotContaining") {
    if (++depth > config2.maxDepth) {
      return "[" + stringedValue + "]";
    }
    return stringedValue + SPACE$2 + "[" + (0, _collections$3.printListItems)(
      val.sample,
      config2,
      indentation,
      depth,
      refs,
      printer2
    ) + "]";
  }
  if (stringedValue === "ObjectContaining" || stringedValue === "ObjectNotContaining") {
    if (++depth > config2.maxDepth) {
      return "[" + stringedValue + "]";
    }
    return stringedValue + SPACE$2 + "{" + (0, _collections$3.printObjectProperties)(
      val.sample,
      config2,
      indentation,
      depth,
      refs,
      printer2
    ) + "}";
  }
  if (stringedValue === "StringMatching" || stringedValue === "StringNotMatching") {
    return stringedValue + SPACE$2 + printer2(val.sample, config2, indentation, depth, refs);
  }
  if (stringedValue === "StringContaining" || stringedValue === "StringNotContaining") {
    return stringedValue + SPACE$2 + printer2(val.sample, config2, indentation, depth, refs);
  }
  return val.toAsymmetricMatcher();
};
AsymmetricMatcher.serialize = serialize$6;
const test$7 = (val) => val && val.$$typeof === asymmetricMatcher;
AsymmetricMatcher.test = test$7;
const plugin$6 = {
  serialize: serialize$6,
  test: test$7
};
var _default$2p = plugin$6;
AsymmetricMatcher.default = _default$2p;
var ConvertAnsi = {};
var ansiRegex = ({ onlyFirst = false } = {}) => {
  const pattern = [
    "[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)",
    "(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"
  ].join("|");
  return new RegExp(pattern, onlyFirst ? void 0 : "g");
};
Object.defineProperty(ConvertAnsi, "__esModule", {
  value: true
});
ConvertAnsi.test = ConvertAnsi.serialize = ConvertAnsi.default = void 0;
var _ansiRegex = _interopRequireDefault$d(ansiRegex);
var _ansiStyles$1 = _interopRequireDefault$d(ansiStylesExports);
function _interopRequireDefault$d(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const toHumanReadableAnsi = (text2) => text2.replace((0, _ansiRegex.default)(), (match2) => {
  switch (match2) {
    case _ansiStyles$1.default.red.close:
    case _ansiStyles$1.default.green.close:
    case _ansiStyles$1.default.cyan.close:
    case _ansiStyles$1.default.gray.close:
    case _ansiStyles$1.default.white.close:
    case _ansiStyles$1.default.yellow.close:
    case _ansiStyles$1.default.bgRed.close:
    case _ansiStyles$1.default.bgGreen.close:
    case _ansiStyles$1.default.bgYellow.close:
    case _ansiStyles$1.default.inverse.close:
    case _ansiStyles$1.default.dim.close:
    case _ansiStyles$1.default.bold.close:
    case _ansiStyles$1.default.reset.open:
    case _ansiStyles$1.default.reset.close:
      return "</>";
    case _ansiStyles$1.default.red.open:
      return "<red>";
    case _ansiStyles$1.default.green.open:
      return "<green>";
    case _ansiStyles$1.default.cyan.open:
      return "<cyan>";
    case _ansiStyles$1.default.gray.open:
      return "<gray>";
    case _ansiStyles$1.default.white.open:
      return "<white>";
    case _ansiStyles$1.default.yellow.open:
      return "<yellow>";
    case _ansiStyles$1.default.bgRed.open:
      return "<bgRed>";
    case _ansiStyles$1.default.bgGreen.open:
      return "<bgGreen>";
    case _ansiStyles$1.default.bgYellow.open:
      return "<bgYellow>";
    case _ansiStyles$1.default.inverse.open:
      return "<inverse>";
    case _ansiStyles$1.default.dim.open:
      return "<dim>";
    case _ansiStyles$1.default.bold.open:
      return "<bold>";
    default:
      return "";
  }
});
const test$6 = (val) => typeof val === "string" && !!val.match((0, _ansiRegex.default)());
ConvertAnsi.test = test$6;
const serialize$5 = (val, config2, indentation, depth, refs, printer2) => printer2(toHumanReadableAnsi(val), config2, indentation, depth, refs);
ConvertAnsi.serialize = serialize$5;
const plugin$5 = {
  serialize: serialize$5,
  test: test$6
};
var _default$2o = plugin$5;
ConvertAnsi.default = _default$2o;
var DOMCollection$2 = {};
Object.defineProperty(DOMCollection$2, "__esModule", {
  value: true
});
DOMCollection$2.test = DOMCollection$2.serialize = DOMCollection$2.default = void 0;
var _collections$2 = collections;
const SPACE$1 = " ";
const OBJECT_NAMES = ["DOMStringMap", "NamedNodeMap"];
const ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;
const testName = (name2) => OBJECT_NAMES.indexOf(name2) !== -1 || ARRAY_REGEXP.test(name2);
const test$5 = (val) => val && val.constructor && !!val.constructor.name && testName(val.constructor.name);
DOMCollection$2.test = test$5;
const isNamedNodeMap = (collection) => collection.constructor.name === "NamedNodeMap";
const serialize$4 = (collection, config2, indentation, depth, refs, printer2) => {
  const name2 = collection.constructor.name;
  if (++depth > config2.maxDepth) {
    return "[" + name2 + "]";
  }
  return (config2.min ? "" : name2 + SPACE$1) + (OBJECT_NAMES.indexOf(name2) !== -1 ? "{" + (0, _collections$2.printObjectProperties)(
    isNamedNodeMap(collection) ? Array.from(collection).reduce((props2, attribute) => {
      props2[attribute.name] = attribute.value;
      return props2;
    }, {}) : { ...collection },
    config2,
    indentation,
    depth,
    refs,
    printer2
  ) + "}" : "[" + (0, _collections$2.printListItems)(
    Array.from(collection),
    config2,
    indentation,
    depth,
    refs,
    printer2
  ) + "]");
};
DOMCollection$2.serialize = serialize$4;
const plugin$4 = {
  serialize: serialize$4,
  test: test$5
};
var _default$2n = plugin$4;
DOMCollection$2.default = _default$2n;
var DOMElement = {};
var markup = {};
var escapeHTML$3 = {};
Object.defineProperty(escapeHTML$3, "__esModule", {
  value: true
});
escapeHTML$3.default = escapeHTML$2;
function escapeHTML$2(str) {
  return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
Object.defineProperty(markup, "__esModule", {
  value: true
});
markup.printText = markup.printProps = markup.printElementAsLeaf = markup.printElement = markup.printComment = markup.printChildren = void 0;
var _escapeHTML = _interopRequireDefault$c(escapeHTML$3);
function _interopRequireDefault$c(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const printProps$2 = (keys8, props2, config2, indentation, depth, refs, printer2) => {
  const indentationNext = indentation + config2.indent;
  const colors3 = config2.colors;
  return keys8.map((key) => {
    const value = props2[key];
    let printed = printer2(value, config2, indentationNext, depth, refs);
    if (typeof value !== "string") {
      if (printed.indexOf("\n") !== -1) {
        printed = config2.spacingOuter + indentationNext + printed + config2.spacingOuter + indentation;
      }
      printed = "{" + printed + "}";
    }
    return config2.spacingInner + indentation + colors3.prop.open + key + colors3.prop.close + "=" + colors3.value.open + printed + colors3.value.close;
  }).join("");
};
markup.printProps = printProps$2;
const printChildren$2 = (children2, config2, indentation, depth, refs, printer2) => children2.map(
  (child) => config2.spacingOuter + indentation + (typeof child === "string" ? printText$2(child, config2) : printer2(child, config2, indentation, depth, refs))
).join("");
markup.printChildren = printChildren$2;
const printText$2 = (text2, config2) => {
  const contentColor = config2.colors.content;
  return contentColor.open + (0, _escapeHTML.default)(text2) + contentColor.close;
};
markup.printText = printText$2;
const printComment$2 = (comment2, config2) => {
  const commentColor = config2.colors.comment;
  return commentColor.open + "<!--" + (0, _escapeHTML.default)(comment2) + "-->" + commentColor.close;
};
markup.printComment = printComment$2;
const printElement$2 = (type2, printedProps, printedChildren, config2, indentation) => {
  const tagColor = config2.colors.tag;
  return tagColor.open + "<" + type2 + (printedProps && tagColor.close + printedProps + config2.spacingOuter + indentation + tagColor.open) + (printedChildren ? ">" + tagColor.close + printedChildren + config2.spacingOuter + indentation + tagColor.open + "</" + type2 : (printedProps && !config2.min ? "" : " ") + "/") + ">" + tagColor.close;
};
markup.printElement = printElement$2;
const printElementAsLeaf$2 = (type2, config2) => {
  const tagColor = config2.colors.tag;
  return tagColor.open + "<" + type2 + tagColor.close + " …" + tagColor.open + " />" + tagColor.close;
};
markup.printElementAsLeaf = printElementAsLeaf$2;
Object.defineProperty(DOMElement, "__esModule", {
  value: true
});
DOMElement.test = DOMElement.serialize = DOMElement.default = void 0;
var _markup$2 = markup;
const ELEMENT_NODE$3 = 1;
const TEXT_NODE$3 = 3;
const COMMENT_NODE$3 = 8;
const FRAGMENT_NODE$2 = 11;
const ELEMENT_REGEXP$2 = /^((HTML|SVG)\w*)?Element$/;
const testHasAttribute = (val) => {
  try {
    return typeof val.hasAttribute === "function" && val.hasAttribute("is");
  } catch {
    return false;
  }
};
const testNode$2 = (val) => {
  const constructorName = val.constructor.name;
  const { nodeType, tagName } = val;
  const isCustomElement = typeof tagName === "string" && tagName.includes("-") || testHasAttribute(val);
  return nodeType === ELEMENT_NODE$3 && (ELEMENT_REGEXP$2.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$3 && constructorName === "Text" || nodeType === COMMENT_NODE$3 && constructorName === "Comment" || nodeType === FRAGMENT_NODE$2 && constructorName === "DocumentFragment";
};
const test$4 = (val) => {
  var _val$constructor;
  return (val === null || val === void 0 ? void 0 : (_val$constructor = val.constructor) === null || _val$constructor === void 0 ? void 0 : _val$constructor.name) && testNode$2(val);
};
DOMElement.test = test$4;
function nodeIsText$2(node2) {
  return node2.nodeType === TEXT_NODE$3;
}
function nodeIsComment$2(node2) {
  return node2.nodeType === COMMENT_NODE$3;
}
function nodeIsFragment$2(node2) {
  return node2.nodeType === FRAGMENT_NODE$2;
}
const serialize$3 = (node2, config2, indentation, depth, refs, printer2) => {
  if (nodeIsText$2(node2)) {
    return (0, _markup$2.printText)(node2.data, config2);
  }
  if (nodeIsComment$2(node2)) {
    return (0, _markup$2.printComment)(node2.data, config2);
  }
  const type2 = nodeIsFragment$2(node2) ? "DocumentFragment" : node2.tagName.toLowerCase();
  if (++depth > config2.maxDepth) {
    return (0, _markup$2.printElementAsLeaf)(type2, config2);
  }
  return (0, _markup$2.printElement)(
    type2,
    (0, _markup$2.printProps)(
      nodeIsFragment$2(node2) ? [] : Array.from(node2.attributes).map((attr) => attr.name).sort(),
      nodeIsFragment$2(node2) ? {} : Array.from(node2.attributes).reduce((props2, attribute) => {
        props2[attribute.name] = attribute.value;
        return props2;
      }, {}),
      config2,
      indentation + config2.indent,
      depth,
      refs,
      printer2
    ),
    (0, _markup$2.printChildren)(
      Array.prototype.slice.call(node2.childNodes || node2.children),
      config2,
      indentation + config2.indent,
      depth,
      refs,
      printer2
    ),
    config2,
    indentation
  );
};
DOMElement.serialize = serialize$3;
const plugin$3 = {
  serialize: serialize$3,
  test: test$4
};
var _default$2m = plugin$3;
DOMElement.default = _default$2m;
var Immutable = {};
Object.defineProperty(Immutable, "__esModule", {
  value: true
});
Immutable.test = Immutable.serialize = Immutable.default = void 0;
var _collections$1 = collections;
const IS_ITERABLE_SENTINEL = "@@__IMMUTABLE_ITERABLE__@@";
const IS_LIST_SENTINEL = "@@__IMMUTABLE_LIST__@@";
const IS_KEYED_SENTINEL = "@@__IMMUTABLE_KEYED__@@";
const IS_MAP_SENTINEL = "@@__IMMUTABLE_MAP__@@";
const IS_ORDERED_SENTINEL = "@@__IMMUTABLE_ORDERED__@@";
const IS_RECORD_SENTINEL = "@@__IMMUTABLE_RECORD__@@";
const IS_SEQ_SENTINEL = "@@__IMMUTABLE_SEQ__@@";
const IS_SET_SENTINEL = "@@__IMMUTABLE_SET__@@";
const IS_STACK_SENTINEL = "@@__IMMUTABLE_STACK__@@";
const getImmutableName = (name2) => "Immutable." + name2;
const printAsLeaf = (name2) => "[" + name2 + "]";
const SPACE = " ";
const LAZY = "…";
const printImmutableEntries = (val, config2, indentation, depth, refs, printer2, type2) => ++depth > config2.maxDepth ? printAsLeaf(getImmutableName(type2)) : getImmutableName(type2) + SPACE + "{" + (0, _collections$1.printIteratorEntries)(
  val.entries(),
  config2,
  indentation,
  depth,
  refs,
  printer2
) + "}";
function getRecordEntries(val) {
  let i2 = 0;
  return {
    next() {
      if (i2 < val._keys.length) {
        const key = val._keys[i2++];
        return {
          done: false,
          value: [key, val.get(key)]
        };
      }
      return {
        done: true,
        value: void 0
      };
    }
  };
}
const printImmutableRecord = (val, config2, indentation, depth, refs, printer2) => {
  const name2 = getImmutableName(val._name || "Record");
  return ++depth > config2.maxDepth ? printAsLeaf(name2) : name2 + SPACE + "{" + (0, _collections$1.printIteratorEntries)(
    getRecordEntries(val),
    config2,
    indentation,
    depth,
    refs,
    printer2
  ) + "}";
};
const printImmutableSeq = (val, config2, indentation, depth, refs, printer2) => {
  const name2 = getImmutableName("Seq");
  if (++depth > config2.maxDepth) {
    return printAsLeaf(name2);
  }
  if (val[IS_KEYED_SENTINEL]) {
    return name2 + SPACE + "{" + // from Immutable collection of entries or from ECMAScript object
    (val._iter || val._object ? (0, _collections$1.printIteratorEntries)(
      val.entries(),
      config2,
      indentation,
      depth,
      refs,
      printer2
    ) : LAZY) + "}";
  }
  return name2 + SPACE + "[" + (val._iter || // from Immutable collection of values
  val._array || // from ECMAScript array
  val._collection || // from ECMAScript collection in immutable v4
  val._iterable ? (0, _collections$1.printIteratorValues)(
    val.values(),
    config2,
    indentation,
    depth,
    refs,
    printer2
  ) : LAZY) + "]";
};
const printImmutableValues = (val, config2, indentation, depth, refs, printer2, type2) => ++depth > config2.maxDepth ? printAsLeaf(getImmutableName(type2)) : getImmutableName(type2) + SPACE + "[" + (0, _collections$1.printIteratorValues)(
  val.values(),
  config2,
  indentation,
  depth,
  refs,
  printer2
) + "]";
const serialize$2 = (val, config2, indentation, depth, refs, printer2) => {
  if (val[IS_MAP_SENTINEL]) {
    return printImmutableEntries(
      val,
      config2,
      indentation,
      depth,
      refs,
      printer2,
      val[IS_ORDERED_SENTINEL] ? "OrderedMap" : "Map"
    );
  }
  if (val[IS_LIST_SENTINEL]) {
    return printImmutableValues(
      val,
      config2,
      indentation,
      depth,
      refs,
      printer2,
      "List"
    );
  }
  if (val[IS_SET_SENTINEL]) {
    return printImmutableValues(
      val,
      config2,
      indentation,
      depth,
      refs,
      printer2,
      val[IS_ORDERED_SENTINEL] ? "OrderedSet" : "Set"
    );
  }
  if (val[IS_STACK_SENTINEL]) {
    return printImmutableValues(
      val,
      config2,
      indentation,
      depth,
      refs,
      printer2,
      "Stack"
    );
  }
  if (val[IS_SEQ_SENTINEL]) {
    return printImmutableSeq(val, config2, indentation, depth, refs, printer2);
  }
  return printImmutableRecord(val, config2, indentation, depth, refs, printer2);
};
Immutable.serialize = serialize$2;
const test$3 = (val) => val && (val[IS_ITERABLE_SENTINEL] === true || val[IS_RECORD_SENTINEL] === true);
Immutable.test = test$3;
const plugin$2 = {
  serialize: serialize$2,
  test: test$3
};
var _default$2l = plugin$2;
Immutable.default = _default$2l;
var ReactElement = {};
var reactIs$1 = { exports: {} };
var reactIs_production_min$1 = {};
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1)
    return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var b10 = 60103, c7 = 60106, d3 = 60107, e3 = 60108, f = 60114, g2 = 60109, h3 = 60110, k3 = 60112, l = 60113, m3 = 60120, n = 60115, p = 60116, q2 = 60121, r = 60122, u2 = 60117, v = 60129, w2 = 60131;
  if ("function" === typeof Symbol && Symbol.for) {
    var x3 = Symbol.for;
    b10 = x3("react.element");
    c7 = x3("react.portal");
    d3 = x3("react.fragment");
    e3 = x3("react.strict_mode");
    f = x3("react.profiler");
    g2 = x3("react.provider");
    h3 = x3("react.context");
    k3 = x3("react.forward_ref");
    l = x3("react.suspense");
    m3 = x3("react.suspense_list");
    n = x3("react.memo");
    p = x3("react.lazy");
    q2 = x3("react.block");
    r = x3("react.server.block");
    u2 = x3("react.fundamental");
    v = x3("react.debug_trace_mode");
    w2 = x3("react.legacy_hidden");
  }
  function y4(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var t2 = a4.$$typeof;
      switch (t2) {
        case b10:
          switch (a4 = a4.type, a4) {
            case d3:
            case f:
            case e3:
            case l:
            case m3:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case h3:
                case k3:
                case p:
                case n:
                case g2:
                  return a4;
                default:
                  return t2;
              }
          }
        case c7:
          return t2;
      }
    }
  }
  var z2 = g2, A = b10, B2 = k3, C = d3, D2 = p, E2 = n, F = c7, G2 = f, H3 = e3, I2 = l;
  reactIs_production_min$1.ContextConsumer = h3;
  reactIs_production_min$1.ContextProvider = z2;
  reactIs_production_min$1.Element = A;
  reactIs_production_min$1.ForwardRef = B2;
  reactIs_production_min$1.Fragment = C;
  reactIs_production_min$1.Lazy = D2;
  reactIs_production_min$1.Memo = E2;
  reactIs_production_min$1.Portal = F;
  reactIs_production_min$1.Profiler = G2;
  reactIs_production_min$1.StrictMode = H3;
  reactIs_production_min$1.Suspense = I2;
  reactIs_production_min$1.isAsyncMode = function() {
    return false;
  };
  reactIs_production_min$1.isConcurrentMode = function() {
    return false;
  };
  reactIs_production_min$1.isContextConsumer = function(a4) {
    return y4(a4) === h3;
  };
  reactIs_production_min$1.isContextProvider = function(a4) {
    return y4(a4) === g2;
  };
  reactIs_production_min$1.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === b10;
  };
  reactIs_production_min$1.isForwardRef = function(a4) {
    return y4(a4) === k3;
  };
  reactIs_production_min$1.isFragment = function(a4) {
    return y4(a4) === d3;
  };
  reactIs_production_min$1.isLazy = function(a4) {
    return y4(a4) === p;
  };
  reactIs_production_min$1.isMemo = function(a4) {
    return y4(a4) === n;
  };
  reactIs_production_min$1.isPortal = function(a4) {
    return y4(a4) === c7;
  };
  reactIs_production_min$1.isProfiler = function(a4) {
    return y4(a4) === f;
  };
  reactIs_production_min$1.isStrictMode = function(a4) {
    return y4(a4) === e3;
  };
  reactIs_production_min$1.isSuspense = function(a4) {
    return y4(a4) === l;
  };
  reactIs_production_min$1.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === d3 || a4 === f || a4 === v || a4 === e3 || a4 === l || a4 === m3 || a4 === w2 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === p || a4.$$typeof === n || a4.$$typeof === g2 || a4.$$typeof === h3 || a4.$$typeof === k3 || a4.$$typeof === u2 || a4.$$typeof === q2 || a4[0] === r) ? true : false;
  };
  reactIs_production_min$1.typeOf = y4;
  return reactIs_production_min$1;
}
var reactIs_development$1 = {};
/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  if (hasRequiredReactIs_development$1)
    return reactIs_development$1;
  hasRequiredReactIs_development$1 = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var REACT_ELEMENT_TYPE2 = 60103;
      var REACT_PORTAL_TYPE = 60106;
      var REACT_FRAGMENT_TYPE = 60107;
      var REACT_STRICT_MODE_TYPE = 60108;
      var REACT_PROFILER_TYPE = 60114;
      var REACT_PROVIDER_TYPE = 60109;
      var REACT_CONTEXT_TYPE = 60110;
      var REACT_FORWARD_REF_TYPE = 60112;
      var REACT_SUSPENSE_TYPE = 60113;
      var REACT_SUSPENSE_LIST_TYPE = 60120;
      var REACT_MEMO_TYPE = 60115;
      var REACT_LAZY_TYPE = 60116;
      var REACT_BLOCK_TYPE = 60121;
      var REACT_SERVER_BLOCK_TYPE = 60122;
      var REACT_FUNDAMENTAL_TYPE = 60117;
      var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
      var REACT_LEGACY_HIDDEN_TYPE = 60131;
      if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE2 = symbolFor("react.element");
        REACT_PORTAL_TYPE = symbolFor("react.portal");
        REACT_FRAGMENT_TYPE = symbolFor("react.fragment");
        REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
        REACT_PROFILER_TYPE = symbolFor("react.profiler");
        REACT_PROVIDER_TYPE = symbolFor("react.provider");
        REACT_CONTEXT_TYPE = symbolFor("react.context");
        REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
        REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
        REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
        REACT_MEMO_TYPE = symbolFor("react.memo");
        REACT_LAZY_TYPE = symbolFor("react.lazy");
        REACT_BLOCK_TYPE = symbolFor("react.block");
        REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
        REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
        symbolFor("react.scope");
        symbolFor("react.opaque.id");
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
        symbolFor("react.offscreen");
        REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
      }
      var enableScopeAPI = false;
      function isValidElementType(type2) {
        if (typeof type2 === "string" || typeof type2 === "function") {
          return true;
        }
        if (type2 === REACT_FRAGMENT_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_DEBUG_TRACING_MODE_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || type2 === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
          return true;
        }
        if (typeof type2 === "object" && type2 !== null) {
          if (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_BLOCK_TYPE || type2[0] === REACT_SERVER_BLOCK_TYPE) {
            return true;
          }
        }
        return false;
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE2:
              var type2 = object2.type;
              switch (type2) {
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                case REACT_SUSPENSE_LIST_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE2;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      var hasWarnedAboutDeprecatedIsConcurrentMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isConcurrentMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true;
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
          }
        }
        return false;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE2;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development$1.ContextConsumer = ContextConsumer;
      reactIs_development$1.ContextProvider = ContextProvider;
      reactIs_development$1.Element = Element2;
      reactIs_development$1.ForwardRef = ForwardRef;
      reactIs_development$1.Fragment = Fragment2;
      reactIs_development$1.Lazy = Lazy;
      reactIs_development$1.Memo = Memo;
      reactIs_development$1.Portal = Portal2;
      reactIs_development$1.Profiler = Profiler;
      reactIs_development$1.StrictMode = StrictMode;
      reactIs_development$1.Suspense = Suspense;
      reactIs_development$1.isAsyncMode = isAsyncMode;
      reactIs_development$1.isConcurrentMode = isConcurrentMode;
      reactIs_development$1.isContextConsumer = isContextConsumer;
      reactIs_development$1.isContextProvider = isContextProvider;
      reactIs_development$1.isElement = isElement2;
      reactIs_development$1.isForwardRef = isForwardRef;
      reactIs_development$1.isFragment = isFragment;
      reactIs_development$1.isLazy = isLazy;
      reactIs_development$1.isMemo = isMemo;
      reactIs_development$1.isPortal = isPortal;
      reactIs_development$1.isProfiler = isProfiler;
      reactIs_development$1.isStrictMode = isStrictMode;
      reactIs_development$1.isSuspense = isSuspense;
      reactIs_development$1.isValidElementType = isValidElementType;
      reactIs_development$1.typeOf = typeOf;
    })();
  }
  return reactIs_development$1;
}
if (process.env.NODE_ENV === "production") {
  reactIs$1.exports = requireReactIs_production_min$1();
} else {
  reactIs$1.exports = requireReactIs_development$1();
}
var reactIsExports = reactIs$1.exports;
Object.defineProperty(ReactElement, "__esModule", {
  value: true
});
ReactElement.test = ReactElement.serialize = ReactElement.default = void 0;
var ReactIs$1 = _interopRequireWildcard(reactIsExports);
var _markup$1 = markup;
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function")
    return null;
  var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
  var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
  return (_getRequireWildcardCache = function(nodeInterop2) {
    return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return { default: obj };
  }
  var cache2 = _getRequireWildcardCache(nodeInterop);
  if (cache2 && cache2.has(obj)) {
    return cache2.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache2) {
    cache2.set(obj, newObj);
  }
  return newObj;
}
const getChildren$2 = (arg, children2 = []) => {
  if (Array.isArray(arg)) {
    arg.forEach((item) => {
      getChildren$2(item, children2);
    });
  } else if (arg != null && arg !== false) {
    children2.push(arg);
  }
  return children2;
};
const getType$1 = (element) => {
  const type2 = element.type;
  if (typeof type2 === "string") {
    return type2;
  }
  if (typeof type2 === "function") {
    return type2.displayName || type2.name || "Unknown";
  }
  if (ReactIs$1.isFragment(element)) {
    return "React.Fragment";
  }
  if (ReactIs$1.isSuspense(element)) {
    return "React.Suspense";
  }
  if (typeof type2 === "object" && type2 !== null) {
    if (ReactIs$1.isContextProvider(element)) {
      return "Context.Provider";
    }
    if (ReactIs$1.isContextConsumer(element)) {
      return "Context.Consumer";
    }
    if (ReactIs$1.isForwardRef(element)) {
      if (type2.displayName) {
        return type2.displayName;
      }
      const functionName = type2.render.displayName || type2.render.name || "";
      return functionName !== "" ? "ForwardRef(" + functionName + ")" : "ForwardRef";
    }
    if (ReactIs$1.isMemo(element)) {
      const functionName = type2.displayName || type2.type.displayName || type2.type.name || "";
      return functionName !== "" ? "Memo(" + functionName + ")" : "Memo";
    }
  }
  return "UNDEFINED";
};
const getPropKeys$1 = (element) => {
  const { props: props2 } = element;
  return Object.keys(props2).filter((key) => key !== "children" && props2[key] !== void 0).sort();
};
const serialize$1 = (element, config2, indentation, depth, refs, printer2) => ++depth > config2.maxDepth ? (0, _markup$1.printElementAsLeaf)(getType$1(element), config2) : (0, _markup$1.printElement)(
  getType$1(element),
  (0, _markup$1.printProps)(
    getPropKeys$1(element),
    element.props,
    config2,
    indentation + config2.indent,
    depth,
    refs,
    printer2
  ),
  (0, _markup$1.printChildren)(
    getChildren$2(element.props.children),
    config2,
    indentation + config2.indent,
    depth,
    refs,
    printer2
  ),
  config2,
  indentation
);
ReactElement.serialize = serialize$1;
const test$2 = (val) => val != null && ReactIs$1.isElement(val);
ReactElement.test = test$2;
const plugin$1 = {
  serialize: serialize$1,
  test: test$2
};
var _default$2k = plugin$1;
ReactElement.default = _default$2k;
var ReactTestComponent = {};
Object.defineProperty(ReactTestComponent, "__esModule", {
  value: true
});
ReactTestComponent.test = ReactTestComponent.serialize = ReactTestComponent.default = void 0;
var _markup = markup;
var global$1 = function() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  } else if (typeof global$1 !== "undefined") {
    return global$1;
  } else if (typeof self !== "undefined") {
    return self;
  } else if (typeof window !== "undefined") {
    return window;
  } else {
    return Function("return this")();
  }
}();
var Symbol$8 = global$1["jest-symbol-do-not-touch"] || global$1.Symbol;
const testSymbol = typeof Symbol$8 === "function" && Symbol$8.for ? Symbol$8.for("react.test.json") : 245830487;
const getPropKeys = (object2) => {
  const { props: props2 } = object2;
  return props2 ? Object.keys(props2).filter((key) => props2[key] !== void 0).sort() : [];
};
const serialize = (object2, config2, indentation, depth, refs, printer2) => ++depth > config2.maxDepth ? (0, _markup.printElementAsLeaf)(object2.type, config2) : (0, _markup.printElement)(
  object2.type,
  object2.props ? (0, _markup.printProps)(
    getPropKeys(object2),
    object2.props,
    config2,
    indentation + config2.indent,
    depth,
    refs,
    printer2
  ) : "",
  object2.children ? (0, _markup.printChildren)(
    object2.children,
    config2,
    indentation + config2.indent,
    depth,
    refs,
    printer2
  ) : "",
  config2,
  indentation
);
ReactTestComponent.serialize = serialize;
const test$1 = (val) => val && val.$$typeof === testSymbol;
ReactTestComponent.test = test$1;
const plugin = {
  serialize,
  test: test$1
};
var _default$2j = plugin;
ReactTestComponent.default = _default$2j;
Object.defineProperty(build, "__esModule", {
  value: true
});
build.default = build.DEFAULT_OPTIONS = void 0;
var format_1 = build.format = format$3;
var plugins_1 = build.plugins = void 0;
var _ansiStyles = _interopRequireDefault$b(ansiStylesExports);
var _collections = collections;
var _AsymmetricMatcher = _interopRequireDefault$b(
  AsymmetricMatcher
);
var _ConvertAnsi = _interopRequireDefault$b(ConvertAnsi);
var _DOMCollection = _interopRequireDefault$b(DOMCollection$2);
var _DOMElement = _interopRequireDefault$b(DOMElement);
var _Immutable = _interopRequireDefault$b(Immutable);
var _ReactElement = _interopRequireDefault$b(ReactElement);
var _ReactTestComponent = _interopRequireDefault$b(
  ReactTestComponent
);
function _interopRequireDefault$b(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
const toString$6 = Object.prototype.toString;
const toISOString = Date.prototype.toISOString;
const errorToString$1 = Error.prototype.toString;
const regExpToString$1 = RegExp.prototype.toString;
const getConstructorName = (val) => typeof val.constructor === "function" && val.constructor.name || "Object";
const isWindow = (val) => typeof window !== "undefined" && val === window;
const SYMBOL_REGEXP$1 = /^Symbol\((.*)\)(.*)$/;
const NEWLINE_REGEXP = /\n/gi;
class PrettyFormatPluginError extends Error {
  constructor(message, stack2) {
    super(message);
    this.stack = stack2;
    this.name = this.constructor.name;
  }
}
function isToStringedArrayType(toStringed) {
  return toStringed === "[object Array]" || toStringed === "[object ArrayBuffer]" || toStringed === "[object DataView]" || toStringed === "[object Float32Array]" || toStringed === "[object Float64Array]" || toStringed === "[object Int8Array]" || toStringed === "[object Int16Array]" || toStringed === "[object Int32Array]" || toStringed === "[object Uint8Array]" || toStringed === "[object Uint8ClampedArray]" || toStringed === "[object Uint16Array]" || toStringed === "[object Uint32Array]";
}
function printNumber$1(val) {
  return Object.is(val, -0) ? "-0" : String(val);
}
function printBigInt(val) {
  return String(`${val}n`);
}
function printFunction(val, printFunctionName) {
  if (!printFunctionName) {
    return "[Function]";
  }
  return "[Function " + (val.name || "anonymous") + "]";
}
function printSymbol(val) {
  return String(val).replace(SYMBOL_REGEXP$1, "Symbol($1)");
}
function printError(val) {
  return "[" + errorToString$1.call(val) + "]";
}
function printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
  if (val === true || val === false) {
    return "" + val;
  }
  if (val === void 0) {
    return "undefined";
  }
  if (val === null) {
    return "null";
  }
  const typeOf = typeof val;
  if (typeOf === "number") {
    return printNumber$1(val);
  }
  if (typeOf === "bigint") {
    return printBigInt(val);
  }
  if (typeOf === "string") {
    if (escapeString) {
      return '"' + val.replace(/"|\\/g, "\\$&") + '"';
    }
    return '"' + val + '"';
  }
  if (typeOf === "function") {
    return printFunction(val, printFunctionName);
  }
  if (typeOf === "symbol") {
    return printSymbol(val);
  }
  const toStringed = toString$6.call(val);
  if (toStringed === "[object WeakMap]") {
    return "WeakMap {}";
  }
  if (toStringed === "[object WeakSet]") {
    return "WeakSet {}";
  }
  if (toStringed === "[object Function]" || toStringed === "[object GeneratorFunction]") {
    return printFunction(val, printFunctionName);
  }
  if (toStringed === "[object Symbol]") {
    return printSymbol(val);
  }
  if (toStringed === "[object Date]") {
    return isNaN(+val) ? "Date { NaN }" : toISOString.call(val);
  }
  if (toStringed === "[object Error]") {
    return printError(val);
  }
  if (toStringed === "[object RegExp]") {
    if (escapeRegex) {
      return regExpToString$1.call(val).replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    return regExpToString$1.call(val);
  }
  if (val instanceof Error) {
    return printError(val);
  }
  return null;
}
function printComplexValue(val, config2, indentation, depth, refs, hasCalledToJSON) {
  if (refs.indexOf(val) !== -1) {
    return "[Circular]";
  }
  refs = refs.slice();
  refs.push(val);
  const hitMaxDepth = ++depth > config2.maxDepth;
  const min2 = config2.min;
  if (config2.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON === "function" && !hasCalledToJSON) {
    return printer(val.toJSON(), config2, indentation, depth, refs, true);
  }
  const toStringed = toString$6.call(val);
  if (toStringed === "[object Arguments]") {
    return hitMaxDepth ? "[Arguments]" : (min2 ? "" : "Arguments ") + "[" + (0, _collections.printListItems)(
      val,
      config2,
      indentation,
      depth,
      refs,
      printer
    ) + "]";
  }
  if (isToStringedArrayType(toStringed)) {
    return hitMaxDepth ? "[" + val.constructor.name + "]" : (min2 ? "" : !config2.printBasicPrototype && val.constructor.name === "Array" ? "" : val.constructor.name + " ") + "[" + (0, _collections.printListItems)(
      val,
      config2,
      indentation,
      depth,
      refs,
      printer
    ) + "]";
  }
  if (toStringed === "[object Map]") {
    return hitMaxDepth ? "[Map]" : "Map {" + (0, _collections.printIteratorEntries)(
      val.entries(),
      config2,
      indentation,
      depth,
      refs,
      printer,
      " => "
    ) + "}";
  }
  if (toStringed === "[object Set]") {
    return hitMaxDepth ? "[Set]" : "Set {" + (0, _collections.printIteratorValues)(
      val.values(),
      config2,
      indentation,
      depth,
      refs,
      printer
    ) + "}";
  }
  return hitMaxDepth || isWindow(val) ? "[" + getConstructorName(val) + "]" : (min2 ? "" : !config2.printBasicPrototype && getConstructorName(val) === "Object" ? "" : getConstructorName(val) + " ") + "{" + (0, _collections.printObjectProperties)(
    val,
    config2,
    indentation,
    depth,
    refs,
    printer
  ) + "}";
}
function isNewPlugin(plugin2) {
  return plugin2.serialize != null;
}
function printPlugin(plugin2, val, config2, indentation, depth, refs) {
  let printed;
  try {
    printed = isNewPlugin(plugin2) ? plugin2.serialize(val, config2, indentation, depth, refs, printer) : plugin2.print(
      val,
      (valChild) => printer(valChild, config2, indentation, depth, refs),
      (str) => {
        const indentationNext = indentation + config2.indent;
        return indentationNext + str.replace(NEWLINE_REGEXP, "\n" + indentationNext);
      },
      {
        edgeSpacing: config2.spacingOuter,
        min: config2.min,
        spacing: config2.spacingInner
      },
      config2.colors
    );
  } catch (error2) {
    throw new PrettyFormatPluginError(error2.message, error2.stack);
  }
  if (typeof printed !== "string") {
    throw new Error(
      `pretty-format: Plugin must return type "string" but instead returned "${typeof printed}".`
    );
  }
  return printed;
}
function findPlugin(plugins2, val) {
  for (let p = 0; p < plugins2.length; p++) {
    try {
      if (plugins2[p].test(val)) {
        return plugins2[p];
      }
    } catch (error2) {
      throw new PrettyFormatPluginError(error2.message, error2.stack);
    }
  }
  return null;
}
function printer(val, config2, indentation, depth, refs, hasCalledToJSON) {
  const plugin2 = findPlugin(config2.plugins, val);
  if (plugin2 !== null) {
    return printPlugin(plugin2, val, config2, indentation, depth, refs);
  }
  const basicResult = printBasicValue(
    val,
    config2.printFunctionName,
    config2.escapeRegex,
    config2.escapeString
  );
  if (basicResult !== null) {
    return basicResult;
  }
  return printComplexValue(
    val,
    config2,
    indentation,
    depth,
    refs,
    hasCalledToJSON
  );
}
const DEFAULT_THEME = {
  comment: "gray",
  content: "reset",
  prop: "yellow",
  tag: "cyan",
  value: "green"
};
const DEFAULT_THEME_KEYS = Object.keys(DEFAULT_THEME);
const DEFAULT_OPTIONS = {
  callToJSON: true,
  compareKeys: void 0,
  escapeRegex: false,
  escapeString: true,
  highlight: false,
  indent: 2,
  maxDepth: Infinity,
  min: false,
  plugins: [],
  printBasicPrototype: true,
  printFunctionName: true,
  theme: DEFAULT_THEME
};
build.DEFAULT_OPTIONS = DEFAULT_OPTIONS;
function validateOptions(options2) {
  Object.keys(options2).forEach((key) => {
    if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
      throw new Error(`pretty-format: Unknown option "${key}".`);
    }
  });
  if (options2.min && options2.indent !== void 0 && options2.indent !== 0) {
    throw new Error(
      'pretty-format: Options "min" and "indent" cannot be used together.'
    );
  }
  if (options2.theme !== void 0) {
    if (options2.theme === null) {
      throw new Error('pretty-format: Option "theme" must not be null.');
    }
    if (typeof options2.theme !== "object") {
      throw new Error(
        `pretty-format: Option "theme" must be of type "object" but instead received "${typeof options2.theme}".`
      );
    }
  }
}
const getColorsHighlight = (options2) => DEFAULT_THEME_KEYS.reduce((colors3, key) => {
  const value = options2.theme && options2.theme[key] !== void 0 ? options2.theme[key] : DEFAULT_THEME[key];
  const color2 = value && _ansiStyles.default[value];
  if (color2 && typeof color2.close === "string" && typeof color2.open === "string") {
    colors3[key] = color2;
  } else {
    throw new Error(
      `pretty-format: Option "theme" has a key "${key}" whose value "${value}" is undefined in ansi-styles.`
    );
  }
  return colors3;
}, /* @__PURE__ */ Object.create(null));
const getColorsEmpty = () => DEFAULT_THEME_KEYS.reduce((colors3, key) => {
  colors3[key] = {
    close: "",
    open: ""
  };
  return colors3;
}, /* @__PURE__ */ Object.create(null));
const getPrintFunctionName = (options2) => options2 && options2.printFunctionName !== void 0 ? options2.printFunctionName : DEFAULT_OPTIONS.printFunctionName;
const getEscapeRegex = (options2) => options2 && options2.escapeRegex !== void 0 ? options2.escapeRegex : DEFAULT_OPTIONS.escapeRegex;
const getEscapeString = (options2) => options2 && options2.escapeString !== void 0 ? options2.escapeString : DEFAULT_OPTIONS.escapeString;
const getConfig$2 = (options2) => {
  var _options$printBasicPr;
  return {
    callToJSON: options2 && options2.callToJSON !== void 0 ? options2.callToJSON : DEFAULT_OPTIONS.callToJSON,
    colors: options2 && options2.highlight ? getColorsHighlight(options2) : getColorsEmpty(),
    compareKeys: options2 && typeof options2.compareKeys === "function" ? options2.compareKeys : DEFAULT_OPTIONS.compareKeys,
    escapeRegex: getEscapeRegex(options2),
    escapeString: getEscapeString(options2),
    indent: options2 && options2.min ? "" : createIndent(
      options2 && options2.indent !== void 0 ? options2.indent : DEFAULT_OPTIONS.indent
    ),
    maxDepth: options2 && options2.maxDepth !== void 0 ? options2.maxDepth : DEFAULT_OPTIONS.maxDepth,
    min: options2 && options2.min !== void 0 ? options2.min : DEFAULT_OPTIONS.min,
    plugins: options2 && options2.plugins !== void 0 ? options2.plugins : DEFAULT_OPTIONS.plugins,
    printBasicPrototype: (_options$printBasicPr = options2 === null || options2 === void 0 ? void 0 : options2.printBasicPrototype) !== null && _options$printBasicPr !== void 0 ? _options$printBasicPr : true,
    printFunctionName: getPrintFunctionName(options2),
    spacingInner: options2 && options2.min ? " " : "\n",
    spacingOuter: options2 && options2.min ? "" : "\n"
  };
};
function createIndent(indent) {
  return new Array(indent + 1).join(" ");
}
function format$3(val, options2) {
  if (options2) {
    validateOptions(options2);
    if (options2.plugins) {
      const plugin2 = findPlugin(options2.plugins, val);
      if (plugin2 !== null) {
        return printPlugin(plugin2, val, getConfig$2(options2), "", 0, []);
      }
    }
  }
  const basicResult = printBasicValue(
    val,
    getPrintFunctionName(options2),
    getEscapeRegex(options2),
    getEscapeString(options2)
  );
  if (basicResult !== null) {
    return basicResult;
  }
  return printComplexValue(val, getConfig$2(options2), "", 0, []);
}
const plugins = {
  AsymmetricMatcher: _AsymmetricMatcher.default,
  ConvertAnsi: _ConvertAnsi.default,
  DOMCollection: _DOMCollection.default,
  DOMElement: _DOMElement.default,
  Immutable: _Immutable.default,
  ReactElement: _ReactElement.default,
  ReactTestComponent: _ReactTestComponent.default
};
plugins_1 = build.plugins = plugins;
var _default$2i = format$3;
build.default = _default$2i;
var toStr$a = Object.prototype.toString;
function isCallable$2(fn2) {
  return typeof fn2 === "function" || toStr$a.call(fn2) === "[object Function]";
}
function toInteger$1(value) {
  var number2 = Number(value);
  if (isNaN(number2)) {
    return 0;
  }
  if (number2 === 0 || !isFinite(number2)) {
    return number2;
  }
  return (number2 > 0 ? 1 : -1) * Math.floor(Math.abs(number2));
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(value) {
  var len = toInteger$1(value);
  return Math.min(Math.max(len, 0), maxSafeInteger);
}
function arrayFrom(arrayLike, mapFn) {
  var C = Array;
  var items = Object(arrayLike);
  if (arrayLike == null) {
    throw new TypeError("Array.from requires an array-like object - not null or undefined");
  }
  if (typeof mapFn !== "undefined") {
    if (!isCallable$2(mapFn)) {
      throw new TypeError("Array.from: when provided, the second argument must be a function");
    }
  }
  var len = toLength(items.length);
  var A = isCallable$2(C) ? Object(new C(len)) : new Array(len);
  var k3 = 0;
  var kValue;
  while (k3 < len) {
    kValue = items[k3];
    if (mapFn) {
      A[k3] = mapFn(kValue, k3);
    } else {
      A[k3] = kValue;
    }
    k3 += 1;
  }
  A.length = len;
  return A;
}
function _typeof$3(obj) {
  "@babel/helpers - typeof";
  return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$3(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey$2(descriptor.key), descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _defineProperty$5(obj, key, value) {
  key = _toPropertyKey$2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$2(arg) {
  var key = _toPrimitive$2(arg, "string");
  return _typeof$3(key) === "symbol" ? key : String(key);
}
function _toPrimitive$2(input2, hint) {
  if (_typeof$3(input2) !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (_typeof$3(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
var SetLike = /* @__PURE__ */ function() {
  function SetLike2() {
    var items = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    _classCallCheck$1(this, SetLike2);
    _defineProperty$5(this, "items", void 0);
    this.items = items;
  }
  _createClass$1(SetLike2, [{
    key: "add",
    value: function add(value) {
      if (this.has(value) === false) {
        this.items.push(value);
      }
      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.items = [];
    }
  }, {
    key: "delete",
    value: function _delete(value) {
      var previousLength = this.items.length;
      this.items = this.items.filter(function(item) {
        return item !== value;
      });
      return previousLength !== this.items.length;
    }
  }, {
    key: "forEach",
    value: function forEach8(callbackfn) {
      var _this = this;
      this.items.forEach(function(item) {
        callbackfn(item, item, _this);
      });
    }
  }, {
    key: "has",
    value: function has7(value) {
      return this.items.indexOf(value) !== -1;
    }
  }, {
    key: "size",
    get: function get9() {
      return this.items.length;
    }
  }]);
  return SetLike2;
}();
const SetLike$1 = typeof Set === "undefined" ? Set : SetLike;
function getLocalName(element) {
  var _element$localName;
  return (
    // eslint-disable-next-line no-restricted-properties -- actual guard for environments without localName
    (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName : (
      // eslint-disable-next-line no-restricted-properties -- required for the fallback
      element.tagName.toLowerCase()
    )
  );
}
var localNameToRoleMappings = {
  article: "article",
  aside: "complementary",
  button: "button",
  datalist: "listbox",
  dd: "definition",
  details: "group",
  dialog: "dialog",
  dt: "term",
  fieldset: "group",
  figure: "figure",
  // WARNING: Only with an accessible name
  form: "form",
  footer: "contentinfo",
  h1: "heading",
  h2: "heading",
  h3: "heading",
  h4: "heading",
  h5: "heading",
  h6: "heading",
  header: "banner",
  hr: "separator",
  html: "document",
  legend: "legend",
  li: "listitem",
  math: "math",
  main: "main",
  menu: "list",
  nav: "navigation",
  ol: "list",
  optgroup: "group",
  // WARNING: Only in certain context
  option: "option",
  output: "status",
  progress: "progressbar",
  // WARNING: Only with an accessible name
  section: "region",
  summary: "button",
  table: "table",
  tbody: "rowgroup",
  textarea: "textbox",
  tfoot: "rowgroup",
  // WARNING: Only in certain context
  td: "cell",
  th: "columnheader",
  thead: "rowgroup",
  tr: "row",
  ul: "list"
};
var prohibitedAttributes = {
  caption: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  code: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  deletion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  emphasis: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  generic: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby", "aria-roledescription"]),
  insertion: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  paragraph: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  presentation: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  strong: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  subscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"]),
  superscript: /* @__PURE__ */ new Set(["aria-label", "aria-labelledby"])
};
function hasGlobalAriaAttributes(element, role) {
  return [
    "aria-atomic",
    "aria-busy",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    // "disabled",
    "aria-dropeffect",
    // "errormessage",
    "aria-flowto",
    "aria-grabbed",
    // "haspopup",
    "aria-hidden",
    // "invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-live",
    "aria-owns",
    "aria-relevant",
    "aria-roledescription"
  ].some(function(attributeName) {
    var _prohibitedAttributes;
    return element.hasAttribute(attributeName) && !((_prohibitedAttributes = prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
  });
}
function ignorePresentationalRole(element, implicitRole) {
  return hasGlobalAriaAttributes(element, implicitRole);
}
function getRole(element) {
  var explicitRole = getExplicitRole(element);
  if (explicitRole === null || explicitRole === "presentation") {
    var implicitRole = getImplicitRole(element);
    if (explicitRole !== "presentation" || ignorePresentationalRole(element, implicitRole || "")) {
      return implicitRole;
    }
  }
  return explicitRole;
}
function getImplicitRole(element) {
  var mappedByTag = localNameToRoleMappings[getLocalName(element)];
  if (mappedByTag !== void 0) {
    return mappedByTag;
  }
  switch (getLocalName(element)) {
    case "a":
    case "area":
    case "link":
      if (element.hasAttribute("href")) {
        return "link";
      }
      break;
    case "img":
      if (element.getAttribute("alt") === "" && !ignorePresentationalRole(element, "img")) {
        return "presentation";
      }
      return "img";
    case "input": {
      var _ref2 = element, type2 = _ref2.type;
      switch (type2) {
        case "button":
        case "image":
        case "reset":
        case "submit":
          return "button";
        case "checkbox":
        case "radio":
          return type2;
        case "range":
          return "slider";
        case "email":
        case "tel":
        case "text":
        case "url":
          if (element.hasAttribute("list")) {
            return "combobox";
          }
          return "textbox";
        case "search":
          if (element.hasAttribute("list")) {
            return "combobox";
          }
          return "searchbox";
        case "number":
          return "spinbutton";
        default:
          return null;
      }
    }
    case "select":
      if (element.hasAttribute("multiple") || element.size > 1) {
        return "listbox";
      }
      return "combobox";
  }
  return null;
}
function getExplicitRole(element) {
  var role = element.getAttribute("role");
  if (role !== null) {
    var explicitRole = role.trim().split(" ")[0];
    if (explicitRole.length > 0) {
      return explicitRole;
    }
  }
  return null;
}
function isElement$1(node2) {
  return node2 !== null && node2.nodeType === node2.ELEMENT_NODE;
}
function isHTMLTableCaptionElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "caption";
}
function isHTMLInputElement$1(node2) {
  return isElement$1(node2) && getLocalName(node2) === "input";
}
function isHTMLOptGroupElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "optgroup";
}
function isHTMLSelectElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "select";
}
function isHTMLTableElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "table";
}
function isHTMLTextAreaElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "textarea";
}
function safeWindow(node2) {
  var _ref2 = node2.ownerDocument === null ? node2 : node2.ownerDocument, defaultView = _ref2.defaultView;
  if (defaultView === null) {
    throw new TypeError("no window available");
  }
  return defaultView;
}
function isHTMLFieldSetElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "fieldset";
}
function isHTMLLegendElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "legend";
}
function isHTMLSlotElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "slot";
}
function isSVGElement(node2) {
  return isElement$1(node2) && node2.ownerSVGElement !== void 0;
}
function isSVGSVGElement(node2) {
  return isElement$1(node2) && getLocalName(node2) === "svg";
}
function isSVGTitleElement(node2) {
  return isSVGElement(node2) && getLocalName(node2) === "title";
}
function queryIdRefs(node2, attributeName) {
  if (isElement$1(node2) && node2.hasAttribute(attributeName)) {
    var ids = node2.getAttribute(attributeName).split(" ");
    var root2 = node2.getRootNode ? node2.getRootNode() : node2.ownerDocument;
    return ids.map(function(id) {
      return root2.getElementById(id);
    }).filter(
      function(element) {
        return element !== null;
      }
      // TODO: why does this not narrow?
    );
  }
  return [];
}
function hasAnyConcreteRoles(node2, roles2) {
  if (isElement$1(node2)) {
    return roles2.indexOf(getRole(node2)) !== -1;
  }
  return false;
}
function asFlatString(s4) {
  return s4.trim().replace(/\s\s+/g, " ");
}
function isHidden(node2, getComputedStyleImplementation) {
  if (!isElement$1(node2)) {
    return false;
  }
  if (node2.hasAttribute("hidden") || node2.getAttribute("aria-hidden") === "true") {
    return true;
  }
  var style2 = getComputedStyleImplementation(node2);
  return style2.getPropertyValue("display") === "none" || style2.getPropertyValue("visibility") === "hidden";
}
function isControl(node2) {
  return hasAnyConcreteRoles(node2, ["button", "combobox", "listbox", "textbox"]) || hasAbstractRole(node2, "range");
}
function hasAbstractRole(node2, role) {
  if (!isElement$1(node2)) {
    return false;
  }
  switch (role) {
    case "range":
      return hasAnyConcreteRoles(node2, ["meter", "progressbar", "scrollbar", "slider", "spinbutton"]);
    default:
      throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
  }
}
function querySelectorAllSubtree(element, selectors) {
  var elements = arrayFrom(element.querySelectorAll(selectors));
  queryIdRefs(element, "aria-owns").forEach(function(root2) {
    elements.push.apply(elements, arrayFrom(root2.querySelectorAll(selectors)));
  });
  return elements;
}
function querySelectedOptions(listbox) {
  if (isHTMLSelectElement(listbox)) {
    return listbox.selectedOptions || querySelectorAllSubtree(listbox, "[selected]");
  }
  return querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function isMarkedPresentational(node2) {
  return hasAnyConcreteRoles(node2, ["none", "presentation"]);
}
function isNativeHostLanguageTextAlternativeElement(node2) {
  return isHTMLTableCaptionElement(node2);
}
function allowsNameFromContent(node2) {
  return hasAnyConcreteRoles(node2, ["button", "cell", "checkbox", "columnheader", "gridcell", "heading", "label", "legend", "link", "menuitem", "menuitemcheckbox", "menuitemradio", "option", "radio", "row", "rowheader", "switch", "tab", "tooltip", "treeitem"]);
}
function isDescendantOfNativeHostLanguageTextAlternativeElement(node2) {
  return false;
}
function getValueOfTextbox(element) {
  if (isHTMLInputElement$1(element) || isHTMLTextAreaElement(element)) {
    return element.value;
  }
  return element.textContent || "";
}
function getTextualContent(declaration2) {
  var content2 = declaration2.getPropertyValue("content");
  if (/^["'].*["']$/.test(content2)) {
    return content2.slice(1, -1);
  }
  return "";
}
function isLabelableElement(element) {
  var localName = getLocalName(element);
  return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}
function findLabelableElement(element) {
  if (isLabelableElement(element)) {
    return element;
  }
  var labelableElement = null;
  element.childNodes.forEach(function(childNode) {
    if (labelableElement === null && isElement$1(childNode)) {
      var descendantLabelableElement = findLabelableElement(childNode);
      if (descendantLabelableElement !== null) {
        labelableElement = descendantLabelableElement;
      }
    }
  });
  return labelableElement;
}
function getControlOfLabel(label2) {
  if (label2.control !== void 0) {
    return label2.control;
  }
  var htmlFor = label2.getAttribute("for");
  if (htmlFor !== null) {
    return label2.ownerDocument.getElementById(htmlFor);
  }
  return findLabelableElement(label2);
}
function getLabels$2(element) {
  var labelsProperty = element.labels;
  if (labelsProperty === null) {
    return labelsProperty;
  }
  if (labelsProperty !== void 0) {
    return arrayFrom(labelsProperty);
  }
  if (!isLabelableElement(element)) {
    return null;
  }
  var document2 = element.ownerDocument;
  return arrayFrom(document2.querySelectorAll("label")).filter(function(label2) {
    return getControlOfLabel(label2) === element;
  });
}
function getSlotContents(slot) {
  var assignedNodes = slot.assignedNodes();
  if (assignedNodes.length === 0) {
    return arrayFrom(slot.childNodes);
  }
  return assignedNodes;
}
function computeTextAlternative(root2) {
  var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var consultedNodes = new SetLike$1();
  var window2 = safeWindow(root2);
  var _options$compute = options2.compute, compute = _options$compute === void 0 ? "name" : _options$compute, _options$computedStyl = options2.computedStyleSupportsPseudoElements, computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options2.getComputedStyle !== void 0 : _options$computedStyl, _options$getComputedS = options2.getComputedStyle, getComputedStyle2 = _options$getComputedS === void 0 ? window2.getComputedStyle.bind(window2) : _options$getComputedS, _options$hidden = options2.hidden, hidden = _options$hidden === void 0 ? false : _options$hidden;
  function computeMiscTextAlternative(node2, context) {
    var accumulatedText = "";
    if (isElement$1(node2) && computedStyleSupportsPseudoElements) {
      var pseudoBefore = getComputedStyle2(node2, "::before");
      var beforeContent = getTextualContent(pseudoBefore);
      accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
    }
    var childNodes = isHTMLSlotElement(node2) ? getSlotContents(node2) : arrayFrom(node2.childNodes).concat(queryIdRefs(node2, "aria-owns"));
    childNodes.forEach(function(child) {
      var result = computeTextAlternative2(child, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false,
        recursion: true
      });
      var display = isElement$1(child) ? getComputedStyle2(child).getPropertyValue("display") : "inline";
      var separator = display !== "inline" ? " " : "";
      accumulatedText += "".concat(separator).concat(result).concat(separator);
    });
    if (isElement$1(node2) && computedStyleSupportsPseudoElements) {
      var pseudoAfter = getComputedStyle2(node2, "::after");
      var afterContent = getTextualContent(pseudoAfter);
      accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
    }
    return accumulatedText.trim();
  }
  function useAttribute(element, attributeName) {
    var attribute = element.getAttributeNode(attributeName);
    if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
      consultedNodes.add(attribute);
      return attribute.value;
    }
    return null;
  }
  function computeTooltipAttributeValue(node2) {
    if (!isElement$1(node2)) {
      return null;
    }
    return useAttribute(node2, "title");
  }
  function computeElementTextAlternative(node2) {
    if (!isElement$1(node2)) {
      return null;
    }
    if (isHTMLFieldSetElement(node2)) {
      consultedNodes.add(node2);
      var children2 = arrayFrom(node2.childNodes);
      for (var i2 = 0; i2 < children2.length; i2 += 1) {
        var child = children2[i2];
        if (isHTMLLegendElement(child)) {
          return computeTextAlternative2(child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isHTMLTableElement(node2)) {
      consultedNodes.add(node2);
      var _children = arrayFrom(node2.childNodes);
      for (var _i = 0; _i < _children.length; _i += 1) {
        var _child = _children[_i];
        if (isHTMLTableCaptionElement(_child)) {
          return computeTextAlternative2(_child, {
            isEmbeddedInLabel: false,
            isReferenced: false,
            recursion: false
          });
        }
      }
    } else if (isSVGSVGElement(node2)) {
      consultedNodes.add(node2);
      var _children2 = arrayFrom(node2.childNodes);
      for (var _i2 = 0; _i2 < _children2.length; _i2 += 1) {
        var _child2 = _children2[_i2];
        if (isSVGTitleElement(_child2)) {
          return _child2.textContent;
        }
      }
      return null;
    } else if (getLocalName(node2) === "img" || getLocalName(node2) === "area") {
      var nameFromAlt = useAttribute(node2, "alt");
      if (nameFromAlt !== null) {
        return nameFromAlt;
      }
    } else if (isHTMLOptGroupElement(node2)) {
      var nameFromLabel = useAttribute(node2, "label");
      if (nameFromLabel !== null) {
        return nameFromLabel;
      }
    }
    if (isHTMLInputElement$1(node2) && (node2.type === "button" || node2.type === "submit" || node2.type === "reset")) {
      var nameFromValue = useAttribute(node2, "value");
      if (nameFromValue !== null) {
        return nameFromValue;
      }
      if (node2.type === "submit") {
        return "Submit";
      }
      if (node2.type === "reset") {
        return "Reset";
      }
    }
    var labels = getLabels$2(node2);
    if (labels !== null && labels.length !== 0) {
      consultedNodes.add(node2);
      return arrayFrom(labels).map(function(element) {
        return computeTextAlternative2(element, {
          isEmbeddedInLabel: true,
          isReferenced: false,
          recursion: true
        });
      }).filter(function(label2) {
        return label2.length > 0;
      }).join(" ");
    }
    if (isHTMLInputElement$1(node2) && node2.type === "image") {
      var _nameFromAlt = useAttribute(node2, "alt");
      if (_nameFromAlt !== null) {
        return _nameFromAlt;
      }
      var nameFromTitle = useAttribute(node2, "title");
      if (nameFromTitle !== null) {
        return nameFromTitle;
      }
      return "Submit Query";
    }
    if (hasAnyConcreteRoles(node2, ["button"])) {
      var nameFromSubTree = computeMiscTextAlternative(node2, {
        isEmbeddedInLabel: false,
        isReferenced: false
      });
      if (nameFromSubTree !== "") {
        return nameFromSubTree;
      }
    }
    return null;
  }
  function computeTextAlternative2(current, context) {
    if (consultedNodes.has(current)) {
      return "";
    }
    if (!hidden && isHidden(current, getComputedStyle2) && !context.isReferenced) {
      consultedNodes.add(current);
      return "";
    }
    var labelAttributeNode = isElement$1(current) ? current.getAttributeNode("aria-labelledby") : null;
    var labelElements = labelAttributeNode !== null && !consultedNodes.has(labelAttributeNode) ? queryIdRefs(current, "aria-labelledby") : [];
    if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
      consultedNodes.add(labelAttributeNode);
      return labelElements.map(function(element) {
        return computeTextAlternative2(element, {
          isEmbeddedInLabel: context.isEmbeddedInLabel,
          isReferenced: true,
          // this isn't recursion as specified, otherwise we would skip
          // `aria-label` in
          // <input id="myself" aria-label="foo" aria-labelledby="myself"
          recursion: false
        });
      }).join(" ");
    }
    var skipToStep2E = context.recursion && isControl(current) && compute === "name";
    if (!skipToStep2E) {
      var ariaLabel = (isElement$1(current) && current.getAttribute("aria-label") || "").trim();
      if (ariaLabel !== "" && compute === "name") {
        consultedNodes.add(current);
        return ariaLabel;
      }
      if (!isMarkedPresentational(current)) {
        var elementTextAlternative = computeElementTextAlternative(current);
        if (elementTextAlternative !== null) {
          consultedNodes.add(current);
          return elementTextAlternative;
        }
      }
    }
    if (hasAnyConcreteRoles(current, ["menu"])) {
      consultedNodes.add(current);
      return "";
    }
    if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
      if (hasAnyConcreteRoles(current, ["combobox", "listbox"])) {
        consultedNodes.add(current);
        var selectedOptions = querySelectedOptions(current);
        if (selectedOptions.length === 0) {
          return isHTMLInputElement$1(current) ? current.value : "";
        }
        return arrayFrom(selectedOptions).map(function(selectedOption) {
          return computeTextAlternative2(selectedOption, {
            isEmbeddedInLabel: context.isEmbeddedInLabel,
            isReferenced: false,
            recursion: true
          });
        }).join(" ");
      }
      if (hasAbstractRole(current, "range")) {
        consultedNodes.add(current);
        if (current.hasAttribute("aria-valuetext")) {
          return current.getAttribute("aria-valuetext");
        }
        if (current.hasAttribute("aria-valuenow")) {
          return current.getAttribute("aria-valuenow");
        }
        return current.getAttribute("value") || "";
      }
      if (hasAnyConcreteRoles(current, ["textbox"])) {
        consultedNodes.add(current);
        return getValueOfTextbox(current);
      }
    }
    if (allowsNameFromContent(current) || isElement$1(current) && context.isReferenced || isNativeHostLanguageTextAlternativeElement(current) || isDescendantOfNativeHostLanguageTextAlternativeElement()) {
      var accumulatedText2F = computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
      if (accumulatedText2F !== "") {
        consultedNodes.add(current);
        return accumulatedText2F;
      }
    }
    if (current.nodeType === current.TEXT_NODE) {
      consultedNodes.add(current);
      return current.textContent || "";
    }
    if (context.recursion) {
      consultedNodes.add(current);
      return computeMiscTextAlternative(current, {
        isEmbeddedInLabel: context.isEmbeddedInLabel,
        isReferenced: false
      });
    }
    var tooltipAttributeValue = computeTooltipAttributeValue(current);
    if (tooltipAttributeValue !== null) {
      consultedNodes.add(current);
      return tooltipAttributeValue;
    }
    consultedNodes.add(current);
    return "";
  }
  return asFlatString(computeTextAlternative2(root2, {
    isEmbeddedInLabel: false,
    // by spec computeAccessibleDescription starts with the referenced elements as roots
    isReferenced: compute === "description",
    recursion: false
  }));
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$2(obj);
}
function ownKeys$1(object2, enumerableOnly) {
  var keys8 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys8.push.apply(keys8, symbols);
  }
  return keys8;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = null != arguments[i2] ? arguments[i2] : {};
    i2 % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  key = _toPropertyKey$1(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey$1(arg) {
  var key = _toPrimitive$1(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}
function _toPrimitive$1(input2, hint) {
  if (_typeof$2(input2) !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (_typeof$2(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
function computeAccessibleDescription(root2) {
  var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var description = queryIdRefs(root2, "aria-describedby").map(function(element) {
    return computeTextAlternative(element, _objectSpread(_objectSpread({}, options2), {}, {
      compute: "description"
    }));
  }).join(" ");
  if (description === "") {
    var title = root2.getAttribute("title");
    description = title === null ? "" : title;
  }
  return description;
}
function prohibitsNaming(node2) {
  return hasAnyConcreteRoles(node2, ["caption", "code", "deletion", "emphasis", "generic", "insertion", "paragraph", "presentation", "strong", "subscript", "superscript"]);
}
function computeAccessibleName(root2) {
  var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (prohibitsNaming(root2)) {
    return "";
  }
  return computeTextAlternative(root2, options2);
}
var lib$1 = {};
var ariaPropsMap$1 = {};
var iterationDecorator$1 = {};
var iteratorProxy$1 = {};
Object.defineProperty(iteratorProxy$1, "__esModule", {
  value: true
});
iteratorProxy$1.default = void 0;
function iteratorProxy() {
  var values6 = this;
  var index2 = 0;
  var iter = {
    "@@iterator": function iterator() {
      return iter;
    },
    next: function next2() {
      if (index2 < values6.length) {
        var value = values6[index2];
        index2 = index2 + 1;
        return {
          done: false,
          value
        };
      } else {
        return {
          done: true
        };
      }
    }
  };
  return iter;
}
var _default$2h = iteratorProxy;
iteratorProxy$1.default = _default$2h;
Object.defineProperty(iterationDecorator$1, "__esModule", {
  value: true
});
iterationDecorator$1.default = iterationDecorator;
var _iteratorProxy = _interopRequireDefault$a(iteratorProxy$1);
function _interopRequireDefault$a(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function iterationDecorator(collection, entries6) {
  if (typeof Symbol === "function" && _typeof$1(Symbol.iterator) === "symbol") {
    Object.defineProperty(collection, Symbol.iterator, {
      value: _iteratorProxy.default.bind(entries6)
    });
  }
  return collection;
}
Object.defineProperty(ariaPropsMap$1, "__esModule", {
  value: true
});
ariaPropsMap$1.default = void 0;
var _iterationDecorator$4 = _interopRequireDefault$9(iterationDecorator$1);
function _interopRequireDefault$9(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _slicedToArray$4(arr, i2) {
  return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i2) || _unsupportedIterableToArray$5(arr, i2) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit$4(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _createForOfIteratorHelper$5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$5(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e3(_e2) {
        throw _e2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s4() {
    it = it.call(o);
  }, n: function n() {
    var step2 = it.next();
    normalCompletion = step2.done;
    return step2;
  }, e: function e3(_e3) {
    didErr = true;
    err = _e3;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$5(o, minLen);
}
function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
var properties = [["aria-activedescendant", {
  "type": "id"
}], ["aria-atomic", {
  "type": "boolean"
}], ["aria-autocomplete", {
  "type": "token",
  "values": ["inline", "list", "both", "none"]
}], ["aria-busy", {
  "type": "boolean"
}], ["aria-checked", {
  "type": "tristate"
}], ["aria-colcount", {
  type: "integer"
}], ["aria-colindex", {
  type: "integer"
}], ["aria-colspan", {
  type: "integer"
}], ["aria-controls", {
  "type": "idlist"
}], ["aria-current", {
  type: "token",
  values: ["page", "step", "location", "date", "time", true, false]
}], ["aria-describedby", {
  "type": "idlist"
}], ["aria-details", {
  "type": "id"
}], ["aria-disabled", {
  "type": "boolean"
}], ["aria-dropeffect", {
  "type": "tokenlist",
  "values": ["copy", "execute", "link", "move", "none", "popup"]
}], ["aria-errormessage", {
  "type": "id"
}], ["aria-expanded", {
  "type": "boolean",
  "allowundefined": true
}], ["aria-flowto", {
  "type": "idlist"
}], ["aria-grabbed", {
  "type": "boolean",
  "allowundefined": true
}], ["aria-haspopup", {
  "type": "token",
  "values": [false, true, "menu", "listbox", "tree", "grid", "dialog"]
}], ["aria-hidden", {
  "type": "boolean",
  "allowundefined": true
}], ["aria-invalid", {
  "type": "token",
  "values": ["grammar", false, "spelling", true]
}], ["aria-keyshortcuts", {
  type: "string"
}], ["aria-label", {
  "type": "string"
}], ["aria-labelledby", {
  "type": "idlist"
}], ["aria-level", {
  "type": "integer"
}], ["aria-live", {
  "type": "token",
  "values": ["assertive", "off", "polite"]
}], ["aria-modal", {
  type: "boolean"
}], ["aria-multiline", {
  "type": "boolean"
}], ["aria-multiselectable", {
  "type": "boolean"
}], ["aria-orientation", {
  "type": "token",
  "values": ["vertical", "undefined", "horizontal"]
}], ["aria-owns", {
  "type": "idlist"
}], ["aria-placeholder", {
  type: "string"
}], ["aria-posinset", {
  "type": "integer"
}], ["aria-pressed", {
  "type": "tristate"
}], ["aria-readonly", {
  "type": "boolean"
}], ["aria-relevant", {
  "type": "tokenlist",
  "values": ["additions", "all", "removals", "text"]
}], ["aria-required", {
  "type": "boolean"
}], ["aria-roledescription", {
  type: "string"
}], ["aria-rowcount", {
  type: "integer"
}], ["aria-rowindex", {
  type: "integer"
}], ["aria-rowspan", {
  type: "integer"
}], ["aria-selected", {
  "type": "boolean",
  "allowundefined": true
}], ["aria-setsize", {
  "type": "integer"
}], ["aria-sort", {
  "type": "token",
  "values": ["ascending", "descending", "none", "other"]
}], ["aria-valuemax", {
  "type": "number"
}], ["aria-valuemin", {
  "type": "number"
}], ["aria-valuenow", {
  "type": "number"
}], ["aria-valuetext", {
  "type": "string"
}]];
var ariaPropsMap = {
  entries: function entries() {
    return properties;
  },
  forEach: function forEach(fn2) {
    var thisArg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper$5(properties), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray$4(_step.value, 2), key = _step$value[0], values6 = _step$value[1];
        fn2.call(thisArg, values6, key, properties);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get3(key) {
    var item = properties.find(function(tuple2) {
      return tuple2[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has(key) {
    return !!ariaPropsMap.get(key);
  },
  keys: function keys() {
    return properties.map(function(_ref2) {
      var _ref22 = _slicedToArray$4(_ref2, 1), key = _ref22[0];
      return key;
    });
  },
  values: function values() {
    return properties.map(function(_ref3) {
      var _ref4 = _slicedToArray$4(_ref3, 2), values6 = _ref4[1];
      return values6;
    });
  }
};
var _default$2g = (0, _iterationDecorator$4.default)(ariaPropsMap, ariaPropsMap.entries());
ariaPropsMap$1.default = _default$2g;
var domMap$1 = {};
Object.defineProperty(domMap$1, "__esModule", {
  value: true
});
domMap$1.default = void 0;
var _iterationDecorator$3 = _interopRequireDefault$8(iterationDecorator$1);
function _interopRequireDefault$8(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _slicedToArray$3(arr, i2) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i2) || _unsupportedIterableToArray$4(arr, i2) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit$3(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _createForOfIteratorHelper$4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$4(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e3(_e2) {
        throw _e2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s4() {
    it = it.call(o);
  }, n: function n() {
    var step2 = it.next();
    normalCompletion = step2.done;
    return step2;
  }, e: function e3(_e3) {
    didErr = true;
    err = _e3;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
var dom$1 = [["a", {
  reserved: false
}], ["abbr", {
  reserved: false
}], ["acronym", {
  reserved: false
}], ["address", {
  reserved: false
}], ["applet", {
  reserved: false
}], ["area", {
  reserved: false
}], ["article", {
  reserved: false
}], ["aside", {
  reserved: false
}], ["audio", {
  reserved: false
}], ["b", {
  reserved: false
}], ["base", {
  reserved: true
}], ["bdi", {
  reserved: false
}], ["bdo", {
  reserved: false
}], ["big", {
  reserved: false
}], ["blink", {
  reserved: false
}], ["blockquote", {
  reserved: false
}], ["body", {
  reserved: false
}], ["br", {
  reserved: false
}], ["button", {
  reserved: false
}], ["canvas", {
  reserved: false
}], ["caption", {
  reserved: false
}], ["center", {
  reserved: false
}], ["cite", {
  reserved: false
}], ["code", {
  reserved: false
}], ["col", {
  reserved: true
}], ["colgroup", {
  reserved: true
}], ["content", {
  reserved: false
}], ["data", {
  reserved: false
}], ["datalist", {
  reserved: false
}], ["dd", {
  reserved: false
}], ["del", {
  reserved: false
}], ["details", {
  reserved: false
}], ["dfn", {
  reserved: false
}], ["dialog", {
  reserved: false
}], ["dir", {
  reserved: false
}], ["div", {
  reserved: false
}], ["dl", {
  reserved: false
}], ["dt", {
  reserved: false
}], ["em", {
  reserved: false
}], ["embed", {
  reserved: false
}], ["fieldset", {
  reserved: false
}], ["figcaption", {
  reserved: false
}], ["figure", {
  reserved: false
}], ["font", {
  reserved: false
}], ["footer", {
  reserved: false
}], ["form", {
  reserved: false
}], ["frame", {
  reserved: false
}], ["frameset", {
  reserved: false
}], ["h1", {
  reserved: false
}], ["h2", {
  reserved: false
}], ["h3", {
  reserved: false
}], ["h4", {
  reserved: false
}], ["h5", {
  reserved: false
}], ["h6", {
  reserved: false
}], ["head", {
  reserved: true
}], ["header", {
  reserved: false
}], ["hgroup", {
  reserved: false
}], ["hr", {
  reserved: false
}], ["html", {
  reserved: true
}], ["i", {
  reserved: false
}], ["iframe", {
  reserved: false
}], ["img", {
  reserved: false
}], ["input", {
  reserved: false
}], ["ins", {
  reserved: false
}], ["kbd", {
  reserved: false
}], ["keygen", {
  reserved: false
}], ["label", {
  reserved: false
}], ["legend", {
  reserved: false
}], ["li", {
  reserved: false
}], ["link", {
  reserved: true
}], ["main", {
  reserved: false
}], ["map", {
  reserved: false
}], ["mark", {
  reserved: false
}], ["marquee", {
  reserved: false
}], ["menu", {
  reserved: false
}], ["menuitem", {
  reserved: false
}], ["meta", {
  reserved: true
}], ["meter", {
  reserved: false
}], ["nav", {
  reserved: false
}], ["noembed", {
  reserved: true
}], ["noscript", {
  reserved: true
}], ["object", {
  reserved: false
}], ["ol", {
  reserved: false
}], ["optgroup", {
  reserved: false
}], ["option", {
  reserved: false
}], ["output", {
  reserved: false
}], ["p", {
  reserved: false
}], ["param", {
  reserved: true
}], ["picture", {
  reserved: true
}], ["pre", {
  reserved: false
}], ["progress", {
  reserved: false
}], ["q", {
  reserved: false
}], ["rp", {
  reserved: false
}], ["rt", {
  reserved: false
}], ["rtc", {
  reserved: false
}], ["ruby", {
  reserved: false
}], ["s", {
  reserved: false
}], ["samp", {
  reserved: false
}], ["script", {
  reserved: true
}], ["section", {
  reserved: false
}], ["select", {
  reserved: false
}], ["small", {
  reserved: false
}], ["source", {
  reserved: true
}], ["spacer", {
  reserved: false
}], ["span", {
  reserved: false
}], ["strike", {
  reserved: false
}], ["strong", {
  reserved: false
}], ["style", {
  reserved: true
}], ["sub", {
  reserved: false
}], ["summary", {
  reserved: false
}], ["sup", {
  reserved: false
}], ["table", {
  reserved: false
}], ["tbody", {
  reserved: false
}], ["td", {
  reserved: false
}], ["textarea", {
  reserved: false
}], ["tfoot", {
  reserved: false
}], ["th", {
  reserved: false
}], ["thead", {
  reserved: false
}], ["time", {
  reserved: false
}], ["title", {
  reserved: true
}], ["tr", {
  reserved: false
}], ["track", {
  reserved: true
}], ["tt", {
  reserved: false
}], ["u", {
  reserved: false
}], ["ul", {
  reserved: false
}], ["var", {
  reserved: false
}], ["video", {
  reserved: false
}], ["wbr", {
  reserved: false
}], ["xmp", {
  reserved: false
}]];
var domMap = {
  entries: function entries2() {
    return dom$1;
  },
  forEach: function forEach2(fn2) {
    var thisArg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper$4(dom$1), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray$3(_step.value, 2), key = _step$value[0], values6 = _step$value[1];
        fn2.call(thisArg, values6, key, dom$1);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get4(key) {
    var item = dom$1.find(function(tuple2) {
      return tuple2[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has2(key) {
    return !!domMap.get(key);
  },
  keys: function keys2() {
    return dom$1.map(function(_ref2) {
      var _ref22 = _slicedToArray$3(_ref2, 1), key = _ref22[0];
      return key;
    });
  },
  values: function values2() {
    return dom$1.map(function(_ref3) {
      var _ref4 = _slicedToArray$3(_ref3, 2), values6 = _ref4[1];
      return values6;
    });
  }
};
var _default$2f = (0, _iterationDecorator$3.default)(domMap, domMap.entries());
domMap$1.default = _default$2f;
var rolesMap$1 = {};
var ariaAbstractRoles$1 = {};
var commandRole$1 = {};
Object.defineProperty(commandRole$1, "__esModule", {
  value: true
});
commandRole$1.default = void 0;
var commandRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menuitem"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget"]]
};
var _default$2e = commandRole;
commandRole$1.default = _default$2e;
var compositeRole$1 = {};
Object.defineProperty(compositeRole$1, "__esModule", {
  value: true
});
compositeRole$1.default = void 0;
var compositeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-disabled": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget"]]
};
var _default$2d = compositeRole;
compositeRole$1.default = _default$2d;
var inputRole$1 = {};
Object.defineProperty(inputRole$1, "__esModule", {
  value: true
});
inputRole$1.default = void 0;
var inputRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null
  },
  relatedConcepts: [{
    concept: {
      name: "input"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget"]]
};
var _default$2c = inputRole;
inputRole$1.default = _default$2c;
var landmarkRole$1 = {};
Object.defineProperty(landmarkRole$1, "__esModule", {
  value: true
});
landmarkRole$1.default = void 0;
var landmarkRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$2b = landmarkRole;
landmarkRole$1.default = _default$2b;
var rangeRole$1 = {};
Object.defineProperty(rangeRole$1, "__esModule", {
  value: true
});
rangeRole$1.default = void 0;
var rangeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$2a = rangeRole;
rangeRole$1.default = _default$2a;
var roletypeRole$1 = {};
Object.defineProperty(roletypeRole$1, "__esModule", {
  value: true
});
roletypeRole$1.default = void 0;
var roletypeRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {
    "aria-atomic": null,
    "aria-busy": null,
    "aria-controls": null,
    "aria-current": null,
    "aria-describedby": null,
    "aria-details": null,
    "aria-dropeffect": null,
    "aria-flowto": null,
    "aria-grabbed": null,
    "aria-hidden": null,
    "aria-keyshortcuts": null,
    "aria-label": null,
    "aria-labelledby": null,
    "aria-live": null,
    "aria-owns": null,
    "aria-relevant": null,
    "aria-roledescription": null
  },
  relatedConcepts: [{
    concept: {
      name: "rel"
    },
    module: "HTML"
  }, {
    concept: {
      name: "role"
    },
    module: "XHTML"
  }, {
    concept: {
      name: "type"
    },
    module: "Dublin Core"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default$29 = roletypeRole;
roletypeRole$1.default = _default$29;
var sectionRole$1 = {};
Object.defineProperty(sectionRole$1, "__esModule", {
  value: true
});
sectionRole$1.default = void 0;
var sectionRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "frontmatter"
    },
    module: "DTB"
  }, {
    concept: {
      name: "level"
    },
    module: "DTB"
  }, {
    concept: {
      name: "level"
    },
    module: "SMIL"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$28 = sectionRole;
sectionRole$1.default = _default$28;
var sectionheadRole$1 = {};
Object.defineProperty(sectionheadRole$1, "__esModule", {
  value: true
});
sectionheadRole$1.default = void 0;
var sectionheadRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$27 = sectionheadRole;
sectionheadRole$1.default = _default$27;
var selectRole$1 = {};
Object.defineProperty(selectRole$1, "__esModule", {
  value: true
});
selectRole$1.default = void 0;
var selectRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "group"]]
};
var _default$26 = selectRole;
selectRole$1.default = _default$26;
var structureRole$1 = {};
Object.defineProperty(structureRole$1, "__esModule", {
  value: true
});
structureRole$1.default = void 0;
var structureRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype"]]
};
var _default$25 = structureRole;
structureRole$1.default = _default$25;
var widgetRole$1 = {};
Object.defineProperty(widgetRole$1, "__esModule", {
  value: true
});
widgetRole$1.default = void 0;
var widgetRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype"]]
};
var _default$24 = widgetRole;
widgetRole$1.default = _default$24;
var windowRole$1 = {};
Object.defineProperty(windowRole$1, "__esModule", {
  value: true
});
windowRole$1.default = void 0;
var windowRole = {
  abstract: true,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-modal": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype"]]
};
var _default$23 = windowRole;
windowRole$1.default = _default$23;
Object.defineProperty(ariaAbstractRoles$1, "__esModule", {
  value: true
});
ariaAbstractRoles$1.default = void 0;
var _commandRole = _interopRequireDefault$7(commandRole$1);
var _compositeRole = _interopRequireDefault$7(compositeRole$1);
var _inputRole = _interopRequireDefault$7(inputRole$1);
var _landmarkRole = _interopRequireDefault$7(landmarkRole$1);
var _rangeRole = _interopRequireDefault$7(rangeRole$1);
var _roletypeRole = _interopRequireDefault$7(roletypeRole$1);
var _sectionRole = _interopRequireDefault$7(sectionRole$1);
var _sectionheadRole = _interopRequireDefault$7(sectionheadRole$1);
var _selectRole = _interopRequireDefault$7(selectRole$1);
var _structureRole = _interopRequireDefault$7(structureRole$1);
var _widgetRole = _interopRequireDefault$7(widgetRole$1);
var _windowRole = _interopRequireDefault$7(windowRole$1);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var ariaAbstractRoles = [["command", _commandRole.default], ["composite", _compositeRole.default], ["input", _inputRole.default], ["landmark", _landmarkRole.default], ["range", _rangeRole.default], ["roletype", _roletypeRole.default], ["section", _sectionRole.default], ["sectionhead", _sectionheadRole.default], ["select", _selectRole.default], ["structure", _structureRole.default], ["widget", _widgetRole.default], ["window", _windowRole.default]];
var _default$22 = ariaAbstractRoles;
ariaAbstractRoles$1.default = _default$22;
var ariaLiteralRoles$1 = {};
var alertRole$1 = {};
Object.defineProperty(alertRole$1, "__esModule", {
  value: true
});
alertRole$1.default = void 0;
var alertRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-atomic": "true",
    "aria-live": "assertive"
  },
  relatedConcepts: [{
    concept: {
      name: "alert"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$21 = alertRole;
alertRole$1.default = _default$21;
var alertdialogRole$1 = {};
Object.defineProperty(alertdialogRole$1, "__esModule", {
  value: true
});
alertdialogRole$1.default = void 0;
var alertdialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "alert"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "alert"], ["roletype", "window", "dialog"]]
};
var _default$20 = alertdialogRole;
alertdialogRole$1.default = _default$20;
var applicationRole$1 = {};
Object.defineProperty(applicationRole$1, "__esModule", {
  value: true
});
applicationRole$1.default = void 0;
var applicationRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "Device Independence Delivery Unit"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$1$ = applicationRole;
applicationRole$1.default = _default$1$;
var articleRole$1 = {};
Object.defineProperty(articleRole$1, "__esModule", {
  value: true
});
articleRole$1.default = void 0;
var articleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      name: "article"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "document"]]
};
var _default$1_ = articleRole;
articleRole$1.default = _default$1_;
var bannerRole$1 = {};
Object.defineProperty(bannerRole$1, "__esModule", {
  value: true
});
bannerRole$1.default = void 0;
var bannerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ["direct descendant of document"],
      name: "header"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1Z = bannerRole;
bannerRole$1.default = _default$1Z;
var blockquoteRole$1 = {};
Object.defineProperty(blockquoteRole$1, "__esModule", {
  value: true
});
blockquoteRole$1.default = void 0;
var blockquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1Y = blockquoteRole;
blockquoteRole$1.default = _default$1Y;
var buttonRole$1 = {};
Object.defineProperty(buttonRole$1, "__esModule", {
  value: true
});
buttonRole$1.default = void 0;
var buttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-pressed": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-pressed"
      }, {
        name: "type",
        value: "checkbox"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "aria-expanded",
        value: "false"
      }],
      name: "summary"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "aria-expanded",
        value: "true"
      }],
      constraints: ["direct descendant of details element with the open attribute defined"],
      name: "summary"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "button"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "image"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "reset"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "type",
        value: "submit"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      name: "button"
    },
    module: "HTML"
  }, {
    concept: {
      name: "trigger"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command"]]
};
var _default$1X = buttonRole;
buttonRole$1.default = _default$1X;
var captionRole$1 = {};
Object.defineProperty(captionRole$1, "__esModule", {
  value: true
});
captionRole$1.default = void 0;
var captionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: ["figure", "grid", "table"],
  requiredContextRole: ["figure", "grid", "table"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1W = captionRole;
captionRole$1.default = _default$1W;
var cellRole$1 = {};
Object.defineProperty(cellRole$1, "__esModule", {
  value: true
});
cellRole$1.default = void 0;
var cellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-colindex": null,
    "aria-colspan": null,
    "aria-rowindex": null,
    "aria-rowspan": null
  },
  relatedConcepts: [{
    concept: {
      constraints: ["descendant of table"],
      name: "td"
    },
    module: "HTML"
  }],
  requireContextRole: ["row"],
  requiredContextRole: ["row"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1V = cellRole;
cellRole$1.default = _default$1V;
var checkboxRole$1 = {};
Object.defineProperty(checkboxRole$1, "__esModule", {
  value: true
});
checkboxRole$1.default = void 0;
var checkboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-checked": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "checkbox"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      name: "option"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input"]]
};
var _default$1U = checkboxRole;
checkboxRole$1.default = _default$1U;
var codeRole$1 = {};
Object.defineProperty(codeRole$1, "__esModule", {
  value: true
});
codeRole$1.default = void 0;
var codeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1T = codeRole;
codeRole$1.default = _default$1T;
var columnheaderRole$1 = {};
Object.defineProperty(columnheaderRole$1, "__esModule", {
  value: true
});
columnheaderRole$1.default = void 0;
var columnheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-sort": null
  },
  relatedConcepts: [{
    attributes: [{
      name: "scope",
      value: "col"
    }],
    concept: {
      name: "th"
    },
    module: "HTML"
  }],
  requireContextRole: ["row"],
  requiredContextRole: ["row"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widget", "gridcell"], ["roletype", "structure", "sectionhead"]]
};
var _default$1S = columnheaderRole;
columnheaderRole$1.default = _default$1S;
var comboboxRole$1 = {};
Object.defineProperty(comboboxRole$1, "__esModule", {
  value: true
});
comboboxRole$1.default = void 0;
var comboboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-autocomplete": null,
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-expanded": "false",
    "aria-haspopup": "listbox"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "email"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "search"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "tel"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "text"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "url"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "list"
      }, {
        name: "type",
        value: "url"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "multiple"
      }, {
        constraints: ["undefined"],
        name: "size"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "multiple"
      }, {
        name: "size",
        value: 1
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      name: "select"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-controls": null,
    "aria-expanded": "false"
  },
  superClass: [["roletype", "widget", "input"]]
};
var _default$1R = comboboxRole;
comboboxRole$1.default = _default$1R;
var complementaryRole$1 = {};
Object.defineProperty(complementaryRole$1, "__esModule", {
  value: true
});
complementaryRole$1.default = void 0;
var complementaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "aside"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1Q = complementaryRole;
complementaryRole$1.default = _default$1Q;
var contentinfoRole$1 = {};
Object.defineProperty(contentinfoRole$1, "__esModule", {
  value: true
});
contentinfoRole$1.default = void 0;
var contentinfoRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      constraints: ["direct descendant of document"],
      name: "footer"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1P = contentinfoRole;
contentinfoRole$1.default = _default$1P;
var definitionRole$1 = {};
Object.defineProperty(definitionRole$1, "__esModule", {
  value: true
});
definitionRole$1.default = void 0;
var definitionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "dd"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1O = definitionRole;
definitionRole$1.default = _default$1O;
var deletionRole$1 = {};
Object.defineProperty(deletionRole$1, "__esModule", {
  value: true
});
deletionRole$1.default = void 0;
var deletionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1N = deletionRole;
deletionRole$1.default = _default$1N;
var dialogRole$1 = {};
Object.defineProperty(dialogRole$1, "__esModule", {
  value: true
});
dialogRole$1.default = void 0;
var dialogRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "dialog"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "window"]]
};
var _default$1M = dialogRole;
dialogRole$1.default = _default$1M;
var directoryRole$1 = {};
Object.defineProperty(directoryRole$1, "__esModule", {
  value: true
});
directoryRole$1.default = void 0;
var directoryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    module: "DAISY Guide"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "list"]]
};
var _default$1L = directoryRole;
directoryRole$1.default = _default$1L;
var documentRole$1 = {};
Object.defineProperty(documentRole$1, "__esModule", {
  value: true
});
documentRole$1.default = void 0;
var documentRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "Device Independence Delivery Unit"
    }
  }, {
    concept: {
      name: "body"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$1K = documentRole;
documentRole$1.default = _default$1K;
var emphasisRole$1 = {};
Object.defineProperty(emphasisRole$1, "__esModule", {
  value: true
});
emphasisRole$1.default = void 0;
var emphasisRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1J = emphasisRole;
emphasisRole$1.default = _default$1J;
var feedRole$1 = {};
Object.defineProperty(feedRole$1, "__esModule", {
  value: true
});
feedRole$1.default = void 0;
var feedRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["article"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "list"]]
};
var _default$1I = feedRole;
feedRole$1.default = _default$1I;
var figureRole$1 = {};
Object.defineProperty(figureRole$1, "__esModule", {
  value: true
});
figureRole$1.default = void 0;
var figureRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "figure"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1H = figureRole;
figureRole$1.default = _default$1H;
var formRole$1 = {};
Object.defineProperty(formRole$1, "__esModule", {
  value: true
});
formRole$1.default = void 0;
var formRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-label"
      }],
      name: "form"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-labelledby"
      }],
      name: "form"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "name"
      }],
      name: "form"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1G = formRole;
formRole$1.default = _default$1G;
var genericRole$1 = {};
Object.defineProperty(genericRole$1, "__esModule", {
  value: true
});
genericRole$1.default = void 0;
var genericRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "span"
    },
    module: "HTML"
  }, {
    concept: {
      name: "div"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$1F = genericRole;
genericRole$1.default = _default$1F;
var gridRole$1 = {};
Object.defineProperty(gridRole$1, "__esModule", {
  value: true
});
gridRole$1.default = void 0;
var gridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-multiselectable": null,
    "aria-readonly": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "role",
        value: "grid"
      }],
      name: "table"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["row"], ["row", "rowgroup"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"], ["roletype", "structure", "section", "table"]]
};
var _default$1E = gridRole;
gridRole$1.default = _default$1E;
var gridcellRole$1 = {};
Object.defineProperty(gridcellRole$1, "__esModule", {
  value: true
});
gridcellRole$1.default = void 0;
var gridcellRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-selected": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "role",
        value: "gridcell"
      }],
      name: "td"
    },
    module: "HTML"
  }],
  requireContextRole: ["row"],
  requiredContextRole: ["row"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "cell"], ["roletype", "widget"]]
};
var _default$1D = gridcellRole;
gridcellRole$1.default = _default$1D;
var groupRole$1 = {};
Object.defineProperty(groupRole$1, "__esModule", {
  value: true
});
groupRole$1.default = void 0;
var groupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-disabled": null
  },
  relatedConcepts: [{
    concept: {
      name: "details"
    },
    module: "HTML"
  }, {
    concept: {
      name: "fieldset"
    },
    module: "HTML"
  }, {
    concept: {
      name: "optgroup"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1C = groupRole;
groupRole$1.default = _default$1C;
var headingRole$1 = {};
Object.defineProperty(headingRole$1, "__esModule", {
  value: true
});
headingRole$1.default = void 0;
var headingRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-level": "2"
  },
  relatedConcepts: [{
    concept: {
      name: "h1"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h2"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h3"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h4"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h5"
    },
    module: "HTML"
  }, {
    concept: {
      name: "h6"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-level": "2"
  },
  superClass: [["roletype", "structure", "sectionhead"]]
};
var _default$1B = headingRole;
headingRole$1.default = _default$1B;
var imgRole$1 = {};
Object.defineProperty(imgRole$1, "__esModule", {
  value: true
});
imgRole$1.default = void 0;
var imgRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "alt"
      }],
      name: "img"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "alt"
      }],
      name: "img"
    },
    module: "HTML"
  }, {
    concept: {
      name: "imggroup"
    },
    module: "DTB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1A = imgRole;
imgRole$1.default = _default$1A;
var insertionRole$1 = {};
Object.defineProperty(insertionRole$1, "__esModule", {
  value: true
});
insertionRole$1.default = void 0;
var insertionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1z = insertionRole;
insertionRole$1.default = _default$1z;
var linkRole$1 = {};
Object.defineProperty(linkRole$1, "__esModule", {
  value: true
});
linkRole$1.default = void 0;
var linkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "href"
      }],
      name: "a"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "href"
      }],
      name: "area"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "href"
      }],
      name: "link"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command"]]
};
var _default$1y = linkRole;
linkRole$1.default = _default$1y;
var listRole$1 = {};
Object.defineProperty(listRole$1, "__esModule", {
  value: true
});
listRole$1.default = void 0;
var listRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menu"
    },
    module: "HTML"
  }, {
    concept: {
      name: "ol"
    },
    module: "HTML"
  }, {
    concept: {
      name: "ul"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["listitem"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1x = listRole;
listRole$1.default = _default$1x;
var listboxRole$1 = {};
Object.defineProperty(listboxRole$1, "__esModule", {
  value: true
});
listboxRole$1.default = void 0;
var listboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-invalid": null,
    "aria-multiselectable": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-orientation": "vertical"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: [">1"],
        name: "size"
      }, {
        name: "multiple"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: [">1"],
        name: "size"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "multiple"
      }],
      name: "select"
    },
    module: "HTML"
  }, {
    concept: {
      name: "datalist"
    },
    module: "HTML"
  }, {
    concept: {
      name: "list"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "select"
    },
    module: "XForms"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["option", "group"], ["option"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
};
var _default$1w = listboxRole;
listboxRole$1.default = _default$1w;
var listitemRole$1 = {};
Object.defineProperty(listitemRole$1, "__esModule", {
  value: true
});
listitemRole$1.default = void 0;
var listitemRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-level": null,
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      constraints: ["direct descendant of ol, ul or menu"],
      name: "li"
    },
    module: "HTML"
  }, {
    concept: {
      name: "item"
    },
    module: "XForms"
  }],
  requireContextRole: ["directory", "list"],
  requiredContextRole: ["directory", "list"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1v = listitemRole;
listitemRole$1.default = _default$1v;
var logRole$1 = {};
Object.defineProperty(logRole$1, "__esModule", {
  value: true
});
logRole$1.default = void 0;
var logRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-live": "polite"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1u = logRole;
logRole$1.default = _default$1u;
var mainRole$1 = {};
Object.defineProperty(mainRole$1, "__esModule", {
  value: true
});
mainRole$1.default = void 0;
var mainRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "main"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1t = mainRole;
mainRole$1.default = _default$1t;
var marqueeRole$1 = {};
Object.defineProperty(marqueeRole$1, "__esModule", {
  value: true
});
marqueeRole$1.default = void 0;
var marqueeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1s = marqueeRole;
marqueeRole$1.default = _default$1s;
var mathRole$1 = {};
Object.defineProperty(mathRole$1, "__esModule", {
  value: true
});
mathRole$1.default = void 0;
var mathRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "math"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1r = mathRole;
mathRole$1.default = _default$1r;
var menuRole$1 = {};
Object.defineProperty(menuRole$1, "__esModule", {
  value: true
});
menuRole$1.default = void 0;
var menuRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": "vertical"
  },
  relatedConcepts: [{
    concept: {
      name: "MENU"
    },
    module: "JAPI"
  }, {
    concept: {
      name: "list"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "select"
    },
    module: "XForms"
  }, {
    concept: {
      name: "sidebar"
    },
    module: "DTB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckbox"], ["menuitemradio"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
};
var _default$1q = menuRole;
menuRole$1.default = _default$1q;
var menubarRole$1 = {};
Object.defineProperty(menubarRole$1, "__esModule", {
  value: true
});
menubarRole$1.default = void 0;
var menubarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": "horizontal"
  },
  relatedConcepts: [{
    concept: {
      name: "toolbar"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["menuitem", "group"], ["menuitemradio", "group"], ["menuitemcheckbox", "group"], ["menuitem"], ["menuitemcheckbox"], ["menuitemradio"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select", "menu"], ["roletype", "structure", "section", "group", "select", "menu"]]
};
var _default$1p = menubarRole;
menubarRole$1.default = _default$1p;
var menuitemRole$1 = {};
Object.defineProperty(menuitemRole$1, "__esModule", {
  value: true
});
menuitemRole$1.default = void 0;
var menuitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      name: "MENU_ITEM"
    },
    module: "JAPI"
  }, {
    concept: {
      name: "listitem"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "menuitem"
    },
    module: "HTML"
  }, {
    concept: {
      name: "option"
    },
    module: "ARIA"
  }],
  requireContextRole: ["group", "menu", "menubar"],
  requiredContextRole: ["group", "menu", "menubar"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command"]]
};
var _default$1o = menuitemRole;
menuitemRole$1.default = _default$1o;
var menuitemcheckboxRole$1 = {};
Object.defineProperty(menuitemcheckboxRole$1, "__esModule", {
  value: true
});
menuitemcheckboxRole$1.default = void 0;
var menuitemcheckboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menuitem"
    },
    module: "ARIA"
  }],
  requireContextRole: ["group", "menu", "menubar"],
  requiredContextRole: ["group", "menu", "menubar"],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input", "checkbox"], ["roletype", "widget", "command", "menuitem"]]
};
var _default$1n = menuitemcheckboxRole;
menuitemcheckboxRole$1.default = _default$1n;
var menuitemradioRole$1 = {};
Object.defineProperty(menuitemradioRole$1, "__esModule", {
  value: true
});
menuitemradioRole$1.default = void 0;
var menuitemradioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "menuitem"
    },
    module: "ARIA"
  }],
  requireContextRole: ["group", "menu", "menubar"],
  requiredContextRole: ["group", "menu", "menubar"],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input", "checkbox", "menuitemcheckbox"], ["roletype", "widget", "command", "menuitem", "menuitemcheckbox"], ["roletype", "widget", "input", "radio"]]
};
var _default$1m = menuitemradioRole;
menuitemradioRole$1.default = _default$1m;
var meterRole$1 = {};
Object.defineProperty(meterRole$1, "__esModule", {
  value: true
});
meterRole$1.default = void 0;
var meterRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-valuetext": null,
    "aria-valuemax": "100",
    "aria-valuemin": "0"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-valuenow": null
  },
  superClass: [["roletype", "structure", "range"]]
};
var _default$1l = meterRole;
meterRole$1.default = _default$1l;
var navigationRole$1 = {};
Object.defineProperty(navigationRole$1, "__esModule", {
  value: true
});
navigationRole$1.default = void 0;
var navigationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "nav"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1k = navigationRole;
navigationRole$1.default = _default$1k;
var noneRole$1 = {};
Object.defineProperty(noneRole$1, "__esModule", {
  value: true
});
noneRole$1.default = void 0;
var noneRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: [],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: []
};
var _default$1j = noneRole;
noneRole$1.default = _default$1j;
var noteRole$1 = {};
Object.defineProperty(noteRole$1, "__esModule", {
  value: true
});
noteRole$1.default = void 0;
var noteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1i = noteRole;
noteRole$1.default = _default$1i;
var optionRole$1 = {};
Object.defineProperty(optionRole$1, "__esModule", {
  value: true
});
optionRole$1.default = void 0;
var optionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-checked": null,
    "aria-posinset": null,
    "aria-setsize": null,
    "aria-selected": "false"
  },
  relatedConcepts: [{
    concept: {
      name: "item"
    },
    module: "XForms"
  }, {
    concept: {
      name: "listitem"
    },
    module: "ARIA"
  }, {
    concept: {
      name: "option"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-selected": "false"
  },
  superClass: [["roletype", "widget", "input"]]
};
var _default$1h = optionRole;
optionRole$1.default = _default$1h;
var paragraphRole$1 = {};
Object.defineProperty(paragraphRole$1, "__esModule", {
  value: true
});
paragraphRole$1.default = void 0;
var paragraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$1g = paragraphRole;
paragraphRole$1.default = _default$1g;
var presentationRole$1 = {};
Object.defineProperty(presentationRole$1, "__esModule", {
  value: true
});
presentationRole$1.default = void 0;
var presentationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$1f = presentationRole;
presentationRole$1.default = _default$1f;
var progressbarRole$1 = {};
Object.defineProperty(progressbarRole$1, "__esModule", {
  value: true
});
progressbarRole$1.default = void 0;
var progressbarRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-valuetext": null
  },
  relatedConcepts: [{
    concept: {
      name: "progress"
    },
    module: "HTML"
  }, {
    concept: {
      name: "status"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
};
var _default$1e = progressbarRole;
progressbarRole$1.default = _default$1e;
var radioRole$1 = {};
Object.defineProperty(radioRole$1, "__esModule", {
  value: true
});
radioRole$1.default = void 0;
var radioRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-checked": null,
    "aria-posinset": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "radio"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input"]]
};
var _default$1d = radioRole;
radioRole$1.default = _default$1d;
var radiogroupRole$1 = {};
Object.defineProperty(radiogroupRole$1, "__esModule", {
  value: true
});
radiogroupRole$1.default = void 0;
var radiogroupRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null
  },
  relatedConcepts: [{
    concept: {
      name: "list"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["radio"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
};
var _default$1c = radiogroupRole;
radiogroupRole$1.default = _default$1c;
var regionRole$1 = {};
Object.defineProperty(regionRole$1, "__esModule", {
  value: true
});
regionRole$1.default = void 0;
var regionRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-label"
      }],
      name: "section"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["set"],
        name: "aria-labelledby"
      }],
      name: "section"
    },
    module: "HTML"
  }, {
    concept: {
      name: "Device Independence Glossart perceivable unit"
    }
  }, {
    concept: {
      name: "frame"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$1b = regionRole;
regionRole$1.default = _default$1b;
var rowRole$1 = {};
Object.defineProperty(rowRole$1, "__esModule", {
  value: true
});
rowRole$1.default = void 0;
var rowRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-colindex": null,
    "aria-expanded": null,
    "aria-level": null,
    "aria-posinset": null,
    "aria-rowindex": null,
    "aria-selected": null,
    "aria-setsize": null
  },
  relatedConcepts: [{
    concept: {
      name: "tr"
    },
    module: "HTML"
  }],
  requireContextRole: ["grid", "rowgroup", "table", "treegrid"],
  requiredContextRole: ["grid", "rowgroup", "table", "treegrid"],
  requiredOwnedElements: [["cell"], ["columnheader"], ["gridcell"], ["rowheader"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "group"], ["roletype", "widget"]]
};
var _default$1a = rowRole;
rowRole$1.default = _default$1a;
var rowgroupRole$1 = {};
Object.defineProperty(rowgroupRole$1, "__esModule", {
  value: true
});
rowgroupRole$1.default = void 0;
var rowgroupRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "tbody"
    },
    module: "HTML"
  }, {
    concept: {
      name: "tfoot"
    },
    module: "HTML"
  }, {
    concept: {
      name: "thead"
    },
    module: "HTML"
  }],
  requireContextRole: ["grid", "table", "treegrid"],
  requiredContextRole: ["grid", "table", "treegrid"],
  requiredOwnedElements: [["row"]],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$19 = rowgroupRole;
rowgroupRole$1.default = _default$19;
var rowheaderRole$1 = {};
Object.defineProperty(rowheaderRole$1, "__esModule", {
  value: true
});
rowheaderRole$1.default = void 0;
var rowheaderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-sort": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "scope",
        value: "row"
      }],
      name: "th"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        name: "scope",
        value: "rowgroup"
      }],
      name: "th"
    },
    module: "HTML"
  }],
  requireContextRole: ["row", "rowgroup"],
  requiredContextRole: ["row", "rowgroup"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "cell"], ["roletype", "structure", "section", "cell", "gridcell"], ["roletype", "widget", "gridcell"], ["roletype", "structure", "sectionhead"]]
};
var _default$18 = rowheaderRole;
rowheaderRole$1.default = _default$18;
var scrollbarRole$1 = {};
Object.defineProperty(scrollbarRole$1, "__esModule", {
  value: true
});
scrollbarRole$1.default = void 0;
var scrollbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-valuetext": null,
    "aria-orientation": "vertical",
    "aria-valuemax": "100",
    "aria-valuemin": "0"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-controls": null,
    "aria-valuenow": null
  },
  superClass: [["roletype", "structure", "range"], ["roletype", "widget"]]
};
var _default$17 = scrollbarRole;
scrollbarRole$1.default = _default$17;
var searchRole$1 = {};
Object.defineProperty(searchRole$1, "__esModule", {
  value: true
});
searchRole$1.default = void 0;
var searchRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$16 = searchRole;
searchRole$1.default = _default$16;
var searchboxRole$1 = {};
Object.defineProperty(searchboxRole$1, "__esModule", {
  value: true
});
searchboxRole$1.default = void 0;
var searchboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "search"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "input", "textbox"]]
};
var _default$15 = searchboxRole;
searchboxRole$1.default = _default$15;
var separatorRole$1 = {};
Object.defineProperty(separatorRole$1, "__esModule", {
  value: true
});
separatorRole$1.default = void 0;
var separatorRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-orientation": "horizontal",
    "aria-valuemax": "100",
    "aria-valuemin": "0",
    "aria-valuenow": null,
    "aria-valuetext": null
  },
  relatedConcepts: [{
    concept: {
      name: "hr"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure"]]
};
var _default$14 = separatorRole;
separatorRole$1.default = _default$14;
var sliderRole$1 = {};
Object.defineProperty(sliderRole$1, "__esModule", {
  value: true
});
sliderRole$1.default = void 0;
var sliderRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-haspopup": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-valuetext": null,
    "aria-orientation": "horizontal",
    "aria-valuemax": "100",
    "aria-valuemin": "0"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "range"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-valuenow": null
  },
  superClass: [["roletype", "widget", "input"], ["roletype", "structure", "range"]]
};
var _default$13 = sliderRole;
sliderRole$1.default = _default$13;
var spinbuttonRole$1 = {};
Object.defineProperty(spinbuttonRole$1, "__esModule", {
  value: true
});
spinbuttonRole$1.default = void 0;
var spinbuttonRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-readonly": null,
    "aria-required": null,
    "aria-valuetext": null,
    "aria-valuenow": "0"
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        name: "type",
        value: "number"
      }],
      name: "input"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"], ["roletype", "widget", "input"], ["roletype", "structure", "range"]]
};
var _default$12 = spinbuttonRole;
spinbuttonRole$1.default = _default$12;
var statusRole$1 = {};
Object.defineProperty(statusRole$1, "__esModule", {
  value: true
});
statusRole$1.default = void 0;
var statusRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-atomic": "true",
    "aria-live": "polite"
  },
  relatedConcepts: [{
    concept: {
      name: "output"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$11 = statusRole;
statusRole$1.default = _default$11;
var strongRole$1 = {};
Object.defineProperty(strongRole$1, "__esModule", {
  value: true
});
strongRole$1.default = void 0;
var strongRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$10 = strongRole;
strongRole$1.default = _default$10;
var subscriptRole$1 = {};
Object.defineProperty(subscriptRole$1, "__esModule", {
  value: true
});
subscriptRole$1.default = void 0;
var subscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$$ = subscriptRole;
subscriptRole$1.default = _default$$;
var superscriptRole$1 = {};
Object.defineProperty(superscriptRole$1, "__esModule", {
  value: true
});
superscriptRole$1.default = void 0;
var superscriptRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["prohibited"],
  prohibitedProps: ["aria-label", "aria-labelledby"],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$_ = superscriptRole;
superscriptRole$1.default = _default$_;
var switchRole$1 = {};
Object.defineProperty(switchRole$1, "__esModule", {
  value: true
});
switchRole$1.default = void 0;
var switchRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "button"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-checked": null
  },
  superClass: [["roletype", "widget", "input", "checkbox"]]
};
var _default$Z = switchRole;
switchRole$1.default = _default$Z;
var tabRole$1 = {};
Object.defineProperty(tabRole$1, "__esModule", {
  value: true
});
tabRole$1.default = void 0;
var tabRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-posinset": null,
    "aria-setsize": null,
    "aria-selected": "false"
  },
  relatedConcepts: [],
  requireContextRole: ["tablist"],
  requiredContextRole: ["tablist"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "sectionhead"], ["roletype", "widget"]]
};
var _default$Y = tabRole;
tabRole$1.default = _default$Y;
var tableRole$1 = {};
Object.defineProperty(tableRole$1, "__esModule", {
  value: true
});
tableRole$1.default = void 0;
var tableRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-colcount": null,
    "aria-rowcount": null
  },
  relatedConcepts: [{
    concept: {
      name: "table"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["row"], ["row", "rowgroup"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$X = tableRole;
tableRole$1.default = _default$X;
var tablistRole$1 = {};
Object.defineProperty(tablistRole$1, "__esModule", {
  value: true
});
tablistRole$1.default = void 0;
var tablistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-level": null,
    "aria-multiselectable": null,
    "aria-orientation": "horizontal"
  },
  relatedConcepts: [{
    module: "DAISY",
    concept: {
      name: "guide"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["tab"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite"]]
};
var _default$W = tablistRole;
tablistRole$1.default = _default$W;
var tabpanelRole$1 = {};
Object.defineProperty(tabpanelRole$1, "__esModule", {
  value: true
});
tabpanelRole$1.default = void 0;
var tabpanelRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$V = tabpanelRole;
tabpanelRole$1.default = _default$V;
var termRole$1 = {};
Object.defineProperty(termRole$1, "__esModule", {
  value: true
});
termRole$1.default = void 0;
var termRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "dfn"
    },
    module: "HTML"
  }, {
    concept: {
      name: "dt"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$U = termRole;
termRole$1.default = _default$U;
var textboxRole$1 = {};
Object.defineProperty(textboxRole$1, "__esModule", {
  value: true
});
textboxRole$1.default = void 0;
var textboxRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-activedescendant": null,
    "aria-autocomplete": null,
    "aria-errormessage": null,
    "aria-haspopup": null,
    "aria-invalid": null,
    "aria-multiline": null,
    "aria-placeholder": null,
    "aria-readonly": null,
    "aria-required": null
  },
  relatedConcepts: [{
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "type"
      }, {
        constraints: ["undefined"],
        name: "list"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "email"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "tel"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "text"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      attributes: [{
        constraints: ["undefined"],
        name: "list"
      }, {
        name: "type",
        value: "url"
      }],
      name: "input"
    },
    module: "HTML"
  }, {
    concept: {
      name: "input"
    },
    module: "XForms"
  }, {
    concept: {
      name: "textarea"
    },
    module: "HTML"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "input"]]
};
var _default$T = textboxRole;
textboxRole$1.default = _default$T;
var timeRole$1 = {};
Object.defineProperty(timeRole$1, "__esModule", {
  value: true
});
timeRole$1.default = void 0;
var timeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$S = timeRole;
timeRole$1.default = _default$S;
var timerRole$1 = {};
Object.defineProperty(timerRole$1, "__esModule", {
  value: true
});
timerRole$1.default = void 0;
var timerRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "status"]]
};
var _default$R = timerRole;
timerRole$1.default = _default$R;
var toolbarRole$1 = {};
Object.defineProperty(toolbarRole$1, "__esModule", {
  value: true
});
toolbarRole$1.default = void 0;
var toolbarRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-orientation": "horizontal"
  },
  relatedConcepts: [{
    concept: {
      name: "menubar"
    },
    module: "ARIA"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "group"]]
};
var _default$Q = toolbarRole;
toolbarRole$1.default = _default$Q;
var tooltipRole$1 = {};
Object.defineProperty(tooltipRole$1, "__esModule", {
  value: true
});
tooltipRole$1.default = void 0;
var tooltipRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$P = tooltipRole;
tooltipRole$1.default = _default$P;
var treeRole$1 = {};
Object.defineProperty(treeRole$1, "__esModule", {
  value: true
});
treeRole$1.default = void 0;
var treeRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null,
    "aria-multiselectable": null,
    "aria-required": null,
    "aria-orientation": "vertical"
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["treeitem", "group"], ["treeitem"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "select"], ["roletype", "structure", "section", "group", "select"]]
};
var _default$O = treeRole;
treeRole$1.default = _default$O;
var treegridRole$1 = {};
Object.defineProperty(treegridRole$1, "__esModule", {
  value: true
});
treegridRole$1.default = void 0;
var treegridRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["row"], ["row", "rowgroup"]],
  requiredProps: {},
  superClass: [["roletype", "widget", "composite", "grid"], ["roletype", "structure", "section", "table", "grid"], ["roletype", "widget", "composite", "select", "tree"], ["roletype", "structure", "section", "group", "select", "tree"]]
};
var _default$N = treegridRole;
treegridRole$1.default = _default$N;
var treeitemRole$1 = {};
Object.defineProperty(treeitemRole$1, "__esModule", {
  value: true
});
treeitemRole$1.default = void 0;
var treeitemRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-expanded": null,
    "aria-haspopup": null
  },
  relatedConcepts: [],
  requireContextRole: ["group", "tree"],
  requiredContextRole: ["group", "tree"],
  requiredOwnedElements: [],
  requiredProps: {
    "aria-selected": null
  },
  superClass: [["roletype", "structure", "section", "listitem"], ["roletype", "widget", "input", "option"]]
};
var _default$M = treeitemRole;
treeitemRole$1.default = _default$M;
Object.defineProperty(ariaLiteralRoles$1, "__esModule", {
  value: true
});
ariaLiteralRoles$1.default = void 0;
var _alertRole = _interopRequireDefault$6(alertRole$1);
var _alertdialogRole = _interopRequireDefault$6(alertdialogRole$1);
var _applicationRole = _interopRequireDefault$6(applicationRole$1);
var _articleRole = _interopRequireDefault$6(articleRole$1);
var _bannerRole = _interopRequireDefault$6(bannerRole$1);
var _blockquoteRole = _interopRequireDefault$6(blockquoteRole$1);
var _buttonRole = _interopRequireDefault$6(buttonRole$1);
var _captionRole = _interopRequireDefault$6(captionRole$1);
var _cellRole = _interopRequireDefault$6(cellRole$1);
var _checkboxRole = _interopRequireDefault$6(checkboxRole$1);
var _codeRole = _interopRequireDefault$6(codeRole$1);
var _columnheaderRole = _interopRequireDefault$6(columnheaderRole$1);
var _comboboxRole = _interopRequireDefault$6(comboboxRole$1);
var _complementaryRole = _interopRequireDefault$6(complementaryRole$1);
var _contentinfoRole = _interopRequireDefault$6(contentinfoRole$1);
var _definitionRole = _interopRequireDefault$6(definitionRole$1);
var _deletionRole = _interopRequireDefault$6(deletionRole$1);
var _dialogRole = _interopRequireDefault$6(dialogRole$1);
var _directoryRole = _interopRequireDefault$6(directoryRole$1);
var _documentRole = _interopRequireDefault$6(documentRole$1);
var _emphasisRole = _interopRequireDefault$6(emphasisRole$1);
var _feedRole = _interopRequireDefault$6(feedRole$1);
var _figureRole = _interopRequireDefault$6(figureRole$1);
var _formRole = _interopRequireDefault$6(formRole$1);
var _genericRole = _interopRequireDefault$6(genericRole$1);
var _gridRole = _interopRequireDefault$6(gridRole$1);
var _gridcellRole = _interopRequireDefault$6(gridcellRole$1);
var _groupRole = _interopRequireDefault$6(groupRole$1);
var _headingRole = _interopRequireDefault$6(headingRole$1);
var _imgRole = _interopRequireDefault$6(imgRole$1);
var _insertionRole = _interopRequireDefault$6(insertionRole$1);
var _linkRole = _interopRequireDefault$6(linkRole$1);
var _listRole = _interopRequireDefault$6(listRole$1);
var _listboxRole = _interopRequireDefault$6(listboxRole$1);
var _listitemRole = _interopRequireDefault$6(listitemRole$1);
var _logRole = _interopRequireDefault$6(logRole$1);
var _mainRole = _interopRequireDefault$6(mainRole$1);
var _marqueeRole = _interopRequireDefault$6(marqueeRole$1);
var _mathRole = _interopRequireDefault$6(mathRole$1);
var _menuRole = _interopRequireDefault$6(menuRole$1);
var _menubarRole = _interopRequireDefault$6(menubarRole$1);
var _menuitemRole = _interopRequireDefault$6(menuitemRole$1);
var _menuitemcheckboxRole = _interopRequireDefault$6(menuitemcheckboxRole$1);
var _menuitemradioRole = _interopRequireDefault$6(menuitemradioRole$1);
var _meterRole = _interopRequireDefault$6(meterRole$1);
var _navigationRole = _interopRequireDefault$6(navigationRole$1);
var _noneRole = _interopRequireDefault$6(noneRole$1);
var _noteRole = _interopRequireDefault$6(noteRole$1);
var _optionRole = _interopRequireDefault$6(optionRole$1);
var _paragraphRole = _interopRequireDefault$6(paragraphRole$1);
var _presentationRole = _interopRequireDefault$6(presentationRole$1);
var _progressbarRole = _interopRequireDefault$6(progressbarRole$1);
var _radioRole = _interopRequireDefault$6(radioRole$1);
var _radiogroupRole = _interopRequireDefault$6(radiogroupRole$1);
var _regionRole = _interopRequireDefault$6(regionRole$1);
var _rowRole = _interopRequireDefault$6(rowRole$1);
var _rowgroupRole = _interopRequireDefault$6(rowgroupRole$1);
var _rowheaderRole = _interopRequireDefault$6(rowheaderRole$1);
var _scrollbarRole = _interopRequireDefault$6(scrollbarRole$1);
var _searchRole = _interopRequireDefault$6(searchRole$1);
var _searchboxRole = _interopRequireDefault$6(searchboxRole$1);
var _separatorRole = _interopRequireDefault$6(separatorRole$1);
var _sliderRole = _interopRequireDefault$6(sliderRole$1);
var _spinbuttonRole = _interopRequireDefault$6(spinbuttonRole$1);
var _statusRole = _interopRequireDefault$6(statusRole$1);
var _strongRole = _interopRequireDefault$6(strongRole$1);
var _subscriptRole = _interopRequireDefault$6(subscriptRole$1);
var _superscriptRole = _interopRequireDefault$6(superscriptRole$1);
var _switchRole = _interopRequireDefault$6(switchRole$1);
var _tabRole = _interopRequireDefault$6(tabRole$1);
var _tableRole = _interopRequireDefault$6(tableRole$1);
var _tablistRole = _interopRequireDefault$6(tablistRole$1);
var _tabpanelRole = _interopRequireDefault$6(tabpanelRole$1);
var _termRole = _interopRequireDefault$6(termRole$1);
var _textboxRole = _interopRequireDefault$6(textboxRole$1);
var _timeRole = _interopRequireDefault$6(timeRole$1);
var _timerRole = _interopRequireDefault$6(timerRole$1);
var _toolbarRole = _interopRequireDefault$6(toolbarRole$1);
var _tooltipRole = _interopRequireDefault$6(tooltipRole$1);
var _treeRole = _interopRequireDefault$6(treeRole$1);
var _treegridRole = _interopRequireDefault$6(treegridRole$1);
var _treeitemRole = _interopRequireDefault$6(treeitemRole$1);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var ariaLiteralRoles = [["alert", _alertRole.default], ["alertdialog", _alertdialogRole.default], ["application", _applicationRole.default], ["article", _articleRole.default], ["banner", _bannerRole.default], ["blockquote", _blockquoteRole.default], ["button", _buttonRole.default], ["caption", _captionRole.default], ["cell", _cellRole.default], ["checkbox", _checkboxRole.default], ["code", _codeRole.default], ["columnheader", _columnheaderRole.default], ["combobox", _comboboxRole.default], ["complementary", _complementaryRole.default], ["contentinfo", _contentinfoRole.default], ["definition", _definitionRole.default], ["deletion", _deletionRole.default], ["dialog", _dialogRole.default], ["directory", _directoryRole.default], ["document", _documentRole.default], ["emphasis", _emphasisRole.default], ["feed", _feedRole.default], ["figure", _figureRole.default], ["form", _formRole.default], ["generic", _genericRole.default], ["grid", _gridRole.default], ["gridcell", _gridcellRole.default], ["group", _groupRole.default], ["heading", _headingRole.default], ["img", _imgRole.default], ["insertion", _insertionRole.default], ["link", _linkRole.default], ["list", _listRole.default], ["listbox", _listboxRole.default], ["listitem", _listitemRole.default], ["log", _logRole.default], ["main", _mainRole.default], ["marquee", _marqueeRole.default], ["math", _mathRole.default], ["menu", _menuRole.default], ["menubar", _menubarRole.default], ["menuitem", _menuitemRole.default], ["menuitemcheckbox", _menuitemcheckboxRole.default], ["menuitemradio", _menuitemradioRole.default], ["meter", _meterRole.default], ["navigation", _navigationRole.default], ["none", _noneRole.default], ["note", _noteRole.default], ["option", _optionRole.default], ["paragraph", _paragraphRole.default], ["presentation", _presentationRole.default], ["progressbar", _progressbarRole.default], ["radio", _radioRole.default], ["radiogroup", _radiogroupRole.default], ["region", _regionRole.default], ["row", _rowRole.default], ["rowgroup", _rowgroupRole.default], ["rowheader", _rowheaderRole.default], ["scrollbar", _scrollbarRole.default], ["search", _searchRole.default], ["searchbox", _searchboxRole.default], ["separator", _separatorRole.default], ["slider", _sliderRole.default], ["spinbutton", _spinbuttonRole.default], ["status", _statusRole.default], ["strong", _strongRole.default], ["subscript", _subscriptRole.default], ["superscript", _superscriptRole.default], ["switch", _switchRole.default], ["tab", _tabRole.default], ["table", _tableRole.default], ["tablist", _tablistRole.default], ["tabpanel", _tabpanelRole.default], ["term", _termRole.default], ["textbox", _textboxRole.default], ["time", _timeRole.default], ["timer", _timerRole.default], ["toolbar", _toolbarRole.default], ["tooltip", _tooltipRole.default], ["tree", _treeRole.default], ["treegrid", _treegridRole.default], ["treeitem", _treeitemRole.default]];
var _default$L = ariaLiteralRoles;
ariaLiteralRoles$1.default = _default$L;
var ariaDpubRoles$1 = {};
var docAbstractRole$1 = {};
Object.defineProperty(docAbstractRole$1, "__esModule", {
  value: true
});
docAbstractRole$1.default = void 0;
var docAbstractRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "abstract [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$K = docAbstractRole;
docAbstractRole$1.default = _default$K;
var docAcknowledgmentsRole$1 = {};
Object.defineProperty(docAcknowledgmentsRole$1, "__esModule", {
  value: true
});
docAcknowledgmentsRole$1.default = void 0;
var docAcknowledgmentsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "acknowledgments [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$J = docAcknowledgmentsRole;
docAcknowledgmentsRole$1.default = _default$J;
var docAfterwordRole$1 = {};
Object.defineProperty(docAfterwordRole$1, "__esModule", {
  value: true
});
docAfterwordRole$1.default = void 0;
var docAfterwordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "afterword [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$I = docAfterwordRole;
docAfterwordRole$1.default = _default$I;
var docAppendixRole$1 = {};
Object.defineProperty(docAppendixRole$1, "__esModule", {
  value: true
});
docAppendixRole$1.default = void 0;
var docAppendixRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "appendix [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$H = docAppendixRole;
docAppendixRole$1.default = _default$H;
var docBacklinkRole$1 = {};
Object.defineProperty(docBacklinkRole$1, "__esModule", {
  value: true
});
docBacklinkRole$1.default = void 0;
var docBacklinkRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "content"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "referrer [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
};
var _default$G = docBacklinkRole;
docBacklinkRole$1.default = _default$G;
var docBiblioentryRole$1 = {};
Object.defineProperty(docBiblioentryRole$1, "__esModule", {
  value: true
});
docBiblioentryRole$1.default = void 0;
var docBiblioentryRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "EPUB biblioentry [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: ["doc-bibliography"],
  requiredContextRole: ["doc-bibliography"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "listitem"]]
};
var _default$F = docBiblioentryRole;
docBiblioentryRole$1.default = _default$F;
var docBibliographyRole$1 = {};
Object.defineProperty(docBibliographyRole$1, "__esModule", {
  value: true
});
docBibliographyRole$1.default = void 0;
var docBibliographyRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "bibliography [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["doc-biblioentry"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$E = docBibliographyRole;
docBibliographyRole$1.default = _default$E;
var docBibliorefRole$1 = {};
Object.defineProperty(docBibliorefRole$1, "__esModule", {
  value: true
});
docBibliorefRole$1.default = void 0;
var docBibliorefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "biblioref [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
};
var _default$D = docBibliorefRole;
docBibliorefRole$1.default = _default$D;
var docChapterRole$1 = {};
Object.defineProperty(docChapterRole$1, "__esModule", {
  value: true
});
docChapterRole$1.default = void 0;
var docChapterRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "chapter [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$C = docChapterRole;
docChapterRole$1.default = _default$C;
var docColophonRole$1 = {};
Object.defineProperty(docColophonRole$1, "__esModule", {
  value: true
});
docColophonRole$1.default = void 0;
var docColophonRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "colophon [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$B = docColophonRole;
docColophonRole$1.default = _default$B;
var docConclusionRole$1 = {};
Object.defineProperty(docConclusionRole$1, "__esModule", {
  value: true
});
docConclusionRole$1.default = void 0;
var docConclusionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "conclusion [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$A = docConclusionRole;
docConclusionRole$1.default = _default$A;
var docCoverRole$1 = {};
Object.defineProperty(docCoverRole$1, "__esModule", {
  value: true
});
docCoverRole$1.default = void 0;
var docCoverRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "cover [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "img"]]
};
var _default$z = docCoverRole;
docCoverRole$1.default = _default$z;
var docCreditRole$1 = {};
Object.defineProperty(docCreditRole$1, "__esModule", {
  value: true
});
docCreditRole$1.default = void 0;
var docCreditRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "credit [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$y = docCreditRole;
docCreditRole$1.default = _default$y;
var docCreditsRole$1 = {};
Object.defineProperty(docCreditsRole$1, "__esModule", {
  value: true
});
docCreditsRole$1.default = void 0;
var docCreditsRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "credits [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$x = docCreditsRole;
docCreditsRole$1.default = _default$x;
var docDedicationRole$1 = {};
Object.defineProperty(docDedicationRole$1, "__esModule", {
  value: true
});
docDedicationRole$1.default = void 0;
var docDedicationRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "dedication [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$w = docDedicationRole;
docDedicationRole$1.default = _default$w;
var docEndnoteRole$1 = {};
Object.defineProperty(docEndnoteRole$1, "__esModule", {
  value: true
});
docEndnoteRole$1.default = void 0;
var docEndnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "rearnote [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: ["doc-endnotes"],
  requiredContextRole: ["doc-endnotes"],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "listitem"]]
};
var _default$v = docEndnoteRole;
docEndnoteRole$1.default = _default$v;
var docEndnotesRole$1 = {};
Object.defineProperty(docEndnotesRole$1, "__esModule", {
  value: true
});
docEndnotesRole$1.default = void 0;
var docEndnotesRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "rearnotes [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["doc-endnote"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$u = docEndnotesRole;
docEndnotesRole$1.default = _default$u;
var docEpigraphRole$1 = {};
Object.defineProperty(docEpigraphRole$1, "__esModule", {
  value: true
});
docEpigraphRole$1.default = void 0;
var docEpigraphRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "epigraph [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$t = docEpigraphRole;
docEpigraphRole$1.default = _default$t;
var docEpilogueRole$1 = {};
Object.defineProperty(docEpilogueRole$1, "__esModule", {
  value: true
});
docEpilogueRole$1.default = void 0;
var docEpilogueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "epilogue [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$s = docEpilogueRole;
docEpilogueRole$1.default = _default$s;
var docErrataRole$1 = {};
Object.defineProperty(docErrataRole$1, "__esModule", {
  value: true
});
docErrataRole$1.default = void 0;
var docErrataRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "errata [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$r = docErrataRole;
docErrataRole$1.default = _default$r;
var docExampleRole$1 = {};
Object.defineProperty(docExampleRole$1, "__esModule", {
  value: true
});
docExampleRole$1.default = void 0;
var docExampleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$q = docExampleRole;
docExampleRole$1.default = _default$q;
var docFootnoteRole$1 = {};
Object.defineProperty(docFootnoteRole$1, "__esModule", {
  value: true
});
docFootnoteRole$1.default = void 0;
var docFootnoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "footnote [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$p = docFootnoteRole;
docFootnoteRole$1.default = _default$p;
var docForewordRole$1 = {};
Object.defineProperty(docForewordRole$1, "__esModule", {
  value: true
});
docForewordRole$1.default = void 0;
var docForewordRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "foreword [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$o = docForewordRole;
docForewordRole$1.default = _default$o;
var docGlossaryRole$1 = {};
Object.defineProperty(docGlossaryRole$1, "__esModule", {
  value: true
});
docGlossaryRole$1.default = void 0;
var docGlossaryRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "glossary [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [["definition"], ["term"]],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$n = docGlossaryRole;
docGlossaryRole$1.default = _default$n;
var docGlossrefRole$1 = {};
Object.defineProperty(docGlossrefRole$1, "__esModule", {
  value: true
});
docGlossrefRole$1.default = void 0;
var docGlossrefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "glossref [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
};
var _default$m = docGlossrefRole;
docGlossrefRole$1.default = _default$m;
var docIndexRole$1 = {};
Object.defineProperty(docIndexRole$1, "__esModule", {
  value: true
});
docIndexRole$1.default = void 0;
var docIndexRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "index [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
};
var _default$l = docIndexRole;
docIndexRole$1.default = _default$l;
var docIntroductionRole$1 = {};
Object.defineProperty(docIntroductionRole$1, "__esModule", {
  value: true
});
docIntroductionRole$1.default = void 0;
var docIntroductionRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "introduction [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$k = docIntroductionRole;
docIntroductionRole$1.default = _default$k;
var docNoterefRole$1 = {};
Object.defineProperty(docNoterefRole$1, "__esModule", {
  value: true
});
docNoterefRole$1.default = void 0;
var docNoterefRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "noteref [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "widget", "command", "link"]]
};
var _default$j = docNoterefRole;
docNoterefRole$1.default = _default$j;
var docNoticeRole$1 = {};
Object.defineProperty(docNoticeRole$1, "__esModule", {
  value: true
});
docNoticeRole$1.default = void 0;
var docNoticeRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "notice [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "note"]]
};
var _default$i = docNoticeRole;
docNoticeRole$1.default = _default$i;
var docPagebreakRole$1 = {};
Object.defineProperty(docPagebreakRole$1, "__esModule", {
  value: true
});
docPagebreakRole$1.default = void 0;
var docPagebreakRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "pagebreak [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "separator"]]
};
var _default$h = docPagebreakRole;
docPagebreakRole$1.default = _default$h;
var docPagelistRole$1 = {};
Object.defineProperty(docPagelistRole$1, "__esModule", {
  value: true
});
docPagelistRole$1.default = void 0;
var docPagelistRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "page-list [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
};
var _default$g = docPagelistRole;
docPagelistRole$1.default = _default$g;
var docPartRole$1 = {};
Object.defineProperty(docPartRole$1, "__esModule", {
  value: true
});
docPartRole$1.default = void 0;
var docPartRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "part [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$f = docPartRole;
docPartRole$1.default = _default$f;
var docPrefaceRole$1 = {};
Object.defineProperty(docPrefaceRole$1, "__esModule", {
  value: true
});
docPrefaceRole$1.default = void 0;
var docPrefaceRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "preface [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$e = docPrefaceRole;
docPrefaceRole$1.default = _default$e;
var docPrologueRole$1 = {};
Object.defineProperty(docPrologueRole$1, "__esModule", {
  value: true
});
docPrologueRole$1.default = void 0;
var docPrologueRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "prologue [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark"]]
};
var _default$d = docPrologueRole;
docPrologueRole$1.default = _default$d;
var docPullquoteRole$1 = {};
Object.defineProperty(docPullquoteRole$1, "__esModule", {
  value: true
});
docPullquoteRole$1.default = void 0;
var docPullquoteRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {},
  relatedConcepts: [{
    concept: {
      name: "pullquote [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["none"]]
};
var _default$c = docPullquoteRole;
docPullquoteRole$1.default = _default$c;
var docQnaRole$1 = {};
Object.defineProperty(docQnaRole$1, "__esModule", {
  value: true
});
docQnaRole$1.default = void 0;
var docQnaRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "qna [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section"]]
};
var _default$b = docQnaRole;
docQnaRole$1.default = _default$b;
var docSubtitleRole$1 = {};
Object.defineProperty(docSubtitleRole$1, "__esModule", {
  value: true
});
docSubtitleRole$1.default = void 0;
var docSubtitleRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "subtitle [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "sectionhead"]]
};
var _default$a = docSubtitleRole;
docSubtitleRole$1.default = _default$a;
var docTipRole$1 = {};
Object.defineProperty(docTipRole$1, "__esModule", {
  value: true
});
docTipRole$1.default = void 0;
var docTipRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "help [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "note"]]
};
var _default$9 = docTipRole;
docTipRole$1.default = _default$9;
var docTocRole$1 = {};
Object.defineProperty(docTocRole$1, "__esModule", {
  value: true
});
docTocRole$1.default = void 0;
var docTocRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    concept: {
      name: "toc [EPUB-SSV]"
    },
    module: "EPUB"
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "landmark", "navigation"]]
};
var _default$8 = docTocRole;
docTocRole$1.default = _default$8;
Object.defineProperty(ariaDpubRoles$1, "__esModule", {
  value: true
});
ariaDpubRoles$1.default = void 0;
var _docAbstractRole = _interopRequireDefault$5(docAbstractRole$1);
var _docAcknowledgmentsRole = _interopRequireDefault$5(docAcknowledgmentsRole$1);
var _docAfterwordRole = _interopRequireDefault$5(docAfterwordRole$1);
var _docAppendixRole = _interopRequireDefault$5(docAppendixRole$1);
var _docBacklinkRole = _interopRequireDefault$5(docBacklinkRole$1);
var _docBiblioentryRole = _interopRequireDefault$5(docBiblioentryRole$1);
var _docBibliographyRole = _interopRequireDefault$5(docBibliographyRole$1);
var _docBibliorefRole = _interopRequireDefault$5(docBibliorefRole$1);
var _docChapterRole = _interopRequireDefault$5(docChapterRole$1);
var _docColophonRole = _interopRequireDefault$5(docColophonRole$1);
var _docConclusionRole = _interopRequireDefault$5(docConclusionRole$1);
var _docCoverRole = _interopRequireDefault$5(docCoverRole$1);
var _docCreditRole = _interopRequireDefault$5(docCreditRole$1);
var _docCreditsRole = _interopRequireDefault$5(docCreditsRole$1);
var _docDedicationRole = _interopRequireDefault$5(docDedicationRole$1);
var _docEndnoteRole = _interopRequireDefault$5(docEndnoteRole$1);
var _docEndnotesRole = _interopRequireDefault$5(docEndnotesRole$1);
var _docEpigraphRole = _interopRequireDefault$5(docEpigraphRole$1);
var _docEpilogueRole = _interopRequireDefault$5(docEpilogueRole$1);
var _docErrataRole = _interopRequireDefault$5(docErrataRole$1);
var _docExampleRole = _interopRequireDefault$5(docExampleRole$1);
var _docFootnoteRole = _interopRequireDefault$5(docFootnoteRole$1);
var _docForewordRole = _interopRequireDefault$5(docForewordRole$1);
var _docGlossaryRole = _interopRequireDefault$5(docGlossaryRole$1);
var _docGlossrefRole = _interopRequireDefault$5(docGlossrefRole$1);
var _docIndexRole = _interopRequireDefault$5(docIndexRole$1);
var _docIntroductionRole = _interopRequireDefault$5(docIntroductionRole$1);
var _docNoterefRole = _interopRequireDefault$5(docNoterefRole$1);
var _docNoticeRole = _interopRequireDefault$5(docNoticeRole$1);
var _docPagebreakRole = _interopRequireDefault$5(docPagebreakRole$1);
var _docPagelistRole = _interopRequireDefault$5(docPagelistRole$1);
var _docPartRole = _interopRequireDefault$5(docPartRole$1);
var _docPrefaceRole = _interopRequireDefault$5(docPrefaceRole$1);
var _docPrologueRole = _interopRequireDefault$5(docPrologueRole$1);
var _docPullquoteRole = _interopRequireDefault$5(docPullquoteRole$1);
var _docQnaRole = _interopRequireDefault$5(docQnaRole$1);
var _docSubtitleRole = _interopRequireDefault$5(docSubtitleRole$1);
var _docTipRole = _interopRequireDefault$5(docTipRole$1);
var _docTocRole = _interopRequireDefault$5(docTocRole$1);
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var ariaDpubRoles = [["doc-abstract", _docAbstractRole.default], ["doc-acknowledgments", _docAcknowledgmentsRole.default], ["doc-afterword", _docAfterwordRole.default], ["doc-appendix", _docAppendixRole.default], ["doc-backlink", _docBacklinkRole.default], ["doc-biblioentry", _docBiblioentryRole.default], ["doc-bibliography", _docBibliographyRole.default], ["doc-biblioref", _docBibliorefRole.default], ["doc-chapter", _docChapterRole.default], ["doc-colophon", _docColophonRole.default], ["doc-conclusion", _docConclusionRole.default], ["doc-cover", _docCoverRole.default], ["doc-credit", _docCreditRole.default], ["doc-credits", _docCreditsRole.default], ["doc-dedication", _docDedicationRole.default], ["doc-endnote", _docEndnoteRole.default], ["doc-endnotes", _docEndnotesRole.default], ["doc-epigraph", _docEpigraphRole.default], ["doc-epilogue", _docEpilogueRole.default], ["doc-errata", _docErrataRole.default], ["doc-example", _docExampleRole.default], ["doc-footnote", _docFootnoteRole.default], ["doc-foreword", _docForewordRole.default], ["doc-glossary", _docGlossaryRole.default], ["doc-glossref", _docGlossrefRole.default], ["doc-index", _docIndexRole.default], ["doc-introduction", _docIntroductionRole.default], ["doc-noteref", _docNoterefRole.default], ["doc-notice", _docNoticeRole.default], ["doc-pagebreak", _docPagebreakRole.default], ["doc-pagelist", _docPagelistRole.default], ["doc-part", _docPartRole.default], ["doc-preface", _docPrefaceRole.default], ["doc-prologue", _docPrologueRole.default], ["doc-pullquote", _docPullquoteRole.default], ["doc-qna", _docQnaRole.default], ["doc-subtitle", _docSubtitleRole.default], ["doc-tip", _docTipRole.default], ["doc-toc", _docTocRole.default]];
var _default$7 = ariaDpubRoles;
ariaDpubRoles$1.default = _default$7;
var ariaGraphicsRoles$1 = {};
var graphicsDocumentRole$1 = {};
Object.defineProperty(graphicsDocumentRole$1, "__esModule", {
  value: true
});
graphicsDocumentRole$1.default = void 0;
var graphicsDocumentRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    module: "GRAPHICS",
    concept: {
      name: "graphics-object"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "img"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "article"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "document"]]
};
var _default$6 = graphicsDocumentRole;
graphicsDocumentRole$1.default = _default$6;
var graphicsObjectRole$1 = {};
Object.defineProperty(graphicsObjectRole$1, "__esModule", {
  value: true
});
graphicsObjectRole$1.default = void 0;
var graphicsObjectRole = {
  abstract: false,
  accessibleNameRequired: false,
  baseConcepts: [],
  childrenPresentational: false,
  nameFrom: ["author", "contents"],
  prohibitedProps: [],
  props: {
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [{
    module: "GRAPHICS",
    concept: {
      name: "graphics-document"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "group"
    }
  }, {
    module: "ARIA",
    concept: {
      name: "img"
    }
  }, {
    module: "GRAPHICS",
    concept: {
      name: "graphics-symbol"
    }
  }],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "group"]]
};
var _default$5 = graphicsObjectRole;
graphicsObjectRole$1.default = _default$5;
var graphicsSymbolRole$1 = {};
Object.defineProperty(graphicsSymbolRole$1, "__esModule", {
  value: true
});
graphicsSymbolRole$1.default = void 0;
var graphicsSymbolRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [],
  childrenPresentational: true,
  nameFrom: ["author"],
  prohibitedProps: [],
  props: {
    "aria-disabled": null,
    "aria-errormessage": null,
    "aria-expanded": null,
    "aria-haspopup": null,
    "aria-invalid": null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [["roletype", "structure", "section", "img"]]
};
var _default$4 = graphicsSymbolRole;
graphicsSymbolRole$1.default = _default$4;
Object.defineProperty(ariaGraphicsRoles$1, "__esModule", {
  value: true
});
ariaGraphicsRoles$1.default = void 0;
var _graphicsDocumentRole = _interopRequireDefault$4(graphicsDocumentRole$1);
var _graphicsObjectRole = _interopRequireDefault$4(graphicsObjectRole$1);
var _graphicsSymbolRole = _interopRequireDefault$4(graphicsSymbolRole$1);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var ariaGraphicsRoles = [["graphics-document", _graphicsDocumentRole.default], ["graphics-object", _graphicsObjectRole.default], ["graphics-symbol", _graphicsSymbolRole.default]];
var _default$3 = ariaGraphicsRoles;
ariaGraphicsRoles$1.default = _default$3;
Object.defineProperty(rolesMap$1, "__esModule", {
  value: true
});
rolesMap$1.default = void 0;
var _ariaAbstractRoles = _interopRequireDefault$3(ariaAbstractRoles$1);
var _ariaLiteralRoles = _interopRequireDefault$3(ariaLiteralRoles$1);
var _ariaDpubRoles = _interopRequireDefault$3(ariaDpubRoles$1);
var _ariaGraphicsRoles = _interopRequireDefault$3(ariaGraphicsRoles$1);
var _iterationDecorator$2 = _interopRequireDefault$3(iterationDecorator$1);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _createForOfIteratorHelper$3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$3(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e3(_e2) {
        throw _e2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s4() {
    it = it.call(o);
  }, n: function n() {
    var step2 = it.next();
    normalCompletion = step2.done;
    return step2;
  }, e: function e3(_e3) {
    didErr = true;
    err = _e3;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _slicedToArray$2(arr, i2) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i2) || _unsupportedIterableToArray$3(arr, i2) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
function _iterableToArrayLimit$2(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr))
    return arr;
}
var roles$1 = [].concat(_ariaAbstractRoles.default, _ariaLiteralRoles.default, _ariaDpubRoles.default, _ariaGraphicsRoles.default);
roles$1.forEach(function(_ref2) {
  var _ref22 = _slicedToArray$2(_ref2, 2), roleDefinition = _ref22[1];
  var _iterator = _createForOfIteratorHelper$3(roleDefinition.superClass), _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var superClassIter = _step.value;
      var _iterator2 = _createForOfIteratorHelper$3(superClassIter), _step2;
      try {
        var _loop3 = function _loop4() {
          var superClassName = _step2.value;
          var superClassRoleTuple = roles$1.find(function(_ref3) {
            var _ref4 = _slicedToArray$2(_ref3, 1), name2 = _ref4[0];
            return name2 === superClassName;
          });
          if (superClassRoleTuple) {
            var superClassDefinition = superClassRoleTuple[1];
            for (var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++) {
              var prop = _Object$keys[_i2];
              if (
                // $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
                !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)
              ) {
                Object.assign(roleDefinition.props, _defineProperty$3({}, prop, superClassDefinition.props[prop]));
              }
            }
          }
        };
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
          _loop3();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
});
var rolesMap = {
  entries: function entries3() {
    return roles$1;
  },
  forEach: function forEach3(fn2) {
    var thisArg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _iterator3 = _createForOfIteratorHelper$3(roles$1), _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done; ) {
        var _step3$value = _slicedToArray$2(_step3.value, 2), key = _step3$value[0], values6 = _step3$value[1];
        fn2.call(thisArg, values6, key, roles$1);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  },
  get: function get5(key) {
    var item = roles$1.find(function(tuple2) {
      return tuple2[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has3(key) {
    return !!rolesMap.get(key);
  },
  keys: function keys3() {
    return roles$1.map(function(_ref5) {
      var _ref6 = _slicedToArray$2(_ref5, 1), key = _ref6[0];
      return key;
    });
  },
  values: function values3() {
    return roles$1.map(function(_ref7) {
      var _ref8 = _slicedToArray$2(_ref7, 2), values6 = _ref8[1];
      return values6;
    });
  }
};
var _default$2 = (0, _iterationDecorator$2.default)(rolesMap, rolesMap.entries());
rolesMap$1.default = _default$2;
var elementRoleMap$1 = {};
var toStr$9 = Object.prototype.toString;
var isArguments$8 = function isArguments(value) {
  var str = toStr$9.call(value);
  var isArgs2 = str === "[object Arguments]";
  if (!isArgs2) {
    isArgs2 = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && toStr$9.call(value.callee) === "[object Function]";
  }
  return isArgs2;
};
var implementation$b;
var hasRequiredImplementation;
function requireImplementation() {
  if (hasRequiredImplementation)
    return implementation$b;
  hasRequiredImplementation = 1;
  var keysShim2;
  if (!Object.keys) {
    var has7 = Object.prototype.hasOwnProperty;
    var toStr2 = Object.prototype.toString;
    var isArgs2 = isArguments$8;
    var isEnumerable2 = Object.prototype.propertyIsEnumerable;
    var hasDontEnumBug = !isEnumerable2.call({ toString: null }, "toString");
    var hasProtoEnumBug = isEnumerable2.call(function() {
    }, "prototype");
    var dontEnums = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ];
    var equalsConstructorPrototype = function(o) {
      var ctor = o.constructor;
      return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
      $applicationCache: true,
      $console: true,
      $external: true,
      $frame: true,
      $frameElement: true,
      $frames: true,
      $innerHeight: true,
      $innerWidth: true,
      $onmozfullscreenchange: true,
      $onmozfullscreenerror: true,
      $outerHeight: true,
      $outerWidth: true,
      $pageXOffset: true,
      $pageYOffset: true,
      $parent: true,
      $scrollLeft: true,
      $scrollTop: true,
      $scrollX: true,
      $scrollY: true,
      $self: true,
      $webkitIndexedDB: true,
      $webkitStorageInfo: true,
      $window: true
    };
    var hasAutomationEqualityBug = function() {
      if (typeof window === "undefined") {
        return false;
      }
      for (var k3 in window) {
        try {
          if (!excludedKeys["$" + k3] && has7.call(window, k3) && window[k3] !== null && typeof window[k3] === "object") {
            try {
              equalsConstructorPrototype(window[k3]);
            } catch (e3) {
              return true;
            }
          }
        } catch (e3) {
          return true;
        }
      }
      return false;
    }();
    var equalsConstructorPrototypeIfNotBuggy = function(o) {
      if (typeof window === "undefined" || !hasAutomationEqualityBug) {
        return equalsConstructorPrototype(o);
      }
      try {
        return equalsConstructorPrototype(o);
      } catch (e3) {
        return false;
      }
    };
    keysShim2 = function keys8(object2) {
      var isObject3 = object2 !== null && typeof object2 === "object";
      var isFunction4 = toStr2.call(object2) === "[object Function]";
      var isArguments5 = isArgs2(object2);
      var isString4 = isObject3 && toStr2.call(object2) === "[object String]";
      var theKeys = [];
      if (!isObject3 && !isFunction4 && !isArguments5) {
        throw new TypeError("Object.keys called on a non-object");
      }
      var skipProto = hasProtoEnumBug && isFunction4;
      if (isString4 && object2.length > 0 && !has7.call(object2, 0)) {
        for (var i2 = 0; i2 < object2.length; ++i2) {
          theKeys.push(String(i2));
        }
      }
      if (isArguments5 && object2.length > 0) {
        for (var j = 0; j < object2.length; ++j) {
          theKeys.push(String(j));
        }
      } else {
        for (var name2 in object2) {
          if (!(skipProto && name2 === "prototype") && has7.call(object2, name2)) {
            theKeys.push(String(name2));
          }
        }
      }
      if (hasDontEnumBug) {
        var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object2);
        for (var k3 = 0; k3 < dontEnums.length; ++k3) {
          if (!(skipConstructor && dontEnums[k3] === "constructor") && has7.call(object2, dontEnums[k3])) {
            theKeys.push(dontEnums[k3]);
          }
        }
      }
      return theKeys;
    };
  }
  implementation$b = keysShim2;
  return implementation$b;
}
var slice$1 = Array.prototype.slice;
var isArgs = isArguments$8;
var origKeys = Object.keys;
var keysShim = origKeys ? function keys4(o) {
  return origKeys(o);
} : requireImplementation();
var originalKeys = Object.keys;
keysShim.shim = function shimObjectKeys() {
  if (Object.keys) {
    var keysWorksWithArguments = function() {
      var args = Object.keys(arguments);
      return args && args.length === arguments.length;
    }(1, 2);
    if (!keysWorksWithArguments) {
      Object.keys = function keys8(object2) {
        if (isArgs(object2)) {
          return originalKeys(slice$1.call(object2));
        }
        return originalKeys(object2);
      };
    }
  } else {
    Object.keys = keysShim;
  }
  return Object.keys || keysShim;
};
var objectKeys$2 = keysShim;
var esErrors = Error;
var _eval = EvalError;
var range$2 = RangeError;
var ref = ReferenceError;
var syntax = SyntaxError;
var type = TypeError;
var uri = URIError;
var shams$1 = function hasSymbols() {
  if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") {
    return false;
  }
  if (typeof Symbol.iterator === "symbol") {
    return true;
  }
  var obj = {};
  var sym = Symbol("test");
  var symObj = Object(sym);
  if (typeof sym === "string") {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== "[object Symbol]") {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== "[object Symbol]") {
    return false;
  }
  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  }
  if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === "function") {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};
var origSymbol = typeof Symbol !== "undefined" && Symbol;
var hasSymbolSham = shams$1;
var hasSymbols$5 = function hasNativeSymbols() {
  if (typeof origSymbol !== "function") {
    return false;
  }
  if (typeof Symbol !== "function") {
    return false;
  }
  if (typeof origSymbol("foo") !== "symbol") {
    return false;
  }
  if (typeof Symbol("bar") !== "symbol") {
    return false;
  }
  return hasSymbolSham();
};
var test = {
  __proto__: null,
  foo: {}
};
var $Object$1 = Object;
var hasProto$1 = function hasProto() {
  return { __proto__: test }.foo === test.foo && !(test instanceof $Object$1);
};
var ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var toStr$8 = Object.prototype.toString;
var max$2 = Math.max;
var funcType = "[object Function]";
var concatty = function concatty2(a4, b10) {
  var arr = [];
  for (var i2 = 0; i2 < a4.length; i2 += 1) {
    arr[i2] = a4[i2];
  }
  for (var j = 0; j < b10.length; j += 1) {
    arr[j + a4.length] = b10[j];
  }
  return arr;
};
var slicy = function slicy2(arrLike, offset2) {
  var arr = [];
  for (var i2 = offset2 || 0, j = 0; i2 < arrLike.length; i2 += 1, j += 1) {
    arr[j] = arrLike[i2];
  }
  return arr;
};
var joiny = function(arr, joiner) {
  var str = "";
  for (var i2 = 0; i2 < arr.length; i2 += 1) {
    str += arr[i2];
    if (i2 + 1 < arr.length) {
      str += joiner;
    }
  }
  return str;
};
var implementation$a = function bind(that) {
  var target = this;
  if (typeof target !== "function" || toStr$8.apply(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slicy(arguments, 1);
  var bound2;
  var binder = function() {
    if (this instanceof bound2) {
      var result = target.apply(
        this,
        concatty(args, arguments)
      );
      if (Object(result) === result) {
        return result;
      }
      return this;
    }
    return target.apply(
      that,
      concatty(args, arguments)
    );
  };
  var boundLength = max$2(0, target.length - args.length);
  var boundArgs = [];
  for (var i2 = 0; i2 < boundLength; i2++) {
    boundArgs[i2] = "$" + i2;
  }
  bound2 = Function("binder", "return function (" + joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
  if (target.prototype) {
    var Empty = function Empty2() {
    };
    Empty.prototype = target.prototype;
    bound2.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound2;
};
var implementation$9 = implementation$a;
var functionBind = Function.prototype.bind || implementation$9;
var call$2 = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind$2 = functionBind;
var hasown = bind$2.call(call$2, $hasOwn);
var undefined$1;
var $Error = esErrors;
var $EvalError = _eval;
var $RangeError = range$2;
var $ReferenceError = ref;
var $SyntaxError$2 = syntax;
var $TypeError$6 = type;
var $URIError = uri;
var $Function = Function;
var getEvalledConstructor = function(expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
  } catch (e3) {
  }
};
var $gOPD$2 = Object.getOwnPropertyDescriptor;
if ($gOPD$2) {
  try {
    $gOPD$2({}, "");
  } catch (e3) {
    $gOPD$2 = null;
  }
}
var throwTypeError = function() {
  throw new $TypeError$6();
};
var ThrowTypeError = $gOPD$2 ? function() {
  try {
    arguments.callee;
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      return $gOPD$2(arguments, "callee").get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols$4 = hasSymbols$5();
var hasProto2 = hasProto$1();
var getProto$1 = Object.getPrototypeOf || (hasProto2 ? function(x3) {
  return x3.__proto__;
} : null);
var needsEval = {};
var TypedArray = typeof Uint8Array === "undefined" || !getProto$1 ? undefined$1 : getProto$1(Uint8Array);
var INTRINSICS = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError === "undefined" ? undefined$1 : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined$1 : ArrayBuffer,
  "%ArrayIteratorPrototype%": hasSymbols$4 && getProto$1 ? getProto$1([][Symbol.iterator]()) : undefined$1,
  "%AsyncFromSyncIteratorPrototype%": undefined$1,
  "%AsyncFunction%": needsEval,
  "%AsyncGenerator%": needsEval,
  "%AsyncGeneratorFunction%": needsEval,
  "%AsyncIteratorPrototype%": needsEval,
  "%Atomics%": typeof Atomics === "undefined" ? undefined$1 : Atomics,
  "%BigInt%": typeof BigInt === "undefined" ? undefined$1 : BigInt,
  "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined$1 : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined$1 : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView === "undefined" ? undefined$1 : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": $Error,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": $EvalError,
  "%Float32Array%": typeof Float32Array === "undefined" ? undefined$1 : Float32Array,
  "%Float64Array%": typeof Float64Array === "undefined" ? undefined$1 : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined$1 : FinalizationRegistry,
  "%Function%": $Function,
  "%GeneratorFunction%": needsEval,
  "%Int8Array%": typeof Int8Array === "undefined" ? undefined$1 : Int8Array,
  "%Int16Array%": typeof Int16Array === "undefined" ? undefined$1 : Int16Array,
  "%Int32Array%": typeof Int32Array === "undefined" ? undefined$1 : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": hasSymbols$4 && getProto$1 ? getProto$1(getProto$1([][Symbol.iterator]())) : undefined$1,
  "%JSON%": typeof JSON === "object" ? JSON : undefined$1,
  "%Map%": typeof Map === "undefined" ? undefined$1 : Map,
  "%MapIteratorPrototype%": typeof Map === "undefined" || !hasSymbols$4 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Object,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise === "undefined" ? undefined$1 : Promise,
  "%Proxy%": typeof Proxy === "undefined" ? undefined$1 : Proxy,
  "%RangeError%": $RangeError,
  "%ReferenceError%": $ReferenceError,
  "%Reflect%": typeof Reflect === "undefined" ? undefined$1 : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set === "undefined" ? undefined$1 : Set,
  "%SetIteratorPrototype%": typeof Set === "undefined" || !hasSymbols$4 || !getProto$1 ? undefined$1 : getProto$1((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined$1 : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": hasSymbols$4 && getProto$1 ? getProto$1(""[Symbol.iterator]()) : undefined$1,
  "%Symbol%": hasSymbols$4 ? Symbol : undefined$1,
  "%SyntaxError%": $SyntaxError$2,
  "%ThrowTypeError%": ThrowTypeError,
  "%TypedArray%": TypedArray,
  "%TypeError%": $TypeError$6,
  "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined$1 : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined$1 : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined$1 : Uint16Array,
  "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined$1 : Uint32Array,
  "%URIError%": $URIError,
  "%WeakMap%": typeof WeakMap === "undefined" ? undefined$1 : WeakMap,
  "%WeakRef%": typeof WeakRef === "undefined" ? undefined$1 : WeakRef,
  "%WeakSet%": typeof WeakSet === "undefined" ? undefined$1 : WeakSet
};
if (getProto$1) {
  try {
    null.error;
  } catch (e3) {
    var errorProto = getProto$1(getProto$1(e3));
    INTRINSICS["%Error.prototype%"] = errorProto;
  }
}
var doEval = function doEval2(name2) {
  var value;
  if (name2 === "%AsyncFunction%") {
    value = getEvalledConstructor("async function () {}");
  } else if (name2 === "%GeneratorFunction%") {
    value = getEvalledConstructor("function* () {}");
  } else if (name2 === "%AsyncGeneratorFunction%") {
    value = getEvalledConstructor("async function* () {}");
  } else if (name2 === "%AsyncGenerator%") {
    var fn2 = doEval2("%AsyncGeneratorFunction%");
    if (fn2) {
      value = fn2.prototype;
    }
  } else if (name2 === "%AsyncIteratorPrototype%") {
    var gen = doEval2("%AsyncGenerator%");
    if (gen && getProto$1) {
      value = getProto$1(gen.prototype);
    }
  }
  INTRINSICS[name2] = value;
  return value;
};
var LEGACY_ALIASES = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
};
var bind$1 = functionBind;
var hasOwn$2 = hasown;
var $concat$1 = bind$1.call(Function.call, Array.prototype.concat);
var $spliceApply = bind$1.call(Function.apply, Array.prototype.splice);
var $replace$1 = bind$1.call(Function.call, String.prototype.replace);
var $strSlice = bind$1.call(Function.call, String.prototype.slice);
var $exec$1 = bind$1.call(Function.call, RegExp.prototype.exec);
var rePropName$1 = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = function stringToPath(string2) {
  var first = $strSlice(string2, 0, 1);
  var last2 = $strSlice(string2, -1);
  if (first === "%" && last2 !== "%") {
    throw new $SyntaxError$2("invalid intrinsic syntax, expected closing `%`");
  } else if (last2 === "%" && first !== "%") {
    throw new $SyntaxError$2("invalid intrinsic syntax, expected opening `%`");
  }
  var result = [];
  $replace$1(string2, rePropName$1, function(match2, number2, quote2, subString) {
    result[result.length] = quote2 ? $replace$1(subString, reEscapeChar$1, "$1") : number2 || match2;
  });
  return result;
};
var getBaseIntrinsic = function getBaseIntrinsic2(name2, allowMissing) {
  var intrinsicName = name2;
  var alias2;
  if (hasOwn$2(LEGACY_ALIASES, intrinsicName)) {
    alias2 = LEGACY_ALIASES[intrinsicName];
    intrinsicName = "%" + alias2[0] + "%";
  }
  if (hasOwn$2(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === "undefined" && !allowMissing) {
      throw new $TypeError$6("intrinsic " + name2 + " exists, but is not available. Please file an issue!");
    }
    return {
      alias: alias2,
      name: intrinsicName,
      value
    };
  }
  throw new $SyntaxError$2("intrinsic " + name2 + " does not exist!");
};
var getIntrinsic = function GetIntrinsic(name2, allowMissing) {
  if (typeof name2 !== "string" || name2.length === 0) {
    throw new $TypeError$6("intrinsic name must be a non-empty string");
  }
  if (arguments.length > 1 && typeof allowMissing !== "boolean") {
    throw new $TypeError$6('"allowMissing" argument must be a boolean');
  }
  if ($exec$1(/^%?[^%]*%?$/, name2) === null) {
    throw new $SyntaxError$2("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  }
  var parts = stringToPath$2(name2);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
  var intrinsic = getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias2 = intrinsic.alias;
  if (alias2) {
    intrinsicBaseName = alias2[0];
    $spliceApply(parts, $concat$1([0, 1], alias2));
  }
  for (var i2 = 1, isOwn = true; i2 < parts.length; i2 += 1) {
    var part = parts[i2];
    var first = $strSlice(part, 0, 1);
    var last2 = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === "`" || (last2 === '"' || last2 === "'" || last2 === "`")) && first !== last2) {
      throw new $SyntaxError$2("property names with quotes must have matching quotes");
    }
    if (part === "constructor" || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += "." + part;
    intrinsicRealName = "%" + intrinsicBaseName + "%";
    if (hasOwn$2(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError$6("base intrinsic for " + name2 + " exists, but the property is not available.");
        }
        return void 0;
      }
      if ($gOPD$2 && i2 + 1 >= parts.length) {
        var desc = $gOPD$2(value, part);
        isOwn = !!desc;
        if (isOwn && "get" in desc && !("originalValue" in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn$2(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};
var GetIntrinsic$8 = getIntrinsic;
var $defineProperty$2 = GetIntrinsic$8("%Object.defineProperty%", true) || false;
if ($defineProperty$2) {
  try {
    $defineProperty$2({}, "a", { value: 1 });
  } catch (e3) {
    $defineProperty$2 = false;
  }
}
var esDefineProperty = $defineProperty$2;
var GetIntrinsic$7 = getIntrinsic;
var $gOPD$1 = GetIntrinsic$7("%Object.getOwnPropertyDescriptor%", true);
if ($gOPD$1) {
  try {
    $gOPD$1([], "length");
  } catch (e3) {
    $gOPD$1 = null;
  }
}
var gopd$1 = $gOPD$1;
var $defineProperty$1 = esDefineProperty;
var $SyntaxError$1 = syntax;
var $TypeError$5 = type;
var gopd = gopd$1;
var defineDataProperty$1 = function defineDataProperty(obj, property2, value) {
  if (!obj || typeof obj !== "object" && typeof obj !== "function") {
    throw new $TypeError$5("`obj` must be an object or a function`");
  }
  if (typeof property2 !== "string" && typeof property2 !== "symbol") {
    throw new $TypeError$5("`property` must be a string or a symbol`");
  }
  if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) {
    throw new $TypeError$5("`nonEnumerable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) {
    throw new $TypeError$5("`nonWritable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) {
    throw new $TypeError$5("`nonConfigurable`, if provided, must be a boolean or null");
  }
  if (arguments.length > 6 && typeof arguments[6] !== "boolean") {
    throw new $TypeError$5("`loose`, if provided, must be a boolean");
  }
  var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
  var nonWritable = arguments.length > 4 ? arguments[4] : null;
  var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
  var loose = arguments.length > 6 ? arguments[6] : false;
  var desc = !!gopd && gopd(obj, property2);
  if ($defineProperty$1) {
    $defineProperty$1(obj, property2, {
      configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
      enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
      value,
      writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
  } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
    obj[property2] = value;
  } else {
    throw new $SyntaxError$1("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }
};
var $defineProperty = esDefineProperty;
var hasPropertyDescriptors = function hasPropertyDescriptors2() {
  return !!$defineProperty;
};
hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
  if (!$defineProperty) {
    return null;
  }
  try {
    return $defineProperty([], "length", { value: 1 }).length !== 1;
  } catch (e3) {
    return true;
  }
};
var hasPropertyDescriptors_1 = hasPropertyDescriptors;
var keys$6 = objectKeys$2;
var hasSymbols$3 = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var toStr$7 = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty2 = defineDataProperty$1;
var isFunction$7 = function(fn2) {
  return typeof fn2 === "function" && toStr$7.call(fn2) === "[object Function]";
};
var supportsDescriptors$2 = hasPropertyDescriptors_1();
var defineProperty$4 = function(object2, name2, value, predicate) {
  if (name2 in object2) {
    if (predicate === true) {
      if (object2[name2] === value) {
        return;
      }
    } else if (!isFunction$7(predicate) || !predicate()) {
      return;
    }
  }
  if (supportsDescriptors$2) {
    defineDataProperty2(object2, name2, value, true);
  } else {
    defineDataProperty2(object2, name2, value);
  }
};
var defineProperties$1 = function(object2, map2) {
  var predicates2 = arguments.length > 2 ? arguments[2] : {};
  var props2 = keys$6(map2);
  if (hasSymbols$3) {
    props2 = concat.call(props2, Object.getOwnPropertySymbols(map2));
  }
  for (var i2 = 0; i2 < props2.length; i2 += 1) {
    defineProperty$4(object2, props2[i2], map2[props2[i2]], predicates2[props2[i2]]);
  }
};
defineProperties$1.supportsDescriptors = !!supportsDescriptors$2;
var defineProperties_1 = defineProperties$1;
var callBind$6 = { exports: {} };
var GetIntrinsic$6 = getIntrinsic;
var define$6 = defineDataProperty$1;
var hasDescriptors$1 = hasPropertyDescriptors_1();
var gOPD$4 = gopd$1;
var $TypeError$4 = type;
var $floor$1 = GetIntrinsic$6("%Math.floor%");
var setFunctionLength = function setFunctionLength2(fn2, length2) {
  if (typeof fn2 !== "function") {
    throw new $TypeError$4("`fn` is not a function");
  }
  if (typeof length2 !== "number" || length2 < 0 || length2 > 4294967295 || $floor$1(length2) !== length2) {
    throw new $TypeError$4("`length` must be a positive 32-bit integer");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  var functionLengthIsConfigurable = true;
  var functionLengthIsWritable = true;
  if ("length" in fn2 && gOPD$4) {
    var desc = gOPD$4(fn2, "length");
    if (desc && !desc.configurable) {
      functionLengthIsConfigurable = false;
    }
    if (desc && !desc.writable) {
      functionLengthIsWritable = false;
    }
  }
  if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
    if (hasDescriptors$1) {
      define$6(
        /** @type {Parameters<define>[0]} */
        fn2,
        "length",
        length2,
        true,
        true
      );
    } else {
      define$6(
        /** @type {Parameters<define>[0]} */
        fn2,
        "length",
        length2
      );
    }
  }
  return fn2;
};
(function(module2) {
  var bind3 = functionBind;
  var GetIntrinsic3 = getIntrinsic;
  var setFunctionLength$1 = setFunctionLength;
  var $TypeError2 = type;
  var $apply = GetIntrinsic3("%Function.prototype.apply%");
  var $call = GetIntrinsic3("%Function.prototype.call%");
  var $reflectApply = GetIntrinsic3("%Reflect.apply%", true) || bind3.call($call, $apply);
  var $defineProperty2 = esDefineProperty;
  var $max = GetIntrinsic3("%Math.max%");
  module2.exports = function callBind2(originalFunction) {
    if (typeof originalFunction !== "function") {
      throw new $TypeError2("a function is required");
    }
    var func = $reflectApply(bind3, $call, arguments);
    return setFunctionLength$1(
      func,
      1 + $max(0, originalFunction.length - (arguments.length - 1)),
      true
    );
  };
  var applyBind = function applyBind2() {
    return $reflectApply(bind3, $apply, arguments);
  };
  if ($defineProperty2) {
    $defineProperty2(module2.exports, "apply", { value: applyBind });
  } else {
    module2.exports.apply = applyBind;
  }
})(callBind$6);
var callBindExports = callBind$6.exports;
var GetIntrinsic$5 = getIntrinsic;
var callBind$5 = callBindExports;
var $indexOf$1 = callBind$5(GetIntrinsic$5("String.prototype.indexOf"));
var callBound$c = function callBoundIntrinsic(name2, allowMissing) {
  var intrinsic = GetIntrinsic$5(name2, !!allowMissing);
  if (typeof intrinsic === "function" && $indexOf$1(name2, ".prototype.") > -1) {
    return callBind$5(intrinsic);
  }
  return intrinsic;
};
var objectKeys$1 = objectKeys$2;
var hasSymbols$2 = shams$1();
var callBound$b = callBound$c;
var toObject = Object;
var $push = callBound$b("Array.prototype.push");
var $propIsEnumerable = callBound$b("Object.prototype.propertyIsEnumerable");
var originalGetSymbols = hasSymbols$2 ? Object.getOwnPropertySymbols : null;
var implementation$8 = function assign(target, source1) {
  if (target == null) {
    throw new TypeError("target must be an object");
  }
  var to2 = toObject(target);
  if (arguments.length === 1) {
    return to2;
  }
  for (var s4 = 1; s4 < arguments.length; ++s4) {
    var from2 = toObject(arguments[s4]);
    var keys8 = objectKeys$1(from2);
    var getSymbols2 = hasSymbols$2 && (Object.getOwnPropertySymbols || originalGetSymbols);
    if (getSymbols2) {
      var syms = getSymbols2(from2);
      for (var j = 0; j < syms.length; ++j) {
        var key = syms[j];
        if ($propIsEnumerable(from2, key)) {
          $push(keys8, key);
        }
      }
    }
    for (var i2 = 0; i2 < keys8.length; ++i2) {
      var nextKey2 = keys8[i2];
      if ($propIsEnumerable(from2, nextKey2)) {
        var propValue = from2[nextKey2];
        to2[nextKey2] = propValue;
      }
    }
  }
  return to2;
};
var implementation$7 = implementation$8;
var lacksProperEnumerationOrder = function() {
  if (!Object.assign) {
    return false;
  }
  var str = "abcdefghijklmnopqrst";
  var letters = str.split("");
  var map2 = {};
  for (var i2 = 0; i2 < letters.length; ++i2) {
    map2[letters[i2]] = letters[i2];
  }
  var obj = Object.assign({}, map2);
  var actual = "";
  for (var k3 in obj) {
    actual += k3;
  }
  return str !== actual;
};
var assignHasPendingExceptions = function() {
  if (!Object.assign || !Object.preventExtensions) {
    return false;
  }
  var thrower = Object.preventExtensions({ 1: 2 });
  try {
    Object.assign(thrower, "xy");
  } catch (e3) {
    return thrower[1] === "y";
  }
  return false;
};
var polyfill$4 = function getPolyfill() {
  if (!Object.assign) {
    return implementation$7;
  }
  if (lacksProperEnumerationOrder()) {
    return implementation$7;
  }
  if (assignHasPendingExceptions()) {
    return implementation$7;
  }
  return Object.assign;
};
var define$5 = defineProperties_1;
var getPolyfill$5 = polyfill$4;
var shim$6 = function shimAssign() {
  var polyfill2 = getPolyfill$5();
  define$5(
    Object,
    { assign: polyfill2 },
    { assign: function() {
      return Object.assign !== polyfill2;
    } }
  );
  return polyfill2;
};
var defineProperties = defineProperties_1;
var callBind$4 = callBindExports;
var implementation$6 = implementation$8;
var getPolyfill$4 = polyfill$4;
var shim$5 = shim$6;
var polyfill$3 = callBind$4.apply(getPolyfill$4());
var bound = function assign2(target, source1) {
  return polyfill$3(Object, arguments);
};
defineProperties(bound, {
  getPolyfill: getPolyfill$4,
  implementation: implementation$6,
  shim: shim$5
});
var object_assign = bound;
var functionsHaveNames = function functionsHaveNames2() {
  return typeof (function f() {
  }).name === "string";
};
var gOPD$3 = Object.getOwnPropertyDescriptor;
if (gOPD$3) {
  try {
    gOPD$3([], "length");
  } catch (e3) {
    gOPD$3 = null;
  }
}
functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
  if (!functionsHaveNames() || !gOPD$3) {
    return false;
  }
  var desc = gOPD$3(function() {
  }, "name");
  return !!desc && !!desc.configurable;
};
var $bind = Function.prototype.bind;
functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
  return functionsHaveNames() && typeof $bind === "function" && (function f() {
  }).bind().name !== "";
};
var functionsHaveNames_1 = functionsHaveNames;
var define$4 = defineDataProperty$1;
var hasDescriptors = hasPropertyDescriptors_1();
var functionsHaveConfigurableNames2 = functionsHaveNames_1.functionsHaveConfigurableNames();
var $TypeError$3 = type;
var setFunctionName$1 = function setFunctionName(fn2, name2) {
  if (typeof fn2 !== "function") {
    throw new $TypeError$3("`fn` is not a function");
  }
  var loose = arguments.length > 2 && !!arguments[2];
  if (!loose || functionsHaveConfigurableNames2) {
    if (hasDescriptors) {
      define$4(
        /** @type {Parameters<define>[0]} */
        fn2,
        "name",
        name2,
        true,
        true
      );
    } else {
      define$4(
        /** @type {Parameters<define>[0]} */
        fn2,
        "name",
        name2
      );
    }
  }
  return fn2;
};
var setFunctionName2 = setFunctionName$1;
var $TypeError$2 = type;
var $Object = Object;
var implementation$5 = setFunctionName2(function flags() {
  if (this == null || this !== $Object(this)) {
    throw new $TypeError$2("RegExp.prototype.flags getter called on non-object");
  }
  var result = "";
  if (this.hasIndices) {
    result += "d";
  }
  if (this.global) {
    result += "g";
  }
  if (this.ignoreCase) {
    result += "i";
  }
  if (this.multiline) {
    result += "m";
  }
  if (this.dotAll) {
    result += "s";
  }
  if (this.unicode) {
    result += "u";
  }
  if (this.unicodeSets) {
    result += "v";
  }
  if (this.sticky) {
    result += "y";
  }
  return result;
}, "get flags", true);
var implementation$4 = implementation$5;
var supportsDescriptors$1 = defineProperties_1.supportsDescriptors;
var $gOPD = Object.getOwnPropertyDescriptor;
var polyfill$2 = function getPolyfill2() {
  if (supportsDescriptors$1 && /a/mig.flags === "gim") {
    var descriptor = $gOPD(RegExp.prototype, "flags");
    if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
      var calls = "";
      var o = {};
      Object.defineProperty(o, "hasIndices", {
        get: function() {
          calls += "d";
        }
      });
      Object.defineProperty(o, "sticky", {
        get: function() {
          calls += "y";
        }
      });
      if (calls === "dy") {
        return descriptor.get;
      }
    }
  }
  return implementation$4;
};
var supportsDescriptors = defineProperties_1.supportsDescriptors;
var getPolyfill$3 = polyfill$2;
var gOPD$2 = Object.getOwnPropertyDescriptor;
var defineProperty$3 = Object.defineProperty;
var TypeErr = TypeError;
var getProto = Object.getPrototypeOf;
var regex = /a/;
var shim$4 = function shimFlags() {
  if (!supportsDescriptors || !getProto) {
    throw new TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
  }
  var polyfill2 = getPolyfill$3();
  var proto = getProto(regex);
  var descriptor = gOPD$2(proto, "flags");
  if (!descriptor || descriptor.get !== polyfill2) {
    defineProperty$3(proto, "flags", {
      configurable: true,
      enumerable: false,
      get: polyfill2
    });
  }
  return polyfill2;
};
var define$3 = defineProperties_1;
var callBind$3 = callBindExports;
var implementation$3 = implementation$5;
var getPolyfill$2 = polyfill$2;
var shim$3 = shim$4;
var flagsBound = callBind$3(getPolyfill$2());
define$3(flagsBound, {
  getPolyfill: getPolyfill$2,
  implementation: implementation$3,
  shim: shim$3
});
var regexp_prototype_flags = flagsBound;
var esGetIterator = { exports: {} };
var hasSymbols$1 = shams$1;
var shams = function hasToStringTagShams() {
  return hasSymbols$1() && !!Symbol.toStringTag;
};
var hasToStringTag$7 = shams();
var callBound$a = callBound$c;
var $toString$4 = callBound$a("Object.prototype.toString");
var isStandardArguments = function isArguments2(value) {
  if (hasToStringTag$7 && value && typeof value === "object" && Symbol.toStringTag in value) {
    return false;
  }
  return $toString$4(value) === "[object Arguments]";
};
var isLegacyArguments = function isArguments3(value) {
  if (isStandardArguments(value)) {
    return true;
  }
  return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $toString$4(value) !== "[object Array]" && $toString$4(value.callee) === "[object Function]";
};
var supportsStandardArguments = function() {
  return isStandardArguments(arguments);
}();
isStandardArguments.isLegacyArguments = isLegacyArguments;
var isArguments$7 = supportsStandardArguments ? isStandardArguments : isLegacyArguments;
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var hasMap$4 = typeof Map === "function" && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap$4 ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var mapSize = hasMap$4 && mapSizeDescriptor && typeof mapSizeDescriptor.get === "function" ? mapSizeDescriptor.get : null;
var mapForEach = hasMap$4 && Map.prototype.forEach;
var hasSet$4 = typeof Set === "function" && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet$4 ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var setSize = hasSet$4 && setSizeDescriptor && typeof setSizeDescriptor.get === "function" ? setSizeDescriptor.get : null;
var setForEach = hasSet$4 && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$2 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice$1 = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf$1 = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
var toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO$1 = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(O2) {
  return O2.__proto__;
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1e3 && num < 1e3 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === "number") {
    var int = num < 0 ? -$floor(-num) : $floor(num);
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice$1.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, "$&_") + "." + $replace.call($replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return $replace.call(str, sepRegex, "$&_");
}
var utilInspect = require$$0;
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol$8(inspectCustom) ? inspectCustom : null;
var objectInspect = function inspect_(obj, options2, depth, seen) {
  var opts = options2 || {};
  if (has$3(opts, "quoteStyle") && (opts.quoteStyle !== "single" && opts.quoteStyle !== "double")) {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has$3(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has$3(opts, "customInspect") ? opts.customInspect : true;
  if (typeof customInspect !== "boolean" && customInspect !== "symbol") {
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  }
  if (has$3(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has$3(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === "undefined") {
    return "undefined";
  }
  if (obj === null) {
    return "null";
  }
  if (typeof obj === "boolean") {
    return obj ? "true" : "false";
  }
  if (typeof obj === "string") {
    return inspectString(obj, opts);
  }
  if (typeof obj === "number") {
    if (obj === 0) {
      return Infinity / obj > 0 ? "0" : "-0";
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === "bigint") {
    var bigIntStr = String(obj) + "n";
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
  if (typeof depth === "undefined") {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") {
    return isArray$i(obj) ? "[Array]" : "[Object]";
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === "undefined") {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return "[Circular]";
  }
  function inspect2(value, from2, noIndent) {
    if (from2) {
      seen = $arrSlice.call(seen);
      seen.push(from2);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has$3(opts, "quoteStyle")) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === "function" && !isRegExp$2(obj)) {
    var name2 = nameOf(obj);
    var keys8 = arrObjKeys(obj, inspect2);
    return "[Function" + (name2 ? ": " + name2 : " (anonymous)") + "]" + (keys8.length > 0 ? " { " + $join.call(keys8, ", ") + " }" : "");
  }
  if (isSymbol$8(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : symToString.call(obj);
    return typeof obj === "object" && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s4 = "<" + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i2 = 0; i2 < attrs.length; i2++) {
      s4 += " " + attrs[i2].name + "=" + wrapQuotes(quote(attrs[i2].value), "double", opts);
    }
    s4 += ">";
    if (obj.childNodes && obj.childNodes.length) {
      s4 += "...";
    }
    s4 += "</" + $toLowerCase.call(String(obj.nodeName)) + ">";
    return s4;
  }
  if (isArray$i(obj)) {
    if (obj.length === 0) {
      return "[]";
    }
    var xs = arrObjKeys(obj, inspect2);
    if (indent && !singleLineValues(xs)) {
      return "[" + indentedJoin(xs, indent) + "]";
    }
    return "[ " + $join.call(xs, ", ") + " ]";
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect2);
    if (!("cause" in Error.prototype) && "cause" in obj && !isEnumerable.call(obj, "cause")) {
      return "{ [" + String(obj) + "] " + $join.call($concat.call("[cause]: " + inspect2(obj.cause), parts), ", ") + " }";
    }
    if (parts.length === 0) {
      return "[" + String(obj) + "]";
    }
    return "{ [" + String(obj) + "] " + $join.call(parts, ", ") + " }";
  }
  if (typeof obj === "object" && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === "function" && utilInspect) {
      return utilInspect(obj, { depth: maxDepth - depth });
    } else if (customInspect !== "symbol" && typeof obj.inspect === "function") {
      return obj.inspect();
    }
  }
  if (isMap$3(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function(value, key) {
        mapParts.push(inspect2(key, obj, true) + " => " + inspect2(value, obj));
      });
    }
    return collectionOf("Map", mapSize.call(obj), mapParts, indent);
  }
  if (isSet$3(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function(value) {
        setParts.push(inspect2(value, obj));
      });
    }
    return collectionOf("Set", setSize.call(obj), setParts, indent);
  }
  if (isWeakMap$1(obj)) {
    return weakCollectionOf("WeakMap");
  }
  if (isWeakSet$1(obj)) {
    return weakCollectionOf("WeakSet");
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf("WeakRef");
  }
  if (isNumber$3(obj)) {
    return markBoxed(inspect2(Number(obj)));
  }
  if (isBigInt$1(obj)) {
    return markBoxed(inspect2(bigIntValueOf$1.call(obj)));
  }
  if (isBoolean$2(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString$7(obj)) {
    return markBoxed(inspect2(String(obj)));
  }
  if (typeof window !== "undefined" && obj === window) {
    return "{ [object Window] }";
  }
  if (obj === commonjsGlobal) {
    return "{ [object globalThis] }";
  }
  if (!isDate$5(obj) && !isRegExp$2(obj)) {
    var ys = arrObjKeys(obj, inspect2);
    var isPlainObject2 = gPO$1 ? gPO$1(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? "" : "null prototype";
    var stringTag2 = !isPlainObject2 && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice$1.call(toStr$6(obj), 8, -1) : protoTag ? "Object" : "";
    var constructorTag = isPlainObject2 || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
    var tag2 = constructorTag + (stringTag2 || protoTag ? "[" + $join.call($concat.call([], stringTag2 || [], protoTag || []), ": ") + "] " : "");
    if (ys.length === 0) {
      return tag2 + "{}";
    }
    if (indent) {
      return tag2 + "{" + indentedJoin(ys, indent) + "}";
    }
    return tag2 + "{ " + $join.call(ys, ", ") + " }";
  }
  return String(obj);
};
function wrapQuotes(s4, defaultStyle2, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle2) === "double" ? '"' : "'";
  return quoteChar + s4 + quoteChar;
}
function quote(s4) {
  return $replace.call(String(s4), /"/g, "&quot;");
}
function isArray$i(obj) {
  return toStr$6(obj) === "[object Array]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isDate$5(obj) {
  return toStr$6(obj) === "[object Date]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isRegExp$2(obj) {
  return toStr$6(obj) === "[object RegExp]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isError(obj) {
  return toStr$6(obj) === "[object Error]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isString$7(obj) {
  return toStr$6(obj) === "[object String]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isNumber$3(obj) {
  return toStr$6(obj) === "[object Number]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isBoolean$2(obj) {
  return toStr$6(obj) === "[object Boolean]" && (!toStringTag || !(typeof obj === "object" && toStringTag in obj));
}
function isSymbol$8(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === "object" && obj instanceof Symbol;
  }
  if (typeof obj === "symbol") {
    return true;
  }
  if (!obj || typeof obj !== "object" || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e3) {
  }
  return false;
}
function isBigInt$1(obj) {
  if (!obj || typeof obj !== "object" || !bigIntValueOf$1) {
    return false;
  }
  try {
    bigIntValueOf$1.call(obj);
    return true;
  } catch (e3) {
  }
  return false;
}
var hasOwn$1 = Object.prototype.hasOwnProperty || function(key) {
  return key in this;
};
function has$3(obj, key) {
  return hasOwn$1.call(obj, key);
}
function toStr$6(obj) {
  return objectToString$2.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m3 = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m3) {
    return m3[1];
  }
  return null;
}
function indexOf(xs, x3) {
  if (xs.indexOf) {
    return xs.indexOf(x3);
  }
  for (var i2 = 0, l = xs.length; i2 < l; i2++) {
    if (xs[i2] === x3) {
      return i2;
    }
  }
  return -1;
}
function isMap$3(x3) {
  if (!mapSize || !x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    mapSize.call(x3);
    try {
      setSize.call(x3);
    } catch (s4) {
      return true;
    }
    return x3 instanceof Map;
  } catch (e3) {
  }
  return false;
}
function isWeakMap$1(x3) {
  if (!weakMapHas || !x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    weakMapHas.call(x3, weakMapHas);
    try {
      weakSetHas.call(x3, weakSetHas);
    } catch (s4) {
      return true;
    }
    return x3 instanceof WeakMap;
  } catch (e3) {
  }
  return false;
}
function isWeakRef(x3) {
  if (!weakRefDeref || !x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    weakRefDeref.call(x3);
    return true;
  } catch (e3) {
  }
  return false;
}
function isSet$3(x3) {
  if (!setSize || !x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    setSize.call(x3);
    try {
      mapSize.call(x3);
    } catch (m3) {
      return true;
    }
    return x3 instanceof Set;
  } catch (e3) {
  }
  return false;
}
function isWeakSet$1(x3) {
  if (!weakSetHas || !x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    weakSetHas.call(x3, weakSetHas);
    try {
      weakMapHas.call(x3, weakMapHas);
    } catch (s4) {
      return true;
    }
    return x3 instanceof WeakSet;
  } catch (e3) {
  }
  return false;
}
function isElement(x3) {
  if (!x3 || typeof x3 !== "object") {
    return false;
  }
  if (typeof HTMLElement !== "undefined" && x3 instanceof HTMLElement) {
    return true;
  }
  return typeof x3.nodeName === "string" && typeof x3.getAttribute === "function";
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
    return inspectString($slice$1.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  var s4 = $replace.call($replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s4, "single", opts);
}
function lowbyte(c7) {
  var n = c7.charCodeAt(0);
  var x3 = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[n];
  if (x3) {
    return "\\" + x3;
  }
  return "\\x" + (n < 16 ? "0" : "") + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return "Object(" + str + ")";
}
function weakCollectionOf(type2) {
  return type2 + " { ? }";
}
function collectionOf(type2, size, entries6, indent) {
  var joinedEntries = indent ? indentedJoin(entries6, indent) : $join.call(entries6, ", ");
  return type2 + " (" + size + ") {" + joinedEntries + "}";
}
function singleLineValues(xs) {
  for (var i2 = 0; i2 < xs.length; i2++) {
    if (indexOf(xs[i2], "\n") >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === "	") {
    baseIndent = "	";
  } else if (typeof opts.indent === "number" && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), " ");
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return "";
  }
  var lineJoiner = "\n" + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function arrObjKeys(obj, inspect2) {
  var isArr = isArray$i(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i2 = 0; i2 < obj.length; i2++) {
      xs[i2] = has$3(obj, i2) ? inspect2(obj[i2], obj) : "";
    }
  }
  var syms = typeof gOPS === "function" ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k3 = 0; k3 < syms.length; k3++) {
      symMap["$" + syms[k3]] = syms[k3];
    }
  }
  for (var key in obj) {
    if (!has$3(obj, key)) {
      continue;
    }
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    }
    if (hasShammedSymbols && symMap["$" + key] instanceof Symbol) {
      continue;
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect2(key, obj) + ": " + inspect2(obj[key], obj));
    } else {
      xs.push(key + ": " + inspect2(obj[key], obj));
    }
  }
  if (typeof gOPS === "function") {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push("[" + inspect2(syms[j]) + "]: " + inspect2(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}
var GetIntrinsic$4 = getIntrinsic;
var callBound$9 = callBound$c;
var inspect = objectInspect;
var $TypeError$1 = type;
var $WeakMap$1 = GetIntrinsic$4("%WeakMap%", true);
var $Map$3 = GetIntrinsic$4("%Map%", true);
var $weakMapGet = callBound$9("WeakMap.prototype.get", true);
var $weakMapSet = callBound$9("WeakMap.prototype.set", true);
var $weakMapHas = callBound$9("WeakMap.prototype.has", true);
var $mapGet$1 = callBound$9("Map.prototype.get", true);
var $mapSet = callBound$9("Map.prototype.set", true);
var $mapHas$5 = callBound$9("Map.prototype.has", true);
var listGetNode = function(list, key) {
  var prev2 = list;
  var curr;
  for (; (curr = prev2.next) !== null; prev2 = curr) {
    if (curr.key === key) {
      prev2.next = curr.next;
      curr.next = /** @type {NonNullable<typeof list.next>} */
      list.next;
      list.next = curr;
      return curr;
    }
  }
};
var listGet = function(objects, key) {
  var node2 = listGetNode(objects, key);
  return node2 && node2.value;
};
var listSet = function(objects, key, value) {
  var node2 = listGetNode(objects, key);
  if (node2) {
    node2.value = value;
  } else {
    objects.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key,
      next: objects.next,
      value
    };
  }
};
var listHas = function(objects, key) {
  return !!listGetNode(objects, key);
};
var sideChannel = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel2 = {
    assert: function(key) {
      if (!channel2.has(key)) {
        throw new $TypeError$1("Side channel does not contain " + inspect(key));
      }
    },
    get: function(key) {
      if ($WeakMap$1 && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map$3) {
        if ($m) {
          return $mapGet$1($m, key);
        }
      } else {
        if ($o) {
          return listGet($o, key);
        }
      }
    },
    has: function(key) {
      if ($WeakMap$1 && key && (typeof key === "object" || typeof key === "function")) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map$3) {
        if ($m) {
          return $mapHas$5($m, key);
        }
      } else {
        if ($o) {
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function(key, value) {
      if ($WeakMap$1 && key && (typeof key === "object" || typeof key === "function")) {
        if (!$wm) {
          $wm = new $WeakMap$1();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map$3) {
        if (!$m) {
          $m = new $Map$3();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          $o = { key: {}, next: null };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel2;
};
var hasOwn = hasown;
var channel = sideChannel();
var $TypeError = type;
var SLOT$1 = {
  assert: function(O2, slot) {
    if (!O2 || typeof O2 !== "object" && typeof O2 !== "function") {
      throw new $TypeError("`O` is not an object");
    }
    if (typeof slot !== "string") {
      throw new $TypeError("`slot` must be a string");
    }
    channel.assert(O2);
    if (!SLOT$1.has(O2, slot)) {
      throw new $TypeError("`" + slot + "` is not present on `O`");
    }
  },
  get: function(O2, slot) {
    if (!O2 || typeof O2 !== "object" && typeof O2 !== "function") {
      throw new $TypeError("`O` is not an object");
    }
    if (typeof slot !== "string") {
      throw new $TypeError("`slot` must be a string");
    }
    var slots = channel.get(O2);
    return slots && slots["$" + slot];
  },
  has: function(O2, slot) {
    if (!O2 || typeof O2 !== "object" && typeof O2 !== "function") {
      throw new $TypeError("`O` is not an object");
    }
    if (typeof slot !== "string") {
      throw new $TypeError("`slot` must be a string");
    }
    var slots = channel.get(O2);
    return !!slots && hasOwn(slots, "$" + slot);
  },
  set: function(O2, slot, V2) {
    if (!O2 || typeof O2 !== "object" && typeof O2 !== "function") {
      throw new $TypeError("`O` is not an object");
    }
    if (typeof slot !== "string") {
      throw new $TypeError("`slot` must be a string");
    }
    var slots = channel.get(O2);
    if (!slots) {
      slots = {};
      channel.set(O2, slots);
    }
    slots["$" + slot] = V2;
  }
};
if (Object.freeze) {
  Object.freeze(SLOT$1);
}
var internalSlot = SLOT$1;
var SLOT = internalSlot;
var $SyntaxError = SyntaxError;
var $StopIteration = typeof StopIteration === "object" ? StopIteration : null;
var stopIterationIterator = function getStopIterationIterator(origIterator) {
  if (!$StopIteration) {
    throw new $SyntaxError("this environment lacks StopIteration");
  }
  SLOT.set(origIterator, "[[Done]]", false);
  var siIterator = {
    next: function next2() {
      var iterator = SLOT.get(this, "[[Iterator]]");
      var done2 = SLOT.get(iterator, "[[Done]]");
      try {
        return {
          done: done2,
          value: done2 ? void 0 : iterator.next()
        };
      } catch (e3) {
        SLOT.set(iterator, "[[Done]]", true);
        if (e3 !== $StopIteration) {
          throw e3;
        }
        return {
          done: true,
          value: void 0
        };
      }
    }
  };
  SLOT.set(siIterator, "[[Iterator]]", origIterator);
  return siIterator;
};
var toString$5 = {}.toString;
var isarray = Array.isArray || function(arr) {
  return toString$5.call(arr) == "[object Array]";
};
var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject2(value) {
  try {
    strValue.call(value);
    return true;
  } catch (e3) {
    return false;
  }
};
var toStr$5 = Object.prototype.toString;
var strClass = "[object String]";
var hasToStringTag$6 = shams();
var isString$6 = function isString(value) {
  if (typeof value === "string") {
    return true;
  }
  if (typeof value !== "object") {
    return false;
  }
  return hasToStringTag$6 ? tryStringObject(value) : toStr$5.call(value) === strClass;
};
var $Map$2 = typeof Map === "function" && Map.prototype ? Map : null;
var $Set$3 = typeof Set === "function" && Set.prototype ? Set : null;
var exported$2;
if (!$Map$2) {
  exported$2 = function isMap3(x3) {
    return false;
  };
}
var $mapHas$4 = $Map$2 ? Map.prototype.has : null;
var $setHas$4 = $Set$3 ? Set.prototype.has : null;
if (!exported$2 && !$mapHas$4) {
  exported$2 = function isMap3(x3) {
    return false;
  };
}
var isMap$2 = exported$2 || function isMap(x3) {
  if (!x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    $mapHas$4.call(x3);
    if ($setHas$4) {
      try {
        $setHas$4.call(x3);
      } catch (e3) {
        return true;
      }
    }
    return x3 instanceof $Map$2;
  } catch (e3) {
  }
  return false;
};
var $Map$1 = typeof Map === "function" && Map.prototype ? Map : null;
var $Set$2 = typeof Set === "function" && Set.prototype ? Set : null;
var exported$1;
if (!$Set$2) {
  exported$1 = function isSet3(x3) {
    return false;
  };
}
var $mapHas$3 = $Map$1 ? Map.prototype.has : null;
var $setHas$3 = $Set$2 ? Set.prototype.has : null;
if (!exported$1 && !$setHas$3) {
  exported$1 = function isSet3(x3) {
    return false;
  };
}
var isSet$2 = exported$1 || function isSet(x3) {
  if (!x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    $setHas$3.call(x3);
    if ($mapHas$3) {
      try {
        $mapHas$3.call(x3);
      } catch (e3) {
        return true;
      }
    }
    return x3 instanceof $Set$2;
  } catch (e3) {
  }
  return false;
};
var isArguments$6 = isArguments$7;
var getStopIterationIterator2 = stopIterationIterator;
if (hasSymbols$5() || shams$1()) {
  var $iterator = Symbol.iterator;
  esGetIterator.exports = function getIterator2(iterable) {
    if (iterable != null && typeof iterable[$iterator] !== "undefined") {
      return iterable[$iterator]();
    }
    if (isArguments$6(iterable)) {
      return Array.prototype[$iterator].call(iterable);
    }
  };
} else {
  var isArray$h = isarray;
  var isString$5 = isString$6;
  var GetIntrinsic$3 = getIntrinsic;
  var $Map = GetIntrinsic$3("%Map%", true);
  var $Set$1 = GetIntrinsic$3("%Set%", true);
  var callBound$8 = callBound$c;
  var $arrayPush = callBound$8("Array.prototype.push");
  var $charCodeAt = callBound$8("String.prototype.charCodeAt");
  var $stringSlice = callBound$8("String.prototype.slice");
  var advanceStringIndex = function advanceStringIndex2(S3, index2) {
    var length2 = S3.length;
    if (index2 + 1 >= length2) {
      return index2 + 1;
    }
    var first = $charCodeAt(S3, index2);
    if (first < 55296 || first > 56319) {
      return index2 + 1;
    }
    var second2 = $charCodeAt(S3, index2 + 1);
    if (second2 < 56320 || second2 > 57343) {
      return index2 + 1;
    }
    return index2 + 2;
  };
  var getArrayIterator = function getArrayIterator2(arraylike) {
    var i2 = 0;
    return {
      next: function next2() {
        var done2 = i2 >= arraylike.length;
        var value;
        if (!done2) {
          value = arraylike[i2];
          i2 += 1;
        }
        return {
          done: done2,
          value
        };
      }
    };
  };
  var getNonCollectionIterator = function getNonCollectionIterator2(iterable, noPrimordialCollections) {
    if (isArray$h(iterable) || isArguments$6(iterable)) {
      return getArrayIterator(iterable);
    }
    if (isString$5(iterable)) {
      var i2 = 0;
      return {
        next: function next2() {
          var nextIndex = advanceStringIndex(iterable, i2);
          var value = $stringSlice(iterable, i2, nextIndex);
          i2 = nextIndex;
          return {
            done: nextIndex > iterable.length,
            value
          };
        }
      };
    }
    if (noPrimordialCollections && typeof iterable["_es6-shim iterator_"] !== "undefined") {
      return iterable["_es6-shim iterator_"]();
    }
  };
  if (!$Map && !$Set$1) {
    esGetIterator.exports = function getIterator2(iterable) {
      if (iterable != null) {
        return getNonCollectionIterator(iterable, true);
      }
    };
  } else {
    var isMap$1 = isMap$2;
    var isSet$1 = isSet$2;
    var $mapForEach = callBound$8("Map.prototype.forEach", true);
    var $setForEach = callBound$8("Set.prototype.forEach", true);
    if (typeof process === "undefined" || !process.versions || !process.versions.node) {
      var $mapIterator = callBound$8("Map.prototype.iterator", true);
      var $setIterator = callBound$8("Set.prototype.iterator", true);
    }
    var $mapAtAtIterator = callBound$8("Map.prototype.@@iterator", true) || callBound$8("Map.prototype._es6-shim iterator_", true);
    var $setAtAtIterator = callBound$8("Set.prototype.@@iterator", true) || callBound$8("Set.prototype._es6-shim iterator_", true);
    var getCollectionIterator = function getCollectionIterator2(iterable) {
      if (isMap$1(iterable)) {
        if ($mapIterator) {
          return getStopIterationIterator2($mapIterator(iterable));
        }
        if ($mapAtAtIterator) {
          return $mapAtAtIterator(iterable);
        }
        if ($mapForEach) {
          var entries6 = [];
          $mapForEach(iterable, function(v, k3) {
            $arrayPush(entries6, [k3, v]);
          });
          return getArrayIterator(entries6);
        }
      }
      if (isSet$1(iterable)) {
        if ($setIterator) {
          return getStopIterationIterator2($setIterator(iterable));
        }
        if ($setAtAtIterator) {
          return $setAtAtIterator(iterable);
        }
        if ($setForEach) {
          var values6 = [];
          $setForEach(iterable, function(v) {
            $arrayPush(values6, v);
          });
          return getArrayIterator(values6);
        }
      }
    };
    esGetIterator.exports = function getIterator2(iterable) {
      return getCollectionIterator(iterable) || getNonCollectionIterator(iterable);
    };
  }
}
var esGetIteratorExports = esGetIterator.exports;
var numberIsNaN = function(value) {
  return value !== value;
};
var implementation$2 = function is(a4, b10) {
  if (a4 === 0 && b10 === 0) {
    return 1 / a4 === 1 / b10;
  }
  if (a4 === b10) {
    return true;
  }
  if (numberIsNaN(a4) && numberIsNaN(b10)) {
    return true;
  }
  return false;
};
var implementation$1 = implementation$2;
var polyfill$1 = function getPolyfill3() {
  return typeof Object.is === "function" ? Object.is : implementation$1;
};
var getPolyfill$1 = polyfill$1;
var define$2 = defineProperties_1;
var shim$2 = function shimObjectIs() {
  var polyfill2 = getPolyfill$1();
  define$2(Object, { is: polyfill2 }, {
    is: function testObjectIs() {
      return Object.is !== polyfill2;
    }
  });
  return polyfill2;
};
var define$1 = defineProperties_1;
var callBind$2 = callBindExports;
var implementation = implementation$2;
var getPolyfill4 = polyfill$1;
var shim$1 = shim$2;
var polyfill = callBind$2(getPolyfill4(), Object);
define$1(polyfill, {
  getPolyfill: getPolyfill4,
  implementation,
  shim: shim$1
});
var objectIs = polyfill;
var callBind$1 = callBindExports;
var callBound$7 = callBound$c;
var GetIntrinsic$2 = getIntrinsic;
var $ArrayBuffer = GetIntrinsic$2("%ArrayBuffer%", true);
var $byteLength$2 = callBound$7("ArrayBuffer.prototype.byteLength", true);
var $toString$3 = callBound$7("Object.prototype.toString");
var abSlice = !!$ArrayBuffer && !$byteLength$2 && new $ArrayBuffer(0).slice;
var $abSlice = !!abSlice && callBind$1(abSlice);
var isArrayBuffer$3 = $byteLength$2 || $abSlice ? function isArrayBuffer(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  try {
    if ($byteLength$2) {
      $byteLength$2(obj);
    } else {
      $abSlice(obj, 0);
    }
    return true;
  } catch (e3) {
    return false;
  }
} : $ArrayBuffer ? function isArrayBuffer2(obj) {
  return $toString$3(obj) === "[object ArrayBuffer]";
} : function isArrayBuffer3(obj) {
  return false;
};
var getDay$1 = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
  try {
    getDay$1.call(value);
    return true;
  } catch (e3) {
    return false;
  }
};
var toStr$4 = Object.prototype.toString;
var dateClass = "[object Date]";
var hasToStringTag$5 = shams();
var isDateObject = function isDateObject2(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  return hasToStringTag$5 ? tryDateObject(value) : toStr$4.call(value) === dateClass;
};
var callBound$6 = callBound$c;
var hasToStringTag$4 = shams();
var has$2;
var $exec;
var isRegexMarker;
var badStringifier;
if (hasToStringTag$4) {
  has$2 = callBound$6("Object.prototype.hasOwnProperty");
  $exec = callBound$6("RegExp.prototype.exec");
  isRegexMarker = {};
  var throwRegexMarker = function() {
    throw isRegexMarker;
  };
  badStringifier = {
    toString: throwRegexMarker,
    valueOf: throwRegexMarker
  };
  if (typeof Symbol.toPrimitive === "symbol") {
    badStringifier[Symbol.toPrimitive] = throwRegexMarker;
  }
}
var $toString$2 = callBound$6("Object.prototype.toString");
var gOPD$1 = Object.getOwnPropertyDescriptor;
var regexClass = "[object RegExp]";
var isRegex$1 = hasToStringTag$4 ? function isRegex(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  var descriptor = gOPD$1(value, "lastIndex");
  var hasLastIndexDataProperty = descriptor && has$2(descriptor, "value");
  if (!hasLastIndexDataProperty) {
    return false;
  }
  try {
    $exec(value, badStringifier);
  } catch (e3) {
    return e3 === isRegexMarker;
  }
} : function isRegex2(value) {
  if (!value || typeof value !== "object" && typeof value !== "function") {
    return false;
  }
  return $toString$2(value) === regexClass;
};
var callBound$5 = callBound$c;
var $byteLength$1 = callBound$5("SharedArrayBuffer.prototype.byteLength", true);
var isSharedArrayBuffer$1 = $byteLength$1 ? function isSharedArrayBuffer(obj) {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  try {
    $byteLength$1(obj);
    return true;
  } catch (e3) {
    return false;
  }
} : function isSharedArrayBuffer2(obj) {
  return false;
};
var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject2(value) {
  try {
    numToStr.call(value);
    return true;
  } catch (e3) {
    return false;
  }
};
var toStr$3 = Object.prototype.toString;
var numClass = "[object Number]";
var hasToStringTag$3 = shams();
var isNumberObject = function isNumberObject2(value) {
  if (typeof value === "number") {
    return true;
  }
  if (typeof value !== "object") {
    return false;
  }
  return hasToStringTag$3 ? tryNumberObject(value) : toStr$3.call(value) === numClass;
};
var callBound$4 = callBound$c;
var $boolToStr = callBound$4("Boolean.prototype.toString");
var $toString$1 = callBound$4("Object.prototype.toString");
var tryBooleanObject = function booleanBrandCheck(value) {
  try {
    $boolToStr(value);
    return true;
  } catch (e3) {
    return false;
  }
};
var boolClass = "[object Boolean]";
var hasToStringTag$2 = shams();
var isBooleanObject = function isBoolean(value) {
  if (typeof value === "boolean") {
    return true;
  }
  if (value === null || typeof value !== "object") {
    return false;
  }
  return hasToStringTag$2 && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString$1(value) === boolClass;
};
var isSymbol$7 = { exports: {} };
var toStr$2 = Object.prototype.toString;
var hasSymbols2 = hasSymbols$5();
if (hasSymbols2) {
  var symToStr = Symbol.prototype.toString;
  var symStringRegex = /^Symbol\(.*\)$/;
  var isSymbolObject = function isRealSymbolObject(value) {
    if (typeof value.valueOf() !== "symbol") {
      return false;
    }
    return symStringRegex.test(symToStr.call(value));
  };
  isSymbol$7.exports = function isSymbol2(value) {
    if (typeof value === "symbol") {
      return true;
    }
    if (toStr$2.call(value) !== "[object Symbol]") {
      return false;
    }
    try {
      return isSymbolObject(value);
    } catch (e3) {
      return false;
    }
  };
} else {
  isSymbol$7.exports = function isSymbol2(value) {
    return false;
  };
}
var isSymbolExports = isSymbol$7.exports;
var isBigint = { exports: {} };
var $BigInt = typeof BigInt !== "undefined" && BigInt;
var hasBigints = function hasNativeBigInts() {
  return typeof $BigInt === "function" && typeof BigInt === "function" && typeof $BigInt(42) === "bigint" && typeof BigInt(42) === "bigint";
};
var hasBigInts = hasBigints();
if (hasBigInts) {
  var bigIntValueOf = BigInt.prototype.valueOf;
  var tryBigInt = function tryBigIntObject(value) {
    try {
      bigIntValueOf.call(value);
      return true;
    } catch (e3) {
    }
    return false;
  };
  isBigint.exports = function isBigInt2(value) {
    if (value === null || typeof value === "undefined" || typeof value === "boolean" || typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "function") {
      return false;
    }
    if (typeof value === "bigint") {
      return true;
    }
    return tryBigInt(value);
  };
} else {
  isBigint.exports = function isBigInt2(value) {
    return false;
  };
}
var isBigintExports = isBigint.exports;
var isString$4 = isString$6;
var isNumber$2 = isNumberObject;
var isBoolean$1 = isBooleanObject;
var isSymbol$6 = isSymbolExports;
var isBigInt = isBigintExports;
var whichBoxedPrimitive$1 = function whichBoxedPrimitive(value) {
  if (value == null || typeof value !== "object" && typeof value !== "function") {
    return null;
  }
  if (isString$4(value)) {
    return "String";
  }
  if (isNumber$2(value)) {
    return "Number";
  }
  if (isBoolean$1(value)) {
    return "Boolean";
  }
  if (isSymbol$6(value)) {
    return "Symbol";
  }
  if (isBigInt(value)) {
    return "BigInt";
  }
};
var $WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $WeakSet$1 = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var exported;
if (!$WeakMap) {
  exported = function isWeakMap3(x3) {
    return false;
  };
}
var $mapHas$2 = $WeakMap ? $WeakMap.prototype.has : null;
var $setHas$2 = $WeakSet$1 ? $WeakSet$1.prototype.has : null;
if (!exported && !$mapHas$2) {
  exported = function isWeakMap3(x3) {
    return false;
  };
}
var isWeakmap = exported || function isWeakMap(x3) {
  if (!x3 || typeof x3 !== "object") {
    return false;
  }
  try {
    $mapHas$2.call(x3, $mapHas$2);
    if ($setHas$2) {
      try {
        $setHas$2.call(x3, $setHas$2);
      } catch (e3) {
        return true;
      }
    }
    return x3 instanceof $WeakMap;
  } catch (e3) {
  }
  return false;
};
var isWeakset = { exports: {} };
var GetIntrinsic$1 = getIntrinsic;
var callBound$3 = callBound$c;
var $WeakSet = GetIntrinsic$1("%WeakSet%", true);
var $setHas$1 = callBound$3("WeakSet.prototype.has", true);
if ($setHas$1) {
  var $mapHas$1 = callBound$3("WeakMap.prototype.has", true);
  isWeakset.exports = function isWeakSet2(x3) {
    if (!x3 || typeof x3 !== "object") {
      return false;
    }
    try {
      $setHas$1(x3, $setHas$1);
      if ($mapHas$1) {
        try {
          $mapHas$1(x3, $mapHas$1);
        } catch (e3) {
          return true;
        }
      }
      return x3 instanceof $WeakSet;
    } catch (e3) {
    }
    return false;
  };
} else {
  isWeakset.exports = function isWeakSet2(x3) {
    return false;
  };
}
var isWeaksetExports = isWeakset.exports;
var isMap2 = isMap$2;
var isSet2 = isSet$2;
var isWeakMap2 = isWeakmap;
var isWeakSet = isWeaksetExports;
var whichCollection$1 = function whichCollection(value) {
  if (value && typeof value === "object") {
    if (isMap2(value)) {
      return "Map";
    }
    if (isSet2(value)) {
      return "Set";
    }
    if (isWeakMap2(value)) {
      return "WeakMap";
    }
    if (isWeakSet(value)) {
      return "WeakSet";
    }
  }
  return false;
};
var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === "function" && typeof Object.defineProperty === "function") {
  try {
    badArrayLike = Object.defineProperty({}, "length", {
      get: function() {
        throw isCallableMarker;
      }
    });
    isCallableMarker = {};
    reflectApply(function() {
      throw 42;
    }, null, badArrayLike);
  } catch (_) {
    if (_ !== isCallableMarker) {
      reflectApply = null;
    }
  }
} else {
  reflectApply = null;
}
var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
  try {
    var fnStr = fnToStr.call(value);
    return constructorRegex.test(fnStr);
  } catch (e3) {
    return false;
  }
};
var tryFunctionObject = function tryFunctionToStr(value) {
  try {
    if (isES6ClassFn(value)) {
      return false;
    }
    fnToStr.call(value);
    return true;
  } catch (e3) {
    return false;
  }
};
var toStr$1 = Object.prototype.toString;
var objectClass = "[object Object]";
var fnClass = "[object Function]";
var genClass = "[object GeneratorFunction]";
var ddaClass = "[object HTMLAllCollection]";
var ddaClass2 = "[object HTML document.all class]";
var ddaClass3 = "[object HTMLCollection]";
var hasToStringTag$1 = typeof Symbol === "function" && !!Symbol.toStringTag;
var isIE68 = !(0 in [,]);
var isDDA = function isDocumentDotAll() {
  return false;
};
if (typeof document === "object") {
  var all2 = document.all;
  if (toStr$1.call(all2) === toStr$1.call(document.all)) {
    isDDA = function isDocumentDotAll2(value) {
      if ((isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) {
        try {
          var str = toStr$1.call(value);
          return (str === ddaClass || str === ddaClass2 || str === ddaClass3 || str === objectClass) && value("") == null;
        } catch (e3) {
        }
      }
      return false;
    };
  }
}
var isCallable$1 = reflectApply ? function isCallable(value) {
  if (isDDA(value)) {
    return true;
  }
  if (!value) {
    return false;
  }
  if (typeof value !== "function" && typeof value !== "object") {
    return false;
  }
  try {
    reflectApply(value, null, badArrayLike);
  } catch (e3) {
    if (e3 !== isCallableMarker) {
      return false;
    }
  }
  return !isES6ClassFn(value) && tryFunctionObject(value);
} : function isCallable2(value) {
  if (isDDA(value)) {
    return true;
  }
  if (!value) {
    return false;
  }
  if (typeof value !== "function" && typeof value !== "object") {
    return false;
  }
  if (hasToStringTag$1) {
    return tryFunctionObject(value);
  }
  if (isES6ClassFn(value)) {
    return false;
  }
  var strClass2 = toStr$1.call(value);
  if (strClass2 !== fnClass && strClass2 !== genClass && !/^\[object HTML/.test(strClass2)) {
    return false;
  }
  return tryFunctionObject(value);
};
var isCallable3 = isCallable$1;
var toStr = Object.prototype.toString;
var hasOwnProperty$f = Object.prototype.hasOwnProperty;
var forEachArray = function forEachArray2(array2, iterator, receiver) {
  for (var i2 = 0, len = array2.length; i2 < len; i2++) {
    if (hasOwnProperty$f.call(array2, i2)) {
      if (receiver == null) {
        iterator(array2[i2], i2, array2);
      } else {
        iterator.call(receiver, array2[i2], i2, array2);
      }
    }
  }
};
var forEachString = function forEachString2(string2, iterator, receiver) {
  for (var i2 = 0, len = string2.length; i2 < len; i2++) {
    if (receiver == null) {
      iterator(string2.charAt(i2), i2, string2);
    } else {
      iterator.call(receiver, string2.charAt(i2), i2, string2);
    }
  }
};
var forEachObject = function forEachObject2(object2, iterator, receiver) {
  for (var k3 in object2) {
    if (hasOwnProperty$f.call(object2, k3)) {
      if (receiver == null) {
        iterator(object2[k3], k3, object2);
      } else {
        iterator.call(receiver, object2[k3], k3, object2);
      }
    }
  }
};
var forEach$3 = function forEach4(list, iterator, thisArg) {
  if (!isCallable3(iterator)) {
    throw new TypeError("iterator must be a function");
  }
  var receiver;
  if (arguments.length >= 3) {
    receiver = thisArg;
  }
  if (toStr.call(list) === "[object Array]") {
    forEachArray(list, iterator, receiver);
  } else if (typeof list === "string") {
    forEachString(list, iterator, receiver);
  } else {
    forEachObject(list, iterator, receiver);
  }
};
var forEach_1 = forEach$3;
var possibleTypedArrayNames = [
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Int16Array",
  "Int32Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array"
];
var possibleNames = possibleTypedArrayNames;
var g$2 = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var availableTypedArrays$1 = function availableTypedArrays() {
  var out = [];
  for (var i2 = 0; i2 < possibleNames.length; i2++) {
    if (typeof g$2[possibleNames[i2]] === "function") {
      out[out.length] = possibleNames[i2];
    }
  }
  return out;
};
var forEach$2 = forEach_1;
var availableTypedArrays2 = availableTypedArrays$1;
var callBind = callBindExports;
var callBound$2 = callBound$c;
var gOPD = gopd$1;
var $toString = callBound$2("Object.prototype.toString");
var hasToStringTag = shams();
var g$1 = typeof globalThis === "undefined" ? commonjsGlobal : globalThis;
var typedArrays = availableTypedArrays2();
var $slice = callBound$2("String.prototype.slice");
var getPrototypeOf$1 = Object.getPrototypeOf;
var $indexOf = callBound$2("Array.prototype.indexOf", true) || function indexOf2(array2, value) {
  for (var i2 = 0; i2 < array2.length; i2 += 1) {
    if (array2[i2] === value) {
      return i2;
    }
  }
  return -1;
};
var cache = { __proto__: null };
if (hasToStringTag && gOPD && getPrototypeOf$1) {
  forEach$2(typedArrays, function(typedArray) {
    var arr = new g$1[typedArray]();
    if (Symbol.toStringTag in arr) {
      var proto = getPrototypeOf$1(arr);
      var descriptor = gOPD(proto, Symbol.toStringTag);
      if (!descriptor) {
        var superProto = getPrototypeOf$1(proto);
        descriptor = gOPD(superProto, Symbol.toStringTag);
      }
      cache["$" + typedArray] = callBind(descriptor.get);
    }
  });
} else {
  forEach$2(typedArrays, function(typedArray) {
    var arr = new g$1[typedArray]();
    var fn2 = arr.slice || arr.set;
    if (fn2) {
      cache["$" + typedArray] = callBind(fn2);
    }
  });
}
var tryTypedArrays = function tryAllTypedArrays(value) {
  var found = false;
  forEach$2(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
    function(getter, typedArray) {
      if (!found) {
        try {
          if ("$" + getter(value) === typedArray) {
            found = $slice(typedArray, 1);
          }
        } catch (e3) {
        }
      }
    }
  );
  return found;
};
var trySlices = function tryAllSlices(value) {
  var found = false;
  forEach$2(
    // eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */
    /** @type {any} */
    cache,
    /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
    function(getter, name2) {
      if (!found) {
        try {
          getter(value);
          found = $slice(name2, 1);
        } catch (e3) {
        }
      }
    }
  );
  return found;
};
var whichTypedArray$1 = function whichTypedArray(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  if (!hasToStringTag) {
    var tag2 = $slice($toString(value), 8, -1);
    if ($indexOf(typedArrays, tag2) > -1) {
      return tag2;
    }
    if (tag2 !== "Object") {
      return false;
    }
    return trySlices(value);
  }
  if (!gOPD) {
    return null;
  }
  return tryTypedArrays(value);
};
var callBound$1 = callBound$c;
var $byteLength = callBound$1("ArrayBuffer.prototype.byteLength", true);
var isArrayBuffer$2 = isArrayBuffer$3;
var arrayBufferByteLength = function byteLength(ab) {
  if (!isArrayBuffer$2(ab)) {
    return NaN;
  }
  return $byteLength ? $byteLength(ab) : ab.byteLength;
};
var assign$5 = object_assign;
var callBound = callBound$c;
var flags2 = regexp_prototype_flags;
var GetIntrinsic2 = getIntrinsic;
var getIterator = esGetIteratorExports;
var getSideChannel2 = sideChannel;
var is$1 = objectIs;
var isArguments$5 = isArguments$7;
var isArray$g = isarray;
var isArrayBuffer$1 = isArrayBuffer$3;
var isDate$4 = isDateObject;
var isRegex3 = isRegex$1;
var isSharedArrayBuffer3 = isSharedArrayBuffer$1;
var objectKeys = objectKeys$2;
var whichBoxedPrimitive2 = whichBoxedPrimitive$1;
var whichCollection2 = whichCollection$1;
var whichTypedArray2 = whichTypedArray$1;
var byteLength2 = arrayBufferByteLength;
var sabByteLength = callBound("SharedArrayBuffer.prototype.byteLength", true);
var $getTime = callBound("Date.prototype.getTime");
var gPO = Object.getPrototypeOf;
var $objToString = callBound("Object.prototype.toString");
var $Set = GetIntrinsic2("%Set%", true);
var $mapHas = callBound("Map.prototype.has", true);
var $mapGet = callBound("Map.prototype.get", true);
var $mapSize = callBound("Map.prototype.size", true);
var $setAdd = callBound("Set.prototype.add", true);
var $setDelete = callBound("Set.prototype.delete", true);
var $setHas = callBound("Set.prototype.has", true);
var $setSize = callBound("Set.prototype.size", true);
function setHasEqualElement(set, val1, opts, channel2) {
  var i2 = getIterator(set);
  var result;
  while ((result = i2.next()) && !result.done) {
    if (internalDeepEqual(val1, result.value, opts, channel2)) {
      $setDelete(set, result.value);
      return true;
    }
  }
  return false;
}
function findLooseMatchingPrimitives(prim) {
  if (typeof prim === "undefined") {
    return null;
  }
  if (typeof prim === "object") {
    return void 0;
  }
  if (typeof prim === "symbol") {
    return false;
  }
  if (typeof prim === "string" || typeof prim === "number") {
    return +prim === +prim;
  }
  return true;
}
function mapMightHaveLoosePrim(a4, b10, prim, item, opts, channel2) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  var curB = $mapGet(b10, altValue);
  var looseOpts = assign$5({}, opts, { strict: false });
  if (typeof curB === "undefined" && !$mapHas(b10, altValue) || !internalDeepEqual(item, curB, looseOpts, channel2)) {
    return false;
  }
  return !$mapHas(a4, altValue) && internalDeepEqual(item, curB, looseOpts, channel2);
}
function setMightHaveLoosePrim(a4, b10, prim) {
  var altValue = findLooseMatchingPrimitives(prim);
  if (altValue != null) {
    return altValue;
  }
  return $setHas(b10, altValue) && !$setHas(a4, altValue);
}
function mapHasEqualEntry(set, map2, key1, item1, opts, channel2) {
  var i2 = getIterator(set);
  var result;
  var key2;
  while ((result = i2.next()) && !result.done) {
    key2 = result.value;
    if (
      // eslint-disable-next-line no-use-before-define
      internalDeepEqual(key1, key2, opts, channel2) && internalDeepEqual(item1, $mapGet(map2, key2), opts, channel2)
    ) {
      $setDelete(set, key2);
      return true;
    }
  }
  return false;
}
function internalDeepEqual(actual, expected, options2, channel2) {
  var opts = options2 || {};
  if (opts.strict ? is$1(actual, expected) : actual === expected) {
    return true;
  }
  var actualBoxed = whichBoxedPrimitive2(actual);
  var expectedBoxed = whichBoxedPrimitive2(expected);
  if (actualBoxed !== expectedBoxed) {
    return false;
  }
  if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") {
    return opts.strict ? is$1(actual, expected) : actual == expected;
  }
  var hasActual = channel2.has(actual);
  var hasExpected = channel2.has(expected);
  var sentinel;
  if (hasActual && hasExpected) {
    if (channel2.get(actual) === channel2.get(expected)) {
      return true;
    }
  } else {
    sentinel = {};
  }
  if (!hasActual) {
    channel2.set(actual, sentinel);
  }
  if (!hasExpected) {
    channel2.set(expected, sentinel);
  }
  return objEquiv(actual, expected, opts, channel2);
}
function isBuffer$5(x3) {
  if (!x3 || typeof x3 !== "object" || typeof x3.length !== "number") {
    return false;
  }
  if (typeof x3.copy !== "function" || typeof x3.slice !== "function") {
    return false;
  }
  if (x3.length > 0 && typeof x3[0] !== "number") {
    return false;
  }
  return !!(x3.constructor && x3.constructor.isBuffer && x3.constructor.isBuffer(x3));
}
function setEquiv(a4, b10, opts, channel2) {
  if ($setSize(a4) !== $setSize(b10)) {
    return false;
  }
  var iA = getIterator(a4);
  var iB = getIterator(b10);
  var resultA;
  var resultB;
  var set;
  while ((resultA = iA.next()) && !resultA.done) {
    if (resultA.value && typeof resultA.value === "object") {
      if (!set) {
        set = new $Set();
      }
      $setAdd(set, resultA.value);
    } else if (!$setHas(b10, resultA.value)) {
      if (opts.strict) {
        return false;
      }
      if (!setMightHaveLoosePrim(a4, b10, resultA.value)) {
        return false;
      }
      if (!set) {
        set = new $Set();
      }
      $setAdd(set, resultA.value);
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      if (resultB.value && typeof resultB.value === "object") {
        if (!setHasEqualElement(set, resultB.value, opts.strict, channel2)) {
          return false;
        }
      } else if (!opts.strict && !$setHas(a4, resultB.value) && !setHasEqualElement(set, resultB.value, opts.strict, channel2)) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}
function mapEquiv(a4, b10, opts, channel2) {
  if ($mapSize(a4) !== $mapSize(b10)) {
    return false;
  }
  var iA = getIterator(a4);
  var iB = getIterator(b10);
  var resultA;
  var resultB;
  var set;
  var key;
  var item1;
  var item2;
  while ((resultA = iA.next()) && !resultA.done) {
    key = resultA.value[0];
    item1 = resultA.value[1];
    if (key && typeof key === "object") {
      if (!set) {
        set = new $Set();
      }
      $setAdd(set, key);
    } else {
      item2 = $mapGet(b10, key);
      if (typeof item2 === "undefined" && !$mapHas(b10, key) || !internalDeepEqual(item1, item2, opts, channel2)) {
        if (opts.strict) {
          return false;
        }
        if (!mapMightHaveLoosePrim(a4, b10, key, item1, opts, channel2)) {
          return false;
        }
        if (!set) {
          set = new $Set();
        }
        $setAdd(set, key);
      }
    }
  }
  if (set) {
    while ((resultB = iB.next()) && !resultB.done) {
      key = resultB.value[0];
      item2 = resultB.value[1];
      if (key && typeof key === "object") {
        if (!mapHasEqualEntry(set, a4, key, item2, opts, channel2)) {
          return false;
        }
      } else if (!opts.strict && (!a4.has(key) || !internalDeepEqual($mapGet(a4, key), item2, opts, channel2)) && !mapHasEqualEntry(set, a4, key, item2, assign$5({}, opts, { strict: false }), channel2)) {
        return false;
      }
    }
    return $setSize(set) === 0;
  }
  return true;
}
function objEquiv(a4, b10, opts, channel2) {
  var i2, key;
  if (typeof a4 !== typeof b10) {
    return false;
  }
  if (a4 == null || b10 == null) {
    return false;
  }
  if ($objToString(a4) !== $objToString(b10)) {
    return false;
  }
  if (isArguments$5(a4) !== isArguments$5(b10)) {
    return false;
  }
  var aIsArray = isArray$g(a4);
  var bIsArray = isArray$g(b10);
  if (aIsArray !== bIsArray) {
    return false;
  }
  var aIsError = a4 instanceof Error;
  var bIsError = b10 instanceof Error;
  if (aIsError !== bIsError) {
    return false;
  }
  if (aIsError || bIsError) {
    if (a4.name !== b10.name || a4.message !== b10.message) {
      return false;
    }
  }
  var aIsRegex = isRegex3(a4);
  var bIsRegex = isRegex3(b10);
  if (aIsRegex !== bIsRegex) {
    return false;
  }
  if ((aIsRegex || bIsRegex) && (a4.source !== b10.source || flags2(a4) !== flags2(b10))) {
    return false;
  }
  var aIsDate = isDate$4(a4);
  var bIsDate = isDate$4(b10);
  if (aIsDate !== bIsDate) {
    return false;
  }
  if (aIsDate || bIsDate) {
    if ($getTime(a4) !== $getTime(b10)) {
      return false;
    }
  }
  if (opts.strict && gPO && gPO(a4) !== gPO(b10)) {
    return false;
  }
  var aWhich = whichTypedArray2(a4);
  var bWhich = whichTypedArray2(b10);
  if (aWhich !== bWhich) {
    return false;
  }
  if (aWhich || bWhich) {
    if (a4.length !== b10.length) {
      return false;
    }
    for (i2 = 0; i2 < a4.length; i2++) {
      if (a4[i2] !== b10[i2]) {
        return false;
      }
    }
    return true;
  }
  var aIsBuffer = isBuffer$5(a4);
  var bIsBuffer = isBuffer$5(b10);
  if (aIsBuffer !== bIsBuffer) {
    return false;
  }
  if (aIsBuffer || bIsBuffer) {
    if (a4.length !== b10.length) {
      return false;
    }
    for (i2 = 0; i2 < a4.length; i2++) {
      if (a4[i2] !== b10[i2]) {
        return false;
      }
    }
    return true;
  }
  var aIsArrayBuffer = isArrayBuffer$1(a4);
  var bIsArrayBuffer = isArrayBuffer$1(b10);
  if (aIsArrayBuffer !== bIsArrayBuffer) {
    return false;
  }
  if (aIsArrayBuffer || bIsArrayBuffer) {
    if (byteLength2(a4) !== byteLength2(b10)) {
      return false;
    }
    return typeof Uint8Array === "function" && internalDeepEqual(new Uint8Array(a4), new Uint8Array(b10), opts, channel2);
  }
  var aIsSAB = isSharedArrayBuffer3(a4);
  var bIsSAB = isSharedArrayBuffer3(b10);
  if (aIsSAB !== bIsSAB) {
    return false;
  }
  if (aIsSAB || bIsSAB) {
    if (sabByteLength(a4) !== sabByteLength(b10)) {
      return false;
    }
    return typeof Uint8Array === "function" && internalDeepEqual(new Uint8Array(a4), new Uint8Array(b10), opts, channel2);
  }
  if (typeof a4 !== typeof b10) {
    return false;
  }
  var ka2 = objectKeys(a4);
  var kb = objectKeys(b10);
  if (ka2.length !== kb.length) {
    return false;
  }
  ka2.sort();
  kb.sort();
  for (i2 = ka2.length - 1; i2 >= 0; i2--) {
    if (ka2[i2] != kb[i2]) {
      return false;
    }
  }
  for (i2 = ka2.length - 1; i2 >= 0; i2--) {
    key = ka2[i2];
    if (!internalDeepEqual(a4[key], b10[key], opts, channel2)) {
      return false;
    }
  }
  var aCollection = whichCollection2(a4);
  var bCollection = whichCollection2(b10);
  if (aCollection !== bCollection) {
    return false;
  }
  if (aCollection === "Set" || bCollection === "Set") {
    return setEquiv(a4, b10, opts, channel2);
  }
  if (aCollection === "Map") {
    return mapEquiv(a4, b10, opts, channel2);
  }
  return true;
}
var deepEqual = function deepEqual2(a4, b10, opts) {
  return internalDeepEqual(a4, b10, opts, getSideChannel2());
};
Object.defineProperty(elementRoleMap$1, "__esModule", {
  value: true
});
elementRoleMap$1.default = void 0;
var _deepEqual = _interopRequireDefault$2(deepEqual);
var _iterationDecorator$1 = _interopRequireDefault$2(iterationDecorator$1);
var _rolesMap$2 = _interopRequireDefault$2(rolesMap$1);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _slicedToArray$1(arr, i2) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i2) || _unsupportedIterableToArray$2(arr, i2) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit$1(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _createForOfIteratorHelper$2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$2(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e3(_e2) {
        throw _e2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s4() {
    it = it.call(o);
  }, n: function n() {
    var step2 = it.next();
    normalCompletion = step2.done;
    return step2;
  }, e: function e3(_e3) {
    didErr = true;
    err = _e3;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
var elementRoles$1 = [];
var keys$5 = _rolesMap$2.default.keys();
for (var i$1 = 0; i$1 < keys$5.length; i$1++) {
  var key = keys$5[i$1];
  var role = _rolesMap$2.default.get(key);
  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
    for (var k$1 = 0; k$1 < concepts.length; k$1++) {
      var relation = concepts[k$1];
      if (relation.module === "HTML") {
        var concept = relation.concept;
        if (concept) {
          (function() {
            var conceptStr = JSON.stringify(concept);
            var elementRoleRelation = elementRoles$1.find(function(relation2) {
              return JSON.stringify(relation2[0]) === conceptStr;
            });
            var roles2 = void 0;
            if (elementRoleRelation) {
              roles2 = elementRoleRelation[1];
            } else {
              roles2 = [];
            }
            var isUnique = true;
            for (var _i = 0; _i < roles2.length; _i++) {
              if (roles2[_i] === key) {
                isUnique = false;
                break;
              }
            }
            if (isUnique) {
              roles2.push(key);
            }
            elementRoles$1.push([concept, roles2]);
          })();
        }
      }
    }
  }
}
var elementRoleMap = {
  entries: function entries4() {
    return elementRoles$1;
  },
  forEach: function forEach5(fn2) {
    var thisArg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper$2(elementRoles$1), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray$1(_step.value, 2), _key = _step$value[0], values6 = _step$value[1];
        fn2.call(thisArg, values6, _key, elementRoles$1);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get6(key) {
    var item = elementRoles$1.find(function(tuple2) {
      return (0, _deepEqual.default)(key, tuple2[0]);
    });
    return item && item[1];
  },
  has: function has4(key) {
    return !!elementRoleMap.get(key);
  },
  keys: function keys5() {
    return elementRoles$1.map(function(_ref2) {
      var _ref22 = _slicedToArray$1(_ref2, 1), key = _ref22[0];
      return key;
    });
  },
  values: function values4() {
    return elementRoles$1.map(function(_ref3) {
      var _ref4 = _slicedToArray$1(_ref3, 2), values6 = _ref4[1];
      return values6;
    });
  }
};
var _default$1 = (0, _iterationDecorator$1.default)(elementRoleMap, elementRoleMap.entries());
elementRoleMap$1.default = _default$1;
var roleElementMap$1 = {};
Object.defineProperty(roleElementMap$1, "__esModule", {
  value: true
});
roleElementMap$1.default = void 0;
var _iterationDecorator = _interopRequireDefault$1(iterationDecorator$1);
var _rolesMap$1 = _interopRequireDefault$1(rolesMap$1);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray$1(arr, i2) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(arr, i2) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i2 && _arr.length === i2)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _createForOfIteratorHelper$1(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return { s: F, n: function n() {
        if (i2 >= o.length)
          return { done: true };
        return { done: false, value: o[i2++] };
      }, e: function e3(_e2) {
        throw _e2;
      }, f: F };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return { s: function s4() {
    it = it.call(o);
  }, n: function n() {
    var step2 = it.next();
    normalCompletion = step2.done;
    return step2;
  }, e: function e3(_e3) {
    didErr = true;
    err = _e3;
  }, f: function f() {
    try {
      if (!normalCompletion && it.return != null)
        it.return();
    } finally {
      if (didErr)
        throw err;
    }
  } };
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++) {
    arr2[i2] = arr[i2];
  }
  return arr2;
}
var roleElement = [];
var keys$4 = _rolesMap$1.default.keys();
var _loop = function _loop2(i2) {
  var key = keys$4[i2];
  var role = _rolesMap$1.default.get(key);
  if (role) {
    var concepts = [].concat(role.baseConcepts, role.relatedConcepts);
    for (var k3 = 0; k3 < concepts.length; k3++) {
      var relation = concepts[k3];
      if (relation.module === "HTML") {
        var concept = relation.concept;
        if (concept) {
          var roleElementRelation = roleElement.find(function(item) {
            return item[0] === key;
          });
          var relationConcepts = void 0;
          if (roleElementRelation) {
            relationConcepts = roleElementRelation[1];
          } else {
            relationConcepts = [];
          }
          relationConcepts.push(concept);
          roleElement.push([key, relationConcepts]);
        }
      }
    }
  }
};
for (var i2 = 0; i2 < keys$4.length; i2++) {
  _loop(i2);
}
var roleElementMap = {
  entries: function entries5() {
    return roleElement;
  },
  forEach: function forEach6(fn2) {
    var thisArg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var _iterator = _createForOfIteratorHelper$1(roleElement), _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done; ) {
        var _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], values6 = _step$value[1];
        fn2.call(thisArg, values6, key, roleElement);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  get: function get7(key) {
    var item = roleElement.find(function(tuple2) {
      return tuple2[0] === key ? true : false;
    });
    return item && item[1];
  },
  has: function has5(key) {
    return !!roleElementMap.get(key);
  },
  keys: function keys6() {
    return roleElement.map(function(_ref2) {
      var _ref22 = _slicedToArray(_ref2, 1), key = _ref22[0];
      return key;
    });
  },
  values: function values5() {
    return roleElement.map(function(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2), values6 = _ref4[1];
      return values6;
    });
  }
};
var _default = (0, _iterationDecorator.default)(roleElementMap, roleElementMap.entries());
roleElementMap$1.default = _default;
Object.defineProperty(lib$1, "__esModule", {
  value: true
});
var roles_1 = lib$1.roles = roleElements_1 = lib$1.roleElements = elementRoles_1 = lib$1.elementRoles = lib$1.dom = lib$1.aria = void 0;
var _ariaPropsMap = _interopRequireDefault(ariaPropsMap$1);
var _domMap = _interopRequireDefault(domMap$1);
var _rolesMap = _interopRequireDefault(rolesMap$1);
var _elementRoleMap = _interopRequireDefault(elementRoleMap$1);
var _roleElementMap = _interopRequireDefault(roleElementMap$1);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var aria = _ariaPropsMap.default;
lib$1.aria = aria;
var dom = _domMap.default;
lib$1.dom = dom;
var roles = _rolesMap.default;
roles_1 = lib$1.roles = roles;
var elementRoles = _elementRoleMap.default;
var elementRoles_1 = lib$1.elementRoles = elementRoles;
var roleElements = _roleElementMap.default;
var roleElements_1 = lib$1.roleElements = roleElements;
var lzString$1 = { exports: {} };
lzString$1.exports;
(function(module2) {
  var LZString = function() {
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character2) {
      if (!baseReverseDic[alphabet]) {
        baseReverseDic[alphabet] = {};
        for (var i2 = 0; i2 < alphabet.length; i2++) {
          baseReverseDic[alphabet][alphabet.charAt(i2)] = i2;
        }
      }
      return baseReverseDic[alphabet][character2];
    }
    var LZString2 = {
      compressToBase64: function(input2) {
        if (input2 == null)
          return "";
        var res = LZString2._compress(input2, 6, function(a4) {
          return keyStrBase64.charAt(a4);
        });
        switch (res.length % 4) {
          default:
          case 0:
            return res;
          case 1:
            return res + "===";
          case 2:
            return res + "==";
          case 3:
            return res + "=";
        }
      },
      decompressFromBase64: function(input2) {
        if (input2 == null)
          return "";
        if (input2 == "")
          return null;
        return LZString2._decompress(input2.length, 32, function(index2) {
          return getBaseValue(keyStrBase64, input2.charAt(index2));
        });
      },
      compressToUTF16: function(input2) {
        if (input2 == null)
          return "";
        return LZString2._compress(input2, 15, function(a4) {
          return f(a4 + 32);
        }) + " ";
      },
      decompressFromUTF16: function(compressed) {
        if (compressed == null)
          return "";
        if (compressed == "")
          return null;
        return LZString2._decompress(compressed.length, 16384, function(index2) {
          return compressed.charCodeAt(index2) - 32;
        });
      },
      //compress into uint8array (UCS-2 big endian format)
      compressToUint8Array: function(uncompressed) {
        var compressed = LZString2.compress(uncompressed);
        var buf = new Uint8Array(compressed.length * 2);
        for (var i2 = 0, TotalLen = compressed.length; i2 < TotalLen; i2++) {
          var current_value = compressed.charCodeAt(i2);
          buf[i2 * 2] = current_value >>> 8;
          buf[i2 * 2 + 1] = current_value % 256;
        }
        return buf;
      },
      //decompress from uint8array (UCS-2 big endian format)
      decompressFromUint8Array: function(compressed) {
        if (compressed === null || compressed === void 0) {
          return LZString2.decompress(compressed);
        } else {
          var buf = new Array(compressed.length / 2);
          for (var i2 = 0, TotalLen = buf.length; i2 < TotalLen; i2++) {
            buf[i2] = compressed[i2 * 2] * 256 + compressed[i2 * 2 + 1];
          }
          var result = [];
          buf.forEach(function(c7) {
            result.push(f(c7));
          });
          return LZString2.decompress(result.join(""));
        }
      },
      //compress into a string that is already URI encoded
      compressToEncodedURIComponent: function(input2) {
        if (input2 == null)
          return "";
        return LZString2._compress(input2, 6, function(a4) {
          return keyStrUriSafe.charAt(a4);
        });
      },
      //decompress from an output of compressToEncodedURIComponent
      decompressFromEncodedURIComponent: function(input2) {
        if (input2 == null)
          return "";
        if (input2 == "")
          return null;
        input2 = input2.replace(/ /g, "+");
        return LZString2._decompress(input2.length, 32, function(index2) {
          return getBaseValue(keyStrUriSafe, input2.charAt(index2));
        });
      },
      compress: function(uncompressed) {
        return LZString2._compress(uncompressed, 16, function(a4) {
          return f(a4);
        });
      },
      _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
        if (uncompressed == null)
          return "";
        var i2, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
        for (ii = 0; ii < uncompressed.length; ii += 1) {
          context_c = uncompressed.charAt(ii);
          if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
            context_dictionary[context_c] = context_dictSize++;
            context_dictionaryToCreate[context_c] = true;
          }
          context_wc = context_w + context_c;
          if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) {
            context_w = context_wc;
          } else {
            if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
              if (context_w.charCodeAt(0) < 256) {
                for (i2 = 0; i2 < context_numBits; i2++) {
                  context_data_val = context_data_val << 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                }
                value = context_w.charCodeAt(0);
                for (i2 = 0; i2 < 8; i2++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              } else {
                value = 1;
                for (i2 = 0; i2 < context_numBits; i2++) {
                  context_data_val = context_data_val << 1 | value;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = 0;
                }
                value = context_w.charCodeAt(0);
                for (i2 = 0; i2 < 16; i2++) {
                  context_data_val = context_data_val << 1 | value & 1;
                  if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                  } else {
                    context_data_position++;
                  }
                  value = value >> 1;
                }
              }
              context_enlargeIn--;
              if (context_enlargeIn == 0) {
                context_enlargeIn = Math.pow(2, context_numBits);
                context_numBits++;
              }
              delete context_dictionaryToCreate[context_w];
            } else {
              value = context_dictionary[context_w];
              for (i2 = 0; i2 < context_numBits; i2++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            }
            context_enlargeIn--;
            if (context_enlargeIn == 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
            context_dictionary[context_wc] = context_dictSize++;
            context_w = String(context_c);
          }
        }
        if (context_w !== "") {
          if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
            if (context_w.charCodeAt(0) < 256) {
              for (i2 = 0; i2 < context_numBits; i2++) {
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
              }
              value = context_w.charCodeAt(0);
              for (i2 = 0; i2 < 8; i2++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            } else {
              value = 1;
              for (i2 = 0; i2 < context_numBits; i2++) {
                context_data_val = context_data_val << 1 | value;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = 0;
              }
              value = context_w.charCodeAt(0);
              for (i2 = 0; i2 < 16; i2++) {
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                  context_data_position = 0;
                  context_data.push(getCharFromInt(context_data_val));
                  context_data_val = 0;
                } else {
                  context_data_position++;
                }
                value = value >> 1;
              }
            }
            context_enlargeIn--;
            if (context_enlargeIn == 0) {
              context_enlargeIn = Math.pow(2, context_numBits);
              context_numBits++;
            }
            delete context_dictionaryToCreate[context_w];
          } else {
            value = context_dictionary[context_w];
            for (i2 = 0; i2 < context_numBits; i2++) {
              context_data_val = context_data_val << 1 | value & 1;
              if (context_data_position == bitsPerChar - 1) {
                context_data_position = 0;
                context_data.push(getCharFromInt(context_data_val));
                context_data_val = 0;
              } else {
                context_data_position++;
              }
              value = value >> 1;
            }
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0) {
            context_enlargeIn = Math.pow(2, context_numBits);
            context_numBits++;
          }
        }
        value = 2;
        for (i2 = 0; i2 < context_numBits; i2++) {
          context_data_val = context_data_val << 1 | value & 1;
          if (context_data_position == bitsPerChar - 1) {
            context_data_position = 0;
            context_data.push(getCharFromInt(context_data_val));
            context_data_val = 0;
          } else {
            context_data_position++;
          }
          value = value >> 1;
        }
        while (true) {
          context_data_val = context_data_val << 1;
          if (context_data_position == bitsPerChar - 1) {
            context_data.push(getCharFromInt(context_data_val));
            break;
          } else
            context_data_position++;
        }
        return context_data.join("");
      },
      decompress: function(compressed) {
        if (compressed == null)
          return "";
        if (compressed == "")
          return null;
        return LZString2._decompress(compressed.length, 32768, function(index2) {
          return compressed.charCodeAt(index2);
        });
      },
      _decompress: function(length2, resetValue, getNextValue) {
        var dictionary = [], enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i2, w2, bits, resb, maxpower, power, c7, data = { val: getNextValue(0), position: resetValue, index: 1 };
        for (i2 = 0; i2 < 3; i2 += 1) {
          dictionary[i2] = i2;
        }
        bits = 0;
        maxpower = Math.pow(2, 2);
        power = 1;
        while (power != maxpower) {
          resb = data.val & data.position;
          data.position >>= 1;
          if (data.position == 0) {
            data.position = resetValue;
            data.val = getNextValue(data.index++);
          }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        switch (bits) {
          case 0:
            bits = 0;
            maxpower = Math.pow(2, 8);
            power = 1;
            while (power != maxpower) {
              resb = data.val & data.position;
              data.position >>= 1;
              if (data.position == 0) {
                data.position = resetValue;
                data.val = getNextValue(data.index++);
              }
              bits |= (resb > 0 ? 1 : 0) * power;
              power <<= 1;
            }
            c7 = f(bits);
            break;
          case 1:
            bits = 0;
            maxpower = Math.pow(2, 16);
            power = 1;
            while (power != maxpower) {
              resb = data.val & data.position;
              data.position >>= 1;
              if (data.position == 0) {
                data.position = resetValue;
                data.val = getNextValue(data.index++);
              }
              bits |= (resb > 0 ? 1 : 0) * power;
              power <<= 1;
            }
            c7 = f(bits);
            break;
          case 2:
            return "";
        }
        dictionary[3] = c7;
        w2 = c7;
        result.push(c7);
        while (true) {
          if (data.index > length2) {
            return "";
          }
          bits = 0;
          maxpower = Math.pow(2, numBits);
          power = 1;
          while (power != maxpower) {
            resb = data.val & data.position;
            data.position >>= 1;
            if (data.position == 0) {
              data.position = resetValue;
              data.val = getNextValue(data.index++);
            }
            bits |= (resb > 0 ? 1 : 0) * power;
            power <<= 1;
          }
          switch (c7 = bits) {
            case 0:
              bits = 0;
              maxpower = Math.pow(2, 8);
              power = 1;
              while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                  data.position = resetValue;
                  data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
              }
              dictionary[dictSize++] = f(bits);
              c7 = dictSize - 1;
              enlargeIn--;
              break;
            case 1:
              bits = 0;
              maxpower = Math.pow(2, 16);
              power = 1;
              while (power != maxpower) {
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                  data.position = resetValue;
                  data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
              }
              dictionary[dictSize++] = f(bits);
              c7 = dictSize - 1;
              enlargeIn--;
              break;
            case 2:
              return result.join("");
          }
          if (enlargeIn == 0) {
            enlargeIn = Math.pow(2, numBits);
            numBits++;
          }
          if (dictionary[c7]) {
            entry = dictionary[c7];
          } else {
            if (c7 === dictSize) {
              entry = w2 + w2.charAt(0);
            } else {
              return null;
            }
          }
          result.push(entry);
          dictionary[dictSize++] = w2 + entry.charAt(0);
          enlargeIn--;
          w2 = entry;
          if (enlargeIn == 0) {
            enlargeIn = Math.pow(2, numBits);
            numBits++;
          }
        }
      }
    };
    return LZString2;
  }();
  if (module2 != null) {
    module2.exports = LZString;
  } else if (typeof angular !== "undefined" && angular != null) {
    angular.module("LZString", []).factory("LZString", function() {
      return LZString;
    });
  }
})(lzString$1);
var lzStringExports = lzString$1.exports;
const lzString = /* @__PURE__ */ getDefaultExportFromCjs(lzStringExports);
function escapeHTML$1(str) {
  return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const printProps$1 = (keys8, props2, config2, indentation, depth, refs, printer2) => {
  const indentationNext = indentation + config2.indent;
  const colors3 = config2.colors;
  return keys8.map((key) => {
    const value = props2[key];
    let printed = printer2(value, config2, indentationNext, depth, refs);
    if (typeof value !== "string") {
      if (printed.indexOf("\n") !== -1) {
        printed = config2.spacingOuter + indentationNext + printed + config2.spacingOuter + indentation;
      }
      printed = "{" + printed + "}";
    }
    return config2.spacingInner + indentation + colors3.prop.open + key + colors3.prop.close + "=" + colors3.value.open + printed + colors3.value.close;
  }).join("");
};
const NodeTypeTextNode$1 = 3;
const printChildren$1 = (children2, config2, indentation, depth, refs, printer2) => children2.map((child) => {
  const printedChild = typeof child === "string" ? printText$1(child, config2) : printer2(child, config2, indentation, depth, refs);
  if (printedChild === "" && typeof child === "object" && child !== null && child.nodeType !== NodeTypeTextNode$1) {
    return "";
  }
  return config2.spacingOuter + indentation + printedChild;
}).join("");
const printText$1 = (text2, config2) => {
  const contentColor = config2.colors.content;
  return contentColor.open + escapeHTML$1(text2) + contentColor.close;
};
const printComment$1 = (comment2, config2) => {
  const commentColor = config2.colors.comment;
  return commentColor.open + "<!--" + escapeHTML$1(comment2) + "-->" + commentColor.close;
};
const printElement$1 = (type2, printedProps, printedChildren, config2, indentation) => {
  const tagColor = config2.colors.tag;
  return tagColor.open + "<" + type2 + (printedProps && tagColor.close + printedProps + config2.spacingOuter + indentation + tagColor.open) + (printedChildren ? ">" + tagColor.close + printedChildren + config2.spacingOuter + indentation + tagColor.open + "</" + type2 : (printedProps && !config2.min ? "" : " ") + "/") + ">" + tagColor.close;
};
const printElementAsLeaf$1 = (type2, config2) => {
  const tagColor = config2.colors.tag;
  return tagColor.open + "<" + type2 + tagColor.close + " …" + tagColor.open + " />" + tagColor.close;
};
const ELEMENT_NODE$1$1 = 1;
const TEXT_NODE$1$1 = 3;
const COMMENT_NODE$1$1 = 8;
const FRAGMENT_NODE$1 = 11;
const ELEMENT_REGEXP$1 = /^((HTML|SVG)\w*)?Element$/;
const testNode$1 = (val) => {
  const constructorName = val.constructor.name;
  const {
    nodeType,
    tagName
  } = val;
  const isCustomElement = typeof tagName === "string" && tagName.includes("-") || typeof val.hasAttribute === "function" && val.hasAttribute("is");
  return nodeType === ELEMENT_NODE$1$1 && (ELEMENT_REGEXP$1.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1$1 && constructorName === "Text" || nodeType === COMMENT_NODE$1$1 && constructorName === "Comment" || nodeType === FRAGMENT_NODE$1 && constructorName === "DocumentFragment";
};
function nodeIsText$1(node2) {
  return node2.nodeType === TEXT_NODE$1$1;
}
function nodeIsComment$1(node2) {
  return node2.nodeType === COMMENT_NODE$1$1;
}
function nodeIsFragment$1(node2) {
  return node2.nodeType === FRAGMENT_NODE$1;
}
function createDOMElementFilter$1(filterNode) {
  return {
    test: (val) => {
      var _val$constructor2;
      return (val == null ? void 0 : (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode$1(val);
    },
    serialize: (node2, config2, indentation, depth, refs, printer2) => {
      if (nodeIsText$1(node2)) {
        return printText$1(node2.data, config2);
      }
      if (nodeIsComment$1(node2)) {
        return printComment$1(node2.data, config2);
      }
      const type2 = nodeIsFragment$1(node2) ? "DocumentFragment" : node2.tagName.toLowerCase();
      if (++depth > config2.maxDepth) {
        return printElementAsLeaf$1(type2, config2);
      }
      return printElement$1(type2, printProps$1(nodeIsFragment$1(node2) ? [] : Array.from(node2.attributes).map((attr) => attr.name).sort(), nodeIsFragment$1(node2) ? {} : Array.from(node2.attributes).reduce((props2, attribute) => {
        props2[attribute.name] = attribute.value;
        return props2;
      }, {}), config2, indentation + config2.indent, depth, refs, printer2), printChildren$1(Array.prototype.slice.call(node2.childNodes || node2.children).filter(filterNode), config2, indentation + config2.indent, depth, refs, printer2), config2, indentation);
    }
  };
}
let chalk$1 = null;
let readFileSync$1 = null;
let codeFrameColumns$1 = null;
try {
  const nodeRequire = module && module.require;
  readFileSync$1 = nodeRequire.call(module, "fs").readFileSync;
  codeFrameColumns$1 = nodeRequire.call(module, "@babel/code-frame").codeFrameColumns;
  chalk$1 = nodeRequire.call(module, "chalk");
} catch {
}
function getCodeFrame$1(frame2) {
  const locationStart = frame2.indexOf("(") + 1;
  const locationEnd = frame2.indexOf(")");
  const frameLocation = frame2.slice(locationStart, locationEnd);
  const frameLocationElements = frameLocation.split(":");
  const [filename, line2, column2] = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)];
  let rawFileContents = "";
  try {
    rawFileContents = readFileSync$1(filename, "utf-8");
  } catch {
    return "";
  }
  const codeFrame = codeFrameColumns$1(rawFileContents, {
    start: {
      line: line2,
      column: column2
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk$1.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame$1() {
  if (!readFileSync$1 || !codeFrameColumns$1) {
    return "";
  }
  const err = new Error();
  const firstClientCodeFrame = err.stack.split("\n").slice(1).find((frame2) => !frame2.includes("node_modules/"));
  return getCodeFrame$1(firstClientCodeFrame);
}
const TEXT_NODE$2 = 3;
function jestFakeTimersAreEnabled$1() {
  if (typeof jest !== "undefined" && jest !== null) {
    return (
      // legacy timers
      setTimeout._isMockFunction === true || // modern timers
      Object.prototype.hasOwnProperty.call(setTimeout, "clock")
    );
  }
  return false;
}
function getDocument$1() {
  if (typeof window === "undefined") {
    throw new Error("Could not find default container");
  }
  return window.document;
}
function getWindowFromNode$1(node2) {
  if (node2.defaultView) {
    return node2.defaultView;
  } else if (node2.ownerDocument && node2.ownerDocument.defaultView) {
    return node2.ownerDocument.defaultView;
  } else if (node2.window) {
    return node2.window;
  } else if (node2.ownerDocument && node2.ownerDocument.defaultView === null) {
    throw new Error("It looks like the window object is not available for the provided node.");
  } else if (node2.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node2)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node2.debug === "function" && typeof node2.logTestingPlaygroundURL === "function") {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    throw new Error("The given node is not an Element, the node type is: " + typeof node2 + ".");
  }
}
function checkContainerType$1(container2) {
  if (!container2 || !(typeof container2.querySelector === "function") || !(typeof container2.querySelectorAll === "function")) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container2) + ".");
  }
  function getTypeName(object2) {
    if (typeof object2 === "object") {
      return object2 === null ? "null" : object2.constructor.name;
    }
    return typeof object2;
  }
}
const shouldHighlight$1 = () => {
  let colors3;
  try {
    var _process, _process$env2;
    colors3 = JSON.parse((_process = process) == null ? void 0 : (_process$env2 = _process.env) == null ? void 0 : _process$env2.COLORS);
  } catch (e3) {
  }
  if (typeof colors3 === "boolean") {
    return colors3;
  } else {
    return typeof process !== "undefined" && process.versions !== void 0 && process.versions.node !== void 0;
  }
};
const {
  DOMCollection: DOMCollection$1
} = plugins_1;
const ELEMENT_NODE$2 = 1;
const COMMENT_NODE$2 = 8;
function filterCommentsAndDefaultIgnoreTagsTags$1(value) {
  return value.nodeType !== COMMENT_NODE$2 && (value.nodeType !== ELEMENT_NODE$2 || !value.matches(getConfig$1().defaultIgnore));
}
function prettyDOM$1(dom2, maxLength, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (!dom2) {
    dom2 = getDocument$1().body;
  }
  if (typeof maxLength !== "number") {
    maxLength = typeof process !== "undefined" && process.env.DEBUG_PRINT_LIMIT || 7e3;
  }
  if (maxLength === 0) {
    return "";
  }
  if (dom2.documentElement) {
    dom2 = dom2.documentElement;
  }
  let domTypeName = typeof dom2;
  if (domTypeName === "object") {
    domTypeName = dom2.constructor.name;
  } else {
    dom2 = {};
  }
  if (!("outerHTML" in dom2)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }
  const {
    filterNode = filterCommentsAndDefaultIgnoreTagsTags$1,
    ...prettyFormatOptions
  } = options2;
  const debugContent = format_1(dom2, {
    plugins: [createDOMElementFilter$1(filterNode), DOMCollection$1],
    printFunctionName: false,
    highlight: shouldHighlight$1(),
    ...prettyFormatOptions
  });
  return maxLength !== void 0 && dom2.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
const logDOM$1 = function() {
  const userCodeFrame = getUserCodeFrame$1();
  if (userCodeFrame) {
    console.log(prettyDOM$1(...arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM$1(...arguments));
  }
};
let config$2 = {
  testIdAttribute: "data-testid",
  asyncUtilTimeout: 1e3,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: (cb) => cb(),
  unstable_advanceTimersWrapper: (cb) => cb(),
  eventWrapper: (cb) => cb(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: "script, style",
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(message, container2) {
    const prettifiedDOM = prettyDOM$1(container2);
    const error2 = new Error([message, "Ignored nodes: comments, " + config$2.defaultIgnore + "\n" + prettifiedDOM].filter(Boolean).join("\n\n"));
    error2.name = "TestingLibraryElementError";
    return error2;
  },
  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled$1(callback) {
  try {
    config$2._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config$2._disableExpensiveErrorDiagnostics = false;
  }
}
function configure(newConfig) {
  if (typeof newConfig === "function") {
    newConfig = newConfig(config$2);
  }
  config$2 = {
    ...config$2,
    ...newConfig
  };
}
function getConfig$1() {
  return config$2;
}
const labelledNodeNames$1 = ["button", "meter", "output", "progress", "select", "textarea", "input"];
function getTextContent$1(node2) {
  if (labelledNodeNames$1.includes(node2.nodeName.toLowerCase())) {
    return "";
  }
  if (node2.nodeType === TEXT_NODE$2)
    return node2.textContent;
  return Array.from(node2.childNodes).map((childNode) => getTextContent$1(childNode)).join("");
}
function getLabelContent$1(element) {
  let textContent;
  if (element.tagName.toLowerCase() === "label") {
    textContent = getTextContent$1(element);
  } else {
    textContent = element.value || element.textContent;
  }
  return textContent;
}
function getRealLabels$1(element) {
  if (element.labels !== void 0) {
    var _labels;
    return (_labels = element.labels) != null ? _labels : [];
  }
  if (!isLabelable$1(element))
    return [];
  const labels = element.ownerDocument.querySelectorAll("label");
  return Array.from(labels).filter((label2) => label2.control === element);
}
function isLabelable$1(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === "INPUT" && element.getAttribute("type") !== "hidden";
}
function getLabels$1(container2, element, _temp) {
  let {
    selector = "*"
  } = _temp === void 0 ? {} : _temp;
  const ariaLabelledBy = element.getAttribute("aria-labelledby");
  const labelsId = ariaLabelledBy ? ariaLabelledBy.split(" ") : [];
  return labelsId.length ? labelsId.map((labelId) => {
    const labellingElement = container2.querySelector('[id="' + labelId + '"]');
    return labellingElement ? {
      content: getLabelContent$1(labellingElement),
      formControl: null
    } : {
      content: "",
      formControl: null
    };
  }) : Array.from(getRealLabels$1(element)).map((label2) => {
    const textToMatch = getLabelContent$1(label2);
    const formControlSelector = "button, input, meter, output, progress, select, textarea";
    const labelledFormControl = Array.from(label2.querySelectorAll(formControlSelector)).filter((formControlElement) => formControlElement.matches(selector))[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}
function assertNotNullOrUndefined$1(matcher) {
  if (matcher === null || matcher === void 0) {
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
      "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?"
    );
  }
}
function fuzzyMatches$1(textToMatch, node2, matcher, normalizer) {
  if (typeof textToMatch !== "string") {
    return false;
  }
  assertNotNullOrUndefined$1(matcher);
  const normalizedText = normalizer(textToMatch);
  if (typeof matcher === "string" || typeof matcher === "number") {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === "function") {
    return matcher(normalizedText, node2);
  } else {
    return matchRegExp$1(matcher, normalizedText);
  }
}
function matches$1(textToMatch, node2, matcher, normalizer) {
  if (typeof textToMatch !== "string") {
    return false;
  }
  assertNotNullOrUndefined$1(matcher);
  const normalizedText = normalizer(textToMatch);
  if (matcher instanceof Function) {
    return matcher(normalizedText, node2);
  } else if (matcher instanceof RegExp) {
    return matchRegExp$1(matcher, normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}
function getDefaultNormalizer$1(_temp) {
  let {
    trim: trim2 = true,
    collapseWhitespace = true
  } = _temp === void 0 ? {} : _temp;
  return (text2) => {
    let normalizedText = text2;
    normalizedText = trim2 ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, " ") : normalizedText;
    return normalizedText;
  };
}
function makeNormalizer$1(_ref2) {
  let {
    trim: trim2,
    collapseWhitespace,
    normalizer
  } = _ref2;
  if (!normalizer) {
    return getDefaultNormalizer$1({
      trim: trim2,
      collapseWhitespace
    });
  }
  if (typeof trim2 !== "undefined" || typeof collapseWhitespace !== "undefined") {
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhitespace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  }
  return normalizer;
}
function matchRegExp$1(matcher, text2) {
  const match2 = matcher.test(text2);
  if (matcher.global && matcher.lastIndex !== 0) {
    console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
    matcher.lastIndex = 0;
  }
  return match2;
}
function getNodeText$1(node2) {
  if (node2.matches("input[type=submit], input[type=button], input[type=reset]")) {
    return node2.value;
  }
  return Array.from(node2.childNodes).filter((child) => child.nodeType === TEXT_NODE$2 && Boolean(child.textContent)).map((c7) => c7.textContent).join("");
}
const elementRoleList$1 = buildElementRoleList$1(elementRoles_1);
function isSubtreeInaccessible$1(element) {
  if (element.hidden === true) {
    return true;
  }
  if (element.getAttribute("aria-hidden") === "true") {
    return true;
  }
  const window2 = element.ownerDocument.defaultView;
  if (window2.getComputedStyle(element).display === "none") {
    return true;
  }
  return false;
}
function isInaccessible$1(element, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible$1
  } = options2;
  const window2 = element.ownerDocument.defaultView;
  if (window2.getComputedStyle(element).visibility === "hidden") {
    return true;
  }
  let currentElement = element;
  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function getImplicitAriaRoles$1(currentNode) {
  for (const {
    match: match2,
    roles: roles2
  } of elementRoleList$1) {
    if (match2(currentNode)) {
      return [...roles2];
    }
  }
  return [];
}
function buildElementRoleList$1(elementRolesMap) {
  function makeElementSelector(_ref2) {
    let {
      name: name2,
      attributes
    } = _ref2;
    return "" + name2 + attributes.map((_ref22) => {
      let {
        name: attributeName,
        value,
        constraints = []
      } = _ref22;
      const shouldNotExist = constraints.indexOf("undefined") !== -1;
      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + '="' + value + '"]';
      } else {
        return "[" + attributeName + "]";
      }
    }).join("");
  }
  function getSelectorSpecificity(_ref3) {
    let {
      attributes = []
    } = _ref3;
    return attributes.length;
  }
  function bySelectorSpecificity(_ref4, _ref5) {
    let {
      specificity: leftSpecificity
    } = _ref4;
    let {
      specificity: rightSpecificity
    } = _ref5;
    return rightSpecificity - leftSpecificity;
  }
  function match2(element) {
    let {
      attributes = []
    } = element;
    const typeTextIndex = attributes.findIndex((attribute) => attribute.value && attribute.name === "type" && attribute.value === "text");
    if (typeTextIndex >= 0) {
      attributes = [...attributes.slice(0, typeTextIndex), ...attributes.slice(typeTextIndex + 1)];
    }
    const selector = makeElementSelector({
      ...element,
      attributes
    });
    return (node2) => {
      if (typeTextIndex >= 0 && node2.type !== "text") {
        return false;
      }
      return node2.matches(selector);
    };
  }
  let result = [];
  for (const [element, roles2] of elementRolesMap.entries()) {
    result = [...result, {
      match: match2(element),
      roles: Array.from(roles2),
      specificity: getSelectorSpecificity(element)
    }];
  }
  return result.sort(bySelectorSpecificity);
}
function getRoles$1(container2, _temp) {
  let {
    hidden = false
  } = _temp === void 0 ? {} : _temp;
  function flattenDOM(node2) {
    return [node2, ...Array.from(node2.children).reduce((acc, child) => [...acc, ...flattenDOM(child)], [])];
  }
  return flattenDOM(container2).filter((element) => {
    return hidden === false ? isInaccessible$1(element) === false : true;
  }).reduce((acc, node2) => {
    let roles2 = [];
    if (node2.hasAttribute("role")) {
      roles2 = node2.getAttribute("role").split(" ").slice(0, 1);
    } else {
      roles2 = getImplicitAriaRoles$1(node2);
    }
    return roles2.reduce((rolesAcc, role) => Array.isArray(rolesAcc[role]) ? {
      ...rolesAcc,
      [role]: [...rolesAcc[role], node2]
    } : {
      ...rolesAcc,
      [role]: [node2]
    }, acc);
  }, {});
}
function prettyRoles$1(dom2, _ref6) {
  let {
    hidden,
    includeDescription
  } = _ref6;
  const roles2 = getRoles$1(dom2, {
    hidden
  });
  return Object.entries(roles2).filter((_ref7) => {
    let [role] = _ref7;
    return role !== "generic";
  }).map((_ref8) => {
    let [role, elements] = _ref8;
    const delimiterBar = "-".repeat(50);
    const elementsString = elements.map((el) => {
      const nameString = 'Name "' + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig$1().computedStyleSupportsPseudoElements
      }) + '":\n';
      const domString = prettyDOM$1(el.cloneNode(false));
      if (includeDescription) {
        const descriptionString = 'Description "' + computeAccessibleDescription(el, {
          computedStyleSupportsPseudoElements: getConfig$1().computedStyleSupportsPseudoElements
        }) + '":\n';
        return "" + nameString + descriptionString + domString;
      }
      return "" + nameString + domString;
    }).join("\n\n");
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join("\n");
}
function computeAriaSelected$1(element) {
  if (element.tagName === "OPTION") {
    return element.selected;
  }
  return checkBooleanAttribute$1(element, "aria-selected");
}
function computeAriaChecked$1(element) {
  if ("indeterminate" in element && element.indeterminate) {
    return void 0;
  }
  if ("checked" in element) {
    return element.checked;
  }
  return checkBooleanAttribute$1(element, "aria-checked");
}
function computeAriaPressed$1(element) {
  return checkBooleanAttribute$1(element, "aria-pressed");
}
function computeAriaCurrent$1(element) {
  var _ref9, _checkBooleanAttribut;
  return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute$1(element, "aria-current")) != null ? _checkBooleanAttribut : element.getAttribute("aria-current")) != null ? _ref9 : false;
}
function computeAriaExpanded$1(element) {
  return checkBooleanAttribute$1(element, "aria-expanded");
}
function checkBooleanAttribute$1(element, attribute) {
  const attributeValue = element.getAttribute(attribute);
  if (attributeValue === "true") {
    return true;
  }
  if (attributeValue === "false") {
    return false;
  }
  return void 0;
}
function computeHeadingLevel$1(element) {
  const implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  const ariaLevelAttribute = element.getAttribute("aria-level") && Number(element.getAttribute("aria-level"));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}
const normalize$2 = getDefaultNormalizer$1();
function escapeRegExp$2(string2) {
  return string2.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}
function getRegExpMatcher$1(string2) {
  return new RegExp(escapeRegExp$2(string2.toLowerCase()), "i");
}
function makeSuggestion$1(queryName, element, content2, _ref2) {
  let {
    variant: variant3,
    name: name2
  } = _ref2;
  let warning2 = "";
  const queryOptions = {};
  const queryArgs = [["Role", "TestId"].includes(queryName) ? content2 : getRegExpMatcher$1(content2)];
  if (name2) {
    queryOptions.name = getRegExpMatcher$1(name2);
  }
  if (queryName === "Role" && isInaccessible$1(element)) {
    queryOptions.hidden = true;
    warning2 = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }
  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }
  const queryMethod = variant3 + "By" + queryName;
  return {
    queryName,
    queryMethod,
    queryArgs,
    variant: variant3,
    warning: warning2,
    toString() {
      if (warning2) {
        console.warn(warning2);
      }
      let [text2, options2] = queryArgs;
      text2 = typeof text2 === "string" ? "'" + text2 + "'" : text2;
      options2 = options2 ? ", { " + Object.entries(options2).map((_ref22) => {
        let [k3, v] = _ref22;
        return k3 + ": " + v;
      }).join(", ") + " }" : "";
      return queryMethod + "(" + text2 + options2 + ")";
    }
  };
}
function canSuggest$1(currentMethod, requestedMethod, data) {
  return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery$1(element, variant3, method) {
  var _element$getAttribute, _getImplicitAriaRoles;
  if (variant3 === void 0) {
    variant3 = "get";
  }
  if (element.matches(getConfig$1().defaultIgnore)) {
    return void 0;
  }
  const role = (_element$getAttribute = element.getAttribute("role")) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles$1(element)) == null ? void 0 : _getImplicitAriaRoles[0];
  if (role !== "generic" && canSuggest$1("Role", method, role)) {
    return makeSuggestion$1("Role", element, role, {
      variant: variant3,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig$1().computedStyleSupportsPseudoElements
      })
    });
  }
  const labelText = getLabels$1(document, element).map((label2) => label2.content).join(" ");
  if (canSuggest$1("LabelText", method, labelText)) {
    return makeSuggestion$1("LabelText", element, labelText, {
      variant: variant3
    });
  }
  const placeholderText = element.getAttribute("placeholder");
  if (canSuggest$1("PlaceholderText", method, placeholderText)) {
    return makeSuggestion$1("PlaceholderText", element, placeholderText, {
      variant: variant3
    });
  }
  const textContent = normalize$2(getNodeText$1(element));
  if (canSuggest$1("Text", method, textContent)) {
    return makeSuggestion$1("Text", element, textContent, {
      variant: variant3
    });
  }
  if (canSuggest$1("DisplayValue", method, element.value)) {
    return makeSuggestion$1("DisplayValue", element, normalize$2(element.value), {
      variant: variant3
    });
  }
  const alt = element.getAttribute("alt");
  if (canSuggest$1("AltText", method, alt)) {
    return makeSuggestion$1("AltText", element, alt, {
      variant: variant3
    });
  }
  const title = element.getAttribute("title");
  if (canSuggest$1("Title", method, title)) {
    return makeSuggestion$1("Title", element, title, {
      variant: variant3
    });
  }
  const testId = element.getAttribute(getConfig$1().testIdAttribute);
  if (canSuggest$1("TestId", method, testId)) {
    return makeSuggestion$1("TestId", element, testId, {
      variant: variant3
    });
  }
  return void 0;
}
function copyStackTrace$1(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}
function waitFor$1(callback, _ref2) {
  let {
    container: container2 = getDocument$1(),
    timeout: timeout2 = getConfig$1().asyncUtilTimeout,
    showOriginalStackTrace = getConfig$1().showOriginalStackTrace,
    stackTraceError,
    interval: interval2 = 50,
    onTimeout = (error2) => {
      error2.message = getConfig$1().getElementError(error2.message, container2).message;
      return error2;
    },
    mutationObserverOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    }
  } = _ref2;
  if (typeof callback !== "function") {
    throw new TypeError("Received `callback` arg must be a function");
  }
  return new Promise(async (resolve, reject) => {
    let lastError, intervalId, observer;
    let finished = false;
    let promiseStatus = "idle";
    const overallTimeoutTimer = setTimeout(handleTimeout, timeout2);
    const usingJestFakeTimers = jestFakeTimersAreEnabled$1();
    if (usingJestFakeTimers) {
      const {
        unstable_advanceTimersWrapper: advanceTimersWrapper
      } = getConfig$1();
      checkCallback();
      while (!finished) {
        if (!jestFakeTimersAreEnabled$1()) {
          const error2 = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          if (!showOriginalStackTrace)
            copyStackTrace$1(error2, stackTraceError);
          reject(error2);
          return;
        }
        advanceTimersWrapper(() => {
          jest.advanceTimersByTime(interval2);
        });
        checkCallback();
        if (finished) {
          break;
        }
        await advanceTimersWrapper(async () => {
          await new Promise((r) => {
            setTimeout(r, 0);
            jest.advanceTimersByTime(0);
          });
        });
      }
    } else {
      try {
        checkContainerType$1(container2);
      } catch (e3) {
        reject(e3);
        return;
      }
      intervalId = setInterval(checkRealTimersCallback, interval2);
      const {
        MutationObserver
      } = getWindowFromNode$1(container2);
      observer = new MutationObserver(checkRealTimersCallback);
      observer.observe(container2, mutationObserverOptions);
      checkCallback();
    }
    function onDone(error2, result) {
      finished = true;
      clearTimeout(overallTimeoutTimer);
      if (!usingJestFakeTimers) {
        clearInterval(intervalId);
        observer.disconnect();
      }
      if (error2) {
        reject(error2);
      } else {
        resolve(result);
      }
    }
    function checkRealTimersCallback() {
      if (jestFakeTimersAreEnabled$1()) {
        const error2 = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        if (!showOriginalStackTrace)
          copyStackTrace$1(error2, stackTraceError);
        return reject(error2);
      } else {
        return checkCallback();
      }
    }
    function checkCallback() {
      if (promiseStatus === "pending")
        return;
      try {
        const result = runWithExpensiveErrorDiagnosticsDisabled$1(callback);
        if (typeof (result == null ? void 0 : result.then) === "function") {
          promiseStatus = "pending";
          result.then((resolvedValue) => {
            promiseStatus = "resolved";
            onDone(null, resolvedValue);
          }, (rejectedValue) => {
            promiseStatus = "rejected";
            lastError = rejectedValue;
          });
        } else {
          onDone(null, result);
        }
      } catch (error2) {
        lastError = error2;
      }
    }
    function handleTimeout() {
      let error2;
      if (lastError) {
        error2 = lastError;
        if (!showOriginalStackTrace && error2.name === "TestingLibraryElementError") {
          copyStackTrace$1(error2, stackTraceError);
        }
      } else {
        error2 = new Error("Timed out in waitFor.");
        if (!showOriginalStackTrace) {
          copyStackTrace$1(error2, stackTraceError);
        }
      }
      onDone(onTimeout(error2), null);
    }
  });
}
function waitForWrapper$1(callback, options2) {
  const stackTraceError = new Error("STACK_TRACE_MESSAGE");
  return getConfig$1().asyncWrapper(() => waitFor$1(callback, {
    stackTraceError,
    ...options2
  }));
}
function getElementError$1(message, container2) {
  return getConfig$1().getElementError(message, container2);
}
function getMultipleElementsFoundError$1(message, container2) {
  return getElementError$1(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container2);
}
function queryAllByAttribute$1(attribute, container2, text2, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  return Array.from(container2.querySelectorAll("[" + attribute + "]")).filter((node2) => matcher(node2.getAttribute(attribute), node2, text2, matchNormalizer));
}
function makeSingleQuery$1(allQuery, getMultipleError2) {
  return function(container2) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const els = allQuery(container2, ...args);
    if (els.length > 1) {
      const elementStrings = els.map((element) => getElementError$1(null, element).message).join("\n\n");
      throw getMultipleElementsFoundError$1(getMultipleError2(container2, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container2);
    }
    return els[0] || null;
  };
}
function getSuggestionError$1(suggestion, container2) {
  return getConfig$1().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container2);
}
function makeGetAllQuery$1(allQuery, getMissingError2) {
  return function(container2) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const els = allQuery(container2, ...args);
    if (!els.length) {
      throw getConfig$1().getElementError(getMissingError2(container2, ...args), container2);
    }
    return els;
  };
}
function makeFindQuery$1(getter) {
  return (container2, text2, options2, waitForOptions) => {
    return waitForWrapper$1(() => {
      return getter(container2, text2, options2);
    }, {
      container: container2,
      ...waitForOptions
    });
  };
}
const wrapSingleQueryWithSuggestion$1 = (query, queryAllByName, variant3) => function(container2) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  const element = query(container2, ...args);
  const [{
    suggest = getConfig$1().throwSuggestions
  } = {}] = args.slice(-1);
  if (element && suggest) {
    const suggestion = getSuggestedQuery$1(element, variant3);
    if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
      throw getSuggestionError$1(suggestion.toString(), container2);
    }
  }
  return element;
};
const wrapAllByQueryWithSuggestion$1 = (query, queryAllByName, variant3) => function(container2) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  const els = query(container2, ...args);
  const [{
    suggest = getConfig$1().throwSuggestions
  } = {}] = args.slice(-1);
  if (els.length && suggest) {
    const uniqueSuggestionMessages = [...new Set(els.map((element) => {
      var _getSuggestedQuery;
      return (_getSuggestedQuery = getSuggestedQuery$1(element, variant3)) == null ? void 0 : _getSuggestedQuery.toString();
    }))];
    if (
      // only want to suggest if all the els have the same suggestion.
      uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
        getSuggestedQuery$1(els[0], variant3).queryName
      )
    ) {
      throw getSuggestionError$1(uniqueSuggestionMessages[0], container2);
    }
  }
  return els;
};
function buildQueries$1(queryAllBy, getMultipleError2, getMissingError2) {
  const queryBy = wrapSingleQueryWithSuggestion$1(makeSingleQuery$1(queryAllBy, getMultipleError2), queryAllBy.name, "query");
  const getAllBy = makeGetAllQuery$1(queryAllBy, getMissingError2);
  const getBy = makeSingleQuery$1(getAllBy, getMultipleError2);
  const getByWithSuggestions = wrapSingleQueryWithSuggestion$1(getBy, queryAllBy.name, "get");
  const getAllWithSuggestions = wrapAllByQueryWithSuggestion$1(getAllBy, queryAllBy.name.replace("query", "get"), "getAll");
  const findAllBy = makeFindQuery$1(wrapAllByQueryWithSuggestion$1(getAllBy, queryAllBy.name, "findAll"));
  const findBy = makeFindQuery$1(wrapSingleQueryWithSuggestion$1(getBy, queryAllBy.name, "find"));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}
function queryAllLabels$1(container2) {
  return Array.from(container2.querySelectorAll("label,input")).map((node2) => {
    return {
      node: node2,
      textToMatch: getLabelContent$1(node2)
    };
  }).filter((_ref2) => {
    let {
      textToMatch
    } = _ref2;
    return textToMatch !== null;
  });
}
const queryAllLabelsByText$1 = function(container2, text2, _temp) {
  let {
    exact = true,
    trim: trim2,
    collapseWhitespace,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  const textToMatchByLabels = queryAllLabels$1(container2);
  return textToMatchByLabels.filter((_ref2) => {
    let {
      node: node2,
      textToMatch
    } = _ref2;
    return matcher(textToMatch, node2, text2, matchNormalizer);
  }).map((_ref3) => {
    let {
      node: node2
    } = _ref3;
    return node2;
  });
};
const queryAllByLabelText$1 = function(container2, text2, _temp2) {
  let {
    selector = "*",
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp2 === void 0 ? {} : _temp2;
  checkContainerType$1(container2);
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  const matchingLabelledElements = Array.from(container2.querySelectorAll("*")).filter((element) => {
    return getRealLabels$1(element).length || element.hasAttribute("aria-labelledby");
  }).reduce((labelledElements, labelledElement) => {
    const labelList = getLabels$1(container2, labelledElement, {
      selector
    });
    labelList.filter((label2) => Boolean(label2.formControl)).forEach((label2) => {
      if (matcher(label2.content, label2.formControl, text2, matchNormalizer) && label2.formControl)
        labelledElements.push(label2.formControl);
    });
    const labelsValue = labelList.filter((label2) => Boolean(label2.content)).map((label2) => label2.content);
    if (matcher(labelsValue.join(" "), labelledElement, text2, matchNormalizer))
      labelledElements.push(labelledElement);
    if (labelsValue.length > 1) {
      labelsValue.forEach((labelValue, index2) => {
        if (matcher(labelValue, labelledElement, text2, matchNormalizer))
          labelledElements.push(labelledElement);
        const labelsFiltered = [...labelsValue];
        labelsFiltered.splice(index2, 1);
        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(" "), labelledElement, text2, matchNormalizer))
            labelledElements.push(labelledElement);
        }
      });
    }
    return labelledElements;
  }, []).concat(queryAllByAttribute$1("aria-label", container2, text2, {
    exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter((element) => element.matches(selector));
};
const getAllByLabelText$1 = function(container2, text2) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  const els = queryAllByLabelText$1(container2, text2, ...rest);
  if (!els.length) {
    const labels = queryAllLabelsByText$1(container2, text2, ...rest);
    if (labels.length) {
      const tagNames = labels.map((label2) => getTagNameOfElementAssociatedWithLabelViaFor$1(container2, label2)).filter((tagName) => !!tagName);
      if (tagNames.length) {
        throw getConfig$1().getElementError(tagNames.map((tagName) => "Found a label with the text of: " + text2 + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join("\n\n"), container2);
      } else {
        throw getConfig$1().getElementError("Found a label with the text of: " + text2 + `, however no form control was found associated to that label. Make sure you're using the "for" attribute or "aria-labelledby" attribute correctly.`, container2);
      }
    } else {
      throw getConfig$1().getElementError("Unable to find a label with the text of: " + text2, container2);
    }
  }
  return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor$1(container2, label2) {
  const htmlFor = label2.getAttribute("for");
  if (!htmlFor) {
    return null;
  }
  const element = container2.querySelector('[id="' + htmlFor + '"]');
  return element ? element.tagName.toLowerCase() : null;
}
const getMultipleError$7$1 = (c7, text2) => "Found multiple elements with the text of: " + text2;
const queryByLabelText$1 = wrapSingleQueryWithSuggestion$1(makeSingleQuery$1(queryAllByLabelText$1, getMultipleError$7$1), queryAllByLabelText$1.name, "query");
const getByLabelText$1 = makeSingleQuery$1(getAllByLabelText$1, getMultipleError$7$1);
const findAllByLabelText$1 = makeFindQuery$1(wrapAllByQueryWithSuggestion$1(getAllByLabelText$1, getAllByLabelText$1.name, "findAll"));
const findByLabelText$1 = makeFindQuery$1(wrapSingleQueryWithSuggestion$1(getByLabelText$1, getAllByLabelText$1.name, "find"));
const getAllByLabelTextWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(getAllByLabelText$1, getAllByLabelText$1.name, "getAll");
const getByLabelTextWithSuggestions$1 = wrapSingleQueryWithSuggestion$1(getByLabelText$1, getAllByLabelText$1.name, "get");
const queryAllByLabelTextWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByLabelText$1, queryAllByLabelText$1.name, "queryAll");
const queryAllByPlaceholderText$1 = function() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType$1(args[0]);
  return queryAllByAttribute$1("placeholder", ...args);
};
const getMultipleError$6$1 = (c7, text2) => "Found multiple elements with the placeholder text of: " + text2;
const getMissingError$6$1 = (c7, text2) => "Unable to find an element with the placeholder text of: " + text2;
const queryAllByPlaceholderTextWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByPlaceholderText$1, queryAllByPlaceholderText$1.name, "queryAll");
const [queryByPlaceholderText$1, getAllByPlaceholderText$1, getByPlaceholderText$1, findAllByPlaceholderText$1, findByPlaceholderText$1] = buildQueries$1(queryAllByPlaceholderText$1, getMultipleError$6$1, getMissingError$6$1);
const queryAllByText$1 = function(container2, text2, _temp) {
  let {
    selector = "*",
    exact = true,
    collapseWhitespace,
    trim: trim2,
    ignore = getConfig$1().defaultIgnore,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType$1(container2);
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  let baseArray = [];
  if (typeof container2.matches === "function" && container2.matches(selector)) {
    baseArray = [container2];
  }
  return [...baseArray, ...Array.from(container2.querySelectorAll(selector))].filter((node2) => !ignore || !node2.matches(ignore)).filter((node2) => matcher(getNodeText$1(node2), node2, text2, matchNormalizer));
};
const getMultipleError$5$1 = (c7, text2) => "Found multiple elements with the text: " + text2;
const getMissingError$5$1 = function(c7, text2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    collapseWhitespace,
    trim: trim2,
    normalizer,
    selector
  } = options2;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  const normalizedText = matchNormalizer(text2.toString());
  const isNormalizedDifferent = normalizedText !== text2.toString();
  const isCustomSelector = (selector != null ? selector : "*") !== "*";
  return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text2 + "')" : text2) + (isCustomSelector ? ", which matches selector '" + selector + "'" : "") + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
const queryAllByTextWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByText$1, queryAllByText$1.name, "queryAll");
const [queryByText$1, getAllByText$1, getByText$1, findAllByText$1, findByText$1] = buildQueries$1(queryAllByText$1, getMultipleError$5$1, getMissingError$5$1);
const queryAllByDisplayValue$1 = function(container2, value, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType$1(container2);
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  return Array.from(container2.querySelectorAll("input,textarea,select")).filter((node2) => {
    if (node2.tagName === "SELECT") {
      const selectedOptions = Array.from(node2.options).filter((option) => option.selected);
      return selectedOptions.some((optionNode) => matcher(getNodeText$1(optionNode), optionNode, value, matchNormalizer));
    } else {
      return matcher(node2.value, node2, value, matchNormalizer);
    }
  });
};
const getMultipleError$4$1 = (c7, value) => "Found multiple elements with the display value: " + value + ".";
const getMissingError$4$1 = (c7, value) => "Unable to find an element with the display value: " + value + ".";
const queryAllByDisplayValueWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByDisplayValue$1, queryAllByDisplayValue$1.name, "queryAll");
const [queryByDisplayValue$1, getAllByDisplayValue$1, getByDisplayValue$1, findAllByDisplayValue$1, findByDisplayValue$1] = buildQueries$1(queryAllByDisplayValue$1, getMultipleError$4$1, getMissingError$4$1);
const VALID_TAG_REGEXP$1 = /^(img|input|area|.+-.+)$/i;
const queryAllByAltText$1 = function(container2, alt, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  checkContainerType$1(container2);
  return queryAllByAttribute$1("alt", container2, alt, options2).filter((node2) => VALID_TAG_REGEXP$1.test(node2.tagName));
};
const getMultipleError$3$1 = (c7, alt) => "Found multiple elements with the alt text: " + alt;
const getMissingError$3$1 = (c7, alt) => "Unable to find an element with the alt text: " + alt;
const queryAllByAltTextWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByAltText$1, queryAllByAltText$1.name, "queryAll");
const [queryByAltText$1, getAllByAltText$1, getByAltText$1, findAllByAltText$1, findByAltText$1] = buildQueries$1(queryAllByAltText$1, getMultipleError$3$1, getMissingError$3$1);
const isSvgTitle$1 = (node2) => {
  var _node$parentElement;
  return node2.tagName.toLowerCase() === "title" && ((_node$parentElement = node2.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === "svg";
};
const queryAllByTitle$1 = function(container2, text2, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType$1(container2);
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  return Array.from(container2.querySelectorAll("[title], svg > title")).filter((node2) => matcher(node2.getAttribute("title"), node2, text2, matchNormalizer) || isSvgTitle$1(node2) && matcher(getNodeText$1(node2), node2, text2, matchNormalizer));
};
const getMultipleError$2$1 = (c7, title) => "Found multiple elements with the title: " + title + ".";
const getMissingError$2$1 = (c7, title) => "Unable to find an element with the title: " + title + ".";
const queryAllByTitleWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByTitle$1, queryAllByTitle$1.name, "queryAll");
const [queryByTitle$1, getAllByTitle$1, getByTitle$1, findAllByTitle$1, findByTitle$1] = buildQueries$1(queryAllByTitle$1, getMultipleError$2$1, getMissingError$2$1);
function queryAllByRole$1(container2, role, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    hidden = getConfig$1().defaultHidden,
    name: name2,
    description,
    trim: trim2,
    normalizer,
    queryFallbacks = false,
    selected,
    checked,
    pressed,
    current,
    level,
    expanded
  } = _temp === void 0 ? {} : _temp;
  checkContainerType$1(container2);
  const matcher = exact ? matches$1 : fuzzyMatches$1;
  const matchNormalizer = makeNormalizer$1({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  if (selected !== void 0) {
    var _allRoles$get;
    if (((_allRoles$get = roles_1.get(role)) == null ? void 0 : _allRoles$get.props["aria-selected"]) === void 0) {
      throw new Error('"aria-selected" is not supported on role "' + role + '".');
    }
  }
  if (checked !== void 0) {
    var _allRoles$get2;
    if (((_allRoles$get2 = roles_1.get(role)) == null ? void 0 : _allRoles$get2.props["aria-checked"]) === void 0) {
      throw new Error('"aria-checked" is not supported on role "' + role + '".');
    }
  }
  if (pressed !== void 0) {
    var _allRoles$get3;
    if (((_allRoles$get3 = roles_1.get(role)) == null ? void 0 : _allRoles$get3.props["aria-pressed"]) === void 0) {
      throw new Error('"aria-pressed" is not supported on role "' + role + '".');
    }
  }
  if (current !== void 0) {
    var _allRoles$get4;
    if (((_allRoles$get4 = roles_1.get(role)) == null ? void 0 : _allRoles$get4.props["aria-current"]) === void 0) {
      throw new Error('"aria-current" is not supported on role "' + role + '".');
    }
  }
  if (level !== void 0) {
    if (role !== "heading") {
      throw new Error('Role "' + role + '" cannot have "level" property.');
    }
  }
  if (expanded !== void 0) {
    var _allRoles$get5;
    if (((_allRoles$get5 = roles_1.get(role)) == null ? void 0 : _allRoles$get5.props["aria-expanded"]) === void 0) {
      throw new Error('"aria-expanded" is not supported on role "' + role + '".');
    }
  }
  const subtreeIsInaccessibleCache = /* @__PURE__ */ new WeakMap();
  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible$1(element));
    }
    return subtreeIsInaccessibleCache.get(element);
  }
  return Array.from(container2.querySelectorAll(
    // Only query elements that can be matched by the following filters
    makeRoleSelector$1(role, exact, normalizer ? matchNormalizer : void 0)
  )).filter((node2) => {
    const isRoleSpecifiedExplicitly = node2.hasAttribute("role");
    if (isRoleSpecifiedExplicitly) {
      const roleValue = node2.getAttribute("role");
      if (queryFallbacks) {
        return roleValue.split(" ").filter(Boolean).some((text2) => matcher(text2, node2, role, matchNormalizer));
      }
      if (normalizer) {
        return matcher(roleValue, node2, role, matchNormalizer);
      }
      const [firstWord] = roleValue.split(" ");
      return matcher(firstWord, node2, role, matchNormalizer);
    }
    const implicitRoles = getImplicitAriaRoles$1(node2);
    return implicitRoles.some((implicitRole) => matcher(implicitRole, node2, role, matchNormalizer));
  }).filter((element) => {
    if (selected !== void 0) {
      return selected === computeAriaSelected$1(element);
    }
    if (checked !== void 0) {
      return checked === computeAriaChecked$1(element);
    }
    if (pressed !== void 0) {
      return pressed === computeAriaPressed$1(element);
    }
    if (current !== void 0) {
      return current === computeAriaCurrent$1(element);
    }
    if (expanded !== void 0) {
      return expanded === computeAriaExpanded$1(element);
    }
    if (level !== void 0) {
      return level === computeHeadingLevel$1(element);
    }
    return true;
  }).filter((element) => {
    if (name2 === void 0) {
      return true;
    }
    return matches$1(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig$1().computedStyleSupportsPseudoElements
    }), element, name2, (text2) => text2);
  }).filter((element) => {
    if (description === void 0) {
      return true;
    }
    return matches$1(computeAccessibleDescription(element, {
      computedStyleSupportsPseudoElements: getConfig$1().computedStyleSupportsPseudoElements
    }), element, description, (text2) => text2);
  }).filter((element) => {
    return hidden === false ? isInaccessible$1(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  });
}
function makeRoleSelector$1(role, exact, customNormalizer) {
  var _roleElements$get;
  if (typeof role !== "string") {
    return "*";
  }
  const explicitRoleSelector = exact && !customNormalizer ? '*[role~="' + role + '"]' : "*[role]";
  const roleRelations = (_roleElements$get = roleElements_1.get(role)) != null ? _roleElements$get : /* @__PURE__ */ new Set();
  const implicitRoleSelectors = new Set(Array.from(roleRelations).map((_ref2) => {
    let {
      name: name2
    } = _ref2;
    return name2;
  }));
  return [explicitRoleSelector].concat(Array.from(implicitRoleSelectors)).join(",");
}
const getNameHint$1 = (name2) => {
  let nameHint = "";
  if (name2 === void 0) {
    nameHint = "";
  } else if (typeof name2 === "string") {
    nameHint = ' and name "' + name2 + '"';
  } else {
    nameHint = " and name `" + name2 + "`";
  }
  return nameHint;
};
const getMultipleError$1$1 = function(c7, role, _temp2) {
  let {
    name: name2
  } = _temp2 === void 0 ? {} : _temp2;
  return 'Found multiple elements with the role "' + role + '"' + getNameHint$1(name2);
};
const getMissingError$1$1 = function(container2, role, _temp3) {
  let {
    hidden = getConfig$1().defaultHidden,
    name: name2,
    description
  } = _temp3 === void 0 ? {} : _temp3;
  if (getConfig$1()._disableExpensiveErrorDiagnostics) {
    return 'Unable to find role="' + role + '"' + getNameHint$1(name2);
  }
  let roles2 = "";
  Array.from(container2.children).forEach((childElement) => {
    roles2 += prettyRoles$1(childElement, {
      hidden,
      includeDescription: description !== void 0
    });
  });
  let roleMessage;
  if (roles2.length === 0) {
    if (hidden === false) {
      roleMessage = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, then set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole";
    } else {
      roleMessage = "There are no available roles.";
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? "accessible" : "available") + " roles:\n\n  " + roles2.replace(/\n/g, "\n  ").replace(/\n\s\s\n/g, "\n\n") + "\n").trim();
  }
  let nameHint = "";
  if (name2 === void 0) {
    nameHint = "";
  } else if (typeof name2 === "string") {
    nameHint = ' and name "' + name2 + '"';
  } else {
    nameHint = " and name `" + name2 + "`";
  }
  let descriptionHint = "";
  if (description === void 0) {
    descriptionHint = "";
  } else if (typeof description === "string") {
    descriptionHint = ' and description "' + description + '"';
  } else {
    descriptionHint = " and description `" + description + "`";
  }
  return ("\nUnable to find an " + (hidden === false ? "accessible " : "") + 'element with the role "' + role + '"' + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
const queryAllByRoleWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByRole$1, queryAllByRole$1.name, "queryAll");
const [queryByRole$1, getAllByRole$1, getByRole$1, findAllByRole$1, findByRole$1] = buildQueries$1(queryAllByRole$1, getMultipleError$1$1, getMissingError$1$1);
const getTestIdAttribute$1 = () => getConfig$1().testIdAttribute;
const queryAllByTestId$1 = function() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType$1(args[0]);
  return queryAllByAttribute$1(getTestIdAttribute$1(), ...args);
};
const getMultipleError$8 = (c7, id) => "Found multiple elements by: [" + getTestIdAttribute$1() + '="' + id + '"]';
const getMissingError$7 = (c7, id) => "Unable to find an element by: [" + getTestIdAttribute$1() + '="' + id + '"]';
const queryAllByTestIdWithSuggestions$1 = wrapAllByQueryWithSuggestion$1(queryAllByTestId$1, queryAllByTestId$1.name, "queryAll");
const [queryByTestId$1, getAllByTestId$1, getByTestId$1, findAllByTestId$1, findByTestId$1] = buildQueries$1(queryAllByTestId$1, getMultipleError$8, getMissingError$7);
var queries$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions$1,
  queryByLabelText: queryByLabelText$1,
  getAllByLabelText: getAllByLabelTextWithSuggestions$1,
  getByLabelText: getByLabelTextWithSuggestions$1,
  findAllByLabelText: findAllByLabelText$1,
  findByLabelText: findByLabelText$1,
  queryByPlaceholderText: queryByPlaceholderText$1,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions$1,
  getByPlaceholderText: getByPlaceholderText$1,
  getAllByPlaceholderText: getAllByPlaceholderText$1,
  findAllByPlaceholderText: findAllByPlaceholderText$1,
  findByPlaceholderText: findByPlaceholderText$1,
  queryByText: queryByText$1,
  queryAllByText: queryAllByTextWithSuggestions$1,
  getByText: getByText$1,
  getAllByText: getAllByText$1,
  findAllByText: findAllByText$1,
  findByText: findByText$1,
  queryByDisplayValue: queryByDisplayValue$1,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions$1,
  getByDisplayValue: getByDisplayValue$1,
  getAllByDisplayValue: getAllByDisplayValue$1,
  findAllByDisplayValue: findAllByDisplayValue$1,
  findByDisplayValue: findByDisplayValue$1,
  queryByAltText: queryByAltText$1,
  queryAllByAltText: queryAllByAltTextWithSuggestions$1,
  getByAltText: getByAltText$1,
  getAllByAltText: getAllByAltText$1,
  findAllByAltText: findAllByAltText$1,
  findByAltText: findByAltText$1,
  queryByTitle: queryByTitle$1,
  queryAllByTitle: queryAllByTitleWithSuggestions$1,
  getByTitle: getByTitle$1,
  getAllByTitle: getAllByTitle$1,
  findAllByTitle: findAllByTitle$1,
  findByTitle: findByTitle$1,
  queryByRole: queryByRole$1,
  queryAllByRole: queryAllByRoleWithSuggestions$1,
  getAllByRole: getAllByRole$1,
  getByRole: getByRole$1,
  findAllByRole: findAllByRole$1,
  findByRole: findByRole$1,
  queryByTestId: queryByTestId$1,
  queryAllByTestId: queryAllByTestIdWithSuggestions$1,
  getByTestId: getByTestId$1,
  getAllByTestId: getAllByTestId$1,
  findAllByTestId: findAllByTestId$1,
  findByTestId: findByTestId$1
});
function getQueriesForElement$1(element, queries$1$1, initialValue2) {
  if (queries$1$1 === void 0) {
    queries$1$1 = queries$1;
  }
  if (initialValue2 === void 0) {
    initialValue2 = {};
  }
  return Object.keys(queries$1$1).reduce((helpers, key) => {
    const fn2 = queries$1$1[key];
    helpers[key] = fn2.bind(null, element);
    return helpers;
  }, initialValue2);
}
const eventMap$1 = {
  // Clipboard Events
  copy: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  resize: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  scroll: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: "WheelEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionEnd: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  transitionRun: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionStart: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // pointer events
  pointerOver: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: "PopStateEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // window events
  offline: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  online: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  }
};
const eventAliasMap$1 = {
  doubleClick: "dblClick"
};
function fireEvent(element, event2) {
  return getConfig$1().eventWrapper(() => {
    if (!event2) {
      throw new Error("Unable to fire an event - please provide an event object.");
    }
    if (!element) {
      throw new Error('Unable to fire a "' + event2.type + '" event - please provide a DOM element.');
    }
    return element.dispatchEvent(event2);
  });
}
function createEvent(eventName, node2, init2, _temp) {
  let {
    EventType = "Event",
    defaultInit = {}
  } = _temp === void 0 ? {} : _temp;
  if (!node2) {
    throw new Error('Unable to fire a "' + eventName + '" event - please provide a DOM element.');
  }
  const eventInit = {
    ...defaultInit,
    ...init2
  };
  const {
    target: {
      value,
      files: files2,
      ...targetProperties
    } = {}
  } = eventInit;
  if (value !== void 0) {
    setNativeValue(node2, value);
  }
  if (files2 !== void 0) {
    Object.defineProperty(node2, "files", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: files2
    });
  }
  Object.assign(node2, targetProperties);
  const window2 = getWindowFromNode$1(node2);
  const EventConstructor = window2[EventType] || window2.Event;
  let event2;
  if (typeof EventConstructor === "function") {
    event2 = new EventConstructor(eventName, eventInit);
  } else {
    event2 = window2.document.createEvent(EventType);
    const {
      bubbles,
      cancelable,
      detail,
      ...otherInit
    } = eventInit;
    event2.initEvent(eventName, bubbles, cancelable, detail);
    Object.keys(otherInit).forEach((eventKey) => {
      event2[eventKey] = otherInit[eventKey];
    });
  }
  const dataTransferProperties = ["dataTransfer", "clipboardData"];
  dataTransferProperties.forEach((dataTransferKey) => {
    const dataTransferValue = eventInit[dataTransferKey];
    if (typeof dataTransferValue === "object") {
      if (typeof window2.DataTransfer === "function") {
        Object.defineProperty(event2, dataTransferKey, {
          value: Object.getOwnPropertyNames(dataTransferValue).reduce((acc, propName) => {
            Object.defineProperty(acc, propName, {
              value: dataTransferValue[propName]
            });
            return acc;
          }, new window2.DataTransfer())
        });
      } else {
        Object.defineProperty(event2, dataTransferKey, {
          value: dataTransferValue
        });
      }
    }
  });
  return event2;
}
Object.keys(eventMap$1).forEach((key) => {
  const {
    EventType,
    defaultInit
  } = eventMap$1[key];
  const eventName = key.toLowerCase();
  createEvent[key] = (node2, init2) => createEvent(eventName, node2, init2, {
    EventType,
    defaultInit
  });
  fireEvent[key] = (node2, init2) => fireEvent(node2, createEvent[key](node2, init2));
});
function setNativeValue(element, value) {
  const {
    set: valueSetter
  } = Object.getOwnPropertyDescriptor(element, "value") || {};
  const prototype2 = Object.getPrototypeOf(element);
  const {
    set: prototypeValueSetter
  } = Object.getOwnPropertyDescriptor(prototype2, "value") || {};
  if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    if (valueSetter) {
      valueSetter.call(element, value);
    } else {
      throw new Error("The given element does not have a value setter");
    }
  }
}
Object.keys(eventAliasMap$1).forEach((aliasKey) => {
  const key = eventAliasMap$1[aliasKey];
  fireEvent[aliasKey] = function() {
    return fireEvent[key](...arguments);
  };
});
function unindent$1(string2) {
  return string2.replace(/[ \t]*[\n][ \t]*/g, "\n");
}
function encode$3(value) {
  return lzString.compressToEncodedURIComponent(unindent$1(value));
}
function getPlaygroundUrl$1(markup2) {
  return "https://testing-playground.com/#markup=" + encode$3(markup2);
}
const debug$1 = (element, maxLength, options2) => Array.isArray(element) ? element.forEach((el) => logDOM$1(el, maxLength, options2)) : logDOM$1(element, maxLength, options2);
const logTestingPlaygroundURL$1 = function(element) {
  if (element === void 0) {
    element = getDocument$1().body;
  }
  if (!element || !("innerHTML" in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const playgroundUrl = getPlaygroundUrl$1(element.innerHTML);
  console.log("Open this URL in your browser\n\n" + playgroundUrl);
  return playgroundUrl;
};
const initialValue$1 = {
  debug: debug$1,
  logTestingPlaygroundURL: logTestingPlaygroundURL$1
};
typeof document !== "undefined" && document.body ? getQueriesForElement$1(document.body, queries$1, initialValue$1) : Object.keys(queries$1).reduce((helpers, key) => {
  helpers[key] = () => {
    throw new TypeError("For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error");
  };
  return helpers;
}, initialValue$1);
var testUtils = { exports: {} };
var reactDomTestUtils_production_min = { exports: {} };
/** @license React v17.0.2
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
reactDomTestUtils_production_min.exports;
var hasRequiredReactDomTestUtils_production_min;
function requireReactDomTestUtils_production_min() {
  if (hasRequiredReactDomTestUtils_production_min)
    return reactDomTestUtils_production_min.exports;
  hasRequiredReactDomTestUtils_production_min = 1;
  (function(module2, exports2) {
    var h3 = requireObjectAssign(), l = React__default, m3 = ReactDOM__default, n = requireScheduler();
    function p(a4) {
      for (var b10 = "https://reactjs.org/docs/error-decoder.html?invariant=" + a4, c7 = 1; c7 < arguments.length; c7++)
        b10 += "&args[]=" + encodeURIComponent(arguments[c7]);
      return "Minified React error #" + a4 + "; visit " + b10 + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var q2 = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function r(a4) {
      var b10 = a4, c7 = a4;
      if (a4.alternate)
        for (; b10.return; )
          b10 = b10.return;
      else {
        a4 = b10;
        do
          b10 = a4, 0 !== (b10.flags & 1026) && (c7 = b10.return), a4 = b10.return;
        while (a4);
      }
      return 3 === b10.tag ? c7 : null;
    }
    function t2(a4) {
      if (r(a4) !== a4)
        throw Error(p(188));
    }
    function aa(a4) {
      var b10 = a4.alternate;
      if (!b10) {
        b10 = r(a4);
        if (null === b10)
          throw Error(p(188));
        return b10 !== a4 ? null : a4;
      }
      for (var c7 = a4, d3 = b10; ; ) {
        var e3 = c7.return;
        if (null === e3)
          break;
        var g2 = e3.alternate;
        if (null === g2) {
          d3 = e3.return;
          if (null !== d3) {
            c7 = d3;
            continue;
          }
          break;
        }
        if (e3.child === g2.child) {
          for (g2 = e3.child; g2; ) {
            if (g2 === c7)
              return t2(e3), a4;
            if (g2 === d3)
              return t2(e3), b10;
            g2 = g2.sibling;
          }
          throw Error(p(188));
        }
        if (c7.return !== d3.return)
          c7 = e3, d3 = g2;
        else {
          for (var f = false, k3 = e3.child; k3; ) {
            if (k3 === c7) {
              f = true;
              c7 = e3;
              d3 = g2;
              break;
            }
            if (k3 === d3) {
              f = true;
              d3 = e3;
              c7 = g2;
              break;
            }
            k3 = k3.sibling;
          }
          if (!f) {
            for (k3 = g2.child; k3; ) {
              if (k3 === c7) {
                f = true;
                c7 = g2;
                d3 = e3;
                break;
              }
              if (k3 === d3) {
                f = true;
                d3 = g2;
                c7 = e3;
                break;
              }
              k3 = k3.sibling;
            }
            if (!f)
              throw Error(p(189));
          }
        }
        if (c7.alternate !== d3)
          throw Error(p(190));
      }
      if (3 !== c7.tag)
        throw Error(p(188));
      return c7.stateNode.current === c7 ? a4 : b10;
    }
    function u2(a4) {
      var b10 = a4.keyCode;
      "charCode" in a4 ? (a4 = a4.charCode, 0 === a4 && 13 === b10 && (a4 = 13)) : a4 = b10;
      10 === a4 && (a4 = 13);
      return 32 <= a4 || 13 === a4 ? a4 : 0;
    }
    function v() {
      return true;
    }
    function w2() {
      return false;
    }
    function x3(a4) {
      function b10(c7, b11, e3, g2, f) {
        this._reactName = c7;
        this._targetInst = e3;
        this.type = b11;
        this.nativeEvent = g2;
        this.target = f;
        this.currentTarget = null;
        for (var d3 in a4)
          a4.hasOwnProperty(d3) && (c7 = a4[d3], this[d3] = c7 ? c7(g2) : g2[d3]);
        this.isDefaultPrevented = (null != g2.defaultPrevented ? g2.defaultPrevented : false === g2.returnValue) ? v : w2;
        this.isPropagationStopped = w2;
        return this;
      }
      h3(b10.prototype, { preventDefault: function() {
        this.defaultPrevented = true;
        var a5 = this.nativeEvent;
        a5 && (a5.preventDefault ? a5.preventDefault() : "unknown" !== typeof a5.returnValue && (a5.returnValue = false), this.isDefaultPrevented = v);
      }, stopPropagation: function() {
        var a5 = this.nativeEvent;
        a5 && (a5.stopPropagation ? a5.stopPropagation() : "unknown" !== typeof a5.cancelBubble && (a5.cancelBubble = true), this.isPropagationStopped = v);
      }, persist: function() {
      }, isPersistent: v });
      return b10;
    }
    var y4 = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a4) {
      return a4.timeStamp || Date.now();
    }, defaultPrevented: 0, isTrusted: 0 }, ba = x3(y4), z2 = h3({}, y4, { view: 0, detail: 0 });
    x3(z2);
    var A, B2, C, E2 = h3({}, z2, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: D2, button: 0, buttons: 0, relatedTarget: function(a4) {
      return void 0 === a4.relatedTarget ? a4.fromElement === a4.srcElement ? a4.toElement : a4.fromElement : a4.relatedTarget;
    }, movementX: function(a4) {
      if ("movementX" in a4)
        return a4.movementX;
      a4 !== C && (C && "mousemove" === a4.type ? (A = a4.screenX - C.screenX, B2 = a4.screenY - C.screenY) : B2 = A = 0, C = a4);
      return A;
    }, movementY: function(a4) {
      return "movementY" in a4 ? a4.movementY : B2;
    } });
    x3(E2);
    var da = h3({}, E2, { dataTransfer: 0 });
    x3(da);
    var ea = h3({}, z2, { relatedTarget: 0 });
    x3(ea);
    var fa = h3({}, y4, { animationName: 0, elapsedTime: 0, pseudoElement: 0 });
    x3(fa);
    var ha = h3({}, y4, { clipboardData: function(a4) {
      return "clipboardData" in a4 ? a4.clipboardData : window.clipboardData;
    } });
    x3(ha);
    var ia = h3({}, y4, { data: 0 });
    x3(ia);
    var ja = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, ka2 = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, la = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
    function ma(a4) {
      var b10 = this.nativeEvent;
      return b10.getModifierState ? b10.getModifierState(a4) : (a4 = la[a4]) ? !!b10[a4] : false;
    }
    function D2() {
      return ma;
    }
    var na = h3({}, z2, { key: function(a4) {
      if (a4.key) {
        var b10 = ja[a4.key] || a4.key;
        if ("Unidentified" !== b10)
          return b10;
      }
      return "keypress" === a4.type ? (a4 = u2(a4), 13 === a4 ? "Enter" : String.fromCharCode(a4)) : "keydown" === a4.type || "keyup" === a4.type ? ka2[a4.keyCode] || "Unidentified" : "";
    }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: D2, charCode: function(a4) {
      return "keypress" === a4.type ? u2(a4) : 0;
    }, keyCode: function(a4) {
      return "keydown" === a4.type || "keyup" === a4.type ? a4.keyCode : 0;
    }, which: function(a4) {
      return "keypress" === a4.type ? u2(a4) : "keydown" === a4.type || "keyup" === a4.type ? a4.keyCode : 0;
    } });
    x3(na);
    var oa = h3({}, E2, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 });
    x3(oa);
    var pa = h3({}, z2, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: D2 });
    x3(pa);
    var qa = h3({}, y4, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 });
    x3(qa);
    var ra = h3({}, E2, { deltaX: function(a4) {
      return "deltaX" in a4 ? a4.deltaX : "wheelDeltaX" in a4 ? -a4.wheelDeltaX : 0;
    }, deltaY: function(a4) {
      return "deltaY" in a4 ? a4.deltaY : "wheelDeltaY" in a4 ? -a4.wheelDeltaY : "wheelDelta" in a4 ? -a4.wheelDelta : 0;
    }, deltaZ: 0, deltaMode: 0 });
    x3(ra);
    var F = null;
    function G2(a4) {
      if (null === F)
        try {
          var b10 = ("require" + Math.random()).slice(0, 7);
          F = (module2 && module2[b10]).call(module2, "timers").setImmediate;
        } catch (c7) {
          F = function(a5) {
            var b11 = new MessageChannel();
            b11.port1.onmessage = a5;
            b11.port2.postMessage(void 0);
          };
        }
      return F(a4);
    }
    var H3 = m3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events, sa = H3[5], I2 = H3[6], ta = m3.unstable_batchedUpdates, J = q2.IsSomeRendererActing, K2 = "function" === typeof n.unstable_flushAllWithoutAsserting, L2 = n.unstable_flushAllWithoutAsserting || function() {
      for (var a4 = false; sa(); )
        a4 = true;
      return a4;
    };
    function M3(a4) {
      try {
        L2(), G2(function() {
          L2() ? M3(a4) : a4();
        });
      } catch (b10) {
        a4(b10);
      }
    }
    var N = 0, ua = false, O2 = m3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events[6], va = m3.unstable_batchedUpdates, Q2 = q2.IsSomeRendererActing;
    function wa(a4, b10) {
      jest.runOnlyPendingTimers();
      G2(function() {
        try {
          n.unstable_flushAllWithoutAsserting() ? wa(a4, b10) : a4();
        } catch (c7) {
          b10(c7);
        }
      });
    }
    function xa(a4, b10, c7, d3, e3, g2, f, k3, ca) {
      var P = Array.prototype.slice.call(arguments, 3);
      try {
        b10.apply(c7, P);
      } catch (Ga) {
        this.onError(Ga);
      }
    }
    var R2 = false, S3 = null, T2 = false, U = null, ya = { onError: function(a4) {
      R2 = true;
      S3 = a4;
    } };
    function za(a4, b10, c7, d3, e3, g2, f, k3, ca) {
      R2 = false;
      S3 = null;
      xa.apply(ya, arguments);
    }
    function Aa(a4, b10, c7, d3, e3, g2, f, k3, ca) {
      za.apply(this, arguments);
      if (R2) {
        if (R2) {
          var P = S3;
          R2 = false;
          S3 = null;
        } else
          throw Error(p(198));
        T2 || (T2 = true, U = P);
      }
    }
    var V2 = m3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events, Ba = V2[0], Ca = V2[1], Da = V2[2], Ea = V2[3], Fa = V2[4];
    function Ha() {
    }
    function Ia(a4, b10) {
      if (!a4)
        return [];
      a4 = aa(a4);
      if (!a4)
        return [];
      for (var c7 = a4, d3 = []; ; ) {
        if (5 === c7.tag || 6 === c7.tag || 1 === c7.tag || 0 === c7.tag) {
          var e3 = c7.stateNode;
          b10(e3) && d3.push(e3);
        }
        if (c7.child)
          c7.child.return = c7, c7 = c7.child;
        else {
          if (c7 === a4)
            return d3;
          for (; !c7.sibling; ) {
            if (!c7.return || c7.return === a4)
              return d3;
            c7 = c7.return;
          }
          c7.sibling.return = c7.return;
          c7 = c7.sibling;
        }
      }
    }
    function W(a4, b10) {
      if (a4 && !a4._reactInternals) {
        var c7 = "" + a4;
        a4 = Array.isArray(a4) ? "an array" : a4 && 1 === a4.nodeType && a4.tagName ? "a DOM node" : "[object Object]" === c7 ? "object with keys {" + Object.keys(a4).join(", ") + "}" : c7;
        throw Error(p(286, b10, a4));
      }
    }
    function X2(a4) {
      return !(!a4 || 1 !== a4.nodeType || !a4.tagName);
    }
    function Y2(a4) {
      return X2(a4) ? false : null != a4 && "function" === typeof a4.render && "function" === typeof a4.setState;
    }
    function Ja(a4, b10) {
      return Y2(a4) ? a4._reactInternals.type === b10 : false;
    }
    function Z(a4, b10) {
      W(a4, "findAllInRenderedTree");
      return a4 ? Ia(a4._reactInternals, b10) : [];
    }
    function Ka(a4, b10) {
      W(a4, "scryRenderedDOMComponentsWithClass");
      return Z(a4, function(a5) {
        if (X2(a5)) {
          var c7 = a5.className;
          "string" !== typeof c7 && (c7 = a5.getAttribute("class") || "");
          var e3 = c7.split(/\s+/);
          if (!Array.isArray(b10)) {
            if (void 0 === b10)
              throw Error(p(11));
            b10 = b10.split(/\s+/);
          }
          return b10.every(function(a6) {
            return -1 !== e3.indexOf(a6);
          });
        }
        return false;
      });
    }
    function La(a4, b10) {
      W(a4, "scryRenderedDOMComponentsWithTag");
      return Z(a4, function(a5) {
        return X2(a5) && a5.tagName.toUpperCase() === b10.toUpperCase();
      });
    }
    function Ma(a4, b10) {
      W(a4, "scryRenderedComponentsWithType");
      return Z(a4, function(a5) {
        return Ja(a5, b10);
      });
    }
    function Na(a4, b10, c7) {
      var d3 = a4.type || "unknown-event";
      a4.currentTarget = Ca(c7);
      Aa(d3, b10, void 0, a4);
      a4.currentTarget = null;
    }
    function Oa(a4, b10, c7) {
      for (var d3 = []; a4; ) {
        d3.push(a4);
        do
          a4 = a4.return;
        while (a4 && 5 !== a4.tag);
        a4 = a4 ? a4 : null;
      }
      for (a4 = d3.length; 0 < a4--; )
        b10(d3[a4], "captured", c7);
      for (a4 = 0; a4 < d3.length; a4++)
        b10(d3[a4], "bubbled", c7);
    }
    function Pa(a4, b10) {
      var c7 = a4.stateNode;
      if (!c7)
        return null;
      var d3 = Da(c7);
      if (!d3)
        return null;
      c7 = d3[b10];
      a:
        switch (b10) {
          case "onClick":
          case "onClickCapture":
          case "onDoubleClick":
          case "onDoubleClickCapture":
          case "onMouseDown":
          case "onMouseDownCapture":
          case "onMouseMove":
          case "onMouseMoveCapture":
          case "onMouseUp":
          case "onMouseUpCapture":
          case "onMouseEnter":
            (d3 = !d3.disabled) || (a4 = a4.type, d3 = !("button" === a4 || "input" === a4 || "select" === a4 || "textarea" === a4));
            a4 = !d3;
            break a;
          default:
            a4 = false;
        }
      if (a4)
        return null;
      if (c7 && "function" !== typeof c7)
        throw Error(p(
          231,
          b10,
          typeof c7
        ));
      return c7;
    }
    function Qa(a4, b10, c7) {
      a4 && c7 && c7._reactName && (b10 = Pa(a4, c7._reactName)) && (null == c7._dispatchListeners && (c7._dispatchListeners = []), null == c7._dispatchInstances && (c7._dispatchInstances = []), c7._dispatchListeners.push(b10), c7._dispatchInstances.push(a4));
    }
    function Ra(a4, b10, c7) {
      var d3 = c7._reactName;
      "captured" === b10 && (d3 += "Capture");
      if (b10 = Pa(a4, d3))
        null == c7._dispatchListeners && (c7._dispatchListeners = []), null == c7._dispatchInstances && (c7._dispatchInstances = []), c7._dispatchListeners.push(b10), c7._dispatchInstances.push(a4);
    }
    var Sa = {}, Ta = /* @__PURE__ */ new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
    function Ua(a4) {
      return function(b10, c7) {
        if (l.isValidElement(b10))
          throw Error(p(228));
        if (Y2(b10))
          throw Error(p(229));
        var d3 = "on" + a4[0].toUpperCase() + a4.slice(1), e3 = new Ha();
        e3.target = b10;
        e3.type = a4.toLowerCase();
        var g2 = Ba(b10), f = new ba(d3, e3.type, g2, e3, b10);
        f.persist();
        h3(f, c7);
        Ta.has(a4) ? f && f._reactName && Qa(f._targetInst, null, f) : f && f._reactName && Oa(f._targetInst, Ra, f);
        m3.unstable_batchedUpdates(function() {
          Ea(b10);
          if (f) {
            var a5 = f._dispatchListeners, c8 = f._dispatchInstances;
            if (Array.isArray(a5))
              for (var d4 = 0; d4 < a5.length && !f.isPropagationStopped(); d4++)
                Na(
                  f,
                  a5[d4],
                  c8[d4]
                );
            else
              a5 && Na(f, a5, c8);
            f._dispatchListeners = null;
            f._dispatchInstances = null;
            f.isPersistent() || f.constructor.release(f);
          }
          if (T2)
            throw a5 = U, T2 = false, U = null, a5;
        });
        Fa();
      };
    }
    "blur cancel click close contextMenu copy cut auxClick doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play pointerCancel pointerDown pointerUp rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange drag dragEnter dragExit dragLeave dragOver mouseMove mouseOut mouseOver pointerMove pointerOut pointerOver scroll toggle touchMove wheel abort animationEnd animationIteration animationStart canPlay canPlayThrough durationChange emptied encrypted ended error gotPointerCapture load loadedData loadedMetadata loadStart lostPointerCapture playing progress seeking stalled suspend timeUpdate transitionEnd waiting mouseEnter mouseLeave pointerEnter pointerLeave change select beforeInput compositionEnd compositionStart compositionUpdate".split(" ").forEach(function(a4) {
      Sa[a4] = Ua(a4);
    });
    exports2.Simulate = Sa;
    exports2.act = function(a4) {
      function b10() {
        N--;
        J.current = c7;
        I2.current = d3;
      }
      false === ua && (ua = true, console.error("act(...) is not supported in production builds of React, and might not behave as expected."));
      N++;
      var c7 = J.current, d3 = I2.current;
      J.current = true;
      I2.current = true;
      try {
        var e3 = ta(a4);
      } catch (g2) {
        throw b10(), g2;
      }
      if (null !== e3 && "object" === typeof e3 && "function" === typeof e3.then)
        return { then: function(a5, d4) {
          e3.then(function() {
            1 < N || true === K2 && true === c7 ? (b10(), a5()) : M3(function(c8) {
              b10();
              c8 ? d4(c8) : a5();
            });
          }, function(a6) {
            b10();
            d4(a6);
          });
        } };
      try {
        1 !== N || false !== K2 && false !== c7 || L2(), b10();
      } catch (g2) {
        throw b10(), g2;
      }
      return { then: function(a5) {
        a5();
      } };
    };
    exports2.findAllInRenderedTree = Z;
    exports2.findRenderedComponentWithType = function(a4, b10) {
      W(a4, "findRenderedComponentWithType");
      a4 = Ma(a4, b10);
      if (1 !== a4.length)
        throw Error("Did not find exactly one match (found: " + a4.length + ") for componentType:" + b10);
      return a4[0];
    };
    exports2.findRenderedDOMComponentWithClass = function(a4, b10) {
      W(a4, "findRenderedDOMComponentWithClass");
      a4 = Ka(a4, b10);
      if (1 !== a4.length)
        throw Error("Did not find exactly one match (found: " + a4.length + ") for class:" + b10);
      return a4[0];
    };
    exports2.findRenderedDOMComponentWithTag = function(a4, b10) {
      W(a4, "findRenderedDOMComponentWithTag");
      a4 = La(a4, b10);
      if (1 !== a4.length)
        throw Error("Did not find exactly one match (found: " + a4.length + ") for tag:" + b10);
      return a4[0];
    };
    exports2.isCompositeComponent = Y2;
    exports2.isCompositeComponentWithType = Ja;
    exports2.isDOMComponent = X2;
    exports2.isDOMComponentElement = function(a4) {
      return !!(a4 && l.isValidElement(a4) && a4.tagName);
    };
    exports2.isElement = function(a4) {
      return l.isValidElement(a4);
    };
    exports2.isElementOfType = function(a4, b10) {
      return l.isValidElement(a4) && a4.type === b10;
    };
    exports2.mockComponent = function(a4, b10) {
      b10 = b10 || a4.mockTagName || "div";
      a4.prototype.render.mockImplementation(function() {
        return l.createElement(b10, null, this.props.children);
      });
      return this;
    };
    exports2.nativeTouchData = function(a4, b10) {
      return { touches: [{ pageX: a4, pageY: b10 }] };
    };
    exports2.renderIntoDocument = function(a4) {
      var b10 = document.createElement("div");
      return m3.render(a4, b10);
    };
    exports2.scryRenderedComponentsWithType = Ma;
    exports2.scryRenderedDOMComponentsWithClass = Ka;
    exports2.scryRenderedDOMComponentsWithTag = La;
    exports2.traverseTwoPhase = Oa;
    exports2.unstable_concurrentAct = function(a4) {
      function b10() {
        Q2.current = c7;
        O2.current = d3;
      }
      if (void 0 === n.unstable_flushAllWithoutAsserting)
        throw Error("This version of `act` requires a special mock build of Scheduler.");
      if (true !== setTimeout._isMockFunction)
        throw Error("This version of `act` requires Jest's timer mocks (i.e. jest.useFakeTimers).");
      var c7 = Q2.current, d3 = O2.current;
      Q2.current = true;
      O2.current = true;
      try {
        var e3 = va(a4);
        if ("object" === typeof e3 && null !== e3 && "function" === typeof e3.then)
          return { then: function(a5, c8) {
            e3.then(function() {
              wa(function() {
                b10();
                a5();
              }, function(a6) {
                b10();
                c8(a6);
              });
            }, function(a6) {
              b10();
              c8(a6);
            });
          } };
        try {
          do
            var g2 = n.unstable_flushAllWithoutAsserting();
          while (g2);
        } finally {
          b10();
        }
      } catch (f) {
        throw b10(), f;
      }
    };
  })(reactDomTestUtils_production_min, reactDomTestUtils_production_min.exports);
  return reactDomTestUtils_production_min.exports;
}
var reactDomTestUtils_development = { exports: {} };
/** @license React v17.0.2
 * react-dom-test-utils.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
reactDomTestUtils_development.exports;
var hasRequiredReactDomTestUtils_development;
function requireReactDomTestUtils_development() {
  if (hasRequiredReactDomTestUtils_development)
    return reactDomTestUtils_development.exports;
  hasRequiredReactDomTestUtils_development = 1;
  (function(module2, exports2) {
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var _assign2 = requireObjectAssign();
        var React2 = React__default;
        var ReactDOM2 = ReactDOM__default;
        var Scheduler2 = requireScheduler();
        var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function warn2(format2) {
          {
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }
            printWarning("warn", format2, args);
          }
        }
        function error2(format2) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
        function printWarning(level, format2, args) {
          {
            var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack2 = ReactDebugCurrentFrame.getStackAddendum();
            if (stack2 !== "") {
              format2 += "%s";
              args = args.concat([stack2]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format2);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        function get9(key) {
          return key._reactInternals;
        }
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          symbolFor("react.element");
          symbolFor("react.portal");
          symbolFor("react.fragment");
          symbolFor("react.strict_mode");
          symbolFor("react.profiler");
          symbolFor("react.provider");
          symbolFor("react.context");
          symbolFor("react.forward_ref");
          symbolFor("react.suspense");
          symbolFor("react.suspense_list");
          symbolFor("react.memo");
          symbolFor("react.lazy");
          symbolFor("react.block");
          symbolFor("react.server.block");
          symbolFor("react.fundamental");
          symbolFor("react.scope");
          symbolFor("react.opaque.id");
          symbolFor("react.debug_trace_mode");
          symbolFor("react.offscreen");
          symbolFor("react.legacy_hidden");
        }
        var FunctionComponent = 0;
        var ClassComponent = 1;
        var HostRoot = 3;
        var HostComponent = 5;
        var HostText = 6;
        var NoFlags = (
          /*                      */
          0
        );
        var Placement = (
          /*                    */
          2
        );
        var Hydrating = (
          /*                    */
          1024
        );
        ReactSharedInternals.ReactCurrentOwner;
        function getNearestMountedFiber(fiber) {
          var node2 = fiber;
          var nearestMounted = fiber;
          if (!fiber.alternate) {
            var nextNode = node2;
            do {
              node2 = nextNode;
              if ((node2.flags & (Placement | Hydrating)) !== NoFlags) {
                nearestMounted = node2.return;
              }
              nextNode = node2.return;
            } while (nextNode);
          } else {
            while (node2.return) {
              node2 = node2.return;
            }
          }
          if (node2.tag === HostRoot) {
            return nearestMounted;
          }
          return null;
        }
        function assertIsMounted(fiber) {
          if (!(getNearestMountedFiber(fiber) === fiber)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
        }
        function findCurrentFiberUsingSlowPath(fiber) {
          var alternate = fiber.alternate;
          if (!alternate) {
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) {
              {
                throw Error("Unable to find node on an unmounted component.");
              }
            }
            if (nearestMounted !== fiber) {
              return null;
            }
            return fiber;
          }
          var a4 = fiber;
          var b10 = alternate;
          while (true) {
            var parentA = a4.return;
            if (parentA === null) {
              break;
            }
            var parentB = parentA.alternate;
            if (parentB === null) {
              var nextParent = parentA.return;
              if (nextParent !== null) {
                a4 = b10 = nextParent;
                continue;
              }
              break;
            }
            if (parentA.child === parentB.child) {
              var child = parentA.child;
              while (child) {
                if (child === a4) {
                  assertIsMounted(parentA);
                  return fiber;
                }
                if (child === b10) {
                  assertIsMounted(parentA);
                  return alternate;
                }
                child = child.sibling;
              }
              {
                {
                  throw Error("Unable to find node on an unmounted component.");
                }
              }
            }
            if (a4.return !== b10.return) {
              a4 = parentA;
              b10 = parentB;
            } else {
              var didFindChild = false;
              var _child = parentA.child;
              while (_child) {
                if (_child === a4) {
                  didFindChild = true;
                  a4 = parentA;
                  b10 = parentB;
                  break;
                }
                if (_child === b10) {
                  didFindChild = true;
                  b10 = parentA;
                  a4 = parentB;
                  break;
                }
                _child = _child.sibling;
              }
              if (!didFindChild) {
                _child = parentB.child;
                while (_child) {
                  if (_child === a4) {
                    didFindChild = true;
                    a4 = parentB;
                    b10 = parentA;
                    break;
                  }
                  if (_child === b10) {
                    didFindChild = true;
                    b10 = parentB;
                    a4 = parentA;
                    break;
                  }
                  _child = _child.sibling;
                }
                if (!didFindChild) {
                  {
                    throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                  }
                }
              }
            }
            if (!(a4.alternate === b10)) {
              {
                throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
          if (!(a4.tag === HostRoot)) {
            {
              throw Error("Unable to find node on an unmounted component.");
            }
          }
          if (a4.stateNode.current === a4) {
            return fiber;
          }
          return alternate;
        }
        function getEventCharCode(nativeEvent) {
          var charCode;
          var keyCode = nativeEvent.keyCode;
          if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode;
            if (charCode === 0 && keyCode === 13) {
              charCode = 13;
            }
          } else {
            charCode = keyCode;
          }
          if (charCode === 10) {
            charCode = 13;
          }
          if (charCode >= 32 || charCode === 13) {
            return charCode;
          }
          return 0;
        }
        function functionThatReturnsTrue() {
          return true;
        }
        function functionThatReturnsFalse() {
          return false;
        }
        function createSyntheticEvent(Interface) {
          function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for (var _propName in Interface) {
              if (!Interface.hasOwnProperty(_propName)) {
                continue;
              }
              var normalize2 = Interface[_propName];
              if (normalize2) {
                this[_propName] = normalize2(nativeEvent);
              } else {
                this[_propName] = nativeEvent[_propName];
              }
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) {
              this.isDefaultPrevented = functionThatReturnsTrue;
            } else {
              this.isDefaultPrevented = functionThatReturnsFalse;
            }
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
          }
          _assign2(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
              this.defaultPrevented = true;
              var event2 = this.nativeEvent;
              if (!event2) {
                return;
              }
              if (event2.preventDefault) {
                event2.preventDefault();
              } else if (typeof event2.returnValue !== "unknown") {
                event2.returnValue = false;
              }
              this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
              var event2 = this.nativeEvent;
              if (!event2) {
                return;
              }
              if (event2.stopPropagation) {
                event2.stopPropagation();
              } else if (typeof event2.cancelBubble !== "unknown") {
                event2.cancelBubble = true;
              }
              this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
             * We release all dispatched `SyntheticEvent`s after each event loop, adding
             * them back into the pool. This allows a way to hold onto a reference that
             * won't be added back into the pool.
             */
            persist: function() {
            },
            /**
             * Checks if this event should be released back into the pool.
             *
             * @return {boolean} True if this should not be released, false otherwise.
             */
            isPersistent: functionThatReturnsTrue
          });
          return SyntheticBaseEvent;
        }
        var EventInterface = {
          eventPhase: 0,
          bubbles: 0,
          cancelable: 0,
          timeStamp: function(event2) {
            return event2.timeStamp || Date.now();
          },
          defaultPrevented: 0,
          isTrusted: 0
        };
        var SyntheticEvent = createSyntheticEvent(EventInterface);
        var UIEventInterface = _assign2({}, EventInterface, {
          view: 0,
          detail: 0
        });
        createSyntheticEvent(UIEventInterface);
        var lastMovementX;
        var lastMovementY;
        var lastMouseEvent;
        function updateMouseMovementPolyfillState(event2) {
          if (event2 !== lastMouseEvent) {
            if (lastMouseEvent && event2.type === "mousemove") {
              lastMovementX = event2.screenX - lastMouseEvent.screenX;
              lastMovementY = event2.screenY - lastMouseEvent.screenY;
            } else {
              lastMovementX = 0;
              lastMovementY = 0;
            }
            lastMouseEvent = event2;
          }
        }
        var MouseEventInterface = _assign2({}, UIEventInterface, {
          screenX: 0,
          screenY: 0,
          clientX: 0,
          clientY: 0,
          pageX: 0,
          pageY: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          getModifierState: getEventModifierState,
          button: 0,
          buttons: 0,
          relatedTarget: function(event2) {
            if (event2.relatedTarget === void 0)
              return event2.fromElement === event2.srcElement ? event2.toElement : event2.fromElement;
            return event2.relatedTarget;
          },
          movementX: function(event2) {
            if ("movementX" in event2) {
              return event2.movementX;
            }
            updateMouseMovementPolyfillState(event2);
            return lastMovementX;
          },
          movementY: function(event2) {
            if ("movementY" in event2) {
              return event2.movementY;
            }
            return lastMovementY;
          }
        });
        createSyntheticEvent(MouseEventInterface);
        var DragEventInterface = _assign2({}, MouseEventInterface, {
          dataTransfer: 0
        });
        createSyntheticEvent(DragEventInterface);
        var FocusEventInterface = _assign2({}, UIEventInterface, {
          relatedTarget: 0
        });
        createSyntheticEvent(FocusEventInterface);
        var AnimationEventInterface = _assign2({}, EventInterface, {
          animationName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        });
        createSyntheticEvent(AnimationEventInterface);
        var ClipboardEventInterface = _assign2({}, EventInterface, {
          clipboardData: function(event2) {
            return "clipboardData" in event2 ? event2.clipboardData : window.clipboardData;
          }
        });
        createSyntheticEvent(ClipboardEventInterface);
        var CompositionEventInterface = _assign2({}, EventInterface, {
          data: 0
        });
        createSyntheticEvent(CompositionEventInterface);
        var normalizeKey = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified"
        };
        var translateToKey = {
          "8": "Backspace",
          "9": "Tab",
          "12": "Clear",
          "13": "Enter",
          "16": "Shift",
          "17": "Control",
          "18": "Alt",
          "19": "Pause",
          "20": "CapsLock",
          "27": "Escape",
          "32": " ",
          "33": "PageUp",
          "34": "PageDown",
          "35": "End",
          "36": "Home",
          "37": "ArrowLeft",
          "38": "ArrowUp",
          "39": "ArrowRight",
          "40": "ArrowDown",
          "45": "Insert",
          "46": "Delete",
          "112": "F1",
          "113": "F2",
          "114": "F3",
          "115": "F4",
          "116": "F5",
          "117": "F6",
          "118": "F7",
          "119": "F8",
          "120": "F9",
          "121": "F10",
          "122": "F11",
          "123": "F12",
          "144": "NumLock",
          "145": "ScrollLock",
          "224": "Meta"
        };
        function getEventKey2(nativeEvent) {
          if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") {
              return key;
            }
          }
          if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent);
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
          }
          if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") {
            return translateToKey[nativeEvent.keyCode] || "Unidentified";
          }
          return "";
        }
        var modifierKeyToProp = {
          Alt: "altKey",
          Control: "ctrlKey",
          Meta: "metaKey",
          Shift: "shiftKey"
        };
        function modifierStateGetter(keyArg) {
          var syntheticEvent = this;
          var nativeEvent = syntheticEvent.nativeEvent;
          if (nativeEvent.getModifierState) {
            return nativeEvent.getModifierState(keyArg);
          }
          var keyProp = modifierKeyToProp[keyArg];
          return keyProp ? !!nativeEvent[keyProp] : false;
        }
        function getEventModifierState(nativeEvent) {
          return modifierStateGetter;
        }
        var KeyboardEventInterface = _assign2({}, UIEventInterface, {
          key: getEventKey2,
          code: 0,
          location: 0,
          ctrlKey: 0,
          shiftKey: 0,
          altKey: 0,
          metaKey: 0,
          repeat: 0,
          locale: 0,
          getModifierState: getEventModifierState,
          // Legacy Interface
          charCode: function(event2) {
            if (event2.type === "keypress") {
              return getEventCharCode(event2);
            }
            return 0;
          },
          keyCode: function(event2) {
            if (event2.type === "keydown" || event2.type === "keyup") {
              return event2.keyCode;
            }
            return 0;
          },
          which: function(event2) {
            if (event2.type === "keypress") {
              return getEventCharCode(event2);
            }
            if (event2.type === "keydown" || event2.type === "keyup") {
              return event2.keyCode;
            }
            return 0;
          }
        });
        createSyntheticEvent(KeyboardEventInterface);
        var PointerEventInterface = _assign2({}, MouseEventInterface, {
          pointerId: 0,
          width: 0,
          height: 0,
          pressure: 0,
          tangentialPressure: 0,
          tiltX: 0,
          tiltY: 0,
          twist: 0,
          pointerType: 0,
          isPrimary: 0
        });
        createSyntheticEvent(PointerEventInterface);
        var TouchEventInterface = _assign2({}, UIEventInterface, {
          touches: 0,
          targetTouches: 0,
          changedTouches: 0,
          altKey: 0,
          metaKey: 0,
          ctrlKey: 0,
          shiftKey: 0,
          getModifierState: getEventModifierState
        });
        createSyntheticEvent(TouchEventInterface);
        var TransitionEventInterface = _assign2({}, EventInterface, {
          propertyName: 0,
          elapsedTime: 0,
          pseudoElement: 0
        });
        createSyntheticEvent(TransitionEventInterface);
        var WheelEventInterface = _assign2({}, MouseEventInterface, {
          deltaX: function(event2) {
            return "deltaX" in event2 ? event2.deltaX : (
              // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
              "wheelDeltaX" in event2 ? -event2.wheelDeltaX : 0
            );
          },
          deltaY: function(event2) {
            return "deltaY" in event2 ? event2.deltaY : (
              // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
              "wheelDeltaY" in event2 ? -event2.wheelDeltaY : (
                // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
                "wheelDelta" in event2 ? -event2.wheelDelta : 0
              )
            );
          },
          deltaZ: 0,
          // Browsers without "deltaMode" is reporting in raw wheel delta where one
          // notch on the scroll is always +/- 120, roughly equivalent to pixels.
          // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
          // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
          deltaMode: 0
        });
        createSyntheticEvent(WheelEventInterface);
        var ELEMENT_NODE2 = 1;
        var didWarnAboutMessageChannel = false;
        var enqueueTaskImpl = null;
        function enqueueTask(task) {
          if (enqueueTaskImpl === null) {
            try {
              var requireString = ("require" + Math.random()).slice(0, 7);
              var nodeRequire = module2 && module2[requireString];
              enqueueTaskImpl = nodeRequire.call(module2, "timers").setImmediate;
            } catch (_err) {
              enqueueTaskImpl = function(callback) {
                {
                  if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") {
                      error2("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                    }
                  }
                }
                var channel2 = new MessageChannel();
                channel2.port1.onmessage = callback;
                channel2.port2.postMessage(void 0);
              };
            }
          }
          return enqueueTaskImpl(task);
        }
        var EventInternals = ReactDOM2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events;
        var flushPassiveEffects = EventInternals[5];
        var IsThisRendererActing = EventInternals[6];
        var batchedUpdates = ReactDOM2.unstable_batchedUpdates;
        var IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
        var isSchedulerMocked = typeof Scheduler2.unstable_flushAllWithoutAsserting === "function";
        var flushWork = Scheduler2.unstable_flushAllWithoutAsserting || function() {
          var didFlushWork = false;
          while (flushPassiveEffects()) {
            didFlushWork = true;
          }
          return didFlushWork;
        };
        function flushWorkAndMicroTasks(onDone) {
          try {
            flushWork();
            enqueueTask(function() {
              if (flushWork()) {
                flushWorkAndMicroTasks(onDone);
              } else {
                onDone();
              }
            });
          } catch (err) {
            onDone(err);
          }
        }
        var actingUpdatesScopeDepth = 0;
        function act2(callback) {
          var previousActingUpdatesScopeDepth = actingUpdatesScopeDepth;
          actingUpdatesScopeDepth++;
          var previousIsSomeRendererActing = IsSomeRendererActing.current;
          var previousIsThisRendererActing = IsThisRendererActing.current;
          IsSomeRendererActing.current = true;
          IsThisRendererActing.current = true;
          function onDone() {
            actingUpdatesScopeDepth--;
            IsSomeRendererActing.current = previousIsSomeRendererActing;
            IsThisRendererActing.current = previousIsThisRendererActing;
            {
              if (actingUpdatesScopeDepth > previousActingUpdatesScopeDepth) {
                error2("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
              }
            }
          }
          var result;
          try {
            result = batchedUpdates(callback);
          } catch (error3) {
            onDone();
            throw error3;
          }
          if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var called = false;
            {
              if (typeof Promise !== "undefined") {
                Promise.resolve().then(function() {
                }).then(function() {
                  if (called === false) {
                    error2("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                  }
                });
              }
            }
            return {
              then: function(resolve, reject) {
                called = true;
                result.then(function() {
                  if (actingUpdatesScopeDepth > 1 || isSchedulerMocked === true && previousIsSomeRendererActing === true) {
                    onDone();
                    resolve();
                    return;
                  }
                  flushWorkAndMicroTasks(function(err) {
                    onDone();
                    if (err) {
                      reject(err);
                    } else {
                      resolve();
                    }
                  });
                }, function(err) {
                  onDone();
                  reject(err);
                });
              }
            };
          } else {
            {
              if (result !== void 0) {
                error2("The callback passed to act(...) function must return undefined, or a Promise. You returned %s", result);
              }
            }
            try {
              if (actingUpdatesScopeDepth === 1 && (isSchedulerMocked === false || previousIsSomeRendererActing === false)) {
                flushWork();
              }
              onDone();
            } catch (err) {
              onDone();
              throw err;
            }
            return {
              then: function(resolve) {
                {
                  error2("Do not await the result of calling act(...) with sync logic, it is not a Promise.");
                }
                resolve();
              }
            };
          }
        }
        var EventInternals$1 = ReactDOM2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events;
        var IsThisRendererActing$1 = EventInternals$1[6];
        var batchedUpdates$1 = ReactDOM2.unstable_batchedUpdates;
        var IsSomeRendererActing$1 = ReactSharedInternals.IsSomeRendererActing;
        var actingUpdatesScopeDepth$1 = 0;
        function unstable_concurrentAct(scope) {
          if (Scheduler2.unstable_flushAllWithoutAsserting === void 0) {
            throw Error("This version of `act` requires a special mock build of Scheduler.");
          }
          if (setTimeout._isMockFunction !== true) {
            throw Error("This version of `act` requires Jest's timer mocks (i.e. jest.useFakeTimers).");
          }
          var previousActingUpdatesScopeDepth = actingUpdatesScopeDepth$1;
          var previousIsSomeRendererActing = IsSomeRendererActing$1.current;
          var previousIsThisRendererActing = IsThisRendererActing$1.current;
          IsSomeRendererActing$1.current = true;
          IsThisRendererActing$1.current = true;
          actingUpdatesScopeDepth$1++;
          var unwind = function() {
            actingUpdatesScopeDepth$1--;
            IsSomeRendererActing$1.current = previousIsSomeRendererActing;
            IsThisRendererActing$1.current = previousIsThisRendererActing;
            {
              if (actingUpdatesScopeDepth$1 > previousActingUpdatesScopeDepth) {
                error2("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
              }
            }
          };
          try {
            var thenable = batchedUpdates$1(scope);
            if (typeof thenable === "object" && thenable !== null && typeof thenable.then === "function") {
              return {
                then: function(resolve, reject) {
                  thenable.then(function() {
                    flushActWork(function() {
                      unwind();
                      resolve();
                    }, function(error3) {
                      unwind();
                      reject(error3);
                    });
                  }, function(error3) {
                    unwind();
                    reject(error3);
                  });
                }
              };
            } else {
              try {
                var didFlushWork;
                do {
                  didFlushWork = Scheduler2.unstable_flushAllWithoutAsserting();
                } while (didFlushWork);
              } finally {
                unwind();
              }
            }
          } catch (error3) {
            unwind();
            throw error3;
          }
        }
        function flushActWork(resolve, reject) {
          jest.runOnlyPendingTimers();
          enqueueTask(function() {
            try {
              var didFlushWork = Scheduler2.unstable_flushAllWithoutAsserting();
              if (didFlushWork) {
                flushActWork(resolve, reject);
              } else {
                resolve();
              }
            } catch (error3) {
              reject(error3);
            }
          });
        }
        function invokeGuardedCallbackProd(name2, func, context, a4, b10, c7, d3, e3, f) {
          var funcArgs = Array.prototype.slice.call(arguments, 3);
          try {
            func.apply(context, funcArgs);
          } catch (error3) {
            this.onError(error3);
          }
        }
        var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
        {
          if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
            var fakeNode = document.createElement("react");
            invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name2, func, context, a4, b10, c7, d3, e3, f) {
              if (!(typeof document !== "undefined")) {
                {
                  throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
                }
              }
              var evt = document.createEvent("Event");
              var didCall = false;
              var didError = true;
              var windowEvent = window.event;
              var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
              function restoreAfterDispatch() {
                fakeNode.removeEventListener(evtType, callCallback, false);
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) {
                  window.event = windowEvent;
                }
              }
              var funcArgs = Array.prototype.slice.call(arguments, 3);
              function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
              }
              var error3;
              var didSetError = false;
              var isCrossOriginError = false;
              function handleWindowError(event2) {
                error3 = event2.error;
                didSetError = true;
                if (error3 === null && event2.colno === 0 && event2.lineno === 0) {
                  isCrossOriginError = true;
                }
                if (event2.defaultPrevented) {
                  if (error3 != null && typeof error3 === "object") {
                    try {
                      error3._suppressLogging = true;
                    } catch (inner) {
                    }
                  }
                }
              }
              var evtType = "react-" + (name2 ? name2 : "invokeguardedcallback");
              window.addEventListener("error", handleWindowError);
              fakeNode.addEventListener(evtType, callCallback, false);
              evt.initEvent(evtType, false, false);
              fakeNode.dispatchEvent(evt);
              if (windowEventDescriptor) {
                Object.defineProperty(window, "event", windowEventDescriptor);
              }
              if (didCall && didError) {
                if (!didSetError) {
                  error3 = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`);
                } else if (isCrossOriginError) {
                  error3 = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                }
                this.onError(error3);
              }
              window.removeEventListener("error", handleWindowError);
              if (!didCall) {
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
              }
            };
          }
        }
        var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
        var hasError = false;
        var caughtError = null;
        var hasRethrowError = false;
        var rethrowError = null;
        var reporter = {
          onError: function(error3) {
            hasError = true;
            caughtError = error3;
          }
        };
        function invokeGuardedCallback(name2, func, context, a4, b10, c7, d3, e3, f) {
          hasError = false;
          caughtError = null;
          invokeGuardedCallbackImpl$1.apply(reporter, arguments);
        }
        function invokeGuardedCallbackAndCatchFirstError(name2, func, context, a4, b10, c7, d3, e3, f) {
          invokeGuardedCallback.apply(this, arguments);
          if (hasError) {
            var error3 = clearCaughtError();
            if (!hasRethrowError) {
              hasRethrowError = true;
              rethrowError = error3;
            }
          }
        }
        function rethrowCaughtError() {
          if (hasRethrowError) {
            var error3 = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error3;
          }
        }
        function clearCaughtError() {
          if (hasError) {
            var error3 = caughtError;
            hasError = false;
            caughtError = null;
            return error3;
          } else {
            {
              {
                throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
              }
            }
          }
        }
        var EventInternals$2 = ReactDOM2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events;
        var getInstanceFromNode = EventInternals$2[0];
        var getNodeFromInstance = EventInternals$2[1];
        var getFiberCurrentPropsFromNode = EventInternals$2[2];
        var enqueueStateRestore = EventInternals$2[3];
        var restoreStateIfNeeded = EventInternals$2[4];
        function Event(suffix) {
        }
        var hasWarnedAboutDeprecatedMockComponent = false;
        function findAllInRenderedFiberTreeInternal(fiber, test2) {
          if (!fiber) {
            return [];
          }
          var currentParent = findCurrentFiberUsingSlowPath(fiber);
          if (!currentParent) {
            return [];
          }
          var node2 = currentParent;
          var ret = [];
          while (true) {
            if (node2.tag === HostComponent || node2.tag === HostText || node2.tag === ClassComponent || node2.tag === FunctionComponent) {
              var publicInst = node2.stateNode;
              if (test2(publicInst)) {
                ret.push(publicInst);
              }
            }
            if (node2.child) {
              node2.child.return = node2;
              node2 = node2.child;
              continue;
            }
            if (node2 === currentParent) {
              return ret;
            }
            while (!node2.sibling) {
              if (!node2.return || node2.return === currentParent) {
                return ret;
              }
              node2 = node2.return;
            }
            node2.sibling.return = node2.return;
            node2 = node2.sibling;
          }
        }
        function validateClassInstance(inst, methodName) {
          if (!inst) {
            return;
          }
          if (get9(inst)) {
            return;
          }
          var received;
          var stringified = "" + inst;
          if (Array.isArray(inst)) {
            received = "an array";
          } else if (inst && inst.nodeType === ELEMENT_NODE2 && inst.tagName) {
            received = "a DOM node";
          } else if (stringified === "[object Object]") {
            received = "object with keys {" + Object.keys(inst).join(", ") + "}";
          } else {
            received = stringified;
          }
          {
            {
              throw Error(methodName + "(...): the first argument must be a React class instance. Instead received: " + received + ".");
            }
          }
        }
        function renderIntoDocument(element) {
          var div = document.createElement("div");
          return ReactDOM2.render(element, div);
        }
        function isElement2(element) {
          return React2.isValidElement(element);
        }
        function isElementOfType(inst, convenienceConstructor) {
          return React2.isValidElement(inst) && inst.type === convenienceConstructor;
        }
        function isDOMComponent(inst) {
          return !!(inst && inst.nodeType === ELEMENT_NODE2 && inst.tagName);
        }
        function isDOMComponentElement(inst) {
          return !!(inst && React2.isValidElement(inst) && !!inst.tagName);
        }
        function isCompositeComponent(inst) {
          if (isDOMComponent(inst)) {
            return false;
          }
          return inst != null && typeof inst.render === "function" && typeof inst.setState === "function";
        }
        function isCompositeComponentWithType(inst, type2) {
          if (!isCompositeComponent(inst)) {
            return false;
          }
          var internalInstance = get9(inst);
          var constructor = internalInstance.type;
          return constructor === type2;
        }
        function findAllInRenderedTree(inst, test2) {
          validateClassInstance(inst, "findAllInRenderedTree");
          if (!inst) {
            return [];
          }
          var internalInstance = get9(inst);
          return findAllInRenderedFiberTreeInternal(internalInstance, test2);
        }
        function scryRenderedDOMComponentsWithClass(root2, classNames2) {
          validateClassInstance(root2, "scryRenderedDOMComponentsWithClass");
          return findAllInRenderedTree(root2, function(inst) {
            if (isDOMComponent(inst)) {
              var className = inst.className;
              if (typeof className !== "string") {
                className = inst.getAttribute("class") || "";
              }
              var classList = className.split(/\s+/);
              if (!Array.isArray(classNames2)) {
                if (!(classNames2 !== void 0)) {
                  {
                    throw Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
                  }
                }
                classNames2 = classNames2.split(/\s+/);
              }
              return classNames2.every(function(name2) {
                return classList.indexOf(name2) !== -1;
              });
            }
            return false;
          });
        }
        function findRenderedDOMComponentWithClass(root2, className) {
          validateClassInstance(root2, "findRenderedDOMComponentWithClass");
          var all2 = scryRenderedDOMComponentsWithClass(root2, className);
          if (all2.length !== 1) {
            throw new Error("Did not find exactly one match (found: " + all2.length + ") for class:" + className);
          }
          return all2[0];
        }
        function scryRenderedDOMComponentsWithTag(root2, tagName) {
          validateClassInstance(root2, "scryRenderedDOMComponentsWithTag");
          return findAllInRenderedTree(root2, function(inst) {
            return isDOMComponent(inst) && inst.tagName.toUpperCase() === tagName.toUpperCase();
          });
        }
        function findRenderedDOMComponentWithTag(root2, tagName) {
          validateClassInstance(root2, "findRenderedDOMComponentWithTag");
          var all2 = scryRenderedDOMComponentsWithTag(root2, tagName);
          if (all2.length !== 1) {
            throw new Error("Did not find exactly one match (found: " + all2.length + ") for tag:" + tagName);
          }
          return all2[0];
        }
        function scryRenderedComponentsWithType(root2, componentType) {
          validateClassInstance(root2, "scryRenderedComponentsWithType");
          return findAllInRenderedTree(root2, function(inst) {
            return isCompositeComponentWithType(inst, componentType);
          });
        }
        function findRenderedComponentWithType(root2, componentType) {
          validateClassInstance(root2, "findRenderedComponentWithType");
          var all2 = scryRenderedComponentsWithType(root2, componentType);
          if (all2.length !== 1) {
            throw new Error("Did not find exactly one match (found: " + all2.length + ") for componentType:" + componentType);
          }
          return all2[0];
        }
        function mockComponent(module3, mockTagName) {
          {
            if (!hasWarnedAboutDeprecatedMockComponent) {
              hasWarnedAboutDeprecatedMockComponent = true;
              warn2("ReactTestUtils.mockComponent() is deprecated. Use shallow rendering or jest.mock() instead.\n\nSee https://reactjs.org/link/test-utils-mock-component for more information.");
            }
          }
          mockTagName = mockTagName || module3.mockTagName || "div";
          module3.prototype.render.mockImplementation(function() {
            return React2.createElement(mockTagName, null, this.props.children);
          });
          return this;
        }
        function nativeTouchData(x3, y4) {
          return {
            touches: [{
              pageX: x3,
              pageY: y4
            }]
          };
        }
        function executeDispatch(event2, listener, inst) {
          var type2 = event2.type || "unknown-event";
          event2.currentTarget = getNodeFromInstance(inst);
          invokeGuardedCallbackAndCatchFirstError(type2, listener, void 0, event2);
          event2.currentTarget = null;
        }
        function executeDispatchesInOrder(event2) {
          var dispatchListeners = event2._dispatchListeners;
          var dispatchInstances = event2._dispatchInstances;
          if (Array.isArray(dispatchListeners)) {
            for (var i2 = 0; i2 < dispatchListeners.length; i2++) {
              if (event2.isPropagationStopped()) {
                break;
              }
              executeDispatch(event2, dispatchListeners[i2], dispatchInstances[i2]);
            }
          } else if (dispatchListeners) {
            executeDispatch(event2, dispatchListeners, dispatchInstances);
          }
          event2._dispatchListeners = null;
          event2._dispatchInstances = null;
        }
        var executeDispatchesAndRelease = function(event2) {
          if (event2) {
            executeDispatchesInOrder(event2);
            if (!event2.isPersistent()) {
              event2.constructor.release(event2);
            }
          }
        };
        function isInteractive(tag2) {
          return tag2 === "button" || tag2 === "input" || tag2 === "select" || tag2 === "textarea";
        }
        function getParent(inst) {
          do {
            inst = inst.return;
          } while (inst && inst.tag !== HostComponent);
          if (inst) {
            return inst;
          }
          return null;
        }
        function traverseTwoPhase(inst, fn2, arg) {
          var path2 = [];
          while (inst) {
            path2.push(inst);
            inst = getParent(inst);
          }
          var i2;
          for (i2 = path2.length; i2-- > 0; ) {
            fn2(path2[i2], "captured", arg);
          }
          for (i2 = 0; i2 < path2.length; i2++) {
            fn2(path2[i2], "bubbled", arg);
          }
        }
        function shouldPreventMouseEvent(name2, type2, props2) {
          switch (name2) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              return !!(props2.disabled && isInteractive(type2));
            default:
              return false;
          }
        }
        function getListener(inst, registrationName) {
          var stateNode = inst.stateNode;
          if (!stateNode) {
            return null;
          }
          var props2 = getFiberCurrentPropsFromNode(stateNode);
          if (!props2) {
            return null;
          }
          var listener = props2[registrationName];
          if (shouldPreventMouseEvent(registrationName, inst.type, props2)) {
            return null;
          }
          if (!(!listener || typeof listener === "function")) {
            {
              throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
            }
          }
          return listener;
        }
        function listenerAtPhase(inst, event2, propagationPhase) {
          var registrationName = event2._reactName;
          if (propagationPhase === "captured") {
            registrationName += "Capture";
          }
          return getListener(inst, registrationName);
        }
        function accumulateDispatches(inst, ignoredDirection, event2) {
          if (inst && event2 && event2._reactName) {
            var registrationName = event2._reactName;
            var listener = getListener(inst, registrationName);
            if (listener) {
              if (event2._dispatchListeners == null) {
                event2._dispatchListeners = [];
              }
              if (event2._dispatchInstances == null) {
                event2._dispatchInstances = [];
              }
              event2._dispatchListeners.push(listener);
              event2._dispatchInstances.push(inst);
            }
          }
        }
        function accumulateDirectionalDispatches(inst, phase, event2) {
          {
            if (!inst) {
              error2("Dispatching inst must not be null");
            }
          }
          var listener = listenerAtPhase(inst, event2, phase);
          if (listener) {
            if (event2._dispatchListeners == null) {
              event2._dispatchListeners = [];
            }
            if (event2._dispatchInstances == null) {
              event2._dispatchInstances = [];
            }
            event2._dispatchListeners.push(listener);
            event2._dispatchInstances.push(inst);
          }
        }
        function accumulateDirectDispatchesSingle(event2) {
          if (event2 && event2._reactName) {
            accumulateDispatches(event2._targetInst, null, event2);
          }
        }
        function accumulateTwoPhaseDispatchesSingle(event2) {
          if (event2 && event2._reactName) {
            traverseTwoPhase(event2._targetInst, accumulateDirectionalDispatches, event2);
          }
        }
        var Simulate = {};
        var directDispatchEventTypes = /* @__PURE__ */ new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
        function makeSimulator(eventType) {
          return function(domNode, eventData) {
            if (!!React2.isValidElement(domNode)) {
              {
                throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
              }
            }
            if (!!isCompositeComponent(domNode)) {
              {
                throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
              }
            }
            var reactName = "on" + eventType[0].toUpperCase() + eventType.slice(1);
            var fakeNativeEvent = new Event();
            fakeNativeEvent.target = domNode;
            fakeNativeEvent.type = eventType.toLowerCase();
            var targetInst = getInstanceFromNode(domNode);
            var event2 = new SyntheticEvent(reactName, fakeNativeEvent.type, targetInst, fakeNativeEvent, domNode);
            event2.persist();
            _assign2(event2, eventData);
            if (directDispatchEventTypes.has(eventType)) {
              accumulateDirectDispatchesSingle(event2);
            } else {
              accumulateTwoPhaseDispatchesSingle(event2);
            }
            ReactDOM2.unstable_batchedUpdates(function() {
              enqueueStateRestore(domNode);
              executeDispatchesAndRelease(event2);
              rethrowCaughtError();
            });
            restoreStateIfNeeded();
          };
        }
        var simulatedEventTypes = ["blur", "cancel", "click", "close", "contextMenu", "copy", "cut", "auxClick", "doubleClick", "dragEnd", "dragStart", "drop", "focus", "input", "invalid", "keyDown", "keyPress", "keyUp", "mouseDown", "mouseUp", "paste", "pause", "play", "pointerCancel", "pointerDown", "pointerUp", "rateChange", "reset", "seeked", "submit", "touchCancel", "touchEnd", "touchStart", "volumeChange", "drag", "dragEnter", "dragExit", "dragLeave", "dragOver", "mouseMove", "mouseOut", "mouseOver", "pointerMove", "pointerOut", "pointerOver", "scroll", "toggle", "touchMove", "wheel", "abort", "animationEnd", "animationIteration", "animationStart", "canPlay", "canPlayThrough", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "playing", "progress", "seeking", "stalled", "suspend", "timeUpdate", "transitionEnd", "waiting", "mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave", "change", "select", "beforeInput", "compositionEnd", "compositionStart", "compositionUpdate"];
        function buildSimulators() {
          simulatedEventTypes.forEach(function(eventType) {
            Simulate[eventType] = makeSimulator(eventType);
          });
        }
        buildSimulators();
        exports2.Simulate = Simulate;
        exports2.act = act2;
        exports2.findAllInRenderedTree = findAllInRenderedTree;
        exports2.findRenderedComponentWithType = findRenderedComponentWithType;
        exports2.findRenderedDOMComponentWithClass = findRenderedDOMComponentWithClass;
        exports2.findRenderedDOMComponentWithTag = findRenderedDOMComponentWithTag;
        exports2.isCompositeComponent = isCompositeComponent;
        exports2.isCompositeComponentWithType = isCompositeComponentWithType;
        exports2.isDOMComponent = isDOMComponent;
        exports2.isDOMComponentElement = isDOMComponentElement;
        exports2.isElement = isElement2;
        exports2.isElementOfType = isElementOfType;
        exports2.mockComponent = mockComponent;
        exports2.nativeTouchData = nativeTouchData;
        exports2.renderIntoDocument = renderIntoDocument;
        exports2.scryRenderedComponentsWithType = scryRenderedComponentsWithType;
        exports2.scryRenderedDOMComponentsWithClass = scryRenderedDOMComponentsWithClass;
        exports2.scryRenderedDOMComponentsWithTag = scryRenderedDOMComponentsWithTag;
        exports2.traverseTwoPhase = traverseTwoPhase;
        exports2.unstable_concurrentAct = unstable_concurrentAct;
      })();
    }
  })(reactDomTestUtils_development, reactDomTestUtils_development.exports);
  return reactDomTestUtils_development.exports;
}
if (process.env.NODE_ENV === "production") {
  testUtils.exports = requireReactDomTestUtils_production_min();
} else {
  testUtils.exports = requireReactDomTestUtils_development();
}
var testUtilsExports = testUtils.exports;
var reactAct = testUtilsExports.act;
var actSupported = reactAct !== void 0;
function actPolyfill(cb) {
  ReactDOM__default.unstable_batchedUpdates(cb);
  ReactDOM__default.render(/* @__PURE__ */ React.createElement("div", null), document.createElement("div"));
}
var act = reactAct || actPolyfill;
var youHaveBeenWarned = false;
var isAsyncActSupported = null;
function asyncAct(cb) {
  if (actSupported === true) {
    if (isAsyncActSupported === null) {
      return new Promise(function(resolve, reject) {
        var originalConsoleError = console.error;
        console.error = function error2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var firstArgIsString = typeof args[0] === "string";
          if (firstArgIsString && args[0].indexOf("Warning: Do not await the result of calling ReactTestUtils.act") === 0) {
            isAsyncActSupported = false;
          } else if (firstArgIsString && args[0].indexOf("Warning: The callback passed to ReactTestUtils.act(...) function must not return anything") === 0)
            ;
          else {
            originalConsoleError.apply(console, args);
          }
        };
        var cbReturn, result2;
        try {
          result2 = reactAct(function() {
            cbReturn = cb();
            return cbReturn;
          });
        } catch (err) {
          console.error = originalConsoleError;
          reject(err);
          return;
        }
        result2.then(function() {
          console.error = originalConsoleError;
          isAsyncActSupported = true;
          resolve();
        }, function(err) {
          console.error = originalConsoleError;
          isAsyncActSupported = true;
          reject(err);
        });
        if (isAsyncActSupported === false) {
          console.error = originalConsoleError;
          if (!youHaveBeenWarned) {
            console.error(`It looks like you're using a version of react-dom that supports the "act" function, but not an awaitable version of "act" which you will need. Please upgrade to at least react-dom@16.9.0 to remove this warning.`);
            youHaveBeenWarned = true;
          }
          cbReturn.then(function() {
            Promise.resolve().then(function() {
              act(function() {
              });
              resolve();
            });
          }, reject);
        }
      });
    } else if (isAsyncActSupported === false) {
      var _result;
      act(function() {
        _result = cb();
      });
      return _result.then(function() {
        return Promise.resolve().then(function() {
          act(function() {
          });
        });
      });
    }
    return act(cb);
  }
  var result;
  act(function() {
    result = cb();
  });
  return result.then(function() {
    return Promise.resolve().then(function() {
      act(function() {
      });
    });
  });
}
Object.keys(fireEvent).forEach(function(key) {
});
configure({
  asyncWrapper: function() {
    var _asyncWrapper = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime.mark(function _callee2(cb) {
      var result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return asyncAct(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime.mark(function _callee() {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return cb();
                      case 2:
                        result = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })));
            case 2:
              return _context2.abrupt("return", result);
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    function asyncWrapper(_x) {
      return _asyncWrapper.apply(this, arguments);
    }
    return asyncWrapper;
  }(),
  eventWrapper: function eventWrapper(cb) {
    var result;
    act(function() {
      result = cb();
    });
    return result;
  }
});
var mountedContainers = /* @__PURE__ */ new Set();
function cleanup() {
  mountedContainers.forEach(cleanupAtContainer);
}
function cleanupAtContainer(container2) {
  act(function() {
    ReactDOM__default.unmountComponentAtNode(container2);
  });
  if (container2.parentNode === document.body) {
    document.body.removeChild(container2);
  }
  mountedContainers.delete(container2);
}
var _process$env;
if (typeof process === "undefined" || !((_process$env = process.env) != null && _process$env.RTL_SKIP_AUTO_CLEANUP)) {
  if (typeof afterEach === "function") {
    afterEach(function() {
      cleanup();
    });
  } else if (typeof teardown === "function") {
    teardown(function() {
      cleanup();
    });
  }
}
var clickableInputTypes;
(function(clickableInputTypes2) {
  clickableInputTypes2["button"] = "button";
  clickableInputTypes2["color"] = "color";
  clickableInputTypes2["file"] = "file";
  clickableInputTypes2["image"] = "image";
  clickableInputTypes2["reset"] = "reset";
  clickableInputTypes2["submit"] = "submit";
  clickableInputTypes2["checkbox"] = "checkbox";
  clickableInputTypes2["radio"] = "radio";
})(clickableInputTypes || (clickableInputTypes = {}));
const ClipboardStubControl = Symbol("Manage ClipboardSub");
function isClipboardStub(clipboard) {
  return !!(clipboard === null || clipboard === void 0 ? void 0 : clipboard[ClipboardStubControl]);
}
function resetClipboardStubOnView(window2) {
  if (isClipboardStub(window2.navigator.clipboard)) {
    window2.navigator.clipboard[ClipboardStubControl].resetClipboardStub();
  }
}
function detachClipboardStubFromView(window2) {
  if (isClipboardStub(window2.navigator.clipboard)) {
    window2.navigator.clipboard[ClipboardStubControl].detachClipboardStub();
  }
}
const g = globalThis;
if (typeof g.afterEach === "function") {
  g.afterEach(() => resetClipboardStubOnView(globalThis.window));
}
if (typeof g.afterAll === "function") {
  g.afterAll(() => detachClipboardStubFromView(globalThis.window));
}
var editableInputTypes;
(function(editableInputTypes2) {
  editableInputTypes2["text"] = "text";
  editableInputTypes2["date"] = "date";
  editableInputTypes2["datetime-local"] = "datetime-local";
  editableInputTypes2["email"] = "email";
  editableInputTypes2["month"] = "month";
  editableInputTypes2["number"] = "number";
  editableInputTypes2["password"] = "password";
  editableInputTypes2["search"] = "search";
  editableInputTypes2["tel"] = "tel";
  editableInputTypes2["time"] = "time";
  editableInputTypes2["url"] = "url";
  editableInputTypes2["week"] = "week";
})(editableInputTypes || (editableInputTypes = {}));
var maxLengthSupportedTypes;
(function(maxLengthSupportedTypes2) {
  maxLengthSupportedTypes2["email"] = "email";
  maxLengthSupportedTypes2["password"] = "password";
  maxLengthSupportedTypes2["search"] = "search";
  maxLengthSupportedTypes2["telephone"] = "telephone";
  maxLengthSupportedTypes2["text"] = "text";
  maxLengthSupportedTypes2["url"] = "url";
})(maxLengthSupportedTypes || (maxLengthSupportedTypes = {}));
var bracketDict;
(function(bracketDict2) {
  bracketDict2["{"] = "}";
  bracketDict2["["] = "]";
})(bracketDict || (bracketDict = {}));
var ApiLevel;
(function(ApiLevel2) {
  ApiLevel2[ApiLevel2["Trigger"] = 2] = "Trigger";
  ApiLevel2[ApiLevel2["Call"] = 1] = "Call";
})(ApiLevel || (ApiLevel = {}));
var PointerEventsCheckLevel;
(function(PointerEventsCheckLevel2) {
  PointerEventsCheckLevel2[PointerEventsCheckLevel2["EachTrigger"] = 4] = "EachTrigger";
  PointerEventsCheckLevel2[PointerEventsCheckLevel2["EachApiCall"] = 2] = "EachApiCall";
  PointerEventsCheckLevel2[PointerEventsCheckLevel2["EachTarget"] = 1] = "EachTarget";
  PointerEventsCheckLevel2[PointerEventsCheckLevel2["Never"] = 0] = "Never";
})(PointerEventsCheckLevel || (PointerEventsCheckLevel = {}));
function escapeHTML(str) {
  return str.replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
const printProps = (keys8, props2, config2, indentation, depth, refs, printer2) => {
  const indentationNext = indentation + config2.indent;
  const colors3 = config2.colors;
  return keys8.map((key) => {
    const value = props2[key];
    let printed = printer2(value, config2, indentationNext, depth, refs);
    if (typeof value !== "string") {
      if (printed.indexOf("\n") !== -1) {
        printed = config2.spacingOuter + indentationNext + printed + config2.spacingOuter + indentation;
      }
      printed = "{" + printed + "}";
    }
    return config2.spacingInner + indentation + colors3.prop.open + key + colors3.prop.close + "=" + colors3.value.open + printed + colors3.value.close;
  }).join("");
};
const NodeTypeTextNode = 3;
const printChildren = (children2, config2, indentation, depth, refs, printer2) => children2.map((child) => {
  const printedChild = typeof child === "string" ? printText(child, config2) : printer2(child, config2, indentation, depth, refs);
  if (printedChild === "" && typeof child === "object" && child !== null && child.nodeType !== NodeTypeTextNode) {
    return "";
  }
  return config2.spacingOuter + indentation + printedChild;
}).join("");
const printText = (text2, config2) => {
  const contentColor = config2.colors.content;
  return contentColor.open + escapeHTML(text2) + contentColor.close;
};
const printComment = (comment2, config2) => {
  const commentColor = config2.colors.comment;
  return commentColor.open + "<!--" + escapeHTML(comment2) + "-->" + commentColor.close;
};
const printElement = (type2, printedProps, printedChildren, config2, indentation) => {
  const tagColor = config2.colors.tag;
  return tagColor.open + "<" + type2 + (printedProps && tagColor.close + printedProps + config2.spacingOuter + indentation + tagColor.open) + (printedChildren ? ">" + tagColor.close + printedChildren + config2.spacingOuter + indentation + tagColor.open + "</" + type2 : (printedProps && !config2.min ? "" : " ") + "/") + ">" + tagColor.close;
};
const printElementAsLeaf = (type2, config2) => {
  const tagColor = config2.colors.tag;
  return tagColor.open + "<" + type2 + tagColor.close + " …" + tagColor.open + " />" + tagColor.close;
};
const ELEMENT_NODE$1 = 1;
const TEXT_NODE$1 = 3;
const COMMENT_NODE$1 = 8;
const FRAGMENT_NODE = 11;
const ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
const testNode = (val) => {
  const constructorName = val.constructor.name;
  const {
    nodeType,
    tagName
  } = val;
  const isCustomElement = typeof tagName === "string" && tagName.includes("-") || typeof val.hasAttribute === "function" && val.hasAttribute("is");
  return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === TEXT_NODE$1 && constructorName === "Text" || nodeType === COMMENT_NODE$1 && constructorName === "Comment" || nodeType === FRAGMENT_NODE && constructorName === "DocumentFragment";
};
function nodeIsText(node2) {
  return node2.nodeType === TEXT_NODE$1;
}
function nodeIsComment(node2) {
  return node2.nodeType === COMMENT_NODE$1;
}
function nodeIsFragment(node2) {
  return node2.nodeType === FRAGMENT_NODE;
}
function createDOMElementFilter(filterNode) {
  return {
    test: (val) => {
      var _val$constructor2;
      return (val == null || (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) && testNode(val);
    },
    serialize: (node2, config2, indentation, depth, refs, printer2) => {
      if (nodeIsText(node2)) {
        return printText(node2.data, config2);
      }
      if (nodeIsComment(node2)) {
        return printComment(node2.data, config2);
      }
      const type2 = nodeIsFragment(node2) ? "DocumentFragment" : node2.tagName.toLowerCase();
      if (++depth > config2.maxDepth) {
        return printElementAsLeaf(type2, config2);
      }
      return printElement(type2, printProps(nodeIsFragment(node2) ? [] : Array.from(node2.attributes).map((attr) => attr.name).sort(), nodeIsFragment(node2) ? {} : Array.from(node2.attributes).reduce((props2, attribute) => {
        props2[attribute.name] = attribute.value;
        return props2;
      }, {}), config2, indentation + config2.indent, depth, refs, printer2), printChildren(Array.prototype.slice.call(node2.childNodes || node2.children).filter(filterNode), config2, indentation + config2.indent, depth, refs, printer2), config2, indentation);
    }
  };
}
let chalk = null;
let readFileSync = null;
let codeFrameColumns = null;
try {
  const nodeRequire = module && module.require;
  readFileSync = nodeRequire.call(module, "fs").readFileSync;
  codeFrameColumns = nodeRequire.call(module, "@babel/code-frame").codeFrameColumns;
  chalk = nodeRequire.call(module, "chalk");
} catch {
}
function getCodeFrame(frame2) {
  const locationStart = frame2.indexOf("(") + 1;
  const locationEnd = frame2.indexOf(")");
  const frameLocation = frame2.slice(locationStart, locationEnd);
  const frameLocationElements = frameLocation.split(":");
  const [filename, line2, column2] = [frameLocationElements[0], parseInt(frameLocationElements[1], 10), parseInt(frameLocationElements[2], 10)];
  let rawFileContents = "";
  try {
    rawFileContents = readFileSync(filename, "utf-8");
  } catch {
    return "";
  }
  const codeFrame = codeFrameColumns(rawFileContents, {
    start: {
      line: line2,
      column: column2
    }
  }, {
    highlightCode: true,
    linesBelow: 0
  });
  return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
  if (!readFileSync || !codeFrameColumns) {
    return "";
  }
  const err = new Error();
  const firstClientCodeFrame = err.stack.split("\n").slice(1).find((frame2) => !frame2.includes("node_modules/"));
  return getCodeFrame(firstClientCodeFrame);
}
const TEXT_NODE = 3;
function jestFakeTimersAreEnabled() {
  if (typeof jest !== "undefined" && jest !== null) {
    return (
      // legacy timers
      setTimeout._isMockFunction === true || // modern timers
      // eslint-disable-next-line prefer-object-has-own -- not supported by our support matrix
      Object.prototype.hasOwnProperty.call(setTimeout, "clock")
    );
  }
  return false;
}
function getDocument() {
  if (typeof window === "undefined") {
    throw new Error("Could not find default container");
  }
  return window.document;
}
function getWindowFromNode(node2) {
  if (node2.defaultView) {
    return node2.defaultView;
  } else if (node2.ownerDocument && node2.ownerDocument.defaultView) {
    return node2.ownerDocument.defaultView;
  } else if (node2.window) {
    return node2.window;
  } else if (node2.ownerDocument && node2.ownerDocument.defaultView === null) {
    throw new Error("It looks like the window object is not available for the provided node.");
  } else if (node2.then instanceof Function) {
    throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
  } else if (Array.isArray(node2)) {
    throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
  } else if (typeof node2.debug === "function" && typeof node2.logTestingPlaygroundURL === "function") {
    throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
  } else {
    throw new Error("The given node is not an Element, the node type is: " + typeof node2 + ".");
  }
}
function checkContainerType(container2) {
  if (!container2 || !(typeof container2.querySelector === "function") || !(typeof container2.querySelectorAll === "function")) {
    throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container2) + ".");
  }
  function getTypeName(object2) {
    if (typeof object2 === "object") {
      return object2 === null ? "null" : object2.constructor.name;
    }
    return typeof object2;
  }
}
const shouldHighlight = () => {
  let colors3;
  try {
    var _process;
    colors3 = JSON.parse((_process = process) == null || (_process = _process.env) == null ? void 0 : _process.COLORS);
  } catch (e3) {
  }
  if (typeof colors3 === "boolean") {
    return colors3;
  } else {
    return typeof process !== "undefined" && process.versions !== void 0 && process.versions.node !== void 0;
  }
};
const {
  DOMCollection
} = plugins_1;
const ELEMENT_NODE = 1;
const COMMENT_NODE = 8;
function filterCommentsAndDefaultIgnoreTagsTags(value) {
  return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}
function prettyDOM(dom2, maxLength, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  if (!dom2) {
    dom2 = getDocument().body;
  }
  if (typeof maxLength !== "number") {
    maxLength = typeof process !== "undefined" && process.env.DEBUG_PRINT_LIMIT || 7e3;
  }
  if (maxLength === 0) {
    return "";
  }
  if (dom2.documentElement) {
    dom2 = dom2.documentElement;
  }
  let domTypeName = typeof dom2;
  if (domTypeName === "object") {
    domTypeName = dom2.constructor.name;
  } else {
    dom2 = {};
  }
  if (!("outerHTML" in dom2)) {
    throw new TypeError("Expected an element or document but got " + domTypeName);
  }
  const {
    filterNode = filterCommentsAndDefaultIgnoreTagsTags,
    ...prettyFormatOptions
  } = options2;
  const debugContent = format_1(dom2, {
    plugins: [createDOMElementFilter(filterNode), DOMCollection],
    printFunctionName: false,
    highlight: shouldHighlight(),
    ...prettyFormatOptions
  });
  return maxLength !== void 0 && dom2.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
const logDOM = function() {
  const userCodeFrame = getUserCodeFrame();
  if (userCodeFrame) {
    console.log(prettyDOM(...arguments) + "\n\n" + userCodeFrame);
  } else {
    console.log(prettyDOM(...arguments));
  }
};
let config$1 = {
  testIdAttribute: "data-testid",
  asyncUtilTimeout: 1e3,
  // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
  // forcing react-testing-library to wrap all async functions would've been
  // a total nightmare (consider wrapping every findBy* query and then also
  // updating `within` so those would be wrapped too. Total nightmare).
  // so we have this config option that's really only intended for
  // react-testing-library to use. For that reason, this feature will remain
  // undocumented.
  asyncWrapper: (cb) => cb(),
  unstable_advanceTimersWrapper: (cb) => cb(),
  eventWrapper: (cb) => cb(),
  // default value for the `hidden` option in `ByRole` queries
  defaultHidden: false,
  // default value for the `ignore` option in `ByText` queries
  defaultIgnore: "script, style",
  // showOriginalStackTrace flag to show the full error stack traces for async errors
  showOriginalStackTrace: false,
  // throw errors w/ suggestions for better queries. Opt in so off by default.
  throwSuggestions: false,
  // called when getBy* queries fail. (message, container) => Error
  getElementError(message, container2) {
    const prettifiedDOM = prettyDOM(container2);
    const error2 = new Error([message, "Ignored nodes: comments, " + config$1.defaultIgnore + "\n" + prettifiedDOM].filter(Boolean).join("\n\n"));
    error2.name = "TestingLibraryElementError";
    return error2;
  },
  _disableExpensiveErrorDiagnostics: false,
  computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
  try {
    config$1._disableExpensiveErrorDiagnostics = true;
    return callback();
  } finally {
    config$1._disableExpensiveErrorDiagnostics = false;
  }
}
function getConfig() {
  return config$1;
}
const labelledNodeNames = ["button", "meter", "output", "progress", "select", "textarea", "input"];
function getTextContent(node2) {
  if (labelledNodeNames.includes(node2.nodeName.toLowerCase())) {
    return "";
  }
  if (node2.nodeType === TEXT_NODE)
    return node2.textContent;
  return Array.from(node2.childNodes).map((childNode) => getTextContent(childNode)).join("");
}
function getLabelContent(element) {
  let textContent;
  if (element.tagName.toLowerCase() === "label") {
    textContent = getTextContent(element);
  } else {
    textContent = element.value || element.textContent;
  }
  return textContent;
}
function getRealLabels(element) {
  if (element.labels !== void 0) {
    var _labels;
    return (_labels = element.labels) != null ? _labels : [];
  }
  if (!isLabelable(element))
    return [];
  const labels = element.ownerDocument.querySelectorAll("label");
  return Array.from(labels).filter((label2) => label2.control === element);
}
function isLabelable(element) {
  return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === "INPUT" && element.getAttribute("type") !== "hidden";
}
function getLabels(container2, element, _temp) {
  let {
    selector = "*"
  } = _temp === void 0 ? {} : _temp;
  const ariaLabelledBy = element.getAttribute("aria-labelledby");
  const labelsId = ariaLabelledBy ? ariaLabelledBy.split(" ") : [];
  return labelsId.length ? labelsId.map((labelId) => {
    const labellingElement = container2.querySelector('[id="' + labelId + '"]');
    return labellingElement ? {
      content: getLabelContent(labellingElement),
      formControl: null
    } : {
      content: "",
      formControl: null
    };
  }) : Array.from(getRealLabels(element)).map((label2) => {
    const textToMatch = getLabelContent(label2);
    const formControlSelector = "button, input, meter, output, progress, select, textarea";
    const labelledFormControl = Array.from(label2.querySelectorAll(formControlSelector)).filter((formControlElement) => formControlElement.matches(selector))[0];
    return {
      content: textToMatch,
      formControl: labelledFormControl
    };
  });
}
function assertNotNullOrUndefined(matcher) {
  if (matcher === null || matcher === void 0) {
    throw new Error(
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- implicitly converting `T` to `string`
      "It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?"
    );
  }
}
function fuzzyMatches(textToMatch, node2, matcher, normalizer) {
  if (typeof textToMatch !== "string") {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (typeof matcher === "string" || typeof matcher === "number") {
    return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
  } else if (typeof matcher === "function") {
    return matcher(normalizedText, node2);
  } else {
    return matchRegExp(matcher, normalizedText);
  }
}
function matches(textToMatch, node2, matcher, normalizer) {
  if (typeof textToMatch !== "string") {
    return false;
  }
  assertNotNullOrUndefined(matcher);
  const normalizedText = normalizer(textToMatch);
  if (matcher instanceof Function) {
    return matcher(normalizedText, node2);
  } else if (matcher instanceof RegExp) {
    return matchRegExp(matcher, normalizedText);
  } else {
    return normalizedText === String(matcher);
  }
}
function getDefaultNormalizer(_temp) {
  let {
    trim: trim2 = true,
    collapseWhitespace = true
  } = _temp === void 0 ? {} : _temp;
  return (text2) => {
    let normalizedText = text2;
    normalizedText = trim2 ? normalizedText.trim() : normalizedText;
    normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, " ") : normalizedText;
    return normalizedText;
  };
}
function makeNormalizer(_ref2) {
  let {
    trim: trim2,
    collapseWhitespace,
    normalizer
  } = _ref2;
  if (!normalizer) {
    return getDefaultNormalizer({
      trim: trim2,
      collapseWhitespace
    });
  }
  if (typeof trim2 !== "undefined" || typeof collapseWhitespace !== "undefined") {
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhitespace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
  }
  return normalizer;
}
function matchRegExp(matcher, text2) {
  const match2 = matcher.test(text2);
  if (matcher.global && matcher.lastIndex !== 0) {
    console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
    matcher.lastIndex = 0;
  }
  return match2;
}
function getNodeText(node2) {
  if (node2.matches("input[type=submit], input[type=button], input[type=reset]")) {
    return node2.value;
  }
  return Array.from(node2.childNodes).filter((child) => child.nodeType === TEXT_NODE && Boolean(child.textContent)).map((c7) => c7.textContent).join("");
}
const elementRoleList = buildElementRoleList(elementRoles_1);
function isSubtreeInaccessible(element) {
  if (element.hidden === true) {
    return true;
  }
  if (element.getAttribute("aria-hidden") === "true") {
    return true;
  }
  const window2 = element.ownerDocument.defaultView;
  if (window2.getComputedStyle(element).display === "none") {
    return true;
  }
  return false;
}
function isInaccessible(element, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    isSubtreeInaccessible: isSubtreeInaccessibleImpl = isSubtreeInaccessible
  } = options2;
  const window2 = element.ownerDocument.defaultView;
  if (window2.getComputedStyle(element).visibility === "hidden") {
    return true;
  }
  let currentElement = element;
  while (currentElement) {
    if (isSubtreeInaccessibleImpl(currentElement)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function getImplicitAriaRoles(currentNode) {
  for (const {
    match: match2,
    roles: roles2
  } of elementRoleList) {
    if (match2(currentNode)) {
      return [...roles2];
    }
  }
  return [];
}
function buildElementRoleList(elementRolesMap) {
  function makeElementSelector(_ref2) {
    let {
      name: name2,
      attributes
    } = _ref2;
    return "" + name2 + attributes.map((_ref22) => {
      let {
        name: attributeName,
        value,
        constraints = []
      } = _ref22;
      const shouldNotExist = constraints.indexOf("undefined") !== -1;
      if (shouldNotExist) {
        return ":not([" + attributeName + "])";
      } else if (value) {
        return "[" + attributeName + '="' + value + '"]';
      } else {
        return "[" + attributeName + "]";
      }
    }).join("");
  }
  function getSelectorSpecificity(_ref3) {
    let {
      attributes = []
    } = _ref3;
    return attributes.length;
  }
  function bySelectorSpecificity(_ref4, _ref5) {
    let {
      specificity: leftSpecificity
    } = _ref4;
    let {
      specificity: rightSpecificity
    } = _ref5;
    return rightSpecificity - leftSpecificity;
  }
  function match2(element) {
    let {
      attributes = []
    } = element;
    const typeTextIndex = attributes.findIndex((attribute) => attribute.value && attribute.name === "type" && attribute.value === "text");
    if (typeTextIndex >= 0) {
      attributes = [...attributes.slice(0, typeTextIndex), ...attributes.slice(typeTextIndex + 1)];
    }
    const selector = makeElementSelector({
      ...element,
      attributes
    });
    return (node2) => {
      if (typeTextIndex >= 0 && node2.type !== "text") {
        return false;
      }
      return node2.matches(selector);
    };
  }
  let result = [];
  for (const [element, roles2] of elementRolesMap.entries()) {
    result = [...result, {
      match: match2(element),
      roles: Array.from(roles2),
      specificity: getSelectorSpecificity(element)
    }];
  }
  return result.sort(bySelectorSpecificity);
}
function getRoles(container2, _temp) {
  let {
    hidden = false
  } = _temp === void 0 ? {} : _temp;
  function flattenDOM(node2) {
    return [node2, ...Array.from(node2.children).reduce((acc, child) => [...acc, ...flattenDOM(child)], [])];
  }
  return flattenDOM(container2).filter((element) => {
    return hidden === false ? isInaccessible(element) === false : true;
  }).reduce((acc, node2) => {
    let roles2 = [];
    if (node2.hasAttribute("role")) {
      roles2 = node2.getAttribute("role").split(" ").slice(0, 1);
    } else {
      roles2 = getImplicitAriaRoles(node2);
    }
    return roles2.reduce((rolesAcc, role) => Array.isArray(rolesAcc[role]) ? {
      ...rolesAcc,
      [role]: [...rolesAcc[role], node2]
    } : {
      ...rolesAcc,
      [role]: [node2]
    }, acc);
  }, {});
}
function prettyRoles(dom2, _ref6) {
  let {
    hidden,
    includeDescription
  } = _ref6;
  const roles2 = getRoles(dom2, {
    hidden
  });
  return Object.entries(roles2).filter((_ref7) => {
    let [role] = _ref7;
    return role !== "generic";
  }).map((_ref8) => {
    let [role, elements] = _ref8;
    const delimiterBar = "-".repeat(50);
    const elementsString = elements.map((el) => {
      const nameString = 'Name "' + computeAccessibleName(el, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      }) + '":\n';
      const domString = prettyDOM(el.cloneNode(false));
      if (includeDescription) {
        const descriptionString = 'Description "' + computeAccessibleDescription(el, {
          computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }) + '":\n';
        return "" + nameString + descriptionString + domString;
      }
      return "" + nameString + domString;
    }).join("\n\n");
    return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
  }).join("\n");
}
function computeAriaSelected(element) {
  if (element.tagName === "OPTION") {
    return element.selected;
  }
  return checkBooleanAttribute(element, "aria-selected");
}
function computeAriaBusy(element) {
  return element.getAttribute("aria-busy") === "true";
}
function computeAriaChecked(element) {
  if ("indeterminate" in element && element.indeterminate) {
    return void 0;
  }
  if ("checked" in element) {
    return element.checked;
  }
  return checkBooleanAttribute(element, "aria-checked");
}
function computeAriaPressed(element) {
  return checkBooleanAttribute(element, "aria-pressed");
}
function computeAriaCurrent(element) {
  var _ref9, _checkBooleanAttribut;
  return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, "aria-current")) != null ? _checkBooleanAttribut : element.getAttribute("aria-current")) != null ? _ref9 : false;
}
function computeAriaExpanded(element) {
  return checkBooleanAttribute(element, "aria-expanded");
}
function checkBooleanAttribute(element, attribute) {
  const attributeValue = element.getAttribute(attribute);
  if (attributeValue === "true") {
    return true;
  }
  if (attributeValue === "false") {
    return false;
  }
  return void 0;
}
function computeHeadingLevel(element) {
  const implicitHeadingLevels = {
    H1: 1,
    H2: 2,
    H3: 3,
    H4: 4,
    H5: 5,
    H6: 6
  };
  const ariaLevelAttribute = element.getAttribute("aria-level") && Number(element.getAttribute("aria-level"));
  return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}
function computeAriaValueNow(element) {
  const valueNow = element.getAttribute("aria-valuenow");
  return valueNow === null ? void 0 : +valueNow;
}
function computeAriaValueMax(element) {
  const valueMax = element.getAttribute("aria-valuemax");
  return valueMax === null ? void 0 : +valueMax;
}
function computeAriaValueMin(element) {
  const valueMin = element.getAttribute("aria-valuemin");
  return valueMin === null ? void 0 : +valueMin;
}
function computeAriaValueText(element) {
  const valueText = element.getAttribute("aria-valuetext");
  return valueText === null ? void 0 : valueText;
}
const normalize$1 = getDefaultNormalizer();
function escapeRegExp$1(string2) {
  return string2.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}
function getRegExpMatcher(string2) {
  return new RegExp(escapeRegExp$1(string2.toLowerCase()), "i");
}
function makeSuggestion(queryName, element, content2, _ref2) {
  let {
    variant: variant3,
    name: name2
  } = _ref2;
  let warning2 = "";
  const queryOptions = {};
  const queryArgs = [["Role", "TestId"].includes(queryName) ? content2 : getRegExpMatcher(content2)];
  if (name2) {
    queryOptions.name = getRegExpMatcher(name2);
  }
  if (queryName === "Role" && isInaccessible(element)) {
    queryOptions.hidden = true;
    warning2 = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
  }
  if (Object.keys(queryOptions).length > 0) {
    queryArgs.push(queryOptions);
  }
  const queryMethod = variant3 + "By" + queryName;
  return {
    queryName,
    queryMethod,
    queryArgs,
    variant: variant3,
    warning: warning2,
    toString() {
      if (warning2) {
        console.warn(warning2);
      }
      let [text2, options2] = queryArgs;
      text2 = typeof text2 === "string" ? "'" + text2 + "'" : text2;
      options2 = options2 ? ", { " + Object.entries(options2).map((_ref22) => {
        let [k3, v] = _ref22;
        return k3 + ": " + v;
      }).join(", ") + " }" : "";
      return queryMethod + "(" + text2 + options2 + ")";
    }
  };
}
function canSuggest(currentMethod, requestedMethod, data) {
  return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery(element, variant3, method) {
  var _element$getAttribute, _getImplicitAriaRoles;
  if (variant3 === void 0) {
    variant3 = "get";
  }
  if (element.matches(getConfig().defaultIgnore)) {
    return void 0;
  }
  const role = (_element$getAttribute = element.getAttribute("role")) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
  if (role !== "generic" && canSuggest("Role", method, role)) {
    return makeSuggestion("Role", element, role, {
      variant: variant3,
      name: computeAccessibleName(element, {
        computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
      })
    });
  }
  const labelText = getLabels(document, element).map((label2) => label2.content).join(" ");
  if (canSuggest("LabelText", method, labelText)) {
    return makeSuggestion("LabelText", element, labelText, {
      variant: variant3
    });
  }
  const placeholderText = element.getAttribute("placeholder");
  if (canSuggest("PlaceholderText", method, placeholderText)) {
    return makeSuggestion("PlaceholderText", element, placeholderText, {
      variant: variant3
    });
  }
  const textContent = normalize$1(getNodeText(element));
  if (canSuggest("Text", method, textContent)) {
    return makeSuggestion("Text", element, textContent, {
      variant: variant3
    });
  }
  if (canSuggest("DisplayValue", method, element.value)) {
    return makeSuggestion("DisplayValue", element, normalize$1(element.value), {
      variant: variant3
    });
  }
  const alt = element.getAttribute("alt");
  if (canSuggest("AltText", method, alt)) {
    return makeSuggestion("AltText", element, alt, {
      variant: variant3
    });
  }
  const title = element.getAttribute("title");
  if (canSuggest("Title", method, title)) {
    return makeSuggestion("Title", element, title, {
      variant: variant3
    });
  }
  const testId = element.getAttribute(getConfig().testIdAttribute);
  if (canSuggest("TestId", method, testId)) {
    return makeSuggestion("TestId", element, testId, {
      variant: variant3
    });
  }
  return void 0;
}
function copyStackTrace(target, source) {
  target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref2) {
  let {
    container: container2 = getDocument(),
    timeout: timeout2 = getConfig().asyncUtilTimeout,
    showOriginalStackTrace = getConfig().showOriginalStackTrace,
    stackTraceError,
    interval: interval2 = 50,
    onTimeout = (error2) => {
      Object.defineProperty(error2, "message", {
        value: getConfig().getElementError(error2.message, container2).message
      });
      return error2;
    },
    mutationObserverOptions = {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    }
  } = _ref2;
  if (typeof callback !== "function") {
    throw new TypeError("Received `callback` arg must be a function");
  }
  return new Promise(async (resolve, reject) => {
    let lastError, intervalId, observer;
    let finished = false;
    let promiseStatus = "idle";
    const overallTimeoutTimer = setTimeout(handleTimeout, timeout2);
    const usingJestFakeTimers = jestFakeTimersAreEnabled();
    if (usingJestFakeTimers) {
      const {
        unstable_advanceTimersWrapper: advanceTimersWrapper
      } = getConfig();
      checkCallback();
      while (!finished) {
        if (!jestFakeTimersAreEnabled()) {
          const error2 = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
          if (!showOriginalStackTrace)
            copyStackTrace(error2, stackTraceError);
          reject(error2);
          return;
        }
        await advanceTimersWrapper(async () => {
          jest.advanceTimersByTime(interval2);
        });
        if (finished) {
          break;
        }
        checkCallback();
      }
    } else {
      try {
        checkContainerType(container2);
      } catch (e3) {
        reject(e3);
        return;
      }
      intervalId = setInterval(checkRealTimersCallback, interval2);
      const {
        MutationObserver
      } = getWindowFromNode(container2);
      observer = new MutationObserver(checkRealTimersCallback);
      observer.observe(container2, mutationObserverOptions);
      checkCallback();
    }
    function onDone(error2, result) {
      finished = true;
      clearTimeout(overallTimeoutTimer);
      if (!usingJestFakeTimers) {
        clearInterval(intervalId);
        observer.disconnect();
      }
      if (error2) {
        reject(error2);
      } else {
        resolve(result);
      }
    }
    function checkRealTimersCallback() {
      if (jestFakeTimersAreEnabled()) {
        const error2 = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
        if (!showOriginalStackTrace)
          copyStackTrace(error2, stackTraceError);
        return reject(error2);
      } else {
        return checkCallback();
      }
    }
    function checkCallback() {
      if (promiseStatus === "pending")
        return;
      try {
        const result = runWithExpensiveErrorDiagnosticsDisabled(callback);
        if (typeof (result == null ? void 0 : result.then) === "function") {
          promiseStatus = "pending";
          result.then((resolvedValue) => {
            promiseStatus = "resolved";
            onDone(null, resolvedValue);
          }, (rejectedValue) => {
            promiseStatus = "rejected";
            lastError = rejectedValue;
          });
        } else {
          onDone(null, result);
        }
      } catch (error2) {
        lastError = error2;
      }
    }
    function handleTimeout() {
      let error2;
      if (lastError) {
        error2 = lastError;
        if (!showOriginalStackTrace && error2.name === "TestingLibraryElementError") {
          copyStackTrace(error2, stackTraceError);
        }
      } else {
        error2 = new Error("Timed out in waitFor.");
        if (!showOriginalStackTrace) {
          copyStackTrace(error2, stackTraceError);
        }
      }
      onDone(onTimeout(error2), null);
    }
  });
}
function waitForWrapper(callback, options2) {
  const stackTraceError = new Error("STACK_TRACE_MESSAGE");
  return getConfig().asyncWrapper(() => waitFor(callback, {
    stackTraceError,
    ...options2
  }));
}
function getElementError(message, container2) {
  return getConfig().getElementError(message, container2);
}
function getMultipleElementsFoundError(message, container2) {
  return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container2);
}
function queryAllByAttribute(attribute, container2, text2, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  return Array.from(container2.querySelectorAll("[" + attribute + "]")).filter((node2) => matcher(node2.getAttribute(attribute), node2, text2, matchNormalizer));
}
function makeSingleQuery(allQuery, getMultipleError2) {
  return function(container2) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const els = allQuery(container2, ...args);
    if (els.length > 1) {
      const elementStrings = els.map((element) => getElementError(null, element).message).join("\n\n");
      throw getMultipleElementsFoundError(getMultipleError2(container2, ...args) + "\n\nHere are the matching elements:\n\n" + elementStrings, container2);
    }
    return els[0] || null;
  };
}
function getSuggestionError(suggestion, container2) {
  return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container2);
}
function makeGetAllQuery(allQuery, getMissingError2) {
  return function(container2) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const els = allQuery(container2, ...args);
    if (!els.length) {
      throw getConfig().getElementError(getMissingError2(container2, ...args), container2);
    }
    return els;
  };
}
function makeFindQuery(getter) {
  return (container2, text2, options2, waitForOptions) => {
    return waitForWrapper(() => {
      return getter(container2, text2, options2);
    }, {
      container: container2,
      ...waitForOptions
    });
  };
}
const wrapSingleQueryWithSuggestion = (query, queryAllByName, variant3) => function(container2) {
  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }
  const element = query(container2, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (element && suggest) {
    const suggestion = getSuggestedQuery(element, variant3);
    if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) {
      throw getSuggestionError(suggestion.toString(), container2);
    }
  }
  return element;
};
const wrapAllByQueryWithSuggestion = (query, queryAllByName, variant3) => function(container2) {
  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }
  const els = query(container2, ...args);
  const [{
    suggest = getConfig().throwSuggestions
  } = {}] = args.slice(-1);
  if (els.length && suggest) {
    const uniqueSuggestionMessages = [...new Set(els.map((element) => {
      var _getSuggestedQuery;
      return (_getSuggestedQuery = getSuggestedQuery(element, variant3)) == null ? void 0 : _getSuggestedQuery.toString();
    }))];
    if (
      // only want to suggest if all the els have the same suggestion.
      uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
        getSuggestedQuery(els[0], variant3).queryName
      )
    ) {
      throw getSuggestionError(uniqueSuggestionMessages[0], container2);
    }
  }
  return els;
};
function buildQueries(queryAllBy, getMultipleError2, getMissingError2) {
  const queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError2), queryAllBy.name, "query");
  const getAllBy = makeGetAllQuery(queryAllBy, getMissingError2);
  const getBy = makeSingleQuery(getAllBy, getMultipleError2);
  const getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, "get");
  const getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace("query", "get"), "getAll");
  const findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, "findAll"));
  const findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, "find"));
  return [queryBy, getAllWithSuggestions, getByWithSuggestions, findAllBy, findBy];
}
function queryAllLabels(container2) {
  return Array.from(container2.querySelectorAll("label,input")).map((node2) => {
    return {
      node: node2,
      textToMatch: getLabelContent(node2)
    };
  }).filter((_ref2) => {
    let {
      textToMatch
    } = _ref2;
    return textToMatch !== null;
  });
}
const queryAllLabelsByText = function(container2, text2, _temp) {
  let {
    exact = true,
    trim: trim2,
    collapseWhitespace,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  const textToMatchByLabels = queryAllLabels(container2);
  return textToMatchByLabels.filter((_ref2) => {
    let {
      node: node2,
      textToMatch
    } = _ref2;
    return matcher(textToMatch, node2, text2, matchNormalizer);
  }).map((_ref3) => {
    let {
      node: node2
    } = _ref3;
    return node2;
  });
};
const queryAllByLabelText = function(container2, text2, _temp2) {
  let {
    selector = "*",
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp2 === void 0 ? {} : _temp2;
  checkContainerType(container2);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  const matchingLabelledElements = Array.from(container2.querySelectorAll("*")).filter((element) => {
    return getRealLabels(element).length || element.hasAttribute("aria-labelledby");
  }).reduce((labelledElements, labelledElement) => {
    const labelList = getLabels(container2, labelledElement, {
      selector
    });
    labelList.filter((label2) => Boolean(label2.formControl)).forEach((label2) => {
      if (matcher(label2.content, label2.formControl, text2, matchNormalizer) && label2.formControl) {
        labelledElements.push(label2.formControl);
      }
    });
    const labelsValue = labelList.filter((label2) => Boolean(label2.content)).map((label2) => label2.content);
    if (matcher(labelsValue.join(" "), labelledElement, text2, matchNormalizer)) {
      labelledElements.push(labelledElement);
    }
    if (labelsValue.length > 1) {
      labelsValue.forEach((labelValue, index2) => {
        if (matcher(labelValue, labelledElement, text2, matchNormalizer)) {
          labelledElements.push(labelledElement);
        }
        const labelsFiltered = [...labelsValue];
        labelsFiltered.splice(index2, 1);
        if (labelsFiltered.length > 1) {
          if (matcher(labelsFiltered.join(" "), labelledElement, text2, matchNormalizer)) {
            labelledElements.push(labelledElement);
          }
        }
      });
    }
    return labelledElements;
  }, []).concat(queryAllByAttribute("aria-label", container2, text2, {
    exact,
    normalizer: matchNormalizer
  }));
  return Array.from(new Set(matchingLabelledElements)).filter((element) => element.matches(selector));
};
const getAllByLabelText = function(container2, text2) {
  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }
  const els = queryAllByLabelText(container2, text2, ...rest);
  if (!els.length) {
    const labels = queryAllLabelsByText(container2, text2, ...rest);
    if (labels.length) {
      const tagNames = labels.map((label2) => getTagNameOfElementAssociatedWithLabelViaFor(container2, label2)).filter((tagName) => !!tagName);
      if (tagNames.length) {
        throw getConfig().getElementError(tagNames.map((tagName) => "Found a label with the text of: " + text2 + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.").join("\n\n"), container2);
      } else {
        throw getConfig().getElementError("Found a label with the text of: " + text2 + `, however no form control was found associated to that label. Make sure you're using the "for" attribute or "aria-labelledby" attribute correctly.`, container2);
      }
    } else {
      throw getConfig().getElementError("Unable to find a label with the text of: " + text2, container2);
    }
  }
  return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container2, label2) {
  const htmlFor = label2.getAttribute("for");
  if (!htmlFor) {
    return null;
  }
  const element = container2.querySelector('[id="' + htmlFor + '"]');
  return element ? element.tagName.toLowerCase() : null;
}
const getMultipleError$7 = (c7, text2) => "Found multiple elements with the text of: " + text2;
const queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, "query");
const getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
const findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, "findAll"));
const findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, "find"));
const getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, "getAll");
const getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, "get");
const queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, "queryAll");
const queryAllByPlaceholderText = function() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute("placeholder", ...args);
};
const getMultipleError$6 = (c7, text2) => "Found multiple elements with the placeholder text of: " + text2;
const getMissingError$6 = (c7, text2) => "Unable to find an element with the placeholder text of: " + text2;
const queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, "queryAll");
const [queryByPlaceholderText, getAllByPlaceholderText, getByPlaceholderText, findAllByPlaceholderText, findByPlaceholderText] = buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6);
const queryAllByText = function(container2, text2, _temp) {
  let {
    selector = "*",
    exact = true,
    collapseWhitespace,
    trim: trim2,
    ignore = getConfig().defaultIgnore,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container2);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  let baseArray = [];
  if (typeof container2.matches === "function" && container2.matches(selector)) {
    baseArray = [container2];
  }
  return [...baseArray, ...Array.from(container2.querySelectorAll(selector))].filter((node2) => !ignore || !node2.matches(ignore)).filter((node2) => matcher(getNodeText(node2), node2, text2, matchNormalizer));
};
const getMultipleError$5 = (c7, text2) => "Found multiple elements with the text: " + text2;
const getMissingError$5 = function(c7, text2, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    collapseWhitespace,
    trim: trim2,
    normalizer,
    selector
  } = options2;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  const normalizedText = matchNormalizer(text2.toString());
  const isNormalizedDifferent = normalizedText !== text2.toString();
  const isCustomSelector = (selector != null ? selector : "*") !== "*";
  return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text2 + "')" : text2) + (isCustomSelector ? ", which matches selector '" + selector + "'" : "") + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
const queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, "queryAll");
const [queryByText, getAllByText, getByText, findAllByText, findByText] = buildQueries(queryAllByText, getMultipleError$5, getMissingError$5);
const queryAllByDisplayValue = function(container2, value, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container2);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  return Array.from(container2.querySelectorAll("input,textarea,select")).filter((node2) => {
    if (node2.tagName === "SELECT") {
      const selectedOptions = Array.from(node2.options).filter((option) => option.selected);
      return selectedOptions.some((optionNode) => matcher(getNodeText(optionNode), optionNode, value, matchNormalizer));
    } else {
      return matcher(node2.value, node2, value, matchNormalizer);
    }
  });
};
const getMultipleError$4 = (c7, value) => "Found multiple elements with the display value: " + value + ".";
const getMissingError$4 = (c7, value) => "Unable to find an element with the display value: " + value + ".";
const queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, "queryAll");
const [queryByDisplayValue, getAllByDisplayValue, getByDisplayValue, findAllByDisplayValue, findByDisplayValue] = buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4);
const VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;
const queryAllByAltText = function(container2, alt, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  checkContainerType(container2);
  return queryAllByAttribute("alt", container2, alt, options2).filter((node2) => VALID_TAG_REGEXP.test(node2.tagName));
};
const getMultipleError$3 = (c7, alt) => "Found multiple elements with the alt text: " + alt;
const getMissingError$3 = (c7, alt) => "Unable to find an element with the alt text: " + alt;
const queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, "queryAll");
const [queryByAltText, getAllByAltText, getByAltText, findAllByAltText, findByAltText] = buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3);
const isSvgTitle = (node2) => {
  var _node$parentElement;
  return node2.tagName.toLowerCase() === "title" && ((_node$parentElement = node2.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === "svg";
};
const queryAllByTitle = function(container2, text2, _temp) {
  let {
    exact = true,
    collapseWhitespace,
    trim: trim2,
    normalizer
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container2);
  const matcher = exact ? matches : fuzzyMatches;
  const matchNormalizer = makeNormalizer({
    collapseWhitespace,
    trim: trim2,
    normalizer
  });
  return Array.from(container2.querySelectorAll("[title], svg > title")).filter((node2) => matcher(node2.getAttribute("title"), node2, text2, matchNormalizer) || isSvgTitle(node2) && matcher(getNodeText(node2), node2, text2, matchNormalizer));
};
const getMultipleError$2 = (c7, title) => "Found multiple elements with the title: " + title + ".";
const getMissingError$2 = (c7, title) => "Unable to find an element with the title: " + title + ".";
const queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, "queryAll");
const [queryByTitle, getAllByTitle, getByTitle, findAllByTitle, findByTitle] = buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2);
const queryAllByRole = function(container2, role, _temp) {
  let {
    hidden = getConfig().defaultHidden,
    name: name2,
    description,
    queryFallbacks = false,
    selected,
    busy,
    checked,
    pressed,
    current,
    level,
    expanded,
    value: {
      now: valueNow,
      min: valueMin,
      max: valueMax,
      text: valueText
    } = {}
  } = _temp === void 0 ? {} : _temp;
  checkContainerType(container2);
  if (selected !== void 0) {
    var _allRoles$get;
    if (((_allRoles$get = roles_1.get(role)) == null ? void 0 : _allRoles$get.props["aria-selected"]) === void 0) {
      throw new Error('"aria-selected" is not supported on role "' + role + '".');
    }
  }
  if (busy !== void 0) {
    var _allRoles$get2;
    if (((_allRoles$get2 = roles_1.get(role)) == null ? void 0 : _allRoles$get2.props["aria-busy"]) === void 0) {
      throw new Error('"aria-busy" is not supported on role "' + role + '".');
    }
  }
  if (checked !== void 0) {
    var _allRoles$get3;
    if (((_allRoles$get3 = roles_1.get(role)) == null ? void 0 : _allRoles$get3.props["aria-checked"]) === void 0) {
      throw new Error('"aria-checked" is not supported on role "' + role + '".');
    }
  }
  if (pressed !== void 0) {
    var _allRoles$get4;
    if (((_allRoles$get4 = roles_1.get(role)) == null ? void 0 : _allRoles$get4.props["aria-pressed"]) === void 0) {
      throw new Error('"aria-pressed" is not supported on role "' + role + '".');
    }
  }
  if (current !== void 0) {
    var _allRoles$get5;
    if (((_allRoles$get5 = roles_1.get(role)) == null ? void 0 : _allRoles$get5.props["aria-current"]) === void 0) {
      throw new Error('"aria-current" is not supported on role "' + role + '".');
    }
  }
  if (level !== void 0) {
    if (role !== "heading") {
      throw new Error('Role "' + role + '" cannot have "level" property.');
    }
  }
  if (valueNow !== void 0) {
    var _allRoles$get6;
    if (((_allRoles$get6 = roles_1.get(role)) == null ? void 0 : _allRoles$get6.props["aria-valuenow"]) === void 0) {
      throw new Error('"aria-valuenow" is not supported on role "' + role + '".');
    }
  }
  if (valueMax !== void 0) {
    var _allRoles$get7;
    if (((_allRoles$get7 = roles_1.get(role)) == null ? void 0 : _allRoles$get7.props["aria-valuemax"]) === void 0) {
      throw new Error('"aria-valuemax" is not supported on role "' + role + '".');
    }
  }
  if (valueMin !== void 0) {
    var _allRoles$get8;
    if (((_allRoles$get8 = roles_1.get(role)) == null ? void 0 : _allRoles$get8.props["aria-valuemin"]) === void 0) {
      throw new Error('"aria-valuemin" is not supported on role "' + role + '".');
    }
  }
  if (valueText !== void 0) {
    var _allRoles$get9;
    if (((_allRoles$get9 = roles_1.get(role)) == null ? void 0 : _allRoles$get9.props["aria-valuetext"]) === void 0) {
      throw new Error('"aria-valuetext" is not supported on role "' + role + '".');
    }
  }
  if (expanded !== void 0) {
    var _allRoles$get10;
    if (((_allRoles$get10 = roles_1.get(role)) == null ? void 0 : _allRoles$get10.props["aria-expanded"]) === void 0) {
      throw new Error('"aria-expanded" is not supported on role "' + role + '".');
    }
  }
  const subtreeIsInaccessibleCache = /* @__PURE__ */ new WeakMap();
  function cachedIsSubtreeInaccessible(element) {
    if (!subtreeIsInaccessibleCache.has(element)) {
      subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
    }
    return subtreeIsInaccessibleCache.get(element);
  }
  return Array.from(container2.querySelectorAll(
    // Only query elements that can be matched by the following filters
    makeRoleSelector(role)
  )).filter((node2) => {
    const isRoleSpecifiedExplicitly = node2.hasAttribute("role");
    if (isRoleSpecifiedExplicitly) {
      const roleValue = node2.getAttribute("role");
      if (queryFallbacks) {
        return roleValue.split(" ").filter(Boolean).some((roleAttributeToken) => roleAttributeToken === role);
      }
      const [firstRoleAttributeToken] = roleValue.split(" ");
      return firstRoleAttributeToken === role;
    }
    const implicitRoles = getImplicitAriaRoles(node2);
    return implicitRoles.some((implicitRole) => {
      return implicitRole === role;
    });
  }).filter((element) => {
    if (selected !== void 0) {
      return selected === computeAriaSelected(element);
    }
    if (busy !== void 0) {
      return busy === computeAriaBusy(element);
    }
    if (checked !== void 0) {
      return checked === computeAriaChecked(element);
    }
    if (pressed !== void 0) {
      return pressed === computeAriaPressed(element);
    }
    if (current !== void 0) {
      return current === computeAriaCurrent(element);
    }
    if (expanded !== void 0) {
      return expanded === computeAriaExpanded(element);
    }
    if (level !== void 0) {
      return level === computeHeadingLevel(element);
    }
    if (valueNow !== void 0 || valueMax !== void 0 || valueMin !== void 0 || valueText !== void 0) {
      let valueMatches = true;
      if (valueNow !== void 0) {
        valueMatches && (valueMatches = valueNow === computeAriaValueNow(element));
      }
      if (valueMax !== void 0) {
        valueMatches && (valueMatches = valueMax === computeAriaValueMax(element));
      }
      if (valueMin !== void 0) {
        valueMatches && (valueMatches = valueMin === computeAriaValueMin(element));
      }
      if (valueText !== void 0) {
        var _computeAriaValueText;
        valueMatches && (valueMatches = matches((_computeAriaValueText = computeAriaValueText(element)) != null ? _computeAriaValueText : null, element, valueText, (text2) => text2));
      }
      return valueMatches;
    }
    return true;
  }).filter((element) => {
    if (name2 === void 0) {
      return true;
    }
    return matches(computeAccessibleName(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, name2, (text2) => text2);
  }).filter((element) => {
    if (description === void 0) {
      return true;
    }
    return matches(computeAccessibleDescription(element, {
      computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
    }), element, description, (text2) => text2);
  }).filter((element) => {
    return hidden === false ? isInaccessible(element, {
      isSubtreeInaccessible: cachedIsSubtreeInaccessible
    }) === false : true;
  });
};
function makeRoleSelector(role) {
  var _roleElements$get;
  const explicitRoleSelector = '*[role~="' + role + '"]';
  const roleRelations = (_roleElements$get = roleElements_1.get(role)) != null ? _roleElements$get : /* @__PURE__ */ new Set();
  const implicitRoleSelectors = new Set(Array.from(roleRelations).map((_ref2) => {
    let {
      name: name2
    } = _ref2;
    return name2;
  }));
  return [explicitRoleSelector].concat(Array.from(implicitRoleSelectors)).join(",");
}
const getNameHint = (name2) => {
  let nameHint = "";
  if (name2 === void 0) {
    nameHint = "";
  } else if (typeof name2 === "string") {
    nameHint = ' and name "' + name2 + '"';
  } else {
    nameHint = " and name `" + name2 + "`";
  }
  return nameHint;
};
const getMultipleError$1 = function(c7, role, _temp2) {
  let {
    name: name2
  } = _temp2 === void 0 ? {} : _temp2;
  return 'Found multiple elements with the role "' + role + '"' + getNameHint(name2);
};
const getMissingError$1 = function(container2, role, _temp3) {
  let {
    hidden = getConfig().defaultHidden,
    name: name2,
    description
  } = _temp3 === void 0 ? {} : _temp3;
  if (getConfig()._disableExpensiveErrorDiagnostics) {
    return 'Unable to find role="' + role + '"' + getNameHint(name2);
  }
  let roles2 = "";
  Array.from(container2.children).forEach((childElement) => {
    roles2 += prettyRoles(childElement, {
      hidden,
      includeDescription: description !== void 0
    });
  });
  let roleMessage;
  if (roles2.length === 0) {
    if (hidden === false) {
      roleMessage = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, then set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole";
    } else {
      roleMessage = "There are no available roles.";
    }
  } else {
    roleMessage = ("\nHere are the " + (hidden === false ? "accessible" : "available") + " roles:\n\n  " + roles2.replace(/\n/g, "\n  ").replace(/\n\s\s\n/g, "\n\n") + "\n").trim();
  }
  let nameHint = "";
  if (name2 === void 0) {
    nameHint = "";
  } else if (typeof name2 === "string") {
    nameHint = ' and name "' + name2 + '"';
  } else {
    nameHint = " and name `" + name2 + "`";
  }
  let descriptionHint = "";
  if (description === void 0) {
    descriptionHint = "";
  } else if (typeof description === "string") {
    descriptionHint = ' and description "' + description + '"';
  } else {
    descriptionHint = " and description `" + description + "`";
  }
  return ("\nUnable to find an " + (hidden === false ? "accessible " : "") + 'element with the role "' + role + '"' + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
const queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, "queryAll");
const [queryByRole, getAllByRole, getByRole, findAllByRole, findByRole] = buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1);
const getTestIdAttribute = () => getConfig().testIdAttribute;
const queryAllByTestId = function() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  checkContainerType(args[0]);
  return queryAllByAttribute(getTestIdAttribute(), ...args);
};
const getMultipleError = (c7, id) => "Found multiple elements by: [" + getTestIdAttribute() + '="' + id + '"]';
const getMissingError = (c7, id) => "Unable to find an element by: [" + getTestIdAttribute() + '="' + id + '"]';
const queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, "queryAll");
const [queryByTestId, getAllByTestId, getByTestId, findAllByTestId, findByTestId] = buildQueries(queryAllByTestId, getMultipleError, getMissingError);
var queries = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  queryAllByLabelText: queryAllByLabelTextWithSuggestions,
  queryByLabelText,
  getAllByLabelText: getAllByLabelTextWithSuggestions,
  getByLabelText: getByLabelTextWithSuggestions,
  findAllByLabelText,
  findByLabelText,
  queryByPlaceholderText,
  queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
  getByPlaceholderText,
  getAllByPlaceholderText,
  findAllByPlaceholderText,
  findByPlaceholderText,
  queryByText,
  queryAllByText: queryAllByTextWithSuggestions,
  getByText,
  getAllByText,
  findAllByText,
  findByText,
  queryByDisplayValue,
  queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
  getByDisplayValue,
  getAllByDisplayValue,
  findAllByDisplayValue,
  findByDisplayValue,
  queryByAltText,
  queryAllByAltText: queryAllByAltTextWithSuggestions,
  getByAltText,
  getAllByAltText,
  findAllByAltText,
  findByAltText,
  queryByTitle,
  queryAllByTitle: queryAllByTitleWithSuggestions,
  getByTitle,
  getAllByTitle,
  findAllByTitle,
  findByTitle,
  queryByRole,
  queryAllByRole: queryAllByRoleWithSuggestions,
  getAllByRole,
  getByRole,
  findAllByRole,
  findByRole,
  queryByTestId,
  queryAllByTestId: queryAllByTestIdWithSuggestions,
  getByTestId,
  getAllByTestId,
  findAllByTestId,
  findByTestId
});
function getQueriesForElement(element, queries$12, initialValue2) {
  if (queries$12 === void 0) {
    queries$12 = queries;
  }
  if (initialValue2 === void 0) {
    initialValue2 = {};
  }
  return Object.keys(queries$12).reduce((helpers, key) => {
    const fn2 = queries$12[key];
    helpers[key] = fn2.bind(null, element);
    return helpers;
  }, initialValue2);
}
const eventMap = {
  // Clipboard Events
  copy: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  cut: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  paste: {
    EventType: "ClipboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Composition Events
  compositionEnd: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionStart: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  compositionUpdate: {
    EventType: "CompositionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Keyboard Events
  keyDown: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyPress: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  keyUp: {
    EventType: "KeyboardEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      charCode: 0,
      composed: true
    }
  },
  // Focus Events
  focus: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  blur: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  focusIn: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  focusOut: {
    EventType: "FocusEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // Form Events
  change: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  input: {
    EventType: "InputEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  invalid: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: true
    }
  },
  submit: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  reset: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  // Mouse Events
  click: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      button: 0,
      composed: true
    }
  },
  contextMenu: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dblClick: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drag: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragEnd: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragEnter: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragExit: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragLeave: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  dragOver: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  dragStart: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  drop: {
    EventType: "DragEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseDown: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseEnter: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseLeave: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false,
      composed: true
    }
  },
  mouseMove: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOut: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseOver: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  mouseUp: {
    EventType: "MouseEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Selection Events
  select: {
    EventType: "Event",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Touch Events
  touchCancel: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  touchEnd: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchMove: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  touchStart: {
    EventType: "TouchEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // UI Events
  resize: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  scroll: {
    EventType: "UIEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Wheel Events
  wheel: {
    EventType: "WheelEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  // Media Events
  abort: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlay: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  canPlayThrough: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  durationChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  emptied: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  encrypted: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  ended: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedData: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadedMetadata: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  loadStart: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pause: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  play: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  playing: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  progress: {
    EventType: "ProgressEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  rateChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeked: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  seeking: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  stalled: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  suspend: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  timeUpdate: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  volumeChange: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  waiting: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Events
  load: {
    // TODO: load events can be UIEvent or Event depending on what generated them
    // This is where this abstraction breaks down.
    // But the common targets are <img />, <script /> and window.
    // Neither of these targets receive a UIEvent
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  error: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  // Animation Events
  animationStart: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationEnd: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  animationIteration: {
    EventType: "AnimationEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // Transition Events
  transitionCancel: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionEnd: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true
    }
  },
  transitionRun: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  transitionStart: {
    EventType: "TransitionEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // pointer events
  pointerOver: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerEnter: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  pointerDown: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerMove: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerUp: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerCancel: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  pointerOut: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: true,
      composed: true
    }
  },
  pointerLeave: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  gotPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  lostPointerCapture: {
    EventType: "PointerEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false,
      composed: true
    }
  },
  // history events
  popState: {
    EventType: "PopStateEvent",
    defaultInit: {
      bubbles: true,
      cancelable: false
    }
  },
  // window events
  offline: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  },
  online: {
    EventType: "Event",
    defaultInit: {
      bubbles: false,
      cancelable: false
    }
  }
};
const eventAliasMap = {
  doubleClick: "dblClick"
};
Object.keys(eventMap).forEach((key) => {
  key.toLowerCase();
});
Object.keys(eventAliasMap).forEach((aliasKey) => {
});
function unindent(string2) {
  return string2.replace(/[ \t]*[\n][ \t]*/g, "\n");
}
function encode$2(value) {
  return lzString.compressToEncodedURIComponent(unindent(value));
}
function getPlaygroundUrl(markup2) {
  return "https://testing-playground.com/#markup=" + encode$2(markup2);
}
const debug = (element, maxLength, options2) => Array.isArray(element) ? element.forEach((el) => logDOM(el, maxLength, options2)) : logDOM(element, maxLength, options2);
const logTestingPlaygroundURL = function(element) {
  if (element === void 0) {
    element = getDocument().body;
  }
  if (!element || !("innerHTML" in element)) {
    console.log("The element you're providing isn't a valid DOM element.");
    return;
  }
  if (!element.innerHTML) {
    console.log("The provided element doesn't have any children.");
    return;
  }
  const playgroundUrl = getPlaygroundUrl(element.innerHTML);
  console.log("Open this URL in your browser\n\n" + playgroundUrl);
  return playgroundUrl;
};
const initialValue = {
  debug,
  logTestingPlaygroundURL
};
typeof document !== "undefined" && document.body ? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce((helpers, key) => {
  helpers[key] = () => {
    throw new TypeError("For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error");
  };
  return helpers;
}, initialValue);
var DOM_KEY_LOCATION;
(function(DOM_KEY_LOCATION2) {
  DOM_KEY_LOCATION2[DOM_KEY_LOCATION2["STANDARD"] = 0] = "STANDARD";
  DOM_KEY_LOCATION2[DOM_KEY_LOCATION2["LEFT"] = 1] = "LEFT";
  DOM_KEY_LOCATION2[DOM_KEY_LOCATION2["RIGHT"] = 2] = "RIGHT";
  DOM_KEY_LOCATION2[DOM_KEY_LOCATION2["NUMPAD"] = 3] = "NUMPAD";
})(DOM_KEY_LOCATION || (DOM_KEY_LOCATION = {}));
const defaultKeyMap$1 = [
  // alphanumeric keys
  ..."0123456789".split("").map((c7) => ({
    code: `Digit${c7}`,
    key: c7
  })),
  ...")!@#$%^&*(".split("").map((c7, i2) => ({
    code: `Digit${i2}`,
    key: c7,
    shiftKey: true
  })),
  ..."abcdefghijklmnopqrstuvwxyz".split("").map((c7) => ({
    code: `Key${c7.toUpperCase()}`,
    key: c7
  })),
  ..."ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((c7) => ({
    code: `Key${c7}`,
    key: c7,
    shiftKey: true
  })),
  // alphanumeric block - functional
  {
    code: "Space",
    key: " "
  },
  {
    code: "AltLeft",
    key: "Alt",
    location: DOM_KEY_LOCATION.LEFT
  },
  {
    code: "AltRight",
    key: "Alt",
    location: DOM_KEY_LOCATION.RIGHT
  },
  {
    code: "ShiftLeft",
    key: "Shift",
    location: DOM_KEY_LOCATION.LEFT
  },
  {
    code: "ShiftRight",
    key: "Shift",
    location: DOM_KEY_LOCATION.RIGHT
  },
  {
    code: "ControlLeft",
    key: "Control",
    location: DOM_KEY_LOCATION.LEFT
  },
  {
    code: "ControlRight",
    key: "Control",
    location: DOM_KEY_LOCATION.RIGHT
  },
  {
    code: "MetaLeft",
    key: "Meta",
    location: DOM_KEY_LOCATION.LEFT
  },
  {
    code: "MetaRight",
    key: "Meta",
    location: DOM_KEY_LOCATION.RIGHT
  },
  {
    code: "OSLeft",
    key: "OS",
    location: DOM_KEY_LOCATION.LEFT
  },
  {
    code: "OSRight",
    key: "OS",
    location: DOM_KEY_LOCATION.RIGHT
  },
  {
    code: "Tab",
    key: "Tab"
  },
  {
    code: "CapsLock",
    key: "CapsLock"
  },
  {
    code: "Backspace",
    key: "Backspace"
  },
  {
    code: "Enter",
    key: "Enter"
  },
  // function
  {
    code: "Escape",
    key: "Escape"
  },
  // arrows
  {
    code: "ArrowUp",
    key: "ArrowUp"
  },
  {
    code: "ArrowDown",
    key: "ArrowDown"
  },
  {
    code: "ArrowLeft",
    key: "ArrowLeft"
  },
  {
    code: "ArrowRight",
    key: "ArrowRight"
  },
  // control pad
  {
    code: "Home",
    key: "Home"
  },
  {
    code: "End",
    key: "End"
  },
  {
    code: "Delete",
    key: "Delete"
  },
  {
    code: "PageUp",
    key: "PageUp"
  },
  {
    code: "PageDown",
    key: "PageDown"
  },
  // Special keys that are not part of a default US-layout but included for specific behavior
  {
    code: "Fn",
    key: "Fn"
  },
  {
    code: "Symbol",
    key: "Symbol"
  },
  {
    code: "AltRight",
    key: "AltGraph"
  }
];
const defaultKeyMap = [
  {
    name: "MouseLeft",
    pointerType: "mouse",
    button: "primary"
  },
  {
    name: "MouseRight",
    pointerType: "mouse",
    button: "secondary"
  },
  {
    name: "MouseMiddle",
    pointerType: "mouse",
    button: "auxiliary"
  },
  {
    name: "TouchA",
    pointerType: "touch"
  },
  {
    name: "TouchB",
    pointerType: "touch"
  },
  {
    name: "TouchC",
    pointerType: "touch"
  }
];
({
  applyAccept: true,
  autoModify: true,
  delay: 0,
  document: globalThis.document,
  keyboardMap: defaultKeyMap$1,
  pointerMap: defaultKeyMap,
  pointerEventsCheck: PointerEventsCheckLevel.EachApiCall,
  skipAutoClose: false,
  skipClick: false,
  skipHover: false,
  writeToClipboard: false,
  advanceTimers: () => Promise.resolve()
});
const ErrorContext = createContext(void 0);
const ErrorContextProvider = ({
  handleError = void 0,
  children: children2
}) => {
  const contextValue = useMemo(() => ({ handleError }), [handleError]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorContext.Provider, { value: contextValue, children: children2 });
};
const defaultRenderFallback = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "h2", variant: "40", children: "An error has occurred" });
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      error: null
    });
  }
  componentDidCatch(error2) {
    var _a2;
    console.error(error2);
    const handleError = this.props.handleError ?? ((_a2 = this.context) == null ? void 0 : _a2.handleError);
    handleError == null ? void 0 : handleError(error2);
  }
  render() {
    const { children: children2, renderFallback } = this.props;
    const { error: error2 } = this.state;
    if (error2)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: renderFallback(error2) });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children2 });
  }
}
__publicField(ErrorBoundary, "getDerivedStateFromError", (error2) => ({ error: error2 }));
__publicField(ErrorBoundary, "contextType", ErrorContext);
__publicField(ErrorBoundary, "defaultProps", {
  children: null,
  handleError: null,
  renderFallback: defaultRenderFallback
});
const isMatchingSrc = (srcToMatch) => (srcToTest) => {
  return srcToTest.endsWith(srcToMatch);
};
const Src = ({
  sourcesWithError = [],
  srcSet,
  media = void 0,
  type: type2,
  ...restOfProps
}) => {
  if (sourcesWithError.some(isMatchingSrc(srcSet)))
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "source",
    {
      media,
      srcSet,
      type: type2,
      ...omit$1(restOfProps, "renderError", "renderLoading")
    }
  );
};
const Spinner2 = ({
  sx: sx2 = {},
  title = "Loading...",
  size = SpinnerSizes.default,
  variant: variant3 = SpinnerVariants.primary,
  ...restOfProps
}) => {
  const { style: style2, theme: theme2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Spinner$1,
    {
      size: theme2.sizes.spinner[size] || size,
      sx: style2({
        variant: `spinner.${variant3}`
      }),
      title,
      ...restOfProps
    }
  ) });
};
const Img = ({
  src,
  alt,
  sourcesWithError = [],
  renderLoading = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner2, {}),
  onLoad = noop$6,
  style: style2 = {},
  ...restOfProps
}) => {
  const [loaded, setLoaded] = useState(false);
  if (sourcesWithError.some(isMatchingSrc(src)))
    throw new Error(`Failed to load image at ${src}`);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "img",
      {
        alt,
        onLoad: (event2) => {
          setLoaded(true);
          onLoad == null ? void 0 : onLoad(event2);
        },
        src,
        style: loaded ? style2 : { display: "none" },
        ...restOfProps
      }
    ),
    !loaded && renderLoading()
  ] });
};
const Picture = ({
  children: children2,
  renderError,
  renderLoading,
  onError = noop$6,
  ...restOfProps
}) => {
  const [sourcesWithError, setSourcesWithError] = useState([]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBoundary, { renderFallback: renderError, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "picture",
    {
      "data-test-id": "picture",
      onError: (event2) => {
        const src = event2.target.currentSrc;
        setSourcesWithError((prev2) => [...prev2, src]);
        onError == null ? void 0 : onError(event2);
      },
      ...restOfProps,
      children: Children.toArray(children2).filter(Boolean).map((child) => {
        if (React__default.isValidElement(child)) {
          return cloneElement(child, {
            sourcesWithError,
            renderLoading
          });
        }
        return null;
      })
    }
  ) });
};
Picture.Src = Src;
Picture.Img = Img;
const Avatar = ({
  backgroundColor = "avatar.default.background",
  textColor = "avatar.default.text",
  title = "",
  icon: icon2 = void 0,
  imageUri = void 0,
  size = void 0,
  sx: sx2 = {},
  variant: variant3 = AvatarVariant.human,
  ...restOfProps
}) => {
  const [pictureStyle, setPictureStyle] = useState();
  useEffect(() => {
    imageUri && setPictureStyle({ width: "100%", height: "100%" });
  }, [imageUri]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => {
    const sizeBasedVariant = size === void 0 ? responsiveVariant(mediaQueries2, variant3) : sizedVariant(size, variant3);
    const defaultContent = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Span,
      {
        color: "inherit",
        sx: { fontWeight: "avatar" },
        variant: sizeBasedVariant.textVariant,
        children: title.substring(0, sizeBasedVariant.textLength).toUpperCase()
      }
    );
    let content2 = defaultContent;
    if (icon2) {
      content2 = React__default.cloneElement(icon2, { color: textColor });
    }
    if (imageUri) {
      content2 = /* @__PURE__ */ jsxRuntimeExports.jsx(
        Picture,
        {
          onError: () => setPictureStyle(void 0),
          renderError: () => defaultContent,
          renderLoading: () => null,
          style: pictureStyle,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Picture.Img,
            {
              alt: `avatar-${imageUri}`,
              src: imageUri,
              style: pictureStyle
            }
          )
        }
      );
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        sx: {
          backgroundColor,
          color: textColor,
          variant: sizeBasedVariant.variant,
          ...sx2
        },
        ...restOfProps,
        children: content2
      }
    );
  } });
};
const useAsyncError = () => {
  const [, setError] = useState(false);
  return useCallback(
    (e3) => {
      setError(() => {
        throw e3;
      });
    },
    [setError]
  );
};
function useLoading(action2, deps) {
  const [loading, setLoading] = useState(false);
  const throwError = useAsyncError();
  const isMounted = useRef(true);
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);
  const loadAction = useCallback(
    async (...args) => {
      const delayedLoad = debounce$3(() => {
        setLoading(true);
      }, Throttle.loading);
      try {
        delayedLoad();
        await (action2 == null ? void 0 : action2(...args));
        delayedLoad.cancel();
      } catch (e3) {
        throwError(e3);
        delayedLoad.cancel();
      } finally {
        if (isMounted.current) {
          setLoading(false);
        }
      }
    },
    deps || [action2]
  );
  return {
    loadAction,
    loading
  };
}
function jsx$1(type2, props2, key) {
  if (!hasOwn$3.call(props2, "css")) {
    return jsxRuntimeExports.jsx(type2, props2, key);
  }
  return jsxRuntimeExports.jsx(Emotion$1, createEmotionProps(type2, props2), key);
}
function jsxs$1(type2, props2, key) {
  if (!hasOwn$3.call(props2, "css")) {
    return jsxRuntimeExports.jsxs(type2, props2, key);
  }
  return jsxRuntimeExports.jsxs(Emotion$1, createEmotionProps(type2, props2), key);
}
const jsx2 = (type2, props2, key) => jsx$1(type2, parseProps(props2), key);
const jsxs = (type2, props2, key) => jsxs$1(type2, parseProps(props2), key);
const VisuallyHidden = ({
  children: children2 = null,
  id = void 0,
  isHidden: isHidden2 = true,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsx2(Box$1, { as: "span", id, sx: isHidden2 ? styles$q : {}, ...restOfProps, children: children2 });
};
const styles$q = {
  display: "inline-block",
  opacity: 0,
  position: "absolute",
  clip: "rect(0 0 0 0)",
  overflow: "hidden",
  padding: 0,
  border: 0,
  height: 1,
  width: 1,
  margin: -1
};
const ButtonContent = ({
  children: children2,
  shape,
  variant: variant3
}) => {
  if (shape !== "default") {
    return null;
  }
  if (children2) {
    if (variant3 === ButtonVariant.unstyled) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children2 });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Title,
      {
        as: "span",
        color: "inherit",
        sx: {
          lineHeight: "unset"
        },
        variant: "16",
        children: [
          variant3 === ButtonVariant.primary && /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, { children: "Primary Action" }),
          children2
        ]
      }
    );
  }
  return null;
};
var ButtonIconAlignment = /* @__PURE__ */ ((ButtonIconAlignment2) => {
  ButtonIconAlignment2["Left"] = "left";
  ButtonIconAlignment2["Right"] = "right";
  return ButtonIconAlignment2;
})(ButtonIconAlignment || {});
const Button2 = React__default.forwardRef(
  ({
    block = false,
    children: children2,
    disabled = false,
    icon: icon2 = void 0,
    iconAlignment = "left",
    isLoading = false,
    loadingSpinner = /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner2, { title: "Loading spinner" }),
    onClick = noop$6,
    shape = ButtonShape.default,
    size = ButtonSize.default,
    sx: sx2 = {},
    tooltip = "",
    variant: variant3 = ButtonVariant.primary,
    ...restOfProps
  }, ref2) => {
    const { loadAction, loading } = useLoading(onClick);
    const isLoadingState = (isLoading || loading) && Boolean(loadingSpinner);
    const isDisabled = disabled || isLoadingState;
    const hasTooltip = !!tooltip;
    const { style: style2 } = useStyle(sx2);
    const ButtonTooltipWrapper = useCallback(
      (mediaQueries2) => {
        return (children22) => CreateTooltip({
          children: children22,
          id: uniqueId$1("button-tool-tip-"),
          mediaQueries: mediaQueries2,
          tooltip,
          shape,
          block
        });
      },
      [shape, tooltip, block]
    );
    const clickButton = useCallback(
      (e3) => {
        loadingSpinner ? loadAction(e3) : onClick(e3);
      },
      [loadAction, loadingSpinner, onClick]
    );
    const onClickHandler = isDisabled ? noop$6 : clickButton;
    const isUsingLinkVariant = variant3.includes("links");
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        ConditionalWrapper,
        {
          condition: hasTooltip,
          wrapper: ButtonTooltipWrapper(mediaQueries2),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Button$1,
            {
              "aria-disabled": isDisabled,
              "data-button-shape": shape,
              "data-button-size": size,
              disabled: isDisabled,
              onClick: onClickHandler,
              ref: ref2,
              sx: !isUsingLinkVariant ? style2(
                styles$p.button(
                  size,
                  shape,
                  mediaQueries2,
                  isLoadingState,
                  variant3,
                  block
                )
              ) : style2(styles$p.reset),
              type: "button",
              variant: variant3,
              ...restOfProps,
              children: isUsingLinkVariant ? children2 : /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { sx: styles$p.childContainer(icon2, iconAlignment), children: [
                icon2 && cloneElement(icon2, {
                  sx: styles$p.icon(iconAlignment, shape)
                }),
                isLoadingState ? /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: styles$p.spinnerContainer(variant3), children: cloneElement(loadingSpinner, {
                  variant: spinnerVariantMap[variant3],
                  sx: {
                    color: "inherit"
                  }
                }) }) : null,
                /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonContent, { shape, variant: variant3, children: children2 })
              ] })
            }
          )
        }
      );
    } });
  }
);
const styles$p = {
  button: (size, shape, mediaQueries2, isLoading, variant3, block) => {
    const width = block || mediaQueries2.smDown ? "100%" : "auto";
    const loadingStyle = isLoading ? loadingStyles[variant3] : {};
    if (variant3 === ButtonVariant.back || variant3 === ButtonVariant.unstyled) {
      return {};
    }
    return {
      width: shape === ButtonShape.circle ? `button.${size}` : width,
      display: block ? "block" : "inline-block",
      ...loadingStyle
    };
  },
  childContainer: (icon2, iconAlignment) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    "&> span": {
      ...icon2 && {
        marginRight: iconAlignment === "right" && "clickables.withIcon.spacing",
        marginLeft: iconAlignment === "left" && "clickables.withIcon.spacing"
      }
    }
  }),
  spinnerContainer: (variant3) => ({
    position: "absolute",
    minWidth: "auto",
    maxWidth: "inherit",
    ...spinnerStyles[variant3]
  }),
  icon: (iconAlignment, shape) => shape === "default" ? {
    order: iconAlignment === "left" ? 0 : 1
  } : {
    minWidth: "auto",
    maxWidth: "inherit"
  },
  reset: { px: 0, py: 0, background: "none", fontWeight: "normal" }
};
const spinnerVariantMap = {
  [ButtonVariant.primary]: SpinnerVariants.primary,
  [ButtonVariant.secondary]: SpinnerVariants.secondary,
  [ButtonVariant.tertiary]: SpinnerVariants.secondary,
  [ButtonVariant.destructive]: SpinnerVariants.primary,
  [ButtonVariant.unstyled]: SpinnerVariants.secondary
};
const CreateTooltip = ({
  children: children2,
  id,
  mediaQueries: mediaQueries2,
  shape,
  tooltip = "",
  block
}) => {
  const tooltipStyle = {
    ...(block || mediaQueries2.smDown) && shape !== ButtonShape.circle ? { width: "100%" } : { maxWidth: "fit-content" }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Source, { "data-test-id": id, trigger: Triggers.hover, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "aria-labelledby": id, role: "tooltip", style: tooltipStyle, children: children2 }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tooltip.Content,
      {
        hideTail: true,
        placementOverride: {
          position: Alignment.bottom,
          positionAndAlignment: "bottom"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "aria-live": "polite", id, role: "tooltip", children: tooltip })
      }
    )
  ] });
};
const CompoundButton = Object.assign({}, Button2, {
  Back: ButtonVariant.back,
  Unstyled: ButtonVariant.unstyled,
  Primary: ButtonVariant.primary,
  Secondary: ButtonVariant.secondary,
  Tertiary: ButtonVariant.tertiary,
  Destructive: ButtonVariant.destructive
});
const BackButton = ({
  children: children2 = "Back",
  onClick,
  hideIcon = false,
  iconOnly = false,
  ...restOfProps
}) => {
  invariant$1(
    !(hideIcon && iconOnly),
    `hideIcon and iconOnly prop cannot both be set to true.`
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      ...restOfProps,
      icon: !hideIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          color: "currentColor",
          name: iconOnly ? "arrowLeft" : "chevronLeft",
          size: iconOnly ? IconSizes.Icon24 : IconSizes.Icon12
        }
      ) : void 0,
      onClick,
      variant: ButtonVariant.back,
      children: !iconOnly && children2
    }
  );
};
function cloneValidElement(element, props2) {
  return isValidElement(element) ? cloneElement(element, props2) : element;
}
function useEventCallback$1(eventHandler, onEvent, dependencies2 = []) {
  return useCallback(
    (event2) => {
      onEvent == null ? void 0 : onEvent(event2);
      eventHandler == null ? void 0 : eventHandler(event2);
    },
    dependencies2.concat([eventHandler])
  );
}
var isMergeableObject2 = function isMergeableObject3(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === "object";
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement$1(value);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement$1(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options2) {
  return options2.clone !== false && options2.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options2) : value;
}
function defaultArrayMerge(target, source, options2) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options2);
  });
}
function mergeObject(target, source, options2) {
  var destination = {};
  if (options2.isMergeableObject(target)) {
    Object.keys(target).forEach(function(key) {
      destination[key] = cloneUnlessOtherwiseSpecified(target[key], options2);
    });
  }
  Object.keys(source).forEach(function(key) {
    if (!options2.isMergeableObject(source[key]) || !target[key]) {
      destination[key] = cloneUnlessOtherwiseSpecified(source[key], options2);
    } else {
      destination[key] = deepmerge(target[key], source[key], options2);
    }
  });
  return destination;
}
function deepmerge(target, source, options2) {
  options2 = options2 || {};
  options2.arrayMerge = options2.arrayMerge || defaultArrayMerge;
  options2.isMergeableObject = options2.isMergeableObject || isMergeableObject2;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options2);
  } else if (sourceIsArray) {
    return options2.arrayMerge(target, source, options2);
  } else {
    return mergeObject(target, source, options2);
  }
}
deepmerge.all = function deepmergeAll2(array2, options2) {
  if (!Array.isArray(array2)) {
    throw new Error("first argument should be an array");
  }
  return array2.reduce(function(prev2, next2) {
    return deepmerge(prev2, next2, options2);
  }, {});
};
var deepmerge_1 = deepmerge;
var isArray$f = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType$4 = typeof Element !== "undefined";
function equal$4(a4, b10) {
  if (a4 === b10)
    return true;
  if (a4 && b10 && typeof a4 == "object" && typeof b10 == "object") {
    var arrA = isArray$f(a4), arrB = isArray$f(b10), i2, length2, key;
    if (arrA && arrB) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal$4(a4[i2], b10[i2]))
          return false;
      return true;
    }
    if (arrA != arrB)
      return false;
    var dateA = a4 instanceof Date, dateB = b10 instanceof Date;
    if (dateA != dateB)
      return false;
    if (dateA && dateB)
      return a4.getTime() == b10.getTime();
    var regexpA = a4 instanceof RegExp, regexpB = b10 instanceof RegExp;
    if (regexpA != regexpB)
      return false;
    if (regexpA && regexpB)
      return a4.toString() == b10.toString();
    var keys8 = keyList(a4);
    length2 = keys8.length;
    if (length2 !== keyList(b10).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!hasProp.call(b10, keys8[i2]))
        return false;
    if (hasElementType$4 && a4 instanceof Element && b10 instanceof Element)
      return a4 === b10;
    for (i2 = length2; i2-- !== 0; ) {
      key = keys8[i2];
      if (key === "_owner" && a4.$$typeof) {
        continue;
      } else {
        if (!equal$4(a4[key], b10[key]))
          return false;
      }
    }
    return true;
  }
  return a4 !== a4 && b10 !== b10;
}
var reactFastCompare$4 = function exportedEqual(a4, b10) {
  try {
    return equal$4(a4, b10);
  } catch (error2) {
    if (error2.message && error2.message.match(/stack|recursion/i) || error2.number === -2146828260) {
      console.warn("Warning: react-fast-compare does not handle circular references.", error2.name, error2.message);
      return false;
    }
    throw error2;
  }
};
const isEqual$8 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare$4);
var isProduction = process.env.NODE_ENV === "production";
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }
    var text2 = "Warning: " + message;
    if (typeof console !== "undefined") {
      console.warn(text2);
    }
    try {
      throw Error(text2);
    } catch (x3) {
    }
  }
}
function _extends$6() {
  _extends$6 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$6.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var FormikContext = /* @__PURE__ */ createContext(void 0);
FormikContext.displayName = "FormikContext";
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning(false) : void 0;
  return formik;
}
var isFunction$6 = function isFunction2(obj) {
  return typeof obj === "function";
};
var isObject$d = function isObject(obj) {
  return obj !== null && typeof obj === "object";
};
var isInteger = function isInteger2(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
var isString$3 = function isString2(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
};
var isEmptyChildren = function isEmptyChildren2(children2) {
  return Children.count(children2) === 0;
};
var isPromise = function isPromise2(value) {
  return isObject$d(value) && isFunction$6(value.then);
};
function getActiveElement$1(doc) {
  doc = doc || (typeof document !== "undefined" ? document : void 0);
  if (typeof doc === "undefined") {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e3) {
    return doc.body;
  }
}
function getIn$1(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }
  var path2 = toPath(key);
  while (obj && p < path2.length) {
    obj = obj[path2[p++]];
  }
  if (p !== path2.length && !obj) {
    return def;
  }
  return obj === void 0 ? def : obj;
}
function setIn(obj, path2, value) {
  var res = clone$1(obj);
  var resVal = res;
  var i2 = 0;
  var pathArray = toPath(path2);
  for (; i2 < pathArray.length - 1; i2++) {
    var currentPath = pathArray[i2];
    var currentObj = getIn$1(obj, pathArray.slice(0, i2 + 1));
    if (currentObj && (isObject$d(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone$1(currentObj);
    } else {
      var nextPath = pathArray[i2 + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }
  if ((i2 === 0 ? obj : resVal)[pathArray[i2]] === value) {
    return obj;
  }
  if (value === void 0) {
    delete resVal[pathArray[i2]];
  } else {
    resVal[pathArray[i2]] = value;
  }
  if (i2 === 0 && value === void 0) {
    delete res[pathArray[i2]];
  }
  return res;
}
function setNestedObjectValues(object2, value, visited, response) {
  if (visited === void 0) {
    visited = /* @__PURE__ */ new WeakMap();
  }
  if (response === void 0) {
    response = {};
  }
  for (var _i = 0, _Object$keys = Object.keys(object2); _i < _Object$keys.length; _i++) {
    var k3 = _Object$keys[_i];
    var val = object2[k3];
    if (isObject$d(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k3] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k3]);
      }
    } else {
      response[k3] = value;
    }
  }
  return response;
}
function formikReducer(state, msg) {
  switch (msg.type) {
    case "SET_VALUES":
      return _extends$6({}, state, {
        values: msg.payload
      });
    case "SET_TOUCHED":
      return _extends$6({}, state, {
        touched: msg.payload
      });
    case "SET_ERRORS":
      if (isEqual$8(state.errors, msg.payload)) {
        return state;
      }
      return _extends$6({}, state, {
        errors: msg.payload
      });
    case "SET_STATUS":
      return _extends$6({}, state, {
        status: msg.payload
      });
    case "SET_ISSUBMITTING":
      return _extends$6({}, state, {
        isSubmitting: msg.payload
      });
    case "SET_ISVALIDATING":
      return _extends$6({}, state, {
        isValidating: msg.payload
      });
    case "SET_FIELD_VALUE":
      return _extends$6({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });
    case "SET_FIELD_TOUCHED":
      return _extends$6({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });
    case "SET_FIELD_ERROR":
      return _extends$6({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });
    case "RESET_FORM":
      return _extends$6({}, state, msg.payload);
    case "SET_FORMIK_STATE":
      return msg.payload(state);
    case "SUBMIT_ATTEMPT":
      return _extends$6({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });
    case "SUBMIT_FAILURE":
      return _extends$6({}, state, {
        isSubmitting: false
      });
    case "SUBMIT_SUCCESS":
      return _extends$6({}, state, {
        isSubmitting: false
      });
    default:
      return state;
  }
}
var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref2) {
  var _ref$validateOnChange = _ref2.validateOnChange, validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange, _ref$validateOnBlur = _ref2.validateOnBlur, validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur, _ref$validateOnMount = _ref2.validateOnMount, validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount, isInitialValid = _ref2.isInitialValid, _ref$enableReinitiali = _ref2.enableReinitialize, enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali, onSubmit = _ref2.onSubmit, rest = _objectWithoutPropertiesLoose$2(_ref2, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);
  var props2 = _extends$6({
    validateOnChange,
    validateOnBlur,
    validateOnMount,
    onSubmit
  }, rest);
  var initialValues = useRef(props2.initialValues);
  var initialErrors = useRef(props2.initialErrors || emptyErrors);
  var initialTouched = useRef(props2.initialTouched || emptyTouched);
  var initialStatus = useRef(props2.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});
  if (process.env.NODE_ENV !== "production") {
    useEffect(function() {
      !(typeof isInitialValid === "undefined") ? process.env.NODE_ENV !== "production" ? warning(false, "isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.") : warning(false) : void 0;
    }, []);
  }
  useEffect(function() {
    isMounted.current = true;
    return function() {
      isMounted.current = false;
    };
  }, []);
  var _React$useState = useState(0), setIteration = _React$useState[1];
  var stateRef = useRef({
    values: props2.initialValues,
    errors: props2.initialErrors || emptyErrors,
    touched: props2.initialTouched || emptyTouched,
    status: props2.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  });
  var state = stateRef.current;
  var dispatch = useCallback(function(action2) {
    var prev2 = stateRef.current;
    stateRef.current = formikReducer(prev2, action2);
    if (prev2 !== stateRef.current)
      setIteration(function(x3) {
        return x3 + 1;
      });
  }, []);
  var runValidateHandler = useCallback(function(values6, field) {
    return new Promise(function(resolve, reject) {
      var maybePromisedErrors = props2.validate(values6, field);
      if (maybePromisedErrors == null) {
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function(errors) {
          resolve(errors || emptyErrors);
        }, function(actualException) {
          if (process.env.NODE_ENV !== "production") {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }
          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props2.validate]);
  var runValidationSchema = useCallback(function(values6, field) {
    var validationSchema2 = props2.validationSchema;
    var schema = isFunction$6(validationSchema2) ? validationSchema2(field) : validationSchema2;
    var promise = field && schema.validateAt ? schema.validateAt(field, values6) : validateYupSchema(values6, schema);
    return new Promise(function(resolve, reject) {
      promise.then(function() {
        resolve(emptyErrors);
      }, function(err) {
        if (err.name === "ValidationError") {
          resolve(yupToFormErrors(err));
        } else {
          if (process.env.NODE_ENV !== "production") {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }
          reject(err);
        }
      });
    });
  }, [props2.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function(field, value) {
    return new Promise(function(resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function(values6) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function(f) {
      return isFunction$6(fieldRegistry.current[f].validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f) {
      return runSingleFieldLevelValidation(f, getIn$1(values6, f));
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(fieldValidations).then(function(fieldErrorsList) {
      return fieldErrorsList.reduce(function(prev2, curr, index2) {
        if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") {
          return prev2;
        }
        if (curr) {
          prev2 = setIn(prev2, fieldKeysWithValidation[index2], curr);
        }
        return prev2;
      }, {});
    });
  }, [runSingleFieldLevelValidation]);
  var runAllValidations = useCallback(function(values6) {
    return Promise.all([runFieldLevelValidations(values6), props2.validationSchema ? runValidationSchema(values6) : {}, props2.validate ? runValidateHandler(values6) : {}]).then(function(_ref22) {
      var fieldErrors = _ref22[0], schemaErrors = _ref22[1], validateErrors = _ref22[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge
      });
      return combinedErrors;
    });
  }, [props2.validate, props2.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]);
  var validateFormWithHighPriority = useEventCallback(function(values6) {
    if (values6 === void 0) {
      values6 = state.values;
    }
    dispatch({
      type: "SET_ISVALIDATING",
      payload: true
    });
    return runAllValidations(values6).then(function(combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: "SET_ISVALIDATING",
          payload: false
        });
        dispatch({
          type: "SET_ERRORS",
          payload: combinedErrors
        });
      }
      return combinedErrors;
    });
  });
  useEffect(function() {
    if (validateOnMount && isMounted.current === true && isEqual$8(initialValues.current, props2.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function(nextState) {
    var values6 = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props2.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props2.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props2.initialStatus;
    initialValues.current = values6;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;
    var dispatchFn = function dispatchFn2() {
      dispatch({
        type: "RESET_FORM",
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors,
          touched,
          status,
          values: values6,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === "number" ? nextState.submitCount : 0
        }
      });
    };
    if (props2.onReset) {
      var maybePromisedOnReset = props2.onReset(state.values, imperativeMethods);
      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props2.initialErrors, props2.initialStatus, props2.initialTouched, props2.onReset]);
  useEffect(function() {
    if (isMounted.current === true && !isEqual$8(initialValues.current, props2.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props2.initialValues;
        resetForm();
        if (validateOnMount) {
          validateFormWithHighPriority(initialValues.current);
        }
      }
    }
  }, [enableReinitialize, props2.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function() {
    if (enableReinitialize && isMounted.current === true && !isEqual$8(initialErrors.current, props2.initialErrors)) {
      initialErrors.current = props2.initialErrors || emptyErrors;
      dispatch({
        type: "SET_ERRORS",
        payload: props2.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props2.initialErrors]);
  useEffect(function() {
    if (enableReinitialize && isMounted.current === true && !isEqual$8(initialTouched.current, props2.initialTouched)) {
      initialTouched.current = props2.initialTouched || emptyTouched;
      dispatch({
        type: "SET_TOUCHED",
        payload: props2.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props2.initialTouched]);
  useEffect(function() {
    if (enableReinitialize && isMounted.current === true && !isEqual$8(initialStatus.current, props2.initialStatus)) {
      initialStatus.current = props2.initialStatus;
      dispatch({
        type: "SET_STATUS",
        payload: props2.initialStatus
      });
    }
  }, [enableReinitialize, props2.initialStatus, props2.initialTouched]);
  var validateField = useEventCallback(function(name2) {
    if (fieldRegistry.current[name2] && isFunction$6(fieldRegistry.current[name2].validate)) {
      var value = getIn$1(state.values, name2);
      var maybePromise = fieldRegistry.current[name2].validate(value);
      if (isPromise(maybePromise)) {
        dispatch({
          type: "SET_ISVALIDATING",
          payload: true
        });
        return maybePromise.then(function(x3) {
          return x3;
        }).then(function(error2) {
          dispatch({
            type: "SET_FIELD_ERROR",
            payload: {
              field: name2,
              value: error2
            }
          });
          dispatch({
            type: "SET_ISVALIDATING",
            payload: false
          });
        });
      } else {
        dispatch({
          type: "SET_FIELD_ERROR",
          payload: {
            field: name2,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props2.validationSchema) {
      dispatch({
        type: "SET_ISVALIDATING",
        payload: true
      });
      return runValidationSchema(state.values, name2).then(function(x3) {
        return x3;
      }).then(function(error2) {
        dispatch({
          type: "SET_FIELD_ERROR",
          payload: {
            field: name2,
            value: getIn$1(error2, name2)
          }
        });
        dispatch({
          type: "SET_ISVALIDATING",
          payload: false
        });
      });
    }
    return Promise.resolve();
  });
  var registerField = useCallback(function(name2, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name2] = {
      validate
    };
  }, []);
  var unregisterField = useCallback(function(name2) {
    delete fieldRegistry.current[name2];
  }, []);
  var setTouched = useEventCallback(function(touched, shouldValidate) {
    dispatch({
      type: "SET_TOUCHED",
      payload: touched
    });
    var willValidate = shouldValidate === void 0 ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function(errors) {
    dispatch({
      type: "SET_ERRORS",
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function(values6, shouldValidate) {
    var resolvedValues = isFunction$6(values6) ? values6(state.values) : values6;
    dispatch({
      type: "SET_VALUES",
      payload: resolvedValues
    });
    var willValidate = shouldValidate === void 0 ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function(field, value) {
    dispatch({
      type: "SET_FIELD_ERROR",
      payload: {
        field,
        value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function(field, value, shouldValidate) {
    dispatch({
      type: "SET_FIELD_VALUE",
      payload: {
        field,
        value
      }
    });
    var willValidate = shouldValidate === void 0 ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = useCallback(function(eventOrTextValue, maybePath) {
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed;
    if (!isString$3(eventOrTextValue)) {
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }
      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type2 = target.type, name2 = target.name, id = target.id, value = target.value, checked = target.checked, outerHTML = target.outerHTML, options2 = target.options, multiple = target.multiple;
      field = maybePath ? maybePath : name2 ? name2 : id;
      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
          handlerName: "handleChange"
        });
      }
      val = /number|range/.test(type2) ? (parsed = parseFloat(value), isNaN(parsed) ? "" : parsed) : /checkbox/.test(type2) ? getValueForCheckbox(getIn$1(state.values, field), checked, value) : options2 && multiple ? getSelectedValues(options2) : value;
    }
    if (field) {
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function(eventOrPath) {
    if (isString$3(eventOrPath)) {
      return function(event2) {
        return executeChange(event2, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function(field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }
    dispatch({
      type: "SET_FIELD_TOUCHED",
      payload: {
        field,
        value: touched
      }
    });
    var willValidate = shouldValidate === void 0 ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function(e3, path2) {
    if (e3.persist) {
      e3.persist();
    }
    var _e$target = e3.target, name2 = _e$target.name, id = _e$target.id, outerHTML = _e$target.outerHTML;
    var field = path2 ? path2 : name2 ? name2 : id;
    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: "handleblur-e-any--void",
        handlerName: "handleBlur"
      });
    }
    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function(eventOrString) {
    if (isString$3(eventOrString)) {
      return function(event2) {
        return executeBlur(event2, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function(stateOrCb) {
    if (isFunction$6(stateOrCb)) {
      dispatch({
        type: "SET_FORMIK_STATE",
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: "SET_FORMIK_STATE",
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function(status) {
    dispatch({
      type: "SET_STATUS",
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function(isSubmitting) {
    dispatch({
      type: "SET_ISSUBMITTING",
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function() {
    dispatch({
      type: "SUBMIT_ATTEMPT"
    });
    return validateFormWithHighPriority().then(function(combinedErrors) {
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;
      if (isActuallyValid) {
        var promiseOrUndefined;
        try {
          promiseOrUndefined = executeSubmit();
          if (promiseOrUndefined === void 0) {
            return;
          }
        } catch (error2) {
          throw error2;
        }
        return Promise.resolve(promiseOrUndefined).then(function(result) {
          if (!!isMounted.current) {
            dispatch({
              type: "SUBMIT_SUCCESS"
            });
          }
          return result;
        })["catch"](function(_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: "SUBMIT_FAILURE"
            });
            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        dispatch({
          type: "SUBMIT_FAILURE"
        });
        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }
      return;
    });
  });
  var handleSubmit = useEventCallback(function(e3) {
    if (e3 && e3.preventDefault && isFunction$6(e3.preventDefault)) {
      e3.preventDefault();
    }
    if (e3 && e3.stopPropagation && isFunction$6(e3.stopPropagation)) {
      e3.stopPropagation();
    }
    if (process.env.NODE_ENV !== "production" && typeof document !== "undefined") {
      var activeElement = getActiveElement$1();
      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem("type")) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning(false) : void 0;
      }
    }
    submitForm()["catch"](function(reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm,
    validateForm: validateFormWithHighPriority,
    validateField,
    setErrors,
    setFieldError,
    setFieldTouched,
    setFieldValue,
    setStatus,
    setSubmitting,
    setTouched,
    setValues,
    setFormikState,
    submitForm
  };
  var executeSubmit = useEventCallback(function() {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function(e3) {
    if (e3 && e3.preventDefault && isFunction$6(e3.preventDefault)) {
      e3.preventDefault();
    }
    if (e3 && e3.stopPropagation && isFunction$6(e3.stopPropagation)) {
      e3.stopPropagation();
    }
    resetForm();
  });
  var getFieldMeta = useCallback(function(name2) {
    return {
      value: getIn$1(state.values, name2),
      error: getIn$1(state.errors, name2),
      touched: !!getIn$1(state.touched, name2),
      initialValue: getIn$1(initialValues.current, name2),
      initialTouched: !!getIn$1(initialTouched.current, name2),
      initialError: getIn$1(initialErrors.current, name2)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function(name2) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name2, value, shouldValidate);
      },
      setTouched: function setTouched2(value, shouldValidate) {
        return setFieldTouched(name2, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name2, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function(nameOrOptions) {
    var isAnObject = isObject$d(nameOrOptions);
    var name2 = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn$1(state.values, name2);
    var field = {
      name: name2,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };
    if (isAnObject) {
      var type2 = nameOrOptions.type, valueProp = nameOrOptions.value, is3 = nameOrOptions.as, multiple = nameOrOptions.multiple;
      if (type2 === "checkbox") {
        if (valueProp === void 0) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type2 === "radio") {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is3 === "select" && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }
    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function() {
    return !isEqual$8(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid2 = useMemo(function() {
    return typeof isInitialValid !== "undefined" ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction$6(isInitialValid) ? isInitialValid(props2) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props2]);
  var ctx2 = _extends$6({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur,
    handleChange,
    handleReset,
    handleSubmit,
    resetForm,
    setErrors,
    setFormikState,
    setFieldTouched,
    setFieldValue,
    setFieldError,
    setStatus,
    setSubmitting,
    setTouched,
    setValues,
    submitForm,
    validateForm: validateFormWithHighPriority,
    validateField,
    isValid: isValid2,
    dirty,
    unregisterField,
    registerField,
    getFieldProps,
    getFieldMeta,
    getFieldHelpers,
    validateOnBlur,
    validateOnChange,
    validateOnMount
  });
  return ctx2;
}
function Formik(props2) {
  var formikbag = useFormik(props2);
  var component = props2.component, children2 = props2.children, render = props2.render, innerRef = props2.innerRef;
  useImperativeHandle(innerRef, function() {
    return formikbag;
  });
  if (process.env.NODE_ENV !== "production") {
    useEffect(function() {
      !!props2.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning(false) : void 0;
    }, []);
  }
  return createElement(FormikProvider, {
    value: formikbag
  }, component ? createElement(component, formikbag) : render ? render(formikbag) : children2 ? isFunction$6(children2) ? children2(formikbag) : !isEmptyChildren(children2) ? Children.only(children2) : null : null);
}
function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent, documentationAnchorLink = _ref4.documentationAnchorLink, handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
  var errors = {};
  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }
    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
      var _ref5;
      if (_isArray) {
        if (_i >= _iterator.length)
          break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done)
          break;
        _ref5 = _i.value;
      }
      var err = _ref5;
      if (!getIn$1(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }
  return errors;
}
function validateYupSchema(values6, schema, sync2, context) {
  if (sync2 === void 0) {
    sync2 = false;
  }
  var normalizedValues = prepareDataForValidation(values6);
  return schema[sync2 ? "validateSync" : "validate"](normalizedValues, {
    abortEarly: false,
    context: context || normalizedValues
  });
}
function prepareDataForValidation(values6) {
  var data = Array.isArray(values6) ? [] : {};
  for (var k3 in values6) {
    if (Object.prototype.hasOwnProperty.call(values6, k3)) {
      var key = String(k3);
      if (Array.isArray(values6[key]) === true) {
        data[key] = values6[key].map(function(value) {
          if (Array.isArray(value) === true || isPlainObject$2(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== "" ? value : void 0;
          }
        });
      } else if (isPlainObject$2(values6[key])) {
        data[key] = prepareDataForValidation(values6[key]);
      } else {
        data[key] = values6[key] !== "" ? values6[key] : void 0;
      }
    }
  }
  return data;
}
function arrayMerge(target, source, options2) {
  var destination = target.slice();
  source.forEach(function merge3(e3, i2) {
    if (typeof destination[i2] === "undefined") {
      var cloneRequested = options2.clone !== false;
      var shouldClone = cloneRequested && options2.isMergeableObject(e3);
      destination[i2] = shouldClone ? deepmerge_1(Array.isArray(e3) ? [] : {}, e3, options2) : e3;
    } else if (options2.isMergeableObject(e3)) {
      destination[i2] = deepmerge_1(target[i2], e3, options2);
    } else if (target.indexOf(e3) === -1) {
      destination.push(e3);
    }
  });
  return destination;
}
function getSelectedValues(options2) {
  return Array.from(options2).filter(function(el) {
    return el.selected;
  }).map(function(el) {
    return el.value;
  });
}
function getValueForCheckbox(currentValue, checked, valueProp) {
  if (typeof currentValue === "boolean") {
    return Boolean(checked);
  }
  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index2 = -1;
  if (!Array.isArray(currentValue)) {
    if (!valueProp || valueProp == "true" || valueProp == "false") {
      return Boolean(checked);
    }
  } else {
    currentArrayOfValues = currentValue;
    index2 = currentValue.indexOf(valueProp);
    isValueInArray = index2 >= 0;
  }
  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  }
  if (!isValueInArray) {
    return currentArrayOfValues;
  }
  return currentArrayOfValues.slice(0, index2).concat(currentArrayOfValues.slice(index2 + 1));
}
var useIsomorphicLayoutEffect$2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;
function useEventCallback(fn2) {
  var ref2 = useRef(fn2);
  useIsomorphicLayoutEffect$2(function() {
    ref2.current = fn2;
  });
  return useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref2.current.apply(void 0, args);
  }, []);
}
var Form$1 = /* @__PURE__ */ forwardRef(function(props2, ref2) {
  var action2 = props2.action, rest = _objectWithoutPropertiesLoose$2(props2, ["action"]);
  var _action = action2 != null ? action2 : "#";
  var _useFormikContext = useFormikContext(), handleReset = _useFormikContext.handleReset, handleSubmit = _useFormikContext.handleSubmit;
  return createElement("form", _extends$6({
    onSubmit: handleSubmit,
    ref: ref2,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form$1.displayName = "Form";
const useGuiFormikContext = function() {
  const tmp = console.warn;
  console.warn = noop$6;
  const formik = useFormikContext();
  console.warn = tmp;
  return formik;
};
const GuiFormContext = React.createContext(
  void 0
);
const GuiFormCtxProvider = GuiFormContext.Provider;
GuiFormContext.Consumer;
function useGuiFormContext() {
  const ctx2 = React.useContext(GuiFormContext);
  invariant$1(
    !!ctx2,
    `GuiFormContext is undefined, please verify you are calling useGuiFormContext() as child of a <GuiFormCtxProvider> component.`
  );
  return ctx2;
}
const GuiFormMergedContext = React.createContext(
  void 0
);
const GuiFormMergedContextProvider = function({
  children: children2,
  formikProps
}) {
  const guiFormikContext = useGuiFormikContext();
  const guiFormContext = useGuiFormContext();
  const mergedContext = {
    ...guiFormikContext,
    ...guiFormContext
  };
  const mergedProps = {
    ...formikProps,
    ...guiFormContext
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GuiFormMergedContext.Provider, { value: mergedContext, children: typeof children2 === "function" ? children2(
    mergedProps
  ) : children2 });
};
function useGuiFormMergedContext() {
  const ctx2 = React.useContext(GuiFormMergedContext);
  const guiFormikContext = useGuiFormikContext();
  if (!guiFormikContext) {
    return void 0;
  }
  invariant$1(
    !!ctx2,
    `GuiFormMergedContext is undefined, please verify you are calling useGuiFormMergedContext() as child of a <GuiFormMergedContextProvider> component.`
  );
  return ctx2;
}
const useGuiForm = function() {
  return useGuiFormMergedContext();
};
const useGuiField = (field) => {
  const returnObject = {
    field: void 0,
    meta: void 0,
    helpers: void 0
  };
  const guiForm = useGuiForm();
  const isAnObject = field != null && typeof field === "object";
  const props2 = isAnObject ? field : { name: field };
  const { name: fieldName, validate: validateFn } = props2;
  React__default.useEffect(() => {
    if (fieldName) {
      guiForm == null ? void 0 : guiForm.registerField(fieldName, {
        validate: validateFn
      });
    }
    return () => {
      if (fieldName) {
        guiForm == null ? void 0 : guiForm.unregisterField(fieldName);
      }
    };
  }, [guiForm == null ? void 0 : guiForm.registerField, guiForm == null ? void 0 : guiForm.unregisterField, fieldName, validateFn]);
  React__default.useEffect(() => {
    return () => {
      if (fieldName) {
        guiForm == null ? void 0 : guiForm.setFieldValue(fieldName, void 0, false);
        guiForm == null ? void 0 : guiForm.setFieldError(fieldName, void 0);
        guiForm == null ? void 0 : guiForm.setFieldTouched(fieldName, false, false);
      }
    };
  }, []);
  if (guiForm && fieldName) {
    returnObject.field = guiForm.getFieldProps(props2);
    returnObject.meta = guiForm.getFieldMeta(fieldName);
    returnObject.helpers = guiForm.getFieldHelpers(fieldName);
  }
  return returnObject;
};
const useGuiFieldMeta = (fieldName) => {
  const guiForm = useGuiForm();
  if (guiForm && fieldName)
    return guiForm.getFieldMeta(fieldName);
  return {};
};
const useFieldVariant = (variant3, meta) => {
  const getVariant = useCallback(
    () => (meta == null ? void 0 : meta.error) && (meta == null ? void 0 : meta.touched) ? FormInputVariants.error : variant3,
    [variant3, meta]
  );
  return getVariant();
};
function isMutableRefObject(ref2) {
  return !!(ref2 && typeof ref2 === "object" && "current" in ref2);
}
const useFocusFirst = ({
  focusFirst,
  options: options2,
  formRef
}) => {
  const guiForm = useGuiForm();
  useEffect(() => {
    var _a2, _b;
    let current;
    if (isMutableRefObject(formRef)) {
      const { current: formRefCurrent } = formRef || {};
      current = formRefCurrent;
    }
    if (guiForm && current && focusFirst) {
      const FIELD_SELECTORS = [
        "input:not([type=hidden]):not([type=radio]):not([type=checkbox])",
        "select",
        "textarea"
      ];
      const form2 = current;
      const query = FIELD_SELECTORS.join(", ");
      const formElement = form2 == null ? void 0 : form2.querySelector(query);
      if (options2 == null ? void 0 : options2.preventScroll) {
        formElement == null ? void 0 : formElement.focus({ preventScroll: true });
      } else {
        const scrollIntoViewOpts = (options2 == null ? void 0 : options2.scrollIntoViewOptions) ?? { behavior: "smooth" };
        (_a2 = formElement == null ? void 0 : formElement.scrollIntoView) == null ? void 0 : _a2.call(formElement, scrollIntoViewOpts);
        (_b = formElement == null ? void 0 : formElement.focus) == null ? void 0 : _b.call(formElement, { preventScroll: true });
      }
    }
  }, [focusFirst, formRef]);
};
function isString$2(str) {
  return typeof str === "string" || str instanceof String;
}
function isObject$c(obj) {
  var _obj$constructor;
  return typeof obj === "object" && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === "Object";
}
function pick$1(obj, keys8) {
  if (Array.isArray(keys8))
    return pick$1(obj, (_, k3) => keys8.includes(k3));
  return Object.entries(obj).reduce((acc, _ref2) => {
    let [k3, v] = _ref2;
    if (keys8(v, k3))
      acc[k3] = v;
    return acc;
  }, {});
}
const DIRECTION = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return direction;
  }
}
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
}
function objectIncludes(b10, a4) {
  if (a4 === b10)
    return true;
  const arrA = Array.isArray(a4), arrB = Array.isArray(b10);
  let i2;
  if (arrA && arrB) {
    if (a4.length != b10.length)
      return false;
    for (i2 = 0; i2 < a4.length; i2++)
      if (!objectIncludes(a4[i2], b10[i2]))
        return false;
    return true;
  }
  if (arrA != arrB)
    return false;
  if (a4 && b10 && typeof a4 === "object" && typeof b10 === "object") {
    const dateA = a4 instanceof Date, dateB = b10 instanceof Date;
    if (dateA && dateB)
      return a4.getTime() == b10.getTime();
    if (dateA != dateB)
      return false;
    const regexpA = a4 instanceof RegExp, regexpB = b10 instanceof RegExp;
    if (regexpA && regexpB)
      return a4.toString() == b10.toString();
    if (regexpA != regexpB)
      return false;
    const keys8 = Object.keys(a4);
    for (i2 = 0; i2 < keys8.length; i2++)
      if (!Object.prototype.hasOwnProperty.call(b10, keys8[i2]))
        return false;
    for (i2 = 0; i2 < keys8.length; i2++)
      if (!objectIncludes(b10[keys8[i2]], a4[keys8[i2]]))
        return false;
    return true;
  } else if (a4 && b10 && typeof a4 === "function" && typeof b10 === "function") {
    return a4.toString() === b10.toString();
  }
  return false;
}
class ActionDetails {
  /** Current input value */
  /** Current cursor position */
  /** Old input value */
  /** Old selection */
  constructor(opts) {
    Object.assign(this, opts);
    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
    if (this.insertedCount) {
      while (this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end)) {
        if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end)
          ++this.oldSelection.end;
        else
          ++this.cursorPos;
      }
    }
  }
  /** Start changing position */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }
  /** Inserted symbols count */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }
  /** Inserted symbols */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }
  /** Removed symbols count */
  get removedCount() {
    return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
    this.oldValue.length - this.value.length, 0);
  }
  /** Removed symbols */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }
  /** Unchanged head symbols */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }
  /** Unchanged tail symbols */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }
  /** Remove direction */
  get removeDirection() {
    if (!this.removedCount || this.insertedCount)
      return DIRECTION.NONE;
    return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
  }
}
function IMask(el, opts) {
  return new IMask.InputMask(el, opts);
}
function maskedClass(mask) {
  if (mask == null)
    throw new Error("mask property should be defined");
  if (mask instanceof RegExp)
    return IMask.MaskedRegExp;
  if (isString$2(mask))
    return IMask.MaskedPattern;
  if (mask === Date)
    return IMask.MaskedDate;
  if (mask === Number)
    return IMask.MaskedNumber;
  if (Array.isArray(mask) || mask === Array)
    return IMask.MaskedDynamic;
  if (IMask.Masked && mask.prototype instanceof IMask.Masked)
    return mask;
  if (IMask.Masked && mask instanceof IMask.Masked)
    return mask.constructor;
  if (mask instanceof Function)
    return IMask.MaskedFunction;
  console.warn("Mask not found for mask", mask);
  return IMask.Masked;
}
function normalizeOpts(opts) {
  if (!opts)
    throw new Error("Options in not defined");
  if (IMask.Masked) {
    if (opts.prototype instanceof IMask.Masked)
      return {
        mask: opts
      };
    const {
      mask = void 0,
      ...instanceOpts
    } = opts instanceof IMask.Masked ? {
      mask: opts
    } : isObject$c(opts) && opts.mask instanceof IMask.Masked ? opts : {};
    if (mask) {
      const _mask = mask.mask;
      return {
        ...pick$1(mask, (_, k3) => !k3.startsWith("_")),
        mask: mask.constructor,
        _mask,
        ...instanceOpts
      };
    }
  }
  if (!isObject$c(opts))
    return {
      mask: opts
    };
  return {
    ...opts
  };
}
function createMask(opts) {
  if (IMask.Masked && opts instanceof IMask.Masked)
    return opts;
  const nOpts = normalizeOpts(opts);
  const MaskedClass = maskedClass(nOpts.mask);
  if (!MaskedClass)
    throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
  if (nOpts.mask === MaskedClass)
    delete nOpts.mask;
  if (nOpts._mask) {
    nOpts.mask = nOpts._mask;
    delete nOpts._mask;
  }
  return new MaskedClass(nOpts);
}
IMask.createMask = createMask;
class MaskElement {
  /** */
  /** */
  /** */
  /** Safely returns selection start */
  get selectionStart() {
    let start2;
    try {
      start2 = this._unsafeSelectionStart;
    } catch {
    }
    return start2 != null ? start2 : this.value.length;
  }
  /** Safely returns selection end */
  get selectionEnd() {
    let end2;
    try {
      end2 = this._unsafeSelectionEnd;
    } catch {
    }
    return end2 != null ? end2 : this.value.length;
  }
  /** Safely sets element selection */
  select(start2, end2) {
    if (start2 == null || end2 == null || start2 === this.selectionStart && end2 === this.selectionEnd)
      return;
    try {
      this._unsafeSelect(start2, end2);
    } catch {
    }
  }
  /** */
  get isActive() {
    return false;
  }
  /** */
  /** */
  /** */
}
IMask.MaskElement = MaskElement;
const KEY_Z = 90;
const KEY_Y = 89;
class HTMLMaskElement extends MaskElement {
  /** HTMLElement to use mask on */
  constructor(input2) {
    super();
    this.input = input2;
    this._onKeydown = this._onKeydown.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onBeforeinput = this._onBeforeinput.bind(this);
    this._onCompositionEnd = this._onCompositionEnd.bind(this);
  }
  get rootElement() {
    var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
    return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
  }
  /** Is element in focus */
  get isActive() {
    return this.input === this.rootElement.activeElement;
  }
  /** Binds HTMLElement events to mask internal events */
  bindEvents(handlers) {
    this.input.addEventListener("keydown", this._onKeydown);
    this.input.addEventListener("input", this._onInput);
    this.input.addEventListener("beforeinput", this._onBeforeinput);
    this.input.addEventListener("compositionend", this._onCompositionEnd);
    this.input.addEventListener("drop", handlers.drop);
    this.input.addEventListener("click", handlers.click);
    this.input.addEventListener("focus", handlers.focus);
    this.input.addEventListener("blur", handlers.commit);
    this._handlers = handlers;
  }
  _onKeydown(e3) {
    if (this._handlers.redo && (e3.keyCode === KEY_Z && e3.shiftKey && (e3.metaKey || e3.ctrlKey) || e3.keyCode === KEY_Y && e3.ctrlKey)) {
      e3.preventDefault();
      return this._handlers.redo(e3);
    }
    if (this._handlers.undo && e3.keyCode === KEY_Z && (e3.metaKey || e3.ctrlKey)) {
      e3.preventDefault();
      return this._handlers.undo(e3);
    }
    if (!e3.isComposing)
      this._handlers.selectionChange(e3);
  }
  _onBeforeinput(e3) {
    if (e3.inputType === "historyUndo" && this._handlers.undo) {
      e3.preventDefault();
      return this._handlers.undo(e3);
    }
    if (e3.inputType === "historyRedo" && this._handlers.redo) {
      e3.preventDefault();
      return this._handlers.redo(e3);
    }
  }
  _onCompositionEnd(e3) {
    this._handlers.input(e3);
  }
  _onInput(e3) {
    if (!e3.isComposing)
      this._handlers.input(e3);
  }
  /** Unbinds HTMLElement events to mask internal events */
  unbindEvents() {
    this.input.removeEventListener("keydown", this._onKeydown);
    this.input.removeEventListener("input", this._onInput);
    this.input.removeEventListener("beforeinput", this._onBeforeinput);
    this.input.removeEventListener("compositionend", this._onCompositionEnd);
    this.input.removeEventListener("drop", this._handlers.drop);
    this.input.removeEventListener("click", this._handlers.click);
    this.input.removeEventListener("focus", this._handlers.focus);
    this.input.removeEventListener("blur", this._handlers.commit);
    this._handlers = {};
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;
class HTMLInputMaskElement extends HTMLMaskElement {
  /** InputElement to use mask on */
  constructor(input2) {
    super(input2);
    this.input = input2;
  }
  /** Returns InputElement selection start */
  get _unsafeSelectionStart() {
    return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
  }
  /** Returns InputElement selection end */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }
  /** Sets InputElement selection */
  _unsafeSelect(start2, end2) {
    this.input.setSelectionRange(start2, end2);
  }
  get value() {
    return this.input.value;
  }
  set value(value) {
    this.input.value = value;
  }
}
IMask.HTMLMaskElement = HTMLMaskElement;
class HTMLContenteditableMaskElement extends HTMLMaskElement {
  /** Returns HTMLElement selection start */
  get _unsafeSelectionStart() {
    const root2 = this.rootElement;
    const selection = root2.getSelection && root2.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }
  /** Returns HTMLElement selection end */
  get _unsafeSelectionEnd() {
    const root2 = this.rootElement;
    const selection = root2.getSelection && root2.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }
  /** Sets HTMLElement selection */
  _unsafeSelect(start2, end2) {
    if (!this.rootElement.createRange)
      return;
    const range2 = this.rootElement.createRange();
    range2.setStart(this.input.firstChild || this.input, start2);
    range2.setEnd(this.input.lastChild || this.input, end2);
    const root2 = this.rootElement;
    const selection = root2.getSelection && root2.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range2);
    }
  }
  /** HTMLElement value */
  get value() {
    return this.input.textContent || "";
  }
  set value(value) {
    this.input.textContent = value;
  }
}
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;
class InputHistory {
  constructor() {
    this.states = [];
    this.currentIndex = 0;
  }
  get currentState() {
    return this.states[this.currentIndex];
  }
  get isEmpty() {
    return this.states.length === 0;
  }
  push(state) {
    if (this.currentIndex < this.states.length - 1)
      this.states.length = this.currentIndex + 1;
    this.states.push(state);
    if (this.states.length > InputHistory.MAX_LENGTH)
      this.states.shift();
    this.currentIndex = this.states.length - 1;
  }
  go(steps2) {
    this.currentIndex = Math.min(Math.max(this.currentIndex + steps2, 0), this.states.length - 1);
    return this.currentState;
  }
  undo() {
    return this.go(-1);
  }
  redo() {
    return this.go(1);
  }
  clear() {
    this.states.length = 0;
    this.currentIndex = 0;
  }
}
InputHistory.MAX_LENGTH = 100;
class InputMask {
  /**
    View element
  */
  /** Internal {@link Masked} model */
  constructor(el, opts) {
    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== "INPUT" && el.tagName !== "TEXTAREA" ? new HTMLContenteditableMaskElement(el) : new HTMLInputMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = "";
    this._unmaskedValue = "";
    this._rawInputValue = "";
    this.history = new InputHistory();
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onUndo = this._onUndo.bind(this);
    this._onRedo = this._onRedo.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
    this._bindEvents();
    this.updateValue();
    this._onChange();
  }
  maskEquals(mask) {
    var _this$masked;
    return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
  }
  /** Masked */
  get mask() {
    return this.masked.mask;
  }
  set mask(mask) {
    if (this.maskEquals(mask))
      return;
    if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
      this.masked.updateOptions({
        mask
      });
      return;
    }
    const masked = mask instanceof IMask.Masked ? mask : createMask({
      mask
    });
    masked.unmaskedValue = this.masked.unmaskedValue;
    this.masked = masked;
  }
  /** Raw value */
  get value() {
    return this._value;
  }
  set value(str) {
    if (this.value === str)
      return;
    this.masked.value = str;
    this.updateControl("auto");
  }
  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(str) {
    if (this.unmaskedValue === str)
      return;
    this.masked.unmaskedValue = str;
    this.updateControl("auto");
  }
  /** Raw input value */
  get rawInputValue() {
    return this._rawInputValue;
  }
  set rawInputValue(str) {
    if (this.rawInputValue === str)
      return;
    this.masked.rawInputValue = str;
    this.updateControl();
    this.alignCursor();
  }
  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(val) {
    if (this.masked.typedValueEquals(val))
      return;
    this.masked.typedValue = val;
    this.updateControl("auto");
  }
  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }
  /** Starts listening to element events */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange,
      undo: this._onUndo,
      redo: this._onRedo
    });
  }
  /** Stops listening to element events */
  _unbindEvents() {
    if (this.el)
      this.el.unbindEvents();
  }
  /** Fires custom event */
  _fireEvent(ev, e3) {
    const listeners = this._listeners[ev];
    if (!listeners)
      return;
    listeners.forEach((l) => l(e3));
  }
  /** Current selection start */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }
  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(pos) {
    if (!this.el || !this.el.isActive)
      return;
    this.el.select(pos, pos);
    this._saveSelection();
  }
  /** Stores current selection */
  _saveSelection() {
    if (this.displayValue !== this.el.value) {
      console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.");
    }
    this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }
  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value;
    this._value = this.masked.value;
  }
  /** Syncronizes view from model value, fires change events */
  updateControl(cursorPos) {
    const newUnmaskedValue = this.masked.unmaskedValue;
    const newValue = this.masked.value;
    const newRawInputValue = this.masked.rawInputValue;
    const newDisplayValue = this.displayValue;
    const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
    this._unmaskedValue = newUnmaskedValue;
    this._value = newValue;
    this._rawInputValue = newRawInputValue;
    if (this.el.value !== newDisplayValue)
      this.el.value = newDisplayValue;
    if (cursorPos === "auto")
      this.alignCursor();
    else if (cursorPos != null)
      this.cursorPos = cursorPos;
    if (isChanged)
      this._fireChangeEvents();
    if (!this._historyChanging && (isChanged || this.history.isEmpty))
      this.history.push({
        unmaskedValue: newUnmaskedValue,
        selection: {
          start: this.selectionStart,
          end: this.cursorPos
        }
      });
  }
  /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */
  updateOptions(opts) {
    const {
      mask,
      ...restOpts
    } = opts;
    const updateMask = !this.maskEquals(mask);
    const updateOpts = this.masked.optionsIsChanged(restOpts);
    if (updateMask)
      this.mask = mask;
    if (updateOpts)
      this.masked.updateOptions(restOpts);
    if (updateMask || updateOpts)
      this.updateControl();
  }
  /** Updates cursor */
  updateCursor(cursorPos) {
    if (cursorPos == null)
      return;
    this.cursorPos = cursorPos;
    this._delayUpdateCursor(cursorPos);
  }
  /** Delays cursor update to support mobile browsers */
  _delayUpdateCursor(cursorPos) {
    this._abortUpdateCursor();
    this._changingCursorPos = cursorPos;
    this._cursorChanging = setTimeout(() => {
      if (!this.el)
        return;
      this.cursorPos = this._changingCursorPos;
      this._abortUpdateCursor();
    }, 10);
  }
  /** Fires custom events */
  _fireChangeEvents() {
    this._fireEvent("accept", this._inputEvent);
    if (this.masked.isComplete)
      this._fireEvent("complete", this._inputEvent);
  }
  /** Aborts delayed cursor update */
  _abortUpdateCursor() {
    if (this._cursorChanging) {
      clearTimeout(this._cursorChanging);
      delete this._cursorChanging;
    }
  }
  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
  }
  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    if (this.selectionStart !== this.cursorPos)
      return;
    this.alignCursor();
  }
  /** Adds listener on custom event */
  on(ev, handler) {
    if (!this._listeners[ev])
      this._listeners[ev] = [];
    this._listeners[ev].push(handler);
    return this;
  }
  /** Removes custom event listener */
  off(ev, handler) {
    if (!this._listeners[ev])
      return this;
    if (!handler) {
      delete this._listeners[ev];
      return this;
    }
    const hIndex = this._listeners[ev].indexOf(handler);
    if (hIndex >= 0)
      this._listeners[ev].splice(hIndex, 1);
    return this;
  }
  /** Handles view input event */
  _onInput(e3) {
    this._inputEvent = e3;
    this._abortUpdateCursor();
    const details = new ActionDetails({
      // new state
      value: this.el.value,
      cursorPos: this.cursorPos,
      // old state
      oldValue: this.displayValue,
      oldSelection: this._selection
    });
    const oldRawValue = this.masked.rawInputValue;
    const offset2 = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
      input: true,
      raw: true
    }).offset;
    const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
    let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset2, removeDirection);
    if (removeDirection !== DIRECTION.NONE)
      cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
    this.updateControl(cursorPos);
    delete this._inputEvent;
  }
  /** Handles view change event and commits model value */
  _onChange() {
    if (this.displayValue !== this.el.value) {
      this.updateValue();
    }
    this.masked.doCommit();
    this.updateControl();
    this._saveSelection();
  }
  /** Handles view drop event, prevents by default */
  _onDrop(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }
  /** Restore last selection on focus */
  _onFocus(ev) {
    this.alignCursorFriendly();
  }
  /** Restore last selection on focus */
  _onClick(ev) {
    this.alignCursorFriendly();
  }
  _onUndo() {
    this._applyHistoryState(this.history.undo());
  }
  _onRedo() {
    this._applyHistoryState(this.history.redo());
  }
  _applyHistoryState(state) {
    if (!state)
      return;
    this._historyChanging = true;
    this.unmaskedValue = state.unmaskedValue;
    this.el.select(state.selection.start, state.selection.end);
    this._saveSelection();
    this._historyChanging = false;
  }
  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents();
    this._listeners.length = 0;
    delete this.el;
  }
}
IMask.InputMask = InputMask;
class ChangeDetails {
  /** Inserted symbols */
  /** Additional offset if any changes occurred before tail */
  /** Raw inserted is used by dynamic mask */
  /** Can skip chars */
  static normalize(prep) {
    return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
  }
  constructor(details) {
    Object.assign(this, {
      inserted: "",
      rawInserted: "",
      tailShift: 0,
      skip: false
    }, details);
  }
  /** Aggregate changes */
  aggregate(details) {
    this.inserted += details.inserted;
    this.rawInserted += details.rawInserted;
    this.tailShift += details.tailShift;
    this.skip = this.skip || details.skip;
    return this;
  }
  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
  get consumed() {
    return Boolean(this.rawInserted) || this.skip;
  }
  equals(details) {
    return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
  }
}
IMask.ChangeDetails = ChangeDetails;
class ContinuousTailDetails {
  /** Tail value as string */
  /** Tail start position */
  /** Start position */
  constructor(value, from2, stop2) {
    if (value === void 0) {
      value = "";
    }
    if (from2 === void 0) {
      from2 = 0;
    }
    this.value = value;
    this.from = from2;
    this.stop = stop2;
  }
  toString() {
    return this.value;
  }
  extend(tail) {
    this.value += String(tail);
  }
  appendTo(masked) {
    return masked.append(this.toString(), {
      tail: true
    }).aggregate(masked._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
  unshift(beforePos) {
    if (!this.value.length || beforePos != null && this.from >= beforePos)
      return "";
    const shiftChar = this.value[0];
    this.value = this.value.slice(1);
    return shiftChar;
  }
  shift() {
    if (!this.value.length)
      return "";
    const shiftChar = this.value[this.value.length - 1];
    this.value = this.value.slice(0, -1);
    return shiftChar;
  }
}
class Masked {
  /** */
  /** */
  /** Transforms value before mask processing */
  /** Transforms each char before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing at the end of editing */
  /** Format typed value to string */
  /** Parse string to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** */
  constructor(opts) {
    this._value = "";
    this._update({
      ...Masked.DEFAULTS,
      ...opts
    });
    this._initialized = true;
  }
  /** Sets and applies new options */
  updateOptions(opts) {
    if (!this.optionsIsChanged(opts))
      return;
    this.withValueRefresh(this._update.bind(this, opts));
  }
  /** Sets new options */
  _update(opts) {
    Object.assign(this, opts);
  }
  /** Mask state */
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(state) {
    this._value = state._value;
  }
  /** Resets value */
  reset() {
    this._value = "";
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this.resolve(value, {
      input: true
    });
  }
  /** Resolve new value */
  resolve(value, flags3) {
    if (flags3 === void 0) {
      flags3 = {
        input: true
      };
    }
    this.reset();
    this.append(value, flags3, "");
    this.doCommit();
  }
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(value) {
    this.resolve(value, {});
  }
  get typedValue() {
    return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
  }
  set typedValue(value) {
    if (this.format) {
      this.value = this.format(value, this);
    } else {
      this.unmaskedValue = String(value);
    }
  }
  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.displayValue.length, {
      raw: true
    });
  }
  set rawInputValue(value) {
    this.resolve(value, {
      raw: true
    });
  }
  get displayValue() {
    return this.value;
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return this.isComplete;
  }
  /** Finds nearest input position in direction */
  nearestInputPos(cursorPos, direction) {
    return cursorPos;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return Math.min(this.displayValue.length, toPos - fromPos);
  }
  /** Extracts value in range considering flags */
  extractInput(fromPos, toPos, flags3) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return this.displayValue.slice(fromPos, toPos);
  }
  /** Extracts tail in range */
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
  }
  /** Appends tail */
  appendTail(tail) {
    if (isString$2(tail))
      tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  /** Appends char */
  _appendCharRaw(ch, flags3) {
    if (!ch)
      return new ChangeDetails();
    this._value += ch;
    return new ChangeDetails({
      inserted: ch,
      rawInserted: ch
    });
  }
  /** Appends char */
  _appendChar(ch, flags3, checkTail) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const consistentState = this.state;
    let details;
    [ch, details] = this.doPrepareChar(ch, flags3);
    if (ch) {
      details = details.aggregate(this._appendCharRaw(ch, flags3));
      if (!details.rawInserted && this.autofix === "pad") {
        const noFixState = this.state;
        this.state = consistentState;
        let fixDetails = this.pad(flags3);
        const chDetails = this._appendCharRaw(ch, flags3);
        fixDetails = fixDetails.aggregate(chDetails);
        if (chDetails.rawInserted || fixDetails.equals(details)) {
          details = fixDetails;
        } else {
          this.state = noFixState;
        }
      }
    }
    if (details.inserted) {
      let consistentTail;
      let appended = this.doValidate(flags3) !== false;
      if (appended && checkTail != null) {
        const beforeTailState = this.state;
        if (this.overwrite === true) {
          consistentTail = checkTail.state;
          for (let i2 = 0; i2 < details.rawInserted.length; ++i2) {
            checkTail.unshift(this.displayValue.length - details.tailShift);
          }
        }
        let tailDetails = this.appendTail(checkTail);
        appended = tailDetails.rawInserted.length === checkTail.toString().length;
        if (!(appended && tailDetails.inserted) && this.overwrite === "shift") {
          this.state = beforeTailState;
          consistentTail = checkTail.state;
          for (let i2 = 0; i2 < details.rawInserted.length; ++i2) {
            checkTail.shift();
          }
          tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted.length === checkTail.toString().length;
        }
        if (appended && tailDetails.inserted)
          this.state = beforeTailState;
      }
      if (!appended) {
        details = new ChangeDetails();
        this.state = consistentState;
        if (checkTail && consistentTail)
          checkTail.state = consistentTail;
      }
    }
    return details;
  }
  /** Appends optional placeholder at the end */
  _appendPlaceholder() {
    return new ChangeDetails();
  }
  /** Appends optional eager placeholder at the end */
  _appendEager() {
    return new ChangeDetails();
  }
  /** Appends symbols considering flags */
  append(str, flags3, tail) {
    if (!isString$2(str))
      throw new Error("value should be string");
    const checkTail = isString$2(tail) ? new ContinuousTailDetails(String(tail)) : tail;
    if (flags3 != null && flags3.tail)
      flags3._beforeTailState = this.state;
    let details;
    [str, details] = this.doPrepare(str, flags3);
    for (let ci = 0; ci < str.length; ++ci) {
      const d3 = this._appendChar(str[ci], flags3, checkTail);
      if (!d3.rawInserted && !this.doSkipInvalid(str[ci], flags3, checkTail))
        break;
      details.aggregate(d3);
    }
    if ((this.eager === true || this.eager === "append") && flags3 != null && flags3.input && str) {
      details.aggregate(this._appendEager());
    }
    if (checkTail != null) {
      details.tailShift += this.appendTail(checkTail).tailShift;
    }
    return details;
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
    return new ChangeDetails();
  }
  /** Calls function and reapplies current value */
  withValueRefresh(fn2) {
    if (this._refreshing || !this._initialized)
      return fn2();
    this._refreshing = true;
    const rawInput = this.rawInputValue;
    const value = this.value;
    const ret = fn2();
    this.rawInputValue = rawInput;
    if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
      this.append(value.slice(this.displayValue.length), {}, "");
      this.doCommit();
    }
    delete this._refreshing;
    return ret;
  }
  runIsolated(fn2) {
    if (this._isolated || !this._initialized)
      return fn2(this);
    this._isolated = true;
    const state = this.state;
    const ret = fn2(this);
    this.state = state;
    delete this._isolated;
    return ret;
  }
  doSkipInvalid(ch, flags3, checkTail) {
    return Boolean(this.skipInvalid);
  }
  /** Prepares string before mask processing */
  doPrepare(str, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    return ChangeDetails.normalize(this.prepare ? this.prepare(str, this, flags3) : str);
  }
  /** Prepares each char before mask processing */
  doPrepareChar(str, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    return ChangeDetails.normalize(this.prepareChar ? this.prepareChar(str, this, flags3) : str);
  }
  /** Validates if value is acceptable */
  doValidate(flags3) {
    return (!this.validate || this.validate(this.value, this, flags3)) && (!this.parent || this.parent.doValidate(flags3));
  }
  /** Does additional processing at the end of editing */
  doCommit() {
    if (this.commit)
      this.commit(this.value, this);
  }
  splice(start2, deleteCount, inserted, removeDirection, flags3) {
    if (inserted === void 0) {
      inserted = "";
    }
    if (removeDirection === void 0) {
      removeDirection = DIRECTION.NONE;
    }
    if (flags3 === void 0) {
      flags3 = {
        input: true
      };
    }
    const tailPos = start2 + deleteCount;
    const tail = this.extractTail(tailPos);
    const eagerRemove = this.eager === true || this.eager === "remove";
    let oldRawValue;
    if (eagerRemove) {
      removeDirection = forceDirection(removeDirection);
      oldRawValue = this.extractInput(0, tailPos, {
        raw: true
      });
    }
    let startChangePos = start2;
    const details = new ChangeDetails();
    if (removeDirection !== DIRECTION.NONE) {
      startChangePos = this.nearestInputPos(start2, deleteCount > 1 && start2 !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection);
      details.tailShift = startChangePos - start2;
    }
    details.aggregate(this.remove(startChangePos));
    if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
      if (removeDirection === DIRECTION.FORCE_LEFT) {
        let valLength;
        while (oldRawValue === this.rawInputValue && (valLength = this.displayValue.length)) {
          details.aggregate(new ChangeDetails({
            tailShift: -1
          })).aggregate(this.remove(valLength - 1));
        }
      } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
        tail.unshift();
      }
    }
    return details.aggregate(this.append(inserted, flags3, tail));
  }
  maskEquals(mask) {
    return this.mask === mask;
  }
  optionsIsChanged(opts) {
    return !objectIncludes(this, opts);
  }
  typedValueEquals(value) {
    const tval = this.typedValue;
    return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
  }
  pad(flags3) {
    return new ChangeDetails();
  }
}
Masked.DEFAULTS = {
  skipInvalid: true
};
Masked.EMPTY_VALUES = [void 0, null, ""];
IMask.Masked = Masked;
class ChunksTailDetails {
  /** */
  constructor(chunks, from2) {
    if (chunks === void 0) {
      chunks = [];
    }
    if (from2 === void 0) {
      from2 = 0;
    }
    this.chunks = chunks;
    this.from = from2;
  }
  toString() {
    return this.chunks.map(String).join("");
  }
  extend(tailChunk) {
    if (!String(tailChunk))
      return;
    tailChunk = isString$2(tailChunk) ? new ContinuousTailDetails(String(tailChunk)) : tailChunk;
    const lastChunk = this.chunks[this.chunks.length - 1];
    const extendLast = lastChunk && // if stops are same or tail has no stop
    (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
    tailChunk.from === lastChunk.from + lastChunk.toString().length;
    if (tailChunk instanceof ContinuousTailDetails) {
      if (extendLast) {
        lastChunk.extend(tailChunk.toString());
      } else {
        this.chunks.push(tailChunk);
      }
    } else if (tailChunk instanceof ChunksTailDetails) {
      if (tailChunk.stop == null) {
        let firstTailChunk;
        while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
          firstTailChunk = tailChunk.chunks.shift();
          firstTailChunk.from += tailChunk.from;
          this.extend(firstTailChunk);
        }
      }
      if (tailChunk.toString()) {
        tailChunk.stop = tailChunk.blockIndex;
        this.chunks.push(tailChunk);
      }
    }
  }
  appendTo(masked) {
    if (!(masked instanceof IMask.MaskedPattern)) {
      const tail = new ContinuousTailDetails(this.toString());
      return tail.appendTo(masked);
    }
    const details = new ChangeDetails();
    for (let ci = 0; ci < this.chunks.length; ++ci) {
      const chunk = this.chunks[ci];
      const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
      const stop2 = chunk.stop;
      let chunkBlock;
      if (stop2 != null && // if block not found or stop is behind lastBlock
      (!lastBlockIter || lastBlockIter.index <= stop2)) {
        if (chunk instanceof ChunksTailDetails || // for continuous block also check if stop is exist
        masked._stops.indexOf(stop2) >= 0) {
          details.aggregate(masked._appendPlaceholder(stop2));
        }
        chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop2];
      }
      if (chunkBlock) {
        const tailDetails = chunkBlock.appendTail(chunk);
        details.aggregate(tailDetails);
        const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
        if (remainChars)
          details.aggregate(masked.append(remainChars, {
            tail: true
          }));
      } else {
        details.aggregate(masked.append(chunk.toString(), {
          tail: true
        }));
      }
    }
    return details;
  }
  get state() {
    return {
      chunks: this.chunks.map((c7) => c7.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(state) {
    const {
      chunks,
      ...props2
    } = state;
    Object.assign(this, props2);
    this.chunks = chunks.map((cstate) => {
      const chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
      chunk.state = cstate;
      return chunk;
    });
  }
  unshift(beforePos) {
    if (!this.chunks.length || beforePos != null && this.from >= beforePos)
      return "";
    const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
    let ci = 0;
    while (ci < this.chunks.length) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.unshift(chunkShiftPos);
      if (chunk.toString()) {
        if (!shiftChar)
          break;
        ++ci;
      } else {
        this.chunks.splice(ci, 1);
      }
      if (shiftChar)
        return shiftChar;
    }
    return "";
  }
  shift() {
    if (!this.chunks.length)
      return "";
    let ci = this.chunks.length - 1;
    while (0 <= ci) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.shift();
      if (chunk.toString()) {
        if (!shiftChar)
          break;
        --ci;
      } else {
        this.chunks.splice(ci, 1);
      }
      if (shiftChar)
        return shiftChar;
    }
    return "";
  }
}
class PatternCursor {
  constructor(masked, pos) {
    this.masked = masked;
    this._log = [];
    const {
      offset: offset2,
      index: index2
    } = masked._mapPosToBlock(pos) || (pos < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    ));
    this.offset = offset2;
    this.index = index2;
    this.ok = false;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(s4) {
    Object.assign(this, s4);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const s4 = this._log.pop();
    if (s4)
      this.state = s4;
    return s4;
  }
  bindBlock() {
    if (this.block)
      return;
    if (this.index < 0) {
      this.index = 0;
      this.offset = 0;
    }
    if (this.index >= this.masked._blocks.length) {
      this.index = this.masked._blocks.length - 1;
      this.offset = this.block.displayValue.length;
    }
  }
  _pushLeft(fn2) {
    this.pushState();
    for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0) {
      var _this$block;
      if (fn2())
        return this.ok = true;
    }
    return this.ok = false;
  }
  _pushRight(fn2) {
    this.pushState();
    for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
      if (fn2())
        return this.ok = true;
    }
    return this.ok = false;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (this.block.isFixed || !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
      if (this.offset !== 0)
        return true;
    });
  }
  pushLeftBeforeInput() {
    return this._pushLeft(() => {
      if (this.block.isFixed)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (this.block.isFixed || !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
      if (this.offset !== this.block.value.length)
        return true;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (this.block.isFixed)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value)
        return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
}
class PatternFixedDefinition {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(opts) {
    Object.assign(this, opts);
    this._value = "";
    this.isFixed = true;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : "";
  }
  get rawInputValue() {
    return this._isRawInput ? this.value : "";
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = false;
    this._value = "";
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
    if (!this._value)
      this._isRawInput = false;
    return new ChangeDetails();
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    const minPos = 0;
    const maxPos = this._value.length;
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return minPos;
      case DIRECTION.NONE:
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
      default:
        return maxPos;
    }
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    return this._isRawInput ? toPos - fromPos : 0;
  }
  extractInput(fromPos, toPos, flags3) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this._value.length;
    }
    if (flags3 === void 0) {
      flags3 = {};
    }
    return flags3.raw && this._isRawInput && this._value.slice(fromPos, toPos) || "";
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return Boolean(this._value);
  }
  _appendChar(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    if (this.isFilled)
      return new ChangeDetails();
    const appendEager = this.eager === true || this.eager === "append";
    const appended = this.char === ch;
    const isResolved = appended && (this.isUnmasking || flags3.input || flags3.raw) && (!flags3.raw || !appendEager) && !flags3.tail;
    const details = new ChangeDetails({
      inserted: this.char,
      rawInserted: isResolved ? this.char : ""
    });
    this._value = this.char;
    this._isRawInput = isResolved && (flags3.raw || flags3.input);
    return details;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: true
    });
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled)
      return details;
    this._value = details.inserted = this.char;
    return details;
  }
  extractTail() {
    return new ContinuousTailDetails("");
  }
  appendTail(tail) {
    if (isString$2(tail))
      tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  append(str, flags3, tail) {
    const details = this._appendChar(str[0], flags3);
    if (tail != null) {
      details.tailShift += this.appendTail(tail).tailShift;
    }
    return details;
  }
  doCommit() {
  }
  get state() {
    return {
      _value: this._value,
      _rawInputValue: this.rawInputValue
    };
  }
  set state(state) {
    this._value = state._value;
    this._isRawInput = Boolean(state._rawInputValue);
  }
  pad(flags3) {
    return this._appendPlaceholder();
  }
}
class PatternInputDefinition {
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  /** */
  constructor(opts) {
    const {
      parent: parent2,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager,
      ...maskOpts
    } = opts;
    this.masked = createMask(maskOpts);
    Object.assign(this, {
      parent: parent2,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager
    });
  }
  reset() {
    this.isFilled = false;
    this.masked.reset();
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    if (fromPos === 0 && toPos >= 1) {
      this.isFilled = false;
      return this.masked.remove(fromPos, toPos);
    }
    return new ChangeDetails();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get rawInputValue() {
    return this.masked.rawInputValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return Boolean(this.masked.value) || this.isOptional;
  }
  _appendChar(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    if (this.isFilled)
      return new ChangeDetails();
    const state = this.masked.state;
    let details = this.masked._appendChar(ch, this.currentMaskFlags(flags3));
    if (details.inserted && this.doValidate(flags3) === false) {
      details = new ChangeDetails();
      this.masked.state = state;
    }
    if (!details.inserted && !this.isOptional && !this.lazy && !flags3.input) {
      details.inserted = this.placeholderChar;
    }
    details.skip = !details.inserted && !this.isOptional;
    this.isFilled = Boolean(details.inserted);
    return details;
  }
  append(str, flags3, tail) {
    return this.masked.append(str, this.currentMaskFlags(flags3), tail);
  }
  _appendPlaceholder() {
    if (this.isFilled || this.isOptional)
      return new ChangeDetails();
    this.isFilled = true;
    return new ChangeDetails({
      inserted: this.placeholderChar
    });
  }
  _appendEager() {
    return new ChangeDetails();
  }
  extractTail(fromPos, toPos) {
    return this.masked.extractTail(fromPos, toPos);
  }
  appendTail(tail) {
    return this.masked.appendTail(tail);
  }
  extractInput(fromPos, toPos, flags3) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    return this.masked.extractInput(fromPos, toPos, flags3);
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    const minPos = 0;
    const maxPos = this.value.length;
    const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return this.isComplete ? boundPos : minPos;
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        return this.isComplete ? boundPos : maxPos;
      case DIRECTION.NONE:
      default:
        return boundPos;
    }
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.value.length;
    }
    return this.value.slice(fromPos, toPos).length;
  }
  doValidate(flags3) {
    return this.masked.doValidate(this.currentMaskFlags(flags3)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags3)));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      _value: this.value,
      _rawInputValue: this.rawInputValue,
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(state) {
    this.masked.state = state.masked;
    this.isFilled = state.isFilled;
  }
  currentMaskFlags(flags3) {
    var _flags$_beforeTailSta;
    return {
      ...flags3,
      _beforeTailState: (flags3 == null || (_flags$_beforeTailSta = flags3._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags3 == null ? void 0 : flags3._beforeTailState)
    };
  }
  pad(flags3) {
    return new ChangeDetails();
  }
}
PatternInputDefinition.DEFAULT_DEFINITIONS = {
  "0": /\d/,
  "a": /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
};
class MaskedRegExp extends Masked {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const mask = opts.mask;
    if (mask)
      opts.validate = (value) => value.search(mask) >= 0;
    super._update(opts);
  }
}
IMask.MaskedRegExp = MaskedRegExp;
class MaskedPattern extends Masked {
  /** */
  /** */
  /** Single char for empty input */
  /** Single char for filled input */
  /** Show placeholder only when needed */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(opts) {
    super({
      ...MaskedPattern.DEFAULTS,
      ...opts,
      definitions: Object.assign({}, PatternInputDefinition.DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    opts.definitions = Object.assign({}, this.definitions, opts.definitions);
    super._update(opts);
    this._rebuildMask();
  }
  _rebuildMask() {
    const defs = this.definitions;
    this._blocks = [];
    this.exposeBlock = void 0;
    this._stops = [];
    this._maskedBlocks = {};
    const pattern = this.mask;
    if (!pattern || !defs)
      return;
    let unmaskingBlock = false;
    let optionalBlock = false;
    for (let i2 = 0; i2 < pattern.length; ++i2) {
      if (this.blocks) {
        const p = pattern.slice(i2);
        const bNames = Object.keys(this.blocks).filter((bName2) => p.indexOf(bName2) === 0);
        bNames.sort((a4, b10) => b10.length - a4.length);
        const bName = bNames[0];
        if (bName) {
          const {
            expose,
            repeat,
            ...bOpts
          } = normalizeOpts(this.blocks[bName]);
          const blockOpts = {
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite,
            autofix: this.autofix,
            ...bOpts,
            repeat,
            parent: this
          };
          const maskedBlock = repeat != null ? new IMask.RepeatBlock(
            blockOpts
            /* TODO */
          ) : createMask(blockOpts);
          if (maskedBlock) {
            this._blocks.push(maskedBlock);
            if (expose)
              this.exposeBlock = maskedBlock;
            if (!this._maskedBlocks[bName])
              this._maskedBlocks[bName] = [];
            this._maskedBlocks[bName].push(this._blocks.length - 1);
          }
          i2 += bName.length - 1;
          continue;
        }
      }
      let char2 = pattern[i2];
      let isInput = char2 in defs;
      if (char2 === MaskedPattern.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (char2 === "{" || char2 === "}") {
        unmaskingBlock = !unmaskingBlock;
        continue;
      }
      if (char2 === "[" || char2 === "]") {
        optionalBlock = !optionalBlock;
        continue;
      }
      if (char2 === MaskedPattern.ESCAPE_CHAR) {
        ++i2;
        char2 = pattern[i2];
        if (!char2)
          break;
        isInput = false;
      }
      const def = isInput ? new PatternInputDefinition({
        isOptional: optionalBlock,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar,
        ...normalizeOpts(defs[char2]),
        parent: this
      }) : new PatternFixedDefinition({
        char: char2,
        eager: this.eager,
        isUnmasking: unmaskingBlock
      });
      this._blocks.push(def);
    }
  }
  get state() {
    return {
      ...super.state,
      _blocks: this._blocks.map((b10) => b10.state)
    };
  }
  set state(state) {
    if (!state) {
      this.reset();
      return;
    }
    const {
      _blocks,
      ...maskedState
    } = state;
    this._blocks.forEach((b10, bi) => b10.state = _blocks[bi]);
    super.state = maskedState;
  }
  reset() {
    super.reset();
    this._blocks.forEach((b10) => b10.reset());
  }
  get isComplete() {
    return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b10) => b10.isComplete);
  }
  get isFilled() {
    return this._blocks.every((b10) => b10.isFilled);
  }
  get isFixed() {
    return this._blocks.every((b10) => b10.isFixed);
  }
  get isOptional() {
    return this._blocks.every((b10) => b10.isOptional);
  }
  doCommit() {
    this._blocks.forEach((b10) => b10.doCommit());
    super.doCommit();
  }
  get unmaskedValue() {
    return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b10) => str += b10.unmaskedValue, "");
  }
  set unmaskedValue(unmaskedValue) {
    if (this.exposeBlock) {
      const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.unmaskedValue = unmaskedValue;
      this.appendTail(tail);
      this.doCommit();
    } else
      super.unmaskedValue = unmaskedValue;
  }
  get value() {
    return this.exposeBlock ? this.exposeBlock.value : (
      // TODO return _value when not in change?
      this._blocks.reduce((str, b10) => str += b10.value, "")
    );
  }
  set value(value) {
    if (this.exposeBlock) {
      const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.value = value;
      this.appendTail(tail);
      this.doCommit();
    } else
      super.value = value;
  }
  get typedValue() {
    return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
  }
  set typedValue(value) {
    if (this.exposeBlock) {
      const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
      this.exposeBlock.typedValue = value;
      this.appendTail(tail);
      this.doCommit();
    } else
      super.typedValue = value;
  }
  get displayValue() {
    return this._blocks.reduce((str, b10) => str += b10.displayValue, "");
  }
  appendTail(tail) {
    return super.appendTail(tail).aggregate(this._appendPlaceholder());
  }
  _appendEager() {
    var _this$_mapPosToBlock;
    const details = new ChangeDetails();
    let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
    if (startBlockIndex == null)
      return details;
    if (this._blocks[startBlockIndex].isFilled)
      ++startBlockIndex;
    for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
      const d3 = this._blocks[bi]._appendEager();
      if (!d3.inserted)
        break;
      details.aggregate(d3);
    }
    return details;
  }
  _appendCharRaw(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const blockIter = this._mapPosToBlock(this.displayValue.length);
    const details = new ChangeDetails();
    if (!blockIter)
      return details;
    for (let bi = blockIter.index, block; block = this._blocks[bi]; ++bi) {
      var _flags$_beforeTailSta;
      const blockDetails = block._appendChar(ch, {
        ...flags3,
        _beforeTailState: (_flags$_beforeTailSta = flags3._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
      });
      details.aggregate(blockDetails);
      if (blockDetails.consumed)
        break;
    }
    return details;
  }
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const chunkTail = new ChunksTailDetails();
    if (fromPos === toPos)
      return chunkTail;
    this._forEachBlocksInRange(fromPos, toPos, (b10, bi, bFromPos, bToPos) => {
      const blockChunk = b10.extractTail(bFromPos, bToPos);
      blockChunk.stop = this._findStopBefore(bi);
      blockChunk.from = this._blockStartPos(bi);
      if (blockChunk instanceof ChunksTailDetails)
        blockChunk.blockIndex = bi;
      chunkTail.extend(blockChunk);
    });
    return chunkTail;
  }
  extractInput(fromPos, toPos, flags3) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    if (flags3 === void 0) {
      flags3 = {};
    }
    if (fromPos === toPos)
      return "";
    let input2 = "";
    this._forEachBlocksInRange(fromPos, toPos, (b10, _, fromPos2, toPos2) => {
      input2 += b10.extractInput(fromPos2, toPos2, flags3);
    });
    return input2;
  }
  _findStopBefore(blockIndex) {
    let stopBefore;
    for (let si = 0; si < this._stops.length; ++si) {
      const stop2 = this._stops[si];
      if (stop2 <= blockIndex)
        stopBefore = stop2;
      else
        break;
    }
    return stopBefore;
  }
  /** Appends placeholder depending on laziness */
  _appendPlaceholder(toBlockIndex) {
    const details = new ChangeDetails();
    if (this.lazy && toBlockIndex == null)
      return details;
    const startBlockIter = this._mapPosToBlock(this.displayValue.length);
    if (!startBlockIter)
      return details;
    const startBlockIndex = startBlockIter.index;
    const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
    this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b10) => {
      if (!b10.lazy || toBlockIndex != null) {
        var _blocks2;
        details.aggregate(b10._appendPlaceholder((_blocks2 = b10._blocks) == null ? void 0 : _blocks2.length));
      }
    });
    return details;
  }
  /** Finds block in pos */
  _mapPosToBlock(pos) {
    let accVal = "";
    for (let bi = 0; bi < this._blocks.length; ++bi) {
      const block = this._blocks[bi];
      const blockStartPos = accVal.length;
      accVal += block.displayValue;
      if (pos <= accVal.length) {
        return {
          index: bi,
          offset: pos - blockStartPos
        };
      }
    }
  }
  _blockStartPos(blockIndex) {
    return this._blocks.slice(0, blockIndex).reduce((pos, b10) => pos += b10.displayValue.length, 0);
  }
  _forEachBlocksInRange(fromPos, toPos, fn2) {
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const fromBlockIter = this._mapPosToBlock(fromPos);
    if (fromBlockIter) {
      const toBlockIter = this._mapPosToBlock(toPos);
      const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
      const fromBlockStartPos = fromBlockIter.offset;
      const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
      fn2(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
      if (toBlockIter && !isSameBlock) {
        for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
          fn2(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
        }
        fn2(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
      }
    }
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const removeDetails = super.remove(fromPos, toPos);
    this._forEachBlocksInRange(fromPos, toPos, (b10, _, bFromPos, bToPos) => {
      removeDetails.aggregate(b10.remove(bFromPos, bToPos));
    });
    return removeDetails;
  }
  nearestInputPos(cursorPos, direction) {
    if (direction === void 0) {
      direction = DIRECTION.NONE;
    }
    if (!this._blocks.length)
      return 0;
    const cursor2 = new PatternCursor(this, cursorPos);
    if (direction === DIRECTION.NONE) {
      if (cursor2.pushRightBeforeInput())
        return cursor2.pos;
      cursor2.popState();
      if (cursor2.pushLeftBeforeInput())
        return cursor2.pos;
      return this.displayValue.length;
    }
    if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
      if (direction === DIRECTION.LEFT) {
        cursor2.pushRightBeforeFilled();
        if (cursor2.ok && cursor2.pos === cursorPos)
          return cursorPos;
        cursor2.popState();
      }
      cursor2.pushLeftBeforeInput();
      cursor2.pushLeftBeforeRequired();
      cursor2.pushLeftBeforeFilled();
      if (direction === DIRECTION.LEFT) {
        cursor2.pushRightBeforeInput();
        cursor2.pushRightBeforeRequired();
        if (cursor2.ok && cursor2.pos <= cursorPos)
          return cursor2.pos;
        cursor2.popState();
        if (cursor2.ok && cursor2.pos <= cursorPos)
          return cursor2.pos;
        cursor2.popState();
      }
      if (cursor2.ok)
        return cursor2.pos;
      if (direction === DIRECTION.FORCE_LEFT)
        return 0;
      cursor2.popState();
      if (cursor2.ok)
        return cursor2.pos;
      cursor2.popState();
      if (cursor2.ok)
        return cursor2.pos;
      return 0;
    }
    if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
      cursor2.pushRightBeforeInput();
      cursor2.pushRightBeforeRequired();
      if (cursor2.pushRightBeforeFilled())
        return cursor2.pos;
      if (direction === DIRECTION.FORCE_RIGHT)
        return this.displayValue.length;
      cursor2.popState();
      if (cursor2.ok)
        return cursor2.pos;
      cursor2.popState();
      if (cursor2.ok)
        return cursor2.pos;
      return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
    }
    return cursorPos;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    let total = 0;
    this._forEachBlocksInRange(fromPos, toPos, (b10, _, bFromPos, bToPos) => {
      total += b10.totalInputPositions(bFromPos, bToPos);
    });
    return total;
  }
  /** Get block by name */
  maskedBlock(name2) {
    return this.maskedBlocks(name2)[0];
  }
  /** Get all blocks by name */
  maskedBlocks(name2) {
    const indices = this._maskedBlocks[name2];
    if (!indices)
      return [];
    return indices.map((gi) => this._blocks[gi]);
  }
  pad(flags3) {
    const details = new ChangeDetails();
    this._forEachBlocksInRange(0, this.displayValue.length, (b10) => details.aggregate(b10.pad(flags3)));
    return details;
  }
}
MaskedPattern.DEFAULTS = {
  ...Masked.DEFAULTS,
  lazy: true,
  placeholderChar: "_"
};
MaskedPattern.STOP_CHAR = "`";
MaskedPattern.ESCAPE_CHAR = "\\";
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;
class MaskedRange extends MaskedPattern {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */
  /** Min bound */
  /** Max bound */
  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }
  constructor(opts) {
    super(opts);
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      to: to2 = this.to || 0,
      from: from2 = this.from || 0,
      maxLength = this.maxLength || 0,
      autofix = this.autofix,
      ...patternOpts
    } = opts;
    this.to = to2;
    this.from = from2;
    this.maxLength = Math.max(String(to2).length, maxLength);
    this.autofix = autofix;
    const fromStr = String(this.from).padStart(this.maxLength, "0");
    const toStr2 = String(this.to).padStart(this.maxLength, "0");
    let sameCharsCount = 0;
    while (sameCharsCount < toStr2.length && toStr2[sameCharsCount] === fromStr[sameCharsCount])
      ++sameCharsCount;
    patternOpts.mask = toStr2.slice(0, sameCharsCount).replace(/0/g, "\\0") + "0".repeat(this.maxLength - sameCharsCount);
    super._update(patternOpts);
  }
  get isComplete() {
    return super.isComplete && Boolean(this.value);
  }
  boundaries(str) {
    let minstr = "";
    let maxstr = "";
    const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
    if (num) {
      minstr = "0".repeat(placeholder.length) + num;
      maxstr = "9".repeat(placeholder.length) + num;
    }
    minstr = minstr.padEnd(this.maxLength, "0");
    maxstr = maxstr.padEnd(this.maxLength, "9");
    return [minstr, maxstr];
  }
  doPrepareChar(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    let details;
    [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ""), flags3);
    if (!ch)
      details.skip = !this.isComplete;
    return [ch, details];
  }
  _appendCharRaw(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    if (!this.autofix || this.value.length + 1 > this.maxLength)
      return super._appendCharRaw(ch, flags3);
    const fromStr = String(this.from).padStart(this.maxLength, "0");
    const toStr2 = String(this.to).padStart(this.maxLength, "0");
    const [minstr, maxstr] = this.boundaries(this.value + ch);
    if (Number(maxstr) < this.from)
      return super._appendCharRaw(fromStr[this.value.length], flags3);
    if (Number(minstr) > this.to) {
      if (!flags3.tail && this.autofix === "pad" && this.value.length + 1 < this.maxLength) {
        return super._appendCharRaw(fromStr[this.value.length], flags3).aggregate(this._appendCharRaw(ch, flags3));
      }
      return super._appendCharRaw(toStr2[this.value.length], flags3);
    }
    return super._appendCharRaw(ch, flags3);
  }
  doValidate(flags3) {
    const str = this.value;
    const firstNonZero = str.search(/[^0]/);
    if (firstNonZero === -1 && str.length <= this._matchFrom)
      return true;
    const [minstr, maxstr] = this.boundaries(str);
    return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags3);
  }
  pad(flags3) {
    const details = new ChangeDetails();
    if (this.value.length === this.maxLength)
      return details;
    const value = this.value;
    const padLength = this.maxLength - this.value.length;
    if (padLength) {
      this.reset();
      for (let i2 = 0; i2 < padLength; ++i2) {
        details.aggregate(super._appendCharRaw("0", flags3));
      }
      value.split("").forEach((ch) => this._appendCharRaw(ch));
    }
    return details;
  }
}
IMask.MaskedRange = MaskedRange;
class MaskedDate extends MaskedPattern {
  static extractPatternOptions(opts) {
    const {
      mask,
      pattern,
      ...patternOpts
    } = opts;
    return {
      ...patternOpts,
      mask: isString$2(mask) ? mask : pattern
    };
  }
  /** Pattern mask for date according to {@link MaskedDate#format} */
  /** Start date */
  /** End date */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(opts) {
    super(MaskedDate.extractPatternOptions({
      ...MaskedDate.DEFAULTS,
      ...opts
    }));
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      mask,
      pattern,
      blocks,
      ...patternOpts
    } = {
      ...MaskedDate.DEFAULTS,
      ...opts
    };
    const patternBlocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
    if (opts.min)
      patternBlocks.Y.from = opts.min.getFullYear();
    if (opts.max)
      patternBlocks.Y.to = opts.max.getFullYear();
    if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
      patternBlocks.m.from = opts.min.getMonth() + 1;
      patternBlocks.m.to = opts.max.getMonth() + 1;
      if (patternBlocks.m.from === patternBlocks.m.to) {
        patternBlocks.d.from = opts.min.getDate();
        patternBlocks.d.to = opts.max.getDate();
      }
    }
    Object.assign(patternBlocks, this.blocks, blocks);
    super._update({
      ...patternOpts,
      mask: isString$2(mask) ? mask : pattern,
      blocks: patternBlocks
    });
  }
  doValidate(flags3) {
    const date2 = this.date;
    return super.doValidate(flags3) && (!this.isComplete || this.isDateExist(this.value) && date2 != null && (this.min == null || this.min <= date2) && (this.max == null || date2 <= this.max));
  }
  /** Checks if date is exists */
  isDateExist(str) {
    return this.format(this.parse(str, this), this).indexOf(str) >= 0;
  }
  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(date2) {
    this.typedValue = date2;
  }
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(value) {
    super.typedValue = value;
  }
  maskEquals(mask) {
    return mask === Date || super.maskEquals(mask);
  }
  optionsIsChanged(opts) {
    return super.optionsIsChanged(MaskedDate.extractPatternOptions(opts));
  }
}
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: MaskedRange,
    from: 1900,
    to: 9999
  }
});
MaskedDate.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  mask: Date,
  pattern: "d{.}`m{.}`Y",
  format: (date2, masked) => {
    if (!date2)
      return "";
    const day = String(date2.getDate()).padStart(2, "0");
    const month = String(date2.getMonth() + 1).padStart(2, "0");
    const year = date2.getFullYear();
    return [day, month, year].join(".");
  },
  parse: (str, masked) => {
    const [day, month, year] = str.split(".").map(Number);
    return new Date(year, month - 1, day);
  }
};
IMask.MaskedDate = MaskedDate;
class MaskedDynamic extends Masked {
  constructor(opts) {
    super({
      ...MaskedDynamic.DEFAULTS,
      ...opts
    });
    this.currentMask = void 0;
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update(opts);
    if ("mask" in opts) {
      this.exposeMask = void 0;
      this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m3) => {
        const {
          expose,
          ...maskOpts
        } = normalizeOpts(m3);
        const masked = createMask({
          overwrite: this._overwrite,
          eager: this._eager,
          skipInvalid: this._skipInvalid,
          ...maskOpts
        });
        if (expose)
          this.exposeMask = masked;
        return masked;
      }) : [];
    }
  }
  _appendCharRaw(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const details = this._applyDispatch(ch, flags3);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags3)));
    }
    return details;
  }
  _applyDispatch(appended, flags3, tail) {
    if (appended === void 0) {
      appended = "";
    }
    if (flags3 === void 0) {
      flags3 = {};
    }
    if (tail === void 0) {
      tail = "";
    }
    const prevValueBeforeTail = flags3.tail && flags3._beforeTailState != null ? flags3._beforeTailState._value : this.value;
    const inputValue = this.rawInputValue;
    const insertValue = flags3.tail && flags3._beforeTailState != null ? flags3._beforeTailState._rawInputValue : inputValue;
    const tailValue = inputValue.slice(insertValue.length);
    const prevMask = this.currentMask;
    const details = new ChangeDetails();
    const prevMaskState = prevMask == null ? void 0 : prevMask.state;
    this.currentMask = this.doDispatch(appended, {
      ...flags3
    }, tail);
    if (this.currentMask) {
      if (this.currentMask !== prevMask) {
        this.currentMask.reset();
        if (insertValue) {
          this.currentMask.append(insertValue, {
            raw: true
          });
          details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
        }
        if (tailValue) {
          details.tailShift += this.currentMask.append(tailValue, {
            raw: true,
            tail: true
          }).tailShift;
        }
      } else if (prevMaskState) {
        this.currentMask.state = prevMaskState;
      }
    }
    return details;
  }
  _appendPlaceholder() {
    const details = this._applyDispatch();
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendPlaceholder());
    }
    return details;
  }
  _appendEager() {
    const details = this._applyDispatch();
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendEager());
    }
    return details;
  }
  appendTail(tail) {
    const details = new ChangeDetails();
    if (tail)
      details.aggregate(this._applyDispatch("", {}, tail));
    return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
  }
  currentMaskFlags(flags3) {
    var _flags$_beforeTailSta, _flags$_beforeTailSta2;
    return {
      ...flags3,
      _beforeTailState: ((_flags$_beforeTailSta = flags3._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags3._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags3._beforeTailState
    };
  }
  doDispatch(appended, flags3, tail) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    if (tail === void 0) {
      tail = "";
    }
    return this.dispatch(appended, this, flags3, tail);
  }
  doValidate(flags3) {
    return super.doValidate(flags3) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags3)));
  }
  doPrepare(str, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    let [s4, details] = super.doPrepare(str, flags3);
    if (this.currentMask) {
      let currentDetails;
      [s4, currentDetails] = super.doPrepare(s4, this.currentMaskFlags(flags3));
      details = details.aggregate(currentDetails);
    }
    return [s4, details];
  }
  doPrepareChar(str, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    let [s4, details] = super.doPrepareChar(str, flags3);
    if (this.currentMask) {
      let currentDetails;
      [s4, currentDetails] = super.doPrepareChar(s4, this.currentMaskFlags(flags3));
      details = details.aggregate(currentDetails);
    }
    return [s4, details];
  }
  reset() {
    var _this$currentMask;
    (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
    this.compiledMasks.forEach((m3) => m3.reset());
  }
  get value() {
    return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : "";
  }
  set value(value) {
    if (this.exposeMask) {
      this.exposeMask.value = value;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
    } else
      super.value = value;
  }
  get unmaskedValue() {
    return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : "";
  }
  set unmaskedValue(unmaskedValue) {
    if (this.exposeMask) {
      this.exposeMask.unmaskedValue = unmaskedValue;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
    } else
      super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : "";
  }
  set typedValue(typedValue) {
    if (this.exposeMask) {
      this.exposeMask.typedValue = typedValue;
      this.currentMask = this.exposeMask;
      this._applyDispatch();
      return;
    }
    let unmaskedValue = String(typedValue);
    if (this.currentMask) {
      this.currentMask.typedValue = typedValue;
      unmaskedValue = this.currentMask.unmaskedValue;
    }
    this.unmaskedValue = unmaskedValue;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : "";
  }
  get isComplete() {
    var _this$currentMask2;
    return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
  }
  get isFilled() {
    var _this$currentMask3;
    return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
  }
  remove(fromPos, toPos) {
    const details = new ChangeDetails();
    if (this.currentMask) {
      details.aggregate(this.currentMask.remove(fromPos, toPos)).aggregate(this._applyDispatch());
    }
    return details;
  }
  get state() {
    var _this$currentMask4;
    return {
      ...super.state,
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map((m3) => m3.state),
      currentMaskRef: this.currentMask,
      currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
    };
  }
  set state(state) {
    const {
      compiledMasks,
      currentMaskRef,
      currentMask,
      ...maskedState
    } = state;
    if (compiledMasks)
      this.compiledMasks.forEach((m3, mi) => m3.state = compiledMasks[mi]);
    if (currentMaskRef != null) {
      this.currentMask = currentMaskRef;
      this.currentMask.state = currentMask;
    }
    super.state = maskedState;
  }
  extractInput(fromPos, toPos, flags3) {
    return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags3) : "";
  }
  extractTail(fromPos, toPos) {
    return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
  }
  doCommit() {
    if (this.currentMask)
      this.currentMask.doCommit();
    super.doCommit();
  }
  nearestInputPos(cursorPos, direction) {
    return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : this._overwrite;
  }
  set overwrite(overwrite) {
    this._overwrite = overwrite;
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : this._eager;
  }
  set eager(eager) {
    this._eager = eager;
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
  }
  set skipInvalid(skipInvalid) {
    this._skipInvalid = skipInvalid;
  }
  get autofix() {
    return this.currentMask ? this.currentMask.autofix : this._autofix;
  }
  set autofix(autofix) {
    this._autofix = autofix;
  }
  maskEquals(mask) {
    return Array.isArray(mask) ? this.compiledMasks.every((m3, mi) => {
      if (!mask[mi])
        return;
      const {
        mask: oldMask,
        ...restOpts
      } = mask[mi];
      return objectIncludes(m3, restOpts) && m3.maskEquals(oldMask);
    }) : super.maskEquals(mask);
  }
  typedValueEquals(value) {
    var _this$currentMask5;
    return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
  }
}
MaskedDynamic.DEFAULTS = {
  ...Masked.DEFAULTS,
  dispatch: (appended, masked, flags3, tail) => {
    if (!masked.compiledMasks.length)
      return;
    const inputValue = masked.rawInputValue;
    const inputs = masked.compiledMasks.map((m3, index2) => {
      const isCurrent = masked.currentMask === m3;
      const startInputPos = isCurrent ? m3.displayValue.length : m3.nearestInputPos(m3.displayValue.length, DIRECTION.FORCE_LEFT);
      if (m3.rawInputValue !== inputValue) {
        m3.reset();
        m3.append(inputValue, {
          raw: true
        });
      } else if (!isCurrent) {
        m3.remove(startInputPos);
      }
      m3.append(appended, masked.currentMaskFlags(flags3));
      m3.appendTail(tail);
      return {
        index: index2,
        weight: m3.rawInputValue.length,
        totalInputPositions: m3.totalInputPositions(0, Math.max(startInputPos, m3.nearestInputPos(m3.displayValue.length, DIRECTION.FORCE_LEFT)))
      };
    });
    inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;
class MaskedEnum extends MaskedPattern {
  constructor(opts) {
    super({
      ...MaskedEnum.DEFAULTS,
      ...opts
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    const {
      enum: enum_,
      ...eopts
    } = opts;
    if (enum_) {
      const lengths = enum_.map((e3) => e3.length);
      const requiredLength = Math.min(...lengths);
      const optionalLength = Math.max(...lengths) - requiredLength;
      eopts.mask = "*".repeat(requiredLength);
      if (optionalLength)
        eopts.mask += "[" + "*".repeat(optionalLength) + "]";
      this.enum = enum_;
    }
    super._update(eopts);
  }
  _appendCharRaw(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const matchFrom = Math.min(this.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    const matches2 = this.enum.filter((e3) => this.matchValue(e3, this.unmaskedValue + ch, matchFrom));
    if (matches2.length) {
      if (matches2.length === 1) {
        this._forEachBlocksInRange(0, this.value.length, (b10, bi) => {
          const mch = matches2[0][bi];
          if (bi >= this.value.length || mch === b10.value)
            return;
          b10.reset();
          b10._appendChar(mch, flags3);
        });
      }
      const d3 = super._appendCharRaw(matches2[0][this.value.length], flags3);
      if (matches2.length === 1) {
        matches2[0].slice(this.unmaskedValue.length).split("").forEach((mch) => d3.aggregate(super._appendCharRaw(mch)));
      }
      return d3;
    }
    return new ChangeDetails();
  }
  extractTail(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    return new ContinuousTailDetails("", fromPos);
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    if (fromPos === toPos)
      return new ChangeDetails();
    const matchFrom = Math.min(super.nearestInputPos(0, DIRECTION.FORCE_RIGHT), this.value.length);
    let pos;
    for (pos = fromPos; pos >= 0; --pos) {
      const matches2 = this.enum.filter((e3) => this.matchValue(e3, this.value.slice(matchFrom, pos), matchFrom));
      if (matches2.length > 1)
        break;
    }
    const details = super.remove(pos, toPos);
    details.tailShift += pos - fromPos;
    return details;
  }
}
MaskedEnum.DEFAULTS = {
  ...MaskedPattern.DEFAULTS,
  matchValue: (estr, istr, matchFrom) => estr.indexOf(istr, matchFrom) === matchFrom
};
IMask.MaskedEnum = MaskedEnum;
class MaskedFunction extends Masked {
  /** */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update({
      ...opts,
      validate: opts.mask
    });
  }
}
IMask.MaskedFunction = MaskedFunction;
var _MaskedNumber;
class MaskedNumber extends Masked {
  /** Single char */
  /** Single char */
  /** Array of single chars */
  /** */
  /** */
  /** Digits after point */
  /** Flag to remove leading and trailing zeros in the end of editing */
  /** Flag to pad trailing zeros after point in the end of editing */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  /** Format typed value to string */
  /** Parse string to get typed value */
  constructor(opts) {
    super({
      ...MaskedNumber.DEFAULTS,
      ...opts
    });
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    super._update(opts);
    this._updateRegExps();
  }
  _updateRegExps() {
    const start2 = "^" + (this.allowNegative ? "[+|\\-]?" : "");
    const mid = "\\d*";
    const end2 = (this.scale ? "(" + escapeRegExp(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
    this._numberRegExp = new RegExp(start2 + mid + end2);
    this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(escapeRegExp).join("") + "]", "g");
    this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), "g");
  }
  _removeThousandsSeparators(value) {
    return value.replace(this._thousandsSeparatorRegExp, "");
  }
  _insertThousandsSeparators(value) {
    const parts = value.split(this.radix);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    return parts.join(this.radix);
  }
  doPrepareChar(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    (flags3.input && flags3.raw || !flags3.input && !flags3.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags3);
    if (ch && !prepCh)
      details.skip = true;
    if (prepCh && !this.allowPositive && !this.value && prepCh !== "-")
      details.aggregate(this._appendChar("-"));
    return [prepCh, details];
  }
  _separatorsCount(to2, extendOnSeparators) {
    if (extendOnSeparators === void 0) {
      extendOnSeparators = false;
    }
    let count = 0;
    for (let pos = 0; pos < to2; ++pos) {
      if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
        ++count;
        if (extendOnSeparators)
          to2 += this.thousandsSeparator.length;
      }
    }
    return count;
  }
  _separatorsCountFromSlice(slice2) {
    if (slice2 === void 0) {
      slice2 = this._value;
    }
    return this._separatorsCount(this._removeThousandsSeparators(slice2).length, true);
  }
  extractInput(fromPos, toPos, flags3) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags3));
  }
  _appendCharRaw(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const prevBeforeTailValue = flags3.tail && flags3._beforeTailState ? flags3._beforeTailState._value : this._value;
    const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
    this._value = this._removeThousandsSeparators(this.value);
    const oldValue = this._value;
    this._value += ch;
    const num = this.number;
    let accepted = !isNaN(num);
    let skip = false;
    if (accepted) {
      let fixedNum;
      if (this.min != null && this.min < 0 && this.number < this.min)
        fixedNum = this.min;
      if (this.max != null && this.max > 0 && this.number > this.max)
        fixedNum = this.max;
      if (fixedNum != null) {
        if (this.autofix) {
          this._value = this.format(fixedNum, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
          skip || (skip = oldValue === this._value && !flags3.tail);
        } else {
          accepted = false;
        }
      }
      accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
    }
    let appendDetails;
    if (!accepted) {
      this._value = oldValue;
      appendDetails = new ChangeDetails();
    } else {
      appendDetails = new ChangeDetails({
        inserted: this._value.slice(oldValue.length),
        rawInserted: skip ? "" : ch,
        skip
      });
    }
    this._value = this._insertThousandsSeparators(this._value);
    const beforeTailValue = flags3.tail && flags3._beforeTailState ? flags3._beforeTailState._value : this._value;
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
    appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
    return appendDetails;
  }
  _findSeparatorAround(pos) {
    if (this.thousandsSeparator) {
      const searchFrom = pos - this.thousandsSeparator.length + 1;
      const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
      if (separatorPos <= pos)
        return separatorPos;
    }
    return -1;
  }
  _adjustRangeWithSeparators(from2, to2) {
    const separatorAroundFromPos = this._findSeparatorAround(from2);
    if (separatorAroundFromPos >= 0)
      from2 = separatorAroundFromPos;
    const separatorAroundToPos = this._findSeparatorAround(to2);
    if (separatorAroundToPos >= 0)
      to2 = separatorAroundToPos + this.thousandsSeparator.length;
    return [from2, to2];
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    const valueBeforePos = this.value.slice(0, fromPos);
    const valueAfterPos = this.value.slice(toPos);
    const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
    return new ChangeDetails({
      tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
    });
  }
  nearestInputPos(cursorPos, direction) {
    if (!this.thousandsSeparator)
      return cursorPos;
    switch (direction) {
      case DIRECTION.NONE:
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT: {
        const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
        if (separatorAtLeftPos >= 0) {
          const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
          if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
            return separatorAtLeftPos;
          }
        }
        break;
      }
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT: {
        const separatorAtRightPos = this._findSeparatorAround(cursorPos);
        if (separatorAtRightPos >= 0) {
          return separatorAtRightPos + this.thousandsSeparator.length;
        }
      }
    }
    return cursorPos;
  }
  doCommit() {
    if (this.value) {
      const number2 = this.number;
      let validnum = number2;
      if (this.min != null)
        validnum = Math.max(validnum, this.min);
      if (this.max != null)
        validnum = Math.min(validnum, this.max);
      if (validnum !== number2)
        this.unmaskedValue = this.format(validnum, this);
      let formatted = this.value;
      if (this.normalizeZeros)
        formatted = this._normalizeZeros(formatted);
      if (this.padFractionalZeros && this.scale > 0)
        formatted = this._padFractionalZeros(formatted);
      this._value = formatted;
    }
    super.doCommit();
  }
  _normalizeZeros(value) {
    const parts = this._removeThousandsSeparators(value).split(this.radix);
    parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match2, sign2, zeros, num) => sign2 + num);
    if (value.length && !/\d$/.test(parts[0]))
      parts[0] = parts[0] + "0";
    if (parts.length > 1) {
      parts[1] = parts[1].replace(/0*$/, "");
      if (!parts[1].length)
        parts.length = 1;
    }
    return this._insertThousandsSeparators(parts.join(this.radix));
  }
  _padFractionalZeros(value) {
    if (!value)
      return value;
    const parts = value.split(this.radix);
    if (parts.length < 2)
      parts.push("");
    parts[1] = parts[1].padEnd(this.scale, "0");
    return parts.join(this.radix);
  }
  doSkipInvalid(ch, flags3, checkTail) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
    return super.doSkipInvalid(ch, flags3, checkTail) && !dropFractional;
  }
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }
  get typedValue() {
    return this.parse(this.unmaskedValue, this);
  }
  set typedValue(n) {
    this.rawInputValue = this.format(n, this).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
  }
  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(number2) {
    this.typedValue = number2;
  }
  get allowNegative() {
    return this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }
  get allowPositive() {
    return this.min != null && this.min > 0 || this.max != null && this.max > 0;
  }
  typedValueEquals(value) {
    return (super.typedValueEquals(value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === "");
  }
}
_MaskedNumber = MaskedNumber;
MaskedNumber.UNMASKED_RADIX = ".";
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
MaskedNumber.DEFAULTS = {
  ...Masked.DEFAULTS,
  mask: Number,
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: [_MaskedNumber.UNMASKED_RADIX],
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  scale: 2,
  normalizeZeros: true,
  padFractionalZeros: false,
  parse: Number,
  format: (n) => n.toLocaleString("en-US", {
    useGrouping: false,
    maximumFractionDigits: 20
  })
};
IMask.MaskedNumber = MaskedNumber;
const PIPE_TYPE = {
  MASKED: "value",
  UNMASKED: "unmaskedValue",
  TYPED: "typedValue"
};
function createPipe(arg, from2, to2) {
  if (from2 === void 0) {
    from2 = PIPE_TYPE.MASKED;
  }
  if (to2 === void 0) {
    to2 = PIPE_TYPE.MASKED;
  }
  const masked = createMask(arg);
  return (value) => masked.runIsolated((m3) => {
    m3[from2] = value;
    return m3[to2];
  });
}
function pipe(value, mask, from2, to2) {
  return createPipe(mask, from2, to2)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;
class RepeatBlock extends MaskedPattern {
  get repeatFrom() {
    var _ref2;
    return (_ref2 = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref2 : 0;
  }
  get repeatTo() {
    var _ref2;
    return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
  }
  constructor(opts) {
    super(opts);
  }
  updateOptions(opts) {
    super.updateOptions(opts);
  }
  _update(opts) {
    var _ref3, _ref4, _this$_blocks;
    const {
      repeat,
      ...blockOpts
    } = normalizeOpts(opts);
    this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
    const block = createMask(this._blockOpts);
    this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity;
    super._update({
      mask: "m".repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
      blocks: {
        m: block
      },
      eager: block.eager,
      overwrite: block.overwrite,
      skipInvalid: block.skipInvalid,
      lazy: block.lazy,
      placeholderChar: block.placeholderChar,
      displayChar: block.displayChar
    });
  }
  _allocateBlock(bi) {
    if (bi < this._blocks.length)
      return this._blocks[bi];
    if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
      this._blocks.push(createMask(this._blockOpts));
      this.mask += "m";
      return this._blocks[this._blocks.length - 1];
    }
  }
  _appendCharRaw(ch, flags3) {
    if (flags3 === void 0) {
      flags3 = {};
    }
    const details = new ChangeDetails();
    for (
      let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated;
      // try to get a block or
      // try to allocate a new block if not allocated already
      block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi);
      ++bi
    ) {
      var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
      const blockDetails = block._appendChar(ch, {
        ...flags3,
        _beforeTailState: (_flags$_beforeTailSta = flags3._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
      });
      if (blockDetails.skip && allocated) {
        this._blocks.pop();
        this.mask = this.mask.slice(1);
        break;
      }
      details.aggregate(blockDetails);
      if (blockDetails.consumed)
        break;
    }
    return details;
  }
  _trimEmptyTail(fromPos, toPos) {
    var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
    if (fromPos === void 0) {
      fromPos = 0;
    }
    const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
    let lastBlockIndex;
    if (toPos != null)
      lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
    if (lastBlockIndex == null)
      lastBlockIndex = this._blocks.length - 1;
    let removeCount = 0;
    for (let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount) {
      if (this._blocks[blockIndex].unmaskedValue)
        break;
    }
    if (removeCount) {
      this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
      this.mask = this.mask.slice(removeCount);
    }
  }
  reset() {
    super.reset();
    this._trimEmptyTail();
  }
  remove(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos === void 0) {
      toPos = this.displayValue.length;
    }
    const removeDetails = super.remove(fromPos, toPos);
    this._trimEmptyTail(fromPos, toPos);
    return removeDetails;
  }
  totalInputPositions(fromPos, toPos) {
    if (fromPos === void 0) {
      fromPos = 0;
    }
    if (toPos == null && this.repeatTo === Infinity)
      return Infinity;
    return super.totalInputPositions(fromPos, toPos);
  }
  get state() {
    return super.state;
  }
  set state(state) {
    this._blocks.length = state._blocks.length;
    this.mask = this.mask.slice(0, this._blocks.length);
    super.state = state;
  }
}
IMask.RepeatBlock = RepeatBlock;
try {
  globalThis.IMask = IMask;
} catch {
}
var propTypes$1 = { exports: {} };
var reactIs = { exports: {} };
var reactIs_production_min = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min)
    return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var b10 = "function" === typeof Symbol && Symbol.for, c7 = b10 ? Symbol.for("react.element") : 60103, d3 = b10 ? Symbol.for("react.portal") : 60106, e3 = b10 ? Symbol.for("react.fragment") : 60107, f = b10 ? Symbol.for("react.strict_mode") : 60108, g2 = b10 ? Symbol.for("react.profiler") : 60114, h3 = b10 ? Symbol.for("react.provider") : 60109, k3 = b10 ? Symbol.for("react.context") : 60110, l = b10 ? Symbol.for("react.async_mode") : 60111, m3 = b10 ? Symbol.for("react.concurrent_mode") : 60111, n = b10 ? Symbol.for("react.forward_ref") : 60112, p = b10 ? Symbol.for("react.suspense") : 60113, q2 = b10 ? Symbol.for("react.suspense_list") : 60120, r = b10 ? Symbol.for("react.memo") : 60115, t2 = b10 ? Symbol.for("react.lazy") : 60116, v = b10 ? Symbol.for("react.block") : 60121, w2 = b10 ? Symbol.for("react.fundamental") : 60117, x3 = b10 ? Symbol.for("react.responder") : 60118, y4 = b10 ? Symbol.for("react.scope") : 60119;
  function z2(a4) {
    if ("object" === typeof a4 && null !== a4) {
      var u2 = a4.$$typeof;
      switch (u2) {
        case c7:
          switch (a4 = a4.type, a4) {
            case l:
            case m3:
            case e3:
            case g2:
            case f:
            case p:
              return a4;
            default:
              switch (a4 = a4 && a4.$$typeof, a4) {
                case k3:
                case n:
                case t2:
                case r:
                case h3:
                  return a4;
                default:
                  return u2;
              }
          }
        case d3:
          return u2;
      }
    }
  }
  function A(a4) {
    return z2(a4) === m3;
  }
  reactIs_production_min.AsyncMode = l;
  reactIs_production_min.ConcurrentMode = m3;
  reactIs_production_min.ContextConsumer = k3;
  reactIs_production_min.ContextProvider = h3;
  reactIs_production_min.Element = c7;
  reactIs_production_min.ForwardRef = n;
  reactIs_production_min.Fragment = e3;
  reactIs_production_min.Lazy = t2;
  reactIs_production_min.Memo = r;
  reactIs_production_min.Portal = d3;
  reactIs_production_min.Profiler = g2;
  reactIs_production_min.StrictMode = f;
  reactIs_production_min.Suspense = p;
  reactIs_production_min.isAsyncMode = function(a4) {
    return A(a4) || z2(a4) === l;
  };
  reactIs_production_min.isConcurrentMode = A;
  reactIs_production_min.isContextConsumer = function(a4) {
    return z2(a4) === k3;
  };
  reactIs_production_min.isContextProvider = function(a4) {
    return z2(a4) === h3;
  };
  reactIs_production_min.isElement = function(a4) {
    return "object" === typeof a4 && null !== a4 && a4.$$typeof === c7;
  };
  reactIs_production_min.isForwardRef = function(a4) {
    return z2(a4) === n;
  };
  reactIs_production_min.isFragment = function(a4) {
    return z2(a4) === e3;
  };
  reactIs_production_min.isLazy = function(a4) {
    return z2(a4) === t2;
  };
  reactIs_production_min.isMemo = function(a4) {
    return z2(a4) === r;
  };
  reactIs_production_min.isPortal = function(a4) {
    return z2(a4) === d3;
  };
  reactIs_production_min.isProfiler = function(a4) {
    return z2(a4) === g2;
  };
  reactIs_production_min.isStrictMode = function(a4) {
    return z2(a4) === f;
  };
  reactIs_production_min.isSuspense = function(a4) {
    return z2(a4) === p;
  };
  reactIs_production_min.isValidElementType = function(a4) {
    return "string" === typeof a4 || "function" === typeof a4 || a4 === e3 || a4 === m3 || a4 === g2 || a4 === f || a4 === p || a4 === q2 || "object" === typeof a4 && null !== a4 && (a4.$$typeof === t2 || a4.$$typeof === r || a4.$$typeof === h3 || a4.$$typeof === k3 || a4.$$typeof === n || a4.$$typeof === w2 || a4.$$typeof === x3 || a4.$$typeof === y4 || a4.$$typeof === v);
  };
  reactIs_production_min.typeOf = z2;
  return reactIs_production_min;
}
var reactIs_development = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  if (hasRequiredReactIs_development)
    return reactIs_development;
  hasRequiredReactIs_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      var hasSymbol = typeof Symbol === "function" && Symbol.for;
      var REACT_ELEMENT_TYPE2 = hasSymbol ? Symbol.for("react.element") : 60103;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
      function isValidElementType(type2) {
        return typeof type2 === "string" || typeof type2 === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type2 === REACT_FRAGMENT_TYPE || type2 === REACT_CONCURRENT_MODE_TYPE || type2 === REACT_PROFILER_TYPE || type2 === REACT_STRICT_MODE_TYPE || type2 === REACT_SUSPENSE_TYPE || type2 === REACT_SUSPENSE_LIST_TYPE || typeof type2 === "object" && type2 !== null && (type2.$$typeof === REACT_LAZY_TYPE || type2.$$typeof === REACT_MEMO_TYPE || type2.$$typeof === REACT_PROVIDER_TYPE || type2.$$typeof === REACT_CONTEXT_TYPE || type2.$$typeof === REACT_FORWARD_REF_TYPE || type2.$$typeof === REACT_FUNDAMENTAL_TYPE || type2.$$typeof === REACT_RESPONDER_TYPE || type2.$$typeof === REACT_SCOPE_TYPE || type2.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object2) {
        if (typeof object2 === "object" && object2 !== null) {
          var $$typeof = object2.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE2:
              var type2 = object2.type;
              switch (type2) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type2;
                default:
                  var $$typeofType = type2 && type2.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return void 0;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element2 = REACT_ELEMENT_TYPE2;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment2 = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal2 = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object2) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
          }
        }
        return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object2) {
        return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object2) {
        return typeOf(object2) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object2) {
        return typeOf(object2) === REACT_PROVIDER_TYPE;
      }
      function isElement2(object2) {
        return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE2;
      }
      function isForwardRef(object2) {
        return typeOf(object2) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object2) {
        return typeOf(object2) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object2) {
        return typeOf(object2) === REACT_LAZY_TYPE;
      }
      function isMemo(object2) {
        return typeOf(object2) === REACT_MEMO_TYPE;
      }
      function isPortal(object2) {
        return typeOf(object2) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object2) {
        return typeOf(object2) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object2) {
        return typeOf(object2) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object2) {
        return typeOf(object2) === REACT_SUSPENSE_TYPE;
      }
      reactIs_development.AsyncMode = AsyncMode;
      reactIs_development.ConcurrentMode = ConcurrentMode;
      reactIs_development.ContextConsumer = ContextConsumer;
      reactIs_development.ContextProvider = ContextProvider;
      reactIs_development.Element = Element2;
      reactIs_development.ForwardRef = ForwardRef;
      reactIs_development.Fragment = Fragment2;
      reactIs_development.Lazy = Lazy;
      reactIs_development.Memo = Memo;
      reactIs_development.Portal = Portal2;
      reactIs_development.Profiler = Profiler;
      reactIs_development.StrictMode = StrictMode;
      reactIs_development.Suspense = Suspense;
      reactIs_development.isAsyncMode = isAsyncMode;
      reactIs_development.isConcurrentMode = isConcurrentMode;
      reactIs_development.isContextConsumer = isContextConsumer;
      reactIs_development.isContextProvider = isContextProvider;
      reactIs_development.isElement = isElement2;
      reactIs_development.isForwardRef = isForwardRef;
      reactIs_development.isFragment = isFragment;
      reactIs_development.isLazy = isLazy;
      reactIs_development.isMemo = isMemo;
      reactIs_development.isPortal = isPortal;
      reactIs_development.isProfiler = isProfiler;
      reactIs_development.isStrictMode = isStrictMode;
      reactIs_development.isSuspense = isSuspense;
      reactIs_development.isValidElementType = isValidElementType;
      reactIs_development.typeOf = typeOf;
    })();
  }
  return reactIs_development;
}
var hasRequiredReactIs;
function requireReactIs() {
  if (hasRequiredReactIs)
    return reactIs.exports;
  hasRequiredReactIs = 1;
  if (process.env.NODE_ENV === "production") {
    reactIs.exports = requireReactIs_production_min();
  } else {
    reactIs.exports = requireReactIs_development();
  }
  return reactIs.exports;
}
var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret)
    return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  ReactPropTypesSecret_1 = ReactPropTypesSecret;
  return ReactPropTypesSecret_1;
}
var has$1;
var hasRequiredHas;
function requireHas() {
  if (hasRequiredHas)
    return has$1;
  hasRequiredHas = 1;
  has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  return has$1;
}
var checkPropTypes_1;
var hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes)
    return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var ReactPropTypesSecret = requireReactPropTypesSecret();
    var loggedTypeFailures = {};
    var has7 = requireHas();
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x3) {
      }
    };
  }
  function checkPropTypes(typeSpecs, values6, location, componentName, getStack) {
    if (process.env.NODE_ENV !== "production") {
      for (var typeSpecName in typeSpecs) {
        if (has7(typeSpecs, typeSpecName)) {
          var error2;
          try {
            if (typeof typeSpecs[typeSpecName] !== "function") {
              var err = Error(
                (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              err.name = "Invariant Violation";
              throw err;
            }
            error2 = typeSpecs[typeSpecName](values6, typeSpecName, componentName, location, null, ReactPropTypesSecret);
          } catch (ex) {
            error2 = ex;
          }
          if (error2 && !(error2 instanceof Error)) {
            printWarning(
              (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error2 + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            );
          }
          if (error2 instanceof Error && !(error2.message in loggedTypeFailures)) {
            loggedTypeFailures[error2.message] = true;
            var stack2 = getStack ? getStack() : "";
            printWarning(
              "Failed " + location + " type: " + error2.message + (stack2 != null ? stack2 : "")
            );
          }
        }
      }
    }
  }
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== "production") {
      loggedTypeFailures = {};
    }
  };
  checkPropTypes_1 = checkPropTypes;
  return checkPropTypes_1;
}
var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers)
    return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var ReactIs = requireReactIs();
  var assign4 = requireObjectAssign();
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  var has7 = requireHas();
  var checkPropTypes = requireCheckPropTypes();
  var printWarning = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    printWarning = function(text2) {
      var message = "Warning: " + text2;
      if (typeof console !== "undefined") {
        console.error(message);
      }
      try {
        throw new Error(message);
      } catch (x3) {
      }
    };
  }
  function emptyFunctionThatReturnsNull() {
    return null;
  }
  factoryWithTypeCheckers = function(isValidElement2, throwOnDirectAccess) {
    var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === "function") {
        return iteratorFn;
      }
    }
    var ANONYMOUS = "<<anonymous>>";
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker("array"),
      bigint: createPrimitiveTypeChecker("bigint"),
      bool: createPrimitiveTypeChecker("boolean"),
      func: createPrimitiveTypeChecker("function"),
      number: createPrimitiveTypeChecker("number"),
      object: createPrimitiveTypeChecker("object"),
      string: createPrimitiveTypeChecker("string"),
      symbol: createPrimitiveTypeChecker("symbol"),
      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker
    };
    function is3(x3, y4) {
      if (x3 === y4) {
        return x3 !== 0 || 1 / x3 === 1 / y4;
      } else {
        return x3 !== x3 && y4 !== y4;
      }
    }
    function PropTypeError(message, data) {
      this.message = message;
      this.data = data && typeof data === "object" ? data : {};
      this.stack = "";
    }
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== "production") {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props2, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;
        if (secret !== ReactPropTypesSecret) {
          if (throwOnDirectAccess) {
            var err = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            err.name = "Invariant Violation";
            throw err;
          } else if (process.env.NODE_ENV !== "production" && typeof console !== "undefined") {
            var cacheKey2 = componentName + ":" + propName;
            if (!manualPropTypeCallCache[cacheKey2] && // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3) {
              printWarning(
                "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              );
              manualPropTypeCallCache[cacheKey2] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props2[propName] == null) {
          if (isRequired) {
            if (props2[propName] === null) {
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
            }
            return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
          }
          return null;
        } else {
          return validate(props2, propName, componentName, location, propFullName);
        }
      }
      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);
      return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
      function validate(props2, propName, componentName, location, propFullName, secret) {
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          var preciseType = getPreciseType(propValue);
          return new PropTypeError(
            "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
            { expectedType }
          );
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
      function validate(props2, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
        }
        var propValue = props2[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
        }
        for (var i2 = 0; i2 < propValue.length; i2++) {
          var error2 = typeChecker(propValue, i2, componentName, location, propFullName + "[" + i2 + "]", ReactPropTypesSecret);
          if (error2 instanceof Error) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
      function validate(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        if (!isValidElement2(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
      function validate(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        if (!ReactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
      function validate(props2, propName, componentName, location, propFullName) {
        if (!(props2[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props2[propName]);
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== "production") {
          if (arguments.length > 1) {
            printWarning(
              "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
            );
          } else {
            printWarning("Invalid argument supplied to oneOf, expected an array.");
          }
        }
        return emptyFunctionThatReturnsNull;
      }
      function validate(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        for (var i2 = 0; i2 < expectedValues.length; i2++) {
          if (is3(propValue, expectedValues[i2])) {
            return null;
          }
        }
        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type2 = getPreciseType(value);
          if (type2 === "symbol") {
            return String(value);
          }
          return value;
        });
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
      function validate(props2, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== "function") {
          return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
        }
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
        }
        for (var key in propValue) {
          if (has7(propValue, key)) {
            var error2 = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error2 instanceof Error) {
              return error2;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== "production" ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
        return emptyFunctionThatReturnsNull;
      }
      for (var i2 = 0; i2 < arrayOfTypeCheckers.length; i2++) {
        var checker = arrayOfTypeCheckers[i2];
        if (typeof checker !== "function") {
          printWarning(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i2 + "."
          );
          return emptyFunctionThatReturnsNull;
        }
      }
      function validate(props2, propName, componentName, location, propFullName) {
        var expectedTypes = [];
        for (var i3 = 0; i3 < arrayOfTypeCheckers.length; i3++) {
          var checker2 = arrayOfTypeCheckers[i3];
          var checkerResult = checker2(props2, propName, componentName, location, propFullName, ReactPropTypesSecret);
          if (checkerResult == null) {
            return null;
          }
          if (checkerResult.data && has7(checkerResult.data, "expectedType")) {
            expectedTypes.push(checkerResult.data.expectedType);
          }
        }
        var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
        return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
      }
      return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
      function validate(props2, propName, componentName, location, propFullName) {
        if (!isNode(props2[propName])) {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type2) {
      return new PropTypeError(
        (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type2 + "`."
      );
    }
    function createShapeTypeChecker(shapeTypes) {
      function validate(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props2, propName, componentName, location, propFullName) {
        var propValue = props2[propName];
        var propType = getPropType(propValue);
        if (propType !== "object") {
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
        }
        var allKeys = assign4({}, props2[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (has7(shapeTypes, key) && typeof checker !== "function") {
            return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
          }
          if (!checker) {
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props2[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
            );
          }
          var error2 = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
          if (error2) {
            return error2;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
      switch (typeof propValue) {
        case "number":
        case "string":
        case "undefined":
          return true;
        case "boolean":
          return !propValue;
        case "object":
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement2(propValue)) {
            return true;
          }
          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step2;
            if (iteratorFn !== propValue.entries) {
              while (!(step2 = iterator.next()).done) {
                if (!isNode(step2.value)) {
                  return false;
                }
              }
            } else {
              while (!(step2 = iterator.next()).done) {
                var entry = step2.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }
          return true;
        default:
          return false;
      }
    }
    function isSymbol2(propType, propValue) {
      if (propType === "symbol") {
        return true;
      }
      if (!propValue) {
        return false;
      }
      if (propValue["@@toStringTag"] === "Symbol") {
        return true;
      }
      if (typeof Symbol === "function" && propValue instanceof Symbol) {
        return true;
      }
      return false;
    }
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return "array";
      }
      if (propValue instanceof RegExp) {
        return "object";
      }
      if (isSymbol2(propType, propValue)) {
        return "symbol";
      }
      return propType;
    }
    function getPreciseType(propValue) {
      if (typeof propValue === "undefined" || propValue === null) {
        return "" + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === "object") {
        if (propValue instanceof Date) {
          return "date";
        } else if (propValue instanceof RegExp) {
          return "regexp";
        }
      }
      return propType;
    }
    function getPostfixForTypeWarning(value) {
      var type2 = getPreciseType(value);
      switch (type2) {
        case "array":
        case "object":
          return "an " + type2;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + type2;
        default:
          return type2;
      }
    }
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithTypeCheckers;
}
var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims)
    return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var ReactPropTypesSecret = requireReactPropTypesSecret();
  function emptyFunction() {
  }
  function emptyFunctionWithReset() {
  }
  emptyFunctionWithReset.resetWarningCache = emptyFunction;
  factoryWithThrowingShims = function() {
    function shim2(props2, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret) {
        return;
      }
      var err = new Error(
        "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
      );
      err.name = "Invariant Violation";
      throw err;
    }
    shim2.isRequired = shim2;
    function getShim() {
      return shim2;
    }
    var ReactPropTypes = {
      array: shim2,
      bigint: shim2,
      bool: shim2,
      func: shim2,
      number: shim2,
      object: shim2,
      string: shim2,
      symbol: shim2,
      any: shim2,
      arrayOf: getShim,
      element: shim2,
      elementType: shim2,
      instanceOf: getShim,
      node: shim2,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,
      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
  };
  return factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs();
  var throwOnDirectAccess = true;
  propTypes$1.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  propTypes$1.exports = requireFactoryWithThrowingShims()();
}
var propTypesExports = propTypes$1.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
const MASK_PROPS = {
  // common
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.string, PropTypes.instanceOf(RegExp), PropTypes.oneOf([Date, Number, IMask.Masked]), PropTypes.instanceOf(IMask.Masked)]),
  value: PropTypes.any,
  unmask: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["typed"])]),
  prepare: PropTypes.func,
  prepareChar: PropTypes.func,
  validate: PropTypes.func,
  commit: PropTypes.func,
  overwrite: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["shift"])]),
  eager: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["append", "remove"])]),
  skipInvalid: PropTypes.bool,
  // events
  onAccept: PropTypes.func,
  onComplete: PropTypes.func,
  // pattern
  placeholderChar: PropTypes.string,
  displayChar: PropTypes.string,
  lazy: PropTypes.bool,
  definitions: PropTypes.object,
  blocks: PropTypes.object,
  // enum
  enum: PropTypes.arrayOf(PropTypes.string),
  // range
  maxLength: PropTypes.number,
  from: PropTypes.number,
  to: PropTypes.number,
  // date
  pattern: PropTypes.string,
  format: PropTypes.func,
  parse: PropTypes.func,
  autofix: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(["pad"])]),
  // number
  radix: PropTypes.string,
  thousandsSeparator: PropTypes.string,
  mapToRadix: PropTypes.arrayOf(PropTypes.string),
  scale: PropTypes.number,
  normalizeZeros: PropTypes.bool,
  padFractionalZeros: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  // dynamic
  dispatch: PropTypes.func,
  // ref
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })])
};
const MASK_PROPS_NAMES = Object.keys(MASK_PROPS).filter((p) => p !== "value");
const NON_MASK_OPTIONS_NAMES = ["value", "unmask", "onAccept", "onComplete", "inputRef"];
const MASK_OPTIONS_NAMES = MASK_PROPS_NAMES.filter((pName) => NON_MASK_OPTIONS_NAMES.indexOf(pName) < 0);
function IMaskMixin(ComposedComponent) {
  var _Class;
  const MaskedComponent = (_Class = class MaskedComponent extends React__default.Component {
    constructor(props2) {
      super(props2);
      this._inputRef = this._inputRef.bind(this);
    }
    componentDidMount() {
      if (!this.props.mask)
        return;
      this.initMask();
    }
    componentDidUpdate() {
      const props2 = this.props;
      const maskOptions = this._extractMaskOptionsFromProps(props2);
      if (maskOptions.mask) {
        if (this.maskRef) {
          this.maskRef.updateOptions(maskOptions);
          if ("value" in props2 && props2.value !== void 0)
            this.maskValue = props2.value;
        } else {
          this.initMask(maskOptions);
        }
      } else {
        this.destroyMask();
        if ("value" in props2 && props2.value !== void 0) {
          var _this$element;
          if ((_this$element = this.element) != null && _this$element.isContentEditable && this.element.tagName !== "INPUT" && this.element.tagName !== "TEXTAREA")
            this.element.textContent = props2.value;
          else
            this.element.value = props2.value;
        }
      }
    }
    componentWillUnmount() {
      this.destroyMask();
    }
    _inputRef(el) {
      this.element = el;
      if (this.props.inputRef) {
        if (Object.prototype.hasOwnProperty.call(this.props.inputRef, "current"))
          this.props.inputRef.current = el;
        else
          this.props.inputRef(el);
      }
    }
    initMask(maskOptions) {
      if (maskOptions === void 0) {
        maskOptions = this._extractMaskOptionsFromProps(this.props);
      }
      this.maskRef = IMask(this.element, maskOptions).on("accept", this._onAccept.bind(this)).on("complete", this._onComplete.bind(this));
      if ("value" in this.props && this.props.value !== void 0)
        this.maskValue = this.props.value;
    }
    destroyMask() {
      if (this.maskRef) {
        this.maskRef.destroy();
        delete this.maskRef;
      }
    }
    _extractMaskOptionsFromProps(props2) {
      const {
        ...cloneProps
      } = props2;
      Object.keys(cloneProps).filter((prop) => MASK_OPTIONS_NAMES.indexOf(prop) < 0).forEach((nonMaskProp) => {
        delete cloneProps[nonMaskProp];
      });
      return cloneProps;
    }
    _extractNonMaskProps(props2) {
      const {
        ...cloneProps
      } = props2;
      MASK_PROPS_NAMES.forEach((maskProp) => {
        if (maskProp !== "maxLength")
          delete cloneProps[maskProp];
      });
      if (!("defaultValue" in cloneProps))
        cloneProps.defaultValue = props2.mask ? "" : cloneProps.value;
      delete cloneProps.value;
      return cloneProps;
    }
    get maskValue() {
      if (!this.maskRef)
        return "";
      if (this.props.unmask === "typed")
        return this.maskRef.typedValue;
      if (this.props.unmask)
        return this.maskRef.unmaskedValue;
      return this.maskRef.value;
    }
    set maskValue(value) {
      if (!this.maskRef)
        return;
      value = value == null && this.props.unmask !== "typed" ? "" : value;
      if (this.props.unmask === "typed")
        this.maskRef.typedValue = value;
      else if (this.props.unmask)
        this.maskRef.unmaskedValue = value;
      else
        this.maskRef.value = value;
    }
    _onAccept(e3) {
      if (this.props.onAccept && this.maskRef)
        this.props.onAccept(this.maskValue, this.maskRef, e3);
    }
    _onComplete(e3) {
      if (this.props.onComplete && this.maskRef)
        this.props.onComplete(this.maskValue, this.maskRef, e3);
    }
    render() {
      return React__default.createElement(ComposedComponent, {
        ...this._extractNonMaskProps(this.props),
        inputRef: this._inputRef
      });
    }
  }, _Class.displayName = void 0, _Class.propTypes = void 0, _Class);
  const nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || "Component";
  MaskedComponent.displayName = "IMask(" + nestedComponentName + ")";
  MaskedComponent.propTypes = MASK_PROPS;
  return React__default.forwardRef((props2, ref2) => React__default.createElement(MaskedComponent, {
    ...props2,
    ref: ref2
  }));
}
const IMaskInputClass = IMaskMixin((_ref2) => {
  let {
    inputRef,
    ...props2
  } = _ref2;
  return React__default.createElement("input", {
    ...props2,
    ref: inputRef
  });
});
const IMaskInputFn = (props2, ref2) => React__default.createElement(IMaskInputClass, {
  ...props2,
  ref: ref2
});
React__default.forwardRef(IMaskInputFn);
function useIMask(opts, _temp) {
  let {
    onAccept,
    onComplete
  } = _temp === void 0 ? {} : _temp;
  const ref2 = useRef(null);
  const maskRef = useRef(null);
  const [initialized, setInitialized] = useState(false);
  const [lastAcceptState, setLastAcceptState] = useState({});
  const [value, setValue] = useState("");
  const [unmaskedValue, setUnmaskedValue] = useState("");
  const [typedValue, setTypedValue] = useState();
  const _destroyMask = useCallback(() => {
    var _maskRef$current;
    if (!initialized)
      return;
    (_maskRef$current = maskRef.current) == null || _maskRef$current.destroy();
    maskRef.current = null;
  }, []);
  const _onAccept = useCallback((event2) => {
    const m3 = maskRef.current;
    if (!m3)
      return;
    setLastAcceptState({
      value: m3.value,
      unmaskedValue: m3.unmaskedValue,
      typedValue: m3.typedValue
    });
    setTypedValue(m3.typedValue);
    setUnmaskedValue(m3.unmaskedValue);
    setValue(m3.value);
    onAccept == null || onAccept(m3.value, m3, event2);
  }, [onAccept]);
  const _onComplete = useCallback((event2) => maskRef.current && (onComplete == null ? void 0 : onComplete(maskRef.current.value, maskRef.current, event2)), [onComplete]);
  useEffect(() => {
    const el = ref2.current;
    if (!el || !(opts != null && opts.mask))
      return _destroyMask();
    const mask = maskRef.current;
    if (!mask) {
      if (el && opts != null && opts.mask) {
        maskRef.current = IMask(el, opts);
        _onAccept();
      }
    } else {
      mask == null || mask.updateOptions(opts);
    }
    setInitialized(Boolean(maskRef.current));
  }, [opts, _destroyMask, _onAccept]);
  useEffect(() => {
    if (!maskRef.current)
      return;
    const mask = maskRef.current;
    mask.on("accept", _onAccept);
    mask.on("complete", _onComplete);
    return () => {
      mask.off("accept", _onAccept);
      mask.off("complete", _onComplete);
    };
  }, [_onAccept, _onComplete]);
  useEffect(() => {
    const {
      value: lastAcceptValue,
      ...state
    } = lastAcceptState;
    const mask = maskRef.current;
    if (mask && initialized) {
      if (lastAcceptValue !== value)
        mask.value = value;
      setLastAcceptState(state);
    }
  }, [value]);
  useEffect(() => {
    const {
      unmaskedValue: lastAcceptUnmaskedValue,
      ...state
    } = lastAcceptState;
    const mask = maskRef.current;
    if (mask && initialized) {
      if (lastAcceptUnmaskedValue !== unmaskedValue)
        mask.unmaskedValue = unmaskedValue;
      setLastAcceptState(state);
    }
  }, [unmaskedValue]);
  useEffect(() => {
    const {
      typedValue: lastAcceptTypedValue,
      ...state
    } = lastAcceptState;
    const mask = maskRef.current;
    if (mask && initialized) {
      if (lastAcceptTypedValue !== typedValue)
        mask.typedValue = typedValue;
      setLastAcceptState(state);
    }
  }, [typedValue]);
  useEffect(() => _destroyMask, [_destroyMask]);
  return {
    ref: ref2,
    maskRef,
    value,
    setValue,
    unmaskedValue,
    setUnmaskedValue,
    typedValue,
    setTypedValue
  };
}
const Input2 = React__default.forwardRef(
  ({
    disabled,
    height = InputHeights.default,
    postIcon = null,
    preIcon = null,
    name: name2 = "",
    onBlur: onBlur3 = noop$6,
    onChange = noop$6,
    onClick = noop$6,
    placeholder = void 0,
    sx: sx2 = {},
    sxInputElement = {},
    type: type2 = "text",
    variant: variant3 = FormInputVariants.default,
    validate = noop$6,
    maskOptions = void 0,
    onMaskComplete = void 0,
    onMaskAccept = void 0,
    isDatePicker = false,
    ...restOfProps
  }, inputRef) => {
    const { style: wrapperStyle } = useStyle(sx2);
    const { style: inputStyle } = useStyle(sxInputElement);
    const { field, meta, helpers } = useGuiField({
      name: name2,
      validate,
      type: type2
    });
    const initialValue2 = useMemo(() => {
      if (meta == null ? void 0 : meta.initialValue) {
        return meta.initialValue;
      }
      return "";
    }, [meta]);
    const handleBlur = useEventCallback$1((event2) => field == null ? void 0 : field.onBlur(event2), onBlur3, [
      onBlur3
    ]);
    const handleChange = useEventCallback$1(
      (event2) => {
        var _a2;
        if (!isMasked2) {
          (_a2 = field == null ? void 0 : field.onChange) == null ? void 0 : _a2.call(field, event2);
        }
      },
      onChange,
      [onChange]
    );
    const handleClick = useCallback((event2) => onClick == null ? void 0 : onClick(event2), [onClick]);
    const currentVariant = useFieldVariant(variant3, meta);
    const { ref: ref2, setTypedValue, maskRef } = useIMask(
      maskOptions,
      {
        onAccept(_value, maskRef2, _e) {
          helpers == null ? void 0 : helpers.setValue(maskRef2.unmaskedValue);
          if (onMaskAccept) {
            onMaskAccept(_value, maskRef2, _e);
          }
        },
        onComplete(value, maskRef2, e3) {
          if (onMaskComplete) {
            onMaskComplete(value, maskRef2, e3);
          }
        }
      }
    );
    const isMasked2 = useMemo(() => {
      return !isEmpty$1(maskOptions) && !!(maskOptions == null ? void 0 : maskOptions.mask) || isDatePicker;
    }, [maskOptions, isDatePicker]);
    useEffect(() => {
      var _a2;
      if (!isMasked2)
        return;
      if ((field == null ? void 0 : field.value) !== void 0 && ((_a2 = maskRef.current) == null ? void 0 : _a2.unmaskedValue) !== field.value) {
        const setFormikValue = async () => helpers == null ? void 0 : helpers.setValue(field.value);
        setFormikValue().then(() => {
          setTypedValue(field.value);
        });
      }
    }, [field == null ? void 0 : field.value, isMasked2, initialValue2]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box$1,
      {
        "data-test-id": `input-wrapper--${name2}`,
        sx: wrapperStyle(styles$o.wrapper),
        variant: `forms.${currentVariant}.wrapperStyles`,
        children: [
          preIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Label2,
            {
              htmlFor: name2 || "",
              sx: styles$o.iconWrapper(height, true, disabled),
              children: cloneValidElement(preIcon, {
                "data-test-id": `input-pre-icon--${name2}`
              })
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$1,
            {
              "aria-disabled": disabled,
              "data-test-id": `input--${name2}`,
              disabled,
              id: name2,
              name: name2,
              placeholder,
              ref: (node2) => {
                if (ref2) {
                  ref2.current = node2;
                }
                if (typeof inputRef === "function") {
                  inputRef(node2);
                } else if (inputRef) {
                  inputRef.current = node2;
                }
              },
              sx: inputStyle(
                styles$o.input(
                  height,
                  isValidElement(preIcon),
                  currentVariant,
                  disabled
                )
              ),
              type: type2,
              variant: `forms.${currentVariant}.inputStyles`,
              ...restOfProps,
              ...!isMasked2 ? { ...field } : {},
              onBlur: handleBlur,
              onChange: handleChange,
              onClick: handleClick
            }
          ),
          postIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Label2,
            {
              htmlFor: name2 || "",
              sx: styles$o.iconWrapper(height, false, disabled),
              children: cloneValidElement(postIcon, {
                "data-test-id": `input-post-icon--${name2}`
              })
            }
          )
        ]
      }
    );
  }
);
const styles$o = {
  wrapper: {
    position: "relative",
    border: "none"
  },
  iconWrapper: (height, forPreIcon, disabled) => ({
    position: "absolute",
    top: "0",
    height: `input.${height}.height`,
    cursor: disabled ? "not-allowed" : "text",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "3rem",
    right: forPreIcon ? null : "0"
  }),
  input: (height, preIcon, variant3, disabled) => ({
    backgroundColor: disabled ? "forms.disabled.background" : null,
    borderColor: disabled ? "forms.disabled.border" : null,
    color: disabled ? "forms.disabled.text" : "text.primary",
    cursor: disabled ? "not-allowed" : "inherit",
    height: `input.${height}.height`,
    paddingX: `input.${height}.paddingX`,
    paddingY: `input.${height}.paddingY`,
    paddingLeft: preIcon ? "48px" : null,
    "&:hover": {
      borderColor: !disabled ? `forms.${variant3}.border.hover` : null
    },
    "&:focus": {
      borderColor: `forms.${variant3}.border.active`,
      outline: "none"
    }
  })
};
var InputTypes = /* @__PURE__ */ ((InputTypes2) => {
  InputTypes2["date"] = "date";
  InputTypes2["email"] = "email";
  InputTypes2["hidden"] = "hidden";
  InputTypes2["number"] = "number";
  InputTypes2["password"] = "password";
  InputTypes2["radio"] = "radio";
  InputTypes2["text"] = "text";
  InputTypes2["tel"] = "tel";
  return InputTypes2;
})(InputTypes || {});
const CompoundInput = Object.assign({}, Input2, {
  type: InputTypes,
  height: InputHeights
});
const baseButtonGroupStyles = {
  label: {
    alignItems: "center",
    border: "solid 1px",
    borderColor: "border.subdued",
    borderRight: "0",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    padding: ".5rem 1rem",
    width: "inherit",
    "&:first-of-type": {
      borderBottomLeftRadius: baseRadii[4],
      borderTopLeftRadius: baseRadii[4]
    },
    "&:last-of-type": {
      borderBottomRightRadius: baseRadii[4],
      borderRight: "solid 1px",
      // this must be below borderRight property
      borderColor: "border.subdued",
      borderTopRightRadius: baseRadii[4]
    },
    "&:hover": {
      backgroundColor: "surface.neutral"
    },
    "&:focus:not(:disabled)": {
      boxShadow: "two-pixel-soft",
      outline: "none",
      zIndex: "sticky"
    }
  },
  radio: {
    height: 0,
    visibility: "hidden",
    width: 0
  },
  checked: {
    backgroundColor: "surface.neutral",
    borderColor: "border.tertiary",
    borderRight: "border.tertiary",
    color: "text.primary",
    // prevent double-borders for active labels, except for the last element
    "&-label": {
      borderRight: 0
    },
    "&+label": {
      borderLeft: 0
    },
    "&:last-of-type": {
      borderColor: "border.tertiary",
      backgroundColor: "surface.neutral",
      color: "text.primary",
      borderBottomRightRadius: "4px",
      borderTopRightRadius: "4px"
    }
  },
  disabled: {
    cursor: "default",
    "&:hover": {
      backgroundColor: "fog-00"
    }
  }
};
const superRadioVariants = {
  [
    "default"
    /* default */
  ]: {
    ...baseButtonGroupStyles
  }
};
const Radio$1 = ({
  checked,
  disabled = false,
  id,
  label: label2,
  onChangeGroup,
  value,
  ...rest
}) => {
  const uniqueId2 = `${id}-${value}`;
  const isChecked = checked === value;
  const checkedStyles = isChecked ? superRadioVariants.default.checked : {};
  const disabledStyles2 = disabled ? superRadioVariants.default.disabled : {};
  let color2 = TextColors.primary;
  if (checked && !isChecked) {
    color2 = TextColors.tertiary;
  } else if (disabled) {
    color2 = TextColors.disable;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Label2,
    {
      color: color2,
      "data-checkbox-state": disabled ? "disabled" : "active",
      "data-test-id": `${uniqueId2}-label`,
      htmlFor: uniqueId2,
      sx: {
        ...superRadioVariants.default.label,
        ...checkedStyles,
        ...disabledStyles2
      },
      children: [
        label2,
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundInput,
          {
            "aria-checked": isChecked ? "mixed" : false,
            "aria-labelledby": uniqueId2,
            checked: isChecked,
            "data-test-id": `${uniqueId2}-radio`,
            disabled,
            id: uniqueId2,
            name: value,
            onChange: onChangeGroup,
            sx: { ...superRadioVariants.default.radio },
            type: InputTypes.radio,
            value,
            ...rest
          }
        )
      ]
    }
  );
};
const ButtonGroup = ({
  disabled = false,
  onChange,
  options: options2,
  value
}) => {
  const [checked, setChecked] = useState(value ?? "");
  const id = uniqueId$1("button-group");
  const onChangeGroup = useCallback(
    (event2) => {
      setChecked(event2.target.value);
      onChange == null ? void 0 : onChange(event2);
    },
    []
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { id, children: options2.map((option) => {
    return /* @__PURE__ */ createElement(
      Radio$1,
      {
        ...option,
        checked,
        disabled,
        id,
        key: option.value,
        onChangeGroup
      }
    );
  }) });
};
ButtonGroup.Radio = Radio$1;
const Container$1 = ({
  children: children2 = null,
  sx: sx2 = {},
  variant: variant3 = ContainerVariants.fluid,
  direction = "row"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flexDirection: direction, sx: sx2, variant: `container.${variant3}`, children: children2 });
};
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number2 = Number(dirtyNumber);
  if (isNaN(number2)) {
    return number2;
  }
  return number2 < 0 ? Math.ceil(number2) : Math.floor(number2);
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
  }
}
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || _typeof(argument) === "object" && argStr === "[object Date]") {
    return new Date(argument.getTime());
  } else if (typeof argument === "number" || argStr === "[object Number]") {
    return new Date(argument);
  } else {
    if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      console.warn(new Error().stack);
    }
    return /* @__PURE__ */ new Date(NaN);
  }
}
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date2;
  }
  date2.setDate(date2.getDate() + amount);
  return date2;
}
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}
function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1e3);
}
var MILLISECONDS_IN_MINUTE = 6e4;
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}
var MILLISECONDS_IN_HOUR = 36e5;
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  if (!amount) {
    return date2;
  }
  var dayOfMonth = date2.getDate();
  var endOfDesiredMonth = new Date(date2.getTime());
  endOfDesiredMonth.setMonth(date2.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    date2.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date2;
  }
}
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign2 = compareAsc(dateLeft, dateRight);
  var difference2 = Math.abs(differenceInCalendarYears(dateLeft, dateRight));
  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584);
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign2;
  var result = sign2 * (difference2 - Number(isLastYearNotFull));
  return result === 0 ? 0 : result;
}
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  date2.setHours(23, 59, 59, 999);
  return date2;
}
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var month = date2.getMonth();
  date2.setFullYear(date2.getFullYear(), month + 1, 0);
  date2.setHours(23, 59, 59, 999);
  return date2;
}
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  return endOfDay(date2).getTime() === endOfMonth(date2).getTime();
}
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign2 = compareAsc(dateLeft, dateRight);
  var difference2 = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result;
  if (difference2 < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      dateLeft.setDate(30);
    }
    dateLeft.setMonth(dateLeft.getMonth() - sign2 * difference2);
    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign2;
    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference2 === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }
    result = sign2 * (difference2 - Number(isLastMonthNotFull));
  }
  return result === 0 ? 0 : result;
}
var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function trunc(value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  }
  // Math.trunc is not supported by IE
};
var defaultRoundingMethod = "trunc";
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}
function differenceInQuarters(dateLeft, dateRight, options2) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options2 === null || options2 === void 0 ? void 0 : options2.roundingMethod)(diff);
}
function getTimezoneOffsetInMilliseconds(date2) {
  var utcDate2 = new Date(Date.UTC(date2.getFullYear(), date2.getMonth(), date2.getDate(), date2.getHours(), date2.getMinutes(), date2.getSeconds(), date2.getMilliseconds()));
  utcDate2.setUTCFullYear(date2.getFullYear());
  return date2.getTime() - utcDate2.getTime();
}
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
var MILLISECONDS_IN_DAY$1 = 864e5;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign2 = compareLocalAsc(dateLeft, dateRight);
  var difference2 = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign2 * difference2);
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign2);
  var result = sign2 * (difference2 - isLastDayNotFull);
  return result === 0 ? 0 : result;
}
function differenceInWeeks(dateLeft, dateRight, options2) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options2 === null || options2 === void 0 ? void 0 : options2.roundingMethod)(diff);
}
var millisecondsInMinute = 6e4;
var millisecondsInHour = 36e5;
var millisecondsInSecond = 1e3;
function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}
function differenceInHours(dateLeft, dateRight, options2) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options2 === null || options2 === void 0 ? void 0 : options2.roundingMethod)(diff);
}
function differenceInMinutes(dateLeft, dateRight, options2) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options2 === null || options2 === void 0 ? void 0 : options2.roundingMethod)(diff);
}
function differenceInSeconds(dateLeft, dateRight, options2) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1e3;
  return getRoundingMethod(options2 === null || options2 === void 0 ? void 0 : options2.roundingMethod)(diff);
}
function eachDayOfInterval(dirtyInterval, options2) {
  var _options$step;
  requiredArgs(1, arguments);
  var interval2 = dirtyInterval || {};
  var startDate = toDate(interval2.start);
  var endDate = toDate(interval2.end);
  var endTime = endDate.getTime();
  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step2 = Number((_options$step = options2 === null || options2 === void 0 ? void 0 : options2.step) !== null && _options$step !== void 0 ? _options$step : 1);
  if (step2 < 1 || isNaN(step2))
    throw new RangeError("`options.step` must be a number greater than 1");
  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step2);
    currentDate.setHours(0, 0, 0, 0);
  }
  return dates;
}
var defaultOptions$2 = {};
function getDefaultOptions() {
  return defaultOptions$2;
}
function endOfWeek(dirtyDate, options2) {
  var _ref2, _ref22, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref2 = (_ref22 = (_ref3 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date2.setDate(date2.getDate() + diff);
  date2.setHours(23, 59, 59, 999);
  return date2;
}
function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getFullYear();
  date2.setFullYear(year + 1, 0, 0);
  date2.setHours(23, 59, 59, 999);
  return date2;
}
function isDate$3(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate$3(dirtyDate) && typeof dirtyDate !== "number") {
    return false;
  }
  var date2 = toDate(dirtyDate);
  return !isNaN(Number(date2));
}
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}
var MILLISECONDS_IN_DAY = 864e5;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var timestamp = date2.getTime();
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date2.getTime();
  var difference2 = timestamp - startOfYearTimestamp;
  return Math.floor(difference2 / MILLISECONDS_IN_DAY) + 1;
}
function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date2 = toDate(dirtyDate);
  var day = date2.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setUTCDate(date2.getUTCDate() - diff);
  date2.setUTCHours(0, 0, 0, 0);
  return date2;
}
function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = /* @__PURE__ */ new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = /* @__PURE__ */ new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCISOWeek(fourthOfJanuary);
  return date2;
}
var MILLISECONDS_IN_WEEK$1 = 6048e5;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date2).getTime() - startOfUTCISOWeekYear(date2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}
function startOfUTCWeek(dirtyDate, options2) {
  var _ref2, _ref22, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref2 = (_ref22 = (_ref3 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setUTCDate(date2.getUTCDate() - diff);
  date2.setUTCHours(0, 0, 0, 0);
  return date2;
}
function getUTCWeekYear(dirtyDate, options2) {
  var _ref2, _ref22, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getUTCFullYear();
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref2 = (_ref22 = (_ref3 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var firstWeekOfNextYear = /* @__PURE__ */ new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options2);
  var firstWeekOfThisYear = /* @__PURE__ */ new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options2);
  if (date2.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date2.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfUTCWeekYear(dirtyDate, options2) {
  var _ref2, _ref22, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref2 = (_ref22 = (_ref3 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
  var year = getUTCWeekYear(dirtyDate, options2);
  var firstWeek = /* @__PURE__ */ new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date2 = startOfUTCWeek(firstWeek, options2);
  return date2;
}
var MILLISECONDS_IN_WEEK = 6048e5;
function getUTCWeek(dirtyDate, options2) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var diff = startOfUTCWeek(date2, options2).getTime() - startOfUTCWeekYear(date2, options2).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
function addLeadingZeros(number2, targetLength) {
  var sign2 = number2 < 0 ? "-" : "";
  var output = Math.abs(number2).toString();
  while (output.length < targetLength) {
    output = "0" + output;
  }
  return sign2 + output;
}
var formatters$1 = {
  // Year
  y: function y(date2, token2) {
    var signedYear = date2.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token2 === "yy" ? year % 100 : year, token2.length);
  },
  // Month
  M: function M(date2, token2) {
    var month = date2.getUTCMonth();
    return token2 === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date2, token2) {
    return addLeadingZeros(date2.getUTCDate(), token2.length);
  },
  // AM or PM
  a: function a(date2, token2) {
    var dayPeriodEnumValue = date2.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function h(date2, token2) {
    return addLeadingZeros(date2.getUTCHours() % 12 || 12, token2.length);
  },
  // Hour [0-23]
  H: function H(date2, token2) {
    return addLeadingZeros(date2.getUTCHours(), token2.length);
  },
  // Minute
  m: function m(date2, token2) {
    return addLeadingZeros(date2.getUTCMinutes(), token2.length);
  },
  // Second
  s: function s(date2, token2) {
    return addLeadingZeros(date2.getUTCSeconds(), token2.length);
  },
  // Fraction of second
  S: function S(date2, token2) {
    var numberOfDigits = token2.length;
    var milliseconds = date2.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token2.length);
  }
};
const formatters$2 = formatters$1;
var dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
var formatters = {
  // Era
  G: function G(date2, token2, localize2) {
    var era = date2.getUTCFullYear() > 0 ? 1 : 0;
    switch (token2) {
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, {
          width: "abbreviated"
        });
      case "GGGGG":
        return localize2.era(era, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return localize2.era(era, {
          width: "wide"
        });
    }
  },
  // Year
  y: function y2(date2, token2, localize2) {
    if (token2 === "yo") {
      var signedYear = date2.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, {
        unit: "year"
      });
    }
    return formatters$2.y(date2, token2);
  },
  // Local week-numbering year
  Y: function Y(date2, token2, localize2, options2) {
    var signedWeekYear = getUTCWeekYear(date2, options2);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token2 === "YY") {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token2 === "Yo") {
      return localize2.ordinalNumber(weekYear, {
        unit: "year"
      });
    }
    return addLeadingZeros(weekYear, token2.length);
  },
  // ISO week-numbering year
  R: function R(date2, token2) {
    var isoWeekYear = getUTCISOWeekYear(date2);
    return addLeadingZeros(isoWeekYear, token2.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date2, token2) {
    var year = date2.getUTCFullYear();
    return addLeadingZeros(year, token2.length);
  },
  // Quarter
  Q: function Q(date2, token2, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "Q":
        return String(quarter);
      case "QQ":
        return addLeadingZeros(quarter, 2);
      case "Qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function q(date2, token2, localize2) {
    var quarter = Math.ceil((date2.getUTCMonth() + 1) / 3);
    switch (token2) {
      case "q":
        return String(quarter);
      case "qq":
        return addLeadingZeros(quarter, 2);
      case "qo":
        return localize2.ordinalNumber(quarter, {
          unit: "quarter"
        });
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function M2(date2, token2, localize2) {
    var month = date2.getUTCMonth();
    switch (token2) {
      case "M":
      case "MM":
        return formatters$2.M(date2, token2);
      case "Mo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function L(date2, token2, localize2) {
    var month = date2.getUTCMonth();
    switch (token2) {
      case "L":
        return String(month + 1);
      case "LL":
        return addLeadingZeros(month + 1, 2);
      case "Lo":
        return localize2.ordinalNumber(month + 1, {
          unit: "month"
        });
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return localize2.month(month, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function w(date2, token2, localize2, options2) {
    var week = getUTCWeek(date2, options2);
    if (token2 === "wo") {
      return localize2.ordinalNumber(week, {
        unit: "week"
      });
    }
    return addLeadingZeros(week, token2.length);
  },
  // ISO week of year
  I: function I(date2, token2, localize2) {
    var isoWeek = getUTCISOWeek(date2);
    if (token2 === "Io") {
      return localize2.ordinalNumber(isoWeek, {
        unit: "week"
      });
    }
    return addLeadingZeros(isoWeek, token2.length);
  },
  // Day of the month
  d: function d2(date2, token2, localize2) {
    if (token2 === "do") {
      return localize2.ordinalNumber(date2.getUTCDate(), {
        unit: "date"
      });
    }
    return formatters$2.d(date2, token2);
  },
  // Day of year
  D: function D(date2, token2, localize2) {
    var dayOfYear = getUTCDayOfYear(date2);
    if (token2 === "Do") {
      return localize2.ordinalNumber(dayOfYear, {
        unit: "dayOfYear"
      });
    }
    return addLeadingZeros(dayOfYear, token2.length);
  },
  // Day of week
  E: function E(date2, token2, localize2) {
    var dayOfWeek = date2.getUTCDay();
    switch (token2) {
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function e(date2, token2, localize2, options2) {
    var dayOfWeek = date2.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "e":
        return String(localDayOfWeek);
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date2, token2, localize2, options2) {
    var dayOfWeek = date2.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options2.weekStartsOn + 8) % 7 || 7;
    switch (token2) {
      case "c":
        return String(localDayOfWeek);
      case "cc":
        return addLeadingZeros(localDayOfWeek, token2.length);
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, {
          unit: "day"
        });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function i(date2, token2, localize2) {
    var dayOfWeek = date2.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token2) {
      case "i":
        return String(isoDayOfWeek);
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token2.length);
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, {
          unit: "day"
        });
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function a2(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token2) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token2) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token2) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function h2(date2, token2, localize2) {
    if (token2 === "ho") {
      var hours = date2.getUTCHours() % 12;
      if (hours === 0)
        hours = 12;
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return formatters$2.h(date2, token2);
  },
  // Hour [0-23]
  H: function H2(date2, token2, localize2) {
    if (token2 === "Ho") {
      return localize2.ordinalNumber(date2.getUTCHours(), {
        unit: "hour"
      });
    }
    return formatters$2.H(date2, token2);
  },
  // Hour [0-11]
  K: function K(date2, token2, localize2) {
    var hours = date2.getUTCHours() % 12;
    if (token2 === "Ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Hour [1-24]
  k: function k(date2, token2, localize2) {
    var hours = date2.getUTCHours();
    if (hours === 0)
      hours = 24;
    if (token2 === "ko") {
      return localize2.ordinalNumber(hours, {
        unit: "hour"
      });
    }
    return addLeadingZeros(hours, token2.length);
  },
  // Minute
  m: function m2(date2, token2, localize2) {
    if (token2 === "mo") {
      return localize2.ordinalNumber(date2.getUTCMinutes(), {
        unit: "minute"
      });
    }
    return formatters$2.m(date2, token2);
  },
  // Second
  s: function s2(date2, token2, localize2) {
    if (token2 === "so") {
      return localize2.ordinalNumber(date2.getUTCSeconds(), {
        unit: "second"
      });
    }
    return formatters$2.s(date2, token2);
  },
  // Fraction of second
  S: function S2(date2, token2) {
    return formatters$2.S(date2, token2);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token2) {
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      case "XXXXX":
      case "XXX":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      case "xxxxx":
      case "xxx":
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function O(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function z(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token2) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function t(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timestamp = Math.floor(originalDate.getTime() / 1e3);
    return addLeadingZeros(timestamp, token2.length);
  },
  // Milliseconds timestamp
  T: function T(date2, token2, _localize, options2) {
    var originalDate = options2._originalDate || date2;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token2.length);
  }
};
function formatTimezoneShort(offset2, dirtyDelimiter) {
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign2 + String(hours);
  }
  var delimiter2 = dirtyDelimiter || "";
  return sign2 + String(hours) + delimiter2 + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, dirtyDelimiter) {
  if (offset2 % 60 === 0) {
    var sign2 = offset2 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, dirtyDelimiter);
}
function formatTimezone(offset2, dirtyDelimiter) {
  var delimiter2 = dirtyDelimiter || "";
  var sign2 = offset2 > 0 ? "-" : "+";
  var absOffset = Math.abs(offset2);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours + delimiter2 + minutes;
}
var dateLongFormatter = function dateLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "P":
      return formatLong2.date({
        width: "short"
      });
    case "PP":
      return formatLong2.date({
        width: "medium"
      });
    case "PPP":
      return formatLong2.date({
        width: "long"
      });
    case "PPPP":
    default:
      return formatLong2.date({
        width: "full"
      });
  }
};
var timeLongFormatter = function timeLongFormatter2(pattern, formatLong2) {
  switch (pattern) {
    case "p":
      return formatLong2.time({
        width: "short"
      });
    case "pp":
      return formatLong2.time({
        width: "medium"
      });
    case "ppp":
      return formatLong2.time({
        width: "long"
      });
    case "pppp":
    default:
      return formatLong2.time({
        width: "full"
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter2(pattern, formatLong2) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong2);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({
        width: "short"
      });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({
        width: "full"
      });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
var longFormatters$2 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var protectedDayOfYearTokens = ["D", "DD"];
var protectedWeekYearTokens = ["YY", "YYYY"];
function isProtectedDayOfYearToken(token2) {
  return protectedDayOfYearTokens.indexOf(token2) !== -1;
}
function isProtectedWeekYearToken(token2) {
  return protectedWeekYearTokens.indexOf(token2) !== -1;
}
function throwProtectedError(token2, format2, input2) {
  if (token2 === "YYYY") {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format2, "`) for formatting years to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "YY") {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format2, "`) for formatting years to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "D") {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token2 === "DD") {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format2, "`) for formatting days of the month to the input `").concat(input2, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
var formatDistance = function formatDistance2(token2, count, options2) {
  var result;
  var tokenValue = formatDistanceLocale[token2];
  if (typeof tokenValue === "string") {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace("{{count}}", count.toString());
  }
  if (options2 !== null && options2 !== void 0 && options2.addSuffix) {
    if (options2.comparison && options2.comparison > 0) {
      return "in " + result;
    } else {
      return result + " ago";
    }
  }
  return result;
};
const formatDistance$1 = formatDistance;
function buildFormatLongFn(args) {
  return function() {
    var options2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var width = options2.width ? String(options2.width) : args.defaultWidth;
    var format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
var dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
var timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatLong$1 = formatLong;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
var formatRelative = function formatRelative2(token2, _date, _baseDate, _options) {
  return formatRelativeLocale[token2];
};
const formatRelative$1 = formatRelative;
function buildLocalizeFn(args) {
  return function(dirtyIndex, options2) {
    var context = options2 !== null && options2 !== void 0 && options2.context ? String(options2.context) : "standalone";
    var valuesArray;
    if (context === "formatting" && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options2 !== null && options2 !== void 0 && options2.width ? String(options2.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options2 !== null && options2 !== void 0 && options2.width ? String(options2.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index2 = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index2];
  };
}
var eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
var quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
var monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
};
var dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
};
var dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
var ordinalNumber = function ordinalNumber2(dirtyNumber, _options) {
  var number2 = Number(dirtyNumber);
  var rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
var localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
const localize$1 = localize;
function buildMatchFn(args) {
  return function(string2) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var width = options2.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex$2(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    }) : findKey$1(parsePatterns, function(pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options2.valueCallback ? options2.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
function findKey$1(object2, predicate) {
  for (var key in object2) {
    if (object2.hasOwnProperty(key) && predicate(object2[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex$2(array2, predicate) {
  for (var key = 0; key < array2.length; key++) {
    if (predicate(array2[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return function(string2) {
    var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var matchResult = string2.match(args.matchPattern);
    if (!matchResult)
      return null;
    var matchedString = matchResult[0];
    var parseResult = string2.match(args.parsePattern);
    if (!parseResult)
      return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options2.valueCallback ? options2.valueCallback(value) : value;
    var rest = string2.slice(matchedString.length);
    return {
      value,
      rest
    };
  };
}
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: function valueCallback2(index2) {
      return index2 + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const match$1 = match;
var locale$2 = {
  code: "en-US",
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const defaultLocale$2 = locale$2;
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format$2(dirtyDate, dirtyFormatStr, options2) {
  var _ref2, _options$locale, _ref22, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref2 = (_options$locale = options2 === null || options2 === void 0 ? void 0 : options2.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref2 !== void 0 ? _ref2 : defaultLocale$2;
  var firstWeekContainsDate = toInteger((_ref22 = (_ref3 = (_ref4 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale2 = options2.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale3 = options2.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (!locale2.localize) {
    throw new RangeError("locale must contain localize property");
  }
  if (!locale2.formatLong) {
    throw new RangeError("locale must contain formatLong property");
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate2 = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map(function(substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters[firstCharacter];
    if (formatter) {
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate2, substring, locale2.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
    }
    return substring;
  }).join("");
  return result;
}
function cleanEscapedString$1(input2) {
  var matched = input2.match(escapedStringRegExp$1);
  if (!matched) {
    return input2;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var dayOfMonth = date2.getDate();
  return dayOfMonth;
}
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var day = date2.getDay();
  return day;
}
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var year = date2.getFullYear();
  var monthIndex = date2.getMonth();
  var lastDayOfMonth = /* @__PURE__ */ new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var hours = date2.getHours();
  return hours;
}
function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var minutes = date2.getMinutes();
  return minutes;
}
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var month = date2.getMonth();
  return month;
}
function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  var seconds = date2.getSeconds();
  return seconds;
}
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date2.getTime() > dateToCompare.getTime();
}
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date2.getTime() < dateToCompare.getTime();
}
function isEqual$7(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}
function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  date2.setMinutes(0, 0, 0);
  return date2;
}
function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it)
        o = it;
      var i2 = 0;
      var F = function F2() {
      };
      return {
        s: F,
        n: function n() {
          if (i2 >= o.length)
            return {
              done: true
            };
          return {
            done: false,
            value: o[i2++]
          };
        },
        e: function e3(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true, didErr = false, err;
  return {
    s: function s4() {
      it = it.call(o);
    },
    n: function n() {
      var step2 = it.next();
      normalCompletion = step2.done;
      return step2;
    },
    e: function e3(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null)
          it["return"]();
      } finally {
        if (didErr)
          throw err;
      }
    }
  };
}
function assign$4(target, object2) {
  if (target == null) {
    throw new TypeError("assign requires that input parameter not be null or undefined");
  }
  for (var property2 in object2) {
    if (Object.prototype.hasOwnProperty.call(object2, property2)) {
      target[property2] = object2[property2];
    }
  }
  return target;
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _isNativeReflectConstruct() {
  try {
    var t2 = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t3) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t2;
  })();
}
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (_typeof(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function toPrimitive(t2, r) {
  if ("object" != _typeof(t2) || !t2)
    return t2;
  var e3 = t2[Symbol.toPrimitive];
  if (void 0 !== e3) {
    var i2 = e3.call(t2, r || "default");
    if ("object" != _typeof(i2))
      return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t2);
}
function toPropertyKey(t2) {
  var i2 = toPrimitive(t2, "string");
  return "symbol" == _typeof(i2) ? i2 : i2 + "";
}
function _defineProperties(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$2(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /* @__PURE__ */ function() {
  function Setter2() {
    _classCallCheck(this, Setter2);
    _defineProperty$2(this, "priority", void 0);
    _defineProperty$2(this, "subPriority", 0);
  }
  _createClass(Setter2, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter2;
}();
var ValueSetter = /* @__PURE__ */ function(_Setter) {
  _inherits(ValueSetter2, _Setter);
  var _super = _createSuper(ValueSetter2);
  function ValueSetter2(value, validateValue, setValue, priority2, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter2);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority2;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter2, [{
    key: "validate",
    value: function validate(utcDate2, options2) {
      return this.validateValue(utcDate2, this.value, options2);
    }
  }, {
    key: "set",
    value: function set(utcDate2, flags3, options2) {
      return this.setValue(utcDate2, flags3, this.value, options2);
    }
  }]);
  return ValueSetter2;
}(Setter);
var DateToSystemTimezoneSetter = /* @__PURE__ */ function(_Setter2) {
  _inherits(DateToSystemTimezoneSetter2, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter2);
  function DateToSystemTimezoneSetter2() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty$2(_assertThisInitialized(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter2, [{
    key: "set",
    value: function set(date2, flags3) {
      if (flags3.timestampIsSet) {
        return date2;
      }
      var convertedDate = /* @__PURE__ */ new Date(0);
      convertedDate.setFullYear(date2.getUTCFullYear(), date2.getUTCMonth(), date2.getUTCDate());
      convertedDate.setHours(date2.getUTCHours(), date2.getUTCMinutes(), date2.getUTCSeconds(), date2.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter2;
}(Setter);
var Parser = /* @__PURE__ */ function() {
  function Parser2() {
    _classCallCheck(this, Parser2);
    _defineProperty$2(this, "incompatibleTokens", void 0);
    _defineProperty$2(this, "priority", void 0);
    _defineProperty$2(this, "subPriority", void 0);
  }
  _createClass(Parser2, [{
    key: "run",
    value: function run(dateString, token2, match2, options2) {
      var result = this.parse(dateString, token2, match2, options2);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser2;
}();
var EraParser = /* @__PURE__ */ function(_Parser) {
  _inherits(EraParser2, _Parser);
  var _super = _createSuper(EraParser2);
  function EraParser2() {
    var _this;
    _classCallCheck(this, EraParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 140);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["R", "u", "t", "T"]);
    return _this;
  }
  _createClass(EraParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "G":
        case "GG":
        case "GGG":
          return match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
        case "GGGGG":
          return match2.era(dateString, {
            width: "narrow"
          });
        case "GGGG":
        default:
          return match2.era(dateString, {
            width: "wide"
          }) || match2.era(dateString, {
            width: "abbreviated"
          }) || match2.era(dateString, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function set(date2, flags3, value) {
      flags3.era = value;
      date2.setUTCFullYear(value, 0, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return EraParser2;
}(Parser);
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign2 = matchResult[1] === "+" ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
var YearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(YearParser2, _Parser);
  var _super = _createSuper(YearParser2);
  function YearParser2() {
    var _this;
    _classCallCheck(this, YearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(YearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "yy"
        };
      };
      switch (token2) {
        case "y":
          return mapValue(parseNDigits(4, dateString), valueCallback3);
        case "yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback3);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date2, flags3, value) {
      var currentYear = date2.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date2.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date2.setUTCHours(0, 0, 0, 0);
        return date2;
      }
      var year = !("era" in flags3) || flags3.era === 1 ? value.year : 1 - value.year;
      date2.setUTCFullYear(year, 0, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return YearParser2;
}(Parser);
var LocalWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalWeekYearParser2, _Parser);
  var _super = _createSuper(LocalWeekYearParser2);
  function LocalWeekYearParser2() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(year) {
        return {
          year,
          isTwoDigitYear: token2 === "YY"
        };
      };
      switch (token2) {
        case "Y":
          return mapValue(parseNDigits(4, dateString), valueCallback3);
        case "Yo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "year"
          }), valueCallback3);
        default:
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date2, flags3, value, options2) {
      var currentYear = getUTCWeekYear(date2, options2);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date2.setUTCFullYear(normalizedTwoDigitYear, 0, options2.firstWeekContainsDate);
        date2.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date2, options2);
      }
      var year = !("era" in flags3) || flags3.era === 1 ? value.year : 1 - value.year;
      date2.setUTCFullYear(year, 0, options2.firstWeekContainsDate);
      date2.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date2, options2);
    }
  }]);
  return LocalWeekYearParser2;
}(Parser);
var ISOWeekYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOWeekYearParser2, _Parser);
  var _super = _createSuper(ISOWeekYearParser2);
  function ISOWeekYearParser2() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "R") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = /* @__PURE__ */ new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser2;
}(Parser);
var ExtendedYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ExtendedYearParser2, _Parser);
  var _super = _createSuper(ExtendedYearParser2);
  function ExtendedYearParser2() {
    var _this;
    _classCallCheck(this, ExtendedYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ExtendedYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      if (token2 === "u") {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token2.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCFullYear(value, 0, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return ExtendedYearParser2;
}(Parser);
var QuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits(QuarterParser2, _Parser);
  var _super = _createSuper(QuarterParser2);
  function QuarterParser2() {
    var _this;
    _classCallCheck(this, QuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 120);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(QuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "Q":
        case "QQ":
          return parseNDigits(token2.length, dateString);
        case "Qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "QQQ":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQQ":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "QQQQ":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMonth((value - 1) * 3, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return QuarterParser2;
}(Parser);
var StandAloneQuarterParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneQuarterParser2, _Parser);
  var _super = _createSuper(StandAloneQuarterParser2);
  function StandAloneQuarterParser2() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 120);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneQuarterParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "q":
        case "qq":
          return parseNDigits(token2.length, dateString);
        case "qo":
          return match2.ordinalNumber(dateString, {
            unit: "quarter"
          });
        case "qqq":
          return match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqqq":
          return match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "qqqq":
        default:
          return match2.quarter(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.quarter(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMonth((value - 1) * 3, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return StandAloneQuarterParser2;
}(Parser);
var MonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits(MonthParser2, _Parser);
  var _super = _createSuper(MonthParser2);
  function MonthParser2() {
    var _this;
    _classCallCheck(this, MonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]);
    _defineProperty$2(_assertThisInitialized(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value) {
        return value - 1;
      };
      switch (token2) {
        case "M":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback3);
        case "MM":
          return mapValue(parseNDigits(2, dateString), valueCallback3);
        case "Mo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback3);
        case "MMM":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMMM":
          return match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "MMMM":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMonth(value, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return MonthParser2;
}(Parser);
var StandAloneMonthParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneMonthParser2, _Parser);
  var _super = _createSuper(StandAloneMonthParser2);
  function StandAloneMonthParser2() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 110);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneMonthParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value) {
        return value - 1;
      };
      switch (token2) {
        case "L":
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback3);
        case "LL":
          return mapValue(parseNDigits(2, dateString), valueCallback3);
        case "Lo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "month"
          }), valueCallback3);
        case "LLL":
          return match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLLL":
          return match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "LLLL":
        default:
          return match2.month(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.month(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMonth(value, 1);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return StandAloneMonthParser2;
}(Parser);
function setUTCWeek(dirtyDate, dirtyWeek, options2) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date2, options2) - week;
  date2.setUTCDate(date2.getUTCDate() - diff * 7);
  return date2;
}
var LocalWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalWeekParser2, _Parser);
  var _super = _createSuper(LocalWeekParser2);
  function LocalWeekParser2() {
    var _this;
    _classCallCheck(this, LocalWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 100);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]);
    return _this;
  }
  _createClass(LocalWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "w":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "wo":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value, options2) {
      return startOfUTCWeek(setUTCWeek(date2, value, options2), options2);
    }
  }]);
  return LocalWeekParser2;
}(Parser);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date2) - isoWeek;
  date2.setUTCDate(date2.getUTCDate() - diff * 7);
  return date2;
}
var ISOWeekParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOWeekParser2, _Parser);
  var _super = _createSuper(ISOWeekParser2);
  function ISOWeekParser2() {
    var _this;
    _classCallCheck(this, ISOWeekParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 100);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISOWeekParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "I":
          return parseNumericPattern(numericPatterns.week, dateString);
        case "Io":
          return match2.ordinalNumber(dateString, {
            unit: "week"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date2, value));
    }
  }]);
  return ISOWeekParser2;
}(Parser);
var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DateParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DateParser2, _Parser);
  var _super = _createSuper(DateParser2);
  function DateParser2() {
    var _this;
    _classCallCheck(this, DateParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized(_this), "subPriority", 1);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DateParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "d":
          return parseNumericPattern(numericPatterns.date, dateString);
        case "do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date2, value) {
      var year = date2.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date2.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCDate(value);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return DateParser2;
}(Parser);
var DayOfYearParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayOfYearParser2, _Parser);
  var _super = _createSuper(DayOfYearParser2);
  function DayOfYearParser2() {
    var _this;
    _classCallCheck(this, DayOfYearParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized(_this), "subpriority", 1);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayOfYearParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "D":
        case "DD":
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case "Do":
          return match2.ordinalNumber(dateString, {
            unit: "date"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date2, value) {
      var year = date2.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMonth(0, value);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return DayOfYearParser2;
}(Parser);
function setUTCDay(dirtyDate, dirtyDay, options2) {
  var _ref2, _ref22, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref2 = (_ref22 = (_ref3 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date2.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date2.setUTCDate(date2.getUTCDate() + diff);
  return date2;
}
var DayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayParser2, _Parser);
  var _super = _createSuper(DayParser2);
  function DayParser2() {
    var _this;
    _classCallCheck(this, DayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(DayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "E":
        case "EE":
        case "EEE":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEE":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEEEE":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "EEEE":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value, options2) {
      date2 = setUTCDay(date2, value, options2);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return DayParser2;
}(Parser);
var LocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(LocalDayParser2, _Parser);
  var _super = _createSuper(LocalDayParser2);
  function LocalDayParser2() {
    var _this;
    _classCallCheck(this, LocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]);
    return _this;
  }
  _createClass(LocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options2) {
      var valueCallback3 = function valueCallback4(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options2.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "e":
        case "ee":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
        case "eo":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback3);
        case "eee":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeee":
          return match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeeeee":
          return match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "eeee":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value, options2) {
      date2 = setUTCDay(date2, value, options2);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return LocalDayParser2;
}(Parser);
var StandAloneLocalDayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(StandAloneLocalDayParser2, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser2);
  function StandAloneLocalDayParser2() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]);
    return _this;
  }
  _createClass(StandAloneLocalDayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2, options2) {
      var valueCallback3 = function valueCallback4(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options2.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token2) {
        case "c":
        case "cc":
          return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
        case "co":
          return mapValue(match2.ordinalNumber(dateString, {
            unit: "day"
          }), valueCallback3);
        case "ccc":
          return match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "ccccc":
          return match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccccc":
          return match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
        case "cccc":
        default:
          return match2.day(dateString, {
            width: "wide",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "short",
            context: "standalone"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value, options2) {
      date2 = setUTCDay(date2, value, options2);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return StandAloneLocalDayParser2;
}(Parser);
function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date2 = toDate(dirtyDate);
  var currentDay = date2.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date2.setUTCDate(date2.getUTCDate() + diff);
  return date2;
}
var ISODayParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISODayParser2, _Parser);
  var _super = _createSuper(ISODayParser2);
  function ISODayParser2() {
    var _this;
    _classCallCheck(this, ISODayParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]);
    return _this;
  }
  _createClass(ISODayParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      var valueCallback3 = function valueCallback4(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token2) {
        case "i":
        case "ii":
          return parseNDigits(token2.length, dateString);
        case "io":
          return match2.ordinalNumber(dateString, {
            unit: "day"
          });
        case "iii":
          return mapValue(match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        case "iiiii":
          return mapValue(match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        case "iiiiii":
          return mapValue(match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
        case "iiii":
        default:
          return mapValue(match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }), valueCallback3);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2 = setUTCISODay(date2, value);
      date2.setUTCHours(0, 0, 0, 0);
      return date2;
    }
  }]);
  return ISODayParser2;
}(Parser);
var AMPMParser = /* @__PURE__ */ function(_Parser) {
  _inherits(AMPMParser2, _Parser);
  var _super = _createSuper(AMPMParser2);
  function AMPMParser2() {
    var _this;
    _classCallCheck(this, AMPMParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "a":
        case "aa":
        case "aaa":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date2;
    }
  }]);
  return AMPMParser2;
}(Parser);
var AMPMMidnightParser = /* @__PURE__ */ function(_Parser) {
  _inherits(AMPMMidnightParser2, _Parser);
  var _super = _createSuper(AMPMMidnightParser2);
  function AMPMMidnightParser2() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMMidnightParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "b":
        case "bb":
        case "bbb":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date2;
    }
  }]);
  return AMPMMidnightParser2;
}(Parser);
var DayPeriodParser = /* @__PURE__ */ function(_Parser) {
  _inherits(DayPeriodParser2, _Parser);
  var _super = _createSuper(DayPeriodParser2);
  function DayPeriodParser2() {
    var _this;
    _classCallCheck(this, DayPeriodParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "t", "T"]);
    return _this;
  }
  _createClass(DayPeriodParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "B":
        case "BB":
        case "BBB":
          return match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return match2.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date2;
    }
  }]);
  return DayPeriodParser2;
}(Parser);
var Hour1to12Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour1to12Parser2, _Parser);
  var _super = _createSuper(Hour1to12Parser2);
  function Hour1to12Parser2() {
    var _this;
    _classCallCheck(this, Hour1to12Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour1to12Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "h":
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case "ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      var isPM = date2.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date2.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date2.setUTCHours(0, 0, 0, 0);
      } else {
        date2.setUTCHours(value, 0, 0, 0);
      }
      return date2;
    }
  }]);
  return Hour1to12Parser2;
}(Parser);
var Hour0to23Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour0to23Parser2, _Parser);
  var _super = _createSuper(Hour0to23Parser2);
  function Hour0to23Parser2() {
    var _this;
    _classCallCheck(this, Hour0to23Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0to23Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "H":
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case "Ho":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCHours(value, 0, 0, 0);
      return date2;
    }
  }]);
  return Hour0to23Parser2;
}(Parser);
var Hour0To11Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour0To11Parser2, _Parser);
  var _super = _createSuper(Hour0To11Parser2);
  function Hour0To11Parser2() {
    var _this;
    _classCallCheck(this, Hour0To11Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(Hour0To11Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "K":
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case "Ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      var isPM = date2.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date2.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date2.setUTCHours(value, 0, 0, 0);
      }
      return date2;
    }
  }]);
  return Hour0To11Parser2;
}(Parser);
var Hour1To24Parser = /* @__PURE__ */ function(_Parser) {
  _inherits(Hour1To24Parser2, _Parser);
  var _super = _createSuper(Hour1To24Parser2);
  function Hour1To24Parser2() {
    var _this;
    _classCallCheck(this, Hour1To24Parser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    return _this;
  }
  _createClass(Hour1To24Parser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "k":
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case "ko":
          return match2.ordinalNumber(dateString, {
            unit: "hour"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date2.setUTCHours(hours, 0, 0, 0);
      return date2;
    }
  }]);
  return Hour1To24Parser2;
}(Parser);
var MinuteParser = /* @__PURE__ */ function(_Parser) {
  _inherits(MinuteParser2, _Parser);
  var _super = _createSuper(MinuteParser2);
  function MinuteParser2() {
    var _this;
    _classCallCheck(this, MinuteParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 60);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(MinuteParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "m":
          return parseNumericPattern(numericPatterns.minute, dateString);
        case "mo":
          return match2.ordinalNumber(dateString, {
            unit: "minute"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMinutes(value, 0, 0);
      return date2;
    }
  }]);
  return MinuteParser2;
}(Parser);
var SecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits(SecondParser2, _Parser);
  var _super = _createSuper(SecondParser2);
  function SecondParser2() {
    var _this;
    _classCallCheck(this, SecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 50);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(SecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2, match2) {
      switch (token2) {
        case "s":
          return parseNumericPattern(numericPatterns.second, dateString);
        case "so":
          return match2.ordinalNumber(dateString, {
            unit: "second"
          });
        default:
          return parseNDigits(token2.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCSeconds(value, 0);
      return date2;
    }
  }]);
  return SecondParser2;
}(Parser);
var FractionOfSecondParser = /* @__PURE__ */ function(_Parser) {
  _inherits(FractionOfSecondParser2, _Parser);
  var _super = _createSuper(FractionOfSecondParser2);
  function FractionOfSecondParser2() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 30);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T"]);
    return _this;
  }
  _createClass(FractionOfSecondParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      var valueCallback3 = function valueCallback4(value) {
        return Math.floor(value * Math.pow(10, -token2.length + 3));
      };
      return mapValue(parseNDigits(token2.length, dateString), valueCallback3);
    }
  }, {
    key: "set",
    value: function set(date2, _flags, value) {
      date2.setUTCMilliseconds(value);
      return date2;
    }
  }]);
  return FractionOfSecondParser2;
}(Parser);
var ISOTimezoneWithZParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOTimezoneWithZParser2, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser2);
  function ISOTimezoneWithZParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 10);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "x"]);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "X":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "XX":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "XXXX":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "XXXXX":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "XXX":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date2, flags3, value) {
      if (flags3.timestampIsSet) {
        return date2;
      }
      return new Date(date2.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser2;
}(Parser);
var ISOTimezoneParser = /* @__PURE__ */ function(_Parser) {
  _inherits(ISOTimezoneParser2, _Parser);
  var _super = _createSuper(ISOTimezoneParser2);
  function ISOTimezoneParser2() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 10);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", ["t", "T", "X"]);
    return _this;
  }
  _createClass(ISOTimezoneParser2, [{
    key: "parse",
    value: function parse2(dateString, token2) {
      switch (token2) {
        case "x":
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case "xx":
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case "xxxx":
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case "xxxxx":
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case "xxx":
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date2, flags3, value) {
      if (flags3.timestampIsSet) {
        return date2;
      }
      return new Date(date2.getTime() - value);
    }
  }]);
  return ISOTimezoneParser2;
}(Parser);
var TimestampSecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits(TimestampSecondsParser2, _Parser);
  var _super = _createSuper(TimestampSecondsParser2);
  function TimestampSecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 40);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampSecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1e3), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser2;
}(Parser);
var TimestampMillisecondsParser = /* @__PURE__ */ function(_Parser) {
  _inherits(TimestampMillisecondsParser2, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser2);
  function TimestampMillisecondsParser2() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser2);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized(_this), "priority", 20);
    _defineProperty$2(_assertThisInitialized(_this), "incompatibleTokens", "*");
    return _this;
  }
  _createClass(TimestampMillisecondsParser2, [{
    key: "parse",
    value: function parse2(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser2;
}(Parser);
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse$2(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options2) {
  var _ref2, _options$locale, _ref22, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions2 = getDefaultOptions();
  var locale2 = (_ref2 = (_options$locale = options2 === null || options2 === void 0 ? void 0 : options2.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions2.locale) !== null && _ref2 !== void 0 ? _ref2 : defaultLocale$2;
  if (!locale2.match) {
    throw new RangeError("locale must contain match property");
  }
  var firstWeekContainsDate = toInteger((_ref22 = (_ref3 = (_ref4 = (_options$firstWeekCon = options2 === null || options2 === void 0 ? void 0 : options2.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options2 === null || options2 === void 0 ? void 0 : (_options$locale2 = options2.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions2.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref22 !== void 0 ? _ref22 : 1);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale3 = options2.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions2.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions2.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  if (formatString === "") {
    if (dateString === "") {
      return toDate(dirtyReferenceDate);
    } else {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters$2) {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens), _step;
  try {
    var _loop3 = function _loop4() {
      var token2 = _step.value;
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      if (!(options2 !== null && options2 !== void 0 && options2.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token2)) {
        throwProtectedError(token2, formatString, dirtyDateString);
      }
      var firstCharacter = token2[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function(usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token2, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token2, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token2
        });
        var parseResult = parser.run(dateString, token2, locale2.match, subFnOptions);
        if (!parseResult) {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        }
        if (token2 === "''") {
          token2 = "'";
        } else if (firstCharacter === "'") {
          token2 = cleanEscapedString(token2);
        }
        if (dateString.indexOf(token2) === 0) {
          dateString = dateString.slice(token2.length);
        } else {
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done; ) {
      var _ret = _loop3();
      if (_typeof(_ret) === "object")
        return _ret.v;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function(setter2) {
    return setter2.priority;
  }).sort(function(a4, b10) {
    return b10 - a4;
  }).filter(function(priority2, index2, array2) {
    return array2.indexOf(priority2) === index2;
  }).map(function(priority2) {
    return setters.filter(function(setter2) {
      return setter2.priority === priority2;
    }).sort(function(a4, b10) {
      return b10.subPriority - a4.subPriority;
    });
  }).map(function(setterArray) {
    return setterArray[0];
  });
  var date2 = toDate(dirtyReferenceDate);
  if (isNaN(date2.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var utcDate2 = subMilliseconds(date2, getTimezoneOffsetInMilliseconds(date2));
  var flags3 = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters), _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done; ) {
      var setter = _step2.value;
      if (!setter.validate(utcDate2, subFnOptions)) {
        return /* @__PURE__ */ new Date(NaN);
      }
      var result = setter.set(utcDate2, flags3, subFnOptions);
      if (Array.isArray(result)) {
        utcDate2 = result[0];
        assign$4(flags3, result[1]);
      } else {
        utcDate2 = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate2;
}
function cleanEscapedString(input2) {
  return input2.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function setDate(dirtyDate, dirtyDayOfMonth) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var dayOfMonth = toInteger(dirtyDayOfMonth);
  date2.setDate(dayOfMonth);
  return date2;
}
function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date2.setHours(hours);
  return date2;
}
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date2.setMinutes(minutes);
  return date2;
}
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date2.getFullYear();
  var day = date2.getDate();
  var dateWithDesiredMonth = /* @__PURE__ */ new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  date2.setMonth(month, Math.min(day, daysInMonth));
  return date2;
}
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date2.setSeconds(seconds);
  return date2;
}
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date2 = toDate(dirtyDate);
  var year = toInteger(dirtyYear);
  if (isNaN(date2.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  date2.setFullYear(year);
  return date2;
}
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date2 = toDate(dirtyDate);
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function startOfWeek(dirtyDate, options2) {
  var _ref2, _ref22, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions2 = getDefaultOptions();
  var weekStartsOn = toInteger((_ref2 = (_ref22 = (_ref3 = (_options$weekStartsOn = options2 === null || options2 === void 0 ? void 0 : options2.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options2 === null || options2 === void 0 ? void 0 : (_options$locale = options2.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions2.weekStartsOn) !== null && _ref22 !== void 0 ? _ref22 : (_defaultOptions$local = defaultOptions2.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  }
  var date2 = toDate(dirtyDate);
  var day = date2.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date2.setDate(date2.getDate() - diff);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date2 = /* @__PURE__ */ new Date(0);
  date2.setFullYear(cleanDate.getFullYear(), 0, 1);
  date2.setHours(0, 0, 0, 0);
  return date2;
}
function parseISO(argument, options2) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options2 === null || options2 === void 0 ? void 0 : options2.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  }
  if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date2;
  if (dateStrings.date) {
    var parseYearResult = parseYear$1(dateStrings.date, additionalDigits);
    date2 = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date2 || isNaN(date2.getTime())) {
    return /* @__PURE__ */ new Date(NaN);
  }
  var timestamp = date2.getTime();
  var time2 = 0;
  var offset2;
  if (dateStrings.time) {
    time2 = parseTime(dateStrings.time);
    if (isNaN(time2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset2 = parseTimezone(dateStrings.timezone);
    if (isNaN(offset2)) {
      return /* @__PURE__ */ new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time2);
    var result = /* @__PURE__ */ new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time2 + offset2);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array2 = dateString.split(patterns.dateTimeDelimiter);
  var timeString;
  if (array2.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array2[0])) {
    timeString = array2[0];
  } else {
    dateStrings.date = array2[0];
    timeString = array2[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token2 = patterns.timezone.exec(timeString);
    if (token2) {
      dateStrings.time = timeString.replace(token2[1], "");
      dateStrings.timezone = token2[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear$1(dateString, additionalDigits) {
  var regex2 = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
  var captures = dateString.match(regex2);
  if (!captures)
    return {
      year: NaN,
      restDateString: ""
    };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  if (year === null)
    return /* @__PURE__ */ new Date(NaN);
  var captures = dateString.match(dateRegex);
  if (!captures)
    return /* @__PURE__ */ new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date2 = /* @__PURE__ */ new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return /* @__PURE__ */ new Date(NaN);
    }
    date2.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date2;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures)
    return NaN;
  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1e3;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(",", ".")) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === "Z")
    return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures)
    return 0;
  var sign2 = captures[1] === "+" ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date2 = /* @__PURE__ */ new Date(0);
  date2.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date2.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date2.setUTCDate(date2.getUTCDate() + diff);
  return date2;
}
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date2) {
  return month >= 0 && month <= 11 && date2 >= 1 && date2 <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}
function formatISO(date2, options2) {
  var _options$format, _options$representati;
  requiredArgs(1, arguments);
  var originalDate = toDate(date2);
  if (isNaN(originalDate.getTime())) {
    throw new RangeError("Invalid time value");
  }
  var format2 = String((_options$format = options2 === null || options2 === void 0 ? void 0 : options2.format) !== null && _options$format !== void 0 ? _options$format : "extended");
  var representation = String((_options$representati = options2 === null || options2 === void 0 ? void 0 : options2.representation) !== null && _options$representati !== void 0 ? _options$representati : "complete");
  if (format2 !== "extended" && format2 !== "basic") {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== "date" && representation !== "time" && representation !== "complete") {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = "";
  var tzOffset = "";
  var dateDelimiter = format2 === "extended" ? "-" : "";
  var timeDelimiter = format2 === "extended" ? ":" : "";
  if (representation !== "time") {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4);
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }
  if (representation !== "date") {
    var offset2 = originalDate.getTimezoneOffset();
    if (offset2 !== 0) {
      var absoluteOffset = Math.abs(offset2);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2);
      var sign2 = offset2 < 0 ? "+" : "-";
      tzOffset = "".concat(sign2).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = "Z";
    }
    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second2 = addLeadingZeros(originalDate.getSeconds(), 2);
    var separator = result === "" ? "" : "T";
    var time2 = [hour, minute, second2].join(timeDelimiter);
    result = "".concat(result).concat(separator).concat(time2).concat(tzOffset);
  }
  return result;
}
function isWithinInterval(dirtyDate, interval2) {
  requiredArgs(2, arguments);
  var time2 = toDate(dirtyDate).getTime();
  var startTime = toDate(interval2.start).getTime();
  var endTime = toDate(interval2.end).getTime();
  if (!(startTime <= endTime)) {
    throw new RangeError("Invalid interval");
  }
  return time2 >= startTime && time2 <= endTime;
}
var longFormatters$1 = { exports: {} };
(function(module2, exports2) {
  Object.defineProperty(exports2, "__esModule", {
    value: true
  });
  exports2.default = void 0;
  var dateLongFormatter3 = function dateLongFormatter4(pattern, formatLong2) {
    switch (pattern) {
      case "P":
        return formatLong2.date({
          width: "short"
        });
      case "PP":
        return formatLong2.date({
          width: "medium"
        });
      case "PPP":
        return formatLong2.date({
          width: "long"
        });
      case "PPPP":
      default:
        return formatLong2.date({
          width: "full"
        });
    }
  };
  var timeLongFormatter3 = function timeLongFormatter4(pattern, formatLong2) {
    switch (pattern) {
      case "p":
        return formatLong2.time({
          width: "short"
        });
      case "pp":
        return formatLong2.time({
          width: "medium"
        });
      case "ppp":
        return formatLong2.time({
          width: "long"
        });
      case "pppp":
      default:
        return formatLong2.time({
          width: "full"
        });
    }
  };
  var dateTimeLongFormatter3 = function dateTimeLongFormatter4(pattern, formatLong2) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) {
      return dateLongFormatter3(pattern, formatLong2);
    }
    var dateTimeFormat;
    switch (datePattern) {
      case "P":
        dateTimeFormat = formatLong2.dateTime({
          width: "short"
        });
        break;
      case "PP":
        dateTimeFormat = formatLong2.dateTime({
          width: "medium"
        });
        break;
      case "PPP":
        dateTimeFormat = formatLong2.dateTime({
          width: "long"
        });
        break;
      case "PPPP":
      default:
        dateTimeFormat = formatLong2.dateTime({
          width: "full"
        });
        break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter3(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter3(timePattern, formatLong2));
  };
  var longFormatters2 = {
    p: timeLongFormatter3,
    P: dateTimeLongFormatter3
  };
  var _default2 = longFormatters2;
  exports2.default = _default2;
  module2.exports = exports2.default;
})(longFormatters$1, longFormatters$1.exports);
var longFormattersExports = longFormatters$1.exports;
const longFormatters = /* @__PURE__ */ getDefaultExportFromCjs(longFormattersExports);
const defaultFormats = {
  dayOfMonth: "d",
  fullDate: "PP",
  fullDateWithWeekday: "PPPP",
  fullDateTime: "PP p",
  fullDateTime12h: "PP hh:mm aaa",
  fullDateTime24h: "PP HH:mm",
  fullTime: "p",
  fullTime12h: "hh:mm aaa",
  fullTime24h: "HH:mm",
  hours12h: "hh",
  hours24h: "HH",
  keyboardDate: "P",
  keyboardDateTime: "P p",
  keyboardDateTime12h: "P hh:mm aaa",
  keyboardDateTime24h: "P HH:mm",
  minutes: "mm",
  month: "LLLL",
  monthAndDate: "MMMM d",
  monthAndYear: "LLLL yyyy",
  monthShort: "MMM",
  weekday: "EEEE",
  weekdayShort: "EEE",
  normalDate: "d MMMM",
  normalDateWithWeekday: "EEE, MMM d",
  seconds: "ss",
  shortDate: "MMM d",
  year: "yyyy"
};
class DateFnsUtils {
  constructor({ locale: locale2, formats } = {}) {
    this.lib = "date-fns";
    this.is12HourCycleInCurrentLocale = () => {
      var _a2;
      if (this.locale) {
        return /a/.test((_a2 = this.locale.formatLong) === null || _a2 === void 0 ? void 0 : _a2.time());
      }
      return true;
    };
    this.getFormatHelperText = (format2) => {
      var _a2, _b;
      const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      const locale3 = this.locale || defaultLocale$2;
      return (_b = (_a2 = format2.match(longFormatRegexp)) === null || _a2 === void 0 ? void 0 : _a2.map((token2) => {
        const firstCharacter = token2[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
          const longFormatter = longFormatters[firstCharacter];
          return longFormatter(token2, locale3.formatLong, {});
        }
        return token2;
      }).join("").replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format2;
    };
    this.parseISO = (isoString) => {
      return parseISO(isoString);
    };
    this.toISO = (value) => {
      return formatISO(value, { format: "extended" });
    };
    this.getCurrentLocaleCode = () => {
      var _a2;
      return ((_a2 = this.locale) === null || _a2 === void 0 ? void 0 : _a2.code) || "en-US";
    };
    this.addSeconds = (value, count) => {
      return addSeconds(value, count);
    };
    this.addMinutes = (value, count) => {
      return addMinutes(value, count);
    };
    this.addHours = (value, count) => {
      return addHours(value, count);
    };
    this.addDays = (value, count) => {
      return addDays(value, count);
    };
    this.addWeeks = (value, count) => {
      return addWeeks(value, count);
    };
    this.addMonths = (value, count) => {
      return addMonths(value, count);
    };
    this.addYears = (value, count) => {
      return addYears(value, count);
    };
    this.isValid = (value) => {
      return isValid(this.date(value));
    };
    this.getDiff = (value, comparing, unit2) => {
      var _a2;
      const dateToCompare = (_a2 = this.date(comparing)) !== null && _a2 !== void 0 ? _a2 : value;
      if (!this.isValid(dateToCompare)) {
        return 0;
      }
      switch (unit2) {
        case "years":
          return differenceInYears(value, dateToCompare);
        case "quarters":
          return differenceInQuarters(value, dateToCompare);
        case "months":
          return differenceInMonths(value, dateToCompare);
        case "weeks":
          return differenceInWeeks(value, dateToCompare);
        case "days":
          return differenceInDays(value, dateToCompare);
        case "hours":
          return differenceInHours(value, dateToCompare);
        case "minutes":
          return differenceInMinutes(value, dateToCompare);
        case "seconds":
          return differenceInSeconds(value, dateToCompare);
        default: {
          return differenceInMilliseconds(value, dateToCompare);
        }
      }
    };
    this.isAfter = (value, comparing) => {
      return isAfter(value, comparing);
    };
    this.isBefore = (value, comparing) => {
      return isBefore(value, comparing);
    };
    this.startOfDay = (value) => {
      return startOfDay(value);
    };
    this.endOfDay = (value) => {
      return endOfDay(value);
    };
    this.getHours = (value) => {
      return getHours(value);
    };
    this.setHours = (value, count) => {
      return setHours(value, count);
    };
    this.setMinutes = (value, count) => {
      return setMinutes(value, count);
    };
    this.getSeconds = (value) => {
      return getSeconds(value);
    };
    this.setSeconds = (value, count) => {
      return setSeconds(value, count);
    };
    this.isSameDay = (value, comparing) => {
      return isSameDay(value, comparing);
    };
    this.isSameMonth = (value, comparing) => {
      return isSameMonth(value, comparing);
    };
    this.isSameYear = (value, comparing) => {
      return isSameYear(value, comparing);
    };
    this.isSameHour = (value, comparing) => {
      return isSameHour(value, comparing);
    };
    this.startOfYear = (value) => {
      return startOfYear(value);
    };
    this.endOfYear = (value) => {
      return endOfYear(value);
    };
    this.startOfMonth = (value) => {
      return startOfMonth(value);
    };
    this.endOfMonth = (value) => {
      return endOfMonth(value);
    };
    this.startOfWeek = (value) => {
      return startOfWeek(value, { locale: this.locale });
    };
    this.endOfWeek = (value) => {
      return endOfWeek(value, { locale: this.locale });
    };
    this.getYear = (value) => {
      return getYear(value);
    };
    this.setYear = (value, count) => {
      return setYear(value, count);
    };
    this.date = (value) => {
      if (typeof value === "undefined") {
        return /* @__PURE__ */ new Date();
      }
      if (value === null) {
        return null;
      }
      return new Date(value);
    };
    this.toJsDate = (value) => {
      return value;
    };
    this.parse = (value, formatString) => {
      if (value === "") {
        return null;
      }
      return parse$2(value, formatString, /* @__PURE__ */ new Date(), { locale: this.locale });
    };
    this.format = (date2, formatKey) => {
      return this.formatByString(date2, this.formats[formatKey]);
    };
    this.formatByString = (date2, formatString) => {
      return format$2(date2, formatString, { locale: this.locale });
    };
    this.isEqual = (date2, comparing) => {
      if (date2 === null && comparing === null) {
        return true;
      }
      return isEqual$7(date2, comparing);
    };
    this.isNull = (date2) => {
      return date2 === null;
    };
    this.isAfterDay = (date2, value) => {
      return isAfter(date2, endOfDay(value));
    };
    this.isBeforeDay = (date2, value) => {
      return isBefore(date2, startOfDay(value));
    };
    this.isBeforeYear = (date2, value) => {
      return isBefore(date2, startOfYear(value));
    };
    this.isAfterYear = (date2, value) => {
      return isAfter(date2, endOfYear(value));
    };
    this.isWithinRange = (date2, [start2, end2]) => {
      return isWithinInterval(date2, { start: start2, end: end2 });
    };
    this.formatNumber = (numberToFormat) => {
      return numberToFormat;
    };
    this.getMinutes = (date2) => {
      return getMinutes(date2);
    };
    this.getDate = (date2) => {
      return getDate(date2);
    };
    this.setDate = (date2, count) => {
      return setDate(date2, count);
    };
    this.getMonth = (date2) => {
      return getMonth(date2);
    };
    this.getDaysInMonth = (date2) => {
      return getDaysInMonth(date2);
    };
    this.setMonth = (date2, count) => {
      return setMonth(date2, count);
    };
    this.getMeridiemText = (ampm) => {
      return ampm === "am" ? "AM" : "PM";
    };
    this.getNextMonth = (date2) => {
      return addMonths(date2, 1);
    };
    this.getPreviousMonth = (date2) => {
      return addMonths(date2, -1);
    };
    this.getMonthArray = (date2) => {
      const firstMonth = startOfYear(date2);
      const monthArray = [firstMonth];
      while (monthArray.length < 12) {
        const prevMonth = monthArray[monthArray.length - 1];
        monthArray.push(this.getNextMonth(prevMonth));
      }
      return monthArray;
    };
    this.mergeDateAndTime = (date2, time2) => {
      return this.setSeconds(this.setMinutes(this.setHours(date2, this.getHours(time2)), this.getMinutes(time2)), this.getSeconds(time2));
    };
    this.getWeekdays = () => {
      const now2 = /* @__PURE__ */ new Date();
      return eachDayOfInterval({
        start: startOfWeek(now2, { locale: this.locale }),
        end: endOfWeek(now2, { locale: this.locale })
      }).map((day) => this.formatByString(day, "EEEEEE"));
    };
    this.getWeekArray = (date2) => {
      const start2 = startOfWeek(startOfMonth(date2), { locale: this.locale });
      const end2 = endOfWeek(endOfMonth(date2), { locale: this.locale });
      let count = 0;
      let current = start2;
      const nestedWeeks = [];
      let lastDay = null;
      while (isBefore(current, end2)) {
        const weekNumber = Math.floor(count / 7);
        nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
        const day = getDay(current);
        if (lastDay !== day) {
          lastDay = day;
          nestedWeeks[weekNumber].push(current);
          count += 1;
        }
        current = addDays(current, 1);
      }
      return nestedWeeks;
    };
    this.getYearRange = (start2, end2) => {
      const startDate = startOfYear(start2);
      const endDate = endOfYear(end2);
      const years = [];
      let current = startDate;
      while (isBefore(current, endDate)) {
        years.push(current);
        current = addYears(current, 1);
      }
      return years;
    };
    this.locale = locale2;
    this.formats = Object.assign({}, defaultFormats, formats);
  }
  isBeforeMonth(value, comparing) {
    return isBefore(value, startOfMonth(comparing));
  }
  isAfterMonth(value, comparing) {
    return isAfter(value, startOfMonth(comparing));
  }
}
const formatTokenMap = {
  y: "year",
  yy: "year",
  yyy: "year",
  yyyy: "year",
  MMMM: "month",
  MM: "month",
  DD: "day",
  d: "day",
  dd: "day",
  H: "hour",
  HH: "hour",
  h: "hour",
  hh: "hour",
  mm: "minute",
  ss: "second",
  a: "am-pm",
  aa: "am-pm",
  aaa: "am-pm"
};
class AdapterDateFns extends DateFnsUtils {
  constructor(...args) {
    super(...args);
    this.formatTokenMap = formatTokenMap;
    this.expandFormat = (format2) => {
      const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      return format2.match(longFormatRegexp).map((token2) => {
        const firstCharacter = token2[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
          const longFormatter = longFormatters[firstCharacter];
          const locale2 = this.locale || defaultLocale$2;
          return longFormatter(token2, locale2.formatLong, {});
        }
        return token2;
      }).join("");
    };
    this.getFormatHelperText = (format2) => {
      return this.expandFormat(format2).replace(/(aaa|aa|a)/g, "(a|p)m").toLocaleLowerCase();
    };
  }
}
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}
const DATEPICKER_WIDTH = "312px";
const DATEPICKER_MIN_HEIGHT = "245px";
const DATEPICKER_CELL_SIZE = "40px";
const DatePickerTheme = createTheme({
  typography: {
    fontFamily: "TTNormsPro"
  },
  components: {
    // @ts-ignore
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          inset: "4px auto auto 0px !important;"
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: shadowVariants.elevation.four
        }
      }
    },
    MuiCalendarOrClockPicker: {
      styleOverrides: {
        root: {
          "& > div:first-of-type": {
            width: DATEPICKER_WIDTH
          }
        }
      }
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          width: DATEPICKER_WIDTH
        }
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          width: DATEPICKER_WIDTH,
          padding: 0
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        today: {
          border: "1px solid",
          borderColor: combinedPalettes$1["fog-80"],
          "&.Mui-selected": {
            border: "none"
          }
        },
        root: {
          fontSize: "14px",
          margin: 0,
          "&": {
            width: DATEPICKER_CELL_SIZE,
            height: DATEPICKER_CELL_SIZE,
            ".Mui-selected": {
              backgroundColor: combinedPalettes$1["fog-80"]
            }
          }
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          fontWeight: "bold"
        }
      }
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        root: {
          width: "48px",
          justifyContent: "end"
        }
      }
    },
    MuiDayPicker: {
      styleOverrides: {
        slideTransition: {
          minHeight: DATEPICKER_MIN_HEIGHT
        },
        weekDayLabel: {
          width: DATEPICKER_CELL_SIZE,
          height: DATEPICKER_CELL_SIZE,
          color: text$2.tertiary,
          fontWeight: 600,
          margin: 0
        },
        weekContainer: {
          margin: 0
        }
      }
    },
    PrivatePickersYear: {
      styleOverrides: {
        root: {
          "& button": {
            "&.Mui-selected": {
              backgroundColor: combinedPalettes$1["fog-80"],
              "&:focus": {
                backgroundColor: combinedPalettes$1["fog-80"]
              }
            }
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          "&": {
            width: DATEPICKER_CELL_SIZE,
            height: DATEPICKER_CELL_SIZE,
            margin: 0
          },
          "&.MuiPickersDay-root.Mui-selected": {
            backgroundColor: combinedPalettes$1["fog-80"],
            "&:hover": {
              backgroundColor: combinedPalettes$1["fog-80"]
            },
            "&:focus": {
              backgroundColor: combinedPalettes$1["fog-80"]
            }
          }
        }
      }
    }
  }
});
const InputBase = ({
  children: children2 = null,
  disabled = false,
  hideLabel = false,
  hintText = "",
  hintTextParagraphVariant = ParagraphSizes.Paragraph14,
  label: label2 = "",
  labelId = void 0,
  name: name2,
  sx: sx2,
  variant: variant3 = FormInputVariants.default
}) => {
  const { error: error2, touched } = useGuiFieldMeta(name2);
  const hint = useMemo(() => {
    return hintText || (touched ? error2 : void 0);
  }, [hintText, error2, touched]);
  const variantText = useMemo(
    () => error2 && touched ? FormInputVariants.error : variant3,
    [error2, touched, variant3]
  );
  const LabelWrapper = hideLabel ? VisuallyHidden : React__default.Fragment;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { className: "gui", "data-test-id": `parent-input-wrapper--${name2}`, sx: sx2, children: [
    !isEmpty$1(label2) && /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Label2,
      {
        color: disabled ? TextColors.secondary : TextColors.primary,
        "data-test-id": `input-label--${name2}`,
        htmlFor: name2,
        id: labelId ?? `${name2}Label`,
        sx: { fontWeight: "bold" },
        children: label2
      }
    ) }),
    children2,
    hint && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Paragraph2,
      {
        className: `hint-text--${name2}--${variantText}`,
        color: `forms.${disabled ? "disabled" : variantText}.hintText`,
        "data-test-id": `hint-text--${name2}`,
        id: `${name2}HintText`,
        variant: hintTextParagraphVariant,
        children: hint
      }
    )
  ] });
};
const InputField = React__default.forwardRef(
  function InnerInputField({
    disabled,
    height = InputHeights.default,
    hintText,
    hintTextParagraphVariant = ParagraphSizes.Paragraph14,
    icon: icon2 = null,
    iconAlignment = IconAlignment.trailing,
    hideLabel = false,
    label: label2,
    name: name2,
    onBlur: onBlur3 = noop$6,
    onChange = noop$6,
    onClick = noop$6,
    placeholder,
    sx: sx2 = {},
    sxInput = {},
    type: type2 = InputTypes.text,
    variant: variant3 = FormInputVariants.default,
    validate,
    ...restOfProps
  }, ref2) {
    const labelIsHidden = hideLabel || !label2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      InputBase,
      {
        disabled,
        hideLabel: labelIsHidden,
        hintText,
        hintTextParagraphVariant,
        label: label2,
        name: name2,
        sx: sx2,
        variant: variant3,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundInput,
          {
            "aria-labelledby": `${name2}Label ${name2}HintText`,
            disabled,
            height,
            name: name2,
            onBlur: onBlur3,
            onChange,
            onClick,
            placeholder,
            postIcon: iconAlignment === IconAlignment.trailing ? icon2 : null,
            preIcon: iconAlignment === IconAlignment.leading ? icon2 : null,
            ref: ref2,
            sx: sxInput.wrapper,
            sxInputElement: sxInput.element,
            type: type2,
            validate,
            variant: variant3,
            ...restOfProps
          }
        )
      }
    );
  }
);
const CompoundInputField = Object.assign({}, InputField, {
  type: CompoundInput.type,
  height: CompoundInput.height,
  iconAlignment: IconAlignment
});
const DatePickerActionBar = ({
  guiTheme,
  onAccept,
  onCancel,
  onMount,
  onUnmount
}) => {
  useEffect(() => {
    onMount();
    return () => {
      onUnmount();
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: guiTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    HStack,
    {
      justifyContent: "flex-end",
      sx: {
        p: 0.5
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundButton,
          {
            onClick: onCancel,
            size: ButtonSize.compact,
            sx: { width: "fit-content" },
            variant: ButtonVariant.tertiary,
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundButton,
          {
            onClick: onAccept,
            size: ButtonSize.compact,
            sx: {
              width: "fit-content",
              marginLeft: 1,
              textTransform: "uppercase"
            },
            children: "Ok"
          }
        )
      ]
    }
  ) });
};
const useDatePickerEffects = ({
  value,
  setValue,
  initialValue: initialValue2,
  setDate: setDate2,
  isMobile: isMobile2,
  isDialogOpen,
  inputFormat
}) => {
  const lastValueRef = useRef();
  useEffect(() => {
    setDate2(parse$2(value || "", inputFormat, /* @__PURE__ */ new Date()));
  }, [isMobile2]);
  useEffect(() => {
    setDate2(parse$2(initialValue2, inputFormat, /* @__PURE__ */ new Date()));
  }, [initialValue2, inputFormat]);
  useEffect(() => {
    if (value && isDialogOpen) {
      setDate2(parse$2(value, inputFormat, /* @__PURE__ */ new Date()));
    }
  }, [value]);
  useEffect(() => {
    if (!value || !isDialogOpen) {
      return;
    }
    lastValueRef.current = value;
    return () => {
      if (!value || !isDialogOpen) {
        return;
      }
      lastValueRef.current = value;
    };
  }, [value]);
  useEffect(() => {
    if (value === void 0 && setValue && isMobile2) {
      setValue(lastValueRef.current || "");
    }
  }, [value, isMobile2]);
  return null;
};
const DEFAULT_INPUT_FORMAT = "MM/dd/yyyy";
const DatePicker = ({
  theme: theme2 = DatePickerTheme,
  name: name2,
  placeholder = "",
  label: label2 = "",
  inputFormat = DEFAULT_INPUT_FORMAT,
  openCalendarBtnAriaLabel = "Open calendar",
  ...props2
}) => {
  const [date2, setDate2] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  const isMobile2 = !isPointerFineDevice();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const guiTheme = useTheme();
  const { meta, helpers } = useGuiField({
    name: name2
  });
  const initialValue2 = useMemo(() => {
    if (meta == null ? void 0 : meta.initialValue) {
      return meta.initialValue;
    }
    return "";
  }, [meta]);
  useDatePickerEffects({
    value: meta == null ? void 0 : meta.value,
    setValue: helpers == null ? void 0 : helpers.setValue,
    initialValue: initialValue2,
    setDate: setDate2,
    isMobile: isMobile2,
    isDialogOpen,
    inputFormat
  });
  const onChangeHandler = (_date, _keyboardInputValue) => {
    if (_keyboardInputValue === void 0) {
      helpers == null ? void 0 : helpers.setValue("");
      if (_date) {
        setDate2(_date);
        helpers == null ? void 0 : helpers.setValue(format$2(_date, inputFormat));
      }
    } else {
      helpers == null ? void 0 : helpers.setValue(_keyboardInputValue);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider$2, { theme: theme2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LocalizationProvider, { dateAdapter: AdapterDateFns, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DatePicker$1,
    {
      ...isMobile2 && {
        components: {
          ActionBar: (props22) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            DatePickerActionBar,
            {
              guiTheme,
              onMount: () => {
                setIsDialogOpen(true);
              },
              onUnmount: () => {
                setIsDialogOpen(false);
              },
              ...props22
            }
          )
        }
      },
      PopperProps: {
        placement: "bottom-start",
        anchorEl: containerRef.current
      },
      inputFormat: inputFormat || DEFAULT_INPUT_FORMAT,
      onChange: onChangeHandler,
      onClose: () => {
        setIsOpen(false);
      },
      onOpen: () => {
        setIsOpen(true);
      },
      open: isOpen,
      renderInput: ({ ref: ref2, inputProps, disabled, inputRef }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: guiTheme, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: containerRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: ref2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        CompoundInputField,
        {
          disabled,
          isDatePicker: true,
          label: label2,
          ref: inputRef,
          ...!isDialogOpen && { name: name2 },
          postIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(
            CompoundButton,
            {
              "aria-label": openCalendarBtnAriaLabel,
              disabled,
              icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "calendar", size: IconSizes.Icon16 }),
              onClick: () => {
                helpers == null ? void 0 : helpers.setTouched(true);
                setIsOpen((prev2) => !prev2);
              },
              shape: ButtonShape.circle,
              variant: ButtonVariant.tertiary
            }
          ),
          ...inputProps,
          placeholder: placeholder || (inputFormat == null ? void 0 : inputFormat.toUpperCase())
        }
      ) }) }) }),
      value: date2,
      ...props2
    }
  ) }) });
};
const COPIED_STATE_TIMEOUT = 3e3;
const useClipboard = (copyText, onCopy, copiedTimeout = COPIED_STATE_TIMEOUT) => {
  const [clipboardState, setClipboardState] = useState({
    copied: false
  });
  const performCopy = useCallback(async () => {
    await navigator.clipboard.writeText(copyText);
    setClipboardState({ copied: true });
    onCopy == null ? void 0 : onCopy();
    setTimeout(() => {
      setClipboardState({ copied: false });
    }, copiedTimeout);
  }, [copyText, onCopy, copiedTimeout]);
  return {
    performCopy,
    isCopied: clipboardState.copied
  };
};
var __defProp2 = Object.defineProperty;
var __export = (target, all2) => {
  for (var name2 in all2)
    __defProp2(target, name2, { get: all2[name2], enumerable: true });
};
var globals_exports = {};
__export(globals_exports, {
  assign: () => assign$3,
  colors: () => colors$2,
  createStringInterpolator: () => createStringInterpolator,
  skipAnimation: () => skipAnimation,
  to: () => to,
  willAdvance: () => willAdvance
});
var updateQueue = makeQueue();
var raf = (fn2) => schedule(fn2, updateQueue);
var writeQueue = makeQueue();
raf.write = (fn2) => schedule(fn2, writeQueue);
var onStartQueue = makeQueue();
raf.onStart = (fn2) => schedule(fn2, onStartQueue);
var onFrameQueue = makeQueue();
raf.onFrame = (fn2) => schedule(fn2, onFrameQueue);
var onFinishQueue = makeQueue();
raf.onFinish = (fn2) => schedule(fn2, onFinishQueue);
var timeouts = [];
raf.setTimeout = (handler, ms) => {
  const time2 = raf.now() + ms;
  const cancel2 = () => {
    const i2 = timeouts.findIndex((t2) => t2.cancel == cancel2);
    if (~i2)
      timeouts.splice(i2, 1);
    pendingCount -= ~i2 ? 1 : 0;
  };
  const timeout2 = { time: time2, handler, cancel: cancel2 };
  timeouts.splice(findTimeout(time2), 0, timeout2);
  pendingCount += 1;
  start$2();
  return timeout2;
};
var findTimeout = (time2) => ~(~timeouts.findIndex((t2) => t2.time > time2) || ~timeouts.length);
raf.cancel = (fn2) => {
  onStartQueue.delete(fn2);
  onFrameQueue.delete(fn2);
  onFinishQueue.delete(fn2);
  updateQueue.delete(fn2);
  writeQueue.delete(fn2);
};
raf.sync = (fn2) => {
  sync = true;
  raf.batchedUpdates(fn2);
  sync = false;
};
raf.throttle = (fn2) => {
  let lastArgs;
  function queuedFn() {
    try {
      fn2(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }
  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn2;
  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };
  return throttled;
};
var nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : (
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  () => {
  }
);
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn2) => fn2();
raf.catch = console.error;
raf.frameLoop = "always";
raf.advance = () => {
  if (raf.frameLoop !== "demand") {
    console.warn(
      "Cannot call the manual advancement of rafz whilst frameLoop is not set as demand"
    );
  } else {
    update$1();
  }
};
var ts = -1;
var pendingCount = 0;
var sync = false;
function schedule(fn2, queue) {
  if (sync) {
    queue.delete(fn2);
    fn2(0);
  } else {
    queue.add(fn2);
    start$2();
  }
}
function start$2() {
  if (ts < 0) {
    ts = 0;
    if (raf.frameLoop !== "demand") {
      nativeRaf(loop);
    }
  }
}
function stop$2() {
  ts = -1;
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update$1);
  }
}
function update$1() {
  const prevTs = ts;
  ts = raf.now();
  const count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), (t2) => t2.handler());
    pendingCount -= count;
  }
  if (!pendingCount) {
    stop$2();
    return;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  let next2 = /* @__PURE__ */ new Set();
  let current = next2;
  return {
    add(fn2) {
      pendingCount += current == next2 && !next2.has(fn2) ? 1 : 0;
      next2.add(fn2);
    },
    delete(fn2) {
      pendingCount -= current == next2 && next2.has(fn2) ? 1 : 0;
      return next2.delete(fn2);
    },
    flush(arg) {
      if (current.size) {
        next2 = /* @__PURE__ */ new Set();
        pendingCount -= current.size;
        eachSafely(current, (fn2) => fn2(arg) && next2.add(fn2));
        pendingCount += next2.size;
        current = next2;
      }
    }
  };
}
function eachSafely(values6, each2) {
  values6.forEach((value) => {
    try {
      each2(value);
    } catch (e3) {
      raf.catch(e3);
    }
  });
}
function noop$5() {
}
var defineHidden = (obj, key, value) => Object.defineProperty(obj, key, { value, writable: true, configurable: true });
var is2 = {
  arr: Array.isArray,
  obj: (a4) => !!a4 && a4.constructor.name === "Object",
  fun: (a4) => typeof a4 === "function",
  str: (a4) => typeof a4 === "string",
  num: (a4) => typeof a4 === "number",
  und: (a4) => a4 === void 0
};
function isEqual$6(a4, b10) {
  if (is2.arr(a4)) {
    if (!is2.arr(b10) || a4.length !== b10.length)
      return false;
    for (let i2 = 0; i2 < a4.length; i2++) {
      if (a4[i2] !== b10[i2])
        return false;
    }
    return true;
  }
  return a4 === b10;
}
var each = (obj, fn2) => obj.forEach(fn2);
function eachProp(obj, fn2, ctx2) {
  if (is2.arr(obj)) {
    for (let i2 = 0; i2 < obj.length; i2++) {
      fn2.call(ctx2, obj[i2], `${i2}`);
    }
    return;
  }
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      fn2.call(ctx2, obj[key], key);
    }
  }
}
var toArray$4 = (a4) => is2.und(a4) ? [] : is2.arr(a4) ? a4 : [a4];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
var flushCalls = (queue, ...args) => flush(queue, (fn2) => fn2(...args));
var isSSR = () => typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
var createStringInterpolator;
var to;
var colors$2 = null;
var skipAnimation = false;
var willAdvance = noop$5;
var assign$3 = (globals) => {
  if (globals.to)
    to = globals.to;
  if (globals.now)
    raf.now = globals.now;
  if (globals.colors !== void 0)
    colors$2 = globals.colors;
  if (globals.skipAnimation != null)
    skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator)
    createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame)
    raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates)
    raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance)
    willAdvance = globals.willAdvance;
  if (globals.frameLoop)
    raf.frameLoop = globals.frameLoop;
};
var startQueue = /* @__PURE__ */ new Set();
var currentFrame = [];
var prevFrame = [];
var priority = 0;
var frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  /** Advance the given animation on every frame until idle. */
  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  /** Advance all animations by the given time. */
  advance,
  /** Call this when an animation's priority changes. */
  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */
  clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation))
    startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(
    findIndex$1(currentFrame, (other) => other.priority > animation.priority),
    0,
    animation
  );
}
function advance(dt) {
  const nextFrame = prevFrame;
  for (let i2 = 0; i2 < currentFrame.length; i2++) {
    const animation = currentFrame[i2];
    priority = animation.priority;
    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex$1(arr, test2) {
  const index2 = arr.findIndex(test2);
  return index2 < 0 ? arr.length : index2;
}
var clamp$2 = (min2, max2, v) => Math.min(Math.max(v, min2), max2);
var colors2 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};
var NUMBER = "[-+]?\\d*\\.?\\d+";
var PERCENTAGE = NUMBER + "%";
function call$1(...parts) {
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var rgb$2 = new RegExp("rgb" + call$1(NUMBER, NUMBER, NUMBER));
var rgba$1 = new RegExp("rgba" + call$1(NUMBER, NUMBER, NUMBER, NUMBER));
var hsl$1 = new RegExp("hsl" + call$1(NUMBER, PERCENTAGE, PERCENTAGE));
var hsla$1 = new RegExp(
  "hsla" + call$1(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)
);
var hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var hex6 = /^#([0-9a-fA-F]{6})$/;
var hex8 = /^#([0-9a-fA-F]{8})$/;
function normalizeColor(color2) {
  let match2;
  if (typeof color2 === "number") {
    return color2 >>> 0 === color2 && color2 >= 0 && color2 <= 4294967295 ? color2 : null;
  }
  if (match2 = hex6.exec(color2))
    return parseInt(match2[1] + "ff", 16) >>> 0;
  if (colors$2 && colors$2[color2] !== void 0) {
    return colors$2[color2];
  }
  if (match2 = rgb$2.exec(color2)) {
    return (parse255(match2[1]) << 24 | // r
    parse255(match2[2]) << 16 | // g
    parse255(match2[3]) << 8 | // b
    255) >>> // a
    0;
  }
  if (match2 = rgba$1.exec(color2)) {
    return (parse255(match2[1]) << 24 | // r
    parse255(match2[2]) << 16 | // g
    parse255(match2[3]) << 8 | // b
    parse1(match2[4])) >>> // a
    0;
  }
  if (match2 = hex3.exec(color2)) {
    return parseInt(
      match2[1] + match2[1] + // r
      match2[2] + match2[2] + // g
      match2[3] + match2[3] + // b
      "ff",
      // a
      16
    ) >>> 0;
  }
  if (match2 = hex8.exec(color2))
    return parseInt(match2[1], 16) >>> 0;
  if (match2 = hex4.exec(color2)) {
    return parseInt(
      match2[1] + match2[1] + // r
      match2[2] + match2[2] + // g
      match2[3] + match2[3] + // b
      match2[4] + match2[4],
      // a
      16
    ) >>> 0;
  }
  if (match2 = hsl$1.exec(color2)) {
    return (hslToRgb(
      parse360(match2[1]),
      // h
      parsePercentage(match2[2]),
      // s
      parsePercentage(match2[3])
      // l
    ) | 255) >>> // a
    0;
  }
  if (match2 = hsla$1.exec(color2)) {
    return (hslToRgb(
      parse360(match2[1]),
      // h
      parsePercentage(match2[2]),
      // s
      parsePercentage(match2[3])
      // l
    ) | parse1(match2[4])) >>> // a
    0;
  }
  return null;
}
function hue2rgb(p, q2, t2) {
  if (t2 < 0)
    t2 += 1;
  if (t2 > 1)
    t2 -= 1;
  if (t2 < 1 / 6)
    return p + (q2 - p) * 6 * t2;
  if (t2 < 1 / 2)
    return q2;
  if (t2 < 2 / 3)
    return p + (q2 - p) * (2 / 3 - t2) * 6;
  return p;
}
function hslToRgb(h3, s4, l) {
  const q2 = l < 0.5 ? l * (1 + s4) : l + s4 - l * s4;
  const p = 2 * l - q2;
  const r = hue2rgb(p, q2, h3 + 1 / 3);
  const g2 = hue2rgb(p, q2, h3);
  const b10 = hue2rgb(p, q2, h3 - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g2 * 255) << 16 | Math.round(b10 * 255) << 8;
}
function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}
function colorToRgba(input2) {
  let int32Color = normalizeColor(input2);
  if (int32Color === null)
    return input2;
  int32Color = int32Color || 0;
  const r = (int32Color & 4278190080) >>> 24;
  const g2 = (int32Color & 16711680) >>> 16;
  const b10 = (int32Color & 65280) >>> 8;
  const a4 = (int32Color & 255) / 255;
  return `rgba(${r}, ${g2}, ${b10}, ${a4})`;
}
var createInterpolator = (range2, output, extrapolate) => {
  if (is2.fun(range2)) {
    return range2;
  }
  if (is2.arr(range2)) {
    return createInterpolator({
      range: range2,
      output,
      extrapolate
    });
  }
  if (is2.str(range2.output[0])) {
    return createStringInterpolator(range2);
  }
  const config2 = range2;
  const outputRange = config2.output;
  const inputRange = config2.range || [0, 1];
  const extrapolateLeft = config2.extrapolateLeft || config2.extrapolate || "extend";
  const extrapolateRight = config2.extrapolateRight || config2.extrapolate || "extend";
  const easing = config2.easing || ((t2) => t2);
  return (input2) => {
    const range22 = findRange(input2, inputRange);
    return interpolate$1(
      input2,
      inputRange[range22],
      inputRange[range22 + 1],
      outputRange[range22],
      outputRange[range22 + 1],
      easing,
      extrapolateLeft,
      extrapolateRight,
      config2.map
    );
  };
};
function interpolate$1(input2, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map2) {
  let result = map2 ? map2(input2) : input2;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input2 <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input2, inputRange) {
  for (var i2 = 1; i2 < inputRange.length - 1; ++i2)
    if (inputRange[i2] >= input2)
      break;
  return i2 - 1;
}
var steps = (steps2, direction = "end") => (progress2) => {
  progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
  const expanded = progress2 * steps2;
  const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
  return clamp$2(0, 1, rounded / steps2);
};
var c1 = 1.70158;
var c2 = c1 * 1.525;
var c3 = c1 + 1;
var c4 = 2 * Math.PI / 3;
var c5 = 2 * Math.PI / 4.5;
var bounceOut$1 = (x3) => {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (x3 < 1 / d1) {
    return n1 * x3 * x3;
  } else if (x3 < 2 / d1) {
    return n1 * (x3 -= 1.5 / d1) * x3 + 0.75;
  } else if (x3 < 2.5 / d1) {
    return n1 * (x3 -= 2.25 / d1) * x3 + 0.9375;
  } else {
    return n1 * (x3 -= 2.625 / d1) * x3 + 0.984375;
  }
};
var easings = {
  linear: (x3) => x3,
  easeInQuad: (x3) => x3 * x3,
  easeOutQuad: (x3) => 1 - (1 - x3) * (1 - x3),
  easeInOutQuad: (x3) => x3 < 0.5 ? 2 * x3 * x3 : 1 - Math.pow(-2 * x3 + 2, 2) / 2,
  easeInCubic: (x3) => x3 * x3 * x3,
  easeOutCubic: (x3) => 1 - Math.pow(1 - x3, 3),
  easeInOutCubic: (x3) => x3 < 0.5 ? 4 * x3 * x3 * x3 : 1 - Math.pow(-2 * x3 + 2, 3) / 2,
  easeInQuart: (x3) => x3 * x3 * x3 * x3,
  easeOutQuart: (x3) => 1 - Math.pow(1 - x3, 4),
  easeInOutQuart: (x3) => x3 < 0.5 ? 8 * x3 * x3 * x3 * x3 : 1 - Math.pow(-2 * x3 + 2, 4) / 2,
  easeInQuint: (x3) => x3 * x3 * x3 * x3 * x3,
  easeOutQuint: (x3) => 1 - Math.pow(1 - x3, 5),
  easeInOutQuint: (x3) => x3 < 0.5 ? 16 * x3 * x3 * x3 * x3 * x3 : 1 - Math.pow(-2 * x3 + 2, 5) / 2,
  easeInSine: (x3) => 1 - Math.cos(x3 * Math.PI / 2),
  easeOutSine: (x3) => Math.sin(x3 * Math.PI / 2),
  easeInOutSine: (x3) => -(Math.cos(Math.PI * x3) - 1) / 2,
  easeInExpo: (x3) => x3 === 0 ? 0 : Math.pow(2, 10 * x3 - 10),
  easeOutExpo: (x3) => x3 === 1 ? 1 : 1 - Math.pow(2, -10 * x3),
  easeInOutExpo: (x3) => x3 === 0 ? 0 : x3 === 1 ? 1 : x3 < 0.5 ? Math.pow(2, 20 * x3 - 10) / 2 : (2 - Math.pow(2, -20 * x3 + 10)) / 2,
  easeInCirc: (x3) => 1 - Math.sqrt(1 - Math.pow(x3, 2)),
  easeOutCirc: (x3) => Math.sqrt(1 - Math.pow(x3 - 1, 2)),
  easeInOutCirc: (x3) => x3 < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x3, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x3 + 2, 2)) + 1) / 2,
  easeInBack: (x3) => c3 * x3 * x3 * x3 - c1 * x3 * x3,
  easeOutBack: (x3) => 1 + c3 * Math.pow(x3 - 1, 3) + c1 * Math.pow(x3 - 1, 2),
  easeInOutBack: (x3) => x3 < 0.5 ? Math.pow(2 * x3, 2) * ((c2 + 1) * 2 * x3 - c2) / 2 : (Math.pow(2 * x3 - 2, 2) * ((c2 + 1) * (x3 * 2 - 2) + c2) + 2) / 2,
  easeInElastic: (x3) => x3 === 0 ? 0 : x3 === 1 ? 1 : -Math.pow(2, 10 * x3 - 10) * Math.sin((x3 * 10 - 10.75) * c4),
  easeOutElastic: (x3) => x3 === 0 ? 0 : x3 === 1 ? 1 : Math.pow(2, -10 * x3) * Math.sin((x3 * 10 - 0.75) * c4) + 1,
  easeInOutElastic: (x3) => x3 === 0 ? 0 : x3 === 1 ? 1 : x3 < 0.5 ? -(Math.pow(2, 20 * x3 - 10) * Math.sin((20 * x3 - 11.125) * c5)) / 2 : Math.pow(2, -20 * x3 + 10) * Math.sin((20 * x3 - 11.125) * c5) / 2 + 1,
  easeInBounce: (x3) => 1 - bounceOut$1(1 - x3),
  easeOutBounce: bounceOut$1,
  easeInOutBounce: (x3) => x3 < 0.5 ? (1 - bounceOut$1(1 - 2 * x3)) / 2 : (1 + bounceOut$1(2 * x3 - 1)) / 2,
  steps
};
var $get = Symbol.for("FluidValue.get");
var $observers = Symbol.for("FluidValue.observers");
var hasFluidValue = (arg) => Boolean(arg && arg[$get]);
var getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
var getFluidObservers = (target) => target[$observers] || null;
function callFluidObserver(observer2, event2) {
  if (observer2.eventObserved) {
    observer2.eventObserved(event2);
  } else {
    observer2(event2);
  }
}
function callFluidObservers(target, event2) {
  const observers = target[$observers];
  if (observers) {
    observers.forEach((observer2) => {
      callFluidObserver(observer2, event2);
    });
  }
}
var FluidValue = class {
  constructor(get9) {
    if (!get9 && !(get9 = this.get)) {
      throw Error("Unknown getter");
    }
    setFluidGetter(this, get9);
  }
};
var setFluidGetter = (target, get9) => setHidden(target, $get, get9);
function addFluidObserver(target, observer2) {
  if (target[$get]) {
    let observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = /* @__PURE__ */ new Set());
    }
    if (!observers.has(observer2)) {
      observers.add(observer2);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer2);
      }
    }
  }
  return observer2;
}
function removeFluidObserver(target, observer2) {
  const observers = target[$observers];
  if (observers && observers.has(observer2)) {
    const count = observers.size - 1;
    if (count) {
      observers.delete(observer2);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer2);
    }
  }
}
var setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});
var numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var unitRegex = new RegExp(`(${numberRegex.source})(%|[a-z]+)`, "i");
var rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
var variableToRgba = (input2) => {
  const [token2, fallback] = parseCSSVariable(input2);
  if (!token2 || isSSR()) {
    return input2;
  }
  const value = window.getComputedStyle(document.documentElement).getPropertyValue(token2);
  if (value) {
    return value.trim();
  } else if (fallback && fallback.startsWith("--")) {
    const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
    if (value2) {
      return value2;
    } else {
      return input2;
    }
  } else if (fallback && cssVariableRegex.test(fallback)) {
    return variableToRgba(fallback);
  } else if (fallback) {
    return fallback;
  }
  return input2;
};
var parseCSSVariable = (current) => {
  const match2 = cssVariableRegex.exec(current);
  if (!match2)
    return [,];
  const [, token2, fallback] = match2;
  return [token2, fallback];
};
var namedColorRegex;
var rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var createStringInterpolator2 = (config2) => {
  if (!namedColorRegex)
    namedColorRegex = colors$2 ? (
      // match color names, ignore partial matches
      new RegExp(`(${Object.keys(colors$2).join("|")})(?!\\w)`, "g")
    ) : (
      // never match
      /^\b$/
    );
  const output = config2.output.map((value) => {
    return getFluidValue(value).replace(cssVariableRegex, variableToRgba).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba);
  });
  const keyframes3 = output.map((value) => value.match(numberRegex).map(Number));
  const outputRanges = keyframes3[0].map(
    (_, i2) => keyframes3.map((values6) => {
      if (!(i2 in values6)) {
        throw Error('The arity of each "output" value must be equal');
      }
      return values6[i2];
    })
  );
  const interpolators = outputRanges.map(
    (output2) => createInterpolator({ ...config2, output: output2 })
  );
  return (input2) => {
    var _a2;
    const missingUnit = !unitRegex.test(output[0]) && ((_a2 = output.find((value) => unitRegex.test(value))) == null ? void 0 : _a2.replace(numberRegex, ""));
    let i2 = 0;
    return output[0].replace(
      numberRegex,
      () => `${interpolators[i2++](input2)}${missingUnit || ""}`
    ).replace(rgbaRegex, rgbaRound);
  };
};
var prefix = "react-spring: ";
var once = (fn2) => {
  const func = fn2;
  let called = false;
  if (typeof func != "function") {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }
  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
var warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(
    `${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`
  );
}
var warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(
    `${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`
  );
}
function isAnimatedString(value) {
  return is2.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
  !isSSR() && cssVariableRegex.test(value) || value in (colors$2 || {}));
}
var useIsomorphicLayoutEffect$1 = isSSR() ? useEffect : useLayoutEffect;
var useIsMounted$1 = () => {
  const isMounted = useRef(false);
  useIsomorphicLayoutEffect$1(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};
function useForceUpdate() {
  const update2 = useState()[1];
  const isMounted = useIsMounted$1();
  return () => {
    if (isMounted.current) {
      update2(Math.random());
    }
  };
}
function useMemoOne(getResult, inputs) {
  const [initial] = useState(
    () => ({
      inputs,
      result: getResult()
    })
  );
  const committed = useRef();
  const prevCache = committed.current;
  let cache2 = prevCache;
  if (cache2) {
    const useCache = Boolean(
      inputs && cache2.inputs && areInputsEqual(inputs, cache2.inputs)
    );
    if (!useCache) {
      cache2 = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache2 = initial;
  }
  useEffect(() => {
    committed.current = cache2;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache2]);
  return cache2.result;
}
function areInputsEqual(next2, prev2) {
  if (next2.length !== prev2.length) {
    return false;
  }
  for (let i2 = 0; i2 < next2.length; i2++) {
    if (next2[i2] !== prev2[i2]) {
      return false;
    }
  }
  return true;
}
var useOnce = (effect2) => useEffect(effect2, emptyDeps);
var emptyDeps = [];
function usePrev(value) {
  const prevRef = useRef();
  useEffect(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}
var useReducedMotion = () => {
  const [reducedMotion, setReducedMotion] = useState(null);
  useIsomorphicLayoutEffect$1(() => {
    const mql = window.matchMedia("(prefers-reduced-motion)");
    const handleMediaChange = (e3) => {
      setReducedMotion(e3.matches);
      assign$3({
        skipAnimation: e3.matches
      });
    };
    handleMediaChange(mql);
    mql.addEventListener("change", handleMediaChange);
    return () => {
      mql.removeEventListener("change", handleMediaChange);
    };
  }, []);
  return reducedMotion;
};
var $node = Symbol.for("Animated:node");
var isAnimated = (value) => !!value && value[$node] === value;
var getAnimated = (owner) => owner && owner[$node];
var setAnimated = (owner, node2) => defineHidden(owner, $node, node2);
var getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
var Animated = class {
  constructor() {
    setAnimated(this, this);
  }
  /** Get every `AnimatedValue` used by this node. */
  getPayload() {
    return this.payload || [];
  }
};
var AnimatedValue = class extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.durationProgress = 0;
    if (is2.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  /** @internal */
  static create(value) {
    return new AnimatedValue(value);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step2) {
    if (is2.num(value)) {
      this.lastPosition = value;
      if (step2) {
        value = Math.round(value / step2) * step2;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const { done: done2 } = this;
    this.done = false;
    if (is2.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done2)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
};
var AnimatedString = class extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }
  /** @internal */
  static create(value) {
    return new AnimatedString(value);
  }
  getValue() {
    const value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (is2.str(value)) {
      if (value == this._string) {
        return false;
      }
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
};
var TreeContext = { dependencies: null };
var AnimatedObject = class extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }
  getValue(animated2) {
    const values6 = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values6[key] = source.getValue(animated2);
      } else if (hasFluidValue(source)) {
        values6[key] = getFluidValue(source);
      } else if (!animated2) {
        values6[key] = source;
      }
    });
    return values6;
  }
  /** Replace the raw object data */
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      each(this.payload, (node2) => node2.reset());
    }
  }
  /** Create a payload set. */
  _makePayload(source) {
    if (source) {
      const payload = /* @__PURE__ */ new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  /** Add to a payload set. */
  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      each(payload, (node2) => this.add(node2));
    }
  }
};
var AnimatedArray = class extends AnimatedObject {
  constructor(source) {
    super(source);
  }
  /** @internal */
  static create(source) {
    return new AnimatedArray(source);
  }
  getValue() {
    return this.source.map((node2) => node2.getValue());
  }
  setValue(source) {
    const payload = this.getPayload();
    if (source.length == payload.length) {
      return payload.map((node2, i2) => node2.setValue(source[i2])).some(Boolean);
    }
    super.setValue(source.map(makeAnimated));
    return true;
  }
};
function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}
function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is2.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}
var withAnimated = (Component2, host2) => {
  const hasInstance = (
    // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is2.fun(Component2) || Component2.prototype && Component2.prototype.isReactComponent
  );
  return forwardRef((givenProps, givenRef) => {
    const instanceRef = useRef(null);
    const ref2 = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
    useCallback(
      (value) => {
        instanceRef.current = updateRef(givenRef, value);
      },
      [givenRef]
    );
    const [props2, deps] = getAnimatedState(givenProps, host2);
    const forceUpdate = useForceUpdate();
    const callback = () => {
      const instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      const didUpdate = instance ? host2.applyAnimatedValues(instance, props2.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    const observer = new PropsObserver(callback, deps);
    const observerRef = useRef();
    useIsomorphicLayoutEffect$1(() => {
      observerRef.current = observer;
      each(deps, (dep) => addFluidObserver(dep, observer));
      return () => {
        if (observerRef.current) {
          each(
            observerRef.current.deps,
            (dep) => removeFluidObserver(dep, observerRef.current)
          );
          raf.cancel(observerRef.current.update);
        }
      };
    });
    useEffect(callback, []);
    useOnce(() => () => {
      const observer2 = observerRef.current;
      each(observer2.deps, (dep) => removeFluidObserver(dep, observer2));
    });
    const usedProps = host2.getComponentProps(props2.getValue());
    return /* @__PURE__ */ React.createElement(Component2, { ...usedProps, ref: ref2 });
  });
};
var PropsObserver = class {
  constructor(update2, deps) {
    this.update = update2;
    this.deps = deps;
  }
  eventObserved(event2) {
    if (event2.type == "change") {
      raf.write(this.update);
    }
  }
};
function getAnimatedState(props2, host2) {
  const dependencies2 = /* @__PURE__ */ new Set();
  TreeContext.dependencies = dependencies2;
  if (props2.style)
    props2 = {
      ...props2,
      style: host2.createAnimatedStyle(props2.style)
    };
  props2 = new AnimatedObject(props2);
  TreeContext.dependencies = null;
  return [props2, dependencies2];
}
function updateRef(ref2, value) {
  if (ref2) {
    if (is2.fun(ref2))
      ref2(value);
    else
      ref2.current = value;
  }
  return value;
}
var cacheKey = Symbol.for("AnimatedComponent");
var createHost = (components2, {
  applyAnimatedValues: applyAnimatedValues2 = () => false,
  createAnimatedStyle = (style2) => new AnimatedObject(style2),
  getComponentProps = (props2) => props2
} = {}) => {
  const hostConfig = {
    applyAnimatedValues: applyAnimatedValues2,
    createAnimatedStyle,
    getComponentProps
  };
  const animated2 = (Component2) => {
    const displayName = getDisplayName(Component2) || "Anonymous";
    if (is2.str(Component2)) {
      Component2 = animated2[Component2] || (animated2[Component2] = withAnimated(Component2, hostConfig));
    } else {
      Component2 = Component2[cacheKey] || (Component2[cacheKey] = withAnimated(Component2, hostConfig));
    }
    Component2.displayName = `Animated(${displayName})`;
    return Component2;
  };
  eachProp(components2, (Component2, key) => {
    if (is2.arr(components2)) {
      key = getDisplayName(Component2);
    }
    animated2[key] = animated2(Component2);
  });
  return {
    animated: animated2
  };
};
var getDisplayName = (arg) => is2.str(arg) ? arg : arg && is2.str(arg.displayName) ? arg.displayName : is2.fun(arg) && arg.name || null;
function callProp(value, ...args) {
  return is2.fun(value) ? value(...args) : value;
}
var matchProp = (value, key) => value === true || !!(key && value && (is2.fun(value) ? value(key) : toArray$4(value).includes(key)));
var resolveProp = (prop, key) => is2.obj(prop) ? key && prop[key] : prop;
var getDefaultProp = (props2, key) => props2.default === true ? props2[key] : props2.default ? props2.default[key] : void 0;
var noopTransform = (value) => value;
var getDefaultProps = (props2, transform = noopTransform) => {
  let keys8 = DEFAULT_PROPS;
  if (props2.default && props2.default !== true) {
    props2 = props2.default;
    keys8 = Object.keys(props2);
  }
  const defaults2 = {};
  for (const key of keys8) {
    const value = transform(props2[key], key);
    if (!is2.und(value)) {
      defaults2[key] = value;
    }
  }
  return defaults2;
};
var DEFAULT_PROPS = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
];
var RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  // Transition props
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  // Internal props
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props2) {
  const forward = {};
  let count = 0;
  eachProp(props2, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props2) {
  const to2 = getForwardProps(props2);
  if (to2) {
    const out = { to: to2 };
    eachProp(props2, (val, key) => key in to2 || (out[key] = val));
    return out;
  }
  return { ...props2 };
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is2.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals_exports.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props2) {
  for (const _ in props2)
    return true;
  return false;
}
function isAsyncTo(to2) {
  return is2.fun(to2) || is2.arr(to2) && is2.obj(to2[0]);
}
function detachRefs(ctrl, ref2) {
  var _a2;
  (_a2 = ctrl.ref) == null ? void 0 : _a2.delete(ctrl);
  ref2 == null ? void 0 : ref2.delete(ctrl);
}
function replaceRef(ctrl, ref2) {
  var _a2;
  if (ref2 && ctrl.ref !== ref2) {
    (_a2 = ctrl.ref) == null ? void 0 : _a2.delete(ctrl);
    ref2.add(ctrl);
    ctrl.ref = ref2;
  }
}
var config = {
  default: { tension: 170, friction: 26 },
  gentle: { tension: 120, friction: 14 },
  wobbly: { tension: 180, friction: 12 },
  stiff: { tension: 210, friction: 20 },
  slow: { tension: 280, friction: 60 },
  molasses: { tension: 280, friction: 120 }
};
var defaults$3 = {
  ...config.default,
  mass: 1,
  damping: 1,
  easing: easings.linear,
  clamp: false
};
var AnimationConfig = class {
  constructor() {
    this.velocity = 0;
    Object.assign(this, defaults$3);
  }
};
function mergeConfig$1(config2, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = { ...defaultConfig };
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = { ...defaultConfig, ...newConfig };
  }
  sanitizeConfig(config2, newConfig);
  Object.assign(config2, newConfig);
  for (const key in defaults$3) {
    if (config2[key] == null) {
      config2[key] = defaults$3[key];
    }
  }
  let { frequency, damping } = config2;
  const { mass } = config2;
  if (!is2.und(frequency)) {
    if (frequency < 0.01)
      frequency = 0.01;
    if (damping < 0)
      damping = 0;
    config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config2.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config2;
}
function sanitizeConfig(config2, props2) {
  if (!is2.und(props2.decay)) {
    config2.duration = void 0;
  } else {
    const isTensionConfig = !is2.und(props2.tension) || !is2.und(props2.friction);
    if (isTensionConfig || !is2.und(props2.frequency) || !is2.und(props2.damping) || !is2.und(props2.mass)) {
      config2.duration = void 0;
      config2.decay = void 0;
    }
    if (isTensionConfig) {
      config2.frequency = void 0;
    }
  }
}
var emptyArray$1 = [];
var Animation = class {
  constructor() {
    this.changed = false;
    this.values = emptyArray$1;
    this.toValues = null;
    this.fromValues = emptyArray$1;
    this.config = new AnimationConfig();
    this.immediate = false;
  }
};
function scheduleProps(callId, { key, props: props2, defaultProps: defaultProps2, state, actions }) {
  return new Promise((resolve, reject) => {
    let delay;
    let timeout2;
    let cancel2 = matchProp(props2.cancel ?? (defaultProps2 == null ? void 0 : defaultProps2.cancel), key);
    if (cancel2) {
      onStart();
    } else {
      if (!is2.und(props2.pause)) {
        state.paused = matchProp(props2.pause, key);
      }
      let pause = defaultProps2 == null ? void 0 : defaultProps2.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props2.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout2);
      timeout2.cancel();
      delay = timeout2.time - raf.now();
    }
    function onResume() {
      if (delay > 0 && !globals_exports.skipAnimation) {
        state.delayed = true;
        timeout2 = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout2);
      } else {
        onStart();
      }
    }
    function onStart() {
      if (state.delayed) {
        state.delayed = false;
      }
      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout2);
      if (callId <= (state.cancelId || 0)) {
        cancel2 = true;
      }
      try {
        actions.start({ ...props2, callId, cancel: cancel2 }, resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}
var getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target.get()) : results.every((result) => result.noop) ? getNoopResult(target.get()) : getFinishedResult(
  target.get(),
  results.every((result) => result.finished)
);
var getNoopResult = (value) => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
var getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
var getCancelledResult = (value) => ({
  value,
  cancelled: true,
  finished: false
});
function runAsync(to2, props2, state, target) {
  const { callId, parentId, onRest } = props2;
  const { asyncTo: prevTo, promise: prevPromise } = state;
  if (!parentId && to2 === prevTo && !props2.reset) {
    return prevPromise;
  }
  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to2;
    const defaultProps2 = getDefaultProps(
      props2,
      (value, key) => (
        // The `onRest` prop is only called when the `runAsync` promise is resolved.
        key === "onRest" ? void 0 : value
      )
    );
    let preventBail;
    let bail;
    const bailPromise = new Promise(
      (resolve, reject) => (preventBail = resolve, bail = reject)
    );
    const bailIfEnded = (bailSignal) => {
      const bailResult = (
        // The `cancel` prop or `stop` method was used.
        callId <= (state.cancelId || 0) && getCancelledResult(target) || // The async `to` prop was replaced.
        callId !== state.asyncId && getFinishedResult(target, false)
      );
      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };
    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAnimationSignal();
      return (async () => {
        if (globals_exports.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }
        bailIfEnded(bailSignal);
        const props22 = is2.obj(arg1) ? { ...arg1 } : { ...arg2, to: arg1 };
        props22.parentId = callId;
        eachProp(defaultProps2, (value, key) => {
          if (is2.und(props22[key])) {
            props22[key] = value;
          }
        });
        const result2 = await target.start(props22);
        bailIfEnded(bailSignal);
        if (state.paused) {
          await new Promise((resume) => {
            state.resumeQueue.add(resume);
          });
        }
        return result2;
      })();
    };
    let result;
    if (globals_exports.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }
    try {
      let animating;
      if (is2.arr(to2)) {
        animating = (async (queue) => {
          for (const props22 of queue) {
            await animate(props22);
          }
        })(to2);
      } else {
        animating = Promise.resolve(to2(animate, target.stop.bind(target)));
      }
      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAnimationSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }
    if (is2.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }
    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, (t2) => t2.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId)
    state.cancelId = cancelId;
}
var BailSignal = class extends Error {
  constructor() {
    super(
      "An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise."
    );
  }
};
var SkipAnimationSignal = class extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
};
var isFrameValue = (value) => value instanceof FrameValue;
var nextId = 1;
var FrameValue = class extends FluidValue {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(priority2) {
    if (this._priority != priority2) {
      this._priority = priority2;
      this._onPriorityChange(priority2);
    }
  }
  /** Get the current value */
  get() {
    const node2 = getAnimated(this);
    return node2 && node2.getValue();
  }
  /** Create a spring that maps our value to another value */
  to(...args) {
    return globals_exports.to(this, args);
  }
  /** @deprecated Use the `to` method instead. */
  interpolate(...args) {
    deprecateInterpolate();
    return globals_exports.to(this, args);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(count) {
    if (count == 1)
      this._attach();
  }
  observerRemoved(count) {
    if (count == 0)
      this._detach();
  }
  /** Called when the first child is added. */
  _attach() {
  }
  /** Called when the last child is removed. */
  _detach() {
  }
  /** Tell our children about our new value */
  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  /** Tell our children about our new priority */
  _onPriorityChange(priority2) {
    if (!this.idle) {
      frameLoop.sort(this);
    }
    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority: priority2
    });
  }
};
var $P = Symbol.for("SpringPhase");
var HAS_ANIMATED = 1;
var IS_ANIMATING = 2;
var IS_PAUSED = 4;
var hasAnimated = (target) => (target[$P] & HAS_ANIMATED) > 0;
var isAnimating = (target) => (target[$P] & IS_ANIMATING) > 0;
var isPaused = (target) => (target[$P] & IS_PAUSED) > 0;
var setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
var setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;
var SpringValue = class extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.animation = new Animation();
    this.defaultProps = {};
    this._state = {
      paused: false,
      delayed: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    this._pendingCalls = /* @__PURE__ */ new Set();
    this._lastCallId = 0;
    this._lastToId = 0;
    this._memoizedDuration = 0;
    if (!is2.und(arg1) || !is2.und(arg2)) {
      const props2 = is2.obj(arg1) ? { ...arg1 } : { ...arg2, from: arg1 };
      if (is2.und(props2.default)) {
        props2.default = true;
      }
      this.start(props2);
    }
  }
  /** Equals true when not advancing on each frame. */
  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }
  get goal() {
    return getFluidValue(this.animation.to);
  }
  get velocity() {
    const node2 = getAnimated(this);
    return node2 instanceof AnimatedValue ? node2.lastVelocity || 0 : node2.getPayload().map((node22) => node22.lastVelocity || 0);
  }
  /**
   * When true, this value has been animated at least once.
   */
  get hasAnimated() {
    return hasAnimated(this);
  }
  /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */
  get isAnimating() {
    return isAnimating(this);
  }
  /**
   * When true, all current and future animations are paused.
   */
  get isPaused() {
    return isPaused(this);
  }
  /**
   *
   *
   */
  get isDelayed() {
    return this._state.delayed;
  }
  /** Advance the current animation by a number of milliseconds */
  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let { toValues } = anim;
    const { config: config2 } = anim;
    const payload = getPayload(anim.to);
    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray$4(getFluidValue(anim.to));
    }
    anim.values.forEach((node22, i2) => {
      if (node22.done)
        return;
      const to2 = (
        // Animated strings always go from 0 to 1.
        node22.constructor == AnimatedString ? 1 : payload ? payload[i2].lastPosition : toValues[i2]
      );
      let finished = anim.immediate;
      let position2 = to2;
      if (!finished) {
        position2 = node22.lastPosition;
        if (config2.tension <= 0) {
          node22.done = true;
          return;
        }
        let elapsed = node22.elapsedTime += dt;
        const from2 = anim.fromValues[i2];
        const v0 = node22.v0 != null ? node22.v0 : node22.v0 = is2.arr(config2.velocity) ? config2.velocity[i2] : config2.velocity;
        let velocity;
        const precision = config2.precision || (from2 == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from2) * 1e-3));
        if (!is2.und(config2.duration)) {
          let p = 1;
          if (config2.duration > 0) {
            if (this._memoizedDuration !== config2.duration) {
              this._memoizedDuration = config2.duration;
              if (node22.durationProgress > 0) {
                node22.elapsedTime = config2.duration * node22.durationProgress;
                elapsed = node22.elapsedTime += dt;
              }
            }
            p = (config2.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node22.durationProgress = p;
          }
          position2 = from2 + config2.easing(p) * (to2 - from2);
          velocity = (position2 - node22.lastPosition) / dt;
          finished = p == 1;
        } else if (config2.decay) {
          const decay = config2.decay === true ? 0.998 : config2.decay;
          const e3 = Math.exp(-(1 - decay) * elapsed);
          position2 = from2 + v0 / (1 - decay) * (1 - e3);
          finished = Math.abs(node22.lastPosition - position2) <= precision;
          velocity = v0 * e3;
        } else {
          velocity = node22.lastVelocity == null ? v0 : node22.lastVelocity;
          const restVelocity = config2.restVelocity || precision / 10;
          const bounceFactor = config2.clamp ? 0 : config2.bounce;
          const canBounce = !is2.und(bounceFactor);
          const isGrowing = from2 == to2 ? node22.v0 > 0 : from2 < to2;
          let isMoving;
          let isBouncing = false;
          const step2 = 1;
          const numSteps = Math.ceil(dt / step2);
          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;
            if (!isMoving) {
              finished = Math.abs(to2 - position2) <= precision;
              if (finished) {
                break;
              }
            }
            if (canBounce) {
              isBouncing = position2 == to2 || position2 > to2 == isGrowing;
              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position2 = to2;
              }
            }
            const springForce = -config2.tension * 1e-6 * (position2 - to2);
            const dampingForce = -config2.friction * 1e-3 * velocity;
            const acceleration = (springForce + dampingForce) / config2.mass;
            velocity = velocity + acceleration * step2;
            position2 = position2 + velocity * step2;
          }
        }
        node22.lastVelocity = velocity;
        if (Number.isNaN(position2)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }
      if (payload && !payload[i2].done) {
        finished = false;
      }
      if (finished) {
        node22.done = true;
      } else {
        idle = false;
      }
      if (node22.setValue(position2, config2.round)) {
        changed = true;
      }
    });
    const node2 = getAnimated(this);
    const currVal = node2.getValue();
    if (idle) {
      const finalVal = getFluidValue(anim.to);
      if ((currVal !== finalVal || changed) && !config2.decay) {
        node2.setValue(finalVal);
        this._onChange(finalVal);
      } else if (changed && config2.decay) {
        this._onChange(currVal);
      }
      this._stop();
    } else if (changed) {
      this._onChange(currVal);
    }
  }
  /** Set the current value, while stopping the current animation */
  set(value) {
    raf.batchedUpdates(() => {
      this._stop();
      this._focus(value);
      this._set(value);
    });
    return this;
  }
  /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */
  pause() {
    this._update({ pause: true });
  }
  /** Resume the animation if paused. */
  resume() {
    this._update({ pause: false });
  }
  /** Skip to the end of the current animation. */
  finish() {
    if (isAnimating(this)) {
      const { to: to2, config: config2 } = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();
        if (!config2.decay) {
          this._set(to2, false);
        }
        this._stop();
      });
    }
    return this;
  }
  /** Push props into the pending queue. */
  update(props2) {
    const queue = this.queue || (this.queue = []);
    queue.push(props2);
    return this;
  }
  start(to2, arg2) {
    let queue;
    if (!is2.und(to2)) {
      queue = [is2.obj(to2) ? to2 : { ...arg2, to: to2 }];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }
    return Promise.all(
      queue.map((props2) => {
        const up = this._update(props2);
        return up;
      })
    ).then((results) => getCombinedResult(this, results));
  }
  /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */
  stop(cancel2) {
    const { to: to2 } = this.animation;
    this._focus(this.get());
    stopAsync(this._state, cancel2 && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to2, cancel2));
    return this;
  }
  /** Restart the animation. */
  reset() {
    this._update({ reset: true });
  }
  /** @internal */
  eventObserved(event2) {
    if (event2.type == "change") {
      this._start();
    } else if (event2.type == "priority") {
      this.priority = event2.priority + 1;
    }
  }
  /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */
  _prepareNode(props2) {
    const key = this.key || "";
    let { to: to2, from: from2 } = props2;
    to2 = is2.obj(to2) ? to2[key] : to2;
    if (to2 == null || isAsyncTo(to2)) {
      to2 = void 0;
    }
    from2 = is2.obj(from2) ? from2[key] : from2;
    if (from2 == null) {
      from2 = void 0;
    }
    const range2 = { to: to2, from: from2 };
    if (!hasAnimated(this)) {
      if (props2.reverse)
        [to2, from2] = [from2, to2];
      from2 = getFluidValue(from2);
      if (!is2.und(from2)) {
        this._set(from2);
      } else if (!getAnimated(this)) {
        this._set(to2);
      }
    }
    return range2;
  }
  /** Every update is processed by this method before merging. */
  _update({ ...props2 }, isLoop) {
    const { key, defaultProps: defaultProps2 } = this;
    if (props2.default)
      Object.assign(
        defaultProps2,
        getDefaultProps(
          props2,
          (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value
        )
      );
    mergeActiveFn(this, props2, "onProps");
    sendEvent(this, "onProps", props2, this);
    const range2 = this._prepareNode(props2);
    if (Object.isFrozen(this)) {
      throw Error(
        "Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?"
      );
    }
    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props: props2,
      defaultProps: defaultProps2,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(
              this,
              "onPause",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);
            if (isAnimating(this)) {
              this._resume();
            }
            flushCalls(state.resumeQueue);
            sendEvent(
              this,
              "onResume",
              getFinishedResult(this, checkFinished(this, this.animation.to)),
              this
            );
          }
        },
        start: this._merge.bind(this, range2)
      }
    }).then((result) => {
      if (props2.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props2);
        if (nextProps) {
          return this._update(nextProps, true);
        }
      }
      return result;
    });
  }
  /** Merge props into the current animation */
  _merge(range2, props2, resolve) {
    if (props2.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }
    const hasToProp = !is2.und(range2.to);
    const hasFromProp = !is2.und(range2.from);
    if (hasToProp || hasFromProp) {
      if (props2.callId > this._lastToId) {
        this._lastToId = props2.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    const { key, defaultProps: defaultProps2, animation: anim } = this;
    const { to: prevTo, from: prevFrom } = anim;
    let { to: to2 = prevTo, from: from2 = prevFrom } = range2;
    if (hasFromProp && !hasToProp && (!props2.default || is2.und(to2))) {
      to2 = from2;
    }
    if (props2.reverse)
      [to2, from2] = [from2, to2];
    const hasFromChanged = !isEqual$6(from2, prevFrom);
    if (hasFromChanged) {
      anim.from = from2;
    }
    from2 = getFluidValue(from2);
    const hasToChanged = !isEqual$6(to2, prevTo);
    if (hasToChanged) {
      this._focus(to2);
    }
    const hasAsyncTo = isAsyncTo(props2.to);
    const { config: config2 } = anim;
    const { decay, velocity } = config2;
    if (hasToProp || hasFromProp) {
      config2.velocity = 0;
    }
    if (props2.config && !hasAsyncTo) {
      mergeConfig$1(
        config2,
        callProp(props2.config, key),
        // Avoid calling the same "config" prop twice.
        props2.config !== defaultProps2.config ? callProp(defaultProps2.config, key) : void 0
      );
    }
    let node2 = getAnimated(this);
    if (!node2 || is2.und(to2)) {
      return resolve(getFinishedResult(this, true));
    }
    const reset = (
      // When `reset` is undefined, the `from` prop implies `reset: true`,
      // except for declarative updates. When `reset` is defined, there
      // must exist a value to animate from.
      is2.und(props2.reset) ? hasFromProp && !props2.default : !is2.und(from2) && matchProp(props2.reset, key)
    );
    const value = reset ? from2 : this.get();
    const goal = computeGoal(to2);
    const isAnimatable = is2.num(goal) || is2.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps2.immediate || props2.immediate, key));
    if (hasToChanged) {
      const nodeType = getAnimatedType(to2);
      if (nodeType !== node2.constructor) {
        if (immediate) {
          node2 = this._set(goal);
        } else
          throw Error(
            `Cannot animate between ${node2.constructor.name} and ${nodeType.name}, as the "to" prop suggests`
          );
      }
    }
    const goalType = node2.constructor;
    let started = hasFluidValue(to2);
    let finished = false;
    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
      if (hasToChanged || hasValueChanged) {
        finished = isEqual$6(computeGoal(value), goal);
        started = !finished;
      }
      if (!isEqual$6(anim.immediate, immediate) && !immediate || !isEqual$6(config2.decay, decay) || !isEqual$6(config2.velocity, velocity)) {
        started = true;
      }
    }
    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }
    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node2.getPayload();
        anim.toValues = hasFluidValue(to2) ? null : goalType == AnimatedString ? [1] : toArray$4(goal);
      }
      if (anim.immediate != immediate) {
        anim.immediate = immediate;
        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }
      if (started) {
        const { onRest } = anim;
        each(ACTIVE_EVENTS, (type2) => mergeActiveFn(this, props2, type2));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);
        this._pendingCalls.add(resolve);
        if (anim.changed)
          raf.batchedUpdates(() => {
            var _a2;
            anim.changed = !reset;
            onRest == null ? void 0 : onRest(result, this);
            if (reset) {
              callProp(defaultProps2.onRest, result);
            } else {
              (_a2 = anim.onStart) == null ? void 0 : _a2.call(anim, result, this);
            }
          });
      }
    }
    if (reset) {
      this._set(value);
    }
    if (hasAsyncTo) {
      resolve(runAsync(props2.to, props2, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }
  /** Update the `animation.to` value, which might be a `FluidValue` */
  _focus(value) {
    const anim = this.animation;
    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }
      anim.to = value;
      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }
  _attach() {
    let priority2 = 0;
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      addFluidObserver(to2, this);
      if (isFrameValue(to2)) {
        priority2 = to2.priority + 1;
      }
    }
    this.priority = priority2;
  }
  _detach() {
    const { to: to2 } = this.animation;
    if (hasFluidValue(to2)) {
      removeFluidObserver(to2, this);
    }
  }
  /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */
  _set(arg, idle = true) {
    const value = getFluidValue(arg);
    if (!is2.und(value)) {
      const oldNode = getAnimated(this);
      if (!oldNode || !isEqual$6(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);
        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }
        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }
    return getAnimated(this);
  }
  _onStart() {
    const anim = this.animation;
    if (!anim.changed) {
      anim.changed = true;
      sendEvent(
        this,
        "onStart",
        getFinishedResult(this, checkFinished(this, anim.to)),
        this
      );
    }
  }
  _onChange(value, idle) {
    if (!idle) {
      this._onStart();
      callProp(this.animation.onChange, value, this);
    }
    callProp(this.defaultProps.onChange, value, this);
    super._onChange(value, idle);
  }
  // This method resets the animation state (even if already animating) to
  // ensure the latest from/to range is used, and it also ensures this spring
  // is added to the frameloop.
  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));
    if (!anim.immediate) {
      anim.fromValues = anim.values.map((node2) => node2.lastPosition);
    }
    if (!isAnimating(this)) {
      setActiveBit(this, true);
      if (!isPaused(this)) {
        this._resume();
      }
    }
  }
  _resume() {
    if (globals_exports.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }
  /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */
  _stop(goal, cancel2) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      each(anim.values, (node2) => {
        node2.done = true;
      });
      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = void 0;
      }
      callFluidObservers(this, {
        type: "idle",
        parent: this
      });
      const result = cancel2 ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal ?? anim.to));
      flushCalls(this._pendingCalls, result);
      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, "onRest", result, this);
      }
    }
  }
};
function checkFinished(target, to2) {
  const goal = computeGoal(to2);
  const value = computeGoal(target.get());
  return isEqual$6(value, goal);
}
function createLoopUpdate(props2, loop2 = props2.loop, to2 = props2.to) {
  const loopRet = callProp(loop2);
  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse2 = (overrides || props2).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate({
      ...props2,
      loop: loop2,
      // Avoid updating default props when looping.
      default: false,
      // Never loop the `pause` prop.
      pause: void 0,
      // For the "reverse" prop to loop as expected, the "to" prop
      // must be undefined. The "reverse" prop is ignored when the
      // "to" prop is an array or function.
      to: !reverse2 || isAsyncTo(to2) ? to2 : void 0,
      // Ignore the "from" prop except on reset.
      from: reset ? props2.from : void 0,
      reset,
      // The "loop" prop can return a "useSpring" props object to
      // override any of the original props.
      ...overrides
    });
  }
}
function createUpdate(props2) {
  const { to: to2, from: from2 } = props2 = inferTo(props2);
  const keys8 = /* @__PURE__ */ new Set();
  if (is2.obj(to2))
    findDefined(to2, keys8);
  if (is2.obj(from2))
    findDefined(from2, keys8);
  props2.keys = keys8.size ? Array.from(keys8) : null;
  return props2;
}
function declareUpdate(props2) {
  const update2 = createUpdate(props2);
  if (is2.und(update2.default)) {
    update2.default = getDefaultProps(update2);
  }
  return update2;
}
function findDefined(values6, keys8) {
  eachProp(values6, (value, key) => value != null && keys8.add(key));
}
var ACTIVE_EVENTS = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function mergeActiveFn(target, props2, type2) {
  target.animation[type2] = props2[type2] !== getDefaultProp(props2, type2) ? resolveProp(props2[type2], target.key) : void 0;
}
function sendEvent(target, type2, ...args) {
  var _a2, _b, _c, _d;
  (_b = (_a2 = target.animation)[type2]) == null ? void 0 : _b.call(_a2, ...args);
  (_d = (_c = target.defaultProps)[type2]) == null ? void 0 : _d.call(_c, ...args);
}
var BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
var nextId2 = 1;
var Controller$1 = class Controller {
  constructor(props2, flush3) {
    this.id = nextId2++;
    this.springs = {};
    this.queue = [];
    this._lastAsyncId = 0;
    this._active = /* @__PURE__ */ new Set();
    this._changed = /* @__PURE__ */ new Set();
    this._started = false;
    this._state = {
      paused: false,
      pauseQueue: /* @__PURE__ */ new Set(),
      resumeQueue: /* @__PURE__ */ new Set(),
      timeouts: /* @__PURE__ */ new Set()
    };
    this._events = {
      onStart: /* @__PURE__ */ new Map(),
      onChange: /* @__PURE__ */ new Map(),
      onRest: /* @__PURE__ */ new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush3) {
      this._flush = flush3;
    }
    if (props2) {
      this.start({ default: true, ...props2 });
    }
  }
  /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((spring) => {
      return spring.idle && !spring.isDelayed && !spring.isPaused;
    });
  }
  get item() {
    return this._item;
  }
  set item(item) {
    this._item = item;
  }
  /** Get the current values of our springs */
  get() {
    const values6 = {};
    this.each((spring, key) => values6[key] = spring.get());
    return values6;
  }
  /** Set the current values without animating. */
  set(values6) {
    for (const key in values6) {
      const value = values6[key];
      if (!is2.und(value)) {
        this.springs[key].set(value);
      }
    }
  }
  /** Push an update onto the queue of each value. */
  update(props2) {
    if (props2) {
      this.queue.push(createUpdate(props2));
    }
    return this;
  }
  /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */
  start(props2) {
    let { queue } = this;
    if (props2) {
      queue = toArray$4(props2).map(createUpdate);
    } else {
      this.queue = [];
    }
    if (this._flush) {
      return this._flush(this, queue);
    }
    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  /** @internal */
  stop(arg, keys8) {
    if (arg !== !!arg) {
      keys8 = arg;
    }
    if (keys8) {
      const springs = this.springs;
      each(toArray$4(keys8), (key) => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each((spring) => spring.stop(!!arg));
    }
    return this;
  }
  /** Freeze the active animation in time */
  pause(keys8) {
    if (is2.und(keys8)) {
      this.start({ pause: true });
    } else {
      const springs = this.springs;
      each(toArray$4(keys8), (key) => springs[key].pause());
    }
    return this;
  }
  /** Resume the animation if paused. */
  resume(keys8) {
    if (is2.und(keys8)) {
      this.start({ pause: false });
    } else {
      const springs = this.springs;
      each(toArray$4(keys8), (key) => springs[key].resume());
    }
    return this;
  }
  /** Call a function once per spring value */
  each(iterator) {
    eachProp(this.springs, iterator);
  }
  /** @internal Called at the end of every animation frame */
  _onFrame() {
    const { onStart, onChange, onRest } = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;
    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart2, result]) => {
        result.value = this.get();
        onStart2(result, this, this._item);
      });
    }
    const idle = !active && this._started;
    const values6 = changed || idle && onRest.size ? this.get() : null;
    if (changed && onChange.size) {
      flush(onChange, ([onChange2, result]) => {
        result.value = values6;
        onChange2(result, this, this._item);
      });
    }
    if (idle) {
      this._started = false;
      flush(onRest, ([onRest2, result]) => {
        result.value = values6;
        onRest2(result, this, this._item);
      });
    }
  }
  /** @internal */
  eventObserved(event2) {
    if (event2.type == "change") {
      this._changed.add(event2.parent);
      if (!event2.idle) {
        this._active.add(event2.parent);
      }
    } else if (event2.type == "idle") {
      this._active.delete(event2.parent);
    } else
      return;
    raf.onFrame(this._onFrame);
  }
};
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map((props2) => flushUpdate(ctrl, props2))).then(
    (results) => getCombinedResult(ctrl, results)
  );
}
async function flushUpdate(ctrl, props2, isLoop) {
  const { keys: keys8, to: to2, from: from2, loop: loop2, onRest, onResolve } = props2;
  const defaults2 = is2.obj(props2.default) && props2.default;
  if (loop2) {
    props2.loop = false;
  }
  if (to2 === false)
    props2.to = null;
  if (from2 === false)
    props2.from = null;
  const asyncTo = is2.arr(to2) || is2.fun(to2) ? to2 : void 0;
  if (asyncTo) {
    props2.to = void 0;
    props2.onRest = void 0;
    if (defaults2) {
      defaults2.onRest = void 0;
    }
  } else {
    each(BATCHED_EVENTS, (key) => {
      const handler = props2[key];
      if (is2.fun(handler)) {
        const queue = ctrl["_events"][key];
        props2[key] = ({ finished, cancelled }) => {
          const result2 = queue.get(handler);
          if (result2) {
            if (!finished)
              result2.finished = false;
            if (cancelled)
              result2.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };
        if (defaults2) {
          defaults2[key] = props2[key];
        }
      }
    });
  }
  const state = ctrl["_state"];
  if (props2.pause === !state.paused) {
    state.paused = props2.pause;
    flushCalls(props2.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props2.pause = true;
  }
  const promises = (keys8 || Object.keys(ctrl.springs)).map(
    (key) => ctrl.springs[key].start(props2)
  );
  const cancel2 = props2.cancel === true || getDefaultProp(props2, "cancel") === true;
  if (asyncTo || cancel2 && state.asyncId) {
    promises.push(
      scheduleProps(++ctrl["_lastAsyncId"], {
        props: props2,
        state,
        actions: {
          pause: noop$5,
          resume: noop$5,
          start(props22, resolve) {
            if (cancel2) {
              stopAsync(state, ctrl["_lastAsyncId"]);
              resolve(getCancelledResult(ctrl));
            } else {
              props22.onRest = onRest;
              resolve(
                runAsync(
                  asyncTo,
                  props22,
                  state,
                  ctrl
                )
              );
            }
          }
        }
      })
    );
  }
  if (state.paused) {
    await new Promise((resume) => {
      state.resumeQueue.add(resume);
    });
  }
  const result = getCombinedResult(ctrl, await Promise.all(promises));
  if (loop2 && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props2, loop2, to2);
    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }
  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }
  return result;
}
function getSprings(ctrl, props2) {
  const springs = { ...ctrl.springs };
  if (props2) {
    each(toArray$4(props2), (props22) => {
      if (is2.und(props22.keys)) {
        props22 = createUpdate(props22);
      }
      if (!is2.obj(props22.to)) {
        props22 = { ...props22, to: void 0 };
      }
      prepareSprings(springs, props22, (key) => {
        return createSpring(key);
      });
    });
  }
  setSprings(ctrl, springs);
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props2, create2) {
  if (props2.keys) {
    each(props2.keys, (key) => {
      const spring = springs[key] || (springs[key] = create2(key));
      spring["_prepareNode"](props2);
    });
  }
}
function prepareKeys(ctrl, queue) {
  each(queue, (props2) => {
    prepareSprings(ctrl.springs, props2, (key) => {
      return createSpring(key, ctrl);
    });
  });
}
var SpringContext = ({
  children: children2,
  ...props2
}) => {
  const inherited = useContext(ctx);
  const pause = props2.pause || !!inherited.pause, immediate = props2.immediate || !!inherited.immediate;
  props2 = useMemoOne(() => ({ pause, immediate }), [pause, immediate]);
  const { Provider: Provider2 } = ctx;
  return /* @__PURE__ */ React.createElement(Provider2, { value: props2 }, children2);
};
var ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init2) {
  Object.assign(target, React.createContext(init2));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}
var SpringRef = () => {
  const current = [];
  const SpringRef2 = function(props2) {
    deprecateDirectCall();
    const results = [];
    each(current, (ctrl, i2) => {
      if (is2.und(props2)) {
        results.push(ctrl.start());
      } else {
        const update2 = _getProps(props2, ctrl, i2);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.current = current;
  SpringRef2.add = function(ctrl) {
    if (!current.includes(ctrl)) {
      current.push(ctrl);
    }
  };
  SpringRef2.delete = function(ctrl) {
    const i2 = current.indexOf(ctrl);
    if (~i2)
      current.splice(i2, 1);
  };
  SpringRef2.pause = function() {
    each(current, (ctrl) => ctrl.pause(...arguments));
    return this;
  };
  SpringRef2.resume = function() {
    each(current, (ctrl) => ctrl.resume(...arguments));
    return this;
  };
  SpringRef2.set = function(values6) {
    each(current, (ctrl, i2) => {
      const update2 = is2.fun(values6) ? values6(i2, ctrl) : values6;
      if (update2) {
        ctrl.set(update2);
      }
    });
  };
  SpringRef2.start = function(props2) {
    const results = [];
    each(current, (ctrl, i2) => {
      if (is2.und(props2)) {
        results.push(ctrl.start());
      } else {
        const update2 = this._getProps(props2, ctrl, i2);
        if (update2) {
          results.push(ctrl.start(update2));
        }
      }
    });
    return results;
  };
  SpringRef2.stop = function() {
    each(current, (ctrl) => ctrl.stop(...arguments));
    return this;
  };
  SpringRef2.update = function(props2) {
    each(current, (ctrl, i2) => ctrl.update(this._getProps(props2, ctrl, i2)));
    return this;
  };
  const _getProps = function(arg, ctrl, index2) {
    return is2.fun(arg) ? arg(index2, ctrl) : arg;
  };
  SpringRef2._getProps = _getProps;
  return SpringRef2;
};
function useSprings(length2, props2, deps) {
  const propsFn = is2.fun(props2) && props2;
  if (propsFn && !deps)
    deps = [];
  const ref2 = useMemo(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const layoutId = useRef(0);
  const forceUpdate = useForceUpdate();
  const state = useMemo(
    () => ({
      ctrls: [],
      queue: [],
      flush(ctrl, updates2) {
        const springs2 = getSprings(ctrl, updates2);
        const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key) => !ctrl.springs[key]);
        return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve) => {
          setSprings(ctrl, springs2);
          state.queue.push(() => {
            resolve(flushUpdateQueue(ctrl, updates2));
          });
          forceUpdate();
        });
      }
    }),
    []
  );
  const ctrls = useRef([...state.ctrls]);
  const updates = [];
  const prevLength = usePrev(length2) || 0;
  useMemo(() => {
    each(ctrls.current.slice(length2, prevLength), (ctrl) => {
      detachRefs(ctrl, ref2);
      ctrl.stop(true);
    });
    ctrls.current.length = length2;
    declareUpdates(prevLength, length2);
  }, [length2]);
  useMemo(() => {
    declareUpdates(0, Math.min(prevLength, length2));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (let i2 = startIndex; i2 < endIndex; i2++) {
      const ctrl = ctrls.current[i2] || (ctrls.current[i2] = new Controller$1(null, state.flush));
      const update2 = propsFn ? propsFn(i2, ctrl) : props2[i2];
      if (update2) {
        updates[i2] = declareUpdate(update2);
      }
    }
  }
  const springs = ctrls.current.map((ctrl, i2) => getSprings(ctrl, updates[i2]));
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect$1(() => {
    layoutId.current++;
    state.ctrls = ctrls.current;
    const { queue } = state;
    if (queue.length) {
      state.queue = [];
      each(queue, (cb) => cb());
    }
    each(ctrls.current, (ctrl, i2) => {
      ref2 == null ? void 0 : ref2.add(ctrl);
      if (hasContext) {
        ctrl.start({ default: context });
      }
      const update2 = updates[i2];
      if (update2) {
        replaceRef(ctrl, update2.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update2);
        } else {
          ctrl.start(update2);
        }
      }
    });
  });
  useOnce(() => () => {
    each(state.ctrls, (ctrl) => ctrl.stop(true));
  });
  const values6 = springs.map((x3) => ({ ...x3 }));
  return ref2 ? [values6, ref2] : values6;
}
function useSpring(props2, deps) {
  const isFn = is2.fun(props2);
  const [[values6], ref2] = useSprings(
    1,
    isFn ? props2 : [props2],
    isFn ? deps || [] : deps
  );
  return isFn || arguments.length == 2 ? [values6, ref2] : values6;
}
function useTransition(data, props2, deps) {
  const propsFn = is2.fun(props2) && props2;
  const {
    reset,
    sort: sort3,
    trail = 0,
    expires = true,
    exitBeforeEnter = false,
    onDestroyed,
    ref: propsRef,
    config: propsConfig
  } = propsFn ? propsFn() : props2;
  const ref2 = useMemo(
    () => propsFn || arguments.length == 3 ? SpringRef() : void 0,
    []
  );
  const items = toArray$4(data);
  const transitions2 = [];
  const usedTransitions = useRef(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useIsomorphicLayoutEffect$1(() => {
    usedTransitions.current = transitions2;
  });
  useOnce(() => {
    each(transitions2, (t2) => {
      ref2 == null ? void 0 : ref2.add(t2.ctrl);
      t2.ctrl.ref = ref2;
    });
    return () => {
      each(usedTransitions.current, (t2) => {
        if (t2.expired) {
          clearTimeout(t2.expirationId);
        }
        detachRefs(t2.ctrl, ref2);
        t2.ctrl.stop(true);
      });
    };
  });
  const keys8 = getKeys(items, propsFn ? propsFn() : props2, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useIsomorphicLayoutEffect$1(
    () => each(expired, ({ ctrl, item, key }) => {
      detachRefs(ctrl, ref2);
      callProp(onDestroyed, item, key);
    })
  );
  const reused = [];
  if (prevTransitions)
    each(prevTransitions, (t2, i2) => {
      if (t2.expired) {
        clearTimeout(t2.expirationId);
        expired.push(t2);
      } else {
        i2 = reused[i2] = keys8.indexOf(t2.key);
        if (~i2)
          transitions2[i2] = t2;
      }
    });
  each(items, (item, i2) => {
    if (!transitions2[i2]) {
      transitions2[i2] = {
        key: keys8[i2],
        item,
        phase: "mount",
        ctrl: new Controller$1()
      };
      transitions2[i2].ctrl.item = item;
    }
  });
  if (reused.length) {
    let i2 = -1;
    const { leave } = propsFn ? propsFn() : props2;
    each(reused, (keyIndex, prevIndex) => {
      const t2 = prevTransitions[prevIndex];
      if (~keyIndex) {
        i2 = transitions2.indexOf(t2);
        transitions2[i2] = { ...t2, item: items[keyIndex] };
      } else if (leave) {
        transitions2.splice(++i2, 0, t2);
      }
    });
  }
  if (is2.fun(sort3)) {
    transitions2.sort((a4, b10) => sort3(a4.item, b10.item));
  }
  let delay = -trail;
  const forceUpdate = useForceUpdate();
  const defaultProps2 = getDefaultProps(props2);
  const changes = /* @__PURE__ */ new Map();
  const exitingTransitions = useRef(/* @__PURE__ */ new Map());
  const forceChange = useRef(false);
  each(transitions2, (t2, i2) => {
    const key = t2.key;
    const prevPhase = t2.phase;
    const p = propsFn ? propsFn() : props2;
    let to2;
    let phase;
    const propsDelay = callProp(p.delay || 0, key);
    if (prevPhase == "mount") {
      to2 = p.enter;
      phase = "enter";
    } else {
      const isLeave = keys8.indexOf(key) < 0;
      if (prevPhase != "leave") {
        if (isLeave) {
          to2 = p.leave;
          phase = "leave";
        } else if (to2 = p.update) {
          phase = "update";
        } else
          return;
      } else if (!isLeave) {
        to2 = p.enter;
        phase = "enter";
      } else
        return;
    }
    to2 = callProp(to2, t2.item, i2);
    to2 = is2.obj(to2) ? inferTo(to2) : { to: to2 };
    if (!to2.config) {
      const config2 = propsConfig || defaultProps2.config;
      to2.config = callProp(config2, t2.item, i2, phase);
    }
    delay += trail;
    const payload = {
      ...defaultProps2,
      // we need to add our props.delay value you here.
      delay: propsDelay + delay,
      ref: propsRef,
      immediate: p.immediate,
      // This prevents implied resets.
      reset: false,
      // Merge any phase-specific props.
      ...to2
    };
    if (phase == "enter" && is2.und(payload.from)) {
      const p2 = propsFn ? propsFn() : props2;
      const from2 = is2.und(p2.initial) || prevTransitions ? p2.from : p2.initial;
      payload.from = callProp(from2, t2.item, i2);
    }
    const { onResolve } = payload;
    payload.onResolve = (result) => {
      callProp(onResolve, result);
      const transitions22 = usedTransitions.current;
      const t22 = transitions22.find((t3) => t3.key === key);
      if (!t22)
        return;
      if (result.cancelled && t22.phase != "update") {
        return;
      }
      if (t22.ctrl.idle) {
        const idle = transitions22.every((t3) => t3.ctrl.idle);
        if (t22.phase == "leave") {
          const expiry = callProp(expires, t22.item);
          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t22.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647)
                t22.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions22.some((t3) => t3.expired)) {
          exitingTransitions.current.delete(t22);
          if (exitBeforeEnter) {
            forceChange.current = true;
          }
          forceUpdate();
        }
      }
    };
    const springs = getSprings(t2.ctrl, payload);
    if (phase === "leave" && exitBeforeEnter) {
      exitingTransitions.current.set(t2, { phase, springs, payload });
    } else {
      changes.set(t2, { phase, springs, payload });
    }
  });
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useIsomorphicLayoutEffect$1(() => {
    if (hasContext) {
      each(transitions2, (t2) => {
        t2.ctrl.start({ default: context });
      });
    }
  }, [context]);
  each(changes, (_, t2) => {
    if (exitingTransitions.current.size) {
      const ind = transitions2.findIndex((state) => state.key === t2.key);
      transitions2.splice(ind, 1);
    }
  });
  useIsomorphicLayoutEffect$1(
    () => {
      each(
        exitingTransitions.current.size ? exitingTransitions.current : changes,
        ({ phase, payload }, t2) => {
          const { ctrl } = t2;
          t2.phase = phase;
          ref2 == null ? void 0 : ref2.add(ctrl);
          if (hasContext && phase == "enter") {
            ctrl.start({ default: context });
          }
          if (payload) {
            replaceRef(ctrl, payload.ref);
            if ((ctrl.ref || ref2) && !forceChange.current) {
              ctrl.update(payload);
            } else {
              ctrl.start(payload);
              if (forceChange.current) {
                forceChange.current = false;
              }
            }
          }
        }
      );
    },
    reset ? void 0 : deps
  );
  const renderTransitions = (render) => /* @__PURE__ */ React.createElement(React.Fragment, null, transitions2.map((t2, i2) => {
    const { springs } = changes.get(t2) || t2.ctrl;
    const elem = render({ ...springs }, t2.item, t2, i2);
    return elem && elem.type ? /* @__PURE__ */ React.createElement(
      elem.type,
      {
        ...elem.props,
        key: is2.str(t2.key) || is2.num(t2.key) ? t2.key : t2.ctrl.id,
        ref: elem.ref
      }
    ) : elem;
  }));
  return ref2 ? [renderTransitions, ref2] : renderTransitions;
}
var nextKey = 1;
function getKeys(items, { key, keys: keys8 = key }, prevTransitions) {
  if (keys8 === null) {
    const reused = /* @__PURE__ */ new Set();
    return items.map((item) => {
      const t2 = prevTransitions && prevTransitions.find(
        (t22) => t22.item === item && t22.phase !== "leave" && !reused.has(t22)
      );
      if (t2) {
        reused.add(t2);
        return t2.key;
      }
      return nextKey++;
    });
  }
  return is2.und(keys8) ? items : is2.fun(keys8) ? items.map(keys8) : toArray$4(keys8);
}
var Interpolation = class extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    this.idle = true;
    this._active = /* @__PURE__ */ new Set();
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual$6(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }
  _get() {
    const inputs = is2.arr(this.source) ? this.source.map(getFluidValue) : toArray$4(getFluidValue(this.source));
    return this.calc(...inputs);
  }
  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each(getPayload(this), (node2) => {
        node2.done = false;
      });
      if (globals_exports.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }
  // Observe our sources only when we're observed.
  _attach() {
    let priority2 = 1;
    each(toArray$4(this.source), (source) => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }
      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }
        priority2 = Math.max(priority2, source.priority + 1);
      }
    });
    this.priority = priority2;
    this._start();
  }
  // Stop observing our sources once we have no observers.
  _detach() {
    each(toArray$4(this.source), (source) => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });
    this._active.clear();
    becomeIdle(this);
  }
  /** @internal */
  eventObserved(event2) {
    if (event2.type == "change") {
      if (event2.idle) {
        this.advance();
      } else {
        this._active.add(event2.parent);
        this._start();
      }
    } else if (event2.type == "idle") {
      this._active.delete(event2.parent);
    } else if (event2.type == "priority") {
      this.priority = toArray$4(this.source).reduce(
        (highest, parent2) => Math.max(highest, (isFrameValue(parent2) ? parent2.priority : 0) + 1),
        0
      );
    }
  }
};
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self2) {
  if (!self2.idle) {
    self2.idle = true;
    each(getPayload(self2), (node2) => {
      node2.done = true;
    });
    callFluidObservers(self2, {
      type: "idle",
      parent: self2
    });
  }
}
globals_exports.assign({
  createStringInterpolator: createStringInterpolator2,
  to: (source, args) => new Interpolation(source, args)
});
var isCustomPropRE = /^--/;
function dangerousStyleValue(name2, value) {
  if (value == null || typeof value === "boolean" || value === "")
    return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name2) && !(isUnitlessNumber.hasOwnProperty(name2) && isUnitlessNumber[name2]))
    return value + "px";
  return ("" + value).trim();
}
var attributeCache = {};
function applyAnimatedValues(instance, props2) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  const { style: style2, children: children2, scrollTop, scrollLeft, viewBox, ...attributes } = props2;
  const values6 = Object.values(attributes);
  const names = Object.keys(attributes).map(
    (name2) => isFilterElement || instance.hasAttribute(name2) ? name2 : attributeCache[name2] || (attributeCache[name2] = name2.replace(
      /([A-Z])/g,
      // Attributes are written in dash case
      (n) => "-" + n.toLowerCase()
    ))
  );
  if (children2 !== void 0) {
    instance.textContent = children2;
  }
  for (const name2 in style2) {
    if (style2.hasOwnProperty(name2)) {
      const value = dangerousStyleValue(name2, style2[name2]);
      if (isCustomPropRE.test(name2)) {
        instance.style.setProperty(name2, value);
      } else {
        instance.style[name2] = value;
      }
    }
  }
  names.forEach((name2, i2) => {
    instance.setAttribute(name2, values6[i2]);
  });
  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }
  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
  if (viewBox !== void 0) {
    instance.setAttribute("viewBox", viewBox);
  }
}
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
var prefixKey = (prefix2, key) => prefix2 + key.charAt(0).toUpperCase() + key.substring(1);
var prefixes$2 = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes$2.forEach((prefix2) => acc[prefixKey(prefix2, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);
var domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var pxTransforms = /^(translate)/;
var degTransforms = /^(rotate|skew)/;
var addUnit = (value, unit2) => is2.num(value) && value !== 0 ? value + unit2 : value;
var isValueIdentity = (value, id) => is2.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is2.num(value) ? value === id : parseFloat(value) === id;
var AnimatedStyle = class extends AnimatedObject {
  constructor({ x: x3, y: y4, z: z2, ...style2 }) {
    const inputs = [];
    const transforms2 = [];
    if (x3 || y4 || z2) {
      inputs.push([x3 || 0, y4 || 0, z2 || 0]);
      transforms2.push((xyz) => [
        `translate3d(${xyz.map((v) => addUnit(v, "px")).join(",")})`,
        // prettier-ignore
        isValueIdentity(xyz, 0)
      ]);
    }
    eachProp(style2, (value, key) => {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms2.push((transform) => [transform, transform === ""]);
      } else if (domTransforms.test(key)) {
        delete style2[key];
        if (is2.und(value))
          return;
        const unit2 = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray$4(value));
        transforms2.push(
          key === "rotate3d" ? ([x22, y22, z22, deg]) => [
            `rotate3d(${x22},${y22},${z22},${addUnit(deg, unit2)})`,
            isValueIdentity(deg, 0)
          ] : (input2) => [
            `${key}(${input2.map((v) => addUnit(v, unit2)).join(",")})`,
            isValueIdentity(input2, key.startsWith("scale") ? 1 : 0)
          ]
        );
      }
    });
    if (inputs.length) {
      style2.transform = new FluidTransform(inputs, transforms2);
    }
    super(style2);
  }
};
var FluidTransform = class extends FluidValue {
  constructor(inputs, transforms2) {
    super();
    this.inputs = inputs;
    this.transforms = transforms2;
    this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let transform = "";
    let identity2 = true;
    each(this.inputs, (input2, i2) => {
      const arg1 = getFluidValue(input2[0]);
      const [t2, id] = this.transforms[i2](
        is2.arr(arg1) ? arg1 : input2.map(getFluidValue)
      );
      transform += " " + t2;
      identity2 = identity2 && id;
    });
    return identity2 ? "none" : transform;
  }
  // Start observing our inputs once we have an observer.
  observerAdded(count) {
    if (count == 1)
      each(
        this.inputs,
        (input2) => each(
          input2,
          (value) => hasFluidValue(value) && addFluidObserver(value, this)
        )
      );
  }
  // Stop observing our inputs once we have no observers.
  observerRemoved(count) {
    if (count == 0)
      each(
        this.inputs,
        (input2) => each(
          input2,
          (value) => hasFluidValue(value) && removeFluidObserver(value, this)
        )
      );
  }
  eventObserved(event2) {
    if (event2.type == "change") {
      this._value = null;
    }
    callFluidObservers(this, event2);
  }
};
var primitives = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];
globals_exports.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator2,
  colors: colors2
});
var host = createHost(primitives, {
  applyAnimatedValues,
  createAnimatedStyle: (style2) => new AnimatedStyle(style2),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getComponentProps: ({ scrollTop, scrollLeft, ...props2 }) => props2
});
var animated = host.animated;
function instanceOfDebouncedFunc(func) {
  return "cancel" in func;
}
function useResizeObserver(callback, element, deps = [], options2 = {}) {
  const current = element && element.current;
  const observer = useRef(null);
  useLayoutEffect(() => {
    const { throttle: throttleTime } = options2;
    const observerCallback = throttleTime ? throttle$1(callback, throttleTime) : callback;
    observer.current = new ResizeObserver(observerCallback);
    if (current) {
      observer.current.observe(current);
    }
    return () => {
      if (observer && observer.current && current) {
        if (instanceOfDebouncedFunc(observerCallback)) {
          observerCallback.cancel();
        }
        observer.current.unobserve(current);
      }
    };
  }, [callback, current, options2, ...deps]);
}
function useCollapsibleAnimation(collapsed, {
  animate = true,
  duration = void 0,
  onRest,
  onStart,
  springConfig = void 0
} = {}) {
  const prefersReducedMotion = useReducedMotion();
  const ref2 = useRef(null);
  const [springStyles, api] = useSpring(() => ({
    height: "0px",
    opacity: 0,
    immediate: prefersReducedMotion || !animate
  }));
  useEffect(() => {
    api.start({
      height: `${collapsed || !(ref2 == null ? void 0 : ref2.current) ? 0 : ref2.current.offsetHeight}px`,
      immediate: prefersReducedMotion || !animate,
      opacity: collapsed ? 0 : 1,
      ...onStart && { onStart },
      ...onRest && { onRest },
      config: {
        ...springConfig,
        ...duration && { duration: duration({ collapsed }) }
      }
    });
  }, [api, collapsed, duration, springConfig]);
  useResizeObserver(
    () => {
      if (collapsed || !(ref2 == null ? void 0 : ref2.current)) {
        return;
      }
      api.start({
        height: `${ref2.current.offsetHeight}px`,
        immediate: prefersReducedMotion || !animate
      });
    },
    ref2,
    [collapsed],
    { throttle: Throttle.movement }
  );
  return [ref2, springStyles];
}
var Direction = /* @__PURE__ */ ((Direction2) => {
  Direction2["FORWARD"] = "FORWARD";
  Direction2["BACKWARD"] = "BACKWARD";
  return Direction2;
})(Direction || {});
var Orientation = /* @__PURE__ */ ((Orientation2) => {
  Orientation2["HORIZONTAL"] = "HORIZONTAL";
  Orientation2["VERTICAL"] = "VERTICAL";
  return Orientation2;
})(Orientation || {});
const getAllFocusableElements = (element) => {
  return Array.from(
    element == null ? void 0 : element.querySelectorAll("a[href], button")
  );
};
const getFocusedChildElement = (element) => {
  const focusableElements = getAllFocusableElements(element);
  if ((focusableElements == null ? void 0 : focusableElements.length) === 0) {
    return void 0;
  }
  return focusableElements.find(
    (node2) => node2.isEqualNode(document.activeElement)
  );
};
const focusNextItem = (element, event2, { direction, initiateFocus }) => {
  var _a2;
  const focusableElements = getAllFocusableElements(element);
  if (document.activeElement === element) {
    event2.preventDefault();
    focusableElements[0].focus();
    return;
  }
  const focusedElement = getFocusedChildElement(element);
  if (!initiateFocus && !focusedElement) {
    return;
  }
  const currentIndex = focusableElements.findIndex(
    (node2) => node2 === focusedElement
  );
  let nextIndex;
  if (direction === Direction.FORWARD) {
    nextIndex = focusableElements.length === currentIndex + 1 ? 0 : currentIndex + 1;
  } else {
    nextIndex = currentIndex === 0 || currentIndex === -1 ? focusableElements.length - 1 : currentIndex - 1;
  }
  event2.preventDefault();
  (_a2 = focusableElements == null ? void 0 : focusableElements[nextIndex]) == null ? void 0 : _a2.focus();
};
const focusFirstItem = (element, event2, { initiateFocus }) => {
  var _a2;
  const focusableElements = getAllFocusableElements(element);
  if ((focusableElements == null ? void 0 : focusableElements.length) === 0) {
    return void 0;
  }
  const focusedElement = getFocusedChildElement(element);
  if (!initiateFocus && !focusedElement && document.activeElement !== element) {
    return;
  }
  event2.preventDefault();
  (_a2 = focusableElements == null ? void 0 : focusableElements[0]) == null ? void 0 : _a2.focus();
};
const focusLastItem = (element, event2, { initiateFocus }) => {
  var _a2;
  const focusableElements = getAllFocusableElements(element);
  if ((focusableElements == null ? void 0 : focusableElements.length) === 0) {
    return void 0;
  }
  const focusedElement = getFocusedChildElement(element);
  if (!initiateFocus && !focusedElement && document.activeElement !== element) {
    return;
  }
  event2.preventDefault();
  (_a2 = focusableElements == null ? void 0 : focusableElements[focusableElements.length - 1]) == null ? void 0 : _a2.focus();
};
const clickFocusedItem = (element, event2) => {
  var _a2;
  const focusableElements = getAllFocusableElements(element);
  if ((focusableElements == null ? void 0 : focusableElements.length) === 0) {
    return void 0;
  }
  const focusedElement = getFocusedChildElement(element);
  if (!focusedElement && document.activeElement !== element) {
    return;
  }
  event2.preventDefault();
  (_a2 = document == null ? void 0 : document.activeElement) == null ? void 0 : _a2.click();
};
const useKeyboardNavigation = ({
  enabled = true,
  parentRef,
  orientation,
  initiateFocus = false
}) => {
  useEventListener("keydown", (event2) => {
    if (!enabled) {
      return;
    }
    const upArrowPressed = (event2 == null ? void 0 : event2.key) === "ArrowUp";
    const downArrowPressed = (event2 == null ? void 0 : event2.key) === "ArrowDown";
    const leftArrowPressed = (event2 == null ? void 0 : event2.key) === "ArrowLeft";
    const rightArrowPressed = (event2 == null ? void 0 : event2.key) === "ArrowRight";
    if (orientation === Orientation.VERTICAL && (leftArrowPressed || rightArrowPressed) || orientation === Orientation.HORIZONTAL && (upArrowPressed || downArrowPressed)) {
      return;
    }
    if (upArrowPressed || downArrowPressed || leftArrowPressed || rightArrowPressed) {
      focusNextItem(parentRef.current, event2, {
        direction: downArrowPressed || rightArrowPressed ? Direction.FORWARD : Direction.BACKWARD,
        initiateFocus
      });
    }
    if ((event2 == null ? void 0 : event2.key) === "Home") {
      focusFirstItem(parentRef.current, event2, { initiateFocus });
    }
    if ((event2 == null ? void 0 : event2.key) === "End") {
      focusLastItem(parentRef.current, event2, { initiateFocus });
    }
    if ((event2 == null ? void 0 : event2.key) === " ") {
      clickFocusedItem(parentRef.current, event2);
    }
  });
};
function useIsMounted() {
  const isMountedRef = useRef(false);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
}
const useNoInitialRenderEffect = (effect2, deps) => {
  const initialRender = useRef(true);
  useEffect(() => {
    let effectReturns = () => {
    };
    if (initialRender.current) {
      initialRender.current = false;
    } else {
      effectReturns = effect2();
    }
    if (effectReturns && typeof effectReturns === "function") {
      return effectReturns;
    }
  }, deps);
};
const useOnClickOutside$1 = (ref2, handler) => {
  useEffect(
    () => {
      if (!ref2 || !handler)
        return;
      const listener = (event2) => {
        if (!ref2.current || ref2.current.contains(event2.target)) {
          return;
        }
        handler(event2);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref2, handler]
  );
};
function usePreventBodyScroll(condition, deps = []) {
  useEffect(() => {
    if (condition) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, deps);
}
function usePrevious(value) {
  const ref2 = useRef(null);
  useEffect(() => {
    ref2.current = value;
  }, [value]);
  return ref2;
}
const dropdownFilter = (options2, value) => {
  return options2.filter(
    (op) => op.option.toUpperCase().includes(value.toUpperCase())
  );
};
const useTypeAhead = ({
  options: options2,
  onChange,
  onClick,
  onValueUpdate
}) => {
  const [showResults, setShowResults] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options2);
  const [selectValue, setAutoCompleteSelection] = useState({
    value: "",
    selectedFromAutoComplete: false
  });
  const { value, selectedFromAutoComplete } = selectValue;
  useEffect(() => {
    onValueUpdate && onValueUpdate(selectValue.value);
  }, [selectValue]);
  const handleInput = useEventCallback$1(
    (event2) => {
      setAutoCompleteSelection({
        value: event2.target.value,
        selectedFromAutoComplete: false
      });
    },
    onChange,
    []
  );
  const memoizedDropdownFilter = useCallback(() => {
    return dropdownFilter(options2, value);
  }, [options2, value]);
  useEffect(
    throttle$1(() => {
      if (value && !selectedFromAutoComplete) {
        const updatedFilteredOptions = memoizedDropdownFilter();
        setFilteredOptions(updatedFilteredOptions);
        setShowResults(updatedFilteredOptions.length > 0);
      } else {
        setFilteredOptions(options2);
        setShowResults(false);
      }
    }, Throttle.request),
    [value, selectedFromAutoComplete]
  );
  const handleSelection = useEventCallback$1(
    (e3) => {
      setShowResults(false);
      const target = e3.target;
      setAutoCompleteSelection({
        value: target.textContent || "",
        selectedFromAutoComplete: true
      });
    },
    onClick,
    options2
  );
  const handleClearSelection = useCallback(() => {
    setShowResults(false);
    setAutoCompleteSelection({ value: "", selectedFromAutoComplete: false });
  }, []);
  return [
    filteredOptions,
    value,
    showResults,
    handleSelection,
    handleInput,
    handleClearSelection
  ];
};
var DividerOrientation = /* @__PURE__ */ ((DividerOrientation2) => {
  DividerOrientation2["horizontal"] = "horizontal";
  DividerOrientation2["vertical"] = "vertical";
  return DividerOrientation2;
})(DividerOrientation || {});
const styles$n = {
  [
    "horizontal"
    /* horizontal */
  ]: {
    height: "divider.horizontal.height",
    width: "divider.horizontal.width"
  },
  // For vertical, the browser default height works perfectly in Flex use cases
  // For other use cases, like Grid, you may need to set the height explicitly to 100% or an exact pixel value via sx prop
  [
    "vertical"
    /* vertical */
  ]: {
    alignSelf: "stretch",
    width: "divider.vertical.width"
  }
};
const Divider$1 = ({
  orientation = "horizontal",
  variant: variant3 = DividerVariant.primary,
  sx: sx2 = void 0,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      "aria-orientation": orientation,
      role: "separator",
      sx: style2(styles$n[orientation]),
      variant: `divider.${variant3}`,
      ...restOfProps
    }
  );
};
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var FOCUS_GROUP = "data-focus-lock";
var FOCUS_DISABLED = "data-focus-lock-disabled";
var FOCUS_ALLOW = "data-no-focus-lock";
var FOCUS_AUTO = "data-autofocus-inside";
var FOCUS_NO_AUTOFOCUS = "data-no-autofocus";
function assignRef(ref2, value) {
  if (typeof ref2 === "function") {
    ref2(value);
  } else if (ref2) {
    ref2.current = value;
  }
  return ref2;
}
function useCallbackRef(initialValue2, callback) {
  var ref2 = useState(function() {
    return {
      // value
      value: initialValue2,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref2.value;
        },
        set current(value) {
          var last2 = ref2.value;
          if (last2 !== value) {
            ref2.value = value;
            ref2.callback(value, last2);
          }
        }
      }
    };
  })[0];
  ref2.callback = callback;
  return ref2.facade;
}
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref2) {
      return assignRef(ref2, newValue);
    });
  });
  useIsomorphicLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref2) {
        if (!nextRefs_1.has(ref2)) {
          assignRef(ref2, null);
        }
      });
      nextRefs_1.forEach(function(ref2) {
        if (!prevRefs_1.has(ref2)) {
          assignRef(ref2, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
var __assign$2 = function() {
  __assign$2 = Object.assign || function __assign2(t2) {
    for (var s4, i2 = 1, n = arguments.length; i2 < n; i2++) {
      s4 = arguments[i2];
      for (var p in s4)
        if (Object.prototype.hasOwnProperty.call(s4, p))
          t2[p] = s4[p];
    }
    return t2;
  };
  return __assign$2.apply(this, arguments);
};
typeof SuppressedError === "function" ? SuppressedError : function(error2, suppressed, message) {
  var e3 = new Error(message);
  return e3.name = "SuppressedError", e3.error = error2, e3.suppressed = suppressed, e3;
};
function ItoI(a4) {
  return a4;
}
function innerCreateMedium(defaults2, middleware2) {
  if (middleware2 === void 0) {
    middleware2 = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults2;
    },
    useMedium: function(data) {
      var item = middleware2(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x3) {
          return x3 !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x3) {
          return cb(x3);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x3) {
          pendingQueue.push(x3);
          cycle();
        },
        filter: function(filter2) {
          pendingQueue = pendingQueue.filter(filter2);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults2, middleware2) {
  if (middleware2 === void 0) {
    middleware2 = ItoI;
  }
  return innerCreateMedium(defaults2, middleware2);
}
function createSidecarMedium(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign$2({ async: true, ssr: false }, options2);
  return medium;
}
var mediumFocus = createMedium({}, function(_ref2) {
  var target = _ref2.target, currentTarget = _ref2.currentTarget;
  return {
    target,
    currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true,
  ssr: typeof document !== "undefined"
});
var focusScope = /* @__PURE__ */ createContext(void 0);
var emptyArray = [];
var FocusLock$1 = /* @__PURE__ */ React.forwardRef(function FocusLockUI(props2, parentRef) {
  var _extends2;
  var _React$useState = React.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
  var observed = React.useRef();
  var isActive = React.useRef(false);
  var originalFocusedElement = React.useRef(null);
  var _React$useState2 = React.useState({}), update2 = _React$useState2[1];
  var children2 = props2.children, _props$disabled = props2.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props2.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props2.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props2.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props2.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props2.allowTextSelection, group = props2.group, className = props2.className, whiteList = props2.whiteList, hasPositiveIndices = props2.hasPositiveIndices, _props$shards = props2.shards, shards = _props$shards === void 0 ? emptyArray : _props$shards, _props$as = props2.as, Container2 = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props2.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props2.sideCar, _props$returnFocus = props2.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props2.focusOptions, onActivationCallback = props2.onActivation, onDeactivationCallback = props2.onDeactivation;
  var _React$useState3 = React.useState({}), id = _React$useState3[0];
  var onActivation = React.useCallback(function(_ref2) {
    var captureFocusRestore2 = _ref2.captureFocusRestore;
    if (!originalFocusedElement.current) {
      var _document;
      var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
      originalFocusedElement.current = activeElement;
      if (activeElement !== document.body) {
        originalFocusedElement.current = captureFocusRestore2(activeElement);
      }
    }
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
    update2();
  }, [onActivationCallback]);
  var onDeactivation = React.useCallback(function() {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
    update2();
  }, [onDeactivationCallback]);
  var returnFocus = React.useCallback(function(allowDefer) {
    var focusRestore = originalFocusedElement.current;
    if (focusRestore) {
      var returnFocusTo = (typeof focusRestore === "function" ? focusRestore() : focusRestore) || document.body;
      var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : void 0;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function() {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus3 = React.useCallback(function(event2) {
    if (isActive.current) {
      mediumFocus.useMedium(event2);
    }
  }, []);
  var onBlur3 = mediumBlur.useMedium;
  var setObserveNode = React.useCallback(function(newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (process.env.NODE_ENV !== "production") {
    if (typeof allowTextSelection !== "undefined") {
      console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default");
    }
    React.useEffect(function() {
      if (!observed.current && typeof Container2 !== "string") {
        console.error("FocusLock: could not obtain ref to internal node");
      }
    }, []);
  }
  var lockProps = _extends$9((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && "disabled", _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  var focusScopeValue = React.useMemo(function() {
    return {
      observed,
      shards,
      enabled: !disabled,
      active: isActive.current
    };
  }, [disabled, isActive.current, shards, realObserved]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, hasLeadingGuards && [
    /* @__PURE__ */ React.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }),
    hasPositiveIndices ? /* @__PURE__ */ React.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !disabled && /* @__PURE__ */ React.createElement(SideCar, {
    id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled,
    persistentFocus,
    crossFrame,
    autoFocus,
    whiteList,
    shards,
    onActivation,
    onDeactivation,
    returnFocus,
    focusOptions
  }), /* @__PURE__ */ React.createElement(Container2, _extends$9({
    ref: mergedRef
  }, lockProps, {
    className,
    onBlur: onBlur3,
    onFocus: onFocus3
  }), /* @__PURE__ */ React.createElement(focusScope.Provider, {
    value: focusScopeValue
  }, children2)), hasTailingGuards && /* @__PURE__ */ React.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock$1.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
const FocusLockUI2 = FocusLock$1;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function withSideEffect(reducePropsToState2, handleStateChangeOnClient2) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState2 !== "function") {
      throw new Error("Expected reducePropsToState to be a function.");
    }
    if (typeof handleStateChangeOnClient2 !== "function") {
      throw new Error("Expected handleStateChangeOnClient to be a function.");
    }
  }
  function getDisplayName2(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }
  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== "function") {
        throw new Error("Expected WrappedComponent to be a React component.");
      }
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState2(mountedInstances.map(function(instance) {
        return instance.props;
      }));
      handleStateChangeOnClient2(state);
    }
    var SideEffect = /* @__PURE__ */ function(_PureComponent) {
      _inheritsLoose(SideEffect2, _PureComponent);
      function SideEffect2() {
        return _PureComponent.apply(this, arguments) || this;
      }
      SideEffect2.peek = function peek2() {
        return state;
      };
      var _proto = SideEffect2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index2 = mountedInstances.indexOf(this);
        mountedInstances.splice(index2, 1);
        emitChange();
      };
      _proto.render = function render() {
        return /* @__PURE__ */ React__default.createElement(WrappedComponent, this.props);
      };
      return SideEffect2;
    }(PureComponent);
    _defineProperty$2(SideEffect, "displayName", "SideEffect(" + getDisplayName2(WrappedComponent) + ")");
    return SideEffect;
  };
}
var toArray$3 = function(a4) {
  var ret = Array(a4.length);
  for (var i2 = 0; i2 < a4.length; ++i2) {
    ret[i2] = a4[i2];
  }
  return ret;
};
var asArray = function(a4) {
  return Array.isArray(a4) ? a4 : [a4];
};
var getFirst = function(a4) {
  return Array.isArray(a4) ? a4[0] : a4;
};
var isElementHidden = function(node2) {
  if (node2.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  var computedStyle = window.getComputedStyle(node2, null);
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var getParentNode = function(node2) {
  return node2.parentNode && node2.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    node2.parentNode.host
  ) : node2.parentNode;
};
var isTopNode = function(node2) {
  return node2 === document || node2 && node2.nodeType === Node.DOCUMENT_NODE;
};
var isInert = function(node2) {
  return node2.hasAttribute("inert");
};
var isVisibleUncached = function(node2, checkParent) {
  return !node2 || isTopNode(node2) || !isElementHidden(node2) && !isInert(node2) && checkParent(getParentNode(node2));
};
var isVisibleCached = function(visibilityCache, node2) {
  var cached = visibilityCache.get(node2);
  if (cached !== void 0) {
    return cached;
  }
  var result = isVisibleUncached(node2, isVisibleCached.bind(void 0, visibilityCache));
  visibilityCache.set(node2, result);
  return result;
};
var isAutoFocusAllowedUncached = function(node2, checkParent) {
  return node2 && !isTopNode(node2) ? isAutoFocusAllowed(node2) ? checkParent(getParentNode(node2)) : false : true;
};
var isAutoFocusAllowedCached = function(cache2, node2) {
  var cached = cache2.get(node2);
  if (cached !== void 0) {
    return cached;
  }
  var result = isAutoFocusAllowedUncached(node2, isAutoFocusAllowedCached.bind(void 0, cache2));
  cache2.set(node2, result);
  return result;
};
var getDataset = function(node2) {
  return node2.dataset;
};
var isHTMLButtonElement = function(node2) {
  return node2.tagName === "BUTTON";
};
var isHTMLInputElement = function(node2) {
  return node2.tagName === "INPUT";
};
var isRadioElement = function(node2) {
  return isHTMLInputElement(node2) && node2.type === "radio";
};
var notHiddenInput = function(node2) {
  return !((isHTMLInputElement(node2) || isHTMLButtonElement(node2)) && (node2.type === "hidden" || node2.disabled));
};
var isAutoFocusAllowed = function(node2) {
  var attribute = node2.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![true, "true", ""].includes(attribute);
};
var isGuard = function(node2) {
  var _a2;
  return Boolean(node2 && ((_a2 = getDataset(node2)) === null || _a2 === void 0 ? void 0 : _a2.focusGuard));
};
var isNotAGuard = function(node2) {
  return !isGuard(node2);
};
var isDefined = function(x3) {
  return Boolean(x3);
};
var tabSort = function(a4, b10) {
  var aTab = Math.max(0, a4.tabIndex);
  var bTab = Math.max(0, b10.tabIndex);
  var tabDiff = aTab - bTab;
  var indexDiff = a4.index - b10.index;
  if (tabDiff) {
    if (!aTab) {
      return 1;
    }
    if (!bTab) {
      return -1;
    }
  }
  return tabDiff || indexDiff;
};
var getTabIndex = function(node2) {
  if (node2.tabIndex < 0) {
    if (!node2.hasAttribute("tabindex")) {
      return 0;
    }
  }
  return node2.tabIndex;
};
var orderByTabIndex = function(nodes, filterNegative, keepGuards) {
  return toArray$3(nodes).map(function(node2, index2) {
    var tabIndex = getTabIndex(node2);
    return {
      node: node2,
      index: index2,
      tabIndex: keepGuards && tabIndex === -1 ? (node2.dataset || {}).focusGuard ? 0 : -1 : tabIndex
    };
  }).filter(function(data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};
var tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
];
var queryTabbables = tabbables.join(",");
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function(parent2, withGuards) {
  return toArray$3((parent2.shadowRoot || parent2).children).reduce(function(acc, child) {
    return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
  }, []);
};
var getFocusablesWithIFrame = function(parent2, withGuards) {
  var _a2;
  if (parent2 instanceof HTMLIFrameElement && ((_a2 = parent2.contentDocument) === null || _a2 === void 0 ? void 0 : _a2.body)) {
    return getFocusables([parent2.contentDocument.body], withGuards);
  }
  return [parent2];
};
var getFocusables = function(parents, withGuards) {
  return parents.reduce(function(acc, parent2) {
    var _a2;
    var focusableWithShadowDom = getFocusablesWithShadowDom(parent2, withGuards);
    var focusableWithIframes = (_a2 = []).concat.apply(_a2, focusableWithShadowDom.map(function(node2) {
      return getFocusablesWithIFrame(node2, withGuards);
    }));
    return acc.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      focusableWithIframes,
      // add if node is tabbable itself
      parent2.parentNode ? toArray$3(parent2.parentNode.querySelectorAll(queryTabbables)).filter(function(node2) {
        return node2 === parent2;
      }) : []
    );
  }, []);
};
var getParentAutofocusables = function(parent2) {
  var parentFocus = parent2.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray$3(parentFocus).map(function(node2) {
    return getFocusables([node2]);
  }).reduce(function(acc, nodes) {
    return acc.concat(nodes);
  }, []);
};
var filterFocusable = function(nodes, visibilityCache) {
  return toArray$3(nodes).filter(function(node2) {
    return isVisibleCached(visibilityCache, node2);
  }).filter(function(node2) {
    return notHiddenInput(node2);
  });
};
var filterAutoFocusable = function(nodes, cache2) {
  if (cache2 === void 0) {
    cache2 = /* @__PURE__ */ new Map();
  }
  return toArray$3(nodes).filter(function(node2) {
    return isAutoFocusAllowedCached(cache2, node2);
  });
};
var getTabbableNodes = function(topNodes, visibilityCache, withGuards) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
var getFocusableNodes = function(topNodes, visibilityCache) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
var parentAutofocusables = function(topNode, visibilityCache) {
  return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
var contains = function(scope, element) {
  if (scope.shadowRoot) {
    return contains(scope.shadowRoot, element);
  } else {
    if (Object.getPrototypeOf(scope).contains !== void 0 && Object.getPrototypeOf(scope).contains.call(scope, element)) {
      return true;
    }
    return toArray$3(scope.children).some(function(child) {
      var _a2;
      if (child instanceof HTMLIFrameElement) {
        var iframeBody = (_a2 = child.contentDocument) === null || _a2 === void 0 ? void 0 : _a2.body;
        if (iframeBody) {
          return contains(iframeBody, element);
        }
        return false;
      }
      return contains(child, element);
    });
  }
};
var filterNested = function(nodes) {
  var contained = /* @__PURE__ */ new Set();
  var l = nodes.length;
  for (var i2 = 0; i2 < l; i2 += 1) {
    for (var j = i2 + 1; j < l; j += 1) {
      var position2 = nodes[i2].compareDocumentPosition(nodes[j]);
      if ((position2 & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
        contained.add(j);
      }
      if ((position2 & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
        contained.add(i2);
      }
    }
  }
  return nodes.filter(function(_, index2) {
    return !contained.has(index2);
  });
};
var getTopParent = function(node2) {
  return node2.parentNode ? getTopParent(node2.parentNode) : node2;
};
var getAllAffectedNodes = function(node2) {
  var nodes = asArray(node2);
  return nodes.filter(Boolean).reduce(function(acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray$3(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(group, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [currentNode]);
    return acc;
  }, []);
};
var safeProbe = function(cb) {
  try {
    return cb();
  } catch (e3) {
    return void 0;
  }
};
var getActiveElement = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  if (!inDocument || !inDocument.activeElement) {
    return void 0;
  }
  var activeElement = inDocument.activeElement;
  return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && safeProbe(function() {
    return activeElement.contentWindow.document;
  }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
};
var focusInFrame = function(frame2, activeElement) {
  return frame2 === activeElement;
};
var focusInsideIframe = function(topNode, activeElement) {
  return Boolean(toArray$3(topNode.querySelectorAll("iframe")).some(function(node2) {
    return focusInFrame(node2, activeElement);
  }));
};
var focusInside = function(topNode, activeElement) {
  if (activeElement === void 0) {
    activeElement = getActiveElement(getFirst(topNode).ownerDocument);
  }
  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).some(function(node2) {
    return contains(node2, activeElement) || focusInsideIframe(node2, activeElement);
  });
};
var focusIsHidden = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  var activeElement = getActiveElement(inDocument);
  if (!activeElement) {
    return false;
  }
  return toArray$3(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(node2) {
    return contains(node2, activeElement);
  });
};
var findSelectedRadio = function(node2, nodes) {
  return nodes.filter(isRadioElement).filter(function(el) {
    return el.name === node2.name;
  }).filter(function(el) {
    return el.checked;
  })[0] || node2;
};
var correctNode = function(node2, nodes) {
  if (isRadioElement(node2) && node2.name) {
    return findSelectedRadio(node2, nodes);
  }
  return node2;
};
var correctNodes = function(nodes) {
  var resultSet = /* @__PURE__ */ new Set();
  nodes.forEach(function(node2) {
    return resultSet.add(correctNode(node2, nodes));
  });
  return nodes.filter(function(node2) {
    return resultSet.has(node2);
  });
};
var pickFirstFocus = function(nodes) {
  if (nodes[0] && nodes.length > 1) {
    return correctNode(nodes[0], nodes);
  }
  return nodes[0];
};
var pickFocusable = function(nodes, node2) {
  return nodes.indexOf(correctNode(node2, nodes));
};
var NEW_FOCUS = "NEW_FOCUS";
var newFocus = function(innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);
  if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
    return void 0;
  }
  var activeIndex = activeElement !== void 0 ? outerNodes.indexOf(activeElement) : -1;
  var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
  var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
  if (activeIndex === -1) {
    if (lastNodeInside !== -1) {
      return lastNodeInside;
    }
    return NEW_FOCUS;
  }
  if (lastNodeInside === -1) {
    return NEW_FOCUS;
  }
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);
  var correctedNodes = correctNodes(outerNodes);
  var correctedIndex = activeElement !== void 0 ? correctedNodes.indexOf(activeElement) : -1;
  var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  if (innerTabbables.length === 0) {
    return lastNodeInside;
  }
  var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
  var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
    return lastNodeInside;
  }
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  return void 0;
};
var findAutoFocused = function(autoFocusables) {
  return function(node2) {
    var _a2;
    var autofocus = (_a2 = getDataset(node2)) === null || _a2 === void 0 ? void 0 : _a2.autofocus;
    return (
      // @ts-expect-error
      node2.autofocus || //
      autofocus !== void 0 && autofocus !== "false" || //
      autoFocusables.indexOf(node2) >= 0
    );
  };
};
var pickAutofocus = function(nodesIndexes, orderedNodes, groups) {
  var nodes = nodesIndexes.map(function(_a2) {
    var node2 = _a2.node;
    return node2;
  });
  var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
  if (autoFocusable && autoFocusable.length) {
    return pickFirstFocus(autoFocusable);
  }
  return pickFirstFocus(filterAutoFocusable(orderedNodes));
};
var getParents = function(node2, parents) {
  if (parents === void 0) {
    parents = [];
  }
  parents.push(node2);
  if (node2.parentNode) {
    getParents(node2.parentNode.host || node2.parentNode, parents);
  }
  return parents;
};
var getCommonParent = function(nodeA, nodeB) {
  var parentsA = getParents(nodeA);
  var parentsB = getParents(nodeB);
  for (var i2 = 0; i2 < parentsA.length; i2 += 1) {
    var currentParent = parentsA[i2];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};
var getTopCommonParent = function(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = false;
  leftEntries.filter(Boolean).forEach(function(entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function(subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || contains(common, topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};
var allParentAutofocusables = function(entries6, visibilityCache) {
  return entries6.reduce(function(acc, node2) {
    return acc.concat(parentAutofocusables(node2, visibilityCache));
  }, []);
};
var reorderNodes = function(srcNodes, dstNodes) {
  var remap = /* @__PURE__ */ new Map();
  dstNodes.forEach(function(entity) {
    return remap.set(entity.node, entity);
  });
  return srcNodes.map(function(node2) {
    return remap.get(node2);
  }).filter(isDefined);
};
var focusSolver = function(topNode, lastNode) {
  var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
  var entries6 = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries6);
  var visibilityCache = /* @__PURE__ */ new Map();
  var anyFocusable = getFocusableNodes(entries6, visibilityCache);
  var innerElements = anyFocusable.filter(function(_a2) {
    var node2 = _a2.node;
    return isNotAGuard(node2);
  });
  if (!innerElements[0]) {
    return void 0;
  }
  var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function(_a2) {
    var node2 = _a2.node;
    return node2;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerFocusables = orderedInnerElements.map(function(_a2) {
    var node2 = _a2.node;
    return node2;
  });
  var innerTabbable = orderedInnerElements.filter(function(_a2) {
    var tabIndex = _a2.tabIndex;
    return tabIndex >= 0;
  }).map(function(_a2) {
    var node2 = _a2.node;
    return node2;
  });
  var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
  if (newId === NEW_FOCUS) {
    var focusNode = (
      // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
      pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries6, visibilityCache)) || pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries6, visibilityCache))
    );
    if (focusNode) {
      return { node: focusNode };
    } else {
      console.warn("focus-lock: cannot find any node to move focus into");
      return void 0;
    }
  }
  if (newId === void 0) {
    return newId;
  }
  return orderedInnerElements[newId];
};
var expandFocusableNodes = function(topNode) {
  var entries6 = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries6);
  var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
  var innerElements = getFocusables(entries6, false);
  return outerNodes.map(function(_a2) {
    var node2 = _a2.node, index2 = _a2.index;
    return {
      node: node2,
      index: index2,
      lockItem: innerElements.indexOf(node2) >= 0,
      guard: isGuard(node2)
    };
  });
};
var focusOn = function(target, focusOptions) {
  if (!target) {
    return;
  }
  if ("focus" in target) {
    target.focus(focusOptions);
  }
  if ("contentWindow" in target && target.contentWindow) {
    target.contentWindow.focus();
  }
};
var guardCount = 0;
var lockDisabled = false;
var moveFocusInside = function(topNode, lastNode, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var focusable = focusSolver(topNode, lastNode);
  if (lockDisabled) {
    return;
  }
  if (focusable) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
      lockDisabled = true;
      setTimeout(function() {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node, options2.focusOptions);
    guardCount--;
  }
};
function weakRef(value) {
  if (!value)
    return null;
  if (typeof WeakRef === "undefined") {
    return function() {
      return value || null;
    };
  }
  var w2 = value ? new WeakRef(value) : null;
  return function() {
    return (w2 === null || w2 === void 0 ? void 0 : w2.deref()) || null;
  };
}
var recordElementLocation = function(element) {
  if (!element) {
    return null;
  }
  var stack2 = [];
  var currentElement = element;
  while (currentElement && currentElement !== document.body) {
    stack2.push({
      current: weakRef(currentElement),
      parent: weakRef(currentElement.parentElement),
      left: weakRef(currentElement.previousElementSibling),
      right: weakRef(currentElement.nextElementSibling)
    });
    currentElement = currentElement.parentElement;
  }
  return {
    element: weakRef(element),
    stack: stack2,
    ownerDocument: element.ownerDocument
  };
};
var restoreFocusTo = function(location) {
  var _a2, _b, _c, _d, _e;
  if (!location) {
    return void 0;
  }
  var stack2 = location.stack, ownerDocument = location.ownerDocument;
  var visibilityCache = /* @__PURE__ */ new Map();
  for (var _i = 0, stack_1 = stack2; _i < stack_1.length; _i++) {
    var line2 = stack_1[_i];
    var parent_1 = (_a2 = line2.parent) === null || _a2 === void 0 ? void 0 : _a2.call(line2);
    if (parent_1 && ownerDocument.contains(parent_1)) {
      var left2 = (_b = line2.left) === null || _b === void 0 ? void 0 : _b.call(line2);
      var savedCurrent = line2.current();
      var current = parent_1.contains(savedCurrent) ? savedCurrent : void 0;
      var right2 = (_c = line2.right) === null || _c === void 0 ? void 0 : _c.call(line2);
      var focusables = getTabbableNodes([parent_1], visibilityCache);
      var aim = (
        // that is element itself
        (_e = (_d = current !== null && current !== void 0 ? current : (
          // or something in it's place
          left2 === null || left2 === void 0 ? void 0 : left2.nextElementSibling
        )) !== null && _d !== void 0 ? _d : (
          // or somebody to the right, still close enough
          right2
        )) !== null && _e !== void 0 ? _e : (
          // or somebody to the left, something?
          left2
        )
      );
      while (aim) {
        for (var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++) {
          var focusable = focusables_1[_f];
          if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) {
            return focusable.node;
          }
        }
        aim = aim.nextElementSibling;
      }
      if (focusables.length) {
        return focusables[0].node;
      }
    }
  }
  return void 0;
};
var captureFocusRestore = function(targetElement) {
  var location = recordElementLocation(targetElement);
  return function() {
    return restoreFocusTo(location);
  };
};
var getRelativeFocusable = function(element, scope, useTabbables) {
  if (!element || !scope) {
    console.error("no element or scope given");
    return {};
  }
  var shards = asArray(scope);
  if (shards.every(function(shard) {
    return !contains(shard, element);
  })) {
    console.error("Active element is not contained in the scope");
    return {};
  }
  var focusables = useTabbables ? getTabbableNodes(shards, /* @__PURE__ */ new Map()) : getFocusableNodes(shards, /* @__PURE__ */ new Map());
  var current = focusables.findIndex(function(_a2) {
    var node2 = _a2.node;
    return node2 === element;
  });
  if (current === -1) {
    return void 0;
  }
  return {
    prev: focusables[current - 1],
    next: focusables[current + 1],
    first: focusables[0],
    last: focusables[focusables.length - 1]
  };
};
var getBoundary = function(shards, useTabbables) {
  var set = useTabbables ? getTabbableNodes(asArray(shards), /* @__PURE__ */ new Map()) : getFocusableNodes(asArray(shards), /* @__PURE__ */ new Map());
  return {
    first: set[0],
    last: set[set.length - 1]
  };
};
var defaultOptions$1 = function(options2) {
  return Object.assign({
    scope: document.body,
    cycle: true,
    onlyTabbable: true
  }, options2);
};
var moveFocus = function(fromElement, options2, cb) {
  if (options2 === void 0) {
    options2 = {};
  }
  var newOptions = defaultOptions$1(options2);
  var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
  if (!solution) {
    return;
  }
  var target = cb(solution, newOptions.cycle);
  if (target) {
    focusOn(target.node, newOptions.focusOptions);
  }
};
var focusNextElement = function(fromElement, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  moveFocus(fromElement, options2, function(_a2, cycle) {
    var next2 = _a2.next, first = _a2.first;
    return next2 || cycle && first;
  });
};
var focusPrevElement = function(fromElement, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  moveFocus(fromElement, options2, function(_a2, cycle) {
    var prev2 = _a2.prev, last2 = _a2.last;
    return prev2 || cycle && last2;
  });
};
var pickBoundary = function(scope, options2, what) {
  var _a2;
  var boundary = getBoundary(scope, (_a2 = options2.onlyTabbable) !== null && _a2 !== void 0 ? _a2 : true);
  var node2 = boundary[what];
  if (node2) {
    focusOn(node2.node, options2.focusOptions);
  }
};
var focusFirstElement = function(scope, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  pickBoundary(scope, options2, "first");
};
var focusLastElement = function(scope, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  pickBoundary(scope, options2, "last");
};
function deferAction(action2) {
  setTimeout(action2, 1);
}
var extractRef = function extractRef2(ref2) {
  return ref2 && "current" in ref2 ? ref2.current : ref2;
};
var focusOnBody = function focusOnBody2() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus2() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist2() {
  return true;
};
var focusWhitelisted = function focusWhitelisted2(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal2(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode,
    portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair2(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end2, step2, allNodes) {
  var lastGuard = null;
  var i2 = startIndex;
  do {
    var item = allNodes[i2];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i2 !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i2 += step2) !== end2);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var focusWasOutside = function focusWasOutside2(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === "meanwhile";
};
var checkInHost = function checkInHost2(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost2(check, el.parentNode, boundary));
};
var withinHost = function withinHost2(activeElement, workingArea) {
  return workingArea.some(function(area2) {
    return checkInHost(activeElement, area2, area2);
  });
};
var activateTrap = function activateTrap2() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions
              });
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document && activeElement !== document.activeElement && document.querySelector("[data-focus-auto-guard]")) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function(_ref2) {
          var node2 = _ref2.node;
          return node2;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function(_ref2) {
            var guard = _ref2.guard, node2 = _ref2.node;
            return guard && node2.dataset.focusAutoGuard;
          }).forEach(function(_ref3) {
            var node2 = _ref3.node;
            return node2.removeAttribute("tabIndex");
          });
          autoGuard(focusedIndex, allNodes.length, 1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap2(event2) {
  if (activateTrap() && event2) {
    event2.stopPropagation();
    event2.preventDefault();
  }
};
var onBlur = function onBlur2() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus2(event2) {
  var source = event2.target;
  var currentNode = event2.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher2() {
  return null;
};
process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};
var onWindowBlur = function onWindowBlur2() {
  focusWasOutsideWindow = "just";
  deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
};
var attachHandler = function attachHandler2() {
  document.addEventListener("focusin", onTrap);
  document.addEventListener("focusout", onBlur);
  window.addEventListener("blur", onWindowBlur);
};
var detachHandler = function detachHandler2() {
  document.removeEventListener("focusin", onTrap);
  document.removeEventListener("focusout", onBlur);
  window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function(_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
var focusLockAPI = {
  moveFocusInside,
  focusInside,
  focusNextElement,
  focusPrevElement,
  focusFirstElement,
  focusLastElement,
  captureFocusRestore
};
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function(_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation(focusLockAPI);
    }
    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(cb) {
  return cb(focusLockAPI);
});
const FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);
var FocusLockCombination = /* @__PURE__ */ React.forwardRef(function FocusLockUICombination(props2, ref2) {
  return /* @__PURE__ */ React.createElement(FocusLockUI2, _extends$9({
    sideCar: FocusTrap,
    ref: ref2
  }, props2));
});
var _ref = FocusLockUI2.propTypes || {};
_ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose$1(_ref, ["sideCar"]);
FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
const FocusLock = FocusLockCombination;
const WrappedFocusLock = ({ sx: sx2 = {}, ...restOfProps }) => /* @__PURE__ */ jsx2(FocusLock, { sx: sx2, ...restOfProps });
const GridItem = ({
  alignSelf,
  gridArea,
  gridColumn,
  gridColumnEnd,
  gridColumnStart,
  gridRow,
  gridRowEnd,
  gridRowStart,
  justifySelf,
  placeSelf,
  sx: sx2,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        alignSelf,
        gridArea,
        gridColumn,
        gridColumnEnd,
        gridColumnStart,
        gridRow,
        gridRowEnd,
        gridRowStart,
        justifySelf,
        placeSelf,
        ...sx2
      },
      ...restOfProps
    }
  );
};
const GridContainer = ({
  alignContent,
  alignItems,
  children: children2,
  columnGap,
  display = "grid",
  gap,
  grid: grid2,
  gridAutoColumns,
  gridAutoFlow,
  gridAutoRows,
  gridTemplate,
  gridTemplateAreas,
  gridTemplateColumns,
  gridTemplateRows,
  justifyContent: justifyContent2,
  justifyItems,
  placeContent,
  placeItems,
  rowGap,
  sx: sx2,
  variant: variant3 = GridVariants.unstyled,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        alignContent,
        alignItems,
        columnGap,
        display,
        gap,
        grid: grid2,
        gridAutoColumns,
        gridAutoFlow,
        gridAutoRows,
        gridTemplate,
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows,
        justifyContent: justifyContent2,
        justifyItems,
        placeContent,
        placeItems,
        rowGap,
        ...sx2
      },
      variant: `grid.${variant3}`,
      ...restOfProps,
      children: children2
    }
  );
};
const GRID_ITEM_PROP_NAMES = [
  "alignSelf",
  "gridArea",
  "gridColumn",
  "gridColumnEnd",
  "gridColumnStart",
  "gridRow",
  "gridRowEnd",
  "gridRowStart",
  "justifySelf",
  "placeSelf"
];
const GRID_CONTAINER_PROP_NAMES = [
  "alignContent",
  "alignItems",
  "columnGap",
  "display",
  "gap",
  "grid",
  "gridAutoColumns",
  "gridAutoFlow",
  "gridAutoRows",
  "gridTemplate",
  "gridTemplateAreas",
  "gridTemplateColumns",
  "gridTemplateRows",
  "justifyContent",
  "justifyItems",
  "placeContent",
  "placeItems",
  "rowGap"
];
const Grid = ({ sx: sx2 = {}, ...restOfProps }) => {
  const gridItemProps = pick$2(
    restOfProps,
    GRID_ITEM_PROP_NAMES
  );
  const gridContainerProps = pick$2(
    restOfProps,
    GRID_CONTAINER_PROP_NAMES
  );
  const props2 = omit$1(
    restOfProps,
    GRID_ITEM_PROP_NAMES,
    GRID_CONTAINER_PROP_NAMES
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ...gridItemProps, ...gridContainerProps, ...sx2 }, ...props2 });
};
Grid.Container = GridContainer;
Grid.Item = GridItem;
const Overlay = ({
  onClick = void 0,
  variant: variant3 = OverlayVariant.default,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      "data-test-id": "overlay",
      onClick,
      variant: `overlay.${variant3}`,
      ...props2
    }
  );
};
const clamp$1 = (value, minimum, maximum) => {
  return Math.min(Math.max(value, minimum), maximum);
};
const ProgressBar = ({
  percentage = 0,
  accessibilityDescription = void 0,
  sx: sx2 = {},
  filledProgressSx = {},
  backgroundColor = void 0,
  filledBackgroundColor = void 0
}) => {
  const [labelId] = useState(() => uniqueId$1("loadinglabel-"));
  const displayPercentage = clamp$1(percentage, 0, 100);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      "aria-labelledby": labelId,
      "aria-valuenow": displayPercentage,
      role: "progressbar",
      sx: {
        borderRadius: "progressBar.default",
        backgroundColor: backgroundColor ?? "progressBar.trackBackground",
        height: "progressBar.height",
        ...sx2
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          "data-test-id": "progress-bar-indicator",
          sx: {
            borderRadius: "progressBar.default",
            backgroundColor: filledBackgroundColor ?? "progressBar.indicatorBackground",
            height: "progressBar.height",
            maxWidth: "100%",
            width: `${displayPercentage}%`,
            transition: "progressBar.indicator",
            ...filledProgressSx
          },
          children: accessibilityDescription ? /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, { "data-test-id": "a11y-description", id: labelId, children: accessibilityDescription }) : null
        }
      )
    }
  );
};
const SkeletonContent = ({
  sx: sx2 = {},
  variant: variant3 = SkeletonContentVariants.default,
  ...restOfProps
}) => {
  if (variant3 === SkeletonContentVariants.default) {
    Object.assign(sx2, skeletonContentAnimation);
  } else if (variant3 === SkeletonContentVariants.rainbow) {
    Object.assign(sx2, skeletonContentRainbowAnimation);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: sx2, variant: `skeletonContent.${variant3}`, ...restOfProps });
};
const COLUMN_COUNT = 24;
const StackItem = ({
  children: children2 = null,
  as = "div",
  size,
  order: order2 = void 0,
  justifySelf = void 0,
  alignSelf = void 0,
  sx: sx2 = {},
  ...restOfProps
}) => {
  const finalSize = useResponsiveMedia(size);
  const width = useMemo(() => {
    if (finalSize === "auto") {
      return void 0;
    }
    if (finalSize === "fill") {
      return "100%";
    }
    if (finalSize === "fit-content") {
      return "fit-content";
    }
    return `${finalSize / COLUMN_COUNT * 100}%`;
  }, [finalSize]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      as,
      sx: {
        width,
        order: order2,
        justifySelf,
        alignSelf,
        ...sx2
      },
      ...restOfProps,
      children: children2
    }
  );
};
const Submit = ({
  label: label2 = "Submit",
  isLoading,
  dataTestId,
  ...restOfProps
}) => {
  const guiForm = useGuiForm();
  const { isSubmitting } = guiForm || {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "data-test-id": dataTestId,
      isLoading: isLoading !== void 0 ? isLoading : isSubmitting,
      ...restOfProps,
      type: "submit",
      children: label2
    }
  );
};
function clamp(v, min2, max2) {
  return Math.max(min2, Math.min(v, max2));
}
const V = {
  toVector(v, fallback) {
    if (v === void 0)
      v = fallback;
    return Array.isArray(v) ? v : [v, v];
  },
  add(v1, v2) {
    return [v1[0] + v2[0], v1[1] + v2[1]];
  },
  sub(v1, v2) {
    return [v1[0] - v2[0], v1[1] - v2[1]];
  },
  addTo(v1, v2) {
    v1[0] += v2[0];
    v1[1] += v2[1];
  },
  subTo(v1, v2) {
    v1[0] -= v2[0];
    v1[1] -= v2[1];
  }
};
function rubberband(distance, dimension, constant2) {
  if (dimension === 0 || Math.abs(dimension) === Infinity)
    return Math.pow(distance, constant2 * 5);
  return distance * dimension * constant2 / (dimension + constant2 * distance);
}
function rubberbandIfOutOfBounds(position2, min2, max2, constant2 = 0.15) {
  if (constant2 === 0)
    return clamp(position2, min2, max2);
  if (position2 < min2)
    return -rubberband(min2 - position2, max2 - min2, constant2) + min2;
  if (position2 > max2)
    return +rubberband(position2 - max2, max2 - min2, constant2) + max2;
  return position2;
}
function computeRubberband(bounds, [Vx, Vy], [Rx, Ry]) {
  const [[X0, X1], [Y0, Y1]] = bounds;
  return [rubberbandIfOutOfBounds(Vx, X0, X1, Rx), rubberbandIfOutOfBounds(Vy, Y0, Y1, Ry)];
}
function _toPrimitive(input2, hint) {
  if (typeof input2 !== "object" || input2 === null)
    return input2;
  var prim = input2[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input2, hint || "default");
    if (typeof res !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input2);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function ownKeys(e3, r) {
  var t2 = Object.keys(e3);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e3);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e3, r2).enumerable;
    })), t2.push.apply(t2, o);
  }
  return t2;
}
function _objectSpread2(e3) {
  for (var r = 1; r < arguments.length; r++) {
    var t2 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t2), true).forEach(function(r2) {
      _defineProperty$1(e3, r2, t2[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e3, Object.getOwnPropertyDescriptors(t2)) : ownKeys(Object(t2)).forEach(function(r2) {
      Object.defineProperty(e3, r2, Object.getOwnPropertyDescriptor(t2, r2));
    });
  }
  return e3;
}
const EVENT_TYPE_MAP = {
  pointer: {
    start: "down",
    change: "move",
    end: "up"
  },
  mouse: {
    start: "down",
    change: "move",
    end: "up"
  },
  touch: {
    start: "start",
    change: "move",
    end: "end"
  },
  gesture: {
    start: "start",
    change: "change",
    end: "end"
  }
};
function capitalize(string2) {
  if (!string2)
    return "";
  return string2[0].toUpperCase() + string2.slice(1);
}
const actionsWithoutCaptureSupported = ["enter", "leave"];
function hasCapture(capture = false, actionKey) {
  return capture && !actionsWithoutCaptureSupported.includes(actionKey);
}
function toHandlerProp(device, action2 = "", capture = false) {
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action2] || action2 : action2;
  return "on" + capitalize(device) + capitalize(actionKey) + (hasCapture(capture, actionKey) ? "Capture" : "");
}
const pointerCaptureEvents = ["gotpointercapture", "lostpointercapture"];
function parseProp(prop) {
  let eventKey = prop.substring(2).toLowerCase();
  const passive2 = !!~eventKey.indexOf("passive");
  if (passive2)
    eventKey = eventKey.replace("passive", "");
  const captureKey = pointerCaptureEvents.includes(eventKey) ? "capturecapture" : "capture";
  const capture = !!~eventKey.indexOf(captureKey);
  if (capture)
    eventKey = eventKey.replace("capture", "");
  return {
    device: eventKey,
    capture,
    passive: passive2
  };
}
function toDomEventType(device, action2 = "") {
  const deviceProps = EVENT_TYPE_MAP[device];
  const actionKey = deviceProps ? deviceProps[action2] || action2 : action2;
  return device + actionKey;
}
function isTouch(event2) {
  return "touches" in event2;
}
function getPointerType(event2) {
  if (isTouch(event2))
    return "touch";
  if ("pointerType" in event2)
    return event2.pointerType;
  return "mouse";
}
function getCurrentTargetTouchList(event2) {
  return Array.from(event2.touches).filter((e3) => {
    var _event$currentTarget, _event$currentTarget$;
    return e3.target === event2.currentTarget || ((_event$currentTarget = event2.currentTarget) === null || _event$currentTarget === void 0 || (_event$currentTarget$ = _event$currentTarget.contains) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.call(_event$currentTarget, e3.target));
  });
}
function getTouchList(event2) {
  return event2.type === "touchend" || event2.type === "touchcancel" ? event2.changedTouches : event2.targetTouches;
}
function getValueEvent(event2) {
  return isTouch(event2) ? getTouchList(event2)[0] : event2;
}
function touchIds(event2) {
  return getCurrentTargetTouchList(event2).map((touch) => touch.identifier);
}
function pointerId(event2) {
  const valueEvent = getValueEvent(event2);
  return isTouch(event2) ? valueEvent.identifier : valueEvent.pointerId;
}
function pointerValues(event2) {
  const valueEvent = getValueEvent(event2);
  return [valueEvent.clientX, valueEvent.clientY];
}
function getEventDetails(event2) {
  const payload = {};
  if ("buttons" in event2)
    payload.buttons = event2.buttons;
  if ("shiftKey" in event2) {
    const {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    } = event2;
    Object.assign(payload, {
      shiftKey,
      altKey,
      metaKey,
      ctrlKey
    });
  }
  return payload;
}
function call(v, ...args) {
  if (typeof v === "function") {
    return v(...args);
  } else {
    return v;
  }
}
function noop$4() {
}
function chain(...fns) {
  if (fns.length === 0)
    return noop$4;
  if (fns.length === 1)
    return fns[0];
  return function() {
    let result;
    for (const fn2 of fns) {
      result = fn2.apply(this, arguments) || result;
    }
    return result;
  };
}
function assignDefault(value, fallback) {
  return Object.assign({}, fallback, value || {});
}
const BEFORE_LAST_KINEMATICS_DELAY = 32;
class Engine {
  constructor(ctrl, args, key) {
    this.ctrl = ctrl;
    this.args = args;
    this.key = key;
    if (!this.state) {
      this.state = {};
      this.computeValues([0, 0]);
      this.computeInitial();
      if (this.init)
        this.init();
      this.reset();
    }
  }
  get state() {
    return this.ctrl.state[this.key];
  }
  set state(state) {
    this.ctrl.state[this.key] = state;
  }
  get shared() {
    return this.ctrl.state.shared;
  }
  get eventStore() {
    return this.ctrl.gestureEventStores[this.key];
  }
  get timeoutStore() {
    return this.ctrl.gestureTimeoutStores[this.key];
  }
  get config() {
    return this.ctrl.config[this.key];
  }
  get sharedConfig() {
    return this.ctrl.config.shared;
  }
  get handler() {
    return this.ctrl.handlers[this.key];
  }
  reset() {
    const {
      state,
      shared,
      ingKey,
      args
    } = this;
    shared[ingKey] = state._active = state.active = state._blocked = state._force = false;
    state._step = [false, false];
    state.intentional = false;
    state._movement = [0, 0];
    state._distance = [0, 0];
    state._direction = [0, 0];
    state._delta = [0, 0];
    state._bounds = [[-Infinity, Infinity], [-Infinity, Infinity]];
    state.args = args;
    state.axis = void 0;
    state.memo = void 0;
    state.elapsedTime = state.timeDelta = 0;
    state.direction = [0, 0];
    state.distance = [0, 0];
    state.overflow = [0, 0];
    state._movementBound = [false, false];
    state.velocity = [0, 0];
    state.movement = [0, 0];
    state.delta = [0, 0];
    state.timeStamp = 0;
  }
  start(event2) {
    const state = this.state;
    const config2 = this.config;
    if (!state._active) {
      this.reset();
      this.computeInitial();
      state._active = true;
      state.target = event2.target;
      state.currentTarget = event2.currentTarget;
      state.lastOffset = config2.from ? call(config2.from, state) : state.offset;
      state.offset = state.lastOffset;
      state.startTime = state.timeStamp = event2.timeStamp;
    }
  }
  computeValues(values6) {
    const state = this.state;
    state._values = values6;
    state.values = this.config.transform(values6);
  }
  computeInitial() {
    const state = this.state;
    state._initial = state._values;
    state.initial = state.values;
  }
  compute(event2) {
    const {
      state,
      config: config2,
      shared
    } = this;
    state.args = this.args;
    let dt = 0;
    if (event2) {
      state.event = event2;
      if (config2.preventDefault && event2.cancelable)
        state.event.preventDefault();
      state.type = event2.type;
      shared.touches = this.ctrl.pointerIds.size || this.ctrl.touchIds.size;
      shared.locked = !!document.pointerLockElement;
      Object.assign(shared, getEventDetails(event2));
      shared.down = shared.pressed = shared.buttons % 2 === 1 || shared.touches > 0;
      dt = event2.timeStamp - state.timeStamp;
      state.timeStamp = event2.timeStamp;
      state.elapsedTime = state.timeStamp - state.startTime;
    }
    if (state._active) {
      const _absoluteDelta = state._delta.map(Math.abs);
      V.addTo(state._distance, _absoluteDelta);
    }
    if (this.axisIntent)
      this.axisIntent(event2);
    const [_m0, _m1] = state._movement;
    const [t02, t12] = config2.threshold;
    const {
      _step,
      values: values6
    } = state;
    if (config2.hasCustomTransform) {
      if (_step[0] === false)
        _step[0] = Math.abs(_m0) >= t02 && values6[0];
      if (_step[1] === false)
        _step[1] = Math.abs(_m1) >= t12 && values6[1];
    } else {
      if (_step[0] === false)
        _step[0] = Math.abs(_m0) >= t02 && Math.sign(_m0) * t02;
      if (_step[1] === false)
        _step[1] = Math.abs(_m1) >= t12 && Math.sign(_m1) * t12;
    }
    state.intentional = _step[0] !== false || _step[1] !== false;
    if (!state.intentional)
      return;
    const movement = [0, 0];
    if (config2.hasCustomTransform) {
      const [v0, v1] = values6;
      movement[0] = _step[0] !== false ? v0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? v1 - _step[1] : 0;
    } else {
      movement[0] = _step[0] !== false ? _m0 - _step[0] : 0;
      movement[1] = _step[1] !== false ? _m1 - _step[1] : 0;
    }
    if (this.restrictToAxis && !state._blocked)
      this.restrictToAxis(movement);
    const previousOffset = state.offset;
    const gestureIsActive = state._active && !state._blocked || state.active;
    if (gestureIsActive) {
      state.first = state._active && !state.active;
      state.last = !state._active && state.active;
      state.active = shared[this.ingKey] = state._active;
      if (event2) {
        if (state.first) {
          if ("bounds" in config2)
            state._bounds = call(config2.bounds, state);
          if (this.setup)
            this.setup();
        }
        state.movement = movement;
        this.computeOffset();
      }
    }
    const [ox, oy] = state.offset;
    const [[x0, x1], [y0, y1]] = state._bounds;
    state.overflow = [ox < x0 ? -1 : ox > x1 ? 1 : 0, oy < y0 ? -1 : oy > y1 ? 1 : 0];
    state._movementBound[0] = state.overflow[0] ? state._movementBound[0] === false ? state._movement[0] : state._movementBound[0] : false;
    state._movementBound[1] = state.overflow[1] ? state._movementBound[1] === false ? state._movement[1] : state._movementBound[1] : false;
    const rubberband2 = state._active ? config2.rubberband || [0, 0] : [0, 0];
    state.offset = computeRubberband(state._bounds, state.offset, rubberband2);
    state.delta = V.sub(state.offset, previousOffset);
    this.computeMovement();
    if (gestureIsActive && (!state.last || dt > BEFORE_LAST_KINEMATICS_DELAY)) {
      state.delta = V.sub(state.offset, previousOffset);
      const absoluteDelta = state.delta.map(Math.abs);
      V.addTo(state.distance, absoluteDelta);
      state.direction = state.delta.map(Math.sign);
      state._direction = state._delta.map(Math.sign);
      if (!state.first && dt > 0) {
        state.velocity = [absoluteDelta[0] / dt, absoluteDelta[1] / dt];
        state.timeDelta = dt;
      }
    }
  }
  emit() {
    const state = this.state;
    const shared = this.shared;
    const config2 = this.config;
    if (!state._active)
      this.clean();
    if ((state._blocked || !state.intentional) && !state._force && !config2.triggerAllEvents)
      return;
    const memo = this.handler(_objectSpread2(_objectSpread2(_objectSpread2({}, shared), state), {}, {
      [this.aliasKey]: state.values
    }));
    if (memo !== void 0)
      state.memo = memo;
  }
  clean() {
    this.eventStore.clean();
    this.timeoutStore.clean();
  }
}
function selectAxis([dx, dy], threshold2) {
  const absDx = Math.abs(dx);
  const absDy = Math.abs(dy);
  if (absDx > absDy && absDx > threshold2) {
    return "x";
  }
  if (absDy > absDx && absDy > threshold2) {
    return "y";
  }
  return void 0;
}
class CoordinatesEngine extends Engine {
  constructor(...args) {
    super(...args);
    _defineProperty$1(this, "aliasKey", "xy");
  }
  reset() {
    super.reset();
    this.state.axis = void 0;
  }
  init() {
    this.state.offset = [0, 0];
    this.state.lastOffset = [0, 0];
  }
  computeOffset() {
    this.state.offset = V.add(this.state.lastOffset, this.state.movement);
  }
  computeMovement() {
    this.state.movement = V.sub(this.state.offset, this.state.lastOffset);
  }
  axisIntent(event2) {
    const state = this.state;
    const config2 = this.config;
    if (!state.axis && event2) {
      const threshold2 = typeof config2.axisThreshold === "object" ? config2.axisThreshold[getPointerType(event2)] : config2.axisThreshold;
      state.axis = selectAxis(state._movement, threshold2);
    }
    state._blocked = (config2.lockDirection || !!config2.axis) && !state.axis || !!config2.axis && config2.axis !== state.axis;
  }
  restrictToAxis(v) {
    if (this.config.axis || this.config.lockDirection) {
      switch (this.state.axis) {
        case "x":
          v[1] = 0;
          break;
        case "y":
          v[0] = 0;
          break;
      }
    }
  }
}
const identity$a = (v) => v;
const DEFAULT_RUBBERBAND = 0.15;
const commonConfigResolver = {
  enabled(value = true) {
    return value;
  },
  eventOptions(value, _k, config2) {
    return _objectSpread2(_objectSpread2({}, config2.shared.eventOptions), value);
  },
  preventDefault(value = false) {
    return value;
  },
  triggerAllEvents(value = false) {
    return value;
  },
  rubberband(value = 0) {
    switch (value) {
      case true:
        return [DEFAULT_RUBBERBAND, DEFAULT_RUBBERBAND];
      case false:
        return [0, 0];
      default:
        return V.toVector(value);
    }
  },
  from(value) {
    if (typeof value === "function")
      return value;
    if (value != null)
      return V.toVector(value);
  },
  transform(value, _k, config2) {
    const transform = value || config2.shared.transform;
    this.hasCustomTransform = !!transform;
    if (process.env.NODE_ENV === "development") {
      const originalTransform = transform || identity$a;
      return (v) => {
        const r = originalTransform(v);
        if (!isFinite(r[0]) || !isFinite(r[1])) {
          console.warn(`[@use-gesture]: config.transform() must produce a valid result, but it was: [${r[0]},${[1]}]`);
        }
        return r;
      };
    }
    return transform || identity$a;
  },
  threshold(value) {
    return V.toVector(value, 0);
  }
};
if (process.env.NODE_ENV === "development") {
  Object.assign(commonConfigResolver, {
    domTarget(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);
      }
      return NaN;
    },
    lockDirection(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`lockDirection\` option has been merged with \`axis\`. Use it as in \`{ axis: 'lock' }\``);
      }
      return NaN;
    },
    initial(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`initial\` option has been renamed to \`from\`.`);
      }
      return NaN;
    }
  });
}
const DEFAULT_AXIS_THRESHOLD = 0;
const coordinatesConfigResolver = _objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  axis(_v, _k, {
    axis
  }) {
    this.lockDirection = axis === "lock";
    if (!this.lockDirection)
      return axis;
  },
  axisThreshold(value = DEFAULT_AXIS_THRESHOLD) {
    return value;
  },
  bounds(value = {}) {
    if (typeof value === "function") {
      return (state) => coordinatesConfigResolver.bounds(value(state));
    }
    if ("current" in value) {
      return () => value.current;
    }
    if (typeof HTMLElement === "function" && value instanceof HTMLElement) {
      return value;
    }
    const {
      left: left2 = -Infinity,
      right: right2 = Infinity,
      top: top2 = -Infinity,
      bottom: bottom2 = Infinity
    } = value;
    return [[left2, right2], [top2, bottom2]];
  }
});
const KEYS_DELTA_MAP = {
  ArrowRight: (displacement, factor = 1) => [displacement * factor, 0],
  ArrowLeft: (displacement, factor = 1) => [-1 * displacement * factor, 0],
  ArrowUp: (displacement, factor = 1) => [0, -1 * displacement * factor],
  ArrowDown: (displacement, factor = 1) => [0, displacement * factor]
};
class DragEngine extends CoordinatesEngine {
  constructor(...args) {
    super(...args);
    _defineProperty$1(this, "ingKey", "dragging");
  }
  reset() {
    super.reset();
    const state = this.state;
    state._pointerId = void 0;
    state._pointerActive = false;
    state._keyboardActive = false;
    state._preventScroll = false;
    state._delayed = false;
    state.swipe = [0, 0];
    state.tap = false;
    state.canceled = false;
    state.cancel = this.cancel.bind(this);
  }
  setup() {
    const state = this.state;
    if (state._bounds instanceof HTMLElement) {
      const boundRect = state._bounds.getBoundingClientRect();
      const targetRect = state.currentTarget.getBoundingClientRect();
      const _bounds = {
        left: boundRect.left - targetRect.left + state.offset[0],
        right: boundRect.right - targetRect.right + state.offset[0],
        top: boundRect.top - targetRect.top + state.offset[1],
        bottom: boundRect.bottom - targetRect.bottom + state.offset[1]
      };
      state._bounds = coordinatesConfigResolver.bounds(_bounds);
    }
  }
  cancel() {
    const state = this.state;
    if (state.canceled)
      return;
    state.canceled = true;
    state._active = false;
    setTimeout(() => {
      this.compute();
      this.emit();
    }, 0);
  }
  setActive() {
    this.state._active = this.state._pointerActive || this.state._keyboardActive;
  }
  clean() {
    this.pointerClean();
    this.state._pointerActive = false;
    this.state._keyboardActive = false;
    super.clean();
  }
  pointerDown(event2) {
    const config2 = this.config;
    const state = this.state;
    if (event2.buttons != null && (Array.isArray(config2.pointerButtons) ? !config2.pointerButtons.includes(event2.buttons) : config2.pointerButtons !== -1 && config2.pointerButtons !== event2.buttons))
      return;
    const ctrlIds = this.ctrl.setEventIds(event2);
    if (config2.pointerCapture) {
      event2.target.setPointerCapture(event2.pointerId);
    }
    if (ctrlIds && ctrlIds.size > 1 && state._pointerActive)
      return;
    this.start(event2);
    this.setupPointer(event2);
    state._pointerId = pointerId(event2);
    state._pointerActive = true;
    this.computeValues(pointerValues(event2));
    this.computeInitial();
    if (config2.preventScrollAxis && getPointerType(event2) !== "mouse") {
      state._active = false;
      this.setupScrollPrevention(event2);
    } else if (config2.delay > 0) {
      this.setupDelayTrigger(event2);
      if (config2.triggerAllEvents) {
        this.compute(event2);
        this.emit();
      }
    } else {
      this.startPointerDrag(event2);
    }
  }
  startPointerDrag(event2) {
    const state = this.state;
    state._active = true;
    state._preventScroll = true;
    state._delayed = false;
    this.compute(event2);
    this.emit();
  }
  pointerMove(event2) {
    const state = this.state;
    const config2 = this.config;
    if (!state._pointerActive)
      return;
    const id = pointerId(event2);
    if (state._pointerId !== void 0 && id !== state._pointerId)
      return;
    const _values = pointerValues(event2);
    if (document.pointerLockElement === event2.target) {
      state._delta = [event2.movementX, event2.movementY];
    } else {
      state._delta = V.sub(_values, state._values);
      this.computeValues(_values);
    }
    V.addTo(state._movement, state._delta);
    this.compute(event2);
    if (state._delayed && state.intentional) {
      this.timeoutStore.remove("dragDelay");
      state.active = false;
      this.startPointerDrag(event2);
      return;
    }
    if (config2.preventScrollAxis && !state._preventScroll) {
      if (state.axis) {
        if (state.axis === config2.preventScrollAxis || config2.preventScrollAxis === "xy") {
          state._active = false;
          this.clean();
          return;
        } else {
          this.timeoutStore.remove("startPointerDrag");
          this.startPointerDrag(event2);
          return;
        }
      } else {
        return;
      }
    }
    this.emit();
  }
  pointerUp(event2) {
    this.ctrl.setEventIds(event2);
    try {
      if (this.config.pointerCapture && event2.target.hasPointerCapture(event2.pointerId)) {
        ;
        event2.target.releasePointerCapture(event2.pointerId);
      }
    } catch (_unused) {
      if (process.env.NODE_ENV === "development") {
        console.warn(`[@use-gesture]: If you see this message, it's likely that you're using an outdated version of \`@react-three/fiber\`. 

Please upgrade to the latest version.`);
      }
    }
    const state = this.state;
    const config2 = this.config;
    if (!state._active || !state._pointerActive)
      return;
    const id = pointerId(event2);
    if (state._pointerId !== void 0 && id !== state._pointerId)
      return;
    this.state._pointerActive = false;
    this.setActive();
    this.compute(event2);
    const [dx, dy] = state._distance;
    state.tap = dx <= config2.tapsThreshold && dy <= config2.tapsThreshold;
    if (state.tap && config2.filterTaps) {
      state._force = true;
    } else {
      const [_dx, _dy] = state._delta;
      const [_mx, _my] = state._movement;
      const [svx, svy] = config2.swipe.velocity;
      const [sx2, sy] = config2.swipe.distance;
      const sdt = config2.swipe.duration;
      if (state.elapsedTime < sdt) {
        const _vx = Math.abs(_dx / state.timeDelta);
        const _vy = Math.abs(_dy / state.timeDelta);
        if (_vx > svx && Math.abs(_mx) > sx2)
          state.swipe[0] = Math.sign(_dx);
        if (_vy > svy && Math.abs(_my) > sy)
          state.swipe[1] = Math.sign(_dy);
      }
    }
    this.emit();
  }
  pointerClick(event2) {
    if (!this.state.tap && event2.detail > 0) {
      event2.preventDefault();
      event2.stopPropagation();
    }
  }
  setupPointer(event2) {
    const config2 = this.config;
    const device = config2.device;
    if (process.env.NODE_ENV === "development") {
      try {
        if (device === "pointer" && config2.preventScrollDelay === void 0) {
          const currentTarget = "uv" in event2 ? event2.sourceEvent.currentTarget : event2.currentTarget;
          const style2 = window.getComputedStyle(currentTarget);
          if (style2.touchAction === "auto") {
            console.warn(`[@use-gesture]: The drag target has its \`touch-action\` style property set to \`auto\`. It is recommended to add \`touch-action: 'none'\` so that the drag gesture behaves correctly on touch-enabled devices. For more information read this: https://use-gesture.netlify.app/docs/extras/#touch-action.

This message will only show in development mode. It won't appear in production. If this is intended, you can ignore it.`, currentTarget);
          }
        }
      } catch (_unused2) {
      }
    }
    if (config2.pointerLock) {
      event2.currentTarget.requestPointerLock();
    }
    if (!config2.pointerCapture) {
      this.eventStore.add(this.sharedConfig.window, device, "change", this.pointerMove.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, "end", this.pointerUp.bind(this));
      this.eventStore.add(this.sharedConfig.window, device, "cancel", this.pointerUp.bind(this));
    }
  }
  pointerClean() {
    if (this.config.pointerLock && document.pointerLockElement === this.state.currentTarget) {
      document.exitPointerLock();
    }
  }
  preventScroll(event2) {
    if (this.state._preventScroll && event2.cancelable) {
      event2.preventDefault();
    }
  }
  setupScrollPrevention(event2) {
    this.state._preventScroll = false;
    persistEvent(event2);
    const remove = this.eventStore.add(this.sharedConfig.window, "touch", "change", this.preventScroll.bind(this), {
      passive: false
    });
    this.eventStore.add(this.sharedConfig.window, "touch", "end", remove);
    this.eventStore.add(this.sharedConfig.window, "touch", "cancel", remove);
    this.timeoutStore.add("startPointerDrag", this.startPointerDrag.bind(this), this.config.preventScrollDelay, event2);
  }
  setupDelayTrigger(event2) {
    this.state._delayed = true;
    this.timeoutStore.add("dragDelay", () => {
      this.state._step = [0, 0];
      this.startPointerDrag(event2);
    }, this.config.delay);
  }
  keyDown(event2) {
    const deltaFn = KEYS_DELTA_MAP[event2.key];
    if (deltaFn) {
      const state = this.state;
      const factor = event2.shiftKey ? 10 : event2.altKey ? 0.1 : 1;
      this.start(event2);
      state._delta = deltaFn(this.config.keyboardDisplacement, factor);
      state._keyboardActive = true;
      V.addTo(state._movement, state._delta);
      this.compute(event2);
      this.emit();
    }
  }
  keyUp(event2) {
    if (!(event2.key in KEYS_DELTA_MAP))
      return;
    this.state._keyboardActive = false;
    this.setActive();
    this.compute(event2);
    this.emit();
  }
  bind(bindFunction) {
    const device = this.config.device;
    bindFunction(device, "start", this.pointerDown.bind(this));
    if (this.config.pointerCapture) {
      bindFunction(device, "change", this.pointerMove.bind(this));
      bindFunction(device, "end", this.pointerUp.bind(this));
      bindFunction(device, "cancel", this.pointerUp.bind(this));
      bindFunction("lostPointerCapture", "", this.pointerUp.bind(this));
    }
    if (this.config.keys) {
      bindFunction("key", "down", this.keyDown.bind(this));
      bindFunction("key", "up", this.keyUp.bind(this));
    }
    if (this.config.filterTaps) {
      bindFunction("click", "", this.pointerClick.bind(this), {
        capture: true,
        passive: false
      });
    }
  }
}
function persistEvent(event2) {
  "persist" in event2 && typeof event2.persist === "function" && event2.persist();
}
const isBrowser = typeof window !== "undefined" && window.document && window.document.createElement;
function supportsTouchEvents() {
  return isBrowser && "ontouchstart" in window;
}
function isTouchScreen() {
  return supportsTouchEvents() || isBrowser && window.navigator.maxTouchPoints > 1;
}
function supportsPointerEvents() {
  return isBrowser && "onpointerdown" in window;
}
function supportsPointerLock() {
  return isBrowser && "exitPointerLock" in window.document;
}
function supportsGestureEvents() {
  try {
    return "constructor" in GestureEvent;
  } catch (e3) {
    return false;
  }
}
const SUPPORT = {
  isBrowser,
  gesture: supportsGestureEvents(),
  touch: supportsTouchEvents(),
  touchscreen: isTouchScreen(),
  pointer: supportsPointerEvents(),
  pointerLock: supportsPointerLock()
};
const DEFAULT_PREVENT_SCROLL_DELAY = 250;
const DEFAULT_DRAG_DELAY = 180;
const DEFAULT_SWIPE_VELOCITY = 0.5;
const DEFAULT_SWIPE_DISTANCE = 50;
const DEFAULT_SWIPE_DURATION = 250;
const DEFAULT_KEYBOARD_DISPLACEMENT = 10;
const DEFAULT_DRAG_AXIS_THRESHOLD = {
  mouse: 0,
  touch: 0,
  pen: 8
};
const dragConfigResolver = _objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  device(_v, _k, {
    pointer: {
      touch = false,
      lock = false,
      mouse = false
    } = {}
  }) {
    this.pointerLock = lock && SUPPORT.pointerLock;
    if (SUPPORT.touch && touch)
      return "touch";
    if (this.pointerLock)
      return "mouse";
    if (SUPPORT.pointer && !mouse)
      return "pointer";
    if (SUPPORT.touch)
      return "touch";
    return "mouse";
  },
  preventScrollAxis(value, _k, {
    preventScroll
  }) {
    this.preventScrollDelay = typeof preventScroll === "number" ? preventScroll : preventScroll || preventScroll === void 0 && value ? DEFAULT_PREVENT_SCROLL_DELAY : void 0;
    if (!SUPPORT.touchscreen || preventScroll === false)
      return void 0;
    return value ? value : preventScroll !== void 0 ? "y" : void 0;
  },
  pointerCapture(_v, _k, {
    pointer: {
      capture = true,
      buttons = 1,
      keys: keys8 = true
    } = {}
  }) {
    this.pointerButtons = buttons;
    this.keys = keys8;
    return !this.pointerLock && this.device === "pointer" && capture;
  },
  threshold(value, _k, {
    filterTaps = false,
    tapsThreshold = 3,
    axis = void 0
  }) {
    const threshold2 = V.toVector(value, filterTaps ? tapsThreshold : axis ? 1 : 0);
    this.filterTaps = filterTaps;
    this.tapsThreshold = tapsThreshold;
    return threshold2;
  },
  swipe({
    velocity = DEFAULT_SWIPE_VELOCITY,
    distance = DEFAULT_SWIPE_DISTANCE,
    duration = DEFAULT_SWIPE_DURATION
  } = {}) {
    return {
      velocity: this.transform(V.toVector(velocity)),
      distance: this.transform(V.toVector(distance)),
      duration
    };
  },
  delay(value = 0) {
    switch (value) {
      case true:
        return DEFAULT_DRAG_DELAY;
      case false:
        return 0;
      default:
        return value;
    }
  },
  axisThreshold(value) {
    if (!value)
      return DEFAULT_DRAG_AXIS_THRESHOLD;
    return _objectSpread2(_objectSpread2({}, DEFAULT_DRAG_AXIS_THRESHOLD), value);
  },
  keyboardDisplacement(value = DEFAULT_KEYBOARD_DISPLACEMENT) {
    return value;
  }
});
if (process.env.NODE_ENV === "development") {
  Object.assign(dragConfigResolver, {
    useTouch(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`useTouch\` option has been renamed to \`pointer.touch\`. Use it as in \`{ pointer: { touch: true } }\`.`);
      }
      return NaN;
    },
    experimental_preventWindowScrollY(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`experimental_preventWindowScrollY\` option has been renamed to \`preventScroll\`.`);
      }
      return NaN;
    },
    swipeVelocity(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeVelocity\` option has been renamed to \`swipe.velocity\`. Use it as in \`{ swipe: { velocity: 0.5 } }\`.`);
      }
      return NaN;
    },
    swipeDistance(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeDistance\` option has been renamed to \`swipe.distance\`. Use it as in \`{ swipe: { distance: 50 } }\`.`);
      }
      return NaN;
    },
    swipeDuration(value) {
      if (value !== void 0) {
        throw Error(`[@use-gesture]: \`swipeDuration\` option has been renamed to \`swipe.duration\`. Use it as in \`{ swipe: { duration: 250 } }\`.`);
      }
      return NaN;
    }
  });
}
_objectSpread2(_objectSpread2({}, commonConfigResolver), {}, {
  device(_v, _k, {
    shared,
    pointer: {
      touch = false
    } = {}
  }) {
    const sharedConfig = shared;
    if (sharedConfig.target && !SUPPORT.touch && SUPPORT.gesture)
      return "gesture";
    if (SUPPORT.touch && touch)
      return "touch";
    if (SUPPORT.touchscreen) {
      if (SUPPORT.pointer)
        return "pointer";
      if (SUPPORT.touch)
        return "touch";
    }
  },
  bounds(_v, _k, {
    scaleBounds = {},
    angleBounds = {}
  }) {
    const _scaleBounds = (state) => {
      const D2 = assignDefault(call(scaleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [D2.min, D2.max];
    };
    const _angleBounds = (state) => {
      const A = assignDefault(call(angleBounds, state), {
        min: -Infinity,
        max: Infinity
      });
      return [A.min, A.max];
    };
    if (typeof scaleBounds !== "function" && typeof angleBounds !== "function")
      return [_scaleBounds(), _angleBounds()];
    return (state) => [_scaleBounds(state), _angleBounds(state)];
  },
  threshold(value, _k, config2) {
    this.lockDirection = config2.axis === "lock";
    const threshold2 = V.toVector(value, this.lockDirection ? [0.1, 3] : 0);
    return threshold2;
  },
  modifierKey(value) {
    if (value === void 0)
      return "ctrlKey";
    return value;
  },
  pinchOnWheel(value = true) {
    return value;
  }
});
_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: (value = true) => value
});
_objectSpread2(_objectSpread2({}, coordinatesConfigResolver), {}, {
  mouseOnly: (value = true) => value
});
const EngineMap = /* @__PURE__ */ new Map();
const ConfigResolverMap = /* @__PURE__ */ new Map();
function registerAction(action2) {
  EngineMap.set(action2.key, action2.engine);
  ConfigResolverMap.set(action2.key, action2.resolver);
}
const dragAction = {
  key: "drag",
  engine: DragEngine,
  resolver: dragConfigResolver
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
const sharedConfigResolver = {
  target(value) {
    if (value) {
      return () => "current" in value ? value.current : value;
    }
    return void 0;
  },
  enabled(value = true) {
    return value;
  },
  window(value = SUPPORT.isBrowser ? window : void 0) {
    return value;
  },
  eventOptions({
    passive: passive2 = true,
    capture = false
  } = {}) {
    return {
      passive: passive2,
      capture
    };
  },
  transform(value) {
    return value;
  }
};
const _excluded = ["target", "eventOptions", "window", "enabled", "transform"];
function resolveWith(config2 = {}, resolvers) {
  const result = {};
  for (const [key, resolver] of Object.entries(resolvers)) {
    switch (typeof resolver) {
      case "function":
        if (process.env.NODE_ENV === "development") {
          const r = resolver.call(result, config2[key], key, config2);
          if (!Number.isNaN(r))
            result[key] = r;
        } else {
          result[key] = resolver.call(result, config2[key], key, config2);
        }
        break;
      case "object":
        result[key] = resolveWith(config2[key], resolver);
        break;
      case "boolean":
        if (resolver)
          result[key] = config2[key];
        break;
    }
  }
  return result;
}
function parse$1(newConfig, gestureKey, _config = {}) {
  const _ref2 = newConfig, {
    target,
    eventOptions,
    window: window2,
    enabled,
    transform
  } = _ref2, rest = _objectWithoutProperties(_ref2, _excluded);
  _config.shared = resolveWith({
    target,
    eventOptions,
    window: window2,
    enabled,
    transform
  }, sharedConfigResolver);
  if (gestureKey) {
    const resolver = ConfigResolverMap.get(gestureKey);
    _config[gestureKey] = resolveWith(_objectSpread2({
      shared: _config.shared
    }, rest), resolver);
  } else {
    for (const key in rest) {
      const resolver = ConfigResolverMap.get(key);
      if (resolver) {
        _config[key] = resolveWith(_objectSpread2({
          shared: _config.shared
        }, rest[key]), resolver);
      } else if (process.env.NODE_ENV === "development") {
        if (!["drag", "pinch", "scroll", "wheel", "move", "hover"].includes(key)) {
          if (key === "domTarget") {
            throw Error(`[@use-gesture]: \`domTarget\` option has been renamed to \`target\`.`);
          }
          console.warn(`[@use-gesture]: Unknown config key \`${key}\` was used. Please read the documentation for further information.`);
        }
      }
    }
  }
  return _config;
}
class EventStore {
  constructor(ctrl, gestureKey) {
    _defineProperty$1(this, "_listeners", /* @__PURE__ */ new Set());
    this._ctrl = ctrl;
    this._gestureKey = gestureKey;
  }
  add(element, device, action2, handler, options2) {
    const listeners = this._listeners;
    const type2 = toDomEventType(device, action2);
    const _options = this._gestureKey ? this._ctrl.config[this._gestureKey].eventOptions : {};
    const eventOptions = _objectSpread2(_objectSpread2({}, _options), options2);
    element.addEventListener(type2, handler, eventOptions);
    const remove = () => {
      element.removeEventListener(type2, handler, eventOptions);
      listeners.delete(remove);
    };
    listeners.add(remove);
    return remove;
  }
  clean() {
    this._listeners.forEach((remove) => remove());
    this._listeners.clear();
  }
}
class TimeoutStore {
  constructor() {
    _defineProperty$1(this, "_timeouts", /* @__PURE__ */ new Map());
  }
  add(key, callback, ms = 140, ...args) {
    this.remove(key);
    this._timeouts.set(key, window.setTimeout(callback, ms, ...args));
  }
  remove(key) {
    const timeout2 = this._timeouts.get(key);
    if (timeout2)
      window.clearTimeout(timeout2);
  }
  clean() {
    this._timeouts.forEach((timeout2) => void window.clearTimeout(timeout2));
    this._timeouts.clear();
  }
}
class Controller2 {
  constructor(handlers) {
    _defineProperty$1(this, "gestures", /* @__PURE__ */ new Set());
    _defineProperty$1(this, "_targetEventStore", new EventStore(this));
    _defineProperty$1(this, "gestureEventStores", {});
    _defineProperty$1(this, "gestureTimeoutStores", {});
    _defineProperty$1(this, "handlers", {});
    _defineProperty$1(this, "config", {});
    _defineProperty$1(this, "pointerIds", /* @__PURE__ */ new Set());
    _defineProperty$1(this, "touchIds", /* @__PURE__ */ new Set());
    _defineProperty$1(this, "state", {
      shared: {
        shiftKey: false,
        metaKey: false,
        ctrlKey: false,
        altKey: false
      }
    });
    resolveGestures(this, handlers);
  }
  setEventIds(event2) {
    if (isTouch(event2)) {
      this.touchIds = new Set(touchIds(event2));
      return this.touchIds;
    } else if ("pointerId" in event2) {
      if (event2.type === "pointerup" || event2.type === "pointercancel")
        this.pointerIds.delete(event2.pointerId);
      else if (event2.type === "pointerdown")
        this.pointerIds.add(event2.pointerId);
      return this.pointerIds;
    }
  }
  applyHandlers(handlers, nativeHandlers) {
    this.handlers = handlers;
    this.nativeHandlers = nativeHandlers;
  }
  applyConfig(config2, gestureKey) {
    this.config = parse$1(config2, gestureKey, this.config);
  }
  clean() {
    this._targetEventStore.clean();
    for (const key of this.gestures) {
      this.gestureEventStores[key].clean();
      this.gestureTimeoutStores[key].clean();
    }
  }
  effect() {
    if (this.config.shared.target)
      this.bind();
    return () => this._targetEventStore.clean();
  }
  bind(...args) {
    const sharedConfig = this.config.shared;
    const props2 = {};
    let target;
    if (sharedConfig.target) {
      target = sharedConfig.target();
      if (!target)
        return;
    }
    if (sharedConfig.enabled) {
      for (const gestureKey of this.gestures) {
        const gestureConfig = this.config[gestureKey];
        const bindFunction = bindToProps(props2, gestureConfig.eventOptions, !!target);
        if (gestureConfig.enabled) {
          const Engine2 = EngineMap.get(gestureKey);
          new Engine2(this, args, gestureKey).bind(bindFunction);
        }
      }
      const nativeBindFunction = bindToProps(props2, sharedConfig.eventOptions, !!target);
      for (const eventKey in this.nativeHandlers) {
        nativeBindFunction(eventKey, "", (event2) => this.nativeHandlers[eventKey](_objectSpread2(_objectSpread2({}, this.state.shared), {}, {
          event: event2,
          args
        })), void 0, true);
      }
    }
    for (const handlerProp in props2) {
      props2[handlerProp] = chain(...props2[handlerProp]);
    }
    if (!target)
      return props2;
    for (const handlerProp in props2) {
      const {
        device,
        capture,
        passive: passive2
      } = parseProp(handlerProp);
      this._targetEventStore.add(target, device, "", props2[handlerProp], {
        capture,
        passive: passive2
      });
    }
  }
}
function setupGesture(ctrl, gestureKey) {
  ctrl.gestures.add(gestureKey);
  ctrl.gestureEventStores[gestureKey] = new EventStore(ctrl, gestureKey);
  ctrl.gestureTimeoutStores[gestureKey] = new TimeoutStore();
}
function resolveGestures(ctrl, internalHandlers) {
  if (internalHandlers.drag)
    setupGesture(ctrl, "drag");
  if (internalHandlers.wheel)
    setupGesture(ctrl, "wheel");
  if (internalHandlers.scroll)
    setupGesture(ctrl, "scroll");
  if (internalHandlers.move)
    setupGesture(ctrl, "move");
  if (internalHandlers.pinch)
    setupGesture(ctrl, "pinch");
  if (internalHandlers.hover)
    setupGesture(ctrl, "hover");
}
const bindToProps = (props2, eventOptions, withPassiveOption) => (device, action2, handler, options2 = {}, isNative = false) => {
  var _options$capture, _options$passive;
  const capture = (_options$capture = options2.capture) !== null && _options$capture !== void 0 ? _options$capture : eventOptions.capture;
  const passive2 = (_options$passive = options2.passive) !== null && _options$passive !== void 0 ? _options$passive : eventOptions.passive;
  let handlerProp = isNative ? device : toHandlerProp(device, action2, capture);
  if (withPassiveOption && passive2)
    handlerProp += "Passive";
  props2[handlerProp] = props2[handlerProp] || [];
  props2[handlerProp].push(handler);
};
function useRecognizers(handlers, config2 = {}, gestureKey, nativeHandlers) {
  const ctrl = React__default.useMemo(() => new Controller2(handlers), []);
  ctrl.applyHandlers(handlers, nativeHandlers);
  ctrl.applyConfig(config2, gestureKey);
  React__default.useEffect(ctrl.effect.bind(ctrl));
  React__default.useEffect(() => {
    return ctrl.clean.bind(ctrl);
  }, []);
  if (config2.target === void 0) {
    return ctrl.bind.bind(ctrl);
  }
  return void 0;
}
function useDrag(handler, config2) {
  registerAction(dragAction);
  return useRecognizers({
    drag: handler
  }, config2 || {}, "drag");
}
var SwipeDirection = /* @__PURE__ */ ((SwipeDirection2) => {
  SwipeDirection2["down"] = "down";
  SwipeDirection2["left"] = "left";
  SwipeDirection2["none"] = "none";
  SwipeDirection2["right"] = "right";
  SwipeDirection2["up"] = "up";
  return SwipeDirection2;
})(SwipeDirection || {});
const detectSwipe = (movement, swipe, threshold2) => {
  if (swipe) {
    const [sx2, sy] = swipe;
    if (sx2 === -1) {
      return SwipeDirection.left;
    } else if (sx2 === 1) {
      return SwipeDirection.right;
    } else if (sy === -1) {
      return SwipeDirection.up;
    } else if (sy === 1) {
      return SwipeDirection.down;
    }
  }
  if (movement && threshold2) {
    const [mx, my] = movement;
    const [tx, ty] = threshold2;
    if (tx && mx && Math.abs(mx) > tx) {
      return mx > 0 ? SwipeDirection.right : SwipeDirection.left;
    }
    if (ty && my && Math.abs(my) > ty) {
      return my > 0 ? SwipeDirection.down : SwipeDirection.up;
    }
  }
  return SwipeDirection.none;
};
var Axis = /* @__PURE__ */ ((Axis2) => {
  Axis2["lock"] = "lock";
  Axis2["x"] = "x";
  Axis2["y"] = "y";
  return Axis2;
})(Axis || {});
const Swipeable = React__default.forwardRef(
  ({
    axis,
    children: children2,
    enabled = true,
    manageDrag,
    springStart,
    onSwipe,
    onClick,
    xThreshold,
    yThreshold,
    gestureOptions = {}
  }, ref2) => {
    const [{ x: x3, y: y4 }, spring] = useSpring(() => ({ x: 0, y: 0 }));
    const bind3 = useDrag(
      (dragState) => {
        const {
          event: event2,
          movement: [mx, my],
          swipe: [sx2, sy],
          tap
        } = dragState;
        if (onClick && tap) {
          onClick(event2);
          return;
        }
        manageDrag == null ? void 0 : manageDrag(dragState);
        springStart && spring.start(springStart(dragState));
        const swipeDirection = detectSwipe(
          [mx, my],
          [sx2, sy],
          [xThreshold, yThreshold]
        );
        if (swipeDirection !== SwipeDirection.none) {
          onSwipe({ event: event2, swipeDirection, sx: sx2, sy });
        }
      },
      // useDrag options - https://use-gesture.netlify.app/docs/options/#gesture-options-1
      {
        ...gestureOptions,
        axis,
        enabled,
        filterTaps: Boolean(onClick)
        // Filter touch events for taps if onClick is passed
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(animated.div, { ref: ref2, ...bind3(), style: { x: x3, y: y4, touchAction: "none" }, children: children2 });
  }
);
const SwipeableNamespace = Object.assign(Swipeable, { Axis });
const smallMax$3 = 500;
const mediumMin$3 = smallMax$3 + 1;
const mediumMax$3 = 800;
const largeMin$3 = mediumMax$3 + 1;
const largeMax$3 = 1416;
const hdMin = largeMax$3 + 1;
const screenSizes = {
  // Casing due to legacy usage - TODO: maybe camelCase these and all usage
  "screen-small-max": smallMax$3,
  "screen-medium-min": mediumMin$3,
  "screen-medium-max": mediumMax$3,
  "screen-large-min": largeMin$3,
  "screen-large-max": largeMax$3,
  "screen-hd-min": hdMin
};
const mediaQueries$2 = {
  sm: `all and (max-width: ${smallMax$3}px)`,
  md: `all and (min-width: ${mediumMin$3}px) and (max-width: ${mediumMax$3}px)`,
  "md-up": `all and (min-width: ${mediumMin$3}px)`,
  "md-down": `all and (max-width: ${mediumMax$3}px)`,
  lg: `all and (min-width: ${largeMin$3}px) and (max-width: ${largeMax$3}px)`,
  "lg-up": `all and (min-width: ${largeMin$3}px)`,
  "lg-down": `all and (max-width: ${largeMax$3}px)`,
  hd: `all and (min-width: ${hdMin}px)`,
  // NOTE: complex strings need double quoting
  retina: "'only screen and (-webkit-min-device-pixel-ratio: 1.5), only screen and (-o-min-device-pixel-ratio: 3/2), only screen and (min--moz-device-pixel-ratio: 1.5), only screen and (min-device-pixel-ratio: 1.5)'",
  all: "'all and (min-width: 0)'",
  ie: "'all and (-ms-high-contrast: none), (-ms-high-contrast: active)'",
  print: "print"
};
const smallMax$2 = 500;
const mediumMin$2 = smallMax$2 + 1;
const mediumMax$2 = 800;
const largeMin$2 = mediumMax$2 + 1;
const largeMax$2 = 1416;
const xLargeMin$2 = largeMax$2 + 1;
const breakpoints$1 = {
  mediumMin: mediumMin$2,
  largeMin: largeMin$2,
  xLargeMin: xLargeMin$2
};
const mediaQueries$1 = {
  /** Viewport is printable */
  [
    "print"
    /* print */
  ]: "print",
  /** Viewport is Small - width < 767px */
  [
    "sm"
    /* sm */
  ]: `all and (max-width: ${smallMax$2}px)`,
  /** Viewport is Medium or bigger - width ≥ 768px */
  [
    "mdDown"
    /* mdDown */
  ]: `all and (max-width: ${mediumMax$2}px)`,
  /** Viewport is Medium - 768px ≥ width < 1023px */
  [
    "md"
    /* md */
  ]: `all and (min-width: ${mediumMin$2}px) and (max-width: ${mediumMax$2}px)`,
  /** Viewport is Medium or smaller - width < 1023px */
  [
    "mdUp"
    /* mdUp */
  ]: `all and (min-width: ${mediumMin$2}px)`,
  /** Viewport is Large or bigger - width ≥ 1024px */
  [
    "lgDown"
    /* lgDown */
  ]: `all and (max-width: ${largeMax$2}px)`,
  /** Viewport is Large - 1024px ≥ width < 1439px */
  [
    "lg"
    /* lg */
  ]: `all and (min-width: ${largeMin$2}px) and (max-width: ${largeMax$2}px)`,
  /** Viewport is Large or smaller - width < 1439px */
  [
    "lgUp"
    /* lgUp */
  ]: `all and (min-width: ${largeMin$2}px)`,
  /** Viewport is X-Large: width ≥ 1440px */
  [
    "xl"
    /* xl */
  ]: `all and (min-width: ${xLargeMin$2}px)`
};
Object.keys(mediaQueries$1).map(
  (key) => key
);
const eggplant = {
  95: "#230F91",
  90: "#3c3caa",
  70: "#5252da",
  60: "#6363e9",
  // hsl(240, 75%, 65%)
  50: "#7878f5",
  40: "#AEAEFF",
  30: "#c9c9ff",
  20: "#e4e4ff",
  10: "#eeeeff",
  "05": "#f4f4ff",
  "01": "#f9f9ff"
};
const fog = {
  90: "#0f0f0f",
  80: "#333a44",
  70: "#464C57",
  60: "#575d68",
  50: "#6c727d",
  40: "#7f8690",
  30: "#959ca6",
  25: "#a7adb7",
  20: "#b9bfc8",
  15: "#ccd1da",
  10: "#e2e6ec",
  "07": "#eef1f4",
  "05": "#f5f7f9",
  "00": "#ffffff"
};
const lobster = {
  100: "#920009",
  70: "#e63944",
  60: "#f74f59",
  50: "#fe747c",
  30: "#ffc6c6",
  "05": "#fff3f3"
};
const midnight = {
  100: "#003757",
  50: "#3396fd",
  20: "#b8d9fe"
};
const forest = {
  60: "#00B072"
};
const palettes = {
  eggplant,
  fog,
  lobster,
  midnight,
  forest
};
const rekeyedPalettes = Object.keys(palettes).map((colorKey) => {
  return Object.keys(palettes[colorKey]).reduce((palette, scale) => {
    return {
      ...palette,
      [`${colorKey}-${scale}`]: palettes[colorKey][scale]
    };
  }, {});
});
const combinedPalettes = rekeyedPalettes.reduce((combined, palette) => {
  return {
    ...combined,
    ...palette
  };
}, {});
const action = {
  ...action$1,
  primary: {
    __default: combinedPalettes["eggplant-60"],
    disabled: combinedPalettes["fog-40"],
    hover: combinedPalettes["eggplant-70"],
    pressed: combinedPalettes["eggplant-70"]
  },
  secondary: {
    __default: combinedPalettes["eggplant-70"],
    disabled: combinedPalettes["eggplant-20"],
    hover: combinedPalettes["eggplant-60"],
    pressed: combinedPalettes["eggplant-70"]
  }
};
const border = {
  ...border$1,
  __default: combinedPalettes["fog-10"],
  active: combinedPalettes["eggplant-60"],
  disabled: combinedPalettes["fog-10"],
  error: {
    ...border$1.error,
    __default: combinedPalettes["lobster-70"],
    active: combinedPalettes["lobster-70"]
  },
  focused: combinedPalettes["eggplant-50"],
  subdued: combinedPalettes["fog-20"]
};
const text = {
  ...text$2,
  error: combinedPalettes["lobster-70"],
  primary: combinedPalettes["midnight-100"],
  secondary: combinedPalettes["fog-50"],
  subdued: combinedPalettes["fog-80"],
  white: combinedPalettes["fog-00"]
};
const buttonColors = {
  ...buttonColors$1,
  primary: {
    ...buttonColors$1.primary,
    background: {
      __default: action.primary.__default,
      active: action.primary.pressed,
      disabled: action.primary.disabled,
      hover: action.primary.hover,
      loading: alpha(combinedPalettes["eggplant-70"], 0.8)
    },
    foreground: {
      loading: alpha(combinedPalettes["fog-00"], 0.75)
    },
    text: {
      __default: text.white,
      disabled: text.subdued,
      loading: text.subdued
    }
  }
};
const formColors = {
  background: combinedPalettes$1["fog-00"],
  disabled: {
    border: combinedPalettes$1["fog-50"],
    background: combinedPalettes$1["fog-50"],
    hintText: text.secondary
  },
  placeholder: text.subdued,
  // Variant based color definitions
  default: {
    border: {
      __default: border.__default,
      active: border.active,
      hover: border.hover
    },
    hintText: text.primary
  },
  error: {
    border: {
      __default: border.error.__default,
      active: border.error.active,
      hover: border.error.hover
    },
    hintText: text.error
  },
  success: {
    border: {
      __default: border.success.__default,
      active: border.success.active,
      hover: border.success.hover
    },
    hintText: text.success
  }
};
const linkColors = {
  ...linkColors$1,
  subtle: combinedPalettes["fog-40"]
};
const components = {
  ...components$1,
  button: buttonColors,
  forms: formColors,
  link: linkColors
};
const icon = {
  ...icon$2,
  __default: alpha(combinedPalettes$1["fog-80"], 0.75),
  error: combinedPalettes$1["ember-50"],
  info: combinedPalettes$1["midnight-50"],
  subdued: alpha(combinedPalettes$1["fog-80"], 0.4),
  success: combinedPalettes$1["fern-50"],
  warning: combinedPalettes$1["dawn-50"],
  white: combinedPalettes$1["fog-00"]
};
const lightColors = {
  ...lightColors$1,
  action,
  border,
  icon,
  text,
  ...components
};
const colorModes = { light: lightColors };
const fonts$1 = {
  ...fonts$2,
  heading: "Circular, Arial, 'Helvetica Neue', Helvetica, sans-serif",
  body: "Biwa, Arial, 'Helvetica Neue', Helvetica, sans-serif"
};
const fontWeights = {
  ...fontWeights$1,
  light: 300,
  deminormal: 400,
  normal: 500
};
const fontSizes = fontSizes$1;
const letterSpacings = letterSpacings$1;
const lineHeights = {
  ...lineHeights$1,
  1.3125: "1.3125rem",
  1.6875: "1.6875rem",
  1.875: "1.875rem",
  2.875: "2.875rem"
};
const baseWrapperStyles = {
  ...baseWrapperStyles$1
};
const baseInputStyles = {
  ...baseInputStyles$1,
  fontWeight: "deminormal"
};
const formVariants = {
  [FormInputVariants.default]: {
    wrapperStyles: {
      ...baseWrapperStyles,
      borderColor: "forms.default.border"
    },
    inputStyles: {
      ...baseInputStyles
    }
  },
  [FormInputVariants.error]: {
    wrapperStyles: {
      ...baseWrapperStyles,
      borderColor: "forms.error.border"
    },
    inputStyles: {
      ...baseInputStyles
    }
  },
  [FormInputVariants.success]: {
    wrapperStyles: {
      ...baseWrapperStyles,
      borderColor: "forms.success.border"
    },
    inputStyles: {
      ...baseInputStyles
    }
  }
};
const base = {
  ...base$e,
  fontWeight: "light"
};
const variants$2 = {
  ...variants$b,
  "caption-16": {
    ...base,
    fontSize: 16,
    lineHeight: 1.5,
    letterSpacing: 0,
    fontWeight: "400"
  },
  "caption-14": {
    ...base,
    fontSize: 14,
    lineHeight: 1.3125,
    letterSpacing: 0
  }
};
const variants$1 = {
  "paragraph-24": {
    ...base$d,
    fontSize: buildResponsiveValues({ mdUp: 24, smDown: 18 }),
    lineHeight: buildResponsiveValues({ mdUp: 2, smDown: 1.6875 }),
    letterSpacing: 0
  },
  "paragraph-18": {
    ...base$d,
    fontSize: 18,
    lineHeight: 1.6875,
    // 27px
    letterSpacing: 0
  },
  "paragraph-16": {
    ...base$d,
    fontSize: 16,
    lineHeight: 1.5,
    // 24px
    letterSpacing: 0
  },
  "paragraph-14": {
    ...base$d,
    fontSize: 14,
    lineHeight: 1.3125,
    // 21px
    letterSpacing: 0
  },
  "paragraph-12": {
    ...base$d,
    fontSize: 12,
    lineHeight: 1.5,
    // 18px
    letterSpacing: 0
  }
};
const variants = {
  ...variants$3,
  text: {
    ...variants$3.text,
    ...variants$2,
    ...variants$1,
    ...variants$6
  },
  forms: {
    ...variants$3.forms,
    ...formVariants
  }
};
const theme$1 = {
  ...theme$2,
  breakpoints: Object.values(breakpoints$1).map((pixelValue) => `${pixelValue}px`),
  mediaQueries: mediaQueries$1,
  colors: {
    ...combinedPalettes,
    ...colorModes.light
  },
  fonts: fonts$1,
  fontWeights,
  fontSizes,
  letterSpacings,
  lineHeights,
  ...variants
};
const xSmallMax$1 = 500;
const smallMin$1 = xSmallMax$1 + 1;
const smallMax$1 = 800;
const mediumMin$1 = smallMax$1 + 1;
const mediumMax$1 = 960;
const largeMin$1 = mediumMax$1 + 1;
const largeMax$1 = 1416;
const xLargeMin$1 = largeMax$1 + 1;
const breakpoints = {
  smallMin: smallMin$1,
  mediumMin: mediumMin$1,
  largeMin: largeMin$1,
  xLargeMin: xLargeMin$1
};
const mediaQueries = {
  /** Viewport is printable */
  [
    "print"
    /* print */
  ]: "print",
  /** Viewport is Extra Small - width < 500px */
  [
    "xs"
    /* xs */
  ]: `all and (max-width: ${xSmallMax$1}px)`,
  /** Viewport is Small - 501px ≥ width < 800px */
  [
    "sm"
    /* sm */
  ]: `all and (min-width: ${smallMin$1}px) and (max-width: ${smallMax$1}px)`,
  /** Viewport is Small or larger- width ≥ 501px */
  [
    "smUp"
    /* smUp */
  ]: `all and (min-width: ${smallMin$1}px)`,
  /** Viewport is Small or smaller - width < 800px */
  [
    "smDown"
    /* smDown */
  ]: `all and (max-width: ${smallMax$1}px)`,
  /** Viewport is Medium or bigger - width ≥ 960px */
  [
    "mdDown"
    /* mdDown */
  ]: `all and (max-width: ${mediumMax$1}px)`,
  /** Viewport is Medium - 801px ≥ width < 960px */
  [
    "md"
    /* md */
  ]: `all and (min-width: ${mediumMin$1}px) and (max-width: ${mediumMax$1}px)`,
  /** Viewport is Medium or smaller - width < 801px */
  [
    "mdUp"
    /* mdUp */
  ]: `all and (min-width: ${mediumMin$1}px)`,
  /** Viewport is Large or smaller - width < 1416px */
  [
    "lgDown"
    /* lgDown */
  ]: `all and (max-width: ${largeMax$1}px)`,
  /** Viewport is Large - 961px ≥ width < 1416px */
  [
    "lg"
    /* lg */
  ]: `all and (min-width: ${largeMin$1}px) and (max-width: ${largeMax$1}px)`,
  /** Viewport is Large or bigger - width ≥ 961px */
  [
    "lgUp"
    /* lgUp */
  ]: `all and (min-width: ${largeMin$1}px)`,
  /** Viewport is X-Large: width ≥ 1417px */
  [
    "xl"
    /* xl */
  ]: `all and (min-width: ${xLargeMin$1}px)`
};
Object.keys(mediaQueries).map(
  (key) => key
);
const theme = merge$2(theme$1, {
  breakpoints: Object.values(breakpoints).map((pixelValue) => `${pixelValue}px`),
  mediaQueries
});
const iconMappings$1 = {
  info: "info",
  warning: "warning",
  success: "checkCircle",
  error: "error",
  announcement: "clock"
};
const Banner = ({
  sx: sx2 = {},
  onDismiss = noop$6,
  children: children2 = null,
  title = "",
  showIcon = true,
  showTitle = false,
  variant: variant3 = BannerVariant.success,
  onActionClick = noop$6,
  dismissAriaLabel = "dismiss",
  iconName = "",
  id = "",
  primaryAction = void 0,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const {
    matchMediaQuery: { smUp }
  } = useMatchMedia();
  const handleDissmiss = (e3) => {
    e3.stopPropagation();
    return onDismiss(id);
  };
  const handleActionClick = (event2) => {
    if (onActionClick && primaryAction) {
      onActionClick(event2, { id, href: primaryAction.href });
    }
  };
  const enableDissmiss = !isEqual$a(noop$6, onDismiss);
  let iconKey = getIconByKey(iconName, IconSizes.Icon16) ? iconName : null;
  if (!iconKey) {
    iconKey = variant3 ? iconMappings$1[variant3] : "";
  }
  const bannerOnClick = primaryAction && !smUp ? handleActionClick : noop$6;
  const bannerRole2 = primaryAction && !smUp ? "button" : "banner";
  const bannerTabIndex = smUp ? {} : { tabIndex: 0 };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      onClick: bannerOnClick,
      role: bannerRole2,
      sx: style2(),
      variant: `banner.${variant3}`,
      ...restOfProps,
      ...bannerTabIndex,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { sx: styles$m.container, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { sx: styles$m.descriptionContainer, children: [
          showIcon ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              color: `banner.icon.${variant3}`,
              "data-test-id": "banner-icon",
              name: iconKey,
              size: IconSizes.Icon16,
              sx: styles$m.icon
            }
          ) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Span,
            {
              color: TextColors.primary,
              sx: styles$m.body,
              variant: SpanSizes.Span14,
              children: [
                showTitle ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Title, { sx: styles$m.title, variant: TitleSizes$1.Title14, children: [
                  title,
                  " "
                ] }) : null,
                children2
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { sx: styles$m.actions, children: [
          primaryAction && smUp ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Link$1,
            {
              href: primaryAction.href,
              onClick: handleActionClick,
              size: ButtonSize.compact,
              variant: ButtonVariant.secondary,
              children: primaryAction.text
            }
          ) : null,
          enableDissmiss ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              "aria-label": dismissAriaLabel,
              name: "x",
              onClick: handleDissmiss,
              size: IconSizes.Icon12,
              stroke: "icon",
              sx: styles$m.dismiss
            }
          ) : null
        ] })
      ] })
    }
  );
};
const styles$m = {
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    minHeight: "2.25rem"
  },
  containerInner: {},
  descriptionContainer: {
    flexGrow: "1",
    justifyContent: buildResponsiveValues({
      xs: "start",
      smUp: "center"
    }),
    alignSelf: "center",
    alignItems: "center",
    gap: "0.5rem"
  },
  icon: {
    mr: 0.4,
    ml: 0.4
  },
  title: {
    mr: 0.2,
    ml: 0.2
  },
  dismiss: {
    marginLeft: "auto",
    flexShrink: 0,
    width: "2rem"
  },
  body: {
    display: "flex",
    gap: buildResponsiveValues({
      xs: 0,
      smUp: 0.5
    }),
    overflowWrap: "break-word",
    flexDirection: buildResponsiveValues({
      xs: "column",
      smUp: "row"
    })
  },
  footer: {
    button: {
      marginLeft: "auto",
      marginTop: 1.5
    }
  },
  actions: {
    gap: 0.5,
    flexShrink: 0,
    flexGrow: "0"
  }
};
Banner.variant = BannerVariant;
const Context$9 = createContext(void 0);
function filterDismissed(collection, dismissedIds) {
  return collection == null ? void 0 : collection.filter((banner) => !dismissedIds.includes(banner.id));
}
const BannerProvider = ({
  children: children2,
  dismiss,
  dismissedBanners,
  fetchPromise,
  onPrimaryLinkClicked = void 0,
  onActionButtonClicked = void 0
}) => {
  const [response, setResponse] = useState({
    hero: [],
    banner: []
  });
  const context = {
    dismiss,
    hero: filterDismissed(response.hero || [], dismissedBanners || []),
    banner: filterDismissed(response.banner || [], dismissedBanners || []),
    onPrimaryLinkClicked,
    onActionButtonClicked
  };
  useEffect(() => {
    let isSubscribed = true;
    const fetchData = async () => {
      const data = await fetchPromise;
      if (isSubscribed) {
        setResponse(data);
      }
    };
    fetchData();
    return () => {
      isSubscribed = false;
    };
  }, [fetchPromise]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$9.Provider, { value: context, children: children2 });
};
const useBanners = () => {
  const context = useContext(Context$9);
  if (context === void 0) {
    throw new Error("useBanners must be used within a BannerProvider");
  }
  return context;
};
const Banners = () => {
  const { banner, dismiss, onActionButtonClicked } = useBanners();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { children: banner.map((props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Banner,
    {
      dismissAriaLabel: "dismiss",
      onActionClick: onActionButtonClicked,
      onDismiss: dismiss,
      ...props2
    },
    props2 == null ? void 0 : props2.id
  )) });
};
const Tag = ({
  icon: icon2 = void 0,
  sx: sx2 = {},
  text: text2 = "",
  variant: variant3 = TagVariant.info,
  // TODO: Should this have a default enum value?
  dark = false,
  children: children2 = null
}) => {
  const wrappedIcon = icon2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { pr: 0.25 }, children: React__default.cloneElement(icon2, {
    stroke: "currentColor"
  }) }) : null;
  const tagContent = children2 || text2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "0 0 auto", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "center",
      justifyContent: "center",
      sx: {
        variant: `tag${dark ? ".dark" : ""}.${variant3}`,
        ...sx2
      },
      children: [
        wrappedIcon,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "span", color: "inherit", sx: { flex: "0 0 auto" }, variant: "14", children: tagContent })
      ]
    }
  ) });
};
const HeroBanner = ({
  description = void 0,
  disclosure = void 0,
  id,
  img,
  primaryAction = void 0,
  tag: tag2 = void 0,
  title,
  variant: variant3 = HeroBannerVariant.default
}) => {
  const { dismiss, onPrimaryLinkClicked } = useBanners();
  const primaryLinkClicked = (event2) => {
    if (onPrimaryLinkClicked && primaryAction) {
      onPrimaryLinkClicked(event2, { id, href: primaryAction.href });
    }
  };
  let icon2;
  if ((primaryAction == null ? void 0 : primaryAction.icon) === true) {
    icon2 = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "arrowRight", size: IconSizes.Icon16 });
  } else if (primaryAction == null ? void 0 : primaryAction.icon) {
    icon2 = primaryAction.icon;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => {
    const { smUp, mdUp } = mediaQueries2;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { variant: `heroBanner.${variant3}.container`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Flex,
        {
          flexGrow: 1,
          variant: `heroBanner.${variant3}.contentContainer`,
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 0.75, children: [
            tag2 && mdUp && /* @__PURE__ */ jsxRuntimeExports.jsx(Tag, { text: tag2, variant: TagVariant.indeterminate }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "h3", variant: TitleSizes$1.Title24, children: title }),
              description && /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph2, { sx: { marginTop: 0.25, marginBottom: 0 }, children: description })
            ] }),
            primaryAction && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Link$1,
              {
                href: primaryAction.href,
                icon: icon2,
                iconAlignment: IconAlignment.trailing,
                onClick: primaryLinkClicked,
                size: smUp ? ButtonSize.compact : ButtonSize.default,
                sx: { marginTop: 0.25 },
                variant: ButtonVariant.secondary,
                children: primaryAction.text
              }
            ),
            disclosure && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Paragraph2,
              {
                color: TextColors.tertiary,
                sx: { marginBottom: 0 },
                variant: ParagraphSizes.Paragraph14,
                children: disclosure
              }
            )
          ] })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          sx: {
            backgroundImage: `url(${img})`
          },
          variant: `heroBanner.${variant3}.imageContainer`,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            CompoundButton,
            {
              "aria-label": "Dismiss",
              icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "x", size: IconSizes.Icon12 }),
              onClick: () => dismiss(id),
              shape: ButtonShape.circle,
              size: ButtonSize.compact,
              sx: {
                // TODO: move to theme
                backgroundColor: "surface.__default",
                position: "absolute",
                top: 1,
                right: 1
              },
              variant: ButtonVariant.tertiary
            }
          )
        }
      )
    ] });
  } });
};
HeroBanner.variant = HeroBannerVariant;
const HeroBanners = () => {
  const { hero } = useBanners();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { spacing: 1, children: hero.map((props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(HeroBanner, { ...props2 }, props2 == null ? void 0 : props2.id)) });
};
const Link2 = (props2) => {
  const { children: children2 } = props2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Link$1, { ...props2, variant: LinkVariant.standalone, children: children2 });
};
const ListItem = React__default.forwardRef(
  ({
    children: children2 = void 0,
    className = void 0,
    color: color2 = TextColors.primary,
    sx: sx2 = {},
    variant: variant3 = void 0,
    ...rest
  }, ref2) => {
    const { style: style2 } = useStyle(sx2);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Text$1,
      {
        as: "li",
        className,
        color: color2,
        ref: ref2,
        sx: style2({ variant: `listItem.${variant3}` }),
        ...rest,
        children: children2
      }
    );
  }
);
const crumbDisplayName = "Crumb";
const Crumb = ({
  children: children2,
  isSingleChild = void 0,
  isLastChild = void 0
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isSingleChild ? children2 : /* @__PURE__ */ jsxRuntimeExports.jsx(
    ListItem,
    {
      "aria-current": isLastChild ? "page" : void 0,
      variant: ListItemVariants.unstyled,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Paragraph2,
        {
          color: TextColors.tertiary,
          "data-breadcrumb-type": "crumb",
          sx: { variant: "breadcrumbs.crumb.paragraph" },
          variant: ParagraphSizes.Paragraph14,
          children: children2
        }
      )
    }
  ) });
};
Crumb.displayName = crumbDisplayName;
const crumbLinkDisplayName = "CrumbLink";
const CrumbLink = (props2) => {
  const { children: children2, isSingleChild, isLastChild, pageTitle, ...restProps } = props2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Crumb, { ...restProps, children: isLastChild ? children2 : /* @__PURE__ */ jsxRuntimeExports.jsx(Link2, { ...restProps, children: children2 }) });
};
CrumbLink.displayName = crumbLinkDisplayName;
const isCrumbType = (component) => {
  if (!React__default.isValidElement(component)) {
    return false;
  }
  const { type: type2 } = component;
  if (typeof type2 === "string") {
    return false;
  }
  return "displayName" in type2 && (type2.displayName === crumbDisplayName || type2.displayName === crumbLinkDisplayName);
};
const Nav = ({
  children: children2,
  ariaLabel = "breadcrumbs"
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("nav", { "aria-label": ariaLabel, children: children2 });
const PageTitle = ({
  ariaCurrent = void 0,
  children: children2,
  size = TitleSizes$1.Title32
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { "aria-current": ariaCurrent, as: "div", variant: size, children: children2 });
};
const DefaultSeparator = () => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Icon,
  {
    color: "icon.subdued",
    name: "chevronRight",
    role: "presentation",
    size: IconSizes.Icon12
  }
);
const Breadcrumbs = ({
  children: children2,
  separator = /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultSeparator, {})
}) => {
  const {
    matchMediaQuery: { smDown }
  } = useMatchMedia();
  if (!children2) {
    return null;
  }
  const hasSingleCrumb = React__default.Children.count(children2) === 1;
  const createBreadcrumbComponents = () => {
    let lastCrumb2;
    const crumbsWithSeparators2 = React__default.Children.map(
      children2,
      (child, index2) => {
        let renderedChild = child;
        const isLastChild = index2 === React__default.Children.count(children2) - 1;
        const separatorElement = isLastChild ? null : separator;
        if (isCrumbType(child)) {
          const isSingleChild = hasSingleCrumb;
          renderedChild = React__default.cloneElement(child, {
            isSingleChild,
            isLastChild
          });
          if (isLastChild) {
            lastCrumb2 = child;
          }
        }
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          renderedChild,
          separatorElement ? /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { variant: ListItemVariants.unstyled, children: separatorElement }) : null
        ] });
      }
    );
    return {
      crumbsWithSeparators: crumbsWithSeparators2,
      lastCrumb: lastCrumb2
    };
  };
  const { crumbsWithSeparators, lastCrumb } = createBreadcrumbComponents();
  const renderTitle = lastCrumb && typeof lastCrumb === "object" && "props" in lastCrumb ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    PageTitle,
    {
      ...lastCrumb.props.pageTitleSize && {
        size: lastCrumb.props.pageTitleSize
      },
      children: lastCrumb.props.pageTitle ? lastCrumb.props.pageTitle : lastCrumb.props.children
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flexDirection: "column", sx: { variant: "breadcrumbs.container" }, children: hasSingleCrumb ? renderTitle : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !smDown && /* @__PURE__ */ jsxRuntimeExports.jsx(Nav, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex,
      {
        as: "ol",
        flexDirection: "row",
        sx: { variant: "breadcrumbs.navigationContainer" },
        children: crumbsWithSeparators
      }
    ) }),
    renderTitle
  ] }) });
};
Breadcrumbs.Crumb = Crumb;
Breadcrumbs.CrumbLink = CrumbLink;
Breadcrumbs.Link = Link2;
const Context$8 = React__default.createContext(void 0);
const CardProvider = ({ children: children2 }) => {
  const [hasHeader, setHasHeader] = useState(false);
  const memoizedContext = useMemo(
    () => ({
      hasHeader,
      setHasHeader
    }),
    [hasHeader]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$8.Provider, { value: memoizedContext, children: children2 });
};
const useCard = () => {
  const context = useContext(Context$8);
  if (context === void 0) {
    throw new Error("useCard must be used within a Card Provider");
  }
  return context;
};
const CardContent = ({
  children: children2 = null,
  flexDirection = "column",
  onClick = void 0,
  sx: sx2 = {},
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const { hasHeader } = useCard();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      flexDirection,
      sx: style2(styles$l(hasHeader)),
      ...onClick && { onClick },
      ...restOfProps,
      children: children2
    }
  );
};
const styles$l = (hasHeader) => ({
  p: "card.content.padding",
  pt: hasHeader ? "card.content.paddingTop" : "card.content.padding",
  pb: "card.content.paddingBottom"
});
const CardFooter = ({
  children: children2,
  withDivider = true,
  sx: sx2 = {}
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    withDivider && /* @__PURE__ */ jsxRuntimeExports.jsx(Divider$1, { variant: DividerVariant.secondary }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: style2(styles$k), children: children2 })
  ] });
};
const styles$k = {
  justifyContent: "flex-end",
  p: 1.5
};
const Context$7 = React__default.createContext(void 0);
const Provider = ({
  children: children2 = null,
  initiallyCollapsed = false
}) => {
  const [collapsed, setCollapsed] = useState(initiallyCollapsed);
  const [controlId] = useState(() => uniqueId$1("collapsible-control-"));
  const [contentId] = useState(() => uniqueId$1("collapsible-content-"));
  const isMountedRef = useIsMounted();
  const memoizedContext = useMemo(
    () => ({
      collapsed,
      expanded: !collapsed,
      expand: async (callbacks) => {
        var _a2, _b;
        try {
          await ((_a2 = callbacks == null ? void 0 : callbacks.onAction) == null ? void 0 : _a2.call(callbacks));
          isMountedRef.current && setCollapsed(false);
        } catch (e3) {
          (_b = callbacks == null ? void 0 : callbacks.onError) == null ? void 0 : _b.call(callbacks, e3);
        }
      },
      collapse: async (callbacks) => {
        var _a2, _b;
        try {
          await ((_a2 = callbacks == null ? void 0 : callbacks.onAction) == null ? void 0 : _a2.call(callbacks));
          isMountedRef.current && setCollapsed(true);
        } catch (e3) {
          (_b = callbacks == null ? void 0 : callbacks.onError) == null ? void 0 : _b.call(callbacks, e3);
        }
      },
      toggle: async (callbacks) => {
        var _a2, _b;
        try {
          await ((_a2 = callbacks == null ? void 0 : callbacks.onAction) == null ? void 0 : _a2.call(callbacks));
          isMountedRef.current && setCollapsed(!collapsed);
        } catch (e3) {
          (_b = callbacks == null ? void 0 : callbacks.onError) == null ? void 0 : _b.call(callbacks, e3);
        }
      },
      controlId,
      contentId
    }),
    [collapsed, controlId, contentId]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$7.Provider, { value: memoizedContext, children: children2 });
};
const useCollapsible = () => {
  const context = useContext(Context$7);
  if (context === void 0) {
    throw new Error("useCollapsed must be used within a Collapsible Provider");
  }
  return context;
};
var CollapsibleAction = /* @__PURE__ */ ((CollapsibleAction2) => {
  CollapsibleAction2[CollapsibleAction2["collapse"] = 0] = "collapse";
  CollapsibleAction2[CollapsibleAction2["expand"] = 1] = "expand";
  CollapsibleAction2[CollapsibleAction2["toggle"] = 2] = "toggle";
  CollapsibleAction2[CollapsibleAction2["none"] = 3] = "none";
  return CollapsibleAction2;
})(CollapsibleAction || {});
const CollapsibleControl = ({
  children: children2 = null,
  Component: Component2 = CompoundButton,
  onAction = noop$6,
  onError = noop$6,
  action: action2 = 3,
  ...props2
}) => {
  const { collapsed, collapse, expand: expand2, toggle, controlId, contentId } = useCollapsible();
  const onClick = () => {
    if (action2 === 0) {
      return collapse({ onAction, onError });
    } else if (action2 === 1) {
      return expand2({ onAction, onError });
    } else if (action2 === 2) {
      return toggle({ onAction, onError });
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Component2,
    {
      "aria-controls": contentId,
      "aria-expanded": collapsed ? "false" : "true",
      id: controlId,
      onClick,
      ...props2,
      children: children2
    }
  );
};
const AnimatedFlex$3 = animated(Flex);
const CollapsibleContent = ({
  animate = true,
  children: children2,
  sx: sx2 = {},
  ...props2
}) => {
  const { collapsed, controlId, contentId } = useCollapsible();
  const { style: style2 } = useStyle({}, props2);
  const isMountedRef = useIsMounted();
  const [shouldHide, setShouldHide] = useState(collapsed);
  const [ref2, springStyles] = useCollapsibleAnimation(collapsed, {
    animate,
    onRest: () => {
      if (collapsed) {
        isMountedRef.current && setShouldHide(true);
      }
    }
  });
  useEffect(() => {
    if (!collapsed) {
      setShouldHide(false);
    }
  }, [collapsed]);
  if (shouldHide && collapsed) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    AnimatedFlex$3,
    {
      "aria-labelledby": controlId,
      flexDirection: "column",
      id: contentId,
      role: "region",
      style: {
        ...springStyles
      },
      sx: {
        ...style2(),
        minWidth: "collapsibleContent.minWidth",
        position: "relative",
        overflow: "hidden",
        ...sx2
      },
      ...props2,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: ref2, children: children2 })
    }
  );
};
const Collapsible = ({
  children: children2,
  initiallyCollapsed = false
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Provider, { initiallyCollapsed, children: children2 });
};
Collapsible.Control = CollapsibleControl;
Collapsible.Content = CollapsibleContent;
const CardHeaderTitle = ({
  color: color2,
  size,
  title = "",
  tag: tag2 = void 0
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: mediaQueries2.xs ? "left" : "center",
      flexDirection: mediaQueries2.xs ? "column" : "row",
      spacing: 0.75,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Title,
          {
            as: "span",
            color: color2,
            variant: size,
            ...mediaQueries2.xs && { sx: { textAlign: "left" } },
            children: title
          }
        ),
        tag2
      ]
    }
  ) });
};
var CardHeaderCollapsibleStatus = /* @__PURE__ */ ((CardHeaderCollapsibleStatus2) => {
  CardHeaderCollapsibleStatus2["NotCollapsible"] = "NotCollapsible";
  CardHeaderCollapsibleStatus2["ExpandOnHeader"] = "ExpandOnHeader";
  CardHeaderCollapsibleStatus2["ToggleOnHeader"] = "ToggleOnHeader";
  CardHeaderCollapsibleStatus2["UserDefined"] = "UserDefined";
  return CardHeaderCollapsibleStatus2;
})(CardHeaderCollapsibleStatus || {});
const CollapsibleCardHeader = ({
  children: children2 = void 0,
  title = "",
  titleTag = void 0,
  rightContent = void 0,
  rightContentExpanded = void 0,
  sx: sx2 = {},
  disabled = false,
  canCollapseCard = "NotCollapsible",
  expandedTitleVariant = TitleSizes.Title24,
  collapsedTitleVariant = TitleSizes.Title16,
  onClick = void 0,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const { collapsed, toggle } = useCollapsible();
  const { titleColor, ...forwardedProps } = restOfProps;
  const finalTitleSize = collapsed ? collapsedTitleVariant : expandedTitleVariant;
  const toggleOnHeaderClick = !disabled && (canCollapseCard === "ExpandOnHeader" && collapsed || canCollapseCard === "ToggleOnHeader");
  const onKeyDown = (e3) => {
    if (e3.key === "Enter" || e3.key === " ") {
      onClick == null ? void 0 : onClick(e3);
      toggle();
    }
  };
  const expandableHeaderProps = (shouldExpand) => {
    if (shouldExpand && !disabled) {
      return {
        onKeyDown,
        tabIndex: 0,
        onClick: toggle,
        "aria-expanded": "false"
      };
    }
    return {};
  };
  if (children2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ...style2(styles$j.baseContainer) }, children: children2 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex$1,
    {
      as: toggleOnHeaderClick ? "button" : void 0,
      ...expandableHeaderProps(toggleOnHeaderClick),
      ...disabled && { disabled: true },
      ...onClick && { onClick },
      sx: {
        ...style2(styles$j.baseContainer),
        ...style2(styles$j.collapsibleContainer(toggleOnHeaderClick)),
        ...toggleOnHeaderClick && style2(styles$j.buttonReset),
        pb: collapsed ? "card.header.padding" : 0,
        transition: "card.header"
      },
      ...forwardedProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CardHeaderTitle,
          {
            color: disabled && collapsed ? TextColors.disable : TextColors.primary,
            size: finalTitleSize,
            tag: titleTag,
            title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "none", children: collapsed ? rightContent : rightContentExpanded })
      ]
    }
  ) });
};
const SimpleCardHeader = ({
  children: children2 = void 0,
  title = "",
  titleTag = void 0,
  disabled = false,
  rightContent = void 0,
  expandedTitleVariant = TitleSizes.Title16,
  titleColor = TextColors.primary,
  sx: sx2 = {},
  withDivider = false,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  if (children2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { ...style2(styles$j.baseContainer) }, children: children2 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Flex,
      {
        sx: { ...style2(styles$j.baseContainer), pb: withDivider ? 1 : 0 },
        ...restOfProps,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            CardHeaderTitle,
            {
              color: disabled ? TextColors.disable : titleColor,
              size: expandedTitleVariant,
              tag: titleTag,
              title
            }
          ),
          rightContent ? /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "none", children: rightContent }) : null
        ]
      }
    ),
    withDivider ? /* @__PURE__ */ jsxRuntimeExports.jsx(Divider$1, { sx: { mb: 0.5 }, variant: DividerVariant.secondary }) : null
  ] });
};
const CardHeader = ({
  canCollapseCard = "NotCollapsible",
  disabled = false,
  ...props2
}) => {
  const { setHasHeader } = useCard();
  useEffect(() => {
    setHasHeader(true);
    return () => setHasHeader(false);
  }, [setHasHeader]);
  if (canCollapseCard === "NotCollapsible") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SimpleCardHeader, { ...props2 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CollapsibleCardHeader,
    {
      canCollapseCard,
      disabled,
      ...props2
    }
  );
};
const styles$j = {
  baseContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    px: "card.header.padding",
    pt: "card.header.padding"
  },
  collapsibleContainer: (toggleOnHeaderClick) => ({
    cursor: toggleOnHeaderClick ? "pointer" : void 0,
    ":focus-visible": toggleOnHeaderClick ? {
      outline: "solid transparent",
      boxShadow: "two-pixel-soft",
      borderRadius: "card.container"
    } : void 0
  }),
  buttonReset: {
    background: "initial",
    border: "initial"
  }
};
const Card2 = ({
  children: children2 = null,
  sx: sx2 = {},
  variant: variant3 = CardVariants.shadow,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CardProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      flexDirection: "column",
      sx: sx2,
      variant: `card.${variant3}`,
      ...restOfProps,
      children: children2
    }
  ) });
};
Card2.Header = CardHeader;
Card2.Content = CardContent;
Card2.Footer = CardFooter;
const CheckboxIcon = ({
  checked,
  indeterminate,
  disabled
}) => {
  if (indeterminate) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        className: `guideline-ui--checkbox--indeterminate ${disabled ? "guideline-ui--checkbox--disabled" : ""}`,
        "data-test-id": "indeterminate-icon",
        name: "indeterminateCheckbox",
        size: IconSizes.Icon20
      }
    );
  } else if (checked) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        className: disabled ? "guideline-ui--checkbox--disabled" : "",
        "data-test-id": "checked-icon",
        name: "checkedCheckbox",
        size: IconSizes.Icon20
      }
    );
  } else if (!checked) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        className: disabled ? "guideline-ui--checkbox--disabled" : "guideline-ui--checkbox--unchecked",
        "data-test-id": "unchecked-icon",
        name: "uncheckedCheckbox",
        size: IconSizes.Icon20
      }
    );
  } else
    return null;
};
function useCheckboxGuiForm(name2, value, isChecked, setChecked) {
  const guiForm = useGuiForm();
  const [hasChanged, setHasChanged] = useState(false);
  const guiFormInitialFieldValue = useMemo(() => {
    if (guiForm) {
      return getGuiFormFieldValue(guiForm, name2, value);
    }
    return null;
  }, [name2, value]);
  useEffect(() => {
    if (guiForm) {
      const guiFormInitialFieldValue2 = getGuiFormFieldValue(
        guiForm,
        name2,
        value
      );
      !!guiFormInitialFieldValue2 && setChecked(guiFormInitialFieldValue2);
    }
  }, [guiFormInitialFieldValue, name2, setChecked, value]);
  useEffect(() => {
    if (guiForm && hasChanged) {
      const { setValue, setTouched } = guiForm.getFieldHelpers(name2);
      const fieldProps = guiForm.getFieldProps(name2);
      setTouched(true);
      if (Array.isArray(fieldProps == null ? void 0 : fieldProps.value)) {
        const group = fieldProps.value;
        let updateGroup;
        if (isChecked) {
          updateGroup = group.find((item) => item === value) ? group : [...group, value];
        } else {
          updateGroup = group.filter((item) => item !== value);
        }
        setValue(updateGroup);
      } else {
        setValue(!fieldProps.value);
      }
    }
  }, [hasChanged, isChecked, name2, value]);
  return { setHasChanged };
}
const getGuiFormFieldValue = (guiForm, name2, value) => {
  var _a2;
  const fieldProps = guiForm.getFieldProps(name2);
  if (Array.isArray(fieldProps == null ? void 0 : fieldProps.value)) {
    const idx = (_a2 = fieldProps == null ? void 0 : fieldProps.value) == null ? void 0 : _a2.findIndex(
      (e3) => e3 === value
    );
    if (idx >= 0) {
      return fieldProps.value[idx];
    }
  } else {
    return fieldProps.value;
  }
};
const Checkbox = ({
  label: label2 = "",
  children: children2 = null,
  name: name2 = "",
  id = "",
  checked = false,
  indeterminate = false,
  disabled = false,
  onChange = noop$6,
  onClick = noop$6,
  sx: sx2 = {},
  value = "",
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const [isChecked, setChecked] = useState(checked);
  const { setHasChanged } = useCheckboxGuiForm(
    name2,
    value,
    isChecked,
    setChecked
  );
  useEffect(() => {
    if (checked != null && checked !== isChecked) {
      setChecked(checked);
      setHasChanged(true);
    }
  }, [checked]);
  const checkedCallback = useCallback(() => {
    if (disabled) {
      return null;
    }
    setChecked(!isChecked);
    setHasChanged(true);
  }, [disabled, isChecked, setHasChanged]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Label2,
    {
      color: disabled ? TextColors.disable : TextColors.primary,
      "data-checkbox-state": disabled ? "disabled" : "active",
      "data-test-id": `${name2}-label`,
      disallowSelect: true,
      htmlFor: id,
      onClick,
      sx: (theme2) => {
        var _a2;
        return style2((_a2 = theme2 == null ? void 0 : theme2.forms) == null ? void 0 : _a2.checkbox.default);
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "input",
          {
            "aria-checked": isChecked || (indeterminate ? "mixed" : false),
            checked: isChecked,
            "data-test-id": `${name2}-${value}-input`,
            disabled,
            id,
            name: name2,
            onChange: (e3) => onChange == null ? void 0 : onChange(e3),
            onClick: checkedCallback,
            type: "checkbox",
            value,
            ...restOfProps
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CheckboxIcon,
          {
            checked: isChecked,
            "data-test-id": `${name2}-icon`,
            disabled,
            indeterminate
          }
        ),
        label2 || children2
      ]
    }
  );
};
const CurrencyInput = ({
  prefix: prefix2 = "$",
  max: max2 = void 0,
  min: min2 = void 0,
  thousandsSeparator = ",",
  radix = ".",
  mapToRadix = ",",
  lazy = true,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: `${prefix2}num`,
        blocks: {
          num: {
            mask: Number,
            scale: 2,
            max: max2,
            min: min2,
            thousandsSeparator,
            radix,
            mapToRadix: [mapToRadix]
          }
        },
        lazy
      },
      ...props2
    }
  );
};
const PercentageInput = ({
  max: max2 = void 0,
  min: min2 = void 0,
  lazy = false,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: `num%`,
        blocks: {
          num: {
            mask: Number,
            max: max2,
            min: min2
          }
        },
        lazy
      },
      ...props2
    }
  );
};
const CounterBase = ({
  name: name2 = "counter",
  height = InputHeights.default,
  disabled = false,
  placeholder = void 0,
  floor = -Infinity,
  ceiling = Infinity,
  variant: variant3 = CounterVariant.default,
  containerSx = {},
  sx: sx2 = {},
  onChange = void 0,
  value = "",
  onIncrement = void 0,
  onDecrement = void 0
}) => {
  const incrementDisabled = disabled || value !== null && value !== void 0 && parseInt(value.replace(/[^\d-]/g, ""), 10) >= ceiling;
  const decrementDisabled = disabled || value !== null && value !== void 0 && parseInt(value.replace(/[^\d-]/g, ""), 10) <= floor;
  const InputComponent = useMemo(() => {
    if (variant3 === CounterVariant.percentage) {
      return PercentageInput;
    }
    if (variant3 === CounterVariant.currency) {
      return CurrencyInput;
    }
    return CompoundInputField;
  }, [variant3]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex$1,
    {
      sx: {
        [`& p[data-test-id='hint-text--${name2}']`]: {
          position: "absolute"
        },
        ...containerSx
      },
      variant: `counter.${variant3}`,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundButton,
          {
            "aria-label": `Decrement ${name2}`,
            disabled: decrementDisabled,
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Icon,
              {
                ...decrementDisabled && { color: "icon.subdued" },
                name: "minus",
                size: IconSizes.Icon16
              }
            ),
            onClick: onDecrement,
            shape: ButtonShape.circle,
            sx: styles$u.decrementButton,
            variant: ButtonVariant.secondary
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          InputComponent,
          {
            "aria-label": `Counter Input ${name2}`,
            disabled,
            height,
            inputMode: "numeric",
            max: ceiling,
            min: floor,
            name: name2,
            placeholder,
            sx: sx2,
            sxInput: { element: styles$u.input },
            ...variant3 === CounterVariant.default && { value },
            ...onChange && { onChange }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundButton,
          {
            "aria-label": `Increment ${name2}`,
            disabled: incrementDisabled,
            icon: /* @__PURE__ */ jsxRuntimeExports.jsx(
              Icon,
              {
                ...incrementDisabled && { color: "icon.subdued" },
                name: "plus",
                size: IconSizes.Icon16
              }
            ),
            onClick: onIncrement,
            shape: ButtonShape.circle,
            sx: styles$u.incrementButton,
            variant: ButtonVariant.secondary
          }
        )
      ]
    }
  );
};
const ControlledCounter = (props2) => {
  const { stepSize = 1, variant: variant3 } = props2;
  const [currentValue, setCurrentValue] = useState(0);
  const incrementValue = useCallback(() => {
    const value = Number(currentValue);
    setCurrentValue(value ? value + stepSize : stepSize);
  }, [currentValue, stepSize]);
  const decrementValue = useCallback(() => {
    const value = Number(currentValue);
    setCurrentValue(value ? value - stepSize : -stepSize);
  }, [currentValue, stepSize]);
  const handleChange = useCallback(
    (e3) => {
      const target = e3.target;
      const regEx = new RegExp("^\\d+$");
      const valueWithoutSymbols = target.value.replace(/[^0-9]/g, "");
      if (regEx.test(valueWithoutSymbols)) {
        setCurrentValue(parseInt(valueWithoutSymbols, 10));
      } else {
        setCurrentValue(currentValue);
      }
    },
    [currentValue]
  );
  let formattedValue = currentValue;
  if (variant3 === CounterVariant.percentage) {
    formattedValue = `${currentValue}%`;
  }
  if (variant3 === CounterVariant.currency) {
    formattedValue = `$${currentValue}`;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CounterBase,
    {
      onChange: handleChange,
      onDecrement: decrementValue,
      onIncrement: incrementValue,
      value: `${formattedValue}`,
      ...props2,
      variant: CounterVariant.default
    }
  );
};
var withSelector = { exports: {} };
var withSelector_production_min = {};
var shim = { exports: {} };
var useSyncExternalStoreShim_production_min = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_production_min;
function requireUseSyncExternalStoreShim_production_min() {
  if (hasRequiredUseSyncExternalStoreShim_production_min)
    return useSyncExternalStoreShim_production_min;
  hasRequiredUseSyncExternalStoreShim_production_min = 1;
  var e3 = React__default;
  function h3(a4, b10) {
    return a4 === b10 && (0 !== a4 || 1 / a4 === 1 / b10) || a4 !== a4 && b10 !== b10;
  }
  var k3 = "function" === typeof Object.is ? Object.is : h3, l = e3.useState, m3 = e3.useEffect, n = e3.useLayoutEffect, p = e3.useDebugValue;
  function q2(a4, b10) {
    var d3 = b10(), f = l({ inst: { value: d3, getSnapshot: b10 } }), c7 = f[0].inst, g2 = f[1];
    n(function() {
      c7.value = d3;
      c7.getSnapshot = b10;
      r(c7) && g2({ inst: c7 });
    }, [a4, d3, b10]);
    m3(function() {
      r(c7) && g2({ inst: c7 });
      return a4(function() {
        r(c7) && g2({ inst: c7 });
      });
    }, [a4]);
    p(d3);
    return d3;
  }
  function r(a4) {
    var b10 = a4.getSnapshot;
    a4 = a4.value;
    try {
      var d3 = b10();
      return !k3(a4, d3);
    } catch (f) {
      return true;
    }
  }
  function t2(a4, b10) {
    return b10();
  }
  var u2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? t2 : q2;
  useSyncExternalStoreShim_production_min.useSyncExternalStore = void 0 !== e3.useSyncExternalStore ? e3.useSyncExternalStore : u2;
  return useSyncExternalStoreShim_production_min;
}
var useSyncExternalStoreShim_development = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development)
    return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React2 = React__default;
      var ReactSharedInternals = React2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function error2(format2) {
        {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format2, args);
          }
        }
      }
      function printWarning(level, format2, args) {
        {
          var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
          var stack2 = ReactDebugCurrentFrame.getStackAddendum();
          if (stack2 !== "") {
            format2 += "%s";
            args = args.concat([stack2]);
          }
          var argsWithFormat = args.map(function(item) {
            return String(item);
          });
          argsWithFormat.unshift("Warning: " + format2);
          Function.prototype.apply.call(console[level], console, argsWithFormat);
        }
      }
      function is3(x3, y4) {
        return x3 === y4 && (x3 !== 0 || 1 / x3 === 1 / y4) || x3 !== x3 && y4 !== y4;
      }
      var objectIs2 = typeof Object.is === "function" ? Object.is : is3;
      var useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
      var didWarnOld18Alpha = false;
      var didWarnUncachedGetSnapshot = false;
      function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        {
          if (!didWarnOld18Alpha) {
            if (React2.startTransition !== void 0) {
              didWarnOld18Alpha = true;
              error2("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
          }
        }
        var value = getSnapshot();
        {
          if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs2(value, cachedValue)) {
              error2("The result of getSnapshot should be cached to avoid an infinite loop");
              didWarnUncachedGetSnapshot = true;
            }
          }
        }
        var _useState = useState2({
          inst: {
            value,
            getSnapshot
          }
        }), inst = _useState[0].inst, forceUpdate = _useState[1];
        useLayoutEffect2(function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
        }, [subscribe, value, getSnapshot]);
        useEffect2(function() {
          if (checkIfSnapshotChanged(inst)) {
            forceUpdate({
              inst
            });
          }
          var handleStoreChange = function() {
            if (checkIfSnapshotChanged(inst)) {
              forceUpdate({
                inst
              });
            }
          };
          return subscribe(handleStoreChange);
        }, [subscribe]);
        useDebugValue(value);
        return value;
      }
      function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
          var nextValue = latestGetSnapshot();
          return !objectIs2(prevValue, nextValue);
        } catch (error3) {
          return true;
        }
      }
      function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        return getSnapshot();
      }
      var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
      var isServerEnvironment = !canUseDOM;
      var shim2 = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
      var useSyncExternalStore$2 = React2.useSyncExternalStore !== void 0 ? React2.useSyncExternalStore : shim2;
      useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return useSyncExternalStoreShim_development;
}
if (process.env.NODE_ENV === "production") {
  shim.exports = requireUseSyncExternalStoreShim_production_min();
} else {
  shim.exports = requireUseSyncExternalStoreShim_development();
}
var shimExports = shim.exports;
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_production_min;
function requireWithSelector_production_min() {
  if (hasRequiredWithSelector_production_min)
    return withSelector_production_min;
  hasRequiredWithSelector_production_min = 1;
  var h3 = React__default, n = shimExports;
  function p(a4, b10) {
    return a4 === b10 && (0 !== a4 || 1 / a4 === 1 / b10) || a4 !== a4 && b10 !== b10;
  }
  var q2 = "function" === typeof Object.is ? Object.is : p, r = n.useSyncExternalStore, t2 = h3.useRef, u2 = h3.useEffect, v = h3.useMemo, w2 = h3.useDebugValue;
  withSelector_production_min.useSyncExternalStoreWithSelector = function(a4, b10, e3, l, g2) {
    var c7 = t2(null);
    if (null === c7.current) {
      var f = { hasValue: false, value: null };
      c7.current = f;
    } else
      f = c7.current;
    c7 = v(function() {
      function a5(a6) {
        if (!c8) {
          c8 = true;
          d4 = a6;
          a6 = l(a6);
          if (void 0 !== g2 && f.hasValue) {
            var b11 = f.value;
            if (g2(b11, a6))
              return k3 = b11;
          }
          return k3 = a6;
        }
        b11 = k3;
        if (q2(d4, a6))
          return b11;
        var e4 = l(a6);
        if (void 0 !== g2 && g2(b11, e4))
          return b11;
        d4 = a6;
        return k3 = e4;
      }
      var c8 = false, d4, k3, m3 = void 0 === e3 ? null : e3;
      return [function() {
        return a5(b10());
      }, null === m3 ? void 0 : function() {
        return a5(m3());
      }];
    }, [b10, e3, l, g2]);
    var d3 = r(a4, c7[0], c7[1]);
    u2(function() {
      f.hasValue = true;
      f.value = d3;
    }, [d3]);
    w2(d3);
    return d3;
  };
  return withSelector_production_min;
}
var withSelector_development = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredWithSelector_development;
function requireWithSelector_development() {
  if (hasRequiredWithSelector_development)
    return withSelector_development;
  hasRequiredWithSelector_development = 1;
  if (process.env.NODE_ENV !== "production") {
    (function() {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      }
      var React2 = React__default;
      var shim2 = shimExports;
      function is3(x3, y4) {
        return x3 === y4 && (x3 !== 0 || 1 / x3 === 1 / y4) || x3 !== x3 && y4 !== y4;
      }
      var objectIs2 = typeof Object.is === "function" ? Object.is : is3;
      var useSyncExternalStore = shim2.useSyncExternalStore;
      var useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
      function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual7) {
        var instRef = useRef2(null);
        var inst;
        if (instRef.current === null) {
          inst = {
            hasValue: false,
            value: null
          };
          instRef.current = inst;
        } else {
          inst = instRef.current;
        }
        var _useMemo = useMemo2(function() {
          var hasMemo = false;
          var memoizedSnapshot;
          var memoizedSelection;
          var memoizedSelector = function(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              var _nextSelection = selector(nextSnapshot);
              if (isEqual7 !== void 0) {
                if (inst.hasValue) {
                  var currentSelection = inst.value;
                  if (isEqual7(currentSelection, _nextSelection)) {
                    memoizedSelection = currentSelection;
                    return currentSelection;
                  }
                }
              }
              memoizedSelection = _nextSelection;
              return _nextSelection;
            }
            var prevSnapshot = memoizedSnapshot;
            var prevSelection = memoizedSelection;
            if (objectIs2(prevSnapshot, nextSnapshot)) {
              return prevSelection;
            }
            var nextSelection = selector(nextSnapshot);
            if (isEqual7 !== void 0 && isEqual7(prevSelection, nextSelection)) {
              return prevSelection;
            }
            memoizedSnapshot = nextSnapshot;
            memoizedSelection = nextSelection;
            return nextSelection;
          };
          var maybeGetServerSnapshot = getServerSnapshot === void 0 ? null : getServerSnapshot;
          var getSnapshotWithSelector = function() {
            return memoizedSelector(getSnapshot());
          };
          var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          };
          return [getSnapshotWithSelector, getServerSnapshotWithSelector];
        }, [getSnapshot, getServerSnapshot, selector, isEqual7]), getSelection = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect2(function() {
          inst.hasValue = true;
          inst.value = value;
        }, [value]);
        useDebugValue(value);
        return value;
      }
      withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }
    })();
  }
  return withSelector_development;
}
if (process.env.NODE_ENV === "production") {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}
var withSelectorExports = withSelector.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s4, i2 = 1, n = arguments.length; i2 < n; i2++) {
      s4 = arguments[i2];
      for (var p in s4)
        if (Object.prototype.hasOwnProperty.call(s4, p))
          t2[p] = s4[p];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __rest$1(s4, e3) {
  var t2 = {};
  for (var p in s4)
    if (Object.prototype.hasOwnProperty.call(s4, p) && e3.indexOf(p) < 0)
      t2[p] = s4[p];
  if (s4 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s4); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s4, p[i2]))
        t2[p[i2]] = s4[p[i2]];
    }
  return t2;
}
function __values(o) {
  var s4 = typeof Symbol === "function" && Symbol.iterator, m3 = s4 && o[s4], i2 = 0;
  if (m3)
    return m3.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s4 ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read$1(o, n) {
  var m3 = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m3)
    return o;
  var i2 = m3.call(o), r, ar = [], e3;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i2.next()).done)
      ar.push(r.value);
  } catch (error2) {
    e3 = { error: error2 };
  } finally {
    try {
      if (r && !r.done && (m3 = i2["return"]))
        m3.call(i2);
    } finally {
      if (e3)
        throw e3.error;
    }
  }
  return ar;
}
function __spreadArray(to2, from2, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l = from2.length, ar; i2 < l; i2++) {
      if (ar || !(i2 in from2)) {
        if (!ar)
          ar = Array.prototype.slice.call(from2, 0, i2);
        ar[i2] = from2[i2];
      }
    }
  return to2.concat(ar || Array.prototype.slice.call(from2));
}
var ActionTypes$1;
(function(ActionTypes2) {
  ActionTypes2["Start"] = "xstate.start";
  ActionTypes2["Stop"] = "xstate.stop";
  ActionTypes2["Raise"] = "xstate.raise";
  ActionTypes2["Send"] = "xstate.send";
  ActionTypes2["Cancel"] = "xstate.cancel";
  ActionTypes2["NullEvent"] = "";
  ActionTypes2["Assign"] = "xstate.assign";
  ActionTypes2["After"] = "xstate.after";
  ActionTypes2["DoneState"] = "done.state";
  ActionTypes2["DoneInvoke"] = "done.invoke";
  ActionTypes2["Log"] = "xstate.log";
  ActionTypes2["Init"] = "xstate.init";
  ActionTypes2["Invoke"] = "xstate.invoke";
  ActionTypes2["ErrorExecution"] = "error.execution";
  ActionTypes2["ErrorCommunication"] = "error.communication";
  ActionTypes2["ErrorPlatform"] = "error.platform";
  ActionTypes2["ErrorCustom"] = "xstate.error";
  ActionTypes2["Update"] = "xstate.update";
  ActionTypes2["Pure"] = "xstate.pure";
  ActionTypes2["Choose"] = "xstate.choose";
})(ActionTypes$1 || (ActionTypes$1 = {}));
var SpecialTargets;
(function(SpecialTargets2) {
  SpecialTargets2["Parent"] = "#_parent";
  SpecialTargets2["Internal"] = "#_internal";
})(SpecialTargets || (SpecialTargets = {}));
var start$1 = ActionTypes$1.Start;
var stop$1 = ActionTypes$1.Stop;
var raise$1 = ActionTypes$1.Raise;
var send$1 = ActionTypes$1.Send;
var cancel$1 = ActionTypes$1.Cancel;
var nullEvent = ActionTypes$1.NullEvent;
var assign$2 = ActionTypes$1.Assign;
ActionTypes$1.After;
ActionTypes$1.DoneState;
var log$1 = ActionTypes$1.Log;
var init = ActionTypes$1.Init;
var invoke = ActionTypes$1.Invoke;
ActionTypes$1.ErrorExecution;
var errorPlatform = ActionTypes$1.ErrorPlatform;
var error$1 = ActionTypes$1.ErrorCustom;
var update = ActionTypes$1.Update;
var choose = ActionTypes$1.Choose;
var pure = ActionTypes$1.Pure;
var STATE_DELIMITER = ".";
var EMPTY_ACTIVITY_MAP = {};
var DEFAULT_GUARD_TYPE = "xstate.guard";
var TARGETLESS_KEY = "";
var IS_PRODUCTION = process.env.NODE_ENV === "production";
var _a;
function matchesState(parentStateId, childStateId, delimiter2) {
  if (delimiter2 === void 0) {
    delimiter2 = STATE_DELIMITER;
  }
  var parentStateValue = toStateValue(parentStateId, delimiter2);
  var childStateValue = toStateValue(childStateId, delimiter2);
  if (isString$1(childStateValue)) {
    if (isString$1(parentStateValue)) {
      return childStateValue === parentStateValue;
    }
    return false;
  }
  if (isString$1(parentStateValue)) {
    return parentStateValue in childStateValue;
  }
  return Object.keys(parentStateValue).every(function(key) {
    if (!(key in childStateValue)) {
      return false;
    }
    return matchesState(parentStateValue[key], childStateValue[key]);
  });
}
function getEventType(event2) {
  try {
    return isString$1(event2) || typeof event2 === "number" ? "".concat(event2) : event2.type;
  } catch (e3) {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function toStatePath(stateId, delimiter2) {
  try {
    if (isArray$e(stateId)) {
      return stateId;
    }
    return stateId.toString().split(delimiter2);
  } catch (e3) {
    throw new Error("'".concat(stateId, "' is not a valid state path."));
  }
}
function isStateLike(state) {
  return typeof state === "object" && "value" in state && "context" in state && "event" in state && "_event" in state;
}
function toStateValue(stateValue, delimiter2) {
  if (isStateLike(stateValue)) {
    return stateValue.value;
  }
  if (isArray$e(stateValue)) {
    return pathToStateValue(stateValue);
  }
  if (typeof stateValue !== "string") {
    return stateValue;
  }
  var statePath = toStatePath(stateValue, delimiter2);
  return pathToStateValue(statePath);
}
function pathToStateValue(statePath) {
  if (statePath.length === 1) {
    return statePath[0];
  }
  var value = {};
  var marker = value;
  for (var i2 = 0; i2 < statePath.length - 1; i2++) {
    if (i2 === statePath.length - 2) {
      marker[statePath[i2]] = statePath[i2 + 1];
    } else {
      marker[statePath[i2]] = {};
      marker = marker[statePath[i2]];
    }
  }
  return value;
}
function mapValues(collection, iteratee) {
  var result = {};
  var collectionKeys = Object.keys(collection);
  for (var i2 = 0; i2 < collectionKeys.length; i2++) {
    var key = collectionKeys[i2];
    result[key] = iteratee(collection[key], key, collection, i2);
  }
  return result;
}
function mapFilterValues(collection, iteratee, predicate) {
  var e_1, _a2;
  var result = {};
  try {
    for (var _b = __values(Object.keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var item = collection[key];
      if (!predicate(item)) {
        continue;
      }
      result[key] = iteratee(item, key, collection);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b.return))
        _a2.call(_b);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return result;
}
var path = function(props2) {
  return function(object2) {
    var e_2, _a2;
    var result = object2;
    try {
      for (var props_1 = __values(props2), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
        var prop = props_1_1.value;
        result = result[prop];
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (props_1_1 && !props_1_1.done && (_a2 = props_1.return))
          _a2.call(props_1);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    return result;
  };
};
function nestedPath(props2, accessorProp) {
  return function(object2) {
    var e_3, _a2;
    var result = object2;
    try {
      for (var props_2 = __values(props2), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()) {
        var prop = props_2_1.value;
        result = result[accessorProp][prop];
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (props_2_1 && !props_2_1.done && (_a2 = props_2.return))
          _a2.call(props_2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    return result;
  };
}
function toStatePaths(stateValue) {
  if (!stateValue) {
    return [[]];
  }
  if (isString$1(stateValue)) {
    return [[stateValue]];
  }
  var result = flatten$2(Object.keys(stateValue).map(function(key) {
    var subStateValue = stateValue[key];
    if (typeof subStateValue !== "string" && (!subStateValue || !Object.keys(subStateValue).length)) {
      return [[key]];
    }
    return toStatePaths(stateValue[key]).map(function(subPath) {
      return [key].concat(subPath);
    });
  }));
  return result;
}
function flatten$2(array2) {
  var _a2;
  return (_a2 = []).concat.apply(_a2, __spreadArray([], __read$1(array2), false));
}
function toArrayStrict(value) {
  if (isArray$e(value)) {
    return value;
  }
  return [value];
}
function toArray$2(value) {
  if (value === void 0) {
    return [];
  }
  return toArrayStrict(value);
}
function mapContext(mapper, context, _event) {
  var e_5, _a2;
  if (isFunction$5(mapper)) {
    return mapper(context, _event.data);
  }
  var result = {};
  try {
    for (var _b = __values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()) {
      var key = _c.value;
      var subMapper = mapper[key];
      if (isFunction$5(subMapper)) {
        result[key] = subMapper(context, _event.data);
      } else {
        result[key] = subMapper;
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a2 = _b.return))
        _a2.call(_b);
    } finally {
      if (e_5)
        throw e_5.error;
    }
  }
  return result;
}
function isBuiltInEvent(eventType) {
  return /^(done|error)\./.test(eventType);
}
function isPromiseLike(value) {
  if (value instanceof Promise) {
    return true;
  }
  if (value !== null && (isFunction$5(value) || typeof value === "object") && isFunction$5(value.then)) {
    return true;
  }
  return false;
}
function isBehavior(value) {
  return value !== null && typeof value === "object" && "transition" in value && typeof value.transition === "function";
}
function partition(items, predicate) {
  var e_6, _a2;
  var _b = __read$1([[], []], 2), truthy = _b[0], falsy = _b[1];
  try {
    for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
      var item = items_1_1.value;
      if (predicate(item)) {
        truthy.push(item);
      } else {
        falsy.push(item);
      }
    }
  } catch (e_6_1) {
    e_6 = {
      error: e_6_1
    };
  } finally {
    try {
      if (items_1_1 && !items_1_1.done && (_a2 = items_1.return))
        _a2.call(items_1);
    } finally {
      if (e_6)
        throw e_6.error;
    }
  }
  return [truthy, falsy];
}
function updateHistoryStates(hist, stateValue) {
  return mapValues(hist.states, function(subHist, key) {
    if (!subHist) {
      return void 0;
    }
    var subStateValue = (isString$1(stateValue) ? void 0 : stateValue[key]) || (subHist ? subHist.current : void 0);
    if (!subStateValue) {
      return void 0;
    }
    return {
      current: subStateValue,
      states: updateHistoryStates(subHist, subStateValue)
    };
  });
}
function updateHistoryValue(hist, stateValue) {
  return {
    current: stateValue,
    states: updateHistoryStates(hist, stateValue)
  };
}
function updateContext(context, _event, assignActions, state) {
  if (!IS_PRODUCTION) {
    warn$1(!!context, "Attempting to update undefined context");
  }
  var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
    var e_7, _a2;
    var assignment = assignAction.assignment;
    var meta = {
      state,
      action: assignAction,
      _event
    };
    var partialUpdate = {};
    if (isFunction$5(assignment)) {
      partialUpdate = assignment(acc, _event.data, meta);
    } else {
      try {
        for (var _b = __values(Object.keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var key = _c.value;
          var propAssignment = assignment[key];
          partialUpdate[key] = isFunction$5(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_7)
            throw e_7.error;
        }
      }
    }
    return Object.assign({}, acc, partialUpdate);
  }, context) : context;
  return updatedContext;
}
var warn$1 = function() {
};
if (!IS_PRODUCTION) {
  warn$1 = function(condition, message) {
    var error2 = condition instanceof Error ? condition : void 0;
    if (!error2 && condition) {
      return;
    }
    if (console !== void 0) {
      var args = ["Warning: ".concat(message)];
      if (error2) {
        args.push(error2);
      }
      console.warn.apply(console, args);
    }
  };
}
function isArray$e(value) {
  return Array.isArray(value);
}
function isFunction$5(value) {
  return typeof value === "function";
}
function isString$1(value) {
  return typeof value === "string";
}
function toGuard(condition, guardMap) {
  if (!condition) {
    return void 0;
  }
  if (isString$1(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition,
      predicate: guardMap ? guardMap[condition] : void 0
    };
  }
  if (isFunction$5(condition)) {
    return {
      type: DEFAULT_GUARD_TYPE,
      name: condition.name,
      predicate: condition
    };
  }
  return condition;
}
function isObservable(value) {
  try {
    return "subscribe" in value && isFunction$5(value.subscribe);
  } catch (e3) {
    return false;
  }
}
var symbolObservable = /* @__PURE__ */ function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
_a = {}, _a[symbolObservable] = function() {
  return this;
}, _a[Symbol.observable] = function() {
  return this;
}, _a;
function isMachine(value) {
  return !!value && "__xstatenode" in value;
}
function isActor$1(value) {
  return !!value && typeof value.send === "function";
}
function toEventObject(event2, payload) {
  if (isString$1(event2) || typeof event2 === "number") {
    return __assign$1({
      type: event2
    }, payload);
  }
  return event2;
}
function toSCXMLEvent(event2, scxmlEvent) {
  if (!isString$1(event2) && "$$type" in event2 && event2.$$type === "scxml") {
    return event2;
  }
  var eventObject = toEventObject(event2);
  return __assign$1({
    name: eventObject.type,
    data: eventObject,
    $$type: "scxml",
    type: "external"
  }, scxmlEvent);
}
function toTransitionConfigArray(event2, configLike) {
  var transitions2 = toArrayStrict(configLike).map(function(transitionLike) {
    if (typeof transitionLike === "undefined" || typeof transitionLike === "string" || isMachine(transitionLike)) {
      return {
        target: transitionLike,
        event: event2
      };
    }
    return __assign$1(__assign$1({}, transitionLike), {
      event: event2
    });
  });
  return transitions2;
}
function normalizeTarget(target) {
  if (target === void 0 || target === TARGETLESS_KEY) {
    return void 0;
  }
  return toArray$2(target);
}
function reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
  if (!IS_PRODUCTION) {
    var originalStackTrace = originalError.stack ? " Stacktrace was '".concat(originalError.stack, "'") : "";
    if (originalError === currentError) {
      console.error("Missing onError handler for invocation '".concat(id, "', error was '").concat(originalError, "'.").concat(originalStackTrace));
    } else {
      var stackTrace = currentError.stack ? " Stacktrace was '".concat(currentError.stack, "'") : "";
      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(id, "'. ") + "Original error: '".concat(originalError, "'. ").concat(originalStackTrace, " Current error is '").concat(currentError, "'.").concat(stackTrace));
    }
  }
}
function evaluateGuard(machine, guard, context, _event, state) {
  var guards = machine.options.guards;
  var guardMeta = {
    state,
    cond: guard,
    _event
  };
  if (guard.type === DEFAULT_GUARD_TYPE) {
    return ((guards === null || guards === void 0 ? void 0 : guards[guard.name]) || guard.predicate)(context, _event.data, guardMeta);
  }
  var condFn = guards === null || guards === void 0 ? void 0 : guards[guard.type];
  if (!condFn) {
    throw new Error("Guard '".concat(guard.type, "' is not implemented on machine '").concat(machine.id, "'."));
  }
  return condFn(context, _event.data, guardMeta);
}
function toInvokeSource$1(src) {
  if (typeof src === "string") {
    return {
      type: src
    };
  }
  return src;
}
function toObserver(nextHandler, errorHandler, completionHandler) {
  var noop2 = function() {
  };
  var isObserver = typeof nextHandler === "object";
  var self2 = isObserver ? nextHandler : null;
  return {
    next: ((isObserver ? nextHandler.next : nextHandler) || noop2).bind(self2),
    error: ((isObserver ? nextHandler.error : errorHandler) || noop2).bind(self2),
    complete: ((isObserver ? nextHandler.complete : completionHandler) || noop2).bind(self2)
  };
}
function createInvokeId(stateNodeId, index2) {
  return "".concat(stateNodeId, ":invocation[").concat(index2, "]");
}
function isRaisableAction(action2) {
  return (action2.type === raise$1 || action2.type === send$1 && action2.to === SpecialTargets.Internal) && typeof action2.delay !== "number";
}
var initEvent = /* @__PURE__ */ toSCXMLEvent({
  type: init
});
function getActionFunction(actionType, actionFunctionMap) {
  return actionFunctionMap ? actionFunctionMap[actionType] || void 0 : void 0;
}
function toActionObject(action2, actionFunctionMap) {
  var actionObject;
  if (isString$1(action2) || typeof action2 === "number") {
    var exec = getActionFunction(action2, actionFunctionMap);
    if (isFunction$5(exec)) {
      actionObject = {
        type: action2,
        exec
      };
    } else if (exec) {
      actionObject = exec;
    } else {
      actionObject = {
        type: action2,
        exec: void 0
      };
    }
  } else if (isFunction$5(action2)) {
    actionObject = {
      // Convert action to string if unnamed
      type: action2.name || action2.toString(),
      exec: action2
    };
  } else {
    var exec = getActionFunction(action2.type, actionFunctionMap);
    if (isFunction$5(exec)) {
      actionObject = __assign$1(__assign$1({}, action2), {
        exec
      });
    } else if (exec) {
      var actionType = exec.type || action2.type;
      actionObject = __assign$1(__assign$1(__assign$1({}, exec), action2), {
        type: actionType
      });
    } else {
      actionObject = action2;
    }
  }
  return actionObject;
}
var toActionObjects = function(action2, actionFunctionMap) {
  if (!action2) {
    return [];
  }
  var actions = isArray$e(action2) ? action2 : [action2];
  return actions.map(function(subAction) {
    return toActionObject(subAction, actionFunctionMap);
  });
};
function toActivityDefinition(action2) {
  var actionObject = toActionObject(action2);
  return __assign$1(__assign$1({
    id: isString$1(action2) ? action2 : actionObject.id
  }, actionObject), {
    type: actionObject.type
  });
}
function raise(event2, options2) {
  return {
    type: raise$1,
    event: typeof event2 === "function" ? event2 : toEventObject(event2),
    delay: options2 ? options2.delay : void 0,
    id: options2 === null || options2 === void 0 ? void 0 : options2.id
  };
}
function resolveRaise(action2, ctx2, _event, delaysMap) {
  var meta = {
    _event
  };
  var resolvedEvent = toSCXMLEvent(isFunction$5(action2.event) ? action2.event(ctx2, _event.data, meta) : action2.event);
  var resolvedDelay;
  if (isString$1(action2.delay)) {
    var configDelay = delaysMap && delaysMap[action2.delay];
    resolvedDelay = isFunction$5(configDelay) ? configDelay(ctx2, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction$5(action2.delay) ? action2.delay(ctx2, _event.data, meta) : action2.delay;
  }
  return __assign$1(__assign$1({}, action2), {
    type: raise$1,
    _event: resolvedEvent,
    delay: resolvedDelay
  });
}
function send(event2, options2) {
  return {
    to: options2 ? options2.to : void 0,
    type: send$1,
    event: isFunction$5(event2) ? event2 : toEventObject(event2),
    delay: options2 ? options2.delay : void 0,
    // TODO: don't auto-generate IDs here like that
    // there is too big chance of the ID collision
    id: options2 && options2.id !== void 0 ? options2.id : isFunction$5(event2) ? event2.name : getEventType(event2)
  };
}
function resolveSend(action2, ctx2, _event, delaysMap) {
  var meta = {
    _event
  };
  var resolvedEvent = toSCXMLEvent(isFunction$5(action2.event) ? action2.event(ctx2, _event.data, meta) : action2.event);
  var resolvedDelay;
  if (isString$1(action2.delay)) {
    var configDelay = delaysMap && delaysMap[action2.delay];
    resolvedDelay = isFunction$5(configDelay) ? configDelay(ctx2, _event.data, meta) : configDelay;
  } else {
    resolvedDelay = isFunction$5(action2.delay) ? action2.delay(ctx2, _event.data, meta) : action2.delay;
  }
  var resolvedTarget = isFunction$5(action2.to) ? action2.to(ctx2, _event.data, meta) : action2.to;
  return __assign$1(__assign$1({}, action2), {
    to: resolvedTarget,
    _event: resolvedEvent,
    event: resolvedEvent.data,
    delay: resolvedDelay
  });
}
var resolveLog = function(action2, ctx2, _event) {
  return __assign$1(__assign$1({}, action2), {
    value: isString$1(action2.expr) ? action2.expr : action2.expr(ctx2, _event.data, {
      _event
    })
  });
};
var cancel = function(sendId) {
  return {
    type: cancel$1,
    sendId
  };
};
function start(activity) {
  var activityDef = toActivityDefinition(activity);
  return {
    type: ActionTypes$1.Start,
    activity: activityDef,
    exec: void 0
  };
}
function stop(actorRef) {
  var activity = isFunction$5(actorRef) ? actorRef : toActivityDefinition(actorRef);
  return {
    type: ActionTypes$1.Stop,
    activity,
    exec: void 0
  };
}
function resolveStop(action2, context, _event) {
  var actorRefOrString = isFunction$5(action2.activity) ? action2.activity(context, _event.data) : action2.activity;
  var resolvedActorRef = typeof actorRefOrString === "string" ? {
    id: actorRefOrString
  } : actorRefOrString;
  var actionObject = {
    type: ActionTypes$1.Stop,
    activity: resolvedActorRef
  };
  return actionObject;
}
var assign$1 = function(assignment) {
  return {
    type: assign$2,
    assignment
  };
};
function after(delayRef, id) {
  var idSuffix = id ? "#".concat(id) : "";
  return "".concat(ActionTypes$1.After, "(").concat(delayRef, ")").concat(idSuffix);
}
function done(id, data) {
  var type2 = "".concat(ActionTypes$1.DoneState, ".").concat(id);
  var eventObject = {
    type: type2,
    data
  };
  eventObject.toString = function() {
    return type2;
  };
  return eventObject;
}
function doneInvoke(id, data) {
  var type2 = "".concat(ActionTypes$1.DoneInvoke, ".").concat(id);
  var eventObject = {
    type: type2,
    data
  };
  eventObject.toString = function() {
    return type2;
  };
  return eventObject;
}
function error(id, data) {
  var type2 = "".concat(ActionTypes$1.ErrorPlatform, ".").concat(id);
  var eventObject = {
    type: type2,
    data
  };
  eventObject.toString = function() {
    return type2;
  };
  return eventObject;
}
var pluckAssigns = function(actionBlocks) {
  var e_1, _a2;
  var assignActions = [];
  try {
    for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
      var block = actionBlocks_1_1.value;
      var i2 = 0;
      while (i2 < block.actions.length) {
        if (block.actions[i2].type === assign$2) {
          assignActions.push(block.actions[i2]);
          block.actions.splice(i2, 1);
          continue;
        }
        i2++;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a2 = actionBlocks_1.return))
        _a2.call(actionBlocks_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  return assignActions;
};
function resolveActions(machine, currentState, currentContext, _event, actionBlocks, predictableExec, preserveActionOrder) {
  if (preserveActionOrder === void 0) {
    preserveActionOrder = false;
  }
  var assignActions = preserveActionOrder ? [] : pluckAssigns(actionBlocks);
  var updatedContext = assignActions.length ? updateContext(currentContext, _event, assignActions, currentState) : currentContext;
  var preservedContexts = preserveActionOrder ? [currentContext] : void 0;
  var deferredToBlockEnd = [];
  function handleAction(blockType, actionObject) {
    var _a2;
    switch (actionObject.type) {
      case raise$1: {
        var raisedAction = resolveRaise(actionObject, updatedContext, _event, machine.options.delays);
        if (predictableExec && typeof raisedAction.delay === "number") {
          predictableExec(raisedAction, updatedContext, _event);
        }
        return raisedAction;
      }
      case send$1:
        var sendAction = resolveSend(actionObject, updatedContext, _event, machine.options.delays);
        if (!IS_PRODUCTION) {
          var configuredDelay = actionObject.delay;
          warn$1(
            !isString$1(configuredDelay) || typeof sendAction.delay === "number",
            // tslint:disable-next-line:max-line-length
            "No delay reference for delay expression '".concat(configuredDelay, "' was found on machine '").concat(machine.id, "'")
          );
        }
        if (predictableExec && sendAction.to !== SpecialTargets.Internal) {
          if (blockType === "entry") {
            deferredToBlockEnd.push(sendAction);
          } else {
            predictableExec(sendAction, updatedContext, _event);
          }
        }
        return sendAction;
      case log$1: {
        var resolved = resolveLog(actionObject, updatedContext, _event);
        predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, updatedContext, _event);
        return resolved;
      }
      case choose: {
        var chooseAction = actionObject;
        var matchedActions = (_a2 = chooseAction.conds.find(function(condition) {
          var guard = toGuard(condition.cond, machine.options.guards);
          return !guard || evaluateGuard(machine, guard, updatedContext, _event, !predictableExec ? currentState : void 0);
        })) === null || _a2 === void 0 ? void 0 : _a2.actions;
        if (!matchedActions) {
          return [];
        }
        var _b = __read$1(resolveActions(machine, currentState, updatedContext, _event, [{
          type: blockType,
          actions: toActionObjects(toArray$2(matchedActions), machine.options.actions)
        }], predictableExec, preserveActionOrder), 2), resolvedActionsFromChoose = _b[0], resolvedContextFromChoose = _b[1];
        updatedContext = resolvedContextFromChoose;
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        return resolvedActionsFromChoose;
      }
      case pure: {
        var matchedActions = actionObject.get(updatedContext, _event.data);
        if (!matchedActions) {
          return [];
        }
        var _c = __read$1(resolveActions(machine, currentState, updatedContext, _event, [{
          type: blockType,
          actions: toActionObjects(toArray$2(matchedActions), machine.options.actions)
        }], predictableExec, preserveActionOrder), 2), resolvedActionsFromPure = _c[0], resolvedContext = _c[1];
        updatedContext = resolvedContext;
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        return resolvedActionsFromPure;
      }
      case stop$1: {
        var resolved = resolveStop(actionObject, updatedContext, _event);
        predictableExec === null || predictableExec === void 0 ? void 0 : predictableExec(resolved, currentContext, _event);
        return resolved;
      }
      case assign$2: {
        updatedContext = updateContext(updatedContext, _event, [actionObject], !predictableExec ? currentState : void 0);
        preservedContexts === null || preservedContexts === void 0 ? void 0 : preservedContexts.push(updatedContext);
        break;
      }
      default:
        var resolvedActionObject = toActionObject(actionObject, machine.options.actions);
        var exec_1 = resolvedActionObject.exec;
        if (predictableExec) {
          predictableExec(resolvedActionObject, updatedContext, _event);
        } else if (exec_1 && preservedContexts) {
          var contextIndex_1 = preservedContexts.length - 1;
          var wrapped2 = __assign$1(__assign$1({}, resolvedActionObject), {
            exec: function(_ctx) {
              var args = [];
              for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
              }
              exec_1.apply(void 0, __spreadArray([preservedContexts[contextIndex_1]], __read$1(args), false));
            }
          });
          resolvedActionObject = wrapped2;
        }
        return resolvedActionObject;
    }
  }
  function processBlock(block) {
    var e_2, _a2;
    var resolvedActions2 = [];
    try {
      for (var _b = __values(block.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
        var action2 = _c.value;
        var resolved = handleAction(block.type, action2);
        if (resolved) {
          resolvedActions2 = resolvedActions2.concat(resolved);
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a2 = _b.return))
          _a2.call(_b);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    deferredToBlockEnd.forEach(function(action3) {
      predictableExec(action3, updatedContext, _event);
    });
    deferredToBlockEnd.length = 0;
    return resolvedActions2;
  }
  var resolvedActions = flatten$2(actionBlocks.map(processBlock));
  return [resolvedActions, updatedContext];
}
var provide = function(service, fn2) {
  var result = fn2(service);
  return result;
};
function createNullActor(id) {
  var _a2;
  return _a2 = {
    id,
    send: function() {
      return void 0;
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    },
    getSnapshot: function() {
      return void 0;
    },
    toJSON: function() {
      return {
        id
      };
    }
  }, _a2[symbolObservable] = function() {
    return this;
  }, _a2;
}
function createInvocableActor(invokeDefinition, machine, context, _event) {
  var _a2;
  var invokeSrc = toInvokeSource$1(invokeDefinition.src);
  var serviceCreator = (_a2 = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a2 === void 0 ? void 0 : _a2[invokeSrc.type];
  var resolvedData = invokeDefinition.data ? mapContext(invokeDefinition.data, context, _event) : void 0;
  var tempActor = serviceCreator ? createDeferredActor(serviceCreator, invokeDefinition.id, resolvedData) : createNullActor(invokeDefinition.id);
  tempActor.meta = invokeDefinition;
  return tempActor;
}
function createDeferredActor(entity, id, data) {
  var tempActor = createNullActor(id);
  tempActor.deferred = true;
  if (isMachine(entity)) {
    var initialState_1 = tempActor.state = provide(void 0, function() {
      return (data ? entity.withContext(data) : entity).initialState;
    });
    tempActor.getSnapshot = function() {
      return initialState_1;
    };
  }
  return tempActor;
}
function isActor(item) {
  try {
    return typeof item.send === "function";
  } catch (e3) {
    return false;
  }
}
function isSpawnedActor(item) {
  return isActor(item) && "id" in item;
}
function toActorRef(actorRefLike) {
  var _a2;
  return __assign$1((_a2 = {
    subscribe: function() {
      return {
        unsubscribe: function() {
          return void 0;
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
      return void 0;
    }
  }, _a2[symbolObservable] = function() {
    return this;
  }, _a2), actorRefLike);
}
var isLeafNode = function(stateNode) {
  return stateNode.type === "atomic" || stateNode.type === "final";
};
function getAllChildren(stateNode) {
  return Object.keys(stateNode.states).map(function(key) {
    return stateNode.states[key];
  });
}
function getChildren$1(stateNode) {
  return getAllChildren(stateNode).filter(function(sn) {
    return sn.type !== "history";
  });
}
function getAllStateNodes(stateNode) {
  var stateNodes = [stateNode];
  if (isLeafNode(stateNode)) {
    return stateNodes;
  }
  return stateNodes.concat(flatten$2(getChildren$1(stateNode).map(getAllStateNodes)));
}
function getConfiguration(prevStateNodes, stateNodes) {
  var e_1, _a2, e_2, _b, e_3, _c, e_4, _d;
  var prevConfiguration = new Set(prevStateNodes);
  var prevAdjList = getAdjList(prevConfiguration);
  var configuration = new Set(stateNodes);
  try {
    for (var configuration_1 = __values(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()) {
      var s4 = configuration_1_1.value;
      var m3 = s4.parent;
      while (m3 && !configuration.has(m3)) {
        configuration.add(m3);
        m3 = m3.parent;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (configuration_1_1 && !configuration_1_1.done && (_a2 = configuration_1.return))
        _a2.call(configuration_1);
    } finally {
      if (e_1)
        throw e_1.error;
    }
  }
  var adjList = getAdjList(configuration);
  try {
    for (var configuration_2 = __values(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()) {
      var s4 = configuration_2_1.value;
      if (s4.type === "compound" && (!adjList.get(s4) || !adjList.get(s4).length)) {
        if (prevAdjList.get(s4)) {
          prevAdjList.get(s4).forEach(function(sn) {
            return configuration.add(sn);
          });
        } else {
          s4.initialStateNodes.forEach(function(sn) {
            return configuration.add(sn);
          });
        }
      } else {
        if (s4.type === "parallel") {
          try {
            for (var _e = (e_3 = void 0, __values(getChildren$1(s4))), _f = _e.next(); !_f.done; _f = _e.next()) {
              var child = _f.value;
              if (!configuration.has(child)) {
                configuration.add(child);
                if (prevAdjList.get(child)) {
                  prevAdjList.get(child).forEach(function(sn) {
                    return configuration.add(sn);
                  });
                } else {
                  child.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                  });
                }
              }
            }
          } catch (e_3_1) {
            e_3 = {
              error: e_3_1
            };
          } finally {
            try {
              if (_f && !_f.done && (_c = _e.return))
                _c.call(_e);
            } finally {
              if (e_3)
                throw e_3.error;
            }
          }
        }
      }
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return))
        _b.call(configuration_2);
    } finally {
      if (e_2)
        throw e_2.error;
    }
  }
  try {
    for (var configuration_3 = __values(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()) {
      var s4 = configuration_3_1.value;
      var m3 = s4.parent;
      while (m3 && !configuration.has(m3)) {
        configuration.add(m3);
        m3 = m3.parent;
      }
    }
  } catch (e_4_1) {
    e_4 = {
      error: e_4_1
    };
  } finally {
    try {
      if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return))
        _d.call(configuration_3);
    } finally {
      if (e_4)
        throw e_4.error;
    }
  }
  return configuration;
}
function getValueFromAdj(baseNode, adjList) {
  var childStateNodes = adjList.get(baseNode);
  if (!childStateNodes) {
    return {};
  }
  if (baseNode.type === "compound") {
    var childStateNode = childStateNodes[0];
    if (childStateNode) {
      if (isLeafNode(childStateNode)) {
        return childStateNode.key;
      }
    } else {
      return {};
    }
  }
  var stateValue = {};
  childStateNodes.forEach(function(csn) {
    stateValue[csn.key] = getValueFromAdj(csn, adjList);
  });
  return stateValue;
}
function getAdjList(configuration) {
  var e_5, _a2;
  var adjList = /* @__PURE__ */ new Map();
  try {
    for (var configuration_4 = __values(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()) {
      var s4 = configuration_4_1.value;
      if (!adjList.has(s4)) {
        adjList.set(s4, []);
      }
      if (s4.parent) {
        if (!adjList.has(s4.parent)) {
          adjList.set(s4.parent, []);
        }
        adjList.get(s4.parent).push(s4);
      }
    }
  } catch (e_5_1) {
    e_5 = {
      error: e_5_1
    };
  } finally {
    try {
      if (configuration_4_1 && !configuration_4_1.done && (_a2 = configuration_4.return))
        _a2.call(configuration_4);
    } finally {
      if (e_5)
        throw e_5.error;
    }
  }
  return adjList;
}
function getValue$2(rootNode, configuration) {
  var config2 = getConfiguration([rootNode], configuration);
  return getValueFromAdj(rootNode, getAdjList(config2));
}
function has6(iterable, item) {
  if (Array.isArray(iterable)) {
    return iterable.some(function(member) {
      return member === item;
    });
  }
  if (iterable instanceof Set) {
    return iterable.has(item);
  }
  return false;
}
function nextEvents(configuration) {
  return __spreadArray([], __read$1(new Set(flatten$2(__spreadArray([], __read$1(configuration.map(function(sn) {
    return sn.ownEvents;
  })), false)))), false);
}
function isInFinalState(configuration, stateNode) {
  if (stateNode.type === "compound") {
    return getChildren$1(stateNode).some(function(s4) {
      return s4.type === "final" && has6(configuration, s4);
    });
  }
  if (stateNode.type === "parallel") {
    return getChildren$1(stateNode).every(function(sn) {
      return isInFinalState(configuration, sn);
    });
  }
  return false;
}
function getMeta(configuration) {
  if (configuration === void 0) {
    configuration = [];
  }
  return configuration.reduce(function(acc, stateNode) {
    if (stateNode.meta !== void 0) {
      acc[stateNode.id] = stateNode.meta;
    }
    return acc;
  }, {});
}
function getTagsFromConfiguration(configuration) {
  return new Set(flatten$2(configuration.map(function(sn) {
    return sn.tags;
  })));
}
function stateValuesEqual(a4, b10) {
  if (a4 === b10) {
    return true;
  }
  if (a4 === void 0 || b10 === void 0) {
    return false;
  }
  if (isString$1(a4) || isString$1(b10)) {
    return a4 === b10;
  }
  var aKeys = Object.keys(a4);
  var bKeys = Object.keys(b10);
  return aKeys.length === bKeys.length && aKeys.every(function(key) {
    return stateValuesEqual(a4[key], b10[key]);
  });
}
function isStateConfig(state) {
  if (typeof state !== "object" || state === null) {
    return false;
  }
  return "value" in state && "_event" in state;
}
function bindActionToState(action2, state) {
  var exec = action2.exec;
  var boundAction = __assign$1(__assign$1({}, action2), {
    exec: exec !== void 0 ? function() {
      return exec(state.context, state.event, {
        action: action2,
        state,
        _event: state._event
      });
    } : void 0
  });
  return boundAction;
}
var State$1 = (
  /** @class */
  /* @__PURE__ */ function() {
    function State2(config2) {
      var _this = this;
      var _a2;
      this.actions = [];
      this.activities = EMPTY_ACTIVITY_MAP;
      this.meta = {};
      this.events = [];
      this.value = config2.value;
      this.context = config2.context;
      this._event = config2._event;
      this._sessionid = config2._sessionid;
      this.event = this._event.data;
      this.historyValue = config2.historyValue;
      this.history = config2.history;
      this.actions = config2.actions || [];
      this.activities = config2.activities || EMPTY_ACTIVITY_MAP;
      this.meta = getMeta(config2.configuration);
      this.events = config2.events || [];
      this.matches = this.matches.bind(this);
      this.toStrings = this.toStrings.bind(this);
      this.configuration = config2.configuration;
      this.transitions = config2.transitions;
      this.children = config2.children;
      this.done = !!config2.done;
      this.tags = (_a2 = Array.isArray(config2.tags) ? new Set(config2.tags) : config2.tags) !== null && _a2 !== void 0 ? _a2 : /* @__PURE__ */ new Set();
      this.machine = config2.machine;
      Object.defineProperty(this, "nextEvents", {
        get: function() {
          return nextEvents(_this.configuration);
        }
      });
    }
    State2.from = function(stateValue, context) {
      if (stateValue instanceof State2) {
        if (stateValue.context !== context) {
          return new State2({
            value: stateValue.value,
            context,
            _event: stateValue._event,
            _sessionid: null,
            historyValue: stateValue.historyValue,
            history: stateValue.history,
            actions: [],
            activities: stateValue.activities,
            meta: {},
            events: [],
            configuration: [],
            transitions: [],
            children: {}
          });
        }
        return stateValue;
      }
      var _event = initEvent;
      return new State2({
        value: stateValue,
        context,
        _event,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    };
    State2.create = function(config2) {
      return new State2(config2);
    };
    State2.inert = function(stateValue, context) {
      if (stateValue instanceof State2) {
        if (!stateValue.actions.length) {
          return stateValue;
        }
        var _event = initEvent;
        return new State2({
          value: stateValue.value,
          context,
          _event,
          _sessionid: null,
          historyValue: stateValue.historyValue,
          history: stateValue.history,
          activities: stateValue.activities,
          configuration: stateValue.configuration,
          transitions: [],
          children: {}
        });
      }
      return State2.from(stateValue, context);
    };
    State2.prototype.toStrings = function(stateValue, delimiter2) {
      var _this = this;
      if (stateValue === void 0) {
        stateValue = this.value;
      }
      if (delimiter2 === void 0) {
        delimiter2 = ".";
      }
      if (isString$1(stateValue)) {
        return [stateValue];
      }
      var valueKeys = Object.keys(stateValue);
      return valueKeys.concat.apply(valueKeys, __spreadArray([], __read$1(valueKeys.map(function(key) {
        return _this.toStrings(stateValue[key], delimiter2).map(function(s4) {
          return key + delimiter2 + s4;
        });
      })), false));
    };
    State2.prototype.toJSON = function() {
      var _a2 = this;
      _a2.configuration;
      _a2.transitions;
      var tags2 = _a2.tags;
      _a2.machine;
      var jsonValues = __rest$1(_a2, ["configuration", "transitions", "tags", "machine"]);
      return __assign$1(__assign$1({}, jsonValues), {
        tags: Array.from(tags2)
      });
    };
    State2.prototype.matches = function(parentStateValue) {
      return matchesState(parentStateValue, this.value);
    };
    State2.prototype.hasTag = function(tag2) {
      return this.tags.has(tag2);
    };
    State2.prototype.can = function(event2) {
      var _a2;
      if (IS_PRODUCTION) {
        warn$1(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
      }
      var transitionData = (_a2 = this.machine) === null || _a2 === void 0 ? void 0 : _a2.getTransitionData(this, event2);
      return !!(transitionData === null || transitionData === void 0 ? void 0 : transitionData.transitions.length) && // Check that at least one transition is not forbidden
      transitionData.transitions.some(function(t2) {
        return t2.target !== void 0 || t2.actions.length;
      });
    };
    return State2;
  }()
);
var defaultOptions = {
  deferEvents: false
};
var Scheduler = (
  /** @class */
  /* @__PURE__ */ function() {
    function Scheduler2(options2) {
      this.processingEvent = false;
      this.queue = [];
      this.initialized = false;
      this.options = __assign$1(__assign$1({}, defaultOptions), options2);
    }
    Scheduler2.prototype.initialize = function(callback) {
      this.initialized = true;
      if (callback) {
        if (!this.options.deferEvents) {
          this.schedule(callback);
          return;
        }
        this.process(callback);
      }
      this.flushEvents();
    };
    Scheduler2.prototype.schedule = function(task) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(task);
        return;
      }
      if (this.queue.length !== 0) {
        throw new Error("Event queue should be empty when it is not processing events");
      }
      this.process(task);
      this.flushEvents();
    };
    Scheduler2.prototype.clear = function() {
      this.queue = [];
    };
    Scheduler2.prototype.flushEvents = function() {
      var nextCallback = this.queue.shift();
      while (nextCallback) {
        this.process(nextCallback);
        nextCallback = this.queue.shift();
      }
    };
    Scheduler2.prototype.process = function(callback) {
      this.processingEvent = true;
      try {
        callback();
      } catch (e3) {
        this.clear();
        throw e3;
      } finally {
        this.processingEvent = false;
      }
    };
    return Scheduler2;
  }()
);
var children = /* @__PURE__ */ new Map();
var sessionIdIndex = 0;
var registry = {
  bookId: function() {
    return "x:".concat(sessionIdIndex++);
  },
  register: function(id, actor) {
    children.set(id, actor);
    return id;
  },
  get: function(id) {
    return children.get(id);
  },
  free: function(id) {
    children.delete(id);
  }
};
function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  if (!IS_PRODUCTION) {
    console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
  }
}
function getDevTools() {
  var global2 = getGlobal();
  if (global2 && "__xstate__" in global2) {
    return global2.__xstate__;
  }
  return void 0;
}
function registerService(service) {
  if (!getGlobal()) {
    return;
  }
  var devTools = getDevTools();
  if (devTools) {
    devTools.register(service);
  }
}
function spawnBehavior(behavior, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var state = behavior.initialState;
  var observers = /* @__PURE__ */ new Set();
  var mailbox = [];
  var flushing = false;
  var flush2 = function() {
    if (flushing) {
      return;
    }
    flushing = true;
    while (mailbox.length > 0) {
      var event_1 = mailbox.shift();
      state = behavior.transition(state, event_1, actorCtx);
      observers.forEach(function(observer) {
        return observer.next(state);
      });
    }
    flushing = false;
  };
  var actor = toActorRef({
    id: options2.id,
    send: function(event2) {
      mailbox.push(event2);
      flush2();
    },
    getSnapshot: function() {
      return state;
    },
    subscribe: function(next2, handleError, complete) {
      var observer = toObserver(next2, handleError, complete);
      observers.add(observer);
      observer.next(state);
      return {
        unsubscribe: function() {
          observers.delete(observer);
        }
      };
    }
  });
  var actorCtx = {
    parent: options2.parent,
    self: actor,
    id: options2.id || "anonymous",
    observers
  };
  state = behavior.start ? behavior.start(actorCtx) : state;
  return actor;
}
var DEFAULT_SPAWN_OPTIONS = {
  sync: false,
  autoForward: false
};
var InterpreterStatus;
(function(InterpreterStatus2) {
  InterpreterStatus2[InterpreterStatus2["NotStarted"] = 0] = "NotStarted";
  InterpreterStatus2[InterpreterStatus2["Running"] = 1] = "Running";
  InterpreterStatus2[InterpreterStatus2["Stopped"] = 2] = "Stopped";
})(InterpreterStatus || (InterpreterStatus = {}));
var Interpreter = (
  /** @class */
  /* @__PURE__ */ function() {
    function Interpreter2(machine, options2) {
      if (options2 === void 0) {
        options2 = Interpreter2.defaultOptions;
      }
      var _this = this;
      this.machine = machine;
      this.delayedEventsMap = {};
      this.listeners = /* @__PURE__ */ new Set();
      this.contextListeners = /* @__PURE__ */ new Set();
      this.stopListeners = /* @__PURE__ */ new Set();
      this.doneListeners = /* @__PURE__ */ new Set();
      this.eventListeners = /* @__PURE__ */ new Set();
      this.sendListeners = /* @__PURE__ */ new Set();
      this.initialized = false;
      this.status = InterpreterStatus.NotStarted;
      this.children = /* @__PURE__ */ new Map();
      this.forwardTo = /* @__PURE__ */ new Set();
      this._outgoingQueue = [];
      this.init = this.start;
      this.send = function(event2, payload) {
        if (isArray$e(event2)) {
          _this.batch(event2);
          return _this.state;
        }
        var _event = toSCXMLEvent(toEventObject(event2, payload));
        if (_this.status === InterpreterStatus.Stopped) {
          if (!IS_PRODUCTION) {
            warn$1(false, 'Event "'.concat(_event.name, '" was sent to stopped service "').concat(_this.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(_event.data)));
          }
          return _this.state;
        }
        if (_this.status !== InterpreterStatus.Running && !_this.options.deferEvents) {
          throw new Error('Event "'.concat(_event.name, '" was sent to uninitialized service "').concat(
            _this.machine.id,
            '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: '
          ).concat(JSON.stringify(_event.data)));
        }
        _this.scheduler.schedule(function() {
          _this.forward(_event);
          var nextState = _this._nextState(_event);
          _this.update(nextState, _event);
        });
        return _this._state;
      };
      this.sendTo = function(event2, to2, immediate) {
        var isParent = _this.parent && (to2 === SpecialTargets.Parent || _this.parent.id === to2);
        var target = isParent ? _this.parent : isString$1(to2) ? to2 === SpecialTargets.Internal ? _this : _this.children.get(to2) || registry.get(to2) : isActor$1(to2) ? to2 : void 0;
        if (!target) {
          if (!isParent) {
            throw new Error("Unable to send event to child '".concat(to2, "' from service '").concat(_this.id, "'."));
          }
          if (!IS_PRODUCTION) {
            warn$1(false, "Service '".concat(_this.id, "' has no parent: unable to send event ").concat(event2.type));
          }
          return;
        }
        if ("machine" in target) {
          if (_this.status !== InterpreterStatus.Stopped || _this.parent !== target || // we need to send events to the parent from exit handlers of a machine that reached its final state
          _this.state.done) {
            var scxmlEvent = __assign$1(__assign$1({}, event2), {
              name: event2.name === error$1 ? "".concat(error(_this.id)) : event2.name,
              origin: _this.sessionId
            });
            if (!immediate && _this.machine.config.predictableActionArguments) {
              _this._outgoingQueue.push([target, scxmlEvent]);
            } else {
              target.send(scxmlEvent);
            }
          }
        } else {
          if (!immediate && _this.machine.config.predictableActionArguments) {
            _this._outgoingQueue.push([target, event2.data]);
          } else {
            target.send(event2.data);
          }
        }
      };
      this._exec = function(action2, context, _event, actionFunctionMap) {
        if (actionFunctionMap === void 0) {
          actionFunctionMap = _this.machine.options.actions;
        }
        var actionOrExec = action2.exec || getActionFunction(action2.type, actionFunctionMap);
        var exec = isFunction$5(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action2.exec;
        if (exec) {
          try {
            return exec(context, _event.data, !_this.machine.config.predictableActionArguments ? {
              action: action2,
              state: _this.state,
              _event
            } : {
              action: action2,
              _event
            });
          } catch (err) {
            if (_this.parent) {
              _this.parent.send({
                type: "xstate.error",
                data: err
              });
            }
            throw err;
          }
        }
        switch (action2.type) {
          case raise$1: {
            var sendAction_1 = action2;
            _this.defer(sendAction_1);
            break;
          }
          case send$1:
            var sendAction = action2;
            if (typeof sendAction.delay === "number") {
              _this.defer(sendAction);
              return;
            } else {
              if (sendAction.to) {
                _this.sendTo(sendAction._event, sendAction.to, _event === initEvent);
              } else {
                _this.send(sendAction._event);
              }
            }
            break;
          case cancel$1:
            _this.cancel(action2.sendId);
            break;
          case start$1: {
            if (_this.status !== InterpreterStatus.Running) {
              return;
            }
            var activity = action2.activity;
            if (
              // in v4 with `predictableActionArguments` invokes are called eagerly when the `this.state` still points to the previous state
              !_this.machine.config.predictableActionArguments && !_this.state.activities[activity.id || activity.type]
            ) {
              break;
            }
            if (activity.type === ActionTypes$1.Invoke) {
              var invokeSource = toInvokeSource$1(activity.src);
              var serviceCreator = _this.machine.options.services ? _this.machine.options.services[invokeSource.type] : void 0;
              var id2 = activity.id, data = activity.data;
              if (!IS_PRODUCTION) {
                warn$1(
                  !("forward" in activity),
                  // tslint:disable-next-line:max-line-length
                  "`forward` property is deprecated (found in invocation of '".concat(activity.src, "' in in machine '").concat(_this.machine.id, "'). ") + "Please use `autoForward` instead."
                );
              }
              var autoForward = "autoForward" in activity ? activity.autoForward : !!activity.forward;
              if (!serviceCreator) {
                if (!IS_PRODUCTION) {
                  warn$1(false, "No service found for invocation '".concat(activity.src, "' in machine '").concat(_this.machine.id, "'."));
                }
                return;
              }
              var resolvedData = data ? mapContext(data, context, _event) : void 0;
              if (typeof serviceCreator === "string") {
                return;
              }
              var source = isFunction$5(serviceCreator) ? serviceCreator(context, _event.data, {
                data: resolvedData,
                src: invokeSource,
                meta: activity.meta
              }) : serviceCreator;
              if (!source) {
                return;
              }
              var options3 = void 0;
              if (isMachine(source)) {
                source = resolvedData ? source.withContext(resolvedData) : source;
                options3 = {
                  autoForward
                };
              }
              _this.spawn(source, id2, options3);
            } else {
              _this.spawnActivity(activity);
            }
            break;
          }
          case stop$1: {
            _this.stopChild(action2.activity.id);
            break;
          }
          case log$1:
            var _a2 = action2, label2 = _a2.label, value = _a2.value;
            if (label2) {
              _this.logger(label2, value);
            } else {
              _this.logger(value);
            }
            break;
          default:
            if (!IS_PRODUCTION) {
              warn$1(false, "No implementation found for action type '".concat(action2.type, "'"));
            }
            break;
        }
      };
      var resolvedOptions = __assign$1(__assign$1({}, Interpreter2.defaultOptions), options2);
      var clock2 = resolvedOptions.clock, logger = resolvedOptions.logger, parent2 = resolvedOptions.parent, id = resolvedOptions.id;
      var resolvedId = id !== void 0 ? id : machine.id;
      this.id = resolvedId;
      this.logger = logger;
      this.clock = clock2;
      this.parent = parent2;
      this.options = resolvedOptions;
      this.scheduler = new Scheduler({
        deferEvents: this.options.deferEvents
      });
      this.sessionId = registry.bookId();
    }
    Object.defineProperty(Interpreter2.prototype, "initialState", {
      get: function() {
        var _this = this;
        if (this._initialState) {
          return this._initialState;
        }
        return provide(this, function() {
          _this._initialState = _this.machine.initialState;
          return _this._initialState;
        });
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(Interpreter2.prototype, "state", {
      /**
       * @deprecated Use `.getSnapshot()` instead.
       */
      get: function() {
        if (!IS_PRODUCTION) {
          warn$1(this.status !== InterpreterStatus.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first."));
        }
        return this._state;
      },
      enumerable: false,
      configurable: true
    });
    Interpreter2.prototype.execute = function(state, actionsConfig) {
      var e_1, _a2;
      try {
        for (var _b = __values(state.actions), _c = _b.next(); !_c.done; _c = _b.next()) {
          var action2 = _c.value;
          this.exec(action2, state, actionsConfig);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_1)
            throw e_1.error;
        }
      }
    };
    Interpreter2.prototype.update = function(state, _event) {
      var e_2, _a2, e_3, _b, e_4, _c, e_5, _d;
      var _this = this;
      state._sessionid = this.sessionId;
      this._state = state;
      if ((!this.machine.config.predictableActionArguments || // this is currently required to execute initial actions as the `initialState` gets cached
      // we can't just recompute it (and execute actions while doing so) because we try to preserve identity of actors created within initial assigns
      _event === initEvent) && this.options.execute) {
        this.execute(this.state);
      } else {
        var item = void 0;
        while (item = this._outgoingQueue.shift()) {
          item[0].send(item[1]);
        }
      }
      this.children.forEach(function(child) {
        _this.state.children[child.id] = child;
      });
      if (this.devTools) {
        this.devTools.send(_event.data, state);
      }
      if (state.event) {
        try {
          for (var _e = __values(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()) {
            var listener = _f.value;
            listener(state.event);
          }
        } catch (e_2_1) {
          e_2 = {
            error: e_2_1
          };
        } finally {
          try {
            if (_f && !_f.done && (_a2 = _e.return))
              _a2.call(_e);
          } finally {
            if (e_2)
              throw e_2.error;
          }
        }
      }
      try {
        for (var _g = __values(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()) {
          var listener = _h.value;
          listener(state, state.event);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_h && !_h.done && (_b = _g.return))
            _b.call(_g);
        } finally {
          if (e_3)
            throw e_3.error;
        }
      }
      try {
        for (var _j = __values(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()) {
          var contextListener = _k.value;
          contextListener(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_k && !_k.done && (_c = _j.return))
            _c.call(_j);
        } finally {
          if (e_4)
            throw e_4.error;
        }
      }
      if (this.state.done) {
        var finalChildStateNode = state.configuration.find(function(sn) {
          return sn.type === "final" && sn.parent === _this.machine;
        });
        var doneData = finalChildStateNode && finalChildStateNode.doneData ? mapContext(finalChildStateNode.doneData, state.context, _event) : void 0;
        this._doneEvent = doneInvoke(this.id, doneData);
        try {
          for (var _l = __values(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()) {
            var listener = _m.value;
            listener(this._doneEvent);
          }
        } catch (e_5_1) {
          e_5 = {
            error: e_5_1
          };
        } finally {
          try {
            if (_m && !_m.done && (_d = _l.return))
              _d.call(_l);
          } finally {
            if (e_5)
              throw e_5.error;
          }
        }
        this._stop();
        this._stopChildren();
        registry.free(this.sessionId);
      }
    };
    Interpreter2.prototype.onTransition = function(listener) {
      this.listeners.add(listener);
      if (this.status === InterpreterStatus.Running) {
        listener(this.state, this.state.event);
      }
      return this;
    };
    Interpreter2.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
      var _this = this;
      var observer = toObserver(nextListenerOrObserver, _, completeListener);
      this.listeners.add(observer.next);
      if (this.status !== InterpreterStatus.NotStarted) {
        observer.next(this.state);
      }
      var completeOnce = function() {
        _this.doneListeners.delete(completeOnce);
        _this.stopListeners.delete(completeOnce);
        observer.complete();
      };
      if (this.status === InterpreterStatus.Stopped) {
        observer.complete();
      } else {
        this.onDone(completeOnce);
        this.onStop(completeOnce);
      }
      return {
        unsubscribe: function() {
          _this.listeners.delete(observer.next);
          _this.doneListeners.delete(completeOnce);
          _this.stopListeners.delete(completeOnce);
        }
      };
    };
    Interpreter2.prototype.onEvent = function(listener) {
      this.eventListeners.add(listener);
      return this;
    };
    Interpreter2.prototype.onSend = function(listener) {
      this.sendListeners.add(listener);
      return this;
    };
    Interpreter2.prototype.onChange = function(listener) {
      this.contextListeners.add(listener);
      return this;
    };
    Interpreter2.prototype.onStop = function(listener) {
      this.stopListeners.add(listener);
      return this;
    };
    Interpreter2.prototype.onDone = function(listener) {
      if (this.status === InterpreterStatus.Stopped && this._doneEvent) {
        listener(this._doneEvent);
      } else {
        this.doneListeners.add(listener);
      }
      return this;
    };
    Interpreter2.prototype.off = function(listener) {
      this.listeners.delete(listener);
      this.eventListeners.delete(listener);
      this.sendListeners.delete(listener);
      this.stopListeners.delete(listener);
      this.doneListeners.delete(listener);
      this.contextListeners.delete(listener);
      return this;
    };
    Interpreter2.prototype.start = function(initialState2) {
      var _this = this;
      if (this.status === InterpreterStatus.Running) {
        return this;
      }
      this.machine._init();
      registry.register(this.sessionId, this);
      this.initialized = true;
      this.status = InterpreterStatus.Running;
      var resolvedState = initialState2 === void 0 ? this.initialState : provide(this, function() {
        return isStateConfig(initialState2) ? _this.machine.resolveState(initialState2) : _this.machine.resolveState(State$1.from(initialState2, _this.machine.context));
      });
      if (this.options.devTools) {
        this.attachDev();
      }
      this.scheduler.initialize(function() {
        _this.update(resolvedState, initEvent);
      });
      return this;
    };
    Interpreter2.prototype._stopChildren = function() {
      this.children.forEach(function(child) {
        if (isFunction$5(child.stop)) {
          child.stop();
        }
      });
      this.children.clear();
    };
    Interpreter2.prototype._stop = function() {
      var e_6, _a2, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
      try {
        for (var _f = __values(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()) {
          var listener = _g.value;
          this.listeners.delete(listener);
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (_g && !_g.done && (_a2 = _f.return))
            _a2.call(_f);
        } finally {
          if (e_6)
            throw e_6.error;
        }
      }
      try {
        for (var _h = __values(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()) {
          var listener = _j.value;
          listener();
          this.stopListeners.delete(listener);
        }
      } catch (e_7_1) {
        e_7 = {
          error: e_7_1
        };
      } finally {
        try {
          if (_j && !_j.done && (_b = _h.return))
            _b.call(_h);
        } finally {
          if (e_7)
            throw e_7.error;
        }
      }
      try {
        for (var _k = __values(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()) {
          var listener = _l.value;
          this.contextListeners.delete(listener);
        }
      } catch (e_8_1) {
        e_8 = {
          error: e_8_1
        };
      } finally {
        try {
          if (_l && !_l.done && (_c = _k.return))
            _c.call(_k);
        } finally {
          if (e_8)
            throw e_8.error;
        }
      }
      try {
        for (var _m = __values(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()) {
          var listener = _o.value;
          this.doneListeners.delete(listener);
        }
      } catch (e_9_1) {
        e_9 = {
          error: e_9_1
        };
      } finally {
        try {
          if (_o && !_o.done && (_d = _m.return))
            _d.call(_m);
        } finally {
          if (e_9)
            throw e_9.error;
        }
      }
      if (!this.initialized) {
        return this;
      }
      this.initialized = false;
      this.status = InterpreterStatus.Stopped;
      this._initialState = void 0;
      try {
        for (var _p = __values(Object.keys(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()) {
          var key = _q.value;
          this.clock.clearTimeout(this.delayedEventsMap[key]);
        }
      } catch (e_10_1) {
        e_10 = {
          error: e_10_1
        };
      } finally {
        try {
          if (_q && !_q.done && (_e = _p.return))
            _e.call(_p);
        } finally {
          if (e_10)
            throw e_10.error;
        }
      }
      this.scheduler.clear();
      this.scheduler = new Scheduler({
        deferEvents: this.options.deferEvents
      });
    };
    Interpreter2.prototype.stop = function() {
      var _this = this;
      var scheduler2 = this.scheduler;
      this._stop();
      scheduler2.schedule(function() {
        var _a2;
        if ((_a2 = _this._state) === null || _a2 === void 0 ? void 0 : _a2.done) {
          return;
        }
        var _event = toSCXMLEvent({
          type: "xstate.stop"
        });
        var nextState = provide(_this, function() {
          var exitActions = flatten$2(__spreadArray([], __read$1(_this.state.configuration), false).sort(function(a4, b10) {
            return b10.order - a4.order;
          }).map(function(stateNode) {
            return toActionObjects(stateNode.onExit, _this.machine.options.actions);
          }));
          var _a3 = __read$1(resolveActions(_this.machine, _this.state, _this.state.context, _event, [{
            type: "exit",
            actions: exitActions
          }], _this.machine.config.predictableActionArguments ? _this._exec : void 0, _this.machine.config.predictableActionArguments || _this.machine.config.preserveActionOrder), 2), resolvedActions = _a3[0], updatedContext = _a3[1];
          var newState = new State$1({
            value: _this.state.value,
            context: updatedContext,
            _event,
            _sessionid: _this.sessionId,
            historyValue: void 0,
            history: _this.state,
            actions: resolvedActions.filter(function(action2) {
              return !isRaisableAction(action2);
            }),
            activities: {},
            events: [],
            configuration: [],
            transitions: [],
            children: {},
            done: _this.state.done,
            tags: _this.state.tags,
            machine: _this.machine
          });
          newState.changed = true;
          return newState;
        });
        _this.update(nextState, _event);
        _this._stopChildren();
        registry.free(_this.sessionId);
      });
      return this;
    };
    Interpreter2.prototype.batch = function(events) {
      var _this = this;
      if (this.status === InterpreterStatus.NotStarted && this.options.deferEvents) {
        if (!IS_PRODUCTION) {
          warn$1(false, "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));
        }
      } else if (this.status !== InterpreterStatus.Running) {
        throw new Error(
          // tslint:disable-next-line:max-line-length
          "".concat(events.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
        );
      }
      if (!events.length) {
        return;
      }
      var exec = !!this.machine.config.predictableActionArguments && this._exec;
      this.scheduler.schedule(function() {
        var e_11, _a2;
        var nextState = _this.state;
        var batchChanged = false;
        var batchedActions = [];
        var _loop_1 = function(event_12) {
          var _event = toSCXMLEvent(event_12);
          _this.forward(_event);
          nextState = provide(_this, function() {
            return _this.machine.transition(nextState, _event, void 0, exec || void 0);
          });
          batchedActions.push.apply(batchedActions, __spreadArray([], __read$1(_this.machine.config.predictableActionArguments ? nextState.actions : nextState.actions.map(function(a4) {
            return bindActionToState(a4, nextState);
          })), false));
          batchChanged = batchChanged || !!nextState.changed;
        };
        try {
          for (var events_1 = __values(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()) {
            var event_1 = events_1_1.value;
            _loop_1(event_1);
          }
        } catch (e_11_1) {
          e_11 = {
            error: e_11_1
          };
        } finally {
          try {
            if (events_1_1 && !events_1_1.done && (_a2 = events_1.return))
              _a2.call(events_1);
          } finally {
            if (e_11)
              throw e_11.error;
          }
        }
        nextState.changed = batchChanged;
        nextState.actions = batchedActions;
        _this.update(nextState, toSCXMLEvent(events[events.length - 1]));
      });
    };
    Interpreter2.prototype.sender = function(event2) {
      return this.send.bind(this, event2);
    };
    Interpreter2.prototype._nextState = function(event2, exec) {
      var _this = this;
      if (exec === void 0) {
        exec = !!this.machine.config.predictableActionArguments && this._exec;
      }
      var _event = toSCXMLEvent(event2);
      if (_event.name.indexOf(errorPlatform) === 0 && !this.state.nextEvents.some(function(nextEvent) {
        return nextEvent.indexOf(errorPlatform) === 0;
      })) {
        throw _event.data.data;
      }
      var nextState = provide(this, function() {
        return _this.machine.transition(_this.state, _event, void 0, exec || void 0);
      });
      return nextState;
    };
    Interpreter2.prototype.nextState = function(event2) {
      return this._nextState(event2, false);
    };
    Interpreter2.prototype.forward = function(event2) {
      var e_12, _a2;
      try {
        for (var _b = __values(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()) {
          var id = _c.value;
          var child = this.children.get(id);
          if (!child) {
            throw new Error("Unable to forward event '".concat(event2, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(id, "'."));
          }
          child.send(event2);
        }
      } catch (e_12_1) {
        e_12 = {
          error: e_12_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_12)
            throw e_12.error;
        }
      }
    };
    Interpreter2.prototype.defer = function(sendAction) {
      var _this = this;
      var timerId = this.clock.setTimeout(function() {
        if ("to" in sendAction && sendAction.to) {
          _this.sendTo(sendAction._event, sendAction.to, true);
        } else {
          _this.send(sendAction._event);
        }
      }, sendAction.delay);
      if (sendAction.id) {
        this.delayedEventsMap[sendAction.id] = timerId;
      }
    };
    Interpreter2.prototype.cancel = function(sendId) {
      this.clock.clearTimeout(this.delayedEventsMap[sendId]);
      delete this.delayedEventsMap[sendId];
    };
    Interpreter2.prototype.exec = function(action2, state, actionFunctionMap) {
      if (actionFunctionMap === void 0) {
        actionFunctionMap = this.machine.options.actions;
      }
      this._exec(action2, state.context, state._event, actionFunctionMap);
    };
    Interpreter2.prototype.removeChild = function(childId) {
      var _a2;
      this.children.delete(childId);
      this.forwardTo.delete(childId);
      (_a2 = this.state) === null || _a2 === void 0 ? true : delete _a2.children[childId];
    };
    Interpreter2.prototype.stopChild = function(childId) {
      var child = this.children.get(childId);
      if (!child) {
        return;
      }
      this.removeChild(childId);
      if (isFunction$5(child.stop)) {
        child.stop();
      }
    };
    Interpreter2.prototype.spawn = function(entity, name2, options2) {
      if (this.status !== InterpreterStatus.Running) {
        return createDeferredActor(entity, name2);
      }
      if (isPromiseLike(entity)) {
        return this.spawnPromise(Promise.resolve(entity), name2);
      } else if (isFunction$5(entity)) {
        return this.spawnCallback(entity, name2);
      } else if (isSpawnedActor(entity)) {
        return this.spawnActor(entity, name2);
      } else if (isObservable(entity)) {
        return this.spawnObservable(entity, name2);
      } else if (isMachine(entity)) {
        return this.spawnMachine(entity, __assign$1(__assign$1({}, options2), {
          id: name2
        }));
      } else if (isBehavior(entity)) {
        return this.spawnBehavior(entity, name2);
      } else {
        throw new Error('Unable to spawn entity "'.concat(name2, '" of type "').concat(typeof entity, '".'));
      }
    };
    Interpreter2.prototype.spawnMachine = function(machine, options2) {
      var _this = this;
      if (options2 === void 0) {
        options2 = {};
      }
      var childService = new Interpreter2(machine, __assign$1(__assign$1({}, this.options), {
        parent: this,
        id: options2.id || machine.id
      }));
      var resolvedOptions = __assign$1(__assign$1({}, DEFAULT_SPAWN_OPTIONS), options2);
      if (resolvedOptions.sync) {
        childService.onTransition(function(state) {
          _this.send(update, {
            state,
            id: childService.id
          });
        });
      }
      var actor = childService;
      this.children.set(childService.id, actor);
      if (resolvedOptions.autoForward) {
        this.forwardTo.add(childService.id);
      }
      childService.onDone(function(doneEvent) {
        _this.removeChild(childService.id);
        _this.send(toSCXMLEvent(doneEvent, {
          origin: childService.id
        }));
      }).start();
      return actor;
    };
    Interpreter2.prototype.spawnBehavior = function(behavior, id) {
      var actorRef = spawnBehavior(behavior, {
        id,
        parent: this
      });
      this.children.set(id, actorRef);
      return actorRef;
    };
    Interpreter2.prototype.spawnPromise = function(promise, id) {
      var _a2;
      var _this = this;
      var canceled = false;
      var resolvedData;
      promise.then(function(response) {
        if (!canceled) {
          resolvedData = response;
          _this.removeChild(id);
          _this.send(toSCXMLEvent(doneInvoke(id, response), {
            origin: id
          }));
        }
      }, function(errorData) {
        if (!canceled) {
          _this.removeChild(id);
          var errorEvent = error(id, errorData);
          try {
            _this.send(toSCXMLEvent(errorEvent, {
              origin: id
            }));
          } catch (error2) {
            reportUnhandledExceptionOnInvocation(errorData, error2, id);
            if (_this.devTools) {
              _this.devTools.send(errorEvent, _this.state);
            }
            if (_this.machine.strict) {
              _this.stop();
            }
          }
        }
      });
      var actor = (_a2 = {
        id,
        send: function() {
          return void 0;
        },
        subscribe: function(next2, handleError, complete) {
          var observer = toObserver(next2, handleError, complete);
          var unsubscribed = false;
          promise.then(function(response) {
            if (unsubscribed) {
              return;
            }
            observer.next(response);
            if (unsubscribed) {
              return;
            }
            observer.complete();
          }, function(err) {
            if (unsubscribed) {
              return;
            }
            observer.error(err);
          });
          return {
            unsubscribe: function() {
              return unsubscribed = true;
            }
          };
        },
        stop: function() {
          canceled = true;
        },
        toJSON: function() {
          return {
            id
          };
        },
        getSnapshot: function() {
          return resolvedData;
        }
      }, _a2[symbolObservable] = function() {
        return this;
      }, _a2);
      this.children.set(id, actor);
      return actor;
    };
    Interpreter2.prototype.spawnCallback = function(callback, id) {
      var _a2;
      var _this = this;
      var canceled = false;
      var receivers = /* @__PURE__ */ new Set();
      var listeners = /* @__PURE__ */ new Set();
      var emitted;
      var receive = function(e3) {
        emitted = e3;
        listeners.forEach(function(listener) {
          return listener(e3);
        });
        if (canceled) {
          return;
        }
        _this.send(toSCXMLEvent(e3, {
          origin: id
        }));
      };
      var callbackStop;
      try {
        callbackStop = callback(receive, function(newListener) {
          receivers.add(newListener);
        });
      } catch (err) {
        this.send(error(id, err));
      }
      if (isPromiseLike(callbackStop)) {
        return this.spawnPromise(callbackStop, id);
      }
      var actor = (_a2 = {
        id,
        send: function(event2) {
          return receivers.forEach(function(receiver) {
            return receiver(event2);
          });
        },
        subscribe: function(next2) {
          var observer = toObserver(next2);
          listeners.add(observer.next);
          return {
            unsubscribe: function() {
              listeners.delete(observer.next);
            }
          };
        },
        stop: function() {
          canceled = true;
          if (isFunction$5(callbackStop)) {
            callbackStop();
          }
        },
        toJSON: function() {
          return {
            id
          };
        },
        getSnapshot: function() {
          return emitted;
        }
      }, _a2[symbolObservable] = function() {
        return this;
      }, _a2);
      this.children.set(id, actor);
      return actor;
    };
    Interpreter2.prototype.spawnObservable = function(source, id) {
      var _a2;
      var _this = this;
      var emitted;
      var subscription = source.subscribe(function(value) {
        emitted = value;
        _this.send(toSCXMLEvent(value, {
          origin: id
        }));
      }, function(err) {
        _this.removeChild(id);
        _this.send(toSCXMLEvent(error(id, err), {
          origin: id
        }));
      }, function() {
        _this.removeChild(id);
        _this.send(toSCXMLEvent(doneInvoke(id), {
          origin: id
        }));
      });
      var actor = (_a2 = {
        id,
        send: function() {
          return void 0;
        },
        subscribe: function(next2, handleError, complete) {
          return source.subscribe(next2, handleError, complete);
        },
        stop: function() {
          return subscription.unsubscribe();
        },
        getSnapshot: function() {
          return emitted;
        },
        toJSON: function() {
          return {
            id
          };
        }
      }, _a2[symbolObservable] = function() {
        return this;
      }, _a2);
      this.children.set(id, actor);
      return actor;
    };
    Interpreter2.prototype.spawnActor = function(actor, name2) {
      this.children.set(name2, actor);
      return actor;
    };
    Interpreter2.prototype.spawnActivity = function(activity) {
      var implementation2 = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : void 0;
      if (!implementation2) {
        if (!IS_PRODUCTION) {
          warn$1(false, "No implementation found for activity '".concat(activity.type, "'"));
        }
        return;
      }
      var dispose = implementation2(this.state.context, activity);
      this.spawnEffect(activity.id, dispose);
    };
    Interpreter2.prototype.spawnEffect = function(id, dispose) {
      var _a2;
      this.children.set(id, (_a2 = {
        id,
        send: function() {
          return void 0;
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
              return void 0;
            }
          };
        },
        stop: dispose || void 0,
        getSnapshot: function() {
          return void 0;
        },
        toJSON: function() {
          return {
            id
          };
        }
      }, _a2[symbolObservable] = function() {
        return this;
      }, _a2));
    };
    Interpreter2.prototype.attachDev = function() {
      var global2 = getGlobal();
      if (this.options.devTools && global2) {
        if (global2.__REDUX_DEVTOOLS_EXTENSION__) {
          var devToolsOptions = typeof this.options.devTools === "object" ? this.options.devTools : void 0;
          this.devTools = global2.__REDUX_DEVTOOLS_EXTENSION__.connect(__assign$1(__assign$1({
            name: this.id,
            autoPause: true,
            stateSanitizer: function(state) {
              return {
                value: state.value,
                context: state.context,
                actions: state.actions
              };
            }
          }, devToolsOptions), {
            features: __assign$1({
              jump: false,
              skip: false
            }, devToolsOptions ? devToolsOptions.features : void 0)
          }), this.machine);
          this.devTools.init(this.state);
        }
        registerService(this);
      }
    };
    Interpreter2.prototype.toJSON = function() {
      return {
        id: this.id
      };
    };
    Interpreter2.prototype[symbolObservable] = function() {
      return this;
    };
    Interpreter2.prototype.getSnapshot = function() {
      if (this.status === InterpreterStatus.NotStarted) {
        return this.initialState;
      }
      return this._state;
    };
    Interpreter2.defaultOptions = {
      execute: true,
      deferEvents: true,
      clock: {
        setTimeout: function(fn2, ms) {
          return setTimeout(fn2, ms);
        },
        clearTimeout: function(id) {
          return clearTimeout(id);
        }
      },
      logger: /* @__PURE__ */ console.log.bind(console),
      devTools: false
    };
    Interpreter2.interpret = interpret;
    return Interpreter2;
  }()
);
function interpret(machine, options2) {
  var interpreter = new Interpreter(machine, options2);
  return interpreter;
}
function toInvokeSource(src) {
  if (typeof src === "string") {
    var simpleSrc = {
      type: src
    };
    simpleSrc.toString = function() {
      return src;
    };
    return simpleSrc;
  }
  return src;
}
function toInvokeDefinition(invokeConfig) {
  return __assign$1(__assign$1({
    type: invoke
  }, invokeConfig), {
    toJSON: function() {
      invokeConfig.onDone;
      invokeConfig.onError;
      var invokeDef = __rest$1(invokeConfig, ["onDone", "onError"]);
      return __assign$1(__assign$1({}, invokeDef), {
        type: invoke,
        src: toInvokeSource(invokeConfig.src)
      });
    }
  });
}
var NULL_EVENT = "";
var STATE_IDENTIFIER = "#";
var WILDCARD = "*";
var EMPTY_OBJECT = {};
var isStateId = function(str) {
  return str[0] === STATE_IDENTIFIER;
};
var createDefaultOptions = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};
var validateArrayifiedTransitions = function(stateNode, event2, transitions2) {
  var hasNonLastUnguardedTarget = transitions2.slice(0, -1).some(function(transition) {
    return !("cond" in transition) && !("in" in transition) && (isString$1(transition.target) || isMachine(transition.target));
  });
  var eventText = event2 === NULL_EVENT ? "the transient event" : "event '".concat(event2, "'");
  warn$1(!hasNonLastUnguardedTarget, "One or more transitions for ".concat(eventText, " on state '").concat(stateNode.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
};
var StateNode = (
  /** @class */
  /* @__PURE__ */ function() {
    function StateNode2(config2, options2, _context, _stateInfo) {
      if (_context === void 0) {
        _context = "context" in config2 ? config2.context : void 0;
      }
      var _this = this;
      var _a2;
      this.config = config2;
      this._context = _context;
      this.order = -1;
      this.__xstatenode = true;
      this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      };
      this.idMap = {};
      this.tags = [];
      this.options = Object.assign(createDefaultOptions(), options2);
      this.parent = _stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.parent;
      this.key = this.config.key || (_stateInfo === null || _stateInfo === void 0 ? void 0 : _stateInfo.key) || this.config.id || "(machine)";
      this.machine = this.parent ? this.parent.machine : this;
      this.path = this.parent ? this.parent.path.concat(this.key) : [];
      this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : STATE_DELIMITER);
      this.id = this.config.id || __spreadArray([this.machine.key], __read$1(this.path), false).join(this.delimiter);
      this.version = this.parent ? this.parent.version : this.config.version;
      this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic");
      this.schema = this.parent ? this.machine.schema : (_a2 = this.config.schema) !== null && _a2 !== void 0 ? _a2 : {};
      this.description = this.config.description;
      if (!IS_PRODUCTION) {
        warn$1(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead."));
      }
      this.initial = this.config.initial;
      this.states = this.config.states ? mapValues(this.config.states, function(stateConfig, key) {
        var _a3;
        var stateNode = new StateNode2(stateConfig, {}, void 0, {
          parent: _this,
          key
        });
        Object.assign(_this.idMap, __assign$1((_a3 = {}, _a3[stateNode.id] = stateNode, _a3), stateNode.idMap));
        return stateNode;
      }) : EMPTY_OBJECT;
      var order2 = 0;
      function dfs(stateNode) {
        var e_1, _a3;
        stateNode.order = order2++;
        try {
          for (var _b = __values(getAllChildren(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            dfs(child);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (_c && !_c.done && (_a3 = _b.return))
              _a3.call(_b);
          } finally {
            if (e_1)
              throw e_1.error;
          }
        }
      }
      dfs(this);
      this.history = this.config.history === true ? "shallow" : this.config.history || false;
      this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a3) {
        var event2 = _a3.event;
        return event2 === NULL_EVENT;
      }) : NULL_EVENT in this.config.on);
      this.strict = !!this.config.strict;
      this.onEntry = toArray$2(this.config.entry || this.config.onEntry).map(function(action2) {
        return toActionObject(action2);
      });
      this.onExit = toArray$2(this.config.exit || this.config.onExit).map(function(action2) {
        return toActionObject(action2);
      });
      this.meta = this.config.meta;
      this.doneData = this.type === "final" ? this.config.data : void 0;
      this.invoke = toArray$2(this.config.invoke).map(function(invokeConfig, i2) {
        var _a3, _b;
        if (isMachine(invokeConfig)) {
          var invokeId = createInvokeId(_this.id, i2);
          _this.machine.options.services = __assign$1((_a3 = {}, _a3[invokeId] = invokeConfig, _a3), _this.machine.options.services);
          return toInvokeDefinition({
            src: invokeId,
            id: invokeId
          });
        } else if (isString$1(invokeConfig.src)) {
          var invokeId = invokeConfig.id || createInvokeId(_this.id, i2);
          return toInvokeDefinition(__assign$1(__assign$1({}, invokeConfig), {
            id: invokeId,
            src: invokeConfig.src
          }));
        } else if (isMachine(invokeConfig.src) || isFunction$5(invokeConfig.src)) {
          var invokeId = invokeConfig.id || createInvokeId(_this.id, i2);
          _this.machine.options.services = __assign$1((_b = {}, _b[invokeId] = invokeConfig.src, _b), _this.machine.options.services);
          return toInvokeDefinition(__assign$1(__assign$1({
            id: invokeId
          }, invokeConfig), {
            src: invokeId
          }));
        } else {
          var invokeSource = invokeConfig.src;
          return toInvokeDefinition(__assign$1(__assign$1({
            id: createInvokeId(_this.id, i2)
          }, invokeConfig), {
            src: invokeSource
          }));
        }
      });
      this.activities = toArray$2(this.config.activities).concat(this.invoke).map(function(activity) {
        return toActivityDefinition(activity);
      });
      this.transition = this.transition.bind(this);
      this.tags = toArray$2(this.config.tags);
    }
    StateNode2.prototype._init = function() {
      if (this.__cache.transitions) {
        return;
      }
      getAllStateNodes(this).forEach(function(stateNode) {
        return stateNode.on;
      });
    };
    StateNode2.prototype.withConfig = function(options2, context) {
      var _a2 = this.options, actions = _a2.actions, activities = _a2.activities, guards = _a2.guards, services = _a2.services, delays = _a2.delays;
      return new StateNode2(this.config, {
        actions: __assign$1(__assign$1({}, actions), options2.actions),
        activities: __assign$1(__assign$1({}, activities), options2.activities),
        guards: __assign$1(__assign$1({}, guards), options2.guards),
        services: __assign$1(__assign$1({}, services), options2.services),
        delays: __assign$1(__assign$1({}, delays), options2.delays)
      }, context !== null && context !== void 0 ? context : this.context);
    };
    StateNode2.prototype.withContext = function(context) {
      return new StateNode2(this.config, this.options, context);
    };
    Object.defineProperty(StateNode2.prototype, "context", {
      get: function() {
        return isFunction$5(this._context) ? this._context() : this._context;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateNode2.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: mapValues(this.states, function(state) {
            return state.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: false,
      configurable: true
    });
    StateNode2.prototype.toJSON = function() {
      return this.definition;
    };
    Object.defineProperty(StateNode2.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on) {
          return this.__cache.on;
        }
        var transitions2 = this.transitions;
        return this.__cache.on = transitions2.reduce(function(map2, transition) {
          map2[transition.eventType] = map2[transition.eventType] || [];
          map2[transition.eventType].push(transition);
          return map2;
        }, {});
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateNode2.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateNode2.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: false,
      configurable: true
    });
    StateNode2.prototype.getCandidates = function(eventName) {
      if (this.__cache.candidates[eventName]) {
        return this.__cache.candidates[eventName];
      }
      var transient = eventName === NULL_EVENT;
      var candidates = this.transitions.filter(function(transition) {
        var sameEventType = transition.eventType === eventName;
        return transient ? sameEventType : sameEventType || transition.eventType === WILDCARD;
      });
      this.__cache.candidates[eventName] = candidates;
      return candidates;
    };
    StateNode2.prototype.getDelayedTransitions = function() {
      var _this = this;
      var afterConfig = this.config.after;
      if (!afterConfig) {
        return [];
      }
      var mutateEntryExit = function(delay, i2) {
        var delayRef = isFunction$5(delay) ? "".concat(_this.id, ":delay[").concat(i2, "]") : delay;
        var eventType = after(delayRef, _this.id);
        _this.onEntry.push(send(eventType, {
          delay
        }));
        _this.onExit.push(cancel(eventType));
        return eventType;
      };
      var delayedTransitions = isArray$e(afterConfig) ? afterConfig.map(function(transition, i2) {
        var eventType = mutateEntryExit(transition.delay, i2);
        return __assign$1(__assign$1({}, transition), {
          event: eventType
        });
      }) : flatten$2(Object.keys(afterConfig).map(function(delay, i2) {
        var configTransition = afterConfig[delay];
        var resolvedTransition = isString$1(configTransition) ? {
          target: configTransition
        } : configTransition;
        var resolvedDelay = !isNaN(+delay) ? +delay : delay;
        var eventType = mutateEntryExit(resolvedDelay, i2);
        return toArray$2(resolvedTransition).map(function(transition) {
          return __assign$1(__assign$1({}, transition), {
            event: eventType,
            delay: resolvedDelay
          });
        });
      }));
      return delayedTransitions.map(function(delayedTransition) {
        var delay = delayedTransition.delay;
        return __assign$1(__assign$1({}, _this.formatTransition(delayedTransition)), {
          delay
        });
      });
    };
    StateNode2.prototype.getStateNodes = function(state) {
      var _a2;
      var _this = this;
      if (!state) {
        return [];
      }
      var stateValue = state instanceof State$1 ? state.value : toStateValue(state, this.delimiter);
      if (isString$1(stateValue)) {
        var initialStateValue = this.getStateNode(stateValue).initial;
        return initialStateValue !== void 0 ? this.getStateNodes((_a2 = {}, _a2[stateValue] = initialStateValue, _a2)) : [this, this.states[stateValue]];
      }
      var subStateKeys = Object.keys(stateValue);
      var subStateNodes = [this];
      subStateNodes.push.apply(subStateNodes, __spreadArray([], __read$1(flatten$2(subStateKeys.map(function(subStateKey) {
        return _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
      }))), false));
      return subStateNodes;
    };
    StateNode2.prototype.handles = function(event2) {
      var eventType = getEventType(event2);
      return this.events.includes(eventType);
    };
    StateNode2.prototype.resolveState = function(state) {
      var stateFromConfig = state instanceof State$1 ? state : State$1.create(state);
      var configuration = Array.from(getConfiguration([], this.getStateNodes(stateFromConfig.value)));
      return new State$1(__assign$1(__assign$1({}, stateFromConfig), {
        value: this.resolve(stateFromConfig.value),
        configuration,
        done: isInFinalState(configuration, this),
        tags: getTagsFromConfiguration(configuration),
        machine: this.machine
      }));
    };
    StateNode2.prototype.transitionLeafNode = function(stateValue, state, _event) {
      var stateNode = this.getStateNode(stateValue);
      var next2 = stateNode.next(state, _event);
      if (!next2 || !next2.transitions.length) {
        return this.next(state, _event);
      }
      return next2;
    };
    StateNode2.prototype.transitionCompoundNode = function(stateValue, state, _event) {
      var subStateKeys = Object.keys(stateValue);
      var stateNode = this.getStateNode(subStateKeys[0]);
      var next2 = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
      if (!next2 || !next2.transitions.length) {
        return this.next(state, _event);
      }
      return next2;
    };
    StateNode2.prototype.transitionParallelNode = function(stateValue, state, _event) {
      var e_2, _a2;
      var transitionMap = {};
      try {
        for (var _b = __values(Object.keys(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var subStateKey = _c.value;
          var subStateValue = stateValue[subStateKey];
          if (!subStateValue) {
            continue;
          }
          var subStateNode = this.getStateNode(subStateKey);
          var next2 = subStateNode._transition(subStateValue, state, _event);
          if (next2) {
            transitionMap[subStateKey] = next2;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_2)
            throw e_2.error;
        }
      }
      var stateTransitions = Object.keys(transitionMap).map(function(key) {
        return transitionMap[key];
      });
      var enabledTransitions = flatten$2(stateTransitions.map(function(st) {
        return st.transitions;
      }));
      var willTransition = stateTransitions.some(function(st) {
        return st.transitions.length > 0;
      });
      if (!willTransition) {
        return this.next(state, _event);
      }
      var configuration = flatten$2(Object.keys(transitionMap).map(function(key) {
        return transitionMap[key].configuration;
      }));
      return {
        transitions: enabledTransitions,
        exitSet: flatten$2(stateTransitions.map(function(t2) {
          return t2.exitSet;
        })),
        configuration,
        source: state,
        actions: flatten$2(Object.keys(transitionMap).map(function(key) {
          return transitionMap[key].actions;
        }))
      };
    };
    StateNode2.prototype._transition = function(stateValue, state, _event) {
      if (isString$1(stateValue)) {
        return this.transitionLeafNode(stateValue, state, _event);
      }
      if (Object.keys(stateValue).length === 1) {
        return this.transitionCompoundNode(stateValue, state, _event);
      }
      return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode2.prototype.getTransitionData = function(state, event2) {
      return this._transition(state.value, state, toSCXMLEvent(event2));
    };
    StateNode2.prototype.next = function(state, _event) {
      var e_3, _a2;
      var _this = this;
      var eventName = _event.name;
      var actions = [];
      var nextStateNodes = [];
      var selectedTransition;
      try {
        for (var _b = __values(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var candidate = _c.value;
          var cond = candidate.cond, stateIn = candidate.in;
          var resolvedContext = state.context;
          var isInState = stateIn ? isString$1(stateIn) && isStateId(stateIn) ? (
            // Check if in state by ID
            state.matches(toStateValue(this.getStateNodeById(stateIn).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            matchesState(toStateValue(stateIn, this.delimiter), path(this.path.slice(0, -2))(state.value))
          ) : true;
          var guardPassed = false;
          try {
            guardPassed = !cond || evaluateGuard(this.machine, cond, resolvedContext, _event, state);
          } catch (err) {
            throw new Error("Unable to evaluate guard '".concat(cond.name || cond.type, "' in transition for event '").concat(eventName, "' in state node '").concat(this.id, "':\n").concat(err.message));
          }
          if (guardPassed && isInState) {
            if (candidate.target !== void 0) {
              nextStateNodes = candidate.target;
            }
            actions.push.apply(actions, __spreadArray([], __read$1(candidate.actions), false));
            selectedTransition = candidate;
            break;
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a2 = _b.return))
            _a2.call(_b);
        } finally {
          if (e_3)
            throw e_3.error;
        }
      }
      if (!selectedTransition) {
        return void 0;
      }
      if (!nextStateNodes.length) {
        return {
          transitions: [selectedTransition],
          exitSet: [],
          configuration: state.value ? [this] : [],
          source: state,
          actions
        };
      }
      var allNextStateNodes = flatten$2(nextStateNodes.map(function(stateNode) {
        return _this.getRelativeStateNodes(stateNode, state.historyValue);
      }));
      var isInternal = !!selectedTransition.internal;
      return {
        transitions: [selectedTransition],
        exitSet: isInternal ? [] : flatten$2(nextStateNodes.map(function(targetNode) {
          return _this.getPotentiallyReenteringNodes(targetNode);
        })),
        configuration: allNextStateNodes,
        source: state,
        actions
      };
    };
    StateNode2.prototype.getPotentiallyReenteringNodes = function(targetNode) {
      if (this.order < targetNode.order) {
        return [this];
      }
      var nodes = [];
      var marker = this;
      var possibleAncestor = targetNode;
      while (marker && marker !== possibleAncestor) {
        nodes.push(marker);
        marker = marker.parent;
      }
      if (marker !== possibleAncestor) {
        return [];
      }
      nodes.push(possibleAncestor);
      return nodes;
    };
    StateNode2.prototype.getActions = function(resolvedConfig, isDone, transition, currentContext, _event, prevState, predictableExec) {
      var e_4, _a2, e_5, _b;
      var _this = this;
      var prevConfig = prevState ? getConfiguration([], this.getStateNodes(prevState.value)) : [];
      var entrySet = /* @__PURE__ */ new Set();
      try {
        for (var _c = __values(Array.from(resolvedConfig).sort(function(a4, b10) {
          return a4.order - b10.order;
        })), _d = _c.next(); !_d.done; _d = _c.next()) {
          var sn = _d.value;
          if (!has6(prevConfig, sn) || has6(transition.exitSet, sn) || sn.parent && entrySet.has(sn.parent)) {
            entrySet.add(sn);
          }
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_d && !_d.done && (_a2 = _c.return))
            _a2.call(_c);
        } finally {
          if (e_4)
            throw e_4.error;
        }
      }
      try {
        for (var prevConfig_1 = __values(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()) {
          var sn = prevConfig_1_1.value;
          if (!has6(resolvedConfig, sn) || has6(transition.exitSet, sn.parent)) {
            transition.exitSet.push(sn);
          }
        }
      } catch (e_5_1) {
        e_5 = {
          error: e_5_1
        };
      } finally {
        try {
          if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return))
            _b.call(prevConfig_1);
        } finally {
          if (e_5)
            throw e_5.error;
        }
      }
      transition.exitSet.sort(function(a4, b10) {
        return b10.order - a4.order;
      });
      var entryStates = Array.from(entrySet).sort(function(a4, b10) {
        return a4.order - b10.order;
      });
      var exitStates = new Set(transition.exitSet);
      var doneEvents = flatten$2(entryStates.map(function(sn2) {
        var events = [];
        if (sn2.type !== "final") {
          return events;
        }
        var parent2 = sn2.parent;
        if (!parent2.parent) {
          return events;
        }
        events.push(
          done(sn2.id, sn2.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          done(parent2.id, sn2.doneData ? mapContext(sn2.doneData, currentContext, _event) : void 0)
        );
        var grandparent = parent2.parent;
        if (grandparent.type === "parallel") {
          if (getChildren$1(grandparent).every(function(parentNode) {
            return isInFinalState(transition.configuration, parentNode);
          })) {
            events.push(done(grandparent.id));
          }
        }
        return events;
      }));
      var entryActions = entryStates.map(function(stateNode) {
        var entryActions2 = stateNode.onEntry;
        var invokeActions = stateNode.activities.map(function(activity) {
          return start(activity);
        });
        return {
          type: "entry",
          actions: toActionObjects(predictableExec ? __spreadArray(__spreadArray([], __read$1(entryActions2), false), __read$1(invokeActions), false) : __spreadArray(__spreadArray([], __read$1(invokeActions), false), __read$1(entryActions2), false), _this.machine.options.actions)
        };
      }).concat({
        type: "state_done",
        actions: doneEvents.map(function(event2) {
          return raise(event2);
        })
      });
      var exitActions = Array.from(exitStates).map(function(stateNode) {
        return {
          type: "exit",
          actions: toActionObjects(__spreadArray(__spreadArray([], __read$1(stateNode.onExit), false), __read$1(stateNode.activities.map(function(activity) {
            return stop(activity);
          })), false), _this.machine.options.actions)
        };
      });
      var actions = exitActions.concat({
        type: "transition",
        actions: toActionObjects(transition.actions, this.machine.options.actions)
      }).concat(entryActions);
      if (isDone) {
        var stopActions = toActionObjects(flatten$2(__spreadArray([], __read$1(resolvedConfig), false).sort(function(a4, b10) {
          return b10.order - a4.order;
        }).map(function(stateNode) {
          return stateNode.onExit;
        })), this.machine.options.actions).filter(function(action2) {
          return !isRaisableAction(action2);
        });
        return actions.concat({
          type: "stop",
          actions: stopActions
        });
      }
      return actions;
    };
    StateNode2.prototype.transition = function(state, event2, context, exec) {
      if (state === void 0) {
        state = this.initialState;
      }
      var _event = toSCXMLEvent(event2);
      var currentState;
      if (state instanceof State$1) {
        currentState = context === void 0 ? state : this.resolveState(State$1.from(state, context));
      } else {
        var resolvedStateValue = isString$1(state) ? this.resolve(pathToStateValue(this.getResolvedPath(state))) : this.resolve(state);
        var resolvedContext = context !== null && context !== void 0 ? context : this.machine.context;
        currentState = this.resolveState(State$1.from(resolvedStateValue, resolvedContext));
      }
      if (!IS_PRODUCTION && _event.name === WILDCARD) {
        throw new Error("An event cannot have the wildcard type ('".concat(WILDCARD, "')"));
      }
      if (this.strict) {
        if (!this.events.includes(_event.name) && !isBuiltInEvent(_event.name)) {
          throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(_event.name, "'"));
        }
      }
      var stateTransition = this._transition(currentState.value, currentState, _event) || {
        transitions: [],
        configuration: [],
        exitSet: [],
        source: currentState,
        actions: []
      };
      var prevConfig = getConfiguration([], this.getStateNodes(currentState.value));
      var resolvedConfig = stateTransition.configuration.length ? getConfiguration(prevConfig, stateTransition.configuration) : prevConfig;
      stateTransition.configuration = __spreadArray([], __read$1(resolvedConfig), false);
      return this.resolveTransition(stateTransition, currentState, currentState.context, exec, _event);
    };
    StateNode2.prototype.resolveRaisedTransition = function(state, _event, originalEvent, predictableExec) {
      var _a2;
      var currentActions = state.actions;
      state = this.transition(state, _event, void 0, predictableExec);
      state._event = originalEvent;
      state.event = originalEvent.data;
      (_a2 = state.actions).unshift.apply(_a2, __spreadArray([], __read$1(currentActions), false));
      return state;
    };
    StateNode2.prototype.resolveTransition = function(stateTransition, currentState, context, predictableExec, _event) {
      var e_6, _a2, e_7, _b;
      var _this = this;
      if (_event === void 0) {
        _event = initEvent;
      }
      var configuration = stateTransition.configuration;
      var willTransition = !currentState || stateTransition.transitions.length > 0;
      var resolvedConfiguration = willTransition ? stateTransition.configuration : currentState ? currentState.configuration : [];
      var isDone = isInFinalState(resolvedConfiguration, this);
      var resolvedStateValue = willTransition ? getValue$2(this.machine, configuration) : void 0;
      var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : void 0 : void 0;
      var actionBlocks = this.getActions(new Set(resolvedConfiguration), isDone, stateTransition, context, _event, currentState, predictableExec);
      var activities = currentState ? __assign$1({}, currentState.activities) : {};
      try {
        for (var actionBlocks_1 = __values(actionBlocks), actionBlocks_1_1 = actionBlocks_1.next(); !actionBlocks_1_1.done; actionBlocks_1_1 = actionBlocks_1.next()) {
          var block = actionBlocks_1_1.value;
          try {
            for (var _c = (e_7 = void 0, __values(block.actions)), _d = _c.next(); !_d.done; _d = _c.next()) {
              var action2 = _d.value;
              if (action2.type === start$1) {
                activities[action2.activity.id || action2.activity.type] = action2;
              } else if (action2.type === stop$1) {
                activities[action2.activity.id || action2.activity.type] = false;
              }
            }
          } catch (e_7_1) {
            e_7 = {
              error: e_7_1
            };
          } finally {
            try {
              if (_d && !_d.done && (_b = _c.return))
                _b.call(_c);
            } finally {
              if (e_7)
                throw e_7.error;
            }
          }
        }
      } catch (e_6_1) {
        e_6 = {
          error: e_6_1
        };
      } finally {
        try {
          if (actionBlocks_1_1 && !actionBlocks_1_1.done && (_a2 = actionBlocks_1.return))
            _a2.call(actionBlocks_1);
        } finally {
          if (e_6)
            throw e_6.error;
        }
      }
      var _e = __read$1(resolveActions(this, currentState, context, _event, actionBlocks, predictableExec, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), resolvedActions = _e[0], updatedContext = _e[1];
      var _f = __read$1(partition(resolvedActions, isRaisableAction), 2), raisedEvents = _f[0], nonRaisedActions = _f[1];
      var invokeActions = resolvedActions.filter(function(action3) {
        var _a3;
        return action3.type === start$1 && ((_a3 = action3.activity) === null || _a3 === void 0 ? void 0 : _a3.type) === invoke;
      });
      var children2 = invokeActions.reduce(function(acc, action3) {
        acc[action3.activity.id] = createInvocableActor(action3.activity, _this.machine, updatedContext, _event);
        return acc;
      }, currentState ? __assign$1({}, currentState.children) : {});
      var nextState = new State$1({
        value: resolvedStateValue || currentState.value,
        context: updatedContext,
        _event,
        // Persist _sessionid between states
        _sessionid: currentState ? currentState._sessionid : null,
        historyValue: resolvedStateValue ? historyValue ? updateHistoryValue(historyValue, resolvedStateValue) : void 0 : currentState ? currentState.historyValue : void 0,
        history: !resolvedStateValue || stateTransition.source ? currentState : void 0,
        actions: resolvedStateValue ? nonRaisedActions : [],
        activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
        events: [],
        configuration: resolvedConfiguration,
        transitions: stateTransition.transitions,
        children: children2,
        done: isDone,
        tags: getTagsFromConfiguration(resolvedConfiguration),
        machine: this
      });
      var didUpdateContext = context !== updatedContext;
      nextState.changed = _event.name === update || didUpdateContext;
      var history = nextState.history;
      if (history) {
        delete history.history;
      }
      var hasAlwaysTransitions = !isDone && (this._transient || configuration.some(function(stateNode) {
        return stateNode._transient;
      }));
      if (!willTransition && (!hasAlwaysTransitions || _event.name === NULL_EVENT)) {
        return nextState;
      }
      var maybeNextState = nextState;
      if (!isDone) {
        if (hasAlwaysTransitions) {
          maybeNextState = this.resolveRaisedTransition(maybeNextState, {
            type: nullEvent
          }, _event, predictableExec);
        }
        while (raisedEvents.length) {
          var raisedEvent = raisedEvents.shift();
          maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event, predictableExec);
        }
      }
      var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !stateValuesEqual(maybeNextState.value, history.value) : void 0);
      maybeNextState.changed = changed;
      maybeNextState.history = history;
      return maybeNextState;
    };
    StateNode2.prototype.getStateNode = function(stateKey) {
      if (isStateId(stateKey)) {
        return this.machine.getStateNodeById(stateKey);
      }
      if (!this.states) {
        throw new Error("Unable to retrieve child state '".concat(stateKey, "' from '").concat(this.id, "'; no child states exist."));
      }
      var result = this.states[stateKey];
      if (!result) {
        throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
      }
      return result;
    };
    StateNode2.prototype.getStateNodeById = function(stateId) {
      var resolvedStateId = isStateId(stateId) ? stateId.slice(STATE_IDENTIFIER.length) : stateId;
      if (resolvedStateId === this.id) {
        return this;
      }
      var stateNode = this.machine.idMap[resolvedStateId];
      if (!stateNode) {
        throw new Error("Child state node '#".concat(resolvedStateId, "' does not exist on machine '").concat(this.id, "'"));
      }
      return stateNode;
    };
    StateNode2.prototype.getStateNodeByPath = function(statePath) {
      if (typeof statePath === "string" && isStateId(statePath)) {
        try {
          return this.getStateNodeById(statePath.slice(1));
        } catch (e3) {
        }
      }
      var arrayStatePath = toStatePath(statePath, this.delimiter).slice();
      var currentStateNode = this;
      while (arrayStatePath.length) {
        var key = arrayStatePath.shift();
        if (!key.length) {
          break;
        }
        currentStateNode = currentStateNode.getStateNode(key);
      }
      return currentStateNode;
    };
    StateNode2.prototype.resolve = function(stateValue) {
      var _a2;
      var _this = this;
      if (!stateValue) {
        return this.initialStateValue || EMPTY_OBJECT;
      }
      switch (this.type) {
        case "parallel":
          return mapValues(this.initialStateValue, function(subStateValue, subStateKey) {
            return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : EMPTY_OBJECT;
          });
        case "compound":
          if (isString$1(stateValue)) {
            var subStateNode = this.getStateNode(stateValue);
            if (subStateNode.type === "parallel" || subStateNode.type === "compound") {
              return _a2 = {}, _a2[stateValue] = subStateNode.initialStateValue, _a2;
            }
            return stateValue;
          }
          if (!Object.keys(stateValue).length) {
            return this.initialStateValue || {};
          }
          return mapValues(stateValue, function(subStateValue, subStateKey) {
            return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : EMPTY_OBJECT;
          });
        default:
          return stateValue || EMPTY_OBJECT;
      }
    };
    StateNode2.prototype.getResolvedPath = function(stateIdentifier) {
      if (isStateId(stateIdentifier)) {
        var stateNode = this.machine.idMap[stateIdentifier.slice(STATE_IDENTIFIER.length)];
        if (!stateNode) {
          throw new Error("Unable to find state node '".concat(stateIdentifier, "'"));
        }
        return stateNode.path;
      }
      return toStatePath(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode2.prototype, "initialStateValue", {
      get: function() {
        var _a2;
        if (this.__cache.initialStateValue) {
          return this.__cache.initialStateValue;
        }
        var initialStateValue;
        if (this.type === "parallel") {
          initialStateValue = mapFilterValues(this.states, function(state) {
            return state.initialStateValue || EMPTY_OBJECT;
          }, function(stateNode) {
            return !(stateNode.type === "history");
          });
        } else if (this.initial !== void 0) {
          if (!this.states[this.initial]) {
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          }
          initialStateValue = isLeafNode(this.states[this.initial]) ? this.initial : (_a2 = {}, _a2[this.initial] = this.states[this.initial].initialStateValue, _a2);
        } else {
          initialStateValue = {};
        }
        this.__cache.initialStateValue = initialStateValue;
        return this.__cache.initialStateValue;
      },
      enumerable: false,
      configurable: true
    });
    StateNode2.prototype.getInitialState = function(stateValue, context) {
      this._init();
      var configuration = this.getStateNodes(stateValue);
      return this.resolveTransition({
        configuration,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, context !== null && context !== void 0 ? context : this.machine.context, void 0);
    };
    Object.defineProperty(StateNode2.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var initialStateValue = this.initialStateValue;
        if (!initialStateValue) {
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        }
        return this.getInitialState(initialStateValue);
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateNode2.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var target;
        if (this.type === "history") {
          var historyConfig = this.config;
          if (isString$1(historyConfig.target)) {
            target = isStateId(historyConfig.target) ? pathToStateValue(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
          } else {
            target = historyConfig.target;
          }
        }
        return target;
      },
      enumerable: false,
      configurable: true
    });
    StateNode2.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
      if (resolve === void 0) {
        resolve = true;
      }
      return resolve ? relativeStateId.type === "history" ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [relativeStateId];
    };
    Object.defineProperty(StateNode2.prototype, "initialStateNodes", {
      get: function() {
        var _this = this;
        if (isLeafNode(this)) {
          return [this];
        }
        if (this.type === "compound" && !this.initial) {
          if (!IS_PRODUCTION) {
            warn$1(false, "Compound state node '".concat(this.id, "' has no initial state."));
          }
          return [this];
        }
        var initialStateNodePaths = toStatePaths(this.initialStateValue);
        return flatten$2(initialStateNodePaths.map(function(initialPath) {
          return _this.getFromRelativePath(initialPath);
        }));
      },
      enumerable: false,
      configurable: true
    });
    StateNode2.prototype.getFromRelativePath = function(relativePath) {
      if (!relativePath.length) {
        return [this];
      }
      var _a2 = __read$1(relativePath), stateKey = _a2[0], childStatePath = _a2.slice(1);
      if (!this.states) {
        throw new Error("Cannot retrieve subPath '".concat(stateKey, "' from node with no states"));
      }
      var childStateNode = this.getStateNode(stateKey);
      if (childStateNode.type === "history") {
        return childStateNode.resolveHistory();
      }
      if (!this.states[stateKey]) {
        throw new Error("Child state '".concat(stateKey, "' does not exist on '").concat(this.id, "'"));
      }
      return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode2.prototype.historyValue = function(relativeStateValue) {
      if (!Object.keys(this.states).length) {
        return void 0;
      }
      return {
        current: relativeStateValue || this.initialStateValue,
        states: mapFilterValues(this.states, function(stateNode, key) {
          if (!relativeStateValue) {
            return stateNode.historyValue();
          }
          var subStateValue = isString$1(relativeStateValue) ? void 0 : relativeStateValue[key];
          return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
        }, function(stateNode) {
          return !stateNode.history;
        })
      };
    };
    StateNode2.prototype.resolveHistory = function(historyValue) {
      var _this = this;
      if (this.type !== "history") {
        return [this];
      }
      var parent2 = this.parent;
      if (!historyValue) {
        var historyTarget = this.target;
        return historyTarget ? flatten$2(toStatePaths(historyTarget).map(function(relativeChildPath) {
          return parent2.getFromRelativePath(relativeChildPath);
        })) : parent2.initialStateNodes;
      }
      var subHistoryValue = nestedPath(parent2.path, "states")(historyValue).current;
      if (isString$1(subHistoryValue)) {
        return [parent2.getStateNode(subHistoryValue)];
      }
      return flatten$2(toStatePaths(subHistoryValue).map(function(subStatePath) {
        return _this.history === "deep" ? parent2.getFromRelativePath(subStatePath) : [parent2.states[subStatePath[0]]];
      }));
    };
    Object.defineProperty(StateNode2.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var _this = this;
        var childStateIds = flatten$2(Object.keys(this.states).map(function(stateKey) {
          return _this.states[stateKey].stateIds;
        }));
        return [this.id].concat(childStateIds);
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateNode2.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var e_8, _a2, e_9, _b;
        if (this.__cache.events) {
          return this.__cache.events;
        }
        var states = this.states;
        var events = new Set(this.ownEvents);
        if (states) {
          try {
            for (var _c = __values(Object.keys(states)), _d = _c.next(); !_d.done; _d = _c.next()) {
              var stateId = _d.value;
              var state = states[stateId];
              if (state.states) {
                try {
                  for (var _e = (e_9 = void 0, __values(state.events)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var event_1 = _f.value;
                    events.add("".concat(event_1));
                  }
                } catch (e_9_1) {
                  e_9 = {
                    error: e_9_1
                  };
                } finally {
                  try {
                    if (_f && !_f.done && (_b = _e.return))
                      _b.call(_e);
                  } finally {
                    if (e_9)
                      throw e_9.error;
                  }
                }
              }
            }
          } catch (e_8_1) {
            e_8 = {
              error: e_8_1
            };
          } finally {
            try {
              if (_d && !_d.done && (_a2 = _c.return))
                _a2.call(_c);
            } finally {
              if (e_8)
                throw e_8.error;
            }
          }
        }
        return this.__cache.events = Array.from(events);
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateNode2.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var events = new Set(this.transitions.filter(function(transition) {
          return !(!transition.target && !transition.actions.length && transition.internal);
        }).map(function(transition) {
          return transition.eventType;
        }));
        return Array.from(events);
      },
      enumerable: false,
      configurable: true
    });
    StateNode2.prototype.resolveTarget = function(_target) {
      var _this = this;
      if (_target === void 0) {
        return void 0;
      }
      return _target.map(function(target) {
        if (!isString$1(target)) {
          return target;
        }
        var isInternalTarget = target[0] === _this.delimiter;
        if (isInternalTarget && !_this.parent) {
          return _this.getStateNodeByPath(target.slice(1));
        }
        var resolvedTarget = isInternalTarget ? _this.key + target : target;
        if (_this.parent) {
          try {
            var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
            return targetStateNode;
          } catch (err) {
            throw new Error("Invalid transition definition for state node '".concat(_this.id, "':\n").concat(err.message));
          }
        } else {
          return _this.getStateNodeByPath(resolvedTarget);
        }
      });
    };
    StateNode2.prototype.formatTransition = function(transitionConfig) {
      var _this = this;
      var normalizedTarget = normalizeTarget(transitionConfig.target);
      var internal = "internal" in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
        return isString$1(_target) && _target[0] === _this.delimiter;
      }) : true;
      var guards = this.machine.options.guards;
      var target = this.resolveTarget(normalizedTarget);
      var transition = __assign$1(__assign$1({}, transitionConfig), {
        actions: toActionObjects(toArray$2(transitionConfig.actions)),
        cond: toGuard(transitionConfig.cond, guards),
        target,
        source: this,
        internal,
        eventType: transitionConfig.event,
        toJSON: function() {
          return __assign$1(__assign$1({}, transition), {
            target: transition.target ? transition.target.map(function(t2) {
              return "#".concat(t2.id);
            }) : void 0,
            source: "#".concat(_this.id)
          });
        }
      });
      return transition;
    };
    StateNode2.prototype.formatTransitions = function() {
      var e_10, _a2;
      var _this = this;
      var onConfig;
      if (!this.config.on) {
        onConfig = [];
      } else if (Array.isArray(this.config.on)) {
        onConfig = this.config.on;
      } else {
        var _b = this.config.on, _c = WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = __rest$1(_b, [typeof _c === "symbol" ? _c : _c + ""]);
        onConfig = flatten$2(Object.keys(strictTransitionConfigs_1).map(function(key) {
          if (!IS_PRODUCTION && key === NULL_EVENT) {
            warn$1(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(_this.id, '".'));
          }
          var transitionConfigArray = toTransitionConfigArray(key, strictTransitionConfigs_1[key]);
          if (!IS_PRODUCTION) {
            validateArrayifiedTransitions(_this, key, transitionConfigArray);
          }
          return transitionConfigArray;
        }).concat(toTransitionConfigArray(WILDCARD, wildcardConfigs)));
      }
      var eventlessConfig = this.config.always ? toTransitionConfigArray("", this.config.always) : [];
      var doneConfig = this.config.onDone ? toTransitionConfigArray(String(done(this.id)), this.config.onDone) : [];
      if (!IS_PRODUCTION) {
        warn$1(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
      }
      var invokeConfig = flatten$2(this.invoke.map(function(invokeDef) {
        var settleTransitions = [];
        if (invokeDef.onDone) {
          settleTransitions.push.apply(settleTransitions, __spreadArray([], __read$1(toTransitionConfigArray(String(doneInvoke(invokeDef.id)), invokeDef.onDone)), false));
        }
        if (invokeDef.onError) {
          settleTransitions.push.apply(settleTransitions, __spreadArray([], __read$1(toTransitionConfigArray(String(error(invokeDef.id)), invokeDef.onError)), false));
        }
        return settleTransitions;
      }));
      var delayedTransitions = this.after;
      var formattedTransitions = flatten$2(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read$1(doneConfig), false), __read$1(invokeConfig), false), __read$1(onConfig), false), __read$1(eventlessConfig), false).map(function(transitionConfig) {
        return toArray$2(transitionConfig).map(function(transition) {
          return _this.formatTransition(transition);
        });
      }));
      try {
        for (var delayedTransitions_1 = __values(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()) {
          var delayedTransition = delayedTransitions_1_1.value;
          formattedTransitions.push(delayedTransition);
        }
      } catch (e_10_1) {
        e_10 = {
          error: e_10_1
        };
      } finally {
        try {
          if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a2 = delayedTransitions_1.return))
            _a2.call(delayedTransitions_1);
        } finally {
          if (e_10)
            throw e_10.error;
        }
      }
      return formattedTransitions;
    };
    return StateNode2;
  }()
);
var warned = false;
function createMachine(config2, options2) {
  if (!IS_PRODUCTION && !("predictableActionArguments" in config2) && !warned) {
    warned = true;
    console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html");
  }
  return new StateNode(config2, options2);
}
var assign3 = assign$1;
var index = useLayoutEffect;
function useConstant(fn2) {
  var ref2 = React.useRef();
  if (!ref2.current) {
    ref2.current = { v: fn2() };
  }
  return ref2.current.v;
}
var __assign = function() {
  __assign = Object.assign || function(t2) {
    for (var s4, i2 = 1, n = arguments.length; i2 < n; i2++) {
      s4 = arguments[i2];
      for (var p in s4)
        if (Object.prototype.hasOwnProperty.call(s4, p))
          t2[p] = s4[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s4, e3) {
  var t2 = {};
  for (var p in s4)
    if (Object.prototype.hasOwnProperty.call(s4, p) && e3.indexOf(p) < 0)
      t2[p] = s4[p];
  if (s4 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s4); i2 < p.length; i2++) {
      if (e3.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s4, p[i2]))
        t2[p[i2]] = s4[p[i2]];
    }
  return t2;
};
var __read = function(o, n) {
  var m3 = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m3)
    return o;
  var i2 = m3.call(o), r, ar = [], e3;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i2.next()).done)
      ar.push(r.value);
  } catch (error2) {
    e3 = { error: error2 };
  } finally {
    try {
      if (r && !r.done && (m3 = i2["return"]))
        m3.call(i2);
    } finally {
      if (e3)
        throw e3.error;
    }
  }
  return ar;
};
function useIdleInterpreter(getMachine, options2) {
  var machine = useConstant(function() {
    return typeof getMachine === "function" ? getMachine() : getMachine;
  });
  if (process.env.NODE_ENV !== "production" && typeof getMachine !== "function") {
    var _a2 = __read(useState(machine), 1), initialMachine = _a2[0];
    if (getMachine !== initialMachine) {
      console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
    }
  }
  var context = options2.context, guards = options2.guards, actions = options2.actions, activities = options2.activities, services = options2.services, delays = options2.delays;
  options2.state;
  var interpreterOptions = __rest(options2, ["context", "guards", "actions", "activities", "services", "delays", "state"]);
  var service = useConstant(function() {
    var machineConfig = {
      context,
      guards,
      actions,
      activities,
      services,
      delays
    };
    var machineWithConfig = machine.withConfig(machineConfig, function() {
      return __assign(__assign({}, machine.context), context);
    });
    return interpret(machineWithConfig, interpreterOptions);
  });
  index(function() {
    Object.assign(service.machine.options.actions, actions);
    Object.assign(service.machine.options.guards, guards);
    Object.assign(service.machine.options.activities, activities);
    Object.assign(service.machine.options.services, services);
    Object.assign(service.machine.options.delays, delays);
  }, [actions, guards, activities, services, delays]);
  return service;
}
function useInterpret(getMachine) {
  var _a2 = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    _a2[_i - 1] = arguments[_i];
  }
  var _b = __read(_a2, 2), _c = _b[0], options2 = _c === void 0 ? {} : _c, observerOrListener = _b[1];
  var service = useIdleInterpreter(getMachine, options2);
  useEffect(function() {
    if (!observerOrListener) {
      return;
    }
    var sub = service.subscribe(toObserver(observerOrListener));
    return function() {
      sub.unsubscribe();
    };
  }, [observerOrListener]);
  useEffect(function() {
    var rehydratedState = options2.state;
    service.start(rehydratedState ? State$1.create(rehydratedState) : void 0);
    return function() {
      service.stop();
      service.status = InterpreterStatus.NotStarted;
    };
  }, []);
  return service;
}
(function(o, n) {
  var m3 = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m3)
    return o;
  var i2 = m3.call(o), r, ar = [], e3;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i2.next()).done)
      ar.push(r.value);
  } catch (error2) {
    e3 = { error: error2 };
  } finally {
    try {
      if (r && !r.done && (m3 = i2["return"]))
        m3.call(i2);
    } finally {
      if (e3)
        throw e3.error;
    }
  }
  return ar;
});
(function(o) {
  var s4 = typeof Symbol === "function" && Symbol.iterator, m3 = s4 && o[s4], i2 = 0;
  if (m3)
    return m3.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i2 >= o.length)
          o = void 0;
        return { value: o && o[i2++], done: !o };
      }
    };
  throw new TypeError(s4 ? "Object is not iterable." : "Symbol.iterator is not defined.");
});
function getServiceSnapshot(service) {
  return service.status !== 0 ? service.getSnapshot() : service.machine.initialState;
}
function isService(actor) {
  return "state" in actor && "machine" in actor;
}
function isActorWithState(actorRef) {
  return "state" in actorRef;
}
var defaultCompare = function(a4, b10) {
  return a4 === b10;
};
var defaultGetSnapshot = function(a4, initialStateCacheRef) {
  if (isService(a4)) {
    if (a4.status === 0 && initialStateCacheRef.current) {
      return initialStateCacheRef.current;
    }
    var snapshot = getServiceSnapshot(a4);
    initialStateCacheRef.current = a4.status === 0 ? snapshot : null;
    return snapshot;
  }
  return isActorWithState(a4) ? a4.state : void 0;
};
function useSelector(actor, selector, compare, getSnapshot) {
  if (compare === void 0) {
    compare = defaultCompare;
  }
  var initialStateCacheRef = useRef(null);
  var subscribe = useCallback(function(handleStoreChange) {
    var unsubscribe = actor.subscribe(handleStoreChange).unsubscribe;
    return unsubscribe;
  }, [actor]);
  var boundGetSnapshot = useCallback(function() {
    if (getSnapshot) {
      return getSnapshot(actor);
    }
    return defaultGetSnapshot(actor, initialStateCacheRef);
  }, [actor, getSnapshot]);
  var selectedSnapshot = withSelectorExports.useSyncExternalStoreWithSelector(subscribe, boundGetSnapshot, boundGetSnapshot, selector, compare);
  return selectedSnapshot;
}
const WorkflowStepContext = React__default.createContext(
  {}
);
const useWorkflowStep = () => {
  const context = React__default.useContext(WorkflowStepContext);
  if (!context) {
    throw new Error(
      "useWorkflowState must be used within a <WorkflowStepContext.Provider>"
    );
  }
  return context;
};
const toCamelCase$1 = (text2) => {
  const a4 = text2.toLowerCase().replace(/[-_\s.]+(.)?/g, (_, c7) => c7 ? c7.toUpperCase() : "");
  return a4.substring(0, 1).toLowerCase() + a4.substring(1);
};
const normalizeStateName = (name2) => name2 ? toCamelCase$1(name2) : "";
function createFastContext(initialState2) {
  function useStoreData() {
    const store = useRef(initialState2);
    const get9 = useCallback(() => store.current, []);
    const subscribers = useRef(/* @__PURE__ */ new Set());
    const set = useCallback(
      (value) => {
        let valueToReplace = value;
        if (typeof value === "function") {
          valueToReplace = value(store.current);
        }
        store.current = { ...store.current, ...valueToReplace };
        subscribers.current.forEach((callback) => callback());
      },
      []
    );
    const subscribe = useCallback((callback) => {
      subscribers.current.add(callback);
      return () => subscribers.current.delete(callback);
    }, []);
    return {
      get: get9,
      set,
      subscribe
    };
  }
  const StoreContext = createContext(null);
  function Provider2({ children: children2 }) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(StoreContext.Provider, { value: useStoreData(), children: children2 });
  }
  function useStore(selector) {
    const store = useContext(StoreContext);
    if (!store) {
      throw new Error("Store not found");
    }
    const state = shimExports.useSyncExternalStore(
      store.subscribe,
      () => selector(store.get()),
      () => selector(initialState2)
    );
    return [state, store.set];
  }
  function useWeakStore(selector) {
    const store = useContext(StoreContext);
    const subscribe = (store == null ? void 0 : store.subscribe) || (() => noop$6);
    const state = shimExports.useSyncExternalStore(
      subscribe,
      () => selector(store ? store.get() : {}),
      () => selector(initialState2)
    );
    if (!store) {
      return void 0;
    }
    return [state, store.set];
  }
  return {
    Provider: Provider2,
    useStore,
    useWeakStore
  };
}
const { Provider: WorkflowProvider, useStore: useWorkflow } = createFastContext({
  initialStepperSteps: [],
  machine: void 0,
  machineConfig: void 0,
  path: void 0,
  service: void 0,
  stepperIdxWorkflowIdMap: {},
  stepperSteps: [],
  uiConfig: {}
});
const useWorkflowService = () => {
  const [service] = useWorkflow(
    (store) => store.service || {}
  );
  return service;
};
const STATE_NAME_DELIMITER = ":";
const ID_DELIMITER = "_";
const ID_INVOKED_MACHINE = "invokedMachine";
const ID_PARALLEL_SERVICES = "parallelServices";
const JUMP_EVENT_PREFIX = "JUMP_TO_STEP_#";
const STATE_TYPES = {
  // atomic = "atomic", // no state child states, leaf node
  COMPOUND: "compound",
  // one or more child states, has initial state
  FINAL: "final",
  //  leaf node representing an abstract "terminal" state
  HISTORY: "history",
  //  abstract node that represents resolving to its parent node's most recent shallow or deep history state
  PARALLEL: "parallel"
  // two or more child states, no initial state
};
const WORKFLOW_TYPES = {
  GROUP: "GROUP",
  STEP: "STEP",
  STEP_VIEW: "STEP_VIEW",
  STEP_VIEW_PICKER: "STEP_VIEW_PICKER"
};
const XStateAstNodes = {
  CHILD_MACHINE: "childMachine",
  GROUP_STATE: "groupState",
  STATE: "state",
  STATE_VIEW: "stateView"
  // states that display React components
};
const clampProgressNumber = (progress) => progress !== void 0 && progress >= 0 ? Math.min(Math.max(progress, 0), 1) : 0;
const getFormId = (workflowStateId) => `workflow-form-${workflowStateId}`;
const getState = (stateValue, workflowXStateFullStateId) => {
  const states = workflowXStateFullStateId == null ? void 0 : workflowXStateFullStateId.split(STATE_NAME_DELIMITER);
  return states == null ? void 0 : states.reduce((acc, state) => acc == null ? void 0 : acc[state], stateValue);
};
const createGenericAction = (actionType, stateName, event2) => ({
  type: `${actionType}${stateName ? `_${stateName}` : ""}`,
  ...event2
});
const createSetActiveAction = (stateName, event2) => createGenericAction("SET_ACTIVE", stateName, event2);
const createSetErrorAction = (stateName, event2) => createGenericAction("SET_ERROR", stateName, event2);
const createSetLoadingAction = (stateName, event2) => createGenericAction("SET_LOADING", stateName, event2);
const createSetSubmittingAction = (stateName, event2) => createGenericAction("SET_SUBMITTING", stateName, event2);
const createSetSuccessAction = (stateName, event2) => createGenericAction("SET_SUCCESS", stateName, event2);
const createJumpToStepAction = (normalizedMachineName, workflowFullStateId) => ({
  type: `${JUMP_EVENT_PREFIX}${normalizedMachineName}${STATE_NAME_DELIMITER}${workflowFullStateId}`,
  ...workflowFullStateId && {
    data: {
      currentlySelectedStep: workflowFullStateId
    }
  }
});
const createAssignContextAction = (eventData) => createGenericAction("ASSIGN_CTX", void 0, { data: eventData });
const createUpdateContextAction = (eventData) => createGenericAction("UPDATE_CTX", void 0, { data: eventData });
const createUpdateFormDataContextAction = (eventData) => createGenericAction("UPDATE_FORM_DATA_CTX", void 0, { data: eventData });
const useWorkflowStepHelper = (stepName) => {
  const normalizedStepName = stepName ? normalizeStateName(stepName) : void 0;
  const [machineConfig] = useWorkflow((store) => store.machineConfig);
  const service = useWorkflowService();
  const {
    workflowFullStateId,
    workflowGroupId,
    workflowStateId,
    workflowXStateFullStateId
  } = useWorkflowStep();
  const inStepViewPicker = normalizedStepName != void 0 && normalizedStepName !== workflowStateId;
  const finalStateId = inStepViewPicker ? normalizedStepName : workflowStateId;
  const { id: machineName } = machineConfig;
  const normalizedMachineName = normalizeStateName(machineName);
  const jumpToSelf = () => service.send(
    createJumpToStepAction(normalizedMachineName, workflowFullStateId)
  );
  const inWorkflowContext = !!service;
  const formId = inWorkflowContext && !!finalStateId ? getFormId(finalStateId) : void 0;
  const stepsUsingGuiForm = useSelector(
    service,
    (state2) => state2.context.workflow.stepsUsingGuiForm
  );
  const setActiveState = () => service.send(createSetActiveAction(finalStateId));
  const setErrorState = () => service.send(createSetErrorAction(finalStateId));
  const setLoadingState = () => service.send(createSetLoadingAction(finalStateId));
  const setSubmittingState = () => service.send(createSetSubmittingAction(finalStateId));
  const setSuccessState = () => service.send(createSetSuccessAction(finalStateId));
  const updateContext2 = (contextChange) => service.send(createUpdateContextAction(contextChange));
  const setProgressFor = (workflowNormalizedIds, progress) => {
    const progressNumber = clampProgressNumber(progress);
    const progressData = {};
    const workflowStateId2 = workflowNormalizedIds[workflowNormalizedIds.length - 1];
    const workflowGroupId2 = workflowNormalizedIds.slice(0, -1);
    if (workflowGroupId2 && workflowStateId2) {
      for (let i2 = 0; i2 < workflowGroupId2.length; i2++) {
        const groupId = workflowGroupId2[i2];
        if (groupId) {
          if (!progressData[groupId]) {
            progressData[groupId] = {};
          }
          const lastLevelIdx = workflowGroupId2.length - 1;
          if (i2 === lastLevelIdx) {
            progressData[groupId][workflowStateId2] = progressNumber;
          }
        }
      }
      updateContext2({
        workflow: {
          progressData
        }
      });
    }
  };
  const setProgress = (progress) => setProgressFor(
    [...workflowGroupId || [void 0], workflowStateId],
    progress
  );
  const finalWorkflowXStateFullStateId = inStepViewPicker ? `${workflowXStateFullStateId}${STATE_NAME_DELIMITER}${stepName}` : workflowXStateFullStateId;
  const state = useSelector(service, (state2) => {
    const stateValue = state2.value;
    if (typeof stateValue === "string" && state2.value === stepName) {
      return "active";
    }
    const currentState = getState(stateValue, finalWorkflowXStateFullStateId);
    return currentState;
  });
  const xStateState = useSelector(service, (state2) => state2);
  const groupHasState = useSelector(service, (state2) => {
    const stateValue = state2.value;
    let hasState = true;
    const [groupXStateName] = (workflowXStateFullStateId == null ? void 0 : workflowXStateFullStateId.split(STATE_NAME_DELIMITER)) || [];
    const groupStateValue = stateValue == null ? void 0 : stateValue[groupXStateName];
    if (groupStateValue && Object.keys(groupStateValue).length === 0) {
      hasState = false;
    }
    return hasState;
  });
  const xStatePathId = finalWorkflowXStateFullStateId == null ? void 0 : finalWorkflowXStateFullStateId.replace(":", ".");
  const isActiveState = state === "active";
  const isErrorState = state === "error";
  const isLoadingState = state === "loading";
  const isSubmittingState = state === "submitting";
  const isSuccessState = xStateState.matches(`${xStatePathId}.success`);
  const isSuccessPreActionRunState = xStateState.matches(
    `${xStatePathId}.success.preActionRun`
  );
  const isSuccessCustomActionRunState = xStateState.matches(
    `${xStatePathId}.success.customActionRun`
  );
  const isSuccessActionRunState = xStateState.matches(
    `${xStatePathId}.success.actionRun`
  );
  const isSuccessCompletedState = xStateState.matches(
    `${xStatePathId}.success.completed`
  );
  return {
    // GUI Form
    formId,
    inWorkflowContext,
    // State
    isActiveState,
    isErrorState,
    isLoadingState,
    isSubmittingState,
    isSuccessState,
    isSuccessPreActionRunState,
    isSuccessCustomActionRunState,
    isSuccessActionRunState,
    isSuccessCompletedState,
    setActiveState,
    setErrorState,
    setLoadingState,
    setSubmittingState,
    setSuccessState,
    state,
    // Others
    groupHasState,
    inStepViewPicker,
    jumpToSelf,
    machineName,
    setProgress,
    /** what... */
    setProgressFor,
    stepsUsingGuiForm,
    workflowFullStateId,
    workflowStateId: finalStateId
  };
};
function GuiBaseFormInner(props2, ref2) {
  const { children: children2, focusFirst, focusFirstOptions, ...restOfProps } = props2;
  useFocusFirst({
    focusFirst: Boolean(focusFirst),
    options: focusFirstOptions,
    formRef: ref2
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Form$1, { ref: ref2, ...restOfProps, children: children2 });
}
const GuiBaseForm = React__default.forwardRef(
  GuiBaseFormInner
);
function GuiBaseFormForWorkflowInner(props2, ref2) {
  const { children: children2, focusFirst, focusFirstOptions, id, ...restOfProps } = props2;
  const { formId, inWorkflowContext } = useWorkflowStepHelper();
  const [, setStore] = useWorkflow((store) => store.hasFormLoaded);
  useEffect(() => setStore({ hasFormLoaded: /* @__PURE__ */ new Date() }), [setStore]);
  useFocusFirst({
    focusFirst: Boolean(focusFirst),
    options: focusFirstOptions,
    formRef: ref2
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Form$1,
    {
      "data-using-gui-form": inWorkflowContext,
      id: id || formId,
      ref: ref2,
      ...restOfProps,
      children: children2
    }
  );
}
const GuiBaseFormForWorkflow = React__default.forwardRef(GuiBaseFormForWorkflowInner);
const GuiFormProvider = ({
  children: children2,
  initialValues,
  onSubmit,
  validationSchema: validationSchema2,
  ...restOfProps
}) => {
  const [errorsFromServer, setErrorsFromServer] = useState(
    []
  );
  const [controller] = useState(() => new AbortController());
  const { signal } = controller;
  const clearErrorsFromServer = () => setErrorsFromServer([]);
  const wrapperSubmit = useCallback(
    (data, helpers) => onGuiFormSubmit({
      data,
      helpers,
      onSubmit,
      clearErrorsFromServer,
      errorsFromServer,
      setErrorsFromServer,
      signal
    }),
    [errorsFromServer, onSubmit, signal]
  );
  useEffect(() => () => controller.abort(), []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    GuiFormCtxProvider,
    {
      value: { clearErrorsFromServer, errorsFromServer, setErrorsFromServer },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Formik,
        {
          initialValues,
          onSubmit: wrapperSubmit,
          validationSchema: validationSchema2,
          ...restOfProps,
          children: (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(GuiFormMergedContextProvider, { formikProps: props2, children: children2 })
        }
      )
    }
  );
};
const GuiFormProviderForWorkflow = ({
  children: children2,
  initialValues,
  onSubmit,
  validationSchema: validationSchema2,
  ...restOfProps
}) => {
  const [errorsFromServer, setErrorsFromServer] = useState(
    []
  );
  const [controller] = useState(() => new AbortController());
  const { signal } = controller;
  const {
    inWorkflowContext,
    setErrorState,
    setSubmittingState,
    setSuccessState
  } = useWorkflowStepHelper();
  const clearErrorsFromServer = () => setErrorsFromServer([]);
  const wrapperSubmit = useCallback(
    (data, helpers) => onGuiFormSubmit({
      data,
      helpers,
      onSubmit,
      clearErrorsFromServer,
      errorsFromServer,
      setErrorsFromServer,
      signal,
      // Workflow
      inWorkflowContext,
      setErrorState,
      setSubmittingState,
      setSuccessState
    }),
    [
      errorsFromServer,
      inWorkflowContext,
      onSubmit,
      setErrorState,
      setSubmittingState,
      setSuccessState,
      signal
    ]
  );
  useEffect(() => () => controller.abort(), []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    GuiFormCtxProvider,
    {
      value: { clearErrorsFromServer, errorsFromServer, setErrorsFromServer },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Formik,
        {
          initialValues,
          onSubmit: wrapperSubmit,
          validationSchema: validationSchema2,
          ...restOfProps,
          children: (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(GuiFormMergedContextProvider, { formikProps: props2, children: children2 })
        }
      )
    }
  );
};
const onGuiFormSubmit = ({
  data,
  helpers,
  onSubmit,
  clearErrorsFromServer,
  errorsFromServer,
  setErrorsFromServer,
  signal,
  // Workflow items
  inWorkflowContext,
  setErrorState,
  setSubmittingState,
  setSuccessState
}) => {
  const { setSubmitting } = helpers || {};
  let shouldRun = true;
  let isPromiseRejected = false;
  return Promise.resolve({
    then(res) {
      signal.addEventListener("abort", () => {
        shouldRun = false;
      });
      inWorkflowContext && (setSubmittingState == null ? void 0 : setSubmittingState());
      res == null ? void 0 : res(
        onSubmit == null ? void 0 : onSubmit(data, {
          ...helpers,
          clearErrorsFromServer,
          errorsFromServer,
          setErrorsFromServer
        })
      );
    }
  }).catch((errors) => {
    if (shouldRun) {
      isPromiseRejected = true;
      if (errors) {
        setErrorsFromServer(errors);
      }
      setSubmitting(false);
      inWorkflowContext && (setErrorState == null ? void 0 : setErrorState());
    }
  }).then(() => {
    if (shouldRun && !isPromiseRejected) {
      setSubmitting(false);
      inWorkflowContext && (setSuccessState == null ? void 0 : setSuccessState());
    }
  });
};
const currentlySelectedStepSelector = (state) => state.context.workflow.currentlySelectedStep;
const contextSelector = (state) => state.context;
const useWorkflowContext = () => {
  const service = useWorkflowService();
  return useSelector(service, contextSelector);
};
const SyncFormWithWorkflow = () => {
  const guiForm = useGuiForm();
  const service = useWorkflowService();
  const updateContextDebounced = useCallback(
    debounce$3((guiForm2) => {
      service.send(
        createUpdateFormDataContextAction({
          formData: guiForm2.values
        })
      );
    }, Throttle.forms),
    []
  );
  useEffect(() => {
    if (guiForm && service) {
      updateContextDebounced(guiForm);
    }
  }, [guiForm == null ? void 0 : guiForm.values]);
  return null;
};
const useWorkflowInitialValues = (initialValues) => {
  const ctx2 = useWorkflowContext();
  return Object.keys(initialValues).reduce((prev2, curr) => {
    var _a2;
    return { ...prev2, [curr]: ((_a2 = ctx2 == null ? void 0 : ctx2.formData) == null ? void 0 : _a2[curr]) || initialValues[curr] };
  }, {});
};
const Form = ({
  id,
  initialValues,
  onReset,
  onSubmit,
  children: children2,
  enableReinitialize = false,
  focusFirst,
  validationSchema: validationSchema2,
  validate,
  validateOnBlur = false,
  validateOnChange = false,
  validateOnMount = false,
  ...restOfProps
}) => {
  const formRef = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    GuiFormProvider,
    {
      enableReinitialize,
      initialValues,
      onReset,
      onSubmit,
      validate,
      validateOnBlur,
      validateOnChange,
      validateOnMount,
      validationSchema: validationSchema2,
      children: (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
        GuiBaseForm,
        {
          focusFirst,
          id,
          ref: formRef,
          ...restOfProps,
          children: typeof children2 === "function" ? children2(
            props2
          ) : children2
        }
      )
    }
  );
};
const WorkflowForm = ({
  initialValues,
  onReset,
  onSubmit,
  children: children2,
  enableReinitialize = false,
  focusFirst,
  syncFormWithWorkflow = false,
  validationSchema: validationSchema2,
  validate,
  validateOnBlur = false,
  validateOnChange = false,
  validateOnMount = false,
  ...restOfProps
}) => {
  const formRef = useRef(null);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    GuiFormProviderForWorkflow,
    {
      enableReinitialize,
      initialValues,
      onReset,
      onSubmit,
      validate,
      validateOnBlur,
      validateOnChange,
      validateOnMount,
      validationSchema: validationSchema2,
      children: (props2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
        GuiBaseFormForWorkflow,
        {
          focusFirst,
          ref: formRef,
          ...restOfProps,
          children: [
            syncFormWithWorkflow ? /* @__PURE__ */ jsxRuntimeExports.jsx(SyncFormWithWorkflow, {}) : null,
            typeof children2 === "function" ? children2(
              props2
            ) : children2
          ]
        }
      )
    }
  );
};
const Debug = () => {
  const guiForm = useGuiForm();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { "data-test-id": "form-debug", children: /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { children: JSON.stringify(guiForm, null, 2) }) });
};
const Errors = ({
  dataTestId = void 0,
  hasHtml = false
}) => {
  const guiForm = useGuiForm();
  const { errorsFromServer } = guiForm || {};
  const errorMessages = Array.isArray(errorsFromServer) && (errorsFromServer == null ? void 0 : errorsFromServer.map(
    (err) => err.full_message || err.message
  )) || [];
  const hasMoreThanOneError = (errorMessages == null ? void 0 : errorMessages.length) > 1;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: (errorMessages == null ? void 0 : errorMessages.length) > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      "data-test-id": dataTestId,
      sx: {
        backgroundColor: "surface.error.subdued",
        borderColor: "border.error",
        borderRadius: "4",
        borderStyle: "solid",
        borderWidth: "1px",
        marginBottom: "1",
        padding: "24px"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            color: "icon.error",
            name: "infoOutline",
            size: IconSizes.Icon16,
            sx: { marginRight: "1" }
          }
        ),
        hasMoreThanOneError ? /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorsList, { errorMessages, hasHtml }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { hasHtml, message: errorMessages[0] })
      ] })
    }
  ) : null });
};
const ErrorsList = ({
  hasHtml = false,
  errorMessages = []
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: errorMessages == null ? void 0 : errorMessages.map((errMessage, i2) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      as: "li",
      sx: {
        color: "text.error",
        listStyleType: "none",
        position: "relative",
        "&::before": {
          content: '"●"',
          position: "absolute",
          left: "-1rem",
          top: "0.2rem",
          fontSize: "0.6rem"
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorMessage, { hasHtml, message: errMessage })
    },
    i2
  )
)) });
const ErrorMessage = ({
  hasHtml = false,
  message = ""
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Paragraph2,
  {
    sx: { color: "text.error", marginBottom: 0 },
    variant: ParagraphSizes.Paragraph16,
    children: hasHtml ? /* @__PURE__ */ jsxRuntimeExports.jsx(HtmlContent, { content: message }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: message })
  }
);
const HtmlContent = ({ content: content2 }) => (
  // eslint-disable-next-line react/no-danger
  /* @__PURE__ */ jsxRuntimeExports.jsx("span", { dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(content2) } })
);
const FormCounter = ({
  name: name2 = "counter",
  stepSize = 1,
  ...props2
}) => {
  const { meta, helpers } = useGuiField({
    name: name2,
    validate: noop$6,
    type: InputTypes.number
  });
  const incrementValue = useCallback(() => {
    const parsedValue = Number(meta == null ? void 0 : meta.value);
    helpers == null ? void 0 : helpers.setValue(`${parsedValue + stepSize}`);
  }, [meta == null ? void 0 : meta.value, stepSize, helpers]);
  const decrementValue = useCallback(() => {
    const parsedValue = Number(meta == null ? void 0 : meta.value);
    helpers == null ? void 0 : helpers.setValue(`${parsedValue - stepSize}`);
  }, [meta == null ? void 0 : meta.value, stepSize, helpers]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CounterBase,
    {
      name: name2,
      onDecrement: decrementValue,
      onIncrement: incrementValue,
      ...props2
    }
  );
};
const Counter = (props2) => {
  const { name: name2 = "counter" } = props2;
  const { meta } = useGuiField({
    name: name2
  });
  if (!meta) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ControlledCounter, { ...props2 });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormCounter, { ...props2 });
};
Counter.variant = CounterVariant;
const Context$6 = React__default.createContext(void 0);
var DrawerState = /* @__PURE__ */ ((DrawerState2) => {
  DrawerState2["none"] = "none";
  DrawerState2["partialDrawer"] = "partialDrawer";
  DrawerState2["fullDrawer"] = "fullDrawer";
  return DrawerState2;
})(DrawerState || {});
const NavbarProvider = ({ children: children2 }) => {
  const [linkState, setLinkState] = useState({
    visible: [],
    overflown: []
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = useCallback(() => {
    setIsMenuOpen((prevIsMenuOpen) => !prevIsMenuOpen);
  }, [setIsMenuOpen]);
  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, [setIsMenuOpen]);
  const {
    matchMediaQuery: { mdDown, xs }
  } = useMatchMedia();
  const drawerState = useMemo(() => {
    if (xs) {
      return "fullDrawer";
    }
    if (mdDown) {
      return "partialDrawer";
    }
    return "none";
  }, [mdDown, xs]);
  const [drawerOffset, setDrawerOffset] = useState(0);
  const memoizedContext = useMemo(
    () => ({
      closeMenu,
      drawerOffset,
      drawerState,
      isMenuOpen,
      linkState,
      setDrawerOffset,
      setIsMenuOpen,
      setLinkState,
      toggleMenu
    }),
    [
      closeMenu,
      drawerOffset,
      drawerState,
      isMenuOpen,
      linkState,
      setDrawerOffset,
      setIsMenuOpen,
      setLinkState,
      toggleMenu
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$6.Provider, { value: memoizedContext, children: children2 });
};
const useNavbar = () => {
  const context = useContext(Context$6);
  if (context === void 0) {
    throw new Error("useNavbar must be used within a Navbar Provider");
  }
  return context;
};
const Context$5 = React__default.createContext(void 0);
const DrawerProvider = ({ children: children2 }) => {
  const [isBodyAtTop, setIsBodyAtTop] = useState(true);
  const memoizedContext = useMemo(
    () => ({
      isBodyAtTop,
      setIsBodyAtTop
    }),
    [isBodyAtTop, setIsBodyAtTop]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$5.Provider, { value: memoizedContext, children: children2 });
};
const useDrawer = () => {
  const context = useContext(Context$5);
  if (context === void 0) {
    throw new Error("useDrawer must be used within a Drawer Provider");
  }
  return context;
};
function useWindowSize(debounceWait = Throttle.movement) {
  const [size, setSize2] = useState([0, 0]);
  useLayoutEffect(() => {
    const debouncedUpdateSize = debounce$3(() => {
      setSize2([window.innerWidth, window.innerHeight]);
    }, debounceWait);
    window.addEventListener("resize", debouncedUpdateSize);
    debouncedUpdateSize();
    return () => window.removeEventListener("resize", debouncedUpdateSize);
  }, []);
  return size;
}
const DEBOUNCE_WAIT$1 = Throttle.forms;
const DrawerBody = ({ children: children2, sx: sx2 = {} }) => {
  const { setIsBodyAtTop } = useDrawer();
  const [_, height] = useWindowSize(DEBOUNCE_WAIT$1);
  const [isScrollable, setIsScrollable] = useState(true);
  const bodyRef = useCallback(
    (node2) => {
      function isScrollable2() {
        if (!node2)
          return false;
        return node2.scrollWidth > node2.clientWidth || node2.scrollHeight > node2.clientHeight;
      }
      setIsScrollable(isScrollable2());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [height, children2]
  );
  const debouncedSetIsTopOfPage = useCallback(
    debounce$3((e3) => {
      setIsBodyAtTop(e3.target.scrollTop === 0);
    }, Throttle.movement),
    []
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        whiteSpace: "break-spaces",
        overflowY: isScrollable ? "scroll" : "hidden",
        pb: "drawer.body.pb",
        px: buildResponsiveValues({
          smDown: "drawer.body.px.mobile",
          mdUp: "drawer.body.px.desktop"
        }),
        ...sx2
      },
      ref: bodyRef,
      onScroll: (e3) => {
        e3.persist();
        debouncedSetIsTopOfPage(e3);
      },
      children: children2
    }
  );
};
const DrawerHeader = ({ children: children2, icon: icon2 = void 0 }) => {
  const { isBodyAtTop } = useDrawer();
  const shouldDisplayBoxShadow = !isBodyAtTop;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      "data-test-id": "drawer-header",
      flexDirection: "column",
      sx: {
        pt: "drawer.header.pt",
        pb: "drawer.header.pb",
        px: buildResponsiveValues({
          smDown: "drawer.header.px.mobile",
          mdUp: "drawer.header.px.desktop"
        }),
        boxShadow: shouldDisplayBoxShadow ? "elevation.three" : "unset",
        transition: "drawer.header",
        zIndex: "drawer",
        ...icon2 && { gap: "drawer.header.icon.gap" }
      },
      children: [
        icon2,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { variant: TitleSizes$1.Title32, children: children2 })
      ]
    }
  );
};
const AnimatedOverlay$1 = animated(Overlay);
const AnimatedFlex$2 = animated(Flex);
const Drawer = ({
  children: children2,
  isOpen,
  variant: variant3 = DrawerVariant.default,
  dismissOnOverlayClick = false,
  onDismiss,
  hideCloseIcon = false,
  widthOverride = void 0,
  fullWidthBreakpoint = MatchMediaQuery.smDown
}) => {
  const ref2 = useRef(null);
  const [isVisible, setIsVisible] = useState(isOpen);
  const [isFullWidth, setFullWidth] = useState(false);
  const onEscapeKeyDown = useCallback(() => {
    if (!isOpen) {
      return;
    }
    onDismiss();
  }, [isOpen, onDismiss]);
  useEscapeDown(onEscapeKeyDown);
  const { matchMediaQuery } = useMatchMedia();
  const { smDown, md, mdUp, lg, xl } = matchMediaQuery;
  const drawerState = useMemo(() => {
    if (matchMediaQuery == null ? void 0 : matchMediaQuery[fullWidthBreakpoint]) {
      return DrawerState.fullDrawer;
    }
    if (mdUp) {
      return DrawerState.partialDrawer;
    }
    return DrawerState.none;
  }, [mdUp, matchMediaQuery, fullWidthBreakpoint]);
  const drawerWidth = useMemo(() => {
    if (matchMediaQuery == null ? void 0 : matchMediaQuery[fullWidthBreakpoint]) {
      return `${window.innerWidth}px`;
    }
    if (widthOverride) {
      return widthOverride;
    }
    if (md) {
      return DRAWER_WIDTH.md;
    } else if (lg) {
      return DRAWER_WIDTH.lg;
    } else if (xl) {
      return DRAWER_WIDTH.xl;
    }
  }, [matchMediaQuery, fullWidthBreakpoint, widthOverride, md, lg, xl]);
  usePreventBodyScroll(isOpen && isVisible, [isVisible, isOpen]);
  const rightClosedPosition = useMemo(() => {
    return drawerState === DrawerState.fullDrawer ? `-${window.innerWidth}px` : `-${drawerWidth}`;
  }, [drawerState, drawerWidth]);
  const toggleBodyScrollEnabled = useCallback(() => {
    document.body.style.overflowY = isOpen ? "hidden" : "initial";
  }, [isOpen]);
  const [animation] = useSpring(
    {
      opacity: isOpen ? 1 : 0,
      right: isOpen ? "0" : rightClosedPosition,
      width: drawerWidth,
      onStart: () => {
        if (isOpen) {
          toggleBodyScrollEnabled();
          setIsVisible(true);
          setFullWidth(drawerState === DrawerState.fullDrawer);
        }
      },
      onRest: () => {
        toggleBodyScrollEnabled();
        setIsVisible(isOpen);
        setFullWidth(drawerState === DrawerState.fullDrawer);
      }
    },
    [isOpen, drawerWidth, toggleBodyScrollEnabled, rightClosedPosition]
  );
  if (isVisible) {
    return ReactDOM.createPortal(
      /* @__PURE__ */ jsxRuntimeExports.jsxs(DrawerProvider, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnimatedOverlay$1,
          {
            onClick: () => {
              if (dismissOnOverlayClick) {
                onDismiss();
              }
            },
            style: { opacity: animation.opacity },
            sx: { zIndex: "drawer" }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedFocusLock, { returnFocus: true, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          AnimatedFlex$2,
          {
            "data-test-id": "drawer",
            flexDirection: "column",
            ref: ref2,
            style: {
              right: animation.right,
              width: animation.width
            },
            sx: {
              top: 0,
              transition: isFullWidth ? "drawer.slide" : "unset",
              variant: `drawer.${variant3}`,
              // use !important to overwrite style.width from animation
              width: isFullWidth ? "100% !important" : "unset",
              zIndex: "drawer",
              ...styles$i.drawer
            },
            children: [
              !hideCloseIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Box,
                {
                  "aria-label": isOpen ? "close-drawer" : "drawer",
                  as: "button",
                  "data-test-id": "close-drawer",
                  onClick: onDismiss,
                  sx: {
                    cursor: "pointer",
                    border: "unset",
                    background: "inherit",
                    padding: "drawer.closeButton.padding",
                    position: "absolute",
                    top: "drawer.closeButton.top",
                    right: "drawer.closeButton.right",
                    zIndex: "popover"
                  },
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Icon,
                    {
                      name: "x",
                      size: smDown ? IconSizes.Icon24 : IconSizes.Icon16
                    }
                  )
                }
              ),
              children2
            ]
          }
        ) })
      ] }),
      document.body
    );
  }
  return null;
};
const styles$i = {
  drawer: {
    "& a": {
      "&.focus-visible": {
        boxShadow: "menuListItem.navigation.active",
        borderRadius: "menuListItem.container",
        borderWidth: 0,
        outline: "unset"
      },
      "&:focus": {
        borderWidth: 0
      }
    },
    "& button": {
      "&.focus-visible": {
        boxShadow: "menuListItem.navigation.active",
        borderRadius: "menuListItem.container",
        borderWidth: 0,
        outline: "unset"
      }
    }
  }
};
Drawer.Header = DrawerHeader;
Drawer.Body = DrawerBody;
const Context$4 = React__default.createContext(void 0);
const DropdownProvider = ({
  children: children2,
  isOpen,
  setIsOpen
}) => {
  const memoizedContext = useMemo(
    () => ({
      isOpen,
      setIsOpen
    }),
    [isOpen, setIsOpen]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$4.Provider, { value: memoizedContext, children: children2 });
};
const useDropdown = () => {
  const context = useContext(Context$4);
  if (context === void 0) {
    throw new Error("useDropdown must be used within a Dropdown Provider");
  }
  return context;
};
const Control$1 = ({
  children: children2,
  variant: variant3 = DropdownControlVariants.default
}) => {
  const { isOpen, setIsOpen } = useDropdown();
  const ref2 = useRef(null);
  const onEscapeKeyDown = useCallback(() => {
    var _a2;
    if (!isOpen) {
      return;
    }
    setIsOpen == null ? void 0 : setIsOpen(false);
    if (ref2.current) {
      (_a2 = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _a2.focus();
    }
  }, [ref2, setIsOpen, isOpen]);
  const onArrowDown = useCallback(
    (event2) => {
      var _a2;
      if (isOpen) {
        return;
      }
      if (document.activeElement !== ref2.current) {
        return;
      }
      event2.preventDefault();
      (_a2 = ref2.current) == null ? void 0 : _a2.click();
    },
    [ref2, document, isOpen]
  );
  useEscapeDown(onEscapeKeyDown);
  useKeyDown("ArrowDown", onArrowDown);
  const onClickCallback = useCallback(() => {
    setIsOpen == null ? void 0 : setIsOpen((prev2) => !prev2);
  }, [setIsOpen]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "aria-expanded": isOpen ? "true" : "false",
      onClick: onClickCallback,
      ref: ref2,
      sx: {
        variant: `dropdown.control.${variant3}`
      },
      variant: ButtonVariant.unstyled,
      children: children2
    }
  );
};
const MenuList = React__default.forwardRef(
  ({
    children: children2,
    preventFocus = false,
    sx: sx2,
    variant: variant3 = MenuListVariants.default,
    ...restOfProps
  }, ref2) => {
    const { style: style2 } = useStyle(sx2);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box,
      {
        as: "ul",
        ref: ref2,
        sx: style2(),
        variant: `menuList.${variant3}`,
        ...restOfProps,
        children: React__default.Children.map(
          children2,
          (child) => cloneValidElement(child, {
            tabIndex: preventFocus ? -1 : 0
          })
        )
      }
    );
  }
);
const Content$2 = React__default.forwardRef(
  ({ children: children2, sx: sx2 = {}, variant: variant3 = MenuListVariants.default, ...restOfProps }, ref2) => {
    const { isOpen } = useDropdown();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedFocusLock, { returnFocus: true, children: isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList, { ref: ref2, sx: sx2, variant: variant3, ...restOfProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: React__default.Children.map(
      children2,
      (child, index2) => cloneValidElement(child, { key: index2, _forDropdown: true })
    ) }) }) });
  }
);
function useOnClickOutside(ref2, handler, mouseEvent = "mousedown") {
  useEventListener(mouseEvent, (event2) => {
    const el = ref2 == null ? void 0 : ref2.current;
    if (!el || el.contains(event2.target)) {
      return;
    }
    handler(event2);
  });
}
const Dropdown = ({ children: children2, ...props2 }) => {
  const { isOpen, setIsOpen } = useDropdown();
  const ref2 = useRef(null);
  useOnClickOutside(ref2, () => isOpen && (setIsOpen == null ? void 0 : setIsOpen(false)));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: ref2, sx: { position: "relative" }, ...props2, children: children2 });
};
const WrappedDropdown = ({
  isOpen,
  setIsOpen,
  ...restOfProps
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownProvider, { isOpen, setIsOpen, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Dropdown, { ...restOfProps }) });
WrappedDropdown.Content = Content$2;
WrappedDropdown.Control = Control$1;
const ExpansionPanel = ({
  buttonSx = {},
  children: children2 = null,
  iconAlignment = IconAlignment.trailing,
  iconCollapsed = "chevronDown",
  iconExpanded = "chevronUp",
  initiallyExpanded = false,
  title = "",
  variant: variant3 = ExpansionPanelVariant.default
}) => {
  const [collapsed, setCollapsed] = useState(!initiallyExpanded);
  const onToggle = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);
  const memoizedTitle = useMemo(() => {
    if (typeof title === "function") {
      return title({ collapsed, expanded: !collapsed });
    }
    return title;
  }, [collapsed, title]);
  const renderIcon2 = (icon2) => typeof icon2 === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Icon,
    {
      "data-test-id": "expansion-panel-title-icon",
      name: icon2,
      size: IconSizes.Icon12
    }
  ) : icon2;
  const titleComponent = typeof memoizedTitle === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { color: TextColors.primary, variant: TitleSizes$1.Title16, children: memoizedTitle }) : memoizedTitle;
  const content2 = typeof children2 === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Paragraph2,
    {
      color: TextColors.primary,
      variant: ParagraphSizes.Paragraph16,
      children: children2
    }
  ) : children2;
  const titleComponents = [
    titleComponent,
    renderIcon2(collapsed ? iconCollapsed : iconExpanded)
  ];
  if (iconAlignment === IconAlignment.leading) {
    titleComponents.reverse();
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Collapsible, { initiallyCollapsed: !initiallyExpanded, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Collapsible.Control,
      {
        action: CollapsibleAction.toggle,
        onAction: onToggle,
        sx: { textAlign: "left", ...buttonSx },
        variant: ButtonVariant.unstyled,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Flex,
          {
            "data-test-id": "expansion-panel-title",
            variant: `expansionPanel.${variant3}.titleContainer`,
            children: [
              ...titleComponents
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Collapsible.Content, { "data-test-id": "expansion-panel-content", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { variant: `expansionPanel.${variant3}.contentContainer`, children: content2 }) })
  ] }) });
};
const InlineCalloutBody = ({ hasTitle, content: content2 = null }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: hasTitle && content2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: styles$w.body.container, children: content2 }) : null });
};
const InlineCalloutButton = ({
  buttonLabel = void 0,
  buttonAriaLabel = void 0,
  onClick = void 0
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: buttonLabel && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: styles$w.footer.button, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
  CompoundButton,
  {
    "aria-label": buttonAriaLabel,
    onClick: (e3) => onClick == null ? void 0 : onClick(e3),
    size: ButtonSize.compact,
    variant: CompoundButton.Tertiary,
    children: buttonLabel
  }
) }) });
const InlineCalloutTitle = ({
  title = void 0,
  customTitle = null
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: title ? /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "span", variant: "18", children: title }) : customTitle });
};
const iconMappings = {
  default: "info",
  info: "info",
  warning: "warning",
  success: "checkCircle",
  error: "xCircle"
};
const InlineCallout = ({
  title = void 0,
  variant: variant3 = "info",
  sx: sx2 = {},
  onDismiss = void 0,
  children: children2 = null,
  buttonLabel = void 0,
  onButtonClick = void 0,
  buttonAriaLabel = "",
  showDismiss = false,
  dismissAriaLabel = "dismiss",
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  invariant$1(title || children2, "title or children must be passed");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex$1, { sx: style2({ variant: `inlineCallout.${variant3}` }), ...restOfProps, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { spacing: 0.5, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          color: `icon.${variant3}`,
          name: iconMappings[variant3],
          size: IconSizes.Icon24,
          sx: styles$w.header.icon
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCalloutTitle, { customTitle: children2, title }),
      showDismiss && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          "aria-label": dismissAriaLabel,
          name: "x",
          onClick: (e3) => {
            onDismiss == null ? void 0 : onDismiss(e3);
          },
          size: IconSizes.Icon16,
          stroke: "inlineCallout.stroke.dismiss",
          sx: styles$w.header.dismiss
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InlineCalloutBody, { content: children2, hasTitle: Boolean(title) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      InlineCalloutButton,
      {
        buttonAriaLabel,
        buttonLabel,
        onClick: onButtonClick
      }
    )
  ] });
};
var InlineCalloutVariant = /* @__PURE__ */ ((InlineCalloutVariant2) => {
  InlineCalloutVariant2["default"] = "default";
  InlineCalloutVariant2["info"] = "info";
  InlineCalloutVariant2["warning"] = "warning";
  InlineCalloutVariant2["success"] = "success";
  InlineCalloutVariant2["error"] = "error";
  return InlineCalloutVariant2;
})(InlineCalloutVariant || {});
const emailValidatorRegexp = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
const isEmail = (value) => {
  return emailValidatorRegexp.test(value);
};
const getValidationForEmail = (value) => {
  if (!value || (value == null ? void 0 : value.length) === 0 || typeof value !== "string") {
    return false;
  }
  return isEmail(value);
};
const isSelfValidatedEmail = (props2) => {
  return "isSelfValidating" in props2 && props2.isSelfValidating === true;
};
const isCustomValidatedEmail = (props2) => {
  return "validate" in props2 && !!props2.validate;
};
const DEFAULT_ERROR_MESSAGE = "Email is invalid";
const EmailInput = (props2) => {
  const handleEmailValidation = useCallback(
    (value) => {
      const isSelfValidatedEmailComponent = isSelfValidatedEmail(props2);
      if (!isSelfValidatedEmailComponent) {
        return void 0;
      }
      const isValid2 = value && getValidationForEmail(value);
      if (isValid2) {
        return void 0;
      }
      const { errorMessage } = props2;
      return errorMessage ?? DEFAULT_ERROR_MESSAGE;
    },
    // Cast to SelfValidatedInputOptions to access errorMessage
    [props2 == null ? void 0 : props2.errorMessage]
  );
  const handleValidate = useCallback(
    (value) => {
      if (isCustomValidatedEmail(props2)) {
        const { validate } = props2;
        return validate(value);
      }
      return handleEmailValidation(value);
    },
    // Cast to CustomValidatedEmailInputOptions to access validate
    [props2 == null ? void 0 : props2.validate]
  );
  let rest = props2;
  if (isCustomValidatedEmail(props2)) {
    const { isSelfValidating, ...restOfProps } = props2;
    rest = restOfProps;
  } else if (isSelfValidatedEmail(props2)) {
    const { errorMessage, isSelfValidating, ...restOfProps } = props2;
    rest = restOfProps;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      ...rest,
      inputMode: "email",
      type: InputTypes.email,
      validate: handleValidate
    }
  );
};
const format$1 = (date2) => {
  if (!date2)
    return "";
  if (typeof date2 === "string") {
    date2 = parseDateString(date2);
  }
  const day = String(date2.getDate()).padStart(2, "0");
  const month = String(date2.getMonth() + 1).padStart(2, "0");
  const year = date2.getFullYear();
  return [month, day, year].join("/");
};
const parse = (str) => {
  const [month, day, year] = str.split("/");
  return new Date(Number(year), Number(month) - 1, Number(day));
};
const DateInput = ({
  min: min2 = void 0,
  max: max2 = void 0,
  lazy = false,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: Date,
        min: min2,
        max: max2,
        maxLength: 10,
        lazy,
        format: format$1,
        parse,
        pattern: "m{/}`d{/}`Y"
      },
      ...props2
    }
  );
};
function parseDateString(dateString) {
  let normalizeDate;
  const isoPattern = /^\d{4}-\d{2}-\d{2}$/;
  if (isoPattern.test(dateString)) {
    normalizeDate = dateString;
  }
  const usPattern = /^\d{2}\/\d{2}\/\d{4}$/;
  if (usPattern.test(dateString)) {
    const [month, day, year] = dateString.split("/").map(Number);
    normalizeDate = `${year}-${String(month).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
  }
  if (normalizeDate) {
    const [year, month, day] = normalizeDate.split("-").map(Number);
    return new Date(year, month - 1, day);
  }
  console.error("Unknown or invalid date format:", dateString);
  return new Date(dateString);
}
const EINInput = ({
  lazy = true,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: "00-0000000",
        lazy
      },
      ...props2
    }
  );
};
const NAICSInput = ({
  lazy = true,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: "000000",
        lazy
      },
      ...props2
    }
  );
};
const PhoneInput = ({
  lazy = true,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: "(000) 000-0000",
        lazy
      },
      ...props2
    }
  );
};
const PostalCodeInput = ({
  lazy = true,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: "00000-[0000]",
        blocks: {
          num: {
            mask: Number
          }
        },
        lazy
      },
      ...props2
    }
  );
};
const SSNInput = ({
  lazy = true,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      maskOptions: {
        mask: "000-00-0000",
        lazy
      },
      ...props2
    }
  );
};
function withVariants(Component2, variants2) {
  Object.values(variants2).forEach((variant3) => {
    Object.assign(Component2, { [variant3]: variant3 });
  });
  return Component2;
}
const MenuListItem = ({
  active = false,
  children: children2 = null,
  disabled = false,
  height = MenuListItemSizes.default,
  onClick = void 0,
  leadingElement = null,
  sx: sx2 = {},
  trailingElement = null,
  variant: variant3 = MenuListItemVariants.default,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const styled = useCallback(
    (theme2) => style2({
      cursor: disabled ? "not-allowed" : "pointer",
      ...theme2.space.menuListItem[height],
      ...theme2.sizes.menuListItem[height]
    }),
    [active, disabled, height, style2]
  );
  const handleClick = useCallback(
    (event2) => {
      const { type: type2, key } = event2;
      if (type2 !== "click" && (type2 !== "keydown" || key !== "Enter" && key !== " "))
        return;
      if (disabled === false) {
        onClick == null ? void 0 : onClick(event2);
      }
    },
    [disabled, onClick]
  );
  return /* @__PURE__ */ jsxs(
    Flex$1,
    {
      as: "li",
      "data-test-id": "menulistitem",
      onClick: handleClick,
      onKeyDown: handleClick,
      sx: styled,
      variant: `menuListItems.${variant3}`,
      ...restOfProps,
      children: [
        leadingElement ? /* @__PURE__ */ jsx2(Flex$1, { sx: { ...styles$v.leadingElement }, children: cloneValidElement(leadingElement, { disabled }) }) : null,
        /* @__PURE__ */ jsx2(Flex$1, { sx: { flex: 1 }, children: /* @__PURE__ */ jsx2(
          Title,
          {
            as: "span",
            color: disabled ? TextColors.disable : TextColors.primary,
            sx: { width: "100%" },
            variant: styles$v.titleVariant(variant3),
            children: cloneValidElement(children2, { disabled })
          }
        ) }),
        trailingElement ? /* @__PURE__ */ jsx2(Flex$1, { sx: { ...styles$v.trailingElement }, children: cloneValidElement(trailingElement, { disabled }) }) : null
      ]
    }
  );
};
const wrapped$1 = withVariants(
  MenuListItem,
  MenuListItemVariants
);
const mobileMediaQueryBreakpoint = "mdUp";
const AnimatedCard = animated(Card$1);
const Container = ({
  children: children2,
  isOpen,
  mediaQueries: mediaQueries2 = {},
  size,
  position: position2
}) => {
  const { [mobileMediaQueryBreakpoint]: floatingModal } = mediaQueries2;
  const { theme: theme2 } = useTheme();
  const transitions2 = useTransition(isOpen, {
    config: isOpen ? { ...theme2.animations.modal.physics.type } : { duration: Number(theme2.transitions.durations.Duration100) },
    from: theme2.animations.modal.from,
    enter: theme2.animations.modal.enter,
    leave: theme2.animations.modal.leave
  });
  return transitions2(
    ({ opacity: opacity2, y: y4 }, item) => item ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex$1,
      {
        "data-test-id": "modal-container",
        sx: styles$h.container(position2, floatingModal),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnimatedCard,
          {
            "data-test-id": "card",
            style: {
              transform: y4.to((y22) => `translate3d(0px, ${y22}px, 0px)`),
              ...floatingModal === false ? { opacity: opacity2 } : {}
            },
            sx: cardStyles(size, floatingModal),
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex$1, { sx: styles$h.childrenContainer(floatingModal), children: children2 })
          }
        )
      }
    ) : null
  );
};
const cardStyles = (size, floatingModal) => {
  if (floatingModal) {
    return {
      ...styles$h.card.base,
      ...styles$h.card.floating(size)
    };
  }
  return {
    ...styles$h.card.base,
    // resizes the modal for mobile when mobile toolbars are both present and hidden
    minHeight: "100svh"
  };
};
const styles$h = {
  card: {
    base: {
      backgroundColor: "modal.background",
      display: "flex",
      flexDirection: "column",
      width: "modal.cardFlex.width"
    },
    floating: (size) => ({
      borderRadius: "modal.container",
      boxShadow: "modal.container",
      maxHeight: "modal.card.maxHeight",
      width: `modal.${size}`,
      maxWidth: "calc(100vw - 2rem)"
    })
  },
  container: (position2, floatingModal) => ({
    position: position2,
    zIndex: "modal",
    maxHeight: "100%",
    padding: floatingModal ? 1 : "unset"
  }),
  childrenContainer: (floatingModal) => ({
    flexDirection: "column",
    pointerEvents: "auto",
    maxHeight: "modal.card.maxHeight",
    height: floatingModal ? "unset" : "100%",
    paddingBottom: "modal.childrenContainer.marginBottom"
  })
};
const Body$1 = ({
  children: children2,
  onScroll = void 0,
  sx: sx2 = void 0
}) => {
  const { style: style2 } = useStyle(styles$g);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex$1, { "data-test-id": "modal-body", onScroll, sx: style2(sx2), children: children2 });
};
const styles$g = (theme2) => ({
  backgroundColor: "modal.background",
  flexDirection: "column",
  flex: 1,
  overflow: "auto",
  paddingX: buildResponsiveValues({
    smDown: "modal.body.px.mobile",
    mdUp: "modal.body.px.desktop"
  }),
  ...theme2.shadows.scroll.vertical
});
const ModalTitle = ({
  title,
  ...props2
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Title,
  {
    as: "h2",
    bottomSpace: 0,
    "data-test-id": "modal-header-title",
    variant: TitleSizes$1.Title24,
    ...props2,
    children: title
  }
);
const TitleIcon = ({
  icon: icon2 = void 0,
  sx: sx2 = {}
}) => {
  if (icon2) {
    return React__default.cloneElement(icon2, {
      "data-test-id": "modal-header-title-icon",
      sx: sx2
    });
  }
  return null;
};
const Header$3 = ({
  headerMedia = void 0,
  title,
  titleIcon = void 0,
  onDismiss,
  onBack = void 0,
  multiStepMobileModal = void 0,
  interstitial = void 0
}) => {
  const iconSize = useResponsiveMedia({
    smDown: IconSizes.Icon24,
    mdUp: IconSizes.Icon16
  });
  const mediaCloseIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Icon,
    {
      "aria-label": "Close icon",
      "data-test-id": "modal-header-dismiss",
      name: "x",
      onClick: onDismiss,
      size: iconSize,
      sx: { flexShrink: 0, "&:focus-visible": { backgroundColor: "surface" } }
    }
  );
  const titleRow = /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "top", justify: "start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TitleIcon, { icon: titleIcon, sx: { mb: 1.5 } }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle, { sx: { wordWrap: "break-word" }, title })
  ] });
  const renderWithMediaHeader = ({
    altImages = [],
    image: { alt: imageAlt = "Header background image", src: imageSrc },
    initialHeightDesktop,
    initialHeightMobile
  }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: ({ mdUp }) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Picture,
      {
        renderError: noop$7,
        renderLoading: () => /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box$1,
          {
            sx: {
              height: mdUp ? initialHeightDesktop : initialHeightMobile
            }
          }
        ),
        children: [
          altImages.map(({ media, srcset, type: type2 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            Picture.Src,
            {
              media,
              srcSet: srcset,
              type: type2
            },
            srcset
          )),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Picture.Img,
            {
              alt: imageAlt,
              src: imageSrc,
              style: {
                borderRadius: mdUp ? "0.5rem 0.5rem 0 0" : "0",
                height: "auto",
                width: "100%"
              }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        "data-test-id": "modal-header",
        sx: {
          ...styles$f.container,
          position: "absolute",
          top: 0,
          width: "100%"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          HStack,
          {
            align: "top",
            justify: multiStepMobileModal ? "space-between" : "end",
            children: [
              multiStepMobileModal && !!onBack ? /* @__PURE__ */ jsxRuntimeExports.jsx(BackButton, { "aria-label": "Back button", iconOnly: true, onClick: onBack }) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Flex,
                {
                  alignItems: "center",
                  justifyContent: "center",
                  sx: styles$f.closeIconWithMedia,
                  children: mediaCloseIcon
                }
              )
            ]
          }
        ) })
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: styles$f.container, children: titleRow })
  ] });
  if (headerMedia) {
    return renderWithMediaHeader(headerMedia);
  }
  const closeIcon = !interstitial ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Icon,
    {
      "aria-label": "Close icon",
      "data-test-id": "modal-header-dismiss",
      name: "x",
      onClick: onDismiss,
      size: iconSize,
      sx: {
        flexShrink: 0
      }
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { "data-test-id": "modal-header", sx: styles$f.container, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      HStack,
      {
        align: "top",
        justify: multiStepMobileModal ? "space-between" : "end",
        children: multiStepMobileModal && !!onBack ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(BackButton, { iconOnly: true, onClick: onBack }),
          closeIcon
        ] }) : null
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { justify: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "top", justify: "start", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(TitleIcon, { icon: titleIcon, sx: { mb: 1.5 } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ModalTitle, { sx: { wordWrap: "break-word" }, title })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { children: multiStepMobileModal && !!onBack ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: closeIcon }) })
    ] })
  ] }) });
};
const styles$f = {
  closeIconWithMedia: {
    backgroundColor: "icon.white",
    borderRadius: "50%",
    height: "2rem",
    width: "2rem"
  },
  container: {
    padding: buildResponsiveValues({
      smDown: "modal.header.padding.mobile",
      mdUp: "modal.header.padding.desktop"
    })
  }
};
const Footer$3 = ({
  footerActions: FooterActions = void 0,
  onPrimaryAction = void 0,
  primaryActionText = "",
  onSecondaryAction = void 0,
  secondaryActionText = "",
  onBack = void 0,
  mobile = false
}) => {
  const defaultPrimaryActionButton = onPrimaryAction ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "data-test-id": "modal-footer-primary-action",
      onClick: onPrimaryAction,
      variant: ButtonVariant.primary,
      children: primaryActionText
    }
  ) : null;
  const defaultSecondaryActionButton = onSecondaryAction ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "data-test-id": "modal-footer-secondary-action",
      onClick: onSecondaryAction,
      variant: ButtonVariant.secondary,
      children: secondaryActionText
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { "data-test-id": "modal-footer", sx: styles$e.container, children: [
    onBack ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      BackButton,
      {
        "data-test-id": "modal-header-back",
        hideIcon: true,
        onClick: onBack
      }
    ) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex,
      {
        flexDirection: mobile ? "column-reverse" : "row",
        spacing: `modal.footer.gap.${mobile ? "mobile" : "desktop"}`,
        sx: styles$e.mainActions,
        children: FooterActions ? React__default.cloneElement(FooterActions) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          defaultSecondaryActionButton,
          defaultPrimaryActionButton
        ] })
      }
    )
  ] });
};
const styles$e = {
  container: {
    padding: buildResponsiveValues({
      smDown: "modal.footer.padding.mobile",
      mdUp: "modal.footer.padding.desktop"
    }),
    borderTop: "default",
    borderColor: "border.subdued",
    justifyContent: "space-between"
  },
  beforeActions: {
    alignItems: "center"
  },
  mainActions: {
    flex: 1,
    justifyContent: "flex-end"
  }
};
var ModalSizes = /* @__PURE__ */ ((ModalSizes2) => {
  ModalSizes2["small"] = "small";
  ModalSizes2["large"] = "large";
  ModalSizes2["fluid"] = "fluid";
  ModalSizes2["medium"] = "medium";
  return ModalSizes2;
})(ModalSizes || {});
const AnimatedOverlay = animated(Overlay);
const OverlayContent = ({
  alignItems = "center",
  autoFocus = true,
  justifyContent: justifyContent2 = "center",
  children: children2,
  isOpen,
  dismissOnOutsideClick = false,
  portal = Portal$1,
  onDismiss = noop$6,
  a11yTitle,
  dismissOnEscapeDown = true
}) => {
  const { theme: theme2 } = useTheme();
  const onDismissIfOpen = useCallback(
    (event2) => {
      if (isOpen) {
        onDismiss(event2);
      }
    },
    [isOpen, onDismiss]
  );
  usePreventBodyScroll(isOpen, [isOpen]);
  useEscapeDown(dismissOnEscapeDown ? onDismissIfOpen : () => {
  });
  const transitions2 = useTransition(isOpen, {
    config: isOpen ? { ...theme2.animations.overlay.physics.type } : { duration: Number(theme2.transitions.durations.Duration100) },
    from: theme2.animations.overlay.from,
    enter: theme2.animations.overlay.enter,
    leave: theme2.animations.overlay.leave
  });
  const content2 = transitions2(
    ({ opacity: opacity2 }, item) => item ? /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex$1, { "data-test-id": "overlay-container", sx: styles$d.container, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        AnimatedOverlay,
        {
          "data-test-id": "modal-overlay",
          onClick: dismissOnOutsideClick ? onDismiss : void 0,
          style: { opacity: opacity2 }
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        WrappedFocusLock,
        {
          autoFocus,
          returnFocus: true,
          sx: { alignItems, justifyContent: justifyContent2, ...styles$d.focusLock },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Flex$1,
            {
              "aria-label": a11yTitle,
              "aria-modal": "true",
              role: "dialog",
              sx: styles$d.contentContainer(
                mediaQueries2[mobileMediaQueryBreakpoint]
              ),
              children: children2
            }
          )
        }
      )
    ] }) }) : null
  );
  if (portal) {
    return portal({ children: content2 });
  }
  return content2;
};
const styles$d = {
  container: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0,
    zIndex: "modal",
    position: "fixed"
  },
  focusLock: {
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    height: "overlayContent.focusLock.height",
    width: "overlayContent.focusLock.width"
  },
  contentContainer: (floatingModal) => {
    let base2;
    if (!floatingModal) {
      base2 = {
        height: "overlayContent.contentContainer.height",
        minHeight: "overlayContent.contentContainer.minHeight"
      };
    }
    base2 = {
      pointerEvents: "auto",
      maxHeight: "overlayContent.contentContainer.maxHeight",
      zIndex: "modal",
      ...base2
    };
    return base2;
  }
};
const modal = Symbol("GuidelineComponentType-modal");
const GuidelineComponentType = {
  modal
};
const Modal = ({
  autoFocus = void 0,
  bodySx = {},
  children: children2,
  componentWrapper: ComponentWrapper = React__default.Fragment,
  dismissOnEscapeDown = true,
  headerMedia = void 0,
  isOpen,
  informational = true,
  interstitial = false,
  onBack = void 0,
  onBodyScroll = void 0,
  onDismiss,
  footerActions = void 0,
  onPrimaryAction = void 0,
  onSecondaryAction = void 0,
  primaryActionText = "",
  secondaryActionText = "",
  size = ModalSizes.medium,
  title,
  titleIcon = void 0
}) => {
  const { matchMediaQuery } = useMatchMedia();
  const multiStepMobileModal = Boolean(onBack && matchMediaQuery.smDown);
  const multiStepDesktopModal = Boolean(onBack && matchMediaQuery.mdUp);
  const hasFooter = multiStepDesktopModal || footerActions || onPrimaryAction || onSecondaryAction;
  const { style: bodyStyle } = useStyle(
    hasFooter ? { paddingBottom: "modal.body.marginBottom" } : {}
  );
  const shouldDismissOnOutsideClick = interstitial ? false : informational;
  const shouldDismissOnEscapeDown = interstitial ? false : dismissOnEscapeDown;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    OverlayContent,
    {
      a11yTitle: title || "Modal dialog",
      autoFocus,
      dismissOnEscapeDown: shouldDismissOnEscapeDown,
      dismissOnOutsideClick: shouldDismissOnOutsideClick,
      isOpen,
      onDismiss,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentWrapper, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Container,
        {
          isOpen,
          mediaQueries: matchMediaQuery,
          onDismiss,
          portal: Portal$1,
          size,
          children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Header$3,
              {
                headerMedia,
                interstitial,
                multiStepMobileModal,
                onBack,
                onDismiss,
                title,
                titleIcon
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Body$1, { onScroll: onBodyScroll, sx: bodyStyle(bodySx), children: children2 }),
            hasFooter ? /* @__PURE__ */ jsxRuntimeExports.jsx(
              Footer$3,
              {
                footerActions,
                mobile: matchMediaQuery.smDown,
                onBack: multiStepDesktopModal ? onBack : void 0,
                onPrimaryAction,
                onSecondaryAction,
                primaryActionText,
                secondaryActionText
              }
            ) : null
          ]
        }
      ) })
    }
  );
};
Modal.displayName = "Modal";
Modal.guidelineComponentType = GuidelineComponentType.modal;
const Notification = ({
  children: children2 = null,
  backgroundColor = "",
  sx: sx2 = {},
  textColor = TextColors.white,
  variant: variant3 = NotificationVariant.default,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      sx: style2({
        backgroundColor
      }),
      variant: `notifications.${variant3}`,
      ...restOfProps,
      children: variant3 !== NotificationVariant.dot && /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "span", color: textColor, variant: "14", children: children2 })
    }
  );
};
const wrapped = withVariants(Notification, NotificationVariant);
const OrderedList = ({
  children: children2,
  className = void 0,
  color: color2 = TextColors.primary,
  sx: sx2 = {},
  variant: variant3 = OrderedListSizes.default
}) => {
  const { style: style2 } = useStyle(sx2);
  const listItems = children2 instanceof Array ? children2 : [children2];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Text$1,
    {
      as: "ol",
      className,
      color: color2,
      sx: style2({ variant: `orderedList.${variant3}` }),
      children: listItems.map(
        (listItem2, i2) => React__default.cloneElement(listItem2, {
          key: i2,
          color: color2,
          variant: ListItemVariants.ordered
        })
      )
    }
  );
};
const Context$3 = React__default.createContext(void 0);
const PaginationProvider = ({
  children: children2,
  initialPage = 1,
  totalPages
}) => {
  const [currentPage, setPage] = useState(initialPage);
  const goToNextPage = useCallback(() => {
    if (currentPage < totalPages) {
      setPage((page) => page + 1);
    }
  }, [currentPage, totalPages]);
  const goToPreviousPage = useCallback(() => {
    if (currentPage > 1) {
      setPage((page) => page - 1);
    }
  }, [currentPage]);
  const goToPage = useCallback(
    (page) => {
      if (page > 0 && page <= totalPages) {
        setPage(page);
      }
    },
    [totalPages]
  );
  const goToFirstPage = useCallback(() => {
    setPage(1);
  }, []);
  const goToLastPage = useCallback(() => {
    setPage(totalPages);
  }, [totalPages]);
  const memoizedContext = useMemo(
    () => ({
      currentPage,
      totalPages,
      goToNextPage,
      goToPreviousPage,
      goToPage,
      goToFirstPage,
      goToLastPage
    }),
    [
      currentPage,
      totalPages,
      goToNextPage,
      goToPreviousPage,
      goToPage,
      goToFirstPage,
      goToLastPage
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$3.Provider, { value: memoizedContext, children: children2 });
};
const usePagination = () => {
  const context = useContext(Context$3);
  if (context === void 0) {
    throw new Error("usePagination must be used within a Pagination Provider");
  }
  return context;
};
function iconToAriaLabel(icon2) {
  switch (icon2) {
    case "chevronLeft":
      return "Previous page";
    case "chevronRight":
      return "Next page";
    case "caretLeftDouble":
      return "First page";
    case "caretRightDouble":
      return "Last page";
    default:
      return void 0;
  }
}
const NavArrowPage = ({
  icon: icon2,
  disabled = false,
  onClick
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "aria-label": iconToAriaLabel(icon2),
      disabled,
      onClick,
      sx: {
        p: 0,
        width: buildResponsiveValues({
          smDown: "pagination.chevron.mobile.width",
          mdUp: "pagination.chevron.width"
        }),
        height: buildResponsiveValues({
          smDown: "pagination.chevron.mobile.height",
          mdUp: "pagination.chevron.height"
        }),
        ...!disabled && {
          "&:hover": { backgroundColor: "action.secondary.hover" },
          "&:active": { backgroundColor: "action.secondary.pressed" },
          "&.focus-visible": { backgroundColor: "action.secondary.hover" }
        }
      },
      variant: CompoundButton.Unstyled,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          color: disabled ? "text.subdued" : "text.primary",
          name: icon2,
          size: IconSizes.Icon16
        }
      )
    }
  );
};
const EllipsisPage = ({
  onClick,
  disabled = false,
  direction
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "aria-label": direction === "back-ellipsis" ? "Previous Page Ellipsis" : "Next Page Ellipsis",
      disabled,
      onClick,
      sx: {
        p: 0,
        width: buildResponsiveValues({
          smDown: "pagination.ellipsis.mobile.width",
          mdUp: "pagination.ellipsis.width"
        }),
        height: buildResponsiveValues({
          smDown: "pagination.ellipsis.mobile.height",
          mdUp: "pagination.ellipsis.height"
        }),
        ...!disabled && {
          "&:hover": { backgroundColor: "action.secondary.hover" },
          "&:active": { backgroundColor: "action.secondary.pressed" },
          "&.focus-visible": { backgroundColor: "action.secondary.hover" }
        }
      },
      variant: CompoundButton.Unstyled,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          color: disabled ? "text.subdued" : "text.primary",
          name: "ellipsis",
          size: IconSizes.Icon16
        }
      )
    }
  );
};
const NumberPage = ({
  page,
  active = false,
  onClick,
  disabled = false
}) => {
  const handleClick = useCallback(() => {
    onClick(page);
  }, [onClick, page]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      "aria-current": active ? "page" : void 0,
      "aria-label": `Page ${page}`,
      disabled,
      onClick: handleClick,
      sx: {
        minWidth: buildResponsiveValues({
          smDown: "pagination.number.mobile.minWidth",
          mdUp: "pagination.number.minWidth"
        }),
        height: buildResponsiveValues({
          smDown: "pagination.number.mobile.height",
          mdUp: "pagination.number.height"
        }),
        paddingX: "pagination.number.paddingX",
        ...!disabled && {
          "&:hover": { backgroundColor: "action.secondary.hover" },
          "&:active": { backgroundColor: "action.secondary.pressed" },
          "&.focus-visible": { backgroundColor: "action.secondary.hover" }
        }
      },
      variant: ButtonVariant.unstyled,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box,
        {
          sx: {
            fontSize: "1rem",
            minWidth: "pagination.number.activeBorderMinWidth",
            textAlign: "center",
            color: disabled ? "text.subdued" : "text.primary",
            ...active && {
              borderBottom: "pagination.active",
              borderColor: disabled ? "pagination.number.borderColor.disabled" : "pagination.number.borderColor.active",
              marginBottom: "pagination.number.marginBottom.offset",
              fontWeight: "bold"
            }
          },
          children: page
        }
      )
    }
  );
};
const PaginationControls = ({
  appendedControls = null,
  currentPage,
  disabled = false,
  goToNextPage,
  goToPage,
  goToPreviousPage,
  pages,
  prependedControls = null
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "center",
      "aria-label": `Pagination Navigation, Current Page ${currentPage}`,
      as: "nav",
      spacing: "4px",
      children: [
        prependedControls,
        pages.map((page) => {
          if (typeof page === "string") {
            return /* @__PURE__ */ jsxRuntimeExports.jsx(
              EllipsisPage,
              {
                direction: page,
                disabled,
                onClick: page === "back-ellipsis" ? goToPreviousPage : goToNextPage
              },
              page
            );
          }
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            NumberPage,
            {
              active: page === currentPage,
              disabled,
              onClick: goToPage,
              page
            },
            page
          );
        }),
        appendedControls
      ]
    }
  );
};
const getPagesList = (currentPage, totalPages) => {
  if (!totalPages || currentPage === -1) {
    totalPages = currentPage;
  }
  if (totalPages <= 6) {
    return Array.from({ length: totalPages }, (_, i2) => i2 + 1);
  }
  if (currentPage <= 4) {
    return [1, 2, 3, 4, "forward-ellipsis", totalPages];
  }
  if (totalPages === currentPage) {
    return [
      1,
      "back-ellipsis",
      currentPage - 3,
      currentPage - 2,
      currentPage - 1,
      totalPages
    ];
  }
  if (totalPages === currentPage + 1) {
    return [
      1,
      "back-ellipsis",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      totalPages
    ];
  }
  if (totalPages <= currentPage + 2) {
    return [
      1,
      "back-ellipsis",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      totalPages
    ];
  }
  if (totalPages <= currentPage + 3) {
    return [
      1,
      "back-ellipsis",
      currentPage,
      currentPage + 1,
      currentPage + 2,
      totalPages
    ];
  }
  return [
    1,
    "back-ellipsis",
    currentPage,
    currentPage + 1,
    "forward-ellipsis",
    totalPages
  ];
};
const PaginationBase = ({
  onPageChange = void 0,
  disabled = false
}) => {
  const { currentPage, totalPages, goToPreviousPage, goToNextPage, goToPage } = usePagination();
  const assumedTotalPages = totalPages ?? 0;
  const pages = useMemo(
    () => getPagesList(currentPage, assumedTotalPages),
    [currentPage, assumedTotalPages]
  );
  useEffect(() => {
    if (!onPageChange) {
      return;
    }
    onPageChange(currentPage);
  }, [currentPage, onPageChange]);
  let prependedControls;
  if (assumedTotalPages > 0) {
    prependedControls = /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavArrowPage,
      {
        disabled: currentPage === 1 || disabled,
        icon: "chevronLeft",
        onClick: goToPreviousPage
      }
    );
  }
  let appendedControls;
  if (assumedTotalPages > 0) {
    appendedControls = /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavArrowPage,
      {
        disabled: currentPage === totalPages || disabled,
        icon: "chevronRight",
        onClick: goToNextPage
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PaginationControls,
    {
      appendedControls,
      currentPage,
      disabled,
      goToNextPage,
      goToPage,
      goToPreviousPage,
      pages,
      prependedControls
    }
  );
};
const Pagination = ({
  onPageChange = void 0,
  totalPages,
  initialPage = 1,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationProvider, { initialPage, totalPages, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationBase, { onPageChange, ...props2 }) });
};
const Popover = ({
  children: children2,
  delayClosingTime = null,
  persistContentOnHover = false
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Provider$1,
    {
      delayClosingTime: delayClosingTime ?? persistContentOnHover ? PopoverDelayCloseTime.short : PopoverDelayCloseTime.immediate,
      persistContentOnHover,
      variant: PopoverVariant.default,
      children: children2
    }
  );
};
Popover.Content = PopoverContent;
Popover.Source = PopoverSource;
const Group$1 = ({
  label: label2 = "",
  name: name2,
  description = void 0,
  disabled = false,
  children: children2 = [],
  hideLabel = false,
  sx: sx2 = {},
  onChange = noop$6,
  horizontal = false,
  ...restOfProps
}) => {
  const [currentlySelectedValue, setCurrentlySelectedValue] = React__default.useState(null);
  const guiField = useGuiFieldMeta(name2);
  const { error: error2 } = guiField || {};
  const descriptionId = uniqueId$1("description");
  const radioGroupLabelId = uniqueId$1("radiogroup-label");
  const { style: style2 } = useStyle({
    display: "flex",
    flexDirection: horizontal ? "row" : "column",
    gap: "radio.default.gap",
    marginTop: label2 && "radio.default.marginTop",
    marginBottom: error2 && "radio.default.marginBottomWithError",
    ...sx2
  });
  const onInputChange = useCallback(
    (e3) => {
      onChange == null ? void 0 : onChange(e3);
      setCurrentlySelectedValue(e3.target.value);
    },
    [onChange]
  );
  useEffect(() => {
    if (guiField == null ? void 0 : guiField.initialValue) {
      setCurrentlySelectedValue(guiField.initialValue);
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    InputBase,
    {
      hideLabel,
      label: label2,
      labelId: radioGroupLabelId,
      name: name2,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Description, { id: descriptionId, children: description }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box$1,
          {
            ...label2 && { "aria-labelledby": radioGroupLabelId },
            ...description && { "aria-describedby": descriptionId },
            role: "radiogroup",
            sx: style2(),
            ...restOfProps,
            children: React__default.Children.map(children2, (element) => {
              return React__default.cloneElement(element, {
                currentlySelectedValue,
                disabled: disabled || element.props.disabled,
                id: `${name2}__${element.props.id}`,
                name: name2,
                onGroupChange: onInputChange
              });
            })
          }
        )
      ]
    }
  );
};
const Description = ({
  children: children2,
  id
}) => {
  if (!children2)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      id,
      sx: {
        marginTop: "radio.description.marginTop",
        marginBottom: "radio.description.marginBottom"
      },
      children: typeof children2 === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph$1, { children: children2 }) : children2
    }
  );
};
const Option = ({
  checked = void 0,
  currentlySelectedValue,
  defaultChecked = void 0,
  disabled = false,
  hasLabel = true,
  id,
  label: label2 = "",
  name: name2 = "",
  onChange = noop$6,
  onGroupChange = noop$6,
  validate = noop$6,
  selectedOptionComponent = void 0,
  sx: sx2 = {},
  textSx = {},
  value,
  variant: variant3 = RadioVariant.default,
  hideRadio = false,
  ...restOfProps
}) => {
  const { style: textStyle2 } = useStyle(textSx);
  const { field } = useGuiField({
    name: name2,
    type: "radio",
    validate,
    value: String(value)
  });
  const handleChange = useEventCallback$1(
    (event2) => {
      var _a2;
      return (_a2 = field == null ? void 0 : field.onChange) == null ? void 0 : _a2.call(field, event2);
    },
    (e3) => {
      e3.stopPropagation();
      onChange == null ? void 0 : onChange(e3);
      onGroupChange == null ? void 0 : onGroupChange(e3);
    },
    [onChange]
  );
  const isCurrentlySelected = currentlySelectedValue === value;
  const SelectedOptionComponentWrapper = isCurrentlySelected ? Box$1 : VisuallyHidden;
  const Label$12 = hasLabel ? Label2 : Box$1;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Label$12,
      {
        ...hasLabel && { htmlFor: id },
        sx: {
          variant: `forms.radio.${variant3}.label`,
          cursor: disabled ? "not-allowed" : "pointer",
          ...sx2
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$1,
            {
              checked,
              defaultChecked,
              disabled,
              id,
              name: name2,
              sx: { variant: `forms.radio.${variant3}.input` },
              type: "radio",
              ...field,
              value: String(value),
              ...restOfProps,
              onChange: handleChange
            }
          ),
          !hideRadio ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: variant3 === RadioVariant.checkMark && checked ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              "data-radio-type": "checkMark",
              "data-test-id": `custom-radio-check-${id}`,
              name: "checkCircle",
              size: IconSizes.Icon24,
              sx: { variant: `forms.radio.${variant3}.div` }
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box$1,
            {
              "data-radio-type": "default",
              "data-test-id": `custom-radio-${id}`,
              variant: `forms.radio.${variant3}.div`
            }
          ) }) : null,
          label2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Span,
            {
              color: disabled ? TextColors.disable : TextColors.primary,
              sx: textStyle2({ alignSelf: "center" }),
              children: label2
            }
          ) : null
        ]
      }
    ),
    selectedOptionComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx(SelectedOptionComponentWrapper, { children: typeof selectedOptionComponent === "function" ? selectedOptionComponent({
      disabled: disabled || !isCurrentlySelected,
      // provide the consumer a way to know if the option is disabled, to disable their own form inputs if neceesary
      // provide the consumer knowledge if the radio is hidden and the any necessary css to align their component properly
      hideRadio,
      marginLeft: `calc(${radio == null ? void 0 : radio.width} + ${radioVariants["default"].div.marginRight})`,
      radioCSS: {
        sizes: radio,
        marginRight: radioVariants["default"].div.marginRight
      }
    }) : selectedOptionComponent }) : null
  ] });
};
const Radio = {
  Group: Group$1,
  Option
};
const SubMenuListItem = ({
  children: children2 = [],
  clickToClose = false,
  disabled = false,
  height = MenuListItemSizes.default,
  label: label2 = false,
  onClick = void 0,
  sx: sx2 = {},
  variant: variant3 = SubMenuListItemVariants.default,
  ...restOfProps
}) => {
  var _a2, _b;
  const { style: style2 } = useStyle(sx2);
  const [menuActive, setMenuActive] = useState(false);
  const ref2 = React__default.useRef();
  const handleMenuInput = useCallback(() => {
    if (clickToClose) {
      setMenuActive(!menuActive);
    } else {
      setMenuActive(true);
    }
  }, [clickToClose, menuActive]);
  const handleClick = useCallback(
    (event2) => {
      const { type: type2, key } = event2;
      if (type2 !== "click" && (type2 !== "keydown" || key !== "Enter" && key !== " ")) {
        return;
      }
      event2.stopPropagation();
      event2.preventDefault();
      if (disabled === false) {
        handleMenuInput();
        onClick == null ? void 0 : onClick(event2);
      }
    },
    [disabled, handleMenuInput, onClick]
  );
  const handleMouseEnter = useCallback(() => {
    !disabled && setMenuActive(true);
  }, [disabled]);
  const handleMouseLeave = useCallback(() => {
    !disabled && setMenuActive(false);
  }, [disabled]);
  const styled = useCallback(
    (theme2) => {
      var _a3, _b2, _c, _d;
      return style2({
        cursor: disabled ? "not-allowed" : "pointer",
        ...theme2.space.menuListItem[height],
        ...theme2.sizes.menuListItem[height],
        "&:after": {
          /** We use the ::after pseudo element here to artificially extend the submenus area
           *  without making it visible to the user. This allows for a slight margin of error (via
           *  the `left` property) to allow the mouse events to register beyond the elements ACTUAL width.
           *  Without this, there is some undesired behavior where if the user isn't pixel-perfect
           *  with their mouse positioning, the menu will close.
           */
          position: "fixed",
          content: '""',
          // add submenu margin as after size
          width: "1rem",
          height: ((_a3 = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _a3.getBoundingClientRect().bottom) - ((_b2 = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _b2.getBoundingClientRect().top) || 0,
          left: (_c = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _c.getBoundingClientRect().right,
          top: (_d = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _d.getBoundingClientRect().top
        }
      });
    },
    [style2, disabled, height, ref2]
  );
  return /* @__PURE__ */ jsxs(
    Flex$1,
    {
      ...restOfProps,
      as: "li",
      onClick: handleClick,
      onKeyDown: handleClick,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      ref: ref2,
      sx: styled,
      variant: `subMenuListItems.${variant3}`,
      children: [
        /* @__PURE__ */ jsx2(Flex$1, { children: /* @__PURE__ */ jsx2(
          Title,
          {
            as: "span",
            color: disabled ? TextColors.disable : TextColors.primary,
            variant: "16",
            children: label2
          }
        ) }),
        /* @__PURE__ */ jsx2(
          Icon,
          {
            disabled,
            name: "chevronRight",
            size: IconSizes.Icon12,
            sx: { marginLeft: "auto" }
          }
        ),
        menuActive && /* @__PURE__ */ jsx2(
          MenuList,
          {
            sx: {
              left: (_a2 = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _a2.getBoundingClientRect().right,
              top: (_b = ref2 == null ? void 0 : ref2.current) == null ? void 0 : _b.getBoundingClientRect().top
            },
            variant: MenuListVariants.submenu,
            children: React__default.Children.map(children2, (child) => React__default.cloneElement(child))
          }
        )
      ]
    }
  );
};
const buildMenuListItems$1 = ({
  listItems,
  ...props2
}) => {
  return listItems.map((op, idx) => {
    if (!!op.subOptions && Array.isArray(op.subOptions)) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenuListItem, { label: op.option, children: buildMenuListItems$1({ listItems: op.subOptions, ...props2 }) }, `${op.value}_${idx}`)
      );
    }
    return (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ jsxRuntimeExports.jsx(wrapped$1, { ...props2, children: cloneValidElement(op.option) }, `${op.value}_${idx}`)
    );
  });
};
const buildMenuListItems = ({
  listItems,
  selectedItems,
  onClick,
  name: name2,
  ...props2
}) => {
  return listItems.map((op, idx) => {
    if (!!op.subOptions && Array.isArray(op.subOptions)) {
      return (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ jsxRuntimeExports.jsx(SubMenuListItem, { label: op.option, children: buildMenuListItems({ listItems: op.subOptions, ...props2 }) }, `${op.value}_${idx}`)
      );
    }
    return (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ jsxRuntimeExports.jsx(wrapped$1, { ...props2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Checkbox,
        {
          checked: selectedItems == null ? void 0 : selectedItems.includes(op.value),
          name: `${name2}-${op.value}`,
          onClick: () => onClick && onClick({ target: { textContent: op.option } }),
          value: op.value,
          children: cloneValidElement(op.option)
        }
      ) }, `${op.value}_${idx}`)
    );
  });
};
var SelectTypes = /* @__PURE__ */ ((SelectTypes2) => {
  SelectTypes2["Bare"] = "bare";
  SelectTypes2["Custom"] = "custom";
  SelectTypes2["Native"] = "native";
  SelectTypes2["Multi"] = "multi";
  return SelectTypes2;
})(SelectTypes || {});
const SelectDropDownMenuList = React__default.forwardRef(
  ({
    /**
     * Sort comparison function to determine sort functionality.
     */
    comparisonFn,
    /**
     * Name of select
     */
    name: name2,
    /**
     * onClick event handler
     */
    onClick,
    /**
     * Results to display
     * */
    options: options2,
    /**
     * Selected items
     */
    selectedItems,
    /**
     * Type of select
     */
    selectType,
    /**
     * styling object
     */
    sx: sx2 = {},
    /**
     * variant as defined in themes
     */
    variant: variant3 = MenuListVariants.default,
    ...rest
  }, ref2) => {
    const menuListItems = useMemo(() => {
      const listItems = !comparisonFn ? options2 : [...options2].sort(comparisonFn);
      return selectType === SelectTypes.Multi && Array.isArray(selectedItems) ? buildMenuListItems({
        listItems,
        onClick,
        selectedItems,
        name: name2,
        role: "option"
      }) : buildMenuListItems$1({ listItems, onClick, role: "option" });
    }, [comparisonFn, onClick, options2, selectType, selectedItems]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      MenuList,
      {
        ...rest,
        ref: ref2,
        sx: { ...styles$x.dropDownMenu, ...sx2 },
        variant: variant3,
        children: menuListItems
      }
    );
  }
);
const Search = ({
  name: name2,
  label: label2,
  hintText,
  placeholder = void 0,
  height = InputHeights.default,
  options: options2 = [],
  disabled,
  variant: variant3 = FormInputVariants.default,
  onChange = noop$6,
  onClear = noop$6,
  onClick = noop$6,
  ...rest
}) => {
  const { meta, helpers } = useGuiField({ name: name2 });
  const currentVariant = useFieldVariant(variant3, meta);
  const updateValue = (data) => {
    helpers == null ? void 0 : helpers.setValue(data);
  };
  const [
    filteredOptions,
    value,
    showResults,
    handleSelection,
    handleInput,
    handleClearSelection
  ] = useTypeAhead({
    options: options2,
    onChange,
    onClick,
    onValueUpdate: updateValue
  });
  const handleClearSearchField = useCallback(
    (e3) => {
      handleClearSelection();
      onClear(e3);
    },
    [onClear, handleClearSelection]
  );
  return /* @__PURE__ */ jsx2(
    InputBase,
    {
      disabled,
      hintText,
      label: label2,
      name: name2,
      variant: currentVariant,
      ...rest,
      children: /* @__PURE__ */ jsxs("div", { sx: { position: "relative" }, children: [
        /* @__PURE__ */ jsx2(
          CompoundInput,
          {
            autoComplete: "off",
            disabled,
            height,
            name: name2,
            onChange: handleInput,
            placeholder,
            postIcon: value && /* @__PURE__ */ jsx2(
              Icon,
              {
                name: "x",
                onClick: handleClearSearchField,
                size: IconSizes.Icon16
              }
            ),
            preIcon: /* @__PURE__ */ jsx2(Icon, { name: "search", size: IconSizes.Icon16 }),
            value,
            variant: currentVariant
          }
        ),
        showResults && /* @__PURE__ */ jsx2(
          SelectDropDownMenuList,
          {
            name: name2,
            onClick: handleSelection,
            options: filteredOptions,
            selectType: SelectTypes.Custom,
            sx: { top: "100%", left: "0" },
            variant: MenuListVariants.default
          }
        )
      ] })
    }
  );
};
var State = /* @__PURE__ */ ((State2) => {
  State2["SETUP"] = "SETUP";
  State2["DEFAULT"] = "DEFAULT";
  return State2;
})(State || {});
var ActionType = /* @__PURE__ */ ((ActionType2) => {
  ActionType2["UPDATE_WITH_OPTION"] = "UPDATE_WITH_OPTION";
  ActionType2["UPDATE_WITH_VALUE"] = "UPDATE_WITH_VALUE";
  return ActionType2;
})(ActionType || {});
const useDropDown = ({
  defaultValue = "",
  selectMultiple = false,
  options: options2,
  onChange,
  onClick,
  ref: ref2
}) => {
  const [state, dispatch] = useReducer(
    dropDownReducer,
    initialState$1({ options: options2, selectMultiple })
  );
  const [showResults, setShowResults] = useState(false);
  useOnClickOutside$1(ref2, () => setShowResults(false));
  const { currentState, selectedOption, selectedValue } = state;
  if (currentState === State.SETUP) {
    dispatch({
      type: ActionType.UPDATE_WITH_VALUE,
      value: defaultValue,
      selectMultiple
    });
  }
  const handleInput = useEventCallback$1(
    () => {
      setShowResults(!showResults);
    },
    onChange,
    []
  );
  const handleSelection = useEventCallback$1(
    (e3) => {
      if (!selectMultiple)
        setShowResults(false);
      const target = e3.target;
      dispatch({
        type: ActionType.UPDATE_WITH_OPTION,
        option: target == null ? void 0 : target.textContent,
        selectMultiple
      });
    },
    onClick,
    options2
  );
  return {
    options: options2,
    selectedValue,
    selectedOption,
    showResults,
    handleSelection,
    handleInput
  };
};
const initialState$1 = ({
  options: options2,
  selectMultiple = false
}) => ({
  currentState: State.SETUP,
  selectedValue: selectMultiple ? [] : "",
  selectedOption: [],
  options: options2
});
const dropDownReducer = (state, action2) => {
  switch (action2.type) {
    case ActionType.UPDATE_WITH_VALUE: {
      const { value, selectMultiple } = action2;
      const { option: selectedOption, value: selectedValue } = Array.isArray(
        value
      ) ? getSelectedOptionValues(state.options, "value", value) : getSelectedOptionValue(state.options, "value", value);
      let updatedOptions = state.selectedOption;
      let updatedValues = state.selectedValue;
      if (Array.isArray(value)) {
        updatedOptions = selectedOption;
        updatedValues = selectedValue;
      } else if (selectedOption) {
        if (selectMultiple && Array.isArray(updatedOptions) && Array.isArray(updatedValues)) {
          if (updatedOptions && typeof selectedOption === "string" && updatedOptions.includes(selectedOption)) {
            updatedOptions = updatedOptions.filter((o) => o !== selectedOption);
            updatedValues = updatedValues.filter((v) => v !== selectedValue);
          } else if (updatedOptions && updatedValues && typeof selectedOption === "string" && typeof selectedValue === "string") {
            updatedOptions = [...updatedOptions, selectedOption];
            updatedValues = [...updatedValues, selectedValue];
          }
        } else {
          updatedOptions = selectedOption;
          updatedValues = selectedValue;
        }
      }
      return {
        ...state,
        currentState: State.DEFAULT,
        selectedOption: updatedOptions,
        selectedValue: updatedValues
      };
    }
    case ActionType.UPDATE_WITH_OPTION: {
      const { option, selectMultiple } = action2;
      const { option: selectedOption, value: selectedValue } = Array.isArray(
        option
      ) ? getSelectedOptionValues(state.options, "option", option) : getSelectedOptionValue(state.options, "option", option);
      let updatedOptions = state.selectedOption;
      let updatedValues = state.selectedValue;
      if (selectedOption) {
        if (selectMultiple && Array.isArray(updatedOptions) && Array.isArray(updatedValues)) {
          if (updatedOptions && typeof selectedOption === "string" && updatedOptions.includes(selectedOption) && Array.isArray(updatedOptions) && Array.isArray(updatedValues)) {
            updatedOptions = updatedOptions.filter((o) => o !== selectedOption);
            updatedValues = updatedValues.filter((v) => v !== selectedValue);
          } else if (updatedOptions && updatedValues && typeof selectedOption === "string" && typeof selectedValue === "string") {
            updatedOptions = [...updatedOptions, selectedOption];
            updatedValues = [...updatedValues, selectedValue];
          }
        } else {
          updatedOptions = selectedOption;
          updatedValues = selectedValue;
        }
      }
      return {
        ...state,
        currentState: State.DEFAULT,
        selectedOption: updatedOptions,
        selectedValue: updatedValues
      };
    }
    default: {
      throw new Error(`No action type handled for "${action2}"`);
    }
  }
};
const getSelectedOptionValue = (options2, searchKey, searchTerm) => {
  const foundOptionValue = options2.find(
    (o) => String(o[searchKey]) === String(searchTerm)
  );
  if (foundOptionValue == null) {
    return {};
  }
  const { value, option } = foundOptionValue;
  return { value, option };
};
const getSelectedOptionValues = (options2, searchKey, searchTerms) => {
  const mappedValues = searchTerms == null ? void 0 : searchTerms.map((searchTerm) => {
    const foundOptionValue = options2.find(
      (o) => String(o[searchKey]) === String(searchTerm)
    );
    if (foundOptionValue == null) {
      return {};
    }
    const { value, option } = foundOptionValue;
    return { value, option };
  });
  return {
    value: mappedValues == null ? void 0 : mappedValues.map((x3) => x3.value),
    option: mappedValues == null ? void 0 : mappedValues.map((x3) => x3.option)
  };
};
const ServersideSearch = ({
  name: name2,
  label: label2,
  hintText,
  placeholder = void 0,
  height = InputHeights.default,
  options: options2 = [],
  disabled,
  loading = false,
  loadingComponent = /* @__PURE__ */ jsx2(Spinner2, { size: SpinnerSizes.default, variant: SpinnerVariants.secondary }),
  noResultsComponent = /* @__PURE__ */ jsx2(Fragment, {}),
  onSearch = noop$6,
  onChange = noop$6,
  onClear = noop$6,
  onClick = noop$6,
  searchClearIconAriaLabel,
  wait = 300,
  ...rest
}) => {
  const [shouldShowDropdown, setShouldShowDropdown] = useState(false);
  const { meta, helpers } = useGuiField({ name: name2 });
  const inputRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const setSelectedValue = (helpers == null ? void 0 : helpers.setValue) || noop$6;
  const selectedValue = (meta == null ? void 0 : meta.value) || "";
  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchText === null || searchText === void 0 || searchText === "") {
        return;
      }
      onSearch(searchText);
    }, wait);
    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);
  const handleSelection = useEventCallback$1(
    (e3) => {
      const target = e3.target;
      const optionValue = getSelectedOptionValue(
        options2,
        "option",
        target.textContent
      );
      setSearchText(optionValue.option);
      setSelectedValue(optionValue.value);
      setShouldShowDropdown(false);
    },
    onClick,
    [setSelectedValue]
  );
  const handleClearSelection = (e3) => {
    setSearchText("");
    setSelectedValue("");
    onClear(e3);
  };
  useOnClickOutside$1(inputRef, () => setShouldShowDropdown(false));
  const showLoadingDropdown = shouldShowDropdown && loading;
  const showResults = shouldShowDropdown && !loading && options2.length > 0;
  const showNoResults = shouldShowDropdown && !loading && options2.length === 0;
  return /* @__PURE__ */ jsx2(
    InputBase,
    {
      disabled,
      hintText,
      label: label2,
      name: name2,
      ...rest,
      children: /* @__PURE__ */ jsxs("div", { ref: inputRef, sx: { position: "relative" }, children: [
        /* @__PURE__ */ jsx2(
          CompoundInput,
          {
            autoComplete: "off",
            disabled,
            height,
            onChange: (e3) => setSearchText(e3.target.value),
            onFocus: () => setShouldShowDropdown(true),
            placeholder,
            postIcon: searchText && /* @__PURE__ */ jsx2(
              Icon,
              {
                "aria-label": searchClearIconAriaLabel,
                name: "x",
                onClick: handleClearSelection,
                size: IconSizes.Icon16
              }
            ),
            preIcon: /* @__PURE__ */ jsx2(Icon, { name: "search", role: "presentation", size: IconSizes.Icon16 }),
            value: searchText
          }
        ),
        showLoadingDropdown && /* @__PURE__ */ jsx2(
          MenuList,
          {
            role: "listbox",
            sx: { ...serversideSearch.menuList },
            variant: MenuListVariants.default,
            children: loadingComponent
          }
        ),
        showResults && /* @__PURE__ */ jsx2(
          SelectDropDownMenuList,
          {
            name: name2,
            onClick: handleSelection,
            options: options2,
            role: "listbox",
            selectType: SelectTypes.Custom,
            sx: { ...serversideSearch.menuList },
            variant: MenuListVariants.default
          }
        ),
        showNoResults && /* @__PURE__ */ jsx2(
          MenuList,
          {
            role: "listbox",
            sx: { ...serversideSearch.menuList },
            variant: MenuListVariants.default,
            children: noResultsComponent
          }
        ),
        /* @__PURE__ */ jsx2(
          CompoundInput,
          {
            name: name2,
            onChange,
            readOnly: true,
            tabIndex: -1,
            type: InputTypes.hidden,
            value: selectedValue
          }
        )
      ] })
    }
  );
};
const SelectInput = ({
  disabled = false,
  name: name2,
  height,
  variant: variant3,
  active,
  selectedValue = [],
  selectedOption = [],
  placeholder = void 0,
  onClick,
  onKeyDown,
  sx: sx2 = {},
  ...props2
}) => {
  const { style: wrapperStyle } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex$1,
    {
      "aria-disabled": disabled,
      "aria-labelledby": `${name2}Label ${name2}HintText`,
      "data-test-id": `input-wrapper-select--${name2}`,
      onClick,
      onKeyDown,
      sx: wrapperStyle(
        styles$c.wrapper(
          height,
          variant3,
          disabled,
          active
        )
      ),
      tabIndex: 0,
      variant: `forms.${variant3}.wrapperStyles`,
      ...props2,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph$1,
          {
            color: disabled || !selectedOption || Array.isArray(selectedOption) && selectedOption.length === 0 ? TextColors.disable : TextColors.primary,
            "data-test-id": `input-wrapper-selected-option--${name2}`,
            variant: "16",
            children: Array.isArray(selectedOption) ? selectedOption.join(", ") || placeholder : selectedOption
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          CompoundInput,
          {
            name: name2,
            readOnly: true,
            tabIndex: -1,
            type: InputTypes.hidden,
            value: selectedValue || ""
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Icon,
          {
            color: disabled ? TextColors.disable : TextColors.primary,
            "data-test-id": `input-icon--${name2}`,
            name: "chevronDown",
            size: IconSizes.Icon16
          }
        )
      ]
    }
  );
};
const styles$c = {
  wrapper: (height, variant3, disabled, active) => ({
    "&:hover": {
      borderColor: !disabled ? `forms.${variant3}.border.${active ? ".active" : "hover"}` : null
    },
    "&:focus": {
      borderColor: `forms.${disabled ? "disabled" : variant3}.border.active`,
      outline: "transparent"
    },
    backgroundColor: disabled ? "forms.disabled.background" : null,
    borderColor: `forms.${disabled ? "disabled" : variant3}.border${active ? ".active" : ""}`,
    flexDirection: "row",
    justifyContent: "space-between",
    cursor: disabled ? "not-allowed" : "default",
    height: `input.${height}.height`,
    paddingX: `input.${height}.paddingX`,
    paddingY: `input.${height}.paddingY`
  })
};
const AnimatedBox$1 = animated(Card$1);
var SheetSizes = /* @__PURE__ */ ((SheetSizes2) => {
  SheetSizes2["Auto"] = "auto";
  SheetSizes2["Half"] = "half";
  return SheetSizes2;
})(SheetSizes || {});
const Sheet = ({
  children: children2,
  size = "auto",
  onDismiss = noop$6,
  open = true,
  a11yTitle
}) => {
  const { theme: theme2 } = useTheme();
  const transitions2 = useTransition(open, {
    config: open ? { ...theme2.animations.sheet.physics.type } : { duration: Number(theme2.transitions.durations.Duration100) },
    from: theme2.animations.sheet.from,
    enter: theme2.animations.sheet.enter,
    leave: theme2.animations.sheet.leave
  });
  return transitions2(({ y: y4 }, item) => {
    return item ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      OverlayContent,
      {
        a11yTitle,
        alignItems: "baseline",
        dismissOnOutsideClick: true,
        isOpen: open,
        justifyContent: "flex-end",
        onDismiss,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnimatedBox$1,
          {
            style: {
              transform: y4.to((y22) => `translate3d(0px, ${y22}%, 0px)`)
            },
            sx: styles$b.card,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: styles$b.wrapper(size), children: children2 })
          }
        )
      }
    ) : null;
  });
};
const styles$b = {
  card: {
    backgroundColor: "sheet.background",
    width: "100vw",
    borderRadius: "sheet",
    overflow: "hidden"
  },
  wrapper: (size) => ({
    overflowY: "auto",
    overflowX: "hidden",
    height: `sheet.height.${size}`,
    maxHeight: "sheet.maxHeight",
    paddingTop: "sheet.wrapper.paddingTop",
    paddingBottom: "sheet.wrapper.paddingBottom",
    paddingX: "sheet.wrapper.paddingX"
  })
};
const SelectDropdownContainer = ({
  onDismiss = noop$6,
  children: children2
}) => {
  return /* @__PURE__ */ jsx2(MatchMedia, { children: ({ xs }) => {
    if (xs) {
      return /* @__PURE__ */ jsx2(Sheet, { a11yTitle: "Select", onDismiss, children: cloneValidElement(children2, {
        variant: MenuListVariants.mobile
      }) });
    } else {
      return /* @__PURE__ */ jsx2("div", { sx: { top: "100%", left: 0 }, children: children2 });
    }
  } });
};
const Select$1 = ({
  name: name2,
  label: label2,
  hintText,
  hintTextParagraphVariant,
  placeholder = void 0,
  height = InputHeights.default,
  options: options2 = [],
  disabled,
  defaultValue,
  sx: sx2 = {},
  variant: variant3 = FormInputVariants.default,
  selectType,
  onChange = noop$6,
  onClick = noop$6,
  ...rest
}) => {
  const guiForm = useGuiForm();
  const ref2 = useRef(null);
  let guiFormFieldValue;
  if (guiForm) {
    const fieldProps = guiForm.getFieldProps(name2);
    guiFormFieldValue = fieldProps.value;
  }
  const {
    selectedOption,
    selectedValue,
    showResults,
    handleSelection,
    handleInput
  } = useDropDown({
    options: options2,
    selectMultiple: selectType === SelectTypes.Multi,
    onChange,
    onClick,
    ref: ref2,
    defaultValue: guiFormFieldValue || defaultValue
  });
  useEffect(() => {
    if (guiForm) {
      const { setValue } = guiForm.getFieldHelpers(name2);
      setValue(selectedValue);
    }
  }, [name2, selectedValue]);
  const handleClick = (e3) => {
    if (!disabled)
      handleInput(e3);
  };
  const handleFocusedContainerKeyDown = (event2) => {
    switch (event2 == null ? void 0 : event2.key) {
      case "Enter":
      case "ArrowDown":
      case "Spacebar":
      case " ":
        if (!showResults)
          handleInput(event2);
        break;
      case "Escape":
        if (showResults)
          handleInput(event2);
        break;
    }
  };
  return /* @__PURE__ */ jsx2(
    InputBase,
    {
      disabled,
      hintText,
      hintTextParagraphVariant,
      label: label2,
      name: name2,
      sx: sx2,
      variant: variant3,
      ...rest,
      children: /* @__PURE__ */ jsxs("div", { ref: ref2, sx: { position: "relative" }, children: [
        /* @__PURE__ */ jsx2(
          SelectInput,
          {
            active: showResults,
            disabled,
            height,
            name: name2,
            onClick: handleClick,
            onKeyDown: handleFocusedContainerKeyDown,
            placeholder,
            selectedOption,
            selectedValue: guiFormFieldValue || selectedValue,
            variant: variant3
          }
        ),
        showResults && /* @__PURE__ */ jsx2(SelectDropdownContainer, { onDismiss: handleInput, children: /* @__PURE__ */ jsx2(
          SelectDropDownMenuList,
          {
            name: name2,
            onClick: handleSelection,
            options: options2,
            selectType: selectType || SelectTypes.Native,
            selectedItems: selectedValue,
            variant: MenuListVariants.default
          }
        ) })
      ] })
    }
  );
};
const NativeSelect = ({
  disabled,
  hideLabel = false,
  hintText,
  hintTextParagraphVariant,
  label: label2,
  name: name2,
  variant: variant3 = FormInputVariants.default,
  options: options2,
  defaultValue,
  height = InputHeights.default,
  placeholder,
  onChange = noop$6,
  onClick = noop$6,
  onBlur: onBlur3 = noop$6,
  selectType = SelectTypes.Native,
  sx: sx2,
  validate,
  width,
  ...rest
}) => {
  const { field, meta, helpers } = useGuiField({
    name: name2,
    validate
  });
  const getInitialValue = useCallback(() => {
    if (defaultValue)
      return defaultValue;
    else if ((meta == null ? void 0 : meta.initialValue) === "" || (meta == null ? void 0 : meta.initialValue))
      return meta == null ? void 0 : meta.initialValue;
    else if (placeholder)
      return "";
    else
      return void 0;
  }, [defaultValue, placeholder]);
  const [dataValue, setDataValue] = useState(getInitialValue());
  const handleChange = useEventCallback$1(
    (e3) => {
      helpers == null ? void 0 : helpers.setValue(e3.target.value);
      setDataValue(e3.target.value);
    },
    onChange,
    []
  );
  const { style: style2 } = useStyle();
  const handleBlur = useEventCallback$1(
    () => {
      helpers == null ? void 0 : helpers.setTouched(true);
    },
    onBlur3,
    []
  );
  const currentVariant = useFieldVariant(variant3, meta);
  const labelHidden = hideLabel || selectType === SelectTypes.Bare || !label2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    InputBase,
    {
      disabled,
      hideLabel: labelHidden,
      hintText,
      hintTextParagraphVariant,
      label: label2,
      name: name2,
      sx: sx2,
      variant: variant3,
      ...rest,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
        Select$2,
        {
          "aria-labelledby": `${name2}Label ${name2}HintText`,
          arrow: /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              color: disabled ? TextColors.disable : TextColors.primary,
              "data-test-id": `input-icon--${name2}`,
              name: "chevronDown",
              size: IconSizes.Icon16,
              sx: { ml: -28, alignSelf: "center", pointerEvents: "none" }
            }
          ),
          "data-test-id": `select--${name2}`,
          "data-value": dataValue,
          defaultValue: !field ? getInitialValue() : void 0,
          disabled,
          name: name2,
          onBlur: handleBlur,
          onChange: handleChange,
          onClick,
          placeholder,
          sx: style2(
            styles$a.wrapper(height, width, currentVariant, selectType, disabled)
          ),
          value: (field == null ? void 0 : field.value) ?? (meta == null ? void 0 : meta.initialValue),
          variant: `${currentVariant}.wrapperStyles`,
          children: [
            placeholder && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { disabled: true, value: "", children: placeholder }),
            options2.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: item.value, children: item.option }, item.value))
          ]
        }
      )
    }
  );
};
const styles$a = {
  wrapper: (height, width, variant3, selectType, disabled) => ({
    '&[data-value=""]': {
      color: TextColors.disable
    },
    ":disabled": {
      color: TextColors.secondary,
      opacity: 1,
      // disable browser css default rule
      '&[data-value=""]': {
        color: TextColors.disable
      }
    },
    "&:hover": {
      borderColor: !disabled ? `forms.${variant3}.border.hover` : null
    },
    "&:focus": {
      borderColor: `forms.${disabled ? "disabled" : variant3}.border.active`,
      outline: "transparent"
    },
    color: TextColors.primary,
    backgroundColor: disabled ? "forms.disabled.background" : null,
    borderColor: `forms.${disabled ? "disabled" : variant3}.border`,
    height: `input.${height}.height`,
    paddingX: `input.${height}.paddingX`,
    paddingY: `input.${height}.paddingY`,
    paddingRight: "none",
    // If set, Select icon becomes mis-aligned with selected text at smaller widths.
    width,
    ...selectType === SelectTypes.Bare ? {
      borderColor: "transparent",
      backgroundColor: "unset",
      "&:.focus-visible:not(:focus)": {
        border: "default",
        borderColor: "forms.default.border.active",
        outline: "solid transparent"
      },
      "&:hover": {
        borderColor: "transparent"
      },
      "&:focus:not(.focus-visible)": {
        border: "none",
        borderColor: "transparent"
      }
    } : {}
  })
};
const Select2 = ({ selectType = SelectTypes.Native, ...props2 }) => {
  let SelectComponent;
  switch (selectType) {
    case SelectTypes.Bare: {
      SelectComponent = NativeSelect;
      break;
    }
    case SelectTypes.Custom: {
      SelectComponent = Select$1;
      break;
    }
    case SelectTypes.Multi: {
      SelectComponent = Select$1;
      break;
    }
    case SelectTypes.Native: {
      SelectComponent = NativeSelect;
      break;
    }
    default: {
      SelectComponent = NativeSelect;
    }
  }
  return /* @__PURE__ */ jsx2(SelectComponent, { selectType, ...props2 });
};
const ShowHide = ({
  hideText = "Click to hide",
  initiallyHidden = true,
  showText = "Click to view",
  children: children2
}) => {
  const [hideStatus, setHideStatus] = useState({
    hidden: initiallyHidden,
    controlText: initiallyHidden ? showText : hideText
  });
  const [showHideId] = useState(() => uniqueId$1("showHide-"));
  const toggle = () => {
    const newStatus = !hideStatus.hidden;
    setHideStatus({
      hidden: newStatus,
      controlText: newStatus ? showText : hideText
    });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { spacing: 0.75, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompoundButton,
      {
        "aria-controls": showHideId,
        "aria-expanded": !hideStatus.hidden,
        onClick: toggle,
        variant: LinkVariant.vibrant,
        children: hideStatus.controlText
      }
    ),
    !hideStatus.hidden ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { id: showHideId, children: children2 }) : null
  ] });
};
const SliderContext = createContext(
  void 0
);
const useSliderContext = () => {
  const context = useContext(SliderContext);
  if (!context) {
    throw new Error(`Need to be rendered inside a Slider component.`);
  }
  return context;
};
const resetStyles = {
  WebkitAppearance: "none",
  width: "100%",
  background: "transparent",
  marginTop: 0,
  marginBottom: 0,
  "&::webkit-slider-thumb": {
    WebkitAppearance: "none"
  },
  ":focus": {
    outline: "solid transparent"
    // not set to "none", so will show up in high contrast mode
  }
};
const trackStyles = {
  width: "100%",
  height: "2px",
  // --------------------------------------------------
  // Could not access theme-ui colors directly in this file.
  // ie. The following doesn't work:
  //      background: "slider.track.background"
  // Should dig deeper into why later.
  // --------------------------------------------------
  // background: (theme: Theme) =>
  //   colorMatcher(
  //     theme.colors as Record<string, any>,
  //     "slider.track.background"
  //   ),
  background: (theme2) => asExactTheme(theme2).colors.slider.track.background,
  backgroundImage: (theme2) => asExactTheme(theme2).colors.slider.track.activeSelectionRange.enable.backgroundImage,
  backgroundSize: "0% + 100%",
  backgroundRepeat: "no-repeat"
};
const trackFocusStyles = {
  backgroundImage: (theme2) => asExactTheme(theme2).colors.slider.track.activeSelectionRange.focus.backgroundImage
};
const trackActiveStyles = {
  backgroundImage: (theme2) => asExactTheme(theme2).colors.slider.track.activeSelectionRange.focus.backgroundImage
};
const trackDisabledStyles = {
  background: (theme2) => asExactTheme(theme2).colors.slider.track.disabled.background,
  backgroundImage: (theme2) => asExactTheme(theme2).colors.slider.track.activeSelectionRange.disabled.backgroundImage,
  backgroundRepeat: "no-repeat"
};
const thumbStyles = {
  height: "16px",
  width: "16px",
  borderRadius: "50%",
  background: (theme2) => asExactTheme(theme2).colors.slider.thumb.enable.background,
  cursor: "pointer",
  transitionProperty: "background-color, transform, box-shadow",
  transition: (theme2) => asExactTheme(theme2).transitions.slider.thumb.base,
  marginTop: "-7px"
};
const thumbHoverStyles = {
  transform: "scale(1.375)",
  // from 16px to 22px
  transitionProperty: "background-color, transform, box-shadow",
  transition: (theme2) => asExactTheme(theme2).transitions.slider.thumb.hover
};
const thumbFocusStyles = {
  boxShadow: (theme2) => asExactTheme(theme2).colors.slider.thumb.focus.boxShadow,
  background: (theme2) => asExactTheme(theme2).colors.slider.thumb.focus.background,
  transform: "scale(1)",
  transitionProperty: "background-color, transform, box-shadow",
  transition: (theme2) => asExactTheme(theme2).transitions.slider.thumb.hover
};
const thumbActiveStyles = {
  background: (theme2) => asExactTheme(theme2).colors.slider.thumb.focus.background,
  boxShadow: "unset",
  transform: "scale(1.375)",
  transitionProperty: "background-color",
  transition: (theme2) => asExactTheme(theme2).transitions.slider.thumb.active
};
const thumbDisabledStyles = {
  transform: "scale(1)",
  background: (theme2) => asExactTheme(theme2).colors.slider.thumb.disabled.background,
  pointerEvents: "none"
};
const disabledStyles = {
  cursor: "not-allowed",
  "::-webkit-slider-thumb": {
    ...thumbDisabledStyles,
    ":hover": {
      ...thumbDisabledStyles
    },
    ":focus": {
      ...thumbDisabledStyles
    },
    ":active": {
      ...thumbDisabledStyles
    }
  },
  "::-moz-range-thumb": {
    ...thumbDisabledStyles,
    ":hover,:focus,:active": {
      ...thumbDisabledStyles
    }
  }
};
const pseudoClasses = {
  ":hover": {
    "::-webkit-slider-thumb": { ...thumbHoverStyles },
    "::-moz-range-thumb": { ...thumbHoverStyles },
    // theme-ui renders the :hover before :focus. We need to have the :focus state inside the :hover state in order to override the :hover state when we are in both a :hover and a :focus state.
    ":focus": {
      transitionProperty: "background background-image",
      transition: (theme2) => asExactTheme(theme2).transitions.slider.base,
      "::-webkit-slider-thumb": { ...thumbFocusStyles },
      "::-moz-range-thumb": { ...thumbFocusStyles }
    }
  },
  ":focus": {
    "::-webkit-slider-runnable-track": { ...trackFocusStyles },
    "::-moz-range-track": { ...trackFocusStyles },
    transitionProperty: "background background-image",
    transition: (theme2) => asExactTheme(theme2).transitions.slider.base,
    "::-webkit-slider-thumb": { ...thumbFocusStyles },
    "::-moz-range-thumb": { ...thumbFocusStyles }
  },
  ":active": {
    "::-webkit-slider-runnable-track": { ...trackActiveStyles },
    "::-moz-range-track": { ...trackActiveStyles },
    transitionProperty: "background background-image",
    transition: (theme2) => asExactTheme(theme2).transitions.slider.base,
    "::-webkit-slider-thumb": { ...thumbActiveStyles },
    "::-moz-range-thumb": { ...thumbActiveStyles },
    // theme-ui renders the :active before :focus. We need to have the :focus state inside the :active state in order to override the :active state when we are in both a :active and a :focus state.
    ":focus": {
      "::-webkit-slider-thumb": { ...thumbActiveStyles },
      "::-moz-range-thumb": { ...thumbActiveStyles }
    }
  }
};
const customStyles = {
  borderRadius: "5px",
  transitionProperty: "background background-image",
  transition: (theme2) => asExactTheme(theme2).transitions.slider.base,
  "::-webkit-slider-runnable-track": { ...trackStyles },
  "::-moz-range-track": { ...trackStyles },
  "::-webkit-slider-thumb": { ...thumbStyles },
  "::-moz-range-thumb": { ...thumbStyles }
};
const tooltipArrowWidth = "7px";
const tooltipArrowHeight = 8;
const tooltipArrow = {
  content: '""',
  position: "absolute",
  left: `calc(50% - ${tooltipArrowWidth})`,
  bottom: `-${tooltipArrowHeight}px`,
  borderTop: `${tooltipArrowHeight}px solid`,
  borderColor: (theme2) => asExactTheme(theme2).popover.tooltip.backgroundColor,
  borderLeft: `${tooltipArrowWidth} solid transparent`,
  borderRight: `${tooltipArrowWidth} solid transparent`
};
const SingleThumbRangeBase = ({
  disabled = false,
  tooltipEnabled = false,
  setAriaValueText: getAriaValueText = void 0,
  ariaLabelledBy = "",
  onChange = noop$6,
  debounceOnChangeDelay = Throttle.none,
  onChangeEnd = noop$6,
  mediaQueries: mediaQueries2,
  onTooltipAction = void 0,
  onTooltipError = void 0,
  sx: sx2 = {},
  className = void 0,
  ...restOfProps
}) => {
  const {
    min: min2,
    max: max2,
    step: step2,
    sliderValue,
    setSliderValue,
    activeTrackValue,
    setActiveTrackValue,
    labelId,
    isAllDisabled
  } = useSliderContext();
  const { dismiss, open } = usePlaceablePopover();
  const [controlledStep, setControlledStep] = useState(step2);
  const [ariaValueText, setAriaValueText] = useState("");
  const { style: style2 } = useStyle(sx2);
  const isDisabled = isAllDisabled || disabled;
  const adjustActiveTrack = useCallback(
    (val) => {
      if (Number.isNaN(+val) === false) {
        const activeTrackValue2 = getActiveTrackValue(min2, max2, val);
        setActiveTrackValue(activeTrackValue2);
      }
    },
    [min2, max2]
  );
  const resetSliderState = useCallback(
    (val) => {
      adjustActiveTrack(val);
      setSliderValue(val);
      setControlledStep(step2);
    },
    [adjustActiveTrack, setSliderValue, step2]
  );
  useEffect(() => {
    resetSliderState(sliderValue);
  }, [resetSliderState, sliderValue]);
  const getAriaValueTextSetByFn = useCallback(
    () => getAriaValueText ? getAriaValueText(sliderValue) : "",
    [getAriaValueText, sliderValue]
  );
  useEffect(() => {
    const ariaValueText2 = getAriaValueTextSetByFn();
    setAriaValueText(ariaValueText2);
  }, [getAriaValueTextSetByFn, sliderValue]);
  const debouncedOnChange = useRef(
    debounce$3((val) => {
      if (onChange && typeof onChange === "function") {
        onChange(val);
      }
    }, debounceOnChangeDelay)
  ).current;
  const openPopover = (e3) => {
    if (tooltipEnabled) {
      return open(e3.currentTarget, onTooltipAction, onTooltipError);
    }
    return null;
  };
  const closePopover = () => {
    return dismiss(onTooltipAction, onTooltipError);
  };
  const onThumbDown = useCallback(
    (e3) => {
      const val = +e3.target.value;
      setSliderValue(val);
      debouncedOnChange(val);
    },
    [setSliderValue, debouncedOnChange]
  );
  const onThumbRelease = useCallback(() => {
    if (onChangeEnd && typeof onChangeEnd === "function") {
      onChangeEnd(sliderValue ?? 0);
    }
    if (tooltipEnabled) {
      closePopover();
    }
  }, [closePopover, onChangeEnd, sliderValue, tooltipEnabled]);
  const onChangeHandler = isDisabled ? noop$6 : onThumbDown;
  const onChangeEndHandler = isDisabled ? noop$6 : onThumbRelease;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slider$1,
    {
      "aria-disabled": isDisabled,
      "aria-labelledby": `${labelId} ${ariaLabelledBy}`,
      "aria-valuemax": max2,
      "aria-valuemin": min2,
      "aria-valuenow": sliderValue,
      disabled: isDisabled,
      max: max2,
      min: min2,
      step: controlledStep,
      sx: style2(styles$9.slider(mediaQueries2, isDisabled, activeTrackValue)),
      value: sliderValue,
      ...!!ariaValueText && { "aria-valuetext": ariaValueText },
      className: classNames(className, "gui"),
      onChange: onChangeHandler,
      onKeyUp: onChangeEndHandler,
      onMouseDown: openPopover,
      onMouseUp: onChangeEndHandler,
      onTouchEnd: onChangeEndHandler,
      onTouchStart: openPopover,
      ...restOfProps
    }
  );
};
const getActiveTrackValue = (min2, max2, val) => {
  if (val <= min2)
    return "0.00";
  if (val >= max2)
    return "100.00";
  const range2 = Math.abs(max2 - min2);
  const amount = Math.abs(val - min2);
  const percentageOfRange = Number(amount / range2 * 100).toFixed(2);
  return percentageOfRange;
};
const styles$9 = {
  slider: (mediaQueries2, isDisabled, activeTrackValue) => {
    const activeTrackStyles = {
      backgroundSize: `${activeTrackValue ? `${activeTrackValue}% + ` : ""} 100%`
    };
    const applyActiveTrackStyles = (baseTrackStyles) => ({
      "::-webkit-slider-runnable-track": {
        ...baseTrackStyles,
        ...activeTrackStyles
      },
      "::-moz-range-track": {
        ...baseTrackStyles,
        ...activeTrackStyles
      }
    });
    const rangeDisabledStyles = {
      "&[aria-disabled='true']": {
        ...disabledStyles,
        ...applyActiveTrackStyles(trackDisabledStyles)
      }
    };
    return {
      ...resetStyles,
      ...customStyles,
      // padding to create larger tap-target for smaller screens
      paddingTop: mediaQueries2.smDown ? "24px" : "18px",
      paddingBottom: mediaQueries2.smDown ? "24px" : "18px",
      ...applyActiveTrackStyles(trackStyles),
      ...isDisabled ? rangeDisabledStyles : pseudoClasses
    };
  }
};
const useSliderTooltip = ({
  source,
  popoverElement,
  positionAndAlignment,
  arrowElement,
  offset: offset2,
  popoverMargin: popoverMargin2
}) => {
  return usePopper$1(source, popoverElement, {
    placement: positionAndAlignment,
    modifiers: [
      {
        name: "offset",
        options: {
          // offset dimensions are x, y
          // and measured in px
          offset: [offset2, popoverMargin2]
        }
      },
      { name: "arrow", options: { element: arrowElement } },
      // slider tooltips should always be placed above the slider
      { name: "flip", enabled: false }
    ]
  });
};
const SliderTooltip = ({
  disabled = false,
  tooltipEnabled = false,
  mediaQueries: mediaQueries2,
  sx: sx2 = {},
  ...restOfProps
}) => {
  const {
    popoverState: { visible, source },
    variant: variant3
  } = usePlaceablePopover();
  const { style: style2 } = useStyle(sx2);
  const { isAllDisabled, sliderValue, activeTrackValue } = useSliderContext();
  const isDisabled = isAllDisabled || disabled;
  const [popoverElement, setElement] = useState();
  const [tooltipOffset, setTooltipOffset] = useState(0);
  const [tooltipMargin, setTooltipMargin] = useState(0);
  useEffect(() => {
    if (source) {
      setTooltipOffset(getActiveTrackOffset(activeTrackValue, source));
    }
  }, [activeTrackValue, source]);
  useEffect(() => {
    if (source) {
      setTooltipMargin(getTooltipMargin(source, mediaQueries2));
    }
  }, [source, mediaQueries2]);
  const positionAndAlignment = {
    position: Alignment.top,
    positionAndAlignment: "top"
  };
  const setPopoverElement = useCallback(
    (node2) => {
      if (node2 !== null && source) {
        setElement(node2);
      }
    },
    [source]
  );
  const { styles: styles2, attributes } = useSliderTooltip({
    source,
    popoverElement,
    positionAndAlignment: positionAndAlignment.positionAndAlignment,
    offset: tooltipOffset,
    popoverMargin: tooltipMargin
  });
  const visibility = visible ? "visible" : "hidden";
  const popover2 = /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box$1,
    {
      ref: setPopoverElement,
      sx: style2({
        variant: `popover.${variant3}`,
        ...styles2.popper,
        visibility,
        "&:after": tooltipArrow
      }),
      ...attributes.popper,
      ...restOfProps,
      children: sliderValue
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: !isDisabled && tooltipEnabled && visible && Portal$1({ children: popover2 }) });
};
const getActiveTrackOffset = (activeTrackValue, source) => {
  const thumbCircleWidth = 16;
  const sourceRect = source.getBoundingClientRect();
  const sourceWidth = sourceRect.right - sourceRect.left - thumbCircleWidth;
  const trackValueOffCenter = parseFloat(activeTrackValue) - 50;
  const trackPercentOffCenter = trackValueOffCenter / 100;
  return trackPercentOffCenter * sourceWidth;
};
const getTooltipMargin = (source, mediaQueries2) => {
  const focusedThumbCircleWidth = 22;
  const expectedMargin = mediaQueries2.smDown ? 12 : 4;
  const sourceRect = source.getBoundingClientRect();
  const sourceHeight = sourceRect.bottom - sourceRect.top;
  const gap = sourceHeight / 2 - focusedThumbCircleWidth / 2 - expectedMargin;
  return tooltipArrowHeight - gap;
};
const SingleThumbRange = ({
  ariaLabelledBy = "",
  debounceOnChangeDelay = Throttle.none,
  disabled = false,
  name: name2 = "",
  onChange = noop$6,
  onChangeEnd = noop$6,
  onTooltipAction = void 0,
  onTooltipError = void 0,
  setAriaValueText: getAriaValueText = void 0,
  sx: sx2 = {},
  tooltipEnabled = false,
  className = void 0,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SingleThumbRangeBase,
        {
          ariaLabelledBy,
          className,
          debounceOnChangeDelay,
          disabled,
          mediaQueries: mediaQueries2,
          name: name2,
          onChange,
          onChangeEnd,
          onTooltipAction,
          onTooltipError,
          setAriaValueText: getAriaValueText,
          sx: sx2,
          tooltipEnabled,
          ...restOfProps
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        SliderTooltip,
        {
          disabled,
          mediaQueries: mediaQueries2,
          tooltipEnabled
        }
      )
    ] });
  } });
};
const SliderInput = ({
  ariaLabelledBy = "",
  disabled = false,
  name: name2,
  onChange = noop$6,
  onBlur: onBlur3 = noop$6,
  ...restOfProps
}) => {
  const { sliderValue, setSliderValue, labelId, isAllDisabled, min: min2, max: max2 } = useSliderContext();
  const [inputValue, setInputValue] = useState("");
  const isDisabled = isAllDisabled || disabled;
  useEffect(() => {
    setInputValue(sliderValue || sliderValue === 0 ? `${sliderValue}` : "");
  }, [sliderValue]);
  const onChangeHandler = useCallback(
    (e3) => {
      const targetValue = e3.target.value;
      if (targetValue === "") {
        setInputValue(targetValue);
      } else if (targetValue.match(onlyFractionalNumbers)) {
        setInputValue(targetValue);
        const startingDecimalEntry = /^[+-]?(0|(\d\.))$/;
        if (!targetValue.match(startingDecimalEntry) && isNumber$1(+targetValue)) {
          setSliderValue(+targetValue);
        }
      }
      if (onChange && typeof onChange === "function") {
        onChange({
          event: e3,
          targetValue,
          inputValue,
          setInputValue,
          sliderValue,
          setSliderValue
        });
      }
    },
    [inputValue, onChange, setSliderValue, sliderValue]
  );
  const onBlurHandler = useCallback(
    (e3) => {
      const targetValue = e3.target.value;
      if (targetValue !== "" && isNumber$1(+targetValue)) {
        setInputValue(String(sliderValue));
        const finalValue = clampToMinMax(+targetValue, min2, max2);
        setInputValue(`${finalValue}`);
        setSliderValue(finalValue);
      } else {
        setInputValue(String(sliderValue));
        setSliderValue(sliderValue ?? 0);
      }
      if (onBlur3 && typeof onBlur3 === "function") {
        onBlur3({
          event: e3,
          targetValue,
          inputValue,
          setInputValue,
          sliderValue,
          setSliderValue
        });
      }
    },
    [inputValue, max2, min2, onBlur3, setSliderValue, sliderValue]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundInputField,
    {
      "aria-labelledby": `${labelId} ${ariaLabelledBy}`,
      height: InputHeights.default,
      name: name2,
      onBlur: onBlurHandler,
      onChange: onChangeHandler,
      ...restOfProps,
      disabled: isDisabled,
      value: inputValue
    }
  );
};
const isNumber$1 = (n) => Number.isNaN(n) === false;
const onlyFractionalNumbers = /^[+-]?((\d+(\.\d*)?)|(\.\d+))?$/;
const clampToMinMax = (value, min2, max2) => {
  if (value < min2)
    return min2;
  if (value > max2)
    return max2;
  return value;
};
const SliderLabel = ({
  htmlFor,
  children: children2,
  ...restOfProps
}) => {
  const { labelId } = useSliderContext();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Label2, { htmlFor, id: labelId, ...restOfProps, children: children2 });
};
const Slider2 = ({
  min: min2,
  max: max2,
  step: step2 = 1,
  defaultValue = void 0,
  disabled = false,
  children: children2
}) => {
  const [sliderValue, setSliderValue] = useState(defaultValue);
  const [isAllDisabled, setIsAllDisabled] = useState(disabled);
  const [labelId] = useState(() => uniqueId$1("label-"));
  const [activeTrackValue, setActiveTrackValue] = useState("");
  useEffect(() => {
    setIsAllDisabled(disabled);
  }, [disabled]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    SliderContext.Provider,
    {
      value: {
        min: min2,
        max: max2,
        step: step2,
        sliderValue,
        setSliderValue,
        activeTrackValue,
        setActiveTrackValue,
        labelId,
        isAllDisabled,
        setIsAllDisabled
      },
      children: children2
    }
  );
};
Slider2.Label = SliderLabel;
Slider2.SingleThumbRange = SingleThumbRange;
Slider2.Input = SliderInput;
const Context$2 = React__default.createContext(void 0);
const SuperRadioGroup = ({
  ariaLabelledBy = void 0,
  children: children2,
  defaultValue = void 0,
  hideRadio = false,
  label: label2 = "",
  layout: layout2 = "vertical",
  name: name2,
  onChange = void 0,
  sx: sx2 = {},
  variant: variant3 = SuperRadioGroupVariants.default,
  wrapperSx = {}
}) => {
  const [checkedValue, setChecked] = useState(defaultValue);
  const handleChange = (e3) => {
    setChecked(e3.target.value ?? void 0);
  };
  const memoizedContext = useMemo(() => {
    return {
      checkedValue,
      hideRadio,
      name: name2,
      onGroupChange: callAllFunctions(onChange, handleChange)
    };
  }, [checkedValue, hideRadio, name2, onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$2.Provider, { value: memoizedContext, children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, { label: label2, name: name2, sx: wrapperSx, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex$1,
    {
      "aria-labelledby": ariaLabelledBy,
      role: "radiogroup",
      sx: {
        flexDirection: layout2 === "horizontal" ? "row" : "column",
        ...sx2
      },
      variant: `superRadioGroup.${variant3}`,
      children: children2
    }
  ) }) });
};
const useSuperRadio = () => {
  const context = useContext(Context$2);
  if (context === void 0 || context === null) {
    throw new Error("useSuperRadio must be using within a Super Radio Group");
  }
  return context;
};
const Eyebrow = ({
  color: color2,
  component,
  variant: variant3
}) => {
  const isDesktop = variant3 === "desktop";
  const Component2 = isDesktop ? Caption : Paragraph2;
  const size = isDesktop ? CaptionSizes.Caption12 : ParagraphSizes.Paragraph14;
  if (typeof component === "string") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        color: color2,
        sx: { ...styles$s.eyebrow, ...superRadioSpacing.default.eyebrow },
        variant: size,
        children: component
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: component });
};
const ResponsiveSuperRadio = ({
  descriptionText = "",
  disabled,
  eyebrowText = "",
  footerText = void 0,
  icon: icon2 = null,
  iconName = void 0,
  id,
  labelText = "",
  onChange = void 0,
  sx: sx2 = {},
  tag: tag2 = null,
  tagProps = {},
  tagText = void 0,
  value = "",
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const {
    matchMediaQuery: { smDown }
  } = useMatchMedia();
  const mdUp = !smDown;
  const { checkedValue, hideRadio, name: name2, onGroupChange } = useSuperRadio();
  const checked = checkedValue === value;
  const titleAndDescColor = disabled ? TextColors.tertiary : TextColors.primary;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Collapsible, { initiallyCollapsed: checked, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      ...onChange ? { onChange } : { onChange: onGroupChange },
      sx: styles$s.parentWrapper,
      ...restOfProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Label$1,
        {
          htmlFor: id,
          sx: style2(wrapperStateStyles(disabled, checked)),
          variant: `superRadio.default`,
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            VStack,
            {
              spacing: "superRadio.default.gap",
              sx: styles$s.innerLabelWrapper,
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  Flex,
                  {
                    justifyContent: "space-between",
                    spacing: smDown ? "superRadio.mobile.gap" : "superRadio.default.gap",
                    sx: styles$s.contentsWrapper,
                    children: [
                      /* @__PURE__ */ jsxRuntimeExports.jsxs(
                        Flex,
                        {
                          alignItems: "center",
                          spacing: "superRadio.default.contentsInnerWrapperWithIcon.gap",
                          children: [
                            mdUp && renderIcon(icon2, iconName),
                            /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
                              renderTag({ disabled, tag: tag2, tagText, tagProps }),
                              renderEyebrow({
                                text: eyebrowText,
                                textColor: titleAndDescColor,
                                smDown
                              }),
                              labelText ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                                Title,
                                {
                                  as: "div",
                                  color: titleAndDescColor,
                                  sx: {
                                    ...styles$s.label,
                                    ...superRadioSpacing.default.label
                                  },
                                  variant: TitleSizes$1.Title16,
                                  children: labelText
                                }
                              ) : null,
                              descriptionText ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                                Paragraph2,
                                {
                                  color: titleAndDescColor,
                                  sx: styles$s.description,
                                  variant: ParagraphSizes.Paragraph16,
                                  children: descriptionText
                                }
                              ) : null
                            ] })
                          ]
                        }
                      ),
                      /* @__PURE__ */ jsxRuntimeExports.jsx(
                        Flex,
                        {
                          justifyContent: "flex-end",
                          sx: {
                            ...!hideRadio && styles$s.radio.base,
                            ...smDown ? styles$s.radio.mobile : styles$s.radio.desktop
                          },
                          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                            Radio.Option,
                            {
                              checked,
                              disabled,
                              hasLabel: false,
                              hideRadio,
                              id,
                              name: name2,
                              onChange,
                              onGroupChange,
                              value,
                              variant: RadioVariant.checkMark
                            }
                          )
                        }
                      )
                    ]
                  }
                ),
                footerText && checked ? /* @__PURE__ */ jsxRuntimeExports.jsx(Collapsible.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: styles$s.footer.content, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Paragraph2,
                  {
                    color: TextColors.tertiary,
                    sx: { marginBottom: 0 },
                    variant: ParagraphSizes.Paragraph14,
                    children: footerText
                  }
                ) }) }) : null
              ]
            }
          )
        }
      )
    }
  ) });
};
const renderEyebrow = ({
  text: text2,
  textColor,
  smDown
}) => {
  if (text2) {
    const variant3 = smDown ? "mobile" : "desktop";
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Eyebrow, { color: textColor, component: text2, variant: variant3 });
  }
  return null;
};
const renderIcon = (icon2, iconName) => {
  if (icon2) {
    return icon2;
  }
  if (iconName) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: styles$s.iconWrapper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: iconName, size: IconSizes.Icon24 }) });
  }
  return null;
};
const renderTag = ({
  disabled,
  tag: tag2,
  tagText,
  tagProps
}) => {
  if (tag2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: superRadioSpacing.default.tag, children: tag2 });
  }
  if (tagText) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tag,
      {
        sx: superRadioSpacing.default.tag,
        text: tagText,
        variant: disabled ? TagVariant.indeterminate : TagVariant.info,
        ...tagProps
      }
    );
  }
  return null;
};
ResponsiveSuperRadio.displayName = "ResponsiveSuperRadio";
const SuperRadio = Object.assign(ResponsiveSuperRadio, {
  Group: SuperRadioGroup
});
const Body = ({ children: children2 = /* @__PURE__ */ jsx2(Fragment, {}), sx: sx2 = {}, ...restOfProps }) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsx2("tbody", { sx: style2(), ...restOfProps, children: children2 });
};
const Context$1 = React__default.createContext(void 0);
const TableProvider = ({
  children: children2,
  forCardVariant = true
}) => {
  const memoizedContext = useMemo(
    () => ({
      forCardVariant
    }),
    [forCardVariant]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context$1.Provider, { value: memoizedContext, children: children2 });
};
const useTable = () => {
  const context = useContext(Context$1);
  if (context === void 0) {
    throw new Error("useTable must be used within a Table Provider");
  }
  return context;
};
const Cell = ({
  children: children2 = null,
  sx: sx2 = {},
  responsiveLabel = void 0,
  collapse = false,
  colSpan = 1,
  headers: headers2 = "",
  rowSpan = 1,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const { forCardVariant } = useTable();
  const {
    matchMediaQuery: { smDown }
  } = useMatchMedia();
  return /* @__PURE__ */ jsx2(
    "td",
    {
      className: collapse ? "guideline-ui--table--collapse" : "",
      colSpan,
      headers: headers2,
      rowSpan,
      sx: style2(),
      ...restOfProps,
      children: responsiveLabel && forCardVariant && smDown ? /* @__PURE__ */ jsxs(
        Flex,
        {
          alignItems: "center",
          justifyContent: "space-between",
          sx: { width: "100%" },
          children: [
            /* @__PURE__ */ jsx2(Box, { children: responsiveLabel }),
            /* @__PURE__ */ jsx2(Box, { children: children2 })
          ]
        }
      ) : children2
    }
  );
};
const Head = ({ children: children2 = null, sx: sx2 = {}, ...restOfProps }) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsx2("thead", { sx: style2(), ...restOfProps, children: children2 });
};
const Header$2 = ({
  abbr = "",
  colSpan = 1,
  rowSpan = 1,
  headers: headers2 = "",
  scope = void 0,
  children: children2 = null,
  collapse = false,
  sx: sx2 = {},
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsx2(
    "th",
    {
      abbr,
      className: collapse ? "guideline-ui--table--collapse" : "",
      colSpan,
      headers: headers2,
      rowSpan,
      scope,
      sx: style2(),
      ...restOfProps,
      children: children2
    }
  );
};
const Row = ({
  children: children2 = /* @__PURE__ */ jsx2(Fragment, {}),
  sx: sx2 = {},
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsx2("tr", { sx: style2(), ...restOfProps, children: children2 });
};
const Table = ({
  variant: variant3 = TableVariant.default,
  children: children2 = null,
  responsiveVariant: responsiveVariant2 = TableResponsiveVariant.card,
  sx: sx2 = {},
  striped = true,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const tableRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);
  const debouncedSetOverflow = useMemo(
    () => debounce$3(() => {
      if (tableRef.current) {
        const { scrollWidth, parentElement } = tableRef.current;
        const parentWidth = parentElement == null ? void 0 : parentElement.clientWidth;
        if (parentWidth) {
          if (scrollWidth > parentWidth) {
            setOverflowing(true);
          } else if (scrollWidth <= parentWidth) {
            setOverflowing(false);
          }
        }
      }
    }, Throttle.movement),
    [tableRef]
  );
  useEffect(() => {
    debouncedSetOverflow();
    return () => {
      debouncedSetOverflow.cancel();
    };
  }, [debouncedSetOverflow]);
  useEventListener("resize", debouncedSetOverflow);
  return /* @__PURE__ */ jsx2(
    TableProvider,
    {
      forCardVariant: responsiveVariant2 === TableResponsiveVariant.card,
      children: /* @__PURE__ */ jsx2(Box$1, { sx: { variant: "table.container" }, children: /* @__PURE__ */ jsx2(MatchMedia, { children: (mediaQueries2) => {
        const hasOverflowClass = !mediaQueries2.smDown && overflowing && "guideline-ui--table--overflow";
        const tableClassName = hasOverflowClass || "";
        return /* @__PURE__ */ jsx2(
          "table",
          {
            className: tableClassName,
            ref: tableRef,
            sx: style2({
              variant: `table.${mediaQueries2.smDown ? responsiveVariant2 : variant3}`,
              ...styles$8(
                striped,
                !!mediaQueries2.smDown && responsiveVariant2 === TableResponsiveVariant.card
              )
            }),
            ...restOfProps,
            children: children2
          }
        );
      } }) })
    }
  );
};
const styles$8 = (striped, forCard) => forCard ? {
  "td:nth-of-type(even)": {
    backgroundColor: striped ? "table.background.even" : "table.background.odd"
  }
} : {
  "tr:nth-of-type(even)": {
    backgroundColor: striped ? "table.background.even" : "table.background.odd"
  }
};
Table.Head = Head;
Table.Body = Body;
Table.Cell = Cell;
Table.Row = Row;
Table.Header = Header$2;
const Textarea2 = ({
  label: label2,
  /**
   * Name of the text area input control for use with `name` and `id` attributes.
   * <br /> Should be unique.
   * */
  name: name2,
  variant: variant3 = FormInputVariants.default,
  disabled = false,
  hideLabel = false,
  /**
   * Event handler for when the input loses focus
   */
  onBlur: onBlur3 = void 0,
  /**
   * Event handler for when the input's value is changed
   */
  onChange = void 0,
  /**
   * Event handler for when the input is clicked
   */
  onClick = void 0,
  placeholder = void 0,
  hintText,
  hintTextParagraphVariant,
  sx: sx2 = {},
  validate = void 0,
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  const { field, meta } = useGuiField({
    name: name2,
    validate
  });
  const initialValue2 = useMemo(() => {
    if (meta == null ? void 0 : meta.initialValue) {
      return meta.initialValue;
    }
    return "";
  }, [meta]);
  const handleBlur = useEventCallback$1(field == null ? void 0 : field.onBlur, onBlur3, [field, onBlur3]);
  const handleChange = useEventCallback$1(field == null ? void 0 : field.onChange, onChange, [
    field,
    onChange
  ]);
  const handleClick = useCallback((event2) => onClick == null ? void 0 : onClick(event2), [onClick]);
  const currentVariant = useFieldVariant(variant3, meta);
  const labelIsHidden = hideLabel || !label2;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    InputBase,
    {
      disabled,
      hideLabel: labelIsHidden,
      hintText,
      hintTextParagraphVariant,
      label: label2,
      name: name2,
      variant: currentVariant,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Textarea$1,
        {
          "aria-labelledby": `${name2}Label ${name2}HintText`,
          "data-test-id": `textarea--${name2}`,
          defaultValue: initialValue2,
          disabled,
          id: name2,
          name: name2,
          onBlur: handleBlur,
          onChange: handleChange,
          onClick: handleClick,
          placeholder,
          sx: style2(styles$7.textarea(disabled, currentVariant)),
          variant: `forms.${currentVariant}.inputStyles`,
          ...restOfProps
        }
      )
    }
  );
};
const styles$7 = {
  textarea: (disabled, variant3) => ({
    backgroundColor: disabled ? "forms.disabled.background" : null,
    borderColor: disabled ? "forms.disabled.border" : null,
    color: disabled ? "forms.disabled.text" : "text.primary",
    cursor: disabled ? "not-allowed" : "inherit",
    marginY: "input.marginY",
    minHeight: "textarea.default.minHeight",
    outline: "none",
    paddingX: "input.default.paddingX",
    paddingY: "input.default.paddingY",
    resize: "vertical",
    "&:hover": {
      borderColor: !disabled ? `forms.${variant3}.border.hover` : null
    },
    "&:focus": {
      borderColor: `forms.${variant3}.border.active`
    }
  })
};
const ToastContext = createContext(
  void 0
);
const useToastContext = () => {
  const toastContext = useContext(ToastContext);
  if (toastContext === void 0) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }
  return toastContext;
};
const useBoundingRect = (ref2) => {
  const [boundingRect, setBoundingRect] = useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  });
  useEffect(() => {
    const set = () => setBoundingRect(
      ref2 && ref2.current ? ref2.current.getBoundingClientRect() : {}
    );
    set();
    window.addEventListener("resize", set);
    return () => window.removeEventListener("resize", set);
  }, [ref2]);
  return boundingRect;
};
const preventSwipeUp = ({ movement: [, my], cancel: cancel2 }) => {
  if (my < 0)
    cancel2();
};
const startSpring = ({ down: mouseDown, movement: [, my] }) => ({
  y: mouseDown && my > 0 ? my : 0,
  immediate: mouseDown
});
const SWIPE_THRESHOLD = 0.75;
const Toast = ({
  id,
  content: content2,
  actionLabel = "",
  actionAriaLabel = "",
  icon: icon2 = void 0,
  onClick = void 0,
  onActionClick = void 0,
  ...restOfProps
}) => {
  const { Toast: Toast2 } = useToastContext();
  const swipeableRef = useRef(null);
  const swipeableBoundingRect = useBoundingRect(swipeableRef);
  const removeToast = useCallback(
    (id2) => {
      Toast2.remove(id2);
    },
    [Toast2]
  );
  const handleClick = useCallback(
    (event2) => {
      onClick == null ? void 0 : onClick(event2);
      removeToast(id);
    },
    [onClick, removeToast, id]
  );
  const yThreshold = swipeableBoundingRect.height * SWIPE_THRESHOLD;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => {
    const { smDown } = mediaQueries2;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      SwipeableNamespace,
      {
        axis: SwipeableNamespace.Axis.y,
        enabled: smDown,
        manageDrag: preventSwipeUp,
        onClick: onActionClick ? void 0 : handleClick,
        onSwipe: removeToast,
        ref: swipeableRef,
        springStart: startSpring,
        yThreshold,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Flex$1,
          {
            onClick: smDown ? void 0 : handleClick,
            sx: {
              color: "toast.text",
              backgroundColor: "toast.background",
              justifyContent: "space-between"
            },
            variant: `toast.${smDown ? "small" : "default"}`,
            ...restOfProps,
            children: [
              icon2 ? cloneElement(icon2, { sx: styles$r.icon }) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsx(Paragraph2, { color: "inherit", sx: styles$r.content, variant: "16", children: content2 }),
              onActionClick ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                CompoundButton,
                {
                  "aria-label": actionAriaLabel,
                  onClick: onActionClick,
                  size: ButtonSize.compact,
                  sx: styles$r.actionButton(mediaQueries2),
                  variant: ButtonVariant.tertiary,
                  children: actionLabel
                }
              ) : null
            ]
          }
        )
      }
    );
  } });
};
const ToastContainer = ({ toastQueue }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: (mediaQueries2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex$1,
    {
      "data-test-id": "toast.container",
      variant: `toast.container.${mediaQueries2.smDown ? "small" : "default"}`,
      children: toastQueue.map(
        (toastArgs) => toastArgs.timeoutId && /* @__PURE__ */ jsxRuntimeExports.jsx(
          Toast,
          {
            actionAriaLabel: toastArgs.actionAriaLabel,
            actionLabel: toastArgs.actionLabel,
            content: toastArgs.content,
            icon: toastArgs.icon,
            id: toastArgs.id,
            onActionClick: toastArgs.onActionClick,
            onClick: toastArgs.onClick
          },
          toastArgs.id
        )
      )
    }
  ) });
};
var ActionTypes = /* @__PURE__ */ ((ActionTypes2) => {
  ActionTypes2["ADD_TOAST"] = "ADD_TOAST";
  ActionTypes2["UPDATE_TOAST"] = "UPDATE_TOAST";
  ActionTypes2["REMOVE_TOAST"] = "REMOVE_TOAST";
  ActionTypes2["CLEAR_QUEUE"] = "CLEAR_QUEUE";
  return ActionTypes2;
})(ActionTypes || {});
const initialState = [];
const toastReducer = (state, action2) => {
  switch (action2.type) {
    case ActionTypes.ADD_TOAST:
      return [...state, action2.toast];
    case ActionTypes.UPDATE_TOAST: {
      const toastToUpdate = state.find((t2) => t2.id === action2.id);
      return [
        { ...toastToUpdate, timeoutId: action2.timeoutId },
        ...state.filter((t2) => t2.id !== action2.id)
      ];
    }
    case ActionTypes.REMOVE_TOAST:
      return state.filter((t2) => t2.id !== action2.id);
    case ActionTypes.CLEAR_QUEUE:
      return initialState;
    default:
      return state;
  }
};
const DEFAULT_DELAY = 5e3;
const InfoIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { color: "toast.icon.info", name: "info", size: IconSizes.Icon16 });
const ErrorIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { color: "toast.icon.error", name: "xCircle", size: IconSizes.Icon16 });
const SuccessIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { color: "toast.icon.success", name: "checkCircle", size: IconSizes.Icon16 });
const WarningIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { color: "toast.icon.warning", name: "warning", size: IconSizes.Icon16 });
const ToastProvider = ({ children: children2 }) => {
  const [toastQueue, toastDispatch] = useReducer(toastReducer, initialState);
  const toastQueueRef = useRef(toastQueue);
  toastQueueRef.current = toastQueue;
  const { matchMediaQuery } = useMatchMedia();
  const queueToastWithTimeout = useCallback(
    (toastArgs) => {
      const timeoutId = setTimeout(() => {
        toastDispatch({ type: ActionTypes.REMOVE_TOAST, id: toastArgs.id });
        if (matchMediaQuery.smDown && toastQueueRef.current[0]) {
          queueToastWithTimeout(toastQueueRef.current[0]);
        }
      }, toastArgs.delay || DEFAULT_DELAY);
      if (toastQueueRef.current.some((x3) => x3.id === toastArgs.id)) {
        toastDispatch({
          type: ActionTypes.UPDATE_TOAST,
          id: toastArgs.id,
          timeoutId
        });
      } else {
        toastDispatch({
          type: ActionTypes.ADD_TOAST,
          toast: { ...toastArgs, timeoutId }
        });
      }
    },
    [matchMediaQuery]
  );
  const addToast = useCallback(
    (args) => {
      const toastArgs = { ...args, id: +/* @__PURE__ */ new Date() };
      if (matchMediaQuery.smDown) {
        const anyActiveToasts = toastQueue.some((t2) => t2.timeoutId);
        if (anyActiveToasts) {
          toastDispatch({
            type: ActionTypes.ADD_TOAST,
            toast: { ...toastArgs }
          });
        } else {
          queueToastWithTimeout(toastArgs);
        }
      } else {
        queueToastWithTimeout(toastArgs);
      }
    },
    [matchMediaQuery, queueToastWithTimeout, toastQueue]
  );
  const actions = useMemo(
    () => ({
      create: (args) => addToast(args),
      info: (args) => addToast({ icon: InfoIcon, ...args }),
      warning: (args) => addToast({ icon: WarningIcon, ...args }),
      success: (args) => addToast({ icon: SuccessIcon, ...args }),
      error: (args) => addToast({ icon: ErrorIcon, ...args }),
      remove: (id) => {
        const toastToRemove = toastQueue.find((t2) => t2.id === id);
        if (toastToRemove) {
          toastToRemove.timeoutId && clearTimeout(toastToRemove.timeoutId);
          toastDispatch({ type: ActionTypes.REMOVE_TOAST, id });
          if (matchMediaQuery.smDown && toastQueueRef.current[1]) {
            queueToastWithTimeout(toastQueueRef.current[1]);
          }
        }
      },
      clearQueue: () => {
        toastQueue.forEach((t2) => t2.timeoutId && clearTimeout(t2.timeoutId));
        toastDispatch({ type: ActionTypes.CLEAR_QUEUE });
      }
    }),
    [addToast, toastQueue, matchMediaQuery, queueToastWithTimeout]
  );
  const memoizedContext = useMemo(
    () => ({ toastQueue, Toast: { ...actions } }),
    [toastQueue, actions]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ToastContext.Provider, { value: memoizedContext, children: [
    children2,
    /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$1, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(ToastContainer, { toastQueue }) })
  ] });
};
const TokenInput = ({
  onComplete = void 0,
  onAccept = void 0,
  sx: sx2 = {},
  sxInputElement = {},
  maskOptions = void 0,
  color: color2 = TextColors.tertiary,
  length: length2 = 6,
  lazy = false,
  placeholderChar = "0",
  onlyNumbers = true,
  ...restOfProps
}) => {
  const [inputWidth, setInputWidth] = useState(0);
  const ref2 = useRef(null);
  useEffect(() => {
    var _a2;
    setInputWidth((((_a2 = ref2.current) == null ? void 0 : _a2.offsetWidth) || 0) + tokenInputLetterSpacing);
  }, [length2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: styles$6.container, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "span", ref: ref2, sx: styles$6.span, children: "0".repeat(length2) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompoundInput,
      {
        "aria-label": "Enter verification code",
        color: TextColors.tertiary,
        maskOptions: maskOptions || {
          mask: onlyNumbers ? "0".repeat(length2) : "*".repeat(length2),
          lazy,
          placeholderChar
        },
        onMaskAccept: onAccept,
        onMaskComplete: onComplete,
        sx: {
          ...styles$6.inputWrapper,
          ...sx2,
          width: inputWidth
        },
        sxInputElement: { ...styles$6.input(color2), ...sxInputElement },
        type: onlyNumbers ? InputTypes.tel : void 0,
        ...restOfProps
      }
    )
  ] });
};
const styles$6 = {
  container: {
    fontFamily: "monospace",
    fontSize: "tokenInput.fontSize",
    letterSpacing: "tokenInput.letterSpacing"
  },
  inputWrapper: {
    fontFamily: "inherit"
  },
  span: {
    fontFamily: "inherit",
    position: "absolute",
    visibility: "hidden"
  },
  input: (color2) => ({
    fontFamily: "inherit",
    width: "100%",
    fontSize: "tokenInput.fontSize",
    letterSpacing: "tokenInput.letterSpacing",
    textAlign: "center",
    borderWidth: "2px",
    borderRadius: 0,
    borderRight: 0,
    borderLeft: 0,
    borderTop: 0,
    paddingRight: 0,
    paddingLeft: 0.5,
    color: color2
  })
};
function getValidChildrenArray(children2) {
  return React__default.Children.toArray(children2).filter(
    (child) => React__default.isValidElement(child)
  );
}
var StepVariant = /* @__PURE__ */ ((StepVariant2) => {
  StepVariant2["step"] = "step";
  StepVariant2["subStep"] = "subStep";
  return StepVariant2;
})(StepVariant || {});
const StepTitle = ({
  state,
  title,
  variant: variant3 = StepVariant.step
}) => {
  return state === StepState.inProgress ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    Title,
    {
      as: "span",
      sx: style,
      variant: variant3 === StepVariant.step ? TitleSizes$1.Title16 : TitleSizes$1.Title14,
      children: title
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Span,
      {
        color: state === StepState.locked ? TextColors.disable : TextColors.tertiary,
        "data-step-state-locked": state === StepState.locked,
        sx: style,
        variant: variant3 === StepVariant.step ? SpanSizes.Span16 : SpanSizes.Span14,
        children: title
      }
    ),
    state === StepState.locked ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        color: "icon.subdued",
        name: "lockClosed",
        size: IconSizes.Icon16,
        sx: {
          marginBottom: "stepper.step.lock.marginBottom"
        }
      }
    ) : null
  ] });
};
const style = {
  overflowWrap: "break-word",
  textAlign: "left",
  ":not([data-step-state-locked='true']):hover": {
    textDecoration: "underline"
  }
};
const stepIcon = (state) => {
  if (state === StepState.inProgress) {
    return "dot";
  } else if (state === StepState.locked) {
    return "dotFilled";
  } else if (state === StepState.complete) {
    return "checkCircle";
  } else {
    return "dotEmpty";
  }
};
const StepIcon = ({ state }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Icon,
    {
      color: state === StepState.complete ? "stepper.step.icon.complete" : void 0,
      fill: state === StepState.locked ? "stepper.step.icon.locked" : void 0,
      name: stepIcon(state),
      size: IconSizes.Icon16,
      sx: {
        alignSelf: "flex-start",
        borderRadius: "50%",
        backgroundColor: "stepper.step.icon.background",
        marginTop: "stepper.step.marginTop"
      }
    }
  );
};
const StepButton = ({
  component: Component2 = void 0,
  disabled = false,
  onClick = noop$6,
  state,
  title,
  variant: variant3 = StepVariant.step
}) => {
  const content2 = /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "center",
      flex: "0 0 auto",
      spacing: "stepper.step.button",
      sx: { width: "100%" },
      children: [
        variant3 === StepVariant.step ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepIcon, { state }) : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(StepTitle, { state, title })
      ]
    }
  );
  if (Component2) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { children: title });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    CompoundButton,
    {
      disabled,
      onClick,
      sx: {
        zIndex: "sticky"
      },
      variant: ButtonVariant.unstyled,
      children: content2
    }
  );
};
const AnimatedFlex$1 = animated(Flex);
const Step$2 = ({
  children: children2 = void 0,
  component = void 0,
  disabled = void 0,
  id = void 0,
  onClick = noop$6,
  showSubSteps = void 0,
  state = void 0,
  sx: sx2 = {},
  title
}) => {
  const { style: style2 } = useStyle(sx2);
  const { getStepState, jumpToStep, stepperState } = useStepper();
  const onStepClick = useCallback(() => {
    onClick();
    jumpToStep(id);
  }, [id, jumpToStep, onClick]);
  const stepState = state ?? getStepState(id);
  const renderSubSteps = showSubSteps === void 0 ? stepState === StepState.inProgress : showSubSteps;
  const renderSubStepsForactiveGroupOnly = showSubSteps === "activeGroupOnly" && stepState !== StepState.inProgress;
  const hideSubSteps = renderSubSteps === false || renderSubStepsForactiveGroupOnly;
  const [ref2, springStyles] = useCollapsibleAnimation(hideSubSteps, {
    duration: ({ collapsed }) => collapsed ? stepper$1.duration.collapse : stepper$1.duration.expand,
    springConfig: stepper$1.springConfig
  });
  const validChildren = getValidChildrenArray(children2);
  const isDisabled = useMemo(() => {
    if (disabled !== void 0) {
      return disabled;
    }
    if (stepperState.nonLinear) {
      return stepState === StepState.locked;
    }
    return [StepState.incomplete, StepState.locked].includes(stepState);
  }, [disabled, stepState, stepperState.nonLinear]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "flex-start",
      as: "li",
      "data-step-non-linear": !!stepperState.nonLinear,
      "data-step-state": stepState,
      flexDirection: "column",
      sx: style2(stepStyle),
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          StepButton,
          {
            component,
            disabled: isDisabled,
            onClick: onStepClick,
            state: stepState,
            title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AnimatedFlex$1,
          {
            as: "ol",
            flexDirection: "column",
            role: "list",
            style: springStyles,
            sx: {
              padding: 0,
              // Removes ul standard padding
              listStyle: "none",
              // Hide sub steps, but display for screen readers
              ...renderSubSteps === false && {
                overflow: "hidden"
              }
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: ref2, children: validChildren.map((child, index2) => {
              return cloneElement(child, {
                id: index2,
                parentId: id,
                hideSubSteps
              });
            }) })
          }
        )
      ]
    }
  );
};
const stepStyle = {
  position: "relative",
  paddingBottom: "stepper.step.paddingBottom",
  "&[data-step-state='complete']::after": {
    backgroundColor: "stepper.step.rail.complete"
  },
  "&[data-step-non-linear='true']::after": {
    backgroundColor: "stepper.step.rail"
  },
  "&:not([data-step-state='complete'])::after": {
    backgroundColor: "stepper.step.rail"
  },
  "::after": {
    content: "''",
    position: "absolute",
    left: "stepper.step.rail.left",
    width: "step.rail.width",
    height: "100%",
    top: "stepper.step.rail.top"
  },
  ":last-child:after": {
    content: "none"
  }
};
const SubStep = ({
  component = void 0,
  disabled = void 0,
  id = void 0,
  hideSubSteps = void 0,
  onClick = noop$6,
  parentId = void 0,
  state = void 0,
  sx: sx2 = {},
  title
}) => {
  const { style: style2 } = useStyle(sx2);
  const { getStepState, jumpToStep, stepperState } = useStepper();
  const onSubStepClick = useCallback(() => {
    onClick();
    jumpToStep(parentId, id);
  }, [id, jumpToStep, parentId, onClick]);
  const subStepState = state ?? getStepState(parentId, id);
  const isDisabled = useMemo(() => {
    if (disabled !== void 0) {
      return disabled;
    }
    if (hideSubSteps) {
      return true;
    }
    if (stepperState.nonLinear) {
      return subStepState === StepState.locked;
    }
    return [StepState.incomplete, StepState.locked].includes(subStepState);
  }, [disabled, hideSubSteps, subStepState, stepperState.nonLinear]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      as: "li",
      "data-step-state": subStepState,
      sx: style2({
        listStyleType: "none",
        marginLeft: "stepper.subStep.marginLeft",
        marginTop: "stepper.subStep.marginTop",
        paddingLeft: "stepper.subStep.paddingLeft"
      }),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StepButton,
        {
          component,
          disabled: isDisabled,
          onClick: onSubStepClick,
          state: subStepState,
          title,
          variant: StepVariant.subStep
        }
      )
    }
  );
};
const StepperTitle = ({
  as = "p",
  title = void 0
}) => {
  if (title) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as, bottomSpace: 2, variant: TitleSizes$1.Title18, children: title });
  }
  return null;
};
const renderStepStatus = (currentStep, totalSteps) => `Step ${currentStep} of ${totalSteps}`;
const StepperMobileTitle = () => {
  var _a2;
  const { stepperState, getCurrentStepIndex } = useStepper();
  const getTotalSteps = useCallback(() => {
    var _a3;
    return (_a3 = stepperState == null ? void 0 : stepperState.steps) == null ? void 0 : _a3.length;
  }, [(_a2 = stepperState == null ? void 0 : stepperState.steps) == null ? void 0 : _a2.length]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Caption, { sx: { marginBottom: "stepper.mobile.paddingBottom" }, variant: "12", children: renderStepStatus(getCurrentStepIndex() + 1, getTotalSteps()) });
};
const Stepper = ({
  sx: sx2 = {},
  nonLinear = false,
  showSubSteps = void 0,
  title = void 0,
  titleAs = void 0
}) => {
  var _a2;
  const { stepperState, setStepperNonLinear } = useStepper();
  const { style: style2 } = useStyle(sx2);
  useEffect(() => {
    setStepperNonLinear(nonLinear);
  }, [setStepperNonLinear, nonLinear]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(StepperTitle, { as: titleAs, title }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex,
      {
        as: "ol",
        flexDirection: "column",
        role: "list",
        sx: style2({
          listStyle: "none",
          padding: 0
          // Removes ul standard padding
        }),
        children: (_a2 = stepperState == null ? void 0 : stepperState.steps) == null ? void 0 : _a2.map(({ subSteps, ...props2 }, index2) => {
          return /* @__PURE__ */ jsxRuntimeExports.jsx(
            Stepper.Step,
            {
              id: index2,
              ...props2,
              showSubSteps,
              children: subSteps && (subSteps == null ? void 0 : subSteps.length) > 0 ? subSteps.map((props22, subIndex) => {
                return /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Stepper.SubStep,
                  {
                    ...props22
                  },
                  `step-${index2}-${subIndex}`
                );
              }) : null
            },
            `step-${index2}`
          );
        })
      }
    )
  ] });
};
Stepper.Step = Step$2;
Stepper.SubStep = SubStep;
Stepper.MobileTitle = StepperMobileTitle;
const useValidateWorkflowComponent = (props2, type2) => {
  if (props2) {
    invariant$1(
      props2.nodeType,
      `${type2 || "GROUP/STEP/STEP_VIEW/STEP_VIEW_PICKER"} component requires a nodeType prop for XState machine conversion.`
    );
  }
};
const useWorkflowStepperNavigation = () => {
  const [stepperSteps] = useWorkflow((store) => store.stepperSteps);
  const { stepperState } = useStepper();
  const service = useWorkflowService();
  const currentlySelectedStep = useSelector(
    service,
    currentlySelectedStepSelector
  );
  const previousStep = getPreviousStep(stepperState);
  const nextStep = getNextStep(stepperState);
  const hasPreviousStep = previousStep != void 0;
  const hasNextStep = nextStep != void 0;
  const goToPreviousStep = hasPreviousStep ? getOnClickFromStep(stepperSteps, previousStep) : void 0;
  const goToNextStep = hasNextStep ? getOnClickFromStep(stepperSteps, nextStep) : void 0;
  return {
    fromStep: currentlySelectedStep,
    // used to determine what step the prev/next functions executing from
    goToNextStep,
    goToPreviousStep,
    hasNextStep,
    hasPreviousStep
  };
};
const isLockedState = (step2, stepperState) => {
  var _a2, _b;
  const stepIdx = step2 == null ? void 0 : step2.step;
  const subStepIdx = step2 == null ? void 0 : step2.subStep;
  const stepValue = (
    // eslint-disable-next-line eqeqeq
    stepIdx != void 0 && stepIdx >= 0 ? (_a2 = stepperState.steps) == null ? void 0 : _a2[stepIdx] : void 0
  );
  const subStepValue = (
    // eslint-disable-next-line eqeqeq
    subStepIdx != void 0 && subStepIdx >= 0 ? (_b = stepValue == null ? void 0 : stepValue.subSteps) == null ? void 0 : _b[subStepIdx] : void 0
  );
  if (subStepValue) {
    return subStepValue.state === "locked";
  }
  return false;
};
const getSubsequentStep = (stepperState, determineStepFn) => {
  if (stepperState.currentStep == void 0) {
    return void 0;
  }
  let step2 = determineStepFn(stepperState);
  if (step2 === null)
    return void 0;
  const stepIsDefined = (step2 == null ? void 0 : step2.subStep) !== void 0;
  const atBegOfSteps = stepIsDefined && (step2 == null ? void 0 : step2.step) === 0 && (step2 == null ? void 0 : step2.subStep) === null;
  let newStepperState = stepperState;
  while (((step2 == null ? void 0 : step2.subStep) == null || isLockedState(step2, newStepperState)) && !atBegOfSteps && step2 !== null) {
    newStepperState = {
      ...newStepperState,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      currentStep: step2.step,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      currentSubStep: step2.subStep
    };
    step2 = determineStepFn(newStepperState);
  }
  if (atBegOfSteps) {
    return void 0;
  }
  return step2;
};
const getPreviousStep = (stepperState) => {
  return getSubsequentStep(stepperState, determinePreviousStep);
};
const getNextStep = (stepperState) => {
  return getSubsequentStep(stepperState, determineNextStep);
};
const getOnClickFromStep = (stepperSteps, step2) => {
  var _a2, _b;
  const finalStepIdx = (step2 == null ? void 0 : step2.step) ?? 0;
  const finalSubStepIdx = (step2 == null ? void 0 : step2.subStep) ?? 0;
  const { onClick } = ((_b = (_a2 = stepperSteps == null ? void 0 : stepperSteps[finalStepIdx]) == null ? void 0 : _a2.subSteps) == null ? void 0 : _b[finalSubStepIdx]) || {};
  return onClick || noop$6;
};
const isInvalidStep = (steps2, step2, stepSize) => {
  return step2 < 0 || step2 >= stepSize;
};
const isStepValid = (state, step2 = null, subStep = null) => {
  var _a2;
  if (step2 === null || isInvalidStep(state.steps, step2, state.size)) {
    return false;
  }
  const currentStep = (_a2 = state.steps) == null ? void 0 : _a2[step2];
  if (subStep !== null && subStep !== 0 && isInvalidStep(currentStep.subSteps, subStep, currentStep.subStepSize)) {
    return false;
  }
  return true;
};
const determineNextStep = (state) => {
  const { currentStep, currentSubStep } = state;
  if (currentStep === null) {
    return null;
  }
  const { subStepSize } = state.steps[currentStep];
  if (subStepSize > 0) {
    let targetSubStep = currentSubStep;
    if (targetSubStep === void 0 || targetSubStep === null) {
      targetSubStep = 0;
    } else {
      targetSubStep += 1;
    }
    if (isStepValid(state, currentStep, targetSubStep)) {
      return {
        step: currentStep,
        subStep: targetSubStep
      };
    }
  }
  const targetStep = currentStep + 1;
  if (isStepValid(state, targetStep)) {
    return {
      step: targetStep,
      subStep: null
    };
  }
  return null;
};
const determinePreviousStep = (state) => {
  const { currentStep, currentSubStep } = state;
  if (currentStep === null) {
    return null;
  }
  const { subStepSize } = state.steps[currentStep];
  if (currentSubStep !== null && subStepSize > 0) {
    let targetSubStep = currentSubStep - 1;
    if (targetSubStep < 0) {
      targetSubStep = null;
    }
    if (isStepValid(state, currentStep, targetSubStep)) {
      return {
        step: currentStep,
        subStep: targetSubStep
      };
    }
  }
  const targetStep = currentStep - 1;
  if (isStepValid(state, targetStep, 0)) {
    const targetStepSubStepSize = state.steps[targetStep].subStepSize;
    if (targetStepSubStepSize > 0) {
      return {
        step: targetStep,
        subStep: targetStepSubStepSize - 1
      };
    }
    return {
      step: targetStep,
      subStep: null
    };
  }
  return null;
};
const useGetDerivedFormProps = (name2) => {
  const [hasGuiForm, setHasGuiForm] = useState(false);
  const [finalFormId, setFinalFormId] = useState(void 0);
  const { formId: guiFormId } = useWorkflowStepHelper(name2);
  const [hasFormLoaded] = useWorkflow((store) => store.hasFormLoaded);
  useEffect(() => {
    let domFormId = null;
    const formElements = document.querySelectorAll("[data-using-gui-form]");
    const hasFormElements = (formElements == null ? void 0 : formElements.length) && (formElements == null ? void 0 : formElements.length) > 0;
    if (hasFormElements) {
      const firstForm = formElements[0];
      setHasGuiForm(
        Boolean((firstForm == null ? void 0 : firstForm.getAttribute("data-using-gui-form")) === "true")
      );
      domFormId = firstForm == null ? void 0 : firstForm.getAttribute("id");
    }
    setFinalFormId(domFormId || guiFormId);
  }, [guiFormId, hasFormLoaded, hasGuiForm]);
  return { finalFormId, hasGuiForm };
};
function isWorkflowType(element) {
  return isWorkflowGroupType(element) || isWorkflowStepType(element) || isWorkflowStepViewType(element) || isWorkflowStepViewPickerType(element);
}
function isWorkflowGroupType(element) {
  var _a2;
  return React__default.isValidElement(element) && ((_a2 = element.type) == null ? void 0 : _a2.$$workflowType) === WORKFLOW_TYPES.GROUP;
}
function isWorkflowStepType(element) {
  var _a2;
  return React__default.isValidElement(element) && ((_a2 = element.type) == null ? void 0 : _a2.$$workflowType) === WORKFLOW_TYPES.STEP;
}
function isWorkflowStepViewType(element) {
  var _a2;
  return React__default.isValidElement(element) && ((_a2 = element.type) == null ? void 0 : _a2.$$workflowType) === WORKFLOW_TYPES.STEP_VIEW;
}
function isWorkflowStepViewPickerType(element) {
  var _a2;
  return React__default.isValidElement(element) && ((_a2 = element.type) == null ? void 0 : _a2.$$workflowType) === WORKFLOW_TYPES.STEP_VIEW_PICKER;
}
const Group = ({
  children: children2,
  name: name2,
  nodeType = "groupState",
  relativePath = void 0,
  _workflowGroupId = [],
  _workflowXStateGroupId = [],
  _workflowXStateStateId
}) => {
  useValidateWorkflowComponent({ nodeType }, "GROUP");
  const traverse = useCallback(
    (node2) => {
      var _a2, _b;
      if (React__default.isValidElement(node2)) {
        if (isWorkflowType(node2)) {
          const parentStateName = name2;
          const childStateName = ((_a2 = node2 == null ? void 0 : node2.props) == null ? void 0 : _a2.name) || "";
          const parentStateNames = [..._workflowXStateGroupId, parentStateName];
          const allXStateNames = [...parentStateNames, childStateName];
          const fullXStateId = allXStateNames.join(STATE_NAME_DELIMITER);
          const parentStateNameNormalized = normalizeStateName(name2);
          const childStateNameNormalized = normalizeStateName(childStateName);
          const parentStateNamesNormalized = [
            ..._workflowGroupId,
            parentStateNameNormalized
          ];
          const allStateNames = [
            ...parentStateNamesNormalized,
            childStateNameNormalized
          ];
          const fullStateId = allStateNames.join(STATE_NAME_DELIMITER);
          return React__default.cloneElement(node2, {
            relativePathForGroup: relativePath,
            _workflowFullStateId: fullStateId,
            _workflowGroupId: parentStateNamesNormalized,
            _workflowStateId: childStateNameNormalized,
            _workflowXStateFullStateId: fullXStateId,
            _workflowXStateGroupId: parentStateNames,
            _workflowXStateStateId: childStateName
          });
        }
        if ((_b = node2 == null ? void 0 : node2.props) == null ? void 0 : _b.children) {
          const newChildren2 = React__default.Children.map(node2.props.children, traverse);
          const newNode = React__default.cloneElement(node2, {
            ...node2.props,
            children: newChildren2
          });
          return newNode;
        }
      }
      return node2;
    },
    [_workflowGroupId, _workflowXStateGroupId, name2, relativePath]
  );
  const newChildren = useMemo(
    () => React__default.Children.map(children2, traverse),
    [children2, traverse]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: newChildren });
};
Group.$$workflowType = "GROUP";
const useWorkflowCurrentlySelectedStep = () => {
  const service = useWorkflowService();
  return useSelector(service, currentlySelectedStepSelector);
};
const toFullStateId = (...stateNames) => stateNames.filter((stateName) => stateName).map(normalizeStateName).join(STATE_NAME_DELIMITER);
const jumpToStepCreator = (service, machineConfig) => (stepData) => {
  let normalizedStepName;
  const { id: machineName } = machineConfig;
  const normalizedMachineName = normalizeStateName(machineName);
  if (isObject$e(stepData) && stepData.group && stepData.step) {
    normalizedStepName = toFullStateId(stepData.group, stepData.step);
  } else if (typeof stepData === "string") {
    normalizedStepName = stepData;
  }
  service.send(
    createJumpToStepAction(normalizedMachineName, normalizedStepName)
  );
};
const useWorkflowHelper = () => {
  const service = useWorkflowService();
  const [machineConfig] = useWorkflow((store) => store.machineConfig);
  const assignContext = (contextChange) => service.send(createAssignContextAction(contextChange));
  const updateContext2 = (contextChange) => service.send(createUpdateContextAction(contextChange));
  const jumpToStep = useMemo(
    () => jumpToStepCreator(service, machineConfig),
    [machineConfig, service]
  );
  return { assignContext, jumpToStep, updateContext: updateContext2 };
};
const renderComponent = (component) => {
  if (!component) {
    return null;
  } else if (typeof component === "string") {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: component });
  } else if (React__default.isValidElement(component)) {
    return component;
  } else if (typeof component === "function" || typeof component === "object") {
    const Component2 = component;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, {});
  }
};
const RenderComponent = ({
  component = void 0
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: renderComponent(component) });
};
const StepBase = ({
  children: children2,
  component,
  name: name2,
  _workflowXStateFullStateId
}) => {
  const { state } = useWorkflowStepHelper(name2);
  const { updateContext: updateContext2 } = useWorkflowHelper();
  const currentlySelectedStep = useWorkflowCurrentlySelectedStep();
  useEffect(() => {
    if (state === "active") {
      const stateName = normalizeStateName(name2);
      if (currentlySelectedStep !== stateName) {
        updateContext2({
          workflow: { currentlySelectedStep: stateName }
        });
      }
    }
  }, [currentlySelectedStep, name2, state, updateContext2]);
  if (!state) {
    return null;
  }
  const itemToRender = component || children2;
  if (!itemToRender) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(RenderComponent, { component: itemToRender });
};
const Step$1 = ({
  children: children2,
  component,
  name: name2,
  nodeType = "state",
  relativePath = void 0,
  relativePathForGroup = void 0,
  _workflowFullStateId,
  _workflowGroupId,
  _workflowStateId,
  _workflowXStateGroupId,
  _workflowXStateStateId,
  _workflowXStateFullStateId
}) => {
  useValidateWorkflowComponent({ nodeType }, "STEP");
  const [service] = useWorkflow((store) => store.service);
  const [path2] = useWorkflow((store) => store.path);
  if (!service) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    WorkflowStepContext.Provider,
    {
      value: {
        path: path2 || "",
        relativePath: relativePath || "",
        relativePathForGroup: relativePathForGroup || "",
        workflowFullStateId: _workflowFullStateId,
        workflowGroupId: _workflowGroupId,
        workflowStateId: _workflowStateId,
        workflowXStateGroupId: _workflowXStateGroupId,
        workflowXStateStateId: _workflowXStateStateId,
        workflowXStateFullStateId: _workflowXStateFullStateId
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StepBase,
        {
          _workflowXStateFullStateId,
          component,
          name: name2,
          children: children2
        }
      )
    }
  );
};
Step$1.$$workflowType = "STEP";
const workflowNodeTraverse = (element, visitorSearch) => {
  var _a2;
  const workflowComponents = [];
  const visitorFn = visitorSearch(element);
  if (visitorFn && isWorkflowType(element)) {
    const node2 = visitorFn(element, visitorSearch);
    workflowComponents.push(node2);
  } else if (React__default.isValidElement(element) && element.props.children) {
    const filteredWorkflowElements = workflowNodeTraverse(
      (_a2 = element == null ? void 0 : element.props) == null ? void 0 : _a2.children,
      visitorSearch
    );
    workflowComponents.push(...filteredWorkflowElements);
  } else if (Array.isArray(element)) {
    element == null ? void 0 : element.forEach((el) => {
      const filteredWorkflowElements = workflowNodeTraverse(el, visitorSearch);
      workflowComponents.push(...filteredWorkflowElements);
    });
  }
  return flattenDeep(workflowComponents);
};
var WorkflowNode = /* @__PURE__ */ ((WorkflowNode2) => {
  WorkflowNode2["Group"] = "Group";
  WorkflowNode2["Step"] = "Step";
  WorkflowNode2["StepView"] = "StepView";
  WorkflowNode2["StepViewPicker"] = "StepViewPicker";
  return WorkflowNode2;
})(WorkflowNode || {});
const workflowParseVisitor = {
  [WORKFLOW_TYPES.GROUP]: (element, visitorSearch) => {
    var _a2;
    return {
      type: WorkflowNode.Group,
      component: element,
      steps: workflowNodeTraverse(
        (_a2 = element == null ? void 0 : element.props) == null ? void 0 : _a2.children,
        visitorSearch
      )
    };
  },
  [WORKFLOW_TYPES.STEP]: (element, _) => ({
    type: WorkflowNode.Step,
    component: element
  }),
  [WORKFLOW_TYPES.STEP_VIEW]: (element, _) => ({
    type: WorkflowNode.StepView,
    component: element
  }),
  [WORKFLOW_TYPES.STEP_VIEW_PICKER]: (element, visitorSearch) => {
    var _a2;
    return {
      type: WorkflowNode.StepViewPicker,
      component: element,
      steps: workflowNodeTraverse(
        (_a2 = element == null ? void 0 : element.props) == null ? void 0 : _a2.children,
        visitorSearch
      )
    };
  }
};
const _parse = (element) => workflowNodeTraverse(element, workflowParsingVisitorSearch);
const workflowParsingVisitorSearch = (element) => {
  if (isWorkflowGroupType(element)) {
    return workflowParseVisitor[WORKFLOW_TYPES.GROUP];
  } else if (isWorkflowStepType(element)) {
    return workflowParseVisitor[WORKFLOW_TYPES.STEP];
  } else if (isWorkflowStepViewType(element)) {
    return workflowParseVisitor[WORKFLOW_TYPES.STEP_VIEW];
  } else if (isWorkflowStepViewPickerType(element)) {
    return workflowParseVisitor[WORKFLOW_TYPES.STEP_VIEW_PICKER];
  }
  return void 0;
};
function workflowToXstateVisitor(node2, workflowProps) {
  if (isWorkflowGroupNode(node2)) {
    return workflowAstToXStateAstVisitor.Group(node2, workflowProps);
  } else if (isWorkflowStepNode(node2)) {
    return workflowAstToXStateAstVisitor.Step(node2, workflowProps);
  } else if (isWorkflowStepViewNode(node2)) {
    return workflowAstToXStateAstVisitor.StepView(node2, workflowProps);
  } else if (isWorkflowStepViewPickerNode(node2)) {
    return workflowAstToXStateAstVisitor.StepViewPicker(node2, workflowProps);
  }
  throw new Error(
    `Workflow AST node visitor: "${node2}" is not yet setup in 'workflowAstToXStateAstVisitor'`
  );
}
const workflowAstToXStateAstVisitor = {
  Group(node2, workflowProps) {
    var _a2;
    const groupProps = cloneDeep((_a2 = node2 == null ? void 0 : node2.component) == null ? void 0 : _a2.props);
    delete groupProps.children;
    const workflowStepsAst = node2 == null ? void 0 : node2.steps;
    return {
      type: XStateAstNodes.GROUP_STATE,
      props: groupProps,
      body: _transformNodes({
        workflowAst: workflowStepsAst,
        workflowProps
      })
    };
  },
  Step(node2, _) {
    var _a2;
    const stepProps = cloneDeep((_a2 = node2 == null ? void 0 : node2.component) == null ? void 0 : _a2.props);
    delete stepProps.children;
    return {
      type: "state",
      props: stepProps
    };
  },
  StepView(node2, _) {
    var _a2;
    const stepProps = cloneDeep((_a2 = node2 == null ? void 0 : node2.component) == null ? void 0 : _a2.props);
    delete stepProps.children;
    return {
      type: "stateView",
      props: stepProps
    };
  },
  StepViewPicker(node2, workflowProps) {
    var _a2;
    const groupProps = cloneDeep((_a2 = node2 == null ? void 0 : node2.component) == null ? void 0 : _a2.props);
    delete groupProps.children;
    const workflowStepsAst = node2 == null ? void 0 : node2.steps;
    return {
      type: XStateAstNodes.GROUP_STATE,
      props: groupProps,
      body: _transformNodes({
        workflowAst: workflowStepsAst,
        workflowProps
      })
    };
  }
};
function isWorkflowGroupNode(node2) {
  return node2.type === WorkflowNode.Group;
}
function isWorkflowStepNode(node2) {
  return node2.type === WorkflowNode.Step;
}
function isWorkflowStepViewNode(node2) {
  return node2.type === WorkflowNode.StepView;
}
function isWorkflowStepViewPickerNode(node2) {
  return node2.type === WorkflowNode.StepViewPicker;
}
function _transformNodes({
  workflowAst,
  workflowProps
}) {
  return workflowAst.map((node2) => {
    const xStateAstNode = workflowToXstateVisitor(node2, workflowProps);
    return xStateAstNode;
  });
}
function _transform({
  workflowAst,
  workflowProps
}) {
  const xStateAstMachineNode = _transformToMachineNode(workflowProps);
  const xStateAstNodes = _transformNodes({
    workflowAst,
    workflowProps
  });
  if (xStateAstMachineNode) {
    xStateAstMachineNode.body = [
      ...xStateAstMachineNode.body,
      ...xStateAstNodes
    ];
  }
  return xStateAstMachineNode;
}
function _transformToMachineNode(workflowProps) {
  const newWorkflowProps = cloneDeep(workflowProps);
  delete newWorkflowProps.children;
  return {
    type: "machine",
    body: [],
    props: newWorkflowProps
  };
}
const toStepId = (stepName, parentStepName) => {
  let name2 = "";
  if (parentStepName && parentStepName !== stepName) {
    name2 = `${normalizeStateName(parentStepName)}${STATE_NAME_DELIMITER}`;
  }
  name2 += normalizeStateName(stepName);
  return name2;
};
const getIdInvokedMachine = (stateName) => `${ID_INVOKED_MACHINE}${ID_DELIMITER}${normalizeStateName(stateName)}`;
const getIdParallelServices = () => uniqueId$1(`${ID_PARALLEL_SERVICES}${ID_DELIMITER}`);
const removeTrailingSlash = (str) => str.replace(/\/$/, "");
const useStepCardChangeRoutes = (history, location) => {
  const { relativePath, relativePathForGroup } = useWorkflowStep();
  const [workflowBasePath] = useWorkflow((store) => store.path);
  const { state } = useWorkflowStepHelper();
  const [hasSwitchedRoutes, setHasSwitchedRoutes] = useState(false);
  const finalBasePath = workflowBasePath || "";
  const finalPathForGroup = relativePathForGroup || "";
  const stepHasRoute = Boolean(relativePath);
  useEffect(() => {
    if (stepHasRoute) {
      const fullPath = removeTrailingSlash(
        `${finalBasePath}${finalPathForGroup}${relativePath}`
      );
      const finalSearch = location.search || "";
      const fullUrl = `${fullPath}${finalSearch}`;
      const windowLocationPath = removeTrailingSlash(window.location.pathname);
      const stepPathIsSameAsBrowserPath = fullPath === windowLocationPath;
      if (!stepPathIsSameAsBrowserPath) {
        history.push(fullUrl);
      }
      setHasSwitchedRoutes(true);
    }
  }, [
    finalBasePath,
    finalPathForGroup,
    history,
    relativePath,
    stepHasRoute,
    state,
    location,
    hasSwitchedRoutes
  ]);
  return { hasSwitchedRoutes, stepHasRoute };
};
const xStateConfigVisitor = {
  childMachine(node2, parentNode) {
    var _a2, _b;
    validateNameProp(node2);
    const { name: name2 } = node2.props;
    if (((_a2 = parentNode == null ? void 0 : parentNode.props) == null ? void 0 : _a2.nodeType) === XStateAstNodes.CHILD_MACHINE) {
      if (node2 == null ? void 0 : node2.body) {
        const [firstStep, _] = (node2 == null ? void 0 : node2.body) || [];
        const initialState2 = (_b = firstStep == null ? void 0 : firstStep.props) == null ? void 0 : _b.name;
        const invokedMachineConfigSkeleton = _generateMachineConfigSkeleton({
          id: name2,
          context: {},
          initial: initialState2,
          type: STATE_TYPES.PARALLEL
        });
        const stateConfig = _generateFromAstBodyWithVisitor(node2.body, node2);
        const invokedMachineConfig = merge$4(
          invokedMachineConfigSkeleton,
          stateConfig
        );
        const invokedMachine = createMachine(invokedMachineConfig);
        return {
          states: {
            [name2]: {
              // id: getIdInvokedMachine(name),
              // invoke: invokedMachine,
              invoke: {
                id: getIdInvokedMachine(name2),
                src: invokedMachine
              }
            }
          }
        };
      }
    }
  },
  groupState(node2, parentNode) {
    const { props: props2 } = node2;
    validateNameProp(node2);
    const { name: name2 } = node2.props;
    let bodyConfig = {};
    if (node2 == null ? void 0 : node2.body) {
      const stateConfig = _generateFromAstBodyWithVisitor(node2.body, node2);
      bodyConfig = merge$4(bodyConfig, stateConfig);
    }
    const initial = (props2 == null ? void 0 : props2.initial) || void 0;
    const type2 = (props2 == null ? void 0 : props2.machineType) || void 0;
    return {
      states: {
        // could also be "unknown" : https://xstate.js.org/docs/guides/statenodes.html#transient-state-nodes
        [name2]: {
          type: type2,
          initial,
          ...bodyConfig
          // initial: "idle",
          // on: {
          //   [`START_${stateName}`]: { target: ".active" },
          //   [`SET_IDLE_${stateName}`]: { target: ".idle" },
          //   [`SET_ACTIVE_${stateName}`]: { target: ".active" },
          //   [`SET_COMPLETE_${stateName}`]: { target: ".complete" },
          // },
          // states: {
          //   idle: {},
          //   active: {},
          //   complete: {},
          // }
        }
        // https://xstate.js.org/docs/guides/statenodes.html#state-node-types
        // type:
        // https://xstate.js.org/docs/guides/statenodes.html#state-node-meta-data
        // meta: {},
        // https://xstate.js.org/docs/guides/statenodes.html#tags
        // tags: [],
      }
    };
  },
  state(node2, parentNode) {
    const { props: props2 } = node2;
    let stateConfig = {};
    props2 == null ? void 0 : props2.name;
    const stateName = normalizeStateName(props2 == null ? void 0 : props2.name);
    if ((parentNode == null ? void 0 : parentNode.type) === "childMachine") {
      stateConfig = {
        initial: (props2 == null ? void 0 : props2.initial) || "idle",
        on: {
          [`START_${stateName}`]: { target: ".active" },
          // [`SET_IDLE_${stateName}`]: { target: ".idle" },
          [`SET_ACTIVE_${stateName}`]: { target: ".active" },
          [`SET_COMPLETE_${stateName}`]: { target: ".complete" }
        },
        states: {
          idle: {},
          active: {},
          complete: {}
        }
      };
    } else if ((parentNode == null ? void 0 : parentNode.type) === "groupState") {
      stateConfig = {
        initial: (props2 == null ? void 0 : props2.initial) || "active",
        on: {
          [`SET_LOADING_${stateName}`]: { target: ".loading" },
          [`SET_ACTIVE_${stateName}`]: { target: ".active" },
          [`SET_ERROR_${stateName}`]: { target: ".error" }
        },
        states: {
          loading: {},
          active: {},
          error: {}
        }
      };
    }
    const stateConfigFromProps = Object.entries(props2).reduce(
      (configFromProps, propData) => {
        const [prop, value] = propData;
        const stepNodeProp = prop;
        if (statePropsVisitor[stepNodeProp]) {
          const visitor = statePropsVisitor[stepNodeProp];
          const configNode = visitor(stepNodeProp, value, props2);
          configFromProps = merge$4(configFromProps, configNode);
        }
        return configFromProps;
      },
      {}
    );
    validateNameProp(node2);
    const { name: name2 } = node2.props;
    const mergedStateConfig = merge$4(
      stateConfig,
      stateConfigFromProps
      // modifications here will overwrite anything in thestateConfig
    );
    return {
      states: {
        // could also be "unknown" : https://xstate.js.org/docs/guides/statenodes.html#transient-state-nodes
        [name2]: mergedStateConfig
        // https://xstate.js.org/docs/guides/statenodes.html#state-node-types
        // type:
        // https://xstate.js.org/docs/guides/statenodes.html#state-node-meta-data
        // meta: {},
        // https://xstate.js.org/docs/guides/statenodes.html#tags
        // tags: [],
      }
    };
  },
  stateView(node2, parentNode) {
    const { props: props2 } = node2;
    let stateConfig = {};
    const stateName = normalizeStateName(props2 == null ? void 0 : props2.name);
    if ((parentNode == null ? void 0 : parentNode.type) === "groupState") {
      stateConfig = {
        entry: props2 == null ? void 0 : props2.onEntry,
        exit: props2 == null ? void 0 : props2.onExit,
        initial: (props2 == null ? void 0 : props2.initial) || "begin",
        on: {
          [`SET_BEGIN_${stateName}`]: { target: ".begin" },
          [`SET_ACTIVE_${stateName}`]: { target: ".active" },
          [`SET_ERROR_${stateName}`]: { target: ".error" },
          [`SET_LOADING_${stateName}`]: { target: ".loading" },
          [`SET_SUBMITTING_${stateName}`]: { target: ".submitting" },
          [`SET_SUCCESS_${stateName}`]: { target: ".success" }
          // [`SET_SUCCESS_${stateName}`]: { target: ".end" },
        },
        states: {
          begin: {
            on: {
              GO_ACTIVE: "active",
              // default set in React land
              GO_ERROR: "error",
              GO_LOADING: "loading"
            }
          },
          // end: {},
          active: {},
          error: {},
          loading: {},
          submitting: {},
          success: {
            initial: "preActionRun",
            states: {
              preActionRun: {
                on: {
                  DONE: [
                    { target: "customActionRun", cond: "hasCustomAction" },
                    { target: "actionRun" }
                  ]
                }
              },
              customActionRun: {
                on: {
                  DONE: "completed"
                }
              },
              actionRun: {
                on: {
                  DONE: "completed"
                }
              },
              completed: {
                type: "final"
              }
            }
          }
        }
      };
    }
    const stateConfigFromProps = Object.entries(props2).reduce(
      (configFromProps, propData) => {
        const [prop, value] = propData;
        const stepNodeProp = prop;
        if (statePropsVisitor[stepNodeProp]) {
          const visitor = statePropsVisitor[stepNodeProp];
          const configNode = visitor(stepNodeProp, value, props2);
          configFromProps = merge$4(configFromProps, configNode);
        }
        return configFromProps;
      },
      {}
    );
    validateNameProp(node2);
    const { name: name2 } = node2.props;
    const mergedStateConfig = merge$4(
      stateConfig,
      stateConfigFromProps
      // modifications here will overwrite anything in thestateConfig
    );
    return {
      states: {
        // could also be "unknown" : https://xstate.js.org/docs/guides/statenodes.html#transient-state-nodes
        [name2]: mergedStateConfig
        // https://xstate.js.org/docs/guides/statenodes.html#state-node-types
        // type:
        // https://xstate.js.org/docs/guides/statenodes.html#state-node-meta-data
        // meta: {},
        // https://xstate.js.org/docs/guides/statenodes.html#tags
        // tags: [],
      }
    };
  }
};
const statePropsVisitor = {
  on: (_, value) => {
    return {
      on: {
        ...value
      }
    };
  },
  onAlways: (prop, value) => {
    if (!Array.isArray(value)) {
      throw new Error(
        "onAlways prop needs to be an array of Transition objects : https://xstate.js.org/docs/guides/transitions.html#api"
      );
    }
    return {
      always: value
    };
  },
  onComplete: (prop, value, stateProps) => {
    if (!Array.isArray(value)) {
      throw new Error(
        "onComplete prop needs to be an array of Transition objects : https://xstate.js.org/docs/guides/transitions.html#api"
      );
    }
    const stateName = normalizeStateName(stateProps == null ? void 0 : stateProps.name);
    return {
      on: {
        [`COMPLETE_${stateName}`]: value
      }
    };
  },
  onNext: (prop, value) => {
    if (!Array.isArray(value)) {
      throw new Error(
        "onNext prop needs to be an array of Transition objects : https://xstate.js.org/docs/guides/transitions.html#api"
      );
    }
    return {
      on: {
        NEXT: value
      }
    };
  },
  // eslint-disable-next-line unused-imports/no-unused-vars
  onPrev: (prop, value) => ({ on: { PREV: value } }),
  // TODO
  servicesBegin: (prop, value) => {
    const invokedMachineConfigSkeleton = _generateMachineConfigSkeleton({
      id: getIdParallelServices(),
      context: {},
      type: STATE_TYPES.PARALLEL
    });
    const servicesConfig = _generateServicesConfig(value);
    const invokedMachineConfig = merge$4(
      invokedMachineConfigSkeleton,
      servicesConfig
    );
    const servicesObj = value.reduce(
      (obj, service) => ({
        ...obj,
        ...service
      }),
      {}
    );
    const invokedMachineOptions = {
      actions: {},
      guards: {},
      services: servicesObj,
      delays: {}
    };
    const invokedMachine = createMachine(
      invokedMachineConfig,
      invokedMachineOptions
    );
    return {
      on: {
        START: ".runningServicesBegin"
      },
      states: {
        runningServicesBegin: {
          tags: "loading",
          invoke: {
            id: "genericParallelServiceId",
            src: invokedMachine,
            onDone: [{ target: "active" }]
          }
        }
      }
    };
  }
};
const validateNameProp = (node2) => {
  const { name: name2 } = (node2 == null ? void 0 : node2.props) || {};
  if (!name2) {
    throw new Error("Step states need a name prop passed.");
  }
};
function _generateFromAstBody(xStateAst, xStateConfigVisitor2, parentNode) {
  const code = {};
  xStateAst.forEach((node2) => {
    if (xStateConfigVisitor2[node2 == null ? void 0 : node2.type]) {
      const visitor = xStateConfigVisitor2[node2.type];
      const stateConfig = visitor(node2, parentNode);
      merge$4(code, stateConfig);
    }
  });
  return code;
}
function _generateFromAstBodyWithVisitor(xStateAst, parentNode) {
  return _generateFromAstBody(xStateAst, xStateConfigVisitor, parentNode);
}
const _generateMachineConfigSkeleton = ({
  id,
  context,
  initial,
  on,
  type: type2
}) => {
  const mergedOn = merge$4(
    {
      GO_BACK: { actions: ["goBack"] },
      ASSIGN_CTX: { actions: ["assignContext"] },
      UPDATE_CTX: { actions: ["updateContext"] },
      UPDATE_FLOW_DATA_CTX: { actions: ["updateFlowDataContext"] },
      UPDATE_FORM_DATA_CTX: { actions: ["updateFormDataContext"] },
      SELECT_CURRENT_STEP: { actions: ["selectCurrentStep"] }
    },
    on
  );
  return {
    predictableActionArguments: true,
    // https://xstate.js.org/docs/guides/actions.html#actions
    id: id || uniqueId$1("generic-machine-"),
    context,
    initial,
    ...type2 && { type: type2 },
    on: mergedOn,
    states: {}
  };
};
const _generateServicesConfig = (services) => ({
  states: services.reduce((servicesConfig, service) => {
    const [name2] = Object.keys(service);
    return {
      ...servicesConfig,
      ...{
        [name2]: {
          initial: "run",
          states: {
            run: {
              invoke: {
                src: name2,
                id: name2,
                onDone: [
                  {
                    target: "done",
                    actions: "sendParentData"
                  }
                ]
              }
            },
            done: {
              type: "final"
            }
          }
        }
      }
    };
  }, {})
});
function _getInitialCurrentlySelectedStep(xStateAst) {
  var _a2, _b, _c, _d, _e, _f;
  if ((_a2 = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _a2.initialSelectedStep) {
    if (Array.isArray(xStateAst.props.initialSelectedStep)) {
      const arr = (_b = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _b.initialSelectedStep;
      return toFullStateId(...arr);
    }
    return toStepId((_c = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _c.initial);
  }
  const firstNode = (_d = xStateAst == null ? void 0 : xStateAst.body) == null ? void 0 : _d.find(
    (node2) => (node2 == null ? void 0 : node2.type) === "childMachine" || (node2 == null ? void 0 : node2.type) === "state"
  );
  if ((firstNode == null ? void 0 : firstNode.type) === "childMachine") {
    return toStepId((_e = firstNode == null ? void 0 : firstNode.props) == null ? void 0 : _e.name);
  } else if ((firstNode == null ? void 0 : firstNode.type) === "state") {
    return toStepId((_f = firstNode == null ? void 0 : firstNode.props) == null ? void 0 : _f.name);
  }
  return void 0;
}
const getStateViewNodeProps = (node2) => {
  var _a2, _b;
  if (!node2) {
    return {};
  }
  return {
    displayGuard: (_a2 = node2 == null ? void 0 : node2.props) == null ? void 0 : _a2.displayGuard,
    guard: (_b = node2 == null ? void 0 : node2.props) == null ? void 0 : _b.guard
  };
};
function _generateStateViewsData(xStateAst) {
  const stateViewData = {};
  const traverseNode = (node2, parentStateId, grandParentStateId) => {
    var _a2, _b;
    const stateId = normalizeStateName((_a2 = node2 == null ? void 0 : node2.props) == null ? void 0 : _a2.name);
    const isGroupState = node2.type === "groupState";
    const isStateView = node2.type === "stateView";
    if (isGroupState || isStateView) {
      const stateView = { type: node2.type, props: getStateViewNodeProps(node2) };
      let stateKey = stateId;
      if (parentStateId) {
        stateKey = `${parentStateId}:${stateId}`;
      }
      if (grandParentStateId) {
        stateKey = `${grandParentStateId}:${stateKey}`;
      }
      stateViewData[stateKey] = stateView;
      if (isGroupState) {
        (_b = node2.body) == null ? void 0 : _b.forEach((childNode) => {
          traverseNode(childNode, stateId, parentStateId);
        });
      }
    }
  };
  xStateAst.body.forEach((node2) => {
    traverseNode(node2);
  });
  return stateViewData;
}
function _generateJumpToStepViewEvents(xStateAst) {
  var _a2;
  const events = {};
  const machineName = (_a2 = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _a2.name;
  const bodyAst = xStateAst == null ? void 0 : xStateAst.body;
  function traverseNodes(nodes, parentNode) {
    nodes.forEach((node2) => {
      var _a3, _b, _c;
      const isStateViewPicker = (node2 == null ? void 0 : node2.type) === "groupState" && (parentNode == null ? void 0 : parentNode.type) === "groupState";
      if ((node2 == null ? void 0 : node2.type) === "groupState") {
        !isStateViewPicker && traverseNodes(node2 == null ? void 0 : node2.body, node2);
      }
      if ((node2 == null ? void 0 : node2.type) === "stateView" || isStateViewPicker) {
        const parentNodeName = (_a3 = parentNode == null ? void 0 : parentNode.props) == null ? void 0 : _a3.name;
        const ids = parentNodeName ? [machineName, parentNodeName, (_b = node2 == null ? void 0 : node2.props) == null ? void 0 : _b.name] : [machineName, (_c = node2 == null ? void 0 : node2.props) == null ? void 0 : _c.name];
        const fullStateIdWithMachineName = toFullStateId(...ids);
        const jumpToStepEventName = `${JUMP_EVENT_PREFIX}${fullStateIdWithMachineName}`;
        events[jumpToStepEventName] = {
          target: `#${ids.join(".")}`,
          actions: assign3((ctx2, evt) => {
            const { data } = evt;
            const lastHistoryIsSame = ctx2.workflow.history.slice(-1)[0] === (data == null ? void 0 : data.currentlySelectedStep);
            if (data.currentlySelectedStep) {
              return merge$4(ctx2, {
                workflow: {
                  currentlySelectedStep: data.currentlySelectedStep,
                  ...!lastHistoryIsSame ? {
                    history: [
                      ...ctx2.workflow.history,
                      data.currentlySelectedStep
                    ]
                  } : void 0
                }
              });
            }
          })
        };
      }
    });
  }
  if (bodyAst) {
    bodyAst.forEach((node2) => {
      traverseNodes([node2]);
    });
  }
  return events;
}
function _generateUrlToJumpToStepEventData(xStateAst) {
  var _a2, _b;
  const urlToJumpToStepEventData = {};
  const basePath = ((_a2 = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _a2.path) || "";
  const machineName = (_b = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _b.name;
  const normalizedMachineName = normalizeStateName(machineName);
  const traverseNode = (node2, {
    parentUrlKey,
    parentStateId
  }, {
    grandParentUrlKey,
    grandParentStateId
  }) => {
    var _a3, _b2, _c, _d;
    const stateId = normalizeStateName((_a3 = node2 == null ? void 0 : node2.props) == null ? void 0 : _a3.name);
    const hasRelativePath = (_b2 = node2 == null ? void 0 : node2.props) == null ? void 0 : _b2.relativePath;
    const stateRelativePath = ((_c = node2 == null ? void 0 : node2.props) == null ? void 0 : _c.relativePath) || "";
    const isGroupState = node2.type === "groupState";
    const isStateView = node2.type === "stateView";
    if (isGroupState || isStateView) {
      let urlKey = stateRelativePath;
      let stateKey = stateId;
      if (parentStateId) {
        urlKey = `${basePath}${parentUrlKey}${stateRelativePath}`;
        stateKey = `${parentStateId}:${stateId}`;
      }
      if (grandParentStateId) {
        urlKey = `${basePath}${grandParentUrlKey}${urlKey}`;
        stateKey = `${grandParentStateId}:${stateKey}`;
      }
      if (!isGroupState && hasRelativePath) {
        const jumpToStep = createJumpToStepAction(
          normalizedMachineName,
          stateKey
        );
        urlKey = removeTrailingSlash(urlKey);
        if (!urlToJumpToStepEventData[urlKey]) {
          urlToJumpToStepEventData[urlKey] = [];
        }
        urlToJumpToStepEventData[urlKey].push(jumpToStep);
      }
      if (isGroupState) {
        (_d = node2.body) == null ? void 0 : _d.forEach((childNode) => {
          traverseNode(
            childNode,
            {
              parentStateId: stateId,
              parentUrlKey: stateRelativePath
            },
            {
              grandParentStateId: parentStateId,
              grandParentUrlKey: parentUrlKey
            }
          );
        });
      }
    }
  };
  xStateAst.body.forEach((node2) => {
    traverseNode(node2, {}, {});
  });
  return urlToJumpToStepEventData;
}
const generateContext = (workflowContextProp, xStateAst) => {
  const ctxObj = {
    workflow: {
      currentlySelectedStep: _getInitialCurrentlySelectedStep(xStateAst),
      history: [],
      progressData: {},
      stateViewData: _generateStateViewsData(xStateAst),
      urlToJumpToStepEventData: _generateUrlToJumpToStepEventData(xStateAst)
    }
  };
  if (typeof workflowContextProp === "function") {
    return workflowContextProp(ctxObj);
  }
  return merge$4({}, ctxObj, workflowContextProp);
};
function _generateMachineConfigAndOptions(xStateAst) {
  var _a2, _b, _c, _d, _e, _f;
  const contextProps = generateContext((_a2 = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _a2.context, xStateAst);
  const machineConfig = _generateMachineConfigSkeleton({
    id: (_b = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _b.name,
    context: contextProps,
    initial: (_c = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _c.initial,
    on: _generateJumpToStepViewEvents(xStateAst),
    type: (_d = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _d.machineType
  });
  const bodyConfig = _generateFromAstBodyWithVisitor(
    xStateAst == null ? void 0 : xStateAst.body,
    xStateAst
  );
  const machineOptions = {
    actions: {
      ...(_e = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _e.actions,
      // TODO RNDUX 1187 #19 - Don't know if we need this, or maybe we still need to keep history in order to handle browser back
      goBack: assign3((ctx2, _) => {
        const lastIndex = ctx2.workflow.history.length - 1;
        const newHistory = ctx2.workflow.history.slice(0, lastIndex);
        newHistory.slice(-1)[0];
        const onlyOneHistoryItem = ctx2.workflow.history.length === 1;
        if (onlyOneHistoryItem) {
          return;
        }
        ctx2.workflow.history.pop();
        return ctx2;
      }),
      updateContext: assign3((ctx2, event2) => merge$4(ctx2, event2.data)),
      updateFormDataContext: assign3(mergeFormData),
      assignContext: assign3((ctx2, event2) => {
        function customizer(objValue, srcValue) {
          return srcValue;
        }
        return mergeWith(ctx2, event2.data, customizer);
      }),
      selectCurrentStep: assign3((ctx2, event2) => {
        const { workflowFullStateId } = (event2 == null ? void 0 : event2.data) || {};
        const lastHistoryIsSame = ctx2.workflow.history.slice(-1)[0] === workflowFullStateId;
        if (workflowFullStateId) {
          return merge$4(ctx2, {
            workflow: {
              currentlySelectedStep: workflowFullStateId,
              ...!lastHistoryIsSame ? { history: [...ctx2.workflow.history, workflowFullStateId] } : void 0
            }
          });
        }
        return ctx2;
      })
    },
    guards: {
      hasCustomAction: (_, evt) => {
        const { customAction } = evt;
        if (!customAction) {
          return false;
        }
        return true;
      },
      ...(_f = xStateAst == null ? void 0 : xStateAst.props) == null ? void 0 : _f.guards
    },
    delays: {},
    services: {}
  };
  merge$4(machineConfig, bodyConfig);
  return { machineConfig, machineOptions };
}
const mergeFormData = (ctx2, event2) => {
  ctx2.formData = ctx2.formData || {};
  _assign(ctx2.formData, event2.data.formData);
};
const _buildStepperSteps = (workflowAst) => {
  const stepperSteps = workflowAst == null ? void 0 : workflowAst.map((node2) => {
    var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    if (node2.type === WorkflowNode.StepView) {
      const step2 = node2;
      const stepName = (_b = (_a2 = step2.component) == null ? void 0 : _a2.props) == null ? void 0 : _b.name;
      const title = ((_d = (_c = step2 == null ? void 0 : step2.component) == null ? void 0 : _c.props) == null ? void 0 : _d.title) || stepName;
      return {
        title,
        name: stepName,
        ...hasDisplayGuard(step2.component.props.displayGuard) && {
          displayGuard: step2.component.props.displayGuard
        },
        ...hasGuard(step2.component.props.guard) && {
          guard: step2.component.props.guard
        },
        workflowXStateStateName: stepName
      };
    } else if (node2.type === WorkflowNode.StepViewPicker) {
      const step2 = node2;
      const stepName = (_f = (_e = step2.component) == null ? void 0 : _e.props) == null ? void 0 : _f.name;
      const title = ((_h = (_g = step2 == null ? void 0 : step2.component) == null ? void 0 : _g.props) == null ? void 0 : _h.title) || stepName;
      return {
        title,
        name: stepName,
        ...hasDisplayGuard(step2.component.props.displayGuard) && {
          displayGuard: step2.component.props.displayGuard
        },
        ...hasGuard(step2.component.props.guard) && {
          guard: step2.component.props.guard
        },
        stepsPossible: _buildStepperSteps(step2 == null ? void 0 : step2.steps),
        workflowXStateStateName: stepName
      };
    } else if (node2.type === WorkflowNode.Group) {
      const group = node2;
      const groupName = group.component.props.name;
      return {
        title: ((_j = (_i = group == null ? void 0 : group.component) == null ? void 0 : _i.props) == null ? void 0 : _j.title) || groupName,
        name: groupName,
        ...hasDisplayGuard(group.component.props.displayGuard) && {
          displayGuard: group.component.props.displayGuard
        },
        ...hasGuard(group.component.props.guard) && {
          guard: group.component.props.guard
        },
        subSteps: _buildStepperSteps(group == null ? void 0 : group.steps),
        workflowXStateGroupName: groupName
      };
    }
    return void 0;
  }).filter((node2) => node2 !== void 0);
  return stepperSteps;
};
const hasDisplayGuard = (displayGuard) => typeof displayGuard === "function";
const hasGuard = (guard) => typeof guard === "function";
const getStepperIdxMappingFromWorkflowId = (stepperSteps, parentXStateGroupName, stepParentIdx) => (
  // TODO:
  stepperSteps == null ? void 0 : stepperSteps.reduce((mapping, step2, idx) => {
    const isGroupStep2 = parentXStateGroupName == void 0;
    const finalWorkflowXStateId = isGroupStep2 ? step2 == null ? void 0 : step2.workflowXStateGroupName : step2 == null ? void 0 : step2.workflowXStateStateName;
    const stateIds = isGroupStep2 ? [finalWorkflowXStateId] : [parentXStateGroupName, finalWorkflowXStateId];
    const finalWorkflowFullStateId = toFullStateId(...stateIds);
    return {
      ...mapping,
      [finalWorkflowFullStateId]: {
        idx,
        totalSiblingSteps: stepperSteps == null ? void 0 : stepperSteps.length,
        parentIdx: stepParentIdx
      },
      ...getStepperIdxMappingFromWorkflowId(
        step2.subSteps,
        finalWorkflowXStateId,
        idx
      )
    };
  }, {})
);
const _createWorkflowSetup = (workflowProps, workflowChildren) => {
  const workflowAst = _parse(workflowChildren);
  const xStateAst = _transform({
    workflowProps,
    workflowAst
  });
  const { machineConfig, machineOptions } = _generateMachineConfigAndOptions(xStateAst);
  const stepperSteps = _buildStepperSteps(workflowAst);
  return { machineConfig, machineOptions, stepperSteps };
};
const WorkflowBase = (workflowProps) => {
  const { children: children2, onWorkflowStart, path: path2, uiConfig } = workflowProps;
  const setup = useMemo(
    () => {
      const workflowSetup = _createWorkflowSetup(workflowProps, children2);
      const { machineConfig: machineConfig2, machineOptions, stepperSteps } = workflowSetup;
      const machine2 = createMachine(machineConfig2, machineOptions);
      return {
        machine: machine2,
        machineConfig: machineConfig2,
        initialStepperSteps: stepperSteps
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // Currently, do not re-build the machine for any changes to the children. Maybe one day we can test if it's ok to change due to other workflowProps.
    ]
  );
  const { machine, machineConfig, initialStepperSteps } = setup;
  const serviceCreated = useInterpret(machine, { devTools: true });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      SetupMachine,
      {
        initialStepperSteps,
        machine,
        machineConfig,
        onWorkflowStart,
        path: path2,
        service: serviceCreated,
        uiConfig
      }
    ),
    children2
  ] });
};
const SetupMachine = ({
  initialStepperSteps,
  machine,
  machineConfig,
  onWorkflowStart,
  path: path2,
  service,
  uiConfig
}) => {
  const [, setStore] = useWorkflow((store) => store.service);
  useEffect(() => {
    var _a2, _b;
    setStore == null ? void 0 : setStore({
      initialStepperSteps,
      machine,
      machineConfig,
      path: path2,
      service,
      uiConfig
    });
    const definedService = service;
    const jumpToStep = jumpToStepCreator(definedService, machineConfig);
    onWorkflowStart && typeof onWorkflowStart === "function" ? onWorkflowStart == null ? void 0 : onWorkflowStart({
      ctx: (_b = (_a2 = service == null ? void 0 : service.getSnapshot) == null ? void 0 : _a2.call(service)) == null ? void 0 : _b.context,
      jumpToStep,
      service: definedService
    }) : maybeChangeStateBasedOnUrl(definedService);
  }, []);
  return null;
};
const maybeChangeStateBasedOnUrl = (serviceCreated) => {
  var _a2, _b, _c, _d, _e;
  const ctx2 = (_a2 = serviceCreated == null ? void 0 : serviceCreated.getSnapshot()) == null ? void 0 : _a2.context;
  const currentlySelectedStep = (_b = ctx2 == null ? void 0 : ctx2.workflow) == null ? void 0 : _b.currentlySelectedStep;
  const urlToJumpToStepEventData = (_c = ctx2 == null ? void 0 : ctx2.workflow) == null ? void 0 : _c.urlToJumpToStepEventData;
  const stateViewData = (_d = ctx2 == null ? void 0 : ctx2.workflow) == null ? void 0 : _d.stateViewData;
  if (urlToJumpToStepEventData) {
    const urlsToMatch = Object.keys(urlToJumpToStepEventData);
    const locationPath = removeTrailingSlash((_e = window == null ? void 0 : window.location) == null ? void 0 : _e.pathname);
    const matchedPath = urlsToMatch.find((url) => url === locationPath);
    let finalJumpToStepAction;
    if (matchedPath) {
      const matchedStateJumpToStepActions = urlToJumpToStepEventData[matchedPath];
      matchedStateJumpToStepActions.forEach(
        (matchedStateJumpToStepAction) => {
          var _a3;
          let shouldJumpToStep = true;
          const workflowId = (_a3 = matchedStateJumpToStepAction == null ? void 0 : matchedStateJumpToStepAction.data) == null ? void 0 : _a3.currentlySelectedStep;
          if (workflowId) {
            const matchedStateViewData = stateViewData == null ? void 0 : stateViewData[workflowId];
            const { displayGuard, guard } = (matchedStateViewData == null ? void 0 : matchedStateViewData.props) || {};
            if ((displayGuard == null ? void 0 : displayGuard(ctx2)) === false || (guard == null ? void 0 : guard(ctx2)) === false) {
              shouldJumpToStep = false;
            }
            const alreadyInCurrentStep = currentlySelectedStep === workflowId;
            if (alreadyInCurrentStep) {
              shouldJumpToStep = false;
            }
          }
          if (shouldJumpToStep) {
            finalJumpToStepAction = matchedStateJumpToStepAction;
          }
        }
      );
      if (finalJumpToStepAction) {
        serviceCreated.send(finalJumpToStepAction);
      }
    }
  }
};
const useHandleBrowserBackForwardButtons = (shouldRender, history) => {
  const service = useWorkflowService();
  const context = useWorkflowContext();
  const [machineConfig] = useWorkflow((store) => store.machineConfig);
  useEffect(() => {
    const handleBlockEvent = (location, action2) => {
      if (action2 === "POP") {
        maybeChangeStateBasedOnUrl(service);
      }
      return void 0;
    };
    let unblock;
    if (shouldRender) {
      unblock = history.block(handleBlockEvent);
    }
    return () => {
      unblock == null ? void 0 : unblock();
    };
  }, [
    context,
    context.workflow.history,
    history,
    machineConfig.id,
    service,
    shouldRender
  ]);
};
const CheckIfRouteNeedsToChange = withRouter(
  ({
    children: children2 = void 0,
    component = void 0,
    history,
    location
  }) => {
    const { hasSwitchedRoutes, stepHasRoute } = useStepCardChangeRoutes(
      history,
      location
    );
    const stepHasNoRoute = !stepHasRoute;
    const renderComponent2 = /* @__PURE__ */ jsxRuntimeExports.jsx(RenderComponent, { component: component || children2 });
    const shouldRender = stepHasNoRoute || hasSwitchedRoutes;
    useHandleBrowserBackForwardButtons(shouldRender, history);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: shouldRender ? renderComponent2 : null });
  }
);
const CheckForRouterBehavior = ({
  children: children2,
  hasRouterBehavior = false
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: hasRouterBehavior ? /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIfRouteNeedsToChange, { children: children2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(RenderComponent, { component: children2 }) });
};
const StepViewBase = ({
  _workflowXStateFullStateId,
  children: children2,
  component = void 0,
  displayGuard = void 0,
  entryAction = void 0,
  guard = void 0,
  name: name2,
  renderWithGroup
}) => {
  const service = useWorkflowService();
  const [path2] = useWorkflow((store) => store.path);
  const { workflowFullStateId, workflowGroupId, workflowStateId } = useWorkflowStep();
  const currentlySelectedStep = useSelector(
    service,
    currentlySelectedStepSelector
  );
  const context = useSelector(service, contextSelector);
  const stateViewData = useSelector(
    service,
    (state2) => {
      var _a2, _b;
      return (_b = (_a2 = state2.context) == null ? void 0 : _a2.workflow) == null ? void 0 : _b.stateViewData;
    }
  );
  const { updateContext: updateContext2 } = useWorkflowHelper();
  const { groupHasState, inStepViewPicker, jumpToSelf, state } = useWorkflowStepHelper(name2);
  const isCurrentlySelectedStep = currentlySelectedStep === workflowFullStateId;
  const stepViewPickerStateId = inStepViewPicker ? normalizeStateName(name2) : void 0;
  const stateView = getStateView(
    stateViewData,
    workflowFullStateId,
    stepViewPickerStateId
  );
  const isStateView = !!stateView;
  const canPassDisplayGuard2 = displayGuard ? displayGuard == null ? void 0 : displayGuard(context) : true;
  const canPassGuard2 = guard ? guard == null ? void 0 : guard(context) : true;
  if (!isStateView || !canPassDisplayGuard2) {
    return null;
  }
  if ((state || !groupHasState && canPassDisplayGuard2 && canPassGuard2) && !isCurrentlySelectedStep) {
    if (!state) {
      jumpToSelf();
    } else {
      updateContext2({
        workflow: { currentlySelectedStep: workflowFullStateId }
      });
    }
  }
  if (renderWithGroup) {
    const [group] = workflowGroupId || [];
    const currentlySelectedStepArray = currentlySelectedStep == null ? void 0 : currentlySelectedStep.split(STATE_NAME_DELIMITER);
    const isPartOfGroup = group ? currentlySelectedStepArray == null ? void 0 : currentlySelectedStepArray.includes(group) : false;
    if (group && !isPartOfGroup) {
      return null;
    }
    if (!group && !isCurrentlySelectedStep) {
      return null;
    }
  } else if (!isCurrentlySelectedStep) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    StepViewStateManager,
    {
      component,
      displayGuard,
      entryAction,
      hasRouterBehavior: !!path2,
      isCurrentlySelectedStep,
      name: name2,
      children: isCurrentlySelectedStep ? (
        // If there is a path passed into Workflow, then we need to deal with routes.
        /* @__PURE__ */ jsxRuntimeExports.jsx(CheckForRouterBehavior, { hasRouterBehavior: !!path2, children: children2 })
      ) : children2
    }
  ) });
};
const StepViewStateManager = ({
  children: children2,
  component,
  displayGuard,
  entryAction,
  hasRouterBehavior,
  isCurrentlySelectedStep,
  name: name2
}) => {
  const service = useWorkflowService();
  const { jumpToStep } = useWorkflowHelper();
  const { state } = useWorkflowStepHelper(name2);
  useEffect(() => {
    if (state === "begin") {
      if (typeof entryAction === "function") {
        entryAction({
          ctx: service.getSnapshot().context,
          jumpToStep,
          service
        });
      }
      service.send("GO_ACTIVE");
    }
  }, [entryAction, jumpToStep, service, state]);
  if (state === "begin") {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: component ? isCurrentlySelectedStep ? /* @__PURE__ */ jsxRuntimeExports.jsx(CheckForRouterBehavior, { hasRouterBehavior, children: component }) : /* @__PURE__ */ jsxRuntimeExports.jsx(RenderComponent, { component }) : children2 });
};
const getStateView = (stateViewData, workflowFullStateId, stepViewPickerStateId) => {
  const finalStateViewKey = stepViewPickerStateId ? `${workflowFullStateId}${STATE_NAME_DELIMITER}${stepViewPickerStateId}` : workflowFullStateId;
  return finalStateViewKey ? stateViewData == null ? void 0 : stateViewData[finalStateViewKey] : void 0;
};
const StepView = ({
  _workflowFullStateId,
  _workflowGroupId,
  _workflowStateId,
  _workflowXStateFullStateId,
  children: children2,
  component,
  displayGuard = void 0,
  entryAction = void 0,
  name: name2,
  relativePath = void 0,
  relativePathForGroup = void 0,
  renderWithGroup = false
}) => {
  const [service] = useWorkflow((store) => store.service);
  const [path2] = useWorkflow((store) => store.path);
  const memoizedValues = useMemo(() => {
    return {
      path: path2 || "",
      relativePath: relativePath || "",
      relativePathForGroup: relativePathForGroup || "",
      workflowFullStateId: _workflowFullStateId,
      workflowGroupId: _workflowGroupId,
      workflowStateId: _workflowStateId,
      workflowXStateGroupId: _workflowGroupId,
      workflowXStateStateId: _workflowStateId,
      workflowXStateFullStateId: _workflowXStateFullStateId
    };
  }, [
    _workflowFullStateId,
    _workflowGroupId,
    _workflowStateId,
    _workflowXStateFullStateId,
    path2,
    relativePath,
    relativePathForGroup
  ]);
  if (!service) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowStepContext.Provider, { value: memoizedValues, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    StepViewBase,
    {
      _workflowXStateFullStateId,
      component,
      displayGuard,
      entryAction,
      name: name2,
      renderWithGroup,
      children: children2
    }
  ) });
};
StepView.$$workflowType = "STEP_VIEW";
const StepViewPickerBase = ({
  _workflowXStateFullStateId,
  children: children2,
  renderWithGroup
}) => {
  const {
    workflowFullStateId,
    workflowGroupId,
    workflowStateId,
    workflowXStateFullStateId,
    workflowXStateGroupId,
    workflowXStateStateId
  } = useWorkflowStep();
  const traverse = useCallback(
    (node2) => {
      var _a2;
      if (React__default.isValidElement(node2)) {
        if (isWorkflowType(node2)) {
          return React__default.cloneElement(node2, {
            _workflowFullStateId: workflowFullStateId,
            _workflowGroupId: workflowGroupId,
            _workflowStateId: workflowStateId,
            _workflowXStateFullStateId: workflowXStateFullStateId,
            _workflowXStateGroupId: workflowXStateGroupId,
            _workflowXStateStateId: workflowXStateStateId
          });
        }
        if ((_a2 = node2 == null ? void 0 : node2.props) == null ? void 0 : _a2.children) {
          const newChildren2 = React__default.Children.map(node2.props.children, traverse);
          const newNode = React__default.cloneElement(node2, {
            ...node2.props,
            children: newChildren2,
            renderWithGroup
          });
          return newNode;
        }
      }
      return node2;
    },
    [
      renderWithGroup,
      workflowFullStateId,
      workflowGroupId,
      workflowStateId,
      workflowXStateFullStateId,
      workflowXStateGroupId,
      workflowXStateStateId
    ]
  );
  const newChildren = useMemo(
    () => React__default.Children.map(children2, traverse),
    [children2, traverse]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: newChildren });
};
const StepViewPicker = ({
  children: children2,
  relativePath = void 0,
  relativePathForGroup = void 0,
  renderWithGroup = false,
  _workflowFullStateId,
  _workflowGroupId,
  _workflowStateId,
  _workflowXStateFullStateId,
  _workflowXStateGroupId,
  _workflowXStateStateId,
  ...restOfProps
}) => {
  const [service] = useWorkflow((store) => store.service);
  const [path2] = useWorkflow((store) => store.path);
  if (!service) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    WorkflowStepContext.Provider,
    {
      value: {
        path: path2,
        relativePath,
        relativePathForGroup,
        workflowFullStateId: _workflowFullStateId,
        workflowGroupId: _workflowGroupId,
        workflowStateId: _workflowStateId,
        workflowXStateGroupId: _workflowXStateGroupId,
        workflowXStateFullStateId: _workflowXStateFullStateId,
        workflowXStateStateId: _workflowXStateStateId
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StepViewPickerBase,
        {
          _workflowXStateFullStateId,
          renderWithGroup,
          ...restOfProps,
          children: children2
        }
      )
    }
  );
};
StepViewPicker.$$workflowType = "STEP_VIEW_PICKER";
const withService = (Component2) => {
  return (props2) => {
    const [service] = useWorkflow((store) => store == null ? void 0 : store.service);
    if (!service) {
      return null;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Component2, { ...props2 });
  };
};
const WorkflowDisplayManager = withService(
  ({ attributesVisitor = void 0 }) => {
    const [initialStepperSteps, setStore] = useWorkflow(
      (store) => store.initialStepperSteps
    );
    const service = useWorkflowService();
    const context = useSelector(service, (state) => state.context);
    const [machineConfig] = useWorkflow((store) => store.machineConfig);
    const { buildStepperState, jumpToStep } = useStepper();
    const currentlySelectedStep = useSelector(
      service,
      currentlySelectedStepSelector
    );
    useEffect(() => {
      if (initialStepperSteps && initialStepperSteps.length > 0) {
        const defaultAttributeVisitor = {
          onClick: (step2, parentStep) => () => {
            const stepName = step2 == null ? void 0 : step2.name;
            const parentStepName = parentStep == null ? void 0 : parentStep.name;
            const { id: machineName } = machineConfig;
            const normalizedMachineName = normalizeStateName(machineName);
            let workflowFullStateId;
            if (!parentStepName && isGroupStep(step2)) {
              const [firstSubStep] = (step2 == null ? void 0 : step2.subSteps) || [];
              const subStepName = firstSubStep == null ? void 0 : firstSubStep.name;
              workflowFullStateId = toFullStateId(stepName, subStepName);
            } else {
              workflowFullStateId = toFullStateId(parentStepName, stepName);
            }
            if (workflowFullStateId !== currentlySelectedStep) {
              service.send(
                createJumpToStepAction(
                  normalizedMachineName,
                  workflowFullStateId
                )
              );
            }
          }
        };
        const joinedAttributeVisitor = {
          onClick: (step2, parentStep) => () => {
            var _a2, _b, _c, _d;
            (_b = (_a2 = defaultAttributeVisitor == null ? void 0 : defaultAttributeVisitor.onClick) == null ? void 0 : _a2.call(defaultAttributeVisitor, step2, parentStep)) == null ? void 0 : _b();
            (_d = (_c = attributesVisitor == null ? void 0 : attributesVisitor.onClick) == null ? void 0 : _c.call(attributesVisitor, step2, parentStep)) == null ? void 0 : _d();
          }
        };
        const stepperStepsRebuilt = rebuildStepsToDisplay(
          initialStepperSteps,
          context
        );
        const stepperIdxWorkflowIdMap = getStepperIdxMappingFromWorkflowId(stepperStepsRebuilt);
        const selectedStepperIndexes = stepperIdxWorkflowIdMap == null ? void 0 : stepperIdxWorkflowIdMap[currentlySelectedStep];
        const stepperStepsDecorated = decorateStepperSteps(
          stepperStepsRebuilt,
          joinedAttributeVisitor
        );
        setStore({
          stepperIdxWorkflowIdMap,
          stepperSteps: stepperStepsDecorated
        });
        if (!selectedStepperIndexes && !currentlySelectedStep) {
          buildStepperState(stepperStepsDecorated, 0);
        } else if (!selectedStepperIndexes) {
          buildStepperState(stepperStepsDecorated, null, null);
        } else if ((selectedStepperIndexes == null ? void 0 : selectedStepperIndexes.parentIdx) == void 0) {
          buildStepperState(stepperStepsDecorated, selectedStepperIndexes == null ? void 0 : selectedStepperIndexes.idx);
        } else {
          buildStepperState(
            stepperStepsDecorated,
            selectedStepperIndexes.parentIdx,
            selectedStepperIndexes.idx
          );
        }
      }
    }, [
      attributesVisitor,
      buildStepperState,
      context,
      jumpToStep,
      service,
      initialStepperSteps,
      machineConfig,
      setStore,
      currentlySelectedStep
    ]);
    return null;
  }
);
const canPassDisplayGuard = (item, context) => {
  const { displayGuard } = item;
  return typeof displayGuard !== "function" || displayGuard(context);
};
const canPassGuard = (item, context) => {
  if (!item) {
    return true;
  }
  const { guard } = item;
  return typeof guard !== "function" || (guard == null ? void 0 : guard(context));
};
const filterStepsPossibleThatCanBeDisplayed = (stepsPossible, context) => {
  return stepsPossible == null ? void 0 : stepsPossible.filter(
    (stepPossible) => canPassDisplayGuard(stepPossible, context)
  );
};
const filterSubStepsThatCanBeDisplayed = (subSteps, context) => {
  return subSteps == null ? void 0 : subSteps.filter((subStep) => canPassDisplayGuard(subStep, context));
};
const filterStepsThatCanBeDisplayed = (steps2, context) => {
  return steps2.filter((step2) => canPassDisplayGuard(step2, context));
};
const filterStepsPossible = (subSteps, context) => {
  return subSteps == null ? void 0 : subSteps.map((subStep) => {
    const { stepsPossible } = subStep;
    const updatedStepsPossible = flow(
      (subSteps2) => filterStepsPossibleThatCanBeDisplayed(subSteps2, context)
    )(stepsPossible);
    return { ...subStep, stepsPossible: updatedStepsPossible };
  });
};
const filterSubSteps = (steps2, context) => {
  return steps2.map((step2) => {
    const { subSteps } = step2;
    invariant$1(!!subSteps, ERROR_STEPVIEW_INSIDE_GROUP);
    const updatedSubSteps = flow(
      (subSteps2) => filterSubStepsThatCanBeDisplayed(subSteps2, context),
      (subSteps2) => filterStepsPossible(subSteps2, context),
      (subSteps2) => chooseSubStepFromStepsPossible(subSteps2),
      (subSteps2) => addLockedStates(subSteps2, context, step2)
    )(subSteps);
    return { ...step2, subSteps: updatedSubSteps };
  });
};
const updateSubStepTitles = (steps2, context, parentStep) => {
  return steps2.map((step2) => {
    const { subSteps } = step2;
    const updatedTitlesForSubSteps = subSteps == null ? void 0 : subSteps.map((subStep) => {
      const { title } = subStep;
      if (typeof title === "function") {
        return {
          ...subStep,
          // Hard coded collapsed state here. Expanded states usually have longer titles and we most likely do not want to display a long title in the Stepper. In the future, if we do want the expanded title to display in the Stepper, then we need to sync this state with some property in the `workflow` key in the context to the right subStep.
          title: title({ ctx: context, collapsed: true, expanded: false })
        };
      }
      return subStep;
    });
    return { ...step2, subSteps: updatedTitlesForSubSteps };
  });
};
const addProgressStates = (steps2, context) => {
  return steps2.map((step2) => {
    var _a2;
    const groupName = step2.name;
    const normalizedGroupId = toFullStateId(groupName);
    const isSelectingStepFromGroup = (_a2 = context.workflow.currentlySelectedStep) == null ? void 0 : _a2.match(normalizedGroupId);
    const { subSteps } = step2;
    const hasSubSteps = subSteps && Array.isArray(subSteps) && subSteps.length > 0;
    let allSubStepProgressDataExists = true;
    let allSubStepsCompleted = true;
    if (hasSubSteps) {
      subSteps.forEach((step22) => {
        var _a3;
        const stateName = step22.name;
        const normalizedStateId = toFullStateId(stateName);
        const progressData = (_a3 = context.workflow.progressData[normalizedGroupId]) == null ? void 0 : _a3[normalizedStateId];
        if (!progressData) {
          allSubStepProgressDataExists = false;
          allSubStepsCompleted = false;
        } else if (progressData !== 1) {
          allSubStepsCompleted = false;
        }
      });
    }
    const isGroupProgressComplete = hasSubSteps && allSubStepProgressDataExists && allSubStepsCompleted;
    if (!isSelectingStepFromGroup && (!allSubStepProgressDataExists || !isGroupProgressComplete)) {
      return {
        ...step2,
        state: StepState.incomplete
      };
    } else if (!isSelectingStepFromGroup && (allSubStepProgressDataExists || isGroupProgressComplete)) {
      return {
        ...step2,
        state: StepState.complete
      };
    } else {
      return step2;
    }
  });
};
const addLockedStates = (steps2, context, parentStep) => {
  return steps2 == null ? void 0 : steps2.map((step2) => {
    if (!canPassGuard(step2, context) || !canPassGuard(parentStep, context)) {
      return {
        ...step2,
        state: StepState.locked
      };
    } else {
      return step2;
    }
  });
};
const chooseSubStepFromStepsPossible = (subSteps) => {
  return subSteps == null ? void 0 : subSteps.map((subStep) => {
    const newSubStep = { ...subStep };
    const { title, stepsPossible } = newSubStep;
    if (stepsPossible == null ? void 0 : stepsPossible.length) {
      if (isDevEnvironment() && stepsPossible && (stepsPossible == null ? void 0 : stepsPossible.length) > 1) {
        throw new Error(
          `There are multiple StepViews possible for "${title}" that can be displayed in the StepViewPicker. Only the first one will be selected, please put a 'displayGuard' prop on each StepView with the right conditionals to make sure only one is displayed at a time.`
        );
      }
      const [firstStepPossible] = stepsPossible || {};
      if (firstStepPossible) {
        const { displayGuard, guard, title: title2 } = firstStepPossible;
        newSubStep.displayGuard = displayGuard;
        newSubStep.guard = guard;
        newSubStep.title = title2;
      }
      return newSubStep;
    }
    return subStep;
  });
};
const rebuildStepsToDisplay = (steps2, context) => {
  if (!steps2) {
    return [];
  }
  const newSteps = flow(
    (steps22) => filterStepsThatCanBeDisplayed(steps22, context),
    (steps22) => filterSubSteps(steps22, context),
    (steps22) => updateSubStepTitles(steps22, context),
    (steps22) => addProgressStates(steps22, context),
    (steps22) => addLockedStates(steps22, context)
  )(steps2);
  return newSteps;
};
const decorateStepperSteps = (stepperSteps, attributeVisitor) => {
  if (!stepperSteps) {
    return [];
  }
  return stepperSteps == null ? void 0 : stepperSteps.map((step2) => {
    let newStep = { ...step2 };
    const stepType = isGroupStep(newStep) ? "GroupStep" : "Step";
    if (stepType === "GroupStep") {
      const visitor = stepAndSubStepVisitor[stepType];
      newStep = visitor(newStep, attributeVisitor);
    } else {
      const visitor = stepAndSubStepVisitor[stepType];
      newStep = visitor(newStep, attributeVisitor, void 0);
    }
    return newStep;
  });
};
const availableAttributes = [
  "disabled",
  "onClick",
  "showSubSteps",
  "state",
  "title"
];
const isGroupStep = (step2) => "subSteps" in step2;
const stepAndSubStepVisitor = {
  GroupStep: (node2, attributeVisitor) => {
    var _a2;
    return {
      ...node2,
      ...traverseAttributes(node2, attributeVisitor),
      subSteps: (_a2 = node2 == null ? void 0 : node2.subSteps) == null ? void 0 : _a2.map(
        (subStep) => stepAndSubStepVisitor.Step(subStep, attributeVisitor, node2)
      )
    };
  },
  Step: (node2, attributeVisitor, parentNode) => {
    return {
      ...node2,
      ...traverseAttributes(node2, attributeVisitor, parentNode)
    };
  }
};
const traverseAttributes = (node2, attributeVisitor, parentNode) => {
  if (!node2)
    return node2;
  const attributesObj = {};
  Object.entries(attributeVisitor).forEach(([attribute, visitor]) => {
    const isAttributeKeys = (attribute2) => availableAttributes.includes(attribute2);
    if (!isAttributeKeys(attribute)) {
      throw new Error(
        `${attribute} key is not in the available attributes to be modified. These are the ones available: ${availableAttributes}`
      );
    }
    attributesObj[attribute] = visitor(node2, parentNode);
  });
  return attributesObj;
};
const ERROR_STEPVIEW_INSIDE_GROUP = "You might be using a <Workflw.StepView> that is not a child of a <Workflow.Group>. This is not currently supported. Please place the <Workflow.StepView> inside a <Workflow.Group>. ";
const DisplayStateConditionally = withService(
  ({
    children: children2,
    excludeStates,
    includeStates
  }) => {
    const stateId = useWorkflowCurrentlySelectedStep();
    const shouldExclude = excludeStates == null ? void 0 : excludeStates.includes(stateId);
    const shouldInclude = includeStates == null ? void 0 : includeStates.includes(stateId);
    if (excludeStates && shouldExclude) {
      return null;
    }
    if (includeStates && !shouldInclude) {
      return null;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children2 });
  }
);
const Aside$1 = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { as: "aside", ...props2 });
const Article = (props2) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { as: "article", ...props2 });
};
const Main$1 = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { as: "main", ...props2 });
const Footer$2 = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { as: "footer", ...props2 });
const Header$1 = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { as: "header", ...props2 });
const Section = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { as: "section", ...props2 });
const Template = (props2) => /* @__PURE__ */ jsxRuntimeExports.jsx(Grid, { display: "grid", ...props2 });
const MobileWorkflowInsight = ({
  title,
  content: content2,
  iconColor = "icon.default",
  iconName = "infoOutline",
  illustrationName = "lightbulb"
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const openSheet = useCallback(() => setIsOpen(true), [setIsOpen]);
  const closeSheet = useCallback(() => setIsOpen(false), [setIsOpen]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompoundButton,
      {
        onClick: openSheet,
        sx: { margin: -0.25, padding: 0.25 },
        variant: ButtonVariant.unstyled,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            sx: {
              paddingX: 1,
              paddingY: 0.5,
              backgroundColor: "surface.info",
              width: "fit-content",
              borderRadius: 52
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "center", spacing: 0.75, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { color: iconColor, name: iconName, size: IconSizes.Icon16 }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { variant: TitleSizes$1.Title14, children: title })
            ] })
          }
        )
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Sheet,
      {
        a11yTitle: title,
        onDismiss: closeSheet,
        open: isOpen,
        size: SheetSizes.Half,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", spacing: 1.5, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "flex-start", justify: "space-between", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Illustration, { name: illustrationName }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(
              Icon,
              {
                name: "x",
                onClick: closeSheet,
                size: IconSizes.Icon16,
                sx: { flexShrink: 0 }
              }
            )
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", spacing: 0.25, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { sx: { marginBottom: 0 }, variant: TitleSizes$1.Title14, children: title }),
            content2
          ] })
        ] })
      }
    )
  ] });
};
const WorkflowInsight = ({
  content: content2,
  iconColor = "icon.info",
  iconName = "info",
  illustrationName = void 0,
  title
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", sx: styles$5.container, children: [
    iconName && iconColor && !illustrationName ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { color: iconColor, name: iconName, size: IconSizes.Icon16 }) : null,
    illustrationName ? /* @__PURE__ */ jsxRuntimeExports.jsx(Illustration, { name: illustrationName, size: IconSizes.Icon16 }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", spacing: 0.25, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { sx: { marginBottom: 0 }, variant: TitleSizes$1.Title14, children: title }),
      content2
    ] })
  ] });
};
const styles$5 = {
  container: {
    padding: 1,
    gap: 1,
    border: "default",
    borderColor: "border.subdued",
    maxWidth: "workflowInsight.width",
    borderRadius: "workflowInsight"
  }
};
WorkflowInsight.Mobile = MobileWorkflowInsight;
const useStepCardCollapsible = (name2) => {
  const currentlySelectedStep = useWorkflowCurrentlySelectedStep();
  const { state, workflowFullStateId } = useWorkflowStepHelper(name2);
  const { collapsed, expanded, collapse, expand: expand2 } = useCollapsible();
  const isCurrentlySelectedStep = currentlySelectedStep === workflowFullStateId;
  const hasState = !!state;
  const shouldCollapse = !hasState || !isCurrentlySelectedStep;
  return {
    shouldCollapse,
    shouldExpand: !shouldCollapse,
    collapse,
    expand: expand2,
    collapsed,
    expanded
  };
};
const StepCardHeader = ({
  cardTitle = void 0,
  collapsedCardEndElement = void 0,
  guard = void 0,
  name: name2
}) => {
  const context = useWorkflowContext();
  const { collapsed, expanded } = useStepCardCollapsible(name2);
  const { jumpToSelf } = useWorkflowStepHelper(name2);
  const hasGuard2 = guard !== void 0 && guard !== null && typeof guard === "function";
  const guardOutput = (guard == null ? void 0 : guard(context)) || false;
  const canPassGuard2 = hasGuard2 ? guardOutput : true;
  const handleHeaderClick = useCallback(() => {
    if (collapsed && canPassGuard2) {
      jumpToSelf();
    }
  }, [canPassGuard2, collapsed, jumpToSelf]);
  let renderedCardTitle;
  if (typeof cardTitle === "function") {
    renderedCardTitle = cardTitle({ ctx: context, collapsed, expanded });
  } else {
    renderedCardTitle = cardTitle;
  }
  const titleElement = canPassGuard2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: renderedCardTitle }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { spacing: 1, children: [
    renderedCardTitle,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        color: "icon.subdued",
        name: "lockClosed",
        size: IconSizes.Icon16,
        sx: { alignItems: "center" }
      }
    )
  ] });
  const finalCollasedCardEndElement = typeof collapsedCardEndElement === "function" ? collapsedCardEndElement({ context }) : collapsedCardEndElement;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Card2.Header,
    {
      canCollapseCard: CardHeaderCollapsibleStatus.ToggleOnHeader,
      disabled: expanded || collapsed && !canPassGuard2,
      onClick: handleHeaderClick,
      rightContent: finalCollasedCardEndElement,
      sx: {
        ...expanded && { cursor: "default", pointerEvents: "none" },
        ...collapsed && !canPassGuard2 && {
          cursor: "default",
          pointerEvents: "none"
        },
        ...collapsed && {
          width: "100%"
        }
      },
      title: titleElement
    }
  );
};
const RenderWhenCardExpanded = ({
  children: children2 = void 0,
  component = void 0,
  name: name2
}) => {
  invariant$1(
    children2 !== void 0 || component !== void 0,
    "At least one of 'children' or 'component' must be defined."
  );
  const { shouldExpand } = useStepCardCollapsible(name2);
  const shouldRender = shouldExpand;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: shouldRender ? component || children2 : null });
};
const StepCardBackButton = ({
  dataTestId = "stepcard-back-button"
}) => {
  const { fromStep, goToPreviousStep, hasPreviousStep } = useWorkflowStepperNavigation();
  const service = useWorkflowService();
  const currentlySelectedStep = useSelector(
    service,
    currentlySelectedStepSelector
  );
  const [internalCurrentlySelectedStep] = useState(currentlySelectedStep);
  const handleClick = useCallback(
    () => goToPreviousStep == null ? void 0 : goToPreviousStep(),
    [goToPreviousStep]
  );
  const {
    matchMediaQuery: { mdDown }
  } = useMatchMedia();
  if (internalCurrentlySelectedStep !== fromStep || mdDown) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: hasPreviousStep ? /* @__PURE__ */ jsxRuntimeExports.jsx(BackButton, { "data-test-id": dataTestId, onClick: handleClick }) : null });
};
const FooterBegin = ({
  element,
  name: name2
}) => {
  const context = useWorkflowContext();
  const { finalFormId } = useGetDerivedFormProps(name2);
  const backButtonElement = /* @__PURE__ */ jsxRuntimeExports.jsx(StepCardBackButton, { dataTestId: `${finalFormId}-back-button` });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: typeof element === "function" ? element == null ? void 0 : element({ backButtonElement, ctx: context }) : backButtonElement });
};
const FooterEnd = ({
  configContinue = {},
  evaluateProgress = void 0,
  element = void 0,
  name: name2
}) => {
  const service = useWorkflowService();
  const context = useWorkflowContext();
  const { finalFormId, hasGuiForm } = useGetDerivedFormProps(name2);
  const {
    isSubmittingState,
    isSuccessState,
    isSuccessPreActionRunState,
    isSuccessCustomActionRunState,
    isSuccessActionRunState,
    setProgress,
    setSuccessState,
    workflowFullStateId
  } = useWorkflowStepHelper(name2);
  const { goToNextStep } = useWorkflowStepperNavigation();
  const defaultButtonProps = { dataTestId: `${finalFormId}-submit-button` };
  const {
    buttonText,
    buttonGuard,
    onContinue,
    buttonProps = defaultButtonProps
  } = configContinue;
  const canContinue = buttonGuard ? buttonGuard(context) : true;
  const { jumpToStep } = useWorkflowHelper();
  const finalButtonText = getButtonText({ buttonText, ctx: context });
  const finalButtonProps = getButtonProps({
    buttonProps,
    ctx: context,
    defaults: defaultButtonProps
  });
  const continueActions = useCallback(
    (event2) => {
      onContinue == null ? void 0 : onContinue(event2, {
        ctx: context,
        goToNextStep,
        jumpToStep,
        service,
        setProgress
      });
    },
    [context, goToNextStep, jumpToStep, onContinue, service, setProgress]
  );
  useEffect(() => {
    if (isSuccessState) {
      if (!canContinue && isDevEnvironment()) {
        console.error("Can't continue because buttonGuard returned false.");
      }
      if (isSuccessPreActionRunState) {
        const progressNumber = evaluateProgress == null ? void 0 : evaluateProgress(context);
        progressNumber != void 0 && (setProgress == null ? void 0 : setProgress(progressNumber));
        service.send("DONE", {
          customAction: onContinue
        });
      }
      if (isSuccessCustomActionRunState) {
        continueActions();
        service.send("DONE");
      }
      if (isSuccessActionRunState) {
        goToNextStep == null ? void 0 : goToNextStep();
        service.send("DONE");
      }
    }
  }, [
    canContinue,
    context,
    continueActions,
    evaluateProgress,
    goToNextStep,
    isSuccessActionRunState,
    isSuccessCustomActionRunState,
    isSuccessPreActionRunState,
    isSuccessState,
    onContinue,
    service,
    setProgress,
    workflowFullStateId
  ]);
  const submitOnClick = useCallback(
    (_) => setSuccessState(),
    [setSuccessState]
  );
  const continueButtonElement = useMemo(
    () => /* @__PURE__ */ jsxRuntimeExports.jsx(
      Submit,
      {
        "data-test-id": finalButtonProps == null ? void 0 : finalButtonProps.dataTestId,
        disabled: !canContinue,
        form: finalFormId,
        isLoading: isSubmittingState,
        label: finalButtonText || "Save and continue",
        onClick: hasGuiForm ? void 0 : submitOnClick,
        sx: {
          width: buildResponsiveValues({ mdDown: "100%", lgUp: "initial" })
        },
        ...finalButtonProps
      }
    ),
    [
      finalButtonText,
      finalButtonProps,
      canContinue,
      finalFormId,
      hasGuiForm,
      isSubmittingState,
      submitOnClick
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: typeof element === "function" ? element == null ? void 0 : element({ continueButtonElement, ctx: context }) : continueButtonElement });
};
const getButtonText = ({
  buttonText,
  ctx: ctx2
}) => {
  if (!buttonText) {
    return void 0;
  }
  if (typeof buttonText === "function") {
    return buttonText(ctx2);
  }
  return buttonText;
};
const getButtonProps = ({
  buttonProps,
  ctx: ctx2,
  defaults: defaults2
}) => {
  if (!buttonProps) {
    return void 0;
  }
  if (typeof buttonProps === "function") {
    return buttonProps(ctx2);
  }
  return { ...defaults2, ...buttonProps };
};
const useStepCardCollapseExpand = (name2) => {
  const { shouldCollapse } = useStepCardCollapsible(name2);
  const { collapse, expand: expand2 } = useCollapsible();
  useEffect(() => {
    if (shouldCollapse) {
      collapse();
    } else {
      expand2();
    }
  }, [collapse, expand2, shouldCollapse]);
  return null;
};
function isInViewport(element, opts = { partiallyVisible: false }) {
  if (!element) {
    return false;
  }
  const rect = element == null ? void 0 : element.getBoundingClientRect();
  const windowHeight = (window == null ? void 0 : window.innerHeight) || (document == null ? void 0 : document.documentElement.clientHeight);
  const windowWidth = (window == null ? void 0 : window.innerWidth) || (document == null ? void 0 : document.documentElement.clientWidth);
  if (rect && windowHeight && windowWidth) {
    if (opts.partiallyVisible) {
      const verticalInView = rect.top <= windowHeight && rect.top >= 0 || rect.bottom <= windowHeight && rect.bottom >= 0;
      const horizontal = rect.left <= windowWidth && rect.left >= 0 || rect.right <= windowWidth && rect.right >= 0;
      return verticalInView && horizontal;
    } else {
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= windowHeight && rect.right <= windowWidth;
    }
  }
  return false;
}
const useScrollIntoView = ({
  delayScroll = 0,
  scrollOnlyIfHidden = false,
  scrollIntoViewOptions = void 0,
  scrollWhen = true,
  _isInViewPort = isInViewport
}) => {
  const ref2 = useRef(null);
  useEffect(() => {
    let timeoutId;
    if (scrollWhen) {
      timeoutId = setTimeout(() => {
        const { current } = ref2;
        if (current) {
          const scrollIfNotInViewPort = scrollOnlyIfHidden && !_isInViewPort(current);
          const alwaysScroll = !scrollOnlyIfHidden;
          if (alwaysScroll || scrollIfNotInViewPort) {
            current.scrollIntoView(scrollIntoViewOptions);
          }
        }
      }, delayScroll);
    }
    return () => clearTimeout(timeoutId);
  }, []);
  return ref2;
};
const StepCardCollapsible = ({
  cardTitle = void 0,
  component = void 0,
  configContinue = void 0,
  evaluateProgress = void 0,
  footerBeginElement = void 0,
  footerEndElement = void 0,
  guard = void 0,
  insightCardProps = void 0,
  collapsedCardEndElement = void 0,
  name: name2
}) => {
  var _a2, _b;
  const [uiConfig] = useWorkflow((store) => store.uiConfig);
  const animateCollapsibleContent = (_a2 = uiConfig == null ? void 0 : uiConfig.stepCards) == null ? void 0 : _a2.animateCollapsibleContent;
  const scrollIntoViewAlways = (_b = uiConfig == null ? void 0 : uiConfig.stepCards) == null ? void 0 : _b.scrollIntoViewAlways;
  const { isActiveState } = useWorkflowStepHelper();
  const stepCardRef = useScrollIntoView({
    scrollWhen: isActiveState,
    delayScroll: 10,
    scrollIntoViewOptions: { behavior: "smooth", block: "start" },
    scrollOnlyIfHidden: !scrollIntoViewAlways
  });
  useStepCardCollapseExpand(name2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      ref: stepCardRef,
      sx: {
        scrollMarginTop: (theme2) => asExactTheme(theme2).space.templates.workflow.main.paddingTop
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          StepCardHeader,
          {
            cardTitle,
            collapsedCardEndElement,
            guard,
            name: name2
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Collapsible.Content,
          {
            animate: animateCollapsibleContent,
            sx: { flexDirection: "column" },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Card2.Content, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderWhenCardExpanded, { name: name2, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(RenderComponent, { component }),
                insightCardProps ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Box,
                  {
                    sx: {
                      display: buildResponsiveValues({
                        mdDown: "flex",
                        lgUp: "none"
                      }),
                      mb: buildResponsiveValues({ mdDown: 1 })
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      WorkflowInsight.Mobile,
                      {
                        content: insightCardProps == null ? void 0 : insightCardProps.content,
                        title: insightCardProps == null ? void 0 : insightCardProps.title
                      }
                    )
                  }
                ) : null
              ] }) }) }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(Card2.Footer, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
                Flex,
                {
                  justifyContent: "space-between",
                  sx: {
                    flexDirection: buildResponsiveValues({
                      mdDown: "column-reverse",
                      lgUp: "initial"
                    }),
                    width: "100%"
                  },
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Stack$3,
                      {
                        direction: buildResponsiveValues({
                          mdDown: "column-reverse",
                          lgUp: "row"
                        }),
                        sx: {
                          gap: 0.75,
                          marginTop: buildResponsiveValues({
                            mdDown: footerBeginElement ? 0.75 : 0,
                            lgUp: 0
                          })
                        },
                        children: /* @__PURE__ */ jsxRuntimeExports.jsx(FooterBegin, { element: footerBeginElement, name: name2 })
                      }
                    ),
                    /* @__PURE__ */ jsxRuntimeExports.jsx(
                      Stack$3,
                      {
                        direction: buildResponsiveValues({
                          mdDown: "column-reverse",
                          lgUp: "row"
                        }),
                        spacing: 0.75,
                        children: /* @__PURE__ */ jsxRuntimeExports.jsx(RenderWhenCardExpanded, { name: name2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                          FooterEnd,
                          {
                            configContinue,
                            element: footerEndElement,
                            evaluateProgress,
                            name: name2
                          }
                        ) })
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        )
      ]
    }
  );
};
const StepCardInsightDesktop = ({ content: content2, title }) => {
  const [stepperIdxWorkflowIdMap] = useWorkflow(
    (store) => store.stepperIdxWorkflowIdMap
  );
  const { workflowFullStateId } = useWorkflowStepHelper();
  const stepData = workflowFullStateId ? stepperIdxWorkflowIdMap == null ? void 0 : stepperIdxWorkflowIdMap[workflowFullStateId] : { idx: 0, totalSiblingSteps: 0 };
  const { idx, totalSiblingSteps } = stepData || {};
  const hasData = typeof idx === "number" && typeof totalSiblingSteps === "number";
  const gridIndex = hasData && idx + 1;
  const gridTotal = hasData && totalSiblingSteps + 1;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Article,
    {
      gridColumn: "10/13",
      ...hasData && {
        gridRow: `${gridIndex}/${gridTotal}`
      },
      sx: {
        display: buildResponsiveValues({
          mdDown: "none",
          lgUp: "block"
        })
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowInsight, { content: content2, title })
    }
  );
};
const StepCardBase = ({
  collapsedCardEndElement = void 0,
  configContinue = {},
  component = void 0,
  evaluateProgress = void 0,
  footerBeginElement = void 0,
  footerEndElement = void 0,
  guard,
  insightCardProps,
  name: name2,
  title
}) => {
  const { state } = useWorkflowStepHelper(name2);
  const hasState = !!state;
  const shouldCollapse = !hasState;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Article,
      {
        gridColumn: buildResponsiveValues({
          mdDown: "1 / -1",
          lgUp: "1 / span 9"
        }),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Collapsible, { initiallyCollapsed: shouldCollapse, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Card2, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          StepCardCollapsible,
          {
            cardTitle: title || name2,
            collapsedCardEndElement,
            component,
            configContinue,
            evaluateProgress,
            footerBeginElement,
            footerEndElement,
            guard,
            insightCardProps,
            name: name2
          }
        ) }) })
      }
    ),
    insightCardProps && !shouldCollapse ? /* @__PURE__ */ jsxRuntimeExports.jsx(
      StepCardInsightDesktop,
      {
        content: insightCardProps == null ? void 0 : insightCardProps.content,
        title: insightCardProps == null ? void 0 : insightCardProps.title
      }
    ) : null
  ] });
};
const StepCard = ({
  collapsedCardEndElement = void 0,
  component = void 0,
  displayGuard = void 0,
  entryAction = void 0,
  evaluateProgress = () => 1,
  footerEndElement = void 0,
  insightCardProps = void 0,
  name: name2,
  relativePath = void 0,
  renderWithGroup = true,
  relativePathForGroup = void 0,
  title,
  _workflowFullStateId,
  _workflowGroupId,
  _workflowStateId,
  _workflowXStateFullStateId,
  _workflowXStateGroupId,
  _workflowXStateStateId,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    StepView,
    {
      _workflowFullStateId,
      _workflowGroupId,
      _workflowStateId,
      _workflowXStateFullStateId,
      _workflowXStateGroupId,
      _workflowXStateStateId,
      displayGuard,
      entryAction,
      name: name2,
      relativePath,
      relativePathForGroup,
      renderWithGroup,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        StepCardBase,
        {
          collapsedCardEndElement,
          component,
          evaluateProgress,
          footerEndElement,
          insightCardProps,
          name: name2,
          title,
          ...restOfProps
        }
      )
    }
  );
};
StepCard.$$workflowType = "STEP_VIEW";
const WorkflowMobileBackButton = ({
  ariaLabel = "Go to previous step"
}) => {
  const { goToPreviousStep, hasPreviousStep } = useWorkflowStepperNavigation();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", children: [
    hasPreviousStep && /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        "aria-label": ariaLabel,
        name: "arrowLeft",
        onClick: () => {
          if (goToPreviousStep) {
            goToPreviousStep();
          }
        },
        size: IconSizes.Icon16
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StepperMobileTitle, {})
  ] });
};
const WorkflowStepper = withService(
  ({
    showSubSteps = false
  }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex,
      {
        flex: "1 1 auto",
        sx: {
          paddingLeft: 2,
          paddingRight: 1.5,
          paddingY: "40px",
          height: "100%"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Stepper, { nonLinear: true, showSubSteps, titleAs: "h2" })
      }
    );
  }
);
const Workflow = ({
  children: children2,
  machineType = void 0,
  ...workflowProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StepperProvider, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowDisplayManager, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowBase, { machineType, ...workflowProps, children: children2 })
  ] }) });
};
Workflow.Group = Group;
Workflow.Step = Step$1;
Workflow.StepView = StepView;
Workflow.StepViewPicker = StepViewPicker;
const WorkflowDebug = withService(() => {
  const [machineConfig] = useWorkflow((store) => store.machineConfig);
  console.log("Machine Config:", machineConfig);
  const machineConfigString = JSON.stringify(machineConfig);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        // backgroundColor: "black",
        bottom: 0,
        left: 0,
        position: "absolute"
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { style: { width: "10rem", overflowX: "auto" }, children: machineConfigString })
    }
  );
});
const UnorderedList = React__default.forwardRef(
  ({
    children: children2,
    className = void 0,
    color: color2 = TextColors.primary,
    sx: sx2 = {}
  }, ref2) => {
    const listItems = children2 instanceof Array ? children2 : [children2];
    const { style: style2 } = useStyle(sx2);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { as: "ul", className, color: color2, ref: ref2, sx: style2(), children: listItems.map(
      (listItem2, i2) => React__default.cloneElement(listItem2, {
        key: i2,
        color: color2
      })
    ) });
  }
);
const linear$2 = (t2) => +t2;
function quadIn(t2) {
  return t2 * t2;
}
function quadOut(t2) {
  return t2 * (2 - t2);
}
function quadInOut(t2) {
  return ((t2 *= 2) <= 1 ? t2 * t2 : --t2 * (2 - t2) + 1) / 2;
}
function cubicIn(t2) {
  return t2 * t2 * t2;
}
function cubicOut(t2) {
  return --t2 * t2 * t2 + 1;
}
function cubicInOut(t2) {
  return ((t2 *= 2) <= 1 ? t2 * t2 * t2 : (t2 -= 2) * t2 * t2 + 2) / 2;
}
var exponent$1 = 3;
var polyIn = function custom(e3) {
  e3 = +e3;
  function polyIn2(t2) {
    return Math.pow(t2, e3);
  }
  polyIn2.exponent = custom;
  return polyIn2;
}(exponent$1);
var polyOut = function custom2(e3) {
  e3 = +e3;
  function polyOut2(t2) {
    return 1 - Math.pow(1 - t2, e3);
  }
  polyOut2.exponent = custom2;
  return polyOut2;
}(exponent$1);
var polyInOut = function custom3(e3) {
  e3 = +e3;
  function polyInOut2(t2) {
    return ((t2 *= 2) <= 1 ? Math.pow(t2, e3) : 2 - Math.pow(2 - t2, e3)) / 2;
  }
  polyInOut2.exponent = custom3;
  return polyInOut2;
}(exponent$1);
var pi$2 = Math.PI, halfPi$1 = pi$2 / 2;
function sinIn(t2) {
  return +t2 === 1 ? 1 : 1 - Math.cos(t2 * halfPi$1);
}
function sinOut(t2) {
  return Math.sin(t2 * halfPi$1);
}
function sinInOut(t2) {
  return (1 - Math.cos(pi$2 * t2)) / 2;
}
function tpmt(x3) {
  return (Math.pow(2, -10 * x3) - 9765625e-10) * 1.0009775171065494;
}
function expIn(t2) {
  return tpmt(1 - +t2);
}
function expOut(t2) {
  return 1 - tpmt(t2);
}
function expInOut(t2) {
  return ((t2 *= 2) <= 1 ? tpmt(1 - t2) : 2 - tpmt(t2 - 1)) / 2;
}
function circleIn(t2) {
  return 1 - Math.sqrt(1 - t2 * t2);
}
function circleOut(t2) {
  return Math.sqrt(1 - --t2 * t2);
}
function circleInOut(t2) {
  return ((t2 *= 2) <= 1 ? 1 - Math.sqrt(1 - t2 * t2) : Math.sqrt(1 - (t2 -= 2) * t2) + 1) / 2;
}
var b1 = 4 / 11, b2 = 6 / 11, b3 = 8 / 11, b4 = 3 / 4, b5 = 9 / 11, b6 = 10 / 11, b7 = 15 / 16, b8 = 21 / 22, b9 = 63 / 64, b0 = 1 / b1 / b1;
function bounceIn(t2) {
  return 1 - bounceOut(1 - t2);
}
function bounceOut(t2) {
  return (t2 = +t2) < b1 ? b0 * t2 * t2 : t2 < b3 ? b0 * (t2 -= b2) * t2 + b4 : t2 < b6 ? b0 * (t2 -= b5) * t2 + b7 : b0 * (t2 -= b8) * t2 + b9;
}
function bounceInOut(t2) {
  return ((t2 *= 2) <= 1 ? 1 - bounceOut(1 - t2) : bounceOut(t2 - 1) + 1) / 2;
}
var overshoot = 1.70158;
var backIn = function custom4(s4) {
  s4 = +s4;
  function backIn2(t2) {
    return (t2 = +t2) * t2 * (s4 * (t2 - 1) + t2);
  }
  backIn2.overshoot = custom4;
  return backIn2;
}(overshoot);
var backOut = function custom5(s4) {
  s4 = +s4;
  function backOut2(t2) {
    return --t2 * t2 * ((t2 + 1) * s4 + t2) + 1;
  }
  backOut2.overshoot = custom5;
  return backOut2;
}(overshoot);
var backInOut = function custom6(s4) {
  s4 = +s4;
  function backInOut2(t2) {
    return ((t2 *= 2) < 1 ? t2 * t2 * ((s4 + 1) * t2 - s4) : (t2 -= 2) * t2 * ((s4 + 1) * t2 + s4) + 2) / 2;
  }
  backInOut2.overshoot = custom6;
  return backInOut2;
}(overshoot);
var tau$2 = 2 * Math.PI, amplitude = 1, period = 0.3;
var elasticIn = function custom7(a4, p) {
  var s4 = Math.asin(1 / (a4 = Math.max(1, a4))) * (p /= tau$2);
  function elasticIn2(t2) {
    return a4 * tpmt(- --t2) * Math.sin((s4 - t2) / p);
  }
  elasticIn2.amplitude = function(a5) {
    return custom7(a5, p * tau$2);
  };
  elasticIn2.period = function(p2) {
    return custom7(a4, p2);
  };
  return elasticIn2;
}(amplitude, period);
var elasticOut = function custom8(a4, p) {
  var s4 = Math.asin(1 / (a4 = Math.max(1, a4))) * (p /= tau$2);
  function elasticOut2(t2) {
    return 1 - a4 * tpmt(t2 = +t2) * Math.sin((t2 + s4) / p);
  }
  elasticOut2.amplitude = function(a5) {
    return custom8(a5, p * tau$2);
  };
  elasticOut2.period = function(p2) {
    return custom8(a4, p2);
  };
  return elasticOut2;
}(amplitude, period);
var elasticInOut = function custom9(a4, p) {
  var s4 = Math.asin(1 / (a4 = Math.max(1, a4))) * (p /= tau$2);
  function elasticInOut2(t2) {
    return ((t2 = t2 * 2 - 1) < 0 ? a4 * tpmt(-t2) * Math.sin((s4 - t2) / p) : 2 - a4 * tpmt(t2) * Math.sin((s4 + t2) / p)) / 2;
  }
  elasticInOut2.amplitude = function(a5) {
    return custom9(a5, p * tau$2);
  };
  elasticInOut2.period = function(p2) {
    return custom9(a4, p2);
  };
  return elasticInOut2;
}(amplitude, period);
const d3Ease = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  easeBack: backInOut,
  easeBackIn: backIn,
  easeBackInOut: backInOut,
  easeBackOut: backOut,
  easeBounce: bounceOut,
  easeBounceIn: bounceIn,
  easeBounceInOut: bounceInOut,
  easeBounceOut: bounceOut,
  easeCircle: circleInOut,
  easeCircleIn: circleIn,
  easeCircleInOut: circleInOut,
  easeCircleOut: circleOut,
  easeCubic: cubicInOut,
  easeCubicIn: cubicIn,
  easeCubicInOut: cubicInOut,
  easeCubicOut: cubicOut,
  easeElastic: elasticOut,
  easeElasticIn: elasticIn,
  easeElasticInOut: elasticInOut,
  easeElasticOut: elasticOut,
  easeExp: expInOut,
  easeExpIn: expIn,
  easeExpInOut: expInOut,
  easeExpOut: expOut,
  easeLinear: linear$2,
  easePoly: polyInOut,
  easePolyIn: polyIn,
  easePolyInOut: polyInOut,
  easePolyOut: polyOut,
  easeQuad: quadInOut,
  easeQuadIn: quadIn,
  easeQuadInOut: quadInOut,
  easeQuadOut: quadOut,
  easeSin: sinInOut,
  easeSinIn: sinIn,
  easeSinInOut: sinInOut,
  easeSinOut: sinOut
}, Symbol.toStringTag, { value: "Module" }));
function arrayMap$3(array2, iteratee) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, result = Array(length2);
  while (++index2 < length2) {
    result[index2] = iteratee(array2[index2], index2, array2);
  }
  return result;
}
var _arrayMap = arrayMap$3;
var isArray$d = Array.isArray;
var isArray_1 = isArray$d;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$9 = freeGlobal || freeSelf || Function("return this")();
var _root = root$9;
var root$8 = _root;
var Symbol$7 = root$8.Symbol;
var _Symbol = Symbol$7;
var Symbol$6 = _Symbol;
var objectProto$g = Object.prototype;
var hasOwnProperty$e = objectProto$g.hasOwnProperty;
var nativeObjectToString$1 = objectProto$g.toString;
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$e.call(value, symToStringTag$1), tag2 = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e3) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag2;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$f = Object.prototype;
var nativeObjectToString = objectProto$f.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$8(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$8;
function isObjectLike$8(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$8;
var baseGetTag$7 = _baseGetTag, isObjectLike$7 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$5(value) {
  return typeof value == "symbol" || isObjectLike$7(value) && baseGetTag$7(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$5;
var isArray$c = isArray_1, isSymbol$4 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object2) {
  if (isArray$c(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object2 != null && value in Object(object2);
}
var _isKey = isKey$3;
function isObject$b(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$b;
const _isObject = /* @__PURE__ */ getDefaultExportFromCjs(isObject_1);
var baseGetTag$6 = _baseGetTag, isObject$a = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$4(value) {
  if (!isObject$a(value)) {
    return false;
  }
  var tag2 = baseGetTag$6(value);
  return tag2 == funcTag$1 || tag2 == genTag || tag2 == asyncTag || tag2 == proxyTag;
}
var isFunction_1 = isFunction$4;
var root$7 = _root;
var coreJsData$1 = root$7["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e3) {
    }
    try {
      return func + "";
    } catch (e3) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$3 = isFunction_1, isMasked = _isMasked, isObject$9 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$e = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$d = objectProto$e.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$d).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$9(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object2, key) {
  return object2 == null ? void 0 : object2[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue2 = _getValue;
function getNative$7(object2, key) {
  var value = getValue2(object2, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;
var nativeCreate$4 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$d = Object.prototype;
var hasOwnProperty$c = objectProto$d.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$c.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$c = Object.prototype;
var hasOwnProperty$b = objectProto$c.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$b.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries6) {
  var index2 = -1, length2 = entries6 == null ? 0 : entries6.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries6[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$6(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$6;
var eq$5 = eq_1;
function assocIndexOf$4(array2, key) {
  var length2 = array2.length;
  while (length2--) {
    if (eq$5(array2[length2][0], key)) {
      return length2;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index2 = assocIndexOf$2(data, key);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key);
  if (index2 < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries6) {
  var index2 = -1, length2 = entries6 == null ? 0 : entries6.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries6[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative, root$6 = _root;
var Map$4 = getNative$5(root$6, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map2, key) {
  var data = map2.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries6) {
  var index2 = -1, length2 = entries6 == null ? 0 : entries6.length;
  this.clear();
  while (++index2 < length2) {
    var entry = entries6[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT$3 = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
const _memoize = /* @__PURE__ */ getDefaultExportFromCjs(memoize_1);
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string2) {
  var result = [];
  if (string2.charCodeAt(0) === 46) {
    result.push("");
  }
  string2.replace(rePropName, function(match2, number2, quote2, subString) {
    result.push(quote2 ? subString.replace(reEscapeChar, "$1") : number2 || match2);
  });
  return result;
});
var _stringToPath = stringToPath$1;
var Symbol$4 = _Symbol, arrayMap$2 = _arrayMap, isArray$b = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$2 = 1 / 0;
var symbolProto$1 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$b(value)) {
    return arrayMap$2(value, baseToString$1) + "";
  }
  if (isSymbol$3(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$4(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$4;
var isArray$a = isArray_1, isKey$2 = _isKey, stringToPath2 = _stringToPath, toString$3 = toString_1;
function castPath$4(value, object2) {
  if (isArray$a(value)) {
    return value;
  }
  return isKey$2(value, object2) ? [value] : stringToPath2(toString$3(value));
}
var _castPath = castPath$4;
var isSymbol$2 = isSymbol_1;
var INFINITY$1 = 1 / 0;
function toKey$5(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _toKey = toKey$5;
var castPath$3 = _castPath, toKey$4 = _toKey;
function baseGet$4(object2, path2) {
  path2 = castPath$3(path2, object2);
  var index2 = 0, length2 = path2.length;
  while (object2 != null && index2 < length2) {
    object2 = object2[toKey$4(path2[index2++])];
  }
  return index2 && index2 == length2 ? object2 : void 0;
}
var _baseGet = baseGet$4;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(entries6) {
  var data = this.__data__ = new ListCache(entries6);
  this.size = data.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype["delete"] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values6) {
  var index2 = -1, length2 = values6 == null ? 0 : values6.length;
  this.__data__ = new MapCache();
  while (++index2 < length2) {
    this.add(values6[index2]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$1(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$2(cache2, key) {
  return cache2.has(key);
}
var _cacheHas = cacheHas$2;
var SetCache$1 = _SetCache, arraySome = _arraySome, cacheHas$1 = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array2.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack2.get(array2);
  var othStacked = stack2.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array2;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
  stack2.set(array2, other);
  stack2.set(other, array2);
  while (++index2 < arrLength) {
    var arrValue = array2[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array2, stack2) : customizer(arrValue, othValue, index2, array2, other, stack2);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas$1(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack2))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack2))) {
      result = false;
      break;
    }
  }
  stack2["delete"](array2);
  stack2["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$5 = _root;
var Uint8Array$2 = root$5.Uint8Array;
var _Uint8Array = Uint8Array$2;
function mapToArray$1(map2) {
  var index2 = -1, result = Array(map2.size);
  map2.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$3(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$3;
var Symbol$3 = _Symbol, Uint8Array$1 = _Uint8Array, eq$4 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag$1 = "[object Boolean]", dateTag$2 = "[object Date]", errorTag$1 = "[object Error]", mapTag$3 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$2 = "[object RegExp]", setTag$3 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$3 ? Symbol$3.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object2, other, tag2, bitmask, customizer, equalFunc, stack2) {
  switch (tag2) {
    case dataViewTag$2:
      if (object2.byteLength != other.byteLength || object2.byteOffset != other.byteOffset) {
        return false;
      }
      object2 = object2.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object2.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object2), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$2:
    case numberTag$1:
      return eq$4(+object2, +other);
    case errorTag$1:
      return object2.name == other.name && object2.message == other.message;
    case regexpTag$2:
    case stringTag$1:
      return object2 == other + "";
    case mapTag$3:
      var convert = mapToArray;
    case setTag$3:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);
      if (object2.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack2.get(object2);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack2.set(object2, other);
      var result = equalArrays$1(convert(object2), convert(other), bitmask, customizer, equalFunc, stack2);
      stack2["delete"](object2);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object2) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$3(array2, values6) {
  var index2 = -1, length2 = values6.length, offset2 = array2.length;
  while (++index2 < length2) {
    array2[offset2 + index2] = values6[index2];
  }
  return array2;
}
var _arrayPush = arrayPush$3;
var arrayPush$2 = _arrayPush, isArray$9 = isArray_1;
function baseGetAllKeys$2(object2, keysFunc, symbolsFunc) {
  var result = keysFunc(object2);
  return isArray$9(object2) ? result : arrayPush$2(result, symbolsFunc(object2));
}
var _baseGetAllKeys = baseGetAllKeys$2;
function arrayFilter$1(array2, predicate) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2];
    if (predicate(value, index2, array2)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$2() {
  return [];
}
var stubArray_1 = stubArray$2;
var arrayFilter = _arrayFilter, stubArray$1 = stubArray_1;
var objectProto$b = Object.prototype;
var propertyIsEnumerable$1 = objectProto$b.propertyIsEnumerable;
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;
var getSymbols$2 = !nativeGetSymbols$1 ? stubArray$1 : function(object2) {
  if (object2 == null) {
    return [];
  }
  object2 = Object(object2);
  return arrayFilter(nativeGetSymbols$1(object2), function(symbol) {
    return propertyIsEnumerable$1.call(object2, symbol);
  });
};
var _getSymbols = getSymbols$2;
function baseTimes$1(n, iteratee) {
  var index2 = -1, result = Array(n);
  while (++index2 < n) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var baseGetTag$5 = _baseGetTag, isObjectLike$6 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$6(value) && baseGetTag$5(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$5 = isObjectLike_1;
var objectProto$a = Object.prototype;
var hasOwnProperty$a = objectProto$a.hasOwnProperty;
var propertyIsEnumerable = objectProto$a.propertyIsEnumerable;
var isArguments$4 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$5(value) && hasOwnProperty$a.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$4;
var isBuffer$4 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$4.exports;
(function(module2, exports2) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var Buffer2 = moduleExports2 ? root2.Buffer : void 0;
  var nativeIsBuffer2 = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer2 || stubFalse2;
  module2.exports = isBuffer2;
})(isBuffer$4, isBuffer$4.exports);
var isBufferExports = isBuffer$4.exports;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$4(value, length2) {
  var type2 = typeof value;
  length2 = length2 == null ? MAX_SAFE_INTEGER$1 : length2;
  return !!length2 && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
}
var _isIndex = isIndex$4;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$3;
var baseGetTag$4 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$4 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag$1 = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag = "[object Number]", objectTag$3 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$4(value) && isLength$2(value.length) && !!typedArrayTags[baseGetTag$4(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$4(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$4;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module2, exports2) {
  var freeGlobal2 = _freeGlobal;
  var freeExports2 = exports2 && !exports2.nodeType && exports2;
  var freeModule2 = freeExports2 && true && module2 && !module2.nodeType && module2;
  var moduleExports2 = freeModule2 && freeModule2.exports === freeExports2;
  var freeProcess2 = moduleExports2 && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types2 = freeModule2 && freeModule2.require && freeModule2.require("util").types;
      if (types2) {
        return types2;
      }
      return freeProcess2 && freeProcess2.binding && freeProcess2.binding("util");
    } catch (e3) {
    }
  }();
  module2.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary$3 = _baseUnary, nodeUtil$2 = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;
var isTypedArray$4 = nodeIsTypedArray ? baseUnary$3(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$4;
var baseTimes = _baseTimes, isArguments$3 = isArguments_1, isArray$8 = isArray_1, isBuffer$3 = isBufferExports, isIndex$3 = _isIndex, isTypedArray$3 = isTypedArray_1;
var objectProto$9 = Object.prototype;
var hasOwnProperty$9 = objectProto$9.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$8(value), isArg = !isArr && isArguments$3(value), isBuff = !isArr && !isArg && isBuffer$3(value), isType = !isArr && !isArg && !isBuff && isTypedArray$3(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$9.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex$3(key, length2)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;
var objectProto$8 = Object.prototype;
function isPrototype$3(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$8;
  return value === proto;
}
var _isPrototype = isPrototype$3;
function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var nativeKeys$1 = overArg$1(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype$2 = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$7 = Object.prototype;
var hasOwnProperty$8 = objectProto$7.hasOwnProperty;
function baseKeys$2(object2) {
  if (!isPrototype$2(object2)) {
    return nativeKeys(object2);
  }
  var result = [];
  for (var key in Object(object2)) {
    if (hasOwnProperty$8.call(object2, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$2;
var isFunction$2 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$6(value) {
  return value != null && isLength$1(value.length) && !isFunction$2(value);
}
var isArrayLike_1 = isArrayLike$6;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeys$1 = _baseKeys, isArrayLike$5 = isArrayLike_1;
function keys$3(object2) {
  return isArrayLike$5(object2) ? arrayLikeKeys$1(object2) : baseKeys$1(object2);
}
var keys_1 = keys$3;
var baseGetAllKeys$1 = _baseGetAllKeys, getSymbols$1 = _getSymbols, keys$2 = keys_1;
function getAllKeys$1(object2) {
  return baseGetAllKeys$1(object2, keys$2, getSymbols$1);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$7 = objectProto$6.hasOwnProperty;
function equalObjects$1(object2, other, bitmask, customizer, equalFunc, stack2) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object2), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$7.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack2.get(object2);
  var othStacked = stack2.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object2;
  }
  var result = true;
  stack2.set(object2, other);
  stack2.set(other, object2);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object2[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object2, stack2) : customizer(objValue, othValue, key, object2, other, stack2);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack2) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object2.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object2 && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack2["delete"](object2);
  stack2["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$4 = _getNative, root$4 = _root;
var DataView$2 = getNative$4(root$4, "DataView");
var _DataView = DataView$2;
var getNative$3 = _getNative, root$3 = _root;
var Promise$2 = getNative$3(root$3, "Promise");
var _Promise = Promise$2;
var getNative$2 = _getNative, root$2 = _root;
var Set$3 = getNative$2(root$2, "Set");
var _Set = Set$3;
var getNative$1 = _getNative, root$1 = _root;
var WeakMap$2 = getNative$1(root$1, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag$3 = _baseGetTag, toSource = _toSource;
var mapTag$1 = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag$1 = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1);
var getTag$2 = baseGetTag$3;
if (DataView$1 && getTag$2(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$2(new Map$1()) != mapTag$1 || Promise$1 && getTag$2(Promise$1.resolve()) != promiseTag || Set$2 && getTag$2(new Set$2()) != setTag$1 || WeakMap$1 && getTag$2(new WeakMap$1()) != weakMapTag) {
  getTag$2 = function(value) {
    var result = baseGetTag$3(value), Ctor = result == objectTag$2 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag$1;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$1;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$2;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$1 = _getTag, isArray$7 = isArray_1, isBuffer$2 = isBufferExports, isTypedArray$2 = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag$1 = "[object Object]";
var objectProto$5 = Object.prototype;
var hasOwnProperty$6 = objectProto$5.hasOwnProperty;
function baseIsEqualDeep$1(object2, other, bitmask, customizer, equalFunc, stack2) {
  var objIsArr = isArray$7(object2), othIsArr = isArray$7(other), objTag = objIsArr ? arrayTag : getTag$1(object2), othTag = othIsArr ? arrayTag : getTag$1(other);
  objTag = objTag == argsTag ? objectTag$1 : objTag;
  othTag = othTag == argsTag ? objectTag$1 : othTag;
  var objIsObj = objTag == objectTag$1, othIsObj = othTag == objectTag$1, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$2(object2)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack2 || (stack2 = new Stack$1());
    return objIsArr || isTypedArray$2(object2) ? equalArrays(object2, other, bitmask, customizer, equalFunc, stack2) : equalByTag(object2, other, objTag, bitmask, customizer, equalFunc, stack2);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$6.call(object2, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty$6.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object2.value() : object2, othUnwrapped = othIsWrapped ? other.value() : other;
      stack2 || (stack2 = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack2);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack2 || (stack2 = new Stack$1());
  return equalObjects(object2, other, bitmask, customizer, equalFunc, stack2);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$3 = isObjectLike_1;
function baseIsEqual$3(value, other, bitmask, customizer, stack2) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike$3(value) && !isObjectLike$3(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack2);
}
var _baseIsEqual = baseIsEqual$3;
var Stack = _Stack, baseIsEqual$2 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object2, source, matchData, customizer) {
  var index2 = matchData.length, length2 = index2, noCustomizer = !customizer;
  if (object2 == null) {
    return !length2;
  }
  object2 = Object(object2);
  while (index2--) {
    var data = matchData[index2];
    if (noCustomizer && data[2] ? data[1] !== object2[data[0]] : !(data[0] in object2)) {
      return false;
    }
  }
  while (++index2 < length2) {
    data = matchData[index2];
    var key = data[0], objValue = object2[key], srcValue = data[1];
    if (noCustomizer && data[2]) {
      if (objValue === void 0 && !(key in object2)) {
        return false;
      }
    } else {
      var stack2 = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object2, source, stack2);
      }
      if (!(result === void 0 ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack2) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$8 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$8(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$1 = keys_1;
function getMatchData$1(object2) {
  var result = keys$1(object2), length2 = result.length;
  while (length2--) {
    var key = result[length2], value = object2[key];
    result[length2] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object2) {
    if (object2 == null) {
      return false;
    }
    return object2[key] === srcValue && (srcValue !== void 0 || key in Object(object2));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object2) {
    return object2 === source || baseIsMatch(object2, source, matchData);
  };
}
var _baseMatches = baseMatches$1;
var baseGet$3 = _baseGet;
function get$1(object2, path2, defaultValue) {
  var result = object2 == null ? void 0 : baseGet$3(object2, path2);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get$1;
function baseHasIn$1(object2, key) {
  return object2 != null && key in Object(object2);
}
var _baseHasIn = baseHasIn$1;
var castPath$2 = _castPath, isArguments$2 = isArguments_1, isArray$6 = isArray_1, isIndex$2 = _isIndex, isLength = isLength_1, toKey$3 = _toKey;
function hasPath$1(object2, path2, hasFunc) {
  path2 = castPath$2(path2, object2);
  var index2 = -1, length2 = path2.length, result = false;
  while (++index2 < length2) {
    var key = toKey$3(path2[index2]);
    if (!(result = object2 != null && hasFunc(object2, key))) {
      break;
    }
    object2 = object2[key];
  }
  if (result || ++index2 != length2) {
    return result;
  }
  length2 = object2 == null ? 0 : object2.length;
  return !!length2 && isLength(length2) && isIndex$2(key, length2) && (isArray$6(object2) || isArguments$2(object2));
}
var _hasPath = hasPath$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$2(object2, path2) {
  return object2 != null && hasPath(object2, path2, baseHasIn);
}
var hasIn_1 = hasIn$2;
var baseIsEqual$1 = _baseIsEqual, get8 = get_1, hasIn$1 = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$2 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path2, srcValue) {
  if (isKey$1(path2) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path2), srcValue);
  }
  return function(object2) {
    var objValue = get8(object2, path2);
    return objValue === void 0 && objValue === srcValue ? hasIn$1(object2, path2) : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$9(value) {
  return value;
}
var identity_1 = identity$9;
const _identity = /* @__PURE__ */ getDefaultExportFromCjs(identity_1);
function baseProperty$1(key) {
  return function(object2) {
    return object2 == null ? void 0 : object2[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$2 = _baseGet;
function basePropertyDeep$1(path2) {
  return function(object2) {
    return baseGet$2(object2, path2);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey$1 = _toKey;
function property$1(path2) {
  return isKey(path2) ? baseProperty(toKey$1(path2)) : basePropertyDeep(path2);
}
var property_1 = property$1;
const _property = /* @__PURE__ */ getDefaultExportFromCjs(property_1);
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$8 = identity_1, isArray$5 = isArray_1, property = property_1;
function baseIteratee$4(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$8;
  }
  if (typeof value == "object") {
    return isArray$5(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$4;
function createBaseFor$1(fromRight) {
  return function(object2, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object2), props2 = keysFunc(object2), length2 = props2.length;
    while (length2--) {
      var key = props2[fromRight ? length2 : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object2;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$1 = createBaseFor();
var _baseFor = baseFor$1;
var baseFor = _baseFor, keys7 = keys_1;
function baseForOwn$1(object2, iteratee) {
  return object2 && baseFor(object2, iteratee, keys7);
}
var _baseForOwn = baseForOwn$1;
var isArrayLike$4 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$4(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length2 = collection.length, index2 = fromRight ? length2 : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length2) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;
var baseEach = _baseEach, isArrayLike$3 = isArrayLike_1;
function baseMap$1(collection, iteratee) {
  var index2 = -1, result = isArrayLike$3(collection) ? Array(collection.length) : [];
  baseEach(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
var _baseMap = baseMap$1;
function baseSortBy$1(array2, comparer) {
  var length2 = array2.length;
  array2.sort(comparer);
  while (length2--) {
    array2[length2] = array2[length2].value;
  }
  return array2;
}
var _baseSortBy = baseSortBy$1;
var isSymbol$1 = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol$1(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol$1(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
function compareMultiple$1(object2, other, orders) {
  var index2 = -1, objCriteria = object2.criteria, othCriteria = other.criteria, length2 = objCriteria.length, ordersLength = orders.length;
  while (++index2 < length2) {
    var result = compareAscending(objCriteria[index2], othCriteria[index2]);
    if (result) {
      if (index2 >= ordersLength) {
        return result;
      }
      var order2 = orders[index2];
      return result * (order2 == "desc" ? -1 : 1);
    }
  }
  return object2.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap$1 = _arrayMap, baseGet$1 = _baseGet, baseIteratee$3 = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary$2 = _baseUnary, compareMultiple = _compareMultiple, identity$7 = identity_1, isArray$4 = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$1(iteratees, function(iteratee) {
      if (isArray$4(iteratee)) {
        return function(value) {
          return baseGet$1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$7];
  }
  var index2 = -1;
  iteratees = arrayMap$1(iteratees, baseUnary$2(baseIteratee$3));
  var result = baseMap(collection, function(value, key, collection2) {
    var criteria = arrayMap$1(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index2, "value": value };
  });
  return baseSortBy(result, function(object2, other) {
    return compareMultiple(object2, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;
var baseOrderBy = _baseOrderBy, isArray$3 = isArray_1;
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray$3(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? void 0 : orders;
  if (!isArray$3(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}
var orderBy_1 = orderBy;
const _orderBy = /* @__PURE__ */ getDefaultExportFromCjs(orderBy_1);
var overArg = _overArg;
var getPrototype$2 = overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$2;
var baseGetTag$2 = _baseGetTag, getPrototype$1 = _getPrototype, isObjectLike$2 = isObjectLike_1;
var objectTag = "[object Object]";
var funcProto = Function.prototype, objectProto$4 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$5 = objectProto$4.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$1(value) {
  if (!isObjectLike$2(value) || baseGetTag$2(value) != objectTag) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$5.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$1;
const _isPlainObject = /* @__PURE__ */ getDefaultExportFromCjs(isPlainObject_1);
function define(constructor, factory, prototype2) {
  constructor.prototype = factory.prototype = prototype2;
  prototype2.constructor = constructor;
}
function extend$1(parent2, definition) {
  var prototype2 = Object.create(parent2.prototype);
  for (var key in definition)
    prototype2[key] = definition[key];
  return prototype2;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m3, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m3 = reHex.exec(format2)) ? (l = m3[1].length, m3 = parseInt(m3[1], 16), l === 6 ? rgbn(m3) : l === 3 ? new Rgb(m3 >> 8 & 15 | m3 >> 4 & 240, m3 >> 4 & 15 | m3 & 240, (m3 & 15) << 4 | m3 & 15, 1) : l === 8 ? rgba(m3 >> 24 & 255, m3 >> 16 & 255, m3 >> 8 & 255, (m3 & 255) / 255) : l === 4 ? rgba(m3 >> 12 & 15 | m3 >> 8 & 240, m3 >> 8 & 15 | m3 >> 4 & 240, m3 >> 4 & 15 | m3 & 240, ((m3 & 15) << 4 | m3 & 15) / 255) : null) : (m3 = reRgbInteger.exec(format2)) ? new Rgb(m3[1], m3[2], m3[3], 1) : (m3 = reRgbPercent.exec(format2)) ? new Rgb(m3[1] * 255 / 100, m3[2] * 255 / 100, m3[3] * 255 / 100, 1) : (m3 = reRgbaInteger.exec(format2)) ? rgba(m3[1], m3[2], m3[3], m3[4]) : (m3 = reRgbaPercent.exec(format2)) ? rgba(m3[1] * 255 / 100, m3[2] * 255 / 100, m3[3] * 255 / 100, m3[4]) : (m3 = reHslPercent.exec(format2)) ? hsla(m3[1], m3[2] / 100, m3[3] / 100, 1) : (m3 = reHslaPercent.exec(format2)) ? hsla(m3[1], m3[2] / 100, m3[3] / 100, m3[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
  return new Rgb(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function rgba(r, g2, b10, a4) {
  if (a4 <= 0)
    r = g2 = b10 = NaN;
  return new Rgb(r, g2, b10, a4);
}
function rgbConvert(o) {
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb$1(r, g2, b10, opacity2) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g2, b10, opacity2 == null ? 1 : opacity2);
}
function Rgb(r, g2, b10, opacity2) {
  this.r = +r;
  this.g = +g2;
  this.b = +b10;
  this.opacity = +opacity2;
}
define(Rgb, rgb$1, extend$1(Color, {
  brighter(k3) {
    k3 = k3 == null ? brighter : Math.pow(brighter, k3);
    return new Rgb(this.r * k3, this.g * k3, this.b * k3, this.opacity);
  },
  darker(k3) {
    k3 = k3 == null ? darker : Math.pow(darker, k3);
    return new Rgb(this.r * k3, this.g * k3, this.b * k3, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a4 = clampa(this.opacity);
  return `${a4 === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a4 === 1 ? ")" : `, ${a4})`}`;
}
function clampa(opacity2) {
  return isNaN(opacity2) ? 1 : Math.max(0, Math.min(1, opacity2));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h3, s4, l, a4) {
  if (a4 <= 0)
    h3 = s4 = l = NaN;
  else if (l <= 0 || l >= 1)
    h3 = s4 = NaN;
  else if (s4 <= 0)
    h3 = NaN;
  return new Hsl(h3, s4, l, a4);
}
function hslConvert(o) {
  if (o instanceof Hsl)
    return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color))
    o = color(o);
  if (!o)
    return new Hsl();
  if (o instanceof Hsl)
    return o;
  o = o.rgb();
  var r = o.r / 255, g2 = o.g / 255, b10 = o.b / 255, min2 = Math.min(r, g2, b10), max2 = Math.max(r, g2, b10), h3 = NaN, s4 = max2 - min2, l = (max2 + min2) / 2;
  if (s4) {
    if (r === max2)
      h3 = (g2 - b10) / s4 + (g2 < b10) * 6;
    else if (g2 === max2)
      h3 = (b10 - r) / s4 + 2;
    else
      h3 = (r - g2) / s4 + 4;
    s4 /= l < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h3 *= 60;
  } else {
    s4 = l > 0 && l < 1 ? 0 : h3;
  }
  return new Hsl(h3, s4, l, o.opacity);
}
function hsl(h3, s4, l, opacity2) {
  return arguments.length === 1 ? hslConvert(h3) : new Hsl(h3, s4, l, opacity2 == null ? 1 : opacity2);
}
function Hsl(h3, s4, l, opacity2) {
  this.h = +h3;
  this.s = +s4;
  this.l = +l;
  this.opacity = +opacity2;
}
define(Hsl, hsl, extend$1(Color, {
  brighter(k3) {
    k3 = k3 == null ? brighter : Math.pow(brighter, k3);
    return new Hsl(this.h, this.s, this.l * k3, this.opacity);
  },
  darker(k3) {
    k3 = k3 == null ? darker : Math.pow(darker, k3);
    return new Hsl(this.h, this.s, this.l * k3, this.opacity);
  },
  rgb() {
    var h3 = this.h % 360 + (this.h < 0) * 360, s4 = isNaN(h3) || isNaN(this.s) ? 0 : this.s, l = this.l, m22 = l + (l < 0.5 ? l : 1 - l) * s4, m1 = 2 * l - m22;
    return new Rgb(
      hsl2rgb(h3 >= 240 ? h3 - 240 : h3 + 120, m1, m22),
      hsl2rgb(h3, m1, m22),
      hsl2rgb(h3 < 120 ? h3 + 240 : h3 - 120, m1, m22),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a4 = clampa(this.opacity);
    return `${a4 === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a4 === 1 ? ")" : `, ${a4})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h3, m1, m22) {
  return (h3 < 60 ? m1 + (m22 - m1) * h3 / 60 : h3 < 180 ? m22 : h3 < 240 ? m1 + (m22 - m1) * (240 - h3) / 60 : m1) * 255;
}
const constant$3 = (x3) => () => x3;
function linear$1(a4, d3) {
  return function(t2) {
    return a4 + t2 * d3;
  };
}
function exponential(a4, b10, y4) {
  return a4 = Math.pow(a4, y4), b10 = Math.pow(b10, y4) - a4, y4 = 1 / y4, function(t2) {
    return Math.pow(a4 + t2 * b10, y4);
  };
}
function gamma(y4) {
  return (y4 = +y4) === 1 ? nogamma : function(a4, b10) {
    return b10 - a4 ? exponential(a4, b10, y4) : constant$3(isNaN(a4) ? b10 : a4);
  };
}
function nogamma(a4, b10) {
  var d3 = b10 - a4;
  return d3 ? linear$1(a4, d3) : constant$3(isNaN(a4) ? b10 : a4);
}
const rgb = function rgbGamma(y4) {
  var color2 = gamma(y4);
  function rgb2(start2, end2) {
    var r = color2((start2 = rgb$1(start2)).r, (end2 = rgb$1(end2)).r), g2 = color2(start2.g, end2.g), b10 = color2(start2.b, end2.b), opacity2 = nogamma(start2.opacity, end2.opacity);
    return function(t2) {
      start2.r = r(t2);
      start2.g = g2(t2);
      start2.b = b10(t2);
      start2.opacity = opacity2(t2);
      return start2 + "";
    };
  }
  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);
function numberArray(a4, b10) {
  if (!b10)
    b10 = [];
  var n = a4 ? Math.min(b10.length, a4.length) : 0, c7 = b10.slice(), i2;
  return function(t2) {
    for (i2 = 0; i2 < n; ++i2)
      c7[i2] = a4[i2] * (1 - t2) + b10[i2] * t2;
    return c7;
  };
}
function isNumberArray(x3) {
  return ArrayBuffer.isView(x3) && !(x3 instanceof DataView);
}
function genericArray(a4, b10) {
  var nb = b10 ? b10.length : 0, na = a4 ? Math.min(nb, a4.length) : 0, x3 = new Array(na), c7 = new Array(nb), i2;
  for (i2 = 0; i2 < na; ++i2)
    x3[i2] = interpolate(a4[i2], b10[i2]);
  for (; i2 < nb; ++i2)
    c7[i2] = b10[i2];
  return function(t2) {
    for (i2 = 0; i2 < na; ++i2)
      c7[i2] = x3[i2](t2);
    return c7;
  };
}
function date$2(a4, b10) {
  var d3 = /* @__PURE__ */ new Date();
  return a4 = +a4, b10 = +b10, function(t2) {
    return d3.setTime(a4 * (1 - t2) + b10 * t2), d3;
  };
}
function interpolateNumber(a4, b10) {
  return a4 = +a4, b10 = +b10, function(t2) {
    return a4 * (1 - t2) + b10 * t2;
  };
}
function object$1(a4, b10) {
  var i2 = {}, c7 = {}, k3;
  if (a4 === null || typeof a4 !== "object")
    a4 = {};
  if (b10 === null || typeof b10 !== "object")
    b10 = {};
  for (k3 in b10) {
    if (k3 in a4) {
      i2[k3] = interpolate(a4[k3], b10[k3]);
    } else {
      c7[k3] = b10[k3];
    }
  }
  return function(t2) {
    for (k3 in i2)
      c7[k3] = i2[k3](t2);
    return c7;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero$1(b10) {
  return function() {
    return b10;
  };
}
function one(b10) {
  return function(t2) {
    return b10(t2) + "";
  };
}
function string$1(a4, b10) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i2 = -1, s4 = [], q2 = [];
  a4 = a4 + "", b10 = b10 + "";
  while ((am = reA.exec(a4)) && (bm = reB.exec(b10))) {
    if ((bs = bm.index) > bi) {
      bs = b10.slice(bi, bs);
      if (s4[i2])
        s4[i2] += bs;
      else
        s4[++i2] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s4[i2])
        s4[i2] += bm;
      else
        s4[++i2] = bm;
    } else {
      s4[++i2] = null;
      q2.push({ i: i2, x: interpolateNumber(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b10.length) {
    bs = b10.slice(bi);
    if (s4[i2])
      s4[i2] += bs;
    else
      s4[++i2] = bs;
  }
  return s4.length < 2 ? q2[0] ? one(q2[0].x) : zero$1(b10) : (b10 = q2.length, function(t2) {
    for (var i3 = 0, o; i3 < b10; ++i3)
      s4[(o = q2[i3]).i] = o.x(t2);
    return s4.join("");
  });
}
function interpolate(a4, b10) {
  var t2 = typeof b10, c7;
  return b10 == null || t2 === "boolean" ? constant$3(b10) : (t2 === "number" ? interpolateNumber : t2 === "string" ? (c7 = color(b10)) ? (b10 = c7, rgb) : string$1 : b10 instanceof color ? rgb : b10 instanceof Date ? date$2 : isNumberArray(b10) ? numberArray : Array.isArray(b10) ? genericArray : typeof b10.valueOf !== "function" && typeof b10.toString !== "function" || isNaN(b10) ? object$1 : interpolateNumber)(a4, b10);
}
function interpolateRound(a4, b10) {
  return a4 = +a4, b10 = +b10, function(t2) {
    return Math.round(a4 * (1 - t2) + b10 * t2);
  };
}
function piecewise(interpolate$12, values6) {
  if (values6 === void 0)
    values6 = interpolate$12, interpolate$12 = interpolate;
  var i2 = 0, n = values6.length - 1, v = values6[0], I2 = new Array(n < 0 ? 0 : n);
  while (i2 < n)
    I2[i2] = interpolate$12(v, v = values6[++i2]);
  return function(t2) {
    var i3 = Math.max(0, Math.min(n - 1, Math.floor(t2 *= n)));
    return I2[i3](t2 - i3);
  };
}
const isInterpolatable = function(obj) {
  if (obj !== null) {
    switch (typeof obj) {
      case "undefined":
        return false;
      case "number":
        return !isNaN(obj) && obj !== Number.POSITIVE_INFINITY && obj !== Number.NEGATIVE_INFINITY;
      case "string":
        return true;
      case "boolean":
        return false;
      case "object":
        return obj instanceof Date || Array.isArray(obj) || _isPlainObject(obj);
      case "function":
        return true;
    }
  }
  return false;
};
const interpolateImmediate = function(a4, b10, when) {
  if (when === void 0) {
    when = 0;
  }
  return function(t2) {
    return t2 < when ? a4 : b10;
  };
};
const interpolateFunction = function(a4, b10) {
  return function(t2) {
    if (t2 >= 1) {
      return b10;
    }
    return function() {
      const aval = typeof a4 === "function" ? a4.apply(this, arguments) : a4;
      const bval = typeof b10 === "function" ? b10.apply(this, arguments) : b10;
      return interpolate(aval, bval)(t2);
    };
  };
};
const interpolateObject = function(startValue, endValue) {
  const interpolateTypes = (x3, y4) => {
    if (x3 === y4 || !isInterpolatable(x3) || !isInterpolatable(y4)) {
      return interpolateImmediate(x3, y4);
    }
    if (typeof x3 === "function" || typeof y4 === "function") {
      return interpolateFunction(x3, y4);
    }
    if (typeof x3 === "object" && _isPlainObject(x3) || typeof y4 === "object" && _isPlainObject(y4)) {
      return interpolateObject(x3, y4);
    }
    return interpolate(x3, y4);
  };
  const keyData = (val) => {
    return Array.isArray(val) ? _orderBy(val, "key") : val;
  };
  const i2 = {};
  const c7 = {};
  let a4 = startValue;
  let b10 = endValue;
  let k3;
  if (a4 === null || typeof a4 !== "object") {
    a4 = {};
  }
  if (b10 === null || typeof b10 !== "object") {
    b10 = {};
  }
  for (k3 in b10) {
    if (k3 in a4) {
      i2[k3] = interpolateTypes(keyData(a4[k3]), keyData(b10[k3]));
    } else {
      c7[k3] = b10[k3];
    }
  }
  return function(t2) {
    for (k3 in i2) {
      c7[k3] = i2[k3](t2);
    }
    return c7;
  };
};
const interpolateString = function(a4, b10) {
  const format2 = (val) => {
    return typeof val === "string" ? val.replace(/,/g, "") : val;
  };
  return interpolate(format2(a4), format2(b10));
};
const victoryInterpolator = function(a4, b10) {
  if (a4 === b10 || !isInterpolatable(a4) || !isInterpolatable(b10)) {
    return interpolateImmediate(a4, b10);
  }
  if (typeof a4 === "function" || typeof b10 === "function") {
    return interpolateFunction(a4, b10);
  }
  if (_isPlainObject(a4) || _isPlainObject(b10)) {
    return interpolateObject(a4, b10);
  }
  if (typeof a4 === "string" || typeof b10 === "string") {
    return interpolateString(a4, b10);
  }
  return interpolate(a4, b10);
};
var frame = 0, timeout = 0, interval = 0, pokeDelay = 1e3, taskHead, taskTail, clockLast = 0, clockNow = 0, clockSkew = 0, clock = typeof performance === "object" && performance.now ? performance : Date, setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
  setTimeout(f, 17);
};
function now$2() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}
function clearNow() {
  clockNow = 0;
}
function Timer$1() {
  this._call = this._time = this._next = null;
}
Timer$1.prototype = timer.prototype = {
  constructor: Timer$1,
  restart: function(callback, delay, time2) {
    if (typeof callback !== "function")
      throw new TypeError("callback is not a function");
    time2 = (time2 == null ? now$2() : +time2) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail)
        taskTail._next = this;
      else
        taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time2;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};
function timer(callback, delay, time2) {
  var t2 = new Timer$1();
  t2.restart(callback, delay, time2);
  return t2;
}
function timerFlush() {
  now$2();
  ++frame;
  var t2 = taskHead, e3;
  while (t2) {
    if ((e3 = clockNow - t2._time) >= 0)
      t2._call.call(void 0, e3);
    t2 = t2._next;
  }
  --frame;
}
function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}
function poke() {
  var now2 = clock.now(), delay = now2 - clockLast;
  if (delay > pokeDelay)
    clockSkew -= delay, clockLast = now2;
}
function nap() {
  var t02, t12 = taskHead, t2, time2 = Infinity;
  while (t12) {
    if (t12._call) {
      if (time2 > t12._time)
        time2 = t12._time;
      t02 = t12, t12 = t12._next;
    } else {
      t2 = t12._next, t12._next = null;
      t12 = t02 ? t02._next = t2 : taskHead = t2;
    }
  }
  taskTail = t02;
  sleep(time2);
}
function sleep(time2) {
  if (frame)
    return;
  if (timeout)
    timeout = clearTimeout(timeout);
  var delay = time2 - clockNow;
  if (delay > 24) {
    if (time2 < Infinity)
      timeout = setTimeout(wake, time2 - clock.now() - clockSkew);
    if (interval)
      interval = clearInterval(interval);
  } else {
    if (!interval)
      clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}
class Timer {
  constructor() {
    __publicField(this, "loop", () => {
      this.subscribers.forEach((s4) => {
        s4.callback(now$2() - s4.startTime, s4.duration);
      });
    });
    this.shouldAnimate = true;
    this.subscribers = [];
    this.timer = null;
    this.activeSubscriptions = 0;
  }
  bypassAnimation() {
    this.shouldAnimate = false;
  }
  resumeAnimation() {
    this.shouldAnimate = true;
  }
  start() {
    if (!this.timer) {
      this.timer = timer(this.loop);
    }
  }
  stop() {
    if (this.timer) {
      this.timer.stop();
      this.timer = null;
    }
  }
  subscribe(callback, duration) {
    const subscriptionID = this.subscribers.push({
      startTime: now$2(),
      callback,
      duration: this.shouldAnimate ? duration : 0
    });
    this.activeSubscriptions++;
    this.start();
    return subscriptionID;
  }
  unsubscribe(id) {
    if (id !== null && this.subscribers[id - 1]) {
      delete this.subscribers[id - 1];
      this.activeSubscriptions--;
    }
    if (this.activeSubscriptions === 0) {
      this.stop();
    }
  }
}
const TimerContext = /* @__PURE__ */ React__default.createContext({
  transitionTimer: new Timer(),
  animationTimer: new Timer()
});
TimerContext.displayName = "TimerContext";
const formatAnimationName = (name2) => {
  const capitalizedName = name2.charAt(0).toUpperCase() + name2.slice(1);
  return `ease${capitalizedName}`;
};
const DEFAULT_DURATION = 1e3;
const VictoryAnimation = (_ref2) => {
  let {
    duration = DEFAULT_DURATION,
    easing = "quadInOut",
    delay = 0,
    data,
    children: children2,
    onEnd
  } = _ref2;
  const [state, setState] = React__default.useState({
    data: Array.isArray(data) ? data[0] : data,
    animationInfo: {
      progress: 0,
      animating: false
    }
  });
  const timer2 = React__default.useContext(TimerContext).animationTimer;
  const queue = React__default.useRef(Array.isArray(data) ? data.slice(1) : []);
  const interpolator = React__default.useRef(null);
  const loopID = React__default.useRef(void 0);
  const ease = d3Ease[formatAnimationName(easing)];
  React__default.useEffect(() => {
    if (queue.current.length) {
      traverseQueue();
    }
    return () => {
      if (loopID.current) {
        timer2.unsubscribe(loopID.current);
      } else {
        timer2.stop();
      }
    };
  }, []);
  React__default.useEffect(() => {
    if (interpolator.current && state.animationInfo && state.animationInfo.progress < 1) {
      setState({
        data: interpolator.current(1),
        animationInfo: {
          progress: 1,
          animating: false,
          terminating: true
        }
      });
    } else {
      timer2.unsubscribe(loopID.current);
      queue.current = Array.isArray(data) ? data : [data];
      traverseQueue();
    }
  }, [data]);
  const traverseQueue = () => {
    if (queue.current.length) {
      const nextData = queue.current[0];
      interpolator.current = victoryInterpolator(state.data, nextData);
      if (delay) {
        setTimeout(() => {
          loopID.current = timer2.subscribe(functionToBeRunEachFrame, duration);
        }, delay);
      } else {
        loopID.current = timer2.subscribe(functionToBeRunEachFrame, duration);
      }
    } else if (onEnd) {
      onEnd();
    }
  };
  const functionToBeRunEachFrame = (elapsed) => {
    if (!interpolator.current)
      return;
    const step2 = duration ? elapsed / duration : 1;
    if (step2 >= 1) {
      setState({
        data: interpolator.current(1),
        animationInfo: {
          progress: 1,
          animating: false,
          terminating: true
        }
      });
      if (loopID.current) {
        timer2.unsubscribe(loopID.current);
      }
      queue.current.shift();
      traverseQueue();
      return;
    }
    setState({
      data: interpolator.current(ease(step2)),
      animationInfo: {
        progress: step2,
        animating: step2 < 1
      }
    });
  };
  return children2(state.data, state.animationInfo);
};
var toString$2 = toString_1;
var idCounter = 0;
function uniqueId(prefix2) {
  var id = ++idCounter;
  return toString$2(prefix2) + id;
}
var uniqueId_1 = uniqueId;
const _uniqueId = /* @__PURE__ */ getDefaultExportFromCjs(uniqueId_1);
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax$1 = Math.max;
function overRest$2(func, start2, transform) {
  start2 = nativeMax$1(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length2 = nativeMax$1(args.length - start2, 0), array2 = Array(length2);
    while (++index2 < length2) {
      array2[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform(array2);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$2;
function constant$2(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$2;
var getNative = _getNative;
var defineProperty$2 = function() {
  try {
    var func = getNative(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e3) {
  }
}();
var _defineProperty = defineProperty$2;
var constant$1 = constant_1, defineProperty$1 = _defineProperty, identity$6 = identity_1;
var baseSetToString$1 = !defineProperty$1 ? identity$6 : function(func, string2) {
  return defineProperty$1(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant$1(string2),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$2 = shortOut(baseSetToString);
var _setToString = setToString$2;
var identity$5 = identity_1, overRest$1 = _overRest, setToString$1 = _setToString;
function baseRest$1(func, start2) {
  return setToString$1(overRest$1(func, start2, identity$5), func + "");
}
var _baseRest = baseRest$1;
var eq$3 = eq_1, isArrayLike$2 = isArrayLike_1, isIndex$1 = _isIndex, isObject$7 = isObject_1;
function isIterateeCall$1(value, index2, object2) {
  if (!isObject$7(object2)) {
    return false;
  }
  var type2 = typeof index2;
  if (type2 == "number" ? isArrayLike$2(object2) && isIndex$1(index2, object2.length) : type2 == "string" && index2 in object2) {
    return eq$3(object2[index2], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$1;
function nativeKeysIn$1(object2) {
  var result = [];
  if (object2 != null) {
    for (var key in Object(object2)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$6 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$3 = Object.prototype;
var hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function baseKeysIn$1(object2) {
  if (!isObject$6(object2)) {
    return nativeKeysIn(object2);
  }
  var isProto = isPrototype$1(object2), result = [];
  for (var key in object2) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$4.call(object2, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$1 = isArrayLike_1;
function keysIn$2(object2) {
  return isArrayLike$1(object2) ? arrayLikeKeys(object2, true) : baseKeysIn(object2);
}
var keysIn_1 = keysIn$2;
var baseRest = _baseRest, eq$2 = eq_1, isIterateeCall = _isIterateeCall, keysIn$1 = keysIn_1;
var objectProto$2 = Object.prototype;
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;
var defaults$2 = baseRest(function(object2, sources) {
  object2 = Object(object2);
  var index2 = -1;
  var length2 = sources.length;
  var guard = length2 > 2 ? sources[2] : void 0;
  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length2 = 1;
  }
  while (++index2 < length2) {
    var source = sources[index2];
    var props2 = keysIn$1(source);
    var propsIndex = -1;
    var propsLength = props2.length;
    while (++propsIndex < propsLength) {
      var key = props2[propsIndex];
      var value = object2[key];
      if (value === void 0 || eq$2(value, objectProto$2[key]) && !hasOwnProperty$3.call(object2, key)) {
        object2[key] = source[key];
      }
    }
  }
  return object2;
});
var defaults_1 = defaults$2;
const _defaults = /* @__PURE__ */ getDefaultExportFromCjs(defaults_1);
class Portal extends React__default.Component {
  constructor(props2) {
    super(props2);
    __publicField(this, "portalRegister", () => {
      return ++this.index;
    });
    __publicField(this, "portalUpdate", (key, element) => {
      this.map[key] = element;
      this.forceUpdate();
    });
    __publicField(this, "portalDeregister", (key) => {
      delete this.map[key];
      this.forceUpdate();
    });
    this.map = {};
    this.index = 1;
  }
  getChildren() {
    return Object.keys(this.map).map((key) => {
      const el = this.map[key];
      return el ? /* @__PURE__ */ React__default.cloneElement(el, {
        key
      }) : el;
    });
  }
  // Overridden in victory-core-native
  render() {
    return /* @__PURE__ */ React__default.createElement("svg", this.props, this.getChildren());
  }
}
__publicField(Portal, "displayName", "Portal");
const PortalContext = /* @__PURE__ */ React__default.createContext({});
PortalContext.displayName = "PortalContext";
var defineProperty = _defineProperty;
function baseAssignValue$1(object2, key, value) {
  if (key == "__proto__" && defineProperty) {
    defineProperty(object2, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object2[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$1;
var baseAssignValue = _baseAssignValue, eq$1 = eq_1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function assignValue$1(object2, key, value) {
  var objValue = object2[key];
  if (!(hasOwnProperty$2.call(object2, key) && eq$1(objValue, value)) || value === void 0 && !(key in object2)) {
    baseAssignValue(object2, key, value);
  }
}
var _assignValue = assignValue$1;
var assignValue = _assignValue, castPath$1 = _castPath, isIndex = _isIndex, isObject$5 = isObject_1, toKey = _toKey;
function baseSet$1(object2, path2, value, customizer) {
  if (!isObject$5(object2)) {
    return object2;
  }
  path2 = castPath$1(path2, object2);
  var index2 = -1, length2 = path2.length, lastIndex = length2 - 1, nested = object2;
  while (nested != null && ++index2 < length2) {
    var key = toKey(path2[index2]), newValue = value;
    if (key === "__proto__" || key === "constructor" || key === "prototype") {
      return object2;
    }
    if (index2 != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : void 0;
      if (newValue === void 0) {
        newValue = isObject$5(objValue) ? objValue : isIndex(path2[index2 + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object2;
}
var _baseSet = baseSet$1;
var baseGet = _baseGet, baseSet = _baseSet, castPath = _castPath;
function basePickBy$2(object2, paths, predicate) {
  var index2 = -1, length2 = paths.length, result = {};
  while (++index2 < length2) {
    var path2 = paths[index2], value = baseGet(object2, path2);
    if (predicate(value, path2)) {
      baseSet(result, castPath(path2, object2), value);
    }
  }
  return result;
}
var _basePickBy = basePickBy$2;
var basePickBy$1 = _basePickBy, hasIn = hasIn_1;
function basePick$1(object2, paths) {
  return basePickBy$1(object2, paths, function(value, path2) {
    return hasIn(object2, path2);
  });
}
var _basePick = basePick$1;
var Symbol$2 = _Symbol, isArguments$1 = isArguments_1, isArray$2 = isArray_1;
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$2(value) || isArguments$1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush$1 = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(array2, depth, predicate, isStrict, result) {
  var index2 = -1, length2 = array2.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length2) {
    var value = array2[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$1;
var baseFlatten = _baseFlatten;
function flatten$1(array2) {
  var length2 = array2 == null ? 0 : array2.length;
  return length2 ? baseFlatten(array2, 1) : [];
}
var flatten_1 = flatten$1;
var flatten = flatten_1, overRest = _overRest, setToString = _setToString;
function flatRest$1(func) {
  return setToString(overRest(func, void 0, flatten), func + "");
}
var _flatRest = flatRest$1;
var basePick = _basePick, flatRest = _flatRest;
var pick = flatRest(function(object2, paths) {
  return object2 == null ? {} : basePick(object2, paths);
});
var pick_1 = pick;
const _pick = /* @__PURE__ */ getDefaultExportFromCjs(pick_1);
function getCartesianRange(props2, axis) {
  const vertical = axis !== "x";
  const padding2 = getPadding$1(props2);
  if (vertical) {
    return [props2.height - padding2.bottom, padding2.top];
  }
  return [padding2.left, props2.width - padding2.right];
}
function getPolarRange(props2, axis) {
  if (axis === "x") {
    const startAngle = degreesToRadians(props2.startAngle || 0);
    const endAngle = degreesToRadians(props2.endAngle || 360);
    return [startAngle, endAngle];
  }
  return [props2.innerRadius || 0, getRadius$1(props2)];
}
function invert(original) {
  return Object.entries(original).reduce((acc, current) => {
    acc[current[1]] = current[0];
    return acc;
  }, {});
}
function omit(originalObject, ks) {
  if (ks === void 0) {
    ks = [];
  }
  const newObject = {};
  for (const key in originalObject) {
    if (ks.indexOf(key) >= 0) {
      continue;
    }
    if (!Object.prototype.hasOwnProperty.call(originalObject, key)) {
      continue;
    }
    newObject[key] = originalObject[key];
  }
  return newObject;
}
function getPoint(datum) {
  const exists2 = (val) => val !== void 0;
  const {
    _x,
    _x1,
    _x0,
    _voronoiX,
    _y,
    _y1,
    _y0,
    _voronoiY
  } = datum;
  const defaultX = exists2(_x1) ? _x1 : _x;
  const defaultY = exists2(_y1) ? _y1 : _y;
  const point2 = {
    x: exists2(_voronoiX) ? _voronoiX : defaultX,
    x0: exists2(_x0) ? _x0 : _x,
    y: exists2(_voronoiY) ? _voronoiY : defaultY,
    y0: exists2(_y0) ? _y0 : _y
  };
  return _defaults({}, point2, datum);
}
function scalePoint(props2, datum) {
  const {
    scale,
    polar,
    horizontal
  } = props2;
  const d3 = getPoint(datum);
  const origin = props2.origin || {
    x: 0,
    y: 0
  };
  const x3 = horizontal ? scale.y(d3.y) : scale.x(d3.x);
  const x0 = horizontal ? scale.y(d3.y0) : scale.x(d3.x0);
  const y4 = horizontal ? scale.x(d3.x) : scale.y(d3.y);
  const y0 = horizontal ? scale.x(d3.x0) : scale.y(d3.y0);
  return {
    x: polar ? y4 * Math.cos(x3) + origin.x : x3,
    x0: polar ? y0 * Math.cos(x0) + origin.x : x0,
    y: polar ? -y4 * Math.sin(x3) + origin.y : y4,
    y0: polar ? -y0 * Math.sin(x0) + origin.x : y0
  };
}
function getPadding$1(props2, name2) {
  if (name2 === void 0) {
    name2 = "padding";
  }
  const padding2 = props2[name2];
  const paddingVal = typeof padding2 === "number" ? padding2 : 0;
  const paddingObj = typeof padding2 === "object" ? padding2 : {};
  return {
    top: paddingObj.top || paddingVal,
    bottom: paddingObj.bottom || paddingVal,
    left: paddingObj.left || paddingVal,
    right: paddingObj.right || paddingVal
  };
}
function isTooltip(component) {
  const labelRole = component && component.type && component.type.role;
  return labelRole === "tooltip";
}
function getDefaultStyles(props2, role) {
  const {
    theme: theme2 = {},
    labelComponent
  } = props2;
  const defaultStyles2 = theme2[role] && theme2[role].style || {};
  if (!isTooltip(labelComponent)) {
    return defaultStyles2;
  }
  const tooltipStyle = theme2.tooltip && theme2.tooltip.style || {};
  const labelStyle = _defaults({}, tooltipStyle, defaultStyles2.labels);
  return _defaults({}, {
    labels: labelStyle
  }, defaultStyles2);
}
function getStyles$4(style2, defaultStyles2) {
  const width = "100%";
  const height = "100%";
  if (!style2) {
    return _defaults({
      parent: {
        height,
        width
      }
    }, defaultStyles2);
  }
  const {
    data,
    labels,
    parent: parent2
  } = style2;
  const defaultParent = defaultStyles2 && defaultStyles2.parent || {};
  const defaultLabels = defaultStyles2 && defaultStyles2.labels || {};
  const defaultData2 = defaultStyles2 && defaultStyles2.data || {};
  return {
    parent: _defaults({}, parent2, defaultParent, {
      width,
      height
    }),
    labels: _defaults({}, labels, defaultLabels),
    data: _defaults({}, data, defaultData2)
  };
}
function evaluateProp(prop, props2) {
  return isFunction$1(prop) ? prop(props2) : prop;
}
function evaluateStyle(style2, props2) {
  if (props2.disableInlineStyles) {
    return {};
  }
  if (!style2 || !Object.keys(style2).some((value) => isFunction$1(style2[value]))) {
    return style2;
  }
  return Object.keys(style2).reduce((prev2, curr) => {
    prev2[curr] = evaluateProp(style2[curr], props2);
    return prev2;
  }, {});
}
function degreesToRadians(degrees) {
  return typeof degrees === "number" ? degrees * (Math.PI / 180) : degrees;
}
function radiansToDegrees(radians) {
  return typeof radians === "number" ? radians / (Math.PI / 180) : radians;
}
function getRadius$1(props2) {
  const {
    left: left2,
    right: right2,
    top: top2,
    bottom: bottom2
  } = getPadding$1(props2);
  const {
    width,
    height
  } = props2;
  return Math.min(width - left2 - right2, height - top2 - bottom2) / 2;
}
function getPolarOrigin(props2) {
  const {
    width,
    height
  } = props2;
  const {
    top: top2,
    bottom: bottom2,
    left: left2,
    right: right2
  } = getPadding$1(props2);
  const radius = Math.min(width - left2 - right2, height - top2 - bottom2) / 2;
  const offsetWidth = width / 2 + left2 - right2;
  const offsetHeight = height / 2 + top2 - bottom2;
  return {
    x: offsetWidth + radius > width ? radius + left2 - right2 : offsetWidth,
    y: offsetHeight + radius > height ? radius + top2 - bottom2 : offsetHeight
  };
}
function getRange$1(props2, axis) {
  if (props2.range && props2.range[axis]) {
    return props2.range[axis];
  } else if (props2.range && Array.isArray(props2.range)) {
    return props2.range;
  }
  return props2.polar ? getPolarRange(props2, axis) : getCartesianRange(props2, axis);
}
function isNil(value) {
  return value == null;
}
function isFunction$1(value) {
  return typeof value === "function";
}
function createAccessor(key) {
  if (isFunction$1(key)) {
    return key;
  } else if (key === null || key === void 0) {
    return (x3) => x3;
  }
  return _property(key);
}
function modifyProps$1(props2, fallbackProps2, role) {
  const theme2 = props2.theme && props2.theme[role] ? props2.theme[role] : {};
  const themeProps = omit(theme2, ["style"]);
  const horizontal = isHorizontal(props2);
  const defaultObject = horizontal === void 0 ? {} : {
    horizontal
  };
  return _defaults(defaultObject, props2, themeProps, fallbackProps2);
}
function getCurrentAxis$1(axis, horizontal) {
  const otherAxis = axis === "x" ? "y" : "x";
  return horizontal ? otherAxis : axis;
}
function range$1(start2, end2, increment) {
  const startIndex = end2 ? start2 : 0;
  let endIndex = end2 ? end2 : start2;
  if (!endIndex)
    endIndex = 0;
  const k3 = endIndex - startIndex;
  const length2 = Math.abs(k3);
  const sign2 = k3 / length2 || 1;
  const inc = increment || 1;
  const arrayLength = Math.max(Math.ceil(length2 / inc), 0);
  return Array.from(Array(arrayLength), (_, i2) => startIndex + i2 * sign2 * inc);
}
function reduceChildren(children2, iteratee, parentProps, initialMemo, combine2) {
  if (parentProps === void 0) {
    parentProps = {};
  }
  if (initialMemo === void 0) {
    initialMemo = [];
  }
  if (combine2 === void 0) {
    combine2 = (memo, item) => (
      // @ts-expect-error These defaults are hard to type
      memo.concat(item)
    );
  }
  const sharedProps = ["data", "domain", "categories", "polar", "startAngle", "endAngle", "minDomain", "maxDomain", "horizontal"];
  const traverseChildren = (childArray, names, parent2) => {
    return childArray.reduce((memo, child, index2) => {
      let newMemo = memo;
      const childRole = child.type && child.type.role;
      const childName = child.props.name || `${childRole}-${names[index2]}`;
      if (child.props && child.props.children) {
        const childProps = Object.assign({}, child.props, _pick(parentProps, sharedProps));
        const nestedChildren = child.type && child.type.role === "stack" && isFunction$1(child.type.getChildren) ? child.type.getChildren(childProps) : React__default.Children.toArray(child.props.children).map((c7) => {
          const nestedChildProps = Object.assign({}, c7.props, _pick(childProps, sharedProps));
          return /* @__PURE__ */ React__default.cloneElement(c7, nestedChildProps);
        });
        const childNames2 = nestedChildren.map((c7, i2) => `${childName}-${i2}`);
        const nestedResults = traverseChildren(nestedChildren, childNames2, child);
        newMemo = combine2(newMemo, nestedResults);
      } else {
        const result = iteratee(child, childName, parent2);
        if (result) {
          newMemo = combine2(newMemo, result);
        }
      }
      return newMemo;
    }, initialMemo);
  };
  const validChildren = children2.filter(isValidElement);
  const childNames = validChildren.map((c7, i2) => i2);
  return traverseChildren(validChildren, childNames);
}
function isHorizontal(props2) {
  if (props2.horizontal !== void 0 || !props2.children) {
    return props2.horizontal;
  }
  const traverseChildren = (childArray) => {
    return childArray.reduce((memo, child) => {
      const childProps = child.props || {};
      if (memo || childProps.horizontal || !childProps.children) {
        return memo || childProps.horizontal;
      }
      return traverseChildren(React__default.Children.toArray(childProps.children));
    }, false);
  };
  return traverseChildren(React__default.Children.toArray(props2.children));
}
const USER_PROPS_SAFELIST = {
  startsWith: ["data-", "aria-"],
  exactMatch: []
};
const doesPropStartWith = (key) => {
  let startsWith = false;
  USER_PROPS_SAFELIST.startsWith.forEach((starterString) => {
    const regex2 = new RegExp(`\\b(${starterString})(\\w|-)+`, "g");
    if (regex2.test(key))
      startsWith = true;
  });
  return startsWith;
};
const isExactMatch = (key) => USER_PROPS_SAFELIST.exactMatch.includes(key);
const testIfSafeProp = (key) => {
  if (doesPropStartWith(key) || isExactMatch(key))
    return true;
  return false;
};
function assert(value, message) {
  if (value === void 0 || value === null) {
    throw new Error(message);
  }
}
const getSafeUserProps = (props2) => {
  const propsToFilter = {
    ...props2
  };
  return Object.fromEntries(Object.entries(propsToFilter).filter((_ref2) => {
    let [key] = _ref2;
    return testIfSafeProp(key);
  }).map((_ref2) => {
    let [key, value] = _ref2;
    return [key, evaluateProp(value, props2)];
  }));
};
const withSafeUserProps = (component, props2) => {
  return /* @__PURE__ */ React.cloneElement(component, getSafeUserProps(props2));
};
function _extends$5() {
  _extends$5 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
class VictoryContainer extends React__default.Component {
  // @ts-expect-error Ref will be initialized on mount
  // @ts-expect-error Ref will be initialized on mount
  constructor(props2) {
    super(props2);
    __publicField(this, "savePortalRef", (portal) => {
      this.portalRef = portal;
      return portal;
    });
    __publicField(this, "portalUpdate", (key, el) => this.portalRef.portalUpdate(key, el));
    __publicField(this, "portalRegister", () => this.portalRef.portalRegister());
    __publicField(this, "portalDeregister", (key) => this.portalRef.portalDeregister(key));
    __publicField(this, "saveContainerRef", (container2) => {
      if (isFunction$1(this.props.containerRef)) {
        this.props.containerRef(container2);
      }
      this.containerRef = container2;
      return container2;
    });
    __publicField(this, "handleWheel", (e3) => e3.preventDefault());
    this.containerId = !_isObject(props2) || props2.containerId === void 0 ? _uniqueId("victory-container-") : props2.containerId;
    this.shouldHandleWheel = !!(props2 && props2.events && props2.events.onWheel);
  }
  componentDidMount() {
    if (this.shouldHandleWheel && this.containerRef) {
      this.containerRef.addEventListener("wheel", this.handleWheel);
    }
  }
  componentWillUnmount() {
    if (this.shouldHandleWheel && this.containerRef) {
      this.containerRef.removeEventListener("wheel", this.handleWheel);
    }
  }
  getIdForElement(elementName) {
    return `${this.containerId}-${elementName}`;
  }
  // overridden in custom containers
  getChildren(props2) {
    return props2.children;
  }
  // Get props defined by the Open UI Automation (OUIA) 1.0-RC spec
  // See https://ouia.readthedocs.io/en/latest/README.html#ouia-component
  getOUIAProps(props2) {
    const {
      ouiaId,
      ouiaSafe,
      ouiaType
    } = props2;
    return {
      ...ouiaId && {
        "data-ouia-component-id": ouiaId
      },
      ...ouiaType && {
        "data-ouia-component-type": ouiaType
      },
      ...ouiaSafe !== void 0 && {
        "data-ouia-safe": ouiaSafe
      }
    };
  }
  renderContainer(props2, svgProps, style2) {
    const {
      title,
      desc,
      portalComponent,
      className,
      width,
      height,
      portalZIndex,
      responsive: responsive3
    } = props2;
    const children2 = this.getChildren(props2);
    const dimensions = responsive3 ? {
      width: "100%",
      height: "100%"
    } : {
      width,
      height
    };
    const divStyle = Object.assign({
      pointerEvents: "none",
      touchAction: "none",
      position: "relative"
    }, dimensions);
    const portalDivStyle = Object.assign({
      zIndex: portalZIndex,
      position: "absolute",
      top: 0,
      left: 0
    }, dimensions);
    const svgStyle = Object.assign({
      pointerEvents: "all"
    }, dimensions);
    const portalSvgStyle = Object.assign({
      overflow: "visible"
    }, dimensions);
    const portalProps = {
      width,
      height,
      viewBox: svgProps.viewBox,
      preserveAspectRatio: svgProps.preserveAspectRatio,
      style: portalSvgStyle
    };
    return /* @__PURE__ */ React__default.createElement(PortalContext.Provider, {
      value: {
        portalUpdate: this.portalUpdate,
        portalRegister: this.portalRegister,
        portalDeregister: this.portalDeregister
      }
    }, /* @__PURE__ */ React__default.createElement("div", _extends$5({
      style: _defaults({}, style2, divStyle),
      className,
      ref: this.saveContainerRef
    }, this.getOUIAProps(props2)), /* @__PURE__ */ React__default.createElement("svg", _extends$5({}, svgProps, {
      style: svgStyle
    }), title ? /* @__PURE__ */ React__default.createElement("title", {
      id: this.getIdForElement("title")
    }, title) : null, desc ? /* @__PURE__ */ React__default.createElement("desc", {
      id: this.getIdForElement("desc")
    }, desc) : null, children2), /* @__PURE__ */ React__default.createElement("div", {
      style: portalDivStyle
    }, /* @__PURE__ */ React__default.cloneElement(portalComponent, {
      ...portalProps,
      ref: this.savePortalRef
    }))));
  }
  render() {
    const {
      width,
      height,
      responsive: responsive3,
      events,
      title,
      desc,
      tabIndex,
      preserveAspectRatio,
      role
    } = this.props;
    const style2 = responsive3 ? this.props.style : omit(this.props.style, ["height", "width"]);
    const userProps = getSafeUserProps(this.props);
    const svgProps = Object.assign({
      width,
      height,
      tabIndex,
      role,
      "aria-labelledby": [title && this.getIdForElement("title"), this.props["aria-labelledby"]].filter(Boolean).join(" ") || void 0,
      "aria-describedby": [desc && this.getIdForElement("desc"), this.props["aria-describedby"]].filter(Boolean).join(" ") || void 0,
      viewBox: responsive3 ? `0 0 ${width} ${height}` : void 0,
      preserveAspectRatio: responsive3 ? preserveAspectRatio : void 0,
      ...userProps
    }, events);
    return this.renderContainer(this.props, svgProps, style2);
  }
}
__publicField(VictoryContainer, "displayName", "VictoryContainer");
__publicField(VictoryContainer, "role", "container");
__publicField(VictoryContainer, "defaultProps", {
  className: "VictoryContainer",
  portalComponent: /* @__PURE__ */ React__default.createElement(Portal, null),
  portalZIndex: 99,
  responsive: true,
  role: "img"
});
__publicField(VictoryContainer, "contextType", TimerContext);
var baseKeys = _baseKeys, getTag = _getTag, isArguments4 = isArguments_1, isArray$1 = isArray_1, isArrayLike = isArrayLike_1, isBuffer$1 = isBufferExports, isPrototype = _isPrototype, isTypedArray$1 = isTypedArray_1;
var mapTag = "[object Map]", setTag = "[object Set]";
var objectProto = Object.prototype;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) && (isArray$1(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer$1(value) || isTypedArray$1(value) || isArguments4(value))) {
    return !value.length;
  }
  var tag2 = getTag(value);
  if (tag2 == mapTag || tag2 == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty$1.call(value, key)) {
      return false;
    }
  }
  return true;
}
var isEmpty_1 = isEmpty;
const _isEmpty = /* @__PURE__ */ getDefaultExportFromCjs(isEmpty_1);
function warn(message) {
  if (process.env.NODE_ENV !== "production") {
    if (console && console.warn) {
      console.warn(message);
    }
  }
}
class VictoryPortal extends React__default.Component {
  componentDidMount() {
    if (!this.checkedContext) {
      if (typeof this.context.portalUpdate !== "function") {
        const msg = "`renderInPortal` is not supported outside of `VictoryContainer`. Component will be rendered in place";
        warn(msg);
        this.renderInPlace = true;
      }
      this.checkedContext = true;
    }
    this.forceUpdate();
  }
  componentDidUpdate() {
    if (!this.renderInPlace) {
      this.portalKey = this.portalKey || this.context.portalRegister();
      this.context.portalUpdate(this.portalKey, this.element);
    }
  }
  componentWillUnmount() {
    if (this.context && this.context.portalDeregister) {
      this.context.portalDeregister(this.portalKey);
    }
  }
  // Overridden in victory-core-native
  renderPortal(child) {
    if (this.renderInPlace) {
      return child;
    }
    this.element = child;
    return null;
  }
  render() {
    const children2 = Array.isArray(this.props.children) ? this.props.children[0] : this.props.children;
    const {
      groupComponent
    } = this.props;
    const childProps = children2 && children2.props || {};
    const standardProps = childProps.groupComponent ? {
      groupComponent,
      standalone: false
    } : {};
    const newProps = _defaults(standardProps, childProps, omit(this.props, ["children", "groupComponent"]));
    const child = children2 && /* @__PURE__ */ React__default.cloneElement(children2, newProps);
    return this.renderPortal(child);
  }
}
__publicField(VictoryPortal, "displayName", "VictoryPortal");
__publicField(VictoryPortal, "role", "portal");
__publicField(VictoryPortal, "defaultProps", {
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null)
});
__publicField(VictoryPortal, "contextType", PortalContext);
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
const Rect = /* @__PURE__ */ forwardRef((props2, ref2) => {
  var _a2;
  const {
    desc,
    id,
    tabIndex,
    origin,
    ...rest
  } = props2;
  const svgProps = {
    vectorEffect: "non-scaling-stroke",
    id: (_a2 = evaluateProp(id, props2)) == null ? void 0 : _a2.toString(),
    tabIndex: evaluateProp(tabIndex, props2),
    ...rest
  };
  return desc ? /* @__PURE__ */ React__default.createElement("rect", _extends$4({}, svgProps, {
    ref: ref2
  }), /* @__PURE__ */ React__default.createElement("desc", null, desc)) : /* @__PURE__ */ React__default.createElement("rect", _extends$4({}, svgProps, {
    ref: ref2
  }));
});
const Text2 = (props2) => {
  var _a2;
  const {
    children: children2,
    desc,
    id,
    origin,
    tabIndex,
    title,
    ...rest
  } = props2;
  const svgProps = {
    id: (_a2 = evaluateProp(id, props2)) == null ? void 0 : _a2.toString(),
    tabIndex: evaluateProp(tabIndex, props2),
    ...rest
  };
  return /* @__PURE__ */ React__default.createElement("text", svgProps, title && /* @__PURE__ */ React__default.createElement("title", null, title), desc && /* @__PURE__ */ React__default.createElement("desc", null, desc), children2);
};
const TSpan = (props2) => {
  var _a2;
  const {
    desc,
    id,
    tabIndex,
    origin,
    ...rest
  } = props2;
  const svgProps = {
    id: (_a2 = evaluateProp(id, props2)) == null ? void 0 : _a2.toString(),
    tabIndex: evaluateProp(tabIndex, props2),
    ...rest
  };
  return /* @__PURE__ */ React__default.createElement("tspan", svgProps);
};
function getVerticalAnchor(props2, datum) {
  if (datum === void 0) {
    datum = {};
  }
  const sign2 = datum._y >= 0 ? 1 : -1;
  const labelStyle = props2.style && props2.style.labels || {};
  if (datum.verticalAnchor || labelStyle.verticalAnchor) {
    return datum.verticalAnchor || labelStyle.verticalAnchor;
  } else if (!props2.horizontal) {
    return sign2 >= 0 ? "end" : "start";
  }
  return "middle";
}
function getTextAnchor(props2, datum) {
  if (datum === void 0) {
    datum = {};
  }
  const {
    style: style2,
    horizontal
  } = props2;
  const sign2 = datum._y >= 0 ? 1 : -1;
  const labelStyle = style2 && style2.labels || {};
  if (datum.verticalAnchor || labelStyle.verticalAnchor) {
    return datum.verticalAnchor || labelStyle.verticalAnchor;
  } else if (!horizontal) {
    return "middle";
  }
  return sign2 >= 0 ? "start" : "end";
}
function getAngle$1(props2, datum) {
  if (datum === void 0) {
    datum = {};
  }
  const labelStyle = props2.style && props2.style.labels || {};
  return datum.angle === void 0 ? labelStyle.angle : datum.angle;
}
function getPadding(props2, datum) {
  if (datum === void 0) {
    datum = {};
  }
  const {
    horizontal,
    style: style2
  } = props2;
  const labelStyle = style2.labels || {};
  const defaultPadding = evaluateProp(labelStyle.padding, props2) || 0;
  const sign2 = datum._y < 0 ? -1 : 1;
  return {
    x: horizontal ? sign2 * defaultPadding : 0,
    y: horizontal ? 0 : -1 * sign2 * defaultPadding
  };
}
function getOffset$1(props2, datum) {
  if (props2.polar) {
    return {};
  }
  const padding2 = getPadding(props2, datum);
  return {
    dx: padding2.x,
    dy: padding2.y
  };
}
function getPosition$3(props2, datum) {
  const {
    polar
  } = props2;
  const {
    x: x3,
    y: y4
  } = scalePoint(props2, datum);
  if (!polar) {
    return {
      x: x3,
      y: y4
    };
  }
  const polarPadding = getPolarPadding(props2, datum);
  return {
    x: x3 + polarPadding.x,
    y: y4 + polarPadding.y
  };
}
function getPolarPadding(props2, datum) {
  const {
    style: style2
  } = props2;
  const degrees = getDegrees(props2, datum);
  const labelStyle = style2.labels || {};
  const padding2 = evaluateProp(labelStyle.padding, props2) || 0;
  const angle = degreesToRadians(degrees);
  return {
    x: padding2 * Math.cos(angle),
    y: -padding2 * Math.sin(angle)
  };
}
function getLabelPlacement(props2) {
  const {
    labelComponent,
    labelPlacement,
    polar
  } = props2;
  const defaultLabelPlacement = polar ? "perpendicular" : "vertical";
  return labelPlacement ? labelPlacement : labelComponent.props && labelComponent.props.labelPlacement || defaultLabelPlacement;
}
function getPolarOrientation(degrees) {
  if (degrees < 45 || degrees > 315) {
    return "right";
  } else if (degrees >= 45 && degrees <= 135) {
    return "top";
  } else if (degrees > 135 && degrees < 225) {
    return "left";
  }
  return "bottom";
}
function getText(props2, datum, index2) {
  if (datum === void 0) {
    datum = {};
  }
  if (datum.label !== void 0) {
    return datum.label;
  }
  return Array.isArray(props2.labels) ? props2.labels[index2] : props2.labels;
}
function getPolarTextAnchor(props2, degrees) {
  const labelPlacement = getLabelPlacement(props2);
  if (labelPlacement === "perpendicular" || labelPlacement === "vertical" && (degrees === 90 || degrees === 270)) {
    return "middle";
  }
  return degrees <= 90 || degrees > 270 ? "start" : "end";
}
function getPolarVerticalAnchor(props2, degrees) {
  const labelPlacement = getLabelPlacement(props2);
  const orientation = getPolarOrientation(degrees);
  if (labelPlacement === "parallel" || orientation === "left" || orientation === "right") {
    return "middle";
  }
  return orientation === "top" ? "end" : "start";
}
function getPolarAngle(props2, baseAngle) {
  const {
    labelPlacement,
    datum
  } = props2;
  if (!labelPlacement || labelPlacement === "vertical") {
    return 0;
  }
  const degrees = baseAngle !== void 0 ? baseAngle % 360 : getDegrees(props2, datum);
  const sign2 = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
  let angle = 0;
  if (degrees === 0 || degrees === 180) {
    angle = 90;
  } else if (degrees > 0 && degrees < 180) {
    angle = 90 - degrees;
  } else if (degrees > 180 && degrees < 360) {
    angle = 270 - degrees;
  }
  const labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
  return angle + sign2 * labelRotation;
}
function getDegrees(props2, datum) {
  const {
    x: x3
  } = getPoint(datum);
  return radiansToDegrees(props2.scale.x(x3)) % 360;
}
function getProps(props2, index2) {
  const {
    scale,
    data,
    style: style2,
    horizontal,
    polar,
    width,
    height,
    theme: theme2,
    labelComponent,
    disableInlineStyles
  } = props2;
  const datum = data[index2];
  const degrees = getDegrees(props2, datum);
  const textAnchor = polar ? getPolarTextAnchor(props2, degrees) : getTextAnchor(props2, datum);
  const verticalAnchor = polar ? getPolarVerticalAnchor(props2, degrees) : getVerticalAnchor(props2, datum);
  const angle = getAngle$1(props2, datum);
  const text2 = getText(props2, datum, index2);
  const labelPlacement = getLabelPlacement(props2);
  const {
    x: x3,
    y: y4
  } = getPosition$3(props2, datum);
  const {
    dx,
    dy
  } = getOffset$1(props2, datum);
  const labelProps = {
    angle,
    data,
    datum,
    disableInlineStyles,
    horizontal,
    index: index2,
    polar,
    scale,
    labelPlacement,
    text: text2,
    textAnchor,
    verticalAnchor,
    x: x3,
    y: y4,
    dx,
    dy,
    width,
    height,
    style: style2.labels
  };
  if (!isTooltip(labelComponent)) {
    return labelProps;
  }
  const tooltipTheme = theme2 && theme2.tooltip || {};
  return _defaults({}, labelProps, omit(tooltipTheme, ["style"]));
}
const toTransformString = function(obj) {
  for (var _len = arguments.length, more = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    more[_key - 1] = arguments[_key];
  }
  if (more.length > 0) {
    return more.reduce((memo, currentObj) => {
      return [memo, toTransformString(currentObj)].join(" ");
    }, toTransformString(obj)).trim();
  }
  if (obj === void 0 || obj === null || typeof obj === "string") {
    return obj;
  }
  const transforms2 = [];
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      transforms2.push(`${key}(${value})`);
    }
  }
  return transforms2.join(" ").trim();
};
const fonts = {
  "American Typewriter": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.4203125, 0.3296875, 0.6, 0.6375, 0.8015625, 0.8203125, 0.1875, 0.45625, 0.45625, 0.6375, 0.5, 0.2734375, 0.309375, 0.2734375, 0.4390625, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.6375, 0.2734375, 0.2734375, 0.5, 0.5, 0.5, 0.6, 0.6921875, 0.7640625, 0.6921875, 0.6375, 0.728125, 0.6734375, 0.6203125, 0.7109375, 0.784375, 0.3828125, 0.6421875, 0.7859375, 0.6375, 0.9484375, 0.7640625, 0.65625, 0.6375, 0.65625, 0.7296875, 0.6203125, 0.6375, 0.7109375, 0.740625, 0.940625, 0.784375, 0.7578125, 0.6203125, 0.4375, 0.5, 0.4375, 0.5, 0.5, 0.4921875, 0.5734375, 0.5890625, 0.5109375, 0.6, 0.528125, 0.43125, 0.5578125, 0.6375, 0.3109375, 0.40625, 0.6234375, 0.309375, 0.928125, 0.6375, 0.546875, 0.6, 0.58125, 0.4921875, 0.4921875, 0.4, 0.6203125, 0.625, 0.825, 0.6375, 0.640625, 0.528125, 0.5, 0.5, 0.5, 0.6671875],
    avg: 0.5793421052631578
  },
  Arial: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.278125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.584375, 0.584375, 0.584375, 0.55625, 1.015625, 0.6703125, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.278125, 0.278125, 0.4703125, 0.584375, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.3125, 0.55625, 0.55625, 0.2234375, 0.2703125, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.346875, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.528733552631579
  },
  "Arial Black": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.33125, 0.334375, 0.5, 0.6609375, 0.6671875, 1, 0.890625, 0.278125, 0.390625, 0.390625, 0.55625, 0.6609375, 0.334375, 0.334375, 0.334375, 0.28125, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.334375, 0.6609375, 0.6609375, 0.6609375, 0.6109375, 0.7453125, 0.78125, 0.778125, 0.778125, 0.778125, 0.7234375, 0.6671875, 0.834375, 0.834375, 0.390625, 0.6671875, 0.834375, 0.6671875, 0.9453125, 0.834375, 0.834375, 0.7234375, 0.834375, 0.78125, 0.7234375, 0.7234375, 0.834375, 0.7796875, 1.003125, 0.78125, 0.78125, 0.7234375, 0.390625, 0.28125, 0.390625, 0.6609375, 0.5125, 0.334375, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.41875, 0.6671875, 0.6671875, 0.334375, 0.384375, 0.6671875, 0.334375, 1, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.4703125, 0.6109375, 0.4453125, 0.6671875, 0.6140625, 0.946875, 0.6671875, 0.615625, 0.55625, 0.390625, 0.278125, 0.390625, 0.6609375],
    avg: 0.6213157894736842
  },
  Baskerville: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.25, 0.40625, 0.6671875, 0.490625, 0.875, 0.7015625, 0.178125, 0.2453125, 0.246875, 0.4171875, 0.6671875, 0.25, 0.3125, 0.25, 0.521875, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.6671875, 0.6671875, 0.6671875, 0.396875, 0.9171875, 0.684375, 0.615625, 0.71875, 0.7609375, 0.625, 0.553125, 0.771875, 0.803125, 0.3546875, 0.515625, 0.78125, 0.6046875, 0.928125, 0.75, 0.8234375, 0.5625, 0.96875, 0.7296875, 0.5421875, 0.6984375, 0.771875, 0.7296875, 0.9484375, 0.771875, 0.678125, 0.6359375, 0.3640625, 0.521875, 0.3640625, 0.46875, 0.5125, 0.334375, 0.46875, 0.521875, 0.428125, 0.521875, 0.4375, 0.3890625, 0.4765625, 0.53125, 0.25, 0.359375, 0.4640625, 0.240625, 0.803125, 0.53125, 0.5, 0.521875, 0.521875, 0.365625, 0.334375, 0.2921875, 0.521875, 0.4640625, 0.678125, 0.4796875, 0.465625, 0.428125, 0.4796875, 0.5109375, 0.4796875, 0.6671875],
    avg: 0.5323519736842108
  },
  Courier: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  "Courier New": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6015296052631579
  },
  cursive: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.1921875, 0.24375, 0.40625, 0.5671875, 0.3984375, 0.721875, 0.909375, 0.2328125, 0.434375, 0.365625, 0.4734375, 0.5578125, 0.19375, 0.3484375, 0.19375, 0.7734375, 0.503125, 0.4171875, 0.5453125, 0.45, 0.6046875, 0.4703125, 0.5984375, 0.55625, 0.503125, 0.5546875, 0.20625, 0.2, 0.5625, 0.5546875, 0.546875, 0.403125, 0.70625, 0.734375, 0.7078125, 0.64375, 0.85, 0.753125, 0.75, 0.6484375, 1.0765625, 0.44375, 0.5359375, 0.8359375, 0.653125, 1.0109375, 1.1515625, 0.6796875, 0.6984375, 1.0625, 0.8234375, 0.5125, 0.9234375, 0.8546875, 0.70625, 0.9109375, 0.7421875, 0.715625, 0.6015625, 0.4640625, 0.3359375, 0.4109375, 0.5421875, 0.5421875, 0.4328125, 0.5125, 0.5, 0.3859375, 0.7375, 0.359375, 0.75625, 0.540625, 0.5328125, 0.3203125, 0.5296875, 0.5015625, 0.484375, 0.7890625, 0.5640625, 0.4203125, 0.703125, 0.471875, 0.4734375, 0.35, 0.4125, 0.5640625, 0.471875, 0.6484375, 0.5296875, 0.575, 0.4140625, 0.415625, 0.20625, 0.3796875, 0.5421875],
    avg: 0.5604440789473684
  },
  fantasy: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.2625, 0.3265625, 0.6109375, 0.534375, 0.7625, 0.7828125, 0.2, 0.4359375, 0.4359375, 0.3765625, 0.5109375, 0.2796875, 0.4609375, 0.2796875, 0.5296875, 0.6640625, 0.253125, 0.521875, 0.4765625, 0.6640625, 0.490625, 0.528125, 0.5546875, 0.496875, 0.5421875, 0.2796875, 0.2796875, 0.5625, 0.4609375, 0.5625, 0.4828125, 0.609375, 0.740625, 0.7234375, 0.740625, 0.8265625, 0.7234375, 0.6171875, 0.7359375, 0.765625, 0.240625, 0.5453125, 0.715625, 0.6078125, 0.8640625, 0.653125, 0.9125, 0.6484375, 0.946875, 0.6921875, 0.653125, 0.6953125, 0.8015625, 0.58125, 0.784375, 0.671875, 0.6265625, 0.690625, 0.4359375, 0.5296875, 0.4359375, 0.53125, 0.5, 0.2875, 0.5375, 0.603125, 0.4984375, 0.60625, 0.53125, 0.434375, 0.6421875, 0.56875, 0.209375, 0.4671875, 0.5484375, 0.2203125, 0.709375, 0.55, 0.5984375, 0.6140625, 0.5765625, 0.40625, 0.4734375, 0.3734375, 0.559375, 0.4421875, 0.6421875, 0.4890625, 0.578125, 0.4484375, 0.2546875, 0.2203125, 0.2546875, 0.55],
    avg: 0.536496710526316
  },
  Geneva: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3328125, 0.3046875, 0.5, 0.6671875, 0.6671875, 0.90625, 0.728125, 0.3046875, 0.446875, 0.446875, 0.5078125, 0.6671875, 0.3046875, 0.3796875, 0.3046875, 0.5390625, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.6671875, 0.3046875, 0.3046875, 0.6671875, 0.6671875, 0.6671875, 0.56875, 0.871875, 0.728125, 0.6375, 0.6515625, 0.7015625, 0.5765625, 0.5546875, 0.675, 0.690625, 0.2421875, 0.4921875, 0.6640625, 0.584375, 0.7890625, 0.709375, 0.7359375, 0.584375, 0.78125, 0.60625, 0.60625, 0.640625, 0.6671875, 0.728125, 0.946875, 0.6109375, 0.6109375, 0.5765625, 0.446875, 0.5390625, 0.446875, 0.6671875, 0.6671875, 0.5921875, 0.5546875, 0.6109375, 0.546875, 0.603125, 0.5765625, 0.390625, 0.6109375, 0.584375, 0.2359375, 0.334375, 0.5390625, 0.2359375, 0.8953125, 0.584375, 0.60625, 0.603125, 0.603125, 0.3875, 0.509375, 0.44375, 0.584375, 0.565625, 0.78125, 0.53125, 0.571875, 0.5546875, 0.4515625, 0.246875, 0.4515625, 0.6671875],
    avg: 0.5762664473684211
  },
  Georgia: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2421875, 0.33125, 0.4125, 0.64375, 0.6109375, 0.81875, 0.7109375, 0.215625, 0.375, 0.375, 0.4734375, 0.64375, 0.2703125, 0.375, 0.2703125, 0.46875, 0.6140625, 0.4296875, 0.559375, 0.553125, 0.565625, 0.5296875, 0.5671875, 0.503125, 0.596875, 0.5671875, 0.3125, 0.3125, 0.64375, 0.64375, 0.64375, 0.4796875, 0.9296875, 0.715625, 0.6546875, 0.6421875, 0.75, 0.6546875, 0.6, 0.7265625, 0.815625, 0.390625, 0.51875, 0.7203125, 0.6046875, 0.928125, 0.7671875, 0.7453125, 0.6109375, 0.7453125, 0.7234375, 0.5625, 0.61875, 0.7578125, 0.70625, 0.99375, 0.7125, 0.6640625, 0.6015625, 0.375, 0.46875, 0.375, 0.64375, 0.65, 0.5, 0.5046875, 0.56875, 0.4546875, 0.575, 0.484375, 0.39375, 0.509375, 0.5828125, 0.29375, 0.3671875, 0.546875, 0.2875, 0.88125, 0.5921875, 0.5390625, 0.571875, 0.5640625, 0.4109375, 0.4328125, 0.3453125, 0.5765625, 0.5203125, 0.75625, 0.50625, 0.5171875, 0.4453125, 0.43125, 0.375, 0.43125, 0.64375],
    avg: 0.5551809210526316
  },
  "Gill Sans": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2765625, 0.271875, 0.3546875, 0.584375, 0.5421875, 0.6765625, 0.625, 0.1890625, 0.3234375, 0.3234375, 0.4171875, 0.584375, 0.2203125, 0.3234375, 0.2203125, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.2203125, 0.2296875, 0.584375, 0.584375, 0.584375, 0.334375, 1.0109375, 0.6671875, 0.5640625, 0.709375, 0.75, 0.5, 0.4703125, 0.740625, 0.7296875, 0.25, 0.3125, 0.65625, 0.490625, 0.78125, 0.78125, 0.8234375, 0.5109375, 0.8234375, 0.6046875, 0.459375, 0.6046875, 0.709375, 0.6046875, 1.0421875, 0.709375, 0.6046875, 0.646875, 0.334375, 0.28125, 0.334375, 0.4703125, 0.5828125, 0.334375, 0.428125, 0.5, 0.4390625, 0.5109375, 0.4796875, 0.296875, 0.428125, 0.5, 0.2203125, 0.2265625, 0.5, 0.2203125, 0.771875, 0.5, 0.553125, 0.5, 0.5, 0.3984375, 0.3859375, 0.334375, 0.5, 0.4390625, 0.7203125, 0.5, 0.4390625, 0.4171875, 0.334375, 0.2609375, 0.334375, 0.584375],
    avg: 0.4933717105263159
  },
  Helvetica: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2796875, 0.2765625, 0.3546875, 0.5546875, 0.5546875, 0.8890625, 0.665625, 0.190625, 0.3328125, 0.3328125, 0.3890625, 0.5828125, 0.2765625, 0.3328125, 0.2765625, 0.3015625, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.2765625, 0.2765625, 0.584375, 0.5828125, 0.584375, 0.5546875, 1.0140625, 0.665625, 0.665625, 0.721875, 0.721875, 0.665625, 0.609375, 0.7765625, 0.721875, 0.2765625, 0.5, 0.665625, 0.5546875, 0.8328125, 0.721875, 0.7765625, 0.665625, 0.7765625, 0.721875, 0.665625, 0.609375, 0.721875, 0.665625, 0.94375, 0.665625, 0.665625, 0.609375, 0.2765625, 0.3546875, 0.2765625, 0.4765625, 0.5546875, 0.3328125, 0.5546875, 0.5546875, 0.5, 0.5546875, 0.5546875, 0.2765625, 0.5546875, 0.5546875, 0.221875, 0.240625, 0.5, 0.221875, 0.8328125, 0.5546875, 0.5546875, 0.5546875, 0.5546875, 0.3328125, 0.5, 0.2765625, 0.5546875, 0.5, 0.721875, 0.5, 0.5, 0.5, 0.3546875, 0.259375, 0.353125, 0.5890625],
    avg: 0.5279276315789471
  },
  "Helvetica Neue": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.259375, 0.4265625, 0.55625, 0.55625, 1, 0.6453125, 0.278125, 0.2703125, 0.26875, 0.353125, 0.6, 0.278125, 0.3890625, 0.278125, 0.36875, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.6, 0.6, 0.6, 0.55625, 0.8, 0.6625, 0.6859375, 0.7234375, 0.7046875, 0.6125, 0.575, 0.759375, 0.7234375, 0.259375, 0.5203125, 0.6703125, 0.55625, 0.871875, 0.7234375, 0.7609375, 0.6484375, 0.7609375, 0.6859375, 0.6484375, 0.575, 0.7234375, 0.6140625, 0.9265625, 0.6125, 0.6484375, 0.6125, 0.259375, 0.36875, 0.259375, 0.6, 0.5, 0.25625, 0.5375, 0.59375, 0.5375, 0.59375, 0.5375, 0.2984375, 0.575, 0.55625, 0.2234375, 0.2375, 0.5203125, 0.2234375, 0.853125, 0.55625, 0.575, 0.59375, 0.59375, 0.334375, 0.5, 0.315625, 0.55625, 0.5, 0.759375, 0.51875, 0.5, 0.48125, 0.334375, 0.2234375, 0.334375, 0.6],
    avg: 0.5279440789473684
  },
  "Hoefler Text": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2359375, 0.2234375, 0.3921875, 0.7125, 0.49375, 0.8859375, 0.771875, 0.2125, 0.3078125, 0.309375, 0.375, 0.4234375, 0.234375, 0.3125, 0.234375, 0.3, 0.5828125, 0.365625, 0.434375, 0.3921875, 0.5234375, 0.3984375, 0.5125, 0.4328125, 0.46875, 0.5125, 0.234375, 0.234375, 0.515625, 0.4234375, 0.515625, 0.340625, 0.7609375, 0.7359375, 0.6359375, 0.721875, 0.8125, 0.6375, 0.5875, 0.8078125, 0.853125, 0.4296875, 0.503125, 0.78125, 0.609375, 0.9609375, 0.8515625, 0.8140625, 0.6125, 0.8140625, 0.71875, 0.49375, 0.7125, 0.76875, 0.771875, 1.125, 0.7765625, 0.7734375, 0.65625, 0.321875, 0.3078125, 0.321875, 0.3546875, 0.5, 0.3375, 0.446875, 0.5359375, 0.45, 0.5296875, 0.4546875, 0.425, 0.4921875, 0.54375, 0.2671875, 0.240625, 0.5390625, 0.25, 0.815625, 0.5375, 0.5234375, 0.5390625, 0.5421875, 0.365625, 0.36875, 0.35625, 0.5171875, 0.5015625, 0.75, 0.5, 0.509375, 0.44375, 0.2421875, 0.14375, 0.2421875, 0.35],
    avg: 0.5116447368421051
  },
  "Montserrat": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2625, 0.2609375, 0.3734375, 0.696875, 0.615625, 0.8296875, 0.6703125, 0.203125, 0.3296875, 0.3296875, 0.3875, 0.575, 0.2125, 0.3828125, 0.2125, 0.3953125, 0.6625, 0.3625, 0.56875, 0.5640625, 0.6625, 0.5671875, 0.609375, 0.5890625, 0.6390625, 0.609375, 0.2125, 0.2125, 0.575, 0.575, 0.575, 0.5671875, 1.034375, 0.7171875, 0.7546875, 0.7203125, 0.8265625, 0.6703125, 0.634375, 0.7734375, 0.8140625, 0.303125, 0.5078125, 0.7125, 0.5890625, 0.95625, 0.8140625, 0.8390625, 0.71875, 0.8390625, 0.7234375, 0.615625, 0.575, 0.7921875, 0.6984375, 1.1125, 0.65625, 0.6359375, 0.6515625, 0.31875, 0.396875, 0.31875, 0.5765625, 0.5, 0.6, 0.590625, 0.678125, 0.5640625, 0.678125, 0.6046875, 0.375, 0.6875, 0.678125, 0.2703125, 0.365625, 0.6015625, 0.2703125, 1.0625, 0.678125, 0.628125, 0.678125, 0.678125, 0.4015625, 0.4890625, 0.40625, 0.6734375, 0.5421875, 0.8796875, 0.534375, 0.5671875, 0.5125, 0.334375, 0.2953125, 0.334375, 0.575],
    avg: 0.571792763157895
  },
  monospace: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.5984375, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6078125, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.61875, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.615625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6140625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625, 0.6015625],
    avg: 0.6020559210526316
  },
  Overpass: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2296875, 0.2765625, 0.4203125, 0.68125, 0.584375, 0.8515625, 0.7015625, 0.2203125, 0.3453125, 0.3453125, 0.53125, 0.63125, 0.2234375, 0.3953125, 0.2234375, 0.509375, 0.65, 0.4046875, 0.6171875, 0.60625, 0.6484375, 0.60625, 0.6015625, 0.5375, 0.615625, 0.6015625, 0.2234375, 0.2234375, 0.63125, 0.63125, 0.63125, 0.5015625, 0.8203125, 0.696875, 0.6671875, 0.65, 0.6859375, 0.6015625, 0.559375, 0.690625, 0.7078125, 0.2953125, 0.565625, 0.678125, 0.58125, 0.8046875, 0.7109375, 0.740625, 0.6421875, 0.740625, 0.6765625, 0.6046875, 0.590625, 0.696875, 0.6640625, 0.853125, 0.65, 0.6671875, 0.6625, 0.3734375, 0.509375, 0.3734375, 0.63125, 0.5125, 0.4, 0.5328125, 0.5625, 0.51875, 0.5625, 0.546875, 0.3359375, 0.5625, 0.565625, 0.25625, 0.3203125, 0.55, 0.265625, 0.85, 0.565625, 0.5671875, 0.5625, 0.5625, 0.4046875, 0.4765625, 0.3796875, 0.565625, 0.521875, 0.7265625, 0.53125, 0.5390625, 0.5125, 0.3671875, 0.275, 0.3671875, 0.63125],
    avg: 0.5430756578947369
  },
  Palatino: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.25, 0.278125, 0.371875, 0.60625, 0.5, 0.840625, 0.778125, 0.209375, 0.334375, 0.334375, 0.390625, 0.60625, 0.2578125, 0.334375, 0.25, 0.60625, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.25, 0.25, 0.60625, 0.60625, 0.60625, 0.4453125, 0.7484375, 0.778125, 0.6109375, 0.709375, 0.775, 0.6109375, 0.55625, 0.7640625, 0.8328125, 0.3375, 0.346875, 0.7265625, 0.6109375, 0.946875, 0.83125, 0.7875, 0.6046875, 0.7875, 0.66875, 0.525, 0.6140625, 0.778125, 0.7234375, 1, 0.6671875, 0.6671875, 0.6671875, 0.334375, 0.60625, 0.334375, 0.60625, 0.5, 0.334375, 0.5, 0.565625, 0.4453125, 0.6109375, 0.4796875, 0.340625, 0.55625, 0.5828125, 0.2921875, 0.2671875, 0.5640625, 0.2921875, 0.8828125, 0.5828125, 0.546875, 0.6015625, 0.5609375, 0.3953125, 0.425, 0.3265625, 0.603125, 0.565625, 0.834375, 0.5171875, 0.55625, 0.5, 0.334375, 0.60625, 0.334375, 0.60625],
    avg: 0.5408552631578947
  },
  "RedHatText": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2328125, 0.2203125, 0.35625, 0.6890625, 0.55, 0.7390625, 0.6703125, 0.2140625, 0.4015625, 0.4015625, 0.4546875, 0.53125, 0.2203125, 0.45625, 0.2203125, 0.515625, 0.6609375, 0.3078125, 0.5484375, 0.5875, 0.61875, 0.5703125, 0.6203125, 0.559375, 0.6140625, 0.6203125, 0.2203125, 0.2234375, 0.465625, 0.534375, 0.465625, 0.5125, 0.7671875, 0.6609375, 0.6703125, 0.7265625, 0.728125, 0.6203125, 0.6109375, 0.8, 0.73125, 0.253125, 0.6, 0.6125, 0.6078125, 0.8625, 0.7390625, 0.8109375, 0.6546875, 0.809375, 0.6484375, 0.6234375, 0.6171875, 0.7125, 0.6609375, 0.8984375, 0.6546875, 0.646875, 0.60625, 0.3625, 0.5203125, 0.3625, 0.540625, 0.4609375, 0.5234375, 0.5265625, 0.584375, 0.509375, 0.5828125, 0.5578125, 0.3703125, 0.5828125, 0.553125, 0.2234375, 0.24375, 0.4890625, 0.2234375, 0.8453125, 0.553125, 0.58125, 0.584375, 0.5828125, 0.353125, 0.453125, 0.378125, 0.553125, 0.5015625, 0.6984375, 0.4875, 0.4984375, 0.459375, 0.3953125, 0.2921875, 0.3953125, 0.58125],
    avg: 0.5341940789473685
  },
  "sans-serif": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.278125, 0.278125, 0.35625, 0.55625, 0.55625, 0.890625, 0.6671875, 0.1921875, 0.334375, 0.334375, 0.390625, 0.584375, 0.278125, 0.334375, 0.278125, 0.303125, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.55625, 0.278125, 0.278125, 0.5859375, 0.584375, 0.5859375, 0.55625, 1.015625, 0.6671875, 0.6671875, 0.7234375, 0.7234375, 0.6671875, 0.6109375, 0.778125, 0.7234375, 0.278125, 0.5, 0.6671875, 0.55625, 0.834375, 0.7234375, 0.778125, 0.6671875, 0.778125, 0.7234375, 0.6671875, 0.6109375, 0.7234375, 0.6671875, 0.9453125, 0.6671875, 0.6671875, 0.6109375, 0.278125, 0.35625, 0.278125, 0.478125, 0.55625, 0.334375, 0.55625, 0.55625, 0.5, 0.55625, 0.55625, 0.278125, 0.55625, 0.55625, 0.2234375, 0.2421875, 0.5, 0.2234375, 0.834375, 0.55625, 0.55625, 0.55625, 0.55625, 0.334375, 0.5, 0.278125, 0.55625, 0.5, 0.7234375, 0.5, 0.5, 0.5, 0.35625, 0.2609375, 0.3546875, 0.590625],
    avg: 0.5293256578947368
  },
  Seravek: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.215625, 0.296875, 0.4171875, 0.6734375, 0.4953125, 0.9125, 0.740625, 0.2421875, 0.3375, 0.3375, 0.409375, 0.60625, 0.2609375, 0.35625, 0.25625, 0.41875, 0.5921875, 0.3515625, 0.475, 0.4875, 0.5375, 0.509375, 0.5484375, 0.4546875, 0.5421875, 0.5484375, 0.25625, 0.2546875, 0.5875, 0.6171875, 0.5875, 0.4578125, 0.8140625, 0.6765625, 0.5703125, 0.6109375, 0.684375, 0.5109375, 0.4953125, 0.678125, 0.6859375, 0.2625, 0.2625, 0.5859375, 0.4734375, 0.846875, 0.709375, 0.740625, 0.509375, 0.740625, 0.584375, 0.5015625, 0.528125, 0.675, 0.5953125, 0.9453125, 0.596875, 0.540625, 0.540625, 0.359375, 0.4203125, 0.359375, 0.5109375, 0.421875, 0.4046875, 0.5015625, 0.5421875, 0.446875, 0.5453125, 0.484375, 0.38125, 0.5140625, 0.5546875, 0.240625, 0.2640625, 0.490625, 0.2765625, 0.8625, 0.5546875, 0.546875, 0.5453125, 0.5453125, 0.3625, 0.41875, 0.3890625, 0.5453125, 0.4703125, 0.7546875, 0.4921875, 0.4609375, 0.453125, 0.4015625, 0.2640625, 0.4015625, 0.58125],
    avg: 0.5044078947368421
  },
  serif: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.278125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.7234375, 0.6109375, 0.890625, 0.7234375, 0.7234375, 0.55625, 0.7234375, 0.6671875, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.340625, 0.334375, 0.4703125, 0.5, 0.3453125, 0.4453125, 0.5, 0.4453125, 0.5, 0.4453125, 0.3828125, 0.5, 0.5, 0.278125, 0.3359375, 0.5, 0.278125, 0.778125, 0.5, 0.5, 0.5, 0.5, 0.3375, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5126315789473684
  },
  Tahoma: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3109375, 0.3328125, 0.4015625, 0.728125, 0.546875, 0.9765625, 0.70625, 0.2109375, 0.3828125, 0.3828125, 0.546875, 0.728125, 0.303125, 0.3640625, 0.303125, 0.3953125, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.546875, 0.3546875, 0.3546875, 0.728125, 0.728125, 0.728125, 0.475, 0.909375, 0.6109375, 0.590625, 0.6015625, 0.6796875, 0.5625, 0.521875, 0.66875, 0.6765625, 0.3734375, 0.4171875, 0.6046875, 0.4984375, 0.771875, 0.66875, 0.7078125, 0.5515625, 0.7078125, 0.6375, 0.5578125, 0.5875, 0.65625, 0.60625, 0.903125, 0.58125, 0.5890625, 0.559375, 0.3828125, 0.39375, 0.3828125, 0.728125, 0.5625, 0.546875, 0.525, 0.553125, 0.4625, 0.553125, 0.5265625, 0.3546875, 0.553125, 0.5578125, 0.2296875, 0.328125, 0.51875, 0.2296875, 0.840625, 0.5578125, 0.54375, 0.553125, 0.553125, 0.3609375, 0.446875, 0.3359375, 0.5578125, 0.4984375, 0.7421875, 0.4953125, 0.4984375, 0.4453125, 0.48125, 0.3828125, 0.48125, 0.728125],
    avg: 0.5384374999999998
  },
  "Times New Roman": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2484375, 0.334375, 0.409375, 0.5, 0.5, 0.834375, 0.778125, 0.18125, 0.334375, 0.334375, 0.5, 0.5640625, 0.25, 0.334375, 0.25, 0.28125, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.5, 0.278125, 0.278125, 0.5640625, 0.5640625, 0.5640625, 0.4453125, 0.921875, 0.7234375, 0.6671875, 0.6671875, 0.7234375, 0.6109375, 0.55625, 0.7234375, 0.7234375, 0.334375, 0.390625, 0.73125, 0.6109375, 0.890625, 0.7375, 0.7234375, 0.55625, 0.7234375, 0.6765625, 0.55625, 0.6109375, 0.7234375, 0.7234375, 0.9453125, 0.7234375, 0.7234375, 0.6109375, 0.334375, 0.28125, 0.334375, 0.4703125, 0.51875, 0.334375, 0.4453125, 0.503125, 0.4453125, 0.503125, 0.4453125, 0.4359375, 0.5, 0.5, 0.278125, 0.35625, 0.50625, 0.278125, 0.778125, 0.5, 0.5, 0.5046875, 0.5, 0.340625, 0.390625, 0.2796875, 0.5, 0.5, 0.7234375, 0.5, 0.5, 0.4453125, 0.48125, 0.2015625, 0.48125, 0.5421875],
    avg: 0.5134375
  },
  "Trebuchet MS": {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.3015625, 0.3671875, 0.325, 0.53125, 0.525, 0.6015625, 0.70625, 0.1609375, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.3671875, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.525, 0.3671875, 0.3671875, 0.525, 0.525, 0.525, 0.3671875, 0.771875, 0.590625, 0.5671875, 0.5984375, 0.6140625, 0.5359375, 0.525, 0.6765625, 0.6546875, 0.2796875, 0.4765625, 0.5765625, 0.5078125, 0.7109375, 0.6390625, 0.675, 0.5578125, 0.7421875, 0.5828125, 0.48125, 0.58125, 0.6484375, 0.5875, 0.853125, 0.5578125, 0.5703125, 0.5515625, 0.3671875, 0.3578125, 0.3671875, 0.525, 0.53125, 0.525, 0.5265625, 0.5578125, 0.4953125, 0.5578125, 0.546875, 0.375, 0.503125, 0.546875, 0.2859375, 0.3671875, 0.5046875, 0.2953125, 0.83125, 0.546875, 0.5375, 0.5578125, 0.5578125, 0.3890625, 0.40625, 0.396875, 0.546875, 0.490625, 0.7453125, 0.5015625, 0.49375, 0.475, 0.3671875, 0.525, 0.3671875, 0.525],
    avg: 0.5085197368421052
  },
  Verdana: {
    widths: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.35, 0.39375, 0.459375, 0.81875, 0.6359375, 1.0765625, 0.759375, 0.26875, 0.4546875, 0.4546875, 0.6359375, 0.81875, 0.3640625, 0.4546875, 0.3640625, 0.4703125, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.6359375, 0.4546875, 0.4546875, 0.81875, 0.81875, 0.81875, 0.546875, 1, 0.684375, 0.6859375, 0.6984375, 0.771875, 0.6328125, 0.575, 0.7765625, 0.7515625, 0.421875, 0.4546875, 0.69375, 0.5578125, 0.84375, 0.7484375, 0.7875, 0.603125, 0.7875, 0.7, 0.684375, 0.6171875, 0.7328125, 0.684375, 0.9890625, 0.6859375, 0.615625, 0.6859375, 0.4546875, 0.46875, 0.4546875, 0.81875, 0.6421875, 0.6359375, 0.6015625, 0.6234375, 0.521875, 0.6234375, 0.596875, 0.384375, 0.6234375, 0.6328125, 0.275, 0.3765625, 0.5921875, 0.275, 0.9734375, 0.6328125, 0.6078125, 0.6234375, 0.6234375, 0.43125, 0.521875, 0.3953125, 0.6328125, 0.5921875, 0.81875, 0.5921875, 0.5921875, 0.5265625, 0.6359375, 0.4546875, 0.6359375, 0.81875],
    avg: 0.6171875000000003
  }
};
const absoluteMeasurementUnitsToPixels = {
  mm: 3.8,
  sm: 38,
  pt: 1.33,
  pc: 16,
  in: 96,
  px: 1
};
const relativeMeasurementUnitsCoef = {
  em: 1,
  ex: 0.5
};
const coefficients = {
  heightOverlapCoef: 1.05,
  // Coefficient for height value to prevent overlap.
  lineCapitalCoef: 1.15
  // Coefficient for height value. Reserve space for capital chars.
};
const defaultStyle = {
  lineHeight: 1,
  letterSpacing: "0px",
  fontSize: 0,
  angle: 0,
  fontFamily: ""
};
const _degreeToRadian = (angle) => angle * Math.PI / 180;
const _getFontData = (fontFamily) => {
  const possibleFonts = fontFamily.split(",").map((f) => f.replace(/'|"/g, ""));
  const fontMatch = possibleFonts.find((f) => fonts[f]) || "Helvetica";
  return fonts[fontMatch];
};
const _splitToLines = (text2) => {
  return Array.isArray(text2) ? text2 : text2.toString().split(/\r\n|\r|\n/g);
};
const _getSizeWithRotate = (axisSize, dependentSize, angle) => {
  const angleInRadian = _degreeToRadian(angle);
  return Math.abs(Math.cos(angleInRadian) * axisSize) + Math.abs(Math.sin(angleInRadian) * dependentSize);
};
const convertLengthToPixels = (length2, fontSize2) => {
  var _a2;
  const attribute = (_a2 = length2.match(/[a-zA-Z%]+/)) == null ? void 0 : _a2[0];
  const value = Number(length2.match(/[0-9.,]+/));
  let result;
  if (!attribute) {
    result = value || 0;
  } else if (absoluteMeasurementUnitsToPixels.hasOwnProperty(attribute)) {
    result = value * absoluteMeasurementUnitsToPixels[attribute];
  } else if (relativeMeasurementUnitsCoef.hasOwnProperty(attribute)) {
    result = (fontSize2 ? value * fontSize2 : value * defaultStyle.fontSize) * relativeMeasurementUnitsCoef[attribute];
  } else {
    result = value;
  }
  return result;
};
const _prepareParams = (inputStyle, index2) => {
  const lineStyle = Array.isArray(inputStyle) ? inputStyle[index2] : inputStyle;
  const style2 = _defaults({}, lineStyle, defaultStyle);
  return Object.assign({}, style2, {
    fontFamily: style2.fontFamily,
    letterSpacing: typeof style2.letterSpacing === "number" ? style2.letterSpacing : convertLengthToPixels(String(style2.letterSpacing), style2.fontSize),
    fontSize: typeof style2.fontSize === "number" ? style2.fontSize : convertLengthToPixels(String(style2.fontSize))
  });
};
const _approximateTextWidthInternal = (text2, style2) => {
  if (text2 === void 0 || text2 === "" || text2 === null) {
    return 0;
  }
  const widths = _splitToLines(text2).map((line2, index2) => {
    const len = line2.toString().length;
    const {
      fontSize: fontSize2,
      letterSpacing: letterSpacing2,
      fontFamily
    } = _prepareParams(style2, index2);
    const fontData = _getFontData(fontFamily);
    const width = line2.toString().split("").map((c7) => {
      return c7.charCodeAt(0) < fontData.widths.length ? fontData.widths[c7.charCodeAt(0)] : fontData.avg;
    }).reduce((cur, acc) => acc + cur, 0) * fontSize2;
    return width + letterSpacing2 * Math.max(len - 1, 0);
  });
  return Math.max(...widths);
};
const _approximateTextHeightInternal = (text2, style2) => {
  if (text2 === void 0 || text2 === "" || text2 === null) {
    return 0;
  }
  return _splitToLines(text2).reduce((total, line2, index2) => {
    const lineStyle = _prepareParams(style2, index2);
    const containsCaps = line2.toString().match(/[(A-Z)(0-9)]/);
    const height = containsCaps ? lineStyle.fontSize * coefficients.lineCapitalCoef : lineStyle.fontSize;
    return total + lineStyle.lineHeight * height;
  }, 0);
};
const _approximateDimensionsInternal = (text2, style2) => {
  const angle = Array.isArray(style2) ? style2[0] && style2[0].angle : style2 && style2.angle;
  const height = _approximateTextHeightInternal(text2, style2);
  const width = _approximateTextWidthInternal(text2, style2);
  const widthWithRotate = angle ? _getSizeWithRotate(width, height, angle) : width;
  const heightWithRotate = angle ? _getSizeWithRotate(height, width, angle) : height;
  return {
    width: widthWithRotate,
    height: heightWithRotate * coefficients.heightOverlapCoef
  };
};
const _getMeasurementContainer = _memoize(() => {
  const element = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  element.setAttribute("xlink", "http://www.w3.org/1999/xlink");
  element.setAttribute("width", "300");
  element.setAttribute("height", "300");
  element.setAttribute("viewBox", "0 0 300 300");
  element.setAttribute("aria-hidden", "true");
  const containerElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
  element.appendChild(containerElement);
  element.style.position = "fixed";
  element.style.top = "-9999px";
  element.style.left = "-9999px";
  document.body.appendChild(element);
  return containerElement;
});
const styleToKeyComponent = (style2) => {
  if (!style2) {
    return "null";
  }
  return `${style2.angle}:${style2.fontFamily}:${style2.fontSize}:${style2.letterSpacing}:${style2.lineHeight}`;
};
const _measureDimensionsInternal = _memoize((text2, style2) => {
  var _a2, _b;
  let containerElement = _getMeasurementContainer();
  if (!containerElement.isConnected) {
    (_b = (_a2 = _getMeasurementContainer.cache).clear) == null ? void 0 : _b.call(_a2);
    containerElement = _getMeasurementContainer();
  }
  const lines = _splitToLines(text2);
  let heightAcc = 0;
  for (const [i2, line2] of lines.entries()) {
    const textElement = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
    const params = _prepareParams(style2, i2);
    textElement.style.fontFamily = params.fontFamily;
    textElement.style.fontSize = `${params.fontSize}px`;
    textElement.style.lineHeight = params.lineHeight;
    textElement.style.fontFamily = params.fontFamily;
    textElement.style.letterSpacing = params.letterSpacing;
    textElement.textContent = line2;
    textElement.setAttribute("x", "0");
    textElement.setAttribute("y", `${heightAcc}`);
    containerElement.appendChild(textElement);
    heightAcc += params.lineHeight * textElement.getBoundingClientRect().height;
  }
  const {
    width
  } = containerElement.getBoundingClientRect();
  containerElement.innerHTML = "";
  return {
    width: (style2 == null ? void 0 : style2.angle) ? _getSizeWithRotate(width, heightAcc, style2 == null ? void 0 : style2.angle) : width,
    height: (style2 == null ? void 0 : style2.angle) ? _getSizeWithRotate(heightAcc, width, style2 == null ? void 0 : style2.angle) : heightAcc
  };
}, (text2, style2) => {
  const totalText = Array.isArray(text2) ? text2.join() : text2;
  const totalStyle = Array.isArray(style2) ? style2.map(styleToKeyComponent).join() : styleToKeyComponent(style2);
  return `${totalText}::${totalStyle}`;
});
const _approximateTextSizeInternal = {
  impl: function(text2, style2, __debugForceApproximate) {
    if (__debugForceApproximate === void 0) {
      __debugForceApproximate = false;
    }
    const isClient = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
    if (!isClient || __debugForceApproximate) {
      return _approximateDimensionsInternal(text2, style2);
    }
    return _measureDimensionsInternal(text2, style2);
  }
};
const approximateTextSize = (text2, style2) => _approximateTextSizeInternal.impl(text2, style2);
const defaultStyles = {
  fill: "#252525",
  fontSize: 14,
  fontFamily: "'Gill Sans', 'Gill Sans MT', 'Ser­avek', 'Trebuchet MS', sans-serif",
  stroke: "transparent"
};
const getPosition$2 = (props2, dimension) => {
  if (!props2.datum) {
    return 0;
  }
  const scaledPoint = scalePoint(props2, props2.datum);
  return scaledPoint[dimension];
};
const getFontSize = (style2) => {
  const baseSize = style2 && style2.fontSize;
  if (typeof baseSize === "number") {
    return baseSize;
  } else if (baseSize === void 0 || baseSize === null) {
    return defaultStyles.fontSize;
  } else if (typeof baseSize === "string") {
    const fontSize2 = Number(baseSize.replace("px", ""));
    if (!isNaN(fontSize2)) {
      return fontSize2;
    }
    warn("fontSize should be expressed as a number of pixels");
    return defaultStyles.fontSize;
  }
  return defaultStyles.fontSize;
};
const getSingleValue = function(prop, index2) {
  if (index2 === void 0) {
    index2 = 0;
  }
  return Array.isArray(prop) ? prop[index2] || prop[0] : prop;
};
const shouldUseMultilineBackgrounds = (props2) => {
  const {
    backgroundStyle,
    backgroundPadding
  } = props2;
  return Array.isArray(backgroundStyle) && !_isEmpty(backgroundStyle) || Array.isArray(backgroundPadding) && !_isEmpty(backgroundPadding);
};
const getStyles$3 = (style2, props2) => {
  if (props2.disableInlineStyles) {
    const baseStyles2 = evaluateStyle(style2, props2);
    return {
      // Font size is necessary to calculate the y position of the label
      fontSize: getFontSize(baseStyles2)
    };
  }
  const getSingleStyle = (s4) => {
    const baseStyles2 = evaluateStyle(s4 ? _defaults({}, s4, defaultStyles) : defaultStyles, props2);
    return Object.assign({}, baseStyles2, {
      fontSize: getFontSize(baseStyles2)
    });
  };
  return Array.isArray(style2) && !_isEmpty(style2) ? style2.map((s4) => getSingleStyle(s4)) : getSingleStyle(style2);
};
const getBackgroundStyles = (style2, props2) => {
  if (!style2) {
    return void 0;
  }
  return Array.isArray(style2) && !_isEmpty(style2) ? style2.map((s4) => evaluateStyle(s4, props2)) : evaluateStyle(style2, props2);
};
const getBackgroundPadding = (props2) => {
  if (props2.backgroundPadding && Array.isArray(props2.backgroundPadding)) {
    return props2.backgroundPadding.map((backgroundPadding) => {
      const padding3 = evaluateProp(backgroundPadding, props2);
      return getPadding$1({
        padding: padding3
      });
    });
  }
  const padding2 = evaluateProp(props2.backgroundPadding, props2);
  return getPadding$1({
    padding: padding2
  });
};
const getLineHeight = (props2) => {
  const lineHeight = evaluateProp(props2.lineHeight, props2);
  if (Array.isArray(lineHeight)) {
    return _isEmpty(lineHeight) ? [1] : lineHeight;
  }
  return lineHeight;
};
const getContent = (text2, props2) => {
  if (text2 === void 0 || text2 === null) {
    return void 0;
  }
  if (Array.isArray(text2)) {
    return text2.map((line2) => evaluateProp(line2, props2));
  }
  const child = evaluateProp(text2, props2);
  if (child === void 0 || child === null) {
    return void 0;
  }
  return Array.isArray(child) ? child : `${child}`.split("\n");
};
const getDy = (props2, verticalAnchor, lineHeight) => {
  const dy = props2.dy ? evaluateProp(props2.dy, props2) : 0;
  const length2 = props2.inline ? 1 : props2.text.length;
  const capHeight = evaluateProp(props2.capHeight, props2);
  const anchor = verticalAnchor ? evaluateProp(verticalAnchor, props2) : "middle";
  const fontSizes2 = [...Array(length2).keys()].map((i2) => getSingleValue(props2.style, i2).fontSize);
  const lineHeights2 = [...Array(length2).keys()].map((i2) => getSingleValue(lineHeight, i2));
  if (anchor === "start") {
    return dy + (capHeight / 2 + lineHeights2[0] / 2) * fontSizes2[0];
  } else if (props2.inline) {
    return anchor === "end" ? dy + (capHeight / 2 - lineHeights2[0] / 2) * fontSizes2[0] : dy + capHeight / 2 * fontSizes2[0];
  } else if (length2 === 1) {
    return anchor === "end" ? dy + (capHeight / 2 + (0.5 - length2) * lineHeights2[0]) * fontSizes2[0] : dy + (capHeight / 2 + (0.5 - length2 / 2) * lineHeights2[0]) * fontSizes2[0];
  }
  const allHeights = [...Array(length2).keys()].reduce((memo, i2) => {
    return memo + (capHeight / 2 + (0.5 - length2) * lineHeights2[i2]) * fontSizes2[i2] / length2;
  }, 0);
  return anchor === "end" ? dy + allHeights : dy + allHeights / 2 + capHeight / 2 * lineHeights2[length2 - 1] * fontSizes2[length2 - 1];
};
const getTransform$1 = (props2, x3, y4) => {
  const {
    polar
  } = props2;
  const style2 = getSingleValue(props2.style);
  const defaultAngle = polar ? getPolarAngle(props2) : 0;
  const baseAngle = style2.angle === void 0 ? evaluateProp(props2.angle, props2) : style2.angle;
  const angle = baseAngle === void 0 ? defaultAngle : baseAngle;
  const transform = props2.transform || style2.transform;
  const transformPart = transform && evaluateProp(transform, props2);
  const rotatePart = angle && {
    rotate: [angle, x3, y4]
  };
  return transformPart || angle ? toTransformString(transformPart, rotatePart) : void 0;
};
const getXCoordinate = (calculatedProps, labelSizeWidth) => {
  const {
    direction,
    textAnchor,
    x: x3,
    dx
  } = calculatedProps;
  if (direction === "rtl") {
    return x3 - labelSizeWidth;
  }
  switch (textAnchor) {
    case "middle":
      return Math.round(x3 - labelSizeWidth / 2);
    case "end":
      return Math.round(x3 - labelSizeWidth);
    default:
      return x3 + (dx || 0);
  }
};
const getYCoordinate = (calculatedProps, textHeight) => {
  const {
    verticalAnchor,
    y: y4,
    originalDy = 0
  } = calculatedProps;
  const offset2 = y4 + originalDy;
  switch (verticalAnchor) {
    case "start":
      return Math.floor(offset2);
    case "end":
      return Math.ceil(offset2 - textHeight);
    default:
      return Math.floor(offset2 - textHeight / 2);
  }
};
const getFullBackground = (calculatedProps, tspanValues) => {
  const {
    dx = 0,
    transform,
    backgroundComponent,
    backgroundStyle,
    inline,
    backgroundPadding,
    capHeight
  } = calculatedProps;
  const textSizes = tspanValues.map((tspan) => {
    return tspan.textSize;
  });
  const height = inline ? Math.max(...textSizes.map((size) => size.height)) : textSizes.reduce((memo, size, i2) => {
    const capHeightAdjustment = i2 ? 0 : capHeight / 2;
    return memo + size.height * (tspanValues[i2].lineHeight - capHeightAdjustment);
  }, 0);
  const width = inline ? textSizes.reduce((memo, size, index2) => {
    const offset2 = index2 ? dx : 0;
    return memo + size.width + offset2;
  }, 0) : Math.max(...textSizes.map((size) => size.width));
  const xCoordinate = getXCoordinate(calculatedProps, width);
  const yCoordinate = getYCoordinate(calculatedProps, height);
  const backgroundProps = {
    key: "background",
    height: height + backgroundPadding.top + backgroundPadding.bottom,
    style: backgroundStyle,
    transform,
    width: width + backgroundPadding.left + backgroundPadding.right,
    x: inline ? xCoordinate - backgroundPadding.left : xCoordinate + dx - backgroundPadding.left,
    y: yCoordinate
  };
  return /* @__PURE__ */ React__default.cloneElement(backgroundComponent, _defaults({}, backgroundComponent.props, backgroundProps));
};
const getInlineXOffset = (calculatedProps, textElements, index2) => {
  const {
    textAnchor
  } = calculatedProps;
  const widths = textElements.map((t2) => t2.widthWithPadding);
  const totalWidth = widths.reduce((memo, width) => memo + width, 0);
  const centerOffset = -totalWidth / 2;
  switch (textAnchor) {
    case "start":
      return widths.reduce((memo, width, i2) => i2 < index2 ? memo + width : memo, 0);
    case "end":
      return widths.reduce((memo, width, i2) => i2 > index2 ? memo - width : memo, 0);
    default:
      return widths.reduce((memo, width, i2) => {
        const offsetWidth = i2 < index2 ? width : 0;
        return i2 === index2 ? memo + width / 2 : memo + offsetWidth;
      }, centerOffset);
  }
};
const getChildBackgrounds = (calculatedProps, tspanValues) => {
  const {
    dy,
    dx,
    transform,
    backgroundStyle,
    backgroundPadding,
    backgroundComponent,
    inline,
    y: y4
  } = calculatedProps;
  const textElements = tspanValues.map((current, i2) => {
    const previous = getSingleValue(tspanValues, i2 - 1);
    const labelSize = current.textSize;
    const totalLineHeight = current.fontSize * current.lineHeight;
    const textHeight = Math.ceil(totalLineHeight);
    const padding2 = getSingleValue(backgroundPadding, i2);
    const prevPadding = getSingleValue(backgroundPadding, i2 - 1);
    const xOffset = inline ? dx || 0 : 0;
    const childDy = i2 && !inline ? previous.fontSize * previous.lineHeight + prevPadding.top + prevPadding.bottom : dy - totalLineHeight * 0.5 - (current.fontSize - current.capHeight);
    return {
      textHeight,
      labelSize,
      heightWithPadding: textHeight + padding2.top + padding2.bottom,
      widthWithPadding: labelSize.width + padding2.left + padding2.right + xOffset,
      y: y4,
      fontSize: current.fontSize,
      dy: childDy
    };
  });
  return textElements.map((textElement, i2) => {
    const xCoordinate = getXCoordinate(calculatedProps, textElement.labelSize.width);
    const yCoordinate = textElements.slice(0, i2 + 1).reduce((prev2, curr) => {
      return prev2 + curr.dy;
    }, y4);
    const padding2 = getSingleValue(backgroundPadding, i2);
    const height = textElement.heightWithPadding;
    const xCoord = inline ? getInlineXOffset(calculatedProps, textElements, i2) + xCoordinate - padding2.left : xCoordinate;
    const yCoord = inline ? getYCoordinate(calculatedProps, height) - padding2.top : yCoordinate;
    const backgroundProps = {
      key: `tspan-background-${i2}`,
      height,
      style: getSingleValue(backgroundStyle, i2),
      width: textElement.widthWithPadding,
      transform,
      x: xCoord - padding2.left,
      y: yCoord
    };
    return /* @__PURE__ */ React__default.cloneElement(backgroundComponent, _defaults({}, backgroundComponent.props, backgroundProps));
  });
};
const getBackgroundElement = (calculatedProps, tspanValues) => {
  return shouldUseMultilineBackgrounds(calculatedProps) ? getChildBackgrounds(calculatedProps, tspanValues) : getFullBackground(calculatedProps, tspanValues);
};
const calculateSpanDy = (tspanValues, i2, calculatedProps) => {
  const current = getSingleValue(tspanValues, i2);
  const previous = getSingleValue(tspanValues, i2 - 1);
  const previousHeight = previous.fontSize * previous.lineHeight;
  const currentHeight = current.fontSize * current.lineHeight;
  const previousCaps = previous.fontSize - previous.capHeight;
  const currentCaps = current.fontSize - current.capHeight;
  const textHeight = previousHeight - previous.fontSize / 2 + current.fontSize / 2 - previousHeight / 2 + currentHeight / 2 - currentCaps / 2 + previousCaps / 2;
  return shouldUseMultilineBackgrounds(calculatedProps) ? textHeight + current.backgroundPadding.top + previous.backgroundPadding.bottom : textHeight;
};
const getTSpanDy = (tspanValues, calculatedProps, i2) => {
  const {
    inline
  } = calculatedProps;
  const current = getSingleValue(tspanValues, i2);
  if (i2 && !inline) {
    return calculateSpanDy(tspanValues, i2, calculatedProps);
  } else if (inline) {
    return i2 === 0 ? current.backgroundPadding.top : void 0;
  }
  return current.backgroundPadding.top;
};
const evaluateProps$7 = (props2) => {
  const text2 = getContent(props2.text, props2);
  const style2 = getStyles$3(props2.style, Object.assign({}, props2, {
    text: text2
  }));
  const backgroundStyle = getBackgroundStyles(props2.backgroundStyle, Object.assign({}, props2, {
    text: text2,
    style: style2
  }));
  const backgroundPadding = getBackgroundPadding(Object.assign({}, props2, {
    text: text2,
    style: style2,
    backgroundStyle
  }));
  const id = evaluateProp(props2.id, props2);
  return Object.assign({}, props2, {
    backgroundStyle,
    backgroundPadding,
    style: style2,
    text: text2,
    id
  });
};
const getCalculatedProps$1 = (props2) => {
  const ariaLabel = evaluateProp(props2.ariaLabel, props2);
  const style2 = getSingleValue(props2.style);
  const lineHeight = getLineHeight(props2);
  const direction = props2.direction ? evaluateProp(props2.direction, props2) : "inherit";
  const textAnchor = props2.textAnchor ? evaluateProp(props2.textAnchor, props2) : style2.textAnchor || "start";
  const verticalAnchor = props2.verticalAnchor ? evaluateProp(props2.verticalAnchor, props2) : style2.verticalAnchor || "middle";
  const dx = props2.dx ? evaluateProp(props2.dx, props2) : 0;
  const dy = getDy(props2, verticalAnchor, lineHeight);
  const x3 = props2.x !== void 0 ? props2.x : getPosition$2(props2, "x");
  const y4 = props2.y !== void 0 ? props2.y : getPosition$2(props2, "y");
  const transform = getTransform$1(props2, x3, y4);
  return Object.assign({}, props2, {
    ariaLabel,
    lineHeight,
    direction,
    textAnchor,
    verticalAnchor,
    dx,
    dy,
    originalDy: evaluateProp(props2.dy, props2),
    transform,
    x: x3,
    y: y4
  });
};
const renderLabel = (calculatedProps, tspanValues) => {
  const {
    ariaLabel,
    inline,
    className,
    title,
    events,
    direction,
    text: text2,
    textAnchor,
    dx,
    dy,
    transform,
    x: x3,
    y: y4,
    desc,
    id,
    tabIndex,
    tspanComponent,
    textComponent
  } = calculatedProps;
  const userProps = getSafeUserProps(calculatedProps);
  const textProps = {
    "aria-label": ariaLabel,
    key: "text",
    ...events,
    direction,
    dx,
    x: x3,
    y: y4 + dy,
    transform,
    className,
    title,
    desc: evaluateProp(desc, calculatedProps),
    tabIndex: evaluateProp(tabIndex, calculatedProps),
    id,
    ...userProps
  };
  const tspans = text2.map((line2, i2) => {
    const currentStyle = tspanValues[i2].style;
    const tspanProps = {
      key: `${id}-key-${i2}`,
      x: !inline ? x3 : void 0,
      dx: inline ? dx + tspanValues[i2].backgroundPadding.left : dx,
      dy: getTSpanDy(tspanValues, calculatedProps, i2),
      textAnchor: currentStyle.textAnchor || textAnchor,
      style: currentStyle,
      children: line2
    };
    return /* @__PURE__ */ React__default.cloneElement(tspanComponent, tspanProps);
  });
  return /* @__PURE__ */ React__default.cloneElement(textComponent, textProps, tspans);
};
const defaultProps$8 = {
  backgroundComponent: /* @__PURE__ */ React__default.createElement(Rect, null),
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null),
  direction: "inherit",
  textComponent: /* @__PURE__ */ React__default.createElement(Text2, null),
  tspanComponent: /* @__PURE__ */ React__default.createElement(TSpan, null),
  capHeight: 0.71,
  // Magic number from d3.
  lineHeight: 1
};
const VictoryLabel = (initialProps) => {
  const props2 = evaluateProps$7(_defaults({}, initialProps, defaultProps$8));
  if (props2.text === null || props2.text === void 0) {
    return null;
  }
  const calculatedProps = getCalculatedProps$1(props2);
  const {
    text: text2,
    style: style2,
    capHeight,
    backgroundPadding,
    lineHeight
  } = calculatedProps;
  const tspanValues = text2.map((line2, i2) => {
    const currentStyle = getSingleValue(style2, i2);
    const capHeightPx = convertLengthToPixels(`${capHeight}em`, currentStyle.fontSize);
    const currentLineHeight = getSingleValue(lineHeight, i2);
    return {
      style: currentStyle,
      fontSize: currentStyle.fontSize || defaultStyles.fontSize,
      capHeight: capHeightPx,
      text: line2,
      // TODO: This looks like a bug:
      textSize: approximateTextSize(line2, currentStyle),
      lineHeight: currentLineHeight,
      backgroundPadding: getSingleValue(backgroundPadding, i2)
    };
  });
  const label2 = renderLabel(calculatedProps, tspanValues);
  if (props2.backgroundStyle) {
    const backgroundElement = getBackgroundElement(calculatedProps, tspanValues);
    const children2 = [backgroundElement, label2];
    const backgroundWithLabel = /* @__PURE__ */ React__default.cloneElement(props2.groupComponent, {}, children2);
    return props2.renderInPortal ? /* @__PURE__ */ React__default.createElement(VictoryPortal, null, backgroundWithLabel) : backgroundWithLabel;
  }
  return props2.renderInPortal ? /* @__PURE__ */ React__default.createElement(VictoryPortal, null, label2) : label2;
};
VictoryLabel.displayName = "VictoryLabel";
VictoryLabel.role = "label";
VictoryLabel.defaultStyles = defaultStyles;
function isNonEmptyArray(collection) {
  return Array.isArray(collection) && collection.length > 0;
}
function containsStrings(collection) {
  return Array.isArray(collection) && collection.some((value) => typeof value === "string");
}
function containsDates(collection) {
  return Array.isArray(collection) && collection.some((value) => value instanceof Date);
}
function containsOnlyStrings(collection) {
  return isNonEmptyArray(collection) && collection.every((value) => typeof value === "string");
}
function difference(a4, b10) {
  if (a4 && b10) {
    return a4.filter((value) => !b10.includes(value));
  }
  return [];
}
function isArrayOfArrays(collection) {
  return isNonEmptyArray(collection) && collection.every(Array.isArray);
}
function removeUndefined(arr) {
  return arr.filter((el) => el !== void 0);
}
function getMaxValue(arr) {
  for (var _len = arguments.length, values6 = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values6[_key - 1] = arguments[_key];
  }
  const array2 = arr.concat(values6);
  return containsDates(array2) ? new Date(Math.max(...array2)) : Math.max(...array2);
}
function getMinValue(arr) {
  for (var _len2 = arguments.length, values6 = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    values6[_key2 - 1] = arguments[_key2];
  }
  const array2 = arr.concat(values6);
  return containsDates(array2) ? new Date(Math.min(...array2)) : Math.min(...array2);
}
function getDatumKey(datum, idx) {
  return (datum.key || idx).toString();
}
function getKeyedData(data) {
  return data.reduce((keyedData, datum, idx) => {
    const key = getDatumKey(datum, idx);
    keyedData[key] = datum;
    return keyedData;
  }, {});
}
function getKeyedDataDifference(a4, b10) {
  let hasDifference = false;
  const difference2 = Object.keys(a4).reduce((_difference, key) => {
    if (!(key in b10)) {
      hasDifference = true;
      _difference[key] = true;
    }
    return _difference;
  }, {});
  return hasDifference && difference2;
}
function getNodeTransitions(oldData, nextData) {
  const oldDataKeyed = oldData && getKeyedData(oldData);
  const nextDataKeyed = nextData && getKeyedData(nextData);
  return {
    entering: oldDataKeyed && getKeyedDataDifference(nextDataKeyed, oldDataKeyed),
    exiting: nextDataKeyed && getKeyedDataDifference(oldDataKeyed, nextDataKeyed)
  };
}
function getChildData(child) {
  if (child.type && child.type.getData) {
    return child.type.getData(child.props);
  }
  return child.props && child.props.data || false;
}
function getInitialTransitionState(oldChildren, nextChildren) {
  let nodesWillExit = false;
  let nodesWillEnter = false;
  const getTransition = (oldChild, newChild) => {
    if (!newChild || oldChild.type !== newChild.type) {
      return {};
    }
    const {
      entering,
      exiting
    } = getNodeTransitions(getChildData(oldChild), getChildData(newChild)) || {};
    nodesWillExit = nodesWillExit || !!exiting;
    nodesWillEnter = nodesWillEnter || !!entering;
    return {
      entering: entering || false,
      exiting: exiting || false
    };
  };
  const getTransitionsFromChildren = (old, next2) => {
    return old.map((child, idx) => {
      if (child && child.props && child.props.children && next2[idx]) {
        return getTransitionsFromChildren(React__default.Children.toArray(old[idx].props.children), React__default.Children.toArray(next2[idx].props.children));
      }
      return getTransition(child, next2[idx]);
    });
  };
  const childrenTransitions = getTransitionsFromChildren(React__default.Children.toArray(oldChildren), React__default.Children.toArray(nextChildren));
  return {
    nodesWillExit,
    nodesWillEnter,
    childrenTransitions,
    // TODO: This may need to be refactored for the following situation.
    //       The component receives new props, and the data provided
    //       is a perfect match for the previous data and domain except
    //       for new nodes. In this case, we wouldn't want a delay before
    //       the new nodes appear.
    nodesShouldEnter: false
  };
}
function getInitialChildProps(animate, data) {
  const after2 = animate.onEnter && animate.onEnter.after ? animate.onEnter.after : _identity;
  return {
    data: data.map((datum, idx) => Object.assign({}, datum, after2(datum, idx, data)))
  };
}
function getChildBeforeLoad(animate, child, data, cb) {
  const newAnimate = Object.assign({}, animate, {
    onEnd: cb
  });
  if (newAnimate && newAnimate.onLoad && !newAnimate.onLoad.duration) {
    return {
      animate: newAnimate,
      data
    };
  }
  const before = newAnimate.onLoad && newAnimate.onLoad.before ? newAnimate.onLoad.before : _identity;
  const newData = data.map((datum, idx) => {
    return Object.assign({}, datum, before(datum, idx, data));
  });
  return {
    animate: newAnimate,
    data: newData,
    clipWidth: 0
  };
}
function getChildOnLoad(animate, data, cb) {
  const newAnimate = Object.assign({}, animate, {
    onEnd: cb
  });
  let newData = data;
  if (newAnimate && newAnimate.onLoad && !newAnimate.onLoad.duration) {
    return {
      animate,
      data
    };
  }
  const after2 = animate.onLoad && animate.onLoad.after ? animate.onLoad.after : _identity;
  newData = data.map((datum, idx) => {
    return Object.assign({}, datum, after2(datum, idx, data));
  });
  return {
    animate: newAnimate,
    data: newData
  };
}
function getChildPropsOnExit(animate, child, data, exitingNodes, cb) {
  const onExit = animate && animate.onExit;
  const newAnimate = Object.assign({}, animate, onExit);
  let newData = data;
  if (exitingNodes) {
    animate.onEnd = cb;
    const before = animate.onExit && animate.onExit.before ? animate.onExit.before : _identity;
    newData = data.map((datum, idx) => {
      const key = (datum.key || idx).toString();
      return exitingNodes[key] ? Object.assign({}, datum, before(datum, idx, data)) : datum;
    });
  }
  return {
    animate: newAnimate,
    data: newData
  };
}
function getChildPropsBeforeEnter(animate, child, data, enteringNodes, cb) {
  let newAnimate = animate;
  let newData = data;
  if (enteringNodes) {
    newAnimate = Object.assign({}, animate, {
      onEnd: cb
    });
    const before = animate.onEnter && animate.onEnter.before ? animate.onEnter.before : _identity;
    newData = data.map((datum, idx) => {
      const key = (datum.key || idx).toString();
      return enteringNodes[key] ? Object.assign({}, datum, before(datum, idx, data)) : datum;
    });
  }
  return {
    animate: newAnimate,
    data: newData
  };
}
function getChildPropsOnEnter(animate, data, enteringNodes, cb) {
  const onEnter = animate && animate.onEnter;
  const newAnimate = Object.assign({}, animate, onEnter);
  let newData = data;
  if (enteringNodes) {
    newAnimate.onEnd = cb;
    const after2 = newAnimate.onEnter && newAnimate.onEnter.after ? newAnimate.onEnter.after : _identity;
    newData = data.map((datum, idx) => {
      const key = getDatumKey(datum, idx);
      return enteringNodes[key] ? Object.assign({}, datum, after2(datum, idx, data)) : datum;
    });
  }
  return {
    animate: newAnimate,
    data: newData
  };
}
function getTransitionPropsFactory(props2, state, setState) {
  const nodesWillExit = state && state.nodesWillExit;
  const nodesWillEnter = state && state.nodesWillEnter;
  const nodesShouldEnter = state && state.nodesShouldEnter;
  const nodesShouldLoad = state && state.nodesShouldLoad;
  const nodesDoneLoad = state && state.nodesDoneLoad;
  const childrenTransitions = state && state.childrenTransitions || [];
  const transitionDurations = {
    enter: props2.animate && props2.animate.onEnter && props2.animate.onEnter.duration,
    exit: props2.animate && props2.animate.onExit && props2.animate.onExit.duration,
    load: props2.animate && props2.animate.onLoad && props2.animate.onLoad.duration,
    move: props2.animate && props2.animate.duration
  };
  const onLoad = (child, data, animate) => {
    if (nodesShouldLoad) {
      return getChildOnLoad(animate, data, () => {
        setState({
          nodesShouldLoad: false,
          nodesDoneLoad: true
        });
      });
    }
    return getChildBeforeLoad(animate, child, data, () => {
      setState({
        nodesDoneLoad: true
      });
    });
  };
  const onExit = (nodes, child, data, animate) => {
    return getChildPropsOnExit(animate, child, data, nodes, () => {
      setState({
        nodesWillExit: false
      });
    });
  };
  const onEnter = (nodes, child, data, animate) => {
    if (nodesShouldEnter) {
      return getChildPropsOnEnter(animate, data, nodes, () => {
        setState({
          nodesWillEnter: false
        });
      });
    }
    return getChildPropsBeforeEnter(animate, child, data, nodes, () => {
      setState({
        nodesShouldEnter: true
      });
    });
  };
  const getChildTransitionDuration = function(child, type2) {
    const animate = child.props.animate;
    if (!child.type) {
      return {};
    }
    const defaultTransitions = child.props && child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
    if (defaultTransitions) {
      const animationDuration = animate[type2] && animate[type2].duration;
      return animationDuration !== void 0 ? animationDuration : defaultTransitions[type2] && defaultTransitions[type2].duration;
    }
    return {};
  };
  return function getTransitionProps(child, index2) {
    const data = getChildData(child) || [];
    const animate = _defaults({}, props2.animate, child.props.animate);
    const defaultTransitions = child.props.polar ? child.type.defaultPolarTransitions || child.type.defaultTransitions : child.type.defaultTransitions;
    animate.onExit = _defaults({}, animate.onExit, defaultTransitions && defaultTransitions.onExit);
    animate.onEnter = _defaults({}, animate.onEnter, defaultTransitions && defaultTransitions.onEnter);
    animate.onLoad = _defaults({}, animate.onLoad, defaultTransitions && defaultTransitions.onLoad);
    const childTransitions = childrenTransitions[index2] || childrenTransitions[0];
    if (!nodesDoneLoad) {
      const load = transitionDurations.load !== void 0 ? transitionDurations.load : getChildTransitionDuration(child, "onLoad");
      const animation = {
        duration: load
      };
      return onLoad(child, data, Object.assign({}, animate, animation));
    } else if (nodesWillExit) {
      const exitingNodes = childTransitions && childTransitions.exiting;
      const exit = transitionDurations.exit !== void 0 ? transitionDurations.exit : getChildTransitionDuration(child, "onExit");
      const animation = exitingNodes ? {
        duration: exit
      } : {
        delay: exit
      };
      return onExit(exitingNodes, child, data, Object.assign({}, animate, animation));
    } else if (nodesWillEnter) {
      const enteringNodes = childTransitions && childTransitions.entering;
      const enter = transitionDurations.enter !== void 0 ? transitionDurations.enter : getChildTransitionDuration(child, "onEnter");
      const move = transitionDurations.move !== void 0 ? transitionDurations.move : child.props.animate && child.props.animate.duration;
      const animation = {
        duration: nodesShouldEnter && enteringNodes ? enter : move
      };
      return onEnter(enteringNodes, child, data, Object.assign({}, animate, animation));
    } else if (!state && animate && animate.onExit) {
      return getInitialChildProps(animate, data);
    }
    return {
      animate,
      data
    };
  };
}
var hasElementType$3 = typeof Element !== "undefined";
var hasMap$3 = typeof Map === "function";
var hasSet$3 = typeof Set === "function";
var hasArrayBuffer$3 = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal$3(a4, b10) {
  if (a4 === b10)
    return true;
  if (a4 && b10 && typeof a4 == "object" && typeof b10 == "object") {
    if (a4.constructor !== b10.constructor)
      return false;
    var length2, i2, keys8;
    if (Array.isArray(a4)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal$3(a4[i2], b10[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap$3 && a4 instanceof Map && b10 instanceof Map) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!equal$3(i2.value[1], b10.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet$3 && a4 instanceof Set && b10 instanceof Set) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer$3 && ArrayBuffer.isView(a4) && ArrayBuffer.isView(b10)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a4[i2] !== b10[i2])
          return false;
      return true;
    }
    if (a4.constructor === RegExp)
      return a4.source === b10.source && a4.flags === b10.flags;
    if (a4.valueOf !== Object.prototype.valueOf && typeof a4.valueOf === "function" && typeof b10.valueOf === "function")
      return a4.valueOf() === b10.valueOf();
    if (a4.toString !== Object.prototype.toString && typeof a4.toString === "function" && typeof b10.toString === "function")
      return a4.toString() === b10.toString();
    keys8 = Object.keys(a4);
    length2 = keys8.length;
    if (length2 !== Object.keys(b10).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b10, keys8[i2]))
        return false;
    if (hasElementType$3 && a4 instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys8[i2] === "_owner" || keys8[i2] === "__v" || keys8[i2] === "__o") && a4.$$typeof) {
        continue;
      }
      if (!equal$3(a4[keys8[i2]], b10[keys8[i2]]))
        return false;
    }
    return true;
  }
  return a4 !== a4 && b10 !== b10;
}
var reactFastCompare$3 = function isEqual2(a4, b10) {
  try {
    return equal$3(a4, b10);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
const isEqual$5 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare$3);
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
class VictoryTransition extends React__default.Component {
  constructor(props2, context) {
    super(props2, context);
    this.state = {
      nodesShouldLoad: false,
      nodesDoneLoad: false
    };
    const child = this.props.children;
    const polar = child.props.polar;
    this.continuous = !polar && child.type && child.type.continuous === true;
    this.timer = this.context.transitionTimer;
  }
  componentDidMount() {
    this.setState({
      nodesShouldLoad: true
    });
  }
  shouldComponentUpdate(nextProps) {
    if (!isEqual$5(this.props, nextProps)) {
      this.timer.bypassAnimation();
      this.setState(this.getTransitionState(this.props, nextProps), () => this.timer.resumeAnimation());
    }
    return true;
  }
  componentWillUnmount() {
    this.timer.stop();
  }
  getTransitionState(props2, nextProps) {
    const {
      animate
    } = props2;
    if (!animate) {
      return {};
    } else if (animate.parentState) {
      const state = animate.parentState;
      const oldProps = state.nodesWillExit ? props2 : null;
      return {
        oldProps,
        nextProps
      };
    }
    const oldChildren = React__default.Children.toArray(props2.children);
    const nextChildren = React__default.Children.toArray(nextProps.children);
    const {
      nodesWillExit,
      nodesWillEnter,
      childrenTransitions,
      nodesShouldEnter
    } = getInitialTransitionState(oldChildren, nextChildren);
    return {
      nodesWillExit,
      nodesWillEnter,
      childrenTransitions,
      nodesShouldEnter,
      oldProps: nodesWillExit ? props2 : null,
      nextProps
    };
  }
  getDomainFromChildren(props2, axis) {
    const getChildDomains = (children2) => {
      return children2.reduce((memo, child2) => {
        if (child2.type && isFunction$1(child2.type.getDomain)) {
          const childDomain = child2.props && child2.type.getDomain(child2.props, axis);
          return childDomain ? memo.concat(childDomain) : memo;
        } else if (child2.props && child2.props.children) {
          return memo.concat(getChildDomains(React__default.Children.toArray(child2.props.children)));
        }
        return memo;
      }, []);
    };
    const child = React__default.Children.toArray(props2.children)[0];
    const childProps = child.props || {};
    const domain = Array.isArray(childProps.domain) ? childProps.domain : childProps.domain && childProps.domain[axis];
    if (!childProps.children && domain) {
      return domain;
    }
    const childDomains = getChildDomains([child]);
    return childDomains.length === 0 ? [0, 1] : [getMinValue(childDomains), getMaxValue(childDomains)];
  }
  pickProps() {
    if (!this.state) {
      return this.props;
    }
    return this.state.nodesWillExit ? this.state.oldProps || this.props : this.props;
  }
  pickDomainProps(props2) {
    var _a2;
    const parentState = (_a2 = props2.animate) == null ? void 0 : _a2.parentState;
    if (parentState && parentState.nodesWillExit) {
      return this.continuous || parentState.continuous ? parentState.nextProps || this.state.nextProps || props2 : props2;
    }
    return this.continuous && this.state.nodesWillExit ? this.state.nextProps || props2 : props2;
  }
  getClipWidth(props2, child) {
    const getDefaultClipWidth = () => {
      const range2 = getRange$1(child.props, "x");
      return range2 ? Math.abs(range2[1] - range2[0]) : props2.width;
    };
    const clipWidth = this.transitionProps ? this.transitionProps.clipWidth : void 0;
    return clipWidth !== void 0 ? clipWidth : getDefaultClipWidth();
  }
  render() {
    var _a2;
    const props2 = this.pickProps();
    const getTransitionProps = ((_a2 = this.props.animate) == null ? void 0 : _a2.getTransitions) ? this.props.animate.getTransitions : getTransitionPropsFactory(props2, this.state, (newState) => this.setState(newState));
    const child = React__default.Children.toArray(props2.children)[0];
    const transitionProps = getTransitionProps(child);
    this.transitionProps = transitionProps;
    const domain = {
      x: this.getDomainFromChildren(this.pickDomainProps(props2), "x"),
      y: this.getDomainFromChildren(props2, "y")
    };
    const clipWidth = this.getClipWidth(props2, child);
    const combinedProps = _defaults({
      domain,
      clipWidth
    }, transitionProps, child.props);
    const animationWhitelist = props2.animationWhitelist || [];
    const whitelist = animationWhitelist.concat(["clipWidth"]);
    const propsToAnimate = whitelist.length ? _pick(combinedProps, whitelist) : combinedProps;
    return /* @__PURE__ */ React__default.createElement(VictoryAnimation, _extends$3({}, combinedProps.animate, {
      data: propsToAnimate
    }), (newProps) => {
      if (child.props.groupComponent) {
        const groupComponent = this.continuous ? /* @__PURE__ */ React__default.cloneElement(child.props.groupComponent, {
          clipWidth: newProps.clipWidth || 0
        }) : child.props.groupComponent;
        return /* @__PURE__ */ React__default.cloneElement(child, _defaults({
          animate: null,
          animating: true,
          groupComponent
        }, newProps, combinedProps));
      }
      return /* @__PURE__ */ React__default.cloneElement(child, _defaults({
        animate: null,
        animating: true
      }, newProps, combinedProps));
    });
  }
}
__publicField(VictoryTransition, "displayName", "VictoryTransition");
__publicField(VictoryTransition, "contextType", TimerContext);
const ClipPath = (props2) => {
  var _a2;
  return /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
    id: (_a2 = props2.clipId) == null ? void 0 : _a2.toString()
  }, props2.children));
};
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
const Circle = /* @__PURE__ */ forwardRef((props2, ref2) => {
  var _a2;
  const {
    desc,
    id,
    tabIndex,
    origin,
    ...rest
  } = props2;
  const svgProps = {
    vectorEffect: "non-scaling-stroke",
    id: (_a2 = evaluateProp(id, props2)) == null ? void 0 : _a2.toString(),
    tabIndex: evaluateProp(tabIndex, props2),
    ...rest
  };
  return desc ? /* @__PURE__ */ React__default.createElement("circle", _extends$2({}, svgProps, {
    ref: ref2
  }), /* @__PURE__ */ React__default.createElement("desc", null, desc)) : /* @__PURE__ */ React__default.createElement("circle", _extends$2({}, svgProps, {
    ref: ref2
  }));
});
class VictoryClipContainer extends React__default.Component {
  constructor(props2) {
    super(props2);
    this.clipId = !_isObject(props2) || props2.clipId === void 0 ? _uniqueId("victory-clip-") : props2.clipId;
  }
  calculateAttributes(props2) {
    const {
      polar,
      origin,
      clipWidth = 0,
      clipHeight = 0,
      translateX = 0,
      translateY = 0
    } = props2;
    const clipPadding = getPadding$1({
      padding: props2.clipPadding
    });
    const radius = props2.radius || getRadius$1(props2);
    return {
      x: (polar ? origin.x : translateX) - clipPadding.left,
      y: (polar ? origin.y : translateY) - clipPadding.top,
      width: Math.max((polar ? radius : clipWidth) + clipPadding.left + clipPadding.right, 0),
      height: Math.max((polar ? radius : clipHeight) + clipPadding.top + clipPadding.bottom, 0)
    };
  }
  renderClippedGroup(props2, clipId) {
    const userProps = getSafeUserProps(props2);
    const {
      style: style2,
      events,
      transform,
      children: children2,
      className,
      groupComponent,
      tabIndex
    } = props2;
    const clipComponent = this.renderClipComponent(props2, clipId);
    const groupProps = Object.assign({
      className,
      style: style2,
      transform,
      key: `clipped-group-${clipId}`,
      clipPath: `url(#${clipId})`
    }, events);
    return /* @__PURE__ */ React__default.cloneElement(groupComponent, {
      ...groupProps,
      tabIndex,
      ...userProps
    }, [clipComponent, ...React__default.Children.toArray(children2)]);
  }
  renderGroup(props2) {
    const {
      style: style2,
      events,
      transform,
      children: children2,
      className,
      groupComponent,
      tabIndex
    } = props2;
    return /* @__PURE__ */ React__default.cloneElement(groupComponent, Object.assign({
      className,
      style: style2,
      transform,
      "aria-label": props2["aria-label"],
      tabIndex
    }, events), children2);
  }
  renderClipComponent(props2, clipId) {
    const {
      polar,
      origin,
      clipWidth = 0,
      clipHeight = 0,
      translateX = 0,
      translateY = 0,
      circleComponent,
      rectComponent,
      clipPathComponent
    } = props2;
    const {
      top: top2,
      bottom: bottom2,
      left: left2,
      right: right2
    } = getPadding$1({
      padding: props2.clipPadding
    });
    let child;
    if (polar) {
      const radius = props2.radius || getRadius$1(props2);
      const circleProps = {
        r: Math.max(radius + left2 + right2, radius + top2 + bottom2, 0),
        cx: origin.x - left2,
        cy: origin.y - top2
      };
      child = /* @__PURE__ */ React__default.cloneElement(circleComponent, circleProps);
    } else {
      const rectProps = {
        x: translateX - left2,
        y: translateY - top2,
        width: Math.max(clipWidth + left2 + right2, 0),
        height: Math.max(clipHeight + top2 + bottom2, 0)
      };
      child = /* @__PURE__ */ React__default.cloneElement(rectComponent, rectProps);
    }
    return /* @__PURE__ */ React__default.cloneElement(clipPathComponent, Object.assign({
      key: `clip-path-${clipId}`
    }, props2, {
      clipId
    }), child);
  }
  getClipValue(props2, axis) {
    const clipValues = {
      x: props2.clipWidth,
      y: props2.clipHeight
    };
    if (clipValues[axis] !== void 0) {
      return clipValues[axis];
    }
    const range2 = getRange$1(props2, axis);
    return range2 ? Math.abs(range2[0] - range2[1]) || void 0 : void 0;
  }
  getTranslateValue(props2, axis) {
    const translateValues = {
      x: props2.translateX,
      y: props2.translateY
    };
    if (translateValues[axis] !== void 0) {
      return translateValues[axis];
    }
    const range2 = getRange$1(props2, axis);
    return range2 ? Math.min(...range2) : void 0;
  }
  render() {
    const clipHeight = this.getClipValue(this.props, "y");
    const clipWidth = this.getClipValue(this.props, "x");
    if (clipWidth === void 0 || clipHeight === void 0) {
      return this.renderGroup(this.props);
    }
    const translateX = this.getTranslateValue(this.props, "x");
    const translateY = this.getTranslateValue(this.props, "y");
    const clipProps = _defaults({}, this.props, {
      clipHeight,
      clipWidth,
      translateX,
      translateY
    });
    return this.renderClippedGroup(clipProps, this.clipId);
  }
}
__publicField(VictoryClipContainer, "displayName", "VictoryClipContainer");
__publicField(VictoryClipContainer, "role", "container");
__publicField(VictoryClipContainer, "defaultProps", {
  circleComponent: /* @__PURE__ */ React__default.createElement(Circle, null),
  rectComponent: /* @__PURE__ */ React__default.createElement(Rect, null),
  clipPathComponent: /* @__PURE__ */ React__default.createElement(ClipPath, null),
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null)
});
const colors$1 = ["#252525", "#525252", "#737373", "#969696", "#bdbdbd", "#d9d9d9", "#f0f0f0"];
const charcoal = "#252525";
const grey = "#969696";
const sansSerif$1 = "'Gill Sans', 'Seravek', 'Trebuchet MS', sans-serif";
const letterSpacing$1 = "normal";
const fontSize$2 = 14;
const baseProps$1 = {
  width: 450,
  height: 300,
  padding: 50,
  colorScale: colors$1
};
const baseLabelStyles$2 = {
  fontFamily: sansSerif$1,
  fontSize: fontSize$2,
  letterSpacing: letterSpacing$1,
  padding: 10,
  fill: charcoal,
  stroke: "transparent"
};
const centeredLabelStyles$1 = Object.assign({
  textAnchor: "middle"
}, baseLabelStyles$2);
const strokeLinecap$1 = "round";
const strokeLinejoin$1 = "round";
const grayscale = {
  area: Object.assign({
    style: {
      data: {
        fill: charcoal
      },
      labels: baseLabelStyles$2
    }
  }, baseProps$1),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: charcoal,
        strokeWidth: 1,
        strokeLinecap: strokeLinecap$1,
        strokeLinejoin: strokeLinejoin$1
      },
      axisLabel: Object.assign({}, centeredLabelStyles$1, {
        padding: 25
      }),
      grid: {
        fill: "none",
        stroke: "none",
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      },
      tickLabels: baseLabelStyles$2
    }
  }, baseProps$1),
  bar: Object.assign({
    style: {
      data: {
        fill: charcoal,
        padding: 8,
        strokeWidth: 0
      },
      labels: baseLabelStyles$2
    }
  }, baseProps$1),
  boxplot: Object.assign({
    style: {
      max: {
        padding: 8,
        stroke: charcoal,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, baseLabelStyles$2, {
        padding: 3
      }),
      median: {
        padding: 8,
        stroke: charcoal,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, baseLabelStyles$2, {
        padding: 3
      }),
      min: {
        padding: 8,
        stroke: charcoal,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, baseLabelStyles$2, {
        padding: 3
      }),
      q1: {
        padding: 8,
        fill: grey
      },
      q1Labels: Object.assign({}, baseLabelStyles$2, {
        padding: 3
      }),
      q3: {
        padding: 8,
        fill: grey
      },
      q3Labels: Object.assign({}, baseLabelStyles$2, {
        padding: 3
      })
    },
    boxWidth: 20
  }, baseProps$1),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: charcoal,
        strokeWidth: 1
      },
      labels: Object.assign({}, baseLabelStyles$2, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: charcoal
    }
  }, baseProps$1),
  chart: baseProps$1,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        stroke: charcoal,
        strokeWidth: 2
      },
      labels: baseLabelStyles$2
    }
  }, baseProps$1),
  group: Object.assign({
    colorScale: colors$1
  }, baseProps$1),
  histogram: Object.assign({
    style: {
      data: {
        fill: grey,
        stroke: charcoal,
        strokeWidth: 2
      },
      labels: baseLabelStyles$2
    }
  }, baseProps$1),
  legend: {
    colorScale: colors$1,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: baseLabelStyles$2,
      title: Object.assign({}, baseLabelStyles$2, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: charcoal,
        strokeWidth: 2
      },
      labels: baseLabelStyles$2
    }
  }, baseProps$1),
  pie: {
    style: {
      data: {
        padding: 10,
        stroke: "transparent",
        strokeWidth: 1
      },
      labels: Object.assign({}, baseLabelStyles$2, {
        padding: 20
      })
    },
    colorScale: colors$1,
    width: 400,
    height: 400,
    padding: 50
  },
  scatter: Object.assign({
    style: {
      data: {
        fill: charcoal,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: baseLabelStyles$2
    }
  }, baseProps$1),
  stack: Object.assign({
    colorScale: colors$1
  }, baseProps$1),
  tooltip: {
    style: Object.assign({}, baseLabelStyles$2, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: charcoal,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, baseLabelStyles$2, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: charcoal,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, baseProps$1)
};
const yellow200 = "#FFF59D";
const deepOrange600 = "#F4511E";
const lime300 = "#DCE775";
const lightGreen500 = "#8BC34A";
const teal700 = "#00796B";
const cyan900 = "#006064";
const colors = [deepOrange600, yellow200, lime300, lightGreen500, teal700, cyan900];
const blueGrey50 = "#ECEFF1";
const blueGrey300 = "#90A4AE";
const blueGrey700 = "#455A64";
const grey900 = "#212121";
const sansSerif = "'Helvetica Neue', 'Helvetica', sans-serif";
const letterSpacing = "normal";
const fontSize$1 = 12;
const padding = 8;
const baseProps = {
  width: 350,
  height: 350,
  padding: 50
};
const baseLabelStyles$1 = {
  fontFamily: sansSerif,
  fontSize: fontSize$1,
  letterSpacing,
  padding,
  fill: blueGrey700,
  stroke: "transparent",
  strokeWidth: 0
};
const centeredLabelStyles = Object.assign({
  textAnchor: "middle"
}, baseLabelStyles$1);
const strokeDasharray = "10, 5";
const strokeLinecap = "round";
const strokeLinejoin = "round";
const material = {
  area: Object.assign({
    style: {
      data: {
        fill: grey900
      },
      labels: baseLabelStyles$1
    }
  }, baseProps),
  axis: Object.assign({
    style: {
      axis: {
        fill: "transparent",
        stroke: blueGrey300,
        strokeWidth: 2,
        strokeLinecap,
        strokeLinejoin
      },
      axisLabel: Object.assign({}, centeredLabelStyles, {
        padding,
        stroke: "transparent"
      }),
      grid: {
        fill: "none",
        stroke: blueGrey50,
        strokeDasharray,
        strokeLinecap,
        strokeLinejoin,
        pointerEvents: "painted"
      },
      ticks: {
        fill: "transparent",
        size: 5,
        stroke: blueGrey300,
        strokeWidth: 1,
        strokeLinecap,
        strokeLinejoin
      },
      tickLabels: Object.assign({}, baseLabelStyles$1, {
        fill: blueGrey700
      })
    }
  }, baseProps),
  polarDependentAxis: Object.assign({
    style: {
      ticks: {
        fill: "transparent",
        size: 1,
        stroke: "transparent"
      }
    }
  }),
  bar: Object.assign({
    style: {
      data: {
        fill: blueGrey700,
        padding,
        strokeWidth: 0
      },
      labels: baseLabelStyles$1
    }
  }, baseProps),
  boxplot: Object.assign({
    style: {
      max: {
        padding,
        stroke: blueGrey700,
        strokeWidth: 1
      },
      maxLabels: Object.assign({}, baseLabelStyles$1, {
        padding: 3
      }),
      median: {
        padding,
        stroke: blueGrey700,
        strokeWidth: 1
      },
      medianLabels: Object.assign({}, baseLabelStyles$1, {
        padding: 3
      }),
      min: {
        padding,
        stroke: blueGrey700,
        strokeWidth: 1
      },
      minLabels: Object.assign({}, baseLabelStyles$1, {
        padding: 3
      }),
      q1: {
        padding,
        fill: blueGrey700
      },
      q1Labels: Object.assign({}, baseLabelStyles$1, {
        padding: 3
      }),
      q3: {
        padding,
        fill: blueGrey700
      },
      q3Labels: Object.assign({}, baseLabelStyles$1, {
        padding: 3
      })
    },
    boxWidth: 20
  }, baseProps),
  candlestick: Object.assign({
    style: {
      data: {
        stroke: blueGrey700
      },
      labels: Object.assign({}, baseLabelStyles$1, {
        padding: 5
      })
    },
    candleColors: {
      positive: "#ffffff",
      negative: blueGrey700
    }
  }, baseProps),
  chart: baseProps,
  errorbar: Object.assign({
    borderWidth: 8,
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: blueGrey700,
        strokeWidth: 2
      },
      labels: baseLabelStyles$1
    }
  }, baseProps),
  group: Object.assign({
    colorScale: colors
  }, baseProps),
  histogram: Object.assign({
    style: {
      data: {
        fill: blueGrey700,
        stroke: grey900,
        strokeWidth: 2
      },
      labels: baseLabelStyles$1
    }
  }, baseProps),
  legend: {
    colorScale: colors,
    gutter: 10,
    orientation: "vertical",
    titleOrientation: "top",
    style: {
      data: {
        type: "circle"
      },
      labels: baseLabelStyles$1,
      title: Object.assign({}, baseLabelStyles$1, {
        padding: 5
      })
    }
  },
  line: Object.assign({
    style: {
      data: {
        fill: "transparent",
        opacity: 1,
        stroke: blueGrey700,
        strokeWidth: 2
      },
      labels: baseLabelStyles$1
    }
  }, baseProps),
  pie: Object.assign({
    colorScale: colors,
    style: {
      data: {
        padding,
        stroke: blueGrey50,
        strokeWidth: 1
      },
      labels: Object.assign({}, baseLabelStyles$1, {
        padding: 20
      })
    }
  }, baseProps),
  scatter: Object.assign({
    style: {
      data: {
        fill: blueGrey700,
        opacity: 1,
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: baseLabelStyles$1
    }
  }, baseProps),
  stack: Object.assign({
    colorScale: colors
  }, baseProps),
  tooltip: {
    style: Object.assign({}, baseLabelStyles$1, {
      padding: 0,
      pointerEvents: "none"
    }),
    flyoutStyle: {
      stroke: grey900,
      strokeWidth: 1,
      fill: "#f0f0f0",
      pointerEvents: "none"
    },
    flyoutPadding: 5,
    cornerRadius: 5,
    pointerLength: 10
  },
  voronoi: Object.assign({
    style: {
      data: {
        fill: "transparent",
        stroke: "transparent",
        strokeWidth: 0
      },
      labels: Object.assign({}, baseLabelStyles$1, {
        padding: 5,
        pointerEvents: "none"
      }),
      flyout: {
        stroke: grey900,
        strokeWidth: 1,
        fill: "#f0f0f0",
        pointerEvents: "none"
      }
    }
  }, baseProps)
};
const VictoryTheme = {
  grayscale,
  material
};
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
const Path$1 = /* @__PURE__ */ forwardRef((props2, ref2) => {
  var _a2;
  const {
    desc,
    id,
    tabIndex,
    origin,
    ...rest
  } = props2;
  const svgProps = {
    id: (_a2 = evaluateProp(id, props2)) == null ? void 0 : _a2.toString(),
    tabIndex: evaluateProp(tabIndex, props2),
    ...rest
  };
  return desc ? /* @__PURE__ */ React__default.createElement("path", _extends$1({}, svgProps, {
    ref: ref2
  }), /* @__PURE__ */ React__default.createElement("desc", null, desc)) : /* @__PURE__ */ React__default.createElement("path", _extends$1({}, svgProps, {
    ref: ref2
  }));
});
const getArcPath = (props2) => {
  const {
    cx,
    cy,
    r,
    startAngle,
    endAngle,
    closedPath
  } = props2;
  const halfAngle = Math.abs(endAngle - startAngle) / 2 + startAngle;
  const x1 = cx + r * Math.cos(degreesToRadians(startAngle));
  const y1 = cy - r * Math.sin(degreesToRadians(startAngle));
  const x22 = cx + r * Math.cos(degreesToRadians(halfAngle));
  const y22 = cy - r * Math.sin(degreesToRadians(halfAngle));
  const x3 = cx + r * Math.cos(degreesToRadians(endAngle));
  const y32 = cy - r * Math.sin(degreesToRadians(endAngle));
  const largerArcFlag1 = halfAngle - startAngle <= 180 ? 0 : 1;
  const largerArcFlag2 = endAngle - halfAngle <= 180 ? 0 : 1;
  const arcStart = closedPath ? ` M ${cx}, ${cy} L ${x1}, ${y1}` : `M ${x1}, ${y1}`;
  const arc1 = `A ${r}, ${r}, 0, ${largerArcFlag1}, 0, ${x22}, ${y22}`;
  const arc2 = `A ${r}, ${r}, 0, ${largerArcFlag2}, 0, ${x3}, ${y32}`;
  const arcEnd = closedPath ? "Z" : "";
  return `${arcStart} ${arc1} ${arc2} ${arcEnd}`;
};
const evaluateProps$6 = (props2) => {
  const ariaLabel = evaluateProp(props2.ariaLabel, props2);
  const desc = evaluateProp(props2.desc, props2);
  const id = evaluateProp(props2.id, props2);
  const style2 = evaluateStyle(Object.assign({
    stroke: "black",
    fill: "none"
  }, props2.style), props2);
  const tabIndex = evaluateProp(props2.tabIndex, props2);
  return Object.assign({}, props2, {
    ariaLabel,
    desc,
    id,
    style: style2,
    tabIndex
  });
};
const defaultProps$7 = {
  pathComponent: /* @__PURE__ */ React__default.createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};
const Arc = (initialProps) => {
  const props2 = evaluateProps$6(_defaults({}, initialProps, defaultProps$7));
  return /* @__PURE__ */ React__default.cloneElement(props2.pathComponent, {
    ...props2.events,
    "aria-label": props2.ariaLabel,
    d: getArcPath(props2),
    style: props2.style,
    desc: props2.desc,
    tabIndex: props2.tabIndex,
    className: props2.className,
    role: props2.role,
    shapeRendering: props2.shapeRendering,
    transform: props2.transform,
    clipPath: props2.clipPath
  });
};
const evaluateProps$5 = (props2) => {
  const id = evaluateProp(props2.id, props2);
  return Object.assign({}, props2, {
    id
  });
};
const defaultProps$6 = {
  circleComponent: /* @__PURE__ */ React__default.createElement(Circle, null),
  rectComponent: /* @__PURE__ */ React__default.createElement(Rect, null),
  role: "presentation",
  shapeRendering: "auto"
};
const Background = (initialProps) => {
  const props2 = evaluateProps$5(_defaults({}, initialProps, defaultProps$6));
  return props2.polar ? /* @__PURE__ */ React__default.cloneElement(props2.circleComponent, {
    ...props2.events,
    style: props2.style,
    role: props2.role,
    shapeRendering: props2.shapeRendering,
    cx: props2.x,
    cy: props2.y,
    r: props2.height,
    className: props2.className
  }) : /* @__PURE__ */ React__default.cloneElement(props2.rectComponent, {
    ...props2.events,
    style: props2.style,
    role: props2.role,
    shapeRendering: props2.shapeRendering,
    x: props2.x,
    y: props2.y,
    rx: props2.rx,
    ry: props2.ry,
    width: props2.width,
    height: props2.height,
    className: props2.className
  });
};
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const Line = /* @__PURE__ */ forwardRef((props2, ref2) => {
  var _a2;
  const {
    desc,
    id,
    tabIndex,
    origin,
    ...rest
  } = props2;
  const svgProps = {
    vectorEffect: "non-scaling-stroke",
    id: (_a2 = evaluateProp(id, props2)) == null ? void 0 : _a2.toString(),
    tabIndex: evaluateProp(tabIndex, props2),
    ...rest
  };
  return desc ? /* @__PURE__ */ React__default.createElement("line", _extends({}, svgProps, {
    ref: ref2
  }), /* @__PURE__ */ React__default.createElement("desc", null, desc)) : /* @__PURE__ */ React__default.createElement("line", _extends({}, svgProps, {
    ref: ref2
  }));
});
const evaluateProps$4 = (props2) => {
  const ariaLabel = evaluateProp(props2.ariaLabel, props2);
  const desc = evaluateProp(props2.desc, props2);
  const id = evaluateProp(props2.id, props2);
  const style2 = evaluateStyle(Object.assign({
    stroke: "black"
  }, props2.style), props2);
  const tabIndex = evaluateProp(props2.tabIndex, props2);
  return Object.assign({}, props2, {
    ariaLabel,
    desc,
    id,
    style: style2,
    tabIndex
  });
};
const defaultProps$5 = {
  lineComponent: /* @__PURE__ */ React__default.createElement(Line, null),
  role: "presentation",
  shapeRendering: "auto"
};
const LineSegment = (initialProps) => {
  const props2 = evaluateProps$4(_defaults({}, initialProps, defaultProps$5));
  return /* @__PURE__ */ React__default.cloneElement(props2.lineComponent, {
    ...props2.events,
    "aria-label": props2.ariaLabel,
    style: props2.style,
    desc: props2.desc,
    tabIndex: props2.tabIndex,
    className: props2.className,
    role: props2.role,
    shapeRendering: props2.shapeRendering,
    x1: props2.x1,
    x2: props2.x2,
    y1: props2.y1,
    y2: props2.y2,
    transform: props2.transform,
    clipPath: props2.clipPath
  });
};
function baseFindIndex$1(array2, predicate, fromIndex, fromRight) {
  var length2 = array2.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length2) {
    if (predicate(array2[index2], index2, array2)) {
      return index2;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array2, value, fromIndex) {
  var index2 = fromIndex - 1, length2 = array2.length;
  while (++index2 < length2) {
    if (array2[index2] === value) {
      return index2;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array2, value, fromIndex) {
  return value === value ? strictIndexOf(array2, value, fromIndex) : baseFindIndex(array2, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array2, value) {
  var length2 = array2 == null ? 0 : array2.length;
  return !!length2 && baseIndexOf(array2, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array2, value, comparator) {
  var index2 = -1, length2 = array2 == null ? 0 : array2.length;
  while (++index2 < length2) {
    if (comparator(value, array2[index2])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function noop$3() {
}
var noop_1 = noop$3;
var Set$1 = _Set, noop$2 = noop_1, setToArray$1 = _setToArray;
var INFINITY = 1 / 0;
var createSet$1 = !(Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY) ? noop$2 : function(values6) {
  return new Set$1(values6);
};
var _createSet = createSet$1;
var SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas = _cacheHas, createSet = _createSet, setToArray = _setToArray;
var LARGE_ARRAY_SIZE = 200;
function baseUniq$2(array2, iteratee, comparator) {
  var index2 = -1, includes = arrayIncludes, length2 = array2.length, isCommon = true, result = [], seen = result;
  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  } else if (length2 >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array2);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length2) {
      var value = array2[index2], computed = iteratee ? iteratee(value) : value;
      value = comparator || value !== 0 ? value : 0;
      if (isCommon && computed === computed) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed);
        }
        result.push(value);
      } else if (!includes(seen, computed, comparator)) {
        if (seen !== result) {
          seen.push(computed);
        }
        result.push(value);
      }
    }
  return result;
}
var _baseUniq = baseUniq$2;
var baseUniq$1 = _baseUniq;
function uniq(array2) {
  return array2 && array2.length ? baseUniq$1(array2) : [];
}
var uniq_1 = uniq;
const _uniq = /* @__PURE__ */ getDefaultExportFromCjs(uniq_1);
var FUNC_ERROR_TEXT$2 = "Expected a function";
function negate$1(predicate) {
  if (typeof predicate != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0:
        return !predicate.call(this);
      case 1:
        return !predicate.call(this, args[0]);
      case 2:
        return !predicate.call(this, args[0], args[1]);
      case 3:
        return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}
var negate_1 = negate$1;
var arrayPush = _arrayPush, getPrototype = _getPrototype, getSymbols = _getSymbols, stubArray = stubArray_1;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn$1 = !nativeGetSymbols ? stubArray : function(object2) {
  var result = [];
  while (object2) {
    arrayPush(result, getSymbols(object2));
    object2 = getPrototype(object2);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbolsIn = _getSymbolsIn, keysIn = keysIn_1;
function getAllKeysIn$1(object2) {
  return baseGetAllKeys(object2, keysIn, getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn$1;
var arrayMap = _arrayMap, baseIteratee$2 = _baseIteratee, basePickBy = _basePickBy, getAllKeysIn = _getAllKeysIn;
function pickBy$1(object2, predicate) {
  if (object2 == null) {
    return {};
  }
  var props2 = arrayMap(getAllKeysIn(object2), function(prop) {
    return [prop];
  });
  predicate = baseIteratee$2(predicate);
  return basePickBy(object2, props2, function(value, path2) {
    return predicate(value, path2[0]);
  });
}
var pickBy_1 = pickBy$1;
const _pickBy = /* @__PURE__ */ getDefaultExportFromCjs(pickBy_1);
var baseIteratee$1 = _baseIteratee, negate = negate_1, pickBy = pickBy_1;
function omitBy(object2, predicate) {
  return pickBy(object2, negate(baseIteratee$1(predicate)));
}
var omitBy_1 = omitBy;
const _omitBy = /* @__PURE__ */ getDefaultExportFromCjs(omitBy_1);
const GLOBAL_EVENT_REGEX = /^onGlobal(.*)$/;
function getEvents(props2, target, eventKey, getScopedEvents2) {
  const getEventsByTarget = (events) => {
    const getSelectedEvents = () => {
      const targetEvents = events.reduce((memo, event2) => {
        if (event2.target !== void 0) {
          const matchesTarget = Array.isArray(event2.target) ? event2.target.includes(target) : `${event2.target}` === `${target}`;
          return matchesTarget ? memo.concat(event2) : memo;
        }
        return memo.concat(event2);
      }, []);
      if (eventKey !== void 0 && target !== "parent") {
        return targetEvents.filter((obj) => {
          const targetKeys = obj.eventKey;
          const useKey = (key) => key ? `${key}` === `${eventKey}` : true;
          return Array.isArray(targetKeys) ? targetKeys.some((k3) => useKey(k3)) : useKey(targetKeys);
        });
      }
      return targetEvents;
    };
    const selectedEvents = getSelectedEvents();
    return Array.isArray(selectedEvents) && selectedEvents.reduce((memo, event2) => {
      return event2 ? Object.assign(memo, event2.eventHandlers) : memo;
    }, {});
  };
  const getAllEvents2 = () => {
    if (Array.isArray(this.componentEvents)) {
      return Array.isArray(props2.events) ? this.componentEvents.concat(...props2.events) : this.componentEvents;
    }
    return props2.events;
  };
  const allEvents = getAllEvents2();
  const ownEvents = allEvents && isFunction$1(getScopedEvents2) ? getScopedEvents2(getEventsByTarget(allEvents), target) : void 0;
  if (!props2.sharedEvents) {
    return ownEvents;
  }
  const getSharedEvents = props2.sharedEvents.getEvents;
  const sharedEvents = props2.sharedEvents.events && getSharedEvents(getEventsByTarget(props2.sharedEvents.events), target);
  return Object.assign({}, sharedEvents, ownEvents);
}
function getScopedEvents(events, namespace, childType, baseProps2) {
  if (_isEmpty(events)) {
    return {};
  }
  const newBaseProps = baseProps2 || this.baseProps;
  const getTargetProps = (identifier2, type2) => {
    const {
      childName,
      target,
      key
    } = identifier2;
    const baseType = type2 === "props" ? newBaseProps : this.state || {};
    const base2 = childName === void 0 || childName === null || !baseType[childName] ? baseType : baseType[childName];
    return key === "parent" ? base2.parent : base2[key] && base2[key][target];
  };
  const parseEvent = (eventReturn, eventKey) => {
    const childNames = namespace === "parent" ? eventReturn.childName : eventReturn.childName || childType;
    const target = eventReturn.target || namespace;
    const getKeys2 = (childName) => {
      if (target === "parent") {
        return "parent";
      }
      if (eventReturn.eventKey === "all") {
        return newBaseProps[childName] ? Object.keys(newBaseProps[childName]).filter((value) => value !== "parent") : Object.keys(newBaseProps).filter((value) => value !== "parent");
      } else if (eventReturn.eventKey === void 0 && eventKey === "parent") {
        return newBaseProps[childName] ? Object.keys(newBaseProps[childName]) : Object.keys(newBaseProps);
      }
      return eventReturn.eventKey !== void 0 ? eventReturn.eventKey : eventKey;
    };
    const getMutationObject = (key, childName) => {
      const baseState = this.state || {};
      if (!isFunction$1(eventReturn.mutation)) {
        return baseState;
      }
      const mutationTargetProps = getTargetProps({
        childName,
        key,
        target
      }, "props");
      const mutationTargetState = getTargetProps({
        childName,
        key,
        target
      }, "state");
      const mutatedProps = eventReturn.mutation(Object.assign({}, mutationTargetProps, mutationTargetState), newBaseProps);
      const childState = baseState[childName] || {};
      const filterState = (state) => {
        if (state[key] && state[key][target]) {
          delete state[key][target];
        }
        if (state[key] && !Object.keys(state[key]).length) {
          delete state[key];
        }
        return state;
      };
      const extendState = (state) => {
        return target === "parent" ? Object.assign(state, {
          [key]: Object.assign(state[key] || {}, mutatedProps)
        }) : Object.assign(state, {
          [key]: Object.assign(state[key] || {}, {
            [target]: mutatedProps
          })
        });
      };
      const updateState = (state) => {
        return mutatedProps ? extendState(state) : filterState(state);
      };
      return childName !== void 0 && childName !== null ? Object.assign(baseState, {
        [childName]: updateState(childState)
      }) : updateState(baseState);
    };
    const getReturnByChild = (childName) => {
      const mutationKeys = getKeys2(childName);
      return Array.isArray(mutationKeys) ? mutationKeys.reduce((memo, key) => {
        return Object.assign(memo, getMutationObject(key, childName));
      }, {}) : getMutationObject(mutationKeys, childName);
    };
    const allChildNames = childNames === "all" ? Object.keys(newBaseProps).filter((value) => value !== "parent") : childNames;
    return Array.isArray(allChildNames) ? allChildNames.reduce((memo, childName) => {
      return Object.assign(memo, getReturnByChild(childName));
    }, {}) : getReturnByChild(allChildNames);
  };
  const parseEventReturn = (eventReturn, eventKey) => {
    return Array.isArray(eventReturn) ? eventReturn.reduce((memo, props2) => Object.assign({}, memo, parseEvent(props2, eventKey)), {}) : parseEvent(eventReturn, eventKey);
  };
  const compileCallbacks = (eventReturn) => {
    const getCallback = (obj) => isFunction$1(obj.callback) && obj.callback;
    const callbacks = Array.isArray(eventReturn) ? eventReturn.map((evtObj) => getCallback(evtObj)) : [getCallback(eventReturn)];
    const callbackArray = callbacks.filter((callback) => callback !== false);
    return callbackArray.length ? () => callbackArray.forEach((callback) => callback()) : void 0;
  };
  const onEvent = (evt, childProps, eventKey, eventName) => {
    const eventReturn = events[eventName](evt, childProps, eventKey, this);
    if (!_isEmpty(eventReturn)) {
      const callbacks = compileCallbacks(eventReturn);
      this.setState(parseEventReturn(eventReturn, eventKey), callbacks);
    }
  };
  return Object.keys(events).reduce((memo, event2) => {
    memo[event2] = onEvent;
    return memo;
  }, {});
}
function getPartialEvents(events, eventKey, childProps) {
  if (!events)
    return {};
  return Object.keys(events).reduce((memo, eventName) => {
    const appliedEvent = (evt) => events[eventName](evt, childProps, eventKey, eventName);
    memo[eventName] = appliedEvent;
    return memo;
  }, {});
}
function getEventState(eventKey, namespace, childType) {
  const state = this.state || {};
  if (!childType) {
    return eventKey === "parent" ? state[eventKey] && state[eventKey][namespace] || state[eventKey] : state[eventKey] && state[eventKey][namespace];
  }
  return state[childType] && state[childType][eventKey] && state[childType][eventKey][namespace];
}
function getExternalMutationsWithChildren(mutations, baseProps2, baseState, childNames) {
  if (baseProps2 === void 0) {
    baseProps2 = {};
  }
  if (baseState === void 0) {
    baseState = {};
  }
  return childNames.reduce((memo, childName) => {
    const childState = baseState[childName];
    const mutation = getExternalMutations(mutations, baseProps2[childName], baseState[childName], childName);
    memo[childName] = mutation ? mutation : childState;
    return _pickBy(memo, (v) => !_isEmpty(v));
  }, {});
}
function getExternalMutations(mutations, baseProps2, baseState, childName) {
  if (baseProps2 === void 0) {
    baseProps2 = {};
  }
  if (baseState === void 0) {
    baseState = {};
  }
  const eventKeys = Object.keys(baseProps2);
  return eventKeys.reduce((memo, eventKey) => {
    const keyState = baseState[eventKey] || {};
    const keyProps = baseProps2[eventKey] || {};
    if (eventKey === "parent") {
      const identifier2 = {
        eventKey,
        target: "parent"
      };
      const mutation = getExternalMutation(mutations, keyProps, keyState, identifier2);
      memo[eventKey] = mutation !== void 0 ? Object.assign({}, keyState, mutation) : keyState;
    } else {
      const targets = _uniq(Object.keys(keyProps).concat(Object.keys(keyState)));
      memo[eventKey] = targets.reduce((m3, target) => {
        const identifier2 = {
          eventKey,
          target,
          childName
        };
        const mutation = getExternalMutation(mutations, keyProps[target], keyState[target], identifier2);
        m3[target] = mutation !== void 0 ? Object.assign({}, keyState[target], mutation) : keyState[target];
        return _pickBy(m3, (v) => !_isEmpty(v));
      }, {});
    }
    return _pickBy(memo, (v) => !_isEmpty(v));
  }, {});
}
function getExternalMutation(mutations, baseProps2, baseState, identifier2) {
  const filterMutations = (mutation, type2) => {
    if (typeof mutation[type2] === "string") {
      return mutation[type2] === "all" || mutation[type2] === identifier2[type2];
    } else if (Array.isArray(mutation[type2])) {
      const stringArray = mutation[type2].map((m3) => `${m3}`);
      return stringArray.includes(identifier2[type2]);
    }
    return false;
  };
  let scopedMutations = Array.isArray(mutations) ? mutations : [mutations];
  if (identifier2.childName) {
    scopedMutations = mutations.filter((m3) => filterMutations(m3, "childName"));
  }
  const targetMutations = scopedMutations.filter((m3) => filterMutations(m3, "target"));
  if (_isEmpty(targetMutations)) {
    return void 0;
  }
  const keyMutations = targetMutations.filter((m3) => filterMutations(m3, "eventKey"));
  if (_isEmpty(keyMutations)) {
    return void 0;
  }
  return keyMutations.reduce((memo, curr) => {
    const mutationFunction = curr && isFunction$1(curr.mutation) ? curr.mutation : () => void 0;
    const currentMutation = mutationFunction(Object.assign({}, baseProps2, baseState));
    return Object.assign({}, memo, currentMutation);
  }, {});
}
function getComponentEvents(props2, components2) {
  const events = Array.isArray(components2) && components2.reduce((memo, componentName) => {
    const component = props2[componentName];
    const defaultEvents = component && component.type && component.type.defaultEvents;
    const componentEvents = isFunction$1(defaultEvents) ? defaultEvents(component.props) : defaultEvents;
    return Array.isArray(componentEvents) ? memo.concat(...componentEvents) : memo;
  }, []);
  return events && events.length ? events : void 0;
}
function getGlobalEventNameFromKey(key) {
  const match2 = key.match(GLOBAL_EVENT_REGEX);
  return match2 && match2[1] && match2[1].toLowerCase();
}
const getGlobalEvents = (events) => _pickBy(events, (_, key) => GLOBAL_EVENT_REGEX.test(key));
const omitGlobalEvents = (events) => _omitBy(events, (_, key) => GLOBAL_EVENT_REGEX.test(key));
const emulateReactEvent = (event2) => Object.assign(event2, {
  nativeEvent: event2
});
const datumHasXandY = (datum) => {
  return !isNil(datum._x) && !isNil(datum._y);
};
const defaultComponents = [{
  name: "parent",
  index: "parent"
}, {
  name: "data"
}, {
  name: "labels"
}];
function addEvents(WrappedComponent, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  class AddEventsMixin extends WrappedComponent {
    constructor(props2) {
      super(props2);
      __publicField(this, "state", {});
      __publicField(this, "getEventState", getEventState.bind(this));
      __publicField(this, "getScopedEvents", getScopedEvents.bind(this));
      __publicField(this, "getEvents", (p, target, eventKey) => {
        return getEvents.call(this, p, target, eventKey, this.getScopedEvents);
      });
      __publicField(this, "externalMutations", this.getExternalMutations(this.props));
      __publicField(this, "calculatedState", this.getStateChanges(this.props));
      __publicField(this, "globalEvents", {});
      __publicField(this, "prevGlobalEventKeys", []);
      __publicField(this, "boundGlobalEvents", {});
      this.cacheValues(this.getCalculatedValues(props2));
    }
    shouldComponentUpdate(nextProps) {
      const externalMutations = this.getExternalMutations(nextProps);
      const animating = this.props.animating || this.props.animate;
      const newMutation = !isEqual$5(externalMutations, this.externalMutations);
      if (animating || newMutation) {
        this.cacheValues(this.getCalculatedValues(nextProps));
        this.externalMutations = externalMutations;
        this.applyExternalMutations(nextProps, externalMutations);
        return true;
      }
      const calculatedState = this.getStateChanges(nextProps);
      if (!isEqual$5(this.calculatedState, calculatedState)) {
        this.cacheValues(this.getCalculatedValues(nextProps));
        return true;
      }
      if (!isEqual$5(this.props, nextProps)) {
        this.cacheValues(this.getCalculatedValues(nextProps));
        return true;
      }
      return false;
    }
    componentDidMount() {
      const globalEventKeys = Object.keys(this.globalEvents);
      globalEventKeys.forEach((key) => this.addGlobalListener(key));
      this.prevGlobalEventKeys = globalEventKeys;
    }
    componentDidUpdate(prevProps) {
      const calculatedState = this.getStateChanges(prevProps);
      this.calculatedState = calculatedState;
      const globalEventKeys = Object.keys(this.globalEvents);
      const removedGlobalEventKeys = difference(this.prevGlobalEventKeys, globalEventKeys);
      removedGlobalEventKeys.forEach((key) => this.removeGlobalListener(key));
      const addedGlobalEventKeys = difference(globalEventKeys, this.prevGlobalEventKeys);
      addedGlobalEventKeys.forEach((key) => this.addGlobalListener(key));
      this.prevGlobalEventKeys = globalEventKeys;
    }
    componentWillUnmount() {
      this.prevGlobalEventKeys.forEach((key) => this.removeGlobalListener(key));
    }
    addGlobalListener(key) {
      const boundListener = (event2) => {
        const listener = this.globalEvents[key];
        return listener && listener(emulateReactEvent(event2));
      };
      this.boundGlobalEvents[key] = boundListener;
      window.addEventListener(getGlobalEventNameFromKey(key), boundListener);
    }
    removeGlobalListener(key) {
      window.removeEventListener(getGlobalEventNameFromKey(key), this.boundGlobalEvents[key]);
    }
    // compile all state changes from own and parent state. Order doesn't matter, as any state
    // state change should trigger a re-render
    getStateChanges(props2) {
      if (!this.hasEvents) {
        return {};
      }
      const getState2 = (key, type2) => {
        const result = _defaults({}, this.getEventState(key, type2), this.getSharedEventState(key, type2));
        return _isEmpty(result) ? void 0 : result;
      };
      const components2 = options2.components || defaultComponents;
      const stateChanges = components2.map((component) => {
        if (!props2.standalone && component.name === "parent") {
          return void 0;
        }
        return component.index !== void 0 ? getState2(component.index, component.name) : this.dataKeys.map((key) => getState2(key, component.name)).filter(Boolean);
      }).filter(Boolean);
      return stateChanges;
    }
    applyExternalMutations(props2, externalMutations) {
      if (!_isEmpty(externalMutations)) {
        const callbacks = props2.externalEventMutations.reduce((memo, mutation) => isFunction$1(mutation.callback) ? memo.concat(mutation.callback) : memo, []);
        const compiledCallbacks = callbacks.length ? () => {
          callbacks.forEach((c7) => c7());
        } : void 0;
        this.setState(externalMutations, compiledCallbacks);
      }
    }
    getCalculatedValues(props2) {
      const {
        sharedEvents
      } = props2;
      const components2 = WrappedComponent.expectedComponents;
      const componentEvents = getComponentEvents(props2, components2);
      const getSharedEventState = sharedEvents && isFunction$1(sharedEvents.getEventState) ? sharedEvents.getEventState : () => void 0;
      const baseProps2 = this.getBaseProps(props2, getSharedEventState);
      const dataKeys = Object.keys(baseProps2).filter((key) => key !== "parent");
      const hasEvents = props2.events || props2.sharedEvents || componentEvents;
      const events = this.getAllEvents(props2);
      return {
        componentEvents,
        getSharedEventState,
        baseProps: baseProps2,
        dataKeys,
        hasEvents,
        events
      };
    }
    getExternalMutations(props2) {
      const {
        sharedEvents,
        externalEventMutations
      } = props2;
      return _isEmpty(externalEventMutations) || sharedEvents ? void 0 : getExternalMutations(externalEventMutations, this.baseProps, this.state);
    }
    cacheValues(obj) {
      Object.keys(obj).forEach((key) => {
        this[key] = obj[key];
      });
    }
    getBaseProps(props2, getSharedEventState) {
      const getSharedEventStateFunction = getSharedEventState || this.getSharedEventState.bind(this);
      const sharedParentState = getSharedEventStateFunction("parent", "parent");
      const parentState = this.getEventState("parent", "parent");
      const baseParentProps = _defaults({}, parentState, sharedParentState);
      const parentPropsList = baseParentProps.parentControlledProps;
      const parentProps = parentPropsList ? _pick(baseParentProps, parentPropsList) : {};
      const modifiedProps = _defaults({}, parentProps, props2);
      return typeof WrappedComponent.getBaseProps === "function" ? WrappedComponent.getBaseProps(modifiedProps) : {};
    }
    getAllEvents(props2) {
      if (Array.isArray(this.componentEvents)) {
        return Array.isArray(props2.events) ? this.componentEvents.concat(...props2.events) : this.componentEvents;
      }
      return props2.events;
    }
    getComponentProps(component, type2, index2) {
      const name2 = this.props.name || WrappedComponent.role;
      const key = this.dataKeys && this.dataKeys[index2] || index2;
      const id = `${name2}-${type2}-${key}`;
      const baseProps2 = this.baseProps[key] && this.baseProps[key][type2] || this.baseProps[key];
      if (!baseProps2 && !this.hasEvents) {
        return void 0;
      }
      const currentProps = component && typeof component === "object" && "props" in component ? component.props : void 0;
      if (this.hasEvents) {
        const baseEvents = this.getEvents(this.props, type2, key);
        const componentProps = _defaults({
          index: index2,
          key: id
        }, this.getEventState(key, type2), this.getSharedEventState(key, type2), currentProps, baseProps2, {
          id
        });
        const events = _defaults({}, getPartialEvents(baseEvents, key, componentProps), componentProps.events);
        return Object.assign({}, componentProps, {
          events
        });
      }
      return _defaults({
        index: index2,
        key: id
      }, currentProps, baseProps2, {
        id
      });
    }
    renderContainer(component, children2) {
      const isContainer = component.type && component.type.role === "container";
      const parentProps = isContainer ? this.getComponentProps(component, "parent", "parent") : {};
      if (parentProps.events) {
        this.globalEvents = getGlobalEvents(parentProps.events);
        parentProps.events = omitGlobalEvents(parentProps.events);
      }
      return /* @__PURE__ */ React__default.cloneElement(component, parentProps, children2);
    }
    animateComponent(props2, defaultAnimationWhitelist) {
      var _a2;
      const animationWhitelist = typeof props2.animate === "object" && ((_a2 = props2.animate) == null ? void 0 : _a2.animationWhitelist) || defaultAnimationWhitelist;
      const Comp = this.constructor;
      return /* @__PURE__ */ React__default.createElement(VictoryTransition, {
        animate: props2.animate,
        animationWhitelist
      }, /* @__PURE__ */ React__default.createElement(Comp, props2));
    }
    // Used by `VictoryLine` and `VictoryArea`
    renderContinuousData(props2) {
      const {
        dataComponent,
        labelComponent,
        groupComponent
      } = props2;
      const dataKeys = this.dataKeys.filter((value) => value !== "all");
      const labelComponents = dataKeys.reduce((memo, key) => {
        let newMemo = memo;
        const labelProps = this.getComponentProps(labelComponent, "labels", key);
        if (labelProps && labelProps.text !== void 0 && labelProps.text !== null) {
          newMemo = newMemo.concat(/* @__PURE__ */ React__default.cloneElement(labelComponent, labelProps));
        }
        return newMemo;
      }, []);
      const dataProps = this.getComponentProps(dataComponent, "data", "all");
      const children2 = [/* @__PURE__ */ React__default.cloneElement(dataComponent, dataProps), ...labelComponents];
      return this.renderContainer(groupComponent, children2);
    }
    renderData(props2, shouldRenderDatum) {
      if (shouldRenderDatum === void 0) {
        shouldRenderDatum = datumHasXandY;
      }
      const {
        dataComponent,
        labelComponent,
        groupComponent
      } = props2;
      const dataComponents = this.dataKeys.reduce((validDataComponents, _dataKey, index2) => {
        const dataProps = this.getComponentProps(dataComponent, "data", index2);
        if (shouldRenderDatum(dataProps.datum)) {
          validDataComponents.push(/* @__PURE__ */ React__default.cloneElement(dataComponent, dataProps));
        }
        return validDataComponents;
      }, []);
      const labelComponents = this.dataKeys.map((_dataKey, index2) => {
        const labelProps = this.getComponentProps(labelComponent, "labels", index2);
        if (labelProps.text !== void 0 && labelProps.text !== null) {
          return /* @__PURE__ */ React__default.cloneElement(labelComponent, labelProps);
        }
        return void 0;
      }).filter(Boolean);
      const children2 = [...dataComponents, ...labelComponents];
      return this.renderContainer(groupComponent, children2);
    }
  }
  return AddEventsMixin;
}
var baseGetTag$1 = _baseGetTag, isObjectLike$1 = isObjectLike_1;
var dateTag = "[object Date]";
function baseIsDate$1(value) {
  return isObjectLike$1(value) && baseGetTag$1(value) == dateTag;
}
var _baseIsDate = baseIsDate$1;
var baseIsDate = _baseIsDate, baseUnary$1 = _baseUnary, nodeUtil$1 = _nodeUtilExports;
var nodeIsDate = nodeUtil$1 && nodeUtil$1.isDate;
var isDate$2 = nodeIsDate ? baseUnary$1(nodeIsDate) : baseIsDate;
var isDate_1 = isDate$2;
const _isDate = /* @__PURE__ */ getDefaultExportFromCjs(isDate_1);
var eq = eq_1;
function baseSortedUniq$1(array2, iteratee) {
  var index2 = -1, length2 = array2.length, resIndex = 0, result = [];
  while (++index2 < length2) {
    var value = array2[index2], computed = iteratee ? iteratee(value) : value;
    if (!index2 || !eq(computed, seen)) {
      var seen = computed;
      result[resIndex++] = value === 0 ? 0 : value;
    }
  }
  return result;
}
var _baseSortedUniq = baseSortedUniq$1;
var baseSortedUniq = _baseSortedUniq;
function sortedUniq(array2) {
  return array2 && array2.length ? baseSortedUniq(array2) : [];
}
var sortedUniq_1 = sortedUniq;
const _sortedUniq = /* @__PURE__ */ getDefaultExportFromCjs(sortedUniq_1);
function isUndefined$1(value) {
  return value === void 0;
}
var isUndefined_1 = isUndefined$1;
const _isUndefined = /* @__PURE__ */ getDefaultExportFromCjs(isUndefined_1);
var baseIsEqual = _baseIsEqual;
function isEqual$4(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1 = isEqual$4;
const _isEqual = /* @__PURE__ */ getDefaultExportFromCjs(isEqual_1);
function ascending$1(a4, b10) {
  return a4 == null || b10 == null ? NaN : a4 < b10 ? -1 : a4 > b10 ? 1 : a4 >= b10 ? 0 : NaN;
}
function descending$2(a4, b10) {
  return a4 == null || b10 == null ? NaN : b10 < a4 ? -1 : b10 > a4 ? 1 : b10 >= a4 ? 0 : NaN;
}
function bisector(f) {
  let compare1, compare2, delta;
  if (f.length !== 2) {
    compare1 = ascending$1;
    compare2 = (d3, x3) => ascending$1(f(d3), x3);
    delta = (d3, x3) => f(d3) - x3;
  } else {
    compare1 = f === ascending$1 || f === descending$2 ? f : zero;
    compare2 = f;
    delta = f;
  }
  function left2(a4, x3, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x3, x3) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a4[mid], x3) < 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function right2(a4, x3, lo = 0, hi = a4.length) {
    if (lo < hi) {
      if (compare1(x3, x3) !== 0)
        return hi;
      do {
        const mid = lo + hi >>> 1;
        if (compare2(a4[mid], x3) <= 0)
          lo = mid + 1;
        else
          hi = mid;
      } while (lo < hi);
    }
    return lo;
  }
  function center(a4, x3, lo = 0, hi = a4.length) {
    const i2 = left2(a4, x3, lo, hi - 1);
    return i2 > lo && delta(a4[i2 - 1], x3) > -delta(a4[i2], x3) ? i2 - 1 : i2;
  }
  return { left: left2, center, right: right2 };
}
function zero() {
  return 0;
}
function number$3(x3) {
  return x3 === null ? NaN : +x3;
}
function* numbers(values6, valueof) {
  if (valueof === void 0) {
    for (let value of values6) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values6) {
      if ((value = valueof(value, ++index2, values6)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}
const ascendingBisect = bisector(ascending$1);
const bisectRight = ascendingBisect.right;
bisector(number$3).center;
class InternMap extends Map {
  constructor(entries6, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries6 != null)
      for (const [key2, value] of entries6)
        this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key))
    return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
function compareDefined(compare = ascending$1) {
  if (compare === ascending$1)
    return ascendingDefined;
  if (typeof compare !== "function")
    throw new TypeError("compare is not a function");
  return (a4, b10) => {
    const x3 = compare(a4, b10);
    if (x3 || x3 === 0)
      return x3;
    return (compare(b10, b10) === 0) - (compare(a4, a4) === 0);
  };
}
function ascendingDefined(a4, b10) {
  return (a4 == null || !(a4 >= a4)) - (b10 == null || !(b10 >= b10)) || (a4 < b10 ? -1 : a4 > b10 ? 1 : 0);
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start2, stop2, count) {
  const step2 = (stop2 - start2) / Math.max(0, count), power = Math.floor(Math.log10(step2)), error2 = step2 / Math.pow(10, power), factor = error2 >= e10 ? 10 : error2 >= e5 ? 5 : error2 >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start2 * inc);
    i2 = Math.round(stop2 * inc);
    if (i1 / inc < start2)
      ++i1;
    if (i2 / inc > stop2)
      --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start2 / inc);
    i2 = Math.round(stop2 / inc);
    if (i1 * inc < start2)
      ++i1;
    if (i2 * inc > stop2)
      --i2;
  }
  if (i2 < i1 && 0.5 <= count && count < 2)
    return tickSpec(start2, stop2, count * 2);
  return [i1, i2, inc];
}
function ticks(start2, stop2, count) {
  stop2 = +stop2, start2 = +start2, count = +count;
  if (!(count > 0))
    return [];
  if (start2 === stop2)
    return [start2];
  const reverse2 = stop2 < start2, [i1, i2, inc] = reverse2 ? tickSpec(stop2, start2, count) : tickSpec(start2, stop2, count);
  if (!(i2 >= i1))
    return [];
  const n = i2 - i1 + 1, ticks2 = new Array(n);
  if (reverse2) {
    if (inc < 0)
      for (let i3 = 0; i3 < n; ++i3)
        ticks2[i3] = (i2 - i3) / -inc;
    else
      for (let i3 = 0; i3 < n; ++i3)
        ticks2[i3] = (i2 - i3) * inc;
  } else {
    if (inc < 0)
      for (let i3 = 0; i3 < n; ++i3)
        ticks2[i3] = (i1 + i3) / -inc;
    else
      for (let i3 = 0; i3 < n; ++i3)
        ticks2[i3] = (i1 + i3) * inc;
  }
  return ticks2;
}
function tickIncrement(start2, stop2, count) {
  stop2 = +stop2, start2 = +start2, count = +count;
  return tickSpec(start2, stop2, count)[2];
}
function tickStep(start2, stop2, count) {
  stop2 = +stop2, start2 = +start2, count = +count;
  const reverse2 = stop2 < start2, inc = reverse2 ? tickIncrement(stop2, start2, count) : tickIncrement(start2, stop2, count);
  return (reverse2 ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
function max$1(values6, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values6) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values6) {
      if ((value = valueof(value, ++index2, values6)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$1(values6, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values6) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values6) {
      if ((value = valueof(value, ++index2, values6)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function quickselect(array2, k3, left2 = 0, right2 = Infinity, compare) {
  k3 = Math.floor(k3);
  left2 = Math.floor(Math.max(0, left2));
  right2 = Math.floor(Math.min(array2.length - 1, right2));
  if (!(left2 <= k3 && k3 <= right2))
    return array2;
  compare = compare === void 0 ? ascendingDefined : compareDefined(compare);
  while (right2 > left2) {
    if (right2 - left2 > 600) {
      const n = right2 - left2 + 1;
      const m3 = k3 - left2 + 1;
      const z2 = Math.log(n);
      const s4 = 0.5 * Math.exp(2 * z2 / 3);
      const sd = 0.5 * Math.sqrt(z2 * s4 * (n - s4) / n) * (m3 - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left2, Math.floor(k3 - m3 * s4 / n + sd));
      const newRight = Math.min(right2, Math.floor(k3 + (n - m3) * s4 / n + sd));
      quickselect(array2, k3, newLeft, newRight, compare);
    }
    const t2 = array2[k3];
    let i2 = left2;
    let j = right2;
    swap(array2, left2, k3);
    if (compare(array2[right2], t2) > 0)
      swap(array2, left2, right2);
    while (i2 < j) {
      swap(array2, i2, j), ++i2, --j;
      while (compare(array2[i2], t2) < 0)
        ++i2;
      while (compare(array2[j], t2) > 0)
        --j;
    }
    if (compare(array2[left2], t2) === 0)
      swap(array2, left2, j);
    else
      ++j, swap(array2, j, right2);
    if (j <= k3)
      left2 = j + 1;
    if (k3 <= j)
      right2 = j - 1;
  }
  return array2;
}
function swap(array2, i2, j) {
  const t2 = array2[i2];
  array2[i2] = array2[j];
  array2[j] = t2;
}
function quantile$1(values6, p, valueof) {
  values6 = Float64Array.from(numbers(values6, valueof));
  if (!(n = values6.length) || isNaN(p = +p))
    return;
  if (p <= 0 || n < 2)
    return min$1(values6);
  if (p >= 1)
    return max$1(values6);
  var n, i2 = (n - 1) * p, i0 = Math.floor(i2), value0 = max$1(quickselect(values6, i0).subarray(0, i0 + 1)), value1 = min$1(values6.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i2 - i0);
}
function quantileSorted(values6, p, valueof = number$3) {
  if (!(n = values6.length) || isNaN(p = +p))
    return;
  if (p <= 0 || n < 2)
    return +valueof(values6[0], 0, values6);
  if (p >= 1)
    return +valueof(values6[n - 1], n - 1, values6);
  var n, i2 = (n - 1) * p, i0 = Math.floor(i2), value0 = +valueof(values6[i0], i0, values6), value1 = +valueof(values6[i0 + 1], i0 + 1, values6);
  return value0 + (value1 - value0) * (i2 - i0);
}
function range(start2, stop2, step2) {
  start2 = +start2, stop2 = +stop2, step2 = (n = arguments.length) < 2 ? (stop2 = start2, start2 = 0, 1) : n < 3 ? 1 : +step2;
  var i2 = -1, n = Math.max(0, Math.ceil((stop2 - start2) / step2)) | 0, range2 = new Array(n);
  while (++i2 < n) {
    range2[i2] = start2 + i2 * step2;
  }
  return range2;
}
function initRange(domain, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain);
      break;
    default:
      this.range(range2).domain(domain);
      break;
  }
  return this;
}
function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain === "function")
        this.interpolator(domain);
      else
        this.range(domain);
      break;
    }
    default: {
      this.domain(domain);
      if (typeof interpolator === "function")
        this.interpolator(interpolator);
      else
        this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain = [], range2 = [], unknown2 = implicit;
  function scale(d3) {
    let i2 = index2.get(d3);
    if (i2 === void 0) {
      if (unknown2 !== implicit)
        return unknown2;
      index2.set(d3, i2 = domain.push(d3) - 1);
    }
    return range2[i2 % range2.length];
  }
  scale.domain = function(_) {
    if (!arguments.length)
      return domain.slice();
    domain = [], index2 = new InternMap();
    for (const value of _) {
      if (index2.has(value))
        continue;
      index2.set(value, domain.push(value) - 1);
    }
    return scale;
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), scale) : range2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  scale.copy = function() {
    return ordinal(domain, range2).unknown(unknown2);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step2, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n = domain().length, reverse2 = r1 < r0, start2 = reverse2 ? r1 : r0, stop2 = reverse2 ? r0 : r1;
    step2 = (stop2 - start2) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round2)
      step2 = Math.floor(step2);
    start2 += (stop2 - start2 - step2 * (n - paddingInner)) * align;
    bandwidth = step2 * (1 - paddingInner);
    if (round2)
      start2 = Math.round(start2), bandwidth = Math.round(bandwidth);
    var values6 = range(n).map(function(i2) {
      return start2 + step2 * i2;
    });
    return ordinalRange(reverse2 ? values6.reverse() : values6);
  }
  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step2;
  };
  scale.round = function(_) {
    return arguments.length ? (round2 = !!_, rescale()) : round2;
  };
  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };
  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };
  scale.copy = function() {
    return band(domain(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function pointish(scale) {
  var copy2 = scale.copy;
  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;
  scale.copy = function() {
    return pointish(copy2());
  };
  return scale;
}
function point$5() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function constants(x3) {
  return function() {
    return x3;
  };
}
function number$2(x3) {
  return +x3;
}
var unit = [0, 1];
function identity$4(x3) {
  return x3;
}
function normalize(a4, b10) {
  return (b10 -= a4 = +a4) ? function(x3) {
    return (x3 - a4) / b10;
  } : constants(isNaN(b10) ? NaN : 0.5);
}
function clamper(a4, b10) {
  var t2;
  if (a4 > b10)
    t2 = a4, a4 = b10, b10 = t2;
  return function(x3) {
    return Math.max(a4, Math.min(b10, x3));
  };
}
function bimap(domain, range2, interpolate2) {
  var d0 = domain[0], d1 = domain[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0)
    d0 = normalize(d1, d0), r0 = interpolate2(r1, r0);
  else
    d0 = normalize(d0, d1), r0 = interpolate2(r0, r1);
  return function(x3) {
    return r0(d0(x3));
  };
}
function polymap(domain, range2, interpolate2) {
  var j = Math.min(domain.length, range2.length) - 1, d3 = new Array(j), r = new Array(j), i2 = -1;
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i2 < j) {
    d3[i2] = normalize(domain[i2], domain[i2 + 1]);
    r[i2] = interpolate2(range2[i2], range2[i2 + 1]);
  }
  return function(x3) {
    var i3 = bisectRight(domain, x3, 1, j) - 1;
    return r[i3](d3[i3](x3));
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$2() {
  var domain = unit, range2 = unit, interpolate$12 = interpolate, transform, untransform, unknown2, clamp2 = identity$4, piecewise2, output, input2;
  function rescale() {
    var n = Math.min(domain.length, range2.length);
    if (clamp2 !== identity$4)
      clamp2 = clamper(domain[0], domain[n - 1]);
    piecewise2 = n > 2 ? polymap : bimap;
    output = input2 = null;
    return scale;
  }
  function scale(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown2 : (output || (output = piecewise2(domain.map(transform), range2, interpolate$12)))(transform(clamp2(x3)));
  }
  scale.invert = function(y4) {
    return clamp2(untransform((input2 || (input2 = piecewise2(range2, domain.map(transform), interpolateNumber)))(y4)));
  };
  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$2), rescale()) : domain.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_) {
    return range2 = Array.from(_), interpolate$12 = interpolateRound, rescale();
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp2 = _ ? true : identity$4, rescale()) : clamp2 !== identity$4;
  };
  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$12 = _, rescale()) : interpolate$12;
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  return function(t2, u2) {
    transform = t2, untransform = u2;
    return rescale();
  };
}
function continuous() {
  return transformer$2()(identity$4, identity$4);
}
function formatDecimal(x3) {
  return Math.abs(x3 = Math.round(x3)) >= 1e21 ? x3.toLocaleString("en").replace(/,/g, "") : x3.toString(10);
}
function formatDecimalParts(x3, p) {
  if ((i2 = (x3 = p ? x3.toExponential(p - 1) : x3.toExponential()).indexOf("e")) < 0)
    return null;
  var i2, coefficient = x3.slice(0, i2);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x3.slice(i2 + 1)
  ];
}
function exponent(x3) {
  return x3 = formatDecimalParts(Math.abs(x3)), x3 ? x3[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i2 = value.length, t2 = [], j = 0, g2 = grouping[0], length2 = 0;
    while (i2 > 0 && g2 > 0) {
      if (length2 + g2 + 1 > width)
        g2 = Math.max(1, width - length2);
      t2.push(value.substring(i2 -= g2, i2 + g2));
      if ((length2 += g2 + 1) > width)
        break;
      g2 = grouping[j = (j + 1) % grouping.length];
    }
    return t2.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i2) {
      return numerals[+i2];
    });
  };
}
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match2 = re.exec(specifier)))
    throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s4) {
  out:
    for (var n = s4.length, i2 = 1, i0 = -1, i1; i2 < n; ++i2) {
      switch (s4[i2]) {
        case ".":
          i0 = i1 = i2;
          break;
        case "0":
          if (i0 === 0)
            i0 = i2;
          i1 = i2;
          break;
        default:
          if (!+s4[i2])
            break out;
          if (i0 > 0)
            i0 = 0;
          break;
      }
    }
  return i0 > 0 ? s4.slice(0, i0) + s4.slice(i1 + 1) : s4;
}
var prefixExponent;
function formatPrefixAuto(x3, p) {
  var d3 = formatDecimalParts(x3, p);
  if (!d3)
    return x3 + "";
  var coefficient = d3[0], exponent2 = d3[1], i2 = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n = coefficient.length;
  return i2 === n ? coefficient : i2 > n ? coefficient + new Array(i2 - n + 1).join("0") : i2 > 0 ? coefficient.slice(0, i2) + "." + coefficient.slice(i2) : "0." + new Array(1 - i2).join("0") + formatDecimalParts(x3, Math.max(0, p + i2 - 1))[0];
}
function formatRounded(x3, p) {
  var d3 = formatDecimalParts(x3, p);
  if (!d3)
    return x3 + "";
  var coefficient = d3[0], exponent2 = d3[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
const formatTypes = {
  "%": (x3, p) => (x3 * 100).toFixed(p),
  "b": (x3) => Math.round(x3).toString(2),
  "c": (x3) => x3 + "",
  "d": formatDecimal,
  "e": (x3, p) => x3.toExponential(p),
  "f": (x3, p) => x3.toFixed(p),
  "g": (x3, p) => x3.toPrecision(p),
  "o": (x3) => Math.round(x3).toString(8),
  "p": (x3, p) => formatRounded(x3 * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x3) => Math.round(x3).toString(16).toUpperCase(),
  "x": (x3) => Math.round(x3).toString(16)
};
function identity$3(x3) {
  return x3;
}
var map = Array.prototype.map, prefixes$1 = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$3 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$3 : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type2 = specifier.type;
    if (type2 === "n")
      comma = true, type2 = "g";
    else if (!formatTypes[type2])
      precision === void 0 && (precision = 12), trim2 = true, type2 = "g";
    if (zero2 || fill === "0" && align === "=")
      zero2 = true, fill = "0", align = "=";
    var prefix2 = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type2) ? "0" + type2.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type2) ? percent : "";
    var formatType = formatTypes[type2], maybeSuffix = /[defgprs%]/.test(type2);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type2) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix2, valueSuffix = suffix, i2, n, c7;
      if (type2 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim2)
          value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+")
          valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type2 === "s" ? prefixes$1[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i2 = -1, n = value.length;
          while (++i2 < n) {
            if (c7 = value.charCodeAt(i2), 48 > c7 || c7 > 57) {
              valueSuffix = (c7 === 46 ? decimal + value.slice(i2 + 1) : value.slice(i2)) + valueSuffix;
              value = value.slice(0, i2);
              break;
            }
          }
        }
      }
      if (comma && !zero2)
        value = group(value, Infinity);
      var length2 = valuePrefix.length + value.length + valueSuffix.length, padding2 = length2 < width ? new Array(width - length2 + 1).join(fill) : "";
      if (comma && zero2)
        value = group(padding2 + value, padding2.length ? width - valueSuffix.length : Infinity), padding2 = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding2;
          break;
        case "=":
          value = valuePrefix + padding2 + value + valueSuffix;
          break;
        case "^":
          value = padding2.slice(0, length2 = padding2.length >> 1) + valuePrefix + value + valueSuffix + padding2.slice(length2);
          break;
        default:
          value = padding2 + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e3 = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k3 = Math.pow(10, -e3), prefix2 = prefixes$1[8 + e3 / 3];
    return function(value2) {
      return f(k3 * value2) + prefix2;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale$1;
var format;
var formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(definition) {
  locale$1 = formatLocale$1(definition);
  format = locale$1.format;
  formatPrefix = locale$1.formatPrefix;
  return locale$1;
}
function precisionFixed(step2) {
  return Math.max(0, -exponent(Math.abs(step2)));
}
function precisionPrefix(step2, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step2)));
}
function precisionRound(step2, max2) {
  step2 = Math.abs(step2), max2 = Math.abs(max2) - step2;
  return Math.max(0, exponent(max2) - exponent(step2)) + 1;
}
function tickFormat(start2, stop2, count, specifier) {
  var step2 = tickStep(start2, stop2, count), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start2), Math.abs(stop2));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step2, value)))
        specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step2, Math.max(Math.abs(start2), Math.abs(stop2)))))
        specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step2)))
        specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format(specifier);
}
function linearish(scale) {
  var domain = scale.domain;
  scale.ticks = function(count) {
    var d3 = domain();
    return ticks(d3[0], d3[d3.length - 1], count == null ? 10 : count);
  };
  scale.tickFormat = function(count, specifier) {
    var d3 = domain();
    return tickFormat(d3[0], d3[d3.length - 1], count == null ? 10 : count, specifier);
  };
  scale.nice = function(count) {
    if (count == null)
      count = 10;
    var d3 = domain();
    var i0 = 0;
    var i1 = d3.length - 1;
    var start2 = d3[i0];
    var stop2 = d3[i1];
    var prestep;
    var step2;
    var maxIter = 10;
    if (stop2 < start2) {
      step2 = start2, start2 = stop2, stop2 = step2;
      step2 = i0, i0 = i1, i1 = step2;
    }
    while (maxIter-- > 0) {
      step2 = tickIncrement(start2, stop2, count);
      if (step2 === prestep) {
        d3[i0] = start2;
        d3[i1] = stop2;
        return domain(d3);
      } else if (step2 > 0) {
        start2 = Math.floor(start2 / step2) * step2;
        stop2 = Math.ceil(stop2 / step2) * step2;
      } else if (step2 < 0) {
        start2 = Math.ceil(start2 * step2) / step2;
        stop2 = Math.floor(stop2 * step2) / step2;
      } else {
        break;
      }
      prestep = step2;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy$1(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function identity$2(domain) {
  var unknown2;
  function scale(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown2 : x3;
  }
  scale.invert = scale;
  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = Array.from(_, number$2), scale) : domain.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  scale.copy = function() {
    return identity$2(domain).unknown(unknown2);
  };
  domain = arguments.length ? Array.from(domain, number$2) : [0, 1];
  return linearish(scale);
}
function nice(domain, interval2) {
  domain = domain.slice();
  var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t2;
  if (x1 < x0) {
    t2 = i0, i0 = i1, i1 = t2;
    t2 = x0, x0 = x1, x1 = t2;
  }
  domain[i0] = interval2.floor(x0);
  domain[i1] = interval2.ceil(x1);
  return domain;
}
function transformLog(x3) {
  return Math.log(x3);
}
function transformExp(x3) {
  return Math.exp(x3);
}
function transformLogn(x3) {
  return -Math.log(-x3);
}
function transformExpn(x3) {
  return -Math.exp(-x3);
}
function pow10(x3) {
  return isFinite(x3) ? +("1e" + x3) : x3 < 0 ? 0 : x3;
}
function powp(base2) {
  return base2 === 10 ? pow10 : base2 === Math.E ? Math.exp : (x3) => Math.pow(base2, x3);
}
function logp(base2) {
  return base2 === Math.E ? Math.log : base2 === 10 && Math.log10 || base2 === 2 && Math.log2 || (base2 = Math.log(base2), (x3) => Math.log(x3) / base2);
}
function reflect(f) {
  return (x3, k3) => -f(-x3, k3);
}
function loggish(transform) {
  const scale = transform(transformLog, transformExp);
  const domain = scale.domain;
  let base2 = 10;
  let logs;
  let pows;
  function rescale() {
    logs = logp(base2), pows = powp(base2);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }
  scale.base = function(_) {
    return arguments.length ? (base2 = +_, rescale()) : base2;
  };
  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };
  scale.ticks = (count) => {
    const d3 = domain();
    let u2 = d3[0];
    let v = d3[d3.length - 1];
    const r = v < u2;
    if (r)
      [u2, v] = [v, u2];
    let i2 = logs(u2);
    let j = logs(v);
    let k3;
    let t2;
    const n = count == null ? 10 : +count;
    let z2 = [];
    if (!(base2 % 1) && j - i2 < n) {
      i2 = Math.floor(i2), j = Math.ceil(j);
      if (u2 > 0)
        for (; i2 <= j; ++i2) {
          for (k3 = 1; k3 < base2; ++k3) {
            t2 = i2 < 0 ? k3 / pows(-i2) : k3 * pows(i2);
            if (t2 < u2)
              continue;
            if (t2 > v)
              break;
            z2.push(t2);
          }
        }
      else
        for (; i2 <= j; ++i2) {
          for (k3 = base2 - 1; k3 >= 1; --k3) {
            t2 = i2 > 0 ? k3 / pows(-i2) : k3 * pows(i2);
            if (t2 < u2)
              continue;
            if (t2 > v)
              break;
            z2.push(t2);
          }
        }
      if (z2.length * 2 < n)
        z2 = ticks(u2, v, n);
    } else {
      z2 = ticks(i2, j, Math.min(j - i2, n)).map(pows);
    }
    return r ? z2.reverse() : z2;
  };
  scale.tickFormat = (count, specifier) => {
    if (count == null)
      count = 10;
    if (specifier == null)
      specifier = base2 === 10 ? "s" : ",";
    if (typeof specifier !== "function") {
      if (!(base2 % 1) && (specifier = formatSpecifier(specifier)).precision == null)
        specifier.trim = true;
      specifier = format(specifier);
    }
    if (count === Infinity)
      return specifier;
    const k3 = Math.max(1, base2 * count / scale.ticks().length);
    return (d3) => {
      let i2 = d3 / pows(Math.round(logs(d3)));
      if (i2 * base2 < base2 - 0.5)
        i2 *= base2;
      return i2 <= k3 ? specifier(d3) : "";
    };
  };
  scale.nice = () => {
    return domain(nice(domain(), {
      floor: (x3) => pows(Math.floor(logs(x3))),
      ceil: (x3) => pows(Math.ceil(logs(x3)))
    }));
  };
  return scale;
}
function log() {
  const scale = loggish(transformer$2()).domain([1, 10]);
  scale.copy = () => copy$1(scale, log()).base(scale.base());
  initRange.apply(scale, arguments);
  return scale;
}
function transformSymlog(c7) {
  return function(x3) {
    return Math.sign(x3) * Math.log1p(Math.abs(x3 / c7));
  };
}
function transformSymexp(c7) {
  return function(x3) {
    return Math.sign(x3) * Math.expm1(Math.abs(x3)) * c7;
  };
}
function symlogish(transform) {
  var c7 = 1, scale = transform(transformSymlog(c7), transformSymexp(c7));
  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c7 = +_), transformSymexp(c7)) : c7;
  };
  return linearish(scale);
}
function symlog() {
  var scale = symlogish(transformer$2());
  scale.copy = function() {
    return copy$1(scale, symlog()).constant(scale.constant());
  };
  return initRange.apply(scale, arguments);
}
function transformPow(exponent2) {
  return function(x3) {
    return x3 < 0 ? -Math.pow(-x3, exponent2) : Math.pow(x3, exponent2);
  };
}
function transformSqrt(x3) {
  return x3 < 0 ? -Math.sqrt(-x3) : Math.sqrt(x3);
}
function transformSquare(x3) {
  return x3 < 0 ? -x3 * x3 : x3 * x3;
}
function powish(transform) {
  var scale = transform(identity$4, identity$4), exponent2 = 1;
  function rescale() {
    return exponent2 === 1 ? transform(identity$4, identity$4) : exponent2 === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent2), transformPow(1 / exponent2));
  }
  scale.exponent = function(_) {
    return arguments.length ? (exponent2 = +_, rescale()) : exponent2;
  };
  return linearish(scale);
}
function pow() {
  var scale = powish(transformer$2());
  scale.copy = function() {
    return copy$1(scale, pow()).exponent(scale.exponent());
  };
  initRange.apply(scale, arguments);
  return scale;
}
function sqrt$1() {
  return pow.apply(null, arguments).exponent(0.5);
}
function square$1(x3) {
  return Math.sign(x3) * x3 * x3;
}
function unsquare(x3) {
  return Math.sign(x3) * Math.sqrt(Math.abs(x3));
}
function radial() {
  var squared = continuous(), range2 = [0, 1], round2 = false, unknown2;
  function scale(x3) {
    var y4 = unsquare(squared(x3));
    return isNaN(y4) ? unknown2 : round2 ? Math.round(y4) : y4;
  }
  scale.invert = function(y4) {
    return squared.invert(square$1(y4));
  };
  scale.domain = function(_) {
    return arguments.length ? (squared.domain(_), scale) : squared.domain();
  };
  scale.range = function(_) {
    return arguments.length ? (squared.range((range2 = Array.from(_, number$2)).map(square$1)), scale) : range2.slice();
  };
  scale.rangeRound = function(_) {
    return scale.range(_).round(true);
  };
  scale.round = function(_) {
    return arguments.length ? (round2 = !!_, scale) : round2;
  };
  scale.clamp = function(_) {
    return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  scale.copy = function() {
    return radial(squared.domain(), range2).round(round2).clamp(squared.clamp()).unknown(unknown2);
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function quantile() {
  var domain = [], range2 = [], thresholds = [], unknown2;
  function rescale() {
    var i2 = 0, n = Math.max(1, range2.length);
    thresholds = new Array(n - 1);
    while (++i2 < n)
      thresholds[i2 - 1] = quantileSorted(domain, i2 / n);
    return scale;
  }
  function scale(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown2 : range2[bisectRight(thresholds, x3)];
  }
  scale.invertExtent = function(y4) {
    var i2 = range2.indexOf(y4);
    return i2 < 0 ? [NaN, NaN] : [
      i2 > 0 ? thresholds[i2 - 1] : domain[0],
      i2 < thresholds.length ? thresholds[i2] : domain[domain.length - 1]
    ];
  };
  scale.domain = function(_) {
    if (!arguments.length)
      return domain.slice();
    domain = [];
    for (let d3 of _)
      if (d3 != null && !isNaN(d3 = +d3))
        domain.push(d3);
    domain.sort(ascending$1);
    return rescale();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), rescale()) : range2.slice();
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  scale.quantiles = function() {
    return thresholds.slice();
  };
  scale.copy = function() {
    return quantile().domain(domain).range(range2).unknown(unknown2);
  };
  return initRange.apply(scale, arguments);
}
function quantize() {
  var x0 = 0, x1 = 1, n = 1, domain = [0.5], range2 = [0, 1], unknown2;
  function scale(x3) {
    return x3 != null && x3 <= x3 ? range2[bisectRight(domain, x3, 0, n)] : unknown2;
  }
  function rescale() {
    var i2 = -1;
    domain = new Array(n);
    while (++i2 < n)
      domain[i2] = ((i2 + 1) * x1 - (i2 - n) * x0) / (n + 1);
    return scale;
  }
  scale.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [x0, x1];
  };
  scale.range = function(_) {
    return arguments.length ? (n = (range2 = Array.from(_)).length - 1, rescale()) : range2.slice();
  };
  scale.invertExtent = function(y4) {
    var i2 = range2.indexOf(y4);
    return i2 < 0 ? [NaN, NaN] : i2 < 1 ? [x0, domain[0]] : i2 >= n ? [domain[n - 1], x1] : [domain[i2 - 1], domain[i2]];
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : scale;
  };
  scale.thresholds = function() {
    return domain.slice();
  };
  scale.copy = function() {
    return quantize().domain([x0, x1]).range(range2).unknown(unknown2);
  };
  return initRange.apply(linearish(scale), arguments);
}
function threshold() {
  var domain = [0.5], range2 = [0, 1], unknown2, n = 1;
  function scale(x3) {
    return x3 != null && x3 <= x3 ? range2[bisectRight(domain, x3, 0, n)] : unknown2;
  }
  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range2.length - 1), scale) : domain.slice();
  };
  scale.range = function(_) {
    return arguments.length ? (range2 = Array.from(_), n = Math.min(domain.length, range2.length - 1), scale) : range2.slice();
  };
  scale.invertExtent = function(y4) {
    var i2 = range2.indexOf(y4);
    return [domain[i2 - 1], domain[i2]];
  };
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  scale.copy = function() {
    return threshold().domain(domain).range(range2).unknown(unknown2);
  };
  return initRange.apply(scale, arguments);
}
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(floori, offseti, count, field) {
  function interval2(date2) {
    return floori(date2 = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+date2)), date2;
  }
  interval2.floor = (date2) => {
    return floori(date2 = /* @__PURE__ */ new Date(+date2)), date2;
  };
  interval2.ceil = (date2) => {
    return floori(date2 = new Date(date2 - 1)), offseti(date2, 1), floori(date2), date2;
  };
  interval2.round = (date2) => {
    const d0 = interval2(date2), d1 = interval2.ceil(date2);
    return date2 - d0 < d1 - date2 ? d0 : d1;
  };
  interval2.offset = (date2, step2) => {
    return offseti(date2 = /* @__PURE__ */ new Date(+date2), step2 == null ? 1 : Math.floor(step2)), date2;
  };
  interval2.range = (start2, stop2, step2) => {
    const range2 = [];
    start2 = interval2.ceil(start2);
    step2 = step2 == null ? 1 : Math.floor(step2);
    if (!(start2 < stop2) || !(step2 > 0))
      return range2;
    let previous;
    do
      range2.push(previous = /* @__PURE__ */ new Date(+start2)), offseti(start2, step2), floori(start2);
    while (previous < start2 && start2 < stop2);
    return range2;
  };
  interval2.filter = (test2) => {
    return timeInterval((date2) => {
      if (date2 >= date2)
        while (floori(date2), !test2(date2))
          date2.setTime(date2 - 1);
    }, (date2, step2) => {
      if (date2 >= date2) {
        if (step2 < 0)
          while (++step2 <= 0) {
            while (offseti(date2, -1), !test2(date2)) {
            }
          }
        else
          while (--step2 >= 0) {
            while (offseti(date2, 1), !test2(date2)) {
            }
          }
      }
    });
  };
  if (count) {
    interval2.count = (start2, end2) => {
      t0.setTime(+start2), t1.setTime(+end2);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };
    interval2.every = (step2) => {
      step2 = Math.floor(step2);
      return !isFinite(step2) || !(step2 > 0) ? null : !(step2 > 1) ? interval2 : interval2.filter(field ? (d3) => field(d3) % step2 === 0 : (d3) => interval2.count(0, d3) % step2 === 0);
    };
  }
  return interval2;
}
const millisecond = timeInterval(() => {
}, (date2, step2) => {
  date2.setTime(+date2 + step2);
}, (start2, end2) => {
  return end2 - start2;
});
millisecond.every = (k3) => {
  k3 = Math.floor(k3);
  if (!isFinite(k3) || !(k3 > 0))
    return null;
  if (!(k3 > 1))
    return millisecond;
  return timeInterval((date2) => {
    date2.setTime(Math.floor(date2 / k3) * k3);
  }, (date2, step2) => {
    date2.setTime(+date2 + step2 * k3);
  }, (start2, end2) => {
    return (end2 - start2) / k3;
  });
};
millisecond.range;
const durationSecond = 1e3;
const durationMinute = durationSecond * 60;
const durationHour = durationMinute * 60;
const durationDay = durationHour * 24;
const durationWeek = durationDay * 7;
const durationMonth = durationDay * 30;
const durationYear = durationDay * 365;
const second = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds());
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationSecond);
}, (start2, end2) => {
  return (end2 - start2) / durationSecond;
}, (date2) => {
  return date2.getUTCSeconds();
});
second.range;
const timeMinute = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationMinute);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute;
}, (date2) => {
  return date2.getMinutes();
});
timeMinute.range;
const utcMinute = timeInterval((date2) => {
  date2.setUTCSeconds(0, 0);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationMinute);
}, (start2, end2) => {
  return (end2 - start2) / durationMinute;
}, (date2) => {
  return date2.getUTCMinutes();
});
utcMinute.range;
const timeHour = timeInterval((date2) => {
  date2.setTime(date2 - date2.getMilliseconds() - date2.getSeconds() * durationSecond - date2.getMinutes() * durationMinute);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationHour);
}, (start2, end2) => {
  return (end2 - start2) / durationHour;
}, (date2) => {
  return date2.getHours();
});
timeHour.range;
const utcHour = timeInterval((date2) => {
  date2.setUTCMinutes(0, 0, 0);
}, (date2, step2) => {
  date2.setTime(+date2 + step2 * durationHour);
}, (start2, end2) => {
  return (end2 - start2) / durationHour;
}, (date2) => {
  return date2.getUTCHours();
});
utcHour.range;
const timeDay = timeInterval(
  (date2) => date2.setHours(0, 0, 0, 0),
  (date2, step2) => date2.setDate(date2.getDate() + step2),
  (start2, end2) => (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationDay,
  (date2) => date2.getDate() - 1
);
timeDay.range;
const utcDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCDate(date2.getUTCDate() + step2);
}, (start2, end2) => {
  return (end2 - start2) / durationDay;
}, (date2) => {
  return date2.getUTCDate() - 1;
});
utcDay.range;
const unixDay = timeInterval((date2) => {
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCDate(date2.getUTCDate() + step2);
}, (start2, end2) => {
  return (end2 - start2) / durationDay;
}, (date2) => {
  return Math.floor(date2 / durationDay);
});
unixDay.range;
function timeWeekday(i2) {
  return timeInterval((date2) => {
    date2.setDate(date2.getDate() - (date2.getDay() + 7 - i2) % 7);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setDate(date2.getDate() + step2 * 7);
  }, (start2, end2) => {
    return (end2 - start2 - (end2.getTimezoneOffset() - start2.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}
const timeSunday = timeWeekday(0);
const timeMonday = timeWeekday(1);
const timeTuesday = timeWeekday(2);
const timeWednesday = timeWeekday(3);
const timeThursday = timeWeekday(4);
const timeFriday = timeWeekday(5);
const timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(i2) {
  return timeInterval((date2) => {
    date2.setUTCDate(date2.getUTCDate() - (date2.getUTCDay() + 7 - i2) % 7);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setUTCDate(date2.getUTCDate() + step2 * 7);
  }, (start2, end2) => {
    return (end2 - start2) / durationWeek;
  });
}
const utcSunday = utcWeekday(0);
const utcMonday = utcWeekday(1);
const utcTuesday = utcWeekday(2);
const utcWednesday = utcWeekday(3);
const utcThursday = utcWeekday(4);
const utcFriday = utcWeekday(5);
const utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((date2) => {
  date2.setDate(1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setMonth(date2.getMonth() + step2);
}, (start2, end2) => {
  return end2.getMonth() - start2.getMonth() + (end2.getFullYear() - start2.getFullYear()) * 12;
}, (date2) => {
  return date2.getMonth();
});
timeMonth.range;
const utcMonth = timeInterval((date2) => {
  date2.setUTCDate(1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCMonth(date2.getUTCMonth() + step2);
}, (start2, end2) => {
  return end2.getUTCMonth() - start2.getUTCMonth() + (end2.getUTCFullYear() - start2.getUTCFullYear()) * 12;
}, (date2) => {
  return date2.getUTCMonth();
});
utcMonth.range;
const timeYear = timeInterval((date2) => {
  date2.setMonth(0, 1);
  date2.setHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setFullYear(date2.getFullYear() + step2);
}, (start2, end2) => {
  return end2.getFullYear() - start2.getFullYear();
}, (date2) => {
  return date2.getFullYear();
});
timeYear.every = (k3) => {
  return !isFinite(k3 = Math.floor(k3)) || !(k3 > 0) ? null : timeInterval((date2) => {
    date2.setFullYear(Math.floor(date2.getFullYear() / k3) * k3);
    date2.setMonth(0, 1);
    date2.setHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setFullYear(date2.getFullYear() + step2 * k3);
  });
};
timeYear.range;
const utcYear = timeInterval((date2) => {
  date2.setUTCMonth(0, 1);
  date2.setUTCHours(0, 0, 0, 0);
}, (date2, step2) => {
  date2.setUTCFullYear(date2.getUTCFullYear() + step2);
}, (start2, end2) => {
  return end2.getUTCFullYear() - start2.getUTCFullYear();
}, (date2) => {
  return date2.getUTCFullYear();
});
utcYear.every = (k3) => {
  return !isFinite(k3 = Math.floor(k3)) || !(k3 > 0) ? null : timeInterval((date2) => {
    date2.setUTCFullYear(Math.floor(date2.getUTCFullYear() / k3) * k3);
    date2.setUTCMonth(0, 1);
    date2.setUTCHours(0, 0, 0, 0);
  }, (date2, step2) => {
    date2.setUTCFullYear(date2.getUTCFullYear() + step2 * k3);
  });
};
utcYear.range;
function ticker(year, month, week, day, hour, minute) {
  const tickIntervals = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute, 1, durationMinute],
    [minute, 5, 5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [hour, 1, durationHour],
    [hour, 3, 3 * durationHour],
    [hour, 6, 6 * durationHour],
    [hour, 12, 12 * durationHour],
    [day, 1, durationDay],
    [day, 2, 2 * durationDay],
    [week, 1, durationWeek],
    [month, 1, durationMonth],
    [month, 3, 3 * durationMonth],
    [year, 1, durationYear]
  ];
  function ticks2(start2, stop2, count) {
    const reverse2 = stop2 < start2;
    if (reverse2)
      [start2, stop2] = [stop2, start2];
    const interval2 = count && typeof count.range === "function" ? count : tickInterval(start2, stop2, count);
    const ticks3 = interval2 ? interval2.range(start2, +stop2 + 1) : [];
    return reverse2 ? ticks3.reverse() : ticks3;
  }
  function tickInterval(start2, stop2, count) {
    const target = Math.abs(stop2 - start2) / count;
    const i2 = bisector(([, , step3]) => step3).right(tickIntervals, target);
    if (i2 === tickIntervals.length)
      return year.every(tickStep(start2 / durationYear, stop2 / durationYear, count));
    if (i2 === 0)
      return millisecond.every(Math.max(tickStep(start2, stop2, count), 1));
    const [t2, step2] = tickIntervals[target / tickIntervals[i2 - 1][2] < tickIntervals[i2][2] / target ? i2 - 1 : i2];
    return t2.every(step2);
  }
  return [ticks2, tickInterval];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute);
const [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(d3) {
  if (0 <= d3.y && d3.y < 100) {
    var date2 = new Date(-1, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L);
    date2.setFullYear(d3.y);
    return date2;
  }
  return new Date(d3.y, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L);
}
function utcDate(d3) {
  if (0 <= d3.y && d3.y < 100) {
    var date2 = new Date(Date.UTC(-1, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L));
    date2.setUTCFullYear(d3.y);
    return date2;
  }
  return new Date(Date.UTC(d3.y, d3.m, d3.d, d3.H, d3.M, d3.S, d3.L));
}
function newDate(y4, m3, d3) {
  return { y: y4, m: m3, d: d3, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(locale2) {
  var locale_dateTime = locale2.dateTime, locale_date = locale2.date, locale_time = locale2.time, locale_periods = locale2.periods, locale_weekdays = locale2.days, locale_shortWeekdays = locale2.shortDays, locale_months = locale2.months, locale_shortMonths = locale2.shortMonths;
  var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };
  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };
  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);
  function newFormat(specifier, formats2) {
    return function(date2) {
      var string2 = [], i2 = -1, j = 0, n = specifier.length, c7, pad2, format2;
      if (!(date2 instanceof Date))
        date2 = /* @__PURE__ */ new Date(+date2);
      while (++i2 < n) {
        if (specifier.charCodeAt(i2) === 37) {
          string2.push(specifier.slice(j, i2));
          if ((pad2 = pads[c7 = specifier.charAt(++i2)]) != null)
            c7 = specifier.charAt(++i2);
          else
            pad2 = c7 === "e" ? " " : "0";
          if (format2 = formats2[c7])
            c7 = format2(date2, pad2);
          string2.push(c7);
          j = i2 + 1;
        }
      }
      string2.push(specifier.slice(j, i2));
      return string2.join("");
    };
  }
  function newParse(specifier, Z) {
    return function(string2) {
      var d3 = newDate(1900, void 0, 1), i2 = parseSpecifier(d3, specifier, string2 += "", 0), week, day;
      if (i2 != string2.length)
        return null;
      if ("Q" in d3)
        return new Date(d3.Q);
      if ("s" in d3)
        return new Date(d3.s * 1e3 + ("L" in d3 ? d3.L : 0));
      if (Z && !("Z" in d3))
        d3.Z = 0;
      if ("p" in d3)
        d3.H = d3.H % 12 + d3.p * 12;
      if (d3.m === void 0)
        d3.m = "q" in d3 ? d3.q : 0;
      if ("V" in d3) {
        if (d3.V < 1 || d3.V > 53)
          return null;
        if (!("w" in d3))
          d3.w = 1;
        if ("Z" in d3) {
          week = utcDate(newDate(d3.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay.offset(week, (d3.V - 1) * 7);
          d3.y = week.getUTCFullYear();
          d3.m = week.getUTCMonth();
          d3.d = week.getUTCDate() + (d3.w + 6) % 7;
        } else {
          week = localDate(newDate(d3.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? timeMonday.ceil(week) : timeMonday(week);
          week = timeDay.offset(week, (d3.V - 1) * 7);
          d3.y = week.getFullYear();
          d3.m = week.getMonth();
          d3.d = week.getDate() + (d3.w + 6) % 7;
        }
      } else if ("W" in d3 || "U" in d3) {
        if (!("w" in d3))
          d3.w = "u" in d3 ? d3.u % 7 : "W" in d3 ? 1 : 0;
        day = "Z" in d3 ? utcDate(newDate(d3.y, 0, 1)).getUTCDay() : localDate(newDate(d3.y, 0, 1)).getDay();
        d3.m = 0;
        d3.d = "W" in d3 ? (d3.w + 6) % 7 + d3.W * 7 - (day + 5) % 7 : d3.w + d3.U * 7 - (day + 6) % 7;
      }
      if ("Z" in d3) {
        d3.H += d3.Z / 100 | 0;
        d3.M += d3.Z % 100;
        return utcDate(d3);
      }
      return localDate(d3);
    };
  }
  function parseSpecifier(d3, specifier, string2, j) {
    var i2 = 0, n = specifier.length, m3 = string2.length, c7, parse2;
    while (i2 < n) {
      if (j >= m3)
        return -1;
      c7 = specifier.charCodeAt(i2++);
      if (c7 === 37) {
        c7 = specifier.charAt(i2++);
        parse2 = parses[c7 in pads ? specifier.charAt(i2++) : c7];
        if (!parse2 || (j = parse2(d3, string2, j)) < 0)
          return -1;
      } else if (c7 != string2.charCodeAt(j++)) {
        return -1;
      }
    }
    return j;
  }
  function parsePeriod(d3, string2, i2) {
    var n = periodRe.exec(string2.slice(i2));
    return n ? (d3.p = periodLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  function parseShortWeekday(d3, string2, i2) {
    var n = shortWeekdayRe.exec(string2.slice(i2));
    return n ? (d3.w = shortWeekdayLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  function parseWeekday(d3, string2, i2) {
    var n = weekdayRe.exec(string2.slice(i2));
    return n ? (d3.w = weekdayLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  function parseShortMonth(d3, string2, i2) {
    var n = shortMonthRe.exec(string2.slice(i2));
    return n ? (d3.m = shortMonthLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  function parseMonth(d3, string2, i2) {
    var n = monthRe.exec(string2.slice(i2));
    return n ? (d3.m = monthLookup.get(n[0].toLowerCase()), i2 + n[0].length) : -1;
  }
  function parseLocaleDateTime(d3, string2, i2) {
    return parseSpecifier(d3, locale_dateTime, string2, i2);
  }
  function parseLocaleDate(d3, string2, i2) {
    return parseSpecifier(d3, locale_date, string2, i2);
  }
  function parseLocaleTime(d3, string2, i2) {
    return parseSpecifier(d3, locale_time, string2, i2);
  }
  function formatShortWeekday(d3) {
    return locale_shortWeekdays[d3.getDay()];
  }
  function formatWeekday(d3) {
    return locale_weekdays[d3.getDay()];
  }
  function formatShortMonth(d3) {
    return locale_shortMonths[d3.getMonth()];
  }
  function formatMonth(d3) {
    return locale_months[d3.getMonth()];
  }
  function formatPeriod(d3) {
    return locale_periods[+(d3.getHours() >= 12)];
  }
  function formatQuarter(d3) {
    return 1 + ~~(d3.getMonth() / 3);
  }
  function formatUTCShortWeekday(d3) {
    return locale_shortWeekdays[d3.getUTCDay()];
  }
  function formatUTCWeekday(d3) {
    return locale_weekdays[d3.getUTCDay()];
  }
  function formatUTCShortMonth(d3) {
    return locale_shortMonths[d3.getUTCMonth()];
  }
  function formatUTCMonth(d3) {
    return locale_months[d3.getUTCMonth()];
  }
  function formatUTCPeriod(d3) {
    return locale_periods[+(d3.getUTCHours() >= 12)];
  }
  function formatUTCQuarter(d3) {
    return 1 + ~~(d3.getUTCMonth() / 3);
  }
  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() {
        return specifier;
      };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() {
        return specifier;
      };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() {
        return specifier;
      };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() {
        return specifier;
      };
      return p;
    }
  };
}
var pads = { "-": "", "_": " ", "0": "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
  var sign2 = value < 0 ? "-" : "", string2 = (sign2 ? -value : value) + "", length2 = string2.length;
  return sign2 + (length2 < width ? new Array(width - length2 + 1).join(fill) + string2 : string2);
}
function requote(s4) {
  return s4.replace(requoteRe, "\\$&");
}
function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
  return new Map(names.map((name2, i2) => [name2.toLowerCase(), i2]));
}
function parseWeekdayNumberSunday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 1));
  return n ? (d3.w = +n[0], i2 + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 1));
  return n ? (d3.u = +n[0], i2 + n[0].length) : -1;
}
function parseWeekNumberSunday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.U = +n[0], i2 + n[0].length) : -1;
}
function parseWeekNumberISO(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.V = +n[0], i2 + n[0].length) : -1;
}
function parseWeekNumberMonday(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.W = +n[0], i2 + n[0].length) : -1;
}
function parseFullYear(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 4));
  return n ? (d3.y = +n[0], i2 + n[0].length) : -1;
}
function parseYear(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), i2 + n[0].length) : -1;
}
function parseZone(d3, string2, i2) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string2.slice(i2, i2 + 6));
  return n ? (d3.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i2 + n[0].length) : -1;
}
function parseQuarter(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 1));
  return n ? (d3.q = n[0] * 3 - 3, i2 + n[0].length) : -1;
}
function parseMonthNumber(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.m = n[0] - 1, i2 + n[0].length) : -1;
}
function parseDayOfMonth(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.d = +n[0], i2 + n[0].length) : -1;
}
function parseDayOfYear(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 3));
  return n ? (d3.m = 0, d3.d = +n[0], i2 + n[0].length) : -1;
}
function parseHour24(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.H = +n[0], i2 + n[0].length) : -1;
}
function parseMinutes(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.M = +n[0], i2 + n[0].length) : -1;
}
function parseSeconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 2));
  return n ? (d3.S = +n[0], i2 + n[0].length) : -1;
}
function parseMilliseconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 3));
  return n ? (d3.L = +n[0], i2 + n[0].length) : -1;
}
function parseMicroseconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2, i2 + 6));
  return n ? (d3.L = Math.floor(n[0] / 1e3), i2 + n[0].length) : -1;
}
function parseLiteralPercent(d3, string2, i2) {
  var n = percentRe.exec(string2.slice(i2, i2 + 1));
  return n ? i2 + n[0].length : -1;
}
function parseUnixTimestamp(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2));
  return n ? (d3.Q = +n[0], i2 + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d3, string2, i2) {
  var n = numberRe.exec(string2.slice(i2));
  return n ? (d3.s = +n[0], i2 + n[0].length) : -1;
}
function formatDayOfMonth(d3, p) {
  return pad(d3.getDate(), p, 2);
}
function formatHour24(d3, p) {
  return pad(d3.getHours(), p, 2);
}
function formatHour12(d3, p) {
  return pad(d3.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d3, p) {
  return pad(1 + timeDay.count(timeYear(d3), d3), p, 3);
}
function formatMilliseconds(d3, p) {
  return pad(d3.getMilliseconds(), p, 3);
}
function formatMicroseconds(d3, p) {
  return formatMilliseconds(d3, p) + "000";
}
function formatMonthNumber(d3, p) {
  return pad(d3.getMonth() + 1, p, 2);
}
function formatMinutes(d3, p) {
  return pad(d3.getMinutes(), p, 2);
}
function formatSeconds(d3, p) {
  return pad(d3.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d3) {
  var day = d3.getDay();
  return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d3, p) {
  return pad(timeSunday.count(timeYear(d3) - 1, d3), p, 2);
}
function dISO(d3) {
  var day = d3.getDay();
  return day >= 4 || day === 0 ? timeThursday(d3) : timeThursday.ceil(d3);
}
function formatWeekNumberISO(d3, p) {
  d3 = dISO(d3);
  return pad(timeThursday.count(timeYear(d3), d3) + (timeYear(d3).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d3) {
  return d3.getDay();
}
function formatWeekNumberMonday(d3, p) {
  return pad(timeMonday.count(timeYear(d3) - 1, d3), p, 2);
}
function formatYear(d3, p) {
  return pad(d3.getFullYear() % 100, p, 2);
}
function formatYearISO(d3, p) {
  d3 = dISO(d3);
  return pad(d3.getFullYear() % 100, p, 2);
}
function formatFullYear(d3, p) {
  return pad(d3.getFullYear() % 1e4, p, 4);
}
function formatFullYearISO(d3, p) {
  var day = d3.getDay();
  d3 = day >= 4 || day === 0 ? timeThursday(d3) : timeThursday.ceil(d3);
  return pad(d3.getFullYear() % 1e4, p, 4);
}
function formatZone(d3) {
  var z2 = d3.getTimezoneOffset();
  return (z2 > 0 ? "-" : (z2 *= -1, "+")) + pad(z2 / 60 | 0, "0", 2) + pad(z2 % 60, "0", 2);
}
function formatUTCDayOfMonth(d3, p) {
  return pad(d3.getUTCDate(), p, 2);
}
function formatUTCHour24(d3, p) {
  return pad(d3.getUTCHours(), p, 2);
}
function formatUTCHour12(d3, p) {
  return pad(d3.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d3, p) {
  return pad(1 + utcDay.count(utcYear(d3), d3), p, 3);
}
function formatUTCMilliseconds(d3, p) {
  return pad(d3.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d3, p) {
  return formatUTCMilliseconds(d3, p) + "000";
}
function formatUTCMonthNumber(d3, p) {
  return pad(d3.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d3, p) {
  return pad(d3.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d3, p) {
  return pad(d3.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d3) {
  var dow = d3.getUTCDay();
  return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d3, p) {
  return pad(utcSunday.count(utcYear(d3) - 1, d3), p, 2);
}
function UTCdISO(d3) {
  var day = d3.getUTCDay();
  return day >= 4 || day === 0 ? utcThursday(d3) : utcThursday.ceil(d3);
}
function formatUTCWeekNumberISO(d3, p) {
  d3 = UTCdISO(d3);
  return pad(utcThursday.count(utcYear(d3), d3) + (utcYear(d3).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d3) {
  return d3.getUTCDay();
}
function formatUTCWeekNumberMonday(d3, p) {
  return pad(utcMonday.count(utcYear(d3) - 1, d3), p, 2);
}
function formatUTCYear(d3, p) {
  return pad(d3.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d3, p) {
  d3 = UTCdISO(d3);
  return pad(d3.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d3, p) {
  return pad(d3.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCFullYearISO(d3, p) {
  var day = d3.getUTCDay();
  d3 = day >= 4 || day === 0 ? utcThursday(d3) : utcThursday.ceil(d3);
  return pad(d3.getUTCFullYear() % 1e4, p, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(d3) {
  return +d3;
}
function formatUnixTimestampSeconds(d3) {
  return Math.floor(+d3 / 1e3);
}
var locale;
var timeFormat;
var utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  timeFormat = locale.format;
  locale.parse;
  utcFormat = locale.utcFormat;
  locale.utcParse;
  return locale;
}
function date$1(t2) {
  return new Date(t2);
}
function number$1(t2) {
  return t2 instanceof Date ? +t2 : +/* @__PURE__ */ new Date(+t2);
}
function calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2) {
  var scale = continuous(), invert2 = scale.invert, domain = scale.domain;
  var formatMillisecond = format2(".%L"), formatSecond = format2(":%S"), formatMinute = format2("%I:%M"), formatHour = format2("%I %p"), formatDay = format2("%a %d"), formatWeek = format2("%b %d"), formatMonth = format2("%B"), formatYear2 = format2("%Y");
  function tickFormat2(date2) {
    return (second2(date2) < date2 ? formatMillisecond : minute(date2) < date2 ? formatSecond : hour(date2) < date2 ? formatMinute : day(date2) < date2 ? formatHour : month(date2) < date2 ? week(date2) < date2 ? formatDay : formatWeek : year(date2) < date2 ? formatMonth : formatYear2)(date2);
  }
  scale.invert = function(y4) {
    return new Date(invert2(y4));
  };
  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number$1)) : domain().map(date$1);
  };
  scale.ticks = function(interval2) {
    var d3 = domain();
    return ticks2(d3[0], d3[d3.length - 1], interval2 == null ? 10 : interval2);
  };
  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat2 : format2(specifier);
  };
  scale.nice = function(interval2) {
    var d3 = domain();
    if (!interval2 || typeof interval2.range !== "function")
      interval2 = tickInterval(d3[0], d3[d3.length - 1], interval2 == null ? 10 : interval2);
    return interval2 ? domain(nice(d3, interval2)) : scale;
  };
  scale.copy = function() {
    return copy$1(scale, calendar(ticks2, tickInterval, year, month, week, day, hour, minute, second2, format2));
  };
  return scale;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$1() {
  var x0 = 0, x1 = 1, t02, t12, k10, transform, interpolator = identity$4, clamp2 = false, unknown2;
  function scale(x3) {
    return x3 == null || isNaN(x3 = +x3) ? unknown2 : interpolator(k10 === 0 ? 0.5 : (x3 = (transform(x3) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale.domain = function(_) {
    return arguments.length ? ([x0, x1] = _, t02 = transform(x0 = +x0), t12 = transform(x1 = +x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x0, x1];
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale) : clamp2;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  return function(t2) {
    transform = t2, t02 = t2(x0), t12 = t2(x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer$1()(identity$4));
  scale.copy = function() {
    return copy(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
  var scale = loggish(transformer$1()).domain([1, 10]);
  scale.copy = function() {
    return copy(scale, sequentialLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
  var scale = symlogish(transformer$1());
  scale.copy = function() {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
  var scale = powish(transformer$1());
  scale.copy = function() {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var domain = [], interpolator = identity$4;
  function scale(x3) {
    if (x3 != null && !isNaN(x3 = +x3))
      return interpolator((bisectRight(domain, x3, 1) - 1) / (domain.length - 1));
  }
  scale.domain = function(_) {
    if (!arguments.length)
      return domain.slice();
    domain = [];
    for (let d3 of _)
      if (d3 != null && !isNaN(d3 = +d3))
        domain.push(d3);
    domain.sort(ascending$1);
    return scale;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  scale.range = function() {
    return domain.map((d3, i2) => interpolator(i2 / (domain.length - 1)));
  };
  scale.quantiles = function(n) {
    return Array.from({ length: n + 1 }, (_, i2) => quantile$1(domain, i2 / n));
  };
  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };
  return initInterpolator.apply(scale, arguments);
}
function transformer() {
  var x0 = 0, x1 = 0.5, x22 = 1, s4 = 1, t02, t12, t2, k10, k21, interpolator = identity$4, transform, clamp2 = false, unknown2;
  function scale(x3) {
    return isNaN(x3 = +x3) ? unknown2 : (x3 = 0.5 + ((x3 = +transform(x3)) - t12) * (s4 * x3 < s4 * t12 ? k10 : k21), interpolator(clamp2 ? Math.max(0, Math.min(1, x3)) : x3));
  }
  scale.domain = function(_) {
    return arguments.length ? ([x0, x1, x22] = _, t02 = transform(x0 = +x0), t12 = transform(x1 = +x1), t2 = transform(x22 = +x22), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t2 ? 0 : 0.5 / (t2 - t12), s4 = t12 < t02 ? -1 : 1, scale) : [x0, x1, x22];
  };
  scale.clamp = function(_) {
    return arguments.length ? (clamp2 = !!_, scale) : clamp2;
  };
  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_) {
      var r0, r1, r2;
      return arguments.length ? ([r0, r1, r2] = _, interpolator = piecewise(interpolate2, [r0, r1, r2]), scale) : [interpolator(0), interpolator(0.5), interpolator(1)];
    };
  }
  scale.range = range2(interpolate);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_) {
    return arguments.length ? (unknown2 = _, scale) : unknown2;
  };
  return function(t3) {
    transform = t3, t02 = t3(x0), t12 = t3(x1), t2 = t3(x22), k10 = t02 === t12 ? 0 : 0.5 / (t12 - t02), k21 = t12 === t2 ? 0 : 0.5 / (t2 - t12), s4 = t12 < t02 ? -1 : 1;
    return scale;
  };
}
function diverging$1() {
  var scale = linearish(transformer()(identity$4));
  scale.copy = function() {
    return copy(scale, diverging$1());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingLog() {
  var scale = loggish(transformer()).domain([0.1, 1, 10]);
  scale.copy = function() {
    return copy(scale, divergingLog()).base(scale.base());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
  var scale = symlogish(transformer());
  scale.copy = function() {
    return copy(scale, divergingSymlog()).constant(scale.constant());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingPow() {
  var scale = powish(transformer());
  scale.copy = function() {
    return copy(scale, divergingPow()).exponent(scale.exponent());
  };
  return initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
const d3Scale = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging$1,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity$2,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log,
  scaleOrdinal: ordinal,
  scalePoint: point$5,
  scalePow: pow,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt$1,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
const supportedScaleStrings = ["linear", "time", "log", "sqrt"];
function toNewName$1(scale) {
  const capitalize2 = (s4) => s4 && s4[0].toUpperCase() + s4.slice(1);
  return `scale${capitalize2(scale)}`;
}
function validScale(scale) {
  if (typeof scale === "function") {
    return isFunction$1(scale.copy) && isFunction$1(scale.domain) && isFunction$1(scale.range);
  } else if (typeof scale === "string") {
    return supportedScaleStrings.includes(scale);
  }
  return false;
}
function isScaleDefined(props2, axis) {
  if (!props2.scale) {
    return false;
  } else if (props2.scale.x || props2.scale.y) {
    return !!props2.scale[axis];
  }
  return true;
}
function getScaleTypeFromProps(props2, axis) {
  if (!isScaleDefined(props2, axis)) {
    return void 0;
  }
  const scale = props2.scale[axis] || props2.scale;
  return typeof scale === "string" ? scale : getType(scale);
}
function getScaleFromDomain(props2, axis) {
  let domain;
  if (props2.domain && props2.domain[axis]) {
    domain = props2.domain[axis];
  } else if (props2.domain && Array.isArray(props2.domain)) {
    domain = props2.domain;
  }
  if (!domain) {
    return void 0;
  }
  return containsDates(domain) ? "time" : "linear";
}
function getScaleTypeFromData(props2, axis) {
  if (!props2.data) {
    return "linear";
  }
  const accessor = createAccessor(props2[axis]);
  const axisData = props2.data.map((datum) => {
    const processedData = _isPlainObject(accessor(datum)) ? accessor(datum)[axis] : accessor(datum);
    return processedData !== void 0 ? processedData : datum[axis];
  });
  return containsDates(axisData) ? "time" : "linear";
}
function getScaleFromName(name2) {
  if (validScale(name2)) {
    const methodName = toNewName$1(name2);
    return d3Scale[methodName]();
  }
  return linear();
}
function getBaseScale(props2, axis) {
  const scale = getScaleFromProps(props2, axis);
  if (scale) {
    return typeof scale === "string" ? getScaleFromName(scale) : scale;
  }
  const defaultScale = getScaleFromDomain(props2, axis) || getScaleTypeFromData(props2, axis);
  return getScaleFromName(defaultScale);
}
function getScaleFromProps(props2, axis) {
  if (!isScaleDefined(props2, axis)) {
    return void 0;
  }
  const scale = props2.scale[axis] || props2.scale;
  if (validScale(scale)) {
    return isFunction$1(scale) ? scale : getScaleFromName(scale);
  }
  return void 0;
}
function getScaleType(props2, axis) {
  return getScaleTypeFromProps(props2, axis) || getScaleTypeFromData(props2, axis);
}
const DUCK_TYPES = [
  {
    name: "quantile",
    method: "quantiles"
  },
  {
    name: "log",
    method: "base"
  }
  // TODO(2214): Re-evaluate (1) duck typing approach, and (2) if duck typing,
  //   do we need a different approach? (Multiple keys? Stringifying functions?)
  // https://github.com/FormidableLabs/victory/issues/2214
  // Below are matches that don't seem to otherwise occur in Victory code base.
  // { name: "ordinal", method: "unknown" },
  // { name: "pow-sqrt", method: "exponent" },
  // { name: "quantize-threshold", method: "invertExtent" }
];
function getType(scale) {
  if (typeof scale === "string") {
    return scale;
  }
  const scaleType = DUCK_TYPES.filter((type2) => {
    return scale[type2.method] !== void 0;
  })[0];
  return scaleType ? scaleType.name : void 0;
}
const IMMUTABLE_ITERABLE = "@@__IMMUTABLE_ITERABLE__@@";
const IMMUTABLE_RECORD = "@@__IMMUTABLE_RECORD__@@";
const IMMUTABLE_LIST = "@@__IMMUTABLE_LIST__@@";
function isIterable(x3) {
  return !!(x3 && x3[IMMUTABLE_ITERABLE]);
}
function isRecord(x3) {
  return !!(x3 && x3[IMMUTABLE_RECORD]);
}
function isImmutable(x3) {
  return isIterable(x3) || isRecord(x3);
}
function isList(x3) {
  return !!(x3 && x3[IMMUTABLE_LIST]);
}
function shallowToJS(x3, whitelist) {
  return isIterable(x3) ? x3.reduce((result, curr, key) => {
    let newCurr = curr;
    if (whitelist && whitelist[key]) {
      newCurr = shallowToJS(curr);
    }
    result[key] = newCurr;
    return result;
  }, isList(x3) ? [] : {}) : x3;
}
function parseDatum(datum) {
  const immutableDatumWhitelist = {
    errorX: true,
    errorY: true
  };
  return isImmutable(datum) ? shallowToJS(datum, immutableDatumWhitelist) : datum;
}
function getLength(data) {
  return isIterable(data) ? data.size : data.length;
}
function generateDataArray(props2, axis) {
  const propsDomain = _isPlainObject(props2.domain) ? props2.domain[axis] : props2.domain;
  const domain = propsDomain || getBaseScale(props2, axis).domain();
  const samples = props2.samples || 1;
  const domainMax = Math.max(...domain);
  const domainMin = Math.min(...domain);
  const step2 = (domainMax - domainMin) / samples;
  const values6 = range$1(domainMin, domainMax, step2);
  return values6[values6.length - 1] === domainMax ? values6 : values6.concat(domainMax);
}
function sortData(dataset, sortKey, sortOrder) {
  if (sortOrder === void 0) {
    sortOrder = "ascending";
  }
  if (!sortKey) {
    return dataset;
  }
  let formattedSortKey = sortKey;
  if (sortKey === "x" || sortKey === "y") {
    formattedSortKey = `_${sortKey}`;
  }
  const order2 = sortOrder === "ascending" ? "asc" : "desc";
  return _orderBy(dataset, formattedSortKey, order2);
}
function cleanData(dataset, props2) {
  const smallNumber = 1 / Number.MAX_SAFE_INTEGER;
  const scaleType = {
    x: getScaleType(props2, "x"),
    y: getScaleType(props2, "y")
  };
  if (scaleType.x !== "log" && scaleType.y !== "log") {
    return dataset;
  }
  const rules = (datum, axis) => {
    return scaleType[axis] === "log" ? datum[`_${axis}`] !== 0 : true;
  };
  const sanitize = (datum) => {
    const _x = rules(datum, "x") ? datum._x : smallNumber;
    const _y = rules(datum, "y") ? datum._y : smallNumber;
    const _y0 = rules(datum, "y0") ? datum._y0 : smallNumber;
    return Object.assign({}, datum, {
      _x,
      _y,
      _y0
    });
  };
  return dataset.map((datum) => {
    if (rules(datum, "x") && rules(datum, "y") && rules(datum, "y0")) {
      return datum;
    }
    return sanitize(datum);
  });
}
function getEventKey(key) {
  if (isFunction$1(key)) {
    return key;
  } else if (key === null || key === void 0) {
    return () => void 0;
  }
  return _property(key);
}
function addEventKeys(props2, data) {
  const hasEventKeyAccessor = !!props2.eventKey;
  const eventKeyAccessor = getEventKey(props2.eventKey);
  return data.map((datum, index2) => {
    if (datum.eventKey !== void 0) {
      return datum;
    } else if (hasEventKeyAccessor) {
      const eventKey = eventKeyAccessor(datum, index2);
      return eventKey !== void 0 ? Object.assign({
        eventKey
      }, datum) : datum;
    }
    return datum;
  });
}
function formatDataFromDomain(dataset, domain, defaultBaseline) {
  const exists2 = (val) => val !== void 0;
  const minDomainX = getMinValue(domain.x);
  const maxDomainX = getMaxValue(domain.x);
  const minDomainY = getMinValue(domain.y);
  const maxDomainY = getMaxValue(domain.y);
  const underMin = (min2) => (val) => exists2(val) && val < min2;
  const overMax = (max2) => (val) => exists2(val) && val > max2;
  const isUnderMinX = underMin(minDomainX);
  const isUnderMinY = underMin(minDomainY);
  const isOverMaxX = overMax(maxDomainX);
  const isOverMaxY = overMax(maxDomainY);
  return dataset.map((datum) => {
    let {
      _x,
      _y,
      _y0,
      _y1
    } = datum;
    if (isUnderMinX(_x) || isOverMaxX(_x))
      _x = null;
    const baseline = exists2(_y0) ? _y0 : defaultBaseline;
    const value = exists2(_y1) ? _y1 : _y;
    if (!exists2(value))
      return datum;
    if (!exists2(baseline) && (isUnderMinY(value) || isOverMaxY(value)))
      _y = null;
    if (isUnderMinY(baseline) && isUnderMinY(value) || isOverMaxY(baseline) && isOverMaxY(value))
      _y = _y0 = _y1 = null;
    if (isUnderMinY(baseline) && !isUnderMinY(value))
      _y0 = minDomainY;
    if (isOverMaxY(baseline) && !isOverMaxY(value))
      _y0 = maxDomainY;
    return Object.assign({}, datum, _omitBy({
      _x,
      _y,
      _y0,
      _y1
    }, _isUndefined));
  });
}
function createStringMap$1(props2, axis) {
  const stringsFromAxes = getStringsFromAxes(props2, axis);
  const stringsFromCategories = getStringsFromCategories$1(props2, axis);
  const stringsFromData = getStringsFromData$1(props2, axis);
  const allStrings = _uniq([...stringsFromAxes, ...stringsFromCategories, ...stringsFromData]);
  return allStrings.length === 0 ? null : allStrings.reduce((memo, string2, index2) => {
    memo[string2] = index2 + 1;
    return memo;
  }, {});
}
function formatData(dataset, props2, expectedKeys) {
  const isArrayOrIterable = Array.isArray(dataset) || isIterable(dataset);
  if (!isArrayOrIterable || getLength(dataset) < 1) {
    return [];
  }
  const defaultKeys = ["x", "y", "y0"];
  expectedKeys = Array.isArray(expectedKeys) ? expectedKeys : defaultKeys;
  const createAccessor$1 = (name2) => {
    return createAccessor(props2[name2] !== void 0 ? props2[name2] : name2);
  };
  const accessor = expectedKeys.reduce((memo, type2) => {
    memo[type2] = createAccessor$1(type2);
    return memo;
  }, {});
  const preformattedData = _isEqual(expectedKeys, defaultKeys) && props2.x === "_x" && props2.y === "_y" && props2.y0 === "_y0";
  let stringMap;
  if (preformattedData === false) {
    stringMap = {
      x: expectedKeys.indexOf("x") !== -1 ? createStringMap$1(props2, "x") : void 0,
      y: expectedKeys.indexOf("y") !== -1 ? createStringMap$1(props2, "y") : void 0,
      y0: expectedKeys.indexOf("y0") !== -1 ? createStringMap$1(props2, "y") : void 0
    };
  }
  const data = preformattedData ? dataset : dataset.reduce((dataArr, datum, index2) => {
    const parsedDatum = parseDatum(datum);
    const fallbackValues = {
      x: index2,
      y: parsedDatum
    };
    const processedValues = expectedKeys.reduce((memo, type2) => {
      const processedValue = accessor[type2](parsedDatum);
      const value = processedValue !== void 0 ? processedValue : fallbackValues[type2];
      if (value !== void 0) {
        if (typeof value === "string" && stringMap[type2]) {
          memo[`${type2}Name`] = value;
          memo[`_${type2}`] = stringMap[type2][value];
        } else {
          memo[`_${type2}`] = value;
        }
      }
      return memo;
    }, {});
    const formattedDatum = Object.assign({}, processedValues, parsedDatum);
    if (!_isEmpty(formattedDatum)) {
      dataArr.push(formattedDatum);
    }
    return dataArr;
  }, []);
  const sortedData = sortData(data, props2.sortKey, props2.sortOrder);
  const cleanedData = cleanData(sortedData, props2);
  return addEventKeys(props2, cleanedData);
}
function generateData(props2) {
  const xValues = generateDataArray(props2, "x");
  const yValues = generateDataArray(props2, "y");
  const values6 = xValues.map((x3, i2) => {
    return {
      x: x3,
      y: yValues[i2]
    };
  });
  return values6;
}
function getCategories$1(props2, axis) {
  return props2.categories && !Array.isArray(props2.categories) ? props2.categories[axis] : props2.categories;
}
function getData(props2) {
  return props2.data ? formatData(props2.data, props2) : formatData(generateData(props2), props2);
}
function getStringsFromAxes(props2, axis) {
  const {
    tickValues,
    tickFormat: tickFormat2
  } = props2;
  let tickValueArray;
  if (!tickValues || !Array.isArray(tickValues) && !tickValues[axis]) {
    tickValueArray = tickFormat2 && Array.isArray(tickFormat2) ? tickFormat2 : [];
  } else {
    tickValueArray = tickValues[axis] || tickValues;
  }
  return tickValueArray.filter((val) => typeof val === "string");
}
function getStringsFromCategories$1(props2, axis) {
  if (!props2.categories) {
    return [];
  }
  const categories = getCategories$1(props2, axis);
  const categoryStrings = categories && categories.filter((val) => typeof val === "string");
  return categoryStrings ? removeUndefined(categoryStrings) : [];
}
function getStringsFromData$1(props2, axis) {
  const isArrayOrIterable = Array.isArray(props2.data) || isIterable(props2.data);
  if (!isArrayOrIterable) {
    return [];
  }
  const key = props2[axis] === void 0 ? axis : props2[axis];
  const accessor = createAccessor(key);
  const data = props2.data.reduce((memo, d3) => {
    memo.push(parseDatum(d3));
    return memo;
  }, []);
  const sortedData = sortData(data, props2.sortKey, props2.sortOrder);
  const dataStrings = sortedData.reduce((dataArr, datum) => {
    const parsedDatum = parseDatum(datum);
    dataArr.push(accessor(parsedDatum));
    return dataArr;
  }, []).filter((datum) => typeof datum === "string");
  return dataStrings.reduce((prev2, curr) => {
    if (curr !== void 0 && curr !== null && prev2.indexOf(curr) === -1) {
      prev2.push(curr);
    }
    return prev2;
  }, []);
}
function isDataComponent(component) {
  const getRole2 = (child) => {
    return child && child.type ? child.type.role : "";
  };
  let role = getRole2(component);
  if (role === "portal") {
    const children2 = React__default.Children.toArray(component.props.children);
    role = children2.length ? getRole2(children2[0]) : "";
  }
  const whitelist = ["area", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"];
  return whitelist.includes(role);
}
function cleanDomain(domain, props2, axis) {
  const scaleType = getScaleType(props2, axis);
  if (scaleType !== "log") {
    return domain;
  }
  const rules = (dom2) => {
    const almostZero = dom2[0] < 0 || dom2[1] < 0 ? -1 / Number.MAX_SAFE_INTEGER : 1 / Number.MAX_SAFE_INTEGER;
    const domainOne = dom2[0] === 0 ? almostZero : dom2[0];
    const domainTwo = dom2[1] === 0 ? almostZero : dom2[1];
    return [domainOne, domainTwo];
  };
  return rules(domain);
}
function getDomainPadding(props2, axis) {
  const formatPadding = (padding2) => {
    return Array.isArray(padding2) ? {
      left: padding2[0],
      right: padding2[1]
    } : {
      left: padding2,
      right: padding2
    };
  };
  return _isPlainObject(props2.domainPadding) ? formatPadding(props2.domainPadding[axis]) : formatPadding(props2.domainPadding);
}
function getFlatData(dataset, axis) {
  const axisKey = `_${axis}`;
  return dataset.flat().map((datum) => {
    return datum[axisKey] && datum[axisKey][1] !== void 0 ? datum[axisKey][1] : datum[axisKey];
  });
}
function getExtremeFromData(dataset, axis, type2) {
  if (type2 === void 0) {
    type2 = "min";
  }
  const getExtreme = (arr) => type2 === "max" ? Math.max(...arr) : Math.min(...arr);
  const initialValue2 = type2 === "max" ? -Infinity : Infinity;
  let containsDate = false;
  const result = dataset.flat().reduce((memo, datum) => {
    const current0 = datum[`_${axis}0`] !== void 0 ? datum[`_${axis}0`] : datum[`_${axis}`];
    const current1 = datum[`_${axis}1`] !== void 0 ? datum[`_${axis}1`] : datum[`_${axis}`];
    const current = getExtreme([current0, current1]);
    containsDate = containsDate || current0 instanceof Date || current1 instanceof Date;
    return getExtreme([memo, current]);
  }, initialValue2);
  return containsDate ? new Date(result) : result;
}
function padDomain(domain, props2, axis) {
  if (!props2.domainPadding) {
    return domain;
  }
  const minDomain = getMinFromProps(props2, axis);
  const maxDomain = getMaxFromProps(props2, axis);
  const padding2 = getDomainPadding(props2, axis);
  if (!padding2.left && !padding2.right) {
    return domain;
  }
  const min2 = getMinValue(domain);
  const max2 = getMaxValue(domain);
  const currentAxis = getCurrentAxis$1(axis, props2.horizontal);
  const range2 = getRange$1(props2, currentAxis);
  const rangeExtent = Math.abs(range2[0] - range2[1]);
  const paddedRangeExtent = Math.max(rangeExtent - padding2.left - padding2.right, 1);
  const paddedDomainExtent = Math.abs(max2.valueOf() - min2.valueOf()) / paddedRangeExtent * rangeExtent;
  const simplePadding = {
    left: paddedDomainExtent * padding2.left / rangeExtent,
    right: paddedDomainExtent * padding2.right / rangeExtent
  };
  let paddedDomain = {
    min: min2.valueOf() - simplePadding.left,
    max: max2.valueOf() + simplePadding.right
  };
  const singleQuadrantDomainPadding = _isPlainObject(props2.singleQuadrantDomainPadding) ? props2.singleQuadrantDomainPadding[axis] : props2.singleQuadrantDomainPadding;
  const addsQuadrants = min2 >= 0 && paddedDomain.min <= 0 || max2 <= 0 && paddedDomain.max >= 0;
  const adjust = (val, type2) => {
    const coerce = type2 === "min" && min2 >= 0 && val <= 0 || type2 === "max" && max2 <= 0 && val >= 0;
    return coerce ? 0 : val;
  };
  if (addsQuadrants && singleQuadrantDomainPadding !== false) {
    const initialPadding = {
      // @ts-expect-error `max/min` might be dates
      left: Math.abs(max2 - min2) * padding2.left / rangeExtent,
      // @ts-expect-error `max/min` might be dates
      right: Math.abs(max2 - min2) * padding2.right / rangeExtent
    };
    const adjustedDomain = {
      min: adjust(min2.valueOf() - initialPadding.left, "min"),
      max: adjust(max2.valueOf() + initialPadding.right, "max")
    };
    const finalPadding = {
      left: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding2.left / rangeExtent,
      right: Math.abs(adjustedDomain.max - adjustedDomain.min) * padding2.right / rangeExtent
    };
    paddedDomain = {
      min: adjust(min2.valueOf() - finalPadding.left, "min"),
      max: adjust(max2.valueOf() + finalPadding.right, "max")
    };
  }
  const finalDomain = {
    min: minDomain !== void 0 ? minDomain : paddedDomain.min,
    max: maxDomain !== void 0 ? maxDomain : paddedDomain.max
  };
  return min2 instanceof Date || max2 instanceof Date ? getDomainFromMinMax(new Date(finalDomain.min), new Date(finalDomain.max)) : getDomainFromMinMax(finalDomain.min, finalDomain.max);
}
function createDomainFunction(getDomainFromDataFunction, formatDomainFunction) {
  const getDomainFromDataFn = isFunction$1(getDomainFromDataFunction) ? getDomainFromDataFunction : getDomainFromData$1;
  const formatDomainFn = isFunction$1(formatDomainFunction) ? formatDomainFunction : formatDomain;
  return (props2, axis) => {
    const propsDomain = getDomainFromProps(props2, axis);
    if (propsDomain) {
      return formatDomainFn(propsDomain, props2, axis);
    }
    const categories = getCategories$1(props2, axis);
    const domain = categories ? getDomainFromCategories(props2, axis, categories) : getDomainFromDataFn(props2, axis);
    return domain ? formatDomainFn(domain, props2, axis) : void 0;
  };
}
function formatDomain(domain, props2, axis) {
  return cleanDomain(padDomain(domain, props2, axis), props2, axis);
}
function getDomain$3(props2, axis) {
  return createDomainFunction()(props2, axis);
}
function getDomainFromCategories(props2, axis, categories) {
  const categoriesArray = categories || getCategories$1(props2, axis);
  const {
    polar,
    startAngle = 0,
    endAngle = 360
  } = props2;
  if (!categoriesArray) {
    return void 0;
  }
  const minDomain = getMinFromProps(props2, axis);
  const maxDomain = getMaxFromProps(props2, axis);
  const stringArray = containsStrings(categoriesArray) ? getStringsFromCategories$1(props2, axis) : [];
  const stringMap = stringArray.length === 0 ? null : stringArray.reduce((memo, string2, index2) => {
    memo[string2] = index2 + 1;
    return memo;
  }, {});
  const categoryValues = stringMap ? categoriesArray.map((value) => stringMap[value]) : categoriesArray;
  const min2 = minDomain !== void 0 ? minDomain : getMinValue(categoryValues);
  const max2 = maxDomain !== void 0 ? maxDomain : getMaxValue(categoryValues);
  const categoryDomain = getDomainFromMinMax(min2, max2);
  return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(categoryDomain, categoryValues) : categoryDomain;
}
function getDomainFromData$1(props2, axis, dataset) {
  const datasetArray = dataset || getData(props2);
  const {
    polar,
    startAngle = 0,
    endAngle = 360
  } = props2;
  const minDomain = getMinFromProps(props2, axis);
  const maxDomain = getMaxFromProps(props2, axis);
  if (datasetArray.length < 1) {
    return minDomain !== void 0 && maxDomain !== void 0 ? getDomainFromMinMax(minDomain, maxDomain) : void 0;
  }
  const min2 = minDomain !== void 0 ? minDomain : getExtremeFromData(datasetArray, axis, "min");
  const max2 = maxDomain !== void 0 ? maxDomain : getExtremeFromData(datasetArray, axis, "max");
  const domain = getDomainFromMinMax(min2, max2);
  return polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(domain, getFlatData(datasetArray, axis)) : domain;
}
function getDomainFromMinMax(min2, max2) {
  const getSinglePointDomain = (val) => {
    const verySmallNumber = (
      // eslint-disable-next-line no-magic-numbers
      val === 0 ? 2 * Math.pow(10, -10) : Math.pow(10, -10)
    );
    const verySmallDate = 1;
    const minVal = val instanceof Date ? new Date(Number(val) - verySmallDate) : Number(val) - verySmallNumber;
    const maxVal = val instanceof Date ? new Date(Number(val) + verySmallDate) : Number(val) + verySmallNumber;
    return val === 0 ? [0, maxVal] : [minVal, maxVal];
  };
  return Number(min2) === Number(max2) ? getSinglePointDomain(max2) : [min2, max2];
}
function getDomainFromProps(props2, axis) {
  const minDomain = getMinFromProps(props2, axis);
  const maxDomain = getMaxFromProps(props2, axis);
  if (_isPlainObject(props2.domain) && props2.domain[axis]) {
    return props2.domain[axis];
  } else if (Array.isArray(props2.domain)) {
    return props2.domain;
  } else if (minDomain !== void 0 && maxDomain !== void 0) {
    return getDomainFromMinMax(minDomain, maxDomain);
  }
  return void 0;
}
function getDomainWithZero(props2, axis) {
  const propsDomain = getDomainFromProps(props2, axis);
  if (propsDomain) {
    return propsDomain;
  }
  const dataset = getData(props2);
  const y0Min = dataset.reduce((min2, datum) => datum._y0 < min2 ? datum._y0 : min2, Infinity);
  const ensureZero = (domain) => {
    if (axis === "x") {
      return domain;
    }
    const defaultMin = y0Min !== Infinity ? y0Min : 0;
    const maxDomainProp = getMaxFromProps(props2, axis);
    const minDomainProp = getMinFromProps(props2, axis);
    const max2 = maxDomainProp !== void 0 ? maxDomainProp : getMaxValue(domain, defaultMin);
    const min2 = minDomainProp !== void 0 ? minDomainProp : getMinValue(domain, defaultMin);
    return getDomainFromMinMax(min2, max2);
  };
  const getDomainFunction = () => {
    return getDomainFromData$1(props2, axis, dataset);
  };
  const formatDomainFunction = (domain) => {
    return formatDomain(ensureZero(domain), props2, axis);
  };
  return createDomainFunction(getDomainFunction, formatDomainFunction)(props2, axis);
}
function getMaxFromProps(props2, axis) {
  if (_isPlainObject(props2.maxDomain) && props2.maxDomain[axis] !== void 0) {
    return props2.maxDomain[axis];
  }
  return typeof props2.maxDomain === "number" || _isDate(props2.maxDomain) ? props2.maxDomain : void 0;
}
function getMinFromProps(props2, axis) {
  if (_isPlainObject(props2.minDomain) && props2.minDomain[axis] !== void 0) {
    return props2.minDomain[axis];
  }
  return typeof props2.minDomain === "number" || _isDate(props2.minDomain) ? props2.minDomain : void 0;
}
function getSymmetricDomain(domain, values6) {
  const processedData = _sortedUniq(values6.sort((a4, b10) => a4 - b10));
  const step2 = processedData[1] - processedData[0];
  return [domain[0], domain[1] + step2];
}
function isDomainComponent(component) {
  const getRole2 = (child) => {
    return child && child.type ? child.type.role : "";
  };
  let role = getRole2(component);
  if (role === "portal") {
    const children2 = React__default.Children.toArray(component.props.children);
    role = children2.length ? getRole2(children2[0]) : "";
  }
  const whitelist = ["area", "axis", "bar", "boxplot", "candlestick", "errorbar", "group", "histogram", "line", "pie", "scatter", "stack", "voronoi"];
  return whitelist.includes(role);
}
function identity$1(value) {
  return value;
}
function getAxis(props2) {
  const {
    dependentAxis
  } = props2;
  return dependentAxis ? "y" : "x";
}
function findAxisComponents(childComponents, predicate) {
  const predicateFunction = predicate || identity$1;
  const findAxes = (children2) => {
    return children2.reduce((memo, child) => {
      if (child.type && child.type.role === "axis" && predicateFunction(child)) {
        return memo.concat(child);
      } else if (child.props && child.props.children) {
        return memo.concat(findAxes(React__default.Children.toArray(child.props.children)));
      }
      return memo;
    }, []);
  };
  return findAxes(childComponents);
}
function getAxisComponent(childComponents, axis) {
  const matchesAxis = (component) => {
    const type2 = component.type.getAxis(component.props);
    return type2 === axis;
  };
  return findAxisComponents(childComponents, matchesAxis)[0];
}
function getAxisComponentsWithParent(childComponents, type2) {
  const matchesType = (child) => {
    return type2 === "dependent" ? child.props.dependentAxis : !child.props.dependentAxis;
  };
  const findComponents = (children2) => {
    return children2.reduce((memo, child) => {
      if (child.type && child.type.role === "axis" && matchesType(child)) {
        return memo.concat(child);
      } else if (child.props && child.props.children) {
        const childAxis = findComponents(React__default.Children.toArray(child.props.children));
        return childAxis.length > 0 ? memo.concat(child) : memo;
      }
      return memo;
    }, []);
  };
  return findComponents(childComponents);
}
function getOrigin(domain) {
  const getSingleOrigin = (d3) => {
    const domainMin = Math.min(...d3);
    const domainMax = Math.max(...d3);
    return domainMax < 0 ? domainMax : Math.max(0, domainMin);
  };
  return {
    x: containsDates(domain.x) ? new Date(Math.min(...domain.x)) : getSingleOrigin(domain.x),
    y: containsDates(domain.y) ? new Date(Math.min(...domain.y)) : getSingleOrigin(domain.y)
  };
}
function getOriginSign(origin, domain) {
  const getSign = () => {
    return origin <= 0 && Math.max(...domain) <= 0 ? "negative" : "positive";
  };
  return containsDates(domain) ? "positive" : getSign();
}
function isVertical(props2) {
  const orientation = props2.orientation || (props2.dependentAxis ? "left" : "bottom");
  const vertical = {
    top: false,
    bottom: false,
    left: true,
    right: true
  };
  return vertical[orientation];
}
function stringTicks(props2) {
  return props2.tickValues !== void 0 && containsStrings(props2.tickValues);
}
function getDefaultTickFormat(props2) {
  const {
    tickValues
  } = props2;
  const axis = getAxis(props2);
  const stringMap = props2.stringMap && props2.stringMap[axis];
  const fallbackFormat = tickValues && !containsDates(tickValues) ? (x3) => x3 : void 0;
  if (!stringMap) {
    return stringTicks(props2) ? (x3, index2) => tickValues[index2] : fallbackFormat;
  }
  const invertedStringMap = stringMap && invert(stringMap);
  const tickValueArray = _orderBy(Object.values(stringMap), (n) => n);
  const dataNames = tickValueArray.map((tick) => invertedStringMap[tick]);
  const dataTicks = ["", ...dataNames, ""];
  return (x3) => dataTicks[x3];
}
function getStringTicks(props2) {
  const axis = getAxis(props2);
  const stringMap = props2.stringMap && props2.stringMap[axis];
  const categories = Array.isArray(props2.categories) ? props2.categories : props2.categories && props2.categories[axis];
  const ticksFromCategories = categories && containsOnlyStrings(categories) ? categories.map((tick) => stringMap[tick]) : void 0;
  const ticksFromStringMap = stringMap && Object.values(stringMap);
  return ticksFromCategories && ticksFromCategories.length !== 0 ? ticksFromCategories : ticksFromStringMap;
}
function getTickArray(props2) {
  const {
    tickValues,
    tickFormat: tickFormat2
  } = props2;
  if ((tickValues == null ? void 0 : tickValues.length) === 0) {
    return [];
  }
  const axis = getAxis(props2);
  const stringMap = props2.stringMap && props2.stringMap[axis];
  const getTicksFromFormat = () => {
    if (!tickFormat2 || !Array.isArray(tickFormat2)) {
      return void 0;
    }
    return containsStrings(tickFormat2) ? tickFormat2.map((t2, i2) => i2) : tickFormat2;
  };
  let ticks2 = tickValues;
  if (stringMap) {
    ticks2 = getStringTicks(props2);
  }
  if (tickValues && containsStrings(tickValues)) {
    ticks2 = stringMap ? tickValues.map((tick) => stringMap[tick]) : range$1(1, tickValues.length + 1);
  }
  const tickArray = ticks2 ? _uniq(ticks2) : getTicksFromFormat();
  const buildTickArray = (arr) => {
    const newTickArray = [];
    const domain = props2.domain && props2.domain[axis] || props2.domain;
    if (arr) {
      arr.forEach((t2, index2) => {
        if (Array.isArray(domain)) {
          if (t2 >= getMinValue(domain) && t2 <= getMaxValue(domain)) {
            newTickArray.push({
              value: t2,
              index: index2
            });
          }
        } else {
          newTickArray.push({
            value: t2,
            index: index2
          });
        }
      });
      return newTickArray;
    }
    return void 0;
  };
  return Array.isArray(tickArray) && tickArray.length ? buildTickArray(tickArray) : void 0;
}
function getTickFormat(props2, scale) {
  const {
    tickFormat: tickFormat2
  } = props2;
  const axis = getAxis(props2);
  const stringMap = props2.stringMap && props2.stringMap[axis];
  if (!tickFormat2) {
    const defaultTickFormat = getDefaultTickFormat(props2);
    const scaleTickFormat = scale.tickFormat && isFunction$1(scale.tickFormat) ? scale.tickFormat() : (x3) => x3;
    return defaultTickFormat || scaleTickFormat;
  } else if (tickFormat2 && Array.isArray(tickFormat2)) {
    const tickArray = getTickArray(props2);
    const tickArrayIndices = tickArray == null ? void 0 : tickArray.map((v) => v.index);
    const filteredTickFormat = tickFormat2.filter((t2, index2) => tickArrayIndices == null ? void 0 : tickArrayIndices.includes(index2));
    return (x3, index2) => filteredTickFormat[index2];
  } else if (tickFormat2 && isFunction$1(tickFormat2)) {
    const applyStringTicks = (tick, index2, ticks2) => {
      const invertedStringMap = invert(stringMap);
      const stringTickArray = ticks2.map((t2) => invertedStringMap[t2]);
      return props2.tickFormat(invertedStringMap[tick], index2, stringTickArray);
    };
    return stringMap ? applyStringTicks : tickFormat2;
  }
  return (x3) => x3;
}
function downsampleTicks(ticks2, tickCount) {
  if (!tickCount || !Array.isArray(ticks2) || ticks2.length <= tickCount) {
    return ticks2;
  }
  const k3 = Math.floor(ticks2.length / tickCount);
  return ticks2.filter((d3, i2) => i2 % k3 === 0);
}
function getTicks(props2, scale, filterZero) {
  if (filterZero === void 0) {
    filterZero = false;
  }
  const {
    tickCount
  } = props2;
  const tickArray = getTickArray(props2);
  if ((tickArray == null ? void 0 : tickArray.length) === 0) {
    return [""];
  }
  const tickValues = tickArray ? tickArray.map((v) => v.value) : void 0;
  if (tickValues) {
    return downsampleTicks(tickValues, tickCount);
  } else if (scale.ticks && isFunction$1(scale.ticks)) {
    const defaultTickCount = tickCount || 5;
    const scaleTicks = scale.ticks(defaultTickCount);
    const scaledTickArray = Array.isArray(scaleTicks) && scaleTicks.length ? scaleTicks : scale.domain();
    const ticks2 = downsampleTicks(scaledTickArray, tickCount);
    if (filterZero) {
      const filteredTicks = ticks2.filter((value) => value !== 0);
      return filteredTicks.length ? filteredTicks : ticks2;
    }
    return ticks2;
  }
  return scale.domain();
}
function getDomainFromData(props2, axis) {
  const {
    polar,
    startAngle = 0,
    endAngle = 360
  } = props2;
  const tickArray = getTickArray(props2);
  const tickValues = tickArray && (tickArray == null ? void 0 : tickArray.length) !== 0 ? tickArray.map((v) => v.value) : void 0;
  if (!Array.isArray(tickValues)) {
    return void 0;
  }
  const minDomain = getMinFromProps(props2, axis);
  const maxDomain = getMaxFromProps(props2, axis);
  const tickStrings = stringTicks(props2);
  const ticks2 = tickValues.map((value) => Number(value));
  const defaultMin = tickStrings ? 1 : getMinValue(ticks2);
  const defaultMax = tickStrings ? tickValues.length : getMaxValue(ticks2);
  const min2 = minDomain !== void 0 ? minDomain : defaultMin;
  const max2 = maxDomain !== void 0 ? maxDomain : defaultMax;
  const initialDomain = getDomainFromMinMax(min2, max2);
  const domain = polar && axis === "x" && Math.abs(startAngle - endAngle) === 360 ? getSymmetricDomain(initialDomain, ticks2) : initialDomain;
  if (isVertical(props2) && !polar) {
    domain.reverse();
  }
  return domain;
}
function getDomain$2(props2, axis) {
  const inherentAxis = getAxis(props2);
  if (axis && axis !== inherentAxis) {
    return void 0;
  }
  return createDomainFunction(getDomainFromData)(props2, inherentAxis);
}
function getAxisValue(props2, axis) {
  if (!props2.axisValue) {
    return void 0;
  }
  const scaleAxis = axis === "x" ? "y" : "x";
  const scale = _isObject(props2.scale) && isFunction$1(props2.scale[scaleAxis]) ? props2.scale[scaleAxis] : void 0;
  if (!scale) {
    return void 0;
  }
  const stringMapAxis = axis === "x" ? "y" : "x";
  const stringMap = _isObject(props2.stringMap) && props2.stringMap[stringMapAxis];
  const axisValue = stringMap && typeof props2.axisValue === "string" ? stringMap[props2.axisValue] : props2.axisValue;
  return scale(axisValue);
}
function modifyProps(props2, fallbackProps2) {
  if (!_isObject(props2.theme)) {
    return modifyProps$1(props2, fallbackProps2, "axis");
  }
  let role = "axis";
  if (props2.dependentAxis && props2.theme.dependentAxis) {
    role = "dependentAxis";
  } else if (!props2.dependentAxis && props2.theme.independentAxis) {
    role = "independentAxis";
  }
  if (role === "axis") {
    return modifyProps$1(props2, fallbackProps2, "axis");
  }
  const axisTheme = _defaults({}, props2.theme[role], props2.theme.axis);
  const theme2 = Object.assign({}, props2.theme, {
    axis: axisTheme
  });
  return modifyProps$1(Object.assign({}, props2, {
    theme: theme2
  }), fallbackProps2, "axis");
}
function continuousTransitions() {
  return {
    onLoad: {
      duration: 2e3
    },
    onExit: {
      duration: 500
    },
    onEnter: {
      duration: 500
    }
  };
}
function continuousPolarTransitions() {
  return {
    onLoad: {
      duration: 2e3,
      before: () => ({
        _y: 0,
        _y1: 0,
        _y0: 0
      }),
      after: (datum) => ({
        _y: datum._y,
        _y1: datum._y1,
        _y0: datum._y0
      })
    },
    onExit: {
      duration: 500,
      before: (datum, index2, data) => {
        const adjacent = (attr) => {
          const adj = index2 === 0 ? data[index2 + 1] : data[index2 - 1];
          return adj[attr];
        };
        return {
          _x: adjacent("_x"),
          _y: adjacent("_y"),
          _y0: adjacent("_y0")
        };
      }
    },
    onEnter: {
      duration: 500,
      before: (datum, index2, data) => {
        const adjacent = (attr) => {
          const adj = index2 === 0 ? data[index2 + 1] : data[index2 - 1];
          return adj[attr];
        };
        return {
          _x: adjacent("_x"),
          _y: adjacent("_y"),
          _y0: adjacent("_y0")
        };
      },
      after: (datum) => ({
        _x: datum._x,
        _y: datum._y,
        _y1: datum._y1,
        _y0: datum._y0
      })
    }
  };
}
function usePreviousProps(props2) {
  const ref2 = React__default.useRef();
  React__default.useEffect(() => {
    ref2.current = props2;
  });
  return ref2.current;
}
const INITIAL_STATE = {
  nodesShouldLoad: false,
  nodesDoneLoad: false,
  animating: true
};
const useAnimationState = function(initialState2) {
  if (initialState2 === void 0) {
    initialState2 = INITIAL_STATE;
  }
  const [state, _setState] = React__default.useState(initialState2);
  const setState = React__default.useCallback((newState) => {
    _setState((oldState) => ({
      ...oldState,
      ...newState
    }));
  }, [_setState]);
  const getAnimationProps = React__default.useCallback((props2, child, index2) => {
    if (!(props2 == null ? void 0 : props2.animate)) {
      return child.props.animate;
    }
    const getFilteredState = () => {
      let childrenTransitions = state && state.childrenTransitions;
      childrenTransitions = isArrayOfArrays(childrenTransitions) ? childrenTransitions[index2] : childrenTransitions;
      return _defaults({
        childrenTransitions
      }, state);
    };
    let getTransitions = props2.animate && props2.animate.getTransitions;
    const filteredState = getFilteredState();
    const parentState = props2.animate && props2.animate.parentState || filteredState;
    if (!getTransitions) {
      const getTransitionProps = getTransitionPropsFactory(props2, filteredState, (newState) => setState(newState));
      getTransitions = (childComponent) => getTransitionProps(childComponent, index2);
    }
    return _defaults({
      getTransitions,
      parentState
    }, props2.animate, child.props.animate);
  }, [state, setState]);
  const setAnimationState = React__default.useCallback((props2, nextProps) => {
    if (!(props2 == null ? void 0 : props2.animate)) {
      return;
    }
    if (props2.animate.parentState) {
      const nodesWillExit = props2.animate.parentState.nodesWillExit;
      const oldProps = nodesWillExit ? props2 : null;
      const newState = _defaults({
        oldProps,
        nextProps
      }, props2.animate.parentState);
      setState(newState);
    } else {
      const oldChildren = React__default.Children.toArray(props2.children);
      const nextChildren = React__default.Children.toArray(nextProps.children);
      const isContinuous = (child) => {
        const check = (c7) => c7.type && c7.type.continuous;
        return Array.isArray(child) ? child.some(check) : check(child);
      };
      const continuous2 = !props2.polar && oldChildren.some((child) => {
        var _a2;
        return isContinuous(child) || ((_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.children) && isContinuous(child.props.children);
      });
      const {
        nodesWillExit,
        nodesWillEnter,
        childrenTransitions,
        nodesShouldEnter
      } = getInitialTransitionState(oldChildren, nextChildren);
      setState({
        nodesWillExit,
        nodesWillEnter,
        nodesShouldEnter,
        childrenTransitions: isArrayOfArrays(childrenTransitions) ? childrenTransitions[0] : childrenTransitions,
        oldProps: nodesWillExit ? props2 : void 0,
        nextProps,
        continuous: continuous2
      });
    }
  }, [setState]);
  const getProps2 = React__default.useCallback((initialProps) => {
    return state && state.nodesWillExit ? state.oldProps || initialProps : initialProps;
  }, [state]);
  return {
    state,
    setState,
    getAnimationProps,
    setAnimationState,
    getProps: getProps2
  };
};
function constant(x3) {
  return function constant2() {
    return x3;
  };
}
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max = Math.max;
const min = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon$1 = 1e-12;
const pi$1 = Math.PI;
const halfPi = pi$1 / 2;
const tau$1 = 2 * pi$1;
function acos(x3) {
  return x3 > 1 ? 0 : x3 < -1 ? pi$1 : Math.acos(x3);
}
function asin(x3) {
  return x3 >= 1 ? halfPi : x3 <= -1 ? -halfPi : Math.asin(x3);
}
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(strings) {
  this._ += strings[0];
  for (let i2 = 1, n = strings.length; i2 < n; ++i2) {
    this._ += arguments[i2] + strings[i2];
  }
}
function appendRound(digits) {
  let d3 = Math.floor(digits);
  if (!(d3 >= 0))
    throw new Error(`invalid digits: ${digits}`);
  if (d3 > 15)
    return append;
  const k3 = 10 ** d3;
  return function(strings) {
    this._ += strings[0];
    for (let i2 = 1, n = strings.length; i2 < n; ++i2) {
      this._ += Math.round(arguments[i2] * k3) / k3 + strings[i2];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x3, y4) {
    this._append`M${this._x0 = this._x1 = +x3},${this._y0 = this._y1 = +y4}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x3, y4) {
    this._append`L${this._x1 = +x3},${this._y1 = +y4}`;
  }
  quadraticCurveTo(x1, y1, x3, y4) {
    this._append`Q${+x1},${+y1},${this._x1 = +x3},${this._y1 = +y4}`;
  }
  bezierCurveTo(x1, y1, x22, y22, x3, y4) {
    this._append`C${+x1},${+y1},${+x22},${+y22},${this._x1 = +x3},${this._y1 = +y4}`;
  }
  arcTo(x1, y1, x22, y22, r) {
    x1 = +x1, y1 = +y1, x22 = +x22, y22 = +y22, r = +r;
    if (r < 0)
      throw new Error(`negative radius: ${r}`);
    let x0 = this._x1, y0 = this._y1, x21 = x22 - x1, y21 = y22 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon))
      ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x22 - x0, y20 = y22 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x3, y4, r, a0, a1, ccw) {
    x3 = +x3, y4 = +y4, r = +r, ccw = !!ccw;
    if (r < 0)
      throw new Error(`negative radius: ${r}`);
    let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x3 + dx, y0 = y4 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._append`L${x0},${y0}`;
    }
    if (!r)
      return;
    if (da < 0)
      da = da % tau + tau;
    if (da > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x3 - dx},${y4 - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon) {
      this._append`A${r},${r},0,${+(da >= pi)},${cw},${this._x1 = x3 + r * Math.cos(a1)},${this._y1 = y4 + r * Math.sin(a1)}`;
    }
  }
  rect(x3, y4, w2, h3) {
    this._append`M${this._x0 = this._x1 = +x3},${this._y0 = this._y1 = +y4}h${w2 = +w2}v${+h3}h${-w2}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_) {
    if (!arguments.length)
      return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d3 = Math.floor(_);
      if (!(d3 >= 0))
        throw new RangeError(`invalid digits: ${_}`);
      digits = d3;
    }
    return shape;
  };
  return () => new Path(digits);
}
function arcInnerRadius(d3) {
  return d3.innerRadius;
}
function arcOuterRadius(d3) {
  return d3.outerRadius;
}
function arcStartAngle(d3) {
  return d3.startAngle;
}
function arcEndAngle(d3) {
  return d3.endAngle;
}
function arcPadAngle(d3) {
  return d3 && d3.padAngle;
}
function intersect(x0, y0, x1, y1, x22, y22, x3, y32) {
  var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x22, y322 = y32 - y22, t2 = y322 * x10 - x32 * y10;
  if (t2 * t2 < epsilon$1)
    return;
  t2 = (x32 * (y0 - y22) - y322 * (x0 - x22)) / t2;
  return [x0 + t2 * x10, y0 + t2 * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d22 = dx * dx + dy * dy, r = r1 - rc, D2 = x11 * y10 - x10 * y11, d3 = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d22 - D2 * D2)), cx0 = (D2 * dy - dx * d3) / d22, cy0 = (-D2 * dx - dy * d3) / d22, cx1 = (D2 * dy + dx * d3) / d22, cy1 = (-D2 * dx + dy * d3) / d22, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1)
    cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path2 = withPath(arc2);
  function arc2() {
    var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs(a1 - a0), cw = a1 > a0;
    if (!context)
      context = buffer = path2();
    if (r1 < r0)
      r = r1, r1 = r0, r0 = r;
    if (!(r1 > epsilon$1))
      context.moveTo(0, 0);
    else if (da > tau$1 - epsilon$1) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$1) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon$1 && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t02, t12;
      if (rp > epsilon$1) {
        var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$1)
          p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
        else
          da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$1)
          p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else
          da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
      if (rc > epsilon$1) {
        var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
        if (da < pi$1) {
          if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min(rc, (r0 - lc) / (kc - 1));
            rc1 = min(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }
      if (!(da1 > epsilon$1))
        context.moveTo(x01, y01);
      else if (rc1 > epsilon$1) {
        t02 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t12 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc1 < rc)
          context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r1, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), !cw);
          context.arc(t12.cx, t12.cy, rc1, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else
        context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon$1) || !(da0 > epsilon$1))
        context.lineTo(x10, y10);
      else if (rc0 > epsilon$1) {
        t02 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t12 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc0 < rc)
          context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r0, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), cw);
          context.arc(t12.cx, t12.cy, rc0, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else
        context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer)
      return context = null, buffer + "" || null;
  }
  arc2.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a4 = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$1 / 2;
    return [cos(a4) * r, sin(a4) * r];
  };
  arc2.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc2) : innerRadius;
  };
  arc2.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc2) : outerRadius;
  };
  arc2.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc2) : cornerRadius;
  };
  arc2.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc2) : padRadius;
  };
  arc2.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc2) : startAngle;
  };
  arc2.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc2) : endAngle;
  };
  arc2.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc2) : padAngle;
  };
  arc2.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, arc2) : context;
  };
  return arc2;
}
var slice = Array.prototype.slice;
function array$1(x3) {
  return typeof x3 === "object" && "length" in x3 ? x3 : Array.from(x3);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x3, y4);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x2(p) {
  return p[0];
}
function y3(p) {
  return p[1];
}
function line(x$1, y$1) {
  var defined2 = constant(true), context = null, curve = curveLinear, output = null, path2 = withPath(line2);
  x$1 = typeof x$1 === "function" ? x$1 : x$1 === void 0 ? x2 : constant(x$1);
  y$1 = typeof y$1 === "function" ? y$1 : y$1 === void 0 ? y3 : constant(y$1);
  function line2(data) {
    var i2, n = (data = array$1(data)).length, d3, defined0 = false, buffer;
    if (context == null)
      output = curve(buffer = path2());
    for (i2 = 0; i2 <= n; ++i2) {
      if (!(i2 < n && defined2(d3 = data[i2], i2, data)) === defined0) {
        if (defined0 = !defined0)
          output.lineStart();
        else
          output.lineEnd();
      }
      if (defined0)
        output.point(+x$1(d3, i2, data), +y$1(d3, i2, data));
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  line2.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line2) : x$1;
  };
  line2.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line2) : y$1;
  };
  line2.defined = function(_) {
    return arguments.length ? (defined2 = typeof _ === "function" ? _ : constant(!!_), line2) : defined2;
  };
  line2.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line2) : context;
  };
  return line2;
}
function area(x0, y0, y1) {
  var x1 = null, defined2 = constant(true), context = null, curve = curveLinear, output = null, path2 = withPath(area2);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x2 : constant(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant(0) : constant(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y3 : constant(+y1);
  function area2(data) {
    var i2, j, k3, n = (data = array$1(data)).length, d3, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
    if (context == null)
      output = curve(buffer = path2());
    for (i2 = 0; i2 <= n; ++i2) {
      if (!(i2 < n && defined2(d3 = data[i2], i2, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i2;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k3 = i2 - 1; k3 >= j; --k3) {
            output.point(x0z[k3], y0z[k3]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i2] = +x0(d3, i2, data), y0z[i2] = +y0(d3, i2, data);
        output.point(x1 ? +x1(d3, i2, data) : x0z[i2], y1 ? +y1(d3, i2, data) : y0z[i2]);
      }
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  function arealine() {
    return line().defined(defined2).curve(curve).context(context);
  }
  area2.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area2) : x0;
  };
  area2.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area2) : x0;
  };
  area2.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area2) : x1;
  };
  area2.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area2) : y0;
  };
  area2.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area2) : y0;
  };
  area2.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area2) : y1;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area2.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area2.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area2.defined = function(_) {
    return arguments.length ? (defined2 = typeof _ === "function" ? _ : constant(!!_), area2) : defined2;
  };
  area2.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area2) : context;
  };
  return area2;
}
function descending$1(a4, b10) {
  return b10 < a4 ? -1 : b10 > a4 ? 1 : b10 >= a4 ? 0 : NaN;
}
function identity(d3) {
  return d3;
}
function pie() {
  var value = identity, sortValues = descending$1, sort3 = null, startAngle = constant(0), endAngle = constant(tau$1), padAngle = constant(0);
  function pie2(data) {
    var i2, n = (data = array$1(data)).length, j, k3, sum2 = 0, index2 = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(tau$1, Math.max(-tau$1, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
    for (i2 = 0; i2 < n; ++i2) {
      if ((v = arcs[index2[i2] = i2] = +value(data[i2], i2, data)) > 0) {
        sum2 += v;
      }
    }
    if (sortValues != null)
      index2.sort(function(i3, j2) {
        return sortValues(arcs[i3], arcs[j2]);
      });
    else if (sort3 != null)
      index2.sort(function(i3, j2) {
        return sort3(data[i3], data[j2]);
      });
    for (i2 = 0, k3 = sum2 ? (da - n * pa) / sum2 : 0; i2 < n; ++i2, a0 = a1) {
      j = index2[i2], v = arcs[j], a1 = a0 + (v > 0 ? v * k3 : 0) + pa, arcs[j] = {
        data: data[j],
        index: i2,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }
    return arcs;
  }
  pie2.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie2) : value;
  };
  pie2.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort3 = null, pie2) : sortValues;
  };
  pie2.sort = function(_) {
    return arguments.length ? (sort3 = _, sortValues = null, pie2) : sort3;
  };
  pie2.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie2) : startAngle;
  };
  pie2.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie2) : endAngle;
  };
  pie2.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie2) : padAngle;
  };
  return pie2;
}
var curveRadialLinear = curveRadial(curveLinear);
function Radial(curve) {
  this._curve = curve;
}
Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a4, r) {
    this._curve.point(r * Math.sin(a4), r * -Math.cos(a4));
  }
};
function curveRadial(curve) {
  function radial2(context) {
    return new Radial(curve(context));
  }
  radial2._curve = curve;
  return radial2;
}
function lineRadial(l) {
  var c7 = l.curve;
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  l.curve = function(_) {
    return arguments.length ? c7(curveRadial(_)) : c7()._curve;
  };
  return l;
}
function lineRadial$1() {
  return lineRadial(line().curve(curveRadialLinear));
}
function areaRadial() {
  var a4 = area().curve(curveRadialLinear), c7 = a4.curve, x0 = a4.lineX0, x1 = a4.lineX1, y0 = a4.lineY0, y1 = a4.lineY1;
  a4.angle = a4.x, delete a4.x;
  a4.startAngle = a4.x0, delete a4.x0;
  a4.endAngle = a4.x1, delete a4.x1;
  a4.radius = a4.y, delete a4.y;
  a4.innerRadius = a4.y0, delete a4.y0;
  a4.outerRadius = a4.y1, delete a4.y1;
  a4.lineStartAngle = function() {
    return lineRadial(x0());
  }, delete a4.lineX0;
  a4.lineEndAngle = function() {
    return lineRadial(x1());
  }, delete a4.lineX1;
  a4.lineInnerRadius = function() {
    return lineRadial(y0());
  }, delete a4.lineY0;
  a4.lineOuterRadius = function() {
    return lineRadial(y1());
  }, delete a4.lineY1;
  a4.curve = function(_) {
    return arguments.length ? c7(curveRadial(_)) : c7()._curve;
  };
  return a4;
}
function pointRadial(x3, y4) {
  return [(y4 = +y4) * Math.cos(x3 -= Math.PI / 2), y4 * Math.sin(x3)];
}
class Bump {
  constructor(context, x3) {
    this._context = context;
    this._x = x3;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  }
  point(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0: {
        this._point = 1;
        if (this._line)
          this._context.lineTo(x3, y4);
        else
          this._context.moveTo(x3, y4);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        if (this._x)
          this._context.bezierCurveTo(this._x0 = (this._x0 + x3) / 2, this._y0, this._x0, y4, x3, y4);
        else
          this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y4) / 2, x3, this._y0, x3, y4);
        break;
      }
    }
    this._x0 = x3, this._y0 = y4;
  }
}
class BumpRadial {
  constructor(context) {
    this._context = context;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
  }
  point(x3, y4) {
    x3 = +x3, y4 = +y4;
    if (this._point === 0) {
      this._point = 1;
    } else {
      const p0 = pointRadial(this._x0, this._y0);
      const p1 = pointRadial(this._x0, this._y0 = (this._y0 + y4) / 2);
      const p2 = pointRadial(x3, this._y0);
      const p3 = pointRadial(x3, y4);
      this._context.moveTo(...p0);
      this._context.bezierCurveTo(...p1, ...p2, ...p3);
    }
    this._x0 = x3, this._y0 = y4;
  }
}
function bumpX(context) {
  return new Bump(context, true);
}
function bumpY(context) {
  return new Bump(context, false);
}
function bumpRadial(context) {
  return new BumpRadial(context);
}
function linkSource(d3) {
  return d3.source;
}
function linkTarget(d3) {
  return d3.target;
}
function link(curve) {
  let source = linkSource, target = linkTarget, x$1 = x2, y$1 = y3, context = null, output = null, path2 = withPath(link2);
  function link2() {
    let buffer;
    const argv = slice.call(arguments);
    const s4 = source.apply(this, argv);
    const t2 = target.apply(this, argv);
    if (context == null)
      output = curve(buffer = path2());
    output.lineStart();
    argv[0] = s4, output.point(+x$1.apply(this, argv), +y$1.apply(this, argv));
    argv[0] = t2, output.point(+x$1.apply(this, argv), +y$1.apply(this, argv));
    output.lineEnd();
    if (buffer)
      return output = null, buffer + "" || null;
  }
  link2.source = function(_) {
    return arguments.length ? (source = _, link2) : source;
  };
  link2.target = function(_) {
    return arguments.length ? (target = _, link2) : target;
  };
  link2.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link2) : x$1;
  };
  link2.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link2) : y$1;
  };
  link2.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link2) : context;
  };
  return link2;
}
function linkHorizontal() {
  return link(bumpX);
}
function linkVertical() {
  return link(bumpY);
}
function linkRadial() {
  const l = link(bumpRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}
const sqrt3$2 = sqrt(3);
const asterisk = {
  draw(context, size) {
    const r = sqrt(size + min(size / 28, 0.75)) * 0.59436;
    const t2 = r / 2;
    const u2 = t2 * sqrt3$2;
    context.moveTo(0, r);
    context.lineTo(0, -r);
    context.moveTo(-u2, -t2);
    context.lineTo(u2, t2);
    context.moveTo(-u2, t2);
    context.lineTo(u2, -t2);
  }
};
const circle$1 = {
  draw(context, size) {
    const r = sqrt(size / pi$1);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, tau$1);
  }
};
const cross = {
  draw(context, size) {
    const r = sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
};
const tan30 = sqrt(1 / 3);
const tan30_2 = tan30 * 2;
const diamond = {
  draw(context, size) {
    const y4 = sqrt(size / tan30_2);
    const x3 = y4 * tan30;
    context.moveTo(0, -y4);
    context.lineTo(x3, 0);
    context.lineTo(0, y4);
    context.lineTo(-x3, 0);
    context.closePath();
  }
};
const diamond2 = {
  draw(context, size) {
    const r = sqrt(size) * 0.62625;
    context.moveTo(0, -r);
    context.lineTo(r, 0);
    context.lineTo(0, r);
    context.lineTo(-r, 0);
    context.closePath();
  }
};
const plus = {
  draw(context, size) {
    const r = sqrt(size - min(size / 7, 2)) * 0.87559;
    context.moveTo(-r, 0);
    context.lineTo(r, 0);
    context.moveTo(0, r);
    context.lineTo(0, -r);
  }
};
const square = {
  draw(context, size) {
    const w2 = sqrt(size);
    const x3 = -w2 / 2;
    context.rect(x3, x3, w2, w2);
  }
};
const square2 = {
  draw(context, size) {
    const r = sqrt(size) * 0.4431;
    context.moveTo(r, r);
    context.lineTo(r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, r);
    context.closePath();
  }
};
const ka = 0.8908130915292852;
const kr = sin(pi$1 / 10) / sin(7 * pi$1 / 10);
const kx = sin(tau$1 / 10) * kr;
const ky = -cos(tau$1 / 10) * kr;
const star = {
  draw(context, size) {
    const r = sqrt(size * ka);
    const x3 = kx * r;
    const y4 = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x3, y4);
    for (let i2 = 1; i2 < 5; ++i2) {
      const a4 = tau$1 * i2 / 5;
      const c7 = cos(a4);
      const s4 = sin(a4);
      context.lineTo(s4 * r, -c7 * r);
      context.lineTo(c7 * x3 - s4 * y4, s4 * x3 + c7 * y4);
    }
    context.closePath();
  }
};
const sqrt3$1 = sqrt(3);
const triangle = {
  draw(context, size) {
    const y4 = -sqrt(size / (sqrt3$1 * 3));
    context.moveTo(0, y4 * 2);
    context.lineTo(-sqrt3$1 * y4, -y4);
    context.lineTo(sqrt3$1 * y4, -y4);
    context.closePath();
  }
};
const sqrt3 = sqrt(3);
const triangle2 = {
  draw(context, size) {
    const s4 = sqrt(size) * 0.6824;
    const t2 = s4 / 2;
    const u2 = s4 * sqrt3 / 2;
    context.moveTo(0, -s4);
    context.lineTo(u2, t2);
    context.lineTo(-u2, t2);
    context.closePath();
  }
};
const c6 = -0.5;
const s3 = sqrt(3) / 2;
const k2 = 1 / sqrt(12);
const a3 = (k2 / 2 + 1) * 3;
const wye = {
  draw(context, size) {
    const r = sqrt(size / a3);
    const x0 = r / 2, y0 = r * k2;
    const x1 = x0, y1 = r * k2 + r;
    const x22 = -x1, y22 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x22, y22);
    context.lineTo(c6 * x0 - s3 * y0, s3 * x0 + c6 * y0);
    context.lineTo(c6 * x1 - s3 * y1, s3 * x1 + c6 * y1);
    context.lineTo(c6 * x22 - s3 * y22, s3 * x22 + c6 * y22);
    context.lineTo(c6 * x0 + s3 * y0, c6 * y0 - s3 * x0);
    context.lineTo(c6 * x1 + s3 * y1, c6 * y1 - s3 * x1);
    context.lineTo(c6 * x22 + s3 * y22, c6 * y22 - s3 * x22);
    context.closePath();
  }
};
const times = {
  draw(context, size) {
    const r = sqrt(size - min(size / 6, 1.7)) * 0.6189;
    context.moveTo(-r, -r);
    context.lineTo(r, r);
    context.moveTo(-r, r);
    context.lineTo(r, -r);
  }
};
const symbolsFill = [
  circle$1,
  cross,
  diamond,
  square,
  star,
  triangle,
  wye
];
const symbolsStroke = [
  circle$1,
  plus,
  times,
  triangle2,
  asterisk,
  square2,
  diamond2
];
function Symbol$1(type2, size) {
  let context = null, path2 = withPath(symbol);
  type2 = typeof type2 === "function" ? type2 : constant(type2 || circle$1);
  size = typeof size === "function" ? size : constant(size === void 0 ? 64 : +size);
  function symbol() {
    let buffer;
    if (!context)
      context = buffer = path2();
    type2.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer)
      return context = null, buffer + "" || null;
  }
  symbol.type = function(_) {
    return arguments.length ? (type2 = typeof _ === "function" ? _ : constant(_), symbol) : type2;
  };
  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
  };
  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };
  return symbol;
}
function noop$1() {
}
function point$4(that, x3, y4) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x3) / 6,
    (that._y0 + 4 * that._y1 + y4) / 6
  );
}
function Basis(context) {
  this._context = context;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$4(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        point$4(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
  }
};
function basis(context) {
  return new Basis(context);
}
function BasisClosed(context) {
  this._context = context;
}
BasisClosed.prototype = {
  areaStart: noop$1,
  areaEnd: noop$1,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x2 = x3, this._y2 = y4;
        break;
      case 1:
        this._point = 2;
        this._x3 = x3, this._y3 = y4;
        break;
      case 2:
        this._point = 3;
        this._x4 = x3, this._y4 = y4;
        this._context.moveTo((this._x0 + 4 * this._x1 + x3) / 6, (this._y0 + 4 * this._y1 + y4) / 6);
        break;
      default:
        point$4(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
  }
};
function basisClosed(context) {
  return new BasisClosed(context);
}
function BasisOpen(context) {
  this._context = context;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var x0 = (this._x0 + 4 * this._x1 + x3) / 6, y0 = (this._y0 + 4 * this._y1 + y4) / 6;
        this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
        break;
      case 3:
        this._point = 4;
      default:
        point$4(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
  }
};
function basisOpen(context) {
  return new BasisOpen(context);
}
function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}
Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x3 = this._x, y4 = this._y, j = x3.length - 1;
    if (j > 0) {
      var x0 = x3[0], y0 = y4[0], dx = x3[j] - x0, dy = y4[j] - y0, i2 = -1, t2;
      while (++i2 <= j) {
        t2 = i2 / j;
        this._basis.point(
          this._beta * x3[i2] + (1 - this._beta) * (x0 + t2 * dx),
          this._beta * y4[i2] + (1 - this._beta) * (y0 + t2 * dy)
        );
      }
    }
    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x3, y4) {
    this._x.push(+x3);
    this._y.push(+y4);
  }
};
const bundle = function custom10(beta) {
  function bundle2(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }
  bundle2.beta = function(beta2) {
    return custom10(+beta2);
  };
  return bundle2;
}(0.85);
function point$3(that, x3, y4) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x3),
    that._y2 + that._k * (that._y1 - y4),
    that._x2,
    that._y2
  );
}
function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        point$3(this, this._x1, this._y1);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        this._x1 = x3, this._y1 = y4;
        break;
      case 2:
        this._point = 3;
      default:
        point$3(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x3;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
  }
};
const cardinal = function custom11(tension) {
  function cardinal2(context) {
    return new Cardinal(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom11(+tension2);
  };
  return cardinal2;
}(0);
function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
  areaStart: noop$1,
  areaEnd: noop$1,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x3, this._y3 = y4;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x3, this._y4 = y4);
        break;
      case 2:
        this._point = 3;
        this._x5 = x3, this._y5 = y4;
        break;
      default:
        point$3(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x3;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
  }
};
const cardinalClosed = function custom12(tension) {
  function cardinal2(context) {
    return new CardinalClosed(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom12(+tension2);
  };
  return cardinal2;
}(0);
function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        point$3(this, x3, y4);
        break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x3;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
  }
};
const cardinalOpen = function custom13(tension) {
  function cardinal2(context) {
    return new CardinalOpen(context, tension);
  }
  cardinal2.tension = function(tension2) {
    return custom13(+tension2);
  };
  return cardinal2;
}(0);
function point$2(that, x3, y4) {
  var x1 = that._x1, y1 = that._y1, x22 = that._x2, y22 = that._y2;
  if (that._l01_a > epsilon$1) {
    var a4 = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a4 - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a4 - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }
  if (that._l23_a > epsilon$1) {
    var b10 = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m3 = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x22 = (x22 * b10 + that._x1 * that._l23_2a - x3 * that._l12_2a) / m3;
    y22 = (y22 * b10 + that._y1 * that._l23_2a - y4 * that._l12_2a) / m3;
  }
  that._context.bezierCurveTo(x1, y1, x22, y22, that._x2, that._y2);
}
function CatmullRom(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x2, this._y2);
        break;
      case 3:
        this.point(this._x2, this._y2);
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    if (this._point) {
      var x23 = this._x2 - x3, y23 = this._y2 - y4;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
      default:
        point$2(this, x3, y4);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x3;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
  }
};
const catmullRom = function custom14(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRom(context, alpha2) : new Cardinal(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom14(+alpha3);
  };
  return catmullRom2;
}(0.5);
function CatmullRomClosed(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRomClosed.prototype = {
  areaStart: noop$1,
  areaEnd: noop$1,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    if (this._point) {
      var x23 = this._x2 - x3, y23 = this._y2 - y4;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        this._x3 = x3, this._y3 = y4;
        break;
      case 1:
        this._point = 2;
        this._context.moveTo(this._x4 = x3, this._y4 = y4);
        break;
      case 2:
        this._point = 3;
        this._x5 = x3, this._y5 = y4;
        break;
      default:
        point$2(this, x3, y4);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x3;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
  }
};
const catmullRomClosed = function custom15(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRomClosed(context, alpha2) : new CardinalClosed(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom15(+alpha3);
  };
  return catmullRom2;
}(0.5);
function CatmullRomOpen(context, alpha2) {
  this._context = context;
  this._alpha = alpha2;
}
CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 3)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    if (this._point) {
      var x23 = this._x2 - x3, y23 = this._y2 - y4;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }
    switch (this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
        break;
      case 3:
        this._point = 4;
      default:
        point$2(this, x3, y4);
        break;
    }
    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x3;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y4;
  }
};
const catmullRomOpen = function custom16(alpha2) {
  function catmullRom2(context) {
    return alpha2 ? new CatmullRomOpen(context, alpha2) : new CardinalOpen(context, 0);
  }
  catmullRom2.alpha = function(alpha3) {
    return custom16(+alpha3);
  };
  return catmullRom2;
}(0.5);
function LinearClosed(context) {
  this._context = context;
}
LinearClosed.prototype = {
  areaStart: noop$1,
  areaEnd: noop$1,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point)
      this._context.closePath();
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    if (this._point)
      this._context.lineTo(x3, y4);
    else
      this._point = 1, this._context.moveTo(x3, y4);
  }
};
function linearClosed(context) {
  return new LinearClosed(context);
}
function sign(x3) {
  return x3 < 0 ? -1 : 1;
}
function slope3(that, x22, y22) {
  var h0 = that._x1 - that._x0, h1 = x22 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y22 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
function slope2(that, t2) {
  var h3 = that._x1 - that._x0;
  return h3 ? (3 * (that._y1 - that._y0) / h3 - t2) / 2 : t2;
}
function point$1(that, t02, t12) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t02, x1 - dx, y1 - dx * t12, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    var t12 = NaN;
    x3 = +x3, y4 = +y4;
    if (x3 === this._x1 && y4 === this._y1)
      return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point$1(this, slope2(this, t12 = slope3(this, x3, y4)), t12);
        break;
      default:
        point$1(this, this._t0, t12 = slope3(this, x3, y4));
        break;
    }
    this._x0 = this._x1, this._x1 = x3;
    this._y0 = this._y1, this._y1 = y4;
    this._t0 = t12;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x3, y4) {
  MonotoneX.prototype.point.call(this, y4, x3);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x3, y4) {
    this._context.moveTo(y4, x3);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x3, y4) {
    this._context.lineTo(y4, x3);
  },
  bezierCurveTo: function(x1, y1, x22, y22, x3, y4) {
    this._context.bezierCurveTo(y1, x1, y22, x22, y4, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x3 = this._x, y4 = this._y, n = x3.length;
    if (n) {
      this._line ? this._context.lineTo(x3[0], y4[0]) : this._context.moveTo(x3[0], y4[0]);
      if (n === 2) {
        this._context.lineTo(x3[1], y4[1]);
      } else {
        var px = controlPoints(x3), py = controlPoints(y4);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x3[i1], y4[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n === 1)
      this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x3, y4) {
    this._x.push(+x3);
    this._y.push(+y4);
  }
};
function controlPoints(x3) {
  var i2, n = x3.length - 1, m3, a4 = new Array(n), b10 = new Array(n), r = new Array(n);
  a4[0] = 0, b10[0] = 2, r[0] = x3[0] + 2 * x3[1];
  for (i2 = 1; i2 < n - 1; ++i2)
    a4[i2] = 1, b10[i2] = 4, r[i2] = 4 * x3[i2] + 2 * x3[i2 + 1];
  a4[n - 1] = 2, b10[n - 1] = 7, r[n - 1] = 8 * x3[n - 1] + x3[n];
  for (i2 = 1; i2 < n; ++i2)
    m3 = a4[i2] / b10[i2 - 1], b10[i2] -= m3, r[i2] -= m3 * r[i2 - 1];
  a4[n - 1] = r[n - 1] / b10[n - 1];
  for (i2 = n - 2; i2 >= 0; --i2)
    a4[i2] = (r[i2] - a4[i2 + 1]) / b10[i2];
  b10[n - 1] = (x3[n] + a4[n - 1]) / 2;
  for (i2 = 0; i2 < n - 1; ++i2)
    b10[i2] = 2 * x3[i2 + 1] - a4[i2 + 1];
  return [a4, b10];
}
function natural(context) {
  return new Natural(context);
}
function Step(context, t2) {
  this._context = context;
  this._t = t2;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2)
      this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    if (this._line >= 0)
      this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x3, y4) {
    x3 = +x3, y4 = +y4;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x3, y4) : this._context.moveTo(x3, y4);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y4);
          this._context.lineTo(x3, y4);
        } else {
          var x1 = this._x * (1 - this._t) + x3 * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y4);
        }
        break;
      }
    }
    this._x = x3, this._y = y4;
  }
};
function step(context) {
  return new Step(context, 0.5);
}
function stepBefore(context) {
  return new Step(context, 0);
}
function stepAfter(context) {
  return new Step(context, 1);
}
function none$1(series, order2) {
  if (!((n = series.length) > 1))
    return;
  for (var i2 = 1, j, s0, s1 = series[order2[0]], n, m3 = s1.length; i2 < n; ++i2) {
    s0 = s1, s1 = series[order2[i2]];
    for (j = 0; j < m3; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}
function none(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0)
    o[n] = n;
  return o;
}
function stackValue(d3, key) {
  return d3[key];
}
function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}
function stack() {
  var keys8 = constant([]), order2 = none, offset2 = none$1, value = stackValue;
  function stack2(data) {
    var sz = Array.from(keys8.apply(this, arguments), stackSeries), i2, n = sz.length, j = -1, oz;
    for (const d3 of data) {
      for (i2 = 0, ++j; i2 < n; ++i2) {
        (sz[i2][j] = [0, +value(d3, sz[i2].key, j, data)]).data = d3;
      }
    }
    for (i2 = 0, oz = array$1(order2(sz)); i2 < n; ++i2) {
      sz[oz[i2]].index = i2;
    }
    offset2(sz, oz);
    return sz;
  }
  stack2.keys = function(_) {
    return arguments.length ? (keys8 = typeof _ === "function" ? _ : constant(Array.from(_)), stack2) : keys8;
  };
  stack2.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack2) : value;
  };
  stack2.order = function(_) {
    return arguments.length ? (order2 = _ == null ? none : typeof _ === "function" ? _ : constant(Array.from(_)), stack2) : order2;
  };
  stack2.offset = function(_) {
    return arguments.length ? (offset2 = _ == null ? none$1 : _, stack2) : offset2;
  };
  return stack2;
}
function expand(series, order2) {
  if (!((n = series.length) > 0))
    return;
  for (var i2, n, j = 0, m3 = series[0].length, y4; j < m3; ++j) {
    for (y4 = i2 = 0; i2 < n; ++i2)
      y4 += series[i2][j][1] || 0;
    if (y4)
      for (i2 = 0; i2 < n; ++i2)
        series[i2][j][1] /= y4;
  }
  none$1(series, order2);
}
function diverging(series, order2) {
  if (!((n = series.length) > 0))
    return;
  for (var i2, j = 0, d3, dy, yp, yn, n, m3 = series[order2[0]].length; j < m3; ++j) {
    for (yp = yn = 0, i2 = 0; i2 < n; ++i2) {
      if ((dy = (d3 = series[order2[i2]][j])[1] - d3[0]) > 0) {
        d3[0] = yp, d3[1] = yp += dy;
      } else if (dy < 0) {
        d3[1] = yn, d3[0] = yn += dy;
      } else {
        d3[0] = 0, d3[1] = dy;
      }
    }
  }
}
function silhouette(series, order2) {
  if (!((n = series.length) > 0))
    return;
  for (var j = 0, s0 = series[order2[0]], n, m3 = s0.length; j < m3; ++j) {
    for (var i2 = 0, y4 = 0; i2 < n; ++i2)
      y4 += series[i2][j][1] || 0;
    s0[j][1] += s0[j][0] = -y4 / 2;
  }
  none$1(series, order2);
}
function wiggle(series, order2) {
  if (!((n = series.length) > 0) || !((m3 = (s0 = series[order2[0]]).length) > 0))
    return;
  for (var y4 = 0, j = 1, s0, m3, n; j < m3; ++j) {
    for (var i2 = 0, s1 = 0, s22 = 0; i2 < n; ++i2) {
      var si = series[order2[i2]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s32 = (sij0 - sij1) / 2;
      for (var k3 = 0; k3 < i2; ++k3) {
        var sk = series[order2[k3]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
        s32 += skj0 - skj1;
      }
      s1 += sij0, s22 += s32 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y4;
    if (s1)
      y4 -= s22 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y4;
  none$1(series, order2);
}
function appearance(series) {
  var peaks = series.map(peak);
  return none(series).sort(function(a4, b10) {
    return peaks[a4] - peaks[b10];
  });
}
function peak(series) {
  var i2 = -1, j = 0, n = series.length, vi2, vj = -Infinity;
  while (++i2 < n)
    if ((vi2 = +series[i2][1]) > vj)
      vj = vi2, j = i2;
  return j;
}
function ascending(series) {
  var sums = series.map(sum);
  return none(series).sort(function(a4, b10) {
    return sums[a4] - sums[b10];
  });
}
function sum(series) {
  var s4 = 0, i2 = -1, n = series.length, v;
  while (++i2 < n)
    if (v = +series[i2][1])
      s4 += v;
  return s4;
}
function descending(series) {
  return ascending(series).reverse();
}
function insideOut(series) {
  var n = series.length, i2, j, sums = series.map(sum), order2 = appearance(series), top2 = 0, bottom2 = 0, tops = [], bottoms = [];
  for (i2 = 0; i2 < n; ++i2) {
    j = order2[i2];
    if (top2 < bottom2) {
      top2 += sums[j];
      tops.push(j);
    } else {
      bottom2 += sums[j];
      bottoms.push(j);
    }
  }
  return bottoms.reverse().concat(tops);
}
function reverse(series) {
  return none(series).reverse();
}
const d3Shape = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arc,
  area,
  areaRadial,
  curveBasis: basis,
  curveBasisClosed: basisClosed,
  curveBasisOpen: basisOpen,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveBundle: bundle,
  curveCardinal: cardinal,
  curveCardinalClosed: cardinalClosed,
  curveCardinalOpen: cardinalOpen,
  curveCatmullRom: catmullRom,
  curveCatmullRomClosed: catmullRomClosed,
  curveCatmullRomOpen: catmullRomOpen,
  curveLinear,
  curveLinearClosed: linearClosed,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural: natural,
  curveStep: step,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore,
  line,
  lineRadial: lineRadial$1,
  link,
  linkHorizontal,
  linkRadial,
  linkVertical,
  pie,
  pointRadial,
  radialArea: areaRadial,
  radialLine: lineRadial$1,
  stack,
  stackOffsetDiverging: diverging,
  stackOffsetExpand: expand,
  stackOffsetNone: none$1,
  stackOffsetSilhouette: silhouette,
  stackOffsetWiggle: wiggle,
  stackOrderAppearance: appearance,
  stackOrderAscending: ascending,
  stackOrderDescending: descending,
  stackOrderInsideOut: insideOut,
  stackOrderNone: none,
  stackOrderReverse: reverse,
  symbol: Symbol$1,
  symbolAsterisk: asterisk,
  symbolCircle: circle$1,
  symbolCross: cross,
  symbolDiamond: diamond,
  symbolDiamond2: diamond2,
  symbolPlus: plus,
  symbolSquare: square,
  symbolSquare2: square2,
  symbolStar: star,
  symbolTimes: times,
  symbolTriangle: triangle,
  symbolTriangle2: triangle2,
  symbolWye: wye,
  symbolX: times,
  symbols: symbolsFill,
  symbolsFill,
  symbolsStroke
}, Symbol.toStringTag, { value: "Module" }));
const defined$1 = (d3) => {
  const y4 = d3._y1 !== void 0 ? d3._y1 : d3._y;
  return y4 !== null && y4 !== void 0 && d3._y0 !== null;
};
const getXAccessor$1 = (scale) => {
  return (d3) => scale.x(d3._x1 !== void 0 ? d3._x1 : d3._x);
};
const getYAccessor$1 = (scale) => {
  return (d3) => scale.y(d3._y1 !== void 0 ? d3._y1 : d3._y);
};
const getAngleAccessor$1 = (scale) => {
  return (d3) => {
    const x3 = scale.x(d3._x1 !== void 0 ? d3._x1 : d3._x);
    return -1 * x3 + Math.PI / 2;
  };
};
const toNewName = (interpolation) => {
  const capitalize2 = (s4) => s4 && s4[0].toUpperCase() + s4.slice(1);
  return `curve${capitalize2(interpolation)}`;
};
const toNewNameClosed = (interpolation) => {
  return `${toNewName(interpolation)}Closed`;
};
const getInterpolationFunction = (props2) => {
  const {
    interpolation
  } = props2;
  if (typeof interpolation === "function") {
    return interpolation;
  }
  if (typeof interpolation === "string") {
    const {
      polar,
      openCurve = !polar
    } = props2;
    const interpolationName = !openCurve ? toNewNameClosed(interpolation) : toNewName(interpolation);
    return d3Shape[interpolationName];
  }
  return curveLinear;
};
const getLineFunction = (props2) => {
  const {
    polar,
    scale,
    horizontal
  } = props2;
  return polar ? lineRadial$1().defined(defined$1).curve(getInterpolationFunction(props2)).angle(getAngleAccessor$1(scale)).radius(getYAccessor$1(scale)) : line().defined(defined$1).curve(getInterpolationFunction(props2)).x(horizontal ? getYAccessor$1(scale) : getXAccessor$1(scale)).y(horizontal ? getXAccessor$1(scale) : getYAccessor$1(scale));
};
function transformTarget(target, matrix, dimension) {
  const {
    a: a4,
    d: d3,
    e: e3,
    f
  } = matrix;
  return dimension === "y" ? d3 * target + f : a4 * target + e3;
}
function getTransformationMatrix(svg) {
  return svg.getScreenCTM().inverse();
}
function isNativeTouchEvent(nativeEvent) {
  return !!(nativeEvent && nativeEvent.identifier !== void 0);
}
function isReactTouchEvent(evt) {
  return evt.changedTouches && evt.changedTouches.length > 0;
}
function getParentSVG(evt) {
  if (isNativeTouchEvent(evt.nativeEvent)) {
    return void 0;
  }
  const getParent = (target) => {
    if (target.nodeName === "svg") {
      return target;
    }
    return target.parentNode ? getParent(target.parentNode) : target;
  };
  return getParent(evt.target);
}
function getSVGEventCoordinates(evt, svg) {
  if (isNativeTouchEvent(evt.nativeEvent)) {
    return {
      x: evt.nativeEvent.locationX,
      y: evt.nativeEvent.locationY
    };
  }
  const location = isReactTouchEvent(evt) ? evt.changedTouches[0] : evt;
  const matrix = getTransformationMatrix(svg || getParentSVG(location));
  return {
    x: transformTarget(location.clientX, matrix, "x"),
    y: transformTarget(location.clientY, matrix, "y")
  };
}
var baseIteratee = _baseIteratee, baseUniq = _baseUniq;
function uniqBy(array2, iteratee) {
  return array2 && array2.length ? baseUniq(array2, baseIteratee(iteratee)) : [];
}
var uniqBy_1 = uniqBy;
const _uniqBy = /* @__PURE__ */ getDefaultExportFromCjs(uniqBy_1);
function getWidth2(props2, groupLength, seriesLength) {
  const {
    datasets,
    horizontal
  } = props2;
  const range2 = horizontal ? getRange$1(props2, "y") : getRange$1(props2, "x");
  const extent = Math.abs(range2[1] - range2[0]);
  const seriesLengthValue = seriesLength !== void 0 ? seriesLength : Array.isArray(datasets[0]) && datasets[0].length || 1;
  const groupLengthValue = groupLength || datasets.length;
  const bars = groupLengthValue * seriesLengthValue;
  const barRatio = 0.5;
  return Math.round(barRatio * extent / bars);
}
function getDefaultDomainPadding(props2, axis, childComponents) {
  if (props2.polar || axis !== "x") {
    return void 0;
  }
  const groupComponent = childComponents.filter((child) => {
    return child.type && child.type.role && child.type.role === "group";
  });
  if (groupComponent.length < 1) {
    return void 0;
  }
  const {
    offset: offset2,
    children: children2
  } = groupComponent[0].props;
  if (!offset2) {
    return void 0;
  }
  const firstChild = Array.isArray(children2) && children2[0];
  if (!firstChild) {
    return void 0;
  }
  let barWidth = firstChild.props.barWidth;
  let dataLength = firstChild.props.data && firstChild.props.data.length || 1;
  if (firstChild && firstChild.type.role === "stack") {
    const nestedChild = firstChild.props.children && firstChild.props.children[0];
    if (!nestedChild) {
      return void 0;
    }
    barWidth = nestedChild.props.barWidth;
    dataLength = firstChild.props.children.length;
  }
  const width = barWidth || getWidth2(props2, children2.length, dataLength);
  return {
    x: width * children2.length / 2 + (offset2 - width * ((children2.length - 1) / 2))
  };
}
function getDomainFromChildren(props2, axis, childComponents) {
  const children2 = childComponents ? childComponents.slice(0) : React__default.Children.toArray(props2.children);
  const parentData = props2.data ? getData(props2) : void 0;
  const {
    polar,
    startAngle,
    endAngle,
    categories,
    minDomain,
    maxDomain,
    horizontal
  } = props2;
  const baseParentProps = {
    horizontal,
    polar,
    startAngle,
    endAngle,
    minDomain,
    maxDomain,
    categories
  };
  const parentProps = parentData ? Object.assign(baseParentProps, {
    data: parentData
  }) : baseParentProps;
  const iteratee = (child) => {
    const sharedProps = Object.assign({}, child.props, parentProps);
    if (!isDomainComponent(child)) {
      return null;
    } else if (child.type && isFunction$1(child.type.getDomain)) {
      return child.props && child.type.getDomain(sharedProps, axis);
    }
    return getDomain$3(sharedProps, axis);
  };
  const childDomains = reduceChildren(children2, iteratee, props2);
  const min2 = childDomains.length === 0 ? 0 : getMinValue(childDomains);
  const max2 = childDomains.length === 0 ? 1 : getMaxValue(childDomains);
  return [min2, max2];
}
function getDomain$1(props2, axis, childComponents) {
  const children2 = childComponents || React__default.Children.toArray(props2.children);
  const propsDomain = getDomainFromProps(props2, axis);
  const domainPadding = getDefaultDomainPadding(props2, axis, children2);
  let domain;
  if (propsDomain) {
    domain = propsDomain;
  } else {
    const minDomain = getMinFromProps(props2, axis);
    const maxDomain = getMaxFromProps(props2, axis);
    const dataset = (props2.data || props2.y) && getData(props2);
    const dataDomain = dataset ? getDomainFromData$1(props2, axis, dataset) : [];
    const childDomain = getDomainFromChildren(props2, axis, children2);
    const min2 = minDomain || getMinValue([...dataDomain, ...childDomain]);
    const max2 = maxDomain || getMaxValue([...dataDomain, ...childDomain]);
    domain = getDomainFromMinMax(min2, max2);
  }
  return formatDomain(domain, Object.assign({
    domainPadding
  }, props2), axis);
}
function getScale$2(props2, axis, childComponents) {
  if (props2.data) {
    return getBaseScale(props2, axis);
  }
  const children2 = childComponents ? childComponents.slice(0) : React__default.Children.toArray(props2.children);
  const iteratee = (child) => {
    const sharedProps = Object.assign({}, child.props, {
      horizontal: props2.horizontal
    });
    return getScaleType(sharedProps, axis);
  };
  const childScale = _uniq(reduceChildren(children2, iteratee, props2));
  return childScale.length > 1 ? getScaleFromName("linear") : getScaleFromName(childScale[0]);
}
function getAllEvents(props2) {
  const components2 = ["groupComponent", "containerComponent", "labelComponent"];
  const componentEvents = getComponentEvents(props2, components2);
  let events = props2.events;
  if (Array.isArray(componentEvents)) {
    events = Array.isArray(props2.events) ? componentEvents.concat(...props2.events) : componentEvents;
  }
  return events || [];
}
function getStringsFromCategories(childComponents, axis) {
  const iteratee = (child) => {
    const childProps = child.props || {};
    if (!isDomainComponent(child) || !childProps.categories) {
      return null;
    }
    const categories = childProps.categories && !Array.isArray(childProps.categories) ? childProps.categories[axis] : childProps.props.categories;
    const categoryStrings = categories && categories.filter((val) => typeof val === "string");
    return categoryStrings ? removeUndefined(categoryStrings) : [];
  };
  return reduceChildren(childComponents.slice(0), iteratee);
}
function getStringsFromData(childComponents) {
  const iteratee = (child) => {
    const childProps = child.props || {};
    let data;
    if (!isDataComponent(child)) {
      return null;
    } else if (child.type && isFunction$1(child.type.getData)) {
      data = child.type.getData(childProps);
    } else {
      data = getData(childProps);
    }
    return data.map((d3) => ({
      x: d3.xName,
      y: d3.yName
    }));
  };
  const initialMemo = {
    x: [],
    y: []
  };
  const combine2 = (memo, datum) => {
    const x3 = Array.isArray(datum) ? datum.map((d3) => d3.x).filter(Boolean) : datum.x;
    const y4 = Array.isArray(datum) ? datum.map((d3) => d3.y).filter(Boolean) : datum.y;
    return {
      x: x3 !== void 0 ? memo.x.concat(x3) : memo.x,
      y: y4 !== void 0 ? memo.y.concat(y4) : memo.y
    };
  };
  return reduceChildren(childComponents.slice(0), iteratee, {}, initialMemo, combine2);
}
function getCategoryAndAxisStringsFromChildren(props2, axis, childComponents) {
  const categories = _isPlainObject(props2.categories) ? props2.categories[axis] : props2.categories;
  const axisComponent = getAxisComponent(childComponents, axis);
  const axisStrings = axisComponent ? getStringsFromAxes(axisComponent.props, axis) : [];
  const categoryStrings = categories || getStringsFromCategories(childComponents, axis);
  return _uniq([...categoryStrings, ...axisStrings].flat());
}
function getStringsFromChildren(props2, childComponents) {
  const children2 = childComponents || React__default.Children.toArray(props2.children);
  const xStrings = getCategoryAndAxisStringsFromChildren(props2, "x", children2);
  const yStrings = getCategoryAndAxisStringsFromChildren(props2, "y", children2);
  const dataStrings = getStringsFromData(children2);
  return {
    x: _uniq([...xStrings, ...dataStrings.x].flat()),
    y: _uniq([...yStrings, ...dataStrings.y].flat())
  };
}
function getCategories(props2, childComponents, allStrings) {
  const xPropCategories = props2.categories && !Array.isArray(props2.categories) ? props2.categories.x : props2.categories;
  const yPropCategories = props2.categories && !Array.isArray(props2.categories) ? props2.categories.y : props2.categories;
  const fallbackRequired = !xPropCategories || !yPropCategories;
  const fallbackProps2 = fallbackRequired ? allStrings || getStringsFromChildren(props2, childComponents) : {};
  const xCategories = xPropCategories || fallbackProps2.x;
  const yCategories = yPropCategories || fallbackProps2.y;
  return {
    x: xCategories.length > 0 ? xCategories : void 0,
    y: yCategories.length > 0 ? yCategories : void 0
  };
}
const getDataWithBaseline = (props2, scale) => {
  let data = getData(props2);
  if (data.length < 2) {
    data = [];
  }
  const getDefaultMin = (axis) => {
    const defaultZero = getType(scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
    const domain = scale[axis].domain();
    const minY = getMinValue(domain);
    const maxY = getMaxValue(domain);
    let defaultMin = defaultZero;
    if (minY < 0 && maxY <= 0) {
      defaultMin = maxY;
    } else if (minY >= 0 && maxY > 0) {
      defaultMin = minY;
    }
    return containsDates(domain) ? new Date(defaultMin) : defaultMin;
  };
  return data.map((datum) => {
    const _y1 = datum._y1 !== void 0 ? datum._y1 : datum._y;
    const _y0 = datum._y0 !== void 0 ? datum._y0 : getDefaultMin("y");
    const _x1 = datum._x1 !== void 0 ? datum._x1 : datum._x;
    const _x0 = datum._x0 !== void 0 ? datum._x0 : getDefaultMin("x");
    return Object.assign({}, datum, {
      _y0,
      _y1,
      _x0,
      _x1
    });
  });
};
const getCalculatedValues$4 = (props2) => {
  const {
    polar
  } = props2;
  const defaultStyles2 = getDefaultStyles(props2, "area");
  const style2 = getStyles$4(props2.style, defaultStyles2);
  const range2 = {
    x: getRange$1(props2, "x"),
    y: getRange$1(props2, "y")
  };
  const domain = {
    x: getDomainWithZero(props2, "x"),
    y: getDomainWithZero(props2, "y")
  };
  const scale = {
    x: getBaseScale(props2, "x").domain(domain.x).range(props2.horizontal ? range2.y : range2.x),
    y: getBaseScale(props2, "y").domain(domain.y).range(props2.horizontal ? range2.x : range2.y)
  };
  const origin = polar ? props2.origin || getPolarOrigin(props2) : void 0;
  const data = getDataWithBaseline(props2, scale);
  return {
    style: style2,
    data,
    scale,
    domain,
    origin
  };
};
const getBaseProps$4 = (initialProps, fallbackProps2) => {
  const modifiedProps = modifyProps$1(initialProps, fallbackProps2, "area");
  const props2 = Object.assign({}, modifiedProps, getCalculatedValues$4(modifiedProps));
  const {
    data,
    domain,
    events,
    groupComponent,
    height,
    horizontal,
    interpolation,
    origin,
    padding: padding2,
    polar,
    scale,
    sharedEvents,
    standalone,
    style: style2,
    theme: theme2,
    width,
    labels,
    name: name2,
    disableInlineStyles
  } = props2;
  const initialChildProps = {
    parent: {
      style: style2.parent,
      width,
      height,
      scale,
      data,
      domain,
      standalone,
      theme: theme2,
      polar,
      origin,
      padding: padding2,
      name: name2,
      horizontal
    },
    all: {
      data: {
        horizontal,
        polar,
        origin,
        scale,
        data,
        interpolation,
        groupComponent,
        style: disableInlineStyles ? {} : style2.data,
        disableInlineStyles
      }
    }
  };
  return data.reduce((childProps, datum, index2) => {
    const text2 = getText(props2, datum, index2);
    if (text2 !== void 0 && text2 !== null || labels && (events || sharedEvents)) {
      const eventKey = !isNil(datum.eventKey) ? datum.eventKey : index2;
      childProps[eventKey] = {
        labels: getProps(props2, index2)
      };
    }
    return childProps;
  }, initialChildProps);
};
const defined = (d3) => {
  const y4 = d3._y1 !== void 0 ? d3._y1 : d3._y;
  return y4 !== null && y4 !== void 0 && d3._y0 !== null;
};
const getXAccessor = (scale) => {
  return (d3) => scale.x(d3._x1 !== void 0 ? d3._x1 : d3._x);
};
const getYAccessor = (scale) => {
  return (d3) => scale.y(d3._y1 !== void 0 ? d3._y1 : d3._y);
};
const getY0Accessor = (scale) => {
  return (d3) => scale.y(d3._y0);
};
const getAngleAccessor = (scale) => {
  return (d3) => {
    const x3 = scale.x(d3._x1 !== void 0 ? d3._x1 : d3._x);
    return -1 * x3 + Math.PI / 2;
  };
};
const getCartesianArea = (props2) => {
  const {
    horizontal,
    scale
  } = props2;
  const interpolationFunction = getInterpolationFunction(props2);
  return horizontal ? area().defined(defined).curve(interpolationFunction).x0(getY0Accessor(scale)).x1(getYAccessor(scale)).y(getXAccessor(scale)) : area().defined(defined).curve(interpolationFunction).x(getXAccessor(scale)).y1(getYAccessor(scale)).y0(getY0Accessor(scale));
};
const getAreaFunction = (props2) => {
  const {
    polar,
    scale
  } = props2;
  const interpolationFunction = getInterpolationFunction(props2);
  return polar ? areaRadial().defined(defined).curve(interpolationFunction).angle(getAngleAccessor(scale)).outerRadius(getYAccessor(scale)).innerRadius(getY0Accessor(scale)) : getCartesianArea(props2);
};
const evaluateProps$3 = (props2) => {
  const ariaLabel = evaluateProp(props2.ariaLabel, props2);
  const desc = evaluateProp(props2.desc, props2);
  const id = evaluateProp(props2.id, props2);
  const style2 = evaluateStyle(Object.assign({
    fill: "black"
  }, props2.style), props2);
  const tabIndex = evaluateProp(props2.tabIndex, props2);
  return Object.assign({}, props2, {
    ariaLabel,
    desc,
    id,
    style: style2,
    tabIndex
  });
};
const defaultProps$4 = {
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null),
  pathComponent: /* @__PURE__ */ React__default.createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};
const Area = (initialProps) => {
  const props2 = evaluateProps$3(_defaults({}, initialProps, defaultProps$4));
  const {
    ariaLabel,
    role,
    shapeRendering,
    className,
    polar,
    origin,
    data,
    pathComponent,
    events,
    groupComponent,
    clipPath,
    id,
    style: style2,
    desc,
    tabIndex
  } = props2;
  const userProps = getSafeUserProps(props2);
  const defaultTransform = polar && origin ? `translate(${origin.x}, ${origin.y})` : void 0;
  const transform = props2.transform || defaultTransform;
  const renderLine = style2.stroke && style2.stroke !== "none" && style2.stroke !== "transparent";
  const areaFunction = getAreaFunction(props2);
  const lineFunction = renderLine && getLineFunction(props2);
  const areaStroke = style2.stroke ? "none" : style2.fill;
  const sharedProps = {
    "aria-label": ariaLabel,
    className,
    role,
    shapeRendering,
    transform,
    ...events,
    clipPath,
    tabIndex
  };
  const area2 = /* @__PURE__ */ React__default.cloneElement(pathComponent, Object.assign({
    key: `${id}-area`,
    style: Object.assign({}, style2, {
      stroke: areaStroke
    }),
    d: areaFunction(data),
    desc,
    tabIndex
  }, sharedProps, userProps));
  const line2 = renderLine ? /* @__PURE__ */ React__default.cloneElement(pathComponent, Object.assign({
    key: `${id}-area-stroke`,
    style: Object.assign({}, style2, {
      fill: "none"
    }),
    d: lineFunction(data)
  }, sharedProps)) : null;
  return renderLine ? /* @__PURE__ */ React__default.cloneElement(groupComponent, userProps, [area2, line2]) : area2;
};
const fallbackProps$7 = {
  width: 450,
  height: 300,
  padding: 50,
  interpolation: "linear"
};
const options$3 = {
  components: [{
    name: "parent",
    index: "parent"
  }, {
    name: "data",
    index: "all"
  }, {
    name: "labels"
  }]
};
const _VictoryAreaBase = class _VictoryAreaBase extends React__default.Component {
  static getBaseProps(props2) {
    return getBaseProps$4(props2, fallbackProps$7);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist,
      role
    } = _VictoryAreaBase;
    const props2 = modifyProps$1(this.props, fallbackProps$7, role);
    if (this.shouldAnimate()) {
      return this.animateComponent(props2, animationWhitelist);
    }
    const children2 = this.renderContinuousData(props2);
    const component = props2.standalone ? this.renderContainer(props2.containerComponent, children2) : children2;
    return withSafeUserProps(component, props2);
  }
};
__publicField(_VictoryAreaBase, "animationWhitelist", ["data", "domain", "height", "padding", "style", "width"]);
__publicField(_VictoryAreaBase, "defaultProps", {
  containerComponent: /* @__PURE__ */ React__default.createElement(VictoryContainer, null),
  dataComponent: /* @__PURE__ */ React__default.createElement(Area, null),
  groupComponent: /* @__PURE__ */ React__default.createElement(VictoryClipContainer, null),
  labelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, {
    renderInPortal: true
  }),
  samples: 50,
  sortKey: "x",
  sortOrder: "ascending",
  standalone: true,
  theme: VictoryTheme.grayscale
});
__publicField(_VictoryAreaBase, "displayName", "VictoryArea");
__publicField(_VictoryAreaBase, "role", "area");
__publicField(_VictoryAreaBase, "continuous", true);
__publicField(_VictoryAreaBase, "defaultTransitions", continuousTransitions());
__publicField(_VictoryAreaBase, "defaultPolarTransitions", continuousPolarTransitions());
__publicField(_VictoryAreaBase, "getDomain", getDomainWithZero);
__publicField(_VictoryAreaBase, "getData", getData);
__publicField(_VictoryAreaBase, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
let VictoryAreaBase = _VictoryAreaBase;
const VictoryArea = addEvents(VictoryAreaBase, options$3);
const orientationSign = {
  top: -1,
  left: -1,
  right: 1,
  bottom: 1
};
const exists = (val) => val !== null && val !== void 0;
const getCurrentAxis = (props2, axis) => {
  const {
    orientation,
    horizontal
  } = props2;
  if (orientation) {
    const dimensions = {
      top: "x",
      bottom: "x",
      left: "y",
      right: "y"
    };
    return dimensions[orientation];
  }
  const otherAxis = axis === "x" ? "y" : "x";
  return horizontal ? otherAxis : axis;
};
const getScale$1 = (props2) => {
  const axis = getAxis(props2);
  const currentAxis = getCurrentAxis(props2, axis);
  const scale = getBaseScale(props2, axis);
  const propsDomain = props2.domain && props2.domain[axis];
  const domain = propsDomain || getDomain$2(props2) || scale.domain();
  scale.range(getRange$1(props2, currentAxis));
  scale.domain(domain);
  return scale;
};
const getStyleObject$1 = (props2) => {
  const {
    theme: theme2,
    dependentAxis
  } = props2;
  const generalAxisStyle = theme2 && theme2.axis && theme2.axis.style;
  const axisType = dependentAxis ? "dependentAxis" : "independentAxis";
  const specificAxisStyle = theme2 && theme2[axisType] && theme2[axisType].style;
  const mergeStyles = () => {
    const styleNamespaces = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
    return styleNamespaces.reduce((memo, curr) => {
      memo[curr] = _defaults({}, specificAxisStyle[curr], generalAxisStyle[curr]);
      return memo;
    }, {});
  };
  return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};
const getStyles$2 = function(props2, styleObject) {
  if (styleObject === void 0) {
    styleObject = {};
  }
  const style2 = props2.style || {};
  const parentStyleProps = {
    height: "100%",
    width: "100%"
  };
  return {
    parent: _defaults(style2.parent, styleObject.parent, parentStyleProps),
    axis: _defaults({}, style2.axis, styleObject.axis),
    axisLabel: _defaults({}, style2.axisLabel, styleObject.axisLabel),
    grid: _defaults({}, style2.grid, styleObject.grid),
    ticks: _defaults({}, style2.ticks, styleObject.ticks),
    tickLabels: _defaults({}, style2.tickLabels, styleObject.tickLabels)
  };
};
const getTickProps$1 = (layout2, style2, datum) => {
  const {
    position: position2,
    transform
  } = layout2;
  return {
    x1: transform.x,
    y1: transform.y,
    x2: transform.x + position2.x2,
    y2: transform.y + position2.y2,
    style: style2,
    datum
  };
};
const getTickLabelProps$1 = (layout2, style2, anchors, datum, text2) => {
  const {
    position: position2,
    transform
  } = layout2;
  return {
    style: style2,
    x: transform.x + position2.x,
    y: transform.y + position2.y,
    verticalAnchor: anchors.verticalAnchor,
    textAnchor: anchors.textAnchor,
    angle: style2.angle,
    text: text2,
    datum
  };
};
const getGridProps$1 = (layout2, style2, datum) => {
  const {
    edge,
    transform
  } = layout2;
  return {
    x1: transform.x,
    y1: transform.y,
    x2: edge.x + transform.x,
    y2: edge.y + transform.y,
    style: style2,
    datum
  };
};
const getAxisProps$2 = (modifiedProps, calculatedValues, globalTransform) => {
  const {
    style: style2,
    padding: padding2,
    isVertical: isVertical2
  } = calculatedValues;
  const {
    width,
    height
  } = modifiedProps;
  return {
    style: style2.axis,
    x1: isVertical2 ? globalTransform.x : padding2.left + globalTransform.x,
    x2: isVertical2 ? globalTransform.x : width - padding2.right + globalTransform.x,
    y1: isVertical2 ? padding2.top + globalTransform.y : globalTransform.y,
    y2: isVertical2 ? height - padding2.bottom + globalTransform.y : globalTransform.y
  };
};
const getEvaluatedStyles$1 = (style2, props2) => {
  return {
    tickStyle: evaluateStyle(style2.ticks, props2),
    labelStyle: evaluateStyle(style2.tickLabels, props2),
    gridStyle: evaluateStyle(style2.grid, props2)
  };
};
const getAxisLabelProps$1 = (props2, calculatedValues, globalTransform) => {
  const {
    style: style2,
    orientation,
    padding: padding2,
    labelPadding,
    isVertical: isVertical2
  } = calculatedValues;
  const sign2 = orientationSign[orientation];
  const hPadding = padding2.left + padding2.right;
  const vPadding = padding2.top + padding2.bottom;
  const verticalAnchor = sign2 < 0 ? "end" : "start";
  const labelStyle = style2.axisLabel;
  const angle = isVertical2 ? -90 : 0;
  const x3 = isVertical2 ? globalTransform.x + sign2 * labelPadding : (props2.width - hPadding) / 2 + padding2.left + globalTransform.x;
  const y4 = isVertical2 ? (props2.height - vPadding) / 2 + padding2.top + globalTransform.y : sign2 * labelPadding + globalTransform.y;
  return {
    x: x3,
    y: y4,
    verticalAnchor: labelStyle.verticalAnchor || verticalAnchor,
    textAnchor: labelStyle.textAnchor || "middle",
    angle: labelStyle.angle === void 0 ? angle : labelStyle.angle,
    style: labelStyle,
    text: props2.label
  };
};
const getAnchors = (orientation, isVertical2) => {
  const anchorOrientation = {
    top: "end",
    left: "end",
    right: "start",
    bottom: "start"
  };
  const anchor = anchorOrientation[orientation];
  return {
    textAnchor: isVertical2 ? anchor : "middle",
    verticalAnchor: isVertical2 ? "middle" : anchor
  };
};
const getLabelPadding = (props2, style2) => {
  const labelStyle = style2.axisLabel || {};
  if (labelStyle.padding !== void 0 && labelStyle.padding !== null) {
    return labelStyle.padding;
  }
  const isVertical$1 = isVertical(props2);
  const fontSize2 = labelStyle.fontSize || 14;
  return props2.label ? fontSize2 * (isVertical$1 ? 2.3 : 1.6) : 0;
};
const getDefaultOrientations = (axis, originSign, horizontal) => {
  const sign2 = originSign || "positive";
  const orientations = {
    positive: {
      x: "bottom",
      y: "left"
    },
    negative: {
      x: "top",
      y: "right"
    }
  };
  const horizontalOrientations = {
    positive: {
      x: "left",
      y: "bottom"
    },
    negative: {
      x: "right",
      y: "top"
    }
  };
  return horizontal ? horizontalOrientations[sign2][axis] : orientations[sign2][axis];
};
const getStandaloneOffset = (props2, calculatedValues) => {
  const {
    style: style2,
    scale,
    orientation,
    padding: padding2,
    axis,
    ticks: ticks2,
    stringTicks: stringTicks2,
    isVertical: isVertical2,
    labelPadding
  } = calculatedValues;
  const {
    polar,
    horizontal
  } = props2;
  const sharedProps = {
    scale: {
      [axis]: scale
    },
    polar,
    horizontal,
    ticks: ticks2,
    stringTicks: stringTicks2
  };
  const xPadding = orientation === "right" ? padding2.right : padding2.left;
  const yPadding = orientation === "top" ? padding2.top : padding2.bottom;
  const offsetX = props2.offsetX !== null && props2.offsetX !== void 0 ? props2.offsetX : xPadding;
  const offsetY = props2.offsetY !== null && props2.offsetY !== void 0 ? props2.offsetY : yPadding;
  const fontSize2 = style2.axisLabel.fontSize || 14;
  const tickSizes = ticks2.map((data, index2) => {
    const tick = stringTicks2 ? props2.tickValues[data - 1] : data;
    const tickStyle = evaluateStyle(style2.ticks, Object.assign({}, sharedProps, {
      tick,
      index: index2
    }));
    return tickStyle.size || 0;
  });
  const totalPadding = fontSize2 + 2 * Math.max(...tickSizes) + labelPadding;
  const minimumPadding = 1.2 * fontSize2;
  const x3 = isVertical2 ? totalPadding : minimumPadding;
  const y4 = isVertical2 ? minimumPadding : totalPadding;
  return {
    x: offsetX !== null && offsetX !== void 0 ? offsetX : x3,
    y: offsetY !== null && offsetY !== void 0 ? offsetY : y4
  };
};
const isEqual$3 = (a4, b10) => {
  if (a4 instanceof Date && b10 instanceof Date) {
    return a4.getTime() === b10.getTime();
  }
  return a4 === b10;
};
const getOffset = (props2, calculatedValues) => {
  const {
    scale,
    origin,
    orientation,
    orientations,
    domain,
    padding: padding2
  } = calculatedValues;
  const {
    top: top2,
    bottom: bottom2,
    left: left2,
    right: right2
  } = padding2;
  const calculatedOrientation = {
    x: orientation === "bottom" || orientation === "top" ? orientation : orientations.x,
    y: orientation === "left" || orientation === "right" ? orientation : orientations.y
  };
  const orientationOffset = {
    x: calculatedOrientation.y === "left" ? left2 : right2,
    y: calculatedOrientation.x === "bottom" ? bottom2 : top2
  };
  const originOffset = {
    x: calculatedOrientation.y === "left" ? 0 : props2.width,
    y: calculatedOrientation.x === "bottom" ? props2.height : 0
  };
  const originPosition = {
    x: isEqual$3(origin.x, domain.x[0]) || isEqual$3(origin.x, domain.x[1]) ? 0 : scale.x(origin.x),
    y: isEqual$3(origin.y, domain.y[0]) || isEqual$3(origin.y, domain.y[1]) ? 0 : scale.y(origin.y)
  };
  const x3 = originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x;
  const y4 = originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y;
  const offsetX = exists(props2.offsetX) ? props2.offsetX : x3;
  const offsetY = exists(props2.offsetY) ? props2.offsetY : y4;
  return {
    x: offsetX,
    y: offsetY
  };
};
const getHorizontalOffset = (props2, calculatedValues) => {
  const {
    scale,
    origin,
    orientation,
    orientations,
    domain,
    padding: padding2
  } = calculatedValues;
  const {
    top: top2,
    bottom: bottom2,
    left: left2,
    right: right2
  } = padding2;
  const calculatedOrientation = {
    y: orientation === "bottom" || orientation === "top" ? orientation : orientations.x,
    x: orientation === "left" || orientation === "right" ? orientation : orientations.y
  };
  const orientationOffset = {
    x: calculatedOrientation.y === "bottom" ? bottom2 : top2,
    y: calculatedOrientation.x === "left" ? left2 : right2
  };
  const originOffset = {
    y: calculatedOrientation.x === "left" ? 0 : props2.width,
    x: calculatedOrientation.y === "bottom" ? props2.height : 0
  };
  const originPosition = {
    x: isEqual$3(origin.x, domain.x[0]) || isEqual$3(origin.x, domain.x[1]) ? 0 : scale.x(origin.x),
    y: isEqual$3(origin.y, domain.y[0]) || isEqual$3(origin.y, domain.y[1]) ? 0 : scale.y(origin.y)
  };
  const y4 = originPosition.x ? Math.abs(originOffset.x - originPosition.x) : orientationOffset.x;
  const x3 = originPosition.y ? Math.abs(originOffset.y - originPosition.y) : orientationOffset.y;
  const offsetX = exists(props2.offsetX) ? props2.offsetX : x3;
  const offsetY = exists(props2.offsetY) ? props2.offsetY : y4;
  return {
    x: offsetX,
    y: offsetY
  };
};
const getTransform = (props2, calculatedValues, offset2) => {
  const {
    orientation,
    axis
  } = calculatedValues;
  const axisValue = getAxisValue(props2, axis);
  return {
    top: {
      x: 0,
      y: axisValue !== void 0 ? axisValue : offset2.y
    },
    bottom: {
      x: 0,
      y: axisValue !== void 0 ? axisValue : props2.height - offset2.y
    },
    left: {
      x: axisValue !== void 0 ? axisValue : offset2.x,
      y: 0
    },
    right: {
      x: axisValue !== void 0 ? axisValue : props2.width - offset2.x,
      y: 0
    }
  }[orientation];
};
const getTickPosition = (style2, orientation, isVertical2) => {
  const {
    tickStyle,
    labelStyle
  } = style2;
  const size = tickStyle.size || 0;
  const tickPadding = tickStyle.padding || 0;
  const labelPadding = labelStyle.padding || 0;
  const tickSpacing = size + tickPadding + labelPadding;
  const sign2 = orientationSign[orientation];
  return {
    x: isVertical2 ? sign2 * tickSpacing : 0,
    x2: isVertical2 ? sign2 * size : 0,
    y: isVertical2 ? 0 : sign2 * tickSpacing,
    y2: isVertical2 ? 0 : sign2 * size
  };
};
const getTickTransform = (tick, globalTransform, isVertical2) => {
  return {
    x: isVertical2 ? globalTransform.x : tick + globalTransform.x,
    y: isVertical2 ? tick + globalTransform.y : globalTransform.y
  };
};
const getGridEdge = (props2, calculatedValues) => {
  const {
    orientation,
    padding: padding2,
    isVertical: isVertical2
  } = calculatedValues;
  const sign2 = -orientationSign[orientation];
  const x3 = isVertical2 ? sign2 * (props2.width - (padding2.left + padding2.right)) : 0;
  const y4 = isVertical2 ? 0 : sign2 * (props2.height - (padding2.top + padding2.bottom));
  return {
    x: x3,
    y: y4
  };
};
const getGridOffset = (calculatedValues, offset2) => {
  const {
    padding: padding2,
    orientation,
    crossAxis
  } = calculatedValues;
  const xPadding = orientation === "right" ? padding2.right : padding2.left;
  const yPadding = orientation === "top" ? padding2.top : padding2.bottom;
  return {
    x: crossAxis ? offset2.x - xPadding : 0,
    y: crossAxis ? offset2.y - yPadding : 0
  };
};
const getLayoutProps = (modifiedProps, calculatedValues) => {
  let offset2;
  if (calculatedValues.domain.x && calculatedValues.domain.y) {
    offset2 = modifiedProps.horizontal ? getHorizontalOffset(modifiedProps, calculatedValues) : getOffset(modifiedProps, calculatedValues);
  } else {
    offset2 = getStandaloneOffset(modifiedProps, calculatedValues);
  }
  return {
    globalTransform: getTransform(modifiedProps, calculatedValues, offset2),
    gridOffset: getGridOffset(calculatedValues, offset2),
    gridEdge: getGridEdge(modifiedProps, calculatedValues)
  };
};
const getOrientation = (props2) => {
  if (props2.orientation) {
    return props2.orientation;
  }
  const defaultOrientations = {
    dependent: props2.horizontal ? "bottom" : "left",
    independent: props2.horizontal ? "left" : "bottom"
  };
  return props2.dependentAxis ? defaultOrientations.dependent : defaultOrientations.independent;
};
const getCalculatedValues$3 = (props2) => {
  const defaultStyles2 = getStyleObject$1(props2);
  const style2 = getStyles$2(props2, defaultStyles2);
  const padding2 = getPadding$1(props2);
  const labelPadding = getLabelPadding(props2, style2);
  const stringTicks$1 = stringTicks(props2) ? props2.tickValues : void 0;
  const axis = getAxis(props2);
  const axisDomain = getDomain$2(props2);
  const axisScale = getScale$1(props2);
  const xAxisDomain = axis === "x" ? axisDomain : void 0;
  const yAxisDomain = axis === "y" ? axisDomain : void 0;
  const xAxisScale = axis === "x" ? axisScale : void 0;
  const yAxisScale = axis === "y" ? axisScale : void 0;
  const crossAxis = !(props2.crossAxis === false || props2.standalone === true);
  const ticks2 = getTicks(props2, axisScale, crossAxis);
  const tickFormat2 = getTickFormat(props2, axisScale);
  const range2 = {
    x: getRange$1(props2, "x"),
    y: getRange$1(props2, "y")
  };
  const domain = {
    x: props2.domain && props2.domain.x ? props2.domain.x : xAxisDomain,
    y: props2.domain && props2.domain.y ? props2.domain.y : yAxisDomain
  };
  const scale = {
    x: props2.domain && props2.domain.x ? getBaseScale(props2, "x").domain(props2.domain.x).range(props2.horizontal ? range2.y : range2.x) : xAxisScale,
    y: props2.domain && props2.domain.y ? getBaseScale(props2, "y").domain(props2.domain.y).range(props2.horizontal ? range2.x : range2.y) : yAxisScale
  };
  const origin = domain.x && domain.y ? getOrigin(domain) : void 0;
  const originSign = origin ? {
    x: getOriginSign(origin.x, domain.x),
    y: getOriginSign(origin.y, domain.y)
  } : void 0;
  const orientations = originSign ? {
    x: getDefaultOrientations("x", originSign.y, props2.horizontal),
    y: getDefaultOrientations("y", originSign.x, props2.horizontal)
  } : void 0;
  const orientation = orientations ? props2.orientation || orientations[axis] : getOrientation(props2);
  const isVertical$1 = isVertical(Object.assign({}, props2, {
    orientation
  }));
  const anchors = getAnchors(orientation, isVertical$1);
  return {
    anchors,
    axis,
    crossAxis,
    domain,
    isVertical: isVertical$1,
    labelPadding,
    orientation,
    orientations,
    origin,
    padding: padding2,
    scale,
    stringTicks: stringTicks$1,
    style: style2,
    tickFormat: tickFormat2,
    ticks: ticks2
  };
};
const getBaseProps$3 = (initialProps, fallbackProps2) => {
  const props2 = modifyProps(initialProps, fallbackProps2);
  const calculatedValues = getCalculatedValues$3(props2);
  const {
    axis,
    style: style2,
    orientation,
    isVertical: isVertical2,
    scale,
    ticks: ticks2,
    tickFormat: tickFormat2,
    anchors,
    domain,
    stringTicks: stringTicks2
  } = calculatedValues;
  const otherAxis = axis === "x" ? "y" : "x";
  const {
    width,
    height,
    standalone,
    theme: theme2,
    polar,
    padding: padding2,
    horizontal
  } = props2;
  const {
    globalTransform,
    gridOffset,
    gridEdge
  } = getLayoutProps(props2, calculatedValues);
  const sharedProps = {
    scale: {
      [axis]: scale[axis]
    },
    polar,
    horizontal,
    ticks: ticks2,
    stringTicks: stringTicks2
  };
  const axisProps = getAxisProps$2(props2, calculatedValues, globalTransform);
  const axisLabelProps = getAxisLabelProps$1(props2, calculatedValues, globalTransform);
  const initialChildProps = {
    parent: Object.assign({
      style: style2.parent,
      ticks: ticks2,
      standalone,
      theme: theme2,
      width,
      height,
      padding: padding2,
      domain
    }, sharedProps)
  };
  const gridProps = {
    dimension: otherAxis,
    range: {
      [otherAxis]: getRange$1(props2, otherAxis)
    },
    scale: props2.scale && props2.scale[otherAxis] ? {
      [otherAxis]: props2.scale[otherAxis]
    } : void 0
  };
  return ticks2.reduce((childProps, tickValue, index2) => {
    var _a2, _b, _c;
    const tick = stringTicks2 ? stringTicks2[index2] : tickValue;
    const text2 = tickFormat2(tickValue, index2, ticks2);
    const styles2 = getEvaluatedStyles$1(style2, Object.assign({}, sharedProps, {
      tick,
      tickValue,
      index: index2,
      text: text2
    }));
    const tickLayout = {
      position: getTickPosition(styles2, orientation, isVertical2),
      transform: getTickTransform((_a2 = scale[axis]) == null ? void 0 : _a2.call(scale, tickValue), globalTransform, isVertical2)
    };
    const gridLayout = {
      edge: gridEdge,
      transform: {
        x: isVertical2 ? -gridOffset.x + globalTransform.x : ((_b = scale[axis]) == null ? void 0 : _b.call(scale, tickValue)) + globalTransform.x,
        y: isVertical2 ? ((_c = scale[axis]) == null ? void 0 : _c.call(scale, tickValue)) + globalTransform.y : gridOffset.y + globalTransform.y
      }
    };
    childProps[index2] = {
      axis: Object.assign({
        dimension: axis
      }, sharedProps, axisProps),
      axisLabel: Object.assign({}, sharedProps, axisLabelProps),
      ticks: Object.assign({}, sharedProps, getTickProps$1(tickLayout, styles2.tickStyle, tickValue)),
      tickLabels: Object.assign({}, sharedProps, getTickLabelProps$1(tickLayout, styles2.labelStyle, anchors, tickValue, text2)),
      grid: Object.assign({}, sharedProps, gridProps, getGridProps$1(gridLayout, styles2.gridStyle, tickValue))
    };
    return childProps;
  }, initialChildProps);
};
const fallbackProps$6 = {
  width: 450,
  height: 300,
  padding: 50
};
const options$2 = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
};
class VictoryAxisBase extends React__default.Component {
  static getStyles(props2) {
    return getStyles$2(props2);
  }
  static getBaseProps(props2) {
    return getBaseProps$3(props2, fallbackProps$6);
  }
  renderLine(props2) {
    const {
      axisComponent
    } = props2;
    const axisProps = this.getComponentProps(axisComponent, "axis", 0);
    return /* @__PURE__ */ React__default.cloneElement(axisComponent, axisProps);
  }
  renderLabel(props2) {
    const {
      axisLabelComponent,
      label: label2
    } = props2;
    if (!label2) {
      return null;
    }
    const axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
    return /* @__PURE__ */ React__default.cloneElement(axisLabelComponent, axisLabelProps);
  }
  renderGridAndTicks(props2) {
    const {
      tickComponent,
      tickLabelComponent,
      gridComponent,
      name: name2
    } = props2;
    const shouldRender = (componentProps) => {
      const {
        style: style2 = {},
        events = {}
      } = componentProps;
      const visible = style2.stroke !== "transparent" && style2.stroke !== "none" && style2.strokeWidth !== 0;
      return visible || !_isEmpty(events);
    };
    return this.dataKeys.map((key, index2) => {
      const tickProps = this.getComponentProps(tickComponent, "ticks", index2);
      const BaseTickComponent = /* @__PURE__ */ React__default.cloneElement(tickComponent, tickProps);
      const TickComponent = shouldRender(BaseTickComponent.props) ? BaseTickComponent : void 0;
      const gridProps = this.getComponentProps(gridComponent, "grid", index2);
      const BaseGridComponent = /* @__PURE__ */ React__default.cloneElement(gridComponent, gridProps);
      const GridComponent = shouldRender(BaseGridComponent.props) ? BaseGridComponent : void 0;
      const tickLabelProps = this.getComponentProps(tickLabelComponent, "tickLabels", index2);
      const TickLabel = /* @__PURE__ */ React__default.cloneElement(tickLabelComponent, tickLabelProps);
      const children2 = [GridComponent, TickComponent, TickLabel].filter(Boolean);
      return /* @__PURE__ */ React__default.cloneElement(props2.groupComponent, {
        key: `${name2}-tick-group-${key}`
      }, children2);
    });
  }
  fixLabelOverlap(gridAndTicks, props2) {
    const isVertical$1 = isVertical(props2);
    const size = isVertical$1 ? props2.height : props2.width;
    const isVictoryLabel = (child) => child.type && child.type.role === "label";
    const labels = gridAndTicks.map((gridAndTick) => gridAndTick.props.children).reduce((accumulator, childArr) => accumulator.concat(childArr), []).filter(isVictoryLabel).map((child) => child.props);
    const paddingToObject = (padding2) => typeof padding2 === "object" ? Object.assign({}, {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }, padding2) : {
      top: padding2,
      right: padding2,
      bottom: padding2,
      left: padding2
    };
    const labelsSumSize = labels.reduce((sum2, label2) => {
      const padding2 = paddingToObject(label2.style.padding);
      const labelSize = approximateTextSize(label2.text, {
        angle: label2.angle,
        fontSize: label2.style.fontSize,
        letterSpacing: label2.style.letterSpacing,
        fontFamily: label2.style.fontFamily
      });
      return sum2 + (isVertical$1 ? labelSize.height + padding2.top + padding2.bottom : labelSize.width + padding2.right + padding2.left);
    }, 0);
    const availiableLabelCount = Math.floor(size * gridAndTicks.length / labelsSumSize);
    const divider2 = Math.ceil(gridAndTicks.length / availiableLabelCount) || 1;
    const getLabelCoord = (gridAndTick) => gridAndTick.props.children.filter(isVictoryLabel).reduce((prev2, child) => (isVertical$1 ? child.props.y : child.props.x) || 0, 0);
    const sorted = gridAndTicks.sort(
      (a4, b10) => isVertical$1 ? getLabelCoord(b10) - getLabelCoord(a4) : getLabelCoord(a4) - getLabelCoord(b10)
      // ordinary axis has left-right orientation
    );
    return sorted.filter((gridAndTick, index2) => index2 % divider2 === 0);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist
    } = VictoryAxis;
    const props2 = modifyProps(this.props, fallbackProps$6);
    const userProps = getSafeUserProps(this.props);
    if (this.shouldAnimate()) {
      return this.animateComponent(props2, animationWhitelist);
    }
    const gridAndTicks = this.renderGridAndTicks(props2);
    const modifiedGridAndTicks = props2.fixLabelOverlap ? this.fixLabelOverlap(gridAndTicks, props2) : gridAndTicks;
    const children2 = [this.renderLine(props2), this.renderLabel(props2), ...modifiedGridAndTicks];
    const container2 = /* @__PURE__ */ React__default.cloneElement(props2.containerComponent, userProps);
    return props2.standalone ? this.renderContainer(container2, children2) : /* @__PURE__ */ React__default.cloneElement(props2.groupComponent, userProps, children2);
  }
}
__publicField(VictoryAxisBase, "animationWhitelist", ["style", "domain", "range", "tickCount", "tickValues", "offsetX", "offsetY", "padding", "width", "height"]);
__publicField(VictoryAxisBase, "displayName", "VictoryAxis");
__publicField(VictoryAxisBase, "role", "axis");
__publicField(VictoryAxisBase, "defaultTransitions", {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
});
__publicField(VictoryAxisBase, "defaultProps", {
  axisComponent: /* @__PURE__ */ React__default.createElement(LineSegment, null),
  axisLabelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, null),
  tickLabelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, null),
  tickComponent: /* @__PURE__ */ React__default.createElement(LineSegment, null),
  gridComponent: /* @__PURE__ */ React__default.createElement(LineSegment, null),
  standalone: true,
  theme: VictoryTheme.grayscale,
  containerComponent: /* @__PURE__ */ React__default.createElement(VictoryContainer, null),
  groupComponent: /* @__PURE__ */ React__default.createElement("g", {
    role: "presentation"
  }),
  fixLabelOverlap: false
});
__publicField(VictoryAxisBase, "getDomain", getDomain$2);
__publicField(VictoryAxisBase, "getAxis", getAxis);
__publicField(VictoryAxisBase, "expectedComponents", ["axisComponent", "axisLabelComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent"]);
const VictoryAxis = addEvents(VictoryAxisBase, options$2);
const getBarPosition = (props2, datum) => {
  const getDefaultMin = (axis) => {
    const defaultZero = getType(props2.scale[axis]) === "log" ? 1 / Number.MAX_SAFE_INTEGER : 0;
    let defaultMin = defaultZero;
    const minY = getMinValue(props2.domain[axis]);
    const maxY = getMaxValue(props2.domain[axis]);
    if (minY < 0 && maxY <= 0) {
      defaultMin = maxY;
    } else if (minY >= 0 && maxY > 0) {
      defaultMin = minY;
    }
    return datum[`_${axis}`] instanceof Date ? new Date(defaultMin) : defaultMin;
  };
  const _y0 = datum._y0 !== void 0 ? datum._y0 : getDefaultMin("y");
  const _x0 = datum._x0 !== void 0 ? datum._x0 : getDefaultMin("x");
  return scalePoint(props2, Object.assign({}, datum, {
    _y0,
    _x0
  }));
};
const getCalculatedValues$2 = (props2) => {
  const {
    polar
  } = props2;
  const defaultStyles2 = getDefaultStyles(props2, "bar");
  const style2 = !props2.disableInlineStyles ? getStyles$4(props2.style, defaultStyles2) : {};
  const range2 = props2.range || {
    x: getRange$1(props2, "x"),
    y: getRange$1(props2, "y")
  };
  const domain = {
    x: getDomainWithZero(props2, "x"),
    y: getDomainWithZero(props2, "y")
  };
  const scale = {
    x: getBaseScale(props2, "x").domain(domain.x).range(props2.horizontal ? range2.y : range2.x),
    y: getBaseScale(props2, "y").domain(domain.y).range(props2.horizontal ? range2.x : range2.y)
  };
  const origin = polar ? props2.origin || getPolarOrigin(props2) : void 0;
  let data = getData(props2);
  data = formatDataFromDomain(data, domain, 0);
  return {
    style: style2,
    data,
    scale,
    domain,
    origin
  };
};
const getBaseProps$2 = (initialProps, fallbackProps2) => {
  const modifiedProps = modifyProps$1(initialProps, fallbackProps2, "bar");
  const props2 = Object.assign({}, modifiedProps, getCalculatedValues$2(modifiedProps));
  const {
    alignment,
    barRatio,
    cornerRadius,
    data,
    disableInlineStyles,
    domain,
    events,
    height,
    horizontal,
    origin,
    padding: padding2,
    polar,
    scale,
    sharedEvents,
    standalone,
    style: style2,
    theme: theme2,
    width,
    labels,
    name: name2,
    barWidth,
    getPath
  } = props2;
  const initialChildProps = {
    parent: {
      horizontal,
      domain,
      scale,
      width,
      height,
      data,
      standalone,
      name: name2,
      theme: theme2,
      polar,
      origin,
      padding: padding2,
      style: style2.parent
    }
  };
  return data.reduce((childProps, datum, index2) => {
    const eventKey = !isNil(datum.eventKey) ? datum.eventKey : index2;
    const {
      x: x3,
      y: y4,
      y0,
      x0
    } = getBarPosition(props2, datum);
    const dataProps = {
      alignment,
      barRatio,
      barWidth,
      cornerRadius,
      data,
      datum,
      disableInlineStyles,
      getPath,
      horizontal,
      index: index2,
      polar,
      origin,
      scale,
      style: style2.data,
      width,
      height,
      x: x3,
      y: y4,
      y0,
      x0
    };
    childProps[eventKey] = {
      data: dataProps
    };
    const text2 = getText(props2, datum, index2);
    if (text2 !== void 0 && text2 !== null || labels && (events || sharedEvents)) {
      childProps[eventKey].labels = getProps(props2, index2);
    }
    return childProps;
  }, initialChildProps);
};
const DEFAULT_BAR_WIDTH = 8;
const getBarWidth = (barWidth, props2) => {
  const {
    scale,
    data,
    style: style2
  } = props2;
  if (barWidth) {
    return evaluateProp(barWidth, props2);
  } else if (style2.width) {
    return style2.width;
  }
  const range2 = scale.x.range();
  const extent = Math.abs(range2[1] - range2[0]);
  const bars = data.length + 2;
  const barRatio = props2.barRatio || 0.5;
  const defaultWidth = barRatio * (data.length < 2 ? DEFAULT_BAR_WIDTH : extent / bars);
  return Math.max(1, defaultWidth);
};
const getCornerRadiusFromObject = (cornerRadius, props2) => {
  const realCornerRadius = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };
  const updateCornerRadius = (corner, fallback) => {
    if (!isNil(cornerRadius[corner])) {
      realCornerRadius[corner] = evaluateProp(cornerRadius[corner], props2);
    } else if (!isNil(cornerRadius[fallback])) {
      realCornerRadius[corner] = evaluateProp(cornerRadius[fallback], props2);
    }
  };
  updateCornerRadius("topLeft", "top");
  updateCornerRadius("topRight", "top");
  updateCornerRadius("bottomLeft", "bottom");
  updateCornerRadius("bottomRight", "bottom");
  return realCornerRadius;
};
function isCornerRadiusObject(cornerRadius) {
  return _isPlainObject(cornerRadius);
}
const getCornerRadius = (cornerRadius, props2) => {
  const realCornerRadius = {
    topLeft: 0,
    topRight: 0,
    bottomLeft: 0,
    bottomRight: 0
  };
  if (!cornerRadius) {
    return realCornerRadius;
  }
  if (isCornerRadiusObject(cornerRadius)) {
    return getCornerRadiusFromObject(cornerRadius, props2);
  }
  realCornerRadius.topLeft = evaluateProp(cornerRadius, props2);
  realCornerRadius.topRight = evaluateProp(cornerRadius, props2);
  return realCornerRadius;
};
const getStyle = function(style2, props2) {
  if (style2 === void 0) {
    style2 = {};
  }
  if (props2.disableInlineStyles) {
    return {};
  }
  const stroke = style2.fill || "black";
  const baseStyle2 = {
    fill: "black",
    stroke
  };
  return evaluateStyle(Object.assign(baseStyle2, style2), props2);
};
const point = (x3, y4) => ({
  x: x3,
  y: y4,
  distance(p1) {
    return Math.sqrt(Math.pow(this.x - p1.x, 2) + Math.pow(this.y - p1.y, 2));
  },
  // vector addition in 2d plane
  add(p1) {
    return point(this.x + p1.x, this.y + p1.y);
  },
  // vector subtraction in 2d
  // returns p0 - p1
  subtract(p1) {
    return point(this.x - p1.x, this.y - p1.y);
  },
  // multiply a 2d point by a scalar
  scalarMult(n) {
    return point(this.x * n, this.y * n);
  },
  scalarDivide(n) {
    if (n === 0) {
      throw new Error("Division by 0 error");
    }
    return point(this.x / n, this.y / n);
  },
  equals(p1) {
    return this.x === p1.x && this.y === p1.y;
  }
});
const circle = (center, radius) => ({
  center,
  radius,
  hasIntersection(circle1) {
    const P0 = this.center;
    const P1 = circle1.center;
    const r0 = this.radius;
    const r1 = circle1.radius;
    const d3 = P0.distance(P1);
    if (d3 > r0 + r1) {
      return false;
    }
    if (d3 < Math.abs(r0 - r1)) {
      return false;
    }
    return true;
  },
  equals(circle1) {
    const P0 = this.center;
    const P1 = circle1.center;
    const r0 = this.radius;
    const r1 = circle1.radius;
    return r0 === r1 && P0.equals(P1);
  },
  // Source: http://paulbourke.net/geometry/circlesphere/
  // "Intersection of two circles" by Paul Bourke
  // Left-most point is returned as 0th element of array
  // Right-most point is returned as 1st elemennt of array
  intersection(circle1) {
    const P0 = this.center;
    const P1 = circle1.center;
    const r0 = this.radius;
    const r1 = circle1.radius;
    const d3 = P0.distance(P1);
    if (!this.hasIntersection(circle1) || this.equals(circle1)) {
      return [];
    }
    const a4 = (Math.pow(r0, 2) - Math.pow(r1, 2) + Math.pow(d3, 2)) / (2 * d3);
    const h3 = Math.sqrt(Math.pow(r0, 2) - Math.pow(a4, 2));
    const P2 = P0.add(P1.subtract(P0).scalarMult(a4).scalarDivide(d3));
    const {
      x: x0,
      y: y0
    } = P0;
    const {
      x: x1,
      y: y1
    } = P1;
    const {
      x: x22,
      y: y22
    } = P2;
    const P3s = [point(x22 - h3 * (y1 - y0) / d3, y22 + h3 * (x1 - x0) / d3), point(x22 + h3 * (y1 - y0) / d3, y22 - h3 * (x1 - x0) / d3)];
    P3s.sort((Point1, Point2) => Point1.x - Point2.x);
    return P3s;
  },
  solveX(y4) {
    const sqrt2 = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(y4 - this.center.y, 2));
    return [this.center.x - sqrt2, this.center.x + sqrt2];
  },
  solveY(x3) {
    const sqrt2 = Math.sqrt(Math.pow(this.radius, 2) - Math.pow(x3 - this.center.x, 2));
    return [this.center.y - sqrt2, this.center.y + sqrt2];
  }
});
const getPosition$1 = (props2, width) => {
  const {
    x: x3,
    x0,
    y: y4,
    y0,
    horizontal
  } = props2;
  const alignment = props2.alignment || "middle";
  const size = alignment === "middle" ? width / 2 : width;
  const sign2 = horizontal ? -1 : 1;
  if (horizontal) {
    return {
      x0,
      x1: x3,
      y0: alignment === "start" ? y4 : y4 - sign2 * size,
      y1: alignment === "end" ? y4 : y4 + sign2 * size
    };
  }
  return {
    x0: alignment === "start" ? x3 : x3 - sign2 * size,
    x1: alignment === "end" ? x3 : x3 + sign2 * size,
    y0,
    y1: y4
  };
};
const getAngle = (props2, index2) => {
  const {
    data,
    scale
  } = props2;
  const x3 = data[index2]._x1 === void 0 ? "_x" : "_x1";
  return scale.x(data[index2][x3]);
};
const getAngularWidth = (props2, width) => {
  const {
    scale
  } = props2;
  const range2 = scale.y.range();
  const r = Math.max(...range2);
  const angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
  return width / (2 * Math.PI * r) * angularRange;
};
const transformAngle = (angle) => {
  return -1 * angle + Math.PI / 2;
};
const getCustomBarPath = (props2, width) => {
  const {
    getPath
  } = props2;
  if (typeof getPath === "function") {
    const propsWithCalculatedValues = {
      ...props2,
      ...getPosition$1(props2, width)
    };
    return getPath(propsWithCalculatedValues);
  }
};
const getStartAngle = (props2, index2) => {
  const {
    data,
    scale,
    alignment
  } = props2;
  const currentAngle = getAngle(props2, index2);
  const angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
  const previousAngle = index2 === 0 ? getAngle(props2, data.length - 1) - Math.PI * 2 : getAngle(props2, index2 - 1);
  if (index2 === 0 && angularRange < 2 * Math.PI) {
    return scale.x.range()[0];
  } else if (alignment === "start" || alignment === "end") {
    return alignment === "start" ? previousAngle : currentAngle;
  }
  return (currentAngle + previousAngle) / 2;
};
const getEndAngle = (props2, index2) => {
  const {
    data,
    scale,
    alignment
  } = props2;
  const currentAngle = getAngle(props2, index2);
  const angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
  const lastAngle = scale.x.range()[1] === 2 * Math.PI ? getAngle(props2, 0) + Math.PI * 2 : scale.x.range()[1];
  const nextAngle = index2 === data.length - 1 ? getAngle(props2, 0) + Math.PI * 2 : getAngle(props2, index2 + 1);
  if (index2 === data.length - 1 && angularRange < 2 * Math.PI) {
    return lastAngle;
  } else if (alignment === "start" || alignment === "end") {
    return alignment === "start" ? currentAngle : nextAngle;
  }
  return (currentAngle + nextAngle) / 2;
};
const mapPointsToPath = (coords, cornerRadius, direction) => {
  const topLeftPath = `${cornerRadius.topLeft} ${cornerRadius.topLeft} ${direction}`;
  const topRightPath = `${cornerRadius.topRight} ${cornerRadius.topRight} ${direction}`;
  const bottomLeftPath = `${cornerRadius.bottomLeft} ${cornerRadius.bottomLeft} ${direction}`;
  const bottomRightPath = `${cornerRadius.bottomRight} ${cornerRadius.bottomRight} ${direction}`;
  const commands = ["M", `A ${bottomLeftPath},`, "L", `A ${topLeftPath},`, "L", `A ${topRightPath},`, "L", `A ${bottomRightPath},`];
  const path2 = commands.reduce((acc, command, i2) => `${acc}${command} ${coords[i2].x}, ${coords[i2].y} 
`, "");
  return `${path2} z`;
};
const getVerticalBarPoints = (position2, sign2, cr) => {
  const {
    x0,
    x1,
    y0,
    y1
  } = position2;
  const getHalfPoints = (side) => {
    const isLeft = side === "Left";
    const signL = isLeft ? 1 : -1;
    const x3 = isLeft ? x0 : x1;
    let bottomPoint = {
      x: x3 + signL * cr[`bottom${side}`],
      y: y0
    };
    let bottomMiddlePoint = {
      x: x3,
      y: y0 - sign2 * cr[`bottom${side}`]
    };
    let topMiddlePoint = {
      x: x3,
      y: y1 + sign2 * cr[`top${side}`]
    };
    let topPoint = {
      x: x3 + signL * cr[`top${side}`],
      y: y1
    };
    const hasIntersection = sign2 === 1 ? y0 - cr[`bottom${side}`] < y1 + cr[`top${side}`] : y0 + cr[`bottom${side}`] > y1 - cr[`top${side}`];
    if (hasIntersection) {
      const topCenter = point(x3 + signL * cr[`top${side}`], y1 + sign2 * cr[`top${side}`]);
      const topCircle = circle(topCenter, cr[`top${side}`]);
      const bottomCenter = point(x3 + signL * cr[`bottom${side}`], y0 - sign2 * cr[`bottom${side}`]);
      const bottomCircle = circle(bottomCenter, cr[`bottom${side}`]);
      const circleIntersection = topCircle.intersection(bottomCircle);
      const hasArcIntersection = circleIntersection.length > 0;
      if (hasArcIntersection) {
        const arcIntersection = circleIntersection[isLeft ? 0 : 1];
        bottomMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
        topMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
      } else {
        const hasBottomLineTopArcIntersection = cr[`top${side}`] > cr[`bottom${side}`];
        if (hasBottomLineTopArcIntersection) {
          const newX = topCircle.solveX(y0)[isLeft ? 0 : 1];
          bottomPoint = {
            x: newX,
            y: y0
          };
          bottomMiddlePoint = {
            x: newX,
            y: y0
          };
          topMiddlePoint = {
            x: newX,
            y: y0
          };
        } else {
          const newX = bottomCircle.solveX(y1)[isLeft ? 0 : 1];
          bottomMiddlePoint = {
            x: newX,
            y: y1
          };
          topMiddlePoint = {
            x: newX,
            y: y1
          };
          topPoint = {
            x: newX,
            y: y1
          };
        }
      }
    }
    const points = [bottomPoint, bottomMiddlePoint, topMiddlePoint, topPoint];
    return isLeft ? points : points.reverse();
  };
  return getHalfPoints("Left").concat(getHalfPoints("Right"));
};
const getHorizontalBarPoints = (position2, sign2, cr) => {
  const {
    y0,
    y1
  } = position2;
  const x0 = position2.x0 < position2.x1 ? position2.x0 : position2.x1;
  const x1 = position2.x0 < position2.x1 ? position2.x1 : position2.x0;
  const getHalfPoints = (side) => {
    const isTop = side === "top";
    const signL = isTop ? -1 : 1;
    const y4 = isTop ? y1 : y0;
    let leftPoint = {
      x: x0,
      y: y4 - signL * cr[`${side}Left`]
    };
    let leftMiddlePoint = {
      x: x0 + cr[`${side}Left`],
      y: y4
    };
    let rightMiddlePoint = {
      x: x1 - cr[`${side}Right`],
      y: y4
    };
    let rightPoint = {
      x: x1,
      y: y4 - signL * cr[`${side}Right`]
    };
    const hasIntersection = leftMiddlePoint.x > rightMiddlePoint.x;
    if (hasIntersection) {
      const leftCenter = point(x0 + cr[`${side}Left`], y4 - signL * cr[`${side}Left`]);
      const leftCircle = circle(leftCenter, cr[`${side}Left`]);
      const rightCenter = point(x1 - cr[`${side}Right`], y4 - signL * cr[`${side}Right`]);
      const rightCircle = circle(rightCenter, cr[`${side}Right`]);
      const circleIntersection = leftCircle.intersection(rightCircle);
      const hasArcIntersection = circleIntersection.length > 0;
      if (hasArcIntersection) {
        const arcIntersection = circleIntersection[sign2 > 0 ? 1 : 0];
        leftMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
        rightMiddlePoint = {
          x: arcIntersection.x,
          y: arcIntersection.y
        };
      } else {
        const hasLeftLineRightArcIntersection = cr[`${side}Right`] > cr[`${side}Left`];
        if (hasLeftLineRightArcIntersection) {
          const newY = rightCircle.solveY(x0)[isTop ? 0 : 1];
          leftPoint = {
            x: x0,
            y: newY
          };
          leftMiddlePoint = {
            x: x0,
            y: newY
          };
          rightMiddlePoint = {
            x: x0,
            y: newY
          };
        } else {
          const newY = leftCircle.solveY(x1)[isTop ? 0 : 1];
          rightPoint = {
            x: x1,
            y: newY
          };
          rightMiddlePoint = {
            x: x1,
            y: newY
          };
          leftMiddlePoint = {
            x: x1,
            y: newY
          };
        }
      }
    }
    return [leftPoint, leftMiddlePoint, rightMiddlePoint, rightPoint];
  };
  const topPoints = getHalfPoints("top");
  const bottomPoints = getHalfPoints("bottom");
  return [
    bottomPoints[1],
    bottomPoints[0],
    ...topPoints,
    // eslint-disable-next-line no-magic-numbers
    bottomPoints[3],
    bottomPoints[2]
  ];
};
const getVerticalBarPath = (props2, width, cornerRadius) => {
  const position2 = getPosition$1(props2, width);
  const sign2 = position2.y0 > position2.y1 ? 1 : -1;
  const direction = sign2 > 0 ? "0 0 1" : "0 0 0";
  const points = getVerticalBarPoints(position2, sign2, cornerRadius);
  return mapPointsToPath(points, cornerRadius, direction);
};
const getHorizontalBarPath = (props2, width, cornerRadius) => {
  const position2 = getPosition$1(props2, width);
  const sign2 = position2.x0 < position2.x1 ? 1 : -1;
  const direction = "0 0 1";
  const cr = {
    topRight: sign2 > 0 ? cornerRadius.topLeft : cornerRadius.bottomLeft,
    bottomRight: sign2 > 0 ? cornerRadius.topRight : cornerRadius.bottomRight,
    bottomLeft: sign2 > 0 ? cornerRadius.bottomRight : cornerRadius.topRight,
    topLeft: sign2 > 0 ? cornerRadius.bottomLeft : cornerRadius.topLeft
  };
  const points = getHorizontalBarPoints(position2, sign2, cr);
  return mapPointsToPath(points, cr, direction);
};
const getVerticalPolarBarPath = (props2, cornerRadius) => {
  const {
    datum,
    scale,
    index: index2,
    alignment,
    style: style2
  } = props2;
  const r1 = scale.y(datum._y0 || 0);
  const r2 = scale.y(datum._y1 !== void 0 ? datum._y1 : datum._y);
  const currentAngle = scale.x(datum._x1 !== void 0 ? datum._x1 : datum._x);
  let start2;
  let end2;
  if (style2.width) {
    const width = getAngularWidth(props2, style2.width);
    const size = alignment === "middle" ? width / 2 : width;
    start2 = alignment === "start" ? currentAngle : currentAngle - size;
    end2 = alignment === "end" ? currentAngle : currentAngle + size;
  } else {
    start2 = getStartAngle(props2, Number(index2));
    end2 = getEndAngle(props2, Number(index2));
  }
  const getPath = (edge) => {
    const pathFunction = arc().innerRadius(r1).outerRadius(r2).startAngle(transformAngle(start2)).endAngle(transformAngle(end2)).cornerRadius(cornerRadius[edge]);
    return pathFunction();
  };
  const getPathData = (edge) => {
    const rightPath = getPath(`${edge}Right`);
    const rightMoves = rightPath.match(/[A-Z]/g) || [];
    const rightCoords = rightPath.split(/[A-Z]/).slice(1);
    const rightMiddle = rightMoves.indexOf("L");
    const leftPath = getPath(`${edge}Left`);
    const leftMoves = leftPath.match(/[A-Z]/g) || [];
    const leftCoords = leftPath.split(/[A-Z]/).slice(1);
    const leftMiddle = leftMoves.indexOf("L");
    return {
      rightMoves,
      rightCoords,
      rightMiddle,
      leftMoves,
      leftCoords,
      leftMiddle
    };
  };
  const getTopPath = () => {
    const {
      topRight,
      topLeft
    } = cornerRadius;
    const arcLength = r2 * Math.abs(end2 - start2);
    const {
      rightMoves,
      rightCoords,
      rightMiddle,
      leftMoves,
      leftCoords,
      leftMiddle
    } = getPathData("top");
    let moves2;
    let coords;
    if (topRight === topLeft || arcLength < 2 * topRight + 2 * topLeft) {
      moves2 = topRight > topLeft ? rightMoves : leftMoves;
      coords = topRight > topLeft ? rightCoords : leftCoords;
    } else {
      const isShort = (middle2) => middle2 < 3;
      const rightOffset = topLeft > topRight && isShort(rightMiddle) ? 1 : 2;
      let leftOffset;
      if (topRight > topLeft) {
        const defaultOffset = isShort(rightMiddle) ? leftMiddle : leftMiddle - 2;
        leftOffset = isShort(leftMiddle) ? leftMiddle - 1 : defaultOffset;
      } else {
        const defaultOffset = isShort(leftMiddle) ? 1 : 2;
        leftOffset = isShort(rightMiddle) ? defaultOffset : leftMiddle - 2;
      }
      moves2 = [...rightMoves.slice(0, rightOffset), ...leftMoves.slice(leftOffset)];
      coords = [...rightCoords.slice(0, rightOffset), ...leftCoords.slice(leftOffset)];
    }
    const middle = moves2.indexOf("L");
    const subMoves = moves2.slice(0, middle);
    const subCoords = coords.slice(0, middle);
    return subMoves.map((m3, i2) => ({
      command: m3,
      coords: subCoords[i2].split(",")
    }));
  };
  const getBottomPath = () => {
    const {
      bottomRight,
      bottomLeft
    } = cornerRadius;
    const arcLength = r1 * Math.abs(end2 - start2);
    const {
      rightMoves,
      rightCoords,
      rightMiddle,
      leftMoves,
      leftCoords,
      leftMiddle
    } = getPathData("bottom");
    let moves2;
    let coords;
    if (bottomRight === bottomLeft || arcLength < 2 * bottomRight + 2 * bottomLeft) {
      moves2 = bottomRight > bottomLeft ? rightMoves : leftMoves;
      coords = bottomRight > bottomLeft ? rightCoords : leftCoords;
    } else {
      const isShort = (m3, middle2) => m3.length - middle2 < 4;
      const shortPath = bottomRight > bottomLeft ? isShort(rightMoves, rightMiddle) : isShort(leftMoves, leftMiddle);
      const rightOffset = shortPath ? -1 : -3;
      moves2 = [...leftMoves.slice(0, leftMiddle + 2), ...rightMoves.slice(rightOffset)];
      coords = [...leftCoords.slice(0, leftMiddle + 2), ...rightCoords.slice(rightOffset)];
    }
    const middle = moves2.indexOf("L");
    const subMoves = moves2.slice(middle, -1);
    const subCoords = coords.slice(middle, -1);
    return subMoves.map((m3, i2) => ({
      command: m3,
      coords: subCoords[i2].split(",")
    }));
  };
  const topPath = getTopPath();
  const bottomPath = getBottomPath();
  const moves = [...topPath, ...bottomPath];
  const path2 = moves.reduce((memo, move) => `${memo}${move.command} ${move.coords.join()}`, "");
  return `${path2} z`;
};
const getBarPath = (props2, width, cornerRadius) => {
  if (props2.getPath) {
    return getCustomBarPath(props2, width);
  }
  return props2.horizontal ? getHorizontalBarPath(props2, width, cornerRadius) : getVerticalBarPath(props2, width, cornerRadius);
};
const getPolarBarPath = (props2, cornerRadius) => {
  return getVerticalPolarBarPath(props2, cornerRadius);
};
const evaluateProps$2 = (props2) => {
  const style2 = getStyle(props2.style, props2);
  const barWidth = getBarWidth(props2.barWidth, Object.assign({}, props2, {
    style: style2
  }));
  const cornerRadius = getCornerRadius(props2.cornerRadius, Object.assign({}, props2, {
    style: style2,
    barWidth
  }));
  const ariaLabel = evaluateProp(props2.ariaLabel, props2);
  const desc = evaluateProp(props2.desc, props2);
  const id = evaluateProp(props2.id, props2);
  const tabIndex = evaluateProp(props2.tabIndex, props2);
  return Object.assign({}, props2, {
    ariaLabel,
    style: style2,
    barWidth,
    cornerRadius,
    desc,
    id,
    tabIndex
  });
};
const defaultProps$3 = {
  pathComponent: /* @__PURE__ */ React__default.createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};
const Bar = /* @__PURE__ */ forwardRef(function Bar2(initialProps, ref2) {
  const props2 = evaluateProps$2(_defaults({}, initialProps, defaultProps$3));
  const {
    polar,
    origin,
    style: style2,
    barWidth,
    cornerRadius
  } = props2;
  const path2 = polar ? getPolarBarPath(props2, cornerRadius) : getBarPath(props2, barWidth, cornerRadius);
  const defaultTransform = polar && origin ? `translate(${origin.x}, ${origin.y})` : void 0;
  if (!props2.pathComponent) {
    return null;
  }
  return /* @__PURE__ */ React__default.cloneElement(props2.pathComponent, {
    ...props2.events,
    "aria-label": props2.ariaLabel,
    style: style2,
    d: path2,
    className: props2.className,
    clipPath: props2.clipPath,
    desc: props2.desc,
    index: props2.index,
    role: props2.role,
    shapeRendering: props2.shapeRendering,
    transform: props2.transform || defaultTransform,
    tabIndex: props2.tabIndex,
    ref: ref2
  });
});
const fallbackProps$5 = {
  width: 450,
  height: 300,
  padding: 50
};
const defaultData = [{
  x: 1,
  y: 1
}, {
  x: 2,
  y: 2
}, {
  x: 3,
  y: 3
}, {
  x: 4,
  y: 4
}];
class VictoryBarBase extends React__default.Component {
  static getBaseProps(props2) {
    return getBaseProps$2(props2, fallbackProps$5);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist,
      role
    } = VictoryBar;
    const props2 = modifyProps$1(this.props, fallbackProps$5, role);
    if (this.shouldAnimate()) {
      return this.animateComponent(props2, animationWhitelist);
    }
    const children2 = this.renderData(props2);
    const component = props2.standalone ? this.renderContainer(props2.containerComponent, children2) : children2;
    return withSafeUserProps(component, props2);
  }
}
__publicField(VictoryBarBase, "animationWhitelist", ["data", "domain", "height", "padding", "style", "width"]);
__publicField(VictoryBarBase, "displayName", "VictoryBar");
__publicField(VictoryBarBase, "role", "bar");
__publicField(VictoryBarBase, "defaultTransitions", {
  onLoad: {
    duration: 2e3,
    before: () => ({
      _y: 0,
      _y1: 0,
      _y0: 0
    }),
    after: (datum) => ({
      _y: datum._y,
      _y1: datum._y1,
      _y0: datum._y0
    })
  },
  onExit: {
    duration: 500,
    before: () => ({
      _y: 0,
      yOffset: 0
    })
  },
  onEnter: {
    duration: 500,
    before: () => ({
      _y: 0,
      _y1: 0,
      _y0: 0
    }),
    after: (datum) => ({
      _y: datum._y,
      _y1: datum._y1,
      _y0: datum._y0
    })
  }
});
__publicField(VictoryBarBase, "defaultProps", {
  containerComponent: /* @__PURE__ */ React__default.createElement(VictoryContainer, null),
  data: defaultData,
  dataComponent: /* @__PURE__ */ React__default.createElement(Bar, null),
  groupComponent: /* @__PURE__ */ React__default.createElement("g", {
    role: "presentation"
  }),
  labelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, null),
  samples: 50,
  sortOrder: "ascending",
  standalone: true,
  theme: VictoryTheme.grayscale
});
__publicField(VictoryBarBase, "getDomain", getDomainWithZero);
__publicField(VictoryBarBase, "getData", getData);
__publicField(VictoryBarBase, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
const VictoryBar = addEvents(VictoryBarBase);
var root = _root;
var now$1 = function() {
  return root.Date.now();
};
var now_1 = now$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string2) {
  var index2 = string2.length;
  while (index2-- && reWhitespace.test(string2.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string2) {
  return string2 ? string2.slice(0, trimmedEndIndex(string2) + 1).replace(reTrimStart, "") : string2;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject$4 = isObject_1, isSymbol = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$2(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$4(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$4(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$2;
var isObject$3 = isObject_1, now = now_1, toNumber$1 = toNumber_1;
var FUNC_ERROR_TEXT$1 = "Expected a function";
var nativeMax = Math.max, nativeMin = Math.min;
function debounce$1(func, wait, options2) {
  var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$3(options2)) {
    leading = !!options2.leading;
    maxing = "maxWait" in options2;
    maxWait = maxing ? nativeMax(toNumber$1(options2.maxWait) || 0, wait) : maxWait;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  function invokeFunc(time2) {
    var args = lastArgs, thisArg = lastThis;
    lastArgs = lastThis = void 0;
    lastInvokeTime = time2;
    result = func.apply(thisArg, args);
    return result;
  }
  function leadingEdge(time2) {
    lastInvokeTime = time2;
    timerId = setTimeout(timerExpired, wait);
    return leading ? invokeFunc(time2) : result;
  }
  function remainingWait(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
  }
  function shouldInvoke(time2) {
    var timeSinceLastCall = time2 - lastCallTime, timeSinceLastInvoke = time2 - lastInvokeTime;
    return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }
  function timerExpired() {
    var time2 = now();
    if (shouldInvoke(time2)) {
      return trailingEdge(time2);
    }
    timerId = setTimeout(timerExpired, remainingWait(time2));
  }
  function trailingEdge(time2) {
    timerId = void 0;
    if (trailing && lastArgs) {
      return invokeFunc(time2);
    }
    lastArgs = lastThis = void 0;
    return result;
  }
  function cancel2() {
    if (timerId !== void 0) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = void 0;
  }
  function flush2() {
    return timerId === void 0 ? result : trailingEdge(now());
  }
  function debounced() {
    var time2 = now(), isInvoking = shouldInvoke(time2);
    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time2;
    if (isInvoking) {
      if (timerId === void 0) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === void 0) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel2;
  debounced.flush = flush2;
  return debounced;
}
var debounce_1 = debounce$1;
var debounce = debounce_1, isObject$2 = isObject_1;
var FUNC_ERROR_TEXT = "Expected a function";
function throttle(func, wait, options2) {
  var leading = true, trailing = true;
  if (typeof func != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$2(options2)) {
    leading = "leading" in options2 ? !!options2.leading : leading;
    trailing = "trailing" in options2 ? !!options2.trailing : trailing;
  }
  return debounce(func, wait, {
    "leading": leading,
    "maxWait": wait,
    "trailing": trailing
  });
}
var throttle_1 = throttle;
const _throttle = /* @__PURE__ */ getDefaultExportFromCjs(throttle_1);
function fromPairs(pairs) {
  var index2 = -1, length2 = pairs == null ? 0 : pairs.length, result = {};
  while (++index2 < length2) {
    var pair = pairs[index2];
    result[pair[0]] = pair[1];
  }
  return result;
}
var fromPairs_1 = fromPairs;
const _fromPairs = /* @__PURE__ */ getDefaultExportFromCjs(fromPairs_1);
var hasElementType$2 = typeof Element !== "undefined";
var hasMap$2 = typeof Map === "function";
var hasSet$2 = typeof Set === "function";
var hasArrayBuffer$2 = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal$2(a4, b10) {
  if (a4 === b10)
    return true;
  if (a4 && b10 && typeof a4 == "object" && typeof b10 == "object") {
    if (a4.constructor !== b10.constructor)
      return false;
    var length2, i2, keys8;
    if (Array.isArray(a4)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal$2(a4[i2], b10[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap$2 && a4 instanceof Map && b10 instanceof Map) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!equal$2(i2.value[1], b10.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet$2 && a4 instanceof Set && b10 instanceof Set) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer$2 && ArrayBuffer.isView(a4) && ArrayBuffer.isView(b10)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a4[i2] !== b10[i2])
          return false;
      return true;
    }
    if (a4.constructor === RegExp)
      return a4.source === b10.source && a4.flags === b10.flags;
    if (a4.valueOf !== Object.prototype.valueOf && typeof a4.valueOf === "function" && typeof b10.valueOf === "function")
      return a4.valueOf() === b10.valueOf();
    if (a4.toString !== Object.prototype.toString && typeof a4.toString === "function" && typeof b10.toString === "function")
      return a4.toString() === b10.toString();
    keys8 = Object.keys(a4);
    length2 = keys8.length;
    if (length2 !== Object.keys(b10).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b10, keys8[i2]))
        return false;
    if (hasElementType$2 && a4 instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys8[i2] === "_owner" || keys8[i2] === "__v" || keys8[i2] === "__o") && a4.$$typeof) {
        continue;
      }
      if (!equal$2(a4[keys8[i2]], b10[keys8[i2]]))
        return false;
    }
    return true;
  }
  return a4 !== a4 && b10 !== b10;
}
var reactFastCompare$2 = function isEqual3(a4, b10) {
  try {
    return equal$2(a4, b10);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
const isEqual$2 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare$2);
var stringify$1 = { exports: {} };
(function(module2, exports2) {
  exports2 = module2.exports = stringify2;
  exports2.getSerialize = serializer;
  function stringify2(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
  }
  function serializer(replacer, cycleReplacer) {
    var stack2 = [], keys8 = [];
    if (cycleReplacer == null)
      cycleReplacer = function(key, value) {
        if (stack2[0] === value)
          return "[Circular ~]";
        return "[Circular ~." + keys8.slice(0, stack2.indexOf(value)).join(".") + "]";
      };
    return function(key, value) {
      if (stack2.length > 0) {
        var thisPos = stack2.indexOf(this);
        ~thisPos ? stack2.splice(thisPos + 1) : stack2.push(this);
        ~thisPos ? keys8.splice(thisPos, Infinity, key) : keys8.push(key);
        if (~stack2.indexOf(value))
          value = cycleReplacer.call(this, key, value);
      } else
        stack2.push(value);
      return replacer == null ? value : replacer.call(this, key, value);
    };
  }
})(stringify$1, stringify$1.exports);
var stringifyExports = stringify$1.exports;
const stringify = /* @__PURE__ */ getDefaultExportFromCjs(stringifyExports);
class VictorySharedEvents extends React__default.Component {
  constructor(props2) {
    super(props2);
    this.getScopedEvents = getScopedEvents.bind(this);
    this.getEventState = getEventState.bind(this);
    this.state = this.state || {};
    this.sharedEventsCache = {};
    this.globalEvents = {};
    this.prevGlobalEventKeys = [];
    this.boundGlobalEvents = {};
    this.baseProps = this.getBaseProps(props2);
  }
  shouldComponentUpdate(nextProps) {
    if (!isEqual$2(this.props, nextProps)) {
      this.baseProps = this.getBaseProps(nextProps);
      const externalMutations = this.getExternalMutations(nextProps, this.baseProps);
      this.applyExternalMutations(nextProps, externalMutations);
    }
    return true;
  }
  componentDidMount() {
    const globalEventKeys = Object.keys(this.globalEvents);
    globalEventKeys.forEach((key) => this.addGlobalListener(key));
    this.prevGlobalEventKeys = globalEventKeys;
  }
  componentDidUpdate() {
    const globalEventKeys = Object.keys(this.globalEvents);
    const removedGlobalEventKeys = difference(this.prevGlobalEventKeys, globalEventKeys);
    removedGlobalEventKeys.forEach((key) => this.removeGlobalListener(key));
    const addedGlobalEventKeys = difference(globalEventKeys, this.prevGlobalEventKeys);
    addedGlobalEventKeys.forEach((key) => this.addGlobalListener(key));
    this.prevGlobalEventKeys = globalEventKeys;
  }
  componentWillUnmount() {
    this.prevGlobalEventKeys.forEach((key) => this.removeGlobalListener(key));
  }
  addGlobalListener(key) {
    const boundListener = (event2) => {
      const listener = this.globalEvents[key];
      return listener && listener(emulateReactEvent(event2));
    };
    this.boundGlobalEvents[key] = boundListener;
    window.addEventListener(getGlobalEventNameFromKey(key), boundListener);
  }
  removeGlobalListener(key) {
    window.removeEventListener(getGlobalEventNameFromKey(key), this.boundGlobalEvents[key]);
  }
  getAllEvents(props2) {
    const components2 = ["container", "groupComponent"];
    const componentEvents = getComponentEvents(props2, components2);
    if (Array.isArray(componentEvents)) {
      return Array.isArray(props2.events) ? componentEvents.concat(...props2.events) : componentEvents;
    }
    return props2.events;
  }
  applyExternalMutations(props2, externalMutations) {
    if (!_isEmpty(externalMutations)) {
      const callbacks = props2.externalEventMutations.reduce((memo, mutation) => isFunction$1(mutation.callback) ? memo.concat(mutation.callback) : memo, []);
      const compiledCallbacks = callbacks.length ? () => {
        callbacks.forEach((c7) => c7());
      } : void 0;
      this.setState(externalMutations, compiledCallbacks);
    }
  }
  getExternalMutations(props2, baseProps2) {
    return !_isEmpty(props2.externalEventMutations) ? getExternalMutationsWithChildren(props2.externalEventMutations, baseProps2, this.state, Object.keys(baseProps2)) : void 0;
  }
  cacheSharedEvents(name2, sharedEvents, cacheValues) {
    this.sharedEventsCache[name2] = [sharedEvents, cacheValues];
  }
  getCachedSharedEvents(name2, cacheValues) {
    const [sharedEvents, prevCacheValues] = this.sharedEventsCache[name2] || [];
    if (sharedEvents && isEqual$2(cacheValues, prevCacheValues)) {
      return sharedEvents;
    }
    return void 0;
  }
  getBaseProps(props2) {
    const {
      container: container2
    } = props2;
    const children2 = React__default.Children.toArray(this.props.children);
    const childBaseProps = this.getBasePropsFromChildren(children2);
    const parentBaseProps = container2 ? container2.props : {};
    return Object.assign({}, childBaseProps, {
      parent: parentBaseProps
    });
  }
  getBasePropsFromChildren(childComponents) {
    const iteratee = (child, childName) => {
      if (child.type && isFunction$1(child.type.getBaseProps)) {
        const baseProps3 = child.props && child.type.getBaseProps(child.props);
        return baseProps3 ? [[childName, baseProps3]] : null;
      }
      return null;
    };
    const baseProps2 = reduceChildren(childComponents, iteratee);
    return _fromPairs(baseProps2);
  }
  getNewChildren(props2, baseProps2) {
    const {
      events,
      eventKey
    } = props2;
    const alterChildren = (children2, childNames2) => {
      return children2.reduce((memo, child, index2) => {
        if (child.props.children) {
          const newChildren = React__default.Children.toArray(child.props.children);
          const names = childNames2.slice(index2, index2 + newChildren.length);
          const results = /* @__PURE__ */ React__default.cloneElement(child, child.props, alterChildren(newChildren, names));
          return memo.concat(results);
        } else if (childNames2[index2] !== "parent" && child.type && isFunction$1(child.type.getBaseProps)) {
          const name2 = child.props.name || childNames2[index2];
          const childEvents = Array.isArray(events) && events.filter((event2) => {
            if (event2.target === "parent") {
              return false;
            }
            return Array.isArray(event2.childName) ? event2.childName.indexOf(name2) > -1 : event2.childName === name2 || event2.childName === "all";
          });
          const sharedEventsCacheValues = [name2, baseProps2, childEvents, stringify(this.state[name2])];
          const sharedEvents = this.getCachedSharedEvents(name2, sharedEventsCacheValues) || {
            events: childEvents,
            // partially apply child name and baseProps,
            getEvents: (evts, target) => this.getScopedEvents(evts, target, name2, baseProps2),
            // partially apply child name
            getEventState: (key, target) => this.getEventState(key, target, name2)
          };
          this.cacheSharedEvents(name2, sharedEvents, sharedEventsCacheValues);
          return memo.concat(/* @__PURE__ */ React__default.cloneElement(child, Object.assign({
            key: `events-${name2}`,
            sharedEvents,
            eventKey,
            name: name2
          }, child.props)));
        }
        return memo.concat(child);
      }, []);
    };
    const childNames = Object.keys(baseProps2);
    const childComponents = React__default.Children.toArray(props2.children);
    return alterChildren(childComponents, childNames);
  }
  getContainer(props2, baseProps2, events) {
    const children2 = this.getNewChildren(props2, baseProps2);
    const parents = Array.isArray(events) ? events.filter((event2) => event2.target === "parent") : [];
    const sharedEvents = parents.length > 0 ? {
      events: parents,
      // partially apply childName (null) and baseProps,
      getEvents: (evts, target) => this.getScopedEvents(evts, target, null, baseProps2),
      getEventState: this.getEventState
    } : null;
    const container2 = props2.container || props2.groupComponent;
    const role = container2.type && container2.type.role;
    const containerProps = container2.props || {};
    const boundGetEvents = getEvents.bind(this);
    const parentEvents = sharedEvents && boundGetEvents({
      sharedEvents
    }, "parent");
    const parentProps = _defaults({}, this.getEventState("parent", "parent"), containerProps, baseProps2.parent, {
      children: children2
    });
    const containerEvents = _defaults({}, getPartialEvents(parentEvents, "parent", parentProps), containerProps.events);
    this.globalEvents = getGlobalEvents(containerEvents);
    const localEvents = omitGlobalEvents(containerEvents);
    return role === "container" ? /* @__PURE__ */ React__default.cloneElement(container2, Object.assign({}, parentProps, {
      events: localEvents
    })) : /* @__PURE__ */ React__default.cloneElement(container2, localEvents, children2);
  }
  render() {
    const events = this.getAllEvents(this.props);
    if (events) {
      return this.getContainer(this.props, this.baseProps, events);
    }
    return /* @__PURE__ */ React__default.cloneElement(this.props.container, {
      children: this.props.children
    });
  }
}
__publicField(VictorySharedEvents, "displayName", "VictorySharedEvents");
__publicField(VictorySharedEvents, "role", "shared-event-wrapper");
__publicField(VictorySharedEvents, "contextType", TimerContext);
__publicField(VictorySharedEvents, "defaultProps", {
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null)
});
const getPosition = (r, angle, axis) => {
  return axis === "x" ? r * Math.cos(angle) : -r * Math.sin(angle);
};
const getAxisType = (props2) => {
  const typicalType = props2.dependentAxis ? "radial" : "angular";
  const invertedType = typicalType === "angular" ? "radial" : "angular";
  return props2.horizontal ? invertedType : typicalType;
};
const filterTicks = (ticks2, scale) => {
  const compareTicks = (t2) => scale(t2) % (2 * Math.PI);
  return _uniqBy(ticks2, compareTicks);
};
const getEvaluatedStyles = (style2, props2) => {
  return {
    tickStyle: evaluateStyle(style2.ticks, props2),
    labelStyle: evaluateStyle(style2.tickLabels, props2),
    gridStyle: evaluateStyle(style2.grid, props2)
  };
};
const getStyleObject = (props2) => {
  var _a2, _b;
  const {
    theme: theme2 = {},
    dependentAxis
  } = props2;
  const generalAxisStyle = theme2.polarAxis && theme2.polarAxis.style || theme2.axis && theme2.axis.style;
  const polarAxisType = dependentAxis ? "polarDependentAxis" : "polarIndependentAxis";
  const standardAxisType = dependentAxis ? "dependentAxis" : "independentAxis";
  const specificAxisStyle = ((_a2 = theme2 == null ? void 0 : theme2[polarAxisType]) == null ? void 0 : _a2.style) || ((_b = theme2 == null ? void 0 : theme2[standardAxisType]) == null ? void 0 : _b.style);
  const mergeStyles = () => {
    const styleNamespaces = ["axis", "axisLabel", "grid", "parent", "tickLabels", "ticks"];
    return styleNamespaces.reduce((memo, curr) => {
      memo[curr] = _defaults({}, specificAxisStyle == null ? void 0 : specificAxisStyle[curr], generalAxisStyle == null ? void 0 : generalAxisStyle[curr]);
      return memo;
    }, {});
  };
  return generalAxisStyle && specificAxisStyle ? mergeStyles() : specificAxisStyle || generalAxisStyle;
};
const getRadius = (props2) => {
  const {
    left: left2,
    right: right2,
    top: top2,
    bottom: bottom2
  } = getPadding$1(props2);
  const {
    width,
    height
  } = props2;
  if (width === void 0 || height === void 0) {
    throw new Error("VictoryPolarAxis: width and height properties are required for standalone axes.");
  }
  return Math.min(width - left2 - right2, height - top2 - bottom2) / 2;
};
const getRange = (props2, axis) => {
  if (props2.range && props2.range[axis]) {
    return props2.range[axis];
  } else if (props2.range && Array.isArray(props2.range)) {
    return props2.range;
  }
  const axisType = getAxisType(props2);
  if (axisType === "angular") {
    const startAngle = degreesToRadians(props2.startAngle);
    const endAngle = degreesToRadians(props2.endAngle);
    return [startAngle, endAngle];
  }
  const radius = getRadius(props2);
  return [props2.innerRadius || 0, radius];
};
const getScale = (props2) => {
  const axis = getAxis(props2);
  const scale = getBaseScale(props2, axis);
  const domain = getDomain$2(props2, axis) || scale.domain();
  const range2 = getRange(props2, axis);
  scale.range(range2);
  scale.domain(domain);
  return scale;
};
const getStyles$1 = function(props2, styleObject) {
  if (styleObject === void 0) {
    styleObject = {};
  }
  if (props2.disableInlineStyles) {
    return {};
  }
  const style2 = props2.style || {};
  const parentStyleProps = {
    height: "auto",
    width: "100%"
  };
  return {
    parent: _defaults(parentStyleProps, style2.parent, styleObject.parent),
    axis: _defaults({}, style2.axis, styleObject.axis),
    axisLabel: _defaults({}, style2.axisLabel, styleObject.axisLabel),
    grid: _defaults({}, style2.grid, styleObject.grid),
    ticks: _defaults({}, style2.ticks, styleObject.ticks),
    tickLabels: _defaults({}, style2.tickLabels, styleObject.tickLabels)
  };
};
const getAxisAngle = (props2) => {
  const {
    axisAngle,
    startAngle,
    dependentAxis
  } = props2;
  const axis = getAxis(props2);
  const axisValue = getAxisValue(props2, axis);
  if (axisValue === void 0 || !dependentAxis) {
    return axisAngle === void 0 ? startAngle : axisAngle;
  }
  return radiansToDegrees(axisValue);
};
const getTickProps = (props2, calculatedValues, tickValue, index2) => {
  const {
    axisType,
    radius,
    scale,
    style: style2,
    stringTicks: stringTicks2,
    ticks: ticks2,
    tickFormat: tickFormat2,
    origin
  } = calculatedValues;
  const text2 = tickFormat2(tickValue, index2, ticks2);
  const tick = stringTicks2 ? stringTicks2[index2] : tickValue;
  const {
    tickStyle
  } = getEvaluatedStyles(style2, {
    tick,
    tickValue,
    index: index2,
    ticks: ticks2,
    stringTicks: stringTicks2,
    radius,
    scale,
    axisType,
    text: text2
  });
  const axisAngle = axisType === "radial" ? getAxisAngle(props2) : void 0;
  const tickPadding = tickStyle.padding || tickStyle.size || 0;
  const padAngle = degreesToRadians(90 - axisAngle);
  const tickAngle = axisType === "angular" ? scale(tickValue) : degreesToRadians(-1 * axisAngle);
  const tickRadius = axisType === "angular" ? radius : scale(tickValue);
  return axisType === "angular" ? {
    index: index2,
    datum: tick,
    style: tickStyle,
    x1: getPosition(tickRadius, tickAngle, "x") + origin.x,
    y1: getPosition(tickRadius, tickAngle, "y") + origin.y,
    x2: getPosition(tickRadius + tickPadding, tickAngle, "x") + origin.x,
    y2: getPosition(tickRadius + tickPadding, tickAngle, "y") + origin.y
  } : {
    index: index2,
    datum: tick,
    style: tickStyle,
    x1: tickRadius * Math.cos(tickAngle) + Math.cos(padAngle) * tickPadding + origin.x,
    x2: tickRadius * Math.cos(tickAngle) - Math.cos(padAngle) * tickPadding + origin.x,
    y1: tickRadius * Math.sin(tickAngle) + Math.sin(padAngle) * tickPadding + origin.y,
    y2: tickRadius * Math.sin(tickAngle) - Math.sin(padAngle) * tickPadding + origin.y
  };
};
const getTickLabelProps = (props2, calculatedValues, tickValue, index2) => {
  const {
    axisType,
    radius,
    tickFormat: tickFormat2,
    style: style2,
    scale,
    ticks: ticks2,
    stringTicks: stringTicks2,
    origin
  } = calculatedValues;
  const text2 = tickFormat2(tickValue, index2, ticks2);
  const tick = stringTicks2 ? stringTicks2[index2] : tickValue;
  const {
    labelStyle
  } = getEvaluatedStyles(style2, {
    text: text2,
    tick,
    tickValue,
    index: index2,
    ticks: ticks2,
    stringTicks: stringTicks2,
    radius,
    scale,
    axisType
  });
  const {
    tickLabelComponent
  } = props2;
  const labelPlacement = (tickLabelComponent == null ? void 0 : tickLabelComponent.props.labelPlacement) ? tickLabelComponent.props.labelPlacement : props2.labelPlacement;
  const tickPadding = labelStyle.padding || 0;
  const angularPadding = 0;
  const axisAngle = axisType === "radial" ? getAxisAngle(props2) : void 0;
  const labelAngle = axisType === "angular" ? radiansToDegrees(scale(tickValue)) : axisAngle + angularPadding;
  const textAngle = labelStyle.angle === void 0 ? getPolarAngle(Object.assign({}, props2, {
    labelPlacement
  }), labelAngle) : labelStyle.angle;
  const labelRadius = axisType === "angular" ? radius + tickPadding : scale(tickValue);
  const textAnchor = labelStyle.textAnchor || getPolarTextAnchor(Object.assign({}, props2, {
    labelPlacement
  }), labelAngle);
  return {
    index: index2,
    datum: tick,
    style: labelStyle,
    angle: textAngle,
    textAnchor,
    text: text2,
    x: labelRadius * Math.cos(degreesToRadians(labelAngle)) + origin.x,
    y: -labelRadius * Math.sin(degreesToRadians(labelAngle)) + origin.y
  };
};
const getGridProps = (props2, calculatedValues, tickValue, index2) => {
  const {
    axisType,
    radius,
    style: style2,
    scale,
    stringTicks: stringTicks2,
    ticks: ticks2,
    tickFormat: tickFormat2,
    origin
  } = calculatedValues;
  const text2 = tickFormat2(tickValue, index2, ticks2);
  const {
    startAngle,
    endAngle,
    innerRadius = 0
  } = props2;
  const tick = stringTicks2 ? stringTicks2[index2] : tickValue;
  const {
    gridStyle
  } = getEvaluatedStyles(style2, {
    tick,
    tickValue,
    index: index2,
    ticks: ticks2,
    stringTicks: stringTicks2,
    radius,
    scale,
    axisType,
    text: text2
  });
  const angle = scale(tickValue);
  return axisType === "angular" ? {
    index: index2,
    datum: tick,
    style: gridStyle,
    x1: getPosition(radius, angle, "x") + origin.x,
    y1: getPosition(radius, angle, "y") + origin.y,
    x2: getPosition(innerRadius, angle, "x") + origin.x,
    y2: getPosition(innerRadius, angle, "y") + origin.y
  } : {
    style: gridStyle,
    index: index2,
    datum: tick,
    cx: origin.x,
    cy: origin.y,
    r: scale(tickValue),
    startAngle,
    endAngle
  };
};
const getAxisLabelProps = (props2, calculatedValues) => {
  const {
    axisType,
    radius,
    style: style2,
    origin
  } = calculatedValues;
  const {
    axisLabelComponent
  } = props2;
  if (axisType !== "radial") {
    return {};
  }
  const labelPlacement = (axisLabelComponent == null ? void 0 : axisLabelComponent.props.labelPlacement) ? axisLabelComponent.props.labelPlacement : props2.labelPlacement;
  const labelStyle = style2 && style2.axisLabel || {};
  const axisAngle = axisType === "radial" ? getAxisAngle(props2) : void 0;
  const textAngle = labelStyle.angle === void 0 ? getPolarAngle(Object.assign({}, props2, {
    labelPlacement
  }), axisAngle) : labelStyle.angle;
  const labelRadius = radius + (labelStyle.padding || 0);
  const textAnchor = labelStyle.textAnchor || getPolarTextAnchor(Object.assign({}, props2, {
    labelPlacement
  }), axisAngle);
  const verticalAnchor = labelStyle.verticalAnchor || getPolarVerticalAnchor(Object.assign({}, props2, {
    labelPlacement
  }), axisAngle);
  return {
    style: labelStyle,
    angle: textAngle,
    textAnchor,
    verticalAnchor,
    text: props2.label,
    x: getPosition(labelRadius, degreesToRadians(axisAngle), "x") + origin.x,
    y: getPosition(labelRadius, degreesToRadians(axisAngle), "y") + origin.y
  };
};
const getAxisProps$1 = (modifiedProps, calculatedValues) => {
  const {
    style: style2,
    axisType,
    radius,
    origin
  } = calculatedValues;
  const {
    startAngle,
    endAngle,
    innerRadius = 0
  } = modifiedProps;
  const axisAngle = axisType === "radial" ? degreesToRadians(getAxisAngle(modifiedProps)) : void 0;
  return axisType === "radial" ? {
    style: style2.axis,
    x1: getPosition(innerRadius, axisAngle, "x") + origin.x,
    x2: getPosition(radius, axisAngle, "x") + origin.x,
    y1: getPosition(innerRadius, axisAngle, "y") + origin.y,
    y2: getPosition(radius, axisAngle, "y") + origin.y
  } : {
    style: style2.axis,
    cx: origin.x,
    cy: origin.y,
    r: radius,
    startAngle,
    endAngle
  };
};
const getCalculatedValues$1 = (initialProps) => {
  const props2 = Object.assign({
    polar: true
  }, initialProps);
  const defaultStyles2 = getStyleObject(props2);
  const style2 = getStyles$1(props2, defaultStyles2);
  const padding2 = getPadding$1(props2);
  const axis = getAxis(props2);
  const axisType = getAxisType(props2);
  const stringTicks$1 = stringTicks(props2) ? props2.tickValues : void 0;
  const domain = getDomain$2(props2, axis);
  const range2 = getRange(props2, axis);
  const scale = getScale(props2);
  const initialTicks = getTicks(props2, scale);
  const ticks2 = axisType === "angular" ? filterTicks(initialTicks, scale) : initialTicks;
  const tickFormat2 = getTickFormat(props2, scale);
  const radius = getRadius(props2);
  const origin = getPolarOrigin(props2);
  return {
    axis,
    style: style2,
    padding: padding2,
    stringTicks: stringTicks$1,
    axisType,
    scale,
    ticks: ticks2,
    tickFormat: tickFormat2,
    domain,
    range: range2,
    radius,
    origin
  };
};
const getBaseProps$1 = (initialProps, fallbackProps2) => {
  const props2 = modifyProps(initialProps, fallbackProps2);
  const calculatedValues = getCalculatedValues$1(props2);
  const {
    style: style2,
    scale,
    ticks: ticks2,
    domain
  } = calculatedValues;
  const {
    width,
    height,
    standalone,
    theme: theme2,
    name: name2
  } = props2;
  const axisProps = getAxisProps$1(props2, calculatedValues);
  const axisLabelProps = getAxisLabelProps(props2, calculatedValues);
  const initialChildProps = {
    parent: {
      style: style2.parent,
      ticks: ticks2,
      scale,
      width,
      height,
      domain,
      standalone,
      theme: theme2,
      name: name2
    }
  };
  return ticks2.reduce((childProps, tick, index2) => {
    childProps[index2] = {
      axis: axisProps,
      axisLabel: axisLabelProps,
      ticks: getTickProps(props2, calculatedValues, tick, index2),
      tickLabels: getTickLabelProps(props2, calculatedValues, tick, index2),
      grid: getGridProps(props2, calculatedValues, tick, index2)
    };
    return childProps;
  }, initialChildProps);
};
const fallbackProps$4 = {
  width: 450,
  height: 300,
  padding: 50
};
class VictoryPolarAxisBase extends React__default.Component {
  static getScale(props2) {
    return getScale(props2);
  }
  static getStyles(props2) {
    return getStyles$1(props2, fallbackProps$4.style);
  }
  static getBaseProps(props2) {
    return getBaseProps$1(props2, fallbackProps$4);
  }
  renderAxisLine(props2) {
    const {
      dependentAxis
    } = props2;
    const axisComponent = dependentAxis ? props2.axisComponent : props2.circularAxisComponent;
    const axisProps = this.getComponentProps(axisComponent, "axis", 0);
    return /* @__PURE__ */ React__default.cloneElement(axisComponent, axisProps);
  }
  renderLabel(props2) {
    const {
      axisLabelComponent,
      dependentAxis,
      label: label2
    } = props2;
    if (!label2 || !dependentAxis) {
      return null;
    }
    const axisLabelProps = this.getComponentProps(axisLabelComponent, "axisLabel", 0);
    return /* @__PURE__ */ React__default.cloneElement(axisLabelComponent, axisLabelProps);
  }
  renderAxis(props2) {
    const {
      tickComponent,
      tickLabelComponent,
      name: name2
    } = props2;
    const shouldRender = (componentProps) => {
      const {
        style: style2 = {},
        events = {}
      } = componentProps;
      const visible = style2.stroke !== "transparent" && style2.stroke !== "none" && style2.strokeWidth !== 0;
      return visible || !_isEmpty(events);
    };
    const axisType = props2.dependentAxis ? "radial" : "angular";
    const gridComponent = axisType === "radial" ? props2.circularGridComponent : props2.gridComponent;
    const tickComponents = this.dataKeys.map((key, index2) => {
      const tickProps = Object.assign({
        key: `${name2}-tick-${key}`
      }, this.getComponentProps(tickComponent, "ticks", index2));
      const TickComponent = /* @__PURE__ */ React__default.cloneElement(tickComponent, tickProps);
      return shouldRender(TickComponent.props) ? TickComponent : void 0;
    }).filter(Boolean);
    const gridComponents = this.dataKeys.map((key, index2) => {
      const gridProps = Object.assign({
        key: `${name2}-grid-${key}`
      }, this.getComponentProps(gridComponent, "grid", index2));
      const GridComponent = /* @__PURE__ */ React__default.cloneElement(gridComponent, gridProps);
      return shouldRender(GridComponent.props) ? GridComponent : void 0;
    }).filter(Boolean);
    const tickLabelComponents = this.dataKeys.map((key, index2) => {
      const tickLabelProps = Object.assign({
        key: `${name2}-tick-${key}`
      }, this.getComponentProps(tickLabelComponent, "tickLabels", index2));
      return /* @__PURE__ */ React__default.cloneElement(tickLabelComponent, tickLabelProps);
    });
    const axis = this.renderAxisLine(props2);
    const axisLabel = this.renderLabel(props2);
    const children2 = [axis, axisLabel, ...tickComponents, ...gridComponents, ...tickLabelComponents];
    return this.renderGroup(props2, children2);
  }
  // Overridden in victory-native
  renderGroup(props2, children2) {
    const {
      groupComponent
    } = props2;
    return /* @__PURE__ */ React__default.cloneElement(groupComponent, {}, children2);
  }
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist
    } = VictoryPolarAxis;
    const props2 = modifyProps(this.props, fallbackProps$4);
    if (this.shouldAnimate()) {
      return this.animateComponent(props2, animationWhitelist);
    }
    const children2 = this.renderAxis(props2);
    return props2.standalone ? this.renderContainer(props2.containerComponent, children2) : children2;
  }
}
__publicField(VictoryPolarAxisBase, "animationWhitelist", ["style", "domain", "range", "tickCount", "tickValues", "padding", "width", "height"]);
__publicField(VictoryPolarAxisBase, "displayName", "VictoryAxis");
__publicField(VictoryPolarAxisBase, "role", "axis");
__publicField(VictoryPolarAxisBase, "defaultTransitions", {
  onExit: {
    duration: 500
  },
  onEnter: {
    duration: 500
  }
});
__publicField(VictoryPolarAxisBase, "defaultProps", {
  axisComponent: /* @__PURE__ */ React__default.createElement(LineSegment, null),
  axisLabelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, null),
  circularAxisComponent: /* @__PURE__ */ React__default.createElement(Arc, null),
  circularGridComponent: /* @__PURE__ */ React__default.createElement(Arc, null),
  containerComponent: /* @__PURE__ */ React__default.createElement(VictoryContainer, null),
  endAngle: 360,
  gridComponent: /* @__PURE__ */ React__default.createElement(LineSegment, null),
  groupComponent: /* @__PURE__ */ React__default.createElement("g", {
    role: "presentation"
  }),
  labelPlacement: "parallel",
  startAngle: 0,
  standalone: true,
  theme: VictoryTheme.grayscale,
  tickComponent: /* @__PURE__ */ React__default.createElement(LineSegment, null),
  tickLabelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, null)
});
__publicField(VictoryPolarAxisBase, "getDomain", getDomain$2);
__publicField(VictoryPolarAxisBase, "getAxis", getAxis);
__publicField(VictoryPolarAxisBase, "expectedComponents", ["axisComponent", "circularAxisComponent", "groupComponent", "containerComponent", "tickComponent", "tickLabelComponent", "gridComponent", "circularGridComponent"]);
const options$1 = {
  components: [{
    name: "axis",
    index: 0
  }, {
    name: "axisLabel",
    index: 0
  }, {
    name: "grid"
  }, {
    name: "parent",
    index: "parent"
  }, {
    name: "ticks"
  }, {
    name: "tickLabels"
  }]
};
const VictoryPolarAxis = addEvents(VictoryPolarAxisBase, options$1);
const fallbackProps$3 = {
  width: 450,
  height: 300,
  padding: 50
};
function getAxisProps(child, props2, calculatedProps) {
  const {
    domain,
    scale,
    stringMap,
    categories,
    horizontal
  } = calculatedProps;
  return {
    stringMap,
    horizontal,
    categories,
    startAngle: props2.startAngle,
    endAngle: props2.endAngle,
    innerRadius: props2.innerRadius,
    domain,
    scale
  };
}
function getBackgroundWithProps(props2, calculatedProps) {
  const backgroundElement = props2.backgroundComponent;
  const height = props2.polar ? calculatedProps.range.y[1] : calculatedProps.range.y[0] - calculatedProps.range.y[1];
  const width = calculatedProps.range.x[1] - calculatedProps.range.x[0];
  const xScale = props2.horizontal ? calculatedProps.scale.y.range()[0] : calculatedProps.scale.x.range()[0];
  const yScale = props2.horizontal ? calculatedProps.scale.x.range()[1] : calculatedProps.scale.y.range()[1];
  const xCoordinate = props2.polar ? calculatedProps.origin.x : xScale;
  const yCoordinate = props2.polar ? calculatedProps.origin.y : yScale;
  const parentName = props2.name || "chart";
  const backgroundProps = {
    height,
    polar: props2.polar,
    scale: calculatedProps.scale,
    style: props2.style.background,
    x: xCoordinate,
    y: yCoordinate,
    key: `${parentName}-background`,
    width
  };
  return /* @__PURE__ */ React__default.cloneElement(backgroundElement, _defaults({}, backgroundElement.props, backgroundProps));
}
function getChildProps(child, props2, calculatedProps) {
  const axisChild = findAxisComponents([child]);
  if (axisChild.length > 0) {
    return getAxisProps(axisChild[0], props2, calculatedProps);
  }
  const {
    categories,
    domain,
    range: range2,
    scale,
    stringMap,
    horizontal
  } = calculatedProps;
  return {
    categories,
    domain,
    range: range2,
    scale,
    stringMap,
    horizontal
  };
}
function getStyles(props2) {
  const styleProps = props2.style && props2.style.parent;
  return {
    parent: _defaults({}, styleProps, {
      height: "100%",
      width: "100%",
      userSelect: "none"
    })
  };
}
function getCalculatedProps(initialProps, childComponents) {
  const style2 = getStyles(initialProps);
  const props2 = modifyProps$1(initialProps, fallbackProps$3, "chart");
  const {
    horizontal,
    polar
  } = props2;
  const allStrings = getStringsFromChildren(props2, childComponents);
  const categories = getCategories(props2, childComponents, allStrings);
  const stringMap = createStringMap(props2, childComponents, allStrings);
  const domain = {
    x: getDomain(Object.assign({}, props2, {
      categories
    }), "x", childComponents),
    y: getDomain(Object.assign({}, props2, {
      categories
    }), "y", childComponents)
  };
  const range2 = {
    x: getRange$1(props2, "x"),
    y: getRange$1(props2, "y")
  };
  const baseScale = {
    x: getScaleFromProps(props2, "x") || getScale$2(props2, "x"),
    y: getScaleFromProps(props2, "y") || getScale$2(props2, "y")
  };
  const scale = {
    x: baseScale.x.domain(domain.x).range(horizontal ? range2.y : range2.x),
    y: baseScale.y.domain(domain.y).range(horizontal ? range2.x : range2.y)
  };
  const origin = polar ? getPolarOrigin(props2) : getOrigin(domain);
  const padding2 = getPadding$1(props2);
  return {
    categories,
    domain,
    range: range2,
    horizontal,
    scale,
    stringMap,
    style: style2,
    origin,
    padding: padding2
  };
}
function getChildren(props2, childComponents, calculatedProps) {
  const children2 = childComponents || getChildComponents(props2);
  const newCalculatedProps = calculatedProps || getCalculatedProps(props2, children2);
  const baseStyle2 = newCalculatedProps.style.parent;
  const {
    height,
    polar,
    theme: theme2,
    width
  } = props2;
  const {
    origin,
    horizontal
  } = newCalculatedProps;
  const parentName = props2.name || "chart";
  return children2.filter(React__default.isValidElement).map((child, index2) => {
    const role = child.type && child.type.role;
    const style2 = Array.isArray(child.props.style) ? child.props.style : _defaults({}, child.props.style, {
      parent: baseStyle2
    });
    const childProps = getChildProps(child, props2, newCalculatedProps);
    const name2 = child.props.name || `${parentName}-${role}-${index2}`;
    const newProps = _defaults({
      horizontal,
      height,
      polar,
      theme: theme2,
      width,
      style: style2,
      name: name2,
      origin: polar ? origin : void 0,
      padding: newCalculatedProps.padding,
      key: `${name2}-key-${index2}`,
      standalone: false
    }, childProps);
    return /* @__PURE__ */ React__default.cloneElement(child, newProps);
  });
}
const getChildComponents = (props2, defaultAxes) => {
  let childComponents = React__default.Children.toArray(props2.children);
  if (childComponents.length === 0) {
    childComponents.push(defaultAxes.independent, defaultAxes.dependent);
  } else {
    const axisComponents = {
      dependent: getAxisComponentsWithParent(childComponents, "dependent"),
      independent: getAxisComponentsWithParent(childComponents, "independent")
    };
    if (axisComponents.dependent.length === 0 && axisComponents.independent.length === 0) {
      childComponents = props2.prependDefaultAxes ? [defaultAxes.independent, defaultAxes.dependent].concat(childComponents) : childComponents.concat([defaultAxes.independent, defaultAxes.dependent]);
    }
  }
  return childComponents;
};
const getDomain = (props2, axis, childComponents) => {
  const children2 = childComponents || React__default.Children.toArray(props2.children);
  const domain = getDomain$1(props2, axis, children2);
  const axisComponent = getAxisComponent(children2, axis);
  const invertDomain = axisComponent && axisComponent.props && axisComponent.props.invertAxis;
  return invertDomain ? domain.concat().reverse() : domain;
};
const createStringMap = (props2, childComponents, allStrings) => {
  const x3 = !allStrings.x || allStrings.x.length === 0 ? null : allStrings.x.reduce((memo, string2, index2) => {
    memo[string2] = index2 + 1;
    return memo;
  }, {});
  const y4 = !allStrings.y || allStrings.y.length === 0 ? null : allStrings.y.reduce((memo, string2, index2) => {
    memo[string2] = index2 + 1;
    return memo;
  }, {});
  return {
    x: x3,
    y: y4
  };
};
var hasElementType$1 = typeof Element !== "undefined";
var hasMap$1 = typeof Map === "function";
var hasSet$1 = typeof Set === "function";
var hasArrayBuffer$1 = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal$1(a4, b10) {
  if (a4 === b10)
    return true;
  if (a4 && b10 && typeof a4 == "object" && typeof b10 == "object") {
    if (a4.constructor !== b10.constructor)
      return false;
    var length2, i2, keys8;
    if (Array.isArray(a4)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal$1(a4[i2], b10[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap$1 && a4 instanceof Map && b10 instanceof Map) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!equal$1(i2.value[1], b10.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet$1 && a4 instanceof Set && b10 instanceof Set) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer$1 && ArrayBuffer.isView(a4) && ArrayBuffer.isView(b10)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a4[i2] !== b10[i2])
          return false;
      return true;
    }
    if (a4.constructor === RegExp)
      return a4.source === b10.source && a4.flags === b10.flags;
    if (a4.valueOf !== Object.prototype.valueOf && typeof a4.valueOf === "function" && typeof b10.valueOf === "function")
      return a4.valueOf() === b10.valueOf();
    if (a4.toString !== Object.prototype.toString && typeof a4.toString === "function" && typeof b10.toString === "function")
      return a4.toString() === b10.toString();
    keys8 = Object.keys(a4);
    length2 = keys8.length;
    if (length2 !== Object.keys(b10).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b10, keys8[i2]))
        return false;
    if (hasElementType$1 && a4 instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys8[i2] === "_owner" || keys8[i2] === "__v" || keys8[i2] === "__o") && a4.$$typeof) {
        continue;
      }
      if (!equal$1(a4[keys8[i2]], b10[keys8[i2]]))
        return false;
    }
    return true;
  }
  return a4 !== a4 && b10 !== b10;
}
var reactFastCompare$1 = function isEqual4(a4, b10) {
  try {
    return equal$1(a4, b10);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare$1);
const fallbackProps$2 = {
  width: 450,
  height: 300,
  padding: 50
};
const defaultProps$2 = {
  backgroundComponent: /* @__PURE__ */ React__default.createElement(Background, null),
  containerComponent: /* @__PURE__ */ React__default.createElement(VictoryContainer, null),
  defaultAxes: {
    independent: /* @__PURE__ */ React__default.createElement(VictoryAxis, null),
    dependent: /* @__PURE__ */ React__default.createElement(VictoryAxis, {
      dependentAxis: true
    })
  },
  defaultPolarAxes: {
    independent: /* @__PURE__ */ React__default.createElement(VictoryPolarAxis, null),
    dependent: /* @__PURE__ */ React__default.createElement(VictoryPolarAxis, {
      dependentAxis: true
    })
  },
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null),
  standalone: true,
  theme: VictoryTheme.grayscale
};
const VictoryChartImpl = (initialProps) => {
  const propsWithDefaults = React__default.useMemo(() => _defaults({}, initialProps, defaultProps$2), [initialProps]);
  const role = "chart";
  const {
    getAnimationProps,
    setAnimationState,
    getProps: getProps2
  } = useAnimationState();
  const props2 = getProps2(propsWithDefaults);
  const modifiedProps = modifyProps$1(props2, fallbackProps$2, role);
  const {
    desc,
    eventKey,
    containerComponent,
    standalone,
    groupComponent,
    externalEventMutations,
    width,
    height,
    theme: theme2,
    polar,
    name: name2,
    title
  } = modifiedProps;
  const axes = props2.polar ? modifiedProps.defaultPolarAxes : modifiedProps.defaultAxes;
  const childComponents = React__default.useMemo(() => getChildComponents(modifiedProps, axes), [modifiedProps, axes]);
  const calculatedProps = React__default.useMemo(() => getCalculatedProps(modifiedProps, childComponents), [modifiedProps, childComponents]);
  const {
    domain,
    scale,
    style: style2,
    origin,
    horizontal
  } = calculatedProps;
  const newChildren = React__default.useMemo(() => {
    const children2 = getChildren(props2, childComponents, calculatedProps);
    const mappedChildren = children2.map((child, index2) => {
      const childProps = Object.assign({
        animate: getAnimationProps(props2, child, index2)
      }, child.props);
      return /* @__PURE__ */ React__default.cloneElement(child, childProps);
    });
    if (props2.style && props2.style.background) {
      const backgroundComponent = getBackgroundWithProps(props2, calculatedProps);
      mappedChildren.unshift(backgroundComponent);
    }
    return mappedChildren;
  }, [getAnimationProps, childComponents, props2, calculatedProps]);
  const containerProps = React__default.useMemo(() => {
    if (standalone) {
      return {
        desc,
        domain,
        width,
        height,
        horizontal,
        name: name2,
        origin: polar ? origin : void 0,
        polar,
        theme: theme2,
        title,
        scale,
        standalone,
        style: style2.parent
      };
    }
    return {};
  }, [desc, domain, height, horizontal, name2, origin, polar, scale, standalone, style2, title, theme2, width]);
  const container2 = React__default.useMemo(() => {
    if (standalone) {
      const defaultContainerProps = _defaults({}, containerComponent.props, containerProps, getSafeUserProps(propsWithDefaults));
      return /* @__PURE__ */ React__default.cloneElement(containerComponent, defaultContainerProps);
    }
    return groupComponent;
  }, [groupComponent, standalone, containerComponent, containerProps, propsWithDefaults]);
  const events = React__default.useMemo(() => {
    return getAllEvents(props2);
  }, [props2]);
  const previousProps = usePreviousProps(propsWithDefaults);
  React__default.useEffect(() => {
    return () => {
      if (propsWithDefaults.animate) {
        setAnimationState(previousProps, propsWithDefaults);
      }
    };
  }, [setAnimationState, previousProps, propsWithDefaults]);
  if (!_isEmpty(events)) {
    return /* @__PURE__ */ React__default.createElement(VictorySharedEvents, {
      container: container2,
      eventKey,
      events,
      externalEventMutations
    }, newChildren);
  }
  return /* @__PURE__ */ React__default.cloneElement(container2, container2.props, newChildren);
};
const VictoryChart = /* @__PURE__ */ React__default.memo(VictoryChartImpl, isEqual$1);
VictoryChart.displayName = "VictoryChart";
VictoryChart.expectedComponents = ["groupComponent", "containerComponent"];
const getVerticalPath = (props2) => {
  const {
    pointerWidth,
    cornerRadius,
    orientation,
    width,
    height,
    center
  } = props2;
  const sign2 = orientation === "bottom" ? 1 : -1;
  const x3 = props2.x + (props2.dx || 0);
  const y4 = props2.y + (props2.dy || 0);
  const centerX = center.x;
  const centerY = center.y;
  const pointerEdge = centerY + sign2 * (height / 2);
  const oppositeEdge = centerY - sign2 * (height / 2);
  const rightEdge = centerX + width / 2;
  const leftEdge = centerX - width / 2;
  const pointerLength = sign2 * (y4 - pointerEdge) < 0 ? 0 : props2.pointerLength;
  const direction = orientation === "bottom" ? "0 0 0" : "0 0 1";
  const arc2 = `${cornerRadius} ${cornerRadius} ${direction}`;
  return `M ${centerX - pointerWidth / 2}, ${pointerEdge}
    L ${pointerLength ? x3 : centerX + pointerWidth / 2}, ${pointerLength ? y4 : pointerEdge}
    L ${centerX + pointerWidth / 2}, ${pointerEdge}
    L ${rightEdge - cornerRadius}, ${pointerEdge}
    A ${arc2} ${rightEdge}, ${pointerEdge - sign2 * cornerRadius}
    L ${rightEdge}, ${oppositeEdge + sign2 * cornerRadius}
    A ${arc2} ${rightEdge - cornerRadius}, ${oppositeEdge}
    L ${leftEdge + cornerRadius}, ${oppositeEdge}
    A ${arc2} ${leftEdge}, ${oppositeEdge + sign2 * cornerRadius}
    L ${leftEdge}, ${pointerEdge - sign2 * cornerRadius}
    A ${arc2} ${leftEdge + cornerRadius}, ${pointerEdge}
    z`;
};
const getHorizontalPath = (props2) => {
  const {
    pointerWidth,
    cornerRadius,
    orientation,
    width,
    height,
    center
  } = props2;
  const sign2 = orientation === "left" ? 1 : -1;
  const x3 = props2.x + (props2.dx || 0);
  const y4 = props2.y + (props2.dy || 0);
  const centerX = center.x;
  const centerY = center.y;
  const pointerEdge = centerX - sign2 * (width / 2);
  const oppositeEdge = centerX + sign2 * (width / 2);
  const bottomEdge = centerY + height / 2;
  const topEdge = centerY - height / 2;
  const pointerLength = sign2 * (x3 - pointerEdge) > 0 ? 0 : props2.pointerLength;
  const direction = orientation === "left" ? "0 0 0" : "0 0 1";
  const arc2 = `${cornerRadius} ${cornerRadius} ${direction}`;
  return `M ${pointerEdge}, ${centerY - pointerWidth / 2}
    L ${pointerLength ? x3 : pointerEdge}, ${pointerLength ? y4 : centerY + pointerWidth / 2}
    L ${pointerEdge}, ${centerY + pointerWidth / 2}
    L ${pointerEdge}, ${bottomEdge - cornerRadius}
    A ${arc2} ${pointerEdge + sign2 * cornerRadius}, ${bottomEdge}
    L ${oppositeEdge - sign2 * cornerRadius}, ${bottomEdge}
    A ${arc2} ${oppositeEdge}, ${bottomEdge - cornerRadius}
    L ${oppositeEdge}, ${topEdge + cornerRadius}
    A ${arc2} ${oppositeEdge - sign2 * cornerRadius}, ${topEdge}
    L ${pointerEdge + sign2 * cornerRadius}, ${topEdge}
    A ${arc2} ${pointerEdge}, ${topEdge + cornerRadius}
    z`;
};
const getFlyoutPath = (props2) => {
  const orientation = props2.orientation || "top";
  return orientation === "left" || orientation === "right" ? getHorizontalPath(props2) : getVerticalPath(props2);
};
const evaluateProps$1 = (props2) => {
  const id = evaluateProp(props2.id, props2);
  const style2 = evaluateStyle(props2.style, props2);
  return {
    ...props2,
    id,
    style: style2
  };
};
const defaultProps$1 = {
  pathComponent: /* @__PURE__ */ React__default.createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};
const Flyout = (initialProps) => {
  const props2 = evaluateProps$1(_defaults({}, initialProps, defaultProps$1));
  const userProps = getSafeUserProps(props2);
  assert(props2.height, "Flyout props[height] is undefined");
  assert(props2.width, "Flyout props[width] is undefined");
  assert(props2.x, "Flyout props[x] is undefined");
  assert(props2.y, "Flyout props[y] is undefined");
  const flyoutPathProps = {
    center: props2.center || {
      x: 0,
      y: 0
    },
    cornerRadius: props2.cornerRadius || 0,
    dx: props2.dx,
    dy: props2.dy,
    height: props2.height,
    orientation: props2.orientation || "top",
    pointerLength: props2.pointerLength || 0,
    pointerWidth: props2.pointerWidth || 0,
    width: props2.width,
    x: props2.x,
    y: props2.y
  };
  return /* @__PURE__ */ React__default.cloneElement(props2.pathComponent, {
    ...props2.events,
    ...userProps,
    style: props2.style,
    d: getFlyoutPath(flyoutPathProps),
    className: props2.className,
    shapeRendering: props2.shapeRendering,
    role: props2.role,
    transform: props2.transform,
    clipPath: props2.clipPath
  });
};
const fallbackProps$1 = {
  cornerRadius: 5,
  pointerLength: 10,
  pointerWidth: 10
};
class VictoryTooltip extends React__default.Component {
  static defaultEvents(props2) {
    const activate = props2.activateData ? [{
      target: "labels",
      mutation: () => ({
        active: true
      })
    }, {
      target: "data",
      mutation: () => ({
        active: true
      })
    }] : [{
      target: "labels",
      mutation: () => ({
        active: true
      })
    }];
    const deactivate = props2.activateData ? [{
      target: "labels",
      mutation: () => ({
        active: void 0
      })
    }, {
      target: "data",
      mutation: () => ({
        active: void 0
      })
    }] : [{
      target: "labels",
      mutation: () => ({
        active: void 0
      })
    }];
    return [{
      target: "data",
      eventHandlers: {
        onMouseOver: () => activate,
        onFocus: () => activate,
        onTouchStart: () => activate,
        onMouseOut: () => deactivate,
        onBlur: () => deactivate,
        onTouchEnd: () => deactivate
      }
    }];
  }
  constructor(props2) {
    super(props2);
    this.id = props2.id === void 0 ? _uniqueId("tooltip-") : props2.id;
  }
  getDefaultOrientation(props2) {
    const {
      datum,
      horizontal,
      polar
    } = props2;
    if (!polar) {
      const positive = horizontal ? "right" : "top";
      const negative = horizontal ? "left" : "bottom";
      return datum && datum.y < 0 ? negative : positive;
    }
    return this.getPolarOrientation(props2);
  }
  getPolarOrientation(props2) {
    const degrees = getDegrees(props2, props2.datum);
    const placement = props2.labelPlacement || "vertical";
    if (placement === "vertical") {
      return this.getVerticalOrientations(degrees);
    } else if (placement === "parallel") {
      return degrees < 90 || degrees > 270 ? "right" : "left";
    }
    return degrees > 180 ? "bottom" : "top";
  }
  getVerticalOrientations(degrees) {
    if (degrees < 45 || degrees > 315) {
      return "right";
    } else if (degrees >= 45 && degrees <= 135) {
      return "top";
    } else if (degrees > 135 && degrees < 225) {
      return "left";
    }
    return "bottom";
  }
  getStyles(props2) {
    const theme2 = props2.theme || VictoryTheme.grayscale;
    const defaultLabelStyles = theme2 && theme2.tooltip && theme2.tooltip.style ? theme2.tooltip.style : {};
    const baseLabelStyle = Array.isArray(props2.style) ? props2.style.map((s4) => _defaults({}, s4, defaultLabelStyles)) : _defaults({}, props2.style, defaultLabelStyles);
    const defaultFlyoutStyles = theme2 && theme2.tooltip && theme2.tooltip.flyoutStyle ? theme2.tooltip.flyoutStyle : {};
    const baseFlyoutStyle = props2.flyoutStyle ? _defaults({}, props2.flyoutStyle, defaultFlyoutStyles) : defaultFlyoutStyles;
    const style2 = Array.isArray(baseLabelStyle) ? baseLabelStyle.map((s4) => evaluateStyle(s4, props2)) : evaluateStyle(baseLabelStyle, props2);
    const flyoutStyle = evaluateStyle(baseFlyoutStyle, Object.assign({}, props2, {
      style: style2
    }));
    return {
      style: style2,
      flyoutStyle
    };
  }
  getEvaluatedProps(props2) {
    const {
      cornerRadius,
      centerOffset,
      dx,
      dy
    } = props2;
    const active = evaluateProp(props2.active, props2);
    let text2 = evaluateProp(props2.text, Object.assign({}, props2, {
      active
    }));
    if (text2 === void 0 || text2 === null) {
      text2 = "";
    }
    if (typeof text2 === "number") {
      text2 = text2.toString();
    }
    const {
      style: style2,
      flyoutStyle
    } = this.getStyles(Object.assign({}, props2, {
      active,
      text: text2
    }));
    const orientation = evaluateProp(props2.orientation, Object.assign({}, props2, {
      active,
      text: text2,
      style: style2,
      flyoutStyle
    })) || this.getDefaultOrientation(props2);
    const padding2 = evaluateProp(props2.flyoutPadding, Object.assign({}, props2, {
      active,
      text: text2,
      style: style2,
      flyoutStyle,
      orientation
    })) || this.getLabelPadding(style2);
    const flyoutPadding = getPadding$1({
      padding: padding2
    });
    const pointerWidth = evaluateProp(props2.pointerWidth, Object.assign({}, props2, {
      active,
      text: text2,
      style: style2,
      flyoutStyle,
      orientation
    }));
    const pointerLength = evaluateProp(props2.pointerLength, Object.assign({}, props2, {
      active,
      text: text2,
      style: style2,
      flyoutStyle,
      orientation
    }));
    const labelSize = approximateTextSize(text2, style2);
    const {
      flyoutHeight,
      flyoutWidth
    } = this.getDimensions(Object.assign({}, props2, {
      style: style2,
      flyoutStyle,
      active,
      text: text2,
      orientation,
      flyoutPadding,
      pointerWidth,
      pointerLength
    }), labelSize);
    const evaluatedProps = Object.assign({}, props2, {
      active,
      text: text2,
      style: style2,
      flyoutStyle,
      orientation,
      flyoutHeight,
      flyoutWidth,
      flyoutPadding,
      pointerWidth,
      pointerLength
    });
    const offsetX = _isPlainObject(centerOffset) && (centerOffset == null ? void 0 : centerOffset.x) !== void 0 ? evaluateProp(centerOffset.x, evaluatedProps) : 0;
    const offsetY = _isPlainObject(centerOffset) && (centerOffset == null ? void 0 : centerOffset.y) !== void 0 ? evaluateProp(centerOffset.y, evaluatedProps) : 0;
    return {
      ...evaluatedProps,
      centerOffset: {
        x: offsetX,
        y: offsetY
      },
      dx: dx !== void 0 ? evaluateProp(dx, evaluatedProps) : 0,
      dy: dy !== void 0 ? evaluateProp(dy, evaluatedProps) : 0,
      cornerRadius: evaluateProp(cornerRadius, evaluatedProps)
    };
  }
  getCalculatedValues(props2) {
    const {
      style: style2,
      text: text2,
      flyoutStyle,
      flyoutHeight,
      flyoutWidth
    } = props2;
    const labelSize = approximateTextSize(text2, style2);
    const flyoutDimensions = {
      height: flyoutHeight,
      width: flyoutWidth
    };
    const flyoutCenter = this.getFlyoutCenter(props2, flyoutDimensions);
    const transform = this.getTransform(props2);
    return {
      style: style2,
      flyoutStyle,
      labelSize,
      flyoutDimensions,
      flyoutCenter,
      transform
    };
  }
  getTransform(props2) {
    const {
      x: x3,
      y: y4,
      style: style2
    } = props2;
    const labelStyle = style2 || {};
    const angle = labelStyle.angle || props2.angle || this.getDefaultAngle(props2);
    return angle ? `rotate(${angle} ${x3} ${y4})` : void 0;
  }
  getDefaultAngle(props2) {
    const {
      polar,
      labelPlacement,
      orientation,
      datum
    } = props2;
    if (!polar || !labelPlacement || labelPlacement === "vertical") {
      return 0;
    }
    const degrees = getDegrees(props2, datum);
    const sign2 = degrees > 90 && degrees < 180 || degrees > 270 ? 1 : -1;
    const labelRotation = labelPlacement === "perpendicular" ? 0 : 90;
    let angle = 0;
    if (degrees === 0 || degrees === 180) {
      angle = orientation === "top" && degrees === 180 ? 270 : 90;
    } else if (degrees > 0 && degrees < 180) {
      angle = 90 - degrees;
    } else if (degrees > 180 && degrees < 360) {
      angle = 270 - degrees;
    }
    return angle + sign2 * labelRotation;
  }
  constrainTooltip(center, props2, dimensions) {
    const {
      x: x3,
      y: y4
    } = center;
    const {
      width,
      height
    } = dimensions;
    const extent = {
      x: [0, props2.width],
      y: [0, props2.height]
    };
    const flyoutExtent = {
      x: [x3 - width / 2, x3 + width / 2],
      y: [y4 - height / 2, y4 + height / 2]
    };
    const adjustments = {
      x: [flyoutExtent.x[0] < extent.x[0] ? extent.x[0] - flyoutExtent.x[0] : 0, flyoutExtent.x[1] > extent.x[1] ? flyoutExtent.x[1] - extent.x[1] : 0],
      y: [flyoutExtent.y[0] < extent.y[0] ? extent.y[0] - flyoutExtent.y[0] : 0, flyoutExtent.y[1] > extent.y[1] ? flyoutExtent.y[1] - extent.y[1] : 0]
    };
    return {
      x: Math.round(x3 + adjustments.x[0] - adjustments.x[1]),
      y: Math.round(y4 + adjustments.y[0] - adjustments.y[1])
    };
  }
  // eslint-disable-next-line complexity
  getFlyoutCenter(props2, dimensions) {
    const {
      x: x3,
      y: y4,
      dx,
      dy,
      pointerLength,
      orientation,
      constrainToVisibleArea,
      centerOffset
    } = props2;
    const {
      height,
      width
    } = dimensions;
    const xSign = orientation === "left" ? -1 : 1;
    const ySign = orientation === "bottom" ? -1 : 1;
    const flyoutCenter = {
      x: orientation === "left" || orientation === "right" ? x3 + xSign * (pointerLength + width / 2 + xSign * dx) : x3 + dx,
      y: orientation === "top" || orientation === "bottom" ? y4 - ySign * (pointerLength + height / 2 - ySign * dy) : y4 + dy
    };
    const center = {
      x: _isPlainObject(props2.center) && props2.center.x !== void 0 ? props2.center.x : flyoutCenter.x,
      y: _isPlainObject(props2.center) && props2.center.y !== void 0 ? props2.center.y : flyoutCenter.y
    };
    const centerWithOffset = {
      x: center.x + centerOffset.x,
      y: center.y + centerOffset.y
    };
    return constrainToVisibleArea ? this.constrainTooltip(centerWithOffset, props2, dimensions) : centerWithOffset;
  }
  getLabelPadding(style2) {
    if (!style2) {
      return 0;
    }
    const paddings = Array.isArray(style2) ? style2.map((s4) => s4.padding) : [style2.padding];
    return Math.max(...paddings, 0);
  }
  getDimensions(props2, labelSize) {
    const {
      orientation,
      pointerLength,
      pointerWidth,
      flyoutHeight,
      flyoutWidth,
      flyoutPadding
    } = props2;
    const cornerRadius = evaluateProp(props2.cornerRadius, props2);
    const getHeight = () => {
      const calculatedHeight = labelSize.height + flyoutPadding.top + flyoutPadding.bottom;
      const minHeight = orientation === "top" || orientation === "bottom" ? 2 * cornerRadius : 2 * cornerRadius + pointerWidth;
      return Math.max(minHeight, calculatedHeight);
    };
    const getWidth3 = () => {
      const calculatedWidth = labelSize.width + flyoutPadding.left + flyoutPadding.right;
      const minWidth2 = orientation === "left" || orientation === "right" ? 2 * cornerRadius + pointerLength : 2 * cornerRadius;
      return Math.max(minWidth2, calculatedWidth);
    };
    return {
      flyoutHeight: flyoutHeight ? evaluateProp(flyoutHeight, props2) : getHeight(),
      flyoutWidth: flyoutWidth ? evaluateProp(flyoutWidth, props2) : getWidth3()
    };
  }
  getLabelProps(props2, calculatedValues) {
    const {
      flyoutCenter,
      style: style2,
      labelSize,
      dy = 0,
      dx = 0
    } = calculatedValues;
    const {
      text: text2,
      datum,
      activePoints,
      labelComponent,
      index: index2,
      flyoutPadding
    } = props2;
    const textAnchor = (Array.isArray(style2) && style2.length ? style2[0].textAnchor : style2.textAnchor) || "middle";
    const getLabelX = () => {
      if (!textAnchor || textAnchor === "middle") {
        return flyoutCenter.x;
      }
      const sign2 = textAnchor === "end" ? -1 : 1;
      return flyoutCenter.x - sign2 * (labelSize.width / 2);
    };
    return _defaults({}, labelComponent.props, {
      key: `${this.id}-label-${index2}`,
      text: text2,
      datum,
      activePoints,
      textAnchor,
      dy,
      dx,
      style: style2,
      x: getLabelX() + (flyoutPadding.left - flyoutPadding.right) / 2,
      y: flyoutCenter.y + (flyoutPadding.top - flyoutPadding.bottom) / 2,
      verticalAnchor: "middle",
      angle: style2.angle
    });
  }
  getPointerOrientation(point2, center, flyoutDimensions) {
    const edges = {
      bottom: center.y + flyoutDimensions.height / 2,
      top: center.y - flyoutDimensions.height / 2,
      left: center.x - flyoutDimensions.width / 2,
      right: center.x + flyoutDimensions.width / 2
    };
    const gaps = [{
      side: "top",
      val: edges.top > point2.y ? edges.top - point2.y : -1
    }, {
      side: "bottom",
      val: edges.bottom < point2.y ? point2.y - edges.bottom : -1
    }, {
      side: "right",
      val: edges.right < point2.x ? point2.x - edges.right : -1
    }, {
      side: "left",
      val: edges.left > point2.x ? edges.left - point2.x : -1
    }];
    return _orderBy(gaps, "val", "desc")[0].side;
  }
  getFlyoutProps(props2, calculatedValues) {
    const {
      flyoutDimensions,
      flyoutStyle,
      flyoutCenter
    } = calculatedValues;
    const {
      x: x3,
      y: y4,
      dx,
      dy,
      datum,
      activePoints,
      index: index2,
      pointerLength,
      pointerWidth,
      cornerRadius,
      events,
      flyoutComponent
    } = props2;
    const pointerOrientation = evaluateProp(props2.pointerOrientation, props2);
    return _defaults({}, flyoutComponent.props, {
      x: x3,
      y: y4,
      dx,
      dy,
      datum,
      activePoints,
      index: index2,
      pointerLength,
      pointerWidth,
      cornerRadius,
      events,
      orientation: pointerOrientation || this.getPointerOrientation({
        x: x3,
        y: y4
      }, flyoutCenter, flyoutDimensions),
      key: `${this.id}-tooltip-${index2}`,
      width: flyoutDimensions.width,
      height: flyoutDimensions.height,
      style: flyoutStyle,
      center: flyoutCenter
    });
  }
  // Overridden in victory-core-native
  renderTooltip(props2) {
    const active = evaluateProp(props2.active, props2);
    const {
      renderInPortal
    } = props2;
    if (!active) {
      return renderInPortal ? /* @__PURE__ */ React__default.createElement(VictoryPortal, null) : null;
    }
    const evaluatedProps = this.getEvaluatedProps(props2);
    const {
      flyoutComponent,
      labelComponent,
      groupComponent
    } = evaluatedProps;
    const calculatedValues = this.getCalculatedValues(evaluatedProps);
    const children2 = [/* @__PURE__ */ React__default.cloneElement(flyoutComponent, this.getFlyoutProps(evaluatedProps, calculatedValues)), /* @__PURE__ */ React__default.cloneElement(labelComponent, this.getLabelProps(evaluatedProps, calculatedValues))];
    const tooltip = /* @__PURE__ */ React__default.cloneElement(groupComponent, {
      role: "presentation",
      transform: calculatedValues.transform
    }, children2);
    return renderInPortal ? /* @__PURE__ */ React__default.createElement(VictoryPortal, null, tooltip) : tooltip;
  }
  render() {
    const props2 = modifyProps$1(this.props, fallbackProps$1, "tooltip");
    return this.renderTooltip(props2);
  }
}
__publicField(VictoryTooltip, "displayName", "VictoryTooltip");
__publicField(VictoryTooltip, "role", "tooltip");
__publicField(VictoryTooltip, "defaultProps", {
  active: false,
  renderInPortal: true,
  labelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, null),
  flyoutComponent: /* @__PURE__ */ React__default.createElement(Flyout, null),
  groupComponent: /* @__PURE__ */ React__default.createElement("g", null)
});
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1;
var regexpTag = "[object RegExp]";
function baseIsRegExp$1(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}
var _baseIsRegExp = baseIsRegExp$1;
var baseIsRegExp = _baseIsRegExp, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;
var isRegExp$1 = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
var isRegExp_1 = isRegExp$1;
const _isRegExp = /* @__PURE__ */ getDefaultExportFromCjs(isRegExp_1);
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal(a4, b10) {
  if (a4 === b10)
    return true;
  if (a4 && b10 && typeof a4 == "object" && typeof b10 == "object") {
    if (a4.constructor !== b10.constructor)
      return false;
    var length2, i2, keys8;
    if (Array.isArray(a4)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (!equal(a4[i2], b10[i2]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a4 instanceof Map && b10 instanceof Map) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!equal(i2.value[1], b10.get(i2.value[0])))
          return false;
      return true;
    }
    if (hasSet && a4 instanceof Set && b10 instanceof Set) {
      if (a4.size !== b10.size)
        return false;
      it = a4.entries();
      while (!(i2 = it.next()).done)
        if (!b10.has(i2.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a4) && ArrayBuffer.isView(b10)) {
      length2 = a4.length;
      if (length2 != b10.length)
        return false;
      for (i2 = length2; i2-- !== 0; )
        if (a4[i2] !== b10[i2])
          return false;
      return true;
    }
    if (a4.constructor === RegExp)
      return a4.source === b10.source && a4.flags === b10.flags;
    if (a4.valueOf !== Object.prototype.valueOf && typeof a4.valueOf === "function" && typeof b10.valueOf === "function")
      return a4.valueOf() === b10.valueOf();
    if (a4.toString !== Object.prototype.toString && typeof a4.toString === "function" && typeof b10.toString === "function")
      return a4.toString() === b10.toString();
    keys8 = Object.keys(a4);
    length2 = keys8.length;
    if (length2 !== Object.keys(b10).length)
      return false;
    for (i2 = length2; i2-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b10, keys8[i2]))
        return false;
    if (hasElementType && a4 instanceof Element)
      return false;
    for (i2 = length2; i2-- !== 0; ) {
      if ((keys8[i2] === "_owner" || keys8[i2] === "__v" || keys8[i2] === "__o") && a4.$$typeof) {
        continue;
      }
      if (!equal(a4[keys8[i2]], b10[keys8[i2]]))
        return false;
    }
    return true;
  }
  return a4 !== a4 && b10 !== b10;
}
var reactFastCompare = function isEqual5(a4, b10) {
  try {
    return equal(a4, b10);
  } catch (error2) {
    if ((error2.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error2;
  }
};
const isEqual6 = /* @__PURE__ */ getDefaultExportFromCjs(reactFastCompare);
var lib = {};
var delaunator = { exports: {} };
(function(module2, exports2) {
  (function(global2, factory) {
    module2.exports = factory();
  })(commonjsGlobal, function() {
    var EPSILON = Math.pow(2, -52);
    var EDGE_STACK = new Uint32Array(512);
    var Delaunator = function Delaunator2(coords) {
      var n = coords.length >> 1;
      if (n > 0 && typeof coords[0] !== "number") {
        throw new Error("Expected coords to contain numbers.");
      }
      this.coords = coords;
      var maxTriangles = Math.max(2 * n - 5, 0);
      this._triangles = new Uint32Array(maxTriangles * 3);
      this._halfedges = new Int32Array(maxTriangles * 3);
      this._hashSize = Math.ceil(Math.sqrt(n));
      this._hullPrev = new Uint32Array(n);
      this._hullNext = new Uint32Array(n);
      this._hullTri = new Uint32Array(n);
      this._hullHash = new Int32Array(this._hashSize).fill(-1);
      this._ids = new Uint32Array(n);
      this._dists = new Float64Array(n);
      this.update();
    };
    Delaunator.from = function from2(points, getX, getY) {
      if (getX === void 0)
        getX = defaultGetX;
      if (getY === void 0)
        getY = defaultGetY;
      var n = points.length;
      var coords = new Float64Array(n * 2);
      for (var i2 = 0; i2 < n; i2++) {
        var p = points[i2];
        coords[2 * i2] = getX(p);
        coords[2 * i2 + 1] = getY(p);
      }
      return new Delaunator(coords);
    };
    Delaunator.prototype.update = function update2() {
      var ref2 = this;
      var coords = ref2.coords;
      var hullPrev = ref2._hullPrev;
      var hullNext = ref2._hullNext;
      var hullTri = ref2._hullTri;
      var hullHash = ref2._hullHash;
      var n = coords.length >> 1;
      var minX = Infinity;
      var minY = Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      for (var i2 = 0; i2 < n; i2++) {
        var x3 = coords[2 * i2];
        var y4 = coords[2 * i2 + 1];
        if (x3 < minX) {
          minX = x3;
        }
        if (y4 < minY) {
          minY = y4;
        }
        if (x3 > maxX) {
          maxX = x3;
        }
        if (y4 > maxY) {
          maxY = y4;
        }
        this._ids[i2] = i2;
      }
      var cx = (minX + maxX) / 2;
      var cy = (minY + maxY) / 2;
      var minDist = Infinity;
      var i0, i1, i22;
      for (var i$1 = 0; i$1 < n; i$1++) {
        var d3 = dist(cx, cy, coords[2 * i$1], coords[2 * i$1 + 1]);
        if (d3 < minDist) {
          i0 = i$1;
          minDist = d3;
        }
      }
      var i0x = coords[2 * i0];
      var i0y = coords[2 * i0 + 1];
      minDist = Infinity;
      for (var i$2 = 0; i$2 < n; i$2++) {
        if (i$2 === i0) {
          continue;
        }
        var d$1 = dist(i0x, i0y, coords[2 * i$2], coords[2 * i$2 + 1]);
        if (d$1 < minDist && d$1 > 0) {
          i1 = i$2;
          minDist = d$1;
        }
      }
      var i1x = coords[2 * i1];
      var i1y = coords[2 * i1 + 1];
      var minRadius = Infinity;
      for (var i$3 = 0; i$3 < n; i$3++) {
        if (i$3 === i0 || i$3 === i1) {
          continue;
        }
        var r = circumradius(i0x, i0y, i1x, i1y, coords[2 * i$3], coords[2 * i$3 + 1]);
        if (r < minRadius) {
          i22 = i$3;
          minRadius = r;
        }
      }
      var i2x = coords[2 * i22];
      var i2y = coords[2 * i22 + 1];
      if (minRadius === Infinity) {
        for (var i$4 = 0; i$4 < n; i$4++) {
          this._dists[i$4] = coords[2 * i$4] - coords[0] || coords[2 * i$4 + 1] - coords[1];
        }
        quicksort(this._ids, this._dists, 0, n - 1);
        var hull = new Uint32Array(n);
        var j = 0;
        for (var i$5 = 0, d0 = -Infinity; i$5 < n; i$5++) {
          var id = this._ids[i$5];
          if (this._dists[id] > d0) {
            hull[j++] = id;
            d0 = this._dists[id];
          }
        }
        this.hull = hull.subarray(0, j);
        this.triangles = new Uint32Array(0);
        this.halfedges = new Uint32Array(0);
        return;
      }
      if (orient(i0x, i0y, i1x, i1y, i2x, i2y)) {
        var i$6 = i1;
        var x$1 = i1x;
        var y$1 = i1y;
        i1 = i22;
        i1x = i2x;
        i1y = i2y;
        i22 = i$6;
        i2x = x$1;
        i2y = y$1;
      }
      var center = circumcenter(i0x, i0y, i1x, i1y, i2x, i2y);
      this._cx = center.x;
      this._cy = center.y;
      for (var i$7 = 0; i$7 < n; i$7++) {
        this._dists[i$7] = dist(coords[2 * i$7], coords[2 * i$7 + 1], center.x, center.y);
      }
      quicksort(this._ids, this._dists, 0, n - 1);
      this._hullStart = i0;
      var hullSize = 3;
      hullNext[i0] = hullPrev[i22] = i1;
      hullNext[i1] = hullPrev[i0] = i22;
      hullNext[i22] = hullPrev[i1] = i0;
      hullTri[i0] = 0;
      hullTri[i1] = 1;
      hullTri[i22] = 2;
      hullHash.fill(-1);
      hullHash[this._hashKey(i0x, i0y)] = i0;
      hullHash[this._hashKey(i1x, i1y)] = i1;
      hullHash[this._hashKey(i2x, i2y)] = i22;
      this.trianglesLen = 0;
      this._addTriangle(i0, i1, i22, -1, -1, -1);
      for (var k3 = 0, xp = void 0, yp = void 0; k3 < this._ids.length; k3++) {
        var i$8 = this._ids[k3];
        var x$2 = coords[2 * i$8];
        var y$2 = coords[2 * i$8 + 1];
        if (k3 > 0 && Math.abs(x$2 - xp) <= EPSILON && Math.abs(y$2 - yp) <= EPSILON) {
          continue;
        }
        xp = x$2;
        yp = y$2;
        if (i$8 === i0 || i$8 === i1 || i$8 === i22) {
          continue;
        }
        var start2 = 0;
        for (var j$1 = 0, key = this._hashKey(x$2, y$2); j$1 < this._hashSize; j$1++) {
          start2 = hullHash[(key + j$1) % this._hashSize];
          if (start2 !== -1 && start2 !== hullNext[start2]) {
            break;
          }
        }
        start2 = hullPrev[start2];
        var e3 = start2, q2 = void 0;
        while (q2 = hullNext[e3], !orient(x$2, y$2, coords[2 * e3], coords[2 * e3 + 1], coords[2 * q2], coords[2 * q2 + 1])) {
          e3 = q2;
          if (e3 === start2) {
            e3 = -1;
            break;
          }
        }
        if (e3 === -1) {
          continue;
        }
        var t2 = this._addTriangle(e3, i$8, hullNext[e3], -1, -1, hullTri[e3]);
        hullTri[i$8] = this._legalize(t2 + 2);
        hullTri[e3] = t2;
        hullSize++;
        var n$1 = hullNext[e3];
        while (q2 = hullNext[n$1], orient(x$2, y$2, coords[2 * n$1], coords[2 * n$1 + 1], coords[2 * q2], coords[2 * q2 + 1])) {
          t2 = this._addTriangle(n$1, i$8, q2, hullTri[i$8], -1, hullTri[n$1]);
          hullTri[i$8] = this._legalize(t2 + 2);
          hullNext[n$1] = n$1;
          hullSize--;
          n$1 = q2;
        }
        if (e3 === start2) {
          while (q2 = hullPrev[e3], orient(x$2, y$2, coords[2 * q2], coords[2 * q2 + 1], coords[2 * e3], coords[2 * e3 + 1])) {
            t2 = this._addTriangle(q2, i$8, e3, -1, hullTri[e3], hullTri[q2]);
            this._legalize(t2 + 2);
            hullTri[q2] = t2;
            hullNext[e3] = e3;
            hullSize--;
            e3 = q2;
          }
        }
        this._hullStart = hullPrev[i$8] = e3;
        hullNext[e3] = hullPrev[n$1] = i$8;
        hullNext[i$8] = n$1;
        hullHash[this._hashKey(x$2, y$2)] = i$8;
        hullHash[this._hashKey(coords[2 * e3], coords[2 * e3 + 1])] = e3;
      }
      this.hull = new Uint32Array(hullSize);
      for (var i$9 = 0, e$1 = this._hullStart; i$9 < hullSize; i$9++) {
        this.hull[i$9] = e$1;
        e$1 = hullNext[e$1];
      }
      this.triangles = this._triangles.subarray(0, this.trianglesLen);
      this.halfedges = this._halfedges.subarray(0, this.trianglesLen);
    };
    Delaunator.prototype._hashKey = function _hashKey(x3, y4) {
      return Math.floor(pseudoAngle(x3 - this._cx, y4 - this._cy) * this._hashSize) % this._hashSize;
    };
    Delaunator.prototype._legalize = function _legalize(a4) {
      var ref2 = this;
      var triangles = ref2._triangles;
      var halfedges = ref2._halfedges;
      var coords = ref2.coords;
      var i2 = 0;
      var ar = 0;
      while (true) {
        var b10 = halfedges[a4];
        var a0 = a4 - a4 % 3;
        ar = a0 + (a4 + 2) % 3;
        if (b10 === -1) {
          if (i2 === 0) {
            break;
          }
          a4 = EDGE_STACK[--i2];
          continue;
        }
        var b02 = b10 - b10 % 3;
        var al = a0 + (a4 + 1) % 3;
        var bl = b02 + (b10 + 2) % 3;
        var p0 = triangles[ar];
        var pr = triangles[a4];
        var pl = triangles[al];
        var p1 = triangles[bl];
        var illegal = inCircle(
          coords[2 * p0],
          coords[2 * p0 + 1],
          coords[2 * pr],
          coords[2 * pr + 1],
          coords[2 * pl],
          coords[2 * pl + 1],
          coords[2 * p1],
          coords[2 * p1 + 1]
        );
        if (illegal) {
          triangles[a4] = p1;
          triangles[b10] = p0;
          var hbl = halfedges[bl];
          if (hbl === -1) {
            var e3 = this._hullStart;
            do {
              if (this._hullTri[e3] === bl) {
                this._hullTri[e3] = a4;
                break;
              }
              e3 = this._hullPrev[e3];
            } while (e3 !== this._hullStart);
          }
          this._link(a4, hbl);
          this._link(b10, halfedges[ar]);
          this._link(ar, bl);
          var br = b02 + (b10 + 1) % 3;
          if (i2 < EDGE_STACK.length) {
            EDGE_STACK[i2++] = br;
          }
        } else {
          if (i2 === 0) {
            break;
          }
          a4 = EDGE_STACK[--i2];
        }
      }
      return ar;
    };
    Delaunator.prototype._link = function _link(a4, b10) {
      this._halfedges[a4] = b10;
      if (b10 !== -1) {
        this._halfedges[b10] = a4;
      }
    };
    Delaunator.prototype._addTriangle = function _addTriangle(i0, i1, i2, a4, b10, c7) {
      var t2 = this.trianglesLen;
      this._triangles[t2] = i0;
      this._triangles[t2 + 1] = i1;
      this._triangles[t2 + 2] = i2;
      this._link(t2, a4);
      this._link(t2 + 1, b10);
      this._link(t2 + 2, c7);
      this.trianglesLen += 3;
      return t2;
    };
    function pseudoAngle(dx, dy) {
      var p = dx / (Math.abs(dx) + Math.abs(dy));
      return (dy > 0 ? 3 - p : 1 + p) / 4;
    }
    function dist(ax, ay, bx, by) {
      var dx = ax - bx;
      var dy = ay - by;
      return dx * dx + dy * dy;
    }
    function orientIfSure(px, py, rx, ry, qx, qy) {
      var l = (ry - py) * (qx - px);
      var r = (rx - px) * (qy - py);
      return Math.abs(l - r) >= 33306690738754716e-32 * Math.abs(l + r) ? l - r : 0;
    }
    function orient(rx, ry, qx, qy, px, py) {
      var sign2 = orientIfSure(px, py, rx, ry, qx, qy) || orientIfSure(rx, ry, qx, qy, px, py) || orientIfSure(qx, qy, px, py, rx, ry);
      return sign2 < 0;
    }
    function inCircle(ax, ay, bx, by, cx, cy, px, py) {
      var dx = ax - px;
      var dy = ay - py;
      var ex = bx - px;
      var ey = by - py;
      var fx = cx - px;
      var fy = cy - py;
      var ap = dx * dx + dy * dy;
      var bp = ex * ex + ey * ey;
      var cp = fx * fx + fy * fy;
      return dx * (ey * cp - bp * fy) - dy * (ex * cp - bp * fx) + ap * (ex * fy - ey * fx) < 0;
    }
    function circumradius(ax, ay, bx, by, cx, cy) {
      var dx = bx - ax;
      var dy = by - ay;
      var ex = cx - ax;
      var ey = cy - ay;
      var bl = dx * dx + dy * dy;
      var cl = ex * ex + ey * ey;
      var d3 = 0.5 / (dx * ey - dy * ex);
      var x3 = (ey * bl - dy * cl) * d3;
      var y4 = (dx * cl - ex * bl) * d3;
      return x3 * x3 + y4 * y4;
    }
    function circumcenter(ax, ay, bx, by, cx, cy) {
      var dx = bx - ax;
      var dy = by - ay;
      var ex = cx - ax;
      var ey = cy - ay;
      var bl = dx * dx + dy * dy;
      var cl = ex * ex + ey * ey;
      var d3 = 0.5 / (dx * ey - dy * ex);
      var x3 = ax + (ey * bl - dy * cl) * d3;
      var y4 = ay + (dx * cl - ex * bl) * d3;
      return { x: x3, y: y4 };
    }
    function quicksort(ids, dists, left2, right2) {
      if (right2 - left2 <= 20) {
        for (var i2 = left2 + 1; i2 <= right2; i2++) {
          var temp = ids[i2];
          var tempDist = dists[temp];
          var j = i2 - 1;
          while (j >= left2 && dists[ids[j]] > tempDist) {
            ids[j + 1] = ids[j--];
          }
          ids[j + 1] = temp;
        }
      } else {
        var median = left2 + right2 >> 1;
        var i$1 = left2 + 1;
        var j$1 = right2;
        swap2(ids, median, i$1);
        if (dists[ids[left2]] > dists[ids[right2]]) {
          swap2(ids, left2, right2);
        }
        if (dists[ids[i$1]] > dists[ids[right2]]) {
          swap2(ids, i$1, right2);
        }
        if (dists[ids[left2]] > dists[ids[i$1]]) {
          swap2(ids, left2, i$1);
        }
        var temp$1 = ids[i$1];
        var tempDist$1 = dists[temp$1];
        while (true) {
          do {
            i$1++;
          } while (dists[ids[i$1]] < tempDist$1);
          do {
            j$1--;
          } while (dists[ids[j$1]] > tempDist$1);
          if (j$1 < i$1) {
            break;
          }
          swap2(ids, i$1, j$1);
        }
        ids[left2 + 1] = ids[j$1];
        ids[j$1] = temp$1;
        if (right2 - i$1 + 1 >= j$1 - left2) {
          quicksort(ids, dists, i$1, right2);
          quicksort(ids, dists, left2, j$1 - 1);
        } else {
          quicksort(ids, dists, left2, j$1 - 1);
          quicksort(ids, dists, i$1, right2);
        }
      }
    }
    function swap2(arr, i2, j) {
      var tmp = arr[i2];
      arr[i2] = arr[j];
      arr[j] = tmp;
    }
    function defaultGetX(p) {
      return p[0];
    }
    function defaultGetY(p) {
      return p[1];
    }
    return Delaunator;
  });
})(delaunator);
var delaunatorExports = delaunator.exports;
(function(exports2) {
  exports2.__esModule = true;
  exports2["default"] = void 0;
  var _delaunator = _interopRequireDefault2(delaunatorExports);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function pointX(p) {
    return p[0];
  }
  function pointY(p) {
    return p[1];
  }
  function collinear(d3) {
    var triangles = d3.triangles, coords = d3.coords;
    for (var i2 = 0; i2 < triangles.length; i2 += 3) {
      var a4 = 2 * triangles[i2];
      var b10 = 2 * triangles[i2 + 1];
      var c7 = 2 * triangles[i2 + 2];
      var cross2 = (coords[c7] - coords[a4]) * (coords[b10 + 1] - coords[a4 + 1]) - (coords[b10] - coords[a4]) * (coords[c7 + 1] - coords[a4 + 1]);
      if (cross2 > 1e-10) {
        return false;
      }
    }
    return true;
  }
  function jitter(x3, y4, r) {
    return [x3 + Math.sin(x3 + y4) * r, y4 + Math.cos(x3 - y4) * r];
  }
  function flatArray(points, fx, fy, that) {
    var n = points.length;
    var array2 = new Float64Array(n * 2);
    for (var i2 = 0; i2 < n; ++i2) {
      var p = points[i2];
      array2[i2 * 2] = fx.call(that, p, i2, points);
      array2[i2 * 2 + 1] = fy.call(that, p, i2, points);
    }
    return array2;
  }
  var Delaunay2 = /* @__PURE__ */ function() {
    function Delaunay3(points) {
      var delaunator2 = new _delaunator["default"](points);
      this.inedges = new Int32Array(points.length / 2);
      this._hullIndex = new Int32Array(points.length / 2);
      this.points = delaunator2.coords;
      this._init(delaunator2);
    }
    var _proto = Delaunay3.prototype;
    _proto._init = function _init(delaunator2) {
      var d3 = delaunator2;
      var points = this.points;
      if (d3.hull && d3.hull.length > 2 && collinear(d3)) {
        this.collinear = Int32Array.from({
          length: points.length / 2
        }, function(_, i3) {
          return i3;
        }).sort(function(i3, j) {
          return points[2 * i3] - points[2 * j] || points[2 * i3 + 1] - points[2 * j + 1];
        });
        var e3 = this.collinear[0];
        var f = this.collinear[this.collinear.length - 1];
        var bounds = [points[2 * e3], points[2 * e3 + 1], points[2 * f], points[2 * f + 1]];
        var r = 1e-8 * // eslint-disable-line no-magic-numbers
        Math.sqrt(Math.pow(bounds[3] - bounds[1], 2) + Math.pow(bounds[2] - bounds[0], 2));
        for (var i2 = 0, n = points.length / 2; i2 < n; ++i2) {
          var p = jitter(points[2 * i2], points[2 * i2 + 1], r);
          points[2 * i2] = p[0];
          points[2 * i2 + 1] = p[1];
        }
        delaunator2 = new _delaunator["default"](points);
      }
      var halfedges = this.halfedges = delaunator2.halfedges;
      var hull = this.hull = delaunator2.hull;
      var triangles = this.triangles = delaunator2.triangles;
      var inedges = this.inedges.fill(-1);
      var hullIndex = this._hullIndex.fill(-1);
      for (var _e = 0, _n = halfedges.length; _e < _n; ++_e) {
        var _p = triangles[_e % 3 === 2 ? _e - 2 : _e + 1];
        if (halfedges[_e] === -1 || inedges[_p] === -1)
          inedges[_p] = _e;
      }
      for (var _i = 0, _n2 = hull.length; _i < _n2; ++_i) {
        hullIndex[hull[_i]] = _i;
      }
      if (hull.length <= 2 && hull.length > 0) {
        this.triangles = new Int32Array(3).fill(-1);
        this.halfedges = new Int32Array(3).fill(-1);
        this.triangles[0] = hull[0];
        this.triangles[1] = hull[1];
        this.triangles[2] = hull[1];
        inedges[hull[0]] = 1;
        if (hull.length === 2)
          inedges[hull[1]] = 0;
      }
    };
    _proto.neighbors = function neighbors(i2) {
      var results = [];
      var inedges = this.inedges, hull = this.hull, _hullIndex = this._hullIndex, halfedges = this.halfedges, triangles = this.triangles;
      var e0 = inedges[i2];
      if (e0 === -1)
        return results;
      var e3 = e0;
      var p0 = -1;
      do {
        p0 = triangles[e3];
        results.push(p0);
        e3 = e3 % 3 === 2 ? e3 - 2 : e3 + 1;
        if (triangles[e3] !== i2)
          break;
        e3 = halfedges[e3];
        if (e3 === -1) {
          var p = hull[(_hullIndex[i2] + 1) % hull.length];
          if (p !== p0)
            results.push(p);
          break;
        }
      } while (e3 !== e0);
      return results;
    };
    _proto.find = function find(x3, y4, i2) {
      if (i2 === void 0) {
        i2 = 0;
      }
      if ((x3 = +x3, x3 !== x3) || (y4 = +y4, y4 !== y4))
        return -1;
      var i0 = i2;
      var c7;
      while ((c7 = this._step(i2, x3, y4)) >= 0 && c7 !== i2 && c7 !== i0) {
        i2 = c7;
      }
      return c7;
    };
    _proto._step = function _step(i2, x3, y4) {
      var inedges = this.inedges, points = this.points;
      if (inedges[i2] === -1 || !points.length)
        return (i2 + 1) % (points.length >> 1);
      var c7 = i2;
      var dc = Math.pow(x3 - points[i2 * 2], 2) + Math.pow(y4 - points[i2 * 2 + 1], 2);
      for (var _iterator = this.neighbors(i2), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator](); ; ) {
        var _ref2;
        if (_isArray) {
          if (_i2 >= _iterator.length)
            break;
          _ref2 = _iterator[_i2++];
        } else {
          _i2 = _iterator.next();
          if (_i2.done)
            break;
          _ref2 = _i2.value;
        }
        var t2 = _ref2;
        var dt = Math.pow(x3 - points[t2 * 2], 2) + Math.pow(y4 - points[t2 * 2 + 1], 2);
        if (dt < dc) {
          dc = dt;
          c7 = t2;
        }
      }
      return c7;
    };
    return Delaunay3;
  }();
  exports2["default"] = Delaunay2;
  Delaunay2.from = function(points, fx, fy, that) {
    if (fx === void 0) {
      fx = pointX;
    }
    if (fy === void 0) {
      fy = pointY;
    }
    return new Delaunay2(flatArray(points, fx, fy, that));
  };
})(lib);
const Delaunay = /* @__PURE__ */ getDefaultExportFromCjs(lib);
const ON_MOUSE_MOVE_THROTTLE_MS = 32;
class VoronoiHelpersClass {
  constructor() {
    __publicField(this, "onMouseLeave", (evt, targetProps) => {
      const activePoints = targetProps.activePoints || [];
      this.onDeactivated(targetProps, activePoints);
      const inactiveMutations = activePoints.length ? activePoints.map((point2) => this.getInactiveMutations(targetProps, point2)) : [];
      return this.getParentMutation([]).concat(...inactiveMutations);
    });
    __publicField(this, "handleMouseMove", (evt, targetProps) => {
      const activePoints = targetProps.activePoints || [];
      const parentSVG = targetProps.parentSVG || getParentSVG(evt);
      const mousePosition = getSVGEventCoordinates(evt, parentSVG);
      if (!this.withinBounds(targetProps, mousePosition)) {
        this.onDeactivated(targetProps, activePoints);
        const inactiveMutations2 = activePoints.length ? activePoints.map((point2) => this.getInactiveMutations(targetProps, point2)) : [];
        return this.getParentMutation([], mousePosition, parentSVG).concat(...inactiveMutations2);
      }
      const {
        points = [],
        index: index2
      } = this.getVoronoiPoints(targetProps, mousePosition);
      const parentMutations = this.getParentMutation(points, mousePosition, parentSVG, index2);
      if (activePoints.length && isEqual6(points, activePoints)) {
        return parentMutations;
      }
      this.onActivated(targetProps, points);
      this.onDeactivated(targetProps, activePoints);
      const activeMutations = points.length ? points.map((point2) => this.getActiveMutations(targetProps, point2)) : [];
      const inactiveMutations = activePoints.length ? activePoints.map((point2) => this.getInactiveMutations(targetProps, point2)) : [];
      return parentMutations.concat(...inactiveMutations, ...activeMutations);
    });
    __publicField(this, "onMouseMove", _throttle(this.handleMouseMove, ON_MOUSE_MOVE_THROTTLE_MS, {
      leading: true,
      trailing: false
    }));
  }
  withinBounds(props2, point2) {
    const {
      width,
      height,
      polar,
      origin,
      scale
    } = props2;
    const padding2 = getPadding$1(props2, "voronoiPadding");
    const {
      x: x3,
      y: y4
    } = point2;
    if (polar) {
      const distanceSquared = Math.pow(x3 - origin.x, 2) + Math.pow(y4 - origin.y, 2);
      const radius = Math.max(...scale.y.range());
      return distanceSquared < Math.pow(radius, 2);
    }
    return x3 >= padding2.left && x3 <= width - padding2.right && y4 >= padding2.top && y4 <= height - padding2.bottom;
  }
  getDatasets(props2) {
    const minDomain = {
      x: getMinValue(props2.domain.x),
      y: getMinValue(props2.domain.y)
    };
    const children2 = React__default.Children.toArray(props2.children);
    const addMeta = (data, name2, child) => {
      const continuous2 = child && child.type && child.type.continuous;
      const style2 = child ? child.props && child.props.style : props2.style;
      return data.map((datum, index2) => {
        const {
          x: x3,
          y: y4,
          y0,
          x0
        } = getPoint(datum);
        const voronoiX = (Number(x3) + Number(x0)) / 2;
        const voronoiY = (Number(y4) + Number(y0)) / 2;
        return Object.assign({
          _voronoiX: props2.voronoiDimension === "y" ? minDomain.x : voronoiX,
          _voronoiY: props2.voronoiDimension === "x" ? minDomain.y : voronoiY,
          eventKey: index2,
          childName: name2,
          continuous: continuous2,
          style: style2
        }, datum);
      });
    };
    if (props2.data) {
      return addMeta(props2.data);
    }
    const getData$12 = (childProps) => {
      const data = getData(childProps);
      return Array.isArray(data) && data.length > 0 ? data : void 0;
    };
    const iteratee = (child, childName) => {
      const childProps = child.props || {};
      const name2 = childProps.name || childName;
      const blacklist = props2.voronoiBlacklist || [];
      const blacklistStr = blacklist.filter((value) => !!value && typeof value.valueOf() === "string");
      const blacklistRegExp = blacklist.filter(_isRegExp);
      const isRegExpMatch = blacklistRegExp.some((regExp) => regExp.test(name2));
      if (!isDataComponent(child) || blacklistStr.includes(name2) || isRegExpMatch) {
        return null;
      }
      const getChildData2 = child.type && isFunction$1(child.type.getData) ? child.type.getData : getData$12;
      const childData = getChildData2(child.props);
      return childData ? addMeta(childData, name2, child) : null;
    };
    return reduceChildren(children2, iteratee, props2);
  }
  findPoints(datasets, point2) {
    return datasets.filter((d3) => {
      return point2._voronoiX === d3._voronoiX && point2._voronoiY === d3._voronoiY;
    });
  }
  withinRadius(point2, mousePosition, radius) {
    if (!point2) {
      return false;
    }
    if (!radius) {
      return true;
    }
    const {
      x: x3,
      y: y4
    } = mousePosition;
    const distanceSquared = Math.pow(x3 - point2[0], 2) + Math.pow(y4 - point2[1], 2);
    return distanceSquared < Math.pow(radius, 2);
  }
  getVoronoiPoints(props2, mousePosition) {
    const datasets = this.getDatasets(props2);
    const scaledData = datasets.map((d3) => {
      const {
        x: x3,
        y: y4
      } = scalePoint(props2, d3);
      return [x3, y4];
    });
    const delaunay = Delaunay.from(scaledData);
    const index2 = delaunay.find(mousePosition.x, mousePosition.y);
    const withinRadius = this.withinRadius(scaledData[index2], mousePosition, props2.radius);
    const points = withinRadius ? this.findPoints(datasets, datasets[index2]) : [];
    return {
      points,
      index: index2
    };
  }
  getActiveMutations(props2, point2) {
    const {
      childName,
      continuous: continuous2
    } = point2;
    const {
      activateData,
      activateLabels,
      labels
    } = props2;
    if (!activateData && !activateLabels) {
      return [];
    }
    const defaultTarget = activateData ? ["data"] : [];
    const targets = labels && !activateLabels ? defaultTarget : defaultTarget.concat("labels");
    if (_isEmpty(targets)) {
      return [];
    }
    return targets.map((target) => {
      const eventKey = continuous2 === true && target === "data" ? "all" : point2.eventKey;
      return {
        childName,
        eventKey,
        target,
        mutation: () => ({
          active: true
        })
      };
    });
  }
  getInactiveMutations(props2, point2) {
    const {
      childName,
      continuous: continuous2
    } = point2;
    const {
      activateData,
      activateLabels,
      labels
    } = props2;
    if (!activateData && !activateLabels) {
      return [];
    }
    const defaultTarget = activateData ? ["data"] : [];
    const targets = labels && !activateLabels ? defaultTarget : defaultTarget.concat("labels");
    if (_isEmpty(targets)) {
      return [];
    }
    return targets.map((target) => {
      const eventKey = continuous2 && target === "data" ? "all" : point2.eventKey;
      return {
        childName,
        eventKey,
        target,
        mutation: () => null
      };
    });
  }
  // eslint-disable-next-line max-params
  getParentMutation(activePoints, mousePosition, parentSVG, vIndex) {
    return [{
      target: "parent",
      eventKey: "parent",
      mutation: () => ({
        activePoints,
        mousePosition,
        parentSVG,
        vIndex
      })
    }];
  }
  onActivated(props2, points) {
    if (isFunction$1(props2.onActivated)) {
      props2.onActivated(points, props2);
    }
  }
  onDeactivated(props2, points) {
    if (isFunction$1(props2.onDeactivated)) {
      props2.onDeactivated(points, props2);
    }
  }
}
const VoronoiHelpers = new VoronoiHelpersClass();
function voronoiContainerMixin(Base) {
  var _a2;
  return _a2 = class extends Base {
    static defaultEvents(props2) {
      return [{
        target: "parent",
        eventHandlers: {
          onMouseLeave: (evt, targetProps) => {
            return props2.disable ? {} : VoronoiHelpers.onMouseLeave(evt, targetProps);
          },
          onTouchCancel: (evt, targetProps) => {
            return props2.disable ? {} : VoronoiHelpers.onMouseLeave(evt, targetProps);
          },
          onMouseMove: (evt, targetProps) => {
            return props2.disable ? {} : VoronoiHelpers.onMouseMove(evt, targetProps);
          },
          onTouchMove: (evt, targetProps) => {
            return props2.disable ? {} : VoronoiHelpers.onMouseMove(evt, targetProps);
          }
        }
      }, {
        target: "data",
        eventHandlers: props2.disable ? {} : {
          onMouseOver: () => null,
          onMouseOut: () => null,
          onMouseMove: () => null
        }
      }];
    }
    getDimension(props2) {
      const {
        horizontal,
        voronoiDimension
      } = props2;
      if (!horizontal || !voronoiDimension) {
        return voronoiDimension;
      }
      return voronoiDimension === "x" ? "y" : "x";
    }
    getPoint(point2) {
      const whitelist = ["_x", "_x1", "_x0", "_y", "_y1", "_y0"];
      return _pick(point2, whitelist);
    }
    getLabelPosition(props2, labelProps, points) {
      const {
        mousePosition,
        mouseFollowTooltips
      } = props2;
      const voronoiDimension = this.getDimension(props2);
      const point2 = this.getPoint(points[0]);
      const basePosition = scalePoint(props2, point2);
      let center = mouseFollowTooltips ? mousePosition : void 0;
      if (!voronoiDimension || points.length < 2) {
        return {
          ...basePosition,
          center: _defaults({}, labelProps.center, center)
        };
      }
      const x3 = voronoiDimension === "y" ? mousePosition.x : basePosition.x;
      const y4 = voronoiDimension === "x" ? mousePosition.y : basePosition.y;
      center = mouseFollowTooltips ? mousePosition : {
        x: x3,
        y: y4
      };
      return {
        x: x3,
        y: y4,
        center: _defaults({}, labelProps.center, center)
      };
    }
    getStyle(props2, points, type2) {
      const {
        labels,
        labelComponent,
        theme: theme2
      } = props2;
      const componentProps = labelComponent.props || {};
      const themeStyles = theme2 && theme2.voronoi && theme2.voronoi.style ? theme2.voronoi.style : {};
      const componentStyleArray = type2 === "flyout" ? componentProps.flyoutStyle : componentProps.style;
      return points.reduce((memo, datum, index2) => {
        const labelProps = _defaults({}, componentProps, {
          datum,
          active: true
        });
        const text2 = isFunction$1(labels) ? labels(labelProps) : void 0;
        const textArray = text2 !== void 0 ? `${text2}`.split("\n") : [];
        const baseStyle2 = datum.style && datum.style[type2] || {};
        const componentStyle = Array.isArray(componentStyleArray) ? componentStyleArray[index2] : componentStyleArray;
        const style2 = evaluateStyle(_defaults({}, componentStyle, baseStyle2, themeStyles[type2]), labelProps);
        const styleArray = textArray.length ? textArray.map(() => style2) : [style2];
        return memo.concat(styleArray);
      }, []);
    }
    getDefaultLabelProps(props2, points) {
      const {
        voronoiDimension,
        horizontal,
        mouseFollowTooltips
      } = props2;
      const point2 = this.getPoint(points[0]);
      const multiPoint = voronoiDimension && points.length > 1;
      const y4 = point2._y1 !== void 0 ? point2._y1 : point2._y;
      const defaultHorizontalOrientation = y4 < 0 ? "left" : "right";
      const defaultOrientation = y4 < 0 ? "bottom" : "top";
      const labelOrientation = horizontal ? defaultHorizontalOrientation : defaultOrientation;
      const orientation = mouseFollowTooltips ? void 0 : labelOrientation;
      return {
        orientation,
        pointerLength: multiPoint ? 0 : void 0,
        constrainToVisibleArea: multiPoint || mouseFollowTooltips ? true : void 0
      };
    }
    getLabelProps(props2, points) {
      const {
        labels,
        scale,
        labelComponent,
        theme: theme2,
        width,
        height
      } = props2;
      const componentProps = labelComponent.props || {};
      const text2 = points.reduce((memo, datum2) => {
        const labelProps2 = _defaults({}, componentProps, {
          datum: datum2,
          active: true
        });
        const t2 = isFunction$1(labels) ? labels(labelProps2) : null;
        if (t2 === null || t2 === void 0) {
          return memo;
        }
        return memo.concat(`${t2}`.split("\n"));
      }, []);
      const {
        childName,
        eventKey,
        style: style2,
        continuous: continuous2,
        ...datum
      } = points[0];
      const name2 = props2.name === childName ? childName : `${props2.name}-${childName}`;
      const labelProps = _defaults({
        key: `${name2}-${eventKey}-voronoi-tooltip`,
        id: `${name2}-${eventKey}-voronoi-tooltip`,
        active: true,
        renderInPortal: false,
        activePoints: points,
        datum,
        scale,
        theme: theme2
      }, componentProps, {
        text: text2,
        width,
        height,
        style: this.getStyle(props2, points, "labels"),
        flyoutStyle: this.getStyle(props2, points, "flyout")[0]
      }, this.getDefaultLabelProps(props2, points));
      const labelPosition = this.getLabelPosition(props2, labelProps, points);
      return _defaults({}, labelPosition, labelProps);
    }
    getTooltip(props2) {
      const {
        labels,
        activePoints,
        labelComponent
      } = props2;
      if (!labels) {
        return null;
      }
      if (Array.isArray(activePoints) && activePoints.length) {
        const labelProps = this.getLabelProps(props2, activePoints);
        const {
          text: text2
        } = labelProps;
        const showLabel = Array.isArray(text2) ? text2.filter(Boolean).length : text2;
        return showLabel ? /* @__PURE__ */ React__default.cloneElement(labelComponent, labelProps) : null;
      }
      return null;
    }
    // Overrides method in VictoryContainer
    getChildren(props2) {
      return [...React__default.Children.toArray(props2.children), this.getTooltip(props2)];
    }
  }, __publicField(_a2, "displayName", "VictoryVoronoiContainer"), __publicField(_a2, "defaultProps", {
    ...VictoryContainer.defaultProps,
    activateData: true,
    activateLabels: true,
    labelComponent: /* @__PURE__ */ React__default.createElement(VictoryTooltip, null),
    voronoiPadding: 5
  }), _a2;
}
const VictoryVoronoiContainer = voronoiContainerMixin(VictoryContainer);
const getCalculatedValues = (props2) => {
  let data = getData(props2);
  if (data.length < 2) {
    data = [];
  }
  const range2 = {
    x: getRange$1(props2, "x"),
    y: getRange$1(props2, "y")
  };
  const domain = {
    x: getDomain$3(props2, "x"),
    y: getDomain$3(props2, "y")
  };
  const scale = {
    x: getBaseScale(props2, "x").domain(domain.x).range(props2.horizontal ? range2.y : range2.x),
    y: getBaseScale(props2, "y").domain(domain.y).range(props2.horizontal ? range2.x : range2.y)
  };
  const origin = props2.polar ? props2.origin || getPolarOrigin(props2) : void 0;
  const defaultStyles2 = getDefaultStyles(props2, "line");
  const style2 = getStyles$4(props2.style, defaultStyles2);
  return {
    domain,
    data,
    scale,
    style: style2,
    origin
  };
};
const getBaseProps = (initialProps, fallbackProps2) => {
  const modifiedProps = modifyProps$1(initialProps, fallbackProps2, "line");
  const props2 = Object.assign({}, modifiedProps, getCalculatedValues(modifiedProps));
  const {
    data,
    domain,
    events,
    groupComponent,
    height,
    horizontal,
    interpolation,
    origin,
    padding: padding2,
    polar,
    scale,
    sharedEvents,
    standalone,
    style: style2,
    theme: theme2,
    width,
    labels,
    name: name2,
    disableInlineStyles
  } = props2;
  const initialChildProps = {
    parent: {
      style: style2.parent,
      scale,
      data,
      height,
      width,
      name: name2,
      domain,
      standalone,
      polar,
      origin,
      padding: padding2,
      horizontal
    },
    all: {
      data: {
        horizontal,
        polar,
        origin,
        scale,
        data,
        interpolation,
        groupComponent,
        style: disableInlineStyles ? {} : style2.data,
        theme: theme2,
        disableInlineStyles
      }
    }
  };
  return data.reduce((childProps, datum, index2) => {
    const text2 = getText(props2, datum, index2);
    if (text2 !== void 0 && text2 !== null || labels && (events || sharedEvents)) {
      const eventKey = !isNil(datum.eventKey) ? datum.eventKey : index2;
      childProps[eventKey] = {
        labels: getProps(props2, index2)
      };
    }
    return childProps;
  }, initialChildProps);
};
const evaluateProps = (props2) => {
  const ariaLabel = evaluateProp(props2.ariaLabel, props2);
  const id = evaluateProp(props2.id, props2);
  const style2 = evaluateStyle(Object.assign({
    fill: "none",
    stroke: "black",
    pointerEvents: "stroke"
  }, props2.style), props2);
  const tabIndex = evaluateProp(props2.tabIndex, props2);
  return Object.assign({}, props2, {
    ariaLabel,
    id,
    style: style2,
    tabIndex
  });
};
const defaultProps = {
  pathComponent: /* @__PURE__ */ React__default.createElement(Path$1, null),
  role: "presentation",
  shapeRendering: "auto"
};
const Curve = (initialProps) => {
  const props2 = evaluateProps(_defaults({}, initialProps, defaultProps));
  const userProps = getSafeUserProps(props2);
  const {
    polar,
    origin
  } = props2;
  const lineFunction = getLineFunction(props2);
  const defaultTransform = polar && origin ? `translate(${origin.x}, ${origin.y})` : void 0;
  const d3 = lineFunction(props2.data);
  return /* @__PURE__ */ React__default.cloneElement(props2.pathComponent, {
    ...props2.events,
    ...userProps,
    "aria-label": props2.ariaLabel,
    d: d3,
    style: props2.style,
    transform: props2.transform || defaultTransform,
    className: props2.className,
    role: props2.role,
    shapeRendering: props2.shapeRendering,
    clipPath: props2.clipPath,
    tabIndex: props2.tabIndex
  });
};
const fallbackProps = {
  width: 450,
  height: 300,
  padding: 50,
  interpolation: "linear"
};
const options = {
  components: [{
    name: "parent",
    index: "parent"
  }, {
    name: "data",
    index: "all"
  }, {
    name: "labels"
  }]
};
const _VictoryLineBase = class _VictoryLineBase extends React__default.Component {
  constructor(props2) {
    super(props2);
  }
  static getBaseProps(props2) {
    return getBaseProps(props2, fallbackProps);
  }
  // Overridden in native versions
  shouldAnimate() {
    return !!this.props.animate;
  }
  render() {
    const {
      animationWhitelist,
      role
    } = _VictoryLineBase;
    const props2 = modifyProps$1(this.props, fallbackProps, role);
    if (this.shouldAnimate()) {
      return this.animateComponent(props2, animationWhitelist);
    }
    const children2 = this.renderContinuousData(props2);
    const component = props2.standalone ? this.renderContainer(props2.containerComponent, children2) : children2;
    return withSafeUserProps(component, props2);
  }
};
__publicField(_VictoryLineBase, "animationWhitelist", ["data", "domain", "height", "padding", "samples", "style", "width"]);
__publicField(_VictoryLineBase, "displayName", "VictoryLine");
__publicField(_VictoryLineBase, "role", "line");
__publicField(_VictoryLineBase, "defaultTransitions", continuousTransitions());
__publicField(_VictoryLineBase, "defaultPolarTransitions", continuousPolarTransitions());
__publicField(_VictoryLineBase, "continuous", true);
__publicField(_VictoryLineBase, "defaultProps", {
  containerComponent: /* @__PURE__ */ React__default.createElement(VictoryContainer, null),
  dataComponent: /* @__PURE__ */ React__default.createElement(Curve, null),
  labelComponent: /* @__PURE__ */ React__default.createElement(VictoryLabel, {
    renderInPortal: true
  }),
  groupComponent: /* @__PURE__ */ React__default.createElement(VictoryClipContainer, null),
  samples: 50,
  sortKey: "x",
  sortOrder: "ascending",
  standalone: true,
  theme: VictoryTheme.grayscale
});
__publicField(_VictoryLineBase, "getDomain", getDomain$3);
__publicField(_VictoryLineBase, "getData", getData);
__publicField(_VictoryLineBase, "expectedComponents", ["dataComponent", "labelComponent", "groupComponent", "containerComponent"]);
let VictoryLineBase = _VictoryLineBase;
const VictoryLine = addEvents(VictoryLineBase, options);
const VictoryAnimationJSXComponent = VictoryAnimation;
const OdometerNumber = ({
  component = /* @__PURE__ */ jsxRuntimeExports.jsx(DataWrapper, {}),
  data = 0,
  delay = 0,
  duration = void 0,
  easing = "expOut",
  ...restOfProps
}) => {
  const [, setUpdate] = useState(/* @__PURE__ */ new Date());
  useEffect(() => {
    setUpdate(/* @__PURE__ */ new Date());
  }, [data]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    VictoryAnimationJSXComponent,
    {
      data: [{ number: data }],
      delay,
      duration,
      easing,
      ...restOfProps,
      children: (newData) => React__default.cloneElement(component, {
        data: newData == null ? void 0 : newData.number
      })
    }
  );
};
const DataWrapper = ({ data = void 0 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: data });
const DEFAULT_CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});
const NumberCurrency = ({
  formatter = DEFAULT_CURRENCY_FORMATTER,
  data = void 0,
  isAbsoluteValue = false
}) => {
  const finalData = data && isAbsoluteValue ? Math.abs(data) : data;
  const currency = formatter && (finalData || finalData === 0) ? formatter.format(finalData) : finalData;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Number.isNaN(finalData) || currency === "$NaN" || currency == null ? " " : currency });
};
const AccountBalance = ({
  _accountBalanceAnimationDuration,
  data,
  currencyFormatter,
  dataTestUniqueId
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Title,
    {
      as: "span",
      dataTestId: `balances-total-value-${dataTestUniqueId}`,
      variant: TitleSizes$1.Title32,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        OdometerNumber,
        {
          component: /* @__PURE__ */ jsxRuntimeExports.jsx(NumberCurrency, { formatter: currencyFormatter }),
          data,
          duration: _accountBalanceAnimationDuration
        }
      )
    }
  );
};
const ACCOUNT_BALANCE_DURATION = Number(Durations.Duration75);
const infoDisplayTransition = {
  from: { opacity: 0 },
  enter: { opacity: 1 },
  leave: { opacity: 0 },
  delay: Number(Durations.Duration150),
  config: config.default
};
const getAnimationThemeState = ({
  chartOnEnterDuration,
  chartOnExitDuration,
  chartOnLoadDuration,
  yDataStartFactor
}) => {
  if (typeof chartOnEnterDuration === "string") {
    chartOnEnterDuration = parseInt(chartOnEnterDuration, 10);
  }
  if (typeof chartOnExitDuration === "string") {
    chartOnExitDuration = parseInt(chartOnExitDuration, 10);
  }
  if (typeof chartOnLoadDuration === "string") {
    chartOnLoadDuration = parseInt(chartOnLoadDuration, 10);
  }
  return {
    easing: "cubicOut",
    // specific to d3 easing values
    duration: chartOnEnterDuration,
    onLoad: {
      duration: chartOnLoadDuration,
      before: (datum) => ({
        _y: datum._y * yDataStartFactor,
        opacity: 0
      }),
      after: (datum) => ({ _y: datum._y, opacity: 1 })
    },
    onEnter: {
      // duration: chartOnEnterDuration,  // This does not work. So using chartOnEnterDuration for the overall chart duration.
      before: (datum) => ({
        _y: datum._y * yDataStartFactor,
        opacity: 0
      }),
      after: (datum) => ({ _y: datum._y, opacity: 1 })
    },
    onExit: {
      duration: chartOnExitDuration,
      before: (datum) => ({
        _y: datum._y * yDataStartFactor,
        opacity: 0
      }),
      after: (datum) => ({ _y: datum._y, opacity: 1 })
    }
  };
};
const animationTheme = getAnimationThemeState({
  chartOnEnterDuration: Number(Durations.Duration350),
  chartOnExitDuration: Number(Durations.Duration200),
  chartOnLoadDuration: Number(Durations.Duration0),
  yDataStartFactor: 1
});
const AnimatedBox = animated(Box$1);
const AccountCurrencyDisplay = ({
  formatter = void 0,
  data,
  dataTestId = void 0
}) => {
  const transitions2 = useTransition(data, infoDisplayTransition);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: transitions2(({ opacity: opacity2 }, currData) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    AnimatedBox,
    {
      "data-test-id": dataTestId,
      style: {
        opacity: opacity2,
        position: "absolute",
        top: 0,
        left: 0
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(NumberCurrency, { data: currData, formatter })
    }
  )) });
};
const DEFAULT_PERCENTAGE_FORMATTER_ARGS = {
  locale: "default",
  options: {
    style: "percent",
    maximumFractionDigits: 1,
    minimumFractionDigits: 1
  }
};
const NumberPercentage = ({
  data,
  isAbsoluteValue = false,
  locale: locale2 = DEFAULT_PERCENTAGE_FORMATTER_ARGS.locale,
  maximumFractionDigits = DEFAULT_PERCENTAGE_FORMATTER_ARGS.options.maximumFractionDigits,
  minimumFractionDigits = DEFAULT_PERCENTAGE_FORMATTER_ARGS.options.minimumFractionDigits
}) => {
  const finalData = data && isAbsoluteValue ? Math.abs(data) : data;
  const formatter = new Intl.NumberFormat(locale2, {
    style: DEFAULT_PERCENTAGE_FORMATTER_ARGS.options.style,
    maximumFractionDigits: maximumFractionDigits || DEFAULT_PERCENTAGE_FORMATTER_ARGS.options.maximumFractionDigits,
    minimumFractionDigits: minimumFractionDigits || DEFAULT_PERCENTAGE_FORMATTER_ARGS.options.minimumFractionDigits
  });
  const percent = formatter && (finalData || finalData === 0) ? formatter.format(finalData) : finalData;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Number.isNaN(finalData) || percent === "NaN%" || percent == null ? " " : percent });
};
const DeltaDisplay = ({
  a11yDescription,
  rate,
  amount,
  timeFrameText,
  selectedTimeFrame = void 0
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Box$1, { "aria-live": "polite", "data-test-id": "delta-display-button", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      VisuallyHidden,
      {
        "data-test-id": "delta-display-description",
        id: uniqueId$1("delta-display-description-"),
        children: [
          a11yDescription,
          " ",
          rate > 0 ? "up" : "down"
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        "data-test-id": "delta-display-value",
        sx: styles$4.content,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "center", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Icon,
            {
              color: rate >= 0 ? "icon.success" : "icon.error",
              name: rate >= 0 ? "caretUp" : "caretDown",
              size: IconSizes.Icon12
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Span,
            {
              color: "primary",
              variant: ParagraphSizes.Paragraph14,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                NumberPercentage,
                {
                  data: rate,
                  isAbsoluteValue: true,
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                }
              )
            },
            "deltaRate"
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Span, { color: "primary", variant: ParagraphSizes.Paragraph14, children: [
            " (",
            amount > 0 ? "+" : null,
            /* @__PURE__ */ jsxRuntimeExports.jsx(NumberCurrency, { data: amount }),
            ")"
          ] }),
          selectedTimeFrame && (timeFrameText == null ? void 0 : timeFrameText[selectedTimeFrame]) ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Span, { color: "primary", variant: ParagraphSizes.Paragraph14, children: [
            " ",
            timeFrameText[selectedTimeFrame]
          ] }) : null
        ] })
      }
    )
  ] });
};
const styles$4 = {
  content: {
    left: 0,
    minWidth: "44px",
    // deltaDisplay can have a single-digit number, so this makes sure the tap target width stays 44px
    whiteSpace: "nowrap"
  }
};
const HiddenStillInDOM = ({ children: children2 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  Box,
  {
    "aria-hidden": "true",
    sx: { color: "transparent", lineHeight: 0, transform: "scaleY(0)" },
    children: children2
  }
);
const ChartDisclaimer = ({
  accountBalanceDisclaimer
}) => {
  const [disclaimerId] = useState(() => uniqueId$1("portfolio-chart-"));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip.Source, { trigger: Triggers.hover, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        "aria-labelledby": disclaimerId,
        "data-test-id": "disclaimer-button",
        name: "questionCircle",
        size: IconSizes.Icon16,
        sx: {
          // TODO: RNDUX-767 Adjust Portfolio Chart styling to only be in themes.
          WebkitTapHighlightColor: "rgba(0,0,0,0)"
          // no blue highlight when tapping on icon button in mobile
        }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tooltip.Content,
      {
        placementOverride: {
          position: Alignment.bottom,
          positionAndAlignment: "bottom"
        },
        sx: {
          px: "1rem",
          py: "1rem",
          textAlign: "left",
          width: "250px"
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "aria-live": "assertive", id: disclaimerId, children: accountBalanceDisclaimer })
      }
    )
  ] });
};
const AnimatedFlex = animated(Flex);
const AccountInfo = ({
  _accountBalanceAnimationDuration,
  accountBalanceTitle,
  accountBalanceDisclaimer,
  balance,
  currencyFormatter,
  dataTestUniqueId,
  delta,
  isZeroed,
  subAccountsData = [],
  selectedTimeFrame,
  type: type2
}) => {
  const hasSubAccounts = subAccountsData.length > 0;
  const hideDelta = Math.abs(delta.amount) === 0 && Math.abs(delta.rate) === 0;
  const zeroCurrencyFormatter = isZeroed ? new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  }) : void 0;
  const finalCurrencyFormatter = currencyFormatter || zeroCurrencyFormatter;
  const {
    matchMediaQuery: { smDown }
  } = useMatchMedia();
  const { theme: theme2 } = useTheme();
  const willDisplaySubAccounts = hasSubAccounts && smDown === false;
  const transitions2 = useTransition(willDisplaySubAccounts, {
    initial: null,
    // don't animate on initial load
    config: theme2.animations.accountInfo.physics.type,
    from: theme2.animations.accountInfo.from,
    enter: theme2.animations.accountInfo.enter,
    leave: theme2.animations.accountInfo.leave,
    delay: Number(Durations.Duration200)
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 1, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(HStack, { align: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Title,
          {
            "aria-level": "2",
            as: "span",
            sx: {
              ...theme2.charts.portfolioCharts[type2].accountInfoTitle
            },
            variant: ACCOUNT_INFO_TITLE_SIZE,
            children: accountBalanceTitle
          }
        ),
        accountBalanceDisclaimer ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          ChartDisclaimer,
          {
            accountBalanceDisclaimer
          }
        ) : null
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 0, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          AccountBalance,
          {
            _accountBalanceAnimationDuration,
            currencyFormatter: finalCurrencyFormatter,
            data: balance,
            dataTestUniqueId
          }
        ),
        isZeroed || hideDelta ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(DeltaDisplay, { ...delta, selectedTimeFrame })
      ] })
    ] }),
    transitions2(
      ({ height, marginTop, opacity: opacity2 }, willDisplay) => willDisplay ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        AnimatedFlex,
        {
          flexDirection: "row",
          spacing: 1,
          style: {
            height: height.to((h3) => `${h3}rem`),
            opacity: opacity2,
            marginTop: marginTop.to((mt) => `${mt}rem`)
          },
          children: subAccountsData.map(({ accountName, amount }) => {
            const cleanedAccountName = accountName.replace(/\s/g, "").toLowerCase();
            return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(Box, { sx: { position: "relative" }, children: [
                " ",
                /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "span", variant: TitleSizes$1.Title14, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  AccountCurrencyDisplay,
                  {
                    data: amount,
                    dataTestId: `balances-${cleanedAccountName}`,
                    formatter: finalCurrencyFormatter
                  }
                ) })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Title,
                {
                  as: "div",
                  color: TextColors.tertiary,
                  variant: TitleSizes$1.Title14,
                  children: accountName
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(HiddenStillInDOM, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                NumberCurrency,
                {
                  data: amount,
                  formatter: finalCurrencyFormatter
                }
              ) })
            ] }, accountName);
          })
        }
      ) : null
    )
  ] }) });
};
const portfolioChartColors = {
  area: {
    stroke: {
      default: combinedPalettes$1["dusk-50"],
      disabled: combinedPalettes$1["fog-30"]
    },
    surface: {
      empty: {
        stop1offset: "0%",
        stop1color: combinedPalettes$1["fog-00"],
        stop1opacity: "0.2",
        stop2offset: "50%",
        stop2color: combinedPalettes$1["fog-20"],
        stop2opacity: "0.1",
        stop3offset: "100%",
        stop3color: combinedPalettes$1["fog-20"],
        stop3opacity: "0.5"
      },
      loading: {
        stop1offset: "0%",
        stop1color: combinedPalettes$1["fog-00"],
        stop1opacity: "0.1",
        stop2offset: "100%",
        stop2color: combinedPalettes$1["fog-20"],
        stop2opacity: "0.7"
      },
      normal: {
        stop1offset: "0%",
        stop1color: combinedPalettes$1["fog-00"],
        stop1opacity: "0.1",
        stop2offset: "100%",
        stop2color: combinedPalettes$1["dusk-40"],
        stop2opacity: "0.1"
      }
    }
  },
  axis: {
    axis: {
      fill: "none",
      stroke: "none"
    },
    grid: {
      fill: "none",
      stroke: "none"
    },
    ticks: {
      fill: "none",
      stroke: "none"
    }
  },
  tooltip: {
    lineColor: combinedPalettes$1["fog-50"],
    text: text$2.white
  },
  flyout: {
    background: surface.dark
  }
};
const PortfolioEmptyStateGradient = ({ id }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id, x1: "0", x2: "0", y1: "1", y2: "0", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.empty.stop1offset,
      stopColor: portfolioChartColors.area.surface.empty.stop1color,
      stopOpacity: portfolioChartColors.area.surface.empty.stop1opacity
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.empty.stop2offset,
      stopColor: portfolioChartColors.area.surface.empty.stop2color,
      stopOpacity: portfolioChartColors.area.surface.empty.stop2opacity
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.empty.stop3offset,
      stopColor: portfolioChartColors.area.surface.empty.stop3color,
      stopOpacity: portfolioChartColors.area.surface.empty.stop3opacity
    }
  )
] });
const PortfolioLoadingGradient = ({ id }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id, x1: "0", x2: "0", y1: "1", y2: "0", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.loading.stop1offset,
      stopColor: portfolioChartColors.area.surface.loading.stop1color,
      stopOpacity: portfolioChartColors.area.surface.loading.stop1opacity
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.loading.stop2offset,
      stopColor: portfolioChartColors.area.surface.loading.stop2color,
      stopOpacity: portfolioChartColors.area.surface.loading.stop2opacity
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "animate",
    {
      attributeName: "y1",
      dur: `${Durations.Duration3000}ms`,
      repeatCount: "indefinite",
      values: "0;1;0"
    }
  )
] });
const PortfolioNormalGradient = ({ id }) => /* @__PURE__ */ jsxRuntimeExports.jsxs("linearGradient", { id, x1: "0", x2: "0", y1: "1", y2: "0", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.normal.stop1offset,
      stopColor: portfolioChartColors.area.surface.normal.stop1color,
      stopOpacity: portfolioChartColors.area.surface.normal.stop1opacity
    }
  ),
  /* @__PURE__ */ jsxRuntimeExports.jsx(
    "stop",
    {
      offset: portfolioChartColors.area.surface.normal.stop2offset,
      stopColor: portfolioChartColors.area.surface.normal.stop2color,
      stopOpacity: portfolioChartColors.area.surface.normal.stop2opacity
    }
  )
] });
const emptyStateGradientId = "portfolioEmptyStateGradient";
const loadingGradientId = "portfolioLoadingGradient";
const normalGradientId = "portfolioNormalGradient";
const ChartGradient = ({
  chartState = PortfolioChartStates.DISPLAYING
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { role: "presentation", style: { height: 0 }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("defs", { children: [
  shouldDisplayEmptyStateGradient(chartState) ? /* @__PURE__ */ jsxRuntimeExports.jsx(PortfolioEmptyStateGradient, { id: emptyStateGradientId }) : null,
  shouldDisplayLoadingGradient(chartState) ? /* @__PURE__ */ jsxRuntimeExports.jsx(PortfolioLoadingGradient, { id: loadingGradientId }) : null,
  shouldDisplayNormalGradient(chartState) ? /* @__PURE__ */ jsxRuntimeExports.jsx(PortfolioNormalGradient, { id: normalGradientId }) : null
] }) });
const shouldDisplayEmptyStateGradient = (chartState) => [
  PortfolioChartStates.ANIMATING_ON_LOAD,
  PortfolioChartStates.EMPTY_CHART,
  PortfolioChartStates.EMPTY_W_CTA,
  PortfolioChartStates.UNKNOWN
].includes(chartState);
const shouldDisplayNormalGradient = (chartState) => [
  PortfolioChartStates.DISPLAYING,
  PortfolioChartStates.NEW_DATA_LOADED
].includes(chartState);
const shouldDisplayLoadingGradient = (chartState) => [PortfolioChartStates.LOADING].includes(chartState);
const getPortfolioGradientId = (chartState = PortfolioChartStates.DISPLAYING) => {
  if (shouldDisplayEmptyStateGradient(chartState)) {
    return emptyStateGradientId;
  }
  if (shouldDisplayNormalGradient(chartState)) {
    return normalGradientId;
  }
  if (shouldDisplayLoadingGradient(chartState)) {
    return loadingGradientId;
  }
};
const isDisabledState = (chartState) => [
  PortfolioChartStates.ANIMATING_ON_LOAD,
  PortfolioChartStates.EMPTY_CHART,
  PortfolioChartStates.EMPTY_W_CTA,
  PortfolioChartStates.LOADING
].includes(chartState);
const xxsSmallMax = 300;
const xSmallMin = xxsSmallMax + 1;
const xSmallMax = 400;
const smallMin = xSmallMax + 1;
const smallMax = 500;
const mediumMin = smallMax + 1;
const mediumMax = 600;
const largeMin = mediumMax + 1;
const largeMax = 700;
const xLargeMin = largeMax + 1;
const xLargeMax = 800;
const xxLargeMin = xLargeMax + 1;
const apsectRatioSizes = {
  [AspectRatios.Ratio3x1]: {
    width: 300,
    height: 100
  },
  [AspectRatios.Ratio4x1]: {
    width: 400,
    height: 100
  },
  [AspectRatios.Ratio6x1]: {
    width: 600,
    height: 100
  },
  [AspectRatios.Ratio12x1]: {
    width: 1200,
    height: 100
  }
};
const chartHitTargetOffset = 10;
const domainScale = {
  y: {
    min: 0.98,
    max: 1.02
  }
};
const aspectRatiosLegacyDashboard = {
  default: [AspectRatios.Ratio4x1, apsectRatioSizes.Ratio4x1],
  values: {
    xxs: [AspectRatios.Ratio4x1, apsectRatioSizes.Ratio4x1],
    xs: [AspectRatios.Ratio4x1, apsectRatioSizes.Ratio4x1],
    sm: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    md: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    lg: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    xl: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    xxl: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1]
  }
};
const aspectRatiosLegacyFullPageWidth = {
  default: [AspectRatios.Ratio12x1, apsectRatioSizes.Ratio12x1],
  values: {
    xxs: [AspectRatios.Ratio4x1, apsectRatioSizes.Ratio4x1],
    xs: [AspectRatios.Ratio4x1, apsectRatioSizes.Ratio4x1],
    sm: [AspectRatios.Ratio4x1, apsectRatioSizes.Ratio4x1],
    md: [AspectRatios.Ratio12x1, apsectRatioSizes.Ratio12x1],
    lg: [AspectRatios.Ratio12x1, apsectRatioSizes.Ratio12x1],
    xl: [AspectRatios.Ratio12x1, apsectRatioSizes.Ratio12x1],
    xxl: [AspectRatios.Ratio12x1, apsectRatioSizes.Ratio12x1]
  }
};
const aspectRatiosDefault = {
  default: [AspectRatios.Ratio3x1, apsectRatioSizes.Ratio3x1],
  values: {
    xxs: [AspectRatios.Ratio3x1, apsectRatioSizes.Ratio3x1],
    xs: [AspectRatios.Ratio3x1, apsectRatioSizes.Ratio3x1],
    sm: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    md: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    lg: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    xl: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1],
    xxl: [AspectRatios.Ratio6x1, apsectRatioSizes.Ratio6x1]
  }
};
const flyoutPaddings = {
  top: 10,
  bottom: 10
};
const aspectRatioBreakpointStylings = {
  [AspectRatios.Ratio3x1]: {
    xxs: {
      axisTickLabelsFont: FontSizes.Font12,
      axisTickLabelsPadding: 9,
      chartPaddingBottom: 29,
      flyoutCornerRadius: 3.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.75,
        bottom: flyoutPaddings.bottom,
        left: 2.75
      },
      tooltipFontSize: FontSizes.Font12,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 22
    },
    xs: {
      axisTickLabelsFont: FontSizes.Font10,
      axisTickLabelsPadding: 8,
      chartPaddingBottom: 25,
      flyoutCornerRadius: 3.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.5,
        bottom: flyoutPaddings.bottom,
        left: 2.5
      },
      tooltipFontSize: FontSizes.Font10,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 18
    },
    sm: {
      axisTickLabelsFont: FontSizes.Font8,
      axisTickLabelsPadding: 5,
      chartPaddingBottom: 19,
      flyoutCornerRadius: 3,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.25,
        bottom: flyoutPaddings.bottom,
        left: 2.25
      },
      tooltipFontSize: FontSizes.Font8,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 16
    },
    md: {
      axisTickLabelsFont: FontSizes.Font6,
      axisTickLabelsPadding: 3,
      chartPaddingBottom: 16,
      flyoutCornerRadius: 2.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.25,
        bottom: flyoutPaddings.bottom,
        left: 2.25
      },
      tooltipFontSize: FontSizes.Font6,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 13
    },
    lg: {
      axisTickLabelsFont: FontSizes.Font5,
      axisTickLabelsPadding: 3,
      chartPaddingBottom: 13,
      flyoutCornerRadius: 2.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 1.75,
        bottom: flyoutPaddings.bottom,
        left: 1.75
      },
      tooltipFontSize: FontSizes.Font5,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 11
    },
    xl: {
      axisTickLabelsFont: FontSizes.Font5,
      axisTickLabelsPadding: 3,
      chartPaddingBottom: 12,
      flyoutCornerRadius: 2,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 1.75,
        bottom: flyoutPaddings.bottom,
        left: 1.75
      },
      tooltipFontSize: FontSizes.Font5,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 9
    },
    xxl: {
      axisTickLabelsFont: FontSizes.Font4,
      axisTickLabelsPadding: 1,
      chartPaddingBottom: 9,
      flyoutCornerRadius: 1.5,
      flyoutPadding: { top: 0.75, right: 1.5, bottom: 0.75, left: 1.5 },
      tooltipFontSize: FontSizes.Font4,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 9
    }
  },
  [AspectRatios.Ratio4x1]: {
    xxs: {
      axisTickLabelsFont: FontSizes.Font12,
      axisTickLabelsPadding: 9,
      chartPaddingBottom: 30,
      flyoutCornerRadius: 3.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.75,
        bottom: flyoutPaddings.bottom,
        left: 2.75
      },
      tooltipFontSize: FontSizes.Font12,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 25
    },
    xs: {
      axisTickLabelsFont: FontSizes.Font12,
      axisTickLabelsPadding: 9,
      chartPaddingBottom: 29,
      flyoutCornerRadius: 3.5,
      flyoutPadding: {
        top: flyoutPaddings.top + 2,
        right: 4.75,
        bottom: flyoutPaddings.bottom + 2,
        left: 4.75
      },
      tooltipFontSize: FontSizes.Font12,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 21
    },
    sm: {
      axisTickLabelsFont: FontSizes.Font10,
      axisTickLabelsPadding: 7,
      chartPaddingBottom: 23,
      flyoutCornerRadius: 3.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.5,
        bottom: flyoutPaddings.bottom,
        left: 2.5
      },
      tooltipFontSize: FontSizes.Font10,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 18
    },
    md: {
      axisTickLabelsFont: FontSizes.Font8,
      axisTickLabelsPadding: 5,
      chartPaddingBottom: 17,
      flyoutCornerRadius: 3,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.25,
        bottom: flyoutPaddings.bottom,
        left: 2.25
      },
      tooltipFontSize: FontSizes.Font8,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 15
    },
    lg: {
      axisTickLabelsFont: FontSizes.Font8,
      axisTickLabelsPadding: 5,
      chartPaddingBottom: 17,
      flyoutCornerRadius: 3,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.25,
        bottom: flyoutPaddings.bottom,
        left: 2.25
      },
      tooltipFontSize: FontSizes.Font8,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 14
    },
    xl: {
      axisTickLabelsFont: FontSizes.Font6,
      axisTickLabelsPadding: 5,
      chartPaddingBottom: 15,
      flyoutCornerRadius: 2,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.25,
        bottom: flyoutPaddings.bottom,
        left: 2.25
      },
      tooltipFontSize: FontSizes.Font6,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 12
    },
    xxl: {
      axisTickLabelsFont: FontSizes.Font6,
      axisTickLabelsPadding: 2,
      chartPaddingBottom: 12,
      flyoutCornerRadius: 2,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.25,
        bottom: flyoutPaddings.bottom,
        left: 2.25
      },
      tooltipFontSize: FontSizes.Font6,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 11
    }
  },
  [AspectRatios.Ratio6x1]: {
    xxs: {
      axisTickLabelsFont: FontSizes.Font18,
      axisTickLabelsPadding: 15,
      chartPaddingBottom: 41,
      flyoutCornerRadius: 6,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 7,
        bottom: flyoutPaddings.bottom,
        left: 7
      },
      tooltipFontSize: FontSizes.Font18,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 30
    },
    xs: {
      axisTickLabelsFont: FontSizes.Font16,
      axisTickLabelsPadding: 10,
      chartPaddingBottom: 34,
      flyoutCornerRadius: 5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 4.5,
        bottom: flyoutPaddings.bottom,
        left: 4.5
      },
      tooltipFontSize: FontSizes.Font16,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 30
    },
    /* Page at full width and default on Legacy Dashboard layout */
    sm: {
      axisTickLabelsFont: FontSizes.Font14,
      axisTickLabelsPadding: 5,
      chartPaddingBottom: 30,
      flyoutCornerRadius: 4,
      flyoutPadding: {
        top: flyoutPaddings.top + 3,
        right: 6,
        bottom: flyoutPaddings.bottom + 3,
        left: 6
      },
      tooltipFontSize: FontSizes.Font14,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 30
    },
    md: {
      axisTickLabelsFont: FontSizes.Font12,
      axisTickLabelsPadding: 8,
      chartPaddingBottom: 30,
      flyoutCornerRadius: 3.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 3.75,
        bottom: flyoutPaddings.bottom,
        left: 3.75
      },
      tooltipFontSize: FontSizes.Font12,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 23
    },
    lg: {
      axisTickLabelsFont: FontSizes.Font10,
      axisTickLabelsPadding: 8,
      chartPaddingBottom: 28,
      flyoutCornerRadius: 3,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 5.25,
        bottom: flyoutPaddings.bottom,
        left: 5.25
      },
      tooltipFontSize: FontSizes.Font10,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 22
    },
    xl: {
      axisTickLabelsFont: FontSizes.Font9,
      axisTickLabelsPadding: 10,
      chartPaddingBottom: 26,
      flyoutCornerRadius: 3,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2.5,
        bottom: flyoutPaddings.bottom,
        left: 2.5
      },
      tooltipFontSize: FontSizes.Font10,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 17
    },
    xxl: {
      axisTickLabelsFont: FontSizes.Font8,
      axisTickLabelsPadding: 8,
      chartPaddingBottom: 22,
      flyoutCornerRadius: 2.5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 2,
        bottom: flyoutPaddings.bottom,
        left: 2
      },
      tooltipFontSize: FontSizes.Font8,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 15
    }
  },
  [AspectRatios.Ratio12x1]: {
    xxs: {
      axisTickLabelsFont: FontSizes.Font38,
      chartPaddingBottom: 90,
      axisTickLabelsPadding: 22,
      flyoutCornerRadius: 10,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 7,
        bottom: flyoutPaddings.bottom,
        left: 7
      },
      tooltipFontSize: FontSizes.Font38,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 60
    },
    xs: {
      axisTickLabelsFont: FontSizes.Font34,
      axisTickLabelsPadding: 22,
      chartPaddingBottom: 70,
      flyoutCornerRadius: 10,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 7,
        bottom: flyoutPaddings.bottom,
        left: 7
      },
      tooltipFontSize: FontSizes.Font34,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 53
    },
    sm: {
      axisTickLabelsFont: FontSizes.Font26,
      axisTickLabelsPadding: 20,
      chartPaddingBottom: 60,
      flyoutCornerRadius: 9,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 7,
        bottom: flyoutPaddings.bottom,
        left: 7
      },
      tooltipFontSize: FontSizes.Font26,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 45
    },
    md: {
      axisTickLabelsFont: FontSizes.Font22,
      axisTickLabelsPadding: 15,
      chartPaddingBottom: 49,
      flyoutCornerRadius: 8,
      flyoutPadding: {
        top: flyoutPaddings.top + 7,
        right: 7,
        bottom: flyoutPaddings.bottom + 7,
        left: 7
      },
      tooltipFontSize: FontSizes.Font22,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 39
    },
    lg: {
      axisTickLabelsFont: FontSizes.Font18,
      axisTickLabelsPadding: 10,
      chartPaddingBottom: 36,
      flyoutCornerRadius: 7,
      flyoutPadding: {
        top: flyoutPaddings.top + 5,
        right: 6,
        bottom: flyoutPaddings.bottom + 5,
        left: 6
      },
      tooltipFontSize: FontSizes.Font18,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 29
    },
    xl: {
      axisTickLabelsFont: FontSizes.Font16,
      axisTickLabelsPadding: 8,
      chartPaddingBottom: 33,
      flyoutCornerRadius: 6,
      flyoutPadding: {
        top: flyoutPaddings.top + 3,
        right: 6,
        bottom: flyoutPaddings.bottom + 3,
        left: 6
      },
      tooltipFontSize: FontSizes.Font16,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 28
    },
    xxl: {
      axisTickLabelsFont: FontSizes.Font12,
      axisTickLabelsPadding: 8,
      chartPaddingBottom: 31,
      flyoutCornerRadius: 5,
      flyoutPadding: {
        top: flyoutPaddings.top,
        right: 5,
        bottom: flyoutPaddings.bottom,
        left: 5
      },
      tooltipFontSize: FontSizes.Font12,
      tooltipLineHeight: 1.3,
      tooltipPaddingFromXAxis: 25
    }
  }
};
const browserOverrideStylings = {
  [AspectRatios.Ratio4x1]: {
    xs: {
      // If chart is small, but we are in desktop mode (browserWidth > mediumMax), then fonts should be smaller. Mobile mode should have larger fonts and won't be overriden by this browser override styling.
      condition: (browserWidth) => browserWidth >= mediumMax,
      styling: {
        axisTickLabelsFont: FontSizes.Font10,
        axisTickLabelsPadding: 7,
        chartPaddingBottom: 25,
        flyoutCornerRadius: 3.5,
        flyoutPadding: {
          top: flyoutPaddings.top,
          right: 3.5,
          bottom: flyoutPaddings.bottom,
          left: 3.5
        },
        tooltipFontSize: FontSizes.Font10,
        tooltipLineHeight: 1.3,
        tooltipPaddingFromXAxis: 13
      }
    }
  }
};
const getAspectRatioBreakpointSetup = (type2) => {
  switch (type2) {
    case PortfolioChartTypes.LEGACY_DASHBOARD: {
      return aspectRatiosLegacyDashboard;
    }
    case PortfolioChartTypes.LEGACY_FULL_PAGE_WIDTH: {
      return aspectRatiosLegacyFullPageWidth;
    }
    default: {
      return aspectRatiosDefault;
    }
  }
};
const chartEdgeHugOffsetsConfig = {
  [AspectRatios.Ratio3x1]: {
    defaultOffset: -chartHitTargetOffset,
    xxs: -chartHitTargetOffset,
    xs: -chartHitTargetOffset - 3,
    sm: -chartHitTargetOffset - 8,
    md: -chartHitTargetOffset - 11,
    lg: -chartHitTargetOffset - 15,
    xl: -chartHitTargetOffset - 19,
    xxl: -chartHitTargetOffset - 24
  },
  [AspectRatios.Ratio4x1]: {
    defaultOffset: -chartHitTargetOffset - 1,
    xxs: -chartHitTargetOffset + 2,
    xs: -chartHitTargetOffset,
    sm: -chartHitTargetOffset - 3,
    md: -chartHitTargetOffset - 6,
    lg: -chartHitTargetOffset - 8,
    xl: -chartHitTargetOffset - 12,
    xxl: -chartHitTargetOffset - 16
  },
  [AspectRatios.Ratio6x1]: {
    defaultOffset: -chartHitTargetOffset + 1,
    xxs: -chartHitTargetOffset + 5,
    xs: -chartHitTargetOffset + 2,
    sm: -chartHitTargetOffset + 2,
    md: -chartHitTargetOffset,
    lg: -chartHitTargetOffset - 2,
    xl: -chartHitTargetOffset - 3,
    xxl: -chartHitTargetOffset - 7
  },
  [AspectRatios.Ratio12x1]: {
    defaultOffset: -chartHitTargetOffset + 2,
    xxs: -chartHitTargetOffset + 7,
    xs: -chartHitTargetOffset + 7,
    sm: -chartHitTargetOffset + 6,
    md: -chartHitTargetOffset + 5,
    lg: -chartHitTargetOffset + 3,
    xl: -chartHitTargetOffset + 3,
    xxl: -chartHitTargetOffset + 2
  }
};
const tooltipLineStyle = {
  stroke: portfolioChartColors.tooltip.lineColor,
  strokeDasharray: "2",
  strokeWidth: "0.5"
};
const tooltipYOffsetFromMaxScale = 4;
const fontSize = 12;
const baseLabelStyles = {
  fontFamily: fonts$2 ? fonts$2.body : "inherit",
  fontSize,
  fill: text$2.tertiary
};
const portfolioChartStyleSetup = ({
  axisTickLabelsFont,
  axisTickLabelsPadding,
  chartPaddingBottom,
  chartSize,
  chartState,
  flyoutCornerRadius,
  flyoutPadding,
  isAxisTickColorTransparent,
  tooltipFontSize,
  tooltipLineHeight
}) => ({
  area: {
    style: {
      data: {
        stroke: isDisabledState(chartState) ? portfolioChartColors.area.stroke.disabled : portfolioChartColors.area.stroke.default,
        fill: `url(#${getPortfolioGradientId(chartState)})`
      }
    }
  },
  axis: {
    style: {
      axis: {
        fill: portfolioChartColors.axis.axis.fill,
        stroke: portfolioChartColors.axis.axis.stroke
      },
      axisLabel: {
        ...baseLabelStyles
      },
      grid: {
        fill: portfolioChartColors.axis.grid.fill,
        stroke: portfolioChartColors.axis.grid.stroke,
        pointerEvents: "painted"
      },
      ticks: {
        fill: portfolioChartColors.axis.ticks.fill,
        stroke: portfolioChartColors.axis.ticks.stroke,
        size: 1
      },
      tickLabels: {
        ...baseLabelStyles,
        fontSize: axisTickLabelsFont,
        ...isAxisTickColorTransparent && {
          fill: "transparent"
        },
        padding: axisTickLabelsPadding
      }
    },
    ...chartSize
  },
  chart: {
    padding: {
      left: chartHitTargetOffset,
      right: chartHitTargetOffset,
      top: 0,
      bottom: isAxisTickColorTransparent || !chartPaddingBottom ? 0 : chartPaddingBottom
    },
    ...chartSize
  },
  tooltip: {
    style: {
      fontFamily: fonts$2 ? fonts$2.body : "inherit",
      fill: portfolioChartColors.tooltip.text,
      fontSize: tooltipFontSize
    },
    cornerRadius: flyoutCornerRadius,
    flyoutPadding,
    flyoutStyle: {
      fill: portfolioChartColors.flyout.background,
      lineHeight: 4
    }
  },
  /* tooltipLabel doesn't exist on VictoryThemeDefinition. It was added because there doesn't seem to be a way to style a <VictoryLabel /> from this definition. These props are manually set in the lineHeight prop on <VictoryLabel /> inside <PortfolioTooltip />. */
  tooltipLabel: {
    style: {
      lineHeight: tooltipLineHeight
    }
  },
  voronoi: {
    ...chartSize,
    style: {
      labels: {
        lineHeight: 2.3
      }
    }
  }
});
const DEFAULT_CHART_CONTAINER_WIDTH = 500;
const getValueForBreakpoints = (componentWidth, defaultValue, values6) => {
  if (
    // eslint-disable-next-line eqeqeq
    componentWidth == void 0 || // eslint-disable-next-line eqeqeq
    values6 == void 0 || Object.keys(values6).length === 0
  ) {
    return defaultValue;
  }
  switch (true) {
    case componentWidth <= xxsSmallMax:
      return values6.xxs;
    case (componentWidth > xSmallMin && componentWidth <= xSmallMax):
      return values6.xs;
    case (componentWidth > smallMin && componentWidth <= smallMax):
      return values6.sm;
    case (componentWidth > mediumMin && componentWidth <= mediumMax):
      return values6.md;
    case (componentWidth > largeMin && componentWidth <= largeMax):
      return values6.lg;
    case (componentWidth > xLargeMin && componentWidth <= xLargeMax):
      return values6.xl;
    case componentWidth > xxLargeMin:
      return values6.xxl;
    default:
      return defaultValue;
  }
};
const getChartMediaQuery = (width) => getValueForBreakpoints(width, ChartMatchMediaQuery.md, {
  xxs: ChartMatchMediaQuery.xxs,
  xs: ChartMatchMediaQuery.xs,
  sm: ChartMatchMediaQuery.sm,
  md: ChartMatchMediaQuery.md,
  lg: ChartMatchMediaQuery.lg,
  xl: ChartMatchMediaQuery.xl,
  xxl: ChartMatchMediaQuery.xxl
});
const getChartAspectRatio = ({
  chartContainerWidth,
  getAspectRatioBreakpointSetup: getAspectRatioBreakpointSetup2,
  type: type2
}) => {
  const breakpointSetup = getAspectRatioBreakpointSetup2(type2);
  return getValueForBreakpoints(
    chartContainerWidth,
    breakpointSetup.default,
    breakpointSetup.values
  );
};
const defaultAspectRatioLayout = {
  axisTickLabelsFont: FontSizes.Font6,
  axisTickLabelsPadding: 5,
  chartPaddingBottom: 15,
  flyoutCornerRadius: 2,
  flyoutPadding: { top: 0.25, right: 2.25, bottom: 0.25, left: 2.25 },
  tooltipFontSize: FontSizes.Font6,
  tooltipLineHeight: 1.3,
  tooltipPaddingFromXAxis: 12
};
const getAspectRatioBreakpointStyling = ({
  aspectRatio,
  aspectRatioBreakpointStylings: aspectRatioBreakpointStylings2,
  chartContainerWidth,
  defaultLayout = defaultAspectRatioLayout
}) => {
  const chartMatchMediaQuery = getChartMediaQuery(chartContainerWidth);
  if (!aspectRatio || !chartMatchMediaQuery) {
    return defaultLayout;
  }
  const styling = aspectRatioBreakpointStylings2[aspectRatio][chartMatchMediaQuery];
  if (!styling) {
    return defaultLayout;
  }
  return styling;
};
const getAspectRatioBreakpointLayout = ({
  aspectRatioBreakpointData,
  aspectRatioBreakpointStylings: aspectRatioBreakpointStylings2,
  chartContainerWidth
}) => {
  const [aspectRatio] = aspectRatioBreakpointData;
  const aspectRatioStylingConfig = getAspectRatioBreakpointStyling({
    aspectRatio,
    chartContainerWidth,
    aspectRatioBreakpointStylings: aspectRatioBreakpointStylings2
  });
  return aspectRatioStylingConfig;
};
const getBrowserLayout = ({
  aspectRatioBreakpointData,
  browserWidth,
  browserOverrideStylings: browserOverrideStylings2,
  chartContainerWidth
}) => {
  var _a2;
  const [aspectRatio] = aspectRatioBreakpointData;
  const chartMatchMediaQuery = getChartMediaQuery(chartContainerWidth);
  const browserOverrideStylingsConfig = (_a2 = browserOverrideStylings2 == null ? void 0 : browserOverrideStylings2[aspectRatio]) == null ? void 0 : _a2[chartMatchMediaQuery];
  if (browserOverrideStylingsConfig && browserWidth && browserOverrideStylingsConfig.condition(browserWidth)) {
    return browserOverrideStylingsConfig.styling;
  }
  return void 0;
};
const memoizedPortfolioChartStyles = {};
const getPortfolioChartStyles = ({
  aspectRatioBreakpointStylings: aspectRatioBreakpointStylings2,
  browserOverrideStylings: browserOverrideStylings2,
  browserWidth,
  chartState,
  chartContainerWidth,
  displayXAxis,
  getAspectRatioBreakpointSetup: getAspectRatioBreakpointSetup2,
  portfolioChartId,
  portfolioChartStyleSetup: portfolioChartStyleSetup2,
  type: type2
}) => {
  if (!chartContainerWidth || chartContainerWidth === 0 && portfolioChartId) {
    if (memoizedPortfolioChartStyles[portfolioChartId]) {
      return memoizedPortfolioChartStyles[portfolioChartId];
    }
    return getPortfolioChartStyles({
      aspectRatioBreakpointStylings: aspectRatioBreakpointStylings2,
      browserOverrideStylings: browserOverrideStylings2,
      browserWidth,
      chartState,
      chartContainerWidth: DEFAULT_CHART_CONTAINER_WIDTH,
      displayXAxis,
      getAspectRatioBreakpointSetup: getAspectRatioBreakpointSetup2,
      portfolioChartId,
      portfolioChartStyleSetup: portfolioChartStyleSetup2,
      type: type2
    });
  }
  const aspectRatioBreakpointData = getChartAspectRatio({
    chartContainerWidth,
    getAspectRatioBreakpointSetup: getAspectRatioBreakpointSetup2,
    type: type2
  });
  const [, chartSize] = aspectRatioBreakpointData;
  const layout2 = getAspectRatioBreakpointLayout({
    aspectRatioBreakpointData,
    aspectRatioBreakpointStylings: aspectRatioBreakpointStylings2,
    chartContainerWidth
  });
  const {
    axisTickLabelsFont,
    axisTickLabelsPadding,
    chartPaddingBottom,
    flyoutCornerRadius,
    flyoutPadding,
    tooltipFontSize,
    tooltipLineHeight,
    tooltipPaddingFromXAxis
  } = layout2;
  let isAxisTickColorTransparent = false;
  if (chartState === PortfolioChartStates.ANIMATING_ON_LOAD || displayXAxis === false) {
    isAxisTickColorTransparent = true;
  }
  const browserLayout = getBrowserLayout({
    aspectRatioBreakpointData,
    browserOverrideStylings: browserOverrideStylings2,
    browserWidth,
    chartContainerWidth
  });
  const {
    axisTickLabelsFont: browserAxisTickLabelsFont,
    axisTickLabelsPadding: browserAxisTickLabelsPadding,
    chartPaddingBottom: browserChartPaddingBottom,
    flyoutCornerRadius: browserFlyoutCornerRadius,
    flyoutPadding: browserFlyoutPadding,
    tooltipFontSize: browserTooltipFontSize,
    tooltipLineHeight: browserTooltipLineHeight,
    tooltipPaddingFromXAxis: browserTooltipPaddingFromXAxis
  } = browserLayout || {};
  const chartStyle = portfolioChartStyleSetup2({
    axisTickLabelsFont: browserAxisTickLabelsFont || axisTickLabelsFont,
    axisTickLabelsPadding: browserAxisTickLabelsPadding || axisTickLabelsPadding,
    chartSize,
    chartState,
    chartPaddingBottom: browserChartPaddingBottom || chartPaddingBottom,
    flyoutCornerRadius: browserFlyoutCornerRadius || flyoutCornerRadius,
    flyoutPadding: browserFlyoutPadding || flyoutPadding,
    isAxisTickColorTransparent,
    tooltipFontSize: browserTooltipFontSize || tooltipFontSize,
    tooltipLineHeight: browserTooltipLineHeight || tooltipLineHeight,
    tooltipPaddingFromXAxis: browserTooltipPaddingFromXAxis || tooltipPaddingFromXAxis
  });
  if (chartStyle) {
    memoizedPortfolioChartStyles[portfolioChartId] = chartStyle;
  }
  return chartStyle;
};
const getTooltipLabelLineHeight = (id) => {
  var _a2, _b, _c;
  return ((_c = (_b = (_a2 = memoizedPortfolioChartStyles[id]) == null ? void 0 : _a2.tooltipLabel) == null ? void 0 : _b.style) == null ? void 0 : _c.lineHeight) || "";
};
const clearMemoizedPortfolioChartStyles = (portfolioChartId) => portfolioChartId && delete memoizedPortfolioChartStyles[portfolioChartId];
const getHugOffsetMargin = ({
  chartContainerWidth,
  getAspectRatioBreakpointSetup: getAspectRatioBreakpointSetup2,
  type: type2,
  chartHitTargetOffset: chartHitTargetOffset2
}) => {
  const [aspectRatio] = getChartAspectRatio({
    chartContainerWidth,
    getAspectRatioBreakpointSetup: getAspectRatioBreakpointSetup2,
    type: type2
  });
  const chartMediaQuery = getChartMediaQuery(chartContainerWidth);
  const offsetConfig = chartEdgeHugOffsetsConfig[aspectRatio];
  const globalDefaultOffset = -chartHitTargetOffset2;
  if (!offsetConfig) {
    return globalDefaultOffset;
  }
  const mediaQueryOffset = offsetConfig[chartMediaQuery];
  const { defaultOffset: aspectRatioDefaultOffset } = offsetConfig;
  if (!mediaQueryOffset) {
    return aspectRatioDefaultOffset;
  }
  return mediaQueryOffset;
};
const getChartState = ({
  chartData,
  isAnimateOnLoad,
  isEmptyState,
  isFinishedAnimatedOnLoad,
  isLoading
}) => {
  if (isEmptyState) {
    return PortfolioChartStates.EMPTY_CHART;
  }
  if (isAnimateOnLoad && isFinishedAnimatedOnLoad.current === false) {
    return PortfolioChartStates.ANIMATING_ON_LOAD;
  }
  if (isLoading) {
    return PortfolioChartStates.LOADING;
  }
  if (chartData) {
    return PortfolioChartStates.DISPLAYING;
  }
  return PortfolioChartStates.UNKNOWN;
};
const isZeroedState = (chartState) => [
  PortfolioChartStates.ANIMATING_ON_LOAD,
  PortfolioChartStates.EMPTY_CHART,
  PortfolioChartStates.EMPTY_W_CTA
].includes(chartState);
const getDerivedChartStateData = ({
  chartData,
  isAnimateOnLoad,
  isEmptyState,
  isFinishedAnimatedOnLoad,
  isLoading
}) => {
  const chartState = getChartState({
    chartData,
    isAnimateOnLoad,
    isEmptyState,
    isFinishedAnimatedOnLoad,
    isLoading
  });
  const isZeroed = isZeroedState(chartState);
  const isDisabled = isDisabledState(chartState);
  return {
    currentChartState: chartState,
    isZeroed,
    isDisabled
  };
};
const getDerivedChartData = ({
  accountBalance,
  chartData,
  isZeroed
}) => {
  var _a2;
  if (!((_a2 = chartData == null ? void 0 : chartData.data) == null ? void 0 : _a2.length)) {
    return {
      data: void 0,
      meta: {
        maxBalance: 0,
        minBalance: 0,
        returnAmt: 0,
        returnPerc: 0
      },
      firstBalance: 0,
      finalBalance: 0,
      firstDate: void 0,
      lastDate: void 0,
      lastReturnAmt: 0,
      lastReturnPerc: 0
    };
  }
  const { data, meta } = chartData;
  let newData = data.map((d3) => {
    var _a3, _b;
    if (!d3 || !d3.date) {
      return d3;
    }
    const [date2] = ((_b = (_a3 = d3.date) == null ? void 0 : _a3.split) == null ? void 0 : _b.call(_a3, "T")) || [];
    const utcDateISO = `${date2}T23:59:59.000Z`;
    return {
      date: new Date(utcDateISO),
      balance: d3.balance
    };
  });
  let onlyOneDataPtMinBalance;
  if (newData.length === 1) {
    const prevDaysData = {
      date: subDays(newData[0].date, 1),
      balance: 0
    };
    newData = [prevDaysData, newData[0]];
    onlyOneDataPtMinBalance = 0;
  }
  let firstDataPt = newData[0];
  let lastDataPt = newData[newData.length - 1];
  if (firstDataPt.date.getTime() > lastDataPt.date.getTime()) {
    newData.sort(
      (a4, b10) => a4.date.getTime() - b10.date.getTime()
    );
    firstDataPt = newData[0];
    lastDataPt = newData[newData.length - 1];
  }
  const emptyBalance = { balance: 0 };
  const { balance: firstBalance } = isZeroed ? emptyBalance : firstDataPt;
  const firstDate = firstDataPt.date;
  const { balance: lastBalance } = isZeroed ? emptyBalance : lastDataPt;
  const lastDate = lastDataPt.date;
  const { maxBalance, minBalance, returnAmt, returnPerc } = meta;
  const finalBalance = accountBalance ?? lastBalance;
  const newMeta = {
    isEmptyData: !!(meta == null ? void 0 : meta.isEmptyData),
    maxBalance: maxBalance ?? getMinMaxBalance(newData).max,
    minBalance: onlyOneDataPtMinBalance ?? minBalance ?? getMinMaxBalance(newData).min,
    returnAmt: returnAmt ?? 0,
    returnPerc: returnPerc ?? 0
  };
  const lastReturnAmt = newMeta.returnAmt;
  const lastReturnPerc = newMeta.returnPerc;
  return {
    data: newData,
    meta: newMeta,
    firstBalance,
    finalBalance,
    firstDate,
    lastDate,
    lastReturnAmt,
    lastReturnPerc
  };
};
const getDerivedSubAccountData = ({
  isZeroed,
  subAccountsData
}) => {
  return isZeroed && subAccountsData && Array.isArray(subAccountsData) && subAccountsData.length > 0 ? subAccountsData.map(({ accountName }) => ({
    accountName,
    amount: 0
  })) : subAccountsData;
};
const getDerivedPortfolioChartThemeData = ({
  browserWidth,
  chartContainerWidth,
  chartState,
  displayXAxis,
  portfolioChartId,
  type: type2
}) => {
  const chartMatchMediaQuery = getChartMediaQuery(chartContainerWidth);
  const aspectRatioBreakpointData = getChartAspectRatio({
    chartContainerWidth,
    getAspectRatioBreakpointSetup,
    type: type2
  });
  let aspectRatioLayout = defaultAspectRatioLayout;
  if (aspectRatioBreakpointData) {
    const [aspectRatio] = aspectRatioBreakpointData;
    const retrievedAspectRatioLayout = getAspectRatioBreakpointStyling({
      aspectRatio,
      aspectRatioBreakpointStylings,
      chartContainerWidth
    });
    if (retrievedAspectRatioLayout) {
      aspectRatioLayout = retrievedAspectRatioLayout;
    }
  }
  const portfolioChartStyle = getPortfolioChartStyles({
    aspectRatioBreakpointStylings,
    browserOverrideStylings,
    browserWidth,
    chartContainerWidth,
    chartState,
    displayXAxis,
    getAspectRatioBreakpointSetup,
    portfolioChartId,
    portfolioChartStyleSetup,
    type: type2
  });
  return {
    aspectRatioLayout,
    chartMatchMediaQuery,
    portfolioChartStyle
  };
};
const getMinMaxBalance = (data) => {
  if (!data || Array.isArray(data) === false || data.length === 0)
    return { min: 0, max: 0 };
  const initialMin = data[0].balance;
  const initialMax = initialMin;
  return data.reduce(
    (minMax, { balance }) => {
      if (balance > minMax.max) {
        minMax.max = balance;
      }
      if (balance < minMax.min) {
        minMax.min = balance;
      }
      return minMax;
    },
    { min: initialMin, max: initialMax }
  );
};
const isChartDataValid = (chartData) => {
  if (chartData == void 0) {
    return false;
  }
  const { data, meta } = chartData;
  if (
    // eslint-disable-next-line eqeqeq
    data == void 0 || data.length <= 0 || // eslint-disable-next-line eqeqeq
    meta == void 0
  ) {
    return false;
  }
  return true;
};
const isChartDataEmpty = (chartData) => {
  if (chartData == void 0) {
    return false;
  }
  const { meta } = chartData;
  if ((meta == null ? void 0 : meta.isEmptyData) === true) {
    return true;
  }
  return false;
};
const isPortfolioAumChartDataValid = (data) => {
  if (data == void 0 || Array.isArray(data) === false)
    return false;
  return true;
};
const getPortfolioChartVariantStyle = (variantConfig, variant3, key) => variantConfig && variantConfig[variant3] && variantConfig[variant3][key] ? variantConfig[variant3][key] : {};
const zeroChartDataBalances = (chartData) => {
  var _a2;
  const zeroedBalanceData = (_a2 = chartData.data) == null ? void 0 : _a2.map((item) => ({
    ...item,
    balance: 0
  }));
  return {
    data: zeroedBalanceData,
    meta: {
      maxBalance: 0,
      minBalance: 0,
      returnAmt: 0,
      returnPerc: 0
    }
  };
};
const TimeFrameSelect = ({
  defaultValue = TimeFrames.ThreeMonths,
  onTimeFrameChange,
  type: type2,
  _setTimeFrame
}) => {
  const onChangeHandler = useCallback(
    (e3) => {
      var _a2;
      const numberOfMonths = parseInt((_a2 = e3 == null ? void 0 : e3.target) == null ? void 0 : _a2.value, 10);
      const timeFrameConv = String(numberOfMonths);
      _setTimeFrame == null ? void 0 : _setTimeFrame(timeFrameConv);
      onTimeFrameChange == null ? void 0 : onTimeFrameChange(timeFrameConv);
    },
    [_setTimeFrame, onTimeFrameChange]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: getPortfolioChartVariantStyle(
        portfolioChartVariants,
        type2,
        "timeFrameSelect"
      ),
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Select2,
        {
          defaultValue,
          disabled: false,
          height: InputHeights.default,
          label: "Time Period",
          name: "timePeriod",
          onChange: onChangeHandler,
          options: [
            { value: TimeFrames.OneMonth, option: "1 Month" },
            { value: TimeFrames.ThreeMonths, option: "3 Months" },
            { value: TimeFrames.SixMonths, option: "6 Months" },
            { value: TimeFrames.OneYear, option: "1 Year" },
            { value: TimeFrames.AllTime, option: "All Time" }
          ],
          selectType: SelectTypes.Bare,
          variant: FormInputVariants.default,
          width: "unset"
        }
      )
    }
  );
};
const VictoryAxisJSXComponent = VictoryAxis;
const ChartAxis = ({
  _animationTheme = void 0,
  chartMatchMediaQuery,
  chartState,
  data,
  ...restOfProps
}) => {
  const axisDisplayType = getAxisDisplayTypeFrom(chartState, data);
  const hasMinimalDataPoints = (data == null ? void 0 : data.length) <= 7;
  const minimalDataPointsFilter = hasMinimalDataPoints && axisDisplayType !== AxisDisplayType.Month;
  const tickValues = getTickValues({
    axisDisplayType,
    chartMatchMediaQuery,
    data,
    minimalDataPointsFilter
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    VictoryAxisJSXComponent,
    {
      animate: false,
      tickFormat: (currentDate) => getAxisDisplayValue(axisDisplayType, currentDate),
      tickLabelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
        VictoryLabel,
        {
          dx: (props2) => getAxisLabelDxOffset(props2, tickValues, minimalDataPointsFilter),
          textAnchor: "middle"
        }
      ),
      tickValues,
      ...restOfProps
    }
  );
};
const getAxisLabelDxOffset = (props2, tickValues, minimalDataPointsFilter) => {
  if (minimalDataPointsFilter) {
    const { index: index2 } = props2;
    if (index2 === 0) {
      return 40;
    } else if (index2 === tickValues.length - 1) {
      return -40;
    }
  }
  return 0;
};
const getDateTickValues = (data, axisDisplayType, numOfDates, minimalDataPointsFilter) => {
  const dates = [];
  if (!data || data.length === 0) {
    return dates;
  }
  const start2 = data[0].date;
  if (data.length === 1) {
    return [start2];
  }
  const end2 = data[data.length - 1].date;
  if (minimalDataPointsFilter) {
    return [start2, end2];
  }
  let steps2 = numOfDates + 1;
  const stepSize = Math.abs(end2.getTime() - start2.getTime()) / steps2;
  let lastDateMarker = start2;
  const previousDisplayValues = {};
  while (steps2 > 1) {
    const nextDate = new Date(lastDateMarker.getTime() + stepSize);
    const displayValue = getAxisDisplayValue(axisDisplayType, nextDate);
    lastDateMarker = nextDate;
    if (!previousDisplayValues[displayValue]) {
      dates.push(nextDate);
    }
    previousDisplayValues[displayValue] = 1;
    steps2--;
  }
  return dates;
};
const getTickValues = ({
  axisDisplayType,
  chartMatchMediaQuery,
  data,
  minimalDataPointsFilter
}) => {
  if (!data || (data == null ? void 0 : data.length) <= 1) {
    return [];
  }
  const dates = getDateTickValues(
    data,
    axisDisplayType,
    getNumOfValues(axisDisplayType, chartMatchMediaQuery),
    minimalDataPointsFilter
  );
  return dates;
};
const getNumOfValues = (axisDisplayType, chartMatchMediaQuery) => {
  if ([ChartMatchMediaQuery.xs, ChartMatchMediaQuery.xxs].includes(
    chartMatchMediaQuery
  )) {
    return 3;
  }
  switch (axisDisplayType) {
    case AxisDisplayType.MonthDay:
      return 5;
    case AxisDisplayType.Month:
      return 15;
    case AxisDisplayType.MonthYear:
      return 5;
    default:
      return 5;
  }
};
const getAxisDisplayValue = (axisDisplayType, date2) => {
  if (!isDate$3(date2) || String(date2) === "Invalid Date" || // eslint-disable-next-line eqeqeq
  axisDisplayType == void 0)
    return "";
  const toMonthStr = (date22) => new Date(date22).toLocaleString("default", {
    month: "short"
  });
  const month = toMonthStr(date2);
  const year = date2.getFullYear();
  const monthDay = `${month} ${date2.getDate()}`;
  const monthYear = `${month} ${year}`;
  switch (axisDisplayType) {
    case AxisDisplayType.MonthDay: {
      return monthDay;
    }
    case AxisDisplayType.Month: {
      return month;
    }
    case AxisDisplayType.MonthYear: {
      return monthYear;
    }
    default:
      return month;
  }
};
const getAxisDisplayTypeFrom = (chartState, data) => {
  if ([
    PortfolioChartStates.EMPTY_CHART,
    PortfolioChartStates.EMPTY_W_CTA
  ].includes(chartState)) {
    return AxisDisplayType.Month;
  }
  if (isPortfolioAumChartDataValid(data) === false) {
    return AxisDisplayType.Month;
  }
  const firstDate = data[0].date;
  const lastDate = data[data.length - 1].date;
  const diffInWeeks = differenceInWeeks(lastDate, firstDate) + 1;
  return getAxisDisplayType(diffInWeeks);
};
const getAxisDisplayType = (numOfWeeks) => {
  const twoMonths = 10;
  const sixMonths = 27;
  if (numOfWeeks <= twoMonths) {
    return AxisDisplayType.MonthDay;
  } else if (numOfWeeks <= sixMonths) {
    return AxisDisplayType.Month;
  }
  return AxisDisplayType.MonthYear;
};
const PortfolioTooltip = (props2) => {
  const {
    aspectRatioLayout,
    datum,
    displayXAxis,
    height,
    meta,
    portfolioChartId,
    scale,
    x: x3
  } = props2;
  const yMinScale = scale ? scale.y(meta.minBalance * domainScale.y.min) : 0;
  const yMaxScale = scale ? scale.y(meta.maxBalance) : 0;
  const yTooltipLineBottom = (height ?? yMinScale) - (displayXAxis && aspectRatioLayout ? aspectRatioLayout == null ? void 0 : aspectRatioLayout.tooltipPaddingFromXAxis : 0);
  const yTooltipBottom = yMaxScale - tooltipYOffsetFromMaxScale;
  const yTooltipLineTop = yTooltipBottom;
  const easternTzDate = datum.date.toLocaleString("default", {
    timeZone: "America/New_York",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour12: false
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "line",
      {
        stroke: tooltipLineStyle.stroke,
        strokeDasharray: tooltipLineStyle.strokeDasharray,
        strokeWidth: tooltipLineStyle.strokeWidth,
        x1: x3,
        x2: x3,
        y1: yTooltipLineBottom,
        y2: yTooltipLineTop
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      PatchedVictoryTooltipJSXComponent,
      {
        ...props2,
        constrainToVisibleArea: true,
        labelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
          VictoryLabel,
          {
            lineHeight: portfolioChartId ? getTooltipLabelLineHeight(portfolioChartId) : void 0
          }
        ),
        pointerLength: 0,
        renderInPortal: false,
        text: [easternTzDate, `${DEFAULT_CURRENCY_FORMATTER.format(datum._y)}`],
        y: yTooltipBottom
      }
    )
  ] });
};
class PatchedVictoryTooltip extends VictoryTooltip {
  constrainTooltip(center, props2, dimensions) {
    const { x: x3, y: y4 } = center;
    const { width, height } = dimensions;
    const extent = {
      x: [0, props2.width],
      y: [0, props2.height]
    };
    const flyoutExtent = {
      x: [x3 - width / 2, x3 + width / 2],
      y: [y4 - height / 2, y4 + height / 2]
    };
    const adjustments = {
      x: [
        // Keeps the tooltip x position within the chart container
        // These lines were changed from victory-tooltip.js (Victory v36.5.3)
        // flyoutExtent.x[0] < extent.x[0] ? extent.x[0] - flyoutExtent.x[0] : 0,
        // flyoutExtent.x[1] > extent.x[1] ? flyoutExtent.x[1] - extent.x[1] : 0,
        flyoutExtent.x[0] < extent.x[0] ? extent.x[0] - flyoutExtent.x[0] + chartHitTargetOffset : 0,
        flyoutExtent.x[1] > extent.x[1] ? flyoutExtent.x[1] - extent.x[1] + chartHitTargetOffset : 0
      ],
      y: [
        // doesn't set any offsets for the y value of the chart so it can be set outside this fn
        // These lines were changed from victory-tooltip.js (Victory v36.5.3)
        // flyoutExtent.y[0] < extent.y[0] ? extent.y[0] - flyoutExtent.y[0] : 0,
        // flyoutExtent.y[1] > extent.y[1] ? flyoutExtent.y[1] - extent.y[1] : 0,
        0,
        0
      ]
    };
    return {
      x: Math.round(x3 + adjustments.x[0] - adjustments.x[1]),
      y: Math.round(y4 + adjustments.y[0] - adjustments.y[1])
    };
  }
}
const PatchedVictoryTooltipJSXComponent = PatchedVictoryTooltip;
const VictoryVoronoiContainerJSXComponent = VictoryVoronoiContainer;
const PortfolioVoronoiContainer = ({
  aspectRatioLayout = void 0,
  displayXAxis = true,
  chartState,
  isTooltipDisabled = false,
  meta,
  portfolioChartId = void 0
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    VictoryVoronoiContainerJSXComponent,
    {
      disable: isTooltipDisabled,
      labelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
        PortfolioTooltip,
        {
          aspectRatioLayout,
          chartState,
          displayXAxis,
          meta,
          portfolioChartId
        }
      ),
      labels: () => "LABELS_NOT_SET_HERE",
      voronoiDimension: "x"
    }
  );
};
const VictoryAreaJSXComponent = VictoryArea;
const ChartArea = ({
  data,
  ...restOfProps
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(
  VictoryAreaJSXComponent,
  {
    ...restOfProps,
    data,
    x: PortfolioAumDataKeys.date,
    y: PortfolioAumDataKeys.balance
  }
);
const AccessibleWrapper = React__default.forwardRef(
  ({
    ariaDescribedBy = void 0,
    ariaLabel = void 0,
    as = "div",
    children: children2,
    role = void 0,
    sx: sx2 = {},
    ...restOfProps
  }, ref2) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      as,
      ref: ref2,
      sx: sx2,
      ...ariaDescribedBy ? { "aria-describedby": ariaDescribedBy } : {},
      ...ariaLabel ? { "aria-label": ariaLabel } : {},
      ...role ? { role } : {},
      ...restOfProps,
      children: children2
    }
  )
);
const emptyPortfolioChartData = {
  data: [],
  meta: {
    isEmptyData: true,
    minBalance: 0,
    maxBalance: 0,
    returnAmt: 0,
    returnPerc: 0
  }
};
const getEmptyPortfolioChartData = (numDays = 88, isAnimateOnLoad = false) => {
  var _a2;
  const emptyData = {
    data: [],
    meta: { ...emptyPortfolioChartData.meta }
  };
  const initialBalance = isAnimateOnLoad ? 100 : 0;
  let balance = initialBalance;
  let minBalance = initialBalance;
  let maxBalance = initialBalance;
  let currentDay = subDays(/* @__PURE__ */ new Date(), numDays);
  for (let i2 = 0; i2 < numDays; i2++) {
    const randPercChange = randBm(-0.01, 0.01, 0.9);
    balance += balance * randPercChange;
    (_a2 = emptyData == null ? void 0 : emptyData.data) == null ? void 0 : _a2.push({
      date: format$2(currentDay, "yyyy-MM-dd"),
      balance: isAnimateOnLoad ? 0 : balance
    });
    if (balance > maxBalance) {
      maxBalance = balance;
    }
    if (balance < minBalance) {
      minBalance = balance;
    }
    currentDay = addDays(currentDay, 1);
  }
  emptyData.meta.maxBalance = isAnimateOnLoad ? numDays : maxBalance;
  emptyData.meta.minBalance = isAnimateOnLoad ? 0 : minBalance;
  return emptyData;
};
function randBm(min2, max2, skew) {
  let u2 = 0;
  let v = 0;
  while (u2 === 0) {
    u2 = Math.random();
  }
  while (v === 0) {
    v = Math.random();
  }
  let num = Math.sqrt(-2 * Math.log(u2)) * Math.cos(2 * Math.PI * v);
  num = num / 10 + 0.5;
  if (num > 1 || num < 0) {
    num = randBm(min2, max2, skew);
  } else {
    num = Math.pow(num, skew);
    num *= max2 - min2;
    num += min2;
  }
  return num;
}
const useChartMediaQuery = (containerDiv) => {
  const [currentChartMediaQuery, setCurrentChartMediaQuery] = useState(null);
  const chartContainerRef = useRef(containerDiv || null);
  const chartWidthRef = useRef(0);
  useResizeObserver(
    () => {
      if (!chartContainerRef.current) {
        return;
      }
      const containerWidth = chartContainerRef.current.offsetWidth;
      const chartMediaQuery = getChartMediaQuery(containerWidth);
      chartWidthRef.current = containerWidth;
      if (currentChartMediaQuery !== chartMediaQuery) {
        setCurrentChartMediaQuery(chartMediaQuery);
      }
    },
    chartContainerRef,
    [chartContainerRef],
    { throttle: Throttle.charts }
  );
  return {
    chartContainerRef,
    chartWidthCurrent: chartWidthRef.current
  };
};
const useBrowserResize = (throttleDuration) => {
  const browserWidth = useRef(document.documentElement.clientWidth);
  useLayoutEffect(() => {
    const handleResize = throttle$1(() => {
      browserWidth.current = document.documentElement.clientWidth;
    }, throttleDuration);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [throttleDuration]);
  return browserWidth == null ? void 0 : browserWidth.current;
};
const useEmptyChartEffect = (chartState, setChartData) => {
  useEffect(() => {
    if ([
      PortfolioChartStates.EMPTY_CHART,
      PortfolioChartStates.EMPTY_W_CTA
    ].includes(chartState)) {
      setChartData(void 0);
    }
  }, [chartState, setChartData]);
};
const useAnimatingOnLoadEffect = ({
  chartState,
  chartData,
  isFinishedAnimatedOnLoad,
  portfolioChartId,
  setChartData
}) => {
  useEffect(() => {
    let timer2;
    if (chartData && chartState === PortfolioChartStates.ANIMATING_ON_LOAD) {
      timer2 = setTimeout(() => {
        if (isChartDataValid(chartData) && isChartDataEmpty(chartData) === false) {
          isFinishedAnimatedOnLoad.current = true;
          const chartDataWithZeroBalances = zeroChartDataBalances(chartData);
          setChartData(chartDataWithZeroBalances);
          setTimeout(() => {
            setChartData(chartData);
          }, 1);
        }
      }, 1);
    }
    return () => {
      clearTimeout(timer2);
      clearMemoizedPortfolioChartStyles(portfolioChartId);
    };
  }, [chartData]);
};
const useChartDataUpdateEffect = ({
  chartData,
  chartState,
  isEmptyState,
  setChartData
}) => {
  useNoInitialRenderEffect(() => {
    if (chartData && isChartDataValid(chartData) && isEmptyState === false && chartState !== PortfolioChartStates.ANIMATING_ON_LOAD) {
      setChartData(chartData);
    }
  }, [chartData]);
};
const ONE_WEEK_OF_DATA = 7;
const DELTA_TIME_FRAME_TEXT = {
  [TimeFrames.OneMonth]: "past month",
  [TimeFrames.ThreeMonths]: "past 3 months",
  [TimeFrames.SixMonths]: "past 6 months",
  [TimeFrames.OneYear]: "past year",
  [TimeFrames.AllTime]: "all time"
};
const DEFAULT_DISCLAIMER = `
  Historical balance amounts presented on the graph are based on
  the underlying historical balances of your individual account
  using data points gathered throughout the life of your account.
`;
const PortfolioChart = ({
  _animationTheme = animationTheme,
  _accountBalanceAnimationDuration = ACCOUNT_BALANCE_DURATION,
  accountBalance = void 0,
  accountBalanceTitle = "Account Balance",
  accountBalanceDisclaimer = DEFAULT_DISCLAIMER,
  chartData,
  a11yDescription = "Display latest account balance change",
  deltaTimeFrameText = DELTA_TIME_FRAME_TEXT,
  defaultTimeFrame = TimeFrames.AllTime,
  displayTimeFrameSelection = true,
  displayXAxis = true,
  currencyFormatter,
  isAnimateOnLoad = true,
  isEmptyState = false,
  isLoading = false,
  onTimeFrameChange,
  subAccountsData,
  type: type2 = PortfolioChartTypes.DEFAULT
}) => {
  const [portfolioChartId] = useState(() => uniqueId$1("portfolio-chart-"));
  const ariaDescribedById = uniqueId$1("portfolio-chart-description-");
  const finalData = chartData || getEmptyPortfolioChartData(ONE_WEEK_OF_DATA, true);
  const initialData = isAnimateOnLoad ? getEmptyPortfolioChartData(ONE_WEEK_OF_DATA, true) : finalData;
  const [_chartData, setChartData] = useState(
    initialData
  );
  const [timeFrame, setTimeFrame] = useState(defaultTimeFrame);
  const { chartContainerRef, chartWidthCurrent } = useChartMediaQuery(null);
  const browserWidth = useBrowserResize();
  const isFinishedAnimatedOnLoad = useRef(false);
  const { currentChartState, isZeroed, isDisabled } = getDerivedChartStateData({
    chartData,
    isAnimateOnLoad,
    isEmptyState,
    isFinishedAnimatedOnLoad,
    isLoading
  });
  const {
    data,
    meta,
    finalBalance,
    firstBalance,
    firstDate,
    lastDate,
    lastReturnAmt,
    lastReturnPerc
  } = getDerivedChartData({
    accountBalance,
    chartData: _chartData,
    isZeroed
  });
  const _subAccountsData = getDerivedSubAccountData({
    isZeroed,
    subAccountsData
  });
  const delta = {
    a11yDescription,
    amount: lastReturnAmt,
    rate: lastReturnPerc,
    timeFrameText: deltaTimeFrameText
  };
  const { aspectRatioLayout, chartMatchMediaQuery, portfolioChartStyle } = getDerivedPortfolioChartThemeData({
    browserWidth,
    chartContainerWidth: chartWidthCurrent,
    chartState: currentChartState,
    displayXAxis,
    portfolioChartId,
    type: type2
  });
  useEmptyChartEffect(currentChartState, setChartData);
  useAnimatingOnLoadEffect({
    chartData,
    chartState: currentChartState,
    isFinishedAnimatedOnLoad,
    portfolioChartId,
    setChartData
  });
  useChartDataUpdateEffect({
    chartData,
    chartState: currentChartState,
    setChartData,
    isEmptyState
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      flexDirection: "column",
      justifyContent: "space-between",
      sx: {
        height: "100%"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Flex,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            sx: getPortfolioChartVariantStyle(
              portfolioChartVariants,
              type2,
              "accountInfo"
            ),
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                AccountInfo,
                {
                  _accountBalanceAnimationDuration,
                  accountBalanceDisclaimer,
                  accountBalanceTitle,
                  balance: finalBalance,
                  currencyFormatter,
                  dataTestUniqueId: portfolioChartId,
                  delta,
                  isZeroed,
                  selectedTimeFrame: timeFrame,
                  subAccountsData: _subAccountsData,
                  type: type2
                }
              ),
              [
                PortfolioChartStates.EMPTY_CHART,
                PortfolioChartStates.EMPTY_W_CTA
              ].includes(currentChartState) === false && displayTimeFrameSelection ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                TimeFrameSelect,
                {
                  _setTimeFrame: setTimeFrame,
                  defaultValue: timeFrame,
                  onTimeFrameChange,
                  type: type2
                }
              ) : null
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          AccessibleWrapper,
          {
            "data-test-id": "portfolio-chart-display",
            ref: chartContainerRef,
            role: "img",
            sx: styles$3(type2, chartWidthCurrent).chartWrapper,
            tabIndex: 0,
            ariaDescribedBy: ariaDescribedById,
            ariaLabel: "Portfolio Chart",
            children: [
              firstDate && lastDate ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
                VisuallyHidden,
                {
                  "data-test-id": "chart-aria-description",
                  id: ariaDescribedById,
                  children: [
                    "The first balance is ",
                    /* @__PURE__ */ jsxRuntimeExports.jsx(NumberCurrency, { data: firstBalance }),
                    " on",
                    " ",
                    `${format$2(firstDate, "M/d/yyy")}`,
                    " and the last balance is",
                    " ",
                    /* @__PURE__ */ jsxRuntimeExports.jsx(NumberCurrency, { data: accountBalance || finalBalance }),
                    " on",
                    " ",
                    `${format$2(lastDate, "M/d/yyy")}`,
                    " "
                  ]
                }
              ) : null,
              /* @__PURE__ */ jsxRuntimeExports.jsx(ChartGradient, { chartState: currentChartState }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                Box,
                {
                  "data-chart-display": true,
                  sx: styles$3(type2, chartWidthCurrent).chartDisplay,
                  children: data ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
                    VictoryChart,
                    {
                      animate: _animationTheme,
                      containerComponent: PortfolioVoronoiContainer({
                        aspectRatioLayout,
                        chartState: currentChartState,
                        displayXAxis,
                        isTooltipDisabled: isDisabled,
                        meta,
                        portfolioChartId
                      }),
                      domain: meta.minBalance !== 0 && (meta == null ? void 0 : meta.maxBalance) !== 0 ? {
                        y: [
                          meta.minBalance * domainScale.y.min,
                          meta.maxBalance * domainScale.y.max
                        ]
                        // 2% above and below padding within the chart itself between min/max vals and x-axis labels / top of chart. The min y values are more easily selecatable to see the tooltip from the user and the max y value can get cut off by the top of the chartwithout this.
                      } : void 0,
                      scale: { x: "time", y: "linear" },
                      theme: portfolioChartStyle,
                      children: [
                        ChartAxis({
                          _animationTheme,
                          chartMatchMediaQuery,
                          chartState: currentChartState,
                          data
                        }),
                        ChartArea({
                          data,
                          isDisabled
                        })
                      ]
                    }
                  ) : ""
                }
              )
            ]
          }
        )
      ]
    }
  );
};
const styles$3 = (type2, chartContainerWidth) => ({
  chartWrapper: {
    "&:focus-visible": {
      outline: "solid transparent",
      "[data-chart-display]::before": {
        borderRadius: "portfolioChart.chartWrapper",
        outline: "solid transparent",
        boxShadow: "two-pixel-soft",
        // boxShadow instead of outline since Safari does not respect border radius when using outline
        height: "100%",
        // needs more to wrap around the axis labels
        width: "99%",
        // since chart extends beyond the container edge, we want to pull back the width of the focus ring slightly
        left: 0,
        right: 0,
        margin: "0 auto",
        position: "absolute",
        content: `""`
      }
    },
    svg: {
      overflow: "visible",
      // tooltips overflow beyond chart container
      userSelect: "none"
      // don't want mobile users to text-select the chart when using tooltips
    },
    zIndex: "sticky"
    // tooltips need to hover above other content
  },
  chartDisplay: {
    ...portfolioChartVariants[type2].chartDisplay,
    // want the chart to go outside it's container and hug the edges
    mx: `${getHugOffsetMargin({
      chartContainerWidth,
      chartHitTargetOffset,
      getAspectRatioBreakpointSetup,
      type: type2
    })}px`
  }
});
const LegendItem = ({ name: name2, marker }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      sx: { width: "9rem" },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { width: "2rem" }, children: marker }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { justifyContent: "flex-start", sx: { width: "6rem" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Caption, { sx: { marginBottom: 0 }, variant: CaptionSizes.Caption12, children: name2 }) })
      ]
    }
  );
};
const LineMarker = ({
  color: color2 = "black",
  type: type2 = "solid",
  width = "0.12rem"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      sx: {
        borderTopWidth: width,
        borderTopStyle: type2,
        borderTopColor: color2,
        height: 0,
        width: "2rem"
      }
    }
  );
};
const Legend$1 = ({
  accountValueText,
  moneyInvestedText
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "flex-end", flexDirection: "column", spacing: 0.5, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      LegendItem,
      {
        marker: /* @__PURE__ */ jsxRuntimeExports.jsx(LineMarker, { color: dusk$2[50] }),
        name: accountValueText
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      LegendItem,
      {
        marker: /* @__PURE__ */ jsxRuntimeExports.jsx(LineMarker, { color: fog$3[50], type: "dashed" }),
        name: moneyInvestedText
      }
    )
  ] });
};
function currencyFormat(num) {
  return `$ ${num.toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`;
}
const MONEY_INVESTED = "money-invested";
const ACCOUNT_VALUE = "account-value";
const RiskToleranceChart = ({
  data,
  totalAmountOfYears = 5,
  crashYear = 4,
  crashText = "Market Crash",
  accountValueText = "Account Value",
  moneyInvestedText = "Money Invested",
  axisStartText = "Start",
  axisTickText = "Year"
}) => {
  const { matchMediaQuery } = useMatchMedia();
  const [boundingRect, setBoundingRect] = useState({ width: 0, height: 0 });
  const graphRef = useCallback((node2) => {
    if (node2 !== null) {
      setBoundingRect(node2.getBoundingClientRect());
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      "data-test-id": "risk-tolerance-chart-display",
      ref: graphRef,
      style: { height: "100%", width: "100%" },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ChartGradient, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          VictoryChart,
          {
            containerComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
              VictoryVoronoiContainer,
              {
                labelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  VictoryTooltip,
                  {
                    flyoutStyle: { fill: surface.dark },
                    style: {
                      fill: "white",
                      fontSize: matchMediaQuery.smDown ? 16 : 10
                    }
                  }
                ),
                labels: ({ datum }) => {
                  if (datum.childName === "crash")
                    return null;
                  let label2 = "";
                  if (datum.childName === ACCOUNT_VALUE)
                    label2 = accountValueText;
                  else
                    label2 = moneyInvestedText;
                  return `${label2}: ${currencyFormat(datum.y)}`;
                },
                voronoiDimension: "x"
              }
            ),
            height: 200,
            padding: { top: 20, bottom: 40, left: 20, right: 20 },
            scale: { x: "time", y: "linear" },
            title: "Risk Tolerance Chart",
            width: boundingRect.width,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                VictoryAxis,
                {
                  axisComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}),
                  tickFormat: (x3) => {
                    return x3 === 0 ? axisStartText : `${axisTickText} ${x3 / 12}`;
                  },
                  tickLabelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    VictoryLabel,
                    {
                      style: {
                        fill: TextColors.secondary,
                        fillOpacity: "0.75",
                        fontSize: matchMediaQuery.smDown ? 16 : 12,
                        fontWeight: "450"
                      }
                    }
                  ),
                  tickValues: Array.from(
                    { length: totalAmountOfYears + 1 },
                    (v, k3) => k3 * 12
                  )
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                VictoryArea,
                {
                  data: data[1],
                  labelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(VictoryTooltip, {}),
                  name: ACCOUNT_VALUE,
                  style: {
                    data: {
                      fill: `url(#${getPortfolioGradientId()})`,
                      stroke: dusk$2[50]
                    }
                  }
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                VictoryLine,
                {
                  data: data[0],
                  name: MONEY_INVESTED,
                  style: {
                    data: {
                      strokeDasharray: "2",
                      stroke: fog$3[50],
                      strokeWidth: "1.5"
                    }
                  }
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                VictoryBar,
                {
                  data: [
                    {
                      x: crashYear * 12,
                      y: data[1][crashYear * 12].y,
                      label: crashText
                    }
                  ],
                  labelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    VictoryTooltip,
                    {
                      active: true,
                      dy: -5,
                      flyoutStyle: { fill: surface.dark },
                      style: {
                        fill: "white",
                        fontSize: matchMediaQuery.smDown ? 16 : 10
                      }
                    }
                  ),
                  name: "crash",
                  style: {
                    data: { fill: TextColors.white, fillOpacity: "0", width: 1 }
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Legend$1,
          {
            accountValueText,
            moneyInvestedText
          }
        )
      ]
    }
  );
};
const VolatilityToleranceChart = ({
  data,
  retirementAge,
  axisStartText = "Today",
  axisEndText = "years old"
}) => {
  const { matchMediaQuery } = useMatchMedia();
  const [boundingRect, setBoundingRect] = useState({ width: 0, height: 0 });
  const graphRef = useCallback((node2) => {
    if (node2 !== null) {
      setBoundingRect(node2.getBoundingClientRect());
    }
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "div",
    {
      "data-test-id": "volatility-tolerance-chart-display",
      ref: graphRef,
      style: { height: "100%", width: "100%" },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ChartGradient, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          VictoryChart,
          {
            height: 120,
            padding: { top: 0, bottom: 30, left: 0, right: 1 },
            scale: { x: "time", y: "linear" },
            title: "Volatility Tolerance Chart",
            width: boundingRect.width,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                VictoryAxis,
                {
                  tickFormat: (x3) => {
                    return x3 === 0 ? axisStartText : `${retirementAge} ${axisEndText}`;
                  },
                  tickLabelComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    VictoryLabel,
                    {
                      dx: (props2) => {
                        const startDx = matchMediaQuery.smDown ? 38 : 27;
                        return props2.datum === 0 ? startDx : 0;
                      },
                      style: {
                        fill: TextColors.secondary,
                        fillOpacity: "0.75",
                        fontSize: matchMediaQuery.smDown ? 16 : 12,
                        fontWeight: "450"
                      },
                      textAnchor: "end"
                    }
                  ),
                  tickValues: [0, data[data.length - 1].x]
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports.jsx(
                VictoryArea,
                {
                  data,
                  name: "volatility",
                  style: {
                    data: {
                      fill: `url(#${getPortfolioGradientId()})`,
                      stroke: dusk$2[50]
                    }
                  }
                }
              )
            ]
          }
        )
      ]
    }
  );
};
const FileSelector = ({
  accept,
  buttonSize = ButtonSize.default,
  disabled = false,
  handleFileChange,
  label: label2,
  multiple = false,
  name: name2,
  sx: sx2,
  variant: variant3 = ButtonVariant.secondary
}) => {
  const hiddenInputRef = useRef(null);
  const handleSelectFileClick = useCallback(() => {
    var _a2;
    (_a2 = hiddenInputRef == null ? void 0 : hiddenInputRef.current) == null ? void 0 : _a2.click();
  }, [hiddenInputRef]);
  const cleanInputValue = useCallback((event2) => {
    event2.target.value = null;
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompoundButton,
      {
        disabled,
        icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { disabled, name: "upload", size: IconSizes.Icon16 }),
        id: `${name2}-select-file-button`,
        onClick: handleSelectFileClick,
        size: buttonSize,
        sx: sx2,
        variant: variant3,
        children: label2
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "input",
      {
        accept,
        "aria-labelledby": `${name2}-select-file-button`,
        disabled,
        id: name2,
        multiple,
        name: name2,
        onChange: disabled ? noop$6 : handleFileChange,
        onClick: cleanInputValue,
        ref: hiddenInputRef,
        style: { opacity: 0, height: 0 },
        type: "file"
      }
    )
  ] });
};
const TRANSITION_TIME_FROM_SUCCESS_TO_COMPLETED = 300;
const FileTile = ({
  error: error2,
  errorText,
  fileName,
  progress,
  success,
  removeFile,
  sx: sx2
}) => {
  const [completed, setCompleted] = useState(false);
  useEffect(() => {
    let timeoutRef;
    if (success) {
      timeoutRef = setTimeout(() => {
        setCompleted(true);
      }, TRANSITION_TIME_FROM_SUCCESS_TO_COMPLETED);
    }
    return () => {
      if (timeoutRef)
        clearTimeout(timeoutRef);
    };
  }, [success]);
  const RightElement = useMemo(() => {
    const defaultElement = /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompoundButton,
      {
        "data-test-id": "file-delete",
        onClick: removeFile,
        sx: { flexShrink: 0 },
        variant: ButtonVariant.unstyled,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "delete", size: IconSizes.Icon16, sx: { flexShrink: 0 } })
      }
    );
    if (completed || error2)
      return defaultElement;
    else if (success)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "check", size: IconSizes.Icon16, sx: { flexShrink: 0 } });
    else if (progress !== void 0 && progress >= 0)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Spinner2,
        {
          sx: { flexShrink: 0, margin: 0 },
          variant: SpinnerVariants.secondary
        }
      );
    else
      return defaultElement;
  }, [completed, error2, progress, success, removeFile]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: "0.375rem", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        sx: {
          backgroundColor: error2 ? "surface.error.subdued" : "surface.neutral",
          borderRadius: "4",
          height: "48px",
          width: "288px",
          position: "relative",
          overflow: "hidden",
          ...sx2
        },
        children: [
          !completed && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box,
            {
              "data-test-id": "progress-bar-indicator",
              sx: {
                position: "absolute",
                left: 0,
                backgroundColor: "midnight-20",
                opacity: "60%",
                maxWidth: "100%",
                height: "100%",
                width: `${progress}%`,
                transition: "progressBar.indicator"
              }
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Flex,
            {
              alignItems: "center",
              justifyContent: "space-between",
              sx: {
                paddingLeft: 1,
                paddingRight: 2,
                paddingY: 0.75,
                zIndex: 1,
                position: "absolute",
                width: "100%"
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", spacing: 0.5, children: [
                  /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: "document", size: IconSizes.Icon16 }),
                  /* @__PURE__ */ jsxRuntimeExports.jsx(
                    Span,
                    {
                      color: "text.primary",
                      sx: {
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                      },
                      children: fileName
                    }
                  )
                ] }),
                RightElement
              ]
            }
          )
        ]
      }
    ),
    error2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { color: "text.error", variant: SpanSizes.Span14, children: errorText })
  ] });
};
function bind2(fn2, thisArg) {
  return function wrap() {
    return fn2.apply(thisArg, arguments);
  };
}
const { toString: toString$1 } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache2) => (thing) => {
  const str = toString$1.call(thing);
  return cache2[str] || (cache2[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type2) => {
  type2 = type2.toLowerCase();
  return (thing) => kindOf(thing) === type2;
};
const typeOfTest = (type2) => (thing) => typeof thing === type2;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction3(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer4 = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer4(val.buffer);
  }
  return result;
}
const isString3 = typeOfTest("string");
const isFunction3 = typeOfTest("function");
const isNumber3 = typeOfTest("number");
const isObject$1 = (thing) => thing !== null && typeof thing === "object";
const isBoolean2 = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate$1 = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$1(val) && isFunction3(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction3(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction3(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach$1(obj, fn2, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i2;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i2 = 0, l = obj.length; i2 < l; i2++) {
      fn2.call(null, obj[i2], i2, obj);
    }
  } else {
    const keys8 = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys8.length;
    let key;
    for (i2 = 0; i2 < len; i2++) {
      key = keys8[i2];
      fn2.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys8 = Object.keys(obj);
  let i2 = keys8.length;
  let _key;
  while (i2-- > 0) {
    _key = keys8[i2];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined")
    return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge2() {
  const { caseless } = isContextDefined(this) && this || {};
  const result = {};
  const assignValue2 = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge2(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge2({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };
  for (let i2 = 0, l = arguments.length; i2 < l; i2++) {
    arguments[i2] && forEach$1(arguments[i2], assignValue2);
  }
  return result;
}
const extend = (a4, b10, thisArg, { allOwnKeys } = {}) => {
  forEach$1(b10, (val, key) => {
    if (thisArg && isFunction3(val)) {
      a4[key] = bind2(val, thisArg);
    } else {
      a4[key] = val;
    }
  }, { allOwnKeys });
  return a4;
};
const stripBOM = (content2) => {
  if (content2.charCodeAt(0) === 65279) {
    content2 = content2.slice(1);
  }
  return content2;
};
const inherits = (constructor, superConstructor, props2, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props2 && Object.assign(constructor.prototype, props2);
};
const toFlatObject = (sourceObj, destObj, filter2, propFilter) => {
  let props2;
  let i2;
  let prop;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null)
    return destObj;
  do {
    props2 = Object.getOwnPropertyNames(sourceObj);
    i2 = props2.length;
    while (i2-- > 0) {
      prop = props2[i2];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter2 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter2 || filter2(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position2) => {
  str = String(str);
  if (position2 === void 0 || position2 > str.length) {
    position2 = str.length;
  }
  position2 -= searchString.length;
  const lastIndex = str.indexOf(searchString, position2);
  return lastIndex !== -1 && lastIndex === position2;
};
const toArray$1 = (thing) => {
  if (!thing)
    return null;
  if (isArray(thing))
    return thing;
  let i2 = thing.length;
  if (!isNumber3(i2))
    return null;
  const arr = new Array(i2);
  while (i2-- > 0) {
    arr[i2] = thing[i2];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray2) => {
  return (thing) => {
    return TypedArray2 && thing instanceof TypedArray2;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn2) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result;
  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn2.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches2;
  const arr = [];
  while ((matches2 = regExp.exec(str)) !== null) {
    arr.push(matches2);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m3, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop) => hasOwnProperty2.call(obj, prop))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer2) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach$1(descriptors2, (descriptor, name2) => {
    let ret;
    if ((ret = reducer2(descriptor, name2, obj)) !== false) {
      reducedDescriptors[name2] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name2) => {
    if (isFunction3(obj) && ["arguments", "caller", "callee"].indexOf(name2) !== -1) {
      return false;
    }
    const value = obj[name2];
    if (!isFunction3(value))
      return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name2 + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter2) => {
  const obj = {};
  const define2 = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter2));
  return obj;
};
const noop = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length: length2 } = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length2 | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction3(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack2 = new Array(10);
  const visit = (source, i2) => {
    if (isObject$1(source)) {
      if (stack2.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack2[i2] = source;
        const target = isArray(source) ? [] : {};
        forEach$1(source, (value, key) => {
          const reducedValue = visit(value, i2 + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack2[i2] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject$1(thing) || isFunction3(thing)) && isFunction3(thing.then) && isFunction3(thing.catch);
const utils$1 = {
  isArray,
  isArrayBuffer: isArrayBuffer4,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString: isString3,
  isNumber: isNumber3,
  isBoolean: isBoolean2,
  isObject: isObject$1,
  isPlainObject,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isRegExp,
  isFunction: isFunction3,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach: forEach$1,
  merge: merge2,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray: toArray$1,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable
};
function AxiosError(message, code, config2, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message;
  this.name = "AxiosError";
  code && (this.code = code);
  config2 && (this.config = config2);
  request && (this.request = request);
  response && (this.response = response);
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const prototype$1 = AxiosError.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError.from = (error2, code, config2, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error2, axiosError, function filter2(obj) {
    return obj !== Error.prototype;
  }, (prop) => {
    return prop !== "isAxiosError";
  });
  AxiosError.call(axiosError, error2.message, code, config2, request, response);
  axiosError.cause = error2;
  axiosError.name = error2.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path2, key, dots) {
  if (!path2)
    return key;
  return path2.concat(key).map(function each2(token2, i2) {
    token2 = removeBrackets(token2);
    return !dots && i2 ? "[" + token2 + "]" : token2;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});
function toFormData(obj, formData, options2) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options2 = utils$1.toFlatObject(options2, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined2(option, source) {
    return !utils$1.isUndefined(source[option]);
  });
  const metaTokens = options2.metaTokens;
  const visitor = options2.visitor || defaultVisitor;
  const dots = options2.dots;
  const indexes = options2.indexes;
  const _Blob = options2.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null)
      return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path2) {
    let arr = value;
    if (value && !path2 && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each2(el, index2) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index2, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path2, key, dots), convertValue(value));
    return false;
  }
  const stack2 = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build2(value, path2) {
    if (utils$1.isUndefined(value))
      return;
    if (stack2.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path2.join("."));
    }
    stack2.push(value);
    utils$1.forEach(value, function each2(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils$1.isString(key) ? key.trim() : key,
        path2,
        exposedHelpers
      );
      if (result === true) {
        build2(el, path2 ? path2.concat(key) : [key]);
      }
    });
    stack2.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build2(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match2) {
    return charMap[match2];
  });
}
function AxiosURLSearchParams(params, options2) {
  this._pairs = [];
  params && toFormData(params, this, options2);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append2(name2, value) {
  this._pairs.push([name2, value]);
};
prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each2(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options2) {
  if (!params) {
    return url;
  }
  const _encode = options2 && options2.encode || encode;
  const serializeFn = options2 && options2.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options2);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options2).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options2) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options2 ? options2.synchronous : false,
      runWhen: options2 ? options2.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn2) {
    utils$1.forEach(this.handlers, function forEachHandler(h3) {
      if (h3 !== null) {
        fn2(h3);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const hasStandardBrowserEnv = ((product) => {
  return hasBrowserEnv && ["ReactNative", "NativeScript", "NS"].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data, options2) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path2, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options2));
}
function parsePropPath(name2) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name2).map((match2) => {
    return match2[0] === "[]" ? "" : match2[1] || match2[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys8 = Object.keys(arr);
  let i2;
  const len = keys8.length;
  let key;
  for (i2 = 0; i2 < len; i2++) {
    key = keys8[i2];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path2, value, target, index2) {
    let name2 = path2[index2++];
    if (name2 === "__proto__")
      return true;
    const isNumericKey = Number.isFinite(+name2);
    const isLast = index2 >= path2.length;
    name2 = !name2 && utils$1.isArray(target) ? target.length : name2;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name2)) {
        target[name2] = [target[name2], value];
      } else {
        target[name2] = value;
      }
      return !isNumericKey;
    }
    if (!target[name2] || !utils$1.isObject(target[name2])) {
      target[name2] = [];
    }
    const result = buildPath(path2, value, target[name2], index2);
    if (result && utils$1.isArray(target[name2])) {
      target[name2] = arrayToObject(target[name2]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name2, value) => {
      buildPath(parsePropPath(name2), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e3) {
      if (e3.name !== "SyntaxError") {
        throw e3;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http"],
  transformRequest: [function transformRequest(data, headers2) {
    const contentType = headers2.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data);
    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }
    const isFormData2 = utils$1.isFormData(data);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }
    if (utils$1.isArrayBuffer(data) || utils$1.isBuffer(data) || utils$1.isStream(data) || utils$1.isFile(data) || utils$1.isBlob(data)) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers2.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(
          isFileList2 ? { "files[]": data } : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers2.setContentType("application/json", false);
      return stringifySafely(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (data && utils$1.isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data);
      } catch (e3) {
        if (strictJSONParsing) {
          if (e3.name === "SyntaxError") {
            throw AxiosError.from(e3, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e3;
        }
      }
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const defaults$1 = defaults;
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i2;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line2) {
    i2 = line2.indexOf(":");
    key = line2.substring(0, i2).trim().toLowerCase();
    val = line2.substring(i2 + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header2) {
  return header2 && String(header2).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match2;
  while (match2 = tokensRE.exec(str)) {
    tokens[match2[1]] = match2[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header2, filter2, isHeaderNameFilter) {
  if (utils$1.isFunction(filter2)) {
    return filter2.call(this, value, header2);
  }
  if (isHeaderNameFilter) {
    value = header2;
  }
  if (!utils$1.isString(value))
    return;
  if (utils$1.isString(filter2)) {
    return value.indexOf(filter2) !== -1;
  }
  if (utils$1.isRegExp(filter2)) {
    return filter2.test(value);
  }
}
function formatHeader(header2) {
  return header2.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w2, char2, str) => {
    return char2.toUpperCase() + str;
  });
}
function buildAccessors(obj, header2) {
  const accessorName = utils$1.toCamelCase(" " + header2);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header2, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers2) {
    headers2 && this.set(headers2);
  }
  set(header2, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers2, _rewrite) => utils$1.forEach(headers2, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header2) || header2 instanceof this.constructor) {
      setHeaders(header2, valueOrRewrite);
    } else if (utils$1.isString(header2) && (header2 = header2.trim()) && !isValidHeaderName(header2)) {
      setHeaders(parseHeaders(header2), valueOrRewrite);
    } else {
      header2 != null && setHeader(valueOrRewrite, header2, rewrite);
    }
    return this;
  }
  get(header2, parser) {
    header2 = normalizeHeader(header2);
    if (header2) {
      const key = utils$1.findKey(this, header2);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header2, matcher) {
    header2 = normalizeHeader(header2);
    if (header2) {
      const key = utils$1.findKey(this, header2);
      return !!(key && this[key] !== void 0 && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }
    return false;
  }
  delete(header2, matcher) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher || matchHeaderValue(self2, self2[key], key, matcher))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header2)) {
      header2.forEach(deleteHeader);
    } else {
      deleteHeader(header2);
    }
    return deleted;
  }
  clear(matcher) {
    const keys8 = Object.keys(this);
    let i2 = keys8.length;
    let deleted = false;
    while (i2--) {
      const key = keys8[i2];
      if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this;
    const headers2 = {};
    utils$1.forEach(this, (value, header2) => {
      const key = utils$1.findKey(headers2, header2);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header2];
        return;
      }
      const normalized = format2 ? formatHeader(header2) : String(header2).trim();
      if (normalized !== header2) {
        delete self2[header2];
      }
      self2[normalized] = normalizeValue(value);
      headers2[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header2) => {
      value != null && value !== false && (obj[header2] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header2, value]) => header2 + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed = new this(first);
    targets.forEach((target) => computed.set(target));
    return computed;
  }
  static accessor(header2) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header2) ? header2.forEach(defineAccessor) : defineAccessor(header2);
    return this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
const AxiosHeaders$1 = AxiosHeaders;
function transformData(fns, response) {
  const config2 = this || defaults$1;
  const context = response || config2;
  const headers2 = AxiosHeaders$1.from(context.headers);
  let data = context.data;
  utils$1.forEach(fns, function transform(fn2) {
    data = fn2.call(config2, data, headers2.normalize(), response ? response.status : void 0);
  });
  headers2.normalize();
  return data;
}
function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError(message, config2, request) {
  AxiosError.call(this, message == null ? "canceled" : message, AxiosError.ERR_CANCELED, config2, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
function settle(resolve, reject, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      "Request failed with status code " + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name2, value, expires, path2, domain, secure) {
      const cookie = [name2 + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path2) && cookie.push("path=" + path2);
      utils$1.isString(domain) && cookie.push("domain=" + domain);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name2) {
      const match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const isURLSameOrigin = platform.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    function resolveURL(url) {
      let href = url;
      if (msie) {
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
      }
      urlParsingNode.setAttribute("href", href);
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
      };
    }
    originURL = resolveURL(window.location.href);
    return function isURLSameOrigin2(requestURL) {
      const parsed = utils$1.isString(requestURL) ? resolveURL(requestURL) : requestURL;
      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function nonStandardBrowserEnv() {
    return function isURLSameOrigin2() {
      return true;
    };
  }()
);
function parseProtocol(url) {
  const match2 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match2 && match2[1] || "";
}
function speedometer(samplesCount, min2) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;
  min2 = min2 !== void 0 ? min2 : 1e3;
  return function push(chunkLength) {
    const now2 = Date.now();
    const startedAt = timestamps[tail];
    if (!firstSampleTS) {
      firstSampleTS = now2;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now2;
    let i2 = tail;
    let bytesCount = 0;
    while (i2 !== head) {
      bytesCount += bytes[i2++];
      i2 = i2 % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }
    if (now2 - firstSampleTS < min2) {
      return;
    }
    const passed = startedAt && now2 - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return (e3) => {
    const loaded = e3.loaded;
    const total = e3.lengthComputable ? e3.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e3
    };
    data[isDownloadStream ? "download" : "upload"] = true;
    listener(data);
  };
}
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config2) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config2.data;
    const requestHeaders = AxiosHeaders$1.from(config2.headers).normalize();
    let { responseType, withXSRFToken } = config2;
    let onCanceled;
    function done2() {
      if (config2.cancelToken) {
        config2.cancelToken.unsubscribe(onCanceled);
      }
      if (config2.signal) {
        config2.signal.removeEventListener("abort", onCanceled);
      }
    }
    let contentType;
    if (utils$1.isFormData(requestData)) {
      if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
        requestHeaders.setContentType(false);
      } else if ((contentType = requestHeaders.getContentType()) !== false) {
        const [type2, ...tokens] = contentType ? contentType.split(";").map((token2) => token2.trim()).filter(Boolean) : [];
        requestHeaders.setContentType([type2 || "multipart/form-data", ...tokens].join("; "));
      }
    }
    let request = new XMLHttpRequest();
    if (config2.auth) {
      const username = config2.auth.username || "";
      const password = config2.auth.password ? unescape(encodeURIComponent(config2.auth.password)) : "";
      requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
    }
    const fullPath = buildFullPath(config2.baseURL, config2.url);
    request.open(config2.method.toUpperCase(), buildURL(fullPath, config2.params, config2.paramsSerializer), true);
    request.timeout = config2.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders$1.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config2,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done2();
      }, function _reject(err) {
        reject(err);
        done2();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config2, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config2, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config2.timeout ? "timeout of " + config2.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = config2.transitional || transitionalDefaults;
      if (config2.timeoutErrorMessage) {
        timeoutErrorMessage = config2.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config2,
        request
      ));
      request = null;
    };
    if (platform.hasStandardBrowserEnv) {
      withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config2));
      if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(fullPath)) {
        const xsrfValue = config2.xsrfHeaderName && config2.xsrfCookieName && cookies.read(config2.xsrfCookieName);
        if (xsrfValue) {
          requestHeaders.set(config2.xsrfHeaderName, xsrfValue);
        }
      }
    }
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(config2.withCredentials)) {
      request.withCredentials = !!config2.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = config2.responseType;
    }
    if (typeof config2.onDownloadProgress === "function") {
      request.addEventListener("progress", progressEventReducer(config2.onDownloadProgress, true));
    }
    if (typeof config2.onUploadProgress === "function" && request.upload) {
      request.upload.addEventListener("progress", progressEventReducer(config2.onUploadProgress));
    }
    if (config2.cancelToken || config2.signal) {
      onCanceled = (cancel2) => {
        if (!request) {
          return;
        }
        reject(!cancel2 || cancel2.type ? new CanceledError(null, config2, request) : cancel2);
        request.abort();
        request = null;
      };
      config2.cancelToken && config2.cancelToken.subscribe(onCanceled);
      if (config2.signal) {
        config2.signal.aborted ? onCanceled() : config2.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(fullPath);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config2));
      return;
    }
    request.send(requestData || null);
  });
};
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter
};
utils$1.forEach(knownAdapters, (fn2, value) => {
  if (fn2) {
    try {
      Object.defineProperty(fn2, "name", { value });
    } catch (e3) {
    }
    Object.defineProperty(fn2, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length: length2 } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i2 = 0; i2 < length2; i2++) {
      nameOrAdapter = adapters2[i2];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i2] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state]) => `adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s4 = length2 ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s4,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config2) {
  if (config2.cancelToken) {
    config2.cancelToken.throwIfRequested();
  }
  if (config2.signal && config2.signal.aborted) {
    throw new CanceledError(null, config2);
  }
}
function dispatchRequest(config2) {
  throwIfCancellationRequested(config2);
  config2.headers = AxiosHeaders$1.from(config2.headers);
  config2.data = transformData.call(
    config2,
    config2.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config2.method) !== -1) {
    config2.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config2.adapter || defaults$1.adapter);
  return adapter(config2).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config2);
    response.data = transformData.call(
      config2,
      config2.transformResponse,
      response
    );
    response.headers = AxiosHeaders$1.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config2);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config2,
          config2.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config3 = {};
  function getMergedValue(target, source, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a4, b10, caseless) {
    if (!utils$1.isUndefined(b10)) {
      return getMergedValue(a4, b10, caseless);
    } else if (!utils$1.isUndefined(a4)) {
      return getMergedValue(void 0, a4, caseless);
    }
  }
  function valueFromConfig2(a4, b10) {
    if (!utils$1.isUndefined(b10)) {
      return getMergedValue(void 0, b10);
    }
  }
  function defaultToConfig2(a4, b10) {
    if (!utils$1.isUndefined(b10)) {
      return getMergedValue(void 0, b10);
    } else if (!utils$1.isUndefined(a4)) {
      return getMergedValue(void 0, a4);
    }
  }
  function mergeDirectKeys(a4, b10, prop) {
    if (prop in config2) {
      return getMergedValue(a4, b10);
    } else if (prop in config1) {
      return getMergedValue(void 0, a4);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a4, b10) => mergeDeepProperties(headersToObject(a4), headersToObject(b10), true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge3 = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge3(config1[prop], config2[prop], prop);
    utils$1.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config3[prop] = configValue);
  });
  return config3;
}
const VERSION = "1.6.8";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type2, i2) => {
  validators$1[type2] = function validator2(thing) {
    return typeof thing === type2 || "a" + (i2 < 1 ? "n " : " ") + type2;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options2, schema, allowUnknown) {
  if (typeof options2 !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys8 = Object.keys(options2);
  let i2 = keys8.length;
  while (i2-- > 0) {
    const opt = keys8[i2];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options2[opt];
      const result = value === void 0 || validator2(value, opt, options2);
      if (result !== true) {
        throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config2) {
    try {
      return await this._request(configOrUrl, config2);
    } catch (err) {
      if (err instanceof Error) {
        let dummy;
        Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
        const stack2 = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        if (!err.stack) {
          err.stack = stack2;
        } else if (stack2 && !String(err.stack).endsWith(stack2.replace(/^.+\n.+\n/, ""))) {
          err.stack += "\n" + stack2;
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config2) {
    if (typeof configOrUrl === "string") {
      config2 = config2 || {};
      config2.url = configOrUrl;
    } else {
      config2 = configOrUrl || {};
    }
    config2 = mergeConfig(this.defaults, config2);
    const { transitional: transitional2, paramsSerializer, headers: headers2 } = config2;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config2.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    config2.method = (config2.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers2 && utils$1.merge(
      headers2.common,
      headers2[config2.method]
    );
    headers2 && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers2[method];
      }
    );
    config2.headers = AxiosHeaders$1.concat(contextHeaders, headers2);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config2) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i2 = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain2 = [dispatchRequest.bind(this), void 0];
      chain2.unshift.apply(chain2, requestInterceptorChain);
      chain2.push.apply(chain2, responseInterceptorChain);
      len = chain2.length;
      promise = Promise.resolve(config2);
      while (i2 < len) {
        promise = promise.then(chain2[i2++], chain2[i2++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config2;
    i2 = 0;
    while (i2 < len) {
      const onFulfilled = requestInterceptorChain[i2++];
      const onRejected = requestInterceptorChain[i2++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error2) {
        onRejected.call(this, error2);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error2) {
      return Promise.reject(error2);
    }
    i2 = 0;
    len = responseInterceptorChain.length;
    while (i2 < len) {
      promise = promise.then(responseInterceptorChain[i2++], responseInterceptorChain[i2++]);
    }
    return promise;
  }
  getUri(config2) {
    config2 = mergeConfig(this.defaults, config2);
    const fullPath = buildFullPath(config2.baseURL, config2.url);
    return buildURL(fullPath, config2.params, config2.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios.prototype[method] = function(url, config2) {
    return this.request(mergeConfig(config2 || {}, {
      method,
      url,
      data: (config2 || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config2) {
      return this.request(mergeConfig(config2 || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
const Axios$1 = Axios;
class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token2 = this;
    this.promise.then((cancel2) => {
      if (!token2._listeners)
        return;
      let i2 = token2._listeners.length;
      while (i2-- > 0) {
        token2._listeners[i2](cancel2);
      }
      token2._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token2.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject() {
        token2.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel2(message, config2, request) {
      if (token2.reason) {
        return;
      }
      token2.reason = new CanceledError(message, config2, request);
      resolvePromise(token2.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index2 = this._listeners.indexOf(listener);
    if (index2 !== -1) {
      this._listeners.splice(index2, 1);
    }
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel2;
    const token2 = new CancelToken(function executor(c7) {
      cancel2 = c7;
    });
    return {
      token: token2,
      cancel: cancel2
    };
  }
}
const CancelToken$1 = CancelToken;
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
const HttpStatusCode$1 = HttpStatusCode;
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind2(Axios$1.prototype.request, context);
  utils$1.extend(instance, Axios$1.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create2(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };
  return instance;
}
const axios = createInstance(defaults$1);
axios.Axios = Axios$1;
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;
axios.AxiosError = AxiosError;
axios.Cancel = axios.CanceledError;
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = spread;
axios.isAxiosError = isAxiosError;
axios.mergeConfig = mergeConfig;
axios.AxiosHeaders = AxiosHeaders$1;
axios.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = adapters.getAdapter;
axios.HttpStatusCode = HttpStatusCode$1;
axios.default = axios;
function useUploadForm(autoUpload) {
  const [metadata, setMetadata] = useState({});
  const [success, setSuccess] = useState({});
  const [error2, setError] = useState({});
  const [progress, setProgress] = useState({});
  const uploadForm = useCallback(
    async (file) => {
      const fileKey = file.name;
      let response;
      setProgress((p) => ({ ...p, [fileKey]: 0 }));
      try {
        if (typeof autoUpload === "string") {
          const formData = new FormData();
          formData.append(fileKey, file);
          response = await axios.post(autoUpload, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: (progressEvent) => {
              if (progressEvent && progressEvent.total) {
                const uploadProgress = progressEvent.loaded / progressEvent.total * 50;
                setProgress((p) => ({ ...p, [fileKey]: uploadProgress }));
              }
            },
            onDownloadProgress: (progressEvent) => {
              if (progressEvent && progressEvent.total) {
                const uploadProgress = 50 + progressEvent.loaded / progressEvent.total * 50;
                setProgress((p) => ({ ...p, [fileKey]: uploadProgress }));
              }
            }
          });
        } else if (typeof autoUpload === "function") {
          response = await autoUpload({
            file,
            setProgress: (progress2) => {
              setProgress((p) => ({ ...p, [fileKey]: progress2 }));
            }
          });
        }
        setMetadata((s4) => ({ ...s4, [fileKey]: response }));
        setSuccess((s4) => ({ ...s4, [fileKey]: true }));
      } catch {
        setSuccess((s4) => ({ ...s4, [fileKey]: false }));
        setProgress((p) => ({ ...p, [fileKey]: 0 }));
        setError((e3) => ({ ...e3, [fileKey]: true }));
      }
      return response;
    },
    [autoUpload]
  );
  const cleanUpFile = useCallback((fileName) => {
    const removeStateEntry = (state) => {
      const { [fileName]: _, ...rest } = state;
      return rest;
    };
    setProgress(removeStateEntry);
    setError(removeStateEntry);
    setSuccess(removeStateEntry);
  }, []);
  return {
    cleanUpFile,
    error: error2,
    metadata,
    progress,
    setError,
    setMetadata,
    setProgress,
    success,
    uploadForm
  };
}
function isFileMetadata(item) {
  return item.file !== void 0;
}
const FileUpload = ({
  accept = void 0,
  autoUpload = void 0,
  buttonLabel = "Select file",
  buttonSize = ButtonSize.default,
  disabled = false,
  errorText = "Upload failed, try again",
  fileTileRender = void 0,
  initialFiles = [],
  multiple = false,
  name: name2,
  onFileChange,
  onFileDelete,
  onUploadComplete,
  sxFileTile = {},
  sxFileSelector = {},
  sxFilesContainer = {},
  variant: variant3 = ButtonVariant.secondary
}) => {
  const { helpers } = useGuiField(name2);
  const {
    cleanUpFile,
    error: error2,
    metadata,
    progress,
    setMetadata,
    success,
    uploadForm
  } = useUploadForm(autoUpload);
  const [files2, setFiles] = useState(
    initialFiles.map((obj) => {
      if (isFileMetadata(obj)) {
        return { file: obj.file };
      }
      return { file: obj };
    })
  );
  useEffect(() => {
    setMetadata(
      initialFiles.reduce((acc, obj) => {
        if (isFileMetadata(obj)) {
          acc[obj.file.name] = obj.meta;
        } else {
          acc[obj.name] = null;
        }
        return acc;
      }, {})
    );
  }, []);
  const AutoUploadFiles = useCallback(
    (files22) => {
      if (autoUpload) {
        files22.forEach((file) => {
          uploadForm(file).then((res) => {
            if (onUploadComplete && res)
              onUploadComplete(res);
          });
        });
      }
    },
    [autoUpload, onUploadComplete, uploadForm]
  );
  const handleFileChange = useCallback(
    (e3) => {
      onFileChange == null ? void 0 : onFileChange(e3);
      if (e3.target.files) {
        const selectedFiles = Array.from(e3.target.files);
        setFiles((files22) => {
          return [
            ...multiple ? files22 : [],
            ...selectedFiles.map((file) => ({ file }))
          ];
        });
        AutoUploadFiles([...selectedFiles]);
      }
    },
    [onFileChange, multiple, setFiles, AutoUploadFiles]
  );
  useEffect(() => {
    helpers == null ? void 0 : helpers.setValue(files2.map(({ file }) => file));
  }, [files2]);
  const removeFile = useCallback(
    (fileIndex) => async () => {
      const { file } = files2[fileIndex];
      if (onFileDelete) {
        await onFileDelete(file, metadata[file.name]);
      }
      cleanUpFile(file.name);
      setFiles((files22) => [
        ...files22.slice(0, fileIndex),
        ...files22.slice(fileIndex + 1, files22.length)
      ]);
    },
    [onFileDelete, files2, cleanUpFile, metadata]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { align: "start", spacing: 1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, { disabled, name: name2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      FileSelector,
      {
        accept,
        buttonSize,
        disabled,
        handleFileChange,
        label: buttonLabel,
        multiple,
        name: name2,
        sx: sxFileSelector,
        variant: variant3
      }
    ) }),
    files2 || initialFiles ? /* @__PURE__ */ jsxRuntimeExports.jsx(VStack, { sx: { gap: 0.5, ...sxFilesContainer }, children: files2.map(({ file }, index2) => {
      const { name: name22 } = file;
      if (fileTileRender) {
        return fileTileRender({
          error: error2[name22],
          errorText,
          fileName: name22,
          progress: progress[name22],
          removeFile: removeFile(index2),
          success: success[name22]
        });
      } else {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(
          FileTile,
          {
            error: error2[name22],
            errorText,
            fileName: name22,
            progress: progress[name22],
            removeFile: removeFile(index2),
            success: success[name22],
            sx: sxFileTile
          },
          name22
        );
      }
    }) }) : null
  ] });
};
const SalesFunnelHeader = ({
  logoProps = { name: "GuidelineDefault", href: "/" },
  afterElement = void 0
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "header", sx: salesFunnel.outerContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
  Flex,
  {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    spacing: salesFunnel$1.innerContainerGap,
    sx: salesFunnel.innerContainer,
    children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Logo, { ...logoProps, sx: salesFunnel.logo }),
      afterElement && /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMedia, { smUp: true, children: afterElement })
    ]
  }
) });
const NavbarBrand = ({
  as: Component2 = Link$1,
  children: children2,
  href = "/",
  variant: variant3 = NavbarBrandVariant.default,
  ...restOfProps
}) => {
  const { closeMenu } = useNavbar();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Component2,
    {
      "aria-label": "brand-logo",
      href,
      onClick: closeMenu,
      ...restOfProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: { variant: `navbarBrand.${variant3}` }, children: children2 })
    }
  );
};
const DrawerContent = ({
  children: children2 = void 0,
  variant: variant3 = NavbarDropdownVariant.default
}) => {
  const { linkState } = useNavbar();
  const links = linkState.visible.concat(linkState.overflown);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    children2,
    variant3 === NavbarDropdownVariant.workflow && links.map(
      (navbarLink, i2) => cloneElement(navbarLink, {
        key: i2,
        _forDropdown: true
      })
    )
  ] });
};
const DropdownContent = ({ children: children2 = void 0 }) => {
  const { linkState } = useNavbar();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    linkState.overflown.map(
      (navbarLink, i2) => cloneElement(navbarLink, {
        key: i2,
        _forDropdown: true
      })
    ),
    children2
  ] });
};
const Content$1 = ({
  "data-test-id": dataTestId = void 0,
  icon: icon2 = void 0,
  title,
  variant: variant3 = NavbarDropdownVariant.default
}) => {
  if (variant3 === NavbarDropdownVariant.workflow) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Avatar,
      {
        backgroundColor: "avatar.dusk.background",
        size: AvatarSize.small,
        textColor: "avatar.dusk.text",
        title
      }
    );
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    icon2 && /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: icon2, size: IconSizes.Icon16 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Title,
      {
        as: "p",
        dataTestId,
        sx: {
          maxWidth: "280px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        },
        variant: TitleSizes$1.Title14,
        children: title == null ? void 0 : title.trim()
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon,
      {
        name: "chevronDown",
        size: IconSizes.Icon12,
        sx: { flex: "1 0 auto" }
      }
    )
  ] });
};
const Control = ({
  "data-test-id": dataTestId = void 0,
  icon: icon2 = void 0,
  title,
  variant: variant3 = NavbarDropdownVariant.default
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(WrappedDropdown.Control, { variant: DropdownControlVariants.navigation, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      alignItems: "center",
      sx: { height: "100%", marginX: "navbar.link.marginX" },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { alignItems: "center", spacing: 0.5, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Content$1,
        {
          "data-test-id": dataTestId,
          icon: icon2,
          title,
          variant: variant3
        }
      ) })
    }
  ) });
};
const Divider = ({ sx: sx2 = {}, ...restOfProps }) => {
  const { drawerState } = useNavbar();
  if (drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Divider$1,
    {
      ...restOfProps,
      sx: { width: "navbar.dropdown.divider.width", marginX: "auto", ...sx2 },
      variant: DividerVariant.secondary
    }
  );
};
const BaseDropdownItem = forwardRef(
  ({
    as: Component2 = Link$1,
    children: children2,
    disabled = false,
    height = MenuListItemSizes.default,
    href,
    onClick,
    active,
    shouldCloseMenuOnClick = true,
    ...restOfProps
  }, ref2) => {
    const { closeMenu } = useNavbar();
    const closeDrawerOnClick = useEventCallback$1(
      () => {
        if (shouldCloseMenuOnClick) {
          closeMenu();
        }
      },
      onClick,
      []
    );
    const isLink = !!href;
    const content2 = /* @__PURE__ */ jsxRuntimeExports.jsx(
      wrapped$1,
      {
        active,
        height,
        sx: {
          paddingX: "navbar.dropdown.item.px",
          backgroundColor: "unset",
          "&:hover": {
            backgroundColor: "unset"
          }
        },
        variant: MenuListItemVariants.navigation,
        children: children2
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: isLink ? /* @__PURE__ */ jsxRuntimeExports.jsx(Box$1, { sx: styles$2.linkWrapper(active), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Component2,
      {
        ...restOfProps,
        disabled,
        href,
        onClick: closeDrawerOnClick,
        ref: ref2,
        children: content2
      }
    ) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        ...onClick && {
          ...restOfProps,
          onClick: closeDrawerOnClick,
          as: "button",
          ref: ref2
        },
        sx: styles$2.button(active),
        children: content2
      }
    ) });
  }
);
const styles$2 = {
  linkWrapper: (active) => ({
    display: "flex",
    width: "100%",
    "&:hover": {
      boxShadow: "unset"
    },
    "& a": {
      textDecoration: "none",
      width: "100%",
      backgroundColor: active ? "navbar.dropdown.item.active" : "initial",
      "&:hover": {
        backgroundColor: "menuListItem.background.hover"
      }
    }
  }),
  button: (active) => ({
    width: "100%",
    border: "none",
    padding: 0,
    background: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    backgroundColor: active ? "navbar.dropdown.item.active" : "initial",
    "&:hover": {
      backgroundColor: "menuListItem.background.hover"
    }
  })
};
const AvatarDropdownItem = ({
  subTitle = void 0,
  title,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BaseDropdownItem,
    {
      height: MenuListItemSizes.workflowNavigation,
      ...restOfProps,
      children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", spacing: 1, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Avatar,
          {
            backgroundColor: "avatar.dusk.background",
            size: AvatarSize.medium,
            textColor: "avatar.dusk.text",
            title
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Flex,
          {
            flexDirection: "column",
            flexGrow: 0,
            sx: {
              textAlign: "left",
              whiteSpace: "nowrap"
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { as: "p", sx: textStyling, variant: TitleSizes$1.Title24, children: title }),
              Boolean(subTitle) && /* @__PURE__ */ jsxRuntimeExports.jsx(
                Paragraph2,
                {
                  color: TextColors.tertiary,
                  sx: textStyling,
                  variant: ParagraphSizes.Paragraph14,
                  children: subTitle
                }
              )
            ]
          }
        )
      ] })
    }
  );
};
const textStyling = {
  textAlign: "left",
  textOverflow: "ellipsis",
  overflow: "hidden"
};
const LinkDropdownItem = ({
  children: children2,
  icon: icon2 = void 0,
  tag: tag2 = void 0,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BaseDropdownItem, { ...restOfProps, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", spacing: 0.5, children: [
    icon2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: icon2, size: IconSizes.Icon16, sx: { flexShrink: 0 } }) : null,
    children2,
    tag2 || null
  ] }) });
};
const Footer$1 = forwardRef(
  ({
    children: children2,
    variant: variant3 = NavbarDropdownFooterVariant.default,
    ...restOfProps
  }, ref2) => {
    const { drawerState } = useNavbar();
    const hasDrawer = drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex,
      {
        ...restOfProps,
        "data-test-id": "dropdown-footer",
        flex: hasDrawer ? 1 : "unset",
        flexDirection: "column-reverse",
        flexGrow: 0,
        variant: `navbarDropdownFooter.${variant3}`,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { ref: ref2, sx: styles$1.footer.content(variant3, hasDrawer), children: children2 })
      }
    );
  }
);
const styles$1 = {
  footer: {
    content: (variant3, hasDrawer) => {
      if (variant3 === NavbarDropdownFooterVariant.workflow) {
        return {};
      }
      return {
        py: hasDrawer ? "navbar.dropdown.footer.content.drawer.py" : "navbar.dropdown.footer.content.py",
        color: "navbar.dropdown.footer.color",
        backgroundColor: "navbar.dropdown.footer.background",
        marginX: "navbar.dropdown.footer.marginX",
        px: "navbar.dropdown.footer.px"
      };
    }
  }
};
const NavbarDropdown = ({
  children: children2,
  "data-test-id": dataTestId,
  footer: footer2,
  title,
  icon: icon2 = void 0,
  variant: variant3 = NavbarDropdownVariant.default
}) => {
  const { drawerState, isMenuOpen, setIsMenuOpen } = useNavbar();
  const menuRef = useRef(null);
  useStyle();
  useKeyboardNavigation({
    enabled: isMenuOpen,
    initiateFocus: true,
    orientation: Orientation.VERTICAL,
    parentRef: menuRef
  });
  if (drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerContent, { variant: variant3, children: children2 }),
      footer2
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(WrappedDropdown, { isOpen: isMenuOpen, setIsOpen: setIsMenuOpen, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Control,
      {
        "data-test-id": dataTestId,
        icon: icon2,
        title,
        variant: variant3
      }
    ),
    isMenuOpen && variant3 === NavbarDropdownVariant.workflow && /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "span", id: "tail" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      WrappedDropdown.Content,
      {
        ref: menuRef,
        variant: determineDropdownContentVariant(variant3),
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownContent, { variant: variant3, children: children2 }),
          footer2
        ]
      }
    )
  ] });
};
const determineDropdownContentVariant = (variant3) => {
  if (variant3 === NavbarDropdownVariant.workflow) {
    return MenuListVariants.workflow;
  }
  return MenuListVariants.navigation;
};
NavbarDropdown.Item = LinkDropdownItem;
NavbarDropdown.LinkItem = LinkDropdownItem;
NavbarDropdown.AvatarItem = AvatarDropdownItem;
NavbarDropdown.Divider = Divider;
NavbarDropdown.Footer = Footer$1;
function isReactElement(children2) {
  return Array.isArray(children2) === false;
}
function toReactElementArray(children2) {
  if (isReactElement(children2)) {
    return [children2];
  }
  return children2;
}
const createCallbackRefsForLinks = (linkElements, linkWidthsRef) => {
  return toReactElementArray(linkElements).map(
    (element, i2) => React__default.cloneElement(element, {
      ref: (el) => {
        if (el) {
          let width = el.offsetWidth;
          const style2 = getComputedStyle(el);
          width += parseInt(style2.marginLeft, 10);
          width += parseInt(style2.marginRight, 10);
          linkWidthsRef.current[i2] = width;
        }
      },
      key: i2
    })
  );
};
function determineLinkState(containerWidth, linkElements) {
  const visible = [];
  const overflown = [];
  let currentWidthOfLinks = 0;
  let hasOverflown = false;
  linkElements.forEach(({ element, width: linkWidth }) => {
    if (currentWidthOfLinks <= containerWidth) {
      if (hasOverflown) {
        overflown.push(element);
      } else if (currentWidthOfLinks + linkWidth > containerWidth) {
        overflown.push(element);
        hasOverflown = true;
      } else {
        visible.push(element);
        currentWidthOfLinks += linkWidth;
      }
    }
  });
  return { visible, overflown };
}
function linkStateChanged(previousState, newState) {
  return previousState.visible.length !== newState.visible.length && previousState.overflown.length !== newState.overflown.length;
}
function mapToLinkElement(children2, linkWidths) {
  const elementArray = toReactElementArray(children2);
  if (elementArray.length !== linkWidths.length) {
    return [];
  }
  const linkElements = [];
  elementArray.forEach((link2, index2) => {
    linkElements[index2] = {
      element: link2,
      width: linkWidths[index2]
    };
  });
  return linkElements;
}
const navbarLinkColor = (variant3) => {
  if (variant3 === NavbarVariant.workflow) {
    return TextColors.primary;
  }
  return TextColors.primary;
};
const NavbarLink = React__default.forwardRef(
  ({
    active = false,
    as: Component2 = Link$1,
    children: children2,
    disabled = false,
    href,
    icon: icon2 = void 0,
    onClick = noop$6,
    shouldCloseMenuOnClick = true,
    sx: sx2 = {},
    variant: variant3 = NavbarVariant.default,
    _forDropdown = false,
    ...restOfProps
  }, ref2) => {
    const { style: style2 } = useStyle(sx2);
    const { drawerState, closeMenu } = useNavbar();
    const onClickHandler = useEventCallback$1(
      () => {
        if (shouldCloseMenuOnClick) {
          closeMenu();
        }
      },
      onClick,
      []
    );
    if (drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer || _forDropdown) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        NavbarDropdown.Item,
        {
          ...restOfProps,
          active,
          as: Component2,
          disabled,
          href,
          icon: icon2,
          onClick,
          shouldCloseMenuOnClick,
          children: children2
        }
      );
    }
    const wrappedChildren = /* @__PURE__ */ jsxRuntimeExports.jsx(
      Title,
      {
        as: "span",
        color: navbarLinkColor(variant3),
        sx: style2(linkStyles.text),
        variant: TitleSizes$1.Title14,
        children: children2
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Flex,
      {
        as: "li",
        flexShrink: 0,
        flexWrap: "nowrap",
        ref: ref2,
        sx: style2(linkStyles.wrapper),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Component2,
          {
            ...restOfProps,
            "aria-current": active ? "page" : void 0,
            disabled,
            href,
            onClick: onClickHandler,
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { alignItems: "center", sx: linkStyles.container(active), children: icon2 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "flex-start", spacing: 0.5, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { name: icon2, size: IconSizes.Icon16 }),
              wrappedChildren
            ] }) : wrappedChildren })
          }
        )
      }
    );
  }
);
const linkStyles = {
  container: (active) => ({
    position: "relative",
    height: "100%",
    paddingX: "navbar.link.paddingX",
    ...active && {
      ":after": {
        content: '""',
        backgroundColor: "navbar.link.borderColor.active",
        position: "absolute",
        bottom: 0,
        left: 0,
        height: "navbar.linkBorder.height",
        width: "100%"
      }
    }
  }),
  text: {
    // explicitly unitless
    lineHeight: "1.25"
  },
  wrapper: {
    height: "100%",
    marginLeft: 1,
    "> *": {
      textDecoration: "none",
      backgroundColor: "navbar.link.background",
      height: "100%",
      ":hover": {
        backgroundColor: "navbar.link.background.hover"
      },
      paddingTop: "navbar.link.borderOffset"
    }
  }
};
const useNavOverflow = (children2) => {
  const containerRef = useRef(null);
  const linkWidthsRef = useRef([]);
  const childrenWithRefs = useMemo(
    () => createCallbackRefsForLinks(children2, linkWidthsRef),
    [children2]
  );
  const { linkState, setLinkState } = useNavbar();
  const prevLinkState = usePrevious(linkState);
  useEffect(() => {
    setLinkState({
      visible: childrenWithRefs,
      overflown: []
    });
  }, [children2, childrenWithRefs, setLinkState]);
  useResizeObserver(
    () => {
      if (!containerRef.current || linkWidthsRef.current.length === 0 || !prevLinkState.current) {
        return;
      }
      const containerWidth = containerRef.current.offsetWidth;
      const linkElements = mapToLinkElement(children2, linkWidthsRef.current);
      const newLinkState = determineLinkState(containerWidth, linkElements);
      if (linkStateChanged(prevLinkState.current, newLinkState)) {
        setLinkState(newLinkState);
      }
    },
    containerRef,
    [childrenWithRefs],
    { throttle: Throttle.movement }
  );
  return { containerRef, visibleLinks: linkState.visible };
};
const NavbarLinks = ({
  children: children2,
  sx: sx2 = {},
  variant: variant3 = NavbarVariant.default
}) => {
  const { style: style2 } = useStyle(sx2);
  const { drawerState } = useNavbar();
  const { containerRef, visibleLinks } = useNavOverflow(children2);
  const hasDrawer = drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer;
  if (variant3 === NavbarVariant.workflow && hasDrawer) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      alignItems: hasDrawer ? "flex-start" : "center",
      as: "ul",
      flex: hasDrawer ? "unset" : 1,
      flexDirection: hasDrawer ? "column" : "row",
      justifyContent: justifyContent(variant3),
      ref: containerRef,
      sx: style2(containerStyles(hasDrawer)),
      children: visibleLinks
    }
  );
};
const containerStyles = (hasDrawer) => ({
  overflow: hasDrawer ? "initial" : "visible",
  padding: 0
  // To remove standard padding-inline-start from ul
});
const justifyContent = (variant3) => {
  if (variant3 === NavbarVariant.workflow) {
    return "flex-end";
  }
  return "flex-start";
};
const NavbarProfile = ({
  children: children2,
  "data-test-id": dataTestId
}) => {
  const { drawerState } = useNavbar();
  const hasDrawer = drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      "data-test-id": dataTestId,
      flex: !hasDrawer ? "none" : "1",
      flexDirection: !hasDrawer ? "row-reverse" : "column",
      children: children2
    }
  );
};
const menuTop = "M 1,3 L 15,3";
const menuCenter = "M 1,8 L 15,8";
const menuBottom = "M 1,13 L 15,13";
const xForwardSlash = "M 2,14 L 14,2";
const xBackwardSlash = "M 2,2 L 14,14";
const HamburgerIcon = ({ isOpen }) => {
  const menuTopStyles = useSpring({
    d: isOpen ? xForwardSlash : menuTop
  });
  const menuCenterStyles = useSpring({
    opacity: isOpen ? 0 : 1
  });
  const menuBottomStyles = useSpring({
    d: isOpen ? xBackwardSlash : menuBottom
  });
  const { theme: theme2 } = useTheme();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "svg",
    {
      "data-icon": isOpen ? "x" : "menu",
      height: theme2.sizes.icon[16],
      stroke: theme2.colors.icon.__default,
      width: theme2.sizes.icon[16],
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(animated.path, { d: menuTopStyles.d, stroke: "current", strokeWidth: "1.5" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          animated.path,
          {
            d: menuCenter,
            stroke: "current",
            strokeWidth: "1.5",
            style: menuCenterStyles
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          animated.path,
          {
            d: menuBottomStyles.d,
            stroke: "current",
            strokeWidth: "1.5"
          }
        )
      ]
    }
  ) });
};
const NavbarCollapse = ({ children: children2 }) => {
  const { closeMenu, drawerState, isMenuOpen, toggleMenu } = useNavbar();
  const buttonRef = useRef(null);
  if (drawerState === DrawerState.partialDrawer || drawerState === DrawerState.fullDrawer) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { alignSelf: "center", flex: "1 0 auto", flexDirection: "row-reverse", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Box$1,
        {
          "aria-label": isMenuOpen ? "close-menu" : "menu",
          as: "button",
          onClick: toggleMenu,
          ref: buttonRef,
          sx: {
            cursor: "pointer",
            border: "unset",
            background: "inherit",
            padding: 1
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(HamburgerIcon, { isOpen: isMenuOpen })
        }
      ) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        Drawer,
        {
          dismissOnOverlayClick: true,
          fullWidthBreakpoint: MatchMediaQuery.xs,
          hideCloseIcon: true,
          isOpen: isMenuOpen,
          onDismiss: closeMenu,
          variant: DrawerVariant.navbar,
          widthOverride: NAVBAR_DRAWER_WIDTH,
          children: children2
        }
      )
    ] });
  }
  return children2;
};
const DEBOUNCE_WAIT = Throttle.loading;
const NavbarComponent = ({
  children: children2,
  containerVariant = ContainerVariants.large,
  "data-test-id": dataTestId,
  variant: variant3 = NavbarVariant.default
}) => {
  const [isAtTopOfPage, setIsAtTopOfPage] = useState(true);
  const { isMenuOpen, drawerOffset, drawerState, setDrawerOffset } = useNavbar();
  const ref2 = useRef(null);
  useEffect(() => {
    if (ref2 && ref2.current) {
      const navbarY = ref2.current.getBoundingClientRect().y;
      if (drawerOffset !== navbarY) {
        setDrawerOffset(navbarY);
      }
    }
  }, []);
  useEffect(() => {
    const debouncedSetIsTopOfPage = debounce$3(() => {
      setIsAtTopOfPage(window.scrollY === 0);
    }, DEBOUNCE_WAIT);
    window.addEventListener("scroll", debouncedSetIsTopOfPage, {
      passive: true
    });
    return () => {
      window.removeEventListener("scroll", debouncedSetIsTopOfPage);
    };
  }, []);
  const isDrawerOpen = isMenuOpen && drawerState !== DrawerState.none;
  const shouldDisplayBoxShadow = !isAtTopOfPage || isDrawerOpen;
  useKeyboardNavigation({
    enabled: isMenuOpen === false,
    orientation: Orientation.HORIZONTAL,
    parentRef: ref2
  });
  const containerMaxWidth = useMemo(() => {
    if (containerVariant === ContainerVariants.fluid) {
      return void 0;
    }
    const maxWidthMap = {
      [ContainerVariants.medium]: screenSizes$1.mediumMax,
      [ContainerVariants.large]: screenSizes$1.largeMax,
      [ContainerVariants.small]: screenSizes$1.smallMax,
      [ContainerVariants.xSmall]: screenSizes$1.xSmallMax,
      [ContainerVariants.fluid]: void 0
    };
    return `calc(${maxWidthMap[containerVariant]}px + calc(${navbarBrandMarginX} + ${navbarBrandMarginX}))`;
  }, [containerVariant]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Flex,
    {
      as: "nav",
      "data-test-id": dataTestId,
      ref: ref2,
      sx: {
        variant: `navbar.${variant3}`,
        boxShadow: shouldDisplayBoxShadow ? "elevation.two" : "unset",
        ...styles.navbar
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Container$1,
        {
          sx: {
            maxWidth: containerMaxWidth,
            paddingRight: buildResponsiveValues({ mdDown: navbarBrandMarginX }),
            paddingLeft: buildResponsiveValues({ mdDown: navbarBrandMarginX })
          },
          variant: containerVariant,
          children: children2
        }
      )
    }
  );
};
const Navbar = ({ children: children2, ...props2 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NavbarProvider, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(NavbarComponent, { ...props2, children: children2 }) });
};
const styles = {
  navbar: {
    transition: "box-shadow 0.3s",
    "& a": {
      "&.focus-visible": {
        boxShadow: "menuListItem.navigation.active",
        borderRadius: "menuListItem.container",
        borderWidth: 0,
        outline: "unset"
      },
      "&:focus": {
        borderWidth: 0
      },
      "&:active": {
        opacity: "initial"
      }
    },
    "& button": {
      "&.focus-visible": {
        boxShadow: "menuListItem.navigation.active",
        borderRadius: "menuListItem.container"
      },
      "&:focus-visible": {
        outline: "unset"
      }
    }
  }
};
Navbar.Brand = NavbarBrand;
Navbar.Links = NavbarLinks;
Navbar.Link = NavbarLink;
Navbar.Profile = NavbarProfile;
Navbar.Collapse = NavbarCollapse;
const TooltipItem = ({ value, color: color2, label: label2 }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "baseline",
      "data-test-id": "contributions-tooltip-item",
      spacing: 0.5,
      sx: { mb: 0.75 },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            sx: {
              height: "contributionChart.tooltip.item.height",
              width: "contributionChart.tooltip.item.width",
              borderRadius: "50%",
              backgroundColor: color2
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Title, { as: "div", color: TextColors.tertiary, variant: TitleSizes$1.Title14, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Title,
            {
              as: "span",
              color: TextColors.secondary,
              variant: TitleSizes$1.Title14,
              children: value
            }
          ),
          " ",
          label2
        ] })
      ]
    }
  );
};
const ContributionChartTooltip = ({
  title,
  data,
  id = void 0,
  ariaLive = "off"
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      "aria-live": ariaLive,
      "data-test-id": "contributions-tooltip",
      id,
      sx: {
        p: "contributionChart.tooltip.container.p",
        width: "contributionChart.tooltip.width",
        textAlign: "left"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Title,
          {
            as: "div",
            sx: { mb: "contributionChart.tooltip.title.mb" },
            variant: TitleSizes$1.Title14,
            children: title
          }
        ),
        data.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(
          TooltipItem,
          {
            color: item.color,
            label: item.label,
            value: item.value
          },
          item.label
        ))
      ]
    }
  );
};
const ContributionProgressBar = ({
  colors: colors3,
  data
}) => {
  const isFirstBarMaximum = (data == null ? void 0 : data[0]) === 100;
  const isSecondBarMaximum = (data == null ? void 0 : data[0]) + (data == null ? void 0 : data[1]) === 100;
  const isFirstBarEmpty = (data == null ? void 0 : data[0]) === 0;
  const borderRadiusValue = "contributionChart.progressBar.borderRadius";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      sx: {
        position: "relative",
        height: "contributionChart.progressBar.height",
        width: "100%",
        backgroundColor: colors3 == null ? void 0 : colors3[2],
        borderRadius: borderRadiusValue
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            "data-test-id": "progress-first-bar",
            sx: {
              position: "absolute",
              left: 0,
              height: "100%",
              width: `${data == null ? void 0 : data[0]}%`,
              backgroundColor: colors3 == null ? void 0 : colors3[0],
              borderBottomLeftRadius: borderRadiusValue,
              borderTopLeftRadius: borderRadiusValue,
              borderTopRightRadius: isFirstBarMaximum ? borderRadiusValue : 0,
              borderBottomRightRadius: isFirstBarMaximum ? borderRadiusValue : 0
            }
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box,
          {
            "data-test-id": "progress-second-bar",
            sx: {
              position: "absolute",
              left: `${data == null ? void 0 : data[0]}%`,
              height: "100%",
              width: `${data == null ? void 0 : data[1]}%`,
              backgroundColor: colors3 == null ? void 0 : colors3[1],
              borderTopRightRadius: isSecondBarMaximum ? borderRadiusValue : 0,
              borderBottomRightRadius: isSecondBarMaximum ? borderRadiusValue : 0,
              borderBottomLeftRadius: isFirstBarEmpty ? borderRadiusValue : 0,
              borderTopLeftRadius: isFirstBarEmpty ? borderRadiusValue : 0
            }
          }
        )
      ]
    }
  );
};
const PersonalContributionsChart = ({
  chartColors,
  dataChartPercentages,
  tooltip
}) => {
  const { title, data } = tooltip;
  const [chartId] = useState(() => uniqueId$1("contributions-chart-"));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Popover.Source, { trigger: Triggers.hover, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        "aria-labelledby": chartId,
        "data-test-id": "contributions-progress-bar",
        role: "toolbar",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ContributionProgressBar,
          {
            colors: chartColors,
            data: dataChartPercentages
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover.Content,
      {
        placementOverride: {
          position: Alignment.bottom,
          positionAndAlignment: Alignment.bottom
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ContributionChartTooltip,
          {
            ariaLive: "polite",
            data,
            id: chartId,
            title
          }
        )
      }
    )
  ] });
};
const Context = React__default.createContext(void 0);
const ProgressivePaginationProvider = ({
  children: children2,
  currentPage,
  onPageChange,
  totalPages = void 0
}) => {
  const assumedTotalPages = totalPages ?? currentPage;
  const goToNextPage = useCallback(() => {
    if (!totalPages || currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  }, [currentPage, onPageChange, totalPages]);
  const goToPreviousPage = useCallback(() => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  }, [currentPage, onPageChange]);
  const goToPage = useCallback(
    (page) => {
      if (page > 0 && page <= assumedTotalPages) {
        onPageChange(page);
      }
    },
    [assumedTotalPages, onPageChange]
  );
  const goToFirstPage = useCallback(() => {
    onPageChange(1);
  }, [onPageChange]);
  const goToLastPage = useCallback(() => {
    onPageChange(totalPages ?? -1);
  }, [onPageChange, totalPages]);
  const memoizedContext = useMemo(
    () => ({
      currentPage,
      totalPages,
      goToNextPage,
      goToPreviousPage,
      goToPage,
      goToFirstPage,
      goToLastPage,
      onPageChange
    }),
    [
      currentPage,
      totalPages,
      goToNextPage,
      goToPreviousPage,
      goToPage,
      goToFirstPage,
      goToLastPage,
      onPageChange
    ]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Context.Provider, { value: memoizedContext, children: children2 });
};
const useProgressivePagination = () => {
  const context = useContext(Context);
  if (context === void 0) {
    throw new Error(
      "useProgressivePagination must be used within a <ProgressivePaginationProvider />"
    );
  }
  return context;
};
const ProgressivePaginationBase = ({
  disabled = false,
  showFirstLastControls = true
}) => {
  const {
    currentPage,
    totalPages,
    goToPreviousPage,
    goToNextPage,
    goToPage,
    goToFirstPage,
    goToLastPage
  } = useProgressivePagination();
  const pages = useMemo(
    () => getPagesList(currentPage, totalPages),
    [currentPage, totalPages]
  );
  const prependedControls = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    showFirstLastControls && /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavArrowPage,
      {
        disabled: currentPage === 1 || disabled,
        icon: "caretLeftDouble",
        onClick: goToFirstPage
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavArrowPage,
      {
        disabled: currentPage === 1 || disabled,
        icon: "chevronLeft",
        onClick: goToPreviousPage
      }
    )
  ] });
  const appendedControls = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavArrowPage,
      {
        disabled: currentPage === totalPages || disabled,
        icon: "chevronRight",
        onClick: goToNextPage
      }
    ),
    showFirstLastControls && /* @__PURE__ */ jsxRuntimeExports.jsx(
      NavArrowPage,
      {
        disabled: currentPage === totalPages || disabled,
        icon: "caretRightDouble",
        onClick: goToLastPage
      }
    )
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    PaginationControls,
    {
      appendedControls,
      currentPage,
      disabled,
      goToNextPage,
      goToPage,
      goToPreviousPage,
      pages,
      prependedControls
    }
  );
};
const ProgressivePagination = ({
  onPageChange,
  totalPages = void 0,
  currentPage,
  ...props2
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    ProgressivePaginationProvider,
    {
      currentPage,
      onPageChange,
      totalPages,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ProgressivePaginationBase, { ...props2 })
    }
  );
};
const SectionBreakdown = ({
  indicatorColor,
  title,
  percentage,
  testId
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      alignItems: "center",
      "data-test-id": testId,
      flexWrap: "wrap",
      justifyContent: "space-between",
      spacing: 0.5,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", flexWrap: "wrap", spacing: 0.5, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            wrapped,
            {
              backgroundColor: indicatorColor,
              variant: NotificationVariant.dot
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Paragraph2,
            {
              color: TextColors.primary,
              sx: { marginBottom: 0 },
              variant: ParagraphSizes.Paragraph16,
              children: title
            }
          )
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(
          Paragraph2,
          {
            color: TextColors.primary,
            sx: { marginBottom: 0 },
            variant: ParagraphSizes.Paragraph16,
            children: [
              percentage,
              "%"
            ]
          }
        )
      ]
    }
  );
};
const HorizontalBar = ({
  percentage = 0,
  indicatorColor,
  title
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Popover, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Popover.Source, { trigger: Triggers.hover, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Box$1,
      {
        as: "data",
        "data-test-id": `percentage-stacked-bar-${percentage}`,
        sx: {
          height: "100%",
          width: `${Number(percentage) || 0}%`,
          backgroundColor: indicatorColor,
          borderRadius: 0
        }
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Popover.Content,
      {
        placementOverride: {
          position: Alignment.bottom,
          positionAndAlignment: Alignment.bottom
        },
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          Box$1,
          {
            "aria-live": "polite",
            sx: {
              p: "percentageStackedBarChart.tooltip.container.p",
              width: "percentageStackedBarChart.tooltip.width",
              textAlign: "left"
            },
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(
              SectionBreakdown,
              {
                indicatorColor,
                percentage,
                testId: "percentage-stacked-bar-chart-tooltip-item",
                title
              }
            )
          }
        )
      }
    )
  ] });
};
const Legend = ({ sections, showLegend }) => {
  if (!showLegend)
    return null;
  const list = "percentageStackedBarChart.legend.list";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { as: "figcaption", "data-test-id": "percentage-stacked-bar-chart-legend", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    UnorderedList,
    {
      sx: {
        padding: `${list}.padding`,
        display: "flex",
        flexDirection: "column",
        gap: `${list}.gap`
      },
      children: sections.map((section) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItem, { variant: ListItemVariants.unstyled, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          SectionBreakdown,
          {
            indicatorColor: section.indicatorColor,
            percentage: section.percentage,
            title: section.title
          }
        ) }, section.title);
      })
    }
  ) });
};
function formatPercentage(percentage) {
  const percentageFormatter = Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2
  });
  let castPercentage = clamp$1(Number(percentage) || 0, 0, 1) * 100;
  if (castPercentage > 100) {
    castPercentage = 100;
  }
  return Number(percentageFormatter.format(castPercentage));
}
const PercentageStackedBarChart = ({
  sx: sx2 = {},
  trackBackgroundColor = "percentageStackedBarChart.trackBackground",
  sections = [],
  otherSectionBackgroundColor = "percentageStackedBarChart.otherFilledBackground",
  otherSectionLabel = "Other",
  accessibilityDescription,
  showLegend = false
}) => {
  const [labelId] = useMemo(() => uniqueId$1("chartlabel-"), []);
  const formattedSections = sections.map((section) => {
    return { ...section, percentage: formatPercentage(section.percentage) };
  });
  const sectionsTotal = formattedSections == null ? void 0 : formattedSections.reduce((acc, section) => {
    acc += Number(section.percentage) || 0;
    return acc;
  }, 0);
  const legendSections = [...formattedSections];
  const totalRepresented = sectionsTotal >= 100;
  const barSections = (() => {
    return formattedSections == null ? void 0 : formattedSections.map((section) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(HorizontalBar, { ...section }, section.title);
    });
  })();
  if (!totalRepresented) {
    const otherPercentage = formatPercentage((100 - sectionsTotal) / 100);
    barSections.push(
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        HorizontalBar,
        {
          indicatorColor: otherSectionBackgroundColor,
          percentage: otherPercentage,
          title: otherSectionLabel
        },
        "other"
      )
    );
    legendSections.push({
      percentage: otherPercentage,
      title: otherSectionLabel,
      indicatorColor: otherSectionBackgroundColor
    });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { as: "figure", flexDirection: "column", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Box,
      {
        "aria-labelledby": labelId,
        sx: {
          display: "flex",
          gap: "2px",
          height: "percentageStackedBarChart.percentageBar.height",
          width: "100%",
          backgroundColor: trackBackgroundColor,
          borderRadius: baseRadii[4],
          "data:first-of-type": {
            borderTopLeftRadius: baseRadii[4],
            borderBottomLeftRadius: baseRadii[4]
          },
          "data:last-of-type": {
            borderTopRightRadius: baseRadii[4],
            borderBottomRightRadius: baseRadii[4]
          },
          ...sx2
        },
        tabIndex: -1,
        children: [
          barSections,
          accessibilityDescription ? /* @__PURE__ */ jsxRuntimeExports.jsx(VisuallyHidden, { "data-test-id": "a11y-description", id: labelId, children: accessibilityDescription }) : null
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Legend, { sections: legendSections, showLegend })
  ] });
};
const SummaryCard = ({
  /**
   * Button element to use for action.
   * */
  action: action2 = void 0,
  /**
   * String value to display description
   * */
  descriptionText = "",
  /**
   * String value to display in eyebrow
   * */
  eyebrowText = "",
  /**
   * String value to display in label
   * */
  labelText = "",
  /**
   * Styling object
   * */
  sx: sx2 = {},
  ...restOfProps
}) => {
  const { style: style2 } = useStyle(sx2);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      spacing: "summaryCard.default.wrapperGap",
      sx: style2(styles$t.wrapper),
      variant: `summaryCard.default`,
      ...restOfProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { children: [
          eyebrowText ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Title,
            {
              as: "h5",
              color: TextColors.tertiary,
              sx: styles$t.default.eyebrow,
              variant: TitleSizes$1.Title14,
              children: eyebrowText
            }
          ) : null,
          labelText ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Title,
            {
              as: "div",
              color: TextColors.primary,
              sx: styles$t.default.label,
              variant: TitleSizes$1.Title16,
              children: labelText
            }
          ) : null,
          descriptionText ? /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { color: TextColors.tertiary, sx: styles$t.default.description, children: descriptionText }) : null
        ] }),
        action2 != null ? /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { sx: styles$t.default.action, children: action2 }) : null
      ]
    }
  );
};
function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function() {
  this._size = 0;
  this._values = /* @__PURE__ */ Object.create(null);
};
Cache.prototype.get = function(key) {
  return this._values[key];
};
Cache.prototype.set = function(key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values))
    this._size++;
  return this._values[key] = value;
};
var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, DIGIT_REGEX = /^\d+$/, LEAD_DIGIT_REGEX = /^\d/, SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, MAX_CACHE_SIZE = 512;
var pathCache = new Cache(MAX_CACHE_SIZE), setCache = new Cache(MAX_CACHE_SIZE), getCache = new Cache(MAX_CACHE_SIZE);
var propertyExpr = {
  Cache,
  split,
  normalizePath,
  setter: function(path2) {
    var parts = normalizePath(path2);
    return setCache.get(path2) || setCache.set(path2, function setter(obj, value) {
      var index2 = 0;
      var len = parts.length;
      var data = obj;
      while (index2 < len - 1) {
        var part = parts[index2];
        if (part === "__proto__" || part === "constructor" || part === "prototype") {
          return obj;
        }
        data = data[parts[index2++]];
      }
      data[parts[index2]] = value;
    });
  },
  getter: function(path2, safe) {
    var parts = normalizePath(path2);
    return getCache.get(path2) || getCache.set(path2, function getter(data) {
      var index2 = 0, len = parts.length;
      while (index2 < len) {
        if (data != null || !safe)
          data = data[parts[index2++]];
        else
          return;
      }
      return data;
    });
  },
  join: function(segments) {
    return segments.reduce(function(path2, part) {
      return path2 + (isQuoted(part) || DIGIT_REGEX.test(part) ? "[" + part + "]" : (path2 ? "." : "") + part);
    }, "");
  },
  forEach: function(path2, cb, thisArg) {
    forEach7(Array.isArray(path2) ? path2 : split(path2), cb, thisArg);
  }
};
function normalizePath(path2) {
  return pathCache.get(path2) || pathCache.set(
    path2,
    split(path2).map(function(part) {
      return part.replace(CLEAN_QUOTES_REGEX, "$2");
    })
  );
}
function split(path2) {
  return path2.match(SPLIT_REGEX) || [""];
}
function forEach7(parts, iter, thisArg) {
  var len = parts.length, part, idx, isArray2, isBracket;
  for (idx = 0; idx < len; idx++) {
    part = parts[idx];
    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }
      isBracket = isQuoted(part);
      isArray2 = !isBracket && /^\d+$/.test(part);
      iter.call(thisArg, part, isBracket, isArray2, idx, parts);
    }
  }
}
function isQuoted(str) {
  return typeof str === "string" && str && ["'", '"'].indexOf(str.charAt(0)) !== -1;
}
function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX);
}
function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part);
}
function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part));
}
const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const words = (str) => str.match(reWords) || [];
const upperFirst = (str) => str[0].toUpperCase() + str.slice(1);
const join = (str, d3) => words(str).join(d3).toLowerCase();
const camelCase = (str) => words(str).reduce(
  (acc, next2) => `${acc}${!acc ? next2.toLowerCase() : next2[0].toUpperCase() + next2.slice(1).toLowerCase()}`,
  ""
);
const pascalCase = (str) => upperFirst(camelCase(str));
const snakeCase = (str) => join(str, "_");
const kebabCase = (str) => join(str, "-");
const sentenceCase = (str) => upperFirst(join(str, " "));
const titleCase = (str) => words(str).map(upperFirst).join(" ");
var tinyCase = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase
};
var toposort$2 = { exports: {} };
toposort$2.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges);
};
toposort$2.exports.array = toposort;
function toposort(nodes, edges) {
  var cursor2 = nodes.length, sorted = new Array(cursor2), visited = {}, i2 = cursor2, outgoingEdges = makeOutgoingEdges(edges), nodesHash = makeNodesHash(nodes);
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }
  });
  while (i2--) {
    if (!visited[i2])
      visit(nodes[i2], i2, /* @__PURE__ */ new Set());
  }
  return sorted;
  function visit(node2, i3, predecessors) {
    if (predecessors.has(node2)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node2);
      } catch (e3) {
        nodeRep = "";
      }
      throw new Error("Cyclic dependency" + nodeRep);
    }
    if (!nodesHash.has(node2)) {
      throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(node2));
    }
    if (visited[i3])
      return;
    visited[i3] = true;
    var outgoing = outgoingEdges.get(node2) || /* @__PURE__ */ new Set();
    outgoing = Array.from(outgoing);
    if (i3 = outgoing.length) {
      predecessors.add(node2);
      do {
        var child = outgoing[--i3];
        visit(child, nodesHash.get(child), predecessors);
      } while (i3);
      predecessors.delete(node2);
    }
    sorted[--cursor2] = node2;
  }
}
function uniqueNodes(arr) {
  var res = /* @__PURE__ */ new Set();
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    var edge = arr[i2];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res);
}
function makeOutgoingEdges(arr) {
  var edges = /* @__PURE__ */ new Map();
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    var edge = arr[i2];
    if (!edges.has(edge[0]))
      edges.set(edge[0], /* @__PURE__ */ new Set());
    if (!edges.has(edge[1]))
      edges.set(edge[1], /* @__PURE__ */ new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges;
}
function makeNodesHash(arr) {
  var res = /* @__PURE__ */ new Map();
  for (var i2 = 0, len = arr.length; i2 < len; i2++) {
    res.set(arr[i2], i2);
  }
  return res;
}
var toposortExports = toposort$2.exports;
const toposort$1 = /* @__PURE__ */ getDefaultExportFromCjs(toposortExports);
const toString2 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== "undefined" ? Symbol.prototype.toString : () => "";
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val)
    return "NaN";
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? "-0" : "" + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false)
    return "" + val;
  const typeOf = typeof val;
  if (typeOf === "number")
    return printNumber(val);
  if (typeOf === "string")
    return quoteStrings ? `"${val}"` : val;
  if (typeOf === "function")
    return "[Function " + (val.name || "anonymous") + "]";
  if (typeOf === "symbol")
    return symbolToString.call(val).replace(SYMBOL_REGEXP, "Symbol($1)");
  const tag2 = toString2.call(val).slice(8, -1);
  if (tag2 === "Date")
    return isNaN(val.getTime()) ? "" + val : val.toISOString(val);
  if (tag2 === "Error" || val instanceof Error)
    return "[" + errorToString.call(val) + "]";
  if (tag2 === "RegExp")
    return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null)
    return result;
  return JSON.stringify(value, function(key, value2) {
    let result2 = printSimpleValue(this[key], quoteStrings);
    if (result2 !== null)
      return result2;
    return value2;
  }, 2);
}
function toArray(value) {
  return value == null ? [] : [].concat(value);
}
let _Symbol$toStringTag, _Symbol$hasInstance, _Symbol$toStringTag2;
let strReg = /\$\{\s*(\w+)\s*\}/g;
_Symbol$toStringTag = Symbol.toStringTag;
class ValidationErrorNoStack {
  constructor(errorOrErrors, value, field, type2) {
    this.name = void 0;
    this.message = void 0;
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = void 0;
    this.inner = void 0;
    this[_Symbol$toStringTag] = "Error";
    this.name = "ValidationError";
    this.value = value;
    this.path = field;
    this.type = type2;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach((err) => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        const innerErrors = err.inner.length ? err.inner : [err];
        this.inner.push(...innerErrors);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
  }
}
_Symbol$hasInstance = Symbol.hasInstance;
_Symbol$toStringTag2 = Symbol.toStringTag;
class ValidationError extends Error {
  static formatError(message, params) {
    const path2 = params.label || params.path || "this";
    if (path2 !== params.path)
      params = Object.assign({}, params, {
        path: path2
      });
    if (typeof message === "string")
      return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === "function")
      return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === "ValidationError";
  }
  constructor(errorOrErrors, value, field, type2, disableStack) {
    const errorNoStack = new ValidationErrorNoStack(errorOrErrors, value, field, type2);
    if (disableStack) {
      return errorNoStack;
    }
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.params = void 0;
    this.errors = [];
    this.inner = [];
    this[_Symbol$toStringTag2] = "Error";
    this.name = errorNoStack.name;
    this.message = errorNoStack.message;
    this.type = errorNoStack.type;
    this.value = errorNoStack.value;
    this.path = errorNoStack.path;
    this.errors = errorNoStack.errors;
    this.inner = errorNoStack.inner;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ValidationError);
    }
  }
  static [_Symbol$hasInstance](inst) {
    return ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
  }
}
let mixed = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  defined: "${path} must be defined",
  notNull: "${path} cannot be null",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: path2,
    type: type2,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : ".";
    return type2 !== "mixed" ? `${path2} must be a \`${type2}\` type, but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path2} must match the configured type. The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  datetime: "${path} must be a valid ISO date-time",
  datetime_precision: "${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits",
  datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
};
let number = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
};
let date = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
};
let boolean = {
  isValue: "${path} field must be ${value}"
};
let object = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
};
let array = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
let tuple = {
  notType: (params) => {
    const {
      path: path2,
      value,
      spec
    } = params;
    const typeLen = spec.types.length;
    if (Array.isArray(value)) {
      if (value.length < typeLen)
        return `${path2} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
      if (value.length > typeLen)
        return `${path2} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${printValue(value, true)}\``;
    }
    return ValidationError.formatError(mixed.notType, params);
  }
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean,
  tuple
});
const isSchema = (obj) => obj && obj.__isYupSchema__;
class Condition {
  static fromOptions(refs, config2) {
    if (!config2.then && !config2.otherwise)
      throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: is3,
      then,
      otherwise
    } = config2;
    let check = typeof is3 === "function" ? is3 : (...values6) => values6.every((value) => value === is3);
    return new Condition(refs, (values6, schema) => {
      var _branch;
      let branch = check(...values6) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base2, options2) {
    let values6 = this.refs.map((ref2) => (
      // TODO: ? operator here?
      ref2.getValue(options2 == null ? void 0 : options2.value, options2 == null ? void 0 : options2.parent, options2 == null ? void 0 : options2.context)
    ));
    let schema = this.fn(values6, base2, options2);
    if (schema === void 0 || // @ts-ignore this can be base
    schema === base2) {
      return base2;
    }
    if (!isSchema(schema))
      throw new TypeError("conditions must return a schema object");
    return schema.resolve(options2);
  }
}
const prefixes = {
  context: "$",
  value: "."
};
class Reference {
  constructor(key, options2 = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== "string")
      throw new TypeError("ref must be a string, got: " + key);
    this.key = key.trim();
    if (key === "")
      throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix2 = this.isContext ? prefixes.context : this.isValue ? prefixes.value : "";
    this.path = this.key.slice(prefix2.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options2.map;
  }
  getValue(value, parent2, context) {
    let result = this.isContext ? context : this.isValue ? value : parent2;
    if (this.getter)
      result = this.getter(result || {});
    if (this.map)
      result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options2) {
    return this.getValue(value, options2 == null ? void 0 : options2.parent, options2 == null ? void 0 : options2.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}
Reference.prototype.__isYupRef = true;
const isAbsent = (value) => value == null;
function createValidation(config2) {
  function validate({
    value,
    path: path2 = "",
    options: options2,
    originalValue,
    schema
  }, panic, next2) {
    const {
      name: name2,
      test: test2,
      params,
      message,
      skipAbsent
    } = config2;
    let {
      parent: parent2,
      context,
      abortEarly = schema.spec.abortEarly,
      disableStackTrace = schema.spec.disableStackTrace
    } = options2;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent2, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path2,
        spec: schema.spec,
        disableStackTrace: overrides.disableStackTrace || disableStackTrace
      }, params, overrides.params);
      for (const key of Object.keys(nextParams))
        nextParams[key] = resolve(nextParams[key]);
      const error2 = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name2, nextParams.disableStackTrace);
      error2.params = nextParams;
      return error2;
    }
    const invalid = abortEarly ? panic : next2;
    let ctx2 = {
      path: path2,
      parent: parent2,
      type: name2,
      from: options2.from,
      createError,
      resolve,
      options: options2,
      originalValue,
      schema
    };
    const handleResult = (validOrError) => {
      if (ValidationError.isError(validOrError))
        invalid(validOrError);
      else if (!validOrError)
        invalid(createError());
      else
        next2(null);
    };
    const handleError = (err) => {
      if (ValidationError.isError(err))
        invalid(err);
      else
        panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (shouldSkip) {
      return handleResult(true);
    }
    let result;
    try {
      var _result;
      result = test2.call(ctx2, value, ctx2);
      if (typeof ((_result = result) == null ? void 0 : _result.then) === "function") {
        if (options2.sync) {
          throw new Error(`Validation test of type: "${ctx2.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
        }
        return Promise.resolve(result).then(handleResult, handleError);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config2;
  return validate;
}
function getIn(schema, path2, value, context = value) {
  let parent2, lastPart, lastPartDebug;
  if (!path2)
    return {
      parent: parent2,
      parentPath: path2,
      schema
    };
  propertyExpr.forEach(path2, (_part, isBracket, isArray2) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent: parent2,
      value
    });
    let isTuple = schema.type === "tuple";
    let idx = isArray2 ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray2)
        throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path2}. because there is no value at that index. `);
      }
      parent2 = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }
    if (!isArray2) {
      if (!schema.fields || !schema.fields[part])
        throw new Error(`The schema does not contain the path: ${path2}. (failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent2 = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? "[" + _part + "]" : "." + _part;
  });
  return {
    schema,
    parent: parent2,
    parentPath: lastPart
  };
}
class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next2 = this.clone();
    newItems.forEach((value) => next2.add(value));
    removeItems.forEach((value) => next2.delete(value));
    return next2;
  }
}
function clone(src, seen = /* @__PURE__ */ new Map()) {
  if (isSchema(src) || !src || typeof src !== "object")
    return src;
  if (seen.has(src))
    return seen.get(src);
  let copy2;
  if (src instanceof Date) {
    copy2 = new Date(src.getTime());
    seen.set(src, copy2);
  } else if (src instanceof RegExp) {
    copy2 = new RegExp(src);
    seen.set(src, copy2);
  } else if (Array.isArray(src)) {
    copy2 = new Array(src.length);
    seen.set(src, copy2);
    for (let i2 = 0; i2 < src.length; i2++)
      copy2[i2] = clone(src[i2], seen);
  } else if (src instanceof Map) {
    copy2 = /* @__PURE__ */ new Map();
    seen.set(src, copy2);
    for (const [k3, v] of src.entries())
      copy2.set(k3, clone(v, seen));
  } else if (src instanceof Set) {
    copy2 = /* @__PURE__ */ new Set();
    seen.set(src, copy2);
    for (const v of src)
      copy2.add(clone(v, seen));
  } else if (src instanceof Object) {
    copy2 = {};
    seen.set(src, copy2);
    for (const [k3, v] of Object.entries(src))
      copy2[k3] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy2;
}
class Schema {
  constructor(options2) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = /* @__PURE__ */ Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options2.type;
    this._typeCheck = options2.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      disableStackTrace: false,
      nullable: false,
      optional: true,
      coerce: true
    }, options2 == null ? void 0 : options2.spec);
    this.withMutation((s4) => {
      s4.nonNullable();
    });
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec)
        Object.assign(this.spec, spec);
      return this;
    }
    const next2 = Object.create(Object.getPrototypeOf(this));
    next2.type = this.type;
    next2._typeCheck = this._typeCheck;
    next2._whitelist = this._whitelist.clone();
    next2._blacklist = this._blacklist.clone();
    next2.internalTests = Object.assign({}, this.internalTests);
    next2.exclusiveTests = Object.assign({}, this.exclusiveTests);
    next2.deps = [...this.deps];
    next2.conditions = [...this.conditions];
    next2.tests = [...this.tests];
    next2.transforms = [...this.transforms];
    next2.spec = clone(Object.assign({}, this.spec, spec));
    return next2;
  }
  label(label2) {
    let next2 = this.clone();
    next2.spec.label = label2;
    return next2;
  }
  meta(...args) {
    if (args.length === 0)
      return this.spec.meta;
    let next2 = this.clone();
    next2.spec.meta = Object.assign(next2.spec.meta || {}, args[0]);
    return next2;
  }
  withMutation(fn2) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn2(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this)
      return this;
    if (schema.type !== this.type && this.type !== "mixed")
      throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base2 = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base2.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base2.internalTests, combined.internalTests);
    combined._whitelist = base2._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base2._blacklist.merge(schema._blacklist, schema._whitelist);
    combined.tests = base2.tests;
    combined.exclusiveTests = base2.exclusiveTests;
    combined.withMutation((next2) => {
      schema.tests.forEach((fn2) => {
        next2.test(fn2.OPTIONS);
      });
    });
    combined.transforms = [...base2.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null)
        return true;
      if (this.spec.optional && v === void 0)
        return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options2) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options2), schema);
      schema = schema.resolve(options2);
    }
    return schema;
  }
  resolveOptions(options2) {
    var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
    return Object.assign({}, options2, {
      from: options2.from || [],
      strict: (_options$strict = options2.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options2.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options2.recursive) != null ? _options$recursive : this.spec.recursive,
      disableStackTrace: (_options$disableStack = options2.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
    });
  }
  /**
   * Run the configured transform pipeline over an input value.
   */
  cast(value, options2 = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options2));
    let allowOptionality = options2.assert === "ignore-optionality";
    let result = resolvedSchema._cast(value, options2);
    if (options2.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options2.path || "field"} could not be cast to a value that satisfies the schema type: "${resolvedSchema.type}". 

attempted value: ${formattedValue} 
` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ""));
    }
    return result;
  }
  _cast(rawValue, options2) {
    let value = rawValue === void 0 ? rawValue : this.transforms.reduce((prevValue, fn2) => fn2.call(this, prevValue, rawValue, this), rawValue);
    if (value === void 0) {
      value = this.getDefault(options2);
    }
    return value;
  }
  _validate(_value, options2 = {}, panic, next2) {
    let {
      path: path2,
      originalValue = _value,
      strict = this.spec.strict
    } = options2;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options2));
    }
    let initialTests = [];
    for (let test2 of Object.values(this.internalTests)) {
      if (test2)
        initialTests.push(test2);
    }
    this.runTests({
      path: path2,
      value,
      originalValue,
      options: options2,
      tests: initialTests
    }, panic, (initialErrors) => {
      if (initialErrors.length) {
        return next2(initialErrors, value);
      }
      this.runTests({
        path: path2,
        value,
        originalValue,
        options: options2,
        tests: this.tests
      }, panic, next2);
    });
  }
  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next2) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path: path2,
      options: options2
    } = runOptions;
    let panicOnce = (arg) => {
      if (fired)
        return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = (arg) => {
      if (fired)
        return;
      fired = true;
      next2(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count)
      return nextOnce([]);
    let args = {
      value,
      originalValue,
      path: path2,
      options: options2,
      schema: this
    };
    for (let i2 = 0; i2 < tests.length; i2++) {
      const test2 = tests[i2];
      test2(args, panicOnce, function finishTestRun(err) {
        if (err) {
          Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index: index2,
    parent: parent2,
    parentPath,
    originalParent,
    options: options2
  }) {
    const k3 = key != null ? key : index2;
    if (k3 == null) {
      throw TypeError("Must include `key` or `index` for nested validations");
    }
    const isIndex2 = typeof k3 === "number";
    let value = parent2[k3];
    const testOptions = Object.assign({}, options2, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent: parent2,
      value,
      originalValue: originalParent[k3],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: void 0,
      // index: undefined,
      [isIndex2 ? "index" : "key"]: k3,
      path: isIndex2 || k3.includes(".") ? `${parentPath || ""}[${isIndex2 ? k3 : `"${k3}"`}]` : (parentPath ? `${parentPath}.` : "") + key
    });
    return (_, panic, next2) => this.resolve(testOptions)._validate(value, testOptions, panic, next2);
  }
  validate(value, options2) {
    var _options$disableStack2;
    let schema = this.resolve(Object.assign({}, options2, {
      value
    }));
    let disableStackTrace = (_options$disableStack2 = options2 == null ? void 0 : options2.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
    return new Promise((resolve, reject) => schema._validate(value, options2, (error2, parsed) => {
      if (ValidationError.isError(error2))
        error2.value = parsed;
      reject(error2);
    }, (errors, validated) => {
      if (errors.length)
        reject(new ValidationError(errors, validated, void 0, void 0, disableStackTrace));
      else
        resolve(validated);
    }));
  }
  validateSync(value, options2) {
    var _options$disableStack3;
    let schema = this.resolve(Object.assign({}, options2, {
      value
    }));
    let result;
    let disableStackTrace = (_options$disableStack3 = options2 == null ? void 0 : options2.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
    schema._validate(value, Object.assign({}, options2, {
      sync: true
    }), (error2, parsed) => {
      if (ValidationError.isError(error2))
        error2.value = parsed;
      throw error2;
    }, (errors, validated) => {
      if (errors.length)
        throw new ValidationError(errors, value, void 0, void 0, disableStackTrace);
      result = validated;
    });
    return result;
  }
  isValid(value, options2) {
    return this.validate(value, options2).then(() => true, (err) => {
      if (ValidationError.isError(err))
        return false;
      throw err;
    });
  }
  isValidSync(value, options2) {
    try {
      this.validateSync(value, options2);
      return true;
    } catch (err) {
      if (ValidationError.isError(err))
        return false;
      throw err;
    }
  }
  _getDefault(options2) {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === "function" ? defaultValue.call(this, options2) : clone(defaultValue);
  }
  getDefault(options2) {
    let schema = this.resolve(options2 || {});
    return schema._getDefault(options2);
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next2 = this.clone({
      default: def
    });
    return next2;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next2 = this.clone({
      nullable
    });
    next2.internalTests.nullable = createValidation({
      message,
      name: "nullable",
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next2;
  }
  optionality(optional, message) {
    const next2 = this.clone({
      optional
    });
    next2.internalTests.optionality = createValidation({
      message,
      name: "optionality",
      test(value) {
        return value === void 0 ? this.schema.spec.optional : true;
      }
    });
    return next2;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation((next2) => next2.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation((next2) => next2.nullable().optional());
  }
  transform(fn2) {
    let next2 = this.clone();
    next2.transforms.push(fn2);
    return next2;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === "function") {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === void 0)
      opts.message = mixed.default;
    if (typeof opts.test !== "function")
      throw new TypeError("`test` is a required parameters");
    let next2 = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next2.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name)
        throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    }
    if (opts.name)
      next2.exclusiveTests[opts.name] = !!opts.exclusive;
    next2.tests = next2.tests.filter((fn2) => {
      if (fn2.OPTIONS.name === opts.name) {
        if (isExclusive)
          return false;
        if (fn2.OPTIONS.test === validate.OPTIONS.test)
          return false;
      }
      return true;
    });
    next2.tests.push(validate);
    return next2;
  }
  when(keys8, options2) {
    if (!Array.isArray(keys8) && typeof keys8 !== "string") {
      options2 = keys8;
      keys8 = ".";
    }
    let next2 = this.clone();
    let deps = toArray(keys8).map((key) => new Reference(key));
    deps.forEach((dep) => {
      if (dep.isSibling)
        next2.deps.push(dep.key);
    });
    next2.conditions.push(typeof options2 === "function" ? new Condition(deps, options2) : Condition.fromOptions(deps, options2));
    return next2;
  }
  typeError(message) {
    let next2 = this.clone();
    next2.internalTests.typeError = createValidation({
      message,
      name: "typeError",
      skipAbsent: true,
      test(value) {
        if (!this.schema._typeCheck(value))
          return this.createError({
            params: {
              type: this.schema.type
            }
          });
        return true;
      }
    });
    return next2;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next2 = this.clone();
    enums.forEach((val) => {
      next2._whitelist.add(val);
      next2._blacklist.delete(val);
    });
    next2.internalTests.whiteList = createValidation({
      message,
      name: "oneOf",
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(", "),
            resolved
          }
        });
      }
    });
    return next2;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next2 = this.clone();
    enums.forEach((val) => {
      next2._blacklist.add(val);
      next2._whitelist.delete(val);
    });
    next2.internalTests.blacklist = createValidation({
      message,
      name: "notOneOf",
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value))
          return this.createError({
            params: {
              values: Array.from(invalids).join(", "),
              resolved
            }
          });
        return true;
      }
    });
    return next2;
  }
  strip(strip = true) {
    let next2 = this.clone();
    next2.spec.strip = strip;
    return next2;
  }
  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options2) {
    const next2 = (options2 ? this.resolve(options2) : this).clone();
    const {
      label: label2,
      meta,
      optional,
      nullable
    } = next2.spec;
    const description = {
      meta,
      label: label2,
      optional,
      nullable,
      default: next2.getDefault(options2),
      type: next2.type,
      oneOf: next2._whitelist.describe(),
      notOneOf: next2._blacklist.describe(),
      tests: next2.tests.map((fn2) => ({
        name: fn2.OPTIONS.name,
        params: fn2.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex((c7) => c7.name === n.name) === idx)
    };
    return description;
  }
}
Schema.prototype.__isYupSchema__ = true;
for (const method of ["validate", "validateSync"])
  Schema.prototype[`${method}At`] = function(path2, value, options2 = {}) {
    const {
      parent: parent2,
      parentPath,
      schema
    } = getIn(this, path2, value, options2.context);
    return schema[method](parent2 && parent2[parentPath], Object.assign({}, options2, {
      parent: parent2,
      path: path2
    }));
  };
for (const alias2 of ["equals", "is"])
  Schema.prototype[alias2] = Schema.prototype.oneOf;
for (const alias2 of ["not", "nope"])
  Schema.prototype[alias2] = Schema.prototype.notOneOf;
const isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date2) {
  const struct = parseDateStruct(date2);
  if (!struct)
    return Date.parse ? Date.parse(date2) : Number.NaN;
  if (struct.z === void 0 && struct.plusMinus === void 0) {
    return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
  }
  let totalMinutesOffset = 0;
  if (struct.z !== "Z" && struct.plusMinus !== void 0) {
    totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
    if (struct.plusMinus === "+")
      totalMinutesOffset = 0 - totalMinutesOffset;
  }
  return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function parseDateStruct(date2) {
  var _regexResult$7$length, _regexResult$;
  const regexResult = isoReg.exec(date2);
  if (!regexResult)
    return null;
  return {
    year: toNumber(regexResult[1]),
    month: toNumber(regexResult[2], 1) - 1,
    day: toNumber(regexResult[3], 1),
    hour: toNumber(regexResult[4]),
    minute: toNumber(regexResult[5]),
    second: toNumber(regexResult[6]),
    millisecond: regexResult[7] ? (
      // allow arbitrary sub-second precision beyond milliseconds
      toNumber(regexResult[7].substring(0, 3))
    ) : 0,
    precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : void 0,
    z: regexResult[8] || void 0,
    plusMinus: regexResult[9] || void 0,
    hourOffset: toNumber(regexResult[10]),
    minuteOffset: toNumber(regexResult[11])
  };
}
function toNumber(str, defaultValue = 0) {
  return Number(str) || defaultValue;
}
let rEmail = (
  // eslint-disable-next-line
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
);
let rUrl = (
  // eslint-disable-next-line
  /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
);
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let yearMonthDay = "^\\d{4}-\\d{2}-\\d{2}";
let hourMinuteSecond = "\\d{2}:\\d{2}:\\d{2}";
let zOrOffset = "(([+-]\\d{2}(:?\\d{2})?)|Z)";
let rIsoDateTime = new RegExp(`${yearMonthDay}T${hourMinuteSecond}(\\.\\d+)?${zOrOffset}$`);
let isTrimmed = (value) => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: "string",
      check(value) {
        if (value instanceof String)
          value = value.valueOf();
        return typeof value === "string";
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx2) => {
        if (!ctx2.spec.coerce || ctx2.isType(value))
          return value;
        if (Array.isArray(value))
          return value;
        const strValue2 = value != null && value.toString ? value.toString() : value;
        if (strValue2 === objStringTag)
          return value;
        return strValue2;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation((schema) => schema.test({
      message: message || mixed.required,
      name: "required",
      skipAbsent: true,
      test: (value) => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation((schema) => {
      schema.tests = schema.tests.filter((t2) => t2.OPTIONS.name !== "required");
      return schema;
    });
  }
  length(length2, message = string.length) {
    return this.test({
      message,
      name: "length",
      exclusive: true,
      params: {
        length: length2
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length2);
      }
    });
  }
  min(min2, message = string.min) {
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min2);
      }
    });
  }
  max(max2, message = string.max) {
    return this.test({
      name: "max",
      exclusive: true,
      message,
      params: {
        max: max2
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max2);
      }
    });
  }
  matches(regex2, options2) {
    let excludeEmptyString = false;
    let message;
    let name2;
    if (options2) {
      if (typeof options2 === "object") {
        ({
          excludeEmptyString = false,
          message,
          name: name2
        } = options2);
      } else {
        message = options2;
      }
    }
    return this.test({
      name: name2 || "matches",
      message: message || string.matches,
      params: {
        regex: regex2
      },
      skipAbsent: true,
      test: (value) => value === "" && excludeEmptyString || value.search(regex2) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: "email",
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: "url",
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: "uuid",
      message,
      excludeEmptyString: false
    });
  }
  datetime(options2) {
    let message = "";
    let allowOffset;
    let precision;
    if (options2) {
      if (typeof options2 === "object") {
        ({
          message = "",
          allowOffset = false,
          precision = void 0
        } = options2);
      } else {
        message = options2;
      }
    }
    return this.matches(rIsoDateTime, {
      name: "datetime",
      message: message || string.datetime,
      excludeEmptyString: true
    }).test({
      name: "datetime_offset",
      message: message || string.datetime_offset,
      params: {
        allowOffset
      },
      skipAbsent: true,
      test: (value) => {
        if (!value || allowOffset)
          return true;
        const struct = parseDateStruct(value);
        if (!struct)
          return false;
        return !!struct.z;
      }
    }).test({
      name: "datetime_precision",
      message: message || string.datetime_precision,
      params: {
        precision
      },
      skipAbsent: true,
      test: (value) => {
        if (!value || precision == void 0)
          return true;
        const struct = parseDateStruct(value);
        if (!struct)
          return false;
        return struct.precision === precision;
      }
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((val) => val === null ? "" : val);
  }
  trim(message = string.trim) {
    return this.transform((val) => val != null ? val.trim() : val).test({
      message,
      name: "trim",
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform((value) => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      skipAbsent: true,
      test: (value) => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform((value) => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: "string_case",
      exclusive: true,
      skipAbsent: true,
      test: (value) => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;
let invalidDate = /* @__PURE__ */ new Date("");
let isDate = (obj) => Object.prototype.toString.call(obj) === "[object Date]";
class DateSchema extends Schema {
  constructor() {
    super({
      type: "date",
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx2) => {
        if (!ctx2.spec.coerce || ctx2.isType(value) || value === null)
          return value;
        value = parseIsoDate(value);
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref2, name2) {
    let param;
    if (!Reference.isRef(ref2)) {
      let cast = this.cast(ref2);
      if (!this._typeCheck(cast))
        throw new TypeError(`\`${name2}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref2;
    }
    return param;
  }
  min(min2, message = date.min) {
    let limit = this.prepareParam(min2, "min");
    return this.test({
      message,
      name: "min",
      exclusive: true,
      params: {
        min: min2
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max2, message = date.max) {
    let limit = this.prepareParam(max2, "max");
    return this.test({
      message,
      name: "max",
      exclusive: true,
      params: {
        max: max2
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
DateSchema.prototype;
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = /* @__PURE__ */ new Set();
  let excludes = new Set(excludedEdges.map(([a4, b10]) => `${a4}-${b10}`));
  function addNode(depPath, key) {
    let node2 = propertyExpr.split(depPath)[0];
    nodes.add(node2);
    if (!excludes.has(`${key}-${node2}`))
      edges.push([key, node2]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling)
      addNode(value.path, key);
    else if (isSchema(value) && "deps" in value)
      value.deps.forEach((path2) => addNode(path2, key));
  }
  return toposort$1.array(Array.from(nodes), edges).reverse();
}
function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys8) {
  return (a4, b10) => {
    return findIndex(keys8, a4) - findIndex(keys8, b10);
  };
}
const parseJson = (value, _, ctx2) => {
  if (typeof value !== "string") {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
  }
  return ctx2.isType(parsed) ? parsed : value;
};
function deepPartial(schema) {
  if ("fields" in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === "array") {
    const nextArray = schema.optional();
    if (nextArray.innerType)
      nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === "tuple") {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ("optional" in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path2 = [...propertyExpr.normalizePath(p)];
  if (path2.length === 1)
    return path2[0] in obj;
  let last2 = path2.pop();
  let parent2 = propertyExpr.getter(propertyExpr.join(path2), true)(obj);
  return !!(parent2 && last2 in parent2);
};
let isObject2 = (obj) => Object.prototype.toString.call(obj) === "[object Object]";
function unknown(ctx2, value) {
  let known = Object.keys(ctx2.fields);
  return Object.keys(value).filter((key) => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: "object",
      check(value) {
        return isObject2(value) || typeof value === "function";
      }
    });
    this.fields = /* @__PURE__ */ Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options2 = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options2);
    if (value === void 0)
      return this.getDefault(options2);
    if (!this._typeCheck(value))
      return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options2.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props2 = [].concat(this._nodes, Object.keys(value).filter((v) => !this._nodes.includes(v)));
    let intermediateValue = {};
    let innerOptions = Object.assign({}, options2, {
      parent: intermediateValue,
      __validating: options2.__validating || false
    });
    let isChanged = false;
    for (const prop of props2) {
      let field = fields[prop];
      let exists2 = prop in value;
      if (field) {
        let fieldValue;
        let inputValue = value[prop];
        innerOptions.path = (options2.path ? `${options2.path}.` : "") + prop;
        field = field.resolve({
          value: inputValue,
          context: options2.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : void 0;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options2.__validating || !strict ? (
          // TODO: use _cast, this is double resolving
          field.cast(value[prop], innerOptions)
        ) : value[prop];
        if (fieldValue !== void 0) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists2 && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists2 !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options2 = {}, panic, next2) {
    let {
      from: from2 = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options2;
    options2.from = [{
      schema: this,
      value: originalValue
    }, ...from2];
    options2.__validating = true;
    options2.originalValue = originalValue;
    super._validate(_value, options2, panic, (objectErrors, value) => {
      if (!recursive || !isObject2(value)) {
        next2(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options: options2,
          key,
          parent: value,
          parentPath: options2.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options: options2
      }, panic, (fieldErrors) => {
        next2(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next2 = super.clone(spec);
    next2.fields = Object.assign({}, this.fields);
    next2._nodes = this._nodes;
    next2._excludedEdges = this._excludedEdges;
    next2._sortErrors = this._sortErrors;
    return next2;
  }
  concat(schema) {
    let next2 = super.concat(schema);
    let nextFields = next2.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === void 0 ? schemaOrRef : target;
    }
    return next2.withMutation((s4) => (
      // XXX: excludes here is wrong
      s4.setFields(nextFields, [...this._excludedEdges, ...schema._excludedEdges])
    ));
  }
  _getDefault(options2) {
    if ("default" in this.spec) {
      return super._getDefault(options2);
    }
    if (!this._nodes.length) {
      return void 0;
    }
    let dft = {};
    this._nodes.forEach((key) => {
      var _innerOptions;
      const field = this.fields[key];
      let innerOptions = options2;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      dft[key] = field && "getDefault" in field ? field.getDefault(innerOptions) : void 0;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next2 = this.clone();
    next2.fields = shape;
    next2._nodes = sortFields(shape, excludedEdges);
    next2._sortErrors = sortByKeyOrder(Object.keys(shape));
    if (excludedEdges)
      next2._excludedEdges = excludedEdges;
    return next2;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation((next2) => {
      let edges = next2._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0]))
          excludes = [excludes];
        edges = [...next2._excludedEdges, ...excludes];
      }
      return next2.setFields(Object.assign(next2.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = "optional" in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next2 = deepPartial(this);
    return next2;
  }
  pick(keys8) {
    const picked = {};
    for (const key of keys8) {
      if (this.fields[key])
        picked[key] = this.fields[key];
    }
    return this.setFields(picked, this._excludedEdges.filter(([a4, b10]) => keys8.includes(a4) && keys8.includes(b10)));
  }
  omit(keys8) {
    const remaining = [];
    for (const key of Object.keys(this.fields)) {
      if (keys8.includes(key))
        continue;
      remaining.push(key);
    }
    return this.pick(remaining);
  }
  from(from2, to2, alias2) {
    let fromGetter = propertyExpr.getter(from2, true);
    return this.transform((obj) => {
      if (!obj)
        return obj;
      let newObj = obj;
      if (deepHas(obj, from2)) {
        newObj = Object.assign({}, obj);
        if (!alias2)
          delete newObj[from2];
        newObj[to2] = fromGetter(obj);
      }
      return newObj;
    });
  }
  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== "boolean") {
      message = noAllow;
      noAllow = true;
    }
    let next2 = this.test({
      name: "noUnknown",
      exclusive: true,
      message,
      test(value) {
        if (value == null)
          return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(", ")
          }
        });
      }
    });
    next2.spec.noUnknown = noAllow;
    return next2;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn2) {
    return this.transform((obj) => {
      if (!obj)
        return obj;
      const result = {};
      for (const key of Object.keys(obj))
        result[fn2(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCase.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCase.snakeCase);
  }
  constantCase() {
    return this.transformKeys((key) => tinyCase.snakeCase(key).toUpperCase());
  }
  describe(options2) {
    const next2 = (options2 ? this.resolve(options2) : this).clone();
    const base2 = super.describe(options2);
    base2.fields = {};
    for (const [key, value] of Object.entries(next2.fields)) {
      var _innerOptions2;
      let innerOptions = options2;
      if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base2.fields[key] = value.describe(innerOptions);
    }
    return base2;
  }
}
create$3.prototype = ObjectSchema.prototype;
const ModalForm = ({
  children: children2 = null,
  isOpen,
  onDismiss,
  options: options2,
  submitText,
  title
}) => {
  const guiForm = useGuiForm();
  useEffect(() => {
    if (isOpen) {
      guiForm == null ? void 0 : guiForm.resetForm();
    }
  }, [isOpen]);
  const groupSx = {
    paddingBottom: "switcherModal.outlinePadding"
  };
  if (!children2) {
    groupSx.paddingTop = "switcherModal.outlinePadding";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Modal,
    {
      footerActions: /* @__PURE__ */ jsxRuntimeExports.jsx(
        CompoundButton,
        {
          "data-test-id": "modal-footer-primary-action",
          onClick: guiForm == null ? void 0 : guiForm.submitForm,
          children: submitText
        }
      ),
      isOpen,
      onDismiss,
      title,
      children: [
        children2,
        /* @__PURE__ */ jsxRuntimeExports.jsx(GuiBaseForm, { name: "switcher-modal-form", children: /* @__PURE__ */ jsxRuntimeExports.jsx(SuperRadio.Group, { name: "switcherModalValue", sx: groupSx, children: options2.map((option) => /* @__PURE__ */ jsxRuntimeExports.jsx(SuperRadio, { ...option })) }) })
      ]
    }
  );
};
const validationSchema = create$3({}).shape({
  switcherModalValue: create$6().required("Required")
});
const SwitcherModal = ({
  children: children2 = null,
  controlText,
  currentValue = void 0,
  onSwitch,
  options: options2,
  submitText,
  title
}) => {
  const [isSwitcherOpen, setIsSwitcherOpen] = useState(false);
  const toggleSwitcher = useCallback(() => {
    setIsSwitcherOpen((prev2) => !prev2);
  }, [setIsSwitcherOpen]);
  const onSubmit = useCallback(
    (data) => {
      toggleSwitcher();
      onSwitch(data.switcherModalValue);
    },
    [onSwitch, toggleSwitcher]
  );
  const initialValues = {
    switcherModalValue: currentValue || ""
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      CompoundButton,
      {
        "data-test-id": "switcher-modal-button",
        onClick: toggleSwitcher,
        variant: LinkVariant.default,
        children: controlText
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      GuiFormProvider,
      {
        initialValues,
        onSubmit,
        validationSchema,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ModalForm,
          {
            isOpen: isSwitcherOpen,
            onDismiss: toggleSwitcher,
            options: options2,
            submitText,
            title,
            children: children2
          }
        )
      }
    )
  ] });
};
const Transaction = ({
  afterElement = void 0,
  contentElement = void 0,
  hasControlElement = false,
  label: label2 = void 0,
  subtitle = void 0,
  labelColor = "transactionsHistory.breakdownSubItem.label",
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Flex,
    {
      flexDirection: "column",
      justifyContent: "flex-start",
      sx: {
        borderBottom: "default",
        borderColor: "border.subdued",
        paddingY: "transactionsHistory.transaction.container.paddingY"
      },
      ...restOfProps,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
          label2 || subtitle ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Flex,
            {
              alignItems: "flex-start",
              flexDirection: "column",
              sx: {
                paddingRight: "transactionsHistory.transaction.content.paddingRight"
              },
              children: [
                label2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { alignItems: "flex-start", flexDirection: "column", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Paragraph2,
                  {
                    color: labelColor,
                    sx: {
                      marginBottom: "transactionsHistory.breakdownSubItem.title.marginBottom"
                    },
                    children: label2
                  }
                ) }) : null,
                subtitle ? /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Span,
                  {
                    sx: {
                      paddingTop: "transactionsHistory.transaction.subtitle.paddingTop"
                    },
                    variant: "14",
                    children: subtitle
                  }
                ) }) : null
              ]
            }
          ) : null,
          afterElement ? /* @__PURE__ */ jsxRuntimeExports.jsx(
            Flex,
            {
              alignItems: "flex-start",
              flex: "1 0 auto",
              justifyContent: "flex-end",
              sx: {
                marginLeft: "transactionsHistory.transaction.afterElement.marginLeft"
              },
              children: cloneValidElement(afterElement, {
                sx: {
                  paddingRight: hasControlElement ? 0 : "transactionsHistory.transaction.afterElement.paddingRight"
                }
              })
            }
          ) : null
        ] }),
        contentElement ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: cloneValidElement(contentElement) }) : null
      ]
    }
  );
};
const BreakdownSubItem = ({
  id = uniqueId$1("breakdown-sub-item-"),
  label: label2 = void 0,
  text: text2 = void 0
}) => {
  if (!label2 && !text2)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Box,
    {
      as: "li",
      sx: {
        backgroundColor: "transactionsHistory.breakdownSubItem.surface",
        paddingX: "transactionsHistory.breakdownSubItem.paddingX",
        paddingY: "transactionsHistory.breakdownSubItem.paddingY"
      },
      children: [
        label2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
          Paragraph2,
          {
            color: "transactionsHistory.breakdownSubItem.label",
            sx: {
              marginBottom: "transactionsHistory.breakdownSubItem.title.marginBottom"
            },
            children: label2
          }
        ) : null,
        text2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { color: "transactionsHistory.breakdownSubItem.text", variant: "14", children: text2 }) : null
      ]
    },
    id
  );
};
const List = ({ data }) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      as: "ol",
      sx: {
        listStyle: "none",
        margin: "transactionsHistory.transaction.list.margin",
        padding: "transactionsHistory.transaction.list.padding"
      },
      children: data.map((element, index2) => {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(BreakdownSubItem, { ...element }, (element == null ? void 0 : element.id) || index2);
      })
    }
  );
};
const BreakdownControl = ({
  isCollapsed = void 0,
  content: content2 = ""
}) => {
  const actionIcon = isCollapsed ? "chevronDown" : "chevronUp";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Collapsible.Control,
    {
      action: isCollapsed ? CollapsibleAction.expand : CollapsibleAction.collapse,
      "data-test-id": "expand-control",
      icon: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Icon,
        {
          color: "transactionsHistory.breakdownControl.icon",
          name: actionIcon,
          size: IconSizes.Icon12
        }
      ),
      iconAlignment: "right",
      size: ButtonSize.compact,
      variant: ButtonVariant.unstyled,
      children: content2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        Span,
        {
          color: "transactionsHistory.breakdownControl.content",
          sx: {
            paddingRight: "transactionsHistory.breakdownControl.paddingRight"
          },
          variant: "14",
          children: content2
        }
      ) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {})
    }
  );
};
const CollapsibleTransaction = ({
  controlContent = "",
  data,
  ...passthroughProps
}) => {
  const { collapsed } = useCollapsible();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Transaction,
    {
      ...passthroughProps,
      afterElement: /* @__PURE__ */ jsxRuntimeExports.jsx(BreakdownControl, { content: controlContent, isCollapsed: collapsed }),
      contentElement: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Collapsible.Content,
        {
          "data-test-id": "collapsible-content",
          sx: {
            marginTop: "transactionsHistory.transaction.expandedContent.marginTop",
            marginBottom: "transactionsHistory.transaction.expandedContent.marginBottom"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(List, { data })
        }
      ),
      hasControlElement: true
    }
  );
};
const WithBreakdown = ({
  controlContent = "",
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Collapsible, { initiallyCollapsed: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    CollapsibleTransaction,
    {
      ...restOfProps,
      controlContent
    }
  ) });
};
const TransactionsHistory = {
  Transaction,
  BreakdownSubItem,
  WithBreakdown
};
const Timeline = ({ ...props2 }) => {
  const { steps: steps2 } = props2;
  const getGradient = useCallback(
    (theme2, index2) => {
      if (index2 === 0) {
        return theme2.colors.timeline.firstTimeStep.background;
      } else if (index2 === steps2.length - 1) {
        return theme2.colors.timeline.lastTimeStep.background;
      } else {
        return theme2.colors.timeline.middleTimeStep.background;
      }
    },
    [steps2.length]
  );
  const totalStepSize = steps2.reduce((sum2, step2) => sum2 + step2.size, 0);
  const getStepSize = useCallback(
    (step2) => 24 * step2.size / totalStepSize,
    [totalStepSize]
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(VStack, { spacing: 0.5, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { align: "center", justify: "center", spacing: 0, children: steps2.map((step2, index2) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: getStepSize(step2), children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Flex,
        {
          justifyContent: "center",
          sx: {
            background: (theme2) => getGradient(theme2, index2)
          },
          children: step2.state === "locked" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(
            Flex,
            {
              flexDirection: "row",
              sx: {
                height: "timeline.line"
              },
              children: [
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Icon,
                  {
                    name: step2.icon || "lockClosed",
                    size: IconSizes.Icon16,
                    stroke: "timeline.icon.stroke",
                    sx: { margin: "timeline.lockedText.margin" }
                  }
                ),
                /* @__PURE__ */ jsxRuntimeExports.jsx(
                  Box,
                  {
                    sx: {
                      margin: "timeline.lockedText.margin",
                      paddingLeft: "timeline.lockedText.paddingLeft"
                    },
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { variant: "14", children: step2.text })
                  }
                )
              ]
            }
          ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
            Box,
            {
              sx: {
                backgroundColor: step2.state === "inactive" ? "timeline.icon.inactive" : "timeline.icon",
                padding: "timeline.icon.padding",
                height: "timeline.line",
                width: "timeline.line",
                borderRadius: "timeline.default"
              },
              children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                Icon,
                {
                  name: step2.icon || "calendar",
                  size: IconSizes.Icon16,
                  stroke: "timeline.icon.stroke",
                  sx: { margin: "auto" }
                }
              )
            }
          )
        }
      ) }, step2.date);
    }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { align: "center", justify: "center", spacing: 0, children: steps2.map((step2) => {
      if (step2.state === "locked") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: getStepSize(step2) }, step2.date);
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: getStepSize(step2), children: step2.date }, step2.date);
    }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Box, { sx: { textAlign: "center" }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(HStack, { align: "center", justify: "center", spacing: 0, children: steps2.map((step2) => {
      if (step2.state === "locked") {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: getStepSize(step2) }, step2.date);
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { size: getStepSize(step2), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Span, { children: step2.text }) }, step2.date);
    }) }) })
  ] });
};
const Aside = ({
  variant: variant3 = WorkflowTemplateVariant.default,
  ...restOfProps
}) => {
  const { matchMediaQuery } = useMatchMedia();
  if (matchMediaQuery.mdDown) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Aside$1,
    {
      variant: `templates.workflow.${variant3}.aside`,
      ...restOfProps
    }
  );
};
const Content = ({
  variant: variant3 = WorkflowTemplateVariant.default,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Box,
    {
      "data-test-id": "workflow-template-content",
      variant: `templates.workflow.${variant3}.content`,
      ...restOfProps
    }
  );
};
const Footer = ({
  variant: variant3 = WorkflowTemplateVariant.default,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Footer$2,
    {
      sx: { variant: `templates.workflow.${variant3}.footer` },
      ...restOfProps
    }
  );
};
const Header = ({
  variant: variant3 = WorkflowTemplateVariant.default,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Header$1,
    {
      variant: `templates.workflow.${variant3}.header`,
      ...restOfProps
    }
  );
};
const Main = ({
  variant: variant3 = WorkflowTemplateVariant.default,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Main$1, { variant: `templates.workflow.${variant3}.main`, ...restOfProps });
};
const WorkflowTemplate = ({
  variant: variant3 = WorkflowTemplateVariant.default,
  ...restOfProps
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Template, { variant: `templates.workflow.${variant3}.root`, ...restOfProps });
WorkflowTemplate.Aside = Aside;
WorkflowTemplate.Content = Content;
WorkflowTemplate.Header = Header;
WorkflowTemplate.Main = Main;
WorkflowTemplate.Footer = Footer;
const WorkflowTemplateLayout = ({
  aside: aside2,
  asideComponent,
  children: children2,
  header: header2 = void 0,
  variant: variant3 = WorkflowTemplateVariant.default
}) => {
  const renderAside = () => {
    if (aside2) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowTemplate.Aside, { variant: variant3, children: aside2 });
    } else if (asideComponent) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: asideComponent });
    }
    return null;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(WorkflowTemplate, { variant: variant3, children: [
    header2 ? /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowTemplate.Header, { variant: variant3, children: header2 }) : null,
    renderAside(),
    /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowTemplate.Content, { variant: variant3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(WorkflowTemplate.Main, { variant: variant3, children: children2 }) })
  ] });
};
const SingleColumnLayoutContainer = ({
  children: children2,
  variant: variant3 = ContainerVariants.medium,
  direction
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Container$1, { direction, variant: variant3, children: children2 });
};
const SingleColumnLayoutBody = ({
  children: children2,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Main$1, { ...restOfProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(SingleColumnLayoutContainer, { children: children2 }) });
};
const SingleColumnLayoutFooter = ({
  children: children2,
  stickToEnd = false,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Footer$2,
    {
      ...restOfProps,
      ...stickToEnd && {
        sx: {
          display: "flex",
          flex: 1,
          alignItems: "end"
        }
      },
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(SingleColumnLayoutContainer, { direction: "column", children: children2 })
    }
  );
};
const SingleColumnLayoutHeader = ({
  children: children2,
  sticky: sticky2 = false,
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Header$1,
    {
      ...restOfProps,
      ...sticky2 && {
        sx: { position: "sticky", zIndex: "navigation", top: 0 }
      },
      children: children2
    }
  );
};
const SingleColumnLayout = ({
  children: children2,
  sx: sx2 = {},
  ...restOfProps
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flexDirection: "column", sx: sx2, ...restOfProps, children: children2 });
};
SingleColumnLayout.Header = SingleColumnLayoutHeader;
SingleColumnLayout.Body = SingleColumnLayoutBody;
SingleColumnLayout.Footer = SingleColumnLayoutFooter;
SingleColumnLayout.Container = SingleColumnLayoutContainer;
const AppProviders = ({ children: children2 }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme: theme$2, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MatchMediaProvider, { children: children2 }) });
const Storybook = {
  Content: {
    ScaffoldingContainer
  },
  Decorators: {
    MatchMediaProviderDecorator,
    StepperDecorator
  },
  Utilities: StorybookUtilities
};
const TestUtilities = {
  ProvidersWrapper
};
export {
  AppProviders,
  Article,
  Aside$1 as Aside,
  Avatar,
  AvatarSize,
  AvatarVariant,
  BackButton,
  Banner,
  BannerProvider,
  BannerVariant,
  Banners,
  Box,
  Breadcrumbs,
  CompoundButton as Button,
  ButtonGroup,
  ButtonIconAlignment,
  ButtonShape,
  ButtonSize,
  ButtonVariant,
  Caption,
  CaptionSizes,
  Card2 as Card,
  CardHeaderCollapsibleStatus,
  CardVariants,
  Checkbox,
  CobrandedLogo,
  Collapsible,
  CollapsibleAction,
  Provider as CollapsibleProvider,
  Container$1 as Container,
  ContainerVariants,
  ContributionChartTooltip,
  ContributionProgressBar,
  Counter,
  CounterBase,
  CounterVariant,
  CurrencyInput,
  DateInput,
  DatePicker,
  DisplayStateConditionally,
  Divider$1 as Divider,
  DividerOrientation,
  DividerVariant,
  Drawer,
  WrappedDropdown as Dropdown,
  EINInput,
  EmailInput,
  ErrorBoundary,
  ErrorContext,
  ErrorContextProvider,
  Errors,
  ExpansionPanel,
  FileSelector,
  FileUpload,
  Flex,
  WrappedFocusLock as FocusLock,
  Footer$2 as Footer,
  Form,
  Debug as FormDebug,
  FormInputVariants,
  Grid,
  GridTemplateColumns,
  GridVariants,
  GuiBaseForm,
  GuiFormProvider,
  GuidelineComponentType,
  HStack,
  Header$1 as Header,
  HeroBanner,
  HeroBannerVariant,
  HeroBanners,
  Icon,
  IconAlignment,
  IconSizes,
  Illustration,
  InlineCallout,
  InlineCalloutVariant,
  CompoundInput as Input,
  CompoundInputField as InputField,
  InputHeights,
  InputTypes,
  Label2 as Label,
  LabelSizes,
  Link$1 as Link,
  LinkVariant,
  ListItem,
  ListItemVariants,
  Logo,
  Main$1 as Main,
  MatchMedia,
  MatchMediaProvider,
  MenuList,
  wrapped$1 as MenuListItem,
  MenuListItemSizes,
  MenuListVariants,
  Modal,
  ModalSizes,
  NAICSInput,
  Navbar,
  NavbarDropdown,
  NavbarDropdownFooterVariant,
  NavbarDropdownVariant,
  NavbarVariant,
  wrapped as Notification,
  NotificationVariant,
  OrderedList,
  OrderedListSizes,
  Overlay,
  Pagination,
  PaginationBase,
  PaginationProvider,
  Paragraph2 as Paragraph,
  ParagraphSizes,
  PercentageStackedBarChart,
  PersonalContributionsChart,
  PhoneInput,
  Picture,
  Popover,
  PopoverDelayCloseTime,
  Portal$1 as Portal,
  PortfolioChart,
  PortfolioChartTypes,
  PostalCodeInput,
  ProgressBar,
  ProgressivePagination,
  ProgressivePaginationBase,
  ProgressivePaginationProvider,
  Radio,
  RiskToleranceChart,
  SSNInput,
  SalesFunnelHeader,
  Search,
  Section,
  Select2 as Select,
  SelectTypes,
  ServersideSearch,
  ShowHide,
  SingleColumnLayout,
  SkeletonContent,
  Slider2 as Slider,
  Span,
  SpanSizes,
  Spinner2 as Spinner,
  SpinnerVariants,
  Stack$3 as Stack,
  StackItem,
  StepCard,
  Stepper,
  StepperProvider,
  Storybook,
  SubMenuListItem,
  Submit,
  SummaryCard,
  SuperRadio,
  SuperRadioGroupVariants,
  SwipeableNamespace as Swipeable,
  SwitcherModal,
  SyncFormWithWorkflow,
  Table,
  TableResponsiveVariant,
  TableVariant,
  Tag,
  TagVariant,
  Template,
  TestUtilities,
  TextColors,
  Textarea2 as Textarea,
  ThemeProvider,
  Throttle,
  TimeFrames,
  Timeline,
  Title,
  TitleSizes$1 as TitleSizes,
  Toast,
  ToastProvider,
  TokenInput,
  Tooltip,
  TransactionsHistory,
  Triggers,
  UnorderedList,
  VStack,
  VisuallyHidden,
  VolatilityToleranceChart,
  Workflow,
  WorkflowDebug,
  WorkflowForm,
  WorkflowInsight,
  WorkflowMobileBackButton,
  WorkflowStepper,
  WorkflowTemplate,
  WorkflowTemplateLayout,
  buildResponsiveValues,
  theme$2 as guidelineUITheme,
  isInViewport,
  theme as legacyMarketingUITheme,
  mediaQueries$2 as legacyMediaQueries,
  screenSizes as legacyScreenSizes,
  theme$1 as legacyUITheme,
  mediaQueries$3 as mediaQueries,
  normalizeStateName,
  palettes$1 as palettes,
  screenSizes$1 as screenSizes,
  toFullStateId,
  typeToLogoName,
  useBanners,
  useClipboard,
  useCollapsible,
  useEventListener,
  useFieldVariant,
  useGuiField,
  useGuiFieldMeta,
  useGuiForm,
  useIsMounted,
  useMatchMedia,
  useNavbar,
  useOnClickOutside$1 as useOnClickOutside,
  usePlaceablePopover,
  usePrevious,
  useResizeObserver,
  useResponsiveMedia,
  useSelector,
  useSliderContext,
  useStepCardCollapsible,
  useStepper,
  useToastContext,
  useValidateWorkflowComponent,
  useWorkflow,
  useWorkflowContext,
  useWorkflowCurrentlySelectedStep,
  useWorkflowHelper,
  useWorkflowInitialValues,
  useWorkflowService,
  useWorkflowStepHelper,
  useWorkflowStepperNavigation,
  withService
};
//# sourceMappingURL=index.js.map
